
      var $parcel$global = globalThis;
    
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree076"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree076"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("d5I5D", function(module, exports) {

$parcel$export(module.exports, "observable", () => observable);
$parcel$export(module.exports, "isObservableObject", () => isObservableObject);
$parcel$export(module.exports, "isObservableArray", () => isObservableArray);
$parcel$export(module.exports, "isObservableMap", () => isObservableMap);
$parcel$export(module.exports, "computed", () => computed);
$parcel$export(module.exports, "_allowStateChanges", () => allowStateChanges);
$parcel$export(module.exports, "untracked", () => untracked);
$parcel$export(module.exports, "_getGlobalState", () => getGlobalState);
$parcel$export(module.exports, "getDependencyTree", () => getDependencyTree);
$parcel$export(module.exports, "Reaction", () => Reaction);
$parcel$export(module.exports, "action", () => action);
$parcel$export(module.exports, "reaction", () => reaction);
$parcel$export(module.exports, "configure", () => configure);
$parcel$export(module.exports, "toJS", () => toJS);
$parcel$export(module.exports, "when", () => when);
$parcel$export(module.exports, "makeObservable", () => makeObservable);
$parcel$export(module.exports, "runInAction", () => runInAction);
var niceErrors = {
    0: "Invalid value for configuration 'enforceActions', expected 'never', 'always' or 'observed'",
    1: function _(annotationType, key) {
        return "Cannot apply '" + annotationType + "' to '" + key.toString() + "': Field not found.";
    },
    /*
  2(prop) {
      return `invalid decorator for '${prop.toString()}'`
  },
  3(prop) {
      return `Cannot decorate '${prop.toString()}': action can only be used on properties with a function value.`
  },
  4(prop) {
      return `Cannot decorate '${prop.toString()}': computed can only be used on getter properties.`
  },
  */ 5: "'keys()' can only be used on observable objects, arrays, sets and maps",
    6: "'values()' can only be used on observable objects, arrays, sets and maps",
    7: "'entries()' can only be used on observable objects, arrays and maps",
    8: "'set()' can only be used on observable objects, arrays and maps",
    9: "'remove()' can only be used on observable objects, arrays and maps",
    10: "'has()' can only be used on observable objects, arrays and maps",
    11: "'get()' can only be used on observable objects, arrays and maps",
    12: "Invalid annotation",
    13: "Dynamic observable objects cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    14: "Intercept handlers should return nothing or a change object",
    15: "Observable arrays cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    16: "Modification exception: the internal structure of an observable array was changed.",
    17: function _(index, length) {
        return "[mobx.array] Index out of bounds, " + index + " is larger than " + length;
    },
    18: "mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js",
    19: function _(other) {
        return "Cannot initialize from classes that inherit from Map: " + other.constructor.name;
    },
    20: function _(other) {
        return "Cannot initialize map from " + other;
    },
    21: function _(dataStructure) {
        return "Cannot convert to map from '" + dataStructure + "'";
    },
    22: "mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js",
    23: "It is not possible to get index atoms from arrays",
    24: function _(thing) {
        return "Cannot obtain administration from " + thing;
    },
    25: function _(property, name) {
        return "the entry '" + property + "' does not exist in the observable map '" + name + "'";
    },
    26: "please specify a property",
    27: function _(property, name) {
        return "no observable property '" + property.toString() + "' found on the observable object '" + name + "'";
    },
    28: function _(thing) {
        return "Cannot obtain atom from " + thing;
    },
    29: "Expecting some object",
    30: "invalid action stack. did you forget to finish an action?",
    31: "missing option for computed: get",
    32: function _(name, derivation) {
        return "Cycle detected in computation " + name + ": " + derivation;
    },
    33: function _(name) {
        return "The setter of computed value '" + name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?";
    },
    34: function _(name) {
        return "[ComputedValue '" + name + "'] It is not possible to assign a new value to a computed value.";
    },
    35: "There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`",
    36: "isolateGlobalState should be called before MobX is running any reactions",
    37: function _(method) {
        return "[mobx] `observableArray." + method + "()` mutates the array in-place, which is not allowed inside a derivation. Use `array.slice()." + method + "()` instead";
    },
    38: "'ownKeys()' can only be used on observable objects",
    39: "'defineProperty()' can only be used on observable objects"
};
var errors = {};
function die(error) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var e;
    throw new Error(typeof error === "number" ? "[MobX] minified error nr: " + error + (args.length ? " " + args.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + error);
}
var mockGlobal = {};
function getGlobal() {
    if (typeof globalThis !== "undefined") return globalThis;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    if (typeof self !== "undefined") return self;
    return mockGlobal;
}
// We shorten anything used > 5 times
var assign = Object.assign;
var getDescriptor = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var objectPrototype = Object.prototype;
var EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);
var EMPTY_OBJECT = {};
Object.freeze(EMPTY_OBJECT);
var hasProxy = typeof Proxy !== "undefined";
var plainObjectString = /*#__PURE__*/ Object.toString();
function assertProxies() {
    if (!hasProxy) die("Proxy not available");
}
function warnAboutProxyRequirement(msg) {}
function getNextId() {
    return ++globalState.mobxGuid;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */ function once(func) {
    var invoked = false;
    return function() {
        if (invoked) return;
        invoked = true;
        return func.apply(this, arguments);
    };
}
var noop = function noop() {};
function isFunction(fn) {
    return typeof fn === "function";
}
function isStringish(value) {
    var t = typeof value;
    switch(t){
        case "string":
        case "symbol":
        case "number":
            return true;
    }
    return false;
}
function isObject(value) {
    return value !== null && typeof value === "object";
}
function isPlainObject(value) {
    if (!isObject(value)) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto == null) return true;
    var protoConstructor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof protoConstructor === "function" && protoConstructor.toString() === plainObjectString;
}
// https://stackoverflow.com/a/37865170
function isGenerator(obj) {
    var constructor = obj == null ? void 0 : obj.constructor;
    if (!constructor) return false;
    if ("GeneratorFunction" === constructor.name || "GeneratorFunction" === constructor.displayName) return true;
    return false;
}
function addHiddenProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
function addHiddenFinalProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
function createInstanceofPredicate(name, theClass) {
    var propName = "isMobX" + name;
    theClass.prototype[propName] = true;
    return function(x) {
        return isObject(x) && x[propName] === true;
    };
}
/**
 * Yields true for both native and observable Map, even across different windows.
 */ function isES6Map(thing) {
    return thing != null && Object.prototype.toString.call(thing) === "[object Map]";
}
/**
 * Makes sure a Map is an instance of non-inherited native or observable Map.
 */ function isPlainES6Map(thing) {
    var mapProto = Object.getPrototypeOf(thing);
    var objectProto = Object.getPrototypeOf(mapProto);
    var nullProto = Object.getPrototypeOf(objectProto);
    return nullProto === null;
}
/**
 * Yields true for both native and observable Set, even across different windows.
 */ function isES6Set(thing) {
    return thing != null && Object.prototype.toString.call(thing) === "[object Set]";
}
var hasGetOwnPropertySymbols = typeof Object.getOwnPropertySymbols !== "undefined";
/**
 * Returns the following: own enumerable keys and symbols.
 */ function getPlainObjectKeys(object) {
    var keys = Object.keys(object);
    // Not supported in IE, so there are not going to be symbol props anyway...
    if (!hasGetOwnPropertySymbols) return keys;
    var symbols = Object.getOwnPropertySymbols(object);
    if (!symbols.length) return keys;
    return [].concat(keys, symbols.filter(function(s) {
        return objectPrototype.propertyIsEnumerable.call(object, s);
    }));
}
// From Immer utils
// Returns all own keys, including non-enumerable and symbolic
var ownKeys = typeof Reflect !== "undefined" && Reflect.ownKeys ? Reflect.ownKeys : hasGetOwnPropertySymbols ? function(obj) {
    return Object.getOwnPropertyNames(obj).concat(Object.getOwnPropertySymbols(obj));
} : /* istanbul ignore next */ Object.getOwnPropertyNames;
function stringifyKey(key) {
    if (typeof key === "string") return key;
    if (typeof key === "symbol") return key.toString();
    return new String(key).toString();
}
function toPrimitive(value) {
    return value === null ? null : typeof value === "object" ? "" + value : value;
}
function hasProp(target, prop) {
    return objectPrototype.hasOwnProperty.call(target, prop);
}
// From Immer utils
var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(target) {
    // Polyfill needed for Hermes and IE, see https://github.com/facebook/hermes/issues/274
    var res = {};
    // Note: without polyfill for ownKeys, symbols won't be picked up
    ownKeys(target).forEach(function(key) {
        res[key] = getDescriptor(target, key);
    });
    return res;
};
function getFlag(flags, mask) {
    return !!(flags & mask);
}
function setFlag(flags, mask, newValue) {
    if (newValue) flags |= mask;
    else flags &= ~mask;
    return flags;
}
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function _defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
    }
}
function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function _createForOfIteratorHelperLoose(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (t) return (t = t.call(r)).next.bind(t);
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
        t && (r = t);
        var o = 0;
        return function() {
            return o >= r.length ? {
                done: !0
            } : {
                done: !1,
                value: r[o++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}
function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return _arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
    }
}
var storedAnnotationsSymbol = /*#__PURE__*/ Symbol("mobx-stored-annotations");
/**
 * Creates a function that acts as
 * - decorator
 * - annotation object
 */ function createDecoratorAnnotation(annotation) {
    function decorator(target, property) {
        if (is20223Decorator(property)) return annotation.decorate_20223_(target, property);
        else storeAnnotation(target, property, annotation);
    }
    return Object.assign(decorator, annotation);
}
/**
 * Stores annotation to prototype,
 * so it can be inspected later by `makeObservable` called from constructor
 */ function storeAnnotation(prototype, key, annotation) {
    if (!hasProp(prototype, storedAnnotationsSymbol)) addHiddenProp(prototype, storedAnnotationsSymbol, _extends({}, prototype[storedAnnotationsSymbol]));
    var fieldName;
    // Cannot re-decorate
    assertNotDecorated(prototype, annotation, key);
    // Ignore override
    if (!isOverride(annotation)) prototype[storedAnnotationsSymbol][key] = annotation;
}
function assertNotDecorated(prototype, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
/**
 * Collects annotations from prototypes and stores them on target (instance)
 */ function collectStoredAnnotations(target) {
    if (!hasProp(target, storedAnnotationsSymbol)) // if (__DEV__ && !target[storedAnnotationsSymbol]) {
    //     die(
    //         `No annotations were passed to makeObservable, but no decorated members have been found either`
    //     )
    // }
    // We need a copy as we will remove annotation from the list once it's applied.
    addHiddenProp(target, storedAnnotationsSymbol, _extends({}, target[storedAnnotationsSymbol]));
    return target[storedAnnotationsSymbol];
}
function is20223Decorator(context) {
    return typeof context == "object" && typeof context["kind"] == "string";
}
function assert20223DecoratorType(context, types) {}
var $mobx = /*#__PURE__*/ Symbol("mobx administration");
var Atom = /*#__PURE__*/ function() {
    /**
   * Create a new atom. For debugging purposes it is recommended to give it a name.
   * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
   */ function Atom(name_) {
        if (name_ === void 0) name_ = "Atom";
        this.name_ = void 0;
        this.flags_ = 0;
        this.observers_ = new Set();
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.NOT_TRACKING_;
        // onBecomeObservedListeners
        this.onBOL = void 0;
        // onBecomeUnobservedListeners
        this.onBUOL = void 0;
        this.name_ = name_;
    }
    // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
    var _proto = Atom.prototype;
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.reportObserved = function reportObserved$1() {
        return reportObserved(this);
    };
    _proto.reportChanged = function reportChanged() {
        startBatch();
        propagateChanged(this);
        endBatch();
    };
    _proto.toString = function toString() {
        return this.name_;
    };
    return _createClass(Atom, [
        {
            key: "isBeingObserved",
            get: function get() {
                return getFlag(this.flags_, Atom.isBeingObservedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.isBeingObservedMask_, newValue);
            }
        },
        {
            key: "isPendingUnobservation",
            get: function get() {
                return getFlag(this.flags_, Atom.isPendingUnobservationMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.isPendingUnobservationMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, Atom.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
Atom.isBeingObservedMask_ = 1;
Atom.isPendingUnobservationMask_ = 2;
Atom.diffValueMask_ = 4;
var isAtom = /*#__PURE__*/ createInstanceofPredicate("Atom", Atom);
function createAtom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
    if (onBecomeObservedHandler === void 0) onBecomeObservedHandler = noop;
    if (onBecomeUnobservedHandler === void 0) onBecomeUnobservedHandler = noop;
    var atom = new Atom(name);
    // default `noop` listener will not initialize the hook Set
    if (onBecomeObservedHandler !== noop) onBecomeObserved(atom, onBecomeObservedHandler);
    if (onBecomeUnobservedHandler !== noop) onBecomeUnobserved(atom, onBecomeUnobservedHandler);
    return atom;
}
function identityComparer(a, b) {
    return a === b;
}
function structuralComparer(a, b) {
    return deepEqual(a, b);
}
function shallowComparer(a, b) {
    return deepEqual(a, b, 1);
}
function defaultComparer(a, b) {
    if (Object.is) return Object.is(a, b);
    return a === b ? a !== 0 || 1 / a === 1 / b : a !== a && b !== b;
}
var comparer = {
    identity: identityComparer,
    structural: structuralComparer,
    "default": defaultComparer,
    shallow: shallowComparer
};
function deepEnhancer(v, _, name) {
    // it is an observable already, done
    if (isObservable(v)) return v;
    // something that can be converted and mutated?
    if (Array.isArray(v)) return observable.array(v, {
        name: name
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name
    });
    if (typeof v === "function" && !isAction(v) && !isFlow(v)) {
        if (isGenerator(v)) return flow(v);
        else return autoAction(name, v);
    }
    return v;
}
function shallowEnhancer(v, _, name) {
    if (v === undefined || v === null) return v;
    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v) || isObservableSet(v)) return v;
    if (Array.isArray(v)) return observable.array(v, {
        name: name,
        deep: false
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name,
        deep: false
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name,
        deep: false
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name,
        deep: false
    });
}
function referenceEnhancer(newValue) {
    // never turn into an observable
    return newValue;
}
function refStructEnhancer(v, oldValue) {
    if (deepEqual(v, oldValue)) return oldValue;
    return v;
}
var OVERRIDE = "override";
var override = /*#__PURE__*/ createDecoratorAnnotation({
    annotationType_: OVERRIDE,
    make_: make_,
    extend_: extend_,
    decorate_20223_: decorate_20223_
});
function isOverride(annotation) {
    return annotation.annotationType_ === OVERRIDE;
}
function make_(adm, key) {
    return 0 /* MakeResult.Cancel */ ;
}
function extend_(adm, key, descriptor, proxyTrap) {
    die("'" + this.annotationType_ + "' can only be used with 'makeObservable'");
}
function decorate_20223_(desc, context) {
    console.warn("'" + this.annotationType_ + "' cannot be used with decorators - this is a no-op");
}
function createActionAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$1,
        extend_: extend_$1,
        decorate_20223_: decorate_20223_$1
    };
}
function make_$1(adm, key, descriptor, source) {
    var _this$options_;
    // bound
    if ((_this$options_ = this.options_) != null && _this$options_.bound) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    if (isAction(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor, false);
    defineProperty(source, key, actionDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$1(adm, key, descriptor, proxyTrap) {
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor);
    return adm.defineProperty_(key, actionDescriptor, proxyTrap);
}
function decorate_20223_$1(mthd, context) {
    var kind = context.kind, name = context.name, addInitializer = context.addInitializer;
    var ann = this;
    var _createAction = function _createAction(m) {
        var _ann$options_$name, _ann$options_, _ann$options_$autoAct, _ann$options_2;
        return createAction((_ann$options_$name = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.name) != null ? _ann$options_$name : name.toString(), m, (_ann$options_$autoAct = (_ann$options_2 = ann.options_) == null ? void 0 : _ann$options_2.autoAction) != null ? _ann$options_$autoAct : false);
    };
    if (kind == "field") return function(initMthd) {
        var _ann$options_3;
        var mthd = initMthd;
        if (!isAction(mthd)) mthd = _createAction(mthd);
        if ((_ann$options_3 = ann.options_) != null && _ann$options_3.bound) {
            mthd = mthd.bind(this);
            mthd.isMobxAction = true;
        }
        return mthd;
    };
    if (kind == "method") {
        var _this$options_2;
        if (!isAction(mthd)) mthd = _createAction(mthd);
        if ((_this$options_2 = this.options_) != null && _this$options_2.bound) addInitializer(function() {
            var self1 = this;
            var bound = self1[name].bind(self1);
            bound.isMobxAction = true;
            self1[name] = bound;
        });
        return mthd;
    }
    die("Cannot apply '" + ann.annotationType_ + "' to '" + String(name) + "' (kind: " + kind + "):" + ("\n'" + ann.annotationType_ + "' can only be used on properties with a function value."));
}
function assertActionDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createActionDescriptor(adm, annotation, key, descriptor, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    var _annotation$options_, _annotation$options_$, _annotation$options_2, _annotation$options_$2, _annotation$options_3, _annotation$options_4, _adm$proxy_2;
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertActionDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    if ((_annotation$options_ = annotation.options_) != null && _annotation$options_.bound) {
        var _adm$proxy_;
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return {
        value: createAction((_annotation$options_$ = (_annotation$options_2 = annotation.options_) == null ? void 0 : _annotation$options_2.name) != null ? _annotation$options_$ : key.toString(), value, (_annotation$options_$2 = (_annotation$options_3 = annotation.options_) == null ? void 0 : _annotation$options_3.autoAction) != null ? _annotation$options_$2 : false, // https://github.com/mobxjs/mobx/discussions/3140
        (_annotation$options_4 = annotation.options_) != null && _annotation$options_4.bound ? (_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_ : undefined),
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createFlowAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$2,
        extend_: extend_$2,
        decorate_20223_: decorate_20223_$2
    };
}
function make_$2(adm, key, descriptor, source) {
    var _this$options_;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    // bound - must annotate protos to support super.flow()
    if ((_this$options_ = this.options_) != null && _this$options_.bound && (!hasProp(adm.target_, key) || !isFlow(adm.target_[key]))) {
        if (this.extend_(adm, key, descriptor, false) === null) return 0 /* MakeResult.Cancel */ ;
    }
    if (isFlow(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, false, false);
    defineProperty(source, key, flowDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$2(adm, key, descriptor, proxyTrap) {
    var _this$options_2;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, (_this$options_2 = this.options_) == null ? void 0 : _this$options_2.bound);
    return adm.defineProperty_(key, flowDescriptor, proxyTrap);
}
function decorate_20223_$2(mthd, context) {
    var _this$options_3;
    var name = context.name, addInitializer = context.addInitializer;
    if (!isFlow(mthd)) mthd = flow(mthd);
    if ((_this$options_3 = this.options_) != null && _this$options_3.bound) addInitializer(function() {
        var self1 = this;
        var bound = self1[name].bind(self1);
        bound.isMobXFlow = true;
        self1[name] = bound;
    });
    return mthd;
}
function assertFlowDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createFlowDescriptor(adm, annotation, key, descriptor, bound, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertFlowDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    // In case of flow.bound, the descriptor can be from already annotated prototype
    if (!isFlow(value)) value = flow(value);
    if (bound) {
        var _adm$proxy_;
        // We do not keep original function around, so we bind the existing flow
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
        // This is normally set by `flow`, but `bind` returns new function...
        value.isMobXFlow = true;
    }
    return {
        value: value,
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createComputedAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$3,
        extend_: extend_$3,
        decorate_20223_: decorate_20223_$3
    };
}
function make_$3(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$3(adm, key, descriptor, proxyTrap) {
    assertComputedDescriptor(adm, this, key, descriptor);
    return adm.defineComputedProperty_(key, _extends({}, this.options_, {
        get: descriptor.get,
        set: descriptor.set
    }), proxyTrap);
}
function decorate_20223_$3(get, context) {
    var ann = this;
    var key = context.name, addInitializer = context.addInitializer;
    addInitializer(function() {
        var adm = asObservableObject(this)[$mobx];
        var options = _extends({}, ann.options_, {
            get: get,
            context: this
        });
        options.name || (options.name = "ObservableObject." + key.toString());
        adm.values_.set(key, new ComputedValue(options));
    });
    return function() {
        return this[$mobx].getObservablePropValue_(key);
    };
}
function assertComputedDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var get = _ref2.get;
}
function createObservableAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$4,
        extend_: extend_$4,
        decorate_20223_: decorate_20223_$4
    };
}
function make_$4(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$4(adm, key, descriptor, proxyTrap) {
    var _this$options_$enhanc, _this$options_;
    assertObservableDescriptor(adm, this, key, descriptor);
    return adm.defineObservableProperty_(key, descriptor.value, (_this$options_$enhanc = (_this$options_ = this.options_) == null ? void 0 : _this$options_.enhancer) != null ? _this$options_$enhanc : deepEnhancer, proxyTrap);
}
function decorate_20223_$4(desc, context) {
    var ann = this;
    var kind = context.kind, name = context.name;
    // The laziness here is not ideal... It's a workaround to how 2022.3 Decorators are implemented:
    //   `addInitializer` callbacks are executed _before_ any accessors are defined (instead of the ideal-for-us right after each).
    //   This means that, if we were to do our stuff in an `addInitializer`, we'd attempt to read a private slot
    //   before it has been initialized. The runtime doesn't like that and throws a `Cannot read private member
    //   from an object whose class did not declare it` error.
    // TODO: it seems that this will not be required anymore in the final version of the spec
    // See TODO: link
    var initializedObjects = new WeakSet();
    function initializeObservable(target, value) {
        var _ann$options_$enhance, _ann$options_;
        var adm = asObservableObject(target)[$mobx];
        var observable = new ObservableValue(value, (_ann$options_$enhance = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.enhancer) != null ? _ann$options_$enhance : deepEnhancer, "ObservableObject." + name.toString(), false);
        adm.values_.set(name, observable);
        initializedObjects.add(target);
    }
    if (kind == "accessor") return {
        get: function get() {
            if (!initializedObjects.has(this)) initializeObservable(this, desc.get.call(this));
            return this[$mobx].getObservablePropValue_(name);
        },
        set: function set(value) {
            if (!initializedObjects.has(this)) initializeObservable(this, value);
            return this[$mobx].setObservablePropValue_(name, value);
        },
        init: function init(value) {
            if (!initializedObjects.has(this)) initializeObservable(this, value);
            return value;
        }
    };
    return;
}
function assertObservableDescriptor(adm, _ref, key, descriptor) {
    var annotationType_ = _ref.annotationType_;
}
var AUTO = "true";
var autoAnnotation = /*#__PURE__*/ createAutoAnnotation();
function createAutoAnnotation(options) {
    return {
        annotationType_: AUTO,
        options_: options,
        make_: make_$5,
        extend_: extend_$5,
        decorate_20223_: decorate_20223_$5
    };
}
function make_$5(adm, key, descriptor, source) {
    var _this$options_3, _this$options_4;
    // getter -> computed
    if (descriptor.get) return computed.make_(adm, key, descriptor, source);
    // lone setter -> action setter
    if (descriptor.set) {
        // TODO make action applicable to setter and delegate to action.make_
        var set = isAction(descriptor.set) ? descriptor.set // See #4553
         : createAction(key.toString(), descriptor.set);
        // own
        if (source === adm.target_) return adm.defineProperty_(key, {
            configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
            set: set
        }) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
        // proto
        defineProperty(source, key, {
            configurable: true,
            set: set
        });
        return 2 /* MakeResult.Continue */ ;
    }
    // function on proto -> autoAction/flow
    if (source !== adm.target_ && typeof descriptor.value === "function") {
        var _this$options_2;
        if (isGenerator(descriptor.value)) {
            var _this$options_;
            var flowAnnotation = (_this$options_ = this.options_) != null && _this$options_.autoBind ? flow.bound : flow;
            return flowAnnotation.make_(adm, key, descriptor, source);
        }
        var actionAnnotation = (_this$options_2 = this.options_) != null && _this$options_2.autoBind ? autoAction.bound : autoAction;
        return actionAnnotation.make_(adm, key, descriptor, source);
    }
    // other -> observable
    // Copy props from proto as well, see test:
    // "decorate should work with Object.create"
    var observableAnnotation = ((_this$options_3 = this.options_) == null ? void 0 : _this$options_3.deep) === false ? observable.ref : observable;
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_4 = this.options_) != null && _this$options_4.autoBind) {
        var _adm$proxy_;
        descriptor.value = descriptor.value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return observableAnnotation.make_(adm, key, descriptor, source);
}
function extend_$5(adm, key, descriptor, proxyTrap) {
    var _this$options_5, _this$options_6;
    // getter -> computed
    if (descriptor.get) return computed.extend_(adm, key, descriptor, proxyTrap);
    // lone setter -> action setter
    if (descriptor.set) // TODO make action applicable to setter and delegate to action.extend_
    return adm.defineProperty_(key, {
        configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
        set: createAction(key.toString(), descriptor.set)
    }, proxyTrap);
    // other -> observable
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_5 = this.options_) != null && _this$options_5.autoBind) {
        var _adm$proxy_2;
        descriptor.value = descriptor.value.bind((_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_);
    }
    var observableAnnotation = ((_this$options_6 = this.options_) == null ? void 0 : _this$options_6.deep) === false ? observable.ref : observable;
    return observableAnnotation.extend_(adm, key, descriptor, proxyTrap);
}
function decorate_20223_$5(desc, context) {
    die("'" + this.annotationType_ + "' cannot be used as a decorator");
}
var OBSERVABLE = "observable";
var OBSERVABLE_REF = "observable.ref";
var OBSERVABLE_SHALLOW = "observable.shallow";
var OBSERVABLE_STRUCT = "observable.struct";
// Predefined bags of create observable options, to avoid allocating temporarily option objects
// in the majority of cases
var defaultCreateObservableOptions = {
    deep: true,
    name: undefined,
    defaultDecorator: undefined,
    proxy: true
};
Object.freeze(defaultCreateObservableOptions);
function asCreateObservableOptions(thing) {
    return thing || defaultCreateObservableOptions;
}
var observableAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE);
var observableRefAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_REF, {
    enhancer: referenceEnhancer
});
var observableShallowAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_SHALLOW, {
    enhancer: shallowEnhancer
});
var observableStructAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_STRUCT, {
    enhancer: refStructEnhancer
});
var observableDecoratorAnnotation = /*#__PURE__*/ createDecoratorAnnotation(observableAnnotation);
function getEnhancerFromOptions(options) {
    return options.deep === true ? deepEnhancer : options.deep === false ? referenceEnhancer : getEnhancerFromAnnotation(options.defaultDecorator);
}
function getAnnotationFromOptions(options) {
    var _options$defaultDecor;
    return options ? (_options$defaultDecor = options.defaultDecorator) != null ? _options$defaultDecor : createAutoAnnotation(options) : undefined;
}
function getEnhancerFromAnnotation(annotation) {
    var _annotation$options_$, _annotation$options_;
    return !annotation ? deepEnhancer : (_annotation$options_$ = (_annotation$options_ = annotation.options_) == null ? void 0 : _annotation$options_.enhancer) != null ? _annotation$options_$ : deepEnhancer;
}
/**
 * Turns an object, array or function into a reactive structure.
 * @param v the value which should become observable.
 */ function createObservable(v, arg2, arg3) {
    // @observable someProp; (2022.3 Decorators)
    if (is20223Decorator(arg2)) return observableAnnotation.decorate_20223_(v, arg2);
    // @observable someProp;
    if (isStringish(arg2)) {
        storeAnnotation(v, arg2, observableAnnotation);
        return;
    }
    // already observable - ignore
    if (isObservable(v)) return v;
    // plain object
    if (isPlainObject(v)) return observable.object(v, arg2, arg3);
    // Array
    if (Array.isArray(v)) return observable.array(v, arg2);
    // Map
    if (isES6Map(v)) return observable.map(v, arg2);
    // Set
    if (isES6Set(v)) return observable.set(v, arg2);
    // other object - ignore
    if (typeof v === "object" && v !== null) return v;
    // anything else
    return observable.box(v, arg2);
}
assign(createObservable, observableDecoratorAnnotation);
var observableFactories = {
    box: function box(value, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableValue(value, getEnhancerFromOptions(o), o.name, true, o.equals);
    },
    array: function array(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return (globalState.useProxies === false || o.proxy === false ? createLegacyArray : createObservableArray)(initialValues, getEnhancerFromOptions(o), o.name);
    },
    map: function map(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableMap(initialValues, getEnhancerFromOptions(o), o.name);
    },
    set: function set(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableSet(initialValues, getEnhancerFromOptions(o), o.name);
    },
    object: function object(props, decorators, options) {
        return initObservable(function() {
            return extendObservable(globalState.useProxies === false || (options == null ? void 0 : options.proxy) === false ? asObservableObject({}, options) : asDynamicObservableObject({}, options), props, decorators);
        });
    },
    ref: /*#__PURE__*/ createDecoratorAnnotation(observableRefAnnotation),
    shallow: /*#__PURE__*/ createDecoratorAnnotation(observableShallowAnnotation),
    deep: observableDecoratorAnnotation,
    struct: /*#__PURE__*/ createDecoratorAnnotation(observableStructAnnotation)
};
// eslint-disable-next-line
var observable = /*#__PURE__*/ assign(createObservable, observableFactories);
var COMPUTED = "computed";
var COMPUTED_STRUCT = "computed.struct";
var computedAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED);
var computedStructAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED_STRUCT, {
    equals: comparer.structural
});
/**
 * Decorator for class properties: @computed get value() { return expr; }.
 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
 */ var computed = function computed(arg1, arg2) {
    if (is20223Decorator(arg2)) // @computed (2022.3 Decorators)
    return computedAnnotation.decorate_20223_(arg1, arg2);
    if (isStringish(arg2)) // @computed
    return storeAnnotation(arg1, arg2, computedAnnotation);
    if (isPlainObject(arg1)) // @computed({ options })
    return createDecoratorAnnotation(createComputedAnnotation(COMPUTED, arg1));
    var opts = isPlainObject(arg2) ? arg2 : {};
    opts.get = arg1;
    opts.name || (opts.name = arg1.name || ""); /* for generated name */ 
    return new ComputedValue(opts);
};
Object.assign(computed, computedAnnotation);
computed.struct = /*#__PURE__*/ createDecoratorAnnotation(computedStructAnnotation);
var _getDescriptor$config, _getDescriptor;
// we don't use globalState for these in order to avoid possible issues with multiple
// mobx versions
var currentActionId = 0;
var nextActionId = 1;
var isFunctionNameConfigurable = (_getDescriptor$config = (_getDescriptor = /*#__PURE__*/ getDescriptor(function() {}, "name")) == null ? void 0 : _getDescriptor.configurable) != null ? _getDescriptor$config : false;
// we can safely recycle this object
var tmpNameDescriptor = {
    value: "action",
    configurable: true,
    writable: false,
    enumerable: false
};
function createAction(actionName, fn, autoAction, ref) {
    if (autoAction === void 0) autoAction = false;
    function res() {
        return executeAction(actionName, autoAction, fn, ref || this, arguments);
    }
    res.isMobxAction = true;
    res.toString = function() {
        return fn.toString();
    };
    if (isFunctionNameConfigurable) {
        tmpNameDescriptor.value = actionName;
        defineProperty(res, "name", tmpNameDescriptor);
    }
    return res;
}
function executeAction(actionName, canRunAsDerivation, fn, scope, args) {
    var runInfo = _startAction(actionName, canRunAsDerivation, scope, args);
    try {
        return fn.apply(scope, args);
    } catch (err) {
        runInfo.error_ = err;
        throw err;
    } finally{
        _endAction(runInfo);
    }
}
function _startAction(actionName, canRunAsDerivation, // true for autoAction
scope, args) {
    var notifySpy_ = false;
    var startTime_ = 0;
    var flattenedArgs;
    var prevDerivation_ = globalState.trackingDerivation;
    var runAsAction = !canRunAsDerivation || !prevDerivation_;
    startBatch();
    var prevAllowStateChanges_ = globalState.allowStateChanges; // by default preserve previous allow
    if (runAsAction) {
        untrackedStart();
        prevAllowStateChanges_ = allowStateChangesStart(true);
    }
    var prevAllowStateReads_ = allowStateReadsStart(true);
    var runInfo = {
        runAsAction_: runAsAction,
        prevDerivation_: prevDerivation_,
        prevAllowStateChanges_: prevAllowStateChanges_,
        prevAllowStateReads_: prevAllowStateReads_,
        notifySpy_: notifySpy_,
        startTime_: startTime_,
        actionId_: nextActionId++,
        parentActionId_: currentActionId
    };
    currentActionId = runInfo.actionId_;
    return runInfo;
}
function _endAction(runInfo) {
    if (currentActionId !== runInfo.actionId_) die(30);
    currentActionId = runInfo.parentActionId_;
    if (runInfo.error_ !== undefined) globalState.suppressReactionErrors = true;
    allowStateChangesEnd(runInfo.prevAllowStateChanges_);
    allowStateReadsEnd(runInfo.prevAllowStateReads_);
    endBatch();
    if (runInfo.runAsAction_) untrackedEnd(runInfo.prevDerivation_);
    globalState.suppressReactionErrors = false;
}
function allowStateChanges(allowStateChanges, func) {
    var prev = allowStateChangesStart(allowStateChanges);
    try {
        return func();
    } finally{
        allowStateChangesEnd(prev);
    }
}
function allowStateChangesStart(allowStateChanges) {
    var prev = globalState.allowStateChanges;
    globalState.allowStateChanges = allowStateChanges;
    return prev;
}
function allowStateChangesEnd(prev) {
    globalState.allowStateChanges = prev;
}
var CREATE = "create";
var ObservableValue = /*#__PURE__*/ function(_Atom) {
    function ObservableValue(value, enhancer, name_, notifySpy, equals) {
        var _this;
        if (name_ === void 0) name_ = "ObservableValue";
        if (notifySpy === void 0) notifySpy = true;
        if (equals === void 0) equals = comparer["default"];
        _this = _Atom.call(this, name_) || this;
        _this.enhancer = void 0;
        _this.name_ = void 0;
        _this.equals = void 0;
        _this.hasUnreportedChange_ = false;
        _this.interceptors_ = void 0;
        _this.changeListeners_ = void 0;
        _this.value_ = void 0;
        _this.dehancer = void 0;
        _this.enhancer = enhancer;
        _this.name_ = name_;
        _this.equals = equals;
        _this.value_ = enhancer(value, undefined, name_);
        var _this$value_;
        return _this;
    }
    _inheritsLoose(ObservableValue, _Atom);
    var _proto = ObservableValue.prototype;
    _proto.dehanceValue = function dehanceValue(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.set = function set(newValue) {
        var oldValue = this.value_;
        newValue = this.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            this.setNewValue_(newValue);
        }
    };
    _proto.prepareNewValue_ = function prepareNewValue_(newValue) {
        checkIfStateModificationsAreAllowed(this);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this,
                type: UPDATE,
                newValue: newValue
            });
            if (!change) return globalState.UNCHANGED;
            newValue = change.newValue;
        }
        // apply modifier
        newValue = this.enhancer(newValue, this.value_, this.name_);
        return this.equals(this.value_, newValue) ? globalState.UNCHANGED : newValue;
    };
    _proto.setNewValue_ = function setNewValue_(newValue) {
        var oldValue = this.value_;
        this.value_ = newValue;
        this.reportChanged();
        if (hasListeners(this)) notifyListeners(this, {
            type: UPDATE,
            object: this,
            newValue: newValue,
            oldValue: oldValue
        });
    };
    _proto.get = function get() {
        this.reportObserved();
        return this.dehanceValue(this.value_);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately) listener({
            observableKind: "value",
            debugObjectName: this.name_,
            object: this,
            type: UPDATE,
            newValue: this.value_,
            oldValue: undefined
        });
        return registerListener(this, listener);
    };
    _proto.raw = function raw() {
        // used by MST ot get undehanced value
        return this.value_;
    };
    _proto.toJSON = function toJSON() {
        return this.get();
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.value_ + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[Symbol.toPrimitive] = function() {
        return this.valueOf();
    };
    return ObservableValue;
}(Atom);
var isObservableValue = /*#__PURE__*/ createInstanceofPredicate("ObservableValue", ObservableValue);
/**
 * A node in the state dependency root that observes other nodes, and can be observed itself.
 *
 * ComputedValue will remember the result of the computation for the duration of the batch, or
 * while being observed.
 *
 * During this time it will recompute only when one of its direct dependencies changed,
 * but only when it is being accessed with `ComputedValue.get()`.
 *
 * Implementation description:
 * 1. First time it's being accessed it will compute and remember result
 *    give back remembered result until 2. happens
 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
 * 3. When it's being accessed, recompute if any shallow dependency changed.
 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
 *    go to step 2. either way
 *
 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
 */ var ComputedValue = /*#__PURE__*/ function() {
    /**
   * Create a new computed value based on a function expression.
   *
   * The `name` property is for debug purposes only.
   *
   * The `equals` property specifies the comparer function to use to determine if a newly produced
   * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
   * compares based on identity comparison (===), and `structuralComparer` deeply compares the structure.
   * Structural comparison can be convenient if you always produce a new aggregated object and
   * don't want to notify observers if it is structurally the same.
   * This is useful for working with vectors, mouse coordinates etc.
   */ function ComputedValue(options) {
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.observing_ = [];
        // nodes we are looking at. Our value depends on these nodes
        this.newObserving_ = null;
        // during tracking it's an array with new observed observers
        this.observers_ = new Set();
        this.runId_ = 0;
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
        this.unboundDepsCount_ = 0;
        this.value_ = new CaughtException(null);
        this.name_ = void 0;
        this.triggeredBy_ = void 0;
        this.flags_ = 0;
        this.derivation = void 0;
        // N.B: unminified as it is used by MST
        this.setter_ = void 0;
        this.isTracing_ = TraceMode.NONE;
        this.scope_ = void 0;
        this.equals_ = void 0;
        this.requiresReaction_ = void 0;
        this.keepAlive_ = void 0;
        this.onBOL = void 0;
        this.onBUOL = void 0;
        if (!options.get) die(31);
        this.derivation = options.get;
        this.name_ = options.name || "ComputedValue";
        if (options.set) this.setter_ = createAction("ComputedValue-setter", options.set);
        this.equals_ = options.equals || (options.compareStructural || options.struct ? comparer.structural : comparer["default"]);
        this.scope_ = options.context;
        this.requiresReaction_ = options.requiresReaction;
        this.keepAlive_ = !!options.keepAlive;
    }
    var _proto = ComputedValue.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        propagateMaybeChanged(this);
    };
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    };
    /**
   * Returns the current value of this computed value.
   * Will evaluate its computation first if needed.
   */ _proto.get = function get() {
        if (this.isComputing) die(32, this.name_, this.derivation);
        if (globalState.inBatch === 0 && // !globalState.trackingDerivatpion &&
        this.observers_.size === 0 && !this.keepAlive_) {
            if (shouldCompute(this)) {
                this.warnAboutUntrackedRead_();
                startBatch(); // See perf test 'computed memoization'
                this.value_ = this.computeValue_(false);
                endBatch();
            }
        } else {
            reportObserved(this);
            if (shouldCompute(this)) {
                var prevTrackingContext = globalState.trackingContext;
                if (this.keepAlive_ && !prevTrackingContext) globalState.trackingContext = this;
                if (this.trackAndCompute()) propagateChangeConfirmed(this);
                globalState.trackingContext = prevTrackingContext;
            }
        }
        var result = this.value_;
        if (isCaughtException(result)) throw result.cause;
        return result;
    };
    _proto.set = function set(value) {
        if (this.setter_) {
            if (this.isRunningSetter) die(33, this.name_);
            this.isRunningSetter = true;
            try {
                this.setter_.call(this.scope_, value);
            } finally{
                this.isRunningSetter = false;
            }
        } else die(34, this.name_);
    };
    _proto.trackAndCompute = function trackAndCompute() {
        // N.B: unminified as it is used by MST
        var oldValue = this.value_;
        var wasSuspended = /* see #1208 */ this.dependenciesState_ === IDerivationState_.NOT_TRACKING_;
        var newValue = this.computeValue_(true);
        var changed = wasSuspended || isCaughtException(oldValue) || isCaughtException(newValue) || !this.equals_(oldValue, newValue);
        if (changed) this.value_ = newValue;
        return changed;
    };
    _proto.computeValue_ = function computeValue_(track) {
        this.isComputing = true;
        // don't allow state changes during computation
        var prev = allowStateChangesStart(false);
        var res;
        if (track) res = trackDerivedFunction(this, this.derivation, this.scope_);
        else {
            if (globalState.disableErrorBoundaries === true) res = this.derivation.call(this.scope_);
            else try {
                res = this.derivation.call(this.scope_);
            } catch (e) {
                res = new CaughtException(e);
            }
        }
        allowStateChangesEnd(prev);
        this.isComputing = false;
        return res;
    };
    _proto.suspend_ = function suspend_() {
        if (!this.keepAlive_) {
            clearObserving(this);
            this.value_ = undefined; // don't hold on to computed value!
        }
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        var _this = this;
        var firstTime = true;
        var prevValue = undefined;
        return autorun(function() {
            // TODO: why is this in a different place than the spyReport() function? in all other observables it's called in the same place
            var newValue = _this.get();
            if (!firstTime || fireImmediately) {
                var prevU = untrackedStart();
                listener({
                    observableKind: "computed",
                    debugObjectName: _this.name_,
                    type: UPDATE,
                    object: _this,
                    newValue: newValue,
                    oldValue: prevValue
                });
                untrackedEnd(prevU);
            }
            firstTime = false;
            prevValue = newValue;
        });
    };
    _proto.warnAboutUntrackedRead_ = function warnAboutUntrackedRead_() {
        return;
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.derivation.toString() + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[Symbol.toPrimitive] = function() {
        return this.valueOf();
    };
    return _createClass(ComputedValue, [
        {
            key: "isComputing",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isComputingMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isComputingMask_, newValue);
            }
        },
        {
            key: "isRunningSetter",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isRunningSetterMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isRunningSetterMask_, newValue);
            }
        },
        {
            key: "isBeingObserved",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isBeingObservedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isBeingObservedMask_, newValue);
            }
        },
        {
            key: "isPendingUnobservation",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isPendingUnobservationMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isPendingUnobservationMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
ComputedValue.isComputingMask_ = 1;
ComputedValue.isRunningSetterMask_ = 2;
ComputedValue.isBeingObservedMask_ = 4;
ComputedValue.isPendingUnobservationMask_ = 8;
ComputedValue.diffValueMask_ = 16;
var isComputedValue = /*#__PURE__*/ createInstanceofPredicate("ComputedValue", ComputedValue);
var IDerivationState_;
(function(IDerivationState_) {
    // before being run or (outside batch and not being observed)
    // at this point derivation is not holding any data about dependency tree
    IDerivationState_[IDerivationState_["NOT_TRACKING_"] = -1] = "NOT_TRACKING_";
    // no shallow dependency changed since last computation
    // won't recalculate derivation
    // this is what makes mobx fast
    IDerivationState_[IDerivationState_["UP_TO_DATE_"] = 0] = "UP_TO_DATE_";
    // some deep dependency changed, but don't know if shallow dependency changed
    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
    // currently only ComputedValue will propagate POSSIBLY_STALE
    //
    // having this state is second big optimization:
    // don't have to recompute on every dependency change, but only when it's needed
    IDerivationState_[IDerivationState_["POSSIBLY_STALE_"] = 1] = "POSSIBLY_STALE_";
    // A shallow dependency has changed since last computation and the derivation
    // will need to recompute when it's needed next.
    IDerivationState_[IDerivationState_["STALE_"] = 2] = "STALE_";
})(IDerivationState_ || (IDerivationState_ = {}));
var TraceMode;
(function(TraceMode) {
    TraceMode[TraceMode["NONE"] = 0] = "NONE";
    TraceMode[TraceMode["LOG"] = 1] = "LOG";
    TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
})(TraceMode || (TraceMode = {}));
var CaughtException = function CaughtException(cause) {
    this.cause = void 0;
    this.cause = cause;
// Empty
};
function isCaughtException(e) {
    return e instanceof CaughtException;
}
/**
 * Finds out whether any dependency of the derivation has actually changed.
 * If dependenciesState is 1 then it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over the dependencies in the same order that they were reported and
 * stopping on the first change, all the recalculations are only called for ComputedValues
 * that will be tracked by derivation. That is because we assume that if the first x
 * dependencies of the derivation doesn't change then the derivation should run the same way
 * up until accessing x-th dependency.
 */ function shouldCompute(derivation) {
    switch(derivation.dependenciesState_){
        case IDerivationState_.UP_TO_DATE_:
            return false;
        case IDerivationState_.NOT_TRACKING_:
        case IDerivationState_.STALE_:
            return true;
        case IDerivationState_.POSSIBLY_STALE_:
            // state propagation can occur outside of action/reactive context #2195
            var prevAllowStateReads = allowStateReadsStart(true);
            var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
            var obs = derivation.observing_, l = obs.length;
            for(var i = 0; i < l; i++){
                var obj = obs[i];
                if (isComputedValue(obj)) {
                    if (globalState.disableErrorBoundaries) obj.get();
                    else try {
                        obj.get();
                    } catch (e) {
                        // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                    // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
                    // and `derivation` is an observer of `obj`
                    // invariantShouldCompute(derivation)
                    if (derivation.dependenciesState_ === IDerivationState_.STALE_) {
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                }
            }
            changeDependenciesStateTo0(derivation);
            untrackedEnd(prevUntracked);
            allowStateReadsEnd(prevAllowStateReads);
            return false;
    }
}
function isComputingDerivation() {
    return globalState.trackingDerivation !== null; // filter out actions inside computations
}
function checkIfStateModificationsAreAllowed(atom) {
    var hasObservers;
    return;
}
function checkIfStateReadsAreAllowed(observable) {}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */ function trackDerivedFunction(derivation, f, context) {
    var prevAllowStateReads = allowStateReadsStart(true);
    changeDependenciesStateTo0(derivation);
    // Preallocate array; will be trimmed by bindDependencies.
    derivation.newObserving_ = new Array(// Reserve constant space for initial dependencies, dynamic space otherwise.
    // See https://github.com/mobxjs/mobx/pull/3833
    derivation.runId_ === 0 ? 100 : derivation.observing_.length);
    derivation.unboundDepsCount_ = 0;
    derivation.runId_ = ++globalState.runId;
    var prevTracking = globalState.trackingDerivation;
    globalState.trackingDerivation = derivation;
    globalState.inBatch++;
    var result;
    if (globalState.disableErrorBoundaries === true) result = f.call(context);
    else try {
        result = f.call(context);
    } catch (e) {
        result = new CaughtException(e);
    }
    globalState.inBatch--;
    globalState.trackingDerivation = prevTracking;
    bindDependencies(derivation);
    warnAboutDerivationWithoutDependencies(derivation);
    allowStateReadsEnd(prevAllowStateReads);
    return result;
}
function warnAboutDerivationWithoutDependencies(derivation) {
    return;
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */ function bindDependencies(derivation) {
    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
    var prevObserving = derivation.observing_;
    var observing = derivation.observing_ = derivation.newObserving_;
    var lowestNewObservingDerivationState = IDerivationState_.UP_TO_DATE_;
    // Go through all new observables and check diffValue: (this list can contain duplicates):
    //   0: first occurrence, change to 1 and keep it
    //   1: extra occurrence, drop it
    var i0 = 0, l = derivation.unboundDepsCount_;
    for(var i = 0; i < l; i++){
        var dep = observing[i];
        if (dep.diffValue === 0) {
            dep.diffValue = 1;
            if (i0 !== i) observing[i0] = dep;
            i0++;
        }
        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
        // not hitting the condition
        if (dep.dependenciesState_ > lowestNewObservingDerivationState) lowestNewObservingDerivationState = dep.dependenciesState_;
    }
    observing.length = i0;
    derivation.newObserving_ = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
    //   0: it's not in new observables, unobserve it
    //   1: it keeps being observed, don't want to notify it. change to 0
    l = prevObserving.length;
    while(l--){
        var _dep = prevObserving[l];
        if (_dep.diffValue === 0) removeObserver(_dep, derivation);
        _dep.diffValue = 0;
    }
    // Go through all new observables and check diffValue: (now it should be unique)
    //   0: it was set to 0 in last loop. don't need to do anything.
    //   1: it wasn't observed, let's observe it. set back to 0
    while(i0--){
        var _dep2 = observing[i0];
        if (_dep2.diffValue === 1) {
            _dep2.diffValue = 0;
            addObserver(_dep2, derivation);
        }
    }
    // Some new observed derivations may become stale during this derivation computation
    // so they have had no chance to propagate staleness (#916)
    if (lowestNewObservingDerivationState !== IDerivationState_.UP_TO_DATE_) {
        derivation.dependenciesState_ = lowestNewObservingDerivationState;
        derivation.onBecomeStale_();
    }
}
function clearObserving(derivation) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
    var obs = derivation.observing_;
    derivation.observing_ = [];
    var i = obs.length;
    while(i--)removeObserver(obs[i], derivation);
    derivation.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
}
function untracked(action) {
    var prev = untrackedStart();
    try {
        return action();
    } finally{
        untrackedEnd(prev);
    }
}
function untrackedStart() {
    var prev = globalState.trackingDerivation;
    globalState.trackingDerivation = null;
    return prev;
}
function untrackedEnd(prev) {
    globalState.trackingDerivation = prev;
}
function allowStateReadsStart(allowStateReads) {
    var prev = globalState.allowStateReads;
    globalState.allowStateReads = allowStateReads;
    return prev;
}
function allowStateReadsEnd(prev) {
    globalState.allowStateReads = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */ function changeDependenciesStateTo0(derivation) {
    if (derivation.dependenciesState_ === IDerivationState_.UP_TO_DATE_) return;
    derivation.dependenciesState_ = IDerivationState_.UP_TO_DATE_;
    var obs = derivation.observing_;
    var i = obs.length;
    while(i--)obs[i].lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
}
/**
 * These values will persist if global state is reset
 */ var persistentKeys = [
    "mobxGuid",
    "spyListeners",
    "enforceActions",
    "computedRequiresReaction",
    "reactionRequiresObservable",
    "observableRequiresReaction",
    "allowStateReads",
    "disableErrorBoundaries",
    "runId",
    "UNCHANGED",
    "useProxies"
];
var MobXGlobals = function MobXGlobals() {
    /**
   * MobXGlobals version.
   * MobX compatiblity with other versions loaded in memory as long as this version matches.
   * It indicates that the global state still stores similar information
   *
   * N.B: this version is unrelated to the package version of MobX, and is only the version of the
   * internal state storage of MobX, and can be the same across many different package versions
   */ this.version = 6;
    /**
   * globally unique token to signal unchanged
   */ this.UNCHANGED = {};
    /**
   * Currently running derivation
   */ this.trackingDerivation = null;
    /**
   * Currently running reaction. This determines if we currently have a reactive context.
   * (Tracking derivation is also set for temporal tracking of computed values inside actions,
   * but trackingReaction can only be set by a form of Reaction)
   */ this.trackingContext = null;
    /**
   * Each time a derivation is tracked, it is assigned a unique run-id
   */ this.runId = 0;
    /**
   * 'guid' for general purpose. Will be persisted amongst resets.
   */ this.mobxGuid = 0;
    /**
   * Are we in a batch block? (and how many of them)
   */ this.inBatch = 0;
    /**
   * Observables that don't have observers anymore, and are about to be
   * suspended, unless somebody else accesses it in the same batch
   *
   * @type {IObservable[]}
   */ this.pendingUnobservations = [];
    /**
   * List of scheduled, not yet executed, reactions.
   */ this.pendingReactions = [];
    /**
   * Are we currently processing reactions?
   */ this.isRunningReactions = false;
    /**
   * Is it allowed to change observables at this point?
   * In general, MobX doesn't allow that when running computations and React.render.
   * To ensure that those functions stay pure.
   */ this.allowStateChanges = false;
    /**
   * Is it allowed to read observables at this point?
   * Used to hold the state needed for `observableRequiresReaction`
   */ this.allowStateReads = true;
    /**
   * If strict mode is enabled, state changes are by default not allowed
   */ this.enforceActions = true;
    /**
   * Spy callbacks
   */ this.spyListeners = [];
    /**
   * Globally attached error handlers that react specifically to errors in reactions
   */ this.globalReactionErrorHandlers = [];
    /**
   * Warn if computed values are accessed outside a reactive context
   */ this.computedRequiresReaction = false;
    /**
   * (Experimental)
   * Warn if you try to create to derivation / reactive context without accessing any observable.
   */ this.reactionRequiresObservable = false;
    /**
   * (Experimental)
   * Warn if observables are accessed outside a reactive context
   */ this.observableRequiresReaction = false;
    /*
   * Don't catch and rethrow exceptions. This is useful for inspecting the state of
   * the stack when an exception occurs while debugging.
   */ this.disableErrorBoundaries = false;
    /*
   * If true, we are already handling an exception in an action. Any errors in reactions should be suppressed, as
   * they are not the cause, see: https://github.com/mobxjs/mobx/issues/1836
   */ this.suppressReactionErrors = false;
    this.useProxies = true;
    /*
   * print warnings about code that would fail if proxies weren't available
   */ this.verifyProxies = false;
    /**
   * False forces all object's descriptors to
   * writable: true
   * configurable: true
   */ this.safeDescriptors = true;
};
var canMergeGlobalState = true;
var isolateCalled = false;
var globalState = /*#__PURE__*/ function() {
    var global1 = /*#__PURE__*/ getGlobal();
    if (global1.__mobxInstanceCount > 0 && !global1.__mobxGlobals) canMergeGlobalState = false;
    if (global1.__mobxGlobals && global1.__mobxGlobals.version !== new MobXGlobals().version) canMergeGlobalState = false;
    if (!canMergeGlobalState) {
        // Because this is a IIFE we need to let isolateCalled a chance to change
        // so we run it after the event loop completed at least 1 iteration
        setTimeout(function() {
            if (!isolateCalled) die(35);
        }, 1);
        return new MobXGlobals();
    } else if (global1.__mobxGlobals) {
        global1.__mobxInstanceCount += 1;
        if (!global1.__mobxGlobals.UNCHANGED) global1.__mobxGlobals.UNCHANGED = {};
         // make merge backward compatible
        return global1.__mobxGlobals;
    } else {
        global1.__mobxInstanceCount = 1;
        return global1.__mobxGlobals = /*#__PURE__*/ new MobXGlobals();
    }
}();
function isolateGlobalState() {
    if (globalState.pendingReactions.length || globalState.inBatch || globalState.isRunningReactions) die(36);
    isolateCalled = true;
    if (canMergeGlobalState) {
        var global1 = getGlobal();
        if (--global1.__mobxInstanceCount === 0) global1.__mobxGlobals = undefined;
        globalState = new MobXGlobals();
    }
}
function getGlobalState() {
    return globalState;
}
/**
 * For testing purposes only; this will break the internal state of existing observables,
 * but can be used to get back at a stable state after throwing errors
 */ function resetGlobalState() {
    var defaultGlobals = new MobXGlobals();
    for(var key in defaultGlobals)if (persistentKeys.indexOf(key) === -1) globalState[key] = defaultGlobals[key];
    globalState.allowStateChanges = !globalState.enforceActions;
}
function hasObservers(observable) {
    return observable.observers_ && observable.observers_.size > 0;
}
function getObservers(observable) {
    return observable.observers_;
}
// function invariantObservers(observable: IObservable) {
//     const list = observable.observers
//     const map = observable.observersIndexes
//     const l = list.length
//     for (let i = 0; i < l; i++) {
//         const id = list[i].__mapid
//         if (i) {
//             invariant(map[id] === i, "INTERNAL ERROR maps derivation.__mapid to index in list") // for performance
//         } else {
//             invariant(!(id in map), "INTERNAL ERROR observer on index 0 shouldn't be held in map.") // for performance
//         }
//     }
//     invariant(
//         list.length === 0 || Object.keys(map).length === list.length - 1,
//         "INTERNAL ERROR there is no junk in map"
//     )
// }
function addObserver(observable, node) {
    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
    // invariantObservers(observable);
    observable.observers_.add(node);
    if (observable.lowestObserverState_ > node.dependenciesState_) observable.lowestObserverState_ = node.dependenciesState_;
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
}
function removeObserver(observable, node) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
    // invariantObservers(observable);
    observable.observers_["delete"](node);
    if (observable.observers_.size === 0) // deleting last observer
    queueForUnobservation(observable);
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function queueForUnobservation(observable) {
    if (observable.isPendingUnobservation === false) {
        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
        observable.isPendingUnobservation = true;
        globalState.pendingUnobservations.push(observable);
    }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */ function startBatch() {
    globalState.inBatch++;
}
function endBatch() {
    if (--globalState.inBatch === 0) {
        runReactions();
        // the batch is actually about to finish, all unobserving should happen here.
        var list = globalState.pendingUnobservations;
        for(var i = 0; i < list.length; i++){
            var observable = list[i];
            observable.isPendingUnobservation = false;
            if (observable.observers_.size === 0) {
                if (observable.isBeingObserved) {
                    // if this observable had reactive observers, trigger the hooks
                    observable.isBeingObserved = false;
                    observable.onBUO();
                }
                if (observable instanceof ComputedValue) // computed values are automatically teared down when the last observer leaves
                // this process happens recursively, this computed might be the last observabe of another, etc..
                observable.suspend_();
            }
        }
        globalState.pendingUnobservations = [];
    }
}
function reportObserved(observable) {
    checkIfStateReadsAreAllowed(observable);
    var derivation = globalState.trackingDerivation;
    if (derivation !== null) {
        /**
     * Simple optimization, give each derivation run an unique id (runId)
     * Check if last time this observable was accessed the same runId is used
     * if this is the case, the relation is already known
     */ if (derivation.runId_ !== observable.lastAccessedBy_) {
            observable.lastAccessedBy_ = derivation.runId_;
            // Tried storing newObserving, or observing, or both as Set, but performance didn't come close...
            derivation.newObserving_[derivation.unboundDepsCount_++] = observable;
            if (!observable.isBeingObserved && globalState.trackingContext) {
                observable.isBeingObserved = true;
                observable.onBO();
            }
        }
        return observable.isBeingObserved;
    } else if (observable.observers_.size === 0 && globalState.inBatch > 0) queueForUnobservation(observable);
    return false;
}
// function invariantLOS(observable: IObservable, msg: string) {
//     // it's expensive so better not run it in produciton. but temporarily helpful for testing
//     const min = getObservers(observable).reduce((a, b) => Math.min(a, b.dependenciesState), 2)
//     if (min >= observable.lowestObserverState) return // <- the only assumption about `lowestObserverState`
//     throw new Error(
//         "lowestObserverState is wrong for " +
//             msg +
//             " because " +
//             min +
//             " < " +
//             observable.lowestObserverState
//     )
// }
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */ // Called by Atom when its value changes
function propagateChanged(observable) {
    // invariantLOS(observable, "changed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    // Ideally we use for..of here, but the downcompiled version is really slow...
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) d.onBecomeStale_();
        d.dependenciesState_ = IDerivationState_.STALE_;
    });
// invariantLOS(observable, "changed end");
}
// Called by ComputedValue when it recalculate and its value changed
function propagateChangeConfirmed(observable) {
    // invariantLOS(observable, "confirmed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.POSSIBLY_STALE_) d.dependenciesState_ = IDerivationState_.STALE_;
        else if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_ // this happens during computing of `d`, just keep lowestObserverState up to date.
        ) observable.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
    });
// invariantLOS(observable, "confirmed end");
}
// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function propagateMaybeChanged(observable) {
    // invariantLOS(observable, "maybe start");
    if (observable.lowestObserverState_ !== IDerivationState_.UP_TO_DATE_) return;
    observable.lowestObserverState_ = IDerivationState_.POSSIBLY_STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) {
            d.dependenciesState_ = IDerivationState_.POSSIBLY_STALE_;
            d.onBecomeStale_();
        }
    });
// invariantLOS(observable, "maybe end");
}
function logTraceInfo(derivation, observable) {
    console.log("[mobx.trace] '" + derivation.name_ + "' is invalidated due to a change in: '" + observable.name_ + "'");
    if (derivation.isTracing_ === TraceMode.BREAK) {
        var lines = [];
        printDepTree(getDependencyTree(derivation), lines, 1);
        // prettier-ignore
        new Function("debugger;\n/*\nTracing '" + derivation.name_ + "'\n\nYou are entering this break point because derivation '" + derivation.name_ + "' is being traced and '" + observable.name_ + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString().replace(/[*]\//g, "/") : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
    }
}
function printDepTree(tree, lines, depth) {
    if (lines.length >= 1000) {
        lines.push("(and many more)");
        return;
    }
    lines.push("" + "\t".repeat(depth - 1) + tree.name);
    if (tree.dependencies) tree.dependencies.forEach(function(child) {
        return printDepTree(child, lines, depth + 1);
    });
}
var Reaction = /*#__PURE__*/ function() {
    function Reaction(name_, onInvalidate_, errorHandler_, requiresObservable_) {
        if (name_ === void 0) name_ = "Reaction";
        this.name_ = void 0;
        this.onInvalidate_ = void 0;
        this.errorHandler_ = void 0;
        this.requiresObservable_ = void 0;
        this.observing_ = [];
        // nodes we are looking at. Our value depends on these nodes
        this.newObserving_ = [];
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.runId_ = 0;
        this.unboundDepsCount_ = 0;
        this.flags_ = 0;
        this.isTracing_ = TraceMode.NONE;
        this.name_ = name_;
        this.onInvalidate_ = onInvalidate_;
        this.errorHandler_ = errorHandler_;
        this.requiresObservable_ = requiresObservable_;
    }
    var _proto = Reaction.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        this.schedule_();
    };
    _proto.schedule_ = function schedule_() {
        if (!this.isScheduled) {
            this.isScheduled = true;
            globalState.pendingReactions.push(this);
            runReactions();
        }
    };
    _proto.runReaction_ = function runReaction_() {
        if (!this.isDisposed) {
            startBatch();
            this.isScheduled = false;
            var prev = globalState.trackingContext;
            globalState.trackingContext = this;
            if (shouldCompute(this)) {
                this.isTrackPending = true;
                try {
                    this.onInvalidate_();
                } catch (e) {
                    this.reportExceptionInDerivation_(e);
                }
            }
            globalState.trackingContext = prev;
            endBatch();
        }
    };
    _proto.track = function track(fn) {
        if (this.isDisposed) return;
        startBatch();
        var notify = isSpyEnabled();
        var startTime;
        this.isRunning = true;
        var prevReaction = globalState.trackingContext; // reactions could create reactions...
        globalState.trackingContext = this;
        var result = trackDerivedFunction(this, fn, undefined);
        globalState.trackingContext = prevReaction;
        this.isRunning = false;
        this.isTrackPending = false;
        if (this.isDisposed) // disposed during last run. Clean up everything that was bound after the dispose call.
        clearObserving(this);
        if (isCaughtException(result)) this.reportExceptionInDerivation_(result.cause);
        endBatch();
    };
    _proto.reportExceptionInDerivation_ = function reportExceptionInDerivation_(error) {
        var _this = this;
        if (this.errorHandler_) {
            this.errorHandler_(error, this);
            return;
        }
        if (globalState.disableErrorBoundaries) throw error;
        var message = "[mobx] uncaught error in '" + this + "'";
        if (!globalState.suppressReactionErrors) console.error(message, error);
         // prettier-ignore
        globalState.globalReactionErrorHandlers.forEach(function(f) {
            return f(error, _this);
        });
    };
    _proto.dispose = function dispose() {
        if (!this.isDisposed) {
            this.isDisposed = true;
            if (!this.isRunning) {
                // if disposed while running, clean up later. Maybe not optimal, but rare case
                startBatch();
                clearObserving(this);
                endBatch();
            }
        }
    };
    _proto.getDisposer_ = function getDisposer_(abortSignal) {
        var _this2 = this;
        var dispose = function dispose() {
            _this2.dispose();
            abortSignal == null || abortSignal.removeEventListener == null || abortSignal.removeEventListener("abort", dispose);
        };
        abortSignal == null || abortSignal.addEventListener == null || abortSignal.addEventListener("abort", dispose);
        dispose[$mobx] = this;
        if ("dispose" in Symbol && typeof Symbol.dispose === "symbol") dispose[Symbol.dispose] = dispose;
        return dispose;
    };
    _proto.toString = function toString() {
        return "Reaction[" + this.name_ + "]";
    };
    _proto.trace = function trace$1(enterBreakPoint) {
        if (enterBreakPoint === void 0) enterBreakPoint = false;
        trace(this, enterBreakPoint);
    };
    return _createClass(Reaction, [
        {
            key: "isDisposed",
            get: function get() {
                return getFlag(this.flags_, Reaction.isDisposedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isDisposedMask_, newValue);
            }
        },
        {
            key: "isScheduled",
            get: function get() {
                return getFlag(this.flags_, Reaction.isScheduledMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isScheduledMask_, newValue);
            }
        },
        {
            key: "isTrackPending",
            get: function get() {
                return getFlag(this.flags_, Reaction.isTrackPendingMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isTrackPendingMask_, newValue);
            }
        },
        {
            key: "isRunning",
            get: function get() {
                return getFlag(this.flags_, Reaction.isRunningMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isRunningMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, Reaction.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
Reaction.isDisposedMask_ = 1;
Reaction.isScheduledMask_ = 2;
Reaction.isTrackPendingMask_ = 4;
Reaction.isRunningMask_ = 8;
Reaction.diffValueMask_ = 16;
function onReactionError(handler) {
    globalState.globalReactionErrorHandlers.push(handler);
    return function() {
        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
        if (idx >= 0) globalState.globalReactionErrorHandlers.splice(idx, 1);
    };
}
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */ var MAX_REACTION_ITERATIONS = 100;
var reactionScheduler = function reactionScheduler(f) {
    return f();
};
function runReactions() {
    // Trampolining, if runReactions are already running, new reactions will be picked up
    if (globalState.inBatch > 0 || globalState.isRunningReactions) return;
    reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
    globalState.isRunningReactions = true;
    var allReactions = globalState.pendingReactions;
    var iterations = 0;
    // While running reactions, new reactions might be triggered.
    // Hence we work with two variables and check whether
    // we converge to no remaining reactions after a while.
    while(allReactions.length > 0){
        if (++iterations === MAX_REACTION_ITERATIONS) {
            console.error("[mobx] cycle in reaction: " + allReactions[0]);
            allReactions.splice(0); // clear reactions
        }
        var remainingReactions = allReactions.splice(0);
        for(var i = 0, l = remainingReactions.length; i < l; i++)remainingReactions[i].runReaction_();
    }
    globalState.isRunningReactions = false;
}
var isReaction = /*#__PURE__*/ createInstanceofPredicate("Reaction", Reaction);
function setReactionScheduler(fn) {
    var baseScheduler = reactionScheduler;
    reactionScheduler = function reactionScheduler(f) {
        return fn(function() {
            return baseScheduler(f);
        });
    };
}
function isSpyEnabled() {
    return false;
}
function spyReport(event) {
    var listeners, i, l;
    return;
}
function spyReportStart(event) {
    var change;
    return;
}
var END_EVENT = {
    type: "report-end",
    spyReportEnd: true
};
function spyReportEnd(change) {
    return;
}
function spy(listener) {
    console.warn("[mobx.spy] Is a no-op in production builds");
    return function() {};
}
var ACTION = "action";
var ACTION_BOUND = "action.bound";
var AUTOACTION = "autoAction";
var AUTOACTION_BOUND = "autoAction.bound";
var DEFAULT_ACTION_NAME = "<unnamed action>";
var actionAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION);
var actionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION_BOUND, {
    bound: true
});
var autoActionAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION, {
    autoAction: true
});
var autoActionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION_BOUND, {
    autoAction: true,
    bound: true
});
function createActionFactory(autoAction) {
    var res = function action(arg1, arg2) {
        // action(fn() {})
        if (isFunction(arg1)) return createAction(arg1.name || DEFAULT_ACTION_NAME, arg1, autoAction);
        // action("name", fn() {})
        if (isFunction(arg2)) return createAction(arg1, arg2, autoAction);
        // @action (2022.3 Decorators)
        if (is20223Decorator(arg2)) return (autoAction ? autoActionAnnotation : actionAnnotation).decorate_20223_(arg1, arg2);
        // @action
        if (isStringish(arg2)) return storeAnnotation(arg1, arg2, autoAction ? autoActionAnnotation : actionAnnotation);
        // action("name") & @action("name")
        if (isStringish(arg1)) return createDecoratorAnnotation(createActionAnnotation(autoAction ? AUTOACTION : ACTION, {
            name: arg1,
            autoAction: autoAction
        }));
    };
    return res;
}
var action = /*#__PURE__*/ createActionFactory(false);
Object.assign(action, actionAnnotation);
var autoAction = /*#__PURE__*/ createActionFactory(true);
Object.assign(autoAction, autoActionAnnotation);
action.bound = /*#__PURE__*/ createDecoratorAnnotation(actionBoundAnnotation);
autoAction.bound = /*#__PURE__*/ createDecoratorAnnotation(autoActionBoundAnnotation);
function runInAction(fn) {
    return executeAction(fn.name || DEFAULT_ACTION_NAME, false, fn, this, undefined);
}
function isAction(thing) {
    return isFunction(thing) && thing.isMobxAction === true;
}
/**
 * Creates a named reactive view and keeps it alive, so that the view is always
 * updated if one of the dependencies changes, even when the view is not further used by something else.
 * @param view The reactive view
 * @returns disposer function, which can be used to stop the view from being updated in the future.
 */ function autorun(view, opts) {
    var _opts$name, _opts, _opts2, _opts3;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name = (_opts = opts) == null ? void 0 : _opts.name) != null ? _opts$name : "Autorun";
    var runSync = !opts.scheduler && !opts.delay;
    var reaction;
    if (runSync) // normal autorun
    reaction = new Reaction(name, function() {
        this.track(reactionRunner);
    }, opts.onError, opts.requiresObservable);
    else {
        var scheduler = createSchedulerFromOptions(opts);
        // debounced autorun
        var isScheduled = false;
        reaction = new Reaction(name, function() {
            if (!isScheduled) {
                isScheduled = true;
                scheduler(function() {
                    isScheduled = false;
                    if (!reaction.isDisposed) reaction.track(reactionRunner);
                });
            }
        }, opts.onError, opts.requiresObservable);
    }
    function reactionRunner() {
        view(reaction);
    }
    if (!((_opts2 = opts) != null && (_opts2 = _opts2.signal) != null && _opts2.aborted)) reaction.schedule_();
    return reaction.getDisposer_((_opts3 = opts) == null ? void 0 : _opts3.signal);
}
var run = function run(f) {
    return f();
};
function createSchedulerFromOptions(opts) {
    return opts.scheduler ? opts.scheduler : opts.delay ? function(f) {
        return setTimeout(f, opts.delay);
    } : run;
}
function reaction(expression, effect, opts) {
    var _opts$name2, _opts4, _opts5;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name2 = opts.name) != null ? _opts$name2 : "Reaction";
    var effectAction = action(name, opts.onError ? wrapErrorHandler(opts.onError, effect) : effect);
    var runSync = !opts.scheduler && !opts.delay;
    var scheduler = createSchedulerFromOptions(opts);
    var firstTime = true;
    var isScheduled = false;
    var value;
    var equals = opts.compareStructural ? comparer.structural : opts.equals || comparer["default"];
    var r = new Reaction(name, function() {
        if (firstTime || runSync) reactionRunner();
        else if (!isScheduled) {
            isScheduled = true;
            scheduler(reactionRunner);
        }
    }, opts.onError, opts.requiresObservable);
    function reactionRunner() {
        isScheduled = false;
        if (r.isDisposed) return;
        var changed = false;
        var oldValue = value;
        r.track(function() {
            var nextValue = allowStateChanges(false, function() {
                return expression(r);
            });
            changed = firstTime || !equals(value, nextValue);
            value = nextValue;
        });
        if (firstTime && opts.fireImmediately) effectAction(value, oldValue, r);
        else if (!firstTime && changed) effectAction(value, oldValue, r);
        firstTime = false;
    }
    if (!((_opts4 = opts) != null && (_opts4 = _opts4.signal) != null && _opts4.aborted)) r.schedule_();
    return r.getDisposer_((_opts5 = opts) == null ? void 0 : _opts5.signal);
}
function wrapErrorHandler(errorHandler, baseFn) {
    return function() {
        try {
            return baseFn.apply(this, arguments);
        } catch (e) {
            errorHandler.call(this, e);
        }
    };
}
var ON_BECOME_OBSERVED = "onBO";
var ON_BECOME_UNOBSERVED = "onBUO";
function onBecomeObserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_OBSERVED, thing, arg2, arg3);
}
function onBecomeUnobserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_UNOBSERVED, thing, arg2, arg3);
}
function interceptHook(hook, thing, arg2, arg3) {
    var atom = typeof arg3 === "function" ? getAtom(thing, arg2) : getAtom(thing);
    var cb = isFunction(arg3) ? arg3 : arg2;
    var listenersKey = hook + "L";
    if (atom[listenersKey]) atom[listenersKey].add(cb);
    else atom[listenersKey] = new Set([
        cb
    ]);
    return function() {
        var hookListeners = atom[listenersKey];
        if (hookListeners) {
            hookListeners["delete"](cb);
            if (hookListeners.size === 0) delete atom[listenersKey];
        }
    };
}
var NEVER = "never";
var ALWAYS = "always";
var OBSERVED = "observed";
// const IF_AVAILABLE = "ifavailable"
function configure(options) {
    if (options.isolateGlobalState === true) isolateGlobalState();
    var useProxies = options.useProxies, enforceActions = options.enforceActions;
    if (useProxies !== undefined) globalState.useProxies = useProxies === ALWAYS ? true : useProxies === NEVER ? false : typeof Proxy !== "undefined";
    if (useProxies === "ifavailable") globalState.verifyProxies = true;
    if (enforceActions !== undefined) {
        var ea = enforceActions === ALWAYS ? ALWAYS : enforceActions === OBSERVED;
        globalState.enforceActions = ea;
        globalState.allowStateChanges = ea === true || ea === ALWAYS ? false : true;
    }
    [
        "computedRequiresReaction",
        "reactionRequiresObservable",
        "observableRequiresReaction",
        "disableErrorBoundaries",
        "safeDescriptors"
    ].forEach(function(key) {
        if (key in options) globalState[key] = !!options[key];
    });
    globalState.allowStateReads = !globalState.observableRequiresReaction;
    if (options.reactionScheduler) setReactionScheduler(options.reactionScheduler);
}
function extendObservable(target, properties, annotations, options) {
    // Pull descriptors first, so we don't have to deal with props added by administration ($mobx)
    var descriptors = getOwnPropertyDescriptors(properties);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        ownKeys(descriptors).forEach(function(key) {
            adm.extend_(key, descriptors[key], // must pass "undefined" for { key: undefined }
            !annotations ? true : key in annotations ? annotations[key] : true);
        });
    });
    return target;
}
function getDependencyTree(thing, property) {
    return nodeToDependencyTree(getAtom(thing, property));
}
function nodeToDependencyTree(node) {
    var result = {
        name: node.name_
    };
    if (node.observing_ && node.observing_.length > 0) result.dependencies = unique(node.observing_).map(nodeToDependencyTree);
    return result;
}
function getObserverTree(thing, property) {
    return nodeToObserverTree(getAtom(thing, property));
}
function nodeToObserverTree(node) {
    var result = {
        name: node.name_
    };
    if (hasObservers(node)) result.observers = Array.from(getObservers(node)).map(nodeToObserverTree);
    return result;
}
function unique(list) {
    return Array.from(new Set(list));
}
var generatorId = 0;
function FlowCancellationError() {
    this.message = "FLOW_CANCELLED";
}
FlowCancellationError.prototype = /*#__PURE__*/ Object.create(Error.prototype);
function isFlowCancellationError(error) {
    return error instanceof FlowCancellationError;
}
var flowAnnotation = /*#__PURE__*/ createFlowAnnotation("flow");
var flowBoundAnnotation = /*#__PURE__*/ createFlowAnnotation("flow.bound", {
    bound: true
});
var flow = /*#__PURE__*/ Object.assign(function flow(arg1, arg2) {
    // @flow (2022.3 Decorators)
    if (is20223Decorator(arg2)) return flowAnnotation.decorate_20223_(arg1, arg2);
    // @flow
    if (isStringish(arg2)) return storeAnnotation(arg1, arg2, flowAnnotation);
    var generator = arg1;
    var name = generator.name || "<unnamed flow>";
    // Implementation based on https://github.com/tj/co/blob/master/index.js
    var res = function res() {
        var ctx = this;
        var args = arguments;
        var runId = ++generatorId;
        var gen = action(name + " - runid: " + runId + " - init", generator).apply(ctx, args);
        var rejector;
        var pendingPromise = undefined;
        var promise = new Promise(function(resolve, reject) {
            var stepId = 0;
            rejector = reject;
            function onFulfilled(res) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.next).call(gen, res);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function onRejected(err) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen["throw"]).call(gen, err);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function next(ret) {
                if (isFunction(ret == null ? void 0 : ret.then)) {
                    // an async iterator
                    ret.then(next, reject);
                    return;
                }
                if (ret.done) return resolve(ret.value);
                pendingPromise = Promise.resolve(ret.value);
                return pendingPromise.then(onFulfilled, onRejected);
            }
            onFulfilled(undefined); // kick off the process
        });
        promise.cancel = action(name + " - runid: " + runId + " - cancel", function() {
            try {
                if (pendingPromise) cancelPromise(pendingPromise);
                // Finally block can return (or yield) stuff..
                var _res = gen["return"](undefined);
                // eat anything that promise would do, it's cancelled!
                var yieldedPromise = Promise.resolve(_res.value);
                yieldedPromise.then(noop, noop);
                cancelPromise(yieldedPromise); // maybe it can be cancelled :)
                // reject our original promise
                rejector(new FlowCancellationError());
            } catch (e) {
                rejector(e); // there could be a throwing finally block
            }
        });
        return promise;
    };
    res.isMobXFlow = true;
    return res;
}, flowAnnotation);
flow.bound = /*#__PURE__*/ createDecoratorAnnotation(flowBoundAnnotation);
function cancelPromise(promise) {
    if (isFunction(promise.cancel)) promise.cancel();
}
function flowResult(result) {
    return result; // just tricking TypeScript :)
}
function isFlow(fn) {
    return (fn == null ? void 0 : fn.isMobXFlow) === true;
}
function interceptReads(thing, propOrHandler, handler) {
    var target;
    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) target = getAdministration(thing);
    else if (isObservableObject(thing)) target = getAdministration(thing, propOrHandler);
    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
    return function() {
        target.dehancer = undefined;
    };
}
function intercept(thing, propOrHandler, handler) {
    if (isFunction(handler)) return interceptProperty(thing, propOrHandler, handler);
    else return interceptInterceptable(thing, propOrHandler);
}
function interceptInterceptable(thing, handler) {
    return getAdministration(thing).intercept_(handler);
}
function interceptProperty(thing, property, handler) {
    return getAdministration(thing, property).intercept_(handler);
}
function _isComputed(value, property) {
    if (property === undefined) return isComputedValue(value);
    if (isObservableObject(value) === false) return false;
    if (!value[$mobx].values_.has(property)) return false;
    var atom = getAtom(value, property);
    return isComputedValue(atom);
}
function isComputed(value) {
    return _isComputed(value);
}
function isComputedProp(value, propName) {
    return _isComputed(value, propName);
}
function _isObservable(value, property) {
    if (!value) return false;
    if (property !== undefined) {
        if (isObservableObject(value)) return value[$mobx].values_.has(property);
        return false;
    }
    // For first check, see #701
    return isObservableObject(value) || !!value[$mobx] || isAtom(value) || isReaction(value) || isComputedValue(value);
}
function isObservable(value) {
    return _isObservable(value);
}
function isObservableProp(value, propName) {
    return _isObservable(value, propName);
}
function keys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].keys_();
    if (isObservableMap(obj) || isObservableSet(obj)) return Array.from(obj.keys());
    if (isObservableArray(obj)) return obj.map(function(_, index) {
        return index;
    });
    die(5);
}
function values(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return obj[key];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return obj.get(key);
    });
    if (isObservableSet(obj)) return Array.from(obj.values());
    if (isObservableArray(obj)) return obj.slice();
    die(6);
}
function entries(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj[key]
        ];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj.get(key)
        ];
    });
    if (isObservableSet(obj)) return Array.from(obj.entries());
    if (isObservableArray(obj)) return obj.map(function(key, index) {
        return [
            index,
            key
        ];
    });
    die(7);
}
function set(obj, key, value) {
    if (arguments.length === 2 && !isObservableSet(obj)) {
        startBatch();
        var _values = key;
        try {
            for(var _key in _values)set(obj, _key, _values[_key]);
        } finally{
            endBatch();
        }
        return;
    }
    if (isObservableObject(obj)) obj[$mobx].set_(key, value);
    else if (isObservableMap(obj)) obj.set(key, value);
    else if (isObservableSet(obj)) obj.add(key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        if (key < 0) die("Invalid index: '" + key + "'");
        startBatch();
        if (key >= obj.length) obj.length = key + 1;
        obj[key] = value;
        endBatch();
    } else die(8);
}
function remove(obj, key) {
    if (isObservableObject(obj)) obj[$mobx].delete_(key);
    else if (isObservableMap(obj)) obj["delete"](key);
    else if (isObservableSet(obj)) obj["delete"](key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        obj.splice(key, 1);
    } else die(9);
}
function has(obj, key) {
    if (isObservableObject(obj)) return obj[$mobx].has_(key);
    else if (isObservableMap(obj)) return obj.has(key);
    else if (isObservableSet(obj)) return obj.has(key);
    else if (isObservableArray(obj)) return key >= 0 && key < obj.length;
    die(10);
}
function get(obj, key) {
    if (!has(obj, key)) return undefined;
    if (isObservableObject(obj)) return obj[$mobx].get_(key);
    else if (isObservableMap(obj)) return obj.get(key);
    else if (isObservableArray(obj)) return obj[key];
    die(11);
}
function apiDefineProperty(obj, key, descriptor) {
    if (isObservableObject(obj)) return obj[$mobx].defineProperty_(key, descriptor);
    die(39);
}
function apiOwnKeys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].ownKeys_();
    die(38);
}
function observe(thing, propOrCb, cbOrFire, fireImmediately) {
    if (isFunction(cbOrFire)) return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
    else return observeObservable(thing, propOrCb, cbOrFire);
}
function observeObservable(thing, listener, fireImmediately) {
    return getAdministration(thing).observe_(listener, fireImmediately);
}
function observeObservableProperty(thing, property, listener, fireImmediately) {
    return getAdministration(thing, property).observe_(listener, fireImmediately);
}
function cache(map, key, value) {
    map.set(key, value);
    return value;
}
function toJSHelper(source, __alreadySeen) {
    if (source == null || typeof source !== "object" || source instanceof Date || !isObservable(source)) return source;
    if (isObservableValue(source) || isComputedValue(source)) return toJSHelper(source.get(), __alreadySeen);
    if (__alreadySeen.has(source)) return __alreadySeen.get(source);
    if (isObservableArray(source)) {
        var res = cache(__alreadySeen, source, new Array(source.length));
        source.forEach(function(value, idx) {
            res[idx] = toJSHelper(value, __alreadySeen);
        });
        return res;
    }
    if (isObservableSet(source)) {
        var _res = cache(__alreadySeen, source, new Set());
        source.forEach(function(value) {
            _res.add(toJSHelper(value, __alreadySeen));
        });
        return _res;
    }
    if (isObservableMap(source)) {
        var _res2 = cache(__alreadySeen, source, new Map());
        source.forEach(function(value, key) {
            _res2.set(key, toJSHelper(value, __alreadySeen));
        });
        return _res2;
    } else {
        // must be observable object
        var _res3 = cache(__alreadySeen, source, {});
        apiOwnKeys(source).forEach(function(key) {
            if (objectPrototype.propertyIsEnumerable.call(source, key)) _res3[key] = toJSHelper(source[key], __alreadySeen);
        });
        return _res3;
    }
}
/**
 * Recursively converts an observable to it's non-observable native counterpart.
 * It does NOT recurse into non-observables, these are left as they are, even if they contain observables.
 * Computed and other non-enumerable properties are completely ignored.
 * Complex scenarios require custom solution, eg implementing `toJSON` or using `serializr` lib.
 */ function toJS(source, options) {
    return toJSHelper(source, new Map());
}
function trace() {
    var enterBreakPoint, _len, args, _key, derivation;
    return;
}
function getAtomFromArgs(args) {
    switch(args.length){
        case 0:
            return globalState.trackingDerivation;
        case 1:
            return getAtom(args[0]);
        case 2:
            return getAtom(args[0], args[1]);
    }
}
/**
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */ function transaction(action, thisArg) {
    if (thisArg === void 0) thisArg = undefined;
    startBatch();
    try {
        return action.apply(thisArg);
    } finally{
        endBatch();
    }
}
function when(predicate, arg1, arg2) {
    if (arguments.length === 1 || arg1 && typeof arg1 === "object") return whenPromise(predicate, arg1);
    return _when(predicate, arg1, arg2 || {});
}
function _when(predicate, effect, opts) {
    var timeoutHandle;
    if (typeof opts.timeout === "number") {
        var error = new Error("WHEN_TIMEOUT");
        timeoutHandle = setTimeout(function() {
            if (!disposer[$mobx].isDisposed) {
                disposer();
                if (opts.onError) opts.onError(error);
                else throw error;
            }
        }, opts.timeout);
    }
    opts.name = "When";
    var effectAction = createAction("When-effect", effect);
    // eslint-disable-next-line
    var disposer = autorun(function(r) {
        // predicate should not change state
        var cond = allowStateChanges(false, predicate);
        if (cond) {
            r.dispose();
            if (timeoutHandle) clearTimeout(timeoutHandle);
            effectAction();
        }
    }, opts);
    return disposer;
}
function whenPromise(predicate, opts) {
    var _opts$signal;
    if (opts != null && (_opts$signal = opts.signal) != null && _opts$signal.aborted) return Object.assign(Promise.reject(new Error("WHEN_ABORTED")), {
        cancel: function cancel() {
            return null;
        }
    });
    var cancel;
    var abort;
    var res = new Promise(function(resolve, reject) {
        var _opts$signal2;
        var disposer = _when(predicate, resolve, _extends({}, opts, {
            onError: reject
        }));
        cancel = function cancel() {
            disposer();
            reject(new Error("WHEN_CANCELLED"));
        };
        abort = function abort() {
            disposer();
            reject(new Error("WHEN_ABORTED"));
        };
        opts == null || (_opts$signal2 = opts.signal) == null || _opts$signal2.addEventListener == null || _opts$signal2.addEventListener("abort", abort);
    })["finally"](function() {
        var _opts$signal3;
        return opts == null || (_opts$signal3 = opts.signal) == null || _opts$signal3.removeEventListener == null ? void 0 : _opts$signal3.removeEventListener("abort", abort);
    });
    res.cancel = cancel;
    return res;
}
function getAdm(target) {
    return target[$mobx];
}
// Optimization: we don't need the intermediate objects and could have a completely custom administration for DynamicObjects,
// and skip either the internal values map, or the base object with its property descriptors!
var objectProxyTraps = {
    has: function has(target, name) {
        return getAdm(target).has_(name);
    },
    get: function get(target, name) {
        return getAdm(target).get_(name);
    },
    set: function set(target, name, value) {
        var _getAdm$set_;
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$set_ = getAdm(target).set_(name, value, true)) != null ? _getAdm$set_ : true;
    },
    deleteProperty: function deleteProperty(target, name) {
        var _getAdm$delete_;
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$delete_ = getAdm(target).delete_(name, true)) != null ? _getAdm$delete_ : true;
    },
    defineProperty: function defineProperty(target, name, descriptor) {
        var _getAdm$definePropert;
        // null (intercepted) -> true (success)
        return (_getAdm$definePropert = getAdm(target).defineProperty_(name, descriptor)) != null ? _getAdm$definePropert : true;
    },
    ownKeys: function ownKeys(target) {
        return getAdm(target).ownKeys_();
    },
    preventExtensions: function preventExtensions(target) {
        die(13);
    }
};
function asDynamicObservableObject(target, options) {
    var _target$$mobx, _target$$mobx$proxy_;
    assertProxies();
    target = asObservableObject(target, options);
    return (_target$$mobx$proxy_ = (_target$$mobx = target[$mobx]).proxy_) != null ? _target$$mobx$proxy_ : _target$$mobx.proxy_ = new Proxy(target, objectProxyTraps);
}
function hasInterceptors(interceptable) {
    return interceptable.interceptors_ !== undefined && interceptable.interceptors_.length > 0;
}
function registerInterceptor(interceptable, handler) {
    var interceptors = interceptable.interceptors_ || (interceptable.interceptors_ = []);
    interceptors.push(handler);
    return once(function() {
        var idx = interceptors.indexOf(handler);
        if (idx !== -1) interceptors.splice(idx, 1);
    });
}
function interceptChange(interceptable, change) {
    var prevU = untrackedStart();
    try {
        // Interceptor can modify the array, copy it to avoid concurrent modification, see #1950
        var interceptors = [].concat(interceptable.interceptors_ || []);
        for(var i = 0, l = interceptors.length; i < l; i++){
            change = interceptors[i](change);
            if (change && !change.type) die(14);
            if (!change) break;
        }
        return change;
    } finally{
        untrackedEnd(prevU);
    }
}
function hasListeners(listenable) {
    return listenable.changeListeners_ !== undefined && listenable.changeListeners_.length > 0;
}
function registerListener(listenable, handler) {
    var listeners = listenable.changeListeners_ || (listenable.changeListeners_ = []);
    listeners.push(handler);
    return once(function() {
        var idx = listeners.indexOf(handler);
        if (idx !== -1) listeners.splice(idx, 1);
    });
}
function notifyListeners(listenable, change) {
    var prevU = untrackedStart();
    var listeners = listenable.changeListeners_;
    if (!listeners) return;
    listeners = listeners.slice();
    for(var i = 0, l = listeners.length; i < l; i++)listeners[i](change);
    untrackedEnd(prevU);
}
function makeObservable(target, annotations, options) {
    initObservable(function() {
        var _annotations;
        var adm = asObservableObject(target, options)[$mobx];
        // Default to decorators
        (_annotations = annotations) != null ? _annotations : annotations = collectStoredAnnotations(target);
        // Annotate
        ownKeys(annotations).forEach(function(key) {
            return adm.make_(key, annotations[key]);
        });
    });
    return target;
}
// proto[keysSymbol] = new Set<PropertyKey>()
var keysSymbol = /*#__PURE__*/ Symbol("mobx-keys");
function makeAutoObservable(target, overrides, options) {
    // Optimization: avoid visiting protos
    // Assumes that annotation.make_/.extend_ works the same for plain objects
    if (isPlainObject(target)) return extendObservable(target, target, overrides, options);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        // Optimization: cache keys on proto
        // Assumes makeAutoObservable can be called only once per object and can't be used in subclass
        if (!target[keysSymbol]) {
            var proto = Object.getPrototypeOf(target);
            var keys = new Set([].concat(ownKeys(target), ownKeys(proto)));
            keys["delete"]("constructor");
            keys["delete"]($mobx);
            addHiddenProp(proto, keysSymbol, keys);
        }
        target[keysSymbol].forEach(function(key) {
            return adm.make_(key, // must pass "undefined" for { key: undefined }
            !overrides ? true : key in overrides ? overrides[key] : true);
        });
    });
    return target;
}
var SPLICE = "splice";
var UPDATE = "update";
var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
var arrayTraps = {
    get: function get(target, name) {
        var adm = target[$mobx];
        if (name === $mobx) return adm;
        if (name === "length") return adm.getArrayLength_();
        if (typeof name === "string" && !isNaN(name)) return adm.get_(parseInt(name));
        if (hasProp(arrayExtensions, name)) return arrayExtensions[name];
        return target[name];
    },
    set: function set(target, name, value) {
        var adm = target[$mobx];
        if (name === "length") adm.setArrayLength_(value);
        if (typeof name === "symbol" || isNaN(name)) target[name] = value;
        else // numeric string
        adm.set_(parseInt(name), value);
        return true;
    },
    preventExtensions: function preventExtensions() {
        die(15);
    }
};
var ObservableArrayAdministration = /*#__PURE__*/ function() {
    function ObservableArrayAdministration(name, enhancer, owned_, legacyMode_) {
        if (name === void 0) name = "ObservableArray";
        this.owned_ = void 0;
        this.legacyMode_ = void 0;
        this.atom_ = void 0;
        this.values_ = [];
        // this is the prop that gets proxied, so can't replace it!
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.enhancer_ = void 0;
        this.dehancer = void 0;
        this.proxy_ = void 0;
        this.lastKnownLength_ = 0;
        this.owned_ = owned_;
        this.legacyMode_ = legacyMode_;
        this.atom_ = new Atom(name);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, "ObservableArray[..]");
        };
    }
    var _proto = ObservableArrayAdministration.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.dehanceValues_ = function dehanceValues_(values) {
        if (this.dehancer !== undefined && values.length > 0) return values.map(this.dehancer);
        return values;
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately === void 0) fireImmediately = false;
        if (fireImmediately) listener({
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: "splice",
            index: 0,
            added: this.values_.slice(),
            addedCount: this.values_.length,
            removed: [],
            removedCount: 0
        });
        return registerListener(this, listener);
    };
    _proto.getArrayLength_ = function getArrayLength_() {
        this.atom_.reportObserved();
        return this.values_.length;
    };
    _proto.setArrayLength_ = function setArrayLength_(newLength) {
        if (typeof newLength !== "number" || isNaN(newLength) || newLength < 0) die("Out of range: " + newLength);
        var currentLength = this.values_.length;
        if (newLength === currentLength) return;
        else if (newLength > currentLength) {
            var newItems = new Array(newLength - currentLength);
            for(var i = 0; i < newLength - currentLength; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            this.spliceWithArray_(currentLength, 0, newItems);
        } else this.spliceWithArray_(newLength, currentLength - newLength);
    };
    _proto.updateArrayLength_ = function updateArrayLength_(oldLength, delta) {
        if (oldLength !== this.lastKnownLength_) die(16);
        this.lastKnownLength_ += delta;
        if (this.legacyMode_ && delta > 0) reserveArrayBuffer(oldLength + delta + 1);
    };
    _proto.spliceWithArray_ = function spliceWithArray_(index, deleteCount, newItems) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        var length = this.values_.length;
        if (index === undefined) index = 0;
        else if (index > length) index = length;
        else if (index < 0) index = Math.max(0, length + index);
        if (arguments.length === 1) deleteCount = length - index;
        else if (deleteCount === undefined || deleteCount === null) deleteCount = 0;
        else deleteCount = Math.max(0, Math.min(deleteCount, length - index));
        if (newItems === undefined) newItems = EMPTY_ARRAY;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_,
                type: SPLICE,
                index: index,
                removedCount: deleteCount,
                added: newItems
            });
            if (!change) return EMPTY_ARRAY;
            deleteCount = change.removedCount;
            newItems = change.added;
        }
        newItems = newItems.length === 0 ? newItems : newItems.map(function(v) {
            return _this.enhancer_(v, undefined);
        });
        if (this.legacyMode_ || false) {
            var lengthDelta = newItems.length - deleteCount;
            this.updateArrayLength_(length, lengthDelta); // checks if internal array wasn't modified
        }
        var res = this.spliceItemsIntoValues_(index, deleteCount, newItems);
        if (deleteCount !== 0 || newItems.length !== 0) this.notifyArraySplice_(index, newItems, res);
        return this.dehanceValues_(res);
    };
    _proto.spliceItemsIntoValues_ = function spliceItemsIntoValues_(index, deleteCount, newItems) {
        if (newItems.length < MAX_SPLICE_SIZE) {
            var _this$values_;
            return (_this$values_ = this.values_).splice.apply(_this$values_, [
                index,
                deleteCount
            ].concat(newItems));
        } else {
            // The items removed by the splice
            var res = this.values_.slice(index, index + deleteCount);
            // The items that that should remain at the end of the array
            var oldItems = this.values_.slice(index + deleteCount);
            // New length is the previous length + addition count - deletion count
            this.values_.length += newItems.length - deleteCount;
            for(var i = 0; i < newItems.length; i++)this.values_[index + i] = newItems[i];
            for(var _i = 0; _i < oldItems.length; _i++)this.values_[index + newItems.length + _i] = oldItems[_i];
            return res;
        }
    };
    _proto.notifyArrayChildUpdate_ = function notifyArrayChildUpdate_(index, newValue, oldValue) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            type: UPDATE,
            debugObjectName: this.atom_.name_,
            index: index,
            newValue: newValue,
            oldValue: oldValue
        } : null;
        this.atom_.reportChanged();
        if (notify) notifyListeners(this, change);
    };
    _proto.notifyArraySplice_ = function notifyArraySplice_(index, added, removed) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: SPLICE,
            index: index,
            removed: removed,
            added: added,
            removedCount: removed.length,
            addedCount: added.length
        } : null;
        this.atom_.reportChanged();
        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
        if (notify) notifyListeners(this, change);
    };
    _proto.get_ = function get_(index) {
        if (this.legacyMode_ && index >= this.values_.length) {
            console.warn("[mobx] Out of bounds read: " + index);
            return undefined;
        }
        this.atom_.reportObserved();
        return this.dehanceValue_(this.values_[index]);
    };
    _proto.set_ = function set_(index, newValue) {
        var values = this.values_;
        if (this.legacyMode_ && index > values.length) // out of bounds
        die(17, index, values.length);
        if (index < values.length) {
            // update at index in range
            checkIfStateModificationsAreAllowed(this.atom_);
            var oldValue = values[index];
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    type: UPDATE,
                    object: this.proxy_,
                    // since "this" is the real array we need to pass its proxy
                    index: index,
                    newValue: newValue
                });
                if (!change) return;
                newValue = change.newValue;
            }
            newValue = this.enhancer_(newValue, oldValue);
            var changed = newValue !== oldValue;
            if (changed) {
                values[index] = newValue;
                this.notifyArrayChildUpdate_(index, newValue, oldValue);
            }
        } else {
            // For out of bound index, we don't create an actual sparse array,
            // but rather fill the holes with undefined (same as setArrayLength_).
            // This could be considered a bug.
            var newItems = new Array(index + 1 - values.length);
            for(var i = 0; i < newItems.length - 1; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            newItems[newItems.length - 1] = newValue;
            this.spliceWithArray_(values.length, 0, newItems);
        }
    };
    return ObservableArrayAdministration;
}();
function createObservableArray(initialValues, enhancer, name, owned) {
    if (name === void 0) name = "ObservableArray";
    if (owned === void 0) owned = false;
    assertProxies();
    return initObservable(function() {
        var adm = new ObservableArrayAdministration(name, enhancer, owned, false);
        addHiddenFinalProp(adm.values_, $mobx, adm);
        var proxy = new Proxy(adm.values_, arrayTraps);
        adm.proxy_ = proxy;
        if (initialValues && initialValues.length) adm.spliceWithArray_(0, 0, initialValues);
        return proxy;
    });
}
// eslint-disable-next-line
var arrayExtensions = {
    clear: function clear() {
        return this.splice(0);
    },
    replace: function replace(newItems) {
        var adm = this[$mobx];
        return adm.spliceWithArray_(0, adm.values_.length, newItems);
    },
    // Used by JSON.stringify
    toJSON: function toJSON() {
        return this.slice();
    },
    /*
   * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
   * since these functions alter the inner structure of the array, the have side effects.
   * Because the have side effects, they should not be used in computed function,
   * and for that reason the do not call dependencyState.notifyObserved
   */ splice: function splice(index, deleteCount) {
        for(var _len = arguments.length, newItems = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)newItems[_key - 2] = arguments[_key];
        var adm = this[$mobx];
        switch(arguments.length){
            case 0:
                return [];
            case 1:
                return adm.spliceWithArray_(index);
            case 2:
                return adm.spliceWithArray_(index, deleteCount);
        }
        return adm.spliceWithArray_(index, deleteCount, newItems);
    },
    spliceWithArray: function spliceWithArray(index, deleteCount, newItems) {
        return this[$mobx].spliceWithArray_(index, deleteCount, newItems);
    },
    push: function push() {
        var adm = this[$mobx];
        for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
        adm.spliceWithArray_(adm.values_.length, 0, items);
        return adm.values_.length;
    },
    pop: function pop() {
        return this.splice(Math.max(this[$mobx].values_.length - 1, 0), 1)[0];
    },
    shift: function shift() {
        return this.splice(0, 1)[0];
    },
    unshift: function unshift() {
        var adm = this[$mobx];
        for(var _len3 = arguments.length, items = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)items[_key3] = arguments[_key3];
        adm.spliceWithArray_(0, 0, items);
        return adm.values_.length;
    },
    reverse: function reverse() {
        // reverse by default mutates in place before returning the result
        // which makes it both a 'derivation' and a 'mutation'.
        if (globalState.trackingDerivation) die(37, "reverse");
        this.replace(this.slice().reverse());
        return this;
    },
    sort: function sort() {
        // sort by default mutates in place before returning the result
        // which goes against all good practices. Let's not change the array in place!
        if (globalState.trackingDerivation) die(37, "sort");
        var copy = this.slice();
        copy.sort.apply(copy, arguments);
        this.replace(copy);
        return this;
    },
    remove: function remove(value) {
        var adm = this[$mobx];
        var idx = adm.dehanceValues_(adm.values_).indexOf(value);
        if (idx > -1) {
            this.splice(idx, 1);
            return true;
        }
        return false;
    }
};
/**
 * Wrap function from prototype
 * Without this, everything works as well, but this works
 * faster as everything works on unproxied values
 */ addArrayExtension("at", simpleFunc);
addArrayExtension("concat", simpleFunc);
addArrayExtension("flat", simpleFunc);
addArrayExtension("includes", simpleFunc);
addArrayExtension("indexOf", simpleFunc);
addArrayExtension("join", simpleFunc);
addArrayExtension("lastIndexOf", simpleFunc);
addArrayExtension("slice", simpleFunc);
addArrayExtension("toString", simpleFunc);
addArrayExtension("toLocaleString", simpleFunc);
addArrayExtension("toSorted", simpleFunc);
addArrayExtension("toSpliced", simpleFunc);
addArrayExtension("with", simpleFunc);
// map
addArrayExtension("every", mapLikeFunc);
addArrayExtension("filter", mapLikeFunc);
addArrayExtension("find", mapLikeFunc);
addArrayExtension("findIndex", mapLikeFunc);
addArrayExtension("findLast", mapLikeFunc);
addArrayExtension("findLastIndex", mapLikeFunc);
addArrayExtension("flatMap", mapLikeFunc);
addArrayExtension("forEach", mapLikeFunc);
addArrayExtension("map", mapLikeFunc);
addArrayExtension("some", mapLikeFunc);
addArrayExtension("toReversed", mapLikeFunc);
// reduce
addArrayExtension("reduce", reduceLikeFunc);
addArrayExtension("reduceRight", reduceLikeFunc);
function addArrayExtension(funcName, funcFactory) {
    if (typeof Array.prototype[funcName] === "function") arrayExtensions[funcName] = funcFactory(funcName);
}
// Report and delegate to dehanced array
function simpleFunc(funcName) {
    return function() {
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
// Make sure callbacks receive correct array arg #2326
function mapLikeFunc(funcName) {
    return function(callback, thisArg) {
        var _this2 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName](function(element, index) {
            return callback.call(thisArg, element, index, _this2);
        });
    };
}
// Make sure callbacks receive correct array arg #2326
function reduceLikeFunc(funcName) {
    return function() {
        var _this3 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        // #2432 - reduce behavior depends on arguments.length
        var callback = arguments[0];
        arguments[0] = function(accumulator, currentValue, index) {
            return callback(accumulator, currentValue, index, _this3);
        };
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
var isObservableArrayAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray(thing) {
    return isObject(thing) && isObservableArrayAdministration(thing[$mobx]);
}
var ObservableMapMarker = {};
var ADD = "add";
var DELETE = "delete";
// just extend Map? See also https://gist.github.com/nestharus/13b4d74f2ef4a2f4357dbd3fc23c1e54
// But: https://github.com/mobxjs/mobx/issues/1556
var ObservableMap = /*#__PURE__*/ function() {
    function ObservableMap(initialData, enhancer_, name_) {
        var _this = this;
        if (enhancer_ === void 0) enhancer_ = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableMap";
        this.enhancer_ = void 0;
        this.name_ = void 0;
        this[$mobx] = ObservableMapMarker;
        this.data_ = void 0;
        this.hasMap_ = void 0;
        // hasMap, not hashMap >-).
        this.keysAtom_ = void 0;
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = enhancer_;
        this.name_ = name_;
        if (!isFunction(Map)) die(18);
        initObservable(function() {
            _this.keysAtom_ = createAtom("ObservableMap.keys()");
            _this.data_ = new Map();
            _this.hasMap_ = new Map();
            if (initialData) _this.merge(initialData);
        });
    }
    var _proto = ObservableMap.prototype;
    _proto.has_ = function has_(key) {
        return this.data_.has(key);
    };
    _proto.has = function has(key) {
        var _this2 = this;
        if (!globalState.trackingDerivation) return this.has_(key);
        var entry = this.hasMap_.get(key);
        if (!entry) {
            var newEntry = entry = new ObservableValue(this.has_(key), referenceEnhancer, "ObservableMap.key?", false);
            this.hasMap_.set(key, newEntry);
            onBecomeUnobserved(newEntry, function() {
                return _this2.hasMap_["delete"](key);
            });
        }
        return entry.get();
    };
    _proto.set = function set(key, value) {
        var hasKey = this.has_(key);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: hasKey ? UPDATE : ADD,
                object: this,
                newValue: value,
                name: key
            });
            if (!change) return this;
            value = change.newValue;
        }
        if (hasKey) this.updateValue_(key, value);
        else this.addValue_(key, value);
        return this;
    };
    _proto["delete"] = function _delete(key) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                name: key
            });
            if (!change) return false;
        }
        if (this.has_(key)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: this.data_.get(key).value_,
                name: key
            } : null;
            transaction(function() {
                var _this3$hasMap_$get;
                _this3.keysAtom_.reportChanged();
                (_this3$hasMap_$get = _this3.hasMap_.get(key)) == null || _this3$hasMap_$get.setNewValue_(false);
                var observable = _this3.data_.get(key);
                observable.setNewValue_(undefined);
                _this3.data_["delete"](key);
            });
            if (notify) notifyListeners(this, _change);
            return true;
        }
        return false;
    };
    _proto.updateValue_ = function updateValue_(key, newValue) {
        var observable = this.data_.get(key);
        newValue = observable.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: UPDATE,
                object: this,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, change);
        }
    };
    _proto.addValue_ = function addValue_(key, newValue) {
        var _this4 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        transaction(function() {
            var _this4$hasMap_$get;
            var observable = new ObservableValue(newValue, _this4.enhancer_, "ObservableMap.key", false);
            _this4.data_.set(key, observable);
            newValue = observable.value_; // value might have been changed
            (_this4$hasMap_$get = _this4.hasMap_.get(key)) == null || _this4$hasMap_$get.setNewValue_(true);
            _this4.keysAtom_.reportChanged();
        });
        var notifySpy = isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "map",
            debugObjectName: this.name_,
            type: ADD,
            object: this,
            name: key,
            newValue: newValue
        } : null;
        if (notify) notifyListeners(this, change);
    };
    _proto.get = function get(key) {
        if (this.has(key)) return this.dehanceValue_(this.data_.get(key).get());
        return this.dehanceValue_(undefined);
    };
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.keys = function keys() {
        this.keysAtom_.reportObserved();
        return this.data_.keys();
    };
    _proto.values = function values() {
        var self1 = this;
        var keys = this.keys();
        return makeIterableForMap({
            next: function next() {
                var _keys$next = keys.next(), done = _keys$next.done, value = _keys$next.value;
                return {
                    done: done,
                    value: done ? undefined : self1.get(value)
                };
            }
        });
    };
    _proto.entries = function entries() {
        var self1 = this;
        var keys = this.keys();
        return makeIterableForMap({
            next: function next() {
                var _keys$next2 = keys.next(), done = _keys$next2.done, value = _keys$next2.value;
                return {
                    done: done,
                    value: done ? undefined : [
                        value,
                        self1.get(value)
                    ]
                };
            }
        });
    };
    _proto[Symbol.iterator] = function() {
        return this.entries();
    };
    _proto.forEach = function forEach(callback, thisArg) {
        for(var _iterator = _createForOfIteratorHelperLoose(this), _step; !(_step = _iterator()).done;){
            var _step$value = _step.value, key = _step$value[0], value = _step$value[1];
            callback.call(thisArg, value, key, this);
        }
    };
    _proto.merge = function merge(other) {
        var _this5 = this;
        if (isObservableMap(other)) other = new Map(other);
        transaction(function() {
            if (isPlainObject(other)) getPlainObjectKeys(other).forEach(function(key) {
                return _this5.set(key, other[key]);
            });
            else if (Array.isArray(other)) other.forEach(function(_ref) {
                var key = _ref[0], value = _ref[1];
                return _this5.set(key, value);
            });
            else if (isES6Map(other)) {
                if (!isPlainES6Map(other)) die(19, other);
                other.forEach(function(value, key) {
                    return _this5.set(key, value);
                });
            } else if (other !== null && other !== undefined) die(20, other);
        });
        return this;
    };
    _proto.clear = function clear() {
        var _this6 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator2 = _createForOfIteratorHelperLoose(_this6.keys()), _step2; !(_step2 = _iterator2()).done;){
                    var key = _step2.value;
                    _this6["delete"](key);
                }
            });
        });
    };
    _proto.replace = function replace(values) {
        var _this7 = this;
        // Implementation requirements:
        // - respect ordering of replacement map
        // - allow interceptors to run and potentially prevent individual operations
        // - don't recreate observables that already exist in original map (so we don't destroy existing subscriptions)
        // - don't _keysAtom.reportChanged if the keys of resulting map are indentical (order matters!)
        // - note that result map may differ from replacement map due to the interceptors
        transaction(function() {
            // Convert to map so we can do quick key lookups
            var replacementMap = convertToMap(values);
            var orderedData = new Map();
            // Used for optimization
            var keysReportChangedCalled = false;
            // Delete keys that don't exist in replacement map
            // if the key deletion is prevented by interceptor
            // add entry at the beginning of the result map
            for(var _iterator3 = _createForOfIteratorHelperLoose(_this7.data_.keys()), _step3; !(_step3 = _iterator3()).done;){
                var key = _step3.value;
                // Concurrently iterating/deleting keys
                // iterator should handle this correctly
                if (!replacementMap.has(key)) {
                    var deleted = _this7["delete"](key);
                    // Was the key removed?
                    if (deleted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                    else {
                        // Delete prevented by interceptor
                        var value = _this7.data_.get(key);
                        orderedData.set(key, value);
                    }
                }
            }
            // Merge entries
            for(var _iterator4 = _createForOfIteratorHelperLoose(replacementMap.entries()), _step4; !(_step4 = _iterator4()).done;){
                var _step4$value = _step4.value, _key = _step4$value[0], _value = _step4$value[1];
                // We will want to know whether a new key is added
                var keyExisted = _this7.data_.has(_key);
                // Add or update value
                _this7.set(_key, _value);
                // The addition could have been prevent by interceptor
                if (_this7.data_.has(_key)) {
                    // The update could have been prevented by interceptor
                    // and also we want to preserve existing values
                    // so use value from _data map (instead of replacement map)
                    var _value2 = _this7.data_.get(_key);
                    orderedData.set(_key, _value2);
                    // Was a new key added?
                    if (!keyExisted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                }
            }
            // Check for possible key order change
            if (!keysReportChangedCalled) {
                if (_this7.data_.size !== orderedData.size) // If size differs, keys are definitely modified
                _this7.keysAtom_.reportChanged();
                else {
                    var iter1 = _this7.data_.keys();
                    var iter2 = orderedData.keys();
                    var next1 = iter1.next();
                    var next2 = iter2.next();
                    while(!next1.done){
                        if (next1.value !== next2.value) {
                            _this7.keysAtom_.reportChanged();
                            break;
                        }
                        next1 = iter1.next();
                        next2 = iter2.next();
                    }
                }
            }
            // Use correctly ordered map
            _this7.data_ = orderedData;
        });
        return this;
    };
    _proto.toString = function toString() {
        return "[object ObservableMap]";
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    /**
   * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
   * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
   * for callback details
   */ _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    return _createClass(ObservableMap, [
        {
            key: "size",
            get: function get() {
                this.keysAtom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Map";
            }
        }
    ]);
}();
// eslint-disable-next-line
var isObservableMap = /*#__PURE__*/ createInstanceofPredicate("ObservableMap", ObservableMap);
function makeIterableForMap(iterator) {
    iterator[Symbol.toStringTag] = "MapIterator";
    return makeIterable(iterator);
}
function convertToMap(dataStructure) {
    if (isES6Map(dataStructure) || isObservableMap(dataStructure)) return dataStructure;
    else if (Array.isArray(dataStructure)) return new Map(dataStructure);
    else if (isPlainObject(dataStructure)) {
        var map = new Map();
        for(var key in dataStructure)map.set(key, dataStructure[key]);
        return map;
    } else return die(21, dataStructure);
}
var ObservableSetMarker = {};
var ObservableSet = /*#__PURE__*/ function() {
    function ObservableSet(initialData, enhancer, name_) {
        var _this = this;
        if (enhancer === void 0) enhancer = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableSet";
        this.name_ = void 0;
        this[$mobx] = ObservableSetMarker;
        this.data_ = new Set();
        this.atom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = void 0;
        this.name_ = name_;
        if (!isFunction(Set)) die(22);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, name_);
        };
        initObservable(function() {
            _this.atom_ = createAtom(_this.name_);
            if (initialData) _this.replace(initialData);
        });
    }
    var _proto = ObservableSet.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.clear = function clear() {
        var _this2 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator = _createForOfIteratorHelperLoose(_this2.data_.values()), _step; !(_step = _iterator()).done;){
                    var value = _step.value;
                    _this2["delete"](value);
                }
            });
        });
    };
    _proto.forEach = function forEach(callbackFn, thisArg) {
        for(var _iterator2 = _createForOfIteratorHelperLoose(this), _step2; !(_step2 = _iterator2()).done;){
            var value = _step2.value;
            callbackFn.call(thisArg, value, value, this);
        }
    };
    _proto.add = function add(value) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: ADD,
                object: this,
                newValue: value
            });
            if (!change) return this;
            // implemented reassignment same as it's done for ObservableMap
            value = change.newValue;
        }
        if (!this.has(value)) {
            transaction(function() {
                _this3.data_.add(_this3.enhancer_(value, undefined));
                _this3.atom_.reportChanged();
            });
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: ADD,
                object: this,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, _change);
        }
        return this;
    };
    _proto["delete"] = function _delete(value) {
        var _this4 = this;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                oldValue: value
            });
            if (!change) return false;
        }
        if (this.has(value)) {
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change2 = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: value
            } : null;
            transaction(function() {
                _this4.atom_.reportChanged();
                _this4.data_["delete"](value);
            });
            if (notify) notifyListeners(this, _change2);
            return true;
        }
        return false;
    };
    _proto.has = function has(value) {
        this.atom_.reportObserved();
        return this.data_.has(this.dehanceValue_(value));
    };
    _proto.entries = function entries() {
        var values = this.values();
        return makeIterableForSet({
            next: function next() {
                var _values$next = values.next(), value = _values$next.value, done = _values$next.done;
                return !done ? {
                    value: [
                        value,
                        value
                    ],
                    done: done
                } : {
                    value: undefined,
                    done: done
                };
            }
        });
    };
    _proto.keys = function keys() {
        return this.values();
    };
    _proto.values = function values() {
        this.atom_.reportObserved();
        var self1 = this;
        var values = this.data_.values();
        return makeIterableForSet({
            next: function next() {
                var _values$next2 = values.next(), value = _values$next2.value, done = _values$next2.done;
                return !done ? {
                    value: self1.dehanceValue_(value),
                    done: done
                } : {
                    value: undefined,
                    done: done
                };
            }
        });
    };
    _proto.intersection = function intersection(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.intersection(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.intersection(otherSet);
        }
    };
    _proto.union = function union(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.union(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.union(otherSet);
        }
    };
    _proto.difference = function difference(otherSet) {
        return new Set(this).difference(otherSet);
    };
    _proto.symmetricDifference = function symmetricDifference(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.symmetricDifference(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.symmetricDifference(otherSet);
        }
    };
    _proto.isSubsetOf = function isSubsetOf(otherSet) {
        return new Set(this).isSubsetOf(otherSet);
    };
    _proto.isSupersetOf = function isSupersetOf(otherSet) {
        return new Set(this).isSupersetOf(otherSet);
    };
    _proto.isDisjointFrom = function isDisjointFrom(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.isDisjointFrom(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.isDisjointFrom(otherSet);
        }
    };
    _proto.replace = function replace(other) {
        var _this5 = this;
        if (isObservableSet(other)) other = new Set(other);
        transaction(function() {
            if (Array.isArray(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (isES6Set(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (other !== null && other !== undefined) die("Cannot initialize set from " + other);
        });
        return this;
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    _proto.toString = function toString() {
        return "[object ObservableSet]";
    };
    _proto[Symbol.iterator] = function() {
        return this.values();
    };
    return _createClass(ObservableSet, [
        {
            key: "size",
            get: function get() {
                this.atom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Set";
            }
        }
    ]);
}();
// eslint-disable-next-line
var isObservableSet = /*#__PURE__*/ createInstanceofPredicate("ObservableSet", ObservableSet);
function makeIterableForSet(iterator) {
    iterator[Symbol.toStringTag] = "SetIterator";
    return makeIterable(iterator);
}
var descriptorCache = /*#__PURE__*/ Object.create(null);
var REMOVE = "remove";
var ObservableObjectAdministration = /*#__PURE__*/ function() {
    function ObservableObjectAdministration(target_, values_, name_, // Used anytime annotation is not explicitely provided
    defaultAnnotation_) {
        if (values_ === void 0) values_ = new Map();
        if (defaultAnnotation_ === void 0) defaultAnnotation_ = autoAnnotation;
        this.target_ = void 0;
        this.values_ = void 0;
        this.name_ = void 0;
        this.defaultAnnotation_ = void 0;
        this.keysAtom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.proxy_ = void 0;
        this.isPlainObject_ = void 0;
        this.appliedAnnotations_ = void 0;
        this.pendingKeys_ = void 0;
        this.target_ = target_;
        this.values_ = values_;
        this.name_ = name_;
        this.defaultAnnotation_ = defaultAnnotation_;
        this.keysAtom_ = new Atom("ObservableObject.keys");
        // Optimization: we use this frequently
        this.isPlainObject_ = isPlainObject(this.target_);
    }
    var _proto = ObservableObjectAdministration.prototype;
    _proto.getObservablePropValue_ = function getObservablePropValue_(key) {
        return this.values_.get(key).get();
    };
    _proto.setObservablePropValue_ = function setObservablePropValue_(key, newValue) {
        var observable = this.values_.get(key);
        if (observable instanceof ComputedValue) {
            observable.set(newValue);
            return true;
        }
        // intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: UPDATE,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: newValue
            });
            if (!change) return null;
            newValue = change.newValue;
        }
        newValue = observable.prepareNewValue_(newValue);
        // notify spy & observers
        if (newValue !== globalState.UNCHANGED) {
            var notify = hasListeners(this);
            var notifySpy = false;
            var _change = notify || notifySpy ? {
                type: UPDATE,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, _change);
        }
        return true;
    };
    _proto.get_ = function get_(key) {
        if (globalState.trackingDerivation && !hasProp(this.target_, key)) // Key doesn't exist yet, subscribe for it in case it's added later
        this.has_(key);
        return this.target_[key];
    };
    _proto.set_ = function set_(key, value, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        // Don't use .has(key) - we care about own
        if (hasProp(this.target_, key)) {
            // Existing prop
            if (this.values_.has(key)) // Observable (can be intercepted)
            return this.setObservablePropValue_(key, value);
            else if (proxyTrap) // Non-observable - proxy
            return Reflect.set(this.target_, key, value);
            else {
                // Non-observable
                this.target_[key] = value;
                return true;
            }
        } else // New prop
        return this.extend_(key, {
            value: value,
            enumerable: true,
            writable: true,
            configurable: true
        }, this.defaultAnnotation_, proxyTrap);
    };
    _proto.has_ = function has_(key) {
        if (!globalState.trackingDerivation) // Skip key subscription outside derivation
        return key in this.target_;
        this.pendingKeys_ || (this.pendingKeys_ = new Map());
        var entry = this.pendingKeys_.get(key);
        if (!entry) {
            entry = new ObservableValue(key in this.target_, referenceEnhancer, "ObservableObject.key?", false);
            this.pendingKeys_.set(key, entry);
        }
        return entry.get();
    };
    _proto.make_ = function make_(key, annotation) {
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return;
        assertAnnotable(this, annotation, key);
        if (!(key in this.target_)) {
            var _this$target_$storedA;
            // Throw on missing key, except for decorators:
            // Decorator annotations are collected from whole prototype chain.
            // When called from super() some props may not exist yet.
            // However we don't have to worry about missing prop,
            // because the decorator must have been applied to something.
            if ((_this$target_$storedA = this.target_[storedAnnotationsSymbol]) != null && _this$target_$storedA[key]) return; // will be annotated by subclass constructor
            else die(1, annotation.annotationType_, this.name_ + "." + key.toString());
        }
        var source = this.target_;
        while(source && source !== objectPrototype){
            var descriptor = getDescriptor(source, key);
            if (descriptor) {
                var outcome = annotation.make_(this, key, descriptor, source);
                if (outcome === 0 /* MakeResult.Cancel */ ) return;
                if (outcome === 1 /* MakeResult.Break */ ) break;
            }
            source = Object.getPrototypeOf(source);
        }
        recordAnnotationApplied(this, annotation, key);
    };
    _proto.extend_ = function extend_(key, descriptor, annotation, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return this.defineProperty_(key, descriptor, proxyTrap);
        assertAnnotable(this, annotation, key);
        var outcome = annotation.extend_(this, key, descriptor, proxyTrap);
        if (outcome) recordAnnotationApplied(this, annotation, key);
        return outcome;
    };
    _proto.defineProperty_ = function defineProperty_(key, descriptor, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: descriptor.value
                });
                if (!change) return null;
                var newValue = change.newValue;
                if (descriptor.value !== newValue) descriptor = _extends({}, descriptor, {
                    value: newValue
                });
            }
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            // Notify
            this.notifyPropertyAddition_(key, descriptor.value);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineObservableProperty_ = function defineObservableProperty_(key, value, enhancer, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: value
                });
                if (!change) return null;
                value = change.newValue;
            }
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: true,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            var observable = new ObservableValue(value, enhancer, "ObservableObject.key", false);
            this.values_.set(key, observable);
            // Notify (value possibly changed by ObservableValue)
            this.notifyPropertyAddition_(key, observable.value_);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineComputedProperty_ = function defineComputedProperty_(key, options, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: undefined
                });
                if (!change) return null;
            }
            options.name || (options.name = "ObservableObject.key");
            options.context = this.proxy_ || this.target_;
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: false,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            this.values_.set(key, new ComputedValue(options));
            // Notify
            this.notifyPropertyAddition_(key, undefined);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.delete_ = function delete_(key, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        // No such prop
        if (!hasProp(this.target_, key)) return true;
        // Intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_ || this.target_,
                name: key,
                type: REMOVE
            });
            // Cancelled
            if (!change) return null;
        }
        // Delete
        try {
            var _this$pendingKeys_;
            startBatch();
            var notify = hasListeners(this);
            var notifySpy = false;
            var observable = this.values_.get(key);
            // Value needed for spies/listeners
            var value = undefined;
            // Optimization: don't pull the value unless we will need it
            if (!observable && (notify || notifySpy)) {
                var _getDescriptor;
                value = (_getDescriptor = getDescriptor(this.target_, key)) == null ? void 0 : _getDescriptor.value;
            }
            // delete prop (do first, may fail)
            if (proxyTrap) {
                if (!Reflect.deleteProperty(this.target_, key)) return false;
            } else delete this.target_[key];
            // Clear observable
            if (observable) {
                this.values_["delete"](key);
                // for computed, value is undefined
                if (observable instanceof ObservableValue) value = observable.value_;
                // Notify: autorun(() => obj[key]), see #1796
                propagateChanged(observable);
            }
            // Notify "keys/entries/values" observers
            this.keysAtom_.reportChanged();
            // Notify "has" observers
            // "in" as it may still exist in proto
            (_this$pendingKeys_ = this.pendingKeys_) == null || (_this$pendingKeys_ = _this$pendingKeys_.get(key)) == null || _this$pendingKeys_.set(key in this.target_);
            // Notify spies/listeners
            if (notify || notifySpy) {
                var _change2 = {
                    type: REMOVE,
                    observableKind: "object",
                    object: this.proxy_ || this.target_,
                    debugObjectName: this.name_,
                    oldValue: value,
                    name: key
                };
                if (notify) notifyListeners(this, _change2);
            }
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.observe_ = function observe_(callback, fireImmediately) {
        return registerListener(this, callback);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.notifyPropertyAddition_ = function notifyPropertyAddition_(key, value) {
        var _this$pendingKeys_2;
        var notify = hasListeners(this);
        var notifySpy = false;
        if (notify || notifySpy) {
            var change = notify || notifySpy ? {
                type: ADD,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, change);
        }
        (_this$pendingKeys_2 = this.pendingKeys_) == null || (_this$pendingKeys_2 = _this$pendingKeys_2.get(key)) == null || _this$pendingKeys_2.set(true);
        // Notify "keys/entries/values" observers
        this.keysAtom_.reportChanged();
    };
    _proto.ownKeys_ = function ownKeys_() {
        this.keysAtom_.reportObserved();
        return ownKeys(this.target_);
    };
    _proto.keys_ = function keys_() {
        // Returns enumerable && own, but unfortunately keysAtom will report on ANY key change.
        // There is no way to distinguish between Object.keys(object) and Reflect.ownKeys(object) - both are handled by ownKeys trap.
        // We can either over-report in Object.keys(object) or under-report in Reflect.ownKeys(object)
        // We choose to over-report in Object.keys(object), because:
        // - typically it's used with simple data objects
        // - when symbolic/non-enumerable keys are relevant Reflect.ownKeys works as expected
        this.keysAtom_.reportObserved();
        return Object.keys(this.target_);
    };
    return ObservableObjectAdministration;
}();
function asObservableObject(target, options) {
    var _options$name;
    if (hasProp(target, $mobx)) return target;
    var name = (_options$name = options == null ? void 0 : options.name) != null ? _options$name : "ObservableObject";
    var adm = new ObservableObjectAdministration(target, new Map(), String(name), getAnnotationFromOptions(options));
    addHiddenProp(target, $mobx, adm);
    return target;
}
var isObservableObjectAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
function getCachedObservablePropDescriptor(key) {
    return descriptorCache[key] || (descriptorCache[key] = {
        get: function get() {
            return this[$mobx].getObservablePropValue_(key);
        },
        set: function set(value) {
            return this[$mobx].setObservablePropValue_(key, value);
        }
    });
}
function isObservableObject(thing) {
    if (isObject(thing)) return isObservableObjectAdministration(thing[$mobx]);
    return false;
}
function recordAnnotationApplied(adm, annotation, key) {
    var _adm$target_$storedAn;
    // Remove applied decorator annotation so we don't try to apply it again in subclass constructor
    (_adm$target_$storedAn = adm.target_[storedAnnotationsSymbol]) == null || delete _adm$target_$storedAn[key];
}
function assertAnnotable(adm, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
// Bug in safari 9.* (or iOS 9 safari mobile). See #364
var ENTRY_0 = /*#__PURE__*/ createArrayEntryDescriptor(0);
var safariPrototypeSetterInheritanceBug = /*#__PURE__*/ function() {
    var v = false;
    var p = {};
    Object.defineProperty(p, "0", {
        set: function set() {
            v = true;
        }
    });
    /*#__PURE__*/ Object.create(p)["0"] = 1;
    return v === false;
}();
/**
 * This array buffer contains two lists of properties, so that all arrays
 * can recycle their property definitions, which significantly improves performance of creating
 * properties on the fly.
 */ var OBSERVABLE_ARRAY_BUFFER_SIZE = 0;
// Typescript workaround to make sure ObservableArray extends Array
var StubArray = function StubArray() {};
function inherit(ctor, proto) {
    if (Object.setPrototypeOf) Object.setPrototypeOf(ctor.prototype, proto);
    else if (ctor.prototype.__proto__ !== undefined) ctor.prototype.__proto__ = proto;
    else ctor.prototype = proto;
}
inherit(StubArray, Array.prototype);
// Weex proto freeze protection was here,
// but it is unclear why the hack is need as MobX never changed the prototype
// anyway, so removed it in V6
var LegacyObservableArray = /*#__PURE__*/ function(_StubArray) {
    function LegacyObservableArray(initialValues, enhancer, name, owned) {
        var _this;
        if (name === void 0) name = "ObservableArray";
        if (owned === void 0) owned = false;
        _this = _StubArray.call(this) || this;
        initObservable(function() {
            var adm = new ObservableArrayAdministration(name, enhancer, owned, true);
            adm.proxy_ = _this;
            addHiddenFinalProp(_this, $mobx, adm);
            if (initialValues && initialValues.length) // @ts-ignore
            _this.spliceWithArray(0, 0, initialValues);
            if (safariPrototypeSetterInheritanceBug) // Seems that Safari won't use numeric prototype setter until any * numeric property is
            // defined on the instance. After that it works fine, even if this property is deleted.
            Object.defineProperty(_this, "0", ENTRY_0);
        });
        return _this;
    }
    _inheritsLoose(LegacyObservableArray, _StubArray);
    var _proto = LegacyObservableArray.prototype;
    _proto.concat = function concat() {
        this[$mobx].atom_.reportObserved();
        for(var _len = arguments.length, arrays = new Array(_len), _key = 0; _key < _len; _key++)arrays[_key] = arguments[_key];
        return Array.prototype.concat.apply(this.slice(), //@ts-ignore
        arrays.map(function(a) {
            return isObservableArray(a) ? a.slice() : a;
        }));
    };
    _proto[Symbol.iterator] = function() {
        var self1 = this;
        var nextIndex = 0;
        return makeIterable({
            next: function next() {
                return nextIndex < self1.length ? {
                    value: self1[nextIndex++],
                    done: false
                } : {
                    done: true,
                    value: undefined
                };
            }
        });
    };
    return _createClass(LegacyObservableArray, [
        {
            key: "length",
            get: function get() {
                return this[$mobx].getArrayLength_();
            },
            set: function set(newLength) {
                this[$mobx].setArrayLength_(newLength);
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Array";
            }
        }
    ]);
}(StubArray);
Object.entries(arrayExtensions).forEach(function(_ref) {
    var prop = _ref[0], fn = _ref[1];
    if (prop !== "concat") addHiddenProp(LegacyObservableArray.prototype, prop, fn);
});
function createArrayEntryDescriptor(index) {
    return {
        enumerable: false,
        configurable: true,
        get: function get() {
            return this[$mobx].get_(index);
        },
        set: function set(value) {
            this[$mobx].set_(index, value);
        }
    };
}
function createArrayBufferItem(index) {
    defineProperty(LegacyObservableArray.prototype, "" + index, createArrayEntryDescriptor(index));
}
function reserveArrayBuffer(max) {
    if (max > OBSERVABLE_ARRAY_BUFFER_SIZE) {
        for(var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max + 100; index++)createArrayBufferItem(index);
        OBSERVABLE_ARRAY_BUFFER_SIZE = max;
    }
}
reserveArrayBuffer(1000);
function createLegacyArray(initialValues, enhancer, name) {
    return new LegacyObservableArray(initialValues, enhancer, name);
}
function getAtom(thing, property) {
    if (typeof thing === "object" && thing !== null) {
        if (isObservableArray(thing)) {
            if (property !== undefined) die(23);
            return thing[$mobx].atom_;
        }
        if (isObservableSet(thing)) return thing.atom_;
        if (isObservableMap(thing)) {
            if (property === undefined) return thing.keysAtom_;
            var observable = thing.data_.get(property) || thing.hasMap_.get(property);
            if (!observable) die(25, property, getDebugName(thing));
            return observable;
        }
        if (isObservableObject(thing)) {
            if (!property) return die(26);
            var _observable = thing[$mobx].values_.get(property);
            if (!_observable) die(27, property, getDebugName(thing));
            return _observable;
        }
        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    } else if (isFunction(thing)) {
        if (isReaction(thing[$mobx])) // disposer function
        return thing[$mobx];
    }
    die(28);
}
function getAdministration(thing, property) {
    if (!thing) die(29);
    if (property !== undefined) return getAdministration(getAtom(thing, property));
    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    if (isObservableMap(thing) || isObservableSet(thing)) return thing;
    if (thing[$mobx]) return thing[$mobx];
    die(24, thing);
}
function getDebugName(thing, property) {
    var named;
    if (property !== undefined) named = getAtom(thing, property);
    else if (isAction(thing)) return thing.name;
    else if (isObservableObject(thing) || isObservableMap(thing) || isObservableSet(thing)) named = getAdministration(thing);
    else // valid for arrays as well
    named = getAtom(thing);
    return named.name_;
}
/**
 * Helper function for initializing observable structures, it applies:
 * 1. allowStateChanges so we don't violate enforceActions.
 * 2. untracked so we don't accidentaly subscribe to anything observable accessed during init in case the observable is created inside derivation.
 * 3. batch to avoid state version updates
 */ function initObservable(cb) {
    var derivation = untrackedStart();
    var allowStateChanges = allowStateChangesStart(true);
    startBatch();
    try {
        return cb();
    } finally{
        endBatch();
        allowStateChangesEnd(allowStateChanges);
        untrackedEnd(derivation);
    }
}
var toString = objectPrototype.toString;
function deepEqual(a, b, depth) {
    if (depth === void 0) depth = -1;
    return eq(a, b, depth);
}
// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
// Modified: "Deep compare objects" part to iterate over keys in forward order instead of reverse order.
//
// Internal recursive comparison function for `isEqual`.
function eq(a, b, depth, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== "function" && type !== "object" && typeof b != "object") return false;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch(className){
        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
        case "[object RegExp]":
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case "[object String]":
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return "" + a === "" + b;
        case "[object Number]":
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a) return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case "[object Date]":
        case "[object Boolean]":
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case "[object Symbol]":
            return typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b);
        case "[object Map]":
        case "[object Set]":
            // Maps and Sets are unwrapped to arrays of entry-pairs, adding an incidental level.
            // Hide this extra level by increasing the depth.
            if (depth >= 0) depth++;
            break;
    }
    // Unwrap any wrapped objects.
    a = unwrap(a);
    b = unwrap(b);
    var areArrays = className === "[object Array]";
    if (!areArrays) {
        if (typeof a != "object" || typeof b != "object") return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor && !(isFunction(aCtor) && aCtor instanceof aCtor && isFunction(bCtor) && bCtor instanceof bCtor) && "constructor" in a && "constructor" in b) return false;
    }
    if (depth === 0) return false;
    else if (depth < 0) depth = -1;
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while(length--){
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a) return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length) return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while(length--){
            if (!eq(a[length], b[length], depth - 1, aStack, bStack)) return false;
        }
    } else {
        // Deep compare objects.
        var keys = Object.keys(a);
        var _length = keys.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if (Object.keys(b).length !== _length) return false;
        for(var i = 0; i < _length; i++){
            // Deep compare each member
            var key = keys[i];
            if (!(hasProp(b, key) && eq(a[key], b[key], depth - 1, aStack, bStack))) return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function unwrap(a) {
    if (isObservableArray(a)) return a.slice();
    if (isES6Map(a) || isObservableMap(a)) return Array.from(a.entries());
    if (isES6Set(a) || isObservableSet(a)) return Array.from(a.entries());
    return a;
}
var _getGlobal$Iterator;
// safely get iterator prototype if available
var maybeIteratorPrototype = ((_getGlobal$Iterator = /*#__PURE__*/ getGlobal().Iterator) == null ? void 0 : _getGlobal$Iterator.prototype) || {};
function makeIterable(iterator) {
    iterator[Symbol.iterator] = getSelf;
    return Object.assign(Object.create(maybeIteratorPrototype), iterator);
}
function getSelf() {
    return this;
}
function isAnnotation(thing) {
    return(// Can be function
    thing instanceof Object && typeof thing.annotationType_ === "string" && isFunction(thing.make_) && isFunction(thing.extend_));
}
/**
 * (c) Michel Weststrate 2015 - 2020
 * MIT Licensed
 *
 * Welcome to the mobx sources! To get a global overview of how MobX internally works,
 * this is a good place to start:
 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
 *
 * Source folders:
 * ===============
 *
 * - api/     Most of the public static methods exposed by the module can be found here.
 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
 * - utils/   Utility stuff.
 *
 */ [
    "Symbol",
    "Map",
    "Set"
].forEach(function(m) {
    var g = getGlobal();
    if (typeof g[m] === "undefined") die("MobX requires global '" + m + "' to be available or polyfilled");
});
if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") // See: https://github.com/andykog/mobx-devtools/
__MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
    spy: spy,
    extras: {
        getDebugName: getDebugName
    },
    $mobx: $mobx
});

});

parcelRegister("f00Nn", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $aeb779073e6ae545$export$a7c73072b1a182ae, (v) => $aeb779073e6ae545$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $aeb779073e6ae545$export$9f27bc3417b4524d, (v) => $aeb779073e6ae545$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $aeb779073e6ae545$export$db77ccec0bb4ccac, (v) => $aeb779073e6ae545$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $aeb779073e6ae545$export$8392c0c9d3dcbd35, (v) => $aeb779073e6ae545$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $aeb779073e6ae545$export$ffb0004e005737fa, (v) => $aeb779073e6ae545$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $aeb779073e6ae545$export$b624eff549462981, (v) => $aeb779073e6ae545$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $aeb779073e6ae545$export$7897aa7841a5380c, (v) => $aeb779073e6ae545$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $aeb779073e6ae545$export$602eac185826482c, (v) => $aeb779073e6ae545$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $aeb779073e6ae545$export$e2c29f18771995cb, (v) => $aeb779073e6ae545$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $aeb779073e6ae545$export$5f8d39834fd61797, (v) => $aeb779073e6ae545$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $aeb779073e6ae545$export$74bf444e3cd11ea5, (v) => $aeb779073e6ae545$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $aeb779073e6ae545$export$998bcd577473dd93, (v) => $aeb779073e6ae545$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $aeb779073e6ae545$export$92387174baf9b227, (v) => $aeb779073e6ae545$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $aeb779073e6ae545$export$ec112efeb987d9c6, (v) => $aeb779073e6ae545$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $aeb779073e6ae545$export$b706b080d889d2c9, (v) => $aeb779073e6ae545$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $aeb779073e6ae545$export$5be5a87408f70ddc, (v) => $aeb779073e6ae545$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $aeb779073e6ae545$export$45a5e7f76e0caa8d, (v) => $aeb779073e6ae545$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $aeb779073e6ae545$export$455c2e768291efa6, (v) => $aeb779073e6ae545$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $aeb779073e6ae545$export$9522e17588c12572, (v) => $aeb779073e6ae545$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $aeb779073e6ae545$export$2110ac352bb060b9, (v) => $aeb779073e6ae545$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $aeb779073e6ae545$export$56885ab8b9c456ab, (v) => $aeb779073e6ae545$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $aeb779073e6ae545$export$d927fcb6adf8f9de, (v) => $aeb779073e6ae545$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $aeb779073e6ae545$export$b82d16f27459e05a, (v) => $aeb779073e6ae545$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $aeb779073e6ae545$export$522c17b4f5e123e8, (v) => $aeb779073e6ae545$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $aeb779073e6ae545$export$1aabd8a0274ecfd6, (v) => $aeb779073e6ae545$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $aeb779073e6ae545$export$3d6c20d97e46b957, (v) => $aeb779073e6ae545$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $aeb779073e6ae545$export$9b621391a187a31a, (v) => $aeb779073e6ae545$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $aeb779073e6ae545$export$f5bbd400c2f4426f, (v) => $aeb779073e6ae545$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $aeb779073e6ae545$export$a7c73072b1a182ae;
var $aeb779073e6ae545$export$9f27bc3417b4524d;
var $aeb779073e6ae545$export$db77ccec0bb4ccac;
var $aeb779073e6ae545$export$8392c0c9d3dcbd35;
var $aeb779073e6ae545$export$ffb0004e005737fa;
var $aeb779073e6ae545$export$b624eff549462981;
var $aeb779073e6ae545$export$7897aa7841a5380c;
var $aeb779073e6ae545$export$602eac185826482c;
var $aeb779073e6ae545$export$e2c29f18771995cb;
var $aeb779073e6ae545$export$5f8d39834fd61797;
var $aeb779073e6ae545$export$74bf444e3cd11ea5;
var $aeb779073e6ae545$export$998bcd577473dd93;
var $aeb779073e6ae545$export$92387174baf9b227;
var $aeb779073e6ae545$export$ec112efeb987d9c6;
var $aeb779073e6ae545$export$b706b080d889d2c9;
var $aeb779073e6ae545$export$5be5a87408f70ddc;
var $aeb779073e6ae545$export$45a5e7f76e0caa8d;
var $aeb779073e6ae545$export$455c2e768291efa6;
var $aeb779073e6ae545$export$9522e17588c12572;
var $aeb779073e6ae545$export$2110ac352bb060b9;
var $aeb779073e6ae545$export$56885ab8b9c456ab;
var $aeb779073e6ae545$export$d927fcb6adf8f9de;
var $aeb779073e6ae545$export$b82d16f27459e05a;
var $aeb779073e6ae545$export$522c17b4f5e123e8;
var $aeb779073e6ae545$export$1aabd8a0274ecfd6;
var $aeb779073e6ae545$export$3d6c20d97e46b957;
var $aeb779073e6ae545$export$9b621391a187a31a;
var $aeb779073e6ae545$export$f5bbd400c2f4426f;
'use strict';
var $aeb779073e6ae545$var$b = Symbol.for("react.element"), $aeb779073e6ae545$var$c = Symbol.for("react.portal"), $aeb779073e6ae545$var$d = Symbol.for("react.fragment"), $aeb779073e6ae545$var$e = Symbol.for("react.strict_mode"), $aeb779073e6ae545$var$f = Symbol.for("react.profiler"), $aeb779073e6ae545$var$g = Symbol.for("react.provider"), $aeb779073e6ae545$var$h = Symbol.for("react.context"), $aeb779073e6ae545$var$k = Symbol.for("react.server_context"), $aeb779073e6ae545$var$l = Symbol.for("react.forward_ref"), $aeb779073e6ae545$var$m = Symbol.for("react.suspense"), $aeb779073e6ae545$var$n = Symbol.for("react.suspense_list"), $aeb779073e6ae545$var$p = Symbol.for("react.memo"), $aeb779073e6ae545$var$q = Symbol.for("react.lazy"), $aeb779073e6ae545$var$t = Symbol.for("react.offscreen"), $aeb779073e6ae545$var$u;
$aeb779073e6ae545$var$u = Symbol.for("react.module.reference");
function $aeb779073e6ae545$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $aeb779073e6ae545$var$b:
                switch(a = a.type, a){
                    case $aeb779073e6ae545$var$d:
                    case $aeb779073e6ae545$var$f:
                    case $aeb779073e6ae545$var$e:
                    case $aeb779073e6ae545$var$m:
                    case $aeb779073e6ae545$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $aeb779073e6ae545$var$k:
                            case $aeb779073e6ae545$var$h:
                            case $aeb779073e6ae545$var$l:
                            case $aeb779073e6ae545$var$q:
                            case $aeb779073e6ae545$var$p:
                            case $aeb779073e6ae545$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $aeb779073e6ae545$var$c:
                return r;
        }
    }
}
$aeb779073e6ae545$export$a7c73072b1a182ae = $aeb779073e6ae545$var$h;
$aeb779073e6ae545$export$9f27bc3417b4524d = $aeb779073e6ae545$var$g;
$aeb779073e6ae545$export$db77ccec0bb4ccac = $aeb779073e6ae545$var$b;
$aeb779073e6ae545$export$8392c0c9d3dcbd35 = $aeb779073e6ae545$var$l;
$aeb779073e6ae545$export$ffb0004e005737fa = $aeb779073e6ae545$var$d;
$aeb779073e6ae545$export$b624eff549462981 = $aeb779073e6ae545$var$q;
$aeb779073e6ae545$export$7897aa7841a5380c = $aeb779073e6ae545$var$p;
$aeb779073e6ae545$export$602eac185826482c = $aeb779073e6ae545$var$c;
$aeb779073e6ae545$export$e2c29f18771995cb = $aeb779073e6ae545$var$f;
$aeb779073e6ae545$export$5f8d39834fd61797 = $aeb779073e6ae545$var$e;
$aeb779073e6ae545$export$74bf444e3cd11ea5 = $aeb779073e6ae545$var$m;
$aeb779073e6ae545$export$998bcd577473dd93 = $aeb779073e6ae545$var$n;
$aeb779073e6ae545$export$92387174baf9b227 = function() {
    return !1;
};
$aeb779073e6ae545$export$ec112efeb987d9c6 = function() {
    return !1;
};
$aeb779073e6ae545$export$b706b080d889d2c9 = function(a) {
    return $aeb779073e6ae545$var$v(a) === $aeb779073e6ae545$var$h;
};
$aeb779073e6ae545$export$5be5a87408f70ddc = function(a) {
    return $aeb779073e6ae545$var$v(a) === $aeb779073e6ae545$var$g;
};
$aeb779073e6ae545$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $aeb779073e6ae545$var$b;
};
$aeb779073e6ae545$export$455c2e768291efa6 = function(a) {
    return $aeb779073e6ae545$var$v(a) === $aeb779073e6ae545$var$l;
};
$aeb779073e6ae545$export$9522e17588c12572 = function(a) {
    return $aeb779073e6ae545$var$v(a) === $aeb779073e6ae545$var$d;
};
$aeb779073e6ae545$export$2110ac352bb060b9 = function(a) {
    return $aeb779073e6ae545$var$v(a) === $aeb779073e6ae545$var$q;
};
$aeb779073e6ae545$export$56885ab8b9c456ab = function(a) {
    return $aeb779073e6ae545$var$v(a) === $aeb779073e6ae545$var$p;
};
$aeb779073e6ae545$export$d927fcb6adf8f9de = function(a) {
    return $aeb779073e6ae545$var$v(a) === $aeb779073e6ae545$var$c;
};
$aeb779073e6ae545$export$b82d16f27459e05a = function(a) {
    return $aeb779073e6ae545$var$v(a) === $aeb779073e6ae545$var$f;
};
$aeb779073e6ae545$export$522c17b4f5e123e8 = function(a) {
    return $aeb779073e6ae545$var$v(a) === $aeb779073e6ae545$var$e;
};
$aeb779073e6ae545$export$1aabd8a0274ecfd6 = function(a) {
    return $aeb779073e6ae545$var$v(a) === $aeb779073e6ae545$var$m;
};
$aeb779073e6ae545$export$3d6c20d97e46b957 = function(a) {
    return $aeb779073e6ae545$var$v(a) === $aeb779073e6ae545$var$n;
};
$aeb779073e6ae545$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $aeb779073e6ae545$var$d || a === $aeb779073e6ae545$var$f || a === $aeb779073e6ae545$var$e || a === $aeb779073e6ae545$var$m || a === $aeb779073e6ae545$var$n || a === $aeb779073e6ae545$var$t || "object" === typeof a && null !== a && (a.$$typeof === $aeb779073e6ae545$var$q || a.$$typeof === $aeb779073e6ae545$var$p || a.$$typeof === $aeb779073e6ae545$var$g || a.$$typeof === $aeb779073e6ae545$var$h || a.$$typeof === $aeb779073e6ae545$var$l || a.$$typeof === $aeb779073e6ae545$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$aeb779073e6ae545$export$f5bbd400c2f4426f = $aeb779073e6ae545$var$v;

});

parcelRegister("b8GbT", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $81c12b4d3b8e8d2a$export$306c0aa65ff9ec16, (v) => $81c12b4d3b8e8d2a$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $81c12b4d3b8e8d2a$export$306c0aa65ff9ec16;
"use strict";
parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
var $N3oW3 = parcelRequire("N3oW3");
function $81c12b4d3b8e8d2a$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $81c12b4d3b8e8d2a$var$objectIs = "function" === typeof Object.is ? Object.is : $81c12b4d3b8e8d2a$var$is, $81c12b4d3b8e8d2a$var$useState = $32rMB.useState, $81c12b4d3b8e8d2a$var$useEffect = $32rMB.useEffect, $81c12b4d3b8e8d2a$var$useLayoutEffect = $32rMB.useLayoutEffect, $81c12b4d3b8e8d2a$var$useDebugValue = $32rMB.useDebugValue;
function $81c12b4d3b8e8d2a$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $81c12b4d3b8e8d2a$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $81c12b4d3b8e8d2a$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $81c12b4d3b8e8d2a$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $81c12b4d3b8e8d2a$var$useEffect(function() {
        $81c12b4d3b8e8d2a$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $81c12b4d3b8e8d2a$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $81c12b4d3b8e8d2a$var$useDebugValue(value);
    return value;
}
function $81c12b4d3b8e8d2a$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$81c12b4d3b8e8d2a$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $81c12b4d3b8e8d2a$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $81c12b4d3b8e8d2a$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $81c12b4d3b8e8d2a$var$useSyncExternalStore$1 : $81c12b4d3b8e8d2a$var$useSyncExternalStore$2;
$81c12b4d3b8e8d2a$export$306c0aa65ff9ec16 = void 0 !== $N3oW3.useSyncExternalStore ? $N3oW3.useSyncExternalStore : $81c12b4d3b8e8d2a$var$shim;

});
parcelRegister("N3oW3", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "useSyncExternalStore", () => $0937371f2be78b0f$export$306c0aa65ff9ec16);
$parcel$export(module.exports, "startTransition", () => $0937371f2be78b0f$export$7568632d0d33d16d);
$parcel$export(module.exports, "useDeferredValue", () => $0937371f2be78b0f$export$6a7bc4e911dc01cf);
$parcel$export(module.exports, "useTransition", () => $0937371f2be78b0f$export$7b286972b8d8ccbf);
$parcel$export(module.exports, "useInsertionEffect", () => $0937371f2be78b0f$export$aaabe4eda9ed9969);
$parcel$export(module.exports, "PureComponent", () => $0937371f2be78b0f$export$221d75b3f55bb0bd);
$parcel$export(module.exports, "memo", () => $0937371f2be78b0f$export$7c73462e0d25e514);
$parcel$export(module.exports, "forwardRef", () => $0937371f2be78b0f$export$257a8862b851cb5b);
$parcel$export(module.exports, "Children", () => $0937371f2be78b0f$export$dca3b0875bd9a954);
$parcel$export(module.exports, "Suspense", () => $0937371f2be78b0f$export$74bf444e3cd11ea5);
$parcel$export(module.exports, "lazy", () => $0937371f2be78b0f$export$488013bae63b21da);
$parcel$export(module.exports, "SuspenseList", () => $0937371f2be78b0f$export$998bcd577473dd93);
$parcel$export(module.exports, "createPortal", () => $0937371f2be78b0f$export$d39a5bbd09211389);
$parcel$export(module.exports, "render", () => $0937371f2be78b0f$export$b3890eb0ae9dca99);
$parcel$export(module.exports, "hydrate", () => $0937371f2be78b0f$export$fa8d919ba61d84db);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0937371f2be78b0f$export$ae55be85d98224ed);
$parcel$export(module.exports, "version", () => $0937371f2be78b0f$export$83d89fbfd8236492);
$parcel$export(module.exports, "createFactory", () => $0937371f2be78b0f$export$d38cd72104c1f0e9);
$parcel$export(module.exports, "isValidElement", () => $0937371f2be78b0f$export$a8257692ac88316c);
$parcel$export(module.exports, "isFragment", () => $0937371f2be78b0f$export$9522e17588c12572);
$parcel$export(module.exports, "isMemo", () => $0937371f2be78b0f$export$56885ab8b9c456ab);
$parcel$export(module.exports, "cloneElement", () => $0937371f2be78b0f$export$e530037191fcd5d7);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0937371f2be78b0f$export$502457920280e6be);
$parcel$export(module.exports, "findDOMNode", () => $0937371f2be78b0f$export$466bfc07425424d5);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0937371f2be78b0f$export$c78a37762a8d58e1);
$parcel$export(module.exports, "flushSync", () => $0937371f2be78b0f$export$cd75ccfd720a3cd4);
$parcel$export(module.exports, "StrictMode", () => $0937371f2be78b0f$export$5f8d39834fd61797);
$parcel$export(module.exports, "isElement", () => $0937371f2be78b0f$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "default", () => $0937371f2be78b0f$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Component", () => (parcelRequire("hO8yS")).Component);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("hO8yS")).Fragment);
$parcel$export(module.exports, "createContext", () => (parcelRequire("hO8yS")).createContext);
$parcel$export(module.exports, "createElement", () => (parcelRequire("hO8yS")).createElement);
$parcel$export(module.exports, "createRef", () => (parcelRequire("hO8yS")).createRef);

var $hO8yS = parcelRequire("hO8yS");

var $32rMB = parcelRequire("32rMB");
function $0937371f2be78b0f$var$g(n, t) {
    for(var e in t)n[e] = t[e];
    return n;
}
function $0937371f2be78b0f$var$E(n, t) {
    for(var e in n)if ("__source" !== e && !(e in t)) return !0;
    for(var r in t)if ("__source" !== r && n[r] !== t[r]) return !0;
    return !1;
}
function $0937371f2be78b0f$export$306c0aa65ff9ec16(n, t) {
    var e = t(), r = (0, $32rMB.useState)({
        t: {
            __: e,
            u: t
        }
    }), u = r[0].t, o = r[1];
    return (0, $32rMB.useLayoutEffect)(function() {
        u.__ = e, u.u = t, $0937371f2be78b0f$var$x(u) && o({
            t: u
        });
    }, [
        n,
        e,
        t
    ]), (0, $32rMB.useEffect)(function() {
        return $0937371f2be78b0f$var$x(u) && o({
            t: u
        }), n(function() {
            $0937371f2be78b0f$var$x(u) && o({
                t: u
            });
        });
    }, [
        n
    ]), e;
}
function $0937371f2be78b0f$var$x(n) {
    var t, e, r = n.u, u = n.__;
    try {
        var o = r();
        return !((t = u) === (e = o) && (0 !== t || 1 / t == 1 / e) || t != t && e != e);
    } catch (n) {
        return !0;
    }
}
function $0937371f2be78b0f$export$7568632d0d33d16d(n) {
    n();
}
function $0937371f2be78b0f$export$6a7bc4e911dc01cf(n) {
    return n;
}
function $0937371f2be78b0f$export$7b286972b8d8ccbf() {
    return [
        !1,
        $0937371f2be78b0f$export$7568632d0d33d16d
    ];
}
var $0937371f2be78b0f$export$aaabe4eda9ed9969 = (0, $32rMB.useLayoutEffect);
function $0937371f2be78b0f$export$221d75b3f55bb0bd(n, t) {
    this.props = n, this.context = t;
}
function $0937371f2be78b0f$export$7c73462e0d25e514(n, e) {
    function r(n) {
        var t = this.props.ref, r = t == n.ref;
        return !r && t && (t.call ? t(null) : t.current = null), e ? !e(this.props, n) || !r : $0937371f2be78b0f$var$E(this.props, n);
    }
    function u(e) {
        return this.shouldComponentUpdate = r, (0, $hO8yS.createElement)(n, e);
    }
    return u.displayName = "Memo(" + (n.displayName || n.name) + ")", u.prototype.isReactComponent = !0, u.__f = !0, u.type = n, u;
}
($0937371f2be78b0f$export$221d75b3f55bb0bd.prototype = new (0, $hO8yS.Component)).isPureReactComponent = !0, $0937371f2be78b0f$export$221d75b3f55bb0bd.prototype.shouldComponentUpdate = function(n, t) {
    return $0937371f2be78b0f$var$E(this.props, n) || $0937371f2be78b0f$var$E(this.state, t);
};
var $0937371f2be78b0f$var$T = (0, $hO8yS.options).__b;
(0, $hO8yS.options).__b = function(n) {
    n.type && n.type.__f && n.ref && (n.props.ref = n.ref, n.ref = null), $0937371f2be78b0f$var$T && $0937371f2be78b0f$var$T(n);
};
var $0937371f2be78b0f$var$A = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.forward_ref") || 3911;
function $0937371f2be78b0f$export$257a8862b851cb5b(n) {
    function t(t) {
        var e = $0937371f2be78b0f$var$g({}, t);
        return delete e.ref, n(e, t.ref || null);
    }
    return t.$$typeof = $0937371f2be78b0f$var$A, t.render = n, t.prototype.isReactComponent = t.__f = !0, t.displayName = "ForwardRef(" + (n.displayName || n.name) + ")", t;
}
var $0937371f2be78b0f$var$L = function(n, t) {
    return null == n ? null : (0, $hO8yS.toChildArray)((0, $hO8yS.toChildArray)(n).map(t));
}, $0937371f2be78b0f$export$dca3b0875bd9a954 = {
    map: $0937371f2be78b0f$var$L,
    forEach: $0937371f2be78b0f$var$L,
    count: function(n) {
        return n ? (0, $hO8yS.toChildArray)(n).length : 0;
    },
    only: function(n) {
        var t = (0, $hO8yS.toChildArray)(n);
        if (1 !== t.length) throw "Children.only";
        return t[0];
    },
    toArray: (0, $hO8yS.toChildArray)
}, $0937371f2be78b0f$var$F = (0, $hO8yS.options).__e;
(0, $hO8yS.options).__e = function(n, t, e, r) {
    if (n.then) {
        for(var u, o = t; o = o.__;)if ((u = o.__c) && u.__c) return null == t.__e && (t.__e = e.__e, t.__k = e.__k), u.__c(n, t);
    }
    $0937371f2be78b0f$var$F(n, t, e, r);
};
var $0937371f2be78b0f$var$U = (0, $hO8yS.options).unmount;
function $0937371f2be78b0f$var$V(n, t, e) {
    return n && (n.__c && n.__c.__H && (n.__c.__H.__.forEach(function(n) {
        "function" == typeof n.__c && n.__c();
    }), n.__c.__H = null), null != (n = $0937371f2be78b0f$var$g({}, n)).__c && (n.__c.__P === e && (n.__c.__P = t), n.__c.__e = !0, n.__c = null), n.__k = n.__k && n.__k.map(function(n) {
        return $0937371f2be78b0f$var$V(n, t, e);
    })), n;
}
function $0937371f2be78b0f$var$W(n, t, e) {
    return n && e && (n.__v = null, n.__k = n.__k && n.__k.map(function(n) {
        return $0937371f2be78b0f$var$W(n, t, e);
    }), n.__c && n.__c.__P === t && (n.__e && e.appendChild(n.__e), n.__c.__e = !0, n.__c.__P = e)), n;
}
function $0937371f2be78b0f$export$74bf444e3cd11ea5() {
    this.__u = 0, this.o = null, this.__b = null;
}
function $0937371f2be78b0f$var$j(n) {
    var t = n.__.__c;
    return t && t.__a && t.__a(n);
}
function $0937371f2be78b0f$export$488013bae63b21da(n) {
    var e, r, u, o = null;
    function i(i) {
        if (e || (e = n()).then(function(n) {
            n && (o = n.default || n), u = !0;
        }, function(n) {
            r = n, u = !0;
        }), r) throw r;
        if (!u) throw e;
        return o ? (0, $hO8yS.createElement)(o, i) : null;
    }
    return i.displayName = "Lazy", i.__f = !0, i;
}
function $0937371f2be78b0f$export$998bcd577473dd93() {
    this.i = null, this.l = null;
}
(0, $hO8yS.options).unmount = function(n) {
    var t = n.__c;
    t && t.__R && t.__R(), t && 32 & n.__u && (n.type = null), $0937371f2be78b0f$var$U && $0937371f2be78b0f$var$U(n);
}, ($0937371f2be78b0f$export$74bf444e3cd11ea5.prototype = new (0, $hO8yS.Component)).__c = function(n, t) {
    var e = t.__c, r = this;
    null == r.o && (r.o = []), r.o.push(e);
    var u = $0937371f2be78b0f$var$j(r.__v), o = !1, i = function() {
        o || (o = !0, e.__R = null, u ? u(l) : l());
    };
    e.__R = i;
    var l = function() {
        if (!--r.__u) {
            if (r.state.__a) {
                var n = r.state.__a;
                r.__v.__k[0] = $0937371f2be78b0f$var$W(n, n.__c.__P, n.__c.__O);
            }
            var t;
            for(r.setState({
                __a: r.__b = null
            }); t = r.o.pop();)t.forceUpdate();
        }
    };
    r.__u++ || 32 & t.__u || r.setState({
        __a: r.__b = r.__v.__k[0]
    }), n.then(i, i);
}, $0937371f2be78b0f$export$74bf444e3cd11ea5.prototype.componentWillUnmount = function() {
    this.o = [];
}, $0937371f2be78b0f$export$74bf444e3cd11ea5.prototype.render = function(n, e) {
    if (this.__b) {
        if (this.__v.__k) {
            var r = document.createElement("div"), o = this.__v.__k[0].__c;
            this.__v.__k[0] = $0937371f2be78b0f$var$V(this.__b, r, o.__O = o.__P);
        }
        this.__b = null;
    }
    var i = e.__a && (0, $hO8yS.createElement)((0, $hO8yS.Fragment), null, n.fallback);
    return i && (i.__u &= -33), [
        (0, $hO8yS.createElement)((0, $hO8yS.Fragment), null, e.__a ? null : n.children),
        i
    ];
};
var $0937371f2be78b0f$var$H = function(n, t, e) {
    if (++e[1] === e[0] && n.l.delete(t), n.props.revealOrder && ("t" !== n.props.revealOrder[0] || !n.l.size)) for(e = n.i; e;){
        for(; e.length > 3;)e.pop()();
        if (e[1] < e[0]) break;
        n.i = e = e[2];
    }
};
function $0937371f2be78b0f$var$Z(n) {
    return this.getChildContext = function() {
        return n.context;
    }, n.children;
}
function $0937371f2be78b0f$var$Y(n) {
    var e = this, r = n.h;
    if (e.componentWillUnmount = function() {
        (0, $hO8yS.render)(null, e.v), e.v = null, e.h = null;
    }, e.h && e.h !== r && e.componentWillUnmount(), !e.v) {
        for(var u = e.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        e.h = r, e.v = {
            nodeType: 1,
            parentNode: r,
            childNodes: [],
            __k: {
                __m: u.__m
            },
            contains: function() {
                return !0;
            },
            insertBefore: function(n, t) {
                this.childNodes.push(n), e.h.insertBefore(n, t);
            },
            removeChild: function(n) {
                this.childNodes.splice(this.childNodes.indexOf(n) >>> 1, 1), e.h.removeChild(n);
            }
        };
    }
    (0, $hO8yS.render)((0, $hO8yS.createElement)($0937371f2be78b0f$var$Z, {
        context: e.context
    }, n.__v), e.v);
}
function $0937371f2be78b0f$export$d39a5bbd09211389(n, e) {
    var r = (0, $hO8yS.createElement)($0937371f2be78b0f$var$Y, {
        __v: n,
        h: e
    });
    return r.containerInfo = e, r;
}
($0937371f2be78b0f$export$998bcd577473dd93.prototype = new (0, $hO8yS.Component)).__a = function(n) {
    var t = this, e = $0937371f2be78b0f$var$j(t.__v), r = t.l.get(n);
    return r[0]++, function(u) {
        var o = function() {
            t.props.revealOrder ? (r.push(u), $0937371f2be78b0f$var$H(t, n, r)) : u();
        };
        e ? e(o) : o();
    };
}, $0937371f2be78b0f$export$998bcd577473dd93.prototype.render = function(n) {
    this.i = null, this.l = new Map;
    var t = (0, $hO8yS.toChildArray)(n.children);
    n.revealOrder && "b" === n.revealOrder[0] && t.reverse();
    for(var e = t.length; e--;)this.l.set(t[e], this.i = [
        1,
        0,
        this.i
    ]);
    return n.children;
}, $0937371f2be78b0f$export$998bcd577473dd93.prototype.componentDidUpdate = $0937371f2be78b0f$export$998bcd577473dd93.prototype.componentDidMount = function() {
    var n = this;
    this.l.forEach(function(t, e) {
        $0937371f2be78b0f$var$H(n, e, t);
    });
};
var $0937371f2be78b0f$var$q = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103, $0937371f2be78b0f$var$G = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image(!S)|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, $0937371f2be78b0f$var$J = /^on(Ani|Tra|Tou|BeforeInp|Compo)/, $0937371f2be78b0f$var$K = /[A-Z0-9]/g, $0937371f2be78b0f$var$Q = "undefined" != typeof document, $0937371f2be78b0f$var$X = function(n) {
    return ("undefined" != typeof Symbol && "symbol" == typeof Symbol() ? /fil|che|rad/ : /fil|che|ra/).test(n);
};
function $0937371f2be78b0f$export$b3890eb0ae9dca99(n, t, e) {
    return null == t.__k && (t.textContent = ""), (0, $hO8yS.render)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
function $0937371f2be78b0f$export$fa8d919ba61d84db(n, t, e) {
    return (0, $hO8yS.hydrate)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
(0, $hO8yS.Component).prototype.isReactComponent = {}, [
    "componentWillMount",
    "componentWillReceiveProps",
    "componentWillUpdate"
].forEach(function(t) {
    Object.defineProperty((0, $hO8yS.Component).prototype, t, {
        configurable: !0,
        get: function() {
            return this["UNSAFE_" + t];
        },
        set: function(n) {
            Object.defineProperty(this, t, {
                configurable: !0,
                writable: !0,
                value: n
            });
        }
    });
});
var $0937371f2be78b0f$var$en = (0, $hO8yS.options).event;
function $0937371f2be78b0f$var$rn() {}
function $0937371f2be78b0f$var$un() {
    return this.cancelBubble;
}
function $0937371f2be78b0f$var$on() {
    return this.defaultPrevented;
}
(0, $hO8yS.options).event = function(n) {
    return $0937371f2be78b0f$var$en && (n = $0937371f2be78b0f$var$en(n)), n.persist = $0937371f2be78b0f$var$rn, n.isPropagationStopped = $0937371f2be78b0f$var$un, n.isDefaultPrevented = $0937371f2be78b0f$var$on, n.nativeEvent = n;
};
var $0937371f2be78b0f$var$ln, $0937371f2be78b0f$var$cn = {
    enumerable: !1,
    configurable: !0,
    get: function() {
        return this.class;
    }
}, $0937371f2be78b0f$var$fn = (0, $hO8yS.options).vnode;
(0, $hO8yS.options).vnode = function(n) {
    "string" == typeof n.type && function(n) {
        var t = n.props, e = n.type, u = {}, o = -1 === e.indexOf("-");
        for(var i in t){
            var l = t[i];
            if (!("value" === i && "defaultValue" in t && null == l || $0937371f2be78b0f$var$Q && "children" === i && "noscript" === e || "class" === i || "className" === i)) {
                var c = i.toLowerCase();
                "defaultValue" === i && "value" in t && null == t.value ? i = "value" : "download" === i && !0 === l ? l = "" : "translate" === c && "no" === l ? l = !1 : "o" === c[0] && "n" === c[1] ? "ondoubleclick" === c ? i = "ondblclick" : "onchange" !== c || "input" !== e && "textarea" !== e || $0937371f2be78b0f$var$X(t.type) ? "onfocus" === c ? i = "onfocusin" : "onblur" === c ? i = "onfocusout" : $0937371f2be78b0f$var$J.test(i) && (i = c) : c = i = "oninput" : o && $0937371f2be78b0f$var$G.test(i) ? i = i.replace($0937371f2be78b0f$var$K, "-$&").toLowerCase() : null === l && (l = void 0), "oninput" === c && u[i = c] && (i = "oninputCapture"), u[i] = l;
            }
        }
        "select" == e && u.multiple && Array.isArray(u.value) && (u.value = (0, $hO8yS.toChildArray)(t.children).forEach(function(n) {
            n.props.selected = -1 != u.value.indexOf(n.props.value);
        })), "select" == e && null != u.defaultValue && (u.value = (0, $hO8yS.toChildArray)(t.children).forEach(function(n) {
            n.props.selected = u.multiple ? -1 != u.defaultValue.indexOf(n.props.value) : u.defaultValue == n.props.value;
        })), t.class && !t.className ? (u.class = t.class, Object.defineProperty(u, "className", $0937371f2be78b0f$var$cn)) : (t.className && !t.class || t.class && t.className) && (u.class = u.className = t.className), n.props = u;
    }(n), n.$$typeof = $0937371f2be78b0f$var$q, $0937371f2be78b0f$var$fn && $0937371f2be78b0f$var$fn(n);
};
var $0937371f2be78b0f$var$an = (0, $hO8yS.options).__r;
(0, $hO8yS.options).__r = function(n) {
    $0937371f2be78b0f$var$an && $0937371f2be78b0f$var$an(n), $0937371f2be78b0f$var$ln = n.__c;
};
var $0937371f2be78b0f$var$sn = (0, $hO8yS.options).diffed;
(0, $hO8yS.options).diffed = function(n) {
    $0937371f2be78b0f$var$sn && $0937371f2be78b0f$var$sn(n);
    var t = n.props, e = n.__e;
    null != e && "textarea" === n.type && "value" in t && t.value !== e.value && (e.value = null == t.value ? "" : t.value), $0937371f2be78b0f$var$ln = null;
};
var $0937371f2be78b0f$export$ae55be85d98224ed = {
    ReactCurrentDispatcher: {
        current: {
            readContext: function(n) {
                return $0937371f2be78b0f$var$ln.__n[n.__c].props.value;
            },
            useCallback: (0, $32rMB.useCallback),
            useContext: (0, $32rMB.useContext),
            useDebugValue: (0, $32rMB.useDebugValue),
            useDeferredValue: $0937371f2be78b0f$export$6a7bc4e911dc01cf,
            useEffect: (0, $32rMB.useEffect),
            useId: (0, $32rMB.useId),
            useImperativeHandle: (0, $32rMB.useImperativeHandle),
            useInsertionEffect: $0937371f2be78b0f$export$aaabe4eda9ed9969,
            useLayoutEffect: (0, $32rMB.useLayoutEffect),
            useMemo: (0, $32rMB.useMemo),
            useReducer: (0, $32rMB.useReducer),
            useRef: (0, $32rMB.useRef),
            useState: (0, $32rMB.useState),
            useSyncExternalStore: $0937371f2be78b0f$export$306c0aa65ff9ec16,
            useTransition: $0937371f2be78b0f$export$7b286972b8d8ccbf
        }
    }
}, $0937371f2be78b0f$export$83d89fbfd8236492 = "18.3.1";
function $0937371f2be78b0f$export$d38cd72104c1f0e9(n) {
    return (0, $hO8yS.createElement).bind(null, n);
}
function $0937371f2be78b0f$export$a8257692ac88316c(n) {
    return !!n && n.$$typeof === $0937371f2be78b0f$var$q;
}
function $0937371f2be78b0f$export$9522e17588c12572(n) {
    return $0937371f2be78b0f$export$a8257692ac88316c(n) && n.type === (0, $hO8yS.Fragment);
}
function $0937371f2be78b0f$export$56885ab8b9c456ab(n) {
    return !!n && !!n.displayName && ("string" == typeof n.displayName || n.displayName instanceof String) && n.displayName.startsWith("Memo(");
}
function $0937371f2be78b0f$export$e530037191fcd5d7(n) {
    return $0937371f2be78b0f$export$a8257692ac88316c(n) ? (0, $hO8yS.cloneElement).apply(null, arguments) : n;
}
function $0937371f2be78b0f$export$502457920280e6be(n) {
    return !!n.__k && ((0, $hO8yS.render)(null, n), !0);
}
function $0937371f2be78b0f$export$466bfc07425424d5(n) {
    return n && (n.base || 1 === n.nodeType && n) || null;
}
var $0937371f2be78b0f$export$c78a37762a8d58e1 = function(n, t) {
    return n(t);
}, $0937371f2be78b0f$export$cd75ccfd720a3cd4 = function(n, t) {
    return n(t);
}, $0937371f2be78b0f$export$5f8d39834fd61797 = (0, $hO8yS.Fragment), $0937371f2be78b0f$export$45a5e7f76e0caa8d = $0937371f2be78b0f$export$a8257692ac88316c, $0937371f2be78b0f$export$2e2bcd8739ae039 = {
    useState: (0, $32rMB.useState),
    useId: (0, $32rMB.useId),
    useReducer: (0, $32rMB.useReducer),
    useEffect: (0, $32rMB.useEffect),
    useLayoutEffect: (0, $32rMB.useLayoutEffect),
    useInsertionEffect: $0937371f2be78b0f$export$aaabe4eda9ed9969,
    useTransition: $0937371f2be78b0f$export$7b286972b8d8ccbf,
    useDeferredValue: $0937371f2be78b0f$export$6a7bc4e911dc01cf,
    useSyncExternalStore: $0937371f2be78b0f$export$306c0aa65ff9ec16,
    startTransition: $0937371f2be78b0f$export$7568632d0d33d16d,
    useRef: (0, $32rMB.useRef),
    useImperativeHandle: (0, $32rMB.useImperativeHandle),
    useMemo: (0, $32rMB.useMemo),
    useCallback: (0, $32rMB.useCallback),
    useContext: (0, $32rMB.useContext),
    useDebugValue: (0, $32rMB.useDebugValue),
    version: "18.3.1",
    Children: $0937371f2be78b0f$export$dca3b0875bd9a954,
    render: $0937371f2be78b0f$export$b3890eb0ae9dca99,
    hydrate: $0937371f2be78b0f$export$fa8d919ba61d84db,
    unmountComponentAtNode: $0937371f2be78b0f$export$502457920280e6be,
    createPortal: $0937371f2be78b0f$export$d39a5bbd09211389,
    createElement: (0, $hO8yS.createElement),
    createContext: (0, $hO8yS.createContext),
    createFactory: $0937371f2be78b0f$export$d38cd72104c1f0e9,
    cloneElement: $0937371f2be78b0f$export$e530037191fcd5d7,
    createRef: (0, $hO8yS.createRef),
    Fragment: (0, $hO8yS.Fragment),
    isValidElement: $0937371f2be78b0f$export$a8257692ac88316c,
    isElement: $0937371f2be78b0f$export$45a5e7f76e0caa8d,
    isFragment: $0937371f2be78b0f$export$9522e17588c12572,
    isMemo: $0937371f2be78b0f$export$56885ab8b9c456ab,
    findDOMNode: $0937371f2be78b0f$export$466bfc07425424d5,
    Component: (0, $hO8yS.Component),
    PureComponent: $0937371f2be78b0f$export$221d75b3f55bb0bd,
    memo: $0937371f2be78b0f$export$7c73462e0d25e514,
    forwardRef: $0937371f2be78b0f$export$257a8862b851cb5b,
    flushSync: $0937371f2be78b0f$export$cd75ccfd720a3cd4,
    unstable_batchedUpdates: $0937371f2be78b0f$export$c78a37762a8d58e1,
    StrictMode: $0937371f2be78b0f$export$5f8d39834fd61797,
    Suspense: $0937371f2be78b0f$export$74bf444e3cd11ea5,
    SuspenseList: $0937371f2be78b0f$export$998bcd577473dd93,
    lazy: $0937371f2be78b0f$export$488013bae63b21da,
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: $0937371f2be78b0f$export$ae55be85d98224ed
};
$parcel$exportWildcard(module.exports, $32rMB);

});
parcelRegister("hO8yS", function(module, exports) {

$parcel$export(module.exports, "options", () => $cf6dbf544b47d79d$export$41c562ebe57d11e2);
$parcel$export(module.exports, "createElement", () => $cf6dbf544b47d79d$export$c8a8987d4410bf2d);
$parcel$export(module.exports, "createRef", () => $cf6dbf544b47d79d$export$7d1e3a5e95ceca43);
$parcel$export(module.exports, "Fragment", () => $cf6dbf544b47d79d$export$ffb0004e005737fa);
$parcel$export(module.exports, "Component", () => $cf6dbf544b47d79d$export$16fa2f45be04daa8);
$parcel$export(module.exports, "toChildArray", () => $cf6dbf544b47d79d$export$47e4c5b300681277);
$parcel$export(module.exports, "render", () => $cf6dbf544b47d79d$export$b3890eb0ae9dca99);
$parcel$export(module.exports, "hydrate", () => $cf6dbf544b47d79d$export$fa8d919ba61d84db);
$parcel$export(module.exports, "cloneElement", () => $cf6dbf544b47d79d$export$e530037191fcd5d7);
$parcel$export(module.exports, "createContext", () => $cf6dbf544b47d79d$export$fd42f52fd3ae1109);
var $cf6dbf544b47d79d$var$n, $cf6dbf544b47d79d$export$41c562ebe57d11e2, $cf6dbf544b47d79d$var$u, $cf6dbf544b47d79d$export$a8257692ac88316c, $cf6dbf544b47d79d$var$i, $cf6dbf544b47d79d$var$r, $cf6dbf544b47d79d$var$o, $cf6dbf544b47d79d$var$e, $cf6dbf544b47d79d$var$f, $cf6dbf544b47d79d$var$c, $cf6dbf544b47d79d$var$s, $cf6dbf544b47d79d$var$a, $cf6dbf544b47d79d$var$h, $cf6dbf544b47d79d$var$p = {}, $cf6dbf544b47d79d$var$v = [], $cf6dbf544b47d79d$var$y = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $cf6dbf544b47d79d$var$w = Array.isArray;
function $cf6dbf544b47d79d$var$d(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $cf6dbf544b47d79d$var$g(n) {
    n && n.parentNode && n.parentNode.removeChild(n);
}
function $cf6dbf544b47d79d$export$c8a8987d4410bf2d(l, u, t) {
    var i, r, o, e = {};
    for(o in u)"key" == o ? i = u[o] : "ref" == o ? r = u[o] : e[o] = u[o];
    if (arguments.length > 2 && (e.children = arguments.length > 3 ? $cf6dbf544b47d79d$var$n.call(arguments, 2) : t), "function" == typeof l && null != l.defaultProps) for(o in l.defaultProps)void 0 === e[o] && (e[o] = l.defaultProps[o]);
    return $cf6dbf544b47d79d$var$m(l, e, i, r, null);
}
function $cf6dbf544b47d79d$var$m(n, t, i, r, o) {
    var e = {
        type: n,
        props: t,
        key: i,
        ref: r,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __c: null,
        constructor: void 0,
        __v: null == o ? ++$cf6dbf544b47d79d$var$u : o,
        __i: -1,
        __u: 0
    };
    return null == o && null != $cf6dbf544b47d79d$export$41c562ebe57d11e2.vnode && $cf6dbf544b47d79d$export$41c562ebe57d11e2.vnode(e), e;
}
function $cf6dbf544b47d79d$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $cf6dbf544b47d79d$export$ffb0004e005737fa(n) {
    return n.children;
}
function $cf6dbf544b47d79d$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $cf6dbf544b47d79d$var$S(n, l) {
    if (null == l) return n.__ ? $cf6dbf544b47d79d$var$S(n.__, n.__i + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $cf6dbf544b47d79d$var$S(n) : null;
}
function $cf6dbf544b47d79d$var$C(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $cf6dbf544b47d79d$var$C(n);
    }
}
function $cf6dbf544b47d79d$var$M(n) {
    (!n.__d && (n.__d = !0) && $cf6dbf544b47d79d$var$i.push(n) && !$cf6dbf544b47d79d$var$$.__r++ || $cf6dbf544b47d79d$var$r != $cf6dbf544b47d79d$export$41c562ebe57d11e2.debounceRendering) && (($cf6dbf544b47d79d$var$r = $cf6dbf544b47d79d$export$41c562ebe57d11e2.debounceRendering) || $cf6dbf544b47d79d$var$o)($cf6dbf544b47d79d$var$$);
}
function $cf6dbf544b47d79d$var$$() {
    for(var n, u, t, r, o, f, c, s = 1; $cf6dbf544b47d79d$var$i.length;)$cf6dbf544b47d79d$var$i.length > s && $cf6dbf544b47d79d$var$i.sort($cf6dbf544b47d79d$var$e), n = $cf6dbf544b47d79d$var$i.shift(), s = $cf6dbf544b47d79d$var$i.length, n.__d && (t = void 0, r = void 0, o = (r = (u = n).__v).__e, f = [], c = [], u.__P && ((t = $cf6dbf544b47d79d$var$d({}, r)).__v = r.__v + 1, $cf6dbf544b47d79d$export$41c562ebe57d11e2.vnode && $cf6dbf544b47d79d$export$41c562ebe57d11e2.vnode(t), $cf6dbf544b47d79d$var$O(u.__P, t, r, u.__n, u.__P.namespaceURI, 32 & r.__u ? [
        o
    ] : null, f, null == o ? $cf6dbf544b47d79d$var$S(r) : o, !!(32 & r.__u), c), t.__v = r.__v, t.__.__k[t.__i] = t, $cf6dbf544b47d79d$var$N(f, t, c), r.__e = r.__ = null, t.__e != o && $cf6dbf544b47d79d$var$C(t)));
    $cf6dbf544b47d79d$var$$.__r = 0;
}
function $cf6dbf544b47d79d$var$I(n, l, u, t, i, r, o, e, f, c, s) {
    var a, h, y, w, d, g, _, m = t && t.__k || $cf6dbf544b47d79d$var$v, b = l.length;
    for(f = $cf6dbf544b47d79d$var$P(u, l, m, f, b), a = 0; a < b; a++)null != (y = u.__k[a]) && (h = -1 == y.__i ? $cf6dbf544b47d79d$var$p : m[y.__i] || $cf6dbf544b47d79d$var$p, y.__i = a, g = $cf6dbf544b47d79d$var$O(n, y, h, i, r, o, e, f, c, s), w = y.__e, y.ref && h.ref != y.ref && (h.ref && $cf6dbf544b47d79d$var$B(h.ref, null, y), s.push(y.ref, y.__c || w, y)), null == d && null != w && (d = w), (_ = !!(4 & y.__u)) || h.__k === y.__k ? f = $cf6dbf544b47d79d$var$A(y, f, n, _) : "function" == typeof y.type && void 0 !== g ? f = g : w && (f = w.nextSibling), y.__u &= -7);
    return u.__e = d, f;
}
function $cf6dbf544b47d79d$var$P(n, l, u, t, i) {
    var r, o, e, f, c, s = u.length, a = s, h = 0;
    for(n.__k = new Array(i), r = 0; r < i; r++)null != (o = l[r]) && "boolean" != typeof o && "function" != typeof o ? ("string" == typeof o || "number" == typeof o || "bigint" == typeof o || o.constructor == String ? o = n.__k[r] = $cf6dbf544b47d79d$var$m(null, o, null, null, null) : $cf6dbf544b47d79d$var$w(o) ? o = n.__k[r] = $cf6dbf544b47d79d$var$m($cf6dbf544b47d79d$export$ffb0004e005737fa, {
        children: o
    }, null, null, null) : null == o.constructor && o.__b > 0 ? o = n.__k[r] = $cf6dbf544b47d79d$var$m(o.type, o.props, o.key, o.ref ? o.ref : null, o.__v) : n.__k[r] = o, f = r + h, o.__ = n, o.__b = n.__b + 1, -1 != (c = o.__i = $cf6dbf544b47d79d$var$L(o, u, f, a)) && (a--, (e = u[c]) && (e.__u |= 2)), null == e || null == e.__v ? (-1 == c && (i > s ? h-- : i < s && h++), "function" != typeof o.type && (o.__u |= 4)) : c != f && (c == f - 1 ? h-- : c == f + 1 ? h++ : (c > f ? h-- : h++, o.__u |= 4))) : n.__k[r] = null;
    if (a) for(r = 0; r < s; r++)null != (e = u[r]) && 0 == (2 & e.__u) && (e.__e == t && (t = $cf6dbf544b47d79d$var$S(e)), $cf6dbf544b47d79d$var$D(e, e));
    return t;
}
function $cf6dbf544b47d79d$var$A(n, l, u, t) {
    var i, r;
    if ("function" == typeof n.type) {
        for(i = n.__k, r = 0; i && r < i.length; r++)i[r] && (i[r].__ = n, l = $cf6dbf544b47d79d$var$A(i[r], l, u, t));
        return l;
    }
    n.__e != l && (t && (l && n.type && !l.parentNode && (l = $cf6dbf544b47d79d$var$S(n)), u.insertBefore(n.__e, l || null)), l = n.__e);
    do l = l && l.nextSibling;
    while (null != l && 8 == l.nodeType);
    return l;
}
function $cf6dbf544b47d79d$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || ($cf6dbf544b47d79d$var$w(n) ? n.some(function(n) {
        $cf6dbf544b47d79d$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $cf6dbf544b47d79d$var$L(n, l, u, t) {
    var i, r, o, e = n.key, f = n.type, c = l[u], s = null != c && 0 == (2 & c.__u);
    if (null === c && null == e || s && e == c.key && f == c.type) return u;
    if (t > (s ? 1 : 0)) {
        for(i = u - 1, r = u + 1; i >= 0 || r < l.length;)if (null != (c = l[o = i >= 0 ? i-- : r++]) && 0 == (2 & c.__u) && e == c.key && f == c.type) return o;
    }
    return -1;
}
function $cf6dbf544b47d79d$var$T(n, l, u) {
    "-" == l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $cf6dbf544b47d79d$var$y.test(l) ? u : u + "px";
}
function $cf6dbf544b47d79d$var$j(n, l, u, t, i) {
    var r, o;
    n: if ("style" == l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof t && (n.style.cssText = t = ""), t) for(l in t)u && l in u || $cf6dbf544b47d79d$var$T(n.style, l, "");
            if (u) for(l in u)t && u[l] == t[l] || $cf6dbf544b47d79d$var$T(n.style, l, u[l]);
        }
    } else if ("o" == l[0] && "n" == l[1]) r = l != (l = l.replace($cf6dbf544b47d79d$var$f, "$1")), o = l.toLowerCase(), l = o in n || "onFocusOut" == l || "onFocusIn" == l ? o.slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + r] = u, u ? t ? u.u = t.u : (u.u = $cf6dbf544b47d79d$var$c, n.addEventListener(l, r ? $cf6dbf544b47d79d$var$a : $cf6dbf544b47d79d$var$s, r)) : n.removeEventListener(l, r ? $cf6dbf544b47d79d$var$a : $cf6dbf544b47d79d$var$s, r);
    else {
        if ("http://www.w3.org/2000/svg" == i) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" != l && "height" != l && "href" != l && "list" != l && "form" != l && "tabIndex" != l && "download" != l && "rowSpan" != l && "colSpan" != l && "role" != l && "popover" != l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && "-" != l[4] ? n.removeAttribute(l) : n.setAttribute(l, "popover" == l && 1 == u ? "" : u));
    }
}
function $cf6dbf544b47d79d$var$F(n) {
    return function(u) {
        if (this.l) {
            var t = this.l[u.type + n];
            if (null == u.t) u.t = $cf6dbf544b47d79d$var$c++;
            else if (u.t < t.u) return;
            return t($cf6dbf544b47d79d$export$41c562ebe57d11e2.event ? $cf6dbf544b47d79d$export$41c562ebe57d11e2.event(u) : u);
        }
    };
}
function $cf6dbf544b47d79d$var$O(n, u, t, i, r, o, e, f, c, s) {
    var a, h, p, v, y, _, m, b, S, C, M, $, P, A, H, L, T, j = u.type;
    if (null != u.constructor) return null;
    128 & t.__u && (c = !!(32 & t.__u), o = [
        f = u.__e = t.__e
    ]), (a = $cf6dbf544b47d79d$export$41c562ebe57d11e2.__b) && a(u);
    n: if ("function" == typeof j) try {
        if (b = u.props, S = "prototype" in j && j.prototype.render, C = (a = j.contextType) && i[a.__c], M = a ? C ? C.props.value : a.__ : i, t.__c ? m = (h = u.__c = t.__c).__ = h.__E : (S ? u.__c = h = new j(b, M) : (u.__c = h = new $cf6dbf544b47d79d$export$16fa2f45be04daa8(b, M), h.constructor = j, h.render = $cf6dbf544b47d79d$var$E), C && C.sub(h), h.state || (h.state = {}), h.__n = i, p = h.__d = !0, h.__h = [], h._sb = []), S && null == h.__s && (h.__s = h.state), S && null != j.getDerivedStateFromProps && (h.__s == h.state && (h.__s = $cf6dbf544b47d79d$var$d({}, h.__s)), $cf6dbf544b47d79d$var$d(h.__s, j.getDerivedStateFromProps(b, h.__s))), v = h.props, y = h.state, h.__v = u, p) S && null == j.getDerivedStateFromProps && null != h.componentWillMount && h.componentWillMount(), S && null != h.componentDidMount && h.__h.push(h.componentDidMount);
        else {
            if (S && null == j.getDerivedStateFromProps && b !== v && null != h.componentWillReceiveProps && h.componentWillReceiveProps(b, M), u.__v == t.__v || !h.__e && null != h.shouldComponentUpdate && !1 === h.shouldComponentUpdate(b, h.__s, M)) {
                for(u.__v != t.__v && (h.props = b, h.state = h.__s, h.__d = !1), u.__e = t.__e, u.__k = t.__k, u.__k.some(function(n) {
                    n && (n.__ = u);
                }), $ = 0; $ < h._sb.length; $++)h.__h.push(h._sb[$]);
                h._sb = [], h.__h.length && e.push(h);
                break n;
            }
            null != h.componentWillUpdate && h.componentWillUpdate(b, h.__s, M), S && null != h.componentDidUpdate && h.__h.push(function() {
                h.componentDidUpdate(v, y, _);
            });
        }
        if (h.context = M, h.props = b, h.__P = n, h.__e = !1, P = $cf6dbf544b47d79d$export$41c562ebe57d11e2.__r, A = 0, S) {
            for(h.state = h.__s, h.__d = !1, P && P(u), a = h.render(h.props, h.state, h.context), H = 0; H < h._sb.length; H++)h.__h.push(h._sb[H]);
            h._sb = [];
        } else do h.__d = !1, P && P(u), a = h.render(h.props, h.state, h.context), h.state = h.__s;
        while (h.__d && ++A < 25);
        h.state = h.__s, null != h.getChildContext && (i = $cf6dbf544b47d79d$var$d($cf6dbf544b47d79d$var$d({}, i), h.getChildContext())), S && !p && null != h.getSnapshotBeforeUpdate && (_ = h.getSnapshotBeforeUpdate(v, y)), L = a, null != a && a.type === $cf6dbf544b47d79d$export$ffb0004e005737fa && null == a.key && (L = $cf6dbf544b47d79d$var$V(a.props.children)), f = $cf6dbf544b47d79d$var$I(n, $cf6dbf544b47d79d$var$w(L) ? L : [
            L
        ], u, t, i, r, o, e, f, c, s), h.base = u.__e, u.__u &= -161, h.__h.length && e.push(h), m && (h.__E = h.__ = null);
    } catch (n) {
        if (u.__v = null, c || null != o) {
            if (n.then) {
                for(u.__u |= c ? 160 : 128; f && 8 == f.nodeType && f.nextSibling;)f = f.nextSibling;
                o[o.indexOf(f)] = null, u.__e = f;
            } else {
                for(T = o.length; T--;)$cf6dbf544b47d79d$var$g(o[T]);
                $cf6dbf544b47d79d$var$z(u);
            }
        } else u.__e = t.__e, u.__k = t.__k, n.then || $cf6dbf544b47d79d$var$z(u);
        $cf6dbf544b47d79d$export$41c562ebe57d11e2.__e(n, u, t);
    }
    else null == o && u.__v == t.__v ? (u.__k = t.__k, u.__e = t.__e) : f = u.__e = $cf6dbf544b47d79d$var$q(t.__e, u, t, i, r, o, e, c, s);
    return (a = $cf6dbf544b47d79d$export$41c562ebe57d11e2.diffed) && a(u), 128 & u.__u ? void 0 : f;
}
function $cf6dbf544b47d79d$var$z(n) {
    n && n.__c && (n.__c.__e = !0), n && n.__k && n.__k.forEach($cf6dbf544b47d79d$var$z);
}
function $cf6dbf544b47d79d$var$N(n, u, t) {
    for(var i = 0; i < t.length; i++)$cf6dbf544b47d79d$var$B(t[i], t[++i], t[++i]);
    $cf6dbf544b47d79d$export$41c562ebe57d11e2.__c && $cf6dbf544b47d79d$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $cf6dbf544b47d79d$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $cf6dbf544b47d79d$var$V(n) {
    return "object" != typeof n || null == n || n.__b && n.__b > 0 ? n : $cf6dbf544b47d79d$var$w(n) ? n.map($cf6dbf544b47d79d$var$V) : $cf6dbf544b47d79d$var$d({}, n);
}
function $cf6dbf544b47d79d$var$q(u, t, i, r, o, e, f, c, s) {
    var a, h, v, y, d, _, m, b = i.props || $cf6dbf544b47d79d$var$p, k = t.props, x = t.type;
    if ("svg" == x ? o = "http://www.w3.org/2000/svg" : "math" == x ? o = "http://www.w3.org/1998/Math/MathML" : o || (o = "http://www.w3.org/1999/xhtml"), null != e) {
        for(a = 0; a < e.length; a++)if ((d = e[a]) && "setAttribute" in d == !!x && (x ? d.localName == x : 3 == d.nodeType)) {
            u = d, e[a] = null;
            break;
        }
    }
    if (null == u) {
        if (null == x) return document.createTextNode(k);
        u = document.createElementNS(o, x, k.is && k), c && ($cf6dbf544b47d79d$export$41c562ebe57d11e2.__m && $cf6dbf544b47d79d$export$41c562ebe57d11e2.__m(t, e), c = !1), e = null;
    }
    if (null == x) b === k || c && u.data == k || (u.data = k);
    else {
        if (e = e && $cf6dbf544b47d79d$var$n.call(u.childNodes), !c && null != e) for(b = {}, a = 0; a < u.attributes.length; a++)b[(d = u.attributes[a]).name] = d.value;
        for(a in b)if (d = b[a], "children" == a) ;
        else if ("dangerouslySetInnerHTML" == a) v = d;
        else if (!(a in k)) {
            if ("value" == a && "defaultValue" in k || "checked" == a && "defaultChecked" in k) continue;
            $cf6dbf544b47d79d$var$j(u, a, null, d, o);
        }
        for(a in k)d = k[a], "children" == a ? y = d : "dangerouslySetInnerHTML" == a ? h = d : "value" == a ? _ = d : "checked" == a ? m = d : c && "function" != typeof d || b[a] === d || $cf6dbf544b47d79d$var$j(u, a, d, b[a], o);
        if (h) c || v && (h.__html == v.__html || h.__html == u.innerHTML) || (u.innerHTML = h.__html), t.__k = [];
        else if (v && (u.innerHTML = ""), $cf6dbf544b47d79d$var$I("template" == t.type ? u.content : u, $cf6dbf544b47d79d$var$w(y) ? y : [
            y
        ], t, i, r, "foreignObject" == x ? "http://www.w3.org/1999/xhtml" : o, e, f, e ? e[0] : i.__k && $cf6dbf544b47d79d$var$S(i, 0), c, s), null != e) for(a = e.length; a--;)$cf6dbf544b47d79d$var$g(e[a]);
        c || (a = "value", "progress" == x && null == _ ? u.removeAttribute("value") : null != _ && (_ !== u[a] || "progress" == x && !_ || "option" == x && _ != b[a]) && $cf6dbf544b47d79d$var$j(u, a, _, b[a], o), a = "checked", null != m && m != u[a] && $cf6dbf544b47d79d$var$j(u, a, m, b[a], o));
    }
    return u;
}
function $cf6dbf544b47d79d$var$B(n, u, t) {
    try {
        if ("function" == typeof n) {
            var i = "function" == typeof n.__u;
            i && n.__u(), i && null == u || (n.__u = n(u));
        } else n.current = u;
    } catch (n) {
        $cf6dbf544b47d79d$export$41c562ebe57d11e2.__e(n, t);
    }
}
function $cf6dbf544b47d79d$var$D(n, u, t) {
    var i, r;
    if ($cf6dbf544b47d79d$export$41c562ebe57d11e2.unmount && $cf6dbf544b47d79d$export$41c562ebe57d11e2.unmount(n), (i = n.ref) && (i.current && i.current != n.__e || $cf6dbf544b47d79d$var$B(i, null, u)), null != (i = n.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (n) {
            $cf6dbf544b47d79d$export$41c562ebe57d11e2.__e(n, u);
        }
        i.base = i.__P = null;
    }
    if (i = n.__k) for(r = 0; r < i.length; r++)i[r] && $cf6dbf544b47d79d$var$D(i[r], u, t || "function" != typeof n.type);
    t || $cf6dbf544b47d79d$var$g(n.__e), n.__c = n.__ = n.__e = void 0;
}
function $cf6dbf544b47d79d$var$E(n, l, u) {
    return this.constructor(n, u);
}
function $cf6dbf544b47d79d$export$b3890eb0ae9dca99(u, t, i) {
    var r, o, e, f;
    t == document && (t = document.documentElement), $cf6dbf544b47d79d$export$41c562ebe57d11e2.__ && $cf6dbf544b47d79d$export$41c562ebe57d11e2.__(u, t), o = (r = "function" == typeof i) ? null : i && i.__k || t.__k, e = [], f = [], $cf6dbf544b47d79d$var$O(t, u = (!r && i || t).__k = $cf6dbf544b47d79d$export$c8a8987d4410bf2d($cf6dbf544b47d79d$export$ffb0004e005737fa, null, [
        u
    ]), o || $cf6dbf544b47d79d$var$p, $cf6dbf544b47d79d$var$p, t.namespaceURI, !r && i ? [
        i
    ] : o ? null : t.firstChild ? $cf6dbf544b47d79d$var$n.call(t.childNodes) : null, e, !r && i ? i : o ? o.__e : t.firstChild, r, f), $cf6dbf544b47d79d$var$N(e, u, f);
}
function $cf6dbf544b47d79d$export$fa8d919ba61d84db(n, l) {
    $cf6dbf544b47d79d$export$b3890eb0ae9dca99(n, l, $cf6dbf544b47d79d$export$fa8d919ba61d84db);
}
function $cf6dbf544b47d79d$export$e530037191fcd5d7(l, u, t) {
    var i, r, o, e, f = $cf6dbf544b47d79d$var$d({}, l.props);
    for(o in l.type && l.type.defaultProps && (e = l.type.defaultProps), u)"key" == o ? i = u[o] : "ref" == o ? r = u[o] : f[o] = void 0 === u[o] && null != e ? e[o] : u[o];
    return arguments.length > 2 && (f.children = arguments.length > 3 ? $cf6dbf544b47d79d$var$n.call(arguments, 2) : t), $cf6dbf544b47d79d$var$m(l.type, f, i || l.key, r || l.ref, null);
}
function $cf6dbf544b47d79d$export$fd42f52fd3ae1109(n) {
    function l(n) {
        var u, t;
        return this.getChildContext || (u = new Set, (t = {})[l.__c] = this, this.getChildContext = function() {
            return t;
        }, this.componentWillUnmount = function() {
            u = null;
        }, this.shouldComponentUpdate = function(n) {
            this.props.value != n.value && u.forEach(function(n) {
                n.__e = !0, $cf6dbf544b47d79d$var$M(n);
            });
        }, this.sub = function(n) {
            u.add(n);
            var l = n.componentWillUnmount;
            n.componentWillUnmount = function() {
                u && u.delete(n), l && l.call(n);
            };
        }), n.children;
    }
    return l.__c = "__cC" + $cf6dbf544b47d79d$var$h++, l.__ = n, l.Provider = l.__l = (l.Consumer = function(n, l) {
        return n.children(l);
    }).contextType = l, l;
}
$cf6dbf544b47d79d$var$n = $cf6dbf544b47d79d$var$v.slice, $cf6dbf544b47d79d$export$41c562ebe57d11e2 = {
    __e: function(n, l, u, t) {
        for(var i, r, o; l = l.__;)if ((i = l.__c) && !i.__) try {
            if ((r = i.constructor) && null != r.getDerivedStateFromError && (i.setState(r.getDerivedStateFromError(n)), o = i.__d), null != i.componentDidCatch && (i.componentDidCatch(n, t || {}), o = i.__d), o) return i.__E = i;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $cf6dbf544b47d79d$var$u = 0, $cf6dbf544b47d79d$export$a8257692ac88316c = function(n) {
    return null != n && null == n.constructor;
}, $cf6dbf544b47d79d$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s != this.state ? this.__s : this.__s = $cf6dbf544b47d79d$var$d({}, this.state), "function" == typeof n && (n = n($cf6dbf544b47d79d$var$d({}, u), this.props)), n && $cf6dbf544b47d79d$var$d(u, n), null != n && this.__v && (l && this._sb.push(l), $cf6dbf544b47d79d$var$M(this));
}, $cf6dbf544b47d79d$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $cf6dbf544b47d79d$var$M(this));
}, $cf6dbf544b47d79d$export$16fa2f45be04daa8.prototype.render = $cf6dbf544b47d79d$export$ffb0004e005737fa, $cf6dbf544b47d79d$var$i = [], $cf6dbf544b47d79d$var$o = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $cf6dbf544b47d79d$var$e = function(n, l) {
    return n.__v.__b - l.__v.__b;
}, $cf6dbf544b47d79d$var$$.__r = 0, $cf6dbf544b47d79d$var$f = /(PointerCapture)$|Capture$/i, $cf6dbf544b47d79d$var$c = 0, $cf6dbf544b47d79d$var$s = $cf6dbf544b47d79d$var$F(!1), $cf6dbf544b47d79d$var$a = $cf6dbf544b47d79d$var$F(!0), $cf6dbf544b47d79d$var$h = 0;

});

parcelRegister("32rMB", function(module, exports) {

$parcel$export(module.exports, "useState", () => $23671c1c4cb9ff6c$export$60241385465d0a34);
$parcel$export(module.exports, "useReducer", () => $23671c1c4cb9ff6c$export$13e3392192263954);
$parcel$export(module.exports, "useEffect", () => $23671c1c4cb9ff6c$export$6d9c69b0de29b591);
$parcel$export(module.exports, "useLayoutEffect", () => $23671c1c4cb9ff6c$export$e5c5a5f917a5871c);
$parcel$export(module.exports, "useRef", () => $23671c1c4cb9ff6c$export$b8f5890fc79d6aca);
$parcel$export(module.exports, "useMemo", () => $23671c1c4cb9ff6c$export$1538c33de8887b59);
$parcel$export(module.exports, "useImperativeHandle", () => $23671c1c4cb9ff6c$export$d5a552a76deda3c2);
$parcel$export(module.exports, "useCallback", () => $23671c1c4cb9ff6c$export$35808ee640e87ca7);
$parcel$export(module.exports, "useContext", () => $23671c1c4cb9ff6c$export$fae74005e78b1a27);
$parcel$export(module.exports, "useDebugValue", () => $23671c1c4cb9ff6c$export$dc8fbce3eb94dc1e);
$parcel$export(module.exports, "useErrorBoundary", () => $23671c1c4cb9ff6c$export$c052f6604b7d51fe);
$parcel$export(module.exports, "useId", () => $23671c1c4cb9ff6c$export$f680877a34711e37);

var $hO8yS = parcelRequire("hO8yS");
var $23671c1c4cb9ff6c$var$t, $23671c1c4cb9ff6c$var$r, $23671c1c4cb9ff6c$var$u, $23671c1c4cb9ff6c$var$i, $23671c1c4cb9ff6c$var$o = 0, $23671c1c4cb9ff6c$var$f = [], $23671c1c4cb9ff6c$var$c = (0, $hO8yS.options), $23671c1c4cb9ff6c$var$e = $23671c1c4cb9ff6c$var$c.__b, $23671c1c4cb9ff6c$var$a = $23671c1c4cb9ff6c$var$c.__r, $23671c1c4cb9ff6c$var$v = $23671c1c4cb9ff6c$var$c.diffed, $23671c1c4cb9ff6c$var$l = $23671c1c4cb9ff6c$var$c.__c, $23671c1c4cb9ff6c$var$m = $23671c1c4cb9ff6c$var$c.unmount, $23671c1c4cb9ff6c$var$s = $23671c1c4cb9ff6c$var$c.__;
function $23671c1c4cb9ff6c$var$p(n, t) {
    $23671c1c4cb9ff6c$var$c.__h && $23671c1c4cb9ff6c$var$c.__h($23671c1c4cb9ff6c$var$r, n, $23671c1c4cb9ff6c$var$o || t), $23671c1c4cb9ff6c$var$o = 0;
    var u = $23671c1c4cb9ff6c$var$r.__H || ($23671c1c4cb9ff6c$var$r.__H = {
        __: [],
        __h: []
    });
    return n >= u.__.length && u.__.push({}), u.__[n];
}
function $23671c1c4cb9ff6c$export$60241385465d0a34(n) {
    return $23671c1c4cb9ff6c$var$o = 1, $23671c1c4cb9ff6c$export$13e3392192263954($23671c1c4cb9ff6c$var$D, n);
}
function $23671c1c4cb9ff6c$export$13e3392192263954(n, u, i) {
    var o = $23671c1c4cb9ff6c$var$p($23671c1c4cb9ff6c$var$t++, 2);
    if (o.t = n, !o.__c && (o.__ = [
        i ? i(u) : $23671c1c4cb9ff6c$var$D(void 0, u),
        function(n) {
            var t = o.__N ? o.__N[0] : o.__[0], r = o.t(t, n);
            t !== r && (o.__N = [
                r,
                o.__[1]
            ], o.__c.setState({}));
        }
    ], o.__c = $23671c1c4cb9ff6c$var$r, !$23671c1c4cb9ff6c$var$r.__f)) {
        var f = function(n, t, r) {
            if (!o.__c.__H) return !0;
            var u = o.__c.__H.__.filter(function(n) {
                return !!n.__c;
            });
            if (u.every(function(n) {
                return !n.__N;
            })) return !c || c.call(this, n, t, r);
            var i = o.__c.props !== n;
            return u.forEach(function(n) {
                if (n.__N) {
                    var t = n.__[0];
                    n.__ = n.__N, n.__N = void 0, t !== n.__[0] && (i = !0);
                }
            }), c && c.call(this, n, t, r) || i;
        };
        $23671c1c4cb9ff6c$var$r.__f = !0;
        var c = $23671c1c4cb9ff6c$var$r.shouldComponentUpdate, e = $23671c1c4cb9ff6c$var$r.componentWillUpdate;
        $23671c1c4cb9ff6c$var$r.componentWillUpdate = function(n, t, r) {
            if (this.__e) {
                var u = c;
                c = void 0, f(n, t, r), c = u;
            }
            e && e.call(this, n, t, r);
        }, $23671c1c4cb9ff6c$var$r.shouldComponentUpdate = f;
    }
    return o.__N || o.__;
}
function $23671c1c4cb9ff6c$export$6d9c69b0de29b591(n, u) {
    var i = $23671c1c4cb9ff6c$var$p($23671c1c4cb9ff6c$var$t++, 3);
    !$23671c1c4cb9ff6c$var$c.__s && $23671c1c4cb9ff6c$var$C(i.__H, u) && (i.__ = n, i.u = u, $23671c1c4cb9ff6c$var$r.__H.__h.push(i));
}
function $23671c1c4cb9ff6c$export$e5c5a5f917a5871c(n, u) {
    var i = $23671c1c4cb9ff6c$var$p($23671c1c4cb9ff6c$var$t++, 4);
    !$23671c1c4cb9ff6c$var$c.__s && $23671c1c4cb9ff6c$var$C(i.__H, u) && (i.__ = n, i.u = u, $23671c1c4cb9ff6c$var$r.__h.push(i));
}
function $23671c1c4cb9ff6c$export$b8f5890fc79d6aca(n) {
    return $23671c1c4cb9ff6c$var$o = 5, $23671c1c4cb9ff6c$export$1538c33de8887b59(function() {
        return {
            current: n
        };
    }, []);
}
function $23671c1c4cb9ff6c$export$d5a552a76deda3c2(n, t, r) {
    $23671c1c4cb9ff6c$var$o = 6, $23671c1c4cb9ff6c$export$e5c5a5f917a5871c(function() {
        if ("function" == typeof n) {
            var r = n(t());
            return function() {
                n(null), r && "function" == typeof r && r();
            };
        }
        if (n) return n.current = t(), function() {
            return n.current = null;
        };
    }, null == r ? r : r.concat(n));
}
function $23671c1c4cb9ff6c$export$1538c33de8887b59(n, r) {
    var u = $23671c1c4cb9ff6c$var$p($23671c1c4cb9ff6c$var$t++, 7);
    return $23671c1c4cb9ff6c$var$C(u.__H, r) && (u.__ = n(), u.__H = r, u.__h = n), u.__;
}
function $23671c1c4cb9ff6c$export$35808ee640e87ca7(n, t) {
    return $23671c1c4cb9ff6c$var$o = 8, $23671c1c4cb9ff6c$export$1538c33de8887b59(function() {
        return n;
    }, t);
}
function $23671c1c4cb9ff6c$export$fae74005e78b1a27(n) {
    var u = $23671c1c4cb9ff6c$var$r.context[n.__c], i = $23671c1c4cb9ff6c$var$p($23671c1c4cb9ff6c$var$t++, 9);
    return i.c = n, u ? (null == i.__ && (i.__ = !0, u.sub($23671c1c4cb9ff6c$var$r)), u.props.value) : n.__;
}
function $23671c1c4cb9ff6c$export$dc8fbce3eb94dc1e(n, t) {
    $23671c1c4cb9ff6c$var$c.useDebugValue && $23671c1c4cb9ff6c$var$c.useDebugValue(t ? t(n) : n);
}
function $23671c1c4cb9ff6c$export$c052f6604b7d51fe(n) {
    var u = $23671c1c4cb9ff6c$var$p($23671c1c4cb9ff6c$var$t++, 10), i = $23671c1c4cb9ff6c$export$60241385465d0a34();
    return u.__ = n, $23671c1c4cb9ff6c$var$r.componentDidCatch || ($23671c1c4cb9ff6c$var$r.componentDidCatch = function(n, t) {
        u.__ && u.__(n, t), i[1](n);
    }), [
        i[0],
        function() {
            i[1](void 0);
        }
    ];
}
function $23671c1c4cb9ff6c$export$f680877a34711e37() {
    var n = $23671c1c4cb9ff6c$var$p($23671c1c4cb9ff6c$var$t++, 11);
    if (!n.__) {
        for(var u = $23671c1c4cb9ff6c$var$r.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        var i = u.__m || (u.__m = [
            0,
            0
        ]);
        n.__ = "P" + i[0] + "-" + i[1]++;
    }
    return n.__;
}
function $23671c1c4cb9ff6c$var$j() {
    for(var n; n = $23671c1c4cb9ff6c$var$f.shift();)if (n.__P && n.__H) try {
        n.__H.__h.forEach($23671c1c4cb9ff6c$var$z), n.__H.__h.forEach($23671c1c4cb9ff6c$var$B), n.__H.__h = [];
    } catch (t) {
        n.__H.__h = [], $23671c1c4cb9ff6c$var$c.__e(t, n.__v);
    }
}
$23671c1c4cb9ff6c$var$c.__b = function(n) {
    $23671c1c4cb9ff6c$var$r = null, $23671c1c4cb9ff6c$var$e && $23671c1c4cb9ff6c$var$e(n);
}, $23671c1c4cb9ff6c$var$c.__ = function(n, t) {
    n && t.__k && t.__k.__m && (n.__m = t.__k.__m), $23671c1c4cb9ff6c$var$s && $23671c1c4cb9ff6c$var$s(n, t);
}, $23671c1c4cb9ff6c$var$c.__r = function(n) {
    $23671c1c4cb9ff6c$var$a && $23671c1c4cb9ff6c$var$a(n), $23671c1c4cb9ff6c$var$t = 0;
    var i = ($23671c1c4cb9ff6c$var$r = n.__c).__H;
    i && ($23671c1c4cb9ff6c$var$u === $23671c1c4cb9ff6c$var$r ? (i.__h = [], $23671c1c4cb9ff6c$var$r.__h = [], i.__.forEach(function(n) {
        n.__N && (n.__ = n.__N), n.u = n.__N = void 0;
    })) : (i.__h.forEach($23671c1c4cb9ff6c$var$z), i.__h.forEach($23671c1c4cb9ff6c$var$B), i.__h = [], $23671c1c4cb9ff6c$var$t = 0)), $23671c1c4cb9ff6c$var$u = $23671c1c4cb9ff6c$var$r;
}, $23671c1c4cb9ff6c$var$c.diffed = function(n) {
    $23671c1c4cb9ff6c$var$v && $23671c1c4cb9ff6c$var$v(n);
    var t = n.__c;
    t && t.__H && (t.__H.__h.length && (1 !== $23671c1c4cb9ff6c$var$f.push(t) && $23671c1c4cb9ff6c$var$i === $23671c1c4cb9ff6c$var$c.requestAnimationFrame || (($23671c1c4cb9ff6c$var$i = $23671c1c4cb9ff6c$var$c.requestAnimationFrame) || $23671c1c4cb9ff6c$var$w)($23671c1c4cb9ff6c$var$j)), t.__H.__.forEach(function(n) {
        n.u && (n.__H = n.u), n.u = void 0;
    })), $23671c1c4cb9ff6c$var$u = $23671c1c4cb9ff6c$var$r = null;
}, $23671c1c4cb9ff6c$var$c.__c = function(n, t) {
    t.some(function(n) {
        try {
            n.__h.forEach($23671c1c4cb9ff6c$var$z), n.__h = n.__h.filter(function(n) {
                return !n.__ || $23671c1c4cb9ff6c$var$B(n);
            });
        } catch (r) {
            t.some(function(n) {
                n.__h && (n.__h = []);
            }), t = [], $23671c1c4cb9ff6c$var$c.__e(r, n.__v);
        }
    }), $23671c1c4cb9ff6c$var$l && $23671c1c4cb9ff6c$var$l(n, t);
}, $23671c1c4cb9ff6c$var$c.unmount = function(n) {
    $23671c1c4cb9ff6c$var$m && $23671c1c4cb9ff6c$var$m(n);
    var t, r = n.__c;
    r && r.__H && (r.__H.__.forEach(function(n) {
        try {
            $23671c1c4cb9ff6c$var$z(n);
        } catch (n) {
            t = n;
        }
    }), r.__H = void 0, t && $23671c1c4cb9ff6c$var$c.__e(t, r.__v));
};
var $23671c1c4cb9ff6c$var$k = "function" == typeof requestAnimationFrame;
function $23671c1c4cb9ff6c$var$w(n) {
    var t, r = function() {
        clearTimeout(u), $23671c1c4cb9ff6c$var$k && cancelAnimationFrame(t), setTimeout(n);
    }, u = setTimeout(r, 35);
    $23671c1c4cb9ff6c$var$k && (t = requestAnimationFrame(r));
}
function $23671c1c4cb9ff6c$var$z(n) {
    var t = $23671c1c4cb9ff6c$var$r, u = n.__c;
    "function" == typeof u && (n.__c = void 0, u()), $23671c1c4cb9ff6c$var$r = t;
}
function $23671c1c4cb9ff6c$var$B(n) {
    var t = $23671c1c4cb9ff6c$var$r;
    n.__c = n.__(), $23671c1c4cb9ff6c$var$r = t;
}
function $23671c1c4cb9ff6c$var$C(n, t) {
    return !n || n.length !== t.length || t.some(function(t, r) {
        return t !== n[r];
    });
}
function $23671c1c4cb9ff6c$var$D(n, t) {
    return "function" == typeof t ? t(n) : t;
}

});



parcelRegister("6v8yO", function(module, exports) {
module.exports = import("lMEZW").then(()=>parcelRequire('udSGY'));

});

parcelRegister("dXeVr", function(module, exports) {
module.exports = import("kfeMV").then(()=>parcelRequire('9Z5Wq'));

});

parcelRegister("aMH3h", function(module, exports) {
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ (function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.17.21';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("dYe7D", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used to compose bitmasks for comparison styles. */ var UNORDERED_COMPARE_FLAG = 1, PARTIAL_COMPARE_FLAG = 2;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', promiseTag = '[object Promise]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding('util');
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') try {
        result = !!(value + '');
    } catch (e) {}
    return result;
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView'), Map = getNative(root, 'Map'), Promise = getNative(root, 'Promise'), Set = getNative(root, 'Set'), WeakMap = getNative(root, 'WeakMap'), nativeCreate = getNative(Object, 'create');
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    return getMapData(this, key)['delete'](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values ? values.length : 0;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    this.__data__ = new ListCache(entries);
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    return this.__data__['delete'](key);
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var cache = this.__data__;
    if (cache instanceof ListCache) {
        var pairs = cache.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            return this;
        }
        cache = this.__data__ = new MapCache(pairs);
    }
    cache.set(key, value);
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == 'length' || isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    return objectToString.call(value);
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {boolean} [bitmask] The bitmask of comparison flags.
 *  The bitmask may be composed of the following flags:
 *     1 - Unordered comparison
 *     2 - Partial comparison
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, customizer, bitmask, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObject(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = arrayTag, othTag = arrayTag;
    if (!objIsArr) {
        objTag = getTag(object);
        objTag = objTag == argsTag ? objectTag : objTag;
    }
    if (!othIsArr) {
        othTag = getTag(other);
        othTag = othTag == argsTag ? objectTag : othTag;
    }
    var objIsObj = objTag == objectTag && !isHostObject(object), othIsObj = othTag == objectTag && !isHostObject(other), isSameTag = objTag == othTag;
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, equalFunc, customizer, bitmask, stack) : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
    }
    if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & UNORDERED_COMPARE_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!seen.has(othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) return seen.add(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= UNORDERED_COMPARE_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
            stack['delete'](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, objProps = keys(object), objLength = objProps.length, othProps = keys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = objectToString.call(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : undefined;
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') && (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * This method is like `_.isEqual` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with up to
 * six arguments: (objValue, othValue [, index|key, object, other, stack]).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, othValue) {
 *   if (isGreeting(objValue) && isGreeting(othValue)) {
 *     return true;
 *   }
 * }
 *
 * var array = ['hello', 'goodbye'];
 * var other = ['hi', 'goodbye'];
 *
 * _.isEqualWith(array, other, customizer);
 * // => true
 */ function isEqualWith(value, other, customizer) {
    customizer = typeof customizer == 'function' ? customizer : undefined;
    var result = customizer ? customizer(value, other) : undefined;
    return result === undefined ? baseIsEqual(value, other, customizer) : !!result;
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : '';
    return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
module.exports = isEqualWith;

});

parcelRegister("dflA0", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $lNqgI = parcelRequire("lNqgI");
function $9a4d6a57aaaab11e$var$emptyFunction() {}
function $9a4d6a57aaaab11e$var$emptyFunctionWithReset() {}
$9a4d6a57aaaab11e$var$emptyFunctionWithReset.resetWarningCache = $9a4d6a57aaaab11e$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $lNqgI) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $9a4d6a57aaaab11e$var$emptyFunctionWithReset,
        resetWarningCache: $9a4d6a57aaaab11e$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("lNqgI", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $fde28cfe61c36500$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $fde28cfe61c36500$var$ReactPropTypesSecret;

});


parcelRegister("gkQP3", function(module, exports) {

$parcel$export(module.exports, "__generator", () => $04dbd055bc5edd2b$export$67ebef60e6f28a6);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $04dbd055bc5edd2b$var$extendStatics = function(d, b) {
    $04dbd055bc5edd2b$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $04dbd055bc5edd2b$var$extendStatics(d, b);
};
function $04dbd055bc5edd2b$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $04dbd055bc5edd2b$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $04dbd055bc5edd2b$export$18ce0697a983be9b = function() {
    $04dbd055bc5edd2b$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $04dbd055bc5edd2b$export$18ce0697a983be9b.apply(this, arguments);
};
function $04dbd055bc5edd2b$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $04dbd055bc5edd2b$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $04dbd055bc5edd2b$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $04dbd055bc5edd2b$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $04dbd055bc5edd2b$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $04dbd055bc5edd2b$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $04dbd055bc5edd2b$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $04dbd055bc5edd2b$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $04dbd055bc5edd2b$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $04dbd055bc5edd2b$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $04dbd055bc5edd2b$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $04dbd055bc5edd2b$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $04dbd055bc5edd2b$export$45d3717a4c69092e(o, m, p);
}
function $04dbd055bc5edd2b$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $04dbd055bc5edd2b$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $04dbd055bc5edd2b$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($04dbd055bc5edd2b$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $04dbd055bc5edd2b$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $04dbd055bc5edd2b$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $04dbd055bc5edd2b$export$10c90e4f7922046c(v) {
    return this instanceof $04dbd055bc5edd2b$export$10c90e4f7922046c ? (this.v = v, this) : new $04dbd055bc5edd2b$export$10c90e4f7922046c(v);
}
function $04dbd055bc5edd2b$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $04dbd055bc5edd2b$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $04dbd055bc5edd2b$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $04dbd055bc5edd2b$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $04dbd055bc5edd2b$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $04dbd055bc5edd2b$export$19a8beecd37a4c45 === "function" ? $04dbd055bc5edd2b$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $04dbd055bc5edd2b$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $04dbd055bc5edd2b$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $04dbd055bc5edd2b$var$ownKeys = function(o) {
    $04dbd055bc5edd2b$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $04dbd055bc5edd2b$var$ownKeys(o);
};
function $04dbd055bc5edd2b$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $04dbd055bc5edd2b$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $04dbd055bc5edd2b$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $04dbd055bc5edd2b$var$__setModuleDefault(result, mod);
    return result;
}
function $04dbd055bc5edd2b$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $04dbd055bc5edd2b$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $04dbd055bc5edd2b$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $04dbd055bc5edd2b$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $04dbd055bc5edd2b$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $04dbd055bc5edd2b$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $04dbd055bc5edd2b$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $04dbd055bc5edd2b$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $04dbd055bc5edd2b$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $04dbd055bc5edd2b$export$2e2bcd8739ae039 = {
    __extends: $04dbd055bc5edd2b$export$a8ba968b8961cb8a,
    __assign: $04dbd055bc5edd2b$export$18ce0697a983be9b,
    __rest: $04dbd055bc5edd2b$export$3c9a16f847548506,
    __decorate: $04dbd055bc5edd2b$export$29e00dfd3077644b,
    __param: $04dbd055bc5edd2b$export$d5ad3fd78186038f,
    __esDecorate: $04dbd055bc5edd2b$export$3a84e1ae4e97e9b0,
    __runInitializers: $04dbd055bc5edd2b$export$d831c04e792af3d,
    __propKey: $04dbd055bc5edd2b$export$6a2a36740a146cb8,
    __setFunctionName: $04dbd055bc5edd2b$export$d1a06452d3489bc7,
    __metadata: $04dbd055bc5edd2b$export$f1db080c865becb9,
    __awaiter: $04dbd055bc5edd2b$export$1050f835b63b671e,
    __generator: $04dbd055bc5edd2b$export$67ebef60e6f28a6,
    __createBinding: $04dbd055bc5edd2b$export$45d3717a4c69092e,
    __exportStar: $04dbd055bc5edd2b$export$f33643c0debef087,
    __values: $04dbd055bc5edd2b$export$19a8beecd37a4c45,
    __read: $04dbd055bc5edd2b$export$8d051b38c9118094,
    __spread: $04dbd055bc5edd2b$export$afc72e2116322959,
    __spreadArrays: $04dbd055bc5edd2b$export$6388937ca91ccae8,
    __spreadArray: $04dbd055bc5edd2b$export$1216008129fb82ed,
    __await: $04dbd055bc5edd2b$export$10c90e4f7922046c,
    __asyncGenerator: $04dbd055bc5edd2b$export$e427f37a30a4de9b,
    __asyncDelegator: $04dbd055bc5edd2b$export$bbd80228419bb833,
    __asyncValues: $04dbd055bc5edd2b$export$e3b29a3d6162315f,
    __makeTemplateObject: $04dbd055bc5edd2b$export$4fb47efe1390b86f,
    __importStar: $04dbd055bc5edd2b$export$c21735bcef00d192,
    __importDefault: $04dbd055bc5edd2b$export$da59b14a69baef04,
    __classPrivateFieldGet: $04dbd055bc5edd2b$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $04dbd055bc5edd2b$export$d40a35129aaff81f,
    __classPrivateFieldIn: $04dbd055bc5edd2b$export$81fdc39f203e4e04,
    __addDisposableResource: $04dbd055bc5edd2b$export$88ac25d8e944e405,
    __disposeResources: $04dbd055bc5edd2b$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $04dbd055bc5edd2b$export$889dfb5d17574b0b
};

});


var $hO8yS = parcelRequire("hO8yS");
var $2882e8b6468c3ed5$var$t = /["&<]/;
function $2882e8b6468c3ed5$var$n(r) {
    if (0 === r.length || !1 === $2882e8b6468c3ed5$var$t.test(r)) return r;
    for(var e = 0, n = 0, o = "", f = ""; n < r.length; n++){
        switch(r.charCodeAt(n)){
            case 34:
                f = "&quot;";
                break;
            case 38:
                f = "&amp;";
                break;
            case 60:
                f = "&lt;";
                break;
            default:
                continue;
        }
        n !== e && (o += r.slice(e, n)), o += f, e = n + 1;
    }
    return n !== e && (o += r.slice(e, n)), o;
}
var $2882e8b6468c3ed5$var$o = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $2882e8b6468c3ed5$var$f = 0, $2882e8b6468c3ed5$var$i = Array.isArray;
function $2882e8b6468c3ed5$export$34b9dba7ce09269b(e, t, n, o, i, u) {
    t || (t = {});
    var a, c, p = t;
    if ("ref" in p) for(c in p = {}, t)"ref" == c ? a = t[c] : p[c] = t[c];
    var l = {
        type: e,
        props: p,
        key: n,
        ref: a,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __c: null,
        constructor: void 0,
        __v: --$2882e8b6468c3ed5$var$f,
        __i: -1,
        __u: 0,
        __source: i,
        __self: u
    };
    if ("function" == typeof e && (a = e.defaultProps)) for(c in a)void 0 === p[c] && (p[c] = a[c]);
    return (0, $hO8yS.options).vnode && (0, $hO8yS.options).vnode(l), l;
}
function $2882e8b6468c3ed5$export$45700d561b2268ac(r) {
    var t = $2882e8b6468c3ed5$export$34b9dba7ce09269b((0, $hO8yS.Fragment), {
        tpl: r,
        exprs: [].slice.call(arguments, 1)
    });
    return t.key = t.__v, t;
}
var $2882e8b6468c3ed5$var$c = {}, $2882e8b6468c3ed5$var$p = /[A-Z]/g;
function $2882e8b6468c3ed5$export$991f6ffe102e5bac(e, t) {
    if ((0, $hO8yS.options).attr) {
        var f = (0, $hO8yS.options).attr(e, t);
        if ("string" == typeof f) return f;
    }
    if (t = function(r) {
        return null !== r && "object" == typeof r && "function" == typeof r.valueOf ? r.valueOf() : r;
    }(t), "ref" === e || "key" === e) return "";
    if ("style" === e && "object" == typeof t) {
        var i = "";
        for(var u in t){
            var a = t[u];
            if (null != a && "" !== a) {
                var l = "-" == u[0] ? u : $2882e8b6468c3ed5$var$c[u] || ($2882e8b6468c3ed5$var$c[u] = u.replace($2882e8b6468c3ed5$var$p, "-$&").toLowerCase()), s = ";";
                "number" != typeof a || l.startsWith("--") || $2882e8b6468c3ed5$var$o.test(l) || (s = "px;"), i = i + l + ":" + a + s;
            }
        }
        return e + '="' + $2882e8b6468c3ed5$var$n(i) + '"';
    }
    return null == t || !1 === t || "function" == typeof t || "object" == typeof t ? "" : !0 === t ? e : e + '="' + $2882e8b6468c3ed5$var$n("" + t) + '"';
}
function $2882e8b6468c3ed5$export$40e96e718441efeb(r) {
    if (null == r || "boolean" == typeof r || "function" == typeof r) return null;
    if ("object" == typeof r) {
        if (void 0 === r.constructor) return r;
        if ($2882e8b6468c3ed5$var$i(r)) {
            for(var e = 0; e < r.length; e++)r[e] = $2882e8b6468c3ed5$export$40e96e718441efeb(r[e]);
            return r;
        }
    }
    return $2882e8b6468c3ed5$var$n("" + r);
}


var $5ec47347fc6130b4$var$OriginalPromise = Promise;
/**
 * ES5 subclassing is used per:
 * https://github.com/rtsao/browser-unhandled-rejection/issues/1
 * https://kangax.github.io/compat-table/es6/#test-Promise_is_subclassable
 *
 * Adapted from: https://gist.github.com/domenic/8ed6048b187ee8f2ec75
 */ var $5ec47347fc6130b4$var$InstrumentedPromise$1 = function Promise1(resolver) {
    if (!(this instanceof $5ec47347fc6130b4$var$InstrumentedPromise$1)) throw new TypeError('Cannot call a class as a function');
    var promise = new $5ec47347fc6130b4$var$OriginalPromise(function(resolve, reject) {
        return resolver(resolve, function(arg) {
            $5ec47347fc6130b4$var$OriginalPromise.resolve().then(function() {
                if (promise._hasDownstreams === undefined) $5ec47347fc6130b4$var$dispatchUnhandledRejectionEvent(promise, arg);
            });
            return reject(arg);
        });
    });
    promise.__proto__ = $5ec47347fc6130b4$var$InstrumentedPromise$1.prototype;
    return promise;
};
$5ec47347fc6130b4$var$InstrumentedPromise$1.__proto__ = $5ec47347fc6130b4$var$OriginalPromise;
$5ec47347fc6130b4$var$InstrumentedPromise$1.prototype.__proto__ = $5ec47347fc6130b4$var$OriginalPromise.prototype;
$5ec47347fc6130b4$var$InstrumentedPromise$1.prototype.then = function then(onFulfilled, onRejected) {
    var next = $5ec47347fc6130b4$var$OriginalPromise.prototype.then.call(this, onFulfilled, onRejected);
    this._hasDownstreams = true;
    return next;
};
function $5ec47347fc6130b4$var$dispatchUnhandledRejectionEvent(promise, reason) {
    var event = document.createEvent('Event');
    /**
   * Note: these properties should not be enumerable, which is the default setting
   */ Object.defineProperties(event, {
        promise: {
            value: promise,
            writable: false
        },
        reason: {
            value: reason,
            writable: false
        }
    });
    event.initEvent('unhandledrejection', false, true // PromiseRejectionEvent is cancelable
    );
    window.dispatchEvent(event);
}
function $5ec47347fc6130b4$export$baf72085f5fb4df() {
    return typeof PromiseRejectionEvent === 'undefined';
}
function $5ec47347fc6130b4$export$cea1c58a6db52bca() {
    Promise = $5ec47347fc6130b4$var$InstrumentedPromise$1;
}
function $5ec47347fc6130b4$export$dfb5619354ba860() {
    if ($5ec47347fc6130b4$export$baf72085f5fb4df()) $5ec47347fc6130b4$export$cea1c58a6db52bca();
}
var $5ec47347fc6130b4$export$2e2bcd8739ae039 = $5ec47347fc6130b4$var$InstrumentedPromise$1;


function $fbe6f1e2fed97fc7$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $fbe6f1e2fed97fc7$var$$9b05bcda60cc529c$exports = {};
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$9b05bcda60cc529c$exports, "likeNull", function() {
    return $fbe6f1e2fed97fc7$export$61cc6ed0f143570b;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$9b05bcda60cc529c$exports, "isEmpty", function() {
    return $fbe6f1e2fed97fc7$export$dd1bc94b04021eeb;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$9b05bcda60cc529c$exports, "classNameOf", function() {
    return $fbe6f1e2fed97fc7$export$a09f818797e212c4;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$9b05bcda60cc529c$exports, "assertInheritance", function() {
    return $fbe6f1e2fed97fc7$export$170f4e08cad8229d;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$9b05bcda60cc529c$exports, "proxyPrototype", function() {
    return $fbe6f1e2fed97fc7$export$2a489b3f92f4996a;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$9b05bcda60cc529c$exports, "isUnsafeNumeric", function() {
    return $fbe6f1e2fed97fc7$export$67a6ce548ae77071;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$9b05bcda60cc529c$exports, "byteLength", function() {
    return $fbe6f1e2fed97fc7$export$a48f0734ac7c2329;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$9b05bcda60cc529c$exports, "toHyphenCase", function() {
    return $fbe6f1e2fed97fc7$export$3f34ca2fef821bbd;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$9b05bcda60cc529c$exports, "toCamelCase", function() {
    return $fbe6f1e2fed97fc7$export$86f54f62aa7a7514;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$9b05bcda60cc529c$exports, "uniqueID", function() {
    return $fbe6f1e2fed97fc7$export$89912e019eef22aa;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$9b05bcda60cc529c$exports, "encodeBase64", function() {
    return $fbe6f1e2fed97fc7$export$8fb536984ec8b4d7;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$9b05bcda60cc529c$exports, "decodeBase64", function() {
    return $fbe6f1e2fed97fc7$export$94fdf11bafc8de6b;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$9b05bcda60cc529c$exports, "objectFrom", function() {
    return $fbe6f1e2fed97fc7$export$1c8ba402144543e5;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$9b05bcda60cc529c$exports, "DiffStatus", function() {
    return $fbe6f1e2fed97fc7$export$2ddabb89308e1a22;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$9b05bcda60cc529c$exports, "diffKeys", function() {
    return $fbe6f1e2fed97fc7$export$14527669107aa301;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$9b05bcda60cc529c$exports, "groupBy", function() {
    return $fbe6f1e2fed97fc7$export$3f063810d7bf01bd;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$9b05bcda60cc529c$exports, "likeArray", function() {
    return $fbe6f1e2fed97fc7$export$b5a4d6f439a5044d;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$9b05bcda60cc529c$exports, "isTypedArray", function() {
    return $fbe6f1e2fed97fc7$export$b119cc7e1840e59c;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$9b05bcda60cc529c$exports, "makeArray", function() {
    return $fbe6f1e2fed97fc7$export$7b85fd78dd236198;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$9b05bcda60cc529c$exports, "splitArray", function() {
    return $fbe6f1e2fed97fc7$export$697c3df919c0e61a;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$9b05bcda60cc529c$exports, "countBy", function() {
    return $fbe6f1e2fed97fc7$export$1d012a0dff3dab06;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$9b05bcda60cc529c$exports, "findDeep", function() {
    return $fbe6f1e2fed97fc7$export$e6b5ff3168b5942b;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$9b05bcda60cc529c$exports, "clone", function() {
    return $fbe6f1e2fed97fc7$export$9cd59f9826255e47;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$9b05bcda60cc529c$exports, "treeFrom", function() {
    return $fbe6f1e2fed97fc7$export$fbc9cd6af26fa64f;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$9b05bcda60cc529c$exports, "cache", function() {
    return $fbe6f1e2fed97fc7$export$69a3209f1a06c04d;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$9b05bcda60cc529c$exports, "createAsyncIterator", function() {
    return $fbe6f1e2fed97fc7$export$86c18c6347f4a8c4;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$9b05bcda60cc529c$exports, "mergeStream", function() {
    return $fbe6f1e2fed97fc7$export$dce9414bed0662c;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$9b05bcda60cc529c$exports, "ByteSize", function() {
    return $fbe6f1e2fed97fc7$export$271f7c16f175f804;
});
var $fbe6f1e2fed97fc7$var$$6a9944941b4c1893$exports = {};
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$6a9944941b4c1893$exports, "sum", function() {
    return $fbe6f1e2fed97fc7$export$8a63f25cc62965f1;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$6a9944941b4c1893$exports, "averageOf", function() {
    return $fbe6f1e2fed97fc7$export$e1f36757ecda301d;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$6a9944941b4c1893$exports, "varianceOf", function() {
    return $fbe6f1e2fed97fc7$export$8e694e1eafd55acb;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$6a9944941b4c1893$exports, "standardDeviationOf", function() {
    return $fbe6f1e2fed97fc7$export$57d7c52a66287430;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$6a9944941b4c1893$exports, "hypotenuseOf", function() {
    return $fbe6f1e2fed97fc7$export$2b4693832ca3ce16;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$6a9944941b4c1893$exports, "carryFloat", function() {
    return $fbe6f1e2fed97fc7$export$5b784e078da1ce6;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$6a9944941b4c1893$exports, "fixFloat", function() {
    return $fbe6f1e2fed97fc7$export$17ec9c9f4f23588c;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$6a9944941b4c1893$exports, "Scalar", function() {
    return $fbe6f1e2fed97fc7$export$595dbf49c602a1f;
});
function $fbe6f1e2fed97fc7$export$8a63f25cc62965f1(...data) {
    return data.reduce((sum, item)=>sum + item, 0);
}
function $fbe6f1e2fed97fc7$export$e1f36757ecda301d(...data) {
    return $fbe6f1e2fed97fc7$export$8a63f25cc62965f1(...data) / data.length;
}
function $fbe6f1e2fed97fc7$export$8e694e1eafd55acb(data, sample = false) {
    const average = $fbe6f1e2fed97fc7$export$e1f36757ecda301d(...data);
    const summary = $fbe6f1e2fed97fc7$export$8a63f25cc62965f1(...data.map((item)=>(item - average) ** 2));
    return summary / (data.length - (sample ? 1 : 0));
}
function $fbe6f1e2fed97fc7$export$57d7c52a66287430(data, sample = false) {
    return Math.sqrt($fbe6f1e2fed97fc7$export$8e694e1eafd55acb(data, sample));
}
function $fbe6f1e2fed97fc7$export$2b4693832ca3ce16(...data) {
    return Math.sqrt($fbe6f1e2fed97fc7$export$8a63f25cc62965f1(...data.map((item)=>item ** 2)));
}
function $fbe6f1e2fed97fc7$export$5b784e078da1ce6(raw, length) {
    const text = raw.toFixed(length + 2);
    const offset = text.indexOf('.') + length + 1;
    const cut = (text)=>text.slice(0, offset - (length ? 0 : 1));
    if (!+text.slice(offset)) return cut(text);
    const result = cut((+cut(text) + 10 ** -length).toFixed(length));
    return result.includes('.') ? result.padEnd(offset, '0') : result;
}
function $fbe6f1e2fed97fc7$export$17ec9c9f4f23588c(raw, length = 2) {
    const text = raw.toFixed(length + 2);
    const floatOffset = text.indexOf('.');
    if (floatOffset < 0) return length ? `${text}.${'0'.repeat(length)}` : text;
    const offset = floatOffset + length + 1;
    const before = +text[offset - 1], anchor = +text[offset], after = +text[offset + 1];
    const carry = anchor > 5 || anchor === 5 && (!!after || !!(before % 2));
    if (carry) return $fbe6f1e2fed97fc7$export$5b784e078da1ce6(raw, length);
    const result = text.slice(0, offset - (length ? 0 : 1));
    return result.includes('.') ? result.padEnd(offset, '0') : result;
}
class $fbe6f1e2fed97fc7$export$595dbf49c602a1f {
    constructor(value){
        this.value = value;
    }
    valueOf() {
        return this.value;
    }
    toShortString(fractionDigits = 2) {
        const { units: units, value: value } = this;
        const { base: base, name: name } = [
            ...units
        ].reverse().find(({ base: base })=>Math.abs(value) >= base) || units[0];
        return `${(value / base).toFixed(fractionDigits)} ${name}`;
    }
    static distanceOf(a, b) {
        return Reflect.construct(this, [
            a - b
        ]);
    }
}
const $fbe6f1e2fed97fc7$export$61cc6ed0f143570b = (value)=>!(value != null) || Number.isNaN(value);
const $fbe6f1e2fed97fc7$export$dd1bc94b04021eeb = (value)=>$fbe6f1e2fed97fc7$export$61cc6ed0f143570b(value) || (typeof value === 'object' ? !Object.keys(value).length : value === '');
const $fbe6f1e2fed97fc7$export$a09f818797e212c4 = (data)=>Object.prototype.toString.call(data).slice(8, -1);
const $fbe6f1e2fed97fc7$export$170f4e08cad8229d = (Sub, Super)=>Sub.prototype instanceof Super;
function $fbe6f1e2fed97fc7$export$2a489b3f92f4996a(target, dataStore, setter) {
    const prototype = Object.getPrototypeOf(target);
    const prototypeProxy = new Proxy(prototype, {
        set: (_, key, value, receiver)=>{
            if (key in receiver) Reflect.set(prototype, key, value, receiver);
            else dataStore[key] = value;
            setter?.(key, value);
            return true;
        },
        get: (prototype, key, receiver)=>key in dataStore ? dataStore[key] : Reflect.get(prototype, key, receiver)
    });
    Object.setPrototypeOf(target, prototypeProxy);
}
const $fbe6f1e2fed97fc7$export$67a6ce548ae77071 = (raw)=>/^[\d.]+$/.test(raw) && raw.localeCompare(Number.MAX_SAFE_INTEGER + '', undefined, {
        numeric: true
    }) > 0;
const $fbe6f1e2fed97fc7$export$a48f0734ac7c2329 = (raw)=>raw.replace(/[^\u0021-\u007e\uff61-\uffef]/g, 'xx').length;
const $fbe6f1e2fed97fc7$export$3f34ca2fef821bbd = (raw)=>raw.replace(/[A-Z]+|[^A-Za-z][A-Za-z]/g, (match, offset)=>`${offset ? '-' : ''}${(match[1] || match[0]).toLowerCase()}`);
const $fbe6f1e2fed97fc7$export$86f54f62aa7a7514 = (raw, large = false)=>raw.replace(/^[A-Za-z]|[^A-Za-z][A-Za-z]/g, (match, offset)=>offset || large ? (match[1] || match[0]).toUpperCase() : match.toLowerCase());
const $fbe6f1e2fed97fc7$export$89912e019eef22aa = ()=>(Date.now() + parseInt((Math.random() + '').slice(2))).toString(36);
const $fbe6f1e2fed97fc7$export$8fb536984ec8b4d7 = (input)=>btoa(String.fromCharCode(...new TextEncoder().encode(input)));
const $fbe6f1e2fed97fc7$export$94fdf11bafc8de6b = (input)=>new TextDecoder().decode(Uint8Array.from(atob(input), (char)=>char.charCodeAt(0)));
const $fbe6f1e2fed97fc7$export$1c8ba402144543e5 = (values, keys)=>Object.fromEntries(values.map((value, index)=>[
            keys[index],
            value
        ]));
var $fbe6f1e2fed97fc7$export$2ddabb89308e1a22 = /*#__PURE__*/ function(DiffStatus) {
    DiffStatus[DiffStatus["Old"] = -1] = "Old";
    DiffStatus[DiffStatus["Same"] = 0] = "Same";
    DiffStatus[DiffStatus["New"] = 1] = "New";
    return DiffStatus;
}({});
function $fbe6f1e2fed97fc7$export$14527669107aa301(oldList, newList) {
    const map = {};
    for (const item of oldList)map[item] = -1;
    for (const item of newList){
        map[item] ||= 0;
        map[item] += 1;
    }
    return {
        map: map,
        group: $fbe6f1e2fed97fc7$export$3f063810d7bf01bd(Object.entries(map), ([key, status])=>status)
    };
}
function $fbe6f1e2fed97fc7$export$b5a4d6f439a5044d(data) {
    if ($fbe6f1e2fed97fc7$export$61cc6ed0f143570b(data)) return false;
    const { length: length } = data;
    return typeof length === 'number' && length >= 0 && ~~length === length;
}
const $fbe6f1e2fed97fc7$export$b119cc7e1840e59c = (data)=>data instanceof Object.getPrototypeOf(Int8Array);
function $fbe6f1e2fed97fc7$export$7b85fd78dd236198(data) {
    if (data instanceof Array) return data;
    if ($fbe6f1e2fed97fc7$export$61cc6ed0f143570b(data)) return [];
    if ($fbe6f1e2fed97fc7$export$b5a4d6f439a5044d(data)) return Array.from(data);
    return [
        data
    ];
}
const $fbe6f1e2fed97fc7$export$697c3df919c0e61a = (array, unitLength)=>array.reduce((grid, item, index)=>{
        (grid[~~(index / unitLength)] ||= [])[index % unitLength] = item;
        return grid;
    }, []);
function $fbe6f1e2fed97fc7$export$3f063810d7bf01bd(list, iteratee) {
    const data = {};
    for (const item of list){
        let keys = iteratee instanceof Function ? iteratee(item) : item[iteratee];
        if (!(keys instanceof Array)) keys = [
            keys
        ];
        for (const key of new Set(keys.filter((key)=>key != null)))(data[key] = data[key] || []).push(item);
    }
    return data;
}
function $fbe6f1e2fed97fc7$export$1d012a0dff3dab06(list, iteratee) {
    const group = $fbe6f1e2fed97fc7$export$3f063810d7bf01bd(list, iteratee);
    const sortedList = Object.entries(group).map(([key, { length: length }])=>[
            key,
            length
        ]);
    return Object.fromEntries(sortedList);
}
function $fbe6f1e2fed97fc7$export$e6b5ff3168b5942b(list, subKey, handler) {
    for (const item of list){
        if (handler(item)) return [
            item
        ];
        if (item[subKey] instanceof Array) {
            const result = $fbe6f1e2fed97fc7$export$e6b5ff3168b5942b(item[subKey], subKey, handler);
            if (result.length) return [
                item,
                ...result
            ];
        }
    }
    return [];
}
function $fbe6f1e2fed97fc7$export$9cd59f9826255e47(data) {
    try {
        return globalThis.structuredClone(data);
    } catch  {
        return JSON.parse(JSON.stringify(data));
    }
}
function $fbe6f1e2fed97fc7$export$fbc9cd6af26fa64f(list, idKey = 'id', parentIdKey = 'parentId', childrenKey = 'children') {
    list = $fbe6f1e2fed97fc7$export$9cd59f9826255e47(list);
    const map = {};
    const roots = [];
    for (const item of list)map[item[idKey]] = item;
    for (const item of list){
        const parent = map[item[parentIdKey]];
        if (!parent) roots.push(item);
        else {
            parent[childrenKey] ||= [];
            parent[childrenKey].push(item);
        }
    }
    if (!roots[0]) throw new ReferenceError('No root node is found');
    return roots;
}
function $fbe6f1e2fed97fc7$export$69a3209f1a06c04d(executor, title) {
    var cacheData;
    return function(...data) {
        if (cacheData != null) return cacheData;
        console.trace(`[Cache] execute: ${title}`);
        cacheData = executor.call(this, ()=>cacheData = undefined, ...data);
        Promise.resolve(cacheData).then((data)=>console.log(`[Cache] refreshed: ${title} => ${data}`), (error)=>console.error(`[Cache] failed: ${error?.message || error}`));
        return cacheData;
    };
}
async function* $fbe6f1e2fed97fc7$export$86c18c6347f4a8c4(executor) {
    let { promise: promise, resolve: resolve, reject: reject } = Promise.withResolvers();
    const doneSymbol = Symbol('done'), done = Promise.withResolvers();
    const disposer = executor({
        next: (value)=>resolve(value),
        error: (error)=>{
            reject(error);
            // @ts-ignore
            disposer?.();
        },
        complete: ()=>{
            done.resolve(doneSymbol);
            // @ts-ignore
            disposer?.();
        }
    });
    while(true){
        const value = await Promise.race([
            promise,
            done.promise
        ]);
        if (value === doneSymbol) return;
        yield value;
        ({ promise: promise, resolve: resolve, reject: reject } = Promise.withResolvers());
    }
}
async function* $fbe6f1e2fed97fc7$export$dce9414bed0662c(...sources) {
    var iterators = sources.map((item)=>item());
    while(iterators[0]){
        const dones = [];
        for(let i = 0, iterator; iterator = iterators[i]; i++){
            const { done: done, value: value } = await iterator.next();
            if (!done) yield value;
            else dones.push(i);
        }
        iterators = iterators.filter((_, i)=>!dones.includes(i));
    }
}
class $fbe6f1e2fed97fc7$export$271f7c16f175f804 extends $fbe6f1e2fed97fc7$export$595dbf49c602a1f {
    constructor(...args){
        super(...args), this.units = [
            '',
            'K',
            'M',
            'G',
            'T',
            'P',
            'E',
            'Z',
            'Y'
        ].map((name, i)=>({
                base: 1024 ** i,
                name: name + 'B'
            }));
    }
}
var $fbe6f1e2fed97fc7$var$$f872d8bba1c0f79f$exports = {};
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$f872d8bba1c0f79f$exports, "Second", function() {
    return $fbe6f1e2fed97fc7$export$c489aa6f7fd82b1a;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$f872d8bba1c0f79f$exports, "Minute", function() {
    return $fbe6f1e2fed97fc7$export$cbd942915f33be50;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$f872d8bba1c0f79f$exports, "Quarter", function() {
    return $fbe6f1e2fed97fc7$export$9b886f8493244014;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$f872d8bba1c0f79f$exports, "Hour", function() {
    return $fbe6f1e2fed97fc7$export$e99cbb807a5bb10d;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$f872d8bba1c0f79f$exports, "Day", function() {
    return $fbe6f1e2fed97fc7$export$7a9a31a911eb9a20;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$f872d8bba1c0f79f$exports, "Week", function() {
    return $fbe6f1e2fed97fc7$export$fca4f8121099df57;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$f872d8bba1c0f79f$exports, "Year", function() {
    return $fbe6f1e2fed97fc7$export$6ce2f08d515512;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$f872d8bba1c0f79f$exports, "Month", function() {
    return $fbe6f1e2fed97fc7$export$951c8378cdfec6e6;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$f872d8bba1c0f79f$exports, "Season", function() {
    return $fbe6f1e2fed97fc7$export$1a4097b876a13bf7;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$f872d8bba1c0f79f$exports, "Timestamp", function() {
    return $fbe6f1e2fed97fc7$export$d9bcbd5e1ff81430;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$f872d8bba1c0f79f$exports, "diffTime", function() {
    return $fbe6f1e2fed97fc7$export$506c8e8f8c8edda;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$f872d8bba1c0f79f$exports, "formatDate", function() {
    return $fbe6f1e2fed97fc7$export$3ae94a2503e890a1;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$f872d8bba1c0f79f$exports, "changeYear", function() {
    return $fbe6f1e2fed97fc7$export$7e1c707225b48c34;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$f872d8bba1c0f79f$exports, "changeMonth", function() {
    return $fbe6f1e2fed97fc7$export$62ad822b3a5fd9a0;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$f872d8bba1c0f79f$exports, "changeDate", function() {
    return $fbe6f1e2fed97fc7$export$9e85258502147ffb;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$f872d8bba1c0f79f$exports, "makeDateRange", function() {
    return $fbe6f1e2fed97fc7$export$3c1f2e5bc03748e2;
});
const $fbe6f1e2fed97fc7$export$c489aa6f7fd82b1a = 1000;
const $fbe6f1e2fed97fc7$export$cbd942915f33be50 = $fbe6f1e2fed97fc7$export$c489aa6f7fd82b1a * 60;
const $fbe6f1e2fed97fc7$export$9b886f8493244014 = $fbe6f1e2fed97fc7$export$cbd942915f33be50 * 15;
const $fbe6f1e2fed97fc7$export$e99cbb807a5bb10d = $fbe6f1e2fed97fc7$export$9b886f8493244014 * 4;
const $fbe6f1e2fed97fc7$export$7a9a31a911eb9a20 = $fbe6f1e2fed97fc7$export$e99cbb807a5bb10d * 24;
const $fbe6f1e2fed97fc7$export$fca4f8121099df57 = $fbe6f1e2fed97fc7$export$7a9a31a911eb9a20 * 7;
const $fbe6f1e2fed97fc7$export$6ce2f08d515512 = $fbe6f1e2fed97fc7$export$7a9a31a911eb9a20 * 365;
const $fbe6f1e2fed97fc7$export$951c8378cdfec6e6 = $fbe6f1e2fed97fc7$export$6ce2f08d515512 / 12;
const $fbe6f1e2fed97fc7$export$1a4097b876a13bf7 = $fbe6f1e2fed97fc7$export$951c8378cdfec6e6 * 3;
class $fbe6f1e2fed97fc7$export$d9bcbd5e1ff81430 extends $fbe6f1e2fed97fc7$export$595dbf49c602a1f {
    toShortString(fractionDigits = 0) {
        return super.toShortString(fractionDigits);
    }
    constructor(...args){
        super(...args), this.units = [
            {
                base: $fbe6f1e2fed97fc7$export$c489aa6f7fd82b1a,
                name: 's'
            },
            {
                base: $fbe6f1e2fed97fc7$export$cbd942915f33be50,
                name: 'm'
            },
            {
                base: $fbe6f1e2fed97fc7$export$e99cbb807a5bb10d,
                name: 'H'
            },
            {
                base: $fbe6f1e2fed97fc7$export$7a9a31a911eb9a20,
                name: 'D'
            },
            {
                base: $fbe6f1e2fed97fc7$export$fca4f8121099df57,
                name: 'W'
            },
            {
                base: $fbe6f1e2fed97fc7$export$951c8378cdfec6e6,
                name: 'M'
            },
            {
                base: $fbe6f1e2fed97fc7$export$6ce2f08d515512,
                name: 'Y'
            }
        ];
    }
}
function $fbe6f1e2fed97fc7$export$506c8e8f8c8edda(end, start = new Date()) {
    const timeDistance = $fbe6f1e2fed97fc7$export$d9bcbd5e1ff81430.distanceOf(+new Date(end), +new Date(start));
    const [value, unit] = timeDistance.toShortString().split(/\s+/);
    return {
        distance: +value,
        unit: unit
    };
}
function $fbe6f1e2fed97fc7$var$$f872d8bba1c0f79f$var$fitUnit(value) {
    value = +value + '';
    return (template)=>(value.length < template.length ? value.padStart(template.length, '0') : value).slice(-Math.max(template.length, 2));
}
function $fbe6f1e2fed97fc7$export$3ae94a2503e890a1(time = new Date(), template = 'YYYY-MM-DD HH:mm:ss') {
    const [year, month, day, hour, minute, second, millisecond] = new Date(time).toJSON().split(/\D/);
    return template.replace(/ms/g, millisecond).replace(/Y+/g, $fbe6f1e2fed97fc7$var$$f872d8bba1c0f79f$var$fitUnit(year)).replace(/M+/g, $fbe6f1e2fed97fc7$var$$f872d8bba1c0f79f$var$fitUnit(month)).replace(/D+/g, $fbe6f1e2fed97fc7$var$$f872d8bba1c0f79f$var$fitUnit(day)).replace(/H+/g, $fbe6f1e2fed97fc7$var$$f872d8bba1c0f79f$var$fitUnit(hour)).replace(/m+/g, $fbe6f1e2fed97fc7$var$$f872d8bba1c0f79f$var$fitUnit(minute)).replace(/s+/g, $fbe6f1e2fed97fc7$var$$f872d8bba1c0f79f$var$fitUnit(second));
}
function $fbe6f1e2fed97fc7$export$7e1c707225b48c34(date, delta) {
    date = new Date(date);
    date.setFullYear(date.getFullYear() + delta);
    return date;
}
function $fbe6f1e2fed97fc7$export$62ad822b3a5fd9a0(date, delta) {
    date = new Date(date);
    const month = date.getMonth() + delta;
    date = $fbe6f1e2fed97fc7$export$7e1c707225b48c34(date, Math.floor(month / 12));
    delta = month % 12;
    date.setMonth(delta < 0 ? 12 + delta : delta);
    return date;
}
const $fbe6f1e2fed97fc7$export$9e85258502147ffb = (date, unit, delta)=>unit === $fbe6f1e2fed97fc7$export$6ce2f08d515512 ? $fbe6f1e2fed97fc7$export$7e1c707225b48c34(date, delta) : unit === $fbe6f1e2fed97fc7$export$951c8378cdfec6e6 ? $fbe6f1e2fed97fc7$export$62ad822b3a5fd9a0(date, delta) : new Date(+new Date(date) + delta * unit);
const $fbe6f1e2fed97fc7$var$$f872d8bba1c0f79f$var$DateLength2Unit = {
    4: $fbe6f1e2fed97fc7$export$6ce2f08d515512,
    7: $fbe6f1e2fed97fc7$export$951c8378cdfec6e6,
    10: $fbe6f1e2fed97fc7$export$7a9a31a911eb9a20,
    13: $fbe6f1e2fed97fc7$export$e99cbb807a5bb10d,
    16: $fbe6f1e2fed97fc7$export$cbd942915f33be50,
    19: $fbe6f1e2fed97fc7$export$c489aa6f7fd82b1a
};
function $fbe6f1e2fed97fc7$export$3c1f2e5bc03748e2(value) {
    const defaultValue = `2025-01-01T00:00:00.000Z`;
    const startedAt = new Date(value + defaultValue.slice(value.length));
    const endedAt = $fbe6f1e2fed97fc7$export$9e85258502147ffb(startedAt, $fbe6f1e2fed97fc7$var$$f872d8bba1c0f79f$var$DateLength2Unit[value.length], 1);
    return [
        startedAt,
        endedAt
    ];
}
var $fbe6f1e2fed97fc7$var$$ba0e5dc395660a7c$exports = {};
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$ba0e5dc395660a7c$exports, "parseJSON", function() {
    return $fbe6f1e2fed97fc7$export$27924e57e9afff7f;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$ba0e5dc395660a7c$exports, "toJSValue", function() {
    return $fbe6f1e2fed97fc7$export$7ea17d45ecdcf634;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$ba0e5dc395660a7c$exports, "stringifyTextTable", function() {
    return $fbe6f1e2fed97fc7$export$bf304e455230454a;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$ba0e5dc395660a7c$exports, "parseTextTable", function() {
    return $fbe6f1e2fed97fc7$export$bb8626e4916f587b;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$ba0e5dc395660a7c$exports, "parseTextTableAsync", function() {
    return $fbe6f1e2fed97fc7$export$88182f6768071c72;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$ba0e5dc395660a7c$exports, "readTextTable", function() {
    return $fbe6f1e2fed97fc7$export$2427785258f88523;
});
function $fbe6f1e2fed97fc7$export$27924e57e9afff7f(raw) {
    function parseItem(value) {
        if (typeof value === 'string' && /^\d+(-\d{1,2}){1,2}/.test(value)) {
            const date = new Date(value);
            if (!Number.isNaN(+date)) return date;
        }
        return value;
    }
    const value = parseItem(raw);
    if (typeof value !== 'string' || $fbe6f1e2fed97fc7$export$67a6ce548ae77071(value)) return value;
    try {
        return JSON.parse(raw, (key, value)=>parseItem(value));
    } catch  {
        return raw;
    }
}
function $fbe6f1e2fed97fc7$export$7ea17d45ecdcf634(raw) {
    const parsed = $fbe6f1e2fed97fc7$export$27924e57e9afff7f(raw);
    if (typeof parsed !== 'string') return parsed;
    const number = +parsed;
    return Number.isNaN(number) || number + '' !== parsed ? parsed : number;
}
const $fbe6f1e2fed97fc7$export$bf304e455230454a = (data, separator = ',')=>[
        Object.keys(data[0]).join(separator),
        ...data.map((item)=>Object.values(item).map((value)=>JSON.stringify(value)).join(separator))
    ].join('\n');
function $fbe6f1e2fed97fc7$var$$ba0e5dc395660a7c$var$readQuoteValue(raw) {
    const quote = raw[0];
    const index = raw.indexOf(quote, 1);
    if (index < 0) throw SyntaxError(`A ${quote} is missing`);
    return raw.slice(1, index);
}
function $fbe6f1e2fed97fc7$var$$ba0e5dc395660a7c$var$parseRow(row, separator = ',') {
    const list = [];
    do {
        let value;
        if (row[0] === '"' || row[0] === "'") {
            value = $fbe6f1e2fed97fc7$var$$ba0e5dc395660a7c$var$readQuoteValue(row);
            row = row.slice(value.length + 3);
        } else {
            const index = row.indexOf(separator);
            if (index > -1) {
                value = row.slice(0, index);
                row = row.slice(index + 1);
            } else {
                value = row;
                row = '';
            }
        }
        list.push($fbe6f1e2fed97fc7$export$7ea17d45ecdcf634(value.trim()));
    }while (row);
    return list;
}
function $fbe6f1e2fed97fc7$export$bb8626e4916f587b(raw, header, separator = ',') {
    const data = raw.trim().split(/[\r\n]+/).map((row)=>$fbe6f1e2fed97fc7$var$$ba0e5dc395660a7c$var$parseRow(row, separator));
    return !header ? data : data.slice(1).map((row)=>$fbe6f1e2fed97fc7$export$1c8ba402144543e5(row, data[0]));
}
const $fbe6f1e2fed97fc7$export$88182f6768071c72 = async (raw)=>Array.fromAsync($fbe6f1e2fed97fc7$export$2427785258f88523(raw[Symbol.iterator]()));
async function* $fbe6f1e2fed97fc7$var$$ba0e5dc395660a7c$var$characterStream(chunks) {
    for await (const chunk of chunks)yield* chunk;
}
async function* $fbe6f1e2fed97fc7$var$$ba0e5dc395660a7c$var$parseCharacterStream(chars, separator = ',') {
    let inQuote = false;
    let quoteChar = '';
    let prevChar = '';
    let cellBuffer = '';
    let currentRow = [];
    const completeCell = ()=>{
        currentRow.push($fbe6f1e2fed97fc7$export$7ea17d45ecdcf634(cellBuffer.trim()));
        cellBuffer = '';
    };
    for await (const char of chars){
        if (char === '\n' || char === '\r') {
            if (char === '\n' && prevChar === '\r') {
                prevChar = char;
                continue;
            }
            completeCell();
            if (currentRow.length > 1 || currentRow[0]) yield currentRow;
            currentRow = [];
        } else if ((char === '"' || char === "'") && !inQuote && cellBuffer.trim() === '') {
            inQuote = true;
            quoteChar = char;
        } else if (char === quoteChar && inQuote) {
            inQuote = false;
            quoteChar = '';
        } else if (inQuote) cellBuffer += char;
        else if (char === separator) completeCell();
        else cellBuffer += char;
        prevChar = char;
    }
    if (cellBuffer || currentRow.length > 0) {
        completeCell();
        if (currentRow.length > 1 || currentRow[0]) yield currentRow;
    }
}
async function* $fbe6f1e2fed97fc7$export$2427785258f88523(chunks, header, separator = ',') {
    let headerRow;
    let isFirstRow = true;
    const chars = $fbe6f1e2fed97fc7$var$$ba0e5dc395660a7c$var$characterStream(chunks);
    for await (const row of $fbe6f1e2fed97fc7$var$$ba0e5dc395660a7c$var$parseCharacterStream(chars, separator))if (header && isFirstRow) {
        headerRow = row;
        isFirstRow = false;
    } else yield header && headerRow ? $fbe6f1e2fed97fc7$export$1c8ba402144543e5(row, headerRow) : row;
}
var $fbe6f1e2fed97fc7$var$$083124ac4b1a50a0$exports = {};
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$083124ac4b1a50a0$exports, "isXDomain", function() {
    return $fbe6f1e2fed97fc7$export$71e6483fc2b024eb;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$083124ac4b1a50a0$exports, "parseURLData", function() {
    return $fbe6f1e2fed97fc7$export$eb9b2aadbe449a20;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$083124ac4b1a50a0$exports, "buildURLData", function() {
    return $fbe6f1e2fed97fc7$export$13397a83aa5915d6;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$083124ac4b1a50a0$exports, "blobOf", function() {
    return $fbe6f1e2fed97fc7$export$fd89523fba250fa4;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$083124ac4b1a50a0$exports, "blobFrom", function() {
    return $fbe6f1e2fed97fc7$export$504fbde693c1771c;
});
const $fbe6f1e2fed97fc7$export$71e6483fc2b024eb = (URI)=>new URL(URI, document.baseURI).origin !== location.origin;
function $fbe6f1e2fed97fc7$export$eb9b2aadbe449a20(raw = globalThis.location?.search || '', toBuiltIn = true) {
    const rawData = raw.split('#').map((URI)=>{
        const [before, after] = URI.split('?');
        return new URLSearchParams(after || (before.includes('=') ? before : ''));
    }).join('&');
    const data = new URLSearchParams(rawData);
    return Object.fromEntries([
        ...data.keys()
    ].map((key)=>{
        const list = toBuiltIn ? data.getAll(key).map($fbe6f1e2fed97fc7$export$27924e57e9afff7f) : data.getAll(key);
        return [
            key,
            list.length < 2 ? list[0] : list
        ];
    }));
}
const $fbe6f1e2fed97fc7$var$$083124ac4b1a50a0$var$stringify = (value)=>typeof value === 'string' ? value : $fbe6f1e2fed97fc7$export$b5a4d6f439a5044d(value) ? $fbe6f1e2fed97fc7$export$7b85fd78dd236198(value) + '' : JSON.stringify(value);
function $fbe6f1e2fed97fc7$export$13397a83aa5915d6(map) {
    if (!(map instanceof Array)) map = Object.entries(map);
    const list = map.map(([key, value])=>!$fbe6f1e2fed97fc7$export$dd1bc94b04021eeb(value) && [
            key,
            $fbe6f1e2fed97fc7$var$$083124ac4b1a50a0$var$stringify(value)
        ]).filter(Boolean);
    return new URLSearchParams(list);
}
const $fbe6f1e2fed97fc7$export$fd89523fba250fa4 = async (URI)=>(await fetch(URI + '')).blob();
const $fbe6f1e2fed97fc7$var$$083124ac4b1a50a0$var$DataURI = /^data:(.+?\/(.+?))?(;base64)?,([\s\S]+)/;
function $fbe6f1e2fed97fc7$export$504fbde693c1771c(URI) {
    var [_, type, __, base64, data] = $fbe6f1e2fed97fc7$var$$083124ac4b1a50a0$var$DataURI.exec(URI) || [];
    data = base64 ? atob(data) : data;
    const aBuffer = Uint8Array.from(data, (char)=>char.charCodeAt(0));
    return new Blob([
        aBuffer
    ], {
        type: type
    });
}
var $fbe6f1e2fed97fc7$var$$d677628cc2ac1e37$exports = {};
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$d677628cc2ac1e37$exports, "parseCookie", function() {
    return $fbe6f1e2fed97fc7$export$d0eaf3e94be578f6;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$d677628cc2ac1e37$exports, "setCookie", function() {
    return $fbe6f1e2fed97fc7$export$110700823644f4a6;
});
const $fbe6f1e2fed97fc7$export$d0eaf3e94be578f6 = (value = globalThis.document?.cookie)=>value ? Object.fromEntries(value.split(/;\s*/).map((item)=>item.split('='))) : {};
function $fbe6f1e2fed97fc7$export$110700823644f4a6(key, value, attributes = {}) {
    const data = `${key}=${value}`, option = Object.entries(attributes).map(([key, value])=>typeof value === 'boolean' ? value ? key : '' : `${key}=${value}`).filter(Boolean).join('; ');
    document.cookie = `${data}; expires=${new Date(0)}`;
    return document.cookie = `${data}; ${option}`;
}
var $fbe6f1e2fed97fc7$var$$50872bf213056663$exports = {};
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$50872bf213056663$exports, "makeCRC32", function() {
    return $fbe6f1e2fed97fc7$export$1b9ac4d3de3ffd2e;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$50872bf213056663$exports, "makeSHA", function() {
    return $fbe6f1e2fed97fc7$export$d51f3b55e8d1aa73;
});
const $fbe6f1e2fed97fc7$var$$50872bf213056663$var$CRC_32_Table = Array.from(new Array(256), (_, cell)=>{
    for(var j = 0; j < 8; j++)if (cell & 1) cell = cell >> 1 & 0x7fffffff ^ 0xedb88320;
    else cell = cell >> 1 & 0x7fffffff;
    return cell;
});
function $fbe6f1e2fed97fc7$export$1b9ac4d3de3ffd2e(raw) {
    var value = 0xffffffff;
    for (const char of raw)value = value >> 8 & 0x00ffffff ^ $fbe6f1e2fed97fc7$var$$50872bf213056663$var$CRC_32_Table[value & 0xff ^ char.charCodeAt(0)];
    return '0x' + ((value ^ 0xffffffff) >>> 0).toString(16);
}
if (typeof self === 'object') {
    if ('msCrypto' in globalThis) {
        // @ts-ignore
        const { subtle: subtle } = globalThis.crypto = globalThis.msCrypto;
        for(const key in subtle){
            const origin = subtle[key];
            if (origin instanceof Function) subtle[key] = function() {
                const observer = origin.apply(this, arguments);
                return new Promise((resolve, reject)=>{
                    observer.oncomplete = ({ target: target })=>resolve(target.result);
                    observer.onabort = observer.onerror = reject;
                });
            };
        }
    }
    const { crypto: crypto1 } = globalThis;
    if (!crypto1?.subtle && crypto1?.['webkitSubtle']) crypto1.subtle = crypto1['webkitSubtle'];
}
async function $fbe6f1e2fed97fc7$export$d51f3b55e8d1aa73(raw, algorithm = 'SHA-1') {
    const buffer = await crypto.subtle.digest(algorithm, new TextEncoder().encode(raw));
    return Array.from(new Uint8Array(buffer), (byte)=>byte.toString(16).padStart(2, '0')).join('');
}
var $fbe6f1e2fed97fc7$var$$93a3089d2937b23f$exports = {};
var $fbe6f1e2fed97fc7$var$$3e0a089cc13f69ad$exports = {};
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$3e0a089cc13f69ad$exports, "XMLNamespace", function() {
    return $fbe6f1e2fed97fc7$export$f5a4056b78c72efa;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$3e0a089cc13f69ad$exports, "templateOf", function() {
    return $fbe6f1e2fed97fc7$export$2ee022bbbc550b25;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$3e0a089cc13f69ad$exports, "elementTypeOf", function() {
    return $fbe6f1e2fed97fc7$export$a549dd5cef7f8327;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$3e0a089cc13f69ad$exports, "isHTMLElementClass", function() {
    return $fbe6f1e2fed97fc7$export$8eece510bcb9c62c;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$3e0a089cc13f69ad$exports, "tagNameOf", function() {
    return $fbe6f1e2fed97fc7$export$b8a1af58c024fefd;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$3e0a089cc13f69ad$exports, "isDOMReadOnly", function() {
    return $fbe6f1e2fed97fc7$export$a2cf0d4bb6e06de4;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$3e0a089cc13f69ad$exports, "parseDOM", function() {
    return $fbe6f1e2fed97fc7$export$d66b332881d9723f;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$3e0a089cc13f69ad$exports, "stringifyDOM", function() {
    return $fbe6f1e2fed97fc7$export$b0709844452f8b6b;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$3e0a089cc13f69ad$exports, "walkDOM", function() {
    return $fbe6f1e2fed97fc7$export$5118471ee5d5453b;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$3e0a089cc13f69ad$exports, "inViewport", function() {
    return $fbe6f1e2fed97fc7$export$6e196edbcc00e5bc;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$3e0a089cc13f69ad$exports, "getVisibleText", function() {
    return $fbe6f1e2fed97fc7$export$be4650432daa84fd;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$3e0a089cc13f69ad$exports, "splitPages", function() {
    return $fbe6f1e2fed97fc7$export$578e38b4a3e0b255;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$3e0a089cc13f69ad$exports, "importCSS", function() {
    return $fbe6f1e2fed97fc7$export$7cd14c57bbb84350;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$3e0a089cc13f69ad$exports, "stringifyCSS", function() {
    return $fbe6f1e2fed97fc7$export$5100419dfae0456d;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$3e0a089cc13f69ad$exports, "insertToCursor", function() {
    return $fbe6f1e2fed97fc7$export$28d9d24a8cd0ffc2;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$3e0a089cc13f69ad$exports, "scrollTo", function() {
    return $fbe6f1e2fed97fc7$export$3f99968195accfaf;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$3e0a089cc13f69ad$exports, "watchScroll", function() {
    return $fbe6f1e2fed97fc7$export$eafdbaa868ea9975;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$3e0a089cc13f69ad$exports, "watchVisible", function() {
    return $fbe6f1e2fed97fc7$export$36a0c1ca2ae264fa;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$3e0a089cc13f69ad$exports, "formToJSON", function() {
    return $fbe6f1e2fed97fc7$export$86d7c59254d6a2c9;
});
const $fbe6f1e2fed97fc7$export$f5a4056b78c72efa = {
    html: 'http://www.w3.org/1999/xhtml',
    svg: 'http://www.w3.org/2000/svg',
    math: 'http://www.w3.org/1998/Math/MathML'
};
const $fbe6f1e2fed97fc7$var$$3e0a089cc13f69ad$var$templateMap = {};
function $fbe6f1e2fed97fc7$export$2ee022bbbc550b25(tagName) {
    if ($fbe6f1e2fed97fc7$var$$3e0a089cc13f69ad$var$templateMap[tagName]) return $fbe6f1e2fed97fc7$var$$3e0a089cc13f69ad$var$templateMap[tagName];
    const spawn = document.createElement('template');
    spawn.innerHTML = `<${tagName} />`;
    return $fbe6f1e2fed97fc7$var$$3e0a089cc13f69ad$var$templateMap[tagName] = spawn.content.firstElementChild;
}
function $fbe6f1e2fed97fc7$export$a549dd5cef7f8327(tagName) {
    if (tagName.includes('-')) return 'html';
    const [prefix, localName] = tagName.split(':');
    if (localName) return prefix === 'html' ? 'html' : 'xml';
    const node = $fbe6f1e2fed97fc7$export$2ee022bbbc550b25(tagName);
    return node instanceof HTMLElement && !(node instanceof HTMLUnknownElement) ? 'html' : 'xml';
}
const $fbe6f1e2fed97fc7$export$8eece510bcb9c62c = (Class)=>$fbe6f1e2fed97fc7$export$170f4e08cad8229d(Class, HTMLElement);
const $fbe6f1e2fed97fc7$var$$3e0a089cc13f69ad$var$nameMap = new WeakMap();
function $fbe6f1e2fed97fc7$export$b8a1af58c024fefd(Class) {
    const name = $fbe6f1e2fed97fc7$var$$3e0a089cc13f69ad$var$nameMap.get(Class);
    if (name) return name;
    var { tagName: tagName } = new Class();
    $fbe6f1e2fed97fc7$var$$3e0a089cc13f69ad$var$nameMap.set(Class, tagName = tagName.toLowerCase());
    return tagName;
}
function $fbe6f1e2fed97fc7$export$a2cf0d4bb6e06de4(tagName, propertyName) {
    /**
     * fetch from https://html.spec.whatwg.org/
     */ const ReadOnly_Properties = [
        [
            HTMLLinkElement,
            [
                'sizes'
            ]
        ],
        [
            HTMLIFrameElement,
            [
                'sandbox'
            ]
        ],
        [
            HTMLObjectElement,
            [
                'form'
            ]
        ],
        [
            HTMLInputElement,
            [
                'form',
                'list'
            ]
        ],
        [
            HTMLButtonElement,
            [
                'form'
            ]
        ],
        [
            HTMLSelectElement,
            [
                'form'
            ]
        ],
        [
            HTMLTextAreaElement,
            [
                'form'
            ]
        ],
        [
            HTMLOutputElement,
            [
                'form'
            ]
        ],
        [
            HTMLFieldSetElement,
            [
                'form'
            ]
        ]
    ];
    const template = $fbe6f1e2fed97fc7$export$2ee022bbbc550b25(tagName);
    for (const [Class, keys] of ReadOnly_Properties)if (template instanceof Class && keys.includes(propertyName)) return true;
    return false;
}
function $fbe6f1e2fed97fc7$export$d66b332881d9723f(HTML) {
    const spawn = document.createElement('template');
    spawn.innerHTML = HTML;
    return [
        ...spawn.content.childNodes
    ].map((node)=>{
        node.remove();
        return node;
    });
}
const $fbe6f1e2fed97fc7$export$b0709844452f8b6b = (node)=>new XMLSerializer().serializeToString(node).replace(/ xmlns="http:\/\/www.w3.org\/1999\/xhtml"/g, '');
function* $fbe6f1e2fed97fc7$export$5118471ee5d5453b(root, type) {
    const children = [
        ...root.childNodes
    ];
    if ($fbe6f1e2fed97fc7$export$dd1bc94b04021eeb(type) || type === root.nodeType) yield root;
    for (const node of children)yield* $fbe6f1e2fed97fc7$export$5118471ee5d5453b(node, type);
}
function $fbe6f1e2fed97fc7$export$6e196edbcc00e5bc(element) {
    const { left: left, top: top } = element.getBoundingClientRect();
    return document.elementFromPoint(left, top) === element;
}
function $fbe6f1e2fed97fc7$export$be4650432daa84fd(root) {
    var text = '';
    for (const { nodeType: nodeType, parentElement: parentElement, nodeValue: nodeValue } of $fbe6f1e2fed97fc7$export$5118471ee5d5453b(root))if (nodeType === Node.TEXT_NODE && parentElement.getAttribute('aria-hidden') !== 'true') {
        const { width: width, height: height } = parentElement.getBoundingClientRect();
        if (width && height) text += nodeValue.trim().replace(/\s+/g, ' ');
    }
    return text;
}
function $fbe6f1e2fed97fc7$export$578e38b4a3e0b255({ offsetWidth: offsetWidth, children: children }, pageHeight = 841.89, pageWidth = 595.28) {
    const scrollHeight = pageHeight / pageWidth * offsetWidth;
    var offset = 0;
    return [
        ...children
    ].reduce((pages, node)=>{
        var { offsetTop: top, offsetHeight: height } = node;
        top += offset;
        var bottom = top + height;
        const bottomOffset = bottom / scrollHeight;
        const topIndex = ~~(top / scrollHeight), bottomIndex = ~~bottomOffset;
        if (topIndex !== bottomIndex) offset += height - bottomOffset;
        (pages[bottomIndex] ||= []).push(node);
        return pages;
    }, []);
}
function $fbe6f1e2fed97fc7$export$7cd14c57bbb84350(URI, { alternate: alternate, ...options } = {}) {
    const style = [
        ...document.styleSheets
    ].find(({ href: href })=>href === URI);
    if (style) return Promise.resolve(style);
    const link = document.createElement('link');
    return new Promise((resolve, reject)=>{
        link.onload = ()=>resolve(link.sheet);
        link.onerror = (_1, _2, _3, _4, error)=>reject(error);
        Object.assign(link, options);
        link.rel = (alternate ? 'alternate ' : '') + 'stylesheet';
        link.href = URI;
        document.head.append(link);
    });
}
function $fbe6f1e2fed97fc7$export$5100419dfae0456d(data, depth = 0, indent = '    ') {
    const padding = indent.repeat(depth);
    return Object.entries(data).map(([key, value])=>typeof value !== 'object' ? `${padding}${$fbe6f1e2fed97fc7$export$3f34ca2fef821bbd(key)}: ${value};` : `${padding}${key} {
${$fbe6f1e2fed97fc7$export$5100419dfae0456d(value, depth + 1, indent)}
${padding}}`).join('\n');
}
function $fbe6f1e2fed97fc7$export$28d9d24a8cd0ffc2(...nodes) {
    const fragment = document.createDocumentFragment();
    fragment.append(...nodes);
    for (const node of $fbe6f1e2fed97fc7$export$5118471ee5d5453b(fragment))if (![
        1,
        3,
        11
    ].includes(node.nodeType) || [
        'meta',
        'title',
        'link',
        'script'
    ].includes(node.nodeName.toLowerCase())) node.replaceWith(...node.childNodes);
    const selection = globalThis.getSelection();
    if (!selection) return;
    const range = selection.getRangeAt(0);
    range.deleteContents();
    range.insertNode(fragment);
}
function $fbe6f1e2fed97fc7$export$3f99968195accfaf(selector, root, align, justify) {
    const [_, ID] = /^#(.+)/.exec(selector) || [];
    if (ID === 'top') window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
    });
    else (root || document).querySelector(ID ? `[id="${ID}"]` : selector)?.scrollIntoView({
        behavior: 'smooth',
        block: align,
        inline: justify
    });
}
const $fbe6f1e2fed97fc7$export$eafdbaa868ea9975 = (box, handler, depth = 6)=>Array.from(box.querySelectorAll(Array.from(new Array(depth), (_, index)=>`h${++index}`) + ''), (header)=>{
        new IntersectionObserver(([item])=>{
            if (!item.isIntersecting) return;
            const target = item.target;
            handler({
                target: target,
                links: [
                    ...target.ownerDocument.querySelectorAll(`[href="#${target.id}"]`)
                ]
            });
        }).observe(header);
        if (!header.id.trim()) header.id = header.textContent.trim().replace(/\W+/g, '-');
        return {
            level: +header.tagName[1],
            id: header.id,
            text: header.textContent.trim()
        };
    });
function $fbe6f1e2fed97fc7$export$36a0c1ca2ae264fa(root, handler) {
    var last = document.visibilityState === 'visible' ? 1 : 0;
    function change(state) {
        if (state === 3 || last === 3) handler(state === 3);
        last = state;
    }
    new IntersectionObserver(([{ isIntersecting: isIntersecting }])=>change(isIntersecting ? last | 2 : last & 1)).observe(root);
    document.addEventListener('visibilitychange', ()=>change(document.visibilityState === 'visible' ? last | 1 : last & 2));
}
function $fbe6f1e2fed97fc7$export$86d7c59254d6a2c9(form) {
    const { elements: elements } = form, data = {};
    for (const field of elements){
        let { name: name, value: value, checked: checked, defaultValue: defaultValue, selectedOptions: selectedOptions, files: files } = field;
        const type = field.type;
        if (!name || value === '') continue;
        const box = type !== 'fieldset' && field.closest('fieldset');
        if (box && box !== form) continue;
        let parsedValue = value;
        switch(type){
            case 'radio':
            case 'checkbox':
                if (checked) parsedValue = !defaultValue || $fbe6f1e2fed97fc7$export$7ea17d45ecdcf634(defaultValue);
                else if ($fbe6f1e2fed97fc7$export$b5a4d6f439a5044d(elements.namedItem(name))) continue;
                else parsedValue = false;
                break;
            case 'select-multiple':
                parsedValue = Array.from(selectedOptions, ({ value: value })=>$fbe6f1e2fed97fc7$export$7ea17d45ecdcf634(value));
                break;
            case 'fieldset':
                parsedValue = $fbe6f1e2fed97fc7$export$86d7c59254d6a2c9(field);
                break;
            case 'file':
                parsedValue = files && Array.from(files);
                break;
            case 'date':
            case 'datetime-local':
            case 'month':
            case 'hidden':
            case 'number':
            case 'range':
            case 'select-one':
                parsedValue = $fbe6f1e2fed97fc7$export$7ea17d45ecdcf634(value);
        }
        if (name in data) data[name] = [].concat(data[name], parsedValue);
        else data[name] = !(parsedValue instanceof Array) || !$fbe6f1e2fed97fc7$export$dd1bc94b04021eeb(parsedValue[1]) ? parsedValue : parsedValue[0];
    }
    return data;
}
var $fbe6f1e2fed97fc7$var$$bb23e0c794fefbef$exports = {};
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$bb23e0c794fefbef$exports, "sleep", function() {
    return $fbe6f1e2fed97fc7$export$e772c8ff12451969;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$bb23e0c794fefbef$exports, "asyncLoop", function() {
    return $fbe6f1e2fed97fc7$export$57207d71b8c929c8;
});
function $fbe6f1e2fed97fc7$export$e772c8ff12451969(seconds = 1) {
    return new Promise((resolve)=>setTimeout(resolve, seconds * 1000));
}
function $fbe6f1e2fed97fc7$export$57207d71b8c929c8(executor, seconds = 1) {
    var stop = false;
    (async ()=>{
        while(!stop){
            const result = executor();
            if (result instanceof Promise) await result;
            await $fbe6f1e2fed97fc7$export$e772c8ff12451969(seconds);
        }
    })();
    return ()=>stop = true;
}
var $fbe6f1e2fed97fc7$var$$19ed8aeb7905a045$exports = {};
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$19ed8aeb7905a045$exports, "delegate", function() {
    return $fbe6f1e2fed97fc7$export$10b1921597150314;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$19ed8aeb7905a045$exports, "documentReady", function() {
    return $fbe6f1e2fed97fc7$export$3e2b244719956741;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$19ed8aeb7905a045$exports, "promisify", function() {
    return $fbe6f1e2fed97fc7$export$1d1d2ed6b55cf67f;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$19ed8aeb7905a045$exports, "createMessageServer", function() {
    return $fbe6f1e2fed97fc7$export$2155c0b5a4b77fb8;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$19ed8aeb7905a045$exports, "createMessageClient", function() {
    return $fbe6f1e2fed97fc7$export$9d97473344489dfc;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$19ed8aeb7905a045$exports, "serviceWorkerUpdate", function() {
    return $fbe6f1e2fed97fc7$export$d635d04af3887bbe;
});
function $fbe6f1e2fed97fc7$export$10b1921597150314(selector, handler) {
    return function(event) {
        var node, path = event.composedPath();
        while((node = path.shift()) && node !== event.currentTarget)if (node instanceof HTMLElement && node.matches(selector)) return handler.call(this, event, node, event.detail);
    };
}
const $fbe6f1e2fed97fc7$export$3e2b244719956741 = typeof window !== 'undefined' ? new Promise((resolve)=>{
    function done() {
        document?.removeEventListener('DOMContentLoaded', done);
        window.removeEventListener('load', done);
        resolve();
    }
    document?.addEventListener('DOMContentLoaded', done);
    window.addEventListener('load', done);
    setTimeout(function check() {
        document?.readyState === 'complete' ? resolve() : setTimeout(check);
    });
}) : Promise.resolve();
function $fbe6f1e2fed97fc7$export$1d1d2ed6b55cf67f(scope, element) {
    return new Promise((resolve, reject)=>{
        function end(event) {
            resolve(event), clean();
        }
        function cancel(event) {
            reject(event), clean();
        }
        function clean() {
            element.removeEventListener(scope + 'end', end);
            element.removeEventListener(scope + 'cancel', cancel);
        }
        element.addEventListener(scope + 'end', end);
        element.addEventListener(scope + 'cancel', cancel);
    });
}
function $fbe6f1e2fed97fc7$export$2155c0b5a4b77fb8(handlers) {
    async function server({ data: { type: type, id: id, ...data }, source: source, origin: origin }) {
        var result = handlers[type]?.(data);
        if (result instanceof Promise) result = await result;
        // @ts-ignore
        source.postMessage({
            ...result,
            id: id
        }, origin);
    }
    globalThis.addEventListener('message', server);
    return ()=>globalThis.removeEventListener('message', server);
}
function $fbe6f1e2fed97fc7$export$9d97473344489dfc(target, origin = '*') {
    return (type, data)=>new Promise((resolve)=>{
            const UID = $fbe6f1e2fed97fc7$export$89912e019eef22aa();
            function handler({ data: { id: id, ...data } }) {
                if (id !== UID) return;
                resolve(data);
                globalThis.removeEventListener('message', handler);
            }
            globalThis.addEventListener('message', handler);
            // @ts-ignore
            target.postMessage({
                id: UID,
                type: type,
                ...data
            }, origin);
        });
}
function $fbe6f1e2fed97fc7$export$d635d04af3887bbe(registration) {
    return new Promise((resolve)=>{
        if (registration.waiting) return resolve(registration.waiting);
        registration.onupdatefound = ()=>registration.installing?.addEventListener('statechange', function() {
                if (this.state === 'installed' && navigator.serviceWorker.controller) resolve(this);
            });
    });
}
var $fbe6f1e2fed97fc7$var$$7a08303ce13c49c5$exports = {};
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$7a08303ce13c49c5$exports, "PageVector", function() {
    return $fbe6f1e2fed97fc7$export$1b88f6b6d432a52a;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$7a08303ce13c49c5$exports, "getSwipeVector", function() {
    return $fbe6f1e2fed97fc7$export$b70f6380221b1350;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$7a08303ce13c49c5$exports, "durationOf", function() {
    return $fbe6f1e2fed97fc7$export$75d6cbe4503e149;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$7a08303ce13c49c5$exports, "watchMotion", function() {
    return $fbe6f1e2fed97fc7$export$b2618d51188815c2;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$7a08303ce13c49c5$exports, "transitIn", function() {
    return $fbe6f1e2fed97fc7$export$490814474ddbb428;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$7a08303ce13c49c5$exports, "animateIn", function() {
    return $fbe6f1e2fed97fc7$export$3ea201dffb50dfef;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$7a08303ce13c49c5$exports, "transitOut", function() {
    return $fbe6f1e2fed97fc7$export$d1012c7198c6b460;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$7a08303ce13c49c5$exports, "animateOut", function() {
    return $fbe6f1e2fed97fc7$export$a35a418b7b17958e;
});
class $fbe6f1e2fed97fc7$export$1b88f6b6d432a52a {
    constructor(from, to){
        this.from = from;
        this.to = to;
    }
    get length() {
        const { from: from, to: to } = this;
        return Math.sqrt(Math.pow(to.x - from.x, 2) + Math.pow(to.y - from.y, 2) + (to.z != null ? Math.pow(to.z - from.z, 2) : 0));
    }
    get direction() {
        const { from: from, to: to } = this;
        const XD = to.x - from.x, YD = to.y - from.y, ZD = to.z - from.z;
        const XL = Math.abs(XD), YL = Math.abs(YD), ZL = Math.abs(ZD);
        switch(isNaN(ZL) ? Math.max(XL, YL) : Math.max(XL, YL, ZL)){
            case XL:
                return XD > 0 ? 'right' : 'left';
            case YL:
                return YD > 0 ? 'forward' : 'backward';
            case ZL:
                return ZD > 0 ? 'up' : 'down';
        }
    }
}
function $fbe6f1e2fed97fc7$export$b70f6380221b1350(from, to, threshold = parseInt(getComputedStyle(document.body).fontSize) * 6) {
    const vector = new $fbe6f1e2fed97fc7$export$1b88f6b6d432a52a(from, to);
    if (vector.length >= threshold && !getSelection()?.toString().trim()) return vector;
}
function $fbe6f1e2fed97fc7$export$75d6cbe4503e149(type, element) {
    const { transitionDuration: transitionDuration, animationDuration: animationDuration } = getComputedStyle(element);
    const duration = type === 'animation' ? animationDuration : transitionDuration;
    return parseFloat(duration) * (duration.slice(-2) === 'ms' ? 1 : 1000);
}
function $fbe6f1e2fed97fc7$export$b2618d51188815c2(type, element) {
    return Promise.race([
        $fbe6f1e2fed97fc7$export$1d1d2ed6b55cf67f(type, element).catch((event)=>Promise.resolve(event)),
        new Promise((resolve)=>setTimeout(resolve, $fbe6f1e2fed97fc7$export$75d6cbe4503e149(type, element)))
    ]);
}
function $fbe6f1e2fed97fc7$var$$7a08303ce13c49c5$var$fadeIn(type, element, className, display) {
    element.style.display = display;
    const end = $fbe6f1e2fed97fc7$export$b2618d51188815c2(type, element);
    return new Promise((resolve)=>requestAnimationFrame(()=>{
            element.classList.add(className);
            end.then(resolve);
        }));
}
async function $fbe6f1e2fed97fc7$var$$7a08303ce13c49c5$var$fadeOut(type, element, className, remove) {
    const end = $fbe6f1e2fed97fc7$export$b2618d51188815c2(type, element);
    element.classList.remove(className);
    await end;
    if (remove) element.remove();
    else element.style.display = 'none';
}
function $fbe6f1e2fed97fc7$export$490814474ddbb428(element, className, display = 'block') {
    return $fbe6f1e2fed97fc7$var$$7a08303ce13c49c5$var$fadeIn('transition', element, className, display);
}
function $fbe6f1e2fed97fc7$export$3ea201dffb50dfef(element, className, display = 'block') {
    return $fbe6f1e2fed97fc7$var$$7a08303ce13c49c5$var$fadeIn('animation', element, className, display);
}
function $fbe6f1e2fed97fc7$export$d1012c7198c6b460(element, className, remove) {
    return $fbe6f1e2fed97fc7$var$$7a08303ce13c49c5$var$fadeOut('transition', element, className, remove);
}
function $fbe6f1e2fed97fc7$export$a35a418b7b17958e(element, className, remove) {
    return $fbe6f1e2fed97fc7$var$$7a08303ce13c49c5$var$fadeOut('animation', element, className, remove);
}
var $fbe6f1e2fed97fc7$var$$69bd9f0117925302$exports = {};
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$69bd9f0117925302$exports, "describe", function() {
    return $fbe6f1e2fed97fc7$export$cd5450f3a47e3789;
});
$fbe6f1e2fed97fc7$var$$parcel$export($fbe6f1e2fed97fc7$var$$69bd9f0117925302$exports, "it", function() {
    return $fbe6f1e2fed97fc7$export$3486a10f30cf1ee4;
});
async function $fbe6f1e2fed97fc7$export$cd5450f3a47e3789(title, cases) {
    console.log(title);
    console.time(title);
    await cases();
    console.timeEnd(title);
}
async function $fbe6f1e2fed97fc7$export$3486a10f30cf1ee4(title, userCase, secondsOut = 3) {
    title = '    ' + title;
    console.time(title);
    const expect = (status)=>{
        const assert = typeof status === 'function' ? status : undefined;
        status = assert?.() ?? status;
        if (!status) throw new Error(`Assertion failed: ${title}\n\n${assert || ''}`);
    };
    const timeOut = ()=>$fbe6f1e2fed97fc7$export$e772c8ff12451969(secondsOut).then(()=>Promise.reject(new RangeError('Timed out')));
    try {
        return await Promise.race([
            userCase(expect),
            timeOut()
        ]);
    } finally{
        console.timeEnd(title);
    }
}



var $d5I5D = parcelRequire("d5I5D");

var $N3oW3 = parcelRequire("N3oW3");
function $30c53faf8d313331$export$882461b6382ed46c(container) {
    return {
        // eslint-disable-next-line
        render: function(children) {
            (0, $N3oW3.render)(children, container);
        },
        // eslint-disable-next-line
        unmount: function() {
            (0, $N3oW3.unmountComponentAtNode)(container);
        }
    };
}
function $30c53faf8d313331$export$757ceba2d55c277e(container, children) {
    (0, $N3oW3.hydrate)(children, container);
    return $30c53faf8d313331$export$882461b6382ed46c(container);
}
var $30c53faf8d313331$export$2e2bcd8739ae039 = {
    createRoot: $30c53faf8d313331$export$882461b6382ed46c,
    hydrateRoot: $30c53faf8d313331$export$757ceba2d55c277e
};


function $f832eddb67ceeced$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $0b6d020adfe2b5fb$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $f832eddb67ceeced$export$2e2bcd8739ae039)(r);
}


function $165ffe990f52ff5d$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}



function $14c3211dd7044622$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $f832eddb67ceeced$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $f832eddb67ceeced$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $a5b521203e616efd$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $3746fb019e1f2ee5$export$2e2bcd8739ae039(r) {
    return (0, $0b6d020adfe2b5fb$export$2e2bcd8739ae039)(r) || (0, $165ffe990f52ff5d$export$2e2bcd8739ae039)(r) || (0, $14c3211dd7044622$export$2e2bcd8739ae039)(r) || (0, $a5b521203e616efd$export$2e2bcd8739ae039)();
}



var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");

const $77c6df01f18c5b91$var$MARK = '__rc_react_root__';
function $77c6df01f18c5b91$export$b3890eb0ae9dca99(node, container) {
    const root = container[$77c6df01f18c5b91$var$MARK] || (0, $30c53faf8d313331$export$882461b6382ed46c)(container);
    root.render(node);
    container[$77c6df01f18c5b91$var$MARK] = root;
}
async function $77c6df01f18c5b91$export$121e2d597d222bad(container) {
    // Delay to unmount to avoid React 18 sync warning
    return Promise.resolve().then(()=>{
        container[$77c6df01f18c5b91$var$MARK]?.unmount();
        delete container[$77c6df01f18c5b91$var$MARK];
    });
}



var $N3oW3 = parcelRequire("N3oW3");
const $ce1a14c8d222cf48$export$264c6064649f9206 = /*#__PURE__*/ (0, $N3oW3.default).createContext({});
const $ce1a14c8d222cf48$var$AppContext = /*#__PURE__*/ (0, $N3oW3.default).createContext({
    message: {},
    notification: {},
    modal: {}
});
var $ce1a14c8d222cf48$export$2e2bcd8739ae039 = $ce1a14c8d222cf48$var$AppContext;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $265e8c0f7074eb72$var$murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}
var $265e8c0f7074eb72$export$2e2bcd8739ae039 = $265e8c0f7074eb72$var$murmur2;


function $bfbc54ac1ac0215e$export$2e2bcd8739ae039() {
    return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}


function $aeb2093ab4befe56$export$2e2bcd8739ae039(root, n) {
    if (!root) return false;
    // Use native if support
    if (root.contains) return root.contains(n);
    // `document.contains` not support with IE11
    let node = n;
    while(node){
        if (node === root) return true;
        node = node.parentNode;
    }
    return false;
}


const $275621885d66fa13$var$APPEND_ORDER = 'data-rc-order';
const $275621885d66fa13$var$APPEND_PRIORITY = 'data-rc-priority';
const $275621885d66fa13$var$MARK_KEY = `rc-util-key`;
const $275621885d66fa13$var$containerCache = new Map();
function $275621885d66fa13$var$getMark({ mark: mark } = {}) {
    if (mark) return mark.startsWith('data-') ? mark : `data-${mark}`;
    return $275621885d66fa13$var$MARK_KEY;
}
function $275621885d66fa13$var$getContainer(option) {
    if (option.attachTo) return option.attachTo;
    const head = document.querySelector('head');
    return head || document.body;
}
function $275621885d66fa13$var$getOrder(prepend) {
    if (prepend === 'queue') return 'prependQueue';
    return prepend ? 'prepend' : 'append';
}
/**
 * Find style which inject by rc-util
 */ function $275621885d66fa13$var$findStyles(container) {
    return Array.from(($275621885d66fa13$var$containerCache.get(container) || container).children).filter((node)=>node.tagName === 'STYLE');
}
function $275621885d66fa13$export$1ab5838465dbd10a(css, option = {}) {
    if (!(0, $bfbc54ac1ac0215e$export$2e2bcd8739ae039)()) return null;
    const { csp: csp, prepend: prepend, priority: priority = 0 } = option;
    const mergedOrder = $275621885d66fa13$var$getOrder(prepend);
    const isPrependQueue = mergedOrder === 'prependQueue';
    const styleNode = document.createElement('style');
    styleNode.setAttribute($275621885d66fa13$var$APPEND_ORDER, mergedOrder);
    if (isPrependQueue && priority) styleNode.setAttribute($275621885d66fa13$var$APPEND_PRIORITY, `${priority}`);
    if (csp?.nonce) styleNode.nonce = csp?.nonce;
    styleNode.innerHTML = css;
    const container = $275621885d66fa13$var$getContainer(option);
    const { firstChild: firstChild } = container;
    if (prepend) {
        // If is queue `prepend`, it will prepend first style and then append rest style
        if (isPrependQueue) {
            const existStyle = (option.styles || $275621885d66fa13$var$findStyles(container)).filter((node)=>{
                // Ignore style which not injected by rc-util with prepend
                if (![
                    'prepend',
                    'prependQueue'
                ].includes(node.getAttribute($275621885d66fa13$var$APPEND_ORDER))) return false;
                // Ignore style which priority less then new style
                const nodePriority = Number(node.getAttribute($275621885d66fa13$var$APPEND_PRIORITY) || 0);
                return priority >= nodePriority;
            });
            if (existStyle.length) {
                container.insertBefore(styleNode, existStyle[existStyle.length - 1].nextSibling);
                return styleNode;
            }
        }
        // Use `insertBefore` as `prepend`
        container.insertBefore(styleNode, firstChild);
    } else container.appendChild(styleNode);
    return styleNode;
}
function $275621885d66fa13$var$findExistNode(key, option = {}) {
    let { styles: styles } = option;
    styles ||= $275621885d66fa13$var$findStyles($275621885d66fa13$var$getContainer(option));
    return styles.find((node)=>node.getAttribute($275621885d66fa13$var$getMark(option)) === key);
}
function $275621885d66fa13$export$2232e336aecaa80a(key, option = {}) {
    const existNode = $275621885d66fa13$var$findExistNode(key, option);
    if (existNode) {
        const container = $275621885d66fa13$var$getContainer(option);
        container.removeChild(existNode);
    }
}
/**
 * qiankun will inject `appendChild` to insert into other
 */ function $275621885d66fa13$var$syncRealContainer(container, option) {
    const cachedRealContainer = $275621885d66fa13$var$containerCache.get(container);
    // Find real container when not cached or cached container removed
    if (!cachedRealContainer || !(0, $aeb2093ab4befe56$export$2e2bcd8739ae039)(document, cachedRealContainer)) {
        const placeholderStyle = $275621885d66fa13$export$1ab5838465dbd10a('', option);
        const { parentNode: parentNode } = placeholderStyle;
        $275621885d66fa13$var$containerCache.set(container, parentNode);
        container.removeChild(placeholderStyle);
    }
}
function $275621885d66fa13$export$f80df667f2f5a272() {
    $275621885d66fa13$var$containerCache.clear();
}
function $275621885d66fa13$export$4d99a2890bb989f0(css, key, originOption = {}) {
    const container = $275621885d66fa13$var$getContainer(originOption);
    const styles = $275621885d66fa13$var$findStyles(container);
    const option = {
        ...originOption,
        styles: styles
    };
    // Sync real parent
    $275621885d66fa13$var$syncRealContainer(container, option);
    const existNode = $275621885d66fa13$var$findExistNode(key, option);
    if (existNode) {
        if (option.csp?.nonce && existNode.nonce !== option.csp?.nonce) existNode.nonce = option.csp?.nonce;
        if (existNode.innerHTML !== css) existNode.innerHTML = css;
        return existNode;
    }
    const newNode = $275621885d66fa13$export$1ab5838465dbd10a(css, option);
    newNode.setAttribute($275621885d66fa13$var$getMark(option), key);
    return newNode;
}


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
function $7b0442ce5e42625c$export$2e2bcd8739ae039(getValue, condition, shouldUpdate) {
    const cacheRef = $32rMB.useRef({});
    if (!('value' in cacheRef.current) || shouldUpdate(cacheRef.current.condition, condition)) {
        cacheRef.current.value = getValue();
        cacheRef.current.condition = condition;
    }
    return cacheRef.current.value;
}


/* eslint-disable no-console */ let $6591254ed6bd1058$var$warned = {};
const $6591254ed6bd1058$var$preWarningFns = [];
const $6591254ed6bd1058$export$61616f168f0e5a05 = (fn)=>{
    $6591254ed6bd1058$var$preWarningFns.push(fn);
};
function $6591254ed6bd1058$export$491112666e282270(valid, message) {}
function $6591254ed6bd1058$export$a92e4c44d367d0af(valid, message) {}
function $6591254ed6bd1058$export$60eef1277fe463e4() {
    $6591254ed6bd1058$var$warned = {};
}
function $6591254ed6bd1058$export$848feb93d8f32b9b(method, valid, message) {
    if (!valid && !$6591254ed6bd1058$var$warned[message]) {
        method(false, message);
        $6591254ed6bd1058$var$warned[message] = true;
    }
}
function $6591254ed6bd1058$export$82934adf09101657(valid, message) {
    $6591254ed6bd1058$export$848feb93d8f32b9b($6591254ed6bd1058$export$491112666e282270, valid, message);
}
function $6591254ed6bd1058$export$89ff31684837bbbf(valid, message) {
    $6591254ed6bd1058$export$848feb93d8f32b9b($6591254ed6bd1058$export$a92e4c44d367d0af, valid, message);
}
$6591254ed6bd1058$export$82934adf09101657.preMessage = $6591254ed6bd1058$export$61616f168f0e5a05;
$6591254ed6bd1058$export$82934adf09101657.resetWarned = $6591254ed6bd1058$export$60eef1277fe463e4;
$6591254ed6bd1058$export$82934adf09101657.noteOnce = $6591254ed6bd1058$export$89ff31684837bbbf;
var $6591254ed6bd1058$export$2e2bcd8739ae039 = $6591254ed6bd1058$export$82934adf09101657;


/**
 * Deeply compares two object literals.
 * @param obj1 object 1
 * @param obj2 object 2
 * @param shallow shallow compare
 * @returns
 */ function $5582f7991b7cfce3$var$isEqual(obj1, obj2, shallow = false) {
    // https://github.com/mapbox/mapbox-gl-js/pull/5979/files#diff-fde7145050c47cc3a306856efd5f9c3016e86e859de9afbd02c879be5067e58f
    const refSet = new Set();
    function deepEqual(a, b, level = 1) {
        const circular = refSet.has(a);
        (0, $6591254ed6bd1058$export$2e2bcd8739ae039)(!circular, 'Warning: There may be circular references');
        if (circular) return false;
        if (a === b) return true;
        if (shallow && level > 1) return false;
        refSet.add(a);
        const newLevel = level + 1;
        if (Array.isArray(a)) {
            if (!Array.isArray(b) || a.length !== b.length) return false;
            for(let i = 0; i < a.length; i++){
                if (!deepEqual(a[i], b[i], newLevel)) return false;
            }
            return true;
        }
        if (a && b && typeof a === 'object' && typeof b === 'object') {
            const keys = Object.keys(a);
            if (keys.length !== Object.keys(b).length) return false;
            return keys.every((key)=>deepEqual(a[key], b[key], newLevel));
        }
        // other
        return false;
    }
    return deepEqual(obj1, obj2);
}
var $5582f7991b7cfce3$export$2e2bcd8739ae039 = $5582f7991b7cfce3$var$isEqual;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");
// [times, realValue]
const $032fd3278bed04bc$var$SPLIT = '%';
function $032fd3278bed04bc$export$1d14e1d8187b9aad(keys) {
    return keys.join($032fd3278bed04bc$var$SPLIT);
}
/** Record update id for extract static style order. */ let $032fd3278bed04bc$var$updateId = 0;
class $032fd3278bed04bc$var$Entity {
    instanceId;
    constructor(instanceId){
        this.instanceId = instanceId;
    }
    /** @private Internal cache map. Do not access this directly */ cache = new Map();
    /** @private Record update times for each key */ updateTimes = new Map();
    extracted = new Set();
    get(keys) {
        return this.opGet($032fd3278bed04bc$export$1d14e1d8187b9aad(keys));
    }
    /** A fast get cache with `get` concat. */ opGet(keyPathStr) {
        return this.cache.get(keyPathStr) || null;
    }
    update(keys, valueFn) {
        return this.opUpdate($032fd3278bed04bc$export$1d14e1d8187b9aad(keys), valueFn);
    }
    /** A fast get cache with `get` concat. */ opUpdate(keyPathStr, valueFn) {
        const prevValue = this.cache.get(keyPathStr);
        const nextValue = valueFn(prevValue);
        if (nextValue === null) {
            this.cache.delete(keyPathStr);
            this.updateTimes.delete(keyPathStr);
        } else {
            this.cache.set(keyPathStr, nextValue);
            this.updateTimes.set(keyPathStr, $032fd3278bed04bc$var$updateId);
            $032fd3278bed04bc$var$updateId += 1;
        }
    }
}
var $032fd3278bed04bc$export$2e2bcd8739ae039 = $032fd3278bed04bc$var$Entity;


const $cdaa75e461ec69af$export$3a1a912fd9fd3325 = {};
const $cdaa75e461ec69af$var$transform = $cdaa75e461ec69af$export$3a1a912fd9fd3325;
var $cdaa75e461ec69af$export$2e2bcd8739ae039 = $cdaa75e461ec69af$var$transform;


const $c756b57cbfcd44a7$export$5d99297dcd5476ac = 'data-token-hash';
const $c756b57cbfcd44a7$export$89ce1123b3c0bd9e = 'data-css-hash';
const $c756b57cbfcd44a7$export$36f8a6c9fa24262a = 'data-cache-path';
const $c756b57cbfcd44a7$export$4c16a0c02134a7dc = '__cssinjs_instance__';
function $c756b57cbfcd44a7$export$cf6fa0bbcc94b912() {
    const cssinjsInstanceId = Math.random().toString(12).slice(2);
    // Tricky SSR: Move all inline style to the head.
    // PS: We do not recommend tricky mode.
    if (typeof document !== 'undefined' && document.head && document.body) {
        const styles = document.body.querySelectorAll(`style[${$c756b57cbfcd44a7$export$89ce1123b3c0bd9e}]`) || [];
        const { firstChild: firstChild } = document.head;
        Array.from(styles).forEach((style)=>{
            style[$c756b57cbfcd44a7$export$4c16a0c02134a7dc] = style[$c756b57cbfcd44a7$export$4c16a0c02134a7dc] || cssinjsInstanceId;
            // Not force move if no head
            if (style[$c756b57cbfcd44a7$export$4c16a0c02134a7dc] === cssinjsInstanceId) document.head.insertBefore(style, firstChild);
        });
        // Deduplicate of moved styles
        const styleHash = {};
        Array.from(document.querySelectorAll(`style[${$c756b57cbfcd44a7$export$89ce1123b3c0bd9e}]`)).forEach((style)=>{
            const hash = style.getAttribute($c756b57cbfcd44a7$export$89ce1123b3c0bd9e);
            if (styleHash[hash]) {
                if (style[$c756b57cbfcd44a7$export$4c16a0c02134a7dc] === cssinjsInstanceId) style.parentNode?.removeChild(style);
            } else styleHash[hash] = true;
        });
    }
    return new (0, $032fd3278bed04bc$export$2e2bcd8739ae039)(cssinjsInstanceId);
}
const $c756b57cbfcd44a7$var$StyleContext = /*#__PURE__*/ $hO8yS.createContext({
    hashPriority: 'low',
    cache: $c756b57cbfcd44a7$export$cf6fa0bbcc94b912(),
    defaultCache: true,
    autoPrefix: false
});
const $c756b57cbfcd44a7$export$6aedb87c7b665270 = (props)=>{
    const { children: children, ...restProps } = props;
    const parentContext = $32rMB.useContext($c756b57cbfcd44a7$var$StyleContext);
    const context = (0, $7b0442ce5e42625c$export$2e2bcd8739ae039)(()=>{
        const mergedContext = {
            ...parentContext
        };
        Object.keys(restProps).forEach((key)=>{
            const value = restProps[key];
            if (restProps[key] !== undefined) mergedContext[key] = value;
        });
        const { cache: cache, transformers: transformers = [] } = restProps;
        mergedContext.cache = mergedContext.cache || $c756b57cbfcd44a7$export$cf6fa0bbcc94b912();
        mergedContext.defaultCache = !cache && parentContext.defaultCache;
        // autoPrefix
        if (transformers.includes((0, $cdaa75e461ec69af$export$3a1a912fd9fd3325))) mergedContext.autoPrefix = true;
        return mergedContext;
    }, [
        parentContext,
        restProps
    ], (prev, next)=>!(0, $5582f7991b7cfce3$export$2e2bcd8739ae039)(prev[0], next[0], true) || !(0, $5582f7991b7cfce3$export$2e2bcd8739ae039)(prev[1], next[1], true));
    return /*#__PURE__*/ $hO8yS.createElement($c756b57cbfcd44a7$var$StyleContext.Provider, {
        value: context
    }, children);
};
var $c756b57cbfcd44a7$export$2e2bcd8739ae039 = $c756b57cbfcd44a7$var$StyleContext;






class $d10f98a0dd120d2f$var$AbstractCalculator {
}
var $d10f98a0dd120d2f$export$2e2bcd8739ae039 = $d10f98a0dd120d2f$var$AbstractCalculator;


const $09fedde6ca986b89$var$CALC_UNIT = 'CALC_UNIT';
const $09fedde6ca986b89$var$regexp = new RegExp($09fedde6ca986b89$var$CALC_UNIT, 'g');
function $09fedde6ca986b89$var$unit(value) {
    if (typeof value === 'number') return `${value}${$09fedde6ca986b89$var$CALC_UNIT}`;
    return value;
}
class $09fedde6ca986b89$export$2e2bcd8739ae039 extends (0, $d10f98a0dd120d2f$export$2e2bcd8739ae039) {
    result = '';
    unitlessCssVar;
    lowPriority;
    constructor(num, unitlessCssVar){
        super();
        const numType = typeof num;
        this.unitlessCssVar = unitlessCssVar;
        if (num instanceof $09fedde6ca986b89$export$2e2bcd8739ae039) this.result = `(${num.result})`;
        else if (numType === 'number') this.result = $09fedde6ca986b89$var$unit(num);
        else if (numType === 'string') this.result = num;
    }
    add(num) {
        if (num instanceof $09fedde6ca986b89$export$2e2bcd8739ae039) this.result = `${this.result} + ${num.getResult()}`;
        else if (typeof num === 'number' || typeof num === 'string') this.result = `${this.result} + ${$09fedde6ca986b89$var$unit(num)}`;
        this.lowPriority = true;
        return this;
    }
    sub(num) {
        if (num instanceof $09fedde6ca986b89$export$2e2bcd8739ae039) this.result = `${this.result} - ${num.getResult()}`;
        else if (typeof num === 'number' || typeof num === 'string') this.result = `${this.result} - ${$09fedde6ca986b89$var$unit(num)}`;
        this.lowPriority = true;
        return this;
    }
    mul(num) {
        if (this.lowPriority) this.result = `(${this.result})`;
        if (num instanceof $09fedde6ca986b89$export$2e2bcd8739ae039) this.result = `${this.result} * ${num.getResult(true)}`;
        else if (typeof num === 'number' || typeof num === 'string') this.result = `${this.result} * ${num}`;
        this.lowPriority = false;
        return this;
    }
    div(num) {
        if (this.lowPriority) this.result = `(${this.result})`;
        if (num instanceof $09fedde6ca986b89$export$2e2bcd8739ae039) this.result = `${this.result} / ${num.getResult(true)}`;
        else if (typeof num === 'number' || typeof num === 'string') this.result = `${this.result} / ${num}`;
        this.lowPriority = false;
        return this;
    }
    getResult(force) {
        return this.lowPriority || force ? `(${this.result})` : this.result;
    }
    equal(options) {
        const { unit: cssUnit } = options || {};
        let mergedUnit = true;
        if (typeof cssUnit === 'boolean') mergedUnit = cssUnit;
        else if (Array.from(this.unitlessCssVar).some((cssVar)=>this.result.includes(cssVar))) mergedUnit = false;
        this.result = this.result.replace($09fedde6ca986b89$var$regexp, mergedUnit ? 'px' : '');
        if (typeof this.lowPriority !== 'undefined') return `calc(${this.result})`;
        return this.result;
    }
}



class $28873b54e767adfb$export$2e2bcd8739ae039 extends (0, $d10f98a0dd120d2f$export$2e2bcd8739ae039) {
    result = 0;
    constructor(num){
        super();
        if (num instanceof $28873b54e767adfb$export$2e2bcd8739ae039) this.result = num.result;
        else if (typeof num === 'number') this.result = num;
    }
    add(num) {
        if (num instanceof $28873b54e767adfb$export$2e2bcd8739ae039) this.result += num.result;
        else if (typeof num === 'number') this.result += num;
        return this;
    }
    sub(num) {
        if (num instanceof $28873b54e767adfb$export$2e2bcd8739ae039) this.result -= num.result;
        else if (typeof num === 'number') this.result -= num;
        return this;
    }
    mul(num) {
        if (num instanceof $28873b54e767adfb$export$2e2bcd8739ae039) this.result *= num.result;
        else if (typeof num === 'number') this.result *= num;
        return this;
    }
    div(num) {
        if (num instanceof $28873b54e767adfb$export$2e2bcd8739ae039) this.result /= num.result;
        else if (typeof num === 'number') this.result /= num;
        return this;
    }
    equal() {
        return this.result;
    }
}


const $6319830bc6092827$var$genCalc = (type, unitlessCssVar)=>{
    const Calculator = type === 'css' ? (0, $09fedde6ca986b89$export$2e2bcd8739ae039) : (0, $28873b54e767adfb$export$2e2bcd8739ae039);
    return (num)=>new Calculator(num, unitlessCssVar);
};
var $6319830bc6092827$export$2e2bcd8739ae039 = $6319830bc6092827$var$genCalc;


// ================================== Cache ==================================
function $60942ef712741889$export$dd65e95e99ed0739(left, right) {
    if (left.length !== right.length) return false;
    for(let i = 0; i < left.length; i++){
        if (left[i] !== right[i]) return false;
    }
    return true;
}
class $60942ef712741889$export$2e2bcd8739ae039 {
    static MAX_CACHE_SIZE = 20;
    static MAX_CACHE_OFFSET = 5;
    cache;
    keys;
    cacheCallTimes;
    constructor(){
        this.cache = new Map();
        this.keys = [];
        this.cacheCallTimes = 0;
    }
    size() {
        return this.keys.length;
    }
    internalGet(derivativeOption, updateCallTimes = false) {
        let cache = {
            map: this.cache
        };
        derivativeOption.forEach((derivative)=>{
            if (!cache) cache = undefined;
            else cache = cache?.map?.get(derivative);
        });
        if (cache?.value && updateCallTimes) cache.value[1] = this.cacheCallTimes++;
        return cache?.value;
    }
    get(derivativeOption) {
        return this.internalGet(derivativeOption, true)?.[0];
    }
    has(derivativeOption) {
        return !!this.internalGet(derivativeOption);
    }
    set(derivativeOption, value) {
        // New cache
        if (!this.has(derivativeOption)) {
            if (this.size() + 1 > $60942ef712741889$export$2e2bcd8739ae039.MAX_CACHE_SIZE + $60942ef712741889$export$2e2bcd8739ae039.MAX_CACHE_OFFSET) {
                const [targetKey] = this.keys.reduce((result, key)=>{
                    const [, callTimes] = result;
                    if (this.internalGet(key)[1] < callTimes) return [
                        key,
                        this.internalGet(key)[1]
                    ];
                    return result;
                }, [
                    this.keys[0],
                    this.cacheCallTimes
                ]);
                this.delete(targetKey);
            }
            this.keys.push(derivativeOption);
        }
        let cache = this.cache;
        derivativeOption.forEach((derivative, index)=>{
            if (index === derivativeOption.length - 1) cache.set(derivative, {
                value: [
                    value,
                    this.cacheCallTimes++
                ]
            });
            else {
                const cacheValue = cache.get(derivative);
                if (!cacheValue) cache.set(derivative, {
                    map: new Map()
                });
                else if (!cacheValue.map) cacheValue.map = new Map();
                cache = cache.get(derivative).map;
            }
        });
    }
    deleteByPath(currentCache, derivatives) {
        const cache = currentCache.get(derivatives[0]);
        if (derivatives.length === 1) {
            if (!cache.map) currentCache.delete(derivatives[0]);
            else currentCache.set(derivatives[0], {
                map: cache.map
            });
            return cache.value?.[0];
        }
        const result = this.deleteByPath(cache.map, derivatives.slice(1));
        if ((!cache.map || cache.map.size === 0) && !cache.value) currentCache.delete(derivatives[0]);
        return result;
    }
    delete(derivativeOption) {
        // If cache exists
        if (this.has(derivativeOption)) {
            this.keys = this.keys.filter((item)=>!$60942ef712741889$export$dd65e95e99ed0739(item, derivativeOption));
            return this.deleteByPath(this.cache, derivativeOption);
        }
        return undefined;
    }
}



let $f7a8a4bc1b2ecd81$var$uuid = 0;
class $f7a8a4bc1b2ecd81$export$2e2bcd8739ae039 {
    derivatives;
    id;
    constructor(derivatives){
        this.derivatives = Array.isArray(derivatives) ? derivatives : [
            derivatives
        ];
        this.id = $f7a8a4bc1b2ecd81$var$uuid;
        if (derivatives.length === 0) (0, $6591254ed6bd1058$export$491112666e282270)(derivatives.length > 0, '[Ant Design CSS-in-JS] Theme should have at least one derivative function.');
        $f7a8a4bc1b2ecd81$var$uuid += 1;
    }
    getDerivativeToken(token) {
        return this.derivatives.reduce((result, derivative)=>derivative(token, result), undefined);
    }
}


const $6011ea73ba4026bc$var$cacheThemes = new (0, $60942ef712741889$export$2e2bcd8739ae039)();
function $6011ea73ba4026bc$export$2e2bcd8739ae039(derivatives) {
    const derivativeArr = Array.isArray(derivatives) ? derivatives : [
        derivatives
    ];
    // Create new theme if not exist
    if (!$6011ea73ba4026bc$var$cacheThemes.has(derivativeArr)) $6011ea73ba4026bc$var$cacheThemes.set(derivativeArr, new (0, $f7a8a4bc1b2ecd81$export$2e2bcd8739ae039)(derivativeArr));
    // Get theme from cache and return
    return $6011ea73ba4026bc$var$cacheThemes.get(derivativeArr);
}






// Create a cache for memo concat
const $763a5b4b58d0a3ff$var$resultCache = new WeakMap();
const $763a5b4b58d0a3ff$var$RESULT_VALUE = {};
function $763a5b4b58d0a3ff$export$6aabcc1951563d93(callback, deps) {
    let current = $763a5b4b58d0a3ff$var$resultCache;
    for(let i = 0; i < deps.length; i += 1){
        const dep = deps[i];
        if (!current.has(dep)) current.set(dep, new WeakMap());
        current = current.get(dep);
    }
    if (!current.has($763a5b4b58d0a3ff$var$RESULT_VALUE)) current.set($763a5b4b58d0a3ff$var$RESULT_VALUE, callback());
    return current.get($763a5b4b58d0a3ff$var$RESULT_VALUE);
}
// Create a cache here to avoid always loop generate
const $763a5b4b58d0a3ff$var$flattenTokenCache = new WeakMap();
function $763a5b4b58d0a3ff$export$597374558a261efc(token) {
    let str = $763a5b4b58d0a3ff$var$flattenTokenCache.get(token) || '';
    if (!str) {
        Object.keys(token).forEach((key)=>{
            const value = token[key];
            str += key;
            if (value instanceof (0, $f7a8a4bc1b2ecd81$export$2e2bcd8739ae039)) str += value.id;
            else if (value && typeof value === 'object') str += $763a5b4b58d0a3ff$export$597374558a261efc(value);
            else str += value;
        });
        // https://github.com/ant-design/ant-design/issues/48386
        // Should hash the string to avoid style tag name too long
        str = (0, $265e8c0f7074eb72$export$2e2bcd8739ae039)(str);
        // Put in cache
        $763a5b4b58d0a3ff$var$flattenTokenCache.set(token, str);
    }
    return str;
}
function $763a5b4b58d0a3ff$export$6c82d0ebe8f2ea2c(token, salt) {
    return (0, $265e8c0f7074eb72$export$2e2bcd8739ae039)(`${salt}_${$763a5b4b58d0a3ff$export$597374558a261efc(token)}`);
}
const $763a5b4b58d0a3ff$var$randomSelectorKey = `random-${Date.now()}-${Math.random()}`.replace(/\./g, '');
// Magic `content` for detect selector support
const $763a5b4b58d0a3ff$var$checkContent = '_bAmBoO_';
function $763a5b4b58d0a3ff$var$supportSelector(styleStr, handleElement, supportCheck) {
    if ((0, $bfbc54ac1ac0215e$export$2e2bcd8739ae039)()) {
        (0, $275621885d66fa13$export$4d99a2890bb989f0)(styleStr, $763a5b4b58d0a3ff$var$randomSelectorKey);
        const ele = document.createElement('div');
        ele.style.position = 'fixed';
        ele.style.left = '0';
        ele.style.top = '0';
        handleElement?.(ele);
        document.body.appendChild(ele);
        const support = supportCheck ? supportCheck(ele) : getComputedStyle(ele).content?.includes($763a5b4b58d0a3ff$var$checkContent);
        ele.parentNode?.removeChild(ele);
        (0, $275621885d66fa13$export$2232e336aecaa80a)($763a5b4b58d0a3ff$var$randomSelectorKey);
        return support;
    }
    return false;
}
let $763a5b4b58d0a3ff$var$canLayer = undefined;
function $763a5b4b58d0a3ff$export$ac8d3fd9840e20dd() {
    if ($763a5b4b58d0a3ff$var$canLayer === undefined) $763a5b4b58d0a3ff$var$canLayer = $763a5b4b58d0a3ff$var$supportSelector(`@layer ${$763a5b4b58d0a3ff$var$randomSelectorKey} { .${$763a5b4b58d0a3ff$var$randomSelectorKey} { content: "${$763a5b4b58d0a3ff$var$checkContent}"!important; } }`, (ele)=>{
        ele.className = $763a5b4b58d0a3ff$var$randomSelectorKey;
    });
    return $763a5b4b58d0a3ff$var$canLayer;
}
let $763a5b4b58d0a3ff$var$canWhere = undefined;
function $763a5b4b58d0a3ff$export$f51d3b8ac4ac9ed1() {
    if ($763a5b4b58d0a3ff$var$canWhere === undefined) $763a5b4b58d0a3ff$var$canWhere = $763a5b4b58d0a3ff$var$supportSelector(`:where(.${$763a5b4b58d0a3ff$var$randomSelectorKey}) { content: "${$763a5b4b58d0a3ff$var$checkContent}"!important; }`, (ele)=>{
        ele.className = $763a5b4b58d0a3ff$var$randomSelectorKey;
    });
    return $763a5b4b58d0a3ff$var$canWhere;
}
let $763a5b4b58d0a3ff$var$canLogic = undefined;
function $763a5b4b58d0a3ff$export$64a912f57d5de48e() {
    if ($763a5b4b58d0a3ff$var$canLogic === undefined) $763a5b4b58d0a3ff$var$canLogic = $763a5b4b58d0a3ff$var$supportSelector(`.${$763a5b4b58d0a3ff$var$randomSelectorKey} { inset-block: 93px !important; }`, (ele)=>{
        ele.className = $763a5b4b58d0a3ff$var$randomSelectorKey;
    }, (ele)=>getComputedStyle(ele).bottom === '93px');
    return $763a5b4b58d0a3ff$var$canLogic;
}
const $763a5b4b58d0a3ff$export$9542afab8c2a5f48 = (0, $bfbc54ac1ac0215e$export$2e2bcd8739ae039)();
function $763a5b4b58d0a3ff$export$523c0b569236b342(num) {
    if (typeof num === 'number') return `${num}px`;
    return num;
}
function $763a5b4b58d0a3ff$export$71c98ec84f0481d3(style, tokenKey, styleId, customizeAttrs = {}, plain = false) {
    if (plain) return style;
    const attrs = {
        ...customizeAttrs,
        [(0, $c756b57cbfcd44a7$export$5d99297dcd5476ac)]: tokenKey,
        [(0, $c756b57cbfcd44a7$export$89ce1123b3c0bd9e)]: styleId
    };
    const attrStr = Object.keys(attrs).map((attr)=>{
        const val = attrs[attr];
        return val ? `${attr}="${val}"` : null;
    }).filter((v)=>v).join(' ');
    return `<style ${attrStr}>${style}</style>`;
}
function $763a5b4b58d0a3ff$export$9c59b80dda569a6e(options) {
    const { hashCls: hashCls, hashPriority: hashPriority = 'low' } = options || {};
    if (!hashCls) return '';
    const hashSelector = `.${hashCls}`;
    return hashPriority === 'low' ? `:where(${hashSelector})` : hashSelector;
}



const $76923c7bf027319b$export$309b3b095f0c7662 = (token, prefix = '')=>{
    return `--${prefix ? `${prefix}-` : ''}${token}`.replace(/([a-z0-9])([A-Z])/g, '$1-$2').replace(/([A-Z]+)([A-Z][a-z0-9]+)/g, '$1-$2').replace(/([a-z])([A-Z0-9])/g, '$1-$2').toLowerCase();
};
const $76923c7bf027319b$export$a27ef1ee9bbc757e = (cssVars, hashId, options)=>{
    const { hashCls: hashCls, hashPriority: hashPriority = 'low' } = options || {};
    if (!Object.keys(cssVars).length) return '';
    return `${(0, $763a5b4b58d0a3ff$export$9c59b80dda569a6e)({
        hashCls: hashCls,
        hashPriority: hashPriority
    })}.${hashId}${options?.scope ? `.${options.scope}` : ''}{${Object.entries(cssVars).map(([key, value])=>`${key}:${value};`).join('')}}`;
};
const $76923c7bf027319b$export$67858afe85bce49f = (token, themeKey, config)=>{
    const { hashCls: hashCls, hashPriority: hashPriority = 'low', prefix: prefix, unitless: unitless, ignore: ignore, preserve: preserve } = config || {};
    const cssVars = {};
    const result = {};
    Object.entries(token).forEach(([key, value])=>{
        if (preserve?.[key]) result[key] = value;
        else if ((typeof value === 'string' || typeof value === 'number') && !ignore?.[key]) {
            const cssVar = $76923c7bf027319b$export$309b3b095f0c7662(key, prefix);
            cssVars[cssVar] = typeof value === 'number' && !unitless?.[key] ? `${value}px` : String(value);
            result[key] = `var(${cssVar})`;
        }
    });
    return [
        result,
        $76923c7bf027319b$export$a27ef1ee9bbc757e(cssVars, themeKey, {
            scope: config?.scope,
            hashCls: hashCls,
            hashPriority: hashPriority
        })
    ];
};


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
var $N3oW3 = parcelRequire("N3oW3");


function $4cb3625788fcd12b$var$useProdHMR() {
    return false;
}
let $4cb3625788fcd12b$var$webpackHMR = false;
function $4cb3625788fcd12b$var$useDevHMR() {
    return $4cb3625788fcd12b$var$webpackHMR;
}
var $4cb3625788fcd12b$export$2e2bcd8739ae039 = $4cb3625788fcd12b$var$useProdHMR;
var $4cb3625788fcd12b$var$args;


const $4acdafa780258ac9$var$effectMap = new Map();
function $4acdafa780258ac9$export$2e2bcd8739ae039(prefix, keyPath, cacheFn, onCacheRemove, // Add additional effect trigger by `useInsertionEffect`
onCacheEffect) {
    const { cache: globalCache } = $32rMB.useContext((0, $c756b57cbfcd44a7$export$2e2bcd8739ae039));
    const fullPath = [
        prefix,
        ...keyPath
    ];
    const fullPathStr = (0, $032fd3278bed04bc$export$1d14e1d8187b9aad)(fullPath);
    const HMRUpdate = (0, $4cb3625788fcd12b$export$2e2bcd8739ae039)();
    const buildCache = (updater)=>{
        globalCache.opUpdate(fullPathStr, (prevCache)=>{
            const [times = 0, cache] = prevCache || [
                undefined,
                undefined
            ];
            // HMR should always ignore cache since developer may change it
            let tmpCache = cache;
            const mergedCache = tmpCache || cacheFn();
            const data = [
                times,
                mergedCache
            ];
            // Call updater if need additional logic
            return updater ? updater(data) : data;
        });
    };
    // Create cache
    $32rMB.useMemo(()=>{
        buildCache();
    }, /* eslint-disable react-hooks/exhaustive-deps */ [
        fullPathStr
    ]);
    let cacheEntity = globalCache.opGet(fullPathStr);
    const cacheContent = cacheEntity[1];
    // Remove if no need anymore
    (0, $N3oW3.useInsertionEffect)(()=>{
        buildCache(([times, cache])=>[
                times + 1,
                cache
            ]);
        if (!$4acdafa780258ac9$var$effectMap.has(fullPathStr)) {
            onCacheEffect?.(cacheContent);
            $4acdafa780258ac9$var$effectMap.set(fullPathStr, true);
            // 微任务清理混存，可以认为是单次 batch render 中只触发一次 effect
            Promise.resolve().then(()=>{
                $4acdafa780258ac9$var$effectMap.delete(fullPathStr);
            });
        }
        return ()=>{
            globalCache.opUpdate(fullPathStr, (prevCache)=>{
                const [times = 0, cache] = prevCache || [];
                const nextCount = times - 1;
                if (nextCount === 0) {
                    onCacheRemove?.(cache, false);
                    $4acdafa780258ac9$var$effectMap.delete(fullPathStr);
                    return null;
                }
                return [
                    times - 1,
                    cache
                ];
            });
        };
    }, [
        fullPathStr
    ]);
    return cacheContent;
}


const $3ec6f7f6664c21fe$var$EMPTY_OVERRIDE = {};
// Generate different prefix to make user selector break in production env.
// This helps developer not to do style override directly on the hash id.
const $3ec6f7f6664c21fe$var$hashPrefix = 'css';
const $3ec6f7f6664c21fe$var$tokenKeys = new Map();
function $3ec6f7f6664c21fe$var$recordCleanToken(tokenKey) {
    $3ec6f7f6664c21fe$var$tokenKeys.set(tokenKey, ($3ec6f7f6664c21fe$var$tokenKeys.get(tokenKey) || 0) + 1);
}
function $3ec6f7f6664c21fe$var$removeStyleTags(key, instanceId) {
    if (typeof document !== 'undefined') {
        const styles = document.querySelectorAll(`style[${(0, $c756b57cbfcd44a7$export$5d99297dcd5476ac)}="${key}"]`);
        styles.forEach((style)=>{
            if (style[0, $c756b57cbfcd44a7$export$4c16a0c02134a7dc] === instanceId) style.parentNode?.removeChild(style);
        });
    }
}
const $3ec6f7f6664c21fe$var$TOKEN_THRESHOLD = -1;
// Remove will check current keys first
function $3ec6f7f6664c21fe$var$cleanTokenStyle(tokenKey, instanceId) {
    $3ec6f7f6664c21fe$var$tokenKeys.set(tokenKey, ($3ec6f7f6664c21fe$var$tokenKeys.get(tokenKey) || 0) - 1);
    const cleanableKeyList = new Set();
    $3ec6f7f6664c21fe$var$tokenKeys.forEach((value, key)=>{
        if (value <= 0) cleanableKeyList.add(key);
    });
    // Should keep tokens under threshold for not to insert style too often
    if ($3ec6f7f6664c21fe$var$tokenKeys.size - cleanableKeyList.size > $3ec6f7f6664c21fe$var$TOKEN_THRESHOLD) cleanableKeyList.forEach((key)=>{
        $3ec6f7f6664c21fe$var$removeStyleTags(key, instanceId);
        $3ec6f7f6664c21fe$var$tokenKeys.delete(key);
    });
}
const $3ec6f7f6664c21fe$export$18602cb46ae80b62 = (originToken, overrideToken, theme, format)=>{
    const derivativeToken = theme.getDerivativeToken(originToken);
    // Merge with override
    let mergedDerivativeToken = {
        ...derivativeToken,
        ...overrideToken
    };
    // Format if needed
    if (format) mergedDerivativeToken = format(mergedDerivativeToken);
    return mergedDerivativeToken;
};
const $3ec6f7f6664c21fe$export$270fba097347f4fa = 'token';
function $3ec6f7f6664c21fe$export$2e2bcd8739ae039(theme, tokens, option) {
    const { cache: { instanceId: instanceId }, container: container, hashPriority: hashPriority } = (0, $32rMB.useContext)((0, $c756b57cbfcd44a7$export$2e2bcd8739ae039));
    const { salt: salt = '', override: override = $3ec6f7f6664c21fe$var$EMPTY_OVERRIDE, formatToken: formatToken, getComputedToken: compute, cssVar: cssVar } = option;
    // Basic - We do basic cache here
    const mergedToken = (0, $763a5b4b58d0a3ff$export$6aabcc1951563d93)(()=>Object.assign({}, ...tokens), tokens);
    const tokenStr = (0, $763a5b4b58d0a3ff$export$597374558a261efc)(mergedToken);
    const overrideTokenStr = (0, $763a5b4b58d0a3ff$export$597374558a261efc)(override);
    const cssVarStr = (0, $763a5b4b58d0a3ff$export$597374558a261efc)(cssVar);
    const cachedToken = (0, $4acdafa780258ac9$export$2e2bcd8739ae039)($3ec6f7f6664c21fe$export$270fba097347f4fa, [
        salt,
        theme.id,
        tokenStr,
        overrideTokenStr,
        cssVarStr
    ], ()=>{
        const mergedDerivativeToken = compute ? compute(mergedToken, override, theme) : $3ec6f7f6664c21fe$export$18602cb46ae80b62(mergedToken, override, theme, formatToken);
        const actualToken = {
            ...mergedDerivativeToken
        };
        // Optimize for `useStyleRegister` performance
        const mergedSalt = `${salt}_${cssVar.prefix}`;
        const hashId = (0, $265e8c0f7074eb72$export$2e2bcd8739ae039)(mergedSalt);
        const hashCls = `${$3ec6f7f6664c21fe$var$hashPrefix}-${(0, $265e8c0f7074eb72$export$2e2bcd8739ae039)(mergedSalt)}`;
        actualToken._tokenKey = (0, $763a5b4b58d0a3ff$export$6c82d0ebe8f2ea2c)(actualToken, mergedSalt);
        // Replace token value with css variables
        const [tokenWithCssVar, cssVarsStr] = (0, $76923c7bf027319b$export$67858afe85bce49f)(mergedDerivativeToken, cssVar.key, {
            prefix: cssVar.prefix,
            ignore: cssVar.ignore,
            unitless: cssVar.unitless,
            preserve: cssVar.preserve,
            hashPriority: hashPriority,
            hashCls: cssVar.hashed ? hashCls : undefined
        });
        tokenWithCssVar._hashId = hashId;
        $3ec6f7f6664c21fe$var$recordCleanToken(cssVar.key);
        return [
            tokenWithCssVar,
            hashCls,
            actualToken,
            cssVarsStr,
            cssVar.key
        ];
    }, ([, , , , themeKey])=>{
        // Remove token will remove all related style
        $3ec6f7f6664c21fe$var$cleanTokenStyle(themeKey, instanceId);
    }, ([, , , cssVarsStr, themeKey])=>{
        if (!cssVarsStr) return;
        const style = (0, $275621885d66fa13$export$4d99a2890bb989f0)(cssVarsStr, (0, $265e8c0f7074eb72$export$2e2bcd8739ae039)(`css-var-${themeKey}`), {
            mark: (0, $c756b57cbfcd44a7$export$89ce1123b3c0bd9e),
            prepend: 'queue',
            attachTo: container,
            priority: -999
        });
        style[0, $c756b57cbfcd44a7$export$4c16a0c02134a7dc] = instanceId;
        // Used for `useCacheToken` to remove on batch when token removed
        style.setAttribute((0, $c756b57cbfcd44a7$export$5d99297dcd5476ac), themeKey);
    });
    return cachedToken;
}
const $3ec6f7f6664c21fe$export$f9380c9a627682d3 = (cache, effectStyles, options)=>{
    const [, , realToken, styleStr, cssVarKey] = cache;
    const { plain: plain } = options || {};
    if (!styleStr) return null;
    const styleId = realToken._tokenKey;
    const order = -999;
    // ====================== Style ======================
    // Used for @rc-component/util
    const sharedAttrs = {
        'data-rc-order': 'prependQueue',
        'data-rc-priority': `${order}`
    };
    const styleText = (0, $763a5b4b58d0a3ff$export$71c98ec84f0481d3)(styleStr, cssVarKey, styleId, sharedAttrs, plain);
    return [
        order,
        styleId,
        styleText
    ];
};



parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");






parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
var $885f4eee88e48c11$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $885f4eee88e48c11$export$2e2bcd8739ae039 = $885f4eee88e48c11$var$unitlessKeys;


var $14f7c1b46e1d219f$export$71ad59f2e432cfe8 = '-ms-';
var $14f7c1b46e1d219f$export$2c0f367103c8d01c = '-moz-';
var $14f7c1b46e1d219f$export$39dfd62a25e0fe93 = '-webkit-';
var $14f7c1b46e1d219f$export$a29989082612d0d9 = 'comm';
var $14f7c1b46e1d219f$export$aa3a2e812ca8570d = 'rule';
var $14f7c1b46e1d219f$export$527d108ccf083c2b = 'decl';
var $14f7c1b46e1d219f$export$d3d35020fa5b54f0 = '@page';
var $14f7c1b46e1d219f$export$500415a86c544f73 = '@media';
var $14f7c1b46e1d219f$export$a763edbf796b780a = '@import';
var $14f7c1b46e1d219f$export$2790aeb8b4e5c826 = '@charset';
var $14f7c1b46e1d219f$export$1cc683e23b84b133 = '@viewport';
var $14f7c1b46e1d219f$export$9447a5efea57e862 = '@supports';
var $14f7c1b46e1d219f$export$ef011b4e114b1fba = '@document';
var $14f7c1b46e1d219f$export$6aad947bda0f3f46 = '@namespace';
var $14f7c1b46e1d219f$export$b44a8529a35fcb60 = '@keyframes';
var $14f7c1b46e1d219f$export$2c16de31893252e6 = '@font-face';
var $14f7c1b46e1d219f$export$3d846dd52e150c6f = '@counter-style';
var $14f7c1b46e1d219f$export$22314bfbb57653fe = '@font-feature-values';
var $14f7c1b46e1d219f$export$d773506282b3cfe6 = '@layer';
var $14f7c1b46e1d219f$export$1c5a554c78c0cd12 = '@scope';


/**
 * @param {number}
 * @return {number}
 */ var $a4dba62487c0087b$export$2335f513bbd82c6d = Math.abs;
var $a4dba62487c0087b$export$6788812c4e6611e6 = String.fromCharCode;
var $a4dba62487c0087b$export$e6e34fd1f2686227 = Object.assign;
function $a4dba62487c0087b$export$d6af199866bfb566(value, length) {
    return $a4dba62487c0087b$export$a9db5e087081082d(value, 0) ^ 45 ? (((length << 2 ^ $a4dba62487c0087b$export$a9db5e087081082d(value, 0)) << 2 ^ $a4dba62487c0087b$export$a9db5e087081082d(value, 1)) << 2 ^ $a4dba62487c0087b$export$a9db5e087081082d(value, 2)) << 2 ^ $a4dba62487c0087b$export$a9db5e087081082d(value, 3) : 0;
}
function $a4dba62487c0087b$export$87c2784dc9fc4ab(value) {
    return value.trim();
}
function $a4dba62487c0087b$export$4659b591c19bdf3d(value, pattern) {
    return (value = pattern.exec(value)) ? value[0] : value;
}
function $a4dba62487c0087b$export$77ad94ebf1c2b9ed(value, pattern, replacement) {
    return value.replace(pattern, replacement);
}
function $a4dba62487c0087b$export$f8e21b1e77979a08(value, search, position) {
    return value.indexOf(search, position);
}
function $a4dba62487c0087b$export$a9db5e087081082d(value, index) {
    return value.charCodeAt(index) | 0;
}
function $a4dba62487c0087b$export$2f35ab04d2335697(value, begin, end) {
    return value.slice(begin, end);
}
function $a4dba62487c0087b$export$36776f635604f274(value) {
    return value.length;
}
function $a4dba62487c0087b$export$f9084667e487ed46(value) {
    return value.length;
}
function $a4dba62487c0087b$export$10d8903dec122b9d(value, array) {
    return array.push(value), value;
}
function $a4dba62487c0087b$export$1be1fc439b849fdf(array, callback) {
    return array.map(callback).join('');
}
function $a4dba62487c0087b$export$3dea766d36a8935f(array, pattern) {
    return array.filter(function(value) {
        return !$a4dba62487c0087b$export$4659b591c19bdf3d(value, pattern);
    });
}



var $091f67372881bac3$export$53f1d5ea8de3d7c = 1;
var $091f67372881bac3$export$4e0c71f277ca26b3 = 1;
var $091f67372881bac3$export$f24224f1c91d8156 = 0;
var $091f67372881bac3$export$5880b8b5730aff45 = 0;
var $091f67372881bac3$export$c0306caf338ac095 = 0;
var $091f67372881bac3$export$30a86d91af8ff6e6 = '';
function $091f67372881bac3$export$35059013cd4a06db(value, root, parent, type, props, children, length, siblings) {
    return {
        value: value,
        root: root,
        parent: parent,
        type: type,
        props: props,
        children: children,
        line: $091f67372881bac3$export$53f1d5ea8de3d7c,
        column: $091f67372881bac3$export$4e0c71f277ca26b3,
        length: length,
        return: '',
        siblings: siblings
    };
}
function $091f67372881bac3$export$784d13d8ee351f07(root, props) {
    return (0, $a4dba62487c0087b$export$e6e34fd1f2686227)($091f67372881bac3$export$35059013cd4a06db('', null, null, '', null, null, 0, root.siblings), root, {
        length: -root.length
    }, props);
}
function $091f67372881bac3$export$590e8b2c435046d9(root) {
    while(root.root)root = $091f67372881bac3$export$784d13d8ee351f07(root.root, {
        children: [
            root
        ]
    });
    (0, $a4dba62487c0087b$export$10d8903dec122b9d)(root, root.siblings);
}
function $091f67372881bac3$export$eba6f6f03b0a92e7() {
    return $091f67372881bac3$export$c0306caf338ac095;
}
function $091f67372881bac3$export$232faf9add678146() {
    $091f67372881bac3$export$c0306caf338ac095 = $091f67372881bac3$export$5880b8b5730aff45 > 0 ? (0, $a4dba62487c0087b$export$a9db5e087081082d)($091f67372881bac3$export$30a86d91af8ff6e6, --$091f67372881bac3$export$5880b8b5730aff45) : 0;
    if ($091f67372881bac3$export$4e0c71f277ca26b3--, $091f67372881bac3$export$c0306caf338ac095 === 10) $091f67372881bac3$export$4e0c71f277ca26b3 = 1, $091f67372881bac3$export$53f1d5ea8de3d7c--;
    return $091f67372881bac3$export$c0306caf338ac095;
}
function $091f67372881bac3$export$48cfd1e771a65c4f() {
    $091f67372881bac3$export$c0306caf338ac095 = $091f67372881bac3$export$5880b8b5730aff45 < $091f67372881bac3$export$f24224f1c91d8156 ? (0, $a4dba62487c0087b$export$a9db5e087081082d)($091f67372881bac3$export$30a86d91af8ff6e6, $091f67372881bac3$export$5880b8b5730aff45++) : 0;
    if ($091f67372881bac3$export$4e0c71f277ca26b3++, $091f67372881bac3$export$c0306caf338ac095 === 10) $091f67372881bac3$export$4e0c71f277ca26b3 = 1, $091f67372881bac3$export$53f1d5ea8de3d7c++;
    return $091f67372881bac3$export$c0306caf338ac095;
}
function $091f67372881bac3$export$4d3fb11e950abb9e() {
    return (0, $a4dba62487c0087b$export$a9db5e087081082d)($091f67372881bac3$export$30a86d91af8ff6e6, $091f67372881bac3$export$5880b8b5730aff45);
}
function $091f67372881bac3$export$e88cb2efb12ae807() {
    return $091f67372881bac3$export$5880b8b5730aff45;
}
function $091f67372881bac3$export$58adb3bec8346d0f(begin, end) {
    return (0, $a4dba62487c0087b$export$2f35ab04d2335697)($091f67372881bac3$export$30a86d91af8ff6e6, begin, end);
}
function $091f67372881bac3$export$9e1725a4cfeada27(type) {
    switch(type){
        // \0 \t \n \r \s whitespace token
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        // ! + , / > @ ~ isolate token
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        // ; { } breakpoint token
        case 59:
        case 123:
        case 125:
            return 4;
        // : accompanied token
        case 58:
            return 3;
        // " ' ( [ opening delimit token
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        // ) ] closing delimit token
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $091f67372881bac3$export$2de70f21292aac9e(value) {
    return $091f67372881bac3$export$53f1d5ea8de3d7c = $091f67372881bac3$export$4e0c71f277ca26b3 = 1, $091f67372881bac3$export$f24224f1c91d8156 = (0, $a4dba62487c0087b$export$36776f635604f274)($091f67372881bac3$export$30a86d91af8ff6e6 = value), $091f67372881bac3$export$5880b8b5730aff45 = 0, [];
}
function $091f67372881bac3$export$45918ac1574455b1(value) {
    return $091f67372881bac3$export$30a86d91af8ff6e6 = '', value;
}
function $091f67372881bac3$export$410ac95b9ec204b8(type) {
    return (0, $a4dba62487c0087b$export$87c2784dc9fc4ab)($091f67372881bac3$export$58adb3bec8346d0f($091f67372881bac3$export$5880b8b5730aff45 - 1, $091f67372881bac3$export$c889f2fcc19dbf12(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function $091f67372881bac3$export$660b2ee2d4fb4eff(value) {
    return $091f67372881bac3$export$45918ac1574455b1($091f67372881bac3$export$5f8c09e3ae6f64e1($091f67372881bac3$export$2de70f21292aac9e(value)));
}
function $091f67372881bac3$export$7af1228ff777d175(type) {
    while($091f67372881bac3$export$c0306caf338ac095 = $091f67372881bac3$export$4d3fb11e950abb9e())if ($091f67372881bac3$export$c0306caf338ac095 < 33) $091f67372881bac3$export$48cfd1e771a65c4f();
    else break;
    return $091f67372881bac3$export$9e1725a4cfeada27(type) > 2 || $091f67372881bac3$export$9e1725a4cfeada27($091f67372881bac3$export$c0306caf338ac095) > 3 ? '' : ' ';
}
function $091f67372881bac3$export$5f8c09e3ae6f64e1(children) {
    while($091f67372881bac3$export$48cfd1e771a65c4f())switch($091f67372881bac3$export$9e1725a4cfeada27($091f67372881bac3$export$c0306caf338ac095)){
        case 0:
            (0, $a4dba62487c0087b$export$10d8903dec122b9d)($091f67372881bac3$export$c2ab62c7bf24634($091f67372881bac3$export$5880b8b5730aff45 - 1), children);
            break;
        case 2:
            (0, $a4dba62487c0087b$export$10d8903dec122b9d)($091f67372881bac3$export$410ac95b9ec204b8($091f67372881bac3$export$c0306caf338ac095), children);
            break;
        default:
            (0, $a4dba62487c0087b$export$10d8903dec122b9d)((0, $a4dba62487c0087b$export$6788812c4e6611e6)($091f67372881bac3$export$c0306caf338ac095), children);
    }
    return children;
}
function $091f67372881bac3$export$955ba06d119e085e(index, count) {
    while(--count && $091f67372881bac3$export$48cfd1e771a65c4f())// not 0-9 A-F a-f
    if ($091f67372881bac3$export$c0306caf338ac095 < 48 || $091f67372881bac3$export$c0306caf338ac095 > 102 || $091f67372881bac3$export$c0306caf338ac095 > 57 && $091f67372881bac3$export$c0306caf338ac095 < 65 || $091f67372881bac3$export$c0306caf338ac095 > 70 && $091f67372881bac3$export$c0306caf338ac095 < 97) break;
    return $091f67372881bac3$export$58adb3bec8346d0f(index, $091f67372881bac3$export$e88cb2efb12ae807() + (count < 6 && $091f67372881bac3$export$4d3fb11e950abb9e() == 32 && $091f67372881bac3$export$48cfd1e771a65c4f() == 32));
}
function $091f67372881bac3$export$c889f2fcc19dbf12(type) {
    while($091f67372881bac3$export$48cfd1e771a65c4f())switch($091f67372881bac3$export$c0306caf338ac095){
        // ] ) " '
        case type:
            return $091f67372881bac3$export$5880b8b5730aff45;
        // " '
        case 34:
        case 39:
            if (type !== 34 && type !== 39) $091f67372881bac3$export$c889f2fcc19dbf12($091f67372881bac3$export$c0306caf338ac095);
            break;
        // (
        case 40:
            if (type === 41) $091f67372881bac3$export$c889f2fcc19dbf12(type);
            break;
        // \
        case 92:
            $091f67372881bac3$export$48cfd1e771a65c4f();
            break;
    }
    return $091f67372881bac3$export$5880b8b5730aff45;
}
function $091f67372881bac3$export$4254d4e2b3745c4c(type, index) {
    while($091f67372881bac3$export$48cfd1e771a65c4f())// //
    if (type + $091f67372881bac3$export$c0306caf338ac095 === 57) break;
    else if (type + $091f67372881bac3$export$c0306caf338ac095 === 84 && $091f67372881bac3$export$4d3fb11e950abb9e() === 47) break;
    return '/*' + $091f67372881bac3$export$58adb3bec8346d0f(index, $091f67372881bac3$export$5880b8b5730aff45 - 1) + '*' + (0, $a4dba62487c0087b$export$6788812c4e6611e6)(type === 47 ? type : $091f67372881bac3$export$48cfd1e771a65c4f());
}
function $091f67372881bac3$export$c2ab62c7bf24634(index) {
    while(!$091f67372881bac3$export$9e1725a4cfeada27($091f67372881bac3$export$4d3fb11e950abb9e()))$091f67372881bac3$export$48cfd1e771a65c4f();
    return $091f67372881bac3$export$58adb3bec8346d0f(index, $091f67372881bac3$export$5880b8b5730aff45);
}


function $0da293b81cdc2df3$export$ef7acd7185315e22(value) {
    return (0, $091f67372881bac3$export$45918ac1574455b1)($0da293b81cdc2df3$export$98e6a39c04603d36('', null, null, null, [
        ''
    ], value = (0, $091f67372881bac3$export$2de70f21292aac9e)(value), 0, [
        0
    ], value));
}
function $0da293b81cdc2df3$export$98e6a39c04603d36(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
    var index = 0;
    var offset = 0;
    var length = pseudo;
    var atrule = 0;
    var property = 0;
    var previous = 0;
    var variable = 1;
    var scanning = 1;
    var ampersand = 1;
    var character = 0;
    var type = '';
    var props = rules;
    var children = rulesets;
    var reference = rule;
    var characters = type;
    while(scanning)switch(previous = character, character = (0, $091f67372881bac3$export$48cfd1e771a65c4f)()){
        // (
        case 40:
            if (previous != 108 && (0, $a4dba62487c0087b$export$a9db5e087081082d)(characters, length - 1) == 58) {
                if ((0, $a4dba62487c0087b$export$f8e21b1e77979a08)(characters += (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)((0, $091f67372881bac3$export$410ac95b9ec204b8)(character), '&', '&\f'), '&\f', (0, $a4dba62487c0087b$export$2335f513bbd82c6d)(index ? points[index - 1] : 0)) != -1) ampersand = -1;
                break;
            }
        // " ' [
        case 34:
        case 39:
        case 91:
            characters += (0, $091f67372881bac3$export$410ac95b9ec204b8)(character);
            break;
        // \t \n \r \s
        case 9:
        case 10:
        case 13:
        case 32:
            characters += (0, $091f67372881bac3$export$7af1228ff777d175)(previous);
            break;
        // \
        case 92:
            characters += (0, $091f67372881bac3$export$955ba06d119e085e)((0, $091f67372881bac3$export$e88cb2efb12ae807)() - 1, 7);
            continue;
        // /
        case 47:
            switch((0, $091f67372881bac3$export$4d3fb11e950abb9e)()){
                case 42:
                case 47:
                    (0, $a4dba62487c0087b$export$10d8903dec122b9d)($0da293b81cdc2df3$export$4a34f930e789283c((0, $091f67372881bac3$export$4254d4e2b3745c4c)((0, $091f67372881bac3$export$48cfd1e771a65c4f)(), (0, $091f67372881bac3$export$e88cb2efb12ae807)()), root, parent, declarations), declarations);
                    if (((0, $091f67372881bac3$export$9e1725a4cfeada27)(previous || 1) == 5 || (0, $091f67372881bac3$export$9e1725a4cfeada27)((0, $091f67372881bac3$export$4d3fb11e950abb9e)() || 1) == 5) && (0, $a4dba62487c0087b$export$36776f635604f274)(characters) && (0, $a4dba62487c0087b$export$2f35ab04d2335697)(characters, -1, void 0) !== ' ') characters += ' ';
                    break;
                default:
                    characters += '/';
            }
            break;
        // {
        case 123 * variable:
            points[index++] = (0, $a4dba62487c0087b$export$36776f635604f274)(characters) * ampersand;
        // } ; \0
        case 125 * variable:
        case 59:
        case 0:
            switch(character){
                // \0 }
                case 0:
                case 125:
                    scanning = 0;
                // ;
                case 59 + offset:
                    if (ampersand == -1) characters = (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(characters, /\f/g, '');
                    if (property > 0 && ((0, $a4dba62487c0087b$export$36776f635604f274)(characters) - length || variable === 0 && previous === 47)) (0, $a4dba62487c0087b$export$10d8903dec122b9d)(property > 32 ? $0da293b81cdc2df3$export$f8483753829ec8f3(characters + ';', rule, parent, length - 1, declarations) : $0da293b81cdc2df3$export$f8483753829ec8f3((0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(characters, ' ', '') + ';', rule, parent, length - 2, declarations), declarations);
                    break;
                // @ ;
                case 59:
                    characters += ';';
                // { rule/at-rule
                default:
                    (0, $a4dba62487c0087b$export$10d8903dec122b9d)(reference = $0da293b81cdc2df3$export$3307ffa7023ede1e(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length, rulesets), rulesets);
                    if (character === 123) {
                        if (offset === 0) $0da293b81cdc2df3$export$98e6a39c04603d36(characters, root, reference, reference, props, rulesets, length, points, children);
                        else {
                            switch(atrule){
                                // c(ontainer)
                                case 99:
                                    if ((0, $a4dba62487c0087b$export$a9db5e087081082d)(characters, 3) === 110) break;
                                // l(ayer)
                                case 108:
                                    if ((0, $a4dba62487c0087b$export$a9db5e087081082d)(characters, 2) === 97) break;
                                default:
                                    offset = 0;
                                // d(ocument) m(edia) s(upports)
                                case 100:
                                case 109:
                                case 115:
                            }
                            if (offset) $0da293b81cdc2df3$export$98e6a39c04603d36(value, reference, reference, rule && (0, $a4dba62487c0087b$export$10d8903dec122b9d)($0da293b81cdc2df3$export$3307ffa7023ede1e(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length, children), children), rules, children, length, points, rule ? props : children);
                            else $0da293b81cdc2df3$export$98e6a39c04603d36(characters, reference, reference, reference, [
                                ''
                            ], children, 0, points, children);
                        }
                    }
            }
            index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
            break;
        // :
        case 58:
            length = 1 + (0, $a4dba62487c0087b$export$36776f635604f274)(characters), property = previous;
        default:
            if (variable < 1) {
                if (character == 123) --variable;
                else if (character == 125 && variable++ == 0 && (0, $091f67372881bac3$export$232faf9add678146)() == 125) continue;
            }
            switch(characters += (0, $a4dba62487c0087b$export$6788812c4e6611e6)(character), character * variable){
                // &
                case 38:
                    ampersand = offset > 0 ? 1 : (characters += '\f', -1);
                    break;
                // ,
                case 44:
                    points[index++] = ((0, $a4dba62487c0087b$export$36776f635604f274)(characters) - 1) * ampersand, ampersand = 1;
                    break;
                // @
                case 64:
                    // -
                    if ((0, $091f67372881bac3$export$4d3fb11e950abb9e)() === 45) characters += (0, $091f67372881bac3$export$410ac95b9ec204b8)((0, $091f67372881bac3$export$48cfd1e771a65c4f)());
                    atrule = (0, $091f67372881bac3$export$4d3fb11e950abb9e)(), offset = length = (0, $a4dba62487c0087b$export$36776f635604f274)(type = characters += (0, $091f67372881bac3$export$c2ab62c7bf24634)((0, $091f67372881bac3$export$e88cb2efb12ae807)())), character++;
                    break;
                // -
                case 45:
                    if (previous === 45 && (0, $a4dba62487c0087b$export$36776f635604f274)(characters) == 2) variable = 0;
            }
    }
    return rulesets;
}
function $0da293b81cdc2df3$export$3307ffa7023ede1e(value, root, parent, index, offset, rules, points, type, props, children, length, siblings) {
    var post = offset - 1;
    var rule = offset === 0 ? rules : [
        ''
    ];
    var size = (0, $a4dba62487c0087b$export$f9084667e487ed46)(rule);
    for(var i = 0, j = 0, k = 0; i < index; ++i)for(var x = 0, y = (0, $a4dba62487c0087b$export$2f35ab04d2335697)(value, post + 1, post = (0, $a4dba62487c0087b$export$2335f513bbd82c6d)(j = points[i])), z = value; x < size; ++x)if (z = (0, $a4dba62487c0087b$export$87c2784dc9fc4ab)(j > 0 ? rule[x] + ' ' + y : (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(y, /&\f/g, rule[x]))) props[k++] = z;
    return (0, $091f67372881bac3$export$35059013cd4a06db)(value, root, parent, offset === 0 ? (0, $14f7c1b46e1d219f$export$aa3a2e812ca8570d) : type, props, children, length, siblings);
}
function $0da293b81cdc2df3$export$4a34f930e789283c(value, root, parent, siblings) {
    return (0, $091f67372881bac3$export$35059013cd4a06db)(value, root, parent, (0, $14f7c1b46e1d219f$export$a29989082612d0d9), (0, $a4dba62487c0087b$export$6788812c4e6611e6)((0, $091f67372881bac3$export$eba6f6f03b0a92e7)()), (0, $a4dba62487c0087b$export$2f35ab04d2335697)(value, 2, -2), 0, siblings);
}
function $0da293b81cdc2df3$export$f8483753829ec8f3(value, root, parent, length, siblings) {
    return (0, $091f67372881bac3$export$35059013cd4a06db)(value, root, parent, (0, $14f7c1b46e1d219f$export$527d108ccf083c2b), (0, $a4dba62487c0087b$export$2f35ab04d2335697)(value, 0, length), (0, $a4dba62487c0087b$export$2f35ab04d2335697)(value, length + 1, -1), length, siblings);
}






function $4f9dba64a0f6480c$export$dfdc1655ccc5b9cb(children, callback) {
    var output = '';
    for(var i = 0; i < children.length; i++)output += callback(children[i], i, children, callback) || '';
    return output;
}
function $4f9dba64a0f6480c$export$fac44ee5b035f737(element, index, children, callback) {
    switch(element.type){
        case 0, $14f7c1b46e1d219f$export$d773506282b3cfe6:
            if (element.children.length) break;
        case 0, $14f7c1b46e1d219f$export$a763edbf796b780a:
        case 0, $14f7c1b46e1d219f$export$6aad947bda0f3f46:
        case 0, $14f7c1b46e1d219f$export$527d108ccf083c2b:
            return element.return = element.return || element.value;
        case 0, $14f7c1b46e1d219f$export$a29989082612d0d9:
            return '';
        case 0, $14f7c1b46e1d219f$export$b44a8529a35fcb60:
            return element.return = element.value + '{' + $4f9dba64a0f6480c$export$dfdc1655ccc5b9cb(element.children, callback) + '}';
        case 0, $14f7c1b46e1d219f$export$aa3a2e812ca8570d:
            if (!(0, $a4dba62487c0087b$export$36776f635604f274)(element.value = element.props.join(','))) return '';
    }
    return (0, $a4dba62487c0087b$export$36776f635604f274)(children = $4f9dba64a0f6480c$export$dfdc1655ccc5b9cb(element.children, callback)) ? element.return = element.value + '{' + children + '}' : '';
}




function $55dc12b39f43b779$export$82e9f45cca5ba907(value, length, children) {
    switch((0, $a4dba62487c0087b$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
        // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
            return (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93) + value + value;
        // mask-composite
        case 4855:
            return (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93) + value.replace('add', 'source-over').replace('substract', 'source-out').replace('intersect', 'source-in').replace('exclude', 'xor') + value;
        // tab-size
        case 4789:
            return (0, $14f7c1b46e1d219f$export$2c0f367103c8d01c) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93) + value + (0, $14f7c1b46e1d219f$export$2c0f367103c8d01c) + value + (0, $14f7c1b46e1d219f$export$71ad59f2e432cfe8) + value + value;
        // writing-mode
        case 5936:
            switch((0, $a4dba62487c0087b$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93) + value + (0, $14f7c1b46e1d219f$export$71ad59f2e432cfe8) + (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93) + value + (0, $14f7c1b46e1d219f$export$71ad59f2e432cfe8) + (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93) + value + (0, $14f7c1b46e1d219f$export$71ad59f2e432cfe8) + (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
        // flex, flex-direction, scroll-snap-type, writing-mode
        case 6828:
        case 4268:
        case 2903:
            return (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93) + value + (0, $14f7c1b46e1d219f$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93) + value + (0, $14f7c1b46e1d219f$export$71ad59f2e432cfe8) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93) + value + (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93) + 'box-$1$2' + (0, $14f7c1b46e1d219f$export$71ad59f2e432cfe8) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93) + value + (0, $14f7c1b46e1d219f$export$71ad59f2e432cfe8) + 'flex-item-' + (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, /flex-|-self/g, '') + (!(0, $a4dba62487c0087b$export$4659b591c19bdf3d)(value, /flex-|baseline/) ? (0, $14f7c1b46e1d219f$export$71ad59f2e432cfe8) + 'grid-row-' + (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, /flex-|-self/g, '') : '') + value;
        // align-content
        case 4675:
            return (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93) + value + (0, $14f7c1b46e1d219f$export$71ad59f2e432cfe8) + 'flex-line-pack' + (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/g, '') + value;
        // flex-shrink
        case 5548:
            return (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93) + value + (0, $14f7c1b46e1d219f$export$71ad59f2e432cfe8) + (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93) + value + (0, $14f7c1b46e1d219f$export$71ad59f2e432cfe8) + (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93) + 'box-' + (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, '-grow', '') + (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93) + value + (0, $14f7c1b46e1d219f$export$71ad59f2e432cfe8) + (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93) + (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, '$1' + (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93) + '$2') + value;
        // cursor
        case 6187:
            return (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)((0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)((0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93) + '$1'), /(image-set)/, (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)((0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93) + 'box-pack:$3' + (0, $14f7c1b46e1d219f$export$71ad59f2e432cfe8) + 'flex-pack:$3'), /space-between/, 'justify') + (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93) + value + value;
        // justify-self
        case 4200:
            if (!(0, $a4dba62487c0087b$export$4659b591c19bdf3d)(value, /flex-|baseline/)) return (0, $14f7c1b46e1d219f$export$71ad59f2e432cfe8) + 'grid-column-align' + (0, $a4dba62487c0087b$export$2f35ab04d2335697)(value, length) + value;
            break;
        // grid-template-(columns|rows)
        case 2592:
        case 3360:
            return (0, $14f7c1b46e1d219f$export$71ad59f2e432cfe8) + (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, 'template-', '') + value;
        // grid-(row|column)-start
        case 4384:
        case 3616:
            if (children && children.some(function(element, index) {
                return length = index, (0, $a4dba62487c0087b$export$4659b591c19bdf3d)(element.props, /grid-\w+-end/);
            })) return ~(0, $a4dba62487c0087b$export$f8e21b1e77979a08)(value + (children = children[length].value), 'span', 0) ? value : (0, $14f7c1b46e1d219f$export$71ad59f2e432cfe8) + (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, '-start', '') + value + (0, $14f7c1b46e1d219f$export$71ad59f2e432cfe8) + 'grid-row-span:' + (~(0, $a4dba62487c0087b$export$f8e21b1e77979a08)(children, 'span', 0) ? (0, $a4dba62487c0087b$export$4659b591c19bdf3d)(children, /\d+/) : +(0, $a4dba62487c0087b$export$4659b591c19bdf3d)(children, /\d+/) - +(0, $a4dba62487c0087b$export$4659b591c19bdf3d)(value, /\d+/)) + ';';
            return (0, $14f7c1b46e1d219f$export$71ad59f2e432cfe8) + (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, '-start', '') + value;
        // grid-(row|column)-end
        case 4896:
        case 4128:
            return children && children.some(function(element) {
                return (0, $a4dba62487c0087b$export$4659b591c19bdf3d)(element.props, /grid-\w+-start/);
            }) ? value : (0, $14f7c1b46e1d219f$export$71ad59f2e432cfe8) + (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)((0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, '-end', '-span'), 'span ', '') + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $a4dba62487c0087b$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $a4dba62487c0087b$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $a4dba62487c0087b$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93) + '$2-$3' + '$1' + (0, $14f7c1b46e1d219f$export$2c0f367103c8d01c) + ((0, $a4dba62487c0087b$export$a9db5e087081082d)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $a4dba62487c0087b$export$f8e21b1e77979a08)(value, 'stretch', 0) ? $55dc12b39f43b779$export$82e9f45cca5ba907((0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, 'stretch', 'fill-available'), length, children) + value : value;
            }
            break;
        // grid-(column|row)
        case 5152:
        case 5920:
            return (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(_, a, b, c, d, e, f) {
                return (0, $14f7c1b46e1d219f$export$71ad59f2e432cfe8) + a + ':' + b + f + (c ? (0, $14f7c1b46e1d219f$export$71ad59f2e432cfe8) + a + '-span:' + (d ? e : +e - +b) + f : '') + value;
            });
        // position: sticky
        case 4949:
            // stick(y)?
            if ((0, $a4dba62487c0087b$export$a9db5e087081082d)(value, length + 6) === 121) return (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93)) + value;
            break;
        // display: (flex|inline-flex|grid|inline-grid)
        case 6444:
            switch((0, $a4dba62487c0087b$export$a9db5e087081082d)(value, (0, $a4dba62487c0087b$export$a9db5e087081082d)(value, 14) === 45 ? 18 : 11)){
                // (inline-)?fle(x)
                case 120:
                    return (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, '$1' + (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93) + ((0, $a4dba62487c0087b$export$a9db5e087081082d)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93) + '$2$3' + '$1' + (0, $14f7c1b46e1d219f$export$71ad59f2e432cfe8) + '$2box$3') + value;
                // (inline-)?gri(d)
                case 100:
                    return (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $14f7c1b46e1d219f$export$71ad59f2e432cfe8)) + value;
            }
            break;
        // scroll-margin, scroll-margin-(top|right|bottom|left)
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, 'scroll-', 'scroll-snap-') + value;
    }
    return value;
}


function $66e69a28cf94fb87$export$5a7767152ae0305f(collection) {
    var length = (0, $a4dba62487c0087b$export$f9084667e487ed46)(collection);
    return function(element, index, children, callback) {
        var output = '';
        for(var i = 0; i < length; i++)output += collection[i](element, index, children, callback) || '';
        return output;
    };
}
function $66e69a28cf94fb87$export$38bcb760f1d4871c(callback) {
    return function(element) {
        if (!element.root) {
            if (element = element.return) callback(element);
        }
    };
}
function $66e69a28cf94fb87$export$e08c7d021b829b7a(element, index, children, callback) {
    if (element.length > -1) {
        if (!element.return) switch(element.type){
            case 0, $14f7c1b46e1d219f$export$527d108ccf083c2b:
                element.return = (0, $55dc12b39f43b779$export$82e9f45cca5ba907)(element.value, element.length, children);
                return;
            case 0, $14f7c1b46e1d219f$export$b44a8529a35fcb60:
                return (0, $4f9dba64a0f6480c$export$dfdc1655ccc5b9cb)([
                    (0, $091f67372881bac3$export$784d13d8ee351f07)(element, {
                        value: (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(element.value, '@', '@' + (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $14f7c1b46e1d219f$export$aa3a2e812ca8570d:
                if (element.length) return (0, $a4dba62487c0087b$export$1be1fc439b849fdf)(children = element.props, function(value) {
                    switch((0, $a4dba62487c0087b$export$4659b591c19bdf3d)(value, callback = /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            (0, $091f67372881bac3$export$590e8b2c435046d9)((0, $091f67372881bac3$export$784d13d8ee351f07)(element, {
                                props: [
                                    (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ':' + (0, $14f7c1b46e1d219f$export$2c0f367103c8d01c) + '$1')
                                ]
                            }));
                            (0, $091f67372881bac3$export$590e8b2c435046d9)((0, $091f67372881bac3$export$784d13d8ee351f07)(element, {
                                props: [
                                    value
                                ]
                            }));
                            (0, $a4dba62487c0087b$export$e6e34fd1f2686227)(element, {
                                props: (0, $a4dba62487c0087b$export$3dea766d36a8935f)(children, callback)
                            });
                            break;
                        // :placeholder
                        case '::placeholder':
                            (0, $091f67372881bac3$export$590e8b2c435046d9)((0, $091f67372881bac3$export$784d13d8ee351f07)(element, {
                                props: [
                                    (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93) + 'input-$1')
                                ]
                            }));
                            (0, $091f67372881bac3$export$590e8b2c435046d9)((0, $091f67372881bac3$export$784d13d8ee351f07)(element, {
                                props: [
                                    (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $14f7c1b46e1d219f$export$2c0f367103c8d01c) + '$1')
                                ]
                            }));
                            (0, $091f67372881bac3$export$590e8b2c435046d9)((0, $091f67372881bac3$export$784d13d8ee351f07)(element, {
                                props: [
                                    (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $14f7c1b46e1d219f$export$71ad59f2e432cfe8) + 'input-$1')
                                ]
                            }));
                            (0, $091f67372881bac3$export$590e8b2c435046d9)((0, $091f67372881bac3$export$784d13d8ee351f07)(element, {
                                props: [
                                    value
                                ]
                            }));
                            (0, $a4dba62487c0087b$export$e6e34fd1f2686227)(element, {
                                props: (0, $a4dba62487c0087b$export$3dea766d36a8935f)(children, callback)
                            });
                            break;
                    }
                    return '';
                });
        }
    }
}
function $66e69a28cf94fb87$export$76a88f7de6507443(element) {
    switch(element.type){
        case 0, $14f7c1b46e1d219f$export$aa3a2e812ca8570d:
            element.props = element.props.map(function(value) {
                return (0, $a4dba62487c0087b$export$1be1fc439b849fdf)((0, $091f67372881bac3$export$660b2ee2d4fb4eff)(value), function(value, index, children) {
                    switch((0, $a4dba62487c0087b$export$a9db5e087081082d)(value, 0)){
                        // \f
                        case 12:
                            return (0, $a4dba62487c0087b$export$2f35ab04d2335697)(value, 1, (0, $a4dba62487c0087b$export$36776f635604f274)(value));
                        // \0 ( + > ~
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return value;
                        // :
                        case 58:
                            if (children[++index] === 'global') children[index] = '', children[++index] = '\f' + (0, $a4dba62487c0087b$export$2f35ab04d2335697)(children[index], index = 1, -1);
                        // \s
                        case 32:
                            return index === 1 ? '' : value;
                        default:
                            switch(index){
                                case 0:
                                    element = value;
                                    return (0, $a4dba62487c0087b$export$f9084667e487ed46)(children) > 1 ? '' : value;
                                case index = (0, $a4dba62487c0087b$export$f9084667e487ed46)(children) - 1:
                                case 2:
                                    return index === 2 ? value + element + element : value + element;
                                default:
                                    return value;
                            }
                    }
                });
            });
    }
}



function $b9068c360a61892c$export$e7b7955c4f1f8c03(message, info) {
    const { path: path, parentSelectors: parentSelectors } = info;
    (0, $6591254ed6bd1058$export$2e2bcd8739ae039)(false, `[Ant Design CSS-in-JS] ${path ? `Error in ${path}: ` : ''}${message}${parentSelectors.length ? ` Selector: ${parentSelectors.join(' | ')}` : ''}`);
}


const $ee95ece3d233b883$var$linter = (key, value, info)=>{
    if (key === 'content') {
        // From emotion: https://github.com/emotion-js/emotion/blob/main/packages/serialize/src/index.js#L63
        const contentValuePattern = /(attr|counters?|url|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/;
        const contentValues = [
            'normal',
            'none',
            'initial',
            'inherit',
            'unset'
        ];
        if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && !value.startsWith('var(') && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) (0, $b9068c360a61892c$export$e7b7955c4f1f8c03)(`You seem to be using a value for 'content' without quotes, try replacing it with \`content: '"${value}"'\`.`, info);
    }
};
var $ee95ece3d233b883$export$2e2bcd8739ae039 = $ee95ece3d233b883$var$linter;



const $42235202492cec71$var$linter = (key, value, info)=>{
    if (key === 'animation') {
        if (info.hashId && value !== 'none') (0, $b9068c360a61892c$export$e7b7955c4f1f8c03)(`You seem to be using hashed animation '${value}', in which case 'animationName' with Keyframe as value is recommended.`, info);
    }
};
var $42235202492cec71$export$2e2bcd8739ae039 = $42235202492cec71$var$linter;



function $fe931858b746c4c4$var$isConcatSelector(selector) {
    const notContent = selector.match(/:not\(([^)]*)\)/)?.[1] || '';
    // split selector. e.g.
    // `h1#a.b` => ['h1', #a', '.b']
    const splitCells = notContent.split(/(\[[^[]*])|(?=[.#])/).filter((str)=>str);
    return splitCells.length > 1;
}
function $fe931858b746c4c4$var$parsePath(info) {
    return info.parentSelectors.reduce((prev, cur)=>{
        if (!prev) return cur;
        return cur.includes('&') ? cur.replace(/&/g, prev) : `${prev} ${cur}`;
    }, '');
}
const $fe931858b746c4c4$var$linter = (key, value, info)=>{
    const parentSelectorPath = $fe931858b746c4c4$var$parsePath(info);
    const notList = parentSelectorPath.match(/:not\([^)]*\)/g) || [];
    if (notList.length > 0 && notList.some($fe931858b746c4c4$var$isConcatSelector)) (0, $b9068c360a61892c$export$e7b7955c4f1f8c03)(`Concat ':not' selector not support in legacy browsers.`, info);
};
var $fe931858b746c4c4$export$2e2bcd8739ae039 = $fe931858b746c4c4$var$linter;



const $b0ecf2e899f9da18$var$linter = (key, value, info)=>{
    switch(key){
        case 'marginLeft':
        case 'marginRight':
        case 'paddingLeft':
        case 'paddingRight':
        case 'left':
        case 'right':
        case 'borderLeft':
        case 'borderLeftWidth':
        case 'borderLeftStyle':
        case 'borderLeftColor':
        case 'borderRight':
        case 'borderRightWidth':
        case 'borderRightStyle':
        case 'borderRightColor':
        case 'borderTopLeftRadius':
        case 'borderTopRightRadius':
        case 'borderBottomLeftRadius':
        case 'borderBottomRightRadius':
            (0, $b9068c360a61892c$export$e7b7955c4f1f8c03)(`You seem to be using non-logical property '${key}' which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties.`, info);
            return;
        case 'margin':
        case 'padding':
        case 'borderWidth':
        case 'borderStyle':
            // case 'borderColor':
            if (typeof value === 'string') {
                const valueArr = value.split(' ').map((item)=>item.trim());
                if (valueArr.length === 4 && valueArr[1] !== valueArr[3]) (0, $b9068c360a61892c$export$e7b7955c4f1f8c03)(`You seem to be using '${key}' property with different left ${key} and right ${key}, which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties.`, info);
            }
            return;
        case 'clear':
        case 'textAlign':
            if (value === 'left' || value === 'right') (0, $b9068c360a61892c$export$e7b7955c4f1f8c03)(`You seem to be using non-logical value '${value}' of ${key}, which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties.`, info);
            return;
        case 'borderRadius':
            if (typeof value === 'string') {
                const radiusGroups = value.split('/').map((item)=>item.trim());
                const invalid = radiusGroups.reduce((result, group)=>{
                    if (result) return result;
                    const radiusArr = group.split(' ').map((item)=>item.trim());
                    // borderRadius: '2px 4px'
                    if (radiusArr.length >= 2 && radiusArr[0] !== radiusArr[1]) return true;
                    // borderRadius: '4px 4px 2px'
                    if (radiusArr.length === 3 && radiusArr[1] !== radiusArr[2]) return true;
                    // borderRadius: '4px 4px 2px 4px'
                    if (radiusArr.length === 4 && radiusArr[2] !== radiusArr[3]) return true;
                    return result;
                }, false);
                if (invalid) (0, $b9068c360a61892c$export$e7b7955c4f1f8c03)(`You seem to be using non-logical value '${value}' of ${key}, which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties.`, info);
            }
            return;
        default:
    }
};
var $b0ecf2e899f9da18$export$2e2bcd8739ae039 = $b0ecf2e899f9da18$var$linter;



const $fb2029c84b61203f$var$linter = (key, value, info)=>{
    if (typeof value === 'string' && /NaN/g.test(value) || Number.isNaN(value)) (0, $b9068c360a61892c$export$e7b7955c4f1f8c03)(`Unexpected 'NaN' in property '${key}: ${value}'.`, info);
};
var $fb2029c84b61203f$export$2e2bcd8739ae039 = $fb2029c84b61203f$var$linter;



const $79b9f80398ff64bd$var$linter = (key, value, info)=>{
    if (info.parentSelectors.some((selector)=>{
        const selectors = selector.split(',');
        return selectors.some((item)=>item.split('&').length > 2);
    })) (0, $b9068c360a61892c$export$e7b7955c4f1f8c03)('Should not use more than one `&` in a selector.', info);
};
var $79b9f80398ff64bd$export$2e2bcd8739ae039 = $79b9f80398ff64bd$var$linter;








const $feede5f73252ebe3$export$1c054aa01963e47e = 'data-ant-cssinjs-cache-path';
const $feede5f73252ebe3$export$e0a2f8ff7fc63361 = '_FILE_STYLE__';
function $feede5f73252ebe3$export$dfdc1655ccc5b9cb(cachePathMap) {
    return Object.keys(cachePathMap).map((path)=>{
        const hash = cachePathMap[path];
        return `${path}:${hash}`;
    }).join(';');
}
let $feede5f73252ebe3$var$cachePathMap;
let $feede5f73252ebe3$var$fromCSSFile = true;
function $feede5f73252ebe3$export$aad8462122ac592b(mockCache, fromFile = true) {
    $feede5f73252ebe3$var$cachePathMap = mockCache;
    $feede5f73252ebe3$var$fromCSSFile = fromFile;
}
function $feede5f73252ebe3$export$18298bb220d85216() {
    if (!$feede5f73252ebe3$var$cachePathMap) {
        $feede5f73252ebe3$var$cachePathMap = {};
        if ((0, $bfbc54ac1ac0215e$export$2e2bcd8739ae039)()) {
            const div = document.createElement('div');
            div.className = $feede5f73252ebe3$export$1c054aa01963e47e;
            div.style.position = 'fixed';
            div.style.visibility = 'hidden';
            div.style.top = '-9999px';
            document.body.appendChild(div);
            let content = getComputedStyle(div).content || '';
            content = content.replace(/^"/, '').replace(/"$/, '');
            // Fill data
            content.split(';').forEach((item)=>{
                const [path, hash] = item.split(':');
                $feede5f73252ebe3$var$cachePathMap[path] = hash;
            });
            // Remove inline record style
            const inlineMapStyle = document.querySelector(`style[${$feede5f73252ebe3$export$1c054aa01963e47e}]`);
            if (inlineMapStyle) {
                $feede5f73252ebe3$var$fromCSSFile = false;
                inlineMapStyle.parentNode?.removeChild(inlineMapStyle);
            }
            document.body.removeChild(div);
        }
    }
}
function $feede5f73252ebe3$export$5aa0d776d676ab98(path) {
    $feede5f73252ebe3$export$18298bb220d85216();
    return !!$feede5f73252ebe3$var$cachePathMap[path];
}
function $feede5f73252ebe3$export$d3851dfd3659b2ce(path) {
    const hash = $feede5f73252ebe3$var$cachePathMap[path];
    let styleStr = null;
    if (hash && (0, $bfbc54ac1ac0215e$export$2e2bcd8739ae039)()) {
        if ($feede5f73252ebe3$var$fromCSSFile) styleStr = $feede5f73252ebe3$export$e0a2f8ff7fc63361;
        else {
            const style = document.querySelector(`style[${(0, $c756b57cbfcd44a7$export$89ce1123b3c0bd9e)}="${$feede5f73252ebe3$var$cachePathMap[path]}"]`);
            if (style) styleStr = style.innerHTML;
            else // Clean up since not exist anymore
            delete $feede5f73252ebe3$var$cachePathMap[path];
        }
    }
    return [
        styleStr,
        hash
    ];
}



const $b7e482f3ef1994cd$var$SKIP_CHECK = '_skip_check_';
const $b7e482f3ef1994cd$var$MULTI_VALUE = '_multi_value_';
function $b7e482f3ef1994cd$export$8756898546458274(styleStr, autoPrefix) {
    const serialized = autoPrefix ? (0, $4f9dba64a0f6480c$export$dfdc1655ccc5b9cb)((0, $0da293b81cdc2df3$export$ef7acd7185315e22)(styleStr), (0, $66e69a28cf94fb87$export$5a7767152ae0305f)([
        (0, $66e69a28cf94fb87$export$e08c7d021b829b7a),
        (0, $4f9dba64a0f6480c$export$fac44ee5b035f737)
    ])) : (0, $4f9dba64a0f6480c$export$dfdc1655ccc5b9cb)((0, $0da293b81cdc2df3$export$ef7acd7185315e22)(styleStr), (0, $4f9dba64a0f6480c$export$fac44ee5b035f737));
    return serialized.replace(/\{%%%\:[^;];}/g, ';');
}
function $b7e482f3ef1994cd$var$isCompoundCSSProperty(value) {
    return typeof value === 'object' && value && ($b7e482f3ef1994cd$var$SKIP_CHECK in value || $b7e482f3ef1994cd$var$MULTI_VALUE in value);
}
// 注入 hash 值
function $b7e482f3ef1994cd$var$injectSelectorHash(key, hashId, hashPriority) {
    if (!hashId) return key;
    const hashClassName = `.${hashId}`;
    const hashSelector = hashPriority === 'low' ? `:where(${hashClassName})` : hashClassName;
    // 注入 hashId
    const keys = key.split(',').map((k)=>{
        const fullPath = k.trim().split(/\s+/);
        // 如果 Selector 第一个是 HTML Element，那我们就插到它的后面。反之，就插到最前面。
        let firstPath = fullPath[0] || '';
        const htmlElement = firstPath.match(/^\w+/)?.[0] || '';
        firstPath = `${htmlElement}${hashSelector}${firstPath.slice(htmlElement.length)}`;
        return [
            firstPath,
            ...fullPath.slice(1)
        ].join(' ');
    });
    return keys.join(',');
}
const $b7e482f3ef1994cd$export$e13dc740254f53d7 = (interpolation, config = {}, { root: root, injectHash: injectHash, parentSelectors: parentSelectors } = {
    root: true,
    parentSelectors: []
})=>{
    const { hashId: hashId, layer: layer, path: path, hashPriority: hashPriority, transformers: transformers = [], linters: linters = [] } = config;
    let styleStr = '';
    let effectStyle = {};
    function parseKeyframes(keyframes) {
        const animationName = keyframes.getName(hashId);
        if (!effectStyle[animationName]) {
            const [parsedStr] = $b7e482f3ef1994cd$export$e13dc740254f53d7(keyframes.style, config, {
                root: false,
                parentSelectors: parentSelectors
            });
            effectStyle[animationName] = `@keyframes ${keyframes.getName(hashId)}${parsedStr}`;
        }
    }
    function flattenList(list, fullList = []) {
        list.forEach((item)=>{
            if (Array.isArray(item)) flattenList(item, fullList);
            else if (item) fullList.push(item);
        });
        return fullList;
    }
    const flattenStyleList = flattenList(Array.isArray(interpolation) ? interpolation : [
        interpolation
    ]);
    flattenStyleList.forEach((originStyle)=>{
        // Only root level can use raw string
        const style = typeof originStyle === 'string' && !root ? {} : originStyle;
        if (typeof style === 'string') styleStr += `${style}\n`;
        else if (style._keyframe) // Keyframe
        parseKeyframes(style);
        else {
            const mergedStyle = transformers.reduce((prev, trans)=>trans?.visit?.(prev) || prev, style);
            // Normal CSSObject
            Object.keys(mergedStyle).forEach((key)=>{
                const value = mergedStyle[key];
                if (typeof value === 'object' && value && (key !== 'animationName' || !value._keyframe) && !$b7e482f3ef1994cd$var$isCompoundCSSProperty(value)) {
                    let subInjectHash = false;
                    // 当成嵌套对象来处理
                    let mergedKey = key.trim();
                    // Whether treat child as root. In most case it is false.
                    let nextRoot = false;
                    // 拆分多个选择器
                    if ((root || injectHash) && hashId) {
                        if (mergedKey.startsWith('@')) // 略过媒体查询，交给子节点继续插入 hashId
                        subInjectHash = true;
                        else if (mergedKey === '&') // 抹掉 root selector 上的单个 &
                        mergedKey = $b7e482f3ef1994cd$var$injectSelectorHash('', hashId, hashPriority);
                        else // 注入 hashId
                        mergedKey = $b7e482f3ef1994cd$var$injectSelectorHash(key, hashId, hashPriority);
                    } else if (root && !hashId && (mergedKey === '&' || mergedKey === '')) {
                        // In case of `{ '&': { a: { color: 'red' } } }` or `{ '': { a: { color: 'red' } } }` without hashId,
                        // we will get `&{a:{color:red;}}` or `{a:{color:red;}}` string for stylis to compile.
                        // But it does not conform to stylis syntax,
                        // and finally we will get `{color:red;}` as css, which is wrong.
                        // So we need to remove key in root, and treat child `{ a: { color: 'red' } }` as root.
                        mergedKey = '';
                        nextRoot = true;
                    }
                    const [parsedStr, childEffectStyle] = $b7e482f3ef1994cd$export$e13dc740254f53d7(value, config, {
                        root: nextRoot,
                        injectHash: subInjectHash,
                        parentSelectors: [
                            ...parentSelectors,
                            mergedKey
                        ]
                    });
                    effectStyle = {
                        ...effectStyle,
                        ...childEffectStyle
                    };
                    styleStr += `${mergedKey}${parsedStr}`;
                } else {
                    function appendStyle(cssKey, cssValue) {
                        var linter;
                        // 如果是样式则直接插入
                        const styleName = cssKey.replace(/[A-Z]/g, (match)=>`-${match.toLowerCase()}`);
                        // Auto suffix with px
                        let formatValue = cssValue;
                        if (!(0, $885f4eee88e48c11$export$2e2bcd8739ae039)[cssKey] && typeof formatValue === 'number' && formatValue !== 0) formatValue = `${formatValue}px`;
                        // handle animationName & Keyframe value
                        if (cssKey === 'animationName' && cssValue?._keyframe) {
                            parseKeyframes(cssValue);
                            formatValue = cssValue.getName(hashId);
                        }
                        styleStr += `${styleName}:${formatValue};`;
                    }
                    const actualValue = value?.value ?? value;
                    if (typeof value === 'object' && value?.[$b7e482f3ef1994cd$var$MULTI_VALUE] && Array.isArray(actualValue)) actualValue.forEach((item)=>{
                        appendStyle(key, item);
                    });
                    else appendStyle(key, actualValue);
                }
            });
        }
    });
    if (!root) styleStr = `{${styleStr}}`;
    else if (layer) {
        // fixme: https://github.com/thysultan/stylis/pull/339
        if (styleStr) styleStr = `@layer ${layer.name} {${styleStr}}`;
        if (layer.dependencies) effectStyle[`@layer ${layer.name}`] = layer.dependencies.map((deps)=>`@layer ${deps}, ${layer.name};`).join('\n');
    }
    return [
        styleStr,
        effectStyle
    ];
};
function $b7e482f3ef1994cd$export$412618713057f6ca(path, styleStr) {
    return (0, $265e8c0f7074eb72$export$2e2bcd8739ae039)(`${path.join('%')}${styleStr}`);
}
const $b7e482f3ef1994cd$export$1e6d9f0d06c7ec14 = 'style';
function $b7e482f3ef1994cd$export$2e2bcd8739ae039(info, styleFn) {
    const { path: path, hashId: hashId, layer: layer, nonce: nonce, clientOnly: clientOnly, order: order = 0 } = info;
    const { mock: mock, hashPriority: hashPriority, container: container, transformers: transformers, linters: linters, cache: cache, layer: enableLayer, autoPrefix: autoPrefix } = $32rMB.useContext((0, $c756b57cbfcd44a7$export$2e2bcd8739ae039));
    const fullPath = [
        hashId || ''
    ];
    if (enableLayer) fullPath.push('layer');
    fullPath.push(...path);
    // Check if need insert style
    let isMergedClientSide = (0, $763a5b4b58d0a3ff$export$9542afab8c2a5f48);
    (0, $4acdafa780258ac9$export$2e2bcd8739ae039)($b7e482f3ef1994cd$export$1e6d9f0d06c7ec14, fullPath, // Create cache if needed
    ()=>{
        const cachePath = fullPath.join('|');
        // Get style from SSR inline style directly
        if ((0, $feede5f73252ebe3$export$5aa0d776d676ab98)(cachePath)) {
            const [inlineCacheStyleStr, styleHash] = (0, $feede5f73252ebe3$export$d3851dfd3659b2ce)(cachePath);
            if (inlineCacheStyleStr) return [
                inlineCacheStyleStr,
                styleHash,
                {},
                clientOnly,
                order
            ];
        }
        // Generate style
        const styleObj = styleFn();
        const [parsedStyle, effectStyle] = $b7e482f3ef1994cd$export$e13dc740254f53d7(styleObj, {
            hashId: hashId,
            hashPriority: hashPriority,
            layer: enableLayer ? layer : undefined,
            path: path.join('-'),
            transformers: transformers,
            linters: linters
        });
        const styleStr = $b7e482f3ef1994cd$export$8756898546458274(parsedStyle, autoPrefix || false);
        const styleId = $b7e482f3ef1994cd$export$412618713057f6ca(fullPath, styleStr);
        return [
            styleStr,
            styleId,
            effectStyle,
            clientOnly,
            order
        ];
    }, // Remove cache if no need
    (cacheValue, fromHMR)=>{
        const [, styleId] = cacheValue;
        if (fromHMR && (0, $763a5b4b58d0a3ff$export$9542afab8c2a5f48)) (0, $275621885d66fa13$export$2232e336aecaa80a)(styleId, {
            mark: (0, $c756b57cbfcd44a7$export$89ce1123b3c0bd9e),
            attachTo: container
        });
    }, // Effect: Inject style here
    (cacheValue)=>{
        const [styleStr, styleId, effectStyle, , priority] = cacheValue;
        if (isMergedClientSide && styleStr !== (0, $feede5f73252ebe3$export$e0a2f8ff7fc63361)) {
            const mergedCSSConfig = {
                mark: (0, $c756b57cbfcd44a7$export$89ce1123b3c0bd9e),
                prepend: enableLayer ? false : 'queue',
                attachTo: container,
                priority: priority
            };
            const nonceStr = typeof nonce === 'function' ? nonce() : nonce;
            if (nonceStr) mergedCSSConfig.csp = {
                nonce: nonceStr
            };
            // ================= Split Effect Style =================
            // We will split effectStyle here since @layer should be at the top level
            const effectLayerKeys = [];
            const effectRestKeys = [];
            Object.keys(effectStyle).forEach((key)=>{
                if (key.startsWith('@layer')) effectLayerKeys.push(key);
                else effectRestKeys.push(key);
            });
            // ================= Inject Layer Style =================
            // Inject layer style
            effectLayerKeys.forEach((effectKey)=>{
                (0, $275621885d66fa13$export$4d99a2890bb989f0)($b7e482f3ef1994cd$export$8756898546458274(effectStyle[effectKey], autoPrefix || false), `_layer-${effectKey}`, {
                    ...mergedCSSConfig,
                    prepend: true
                });
            });
            // ==================== Inject Style ====================
            // Inject style
            const style = (0, $275621885d66fa13$export$4d99a2890bb989f0)(styleStr, styleId, mergedCSSConfig);
            style[0, $c756b57cbfcd44a7$export$4c16a0c02134a7dc] = cache.instanceId;
            // ================ Inject Effect Style =================
            // Inject client side effect style
            effectRestKeys.forEach((effectKey)=>{
                (0, $275621885d66fa13$export$4d99a2890bb989f0)($b7e482f3ef1994cd$export$8756898546458274(effectStyle[effectKey], autoPrefix || false), `_effect-${effectKey}`, mergedCSSConfig);
            });
        }
    });
}
const $b7e482f3ef1994cd$export$f9380c9a627682d3 = (cache, effectStyles, options)=>{
    const [styleStr, styleId, effectStyle, clientOnly, order] = cache;
    const { plain: plain, autoPrefix: autoPrefix } = options || {};
    // Skip client only style
    if (clientOnly) return null;
    let keyStyleText = styleStr;
    // ====================== Share ======================
    // Used for @rc-component/util
    const sharedAttrs = {
        'data-rc-order': 'prependQueue',
        'data-rc-priority': `${order}`
    };
    // ====================== Style ======================
    keyStyleText = (0, $763a5b4b58d0a3ff$export$71c98ec84f0481d3)(styleStr, undefined, styleId, sharedAttrs, plain);
    // =============== Create effect style ===============
    if (effectStyle) Object.keys(effectStyle).forEach((effectKey)=>{
        // Effect style can be reused
        if (!effectStyles[effectKey]) {
            effectStyles[effectKey] = true;
            const effectStyleStr = $b7e482f3ef1994cd$export$8756898546458274(effectStyle[effectKey], autoPrefix || false);
            const effectStyleHTML = (0, $763a5b4b58d0a3ff$export$71c98ec84f0481d3)(effectStyleStr, undefined, `_effect-${effectKey}`, sharedAttrs, plain);
            if (effectKey.startsWith('@layer')) keyStyleText = effectStyleHTML + keyStyleText;
            else keyStyleText += effectStyleHTML;
        }
    });
    return [
        order,
        styleId,
        keyStyleText
    ];
};


const $d16eb0e0ba680681$export$d96c342855c5e1fc = 'cssVar';
const $d16eb0e0ba680681$var$useCSSVarRegister = (config, fn)=>{
    const { key: key, prefix: prefix, unitless: unitless, ignore: ignore, token: token, hashId: hashId, scope: scope = '' } = config;
    const { cache: { instanceId: instanceId }, container: container, hashPriority: hashPriority } = (0, $32rMB.useContext)((0, $c756b57cbfcd44a7$export$2e2bcd8739ae039));
    const { _tokenKey: tokenKey } = token;
    const stylePath = [
        ...config.path,
        key,
        scope,
        tokenKey
    ];
    const cache = (0, $4acdafa780258ac9$export$2e2bcd8739ae039)($d16eb0e0ba680681$export$d96c342855c5e1fc, stylePath, ()=>{
        const originToken = fn();
        const [mergedToken, cssVarsStr] = (0, $76923c7bf027319b$export$67858afe85bce49f)(originToken, key, {
            prefix: prefix,
            unitless: unitless,
            ignore: ignore,
            scope: scope,
            hashPriority: hashPriority,
            hashCls: hashId
        });
        const styleId = (0, $b7e482f3ef1994cd$export$412618713057f6ca)(stylePath, cssVarsStr);
        return [
            mergedToken,
            cssVarsStr,
            styleId,
            key
        ];
    }, ([, , styleId])=>{
        if (0, $763a5b4b58d0a3ff$export$9542afab8c2a5f48) (0, $275621885d66fa13$export$2232e336aecaa80a)(styleId, {
            mark: (0, $c756b57cbfcd44a7$export$89ce1123b3c0bd9e),
            attachTo: container
        });
    }, ([, cssVarsStr, styleId])=>{
        if (!cssVarsStr) return;
        const style = (0, $275621885d66fa13$export$4d99a2890bb989f0)(cssVarsStr, styleId, {
            mark: (0, $c756b57cbfcd44a7$export$89ce1123b3c0bd9e),
            prepend: 'queue',
            attachTo: container,
            priority: -999
        });
        style[0, $c756b57cbfcd44a7$export$4c16a0c02134a7dc] = instanceId;
        // Used for `useCacheToken` to remove on batch when token removed
        style.setAttribute((0, $c756b57cbfcd44a7$export$5d99297dcd5476ac), key);
    });
    return cache;
};
const $d16eb0e0ba680681$export$f9380c9a627682d3 = (cache, effectStyles, options)=>{
    const [, styleStr, styleId, cssVarKey] = cache;
    const { plain: plain } = options || {};
    if (!styleStr) return null;
    const order = -999;
    // ====================== Style ======================
    // Used for @rc-component/util
    const sharedAttrs = {
        'data-rc-order': 'prependQueue',
        'data-rc-priority': `${order}`
    };
    const styleText = (0, $763a5b4b58d0a3ff$export$71c98ec84f0481d3)(styleStr, cssVarKey, styleId, sharedAttrs, plain);
    return [
        order,
        styleId,
        styleText
    ];
};
var $d16eb0e0ba680681$export$2e2bcd8739ae039 = $d16eb0e0ba680681$var$useCSSVarRegister;





const $c855eca5b23fd129$var$ExtractStyleFns = {
    [(0, $b7e482f3ef1994cd$export$1e6d9f0d06c7ec14)]: (0, $b7e482f3ef1994cd$export$f9380c9a627682d3),
    [(0, $3ec6f7f6664c21fe$export$270fba097347f4fa)]: (0, $3ec6f7f6664c21fe$export$f9380c9a627682d3),
    [(0, $d16eb0e0ba680681$export$d96c342855c5e1fc)]: (0, $d16eb0e0ba680681$export$f9380c9a627682d3)
};
function $c855eca5b23fd129$var$isNotNull(value) {
    return value !== null;
}
function $c855eca5b23fd129$export$2e2bcd8739ae039(cache, options) {
    const { plain: plain = false, types: types = [
        'style',
        'token',
        'cssVar'
    ], once: once = false } = typeof options === 'boolean' ? {
        plain: options
    } : options || {};
    const matchPrefixRegexp = new RegExp(`^(${(typeof types === 'string' ? [
        types
    ] : types).join('|')})%`);
    // prefix with `style` is used for `useStyleRegister` to cache style context
    const styleKeys = Array.from(cache.cache.keys()).filter((key)=>matchPrefixRegexp.test(key));
    // Common effect styles like animation
    const effectStyles = {};
    // Mapping of cachePath to style hash
    const cachePathMap = {};
    let styleText = '';
    styleKeys.map((key)=>{
        if (once && cache.extracted.has(key)) return null; // Skip if already extracted
        const cachePath = key.replace(matchPrefixRegexp, '').replace(/%/g, '|');
        const [prefix] = key.split('%');
        const extractFn = $c855eca5b23fd129$var$ExtractStyleFns[prefix];
        const extractedStyle = extractFn(cache.cache.get(key)[1], effectStyles, {
            plain: plain
        });
        if (!extractedStyle) return null;
        const updateTime = cache.updateTimes.get(key) || 0;
        const [order, styleId, styleStr] = extractedStyle;
        if (key.startsWith('style')) cachePathMap[cachePath] = styleId;
        // record that this style has been extracted
        cache.extracted.add(key);
        return [
            order,
            styleStr,
            updateTime
        ];
    }).filter($c855eca5b23fd129$var$isNotNull).sort(([o1, , u1], [o2, , u2])=>{
        if (o1 !== o2) return o1 - o2;
        return u1 - u2;
    }).forEach(([, style])=>{
        styleText += style;
    });
    // ==================== Fill Cache Path ====================
    styleText += (0, $763a5b4b58d0a3ff$export$71c98ec84f0481d3)(`.${(0, $feede5f73252ebe3$export$1c054aa01963e47e)}{content:"${(0, $feede5f73252ebe3$export$dfdc1655ccc5b9cb)(cachePathMap)}";}`, undefined, undefined, {
        [(0, $feede5f73252ebe3$export$1c054aa01963e47e)]: (0, $feede5f73252ebe3$export$1c054aa01963e47e)
    }, plain);
    return styleText;
}





class $f806545df26bb0b4$var$Keyframe {
    name;
    style;
    constructor(name, style){
        this.name = name;
        this.style = style;
    }
    getName(hashId = '') {
        return hashId ? `${hashId}-${this.name}` : this.name;
    }
    _keyframe = true;
}
var $f806545df26bb0b4$export$2e2bcd8739ae039 = $f806545df26bb0b4$var$Keyframe;






function $dc1797a4c67f216d$var$splitValues(value) {
    if (typeof value === 'number') return [
        [
            value
        ],
        false
    ];
    const rawStyle = String(value).trim();
    const importantCells = rawStyle.match(/(.*)(!important)/);
    const splitStyle = (importantCells ? importantCells[1] : rawStyle).trim().split(/\s+/);
    // Combine styles split in brackets, like `calc(1px + 2px)`
    let temp = [];
    let brackets = 0;
    return [
        splitStyle.reduce((list, item)=>{
            if (item.includes('(') || item.includes(')')) {
                const left = item.split('(').length - 1;
                const right = item.split(')').length - 1;
                brackets += left - right;
            }
            if (brackets >= 0) temp.push(item);
            if (brackets === 0) {
                list.push(temp.join(' '));
                temp = [];
            }
            return list;
        }, []),
        !!importantCells
    ];
}
function $dc1797a4c67f216d$var$noSplit(list) {
    list.notSplit = true;
    return list;
}
const $dc1797a4c67f216d$var$keyMap = {
    // Inset
    inset: [
        'top',
        'right',
        'bottom',
        'left'
    ],
    insetBlock: [
        'top',
        'bottom'
    ],
    insetBlockStart: [
        'top'
    ],
    insetBlockEnd: [
        'bottom'
    ],
    insetInline: [
        'left',
        'right'
    ],
    insetInlineStart: [
        'left'
    ],
    insetInlineEnd: [
        'right'
    ],
    // Margin
    marginBlock: [
        'marginTop',
        'marginBottom'
    ],
    marginBlockStart: [
        'marginTop'
    ],
    marginBlockEnd: [
        'marginBottom'
    ],
    marginInline: [
        'marginLeft',
        'marginRight'
    ],
    marginInlineStart: [
        'marginLeft'
    ],
    marginInlineEnd: [
        'marginRight'
    ],
    // Padding
    paddingBlock: [
        'paddingTop',
        'paddingBottom'
    ],
    paddingBlockStart: [
        'paddingTop'
    ],
    paddingBlockEnd: [
        'paddingBottom'
    ],
    paddingInline: [
        'paddingLeft',
        'paddingRight'
    ],
    paddingInlineStart: [
        'paddingLeft'
    ],
    paddingInlineEnd: [
        'paddingRight'
    ],
    // Border
    borderBlock: $dc1797a4c67f216d$var$noSplit([
        'borderTop',
        'borderBottom'
    ]),
    borderBlockStart: $dc1797a4c67f216d$var$noSplit([
        'borderTop'
    ]),
    borderBlockEnd: $dc1797a4c67f216d$var$noSplit([
        'borderBottom'
    ]),
    borderInline: $dc1797a4c67f216d$var$noSplit([
        'borderLeft',
        'borderRight'
    ]),
    borderInlineStart: $dc1797a4c67f216d$var$noSplit([
        'borderLeft'
    ]),
    borderInlineEnd: $dc1797a4c67f216d$var$noSplit([
        'borderRight'
    ]),
    // Border width
    borderBlockWidth: [
        'borderTopWidth',
        'borderBottomWidth'
    ],
    borderBlockStartWidth: [
        'borderTopWidth'
    ],
    borderBlockEndWidth: [
        'borderBottomWidth'
    ],
    borderInlineWidth: [
        'borderLeftWidth',
        'borderRightWidth'
    ],
    borderInlineStartWidth: [
        'borderLeftWidth'
    ],
    borderInlineEndWidth: [
        'borderRightWidth'
    ],
    // Border style
    borderBlockStyle: [
        'borderTopStyle',
        'borderBottomStyle'
    ],
    borderBlockStartStyle: [
        'borderTopStyle'
    ],
    borderBlockEndStyle: [
        'borderBottomStyle'
    ],
    borderInlineStyle: [
        'borderLeftStyle',
        'borderRightStyle'
    ],
    borderInlineStartStyle: [
        'borderLeftStyle'
    ],
    borderInlineEndStyle: [
        'borderRightStyle'
    ],
    // Border color
    borderBlockColor: [
        'borderTopColor',
        'borderBottomColor'
    ],
    borderBlockStartColor: [
        'borderTopColor'
    ],
    borderBlockEndColor: [
        'borderBottomColor'
    ],
    borderInlineColor: [
        'borderLeftColor',
        'borderRightColor'
    ],
    borderInlineStartColor: [
        'borderLeftColor'
    ],
    borderInlineEndColor: [
        'borderRightColor'
    ],
    // Border radius
    borderStartStartRadius: [
        'borderTopLeftRadius'
    ],
    borderStartEndRadius: [
        'borderTopRightRadius'
    ],
    borderEndStartRadius: [
        'borderBottomLeftRadius'
    ],
    borderEndEndRadius: [
        'borderBottomRightRadius'
    ]
};
function $dc1797a4c67f216d$var$wrapImportantAndSkipCheck(value, important) {
    let parsedValue = value;
    if (important) parsedValue = `${parsedValue} !important`;
    return {
        _skip_check_: true,
        value: parsedValue
    };
}
/**
 * Convert css logical properties to legacy properties.
 * Such as: `margin-block-start` to `margin-top`.
 * Transform list:
 * - inset
 * - margin
 * - padding
 * - border
 */ const $dc1797a4c67f216d$var$transform = {
    visit: (cssObj)=>{
        const clone = {};
        Object.keys(cssObj).forEach((key)=>{
            const value = cssObj[key];
            const matchValue = $dc1797a4c67f216d$var$keyMap[key];
            if (matchValue && (typeof value === 'number' || typeof value === 'string')) {
                const [values, important] = $dc1797a4c67f216d$var$splitValues(value);
                if (matchValue.length && matchValue.notSplit) // not split means always give same value like border
                matchValue.forEach((matchKey)=>{
                    clone[matchKey] = $dc1797a4c67f216d$var$wrapImportantAndSkipCheck(value, important);
                });
                else if (matchValue.length === 1) // Handle like `marginBlockStart` => `marginTop`
                clone[matchValue[0]] = $dc1797a4c67f216d$var$wrapImportantAndSkipCheck(values[0], important);
                else if (matchValue.length === 2) // Handle like `marginBlock` => `marginTop` & `marginBottom`
                matchValue.forEach((matchKey, index)=>{
                    clone[matchKey] = $dc1797a4c67f216d$var$wrapImportantAndSkipCheck(values[index] ?? values[0], important);
                });
                else if (matchValue.length === 4) // Handle like `inset` => `top` & `right` & `bottom` & `left`
                matchValue.forEach((matchKey, index)=>{
                    clone[matchKey] = $dc1797a4c67f216d$var$wrapImportantAndSkipCheck(values[index] ?? values[index - 2] ?? values[0], important);
                });
                else clone[key] = value;
            } else clone[key] = value;
        });
        return clone;
    }
};
var $dc1797a4c67f216d$export$2e2bcd8739ae039 = $dc1797a4c67f216d$var$transform;


/**
 * respect https://github.com/cuth/postcss-pxtorem
 */ // @ts-ignore

const $0d66bcfa8a8a56e9$var$pxRegex = /url\([^)]+\)|var\([^)]+\)|(\d*\.?\d+)px/g;
function $0d66bcfa8a8a56e9$var$toFixed(number, precision) {
    const multiplier = Math.pow(10, precision + 1), wholeNumber = Math.floor(number * multiplier);
    return Math.round(wholeNumber / 10) * 10 / multiplier;
}
const $0d66bcfa8a8a56e9$var$transform = (options = {})=>{
    const { rootValue: rootValue = 16, precision: precision = 5, mediaQuery: mediaQuery = false } = options;
    const pxReplace = (m, $1)=>{
        if (!$1) return m;
        const pixels = parseFloat($1);
        // covenant: pixels <= 1, not transform to rem @zombieJ
        if (pixels <= 1) return m;
        const fixedVal = $0d66bcfa8a8a56e9$var$toFixed(pixels / rootValue, precision);
        return `${fixedVal}rem`;
    };
    const visit = (cssObj)=>{
        const clone = {
            ...cssObj
        };
        Object.entries(cssObj).forEach(([key, value])=>{
            if (typeof value === 'string' && value.includes('px')) {
                const newValue = value.replace($0d66bcfa8a8a56e9$var$pxRegex, pxReplace);
                clone[key] = newValue;
            }
            // no unit
            if (!(0, $885f4eee88e48c11$export$2e2bcd8739ae039)[key] && typeof value === 'number' && value !== 0) clone[key] = `${value}px`.replace($0d66bcfa8a8a56e9$var$pxRegex, pxReplace);
            // Media queries
            const mergedKey = key.trim();
            if (mergedKey.startsWith('@') && mergedKey.includes('px') && mediaQuery) {
                const newKey = key.replace($0d66bcfa8a8a56e9$var$pxRegex, pxReplace);
                clone[newKey] = clone[key];
                delete clone[key];
            }
        });
        return clone;
    };
    return {
        visit: visit
    };
};
var $0d66bcfa8a8a56e9$export$2e2bcd8739ae039 = $0d66bcfa8a8a56e9$var$transform;




const $620baf24d0144de0$export$73abaea5066f503b = {
    supportModernCSS: ()=>(0, $763a5b4b58d0a3ff$export$f51d3b8ac4ac9ed1)() && (0, $763a5b4b58d0a3ff$export$64a912f57d5de48e)()
};


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
const $1b2cdad775203647$var$IconContext = /*#__PURE__*/ (0, $hO8yS.createContext)({});
var $1b2cdad775203647$export$2e2bcd8739ae039 = $1b2cdad775203647$var$IconContext;


/* eslint-disable @typescript-eslint/ban-types */ /* eslint-disable react-hooks/exhaustive-deps */ parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
function $ea93068db096b7d6$var$useEvent(callback) {
    const fnRef = $32rMB.useRef(callback);
    fnRef.current = callback;
    const memoFn = $32rMB.useCallback((...args)=>fnRef.current?.(...args), []);
    return memoFn;
}
var $ea93068db096b7d6$export$2e2bcd8739ae039 = $ea93068db096b7d6$var$useEvent;



parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");

/**
 * Wrap `React.useLayoutEffect` which will not throw warning message in test env
 */ const $60cea2402df671e7$var$useInternalLayoutEffect = (0, $bfbc54ac1ac0215e$export$2e2bcd8739ae039)() ? $32rMB.useLayoutEffect : $32rMB.useEffect;
const $60cea2402df671e7$var$useLayoutEffect = (callback, deps)=>{
    const firstMountRef = $32rMB.useRef(true);
    $60cea2402df671e7$var$useInternalLayoutEffect(()=>{
        return callback(firstMountRef.current);
    }, deps);
    // We tell react that first mount has passed
    $60cea2402df671e7$var$useInternalLayoutEffect(()=>{
        firstMountRef.current = false;
        return ()=>{
            firstMountRef.current = true;
        };
    }, []);
};
const $60cea2402df671e7$export$9283e56bae2f7b0f = (callback, deps)=>{
    $60cea2402df671e7$var$useLayoutEffect((firstMount)=>{
        if (!firstMount) return callback();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
};
var $60cea2402df671e7$export$2e2bcd8739ae039 = $60cea2402df671e7$var$useLayoutEffect;


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
function $8ad52953f3345b2f$export$2e2bcd8739ae039(defaultValue) {
    const destroyRef = $32rMB.useRef(false);
    const [value, setValue] = $32rMB.useState(defaultValue);
    $32rMB.useEffect(()=>{
        destroyRef.current = false;
        return ()=>{
            destroyRef.current = true;
        };
    }, []);
    function safeSetState(updater, ignoreDestroy) {
        if (ignoreDestroy && destroyRef.current) return;
        setValue(updater);
    }
    return [
        value,
        safeSetState
    ];
}


/** We only think `undefined` is empty */ function $4675e17da75913d0$var$hasValue(value) {
    return value !== undefined;
}
function $4675e17da75913d0$export$2e2bcd8739ae039(defaultStateValue, option) {
    const { defaultValue: defaultValue, value: value, onChange: onChange, postState: postState } = option || {};
    // ======================= Init =======================
    const [innerValue, setInnerValue] = (0, $8ad52953f3345b2f$export$2e2bcd8739ae039)(()=>{
        if ($4675e17da75913d0$var$hasValue(value)) return value;
        else if ($4675e17da75913d0$var$hasValue(defaultValue)) return typeof defaultValue === 'function' ? defaultValue() : defaultValue;
        else return typeof defaultStateValue === 'function' ? defaultStateValue() : defaultStateValue;
    });
    const mergedValue = value !== undefined ? value : innerValue;
    const postMergedValue = postState ? postState(mergedValue) : mergedValue;
    // ====================== Change ======================
    const onChangeFn = (0, $ea93068db096b7d6$export$2e2bcd8739ae039)(onChange);
    const [prevValue, setPrevValue] = (0, $8ad52953f3345b2f$export$2e2bcd8739ae039)([
        mergedValue
    ]);
    (0, $60cea2402df671e7$export$9283e56bae2f7b0f)(()=>{
        const prev = prevValue[0];
        if (innerValue !== prev) onChangeFn(innerValue, prev);
    }, [
        prevValue
    ]);
    // Sync value back to `undefined` when it from control to un-control
    (0, $60cea2402df671e7$export$9283e56bae2f7b0f)(()=>{
        if (!$4675e17da75913d0$var$hasValue(value)) setInnerValue(value);
    }, [
        value
    ]);
    // ====================== Update ======================
    const triggerChange = (0, $ea93068db096b7d6$export$2e2bcd8739ae039)((updater, ignoreDestroy)=>{
        setInnerValue(updater, ignoreDestroy);
        setPrevValue([
            mergedValue
        ], ignoreDestroy);
    });
    return [
        postMergedValue,
        triggerChange
    ];
}


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");

function $05ea6e97cee440ee$export$2e2bcd8739ae039(defaultStateValue, value) {
    const [innerValue, setInnerValue] = (0, $32rMB.useState)(defaultStateValue);
    const mergedValue = value !== undefined ? value : innerValue;
    (0, $60cea2402df671e7$export$2e2bcd8739ae039)((mount)=>{
        if (!mount) setInnerValue(value);
    }, [
        value
    ]);
    return [
        // Value
        mergedValue,
        // Update function
        setInnerValue
    ];
}



var $N3oW3 = parcelRequire("N3oW3");
var $a3de43725b7a590e$exports = {};
'use strict';

$a3de43725b7a590e$exports = (parcelRequire("f00Nn"));



const $2ba78e6c81fe6499$var$REACT_ELEMENT_TYPE_18 = Symbol.for('react.element');
const $2ba78e6c81fe6499$var$REACT_ELEMENT_TYPE_19 = Symbol.for('react.transitional.element');
const $2ba78e6c81fe6499$var$REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
function $2ba78e6c81fe6499$export$2e2bcd8739ae039(object) {
    return(// Base object type
    object && typeof object === 'object' && // React Element type
    (object.$$typeof === $2ba78e6c81fe6499$var$REACT_ELEMENT_TYPE_18 || object.$$typeof === $2ba78e6c81fe6499$var$REACT_ELEMENT_TYPE_19) && // React Fragment type
    object.type === $2ba78e6c81fe6499$var$REACT_FRAGMENT_TYPE);
}


const $2706ed817e87019d$var$ReactMajorVersion = Number((0, $N3oW3.version).split('.')[0]);
const $2706ed817e87019d$export$f17fd18fa51dcb5b = (ref, node)=>{
    if (typeof ref === 'function') ref(node);
    else if (typeof ref === 'object' && ref && 'current' in ref) ref.current = node;
};
const $2706ed817e87019d$export$ab452c34e8e05029 = (...refs)=>{
    const refList = refs.filter(Boolean);
    if (refList.length <= 1) return refList[0];
    return (node)=>{
        refs.forEach((ref)=>{
            $2706ed817e87019d$export$f17fd18fa51dcb5b(ref, node);
        });
    };
};
const $2706ed817e87019d$export$1d1c999670a1285d = (...refs)=>{
    return (0, $7b0442ce5e42625c$export$2e2bcd8739ae039)(()=>$2706ed817e87019d$export$ab452c34e8e05029(...refs), // eslint-disable-next-line react-hooks/exhaustive-deps
    refs, (prev, next)=>prev.length !== next.length || prev.every((ref, i)=>ref !== next[i]));
};
const $2706ed817e87019d$export$c1cec34af06bcf7 = (nodeOrComponent)=>{
    if (!nodeOrComponent) return false;
    // React 19 no need `forwardRef` anymore. So just pass if is a React element.
    if ($2706ed817e87019d$var$isReactElement(nodeOrComponent) && $2706ed817e87019d$var$ReactMajorVersion >= 19) return true;
    const type = (0, $a3de43725b7a590e$exports.isMemo)(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type;
    // Function component node
    if (typeof type === 'function' && !type.prototype?.render && type.$$typeof !== (0, $a3de43725b7a590e$exports.ForwardRef)) return false;
    // Class component
    if (typeof nodeOrComponent === 'function' && !nodeOrComponent.prototype?.render && nodeOrComponent.$$typeof !== (0, $a3de43725b7a590e$exports.ForwardRef)) return false;
    return true;
};
function $2706ed817e87019d$var$isReactElement(node) {
    return /*#__PURE__*/ (0, $N3oW3.isValidElement)(node) && !(0, $2ba78e6c81fe6499$export$2e2bcd8739ae039)(node);
}
const $2706ed817e87019d$export$b51ae67c7882a242 = (node)=>{
    return $2706ed817e87019d$var$isReactElement(node) && $2706ed817e87019d$export$c1cec34af06bcf7(node);
};
const $2706ed817e87019d$export$7465e5c0bf44f19a = (node)=>{
    if (node && $2706ed817e87019d$var$isReactElement(node)) {
        const ele = node;
        // Source from:
        // https://github.com/mui/material-ui/blob/master/packages/mui-utils/src/getReactNodeRef/getReactNodeRef.ts
        return ele.props.propertyIsEnumerable('ref') ? ele.props.ref : ele.ref;
    }
    return null;
};


function $7967876a5e08d9ff$export$2e2bcd8739ae039(entity, path) {
    let current = entity;
    for(let i = 0; i < path.length; i += 1){
        if (current === null || current === undefined) return undefined;
        current = current[path[i]];
    }
    return current;
}



function $3d19a70b12f43514$var$internalSet(entity, paths, value, removeIfUndefined) {
    if (!paths.length) return value;
    const [path, ...restPath] = paths;
    let clone;
    if (!entity && typeof path === 'number') clone = [];
    else if (Array.isArray(entity)) clone = [
        ...entity
    ];
    else clone = {
        ...entity
    };
    // Delete prop if `removeIfUndefined` and value is undefined
    if (removeIfUndefined && value === undefined && restPath.length === 1) delete clone[path][restPath[0]];
    else clone[path] = $3d19a70b12f43514$var$internalSet(clone[path], restPath, value, removeIfUndefined);
    return clone;
}
function $3d19a70b12f43514$export$2e2bcd8739ae039(entity, paths, value, removeIfUndefined = false) {
    // Do nothing if `removeIfUndefined` and parent object not exist
    if (paths.length && removeIfUndefined && value === undefined && !(0, $7967876a5e08d9ff$export$2e2bcd8739ae039)(entity, paths.slice(0, -1))) return entity;
    return $3d19a70b12f43514$var$internalSet(entity, paths, value, removeIfUndefined);
}
function $3d19a70b12f43514$var$isObject(obj) {
    return typeof obj === 'object' && obj !== null && Object.getPrototypeOf(obj) === Object.prototype;
}
function $3d19a70b12f43514$var$createEmpty(source) {
    return Array.isArray(source) ? [] : {};
}
const $3d19a70b12f43514$var$keys = typeof Reflect === 'undefined' ? Object.keys : Reflect.ownKeys;
function $3d19a70b12f43514$export$4950aa0f605343fb(...sources) {
    let clone = $3d19a70b12f43514$var$createEmpty(sources[0]);
    sources.forEach((src)=>{
        function internalMerge(path, parentLoopSet) {
            const loopSet = new Set(parentLoopSet);
            const value = (0, $7967876a5e08d9ff$export$2e2bcd8739ae039)(src, path);
            const isArr = Array.isArray(value);
            if (isArr || $3d19a70b12f43514$var$isObject(value)) // Only add not loop obj
            {
                if (!loopSet.has(value)) {
                    loopSet.add(value);
                    const originValue = (0, $7967876a5e08d9ff$export$2e2bcd8739ae039)(clone, path);
                    if (isArr) // Array will always be override
                    clone = $3d19a70b12f43514$export$2e2bcd8739ae039(clone, path, []);
                    else if (!originValue || typeof originValue !== 'object') // Init container if not exist
                    clone = $3d19a70b12f43514$export$2e2bcd8739ae039(clone, path, $3d19a70b12f43514$var$createEmpty(value));
                    $3d19a70b12f43514$var$keys(value).forEach((key)=>{
                        internalMerge([
                            ...path,
                            key
                        ], loopSet);
                    });
                }
            } else clone = $3d19a70b12f43514$export$2e2bcd8739ae039(clone, path, value);
        }
        internalMerge([]);
    });
    return clone;
}



function $f4cf9c2e27c0ac8d$export$2e2bcd8739ae039(obj, fields) {
    const clone = Object.assign({}, obj);
    if (Array.isArray(fields)) fields.forEach((key)=>{
        delete clone[key];
    });
    return clone;
}




var $N3oW3 = parcelRequire("N3oW3");
function $a60ede783f74e6a9$export$2e2bcd8739ae039(children, option = {}) {
    let ret = [];
    (0, $N3oW3.default).Children.forEach(children, (child)=>{
        if ((child === undefined || child === null) && !option.keepEmpty) return;
        if (Array.isArray(child)) ret = ret.concat($a60ede783f74e6a9$export$2e2bcd8739ae039(child));
        else if ((0, $2ba78e6c81fe6499$export$2e2bcd8739ae039)(child) && child.props) ret = ret.concat($a60ede783f74e6a9$export$2e2bcd8739ae039(child.props.children, option));
        else ret.push(child);
    });
    return ret;
}





parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");

function $d41680c8243eac18$export$8793edee2d425525() {}
const { resetWarned: $d41680c8243eac18$var$rcResetWarned } = (0, $6591254ed6bd1058$export$2e2bcd8739ae039);
let $d41680c8243eac18$var$deprecatedWarnList = null;
function $d41680c8243eac18$export$60eef1277fe463e4() {
    $d41680c8243eac18$var$deprecatedWarnList = null;
    $d41680c8243eac18$var$rcResetWarned();
}
let $d41680c8243eac18$var$_warning = $d41680c8243eac18$export$8793edee2d425525;
var $d41680c8243eac18$var$valid, $d41680c8243eac18$var$component, $d41680c8243eac18$var$message;
const $d41680c8243eac18$var$warning = $d41680c8243eac18$var$_warning;
const $d41680c8243eac18$export$11b88c75b33aa1fd = /*#__PURE__*/ $hO8yS.createContext({});
const $d41680c8243eac18$export$cf977aa92c751e61 = ()=>{
    const noopWarning = ()=>{};
    noopWarning.deprecated = $d41680c8243eac18$export$8793edee2d425525;
    return noopWarning;
};
var $d41680c8243eac18$export$2e2bcd8739ae039 = $d41680c8243eac18$var$warning;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
"use client";
var // ZombieJ: We export single file here since
// ConfigProvider use this which will make loop deps
// to import whole `rc-component/form`
$731a8553e006c6d2$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $hO8yS.createContext)(undefined);


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");

const $2f29be0dcf198ec8$var$locale = {
    // Options
    items_per_page: '/ page',
    jump_to: 'Go to',
    jump_to_confirm: 'confirm',
    page: 'Page',
    // Pagination
    prev_page: 'Previous Page',
    next_page: 'Next Page',
    prev_5: 'Previous 5 Pages',
    next_5: 'Next 5 Pages',
    prev_3: 'Previous 3 Pages',
    next_3: 'Next 3 Pages',
    page_size: 'Page Size'
};
var $2f29be0dcf198ec8$export$2e2bcd8739ae039 = $2f29be0dcf198ec8$var$locale;


var $a70a30c9a2aaffcd$export$bdd78c3fd9633c1e = {
    yearFormat: 'YYYY',
    dayFormat: 'D',
    cellMeridiemFormat: 'A',
    monthBeforeYear: true
};


function $1b2e108f78e1d312$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $1b2e108f78e1d312$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $1b2e108f78e1d312$var$_typeof(o);
}
function $1b2e108f78e1d312$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1b2e108f78e1d312$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1b2e108f78e1d312$var$ownKeys(Object(t), !0).forEach(function(r) {
            $1b2e108f78e1d312$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1b2e108f78e1d312$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1b2e108f78e1d312$var$_defineProperty(obj, key, value) {
    key = $1b2e108f78e1d312$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1b2e108f78e1d312$var$_toPropertyKey(t) {
    var i = $1b2e108f78e1d312$var$_toPrimitive(t, "string");
    return "symbol" == $1b2e108f78e1d312$var$_typeof(i) ? i : String(i);
}
function $1b2e108f78e1d312$var$_toPrimitive(t, r) {
    if ("object" != $1b2e108f78e1d312$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $1b2e108f78e1d312$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $1b2e108f78e1d312$var$locale = $1b2e108f78e1d312$var$_objectSpread($1b2e108f78e1d312$var$_objectSpread({}, (0, $a70a30c9a2aaffcd$export$bdd78c3fd9633c1e)), {}, {
    locale: 'en_US',
    today: 'Today',
    now: 'Now',
    backToToday: 'Back to today',
    ok: 'OK',
    clear: 'Clear',
    week: 'Week',
    month: 'Month',
    year: 'Year',
    timeSelect: 'select time',
    dateSelect: 'select date',
    weekSelect: 'Choose a week',
    monthSelect: 'Choose a month',
    yearSelect: 'Choose a year',
    decadeSelect: 'Choose a decade',
    previousMonth: 'Previous month (PageUp)',
    nextMonth: 'Next month (PageDown)',
    previousYear: 'Last year (Control + left)',
    nextYear: 'Next year (Control + right)',
    previousDecade: 'Last decade',
    nextDecade: 'Next decade',
    previousCentury: 'Last century',
    nextCentury: 'Next century'
});
var $1b2e108f78e1d312$export$2e2bcd8739ae039 = $1b2e108f78e1d312$var$locale;


const $49de40d52be09895$var$locale = {
    placeholder: 'Select time',
    rangePlaceholder: [
        'Start time',
        'End time'
    ]
};
var $49de40d52be09895$export$2e2bcd8739ae039 = $49de40d52be09895$var$locale;


// Merge into a locale object
const $5c26a281f7777a87$var$locale = {
    lang: {
        placeholder: 'Select date',
        yearPlaceholder: 'Select year',
        quarterPlaceholder: 'Select quarter',
        monthPlaceholder: 'Select month',
        weekPlaceholder: 'Select week',
        rangePlaceholder: [
            'Start date',
            'End date'
        ],
        rangeYearPlaceholder: [
            'Start year',
            'End year'
        ],
        rangeQuarterPlaceholder: [
            'Start quarter',
            'End quarter'
        ],
        rangeMonthPlaceholder: [
            'Start month',
            'End month'
        ],
        rangeWeekPlaceholder: [
            'Start week',
            'End week'
        ],
        ...(0, $1b2e108f78e1d312$export$2e2bcd8739ae039)
    },
    timePickerLocale: {
        ...(0, $49de40d52be09895$export$2e2bcd8739ae039)
    }
};
var // All settings at:
// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json
$5c26a281f7777a87$export$2e2bcd8739ae039 = $5c26a281f7777a87$var$locale;


var $0dcc1762265aac10$export$2e2bcd8739ae039 = (0, $5c26a281f7777a87$export$2e2bcd8739ae039);




const $e154e9cb01eacc19$var$typeTemplate = '${label} is not a valid ${type}';
const $e154e9cb01eacc19$var$localeValues = {
    locale: 'en',
    Pagination: $2f29be0dcf198ec8$export$2e2bcd8739ae039,
    DatePicker: $5c26a281f7777a87$export$2e2bcd8739ae039,
    TimePicker: $49de40d52be09895$export$2e2bcd8739ae039,
    Calendar: $0dcc1762265aac10$export$2e2bcd8739ae039,
    global: {
        placeholder: 'Please select',
        close: 'Close',
        sortable: 'sortable'
    },
    Table: {
        filterTitle: 'Filter menu',
        filterConfirm: 'OK',
        filterReset: 'Reset',
        filterEmptyText: 'No filters',
        filterCheckAll: 'Select all items',
        filterSearchPlaceholder: 'Search in filters',
        emptyText: 'No data',
        selectAll: 'Select current page',
        selectInvert: 'Invert current page',
        selectNone: 'Clear all data',
        selectionAll: 'Select all data',
        sortTitle: 'Sort',
        expand: 'Expand row',
        collapse: 'Collapse row',
        triggerDesc: 'Click to sort descending',
        triggerAsc: 'Click to sort ascending',
        cancelSort: 'Click to cancel sorting'
    },
    Tour: {
        Next: 'Next',
        Previous: 'Previous',
        Finish: 'Finish'
    },
    Modal: {
        okText: 'OK',
        cancelText: 'Cancel',
        justOkText: 'OK'
    },
    Popconfirm: {
        okText: 'OK',
        cancelText: 'Cancel'
    },
    Transfer: {
        titles: [
            '',
            ''
        ],
        searchPlaceholder: 'Search here',
        itemUnit: 'item',
        itemsUnit: 'items',
        remove: 'Remove',
        selectCurrent: 'Select current page',
        removeCurrent: 'Remove current page',
        selectAll: 'Select all data',
        deselectAll: 'Deselect all data',
        removeAll: 'Remove all data',
        selectInvert: 'Invert current page'
    },
    Upload: {
        uploading: 'Uploading...',
        removeFile: 'Remove file',
        uploadError: 'Upload error',
        previewFile: 'Preview file',
        downloadFile: 'Download file'
    },
    Empty: {
        description: 'No data'
    },
    Icon: {
        icon: 'icon'
    },
    Text: {
        edit: 'Edit',
        copy: 'Copy',
        copied: 'Copied',
        expand: 'Expand',
        collapse: 'Collapse'
    },
    Form: {
        optional: '(optional)',
        defaultValidateMessages: {
            default: 'Field validation error for ${label}',
            required: 'Please enter ${label}',
            enum: '${label} must be one of [${enum}]',
            whitespace: '${label} cannot be a blank character',
            date: {
                format: '${label} date format is invalid',
                parse: '${label} cannot be converted to a date',
                invalid: '${label} is an invalid date'
            },
            types: {
                string: $e154e9cb01eacc19$var$typeTemplate,
                method: $e154e9cb01eacc19$var$typeTemplate,
                array: $e154e9cb01eacc19$var$typeTemplate,
                object: $e154e9cb01eacc19$var$typeTemplate,
                number: $e154e9cb01eacc19$var$typeTemplate,
                date: $e154e9cb01eacc19$var$typeTemplate,
                boolean: $e154e9cb01eacc19$var$typeTemplate,
                integer: $e154e9cb01eacc19$var$typeTemplate,
                float: $e154e9cb01eacc19$var$typeTemplate,
                regexp: $e154e9cb01eacc19$var$typeTemplate,
                email: $e154e9cb01eacc19$var$typeTemplate,
                url: $e154e9cb01eacc19$var$typeTemplate,
                hex: $e154e9cb01eacc19$var$typeTemplate
            },
            string: {
                len: '${label} must be ${len} characters',
                min: '${label} must be at least ${min} characters',
                max: '${label} must be up to ${max} characters',
                range: '${label} must be between ${min}-${max} characters'
            },
            number: {
                len: '${label} must be equal to ${len}',
                min: '${label} must be minimum ${min}',
                max: '${label} must be maximum ${max}',
                range: '${label} must be between ${min}-${max}'
            },
            array: {
                len: 'Must be ${len} ${label}',
                min: 'At least ${min} ${label}',
                max: 'At most ${max} ${label}',
                range: 'The amount of ${label} must be between ${min}-${max}'
            },
            pattern: {
                mismatch: '${label} does not match the pattern ${pattern}'
            }
        }
    },
    QRCode: {
        expired: 'QR code expired',
        refresh: 'Refresh',
        scanned: 'Scanned'
    },
    ColorPicker: {
        presetEmpty: 'Empty',
        transparent: 'Transparent',
        singleColor: 'Single',
        gradientColor: 'Gradient'
    }
};
var $e154e9cb01eacc19$export$2e2bcd8739ae039 = $e154e9cb01eacc19$var$localeValues;


let $8ffa4a229f480682$var$runtimeLocale = {
    ...(0, $e154e9cb01eacc19$export$2e2bcd8739ae039).Modal
};
let $8ffa4a229f480682$var$localeList = [];
const $8ffa4a229f480682$var$generateLocale = ()=>$8ffa4a229f480682$var$localeList.reduce((merged, locale)=>({
            ...merged,
            ...locale
        }), (0, $e154e9cb01eacc19$export$2e2bcd8739ae039).Modal);
function $8ffa4a229f480682$export$9485ecb9d81a550c(newLocale) {
    if (newLocale) {
        const cloneLocale = {
            ...newLocale
        };
        $8ffa4a229f480682$var$localeList.push(cloneLocale);
        $8ffa4a229f480682$var$runtimeLocale = $8ffa4a229f480682$var$generateLocale();
        return ()=>{
            $8ffa4a229f480682$var$localeList = $8ffa4a229f480682$var$localeList.filter((locale)=>locale !== cloneLocale);
            $8ffa4a229f480682$var$runtimeLocale = $8ffa4a229f480682$var$generateLocale();
        };
    }
    $8ffa4a229f480682$var$runtimeLocale = {
        ...(0, $e154e9cb01eacc19$export$2e2bcd8739ae039).Modal
    };
}
function $8ffa4a229f480682$export$1b6004afda18cd51() {
    return $8ffa4a229f480682$var$runtimeLocale;
}


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
const $f0cbc91673fbb933$var$LocaleContext = /*#__PURE__*/ (0, $hO8yS.createContext)(undefined);
var $f0cbc91673fbb933$export$2e2bcd8739ae039 = $f0cbc91673fbb933$var$LocaleContext;


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");


const $c176ccd8a9cbd556$var$useLocale = (componentName, defaultLocale)=>{
    const fullLocale = $32rMB.useContext((0, $f0cbc91673fbb933$export$2e2bcd8739ae039));
    const getLocale = $32rMB.useMemo(()=>{
        const locale = defaultLocale || (0, $e154e9cb01eacc19$export$2e2bcd8739ae039)[componentName];
        const localeFromContext = fullLocale?.[componentName] ?? {};
        return {
            ...typeof locale === 'function' ? locale() : locale,
            ...localeFromContext || {}
        };
    }, [
        componentName,
        defaultLocale,
        fullLocale
    ]);
    const getLocaleCode = $32rMB.useMemo(()=>{
        const localeCode = fullLocale?.locale;
        // Had use LocaleProvide but didn't set locale
        if (fullLocale?.exist && !localeCode) return (0, $e154e9cb01eacc19$export$2e2bcd8739ae039).locale;
        return localeCode;
    }, [
        fullLocale
    ]);
    return [
        getLocale,
        getLocaleCode
    ];
};
var $c176ccd8a9cbd556$export$2e2bcd8739ae039 = $c176ccd8a9cbd556$var$useLocale;


"use client";
const $082d8b47c43a69cb$export$b2f162cd5c15ea3e = 'internalMark';
const $082d8b47c43a69cb$var$LocaleProvider = (props)=>{
    const { locale: locale = {}, children: children, _ANT_MARK__: _ANT_MARK__ } = props;
    $32rMB.useEffect(()=>{
        const clearLocale = (0, $8ffa4a229f480682$export$9485ecb9d81a550c)(locale?.Modal);
        return clearLocale;
    }, [
        locale
    ]);
    const getMemoizedContextValue = $32rMB.useMemo(()=>({
            ...locale,
            exist: true
        }), [
        locale
    ]);
    return /*#__PURE__*/ $hO8yS.createElement((0, $f0cbc91673fbb933$export$2e2bcd8739ae039).Provider, {
        value: getMemoizedContextValue
    }, children);
};
var $082d8b47c43a69cb$export$2e2bcd8739ae039 = $082d8b47c43a69cb$var$LocaleProvider;





// 36 Hex to reduce the size of the file
var $cbe6859ff5bfd59f$export$2e2bcd8739ae039 = {
    aliceblue: '9ehhb',
    antiquewhite: '9sgk7',
    aqua: '1ekf',
    aquamarine: '4zsno',
    azure: '9eiv3',
    beige: '9lhp8',
    bisque: '9zg04',
    black: '0',
    blanchedalmond: '9zhe5',
    blue: '73',
    blueviolet: '5e31e',
    brown: '6g016',
    burlywood: '8ouiv',
    cadetblue: '3qba8',
    chartreuse: '4zshs',
    chocolate: '87k0u',
    coral: '9yvyo',
    cornflowerblue: '3xael',
    cornsilk: '9zjz0',
    crimson: '8l4xo',
    cyan: '1ekf',
    darkblue: '3v',
    darkcyan: 'rkb',
    darkgoldenrod: '776yz',
    darkgray: '6mbhl',
    darkgreen: 'jr4',
    darkgrey: '6mbhl',
    darkkhaki: '7ehkb',
    darkmagenta: '5f91n',
    darkolivegreen: '3bzfz',
    darkorange: '9yygw',
    darkorchid: '5z6x8',
    darkred: '5f8xs',
    darksalmon: '9441m',
    darkseagreen: '5lwgf',
    darkslateblue: '2th1n',
    darkslategray: '1ugcv',
    darkslategrey: '1ugcv',
    darkturquoise: '14up',
    darkviolet: '5rw7n',
    deeppink: '9yavn',
    deepskyblue: '11xb',
    dimgray: '442g9',
    dimgrey: '442g9',
    dodgerblue: '16xof',
    firebrick: '6y7tu',
    floralwhite: '9zkds',
    forestgreen: '1cisi',
    fuchsia: '9y70f',
    gainsboro: '8m8kc',
    ghostwhite: '9pq0v',
    goldenrod: '8j4f4',
    gold: '9zda8',
    gray: '50i2o',
    green: 'pa8',
    greenyellow: '6senj',
    grey: '50i2o',
    honeydew: '9eiuo',
    hotpink: '9yrp0',
    indianred: '80gnw',
    indigo: '2xcoy',
    ivory: '9zldc',
    khaki: '9edu4',
    lavenderblush: '9ziet',
    lavender: '90c8q',
    lawngreen: '4vk74',
    lemonchiffon: '9zkct',
    lightblue: '6s73a',
    lightcoral: '9dtog',
    lightcyan: '8s1rz',
    lightgoldenrodyellow: '9sjiq',
    lightgray: '89jo3',
    lightgreen: '5nkwg',
    lightgrey: '89jo3',
    lightpink: '9z6wx',
    lightsalmon: '9z2ii',
    lightseagreen: '19xgq',
    lightskyblue: '5arju',
    lightslategray: '4nwk9',
    lightslategrey: '4nwk9',
    lightsteelblue: '6wau6',
    lightyellow: '9zlcw',
    lime: '1edc',
    limegreen: '1zcxe',
    linen: '9shk6',
    magenta: '9y70f',
    maroon: '4zsow',
    mediumaquamarine: '40eju',
    mediumblue: '5p',
    mediumorchid: '79qkz',
    mediumpurple: '5r3rv',
    mediumseagreen: '2d9ip',
    mediumslateblue: '4tcku',
    mediumspringgreen: '1di2',
    mediumturquoise: '2uabw',
    mediumvioletred: '7rn9h',
    midnightblue: 'z980',
    mintcream: '9ljp6',
    mistyrose: '9zg0x',
    moccasin: '9zfzp',
    navajowhite: '9zest',
    navy: '3k',
    oldlace: '9wq92',
    olive: '50hz4',
    olivedrab: '472ub',
    orange: '9z3eo',
    orangered: '9ykg0',
    orchid: '8iu3a',
    palegoldenrod: '9bl4a',
    palegreen: '5yw0o',
    paleturquoise: '6v4ku',
    palevioletred: '8k8lv',
    papayawhip: '9zi6t',
    peachpuff: '9ze0p',
    peru: '80oqn',
    pink: '9z8wb',
    plum: '8nba5',
    powderblue: '6wgdi',
    purple: '4zssg',
    rebeccapurple: '3zk49',
    red: '9y6tc',
    rosybrown: '7cv4f',
    royalblue: '2jvtt',
    saddlebrown: '5fmkz',
    salmon: '9rvci',
    sandybrown: '9jn1c',
    seagreen: '1tdnb',
    seashell: '9zje6',
    sienna: '6973h',
    silver: '7ir40',
    skyblue: '5arjf',
    slateblue: '45e4t',
    slategray: '4e100',
    slategrey: '4e100',
    snow: '9zke2',
    springgreen: '1egv',
    steelblue: '2r1kk',
    tan: '87yx8',
    teal: 'pds',
    thistle: '8ggk8',
    tomato: '9yqfb',
    turquoise: '2j4r4',
    violet: '9b10u',
    wheat: '9ld4j',
    white: '9zldr',
    whitesmoke: '9lhpx',
    yellow: '9zl6o',
    yellowgreen: '61fzm'
};


const $cbc85b6187a98a9b$var$round = Math.round;
/**
 * Support format, alpha unit will check the % mark:
 * - rgba(102, 204, 255, .5)      -> [102, 204, 255, 0.5]
 * - rgb(102 204 255 / .5)        -> [102, 204, 255, 0.5]
 * - rgb(100%, 50%, 0% / 50%)     -> [255, 128, 0, 0.5]
 * - hsl(270, 60, 40, .5)         -> [270, 60, 40, 0.5]
 * - hsl(270deg 60% 40% / 50%)   -> [270, 60, 40, 0.5]
 *
 * When `base` is provided, the percentage value will be divided by `base`.
 */ function $cbc85b6187a98a9b$var$splitColorStr(str, parseNum) {
    const match = str// Remove str before `(`
    .replace(/^[^(]*\((.*)/, '$1')// Remove str after `)`
    .replace(/\).*/, '').match(/\d*\.?\d+%?/g) || [];
    const numList = match.map((item)=>parseFloat(item));
    for(let i = 0; i < 3; i += 1)numList[i] = parseNum(numList[i] || 0, match[i] || '', i);
    // For alpha. 50% should be 0.5
    if (match[3]) numList[3] = match[3].includes('%') ? numList[3] / 100 : numList[3];
    else // By default, alpha is 1
    numList[3] = 1;
    return numList;
}
const $cbc85b6187a98a9b$var$parseHSVorHSL = (num, _, index)=>index === 0 ? num : num / 100;
/** round and limit number to integer between 0-255 */ function $cbc85b6187a98a9b$var$limitRange(value, max) {
    const mergedMax = max || 255;
    if (value > mergedMax) return mergedMax;
    if (value < 0) return 0;
    return value;
}
class $cbc85b6187a98a9b$export$2c4f38d6c0ecc25a {
    /**
   * All FastColor objects are valid. So isValid is always true. This property is kept to be compatible with TinyColor.
   */ isValid = true;
    /**
   * Red, R in RGB
   */ r = 0;
    /**
   * Green, G in RGB
   */ g = 0;
    /**
   * Blue, B in RGB
   */ b = 0;
    /**
   * Alpha/Opacity, A in RGBA/HSLA
   */ a = 1;
    // HSV privates
    _h;
    _s;
    _l;
    _v;
    // intermediate variables to calculate HSL/HSV
    _max;
    _min;
    _brightness;
    constructor(input){
        /**
     * Always check 3 char in the object to determine the format.
     * We not use function in check to save bundle size.
     * e.g. 'rgb' -> { r: 0, g: 0, b: 0 }.
     */ function matchFormat(str) {
            return str[0] in input && str[1] in input && str[2] in input;
        }
        if (!input) ;
        else if (typeof input === 'string') {
            const trimStr = input.trim();
            function matchPrefix(prefix) {
                return trimStr.startsWith(prefix);
            }
            if (/^#?[A-F\d]{3,8}$/i.test(trimStr)) this.fromHexString(trimStr);
            else if (matchPrefix('rgb')) this.fromRgbString(trimStr);
            else if (matchPrefix('hsl')) this.fromHslString(trimStr);
            else if (matchPrefix('hsv') || matchPrefix('hsb')) this.fromHsvString(trimStr);
            else {
                // From preset color
                const presetColor = (0, $cbe6859ff5bfd59f$export$2e2bcd8739ae039)[trimStr.toLowerCase()];
                if (presetColor) this.fromHexString(// Convert 36 hex to 16 hex
                parseInt(presetColor, 36).toString(16).padStart(6, '0'));
            }
        } else if (input instanceof $cbc85b6187a98a9b$export$2c4f38d6c0ecc25a) {
            this.r = input.r;
            this.g = input.g;
            this.b = input.b;
            this.a = input.a;
            this._h = input._h;
            this._s = input._s;
            this._l = input._l;
            this._v = input._v;
        } else if (matchFormat('rgb')) {
            this.r = $cbc85b6187a98a9b$var$limitRange(input.r);
            this.g = $cbc85b6187a98a9b$var$limitRange(input.g);
            this.b = $cbc85b6187a98a9b$var$limitRange(input.b);
            this.a = typeof input.a === 'number' ? $cbc85b6187a98a9b$var$limitRange(input.a, 1) : 1;
        } else if (matchFormat('hsl')) this.fromHsl(input);
        else if (matchFormat('hsv')) this.fromHsv(input);
        else throw new Error('@ant-design/fast-color: unsupported input ' + JSON.stringify(input));
    }
    // ======================= Setter =======================
    setR(value) {
        return this._sc('r', value);
    }
    setG(value) {
        return this._sc('g', value);
    }
    setB(value) {
        return this._sc('b', value);
    }
    setA(value) {
        return this._sc('a', value, 1);
    }
    setHue(value) {
        const hsv = this.toHsv();
        hsv.h = value;
        return this._c(hsv);
    }
    // ======================= Getter =======================
    /**
   * Returns the perceived luminance of a color, from 0-1.
   * @see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
   */ getLuminance() {
        function adjustGamma(raw) {
            const val = raw / 255;
            return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
        }
        const R = adjustGamma(this.r);
        const G = adjustGamma(this.g);
        const B = adjustGamma(this.b);
        return 0.2126 * R + 0.7152 * G + 0.0722 * B;
    }
    getHue() {
        if (typeof this._h === 'undefined') {
            const delta = this.getMax() - this.getMin();
            if (delta === 0) this._h = 0;
            else this._h = $cbc85b6187a98a9b$var$round(60 * (this.r === this.getMax() ? (this.g - this.b) / delta + (this.g < this.b ? 6 : 0) : this.g === this.getMax() ? (this.b - this.r) / delta + 2 : (this.r - this.g) / delta + 4));
        }
        return this._h;
    }
    getSaturation() {
        if (typeof this._s === 'undefined') {
            const delta = this.getMax() - this.getMin();
            if (delta === 0) this._s = 0;
            else this._s = delta / this.getMax();
        }
        return this._s;
    }
    getLightness() {
        if (typeof this._l === 'undefined') this._l = (this.getMax() + this.getMin()) / 510;
        return this._l;
    }
    getValue() {
        if (typeof this._v === 'undefined') this._v = this.getMax() / 255;
        return this._v;
    }
    /**
   * Returns the perceived brightness of the color, from 0-255.
   * Note: this is not the b of HSB
   * @see http://www.w3.org/TR/AERT#color-contrast
   */ getBrightness() {
        if (typeof this._brightness === 'undefined') this._brightness = (this.r * 299 + this.g * 587 + this.b * 114) / 1000;
        return this._brightness;
    }
    // ======================== Func ========================
    darken(amount = 10) {
        const h = this.getHue();
        const s = this.getSaturation();
        let l = this.getLightness() - amount / 100;
        if (l < 0) l = 0;
        return this._c({
            h: h,
            s: s,
            l: l,
            a: this.a
        });
    }
    lighten(amount = 10) {
        const h = this.getHue();
        const s = this.getSaturation();
        let l = this.getLightness() + amount / 100;
        if (l > 1) l = 1;
        return this._c({
            h: h,
            s: s,
            l: l,
            a: this.a
        });
    }
    /**
   * Mix the current color a given amount with another color, from 0 to 100.
   * 0 means no mixing (return current color).
   */ mix(input, amount = 50) {
        const color = this._c(input);
        const p = amount / 100;
        const calc = (key)=>(color[key] - this[key]) * p + this[key];
        const rgba = {
            r: $cbc85b6187a98a9b$var$round(calc('r')),
            g: $cbc85b6187a98a9b$var$round(calc('g')),
            b: $cbc85b6187a98a9b$var$round(calc('b')),
            a: $cbc85b6187a98a9b$var$round(calc('a') * 100) / 100
        };
        return this._c(rgba);
    }
    /**
   * Mix the color with pure white, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return white.
   */ tint(amount = 10) {
        return this.mix({
            r: 255,
            g: 255,
            b: 255,
            a: 1
        }, amount);
    }
    /**
   * Mix the color with pure black, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return black.
   */ shade(amount = 10) {
        return this.mix({
            r: 0,
            g: 0,
            b: 0,
            a: 1
        }, amount);
    }
    onBackground(background) {
        const bg = this._c(background);
        const alpha = this.a + bg.a * (1 - this.a);
        const calc = (key)=>{
            return $cbc85b6187a98a9b$var$round((this[key] * this.a + bg[key] * bg.a * (1 - this.a)) / alpha);
        };
        return this._c({
            r: calc('r'),
            g: calc('g'),
            b: calc('b'),
            a: alpha
        });
    }
    // ======================= Status =======================
    isDark() {
        return this.getBrightness() < 128;
    }
    isLight() {
        return this.getBrightness() >= 128;
    }
    // ======================== MISC ========================
    equals(other) {
        return this.r === other.r && this.g === other.g && this.b === other.b && this.a === other.a;
    }
    clone() {
        return this._c(this);
    }
    // ======================= Format =======================
    toHexString() {
        let hex = '#';
        const rHex = (this.r || 0).toString(16);
        hex += rHex.length === 2 ? rHex : '0' + rHex;
        const gHex = (this.g || 0).toString(16);
        hex += gHex.length === 2 ? gHex : '0' + gHex;
        const bHex = (this.b || 0).toString(16);
        hex += bHex.length === 2 ? bHex : '0' + bHex;
        if (typeof this.a === 'number' && this.a >= 0 && this.a < 1) {
            const aHex = $cbc85b6187a98a9b$var$round(this.a * 255).toString(16);
            hex += aHex.length === 2 ? aHex : '0' + aHex;
        }
        return hex;
    }
    /** CSS support color pattern */ toHsl() {
        return {
            h: this.getHue(),
            s: this.getSaturation(),
            l: this.getLightness(),
            a: this.a
        };
    }
    /** CSS support color pattern */ toHslString() {
        const h = this.getHue();
        const s = $cbc85b6187a98a9b$var$round(this.getSaturation() * 100);
        const l = $cbc85b6187a98a9b$var$round(this.getLightness() * 100);
        return this.a !== 1 ? `hsla(${h},${s}%,${l}%,${this.a})` : `hsl(${h},${s}%,${l}%)`;
    }
    /** Same as toHsb */ toHsv() {
        return {
            h: this.getHue(),
            s: this.getSaturation(),
            v: this.getValue(),
            a: this.a
        };
    }
    toRgb() {
        return {
            r: this.r,
            g: this.g,
            b: this.b,
            a: this.a
        };
    }
    toRgbString() {
        return this.a !== 1 ? `rgba(${this.r},${this.g},${this.b},${this.a})` : `rgb(${this.r},${this.g},${this.b})`;
    }
    toString() {
        return this.toRgbString();
    }
    // ====================== Privates ======================
    /** Return a new FastColor object with one channel changed */ _sc(rgb, value, max) {
        const clone = this.clone();
        clone[rgb] = $cbc85b6187a98a9b$var$limitRange(value, max);
        return clone;
    }
    _c(input) {
        return new this.constructor(input);
    }
    getMax() {
        if (typeof this._max === 'undefined') this._max = Math.max(this.r, this.g, this.b);
        return this._max;
    }
    getMin() {
        if (typeof this._min === 'undefined') this._min = Math.min(this.r, this.g, this.b);
        return this._min;
    }
    fromHexString(trimStr) {
        const withoutPrefix = trimStr.replace('#', '');
        function connectNum(index1, index2) {
            return parseInt(withoutPrefix[index1] + withoutPrefix[index2 || index1], 16);
        }
        if (withoutPrefix.length < 6) {
            // #rgb or #rgba
            this.r = connectNum(0);
            this.g = connectNum(1);
            this.b = connectNum(2);
            this.a = withoutPrefix[3] ? connectNum(3) / 255 : 1;
        } else {
            // #rrggbb or #rrggbbaa
            this.r = connectNum(0, 1);
            this.g = connectNum(2, 3);
            this.b = connectNum(4, 5);
            this.a = withoutPrefix[6] ? connectNum(6, 7) / 255 : 1;
        }
    }
    fromHsl({ h: h, s: s, l: l, a: a }) {
        this._h = h % 360;
        this._s = s;
        this._l = l;
        this.a = typeof a === 'number' ? a : 1;
        if (s <= 0) {
            const rgb = $cbc85b6187a98a9b$var$round(l * 255);
            this.r = rgb;
            this.g = rgb;
            this.b = rgb;
        }
        let r = 0, g = 0, b = 0;
        const huePrime = h / 60;
        const chroma = (1 - Math.abs(2 * l - 1)) * s;
        const secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
        if (huePrime >= 0 && huePrime < 1) {
            r = chroma;
            g = secondComponent;
        } else if (huePrime >= 1 && huePrime < 2) {
            r = secondComponent;
            g = chroma;
        } else if (huePrime >= 2 && huePrime < 3) {
            g = chroma;
            b = secondComponent;
        } else if (huePrime >= 3 && huePrime < 4) {
            g = secondComponent;
            b = chroma;
        } else if (huePrime >= 4 && huePrime < 5) {
            r = secondComponent;
            b = chroma;
        } else if (huePrime >= 5 && huePrime < 6) {
            r = chroma;
            b = secondComponent;
        }
        const lightnessModification = l - chroma / 2;
        this.r = $cbc85b6187a98a9b$var$round((r + lightnessModification) * 255);
        this.g = $cbc85b6187a98a9b$var$round((g + lightnessModification) * 255);
        this.b = $cbc85b6187a98a9b$var$round((b + lightnessModification) * 255);
    }
    fromHsv({ h: h, s: s, v: v, a: a }) {
        this._h = h % 360;
        this._s = s;
        this._v = v;
        this.a = typeof a === 'number' ? a : 1;
        const vv = $cbc85b6187a98a9b$var$round(v * 255);
        this.r = vv;
        this.g = vv;
        this.b = vv;
        if (s <= 0) return;
        const hh = h / 60;
        const i = Math.floor(hh);
        const ff = hh - i;
        const p = $cbc85b6187a98a9b$var$round(v * (1.0 - s) * 255);
        const q = $cbc85b6187a98a9b$var$round(v * (1.0 - s * ff) * 255);
        const t = $cbc85b6187a98a9b$var$round(v * (1.0 - s * (1.0 - ff)) * 255);
        switch(i){
            case 0:
                this.g = t;
                this.b = p;
                break;
            case 1:
                this.r = q;
                this.b = p;
                break;
            case 2:
                this.r = p;
                this.b = t;
                break;
            case 3:
                this.r = p;
                this.g = q;
                break;
            case 4:
                this.r = t;
                this.g = p;
                break;
            case 5:
            default:
                this.g = p;
                this.b = q;
                break;
        }
    }
    fromHsvString(trimStr) {
        const cells = $cbc85b6187a98a9b$var$splitColorStr(trimStr, $cbc85b6187a98a9b$var$parseHSVorHSL);
        this.fromHsv({
            h: cells[0],
            s: cells[1],
            v: cells[2],
            a: cells[3]
        });
    }
    fromHslString(trimStr) {
        const cells = $cbc85b6187a98a9b$var$splitColorStr(trimStr, $cbc85b6187a98a9b$var$parseHSVorHSL);
        this.fromHsl({
            h: cells[0],
            s: cells[1],
            l: cells[2],
            a: cells[3]
        });
    }
    fromRgbString(trimStr) {
        const cells = $cbc85b6187a98a9b$var$splitColorStr(trimStr, (num, txt)=>// Convert percentage to number. e.g. 50% -> 128
            txt.includes('%') ? $cbc85b6187a98a9b$var$round(num / 100 * 255) : num);
        this.r = cells[0];
        this.g = cells[1];
        this.b = cells[2];
        this.a = cells[3];
    }
}






const $6a46fec5a09f66be$var$hueStep = 2; // 色相阶梯
const $6a46fec5a09f66be$var$saturationStep = 0.16; // 饱和度阶梯，浅色部分
const $6a46fec5a09f66be$var$saturationStep2 = 0.05; // 饱和度阶梯，深色部分
const $6a46fec5a09f66be$var$brightnessStep1 = 0.05; // 亮度阶梯，浅色部分
const $6a46fec5a09f66be$var$brightnessStep2 = 0.15; // 亮度阶梯，深色部分
const $6a46fec5a09f66be$var$lightColorCount = 5; // 浅色数量，主色上
const $6a46fec5a09f66be$var$darkColorCount = 4; // 深色数量，主色下
// 暗色主题颜色映射关系表
const $6a46fec5a09f66be$var$darkColorMap = [
    {
        index: 7,
        amount: 15
    },
    {
        index: 6,
        amount: 25
    },
    {
        index: 5,
        amount: 30
    },
    {
        index: 5,
        amount: 45
    },
    {
        index: 5,
        amount: 65
    },
    {
        index: 5,
        amount: 85
    },
    {
        index: 4,
        amount: 90
    },
    {
        index: 3,
        amount: 95
    },
    {
        index: 2,
        amount: 97
    },
    {
        index: 1,
        amount: 98
    }
];
function $6a46fec5a09f66be$var$getHue(hsv, i, light) {
    let hue;
    // 根据色相不同，色相转向不同
    if (Math.round(hsv.h) >= 60 && Math.round(hsv.h) <= 240) hue = light ? Math.round(hsv.h) - $6a46fec5a09f66be$var$hueStep * i : Math.round(hsv.h) + $6a46fec5a09f66be$var$hueStep * i;
    else hue = light ? Math.round(hsv.h) + $6a46fec5a09f66be$var$hueStep * i : Math.round(hsv.h) - $6a46fec5a09f66be$var$hueStep * i;
    if (hue < 0) hue += 360;
    else if (hue >= 360) hue -= 360;
    return hue;
}
function $6a46fec5a09f66be$var$getSaturation(hsv, i, light) {
    // grey color don't change saturation
    if (hsv.h === 0 && hsv.s === 0) return hsv.s;
    let saturation;
    if (light) saturation = hsv.s - $6a46fec5a09f66be$var$saturationStep * i;
    else if (i === $6a46fec5a09f66be$var$darkColorCount) saturation = hsv.s + $6a46fec5a09f66be$var$saturationStep;
    else saturation = hsv.s + $6a46fec5a09f66be$var$saturationStep2 * i;
    // 边界值修正
    if (saturation > 1) saturation = 1;
    // 第一格的 s 限制在 0.06-0.1 之间
    if (light && i === $6a46fec5a09f66be$var$lightColorCount && saturation > 0.1) saturation = 0.1;
    if (saturation < 0.06) saturation = 0.06;
    return Math.round(saturation * 100) / 100;
}
function $6a46fec5a09f66be$var$getValue(hsv, i, light) {
    let value;
    if (light) value = hsv.v + $6a46fec5a09f66be$var$brightnessStep1 * i;
    else value = hsv.v - $6a46fec5a09f66be$var$brightnessStep2 * i;
    // Clamp value between 0 and 1
    value = Math.max(0, Math.min(1, value));
    return Math.round(value * 100) / 100;
}
function $6a46fec5a09f66be$export$2e2bcd8739ae039(color, opts = {}) {
    const patterns = [];
    const pColor = new (0, $cbc85b6187a98a9b$export$2c4f38d6c0ecc25a)(color);
    const hsv = pColor.toHsv();
    for(let i = $6a46fec5a09f66be$var$lightColorCount; i > 0; i -= 1){
        const c = new (0, $cbc85b6187a98a9b$export$2c4f38d6c0ecc25a)({
            h: $6a46fec5a09f66be$var$getHue(hsv, i, true),
            s: $6a46fec5a09f66be$var$getSaturation(hsv, i, true),
            v: $6a46fec5a09f66be$var$getValue(hsv, i, true)
        });
        patterns.push(c);
    }
    patterns.push(pColor);
    for(let i = 1; i <= $6a46fec5a09f66be$var$darkColorCount; i += 1){
        const c = new (0, $cbc85b6187a98a9b$export$2c4f38d6c0ecc25a)({
            h: $6a46fec5a09f66be$var$getHue(hsv, i),
            s: $6a46fec5a09f66be$var$getSaturation(hsv, i),
            v: $6a46fec5a09f66be$var$getValue(hsv, i)
        });
        patterns.push(c);
    }
    // dark theme patterns
    if (opts.theme === 'dark') return $6a46fec5a09f66be$var$darkColorMap.map(({ index: index, amount: amount })=>new (0, $cbc85b6187a98a9b$export$2c4f38d6c0ecc25a)(opts.backgroundColor || '#141414').mix(patterns[index], amount).toHexString());
    return patterns.map((c)=>c.toHexString());
}


// Generated by script. Do NOT modify!
const $346125f9ce2d0a1f$export$3968a3afc810b5f5 = {
    "red": "#F5222D",
    "volcano": "#FA541C",
    "orange": "#FA8C16",
    "gold": "#FAAD14",
    "yellow": "#FADB14",
    "lime": "#A0D911",
    "green": "#52C41A",
    "cyan": "#13C2C2",
    "blue": "#1677FF",
    "geekblue": "#2F54EB",
    "purple": "#722ED1",
    "magenta": "#EB2F96",
    "grey": "#666666"
};
const $346125f9ce2d0a1f$export$a90204d1394caf30 = [
    "#fff1f0",
    "#ffccc7",
    "#ffa39e",
    "#ff7875",
    "#ff4d4f",
    "#f5222d",
    "#cf1322",
    "#a8071a",
    "#820014",
    "#5c0011"
];
$346125f9ce2d0a1f$export$a90204d1394caf30.primary = $346125f9ce2d0a1f$export$a90204d1394caf30[5];
const $346125f9ce2d0a1f$export$e63a1643b2f79b16 = [
    "#fff2e8",
    "#ffd8bf",
    "#ffbb96",
    "#ff9c6e",
    "#ff7a45",
    "#fa541c",
    "#d4380d",
    "#ad2102",
    "#871400",
    "#610b00"
];
$346125f9ce2d0a1f$export$e63a1643b2f79b16.primary = $346125f9ce2d0a1f$export$e63a1643b2f79b16[5];
const $346125f9ce2d0a1f$export$ad766f34ace1cafd = [
    "#fff7e6",
    "#ffe7ba",
    "#ffd591",
    "#ffc069",
    "#ffa940",
    "#fa8c16",
    "#d46b08",
    "#ad4e00",
    "#873800",
    "#612500"
];
$346125f9ce2d0a1f$export$ad766f34ace1cafd.primary = $346125f9ce2d0a1f$export$ad766f34ace1cafd[5];
const $346125f9ce2d0a1f$export$c24201f7fe3571d8 = [
    "#fffbe6",
    "#fff1b8",
    "#ffe58f",
    "#ffd666",
    "#ffc53d",
    "#faad14",
    "#d48806",
    "#ad6800",
    "#874d00",
    "#613400"
];
$346125f9ce2d0a1f$export$c24201f7fe3571d8.primary = $346125f9ce2d0a1f$export$c24201f7fe3571d8[5];
const $346125f9ce2d0a1f$export$594c5a8758200c32 = [
    "#feffe6",
    "#ffffb8",
    "#fffb8f",
    "#fff566",
    "#ffec3d",
    "#fadb14",
    "#d4b106",
    "#ad8b00",
    "#876800",
    "#614700"
];
$346125f9ce2d0a1f$export$594c5a8758200c32.primary = $346125f9ce2d0a1f$export$594c5a8758200c32[5];
const $346125f9ce2d0a1f$export$221d31baf2636aad = [
    "#fcffe6",
    "#f4ffb8",
    "#eaff8f",
    "#d3f261",
    "#bae637",
    "#a0d911",
    "#7cb305",
    "#5b8c00",
    "#3f6600",
    "#254000"
];
$346125f9ce2d0a1f$export$221d31baf2636aad.primary = $346125f9ce2d0a1f$export$221d31baf2636aad[5];
const $346125f9ce2d0a1f$export$955a2ebd2fb142ae = [
    "#f6ffed",
    "#d9f7be",
    "#b7eb8f",
    "#95de64",
    "#73d13d",
    "#52c41a",
    "#389e0d",
    "#237804",
    "#135200",
    "#092b00"
];
$346125f9ce2d0a1f$export$955a2ebd2fb142ae.primary = $346125f9ce2d0a1f$export$955a2ebd2fb142ae[5];
const $346125f9ce2d0a1f$export$7474046f446842ee = [
    "#e6fffb",
    "#b5f5ec",
    "#87e8de",
    "#5cdbd3",
    "#36cfc9",
    "#13c2c2",
    "#08979c",
    "#006d75",
    "#00474f",
    "#002329"
];
$346125f9ce2d0a1f$export$7474046f446842ee.primary = $346125f9ce2d0a1f$export$7474046f446842ee[5];
const $346125f9ce2d0a1f$export$2aa0182783e7e9de = [
    "#e6f4ff",
    "#bae0ff",
    "#91caff",
    "#69b1ff",
    "#4096ff",
    "#1677ff",
    "#0958d9",
    "#003eb3",
    "#002c8c",
    "#001d66"
];
$346125f9ce2d0a1f$export$2aa0182783e7e9de.primary = $346125f9ce2d0a1f$export$2aa0182783e7e9de[5];
const $346125f9ce2d0a1f$export$4138d3aeddcbf415 = [
    "#f0f5ff",
    "#d6e4ff",
    "#adc6ff",
    "#85a5ff",
    "#597ef7",
    "#2f54eb",
    "#1d39c4",
    "#10239e",
    "#061178",
    "#030852"
];
$346125f9ce2d0a1f$export$4138d3aeddcbf415.primary = $346125f9ce2d0a1f$export$4138d3aeddcbf415[5];
const $346125f9ce2d0a1f$export$e13cce2a2d16a9d4 = [
    "#f9f0ff",
    "#efdbff",
    "#d3adf7",
    "#b37feb",
    "#9254de",
    "#722ed1",
    "#531dab",
    "#391085",
    "#22075e",
    "#120338"
];
$346125f9ce2d0a1f$export$e13cce2a2d16a9d4.primary = $346125f9ce2d0a1f$export$e13cce2a2d16a9d4[5];
const $346125f9ce2d0a1f$export$2a9ca2e383622e18 = [
    "#fff0f6",
    "#ffd6e7",
    "#ffadd2",
    "#ff85c0",
    "#f759ab",
    "#eb2f96",
    "#c41d7f",
    "#9e1068",
    "#780650",
    "#520339"
];
$346125f9ce2d0a1f$export$2a9ca2e383622e18.primary = $346125f9ce2d0a1f$export$2a9ca2e383622e18[5];
const $346125f9ce2d0a1f$export$e4c89085febbc618 = [
    "#a6a6a6",
    "#999999",
    "#8c8c8c",
    "#808080",
    "#737373",
    "#666666",
    "#404040",
    "#1a1a1a",
    "#000000",
    "#000000"
];
$346125f9ce2d0a1f$export$e4c89085febbc618.primary = $346125f9ce2d0a1f$export$e4c89085febbc618[5];
const $346125f9ce2d0a1f$export$3e2c219d3ab79d01 = $346125f9ce2d0a1f$export$e4c89085febbc618;
const $346125f9ce2d0a1f$export$36ad6df0f83f284d = {
    red: $346125f9ce2d0a1f$export$a90204d1394caf30,
    volcano: $346125f9ce2d0a1f$export$e63a1643b2f79b16,
    orange: $346125f9ce2d0a1f$export$ad766f34ace1cafd,
    gold: $346125f9ce2d0a1f$export$c24201f7fe3571d8,
    yellow: $346125f9ce2d0a1f$export$594c5a8758200c32,
    lime: $346125f9ce2d0a1f$export$221d31baf2636aad,
    green: $346125f9ce2d0a1f$export$955a2ebd2fb142ae,
    cyan: $346125f9ce2d0a1f$export$7474046f446842ee,
    blue: $346125f9ce2d0a1f$export$2aa0182783e7e9de,
    geekblue: $346125f9ce2d0a1f$export$4138d3aeddcbf415,
    purple: $346125f9ce2d0a1f$export$e13cce2a2d16a9d4,
    magenta: $346125f9ce2d0a1f$export$2a9ca2e383622e18,
    grey: $346125f9ce2d0a1f$export$e4c89085febbc618
};
const $346125f9ce2d0a1f$export$e984d34fc144caa1 = [
    "#2a1215",
    "#431418",
    "#58181c",
    "#791a1f",
    "#a61d24",
    "#d32029",
    "#e84749",
    "#f37370",
    "#f89f9a",
    "#fac8c3"
];
$346125f9ce2d0a1f$export$e984d34fc144caa1.primary = $346125f9ce2d0a1f$export$e984d34fc144caa1[5];
const $346125f9ce2d0a1f$export$360e10f78e17a865 = [
    "#2b1611",
    "#441d12",
    "#592716",
    "#7c3118",
    "#aa3e19",
    "#d84a1b",
    "#e87040",
    "#f3956a",
    "#f8b692",
    "#fad4bc"
];
$346125f9ce2d0a1f$export$360e10f78e17a865.primary = $346125f9ce2d0a1f$export$360e10f78e17a865[5];
const $346125f9ce2d0a1f$export$d5a12c698b31fa45 = [
    "#2b1d11",
    "#442a11",
    "#593815",
    "#7c4a15",
    "#aa6215",
    "#d87a16",
    "#e89a3c",
    "#f3b765",
    "#f8cf8d",
    "#fae3b7"
];
$346125f9ce2d0a1f$export$d5a12c698b31fa45.primary = $346125f9ce2d0a1f$export$d5a12c698b31fa45[5];
const $346125f9ce2d0a1f$export$2330427fb6a6af6f = [
    "#2b2111",
    "#443111",
    "#594214",
    "#7c5914",
    "#aa7714",
    "#d89614",
    "#e8b339",
    "#f3cc62",
    "#f8df8b",
    "#faedb5"
];
$346125f9ce2d0a1f$export$2330427fb6a6af6f.primary = $346125f9ce2d0a1f$export$2330427fb6a6af6f[5];
const $346125f9ce2d0a1f$export$67d203119f0ecec = [
    "#2b2611",
    "#443b11",
    "#595014",
    "#7c6e14",
    "#aa9514",
    "#d8bd14",
    "#e8d639",
    "#f3ea62",
    "#f8f48b",
    "#fafab5"
];
$346125f9ce2d0a1f$export$67d203119f0ecec.primary = $346125f9ce2d0a1f$export$67d203119f0ecec[5];
const $346125f9ce2d0a1f$export$51ed2a10d86576ed = [
    "#1f2611",
    "#2e3c10",
    "#3e4f13",
    "#536d13",
    "#6f9412",
    "#8bbb11",
    "#a9d134",
    "#c9e75d",
    "#e4f88b",
    "#f0fab5"
];
$346125f9ce2d0a1f$export$51ed2a10d86576ed.primary = $346125f9ce2d0a1f$export$51ed2a10d86576ed[5];
const $346125f9ce2d0a1f$export$76a3d804058f9b5f = [
    "#162312",
    "#1d3712",
    "#274916",
    "#306317",
    "#3c8618",
    "#49aa19",
    "#6abe39",
    "#8fd460",
    "#b2e58b",
    "#d5f2bb"
];
$346125f9ce2d0a1f$export$76a3d804058f9b5f.primary = $346125f9ce2d0a1f$export$76a3d804058f9b5f[5];
const $346125f9ce2d0a1f$export$dee6c7c6683c0d88 = [
    "#112123",
    "#113536",
    "#144848",
    "#146262",
    "#138585",
    "#13a8a8",
    "#33bcb7",
    "#58d1c9",
    "#84e2d8",
    "#b2f1e8"
];
$346125f9ce2d0a1f$export$dee6c7c6683c0d88.primary = $346125f9ce2d0a1f$export$dee6c7c6683c0d88[5];
const $346125f9ce2d0a1f$export$10e0fd027e632624 = [
    "#111a2c",
    "#112545",
    "#15325b",
    "#15417e",
    "#1554ad",
    "#1668dc",
    "#3c89e8",
    "#65a9f3",
    "#8dc5f8",
    "#b7dcfa"
];
$346125f9ce2d0a1f$export$10e0fd027e632624.primary = $346125f9ce2d0a1f$export$10e0fd027e632624[5];
const $346125f9ce2d0a1f$export$abdd57ab473bba66 = [
    "#131629",
    "#161d40",
    "#1c2755",
    "#203175",
    "#263ea0",
    "#2b4acb",
    "#5273e0",
    "#7f9ef3",
    "#a8c1f8",
    "#d2e0fa"
];
$346125f9ce2d0a1f$export$abdd57ab473bba66.primary = $346125f9ce2d0a1f$export$abdd57ab473bba66[5];
const $346125f9ce2d0a1f$export$7a65e68792738764 = [
    "#1a1325",
    "#24163a",
    "#301c4d",
    "#3e2069",
    "#51258f",
    "#642ab5",
    "#854eca",
    "#ab7ae0",
    "#cda8f0",
    "#ebd7fa"
];
$346125f9ce2d0a1f$export$7a65e68792738764.primary = $346125f9ce2d0a1f$export$7a65e68792738764[5];
const $346125f9ce2d0a1f$export$d260a9321db4ab86 = [
    "#291321",
    "#40162f",
    "#551c3b",
    "#75204f",
    "#a02669",
    "#cb2b83",
    "#e0529c",
    "#f37fb7",
    "#f8a8cc",
    "#fad2e3"
];
$346125f9ce2d0a1f$export$d260a9321db4ab86.primary = $346125f9ce2d0a1f$export$d260a9321db4ab86[5];
const $346125f9ce2d0a1f$export$515283ba400ffa6c = [
    "#151515",
    "#1f1f1f",
    "#2d2d2d",
    "#393939",
    "#494949",
    "#5a5a5a",
    "#6a6a6a",
    "#7b7b7b",
    "#888888",
    "#969696"
];
$346125f9ce2d0a1f$export$515283ba400ffa6c.primary = $346125f9ce2d0a1f$export$515283ba400ffa6c[5];
const $346125f9ce2d0a1f$export$24617255e4daf647 = {
    red: $346125f9ce2d0a1f$export$e984d34fc144caa1,
    volcano: $346125f9ce2d0a1f$export$360e10f78e17a865,
    orange: $346125f9ce2d0a1f$export$d5a12c698b31fa45,
    gold: $346125f9ce2d0a1f$export$2330427fb6a6af6f,
    yellow: $346125f9ce2d0a1f$export$67d203119f0ecec,
    lime: $346125f9ce2d0a1f$export$51ed2a10d86576ed,
    green: $346125f9ce2d0a1f$export$76a3d804058f9b5f,
    cyan: $346125f9ce2d0a1f$export$dee6c7c6683c0d88,
    blue: $346125f9ce2d0a1f$export$10e0fd027e632624,
    geekblue: $346125f9ce2d0a1f$export$abdd57ab473bba66,
    purple: $346125f9ce2d0a1f$export$7a65e68792738764,
    magenta: $346125f9ce2d0a1f$export$d260a9321db4ab86,
    grey: $346125f9ce2d0a1f$export$515283ba400ffa6c
};






const $08c67dd9815325ec$export$37e27b43af4d16eb = {
    blue: '#1677FF',
    purple: '#722ED1',
    cyan: '#13C2C2',
    green: '#52C41A',
    magenta: '#EB2F96',
    /**
   * @deprecated Use magenta instead
   */ pink: '#EB2F96',
    red: '#F5222D',
    orange: '#FA8C16',
    yellow: '#FADB14',
    volcano: '#FA541C',
    geekblue: '#2F54EB',
    gold: '#FAAD14',
    lime: '#A0D911'
};
const $08c67dd9815325ec$var$seedToken = {
    // preset color palettes
    ...$08c67dd9815325ec$export$37e27b43af4d16eb,
    // Color
    colorPrimary: '#1677ff',
    colorSuccess: '#52c41a',
    colorWarning: '#faad14',
    colorError: '#ff4d4f',
    colorInfo: '#1677ff',
    colorLink: '',
    colorTextBase: '',
    colorBgBase: '',
    // Font
    fontFamily: `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
'Noto Color Emoji'`,
    fontFamilyCode: `'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace`,
    fontSize: 14,
    // Line
    lineWidth: 1,
    lineType: 'solid',
    // Motion
    motionUnit: 0.1,
    motionBase: 0,
    motionEaseOutCirc: 'cubic-bezier(0.08, 0.82, 0.17, 1)',
    motionEaseInOutCirc: 'cubic-bezier(0.78, 0.14, 0.15, 0.86)',
    motionEaseOut: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
    motionEaseInOut: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    motionEaseOutBack: 'cubic-bezier(0.12, 0.4, 0.29, 1.46)',
    motionEaseInBack: 'cubic-bezier(0.71, -0.46, 0.88, 0.6)',
    motionEaseInQuint: 'cubic-bezier(0.755, 0.05, 0.855, 0.06)',
    motionEaseOutQuint: 'cubic-bezier(0.23, 1, 0.32, 1)',
    // Radius
    borderRadius: 6,
    // Size
    sizeUnit: 4,
    sizeStep: 4,
    sizePopupArrow: 16,
    // Control Base
    controlHeight: 32,
    // zIndex
    zIndexBase: 0,
    zIndexPopupBase: 1000,
    // Image
    opacityImage: 1,
    // Wireframe
    wireframe: false,
    // Motion
    motion: true
};
var $08c67dd9815325ec$export$2e2bcd8739ae039 = $08c67dd9815325ec$var$seedToken;



function $52f90fb27e5d4c0f$export$2e2bcd8739ae039(seed, { generateColorPalettes: generateColorPalettes, generateNeutralColorPalettes: generateNeutralColorPalettes }) {
    const { colorSuccess: colorSuccessBase, colorWarning: colorWarningBase, colorError: colorErrorBase, colorInfo: colorInfoBase, colorPrimary: colorPrimaryBase, colorBgBase: colorBgBase, colorTextBase: colorTextBase } = seed;
    const primaryColors = generateColorPalettes(colorPrimaryBase);
    const successColors = generateColorPalettes(colorSuccessBase);
    const warningColors = generateColorPalettes(colorWarningBase);
    const errorColors = generateColorPalettes(colorErrorBase);
    const infoColors = generateColorPalettes(colorInfoBase);
    const neutralColors = generateNeutralColorPalettes(colorBgBase, colorTextBase);
    // Color Link
    const colorLink = seed.colorLink || seed.colorInfo;
    const linkColors = generateColorPalettes(colorLink);
    const colorErrorBgFilledHover = new (0, $cbc85b6187a98a9b$export$2c4f38d6c0ecc25a)(errorColors[1]).mix(new (0, $cbc85b6187a98a9b$export$2c4f38d6c0ecc25a)(errorColors[3]), 50).toHexString();
    return {
        ...neutralColors,
        colorPrimaryBg: primaryColors[1],
        colorPrimaryBgHover: primaryColors[2],
        colorPrimaryBorder: primaryColors[3],
        colorPrimaryBorderHover: primaryColors[4],
        colorPrimaryHover: primaryColors[5],
        colorPrimary: primaryColors[6],
        colorPrimaryActive: primaryColors[7],
        colorPrimaryTextHover: primaryColors[8],
        colorPrimaryText: primaryColors[9],
        colorPrimaryTextActive: primaryColors[10],
        colorSuccessBg: successColors[1],
        colorSuccessBgHover: successColors[2],
        colorSuccessBorder: successColors[3],
        colorSuccessBorderHover: successColors[4],
        colorSuccessHover: successColors[4],
        colorSuccess: successColors[6],
        colorSuccessActive: successColors[7],
        colorSuccessTextHover: successColors[8],
        colorSuccessText: successColors[9],
        colorSuccessTextActive: successColors[10],
        colorErrorBg: errorColors[1],
        colorErrorBgHover: errorColors[2],
        colorErrorBgFilledHover: colorErrorBgFilledHover,
        colorErrorBgActive: errorColors[3],
        colorErrorBorder: errorColors[3],
        colorErrorBorderHover: errorColors[4],
        colorErrorHover: errorColors[5],
        colorError: errorColors[6],
        colorErrorActive: errorColors[7],
        colorErrorTextHover: errorColors[8],
        colorErrorText: errorColors[9],
        colorErrorTextActive: errorColors[10],
        colorWarningBg: warningColors[1],
        colorWarningBgHover: warningColors[2],
        colorWarningBorder: warningColors[3],
        colorWarningBorderHover: warningColors[4],
        colorWarningHover: warningColors[4],
        colorWarning: warningColors[6],
        colorWarningActive: warningColors[7],
        colorWarningTextHover: warningColors[8],
        colorWarningText: warningColors[9],
        colorWarningTextActive: warningColors[10],
        colorInfoBg: infoColors[1],
        colorInfoBgHover: infoColors[2],
        colorInfoBorder: infoColors[3],
        colorInfoBorderHover: infoColors[4],
        colorInfoHover: infoColors[4],
        colorInfo: infoColors[6],
        colorInfoActive: infoColors[7],
        colorInfoTextHover: infoColors[8],
        colorInfoText: infoColors[9],
        colorInfoTextActive: infoColors[10],
        colorLinkHover: linkColors[4],
        colorLink: linkColors[6],
        colorLinkActive: linkColors[7],
        colorBgMask: new (0, $cbc85b6187a98a9b$export$2c4f38d6c0ecc25a)('#000').setA(0.45).toRgbString(),
        colorWhite: '#fff'
    };
}


const $48bca3d23a77488f$var$genRadius = (radiusBase)=>{
    let radiusLG = radiusBase;
    let radiusSM = radiusBase;
    let radiusXS = radiusBase;
    let radiusOuter = radiusBase;
    // radiusLG
    if (radiusBase < 6 && radiusBase >= 5) radiusLG = radiusBase + 1;
    else if (radiusBase < 16 && radiusBase >= 6) radiusLG = radiusBase + 2;
    else if (radiusBase >= 16) radiusLG = 16;
    // radiusSM
    if (radiusBase < 7 && radiusBase >= 5) radiusSM = 4;
    else if (radiusBase < 8 && radiusBase >= 7) radiusSM = 5;
    else if (radiusBase < 14 && radiusBase >= 8) radiusSM = 6;
    else if (radiusBase < 16 && radiusBase >= 14) radiusSM = 7;
    else if (radiusBase >= 16) radiusSM = 8;
    // radiusXS
    if (radiusBase < 6 && radiusBase >= 2) radiusXS = 1;
    else if (radiusBase >= 6) radiusXS = 2;
    // radiusOuter
    if (radiusBase > 4 && radiusBase < 8) radiusOuter = 4;
    else if (radiusBase >= 8) radiusOuter = 6;
    return {
        borderRadius: radiusBase,
        borderRadiusXS: radiusXS,
        borderRadiusSM: radiusSM,
        borderRadiusLG: radiusLG,
        borderRadiusOuter: radiusOuter
    };
};
var $48bca3d23a77488f$export$2e2bcd8739ae039 = $48bca3d23a77488f$var$genRadius;


function $852eb69ca1363141$export$2e2bcd8739ae039(token) {
    const { motionUnit: motionUnit, motionBase: motionBase, borderRadius: borderRadius, lineWidth: lineWidth } = token;
    return {
        // motion
        motionDurationFast: `${(motionBase + motionUnit).toFixed(1)}s`,
        motionDurationMid: `${(motionBase + motionUnit * 2).toFixed(1)}s`,
        motionDurationSlow: `${(motionBase + motionUnit * 3).toFixed(1)}s`,
        // line
        lineWidthBold: lineWidth + 1,
        // radius
        ...(0, $48bca3d23a77488f$export$2e2bcd8739ae039)(borderRadius)
    };
}


const $4683697ce2bbd595$var$genControlHeight = (token)=>{
    const { controlHeight: controlHeight } = token;
    return {
        controlHeightSM: controlHeight * 0.75,
        controlHeightXS: controlHeight * 0.5,
        controlHeightLG: controlHeight * 1.25
    };
};
var $4683697ce2bbd595$export$2e2bcd8739ae039 = $4683697ce2bbd595$var$genControlHeight;


function $b61daf35cae43c1e$export$56204a27a2958a55(fontSize) {
    return (fontSize + 8) / fontSize;
}
function $b61daf35cae43c1e$export$2e2bcd8739ae039(base) {
    const fontSizes = Array.from({
        length: 10
    }).map((_, index)=>{
        const i = index - 1;
        const baseSize = base * Math.E ** (i / 5);
        const intSize = index > 1 ? Math.floor(baseSize) : Math.ceil(baseSize);
        // Convert to even
        return Math.floor(intSize / 2) * 2;
    });
    fontSizes[1] = base;
    return fontSizes.map((size)=>({
            size: size,
            lineHeight: $b61daf35cae43c1e$export$56204a27a2958a55(size)
        }));
}


const $6f2896c7a8e61521$var$genFontMapToken = (fontSize)=>{
    const fontSizePairs = (0, $b61daf35cae43c1e$export$2e2bcd8739ae039)(fontSize);
    const fontSizes = fontSizePairs.map((pair)=>pair.size);
    const lineHeights = fontSizePairs.map((pair)=>pair.lineHeight);
    const fontSizeMD = fontSizes[1];
    const fontSizeSM = fontSizes[0];
    const fontSizeLG = fontSizes[2];
    const lineHeight = lineHeights[1];
    const lineHeightSM = lineHeights[0];
    const lineHeightLG = lineHeights[2];
    return {
        fontSizeSM: fontSizeSM,
        fontSize: fontSizeMD,
        fontSizeLG: fontSizeLG,
        fontSizeXL: fontSizes[3],
        fontSizeHeading1: fontSizes[6],
        fontSizeHeading2: fontSizes[5],
        fontSizeHeading3: fontSizes[4],
        fontSizeHeading4: fontSizes[3],
        fontSizeHeading5: fontSizes[2],
        lineHeight: lineHeight,
        lineHeightLG: lineHeightLG,
        lineHeightSM: lineHeightSM,
        fontHeight: Math.round(lineHeight * fontSizeMD),
        fontHeightLG: Math.round(lineHeightLG * fontSizeLG),
        fontHeightSM: Math.round(lineHeightSM * fontSizeSM),
        lineHeightHeading1: lineHeights[6],
        lineHeightHeading2: lineHeights[5],
        lineHeightHeading3: lineHeights[4],
        lineHeightHeading4: lineHeights[3],
        lineHeightHeading5: lineHeights[2]
    };
};
var $6f2896c7a8e61521$export$2e2bcd8739ae039 = $6f2896c7a8e61521$var$genFontMapToken;


function $2fe8327cb4e4622b$export$2e2bcd8739ae039(token) {
    const { sizeUnit: sizeUnit, sizeStep: sizeStep } = token;
    return {
        sizeXXL: sizeUnit * (sizeStep + 8),
        // 48
        sizeXL: sizeUnit * (sizeStep + 4),
        // 32
        sizeLG: sizeUnit * (sizeStep + 2),
        // 24
        sizeMD: sizeUnit * (sizeStep + 1),
        // 20
        sizeMS: sizeUnit * sizeStep,
        // 16
        size: sizeUnit * sizeStep,
        // 16
        sizeSM: sizeUnit * (sizeStep - 1),
        // 12
        sizeXS: sizeUnit * (sizeStep - 2),
        // 8
        sizeXXS: sizeUnit * (sizeStep - 3 // 4
        )
    };
}




const $2a32290212fb4951$export$31f6399ba7ce6bea = (baseColor, alpha)=>new (0, $cbc85b6187a98a9b$export$2c4f38d6c0ecc25a)(baseColor).setA(alpha).toRgbString();
const $2a32290212fb4951$export$7003a8a990e79359 = (baseColor, brightness)=>{
    const instance = new (0, $cbc85b6187a98a9b$export$2c4f38d6c0ecc25a)(baseColor);
    return instance.darken(brightness).toHexString();
};


const $956659a6102dc348$export$da275153033f4ec1 = (baseColor)=>{
    const colors = (0, $6a46fec5a09f66be$export$2e2bcd8739ae039)(baseColor);
    return {
        1: colors[0],
        2: colors[1],
        3: colors[2],
        4: colors[3],
        5: colors[4],
        6: colors[5],
        7: colors[6],
        8: colors[4],
        9: colors[5],
        10: colors[6]
    };
};
const $956659a6102dc348$export$3e0cb0c1d9c1b691 = (bgBaseColor, textBaseColor)=>{
    const colorBgBase = bgBaseColor || '#fff';
    const colorTextBase = textBaseColor || '#000';
    return {
        colorBgBase: colorBgBase,
        colorTextBase: colorTextBase,
        colorText: (0, $2a32290212fb4951$export$31f6399ba7ce6bea)(colorTextBase, 0.88),
        colorTextSecondary: (0, $2a32290212fb4951$export$31f6399ba7ce6bea)(colorTextBase, 0.65),
        colorTextTertiary: (0, $2a32290212fb4951$export$31f6399ba7ce6bea)(colorTextBase, 0.45),
        colorTextQuaternary: (0, $2a32290212fb4951$export$31f6399ba7ce6bea)(colorTextBase, 0.25),
        colorFill: (0, $2a32290212fb4951$export$31f6399ba7ce6bea)(colorTextBase, 0.15),
        colorFillSecondary: (0, $2a32290212fb4951$export$31f6399ba7ce6bea)(colorTextBase, 0.06),
        colorFillTertiary: (0, $2a32290212fb4951$export$31f6399ba7ce6bea)(colorTextBase, 0.04),
        colorFillQuaternary: (0, $2a32290212fb4951$export$31f6399ba7ce6bea)(colorTextBase, 0.02),
        colorBgSolid: (0, $2a32290212fb4951$export$31f6399ba7ce6bea)(colorTextBase, 1),
        colorBgSolidHover: (0, $2a32290212fb4951$export$31f6399ba7ce6bea)(colorTextBase, 0.75),
        colorBgSolidActive: (0, $2a32290212fb4951$export$31f6399ba7ce6bea)(colorTextBase, 0.95),
        colorBgLayout: (0, $2a32290212fb4951$export$7003a8a990e79359)(colorBgBase, 4),
        colorBgContainer: (0, $2a32290212fb4951$export$7003a8a990e79359)(colorBgBase, 0),
        colorBgElevated: (0, $2a32290212fb4951$export$7003a8a990e79359)(colorBgBase, 0),
        colorBgSpotlight: (0, $2a32290212fb4951$export$31f6399ba7ce6bea)(colorTextBase, 0.85),
        colorBgBlur: 'transparent',
        colorBorder: (0, $2a32290212fb4951$export$7003a8a990e79359)(colorBgBase, 15),
        colorBorderDisabled: (0, $2a32290212fb4951$export$7003a8a990e79359)(colorBgBase, 15),
        colorBorderSecondary: (0, $2a32290212fb4951$export$7003a8a990e79359)(colorBgBase, 6)
    };
};


function $3317369eb6e151b1$export$2e2bcd8739ae039(token) {
    // pink is deprecated name of magenta, keep this for backwards compatibility
    (0, $346125f9ce2d0a1f$export$3968a3afc810b5f5).pink = (0, $346125f9ce2d0a1f$export$3968a3afc810b5f5).magenta;
    (0, $346125f9ce2d0a1f$export$36ad6df0f83f284d).pink = (0, $346125f9ce2d0a1f$export$36ad6df0f83f284d).magenta;
    const colorPalettes = Object.keys((0, $08c67dd9815325ec$export$37e27b43af4d16eb)).map((colorKey)=>{
        const colors = token[colorKey] === (0, $346125f9ce2d0a1f$export$3968a3afc810b5f5)[colorKey] ? (0, $346125f9ce2d0a1f$export$36ad6df0f83f284d)[colorKey] : (0, $6a46fec5a09f66be$export$2e2bcd8739ae039)(token[colorKey]);
        return Array.from({
            length: 10
        }, ()=>1).reduce((prev, _, i)=>{
            prev[`${colorKey}-${i + 1}`] = colors[i];
            prev[`${colorKey}${i + 1}`] = colors[i];
            return prev;
        }, {});
    }).reduce((prev, cur)=>{
        prev = {
            ...prev,
            ...cur
        };
        return prev;
    }, {});
    return {
        ...token,
        ...colorPalettes,
        // Colors
        ...(0, $52f90fb27e5d4c0f$export$2e2bcd8739ae039)(token, {
            generateColorPalettes: $956659a6102dc348$export$da275153033f4ec1,
            generateNeutralColorPalettes: $956659a6102dc348$export$3e0cb0c1d9c1b691
        }),
        // Font
        ...(0, $6f2896c7a8e61521$export$2e2bcd8739ae039)(token.fontSize),
        // Size
        ...(0, $2fe8327cb4e4622b$export$2e2bcd8739ae039)(token),
        // Height
        ...(0, $4683697ce2bbd595$export$2e2bcd8739ae039)(token),
        // Others
        ...(0, $852eb69ca1363141$export$2e2bcd8739ae039)(token)
    };
}


const $a13b22c41a7bf0da$var$defaultTheme = (0, $6011ea73ba4026bc$export$2e2bcd8739ae039)((0, $3317369eb6e151b1$export$2e2bcd8739ae039));
var $a13b22c41a7bf0da$export$2e2bcd8739ae039 = $a13b22c41a7bf0da$var$defaultTheme;


var $N3oW3 = parcelRequire("N3oW3");


const $a70f9f31ea093dd1$export$f84bd70098573c5c = {
    token: (0, $08c67dd9815325ec$export$2e2bcd8739ae039),
    override: {
        override: (0, $08c67dd9815325ec$export$2e2bcd8739ae039)
    },
    hashed: true
};
const $a70f9f31ea093dd1$export$69b0ebb9efcddb30 = /*#__PURE__*/ (0, $N3oW3.default).createContext($a70f9f31ea093dd1$export$f84bd70098573c5c);




var $N3oW3 = parcelRequire("N3oW3");




var $N3oW3 = parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");

var $N3oW3 = parcelRequire("N3oW3");
parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
const $584e5b2cbeb13ab1$var$OrderContext = /*#__PURE__*/ $hO8yS.createContext(null);
var $584e5b2cbeb13ab1$export$2e2bcd8739ae039 = $584e5b2cbeb13ab1$var$OrderContext;


let $204459889025c74e$export$18c8ad048e32c7d5 = false;
function $204459889025c74e$export$121d9fd0ca615463(nextInline) {
    if (typeof nextInline === 'boolean') $204459889025c74e$export$18c8ad048e32c7d5 = nextInline;
    return $204459889025c74e$export$18c8ad048e32c7d5;
}


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");



const $05dee0e157fb227f$var$EMPTY_LIST = [];
function $05dee0e157fb227f$export$2e2bcd8739ae039(render, debug) {
    const [ele] = $32rMB.useState(()=>{
        if (!(0, $bfbc54ac1ac0215e$export$2e2bcd8739ae039)()) return null;
        const defaultEle = document.createElement('div');
        return defaultEle;
    });
    // ========================== Order ==========================
    const appendedRef = $32rMB.useRef(false);
    const queueCreate = $32rMB.useContext((0, $584e5b2cbeb13ab1$export$2e2bcd8739ae039));
    const [queue, setQueue] = $32rMB.useState($05dee0e157fb227f$var$EMPTY_LIST);
    const mergedQueueCreate = queueCreate || (appendedRef.current ? undefined : (appendFn)=>{
        setQueue((origin)=>{
            const newQueue = [
                appendFn,
                ...origin
            ];
            return newQueue;
        });
    });
    // =========================== DOM ===========================
    function append() {
        if (!ele.parentElement) document.body.appendChild(ele);
        appendedRef.current = true;
    }
    function cleanup() {
        ele.parentElement?.removeChild(ele);
        appendedRef.current = false;
    }
    (0, $60cea2402df671e7$export$2e2bcd8739ae039)(()=>{
        if (render) {
            if (queueCreate) queueCreate(append);
            else append();
        } else cleanup();
        return cleanup;
    }, [
        render
    ]);
    (0, $60cea2402df671e7$export$2e2bcd8739ae039)(()=>{
        if (queue.length) {
            queue.forEach((appendFn)=>appendFn());
            setQueue($05dee0e157fb227f$var$EMPTY_LIST);
        }
    }, [
        queue
    ]);
    return [
        ele,
        mergedQueueCreate
    ];
}


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");


/* eslint-disable no-param-reassign */ 
let $0ea1ccba8e72ea45$var$cached;
function $0ea1ccba8e72ea45$var$measureScrollbarSize(ele) {
    const randomId = `rc-scrollbar-measure-${Math.random().toString(36).substring(7)}`;
    const measureEle = document.createElement('div');
    measureEle.id = randomId;
    // Create Style
    const measureStyle = measureEle.style;
    measureStyle.position = 'absolute';
    measureStyle.left = '0';
    measureStyle.top = '0';
    measureStyle.width = '100px';
    measureStyle.height = '100px';
    measureStyle.overflow = 'scroll';
    // Clone Style if needed
    let fallbackWidth;
    let fallbackHeight;
    if (ele) {
        const targetStyle = getComputedStyle(ele);
        measureStyle.scrollbarColor = targetStyle.scrollbarColor;
        measureStyle.scrollbarWidth = targetStyle.scrollbarWidth;
        // Set Webkit style
        const webkitScrollbarStyle = getComputedStyle(ele, '::-webkit-scrollbar');
        const width = parseInt(webkitScrollbarStyle.width, 10);
        const height = parseInt(webkitScrollbarStyle.height, 10);
        // Try wrap to handle CSP case
        try {
            const widthStyle = width ? `width: ${webkitScrollbarStyle.width};` : '';
            const heightStyle = height ? `height: ${webkitScrollbarStyle.height};` : '';
            (0, $275621885d66fa13$export$4d99a2890bb989f0)(`
#${randomId}::-webkit-scrollbar {
${widthStyle}
${heightStyle}
}`, randomId);
        } catch (e) {
            // Can't wrap, just log error
            console.error(e);
            // Get from style directly
            fallbackWidth = width;
            fallbackHeight = height;
        }
    }
    document.body.appendChild(measureEle);
    // Measure. Get fallback style if provided
    const scrollWidth = ele && fallbackWidth && !isNaN(fallbackWidth) ? fallbackWidth : measureEle.offsetWidth - measureEle.clientWidth;
    const scrollHeight = ele && fallbackHeight && !isNaN(fallbackHeight) ? fallbackHeight : measureEle.offsetHeight - measureEle.clientHeight;
    // Clean up
    document.body.removeChild(measureEle);
    (0, $275621885d66fa13$export$2232e336aecaa80a)(randomId);
    return {
        width: scrollWidth,
        height: scrollHeight
    };
}
function $0ea1ccba8e72ea45$export$2e2bcd8739ae039(fresh) {
    if (typeof document === 'undefined') return 0;
    if (fresh || $0ea1ccba8e72ea45$var$cached === undefined) $0ea1ccba8e72ea45$var$cached = $0ea1ccba8e72ea45$var$measureScrollbarSize();
    return $0ea1ccba8e72ea45$var$cached.width;
}
function $0ea1ccba8e72ea45$export$4f3ef2310365b56a(target) {
    if (typeof document === 'undefined' || !target || !(target instanceof Element)) return {
        width: 0,
        height: 0
    };
    return $0ea1ccba8e72ea45$var$measureScrollbarSize(target);
}


/**
 * Test usage export. Do not use in your production
 */ function $670eaff2cea66ba9$export$31b5c8f1131a3a52() {
    return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
}


const $21f7fd3f0f1282dd$var$UNIQUE_ID = `rc-util-locker-${Date.now()}`;
let $21f7fd3f0f1282dd$var$uuid = 0;
function $21f7fd3f0f1282dd$export$2e2bcd8739ae039(lock) {
    const mergedLock = !!lock;
    const [id] = $32rMB.useState(()=>{
        $21f7fd3f0f1282dd$var$uuid += 1;
        return `${$21f7fd3f0f1282dd$var$UNIQUE_ID}_${$21f7fd3f0f1282dd$var$uuid}`;
    });
    (0, $60cea2402df671e7$export$2e2bcd8739ae039)(()=>{
        if (mergedLock) {
            const scrollbarSize = (0, $0ea1ccba8e72ea45$export$4f3ef2310365b56a)(document.body).width;
            const isOverflow = (0, $670eaff2cea66ba9$export$31b5c8f1131a3a52)();
            (0, $275621885d66fa13$export$4d99a2890bb989f0)(`
html body {
  overflow-y: hidden;
  ${isOverflow ? `width: calc(100% - ${scrollbarSize}px);` : ''}
}`, id);
        } else (0, $275621885d66fa13$export$2232e336aecaa80a)(id);
        return ()=>{
            (0, $275621885d66fa13$export$2232e336aecaa80a)(id);
        };
    }, [
        mergedLock,
        id
    ]);
}


const $36a889a190f59e42$var$getPortalContainer = (getContainer)=>{
    if (getContainer === false) return false;
    if (!(0, $bfbc54ac1ac0215e$export$2e2bcd8739ae039)() || !getContainer) return null;
    if (typeof getContainer === 'string') return document.querySelector(getContainer);
    if (typeof getContainer === 'function') return getContainer();
    return getContainer;
};
const $36a889a190f59e42$var$Portal = /*#__PURE__*/ $N3oW3.forwardRef((props, ref)=>{
    const { open: open, autoLock: autoLock, getContainer: getContainer, debug: debug, autoDestroy: autoDestroy = true, children: children } = props;
    const [shouldRender, setShouldRender] = $32rMB.useState(open);
    const mergedRender = shouldRender || open;
    // ====================== Should Render ======================
    $32rMB.useEffect(()=>{
        if (autoDestroy || open) setShouldRender(open);
    }, [
        open,
        autoDestroy
    ]);
    // ======================== Container ========================
    const [innerContainer, setInnerContainer] = $32rMB.useState(()=>$36a889a190f59e42$var$getPortalContainer(getContainer));
    $32rMB.useEffect(()=>{
        const customizeContainer = $36a889a190f59e42$var$getPortalContainer(getContainer);
        // Tell component that we check this in effect which is safe to be `null`
        setInnerContainer(customizeContainer ?? null);
    });
    const [defaultContainer, queueCreate] = (0, $05dee0e157fb227f$export$2e2bcd8739ae039)(mergedRender && !innerContainer, debug);
    const mergedContainer = innerContainer ?? defaultContainer;
    // ========================= Locker ==========================
    (0, $21f7fd3f0f1282dd$export$2e2bcd8739ae039)(autoLock && open && (0, $bfbc54ac1ac0215e$export$2e2bcd8739ae039)() && (mergedContainer === defaultContainer || mergedContainer === document.body));
    // =========================== Ref ===========================
    let childRef = null;
    if (children && (0, $2706ed817e87019d$export$c1cec34af06bcf7)(children) && ref) childRef = (0, $2706ed817e87019d$export$7465e5c0bf44f19a)(children);
    const mergedRef = (0, $2706ed817e87019d$export$1d1c999670a1285d)(childRef, ref);
    // ========================= Render ==========================
    // Do not render when nothing need render
    // When innerContainer is `undefined`, it may not ready since user use ref in the same render
    if (!mergedRender || !(0, $bfbc54ac1ac0215e$export$2e2bcd8739ae039)() || innerContainer === undefined) return null;
    // Render inline
    const renderInline = mergedContainer === false || (0, $204459889025c74e$export$121d9fd0ca615463)();
    let reffedChildren = children;
    if (ref) reffedChildren = /*#__PURE__*/ $N3oW3.cloneElement(children, {
        ref: mergedRef
    });
    return /*#__PURE__*/ $hO8yS.createElement((0, $584e5b2cbeb13ab1$export$2e2bcd8739ae039).Provider, {
        value: queueCreate
    }, renderInline ? reffedChildren : /*#__PURE__*/ (0, $N3oW3.createPortal)(reffedChildren, mergedContainer));
});
var $36a889a190f59e42$export$2e2bcd8739ae039 = $36a889a190f59e42$var$Portal;



var $af60d9f9d47b1e00$export$2e2bcd8739ae039 = (0, $36a889a190f59e42$export$2e2bcd8739ae039);


function $ee9d4e7b280b4edb$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $ee9d4e7b280b4edb$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $ee9d4e7b280b4edb$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $ee9d4e7b280b4edb$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $ee9d4e7b280b4edb$export$2e2bcd8739ae039 = $ee9d4e7b280b4edb$export$4f5d2d50c9deca37;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");


function $c1d2a04d2d287797$export$41e30d8dd0ba7a50(node) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Element
    // Since XULElement is also subclass of Element, we only need HTMLElement and SVGElement
    return node instanceof HTMLElement || node instanceof SVGElement;
}
function $c1d2a04d2d287797$export$9aa546fdc20ae5b3(node) {
    if (node && typeof node === 'object' && $c1d2a04d2d287797$export$41e30d8dd0ba7a50(node.nativeElement)) return node.nativeElement;
    if ($c1d2a04d2d287797$export$41e30d8dd0ba7a50(node)) return node;
    return null;
}
function $c1d2a04d2d287797$export$2e2bcd8739ae039(node) {
    const domNode = $c1d2a04d2d287797$export$9aa546fdc20ae5b3(node);
    if (domNode) return domNode;
    if (node && typeof node === 'object' && 'current' in node) {
        const refDomNode = $c1d2a04d2d287797$export$9aa546fdc20ae5b3(node.current);
        if (refDomNode) return refDomNode;
    }
    return null;
}




var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");
const $9933b70b5b0c73d4$export$db36075d98ba73d3 = /*#__PURE__*/ $hO8yS.createContext(null);
function $9933b70b5b0c73d4$export$fb8073518f34e6ec({ children: children, onBatchResize: onBatchResize }) {
    const resizeIdRef = $32rMB.useRef(0);
    const resizeInfosRef = $32rMB.useRef([]);
    const onCollectionResize = $32rMB.useContext($9933b70b5b0c73d4$export$db36075d98ba73d3);
    const onResize = $32rMB.useCallback((size, element, data)=>{
        resizeIdRef.current += 1;
        const currentId = resizeIdRef.current;
        resizeInfosRef.current.push({
            size: size,
            element: element,
            data: data
        });
        Promise.resolve().then(()=>{
            if (currentId === resizeIdRef.current) {
                onBatchResize?.(resizeInfosRef.current);
                resizeInfosRef.current = [];
            }
        });
        // Continue bubbling if parent exist
        onCollectionResize?.(size, element, data);
    }, [
        onBatchResize,
        onCollectionResize
    ]);
    return /*#__PURE__*/ $hO8yS.createElement($9933b70b5b0c73d4$export$db36075d98ba73d3.Provider, {
        value: onResize
    }, children);
}


// =============================== Const ===============================
const $626b6895355afd11$var$elementListeners = new Map();
function $626b6895355afd11$var$onResize(entities) {
    entities.forEach((entity)=>{
        const { target: target } = entity;
        $626b6895355afd11$var$elementListeners.get(target)?.forEach((listener)=>listener(target));
    });
}
// Delay create ResizeObserver since it's not supported in server side
let $626b6895355afd11$var$observer;
function $626b6895355afd11$var$ensureResizeObserver() {
    if (!$626b6895355afd11$var$observer) $626b6895355afd11$var$observer = new ResizeObserver($626b6895355afd11$var$onResize);
    return $626b6895355afd11$var$observer;
}
const $626b6895355afd11$export$3fbe5a08fd9e4702 = null; // eslint-disable-line
const $626b6895355afd11$export$524f0fd3b47831a = null; // eslint-disable-line
function $626b6895355afd11$export$d1203567a167490e(element, callback) {
    if (!$626b6895355afd11$var$elementListeners.has(element)) {
        $626b6895355afd11$var$elementListeners.set(element, new Set());
        $626b6895355afd11$var$ensureResizeObserver().observe(element);
    }
    $626b6895355afd11$var$elementListeners.get(element).add(callback);
}
function $626b6895355afd11$export$23a2283368c55ea2(element, callback) {
    if ($626b6895355afd11$var$elementListeners.has(element)) {
        $626b6895355afd11$var$elementListeners.get(element).delete(callback);
        if (!$626b6895355afd11$var$elementListeners.get(element).size) {
            $626b6895355afd11$var$ensureResizeObserver().unobserve(element);
            $626b6895355afd11$var$elementListeners.delete(element);
        }
    }
}


function $63ac96ced8fe5457$var$SingleObserver(props, ref) {
    const { children: children, disabled: disabled } = props;
    const elementRef = $32rMB.useRef(null);
    const onCollectionResize = $32rMB.useContext((0, $9933b70b5b0c73d4$export$db36075d98ba73d3));
    // =========================== Children ===========================
    const isRenderProps = typeof children === 'function';
    const mergedChildren = isRenderProps ? children(elementRef) : children;
    // ============================= Size =============================
    const sizeRef = $32rMB.useRef({
        width: -1,
        height: -1,
        offsetWidth: -1,
        offsetHeight: -1
    });
    // ============================= Ref ==============================
    const canRef = !isRenderProps && /*#__PURE__*/ $N3oW3.isValidElement(mergedChildren) && (0, $2706ed817e87019d$export$c1cec34af06bcf7)(mergedChildren);
    const originRef = canRef ? (0, $2706ed817e87019d$export$7465e5c0bf44f19a)(mergedChildren) : null;
    const mergedRef = (0, $2706ed817e87019d$export$1d1c999670a1285d)(originRef, elementRef);
    const getDomElement = ()=>{
        return (0, $c1d2a04d2d287797$export$9aa546fdc20ae5b3)(elementRef.current);
    };
    $32rMB.useImperativeHandle(ref, ()=>getDomElement());
    // =========================== Observe ============================
    const propsRef = $32rMB.useRef(props);
    propsRef.current = props;
    // Handler
    const onInternalResize = $32rMB.useCallback((target)=>{
        const { onResize: onResize, data: data } = propsRef.current;
        const { width: width, height: height } = target.getBoundingClientRect();
        const { offsetWidth: offsetWidth, offsetHeight: offsetHeight } = target;
        /**
     * Resize observer trigger when content size changed.
     * In most case we just care about element size,
     * let's use `boundary` instead of `contentRect` here to avoid shaking.
     */ const fixedWidth = Math.floor(width);
        const fixedHeight = Math.floor(height);
        if (sizeRef.current.width !== fixedWidth || sizeRef.current.height !== fixedHeight || sizeRef.current.offsetWidth !== offsetWidth || sizeRef.current.offsetHeight !== offsetHeight) {
            const size = {
                width: fixedWidth,
                height: fixedHeight,
                offsetWidth: offsetWidth,
                offsetHeight: offsetHeight
            };
            sizeRef.current = size;
            // IE is strange, right?
            const mergedOffsetWidth = offsetWidth === Math.round(width) ? width : offsetWidth;
            const mergedOffsetHeight = offsetHeight === Math.round(height) ? height : offsetHeight;
            const sizeInfo = {
                ...size,
                offsetWidth: mergedOffsetWidth,
                offsetHeight: mergedOffsetHeight
            };
            // Let collection know what happened
            onCollectionResize?.(sizeInfo, target, data);
            if (onResize) // defer the callback but not defer to next frame
            Promise.resolve().then(()=>{
                onResize(sizeInfo, target);
            });
        }
    }, []);
    // Dynamic observe
    $32rMB.useEffect(()=>{
        const currentElement = getDomElement();
        if (currentElement && !disabled) (0, $626b6895355afd11$export$d1203567a167490e)(currentElement, onInternalResize);
        return ()=>(0, $626b6895355afd11$export$23a2283368c55ea2)(currentElement, onInternalResize);
    }, [
        elementRef.current,
        disabled
    ]);
    // ============================ Render ============================
    return canRef ? /*#__PURE__*/ $N3oW3.cloneElement(mergedChildren, {
        ref: mergedRef
    }) : mergedChildren;
}
const $63ac96ced8fe5457$var$RefSingleObserver = /*#__PURE__*/ $N3oW3.forwardRef($63ac96ced8fe5457$var$SingleObserver);
var $63ac96ced8fe5457$export$2e2bcd8739ae039 = $63ac96ced8fe5457$var$RefSingleObserver;




function $b8d12c084d14878d$var$_extends() {
    $b8d12c084d14878d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b8d12c084d14878d$var$_extends.apply(this, arguments);
}
const $b8d12c084d14878d$var$INTERNAL_PREFIX_KEY = 'rc-observer-key';
function $b8d12c084d14878d$var$ResizeObserver(props, ref) {
    const { children: children } = props;
    const childNodes = typeof children === 'function' ? [
        children
    ] : (0, $a60ede783f74e6a9$export$2e2bcd8739ae039)(children);
    return childNodes.map((child, index)=>{
        const key = child?.key || `${$b8d12c084d14878d$var$INTERNAL_PREFIX_KEY}-${index}`;
        return /*#__PURE__*/ $hO8yS.createElement((0, $63ac96ced8fe5457$export$2e2bcd8739ae039), $b8d12c084d14878d$var$_extends({}, props, {
            key: key,
            ref: index === 0 ? ref : undefined
        }), child);
    });
}
const $b8d12c084d14878d$var$RefResizeObserver = /*#__PURE__*/ $N3oW3.forwardRef($b8d12c084d14878d$var$ResizeObserver);
$b8d12c084d14878d$var$RefResizeObserver.Collection = (0, $9933b70b5b0c73d4$export$fb8073518f34e6ec);
var $b8d12c084d14878d$export$2e2bcd8739ae039 = $b8d12c084d14878d$var$RefResizeObserver;



function $66a153f87c091f0a$var$getRoot(ele) {
    return ele?.getRootNode?.();
}
function $66a153f87c091f0a$export$cca82218ea4431a(ele) {
    return $66a153f87c091f0a$var$getRoot(ele) instanceof ShadowRoot;
}
function $66a153f87c091f0a$export$70e8259662bb498b(ele) {
    return $66a153f87c091f0a$export$cca82218ea4431a(ele) ? $66a153f87c091f0a$var$getRoot(ele) : null;
}




var $N3oW3 = parcelRequire("N3oW3");
function $32268c06752c3bab$var$getUseId() {
    // We need fully clone React function here to avoid webpack warning React 17 do not export `useId`
    const fullClone = {
        ...$N3oW3
    };
    return fullClone.useId;
}
let $32268c06752c3bab$var$uuid = 0;
function $32268c06752c3bab$export$2f0435a662835942() {}
const $32268c06752c3bab$var$useOriginId = $32268c06752c3bab$var$getUseId();
var $32268c06752c3bab$export$2e2bcd8739ae039 = $32268c06752c3bab$var$useOriginId ? // Use React `useId`
function useId(id) {
    const reactId = $32268c06752c3bab$var$useOriginId();
    // Developer passed id is single source of truth
    if (id) return id;
    return reactId;
} : // Use compatible of `useId`
function useCompatId(id) {
    // Inner id for accessibility usage. Only work in client side
    const [innerId, setInnerId] = $N3oW3.useState('ssr-id');
    $N3oW3.useEffect(()=>{
        const nextId = $32268c06752c3bab$var$uuid;
        $32268c06752c3bab$var$uuid += 1;
        setInnerId(`rc_unique_${nextId}`);
    }, []);
    // Developer passed id is single source of truth
    if (id) return id;
    // Return react native id or inner id
    return innerId;
};




var $N3oW3 = parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");

/* eslint-disable react/default-props-match-prop-types, react/no-multi-comp, react/prop-types */ 



var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
const $d83990e2d9a86041$export$841858b892ce1f4c = /*#__PURE__*/ $hO8yS.createContext({});
function $d83990e2d9a86041$export$2e2bcd8739ae039({ children: children, ...props }) {
    return /*#__PURE__*/ $hO8yS.createElement($d83990e2d9a86041$export$841858b892ce1f4c.Provider, {
        value: props
    }, children);
}




parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");

function $15d1399ec9ddc111$export$2e2bcd8739ae039(defaultValue) {
    const [, forceUpdate] = $32rMB.useReducer((x)=>x + 1, 0);
    const currentValueRef = $32rMB.useRef(defaultValue);
    const getValue = (0, $ea93068db096b7d6$export$2e2bcd8739ae039)(()=>{
        return currentValueRef.current;
    });
    const setValue = (0, $ea93068db096b7d6$export$2e2bcd8739ae039)((updater)=>{
        currentValueRef.current = typeof updater === 'function' ? updater(currentValueRef.current) : updater;
        forceUpdate();
    });
    return [
        getValue,
        setValue
    ];
}


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
const $111916efe4142a03$export$de71442bbf2143da = 'none';
const $111916efe4142a03$export$4fc3521687bcacd2 = 'appear';
const $111916efe4142a03$export$5d6af549241fe2e8 = 'enter';
const $111916efe4142a03$export$59b1c493d29f68e4 = 'leave';
const $111916efe4142a03$export$40b34dd77d5522bf = 'none';
const $111916efe4142a03$export$1b792916a5fac4fc = 'prepare';
const $111916efe4142a03$export$9563153dd25a3ce8 = 'start';
const $111916efe4142a03$export$e205886172277ec6 = 'active';
const $111916efe4142a03$export$3a846c3d2fac10b8 = 'end';
const $111916efe4142a03$export$98351fa4e6b4f204 = 'prepared';


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");

// ================= Transition =================
// Event wrapper. Copy from react source code
function $cde841a66656db50$var$makePrefixMap(styleProp, eventName) {
    const prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes[`Webkit${styleProp}`] = `webkit${eventName}`;
    prefixes[`Moz${styleProp}`] = `moz${eventName}`;
    prefixes[`ms${styleProp}`] = `MS${eventName}`;
    prefixes[`O${styleProp}`] = `o${eventName.toLowerCase()}`;
    return prefixes;
}
function $cde841a66656db50$export$6e8b350b1a8958a0(domSupport, win) {
    const prefixes = {
        animationend: $cde841a66656db50$var$makePrefixMap('Animation', 'AnimationEnd'),
        transitionend: $cde841a66656db50$var$makePrefixMap('Transition', 'TransitionEnd')
    };
    if (domSupport) {
        if (!('AnimationEvent' in win)) delete prefixes.animationend.animation;
        if (!('TransitionEvent' in win)) delete prefixes.transitionend.transition;
    }
    return prefixes;
}
const $cde841a66656db50$var$vendorPrefixes = $cde841a66656db50$export$6e8b350b1a8958a0((0, $bfbc54ac1ac0215e$export$2e2bcd8739ae039)(), typeof window !== 'undefined' ? window : {});
let $cde841a66656db50$var$style = {};
if ((0, $bfbc54ac1ac0215e$export$2e2bcd8739ae039)()) ({ style: $cde841a66656db50$var$style } = document.createElement('div'));
const $cde841a66656db50$var$prefixedEventNames = {};
function $cde841a66656db50$export$a032e4f39350c1d8(eventName) {
    if ($cde841a66656db50$var$prefixedEventNames[eventName]) return $cde841a66656db50$var$prefixedEventNames[eventName];
    const prefixMap = $cde841a66656db50$var$vendorPrefixes[eventName];
    if (prefixMap) {
        const stylePropList = Object.keys(prefixMap);
        const len = stylePropList.length;
        for(let i = 0; i < len; i += 1){
            const styleProp = stylePropList[i];
            if (Object.prototype.hasOwnProperty.call(prefixMap, styleProp) && styleProp in $cde841a66656db50$var$style) {
                $cde841a66656db50$var$prefixedEventNames[eventName] = prefixMap[styleProp];
                return $cde841a66656db50$var$prefixedEventNames[eventName];
            }
        }
    }
    return '';
}
const $cde841a66656db50$var$internalAnimationEndName = $cde841a66656db50$export$a032e4f39350c1d8('animationend');
const $cde841a66656db50$var$internalTransitionEndName = $cde841a66656db50$export$a032e4f39350c1d8('transitionend');
const $cde841a66656db50$export$d28133ed3ad06c8b = !!($cde841a66656db50$var$internalAnimationEndName && $cde841a66656db50$var$internalTransitionEndName);
const $cde841a66656db50$export$760cc9769c51b738 = $cde841a66656db50$var$internalAnimationEndName || 'animationend';
const $cde841a66656db50$export$44baea64b8602e3c = $cde841a66656db50$var$internalTransitionEndName || 'transitionend';
function $cde841a66656db50$export$27c72201b1d09951(transitionName, transitionType) {
    if (!transitionName) return null;
    if (typeof transitionName === 'object') {
        const type = transitionType.replace(/-\w/g, (match)=>match[1].toUpperCase());
        return transitionName[type];
    }
    return `${transitionName}-${transitionType}`;
}


var $92eb9ca7af535db9$export$2e2bcd8739ae039 = (onInternalMotionEnd)=>{
    const cacheElementRef = (0, $32rMB.useRef)();
    // Remove events
    function removeMotionEvents(element) {
        if (element) {
            element.removeEventListener((0, $cde841a66656db50$export$44baea64b8602e3c), onInternalMotionEnd);
            element.removeEventListener((0, $cde841a66656db50$export$760cc9769c51b738), onInternalMotionEnd);
        }
    }
    // Patch events
    function patchMotionEvents(element) {
        if (cacheElementRef.current && cacheElementRef.current !== element) removeMotionEvents(cacheElementRef.current);
        if (element && element !== cacheElementRef.current) {
            element.addEventListener((0, $cde841a66656db50$export$44baea64b8602e3c), onInternalMotionEnd);
            element.addEventListener((0, $cde841a66656db50$export$760cc9769c51b738), onInternalMotionEnd);
            // Save as cache in case dom removed trigger by `motionDeadline`
            cacheElementRef.current = element;
        }
    }
    // Clean up when removed
    $32rMB.useEffect(()=>()=>{
            removeMotionEvents(cacheElementRef.current);
        }, []);
    return [
        patchMotionEvents,
        removeMotionEvents
    ];
};



parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
// It's safe to use `useLayoutEffect` but the warning is annoying
const $e04c1362dfd2d49d$var$useIsomorphicLayoutEffect = (0, $bfbc54ac1ac0215e$export$2e2bcd8739ae039)() ? (0, $32rMB.useLayoutEffect) : (0, $32rMB.useEffect);
var $e04c1362dfd2d49d$export$2e2bcd8739ae039 = $e04c1362dfd2d49d$var$useIsomorphicLayoutEffect;



parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");


let $c9c36e20d667d30c$var$raf = (callback)=>+setTimeout(callback, 16);
let $c9c36e20d667d30c$var$caf = (num)=>clearTimeout(num);
if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
    $c9c36e20d667d30c$var$raf = (callback)=>window.requestAnimationFrame(callback);
    $c9c36e20d667d30c$var$caf = (handle)=>window.cancelAnimationFrame(handle);
}
let $c9c36e20d667d30c$var$rafUUID = 0;
const $c9c36e20d667d30c$var$rafIds = new Map();
function $c9c36e20d667d30c$var$cleanup(id) {
    $c9c36e20d667d30c$var$rafIds.delete(id);
}
const $c9c36e20d667d30c$var$wrapperRaf = (callback, times = 1)=>{
    $c9c36e20d667d30c$var$rafUUID += 1;
    const id = $c9c36e20d667d30c$var$rafUUID;
    function callRef(leftTimes) {
        if (leftTimes === 0) {
            // Clean up
            $c9c36e20d667d30c$var$cleanup(id);
            // Trigger
            callback();
        } else {
            // Next raf
            const realId = $c9c36e20d667d30c$var$raf(()=>{
                callRef(leftTimes - 1);
            });
            // Bind real raf id
            $c9c36e20d667d30c$var$rafIds.set(id, realId);
        }
    }
    callRef(times);
    return id;
};
$c9c36e20d667d30c$var$wrapperRaf.cancel = (id)=>{
    const realId = $c9c36e20d667d30c$var$rafIds.get(id);
    $c9c36e20d667d30c$var$cleanup(id);
    return $c9c36e20d667d30c$var$caf(realId);
};
var $c9c36e20d667d30c$export$2e2bcd8739ae039 = $c9c36e20d667d30c$var$wrapperRaf;


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
var $8fdf5d91bedb073a$export$2e2bcd8739ae039 = ()=>{
    const nextFrameRef = $32rMB.useRef(null);
    function cancelNextFrame() {
        (0, $c9c36e20d667d30c$export$2e2bcd8739ae039).cancel(nextFrameRef.current);
    }
    function nextFrame(callback, delay = 2) {
        cancelNextFrame();
        const nextFrameId = (0, $c9c36e20d667d30c$export$2e2bcd8739ae039)(()=>{
            if (delay <= 1) callback({
                isCanceled: ()=>nextFrameId !== nextFrameRef.current
            });
            else nextFrame(callback, delay - 1);
        });
        nextFrameRef.current = nextFrameId;
    }
    $32rMB.useEffect(()=>()=>{
            cancelNextFrame();
        }, []);
    return [
        nextFrame,
        cancelNextFrame
    ];
};


const $926405414855a8c7$var$FULL_STEP_QUEUE = [
    (0, $111916efe4142a03$export$1b792916a5fac4fc),
    (0, $111916efe4142a03$export$9563153dd25a3ce8),
    (0, $111916efe4142a03$export$e205886172277ec6),
    (0, $111916efe4142a03$export$3a846c3d2fac10b8)
];
const $926405414855a8c7$var$SIMPLE_STEP_QUEUE = [
    (0, $111916efe4142a03$export$1b792916a5fac4fc),
    (0, $111916efe4142a03$export$98351fa4e6b4f204)
];
const $926405414855a8c7$export$c2029bf6cfdbc28a = false;
const $926405414855a8c7$export$dbee1e282e8c4830 = true;
function $926405414855a8c7$export$39e04e72f972b885(step) {
    return step === (0, $111916efe4142a03$export$e205886172277ec6) || step === (0, $111916efe4142a03$export$3a846c3d2fac10b8);
}
var $926405414855a8c7$export$2e2bcd8739ae039 = (status, prepareOnly, callback)=>{
    const [step, setStep] = (0, $8ad52953f3345b2f$export$2e2bcd8739ae039)((0, $111916efe4142a03$export$40b34dd77d5522bf));
    const [nextFrame, cancelNextFrame] = (0, $8fdf5d91bedb073a$export$2e2bcd8739ae039)();
    function startQueue() {
        setStep((0, $111916efe4142a03$export$1b792916a5fac4fc), true);
    }
    const STEP_QUEUE = prepareOnly ? $926405414855a8c7$var$SIMPLE_STEP_QUEUE : $926405414855a8c7$var$FULL_STEP_QUEUE;
    (0, $e04c1362dfd2d49d$export$2e2bcd8739ae039)(()=>{
        if (step !== (0, $111916efe4142a03$export$40b34dd77d5522bf) && step !== (0, $111916efe4142a03$export$3a846c3d2fac10b8)) {
            const index = STEP_QUEUE.indexOf(step);
            const nextStep = STEP_QUEUE[index + 1];
            const result = callback(step);
            if (result === $926405414855a8c7$export$c2029bf6cfdbc28a) // Skip when no needed
            setStep(nextStep, true);
            else if (nextStep) // Do as frame for step update
            nextFrame((info)=>{
                function doNext() {
                    // Skip since current queue is ood
                    if (info.isCanceled()) return;
                    setStep(nextStep, true);
                }
                if (result === true) doNext();
                else // Only promise should be async
                Promise.resolve(result).then(doNext);
            });
        }
    }, [
        status,
        step
    ]);
    $32rMB.useEffect(()=>()=>{
            cancelNextFrame();
        }, []);
    return [
        startQueue,
        step
    ];
};


function $eeef065c00ff8ff1$export$2e2bcd8739ae039(supportMotion, visible, getElement, { motionEnter: motionEnter = true, motionAppear: motionAppear = true, motionLeave: motionLeave = true, motionDeadline: motionDeadline, motionLeaveImmediately: motionLeaveImmediately, onAppearPrepare: onAppearPrepare, onEnterPrepare: onEnterPrepare, onLeavePrepare: onLeavePrepare, onAppearStart: onAppearStart, onEnterStart: onEnterStart, onLeaveStart: onLeaveStart, onAppearActive: onAppearActive, onEnterActive: onEnterActive, onLeaveActive: onLeaveActive, onAppearEnd: onAppearEnd, onEnterEnd: onEnterEnd, onLeaveEnd: onLeaveEnd, onVisibleChanged: onVisibleChanged }) {
    // Used for outer render usage to avoid `visible: false & status: none` to render nothing
    const [asyncVisible, setAsyncVisible] = (0, $8ad52953f3345b2f$export$2e2bcd8739ae039)();
    const [getStatus, setStatus] = (0, $15d1399ec9ddc111$export$2e2bcd8739ae039)((0, $111916efe4142a03$export$de71442bbf2143da));
    const [style, setStyle] = (0, $8ad52953f3345b2f$export$2e2bcd8739ae039)(null);
    const currentStatus = getStatus();
    const mountedRef = (0, $32rMB.useRef)(false);
    const deadlineRef = (0, $32rMB.useRef)(null);
    // =========================== Dom Node ===========================
    function getDomElement() {
        return getElement();
    }
    // ========================== Motion End ==========================
    const activeRef = (0, $32rMB.useRef)(false);
    /**
   * Clean up status & style
   */ function updateMotionEndStatus() {
        setStatus((0, $111916efe4142a03$export$de71442bbf2143da));
        setStyle(null, true);
    }
    const onInternalMotionEnd = (0, $ea93068db096b7d6$export$2e2bcd8739ae039)((event)=>{
        const status = getStatus();
        // Do nothing since not in any transition status.
        // This may happen when `motionDeadline` trigger.
        if (status === (0, $111916efe4142a03$export$de71442bbf2143da)) return;
        const element = getDomElement();
        if (event && !event.deadline && event.target !== element) // event exists
        // not initiated by deadline
        // transitionEnd not fired by inner elements
        return;
        const currentActive = activeRef.current;
        let canEnd;
        if (status === (0, $111916efe4142a03$export$4fc3521687bcacd2) && currentActive) canEnd = onAppearEnd?.(element, event);
        else if (status === (0, $111916efe4142a03$export$5d6af549241fe2e8) && currentActive) canEnd = onEnterEnd?.(element, event);
        else if (status === (0, $111916efe4142a03$export$59b1c493d29f68e4) && currentActive) canEnd = onLeaveEnd?.(element, event);
        // Only update status when `canEnd` and not destroyed
        if (currentActive && canEnd !== false) updateMotionEndStatus();
    });
    const [patchMotionEvents] = (0, $92eb9ca7af535db9$export$2e2bcd8739ae039)(onInternalMotionEnd);
    // ============================= Step =============================
    const getEventHandlers = (targetStatus)=>{
        switch(targetStatus){
            case 0, $111916efe4142a03$export$4fc3521687bcacd2:
                return {
                    [(0, $111916efe4142a03$export$1b792916a5fac4fc)]: onAppearPrepare,
                    [(0, $111916efe4142a03$export$9563153dd25a3ce8)]: onAppearStart,
                    [(0, $111916efe4142a03$export$e205886172277ec6)]: onAppearActive
                };
            case 0, $111916efe4142a03$export$5d6af549241fe2e8:
                return {
                    [(0, $111916efe4142a03$export$1b792916a5fac4fc)]: onEnterPrepare,
                    [(0, $111916efe4142a03$export$9563153dd25a3ce8)]: onEnterStart,
                    [(0, $111916efe4142a03$export$e205886172277ec6)]: onEnterActive
                };
            case 0, $111916efe4142a03$export$59b1c493d29f68e4:
                return {
                    [(0, $111916efe4142a03$export$1b792916a5fac4fc)]: onLeavePrepare,
                    [(0, $111916efe4142a03$export$9563153dd25a3ce8)]: onLeaveStart,
                    [(0, $111916efe4142a03$export$e205886172277ec6)]: onLeaveActive
                };
            default:
                return {};
        }
    };
    const eventHandlers = $32rMB.useMemo(()=>getEventHandlers(currentStatus), [
        currentStatus
    ]);
    const [startStep, step] = (0, $926405414855a8c7$export$2e2bcd8739ae039)(currentStatus, !supportMotion, (newStep)=>{
        // Only prepare step can be skip
        if (newStep === (0, $111916efe4142a03$export$1b792916a5fac4fc)) {
            const onPrepare = eventHandlers[0, $111916efe4142a03$export$1b792916a5fac4fc];
            if (!onPrepare) return 0, $926405414855a8c7$export$c2029bf6cfdbc28a;
            return onPrepare(getDomElement());
        }
        // Rest step is sync update
        if (step in eventHandlers) setStyle(eventHandlers[step]?.(getDomElement(), null) || null);
        if (step === (0, $111916efe4142a03$export$e205886172277ec6) && currentStatus !== (0, $111916efe4142a03$export$de71442bbf2143da)) {
            // Patch events when motion needed
            patchMotionEvents(getDomElement());
            if (motionDeadline > 0) {
                clearTimeout(deadlineRef.current);
                deadlineRef.current = setTimeout(()=>{
                    onInternalMotionEnd({
                        deadline: true
                    });
                }, motionDeadline);
            }
        }
        if (step === (0, $111916efe4142a03$export$98351fa4e6b4f204)) updateMotionEndStatus();
        return 0, $926405414855a8c7$export$dbee1e282e8c4830;
    });
    const active = (0, $926405414855a8c7$export$39e04e72f972b885)(step);
    activeRef.current = active;
    // ============================ Status ============================
    const visibleRef = (0, $32rMB.useRef)(null);
    // Update with new status
    (0, $e04c1362dfd2d49d$export$2e2bcd8739ae039)(()=>{
        // When use Suspense, the `visible` will repeat trigger,
        // But not real change of the `visible`, we need to skip it.
        // https://github.com/ant-design/ant-design/issues/44379
        if (mountedRef.current && visibleRef.current === visible) return;
        setAsyncVisible(visible);
        const isMounted = mountedRef.current;
        mountedRef.current = true;
        // if (!supportMotion) {
        //   return;
        // }
        let nextStatus;
        // Appear
        if (!isMounted && visible && motionAppear) nextStatus = (0, $111916efe4142a03$export$4fc3521687bcacd2);
        // Enter
        if (isMounted && visible && motionEnter) nextStatus = (0, $111916efe4142a03$export$5d6af549241fe2e8);
        // Leave
        if (isMounted && !visible && motionLeave || !isMounted && motionLeaveImmediately && !visible && motionLeave) nextStatus = (0, $111916efe4142a03$export$59b1c493d29f68e4);
        const nextEventHandlers = getEventHandlers(nextStatus);
        // Update to next status
        if (nextStatus && (supportMotion || nextEventHandlers[0, $111916efe4142a03$export$1b792916a5fac4fc])) {
            setStatus(nextStatus);
            startStep();
        } else // Set back in case no motion but prev status has prepare step
        setStatus((0, $111916efe4142a03$export$de71442bbf2143da));
        visibleRef.current = visible;
    }, [
        visible
    ]);
    // ============================ Effect ============================
    // Reset when motion changed
    (0, $32rMB.useEffect)(()=>{
        if (// Cancel appear
        currentStatus === (0, $111916efe4142a03$export$4fc3521687bcacd2) && !motionAppear || // Cancel enter
        currentStatus === (0, $111916efe4142a03$export$5d6af549241fe2e8) && !motionEnter || // Cancel leave
        currentStatus === (0, $111916efe4142a03$export$59b1c493d29f68e4) && !motionLeave) setStatus((0, $111916efe4142a03$export$de71442bbf2143da));
    }, [
        motionAppear,
        motionEnter,
        motionLeave
    ]);
    (0, $32rMB.useEffect)(()=>()=>{
            mountedRef.current = false;
            clearTimeout(deadlineRef.current);
        }, []);
    // Trigger `onVisibleChanged`
    const firstMountChangeRef = $32rMB.useRef(false);
    (0, $32rMB.useEffect)(()=>{
        // [visible & motion not end] => [!visible & motion end] still need trigger onVisibleChanged
        if (asyncVisible) firstMountChangeRef.current = true;
        if (asyncVisible !== undefined && currentStatus === (0, $111916efe4142a03$export$de71442bbf2143da)) {
            // Skip first render is invisible since it's nothing changed
            if (firstMountChangeRef.current || asyncVisible) onVisibleChanged?.(asyncVisible);
            firstMountChangeRef.current = true;
        }
    }, [
        asyncVisible,
        currentStatus
    ]);
    // ============================ Styles ============================
    let mergedStyle = style;
    if (eventHandlers[0, $111916efe4142a03$export$1b792916a5fac4fc] && step === (0, $111916efe4142a03$export$9563153dd25a3ce8)) mergedStyle = {
        transition: 'none',
        ...mergedStyle
    };
    return [
        getStatus,
        step,
        mergedStyle,
        asyncVisible ?? visible
    ];
}





function $608da09bec75129a$export$e265d52a86a9f199(config) {
    let transitionSupport = config;
    if (typeof config === 'object') ({ transitionSupport: transitionSupport } = config);
    function isSupportTransition(props, contextMotion) {
        return !!(props.motionName && transitionSupport && contextMotion !== false);
    }
    const CSSMotion = /*#__PURE__*/ $N3oW3.forwardRef((props, ref)=>{
        const { visible: // Default config
        visible = true, removeOnLeave: removeOnLeave = true, forceRender: forceRender, children: children, motionName: motionName, leavedClassName: leavedClassName, eventProps: eventProps } = props;
        const { motion: contextMotion } = $32rMB.useContext((0, $d83990e2d9a86041$export$841858b892ce1f4c));
        const supportMotion = isSupportTransition(props, contextMotion);
        // Ref to the react node, it may be a HTMLElement
        const nodeRef = (0, $32rMB.useRef)();
        function getDomElement() {
            return (0, $c1d2a04d2d287797$export$9aa546fdc20ae5b3)(nodeRef.current);
        }
        const [getStatus, statusStep, statusStyle, mergedVisible] = (0, $eeef065c00ff8ff1$export$2e2bcd8739ae039)(supportMotion, visible, getDomElement, props);
        const status = getStatus();
        // Record whether content has rendered
        // Will return null for un-rendered even when `removeOnLeave={false}`
        const renderedRef = $32rMB.useRef(mergedVisible);
        if (mergedVisible) renderedRef.current = true;
        // ====================== Refs ======================
        const refObj = $32rMB.useMemo(()=>{
            const obj = {};
            Object.defineProperties(obj, {
                nativeElement: {
                    enumerable: true,
                    get: getDomElement
                },
                inMotion: {
                    enumerable: true,
                    get: ()=>()=>getStatus() !== (0, $111916efe4142a03$export$de71442bbf2143da)
                },
                enableMotion: {
                    enumerable: true,
                    get: ()=>()=>supportMotion
                }
            });
            return obj;
        }, []);
        // We lock `deps` here since function return object
        // will repeat trigger ref from `refConfig` -> `null` -> `refConfig`
        $32rMB.useImperativeHandle(ref, ()=>refObj, []);
        // ===================== Render =====================
        let motionChildren;
        const mergedProps = {
            ...eventProps,
            visible: visible
        };
        if (!children) // No children
        motionChildren = null;
        else if (status === (0, $111916efe4142a03$export$de71442bbf2143da)) {
            // Stable children
            if (mergedVisible) motionChildren = children({
                ...mergedProps
            }, nodeRef);
            else if (!removeOnLeave && renderedRef.current && leavedClassName) motionChildren = children({
                ...mergedProps,
                className: leavedClassName
            }, nodeRef);
            else if (forceRender || !removeOnLeave && !leavedClassName) motionChildren = children({
                ...mergedProps,
                style: {
                    display: 'none'
                }
            }, nodeRef);
            else motionChildren = null;
        } else {
            // In motion
            let statusSuffix;
            if (statusStep === (0, $111916efe4142a03$export$1b792916a5fac4fc)) statusSuffix = 'prepare';
            else if ((0, $926405414855a8c7$export$39e04e72f972b885)(statusStep)) statusSuffix = 'active';
            else if (statusStep === (0, $111916efe4142a03$export$9563153dd25a3ce8)) statusSuffix = 'start';
            const motionCls = (0, $cde841a66656db50$export$27c72201b1d09951)(motionName, `${status}-${statusSuffix}`);
            motionChildren = children({
                ...mergedProps,
                className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)((0, $cde841a66656db50$export$27c72201b1d09951)(motionName, status), {
                    [motionCls]: motionCls && statusSuffix,
                    [motionName]: typeof motionName === 'string'
                }),
                style: statusStyle
            }, nodeRef);
        }
        // Auto inject ref if child node not have `ref` props
        if (/*#__PURE__*/ $N3oW3.isValidElement(motionChildren) && (0, $2706ed817e87019d$export$c1cec34af06bcf7)(motionChildren)) {
            const originNodeRef = (0, $2706ed817e87019d$export$7465e5c0bf44f19a)(motionChildren);
            if (!originNodeRef) motionChildren = /*#__PURE__*/ $N3oW3.cloneElement(motionChildren, {
                ref: nodeRef
            });
        }
        return motionChildren;
    });
    CSSMotion.displayName = 'CSSMotion';
    return CSSMotion;
}
var $608da09bec75129a$export$2e2bcd8739ae039 = $608da09bec75129a$export$e265d52a86a9f199((0, $cde841a66656db50$export$d28133ed3ad06c8b));


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");

const $666a3047672c2d71$export$3904baa009bc026e = 'add';
const $666a3047672c2d71$export$851162f0adad2cbc = 'keep';
const $666a3047672c2d71$export$c8b3fb08b68cfc85 = 'remove';
const $666a3047672c2d71$export$2ac1bd1808d2e43a = 'removed';
function $666a3047672c2d71$export$c47fd798e598c85c(key) {
    let keyObj;
    if (key && typeof key === 'object' && 'key' in key) keyObj = key;
    else keyObj = {
        key: key
    };
    return {
        ...keyObj,
        key: String(keyObj.key)
    };
}
function $666a3047672c2d71$export$84bd7bd42ccc0f72(keys = []) {
    return keys.map($666a3047672c2d71$export$c47fd798e598c85c);
}
function $666a3047672c2d71$export$14527669107aa301(prevKeys = [], currentKeys = []) {
    let list = [];
    let currentIndex = 0;
    const currentLen = currentKeys.length;
    const prevKeyObjects = $666a3047672c2d71$export$84bd7bd42ccc0f72(prevKeys);
    const currentKeyObjects = $666a3047672c2d71$export$84bd7bd42ccc0f72(currentKeys);
    // Check prev keys to insert or keep
    prevKeyObjects.forEach((keyObj)=>{
        let hit = false;
        for(let i = currentIndex; i < currentLen; i += 1){
            const currentKeyObj = currentKeyObjects[i];
            if (currentKeyObj.key === keyObj.key) {
                // New added keys should add before current key
                if (currentIndex < i) {
                    list = list.concat(currentKeyObjects.slice(currentIndex, i).map((obj)=>({
                            ...obj,
                            status: $666a3047672c2d71$export$3904baa009bc026e
                        })));
                    currentIndex = i;
                }
                list.push({
                    ...currentKeyObj,
                    status: $666a3047672c2d71$export$851162f0adad2cbc
                });
                currentIndex += 1;
                hit = true;
                break;
            }
        }
        // If not hit, it means key is removed
        if (!hit) list.push({
            ...keyObj,
            status: $666a3047672c2d71$export$c8b3fb08b68cfc85
        });
    });
    // Add rest to the list
    if (currentIndex < currentLen) list = list.concat(currentKeyObjects.slice(currentIndex).map((obj)=>({
            ...obj,
            status: $666a3047672c2d71$export$3904baa009bc026e
        })));
    /**
   * Merge same key when it remove and add again:
   *    [1 - add, 2 - keep, 1 - remove] -> [1 - keep, 2 - keep]
   */ const keys = {};
    list.forEach(({ key: key })=>{
        keys[key] = (keys[key] || 0) + 1;
    });
    const duplicatedKeys = Object.keys(keys).filter((key)=>keys[key] > 1);
    duplicatedKeys.forEach((matchKey)=>{
        // Remove `STATUS_REMOVE` node.
        list = list.filter(({ key: key, status: status })=>key !== matchKey || status !== $666a3047672c2d71$export$c8b3fb08b68cfc85);
        // Update `STATUS_ADD` to `STATUS_KEEP`
        list.forEach((node)=>{
            if (node.key === matchKey) // eslint-disable-next-line no-param-reassign
            node.status = $666a3047672c2d71$export$851162f0adad2cbc;
        });
    });
    return list;
}



function $24d87673fe580a7b$var$_extends() {
    $24d87673fe580a7b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $24d87673fe580a7b$var$_extends.apply(this, arguments);
}
const $24d87673fe580a7b$var$MOTION_PROP_NAMES = [
    'eventProps',
    'visible',
    'children',
    'motionName',
    'motionAppear',
    'motionEnter',
    'motionLeave',
    'motionLeaveImmediately',
    'motionDeadline',
    'removeOnLeave',
    'leavedClassName',
    'onAppearPrepare',
    'onAppearStart',
    'onAppearActive',
    'onAppearEnd',
    'onEnterStart',
    'onEnterActive',
    'onEnterEnd',
    'onLeaveStart',
    'onLeaveActive',
    'onLeaveEnd'
];
function $24d87673fe580a7b$export$fcfc62c1d33d5e2e(transitionSupport, CSSMotion = (0, $608da09bec75129a$export$2e2bcd8739ae039)) {
    class CSSMotionList extends $hO8yS.Component {
        static defaultProps = {
            component: 'div'
        };
        state = {
            keyEntities: []
        };
        static getDerivedStateFromProps({ keys: keys }, { keyEntities: keyEntities }) {
            const parsedKeyObjects = (0, $666a3047672c2d71$export$84bd7bd42ccc0f72)(keys);
            const mixedKeyEntities = (0, $666a3047672c2d71$export$14527669107aa301)(keyEntities, parsedKeyObjects);
            return {
                keyEntities: mixedKeyEntities.filter((entity)=>{
                    const prevEntity = keyEntities.find(({ key: key })=>entity.key === key);
                    // Remove if already mark as removed
                    if (prevEntity && prevEntity.status === (0, $666a3047672c2d71$export$2ac1bd1808d2e43a) && entity.status === (0, $666a3047672c2d71$export$c8b3fb08b68cfc85)) return false;
                    return true;
                })
            };
        }
        // ZombieJ: Return the count of rest keys. It's safe to refactor if need more info.
        removeKey = (removeKey)=>{
            this.setState((prevState)=>{
                const nextKeyEntities = prevState.keyEntities.map((entity)=>{
                    if (entity.key !== removeKey) return entity;
                    return {
                        ...entity,
                        status: (0, $666a3047672c2d71$export$2ac1bd1808d2e43a)
                    };
                });
                return {
                    keyEntities: nextKeyEntities
                };
            }, ()=>{
                const { keyEntities: keyEntities } = this.state;
                const restKeysCount = keyEntities.filter(({ status: status })=>status !== (0, $666a3047672c2d71$export$2ac1bd1808d2e43a)).length;
                if (restKeysCount === 0 && this.props.onAllRemoved) this.props.onAllRemoved();
            });
        };
        render() {
            const { keyEntities: keyEntities } = this.state;
            const { component: component, children: children, onVisibleChanged: onVisibleChanged, onAllRemoved: onAllRemoved, ...restProps } = this.props;
            const Component = component || $hO8yS.Fragment;
            const motionProps = {};
            $24d87673fe580a7b$var$MOTION_PROP_NAMES.forEach((prop)=>{
                motionProps[prop] = restProps[prop];
                delete restProps[prop];
            });
            delete restProps.keys;
            return /*#__PURE__*/ $hO8yS.createElement(Component, restProps, keyEntities.map(({ status: status, ...eventProps }, index)=>{
                const visible = status === (0, $666a3047672c2d71$export$3904baa009bc026e) || status === (0, $666a3047672c2d71$export$851162f0adad2cbc);
                return /*#__PURE__*/ $hO8yS.createElement(CSSMotion, $24d87673fe580a7b$var$_extends({}, motionProps, {
                    key: eventProps.key,
                    visible: visible,
                    eventProps: eventProps,
                    onVisibleChanged: (changedVisible)=>{
                        onVisibleChanged?.(changedVisible, {
                            key: eventProps.key
                        });
                        if (!changedVisible) this.removeKey(eventProps.key);
                    }
                }), (props, ref)=>children({
                        ...props,
                        index: index
                    }, ref));
            }));
        }
    }
    return CSSMotionList;
}
var $24d87673fe580a7b$export$2e2bcd8739ae039 = $24d87673fe580a7b$export$fcfc62c1d33d5e2e((0, $cde841a66656db50$export$d28133ed3ad06c8b));



var $db80a026d0a86ece$export$2e2bcd8739ae039 = (0, $608da09bec75129a$export$2e2bcd8739ae039);





parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");

parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");
function $5c7859697e3c2c1c$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, align: align, arrow: arrow, arrowPos: arrowPos } = props;
    const { className: className, content: content, style: style } = arrow || {};
    const { x: x = 0, y: y = 0 } = arrowPos;
    const arrowRef = $32rMB.useRef(null);
    // Skip if no align
    if (!align || !align.points) return null;
    const alignStyle = {
        position: 'absolute'
    };
    // Skip if no need to align
    if (align.autoArrow !== false) {
        const popupPoints = align.points[0];
        const targetPoints = align.points[1];
        const popupTB = popupPoints[0];
        const popupLR = popupPoints[1];
        const targetTB = targetPoints[0];
        const targetLR = targetPoints[1];
        // Top & Bottom
        if (popupTB === targetTB || ![
            't',
            'b'
        ].includes(popupTB)) alignStyle.top = y;
        else if (popupTB === 't') alignStyle.top = 0;
        else alignStyle.bottom = 0;
        // Left & Right
        if (popupLR === targetLR || ![
            'l',
            'r'
        ].includes(popupLR)) alignStyle.left = x;
        else if (popupLR === 'l') alignStyle.left = 0;
        else alignStyle.right = 0;
    }
    return /*#__PURE__*/ $hO8yS.createElement("div", {
        ref: arrowRef,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-arrow`, className),
        style: {
            ...alignStyle,
            ...style
        }
    }, content);
}




parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
function $6e6e2153bb4351ca$var$_extends() {
    $6e6e2153bb4351ca$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6e6e2153bb4351ca$var$_extends.apply(this, arguments);
}
function $6e6e2153bb4351ca$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, open: open, zIndex: zIndex, mask: mask, motion: motion, mobile: mobile } = props;
    if (!mask) return null;
    return /*#__PURE__*/ $hO8yS.createElement((0, $db80a026d0a86ece$export$2e2bcd8739ae039), $6e6e2153bb4351ca$var$_extends({}, motion, {
        motionAppear: true,
        visible: open,
        removeOnLeave: true
    }), ({ className: className })=>/*#__PURE__*/ $hO8yS.createElement("div", {
            style: {
                zIndex: zIndex
            },
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-mask`, mobile && `${prefixCls}-mobile-mask`, className)
        }));
}



var $N3oW3 = parcelRequire("N3oW3");
const $d355ac37784dac08$var$PopupContent = /*#__PURE__*/ $N3oW3.memo(({ children: children })=>children, (_, next)=>next.cache);
var $d355ac37784dac08$export$2e2bcd8739ae039 = $d355ac37784dac08$var$PopupContent;


function $8e53a1caa8075717$export$2e2bcd8739ae039(isMobile, ready, open, align, offsetR, offsetB, offsetX, offsetY) {
    // >>>>> Offset
    const AUTO = 'auto';
    const offsetStyle = isMobile ? {} : {
        left: '-1000vw',
        top: '-1000vh',
        right: AUTO,
        bottom: AUTO
    };
    // Set align style
    if (!isMobile && (ready || !open)) {
        const { points: points } = align;
        const dynamicInset = align.dynamicInset || align._experimental?.dynamicInset;
        const alignRight = dynamicInset && points[0][1] === 'r';
        const alignBottom = dynamicInset && points[0][0] === 'b';
        if (alignRight) {
            offsetStyle.right = offsetR;
            offsetStyle.left = AUTO;
        } else {
            offsetStyle.left = offsetX;
            offsetStyle.right = AUTO;
        }
        if (alignBottom) {
            offsetStyle.bottom = offsetB;
            offsetStyle.top = AUTO;
        } else {
            offsetStyle.top = offsetY;
            offsetStyle.bottom = AUTO;
        }
    }
    return offsetStyle;
}



function $976d12e4ff9bb99e$var$_extends() {
    $976d12e4ff9bb99e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $976d12e4ff9bb99e$var$_extends.apply(this, arguments);
}
const $976d12e4ff9bb99e$var$Popup = /*#__PURE__*/ $N3oW3.forwardRef((props, ref)=>{
    const { popup: popup, className: className, prefixCls: prefixCls, style: style, target: target, onVisibleChanged: onVisibleChanged, open: // Open
    open, keepDom: keepDom, fresh: fresh, onClick: // Click
    onClick, mask: // Mask
    mask, arrow: // Arrow
    arrow, arrowPos: arrowPos, align: align, motion: // Motion
    motion, maskMotion: maskMotion, mobile: // Mobile
    mobile, forceRender: // Portal
    forceRender, getPopupContainer: getPopupContainer, autoDestroy: autoDestroy, portal: Portal, children: children, zIndex: zIndex, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onPointerEnter: onPointerEnter, onPointerDownCapture: onPointerDownCapture, ready: ready, offsetX: offsetX, offsetY: offsetY, offsetR: offsetR, offsetB: offsetB, onAlign: onAlign, onPrepare: onPrepare, onResize: // Resize
    onResize, stretch: stretch, targetWidth: targetWidth, targetHeight: targetHeight } = props;
    const popupContent = typeof popup === 'function' ? popup() : popup;
    // We can not remove holder only when motion finished.
    const isNodeVisible = open || keepDom;
    // ========================= Mobile =========================
    const isMobile = !!mobile;
    // ========================== Mask ==========================
    const [mergedMask, mergedMaskMotion, mergedPopupMotion] = $32rMB.useMemo(()=>{
        if (mobile) return [
            mobile.mask,
            mobile.maskMotion,
            mobile.motion
        ];
        return [
            mask,
            maskMotion,
            motion
        ];
    }, [
        mobile,
        mask,
        maskMotion,
        motion
    ]);
    // ======================= Container ========================
    const getPopupContainerNeedParams = getPopupContainer?.length > 0;
    const [show, setShow] = $32rMB.useState(!getPopupContainer || !getPopupContainerNeedParams);
    // Delay to show since `getPopupContainer` need target element
    (0, $60cea2402df671e7$export$2e2bcd8739ae039)(()=>{
        if (!show && getPopupContainerNeedParams && target) setShow(true);
    }, [
        show,
        getPopupContainerNeedParams,
        target
    ]);
    // ========================= Resize =========================
    const onInternalResize = (0, $ea93068db096b7d6$export$2e2bcd8739ae039)((size, ele)=>{
        onResize?.(size, ele);
        onAlign();
    });
    // ========================= Styles =========================
    const offsetStyle = (0, $8e53a1caa8075717$export$2e2bcd8739ae039)(isMobile, ready, open, align, offsetR, offsetB, offsetX, offsetY);
    // ========================= Render =========================
    if (!show) return null;
    // >>>>> Misc
    const miscStyle = {};
    if (stretch) {
        if (stretch.includes('height') && targetHeight) miscStyle.height = targetHeight;
        else if (stretch.includes('minHeight') && targetHeight) miscStyle.minHeight = targetHeight;
        if (stretch.includes('width') && targetWidth) miscStyle.width = targetWidth;
        else if (stretch.includes('minWidth') && targetWidth) miscStyle.minWidth = targetWidth;
    }
    if (!open) miscStyle.pointerEvents = 'none';
    return /*#__PURE__*/ $hO8yS.createElement(Portal, {
        open: forceRender || isNodeVisible,
        getContainer: getPopupContainer && (()=>getPopupContainer(target)),
        autoDestroy: autoDestroy
    }, /*#__PURE__*/ $hO8yS.createElement((0, $6e6e2153bb4351ca$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        open: open,
        zIndex: zIndex,
        mask: mergedMask,
        motion: mergedMaskMotion,
        mobile: isMobile
    }), /*#__PURE__*/ $hO8yS.createElement((0, $b8d12c084d14878d$export$2e2bcd8739ae039), {
        onResize: onInternalResize,
        disabled: !open
    }, (resizeObserverRef)=>{
        return /*#__PURE__*/ $hO8yS.createElement((0, $db80a026d0a86ece$export$2e2bcd8739ae039), $976d12e4ff9bb99e$var$_extends({
            motionAppear: true,
            motionEnter: true,
            motionLeave: true,
            removeOnLeave: false,
            forceRender: forceRender,
            leavedClassName: `${prefixCls}-hidden`
        }, mergedPopupMotion, {
            onAppearPrepare: onPrepare,
            onEnterPrepare: onPrepare,
            visible: open,
            onVisibleChanged: (nextVisible)=>{
                motion?.onVisibleChanged?.(nextVisible);
                onVisibleChanged(nextVisible);
            }
        }), ({ className: motionClassName, style: motionStyle }, motionRef)=>{
            const cls = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, motionClassName, className, {
                [`${prefixCls}-mobile`]: isMobile
            });
            return /*#__PURE__*/ $hO8yS.createElement("div", {
                ref: (0, $2706ed817e87019d$export$ab452c34e8e05029)(resizeObserverRef, ref, motionRef),
                className: cls,
                style: {
                    '--arrow-x': `${arrowPos.x || 0}px`,
                    '--arrow-y': `${arrowPos.y || 0}px`,
                    ...offsetStyle,
                    ...miscStyle,
                    ...motionStyle,
                    boxSizing: 'border-box',
                    zIndex: zIndex,
                    ...style
                },
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                onPointerEnter: onPointerEnter,
                onClick: onClick,
                onPointerDownCapture: onPointerDownCapture
            }, arrow && /*#__PURE__*/ $hO8yS.createElement((0, $5c7859697e3c2c1c$export$2e2bcd8739ae039), {
                prefixCls: prefixCls,
                arrow: arrow,
                arrowPos: arrowPos,
                align: align
            }), /*#__PURE__*/ $hO8yS.createElement((0, $d355ac37784dac08$export$2e2bcd8739ae039), {
                cache: !open && !fresh
            }, popupContent));
        });
    }), children);
});
var $976d12e4ff9bb99e$export$2e2bcd8739ae039 = $976d12e4ff9bb99e$var$Popup;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
// ===================== Nest =====================
const $bf8d09429a780634$var$TriggerContext = /*#__PURE__*/ $hO8yS.createContext(null);
var $bf8d09429a780634$export$2e2bcd8739ae039 = $bf8d09429a780634$var$TriggerContext;
const $bf8d09429a780634$export$14cc6d12cdc906c = /*#__PURE__*/ $hO8yS.createContext(null);


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
function $08d878b8ecde4208$var$toArray(val) {
    return val ? Array.isArray(val) ? val : [
        val
    ] : [];
}
function $08d878b8ecde4208$export$2e2bcd8739ae039(action, showAction, hideAction) {
    return $32rMB.useMemo(()=>{
        const mergedShowAction = $08d878b8ecde4208$var$toArray(showAction ?? action);
        const mergedHideAction = $08d878b8ecde4208$var$toArray(hideAction ?? action);
        const showActionSet = new Set(mergedShowAction);
        const hideActionSet = new Set(mergedHideAction);
        if (showActionSet.has('hover') && !showActionSet.has('click')) showActionSet.add('touch');
        if (hideActionSet.has('hover') && !hideActionSet.has('click')) hideActionSet.add('touch');
        return [
            showActionSet,
            hideActionSet
        ];
    }, [
        action,
        showAction,
        hideAction
    ]);
}



var $218f20156c5f8705$export$2e2bcd8739ae039 = (element)=>{
    if (!element) return false;
    if (element instanceof Element) {
        if (element.offsetParent) return true;
        if (element.getBBox) {
            const { width: width, height: height } = element.getBBox();
            if (width || height) return true;
        }
        if (element.getBoundingClientRect) {
            const { width: width, height: height } = element.getBoundingClientRect();
            if (width || height) return true;
        }
    }
    return false;
};




parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
function $e1e5475fabaf4baf$var$isPointsEq(a1 = [], a2 = [], isAlignPoint) {
    if (isAlignPoint) return a1[0] === a2[0];
    return a1[0] === a2[0] && a1[1] === a2[1];
}
function $e1e5475fabaf4baf$export$faa0aa8ed2fe6432(builtinPlacements, prefixCls, align, isAlignPoint) {
    const { points: points } = align;
    const placements = Object.keys(builtinPlacements);
    for(let i = 0; i < placements.length; i += 1){
        const placement = placements[i];
        if ($e1e5475fabaf4baf$var$isPointsEq(builtinPlacements[placement]?.points, points, isAlignPoint)) return `${prefixCls}-placement-${placement}`;
    }
    return '';
}
function $e1e5475fabaf4baf$export$9c0584a7cc24d9e(ele) {
    return ele.ownerDocument.defaultView;
}
function $e1e5475fabaf4baf$export$ba21ed9400ca485b(ele) {
    const scrollerList = [];
    let current = ele?.parentElement;
    const scrollStyle = [
        'hidden',
        'scroll',
        'clip',
        'auto'
    ];
    while(current){
        const { overflowX: overflowX, overflowY: overflowY, overflow: overflow } = $e1e5475fabaf4baf$export$9c0584a7cc24d9e(current).getComputedStyle(current);
        if ([
            overflowX,
            overflowY,
            overflow
        ].some((o)=>scrollStyle.includes(o))) scrollerList.push(current);
        current = current.parentElement;
    }
    return scrollerList;
}
function $e1e5475fabaf4baf$export$34dfc8f73bbb64ae(num, defaultValue = 1) {
    return Number.isNaN(num) ? defaultValue : num;
}
function $e1e5475fabaf4baf$var$getPxValue(val) {
    return $e1e5475fabaf4baf$export$34dfc8f73bbb64ae(parseFloat(val), 0);
}
function $e1e5475fabaf4baf$export$94be9d7985092f2d(initArea, scrollerList) {
    const visibleArea = {
        ...initArea
    };
    (scrollerList || []).forEach((ele)=>{
        if (ele instanceof HTMLBodyElement || ele instanceof HTMLHtmlElement) return;
        // Skip if static position which will not affect visible area
        const { overflow: overflow, overflowClipMargin: overflowClipMargin, borderTopWidth: borderTopWidth, borderBottomWidth: borderBottomWidth, borderLeftWidth: borderLeftWidth, borderRightWidth: borderRightWidth } = $e1e5475fabaf4baf$export$9c0584a7cc24d9e(ele).getComputedStyle(ele);
        const eleRect = ele.getBoundingClientRect();
        const { offsetHeight: eleOutHeight, clientHeight: eleInnerHeight, offsetWidth: eleOutWidth, clientWidth: eleInnerWidth } = ele;
        const borderTopNum = $e1e5475fabaf4baf$var$getPxValue(borderTopWidth);
        const borderBottomNum = $e1e5475fabaf4baf$var$getPxValue(borderBottomWidth);
        const borderLeftNum = $e1e5475fabaf4baf$var$getPxValue(borderLeftWidth);
        const borderRightNum = $e1e5475fabaf4baf$var$getPxValue(borderRightWidth);
        const scaleX = $e1e5475fabaf4baf$export$34dfc8f73bbb64ae(Math.round(eleRect.width / eleOutWidth * 1000) / 1000);
        const scaleY = $e1e5475fabaf4baf$export$34dfc8f73bbb64ae(Math.round(eleRect.height / eleOutHeight * 1000) / 1000);
        // Original visible area
        const eleScrollWidth = (eleOutWidth - eleInnerWidth - borderLeftNum - borderRightNum) * scaleX;
        const eleScrollHeight = (eleOutHeight - eleInnerHeight - borderTopNum - borderBottomNum) * scaleY;
        // Cut border size
        const scaledBorderTopWidth = borderTopNum * scaleY;
        const scaledBorderBottomWidth = borderBottomNum * scaleY;
        const scaledBorderLeftWidth = borderLeftNum * scaleX;
        const scaledBorderRightWidth = borderRightNum * scaleX;
        // Clip margin
        let clipMarginWidth = 0;
        let clipMarginHeight = 0;
        if (overflow === 'clip') {
            const clipNum = $e1e5475fabaf4baf$var$getPxValue(overflowClipMargin);
            clipMarginWidth = clipNum * scaleX;
            clipMarginHeight = clipNum * scaleY;
        }
        // Region
        const eleLeft = eleRect.x + scaledBorderLeftWidth - clipMarginWidth;
        const eleTop = eleRect.y + scaledBorderTopWidth - clipMarginHeight;
        const eleRight = eleLeft + eleRect.width + 2 * clipMarginWidth - scaledBorderLeftWidth - scaledBorderRightWidth - eleScrollWidth;
        const eleBottom = eleTop + eleRect.height + 2 * clipMarginHeight - scaledBorderTopWidth - scaledBorderBottomWidth - eleScrollHeight;
        visibleArea.left = Math.max(visibleArea.left, eleLeft);
        visibleArea.top = Math.max(visibleArea.top, eleTop);
        visibleArea.right = Math.min(visibleArea.right, eleRight);
        visibleArea.bottom = Math.min(visibleArea.bottom, eleBottom);
    });
    return visibleArea;
}


function $e4f1208709f6c2f8$var$getUnitOffset(size, offset = 0) {
    const offsetStr = `${offset}`;
    const cells = offsetStr.match(/^(.*)\%$/);
    if (cells) return size * (parseFloat(cells[1]) / 100);
    return parseFloat(offsetStr);
}
function $e4f1208709f6c2f8$var$getNumberOffset(rect, offset) {
    const [offsetX, offsetY] = offset || [];
    return [
        $e4f1208709f6c2f8$var$getUnitOffset(rect.width, offsetX),
        $e4f1208709f6c2f8$var$getUnitOffset(rect.height, offsetY)
    ];
}
function $e4f1208709f6c2f8$var$splitPoints(points = '') {
    return [
        points[0],
        points[1]
    ];
}
function $e4f1208709f6c2f8$var$getAlignPoint(rect, points) {
    const topBottom = points[0];
    const leftRight = points[1];
    let x;
    let y;
    // Top & Bottom
    if (topBottom === 't') y = rect.y;
    else if (topBottom === 'b') y = rect.y + rect.height;
    else y = rect.y + rect.height / 2;
    // Left & Right
    if (leftRight === 'l') x = rect.x;
    else if (leftRight === 'r') x = rect.x + rect.width;
    else x = rect.x + rect.width / 2;
    return {
        x: x,
        y: y
    };
}
function $e4f1208709f6c2f8$var$reversePoints(points, index) {
    const reverseMap = {
        t: 'b',
        b: 't',
        l: 'r',
        r: 'l'
    };
    return points.map((point, i)=>{
        if (i === index) return reverseMap[point] || 'c';
        return point;
    }).join('');
}
function $e4f1208709f6c2f8$export$2e2bcd8739ae039(open, popupEle, target, placement, builtinPlacements, popupAlign, onPopupAlign, mobile) {
    const [offsetInfo, setOffsetInfo] = $32rMB.useState({
        ready: false,
        offsetX: 0,
        offsetY: 0,
        offsetR: 0,
        offsetB: 0,
        arrowX: 0,
        arrowY: 0,
        scaleX: 1,
        scaleY: 1,
        align: builtinPlacements[placement] || {}
    });
    const alignCountRef = $32rMB.useRef(0);
    const scrollerList = $32rMB.useMemo(()=>{
        if (!popupEle || mobile) return [];
        return (0, $e1e5475fabaf4baf$export$ba21ed9400ca485b)(popupEle);
    }, [
        popupEle
    ]);
    // ========================= Flip ==========================
    // We will memo flip info.
    // If size change to make flip, it will memo the flip info and use it in next align.
    const prevFlipRef = $32rMB.useRef({});
    const resetFlipCache = ()=>{
        prevFlipRef.current = {};
    };
    if (!open) resetFlipCache();
    // ========================= Align =========================
    const onAlign = (0, $ea93068db096b7d6$export$2e2bcd8739ae039)(()=>{
        if (popupEle && target && open && !mobile) {
            const popupElement = popupEle;
            const doc = popupElement.ownerDocument;
            const win = (0, $e1e5475fabaf4baf$export$9c0584a7cc24d9e)(popupElement);
            const { position: popupPosition } = win.getComputedStyle(popupElement);
            const originLeft = popupElement.style.left;
            const originTop = popupElement.style.top;
            const originRight = popupElement.style.right;
            const originBottom = popupElement.style.bottom;
            const originOverflow = popupElement.style.overflow;
            // Placement
            const placementInfo = {
                ...builtinPlacements[placement],
                ...popupAlign
            };
            // placeholder element
            const placeholderElement = doc.createElement('div');
            popupElement.parentElement?.appendChild(placeholderElement);
            placeholderElement.style.left = `${popupElement.offsetLeft}px`;
            placeholderElement.style.top = `${popupElement.offsetTop}px`;
            placeholderElement.style.position = popupPosition;
            placeholderElement.style.height = `${popupElement.offsetHeight}px`;
            placeholderElement.style.width = `${popupElement.offsetWidth}px`;
            // Reset first
            popupElement.style.left = '0';
            popupElement.style.top = '0';
            popupElement.style.right = 'auto';
            popupElement.style.bottom = 'auto';
            popupElement.style.overflow = 'hidden';
            // Calculate align style, we should consider `transform` case
            let targetRect;
            if (Array.isArray(target)) targetRect = {
                x: target[0],
                y: target[1],
                width: 0,
                height: 0
            };
            else {
                const rect = target.getBoundingClientRect();
                rect.x = rect.x ?? rect.left;
                rect.y = rect.y ?? rect.top;
                targetRect = {
                    x: rect.x,
                    y: rect.y,
                    width: rect.width,
                    height: rect.height
                };
            }
            const popupRect = popupElement.getBoundingClientRect();
            const { height: height, width: width } = win.getComputedStyle(popupElement);
            popupRect.x = popupRect.x ?? popupRect.left;
            popupRect.y = popupRect.y ?? popupRect.top;
            const { clientWidth: clientWidth, clientHeight: clientHeight, scrollWidth: scrollWidth, scrollHeight: scrollHeight, scrollTop: scrollTop, scrollLeft: scrollLeft } = doc.documentElement;
            const popupHeight = popupRect.height;
            const popupWidth = popupRect.width;
            const targetHeight = targetRect.height;
            const targetWidth = targetRect.width;
            // Get bounding of visible area
            const visibleRegion = {
                left: 0,
                top: 0,
                right: clientWidth,
                bottom: clientHeight
            };
            const scrollRegion = {
                left: -scrollLeft,
                top: -scrollTop,
                right: scrollWidth - scrollLeft,
                bottom: scrollHeight - scrollTop
            };
            let { htmlRegion: htmlRegion } = placementInfo;
            const VISIBLE = 'visible';
            const VISIBLE_FIRST = 'visibleFirst';
            if (htmlRegion !== 'scroll' && htmlRegion !== VISIBLE_FIRST) htmlRegion = VISIBLE;
            const isVisibleFirst = htmlRegion === VISIBLE_FIRST;
            const scrollRegionArea = (0, $e1e5475fabaf4baf$export$94be9d7985092f2d)(scrollRegion, scrollerList);
            const visibleRegionArea = (0, $e1e5475fabaf4baf$export$94be9d7985092f2d)(visibleRegion, scrollerList);
            const visibleArea = htmlRegion === VISIBLE ? visibleRegionArea : scrollRegionArea;
            // When set to `visibleFirst`,
            // the check `adjust` logic will use `visibleRegion` for check first.
            const adjustCheckVisibleArea = isVisibleFirst ? visibleRegionArea : visibleArea;
            // Record right & bottom align data
            popupElement.style.left = 'auto';
            popupElement.style.top = 'auto';
            popupElement.style.right = '0';
            popupElement.style.bottom = '0';
            const popupMirrorRect = popupElement.getBoundingClientRect();
            // Reset back
            popupElement.style.left = originLeft;
            popupElement.style.top = originTop;
            popupElement.style.right = originRight;
            popupElement.style.bottom = originBottom;
            popupElement.style.overflow = originOverflow;
            popupElement.parentElement?.removeChild(placeholderElement);
            // Calculate scale
            const scaleX = (0, $e1e5475fabaf4baf$export$34dfc8f73bbb64ae)(Math.round(popupWidth / parseFloat(width) * 1000) / 1000);
            const scaleY = (0, $e1e5475fabaf4baf$export$34dfc8f73bbb64ae)(Math.round(popupHeight / parseFloat(height) * 1000) / 1000);
            // No need to align since it's not visible in view
            if (scaleX === 0 || scaleY === 0 || (0, $c1d2a04d2d287797$export$41e30d8dd0ba7a50)(target) && !(0, $218f20156c5f8705$export$2e2bcd8739ae039)(target)) return;
            // Offset
            const { offset: offset, targetOffset: targetOffset } = placementInfo;
            let [popupOffsetX, popupOffsetY] = $e4f1208709f6c2f8$var$getNumberOffset(popupRect, offset);
            const [targetOffsetX, targetOffsetY] = $e4f1208709f6c2f8$var$getNumberOffset(targetRect, targetOffset);
            targetRect.x -= targetOffsetX;
            targetRect.y -= targetOffsetY;
            // Points
            const [popupPoint, targetPoint] = placementInfo.points || [];
            const targetPoints = $e4f1208709f6c2f8$var$splitPoints(targetPoint);
            const popupPoints = $e4f1208709f6c2f8$var$splitPoints(popupPoint);
            const targetAlignPoint = $e4f1208709f6c2f8$var$getAlignPoint(targetRect, targetPoints);
            const popupAlignPoint = $e4f1208709f6c2f8$var$getAlignPoint(popupRect, popupPoints);
            // Real align info may not same as origin one
            const nextAlignInfo = {
                ...placementInfo
            };
            // Next Offset
            let nextOffsetX = targetAlignPoint.x - popupAlignPoint.x + popupOffsetX;
            let nextOffsetY = targetAlignPoint.y - popupAlignPoint.y + popupOffsetY;
            // ============== Intersection ===============
            // Get area by position. Used for check if flip area is better
            function getIntersectionVisibleArea(offsetX, offsetY, area = visibleArea) {
                const l = popupRect.x + offsetX;
                const t = popupRect.y + offsetY;
                const r = l + popupWidth;
                const b = t + popupHeight;
                const visibleL = Math.max(l, area.left);
                const visibleT = Math.max(t, area.top);
                const visibleR = Math.min(r, area.right);
                const visibleB = Math.min(b, area.bottom);
                return Math.max(0, (visibleR - visibleL) * (visibleB - visibleT));
            }
            const originIntersectionVisibleArea = getIntersectionVisibleArea(nextOffsetX, nextOffsetY);
            // As `visibleFirst`, we prepare this for check
            const originIntersectionRecommendArea = getIntersectionVisibleArea(nextOffsetX, nextOffsetY, visibleRegionArea);
            // ========================== Overflow ===========================
            const targetAlignPointTL = $e4f1208709f6c2f8$var$getAlignPoint(targetRect, [
                't',
                'l'
            ]);
            const popupAlignPointTL = $e4f1208709f6c2f8$var$getAlignPoint(popupRect, [
                't',
                'l'
            ]);
            const targetAlignPointBR = $e4f1208709f6c2f8$var$getAlignPoint(targetRect, [
                'b',
                'r'
            ]);
            const popupAlignPointBR = $e4f1208709f6c2f8$var$getAlignPoint(popupRect, [
                'b',
                'r'
            ]);
            const overflow = placementInfo.overflow || {};
            const { adjustX: adjustX, adjustY: adjustY, shiftX: shiftX, shiftY: shiftY } = overflow;
            const supportAdjust = (val)=>{
                if (typeof val === 'boolean') return val;
                return val >= 0;
            };
            // Prepare position
            let nextPopupY;
            let nextPopupBottom;
            let nextPopupX;
            let nextPopupRight;
            function syncNextPopupPosition() {
                nextPopupY = popupRect.y + nextOffsetY;
                nextPopupBottom = nextPopupY + popupHeight;
                nextPopupX = popupRect.x + nextOffsetX;
                nextPopupRight = nextPopupX + popupWidth;
            }
            syncNextPopupPosition();
            // >>>>>>>>>> Top & Bottom
            const needAdjustY = supportAdjust(adjustY);
            const sameTB = popupPoints[0] === targetPoints[0];
            // Bottom to Top
            if (needAdjustY && popupPoints[0] === 't' && (nextPopupBottom > adjustCheckVisibleArea.bottom || prevFlipRef.current.bt)) {
                let tmpNextOffsetY = nextOffsetY;
                if (sameTB) tmpNextOffsetY -= popupHeight - targetHeight;
                else tmpNextOffsetY = targetAlignPointTL.y - popupAlignPointBR.y - popupOffsetY;
                const newVisibleArea = getIntersectionVisibleArea(nextOffsetX, tmpNextOffsetY);
                const newVisibleRecommendArea = getIntersectionVisibleArea(nextOffsetX, tmpNextOffsetY, visibleRegionArea);
                if (// Of course use larger one
                newVisibleArea > originIntersectionVisibleArea || newVisibleArea === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
                newVisibleRecommendArea >= originIntersectionRecommendArea)) {
                    prevFlipRef.current.bt = true;
                    nextOffsetY = tmpNextOffsetY;
                    popupOffsetY = -popupOffsetY;
                    nextAlignInfo.points = [
                        $e4f1208709f6c2f8$var$reversePoints(popupPoints, 0),
                        $e4f1208709f6c2f8$var$reversePoints(targetPoints, 0)
                    ];
                } else prevFlipRef.current.bt = false;
            }
            // Top to Bottom
            if (needAdjustY && popupPoints[0] === 'b' && (nextPopupY < adjustCheckVisibleArea.top || prevFlipRef.current.tb)) {
                let tmpNextOffsetY = nextOffsetY;
                if (sameTB) tmpNextOffsetY += popupHeight - targetHeight;
                else tmpNextOffsetY = targetAlignPointBR.y - popupAlignPointTL.y - popupOffsetY;
                const newVisibleArea = getIntersectionVisibleArea(nextOffsetX, tmpNextOffsetY);
                const newVisibleRecommendArea = getIntersectionVisibleArea(nextOffsetX, tmpNextOffsetY, visibleRegionArea);
                if (// Of course use larger one
                newVisibleArea > originIntersectionVisibleArea || newVisibleArea === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
                newVisibleRecommendArea >= originIntersectionRecommendArea)) {
                    prevFlipRef.current.tb = true;
                    nextOffsetY = tmpNextOffsetY;
                    popupOffsetY = -popupOffsetY;
                    nextAlignInfo.points = [
                        $e4f1208709f6c2f8$var$reversePoints(popupPoints, 0),
                        $e4f1208709f6c2f8$var$reversePoints(targetPoints, 0)
                    ];
                } else prevFlipRef.current.tb = false;
            }
            // >>>>>>>>>> Left & Right
            const needAdjustX = supportAdjust(adjustX);
            // >>>>> Flip
            const sameLR = popupPoints[1] === targetPoints[1];
            // Right to Left
            if (needAdjustX && popupPoints[1] === 'l' && (nextPopupRight > adjustCheckVisibleArea.right || prevFlipRef.current.rl)) {
                let tmpNextOffsetX = nextOffsetX;
                if (sameLR) tmpNextOffsetX -= popupWidth - targetWidth;
                else tmpNextOffsetX = targetAlignPointTL.x - popupAlignPointBR.x - popupOffsetX;
                const newVisibleArea = getIntersectionVisibleArea(tmpNextOffsetX, nextOffsetY);
                const newVisibleRecommendArea = getIntersectionVisibleArea(tmpNextOffsetX, nextOffsetY, visibleRegionArea);
                if (// Of course use larger one
                newVisibleArea > originIntersectionVisibleArea || newVisibleArea === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
                newVisibleRecommendArea >= originIntersectionRecommendArea)) {
                    prevFlipRef.current.rl = true;
                    nextOffsetX = tmpNextOffsetX;
                    popupOffsetX = -popupOffsetX;
                    nextAlignInfo.points = [
                        $e4f1208709f6c2f8$var$reversePoints(popupPoints, 1),
                        $e4f1208709f6c2f8$var$reversePoints(targetPoints, 1)
                    ];
                } else prevFlipRef.current.rl = false;
            }
            // Left to Right
            if (needAdjustX && popupPoints[1] === 'r' && (nextPopupX < adjustCheckVisibleArea.left || prevFlipRef.current.lr)) {
                let tmpNextOffsetX = nextOffsetX;
                if (sameLR) tmpNextOffsetX += popupWidth - targetWidth;
                else tmpNextOffsetX = targetAlignPointBR.x - popupAlignPointTL.x - popupOffsetX;
                const newVisibleArea = getIntersectionVisibleArea(tmpNextOffsetX, nextOffsetY);
                const newVisibleRecommendArea = getIntersectionVisibleArea(tmpNextOffsetX, nextOffsetY, visibleRegionArea);
                if (// Of course use larger one
                newVisibleArea > originIntersectionVisibleArea || newVisibleArea === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
                newVisibleRecommendArea >= originIntersectionRecommendArea)) {
                    prevFlipRef.current.lr = true;
                    nextOffsetX = tmpNextOffsetX;
                    popupOffsetX = -popupOffsetX;
                    nextAlignInfo.points = [
                        $e4f1208709f6c2f8$var$reversePoints(popupPoints, 1),
                        $e4f1208709f6c2f8$var$reversePoints(targetPoints, 1)
                    ];
                } else prevFlipRef.current.lr = false;
            }
            // ============================ Shift ============================
            syncNextPopupPosition();
            const numShiftX = shiftX === true ? 0 : shiftX;
            if (typeof numShiftX === 'number') {
                // Left
                if (nextPopupX < visibleRegionArea.left) {
                    nextOffsetX -= nextPopupX - visibleRegionArea.left - popupOffsetX;
                    if (targetRect.x + targetWidth < visibleRegionArea.left + numShiftX) nextOffsetX += targetRect.x - visibleRegionArea.left + targetWidth - numShiftX;
                }
                // Right
                if (nextPopupRight > visibleRegionArea.right) {
                    nextOffsetX -= nextPopupRight - visibleRegionArea.right - popupOffsetX;
                    if (targetRect.x > visibleRegionArea.right - numShiftX) nextOffsetX += targetRect.x - visibleRegionArea.right + numShiftX;
                }
            }
            const numShiftY = shiftY === true ? 0 : shiftY;
            if (typeof numShiftY === 'number') {
                // Top
                if (nextPopupY < visibleRegionArea.top) {
                    nextOffsetY -= nextPopupY - visibleRegionArea.top - popupOffsetY;
                    // When target if far away from visible area
                    // Stop shift
                    if (targetRect.y + targetHeight < visibleRegionArea.top + numShiftY) nextOffsetY += targetRect.y - visibleRegionArea.top + targetHeight - numShiftY;
                }
                // Bottom
                if (nextPopupBottom > visibleRegionArea.bottom) {
                    nextOffsetY -= nextPopupBottom - visibleRegionArea.bottom - popupOffsetY;
                    if (targetRect.y > visibleRegionArea.bottom - numShiftY) nextOffsetY += targetRect.y - visibleRegionArea.bottom + numShiftY;
                }
            }
            // ============================ Arrow ============================
            // Arrow center align
            const popupLeft = popupRect.x + nextOffsetX;
            const popupRight = popupLeft + popupWidth;
            const popupTop = popupRect.y + nextOffsetY;
            const popupBottom = popupTop + popupHeight;
            const targetLeft = targetRect.x;
            const targetRight = targetLeft + targetWidth;
            const targetTop = targetRect.y;
            const targetBottom = targetTop + targetHeight;
            /** Max left of the popup and target element */ const maxLeft = Math.max(popupLeft, targetLeft);
            /** Min right of the popup and target element */ const minRight = Math.min(popupRight, targetRight);
            /** The center X of popup & target cross area */ const xCenter = (maxLeft + minRight) / 2;
            /** Arrow X of popup offset */ const nextArrowX = xCenter - popupLeft;
            const maxTop = Math.max(popupTop, targetTop);
            const minBottom = Math.min(popupBottom, targetBottom);
            const yCenter = (maxTop + minBottom) / 2;
            const nextArrowY = yCenter - popupTop;
            onPopupAlign?.(popupEle, nextAlignInfo);
            // Additional calculate right & bottom position
            let offsetX4Right = popupMirrorRect.right - popupRect.x - (nextOffsetX + popupRect.width);
            let offsetY4Bottom = popupMirrorRect.bottom - popupRect.y - (nextOffsetY + popupRect.height);
            if (scaleX === 1) {
                nextOffsetX = Math.round(nextOffsetX);
                offsetX4Right = Math.round(offsetX4Right);
            }
            if (scaleY === 1) {
                nextOffsetY = Math.round(nextOffsetY);
                offsetY4Bottom = Math.round(offsetY4Bottom);
            }
            const nextOffsetInfo = {
                ready: true,
                offsetX: nextOffsetX / scaleX,
                offsetY: nextOffsetY / scaleY,
                offsetR: offsetX4Right / scaleX,
                offsetB: offsetY4Bottom / scaleY,
                arrowX: nextArrowX / scaleX,
                arrowY: nextArrowY / scaleY,
                scaleX: scaleX,
                scaleY: scaleY,
                align: nextAlignInfo
            };
            setOffsetInfo(nextOffsetInfo);
        }
    });
    const triggerAlign = ()=>{
        alignCountRef.current += 1;
        const id = alignCountRef.current;
        // Merge all align requirement into one frame
        Promise.resolve().then(()=>{
            if (alignCountRef.current === id) onAlign();
        });
    };
    // Reset ready status when placement & open changed
    const resetReady = ()=>{
        setOffsetInfo((ori)=>({
                ...ori,
                ready: false
            }));
    };
    (0, $60cea2402df671e7$export$2e2bcd8739ae039)(resetReady, [
        placement
    ]);
    (0, $60cea2402df671e7$export$2e2bcd8739ae039)(()=>{
        if (!open) resetReady();
    }, [
        open
    ]);
    return [
        offsetInfo.ready,
        offsetInfo.offsetX,
        offsetInfo.offsetY,
        offsetInfo.offsetR,
        offsetInfo.offsetB,
        offsetInfo.arrowX,
        offsetInfo.arrowY,
        offsetInfo.scaleX,
        offsetInfo.scaleY,
        offsetInfo.align,
        triggerAlign
    ];
}


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
function $ea4251d37b6940bf$export$2e2bcd8739ae039() {
    const delayRef = $32rMB.useRef(null);
    const clearDelay = ()=>{
        if (delayRef.current) {
            clearTimeout(delayRef.current);
            delayRef.current = null;
        }
    };
    const delayInvoke = (callback, delay)=>{
        clearDelay();
        if (delay === 0) callback();
        else delayRef.current = setTimeout(()=>{
            callback();
        }, delay * 1000);
    };
    // Clean up on unmount
    $32rMB.useEffect(()=>{
        return ()=>{
            clearDelay();
        };
    }, []);
    return delayInvoke;
}




function $f76d4b696e9094f7$export$2e2bcd8739ae039(open, target, popup, onAlign, onScroll) {
    (0, $60cea2402df671e7$export$2e2bcd8739ae039)(()=>{
        if (open && target && popup) {
            const targetElement = target;
            const popupElement = popup;
            const targetScrollList = (0, $e1e5475fabaf4baf$export$ba21ed9400ca485b)(targetElement);
            const popupScrollList = (0, $e1e5475fabaf4baf$export$ba21ed9400ca485b)(popupElement);
            const win = (0, $e1e5475fabaf4baf$export$9c0584a7cc24d9e)(popupElement);
            const mergedList = new Set([
                win,
                ...targetScrollList,
                ...popupScrollList
            ]);
            function notifyScroll() {
                onAlign();
                onScroll();
            }
            mergedList.forEach((scroller)=>{
                scroller.addEventListener('scroll', notifyScroll, {
                    passive: true
                });
            });
            win.addEventListener('resize', notifyScroll, {
                passive: true
            });
            // First time always do align
            onAlign();
            return ()=>{
                mergedList.forEach((scroller)=>{
                    scroller.removeEventListener('scroll', notifyScroll);
                    win.removeEventListener('resize', notifyScroll);
                });
            };
        }
    }, [
        open,
        target,
        popup
    ]);
}




parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");

function $c2e4a5f392c04460$export$2e2bcd8739ae039(open, clickToHide, targetEle, popupEle, mask, maskClosable, inPopupOrChild, triggerOpen) {
    const openRef = $32rMB.useRef(open);
    openRef.current = open;
    const popupPointerDownRef = $32rMB.useRef(false);
    // Click to hide is special action since click popup element should not hide
    $32rMB.useEffect(()=>{
        if (clickToHide && popupEle && (!mask || maskClosable)) {
            const onPointerDown = ()=>{
                popupPointerDownRef.current = false;
            };
            const onTriggerClose = (e)=>{
                if (openRef.current && !inPopupOrChild(e.composedPath?.()?.[0] || e.target) && !popupPointerDownRef.current) triggerOpen(false);
            };
            const win = (0, $e1e5475fabaf4baf$export$9c0584a7cc24d9e)(popupEle);
            win.addEventListener('pointerdown', onPointerDown, true);
            win.addEventListener('mousedown', onTriggerClose, true);
            win.addEventListener('contextmenu', onTriggerClose, true);
            // shadow root
            const targetShadowRoot = (0, $66a153f87c091f0a$export$70e8259662bb498b)(targetEle);
            if (targetShadowRoot) {
                targetShadowRoot.addEventListener('mousedown', onTriggerClose, true);
                targetShadowRoot.addEventListener('contextmenu', onTriggerClose, true);
            }
            return ()=>{
                win.removeEventListener('pointerdown', onPointerDown, true);
                win.removeEventListener('mousedown', onTriggerClose, true);
                win.removeEventListener('contextmenu', onTriggerClose, true);
                if (targetShadowRoot) {
                    targetShadowRoot.removeEventListener('mousedown', onTriggerClose, true);
                    targetShadowRoot.removeEventListener('contextmenu', onTriggerClose, true);
                }
            };
        }
    }, [
        clickToHide,
        targetEle,
        popupEle,
        mask,
        maskClosable
    ]);
    function onPopupPointerDown() {
        popupPointerDownRef.current = true;
    }
    return onPopupPointerDown;
}



parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");







var $N3oW3 = parcelRequire("N3oW3");

function $fbc7bbd4d4ba3c39$export$2e2bcd8739ae039() {
    const [options, setOptions] = (0, $N3oW3.default).useState(null);
    const [open, setOpen] = (0, $N3oW3.default).useState(false);
    const [isAnimating, setIsAnimating] = (0, $N3oW3.default).useState(false);
    const pendingOptionsRef = (0, $N3oW3.default).useRef(null);
    const trigger = (0, $ea93068db096b7d6$export$2e2bcd8739ae039)((nextOptions)=>{
        if (nextOptions === false) {
            // Clear pending options when hiding
            pendingOptionsRef.current = null;
            setOpen(false);
        } else if (isAnimating && open) // If animating (appear or enter), cache new options
        pendingOptionsRef.current = nextOptions;
        else {
            setOpen(true);
            // Set new options
            setOptions(nextOptions);
            pendingOptionsRef.current = null;
            // Only mark as animating when transitioning from closed to open
            if (!open) setIsAnimating(true);
        }
    });
    const onVisibleChanged = (0, $ea93068db096b7d6$export$2e2bcd8739ae039)((visible)=>{
        if (visible) {
            // Animation enter completed, check if there are pending options
            setIsAnimating(false);
            if (pendingOptionsRef.current) {
                // Apply pending options
                setOptions(pendingOptionsRef.current);
                pendingOptionsRef.current = null;
            }
        } else {
            // Animation leave completed
            setIsAnimating(false);
            pendingOptionsRef.current = null;
        }
    });
    return [
        trigger,
        open,
        options,
        onVisibleChanged
    ];
}




var $N3oW3 = parcelRequire("N3oW3");



function $7409240892c5ffc4$var$_extends() {
    $7409240892c5ffc4$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7409240892c5ffc4$var$_extends.apply(this, arguments);
}
const $7409240892c5ffc4$var$UniqueContainer = (props)=>{
    const { prefixCls: prefixCls, isMobile: isMobile, ready: ready, open: open, align: align, offsetR: offsetR, offsetB: offsetB, offsetX: offsetX, offsetY: offsetY, arrowPos: arrowPos, popupSize: popupSize, motion: motion, uniqueContainerClassName: uniqueContainerClassName, uniqueContainerStyle: uniqueContainerStyle } = props;
    const containerCls = `${prefixCls}-unique-container`;
    const [motionVisible, setMotionVisible] = (0, $N3oW3.default).useState(false);
    // ========================= Styles =========================
    const offsetStyle = (0, $8e53a1caa8075717$export$2e2bcd8739ae039)(isMobile, ready, open, align, offsetR, offsetB, offsetX, offsetY);
    // Cache for offsetStyle when ready is true
    const cachedOffsetStyleRef = (0, $N3oW3.default).useRef(offsetStyle);
    // Update cached offset style when ready is true
    if (ready) cachedOffsetStyleRef.current = offsetStyle;
    // Apply popup size if available
    const sizeStyle = {};
    if (popupSize) {
        sizeStyle.width = popupSize.width;
        sizeStyle.height = popupSize.height;
    }
    // ========================= Render =========================
    return /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $db80a026d0a86ece$export$2e2bcd8739ae039), $7409240892c5ffc4$var$_extends({
        motionAppear: true,
        motionEnter: true,
        motionLeave: true,
        removeOnLeave: false,
        leavedClassName: `${containerCls}-hidden`
    }, motion, {
        visible: open,
        onVisibleChanged: (nextVisible)=>{
            setMotionVisible(nextVisible);
        }
    }), ({ className: motionClassName, style: motionStyle })=>{
        const cls = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(containerCls, motionClassName, uniqueContainerClassName, {
            [`${containerCls}-visible`]: motionVisible
        });
        return /*#__PURE__*/ (0, $N3oW3.default).createElement("div", {
            className: cls,
            style: {
                '--arrow-x': `${arrowPos?.x || 0}px`,
                '--arrow-y': `${arrowPos?.y || 0}px`,
                ...cachedOffsetStyleRef.current,
                ...sizeStyle,
                ...motionStyle,
                ...uniqueContainerStyle
            }
        });
    });
};
var $7409240892c5ffc4$export$2e2bcd8739ae039 = $7409240892c5ffc4$var$UniqueContainer;




const $ac9437527380b474$var$UniqueProvider = ({ children: children, postTriggerProps: postTriggerProps })=>{
    const [trigger, open, options, onTargetVisibleChanged] = (0, $fbc7bbd4d4ba3c39$export$2e2bcd8739ae039)();
    // ========================== Options ===========================
    const mergedOptions = $32rMB.useMemo(()=>{
        if (!options || !postTriggerProps) return options;
        return postTriggerProps(options);
    }, [
        options,
        postTriggerProps
    ]);
    // =========================== Popup ============================
    const [popupEle, setPopupEle] = $32rMB.useState(null);
    const [popupSize, setPopupSize] = $32rMB.useState(null);
    // Used for forwardRef popup. Not use internal
    const externalPopupRef = $32rMB.useRef(null);
    const setPopupRef = (0, $ea93068db096b7d6$export$2e2bcd8739ae039)((node)=>{
        externalPopupRef.current = node;
        if ((0, $c1d2a04d2d287797$export$41e30d8dd0ba7a50)(node) && popupEle !== node) setPopupEle(node);
    });
    // ========================== Register ==========================
    // Store the isOpen function from the latest show call
    const isOpenRef = $32rMB.useRef(null);
    const delayInvoke = (0, $ea4251d37b6940bf$export$2e2bcd8739ae039)();
    const show = (0, $ea93068db096b7d6$export$2e2bcd8739ae039)((showOptions, isOpen)=>{
        // Store the isOpen function for later use in hide
        isOpenRef.current = isOpen;
        delayInvoke(()=>{
            trigger(showOptions);
        }, showOptions.delay);
    });
    const hide = (delay)=>{
        delayInvoke(()=>{
            // Check if we should still hide by calling the isOpen function
            // If isOpen returns true, it means another trigger wants to keep it open
            if (isOpenRef.current?.()) return; // Don't hide if something else wants it open
            trigger(false);
        // Don't clear target, currentNode, options immediately, wait until animation completes
        }, delay);
    };
    // Callback after animation completes
    const onVisibleChanged = (0, $ea93068db096b7d6$export$2e2bcd8739ae039)((visible)=>{
        // Call useTargetState callback to handle animation state
        onTargetVisibleChanged(visible);
    });
    // =========================== Align ============================
    const [ready, offsetX, offsetY, offsetR, offsetB, arrowX, arrowY, , , // scaleY - not used in UniqueProvider
    alignInfo, onAlign] = (0, $e4f1208709f6c2f8$export$2e2bcd8739ae039)(open, popupEle, mergedOptions?.target, mergedOptions?.popupPlacement, mergedOptions?.builtinPlacements || {}, mergedOptions?.popupAlign, undefined, // onPopupAlign
    false // isMobile
    );
    const alignedClassName = $32rMB.useMemo(()=>{
        if (!mergedOptions) return '';
        const baseClassName = (0, $e1e5475fabaf4baf$export$faa0aa8ed2fe6432)(mergedOptions.builtinPlacements || {}, mergedOptions.prefixCls || '', alignInfo, false // alignPoint is false for UniqueProvider
        );
        return (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(baseClassName, mergedOptions.getPopupClassNameFromAlign?.(alignInfo));
    }, [
        alignInfo,
        mergedOptions?.getPopupClassNameFromAlign,
        mergedOptions?.builtinPlacements,
        mergedOptions?.prefixCls
    ]);
    const contextValue = $32rMB.useMemo(()=>({
            show: show,
            hide: hide
        }), []);
    // =========================== Align ============================
    $32rMB.useEffect(()=>{
        onAlign();
    }, [
        mergedOptions?.target
    ]);
    // =========================== Motion ===========================
    const onPrepare = (0, $ea93068db096b7d6$export$2e2bcd8739ae039)(()=>{
        onAlign();
        return Promise.resolve();
    });
    // ======================== Trigger Context =====================
    const subPopupElements = $32rMB.useRef({});
    const parentContext = $32rMB.useContext((0, $bf8d09429a780634$export$2e2bcd8739ae039));
    const triggerContextValue = $32rMB.useMemo(()=>({
            registerSubPopup: (id, subPopupEle)=>{
                subPopupElements.current[id] = subPopupEle;
                parentContext?.registerSubPopup(id, subPopupEle);
            }
        }), [
        parentContext
    ]);
    // =========================== Render ===========================
    const prefixCls = mergedOptions?.prefixCls;
    return /*#__PURE__*/ $hO8yS.createElement((0, $bf8d09429a780634$export$14cc6d12cdc906c).Provider, {
        value: contextValue
    }, children, mergedOptions && /*#__PURE__*/ $hO8yS.createElement((0, $bf8d09429a780634$export$2e2bcd8739ae039).Provider, {
        value: triggerContextValue
    }, /*#__PURE__*/ $hO8yS.createElement((0, $976d12e4ff9bb99e$export$2e2bcd8739ae039), {
        ref: setPopupRef,
        portal: (0, $af60d9f9d47b1e00$export$2e2bcd8739ae039),
        prefixCls: prefixCls,
        popup: mergedOptions.popup,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(mergedOptions.popupClassName, alignedClassName, `${prefixCls}-unique-controlled`),
        style: mergedOptions.popupStyle,
        target: mergedOptions.target,
        open: open,
        keepDom: true,
        fresh: true,
        autoDestroy: false,
        onVisibleChanged: onVisibleChanged,
        ready: ready,
        offsetX: offsetX,
        offsetY: offsetY,
        offsetR: offsetR,
        offsetB: offsetB,
        onAlign: onAlign,
        onPrepare: onPrepare,
        onResize: (size)=>setPopupSize({
                width: size.offsetWidth,
                height: size.offsetHeight
            }),
        arrowPos: {
            x: arrowX,
            y: arrowY
        },
        align: alignInfo,
        zIndex: mergedOptions.zIndex,
        mask: mergedOptions.mask,
        arrow: mergedOptions.arrow,
        motion: mergedOptions.popupMotion,
        maskMotion: mergedOptions.maskMotion,
        getPopupContainer: mergedOptions.getPopupContainer
    }, /*#__PURE__*/ $hO8yS.createElement((0, $7409240892c5ffc4$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        isMobile: false,
        ready: ready,
        open: open,
        align: alignInfo,
        offsetR: offsetR,
        offsetB: offsetB,
        offsetX: offsetX,
        offsetY: offsetY,
        arrowPos: {
            x: arrowX,
            y: arrowY
        },
        popupSize: popupSize,
        motion: mergedOptions.popupMotion,
        uniqueContainerClassName: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(mergedOptions.uniqueContainerClassName, alignedClassName),
        uniqueContainerStyle: mergedOptions.uniqueContainerStyle
    }))));
};
var $ac9437527380b474$export$2e2bcd8739ae039 = $ac9437527380b474$var$UniqueProvider;



function $0cc98d0cfc01331c$export$55e99723d7f71b47(PortalComponent = (0, $af60d9f9d47b1e00$export$2e2bcd8739ae039)) {
    const Trigger = /*#__PURE__*/ $N3oW3.forwardRef((props, ref)=>{
        const { prefixCls: prefixCls = 'rc-trigger-popup', children: children, action: // Action
        action = 'hover', showAction: showAction, hideAction: hideAction, popupVisible: // Open
        popupVisible, defaultPopupVisible: defaultPopupVisible, onOpenChange: onOpenChange, afterOpenChange: afterOpenChange, onPopupVisibleChange: onPopupVisibleChange, afterPopupVisibleChange: afterPopupVisibleChange, mouseEnterDelay: // Delay
        mouseEnterDelay, mouseLeaveDelay: mouseLeaveDelay = 0.1, focusDelay: focusDelay, blurDelay: blurDelay, mask: // Mask
        mask, maskClosable: maskClosable = true, getPopupContainer: // Portal
        getPopupContainer, forceRender: forceRender, autoDestroy: autoDestroy, popup: // Popup
        popup, popupClassName: popupClassName, uniqueContainerClassName: uniqueContainerClassName, uniqueContainerStyle: uniqueContainerStyle, popupStyle: popupStyle, popupPlacement: popupPlacement, builtinPlacements: builtinPlacements = {}, popupAlign: popupAlign, zIndex: zIndex, stretch: stretch, getPopupClassNameFromAlign: getPopupClassNameFromAlign, fresh: fresh, unique: unique, alignPoint: alignPoint, onPopupClick: onPopupClick, onPopupAlign: onPopupAlign, arrow: // Arrow
        arrow, popupMotion: // Motion
        popupMotion, maskMotion: maskMotion, mobile: // Private
        mobile, ...restProps } = props;
        const mergedAutoDestroy = autoDestroy || false;
        const openUncontrolled = popupVisible === undefined;
        // =========================== Mobile ===========================
        const isMobile = !!mobile;
        // ========================== Context ===========================
        const subPopupElements = $32rMB.useRef({});
        const parentContext = $32rMB.useContext((0, $bf8d09429a780634$export$2e2bcd8739ae039));
        const context = $32rMB.useMemo(()=>{
            return {
                registerSubPopup: (id, subPopupEle)=>{
                    subPopupElements.current[id] = subPopupEle;
                    parentContext?.registerSubPopup(id, subPopupEle);
                }
            };
        }, [
            parentContext
        ]);
        // ======================== UniqueContext =========================
        const uniqueContext = $32rMB.useContext((0, $bf8d09429a780634$export$14cc6d12cdc906c));
        // =========================== Popup ============================
        const id = (0, $32268c06752c3bab$export$2e2bcd8739ae039)();
        const [popupEle, setPopupEle] = $32rMB.useState(null);
        // Used for forwardRef popup. Not use internal
        const externalPopupRef = $32rMB.useRef(null);
        const setPopupRef = (0, $ea93068db096b7d6$export$2e2bcd8739ae039)((node)=>{
            externalPopupRef.current = node;
            if ((0, $c1d2a04d2d287797$export$41e30d8dd0ba7a50)(node) && popupEle !== node) setPopupEle(node);
            parentContext?.registerSubPopup(id, node);
        });
        // =========================== Target ===========================
        // Use state to control here since `useRef` update not trigger render
        const [targetEle, setTargetEle] = $32rMB.useState(null);
        // Used for forwardRef target. Not use internal
        const externalForwardRef = $32rMB.useRef(null);
        const setTargetRef = (0, $ea93068db096b7d6$export$2e2bcd8739ae039)((node)=>{
            if ((0, $c1d2a04d2d287797$export$41e30d8dd0ba7a50)(node) && targetEle !== node) {
                setTargetEle(node);
                externalForwardRef.current = node;
            }
        });
        const cloneProps = {};
        const inPopupOrChild = (0, $ea93068db096b7d6$export$2e2bcd8739ae039)((ele)=>{
            const childDOM = targetEle;
            return childDOM?.contains(ele) || (0, $66a153f87c091f0a$export$70e8259662bb498b)(childDOM)?.host === ele || ele === childDOM || popupEle?.contains(ele) || (0, $66a153f87c091f0a$export$70e8259662bb498b)(popupEle)?.host === ele || ele === popupEle || Object.values(subPopupElements.current).some((subPopupEle)=>subPopupEle?.contains(ele) || ele === subPopupEle);
        });
        // =========================== Arrow ============================
        const innerArrow = arrow ? {
            // true and Object likely
            ...arrow !== true ? arrow : {}
        } : null;
        // ============================ Open ============================
        const [internalOpen, setInternalOpen] = (0, $05ea6e97cee440ee$export$2e2bcd8739ae039)(defaultPopupVisible || false, popupVisible);
        const mergedOpen = internalOpen || false;
        // ========================== Children ==========================
        const child = $32rMB.useMemo(()=>{
            const nextChild = typeof children === 'function' ? children({
                open: mergedOpen
            }) : children;
            return $N3oW3.Children.only(nextChild);
        }, [
            children,
            mergedOpen
        ]);
        const originChildProps = child?.props || {};
        // Support ref
        const isOpen = (0, $ea93068db096b7d6$export$2e2bcd8739ae039)(()=>mergedOpen);
        // Extract common options for UniqueProvider
        const getUniqueOptions = (0, $ea93068db096b7d6$export$2e2bcd8739ae039)((delay = 0)=>({
                popup: popup,
                target: targetEle,
                delay: delay,
                prefixCls: prefixCls,
                popupClassName: popupClassName,
                uniqueContainerClassName: uniqueContainerClassName,
                uniqueContainerStyle: uniqueContainerStyle,
                popupStyle: popupStyle,
                popupPlacement: popupPlacement,
                builtinPlacements: builtinPlacements,
                popupAlign: popupAlign,
                zIndex: zIndex,
                mask: mask,
                maskClosable: maskClosable,
                popupMotion: popupMotion,
                maskMotion: maskMotion,
                arrow: innerArrow,
                getPopupContainer: getPopupContainer,
                getPopupClassNameFromAlign: getPopupClassNameFromAlign,
                id: id
            }));
        // Handle controlled state changes for UniqueProvider
        // Only sync to UniqueProvider when it's controlled mode
        // If there is a parentContext, don't call uniqueContext methods
        (0, $60cea2402df671e7$export$2e2bcd8739ae039)(()=>{
            if (uniqueContext && unique && targetEle && !openUncontrolled && !parentContext) {
                if (mergedOpen) uniqueContext.show(getUniqueOptions(mouseEnterDelay), isOpen);
                else uniqueContext.hide(mouseLeaveDelay);
            }
        }, [
            mergedOpen,
            targetEle
        ]);
        const openRef = $32rMB.useRef(mergedOpen);
        openRef.current = mergedOpen;
        const lastTriggerRef = $32rMB.useRef([]);
        lastTriggerRef.current = [];
        const internalTriggerOpen = (0, $ea93068db096b7d6$export$2e2bcd8739ae039)((nextOpen)=>{
            setInternalOpen(nextOpen);
            // Enter or Pointer will both trigger open state change
            // We only need take one to avoid duplicated change event trigger
            // Use `lastTriggerRef` to record last open type
            if ((lastTriggerRef.current[lastTriggerRef.current.length - 1] ?? mergedOpen) !== nextOpen) {
                lastTriggerRef.current.push(nextOpen);
                onOpenChange?.(nextOpen);
                onPopupVisibleChange?.(nextOpen);
            }
        });
        // Trigger for delay
        const delayInvoke = (0, $ea4251d37b6940bf$export$2e2bcd8739ae039)();
        const triggerOpen = (nextOpen, delay = 0)=>{
            // If it's controlled mode, always use internal trigger logic
            // UniqueProvider will be synced through useLayoutEffect
            if (popupVisible !== undefined) {
                delayInvoke(()=>{
                    internalTriggerOpen(nextOpen);
                }, delay);
                return;
            }
            // If UniqueContext exists and not controlled, pass delay to Provider instead of handling it internally
            // If there is a parentContext, don't call uniqueContext methods
            if (uniqueContext && unique && openUncontrolled && !parentContext) {
                if (nextOpen) uniqueContext.show(getUniqueOptions(delay), isOpen);
                else uniqueContext.hide(delay);
                return;
            }
            delayInvoke(()=>{
                internalTriggerOpen(nextOpen);
            }, delay);
        };
        // ========================== Motion ============================
        const [inMotion, setInMotion] = $32rMB.useState(false);
        (0, $60cea2402df671e7$export$2e2bcd8739ae039)((firstMount)=>{
            if (!firstMount || mergedOpen) setInMotion(true);
        }, [
            mergedOpen
        ]);
        const [motionPrepareResolve, setMotionPrepareResolve] = $32rMB.useState(null);
        // =========================== Align ============================
        const [mousePos, setMousePos] = $32rMB.useState(null);
        const setMousePosByEvent = (event)=>{
            setMousePos([
                event.clientX,
                event.clientY
            ]);
        };
        const [ready, offsetX, offsetY, offsetR, offsetB, arrowX, arrowY, scaleX, scaleY, alignInfo, onAlign] = (0, $e4f1208709f6c2f8$export$2e2bcd8739ae039)(mergedOpen, popupEle, alignPoint && mousePos !== null ? mousePos : targetEle, popupPlacement, builtinPlacements, popupAlign, onPopupAlign, isMobile);
        const [showActions, hideActions] = (0, $08d878b8ecde4208$export$2e2bcd8739ae039)(action, showAction, hideAction);
        const clickToShow = showActions.has('click');
        const clickToHide = hideActions.has('click') || hideActions.has('contextMenu');
        const triggerAlign = (0, $ea93068db096b7d6$export$2e2bcd8739ae039)(()=>{
            if (!inMotion) onAlign();
        });
        const onScroll = ()=>{
            if (openRef.current && alignPoint && clickToHide) triggerOpen(false);
        };
        (0, $f76d4b696e9094f7$export$2e2bcd8739ae039)(mergedOpen, targetEle, popupEle, triggerAlign, onScroll);
        (0, $60cea2402df671e7$export$2e2bcd8739ae039)(()=>{
            triggerAlign();
        }, [
            mousePos,
            popupPlacement
        ]);
        // When no builtinPlacements and popupAlign changed
        (0, $60cea2402df671e7$export$2e2bcd8739ae039)(()=>{
            if (mergedOpen && !builtinPlacements?.[popupPlacement]) triggerAlign();
        }, [
            JSON.stringify(popupAlign)
        ]);
        const alignedClassName = $32rMB.useMemo(()=>{
            const baseClassName = (0, $e1e5475fabaf4baf$export$faa0aa8ed2fe6432)(builtinPlacements, prefixCls, alignInfo, alignPoint);
            return (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(baseClassName, getPopupClassNameFromAlign?.(alignInfo));
        }, [
            alignInfo,
            getPopupClassNameFromAlign,
            builtinPlacements,
            prefixCls,
            alignPoint
        ]);
        // ============================ Refs ============================
        $32rMB.useImperativeHandle(ref, ()=>({
                nativeElement: externalForwardRef.current,
                popupElement: externalPopupRef.current,
                forceAlign: triggerAlign
            }));
        // ========================== Stretch ===========================
        const [targetWidth, setTargetWidth] = $32rMB.useState(0);
        const [targetHeight, setTargetHeight] = $32rMB.useState(0);
        const syncTargetSize = ()=>{
            if (stretch && targetEle) {
                const rect = targetEle.getBoundingClientRect();
                setTargetWidth(rect.width);
                setTargetHeight(rect.height);
            }
        };
        const onTargetResize = ()=>{
            syncTargetSize();
            triggerAlign();
        };
        // ========================== Motion ============================
        const onVisibleChanged = (visible)=>{
            setInMotion(false);
            onAlign();
            afterOpenChange?.(visible);
            afterPopupVisibleChange?.(visible);
        };
        // We will trigger align when motion is in prepare
        const onPrepare = ()=>new Promise((resolve)=>{
                syncTargetSize();
                setMotionPrepareResolve(()=>resolve);
            });
        (0, $60cea2402df671e7$export$2e2bcd8739ae039)(()=>{
            if (motionPrepareResolve) {
                onAlign();
                motionPrepareResolve();
                setMotionPrepareResolve(null);
            }
        }, [
            motionPrepareResolve
        ]);
        // =========================== Action ===========================
        /**
     * Util wrapper for trigger action
     * @param eventName  Listen event name
     * @param nextOpen  Next open state after trigger
     * @param delay Delay to trigger open change
     * @param callback Callback if current event need additional action
     * @param ignoreCheck  Ignore current event if check return true
     */ function wrapperAction(eventName, nextOpen, delay, callback, ignoreCheck) {
            cloneProps[eventName] = (event, ...args)=>{
                if (!ignoreCheck || !ignoreCheck()) {
                    callback?.(event);
                    triggerOpen(nextOpen, delay);
                }
                // Pass to origin
                originChildProps[eventName]?.(event, ...args);
            };
        }
        // ======================= Action: Touch ========================
        const touchToShow = showActions.has('touch');
        const touchToHide = hideActions.has('touch');
        /** Used for prevent `hover` event conflict with mobile env */ const touchedRef = $32rMB.useRef(false);
        if (touchToShow || touchToHide) cloneProps.onTouchStart = (...args)=>{
            touchedRef.current = true;
            if (openRef.current && touchToHide) triggerOpen(false);
            else if (!openRef.current && touchToShow) triggerOpen(true);
            // Pass to origin
            originChildProps.onTouchStart?.(...args);
        };
        // ======================= Action: Click ========================
        if (clickToShow || clickToHide) cloneProps.onClick = (event, ...args)=>{
            if (openRef.current && clickToHide) triggerOpen(false);
            else if (!openRef.current && clickToShow) {
                setMousePosByEvent(event);
                triggerOpen(true);
            }
            // Pass to origin
            originChildProps.onClick?.(event, ...args);
            touchedRef.current = false;
        };
        // Click to hide is special action since click popup element should not hide
        const onPopupPointerDown = (0, $c2e4a5f392c04460$export$2e2bcd8739ae039)(mergedOpen, clickToHide || touchToHide, targetEle, popupEle, mask, maskClosable, inPopupOrChild, triggerOpen);
        // ======================= Action: Hover ========================
        const hoverToShow = showActions.has('hover');
        const hoverToHide = hideActions.has('hover');
        let onPopupMouseEnter;
        let onPopupMouseLeave;
        const ignoreMouseTrigger = ()=>{
            return touchedRef.current;
        };
        if (hoverToShow) {
            const onMouseEnterCallback = (event)=>{
                setMousePosByEvent(event);
            };
            // Compatible with old browser which not support pointer event
            wrapperAction('onMouseEnter', true, mouseEnterDelay, onMouseEnterCallback, ignoreMouseTrigger);
            wrapperAction('onPointerEnter', true, mouseEnterDelay, onMouseEnterCallback, ignoreMouseTrigger);
            onPopupMouseEnter = (event)=>{
                // Only trigger re-open when popup is visible
                if ((mergedOpen || inMotion) && popupEle?.contains(event.target)) triggerOpen(true, mouseEnterDelay);
            };
            // Align Point
            if (alignPoint) cloneProps.onMouseMove = (event)=>{
                originChildProps.onMouseMove?.(event);
            };
        }
        if (hoverToHide) {
            wrapperAction('onMouseLeave', false, mouseLeaveDelay, undefined, ignoreMouseTrigger);
            wrapperAction('onPointerLeave', false, mouseLeaveDelay, undefined, ignoreMouseTrigger);
            onPopupMouseLeave = ()=>{
                triggerOpen(false, mouseLeaveDelay);
            };
        }
        // ======================= Action: Focus ========================
        if (showActions.has('focus')) wrapperAction('onFocus', true, focusDelay);
        if (hideActions.has('focus')) wrapperAction('onBlur', false, blurDelay);
        // ==================== Action: ContextMenu =====================
        if (showActions.has('contextMenu')) cloneProps.onContextMenu = (event, ...args)=>{
            if (openRef.current && hideActions.has('contextMenu')) triggerOpen(false);
            else {
                setMousePosByEvent(event);
                triggerOpen(true);
            }
            event.preventDefault();
            // Pass to origin
            originChildProps.onContextMenu?.(event, ...args);
        };
        // ============================ Perf ============================
        const rendedRef = $32rMB.useRef(false);
        rendedRef.current ||= forceRender || mergedOpen || inMotion;
        // =========================== Render ===========================
        const mergedChildrenProps = {
            ...originChildProps,
            ...cloneProps
        };
        // Pass props into cloneProps for nest usage
        const passedProps = {};
        const passedEventList = [
            'onContextMenu',
            'onClick',
            'onMouseDown',
            'onTouchStart',
            'onMouseEnter',
            'onMouseLeave',
            'onFocus',
            'onBlur'
        ];
        passedEventList.forEach((eventName)=>{
            if (restProps[eventName]) passedProps[eventName] = (...args)=>{
                mergedChildrenProps[eventName]?.(...args);
                restProps[eventName](...args);
            };
        });
        const arrowPos = {
            x: arrowX,
            y: arrowY
        };
        // Child Node
        const triggerNode = /*#__PURE__*/ $N3oW3.cloneElement(child, {
            ...mergedChildrenProps,
            ...passedProps
        });
        // Render
        return /*#__PURE__*/ $hO8yS.createElement($hO8yS.Fragment, null, /*#__PURE__*/ $hO8yS.createElement((0, $b8d12c084d14878d$export$2e2bcd8739ae039), {
            disabled: !mergedOpen,
            ref: setTargetRef,
            onResize: onTargetResize
        }, triggerNode), rendedRef.current && (!uniqueContext || !unique) && /*#__PURE__*/ $hO8yS.createElement((0, $bf8d09429a780634$export$2e2bcd8739ae039).Provider, {
            value: context
        }, /*#__PURE__*/ $hO8yS.createElement((0, $976d12e4ff9bb99e$export$2e2bcd8739ae039), {
            portal: PortalComponent,
            ref: setPopupRef,
            prefixCls: prefixCls,
            popup: popup,
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(popupClassName, !isMobile && alignedClassName),
            style: popupStyle,
            target: targetEle,
            onMouseEnter: onPopupMouseEnter,
            onMouseLeave: onPopupMouseLeave,
            onPointerEnter: onPopupMouseEnter,
            zIndex: zIndex,
            open: mergedOpen,
            keepDom: inMotion,
            fresh: fresh,
            onClick: onPopupClick,
            onPointerDownCapture: onPopupPointerDown,
            mask: mask,
            motion: popupMotion,
            maskMotion: maskMotion,
            onVisibleChanged: onVisibleChanged,
            onPrepare: onPrepare,
            forceRender: forceRender,
            autoDestroy: mergedAutoDestroy,
            getPopupContainer: getPopupContainer,
            align: alignInfo,
            arrow: innerArrow,
            arrowPos: arrowPos,
            ready: ready,
            offsetX: offsetX,
            offsetY: offsetY,
            offsetR: offsetR,
            offsetB: offsetB,
            onAlign: triggerAlign,
            stretch: stretch,
            targetWidth: targetWidth / scaleX,
            targetHeight: targetHeight / scaleY,
            mobile: mobile
        })));
    });
    return Trigger;
}
var $0cc98d0cfc01331c$export$2e2bcd8739ae039 = $0cc98d0cfc01331c$export$55e99723d7f71b47((0, $af60d9f9d47b1e00$export$2e2bcd8739ae039));



var $N3oW3 = parcelRequire("N3oW3");


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");
const $dd01e2f5a4b8605d$export$e4ec87ea71f29b41 = 'ant';
const $dd01e2f5a4b8605d$export$eaca8ee5ed21b4e9 = 'anticon';
const $dd01e2f5a4b8605d$export$fa216ce2679a073b = [
    'outlined',
    'borderless',
    'filled',
    'underlined'
];
const $dd01e2f5a4b8605d$var$defaultGetPrefixCls = (suffixCls, customizePrefixCls)=>{
    if (customizePrefixCls) return customizePrefixCls;
    return suffixCls ? `${$dd01e2f5a4b8605d$export$e4ec87ea71f29b41}-${suffixCls}` : $dd01e2f5a4b8605d$export$e4ec87ea71f29b41;
};
const $dd01e2f5a4b8605d$export$a92f85ab3e9ad68b = /*#__PURE__*/ $hO8yS.createContext({
    // We provide a default function for Context without provider
    getPrefixCls: $dd01e2f5a4b8605d$var$defaultGetPrefixCls,
    iconPrefixCls: $dd01e2f5a4b8605d$export$eaca8ee5ed21b4e9
});
const { Consumer: $dd01e2f5a4b8605d$export$cd5442f2b8da7663 } = $dd01e2f5a4b8605d$export$a92f85ab3e9ad68b;
const $dd01e2f5a4b8605d$var$EMPTY_OBJECT = {};
function $dd01e2f5a4b8605d$export$46f4bd6436a25a31(propName) {
    const context = $32rMB.useContext($dd01e2f5a4b8605d$export$a92f85ab3e9ad68b);
    const { getPrefixCls: getPrefixCls, direction: direction, getPopupContainer: getPopupContainer, renderEmpty: renderEmpty } = context;
    const propValue = context[propName];
    return {
        classNames: $dd01e2f5a4b8605d$var$EMPTY_OBJECT,
        styles: $dd01e2f5a4b8605d$var$EMPTY_OBJECT,
        ...propValue,
        getPrefixCls: getPrefixCls,
        direction: direction,
        getPopupContainer: getPopupContainer,
        renderEmpty: renderEmpty
    };
}


"use client";
const $d108f5dd98db28e6$var$MotionContent = ({ children: children })=>{
    const { getPrefixCls: getPrefixCls } = (0, $N3oW3.default).useContext((0, $dd01e2f5a4b8605d$export$a92f85ab3e9ad68b));
    const rootPrefixCls = getPrefixCls();
    // This will never reach since we will not render this when no children
    /* istanbul ignore next */ if (!/*#__PURE__*/ (0, $N3oW3.default).isValidElement(children)) return children;
    return /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $db80a026d0a86ece$export$2e2bcd8739ae039), {
        visible: true,
        motionName: `${rootPrefixCls}-fade`,
        motionAppear: true,
        motionEnter: true,
        motionLeave: false,
        removeOnLeave: false
    }, ({ style: motionStyle, className: motionClassName })=>{
        const { className: className, style: style } = children.props;
        const mergedStyles = {
            ...style,
            ...motionStyle
        };
        return /*#__PURE__*/ (0, $N3oW3.default).cloneElement(children, {
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(className, motionClassName),
            style: mergedStyles
        });
    });
};
var $d108f5dd98db28e6$export$2e2bcd8739ae039 = $d108f5dd98db28e6$var$MotionContent;


"use client";
const $280b6a0642f9eb46$var$cachedPlacements = [
    null,
    null
];
function $280b6a0642f9eb46$var$uniqueBuiltinPlacements(ori) {
    if ($280b6a0642f9eb46$var$cachedPlacements[0] !== ori) {
        const target = {};
        Object.keys(ori).forEach((placement)=>{
            target[placement] = {
                ...ori[placement],
                dynamicInset: false
            };
        });
        $280b6a0642f9eb46$var$cachedPlacements[0] = ori;
        $280b6a0642f9eb46$var$cachedPlacements[1] = target;
    }
    return $280b6a0642f9eb46$var$cachedPlacements[1];
}
const $280b6a0642f9eb46$var$UniqueProvider = ({ children: children })=>{
    const renderPopup = (options)=>{
        const popupEle = typeof options.popup === 'function' ? options.popup() : options.popup;
        const { id: id, builtinPlacements: builtinPlacements } = options;
        const parsedPlacements = $280b6a0642f9eb46$var$uniqueBuiltinPlacements(builtinPlacements);
        return {
            ...options,
            getPopupContainer: null,
            arrow: false,
            popup: /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $d108f5dd98db28e6$export$2e2bcd8739ae039), {
                key: id
            }, popupEle),
            builtinPlacements: parsedPlacements
        };
    };
    return /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $ac9437527380b474$export$2e2bcd8739ae039), {
        postTriggerProps: renderPopup
    }, children);
};
var $280b6a0642f9eb46$export$2e2bcd8739ae039 = $280b6a0642f9eb46$var$UniqueProvider;



parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");
"use client";
const $ff4b4ddbf52ed41f$var$DisabledContext = /*#__PURE__*/ $hO8yS.createContext(false);
const $ff4b4ddbf52ed41f$export$6adb5f3b918b11bb = ({ children: children, disabled: disabled })=>{
    const originDisabled = $32rMB.useContext($ff4b4ddbf52ed41f$var$DisabledContext);
    return /*#__PURE__*/ $hO8yS.createElement($ff4b4ddbf52ed41f$var$DisabledContext.Provider, {
        value: disabled ?? originDisabled
    }, children);
};
var $ff4b4ddbf52ed41f$export$2e2bcd8739ae039 = $ff4b4ddbf52ed41f$var$DisabledContext;


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");

parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");
"use client";
const $4859819e58dda691$var$SizeContext = /*#__PURE__*/ $hO8yS.createContext(undefined);
const $4859819e58dda691$export$dbc92d89fabc8ebe = ({ children: children, size: size })=>{
    const originSize = $32rMB.useContext($4859819e58dda691$var$SizeContext);
    return /*#__PURE__*/ $hO8yS.createElement($4859819e58dda691$var$SizeContext.Provider, {
        value: size || originSize
    }, children);
};
var $4859819e58dda691$export$2e2bcd8739ae039 = $4859819e58dda691$var$SizeContext;


function $2801c1fd656defdd$var$useConfig() {
    const componentDisabled = (0, $32rMB.useContext)((0, $ff4b4ddbf52ed41f$export$2e2bcd8739ae039));
    const componentSize = (0, $32rMB.useContext)((0, $4859819e58dda691$export$2e2bcd8739ae039));
    return {
        componentDisabled: componentDisabled,
        componentSize: componentSize
    };
}
var $2801c1fd656defdd$export$2e2bcd8739ae039 = $2801c1fd656defdd$var$useConfig;


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");




function $60819677badfb604$export$2e2bcd8739ae039(theme, parentTheme, config) {
    const warning = (0, $d41680c8243eac18$export$cf977aa92c751e61)('ConfigProvider');
    const themeConfig = theme || {};
    const parentThemeConfig = themeConfig.inherit === false || !parentTheme ? {
        ...(0, $a70f9f31ea093dd1$export$f84bd70098573c5c),
        hashed: parentTheme?.hashed ?? (0, $a70f9f31ea093dd1$export$f84bd70098573c5c).hashed,
        cssVar: parentTheme?.cssVar
    } : parentTheme;
    // Generate a unique key for cssVar
    const themeKey = (0, $32rMB.useId)();
    return (0, $7b0442ce5e42625c$export$2e2bcd8739ae039)(()=>{
        if (!theme) return parentTheme;
        // Override
        const mergedComponents = {
            ...parentThemeConfig.components
        };
        Object.keys(theme.components || {}).forEach((componentName)=>{
            mergedComponents[componentName] = {
                ...mergedComponents[componentName],
                ...theme.components[componentName]
            };
        });
        const cssVarKey = `css-var-${themeKey.replace(/:/g, '')}`;
        const mergedCssVar = {
            prefix: config?.prefixCls,
            // Same as prefixCls by default
            ...parentThemeConfig.cssVar,
            ...themeConfig.cssVar,
            key: themeConfig.cssVar?.key || cssVarKey
        };
        // Base token
        return {
            ...parentThemeConfig,
            ...themeConfig,
            token: {
                ...parentThemeConfig.token,
                ...themeConfig.token
            },
            components: mergedComponents,
            cssVar: mergedCssVar
        };
    }, [
        themeConfig,
        parentThemeConfig
    ], (prev, next)=>prev.some((prevTheme, index)=>{
            const nextTheme = next[index];
            return !(0, $5582f7991b7cfce3$export$2e2bcd8739ae039)(prevTheme, nextTheme, true);
        }));
}


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");


var $N3oW3 = parcelRequire("N3oW3");

var $193c4269296d25db$export$2e2bcd8739ae039 = '6.0.1';


"use client";
var $e4e1a4695f179bcc$export$2e2bcd8739ae039 = (0, $193c4269296d25db$export$2e2bcd8739ae039);







function $aa087b253bae3724$var$isStableColor(color) {
    return color >= 0 && color <= 255;
}
function $aa087b253bae3724$var$getAlphaColor(frontColor, backgroundColor) {
    const { r: fR, g: fG, b: fB, a: originAlpha } = new (0, $cbc85b6187a98a9b$export$2c4f38d6c0ecc25a)(frontColor).toRgb();
    if (originAlpha < 1) return frontColor;
    const { r: bR, g: bG, b: bB } = new (0, $cbc85b6187a98a9b$export$2c4f38d6c0ecc25a)(backgroundColor).toRgb();
    for(let fA = 0.01; fA <= 1; fA += 0.01){
        const r = Math.round((fR - bR * (1 - fA)) / fA);
        const g = Math.round((fG - bG * (1 - fA)) / fA);
        const b = Math.round((fB - bB * (1 - fA)) / fA);
        if ($aa087b253bae3724$var$isStableColor(r) && $aa087b253bae3724$var$isStableColor(g) && $aa087b253bae3724$var$isStableColor(b)) return new (0, $cbc85b6187a98a9b$export$2c4f38d6c0ecc25a)({
            r: r,
            g: g,
            b: b,
            a: Math.round(fA * 100) / 100
        }).toRgbString();
    }
    // fallback
    /* istanbul ignore next */ return new (0, $cbc85b6187a98a9b$export$2c4f38d6c0ecc25a)({
        r: fR,
        g: fG,
        b: fB,
        a: 1
    }).toRgbString();
}
var $aa087b253bae3724$export$2e2bcd8739ae039 = $aa087b253bae3724$var$getAlphaColor;


function $363bcafc7b9db979$export$2e2bcd8739ae039(derivativeToken) {
    const { override: override, ...restToken } = derivativeToken;
    const overrideTokens = {
        ...override
    };
    Object.keys((0, $08c67dd9815325ec$export$2e2bcd8739ae039)).forEach((token)=>{
        delete overrideTokens[token];
    });
    const mergedToken = {
        ...restToken,
        ...overrideTokens
    };
    const screenXS = 480;
    const screenSM = 576;
    const screenMD = 768;
    const screenLG = 992;
    const screenXL = 1200;
    const screenXXL = 1600;
    // Motion
    if (mergedToken.motion === false) {
        const fastDuration = '0s';
        mergedToken.motionDurationFast = fastDuration;
        mergedToken.motionDurationMid = fastDuration;
        mergedToken.motionDurationSlow = fastDuration;
    }
    // Generate alias token
    const aliasToken = {
        ...mergedToken,
        // ============== Background ============== //
        colorFillContent: mergedToken.colorFillSecondary,
        colorFillContentHover: mergedToken.colorFill,
        colorFillAlter: mergedToken.colorFillQuaternary,
        colorBgContainerDisabled: mergedToken.colorFillTertiary,
        // ============== Split ============== //
        colorBorderBg: mergedToken.colorBgContainer,
        colorSplit: (0, $aa087b253bae3724$export$2e2bcd8739ae039)(mergedToken.colorBorderSecondary, mergedToken.colorBgContainer),
        // ============== Text ============== //
        colorTextPlaceholder: mergedToken.colorTextQuaternary,
        colorTextDisabled: mergedToken.colorTextQuaternary,
        colorTextHeading: mergedToken.colorText,
        colorTextLabel: mergedToken.colorTextSecondary,
        colorTextDescription: mergedToken.colorTextTertiary,
        colorTextLightSolid: mergedToken.colorWhite,
        colorHighlight: mergedToken.colorError,
        colorBgTextHover: mergedToken.colorFillSecondary,
        colorBgTextActive: mergedToken.colorFill,
        colorIcon: mergedToken.colorTextTertiary,
        colorIconHover: mergedToken.colorText,
        colorErrorOutline: (0, $aa087b253bae3724$export$2e2bcd8739ae039)(mergedToken.colorErrorBg, mergedToken.colorBgContainer),
        colorWarningOutline: (0, $aa087b253bae3724$export$2e2bcd8739ae039)(mergedToken.colorWarningBg, mergedToken.colorBgContainer),
        // Font
        fontSizeIcon: mergedToken.fontSizeSM,
        // Line
        lineWidthFocus: mergedToken.lineWidth * 3,
        // Control
        lineWidth: mergedToken.lineWidth,
        controlOutlineWidth: mergedToken.lineWidth * 2,
        // Checkbox size and expand icon size
        controlInteractiveSize: mergedToken.controlHeight / 2,
        controlItemBgHover: mergedToken.colorFillTertiary,
        controlItemBgActive: mergedToken.colorPrimaryBg,
        controlItemBgActiveHover: mergedToken.colorPrimaryBgHover,
        controlItemBgActiveDisabled: mergedToken.colorFill,
        controlTmpOutline: mergedToken.colorFillQuaternary,
        controlOutline: (0, $aa087b253bae3724$export$2e2bcd8739ae039)(mergedToken.colorPrimaryBg, mergedToken.colorBgContainer),
        lineType: mergedToken.lineType,
        borderRadius: mergedToken.borderRadius,
        borderRadiusXS: mergedToken.borderRadiusXS,
        borderRadiusSM: mergedToken.borderRadiusSM,
        borderRadiusLG: mergedToken.borderRadiusLG,
        fontWeightStrong: 600,
        opacityLoading: 0.65,
        linkDecoration: 'none',
        linkHoverDecoration: 'none',
        linkFocusDecoration: 'none',
        controlPaddingHorizontal: 12,
        controlPaddingHorizontalSM: 8,
        paddingXXS: mergedToken.sizeXXS,
        paddingXS: mergedToken.sizeXS,
        paddingSM: mergedToken.sizeSM,
        padding: mergedToken.size,
        paddingMD: mergedToken.sizeMD,
        paddingLG: mergedToken.sizeLG,
        paddingXL: mergedToken.sizeXL,
        paddingContentHorizontalLG: mergedToken.sizeLG,
        paddingContentVerticalLG: mergedToken.sizeMS,
        paddingContentHorizontal: mergedToken.sizeMS,
        paddingContentVertical: mergedToken.sizeSM,
        paddingContentHorizontalSM: mergedToken.size,
        paddingContentVerticalSM: mergedToken.sizeXS,
        marginXXS: mergedToken.sizeXXS,
        marginXS: mergedToken.sizeXS,
        marginSM: mergedToken.sizeSM,
        margin: mergedToken.size,
        marginMD: mergedToken.sizeMD,
        marginLG: mergedToken.sizeLG,
        marginXL: mergedToken.sizeXL,
        marginXXL: mergedToken.sizeXXL,
        boxShadow: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowSecondary: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowTertiary: `
      0 1px 2px 0 rgba(0, 0, 0, 0.03),
      0 1px 6px -1px rgba(0, 0, 0, 0.02),
      0 2px 4px 0 rgba(0, 0, 0, 0.02)
    `,
        screenXS: screenXS,
        screenXSMin: screenXS,
        screenXSMax: screenSM - 1,
        screenSM: screenSM,
        screenSMMin: screenSM,
        screenSMMax: screenMD - 1,
        screenMD: screenMD,
        screenMDMin: screenMD,
        screenMDMax: screenLG - 1,
        screenLG: screenLG,
        screenLGMin: screenLG,
        screenLGMax: screenXL - 1,
        screenXL: screenXL,
        screenXLMin: screenXL,
        screenXLMax: screenXXL - 1,
        screenXXL: screenXXL,
        screenXXLMin: screenXXL,
        boxShadowPopoverArrow: '2px 2px 5px rgba(0, 0, 0, 0.05)',
        boxShadowCard: `
      0 1px 2px -2px ${new (0, $cbc85b6187a98a9b$export$2c4f38d6c0ecc25a)('rgba(0, 0, 0, 0.16)').toRgbString()},
      0 3px 6px 0 ${new (0, $cbc85b6187a98a9b$export$2c4f38d6c0ecc25a)('rgba(0, 0, 0, 0.12)').toRgbString()},
      0 5px 12px 4px ${new (0, $cbc85b6187a98a9b$export$2c4f38d6c0ecc25a)('rgba(0, 0, 0, 0.09)').toRgbString()}
    `,
        boxShadowDrawerRight: `
      -6px 0 16px 0 rgba(0, 0, 0, 0.08),
      -3px 0 6px -4px rgba(0, 0, 0, 0.12),
      -9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowDrawerLeft: `
      6px 0 16px 0 rgba(0, 0, 0, 0.08),
      3px 0 6px -4px rgba(0, 0, 0, 0.12),
      9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowDrawerUp: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowDrawerDown: `
      0 -6px 16px 0 rgba(0, 0, 0, 0.08),
      0 -3px 6px -4px rgba(0, 0, 0, 0.12),
      0 -9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowTabsOverflowLeft: 'inset 10px 0 8px -8px rgba(0, 0, 0, 0.08)',
        boxShadowTabsOverflowRight: 'inset -10px 0 8px -8px rgba(0, 0, 0, 0.08)',
        boxShadowTabsOverflowTop: 'inset 0 10px 8px -8px rgba(0, 0, 0, 0.08)',
        boxShadowTabsOverflowBottom: 'inset 0 -10px 8px -8px rgba(0, 0, 0, 0.08)',
        // Override AliasToken
        ...overrideTokens
    };
    return aliasToken;
}


const $9481722d146bd166$export$c6b9faa6b723d31a = {
    lineHeight: true,
    lineHeightSM: true,
    lineHeightLG: true,
    lineHeightHeading1: true,
    lineHeightHeading2: true,
    lineHeightHeading3: true,
    lineHeightHeading4: true,
    lineHeightHeading5: true,
    opacityLoading: true,
    fontWeightStrong: true,
    zIndexPopupBase: true,
    zIndexBase: true,
    opacityImage: true
};
const $9481722d146bd166$export$738b109e247a462c = {
    motionBase: true,
    motionUnit: true
};
const $9481722d146bd166$var$preserve = {
    screenXS: true,
    screenXSMin: true,
    screenXSMax: true,
    screenSM: true,
    screenSMMin: true,
    screenSMMax: true,
    screenMD: true,
    screenMDMin: true,
    screenMDMax: true,
    screenLG: true,
    screenLGMin: true,
    screenLGMax: true,
    screenXL: true,
    screenXLMin: true,
    screenXLMax: true,
    screenXXL: true,
    screenXXLMin: true
};
const $9481722d146bd166$export$18602cb46ae80b62 = (originToken, overrideToken, theme)=>{
    const derivativeToken = theme.getDerivativeToken(originToken);
    const { override: override, ...components } = overrideToken;
    // Merge with override
    let mergedDerivativeToken = {
        ...derivativeToken,
        override: override
    };
    // Format if needed
    mergedDerivativeToken = (0, $363bcafc7b9db979$export$2e2bcd8739ae039)(mergedDerivativeToken);
    if (components) Object.entries(components).forEach(([key, value])=>{
        const { theme: componentTheme, ...componentTokens } = value;
        let mergedComponentToken = componentTokens;
        if (componentTheme) mergedComponentToken = $9481722d146bd166$export$18602cb46ae80b62({
            ...mergedDerivativeToken,
            ...componentTokens
        }, {
            override: componentTokens
        }, componentTheme);
        mergedDerivativeToken[key] = mergedComponentToken;
    });
    return mergedDerivativeToken;
};
function $9481722d146bd166$export$2e2bcd8739ae039() {
    const { token: rootDesignToken, hashed: hashed, theme: theme, override: override, cssVar: ctxCssVar, zeroRuntime: zeroRuntime } = (0, $N3oW3.default).useContext((0, $a70f9f31ea093dd1$export$69b0ebb9efcddb30));
    const cssVar = {
        prefix: ctxCssVar?.prefix || 'ant',
        key: ctxCssVar?.key || 'css-var-root'
    };
    const salt = `${(0, $e4e1a4695f179bcc$export$2e2bcd8739ae039)}-${hashed || ''}`;
    const mergedTheme = theme || (0, $a13b22c41a7bf0da$export$2e2bcd8739ae039);
    const [token, hashId, realToken] = (0, $3ec6f7f6664c21fe$export$2e2bcd8739ae039)(mergedTheme, [
        (0, $08c67dd9815325ec$export$2e2bcd8739ae039),
        rootDesignToken
    ], {
        salt: salt,
        override: override,
        getComputedToken: $9481722d146bd166$export$18602cb46ae80b62,
        cssVar: {
            ...cssVar,
            unitless: $9481722d146bd166$export$c6b9faa6b723d31a,
            ignore: $9481722d146bd166$export$738b109e247a462c,
            preserve: $9481722d146bd166$var$preserve
        }
    });
    return [
        mergedTheme,
        realToken,
        hashed ? hashId : '',
        token,
        cssVar,
        !!zeroRuntime
    ];
}


"use client";
const $fb4e004daead3599$var$MotionCacheContext = /*#__PURE__*/ $hO8yS.createContext(true);
function $fb4e004daead3599$export$2e2bcd8739ae039(props) {
    const parentMotion = $32rMB.useContext($fb4e004daead3599$var$MotionCacheContext);
    const { children: children } = props;
    const [, token] = (0, $9481722d146bd166$export$2e2bcd8739ae039)();
    const { motion: motion } = token;
    const needWrapMotionProviderRef = $32rMB.useRef(false);
    needWrapMotionProviderRef.current || (needWrapMotionProviderRef.current = parentMotion !== motion);
    if (needWrapMotionProviderRef.current) return /*#__PURE__*/ $hO8yS.createElement($fb4e004daead3599$var$MotionCacheContext.Provider, {
        value: motion
    }, /*#__PURE__*/ $hO8yS.createElement((0, $d83990e2d9a86041$export$2e2bcd8739ae039), {
        motion: motion
    }, children));
    return children;
}



var $N3oW3 = parcelRequire("N3oW3");

"use client";
/**
 * Warning for ConfigProviderProps.
 * This will be empty function in production.
 */ const $4337621e885a2da5$var$PropWarning = /*#__PURE__*/ $N3oW3.memo(({ dropdownMatchSelectWidth: dropdownMatchSelectWidth })=>{
    const warning = (0, $d41680c8243eac18$export$cf977aa92c751e61)('ConfigProvider');
    warning.deprecated(dropdownMatchSelectWidth === undefined, 'dropdownMatchSelectWidth', 'popupMatchSelectWidth');
    return null;
});
var $4337621e885a2da5$export$2e2bcd8739ae039 = ()=>null;





"use client";
const $2f353af2b0f7600b$export$b2b65df0d0824629 = {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
};
const $2f353af2b0f7600b$export$23997c3e44cc1c59 = (token, needInheritFontFamily = false)=>({
        boxSizing: 'border-box',
        margin: 0,
        padding: 0,
        color: token.colorText,
        fontSize: token.fontSize,
        // font-variant: @font-variant-base;
        lineHeight: token.lineHeight,
        listStyle: 'none',
        // font-feature-settings: @font-feature-settings-base;
        fontFamily: needInheritFontFamily ? 'inherit' : token.fontFamily
    });
const $2f353af2b0f7600b$export$171ccda7bc085e59 = ()=>({
        display: 'inline-flex',
        alignItems: 'center',
        color: 'inherit',
        fontStyle: 'normal',
        lineHeight: 0,
        textAlign: 'center',
        textTransform: 'none',
        // for SVG icon, see https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4
        verticalAlign: '-0.125em',
        textRendering: 'optimizeLegibility',
        '-webkit-font-smoothing': 'antialiased',
        '-moz-osx-font-smoothing': 'grayscale',
        '> *': {
            lineHeight: 1
        },
        svg: {
            display: 'inline-block'
        }
    });
const $2f353af2b0f7600b$export$8c467e8859fdef13 = ()=>({
        // https://github.com/ant-design/ant-design/issues/21301#issuecomment-583955229
        '&::before': {
            display: 'table',
            content: '""'
        },
        '&::after': {
            // https://github.com/ant-design/ant-design/issues/21864
            display: 'table',
            clear: 'both',
            content: '""'
        }
    });
const $2f353af2b0f7600b$export$905d771977096614 = (token)=>({
        a: {
            color: token.colorLink,
            textDecoration: token.linkDecoration,
            backgroundColor: 'transparent',
            // remove the gray background on active links in IE 10.
            outline: 'none',
            cursor: 'pointer',
            transition: `color ${token.motionDurationSlow}`,
            '-webkit-text-decoration-skip': 'objects',
            // remove gaps in links underline in iOS 8+ and Safari 8+.
            '&:hover': {
                color: token.colorLinkHover
            },
            '&:active': {
                color: token.colorLinkActive
            },
            '&:active, &:hover': {
                textDecoration: token.linkHoverDecoration,
                outline: 0
            },
            // https://github.com/ant-design/ant-design/issues/22503
            '&:focus': {
                textDecoration: token.linkFocusDecoration,
                outline: 0
            },
            '&[disabled]': {
                color: token.colorTextDisabled,
                cursor: 'not-allowed'
            }
        }
    });
const $2f353af2b0f7600b$export$689382c111559cd9 = (token, componentPrefixCls, rootCls, resetFont)=>{
    const prefixSelector = `[class^="${componentPrefixCls}"], [class*=" ${componentPrefixCls}"]`;
    const rootPrefixSelector = rootCls ? `.${rootCls}` : prefixSelector;
    const resetStyle = {
        boxSizing: 'border-box',
        '&::before, &::after': {
            boxSizing: 'border-box'
        }
    };
    let resetFontStyle = {};
    if (resetFont !== false) resetFontStyle = {
        fontFamily: token.fontFamily,
        fontSize: token.fontSize
    };
    return {
        [rootPrefixSelector]: {
            ...resetFontStyle,
            ...resetStyle,
            [prefixSelector]: resetStyle
        }
    };
};
const $2f353af2b0f7600b$export$6539948f0a737e39 = (token, offset)=>({
        outline: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.lineWidthFocus)} solid ${token.colorPrimaryBorder}`,
        outlineOffset: offset ?? 1,
        transition: 'outline-offset 0s, outline 0s'
    });
const $2f353af2b0f7600b$export$a44db842bcb28231 = (token, offset)=>({
        '&:focus-visible': $2f353af2b0f7600b$export$6539948f0a737e39(token, offset)
    });
const $2f353af2b0f7600b$export$f1a0b31dfb234e7e = (iconPrefixCls)=>({
        [`.${iconPrefixCls}`]: {
            ...$2f353af2b0f7600b$export$171ccda7bc085e59(),
            [`.${iconPrefixCls} .${iconPrefixCls}-icon`]: {
                display: 'block'
            }
        }
    });
const $2f353af2b0f7600b$export$9a16e7694a707ab4 = (token)=>({
        // FIXME: This use link but is a operation unit. Seems should be a colorPrimary.
        // And Typography use this to generate link style which should not do this.
        color: token.colorLink,
        textDecoration: token.linkDecoration,
        outline: 'none',
        cursor: 'pointer',
        transition: `all ${token.motionDurationSlow}`,
        border: 0,
        padding: 0,
        background: 'none',
        userSelect: 'none',
        ...$2f353af2b0f7600b$export$a44db842bcb28231(token),
        '&:hover': {
            color: token.colorLinkHover,
            textDecoration: token.linkHoverDecoration
        },
        '&:focus': {
            color: token.colorLinkHover,
            textDecoration: token.linkFocusDecoration
        },
        '&:active': {
            color: token.colorLinkActive,
            textDecoration: token.linkHoverDecoration
        }
    });



const $7d19cd7c7c11d64a$var$useResetIconStyle = (iconPrefixCls, csp)=>{
    const [theme, token] = (0, $9481722d146bd166$export$2e2bcd8739ae039)();
    // Generate style for icons
    return (0, $b7e482f3ef1994cd$export$2e2bcd8739ae039)({
        theme: theme,
        token: token,
        hashId: '',
        path: [
            'ant-design-icons',
            iconPrefixCls
        ],
        nonce: ()=>csp?.nonce,
        layer: {
            name: 'antd'
        }
    }, ()=>(0, $2f353af2b0f7600b$export$f1a0b31dfb234e7e)(iconPrefixCls));
};
var $7d19cd7c7c11d64a$export$2e2bcd8739ae039 = $7d19cd7c7c11d64a$var$useResetIconStyle;


"use client";
/**
 * Since too many feedback using static method like `Modal.confirm` not getting theme, we record the
 * theme register info here to help developer get warning info.
 */ let $6ff80b51bd11b92e$var$existThemeConfig = false;
const $6ff80b51bd11b92e$export$7c4f6da0f9434a77 = /* istanbul ignore next */ null;
const $6ff80b51bd11b92e$export$e7f14a745e5c386a = [
    'getTargetContainer',
    'getPopupContainer',
    'rootPrefixCls',
    'getPrefixCls',
    'renderEmpty',
    'csp',
    'autoInsertSpaceInButton',
    'locale'
];
// These props is used by `useContext` directly in sub component
const $6ff80b51bd11b92e$var$PASSED_PROPS = [
    'getTargetContainer',
    'getPopupContainer',
    'renderEmpty',
    'input',
    'pagination',
    'form',
    'select',
    'button'
];
let $6ff80b51bd11b92e$var$globalPrefixCls;
let $6ff80b51bd11b92e$var$globalIconPrefixCls;
let $6ff80b51bd11b92e$var$globalTheme;
let $6ff80b51bd11b92e$var$globalHolderRender;
function $6ff80b51bd11b92e$var$getGlobalPrefixCls() {
    return $6ff80b51bd11b92e$var$globalPrefixCls || (0, $dd01e2f5a4b8605d$export$e4ec87ea71f29b41);
}
function $6ff80b51bd11b92e$var$getGlobalIconPrefixCls() {
    return $6ff80b51bd11b92e$var$globalIconPrefixCls || (0, $dd01e2f5a4b8605d$export$eaca8ee5ed21b4e9);
}
const $6ff80b51bd11b92e$var$setGlobalConfig = (props)=>{
    const { prefixCls: prefixCls, iconPrefixCls: iconPrefixCls, theme: theme, holderRender: holderRender } = props;
    if (prefixCls !== undefined) $6ff80b51bd11b92e$var$globalPrefixCls = prefixCls;
    if (iconPrefixCls !== undefined) $6ff80b51bd11b92e$var$globalIconPrefixCls = iconPrefixCls;
    if ('holderRender' in props) $6ff80b51bd11b92e$var$globalHolderRender = holderRender;
    if (theme) $6ff80b51bd11b92e$var$globalTheme = theme;
};
const $6ff80b51bd11b92e$export$f9cd1e43211d8a4a = ()=>({
        getPrefixCls: (suffixCls, customizePrefixCls)=>{
            if (customizePrefixCls) return customizePrefixCls;
            return suffixCls ? `${$6ff80b51bd11b92e$var$getGlobalPrefixCls()}-${suffixCls}` : $6ff80b51bd11b92e$var$getGlobalPrefixCls();
        },
        getIconPrefixCls: $6ff80b51bd11b92e$var$getGlobalIconPrefixCls,
        getRootPrefixCls: ()=>{
            // If Global prefixCls provided, use this
            if ($6ff80b51bd11b92e$var$globalPrefixCls) return $6ff80b51bd11b92e$var$globalPrefixCls;
            // Fallback to default prefixCls
            return $6ff80b51bd11b92e$var$getGlobalPrefixCls();
        },
        getTheme: ()=>$6ff80b51bd11b92e$var$globalTheme,
        holderRender: $6ff80b51bd11b92e$var$globalHolderRender
    });
const $6ff80b51bd11b92e$var$ProviderChildren = (props)=>{
    const { children: children, csp: customCsp, autoInsertSpaceInButton: autoInsertSpaceInButton, alert: alert, affix: affix, anchor: anchor, form: form, locale: locale, componentSize: componentSize, direction: direction, space: space, splitter: splitter, virtual: virtual, dropdownMatchSelectWidth: dropdownMatchSelectWidth, popupMatchSelectWidth: popupMatchSelectWidth, popupOverflow: popupOverflow, legacyLocale: legacyLocale, parentContext: parentContext, iconPrefixCls: customIconPrefixCls, theme: theme, componentDisabled: componentDisabled, segmented: segmented, statistic: statistic, spin: spin, calendar: calendar, carousel: carousel, cascader: cascader, collapse: collapse, typography: typography, checkbox: checkbox, descriptions: descriptions, divider: divider, drawer: drawer, skeleton: skeleton, steps: steps, image: image, layout: layout, list: list, mentions: mentions, modal: modal, progress: progress, result: result, slider: slider, breadcrumb: breadcrumb, masonry: masonry, menu: menu, pagination: pagination, input: input, textArea: textArea, otp: otp, empty: empty, badge: badge, radio: radio, rate: rate, ribbon: ribbon, switch: SWITCH, transfer: transfer, avatar: avatar, message: message, tag: tag, table: table, card: card, cardMeta: cardMeta, tabs: tabs, timeline: timeline, timePicker: timePicker, upload: upload, notification: notification, tree: tree, colorPicker: colorPicker, datePicker: datePicker, rangePicker: rangePicker, flex: flex, wave: wave, dropdown: dropdown, warning: warningConfig, tour: tour, tooltip: tooltip, popover: popover, popconfirm: popconfirm, qrcode: qrcode, floatButton: floatButton, floatButtonGroup: floatButtonGroup, variant: variant, inputNumber: inputNumber, treeSelect: treeSelect, watermark: watermark } = props;
    // =================================== Context ===================================
    const getPrefixCls = $32rMB.useCallback((suffixCls, customizePrefixCls)=>{
        const { prefixCls: prefixCls } = props;
        if (customizePrefixCls) return customizePrefixCls;
        const mergedPrefixCls = prefixCls || parentContext.getPrefixCls('');
        return suffixCls ? `${mergedPrefixCls}-${suffixCls}` : mergedPrefixCls;
    }, [
        parentContext.getPrefixCls,
        props.prefixCls
    ]);
    const iconPrefixCls = customIconPrefixCls || parentContext.iconPrefixCls || (0, $dd01e2f5a4b8605d$export$eaca8ee5ed21b4e9);
    const csp = customCsp || parentContext.csp;
    (0, $7d19cd7c7c11d64a$export$2e2bcd8739ae039)(iconPrefixCls, csp);
    const mergedTheme = (0, $60819677badfb604$export$2e2bcd8739ae039)(theme, parentContext.theme, {
        prefixCls: getPrefixCls('')
    });
    const baseConfig = {
        csp: csp,
        autoInsertSpaceInButton: autoInsertSpaceInButton,
        alert: alert,
        affix: affix,
        anchor: anchor,
        locale: locale || legacyLocale,
        direction: direction,
        space: space,
        splitter: splitter,
        virtual: virtual,
        popupMatchSelectWidth: popupMatchSelectWidth ?? dropdownMatchSelectWidth,
        popupOverflow: popupOverflow,
        getPrefixCls: getPrefixCls,
        iconPrefixCls: iconPrefixCls,
        theme: mergedTheme,
        segmented: segmented,
        statistic: statistic,
        spin: spin,
        calendar: calendar,
        carousel: carousel,
        cascader: cascader,
        collapse: collapse,
        typography: typography,
        checkbox: checkbox,
        descriptions: descriptions,
        divider: divider,
        drawer: drawer,
        skeleton: skeleton,
        steps: steps,
        image: image,
        input: input,
        textArea: textArea,
        otp: otp,
        layout: layout,
        list: list,
        mentions: mentions,
        modal: modal,
        progress: progress,
        result: result,
        slider: slider,
        breadcrumb: breadcrumb,
        masonry: masonry,
        menu: menu,
        pagination: pagination,
        empty: empty,
        badge: badge,
        radio: radio,
        rate: rate,
        ribbon: ribbon,
        switch: SWITCH,
        transfer: transfer,
        avatar: avatar,
        message: message,
        tag: tag,
        table: table,
        card: card,
        cardMeta: cardMeta,
        tabs: tabs,
        timeline: timeline,
        timePicker: timePicker,
        upload: upload,
        notification: notification,
        tree: tree,
        colorPicker: colorPicker,
        datePicker: datePicker,
        rangePicker: rangePicker,
        flex: flex,
        wave: wave,
        dropdown: dropdown,
        warning: warningConfig,
        tour: tour,
        tooltip: tooltip,
        popover: popover,
        popconfirm: popconfirm,
        qrcode: qrcode,
        floatButton: floatButton,
        floatButtonGroup: floatButtonGroup,
        variant: variant,
        inputNumber: inputNumber,
        treeSelect: treeSelect,
        watermark: watermark
    };
    const config = {
        ...parentContext
    };
    Object.keys(baseConfig).forEach((key)=>{
        if (baseConfig[key] !== undefined) config[key] = baseConfig[key];
    });
    // Pass the props used by `useContext` directly with child component.
    // These props should merged into `config`.
    $6ff80b51bd11b92e$var$PASSED_PROPS.forEach((propName)=>{
        const propValue = props[propName];
        if (propValue) config[propName] = propValue;
    });
    if (typeof autoInsertSpaceInButton !== 'undefined') // merge deprecated api
    config.button = {
        autoInsertSpace: autoInsertSpaceInButton,
        ...config.button
    };
    // https://github.com/ant-design/ant-design/issues/27617
    const memoedConfig = (0, $7b0442ce5e42625c$export$2e2bcd8739ae039)(()=>config, config, (prevConfig, currentConfig)=>{
        const prevKeys = Object.keys(prevConfig);
        const currentKeys = Object.keys(currentConfig);
        return prevKeys.length !== currentKeys.length || prevKeys.some((key)=>prevConfig[key] !== currentConfig[key]);
    });
    const { layer: layer } = $32rMB.useContext((0, $c756b57cbfcd44a7$export$2e2bcd8739ae039));
    const memoIconContextValue = $32rMB.useMemo(()=>({
            prefixCls: iconPrefixCls,
            csp: csp,
            layer: layer ? 'antd' : undefined
        }), [
        iconPrefixCls,
        csp,
        layer
    ]);
    let childNode = /*#__PURE__*/ $hO8yS.createElement($hO8yS.Fragment, null, /*#__PURE__*/ $hO8yS.createElement((0, $4337621e885a2da5$export$2e2bcd8739ae039), {
        dropdownMatchSelectWidth: dropdownMatchSelectWidth
    }), children);
    const validateMessages = $32rMB.useMemo(()=>(0, $3d19a70b12f43514$export$4950aa0f605343fb)((0, $e154e9cb01eacc19$export$2e2bcd8739ae039).Form?.defaultValidateMessages || {}, memoedConfig.locale?.Form?.defaultValidateMessages || {}, memoedConfig.form?.validateMessages || {}, form?.validateMessages || {}), [
        memoedConfig,
        form?.validateMessages
    ]);
    if (Object.keys(validateMessages).length > 0) childNode = /*#__PURE__*/ $hO8yS.createElement((0, $731a8553e006c6d2$export$2e2bcd8739ae039).Provider, {
        value: validateMessages
    }, childNode);
    if (locale) childNode = /*#__PURE__*/ $hO8yS.createElement((0, $082d8b47c43a69cb$export$2e2bcd8739ae039), {
        locale: locale,
        _ANT_MARK__: (0, $082d8b47c43a69cb$export$b2f162cd5c15ea3e)
    }, childNode);
    if (iconPrefixCls || csp) childNode = /*#__PURE__*/ $hO8yS.createElement((0, $1b2cdad775203647$export$2e2bcd8739ae039).Provider, {
        value: memoIconContextValue
    }, childNode);
    if (componentSize) childNode = /*#__PURE__*/ $hO8yS.createElement((0, $4859819e58dda691$export$dbc92d89fabc8ebe), {
        size: componentSize
    }, childNode);
    // =================================== Motion ===================================
    childNode = /*#__PURE__*/ $hO8yS.createElement((0, $fb4e004daead3599$export$2e2bcd8739ae039), null, childNode);
    // ================================ Tooltip Unique ===============================
    if (tooltip?.unique) childNode = /*#__PURE__*/ $hO8yS.createElement((0, $280b6a0642f9eb46$export$2e2bcd8739ae039), null, childNode);
    // ================================ Dynamic theme ================================
    const memoTheme = $32rMB.useMemo(()=>{
        const { algorithm: algorithm, token: token, components: components, cssVar: cssVar, ...rest } = mergedTheme || {};
        const themeObj = algorithm && (!Array.isArray(algorithm) || algorithm.length > 0) ? (0, $6011ea73ba4026bc$export$2e2bcd8739ae039)(algorithm) : (0, $a13b22c41a7bf0da$export$2e2bcd8739ae039);
        const parsedComponents = {};
        Object.entries(components || {}).forEach(([componentName, componentToken])=>{
            const parsedToken = {
                ...componentToken
            };
            if ('algorithm' in parsedToken) {
                if (parsedToken.algorithm === true) parsedToken.theme = themeObj;
                else if (Array.isArray(parsedToken.algorithm) || typeof parsedToken.algorithm === 'function') parsedToken.theme = (0, $6011ea73ba4026bc$export$2e2bcd8739ae039)(parsedToken.algorithm);
                delete parsedToken.algorithm;
            }
            parsedComponents[componentName] = parsedToken;
        });
        const mergedToken = {
            ...(0, $08c67dd9815325ec$export$2e2bcd8739ae039),
            ...token
        };
        return {
            ...rest,
            theme: themeObj,
            token: mergedToken,
            components: parsedComponents,
            override: {
                override: mergedToken,
                ...parsedComponents
            },
            cssVar: cssVar
        };
    }, [
        mergedTheme
    ]);
    if (theme) childNode = /*#__PURE__*/ $hO8yS.createElement((0, $a70f9f31ea093dd1$export$69b0ebb9efcddb30).Provider, {
        value: memoTheme
    }, childNode);
    // ================================== Warning ===================================
    if (memoedConfig.warning) childNode = /*#__PURE__*/ $hO8yS.createElement((0, $d41680c8243eac18$export$11b88c75b33aa1fd).Provider, {
        value: memoedConfig.warning
    }, childNode);
    // =================================== Render ===================================
    if (componentDisabled !== undefined) childNode = /*#__PURE__*/ $hO8yS.createElement((0, $ff4b4ddbf52ed41f$export$6adb5f3b918b11bb), {
        disabled: componentDisabled
    }, childNode);
    return /*#__PURE__*/ $hO8yS.createElement((0, $dd01e2f5a4b8605d$export$a92f85ab3e9ad68b).Provider, {
        value: memoedConfig
    }, childNode);
};
const $6ff80b51bd11b92e$var$ConfigProvider = (props)=>{
    const context = $32rMB.useContext((0, $dd01e2f5a4b8605d$export$a92f85ab3e9ad68b));
    const antLocale = $32rMB.useContext((0, $f0cbc91673fbb933$export$2e2bcd8739ae039));
    return /*#__PURE__*/ $hO8yS.createElement($6ff80b51bd11b92e$var$ProviderChildren, {
        parentContext: context,
        legacyLocale: antLocale,
        ...props
    });
};
$6ff80b51bd11b92e$var$ConfigProvider.ConfigContext = (0, $dd01e2f5a4b8605d$export$a92f85ab3e9ad68b);
$6ff80b51bd11b92e$var$ConfigProvider.SizeContext = (0, $4859819e58dda691$export$2e2bcd8739ae039);
$6ff80b51bd11b92e$var$ConfigProvider.config = $6ff80b51bd11b92e$var$setGlobalConfig;
$6ff80b51bd11b92e$var$ConfigProvider.useConfig = (0, $2801c1fd656defdd$export$2e2bcd8739ae039);
Object.defineProperty($6ff80b51bd11b92e$var$ConfigProvider, 'SizeContext', {
    get: ()=>{
        return 0, $4859819e58dda691$export$2e2bcd8739ae039;
    }
});
var $6ff80b51bd11b92e$export$2e2bcd8739ae039 = $6ff80b51bd11b92e$var$ConfigProvider;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
// This icon file is generated automatically.
var $29b42a28b91e63b3$var$CheckCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z"
                }
            }
        ]
    },
    "name": "check-circle",
    "theme": "filled"
};
var $29b42a28b91e63b3$export$2e2bcd8739ae039 = $29b42a28b91e63b3$var$CheckCircleFilled;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");



parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");





var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");

function $296ec13ef61c8fd9$var$camelCase(input) {
    return input.replace(/-(.)/g, (match, g)=>g.toUpperCase());
}
function $296ec13ef61c8fd9$export$491112666e282270(valid, message) {
    (0, $6591254ed6bd1058$export$82934adf09101657)(valid, `[@ant-design/icons] ${message}`);
}
function $296ec13ef61c8fd9$export$ab652842c37578f4(target) {
    return typeof target === 'object' && typeof target.name === 'string' && typeof target.theme === 'string' && (typeof target.icon === 'object' || typeof target.icon === 'function');
}
function $296ec13ef61c8fd9$export$9f5073e7201cc21c(attrs = {}) {
    return Object.keys(attrs).reduce((acc, key)=>{
        const val = attrs[key];
        switch(key){
            case 'class':
                acc.className = val;
                delete acc.class;
                break;
            default:
                delete acc[key];
                acc[$296ec13ef61c8fd9$var$camelCase(key)] = val;
        }
        return acc;
    }, {});
}
function $296ec13ef61c8fd9$export$80d376111cc09ad7(node, key, rootProps) {
    if (!rootProps) return /*#__PURE__*/ (0, $N3oW3.default).createElement(node.tag, {
        key: key,
        ...$296ec13ef61c8fd9$export$9f5073e7201cc21c(node.attrs)
    }, (node.children || []).map((child, index)=>$296ec13ef61c8fd9$export$80d376111cc09ad7(child, `${key}-${node.tag}-${index}`)));
    return /*#__PURE__*/ (0, $N3oW3.default).createElement(node.tag, {
        key: key,
        ...$296ec13ef61c8fd9$export$9f5073e7201cc21c(node.attrs),
        ...rootProps
    }, (node.children || []).map((child, index)=>$296ec13ef61c8fd9$export$80d376111cc09ad7(child, `${key}-${node.tag}-${index}`)));
}
function $296ec13ef61c8fd9$export$b71c93f469694483(primaryColor) {
    // choose the second color
    return (0, $6a46fec5a09f66be$export$2e2bcd8739ae039)(primaryColor)[0];
}
function $296ec13ef61c8fd9$export$b5b464c3d8433a9b(twoToneColor) {
    if (!twoToneColor) return [];
    return Array.isArray(twoToneColor) ? twoToneColor : [
        twoToneColor
    ];
}
const $296ec13ef61c8fd9$export$960a899a9cccb2d5 = {
    width: '1em',
    height: '1em',
    fill: 'currentColor',
    'aria-hidden': 'true',
    focusable: 'false'
};
const $296ec13ef61c8fd9$export$2c99b98b77550cb4 = `
.anticon {
  display: inline-flex;
  align-items: center;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.anticon > * {
  line-height: 1;
}

.anticon svg {
  display: inline-block;
  vertical-align: inherit;
}

.anticon::before {
  display: none;
}

.anticon .anticon-icon {
  display: block;
}

.anticon[tabindex] {
  cursor: pointer;
}

.anticon-spin::before,
.anticon-spin {
  display: inline-block;
  -webkit-animation: loadingCircle 1s infinite linear;
  animation: loadingCircle 1s infinite linear;
}

@-webkit-keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
`;
const $296ec13ef61c8fd9$export$938b1f86b61613d0 = (eleRef)=>{
    const { csp: csp, prefixCls: prefixCls, layer: layer } = (0, $32rMB.useContext)((0, $1b2cdad775203647$export$2e2bcd8739ae039));
    let mergedStyleStr = $296ec13ef61c8fd9$export$2c99b98b77550cb4;
    if (prefixCls) mergedStyleStr = mergedStyleStr.replace(/anticon/g, prefixCls);
    if (layer) mergedStyleStr = `@layer ${layer} {\n${mergedStyleStr}\n}`;
    (0, $32rMB.useEffect)(()=>{
        const ele = eleRef.current;
        const shadowRoot = (0, $66a153f87c091f0a$export$70e8259662bb498b)(ele);
        (0, $275621885d66fa13$export$4d99a2890bb989f0)(mergedStyleStr, '@ant-design-icons', {
            prepend: !layer,
            csp: csp,
            attachTo: shadowRoot
        });
    }, []);
};


const $44864dd0ecbd7479$var$twoToneColorPalette = {
    primaryColor: '#333',
    secondaryColor: '#E6E6E6',
    calculated: false
};
function $44864dd0ecbd7479$var$setTwoToneColors({ primaryColor: primaryColor, secondaryColor: secondaryColor }) {
    $44864dd0ecbd7479$var$twoToneColorPalette.primaryColor = primaryColor;
    $44864dd0ecbd7479$var$twoToneColorPalette.secondaryColor = secondaryColor || (0, $296ec13ef61c8fd9$export$b71c93f469694483)(primaryColor);
    $44864dd0ecbd7479$var$twoToneColorPalette.calculated = !!secondaryColor;
}
function $44864dd0ecbd7479$var$getTwoToneColors() {
    return {
        ...$44864dd0ecbd7479$var$twoToneColorPalette
    };
}
const $44864dd0ecbd7479$var$IconBase = (props)=>{
    const { icon: icon, className: className, onClick: onClick, style: style, primaryColor: primaryColor, secondaryColor: secondaryColor, ...restProps } = props;
    const svgRef = $32rMB.useRef(null);
    let colors = $44864dd0ecbd7479$var$twoToneColorPalette;
    if (primaryColor) colors = {
        primaryColor: primaryColor,
        secondaryColor: secondaryColor || (0, $296ec13ef61c8fd9$export$b71c93f469694483)(primaryColor)
    };
    (0, $296ec13ef61c8fd9$export$938b1f86b61613d0)(svgRef);
    (0, $296ec13ef61c8fd9$export$491112666e282270)((0, $296ec13ef61c8fd9$export$ab652842c37578f4)(icon), `icon should be icon definiton, but got ${icon}`);
    if (!(0, $296ec13ef61c8fd9$export$ab652842c37578f4)(icon)) return null;
    let target = icon;
    if (target && typeof target.icon === 'function') target = {
        ...target,
        icon: target.icon(colors.primaryColor, colors.secondaryColor)
    };
    return (0, $296ec13ef61c8fd9$export$80d376111cc09ad7)(target.icon, `svg-${target.name}`, {
        className: className,
        onClick: onClick,
        style: style,
        'data-icon': target.name,
        width: '1em',
        height: '1em',
        fill: 'currentColor',
        'aria-hidden': 'true',
        ...restProps,
        ref: svgRef
    });
};
$44864dd0ecbd7479$var$IconBase.displayName = 'IconReact';
$44864dd0ecbd7479$var$IconBase.getTwoToneColors = $44864dd0ecbd7479$var$getTwoToneColors;
$44864dd0ecbd7479$var$IconBase.setTwoToneColors = $44864dd0ecbd7479$var$setTwoToneColors;
var $44864dd0ecbd7479$export$2e2bcd8739ae039 = $44864dd0ecbd7479$var$IconBase;




function $5cf24bc964e12e42$export$8a145f34580ff02b(twoToneColor) {
    const [primaryColor, secondaryColor] = (0, $296ec13ef61c8fd9$export$b5b464c3d8433a9b)(twoToneColor);
    return (0, $44864dd0ecbd7479$export$2e2bcd8739ae039).setTwoToneColors({
        primaryColor: primaryColor,
        secondaryColor: secondaryColor
    });
}
function $5cf24bc964e12e42$export$abc7c554784cb4a7() {
    const colors = (0, $44864dd0ecbd7479$export$2e2bcd8739ae039).getTwoToneColors();
    if (!colors.calculated) return colors.primaryColor;
    return [
        colors.primaryColor,
        colors.secondaryColor
    ];
}



'use client';
function $5fd6f3f3c400c267$var$_extends() {
    $5fd6f3f3c400c267$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5fd6f3f3c400c267$var$_extends.apply(this, arguments);
}
// Initial setting
// should move it to antd main repo?
(0, $5cf24bc964e12e42$export$8a145f34580ff02b)((0, $346125f9ce2d0a1f$export$2aa0182783e7e9de).primary);
// https://github.com/DefinitelyTyped/DefinitelyTyped/issues/34757#issuecomment-488848720
const $5fd6f3f3c400c267$var$Icon = /*#__PURE__*/ $N3oW3.forwardRef((props, ref)=>{
    const { className: // affect outter <i>...</i>
    className, icon: // affect inner <svg>...</svg>
    icon, spin: spin, rotate: rotate, tabIndex: tabIndex, onClick: onClick, twoToneColor: // other
    twoToneColor, ...restProps } = props;
    const { prefixCls: prefixCls = 'anticon', rootClassName: rootClassName } = $32rMB.useContext((0, $1b2cdad775203647$export$2e2bcd8739ae039));
    const classString = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(rootClassName, prefixCls, {
        [`${prefixCls}-${icon.name}`]: !!icon.name,
        [`${prefixCls}-spin`]: !!spin || icon.name === 'loading'
    }, className);
    let iconTabIndex = tabIndex;
    if (iconTabIndex === undefined && onClick) iconTabIndex = -1;
    const svgStyle = rotate ? {
        msTransform: `rotate(${rotate}deg)`,
        transform: `rotate(${rotate}deg)`
    } : undefined;
    const [primaryColor, secondaryColor] = (0, $296ec13ef61c8fd9$export$b5b464c3d8433a9b)(twoToneColor);
    return /*#__PURE__*/ $hO8yS.createElement("span", $5fd6f3f3c400c267$var$_extends({
        role: "img",
        "aria-label": icon.name
    }, restProps, {
        ref: ref,
        tabIndex: iconTabIndex,
        onClick: onClick,
        className: classString
    }), /*#__PURE__*/ $hO8yS.createElement((0, $44864dd0ecbd7479$export$2e2bcd8739ae039), {
        icon: icon,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        style: svgStyle
    }));
});
$5fd6f3f3c400c267$var$Icon.getTwoToneColor = (0, $5cf24bc964e12e42$export$abc7c554784cb4a7);
$5fd6f3f3c400c267$var$Icon.setTwoToneColor = (0, $5cf24bc964e12e42$export$8a145f34580ff02b);
var $5fd6f3f3c400c267$export$2e2bcd8739ae039 = $5fd6f3f3c400c267$var$Icon;


function $1aa4ade09bf83f85$var$_extends() {
    $1aa4ade09bf83f85$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1aa4ade09bf83f85$var$_extends.apply(this, arguments);
}
const $1aa4ade09bf83f85$var$CheckCircleFilled = (props, ref)=>/*#__PURE__*/ $hO8yS.createElement((0, $5fd6f3f3c400c267$export$2e2bcd8739ae039), $1aa4ade09bf83f85$var$_extends({}, props, {
        ref: ref,
        icon: (0, $29b42a28b91e63b3$export$2e2bcd8739ae039)
    }));
/**![check-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0xOTMuNSAzMDEuN2wtMjEwLjYgMjkyYTMxLjggMzEuOCAwIDAxLTUxLjcgMEwzMTguNSA0ODQuOWMtMy44LTUuMyAwLTEyLjcgNi41LTEyLjdoNDYuOWMxMC4yIDAgMTkuOSA0LjkgMjUuOSAxMy4zbDcxLjIgOTguOCAxNTcuMi0yMThjNi04LjMgMTUuNi0xMy4zIDI1LjktMTMuM0g2OTljNi41IDAgMTAuMyA3LjQgNi41IDEyLjd6IiAvPjwvc3ZnPg==) */ const $1aa4ade09bf83f85$var$RefIcon = /*#__PURE__*/ $N3oW3.forwardRef($1aa4ade09bf83f85$var$CheckCircleFilled);
var $1aa4ade09bf83f85$export$2e2bcd8739ae039 = $1aa4ade09bf83f85$var$RefIcon;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
// This icon file is generated automatically.
var $448f8bfdd003c852$var$CloseCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "fill-rule": "evenodd",
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm127.98 274.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 00-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 00-.05.09.12.12 0 000 .07v.02a.27.27 0 00.06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 000 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 00.09.05.12.12 0 00.07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 00.07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 00.05-.09.12.12 0 000-.07v-.02a.27.27 0 00-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 000-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 00-.09-.05.12.12 0 00-.07 0z"
                }
            }
        ]
    },
    "name": "close-circle",
    "theme": "filled"
};
var $448f8bfdd003c852$export$2e2bcd8739ae039 = $448f8bfdd003c852$var$CloseCircleFilled;



function $88ed6189ad3742f6$var$_extends() {
    $88ed6189ad3742f6$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $88ed6189ad3742f6$var$_extends.apply(this, arguments);
}
const $88ed6189ad3742f6$var$CloseCircleFilled = (props, ref)=>/*#__PURE__*/ $hO8yS.createElement((0, $5fd6f3f3c400c267$export$2e2bcd8739ae039), $88ed6189ad3742f6$var$_extends({}, props, {
        ref: ref,
        icon: (0, $448f8bfdd003c852$export$2e2bcd8739ae039)
    }));
/**![close-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdmlld0JveD0iNjQgNjQgODk2IDg5NiIgZm9jdXNhYmxlPSJmYWxzZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNTEyIDY0YzI0Ny40IDAgNDQ4IDIwMC42IDQ0OCA0NDhTNzU5LjQgOTYwIDUxMiA5NjAgNjQgNzU5LjQgNjQgNTEyIDI2NC42IDY0IDUxMiA2NHptMTI3Ljk4IDI3NC44MmgtLjA0bC0uMDguMDZMNTEyIDQ2Ni43NSAzODQuMTQgMzM4Ljg4Yy0uMDQtLjA1LS4wNi0uMDYtLjA4LS4wNmEuMTIuMTIgMCAwMC0uMDcgMGMtLjAzIDAtLjA1LjAxLS4wOS4wNWwtNDUuMDIgNDUuMDJhLjIuMiAwIDAwLS4wNS4wOS4xMi4xMiAwIDAwMCAuMDd2LjAyYS4yNy4yNyAwIDAwLjA2LjA2TDQ2Ni43NSA1MTIgMzM4Ljg4IDYzOS44NmMtLjA1LjA0LS4wNi4wNi0uMDYuMDhhLjEyLjEyIDAgMDAwIC4wN2MwIC4wMy4wMS4wNS4wNS4wOWw0NS4wMiA0NS4wMmEuMi4yIDAgMDAuMDkuMDUuMTIuMTIgMCAwMC4wNyAwYy4wMiAwIC4wNC0uMDEuMDgtLjA1TDUxMiA1NTcuMjVsMTI3Ljg2IDEyNy44N2MuMDQuMDQuMDYuMDUuMDguMDVhLjEyLjEyIDAgMDAuMDcgMGMuMDMgMCAuMDUtLjAxLjA5LS4wNWw0NS4wMi00NS4wMmEuMi4yIDAgMDAuMDUtLjA5LjEyLjEyIDAgMDAwLS4wN3YtLjAyYS4yNy4yNyAwIDAwLS4wNS0uMDZMNTU3LjI1IDUxMmwxMjcuODctMTI3Ljg2Yy4wNC0uMDQuMDUtLjA2LjA1LS4wOGEuMTIuMTIgMCAwMDAtLjA3YzAtLjAzLS4wMS0uMDUtLjA1LS4wOWwtNDUuMDItNDUuMDJhLjIuMiAwIDAwLS4wOS0uMDUuMTIuMTIgMCAwMC0uMDcgMHoiIC8+PC9zdmc+) */ const $88ed6189ad3742f6$var$RefIcon = /*#__PURE__*/ $N3oW3.forwardRef($88ed6189ad3742f6$var$CloseCircleFilled);
var $88ed6189ad3742f6$export$2e2bcd8739ae039 = $88ed6189ad3742f6$var$RefIcon;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
// This icon file is generated automatically.
var $94108feffe355581$var$ExclamationCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z"
                }
            }
        ]
    },
    "name": "exclamation-circle",
    "theme": "filled"
};
var $94108feffe355581$export$2e2bcd8739ae039 = $94108feffe355581$var$ExclamationCircleFilled;



function $eec2491bdf124fc8$var$_extends() {
    $eec2491bdf124fc8$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $eec2491bdf124fc8$var$_extends.apply(this, arguments);
}
const $eec2491bdf124fc8$var$ExclamationCircleFilled = (props, ref)=>/*#__PURE__*/ $hO8yS.createElement((0, $5fd6f3f3c400c267$export$2e2bcd8739ae039), $eec2491bdf124fc8$var$_extends({}, props, {
        ref: ref,
        icon: (0, $94108feffe355581$export$2e2bcd8739ae039)
    }));
/**![exclamation-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0tMzIgMjMyYzAtNC40IDMuNi04IDgtOGg0OGM0LjQgMCA4IDMuNiA4IDh2MjcyYzAgNC40LTMuNiA4LTggOGgtNDhjLTQuNCAwLTgtMy42LTgtOFYyOTZ6bTMyIDQ0MGE0OC4wMSA0OC4wMSAwIDAxMC05NiA0OC4wMSA0OC4wMSAwIDAxMCA5NnoiIC8+PC9zdmc+) */ const $eec2491bdf124fc8$var$RefIcon = /*#__PURE__*/ $N3oW3.forwardRef($eec2491bdf124fc8$var$ExclamationCircleFilled);
var $eec2491bdf124fc8$export$2e2bcd8739ae039 = $eec2491bdf124fc8$var$RefIcon;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
// This icon file is generated automatically.
var $7166abb8ab1baeac$var$InfoCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z"
                }
            }
        ]
    },
    "name": "info-circle",
    "theme": "filled"
};
var $7166abb8ab1baeac$export$2e2bcd8739ae039 = $7166abb8ab1baeac$var$InfoCircleFilled;



function $59cfafa07a56daba$var$_extends() {
    $59cfafa07a56daba$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $59cfafa07a56daba$var$_extends.apply(this, arguments);
}
const $59cfafa07a56daba$var$InfoCircleFilled = (props, ref)=>/*#__PURE__*/ $hO8yS.createElement((0, $5fd6f3f3c400c267$export$2e2bcd8739ae039), $59cfafa07a56daba$var$_extends({}, props, {
        ref: ref,
        icon: (0, $7166abb8ab1baeac$export$2e2bcd8739ae039)
    }));
/**![info-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0zMiA2NjRjMCA0LjQtMy42IDgtOCA4aC00OGMtNC40IDAtOC0zLjYtOC04VjQ1NmMwLTQuNCAzLjYtOCA4LThoNDhjNC40IDAgOCAzLjYgOCA4djI3MnptLTMyLTM0NGE0OC4wMSA0OC4wMSAwIDAxMC05NiA0OC4wMSA0OC4wMSAwIDAxMCA5NnoiIC8+PC9zdmc+) */ const $59cfafa07a56daba$var$RefIcon = /*#__PURE__*/ $N3oW3.forwardRef($59cfafa07a56daba$var$InfoCircleFilled);
var $59cfafa07a56daba$export$2e2bcd8739ae039 = $59cfafa07a56daba$var$RefIcon;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
// This icon file is generated automatically.
var $251c4049929a9a92$var$LoadingOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"
                }
            }
        ]
    },
    "name": "loading",
    "theme": "outlined"
};
var $251c4049929a9a92$export$2e2bcd8739ae039 = $251c4049929a9a92$var$LoadingOutlined;



function $b7d605396d432b67$var$_extends() {
    $b7d605396d432b67$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b7d605396d432b67$var$_extends.apply(this, arguments);
}
const $b7d605396d432b67$var$LoadingOutlined = (props, ref)=>/*#__PURE__*/ $hO8yS.createElement((0, $5fd6f3f3c400c267$export$2e2bcd8739ae039), $b7d605396d432b67$var$_extends({}, props, {
        ref: ref,
        icon: (0, $251c4049929a9a92$export$2e2bcd8739ae039)
    }));
/**![loading](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTk4OCA1NDhjLTE5LjkgMC0zNi0xNi4xLTM2LTM2IDAtNTkuNC0xMS42LTExNy0zNC42LTE3MS4zYTQ0MC40NSA0NDAuNDUgMCAwMC05NC4zLTEzOS45IDQzNy43MSA0MzcuNzEgMCAwMC0xMzkuOS05NC4zQzYyOSA4My42IDU3MS40IDcyIDUxMiA3MmMtMTkuOSAwLTM2LTE2LjEtMzYtMzZzMTYuMS0zNiAzNi0zNmM2OS4xIDAgMTM2LjIgMTMuNSAxOTkuMyA0MC4zQzc3Mi4zIDY2IDgyNyAxMDMgODc0IDE1MGM0NyA0NyA4My45IDEwMS44IDEwOS43IDE2Mi43IDI2LjcgNjMuMSA0MC4yIDEzMC4yIDQwLjIgMTk5LjMuMSAxOS45LTE2IDM2LTM1LjkgMzZ6IiAvPjwvc3ZnPg==) */ const $b7d605396d432b67$var$RefIcon = /*#__PURE__*/ $N3oW3.forwardRef($b7d605396d432b67$var$LoadingOutlined);
var $b7d605396d432b67$export$2e2bcd8739ae039 = $b7d605396d432b67$var$RefIcon;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");
parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");

var $N3oW3 = parcelRequire("N3oW3");

var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");



/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */ const $4d7d870d585f8465$var$KeyCode = {
    /**
   * MAC_ENTER
   */ MAC_ENTER: 3,
    /**
   * BACKSPACE
   */ BACKSPACE: 8,
    /**
   * TAB
   */ TAB: 9,
    /**
   * NUMLOCK on FF/Safari Mac
   */ NUM_CENTER: 12,
    // NUMLOCK on FF/Safari Mac
    /**
   * ENTER
   */ ENTER: 13,
    /**
   * SHIFT
   */ SHIFT: 16,
    /**
   * CTRL
   */ CTRL: 17,
    /**
   * ALT
   */ ALT: 18,
    /**
   * PAUSE
   */ PAUSE: 19,
    /**
   * CAPS_LOCK
   */ CAPS_LOCK: 20,
    /**
   * ESC
   */ ESC: 27,
    /**
   * SPACE
   */ SPACE: 32,
    /**
   * PAGE_UP
   */ PAGE_UP: 33,
    // also NUM_NORTH_EAST
    /**
   * PAGE_DOWN
   */ PAGE_DOWN: 34,
    // also NUM_SOUTH_EAST
    /**
   * END
   */ END: 35,
    // also NUM_SOUTH_WEST
    /**
   * HOME
   */ HOME: 36,
    // also NUM_NORTH_WEST
    /**
   * LEFT
   */ LEFT: 37,
    // also NUM_WEST
    /**
   * UP
   */ UP: 38,
    // also NUM_NORTH
    /**
   * RIGHT
   */ RIGHT: 39,
    // also NUM_EAST
    /**
   * DOWN
   */ DOWN: 40,
    // also NUM_SOUTH
    /**
   * PRINT_SCREEN
   */ PRINT_SCREEN: 44,
    /**
   * INSERT
   */ INSERT: 45,
    // also NUM_INSERT
    /**
   * DELETE
   */ DELETE: 46,
    // also NUM_DELETE
    /**
   * ZERO
   */ ZERO: 48,
    /**
   * ONE
   */ ONE: 49,
    /**
   * TWO
   */ TWO: 50,
    /**
   * THREE
   */ THREE: 51,
    /**
   * FOUR
   */ FOUR: 52,
    /**
   * FIVE
   */ FIVE: 53,
    /**
   * SIX
   */ SIX: 54,
    /**
   * SEVEN
   */ SEVEN: 55,
    /**
   * EIGHT
   */ EIGHT: 56,
    /**
   * NINE
   */ NINE: 57,
    /**
   * QUESTION_MARK
   */ QUESTION_MARK: 63,
    // needs localization
    /**
   * A
   */ A: 65,
    /**
   * B
   */ B: 66,
    /**
   * C
   */ C: 67,
    /**
   * D
   */ D: 68,
    /**
   * E
   */ E: 69,
    /**
   * F
   */ F: 70,
    /**
   * G
   */ G: 71,
    /**
   * H
   */ H: 72,
    /**
   * I
   */ I: 73,
    /**
   * J
   */ J: 74,
    /**
   * K
   */ K: 75,
    /**
   * L
   */ L: 76,
    /**
   * M
   */ M: 77,
    /**
   * N
   */ N: 78,
    /**
   * O
   */ O: 79,
    /**
   * P
   */ P: 80,
    /**
   * Q
   */ Q: 81,
    /**
   * R
   */ R: 82,
    /**
   * S
   */ S: 83,
    /**
   * T
   */ T: 84,
    /**
   * U
   */ U: 85,
    /**
   * V
   */ V: 86,
    /**
   * W
   */ W: 87,
    /**
   * X
   */ X: 88,
    /**
   * Y
   */ Y: 89,
    /**
   * Z
   */ Z: 90,
    /**
   * META
   */ META: 91,
    // WIN_KEY_LEFT
    /**
   * WIN_KEY_RIGHT
   */ WIN_KEY_RIGHT: 92,
    /**
   * CONTEXT_MENU
   */ CONTEXT_MENU: 93,
    /**
   * NUM_ZERO
   */ NUM_ZERO: 96,
    /**
   * NUM_ONE
   */ NUM_ONE: 97,
    /**
   * NUM_TWO
   */ NUM_TWO: 98,
    /**
   * NUM_THREE
   */ NUM_THREE: 99,
    /**
   * NUM_FOUR
   */ NUM_FOUR: 100,
    /**
   * NUM_FIVE
   */ NUM_FIVE: 101,
    /**
   * NUM_SIX
   */ NUM_SIX: 102,
    /**
   * NUM_SEVEN
   */ NUM_SEVEN: 103,
    /**
   * NUM_EIGHT
   */ NUM_EIGHT: 104,
    /**
   * NUM_NINE
   */ NUM_NINE: 105,
    /**
   * NUM_MULTIPLY
   */ NUM_MULTIPLY: 106,
    /**
   * NUM_PLUS
   */ NUM_PLUS: 107,
    /**
   * NUM_MINUS
   */ NUM_MINUS: 109,
    /**
   * NUM_PERIOD
   */ NUM_PERIOD: 110,
    /**
   * NUM_DIVISION
   */ NUM_DIVISION: 111,
    /**
   * F1
   */ F1: 112,
    /**
   * F2
   */ F2: 113,
    /**
   * F3
   */ F3: 114,
    /**
   * F4
   */ F4: 115,
    /**
   * F5
   */ F5: 116,
    /**
   * F6
   */ F6: 117,
    /**
   * F7
   */ F7: 118,
    /**
   * F8
   */ F8: 119,
    /**
   * F9
   */ F9: 120,
    /**
   * F10
   */ F10: 121,
    /**
   * F11
   */ F11: 122,
    /**
   * F12
   */ F12: 123,
    /**
   * NUMLOCK
   */ NUMLOCK: 144,
    /**
   * SEMICOLON
   */ SEMICOLON: 186,
    // needs localization
    /**
   * DASH
   */ DASH: 189,
    // needs localization
    /**
   * EQUALS
   */ EQUALS: 187,
    // needs localization
    /**
   * COMMA
   */ COMMA: 188,
    // needs localization
    /**
   * PERIOD
   */ PERIOD: 190,
    // needs localization
    /**
   * SLASH
   */ SLASH: 191,
    // needs localization
    /**
   * APOSTROPHE
   */ APOSTROPHE: 192,
    // needs localization
    /**
   * SINGLE_QUOTE
   */ SINGLE_QUOTE: 222,
    // needs localization
    /**
   * OPEN_SQUARE_BRACKET
   */ OPEN_SQUARE_BRACKET: 219,
    // needs localization
    /**
   * BACKSLASH
   */ BACKSLASH: 220,
    // needs localization
    /**
   * CLOSE_SQUARE_BRACKET
   */ CLOSE_SQUARE_BRACKET: 221,
    // needs localization
    /**
   * WIN_KEY
   */ WIN_KEY: 224,
    /**
   * MAC_FF_META
   */ MAC_FF_META: 224,
    // Firefox (Gecko) fires this for the meta key instead of 91
    /**
   * WIN_IME
   */ WIN_IME: 229,
    // ======================== Function ========================
    /**
   * whether text and modified key is entered at the same time.
   */ isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
        const { keyCode: keyCode } = e;
        if (e.altKey && !e.ctrlKey || e.metaKey || // Function keys don't generate text
        keyCode >= $4d7d870d585f8465$var$KeyCode.F1 && keyCode <= $4d7d870d585f8465$var$KeyCode.F12) return false;
        // The following keys are quite harmless, even in combination with
        // CTRL, ALT or SHIFT.
        switch(keyCode){
            case $4d7d870d585f8465$var$KeyCode.ALT:
            case $4d7d870d585f8465$var$KeyCode.CAPS_LOCK:
            case $4d7d870d585f8465$var$KeyCode.CONTEXT_MENU:
            case $4d7d870d585f8465$var$KeyCode.CTRL:
            case $4d7d870d585f8465$var$KeyCode.DOWN:
            case $4d7d870d585f8465$var$KeyCode.END:
            case $4d7d870d585f8465$var$KeyCode.ESC:
            case $4d7d870d585f8465$var$KeyCode.HOME:
            case $4d7d870d585f8465$var$KeyCode.INSERT:
            case $4d7d870d585f8465$var$KeyCode.LEFT:
            case $4d7d870d585f8465$var$KeyCode.MAC_FF_META:
            case $4d7d870d585f8465$var$KeyCode.META:
            case $4d7d870d585f8465$var$KeyCode.NUMLOCK:
            case $4d7d870d585f8465$var$KeyCode.NUM_CENTER:
            case $4d7d870d585f8465$var$KeyCode.PAGE_DOWN:
            case $4d7d870d585f8465$var$KeyCode.PAGE_UP:
            case $4d7d870d585f8465$var$KeyCode.PAUSE:
            case $4d7d870d585f8465$var$KeyCode.PRINT_SCREEN:
            case $4d7d870d585f8465$var$KeyCode.RIGHT:
            case $4d7d870d585f8465$var$KeyCode.SHIFT:
            case $4d7d870d585f8465$var$KeyCode.UP:
            case $4d7d870d585f8465$var$KeyCode.WIN_KEY:
            case $4d7d870d585f8465$var$KeyCode.WIN_KEY_RIGHT:
                return false;
            default:
                return true;
        }
    },
    /**
   * whether character is entered.
   */ isCharacterKey: function isCharacterKey(keyCode) {
        if (keyCode >= $4d7d870d585f8465$var$KeyCode.ZERO && keyCode <= $4d7d870d585f8465$var$KeyCode.NINE) return true;
        if (keyCode >= $4d7d870d585f8465$var$KeyCode.NUM_ZERO && keyCode <= $4d7d870d585f8465$var$KeyCode.NUM_MULTIPLY) return true;
        if (keyCode >= $4d7d870d585f8465$var$KeyCode.A && keyCode <= $4d7d870d585f8465$var$KeyCode.Z) return true;
        // Safari sends zero key code for non-latin characters.
        if (window.navigator.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) return true;
        switch(keyCode){
            case $4d7d870d585f8465$var$KeyCode.SPACE:
            case $4d7d870d585f8465$var$KeyCode.QUESTION_MARK:
            case $4d7d870d585f8465$var$KeyCode.NUM_PLUS:
            case $4d7d870d585f8465$var$KeyCode.NUM_MINUS:
            case $4d7d870d585f8465$var$KeyCode.NUM_PERIOD:
            case $4d7d870d585f8465$var$KeyCode.NUM_DIVISION:
            case $4d7d870d585f8465$var$KeyCode.SEMICOLON:
            case $4d7d870d585f8465$var$KeyCode.DASH:
            case $4d7d870d585f8465$var$KeyCode.EQUALS:
            case $4d7d870d585f8465$var$KeyCode.COMMA:
            case $4d7d870d585f8465$var$KeyCode.PERIOD:
            case $4d7d870d585f8465$var$KeyCode.SLASH:
            case $4d7d870d585f8465$var$KeyCode.APOSTROPHE:
            case $4d7d870d585f8465$var$KeyCode.SINGLE_QUOTE:
            case $4d7d870d585f8465$var$KeyCode.OPEN_SQUARE_BRACKET:
            case $4d7d870d585f8465$var$KeyCode.BACKSLASH:
            case $4d7d870d585f8465$var$KeyCode.CLOSE_SQUARE_BRACKET:
                return true;
            default:
                return false;
        }
    }
};
var $4d7d870d585f8465$export$2e2bcd8739ae039 = $4d7d870d585f8465$var$KeyCode;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
const $b0f3dfd0eb3cad70$var$attributes = `accept acceptCharset accessKey action allowFullScreen allowTransparency
    alt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge
    charSet checked classID className colSpan cols content contentEditable contextMenu
    controls coords crossOrigin data dateTime default defer dir disabled download draggable
    encType form formAction formEncType formMethod formNoValidate formTarget frameBorder
    headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity
    is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media
    mediaGroup method min minLength multiple muted name noValidate nonce open
    optimum pattern placeholder poster preload radioGroup readOnly rel required
    reversed role rowSpan rows sandbox scope scoped scrolling seamless selected
    shape size sizes span spellCheck src srcDoc srcLang srcSet start step style
    summary tabIndex target title type useMap value width wmode wrap`;
const $b0f3dfd0eb3cad70$var$eventsName = `onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown
    onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onClick onContextMenu onDoubleClick
    onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown
    onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel
    onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough
    onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata
    onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onError`;
const $b0f3dfd0eb3cad70$var$propList = `${$b0f3dfd0eb3cad70$var$attributes} ${$b0f3dfd0eb3cad70$var$eventsName}`.split(/[\s\n]+/);
/* eslint-enable max-len */ const $b0f3dfd0eb3cad70$var$ariaPrefix = 'aria-';
const $b0f3dfd0eb3cad70$var$dataPrefix = 'data-';
function $b0f3dfd0eb3cad70$var$match(key, prefix) {
    return key.indexOf(prefix) === 0;
}
function $b0f3dfd0eb3cad70$export$2e2bcd8739ae039(props, ariaOnly = false) {
    let mergedConfig;
    if (ariaOnly === false) mergedConfig = {
        aria: true,
        data: true,
        attr: true
    };
    else if (ariaOnly === true) mergedConfig = {
        aria: true
    };
    else mergedConfig = {
        ...ariaOnly
    };
    const attrs = {};
    Object.keys(props).forEach((key)=>{
        if (// Aria
        mergedConfig.aria && (key === 'role' || $b0f3dfd0eb3cad70$var$match(key, $b0f3dfd0eb3cad70$var$ariaPrefix)) || // Data
        mergedConfig.data && $b0f3dfd0eb3cad70$var$match(key, $b0f3dfd0eb3cad70$var$dataPrefix) || // Attr
        mergedConfig.attr && $b0f3dfd0eb3cad70$var$propList.includes(key)) attrs[key] = props[key];
    });
    return attrs;
}


function $f2546aea95b3900f$var$_extends() {
    $f2546aea95b3900f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f2546aea95b3900f$var$_extends.apply(this, arguments);
}
const $f2546aea95b3900f$var$Notify = /*#__PURE__*/ $N3oW3.forwardRef((props, ref)=>{
    const { prefixCls: prefixCls, style: style, className: className, duration: duration = 4.5, showProgress: showProgress, pauseOnHover: pauseOnHover = true, eventKey: eventKey, content: content, closable: closable, props: divProps, onClick: onClick, onNoticeClose: onNoticeClose, times: times, hovering: forcedHovering } = props;
    const [hovering, setHovering] = $32rMB.useState(false);
    const [percent, setPercent] = $32rMB.useState(0);
    const [spentTime, setSpentTime] = $32rMB.useState(0);
    const mergedHovering = forcedHovering || hovering;
    const mergedDuration = typeof duration === 'number' ? duration : 0;
    const mergedShowProgress = mergedDuration > 0 && showProgress;
    // ======================== Close =========================
    const onInternalClose = ()=>{
        onNoticeClose(eventKey);
    };
    const onCloseKeyDown = (e)=>{
        if (e.key === 'Enter' || e.code === 'Enter' || e.keyCode === (0, $4d7d870d585f8465$export$2e2bcd8739ae039).ENTER) onInternalClose();
    };
    // ======================== Effect ========================
    $32rMB.useEffect(()=>{
        if (!mergedHovering && mergedDuration > 0) {
            const start = Date.now() - spentTime;
            const timeout = setTimeout(()=>{
                onInternalClose();
            }, mergedDuration * 1000 - spentTime);
            return ()=>{
                if (pauseOnHover) clearTimeout(timeout);
                setSpentTime(Date.now() - start);
            };
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        mergedDuration,
        mergedHovering,
        times
    ]);
    $32rMB.useEffect(()=>{
        if (!mergedHovering && mergedShowProgress && (pauseOnHover || spentTime === 0)) {
            const start = performance.now();
            let animationFrame;
            const calculate = ()=>{
                cancelAnimationFrame(animationFrame);
                animationFrame = requestAnimationFrame((timestamp)=>{
                    const runtime = timestamp + spentTime - start;
                    const progress = Math.min(runtime / (mergedDuration * 1000), 1);
                    setPercent(progress * 100);
                    if (progress < 1) calculate();
                });
            };
            calculate();
            return ()=>{
                if (pauseOnHover) cancelAnimationFrame(animationFrame);
            };
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        mergedDuration,
        spentTime,
        mergedHovering,
        mergedShowProgress,
        times
    ]);
    // ======================== Closable ========================
    const closableObj = $32rMB.useMemo(()=>{
        if (typeof closable === 'object' && closable !== null) return closable;
        return {};
    }, [
        closable
    ]);
    const ariaProps = (0, $b0f3dfd0eb3cad70$export$2e2bcd8739ae039)(closableObj, true);
    // ======================== Progress ========================
    const validPercent = 100 - (!percent || percent < 0 ? 0 : percent > 100 ? 100 : percent);
    // ======================== Render ========================
    const noticePrefixCls = `${prefixCls}-notice`;
    return /*#__PURE__*/ $hO8yS.createElement("div", $f2546aea95b3900f$var$_extends({}, divProps, {
        ref: ref,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(noticePrefixCls, className, {
            [`${noticePrefixCls}-closable`]: closable
        }),
        style: style,
        onMouseEnter: (e)=>{
            setHovering(true);
            divProps?.onMouseEnter?.(e);
        },
        onMouseLeave: (e)=>{
            setHovering(false);
            divProps?.onMouseLeave?.(e);
        },
        onClick: onClick
    }), /*#__PURE__*/ $hO8yS.createElement("div", {
        className: `${noticePrefixCls}-content`
    }, content), closable && /*#__PURE__*/ $hO8yS.createElement("button", $f2546aea95b3900f$var$_extends({
        className: `${noticePrefixCls}-close`,
        onKeyDown: onCloseKeyDown,
        "aria-label": "Close"
    }, ariaProps, {
        onClick: (e)=>{
            e.preventDefault();
            e.stopPropagation();
            onInternalClose();
        }
    }), closableObj.closeIcon ?? 'x'), mergedShowProgress && /*#__PURE__*/ $hO8yS.createElement("progress", {
        className: `${noticePrefixCls}-progress`,
        max: "100",
        value: validPercent
    }, validPercent + '%'));
});
var $f2546aea95b3900f$export$2e2bcd8739ae039 = $f2546aea95b3900f$var$Notify;



var $N3oW3 = parcelRequire("N3oW3");
const $53c3826fb23b14d5$export$a6e93d8cb5d50678 = /*#__PURE__*/ (0, $N3oW3.default).createContext({});
const $53c3826fb23b14d5$var$NotificationProvider = ({ children: children, classNames: classNames })=>{
    return /*#__PURE__*/ (0, $N3oW3.default).createElement($53c3826fb23b14d5$export$a6e93d8cb5d50678.Provider, {
        value: {
            classNames: classNames
        }
    }, children);
};
var $53c3826fb23b14d5$export$2e2bcd8739ae039 = $53c3826fb23b14d5$var$NotificationProvider;


const $14d9c62e99c2640a$var$DEFAULT_OFFSET = 8;
const $14d9c62e99c2640a$var$DEFAULT_THRESHOLD = 3;
const $14d9c62e99c2640a$var$DEFAULT_GAP = 16;
const $14d9c62e99c2640a$var$useStack = (config)=>{
    const result = {
        offset: $14d9c62e99c2640a$var$DEFAULT_OFFSET,
        threshold: $14d9c62e99c2640a$var$DEFAULT_THRESHOLD,
        gap: $14d9c62e99c2640a$var$DEFAULT_GAP
    };
    if (config && typeof config === 'object') {
        result.offset = config.offset ?? $14d9c62e99c2640a$var$DEFAULT_OFFSET;
        result.threshold = config.threshold ?? $14d9c62e99c2640a$var$DEFAULT_THRESHOLD;
        result.gap = config.gap ?? $14d9c62e99c2640a$var$DEFAULT_GAP;
    }
    return [
        !!config,
        result
    ];
};
var $14d9c62e99c2640a$export$2e2bcd8739ae039 = $14d9c62e99c2640a$var$useStack;


function $1180361c45e22db4$var$_extends() {
    $1180361c45e22db4$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1180361c45e22db4$var$_extends.apply(this, arguments);
}
const $1180361c45e22db4$var$NoticeList = (props)=>{
    const { configList: configList, placement: placement, prefixCls: prefixCls, className: className, style: style, motion: motion, onAllNoticeRemoved: onAllNoticeRemoved, onNoticeClose: onNoticeClose, stack: stackConfig } = props;
    const { classNames: ctxCls } = (0, $32rMB.useContext)((0, $53c3826fb23b14d5$export$a6e93d8cb5d50678));
    const dictRef = (0, $32rMB.useRef)({});
    const [latestNotice, setLatestNotice] = (0, $32rMB.useState)(null);
    const [hoverKeys, setHoverKeys] = (0, $32rMB.useState)([]);
    const keys = configList.map((config)=>({
            config: config,
            key: String(config.key)
        }));
    const [stack, { offset: offset, threshold: threshold, gap: gap }] = (0, $14d9c62e99c2640a$export$2e2bcd8739ae039)(stackConfig);
    const expanded = stack && (hoverKeys.length > 0 || keys.length <= threshold);
    const placementMotion = typeof motion === 'function' ? motion(placement) : motion;
    // Clean hover key
    (0, $32rMB.useEffect)(()=>{
        if (stack && hoverKeys.length > 1) setHoverKeys((prev)=>prev.filter((key)=>keys.some(({ key: dataKey })=>key === dataKey)));
    }, [
        hoverKeys,
        keys,
        stack
    ]);
    // Force update latest notice
    (0, $32rMB.useEffect)(()=>{
        if (stack && dictRef.current[keys[keys.length - 1]?.key]) setLatestNotice(dictRef.current[keys[keys.length - 1]?.key]);
    }, [
        keys,
        stack
    ]);
    return /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $24d87673fe580a7b$export$2e2bcd8739ae039), $1180361c45e22db4$var$_extends({
        key: placement,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-${placement}`, ctxCls?.list, className, {
            [`${prefixCls}-stack`]: !!stack,
            [`${prefixCls}-stack-expanded`]: expanded
        }),
        style: style,
        keys: keys,
        motionAppear: true
    }, placementMotion, {
        onAllRemoved: ()=>{
            onAllNoticeRemoved(placement);
        }
    }), ({ config: config, className: motionClassName, style: motionStyle, index: motionIndex }, nodeRef)=>{
        const { key: key, times: times } = config;
        const strKey = String(key);
        const { className: configClassName, style: configStyle, classNames: configClassNames, styles: configStyles, ...restConfig } = config;
        const dataIndex = keys.findIndex((item)=>item.key === strKey);
        // If dataIndex is -1, that means this notice has been removed in data, but still in dom
        // Should minus (motionIndex - 1) to get the correct index because keys.length is not the same as dom length
        const stackStyle = {};
        if (stack) {
            const index = keys.length - 1 - (dataIndex > -1 ? dataIndex : motionIndex - 1);
            const transformX = placement === 'top' || placement === 'bottom' ? '-50%' : '0';
            if (index > 0) {
                stackStyle.height = expanded ? dictRef.current[strKey]?.offsetHeight : latestNotice?.offsetHeight;
                // Transform
                let verticalOffset = 0;
                for(let i = 0; i < index; i++)verticalOffset += dictRef.current[keys[keys.length - 1 - i].key]?.offsetHeight + gap;
                const transformY = (expanded ? verticalOffset : index * offset) * (placement.startsWith('top') ? 1 : -1);
                const scaleX = !expanded && latestNotice?.offsetWidth && dictRef.current[strKey]?.offsetWidth ? (latestNotice?.offsetWidth - offset * 2 * (index < 3 ? index : 3)) / dictRef.current[strKey]?.offsetWidth : 1;
                stackStyle.transform = `translate3d(${transformX}, ${transformY}px, 0) scaleX(${scaleX})`;
            } else stackStyle.transform = `translate3d(${transformX}, 0, 0)`;
        }
        return /*#__PURE__*/ (0, $N3oW3.default).createElement("div", {
            ref: nodeRef,
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-notice-wrapper`, motionClassName, configClassNames?.wrapper),
            style: {
                ...motionStyle,
                ...stackStyle,
                ...configStyles?.wrapper
            },
            onMouseEnter: ()=>setHoverKeys((prev)=>prev.includes(strKey) ? prev : [
                        ...prev,
                        strKey
                    ]),
            onMouseLeave: ()=>setHoverKeys((prev)=>prev.filter((k)=>k !== strKey))
        }, /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $f2546aea95b3900f$export$2e2bcd8739ae039), $1180361c45e22db4$var$_extends({}, restConfig, {
            ref: (node)=>{
                if (dataIndex > -1) dictRef.current[strKey] = node;
                else delete dictRef.current[strKey];
            },
            prefixCls: prefixCls,
            classNames: configClassNames,
            styles: configStyles,
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(configClassName, ctxCls?.notice),
            style: configStyle,
            times: times,
            key: key,
            eventKey: key,
            onNoticeClose: onNoticeClose,
            hovering: stack && hoverKeys.length > 0
        })));
    });
};
var $1180361c45e22db4$export$2e2bcd8739ae039 = $1180361c45e22db4$var$NoticeList;


// ant-notification ant-notification-topRight
const $0e87a2ea106c2326$var$Notifications = /*#__PURE__*/ $N3oW3.forwardRef((props, ref)=>{
    const { prefixCls: prefixCls = 'rc-notification', container: container, motion: motion, maxCount: maxCount, className: className, style: style, onAllRemoved: onAllRemoved, stack: stack, renderNotifications: renderNotifications } = props;
    const [configList, setConfigList] = $32rMB.useState([]);
    // ======================== Close =========================
    const onNoticeClose = (key)=>{
        // Trigger close event
        const config = configList.find((item)=>item.key === key);
        const closable = config?.closable;
        const closableObj = closable && typeof closable === 'object' ? closable : {};
        const { onClose: closableOnClose } = closableObj;
        closableOnClose?.();
        config?.onClose?.();
        setConfigList((list)=>list.filter((item)=>item.key !== key));
    };
    // ========================= Refs =========================
    $32rMB.useImperativeHandle(ref, ()=>({
            open: (config)=>{
                setConfigList((list)=>{
                    let clone = [
                        ...list
                    ];
                    // Replace if exist
                    const index = clone.findIndex((item)=>item.key === config.key);
                    const innerConfig = {
                        ...config
                    };
                    if (index >= 0) {
                        innerConfig.times = (list[index]?.times || 0) + 1;
                        clone[index] = innerConfig;
                    } else {
                        innerConfig.times = 0;
                        clone.push(innerConfig);
                    }
                    if (maxCount > 0 && clone.length > maxCount) clone = clone.slice(-maxCount);
                    return clone;
                });
            },
            close: (key)=>{
                onNoticeClose(key);
            },
            destroy: ()=>{
                setConfigList([]);
            }
        }));
    // ====================== Placements ======================
    const [placements, setPlacements] = $32rMB.useState({});
    $32rMB.useEffect(()=>{
        const nextPlacements = {};
        configList.forEach((config)=>{
            const { placement: placement = 'topRight' } = config;
            if (placement) {
                nextPlacements[placement] = nextPlacements[placement] || [];
                nextPlacements[placement].push(config);
            }
        });
        // Fill exist placements to avoid empty list causing remove without motion
        Object.keys(placements).forEach((placement)=>{
            nextPlacements[placement] = nextPlacements[placement] || [];
        });
        setPlacements(nextPlacements);
    }, [
        configList
    ]);
    // Clean up container if all notices fade out
    const onAllNoticeRemoved = (placement)=>{
        setPlacements((originPlacements)=>{
            const clone = {
                ...originPlacements
            };
            const list = clone[placement] || [];
            if (!list.length) delete clone[placement];
            return clone;
        });
    };
    // Effect tell that placements is empty now
    const emptyRef = $32rMB.useRef(false);
    $32rMB.useEffect(()=>{
        if (Object.keys(placements).length > 0) emptyRef.current = true;
        else if (emptyRef.current) {
            // Trigger only when from exist to empty
            onAllRemoved?.();
            emptyRef.current = false;
        }
    }, [
        placements
    ]);
    // ======================== Render ========================
    if (!container) return null;
    const placementList = Object.keys(placements);
    return /*#__PURE__*/ (0, $N3oW3.createPortal)(/*#__PURE__*/ $hO8yS.createElement($hO8yS.Fragment, null, placementList.map((placement)=>{
        const placementConfigList = placements[placement];
        const list = /*#__PURE__*/ $hO8yS.createElement((0, $1180361c45e22db4$export$2e2bcd8739ae039), {
            key: placement,
            configList: placementConfigList,
            placement: placement,
            prefixCls: prefixCls,
            className: className?.(placement),
            style: style?.(placement),
            motion: motion,
            onNoticeClose: onNoticeClose,
            onAllNoticeRemoved: onAllNoticeRemoved,
            stack: stack
        });
        return renderNotifications ? renderNotifications(list, {
            prefixCls: prefixCls,
            key: placement
        }) : list;
    })), container);
});
var $0e87a2ea106c2326$export$2e2bcd8739ae039 = $0e87a2ea106c2326$var$Notifications;



const $719b8757d66dd5e6$var$defaultGetContainer = ()=>document.body;
let $719b8757d66dd5e6$var$uniqueKey = 0;
function $719b8757d66dd5e6$var$mergeConfig(...objList) {
    const clone = {};
    objList.forEach((obj)=>{
        if (obj) Object.keys(obj).forEach((key)=>{
            const val = obj[key];
            if (val !== undefined) clone[key] = val;
        });
    });
    return clone;
}
function $719b8757d66dd5e6$export$2e2bcd8739ae039(rootConfig = {}) {
    const { getContainer: getContainer = $719b8757d66dd5e6$var$defaultGetContainer, motion: motion, prefixCls: prefixCls, maxCount: maxCount, className: className, style: style, onAllRemoved: onAllRemoved, stack: stack, renderNotifications: renderNotifications, ...shareConfig } = rootConfig;
    const [container, setContainer] = $32rMB.useState();
    const notificationsRef = $32rMB.useRef();
    const contextHolder = /*#__PURE__*/ $hO8yS.createElement((0, $0e87a2ea106c2326$export$2e2bcd8739ae039), {
        container: container,
        ref: notificationsRef,
        prefixCls: prefixCls,
        motion: motion,
        maxCount: maxCount,
        className: className,
        style: style,
        onAllRemoved: onAllRemoved,
        stack: stack,
        renderNotifications: renderNotifications
    });
    const [taskQueue, setTaskQueue] = $32rMB.useState([]);
    const open = (0, $ea93068db096b7d6$export$2e2bcd8739ae039)((config)=>{
        const mergedConfig = $719b8757d66dd5e6$var$mergeConfig(shareConfig, config);
        if (mergedConfig.key === null || mergedConfig.key === undefined) {
            mergedConfig.key = `rc-notification-${$719b8757d66dd5e6$var$uniqueKey}`;
            $719b8757d66dd5e6$var$uniqueKey += 1;
        }
        setTaskQueue((queue)=>[
                ...queue,
                {
                    type: 'open',
                    config: mergedConfig
                }
            ]);
    });
    // ========================= Refs =========================
    const api = $32rMB.useMemo(()=>({
            open: open,
            close: (key)=>{
                setTaskQueue((queue)=>[
                        ...queue,
                        {
                            type: 'close',
                            key: key
                        }
                    ]);
            },
            destroy: ()=>{
                setTaskQueue((queue)=>[
                        ...queue,
                        {
                            type: 'destroy'
                        }
                    ]);
            }
        }), []);
    // ======================= Container ======================
    // React 18 should all in effect that we will check container in each render
    // Which means getContainer should be stable.
    $32rMB.useEffect(()=>{
        setContainer(getContainer());
    });
    // ======================== Effect ========================
    $32rMB.useEffect(()=>{
        // Flush task when node ready
        if (notificationsRef.current && taskQueue.length) {
            taskQueue.forEach((task)=>{
                switch(task.type){
                    case 'open':
                        notificationsRef.current.open(task.config);
                        break;
                    case 'close':
                        notificationsRef.current.close(task.key);
                        break;
                    case 'destroy':
                        notificationsRef.current.destroy();
                        break;
                }
            });
            // https://github.com/ant-design/ant-design/issues/52590
            // React `startTransition` will run once `useEffect` but many times `setState`,
            // So `setTaskQueue` with filtered array will cause infinite loop.
            // We cache the first match queue instead.
            let oriTaskQueue;
            let tgtTaskQueue;
            // React 17 will mix order of effect & setState in async
            // - open: setState[0]
            // - effect[0]
            // - open: setState[1]
            // - effect setState([]) * here will clean up [0, 1] in React 17
            setTaskQueue((oriQueue)=>{
                if (oriTaskQueue !== oriQueue || !tgtTaskQueue) {
                    oriTaskQueue = oriQueue;
                    tgtTaskQueue = oriQueue.filter((task)=>!taskQueue.includes(task));
                }
                return tgtTaskQueue;
            });
        }
    }, [
        taskQueue
    ]);
    // ======================== Return ========================
    return [
        api,
        contextHolder
    ];
}








parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");

const $4dcf69d8c3d6df5c$export$8bf64cd1c29a1310 = (schema, ...classNames)=>{
    const mergedSchema = schema || {};
    return classNames.filter(Boolean).reduce((acc, cur)=>{
        // Loop keys of the current classNames
        Object.keys(cur || {}).forEach((key)=>{
            const keySchema = mergedSchema[key];
            const curVal = cur[key];
            if (keySchema && typeof keySchema === 'object') {
                if (curVal && typeof curVal === 'object') // Loop fill
                acc[key] = $4dcf69d8c3d6df5c$export$8bf64cd1c29a1310(keySchema, acc[key], curVal);
                else {
                    // Covert string to object structure
                    const { _default: defaultField } = keySchema;
                    if (defaultField) {
                        acc[key] = acc[key] || {};
                        acc[key][defaultField] = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(acc[key][defaultField], curVal);
                    }
                }
            } else // Flatten fill
            acc[key] = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(acc[key], curVal);
        });
        return acc;
    }, {});
};
const $4dcf69d8c3d6df5c$var$useSemanticClassNames = (schema, ...classNames)=>{
    return $32rMB.useMemo(()=>$4dcf69d8c3d6df5c$export$8bf64cd1c29a1310.apply(void 0, [
            schema
        ].concat(classNames)), [
        schema
    ].concat(classNames));
};
const $4dcf69d8c3d6df5c$export$e618dc39ac9ad607 = (...styles)=>{
    return styles.filter(Boolean).reduce((acc, cur = {})=>{
        Object.keys(cur).forEach((key)=>{
            acc[key] = {
                ...acc[key],
                ...cur[key]
            };
        });
        return acc;
    }, {});
};
const $4dcf69d8c3d6df5c$var$useSemanticStyles = (...styles)=>{
    return $32rMB.useMemo(()=>$4dcf69d8c3d6df5c$export$e618dc39ac9ad607.apply(void 0, styles), [].concat(styles));
};
// =========================== Export ===========================
const $4dcf69d8c3d6df5c$var$fillObjectBySchema = (obj, schema)=>{
    const newObj = {
        ...obj
    };
    Object.keys(schema).forEach((key)=>{
        if (key !== '_default') {
            const nestSchema = schema[key];
            const nextValue = newObj[key] || {};
            newObj[key] = nestSchema ? $4dcf69d8c3d6df5c$var$fillObjectBySchema(nextValue, nestSchema) : nextValue;
        }
    });
    return newObj;
};
const $4dcf69d8c3d6df5c$export$ccd424010a24474f = (value, info)=>{
    return typeof value === 'function' ? value(info) : value;
};
const $4dcf69d8c3d6df5c$export$648566b068f28737 = (classNamesList, stylesList, info, schema)=>{
    const resolvedClassNamesList = classNamesList.map((classNames)=>classNames ? $4dcf69d8c3d6df5c$export$ccd424010a24474f(classNames, info) : undefined);
    const resolvedStylesList = stylesList.map((styles)=>styles ? $4dcf69d8c3d6df5c$export$ccd424010a24474f(styles, info) : undefined);
    const mergedClassNames = $4dcf69d8c3d6df5c$var$useSemanticClassNames.apply(void 0, [
        schema
    ].concat((0, $3746fb019e1f2ee5$export$2e2bcd8739ae039)(resolvedClassNamesList)));
    const mergedStyles = $4dcf69d8c3d6df5c$var$useSemanticStyles.apply(void 0, (0, $3746fb019e1f2ee5$export$2e2bcd8739ae039)(resolvedStylesList));
    return $32rMB.useMemo(()=>{
        if (!schema) return [
            mergedClassNames,
            mergedStyles
        ];
        return [
            $4dcf69d8c3d6df5c$var$fillObjectBySchema(mergedClassNames, schema),
            $4dcf69d8c3d6df5c$var$fillObjectBySchema(mergedStyles, schema)
        ];
    }, [
        mergedClassNames,
        mergedStyles,
        schema
    ]);
};



var $N3oW3 = parcelRequire("N3oW3");
function $62609775897a768c$export$9522e17588c12572(child) {
    return child && /*#__PURE__*/ (0, $N3oW3.default).isValidElement(child) && child.type === (0, $N3oW3.default).Fragment;
}
const $62609775897a768c$export$2dfe578f95754f6a = (element, replacement, props)=>{
    if (!/*#__PURE__*/ (0, $N3oW3.default).isValidElement(element)) return replacement;
    return /*#__PURE__*/ (0, $N3oW3.default).cloneElement(element, typeof props === 'function' ? props(element.props || {}) : props);
};
function $62609775897a768c$export$e530037191fcd5d7(element, props) {
    return $62609775897a768c$export$2dfe578f95754f6a(element, element, props);
}



/**
 * This hook is only for cssVar to add root className for components.
 * If root ClassName is needed, this hook could be refactored with `-root`
 * @param prefixCls
 */ const $54b1aecddbbbed4f$var$useCSSVarCls = (prefixCls)=>`${prefixCls}-css-var`;
var $54b1aecddbbbed4f$export$2e2bcd8739ae039 = $54b1aecddbbbed4f$var$useCSSVarCls;




var $N3oW3 = parcelRequire("N3oW3");



var $N3oW3 = parcelRequire("N3oW3");
const $eb222ded4c5a3427$var$zIndexContext = /*#__PURE__*/ (0, $N3oW3.default).createContext(undefined);
var $eb222ded4c5a3427$export$2e2bcd8739ae039 = $eb222ded4c5a3427$var$zIndexContext;


// Z-Index control range
// Container: 1000 + offset 100 (max base + 10 * offset = 2000)
// Popover: offset 50
// Notification: Container Max zIndex + componentOffset
const $15dbea5a917a06ef$var$CONTAINER_OFFSET = 100;
const $15dbea5a917a06ef$var$CONTAINER_OFFSET_MAX_COUNT = 10;
const $15dbea5a917a06ef$export$33ada7d8845f7e5 = $15dbea5a917a06ef$var$CONTAINER_OFFSET * $15dbea5a917a06ef$var$CONTAINER_OFFSET_MAX_COUNT;
/**
 * Static function will default be the `CONTAINER_MAX_OFFSET`.
 * But it still may have children component like Select, Dropdown.
 * So the warning zIndex should exceed the `CONTAINER_MAX_OFFSET`.
 */ const $15dbea5a917a06ef$var$CONTAINER_MAX_OFFSET_WITH_CHILDREN = $15dbea5a917a06ef$export$33ada7d8845f7e5 + $15dbea5a917a06ef$var$CONTAINER_OFFSET;
const $15dbea5a917a06ef$export$1658852af8bb2a55 = {
    Modal: $15dbea5a917a06ef$var$CONTAINER_OFFSET,
    Drawer: $15dbea5a917a06ef$var$CONTAINER_OFFSET,
    Popover: $15dbea5a917a06ef$var$CONTAINER_OFFSET,
    Popconfirm: $15dbea5a917a06ef$var$CONTAINER_OFFSET,
    Tooltip: $15dbea5a917a06ef$var$CONTAINER_OFFSET,
    Tour: $15dbea5a917a06ef$var$CONTAINER_OFFSET,
    FloatButton: $15dbea5a917a06ef$var$CONTAINER_OFFSET
};
const $15dbea5a917a06ef$export$3f7a364c708f940b = {
    SelectLike: 50,
    Dropdown: 50,
    DatePicker: 50,
    Menu: 50,
    ImagePreview: 1
};
const $15dbea5a917a06ef$var$isContainerType = (type)=>{
    return type in $15dbea5a917a06ef$export$1658852af8bb2a55;
};
const $15dbea5a917a06ef$export$3e7906d4075187a4 = (componentType, customZIndex)=>{
    const [, token] = (0, $9481722d146bd166$export$2e2bcd8739ae039)();
    const parentZIndex = (0, $N3oW3.default).useContext((0, $eb222ded4c5a3427$export$2e2bcd8739ae039));
    const isContainer = $15dbea5a917a06ef$var$isContainerType(componentType);
    let result;
    if (customZIndex !== undefined) result = [
        customZIndex,
        customZIndex
    ];
    else {
        let zIndex = parentZIndex ?? 0;
        if (isContainer) zIndex += // Use preset token zIndex by default but not stack when has parent container
        (parentZIndex ? 0 : token.zIndexPopupBase) + // Container offset
        $15dbea5a917a06ef$export$1658852af8bb2a55[componentType];
        else zIndex += $15dbea5a917a06ef$export$3f7a364c708f940b[componentType];
        result = [
            parentZIndex === undefined ? customZIndex : zIndex,
            zIndex
        ];
    }
    return result;
};



parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
function $c5ac91862c8363d3$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $c5ac91862c8363d3$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c5ac91862c8363d3$export$2e2bcd8739ae039(o);
}


function $8a8c02d238873a10$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $d8b0fa7704455138$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}



function $a30004e9c9c9c877$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $e2a93fed214437b8$export$2e2bcd8739ae039(r, e) {
    return (0, $8a8c02d238873a10$export$2e2bcd8739ae039)(r) || (0, $d8b0fa7704455138$export$2e2bcd8739ae039)(r, e) || (0, $14c3211dd7044622$export$2e2bcd8739ae039)(r, e) || (0, $a30004e9c9c9c877$export$2e2bcd8739ae039)();
}




function $a4386b5da3bc956a$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $c5ac91862c8363d3$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $c5ac91862c8363d3$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $cbce4e107de5a9e3$export$2e2bcd8739ae039(t) {
    var i = (0, $a4386b5da3bc956a$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $c5ac91862c8363d3$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $def8730fb4b8d50a$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $cbce4e107de5a9e3$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}



function $cde876c32cf7555b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cde876c32cf7555b$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cde876c32cf7555b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $def8730fb4b8d50a$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cde876c32cf7555b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");


function $c27a1e671724260e$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}



function $3d68cfa6e8f65ecd$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $cbce4e107de5a9e3$export$2e2bcd8739ae039)(o.key), o);
    }
}
function $3d68cfa6e8f65ecd$export$2e2bcd8739ae039(e, r, t) {
    return r && $3d68cfa6e8f65ecd$var$_defineProperties(e.prototype, r), t && $3d68cfa6e8f65ecd$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}


function $d0ef051c99bfe9a2$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $e3c997c5b70ce726$export$2e2bcd8739ae039(t, e) {
    return $e3c997c5b70ce726$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $e3c997c5b70ce726$export$2e2bcd8739ae039(t, e);
}


function $83a5b97ffa16e22b$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $e3c997c5b70ce726$export$2e2bcd8739ae039)(t, e);
}


function $b0b52459905849f7$export$2e2bcd8739ae039(t) {
    return $b0b52459905849f7$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $b0b52459905849f7$export$2e2bcd8739ae039(t);
}


function $f461a574fff50f34$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($f461a574fff50f34$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}




function $3ba1dfd9dbdf5a5e$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $c5ac91862c8363d3$export$2e2bcd8739ae039)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $d0ef051c99bfe9a2$export$2e2bcd8739ae039)(t);
}


function $c64121b56aafd1fd$export$2e2bcd8739ae039(t) {
    var r = (0, $f461a574fff50f34$export$2e2bcd8739ae039)();
    return function() {
        var e, o = (0, $b0b52459905849f7$export$2e2bcd8739ae039)(t);
        if (r) {
            var s = (0, $b0b52459905849f7$export$2e2bcd8739ae039)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $3ba1dfd9dbdf5a5e$export$2e2bcd8739ae039)(this, e);
    };
}





var $e9e9648dd0474ada$var$AbstractCalculator = /*#__PURE__*/ (0, $3d68cfa6e8f65ecd$export$2e2bcd8739ae039)(function AbstractCalculator() {
    (0, $c27a1e671724260e$export$2e2bcd8739ae039)(this, AbstractCalculator);
});
var $e9e9648dd0474ada$export$2e2bcd8739ae039 = $e9e9648dd0474ada$var$AbstractCalculator;


var $4e8877f911edffeb$var$CALC_UNIT = 'CALC_UNIT';
var $4e8877f911edffeb$var$regexp = new RegExp($4e8877f911edffeb$var$CALC_UNIT, 'g');
function $4e8877f911edffeb$var$unit(value) {
    if (typeof value === 'number') return "".concat(value).concat($4e8877f911edffeb$var$CALC_UNIT);
    return value;
}
var $4e8877f911edffeb$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AbstractCalculator) {
    (0, $83a5b97ffa16e22b$export$2e2bcd8739ae039)(CSSCalculator, _AbstractCalculator);
    var _super = (0, $c64121b56aafd1fd$export$2e2bcd8739ae039)(CSSCalculator);
    function CSSCalculator(num, unitlessCssVar) {
        var _this;
        (0, $c27a1e671724260e$export$2e2bcd8739ae039)(this, CSSCalculator);
        _this = _super.call(this);
        (0, $def8730fb4b8d50a$export$2e2bcd8739ae039)((0, $d0ef051c99bfe9a2$export$2e2bcd8739ae039)(_this), "result", '');
        (0, $def8730fb4b8d50a$export$2e2bcd8739ae039)((0, $d0ef051c99bfe9a2$export$2e2bcd8739ae039)(_this), "unitlessCssVar", void 0);
        (0, $def8730fb4b8d50a$export$2e2bcd8739ae039)((0, $d0ef051c99bfe9a2$export$2e2bcd8739ae039)(_this), "lowPriority", void 0);
        var numType = (0, $c5ac91862c8363d3$export$2e2bcd8739ae039)(num);
        _this.unitlessCssVar = unitlessCssVar;
        if (num instanceof CSSCalculator) _this.result = "(".concat(num.result, ")");
        else if (numType === 'number') _this.result = $4e8877f911edffeb$var$unit(num);
        else if (numType === 'string') _this.result = num;
        return _this;
    }
    (0, $3d68cfa6e8f65ecd$export$2e2bcd8739ae039)(CSSCalculator, [
        {
            key: "add",
            value: function add(num) {
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " + ").concat(num.getResult());
                else if (typeof num === 'number' || typeof num === 'string') this.result = "".concat(this.result, " + ").concat($4e8877f911edffeb$var$unit(num));
                this.lowPriority = true;
                return this;
            }
        },
        {
            key: "sub",
            value: function sub(num) {
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " - ").concat(num.getResult());
                else if (typeof num === 'number' || typeof num === 'string') this.result = "".concat(this.result, " - ").concat($4e8877f911edffeb$var$unit(num));
                this.lowPriority = true;
                return this;
            }
        },
        {
            key: "mul",
            value: function mul(num) {
                if (this.lowPriority) this.result = "(".concat(this.result, ")");
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " * ").concat(num.getResult(true));
                else if (typeof num === 'number' || typeof num === 'string') this.result = "".concat(this.result, " * ").concat(num);
                this.lowPriority = false;
                return this;
            }
        },
        {
            key: "div",
            value: function div(num) {
                if (this.lowPriority) this.result = "(".concat(this.result, ")");
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " / ").concat(num.getResult(true));
                else if (typeof num === 'number' || typeof num === 'string') this.result = "".concat(this.result, " / ").concat(num);
                this.lowPriority = false;
                return this;
            }
        },
        {
            key: "getResult",
            value: function getResult(force) {
                return this.lowPriority || force ? "(".concat(this.result, ")") : this.result;
            }
        },
        {
            key: "equal",
            value: function equal(options) {
                var _this2 = this;
                var _ref = options || {}, cssUnit = _ref.unit;
                var mergedUnit = true;
                if (typeof cssUnit === 'boolean') mergedUnit = cssUnit;
                else if (Array.from(this.unitlessCssVar).some(function(cssVar) {
                    return _this2.result.includes(cssVar);
                })) mergedUnit = false;
                this.result = this.result.replace($4e8877f911edffeb$var$regexp, mergedUnit ? 'px' : '');
                if (typeof this.lowPriority !== 'undefined') return "calc(".concat(this.result, ")");
                return this.result;
            }
        }
    ]);
    return CSSCalculator;
}((0, $e9e9648dd0474ada$export$2e2bcd8739ae039));









var $e3523d1fd7e03361$var$NumCalculator = /*#__PURE__*/ function(_AbstractCalculator) {
    (0, $83a5b97ffa16e22b$export$2e2bcd8739ae039)(NumCalculator, _AbstractCalculator);
    var _super = (0, $c64121b56aafd1fd$export$2e2bcd8739ae039)(NumCalculator);
    function NumCalculator(num) {
        var _this;
        (0, $c27a1e671724260e$export$2e2bcd8739ae039)(this, NumCalculator);
        _this = _super.call(this);
        (0, $def8730fb4b8d50a$export$2e2bcd8739ae039)((0, $d0ef051c99bfe9a2$export$2e2bcd8739ae039)(_this), "result", 0);
        if (num instanceof NumCalculator) _this.result = num.result;
        else if (typeof num === 'number') _this.result = num;
        return _this;
    }
    (0, $3d68cfa6e8f65ecd$export$2e2bcd8739ae039)(NumCalculator, [
        {
            key: "add",
            value: function add(num) {
                if (num instanceof NumCalculator) this.result += num.result;
                else if (typeof num === 'number') this.result += num;
                return this;
            }
        },
        {
            key: "sub",
            value: function sub(num) {
                if (num instanceof NumCalculator) this.result -= num.result;
                else if (typeof num === 'number') this.result -= num;
                return this;
            }
        },
        {
            key: "mul",
            value: function mul(num) {
                if (num instanceof NumCalculator) this.result *= num.result;
                else if (typeof num === 'number') this.result *= num;
                return this;
            }
        },
        {
            key: "div",
            value: function div(num) {
                if (num instanceof NumCalculator) this.result /= num.result;
                else if (typeof num === 'number') this.result /= num;
                return this;
            }
        },
        {
            key: "equal",
            value: function equal() {
                return this.result;
            }
        }
    ]);
    return NumCalculator;
}((0, $e9e9648dd0474ada$export$2e2bcd8739ae039));
var $e3523d1fd7e03361$export$2e2bcd8739ae039 = $e3523d1fd7e03361$var$NumCalculator;


var $1ecd3774af5d7040$var$genCalc = function genCalc(type, unitlessCssVar) {
    var Calculator = type === 'css' ? (0, $4e8877f911edffeb$export$2e2bcd8739ae039) : (0, $e3523d1fd7e03361$export$2e2bcd8739ae039);
    return function(num) {
        return new Calculator(num, unitlessCssVar);
    };
};
var $1ecd3774af5d7040$export$2e2bcd8739ae039 = $1ecd3774af5d7040$var$genCalc;


var $db9d03f3dd86be4b$var$getCompVarPrefix = function getCompVarPrefix(component, prefix) {
    return "".concat([
        prefix,
        component.replace(/([A-Z]+)([A-Z][a-z]+)/g, '$1-$2').replace(/([a-z])([A-Z])/g, '$1-$2')
    ].filter(Boolean).join('-'));
};
var $db9d03f3dd86be4b$export$2e2bcd8739ae039 = $db9d03f3dd86be4b$var$getCompVarPrefix;





function $ac64cc151a0eb801$var$getComponentToken(component, token, defaultToken, options) {
    var customToken = (0, $cde876c32cf7555b$export$2e2bcd8739ae039)({}, token[component]);
    if (options !== null && options !== void 0 && options.deprecatedTokens) {
        var deprecatedTokens = options.deprecatedTokens;
        deprecatedTokens.forEach(function(_ref) {
            var _ref2 = (0, $e2a93fed214437b8$export$2e2bcd8739ae039)(_ref, 2), oldTokenKey = _ref2[0], newTokenKey = _ref2[1];
            // Should wrap with `if` clause, or there will be `undefined` in object.
            if (customToken !== null && customToken !== void 0 && customToken[oldTokenKey] || customToken !== null && customToken !== void 0 && customToken[newTokenKey]) {
                var _customToken$newToken;
                (_customToken$newToken = customToken[newTokenKey]) !== null && _customToken$newToken !== void 0 ? _customToken$newToken : customToken[newTokenKey] = customToken === null || customToken === void 0 ? void 0 : customToken[oldTokenKey];
            }
        });
    }
    var mergedToken = (0, $cde876c32cf7555b$export$2e2bcd8739ae039)((0, $cde876c32cf7555b$export$2e2bcd8739ae039)({}, defaultToken), customToken);
    // Remove same value as global token to minimize size
    Object.keys(mergedToken).forEach(function(key) {
        if (mergedToken[key] === token[key]) delete mergedToken[key];
    });
    return mergedToken;
}
var $ac64cc151a0eb801$export$2e2bcd8739ae039 = $ac64cc151a0eb801$var$getComponentToken;




var $90c11ca6cb263fd9$var$enableStatistic = typeof CSSINJS_STATISTIC !== 'undefined';
var $90c11ca6cb263fd9$var$recording = true;
function $90c11ca6cb263fd9$export$4950aa0f605343fb() {
    for(var _len = arguments.length, objs = new Array(_len), _key = 0; _key < _len; _key++)objs[_key] = arguments[_key];
    /* istanbul ignore next */ if (!$90c11ca6cb263fd9$var$enableStatistic) return Object.assign.apply(Object, [
        {}
    ].concat(objs));
    $90c11ca6cb263fd9$var$recording = false;
    var ret = {};
    objs.forEach(function(obj) {
        if ((0, $c5ac91862c8363d3$export$2e2bcd8739ae039)(obj) !== 'object') return;
        var keys = Object.keys(obj);
        keys.forEach(function(key) {
            Object.defineProperty(ret, key, {
                configurable: true,
                enumerable: true,
                get: function get() {
                    return obj[key];
                }
            });
        });
    });
    $90c11ca6cb263fd9$var$recording = true;
    return ret;
}
var $90c11ca6cb263fd9$export$754a5e2d36c5fa7a = {};
var $90c11ca6cb263fd9$export$36157caab8bf9cbd = {};
/* istanbul ignore next */ function $90c11ca6cb263fd9$var$noop() {}
/** Statistic token usage case. Should use `merge` function if you do not want spread record. */ var $90c11ca6cb263fd9$var$statisticToken = function statisticToken(token) {
    var tokenKeys;
    var proxy = token;
    var flush = $90c11ca6cb263fd9$var$noop;
    if ($90c11ca6cb263fd9$var$enableStatistic && typeof Proxy !== 'undefined') {
        tokenKeys = new Set();
        proxy = new Proxy(token, {
            get: function get(obj, prop) {
                if ($90c11ca6cb263fd9$var$recording) {
                    var _tokenKeys;
                    (_tokenKeys = tokenKeys) === null || _tokenKeys === void 0 || _tokenKeys.add(prop);
                }
                return obj[prop];
            }
        });
        flush = function flush(componentName, componentToken) {
            var _statistic$componentN;
            $90c11ca6cb263fd9$export$754a5e2d36c5fa7a[componentName] = {
                global: Array.from(tokenKeys),
                component: (0, $cde876c32cf7555b$export$2e2bcd8739ae039)((0, $cde876c32cf7555b$export$2e2bcd8739ae039)({}, (_statistic$componentN = $90c11ca6cb263fd9$export$754a5e2d36c5fa7a[componentName]) === null || _statistic$componentN === void 0 ? void 0 : _statistic$componentN.component), componentToken)
            };
        };
    }
    return {
        token: proxy,
        keys: tokenKeys,
        flush: flush
    };
};
var $90c11ca6cb263fd9$export$2e2bcd8739ae039 = $90c11ca6cb263fd9$var$statisticToken;


function $0bf0d8d489430954$var$getDefaultComponentToken(component, token, getDefaultToken) {
    if (typeof getDefaultToken === 'function') {
        var _token$component;
        return getDefaultToken((0, $90c11ca6cb263fd9$export$4950aa0f605343fb)(token, (_token$component = token[component]) !== null && _token$component !== void 0 ? _token$component : {}));
    }
    return getDefaultToken !== null && getDefaultToken !== void 0 ? getDefaultToken : {};
}
var $0bf0d8d489430954$export$2e2bcd8739ae039 = $0bf0d8d489430954$var$getDefaultComponentToken;



function $6c680859cfd1aca7$var$genMaxMin(type) {
    if (type === 'js') return {
        max: Math.max,
        min: Math.min
    };
    return {
        max: function max() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return "max(".concat(args.map(function(value) {
                return (0, $763a5b4b58d0a3ff$export$523c0b569236b342)(value);
            }).join(','), ")");
        },
        min: function min() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return "min(".concat(args.map(function(value) {
                return (0, $763a5b4b58d0a3ff$export$523c0b569236b342)(value);
            }).join(','), ")");
        }
    };
}
var $6c680859cfd1aca7$export$2e2bcd8739ae039 = $6c680859cfd1aca7$var$genMaxMin;








var $N3oW3 = parcelRequire("N3oW3");
var $b7bc41154f192704$var$BEAT_LIMIT = 600000;
/**
 * A helper class to map keys to values.
 * It supports both primitive keys and object keys.
 */ var $b7bc41154f192704$var$ArrayKeyMap = /*#__PURE__*/ function() {
    function ArrayKeyMap() {
        (0, $c27a1e671724260e$export$2e2bcd8739ae039)(this, ArrayKeyMap);
        (0, $def8730fb4b8d50a$export$2e2bcd8739ae039)(this, "map", new Map());
        // Use WeakMap to avoid memory leak
        (0, $def8730fb4b8d50a$export$2e2bcd8739ae039)(this, "objectIDMap", new WeakMap());
        (0, $def8730fb4b8d50a$export$2e2bcd8739ae039)(this, "nextID", 0);
        (0, $def8730fb4b8d50a$export$2e2bcd8739ae039)(this, "lastAccessBeat", new Map());
        // We will clean up the cache when reach the limit
        (0, $def8730fb4b8d50a$export$2e2bcd8739ae039)(this, "accessBeat", 0);
    }
    (0, $3d68cfa6e8f65ecd$export$2e2bcd8739ae039)(ArrayKeyMap, [
        {
            key: "set",
            value: function set(keys, value) {
                // New set will trigger clear
                this.clear();
                // Set logic
                var compositeKey = this.getCompositeKey(keys);
                this.map.set(compositeKey, value);
                this.lastAccessBeat.set(compositeKey, Date.now());
            }
        },
        {
            key: "get",
            value: function get(keys) {
                var compositeKey = this.getCompositeKey(keys);
                var cache = this.map.get(compositeKey);
                this.lastAccessBeat.set(compositeKey, Date.now());
                this.accessBeat += 1;
                return cache;
            }
        },
        {
            key: "getCompositeKey",
            value: function getCompositeKey(keys) {
                var _this = this;
                var ids = keys.map(function(key) {
                    if (key && (0, $c5ac91862c8363d3$export$2e2bcd8739ae039)(key) === 'object') return "obj_".concat(_this.getObjectID(key));
                    return "".concat((0, $c5ac91862c8363d3$export$2e2bcd8739ae039)(key), "_").concat(key);
                });
                return ids.join('|');
            }
        },
        {
            key: "getObjectID",
            value: function getObjectID(obj) {
                if (this.objectIDMap.has(obj)) return this.objectIDMap.get(obj);
                var id = this.nextID;
                this.objectIDMap.set(obj, id);
                this.nextID += 1;
                return id;
            }
        },
        {
            key: "clear",
            value: function clear() {
                var _this2 = this;
                if (this.accessBeat > 10000) {
                    var now = Date.now();
                    this.lastAccessBeat.forEach(function(beat, key) {
                        if (now - beat > $b7bc41154f192704$var$BEAT_LIMIT) {
                            _this2.map.delete(key);
                            _this2.lastAccessBeat.delete(key);
                        }
                    });
                    this.accessBeat = 0;
                }
            }
        }
    ]);
    return ArrayKeyMap;
}();
var $b7bc41154f192704$var$uniqueMap = new $b7bc41154f192704$var$ArrayKeyMap();
/**
 * Like `useMemo`, but this hook result will be shared across all instances.
 */ function $b7bc41154f192704$var$useUniqueMemo(memoFn, deps) {
    return (0, $N3oW3.default).useMemo(function() {
        var cachedValue = $b7bc41154f192704$var$uniqueMap.get(deps);
        if (cachedValue) return cachedValue;
        var newValue = memoFn();
        $b7bc41154f192704$var$uniqueMap.set(deps, newValue);
        return newValue;
    }, deps);
}
var $b7bc41154f192704$export$2e2bcd8739ae039 = $b7bc41154f192704$var$useUniqueMemo;


/**
 * Provide a default hook since not everyone needs to config this.
 */ var $362fa9df9fb70997$var$useDefaultCSP = function useDefaultCSP() {
    return {};
};
var $362fa9df9fb70997$export$2e2bcd8739ae039 = $362fa9df9fb70997$var$useDefaultCSP;


function $14e5fa036b71b359$var$genStyleUtils(config) {
    // Dependency inversion for preparing basic config.
    var _config$useCSP = config.useCSP, useCSP = _config$useCSP === void 0 ? (0, $362fa9df9fb70997$export$2e2bcd8739ae039) : _config$useCSP, useToken = config.useToken, usePrefix = config.usePrefix, getResetStyles = config.getResetStyles, getCommonStyle = config.getCommonStyle, getCompUnitless = config.getCompUnitless;
    function genStyleHooks(component, styleFn, getDefaultToken, options) {
        var componentName = Array.isArray(component) ? component[0] : component;
        function prefixToken(key) {
            return "".concat(String(componentName)).concat(key.slice(0, 1).toUpperCase()).concat(key.slice(1));
        }
        // Fill unitless
        var originUnitless = (options === null || options === void 0 ? void 0 : options.unitless) || {};
        var originCompUnitless = typeof getCompUnitless === 'function' ? getCompUnitless(component) : {};
        var compUnitless = (0, $cde876c32cf7555b$export$2e2bcd8739ae039)((0, $cde876c32cf7555b$export$2e2bcd8739ae039)({}, originCompUnitless), {}, (0, $def8730fb4b8d50a$export$2e2bcd8739ae039)({}, prefixToken('zIndexPopup'), true));
        Object.keys(originUnitless).forEach(function(key) {
            compUnitless[prefixToken(key)] = originUnitless[key];
        });
        // Options
        var mergedOptions = (0, $cde876c32cf7555b$export$2e2bcd8739ae039)((0, $cde876c32cf7555b$export$2e2bcd8739ae039)({}, options), {}, {
            unitless: compUnitless,
            prefixToken: prefixToken
        });
        // Hooks
        var useStyle = genComponentStyleHook(component, styleFn, getDefaultToken, mergedOptions);
        var useCSSVar = genCSSVarRegister(componentName, getDefaultToken, mergedOptions);
        return function(prefixCls) {
            var rootCls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : prefixCls;
            var hashId = useStyle(prefixCls, rootCls);
            var cssVarCls = useCSSVar(rootCls);
            return [
                hashId,
                cssVarCls
            ];
        };
    }
    function genCSSVarRegister(component, getDefaultToken, options) {
        var compUnitless = options.unitless, prefixToken = options.prefixToken, ignore = options.ignore;
        return function(rootCls) {
            var _useToken = useToken(), cssVar = _useToken.cssVar, realToken = _useToken.realToken;
            (0, $d16eb0e0ba680681$export$2e2bcd8739ae039)({
                path: [
                    component
                ],
                prefix: cssVar.prefix,
                key: cssVar.key,
                unitless: compUnitless,
                ignore: ignore,
                token: realToken,
                scope: rootCls
            }, function() {
                var defaultToken = (0, $0bf0d8d489430954$export$2e2bcd8739ae039)(component, realToken, getDefaultToken);
                var componentToken = (0, $ac64cc151a0eb801$export$2e2bcd8739ae039)(component, realToken, defaultToken, {
                    deprecatedTokens: options === null || options === void 0 ? void 0 : options.deprecatedTokens
                });
                if (defaultToken) Object.keys(defaultToken).forEach(function(key) {
                    componentToken[prefixToken(key)] = componentToken[key];
                    delete componentToken[key];
                });
                return componentToken;
            });
            return cssVar === null || cssVar === void 0 ? void 0 : cssVar.key;
        };
    }
    function genComponentStyleHook(componentName, styleFn, getDefaultToken) {
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var cells = Array.isArray(componentName) ? componentName : [
            componentName,
            componentName
        ];
        var _cells = (0, $e2a93fed214437b8$export$2e2bcd8739ae039)(cells, 1), component = _cells[0];
        var concatComponent = cells.join('-');
        var mergedLayer = config.layer || {
            name: 'antd'
        };
        // Return new style hook
        return function(prefixCls) {
            var rootCls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : prefixCls;
            var _useToken2 = useToken(), theme = _useToken2.theme, realToken = _useToken2.realToken, hashId = _useToken2.hashId, token = _useToken2.token, cssVar = _useToken2.cssVar, zeroRuntime = _useToken2.zeroRuntime;
            // Update of `disabledRuntimeStyle` would cause React hook error, so memoized it and never update.
            var memoizedZeroRuntime = (0, $32rMB.useMemo)(function() {
                return zeroRuntime;
            }, []);
            if (memoizedZeroRuntime) return hashId;
            var _usePrefix = usePrefix(), rootPrefixCls = _usePrefix.rootPrefixCls, iconPrefixCls = _usePrefix.iconPrefixCls;
            var csp = useCSP();
            var type = 'css';
            // Use unique memo to share the result across all instances
            var calc = (0, $b7bc41154f192704$export$2e2bcd8739ae039)(function() {
                var unitlessCssVar = new Set();
                Object.keys(options.unitless || {}).forEach(function(key) {
                    // Some component proxy the AliasToken (e.g. Image) and some not (e.g. Modal)
                    // We should both pass in `unitlessCssVar` to make sure the CSSVar can be unitless.
                    unitlessCssVar.add((0, $76923c7bf027319b$export$309b3b095f0c7662)(key, cssVar.prefix));
                    unitlessCssVar.add((0, $76923c7bf027319b$export$309b3b095f0c7662)(key, (0, $db9d03f3dd86be4b$export$2e2bcd8739ae039)(component, cssVar.prefix)));
                });
                return (0, $1ecd3774af5d7040$export$2e2bcd8739ae039)(type, unitlessCssVar);
            }, [
                type,
                component,
                cssVar === null || cssVar === void 0 ? void 0 : cssVar.prefix
            ]);
            var _genMaxMin = (0, $6c680859cfd1aca7$export$2e2bcd8739ae039)(type), max = _genMaxMin.max, min = _genMaxMin.min;
            // Shared config
            var sharedConfig = {
                theme: theme,
                token: token,
                hashId: hashId,
                nonce: function nonce() {
                    return csp.nonce;
                },
                clientOnly: options.clientOnly,
                layer: mergedLayer,
                // antd is always at top of styles
                order: options.order || -999
            };
            // This if statement is safe, as it will only be used if the generator has the function. It's not dynamic.
            if (typeof getResetStyles === 'function') // Generate style for all need reset tags.
            (0, $b7e482f3ef1994cd$export$2e2bcd8739ae039)((0, $cde876c32cf7555b$export$2e2bcd8739ae039)((0, $cde876c32cf7555b$export$2e2bcd8739ae039)({}, sharedConfig), {}, {
                clientOnly: false,
                path: [
                    'Shared',
                    rootPrefixCls
                ]
            }), function() {
                return getResetStyles(token, {
                    prefix: {
                        rootPrefixCls: rootPrefixCls,
                        iconPrefixCls: iconPrefixCls
                    },
                    csp: csp
                });
            });
            (0, $b7e482f3ef1994cd$export$2e2bcd8739ae039)((0, $cde876c32cf7555b$export$2e2bcd8739ae039)((0, $cde876c32cf7555b$export$2e2bcd8739ae039)({}, sharedConfig), {}, {
                path: [
                    concatComponent,
                    prefixCls,
                    iconPrefixCls
                ]
            }), function() {
                if (options.injectStyle === false) return [];
                var _statisticToken = (0, $90c11ca6cb263fd9$export$2e2bcd8739ae039)(token), proxyToken = _statisticToken.token, flush = _statisticToken.flush;
                var defaultComponentToken = (0, $0bf0d8d489430954$export$2e2bcd8739ae039)(component, realToken, getDefaultToken);
                var componentCls = ".".concat(prefixCls);
                var componentToken = (0, $ac64cc151a0eb801$export$2e2bcd8739ae039)(component, realToken, defaultComponentToken, {
                    deprecatedTokens: options.deprecatedTokens
                });
                if (defaultComponentToken && (0, $c5ac91862c8363d3$export$2e2bcd8739ae039)(defaultComponentToken) === 'object') Object.keys(defaultComponentToken).forEach(function(key) {
                    defaultComponentToken[key] = "var(".concat((0, $76923c7bf027319b$export$309b3b095f0c7662)(key, (0, $db9d03f3dd86be4b$export$2e2bcd8739ae039)(component, cssVar.prefix)), ")");
                });
                var mergedToken = (0, $90c11ca6cb263fd9$export$4950aa0f605343fb)(proxyToken, {
                    componentCls: componentCls,
                    prefixCls: prefixCls,
                    iconCls: ".".concat(iconPrefixCls),
                    antCls: ".".concat(rootPrefixCls),
                    calc: calc,
                    max: max,
                    min: min
                }, defaultComponentToken);
                var styleInterpolation = styleFn(mergedToken, {
                    hashId: hashId,
                    prefixCls: prefixCls,
                    rootPrefixCls: rootPrefixCls,
                    iconPrefixCls: iconPrefixCls
                });
                flush(component, componentToken);
                var commonStyle = typeof getCommonStyle === 'function' ? getCommonStyle(mergedToken, prefixCls, rootCls, options.resetFont) : null;
                return [
                    options.resetStyle === false ? null : commonStyle,
                    styleInterpolation
                ];
            });
            return hashId;
        };
    }
    function genSubStyleComponent(componentName, styleFn, getDefaultToken) {
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var useStyle = genComponentStyleHook(componentName, styleFn, getDefaultToken, (0, $cde876c32cf7555b$export$2e2bcd8739ae039)({
            resetStyle: false,
            // Sub Style should default after root one
            order: -998
        }, options));
        var StyledComponent = function StyledComponent(_ref) {
            var prefixCls = _ref.prefixCls, _ref$rootCls = _ref.rootCls, rootCls = _ref$rootCls === void 0 ? prefixCls : _ref$rootCls;
            useStyle(prefixCls, rootCls);
            return null;
        };
        return StyledComponent;
    }
    return {
        genStyleHooks: genStyleHooks,
        genSubStyleComponent: genSubStyleComponent,
        genComponentStyleHook: genComponentStyleHook
    };
}
var $14e5fa036b71b359$export$2e2bcd8739ae039 = $14e5fa036b71b359$var$genStyleUtils;









const { genStyleHooks: $d4a2dc313c4d90a4$export$51ec95de45185b42, genComponentStyleHook: $d4a2dc313c4d90a4$export$b8cc4ee2ee8cfbc8, genSubStyleComponent: $d4a2dc313c4d90a4$export$1537386bc155ea56 } = (0, $14e5fa036b71b359$export$2e2bcd8739ae039)({
    usePrefix: ()=>{
        const { getPrefixCls: getPrefixCls, iconPrefixCls: iconPrefixCls } = (0, $32rMB.useContext)((0, $dd01e2f5a4b8605d$export$a92f85ab3e9ad68b));
        const rootPrefixCls = getPrefixCls();
        return {
            rootPrefixCls: rootPrefixCls,
            iconPrefixCls: iconPrefixCls
        };
    },
    useToken: ()=>{
        const [theme, realToken, hashId, token, cssVar, zeroRuntime] = (0, $9481722d146bd166$export$2e2bcd8739ae039)();
        return {
            theme: theme,
            realToken: realToken,
            hashId: hashId,
            token: token,
            cssVar: cssVar,
            zeroRuntime: zeroRuntime
        };
    },
    useCSP: ()=>{
        const { csp: csp } = (0, $32rMB.useContext)((0, $dd01e2f5a4b8605d$export$a92f85ab3e9ad68b));
        return csp ?? {};
    },
    getResetStyles: (token, config)=>{
        const linkStyle = (0, $2f353af2b0f7600b$export$905d771977096614)(token);
        return [
            linkStyle,
            {
                '&': linkStyle
            },
            (0, $2f353af2b0f7600b$export$f1a0b31dfb234e7e)(config?.prefix.iconPrefixCls ?? (0, $dd01e2f5a4b8605d$export$eaca8ee5ed21b4e9))
        ];
    },
    getCommonStyle: (0, $2f353af2b0f7600b$export$689382c111559cd9),
    getCompUnitless: ()=>(0, $9481722d146bd166$export$c6b9faa6b723d31a)
});
const $d4a2dc313c4d90a4$export$d82b8f66c5649e14 = (antCls, componentAbbr)=>{
    const cssPrefix = `--${antCls.replace('.', '')}-${componentAbbr}-`;
    return (name, withVar = false)=>{
        const raw = `${cssPrefix}${name}`;
        return withVar ? `var(${raw})` : raw;
    };
};


const $f4f1c137e0d327f0$var$genMessageStyle = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, boxShadow: boxShadow, colorText: colorText, colorSuccess: colorSuccess, colorError: colorError, colorWarning: colorWarning, colorInfo: colorInfo, fontSizeLG: fontSizeLG, motionEaseInOutCirc: motionEaseInOutCirc, motionDurationSlow: motionDurationSlow, marginXS: marginXS, paddingXS: paddingXS, borderRadiusLG: borderRadiusLG, zIndexPopup: zIndexPopup, contentPadding: // Custom token
    contentPadding, contentBg: contentBg } = token;
    const noticeCls = `${componentCls}-notice`;
    const messageMoveIn = new (0, $f806545df26bb0b4$export$2e2bcd8739ae039)('MessageMoveIn', {
        '0%': {
            padding: 0,
            transform: 'translateY(-100%)',
            opacity: 0
        },
        '100%': {
            padding: paddingXS,
            transform: 'translateY(0)',
            opacity: 1
        }
    });
    const messageMoveOut = new (0, $f806545df26bb0b4$export$2e2bcd8739ae039)('MessageMoveOut', {
        '0%': {
            maxHeight: token.height,
            padding: paddingXS,
            opacity: 1
        },
        '100%': {
            maxHeight: 0,
            padding: 0,
            opacity: 0
        }
    });
    const noticeStyle = {
        padding: paddingXS,
        textAlign: 'center',
        [`${componentCls}-custom-content`]: {
            display: 'flex',
            alignItems: 'center'
        },
        [`${componentCls}-custom-content > ${iconCls}`]: {
            marginInlineEnd: marginXS,
            // affected by ltr or rtl
            fontSize: fontSizeLG
        },
        [`${noticeCls}-content`]: {
            display: 'inline-block',
            padding: contentPadding,
            background: contentBg,
            borderRadius: borderRadiusLG,
            boxShadow: boxShadow,
            pointerEvents: 'all'
        },
        [`${componentCls}-success > ${iconCls}`]: {
            color: colorSuccess
        },
        [`${componentCls}-error > ${iconCls}`]: {
            color: colorError
        },
        [`${componentCls}-warning > ${iconCls}`]: {
            color: colorWarning
        },
        [`${componentCls}-info > ${iconCls},
      ${componentCls}-loading > ${iconCls}`]: {
            color: colorInfo
        }
    };
    return [
        // ============================ Holder ============================
        {
            [componentCls]: {
                ...(0, $2f353af2b0f7600b$export$23997c3e44cc1c59)(token),
                color: colorText,
                position: 'fixed',
                top: marginXS,
                width: '100%',
                pointerEvents: 'none',
                zIndex: zIndexPopup,
                [`${componentCls}-move-up`]: {
                    animationFillMode: 'forwards'
                },
                [`
        ${componentCls}-move-up-appear,
        ${componentCls}-move-up-enter
      `]: {
                    animationName: messageMoveIn,
                    animationDuration: motionDurationSlow,
                    animationPlayState: 'paused',
                    animationTimingFunction: motionEaseInOutCirc
                },
                [`
        ${componentCls}-move-up-appear${componentCls}-move-up-appear-active,
        ${componentCls}-move-up-enter${componentCls}-move-up-enter-active
      `]: {
                    animationPlayState: 'running'
                },
                [`${componentCls}-move-up-leave`]: {
                    animationName: messageMoveOut,
                    animationDuration: motionDurationSlow,
                    animationPlayState: 'paused',
                    animationTimingFunction: motionEaseInOutCirc
                },
                [`${componentCls}-move-up-leave${componentCls}-move-up-leave-active`]: {
                    animationPlayState: 'running'
                },
                '&-rtl': {
                    direction: 'rtl',
                    span: {
                        direction: 'rtl'
                    }
                }
            }
        },
        // ============================ Notice ============================
        {
            [componentCls]: {
                [`${noticeCls}-wrapper`]: {
                    ...noticeStyle
                }
            }
        },
        // ============================= Pure =============================
        {
            [`${componentCls}-notice-pure-panel`]: {
                ...noticeStyle,
                padding: 0,
                textAlign: 'start'
            }
        }
    ];
};
const $f4f1c137e0d327f0$export$9ca1be8807fe0675 = (token)=>({
        zIndexPopup: token.zIndexPopupBase + (0, $15dbea5a917a06ef$export$33ada7d8845f7e5) + 10,
        contentBg: token.colorBgElevated,
        contentPadding: `${(token.controlHeightLG - token.fontSize * token.lineHeight) / 2}px ${token.paddingSM}px`
    });
var // ============================== Export ==============================
$f4f1c137e0d327f0$export$2e2bcd8739ae039 = (0, $d4a2dc313c4d90a4$export$51ec95de45185b42)('Message', (token)=>{
    // Gen-style functions here
    const combinedToken = (0, $90c11ca6cb263fd9$export$4950aa0f605343fb)(token, {
        height: 150
    });
    return $f4f1c137e0d327f0$var$genMessageStyle(combinedToken);
}, $f4f1c137e0d327f0$export$9ca1be8807fe0675);


"use client";
const $ee17468d37d92a49$export$ad8f8fc3bcd61b4a = {
    info: /*#__PURE__*/ $hO8yS.createElement((0, $59cfafa07a56daba$export$2e2bcd8739ae039), null),
    success: /*#__PURE__*/ $hO8yS.createElement((0, $1aa4ade09bf83f85$export$2e2bcd8739ae039), null),
    error: /*#__PURE__*/ $hO8yS.createElement((0, $88ed6189ad3742f6$export$2e2bcd8739ae039), null),
    warning: /*#__PURE__*/ $hO8yS.createElement((0, $eec2491bdf124fc8$export$2e2bcd8739ae039), null),
    loading: /*#__PURE__*/ $hO8yS.createElement((0, $b7d605396d432b67$export$2e2bcd8739ae039), null)
};
const $ee17468d37d92a49$export$429c001938db3a78 = (props)=>{
    const { prefixCls: prefixCls, type: type, icon: icon, children: children, classNames: pureContentClassNames, styles: styles } = props;
    const iconElement = icon || type && $ee17468d37d92a49$export$ad8f8fc3bcd61b4a[type];
    const iconNode = (0, $62609775897a768c$export$e530037191fcd5d7)(iconElement, (currentProps)=>{
        const mergedStyle = {
            ...currentProps?.style,
            ...styles?.icon
        };
        return {
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(currentProps.className, pureContentClassNames?.icon),
            style: mergedStyle
        };
    });
    return /*#__PURE__*/ $hO8yS.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-custom-content`, `${prefixCls}-${type}`)
    }, iconNode, /*#__PURE__*/ $hO8yS.createElement("span", {
        className: pureContentClassNames?.content,
        style: styles?.content
    }, children));
};
/** @private Internal Component. Do not use in your production. */ const $ee17468d37d92a49$var$PurePanel = (props)=>{
    const { prefixCls: staticPrefixCls, className: className, style: style, type: type, icon: icon, content: content, classNames: messageClassNames, styles: styles, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $dd01e2f5a4b8605d$export$46f4bd6436a25a31)('message');
    const prefixCls = staticPrefixCls || getPrefixCls('message');
    const rootCls = (0, $54b1aecddbbbed4f$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $f4f1c137e0d327f0$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const [mergedClassNames, mergedStyles] = (0, $4dcf69d8c3d6df5c$export$648566b068f28737)([
        contextClassNames,
        messageClassNames
    ], [
        contextStyles,
        styles
    ], {
        props: props
    });
    return /*#__PURE__*/ $hO8yS.createElement((0, $f2546aea95b3900f$export$2e2bcd8739ae039), {
        ...restProps,
        prefixCls: prefixCls,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(contextClassName, mergedClassNames.root, className, hashId, `${prefixCls}-notice-pure-panel`, cssVarCls, rootCls),
        style: {
            ...mergedStyles.root,
            ...contextStyle,
            ...style
        },
        eventKey: "pure",
        duration: null,
        content: /*#__PURE__*/ $hO8yS.createElement($ee17468d37d92a49$export$429c001938db3a78, {
            prefixCls: prefixCls,
            type: type,
            icon: icon,
            classNames: mergedClassNames,
            styles: mergedStyles
        }, content)
    });
};
var $ee17468d37d92a49$export$2e2bcd8739ae039 = $ee17468d37d92a49$var$PurePanel;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");



// \b([A-Za-z_$][\w$]*)\s*!==\s*(?:undefined\s*&&\s*\1\s*!==\s*null|null\s*&&\s*\1\s*!==\s*undefined)\b
// \b([A-Za-z_$][\w$\.]*)\s*===\s*(?:undefined|null)\s*\|\|\s*\1\s*===\s*(?:undefined|null)\b
const $95ac4c3d4339216e$var$isNonNullable = (val)=>{
    return val !== undefined && val !== null;
};
var $95ac4c3d4339216e$export$2e2bcd8739ae039 = $95ac4c3d4339216e$var$isNonNullable;








function $c2d18da8b2038cab$export$7b8936ddc277a29a(prefixCls, transitionName) {
    return {
        motionName: transitionName ?? `${prefixCls}-move-up`
    };
}
function $c2d18da8b2038cab$export$52ce770daa307a45(openFn) {
    let closeFn;
    const closePromise = new Promise((resolve)=>{
        closeFn = openFn(()=>{
            resolve(true);
        });
    });
    const result = ()=>{
        closeFn?.();
    };
    result.then = (filled, rejected)=>closePromise.then(filled, rejected);
    result.promise = closePromise;
    return result;
}


"use client";
const $e8b44ff07708d014$var$DEFAULT_OFFSET = 8;
const $e8b44ff07708d014$var$DEFAULT_DURATION = 3;
const $e8b44ff07708d014$var$Wrapper = ({ children: children, prefixCls: prefixCls })=>{
    const rootCls = (0, $54b1aecddbbbed4f$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $f4f1c137e0d327f0$export$2e2bcd8739ae039)(prefixCls, rootCls);
    return /*#__PURE__*/ $hO8yS.createElement((0, $53c3826fb23b14d5$export$2e2bcd8739ae039), {
        classNames: {
            list: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(hashId, cssVarCls, rootCls)
        }
    }, children);
};
const $e8b44ff07708d014$var$renderNotifications = (node, { prefixCls: prefixCls, key: key })=>/*#__PURE__*/ $hO8yS.createElement($e8b44ff07708d014$var$Wrapper, {
        prefixCls: prefixCls,
        key: key
    }, node);
const $e8b44ff07708d014$var$Holder = /*#__PURE__*/ $N3oW3.forwardRef((props, ref)=>{
    const { top: top, prefixCls: staticPrefixCls, getContainer: staticGetContainer, maxCount: maxCount, duration: duration = $e8b44ff07708d014$var$DEFAULT_DURATION, rtl: rtl, transitionName: transitionName, onAllRemoved: onAllRemoved, pauseOnHover: pauseOnHover = true } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, getPopupContainer: getPopupContainer } = (0, $dd01e2f5a4b8605d$export$46f4bd6436a25a31)('message');
    const { message: message } = $32rMB.useContext((0, $dd01e2f5a4b8605d$export$a92f85ab3e9ad68b));
    const prefixCls = staticPrefixCls || getPrefixCls('message');
    // =============================== Style ===============================
    const getStyle = ()=>({
            left: '50%',
            transform: 'translateX(-50%)',
            top: top ?? $e8b44ff07708d014$var$DEFAULT_OFFSET
        });
    const getClassName = ()=>(0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)({
            [`${prefixCls}-rtl`]: rtl ?? direction === 'rtl'
        });
    // ============================== Motion ===============================
    const getNotificationMotion = ()=>(0, $c2d18da8b2038cab$export$7b8936ddc277a29a)(prefixCls, transitionName);
    // Use useMergeSemantic to merge classNames and styles
    const [mergedClassNames, mergedStyles] = (0, $4dcf69d8c3d6df5c$export$648566b068f28737)([
        props?.classNames,
        message?.classNames
    ], [
        props?.styles,
        message?.styles
    ], {
        props: props
    });
    // ============================== Origin ===============================
    const [api, holder] = (0, $719b8757d66dd5e6$export$2e2bcd8739ae039)({
        prefixCls: prefixCls,
        style: getStyle,
        className: getClassName,
        motion: getNotificationMotion,
        // closable=false requires-no closeIcon
        closable: false,
        duration: duration,
        getContainer: ()=>staticGetContainer?.() || getPopupContainer?.() || document.body,
        maxCount: maxCount,
        onAllRemoved: onAllRemoved,
        renderNotifications: $e8b44ff07708d014$var$renderNotifications,
        pauseOnHover: pauseOnHover
    });
    // ================================ Ref ================================
    $32rMB.useImperativeHandle(ref, ()=>({
            ...api,
            prefixCls: prefixCls,
            message: message,
            classNames: mergedClassNames,
            styles: mergedStyles
        }));
    return holder;
});
// ==============================================================================
// ==                                   Hook                                   ==
// ==============================================================================
let $e8b44ff07708d014$var$keyIndex = 0;
function $e8b44ff07708d014$export$1689db33b6c27d9e(messageConfig) {
    const holderRef = $32rMB.useRef(null);
    const warning = (0, $d41680c8243eac18$export$cf977aa92c751e61)('Message');
    // ================================ API ================================
    const wrapAPI = $32rMB.useMemo(()=>{
        // Wrap with notification content
        // >>> close
        const close = (key)=>{
            holderRef.current?.close(key);
        };
        // >>> Open
        const open = (config)=>{
            if (!holderRef.current) {
                const fakeResult = ()=>{};
                // eslint-disable-next-line react-hooks/immutability
                fakeResult.then = ()=>{};
                return fakeResult;
            }
            const { open: originOpen, prefixCls: prefixCls, message: message, classNames: originClassNames, styles: originStyles } = holderRef.current;
            const contextClassName = message?.className || {};
            const contextStyle = message?.style || {};
            const rawContextClassNames = message?.classNames || {};
            const rawContextStyles = message?.styles || {};
            const noticePrefixCls = `${prefixCls}-notice`;
            const { content: content, icon: icon, type: type, key: key, className: className, style: style, onClose: onClose, classNames: configClassNames = {}, styles: styles = {}, ...restConfig } = config;
            let mergedKey = key;
            if (!(0, $95ac4c3d4339216e$export$2e2bcd8739ae039)(mergedKey)) {
                $e8b44ff07708d014$var$keyIndex += 1;
                mergedKey = `antd-message-${$e8b44ff07708d014$var$keyIndex}`;
            }
            const contextConfig = {
                ...messageConfig,
                ...config
            };
            const contextClassNames = (0, $4dcf69d8c3d6df5c$export$ccd424010a24474f)(rawContextClassNames, {
                props: contextConfig
            });
            const semanticClassNames = (0, $4dcf69d8c3d6df5c$export$ccd424010a24474f)(configClassNames, {
                props: contextConfig
            });
            const contextStyles = (0, $4dcf69d8c3d6df5c$export$ccd424010a24474f)(rawContextStyles, {
                props: contextConfig
            });
            const semanticStyles = (0, $4dcf69d8c3d6df5c$export$ccd424010a24474f)(styles, {
                props: contextConfig
            });
            const mergedClassNames = (0, $4dcf69d8c3d6df5c$export$8bf64cd1c29a1310)(undefined, contextClassNames, semanticClassNames, originClassNames);
            const mergedStyles = (0, $4dcf69d8c3d6df5c$export$e618dc39ac9ad607)(contextStyles, semanticStyles, originStyles);
            return (0, $c2d18da8b2038cab$export$52ce770daa307a45)((resolve)=>{
                originOpen({
                    ...restConfig,
                    key: mergedKey,
                    content: /*#__PURE__*/ $hO8yS.createElement((0, $ee17468d37d92a49$export$429c001938db3a78), {
                        prefixCls: prefixCls,
                        type: type,
                        icon: icon,
                        classNames: mergedClassNames,
                        styles: mergedStyles
                    }, content),
                    placement: 'top',
                    className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)({
                        [`${noticePrefixCls}-${type}`]: type
                    }, className, contextClassName, mergedClassNames.root),
                    style: {
                        ...mergedStyles.root,
                        ...contextStyle,
                        ...style
                    },
                    onClose: ()=>{
                        onClose?.();
                        resolve();
                    }
                });
                // Return close function
                return ()=>{
                    close(mergedKey);
                };
            });
        };
        // >>> destroy
        const destroy = (key)=>{
            if (key !== undefined) close(key);
            else holderRef.current?.destroy();
        };
        const clone = {
            open: open,
            destroy: destroy
        };
        const keys = [
            'info',
            'success',
            'warning',
            'error',
            'loading'
        ];
        keys.forEach((type)=>{
            const typeOpen = (jointContent, duration, onClose)=>{
                let config;
                if (jointContent && typeof jointContent === 'object' && 'content' in jointContent) config = jointContent;
                else config = {
                    content: jointContent
                };
                // Params
                let mergedDuration;
                let mergedOnClose;
                if (typeof duration === 'function') mergedOnClose = duration;
                else {
                    mergedDuration = duration;
                    mergedOnClose = onClose;
                }
                const mergedConfig = {
                    onClose: mergedOnClose,
                    duration: mergedDuration,
                    ...config,
                    type: type
                };
                return open(mergedConfig);
            };
            clone[type] = typeOpen;
        });
        return clone;
    }, []);
    // ============================== Return ===============================
    return [
        wrapAPI,
        /*#__PURE__*/ $hO8yS.createElement($e8b44ff07708d014$var$Holder, {
            key: "message-holder",
            ...messageConfig,
            ref: holderRef
        })
    ];
}
function $e8b44ff07708d014$export$2e2bcd8739ae039(messageConfig) {
    return $e8b44ff07708d014$export$1689db33b6c27d9e(messageConfig);
}



"use client";
let $d1cd4dd6f62e88cc$var$message = null;
let $d1cd4dd6f62e88cc$var$act = (callback)=>callback();
let $d1cd4dd6f62e88cc$var$taskQueue = [];
let $d1cd4dd6f62e88cc$var$defaultGlobalConfig = {};
function $d1cd4dd6f62e88cc$var$getGlobalContext() {
    const { getContainer: getContainer, duration: duration, rtl: rtl, maxCount: maxCount, top: top } = $d1cd4dd6f62e88cc$var$defaultGlobalConfig;
    const mergedContainer = getContainer?.() || document.body;
    return {
        getContainer: ()=>mergedContainer,
        duration: duration,
        rtl: rtl,
        maxCount: maxCount,
        top: top
    };
}
const $d1cd4dd6f62e88cc$var$GlobalHolder = /*#__PURE__*/ (0, $N3oW3.default).forwardRef((props, ref)=>{
    const { messageConfig: messageConfig, sync: sync } = props;
    const { getPrefixCls: getPrefixCls } = (0, $32rMB.useContext)((0, $dd01e2f5a4b8605d$export$a92f85ab3e9ad68b));
    const prefixCls = $d1cd4dd6f62e88cc$var$defaultGlobalConfig.prefixCls || getPrefixCls('message');
    const appConfig = (0, $32rMB.useContext)((0, $ce1a14c8d222cf48$export$264c6064649f9206));
    const [api, holder] = (0, $e8b44ff07708d014$export$1689db33b6c27d9e)({
        ...messageConfig,
        prefixCls: prefixCls,
        ...appConfig.message
    });
    (0, $N3oW3.default).useImperativeHandle(ref, ()=>{
        const instance = {
            ...api
        };
        Object.keys(instance).forEach((method)=>{
            instance[method] = (...args)=>{
                sync();
                return api[method].apply(api, args);
            };
        });
        return {
            instance: instance,
            sync: sync
        };
    });
    return holder;
});
const $d1cd4dd6f62e88cc$var$GlobalHolderWrapper = /*#__PURE__*/ (0, $N3oW3.default).forwardRef((_, ref)=>{
    const [messageConfig, setMessageConfig] = (0, $N3oW3.default).useState($d1cd4dd6f62e88cc$var$getGlobalContext);
    const sync = ()=>{
        setMessageConfig($d1cd4dd6f62e88cc$var$getGlobalContext);
    };
    (0, $N3oW3.default).useEffect(sync, []);
    const global = (0, $6ff80b51bd11b92e$export$f9cd1e43211d8a4a)();
    const rootPrefixCls = global.getRootPrefixCls();
    const rootIconPrefixCls = global.getIconPrefixCls();
    const theme = global.getTheme();
    const dom = /*#__PURE__*/ (0, $N3oW3.default).createElement($d1cd4dd6f62e88cc$var$GlobalHolder, {
        ref: ref,
        sync: sync,
        messageConfig: messageConfig
    });
    return /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $6ff80b51bd11b92e$export$2e2bcd8739ae039), {
        prefixCls: rootPrefixCls,
        iconPrefixCls: rootIconPrefixCls,
        theme: theme
    }, global.holderRender ? global.holderRender(dom) : dom);
});
const $d1cd4dd6f62e88cc$var$flushMessageQueue = ()=>{
    if (!$d1cd4dd6f62e88cc$var$message) {
        const holderFragment = document.createDocumentFragment();
        const newMessage = {
            fragment: holderFragment
        };
        $d1cd4dd6f62e88cc$var$message = newMessage;
        // Delay render to avoid sync issue
        $d1cd4dd6f62e88cc$var$act(()=>{
            (0, $77c6df01f18c5b91$export$b3890eb0ae9dca99)(/*#__PURE__*/ (0, $N3oW3.default).createElement($d1cd4dd6f62e88cc$var$GlobalHolderWrapper, {
                ref: (node)=>{
                    const { instance: instance, sync: sync } = node || {};
                    // React 18 test env will throw if call immediately in ref
                    Promise.resolve().then(()=>{
                        if (!newMessage.instance && instance) {
                            newMessage.instance = instance;
                            newMessage.sync = sync;
                            $d1cd4dd6f62e88cc$var$flushMessageQueue();
                        }
                    });
                }
            }), holderFragment);
        });
        return;
    }
    // Notification not ready
    if (!$d1cd4dd6f62e88cc$var$message.instance) return;
    // >>> Execute task
    $d1cd4dd6f62e88cc$var$taskQueue.forEach((task)=>{
        const { type: type, skipped: skipped } = task;
        // Only `skipped` when user call notice but cancel it immediately
        // and instance not ready
        if (!skipped) switch(type){
            case 'open':
                $d1cd4dd6f62e88cc$var$act(()=>{
                    const closeFn = $d1cd4dd6f62e88cc$var$message.instance.open({
                        ...$d1cd4dd6f62e88cc$var$defaultGlobalConfig,
                        ...task.config
                    });
                    closeFn?.then(task.resolve);
                    task.setCloseFn(closeFn);
                });
                break;
            case 'destroy':
                $d1cd4dd6f62e88cc$var$act(()=>{
                    $d1cd4dd6f62e88cc$var$message?.instance.destroy(task.key);
                });
                break;
            // Other type open
            default:
                $d1cd4dd6f62e88cc$var$act(()=>{
                    var _message$instance;
                    const closeFn = (_message$instance = $d1cd4dd6f62e88cc$var$message.instance)[type].apply(_message$instance, (0, $3746fb019e1f2ee5$export$2e2bcd8739ae039)(task.args));
                    closeFn?.then(task.resolve);
                    task.setCloseFn(closeFn);
                });
        }
    });
    // Clean up
    $d1cd4dd6f62e88cc$var$taskQueue = [];
};
// ==============================================================================
// ==                                  Export                                  ==
// ==============================================================================
function $d1cd4dd6f62e88cc$var$setMessageGlobalConfig(config) {
    $d1cd4dd6f62e88cc$var$defaultGlobalConfig = {
        ...$d1cd4dd6f62e88cc$var$defaultGlobalConfig,
        ...config
    };
    // Trigger sync for it
    $d1cd4dd6f62e88cc$var$act(()=>{
        $d1cd4dd6f62e88cc$var$message?.sync?.();
    });
}
function $d1cd4dd6f62e88cc$var$open(config) {
    const result = (0, $c2d18da8b2038cab$export$52ce770daa307a45)((resolve)=>{
        let closeFn;
        const task = {
            type: 'open',
            config: config,
            resolve: resolve,
            setCloseFn: (fn)=>{
                closeFn = fn;
            }
        };
        $d1cd4dd6f62e88cc$var$taskQueue.push(task);
        return ()=>{
            if (closeFn) $d1cd4dd6f62e88cc$var$act(()=>{
                closeFn();
            });
            else task.skipped = true;
        };
    });
    $d1cd4dd6f62e88cc$var$flushMessageQueue();
    return result;
}
function $d1cd4dd6f62e88cc$var$typeOpen(type, args) {
    const global = (0, $6ff80b51bd11b92e$export$f9cd1e43211d8a4a)();
    const result = (0, $c2d18da8b2038cab$export$52ce770daa307a45)((resolve)=>{
        let closeFn;
        const task = {
            type: type,
            args: args,
            resolve: resolve,
            setCloseFn: (fn)=>{
                closeFn = fn;
            }
        };
        $d1cd4dd6f62e88cc$var$taskQueue.push(task);
        return ()=>{
            if (closeFn) $d1cd4dd6f62e88cc$var$act(()=>{
                closeFn();
            });
            else task.skipped = true;
        };
    });
    $d1cd4dd6f62e88cc$var$flushMessageQueue();
    return result;
}
const $d1cd4dd6f62e88cc$var$destroy = (key)=>{
    $d1cd4dd6f62e88cc$var$taskQueue.push({
        type: 'destroy',
        key: key
    });
    $d1cd4dd6f62e88cc$var$flushMessageQueue();
};
const $d1cd4dd6f62e88cc$var$methods = [
    'success',
    'info',
    'warning',
    'error',
    'loading'
];
const $d1cd4dd6f62e88cc$var$baseStaticMethods = {
    open: $d1cd4dd6f62e88cc$var$open,
    destroy: $d1cd4dd6f62e88cc$var$destroy,
    config: $d1cd4dd6f62e88cc$var$setMessageGlobalConfig,
    useMessage: $e8b44ff07708d014$export$2e2bcd8739ae039,
    _InternalPanelDoNotUseOrYouWillBeFired: (0, $ee17468d37d92a49$export$2e2bcd8739ae039)
};
const $d1cd4dd6f62e88cc$var$staticMethods = $d1cd4dd6f62e88cc$var$baseStaticMethods;
$d1cd4dd6f62e88cc$var$methods.forEach((type)=>{
    $d1cd4dd6f62e88cc$var$staticMethods[type] = (...args)=>$d1cd4dd6f62e88cc$var$typeOpen(type, args);
});
// ==============================================================================
// ==                                   Test                                   ==
// ==============================================================================
const $d1cd4dd6f62e88cc$var$noop = ()=>{};
let $d1cd4dd6f62e88cc$var$_actWrapper = $d1cd4dd6f62e88cc$var$noop;
var $d1cd4dd6f62e88cc$var$wrapper;
const $d1cd4dd6f62e88cc$export$71ceb3dabb09f455 = $d1cd4dd6f62e88cc$var$_actWrapper;
let $d1cd4dd6f62e88cc$var$_actDestroy = $d1cd4dd6f62e88cc$var$noop;
const $d1cd4dd6f62e88cc$export$43de32c50edff050 = $d1cd4dd6f62e88cc$var$_actDestroy;
var $d1cd4dd6f62e88cc$export$2e2bcd8739ae039 = $d1cd4dd6f62e88cc$var$staticMethods;




/**
 * react-router v7.10.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");
var $N3oW3 = parcelRequire("N3oW3");
var $dbfbcf83869c9c18$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/.pnpm/react-router@7.10.0_@preact+compat@18.3.1_preact@10.28.0__@preact+compat@18.3.1_preact@10.28.0_/node_modules/react-router/dist/development/chunk-FGUA77HG.mjs"
});
var $dbfbcf83869c9c18$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $dbfbcf83869c9c18$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $dbfbcf83869c9c18$var$__typeError("Cannot " + msg);
var $dbfbcf83869c9c18$var$__privateGet = (obj, member, getter)=>($dbfbcf83869c9c18$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $dbfbcf83869c9c18$var$__privateAdd = (obj, member, value)=>member.has(obj) ? $dbfbcf83869c9c18$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
// lib/router/history.ts
var $dbfbcf83869c9c18$export$e19cd5f9376f8cee = /* @__PURE__ */ ((Action2)=>{
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
})($dbfbcf83869c9c18$export$e19cd5f9376f8cee || {});
var $dbfbcf83869c9c18$var$PopStateEventType = "popstate";
function $dbfbcf83869c9c18$var$createMemoryHistory(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index2)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP" /* Pop */ ;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key) {
        let location = $dbfbcf83869c9c18$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $dbfbcf83869c9c18$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : $dbfbcf83869c9c18$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL (to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $dbfbcf83869c9c18$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH" /* Push */ ;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE" /* Replace */ ;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP" /* Pop */ ;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
function $dbfbcf83869c9c18$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window2, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window2.location;
        return $dbfbcf83869c9c18$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : $dbfbcf83869c9c18$export$fe53371bee54353d(to);
    }
    return $dbfbcf83869c9c18$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function $dbfbcf83869c9c18$var$createHashHistory(options = {}) {
    function createHashLocation(window2, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $dbfbcf83869c9c18$export$8ccf933b0513f8d0(window2.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $dbfbcf83869c9c18$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        let base = window2.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window2.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $dbfbcf83869c9c18$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $dbfbcf83869c9c18$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $dbfbcf83869c9c18$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $dbfbcf83869c9c18$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $dbfbcf83869c9c18$var$warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function $dbfbcf83869c9c18$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function $dbfbcf83869c9c18$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
function $dbfbcf83869c9c18$var$createLocation(current, to, state = null, key) {
    let location = {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $dbfbcf83869c9c18$export$8ccf933b0513f8d0(to) : to,
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $dbfbcf83869c9c18$var$createKey()
    };
    return location;
}
function $dbfbcf83869c9c18$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function $dbfbcf83869c9c18$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $dbfbcf83869c9c18$var$getUrlBasedHistory(getLocation, createHref2, validateLocation, options = {}) {
    let { window: window2 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window2.history;
    let action = "POP" /* Pop */ ;
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        let location = $dbfbcf83869c9c18$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $dbfbcf83869c9c18$var$getHistoryState(location, index);
        let url = history.createHref(location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        let location = $dbfbcf83869c9c18$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $dbfbcf83869c9c18$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return $dbfbcf83869c9c18$var$createBrowserURLImpl(to);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener($dbfbcf83869c9c18$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window2.removeEventListener($dbfbcf83869c9c18$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref2(window2, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace2,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function $dbfbcf83869c9c18$var$createBrowserURLImpl(to, isAbsolute = false) {
    let base = "http://localhost";
    if (typeof window !== "undefined") base = window.location.origin !== "null" ? window.location.origin : window.location.href;
    $dbfbcf83869c9c18$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL");
    let href = typeof to === "string" ? to : $dbfbcf83869c9c18$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    if (!isAbsolute && href.startsWith("//")) href = base + href;
    return new URL(href, base);
}
// lib/router/utils.ts
function $dbfbcf83869c9c18$export$fd42f52fd3ae1109(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
var $dbfbcf83869c9c18$var$_map;
var $dbfbcf83869c9c18$export$b8d3e69d4b3eff04 = class {
    /**
   * Create a new `RouterContextProvider` instance
   * @param init An optional initial context map to populate the provider with
   */ constructor(init){
        $dbfbcf83869c9c18$var$__privateAdd(this, $dbfbcf83869c9c18$var$_map, /* @__PURE__ */ new Map());
        if (init) for (let [context, value] of init)this.set(context, value);
    }
    /**
   * Access a value from the context. If no value has been set for the context,
   * it will return the context's `defaultValue` if provided, or throw an error
   * if no `defaultValue` was set.
   * @param context The context to get the value for
   * @returns The value for the context, or the context's `defaultValue` if no
   * value was set
   */ get(context) {
        if ($dbfbcf83869c9c18$var$__privateGet(this, $dbfbcf83869c9c18$var$_map).has(context)) return $dbfbcf83869c9c18$var$__privateGet(this, $dbfbcf83869c9c18$var$_map).get(context);
        if (context.defaultValue !== void 0) return context.defaultValue;
        throw new Error("No value found for context");
    }
    /**
   * Set a value for the context. If the context already has a value set, this
   * will overwrite it.
   *
   * @param context The context to set the value for
   * @param value The value to set for the context
   * @returns {void}
   */ set(context, value) {
        $dbfbcf83869c9c18$var$__privateGet(this, $dbfbcf83869c9c18$var$_map).set(context, value);
    }
};
$dbfbcf83869c9c18$var$_map = new WeakMap();
var $dbfbcf83869c9c18$var$unsupportedLazyRouteObjectKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $dbfbcf83869c9c18$var$isUnsupportedLazyRouteObjectKey(key) {
    return $dbfbcf83869c9c18$var$unsupportedLazyRouteObjectKeys.has(key);
}
var $dbfbcf83869c9c18$var$unsupportedLazyRouteFunctionKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "middleware",
    "children"
]);
function $dbfbcf83869c9c18$var$isUnsupportedLazyRouteFunctionKey(key) {
    return $dbfbcf83869c9c18$var$unsupportedLazyRouteFunctionKeys.has(key);
}
function $dbfbcf83869c9c18$var$isIndexRoute(route) {
    return route.index === true;
}
function $dbfbcf83869c9c18$export$87cb1a9238dc3fba(routes, mapRouteProperties2, parentPath = [], manifest = {}, allowInPlaceMutations = false) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $dbfbcf83869c9c18$export$f5708dca728d7177(route.index !== true || !route.children, `Cannot specify children on an index route`);
        $dbfbcf83869c9c18$export$f5708dca728d7177(allowInPlaceMutations || !manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($dbfbcf83869c9c18$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                id: id
            };
            manifest[id] = $dbfbcf83869c9c18$var$mergeRouteUpdates(indexRoute, mapRouteProperties2(indexRoute));
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                id: id,
                children: void 0
            };
            manifest[id] = $dbfbcf83869c9c18$var$mergeRouteUpdates(pathOrLayoutRoute, mapRouteProperties2(pathOrLayoutRoute));
            if (route.children) pathOrLayoutRoute.children = $dbfbcf83869c9c18$export$87cb1a9238dc3fba(route.children, mapRouteProperties2, treePath, manifest, allowInPlaceMutations);
            return pathOrLayoutRoute;
        }
    });
}
function $dbfbcf83869c9c18$var$mergeRouteUpdates(route, updates) {
    return Object.assign(route, {
        ...updates,
        ...typeof updates.lazy === "object" && updates.lazy != null ? {
            lazy: {
                ...route.lazy,
                ...updates.lazy
            }
        } : {}
    });
}
function $dbfbcf83869c9c18$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $dbfbcf83869c9c18$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $dbfbcf83869c9c18$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $dbfbcf83869c9c18$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $dbfbcf83869c9c18$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $dbfbcf83869c9c18$var$flattenRoutes(routes);
    $dbfbcf83869c9c18$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        let decoded = $dbfbcf83869c9c18$var$decodePath(pathname);
        matches = $dbfbcf83869c9c18$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $dbfbcf83869c9c18$var$convertRouteMatchToUiMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        loaderData: loaderData[route.id],
        handle: route.handle
    };
}
function $dbfbcf83869c9c18$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "", _hasParentOptionalSegments = false) {
    let flattenRoute = (route, index, hasParentOptionalSegments = _hasParentOptionalSegments, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            if (!meta.relativePath.startsWith(parentPath) && hasParentOptionalSegments) return;
            $dbfbcf83869c9c18$export$f5708dca728d7177(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $dbfbcf83869c9c18$var$joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            $dbfbcf83869c9c18$export$f5708dca728d7177(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $dbfbcf83869c9c18$var$flattenRoutes(route.children, branches, routesMeta, path, hasParentOptionalSegments);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $dbfbcf83869c9c18$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of $dbfbcf83869c9c18$var$explodeOptionalSegments(route.path))flattenRoute(route, index, true, exploded);
    });
    return branches;
}
function $dbfbcf83869c9c18$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $dbfbcf83869c9c18$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $dbfbcf83869c9c18$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $dbfbcf83869c9c18$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
var $dbfbcf83869c9c18$var$paramRe = /^:[\w-]+$/;
var $dbfbcf83869c9c18$var$dynamicSegmentValue = 3;
var $dbfbcf83869c9c18$var$indexRouteValue = 2;
var $dbfbcf83869c9c18$var$emptySegmentValue = 1;
var $dbfbcf83869c9c18$var$staticSegmentValue = 10;
var $dbfbcf83869c9c18$var$splatPenalty = -2;
var $dbfbcf83869c9c18$var$isSplat = (s)=>s === "*";
function $dbfbcf83869c9c18$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($dbfbcf83869c9c18$var$isSplat)) initialScore += $dbfbcf83869c9c18$var$splatPenalty;
    if (index) initialScore += $dbfbcf83869c9c18$var$indexRouteValue;
    return segments.filter((s)=>!$dbfbcf83869c9c18$var$isSplat(s)).reduce((score, segment)=>score + ($dbfbcf83869c9c18$var$paramRe.test(segment) ? $dbfbcf83869c9c18$var$dynamicSegmentValue : segment === "" ? $dbfbcf83869c9c18$var$emptySegmentValue : $dbfbcf83869c9c18$var$staticSegmentValue), initialScore);
}
function $dbfbcf83869c9c18$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $dbfbcf83869c9c18$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $dbfbcf83869c9c18$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $dbfbcf83869c9c18$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $dbfbcf83869c9c18$var$joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $dbfbcf83869c9c18$var$normalizePathname($dbfbcf83869c9c18$var$joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $dbfbcf83869c9c18$var$joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function $dbfbcf83869c9c18$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $dbfbcf83869c9c18$var$warning(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify2 = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") {
            const star = "*";
            return stringify2(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $dbfbcf83869c9c18$export$f5708dca728d7177(optional === "?" || param != null, `Missing ":${key}" param`);
            return encodeURIComponent(stringify2(param));
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
function $dbfbcf83869c9c18$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $dbfbcf83869c9c18$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo2, { paramName: paramName, isOptional: isOptional }, index)=>{
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $dbfbcf83869c9c18$var$compilePath(path, caseSensitive = false, end = true) {
    $dbfbcf83869c9c18$var$warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    }).replace(/\/([\w-]+)\?(\/|$)/g, "(/$1)?$2");
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function $dbfbcf83869c9c18$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $dbfbcf83869c9c18$var$warning(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $dbfbcf83869c9c18$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $dbfbcf83869c9c18$var$prependBasename({ basename: basename, pathname: pathname }) {
    return pathname === "/" ? basename : $dbfbcf83869c9c18$var$joinPaths([
        basename,
        pathname
    ]);
}
var $dbfbcf83869c9c18$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $dbfbcf83869c9c18$var$isAbsoluteUrl = (url)=>$dbfbcf83869c9c18$var$ABSOLUTE_URL_REGEX.test(url);
function $dbfbcf83869c9c18$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $dbfbcf83869c9c18$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        if ($dbfbcf83869c9c18$var$isAbsoluteUrl(toPathname)) pathname = toPathname;
        else {
            if (toPathname.includes("//")) {
                let oldPathname = toPathname;
                toPathname = toPathname.replace(/\/\/+/g, "/");
                $dbfbcf83869c9c18$var$warning(false, `Pathnames cannot have embedded double slashes - normalizing ${oldPathname} -> ${toPathname}`);
            }
            if (toPathname.startsWith("/")) pathname = $dbfbcf83869c9c18$var$resolvePathname(toPathname.substring(1), "/");
            else pathname = $dbfbcf83869c9c18$var$resolvePathname(toPathname, fromPathname);
        }
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $dbfbcf83869c9c18$var$normalizeSearch(search),
        hash: $dbfbcf83869c9c18$var$normalizeHash(hash)
    };
}
function $dbfbcf83869c9c18$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $dbfbcf83869c9c18$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $dbfbcf83869c9c18$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $dbfbcf83869c9c18$var$getResolveToMatches(matches) {
    let pathMatches = $dbfbcf83869c9c18$var$getPathContributingMatches(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $dbfbcf83869c9c18$var$resolveTo(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = $dbfbcf83869c9c18$export$8ccf933b0513f8d0(toArg);
    else {
        to = {
            ...toArg
        };
        $dbfbcf83869c9c18$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("?"), $dbfbcf83869c9c18$var$getInvalidPathError("?", "pathname", "search", to));
        $dbfbcf83869c9c18$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("#"), $dbfbcf83869c9c18$var$getInvalidPathError("#", "pathname", "hash", to));
        $dbfbcf83869c9c18$export$f5708dca728d7177(!to.search || !to.search.includes("#"), $dbfbcf83869c9c18$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $dbfbcf83869c9c18$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var $dbfbcf83869c9c18$var$joinPaths = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
var $dbfbcf83869c9c18$var$normalizePathname = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
var $dbfbcf83869c9c18$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
var $dbfbcf83869c9c18$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $dbfbcf83869c9c18$var$DataWithResponseInit = class {
    constructor(data2, init){
        this.type = "DataWithResponseInit";
        this.data = data2;
        this.init = init || null;
    }
};
function $dbfbcf83869c9c18$export$4051a07651545597(data2, init) {
    return new $dbfbcf83869c9c18$var$DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var $dbfbcf83869c9c18$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
var $dbfbcf83869c9c18$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $dbfbcf83869c9c18$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var $dbfbcf83869c9c18$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $dbfbcf83869c9c18$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var $dbfbcf83869c9c18$export$f2680fa305b734ca = class {
    constructor(status, statusText, data2, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data2 instanceof Error) {
            this.data = data2.toString();
            this.error = data2;
        } else this.data = data2;
    }
};
function $dbfbcf83869c9c18$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
function $dbfbcf83869c9c18$var$getRoutePattern(matches) {
    return matches.map((m)=>m.route.path).filter(Boolean).join("/").replace(/\/\/*/g, "/") || "/";
}
// lib/router/instrumentation.ts
var $dbfbcf83869c9c18$var$UninstrumentedSymbol = Symbol("Uninstrumented");
function $dbfbcf83869c9c18$var$getRouteInstrumentationUpdates(fns, route) {
    let aggregated = {
        lazy: [],
        "lazy.loader": [],
        "lazy.action": [],
        "lazy.middleware": [],
        middleware: [],
        loader: [],
        action: []
    };
    fns.forEach((fn)=>fn({
            id: route.id,
            index: route.index,
            path: route.path,
            instrument (i) {
                let keys = Object.keys(aggregated);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let updates = {};
    if (typeof route.lazy === "function" && aggregated.lazy.length > 0) {
        let instrumented = $dbfbcf83869c9c18$var$wrapImpl(aggregated.lazy, route.lazy, ()=>void 0);
        if (instrumented) updates.lazy = instrumented;
    }
    if (typeof route.lazy === "object") {
        let lazyObject = route.lazy;
        [
            "middleware",
            "loader",
            "action"
        ].forEach((key)=>{
            let lazyFn = lazyObject[key];
            let instrumentations = aggregated[`lazy.${key}`];
            if (typeof lazyFn === "function" && instrumentations.length > 0) {
                let instrumented = $dbfbcf83869c9c18$var$wrapImpl(instrumentations, lazyFn, ()=>void 0);
                if (instrumented) updates.lazy = Object.assign(updates.lazy || {}, {
                    [key]: instrumented
                });
            }
        });
    }
    [
        "loader",
        "action"
    ].forEach((key)=>{
        let handler = route[key];
        if (typeof handler === "function" && aggregated[key].length > 0) {
            let original = handler[$dbfbcf83869c9c18$var$UninstrumentedSymbol] ?? handler;
            let instrumented = $dbfbcf83869c9c18$var$wrapImpl(aggregated[key], original, (...args)=>$dbfbcf83869c9c18$var$getHandlerInfo(args[0]));
            if (instrumented) {
                instrumented[$dbfbcf83869c9c18$var$UninstrumentedSymbol] = original;
                updates[key] = instrumented;
            }
        }
    });
    if (route.middleware && route.middleware.length > 0 && aggregated.middleware.length > 0) updates.middleware = route.middleware.map((middleware)=>{
        let original = middleware[$dbfbcf83869c9c18$var$UninstrumentedSymbol] ?? middleware;
        let instrumented = $dbfbcf83869c9c18$var$wrapImpl(aggregated.middleware, original, (...args)=>$dbfbcf83869c9c18$var$getHandlerInfo(args[0]));
        if (instrumented) {
            instrumented[$dbfbcf83869c9c18$var$UninstrumentedSymbol] = original;
            return instrumented;
        }
        return middleware;
    });
    return updates;
}
function $dbfbcf83869c9c18$var$instrumentClientSideRouter(router, fns) {
    let aggregated = {
        navigate: [],
        fetch: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    if (aggregated.navigate.length > 0) {
        let navigate = router.navigate[$dbfbcf83869c9c18$var$UninstrumentedSymbol] ?? router.navigate;
        let instrumentedNavigate = $dbfbcf83869c9c18$var$wrapImpl(aggregated.navigate, navigate, (...args)=>{
            let [to, opts] = args;
            return {
                to: typeof to === "number" || typeof to === "string" ? to : to ? $dbfbcf83869c9c18$export$fe53371bee54353d(to) : ".",
                ...$dbfbcf83869c9c18$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedNavigate) {
            instrumentedNavigate[$dbfbcf83869c9c18$var$UninstrumentedSymbol] = navigate;
            router.navigate = instrumentedNavigate;
        }
    }
    if (aggregated.fetch.length > 0) {
        let fetch2 = router.fetch[$dbfbcf83869c9c18$var$UninstrumentedSymbol] ?? router.fetch;
        let instrumentedFetch = $dbfbcf83869c9c18$var$wrapImpl(aggregated.fetch, fetch2, (...args)=>{
            let [key, , href, opts] = args;
            return {
                href: href ?? ".",
                fetcherKey: key,
                ...$dbfbcf83869c9c18$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedFetch) {
            instrumentedFetch[$dbfbcf83869c9c18$var$UninstrumentedSymbol] = fetch2;
            router.fetch = instrumentedFetch;
        }
    }
    return router;
}
function $dbfbcf83869c9c18$export$8f7a8e481272777(handler, fns) {
    let aggregated = {
        request: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let instrumentedHandler = handler;
    if (aggregated.request.length > 0) instrumentedHandler = $dbfbcf83869c9c18$var$wrapImpl(aggregated.request, handler, (...args)=>{
        let [request, context] = args;
        return {
            request: $dbfbcf83869c9c18$var$getReadonlyRequest(request),
            context: context != null ? $dbfbcf83869c9c18$var$getReadonlyContext(context) : context
        };
    });
    return instrumentedHandler;
}
function $dbfbcf83869c9c18$var$wrapImpl(impls, handler, getInfo) {
    if (impls.length === 0) return null;
    return async (...args)=>{
        let result = await $dbfbcf83869c9c18$var$recurseRight(impls, getInfo(...args), ()=>handler(...args), impls.length - 1);
        if (result.type === "error") throw result.value;
        return result.value;
    };
}
async function $dbfbcf83869c9c18$var$recurseRight(impls, info, handler, index) {
    let impl = impls[index];
    let result;
    if (!impl) try {
        let value = await handler();
        result = {
            type: "success",
            value: value
        };
    } catch (e) {
        result = {
            type: "error",
            value: e
        };
    }
    else {
        let handlerPromise = void 0;
        let callHandler = async ()=>{
            if (handlerPromise) console.error("You cannot call instrumented handlers more than once");
            else handlerPromise = $dbfbcf83869c9c18$var$recurseRight(impls, info, handler, index - 1);
            result = await handlerPromise;
            $dbfbcf83869c9c18$export$f5708dca728d7177(result, "Expected a result");
            if (result.type === "error" && result.value instanceof Error) return {
                status: "error",
                error: result.value
            };
            return {
                status: "success",
                error: void 0
            };
        };
        try {
            await impl(callHandler, info);
        } catch (e) {
            console.error("An instrumentation function threw an error:", e);
        }
        if (!handlerPromise) await callHandler();
        await handlerPromise;
    }
    if (result) return result;
    return {
        type: "error",
        value: new Error("No result assigned in instrumentation chain.")
    };
}
function $dbfbcf83869c9c18$var$getHandlerInfo(args) {
    let { request: request, context: context, params: params, unstable_pattern: unstable_pattern } = args;
    return {
        request: $dbfbcf83869c9c18$var$getReadonlyRequest(request),
        params: {
            ...params
        },
        unstable_pattern: unstable_pattern,
        context: $dbfbcf83869c9c18$var$getReadonlyContext(context)
    };
}
function $dbfbcf83869c9c18$var$getRouterInfo(router, opts) {
    return {
        currentUrl: $dbfbcf83869c9c18$export$fe53371bee54353d(router.state.location),
        ..."formMethod" in opts ? {
            formMethod: opts.formMethod
        } : {},
        ..."formEncType" in opts ? {
            formEncType: opts.formEncType
        } : {},
        ..."formData" in opts ? {
            formData: opts.formData
        } : {},
        ..."body" in opts ? {
            body: opts.body
        } : {}
    };
}
function $dbfbcf83869c9c18$var$getReadonlyRequest(request) {
    return {
        method: request.method,
        url: request.url,
        headers: {
            get: (...args)=>request.headers.get(...args)
        }
    };
}
function $dbfbcf83869c9c18$var$getReadonlyContext(context) {
    if ($dbfbcf83869c9c18$var$isPlainObject(context)) {
        let frozen = {
            ...context
        };
        Object.freeze(frozen);
        return frozen;
    } else return {
        get: (ctx)=>context.get(ctx)
    };
}
var $dbfbcf83869c9c18$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $dbfbcf83869c9c18$var$isPlainObject(thing) {
    if (thing === null || typeof thing !== "object") return false;
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $dbfbcf83869c9c18$var$objectProtoNames;
}
// lib/router/router.ts
var $dbfbcf83869c9c18$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var $dbfbcf83869c9c18$var$validMutationMethods = new Set($dbfbcf83869c9c18$var$validMutationMethodsArr);
var $dbfbcf83869c9c18$var$validRequestMethodsArr = [
    "GET",
    ...$dbfbcf83869c9c18$var$validMutationMethodsArr
];
var $dbfbcf83869c9c18$var$validRequestMethods = new Set($dbfbcf83869c9c18$var$validRequestMethodsArr);
var $dbfbcf83869c9c18$var$redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var $dbfbcf83869c9c18$var$redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var $dbfbcf83869c9c18$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $dbfbcf83869c9c18$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $dbfbcf83869c9c18$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var $dbfbcf83869c9c18$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
var $dbfbcf83869c9c18$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var $dbfbcf83869c9c18$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
function $dbfbcf83869c9c18$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser2 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    $dbfbcf83869c9c18$export$f5708dca728d7177(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let hydrationRouteProperties2 = init.hydrationRouteProperties || [];
    let _mapRouteProperties = init.mapRouteProperties || $dbfbcf83869c9c18$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    if (init.unstable_instrumentations) {
        let instrumentations = init.unstable_instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$dbfbcf83869c9c18$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let manifest = {};
    let dataRoutes = $dbfbcf83869c9c18$export$87cb1a9238dc3fba(init.routes, mapRouteProperties2, void 0, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    if (!basename.startsWith("/")) basename = `/${basename}`;
    let dataStrategyImpl = init.dataStrategy || $dbfbcf83869c9c18$var$defaultDataStrategyWithMiddleware;
    let future = {
        ...init.future
    };
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let savedScrollPositions2 = null;
    let getScrollRestorationKey2 = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $dbfbcf83869c9c18$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    let initialized;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        let error = $dbfbcf83869c9c18$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $dbfbcf83869c9c18$var$getShortCircuitMatches(dataRoutes);
        initialized = true;
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    } else {
        if (initialMatches && !init.hydrationData) {
            let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            initialMatches = [];
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        } else if (initialMatches.some((m)=>m.route.lazy)) initialized = false;
        else if (!initialMatches.some((m)=>$dbfbcf83869c9c18$var$routeHasLoaderOrMiddleware(m.route))) initialized = true;
        else {
            let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            let errors = init.hydrationData ? init.hydrationData.errors : null;
            if (errors) {
                let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
                initialized = initialMatches.slice(0, idx + 1).every((m)=>!$dbfbcf83869c9c18$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
            } else initialized = initialMatches.every((m)=>!$dbfbcf83869c9c18$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        }
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $dbfbcf83869c9c18$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP" /* Pop */ ;
    let pendingPopstateNavigationDfd = null;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            $dbfbcf83869c9c18$var$warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $dbfbcf83869c9c18$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                pendingPopstateNavigationDfd?.resolve();
                pendingPopstateNavigationDfd = null;
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser2) {
            $dbfbcf83869c9c18$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$dbfbcf83869c9c18$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        if (newState.matches) newState.matches = newState.matches.map((m)=>{
            let route = manifest[m.route.id];
            let matchRoute = m.route;
            if (matchRoute.element !== route.element || matchRoute.errorElement !== route.errorElement || matchRoute.hydrateFallbackElement !== route.hydrateFallbackElement) return {
                ...m,
                route: route
            };
            return m;
        });
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                newErrors: newState.errors ?? null,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $dbfbcf83869c9c18$export$cbae47800eb95bc3(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $dbfbcf83869c9c18$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $dbfbcf83869c9c18$export$386d57f03f0b2883));
        }
        let restoreScrollPosition = isUninterruptedRevalidation ? false : getSavedScrollPosition(location, newState.matches || state.matches);
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $dbfbcf83869c9c18$export$cbae47800eb95bc3(state.navigation.formMethod) && location.state?._isRedirect !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = void 0;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */ ) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: // matches, errors, fetchers go through as-is
            actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $dbfbcf83869c9c18$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: restoreScrollPosition,
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        if (typeof to === "number") {
            if (!pendingPopstateNavigationDfd) pendingPopstateNavigationDfd = $dbfbcf83869c9c18$var$createDeferred();
            let promise = pendingPopstateNavigationDfd.promise;
            init.history.go(to);
            return promise;
        }
        let normalizedPath = $dbfbcf83869c9c18$var$normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative);
        let { path: path, submission: submission, error: error } = $dbfbcf83869c9c18$var$normalizeNavigateOptions(false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $dbfbcf83869c9c18$var$createLocation(state.location, path, opts && opts.state);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH" /* Push */ ;
        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
        else if (userReplace === false) ;
        else if (submission != null && $dbfbcf83869c9c18$export$cbae47800eb95bc3(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $dbfbcf83869c9c18$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $dbfbcf83869c9c18$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts?.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $dbfbcf83869c9c18$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        if (matches && state.initialized && !isRevalidationRequired && $dbfbcf83869c9c18$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $dbfbcf83869c9c18$export$cbae47800eb95bc3(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        pendingNavigationController = new AbortController();
        let request = $dbfbcf83869c9c18$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let scopedContext = init.getContext ? await init.getContext() : new $dbfbcf83869c9c18$export$b8d3e69d4b3eff04();
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $dbfbcf83869c9c18$var$findNearestBoundary(matches).route.id,
            {
                type: "error" /* error */ ,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $dbfbcf83869c9c18$export$cbae47800eb95bc3(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($dbfbcf83869c9c18$var$isErrorResult(result) && $dbfbcf83869c9c18$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $dbfbcf83869c9c18$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $dbfbcf83869c9c18$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$dbfbcf83869c9c18$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors
        });
    }
    async function handleAction(request, location, submission, matches, scopedContext, isFogOfWar, initialHydration, opts = {}) {
        interruptActiveLoads();
        let navigation = $dbfbcf83869c9c18$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $dbfbcf83869c9c18$var$getShortCircuitMatches(dataRoutes);
                    return {
                        matches: matches2,
                        pendingActionResult: [
                            route.id,
                            {
                                type: "error" /* error */ ,
                                error: discoverResult.error
                            }
                        ]
                    };
                }
                let boundaryId = $dbfbcf83869c9c18$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error" /* error */ ,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error" /* error */ ,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = $dbfbcf83869c9c18$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error" /* error */ ,
            error: $dbfbcf83869c9c18$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let dsMatches = $dbfbcf83869c9c18$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties2, scopedContext);
            let results = await callDataStrategy(request, dsMatches, scopedContext, null);
            result = results[actionMatch.route.id];
            if (!result) {
                for (let match of matches)if (results[match.route.id]) {
                    result = results[match.route.id];
                    break;
                }
            }
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($dbfbcf83869c9c18$var$isRedirectResult(result)) {
            let replace2;
            if (opts && opts.replace != null) replace2 = opts.replace;
            else {
                let location2 = $dbfbcf83869c9c18$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace2 = location2 === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        if ($dbfbcf83869c9c18$var$isErrorResult(result)) {
            let boundaryMatch = $dbfbcf83869c9c18$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result,
                    actionMatch.route.id
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult) {
        let loadingNavigation = overrideNavigation || $dbfbcf83869c9c18$var$getLoadingNavigation(location, submission);
        let activeSubmission = submission || fetcherSubmission || $dbfbcf83869c9c18$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $dbfbcf83869c9c18$var$getShortCircuitMatches(dataRoutes);
                    return {
                        matches: matches2,
                        loaderData: {},
                        errors: {
                            [route.id]: discoverResult.error
                        }
                    };
                }
                let boundaryId = $dbfbcf83869c9c18$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $dbfbcf83869c9c18$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties2, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, pendingActionResult);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (!init.dataStrategy && !dsMatches.some((m)=>m.shouldLoad) && !dsMatches.some((m)=>m.route.middleware && m.route.middleware.length > 0) && revalidatingFetchers.length === 0) {
            let updatedFetchers2 = markFetchRedirectsDone();
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $dbfbcf83869c9c18$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$dbfbcf83869c9c18$var$getActionDataForCommit(pendingActionResult),
                ...updatedFetchers2 ? {
                    fetchers: new Map(state.fetchers)
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, scopedContext);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect2 = $dbfbcf83869c9c18$var$findRedirect(loaderResults);
        if (redirect2) {
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        redirect2 = $dbfbcf83869c9c18$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        let { loaderData: loaderData, errors: errors } = $dbfbcf83869c9c18$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$dbfbcf83869c9c18$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $dbfbcf83869c9c18$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    async function fetch2(key, routeId, href, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $dbfbcf83869c9c18$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts?.relative);
        let matches = $dbfbcf83869c9c18$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $dbfbcf83869c9c18$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $dbfbcf83869c9c18$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let scopedContext = init.getContext ? await init.getContext() : new $dbfbcf83869c9c18$export$b8d3e69d4b3eff04();
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $dbfbcf83869c9c18$export$cbae47800eb95bc3(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        await handleFetcherLoader(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $dbfbcf83869c9c18$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $dbfbcf83869c9c18$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $dbfbcf83869c9c18$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else requestMatches = discoverResult.matches;
        }
        let match = $dbfbcf83869c9c18$var$getTargetMatch(requestMatches, path);
        if (!match.route.action && !match.route.lazy) {
            let error = $dbfbcf83869c9c18$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let fetchMatches = $dbfbcf83869c9c18$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, requestMatches, match, hydrationRouteProperties2, scopedContext);
        let actionResults = await callDataStrategy(fetchRequest, fetchMatches, scopedContext, key);
        let actionResult = actionResults[match.route.id];
        if (!actionResult) {
            for (let match2 of fetchMatches)if (actionResults[match2.route.id]) {
                actionResult = actionResults[match2.route.id];
                break;
            }
        }
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($dbfbcf83869c9c18$var$isRedirectResult(actionResult) || $dbfbcf83869c9c18$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $dbfbcf83869c9c18$var$getDoneFetcher(void 0));
                return;
            }
        } else {
            if ($dbfbcf83869c9c18$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, $dbfbcf83869c9c18$var$getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $dbfbcf83869c9c18$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($dbfbcf83869c9c18$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $dbfbcf83869c9c18$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $dbfbcf83869c9c18$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $dbfbcf83869c9c18$export$f5708dca728d7177(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $dbfbcf83869c9c18$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $dbfbcf83869c9c18$var$getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties2, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, [
            match.route.id,
            actionResult
        ]);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher2 = state.fetchers.get(staleKey);
            let revalidatingFetcher = $dbfbcf83869c9c18$var$getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, scopedContext);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        if (state.fetchers.has(key)) {
            let doneFetcher = $dbfbcf83869c9c18$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        let redirect2 = $dbfbcf83869c9c18$var$findRedirect(loaderResults);
        if (redirect2) return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect2 = $dbfbcf83869c9c18$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        let { loaderData: loaderData, errors: errors } = $dbfbcf83869c9c18$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults);
        abortStaleFetchLoads(loadId);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $dbfbcf83869c9c18$export$f5708dca728d7177(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $dbfbcf83869c9c18$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, routeId, path, matches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $dbfbcf83869c9c18$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $dbfbcf83869c9c18$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $dbfbcf83869c9c18$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else matches = discoverResult.matches;
        }
        let match = $dbfbcf83869c9c18$var$getTargetMatch(matches, path);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let dsMatches = $dbfbcf83869c9c18$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, matches, match, hydrationRouteProperties2, scopedContext);
        let results = await callDataStrategy(fetchRequest, dsMatches, scopedContext, key);
        let result = results[match.route.id];
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $dbfbcf83869c9c18$var$getDoneFetcher(void 0));
            return;
        }
        if ($dbfbcf83869c9c18$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $dbfbcf83869c9c18$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($dbfbcf83869c9c18$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $dbfbcf83869c9c18$var$getDoneFetcher(result.data));
    }
    async function startRedirectNavigation(request, redirect2, isNavigation, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace2 } = {}) {
        if (!isNavigation) {
            pendingPopstateNavigationDfd?.resolve();
            pendingPopstateNavigationDfd = null;
        }
        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect2.response.headers.get("Location");
        $dbfbcf83869c9c18$export$f5708dca728d7177(location, "Expected a Location header on the redirect Response");
        location = $dbfbcf83869c9c18$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $dbfbcf83869c9c18$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser2) {
            let isDocumentReload = false;
            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ($dbfbcf83869c9c18$var$isAbsoluteUrl(location)) {
                const url = $dbfbcf83869c9c18$var$createBrowserURLImpl(location, true);
                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $dbfbcf83869c9c18$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace2) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $dbfbcf83869c9c18$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($dbfbcf83869c9c18$var$redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && $dbfbcf83869c9c18$export$cbae47800eb95bc3(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else {
            let overrideNavigation = $dbfbcf83869c9c18$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectNavigationType, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
            });
        }
    }
    async function callDataStrategy(request, matches, scopedContext, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $dbfbcf83869c9c18$var$callDataStrategyImpl(dataStrategyImpl, request, matches, fetcherKey, scopedContext, false);
        } catch (e) {
            matches.filter((m)=>m.shouldLoad).forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error" /* error */ ,
                    error: e
                };
            });
            return dataResults;
        }
        if (request.signal.aborted) return dataResults;
        for (let [routeId, result] of Object.entries(results))if ($dbfbcf83869c9c18$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect" /* redirect */ ,
                response: $dbfbcf83869c9c18$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $dbfbcf83869c9c18$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, scopedContext) {
        let loaderResultsPromise = callDataStrategy(request, matches, scopedContext, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.request && f.controller) {
                let results = await callDataStrategy(f.request, f.matches, scopedContext, f.key);
                let result = results[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error" /* error */ ,
                    error: $dbfbcf83869c9c18$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $dbfbcf83869c9c18$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $dbfbcf83869c9c18$export$52eace9c284d3585;
    }
    function resetFetcher(key, opts) {
        abortFetcher(key, opts?.reason);
        updateFetcherState(key, $dbfbcf83869c9c18$var$getDoneFetcher(null));
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key, reason) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort(reason);
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $dbfbcf83869c9c18$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $dbfbcf83869c9c18$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $dbfbcf83869c9c18$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $dbfbcf83869c9c18$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $dbfbcf83869c9c18$export$386d57f03f0b2883;
        $dbfbcf83869c9c18$export$f5708dca728d7177(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) $dbfbcf83869c9c18$var$warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $dbfbcf83869c9c18$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $dbfbcf83869c9c18$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === $dbfbcf83869c9c18$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            let key = getScrollRestorationKey2(location, matches.map((m)=>$dbfbcf83869c9c18$var$convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (init.patchRoutesOnNavigation) {
            if (!matches) {
                let fogMatches = $dbfbcf83869c9c18$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                let partialMatches = $dbfbcf83869c9c18$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!init.patchRoutesOnNavigation) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await init.patchRoutesOnNavigation({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $dbfbcf83869c9c18$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties2, false);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $dbfbcf83869c9c18$export$2708184779ceb39d(routesToUse, pathname, basename);
            let newPartialMatches = null;
            if (newMatches) {
                if (Object.keys(newMatches[0].params).length === 0) return {
                    type: "success",
                    matches: newMatches
                };
                else {
                    newPartialMatches = $dbfbcf83869c9c18$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                    let matchedDeeper = newPartialMatches && partialMatches.length < newPartialMatches.length && compareMatches(partialMatches, newPartialMatches.slice(0, partialMatches.length));
                    if (!matchedDeeper) return {
                        type: "success",
                        matches: newMatches
                    };
                }
            }
            if (!newPartialMatches) newPartialMatches = $dbfbcf83869c9c18$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            if (!newPartialMatches || compareMatches(partialMatches, newPartialMatches)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function compareMatches(a, b) {
        return a.length === b.length && a.every((m, i)=>m.route.id === b[i].route.id);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $dbfbcf83869c9c18$export$87cb1a9238dc3fba(newRoutes, mapRouteProperties2, void 0, manifest);
    }
    function patchRoutes(routeId, children, unstable_allowElementMutations = false) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $dbfbcf83869c9c18$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2, unstable_allowElementMutations);
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch2,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        resetFetcher: resetFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes,
        _internalSetStateDoNotUseOrYouWillBreakYourApp (newState) {
            updateState(newState);
        }
    };
    if (init.unstable_instrumentations) router = $dbfbcf83869c9c18$var$instrumentClientSideRouter(router, init.unstable_instrumentations.map((i)=>i.router).filter(Boolean));
    return router;
}
function $dbfbcf83869c9c18$export$3336b097a6fbc59a(routes, opts) {
    $dbfbcf83869c9c18$export$f5708dca728d7177(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let _mapRouteProperties = opts?.mapRouteProperties || $dbfbcf83869c9c18$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    if (opts?.unstable_instrumentations) {
        let instrumentations = opts.unstable_instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$dbfbcf83869c9c18$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let dataRoutes = $dbfbcf83869c9c18$export$87cb1a9238dc3fba(routes, mapRouteProperties2, void 0, manifest);
    async function query(request, { requestContext: requestContext, filterMatchesToLoad: filterMatchesToLoad, skipLoaderErrorBubbling: skipLoaderErrorBubbling, skipRevalidation: skipRevalidation, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse } = {}) {
        let url = new URL(request.url);
        let method = request.method;
        let location = $dbfbcf83869c9c18$var$createLocation("", $dbfbcf83869c9c18$export$fe53371bee54353d(url), null, "default");
        let matches = $dbfbcf83869c9c18$export$2708184779ceb39d(dataRoutes, location, basename);
        requestContext = requestContext != null ? requestContext : new $dbfbcf83869c9c18$export$b8d3e69d4b3eff04();
        if (!$dbfbcf83869c9c18$var$isValidMethod(method) && method !== "HEAD") {
            let error = $dbfbcf83869c9c18$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $dbfbcf83869c9c18$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        } else if (!matches) {
            let error = $dbfbcf83869c9c18$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $dbfbcf83869c9c18$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        }
        if (generateMiddlewareResponse) {
            $dbfbcf83869c9c18$export$f5708dca728d7177(requestContext instanceof $dbfbcf83869c9c18$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            try {
                await $dbfbcf83869c9c18$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
                let renderedStaticContext;
                let response = await $dbfbcf83869c9c18$var$runServerMiddlewarePipeline({
                    request: request,
                    unstable_pattern: $dbfbcf83869c9c18$var$getRoutePattern(matches),
                    matches: matches,
                    params: matches[0].params,
                    // If we're calling middleware then it must be enabled so we can cast
                    // this to the proper type knowing it's not an `AppLoadContext`
                    context: requestContext
                }, async ()=>{
                    let res = await generateMiddlewareResponse(async (revalidationRequest, opts2 = {})=>{
                        let result2 = await queryImpl(revalidationRequest, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, "filterMatchesToLoad" in opts2 ? opts2.filterMatchesToLoad ?? null : filterMatchesToLoad ?? null, skipRevalidation === true);
                        if ($dbfbcf83869c9c18$export$3f1eb41d9a6a6a27(result2)) return result2;
                        renderedStaticContext = {
                            location: location,
                            basename: basename,
                            ...result2
                        };
                        return renderedStaticContext;
                    });
                    return res;
                }, async (error, routeId)=>{
                    if ($dbfbcf83869c9c18$export$6e80290866a84dd4(error)) return error;
                    if ($dbfbcf83869c9c18$export$3f1eb41d9a6a6a27(error)) try {
                        error = new $dbfbcf83869c9c18$export$f2680fa305b734ca(error.status, error.statusText, await $dbfbcf83869c9c18$var$parseResponseBody(error));
                    } catch (e) {
                        error = e;
                    }
                    if ($dbfbcf83869c9c18$export$e0163cfdf7bc9cfa(error)) error = $dbfbcf83869c9c18$var$dataWithResponseInitToErrorResponse(error);
                    if (renderedStaticContext) {
                        if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                        let staticContext = $dbfbcf83869c9c18$export$fec11da027c70692(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : $dbfbcf83869c9c18$var$findNearestBoundary(matches, routeId).route.id);
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    } else {
                        let boundaryRouteId = skipLoaderErrorBubbling ? routeId : $dbfbcf83869c9c18$var$findNearestBoundary(matches, matches.find((m)=>m.route.id === routeId || m.route.loader)?.route.id || routeId).route.id;
                        let staticContext = {
                            matches: matches,
                            location: location,
                            basename: basename,
                            loaderData: {},
                            actionData: null,
                            errors: {
                                [boundaryRouteId]: error
                            },
                            statusCode: $dbfbcf83869c9c18$export$972111febbeef05b(error) ? error.status : 500,
                            actionHeaders: {},
                            loaderHeaders: {}
                        };
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    }
                });
                $dbfbcf83869c9c18$export$f5708dca728d7177($dbfbcf83869c9c18$export$3f1eb41d9a6a6a27(response), "Expected a response in query()");
                return response;
            } catch (e) {
                if ($dbfbcf83869c9c18$export$3f1eb41d9a6a6a27(e)) return e;
                throw e;
            }
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
        if ($dbfbcf83869c9c18$export$3f1eb41d9a6a6a27(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result
        };
    }
    async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse } = {}) {
        let url = new URL(request.url);
        let method = request.method;
        let location = $dbfbcf83869c9c18$var$createLocation("", $dbfbcf83869c9c18$export$fe53371bee54353d(url), null, "default");
        let matches = $dbfbcf83869c9c18$export$2708184779ceb39d(dataRoutes, location, basename);
        requestContext = requestContext != null ? requestContext : new $dbfbcf83869c9c18$export$b8d3e69d4b3eff04();
        if (!$dbfbcf83869c9c18$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $dbfbcf83869c9c18$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $dbfbcf83869c9c18$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $dbfbcf83869c9c18$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $dbfbcf83869c9c18$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $dbfbcf83869c9c18$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        if (generateMiddlewareResponse) {
            $dbfbcf83869c9c18$export$f5708dca728d7177(requestContext instanceof $dbfbcf83869c9c18$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            await $dbfbcf83869c9c18$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
            let response = await $dbfbcf83869c9c18$var$runServerMiddlewarePipeline({
                request: request,
                unstable_pattern: $dbfbcf83869c9c18$var$getRoutePattern(matches),
                matches: matches,
                params: matches[0].params,
                // If we're calling middleware then it must be enabled so we can cast
                // this to the proper type knowing it's not an `AppLoadContext`
                context: requestContext
            }, async ()=>{
                let res = await generateMiddlewareResponse(async (innerRequest)=>{
                    let result2 = await queryImpl(innerRequest, location, matches, requestContext, dataStrategy || null, false, match, null, false);
                    let processed = handleQueryResult(result2);
                    return $dbfbcf83869c9c18$export$3f1eb41d9a6a6a27(processed) ? processed : typeof processed === "string" ? new Response(processed) : Response.json(processed);
                });
                return res;
            }, (error)=>{
                if ($dbfbcf83869c9c18$export$e0163cfdf7bc9cfa(error)) return Promise.resolve($dbfbcf83869c9c18$var$dataWithResponseInitToResponse(error));
                if ($dbfbcf83869c9c18$export$3f1eb41d9a6a6a27(error)) return Promise.resolve(error);
                throw error;
            });
            return response;
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false);
        return handleQueryResult(result);
        function handleQueryResult(result2) {
            if ($dbfbcf83869c9c18$export$3f1eb41d9a6a6a27(result2)) return result2;
            let error = result2.errors ? Object.values(result2.errors)[0] : void 0;
            if (error !== void 0) throw error;
            if (result2.actionData) return Object.values(result2.actionData)[0];
            if (result2.loaderData) return Object.values(result2.loaderData)[0];
            return void 0;
        }
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        $dbfbcf83869c9c18$export$f5708dca728d7177(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($dbfbcf83869c9c18$export$cbae47800eb95bc3(request.method)) {
                let result2 = await submit(request, matches, routeMatch || $dbfbcf83869c9c18$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation);
                return result2;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad);
            return $dbfbcf83869c9c18$export$3f1eb41d9a6a6a27(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($dbfbcf83869c9c18$var$isDataStrategyResult(e) && $dbfbcf83869c9c18$export$3f1eb41d9a6a6a27(e.result)) {
                if (e.type === "error" /* error */ ) throw e.result;
                return e.result;
            }
            if ($dbfbcf83869c9c18$export$6e80290866a84dd4(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $dbfbcf83869c9c18$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error" /* error */ ,
                error: error
            };
        } else {
            let dsMatches = $dbfbcf83869c9c18$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, actionMatch, [], requestContext);
            let results = await callDataStrategy(request, dsMatches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $dbfbcf83869c9c18$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($dbfbcf83869c9c18$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($dbfbcf83869c9c18$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if (skipRevalidation) {
            if ($dbfbcf83869c9c18$var$isErrorResult(result)) {
                let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $dbfbcf83869c9c18$var$findNearestBoundary(matches, actionMatch.route.id);
                return {
                    statusCode: $dbfbcf83869c9c18$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                    actionData: null,
                    actionHeaders: {
                        ...result.headers ? {
                            [actionMatch.route.id]: result.headers
                        } : {}
                    },
                    matches: matches,
                    loaderData: {},
                    errors: {
                        [boundaryMatch.route.id]: result.error
                    },
                    loaderHeaders: {}
                };
            } else return {
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                actionHeaders: result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {},
                matches: matches,
                loaderData: {},
                errors: null,
                statusCode: result.statusCode || 200,
                loaderHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($dbfbcf83869c9c18$var$isErrorResult(result)) {
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $dbfbcf83869c9c18$var$findNearestBoundary(matches, actionMatch.route.id);
            let handlerContext2 = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                boundaryMatch.route.id,
                result
            ]);
            return {
                ...handlerContext2,
                statusCode: $dbfbcf83869c9c18$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: {
                    ...result.headers ? {
                        [actionMatch.route.id]: result.headers
                    } : {}
                }
            };
        }
        let handlerContext = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad);
        return {
            ...handlerContext,
            actionData: {
                [actionMatch.route.id]: result.data
            },
            // action status codes take precedence over loader status codes
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw $dbfbcf83869c9c18$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let dsMatches;
        if (routeMatch) dsMatches = $dbfbcf83869c9c18$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, routeMatch, [], requestContext);
        else {
            let maxIdx = pendingActionResult && $dbfbcf83869c9c18$var$isErrorResult(pendingActionResult[1]) ? // Up to but not including the boundary
            matches.findIndex((m)=>m.route.id === pendingActionResult[0]) - 1 : void 0;
            let pattern = $dbfbcf83869c9c18$var$getRoutePattern(matches);
            dsMatches = matches.map((match, index)=>{
                if (maxIdx != null && index > maxIdx) return $dbfbcf83869c9c18$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, [], requestContext, false);
                return $dbfbcf83869c9c18$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
            });
        }
        if (!dataStrategy && !dsMatches.some((m)=>m.shouldLoad)) return {
            matches: matches,
            loaderData: {},
            errors: pendingActionResult && $dbfbcf83869c9c18$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy(request, dsMatches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $dbfbcf83869c9c18$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        let handlerContext = $dbfbcf83869c9c18$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
        return {
            ...handlerContext,
            matches: matches
        };
    }
    async function callDataStrategy(request, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $dbfbcf83869c9c18$var$callDataStrategyImpl(dataStrategy || $dbfbcf83869c9c18$var$defaultDataStrategy, request, matches, null, requestContext, true);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($dbfbcf83869c9c18$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $dbfbcf83869c9c18$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if (isRouteRequest) {
                if ($dbfbcf83869c9c18$export$3f1eb41d9a6a6a27(result.result)) throw result;
                else if ($dbfbcf83869c9c18$export$e0163cfdf7bc9cfa(result.result)) throw $dbfbcf83869c9c18$var$dataWithResponseInitToResponse(result.result);
            }
            dataResults[match.route.id] = await $dbfbcf83869c9c18$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
function $dbfbcf83869c9c18$export$fec11da027c70692(routes, handlerContext, error, boundaryId) {
    let errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return {
        ...handlerContext,
        statusCode: $dbfbcf83869c9c18$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [errorBoundaryId]: error
        }
    };
}
function $dbfbcf83869c9c18$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(`${method}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $dbfbcf83869c9c18$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $dbfbcf83869c9c18$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = $dbfbcf83869c9c18$var$resolveTo(to ? to : ".", $dbfbcf83869c9c18$var$getResolveToMatches(contextualMatches), $dbfbcf83869c9c18$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $dbfbcf83869c9c18$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = $dbfbcf83869c9c18$var$prependBasename({
        basename: basename,
        pathname: path.pathname
    });
    return $dbfbcf83869c9c18$export$fe53371bee54353d(path);
}
function $dbfbcf83869c9c18$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$dbfbcf83869c9c18$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$dbfbcf83869c9c18$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $dbfbcf83869c9c18$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $dbfbcf83869c9c18$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = rawFormMethod.toUpperCase();
    let formAction = $dbfbcf83869c9c18$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$dbfbcf83869c9c18$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}
`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$dbfbcf83869c9c18$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $dbfbcf83869c9c18$export$f5708dca728d7177(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $dbfbcf83869c9c18$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $dbfbcf83869c9c18$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $dbfbcf83869c9c18$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $dbfbcf83869c9c18$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($dbfbcf83869c9c18$export$cbae47800eb95bc3(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = $dbfbcf83869c9c18$export$8ccf933b0513f8d0(path);
    if (isFetcher && parsedPath.search && $dbfbcf83869c9c18$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: $dbfbcf83869c9c18$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
function $dbfbcf83869c9c18$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, hasPatchRoutesOnNavigation, pendingActionResult) {
    let actionResult = pendingActionResult ? $dbfbcf83869c9c18$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let maxIdx;
    if (initialHydration && state.errors) {
        let boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId);
    } else if (pendingActionResult && $dbfbcf83869c9c18$var$isErrorResult(pendingActionResult[1])) {
        let boundaryId = pendingActionResult[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId) - 1;
    }
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let baseShouldRevalidateArgs = {
        currentUrl: currentUrl,
        currentParams: state.matches[0]?.params || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params,
        ...submission,
        actionResult: actionResult,
        actionStatus: actionStatus
    };
    let pattern = $dbfbcf83869c9c18$var$getRoutePattern(matches);
    let dsMatches = matches.map((match, index)=>{
        let { route: route } = match;
        let forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (!$dbfbcf83869c9c18$var$routeHasLoaderOrMiddleware(route)) forceShouldLoad = false;
        else if (initialHydration) forceShouldLoad = $dbfbcf83869c9c18$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        else if ($dbfbcf83869c9c18$var$isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return $dbfbcf83869c9c18$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        let defaultShouldRevalidate = shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
        isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
        currentUrl.search !== nextUrl.search || $dbfbcf83869c9c18$var$isNewRouteInstance(state.matches[index], match);
        let shouldRevalidateArgs = {
            ...baseShouldRevalidateArgs,
            defaultShouldRevalidate: defaultShouldRevalidate
        };
        let shouldLoad = $dbfbcf83869c9c18$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        return $dbfbcf83869c9c18$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs);
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key)) return;
        let fetcher = state.fetchers.get(key);
        let isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        let fetcherMatches = $dbfbcf83869c9c18$export$2708184779ceb39d(routesToUse, f.path, basename);
        if (!fetcherMatches) {
            if (hasPatchRoutesOnNavigation && isMidInitialLoad) return;
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        let fetcherMatch = $dbfbcf83869c9c18$var$getTargetMatch(fetcherMatches, f.path);
        let fetchController = new AbortController();
        let fetchRequest = $dbfbcf83869c9c18$var$createClientSideRequest(history, f.path, fetchController.signal);
        let fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = $dbfbcf83869c9c18$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = $dbfbcf83869c9c18$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            let shouldRevalidateArgs = {
                ...baseShouldRevalidateArgs,
                defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
            };
            if ($dbfbcf83869c9c18$var$shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = $dbfbcf83869c9c18$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function $dbfbcf83869c9c18$var$routeHasLoaderOrMiddleware(route) {
    return route.loader != null || route.middleware != null && route.middleware.length > 0;
}
function $dbfbcf83869c9c18$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    if (route.lazy) return true;
    if (!$dbfbcf83869c9c18$var$routeHasLoaderOrMiddleware(route)) return false;
    let hasData = loaderData != null && route.id in loaderData;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return false;
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    return !hasData && !hasError;
}
function $dbfbcf83869c9c18$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $dbfbcf83869c9c18$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $dbfbcf83869c9c18$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $dbfbcf83869c9c18$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2, allowElementMutations) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $dbfbcf83869c9c18$export$f5708dca728d7177(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    let uniqueChildren = [];
    let existingChildren = [];
    children.forEach((newRoute)=>{
        let existingRoute = childrenToPatch.find((existingRoute2)=>$dbfbcf83869c9c18$var$isSameRoute(newRoute, existingRoute2));
        if (existingRoute) existingChildren.push({
            existingRoute: existingRoute,
            newRoute: newRoute
        });
        else uniqueChildren.push(newRoute);
    });
    if (uniqueChildren.length > 0) {
        let newRoutes = $dbfbcf83869c9c18$export$87cb1a9238dc3fba(uniqueChildren, mapRouteProperties2, [
            routeId || "_",
            "patch",
            String(childrenToPatch?.length || "0")
        ], manifest);
        childrenToPatch.push(...newRoutes);
    }
    if (allowElementMutations && existingChildren.length > 0) for(let i = 0; i < existingChildren.length; i++){
        let { existingRoute: existingRoute, newRoute: newRoute } = existingChildren[i];
        let existingRouteTyped = existingRoute;
        let [newRouteTyped] = $dbfbcf83869c9c18$export$87cb1a9238dc3fba([
            newRoute
        ], mapRouteProperties2, [], // Doesn't matter for mutated routes since they already have an id
        {}, // Don't touch the manifest here since we're updating in place
        true);
        Object.assign(existingRouteTyped, {
            element: newRouteTyped.element ? newRouteTyped.element : existingRouteTyped.element,
            errorElement: newRouteTyped.errorElement ? newRouteTyped.errorElement : existingRouteTyped.errorElement,
            hydrateFallbackElement: newRouteTyped.hydrateFallbackElement ? newRouteTyped.hydrateFallbackElement : existingRouteTyped.hydrateFallbackElement
        });
    }
}
function $dbfbcf83869c9c18$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children.every((aChild, i)=>existingRoute.children?.some((bChild)=>$dbfbcf83869c9c18$var$isSameRoute(aChild, bChild)));
}
var $dbfbcf83869c9c18$var$lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
var $dbfbcf83869c9c18$var$loadLazyRouteProperty = ({ key: key, route: route, manifest: manifest, mapRouteProperties: mapRouteProperties2 })=>{
    let routeToUpdate = manifest[route.id];
    $dbfbcf83869c9c18$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || typeof routeToUpdate.lazy !== "object") return;
    let lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    let cache = $dbfbcf83869c9c18$var$lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        $dbfbcf83869c9c18$var$lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    let cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    let propertyPromise = (async ()=>{
        let isUnsupported = $dbfbcf83869c9c18$var$isUnsupportedLazyRouteObjectKey(key);
        let staticRouteValue = routeToUpdate[key];
        let isStaticallyDefined = staticRouteValue !== void 0 && key !== "hasErrorBoundary";
        if (isUnsupported) {
            $dbfbcf83869c9c18$var$warning(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
            cache[key] = Promise.resolve();
        } else if (isStaticallyDefined) $dbfbcf83869c9c18$var$warning(false, `Route "${routeToUpdate.id}" has a static property "${key}" defined. The lazy property will be ignored.`);
        else {
            let value = await lazyFn();
            if (value != null) {
                Object.assign(routeToUpdate, {
                    [key]: value
                });
                Object.assign(routeToUpdate, mapRouteProperties2(routeToUpdate));
            }
        }
        if (typeof routeToUpdate.lazy === "object") {
            routeToUpdate.lazy[key] = void 0;
            if (Object.values(routeToUpdate.lazy).every((value)=>value === void 0)) routeToUpdate.lazy = void 0;
        }
    })();
    cache[key] = propertyPromise;
    return propertyPromise;
};
var $dbfbcf83869c9c18$var$lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
function $dbfbcf83869c9c18$var$loadLazyRoute(route, type, manifest, mapRouteProperties2, lazyRoutePropertiesToSkip) {
    let routeToUpdate = manifest[route.id];
    $dbfbcf83869c9c18$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        let cachedPromise = $dbfbcf83869c9c18$var$lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        let lazyRoutePromise2 = (async ()=>{
            $dbfbcf83869c9c18$export$f5708dca728d7177(typeof route.lazy === "function", "No lazy route function found");
            let lazyRoute = await route.lazy();
            let routeUpdates = {};
            for(let lazyRouteProperty in lazyRoute){
                let lazyValue = lazyRoute[lazyRouteProperty];
                if (lazyValue === void 0) continue;
                let isUnsupported = $dbfbcf83869c9c18$var$isUnsupportedLazyRouteFunctionKey(lazyRouteProperty);
                let staticRouteValue = routeToUpdate[lazyRouteProperty];
                let isStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
                // on the route updates
                lazyRouteProperty !== "hasErrorBoundary";
                if (isUnsupported) $dbfbcf83869c9c18$var$warning(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                else if (isStaticallyDefined) $dbfbcf83869c9c18$var$warning(!isStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
                else routeUpdates[lazyRouteProperty] = lazyValue;
            }
            Object.assign(routeToUpdate, routeUpdates);
            Object.assign(routeToUpdate, {
                // To keep things framework agnostic, we use the provided `mapRouteProperties`
                // function to set the framework-aware properties (`element`/`hasErrorBoundary`)
                // since the logic will differ between frameworks.
                ...mapRouteProperties2(routeToUpdate),
                lazy: void 0
            });
        })();
        $dbfbcf83869c9c18$var$lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise2);
        lazyRoutePromise2.catch(()=>{});
        return {
            lazyRoutePromise: lazyRoutePromise2,
            lazyHandlerPromise: lazyRoutePromise2
        };
    }
    let lazyKeys = Object.keys(route.lazy);
    let lazyPropertyPromises = [];
    let lazyHandlerPromise = void 0;
    for (let key of lazyKeys){
        if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
        let promise = $dbfbcf83869c9c18$var$loadLazyRouteProperty({
            key: key,
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
        if (promise) {
            lazyPropertyPromises.push(promise);
            if (key === type) lazyHandlerPromise = promise;
        }
    }
    let lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(()=>{}) : void 0;
    lazyRoutePromise?.catch(()=>{});
    lazyHandlerPromise?.catch(()=>{});
    return {
        lazyRoutePromise: lazyRoutePromise,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function $dbfbcf83869c9c18$var$isNonNullable(value) {
    return value !== void 0;
}
function $dbfbcf83869c9c18$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2) {
    let promises = matches.map(({ route: route })=>{
        if (typeof route.lazy !== "object" || !route.lazy.middleware) return void 0;
        return $dbfbcf83869c9c18$var$loadLazyRouteProperty({
            key: "middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
    }).filter($dbfbcf83869c9c18$var$isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
async function $dbfbcf83869c9c18$var$defaultDataStrategy(args) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldLoad);
    let keyedResults = {};
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    results.forEach((result, i)=>{
        keyedResults[matchesToLoad[i].route.id] = result;
    });
    return keyedResults;
}
async function $dbfbcf83869c9c18$var$defaultDataStrategyWithMiddleware(args) {
    if (!args.matches.some((m)=>m.route.middleware)) return $dbfbcf83869c9c18$var$defaultDataStrategy(args);
    return $dbfbcf83869c9c18$var$runClientMiddlewarePipeline(args, ()=>$dbfbcf83869c9c18$var$defaultDataStrategy(args));
}
function $dbfbcf83869c9c18$var$runServerMiddlewarePipeline(args, handler, errorHandler) {
    return $dbfbcf83869c9c18$var$runMiddlewarePipeline(args, handler, processResult, $dbfbcf83869c9c18$export$3f1eb41d9a6a6a27, errorHandler);
    function processResult(result) {
        return $dbfbcf83869c9c18$export$e0163cfdf7bc9cfa(result) ? $dbfbcf83869c9c18$var$dataWithResponseInitToResponse(result) : result;
    }
}
function $dbfbcf83869c9c18$var$runClientMiddlewarePipeline(args, handler) {
    return $dbfbcf83869c9c18$var$runMiddlewarePipeline(args, handler, (r)=>r, // No post-processing needed on the client
    $dbfbcf83869c9c18$var$isDataStrategyResults, errorHandler);
    function errorHandler(error, routeId, nextResult) {
        if (nextResult) return Promise.resolve(Object.assign(nextResult.value, {
            [routeId]: {
                type: "error",
                result: error
            }
        }));
        else {
            let { matches: matches } = args;
            let maxBoundaryIdx = Math.min(// Throwing route
            Math.max(matches.findIndex((m)=>m.route.id === routeId), 0), // or the shallowest route that needs to load data
            Math.max(matches.findIndex((m)=>m.shouldCallHandler()), 0));
            let boundaryRouteId = $dbfbcf83869c9c18$var$findNearestBoundary(matches, matches[maxBoundaryIdx].route.id).route.id;
            return Promise.resolve({
                [boundaryRouteId]: {
                    type: "error",
                    result: error
                }
            });
        }
    }
}
async function $dbfbcf83869c9c18$var$runMiddlewarePipeline(args, handler, processResult, isResult, errorHandler) {
    let { matches: matches, request: request, params: params, context: context, unstable_pattern: unstable_pattern } = args;
    let tuples = matches.flatMap((m)=>m.route.middleware ? m.route.middleware.map((fn)=>[
                m.route.id,
                fn
            ]) : []);
    let result = await $dbfbcf83869c9c18$var$callRouteMiddleware({
        request: request,
        params: params,
        context: context,
        unstable_pattern: unstable_pattern
    }, tuples, handler, processResult, isResult, errorHandler);
    return result;
}
async function $dbfbcf83869c9c18$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx = 0) {
    let { request: request } = args;
    if (request.signal.aborted) throw request.signal.reason ?? new Error(`Request aborted: ${request.method} ${request.url}`);
    let tuple = middlewares[idx];
    if (!tuple) {
        let result = await handler();
        return result;
    }
    let [routeId, middleware] = tuple;
    let nextResult;
    let next = async ()=>{
        if (nextResult) throw new Error("You may only call `next()` once per middleware");
        try {
            let result = await $dbfbcf83869c9c18$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx + 1);
            nextResult = {
                value: result
            };
            return nextResult.value;
        } catch (error) {
            nextResult = {
                value: await errorHandler(error, routeId, nextResult)
            };
            return nextResult.value;
        }
    };
    try {
        let value = await middleware(args, next);
        let result = value != null ? processResult(value) : void 0;
        if (isResult(result)) return result;
        else if (nextResult) return result ?? nextResult.value;
        else {
            nextResult = {
                value: await next()
            };
            return nextResult.value;
        }
    } catch (error) {
        let response = await errorHandler(error, routeId, nextResult);
        return response;
    }
}
function $dbfbcf83869c9c18$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip) {
    let lazyMiddlewarePromise = $dbfbcf83869c9c18$var$loadLazyRouteProperty({
        key: "middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties2
    });
    let lazyRoutePromises = $dbfbcf83869c9c18$var$loadLazyRoute(match.route, $dbfbcf83869c9c18$export$cbae47800eb95bc3(request.method) ? "action" : "loader", manifest, mapRouteProperties2, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function $dbfbcf83869c9c18$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, unstable_pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs = null) {
    let isUsingNewApi = false;
    let _lazyPromises = $dbfbcf83869c9c18$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip);
    return {
        ...match,
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        shouldRevalidateArgs: shouldRevalidateArgs,
        shouldCallHandler (defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!shouldRevalidateArgs) return shouldLoad;
            if (typeof defaultShouldRevalidate === "boolean") return $dbfbcf83869c9c18$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
            return $dbfbcf83869c9c18$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        },
        resolve (handlerOverride) {
            let { lazy: lazy, loader: loader, middleware: middleware } = match.route;
            let callHandler = isUsingNewApi || shouldLoad || handlerOverride && !$dbfbcf83869c9c18$export$cbae47800eb95bc3(request.method) && (lazy || loader);
            let isMiddlewareOnlyRoute = middleware && middleware.length > 0 && !loader && !lazy;
            if (callHandler && ($dbfbcf83869c9c18$export$cbae47800eb95bc3(request.method) || !isMiddlewareOnlyRoute)) return $dbfbcf83869c9c18$var$callLoaderOrAction({
                request: request,
                unstable_pattern: unstable_pattern,
                match: match,
                lazyHandlerPromise: _lazyPromises?.handler,
                lazyRoutePromise: _lazyPromises?.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data" /* data */ ,
                result: void 0
            });
        }
    };
}
function $dbfbcf83869c9c18$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs = null) {
    return matches.map((match)=>{
        if (match.route.id !== targetMatch.route.id) return {
            ...match,
            shouldLoad: false,
            shouldRevalidateArgs: shouldRevalidateArgs,
            shouldCallHandler: ()=>false,
            _lazyPromises: $dbfbcf83869c9c18$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: ()=>Promise.resolve({
                    type: "data",
                    result: void 0
                })
        };
        return $dbfbcf83869c9c18$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, $dbfbcf83869c9c18$var$getRoutePattern(matches), match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
async function $dbfbcf83869c9c18$var$callDataStrategyImpl(dataStrategyImpl, request, matches, fetcherKey, scopedContext, isStaticHandler) {
    if (matches.some((m)=>m._lazyPromises?.middleware)) await Promise.all(matches.map((m)=>m._lazyPromises?.middleware));
    let dataStrategyArgs = {
        request: request,
        unstable_pattern: $dbfbcf83869c9c18$var$getRoutePattern(matches),
        params: matches[0].params,
        context: scopedContext,
        matches: matches
    };
    let runClientMiddleware = isStaticHandler ? ()=>{
        throw new Error("You cannot call `runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
    } : (cb)=>{
        let typedDataStrategyArgs = dataStrategyArgs;
        return $dbfbcf83869c9c18$var$runClientMiddlewarePipeline(typedDataStrategyArgs, ()=>{
            return cb({
                ...typedDataStrategyArgs,
                fetcherKey: fetcherKey,
                runClientMiddleware: ()=>{
                    throw new Error("Cannot call `runClientMiddleware()` from within an `runClientMiddleware` handler");
                }
            });
        });
    };
    let results = await dataStrategyImpl({
        ...dataStrategyArgs,
        fetcherKey: fetcherKey,
        runClientMiddleware: runClientMiddleware
    });
    try {
        await Promise.all(matches.flatMap((m)=>[
                m._lazyPromises?.handler,
                m._lazyPromises?.route
            ]));
    } catch (e) {}
    return results;
}
async function $dbfbcf83869c9c18$var$callLoaderOrAction({ request: request, unstable_pattern: unstable_pattern, match: match, lazyHandlerPromise: lazyHandlerPromise, lazyRoutePromise: lazyRoutePromise, handlerOverride: handlerOverride, scopedContext: scopedContext }) {
    let result;
    let onReject;
    let isAction = $dbfbcf83869c9c18$export$cbae47800eb95bc3(request.method);
    let type = isAction ? "action" : "loader";
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                unstable_pattern: unstable_pattern,
                params: match.params,
                context: scopedContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = isAction ? match.route.action : match.route.loader;
        if (lazyHandlerPromise || lazyRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    // Ensure all lazy route promises are resolved before continuing
                    lazyHandlerPromise,
                    lazyRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await lazyHandlerPromise;
                let handler2 = isAction ? match.route.action : match.route.loader;
                if (handler2) [result] = await Promise.all([
                    runHandler(handler2),
                    lazyRoutePromise
                ]);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $dbfbcf83869c9c18$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data" /* data */ ,
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $dbfbcf83869c9c18$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error" /* error */ ,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $dbfbcf83869c9c18$var$parseResponseBody(response) {
    let contentType = response.headers.get("Content-Type");
    if (contentType && /\bapplication\/json\b/.test(contentType)) return response.body == null ? null : response.json();
    return response.text();
}
async function $dbfbcf83869c9c18$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($dbfbcf83869c9c18$export$3f1eb41d9a6a6a27(result)) {
        let data2;
        try {
            data2 = await $dbfbcf83869c9c18$var$parseResponseBody(result);
        } catch (e) {
            return {
                type: "error" /* error */ ,
                error: e
            };
        }
        if (type === "error" /* error */ ) return {
            type: "error" /* error */ ,
            error: new $dbfbcf83869c9c18$export$f2680fa305b734ca(result.status, result.statusText, data2),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data" /* data */ ,
            data: data2,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error" /* error */ ) {
        if ($dbfbcf83869c9c18$export$e0163cfdf7bc9cfa(result)) {
            if (result.data instanceof Error) return {
                type: "error" /* error */ ,
                error: result.data,
                statusCode: result.init?.status,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
            return {
                type: "error" /* error */ ,
                error: $dbfbcf83869c9c18$var$dataWithResponseInitToErrorResponse(result),
                statusCode: $dbfbcf83869c9c18$export$972111febbeef05b(result) ? result.status : void 0,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
        }
        return {
            type: "error" /* error */ ,
            error: result,
            statusCode: $dbfbcf83869c9c18$export$972111febbeef05b(result) ? result.status : void 0
        };
    }
    if ($dbfbcf83869c9c18$export$e0163cfdf7bc9cfa(result)) return {
        type: "data" /* data */ ,
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data" /* data */ ,
        data: result
    };
}
function $dbfbcf83869c9c18$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    $dbfbcf83869c9c18$export$f5708dca728d7177(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$dbfbcf83869c9c18$var$isAbsoluteUrl(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $dbfbcf83869c9c18$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
function $dbfbcf83869c9c18$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($dbfbcf83869c9c18$var$isAbsoluteUrl(location)) {
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $dbfbcf83869c9c18$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
function $dbfbcf83869c9c18$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($dbfbcf83869c9c18$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $dbfbcf83869c9c18$export$cbae47800eb95bc3(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $dbfbcf83869c9c18$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $dbfbcf83869c9c18$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $dbfbcf83869c9c18$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $dbfbcf83869c9c18$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $dbfbcf83869c9c18$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $dbfbcf83869c9c18$export$f5708dca728d7177(!$dbfbcf83869c9c18$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($dbfbcf83869c9c18$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $dbfbcf83869c9c18$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $dbfbcf83869c9c18$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = $dbfbcf83869c9c18$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $dbfbcf83869c9c18$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults) {
    let { loaderData: loaderData, errors: errors } = $dbfbcf83869c9c18$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.filter((f)=>!f.matches || f.matches.some((m)=>m.shouldLoad)).forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        if (controller && controller.signal.aborted) return;
        let result = fetcherResults[key];
        $dbfbcf83869c9c18$export$f5708dca728d7177(result, "Did not find corresponding fetcher result");
        if ($dbfbcf83869c9c18$var$isErrorResult(result)) {
            let boundaryMatch = $dbfbcf83869c9c18$var$findNearestBoundary(state.matches, match?.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            state.fetchers.delete(key);
        } else if ($dbfbcf83869c9c18$var$isRedirectResult(result)) $dbfbcf83869c9c18$export$f5708dca728d7177(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $dbfbcf83869c9c18$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $dbfbcf83869c9c18$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $dbfbcf83869c9c18$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $dbfbcf83869c9c18$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $dbfbcf83869c9c18$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $dbfbcf83869c9c18$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $dbfbcf83869c9c18$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $dbfbcf83869c9c18$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new $dbfbcf83869c9c18$export$f2680fa305b734ca(status || 500, statusText, new Error(errorMessage), true);
}
function $dbfbcf83869c9c18$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($dbfbcf83869c9c18$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $dbfbcf83869c9c18$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $dbfbcf83869c9c18$export$8ccf933b0513f8d0(path) : path;
    return $dbfbcf83869c9c18$export$fe53371bee54353d({
        ...parsedPath,
        hash: ""
    });
}
function $dbfbcf83869c9c18$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $dbfbcf83869c9c18$var$dataWithResponseInitToResponse(data2) {
    return Response.json(data2.data, data2.init ?? void 0);
}
function $dbfbcf83869c9c18$var$dataWithResponseInitToErrorResponse(data2) {
    return new $dbfbcf83869c9c18$export$f2680fa305b734ca(data2.init?.status ?? 500, data2.init?.statusText ?? "Internal Server Error", data2.data);
}
function $dbfbcf83869c9c18$var$isDataStrategyResults(result) {
    return result != null && typeof result === "object" && Object.entries(result).every(([key, value])=>typeof key === "string" && $dbfbcf83869c9c18$var$isDataStrategyResult(value));
}
function $dbfbcf83869c9c18$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function $dbfbcf83869c9c18$var$isRedirectDataStrategyResult(result) {
    return $dbfbcf83869c9c18$export$3f1eb41d9a6a6a27(result.result) && $dbfbcf83869c9c18$var$redirectStatusCodes.has(result.result.status);
}
function $dbfbcf83869c9c18$var$isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function $dbfbcf83869c9c18$var$isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function $dbfbcf83869c9c18$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $dbfbcf83869c9c18$export$3f1eb41d9a6a6a27(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $dbfbcf83869c9c18$export$794b2760043cf8cd(statusCode) {
    return $dbfbcf83869c9c18$var$redirectStatusCodes.has(statusCode);
}
function $dbfbcf83869c9c18$export$6e80290866a84dd4(result) {
    return $dbfbcf83869c9c18$export$3f1eb41d9a6a6a27(result) && $dbfbcf83869c9c18$export$794b2760043cf8cd(result.status) && result.headers.has("Location");
}
function $dbfbcf83869c9c18$var$isValidMethod(method) {
    return $dbfbcf83869c9c18$var$validRequestMethods.has(method.toUpperCase());
}
function $dbfbcf83869c9c18$export$cbae47800eb95bc3(method) {
    return $dbfbcf83869c9c18$var$validMutationMethods.has(method.toUpperCase());
}
function $dbfbcf83869c9c18$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $dbfbcf83869c9c18$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $dbfbcf83869c9c18$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $dbfbcf83869c9c18$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = $dbfbcf83869c9c18$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $dbfbcf83869c9c18$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $dbfbcf83869c9c18$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation;
    }
}
function $dbfbcf83869c9c18$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $dbfbcf83869c9c18$var$getLoadingFetcher(submission, data2) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher;
    }
}
function $dbfbcf83869c9c18$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function $dbfbcf83869c9c18$var$getDoneFetcher(data2) {
    let fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function $dbfbcf83869c9c18$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($dbfbcf83869c9c18$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {}
}
function $dbfbcf83869c9c18$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($dbfbcf83869c9c18$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $dbfbcf83869c9c18$var$warning(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $dbfbcf83869c9c18$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $dbfbcf83869c9c18$export$2eeee58951ff3c1c = $hO8yS.createContext(null);
$dbfbcf83869c9c18$export$2eeee58951ff3c1c.displayName = "DataRouter";
var $dbfbcf83869c9c18$export$315e3ffb01f217 = $hO8yS.createContext(null);
$dbfbcf83869c9c18$export$315e3ffb01f217.displayName = "DataRouterState";
var $dbfbcf83869c9c18$export$717f757c655223f1 = $hO8yS.createContext(false);
function $dbfbcf83869c9c18$var$useIsRSCRouterContext() {
    return $32rMB.useContext($dbfbcf83869c9c18$export$717f757c655223f1);
}
var $dbfbcf83869c9c18$export$3681f408decb40d1 = $hO8yS.createContext({
    isTransitioning: false
});
$dbfbcf83869c9c18$export$3681f408decb40d1.displayName = "ViewTransition";
var $dbfbcf83869c9c18$export$cb3f1df1bef00a39 = $hO8yS.createContext(/* @__PURE__ */ new Map());
$dbfbcf83869c9c18$export$cb3f1df1bef00a39.displayName = "Fetchers";
var $dbfbcf83869c9c18$var$AwaitContext = $hO8yS.createContext(null);
$dbfbcf83869c9c18$var$AwaitContext.displayName = "Await";
var $dbfbcf83869c9c18$export$2666c20e15407622 = (props)=>$hO8yS.createElement($dbfbcf83869c9c18$var$AwaitContext.Provider, props);
var $dbfbcf83869c9c18$export$3044ab7fdabeaee6 = $hO8yS.createContext(null);
$dbfbcf83869c9c18$export$3044ab7fdabeaee6.displayName = "Navigation";
var $dbfbcf83869c9c18$export$e6a44b110a0c44d3 = $hO8yS.createContext(null);
$dbfbcf83869c9c18$export$e6a44b110a0c44d3.displayName = "Location";
var $dbfbcf83869c9c18$export$aac280ed165a4397 = $hO8yS.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$dbfbcf83869c9c18$export$aac280ed165a4397.displayName = "Route";
var $dbfbcf83869c9c18$var$RouteErrorContext = $hO8yS.createContext(null);
$dbfbcf83869c9c18$var$RouteErrorContext.displayName = "RouteError";
var $dbfbcf83869c9c18$export$945fecf35a8ef089 = true;
function $dbfbcf83869c9c18$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    $dbfbcf83869c9c18$export$f5708dca728d7177($dbfbcf83869c9c18$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator } = $32rMB.useContext($dbfbcf83869c9c18$export$3044ab7fdabeaee6);
    let { hash: hash, pathname: pathname, search: search } = $dbfbcf83869c9c18$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : $dbfbcf83869c9c18$var$joinPaths([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
function $dbfbcf83869c9c18$export$9c954a9d03d32f4a() {
    return $32rMB.useContext($dbfbcf83869c9c18$export$e6a44b110a0c44d3) != null;
}
function $dbfbcf83869c9c18$export$45d76561a5302f2b() {
    $dbfbcf83869c9c18$export$f5708dca728d7177($dbfbcf83869c9c18$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useLocation() may be used only in the context of a <Router> component.`);
    return $32rMB.useContext($dbfbcf83869c9c18$export$e6a44b110a0c44d3).location;
}
function $dbfbcf83869c9c18$export$1b3f31771c5d07c() {
    return $32rMB.useContext($dbfbcf83869c9c18$export$e6a44b110a0c44d3).navigationType;
}
function $dbfbcf83869c9c18$export$6c330e8992e8a295(pattern) {
    $dbfbcf83869c9c18$export$f5708dca728d7177($dbfbcf83869c9c18$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $dbfbcf83869c9c18$export$45d76561a5302f2b();
    return $32rMB.useMemo(()=>$dbfbcf83869c9c18$export$81336c211d5ff295(pattern, $dbfbcf83869c9c18$var$decodePath(pathname)), [
        pathname,
        pattern
    ]);
}
var $dbfbcf83869c9c18$var$navigateEffectWarning = `You should call navigate() in a React.useEffect(), not when your component is first rendered.`;
function $dbfbcf83869c9c18$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $32rMB.useContext($dbfbcf83869c9c18$export$3044ab7fdabeaee6).static;
    if (!isStatic) $32rMB.useLayoutEffect(cb);
}
function $dbfbcf83869c9c18$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $32rMB.useContext($dbfbcf83869c9c18$export$aac280ed165a4397);
    return isDataRoute ? $dbfbcf83869c9c18$var$useNavigateStable() : $dbfbcf83869c9c18$var$useNavigateUnstable();
}
function $dbfbcf83869c9c18$var$useNavigateUnstable() {
    $dbfbcf83869c9c18$export$f5708dca728d7177($dbfbcf83869c9c18$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $32rMB.useContext($dbfbcf83869c9c18$export$2eeee58951ff3c1c);
    let { basename: basename, navigator: navigator } = $32rMB.useContext($dbfbcf83869c9c18$export$3044ab7fdabeaee6);
    let { matches: matches } = $32rMB.useContext($dbfbcf83869c9c18$export$aac280ed165a4397);
    let { pathname: locationPathname } = $dbfbcf83869c9c18$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($dbfbcf83869c9c18$var$getResolveToMatches(matches));
    let activeRef = $32rMB.useRef(false);
    $dbfbcf83869c9c18$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $32rMB.useCallback((to, options = {})=>{
        $dbfbcf83869c9c18$var$warning(activeRef.current, $dbfbcf83869c9c18$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = $dbfbcf83869c9c18$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : $dbfbcf83869c9c18$var$joinPaths([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $dbfbcf83869c9c18$var$OutletContext = $hO8yS.createContext(null);
function $dbfbcf83869c9c18$export$4138103a3ae699cc() {
    return $32rMB.useContext($dbfbcf83869c9c18$var$OutletContext);
}
function $dbfbcf83869c9c18$export$a3be3530d8e40d0b(context) {
    let outlet = $32rMB.useContext($dbfbcf83869c9c18$export$aac280ed165a4397).outlet;
    return $32rMB.useMemo(()=>outlet && /* @__PURE__ */ $hO8yS.createElement($dbfbcf83869c9c18$var$OutletContext.Provider, {
            value: context
        }, outlet), [
        outlet,
        context
    ]);
}
function $dbfbcf83869c9c18$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $32rMB.useContext($dbfbcf83869c9c18$export$aac280ed165a4397);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
function $dbfbcf83869c9c18$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $32rMB.useContext($dbfbcf83869c9c18$export$aac280ed165a4397);
    let { pathname: locationPathname } = $dbfbcf83869c9c18$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($dbfbcf83869c9c18$var$getResolveToMatches(matches));
    return $32rMB.useMemo(()=>$dbfbcf83869c9c18$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function $dbfbcf83869c9c18$export$5d3fca4a98652595(routes, locationArg) {
    return $dbfbcf83869c9c18$var$useRoutesImpl(routes, locationArg);
}
function $dbfbcf83869c9c18$var$useRoutesImpl(routes, locationArg, dataRouterState, unstable_onError, future) {
    $dbfbcf83869c9c18$export$f5708dca728d7177($dbfbcf83869c9c18$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator } = $32rMB.useContext($dbfbcf83869c9c18$export$3044ab7fdabeaee6);
    let { matches: parentMatches } = $32rMB.useContext($dbfbcf83869c9c18$export$aac280ed165a4397);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    if ($dbfbcf83869c9c18$export$945fecf35a8ef089) {
        let parentPath = parentRoute && parentRoute.path || "";
        $dbfbcf83869c9c18$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${parentPathname}" (under <Route path="${parentPath}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${parentPath}"> to <Route path="${parentPath === "/" ? "*" : `${parentPath}/*`}">.`);
    }
    let locationFromContext = $dbfbcf83869c9c18$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? $dbfbcf83869c9c18$export$8ccf933b0513f8d0(locationArg) : locationArg;
        $dbfbcf83869c9c18$export$f5708dca728d7177(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = $dbfbcf83869c9c18$export$2708184779ceb39d(routes, {
        pathname: remainingPathname
    });
    if ($dbfbcf83869c9c18$export$945fecf35a8ef089) {
        $dbfbcf83869c9c18$var$warning(parentRoute || matches != null, `No routes matched location "${location.pathname}${location.search}${location.hash}" `);
        $dbfbcf83869c9c18$var$warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, `Matched leaf route at location "${location.pathname}${location.search}${location.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
    }
    let renderedMatches = $dbfbcf83869c9c18$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: $dbfbcf83869c9c18$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes.
                // Pre-encode `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname.replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : $dbfbcf83869c9c18$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                // Pre-encode `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase.replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, unstable_onError, future);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $hO8yS.createElement($dbfbcf83869c9c18$export$e6a44b110a0c44d3.Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                ...location
            },
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function $dbfbcf83869c9c18$var$DefaultErrorComponent() {
    let error = $dbfbcf83869c9c18$export$ed527bf60f6e05f2();
    let message = $dbfbcf83869c9c18$export$972111febbeef05b(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    if ($dbfbcf83869c9c18$export$945fecf35a8ef089) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ $hO8yS.createElement($hO8yS.Fragment, null, /* @__PURE__ */ $hO8yS.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /* @__PURE__ */ $hO8yS.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ $hO8yS.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ $hO8yS.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ $hO8yS.createElement($hO8yS.Fragment, null, /* @__PURE__ */ $hO8yS.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $hO8yS.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $hO8yS.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $dbfbcf83869c9c18$var$defaultErrorElement = /* @__PURE__ */ $hO8yS.createElement($dbfbcf83869c9c18$var$DefaultErrorComponent, null);
var $dbfbcf83869c9c18$var$RenderErrorBoundary = class extends $hO8yS.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("React Router caught the following error during render", error);
    }
    render() {
        return this.state.error !== void 0 ? /* @__PURE__ */ $hO8yS.createElement($dbfbcf83869c9c18$export$aac280ed165a4397.Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $hO8yS.createElement($dbfbcf83869c9c18$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
};
function $dbfbcf83869c9c18$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $32rMB.useContext($dbfbcf83869c9c18$export$2eeee58951ff3c1c);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $hO8yS.createElement($dbfbcf83869c9c18$export$aac280ed165a4397.Provider, {
        value: routeContext
    }, children);
}
function $dbfbcf83869c9c18$var$_renderMatches(matches, parentMatches = [], dataRouterState = null, unstable_onError = null, future = null) {
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        $dbfbcf83869c9c18$export$f5708dca728d7177(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors2 } = dataRouterState;
            let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
            if (match.route.lazy || needsToRunLoader) {
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    let onError = dataRouterState && unstable_onError ? (error, errorInfo)=>{
        unstable_onError(error, {
            location: dataRouterState.location,
            params: dataRouterState.matches?.[0]?.params ?? {},
            unstable_pattern: $dbfbcf83869c9c18$var$getRoutePattern(dataRouterState.matches),
            errorInfo: errorInfo
        });
    } : void 0;
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $dbfbcf83869c9c18$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $dbfbcf83869c9c18$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $hO8yS.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $hO8yS.createElement($dbfbcf83869c9c18$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $hO8yS.createElement($dbfbcf83869c9c18$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            },
            onError: onError
        }) : getChildren();
    }, null);
}
function $dbfbcf83869c9c18$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $dbfbcf83869c9c18$var$useDataRouterContext(hookName) {
    let ctx = $32rMB.useContext($dbfbcf83869c9c18$export$2eeee58951ff3c1c);
    $dbfbcf83869c9c18$export$f5708dca728d7177(ctx, $dbfbcf83869c9c18$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $dbfbcf83869c9c18$var$useDataRouterState(hookName) {
    let state = $32rMB.useContext($dbfbcf83869c9c18$export$315e3ffb01f217);
    $dbfbcf83869c9c18$export$f5708dca728d7177(state, $dbfbcf83869c9c18$var$getDataRouterConsoleError(hookName));
    return state;
}
function $dbfbcf83869c9c18$var$useRouteContext(hookName) {
    let route = $32rMB.useContext($dbfbcf83869c9c18$export$aac280ed165a4397);
    $dbfbcf83869c9c18$export$f5708dca728d7177(route, $dbfbcf83869c9c18$var$getDataRouterConsoleError(hookName));
    return route;
}
function $dbfbcf83869c9c18$var$useCurrentRouteId(hookName) {
    let route = $dbfbcf83869c9c18$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    $dbfbcf83869c9c18$export$f5708dca728d7177(thisRoute.route.id, `${hookName} can only be used on routes that contain a unique "id"`);
    return thisRoute.route.id;
}
function $dbfbcf83869c9c18$var$useRouteId() {
    return $dbfbcf83869c9c18$var$useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function $dbfbcf83869c9c18$export$d0fd4b7106de2769() {
    let state = $dbfbcf83869c9c18$var$useDataRouterState("useNavigation" /* UseNavigation */ );
    return state.navigation;
}
function $dbfbcf83869c9c18$export$600dc272ed516c15() {
    let dataRouterContext = $dbfbcf83869c9c18$var$useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    let state = $dbfbcf83869c9c18$var$useDataRouterState("useRevalidator" /* UseRevalidator */ );
    let revalidate = $32rMB.useCallback(async ()=>{
        await dataRouterContext.router.revalidate();
    }, [
        dataRouterContext.router
    ]);
    return $32rMB.useMemo(()=>({
            revalidate: revalidate,
            state: state.revalidation
        }), [
        revalidate,
        state.revalidation
    ]);
}
function $dbfbcf83869c9c18$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $dbfbcf83869c9c18$var$useDataRouterState("useMatches" /* UseMatches */ );
    return $32rMB.useMemo(()=>matches.map((m)=>$dbfbcf83869c9c18$var$convertRouteMatchToUiMatch(m, loaderData)), [
        matches,
        loaderData
    ]);
}
function $dbfbcf83869c9c18$export$1448a5050d252c4d() {
    let state = $dbfbcf83869c9c18$var$useDataRouterState("useLoaderData" /* UseLoaderData */ );
    let routeId = $dbfbcf83869c9c18$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function $dbfbcf83869c9c18$export$fd5d37484eab868d(routeId) {
    let state = $dbfbcf83869c9c18$var$useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function $dbfbcf83869c9c18$export$fdc00f3f26066d5e() {
    let state = $dbfbcf83869c9c18$var$useDataRouterState("useActionData" /* UseActionData */ );
    let routeId = $dbfbcf83869c9c18$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function $dbfbcf83869c9c18$export$ed527bf60f6e05f2() {
    let error = $32rMB.useContext($dbfbcf83869c9c18$var$RouteErrorContext);
    let state = $dbfbcf83869c9c18$var$useDataRouterState("useRouteError" /* UseRouteError */ );
    let routeId = $dbfbcf83869c9c18$var$useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return state.errors?.[routeId];
}
function $dbfbcf83869c9c18$export$78a72ddb39bdd145() {
    let value = $32rMB.useContext($dbfbcf83869c9c18$var$AwaitContext);
    return value?._data;
}
function $dbfbcf83869c9c18$export$17f53340677d5831() {
    let value = $32rMB.useContext($dbfbcf83869c9c18$var$AwaitContext);
    return value?._error;
}
var $dbfbcf83869c9c18$var$blockerId = 0;
function $dbfbcf83869c9c18$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $dbfbcf83869c9c18$var$useDataRouterContext("useBlocker" /* UseBlocker */ );
    let state = $dbfbcf83869c9c18$var$useDataRouterState("useBlocker" /* UseBlocker */ );
    let [blockerKey, setBlockerKey] = $32rMB.useState("");
    let blockerFunction = $32rMB.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: $dbfbcf83869c9c18$export$b69e3301ce081aa3(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: $dbfbcf83869c9c18$export$b69e3301ce081aa3(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $32rMB.useEffect(()=>{
        let key = String(++$dbfbcf83869c9c18$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $32rMB.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : $dbfbcf83869c9c18$export$386d57f03f0b2883;
}
function $dbfbcf83869c9c18$var$useNavigateStable() {
    let { router: router } = $dbfbcf83869c9c18$var$useDataRouterContext("useNavigate" /* UseNavigateStable */ );
    let id = $dbfbcf83869c9c18$var$useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    let activeRef = $32rMB.useRef(false);
    $dbfbcf83869c9c18$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $32rMB.useCallback(async (to, options = {})=>{
        $dbfbcf83869c9c18$var$warning(activeRef.current, $dbfbcf83869c9c18$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") await router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
    return navigate;
}
var $dbfbcf83869c9c18$var$alreadyWarned = {};
function $dbfbcf83869c9c18$var$warningOnce(key, cond, message) {
    if (!cond && !$dbfbcf83869c9c18$var$alreadyWarned[key]) {
        $dbfbcf83869c9c18$var$alreadyWarned[key] = true;
        $dbfbcf83869c9c18$var$warning(false, message);
    }
}
function $dbfbcf83869c9c18$export$3f79f0b98112cf57(...args) {
    const currentRouteId = $dbfbcf83869c9c18$var$useCurrentRouteId("useRoute" /* UseRoute */ );
    const id = args[0] ?? currentRouteId;
    const state = $dbfbcf83869c9c18$var$useDataRouterState("useRoute" /* UseRoute */ );
    const route = state.matches.find(({ route: route2 })=>route2.id === id);
    if (route === void 0) return void 0;
    return {
        handle: route.route.handle,
        loaderData: state.loaderData[id],
        actionData: state.actionData?.[id]
    };
}
// lib/server-runtime/warnings.ts
var $dbfbcf83869c9c18$var$alreadyWarned2 = {};
function $dbfbcf83869c9c18$export$5b28268982f175ba(condition, message) {
    if (!condition && !$dbfbcf83869c9c18$var$alreadyWarned2[message]) {
        $dbfbcf83869c9c18$var$alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
var $dbfbcf83869c9c18$var$USE_OPTIMISTIC = "useOptimistic";
var $dbfbcf83869c9c18$var$useOptimisticImpl = $N3oW3[$dbfbcf83869c9c18$var$USE_OPTIMISTIC];
function $dbfbcf83869c9c18$var$useOptimisticSafe(val) {
    if ($dbfbcf83869c9c18$var$useOptimisticImpl) return $dbfbcf83869c9c18$var$useOptimisticImpl(val);
    else return [
        val,
        ()=>void 0
    ];
}
function $dbfbcf83869c9c18$export$9269a41d8c4635e(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if ($dbfbcf83869c9c18$export$945fecf35a8ef089) {
            if (route.element) $dbfbcf83869c9c18$var$warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: $N3oW3.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if ($dbfbcf83869c9c18$export$945fecf35a8ef089) {
            if (route.hydrateFallbackElement) $dbfbcf83869c9c18$var$warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: $N3oW3.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if ($dbfbcf83869c9c18$export$945fecf35a8ef089) {
            if (route.errorElement) $dbfbcf83869c9c18$var$warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: $N3oW3.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
var $dbfbcf83869c9c18$export$e2fd2c03906469db = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
function $dbfbcf83869c9c18$export$f30f7e456d254e83(routes, opts) {
    return $dbfbcf83869c9c18$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $dbfbcf83869c9c18$var$createMemoryHistory({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes: routes,
        hydrationRouteProperties: $dbfbcf83869c9c18$export$e2fd2c03906469db,
        mapRouteProperties: $dbfbcf83869c9c18$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        unstable_instrumentations: opts?.unstable_instrumentations
    }).initialize();
}
var $dbfbcf83869c9c18$var$Deferred = class {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
function $dbfbcf83869c9c18$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl, unstable_onError: unstable_onError, unstable_useTransitions: unstable_useTransitions }) {
    let [_state, setStateImpl] = $N3oW3.useState(router.state);
    let [state, setOptimisticState] = $dbfbcf83869c9c18$var$useOptimisticSafe(_state);
    let [pendingState, setPendingState] = $N3oW3.useState();
    let [vtContext, setVtContext] = $N3oW3.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $N3oW3.useState();
    let [transition, setTransition] = $N3oW3.useState();
    let [interruption, setInterruption] = $N3oW3.useState();
    let fetcherData = $N3oW3.useRef(/* @__PURE__ */ new Map());
    let setState = $N3oW3.useCallback((newState, { deletedFetchers: deletedFetchers, newErrors: newErrors, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        if (newErrors && unstable_onError) Object.values(newErrors).forEach((error)=>unstable_onError(error, {
                location: newState.location,
                params: newState.matches[0]?.params ?? {},
                unstable_pattern: $dbfbcf83869c9c18$var$getRoutePattern(newState.matches)
            }));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        $dbfbcf83869c9c18$export$5b28268982f175ba(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        $dbfbcf83869c9c18$export$5b28268982f175ba(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else if (unstable_useTransitions === false) setStateImpl(newState);
            else $N3oW3.startTransition(()=>{
                if (unstable_useTransitions === true) setOptimisticState((s)=>$dbfbcf83869c9c18$var$getOptimisticRouterState(s, newState));
                setStateImpl(newState);
            });
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd?.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd?.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd,
        unstable_useTransitions,
        setOptimisticState,
        unstable_onError
    ]);
    $N3oW3.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $N3oW3.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $dbfbcf83869c9c18$var$Deferred());
    }, [
        vtContext
    ]);
    $N3oW3.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition2 = router.window.document.startViewTransition(async ()=>{
                if (unstable_useTransitions === false) setStateImpl(newState);
                else $N3oW3.startTransition(()=>{
                    if (unstable_useTransitions === true) setOptimisticState((s)=>$dbfbcf83869c9c18$var$getOptimisticRouterState(s, newState));
                    setStateImpl(newState);
                });
                await renderPromise;
            });
            transition2.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window,
        unstable_useTransitions,
        setOptimisticState
    ]);
    $N3oW3.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $N3oW3.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $N3oW3.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state2, opts)=>router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state2, opts)=>router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $N3oW3.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            unstable_onError: unstable_onError
        }), [
        router,
        navigator,
        basename,
        unstable_onError
    ]);
    return /* @__PURE__ */ $N3oW3.createElement($N3oW3.Fragment, null, /* @__PURE__ */ $N3oW3.createElement($dbfbcf83869c9c18$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $N3oW3.createElement($dbfbcf83869c9c18$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $N3oW3.createElement($dbfbcf83869c9c18$export$cb3f1df1bef00a39.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $N3oW3.createElement($dbfbcf83869c9c18$export$3681f408decb40d1.Provider, {
        value: vtContext
    }, /* @__PURE__ */ $N3oW3.createElement($dbfbcf83869c9c18$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        unstable_useTransitions: unstable_useTransitions === true
    }, /* @__PURE__ */ $N3oW3.createElement($dbfbcf83869c9c18$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state,
        unstable_onError: unstable_onError
    })))))), null);
}
function $dbfbcf83869c9c18$var$getOptimisticRouterState(currentState, newState) {
    return {
        // Don't surface "current location specific" stuff mid-navigation
        // (historyAction, location, matches, loaderData, errors, initialized,
        // restoreScroll, preventScrollReset, blockers, etc.)
        ...currentState,
        // Only surface "pending/in-flight stuff"
        // (navigation, revalidation, actionData, fetchers, )
        navigation: newState.navigation.state !== "idle" ? newState.navigation : currentState.navigation,
        revalidation: newState.revalidation !== "idle" ? newState.revalidation : currentState.revalidation,
        actionData: newState.navigation.state !== "submitting" ? newState.actionData : currentState.actionData,
        fetchers: newState.fetchers
    };
}
var $dbfbcf83869c9c18$var$MemoizedDataRoutes = $N3oW3.memo($dbfbcf83869c9c18$var$DataRoutes);
function $dbfbcf83869c9c18$var$DataRoutes({ routes: routes, future: future, state: state, unstable_onError: unstable_onError }) {
    return $dbfbcf83869c9c18$var$useRoutesImpl(routes, void 0, state, unstable_onError, future);
}
function $dbfbcf83869c9c18$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, unstable_useTransitions: unstable_useTransitions }) {
    let historyRef = $N3oW3.useRef();
    if (historyRef.current == null) historyRef.current = $dbfbcf83869c9c18$var$createMemoryHistory({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $N3oW3.useState({
        action: history.action,
        location: history.location
    });
    let setState = $N3oW3.useCallback((newState)=>{
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $N3oW3.startTransition(()=>setStateImpl(newState));
    }, [
        unstable_useTransitions
    ]);
    $N3oW3.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $N3oW3.createElement($dbfbcf83869c9c18$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions === true
    });
}
function $dbfbcf83869c9c18$export$444b3ab0cb9aec40({ to: to, replace: replace2, state: state, relative: relative }) {
    $dbfbcf83869c9c18$export$f5708dca728d7177($dbfbcf83869c9c18$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic } = $N3oW3.useContext($dbfbcf83869c9c18$export$3044ab7fdabeaee6);
    $dbfbcf83869c9c18$var$warning(!isStatic, `<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.`);
    let { matches: matches } = $N3oW3.useContext($dbfbcf83869c9c18$export$aac280ed165a4397);
    let { pathname: locationPathname } = $dbfbcf83869c9c18$export$45d76561a5302f2b();
    let navigate = $dbfbcf83869c9c18$export$9770f232ac06a008();
    let path = $dbfbcf83869c9c18$var$resolveTo(to, $dbfbcf83869c9c18$var$getResolveToMatches(matches), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $N3oW3.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function $dbfbcf83869c9c18$export$910ae8079b2c2852(props) {
    return $dbfbcf83869c9c18$export$a3be3530d8e40d0b(props.context);
}
function $dbfbcf83869c9c18$export$e7b0ac011bb776c6(props) {
    $dbfbcf83869c9c18$export$f5708dca728d7177(false, `A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.`);
}
function $dbfbcf83869c9c18$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP" /* Pop */ , navigator: navigator, static: staticProp = false, unstable_useTransitions: unstable_useTransitions }) {
    $dbfbcf83869c9c18$export$f5708dca728d7177(!$dbfbcf83869c9c18$export$9c954a9d03d32f4a(), `You cannot render a <Router> inside another <Router>. You should never have more than one in your app.`);
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $N3oW3.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            unstable_useTransitions: unstable_useTransitions,
            future: {}
        }), [
        basename,
        navigator,
        staticProp,
        unstable_useTransitions
    ]);
    if (typeof locationProp === "string") locationProp = $dbfbcf83869c9c18$export$8ccf933b0513f8d0(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $N3oW3.useMemo(()=>{
        let trailingPathname = $dbfbcf83869c9c18$export$b69e3301ce081aa3(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    $dbfbcf83869c9c18$var$warning(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $N3oW3.createElement($dbfbcf83869c9c18$export$3044ab7fdabeaee6.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $N3oW3.createElement($dbfbcf83869c9c18$export$e6a44b110a0c44d3.Provider, {
        children: children,
        value: locationContext
    }));
}
function $dbfbcf83869c9c18$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return $dbfbcf83869c9c18$export$5d3fca4a98652595($dbfbcf83869c9c18$export$16da398f5434bdec(children), location);
}
function $dbfbcf83869c9c18$export$6ddabde395c8c576({ children: children, errorElement: errorElement, resolve: resolve }) {
    let dataRouterContext = $N3oW3.useContext($dbfbcf83869c9c18$export$2eeee58951ff3c1c);
    let dataRouterStateContext = $N3oW3.useContext($dbfbcf83869c9c18$export$315e3ffb01f217);
    let onError = $N3oW3.useCallback((error, errorInfo)=>{
        if (dataRouterContext && dataRouterContext.unstable_onError && dataRouterStateContext) dataRouterContext.unstable_onError(error, {
            location: dataRouterStateContext.location,
            params: dataRouterStateContext.matches[0]?.params || {},
            unstable_pattern: $dbfbcf83869c9c18$var$getRoutePattern(dataRouterStateContext.matches),
            errorInfo: errorInfo
        });
    }, [
        dataRouterContext,
        dataRouterStateContext
    ]);
    return /* @__PURE__ */ $N3oW3.createElement($dbfbcf83869c9c18$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement,
        onError: onError
    }, /* @__PURE__ */ $N3oW3.createElement($dbfbcf83869c9c18$var$ResolveAwait, null, children));
}
var $dbfbcf83869c9c18$var$AwaitErrorBoundary = class extends $N3oW3.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0 /* pending */ ;
        if (!(resolve instanceof Promise)) {
            status = 1 /* success */ ;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2 /* error */ ;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
        } else {
            status = 0 /* pending */ ;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data2)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data2
                }), (error)=>{
                this.props.onError?.(error);
                Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                });
            });
        }
        if (status === 2 /* error */  && !errorElement) throw promise._error;
        if (status === 2 /* error */ ) return /* @__PURE__ */ $N3oW3.createElement($dbfbcf83869c9c18$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1 /* success */ ) return /* @__PURE__ */ $N3oW3.createElement($dbfbcf83869c9c18$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
};
function $dbfbcf83869c9c18$var$ResolveAwait({ children: children }) {
    let data2 = $dbfbcf83869c9c18$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ $N3oW3.createElement($N3oW3.Fragment, null, toRender);
}
function $dbfbcf83869c9c18$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $N3oW3.Children.forEach(children, (element, index)=>{
        if (!$N3oW3.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $N3oW3.Fragment) {
            routes.push.apply(routes, $dbfbcf83869c9c18$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        $dbfbcf83869c9c18$export$f5708dca728d7177(element.type === $dbfbcf83869c9c18$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        $dbfbcf83869c9c18$export$f5708dca728d7177(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            middleware: element.props.middleware,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $dbfbcf83869c9c18$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
var $dbfbcf83869c9c18$export$9b5b6d122dea0c88 = $dbfbcf83869c9c18$export$16da398f5434bdec;
function $dbfbcf83869c9c18$export$daf73786167a7f72(matches) {
    return $dbfbcf83869c9c18$var$_renderMatches(matches);
}
function $dbfbcf83869c9c18$var$useRouteComponentProps() {
    return {
        params: $dbfbcf83869c9c18$export$99eaa27ddbbb95ef(),
        loaderData: $dbfbcf83869c9c18$export$1448a5050d252c4d(),
        actionData: $dbfbcf83869c9c18$export$fdc00f3f26066d5e(),
        matches: $dbfbcf83869c9c18$export$2378eb7f5ff86053()
    };
}
function $dbfbcf83869c9c18$export$6c4f3826290c37af({ children: children }) {
    const props = $dbfbcf83869c9c18$var$useRouteComponentProps();
    return $N3oW3.cloneElement(children, props);
}
function $dbfbcf83869c9c18$export$1a5de91a5c3255e0(Component4) {
    return function WithComponentProps2() {
        const props = $dbfbcf83869c9c18$var$useRouteComponentProps();
        return $N3oW3.createElement(Component4, props);
    };
}
function $dbfbcf83869c9c18$var$useHydrateFallbackProps() {
    return {
        params: $dbfbcf83869c9c18$export$99eaa27ddbbb95ef(),
        loaderData: $dbfbcf83869c9c18$export$1448a5050d252c4d(),
        actionData: $dbfbcf83869c9c18$export$fdc00f3f26066d5e()
    };
}
function $dbfbcf83869c9c18$export$f8cff34f39c1932a({ children: children }) {
    const props = $dbfbcf83869c9c18$var$useHydrateFallbackProps();
    return $N3oW3.cloneElement(children, props);
}
function $dbfbcf83869c9c18$export$cd4a5850c74ba029(HydrateFallback) {
    return function WithHydrateFallbackProps2() {
        const props = $dbfbcf83869c9c18$var$useHydrateFallbackProps();
        return $N3oW3.createElement(HydrateFallback, props);
    };
}
function $dbfbcf83869c9c18$var$useErrorBoundaryProps() {
    return {
        params: $dbfbcf83869c9c18$export$99eaa27ddbbb95ef(),
        loaderData: $dbfbcf83869c9c18$export$1448a5050d252c4d(),
        actionData: $dbfbcf83869c9c18$export$fdc00f3f26066d5e(),
        error: $dbfbcf83869c9c18$export$ed527bf60f6e05f2()
    };
}
function $dbfbcf83869c9c18$export$e5afde5c4b6d747b({ children: children }) {
    const props = $dbfbcf83869c9c18$var$useErrorBoundaryProps();
    return $N3oW3.cloneElement(children, props);
}
function $dbfbcf83869c9c18$export$26aea97ad016e70c(ErrorBoundary) {
    return function WithErrorBoundaryProps2() {
        const props = $dbfbcf83869c9c18$var$useErrorBoundaryProps();
        return $N3oW3.createElement(ErrorBoundary, props);
    };
}
// lib/dom/dom.ts
var $dbfbcf83869c9c18$var$defaultMethod = "get";
var $dbfbcf83869c9c18$var$defaultEncType = "application/x-www-form-urlencoded";
function $dbfbcf83869c9c18$var$isHtmlElement(object) {
    return typeof HTMLElement !== "undefined" && object instanceof HTMLElement;
}
function $dbfbcf83869c9c18$var$isButtonElement(object) {
    return $dbfbcf83869c9c18$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $dbfbcf83869c9c18$var$isFormElement(object) {
    return $dbfbcf83869c9c18$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $dbfbcf83869c9c18$var$isInputElement(object) {
    return $dbfbcf83869c9c18$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $dbfbcf83869c9c18$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $dbfbcf83869c9c18$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$dbfbcf83869c9c18$var$isModifiedEvent(event);
}
function $dbfbcf83869c9c18$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo2, key)=>{
        let value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $dbfbcf83869c9c18$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $dbfbcf83869c9c18$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var $dbfbcf83869c9c18$var$_formDataSupportsSubmitter = null;
function $dbfbcf83869c9c18$var$isFormDataSubmitterSupported() {
    if ($dbfbcf83869c9c18$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $dbfbcf83869c9c18$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $dbfbcf83869c9c18$var$_formDataSupportsSubmitter = true;
    }
    return $dbfbcf83869c9c18$var$_formDataSupportsSubmitter;
}
var $dbfbcf83869c9c18$var$supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $dbfbcf83869c9c18$var$getFormEncType(encType) {
    if (encType != null && !$dbfbcf83869c9c18$var$supportedFormEncTypes.has(encType)) {
        $dbfbcf83869c9c18$var$warning(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$dbfbcf83869c9c18$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $dbfbcf83869c9c18$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($dbfbcf83869c9c18$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? $dbfbcf83869c9c18$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("method") || $dbfbcf83869c9c18$var$defaultMethod;
        encType = $dbfbcf83869c9c18$var$getFormEncType(target.getAttribute("enctype")) || $dbfbcf83869c9c18$var$defaultEncType;
        formData = new FormData(target);
    } else if ($dbfbcf83869c9c18$var$isButtonElement(target) || $dbfbcf83869c9c18$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? $dbfbcf83869c9c18$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $dbfbcf83869c9c18$var$defaultMethod;
        encType = $dbfbcf83869c9c18$var$getFormEncType(target.getAttribute("formenctype")) || $dbfbcf83869c9c18$var$getFormEncType(form.getAttribute("enctype")) || $dbfbcf83869c9c18$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$dbfbcf83869c9c18$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($dbfbcf83869c9c18$var$isHtmlElement(target)) throw new Error(`Cannot submit element that is not <form>, <button>, or <input type="submit|image">`);
    else {
        method = $dbfbcf83869c9c18$var$defaultMethod;
        action = null;
        encType = $dbfbcf83869c9c18$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
// vendor/turbo-stream-v2/utils.ts
var $dbfbcf83869c9c18$var$HOLE = -1;
var $dbfbcf83869c9c18$var$NAN = -2;
var $dbfbcf83869c9c18$var$NEGATIVE_INFINITY = -3;
var $dbfbcf83869c9c18$var$NEGATIVE_ZERO = -4;
var $dbfbcf83869c9c18$var$NULL = -5;
var $dbfbcf83869c9c18$var$POSITIVE_INFINITY = -6;
var $dbfbcf83869c9c18$var$UNDEFINED = -7;
var $dbfbcf83869c9c18$var$TYPE_BIGINT = "B";
var $dbfbcf83869c9c18$var$TYPE_DATE = "D";
var $dbfbcf83869c9c18$var$TYPE_ERROR = "E";
var $dbfbcf83869c9c18$var$TYPE_MAP = "M";
var $dbfbcf83869c9c18$var$TYPE_NULL_OBJECT = "N";
var $dbfbcf83869c9c18$var$TYPE_PROMISE = "P";
var $dbfbcf83869c9c18$var$TYPE_REGEXP = "R";
var $dbfbcf83869c9c18$var$TYPE_SET = "S";
var $dbfbcf83869c9c18$var$TYPE_SYMBOL = "Y";
var $dbfbcf83869c9c18$var$TYPE_URL = "U";
var $dbfbcf83869c9c18$var$TYPE_PREVIOUS_RESOLVED = "Z";
var $dbfbcf83869c9c18$var$Deferred2 = class {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function $dbfbcf83869c9c18$var$createLineSplittingTransform() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}
// vendor/turbo-stream-v2/flatten.ts
function $dbfbcf83869c9c18$var$flatten(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return $dbfbcf83869c9c18$var$UNDEFINED;
    if (input === null) return $dbfbcf83869c9c18$var$NULL;
    if (Number.isNaN(input)) return $dbfbcf83869c9c18$var$NAN;
    if (input === Number.POSITIVE_INFINITY) return $dbfbcf83869c9c18$var$POSITIVE_INFINITY;
    if (input === Number.NEGATIVE_INFINITY) return $dbfbcf83869c9c18$var$NEGATIVE_INFINITY;
    if (input === 0 && 1 / input < 0) return $dbfbcf83869c9c18$var$NEGATIVE_ZERO;
    const index = this.index++;
    indices.set(input, index);
    $dbfbcf83869c9c18$var$stringify.call(this, input, index);
    return index;
}
function $dbfbcf83869c9c18$var$stringify(input, index) {
    const { deferred: deferred, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    const stack = [
        [
            input,
            index
        ]
    ];
    while(stack.length > 0){
        const [input2, index2] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${$dbfbcf83869c9c18$var$flatten.call(this, k)}":${$dbfbcf83869c9c18$var$flatten.call(this, obj[k])}`).join(",");
        let error = null;
        switch(typeof input2){
            case "boolean":
            case "number":
            case "string":
                str[index2] = JSON.stringify(input2);
                break;
            case "bigint":
                str[index2] = `["${$dbfbcf83869c9c18$var$TYPE_BIGINT}","${input2}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input2);
                    if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index2] = `["${$dbfbcf83869c9c18$var$TYPE_SYMBOL}",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input2) {
                        str[index2] = `${$dbfbcf83869c9c18$var$NULL}`;
                        break;
                    }
                    const isArray = Array.isArray(input2);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input2);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index2] += `,${rest.map((v)=>$dbfbcf83869c9c18$var$flatten.call(this, v)).join(",")}`;
                            str[index2] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i = 0; i < input2.length; i++)result += (i ? "," : "") + (i in input2 ? $dbfbcf83869c9c18$var$flatten.call(this, input2[i]) : $dbfbcf83869c9c18$var$HOLE);
                            str[index2] = `${result}]`;
                        } else if (input2 instanceof Date) {
                            const dateTime = input2.getTime();
                            str[index2] = `["${$dbfbcf83869c9c18$var$TYPE_DATE}",${Number.isNaN(dateTime) ? JSON.stringify("invalid") : dateTime}]`;
                        } else if (input2 instanceof URL) str[index2] = `["${$dbfbcf83869c9c18$var$TYPE_URL}",${JSON.stringify(input2.href)}]`;
                        else if (input2 instanceof RegExp) str[index2] = `["${$dbfbcf83869c9c18$var$TYPE_REGEXP}",${JSON.stringify(input2.source)},${JSON.stringify(input2.flags)}]`;
                        else if (input2 instanceof Set) {
                            if (input2.size > 0) str[index2] = `["${$dbfbcf83869c9c18$var$TYPE_SET}",${[
                                ...input2
                            ].map((val)=>$dbfbcf83869c9c18$var$flatten.call(this, val)).join(",")}]`;
                            else str[index2] = `["${$dbfbcf83869c9c18$var$TYPE_SET}"]`;
                        } else if (input2 instanceof Map) {
                            if (input2.size > 0) str[index2] = `["${$dbfbcf83869c9c18$var$TYPE_MAP}",${[
                                ...input2
                            ].flatMap(([k, v])=>[
                                    $dbfbcf83869c9c18$var$flatten.call(this, k),
                                    $dbfbcf83869c9c18$var$flatten.call(this, v)
                                ]).join(",")}]`;
                            else str[index2] = `["${$dbfbcf83869c9c18$var$TYPE_MAP}"]`;
                        } else if (input2 instanceof Promise) {
                            str[index2] = `["${$dbfbcf83869c9c18$var$TYPE_PROMISE}",${index2}]`;
                            deferred[index2] = input2;
                        } else if (input2 instanceof Error) {
                            str[index2] = `["${$dbfbcf83869c9c18$var$TYPE_ERROR}",${JSON.stringify(input2.message)}`;
                            if (input2.name !== "Error") str[index2] += `,${JSON.stringify(input2.name)}`;
                            str[index2] += "]";
                        } else if (Object.getPrototypeOf(input2) === null) str[index2] = `["${$dbfbcf83869c9c18$var$TYPE_NULL_OBJECT}",{${partsForObj(input2)}}]`;
                        else if ($dbfbcf83869c9c18$var$isPlainObject2(input2)) str[index2] = `{${partsForObj(input2)}}`;
                        else error = new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input2);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input2);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index2] += `,${rest.map((v)=>$dbfbcf83869c9c18$var$flatten.call(this, v)).join(",")}`;
                            str[index2] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input2);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index2] += `,${rest.map((v)=>$dbfbcf83869c9c18$var$flatten.call(this, v)).join(",")}`;
                    str[index2] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
var $dbfbcf83869c9c18$var$objectProtoNames2 = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $dbfbcf83869c9c18$var$isPlainObject2(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $dbfbcf83869c9c18$var$objectProtoNames2;
}
// vendor/turbo-stream-v2/unflatten.ts
var $dbfbcf83869c9c18$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function $dbfbcf83869c9c18$var$unflatten(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $dbfbcf83869c9c18$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $dbfbcf83869c9c18$var$hydrate.call(this, startIndex);
}
function $dbfbcf83869c9c18$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index2, set] = stack.pop();
        switch(index2){
            case $dbfbcf83869c9c18$var$UNDEFINED:
                set(void 0);
                continue;
            case $dbfbcf83869c9c18$var$NULL:
                set(null);
                continue;
            case $dbfbcf83869c9c18$var$NAN:
                set(NaN);
                continue;
            case $dbfbcf83869c9c18$var$POSITIVE_INFINITY:
                set(Infinity);
                continue;
            case $dbfbcf83869c9c18$var$NEGATIVE_INFINITY:
                set(-Infinity);
                continue;
            case $dbfbcf83869c9c18$var$NEGATIVE_ZERO:
                set(-0);
                continue;
        }
        if (hydrated[index2]) {
            set(hydrated[index2]);
            continue;
        }
        const value = values[index2];
        if (!value || typeof value !== "object") {
            hydrated[index2] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case $dbfbcf83869c9c18$var$TYPE_DATE:
                        set(hydrated[index2] = new Date(b));
                        continue;
                    case $dbfbcf83869c9c18$var$TYPE_URL:
                        set(hydrated[index2] = new URL(b));
                        continue;
                    case $dbfbcf83869c9c18$var$TYPE_BIGINT:
                        set(hydrated[index2] = BigInt(b));
                        continue;
                    case $dbfbcf83869c9c18$var$TYPE_REGEXP:
                        set(hydrated[index2] = new RegExp(b, c));
                        continue;
                    case $dbfbcf83869c9c18$var$TYPE_SYMBOL:
                        set(hydrated[index2] = Symbol.for(b));
                        continue;
                    case $dbfbcf83869c9c18$var$TYPE_SET:
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index2] = newSet;
                        for(let i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case $dbfbcf83869c9c18$var$TYPE_MAP:
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index2] = map;
                        for(let i = value.length - 2; i > 0; i -= 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case $dbfbcf83869c9c18$var$TYPE_NULL_OBJECT:
                        const obj = /* @__PURE__ */ Object.create(null);
                        hydrated[index2] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case $dbfbcf83869c9c18$var$TYPE_PROMISE:
                        if (hydrated[b]) set(hydrated[index2] = hydrated[b]);
                        else {
                            const d = new $dbfbcf83869c9c18$var$Deferred2();
                            deferred[b] = d;
                            set(hydrated[index2] = d.promise);
                        }
                        continue;
                    case $dbfbcf83869c9c18$var$TYPE_ERROR:
                        const [, message, errorType] = value;
                        let error = errorType && $dbfbcf83869c9c18$var$globalObj && $dbfbcf83869c9c18$var$globalObj[errorType] ? new $dbfbcf83869c9c18$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index2] = error;
                        set(error);
                        continue;
                    case $dbfbcf83869c9c18$var$TYPE_PREVIOUS_RESOLVED:
                        set(hydrated[index2] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v2)=>{
                                        r[i] = v2;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result2 = plugin(value[0], ...r);
                                    if (result2) {
                                        set(hydrated[index2] = result2.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index2] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== $dbfbcf83869c9c18$var$HOLE) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index2] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    object[r[0]] = r[1];
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}
// vendor/turbo-stream-v2/turbo-stream.ts
async function $dbfbcf83869c9c18$var$decode(readable, options) {
    const { plugins: plugins } = options ?? {};
    const done = new $dbfbcf83869c9c18$var$Deferred2();
    const reader = readable.pipeThrough($dbfbcf83869c9c18$var$createLineSplittingTransform()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $dbfbcf83869c9c18$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $dbfbcf83869c9c18$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function $dbfbcf83869c9c18$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch (reason) {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: $dbfbcf83869c9c18$var$unflatten.call(this, line)
    };
}
async function $dbfbcf83869c9c18$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case $dbfbcf83869c9c18$var$TYPE_PROMISE:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $dbfbcf83869c9c18$var$unflatten.call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case $dbfbcf83869c9c18$var$TYPE_ERROR:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $dbfbcf83869c9c18$var$unflatten.call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $dbfbcf83869c9c18$export$c564cdbbe6da493(input, options) {
    const { plugins: plugins, postPlugins: postPlugins, signal: signal } = options ?? {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    const readable = new ReadableStream({
        async start (controller) {
            const id = $dbfbcf83869c9c18$var$flatten.call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}
`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]
`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            if (Object.keys(encoder.deferred).length) {
                let raceDone;
                const racePromise = new Promise((resolve, reject)=>{
                    raceDone = resolve;
                    if (signal) {
                        const rejectPromise = ()=>reject(signal.reason || new Error("Signal was aborted."));
                        if (signal.aborted) rejectPromise();
                        else signal.addEventListener("abort", (event)=>{
                            rejectPromise();
                        });
                    }
                });
                while(Object.keys(encoder.deferred).length > 0){
                    for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                        if (seenPromises.has(deferred)) continue;
                        seenPromises.add(// biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                        encoder.deferred[Number(deferredId)] = Promise.race([
                            racePromise,
                            deferred
                        ]).then((resolved)=>{
                            const id2 = $dbfbcf83869c9c18$var$flatten.call(encoder, resolved);
                            if (Array.isArray(id2)) {
                                controller.enqueue(textEncoder.encode(`${$dbfbcf83869c9c18$var$TYPE_PROMISE}${deferredId}:[["${$dbfbcf83869c9c18$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                encoder.index++;
                                lastSentIndex++;
                            } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$dbfbcf83869c9c18$var$TYPE_PROMISE}${deferredId}:${id2}
`));
                            else {
                                const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                controller.enqueue(textEncoder.encode(`${$dbfbcf83869c9c18$var$TYPE_PROMISE}${deferredId}:[${values}]
`));
                                lastSentIndex = encoder.stringified.length - 1;
                            }
                        }, (reason)=>{
                            if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                            const id2 = $dbfbcf83869c9c18$var$flatten.call(encoder, reason);
                            if (Array.isArray(id2)) {
                                controller.enqueue(textEncoder.encode(`${$dbfbcf83869c9c18$var$TYPE_ERROR}${deferredId}:[["${$dbfbcf83869c9c18$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                encoder.index++;
                                lastSentIndex++;
                            } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$dbfbcf83869c9c18$var$TYPE_ERROR}${deferredId}:${id2}
`));
                            else {
                                const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                controller.enqueue(textEncoder.encode(`${$dbfbcf83869c9c18$var$TYPE_ERROR}${deferredId}:[${values}]
`));
                                lastSentIndex = encoder.stringified.length - 1;
                            }
                        }).finally(()=>{
                            delete encoder.deferred[Number(deferredId)];
                        }));
                    }
                    await Promise.race(Object.values(encoder.deferred));
                }
                raceDone();
            }
            await Promise.all(Object.values(encoder.deferred));
            controller.close();
        }
    });
    return readable;
}
// lib/dom/ssr/data.ts
async function $dbfbcf83869c9c18$export$a30aa2a0fce6c468(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}
// lib/dom/ssr/markup.ts
var $dbfbcf83869c9c18$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $dbfbcf83869c9c18$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $dbfbcf83869c9c18$export$4cf11838cdc2a8a8(html) {
    return html.replace($dbfbcf83869c9c18$var$ESCAPE_REGEX, (match)=>$dbfbcf83869c9c18$var$ESCAPE_LOOKUP[match]);
}
// lib/dom/ssr/invariant.ts
function $dbfbcf83869c9c18$var$invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
// lib/dom/ssr/single-fetch.tsx
var $dbfbcf83869c9c18$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
var $dbfbcf83869c9c18$var$SingleFetchNoResultError = class extends Error {
};
var $dbfbcf83869c9c18$export$ae9272e641ead836 = 202;
var $dbfbcf83869c9c18$export$e35ccdcde387134d = /* @__PURE__ */ new Set([
    100,
    101,
    204,
    205
]);
function $dbfbcf83869c9c18$export$2b0b5f24fd77a79f({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $hO8yS.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${$dbfbcf83869c9c18$export$4cf11838cdc2a8a8(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $hO8yS.createElement($hO8yS.Fragment, null, scriptTag, /* @__PURE__ */ $hO8yS.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $hO8yS.createElement($hO8yS.Fragment, null, scriptTag, /* @__PURE__ */ $hO8yS.createElement($N3oW3.Suspense, null, /* @__PURE__ */ $hO8yS.createElement($dbfbcf83869c9c18$export$2b0b5f24fd77a79f, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $dbfbcf83869c9c18$export$77d7799427e365da(getRouter, manifest, routeModules, ssr, basename) {
    let dataStrategy = $dbfbcf83869c9c18$export$7144ac7f1a8613d3(getRouter, (match)=>{
        let manifestRoute = manifest.routes[match.route.id];
        $dbfbcf83869c9c18$var$invariant2(manifestRoute, "Route not found in manifest");
        let routeModule = routeModules[match.route.id];
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader,
            hasShouldRevalidate: Boolean(routeModule?.shouldRevalidate)
        };
    }, $dbfbcf83869c9c18$var$fetchAndDecodeViaTurboStream, ssr, basename);
    return async (args)=>args.runClientMiddleware(dataStrategy);
}
function $dbfbcf83869c9c18$export$7144ac7f1a8613d3(getRouter, getRouteInfo, fetchAndDecode, ssr, basename, shouldAllowOptOut = ()=>true) {
    return async (args)=>{
        let { request: request, matches: matches, fetcherKey: fetcherKey } = args;
        let router = getRouter();
        if (request.method !== "GET") return $dbfbcf83869c9c18$var$singleFetchActionStrategy(args, fetchAndDecode, basename);
        let foundRevalidatingServerLoader = matches.some((m)=>{
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return m.shouldCallHandler() && hasLoader && !hasClientLoader;
        });
        if (!ssr && !foundRevalidatingServerLoader) return $dbfbcf83869c9c18$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename);
        if (fetcherKey) return $dbfbcf83869c9c18$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename);
        return $dbfbcf83869c9c18$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, shouldAllowOptOut);
    };
}
async function $dbfbcf83869c9c18$var$singleFetchActionStrategy(args, fetchAndDecode, basename) {
    let actionMatch = args.matches.find((m)=>m.shouldCallHandler());
    $dbfbcf83869c9c18$var$invariant2(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        let result2 = await handler(async ()=>{
            let { data: data2, status: status } = await fetchAndDecode(args, basename, [
                actionMatch.route.id
            ]);
            actionStatus = status;
            return $dbfbcf83869c9c18$var$unwrapSingleFetchResult(data2, actionMatch.route.id);
        });
        return result2;
    });
    if ($dbfbcf83869c9c18$export$3f1eb41d9a6a6a27(result.result) || $dbfbcf83869c9c18$export$972111febbeef05b(result.result) || $dbfbcf83869c9c18$export$e0163cfdf7bc9cfa(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: $dbfbcf83869c9c18$export$4051a07651545597(result.result, actionStatus)
        }
    };
}
async function $dbfbcf83869c9c18$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldCallHandler());
    let results = {};
    await Promise.all(matchesToLoad.map((m)=>m.resolve(async (handler)=>{
            try {
                let { hasClientLoader: hasClientLoader } = getRouteInfo(m);
                let routeId = m.route.id;
                let result = hasClientLoader ? await handler(async ()=>{
                    let { data: data2 } = await fetchAndDecode(args, basename, [
                        routeId
                    ]);
                    return $dbfbcf83869c9c18$var$unwrapSingleFetchResult(data2, routeId);
                }) : await handler();
                results[m.route.id] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[m.route.id] = {
                    type: "error",
                    result: e
                };
            }
        })));
    return results;
}
async function $dbfbcf83869c9c18$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, shouldAllowOptOut = ()=>true) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = args.matches.map(()=>$dbfbcf83869c9c18$var$createDeferred2());
    let singleFetchDfd = $dbfbcf83869c9c18$var$createDeferred2();
    let results = {};
    let resolvePromise = Promise.all(args.matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let routeId = m.route.id;
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader, hasShouldRevalidate: hasShouldRevalidate } = getRouteInfo(m);
            let defaultShouldRevalidate = !m.shouldRevalidateArgs || m.shouldRevalidateArgs.actionStatus == null || m.shouldRevalidateArgs.actionStatus < 400;
            let shouldCall = m.shouldCallHandler(defaultShouldRevalidate);
            if (!shouldCall) {
                foundOptOutRoute || (foundOptOutRoute = m.shouldRevalidateArgs != null && // This is a revalidation,
                hasLoader && // for a route with a server loader,
                hasShouldRevalidate === true);
                return;
            }
            if (shouldAllowOptOut(m) && hasClientLoader) {
                if (hasLoader) foundOptOutRoute = true;
                try {
                    let result = await handler(async ()=>{
                        let { data: data2 } = await fetchAndDecode(args, basename, [
                            routeId
                        ]);
                        return $dbfbcf83869c9c18$var$unwrapSingleFetchResult(data2, routeId);
                    });
                    results[routeId] = {
                        type: "data",
                        result: result
                    };
                } catch (e) {
                    results[routeId] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (hasLoader) routesParams.add(routeId);
            try {
                let result = await handler(async ()=>{
                    let data2 = await singleFetchDfd.promise;
                    return $dbfbcf83869c9c18$var$unwrapSingleFetchResult(data2, routeId);
                });
                results[routeId] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[routeId] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await Promise.all(routeDfds.map((d)=>d.promise));
    let isInitialLoad = !router.state.initialized && router.state.navigation.state === "idle";
    if ((isInitialLoad || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({
        routes: {}
    });
    else {
        let targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? [
            ...routesParams.keys()
        ] : void 0;
        try {
            let data2 = await fetchAndDecode(args, basename, targetRoutes);
            singleFetchDfd.resolve(data2.data);
        } catch (e) {
            singleFetchDfd.reject(e);
        }
    }
    await resolvePromise;
    await $dbfbcf83869c9c18$var$bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results);
    return results;
}
async function $dbfbcf83869c9c18$var$bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    try {
        let middlewareError;
        let fetchedData = await singleFetchPromise;
        if ("routes" in fetchedData) {
            for (let match of matches)if (match.route.id in fetchedData.routes) {
                let routeResult = fetchedData.routes[match.route.id];
                if ("error" in routeResult) {
                    middlewareError = routeResult.error;
                    if (results[match.route.id]?.result == null) results[match.route.id] = {
                        type: "error",
                        result: middlewareError
                    };
                    break;
                }
            }
        }
        if (middlewareError !== void 0) Array.from(routesParams.values()).forEach((routeId)=>{
            if (results[routeId].result instanceof $dbfbcf83869c9c18$var$SingleFetchNoResultError) results[routeId].result = middlewareError;
        });
    } catch (e) {}
}
async function $dbfbcf83869c9c18$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename) {
    let fetcherMatch = args.matches.find((m)=>m.shouldCallHandler());
    $dbfbcf83869c9c18$var$invariant2(fetcherMatch, "No fetcher match found");
    let routeId = fetcherMatch.route.id;
    let result = await fetcherMatch.resolve(async (handler)=>handler(async ()=>{
            let { data: data2 } = await fetchAndDecode(args, basename, [
                routeId
            ]);
            return $dbfbcf83869c9c18$var$unwrapSingleFetchResult(data2, routeId);
        }));
    return {
        [fetcherMatch.route.id]: result
    };
}
function $dbfbcf83869c9c18$export$425969b7f98e2c9c(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $dbfbcf83869c9c18$export$7b977381851b2c(reqUrl, basename, extension) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (url.pathname === "/") url.pathname = `_root.${extension}`;
    else if (basename && $dbfbcf83869c9c18$export$b69e3301ce081aa3(url.pathname, basename) === "/") url.pathname = `${basename.replace(/\/$/, "")}/_root.${extension}`;
    else url.pathname = `${url.pathname.replace(/\/$/, "")}.${extension}`;
    return url;
}
async function $dbfbcf83869c9c18$var$fetchAndDecodeViaTurboStream(args, basename, targetRoutes) {
    let { request: request } = args;
    let url = $dbfbcf83869c9c18$export$7b977381851b2c(request.url, basename, "data");
    if (request.method === "GET") {
        url = $dbfbcf83869c9c18$export$425969b7f98e2c9c(url);
        if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
    }
    let res = await fetch(url, await $dbfbcf83869c9c18$export$a30aa2a0fce6c468(request));
    if (res.status >= 400 && !res.headers.has("X-Remix-Response")) throw new $dbfbcf83869c9c18$export$f2680fa305b734ca(res.status, res.statusText, await res.text());
    if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return {
        status: $dbfbcf83869c9c18$export$ae9272e641ead836,
        data: {
            redirect: {
                redirect: res.headers.get("X-Remix-Redirect"),
                status: Number(res.headers.get("X-Remix-Status") || "302"),
                revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                reload: res.headers.get("X-Remix-Reload-Document") === "true",
                replace: res.headers.get("X-Remix-Replace") === "true"
            }
        }
    };
    if ($dbfbcf83869c9c18$export$e35ccdcde387134d.has(res.status)) {
        let routes = {};
        if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
            data: void 0
        };
        return {
            status: res.status,
            data: {
                routes: routes
            }
        };
    }
    $dbfbcf83869c9c18$var$invariant2(res.body, "No response body to decode");
    try {
        let decoded = await $dbfbcf83869c9c18$export$4023ad4ecd4126a2(res.body, window);
        let data2;
        if (request.method === "GET") {
            let typed = decoded.value;
            if ($dbfbcf83869c9c18$export$60644022b8b46aaa in typed) data2 = {
                redirect: typed[$dbfbcf83869c9c18$export$60644022b8b46aaa]
            };
            else data2 = {
                routes: typed
            };
        } else {
            let typed = decoded.value;
            let routeId = targetRoutes?.[0];
            $dbfbcf83869c9c18$var$invariant2(routeId, "No routeId found for single fetch call decoding");
            if ("redirect" in typed) data2 = {
                redirect: typed
            };
            else data2 = {
                routes: {
                    [routeId]: typed
                }
            };
        }
        return {
            status: res.status,
            data: data2
        };
    } catch (e) {
        throw new Error("Unable to decode turbo-stream response");
    }
}
function $dbfbcf83869c9c18$export$4023ad4ecd4126a2(body, global) {
    return $dbfbcf83869c9c18$var$decode(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && name in global && typeof global[name] === "function") Constructor = global[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data2, status, statusText] = rest;
                    return {
                        value: new $dbfbcf83869c9c18$export$f2680fa305b734ca(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$dbfbcf83869c9c18$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $dbfbcf83869c9c18$var$unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        let { redirect: location, revalidate: revalidate, reload: reload, replace: replace2, status: status } = result.redirect;
        throw $dbfbcf83869c9c18$export$89e12c5b50f7529d(location, {
            status: status,
            headers: {
                // Three R's of redirecting (lol Veep)
                ...revalidate ? {
                    "X-Remix-Revalidate": "yes"
                } : null,
                ...reload ? {
                    "X-Remix-Reload-Document": "yes"
                } : null,
                ...replace2 ? {
                    "X-Remix-Replace": "yes"
                } : null
            }
        });
    }
    let routeResult = result.routes[routeId];
    if (routeResult == null) throw new $dbfbcf83869c9c18$var$SingleFetchNoResultError(`No result found for routeId "${routeId}"`);
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error(`Invalid response found for routeId "${routeId}"`);
}
function $dbfbcf83869c9c18$var$createDeferred2() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
// lib/dom/ssr/routeModules.ts
async function $dbfbcf83869c9c18$var$loadRouteModule(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
        $dbfbcf83869c9c18$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}
// lib/dom/ssr/links.ts
function $dbfbcf83869c9c18$var$getKeyedLinksForMatches(matches, routeModules, manifest) {
    let descriptors = matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href: href
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2);
    let preloads = $dbfbcf83869c9c18$var$getModuleLinkHrefs(matches, manifest);
    return $dbfbcf83869c9c18$var$dedupeLinkDescriptors(descriptors, preloads);
}
function $dbfbcf83869c9c18$var$getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map((href)=>({
            rel: "stylesheet",
            href: href
        }));
}
async function $dbfbcf83869c9c18$var$prefetchRouteCss(route) {
    if (!route.css) return;
    let descriptors = $dbfbcf83869c9c18$var$getRouteCssDescriptors(route);
    await Promise.all(descriptors.map($dbfbcf83869c9c18$var$prefetchStyleLink));
}
async function $dbfbcf83869c9c18$var$prefetchStyleLinks(route, routeModule) {
    if (!route.css && !routeModule.links || !$dbfbcf83869c9c18$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...$dbfbcf83869c9c18$var$getRouteCssDescriptors(route));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$dbfbcf83869c9c18$var$isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    await Promise.all(styleLinks.map($dbfbcf83869c9c18$var$prefetchStyleLink));
}
async function $dbfbcf83869c9c18$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector(`link[rel="stylesheet"][href="${descriptor.href}"]`)) return resolve();
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $dbfbcf83869c9c18$var$isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function $dbfbcf83869c9c18$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $dbfbcf83869c9c18$var$getKeyedPrefetchLinks(matches, manifest, routeModules) {
    let links = await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await $dbfbcf83869c9c18$var$loadRouteModule(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }));
    return $dbfbcf83869c9c18$var$dedupeLinkDescriptors(links.flat(1).filter($dbfbcf83869c9c18$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $dbfbcf83869c9c18$var$getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $dbfbcf83869c9c18$var$getModuleLinkHrefs(matches, manifest, { includeHydrateFallback: includeHydrateFallback } = {}) {
    return $dbfbcf83869c9c18$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $dbfbcf83869c9c18$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $dbfbcf83869c9c18$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $dbfbcf83869c9c18$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        let alreadyModulePreload = preloads && !$dbfbcf83869c9c18$var$isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        let key = JSON.stringify($dbfbcf83869c9c18$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var $dbfbcf83869c9c18$var$_isPreloadSupported;
function $dbfbcf83869c9c18$var$isPreloadSupported() {
    if ($dbfbcf83869c9c18$var$_isPreloadSupported !== void 0) return $dbfbcf83869c9c18$var$_isPreloadSupported;
    let el = document.createElement("link");
    $dbfbcf83869c9c18$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $dbfbcf83869c9c18$var$_isPreloadSupported;
}
function $dbfbcf83869c9c18$var$RemixRootDefaultHydrateFallback() {
    return /* @__PURE__ */ $hO8yS.createElement($dbfbcf83869c9c18$var$BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, $dbfbcf83869c9c18$export$945fecf35a8ef089 ? /* @__PURE__ */ $hO8yS.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
              console.log(
                "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this " +
                "when your app is loading JS modules and/or running \`clientLoader\` " +
                "functions. Check out https://reactrouter.com/start/framework/route-module#hydratefallback " +
                "for more information."
              );
            `
        }
    }) : null);
}
// lib/dom/ssr/routes.tsx
function $dbfbcf83869c9c18$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $dbfbcf83869c9c18$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component4 = $dbfbcf83869c9c18$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? $dbfbcf83869c9c18$var$RemixRootDefaultHydrateFallback : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $hO8yS.createElement($dbfbcf83869c9c18$var$RemixRootDefaultErrorBoundary, {
            error: $dbfbcf83869c9c18$export$ed527bf60f6e05f2()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component4 ? {
            element: /* @__PURE__ */ $hO8yS.createElement(routeModule.Layout, null, /* @__PURE__ */ $hO8yS.createElement(Component4, null))
        } : {
            Component: Component4
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $hO8yS.createElement(routeModule.Layout, null, /* @__PURE__ */ $hO8yS.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $hO8yS.createElement(routeModule.Layout, null, /* @__PURE__ */ $hO8yS.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component4,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $dbfbcf83869c9c18$export$5be2318464878170(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $dbfbcf83869c9c18$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        $dbfbcf83869c9c18$var$invariant2(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$dbfbcf83869c9c18$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $dbfbcf83869c9c18$export$5be2318464878170(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $dbfbcf83869c9c18$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return $dbfbcf83869c9c18$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", $dbfbcf83869c9c18$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $dbfbcf83869c9c18$var$preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        let fn = type === "action" ? "serverAction()" : "serverLoader()";
        let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${route.id}")`;
        console.error(msg);
        throw new $dbfbcf83869c9c18$export$f2680fa305b734ca(400, "Bad Request", new Error(msg), true);
    }
}
function $dbfbcf83869c9c18$export$2754e84c8e66e57d(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new $dbfbcf83869c9c18$export$f2680fa305b734ca(405, "Method Not Allowed", new Error(msg), true);
}
function $dbfbcf83869c9c18$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, parentId = "", routesByParentId = $dbfbcf83869c9c18$var$groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            $dbfbcf83869c9c18$var$invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $dbfbcf83869c9c18$export$2754e84c8e66e57d("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route2) {
            if (route2.clientActionModule) prefetchModule(route2.clientActionModule);
            if (route2.clientLoaderModule) prefetchModule(route2.clientLoaderModule);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? $dbfbcf83869c9c18$var$prefetchStyleLinks(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$dbfbcf83869c9c18$var$getRouteComponents(route, routeModule, isSpaMode),
                middleware: routeModule.clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: $dbfbcf83869c9c18$var$getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params, context: context, unstable_pattern: unstable_pattern }, singleFetch)=>{
                try {
                    let result = await prefetchStylesAndCallHandler(async ()=>{
                        $dbfbcf83869c9c18$var$invariant2(routeModule, "No `routeModule` available for critical-route loader");
                        if (!routeModule.clientLoader) return fetchServerLoader(singleFetch);
                        return routeModule.clientLoader({
                            request: request,
                            params: params,
                            context: context,
                            unstable_pattern: unstable_pattern,
                            async serverLoader () {
                                $dbfbcf83869c9c18$var$preventInvalidServerHandlerCall("loader", route);
                                if (isHydrationRequest) {
                                    if (hasInitialData) return initialData;
                                    if (hasInitialError) throw initialError;
                                }
                                return fetchServerLoader(singleFetch);
                            }
                        });
                    });
                    return result;
                } finally{
                    isHydrationRequest = false;
                }
            };
            dataRoute.loader.hydrate = $dbfbcf83869c9c18$export$6ac68922d4e92125(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode);
            dataRoute.action = ({ request: request, params: params, context: context, unstable_pattern: unstable_pattern }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    $dbfbcf83869c9c18$var$invariant2(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw $dbfbcf83869c9c18$export$2754e84c8e66e57d("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        context: context,
                        unstable_pattern: unstable_pattern,
                        async serverAction () {
                            $dbfbcf83869c9c18$var$preventInvalidServerHandlerCall("action", route);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw $dbfbcf83869c9c18$export$2754e84c8e66e57d("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            let lazyRoutePromise;
            async function getLazyRoute() {
                if (lazyRoutePromise) return await lazyRoutePromise;
                lazyRoutePromise = (async ()=>{
                    if (route.clientLoaderModule || route.clientActionModule) await new Promise((resolve)=>setTimeout(resolve, 0));
                    let routeModulePromise = $dbfbcf83869c9c18$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                    prefetchRouteModuleChunks(route);
                    return await routeModulePromise;
                })();
                return await lazyRoutePromise;
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? async ()=>{
                    let { clientLoader: clientLoader } = route.clientLoaderModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule) : await getLazyRoute();
                    $dbfbcf83869c9c18$var$invariant2(clientLoader, "No `clientLoader` export found");
                    return (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $dbfbcf83869c9c18$var$preventInvalidServerHandlerCall("loader", route);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                } : void 0,
                action: route.hasClientAction ? async ()=>{
                    let clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                    prefetchRouteModuleChunks(route);
                    let { clientAction: clientAction } = await clientActionPromise;
                    $dbfbcf83869c9c18$var$invariant2(clientAction, "No `clientAction` export found");
                    return (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $dbfbcf83869c9c18$var$preventInvalidServerHandlerCall("action", route);
                                return fetchServerAction(singleFetch);
                            }
                        });
                } : void 0,
                middleware: route.hasClientMiddleware ? async ()=>{
                    let { clientMiddleware: clientMiddleware } = route.clientMiddlewareModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule) : await getLazyRoute();
                    $dbfbcf83869c9c18$var$invariant2(clientMiddleware, "No `clientMiddleware` export found");
                    return clientMiddleware;
                } : void 0,
                shouldRevalidate: async ()=>{
                    let lazyRoute = await getLazyRoute();
                    return $dbfbcf83869c9c18$var$getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation);
                },
                handle: async ()=>(await getLazyRoute()).handle,
                // No need to wrap these in layout since the root route is never
                // loaded via route.lazy()
                Component: async ()=>(await getLazyRoute()).Component,
                ErrorBoundary: route.hasErrorBoundary ? async ()=>(await getLazyRoute()).ErrorBoundary : void 0
            };
        }
        let children = $dbfbcf83869c9c18$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $dbfbcf83869c9c18$var$getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return $dbfbcf83869c9c18$var$wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        let myParams = path ? $dbfbcf83869c9c18$var$compilePath(path)[1].map((p)=>p.paramName) : [];
        const didParamsChange = (opts)=>myParams.some((p)=>opts.currentParams[p] !== opts.nextParams[p]);
        if (route.shouldRevalidate) {
            let fn = route.shouldRevalidate;
            return (opts)=>fn({
                    ...opts,
                    defaultShouldRevalidate: didParamsChange(opts)
                });
        } else return (opts)=>didParamsChange(opts);
    }
    return route.shouldRevalidate;
}
function $dbfbcf83869c9c18$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $dbfbcf83869c9c18$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModulePromise = $dbfbcf83869c9c18$var$loadRouteModule(route, routeModules);
    let prefetchRouteCssPromise = $dbfbcf83869c9c18$var$prefetchRouteCss(route);
    let routeModule = await routeModulePromise;
    await Promise.all([
        prefetchRouteCssPromise,
        $dbfbcf83869c9c18$var$prefetchStyleLinks(route, routeModule)
    ]);
    return {
        Component: $dbfbcf83869c9c18$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientMiddleware: routeModule.clientMiddleware,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $dbfbcf83869c9c18$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    let isEmptyObject = typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function $dbfbcf83869c9c18$export$6ac68922d4e92125(routeId, clientLoader, hasLoader, isSpaMode) {
    return isSpaMode && routeId !== "root" || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var $dbfbcf83869c9c18$var$nextPaths = /* @__PURE__ */ new Set();
var $dbfbcf83869c9c18$var$discoveredPathsMaxSize = 1e3;
var $dbfbcf83869c9c18$var$discoveredPaths = /* @__PURE__ */ new Set();
var $dbfbcf83869c9c18$var$URL_LIMIT = 7680;
function $dbfbcf83869c9c18$var$isFogOfWarEnabled(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr === true;
}
function $dbfbcf83869c9c18$var$getPartialManifest({ sri: sri, ...manifest }, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = $dbfbcf83869c9c18$export$2708184779ceb39d(router.routes, path, router.basename);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes,
        sri: sri ? true : void 0
    };
}
function $dbfbcf83869c9c18$export$72ab377a1030deb9(manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename) {
    if (!$dbfbcf83869c9c18$var$isFogOfWarEnabled(routeDiscovery, ssr)) return void 0;
    return async ({ path: path, patch: patch, signal: signal, fetcherKey: fetcherKey })=>{
        if ($dbfbcf83869c9c18$var$discoveredPaths.has(path)) return;
        await $dbfbcf83869c9c18$var$fetchAndApplyManifestPatches([
            path
        ], fetcherKey ? window.location.href : path, manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal);
    };
}
function $dbfbcf83869c9c18$export$5ef046b23d96090d(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode) {
    $32rMB.useEffect(()=>{
        if (!$dbfbcf83869c9c18$var$isFogOfWarEnabled(routeDiscovery, ssr) || // @ts-expect-error - TS doesn't know about this yet
        window.navigator?.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$dbfbcf83869c9c18$var$discoveredPaths.has(pathname)) $dbfbcf83869c9c18$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let lazyPaths = Array.from($dbfbcf83869c9c18$var$nextPaths.keys()).filter((path)=>{
                if ($dbfbcf83869c9c18$var$discoveredPaths.has(path)) {
                    $dbfbcf83869c9c18$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $dbfbcf83869c9c18$var$fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $dbfbcf83869c9c18$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery
    ]);
}
function $dbfbcf83869c9c18$export$bcb79c3deff01d56(_manifestPath, basename) {
    let manifestPath = _manifestPath || "/__manifest";
    if (basename == null) return manifestPath;
    return `${basename}${manifestPath}`.replace(/\/+/g, "/");
}
var $dbfbcf83869c9c18$var$MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
async function $dbfbcf83869c9c18$var$fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal) {
    const searchParams = new URLSearchParams();
    searchParams.set("paths", paths.sort().join(","));
    searchParams.set("version", manifest.version);
    let url = new URL($dbfbcf83869c9c18$export$bcb79c3deff01d56(manifestPath, basename), window.location.origin);
    url.search = searchParams.toString();
    if (url.toString().length > $dbfbcf83869c9c18$var$URL_LIMIT) {
        $dbfbcf83869c9c18$var$nextPaths.clear();
        return;
    }
    let serverPatches;
    try {
        let res = await fetch(url, {
            signal: signal
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        else if (res.status === 204 && res.headers.has("X-Remix-Reload-Document")) {
            if (!errorReloadPath) {
                console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
                return;
            }
            try {
                if (sessionStorage.getItem($dbfbcf83869c9c18$var$MANIFEST_VERSION_STORAGE_KEY) === manifest.version) {
                    console.error("Unable to discover routes due to manifest version mismatch.");
                    return;
                }
                sessionStorage.setItem($dbfbcf83869c9c18$var$MANIFEST_VERSION_STORAGE_KEY, manifest.version);
            } catch  {}
            window.location.href = errorReloadPath;
            console.warn("Detected manifest version mismatch, reloading...");
            await new Promise(()=>{});
        } else if (res.status >= 400) throw new Error(await res.text());
        try {
            sessionStorage.removeItem($dbfbcf83869c9c18$var$MANIFEST_VERSION_STORAGE_KEY);
        } catch  {}
        serverPatches = await res.json();
    } catch (e) {
        if (signal?.aborted) return;
        throw e;
    }
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$dbfbcf83869c9c18$var$addToFifoQueue(p, $dbfbcf83869c9c18$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, $dbfbcf83869c9c18$export$af76e85f27ba0229(patches, routeModules, null, ssr, isSpaMode, parentId)));
}
function $dbfbcf83869c9c18$var$addToFifoQueue(path, queue) {
    if (queue.size >= $dbfbcf83869c9c18$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function $dbfbcf83869c9c18$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
// lib/dom/ssr/components.tsx
function $dbfbcf83869c9c18$var$useDataRouterContext2() {
    let context = $32rMB.useContext($dbfbcf83869c9c18$export$2eeee58951ff3c1c);
    $dbfbcf83869c9c18$var$invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function $dbfbcf83869c9c18$var$useDataRouterStateContext() {
    let context = $32rMB.useContext($dbfbcf83869c9c18$export$315e3ffb01f217);
    $dbfbcf83869c9c18$var$invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var $dbfbcf83869c9c18$export$208d6a3bc3aa62bd = $hO8yS.createContext(void 0);
$dbfbcf83869c9c18$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $dbfbcf83869c9c18$var$useFrameworkContext() {
    let context = $32rMB.useContext($dbfbcf83869c9c18$export$208d6a3bc3aa62bd);
    $dbfbcf83869c9c18$var$invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $dbfbcf83869c9c18$var$usePrefetchBehavior(prefetch, theirElementProps) {
    let frameworkContext = $32rMB.useContext($dbfbcf83869c9c18$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $32rMB.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $32rMB.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $32rMB.useRef(null);
    $32rMB.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $32rMB.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $dbfbcf83869c9c18$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $dbfbcf83869c9c18$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $dbfbcf83869c9c18$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $dbfbcf83869c9c18$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $dbfbcf83869c9c18$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $dbfbcf83869c9c18$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $dbfbcf83869c9c18$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$dbfbcf83869c9c18$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
var $dbfbcf83869c9c18$export$7e4ed4715c00dab0 = "data-react-router-critical-css";
function $dbfbcf83869c9c18$export$b2e089eb3692b073({ nonce: nonce }) {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss } = $dbfbcf83869c9c18$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches } = $dbfbcf83869c9c18$var$useDataRouterStateContext();
    let matches = $dbfbcf83869c9c18$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $32rMB.useMemo(()=>$dbfbcf83869c9c18$var$getKeyedLinksForMatches(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    return /* @__PURE__ */ $hO8yS.createElement($hO8yS.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $hO8yS.createElement("style", {
        [$dbfbcf83869c9c18$export$7e4ed4715c00dab0]: "",
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, typeof criticalCss === "object" ? /* @__PURE__ */ $hO8yS.createElement("link", {
        [$dbfbcf83869c9c18$export$7e4ed4715c00dab0]: "",
        rel: "stylesheet",
        href: criticalCss.href,
        nonce: nonce
    }) : null, keyedLinks.map(({ key: key, link: link })=>$dbfbcf83869c9c18$var$isPageLinkDescriptor(link) ? /* @__PURE__ */ $hO8yS.createElement($dbfbcf83869c9c18$export$60dcec93e67386bd, {
            key: key,
            nonce: nonce,
            ...link
        }) : /* @__PURE__ */ $hO8yS.createElement("link", {
            key: key,
            nonce: nonce,
            ...link
        })));
}
function $dbfbcf83869c9c18$export$60dcec93e67386bd({ page: page, ...linkProps }) {
    let { router: router } = $dbfbcf83869c9c18$var$useDataRouterContext2();
    let matches = $32rMB.useMemo(()=>$dbfbcf83869c9c18$export$2708184779ceb39d(router.routes, page, router.basename), [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    return /* @__PURE__ */ $hO8yS.createElement($dbfbcf83869c9c18$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
}
function $dbfbcf83869c9c18$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $dbfbcf83869c9c18$var$useFrameworkContext();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $32rMB.useState([]);
    $32rMB.useEffect(()=>{
        let interrupted = false;
        $dbfbcf83869c9c18$var$getKeyedPrefetchLinks(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $dbfbcf83869c9c18$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $dbfbcf83869c9c18$export$45d76561a5302f2b();
    let { manifest: manifest, routeModules: routeModules } = $dbfbcf83869c9c18$var$useFrameworkContext();
    let { basename: basename } = $dbfbcf83869c9c18$var$useDataRouterContext2();
    let { loaderData: loaderData, matches: matches } = $dbfbcf83869c9c18$var$useDataRouterStateContext();
    let newMatchesForData = $32rMB.useMemo(()=>$dbfbcf83869c9c18$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $32rMB.useMemo(()=>$dbfbcf83869c9c18$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $32rMB.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = $dbfbcf83869c9c18$export$7b977381851b2c(page, basename, "data");
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = $32rMB.useMemo(()=>$dbfbcf83869c9c18$var$getModuleLinkHrefs(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $dbfbcf83869c9c18$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $hO8yS.createElement($hO8yS.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $hO8yS.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })), moduleHrefs.map((href)=>/* @__PURE__ */ $hO8yS.createElement("link", {
            key: href,
            rel: "modulepreload",
            href: href,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ $hO8yS.createElement("link", {
            key: key,
            nonce: linkProps.nonce,
            ...link
        })));
}
function $dbfbcf83869c9c18$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $dbfbcf83869c9c18$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches, loaderData: loaderData } = $dbfbcf83869c9c18$var$useDataRouterStateContext();
    let location = $dbfbcf83869c9c18$export$45d76561a5302f2b();
    let _matches = $dbfbcf83869c9c18$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data2 = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            data: data2,
            loaderData: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            loaderData: data2,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://remix.run/route/meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $hO8yS.createElement($hO8yS.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$dbfbcf83869c9c18$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $hO8yS.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $hO8yS.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            metaProps.charSet ?? (metaProps.charSet = metaProps.charset);
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $hO8yS.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $hO8yS.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: $dbfbcf83869c9c18$export$4cf11838cdc2a8a8(json)
                }
            });
        } catch (err) {
            return null;
        }
        return /* @__PURE__ */ $hO8yS.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $dbfbcf83869c9c18$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var $dbfbcf83869c9c18$var$isHydrated = false;
function $dbfbcf83869c9c18$export$3be068dde909e563() {
    $dbfbcf83869c9c18$var$isHydrated = true;
}
function $dbfbcf83869c9c18$export$ff0bf87698939488(scriptProps) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta, routeDiscovery: routeDiscovery, ssr: ssr } = $dbfbcf83869c9c18$var$useFrameworkContext();
    let { router: router, static: isStatic, staticContext: staticContext } = $dbfbcf83869c9c18$var$useDataRouterContext2();
    let { matches: routerMatches } = $dbfbcf83869c9c18$var$useDataRouterStateContext();
    let isRSCRouterContext = $dbfbcf83869c9c18$var$useIsRSCRouterContext();
    let enableFogOfWar = $dbfbcf83869c9c18$var$isFogOfWarEnabled(routeDiscovery, ssr);
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $dbfbcf83869c9c18$var$getActiveMatches(routerMatches, null, isSpaMode);
    $32rMB.useEffect(()=>{
        $dbfbcf83869c9c18$export$3be068dde909e563();
    }, []);
    let initialScripts = $32rMB.useMemo(()=>{
        if (isRSCRouterContext) return null;
        let streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};${streamScript}` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, routeIndex)=>{
            let routeVarName = `route${routeIndex}`;
            let manifestEntry = manifest.routes[match.route.id];
            $dbfbcf83869c9c18$var$invariant2(manifestEntry, `Route ${match.route.id} not found in manifest`);
            let { clientActionModule: clientActionModule, clientLoaderModule: clientLoaderModule, clientMiddlewareModule: clientMiddlewareModule, hydrateFallbackModule: hydrateFallbackModule, module: module } = manifestEntry;
            let chunks = [
                ...clientActionModule ? [
                    {
                        module: clientActionModule,
                        varName: `${routeVarName}_clientAction`
                    }
                ] : [],
                ...clientLoaderModule ? [
                    {
                        module: clientLoaderModule,
                        varName: `${routeVarName}_clientLoader`
                    }
                ] : [],
                ...clientMiddlewareModule ? [
                    {
                        module: clientMiddlewareModule,
                        varName: `${routeVarName}_clientMiddleware`
                    }
                ] : [],
                ...hydrateFallbackModule ? [
                    {
                        module: hydrateFallbackModule,
                        varName: `${routeVarName}_HydrateFallback`
                    }
                ] : [],
                {
                    module: module,
                    varName: `${routeVarName}_main`
                }
            ];
            if (chunks.length === 1) return `import * as ${routeVarName} from ${JSON.stringify(module)};`;
            let chunkImportsSnippet = chunks.map((chunk)=>`import * as ${chunk.varName} from "${chunk.module}";`).join("\n");
            let mergedChunksSnippet = `const ${routeVarName} = {${chunks.map((chunk)=>`...${chunk.varName}`).join(",")}};`;
            return [
                chunkImportsSnippet,
                mergedChunksSnippet
            ].join("\n");
        }).join("\n")}
  ${enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        `window.__reactRouterManifest = ${JSON.stringify($dbfbcf83869c9c18$var$getPartialManifest(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $hO8yS.createElement($hO8yS.Fragment, null, /* @__PURE__ */ $hO8yS.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: contextScript
            },
            type: void 0
        }), /* @__PURE__ */ $hO8yS.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: routeModulesScript
            },
            type: "module",
            async: true
        }));
    }, []);
    let preloads = $dbfbcf83869c9c18$var$isHydrated || isRSCRouterContext ? [] : $dbfbcf83869c9c18$var$dedupe(manifest.entry.imports.concat($dbfbcf83869c9c18$var$getModuleLinkHrefs(matches, manifest, {
        includeHydrateFallback: true
    })));
    let sri = typeof manifest.sri === "object" ? manifest.sri : {};
    $dbfbcf83869c9c18$export$5b28268982f175ba(!isRSCRouterContext, "The <Scripts /> element is a no-op when using RSC and can be safely removed.");
    return $dbfbcf83869c9c18$var$isHydrated || isRSCRouterContext ? null : /* @__PURE__ */ $hO8yS.createElement($hO8yS.Fragment, null, typeof manifest.sri === "object" ? /* @__PURE__ */ $hO8yS.createElement("script", {
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    }) : null, !enableFogOfWar ? /* @__PURE__ */ $hO8yS.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.url],
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $hO8yS.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.entry.module],
        suppressHydrationWarning: true
    }), preloads.map((path)=>/* @__PURE__ */ $hO8yS.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: scriptProps.crossOrigin,
            integrity: sri[path],
            suppressHydrationWarning: true
        })), initialScripts);
}
function $dbfbcf83869c9c18$var$dedupe(array) {
    return [
        ...new Set(array)
    ];
}
function $dbfbcf83869c9c18$var$mergeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/ssr/errorBoundaries.tsx
var $dbfbcf83869c9c18$export$32e57f52df4b6e34 = class extends $hO8yS.Component {
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $hO8yS.createElement($dbfbcf83869c9c18$var$RemixRootDefaultErrorBoundary, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
};
function $dbfbcf83869c9c18$var$RemixRootDefaultErrorBoundary({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $hO8yS.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ($dbfbcf83869c9c18$export$972111febbeef05b(error)) return /* @__PURE__ */ $hO8yS.createElement($dbfbcf83869c9c18$var$BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $hO8yS.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), $dbfbcf83869c9c18$export$945fecf35a8ef089 ? heyDeveloper : null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $hO8yS.createElement($dbfbcf83869c9c18$var$BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $hO8yS.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $hO8yS.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $dbfbcf83869c9c18$var$BoundaryShell({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    let { routeModules: routeModules } = $dbfbcf83869c9c18$var$useFrameworkContext();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $hO8yS.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $hO8yS.createElement("head", null, /* @__PURE__ */ $hO8yS.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $hO8yS.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $hO8yS.createElement("title", null, title)), /* @__PURE__ */ $hO8yS.createElement("body", null, /* @__PURE__ */ $hO8yS.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $hO8yS.createElement($dbfbcf83869c9c18$export$ff0bf87698939488, null) : null)));
}
var $dbfbcf83869c9c18$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($dbfbcf83869c9c18$var$isBrowser) window.__reactRouterVersion = "7.10.0";
} catch (e) {}
function $dbfbcf83869c9c18$export$1f3f55432a00e06d(routes, opts) {
    return $dbfbcf83869c9c18$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $dbfbcf83869c9c18$export$719fc203c4e16dee({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $dbfbcf83869c9c18$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $dbfbcf83869c9c18$export$9269a41d8c4635e,
        hydrationRouteProperties: $dbfbcf83869c9c18$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        unstable_instrumentations: opts?.unstable_instrumentations
    }).initialize();
}
function $dbfbcf83869c9c18$export$1ba7ed8a3a7b3765(routes, opts) {
    return $dbfbcf83869c9c18$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $dbfbcf83869c9c18$var$createHashHistory({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $dbfbcf83869c9c18$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $dbfbcf83869c9c18$export$9269a41d8c4635e,
        hydrationRouteProperties: $dbfbcf83869c9c18$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        unstable_instrumentations: opts?.unstable_instrumentations
    }).initialize();
}
function $dbfbcf83869c9c18$var$parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $dbfbcf83869c9c18$var$deserializeErrors(state.errors)
    };
    return state;
}
function $dbfbcf83869c9c18$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $dbfbcf83869c9c18$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
function $dbfbcf83869c9c18$export$9ba4e89fdfa1fc54({ basename: basename, children: children, unstable_useTransitions: unstable_useTransitions, window: window2 }) {
    let historyRef = $32rMB.useRef();
    if (historyRef.current == null) historyRef.current = $dbfbcf83869c9c18$export$719fc203c4e16dee({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $32rMB.useState({
        action: history.action,
        location: history.location
    });
    let setState = $32rMB.useCallback((newState)=>{
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $N3oW3.startTransition(()=>setStateImpl(newState));
    }, [
        unstable_useTransitions
    ]);
    $32rMB.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $hO8yS.createElement($dbfbcf83869c9c18$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions === true
    });
}
function $dbfbcf83869c9c18$export$7221d69dcfc8e36b({ basename: basename, children: children, unstable_useTransitions: unstable_useTransitions, window: window2 }) {
    let historyRef = $32rMB.useRef();
    if (historyRef.current == null) historyRef.current = $dbfbcf83869c9c18$var$createHashHistory({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $32rMB.useState({
        action: history.action,
        location: history.location
    });
    let setState = $32rMB.useCallback((newState)=>{
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $N3oW3.startTransition(()=>setStateImpl(newState));
    }, [
        unstable_useTransitions
    ]);
    $32rMB.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $hO8yS.createElement($dbfbcf83869c9c18$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions === true
    });
}
function $dbfbcf83869c9c18$export$de73885c9336221c({ basename: basename, children: children, history: history, unstable_useTransitions: unstable_useTransitions }) {
    let [state, setStateImpl] = $32rMB.useState({
        action: history.action,
        location: history.location
    });
    let setState = $32rMB.useCallback((newState)=>{
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $N3oW3.startTransition(()=>setStateImpl(newState));
    }, [
        unstable_useTransitions
    ]);
    $32rMB.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $hO8yS.createElement($dbfbcf83869c9c18$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions === true
    });
}
$dbfbcf83869c9c18$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
var $dbfbcf83869c9c18$var$ABSOLUTE_URL_REGEX2 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $dbfbcf83869c9c18$export$a6c7ac8248d6e38a = $N3oW3.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace2, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, ...rest }, forwardedRef) {
    let { basename: basename, unstable_useTransitions: unstable_useTransitions } = $32rMB.useContext($dbfbcf83869c9c18$export$3044ab7fdabeaee6);
    let isAbsolute = typeof to === "string" && $dbfbcf83869c9c18$var$ABSOLUTE_URL_REGEX2.test(to);
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && isAbsolute) {
        absoluteHref = to;
        if ($dbfbcf83869c9c18$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = $dbfbcf83869c9c18$export$b69e3301ce081aa3(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {
            $dbfbcf83869c9c18$var$warning(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
        }
    }
    let href = $dbfbcf83869c9c18$export$b66bb29c5006f12f(to, {
        relative: relative
    });
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = $dbfbcf83869c9c18$var$usePrefetchBehavior(prefetch, rest);
    let internalOnClick = $dbfbcf83869c9c18$export$67621102c14d847(to, {
        replace: replace2,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition,
        unstable_useTransitions: unstable_useTransitions
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ $hO8yS.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: $dbfbcf83869c9c18$var$mergeRefs(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $hO8yS.createElement($hO8yS.Fragment, null, link, /* @__PURE__ */ $hO8yS.createElement($dbfbcf83869c9c18$export$60dcec93e67386bd, {
        page: href
    })) : link;
});
$dbfbcf83869c9c18$export$a6c7ac8248d6e38a.displayName = "Link";
var $dbfbcf83869c9c18$export$b0d92dbee9b5b60d = $N3oW3.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = $dbfbcf83869c9c18$export$e75d2a2d1b3c245b(to, {
        relative: rest.relative
    });
    let location = $dbfbcf83869c9c18$export$45d76561a5302f2b();
    let routerState = $32rMB.useContext($dbfbcf83869c9c18$export$315e3ffb01f217);
    let { navigator: navigator, basename: basename } = $32rMB.useContext($dbfbcf83869c9c18$export$3044ab7fdabeaee6);
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $dbfbcf83869c9c18$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = $dbfbcf83869c9c18$export$b69e3301ce081aa3(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $hO8yS.createElement($dbfbcf83869c9c18$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$dbfbcf83869c9c18$export$b0d92dbee9b5b60d.displayName = "NavLink";
var $dbfbcf83869c9c18$export$a7fed597f4b8afd8 = $N3oW3.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace2, state: state, method: method = $dbfbcf83869c9c18$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, ...props }, forwardedRef)=>{
    let { unstable_useTransitions: unstable_useTransitions } = $32rMB.useContext($dbfbcf83869c9c18$export$3044ab7fdabeaee6);
    let submit = $dbfbcf83869c9c18$export$47c85c6e3a081d3();
    let formAction = $dbfbcf83869c9c18$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && $dbfbcf83869c9c18$var$ABSOLUTE_URL_REGEX2.test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        let doSubmit = ()=>submit(submitter || event.currentTarget, {
                fetcherKey: fetcherKey,
                method: submitMethod,
                navigate: navigate,
                replace: replace2,
                state: state,
                relative: relative,
                preventScrollReset: preventScrollReset,
                viewTransition: viewTransition
            });
        if (unstable_useTransitions && navigate !== false) $N3oW3.startTransition(()=>doSubmit());
        else doSubmit();
    };
    return /* @__PURE__ */ $hO8yS.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$dbfbcf83869c9c18$export$a7fed597f4b8afd8.displayName = "Form";
function $dbfbcf83869c9c18$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $32rMB.useContext($dbfbcf83869c9c18$export$208d6a3bc3aa62bd);
    let { basename: basename } = $32rMB.useContext($dbfbcf83869c9c18$export$3044ab7fdabeaee6);
    let location = $dbfbcf83869c9c18$export$45d76561a5302f2b();
    let matches = $dbfbcf83869c9c18$export$2378eb7f5ff86053();
    $dbfbcf83869c9c18$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $32rMB.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $dbfbcf83869c9c18$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey2, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            let storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    return /* @__PURE__ */ $hO8yS.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${JSON.stringify(storageKey || $dbfbcf83869c9c18$var$SCROLL_RESTORATION_STORAGE_KEY)}, ${JSON.stringify(ssrKey)})`
        }
    });
}
$dbfbcf83869c9c18$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
function $dbfbcf83869c9c18$var$getDataRouterConsoleError2(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $dbfbcf83869c9c18$var$useDataRouterContext3(hookName) {
    let ctx = $32rMB.useContext($dbfbcf83869c9c18$export$2eeee58951ff3c1c);
    $dbfbcf83869c9c18$export$f5708dca728d7177(ctx, $dbfbcf83869c9c18$var$getDataRouterConsoleError2(hookName));
    return ctx;
}
function $dbfbcf83869c9c18$var$useDataRouterState2(hookName) {
    let state = $32rMB.useContext($dbfbcf83869c9c18$export$315e3ffb01f217);
    $dbfbcf83869c9c18$export$f5708dca728d7177(state, $dbfbcf83869c9c18$var$getDataRouterConsoleError2(hookName));
    return state;
}
function $dbfbcf83869c9c18$export$67621102c14d847(to, { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition, unstable_useTransitions: unstable_useTransitions } = {}) {
    let navigate = $dbfbcf83869c9c18$export$9770f232ac06a008();
    let location = $dbfbcf83869c9c18$export$45d76561a5302f2b();
    let path = $dbfbcf83869c9c18$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    return $32rMB.useCallback((event)=>{
        if ($dbfbcf83869c9c18$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            let replace2 = replaceProp !== void 0 ? replaceProp : $dbfbcf83869c9c18$export$fe53371bee54353d(location) === $dbfbcf83869c9c18$export$fe53371bee54353d(path);
            let doNavigate = ()=>navigate(to, {
                    replace: replace2,
                    state: state,
                    preventScrollReset: preventScrollReset,
                    relative: relative,
                    viewTransition: viewTransition
                });
            if (unstable_useTransitions) $N3oW3.startTransition(()=>doNavigate());
            else doNavigate();
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition,
        unstable_useTransitions
    ]);
}
function $dbfbcf83869c9c18$export$f1a78c17382fe22a(defaultInit) {
    $dbfbcf83869c9c18$var$warning(typeof URLSearchParams !== "undefined", `You cannot use the \`useSearchParams\` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.`);
    let defaultSearchParamsRef = $32rMB.useRef($dbfbcf83869c9c18$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $32rMB.useRef(false);
    let location = $dbfbcf83869c9c18$export$45d76561a5302f2b();
    let searchParams = $32rMB.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $dbfbcf83869c9c18$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = $dbfbcf83869c9c18$export$9770f232ac06a008();
    let setSearchParams = $32rMB.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $dbfbcf83869c9c18$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(new URLSearchParams(searchParams)) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var $dbfbcf83869c9c18$var$fetcherId = 0;
var $dbfbcf83869c9c18$var$getUniqueFetcherId = ()=>`__${String(++$dbfbcf83869c9c18$var$fetcherId)}__`;
function $dbfbcf83869c9c18$export$47c85c6e3a081d3() {
    let { router: router } = $dbfbcf83869c9c18$var$useDataRouterContext3("useSubmit" /* UseSubmit */ );
    let { basename: basename } = $32rMB.useContext($dbfbcf83869c9c18$export$3044ab7fdabeaee6);
    let currentRouteId = $dbfbcf83869c9c18$var$useRouteId();
    let routerFetch = router.fetch;
    let routerNavigate = router.navigate;
    return $32rMB.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $dbfbcf83869c9c18$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $dbfbcf83869c9c18$var$getUniqueFetcherId();
            await routerFetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else await routerNavigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        routerFetch,
        routerNavigate,
        basename,
        currentRouteId
    ]);
}
function $dbfbcf83869c9c18$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $32rMB.useContext($dbfbcf83869c9c18$export$3044ab7fdabeaee6);
    let routeContext = $32rMB.useContext($dbfbcf83869c9c18$export$aac280ed165a4397);
    $dbfbcf83869c9c18$export$f5708dca728d7177(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...$dbfbcf83869c9c18$export$e75d2a2d1b3c245b(action ? action : ".", {
            relative: relative
        })
    };
    let location = $dbfbcf83869c9c18$export$45d76561a5302f2b();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $dbfbcf83869c9c18$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $dbfbcf83869c9c18$export$fe53371bee54353d(path);
}
function $dbfbcf83869c9c18$export$5b0d2d9a9921565a({ key: key } = {}) {
    let { router: router } = $dbfbcf83869c9c18$var$useDataRouterContext3("useFetcher" /* UseFetcher */ );
    let state = $dbfbcf83869c9c18$var$useDataRouterState2("useFetcher" /* UseFetcher */ );
    let fetcherData = $32rMB.useContext($dbfbcf83869c9c18$export$cb3f1df1bef00a39);
    let route = $32rMB.useContext($dbfbcf83869c9c18$export$aac280ed165a4397);
    let routeId = route.matches[route.matches.length - 1]?.route.id;
    $dbfbcf83869c9c18$export$f5708dca728d7177(fetcherData, `useFetcher must be used inside a FetchersContext`);
    $dbfbcf83869c9c18$export$f5708dca728d7177(route, `useFetcher must be used inside a RouteContext`);
    $dbfbcf83869c9c18$export$f5708dca728d7177(routeId != null, `useFetcher can only be used on routes that contain a unique "id"`);
    let defaultKey = $32rMB.useId();
    let [fetcherKey, setFetcherKey] = $32rMB.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    let { deleteFetcher: deleteFetcher, getFetcher: getFetcher, resetFetcher: resetFetcher, fetch: routerFetch } = router;
    $32rMB.useEffect(()=>{
        getFetcher(fetcherKey);
        return ()=>deleteFetcher(fetcherKey);
    }, [
        deleteFetcher,
        getFetcher,
        fetcherKey
    ]);
    let load = $32rMB.useCallback(async (href, opts)=>{
        $dbfbcf83869c9c18$export$f5708dca728d7177(routeId, "No routeId available for fetcher.load()");
        await routerFetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        routerFetch
    ]);
    let submitImpl = $dbfbcf83869c9c18$export$47c85c6e3a081d3();
    let submit = $32rMB.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let reset = $32rMB.useCallback((opts)=>resetFetcher(fetcherKey, opts), [
        resetFetcher,
        fetcherKey
    ]);
    let FetcherForm = $32rMB.useMemo(()=>{
        let FetcherForm2 = $N3oW3.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $hO8yS.createElement($dbfbcf83869c9c18$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    let fetcher = state.fetchers.get(fetcherKey) || $dbfbcf83869c9c18$export$52eace9c284d3585;
    let data2 = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $32rMB.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            reset: reset,
            ...fetcher,
            data: data2
        }), [
        FetcherForm,
        submit,
        load,
        reset,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function $dbfbcf83869c9c18$export$fa996778a3a31087() {
    let state = $dbfbcf83869c9c18$var$useDataRouterState2("useFetchers" /* UseFetchers */ );
    return Array.from(state.fetchers.entries()).map(([key, fetcher])=>({
            ...fetcher,
            key: key
        }));
}
var $dbfbcf83869c9c18$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $dbfbcf83869c9c18$var$savedScrollPositions = {};
function $dbfbcf83869c9c18$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: $dbfbcf83869c9c18$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function $dbfbcf83869c9c18$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = $dbfbcf83869c9c18$var$useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ );
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $dbfbcf83869c9c18$var$useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ );
    let { basename: basename } = $32rMB.useContext($dbfbcf83869c9c18$export$3044ab7fdabeaee6);
    let location = $dbfbcf83869c9c18$export$45d76561a5302f2b();
    let matches = $dbfbcf83869c9c18$export$2378eb7f5ff86053();
    let navigation = $dbfbcf83869c9c18$export$d0fd4b7106de2769();
    $32rMB.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $dbfbcf83869c9c18$var$usePageHide($32rMB.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $dbfbcf83869c9c18$var$getScrollRestorationKey(location, matches, basename, getKey);
            $dbfbcf83869c9c18$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $dbfbcf83869c9c18$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($dbfbcf83869c9c18$var$savedScrollPositions));
        } catch (error) {
            $dbfbcf83869c9c18$var$warning(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $32rMB.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $dbfbcf83869c9c18$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $dbfbcf83869c9c18$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $32rMB.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration($dbfbcf83869c9c18$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location2, matches2)=>$dbfbcf83869c9c18$var$getScrollRestorationKey(location2, matches2, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $32rMB.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            try {
                if (location.hash) {
                    let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                    if (el) {
                        el.scrollIntoView();
                        return;
                    }
                }
            } catch  {
                $dbfbcf83869c9c18$var$warning(false, `"${location.hash.slice(1)}" is not a decodable element ID. The view will not scroll to it.`);
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function $dbfbcf83869c9c18$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $32rMB.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $dbfbcf83869c9c18$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $32rMB.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $dbfbcf83869c9c18$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = $dbfbcf83869c9c18$export$b273b3273281a049(when);
    $32rMB.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $32rMB.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function $dbfbcf83869c9c18$export$e262bd1977bea848(to, { relative: relative } = {}) {
    let vtContext = $32rMB.useContext($dbfbcf83869c9c18$export$3681f408decb40d1);
    $dbfbcf83869c9c18$export$f5708dca728d7177(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $dbfbcf83869c9c18$var$useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ );
    let path = $dbfbcf83869c9c18$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = $dbfbcf83869c9c18$export$b69e3301ce081aa3(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = $dbfbcf83869c9c18$export$b69e3301ce081aa3(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return $dbfbcf83869c9c18$export$81336c211d5ff295(path.pathname, nextPath) != null || $dbfbcf83869c9c18$export$81336c211d5ff295(path.pathname, currentPath) != null;
}
function $dbfbcf83869c9c18$export$cac06da4d76d935b({ basename: basename, children: children, location: locationProp = "/" }) {
    if (typeof locationProp === "string") locationProp = $dbfbcf83869c9c18$export$8ccf933b0513f8d0(locationProp);
    let action = "POP" /* Pop */ ;
    let location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default"
    };
    let staticNavigator = $dbfbcf83869c9c18$var$getStatelessNavigator();
    return /* @__PURE__ */ $hO8yS.createElement($dbfbcf83869c9c18$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: location,
        navigationType: action,
        navigator: staticNavigator,
        static: true,
        unstable_useTransitions: false
    });
}
function $dbfbcf83869c9c18$export$3d80f15952491985({ context: context, router: router, hydrate: hydrate2 = true, nonce: nonce }) {
    $dbfbcf83869c9c18$export$f5708dca728d7177(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    let dataRouterContext = {
        router: router,
        navigator: $dbfbcf83869c9c18$var$getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    let fetchersContext = /* @__PURE__ */ new Map();
    let hydrateScript = "";
    if (hydrate2 !== false) {
        let data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $dbfbcf83869c9c18$var$serializeErrors(context.errors)
        };
        let json = $dbfbcf83869c9c18$var$htmlEscape(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = `window.__staticRouterHydrationData = JSON.parse(${json});`;
    }
    let { state: state } = dataRouterContext.router;
    return /* @__PURE__ */ $hO8yS.createElement($hO8yS.Fragment, null, /* @__PURE__ */ $hO8yS.createElement($dbfbcf83869c9c18$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $hO8yS.createElement($dbfbcf83869c9c18$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $hO8yS.createElement($dbfbcf83869c9c18$export$cb3f1df1bef00a39.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $hO8yS.createElement($dbfbcf83869c9c18$export$3681f408decb40d1.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ $hO8yS.createElement($dbfbcf83869c9c18$export$55185c17a0fcbe46, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static,
        unstable_useTransitions: false
    }, /* @__PURE__ */ $hO8yS.createElement($dbfbcf83869c9c18$var$DataRoutes2, {
        routes: router.routes,
        future: router.future,
        state: state
    })))))), hydrateScript ? /* @__PURE__ */ $hO8yS.createElement("script", {
        suppressHydrationWarning: true,
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function $dbfbcf83869c9c18$var$DataRoutes2({ routes: routes, future: future, state: state }) {
    return $dbfbcf83869c9c18$var$useRoutesImpl(routes, void 0, state, void 0, future);
}
function $dbfbcf83869c9c18$var$serializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($dbfbcf83869c9c18$export$972111febbeef05b(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) serialized[key] = {
            message: val.message,
            __type: "Error",
            // If this is a subclass (i.e., ReferenceError), send up the type so we
            // can re-create the same type during hydration.
            ...val.name !== "Error" ? {
                __subType: val.name
            } : {}
        };
        else serialized[key] = val;
    }
    return serialized;
}
function $dbfbcf83869c9c18$var$getStatelessNavigator() {
    return {
        createHref: $dbfbcf83869c9c18$var$createHref,
        encodeLocation: $dbfbcf83869c9c18$var$encodeLocation,
        push (to) {
            throw new Error(`You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)})\` somewhere in your app.`);
        },
        replace (to) {
            throw new Error(`You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)}, { replace: true })\` somewhere in your app.`);
        },
        go (delta) {
            throw new Error(`You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${delta})\` somewhere in your app.`);
        },
        back () {
            throw new Error(`You cannot use navigator.back() on the server because it is a stateless environment.`);
        },
        forward () {
            throw new Error(`You cannot use navigator.forward() on the server because it is a stateless environment.`);
        }
    };
}
function $dbfbcf83869c9c18$export$69163f0b72ec60d9(routes, opts) {
    return $dbfbcf83869c9c18$export$3336b097a6fbc59a(routes, {
        ...opts,
        mapRouteProperties: $dbfbcf83869c9c18$export$9269a41d8c4635e
    });
}
function $dbfbcf83869c9c18$export$3dd6171c30258b6f(routes, context, opts = {}) {
    let manifest = {};
    let dataRoutes = $dbfbcf83869c9c18$export$87cb1a9238dc3fba(routes, $dbfbcf83869c9c18$export$9269a41d8c4635e, void 0, manifest);
    let matches = context.matches.map((match)=>{
        let route = manifest[match.route.id] || match.route;
        return {
            ...match,
            route: route
        };
    });
    let msg = (method)=>`You cannot use router.${method}() on the server because it is a stateless environment`;
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return {
                v8_middleware: false,
                ...opts?.future
            };
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches: matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                navigation: $dbfbcf83869c9c18$export$ed3e14b2f9e105d0,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return void 0;
        },
        initialize () {
            throw msg("initialize");
        },
        subscribe () {
            throw msg("subscribe");
        },
        enableScrollRestoration () {
            throw msg("enableScrollRestoration");
        },
        navigate () {
            throw msg("navigate");
        },
        fetch () {
            throw msg("fetch");
        },
        revalidate () {
            throw msg("revalidate");
        },
        createHref: $dbfbcf83869c9c18$var$createHref,
        encodeLocation: $dbfbcf83869c9c18$var$encodeLocation,
        getFetcher () {
            return $dbfbcf83869c9c18$export$52eace9c284d3585;
        },
        deleteFetcher () {
            throw msg("deleteFetcher");
        },
        resetFetcher () {
            throw msg("resetFetcher");
        },
        dispose () {
            throw msg("dispose");
        },
        getBlocker () {
            return $dbfbcf83869c9c18$export$386d57f03f0b2883;
        },
        deleteBlocker () {
            throw msg("deleteBlocker");
        },
        patchRoutes () {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes () {
            throw msg("_internalSetRoutes");
        },
        _internalSetStateDoNotUseOrYouWillBreakYourApp () {
            throw msg("_internalSetStateDoNotUseOrYouWillBreakYourApp");
        }
    };
}
function $dbfbcf83869c9c18$var$createHref(to) {
    return typeof to === "string" ? to : $dbfbcf83869c9c18$export$fe53371bee54353d(to);
}
function $dbfbcf83869c9c18$var$encodeLocation(to) {
    let href = typeof to === "string" ? to : $dbfbcf83869c9c18$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    let encoded = $dbfbcf83869c9c18$var$ABSOLUTE_URL_REGEX3.test(href) ? new URL(href) : new URL(href, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}
var $dbfbcf83869c9c18$var$ABSOLUTE_URL_REGEX3 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $dbfbcf83869c9c18$var$ESCAPE_LOOKUP2 = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $dbfbcf83869c9c18$var$ESCAPE_REGEX2 = /[&><\u2028\u2029]/g;
function $dbfbcf83869c9c18$var$htmlEscape(str) {
    return str.replace($dbfbcf83869c9c18$var$ESCAPE_REGEX2, (match)=>$dbfbcf83869c9c18$var$ESCAPE_LOOKUP2[match]);
}



parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
// This icon file is generated automatically.
var $f8df41bb2af73555$var$LockOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M832 464h-68V240c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM332 240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v224H332V240zm460 600H232V536h560v304zM484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 10-56 0z"
                }
            }
        ]
    },
    "name": "lock",
    "theme": "outlined"
};
var $f8df41bb2af73555$export$2e2bcd8739ae039 = $f8df41bb2af73555$var$LockOutlined;



function $e7b3910945d3664d$var$_extends() {
    $e7b3910945d3664d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e7b3910945d3664d$var$_extends.apply(this, arguments);
}
const $e7b3910945d3664d$var$LockOutlined = (props, ref)=>/*#__PURE__*/ $hO8yS.createElement((0, $5fd6f3f3c400c267$export$2e2bcd8739ae039), $e7b3910945d3664d$var$_extends({}, props, {
        ref: ref,
        icon: (0, $f8df41bb2af73555$export$2e2bcd8739ae039)
    }));
/**![lock](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTgzMiA0NjRoLTY4VjI0MGMwLTcwLjctNTcuMy0xMjgtMTI4LTEyOEgzODhjLTcwLjcgMC0xMjggNTcuMy0xMjggMTI4djIyNGgtNjhjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjM4NGMwIDE3LjcgMTQuMyAzMiAzMiAzMmg2NDBjMTcuNyAwIDMyLTE0LjMgMzItMzJWNDk2YzAtMTcuNy0xNC4zLTMyLTMyLTMyek0zMzIgMjQwYzAtMzAuOSAyNS4xLTU2IDU2LTU2aDI0OGMzMC45IDAgNTYgMjUuMSA1NiA1NnYyMjRIMzMyVjI0MHptNDYwIDYwMEgyMzJWNTM2aDU2MHYzMDR6TTQ4NCA3MDF2NTNjMCA0LjQgMy42IDggOCA4aDQwYzQuNCAwIDgtMy42IDgtOHYtNTNhNDguMDEgNDguMDEgMCAxMC01NiAweiIgLz48L3N2Zz4=) */ const $e7b3910945d3664d$var$RefIcon = /*#__PURE__*/ $N3oW3.forwardRef($e7b3910945d3664d$var$LockOutlined);
var $e7b3910945d3664d$export$2e2bcd8739ae039 = $e7b3910945d3664d$var$RefIcon;

parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
// This icon file is generated automatically.
var $df03f8cdd4eb144b$var$TranslationOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "defs",
                "attrs": {},
                "children": [
                    {
                        "tag": "style",
                        "attrs": {}
                    }
                ]
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M140 188h584v164h76V144c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h544v-76H140V188z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M414.3 256h-60.6c-3.4 0-6.4 2.2-7.6 5.4L219 629.4c-.3.8-.4 1.7-.4 2.6 0 4.4 3.6 8 8 8h55.1c3.4 0 6.4-2.2 7.6-5.4L322 540h196.2L422 261.4a8.42 8.42 0 00-7.7-5.4zm12.4 228h-85.5L384 360.2 426.7 484zM936 528H800v-93c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v93H592c-13.3 0-24 10.7-24 24v176c0 13.3 10.7 24 24 24h136v152c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V752h136c13.3 0 24-10.7 24-24V552c0-13.3-10.7-24-24-24zM728 680h-88v-80h88v80zm160 0h-88v-80h88v80z"
                }
            }
        ]
    },
    "name": "translation",
    "theme": "outlined"
};
var $df03f8cdd4eb144b$export$2e2bcd8739ae039 = $df03f8cdd4eb144b$var$TranslationOutlined;



function $222d3e72b595d6b5$var$_extends() {
    $222d3e72b595d6b5$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $222d3e72b595d6b5$var$_extends.apply(this, arguments);
}
const $222d3e72b595d6b5$var$TranslationOutlined = (props, ref)=>/*#__PURE__*/ $hO8yS.createElement((0, $5fd6f3f3c400c267$export$2e2bcd8739ae039), $222d3e72b595d6b5$var$_extends({}, props, {
        ref: ref,
        icon: (0, $df03f8cdd4eb144b$export$2e2bcd8739ae039)
    }));
/**![translation](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHN0eWxlIC8+PC9kZWZzPjxwYXRoIGQ9Ik0xNDAgMTg4aDU4NHYxNjRoNzZWMTQ0YzAtMTcuNy0xNC4zLTMyLTMyLTMySDk2Yy0xNy43IDAtMzIgMTQuMy0zMiAzMnY3MzZjMCAxNy43IDE0LjMgMzIgMzIgMzJoNTQ0di03NkgxNDBWMTg4eiIgLz48cGF0aCBkPSJNNDE0LjMgMjU2aC02MC42Yy0zLjQgMC02LjQgMi4yLTcuNiA1LjRMMjE5IDYyOS40Yy0uMy44LS40IDEuNy0uNCAyLjYgMCA0LjQgMy42IDggOCA4aDU1LjFjMy40IDAgNi40LTIuMiA3LjYtNS40TDMyMiA1NDBoMTk2LjJMNDIyIDI2MS40YTguNDIgOC40MiAwIDAwLTcuNy01LjR6bTEyLjQgMjI4aC04NS41TDM4NCAzNjAuMiA0MjYuNyA0ODR6TTkzNiA1MjhIODAwdi05M2MwLTQuNC0zLjYtOC04LThoLTU2Yy00LjQgMC04IDMuNi04IDh2OTNINTkyYy0xMy4zIDAtMjQgMTAuNy0yNCAyNHYxNzZjMCAxMy4zIDEwLjcgMjQgMjQgMjRoMTM2djE1MmMwIDQuNCAzLjYgOCA4IDhoNTZjNC40IDAgOC0zLjYgOC04Vjc1MmgxMzZjMTMuMyAwIDI0LTEwLjcgMjQtMjRWNTUyYzAtMTMuMy0xMC43LTI0LTI0LTI0ek03MjggNjgwaC04OHYtODBoODh2ODB6bTE2MCAwaC04OHYtODBoODh2ODB6IiAvPjwvc3ZnPg==) */ const $222d3e72b595d6b5$var$RefIcon = /*#__PURE__*/ $N3oW3.forwardRef($222d3e72b595d6b5$var$TranslationOutlined);
var $222d3e72b595d6b5$export$2e2bcd8739ae039 = $222d3e72b595d6b5$var$RefIcon;

parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
// This icon file is generated automatically.
var $f031dcd86dab2817$var$UserOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M858.5 763.6a374 374 0 00-80.6-119.5 375.63 375.63 0 00-119.5-80.6c-.4-.2-.8-.3-1.2-.5C719.5 518 760 444.7 760 362c0-137-111-248-248-248S264 225 264 362c0 82.7 40.5 156 102.8 201.1-.4.2-.8.3-1.2.5-44.8 18.9-85 46-119.5 80.6a375.63 375.63 0 00-80.6 119.5A371.7 371.7 0 00136 901.8a8 8 0 008 8.2h60c4.4 0 7.9-3.5 8-7.8 2-77.2 33-149.5 87.8-204.3 56.7-56.7 132-87.9 212.2-87.9s155.5 31.2 212.2 87.9C779 752.7 810 825 812 902.2c.1 4.4 3.6 7.8 8 7.8h60a8 8 0 008-8.2c-1-47.8-10.9-94.3-29.5-138.2zM512 534c-45.9 0-89.1-17.9-121.6-50.4S340 407.9 340 362c0-45.9 17.9-89.1 50.4-121.6S466.1 190 512 190s89.1 17.9 121.6 50.4S684 316.1 684 362c0 45.9-17.9 89.1-50.4 121.6S557.9 534 512 534z"
                }
            }
        ]
    },
    "name": "user",
    "theme": "outlined"
};
var $f031dcd86dab2817$export$2e2bcd8739ae039 = $f031dcd86dab2817$var$UserOutlined;



function $4c99305365a0f992$var$_extends() {
    $4c99305365a0f992$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4c99305365a0f992$var$_extends.apply(this, arguments);
}
const $4c99305365a0f992$var$UserOutlined = (props, ref)=>/*#__PURE__*/ $hO8yS.createElement((0, $5fd6f3f3c400c267$export$2e2bcd8739ae039), $4c99305365a0f992$var$_extends({}, props, {
        ref: ref,
        icon: (0, $f031dcd86dab2817$export$2e2bcd8739ae039)
    }));
/**![user](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg1OC41IDc2My42YTM3NCAzNzQgMCAwMC04MC42LTExOS41IDM3NS42MyAzNzUuNjMgMCAwMC0xMTkuNS04MC42Yy0uNC0uMi0uOC0uMy0xLjItLjVDNzE5LjUgNTE4IDc2MCA0NDQuNyA3NjAgMzYyYzAtMTM3LTExMS0yNDgtMjQ4LTI0OFMyNjQgMjI1IDI2NCAzNjJjMCA4Mi43IDQwLjUgMTU2IDEwMi44IDIwMS4xLS40LjItLjguMy0xLjIuNS00NC44IDE4LjktODUgNDYtMTE5LjUgODAuNmEzNzUuNjMgMzc1LjYzIDAgMDAtODAuNiAxMTkuNUEzNzEuNyAzNzEuNyAwIDAwMTM2IDkwMS44YTggOCAwIDAwOCA4LjJoNjBjNC40IDAgNy45LTMuNSA4LTcuOCAyLTc3LjIgMzMtMTQ5LjUgODcuOC0yMDQuMyA1Ni43LTU2LjcgMTMyLTg3LjkgMjEyLjItODcuOXMxNTUuNSAzMS4yIDIxMi4yIDg3LjlDNzc5IDc1Mi43IDgxMCA4MjUgODEyIDkwMi4yYy4xIDQuNCAzLjYgNy44IDggNy44aDYwYTggOCAwIDAwOC04LjJjLTEtNDcuOC0xMC45LTk0LjMtMjkuNS0xMzguMnpNNTEyIDUzNGMtNDUuOSAwLTg5LjEtMTcuOS0xMjEuNi01MC40UzM0MCA0MDcuOSAzNDAgMzYyYzAtNDUuOSAxNy45LTg5LjEgNTAuNC0xMjEuNlM0NjYuMSAxOTAgNTEyIDE5MHM4OS4xIDE3LjkgMTIxLjYgNTAuNFM2ODQgMzE2LjEgNjg0IDM2MmMwIDQ1LjktMTcuOSA4OS4xLTUwLjQgMTIxLjZTNTU3LjkgNTM0IDUxMiA1MzR6IiAvPjwvc3ZnPg==) */ const $4c99305365a0f992$var$RefIcon = /*#__PURE__*/ $N3oW3.forwardRef($4c99305365a0f992$var$UserOutlined);
var $4c99305365a0f992$export$2e2bcd8739ae039 = $4c99305365a0f992$var$RefIcon;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");




var $N3oW3 = parcelRequire("N3oW3");

const $efa0a9940d56f47d$export$74c1bf8296b1541f = [
    'xxl',
    'xl',
    'lg',
    'md',
    'sm',
    'xs'
];
const $efa0a9940d56f47d$var$getResponsiveMap = (token)=>({
        xs: `(max-width: ${token.screenXSMax}px)`,
        sm: `(min-width: ${token.screenSM}px)`,
        md: `(min-width: ${token.screenMD}px)`,
        lg: `(min-width: ${token.screenLG}px)`,
        xl: `(min-width: ${token.screenXL}px)`,
        xxl: `(min-width: ${token.screenXXL}px)`
    });
/**
 * Ensures that the breakpoints token are valid, in good order
 * For each breakpoint : screenMin <= screen <= screenMax and screenMax <= nextScreenMin
 */ const $efa0a9940d56f47d$var$validateBreakpoints = (token)=>{
    const indexableToken = token;
    const revBreakpoints = [].concat($efa0a9940d56f47d$export$74c1bf8296b1541f).reverse();
    revBreakpoints.forEach((breakpoint, i)=>{
        const breakpointUpper = breakpoint.toUpperCase();
        const screenMin = `screen${breakpointUpper}Min`;
        const screen = `screen${breakpointUpper}`;
        if (!(indexableToken[screenMin] <= indexableToken[screen])) throw new Error(`${screenMin}<=${screen} fails : !(${indexableToken[screenMin]}<=${indexableToken[screen]})`);
        if (i < revBreakpoints.length - 1) {
            const screenMax = `screen${breakpointUpper}Max`;
            if (!(indexableToken[screen] <= indexableToken[screenMax])) throw new Error(`${screen}<=${screenMax} fails : !(${indexableToken[screen]}<=${indexableToken[screenMax]})`);
            const nextBreakpointUpperMin = revBreakpoints[i + 1].toUpperCase();
            const nextScreenMin = `screen${nextBreakpointUpperMin}Min`;
            if (!(indexableToken[screenMax] <= indexableToken[nextScreenMin])) throw new Error(`${screenMax}<=${nextScreenMin} fails : !(${indexableToken[screenMax]}<=${indexableToken[nextScreenMin]})`);
        }
    });
    return token;
};
const $efa0a9940d56f47d$export$862220c15691d248 = (screens, screenSizes)=>{
    if (!screenSizes) return;
    for (const breakpoint of $efa0a9940d56f47d$export$74c1bf8296b1541f){
        if (screens[breakpoint] && screenSizes?.[breakpoint] !== undefined) return screenSizes[breakpoint];
    }
};
const $efa0a9940d56f47d$var$useResponsiveObserver = ()=>{
    const [, token] = (0, $9481722d146bd166$export$2e2bcd8739ae039)();
    const responsiveMap = $efa0a9940d56f47d$var$getResponsiveMap($efa0a9940d56f47d$var$validateBreakpoints(token));
    // To avoid repeat create instance, we add `useMemo` here.
    return (0, $N3oW3.default).useMemo(()=>{
        const subscribers = new Map();
        let subUid = -1;
        let screens = {};
        return {
            responsiveMap: responsiveMap,
            matchHandlers: {},
            dispatch (pointMap) {
                screens = pointMap;
                subscribers.forEach((func)=>func(screens));
                return subscribers.size >= 1;
            },
            subscribe (func) {
                if (!subscribers.size) this.register();
                subUid += 1;
                subscribers.set(subUid, func);
                func(screens);
                return subUid;
            },
            unsubscribe (paramToken) {
                subscribers.delete(paramToken);
                if (!subscribers.size) this.unregister();
            },
            register () {
                Object.entries(responsiveMap).forEach(([screen, mediaQuery])=>{
                    const listener = ({ matches: matches })=>{
                        this.dispatch({
                            ...screens,
                            [screen]: matches
                        });
                    };
                    const mql = window.matchMedia(mediaQuery);
                    if (typeof mql?.addEventListener === 'function') mql.addEventListener('change', listener);
                    this.matchHandlers[mediaQuery] = {
                        mql: mql,
                        listener: listener
                    };
                    listener(mql);
                });
            },
            unregister () {
                Object.values(responsiveMap).forEach((mediaQuery)=>{
                    const handler = this.matchHandlers[mediaQuery];
                    if (typeof handler?.mql?.removeEventListener === 'function') handler.mql.removeEventListener('change', handler?.listener);
                });
                subscribers.clear();
            }
        };
    }, [
        responsiveMap
    ]);
};
var $efa0a9940d56f47d$export$2e2bcd8739ae039 = $efa0a9940d56f47d$var$useResponsiveObserver;






var $N3oW3 = parcelRequire("N3oW3");

const $324b30eda6ea1cd7$var$useSize = (customSize)=>{
    const size = (0, $N3oW3.default).useContext((0, $4859819e58dda691$export$2e2bcd8739ae039));
    const mergedSize = (0, $N3oW3.default).useMemo(()=>{
        if (!customSize) return size;
        if (typeof customSize === 'string') return customSize ?? size;
        if (typeof customSize === 'function') return customSize(size);
        return size;
    }, [
        customSize,
        size
    ]);
    return mergedSize;
};
var $324b30eda6ea1cd7$export$2e2bcd8739ae039 = $324b30eda6ea1cd7$var$useSize;


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");


var $N3oW3 = parcelRequire("N3oW3");
const $fd17bb5dce895170$export$91db9bc4f8ac944a = ()=>{
    return (0, $N3oW3.default).useReducer((ori)=>ori + 1, 0);
};



"use client";
function $c5abeec2eaafde8a$var$useBreakpoint(refreshOnChange = true, defaultScreens = {}) {
    const screensRef = (0, $32rMB.useRef)(defaultScreens);
    const [, forceUpdate] = (0, $fd17bb5dce895170$export$91db9bc4f8ac944a)();
    const responsiveObserver = (0, $efa0a9940d56f47d$export$2e2bcd8739ae039)();
    (0, $60cea2402df671e7$export$2e2bcd8739ae039)(()=>{
        const token = responsiveObserver.subscribe((supportScreens)=>{
            screensRef.current = supportScreens;
            if (refreshOnChange) forceUpdate();
        });
        return ()=>responsiveObserver.unsubscribe(token);
    }, []);
    return screensRef.current;
}
var $c5abeec2eaafde8a$export$2e2bcd8739ae039 = $c5abeec2eaafde8a$var$useBreakpoint;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
const $f7abb94a0dd82a5d$var$AvatarContext = /*#__PURE__*/ $hO8yS.createContext({});
var $f7abb94a0dd82a5d$export$2e2bcd8739ae039 = $f7abb94a0dd82a5d$var$AvatarContext;





const $5e4ca8e8dd9005a8$var$genBaseStyle = (token)=>{
    const { antCls: antCls, componentCls: componentCls, iconCls: iconCls, avatarBg: avatarBg, avatarColor: avatarColor, containerSize: containerSize, containerSizeLG: containerSizeLG, containerSizeSM: containerSizeSM, textFontSize: textFontSize, textFontSizeLG: textFontSizeLG, textFontSizeSM: textFontSizeSM, iconFontSize: iconFontSize, iconFontSizeLG: iconFontSizeLG, iconFontSizeSM: iconFontSizeSM, borderRadius: borderRadius, borderRadiusLG: borderRadiusLG, borderRadiusSM: borderRadiusSM, lineWidth: lineWidth, lineType: lineType } = token;
    // Avatar size style
    const avatarSizeStyle = (size, fontSize, iconFontSize, radius)=>({
            width: size,
            height: size,
            borderRadius: '50%',
            fontSize: fontSize,
            [`&${componentCls}-square`]: {
                borderRadius: radius
            },
            [`&${componentCls}-icon`]: {
                fontSize: iconFontSize,
                [`> ${iconCls}`]: {
                    margin: 0
                }
            }
        });
    return {
        [componentCls]: {
            ...(0, $2f353af2b0f7600b$export$23997c3e44cc1c59)(token),
            position: 'relative',
            display: 'inline-flex',
            justifyContent: 'center',
            alignItems: 'center',
            overflow: 'hidden',
            color: avatarColor,
            whiteSpace: 'nowrap',
            textAlign: 'center',
            verticalAlign: 'middle',
            background: avatarBg,
            border: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(lineWidth)} ${lineType} transparent`,
            '&-image': {
                background: 'transparent'
            },
            [`${antCls}-image-img`]: {
                display: 'block'
            },
            ...avatarSizeStyle(containerSize, textFontSize, iconFontSize, borderRadius),
            '&-lg': {
                ...avatarSizeStyle(containerSizeLG, textFontSizeLG, iconFontSizeLG, borderRadiusLG)
            },
            '&-sm': {
                ...avatarSizeStyle(containerSizeSM, textFontSizeSM, iconFontSizeSM, borderRadiusSM)
            },
            '> img': {
                display: 'block',
                width: '100%',
                height: '100%',
                objectFit: 'cover'
            }
        }
    };
};
const $5e4ca8e8dd9005a8$var$genGroupStyle = (token)=>{
    const { componentCls: componentCls, groupBorderColor: groupBorderColor, groupOverlapping: groupOverlapping, groupSpace: groupSpace } = token;
    return {
        [`${componentCls}-group`]: {
            display: 'inline-flex',
            [componentCls]: {
                borderColor: groupBorderColor
            },
            '> *:not(:first-child)': {
                marginInlineStart: groupOverlapping
            }
        },
        [`${componentCls}-group-popover`]: {
            [`${componentCls} + ${componentCls}`]: {
                marginInlineStart: groupSpace
            }
        }
    };
};
const $5e4ca8e8dd9005a8$export$9ca1be8807fe0675 = (token)=>{
    const { controlHeight: controlHeight, controlHeightLG: controlHeightLG, controlHeightSM: controlHeightSM, fontSize: fontSize, fontSizeLG: fontSizeLG, fontSizeXL: fontSizeXL, fontSizeHeading3: fontSizeHeading3, marginXS: marginXS, marginXXS: marginXXS, colorBorderBg: colorBorderBg } = token;
    return {
        containerSize: controlHeight,
        containerSizeLG: controlHeightLG,
        containerSizeSM: controlHeightSM,
        textFontSize: fontSize,
        textFontSizeLG: fontSize,
        textFontSizeSM: fontSize,
        iconFontSize: Math.round((fontSizeLG + fontSizeXL) / 2),
        iconFontSizeLG: fontSizeHeading3,
        iconFontSizeSM: fontSize,
        groupSpace: marginXXS,
        groupOverlapping: -marginXS,
        groupBorderColor: colorBorderBg
    };
};
var $5e4ca8e8dd9005a8$export$2e2bcd8739ae039 = (0, $d4a2dc313c4d90a4$export$51ec95de45185b42)('Avatar', (token)=>{
    const { colorTextLightSolid: colorTextLightSolid, colorTextPlaceholder: colorTextPlaceholder } = token;
    const avatarToken = (0, $90c11ca6cb263fd9$export$4950aa0f605343fb)(token, {
        avatarBg: colorTextPlaceholder,
        avatarColor: colorTextLightSolid
    });
    return [
        $5e4ca8e8dd9005a8$var$genBaseStyle(avatarToken),
        $5e4ca8e8dd9005a8$var$genGroupStyle(avatarToken)
    ];
}, $5e4ca8e8dd9005a8$export$9ca1be8807fe0675);


"use client";
const $16f8327e3ed4cc39$var$Avatar = /*#__PURE__*/ $N3oW3.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, shape: shape, size: customSize, src: src, srcSet: srcSet, icon: icon, className: className, rootClassName: rootClassName, style: style, alt: alt, draggable: draggable, children: children, crossOrigin: crossOrigin, gap: gap = 4, onError: onError, ...others } = props;
    const [scale, setScale] = $32rMB.useState(1);
    const [mounted, setMounted] = $32rMB.useState(false);
    const [isImgExist, setIsImgExist] = $32rMB.useState(true);
    const avatarNodeRef = $32rMB.useRef(null);
    const avatarChildrenRef = $32rMB.useRef(null);
    const avatarNodeMergedRef = (0, $2706ed817e87019d$export$ab452c34e8e05029)(ref, avatarNodeRef);
    const { getPrefixCls: getPrefixCls, className: contextClassName, style: contextStyle } = (0, $dd01e2f5a4b8605d$export$46f4bd6436a25a31)('avatar');
    const avatarCtx = $32rMB.useContext((0, $f7abb94a0dd82a5d$export$2e2bcd8739ae039));
    const setScaleParam = ()=>{
        if (!avatarChildrenRef.current || !avatarNodeRef.current) return;
        const childrenWidth = avatarChildrenRef.current.offsetWidth; // offsetWidth avoid affecting be transform scale
        const nodeWidth = avatarNodeRef.current.offsetWidth;
        // denominator is 0 is no meaning
        if (childrenWidth !== 0 && nodeWidth !== 0) {
            if (gap * 2 < nodeWidth) setScale(nodeWidth - gap * 2 < childrenWidth ? (nodeWidth - gap * 2) / childrenWidth : 1);
        }
    };
    $32rMB.useEffect(()=>{
        setMounted(true);
    }, []);
    $32rMB.useEffect(()=>{
        setIsImgExist(true);
        setScale(1);
    }, [
        src
    ]);
    $32rMB.useEffect(setScaleParam, [
        gap
    ]);
    const handleImgLoadError = ()=>{
        const errorFlag = onError?.();
        if (errorFlag !== false) setIsImgExist(false);
    };
    const size = (0, $324b30eda6ea1cd7$export$2e2bcd8739ae039)((ctxSize)=>customSize ?? avatarCtx?.size ?? ctxSize ?? 'default');
    const needResponsive = Object.keys(typeof size === 'object' ? size || {} : {}).some((key)=>[
            'xs',
            'sm',
            'md',
            'lg',
            'xl',
            'xxl'
        ].includes(key));
    const screens = (0, $c5abeec2eaafde8a$export$2e2bcd8739ae039)(needResponsive);
    const responsiveSizeStyle = $32rMB.useMemo(()=>{
        if (typeof size !== 'object') return {};
        const currentBreakpoint = (0, $efa0a9940d56f47d$export$74c1bf8296b1541f).find((screen)=>screens[screen]);
        const currentSize = size[currentBreakpoint];
        return currentSize ? {
            width: currentSize,
            height: currentSize,
            fontSize: currentSize && (icon || children) ? currentSize / 2 : 18
        } : {};
    }, [
        screens,
        size,
        icon,
        children
    ]);
    const prefixCls = getPrefixCls('avatar', customizePrefixCls);
    const rootCls = (0, $54b1aecddbbbed4f$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $5e4ca8e8dd9005a8$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const sizeCls = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)({
        [`${prefixCls}-lg`]: size === 'large',
        [`${prefixCls}-sm`]: size === 'small'
    });
    const hasImageElement = /*#__PURE__*/ $N3oW3.isValidElement(src);
    const mergedShape = shape || avatarCtx?.shape || 'circle';
    const classString = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, sizeCls, contextClassName, `${prefixCls}-${mergedShape}`, {
        [`${prefixCls}-image`]: hasImageElement || src && isImgExist,
        [`${prefixCls}-icon`]: !!icon
    }, cssVarCls, rootCls, className, rootClassName, hashId);
    const sizeStyle = typeof size === 'number' ? {
        width: size,
        height: size,
        fontSize: icon ? size / 2 : 18
    } : {};
    let childrenToRender;
    if (typeof src === 'string' && isImgExist) childrenToRender = /*#__PURE__*/ $hO8yS.createElement("img", {
        src: src,
        draggable: draggable,
        srcSet: srcSet,
        onError: handleImgLoadError,
        alt: alt,
        crossOrigin: crossOrigin
    });
    else if (hasImageElement) childrenToRender = src;
    else if (icon) childrenToRender = icon;
    else if (mounted || scale !== 1) {
        const transformString = `scale(${scale})`;
        const childrenStyle = {
            msTransform: transformString,
            WebkitTransform: transformString,
            transform: transformString
        };
        childrenToRender = /*#__PURE__*/ $hO8yS.createElement((0, $b8d12c084d14878d$export$2e2bcd8739ae039), {
            onResize: setScaleParam
        }, /*#__PURE__*/ $hO8yS.createElement("span", {
            className: `${prefixCls}-string`,
            ref: avatarChildrenRef,
            style: childrenStyle
        }, children));
    } else childrenToRender = /*#__PURE__*/ $hO8yS.createElement("span", {
        className: `${prefixCls}-string`,
        style: {
            opacity: 0
        },
        ref: avatarChildrenRef
    }, children);
    return /*#__PURE__*/ $hO8yS.createElement("span", {
        ...others,
        style: {
            ...sizeStyle,
            ...responsiveSizeStyle,
            ...contextStyle,
            ...style
        },
        className: classString,
        ref: avatarNodeMergedRef
    }, childrenToRender);
});
var $16f8327e3ed4cc39$export$2e2bcd8739ae039 = $16f8327e3ed4cc39$var$Avatar;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");






parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");



const $5fd6882142905fe9$export$15e5fca53711d340 = (propValue)=>{
    if (!propValue) return null;
    return typeof propValue === 'function' ? propValue() : propValue;
};




// ================== Collapse Motion ==================
const $689b5af26dd3c1cd$var$getCollapsedHeight = ()=>({
        height: 0,
        opacity: 0
    });
const $689b5af26dd3c1cd$var$getRealHeight = (node)=>{
    const { scrollHeight: scrollHeight } = node;
    return {
        height: scrollHeight,
        opacity: 1
    };
};
const $689b5af26dd3c1cd$var$getCurrentHeight = (node)=>({
        height: node ? node.offsetHeight : 0
    });
const $689b5af26dd3c1cd$var$skipOpacityTransition = (_, event)=>event?.deadline === true || event.propertyName === 'height';
const $689b5af26dd3c1cd$var$initCollapseMotion = (rootCls = (0, $dd01e2f5a4b8605d$export$e4ec87ea71f29b41))=>({
        motionName: `${rootCls}-motion-collapse`,
        onAppearStart: $689b5af26dd3c1cd$var$getCollapsedHeight,
        onEnterStart: $689b5af26dd3c1cd$var$getCollapsedHeight,
        onAppearActive: $689b5af26dd3c1cd$var$getRealHeight,
        onEnterActive: $689b5af26dd3c1cd$var$getRealHeight,
        onLeaveStart: $689b5af26dd3c1cd$var$getCurrentHeight,
        onLeaveActive: $689b5af26dd3c1cd$var$getCollapsedHeight,
        onAppearEnd: $689b5af26dd3c1cd$var$skipOpacityTransition,
        onEnterEnd: $689b5af26dd3c1cd$var$skipOpacityTransition,
        onLeaveEnd: $689b5af26dd3c1cd$var$skipOpacityTransition,
        motionDeadline: 500
    });
const $689b5af26dd3c1cd$var$_SelectPlacements = [
    'bottomLeft',
    'bottomRight',
    'topLeft',
    'topRight'
];
const $689b5af26dd3c1cd$export$27c72201b1d09951 = (rootPrefixCls, motion, transitionName)=>{
    if (transitionName !== undefined) return transitionName;
    return `${rootPrefixCls}-${motion}`;
};
var $689b5af26dd3c1cd$export$2e2bcd8739ae039 = $689b5af26dd3c1cd$var$initCollapseMotion;




parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");

parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
const $c1d4e2f940b8a598$var$Popup = (props)=>{
    const { children: children, prefixCls: prefixCls, id: id, classNames: classNames, styles: styles, className: className, style: style } = props;
    return /*#__PURE__*/ $hO8yS.createElement("div", {
        id: id,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-container`, classNames?.container, className),
        style: {
            ...styles?.container,
            ...style
        },
        role: "tooltip"
    }, typeof children === 'function' ? children() : children);
};
var $c1d4e2f940b8a598$export$2e2bcd8739ae039 = $c1d4e2f940b8a598$var$Popup;






var $N3oW3 = parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");
const $55f80df107afccd7$var$autoAdjustOverflowTopBottom = {
    shiftX: 64,
    adjustY: 1
};
const $55f80df107afccd7$var$autoAdjustOverflowLeftRight = {
    adjustX: 1,
    shiftY: true
};
const $55f80df107afccd7$var$targetOffset = [
    0,
    0
];
const $55f80df107afccd7$export$803cd8101b6c182b = {
    left: {
        points: [
            'cr',
            'cl'
        ],
        overflow: $55f80df107afccd7$var$autoAdjustOverflowLeftRight,
        offset: [
            -4,
            0
        ],
        targetOffset: $55f80df107afccd7$var$targetOffset
    },
    right: {
        points: [
            'cl',
            'cr'
        ],
        overflow: $55f80df107afccd7$var$autoAdjustOverflowLeftRight,
        offset: [
            4,
            0
        ],
        targetOffset: $55f80df107afccd7$var$targetOffset
    },
    top: {
        points: [
            'bc',
            'tc'
        ],
        overflow: $55f80df107afccd7$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            -4
        ],
        targetOffset: $55f80df107afccd7$var$targetOffset
    },
    bottom: {
        points: [
            'tc',
            'bc'
        ],
        overflow: $55f80df107afccd7$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            4
        ],
        targetOffset: $55f80df107afccd7$var$targetOffset
    },
    topLeft: {
        points: [
            'bl',
            'tl'
        ],
        overflow: $55f80df107afccd7$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            -4
        ],
        targetOffset: $55f80df107afccd7$var$targetOffset
    },
    leftTop: {
        points: [
            'tr',
            'tl'
        ],
        overflow: $55f80df107afccd7$var$autoAdjustOverflowLeftRight,
        offset: [
            -4,
            0
        ],
        targetOffset: $55f80df107afccd7$var$targetOffset
    },
    topRight: {
        points: [
            'br',
            'tr'
        ],
        overflow: $55f80df107afccd7$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            -4
        ],
        targetOffset: $55f80df107afccd7$var$targetOffset
    },
    rightTop: {
        points: [
            'tl',
            'tr'
        ],
        overflow: $55f80df107afccd7$var$autoAdjustOverflowLeftRight,
        offset: [
            4,
            0
        ],
        targetOffset: $55f80df107afccd7$var$targetOffset
    },
    bottomRight: {
        points: [
            'tr',
            'br'
        ],
        overflow: $55f80df107afccd7$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            4
        ],
        targetOffset: $55f80df107afccd7$var$targetOffset
    },
    rightBottom: {
        points: [
            'bl',
            'br'
        ],
        overflow: $55f80df107afccd7$var$autoAdjustOverflowLeftRight,
        offset: [
            4,
            0
        ],
        targetOffset: $55f80df107afccd7$var$targetOffset
    },
    bottomLeft: {
        points: [
            'tl',
            'bl'
        ],
        overflow: $55f80df107afccd7$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            4
        ],
        targetOffset: $55f80df107afccd7$var$targetOffset
    },
    leftBottom: {
        points: [
            'br',
            'bl'
        ],
        overflow: $55f80df107afccd7$var$autoAdjustOverflowLeftRight,
        offset: [
            -4,
            0
        ],
        targetOffset: $55f80df107afccd7$var$targetOffset
    }
};
var $55f80df107afccd7$export$2e2bcd8739ae039 = $55f80df107afccd7$export$803cd8101b6c182b;



function $50ff1743a74ee089$var$_extends() {
    $50ff1743a74ee089$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $50ff1743a74ee089$var$_extends.apply(this, arguments);
}
const $50ff1743a74ee089$var$Tooltip = /*#__PURE__*/ $N3oW3.forwardRef((props, ref)=>{
    const { trigger: trigger = [
        'hover'
    ], mouseEnterDelay: mouseEnterDelay = 0, mouseLeaveDelay: mouseLeaveDelay = 0.1, prefixCls: prefixCls = 'rc-tooltip', children: children, onVisibleChange: onVisibleChange, afterVisibleChange: afterVisibleChange, motion: motion, placement: placement = 'right', align: align = {}, destroyOnHidden: destroyOnHidden = false, defaultVisible: defaultVisible, getTooltipContainer: getTooltipContainer, arrowContent: arrowContent, overlay: overlay, id: id, showArrow: showArrow = true, classNames: classNames, styles: styles, ...restProps } = props;
    const mergedId = (0, $32268c06752c3bab$export$2e2bcd8739ae039)(id);
    const triggerRef = (0, $32rMB.useRef)(null);
    (0, $32rMB.useImperativeHandle)(ref, ()=>triggerRef.current);
    const extraProps = {
        ...restProps
    };
    if ('visible' in props) extraProps.popupVisible = props.visible;
    // ========================= Arrow ==========================
    // Process arrow configuration
    const mergedArrow = $32rMB.useMemo(()=>{
        if (!showArrow) return false;
        // Convert true to object for unified processing
        const arrowConfig = showArrow === true ? {} : showArrow;
        // Apply semantic styles with unified logic
        return {
            ...arrowConfig,
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(arrowConfig.className, classNames?.arrow),
            style: {
                ...arrowConfig.style,
                ...styles?.arrow
            },
            content: arrowConfig.content ?? arrowContent
        };
    }, [
        showArrow,
        classNames?.arrow,
        styles?.arrow,
        arrowContent
    ]);
    // ======================== Children ========================
    const getChildren = ()=>{
        const child = $N3oW3.Children.only(children);
        const originalProps = child?.props || {};
        const childProps = {
            ...originalProps,
            'aria-describedby': overlay ? mergedId : null
        };
        return /*#__PURE__*/ $N3oW3.cloneElement(children, childProps);
    };
    // ========================= Render =========================
    return /*#__PURE__*/ $hO8yS.createElement((0, $0cc98d0cfc01331c$export$2e2bcd8739ae039), $50ff1743a74ee089$var$_extends({
        popupClassName: classNames?.root,
        prefixCls: prefixCls,
        popup: /*#__PURE__*/ $hO8yS.createElement((0, $c1d4e2f940b8a598$export$2e2bcd8739ae039), {
            key: "content",
            prefixCls: prefixCls,
            id: mergedId,
            classNames: classNames,
            styles: styles
        }, overlay),
        action: trigger,
        builtinPlacements: (0, $55f80df107afccd7$export$803cd8101b6c182b),
        popupPlacement: placement,
        ref: triggerRef,
        popupAlign: align,
        getPopupContainer: getTooltipContainer,
        onOpenChange: onVisibleChange,
        afterOpenChange: afterVisibleChange,
        popupMotion: motion,
        defaultPopupVisible: defaultVisible,
        autoDestroy: destroyOnHidden,
        mouseLeaveDelay: mouseLeaveDelay,
        popupStyle: styles?.root,
        mouseEnterDelay: mouseEnterDelay,
        arrow: mergedArrow,
        uniqueContainerClassName: classNames?.uniqueContainer,
        uniqueContainerStyle: styles?.uniqueContainer
    }, extraProps), getChildren());
});
var $50ff1743a74ee089$export$2e2bcd8739ae039 = $50ff1743a74ee089$var$Tooltip;


var $b2dc4dd58ddb6a64$export$2e2bcd8739ae039 = (0, $50ff1743a74ee089$export$2e2bcd8739ae039);





var $N3oW3 = parcelRequire("N3oW3");
parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");

var $N3oW3 = parcelRequire("N3oW3");




var $N3oW3 = parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");

parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
const $e5b7fab730d97669$export$24829b7c0e49e9f7 = 'RC_FORM_INTERNAL_HOOKS';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e5b7fab730d97669$var$warningFunc = ()=>{
    (0, $6591254ed6bd1058$export$2e2bcd8739ae039)(false, 'Can not find FormContext. Please make sure you wrap Field under Form.');
};
const $e5b7fab730d97669$var$Context = /*#__PURE__*/ $hO8yS.createContext({
    getFieldValue: $e5b7fab730d97669$var$warningFunc,
    getFieldsValue: $e5b7fab730d97669$var$warningFunc,
    getFieldError: $e5b7fab730d97669$var$warningFunc,
    getFieldWarning: $e5b7fab730d97669$var$warningFunc,
    getFieldsError: $e5b7fab730d97669$var$warningFunc,
    isFieldsTouched: $e5b7fab730d97669$var$warningFunc,
    isFieldTouched: $e5b7fab730d97669$var$warningFunc,
    isFieldValidating: $e5b7fab730d97669$var$warningFunc,
    isFieldsValidating: $e5b7fab730d97669$var$warningFunc,
    resetFields: $e5b7fab730d97669$var$warningFunc,
    setFields: $e5b7fab730d97669$var$warningFunc,
    setFieldValue: $e5b7fab730d97669$var$warningFunc,
    setFieldsValue: $e5b7fab730d97669$var$warningFunc,
    validateFields: $e5b7fab730d97669$var$warningFunc,
    submit: $e5b7fab730d97669$var$warningFunc,
    getInternalHooks: ()=>{
        $e5b7fab730d97669$var$warningFunc();
        return {
            dispatch: $e5b7fab730d97669$var$warningFunc,
            initEntityValue: $e5b7fab730d97669$var$warningFunc,
            registerField: $e5b7fab730d97669$var$warningFunc,
            useSubscribe: $e5b7fab730d97669$var$warningFunc,
            setInitialValues: $e5b7fab730d97669$var$warningFunc,
            destroyForm: $e5b7fab730d97669$var$warningFunc,
            setCallbacks: $e5b7fab730d97669$var$warningFunc,
            registerWatch: $e5b7fab730d97669$var$warningFunc,
            getFields: $e5b7fab730d97669$var$warningFunc,
            setValidateMessages: $e5b7fab730d97669$var$warningFunc,
            setPreserve: $e5b7fab730d97669$var$warningFunc,
            getInitialValue: $e5b7fab730d97669$var$warningFunc,
            setBatchUpdate: $e5b7fab730d97669$var$warningFunc
        };
    }
});
var $e5b7fab730d97669$export$2e2bcd8739ae039 = $e5b7fab730d97669$var$Context;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
const $d651cb95b201e088$var$ListContext = /*#__PURE__*/ $hO8yS.createContext(null);
var $d651cb95b201e088$export$2e2bcd8739ae039 = $d651cb95b201e088$var$ListContext;


function $7abb023c0e672c8b$export$45b10814cc054894(value) {
    if (value === undefined || value === null) return [];
    return Array.isArray(value) ? value : [
        value
    ];
}
function $7abb023c0e672c8b$export$717b316e73068e8d(form) {
    return form && !!form._init;
}








function $857d5892f3d98dfe$export$f77fd0c3b25d8534() {
    return {
        default: 'Validation error on field %s',
        required: '%s is required',
        enum: '%s must be one of %s',
        whitespace: '%s cannot be empty',
        date: {
            format: '%s date %s is invalid for format %s',
            parse: '%s date could not be parsed, %s is invalid ',
            invalid: '%s date %s is invalid'
        },
        types: {
            string: '%s is not a %s',
            method: '%s is not a %s (function)',
            array: '%s is not an %s',
            object: '%s is not an %s',
            number: '%s is not a %s',
            date: '%s is not a %s',
            boolean: '%s is not a %s',
            integer: '%s is not an %s',
            float: '%s is not a %s',
            regexp: '%s is not a valid %s',
            email: '%s is not a valid %s',
            url: '%s is not a valid %s',
            hex: '%s is not a valid %s'
        },
        string: {
            len: '%s must be exactly %s characters',
            min: '%s must be at least %s characters',
            max: '%s cannot be longer than %s characters',
            range: '%s must be between %s and %s characters'
        },
        number: {
            len: '%s must equal %s',
            min: '%s cannot be less than %s',
            max: '%s cannot be greater than %s',
            range: '%s must be between %s and %s'
        },
        array: {
            len: '%s must be exactly %s in length',
            min: '%s cannot be less than %s in length',
            max: '%s cannot be greater than %s in length',
            range: '%s must be between %s and %s in length'
        },
        pattern: {
            mismatch: '%s value %s does not match pattern %s'
        },
        clone: function clone() {
            var cloned = JSON.parse(JSON.stringify(this));
            cloned.clone = this.clone;
            return cloned;
        }
    };
}
var $857d5892f3d98dfe$export$defe85febe8b728c = $857d5892f3d98dfe$export$f77fd0c3b25d8534();











function $ecc8413d83db4851$export$2e2bcd8739ae039(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}




function $c163ed0dd230791a$export$2e2bcd8739ae039(t, e, r) {
    if ((0, $f461a574fff50f34$export$2e2bcd8739ae039)()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && (0, $e3c997c5b70ce726$export$2e2bcd8739ae039)(p, r.prototype), p;
}


function $20b9be025a66713c$export$2e2bcd8739ae039(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return $20b9be025a66713c$export$2e2bcd8739ae039 = function _wrapNativeSuper(t) {
        if (null === t || !(0, $ecc8413d83db4851$export$2e2bcd8739ae039)(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return (0, $c163ed0dd230791a$export$2e2bcd8739ae039)(t, arguments, (0, $b0b52459905849f7$export$2e2bcd8739ae039)(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), (0, $e3c997c5b70ce726$export$2e2bcd8739ae039)(Wrapper, t);
    }, $20b9be025a66713c$export$2e2bcd8739ae039(t);
}




/* eslint no-console:0 */ var $6ee37cfdf49d29b7$var$formatRegExp = /%[sdj%]/g;
var $6ee37cfdf49d29b7$export$491112666e282270 = function warning() {};
function $6ee37cfdf49d29b7$export$e85887f5ceeacced(errors) {
    if (!errors || !errors.length) return null;
    var fields = {};
    errors.forEach(function(error) {
        var field = error.field;
        fields[field] = fields[field] || [];
        fields[field].push(error);
    });
    return fields;
}
function $6ee37cfdf49d29b7$export$d9468344d3651243(template) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var i = 0;
    var len = args.length;
    if (typeof template === 'function') // eslint-disable-next-line prefer-spread
    return template.apply(null, args);
    if (typeof template === 'string') {
        var str = template.replace($6ee37cfdf49d29b7$var$formatRegExp, function(x) {
            if (x === '%%') return '%';
            if (i >= len) return x;
            switch(x){
                case '%s':
                    return String(args[i++]);
                case '%d':
                    return Number(args[i++]);
                case '%j':
                    try {
                        return JSON.stringify(args[i++]);
                    } catch (_) {
                        return '[Circular]';
                    }
                    break;
                default:
                    return x;
            }
        });
        return str;
    }
    return template;
}
function $6ee37cfdf49d29b7$var$isNativeStringType(type) {
    return type === 'string' || type === 'url' || type === 'hex' || type === 'email' || type === 'date' || type === 'pattern';
}
function $6ee37cfdf49d29b7$export$141eca273a04dc3e(value, type) {
    if (value === undefined || value === null) return true;
    if (type === 'array' && Array.isArray(value) && !value.length) return true;
    if ($6ee37cfdf49d29b7$var$isNativeStringType(type) && typeof value === 'string' && !value) return true;
    return false;
}
function $6ee37cfdf49d29b7$export$83b788b1a3698c03(obj) {
    return Object.keys(obj).length === 0;
}
function $6ee37cfdf49d29b7$var$asyncParallelArray(arr, func, callback) {
    var results = [];
    var total = 0;
    var arrLength = arr.length;
    function count(errors) {
        results.push.apply(results, (0, $3746fb019e1f2ee5$export$2e2bcd8739ae039)(errors || []));
        total++;
        if (total === arrLength) callback(results);
    }
    arr.forEach(function(a) {
        func(a, count);
    });
}
function $6ee37cfdf49d29b7$var$asyncSerialArray(arr, func, callback) {
    var index = 0;
    var arrLength = arr.length;
    function next(errors) {
        if (errors && errors.length) {
            callback(errors);
            return;
        }
        var original = index;
        index = index + 1;
        if (original < arrLength) func(arr[original], next);
        else callback([]);
    }
    next([]);
}
function $6ee37cfdf49d29b7$var$flattenObjArr(objArr) {
    var ret = [];
    Object.keys(objArr).forEach(function(k) {
        ret.push.apply(ret, (0, $3746fb019e1f2ee5$export$2e2bcd8739ae039)(objArr[k] || []));
    });
    return ret;
}
var $6ee37cfdf49d29b7$export$188f48b73534b6f0 = /*#__PURE__*/ function(_Error) {
    (0, $83a5b97ffa16e22b$export$2e2bcd8739ae039)(AsyncValidationError, _Error);
    var _super = (0, $c64121b56aafd1fd$export$2e2bcd8739ae039)(AsyncValidationError);
    function AsyncValidationError(errors, fields) {
        var _this;
        (0, $c27a1e671724260e$export$2e2bcd8739ae039)(this, AsyncValidationError);
        _this = _super.call(this, 'Async Validation Error');
        (0, $def8730fb4b8d50a$export$2e2bcd8739ae039)((0, $d0ef051c99bfe9a2$export$2e2bcd8739ae039)(_this), "errors", void 0);
        (0, $def8730fb4b8d50a$export$2e2bcd8739ae039)((0, $d0ef051c99bfe9a2$export$2e2bcd8739ae039)(_this), "fields", void 0);
        _this.errors = errors;
        _this.fields = fields;
        return _this;
    }
    return (0, $3d68cfa6e8f65ecd$export$2e2bcd8739ae039)(AsyncValidationError);
}(/*#__PURE__*/ (0, $20b9be025a66713c$export$2e2bcd8739ae039)(Error));
function $6ee37cfdf49d29b7$export$707ee4c4c95d39e3(objArr, option, func, callback, source) {
    if (option.first) {
        var _pending = new Promise(function(resolve, reject) {
            var next = function next(errors) {
                callback(errors);
                return errors.length ? reject(new $6ee37cfdf49d29b7$export$188f48b73534b6f0(errors, $6ee37cfdf49d29b7$export$e85887f5ceeacced(errors))) : resolve(source);
            };
            var flattenArr = $6ee37cfdf49d29b7$var$flattenObjArr(objArr);
            $6ee37cfdf49d29b7$var$asyncSerialArray(flattenArr, func, next);
        });
        _pending.catch(function(e) {
            return e;
        });
        return _pending;
    }
    var firstFields = option.firstFields === true ? Object.keys(objArr) : option.firstFields || [];
    var objArrKeys = Object.keys(objArr);
    var objArrLength = objArrKeys.length;
    var total = 0;
    var results = [];
    var pending = new Promise(function(resolve, reject) {
        var next = function next(errors) {
            // eslint-disable-next-line prefer-spread
            results.push.apply(results, errors);
            total++;
            if (total === objArrLength) {
                callback(results);
                return results.length ? reject(new $6ee37cfdf49d29b7$export$188f48b73534b6f0(results, $6ee37cfdf49d29b7$export$e85887f5ceeacced(results))) : resolve(source);
            }
        };
        if (!objArrKeys.length) {
            callback(results);
            resolve(source);
        }
        objArrKeys.forEach(function(key) {
            var arr = objArr[key];
            if (firstFields.indexOf(key) !== -1) $6ee37cfdf49d29b7$var$asyncSerialArray(arr, func, next);
            else $6ee37cfdf49d29b7$var$asyncParallelArray(arr, func, next);
        });
    });
    pending.catch(function(e) {
        return e;
    });
    return pending;
}
function $6ee37cfdf49d29b7$var$isErrorObj(obj) {
    return !!(obj && obj.message !== undefined);
}
function $6ee37cfdf49d29b7$var$getValue(value, path) {
    var v = value;
    for(var i = 0; i < path.length; i++){
        if (v == undefined) return v;
        v = v[path[i]];
    }
    return v;
}
function $6ee37cfdf49d29b7$export$34d5fe50d2616cee(rule, source) {
    return function(oe) {
        var fieldValue;
        if (rule.fullFields) fieldValue = $6ee37cfdf49d29b7$var$getValue(source, rule.fullFields);
        else fieldValue = source[oe.field || rule.fullField];
        if ($6ee37cfdf49d29b7$var$isErrorObj(oe)) {
            oe.field = oe.field || rule.fullField;
            oe.fieldValue = fieldValue;
            return oe;
        }
        return {
            message: typeof oe === 'function' ? oe() : oe,
            fieldValue: fieldValue,
            field: oe.field || rule.fullField
        };
    };
}
function $6ee37cfdf49d29b7$export$6969335ea1e4e77c(target, source) {
    if (source) {
        for(var s in source)if (source.hasOwnProperty(s)) {
            var value = source[s];
            if ((0, $c5ac91862c8363d3$export$2e2bcd8739ae039)(value) === 'object' && (0, $c5ac91862c8363d3$export$2e2bcd8739ae039)(target[s]) === 'object') target[s] = (0, $cde876c32cf7555b$export$2e2bcd8739ae039)((0, $cde876c32cf7555b$export$2e2bcd8739ae039)({}, target[s]), value);
            else target[s] = value;
        }
    }
    return target;
}



var $b21498ec26a65fa8$var$ENUM = 'enum';
var $b21498ec26a65fa8$var$enumerable = function enumerable(rule, value, source, errors, options) {
    rule[$b21498ec26a65fa8$var$ENUM] = Array.isArray(rule[$b21498ec26a65fa8$var$ENUM]) ? rule[$b21498ec26a65fa8$var$ENUM] : [];
    if (rule[$b21498ec26a65fa8$var$ENUM].indexOf(value) === -1) errors.push((0, $6ee37cfdf49d29b7$export$d9468344d3651243)(options.messages[$b21498ec26a65fa8$var$ENUM], rule.fullField, rule[$b21498ec26a65fa8$var$ENUM].join(', ')));
};
var $b21498ec26a65fa8$export$2e2bcd8739ae039 = $b21498ec26a65fa8$var$enumerable;



var $5e83a1644b7bdfa7$var$pattern = function pattern(rule, value, source, errors, options) {
    if (rule.pattern) {
        if (rule.pattern instanceof RegExp) {
            // if a RegExp instance is passed, reset `lastIndex` in case its `global`
            // flag is accidentally set to `true`, which in a validation scenario
            // is not necessary and the result might be misleading
            rule.pattern.lastIndex = 0;
            if (!rule.pattern.test(value)) errors.push((0, $6ee37cfdf49d29b7$export$d9468344d3651243)(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
        } else if (typeof rule.pattern === 'string') {
            var _pattern = new RegExp(rule.pattern);
            if (!_pattern.test(value)) errors.push((0, $6ee37cfdf49d29b7$export$d9468344d3651243)(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
        }
    }
};
var $5e83a1644b7bdfa7$export$2e2bcd8739ae039 = $5e83a1644b7bdfa7$var$pattern;



var $8d6d1c508ee41bf0$var$range = function range(rule, value, source, errors, options) {
    var len = typeof rule.len === 'number';
    var min = typeof rule.min === 'number';
    var max = typeof rule.max === 'number';
    // 正则匹配码点范围从U+010000一直到U+10FFFF的文字（补充平面Supplementary Plane）
    var spRegexp = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
    var val = value;
    var key = null;
    var num = typeof value === 'number';
    var str = typeof value === 'string';
    var arr = Array.isArray(value);
    if (num) key = 'number';
    else if (str) key = 'string';
    else if (arr) key = 'array';
    // if the value is not of a supported type for range validation
    // the validation rule rule should use the
    // type property to also test for a particular type
    if (!key) return false;
    if (arr) val = value.length;
    if (str) // 处理码点大于U+010000的文字length属性不准确的bug，如"𠮷𠮷𠮷".length !== 3
    val = value.replace(spRegexp, '_').length;
    if (len) {
        if (val !== rule.len) errors.push((0, $6ee37cfdf49d29b7$export$d9468344d3651243)(options.messages[key].len, rule.fullField, rule.len));
    } else if (min && !max && val < rule.min) errors.push((0, $6ee37cfdf49d29b7$export$d9468344d3651243)(options.messages[key].min, rule.fullField, rule.min));
    else if (max && !min && val > rule.max) errors.push((0, $6ee37cfdf49d29b7$export$d9468344d3651243)(options.messages[key].max, rule.fullField, rule.max));
    else if (min && max && (val < rule.min || val > rule.max)) errors.push((0, $6ee37cfdf49d29b7$export$d9468344d3651243)(options.messages[key].range, rule.fullField, rule.min, rule.max));
};
var $8d6d1c508ee41bf0$export$2e2bcd8739ae039 = $8d6d1c508ee41bf0$var$range;



var $b7a77ef4cc752a2a$var$required = function required(rule, value, source, errors, options, type) {
    if (rule.required && (!source.hasOwnProperty(rule.field) || (0, $6ee37cfdf49d29b7$export$141eca273a04dc3e)(value, type || rule.type))) errors.push((0, $6ee37cfdf49d29b7$export$d9468344d3651243)(options.messages.required, rule.fullField));
};
var $b7a77ef4cc752a2a$export$2e2bcd8739ae039 = $b7a77ef4cc752a2a$var$required;





// https://github.com/kevva/url-regex/blob/master/index.js
var $01bbcba44529a2d2$var$urlReg;
var $01bbcba44529a2d2$export$2e2bcd8739ae039 = function() {
    if ($01bbcba44529a2d2$var$urlReg) return $01bbcba44529a2d2$var$urlReg;
    var word = '[a-fA-F\\d:]';
    var b = function b(options) {
        return options && options.includeBoundaries ? "(?:(?<=\\s|^)(?=".concat(word, ")|(?<=").concat(word, ")(?=\\s|$))") : '';
    };
    var v4 = '(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}';
    var v6seg = '[a-fA-F\\d]{1,4}';
    var v6List = [
        "(?:".concat(v6seg, ":){7}(?:").concat(v6seg, "|:)"),
        "(?:".concat(v6seg, ":){6}(?:").concat(v4, "|:").concat(v6seg, "|:)"),
        "(?:".concat(v6seg, ":){5}(?::").concat(v4, "|(?::").concat(v6seg, "){1,2}|:)"),
        "(?:".concat(v6seg, ":){4}(?:(?::").concat(v6seg, "){0,1}:").concat(v4, "|(?::").concat(v6seg, "){1,3}|:)"),
        "(?:".concat(v6seg, ":){3}(?:(?::").concat(v6seg, "){0,2}:").concat(v4, "|(?::").concat(v6seg, "){1,4}|:)"),
        "(?:".concat(v6seg, ":){2}(?:(?::").concat(v6seg, "){0,3}:").concat(v4, "|(?::").concat(v6seg, "){1,5}|:)"),
        "(?:".concat(v6seg, ":){1}(?:(?::").concat(v6seg, "){0,4}:").concat(v4, "|(?::").concat(v6seg, "){1,6}|:)"),
        "(?::(?:(?::".concat(v6seg, "){0,5}:").concat(v4, "|(?::").concat(v6seg, "){1,7}|:))") // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::
    ];
    var v6Eth0 = "(?:%[0-9a-zA-Z]{1,})?"; // %eth0            %1
    var v6 = "(?:".concat(v6List.join('|'), ")").concat(v6Eth0);
    // Pre-compile only the exact regexes because adding a global flag make regexes stateful
    var v46Exact = new RegExp("(?:^".concat(v4, "$)|(?:^").concat(v6, "$)"));
    var v4exact = new RegExp("^".concat(v4, "$"));
    var v6exact = new RegExp("^".concat(v6, "$"));
    var ip = function ip(options) {
        return options && options.exact ? v46Exact : new RegExp("(?:".concat(b(options)).concat(v4).concat(b(options), ")|(?:").concat(b(options)).concat(v6).concat(b(options), ")"), 'g');
    };
    ip.v4 = function(options) {
        return options && options.exact ? v4exact : new RegExp("".concat(b(options)).concat(v4).concat(b(options)), 'g');
    };
    ip.v6 = function(options) {
        return options && options.exact ? v6exact : new RegExp("".concat(b(options)).concat(v6).concat(b(options)), 'g');
    };
    var protocol = "(?:(?:[a-z]+:)?//)";
    var auth = '(?:\\S+(?::\\S*)?@)?';
    var ipv4 = ip.v4().source;
    var ipv6 = ip.v6().source;
    var host = "(?:(?:[a-z\\u00a1-\\uffff0-9][-_]*)*[a-z\\u00a1-\\uffff0-9]+)";
    var domain = "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*";
    var tld = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))";
    var port = '(?::\\d{2,5})?';
    var path = '(?:[/?#][^\\s"]*)?';
    var regex = "(?:".concat(protocol, "|www\\.)").concat(auth, "(?:localhost|").concat(ipv4, "|").concat(ipv6, "|").concat(host).concat(domain).concat(tld, ")").concat(port).concat(path);
    $01bbcba44529a2d2$var$urlReg = new RegExp("(?:^".concat(regex, "$)"), 'i');
    return $01bbcba44529a2d2$var$urlReg;
};


/* eslint max-len:0 */ var $9275b7dd5cc8c1ee$var$pattern = {
    // http://emailregex.com/
    email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/,
    // url: new RegExp(
    //   '^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$',
    //   'i',
    // ),
    hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
};
var $9275b7dd5cc8c1ee$var$types = {
    integer: function integer(value) {
        return $9275b7dd5cc8c1ee$var$types.number(value) && parseInt(value, 10) === value;
    },
    float: function float(value) {
        return $9275b7dd5cc8c1ee$var$types.number(value) && !$9275b7dd5cc8c1ee$var$types.integer(value);
    },
    array: function array(value) {
        return Array.isArray(value);
    },
    regexp: function regexp(value) {
        if (value instanceof RegExp) return true;
        try {
            return new RegExp(value), true;
        } catch (e) {
            return false;
        }
    },
    date: function date(value) {
        return typeof value.getTime === 'function' && typeof value.getMonth === 'function' && typeof value.getYear === 'function' && !isNaN(value.getTime());
    },
    number: function number(value) {
        if (isNaN(value)) return false;
        return typeof value === 'number';
    },
    object: function object(value) {
        return (0, $c5ac91862c8363d3$export$2e2bcd8739ae039)(value) === 'object' && !$9275b7dd5cc8c1ee$var$types.array(value);
    },
    method: function method(value) {
        return typeof value === 'function';
    },
    email: function email(value) {
        return typeof value === 'string' && value.length <= 320 && !!value.match($9275b7dd5cc8c1ee$var$pattern.email);
    },
    url: function url(value) {
        return typeof value === 'string' && value.length <= 2048 && !!value.match((0, $01bbcba44529a2d2$export$2e2bcd8739ae039)());
    },
    hex: function hex(value) {
        return typeof value === 'string' && !!value.match($9275b7dd5cc8c1ee$var$pattern.hex);
    }
};
var $9275b7dd5cc8c1ee$var$type = function type(rule, value, source, errors, options) {
    if (rule.required && value === undefined) {
        (0, $b7a77ef4cc752a2a$export$2e2bcd8739ae039)(rule, value, source, errors, options);
        return;
    }
    var custom = [
        'integer',
        'float',
        'array',
        'regexp',
        'object',
        'method',
        'email',
        'number',
        'date',
        'url',
        'hex'
    ];
    var ruleType = rule.type;
    if (custom.indexOf(ruleType) > -1) {
        if (!$9275b7dd5cc8c1ee$var$types[ruleType](value)) errors.push((0, $6ee37cfdf49d29b7$export$d9468344d3651243)(options.messages.types[ruleType], rule.fullField, rule.type));
    } else if (ruleType && (0, $c5ac91862c8363d3$export$2e2bcd8739ae039)(value) !== rule.type) errors.push((0, $6ee37cfdf49d29b7$export$d9468344d3651243)(options.messages.types[ruleType], rule.fullField, rule.type));
};
var $9275b7dd5cc8c1ee$export$2e2bcd8739ae039 = $9275b7dd5cc8c1ee$var$type;



/**
 *  Rule for validating whitespace.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */ var $d730d7cf007d1ae5$var$whitespace = function whitespace(rule, value, source, errors, options) {
    if (/^\s+$/.test(value) || value === '') errors.push((0, $6ee37cfdf49d29b7$export$d9468344d3651243)(options.messages.whitespace, rule.fullField));
};
var $d730d7cf007d1ae5$export$2e2bcd8739ae039 = $d730d7cf007d1ae5$var$whitespace;


var $0f83e054747dbab9$export$2e2bcd8739ae039 = {
    required: (0, $b7a77ef4cc752a2a$export$2e2bcd8739ae039),
    whitespace: (0, $d730d7cf007d1ae5$export$2e2bcd8739ae039),
    type: (0, $9275b7dd5cc8c1ee$export$2e2bcd8739ae039),
    range: (0, $8d6d1c508ee41bf0$export$2e2bcd8739ae039),
    enum: (0, $b21498ec26a65fa8$export$2e2bcd8739ae039),
    pattern: (0, $5e83a1644b7bdfa7$export$2e2bcd8739ae039)
};



var $56c8da588149fdc6$var$any = function any(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $6ee37cfdf49d29b7$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $0f83e054747dbab9$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
    }
    callback(errors);
};
var $56c8da588149fdc6$export$2e2bcd8739ae039 = $56c8da588149fdc6$var$any;



var $70c8db2378e839bd$var$array = function array(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((value === undefined || value === null) && !rule.required) return callback();
        (0, $0f83e054747dbab9$export$2e2bcd8739ae039).required(rule, value, source, errors, options, 'array');
        if (value !== undefined && value !== null) {
            (0, $0f83e054747dbab9$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
            (0, $0f83e054747dbab9$export$2e2bcd8739ae039).range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $70c8db2378e839bd$export$2e2bcd8739ae039 = $70c8db2378e839bd$var$array;




var $1755d6e0b51baf82$var$boolean = function boolean(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $6ee37cfdf49d29b7$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $0f83e054747dbab9$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (value !== undefined) (0, $0f83e054747dbab9$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $1755d6e0b51baf82$export$2e2bcd8739ae039 = $1755d6e0b51baf82$var$boolean;




var $e8d263c419ff4c2a$var$date = function date(rule, value, callback, source, options) {
    // console.log('integer rule called %j', rule);
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    // console.log('validate on %s value', value);
    if (validate) {
        if ((0, $6ee37cfdf49d29b7$export$141eca273a04dc3e)(value, 'date') && !rule.required) return callback();
        (0, $0f83e054747dbab9$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (!(0, $6ee37cfdf49d29b7$export$141eca273a04dc3e)(value, 'date')) {
            var dateObject;
            if (value instanceof Date) dateObject = value;
            else dateObject = new Date(value);
            (0, $0f83e054747dbab9$export$2e2bcd8739ae039).type(rule, dateObject, source, errors, options);
            if (dateObject) (0, $0f83e054747dbab9$export$2e2bcd8739ae039).range(rule, dateObject.getTime(), source, errors, options);
        }
    }
    callback(errors);
};
var $e8d263c419ff4c2a$export$2e2bcd8739ae039 = $e8d263c419ff4c2a$var$date;




var $0acffa1aac6dbe0f$var$ENUM = 'enum';
var $0acffa1aac6dbe0f$var$enumerable = function enumerable(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $6ee37cfdf49d29b7$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $0f83e054747dbab9$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (value !== undefined) (0, $0f83e054747dbab9$export$2e2bcd8739ae039)[$0acffa1aac6dbe0f$var$ENUM](rule, value, source, errors, options);
    }
    callback(errors);
};
var $0acffa1aac6dbe0f$export$2e2bcd8739ae039 = $0acffa1aac6dbe0f$var$enumerable;




var $cc7cb5332d90a115$var$floatFn = function floatFn(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $6ee37cfdf49d29b7$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $0f83e054747dbab9$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (value !== undefined) {
            (0, $0f83e054747dbab9$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
            (0, $0f83e054747dbab9$export$2e2bcd8739ae039).range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $cc7cb5332d90a115$export$2e2bcd8739ae039 = $cc7cb5332d90a115$var$floatFn;




var $d8e1baf504ff3d94$var$integer = function integer(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $6ee37cfdf49d29b7$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $0f83e054747dbab9$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (value !== undefined) {
            (0, $0f83e054747dbab9$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
            (0, $0f83e054747dbab9$export$2e2bcd8739ae039).range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $d8e1baf504ff3d94$export$2e2bcd8739ae039 = $d8e1baf504ff3d94$var$integer;




var $041b7eda4d6a93e7$var$method = function method(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $6ee37cfdf49d29b7$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $0f83e054747dbab9$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (value !== undefined) (0, $0f83e054747dbab9$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $041b7eda4d6a93e7$export$2e2bcd8739ae039 = $041b7eda4d6a93e7$var$method;




var $2dcf286202a57ad4$var$number = function number(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if (value === '') // eslint-disable-next-line no-param-reassign
        value = undefined;
        if ((0, $6ee37cfdf49d29b7$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $0f83e054747dbab9$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (value !== undefined) {
            (0, $0f83e054747dbab9$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
            (0, $0f83e054747dbab9$export$2e2bcd8739ae039).range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $2dcf286202a57ad4$export$2e2bcd8739ae039 = $2dcf286202a57ad4$var$number;




var $6d2de8da7f1ffe1e$var$object = function object(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $6ee37cfdf49d29b7$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $0f83e054747dbab9$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (value !== undefined) (0, $0f83e054747dbab9$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $6d2de8da7f1ffe1e$export$2e2bcd8739ae039 = $6d2de8da7f1ffe1e$var$object;




var $e58fc2e8583e4256$var$pattern = function pattern(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $6ee37cfdf49d29b7$export$141eca273a04dc3e)(value, 'string') && !rule.required) return callback();
        (0, $0f83e054747dbab9$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (!(0, $6ee37cfdf49d29b7$export$141eca273a04dc3e)(value, 'string')) (0, $0f83e054747dbab9$export$2e2bcd8739ae039).pattern(rule, value, source, errors, options);
    }
    callback(errors);
};
var $e58fc2e8583e4256$export$2e2bcd8739ae039 = $e58fc2e8583e4256$var$pattern;




var $16c3f201ba1f2813$var$regexp = function regexp(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $6ee37cfdf49d29b7$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $0f83e054747dbab9$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (!(0, $6ee37cfdf49d29b7$export$141eca273a04dc3e)(value)) (0, $0f83e054747dbab9$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $16c3f201ba1f2813$export$2e2bcd8739ae039 = $16c3f201ba1f2813$var$regexp;




var $df05631ecaa50976$var$required = function required(rule, value, callback, source, options) {
    var errors = [];
    var type = Array.isArray(value) ? 'array' : (0, $c5ac91862c8363d3$export$2e2bcd8739ae039)(value);
    (0, $0f83e054747dbab9$export$2e2bcd8739ae039).required(rule, value, source, errors, options, type);
    callback(errors);
};
var $df05631ecaa50976$export$2e2bcd8739ae039 = $df05631ecaa50976$var$required;




var $ab8a1f146deb74ee$var$string = function string(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $6ee37cfdf49d29b7$export$141eca273a04dc3e)(value, 'string') && !rule.required) return callback();
        (0, $0f83e054747dbab9$export$2e2bcd8739ae039).required(rule, value, source, errors, options, 'string');
        if (!(0, $6ee37cfdf49d29b7$export$141eca273a04dc3e)(value, 'string')) {
            (0, $0f83e054747dbab9$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
            (0, $0f83e054747dbab9$export$2e2bcd8739ae039).range(rule, value, source, errors, options);
            (0, $0f83e054747dbab9$export$2e2bcd8739ae039).pattern(rule, value, source, errors, options);
            if (rule.whitespace === true) (0, $0f83e054747dbab9$export$2e2bcd8739ae039).whitespace(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $ab8a1f146deb74ee$export$2e2bcd8739ae039 = $ab8a1f146deb74ee$var$string;




var $d92564965be3128e$var$type = function type(rule, value, callback, source, options) {
    var ruleType = rule.type;
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $6ee37cfdf49d29b7$export$141eca273a04dc3e)(value, ruleType) && !rule.required) return callback();
        (0, $0f83e054747dbab9$export$2e2bcd8739ae039).required(rule, value, source, errors, options, ruleType);
        if (!(0, $6ee37cfdf49d29b7$export$141eca273a04dc3e)(value, ruleType)) (0, $0f83e054747dbab9$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $d92564965be3128e$export$2e2bcd8739ae039 = $d92564965be3128e$var$type;


var $970c0c15dc29b0ca$export$2e2bcd8739ae039 = {
    string: (0, $ab8a1f146deb74ee$export$2e2bcd8739ae039),
    method: (0, $041b7eda4d6a93e7$export$2e2bcd8739ae039),
    number: (0, $2dcf286202a57ad4$export$2e2bcd8739ae039),
    boolean: (0, $1755d6e0b51baf82$export$2e2bcd8739ae039),
    regexp: (0, $16c3f201ba1f2813$export$2e2bcd8739ae039),
    integer: (0, $d8e1baf504ff3d94$export$2e2bcd8739ae039),
    float: (0, $cc7cb5332d90a115$export$2e2bcd8739ae039),
    array: (0, $70c8db2378e839bd$export$2e2bcd8739ae039),
    object: (0, $6d2de8da7f1ffe1e$export$2e2bcd8739ae039),
    enum: (0, $0acffa1aac6dbe0f$export$2e2bcd8739ae039),
    pattern: (0, $e58fc2e8583e4256$export$2e2bcd8739ae039),
    date: (0, $e8d263c419ff4c2a$export$2e2bcd8739ae039),
    url: (0, $d92564965be3128e$export$2e2bcd8739ae039),
    hex: (0, $d92564965be3128e$export$2e2bcd8739ae039),
    email: (0, $d92564965be3128e$export$2e2bcd8739ae039),
    required: (0, $df05631ecaa50976$export$2e2bcd8739ae039),
    any: (0, $56c8da588149fdc6$export$2e2bcd8739ae039)
};




/**
 *  Encapsulates a validation schema.
 *
 *  @param descriptor An object declaring validation rules
 *  for this schema.
 */ var $1d3103cdb8ecc4f8$var$Schema = /*#__PURE__*/ function() {
    function Schema(descriptor) {
        (0, $c27a1e671724260e$export$2e2bcd8739ae039)(this, Schema);
        // ======================== Instance ========================
        (0, $def8730fb4b8d50a$export$2e2bcd8739ae039)(this, "rules", null);
        (0, $def8730fb4b8d50a$export$2e2bcd8739ae039)(this, "_messages", (0, $857d5892f3d98dfe$export$defe85febe8b728c));
        this.define(descriptor);
    }
    (0, $3d68cfa6e8f65ecd$export$2e2bcd8739ae039)(Schema, [
        {
            key: "define",
            value: function define(rules) {
                var _this = this;
                if (!rules) throw new Error('Cannot configure a schema with no rules');
                if ((0, $c5ac91862c8363d3$export$2e2bcd8739ae039)(rules) !== 'object' || Array.isArray(rules)) throw new Error('Rules must be an object');
                this.rules = {};
                Object.keys(rules).forEach(function(name) {
                    var item = rules[name];
                    _this.rules[name] = Array.isArray(item) ? item : [
                        item
                    ];
                });
            }
        },
        {
            key: "messages",
            value: function messages(_messages) {
                if (_messages) this._messages = (0, $6ee37cfdf49d29b7$export$6969335ea1e4e77c)((0, $857d5892f3d98dfe$export$f77fd0c3b25d8534)(), _messages);
                return this._messages;
            }
        },
        {
            key: "validate",
            value: function validate(source_) {
                var _this2 = this;
                var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var oc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function() {};
                var source = source_;
                var options = o;
                var callback = oc;
                if (typeof options === 'function') {
                    callback = options;
                    options = {};
                }
                if (!this.rules || Object.keys(this.rules).length === 0) {
                    if (callback) callback(null, source);
                    return Promise.resolve(source);
                }
                function complete(results) {
                    var errors = [];
                    var fields = {};
                    function add(e) {
                        if (Array.isArray(e)) {
                            var _errors;
                            errors = (_errors = errors).concat.apply(_errors, (0, $3746fb019e1f2ee5$export$2e2bcd8739ae039)(e));
                        } else errors.push(e);
                    }
                    for(var i = 0; i < results.length; i++)add(results[i]);
                    if (!errors.length) callback(null, source);
                    else {
                        fields = (0, $6ee37cfdf49d29b7$export$e85887f5ceeacced)(errors);
                        callback(errors, fields);
                    }
                }
                if (options.messages) {
                    var messages = this.messages();
                    if (messages === (0, $857d5892f3d98dfe$export$defe85febe8b728c)) messages = (0, $857d5892f3d98dfe$export$f77fd0c3b25d8534)();
                    (0, $6ee37cfdf49d29b7$export$6969335ea1e4e77c)(messages, options.messages);
                    options.messages = messages;
                } else options.messages = this.messages();
                var series = {};
                var keys = options.keys || Object.keys(this.rules);
                keys.forEach(function(z) {
                    var arr = _this2.rules[z];
                    var value = source[z];
                    arr.forEach(function(r) {
                        var rule = r;
                        if (typeof rule.transform === 'function') {
                            if (source === source_) source = (0, $cde876c32cf7555b$export$2e2bcd8739ae039)({}, source);
                            value = source[z] = rule.transform(value);
                            if (value !== undefined && value !== null) rule.type = rule.type || (Array.isArray(value) ? 'array' : (0, $c5ac91862c8363d3$export$2e2bcd8739ae039)(value));
                        }
                        if (typeof rule === 'function') rule = {
                            validator: rule
                        };
                        else rule = (0, $cde876c32cf7555b$export$2e2bcd8739ae039)({}, rule);
                        // Fill validator. Skip if nothing need to validate
                        rule.validator = _this2.getValidationMethod(rule);
                        if (!rule.validator) return;
                        rule.field = z;
                        rule.fullField = rule.fullField || z;
                        rule.type = _this2.getType(rule);
                        series[z] = series[z] || [];
                        series[z].push({
                            rule: rule,
                            value: value,
                            source: source,
                            field: z
                        });
                    });
                });
                var errorFields = {};
                return (0, $6ee37cfdf49d29b7$export$707ee4c4c95d39e3)(series, options, function(data, doIt) {
                    var rule = data.rule;
                    var deep = (rule.type === 'object' || rule.type === 'array') && ((0, $c5ac91862c8363d3$export$2e2bcd8739ae039)(rule.fields) === 'object' || (0, $c5ac91862c8363d3$export$2e2bcd8739ae039)(rule.defaultField) === 'object');
                    deep = deep && (rule.required || !rule.required && data.value);
                    rule.field = data.field;
                    function addFullField(key, schema) {
                        return (0, $cde876c32cf7555b$export$2e2bcd8739ae039)((0, $cde876c32cf7555b$export$2e2bcd8739ae039)({}, schema), {}, {
                            fullField: "".concat(rule.fullField, ".").concat(key),
                            fullFields: rule.fullFields ? [].concat((0, $3746fb019e1f2ee5$export$2e2bcd8739ae039)(rule.fullFields), [
                                key
                            ]) : [
                                key
                            ]
                        });
                    }
                    function cb() {
                        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                        var errorList = Array.isArray(e) ? e : [
                            e
                        ];
                        if (!options.suppressWarning && errorList.length) Schema.warning('async-validator:', errorList);
                        if (errorList.length && rule.message !== undefined) errorList = [].concat(rule.message);
                        // Fill error info
                        var filledErrors = errorList.map((0, $6ee37cfdf49d29b7$export$34d5fe50d2616cee)(rule, source));
                        if (options.first && filledErrors.length) {
                            errorFields[rule.field] = 1;
                            return doIt(filledErrors);
                        }
                        if (!deep) doIt(filledErrors);
                        else {
                            // if rule is required but the target object
                            // does not exist fail at the rule level and don't
                            // go deeper
                            if (rule.required && !data.value) {
                                if (rule.message !== undefined) filledErrors = [].concat(rule.message).map((0, $6ee37cfdf49d29b7$export$34d5fe50d2616cee)(rule, source));
                                else if (options.error) filledErrors = [
                                    options.error(rule, (0, $6ee37cfdf49d29b7$export$d9468344d3651243)(options.messages.required, rule.field))
                                ];
                                return doIt(filledErrors);
                            }
                            var fieldsSchema = {};
                            if (rule.defaultField) Object.keys(data.value).map(function(key) {
                                fieldsSchema[key] = rule.defaultField;
                            });
                            fieldsSchema = (0, $cde876c32cf7555b$export$2e2bcd8739ae039)((0, $cde876c32cf7555b$export$2e2bcd8739ae039)({}, fieldsSchema), data.rule.fields);
                            var paredFieldsSchema = {};
                            Object.keys(fieldsSchema).forEach(function(field) {
                                var fieldSchema = fieldsSchema[field];
                                var fieldSchemaList = Array.isArray(fieldSchema) ? fieldSchema : [
                                    fieldSchema
                                ];
                                paredFieldsSchema[field] = fieldSchemaList.map(addFullField.bind(null, field));
                            });
                            var schema = new Schema(paredFieldsSchema);
                            schema.messages(options.messages);
                            if (data.rule.options) {
                                data.rule.options.messages = options.messages;
                                data.rule.options.error = options.error;
                            }
                            schema.validate(data.value, data.rule.options || options, function(errs) {
                                var finalErrors = [];
                                if (filledErrors && filledErrors.length) finalErrors.push.apply(finalErrors, (0, $3746fb019e1f2ee5$export$2e2bcd8739ae039)(filledErrors));
                                if (errs && errs.length) finalErrors.push.apply(finalErrors, (0, $3746fb019e1f2ee5$export$2e2bcd8739ae039)(errs));
                                doIt(finalErrors.length ? finalErrors : null);
                            });
                        }
                    }
                    var res;
                    if (rule.asyncValidator) res = rule.asyncValidator(rule, data.value, cb, data.source, options);
                    else if (rule.validator) {
                        try {
                            res = rule.validator(rule, data.value, cb, data.source, options);
                        } catch (error) {
                            var _console$error, _console;
                            (_console$error = (_console = console).error) === null || _console$error === void 0 || _console$error.call(_console, error);
                            // rethrow to report error
                            if (!options.suppressValidatorError) setTimeout(function() {
                                throw error;
                            }, 0);
                            cb(error.message);
                        }
                        if (res === true) cb();
                        else if (res === false) cb(typeof rule.message === 'function' ? rule.message(rule.fullField || rule.field) : rule.message || "".concat(rule.fullField || rule.field, " fails"));
                        else if (res instanceof Array) cb(res);
                        else if (res instanceof Error) cb(res.message);
                    }
                    if (res && res.then) res.then(function() {
                        return cb();
                    }, function(e) {
                        return cb(e);
                    });
                }, function(results) {
                    complete(results);
                }, source);
            }
        },
        {
            key: "getType",
            value: function getType(rule) {
                if (rule.type === undefined && rule.pattern instanceof RegExp) rule.type = 'pattern';
                if (typeof rule.validator !== 'function' && rule.type && !(0, $970c0c15dc29b0ca$export$2e2bcd8739ae039).hasOwnProperty(rule.type)) throw new Error((0, $6ee37cfdf49d29b7$export$d9468344d3651243)('Unknown rule type %s', rule.type));
                return rule.type || 'string';
            }
        },
        {
            key: "getValidationMethod",
            value: function getValidationMethod(rule) {
                if (typeof rule.validator === 'function') return rule.validator;
                var keys = Object.keys(rule);
                var messageIndex = keys.indexOf('message');
                if (messageIndex !== -1) keys.splice(messageIndex, 1);
                if (keys.length === 1 && keys[0] === 'required') return (0, $970c0c15dc29b0ca$export$2e2bcd8739ae039).required;
                return (0, $970c0c15dc29b0ca$export$2e2bcd8739ae039)[this.getType(rule)] || undefined;
            }
        }
    ]);
    return Schema;
}();
// ========================= Static =========================
(0, $def8730fb4b8d50a$export$2e2bcd8739ae039)($1d3103cdb8ecc4f8$var$Schema, "register", function register(type, validator) {
    if (typeof validator !== 'function') throw new Error('Cannot register a validator by type, validator is not a function');
    (0, $970c0c15dc29b0ca$export$2e2bcd8739ae039)[type] = validator;
});
(0, $def8730fb4b8d50a$export$2e2bcd8739ae039)($1d3103cdb8ecc4f8$var$Schema, "warning", (0, $6ee37cfdf49d29b7$export$491112666e282270));
(0, $def8730fb4b8d50a$export$2e2bcd8739ae039)($1d3103cdb8ecc4f8$var$Schema, "messages", (0, $857d5892f3d98dfe$export$defe85febe8b728c));
(0, $def8730fb4b8d50a$export$2e2bcd8739ae039)($1d3103cdb8ecc4f8$var$Schema, "validators", (0, $970c0c15dc29b0ca$export$2e2bcd8739ae039));
var $1d3103cdb8ecc4f8$export$2e2bcd8739ae039 = $1d3103cdb8ecc4f8$var$Schema;



var $N3oW3 = parcelRequire("N3oW3");

const $56211d4c2886bc69$var$typeTemplate = "'${name}' is not a valid ${type}";
const $56211d4c2886bc69$export$c86b939816b8fbf8 = {
    default: "Validation error on field '${name}'",
    required: "'${name}' is required",
    enum: "'${name}' must be one of [${enum}]",
    whitespace: "'${name}' cannot be empty",
    date: {
        format: "'${name}' is invalid for format date",
        parse: "'${name}' could not be parsed as date",
        invalid: "'${name}' is invalid date"
    },
    types: {
        string: $56211d4c2886bc69$var$typeTemplate,
        method: $56211d4c2886bc69$var$typeTemplate,
        array: $56211d4c2886bc69$var$typeTemplate,
        object: $56211d4c2886bc69$var$typeTemplate,
        number: $56211d4c2886bc69$var$typeTemplate,
        date: $56211d4c2886bc69$var$typeTemplate,
        boolean: $56211d4c2886bc69$var$typeTemplate,
        integer: $56211d4c2886bc69$var$typeTemplate,
        float: $56211d4c2886bc69$var$typeTemplate,
        regexp: $56211d4c2886bc69$var$typeTemplate,
        email: $56211d4c2886bc69$var$typeTemplate,
        url: $56211d4c2886bc69$var$typeTemplate,
        hex: $56211d4c2886bc69$var$typeTemplate
    },
    string: {
        len: "'${name}' must be exactly ${len} characters",
        min: "'${name}' must be at least ${min} characters",
        max: "'${name}' cannot be longer than ${max} characters",
        range: "'${name}' must be between ${min} and ${max} characters"
    },
    number: {
        len: "'${name}' must equal ${len}",
        min: "'${name}' cannot be less than ${min}",
        max: "'${name}' cannot be greater than ${max}",
        range: "'${name}' must be between ${min} and ${max}"
    },
    array: {
        len: "'${name}' must be exactly ${len} in length",
        min: "'${name}' cannot be less than ${min} in length",
        max: "'${name}' cannot be greater than ${max} in length",
        range: "'${name}' must be between ${min} and ${max} in length"
    },
    pattern: {
        mismatch: "'${name}' does not match pattern ${pattern}"
    }
};



// Remove incorrect original ts define
const $6b0cfca1ab5d6e4a$var$AsyncValidator = (0, $1d3103cdb8ecc4f8$export$2e2bcd8739ae039);
/**
 * Replace with template.
 *   `I'm ${name}` + { name: 'bamboo' } = I'm bamboo
 */ function $6b0cfca1ab5d6e4a$var$replaceMessage(template, kv) {
    return template.replace(/\\?\$\{\w+\}/g, (str)=>{
        if (str.startsWith('\\')) return str.slice(1);
        const key = str.slice(2, -1);
        return kv[key];
    });
}
const $6b0cfca1ab5d6e4a$var$CODE_LOGIC_ERROR = 'CODE_LOGIC_ERROR';
async function $6b0cfca1ab5d6e4a$var$validateRule(name, value, rule, options, messageVariables) {
    const cloneRule = {
        ...rule
    };
    // Bug of `async-validator`
    // https://github.com/react-component/field-form/issues/316
    // https://github.com/react-component/field-form/issues/313
    delete cloneRule.ruleIndex;
    // https://github.com/ant-design/ant-design/issues/40497#issuecomment-1422282378
    $6b0cfca1ab5d6e4a$var$AsyncValidator.warning = ()=>void 0;
    if (cloneRule.validator) {
        const originValidator = cloneRule.validator;
        cloneRule.validator = (...args)=>{
            try {
                return originValidator(...args);
            } catch (error) {
                console.error(error);
                return Promise.reject($6b0cfca1ab5d6e4a$var$CODE_LOGIC_ERROR);
            }
        };
    }
    // We should special handle array validate
    let subRuleField = null;
    if (cloneRule && cloneRule.type === 'array' && cloneRule.defaultField) {
        subRuleField = cloneRule.defaultField;
        delete cloneRule.defaultField;
    }
    const validator = new $6b0cfca1ab5d6e4a$var$AsyncValidator({
        [name]: [
            cloneRule
        ]
    });
    const messages = (0, $3d19a70b12f43514$export$4950aa0f605343fb)((0, $56211d4c2886bc69$export$c86b939816b8fbf8), options.validateMessages);
    validator.messages(messages);
    let result = [];
    try {
        await Promise.resolve(validator.validate({
            [name]: value
        }, {
            ...options
        }));
    } catch (errObj) {
        if (errObj.errors) result = errObj.errors.map(({ message: message }, index)=>{
            const mergedMessage = message === $6b0cfca1ab5d6e4a$var$CODE_LOGIC_ERROR ? messages.default : message;
            return /*#__PURE__*/ $N3oW3.isValidElement(mergedMessage) ? /*#__PURE__*/ // Wrap ReactNode with `key`
            $N3oW3.cloneElement(mergedMessage, {
                key: `error_${index}`
            }) : mergedMessage;
        });
    }
    if (!result.length && subRuleField && Array.isArray(value) && value.length > 0) {
        const subResults = await Promise.all(value.map((subValue, i)=>$6b0cfca1ab5d6e4a$var$validateRule(`${name}.${i}`, subValue, subRuleField, options, messageVariables)));
        return subResults.reduce((prev, errors)=>[
                ...prev,
                ...errors
            ], []);
    }
    // Replace message with variables
    const kv = {
        ...rule,
        name: name,
        enum: (rule.enum || []).join(', '),
        ...messageVariables
    };
    const fillVariableResult = result.map((error)=>{
        if (typeof error === 'string') return $6b0cfca1ab5d6e4a$var$replaceMessage(error, kv);
        return error;
    });
    return fillVariableResult;
}
function $6b0cfca1ab5d6e4a$export$e1fc4b442d0297dd(namePath, value, rules, options, validateFirst, messageVariables) {
    const name = namePath.join('.');
    // Fill rule with context
    const filledRules = rules.map((currentRule, ruleIndex)=>{
        const originValidatorFunc = currentRule.validator;
        const cloneRule = {
            ...currentRule,
            ruleIndex: ruleIndex
        };
        // Replace validator if needed
        if (originValidatorFunc) cloneRule.validator = (rule, val, callback)=>{
            let hasPromise = false;
            // Wrap callback only accept when promise not provided
            const wrappedCallback = (...args)=>{
                // Wait a tick to make sure return type is a promise
                Promise.resolve().then(()=>{
                    (0, $6591254ed6bd1058$export$2e2bcd8739ae039)(!hasPromise, 'Your validator function has already return a promise. `callback` will be ignored.');
                    if (!hasPromise) callback(...args);
                });
            };
            // Get promise
            const promise = originValidatorFunc(rule, val, wrappedCallback);
            hasPromise = promise && typeof promise.then === 'function' && typeof promise.catch === 'function';
            /**
         * 1. Use promise as the first priority.
         * 2. If promise not exist, use callback with warning instead
         */ (0, $6591254ed6bd1058$export$2e2bcd8739ae039)(hasPromise, '`callback` is deprecated. Please return a promise instead.');
            if (hasPromise) promise.then(()=>{
                callback();
            }).catch((err)=>{
                callback(err || ' ');
            });
        };
        return cloneRule;
    }).sort(({ warningOnly: w1, ruleIndex: i1 }, { warningOnly: w2, ruleIndex: i2 })=>{
        if (!!w1 === !!w2) // Let keep origin order
        return i1 - i2;
        if (w1) return 1;
        return -1;
    });
    // Do validate rules
    let summaryPromise;
    if (validateFirst === true) // >>>>> Validate by serialization
    summaryPromise = new Promise(async (resolve, reject)=>{
        /* eslint-disable no-await-in-loop */ for(let i = 0; i < filledRules.length; i += 1){
            const rule = filledRules[i];
            const errors = await $6b0cfca1ab5d6e4a$var$validateRule(name, value, rule, options, messageVariables);
            if (errors.length) {
                reject([
                    {
                        errors: errors,
                        rule: rule
                    }
                ]);
                return;
            }
        }
        /* eslint-enable */ resolve([]);
    });
    else {
        // >>>>> Validate by parallel
        const rulePromises = filledRules.map((rule)=>$6b0cfca1ab5d6e4a$var$validateRule(name, value, rule, options, messageVariables).then((errors)=>({
                    errors: errors,
                    rule: rule
                })));
        summaryPromise = (validateFirst ? $6b0cfca1ab5d6e4a$var$finishOnFirstFailed(rulePromises) : $6b0cfca1ab5d6e4a$var$finishOnAllFailed(rulePromises)).then((errors)=>{
            // Always change to rejection for Field to catch
            return Promise.reject(errors);
        });
    }
    // Internal catch error to avoid console error log.
    summaryPromise.catch((e)=>e);
    return summaryPromise;
}
async function $6b0cfca1ab5d6e4a$var$finishOnAllFailed(rulePromises) {
    return Promise.all(rulePromises).then((errorsList)=>{
        const errors = [].concat(...errorsList);
        return errors;
    });
}
async function $6b0cfca1ab5d6e4a$var$finishOnFirstFailed(rulePromises) {
    let count = 0;
    return new Promise((resolve)=>{
        rulePromises.forEach((promise)=>{
            promise.then((ruleError)=>{
                if (ruleError.errors.length) resolve([
                    ruleError
                ]);
                count += 1;
                if (count === rulePromises.length) resolve([]);
            });
        });
    });
}





function $6cb43fc24256121e$export$f877b3cb4cb4ccf9(path) {
    return (0, $7abb023c0e672c8b$export$45b10814cc054894)(path);
}
function $6cb43fc24256121e$export$f5be6dfb30403c59(store, namePathList) {
    let newStore = {};
    namePathList.forEach((namePath)=>{
        const value = (0, $7967876a5e08d9ff$export$2e2bcd8739ae039)(store, namePath);
        newStore = (0, $3d19a70b12f43514$export$2e2bcd8739ae039)(newStore, namePath, value);
    });
    return newStore;
}
function $6cb43fc24256121e$export$646d5504364ae55b(namePathList, namePath, partialMatch = false) {
    return namePathList && namePathList.some((path)=>$6cb43fc24256121e$export$325a4bd0e71bdc3a(namePath, path, partialMatch));
}
function $6cb43fc24256121e$export$325a4bd0e71bdc3a(namePath, subNamePath, partialMatch = false) {
    if (!namePath || !subNamePath) return false;
    if (!partialMatch && namePath.length !== subNamePath.length) return false;
    return subNamePath.every((nameUnit, i)=>namePath[i] === nameUnit);
}
function $6cb43fc24256121e$export$dfcec05bb7372a54(source, target) {
    if (source === target) return true;
    if (!source && target || source && !target) return false;
    if (!source || !target || typeof source !== 'object' || typeof target !== 'object') return false;
    const sourceKeys = Object.keys(source);
    const targetKeys = Object.keys(target);
    const keys = new Set([
        ...sourceKeys,
        ...targetKeys
    ]);
    return [
        ...keys
    ].every((key)=>{
        const sourceValue = source[key];
        const targetValue = target[key];
        if (typeof sourceValue === 'function' && typeof targetValue === 'function') return true;
        return sourceValue === targetValue;
    });
}
function $6cb43fc24256121e$export$6eeac3c5b406fb30(valuePropName, ...args) {
    const event = args[0];
    if (event && event.target && typeof event.target === 'object' && valuePropName in event.target) return event.target[valuePropName];
    return event;
}
function $6cb43fc24256121e$export$d947e5f4f4c48d48(array, moveIndex, toIndex) {
    const { length: length } = array;
    if (moveIndex < 0 || moveIndex >= length || toIndex < 0 || toIndex >= length) return array;
    const item = array[moveIndex];
    const diff = moveIndex - toIndex;
    if (diff > 0) // move left
    return [
        ...array.slice(0, toIndex),
        item,
        ...array.slice(toIndex, moveIndex),
        ...array.slice(moveIndex + 1, length)
    ];
    if (diff < 0) // move right
    return [
        ...array.slice(0, moveIndex),
        ...array.slice(moveIndex + 1, toIndex + 1),
        item,
        ...array.slice(toIndex + 1, length)
    ];
    return array;
}


function $8b77da48dce7c38e$var$_extends() {
    $8b77da48dce7c38e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8b77da48dce7c38e$var$_extends.apply(this, arguments);
}
const $8b77da48dce7c38e$var$EMPTY_ERRORS = [];
const $8b77da48dce7c38e$var$EMPTY_WARNINGS = [];
function $8b77da48dce7c38e$var$requireUpdate(shouldUpdate, prev, next, prevValue, nextValue, info) {
    if (typeof shouldUpdate === 'function') return shouldUpdate(prev, next, 'source' in info ? {
        source: info.source
    } : {});
    return prevValue !== nextValue;
}
// eslint-disable-next-line @typescript-eslint/consistent-indexed-object-style
// We use Class instead of Hooks here since it will cost much code by using Hooks.
class $8b77da48dce7c38e$var$Field extends $hO8yS.Component {
    static contextType = (0, $e5b7fab730d97669$export$2e2bcd8739ae039);
    state = {
        resetCount: 0
    };
    cancelRegisterFunc = null;
    mounted = false;
    /**
   * Follow state should not management in State since it will async update by React.
   * This makes first render of form can not get correct state value.
   */ touched = false;
    /**
   * Mark when touched & validated. Currently only used for `dependencies`.
   * Note that we do not think field with `initialValue` is dirty
   * but this will be by `isFieldDirty` func.
   */ dirty = false;
    validatePromise;
    prevValidating;
    errors = $8b77da48dce7c38e$var$EMPTY_ERRORS;
    warnings = $8b77da48dce7c38e$var$EMPTY_WARNINGS;
    // ============================== Subscriptions ==============================
    constructor(props){
        super(props);
        // Register on init
        if (props.fieldContext) {
            const { getInternalHooks: getInternalHooks } = props.fieldContext;
            const { initEntityValue: initEntityValue } = getInternalHooks((0, $e5b7fab730d97669$export$24829b7c0e49e9f7));
            initEntityValue(this);
        }
    }
    componentDidMount() {
        const { shouldUpdate: shouldUpdate, fieldContext: fieldContext } = this.props;
        this.mounted = true;
        // Register on init
        if (fieldContext) {
            const { getInternalHooks: getInternalHooks } = fieldContext;
            const { registerField: registerField } = getInternalHooks((0, $e5b7fab730d97669$export$24829b7c0e49e9f7));
            this.cancelRegisterFunc = registerField(this);
        }
        // One more render for component in case fields not ready
        if (shouldUpdate === true) this.reRender();
    }
    componentWillUnmount() {
        this.cancelRegister();
        this.triggerMetaEvent(true);
        this.mounted = false;
    }
    cancelRegister = ()=>{
        const { preserve: preserve, isListField: isListField, name: name } = this.props;
        if (this.cancelRegisterFunc) this.cancelRegisterFunc(isListField, preserve, (0, $6cb43fc24256121e$export$f877b3cb4cb4ccf9)(name));
        this.cancelRegisterFunc = null;
    };
    // ================================== Utils ==================================
    getNamePath = ()=>{
        const { name: name, fieldContext: fieldContext } = this.props;
        const { prefixName: prefixName = [] } = fieldContext;
        return name !== undefined ? [
            ...prefixName,
            ...name
        ] : [];
    };
    getRules = ()=>{
        const { rules: rules = [], fieldContext: fieldContext } = this.props;
        return rules.map((rule)=>{
            if (typeof rule === 'function') return rule(fieldContext);
            return rule;
        });
    };
    reRender() {
        if (!this.mounted) return;
        this.forceUpdate();
    }
    refresh = ()=>{
        if (!this.mounted) return;
        /**
     * Clean up current node.
     */ this.setState(({ resetCount: resetCount })=>({
                resetCount: resetCount + 1
            }));
    };
    // Event should only trigger when meta changed
    metaCache = null;
    triggerMetaEvent = (destroy)=>{
        const { onMetaChange: onMetaChange } = this.props;
        if (onMetaChange) {
            const meta = {
                ...this.getMeta(),
                destroy: destroy
            };
            if (!(0, $5582f7991b7cfce3$export$2e2bcd8739ae039)(this.metaCache, meta)) onMetaChange(meta);
            this.metaCache = meta;
        } else this.metaCache = null;
    };
    // ========================= Field Entity Interfaces =========================
    // Trigger by store update. Check if need update the component
    onStoreChange = (prevStore, namePathList, info)=>{
        const { shouldUpdate: shouldUpdate, dependencies: dependencies = [], onReset: onReset } = this.props;
        const { store: store } = info;
        const namePath = this.getNamePath();
        const prevValue = this.getValue(prevStore);
        const curValue = this.getValue(store);
        const namePathMatch = namePathList && (0, $6cb43fc24256121e$export$646d5504364ae55b)(namePathList, namePath);
        // `setFieldsValue` is a quick access to update related status
        if (info.type === 'valueUpdate' && info.source === 'external' && !(0, $5582f7991b7cfce3$export$2e2bcd8739ae039)(prevValue, curValue)) {
            this.touched = true;
            this.dirty = true;
            this.validatePromise = null;
            this.errors = $8b77da48dce7c38e$var$EMPTY_ERRORS;
            this.warnings = $8b77da48dce7c38e$var$EMPTY_WARNINGS;
            this.triggerMetaEvent();
        }
        switch(info.type){
            case 'reset':
                if (!namePathList || namePathMatch) {
                    // Clean up state
                    this.touched = false;
                    this.dirty = false;
                    this.validatePromise = undefined;
                    this.errors = $8b77da48dce7c38e$var$EMPTY_ERRORS;
                    this.warnings = $8b77da48dce7c38e$var$EMPTY_WARNINGS;
                    this.triggerMetaEvent();
                    onReset?.();
                    this.refresh();
                    return;
                }
                break;
            /**
       * In case field with `preserve = false` nest deps like:
       * - A = 1 => show B
       * - B = 1 => show C
       * - Reset A, need clean B, C
       */ case 'remove':
                if (shouldUpdate && $8b77da48dce7c38e$var$requireUpdate(shouldUpdate, prevStore, store, prevValue, curValue, info)) {
                    this.reRender();
                    return;
                }
                break;
            case 'setField':
                {
                    const { data: data } = info;
                    if (namePathMatch) {
                        if ('touched' in data) this.touched = data.touched;
                        if ('validating' in data && !('originRCField' in data)) this.validatePromise = data.validating ? Promise.resolve([]) : null;
                        if ('errors' in data) this.errors = data.errors || $8b77da48dce7c38e$var$EMPTY_ERRORS;
                        if ('warnings' in data) this.warnings = data.warnings || $8b77da48dce7c38e$var$EMPTY_WARNINGS;
                        this.dirty = true;
                        this.triggerMetaEvent();
                        this.reRender();
                        return;
                    } else if ('value' in data && (0, $6cb43fc24256121e$export$646d5504364ae55b)(namePathList, namePath, true)) {
                        // Contains path with value should also check
                        this.reRender();
                        return;
                    }
                    // Handle update by `setField` with `shouldUpdate`
                    if (shouldUpdate && !namePath.length && $8b77da48dce7c38e$var$requireUpdate(shouldUpdate, prevStore, store, prevValue, curValue, info)) {
                        this.reRender();
                        return;
                    }
                    break;
                }
            case 'dependenciesUpdate':
                {
                    /**
           * Trigger when marked `dependencies` updated. Related fields will all update
           */ const dependencyList = dependencies.map((0, $6cb43fc24256121e$export$f877b3cb4cb4ccf9));
                    // No need for `namePathMath` check and `shouldUpdate` check, since `valueUpdate` will be
                    // emitted earlier and they will work there
                    // If set it may cause unnecessary twice rerendering
                    if (dependencyList.some((dependency)=>(0, $6cb43fc24256121e$export$646d5504364ae55b)(info.relatedFields, dependency))) {
                        this.reRender();
                        return;
                    }
                    break;
                }
            default:
                // 1. If `namePath` exists in `namePathList`, means it's related value and should update
                //      For example <List name="list"><Field name={['list', 0]}></List>
                //      If `namePathList` is [['list']] (List value update), Field should be updated
                //      If `namePathList` is [['list', 0]] (Field value update), List shouldn't be updated
                // 2.
                //   2.1 If `dependencies` is set, `name` is not set and `shouldUpdate` is not set,
                //       don't use `shouldUpdate`. `dependencies` is view as a shortcut if `shouldUpdate`
                //       is not provided
                //   2.2 If `shouldUpdate` provided, use customize logic to update the field
                //       else to check if value changed
                if (namePathMatch || (!dependencies.length || namePath.length || shouldUpdate) && $8b77da48dce7c38e$var$requireUpdate(shouldUpdate, prevStore, store, prevValue, curValue, info)) {
                    this.reRender();
                    return;
                }
                break;
        }
        if (shouldUpdate === true) this.reRender();
    };
    validateRules = (options)=>{
        // We should fixed namePath & value to avoid developer change then by form function
        const namePath = this.getNamePath();
        const currentValue = this.getValue();
        const { triggerName: triggerName, validateOnly: validateOnly = false } = options || {};
        // Force change to async to avoid rule OOD under renderProps field
        const rootPromise = Promise.resolve().then(async ()=>{
            if (!this.mounted) return [];
            const { validateFirst: validateFirst = false, messageVariables: messageVariables, validateDebounce: validateDebounce } = this.props;
            // Start validate
            let filteredRules = this.getRules();
            if (triggerName) filteredRules = filteredRules.filter((rule)=>rule).filter((rule)=>{
                const { validateTrigger: validateTrigger } = rule;
                if (!validateTrigger) return true;
                const triggerList = (0, $7abb023c0e672c8b$export$45b10814cc054894)(validateTrigger);
                return triggerList.includes(triggerName);
            });
            // Wait for debounce. Skip if no `triggerName` since its from `validateFields / submit`
            if (validateDebounce && triggerName) {
                await new Promise((resolve)=>{
                    setTimeout(resolve, validateDebounce);
                });
                // Skip since out of date
                if (this.validatePromise !== rootPromise) return [];
            }
            const promise = (0, $6b0cfca1ab5d6e4a$export$e1fc4b442d0297dd)(namePath, currentValue, filteredRules, options, validateFirst, messageVariables);
            promise.catch((e)=>e).then((ruleErrors = $8b77da48dce7c38e$var$EMPTY_ERRORS)=>{
                if (this.validatePromise === rootPromise) {
                    this.validatePromise = null;
                    // Get errors & warnings
                    const nextErrors = [];
                    const nextWarnings = [];
                    ruleErrors.forEach?.(({ rule: { warningOnly: warningOnly }, errors: errors = $8b77da48dce7c38e$var$EMPTY_ERRORS })=>{
                        if (warningOnly) nextWarnings.push(...errors);
                        else nextErrors.push(...errors);
                    });
                    this.errors = nextErrors;
                    this.warnings = nextWarnings;
                    this.triggerMetaEvent();
                    this.reRender();
                }
            });
            return promise;
        });
        if (validateOnly) return rootPromise;
        this.validatePromise = rootPromise;
        this.dirty = true;
        this.errors = $8b77da48dce7c38e$var$EMPTY_ERRORS;
        this.warnings = $8b77da48dce7c38e$var$EMPTY_WARNINGS;
        this.triggerMetaEvent();
        // Force trigger re-render since we need sync renderProps with new meta
        this.reRender();
        return rootPromise;
    };
    isFieldValidating = ()=>!!this.validatePromise;
    isFieldTouched = ()=>this.touched;
    isFieldDirty = ()=>{
        // Touched or validate or has initialValue
        if (this.dirty || this.props.initialValue !== undefined) return true;
        // Form set initialValue
        const { fieldContext: fieldContext } = this.props;
        const { getInitialValue: getInitialValue } = fieldContext.getInternalHooks((0, $e5b7fab730d97669$export$24829b7c0e49e9f7));
        if (getInitialValue(this.getNamePath()) !== undefined) return true;
        return false;
    };
    getErrors = ()=>this.errors;
    getWarnings = ()=>this.warnings;
    isListField = ()=>this.props.isListField;
    isList = ()=>this.props.isList;
    isPreserve = ()=>this.props.preserve;
    // ============================= Child Component =============================
    getMeta = ()=>{
        // Make error & validating in cache to save perf
        this.prevValidating = this.isFieldValidating();
        const meta = {
            touched: this.isFieldTouched(),
            validating: this.prevValidating,
            errors: this.errors,
            warnings: this.warnings,
            name: this.getNamePath(),
            validated: this.validatePromise === null
        };
        return meta;
    };
    // Only return validate child node. If invalidate, will do nothing about field.
    getOnlyChild = (children)=>{
        // Support render props
        if (typeof children === 'function') {
            const meta = this.getMeta();
            return {
                ...this.getOnlyChild(children(this.getControlled(), meta, this.props.fieldContext)),
                isFunction: true
            };
        }
        // Filed element only
        const childList = (0, $a60ede783f74e6a9$export$2e2bcd8739ae039)(children);
        if (childList.length !== 1 || !/*#__PURE__*/ $N3oW3.isValidElement(childList[0])) return {
            child: childList,
            isFunction: false
        };
        return {
            child: childList[0],
            isFunction: false
        };
    };
    // ============================== Field Control ==============================
    getValue = (store)=>{
        const { getFieldsValue: getFieldsValue } = this.props.fieldContext;
        const namePath = this.getNamePath();
        return (0, $7967876a5e08d9ff$export$2e2bcd8739ae039)(store || getFieldsValue(true), namePath);
    };
    getControlled = (childProps = {})=>{
        const { name: name, trigger: trigger = 'onChange', validateTrigger: validateTrigger, getValueFromEvent: getValueFromEvent, normalize: normalize, valuePropName: valuePropName = 'value', getValueProps: getValueProps, fieldContext: fieldContext } = this.props;
        const mergedValidateTrigger = validateTrigger !== undefined ? validateTrigger : fieldContext.validateTrigger;
        const namePath = this.getNamePath();
        const { getInternalHooks: getInternalHooks, getFieldsValue: getFieldsValue } = fieldContext;
        const { dispatch: dispatch } = getInternalHooks((0, $e5b7fab730d97669$export$24829b7c0e49e9f7));
        const value = this.getValue();
        const mergedGetValueProps = getValueProps || ((val)=>({
                [valuePropName]: val
            }));
        const originTriggerFunc = childProps[trigger];
        const valueProps = name !== undefined ? mergedGetValueProps(value) : {};
        var key;
        const control = {
            ...childProps,
            ...valueProps
        };
        // Add trigger
        control[trigger] = (...args)=>{
            // Mark as touched
            this.touched = true;
            this.dirty = true;
            this.triggerMetaEvent();
            let newValue;
            if (getValueFromEvent) newValue = getValueFromEvent(...args);
            else newValue = (0, $6cb43fc24256121e$export$6eeac3c5b406fb30)(valuePropName, ...args);
            if (normalize) newValue = normalize(newValue, value, getFieldsValue(true));
            if (newValue !== value) dispatch({
                type: 'updateValue',
                namePath: namePath,
                value: newValue
            });
            if (originTriggerFunc) originTriggerFunc(...args);
        };
        // Add validateTrigger
        const validateTriggerList = (0, $7abb023c0e672c8b$export$45b10814cc054894)(mergedValidateTrigger || []);
        validateTriggerList.forEach((triggerName)=>{
            // Wrap additional function of component, so that we can get latest value from store
            const originTrigger = control[triggerName];
            control[triggerName] = (...args)=>{
                if (originTrigger) originTrigger(...args);
                // Always use latest rules
                const { rules: rules } = this.props;
                if (rules && rules.length) // We dispatch validate to root,
                // since it will update related data with other field with same name
                dispatch({
                    type: 'validateField',
                    namePath: namePath,
                    triggerName: triggerName
                });
            };
        });
        return control;
    };
    render() {
        const { resetCount: resetCount } = this.state;
        const { children: children } = this.props;
        const { child: child, isFunction: isFunction } = this.getOnlyChild(children);
        // Not need to `cloneElement` since user can handle this in render function self
        let returnChildNode;
        if (isFunction) returnChildNode = child;
        else if (/*#__PURE__*/ $N3oW3.isValidElement(child)) returnChildNode = /*#__PURE__*/ $N3oW3.cloneElement(child, this.getControlled(child.props));
        else {
            (0, $6591254ed6bd1058$export$2e2bcd8739ae039)(!child, '`children` of Field is not validate ReactElement.');
            returnChildNode = child;
        }
        return /*#__PURE__*/ $hO8yS.createElement($hO8yS.Fragment, {
            key: resetCount
        }, returnChildNode);
    }
}
function $8b77da48dce7c38e$var$WrapperField({ name: name, ...restProps }) {
    const fieldContext = $32rMB.useContext((0, $e5b7fab730d97669$export$2e2bcd8739ae039));
    const listContext = $32rMB.useContext((0, $d651cb95b201e088$export$2e2bcd8739ae039));
    const namePath = name !== undefined ? (0, $6cb43fc24256121e$export$f877b3cb4cb4ccf9)(name) : undefined;
    const isMergedListField = restProps.isListField ?? !!listContext;
    let key = 'keep';
    if (!isMergedListField) key = `_${(namePath || []).join('_')}`;
    return /*#__PURE__*/ $hO8yS.createElement($8b77da48dce7c38e$var$Field, $8b77da48dce7c38e$var$_extends({
        key: key,
        name: namePath,
        isListField: isMergedListField
    }, restProps, {
        fieldContext: fieldContext
    }));
}
var $8b77da48dce7c38e$export$2e2bcd8739ae039 = $8b77da48dce7c38e$var$WrapperField;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");





function $1c2c0bc5ee309617$var$List({ name: name, initialValue: initialValue, children: children, rules: rules, validateTrigger: validateTrigger, isListField: isListField }) {
    const context = $32rMB.useContext((0, $e5b7fab730d97669$export$2e2bcd8739ae039));
    const wrapperListContext = $32rMB.useContext((0, $d651cb95b201e088$export$2e2bcd8739ae039));
    const keyRef = $32rMB.useRef({
        keys: [],
        id: 0
    });
    const keyManager = keyRef.current;
    const prefixName = $32rMB.useMemo(()=>{
        const parentPrefixName = (0, $6cb43fc24256121e$export$f877b3cb4cb4ccf9)(context.prefixName) || [];
        return [
            ...parentPrefixName,
            ...(0, $6cb43fc24256121e$export$f877b3cb4cb4ccf9)(name)
        ];
    }, [
        context.prefixName,
        name
    ]);
    const fieldContext = $32rMB.useMemo(()=>({
            ...context,
            prefixName: prefixName
        }), [
        context,
        prefixName
    ]);
    // List context
    const listContext = $32rMB.useMemo(()=>({
            getKey: (namePath)=>{
                const len = prefixName.length;
                const pathName = namePath[len];
                return [
                    keyManager.keys[pathName],
                    namePath.slice(len + 1)
                ];
            }
        }), [
        keyManager,
        prefixName
    ]);
    // User should not pass `children` as other type.
    if (typeof children !== 'function') {
        (0, $6591254ed6bd1058$export$2e2bcd8739ae039)(false, 'Form.List only accepts function as children.');
        return null;
    }
    const shouldUpdate = (prevValue, nextValue, { source: source })=>{
        if (source === 'internal') return false;
        return prevValue !== nextValue;
    };
    return /*#__PURE__*/ $hO8yS.createElement((0, $d651cb95b201e088$export$2e2bcd8739ae039).Provider, {
        value: listContext
    }, /*#__PURE__*/ $hO8yS.createElement((0, $e5b7fab730d97669$export$2e2bcd8739ae039).Provider, {
        value: fieldContext
    }, /*#__PURE__*/ $hO8yS.createElement((0, $8b77da48dce7c38e$export$2e2bcd8739ae039), {
        name: [],
        shouldUpdate: shouldUpdate,
        rules: rules,
        validateTrigger: validateTrigger,
        initialValue: initialValue,
        isList: true,
        isListField: isListField ?? !!wrapperListContext
    }, ({ value: value = [], onChange: onChange }, meta)=>{
        const { getFieldValue: getFieldValue } = context;
        const getNewValue = ()=>{
            const values = getFieldValue(prefixName || []);
            return values || [];
        };
        /**
     * Always get latest value in case user update fields by `form` api.
     */ const operations = {
            add: (defaultValue, index)=>{
                // Mapping keys
                const newValue = getNewValue();
                if (index >= 0 && index <= newValue.length) {
                    keyManager.keys = [
                        ...keyManager.keys.slice(0, index),
                        keyManager.id,
                        ...keyManager.keys.slice(index)
                    ];
                    onChange([
                        ...newValue.slice(0, index),
                        defaultValue,
                        ...newValue.slice(index)
                    ]);
                } else {
                    keyManager.keys = [
                        ...keyManager.keys,
                        keyManager.id
                    ];
                    onChange([
                        ...newValue,
                        defaultValue
                    ]);
                }
                keyManager.id += 1;
            },
            remove: (index)=>{
                const newValue = getNewValue();
                const indexSet = new Set(Array.isArray(index) ? index : [
                    index
                ]);
                if (indexSet.size <= 0) return;
                keyManager.keys = keyManager.keys.filter((_, keysIndex)=>!indexSet.has(keysIndex));
                // Trigger store change
                onChange(newValue.filter((_, valueIndex)=>!indexSet.has(valueIndex)));
            },
            move (from, to) {
                if (from === to) return;
                const newValue = getNewValue();
                // Do not handle out of range
                if (from < 0 || from >= newValue.length || to < 0 || to >= newValue.length) return;
                keyManager.keys = (0, $6cb43fc24256121e$export$d947e5f4f4c48d48)(keyManager.keys, from, to);
                // Trigger store change
                onChange((0, $6cb43fc24256121e$export$d947e5f4f4c48d48)(newValue, from, to));
            }
        };
        let listValue = value || [];
        if (!Array.isArray(listValue)) listValue = [];
        return children(listValue.map((__, index)=>{
            let key = keyManager.keys[index];
            if (key === undefined) {
                keyManager.keys[index] = keyManager.id;
                key = keyManager.keys[index];
                keyManager.id += 1;
            }
            return {
                name: index,
                key: key,
                isListField: true
            };
        }), operations, meta);
    })));
}
var $1c2c0bc5ee309617$export$2e2bcd8739ae039 = $1c2c0bc5ee309617$var$List;




parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");

function $16a48f8c0d350f45$export$6152adfdcc6be2b5(promiseList) {
    let hasError = false;
    let count = promiseList.length;
    const results = [];
    if (!promiseList.length) return Promise.resolve([]);
    return new Promise((resolve, reject)=>{
        promiseList.forEach((promise, index)=>{
            promise.catch((e)=>{
                hasError = true;
                return e;
            }).then((result)=>{
                count -= 1;
                results[index] = result;
                if (count > 0) return;
                if (hasError) reject(results);
                resolve(results);
            });
        });
    });
}



const $d0453792a81e0165$var$SPLIT = '__@field_split__';
/**
 * Convert name path into string to fast the fetch speed of Map.
 */ function $d0453792a81e0165$var$normalize(namePath) {
    return namePath.map((cell)=>`${typeof cell}:${cell}`)// Magic split
    .join($d0453792a81e0165$var$SPLIT);
}
/**
 * NameMap like a `Map` but accepts `string[]` as key.
 */ class $d0453792a81e0165$var$NameMap {
    kvs = new Map();
    set(key, value) {
        this.kvs.set($d0453792a81e0165$var$normalize(key), value);
    }
    get(key) {
        return this.kvs.get($d0453792a81e0165$var$normalize(key));
    }
    update(key, updater) {
        const origin = this.get(key);
        const next = updater(origin);
        if (!next) this.delete(key);
        else this.set(key, next);
    }
    delete(key) {
        this.kvs.delete($d0453792a81e0165$var$normalize(key));
    }
    // Since we only use this in test, let simply realize this
    map(callback) {
        return [
            ...this.kvs.entries()
        ].map(([key, value])=>{
            const cells = key.split($d0453792a81e0165$var$SPLIT);
            return callback({
                key: cells.map((cell)=>{
                    const [, type, unit] = cell.match(/^([^:]*):(.*)$/);
                    return type === 'number' ? Number(unit) : unit;
                }),
                value: value
            });
        });
    }
    toJSON() {
        const json = {};
        this.map(({ key: key, value: value })=>{
            json[key.join('.')] = value;
            return null;
        });
        return json;
    }
}
var $d0453792a81e0165$export$2e2bcd8739ae039 = $d0453792a81e0165$var$NameMap;



class $1547c3a057122952$export$75ff1ab1187e691 {
    formHooked = false;
    forceRootUpdate;
    subscribable = true;
    store = {};
    fieldEntities = [];
    initialValues = {};
    callbacks = {};
    validateMessages = null;
    preserve = null;
    lastValidatePromise = null;
    constructor(forceRootUpdate){
        this.forceRootUpdate = forceRootUpdate;
    }
    getForm = ()=>({
            getFieldValue: this.getFieldValue,
            getFieldsValue: this.getFieldsValue,
            getFieldError: this.getFieldError,
            getFieldWarning: this.getFieldWarning,
            getFieldsError: this.getFieldsError,
            isFieldsTouched: this.isFieldsTouched,
            isFieldTouched: this.isFieldTouched,
            isFieldValidating: this.isFieldValidating,
            isFieldsValidating: this.isFieldsValidating,
            resetFields: this.resetFields,
            setFields: this.setFields,
            setFieldValue: this.setFieldValue,
            setFieldsValue: this.setFieldsValue,
            validateFields: this.validateFields,
            submit: this.submit,
            _init: true,
            getInternalHooks: this.getInternalHooks
        });
    // ======================== Internal Hooks ========================
    getInternalHooks = (key)=>{
        if (key === (0, $e5b7fab730d97669$export$24829b7c0e49e9f7)) {
            this.formHooked = true;
            return {
                dispatch: this.dispatch,
                initEntityValue: this.initEntityValue,
                registerField: this.registerField,
                useSubscribe: this.useSubscribe,
                setInitialValues: this.setInitialValues,
                destroyForm: this.destroyForm,
                setCallbacks: this.setCallbacks,
                setValidateMessages: this.setValidateMessages,
                getFields: this.getFields,
                setPreserve: this.setPreserve,
                getInitialValue: this.getInitialValue,
                registerWatch: this.registerWatch,
                setBatchUpdate: this.setBatchUpdate
            };
        }
        (0, $6591254ed6bd1058$export$2e2bcd8739ae039)(false, '`getInternalHooks` is internal usage. Should not call directly.');
        return null;
    };
    useSubscribe = (subscribable)=>{
        this.subscribable = subscribable;
    };
    /**
   * Record prev Form unmount fieldEntities which config preserve false.
   * This need to be refill with initialValues instead of store value.
   */ prevWithoutPreserves = null;
    /**
   * First time `setInitialValues` should update store with initial value
   */ setInitialValues = (initialValues, init)=>{
        this.initialValues = initialValues || {};
        if (init) {
            let nextStore = (0, $3d19a70b12f43514$export$4950aa0f605343fb)(initialValues, this.store);
            // We will take consider prev form unmount fields.
            // When the field is not `preserve`, we need fill this with initialValues instead of store.
            // eslint-disable-next-line array-callback-return
            this.prevWithoutPreserves?.map(({ key: namePath })=>{
                nextStore = (0, $3d19a70b12f43514$export$2e2bcd8739ae039)(nextStore, namePath, (0, $7967876a5e08d9ff$export$2e2bcd8739ae039)(initialValues, namePath));
            });
            this.prevWithoutPreserves = null;
            this.updateStore(nextStore);
        }
    };
    destroyForm = (clearOnDestroy)=>{
        if (clearOnDestroy) // destroy form reset store
        this.updateStore({});
        else {
            // Fill preserve fields
            const prevWithoutPreserves = new (0, $d0453792a81e0165$export$2e2bcd8739ae039)();
            this.getFieldEntities(true).forEach((entity)=>{
                if (!this.isMergedPreserve(entity.isPreserve())) prevWithoutPreserves.set(entity.getNamePath(), true);
            });
            this.prevWithoutPreserves = prevWithoutPreserves;
        }
    };
    getInitialValue = (namePath)=>{
        const initValue = (0, $7967876a5e08d9ff$export$2e2bcd8739ae039)(this.initialValues, namePath);
        // Not cloneDeep when without `namePath`
        return namePath.length ? (0, $3d19a70b12f43514$export$4950aa0f605343fb)(initValue) : initValue;
    };
    setCallbacks = (callbacks)=>{
        this.callbacks = callbacks;
    };
    setValidateMessages = (validateMessages)=>{
        this.validateMessages = validateMessages;
    };
    setPreserve = (preserve)=>{
        this.preserve = preserve;
    };
    // ============================= Watch ============================
    watchList = [];
    registerWatch = (callback)=>{
        this.watchList.push(callback);
        return ()=>{
            this.watchList = this.watchList.filter((fn)=>fn !== callback);
        };
    };
    notifyWatch = (namePath = [])=>{
        // No need to cost perf when nothing need to watch
        if (this.watchList.length) {
            const values = this.getFieldsValue();
            const allValues = this.getFieldsValue(true);
            this.watchList.forEach((callback)=>{
                callback(values, allValues, namePath);
            });
        }
    };
    notifyWatchNamePathList = [];
    batchNotifyWatch = (namePath)=>{
        this.notifyWatchNamePathList.push(namePath);
        this.batch('notifyWatch', ()=>{
            this.notifyWatch(this.notifyWatchNamePathList);
            this.notifyWatchNamePathList = [];
        });
    };
    // ============================= Batch ============================
    batchUpdate;
    setBatchUpdate = (batchUpdate)=>{
        this.batchUpdate = batchUpdate;
    };
    // Batch call the task, only last will be called
    batch = (key, callback)=>{
        this.batchUpdate(key, callback);
    };
    // ========================== Dev Warning =========================
    timeoutId = null;
    warningUnhooked = ()=>{};
    // ============================ Store =============================
    updateStore = (nextStore)=>{
        this.store = nextStore;
    };
    // ============================ Fields ============================
    /**
   * Get registered field entities.
   * @param pure Only return field which has a `name`. Default: false
   */ getFieldEntities = (pure = false)=>{
        if (!pure) return this.fieldEntities;
        return this.fieldEntities.filter((field)=>field.getNamePath().length);
    };
    getFieldsMap = (pure = false)=>{
        const cache = new (0, $d0453792a81e0165$export$2e2bcd8739ae039)();
        this.getFieldEntities(pure).forEach((field)=>{
            const namePath = field.getNamePath();
            cache.set(namePath, field);
        });
        return cache;
    };
    getFieldEntitiesForNamePathList = (nameList)=>{
        if (!nameList) return this.getFieldEntities(true);
        const cache = this.getFieldsMap(true);
        return nameList.map((name)=>{
            const namePath = (0, $6cb43fc24256121e$export$f877b3cb4cb4ccf9)(name);
            return cache.get(namePath) || {
                INVALIDATE_NAME_PATH: (0, $6cb43fc24256121e$export$f877b3cb4cb4ccf9)(name)
            };
        });
    };
    getFieldsValue = (nameList, filterFunc)=>{
        this.warningUnhooked();
        // Fill args
        let mergedNameList;
        let mergedFilterFunc;
        if (nameList === true || Array.isArray(nameList)) {
            mergedNameList = nameList;
            mergedFilterFunc = filterFunc;
        } else if (nameList && typeof nameList === 'object') mergedFilterFunc = nameList.filter;
        if (mergedNameList === true && !mergedFilterFunc) return this.store;
        const fieldEntities = this.getFieldEntitiesForNamePathList(Array.isArray(mergedNameList) ? mergedNameList : null);
        const filteredNameList = [];
        const listNamePaths = [];
        fieldEntities.forEach((entity)=>{
            const namePath = entity.INVALIDATE_NAME_PATH || entity.getNamePath();
            // Ignore when it's a list item and not specific the namePath,
            // since parent field is already take in count
            if (entity.isList?.()) {
                listNamePaths.push(namePath);
                return;
            }
            if (!mergedFilterFunc) filteredNameList.push(namePath);
            else {
                const meta = 'getMeta' in entity ? entity.getMeta() : null;
                if (mergedFilterFunc(meta)) filteredNameList.push(namePath);
            }
        });
        let mergedValues = (0, $6cb43fc24256121e$export$f5be6dfb30403c59)(this.store, filteredNameList.map((0, $6cb43fc24256121e$export$f877b3cb4cb4ccf9)));
        // We need fill the list as [] if Form.List is empty
        listNamePaths.forEach((namePath)=>{
            if (!(0, $7967876a5e08d9ff$export$2e2bcd8739ae039)(mergedValues, namePath)) mergedValues = (0, $3d19a70b12f43514$export$2e2bcd8739ae039)(mergedValues, namePath, []);
        });
        return mergedValues;
    };
    getFieldValue = (name)=>{
        this.warningUnhooked();
        const namePath = (0, $6cb43fc24256121e$export$f877b3cb4cb4ccf9)(name);
        return (0, $7967876a5e08d9ff$export$2e2bcd8739ae039)(this.store, namePath);
    };
    getFieldsError = (nameList)=>{
        this.warningUnhooked();
        const fieldEntities = this.getFieldEntitiesForNamePathList(nameList);
        return fieldEntities.map((entity, index)=>{
            if (entity && !entity.INVALIDATE_NAME_PATH) return {
                name: entity.getNamePath(),
                errors: entity.getErrors(),
                warnings: entity.getWarnings()
            };
            return {
                name: (0, $6cb43fc24256121e$export$f877b3cb4cb4ccf9)(nameList[index]),
                errors: [],
                warnings: []
            };
        });
    };
    getFieldError = (name)=>{
        this.warningUnhooked();
        const namePath = (0, $6cb43fc24256121e$export$f877b3cb4cb4ccf9)(name);
        const fieldError = this.getFieldsError([
            namePath
        ])[0];
        return fieldError.errors;
    };
    getFieldWarning = (name)=>{
        this.warningUnhooked();
        const namePath = (0, $6cb43fc24256121e$export$f877b3cb4cb4ccf9)(name);
        const fieldError = this.getFieldsError([
            namePath
        ])[0];
        return fieldError.warnings;
    };
    isFieldsTouched = (...args)=>{
        this.warningUnhooked();
        const [arg0, arg1] = args;
        let namePathList;
        let isAllFieldsTouched = false;
        if (args.length === 0) namePathList = null;
        else if (args.length === 1) {
            if (Array.isArray(arg0)) {
                namePathList = arg0.map((0, $6cb43fc24256121e$export$f877b3cb4cb4ccf9));
                isAllFieldsTouched = false;
            } else {
                namePathList = null;
                isAllFieldsTouched = arg0;
            }
        } else {
            namePathList = arg0.map((0, $6cb43fc24256121e$export$f877b3cb4cb4ccf9));
            isAllFieldsTouched = arg1;
        }
        const fieldEntities = this.getFieldEntities(true);
        const isFieldTouched = (field)=>field.isFieldTouched();
        // ===== Will get fully compare when not config namePathList =====
        if (!namePathList) return isAllFieldsTouched ? fieldEntities.every((entity)=>isFieldTouched(entity) || entity.isList()) : fieldEntities.some(isFieldTouched);
        // Generate a nest tree for validate
        const map = new (0, $d0453792a81e0165$export$2e2bcd8739ae039)();
        namePathList.forEach((shortNamePath)=>{
            map.set(shortNamePath, []);
        });
        fieldEntities.forEach((field)=>{
            const fieldNamePath = field.getNamePath();
            // Find matched entity and put into list
            namePathList.forEach((shortNamePath)=>{
                if (shortNamePath.every((nameUnit, i)=>fieldNamePath[i] === nameUnit)) map.update(shortNamePath, (list)=>[
                        ...list,
                        field
                    ]);
            });
        });
        // Check if NameMap value is touched
        const isNamePathListTouched = (entities)=>entities.some(isFieldTouched);
        const namePathListEntities = map.map(({ value: value })=>value);
        return isAllFieldsTouched ? namePathListEntities.every(isNamePathListTouched) : namePathListEntities.some(isNamePathListTouched);
    };
    isFieldTouched = (name)=>{
        this.warningUnhooked();
        return this.isFieldsTouched([
            name
        ]);
    };
    isFieldsValidating = (nameList)=>{
        this.warningUnhooked();
        const fieldEntities = this.getFieldEntities();
        if (!nameList) return fieldEntities.some((testField)=>testField.isFieldValidating());
        const namePathList = nameList.map((0, $6cb43fc24256121e$export$f877b3cb4cb4ccf9));
        return fieldEntities.some((testField)=>{
            const fieldNamePath = testField.getNamePath();
            return (0, $6cb43fc24256121e$export$646d5504364ae55b)(namePathList, fieldNamePath) && testField.isFieldValidating();
        });
    };
    isFieldValidating = (name)=>{
        this.warningUnhooked();
        return this.isFieldsValidating([
            name
        ]);
    };
    /**
   * Reset Field with field `initialValue` prop.
   * Can pass `entities` or `namePathList` or just nothing.
   */ resetWithFieldInitialValue = (info = {})=>{
        // Create cache
        const cache = new (0, $d0453792a81e0165$export$2e2bcd8739ae039)();
        const fieldEntities = this.getFieldEntities(true);
        fieldEntities.forEach((field)=>{
            const { initialValue: initialValue } = field.props;
            const namePath = field.getNamePath();
            // Record only if has `initialValue`
            if (initialValue !== undefined) {
                const records = cache.get(namePath) || new Set();
                records.add({
                    entity: field,
                    value: initialValue
                });
                cache.set(namePath, records);
            }
        });
        // Reset
        const resetWithFields = (entities)=>{
            entities.forEach((field)=>{
                const { initialValue: initialValue } = field.props;
                if (initialValue !== undefined) {
                    const namePath = field.getNamePath();
                    const formInitialValue = this.getInitialValue(namePath);
                    if (formInitialValue !== undefined) // Warning if conflict with form initialValues and do not modify value
                    (0, $6591254ed6bd1058$export$2e2bcd8739ae039)(false, `Form already set 'initialValues' with path '${namePath.join('.')}'. Field can not overwrite it.`);
                    else {
                        const records = cache.get(namePath);
                        if (records && records.size > 1) // Warning if multiple field set `initialValue`and do not modify value
                        (0, $6591254ed6bd1058$export$2e2bcd8739ae039)(false, `Multiple Field with path '${namePath.join('.')}' set 'initialValue'. Can not decide which one to pick.`);
                        else if (records) {
                            const originValue = this.getFieldValue(namePath);
                            const isListField = field.isListField();
                            // Set `initialValue`
                            if (!isListField && (!info.skipExist || originValue === undefined)) this.updateStore((0, $3d19a70b12f43514$export$2e2bcd8739ae039)(this.store, namePath, [
                                ...records
                            ][0].value));
                        }
                    }
                }
            });
        };
        let requiredFieldEntities;
        if (info.entities) requiredFieldEntities = info.entities;
        else if (info.namePathList) {
            requiredFieldEntities = [];
            info.namePathList.forEach((namePath)=>{
                const records = cache.get(namePath);
                if (records) requiredFieldEntities.push(...[
                    ...records
                ].map((r)=>r.entity));
            });
        } else requiredFieldEntities = fieldEntities;
        resetWithFields(requiredFieldEntities);
    };
    resetFields = (nameList)=>{
        this.warningUnhooked();
        const prevStore = this.store;
        if (!nameList) {
            this.updateStore((0, $3d19a70b12f43514$export$4950aa0f605343fb)(this.initialValues));
            this.resetWithFieldInitialValue();
            this.notifyObservers(prevStore, null, {
                type: 'reset'
            });
            this.notifyWatch();
            return;
        }
        // Reset by `nameList`
        const namePathList = nameList.map((0, $6cb43fc24256121e$export$f877b3cb4cb4ccf9));
        namePathList.forEach((namePath)=>{
            const initialValue = this.getInitialValue(namePath);
            this.updateStore((0, $3d19a70b12f43514$export$2e2bcd8739ae039)(this.store, namePath, initialValue));
        });
        this.resetWithFieldInitialValue({
            namePathList: namePathList
        });
        this.notifyObservers(prevStore, namePathList, {
            type: 'reset'
        });
        this.notifyWatch(namePathList);
    };
    setFields = (fields)=>{
        this.warningUnhooked();
        const prevStore = this.store;
        const namePathList = [];
        fields.forEach((fieldData)=>{
            const { name: name, ...data } = fieldData;
            const namePath = (0, $6cb43fc24256121e$export$f877b3cb4cb4ccf9)(name);
            namePathList.push(namePath);
            // Value
            if ('value' in data) this.updateStore((0, $3d19a70b12f43514$export$2e2bcd8739ae039)(this.store, namePath, data.value));
            this.notifyObservers(prevStore, [
                namePath
            ], {
                type: 'setField',
                data: fieldData
            });
        });
        this.notifyWatch(namePathList);
    };
    getFields = ()=>{
        const entities = this.getFieldEntities(true);
        const fields = entities.map((field)=>{
            const namePath = field.getNamePath();
            const meta = field.getMeta();
            const fieldData = {
                ...meta,
                name: namePath,
                value: this.getFieldValue(namePath)
            };
            Object.defineProperty(fieldData, 'originRCField', {
                value: true
            });
            return fieldData;
        });
        return fields;
    };
    // =========================== Observer ===========================
    /**
   * This only trigger when a field is on constructor to avoid we get initialValue too late
   */ initEntityValue = (entity)=>{
        const { initialValue: initialValue } = entity.props;
        if (initialValue !== undefined) {
            const namePath = entity.getNamePath();
            const prevValue = (0, $7967876a5e08d9ff$export$2e2bcd8739ae039)(this.store, namePath);
            if (prevValue === undefined) this.updateStore((0, $3d19a70b12f43514$export$2e2bcd8739ae039)(this.store, namePath, initialValue));
        }
    };
    isMergedPreserve = (fieldPreserve)=>{
        const mergedPreserve = fieldPreserve !== undefined ? fieldPreserve : this.preserve;
        return mergedPreserve ?? true;
    };
    registerField = (entity)=>{
        this.fieldEntities.push(entity);
        const namePath = entity.getNamePath();
        this.batchNotifyWatch(namePath);
        // Set initial values
        if (entity.props.initialValue !== undefined) {
            const prevStore = this.store;
            this.resetWithFieldInitialValue({
                entities: [
                    entity
                ],
                skipExist: true
            });
            this.notifyObservers(prevStore, [
                entity.getNamePath()
            ], {
                type: 'valueUpdate',
                source: 'internal'
            });
        }
        // un-register field callback
        return (isListField, preserve, subNamePath = [])=>{
            this.fieldEntities = this.fieldEntities.filter((item)=>item !== entity);
            // Clean up store value if not preserve
            if (!this.isMergedPreserve(preserve) && (!isListField || subNamePath.length > 1)) {
                const defaultValue = isListField ? undefined : this.getInitialValue(namePath);
                if (namePath.length && this.getFieldValue(namePath) !== defaultValue && this.fieldEntities.every((field)=>// Only reset when no namePath exist
                    !(0, $6cb43fc24256121e$export$325a4bd0e71bdc3a)(field.getNamePath(), namePath))) {
                    const prevStore = this.store;
                    this.updateStore((0, $3d19a70b12f43514$export$2e2bcd8739ae039)(prevStore, namePath, defaultValue, true));
                    // Notify that field is unmount
                    this.notifyObservers(prevStore, [
                        namePath
                    ], {
                        type: 'remove'
                    });
                    // Dependencies update
                    this.triggerDependenciesUpdate(prevStore, namePath);
                }
            }
            this.batchNotifyWatch(namePath);
        };
    };
    dispatch = (action)=>{
        switch(action.type){
            case 'updateValue':
                {
                    const { namePath: namePath, value: value } = action;
                    this.updateValue(namePath, value);
                    break;
                }
            case 'validateField':
                {
                    const { namePath: namePath, triggerName: triggerName } = action;
                    this.validateFields([
                        namePath
                    ], {
                        triggerName: triggerName
                    });
                    break;
                }
            default:
        }
    };
    notifyObservers = (prevStore, namePathList, info)=>{
        if (this.subscribable) {
            const mergedInfo = {
                ...info,
                store: this.getFieldsValue(true)
            };
            this.getFieldEntities().forEach(({ onStoreChange: onStoreChange })=>{
                onStoreChange(prevStore, namePathList, mergedInfo);
            });
        } else this.forceRootUpdate();
    };
    /**
   * Notify dependencies children with parent update
   * We need delay to trigger validate in case Field is under render props
   */ triggerDependenciesUpdate = (prevStore, namePath)=>{
        const childrenFields = this.getDependencyChildrenFields(namePath);
        if (childrenFields.length) this.validateFields(childrenFields);
        this.notifyObservers(prevStore, childrenFields, {
            type: 'dependenciesUpdate',
            relatedFields: [
                namePath,
                ...childrenFields
            ]
        });
        return childrenFields;
    };
    updateValue = (name, value)=>{
        const namePath = (0, $6cb43fc24256121e$export$f877b3cb4cb4ccf9)(name);
        const prevStore = this.store;
        this.updateStore((0, $3d19a70b12f43514$export$2e2bcd8739ae039)(this.store, namePath, value));
        this.notifyObservers(prevStore, [
            namePath
        ], {
            type: 'valueUpdate',
            source: 'internal'
        });
        this.notifyWatch([
            namePath
        ]);
        // Dependencies update
        const childrenFields = this.triggerDependenciesUpdate(prevStore, namePath);
        // trigger callback function
        const { onValuesChange: onValuesChange } = this.callbacks;
        if (onValuesChange) {
            const changedValues = (0, $6cb43fc24256121e$export$f5be6dfb30403c59)(this.store, [
                namePath
            ]);
            const allValues = this.getFieldsValue();
            // Merge changedValues into allValues to ensure allValues contains the latest changes
            const mergedAllValues = (0, $3d19a70b12f43514$export$4950aa0f605343fb)(allValues, changedValues);
            onValuesChange(changedValues, mergedAllValues);
        }
        this.triggerOnFieldsChange([
            namePath,
            ...childrenFields
        ]);
    };
    // Let all child Field get update.
    setFieldsValue = (store)=>{
        this.warningUnhooked();
        const prevStore = this.store;
        if (store) {
            const nextStore = (0, $3d19a70b12f43514$export$4950aa0f605343fb)(this.store, store);
            this.updateStore(nextStore);
        }
        this.notifyObservers(prevStore, null, {
            type: 'valueUpdate',
            source: 'external'
        });
        this.notifyWatch();
    };
    setFieldValue = (name, value)=>{
        this.setFields([
            {
                name: name,
                value: value,
                errors: [],
                warnings: [],
                touched: true
            }
        ]);
    };
    getDependencyChildrenFields = (rootNamePath)=>{
        const children = new Set();
        const childrenFields = [];
        const dependencies2fields = new (0, $d0453792a81e0165$export$2e2bcd8739ae039)();
        /**
     * Generate maps
     * Can use cache to save perf if user report performance issue with this
     */ this.getFieldEntities().forEach((field)=>{
            const { dependencies: dependencies } = field.props;
            (dependencies || []).forEach((dependency)=>{
                const dependencyNamePath = (0, $6cb43fc24256121e$export$f877b3cb4cb4ccf9)(dependency);
                dependencies2fields.update(dependencyNamePath, (fields = new Set())=>{
                    fields.add(field);
                    return fields;
                });
            });
        });
        const fillChildren = (namePath)=>{
            const fields = dependencies2fields.get(namePath) || new Set();
            fields.forEach((field)=>{
                if (!children.has(field)) {
                    children.add(field);
                    const fieldNamePath = field.getNamePath();
                    if (field.isFieldDirty() && fieldNamePath.length) {
                        childrenFields.push(fieldNamePath);
                        fillChildren(fieldNamePath);
                    }
                }
            });
        };
        fillChildren(rootNamePath);
        return childrenFields;
    };
    triggerOnFieldsChange = (namePathList, filedErrors)=>{
        const { onFieldsChange: onFieldsChange } = this.callbacks;
        if (onFieldsChange) {
            const fields = this.getFields();
            /**
       * Fill errors since `fields` may be replaced by controlled fields
       */ if (filedErrors) {
                const cache = new (0, $d0453792a81e0165$export$2e2bcd8739ae039)();
                filedErrors.forEach(({ name: name, errors: errors })=>{
                    cache.set(name, errors);
                });
                fields.forEach((field)=>{
                    // eslint-disable-next-line no-param-reassign
                    field.errors = cache.get(field.name) || field.errors;
                });
            }
            const changedFields = fields.filter(({ name: fieldName })=>(0, $6cb43fc24256121e$export$646d5504364ae55b)(namePathList, fieldName));
            if (changedFields.length) onFieldsChange(changedFields, fields);
        }
    };
    // =========================== Validate ===========================
    validateFields = (arg1, arg2)=>{
        this.warningUnhooked();
        let nameList;
        let options;
        if (Array.isArray(arg1) || typeof arg1 === 'string' || typeof arg2 === 'string') {
            nameList = arg1;
            options = arg2;
        } else options = arg1;
        const provideNameList = !!nameList;
        const namePathList = provideNameList ? nameList.map((0, $6cb43fc24256121e$export$f877b3cb4cb4ccf9)) : [];
        // Same namePathList, but does not include Form.List name
        const finalValueNamePathList = [
            ...namePathList
        ];
        // Collect result in promise list
        const promiseList = [];
        // We temp save the path which need trigger for `onFieldsChange`
        const TMP_SPLIT = String(Date.now());
        const validateNamePathList = new Set();
        const { recursive: recursive, dirty: dirty } = options || {};
        this.getFieldEntities(true).forEach((field)=>{
            const fieldNamePath = field.getNamePath();
            // Add field if not provide `nameList`
            if (!provideNameList) {
                if (// If is field, pass directly
                !field.isList() || // If is list, do not add if already exist sub field in the namePathList
                !namePathList.some((name)=>(0, $6cb43fc24256121e$export$325a4bd0e71bdc3a)(name, fieldNamePath, true))) finalValueNamePathList.push(fieldNamePath);
                namePathList.push(fieldNamePath);
            }
            // Skip if without rule
            if (!field.props.rules || !field.props.rules.length) return;
            // Skip if only validate dirty field
            if (dirty && !field.isFieldDirty()) return;
            validateNamePathList.add(fieldNamePath.join(TMP_SPLIT));
            // Add field validate rule in to promise list
            if (!provideNameList || (0, $6cb43fc24256121e$export$646d5504364ae55b)(namePathList, fieldNamePath, recursive)) {
                const promise = field.validateRules({
                    validateMessages: {
                        ...(0, $56211d4c2886bc69$export$c86b939816b8fbf8),
                        ...this.validateMessages
                    },
                    ...options
                });
                // Wrap promise with field
                promiseList.push(promise.then(()=>({
                        name: fieldNamePath,
                        errors: [],
                        warnings: []
                    })).catch((ruleErrors)=>{
                    const mergedErrors = [];
                    const mergedWarnings = [];
                    ruleErrors.forEach?.(({ rule: { warningOnly: warningOnly }, errors: errors })=>{
                        if (warningOnly) mergedWarnings.push(...errors);
                        else mergedErrors.push(...errors);
                    });
                    if (mergedErrors.length) return Promise.reject({
                        name: fieldNamePath,
                        errors: mergedErrors,
                        warnings: mergedWarnings
                    });
                    return {
                        name: fieldNamePath,
                        errors: mergedErrors,
                        warnings: mergedWarnings
                    };
                }));
            }
        });
        const summaryPromise = (0, $16a48f8c0d350f45$export$6152adfdcc6be2b5)(promiseList);
        this.lastValidatePromise = summaryPromise;
        // Notify fields with rule that validate has finished and need update
        summaryPromise.catch((results)=>results).then((results)=>{
            const resultNamePathList = results.map(({ name: name })=>name);
            this.notifyObservers(this.store, resultNamePathList, {
                type: 'validateFinish'
            });
            this.triggerOnFieldsChange(resultNamePathList, results);
        });
        const returnPromise = summaryPromise.then(()=>{
            if (this.lastValidatePromise === summaryPromise) return Promise.resolve(this.getFieldsValue(finalValueNamePathList));
            return Promise.reject([]);
        }).catch((results)=>{
            const errorList = results.filter((result)=>result && result.errors.length);
            const errorMessage = errorList[0]?.errors?.[0];
            return Promise.reject({
                message: errorMessage,
                values: this.getFieldsValue(namePathList),
                errorFields: errorList,
                outOfDate: this.lastValidatePromise !== summaryPromise
            });
        });
        // Do not throw in console
        returnPromise.catch((e)=>e);
        // `validating` changed. Trigger `onFieldsChange`
        const triggerNamePathList = namePathList.filter((namePath)=>validateNamePathList.has(namePath.join(TMP_SPLIT)));
        this.triggerOnFieldsChange(triggerNamePathList);
        return returnPromise;
    };
    // ============================ Submit ============================
    submit = ()=>{
        this.warningUnhooked();
        this.validateFields().then((values)=>{
            const { onFinish: onFinish } = this.callbacks;
            if (onFinish) try {
                onFinish(values);
            } catch (err) {
                // Should print error if user `onFinish` callback failed
                console.error(err);
            }
        }).catch((e)=>{
            const { onFinishFailed: onFinishFailed } = this.callbacks;
            if (onFinishFailed) onFinishFailed(e);
        });
    };
}
function $1547c3a057122952$var$useForm(form) {
    const formRef = $32rMB.useRef(null);
    const [, forceUpdate] = $32rMB.useState({});
    if (!formRef.current) {
        if (form) formRef.current = form;
        else {
            // Create a new FormStore if not provided
            const forceReRender = ()=>{
                forceUpdate({});
            };
            const formStore = new $1547c3a057122952$export$75ff1ab1187e691(forceReRender);
            formRef.current = formStore.getForm();
        }
    }
    return [
        formRef.current
    ];
}
var $1547c3a057122952$export$2e2bcd8739ae039 = $1547c3a057122952$var$useForm;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");
const $cbadb8853612cbc0$var$FormContext = /*#__PURE__*/ $hO8yS.createContext({
    triggerFormChange: ()=>{},
    triggerFormFinish: ()=>{},
    registerForm: ()=>{},
    unregisterForm: ()=>{}
});
const $cbadb8853612cbc0$export$8ce1ff4f94d08846 = ({ validateMessages: validateMessages, onFormChange: onFormChange, onFormFinish: onFormFinish, children: children })=>{
    const formContext = $32rMB.useContext($cbadb8853612cbc0$var$FormContext);
    const formsRef = $32rMB.useRef({});
    return /*#__PURE__*/ $hO8yS.createElement($cbadb8853612cbc0$var$FormContext.Provider, {
        value: {
            ...formContext,
            validateMessages: {
                ...formContext.validateMessages,
                ...validateMessages
            },
            // =========================================================
            // =                  Global Form Control                  =
            // =========================================================
            triggerFormChange: (name, changedFields)=>{
                if (onFormChange) onFormChange(name, {
                    changedFields: changedFields,
                    forms: formsRef.current
                });
                formContext.triggerFormChange(name, changedFields);
            },
            triggerFormFinish: (name, values)=>{
                if (onFormFinish) onFormFinish(name, {
                    values: values,
                    forms: formsRef.current
                });
                formContext.triggerFormFinish(name, values);
            },
            registerForm: (name, form)=>{
                if (name) formsRef.current = {
                    ...formsRef.current,
                    [name]: form
                };
                formContext.registerForm(name, form);
            },
            unregisterForm: (name)=>{
                const newForms = {
                    ...formsRef.current
                };
                delete newForms[name];
                formsRef.current = newForms;
                formContext.unregisterForm(name);
            }
        }
    }, children);
};
var $cbadb8853612cbc0$export$2e2bcd8739ae039 = $cbadb8853612cbc0$var$FormContext;





var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
const $60983b4c31cac80d$var$BatchUpdate = /*#__PURE__*/ $N3oW3.forwardRef((_, ref)=>{
    const [batchInfo, setBatchInfo] = $32rMB.useState({});
    $32rMB.useLayoutEffect(()=>{
        const keys = Object.keys(batchInfo);
        if (keys.length) {
            keys.forEach((key)=>{
                batchInfo[key]?.();
            });
            setBatchInfo({});
        }
    }, [
        batchInfo
    ]);
    $32rMB.useImperativeHandle(ref, ()=>({
            batch: (key, callback)=>{
                setBatchInfo((ori)=>({
                        ...ori,
                        [key]: callback
                    }));
            }
        }));
    return null;
});
var $60983b4c31cac80d$export$2e2bcd8739ae039 = $60983b4c31cac80d$var$BatchUpdate;


function $38525224b795593b$var$_extends() {
    $38525224b795593b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $38525224b795593b$var$_extends.apply(this, arguments);
}
const $38525224b795593b$var$Form = ({ name: name, initialValues: initialValues, fields: fields, form: form, preserve: preserve, children: children, component: Component = 'form', validateMessages: validateMessages, validateTrigger: validateTrigger = 'onChange', onValuesChange: onValuesChange, onFieldsChange: onFieldsChange, onFinish: onFinish, onFinishFailed: onFinishFailed, clearOnDestroy: clearOnDestroy, ...restProps }, ref)=>{
    const nativeElementRef = $32rMB.useRef(null);
    const formContext = $32rMB.useContext((0, $cbadb8853612cbc0$export$2e2bcd8739ae039));
    // We customize handle event since Context will makes all the consumer re-render:
    // https://reactjs.org/docs/context.html#contextprovider
    const [formInstance] = (0, $1547c3a057122952$export$2e2bcd8739ae039)(form);
    const { useSubscribe: useSubscribe, setInitialValues: setInitialValues, setCallbacks: setCallbacks, setValidateMessages: setValidateMessages, setPreserve: setPreserve, destroyForm: destroyForm, setBatchUpdate: setBatchUpdate } = formInstance.getInternalHooks((0, $e5b7fab730d97669$export$24829b7c0e49e9f7));
    // Pass ref with form instance
    $32rMB.useImperativeHandle(ref, ()=>({
            ...formInstance,
            nativeElement: nativeElementRef.current
        }));
    // Register form into Context
    $32rMB.useEffect(()=>{
        formContext.registerForm(name, formInstance);
        return ()=>{
            formContext.unregisterForm(name);
        };
    }, [
        formContext,
        formInstance,
        name
    ]);
    // Pass props to store
    setValidateMessages({
        ...formContext.validateMessages,
        ...validateMessages
    });
    setCallbacks({
        onValuesChange: onValuesChange,
        onFieldsChange: (changedFields, ...rest)=>{
            formContext.triggerFormChange(name, changedFields);
            if (onFieldsChange) onFieldsChange(changedFields, ...rest);
        },
        onFinish: (values)=>{
            formContext.triggerFormFinish(name, values);
            if (onFinish) onFinish(values);
        },
        onFinishFailed: onFinishFailed
    });
    setPreserve(preserve);
    // Set initial value, init store value when first mount
    const mountRef = $32rMB.useRef(null);
    setInitialValues(initialValues, !mountRef.current);
    if (!mountRef.current) mountRef.current = true;
    // ======================== Batch Update ========================
    // zombieJ:
    // To avoid Form self re-render,
    // We create a sub component `BatchUpdate` to handle batch update logic.
    // When the call with do not change immediate, we will batch the update
    // and flush it in `useLayoutEffect` for next tick.
    // Set batch update ref
    const batchUpdateRef = $32rMB.useRef(null);
    const batchUpdateTasksRef = $32rMB.useRef([]);
    const tryFlushBatch = ()=>{
        if (batchUpdateRef.current) {
            batchUpdateTasksRef.current.forEach(([key, fn])=>{
                batchUpdateRef.current.batch(key, fn);
            });
            batchUpdateTasksRef.current = [];
        }
    };
    // Ref update
    const setBatchUpdateRef = $32rMB.useCallback((batchUpdate)=>{
        batchUpdateRef.current = batchUpdate;
        tryFlushBatch();
    }, []);
    // Task list
    const batchUpdate = (key, callback)=>{
        batchUpdateTasksRef.current.push([
            key,
            callback
        ]);
        tryFlushBatch();
    };
    setBatchUpdate(batchUpdate);
    // ========================== Unmount ===========================
    $32rMB.useEffect(()=>()=>destroyForm(clearOnDestroy), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // Prepare children by `children` type
    let childrenNode;
    const childrenRenderProps = typeof children === 'function';
    if (childrenRenderProps) {
        const values = formInstance.getFieldsValue(true);
        childrenNode = children(values, formInstance);
    } else childrenNode = children;
    // Not use subscribe when using render props
    useSubscribe(!childrenRenderProps);
    // Listen if fields provided. We use ref to save prev data here to avoid additional render
    const prevFieldsRef = $32rMB.useRef(null);
    $32rMB.useEffect(()=>{
        if (!(0, $6cb43fc24256121e$export$dfcec05bb7372a54)(prevFieldsRef.current || [], fields || [])) formInstance.setFields(fields || []);
        prevFieldsRef.current = fields;
    }, [
        fields,
        formInstance
    ]);
    // =========================== Render ===========================
    const formContextValue = $32rMB.useMemo(()=>({
            ...formInstance,
            validateTrigger: validateTrigger
        }), [
        formInstance,
        validateTrigger
    ]);
    const wrapperNode = /*#__PURE__*/ $hO8yS.createElement((0, $d651cb95b201e088$export$2e2bcd8739ae039).Provider, {
        value: null
    }, /*#__PURE__*/ $hO8yS.createElement((0, $e5b7fab730d97669$export$2e2bcd8739ae039).Provider, {
        value: formContextValue
    }, childrenNode), /*#__PURE__*/ $hO8yS.createElement((0, $60983b4c31cac80d$export$2e2bcd8739ae039), {
        ref: setBatchUpdateRef
    }));
    if (Component === false) return wrapperNode;
    return /*#__PURE__*/ $hO8yS.createElement(Component, $38525224b795593b$var$_extends({}, restProps, {
        ref: nativeElementRef,
        onSubmit: (event)=>{
            event.preventDefault();
            event.stopPropagation();
            formInstance.submit();
        },
        onReset: (event)=>{
            event.preventDefault();
            formInstance.resetFields();
            restProps.onReset?.(event);
        }
    }), wrapperNode);
};
var $38525224b795593b$export$2e2bcd8739ae039 = $38525224b795593b$var$Form;






parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");




function $7eda32901ee1cabd$export$fac44ee5b035f737(value) {
    try {
        return JSON.stringify(value);
    } catch  {
        return Math.random();
    }
}
// ------- selector type -------
// ------- selector type end -------
function $7eda32901ee1cabd$var$useWatch(...args) {
    const [dependencies, _form = {}] = args;
    const options = (0, $7abb023c0e672c8b$export$717b316e73068e8d)(_form) ? {
        form: _form
    } : _form;
    const form = options.form;
    const [value, setValue] = (0, $32rMB.useState)(()=>typeof dependencies === 'function' ? dependencies({}) : undefined);
    const valueStr = (0, $32rMB.useMemo)(()=>$7eda32901ee1cabd$export$fac44ee5b035f737(value), [
        value
    ]);
    const valueStrRef = (0, $32rMB.useRef)(valueStr);
    valueStrRef.current = valueStr;
    const fieldContext = (0, $32rMB.useContext)((0, $e5b7fab730d97669$export$2e2bcd8739ae039));
    const formInstance = form || fieldContext;
    const isValidForm = formInstance && formInstance._init;
    // ============================== Form ==============================
    const { getFieldsValue: getFieldsValue, getInternalHooks: getInternalHooks } = formInstance;
    const { registerWatch: registerWatch } = getInternalHooks((0, $e5b7fab730d97669$export$24829b7c0e49e9f7));
    // ============================= Update =============================
    const triggerUpdate = (0, $ea93068db096b7d6$export$2e2bcd8739ae039)((values, allValues)=>{
        const watchValue = options.preserve ? allValues ?? getFieldsValue(true) : values ?? getFieldsValue();
        const nextValue = typeof dependencies === 'function' ? dependencies(watchValue) : (0, $7967876a5e08d9ff$export$2e2bcd8739ae039)(watchValue, (0, $6cb43fc24256121e$export$f877b3cb4cb4ccf9)(dependencies));
        if ($7eda32901ee1cabd$export$fac44ee5b035f737(value) !== $7eda32901ee1cabd$export$fac44ee5b035f737(nextValue)) setValue(nextValue);
    });
    // ============================= Effect =============================
    const flattenDeps = typeof dependencies === 'function' ? dependencies : JSON.stringify(dependencies);
    // Deps changed
    (0, $32rMB.useEffect)(()=>{
        // Skip if not exist form instance
        if (!isValidForm) return;
        triggerUpdate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isValidForm,
        flattenDeps
    ]);
    // Value changed
    (0, $32rMB.useEffect)(()=>{
        // Skip if not exist form instance
        if (!isValidForm) return;
        const cancelRegister = registerWatch((values, allValues)=>{
            triggerUpdate(values, allValues);
        });
        return cancelRegister;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isValidForm
    ]);
    return value;
}
var $7eda32901ee1cabd$export$2e2bcd8739ae039 = $7eda32901ee1cabd$var$useWatch;


const $ef79b59c4dbafb7e$var$InternalForm = /*#__PURE__*/ $N3oW3.forwardRef((0, $38525224b795593b$export$2e2bcd8739ae039));
const $ef79b59c4dbafb7e$var$RefForm = $ef79b59c4dbafb7e$var$InternalForm;
$ef79b59c4dbafb7e$var$RefForm.FormProvider = (0, $cbadb8853612cbc0$export$8ce1ff4f94d08846);
$ef79b59c4dbafb7e$var$RefForm.Field = (0, $8b77da48dce7c38e$export$2e2bcd8739ae039);
$ef79b59c4dbafb7e$var$RefForm.List = (0, $1c2c0bc5ee309617$export$2e2bcd8739ae039);
$ef79b59c4dbafb7e$var$RefForm.useForm = (0, $1547c3a057122952$export$2e2bcd8739ae039);
$ef79b59c4dbafb7e$var$RefForm.useWatch = (0, $7eda32901ee1cabd$export$2e2bcd8739ae039);
var $ef79b59c4dbafb7e$export$2e2bcd8739ae039 = $ef79b59c4dbafb7e$var$RefForm;



"use client";
const $a1a112e4dddc1035$export$c24727297075ec6a = /*#__PURE__*/ $hO8yS.createContext({
    labelAlign: 'right',
    layout: 'horizontal',
    itemRef: ()=>{}
});
const $a1a112e4dddc1035$export$d718247e9f9b0b9e = /*#__PURE__*/ $hO8yS.createContext(null);
const $a1a112e4dddc1035$export$8ce1ff4f94d08846 = (props)=>{
    const providerProps = (0, $f4cf9c2e27c0ac8d$export$2e2bcd8739ae039)(props, [
        'prefixCls'
    ]);
    return /*#__PURE__*/ $hO8yS.createElement((0, $cbadb8853612cbc0$export$8ce1ff4f94d08846), {
        ...providerProps
    });
};
const $a1a112e4dddc1035$export$fb6582d3042cc879 = /*#__PURE__*/ $hO8yS.createContext({
    prefixCls: ''
});
const $a1a112e4dddc1035$export$bbb5553c6c7a14ed = /*#__PURE__*/ $hO8yS.createContext({});
const $a1a112e4dddc1035$export$80e4c53cb85dcab1 = ({ children: children, status: status, override: override })=>{
    const formItemInputContext = $32rMB.useContext($a1a112e4dddc1035$export$bbb5553c6c7a14ed);
    const newFormItemInputContext = $32rMB.useMemo(()=>{
        const newContext = {
            ...formItemInputContext
        };
        if (override) delete newContext.isFormItemInput;
        if (status) {
            delete newContext.status;
            delete newContext.hasFeedback;
            delete newContext.feedbackIcon;
        }
        return newContext;
    }, [
        status,
        override,
        formItemInputContext
    ]);
    return /*#__PURE__*/ $hO8yS.createElement($a1a112e4dddc1035$export$bbb5553c6c7a14ed.Provider, {
        value: newFormItemInputContext
    }, children);
};
const $a1a112e4dddc1035$export$6f0555dad42725fb = /*#__PURE__*/ $hO8yS.createContext(undefined);


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
const $2c11327ae0ff8899$var$isValidOrientation = (orientation)=>{
    return orientation === 'horizontal' || orientation === 'vertical';
};
const $2c11327ae0ff8899$export$550084c67147f6c4 = (orientation, vertical, legacyDirection)=>{
    return (0, $32rMB.useMemo)(()=>{
        const validOrientation = $2c11327ae0ff8899$var$isValidOrientation(orientation);
        let mergedOrientation;
        if (validOrientation) mergedOrientation = orientation;
        else if (typeof vertical === 'boolean') mergedOrientation = vertical ? 'vertical' : 'horizontal';
        else {
            const validLegacyDirection = $2c11327ae0ff8899$var$isValidOrientation(legacyDirection);
            mergedOrientation = validLegacyDirection ? legacyDirection : 'horizontal';
        }
        return [
            mergedOrientation,
            mergedOrientation === 'vertical'
        ];
    }, [
        legacyDirection,
        orientation,
        vertical
    ]);
};






const $b171552af8cd923f$var$genSpaceCompactStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: {
            display: 'inline-flex',
            '&-block': {
                display: 'flex',
                width: '100%'
            },
            '&-vertical': {
                flexDirection: 'column'
            },
            '&-rtl': {
                direction: 'rtl'
            }
        }
    };
};
var // ============================== Export ==============================
$b171552af8cd923f$export$2e2bcd8739ae039 = (0, $d4a2dc313c4d90a4$export$51ec95de45185b42)([
    'Space',
    'Compact'
], (token)=>[
        $b171552af8cd923f$var$genSpaceCompactStyle(token)
    ], ()=>({}), {
    // Space component don't apply extra font style
    // https://github.com/ant-design/ant-design/issues/40315
    resetStyle: false
});


"use client";
const $085e8dc0a3d19960$export$8d1c486ac0db0a7d = /*#__PURE__*/ $hO8yS.createContext(null);
const $085e8dc0a3d19960$export$cd8cf9d7bab8dd4 = (prefixCls, direction)=>{
    const compactItemContext = $32rMB.useContext($085e8dc0a3d19960$export$8d1c486ac0db0a7d);
    const compactItemClassnames = $32rMB.useMemo(()=>{
        if (!compactItemContext) return '';
        const { compactDirection: compactDirection, isFirstItem: isFirstItem, isLastItem: isLastItem } = compactItemContext;
        const separator = compactDirection === 'vertical' ? '-vertical-' : '-';
        return (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-compact${separator}item`, {
            [`${prefixCls}-compact${separator}first-item`]: isFirstItem,
            [`${prefixCls}-compact${separator}last-item`]: isLastItem,
            [`${prefixCls}-compact${separator}item-rtl`]: direction === 'rtl'
        });
    }, [
        prefixCls,
        direction,
        compactItemContext
    ]);
    return {
        compactSize: compactItemContext?.compactSize,
        compactDirection: compactItemContext?.compactDirection,
        compactItemClassnames: compactItemClassnames
    };
};
const $085e8dc0a3d19960$export$5f56e610a4afb685 = (props)=>{
    const { children: children } = props;
    return /*#__PURE__*/ $hO8yS.createElement($085e8dc0a3d19960$export$8d1c486ac0db0a7d.Provider, {
        value: null
    }, children);
};
const $085e8dc0a3d19960$var$CompactItem = (props)=>{
    const { children: children, ...others } = props;
    return /*#__PURE__*/ $hO8yS.createElement($085e8dc0a3d19960$export$8d1c486ac0db0a7d.Provider, {
        value: $32rMB.useMemo(()=>others, [
            others
        ])
    }, children);
};
const $085e8dc0a3d19960$var$Compact = (props)=>{
    const { getPrefixCls: getPrefixCls, direction: directionConfig } = $32rMB.useContext((0, $dd01e2f5a4b8605d$export$a92f85ab3e9ad68b));
    const { size: size, direction: direction, orientation: orientation, block: block, prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, children: children, vertical: vertical, ...restProps } = props;
    const [mergedOrientation, mergedVertical] = (0, $2c11327ae0ff8899$export$550084c67147f6c4)(orientation, vertical, direction);
    const mergedSize = (0, $324b30eda6ea1cd7$export$2e2bcd8739ae039)((ctx)=>size ?? ctx);
    const prefixCls = getPrefixCls('space-compact', customizePrefixCls);
    const [hashId] = (0, $b171552af8cd923f$export$2e2bcd8739ae039)(prefixCls);
    const clx = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, hashId, {
        [`${prefixCls}-rtl`]: directionConfig === 'rtl',
        [`${prefixCls}-block`]: block,
        [`${prefixCls}-vertical`]: mergedVertical
    }, className, rootClassName);
    const compactItemContext = $32rMB.useContext($085e8dc0a3d19960$export$8d1c486ac0db0a7d);
    const childNodes = (0, $a60ede783f74e6a9$export$2e2bcd8739ae039)(children);
    const nodes = $32rMB.useMemo(()=>childNodes.map((child, i)=>{
            const key = child?.key || `${prefixCls}-item-${i}`;
            return /*#__PURE__*/ $hO8yS.createElement($085e8dc0a3d19960$var$CompactItem, {
                key: key,
                compactSize: mergedSize,
                compactDirection: mergedOrientation,
                isFirstItem: i === 0 && (!compactItemContext || compactItemContext?.isFirstItem),
                isLastItem: i === childNodes.length - 1 && (!compactItemContext || compactItemContext?.isLastItem)
            }, child);
        }), [
        childNodes,
        compactItemContext,
        mergedOrientation,
        mergedSize,
        prefixCls
    ]);
    // =========================== Render ===========================
    if (childNodes.length === 0) return null;
    return /*#__PURE__*/ $hO8yS.createElement("div", {
        className: clx,
        ...restProps
    }, nodes);
};
var $085e8dc0a3d19960$export$2e2bcd8739ae039 = $085e8dc0a3d19960$var$Compact;



"use client";
const $8a9bb3ef8b2b36aa$var$ContextIsolator = (props)=>{
    const { space: space, form: form, children: children } = props;
    if (!(0, $95ac4c3d4339216e$export$2e2bcd8739ae039)(children)) return null;
    let result = children;
    if (form) result = /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $a1a112e4dddc1035$export$80e4c53cb85dcab1), {
        override: true,
        status: true
    }, result);
    if (space) result = /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $085e8dc0a3d19960$export$5f56e610a4afb685), null, result);
    return result;
};
var $8a9bb3ef8b2b36aa$export$2e2bcd8739ae039 = $8a9bb3ef8b2b36aa$var$ContextIsolator;






function $129ab988bfbe5ce1$export$87e38ee403661ccc(token) {
    const { sizePopupArrow: sizePopupArrow, borderRadiusXS: borderRadiusXS, borderRadiusOuter: borderRadiusOuter } = token;
    const unitWidth = sizePopupArrow / 2;
    const ax = 0;
    const ay = unitWidth;
    const bx = borderRadiusOuter * 1 / Math.sqrt(2);
    const by = unitWidth - borderRadiusOuter * (1 - 1 / Math.sqrt(2));
    const cx = unitWidth - borderRadiusXS * (1 / Math.sqrt(2));
    const cy = borderRadiusOuter * (Math.sqrt(2) - 1) + borderRadiusXS * (1 / Math.sqrt(2));
    const dx = 2 * unitWidth - cx;
    const dy = cy;
    const ex = 2 * unitWidth - bx;
    const ey = by;
    const fx = 2 * unitWidth - ax;
    const fy = ay;
    const shadowWidth = unitWidth * Math.sqrt(2) + borderRadiusOuter * (Math.sqrt(2) - 2);
    const polygonOffset = borderRadiusOuter * (Math.sqrt(2) - 1);
    const arrowPolygon = `polygon(${polygonOffset}px 100%, 50% ${polygonOffset}px, ${2 * unitWidth - polygonOffset}px 100%, ${polygonOffset}px 100%)`;
    const arrowPath = `path('M ${ax} ${ay} A ${borderRadiusOuter} ${borderRadiusOuter} 0 0 0 ${bx} ${by} L ${cx} ${cy} A ${borderRadiusXS} ${borderRadiusXS} 0 0 1 ${dx} ${dy} L ${ex} ${ey} A ${borderRadiusOuter} ${borderRadiusOuter} 0 0 0 ${fx} ${fy} Z')`;
    return {
        arrowShadowWidth: shadowWidth,
        arrowPath: arrowPath,
        arrowPolygon: arrowPolygon
    };
}
const $129ab988bfbe5ce1$export$601fa0375eb80eec = (token, bgColor, boxShadow)=>{
    const { sizePopupArrow: sizePopupArrow, arrowPolygon: arrowPolygon, arrowPath: arrowPath, arrowShadowWidth: arrowShadowWidth, borderRadiusXS: borderRadiusXS, calc: calc } = token;
    return {
        pointerEvents: 'none',
        width: sizePopupArrow,
        height: sizePopupArrow,
        overflow: 'hidden',
        '&::before': {
            position: 'absolute',
            bottom: 0,
            insetInlineStart: 0,
            width: sizePopupArrow,
            height: calc(sizePopupArrow).div(2).equal(),
            background: bgColor,
            clipPath: {
                _multi_value_: true,
                value: [
                    arrowPolygon,
                    arrowPath
                ]
            },
            content: '""'
        },
        '&::after': {
            content: '""',
            position: 'absolute',
            width: arrowShadowWidth,
            height: arrowShadowWidth,
            bottom: 0,
            insetInline: 0,
            margin: 'auto',
            borderRadius: {
                _skip_check_: true,
                value: `0 0 ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(borderRadiusXS)} 0`
            },
            transform: 'translateY(50%) rotate(-135deg)',
            boxShadow: boxShadow,
            zIndex: 0,
            background: 'transparent'
        }
    };
};


const $8d59d91a3e235d80$export$de6e4ffc9ec3c089 = 8;
function $8d59d91a3e235d80$export$bddc192327bb9823(options) {
    const { contentRadius: contentRadius, limitVerticalRadius: limitVerticalRadius } = options;
    const arrowOffset = contentRadius > 12 ? contentRadius + 2 : 12;
    const arrowOffsetVertical = limitVerticalRadius ? $8d59d91a3e235d80$export$de6e4ffc9ec3c089 : arrowOffset;
    return {
        arrowOffsetHorizontal: arrowOffset,
        arrowOffsetVertical: arrowOffsetVertical
    };
}
function $8d59d91a3e235d80$var$isInject(valid, code) {
    if (!valid) return {};
    return code;
}
function $8d59d91a3e235d80$export$2e2bcd8739ae039(token, colorBg, options) {
    const { componentCls: componentCls, boxShadowPopoverArrow: boxShadowPopoverArrow, arrowOffsetVertical: arrowOffsetVertical, arrowOffsetHorizontal: arrowOffsetHorizontal } = token;
    const { arrowDistance: arrowDistance = 0, arrowPlacement: arrowPlacement = {
        left: true,
        right: true,
        top: true,
        bottom: true
    } } = options || {};
    return {
        [componentCls]: {
            // ============================ Basic ============================
            [`${componentCls}-arrow`]: [
                {
                    position: 'absolute',
                    zIndex: 1,
                    // lift it up so the menu wouldn't cask shadow on it
                    display: 'block',
                    ...(0, $129ab988bfbe5ce1$export$601fa0375eb80eec)(token, colorBg, boxShadowPopoverArrow),
                    '&:before': {
                        background: colorBg
                    }
                }
            ],
            // ========================== Placement ==========================
            // Here handle the arrow position and rotate stuff
            // >>>>> Top
            ...$8d59d91a3e235d80$var$isInject(!!arrowPlacement.top, {
                [[
                    `&-placement-top > ${componentCls}-arrow`,
                    `&-placement-topLeft > ${componentCls}-arrow`,
                    `&-placement-topRight > ${componentCls}-arrow`
                ].join(',')]: {
                    bottom: arrowDistance,
                    transform: 'translateY(100%) rotate(180deg)'
                },
                [`&-placement-top > ${componentCls}-arrow`]: {
                    left: {
                        _skip_check_: true,
                        value: '50%'
                    },
                    transform: 'translateX(-50%) translateY(100%) rotate(180deg)'
                },
                '&-placement-topLeft': {
                    '--arrow-offset-horizontal': arrowOffsetHorizontal,
                    [`> ${componentCls}-arrow`]: {
                        left: {
                            _skip_check_: true,
                            value: arrowOffsetHorizontal
                        }
                    }
                },
                '&-placement-topRight': {
                    '--arrow-offset-horizontal': `calc(100% - ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(arrowOffsetHorizontal)})`,
                    [`> ${componentCls}-arrow`]: {
                        right: {
                            _skip_check_: true,
                            value: arrowOffsetHorizontal
                        }
                    }
                }
            }),
            // >>>>> Bottom
            ...$8d59d91a3e235d80$var$isInject(!!arrowPlacement.bottom, {
                [[
                    `&-placement-bottom > ${componentCls}-arrow`,
                    `&-placement-bottomLeft > ${componentCls}-arrow`,
                    `&-placement-bottomRight > ${componentCls}-arrow`
                ].join(',')]: {
                    top: arrowDistance,
                    transform: `translateY(-100%)`
                },
                [`&-placement-bottom > ${componentCls}-arrow`]: {
                    left: {
                        _skip_check_: true,
                        value: '50%'
                    },
                    transform: `translateX(-50%) translateY(-100%)`
                },
                '&-placement-bottomLeft': {
                    '--arrow-offset-horizontal': arrowOffsetHorizontal,
                    [`> ${componentCls}-arrow`]: {
                        left: {
                            _skip_check_: true,
                            value: arrowOffsetHorizontal
                        }
                    }
                },
                '&-placement-bottomRight': {
                    '--arrow-offset-horizontal': `calc(100% - ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(arrowOffsetHorizontal)})`,
                    [`> ${componentCls}-arrow`]: {
                        right: {
                            _skip_check_: true,
                            value: arrowOffsetHorizontal
                        }
                    }
                }
            }),
            // >>>>> Left
            ...$8d59d91a3e235d80$var$isInject(!!arrowPlacement.left, {
                [[
                    `&-placement-left > ${componentCls}-arrow`,
                    `&-placement-leftTop > ${componentCls}-arrow`,
                    `&-placement-leftBottom > ${componentCls}-arrow`
                ].join(',')]: {
                    right: {
                        _skip_check_: true,
                        value: arrowDistance
                    },
                    transform: 'translateX(100%) rotate(90deg)'
                },
                [`&-placement-left > ${componentCls}-arrow`]: {
                    top: {
                        _skip_check_: true,
                        value: '50%'
                    },
                    transform: 'translateY(-50%) translateX(100%) rotate(90deg)'
                },
                [`&-placement-leftTop > ${componentCls}-arrow`]: {
                    top: arrowOffsetVertical
                },
                [`&-placement-leftBottom > ${componentCls}-arrow`]: {
                    bottom: arrowOffsetVertical
                }
            }),
            // >>>>> Right
            ...$8d59d91a3e235d80$var$isInject(!!arrowPlacement.right, {
                [[
                    `&-placement-right > ${componentCls}-arrow`,
                    `&-placement-rightTop > ${componentCls}-arrow`,
                    `&-placement-rightBottom > ${componentCls}-arrow`
                ].join(',')]: {
                    left: {
                        _skip_check_: true,
                        value: arrowDistance
                    },
                    transform: 'translateX(-100%) rotate(-90deg)'
                },
                [`&-placement-right > ${componentCls}-arrow`]: {
                    top: {
                        _skip_check_: true,
                        value: '50%'
                    },
                    transform: 'translateY(-50%) translateX(-100%) rotate(-90deg)'
                },
                [`&-placement-rightTop > ${componentCls}-arrow`]: {
                    top: arrowOffsetVertical
                },
                [`&-placement-rightBottom > ${componentCls}-arrow`]: {
                    bottom: arrowOffsetVertical
                }
            })
        }
    };
}


function $e523ba814abcafb5$export$fde75e5b410c093f(placement, arrowOffset, arrowWidth, autoAdjustOverflow) {
    if (autoAdjustOverflow === false) return {
        adjustX: false,
        adjustY: false
    };
    const overflow = autoAdjustOverflow && typeof autoAdjustOverflow === 'object' ? autoAdjustOverflow : {};
    const baseOverflow = {};
    switch(placement){
        case 'top':
        case 'bottom':
            baseOverflow.shiftX = arrowOffset.arrowOffsetHorizontal * 2 + arrowWidth;
            baseOverflow.shiftY = true;
            baseOverflow.adjustY = true;
            break;
        case 'left':
        case 'right':
            baseOverflow.shiftY = arrowOffset.arrowOffsetVertical * 2 + arrowWidth;
            baseOverflow.shiftX = true;
            baseOverflow.adjustX = true;
            break;
    }
    const mergedOverflow = {
        ...baseOverflow,
        ...overflow
    };
    // Support auto shift
    if (!mergedOverflow.shiftX) mergedOverflow.adjustX = true;
    if (!mergedOverflow.shiftY) mergedOverflow.adjustY = true;
    return mergedOverflow;
}
const $e523ba814abcafb5$var$PlacementAlignMap = {
    left: {
        points: [
            'cr',
            'cl'
        ]
    },
    right: {
        points: [
            'cl',
            'cr'
        ]
    },
    top: {
        points: [
            'bc',
            'tc'
        ]
    },
    bottom: {
        points: [
            'tc',
            'bc'
        ]
    },
    topLeft: {
        points: [
            'bl',
            'tl'
        ]
    },
    leftTop: {
        points: [
            'tr',
            'tl'
        ]
    },
    topRight: {
        points: [
            'br',
            'tr'
        ]
    },
    rightTop: {
        points: [
            'tl',
            'tr'
        ]
    },
    bottomRight: {
        points: [
            'tr',
            'br'
        ]
    },
    rightBottom: {
        points: [
            'bl',
            'br'
        ]
    },
    bottomLeft: {
        points: [
            'tl',
            'bl'
        ]
    },
    leftBottom: {
        points: [
            'br',
            'bl'
        ]
    }
};
const $e523ba814abcafb5$var$ArrowCenterPlacementAlignMap = {
    topLeft: {
        points: [
            'bl',
            'tc'
        ]
    },
    leftTop: {
        points: [
            'tr',
            'cl'
        ]
    },
    topRight: {
        points: [
            'br',
            'tc'
        ]
    },
    rightTop: {
        points: [
            'tl',
            'cr'
        ]
    },
    bottomRight: {
        points: [
            'tr',
            'bc'
        ]
    },
    rightBottom: {
        points: [
            'bl',
            'cr'
        ]
    },
    bottomLeft: {
        points: [
            'tl',
            'bc'
        ]
    },
    leftBottom: {
        points: [
            'br',
            'cl'
        ]
    }
};
const $e523ba814abcafb5$var$DisableAutoArrowList = new Set([
    'topLeft',
    'topRight',
    'bottomLeft',
    'bottomRight',
    'leftTop',
    'leftBottom',
    'rightTop',
    'rightBottom'
]);
function $e523ba814abcafb5$export$2e2bcd8739ae039(config) {
    const { arrowWidth: arrowWidth, autoAdjustOverflow: autoAdjustOverflow, arrowPointAtCenter: arrowPointAtCenter, offset: offset, borderRadius: borderRadius, visibleFirst: visibleFirst } = config;
    const halfArrowWidth = arrowWidth / 2;
    const placementMap = {};
    // Dynamic offset
    const arrowOffset = (0, $8d59d91a3e235d80$export$bddc192327bb9823)({
        contentRadius: borderRadius,
        limitVerticalRadius: true
    });
    Object.keys($e523ba814abcafb5$var$PlacementAlignMap).forEach((key)=>{
        const template = arrowPointAtCenter && $e523ba814abcafb5$var$ArrowCenterPlacementAlignMap[key] || $e523ba814abcafb5$var$PlacementAlignMap[key];
        const placementInfo = {
            ...template,
            offset: [
                0,
                0
            ],
            dynamicInset: true
        };
        placementMap[key] = placementInfo;
        // Disable autoArrow since design is fixed position
        if ($e523ba814abcafb5$var$DisableAutoArrowList.has(key)) placementInfo.autoArrow = false;
        // Static offset
        switch(key){
            case 'top':
            case 'topLeft':
            case 'topRight':
                placementInfo.offset[1] = -halfArrowWidth - offset;
                break;
            case 'bottom':
            case 'bottomLeft':
            case 'bottomRight':
                placementInfo.offset[1] = halfArrowWidth + offset;
                break;
            case 'left':
            case 'leftTop':
            case 'leftBottom':
                placementInfo.offset[0] = -halfArrowWidth - offset;
                break;
            case 'right':
            case 'rightTop':
            case 'rightBottom':
                placementInfo.offset[0] = halfArrowWidth + offset;
                break;
        }
        if (arrowPointAtCenter) switch(key){
            case 'topLeft':
            case 'bottomLeft':
                placementInfo.offset[0] = -arrowOffset.arrowOffsetHorizontal - halfArrowWidth;
                break;
            case 'topRight':
            case 'bottomRight':
                placementInfo.offset[0] = arrowOffset.arrowOffsetHorizontal + halfArrowWidth;
                break;
            case 'leftTop':
            case 'rightTop':
                placementInfo.offset[1] = -arrowOffset.arrowOffsetHorizontal * 2 + halfArrowWidth;
                break;
            case 'leftBottom':
            case 'rightBottom':
                placementInfo.offset[1] = arrowOffset.arrowOffsetHorizontal * 2 - halfArrowWidth;
                break;
        }
        // Overflow
        placementInfo.overflow = $e523ba814abcafb5$export$fde75e5b410c093f(key, arrowOffset, arrowWidth, autoAdjustOverflow);
        // VisibleFirst
        if (visibleFirst) placementInfo.htmlRegion = 'visibleFirst';
    });
    return placementMap;
}









var $N3oW3 = parcelRequire("N3oW3");
const $6993852e4088d6b2$var$useMergedArrow = (providedArrow, providedContextArrow)=>{
    const toConfig = (arrow)=>typeof arrow === 'boolean' ? {
            show: arrow
        } : arrow || {};
    return (0, $N3oW3.default).useMemo(()=>{
        const arrowConfig = toConfig(providedArrow);
        const contextArrowConfig = toConfig(providedContextArrow);
        return {
            ...contextArrowConfig,
            ...arrowConfig,
            show: arrowConfig.show ?? contextArrowConfig.show ?? true
        };
    }, [
        providedArrow,
        providedContextArrow
    ]);
};
var $6993852e4088d6b2$export$2e2bcd8739ae039 = $6993852e4088d6b2$var$useMergedArrow;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");








const $811fac7c59e65981$var$initMotionCommon = (duration)=>({
        animationDuration: duration,
        animationFillMode: 'both'
    });
// FIXME: origin less code seems same as initMotionCommon. Maybe we can safe remove
const $811fac7c59e65981$var$initMotionCommonLeave = (duration)=>({
        animationDuration: duration,
        animationFillMode: 'both'
    });
const $811fac7c59e65981$export$83e1da9e09ec9112 = (motionCls, inKeyframes, outKeyframes, duration, sameLevel = false)=>{
    const sameLevelPrefix = sameLevel ? '&' : '';
    return {
        [`
      ${sameLevelPrefix}${motionCls}-enter,
      ${sameLevelPrefix}${motionCls}-appear
    `]: {
            ...$811fac7c59e65981$var$initMotionCommon(duration),
            animationPlayState: 'paused'
        },
        [`${sameLevelPrefix}${motionCls}-leave`]: {
            ...$811fac7c59e65981$var$initMotionCommonLeave(duration),
            animationPlayState: 'paused'
        },
        [`
      ${sameLevelPrefix}${motionCls}-enter${motionCls}-enter-active,
      ${sameLevelPrefix}${motionCls}-appear${motionCls}-appear-active
    `]: {
            animationName: inKeyframes,
            animationPlayState: 'running'
        },
        [`${sameLevelPrefix}${motionCls}-leave${motionCls}-leave-active`]: {
            animationName: outKeyframes,
            animationPlayState: 'running',
            pointerEvents: 'none'
        }
    };
};


const $75aa16c51f96f6ab$export$82e6205b15e6c637 = new (0, $f806545df26bb0b4$export$2e2bcd8739ae039)('antFadeIn', {
    '0%': {
        opacity: 0
    },
    '100%': {
        opacity: 1
    }
});
const $75aa16c51f96f6ab$export$c091916f1530334c = new (0, $f806545df26bb0b4$export$2e2bcd8739ae039)('antFadeOut', {
    '0%': {
        opacity: 1
    },
    '100%': {
        opacity: 0
    }
});
const $75aa16c51f96f6ab$export$2909268c8354a12 = (token, sameLevel = false)=>{
    const { antCls: antCls } = token;
    const motionCls = `${antCls}-fade`;
    const sameLevelPrefix = sameLevel ? '&' : '';
    return [
        (0, $811fac7c59e65981$export$83e1da9e09ec9112)(motionCls, $75aa16c51f96f6ab$export$82e6205b15e6c637, $75aa16c51f96f6ab$export$c091916f1530334c, token.motionDurationMid, sameLevel),
        {
            [`
        ${sameLevelPrefix}${motionCls}-enter,
        ${sameLevelPrefix}${motionCls}-appear
      `]: {
                opacity: 0,
                animationTimingFunction: 'linear'
            },
            [`${sameLevelPrefix}${motionCls}-leave`]: {
                animationTimingFunction: 'linear'
            }
        }
    ];
};



const $9783f6e7d4c63d86$export$3b71758b3ed5255f = new (0, $f806545df26bb0b4$export$2e2bcd8739ae039)('antZoomIn', {
    '0%': {
        transform: 'scale(0.2)',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        opacity: 1
    }
});
const $9783f6e7d4c63d86$export$9fdb0a49c6b4b521 = new (0, $f806545df26bb0b4$export$2e2bcd8739ae039)('antZoomOut', {
    '0%': {
        transform: 'scale(1)'
    },
    '100%': {
        transform: 'scale(0.2)',
        opacity: 0
    }
});
const $9783f6e7d4c63d86$export$be061d573c42e33a = new (0, $f806545df26bb0b4$export$2e2bcd8739ae039)('antZoomBigIn', {
    '0%': {
        transform: 'scale(0.8)',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        opacity: 1
    }
});
const $9783f6e7d4c63d86$export$582d93d613303da3 = new (0, $f806545df26bb0b4$export$2e2bcd8739ae039)('antZoomBigOut', {
    '0%': {
        transform: 'scale(1)'
    },
    '100%': {
        transform: 'scale(0.8)',
        opacity: 0
    }
});
const $9783f6e7d4c63d86$export$45eddd18c599b827 = new (0, $f806545df26bb0b4$export$2e2bcd8739ae039)('antZoomUpIn', {
    '0%': {
        transform: 'scale(0.8)',
        transformOrigin: '50% 0%',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        transformOrigin: '50% 0%'
    }
});
const $9783f6e7d4c63d86$export$a85c97750adaa37a = new (0, $f806545df26bb0b4$export$2e2bcd8739ae039)('antZoomUpOut', {
    '0%': {
        transform: 'scale(1)',
        transformOrigin: '50% 0%'
    },
    '100%': {
        transform: 'scale(0.8)',
        transformOrigin: '50% 0%',
        opacity: 0
    }
});
const $9783f6e7d4c63d86$export$bd2378f7814f5f1a = new (0, $f806545df26bb0b4$export$2e2bcd8739ae039)('antZoomLeftIn', {
    '0%': {
        transform: 'scale(0.8)',
        transformOrigin: '0% 50%',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        transformOrigin: '0% 50%'
    }
});
const $9783f6e7d4c63d86$export$e58f88c751c4f04e = new (0, $f806545df26bb0b4$export$2e2bcd8739ae039)('antZoomLeftOut', {
    '0%': {
        transform: 'scale(1)',
        transformOrigin: '0% 50%'
    },
    '100%': {
        transform: 'scale(0.8)',
        transformOrigin: '0% 50%',
        opacity: 0
    }
});
const $9783f6e7d4c63d86$export$fee1456954aef331 = new (0, $f806545df26bb0b4$export$2e2bcd8739ae039)('antZoomRightIn', {
    '0%': {
        transform: 'scale(0.8)',
        transformOrigin: '100% 50%',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        transformOrigin: '100% 50%'
    }
});
const $9783f6e7d4c63d86$export$811ba6d3e2adb730 = new (0, $f806545df26bb0b4$export$2e2bcd8739ae039)('antZoomRightOut', {
    '0%': {
        transform: 'scale(1)',
        transformOrigin: '100% 50%'
    },
    '100%': {
        transform: 'scale(0.8)',
        transformOrigin: '100% 50%',
        opacity: 0
    }
});
const $9783f6e7d4c63d86$export$633a68aa72dec21c = new (0, $f806545df26bb0b4$export$2e2bcd8739ae039)('antZoomDownIn', {
    '0%': {
        transform: 'scale(0.8)',
        transformOrigin: '50% 100%',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        transformOrigin: '50% 100%'
    }
});
const $9783f6e7d4c63d86$export$1cf46a906e8dede4 = new (0, $f806545df26bb0b4$export$2e2bcd8739ae039)('antZoomDownOut', {
    '0%': {
        transform: 'scale(1)',
        transformOrigin: '50% 100%'
    },
    '100%': {
        transform: 'scale(0.8)',
        transformOrigin: '50% 100%',
        opacity: 0
    }
});
const $9783f6e7d4c63d86$var$zoomMotion = {
    zoom: {
        inKeyframes: $9783f6e7d4c63d86$export$3b71758b3ed5255f,
        outKeyframes: $9783f6e7d4c63d86$export$9fdb0a49c6b4b521
    },
    'zoom-big': {
        inKeyframes: $9783f6e7d4c63d86$export$be061d573c42e33a,
        outKeyframes: $9783f6e7d4c63d86$export$582d93d613303da3
    },
    'zoom-big-fast': {
        inKeyframes: $9783f6e7d4c63d86$export$be061d573c42e33a,
        outKeyframes: $9783f6e7d4c63d86$export$582d93d613303da3
    },
    'zoom-left': {
        inKeyframes: $9783f6e7d4c63d86$export$bd2378f7814f5f1a,
        outKeyframes: $9783f6e7d4c63d86$export$e58f88c751c4f04e
    },
    'zoom-right': {
        inKeyframes: $9783f6e7d4c63d86$export$fee1456954aef331,
        outKeyframes: $9783f6e7d4c63d86$export$811ba6d3e2adb730
    },
    'zoom-up': {
        inKeyframes: $9783f6e7d4c63d86$export$45eddd18c599b827,
        outKeyframes: $9783f6e7d4c63d86$export$a85c97750adaa37a
    },
    'zoom-down': {
        inKeyframes: $9783f6e7d4c63d86$export$633a68aa72dec21c,
        outKeyframes: $9783f6e7d4c63d86$export$1cf46a906e8dede4
    }
};
const $9783f6e7d4c63d86$export$f5d123412490d9dc = (token, motionName)=>{
    const { antCls: antCls } = token;
    const motionCls = `${antCls}-${motionName}`;
    const { inKeyframes: inKeyframes, outKeyframes: outKeyframes } = $9783f6e7d4c63d86$var$zoomMotion[motionName];
    return [
        (0, $811fac7c59e65981$export$83e1da9e09ec9112)(motionCls, inKeyframes, outKeyframes, motionName === 'zoom-big-fast' ? token.motionDurationFast : token.motionDurationMid),
        {
            [`
        ${motionCls}-enter,
        ${motionCls}-appear
      `]: {
                transform: 'scale(0)',
                opacity: 0,
                animationTimingFunction: token.motionEaseOutCirc,
                '&-prepare': {
                    transform: 'none'
                }
            },
            [`${motionCls}-leave`]: {
                animationTimingFunction: token.motionEaseInOutCirc
            }
        }
    ];
};




const $81d4e816322e7f22$export$6d4fe3a00a1811ad = [
    'blue',
    'purple',
    'cyan',
    'green',
    'magenta',
    'pink',
    'red',
    'orange',
    'yellow',
    'volcano',
    'geekblue',
    'lime',
    'gold'
];


function $c20a950e38531147$export$2e2bcd8739ae039(token, genCss) {
    return (0, $81d4e816322e7f22$export$6d4fe3a00a1811ad).reduce((prev, colorKey)=>{
        const lightColor = token[`${colorKey}1`];
        const lightBorderColor = token[`${colorKey}3`];
        const darkColor = token[`${colorKey}6`];
        const textColor = token[`${colorKey}7`];
        return {
            ...prev,
            ...genCss(colorKey, {
                lightColor: lightColor,
                lightBorderColor: lightBorderColor,
                darkColor: darkColor,
                textColor: textColor
            })
        };
    }, {});
}


const $24429bfd5b936d93$var$genTooltipStyle = (token)=>{
    const { calc: calc, componentCls: componentCls, tooltipMaxWidth: // ant-tooltip
    tooltipMaxWidth, tooltipColor: tooltipColor, tooltipBg: tooltipBg, tooltipBorderRadius: tooltipBorderRadius, zIndexPopup: zIndexPopup, controlHeight: controlHeight, boxShadowSecondary: boxShadowSecondary, paddingSM: paddingSM, paddingXS: paddingXS, arrowOffsetHorizontal: arrowOffsetHorizontal, sizePopupArrow: sizePopupArrow } = token;
    // arrowOffsetHorizontal + arrowWidth + borderRadius
    const edgeAlignMinWidth = calc(tooltipBorderRadius).add(sizePopupArrow).add(arrowOffsetHorizontal).equal();
    // borderRadius * 2 + arrowWidth
    const centerAlignMinWidth = calc(tooltipBorderRadius).mul(2).add(sizePopupArrow).equal();
    const sharedBodyStyle = {
        minWidth: centerAlignMinWidth,
        minHeight: controlHeight,
        padding: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.calc(paddingSM).div(2).equal())} ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(paddingXS)}`,
        color: `var(--ant-tooltip-color, ${tooltipColor})`,
        textAlign: 'start',
        textDecoration: 'none',
        wordWrap: 'break-word',
        backgroundColor: tooltipBg,
        borderRadius: tooltipBorderRadius,
        boxShadow: boxShadowSecondary,
        boxSizing: 'border-box'
    };
    const sharedTransformOrigin = {
        // When use `autoArrow`, origin will follow the arrow position
        '--valid-offset-x': 'var(--arrow-offset-horizontal, var(--arrow-x))',
        transformOrigin: [
            `var(--valid-offset-x, 50%)`,
            `var(--arrow-y, 50%)`
        ].join(' ')
    };
    return [
        {
            [componentCls]: {
                ...(0, $2f353af2b0f7600b$export$23997c3e44cc1c59)(token),
                position: 'absolute',
                zIndex: zIndexPopup,
                display: 'block',
                width: 'max-content',
                maxWidth: tooltipMaxWidth,
                visibility: 'visible',
                ...sharedTransformOrigin,
                '&-hidden': {
                    display: 'none'
                },
                '--antd-arrow-background-color': tooltipBg,
                // Wrapper for the tooltip content
                [`${componentCls}-container`]: [
                    sharedBodyStyle,
                    (0, $75aa16c51f96f6ab$export$2909268c8354a12)(token, true)
                ],
                [`&:has(~ ${componentCls}-unique-container)`]: {
                    [`${componentCls}-container`]: {
                        border: 'none',
                        background: 'transparent',
                        boxShadow: 'none'
                    }
                },
                // Align placement should have another min width
                [[
                    `&-placement-topLeft`,
                    `&-placement-topRight`,
                    `&-placement-bottomLeft`,
                    `&-placement-bottomRight`
                ].join(',')]: {
                    minWidth: edgeAlignMinWidth
                },
                // Limit left and right placement radius
                [[
                    `&-placement-left`,
                    `&-placement-leftTop`,
                    `&-placement-leftBottom`,
                    `&-placement-right`,
                    `&-placement-rightTop`,
                    `&-placement-rightBottom`
                ].join(',')]: {
                    [`${componentCls}-inner`]: {
                        borderRadius: token.min(tooltipBorderRadius, (0, $8d59d91a3e235d80$export$de6e4ffc9ec3c089))
                    }
                },
                [`${componentCls}-content`]: {
                    position: 'relative'
                },
                // generator for preset color
                ...(0, $c20a950e38531147$export$2e2bcd8739ae039)(token, (colorKey, { darkColor: darkColor })=>({
                        [`&${componentCls}-${colorKey}`]: {
                            [`${componentCls}-container`]: {
                                backgroundColor: darkColor
                            },
                            [`${componentCls}-arrow`]: {
                                '--antd-arrow-background-color': darkColor
                            }
                        }
                    })),
                // RTL
                '&-rtl': {
                    direction: 'rtl'
                }
            }
        },
        // Arrow Style
        (0, $8d59d91a3e235d80$export$2e2bcd8739ae039)(token, 'var(--antd-arrow-background-color)'),
        // Pure Render
        {
            [`${componentCls}-pure`]: {
                position: 'relative',
                maxWidth: 'none',
                margin: token.sizePopupArrow
            }
        },
        // Unique Body
        {
            [`${componentCls}-unique-container`]: {
                ...sharedBodyStyle,
                ...sharedTransformOrigin,
                position: 'absolute',
                zIndex: calc(zIndexPopup).sub(1).equal(),
                '&-hidden': {
                    display: 'none'
                },
                '&-visible': {
                    transition: `all ${token.motionDurationSlow}`
                }
            }
        }
    ];
};
const $24429bfd5b936d93$export$9ca1be8807fe0675 = (token)=>({
        zIndexPopup: token.zIndexPopupBase + 70,
        ...(0, $8d59d91a3e235d80$export$bddc192327bb9823)({
            contentRadius: token.borderRadius,
            limitVerticalRadius: true
        }),
        ...(0, $129ab988bfbe5ce1$export$87e38ee403661ccc)((0, $90c11ca6cb263fd9$export$4950aa0f605343fb)(token, {
            borderRadiusOuter: Math.min(token.borderRadiusOuter, 4)
        }))
    });
var $24429bfd5b936d93$export$2e2bcd8739ae039 = (prefixCls, rootCls, injectStyle = true)=>{
    const useStyle = (0, $d4a2dc313c4d90a4$export$51ec95de45185b42)('Tooltip', (token)=>{
        const { borderRadius: borderRadius, colorTextLightSolid: colorTextLightSolid, colorBgSpotlight: colorBgSpotlight } = token;
        const TooltipToken = (0, $90c11ca6cb263fd9$export$4950aa0f605343fb)(token, {
            // default variables
            tooltipMaxWidth: 250,
            tooltipColor: colorTextLightSolid,
            tooltipBorderRadius: borderRadius,
            tooltipBg: colorBgSpotlight
        });
        return [
            $24429bfd5b936d93$var$genTooltipStyle(TooltipToken),
            (0, $9783f6e7d4c63d86$export$f5d123412490d9dc)(token, 'zoom-big-fast')
        ];
    }, $24429bfd5b936d93$export$9ca1be8807fe0675, {
        resetStyle: false,
        injectStyle: // Popover use Tooltip as internal component. We do not need to handle this.
        injectStyle
    });
    return useStyle(prefixCls, rootCls);
};





const $ae5f89a650265493$var$inverseColors = (0, $81d4e816322e7f22$export$6d4fe3a00a1811ad).map((color)=>`${color}-inverse`);
const $ae5f89a650265493$export$2c43cb57a48fae33 = [
    'success',
    'processing',
    'error',
    'default',
    'warning'
];
function $ae5f89a650265493$export$ee62ebd6a58c4884(color, includeInverse = true) {
    if (includeInverse) return [].concat((0, $3746fb019e1f2ee5$export$2e2bcd8739ae039)($ae5f89a650265493$var$inverseColors), (0, $3746fb019e1f2ee5$export$2e2bcd8739ae039)((0, $81d4e816322e7f22$export$6d4fe3a00a1811ad))).includes(color);
    return (0, $81d4e816322e7f22$export$6d4fe3a00a1811ad).includes(color);
}
function $ae5f89a650265493$export$88a0ba1f7d1ea40e(color) {
    return $ae5f89a650265493$export$2c43cb57a48fae33.includes(color);
}




var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");

const $ca36849cc3e4c7a0$export$8d6531175688484b = (value)=>Math.round(Number(value || 0));
const $ca36849cc3e4c7a0$var$convertHsb2Hsv = (color)=>{
    if (color instanceof (0, $cbc85b6187a98a9b$export$2c4f38d6c0ecc25a)) return color;
    if (color && typeof color === 'object' && 'h' in color && 'b' in color) {
        const { b: b, ...resets } = color;
        return {
            ...resets,
            v: b
        };
    }
    if (typeof color === 'string' && /hsb/.test(color)) return color.replace(/hsb/, 'hsv');
    return color;
};
class $ca36849cc3e4c7a0$export$892596cec99bc70e extends (0, $cbc85b6187a98a9b$export$2c4f38d6c0ecc25a) {
    constructor(color){
        super($ca36849cc3e4c7a0$var$convertHsb2Hsv(color));
    }
    toHsbString() {
        const hsb = this.toHsb();
        const saturation = $ca36849cc3e4c7a0$export$8d6531175688484b(hsb.s * 100);
        const lightness = $ca36849cc3e4c7a0$export$8d6531175688484b(hsb.b * 100);
        const hue = $ca36849cc3e4c7a0$export$8d6531175688484b(hsb.h);
        const alpha = hsb.a;
        const hsbString = `hsb(${hue}, ${saturation}%, ${lightness}%)`;
        const hsbaString = `hsba(${hue}, ${saturation}%, ${lightness}%, ${alpha.toFixed(alpha === 0 ? 0 : 2)})`;
        return alpha === 1 ? hsbString : hsbaString;
    }
    toHsb() {
        const { v: v, ...resets } = this.toHsv();
        return {
            ...resets,
            b: v,
            a: this.a
        };
    }
}


const $0a6667ff00f90c75$export$90004e2badfbdf1f = 'rc-color-picker';
const $0a6667ff00f90c75$export$c844f5d21427d1ab = (color)=>{
    if (color instanceof (0, $ca36849cc3e4c7a0$export$892596cec99bc70e)) return color;
    return new (0, $ca36849cc3e4c7a0$export$892596cec99bc70e)(color);
};
const $0a6667ff00f90c75$export$f705f0fde43a55a = $0a6667ff00f90c75$export$c844f5d21427d1ab('#1677ff');
const $0a6667ff00f90c75$export$3a7095e9fd85a71d = (props)=>{
    const { offset: offset, targetRef: targetRef, containerRef: containerRef, color: color, type: type } = props;
    const { width: width, height: height } = containerRef.current.getBoundingClientRect();
    const { width: targetWidth, height: targetHeight } = targetRef.current.getBoundingClientRect();
    const centerOffsetX = targetWidth / 2;
    const centerOffsetY = targetHeight / 2;
    const saturation = (offset.x + centerOffsetX) / width;
    const bright = 1 - (offset.y + centerOffsetY) / height;
    const hsb = color.toHsb();
    const alphaOffset = saturation;
    const hueOffset = (offset.x + centerOffsetX) / width * 360;
    if (type) switch(type){
        case 'hue':
            return $0a6667ff00f90c75$export$c844f5d21427d1ab({
                ...hsb,
                h: hueOffset <= 0 ? 0 : hueOffset
            });
        case 'alpha':
            return $0a6667ff00f90c75$export$c844f5d21427d1ab({
                ...hsb,
                a: alphaOffset <= 0 ? 0 : alphaOffset
            });
    }
    return $0a6667ff00f90c75$export$c844f5d21427d1ab({
        h: hsb.h,
        s: saturation <= 0 ? 0 : saturation,
        b: bright >= 1 ? 1 : bright,
        a: hsb.a
    });
};
const $0a6667ff00f90c75$export$20165527867cbf14 = (color, type)=>{
    const hsb = color.toHsb();
    switch(type){
        case 'hue':
            return {
                x: hsb.h / 360 * 100,
                y: 50
            };
        case 'alpha':
            return {
                x: color.a * 100,
                y: 50
            };
        // Picker panel
        default:
            return {
                x: hsb.s * 100,
                y: (1 - hsb.b) * 100
            };
    }
};






var $N3oW3 = parcelRequire("N3oW3");
const $d281f14c041ccf6a$var$ColorBlock = ({ color: color, prefixCls: prefixCls, className: className, style: style, onClick: onClick })=>{
    const colorBlockCls = `${prefixCls}-color-block`;
    return /*#__PURE__*/ (0, $N3oW3.default).createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(colorBlockCls, className),
        style: style,
        onClick: onClick
    }, /*#__PURE__*/ (0, $N3oW3.default).createElement("div", {
        className: `${colorBlockCls}-inner`,
        style: {
            background: color
        }
    }));
};
var $d281f14c041ccf6a$export$2e2bcd8739ae039 = $d281f14c041ccf6a$var$ColorBlock;



var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
function $3bc65f73782293e9$var$getPosition(e) {
    const obj = 'touches' in e ? e.touches[0] : e;
    const scrollXOffset = document.documentElement.scrollLeft || document.body.scrollLeft || window.pageXOffset;
    const scrollYOffset = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
    return {
        pageX: obj.pageX - scrollXOffset,
        pageY: obj.pageY - scrollYOffset
    };
}
function $3bc65f73782293e9$var$useColorDrag(props) {
    const { targetRef: targetRef, containerRef: containerRef, direction: direction, onDragChange: onDragChange, onDragChangeComplete: onDragChangeComplete, calculate: calculate, color: color, disabledDrag: disabledDrag } = props;
    const [offsetValue, setOffsetValue] = (0, $32rMB.useState)({
        x: 0,
        y: 0
    });
    const mouseMoveRef = (0, $32rMB.useRef)(null);
    const mouseUpRef = (0, $32rMB.useRef)(null);
    // Always get position from `color`
    (0, $32rMB.useEffect)(()=>{
        setOffsetValue(calculate());
    }, [
        color
    ]);
    (0, $32rMB.useEffect)(()=>()=>{
            document.removeEventListener('mousemove', mouseMoveRef.current);
            document.removeEventListener('mouseup', mouseUpRef.current);
            document.removeEventListener('touchmove', mouseMoveRef.current);
            document.removeEventListener('touchend', mouseUpRef.current);
            mouseMoveRef.current = null;
            mouseUpRef.current = null;
        }, []);
    const updateOffset = (e)=>{
        const { pageX: pageX, pageY: pageY } = $3bc65f73782293e9$var$getPosition(e);
        const { x: rectX, y: rectY, width: width, height: height } = containerRef.current.getBoundingClientRect();
        const { width: targetWidth, height: targetHeight } = targetRef.current.getBoundingClientRect();
        const centerOffsetX = targetWidth / 2;
        const centerOffsetY = targetHeight / 2;
        const offsetX = Math.max(0, Math.min(pageX - rectX, width)) - centerOffsetX;
        const offsetY = Math.max(0, Math.min(pageY - rectY, height)) - centerOffsetY;
        const calcOffset = {
            x: offsetX,
            y: direction === 'x' ? offsetValue.y : offsetY
        };
        // Exclusion of boundary cases
        if (targetWidth === 0 && targetHeight === 0 || targetWidth !== targetHeight) return false;
        onDragChange?.(calcOffset);
    };
    const onDragMove = (e)=>{
        e.preventDefault();
        updateOffset(e);
    };
    const onDragStop = (e)=>{
        e.preventDefault();
        document.removeEventListener('mousemove', mouseMoveRef.current);
        document.removeEventListener('mouseup', mouseUpRef.current);
        document.removeEventListener('touchmove', mouseMoveRef.current);
        document.removeEventListener('touchend', mouseUpRef.current);
        mouseMoveRef.current = null;
        mouseUpRef.current = null;
        onDragChangeComplete?.();
    };
    const onDragStart = (e)=>{
        // https://github.com/ant-design/ant-design/issues/43529
        document.removeEventListener('mousemove', mouseMoveRef.current);
        document.removeEventListener('mouseup', mouseUpRef.current);
        if (disabledDrag) return;
        updateOffset(e);
        document.addEventListener('mousemove', onDragMove);
        document.addEventListener('mouseup', onDragStop);
        document.addEventListener('touchmove', onDragMove);
        document.addEventListener('touchend', onDragStop);
        mouseMoveRef.current = onDragMove;
        mouseUpRef.current = onDragStop;
    };
    return [
        offsetValue,
        onDragStart
    ];
}
var $3bc65f73782293e9$export$2e2bcd8739ae039 = $3bc65f73782293e9$var$useColorDrag;






var $N3oW3 = parcelRequire("N3oW3");
const $86a8853011b79c43$var$Handler = ({ size: size = 'default', color: color, prefixCls: prefixCls })=>{
    return /*#__PURE__*/ (0, $N3oW3.default).createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-handler`, {
            [`${prefixCls}-handler-sm`]: size === 'small'
        }),
        style: {
            backgroundColor: color
        }
    });
};
var $86a8853011b79c43$export$2e2bcd8739ae039 = $86a8853011b79c43$var$Handler;



var $N3oW3 = parcelRequire("N3oW3");
const $f34853eeeb8ae4fa$var$Palette = ({ children: children, style: style, prefixCls: prefixCls })=>{
    return /*#__PURE__*/ (0, $N3oW3.default).createElement("div", {
        className: `${prefixCls}-palette`,
        style: {
            position: 'relative',
            ...style
        }
    }, children);
};
var $f34853eeeb8ae4fa$export$2e2bcd8739ae039 = $f34853eeeb8ae4fa$var$Palette;



var $N3oW3 = parcelRequire("N3oW3");
const $64d14c70bfdca965$var$Transform = /*#__PURE__*/ (0, $N3oW3.forwardRef)((props, ref)=>{
    const { children: children, x: x, y: y } = props;
    return /*#__PURE__*/ (0, $N3oW3.default).createElement("div", {
        ref: ref,
        style: {
            position: 'absolute',
            left: `${x}%`,
            top: `${y}%`,
            zIndex: 1,
            transform: 'translate(-50%, -50%)'
        }
    }, children);
});
var $64d14c70bfdca965$export$2e2bcd8739ae039 = $64d14c70bfdca965$var$Transform;


const $fc340841c0905a68$var$Picker = ({ color: color, onChange: onChange, prefixCls: prefixCls, onChangeComplete: onChangeComplete, disabled: disabled })=>{
    const pickerRef = (0, $32rMB.useRef)();
    const transformRef = (0, $32rMB.useRef)();
    const colorRef = (0, $32rMB.useRef)(color);
    const onDragChange = (0, $ea93068db096b7d6$export$2e2bcd8739ae039)((offsetValue)=>{
        const calcColor = (0, $0a6667ff00f90c75$export$3a7095e9fd85a71d)({
            offset: offsetValue,
            targetRef: transformRef,
            containerRef: pickerRef,
            color: color
        });
        colorRef.current = calcColor;
        onChange(calcColor);
    });
    const [offset, dragStartHandle] = (0, $3bc65f73782293e9$export$2e2bcd8739ae039)({
        color: color,
        containerRef: pickerRef,
        targetRef: transformRef,
        calculate: ()=>(0, $0a6667ff00f90c75$export$20165527867cbf14)(color),
        onDragChange: onDragChange,
        onDragChangeComplete: ()=>onChangeComplete?.(colorRef.current),
        disabledDrag: disabled
    });
    return /*#__PURE__*/ (0, $N3oW3.default).createElement("div", {
        ref: pickerRef,
        className: `${prefixCls}-select`,
        onMouseDown: dragStartHandle,
        onTouchStart: dragStartHandle
    }, /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $f34853eeeb8ae4fa$export$2e2bcd8739ae039), {
        prefixCls: prefixCls
    }, /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $64d14c70bfdca965$export$2e2bcd8739ae039), {
        x: offset.x,
        y: offset.y,
        ref: transformRef
    }, /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $86a8853011b79c43$export$2e2bcd8739ae039), {
        color: color.toRgbString(),
        prefixCls: prefixCls
    })), /*#__PURE__*/ (0, $N3oW3.default).createElement("div", {
        className: `${prefixCls}-saturation`,
        style: {
            backgroundColor: `hsl(${color.toHsb().h},100%, 50%)`,
            backgroundImage: 'linear-gradient(0deg, #000, transparent),linear-gradient(90deg, #fff, hsla(0, 0%, 100%, 0))'
        }
    })));
};
var $fc340841c0905a68$export$2e2bcd8739ae039 = $fc340841c0905a68$var$Picker;



parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");

const $08526b757440b5fc$var$useColorState = (defaultValue, value)=>{
    const [mergedValue, setValue] = (0, $05ea6e97cee440ee$export$2e2bcd8739ae039)(defaultValue, value);
    const color = (0, $32rMB.useMemo)(()=>(0, $0a6667ff00f90c75$export$c844f5d21427d1ab)(mergedValue), [
        mergedValue
    ]);
    return [
        color,
        setValue
    ];
};
var $08526b757440b5fc$export$2e2bcd8739ae039 = $08526b757440b5fc$var$useColorState;


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");

var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");







var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");


const $e7e7adfef679aba1$var$Gradient = ({ colors: colors, children: children, direction: direction = 'to right', type: type, prefixCls: prefixCls })=>{
    const gradientColors = (0, $32rMB.useMemo)(()=>colors.map((color, idx)=>{
            let result = (0, $0a6667ff00f90c75$export$c844f5d21427d1ab)(color);
            if (type === 'alpha' && idx === colors.length - 1) result = new (0, $ca36849cc3e4c7a0$export$892596cec99bc70e)(result.setA(1));
            return result.toRgbString();
        }).join(','), [
        colors,
        type
    ]);
    return /*#__PURE__*/ (0, $N3oW3.default).createElement("div", {
        className: `${prefixCls}-gradient`,
        style: {
            position: 'absolute',
            inset: 0,
            background: `linear-gradient(${direction}, ${gradientColors})`
        }
    }, children);
};
var $e7e7adfef679aba1$export$2e2bcd8739ae039 = $e7e7adfef679aba1$var$Gradient;




const $b5c060457aaa8f79$var$Slider = (props)=>{
    const { prefixCls: prefixCls, colors: colors, disabled: disabled, onChange: onChange, onChangeComplete: onChangeComplete, color: color, type: type } = props;
    const sliderRef = (0, $32rMB.useRef)(null);
    const transformRef = (0, $32rMB.useRef)(null);
    const colorRef = (0, $32rMB.useRef)(color);
    const getValue = (c)=>{
        return type === 'hue' ? c.getHue() : c.a * 100;
    };
    const onDragChange = (0, $ea93068db096b7d6$export$2e2bcd8739ae039)((offsetValue)=>{
        const calcColor = (0, $0a6667ff00f90c75$export$3a7095e9fd85a71d)({
            offset: offsetValue,
            targetRef: transformRef,
            containerRef: sliderRef,
            color: color,
            type: type
        });
        colorRef.current = calcColor;
        onChange(getValue(calcColor));
    });
    const [offset, dragStartHandle] = (0, $3bc65f73782293e9$export$2e2bcd8739ae039)({
        color: color,
        targetRef: transformRef,
        containerRef: sliderRef,
        calculate: ()=>(0, $0a6667ff00f90c75$export$20165527867cbf14)(color, type),
        onDragChange: onDragChange,
        onDragChangeComplete () {
            onChangeComplete(getValue(colorRef.current));
        },
        direction: 'x',
        disabledDrag: disabled
    });
    const handleColor = (0, $N3oW3.default).useMemo(()=>{
        if (type === 'hue') {
            const hsb = color.toHsb();
            hsb.s = 1;
            hsb.b = 1;
            hsb.a = 1;
            const lightColor = new (0, $ca36849cc3e4c7a0$export$892596cec99bc70e)(hsb);
            return lightColor;
        }
        return color;
    }, [
        color,
        type
    ]);
    // ========================= Gradient =========================
    const gradientList = (0, $N3oW3.default).useMemo(()=>colors.map((info)=>`${info.color} ${info.percent}%`), [
        colors
    ]);
    // ========================== Render ==========================
    return /*#__PURE__*/ (0, $N3oW3.default).createElement("div", {
        ref: sliderRef,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-slider`, `${prefixCls}-slider-${type}`),
        onMouseDown: dragStartHandle,
        onTouchStart: dragStartHandle
    }, /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $f34853eeeb8ae4fa$export$2e2bcd8739ae039), {
        prefixCls: prefixCls
    }, /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $64d14c70bfdca965$export$2e2bcd8739ae039), {
        x: offset.x,
        y: offset.y,
        ref: transformRef
    }, /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $86a8853011b79c43$export$2e2bcd8739ae039), {
        size: "small",
        color: handleColor.toHexString(),
        prefixCls: prefixCls
    })), /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $e7e7adfef679aba1$export$2e2bcd8739ae039), {
        colors: gradientList,
        type: type,
        prefixCls: prefixCls
    })));
};
var $b5c060457aaa8f79$export$2e2bcd8739ae039 = $b5c060457aaa8f79$var$Slider;


function $f02aa43da215b2dd$export$2e2bcd8739ae039(components) {
    return $32rMB.useMemo(()=>{
        const { slider: slider } = components || {};
        return [
            slider || (0, $b5c060457aaa8f79$export$2e2bcd8739ae039)
        ];
    }, [
        components
    ]);
}


function $68e24b62074ecf76$var$_extends() {
    $68e24b62074ecf76$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $68e24b62074ecf76$var$_extends.apply(this, arguments);
}
const $68e24b62074ecf76$var$HUE_COLORS = [
    {
        color: 'rgb(255, 0, 0)',
        percent: 0
    },
    {
        color: 'rgb(255, 255, 0)',
        percent: 17
    },
    {
        color: 'rgb(0, 255, 0)',
        percent: 33
    },
    {
        color: 'rgb(0, 255, 255)',
        percent: 50
    },
    {
        color: 'rgb(0, 0, 255)',
        percent: 67
    },
    {
        color: 'rgb(255, 0, 255)',
        percent: 83
    },
    {
        color: 'rgb(255, 0, 0)',
        percent: 100
    }
];
const $68e24b62074ecf76$var$ColorPicker = /*#__PURE__*/ (0, $N3oW3.forwardRef)((props, ref)=>{
    const { value: value, defaultValue: defaultValue, prefixCls: prefixCls = (0, $0a6667ff00f90c75$export$90004e2badfbdf1f), onChange: onChange, onChangeComplete: onChangeComplete, className: className, style: style, panelRender: panelRender, disabledAlpha: disabledAlpha = false, disabled: disabled = false, components: components } = props;
    // ========================== Components ==========================
    const [Slider] = (0, $f02aa43da215b2dd$export$2e2bcd8739ae039)(components);
    // ============================ Color =============================
    const [colorValue, setColorValue] = (0, $08526b757440b5fc$export$2e2bcd8739ae039)(defaultValue || (0, $0a6667ff00f90c75$export$f705f0fde43a55a), value);
    const alphaColor = (0, $32rMB.useMemo)(()=>colorValue.setA(1).toRgbString(), [
        colorValue
    ]);
    // ============================ Events ============================
    const handleChange = (data, type)=>{
        if (!value) setColorValue(data);
        onChange?.(data, type);
    };
    // Convert
    const getHueColor = (hue)=>new (0, $ca36849cc3e4c7a0$export$892596cec99bc70e)(colorValue.setHue(hue));
    const getAlphaColor = (alpha)=>new (0, $ca36849cc3e4c7a0$export$892596cec99bc70e)(colorValue.setA(alpha / 100));
    // Slider change
    const onHueChange = (hue)=>{
        handleChange(getHueColor(hue), {
            type: 'hue',
            value: hue
        });
    };
    const onAlphaChange = (alpha)=>{
        handleChange(getAlphaColor(alpha), {
            type: 'alpha',
            value: alpha
        });
    };
    // Complete
    const onHueChangeComplete = (hue)=>{
        if (onChangeComplete) onChangeComplete(getHueColor(hue));
    };
    const onAlphaChangeComplete = (alpha)=>{
        if (onChangeComplete) onChangeComplete(getAlphaColor(alpha));
    };
    // ============================ Render ============================
    const mergeCls = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-panel`, className, {
        [`${prefixCls}-panel-disabled`]: disabled
    });
    const sharedSliderProps = {
        prefixCls: prefixCls,
        disabled: disabled,
        color: colorValue
    };
    const defaultPanel = /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $N3oW3.default).Fragment, null, /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $fc340841c0905a68$export$2e2bcd8739ae039), $68e24b62074ecf76$var$_extends({
        onChange: handleChange
    }, sharedSliderProps, {
        onChangeComplete: onChangeComplete
    })), /*#__PURE__*/ (0, $N3oW3.default).createElement("div", {
        className: `${prefixCls}-slider-container`
    }, /*#__PURE__*/ (0, $N3oW3.default).createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-slider-group`, {
            [`${prefixCls}-slider-group-disabled-alpha`]: disabledAlpha
        })
    }, /*#__PURE__*/ (0, $N3oW3.default).createElement(Slider, $68e24b62074ecf76$var$_extends({}, sharedSliderProps, {
        type: "hue",
        colors: $68e24b62074ecf76$var$HUE_COLORS,
        min: 0,
        max: 359,
        value: colorValue.getHue(),
        onChange: onHueChange,
        onChangeComplete: onHueChangeComplete
    })), !disabledAlpha && /*#__PURE__*/ (0, $N3oW3.default).createElement(Slider, $68e24b62074ecf76$var$_extends({}, sharedSliderProps, {
        type: "alpha",
        colors: [
            {
                percent: 0,
                color: 'rgba(255, 0, 4, 0)'
            },
            {
                percent: 100,
                color: alphaColor
            }
        ],
        min: 0,
        max: 100,
        value: colorValue.a * 100,
        onChange: onAlphaChange,
        onChangeComplete: onAlphaChangeComplete
    }))), /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $d281f14c041ccf6a$export$2e2bcd8739ae039), {
        color: colorValue.toRgbString(),
        prefixCls: prefixCls
    })));
    return /*#__PURE__*/ (0, $N3oW3.default).createElement("div", {
        className: mergeCls,
        style: style,
        ref: ref
    }, typeof panelRender === 'function' ? panelRender(defaultPanel) : defaultPanel);
});
var $68e24b62074ecf76$export$2e2bcd8739ae039 = $68e24b62074ecf76$var$ColorPicker;






var $0db1669b9551b72d$export$2e2bcd8739ae039 = (0, $68e24b62074ecf76$export$2e2bcd8739ae039);





const $218ce3eb00027935$export$d0aa8b5e56c9af06 = (value, alpha)=>value?.replace(/[^\w/]/g, '').slice(0, alpha ? 8 : 6) || '';
const $218ce3eb00027935$export$6c90ef703dcfba25 = (value, alpha)=>value ? $218ce3eb00027935$export$d0aa8b5e56c9af06(value, alpha) : '';
let $218ce3eb00027935$export$e8cc8a2e87e145b4 = /*#__PURE__*/ function() {
    function AggregationColor(color) {
        (0, $c27a1e671724260e$export$2e2bcd8739ae039)(this, AggregationColor);
        this.cleared = false;
        // Clone from another AggregationColor
        if (color instanceof AggregationColor) {
            this.metaColor = color.metaColor.clone();
            this.colors = color.colors?.map((info)=>({
                    color: new AggregationColor(info.color),
                    percent: info.percent
                }));
            this.cleared = color.cleared;
            return;
        }
        const isArray = Array.isArray(color);
        if (isArray && color.length) {
            this.colors = color.map(({ color: c, percent: percent })=>({
                    color: new AggregationColor(c),
                    percent: percent
                }));
            this.metaColor = new (0, $ca36849cc3e4c7a0$export$892596cec99bc70e)(this.colors[0].color.metaColor);
        } else this.metaColor = new (0, $ca36849cc3e4c7a0$export$892596cec99bc70e)(isArray ? '' : color);
        if (!color || isArray && !this.colors) {
            this.metaColor = this.metaColor.setA(0);
            this.cleared = true;
        }
    }
    return (0, $3d68cfa6e8f65ecd$export$2e2bcd8739ae039)(AggregationColor, [
        {
            key: "toHsb",
            value: function toHsb() {
                return this.metaColor.toHsb();
            }
        },
        {
            key: "toHsbString",
            value: function toHsbString() {
                return this.metaColor.toHsbString();
            }
        },
        {
            key: "toHex",
            value: function toHex() {
                return $218ce3eb00027935$export$6c90ef703dcfba25(this.toHexString(), this.metaColor.a < 1);
            }
        },
        {
            key: "toHexString",
            value: function toHexString() {
                return this.metaColor.toHexString();
            }
        },
        {
            key: "toRgb",
            value: function toRgb() {
                return this.metaColor.toRgb();
            }
        },
        {
            key: "toRgbString",
            value: function toRgbString() {
                return this.metaColor.toRgbString();
            }
        },
        {
            key: "isGradient",
            value: function isGradient() {
                return !!this.colors && !this.cleared;
            }
        },
        {
            key: "getColors",
            value: function getColors() {
                return this.colors || [
                    {
                        color: this,
                        percent: 0
                    }
                ];
            }
        },
        {
            key: "toCssString",
            value: function toCssString() {
                const { colors: colors } = this;
                // CSS line-gradient
                if (colors) {
                    const colorsStr = colors.map((c)=>`${c.color.toRgbString()} ${c.percent}%`).join(', ');
                    return `linear-gradient(90deg, ${colorsStr})`;
                }
                return this.metaColor.toRgbString();
            }
        },
        {
            key: "equals",
            value: function equals(color) {
                if (!color || this.isGradient() !== color.isGradient()) return false;
                if (!this.isGradient()) return this.toHexString() === color.toHexString();
                return this.colors.length === color.colors.length && this.colors.every((c, i)=>{
                    const target = color.colors[i];
                    return c.percent === target.percent && c.color.equals(target.color);
                });
            }
        }
    ]);
}();


const $44c1040567028aeb$export$c844f5d21427d1ab = (color)=>{
    if (color instanceof (0, $218ce3eb00027935$export$e8cc8a2e87e145b4)) return color;
    return new (0, $218ce3eb00027935$export$e8cc8a2e87e145b4)(color);
};
const $44c1040567028aeb$export$8d6531175688484b = (value)=>Math.round(Number(value || 0));
const $44c1040567028aeb$export$3c8ae3c73ab0e52a = (color)=>$44c1040567028aeb$export$8d6531175688484b(color.toHsb().a * 100);
const $44c1040567028aeb$export$f04e5f54cfbb466c = (color, alpha)=>{
    const rgba = color.toRgb();
    // Color from hsb input may get `rgb` is (0/0/0) when `hsb.b` is 0
    // So if rgb is empty, we should get from hsb
    if (!rgba.r && !rgba.g && !rgba.b) {
        const hsba = color.toHsb();
        hsba.a = alpha || 1;
        return $44c1040567028aeb$export$c844f5d21427d1ab(hsba);
    }
    rgba.a = alpha || 1;
    return $44c1040567028aeb$export$c844f5d21427d1ab(rgba);
};
const $44c1040567028aeb$export$9dd6bfe648e14e97 = (colors, percent)=>{
    const filledColors = [
        {
            percent: 0,
            color: colors[0].color
        }
    ].concat((0, $3746fb019e1f2ee5$export$2e2bcd8739ae039)(colors), [
        {
            percent: 100,
            color: colors[colors.length - 1].color
        }
    ]);
    for(let i = 0; i < filledColors.length - 1; i += 1){
        const startPtg = filledColors[i].percent;
        const endPtg = filledColors[i + 1].percent;
        const startColor = filledColors[i].color;
        const endColor = filledColors[i + 1].color;
        if (startPtg <= percent && percent <= endPtg) {
            const dist = endPtg - startPtg;
            if (dist === 0) return startColor;
            const ratio = (percent - startPtg) / dist * 100;
            const startRcColor = new (0, $ca36849cc3e4c7a0$export$892596cec99bc70e)(startColor);
            const endRcColor = new (0, $ca36849cc3e4c7a0$export$892596cec99bc70e)(endColor);
            return startRcColor.mix(endRcColor, ratio).toRgbString();
        }
    }
    // This will never reach
    /* istanbul ignore next */ return '';
};


function $5b1798f60923350c$export$6e865ea70d7724f(prefixCls, color) {
    const isInternalColor = (0, $ae5f89a650265493$export$ee62ebd6a58c4884)(color);
    const className = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)({
        [`${prefixCls}-${color}`]: color && isInternalColor
    });
    const overlayStyle = {};
    const arrowStyle = {};
    const rgb = (0, $44c1040567028aeb$export$c844f5d21427d1ab)(color).toRgb();
    const luminance = (0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b) / 255;
    const textColor = luminance < 0.5 ? '#FFF' : '#000';
    if (color && !isInternalColor) {
        overlayStyle.background = color;
        overlayStyle['--ant-tooltip-color'] = textColor;
        // @ts-ignore
        arrowStyle['--antd-arrow-background-color'] = color;
    }
    return {
        className: className,
        overlayStyle: overlayStyle,
        arrowStyle: arrowStyle
    };
}


"use client";
/** @private Internal Component. Do not use in your production. */ const $c13e477fec4d5615$var$PurePanel = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, placement: placement = 'top', title: title, color: color, overlayInnerStyle: overlayInnerStyle, classNames: classNames, styles: styles } = props;
    const { getPrefixCls: getPrefixCls } = $32rMB.useContext((0, $dd01e2f5a4b8605d$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('tooltip', customizePrefixCls);
    const rootCls = (0, $54b1aecddbbbed4f$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $24429bfd5b936d93$export$2e2bcd8739ae039)(prefixCls, rootCls);
    // Color
    const colorInfo = (0, $5b1798f60923350c$export$6e865ea70d7724f)(prefixCls, color);
    const arrowContentStyle = colorInfo.arrowStyle;
    const innerStyles = $32rMB.useMemo(()=>{
        const mergedStyle = {
            ...overlayInnerStyle,
            ...colorInfo.overlayStyle
        };
        return {
            container: mergedStyle
        };
    }, [
        overlayInnerStyle,
        colorInfo.overlayStyle
    ]);
    const mergedProps = {
        ...props,
        placement: placement
    };
    const [mergedClassNames, mergedStyles] = (0, $4dcf69d8c3d6df5c$export$648566b068f28737)([
        classNames
    ], [
        innerStyles,
        styles
    ], {
        props: mergedProps
    });
    const rootClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(rootCls, hashId, cssVarCls, prefixCls, `${prefixCls}-pure`, `${prefixCls}-placement-${placement}`, className, colorInfo.className);
    return /*#__PURE__*/ $hO8yS.createElement("div", {
        className: rootClassName,
        style: arrowContentStyle
    }, /*#__PURE__*/ $hO8yS.createElement("div", {
        className: `${prefixCls}-arrow`
    }), /*#__PURE__*/ $hO8yS.createElement((0, $c1d4e2f940b8a598$export$2e2bcd8739ae039), {
        ...props,
        className: hashId,
        prefixCls: prefixCls,
        classNames: mergedClassNames,
        styles: mergedStyles
    }, title));
};
var $c13e477fec4d5615$export$2e2bcd8739ae039 = $c13e477fec4d5615$var$PurePanel;





"use client";
const $bdb14b445459ab9d$var$InternalTooltip = /*#__PURE__*/ $N3oW3.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, openClassName: openClassName, getTooltipContainer: getTooltipContainer, color: color, children: children, afterOpenChange: afterOpenChange, arrow: tooltipArrow, destroyTooltipOnHide: destroyTooltipOnHide, destroyOnHidden: destroyOnHidden, title: title, overlay: overlay, builtinPlacements: builtinPlacements, autoAdjustOverflow: autoAdjustOverflow = true, motion: motion, getPopupContainer: getPopupContainer, placement: placement = 'top', mouseEnterDelay: mouseEnterDelay = 0.1, mouseLeaveDelay: mouseLeaveDelay = 0.1, rootClassName: rootClassName, styles: styles, classNames: classNames, onOpenChange: onOpenChange, overlayInnerStyle: // Legacy
    overlayInnerStyle, overlayStyle: overlayStyle, overlayClassName: overlayClassName, ...restProps } = props;
    const [, token] = (0, $9481722d146bd166$export$2e2bcd8739ae039)();
    const { getPopupContainer: getContextPopupContainer, getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles, arrow: contextArrow } = (0, $dd01e2f5a4b8605d$export$46f4bd6436a25a31)('tooltip');
    const mergedArrow = (0, $6993852e4088d6b2$export$2e2bcd8739ae039)(tooltipArrow, contextArrow);
    const mergedShowArrow = mergedArrow.show;
    // ============================== Ref ===============================
    const warning = (0, $d41680c8243eac18$export$cf977aa92c751e61)('Tooltip');
    const tooltipRef = $32rMB.useRef(null);
    const forceAlign = ()=>{
        tooltipRef.current?.forceAlign();
    };
    $32rMB.useImperativeHandle(ref, ()=>({
            forceAlign: forceAlign,
            nativeElement: tooltipRef.current?.nativeElement,
            popupElement: tooltipRef.current?.popupElement
        }));
    var deprecatedName, newName;
    // ============================== Open ==============================
    const [open, setOpen] = (0, $05ea6e97cee440ee$export$2e2bcd8739ae039)(props.defaultOpen ?? false, props.open);
    const noTitle = !title && !overlay && title !== 0; // overlay for old version compatibility
    const onInternalOpenChange = (vis)=>{
        setOpen(noTitle ? false : vis);
        if (!noTitle && onOpenChange) onOpenChange(vis);
    };
    const tooltipPlacements = $32rMB.useMemo(()=>{
        return builtinPlacements || (0, $e523ba814abcafb5$export$2e2bcd8739ae039)({
            arrowPointAtCenter: mergedArrow?.pointAtCenter ?? false,
            autoAdjustOverflow: autoAdjustOverflow,
            arrowWidth: mergedShowArrow ? token.sizePopupArrow : 0,
            borderRadius: token.borderRadius,
            offset: token.marginXXS,
            visibleFirst: true
        });
    }, [
        mergedArrow,
        builtinPlacements,
        token,
        mergedShowArrow,
        autoAdjustOverflow
    ]);
    const memoOverlay = $32rMB.useMemo(()=>{
        if (title === 0) return title;
        return overlay || title || '';
    }, [
        overlay,
        title
    ]);
    const memoOverlayWrapper = /*#__PURE__*/ $hO8yS.createElement((0, $8a9bb3ef8b2b36aa$export$2e2bcd8739ae039), {
        space: true
    }, typeof memoOverlay === 'function' ? memoOverlay() : memoOverlay);
    // =========== Merged Props for Semantic ===========
    const mergedProps = {
        ...props,
        color: color,
        placement: placement,
        builtinPlacements: builtinPlacements,
        openClassName: openClassName,
        arrow: tooltipArrow,
        autoAdjustOverflow: autoAdjustOverflow,
        getPopupContainer: getPopupContainer,
        children: children,
        destroyTooltipOnHide: destroyTooltipOnHide,
        destroyOnHidden: destroyOnHidden
    };
    const [mergedClassNames, mergedStyles] = (0, $4dcf69d8c3d6df5c$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    const prefixCls = getPrefixCls('tooltip', customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    const injectFromPopover = props['data-popover-inject'];
    let tempOpen = open;
    // Hide tooltip when there is no title
    if (!('open' in props) && noTitle) tempOpen = false;
    // ============================= Render =============================
    const child = /*#__PURE__*/ $N3oW3.isValidElement(children) && !(0, $62609775897a768c$export$9522e17588c12572)(children) ? children : /*#__PURE__*/ $hO8yS.createElement("span", null, children);
    const childProps = child.props;
    const childCls = !childProps.className || typeof childProps.className === 'string' ? (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(childProps.className, openClassName || `${prefixCls}-open`) : childProps.className;
    // Style
    const rootCls = (0, $54b1aecddbbbed4f$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $24429bfd5b936d93$export$2e2bcd8739ae039)(prefixCls, rootCls, !injectFromPopover);
    // Color
    const colorInfo = (0, $5b1798f60923350c$export$6e865ea70d7724f)(prefixCls, color);
    const arrowContentStyle = colorInfo.arrowStyle;
    const themeCls = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(rootCls, hashId, cssVarCls);
    const rootClassNames = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(overlayClassName, {
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, colorInfo.className, rootClassName, themeCls, contextClassName, mergedClassNames.root);
    // ============================ zIndex ============================
    const [zIndex, contextZIndex] = (0, $15dbea5a917a06ef$export$3e7906d4075187a4)('Tooltip', restProps.zIndex);
    const containerStyle = {
        ...mergedStyles.container,
        ...overlayInnerStyle,
        ...colorInfo.overlayStyle
    };
    const content = /*#__PURE__*/ $hO8yS.createElement((0, $b2dc4dd58ddb6a64$export$2e2bcd8739ae039), {
        unique: true,
        ...restProps,
        zIndex: zIndex,
        showArrow: mergedShowArrow,
        placement: placement,
        mouseEnterDelay: mouseEnterDelay,
        mouseLeaveDelay: mouseLeaveDelay,
        prefixCls: prefixCls,
        classNames: {
            root: rootClassNames,
            container: mergedClassNames.container,
            arrow: mergedClassNames.arrow,
            uniqueContainer: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(themeCls, mergedClassNames.container)
        },
        styles: {
            root: {
                ...arrowContentStyle,
                ...mergedStyles.root,
                ...contextStyle,
                ...overlayStyle
            },
            container: containerStyle,
            uniqueContainer: containerStyle,
            arrow: mergedStyles.arrow
        },
        getTooltipContainer: getPopupContainer || getTooltipContainer || getContextPopupContainer,
        ref: tooltipRef,
        builtinPlacements: tooltipPlacements,
        overlay: memoOverlayWrapper,
        visible: tempOpen,
        onVisibleChange: onInternalOpenChange,
        afterVisibleChange: afterOpenChange,
        arrowContent: /*#__PURE__*/ $hO8yS.createElement("span", {
            className: `${prefixCls}-arrow-content`
        }),
        motion: {
            motionName: (0, $689b5af26dd3c1cd$export$27c72201b1d09951)(rootPrefixCls, 'zoom-big-fast', typeof motion?.motionName === 'string' ? motion?.motionName : undefined),
            motionDeadline: 1000
        },
        destroyOnHidden: destroyOnHidden ?? !!destroyTooltipOnHide
    }, tempOpen ? (0, $62609775897a768c$export$e530037191fcd5d7)(child, {
        className: childCls
    }) : child);
    return /*#__PURE__*/ $hO8yS.createElement((0, $eb222ded4c5a3427$export$2e2bcd8739ae039).Provider, {
        value: contextZIndex
    }, content);
});
const $bdb14b445459ab9d$var$Tooltip = $bdb14b445459ab9d$var$InternalTooltip;
$bdb14b445459ab9d$var$Tooltip._InternalPanelDoNotUseOrYouWillBeFired = (0, $c13e477fec4d5615$export$2e2bcd8739ae039);
$bdb14b445459ab9d$var$Tooltip.UniqueProvider = (0, $280b6a0642f9eb46$export$2e2bcd8739ae039);
var $bdb14b445459ab9d$export$2e2bcd8739ae039 = $bdb14b445459ab9d$var$Tooltip;



parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");










const $968912ff9c4e3004$var$genBaseStyle = (token)=>{
    const { componentCls: componentCls, popoverColor: popoverColor, titleMinWidth: titleMinWidth, fontWeightStrong: fontWeightStrong, innerPadding: innerPadding, boxShadowSecondary: boxShadowSecondary, colorTextHeading: colorTextHeading, borderRadiusLG: borderRadiusLG, zIndexPopup: zIndexPopup, titleMarginBottom: titleMarginBottom, colorBgElevated: colorBgElevated, popoverBg: popoverBg, titleBorderBottom: titleBorderBottom, innerContentPadding: innerContentPadding, titlePadding: titlePadding } = token;
    return [
        {
            [componentCls]: {
                ...(0, $2f353af2b0f7600b$export$23997c3e44cc1c59)(token),
                position: 'absolute',
                top: 0,
                // use `left` to fix https://github.com/ant-design/ant-design/issues/39195
                left: {
                    _skip_check_: true,
                    value: 0
                },
                zIndex: zIndexPopup,
                fontWeight: 'normal',
                whiteSpace: 'normal',
                textAlign: 'start',
                cursor: 'auto',
                userSelect: 'text',
                // When use `autoArrow`, origin will follow the arrow position
                '--valid-offset-x': 'var(--arrow-offset-horizontal, var(--arrow-x))',
                transformOrigin: [
                    `var(--valid-offset-x, 50%)`,
                    `var(--arrow-y, 50%)`
                ].join(' '),
                '--antd-arrow-background-color': colorBgElevated,
                width: 'max-content',
                maxWidth: '100vw',
                '&-rtl': {
                    direction: 'rtl'
                },
                '&-hidden': {
                    display: 'none'
                },
                [`${componentCls}-content`]: {
                    position: 'relative'
                },
                [`${componentCls}-container`]: {
                    backgroundColor: popoverBg,
                    backgroundClip: 'padding-box',
                    borderRadius: borderRadiusLG,
                    boxShadow: boxShadowSecondary,
                    padding: innerPadding
                },
                [`${componentCls}-title`]: {
                    minWidth: titleMinWidth,
                    marginBottom: titleMarginBottom,
                    color: colorTextHeading,
                    fontWeight: fontWeightStrong,
                    borderBottom: titleBorderBottom,
                    padding: titlePadding
                },
                [`${componentCls}-content`]: {
                    color: popoverColor,
                    padding: innerContentPadding
                }
            }
        },
        // Arrow Style
        (0, $8d59d91a3e235d80$export$2e2bcd8739ae039)(token, 'var(--antd-arrow-background-color)'),
        // Pure Render
        {
            [`${componentCls}-pure`]: {
                position: 'relative',
                maxWidth: 'none',
                margin: token.sizePopupArrow,
                display: 'inline-block'
            }
        }
    ];
};
const $968912ff9c4e3004$var$genColorStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: (0, $81d4e816322e7f22$export$6d4fe3a00a1811ad).map((colorKey)=>{
            const lightColor = token[`${colorKey}6`];
            return {
                [`&${componentCls}-${colorKey}`]: {
                    '--antd-arrow-background-color': lightColor,
                    [`${componentCls}-inner`]: {
                        backgroundColor: lightColor
                    },
                    [`${componentCls}-arrow`]: {
                        background: 'transparent'
                    }
                }
            };
        })
    };
};
const $968912ff9c4e3004$export$9ca1be8807fe0675 = (token)=>{
    const { lineWidth: lineWidth, controlHeight: controlHeight, fontHeight: fontHeight, padding: padding, wireframe: wireframe, zIndexPopupBase: zIndexPopupBase, borderRadiusLG: borderRadiusLG, marginXS: marginXS, lineType: lineType, colorSplit: colorSplit, paddingSM: paddingSM } = token;
    const titlePaddingBlockDist = controlHeight - fontHeight;
    const popoverTitlePaddingBlockTop = titlePaddingBlockDist / 2;
    const popoverTitlePaddingBlockBottom = titlePaddingBlockDist / 2 - lineWidth;
    const popoverPaddingHorizontal = padding;
    return {
        titleMinWidth: 177,
        zIndexPopup: zIndexPopupBase + 30,
        ...(0, $129ab988bfbe5ce1$export$87e38ee403661ccc)(token),
        ...(0, $8d59d91a3e235d80$export$bddc192327bb9823)({
            contentRadius: borderRadiusLG,
            limitVerticalRadius: true
        }),
        // internal
        innerPadding: wireframe ? 0 : 12,
        titleMarginBottom: wireframe ? 0 : marginXS,
        titlePadding: wireframe ? `${popoverTitlePaddingBlockTop}px ${popoverPaddingHorizontal}px ${popoverTitlePaddingBlockBottom}px` : 0,
        titleBorderBottom: wireframe ? `${lineWidth}px ${lineType} ${colorSplit}` : 'none',
        innerContentPadding: wireframe ? `${paddingSM}px ${popoverPaddingHorizontal}px` : 0
    };
};
var $968912ff9c4e3004$export$2e2bcd8739ae039 = (0, $d4a2dc313c4d90a4$export$51ec95de45185b42)('Popover', (token)=>{
    const { colorBgElevated: colorBgElevated, colorText: colorText } = token;
    const popoverToken = (0, $90c11ca6cb263fd9$export$4950aa0f605343fb)(token, {
        popoverBg: colorBgElevated,
        popoverColor: colorText
    });
    return [
        $968912ff9c4e3004$var$genBaseStyle(popoverToken),
        $968912ff9c4e3004$var$genColorStyle(popoverToken),
        (0, $9783f6e7d4c63d86$export$f5d123412490d9dc)(popoverToken, 'zoom-big')
    ];
}, $968912ff9c4e3004$export$9ca1be8807fe0675, {
    resetStyle: false,
    deprecatedTokens: [
        [
            'width',
            'titleMinWidth'
        ],
        [
            'minWidth',
            'titleMinWidth'
        ]
    ]
});


"use client";
const $07abdc59284c4674$export$c6fdb837b070b4ff = (props)=>{
    const { title: title, content: content, prefixCls: prefixCls, classNames: classNames, styles: styles } = props;
    if (!title && !content) return null;
    return /*#__PURE__*/ $hO8yS.createElement($hO8yS.Fragment, null, title && /*#__PURE__*/ $hO8yS.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-title`, classNames?.title),
        style: styles?.title
    }, title), content && /*#__PURE__*/ $hO8yS.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-content`, classNames?.content),
        style: styles?.content
    }, content));
};
const $07abdc59284c4674$export$c40925af82c95d5b = (props)=>{
    const { hashId: hashId, prefixCls: prefixCls, className: className, style: style, placement: placement = 'top', title: title, content: content, children: children, classNames: classNames, styles: styles } = props;
    const titleNode = (0, $5fd6882142905fe9$export$15e5fca53711d340)(title);
    const contentNode = (0, $5fd6882142905fe9$export$15e5fca53711d340)(content);
    const mergedProps = {
        ...props,
        placement: placement
    };
    const [mergedClassNames, mergedStyles] = (0, $4dcf69d8c3d6df5c$export$648566b068f28737)([
        classNames
    ], [
        styles
    ], {
        props: mergedProps
    });
    const rootClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(hashId, prefixCls, `${prefixCls}-pure`, `${prefixCls}-placement-${placement}`, className);
    return /*#__PURE__*/ $hO8yS.createElement("div", {
        className: rootClassName,
        style: style
    }, /*#__PURE__*/ $hO8yS.createElement("div", {
        className: `${prefixCls}-arrow`
    }), /*#__PURE__*/ $hO8yS.createElement((0, $c1d4e2f940b8a598$export$2e2bcd8739ae039), {
        ...props,
        className: hashId,
        prefixCls: prefixCls,
        classNames: mergedClassNames,
        styles: mergedStyles
    }, children || /*#__PURE__*/ $hO8yS.createElement($07abdc59284c4674$export$c6fdb837b070b4ff, {
        prefixCls: prefixCls,
        title: titleNode,
        content: contentNode,
        classNames: mergedClassNames,
        styles: mergedStyles
    })));
};
const $07abdc59284c4674$var$PurePanel = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, ...restProps } = props;
    const { getPrefixCls: getPrefixCls } = $32rMB.useContext((0, $dd01e2f5a4b8605d$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('popover', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $968912ff9c4e3004$export$2e2bcd8739ae039)(prefixCls);
    return /*#__PURE__*/ $hO8yS.createElement($07abdc59284c4674$export$c40925af82c95d5b, {
        ...restProps,
        prefixCls: prefixCls,
        hashId: hashId,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(className, cssVarCls)
    });
};
var $07abdc59284c4674$export$2e2bcd8739ae039 = $07abdc59284c4674$var$PurePanel;



"use client";
const $0e41e0372811ac11$var$InternalPopover = /*#__PURE__*/ $N3oW3.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, title: title, content: content, overlayClassName: overlayClassName, placement: placement = 'top', trigger: trigger = 'hover', children: children, mouseEnterDelay: mouseEnterDelay = 0.1, mouseLeaveDelay: mouseLeaveDelay = 0.1, onOpenChange: onOpenChange, overlayStyle: overlayStyle = {}, styles: styles, classNames: classNames, motion: motion, arrow: popoverArrow, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles, arrow: contextArrow } = (0, $dd01e2f5a4b8605d$export$46f4bd6436a25a31)('popover');
    const prefixCls = getPrefixCls('popover', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $968912ff9c4e3004$export$2e2bcd8739ae039)(prefixCls);
    const rootPrefixCls = getPrefixCls();
    const mergedArrow = (0, $6993852e4088d6b2$export$2e2bcd8739ae039)(popoverArrow, contextArrow);
    // ============================= Styles =============================
    const mergedProps = {
        ...props,
        placement: placement,
        trigger: trigger,
        mouseEnterDelay: mouseEnterDelay,
        mouseLeaveDelay: mouseLeaveDelay,
        overlayStyle: overlayStyle,
        styles: styles,
        classNames: classNames
    };
    const [mergedClassNames, mergedStyles] = (0, $4dcf69d8c3d6df5c$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    const rootClassNames = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(overlayClassName, hashId, cssVarCls, contextClassName, mergedClassNames.root);
    const [open, setOpen] = (0, $05ea6e97cee440ee$export$2e2bcd8739ae039)(props.defaultOpen ?? false, props.open);
    const settingOpen = (value, e)=>{
        setOpen(value);
        onOpenChange?.(value, e);
    };
    const onKeyDown = (e)=>{
        if (e.keyCode === (0, $4d7d870d585f8465$export$2e2bcd8739ae039).ESC) settingOpen(false, e);
    };
    const onInternalOpenChange = (value)=>{
        settingOpen(value);
    };
    const titleNode = (0, $5fd6882142905fe9$export$15e5fca53711d340)(title);
    const contentNode = (0, $5fd6882142905fe9$export$15e5fca53711d340)(content);
    return /*#__PURE__*/ $hO8yS.createElement((0, $bdb14b445459ab9d$export$2e2bcd8739ae039), {
        unique: false,
        arrow: mergedArrow,
        placement: placement,
        trigger: trigger,
        mouseEnterDelay: mouseEnterDelay,
        mouseLeaveDelay: mouseLeaveDelay,
        ...restProps,
        prefixCls: prefixCls,
        classNames: {
            root: rootClassNames,
            container: mergedClassNames.container,
            arrow: mergedClassNames.arrow
        },
        styles: {
            root: {
                ...mergedStyles.root,
                ...contextStyle,
                ...overlayStyle
            },
            container: mergedStyles.container,
            arrow: mergedStyles.arrow
        },
        ref: ref,
        open: open,
        onOpenChange: onInternalOpenChange,
        overlay: titleNode || contentNode ? /*#__PURE__*/ $hO8yS.createElement((0, $07abdc59284c4674$export$c6fdb837b070b4ff), {
            prefixCls: prefixCls,
            title: titleNode,
            content: contentNode,
            classNames: mergedClassNames,
            styles: mergedStyles
        }) : null,
        motion: {
            motionName: (0, $689b5af26dd3c1cd$export$27c72201b1d09951)(rootPrefixCls, 'zoom-big', typeof motion?.motionName === 'string' ? motion?.motionName : undefined)
        },
        "data-popover-inject": true
    }, (0, $62609775897a768c$export$e530037191fcd5d7)(children, {
        onKeyDown: (e)=>{
            if (/*#__PURE__*/ (0, $N3oW3.isValidElement)(children)) children?.props.onKeyDown?.(e);
            onKeyDown(e);
        }
    }));
});
const $0e41e0372811ac11$var$Popover = $0e41e0372811ac11$var$InternalPopover;
$0e41e0372811ac11$var$Popover._InternalPanelDoNotUseOrYouWillBeFired = (0, $07abdc59284c4674$export$2e2bcd8739ae039);
var $0e41e0372811ac11$export$2e2bcd8739ae039 = $0e41e0372811ac11$var$Popover;





"use client";
const $92667ef46c65bbce$var$AvatarContextProvider = (props)=>{
    const { size: size, shape: shape } = $32rMB.useContext((0, $f7abb94a0dd82a5d$export$2e2bcd8739ae039));
    const avatarContextValue = $32rMB.useMemo(()=>({
            size: props.size || size,
            shape: props.shape || shape
        }), [
        props.size,
        props.shape,
        size,
        shape
    ]);
    return /*#__PURE__*/ $hO8yS.createElement((0, $f7abb94a0dd82a5d$export$2e2bcd8739ae039).Provider, {
        value: avatarContextValue
    }, props.children);
};
const $92667ef46c65bbce$var$AvatarGroup = (props)=>{
    const { getPrefixCls: getPrefixCls, direction: direction } = $32rMB.useContext((0, $dd01e2f5a4b8605d$export$a92f85ab3e9ad68b));
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, style: style, maxCount: maxCount, maxStyle: maxStyle, size: size, shape: shape, maxPopoverPlacement: maxPopoverPlacement, maxPopoverTrigger: maxPopoverTrigger, children: children, max: max } = props;
    var deprecatedName, newName;
    const prefixCls = getPrefixCls('avatar', customizePrefixCls);
    const groupPrefixCls = `${prefixCls}-group`;
    const rootCls = (0, $54b1aecddbbbed4f$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $5e4ca8e8dd9005a8$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const cls = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(groupPrefixCls, {
        [`${groupPrefixCls}-rtl`]: direction === 'rtl'
    }, cssVarCls, rootCls, className, rootClassName, hashId);
    const childrenWithProps = (0, $a60ede783f74e6a9$export$2e2bcd8739ae039)(children).map((child, index)=>(0, $62609775897a768c$export$e530037191fcd5d7)(child, {
            // eslint-disable-next-line react/no-array-index-key
            key: `avatar-key-${index}`
        }));
    const mergeCount = max?.count || maxCount;
    const numOfChildren = childrenWithProps.length;
    if (mergeCount && mergeCount < numOfChildren) {
        const childrenShow = childrenWithProps.slice(0, mergeCount);
        const childrenHidden = childrenWithProps.slice(mergeCount, numOfChildren);
        const mergeStyle = max?.style || maxStyle;
        const mergePopoverTrigger = max?.popover?.trigger || maxPopoverTrigger || 'hover';
        const mergePopoverPlacement = max?.popover?.placement || maxPopoverPlacement || 'top';
        const popoverProps = {
            content: childrenHidden,
            ...max?.popover,
            placement: mergePopoverPlacement,
            trigger: mergePopoverTrigger,
            rootClassName: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${groupPrefixCls}-popover`, max?.popover?.rootClassName)
        };
        childrenShow.push(/*#__PURE__*/ $hO8yS.createElement((0, $0e41e0372811ac11$export$2e2bcd8739ae039), {
            key: "avatar-popover-key",
            destroyOnHidden: true,
            ...popoverProps
        }, /*#__PURE__*/ $hO8yS.createElement((0, $16f8327e3ed4cc39$export$2e2bcd8739ae039), {
            style: mergeStyle
        }, `+${numOfChildren - mergeCount}`)));
        return /*#__PURE__*/ $hO8yS.createElement($92667ef46c65bbce$var$AvatarContextProvider, {
            shape: shape,
            size: size
        }, /*#__PURE__*/ $hO8yS.createElement("div", {
            className: cls,
            style: style
        }, childrenShow));
    }
    return /*#__PURE__*/ $hO8yS.createElement($92667ef46c65bbce$var$AvatarContextProvider, {
        shape: shape,
        size: size
    }, /*#__PURE__*/ $hO8yS.createElement("div", {
        className: cls,
        style: style
    }, childrenWithProps));
};
var $92667ef46c65bbce$export$2e2bcd8739ae039 = $92667ef46c65bbce$var$AvatarGroup;


"use client";
const $0cb483a407d1bed2$var$Avatar = (0, $16f8327e3ed4cc39$export$2e2bcd8739ae039);
$0cb483a407d1bed2$var$Avatar.Group = (0, $92667ef46c65bbce$export$2e2bcd8739ae039);
var $0cb483a407d1bed2$export$2e2bcd8739ae039 = $0cb483a407d1bed2$var$Avatar;


var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");







var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");






const $492bea4fae3e6417$var$genWaveStyle = (token)=>{
    const { componentCls: componentCls, colorPrimary: colorPrimary } = token;
    return {
        [componentCls]: {
            position: 'absolute',
            background: 'transparent',
            pointerEvents: 'none',
            boxSizing: 'border-box',
            color: `var(--wave-color, ${colorPrimary})`,
            boxShadow: `0 0 0 0 currentcolor`,
            opacity: 0.2,
            // =================== Motion ===================
            '&.wave-motion-appear': {
                transition: [
                    `box-shadow 0.4s ${token.motionEaseOutCirc}`,
                    `opacity 2s ${token.motionEaseOutCirc}`
                ].join(','),
                '&-active': {
                    boxShadow: `0 0 0 6px currentcolor`,
                    opacity: 0
                },
                '&.wave-quick': {
                    transition: [
                        `box-shadow ${token.motionDurationSlow} ${token.motionEaseInOut}`,
                        `opacity ${token.motionDurationSlow} ${token.motionEaseInOut}`
                    ].join(',')
                }
            }
        }
    };
};
var $492bea4fae3e6417$export$2e2bcd8739ae039 = (0, $d4a2dc313c4d90a4$export$b8cc4ee2ee8cfbc8)('Wave', $492bea4fae3e6417$var$genWaveStyle);


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");





const $989003bd02f62eb9$export$23466a5792b7a5d3 = `${(0, $dd01e2f5a4b8605d$export$e4ec87ea71f29b41)}-wave-target`;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");






function $fcf4cc7afb8580d8$export$9d61ea039e87eb91(color) {
    return color && typeof color === 'string' && color !== '#fff' && color !== '#ffffff' && color !== 'rgb(255, 255, 255)' && color !== 'rgba(255, 255, 255, 1)' && !/rgba\((?:\d*, ){3}0\)/.test(color) && // any transparent rgba color
    color !== 'transparent' && color !== 'canvastext';
}
function $fcf4cc7afb8580d8$export$651d8e9c80304fc8(node, colorSource = null) {
    const style = getComputedStyle(node);
    const { borderTopColor: borderTopColor, borderColor: borderColor, backgroundColor: backgroundColor } = style;
    if (colorSource && $fcf4cc7afb8580d8$export$9d61ea039e87eb91(style[colorSource])) return style[colorSource];
    return [
        borderTopColor,
        borderColor,
        backgroundColor
    ].find($fcf4cc7afb8580d8$export$9d61ea039e87eb91) ?? null;
}


"use client";
function $9000ded0b5b41aaf$var$validateNum(value) {
    return Number.isNaN(value) ? 0 : value;
}
const $9000ded0b5b41aaf$var$WaveEffect = (props)=>{
    const { className: className, target: target, component: component, colorSource: colorSource } = props;
    const divRef = $32rMB.useRef(null);
    // ===================== Effect =====================
    const [color, setWaveColor] = $32rMB.useState(null);
    const [borderRadius, setBorderRadius] = $32rMB.useState([]);
    const [left, setLeft] = $32rMB.useState(0);
    const [top, setTop] = $32rMB.useState(0);
    const [width, setWidth] = $32rMB.useState(0);
    const [height, setHeight] = $32rMB.useState(0);
    const [enabled, setEnabled] = $32rMB.useState(false);
    const waveStyle = {
        left: left,
        top: top,
        width: width,
        height: height,
        borderRadius: borderRadius.map((radius)=>`${radius}px`).join(' ')
    };
    if (color) waveStyle['--wave-color'] = color;
    function syncPos() {
        const nodeStyle = getComputedStyle(target);
        // Get wave color from target
        setWaveColor((0, $fcf4cc7afb8580d8$export$651d8e9c80304fc8)(target, colorSource));
        const isStatic = nodeStyle.position === 'static';
        // Rect
        const { borderLeftWidth: borderLeftWidth, borderTopWidth: borderTopWidth } = nodeStyle;
        setLeft(isStatic ? target.offsetLeft : $9000ded0b5b41aaf$var$validateNum(-Number.parseFloat(borderLeftWidth)));
        setTop(isStatic ? target.offsetTop : $9000ded0b5b41aaf$var$validateNum(-Number.parseFloat(borderTopWidth)));
        setWidth(target.offsetWidth);
        setHeight(target.offsetHeight);
        // Get border radius
        const { borderTopLeftRadius: borderTopLeftRadius, borderTopRightRadius: borderTopRightRadius, borderBottomLeftRadius: borderBottomLeftRadius, borderBottomRightRadius: borderBottomRightRadius } = nodeStyle;
        setBorderRadius([
            borderTopLeftRadius,
            borderTopRightRadius,
            borderBottomRightRadius,
            borderBottomLeftRadius
        ].map((radius)=>$9000ded0b5b41aaf$var$validateNum(Number.parseFloat(radius))));
    }
    $32rMB.useEffect(()=>{
        if (target) {
            // We need delay to check position here
            // since UI may change after click
            const id = (0, $c9c36e20d667d30c$export$2e2bcd8739ae039)(()=>{
                syncPos();
                setEnabled(true);
            });
            // Add resize observer to follow size
            let resizeObserver;
            if (typeof ResizeObserver !== 'undefined') {
                resizeObserver = new ResizeObserver(syncPos);
                resizeObserver.observe(target);
            }
            return ()=>{
                (0, $c9c36e20d667d30c$export$2e2bcd8739ae039).cancel(id);
                resizeObserver?.disconnect();
            };
        }
    }, [
        target
    ]);
    if (!enabled) return null;
    const isSmallComponent = (component === 'Checkbox' || component === 'Radio') && target?.classList.contains((0, $989003bd02f62eb9$export$23466a5792b7a5d3));
    return /*#__PURE__*/ $hO8yS.createElement((0, $db80a026d0a86ece$export$2e2bcd8739ae039), {
        visible: true,
        motionAppear: true,
        motionName: "wave-motion",
        motionDeadline: 5000,
        onAppearEnd: (_, event)=>{
            if (event.deadline || event.propertyName === 'opacity') {
                const holder = divRef.current?.parentElement;
                (0, $77c6df01f18c5b91$export$121e2d597d222bad)(holder).then(()=>{
                    holder?.remove();
                });
            }
            return false;
        }
    }, ({ className: motionClassName }, ref)=>/*#__PURE__*/ $hO8yS.createElement("div", {
            ref: (0, $2706ed817e87019d$export$ab452c34e8e05029)(divRef, ref),
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(className, motionClassName, {
                'wave-quick': isSmallComponent
            }),
            style: waveStyle
        }));
};
const $9000ded0b5b41aaf$var$showWaveEffect = (target, info)=>{
    const { component: component } = info;
    // Skip for unchecked checkbox
    if (component === 'Checkbox' && !target.querySelector('input')?.checked) return;
    // Create holder
    const holder = document.createElement('div');
    holder.style.position = 'absolute';
    holder.style.left = '0px';
    holder.style.top = '0px';
    target?.insertBefore(holder, target?.firstChild);
    (0, $77c6df01f18c5b91$export$b3890eb0ae9dca99)(/*#__PURE__*/ $hO8yS.createElement($9000ded0b5b41aaf$var$WaveEffect, {
        ...info,
        target: target
    }), holder);
};
var $9000ded0b5b41aaf$export$2e2bcd8739ae039 = $9000ded0b5b41aaf$var$showWaveEffect;


const $c8771201deb5b375$var$useWave = (nodeRef, className, component, colorSource)=>{
    const { wave: wave } = $32rMB.useContext((0, $dd01e2f5a4b8605d$export$a92f85ab3e9ad68b));
    const [, token, hashId] = (0, $9481722d146bd166$export$2e2bcd8739ae039)();
    const showWave = (0, $ea93068db096b7d6$export$2e2bcd8739ae039)((event)=>{
        const node = nodeRef.current;
        if (wave?.disabled || !node) return;
        const targetNode = node.querySelector(`.${(0, $989003bd02f62eb9$export$23466a5792b7a5d3)}`) || node;
        const { showEffect: showEffect } = wave || {};
        // Customize wave effect
        (showEffect || (0, $9000ded0b5b41aaf$export$2e2bcd8739ae039))(targetNode, {
            className: className,
            token: token,
            component: component,
            event: event,
            hashId: hashId,
            colorSource: colorSource
        });
    });
    const rafId = $32rMB.useRef(null);
    // Clean up RAF on unmount to prevent memory leaks and stale callbacks
    $32rMB.useEffect(()=>()=>{
            (0, $c9c36e20d667d30c$export$2e2bcd8739ae039).cancel(rafId.current);
        }, []);
    // Merge trigger event into one for each frame
    const showDebounceWave = (event)=>{
        (0, $c9c36e20d667d30c$export$2e2bcd8739ae039).cancel(rafId.current);
        rafId.current = (0, $c9c36e20d667d30c$export$2e2bcd8739ae039)(()=>{
            showWave(event);
        });
    };
    return showDebounceWave;
};
var $c8771201deb5b375$export$2e2bcd8739ae039 = $c8771201deb5b375$var$useWave;


const $b6fefae43eb584fa$var$Wave = (props)=>{
    const { children: children, disabled: disabled, component: component, colorSource: colorSource } = props;
    const { getPrefixCls: getPrefixCls } = (0, $32rMB.useContext)((0, $dd01e2f5a4b8605d$export$a92f85ab3e9ad68b));
    const containerRef = (0, $32rMB.useRef)(null);
    // ============================== Style ===============================
    const prefixCls = getPrefixCls('wave');
    const [, hashId] = (0, $492bea4fae3e6417$export$2e2bcd8739ae039)(prefixCls);
    // =============================== Wave ===============================
    const showWave = (0, $c8771201deb5b375$export$2e2bcd8739ae039)(containerRef, (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, hashId), component, colorSource);
    // ============================== Effect ==============================
    (0, $N3oW3.default).useEffect(()=>{
        const node = containerRef.current;
        if (!node || node.nodeType !== window.Node.ELEMENT_NODE || disabled) return;
        // Click handler
        const onClick = (e)=>{
            // Fix radio button click twice
            if (!(0, $218f20156c5f8705$export$2e2bcd8739ae039)(e.target) || // No need wave
            !node.getAttribute || node.getAttribute('disabled') || node.disabled || node.className.includes('disabled') && !node.className.includes('disabled:') || node.getAttribute('aria-disabled') === 'true' || node.className.includes('-leave')) return;
            showWave(e);
        };
        // Bind events
        node.addEventListener('click', onClick, true);
        return ()=>{
            node.removeEventListener('click', onClick, true);
        };
    }, [
        disabled
    ]);
    // ============================== Render ==============================
    if (!/*#__PURE__*/ (0, $N3oW3.default).isValidElement(children)) return children ?? null;
    const ref = (0, $2706ed817e87019d$export$c1cec34af06bcf7)(children) ? (0, $2706ed817e87019d$export$ab452c34e8e05029)((0, $2706ed817e87019d$export$7465e5c0bf44f19a)(children), containerRef) : containerRef;
    return (0, $62609775897a768c$export$e530037191fcd5d7)(children, {
        ref: ref
    });
};
var $b6fefae43eb584fa$export$2e2bcd8739ae039 = $b6fefae43eb584fa$var$Wave;






parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");




"use client";
const $ac1bd5b23bcbd4c2$export$ed0cc8bd1f617d6d = /*#__PURE__*/ $hO8yS.createContext(undefined);
const $ac1bd5b23bcbd4c2$var$ButtonGroup = (props)=>{
    const { getPrefixCls: getPrefixCls, direction: direction } = $32rMB.useContext((0, $dd01e2f5a4b8605d$export$a92f85ab3e9ad68b));
    const { prefixCls: customizePrefixCls, size: size, className: className, ...others } = props;
    const prefixCls = getPrefixCls('btn-group', customizePrefixCls);
    const [, , hashId] = (0, $9481722d146bd166$export$2e2bcd8739ae039)();
    const sizeCls = $32rMB.useMemo(()=>{
        switch(size){
            case 'large':
                return 'lg';
            case 'small':
                return 'sm';
            default:
                return '';
        }
    }, [
        size
    ]);
    const classes = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, {
        [`${prefixCls}-${sizeCls}`]: sizeCls,
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, className, hashId);
    return /*#__PURE__*/ $hO8yS.createElement($ac1bd5b23bcbd4c2$export$ed0cc8bd1f617d6d.Provider, {
        value: size
    }, /*#__PURE__*/ $hO8yS.createElement("div", {
        ...others,
        className: classes
    }));
};
var $ac1bd5b23bcbd4c2$export$2e2bcd8739ae039 = $ac1bd5b23bcbd4c2$var$ButtonGroup;




var $N3oW3 = parcelRequire("N3oW3");




"use client";
const $c59d4dc2abd8d863$var$rxTwoCNChar = /^[\u4E00-\u9FA5]{2}$/;
const $c59d4dc2abd8d863$export$c5dca2bf412dea0d = $c59d4dc2abd8d863$var$rxTwoCNChar.test.bind($c59d4dc2abd8d863$var$rxTwoCNChar);
function $c59d4dc2abd8d863$export$19bc9a290855952(type) {
    if (type === 'danger') return {
        danger: true
    };
    return {
        type: type
    };
}
function $c59d4dc2abd8d863$export$844ec244b1367d54(str) {
    return typeof str === 'string';
}
function $c59d4dc2abd8d863$export$b120bc11c0d9c214(type) {
    return type === 'text' || type === 'link';
}
function $c59d4dc2abd8d863$var$splitCNCharsBySpace(child, needInserted, style, className) {
    if (!(0, $95ac4c3d4339216e$export$2e2bcd8739ae039)(child) || child === '') return;
    const SPACE = needInserted ? ' ' : '';
    if (typeof child !== 'string' && typeof child !== 'number' && $c59d4dc2abd8d863$export$844ec244b1367d54(child.type) && $c59d4dc2abd8d863$export$c5dca2bf412dea0d(child.props.children)) return (0, $62609775897a768c$export$e530037191fcd5d7)(child, (oriProps)=>({
            ...oriProps,
            children: oriProps.children.split('').join(SPACE),
            className: className,
            style: style
        }));
    if ($c59d4dc2abd8d863$export$844ec244b1367d54(child)) return /*#__PURE__*/ (0, $N3oW3.default).createElement("span", {
        className: className,
        style: style
    }, $c59d4dc2abd8d863$export$c5dca2bf412dea0d(child) ? child.split('').join(SPACE) : child);
    if ((0, $62609775897a768c$export$9522e17588c12572)(child)) return /*#__PURE__*/ (0, $N3oW3.default).createElement("span", {
        className: className,
        style: style
    }, child);
    return (0, $62609775897a768c$export$e530037191fcd5d7)(child, (oriProps)=>({
            ...oriProps,
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(oriProps.className, className) || undefined,
            style: {
                ...oriProps.style,
                ...style
            }
        }));
}
function $c59d4dc2abd8d863$export$b6ee00a7e7908bc(children, needInserted, style, className) {
    let isPrevChildPure = false;
    const childList = [];
    (0, $N3oW3.default).Children.forEach(children, (child)=>{
        const type = typeof child;
        const isCurrentChildPure = type === 'string' || type === 'number';
        if (isPrevChildPure && isCurrentChildPure) {
            const lastIndex = childList.length - 1;
            const lastChild = childList[lastIndex];
            childList[lastIndex] = `${lastChild}${child}`;
        } else childList.push(child);
        isPrevChildPure = isCurrentChildPure;
    });
    return (0, $N3oW3.default).Children.map(childList, (child)=>$c59d4dc2abd8d863$var$splitCNCharsBySpace(child, needInserted, style, className));
}
const $c59d4dc2abd8d863$var$_ButtonTypes = [
    'default',
    'primary',
    'dashed',
    'link',
    'text'
];
const $c59d4dc2abd8d863$var$_ButtonShapes = [
    'default',
    'circle',
    'round',
    'square'
];
const $c59d4dc2abd8d863$var$_ButtonHTMLTypes = [
    'submit',
    'button',
    'reset'
];
const $c59d4dc2abd8d863$export$9870b52452f51da5 = [
    'outlined',
    'dashed',
    'solid',
    'filled',
    'text',
    'link'
];
const $c59d4dc2abd8d863$export$760f16d96e091fc5 = [
    'default',
    'primary',
    'danger'
].concat((0, $3746fb019e1f2ee5$export$2e2bcd8739ae039)((0, $81d4e816322e7f22$export$6d4fe3a00a1811ad)));



var $N3oW3 = parcelRequire("N3oW3");




var $N3oW3 = parcelRequire("N3oW3");

"use client";
const $1801985a04a36901$var$IconWrapper = /*#__PURE__*/ (0, $N3oW3.forwardRef)((props, ref)=>{
    const { className: className, style: style, children: children, prefixCls: prefixCls } = props;
    const iconWrapperCls = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-icon`, className);
    return /*#__PURE__*/ (0, $N3oW3.default).createElement("span", {
        ref: ref,
        className: iconWrapperCls,
        style: style
    }, children);
});
var $1801985a04a36901$export$2e2bcd8739ae039 = $1801985a04a36901$var$IconWrapper;


"use client";
const $5158f4bd8b12bdc4$var$InnerLoadingIcon = /*#__PURE__*/ (0, $N3oW3.forwardRef)((props, ref)=>{
    const { prefixCls: prefixCls, className: className, style: style, iconClassName: iconClassName } = props;
    const mergedIconCls = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-loading-icon`, className);
    return /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $1801985a04a36901$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        className: mergedIconCls,
        style: style,
        ref: ref
    }, /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $b7d605396d432b67$export$2e2bcd8739ae039), {
        className: iconClassName
    }));
});
const $5158f4bd8b12bdc4$var$getCollapsedWidth = ()=>({
        width: 0,
        opacity: 0,
        transform: 'scale(0)'
    });
const $5158f4bd8b12bdc4$var$getRealWidth = (node)=>({
        width: node.scrollWidth,
        opacity: 1,
        transform: 'scale(1)'
    });
const $5158f4bd8b12bdc4$var$DefaultLoadingIcon = (props)=>{
    const { prefixCls: prefixCls, loading: loading, existIcon: existIcon, className: className, style: style, mount: mount } = props;
    const visible = !!loading;
    if (existIcon) return /*#__PURE__*/ (0, $N3oW3.default).createElement($5158f4bd8b12bdc4$var$InnerLoadingIcon, {
        prefixCls: prefixCls,
        className: className,
        style: style
    });
    return /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $db80a026d0a86ece$export$2e2bcd8739ae039), {
        visible: visible,
        // Used for minus flex gap style only
        motionName: `${prefixCls}-loading-icon-motion`,
        motionAppear: !mount,
        motionEnter: !mount,
        motionLeave: !mount,
        removeOnLeave: true,
        onAppearStart: $5158f4bd8b12bdc4$var$getCollapsedWidth,
        onAppearActive: $5158f4bd8b12bdc4$var$getRealWidth,
        onEnterStart: $5158f4bd8b12bdc4$var$getCollapsedWidth,
        onEnterActive: $5158f4bd8b12bdc4$var$getRealWidth,
        onLeaveStart: $5158f4bd8b12bdc4$var$getRealWidth,
        onLeaveActive: $5158f4bd8b12bdc4$var$getCollapsedWidth
    }, ({ className: motionCls, style: motionStyle }, ref)=>{
        const mergedStyle = {
            ...style,
            ...motionStyle
        };
        return /*#__PURE__*/ (0, $N3oW3.default).createElement($5158f4bd8b12bdc4$var$InnerLoadingIcon, {
            prefixCls: prefixCls,
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(className, motionCls),
            style: mergedStyle,
            ref: ref
        });
    });
};
var $5158f4bd8b12bdc4$export$2e2bcd8739ae039 = $5158f4bd8b12bdc4$var$DefaultLoadingIcon;






const $d63ea136fc17b109$var$genButtonBorderStyle = (buttonTypeCls, borderColor)=>({
        // Border
        [`> span, > ${buttonTypeCls}`]: {
            '&:not(:last-child)': {
                [`&, & > ${buttonTypeCls}`]: {
                    '&:not(:disabled)': {
                        borderInlineEndColor: borderColor
                    }
                }
            },
            '&:not(:first-child)': {
                [`&, & > ${buttonTypeCls}`]: {
                    '&:not(:disabled)': {
                        borderInlineStartColor: borderColor
                    }
                }
            }
        }
    });
const $d63ea136fc17b109$var$genGroupStyle = (token)=>{
    const { componentCls: componentCls, fontSize: fontSize, lineWidth: lineWidth, groupBorderColor: groupBorderColor, colorErrorHover: colorErrorHover } = token;
    return {
        [`${componentCls}-group`]: [
            {
                position: 'relative',
                display: 'inline-flex',
                // Border
                [`> span, > ${componentCls}`]: {
                    '&:not(:last-child)': {
                        [`&, & > ${componentCls}`]: {
                            borderStartEndRadius: 0,
                            borderEndEndRadius: 0
                        }
                    },
                    '&:not(:first-child)': {
                        marginInlineStart: token.calc(lineWidth).mul(-1).equal(),
                        [`&, & > ${componentCls}`]: {
                            borderStartStartRadius: 0,
                            borderEndStartRadius: 0
                        }
                    }
                },
                [componentCls]: {
                    position: 'relative',
                    zIndex: 1,
                    '&:hover, &:focus, &:active': {
                        zIndex: 2
                    },
                    '&[disabled]': {
                        zIndex: 0
                    }
                },
                [`${componentCls}-icon-only`]: {
                    fontSize: fontSize
                }
            },
            // Border Color
            $d63ea136fc17b109$var$genButtonBorderStyle(`${componentCls}-primary`, groupBorderColor),
            $d63ea136fc17b109$var$genButtonBorderStyle(`${componentCls}-danger`, colorErrorHover)
        ]
    };
};
var $d63ea136fc17b109$export$2e2bcd8739ae039 = $d63ea136fc17b109$var$genGroupStyle;





var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
// This icon file is generated automatically.
var $6146020f7d2d07a2$var$RightOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z"
                }
            }
        ]
    },
    "name": "right",
    "theme": "outlined"
};
var $6146020f7d2d07a2$export$2e2bcd8739ae039 = $6146020f7d2d07a2$var$RightOutlined;



function $c8c7be68bfada8d0$var$_extends() {
    $c8c7be68bfada8d0$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c8c7be68bfada8d0$var$_extends.apply(this, arguments);
}
const $c8c7be68bfada8d0$var$RightOutlined = (props, ref)=>/*#__PURE__*/ $hO8yS.createElement((0, $5fd6f3f3c400c267$export$2e2bcd8739ae039), $c8c7be68bfada8d0$var$_extends({}, props, {
        ref: ref,
        icon: (0, $6146020f7d2d07a2$export$2e2bcd8739ae039)
    }));
/**![right](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTc2NS43IDQ4Ni44TDMxNC45IDEzNC43QTcuOTcgNy45NyAwIDAwMzAyIDE0MXY3Ny4zYzAgNC45IDIuMyA5LjYgNi4xIDEyLjZsMzYwIDI4MS4xLTM2MCAyODEuMWMtMy45IDMtNi4xIDcuNy02LjEgMTIuNlY4ODNjMCA2LjcgNy43IDEwLjQgMTIuOSA2LjNsNDUwLjgtMzUyLjFhMzEuOTYgMzEuOTYgMCAwMDAtNTAuNHoiIC8+PC9zdmc+) */ const $c8c7be68bfada8d0$var$RefIcon = /*#__PURE__*/ $N3oW3.forwardRef($c8c7be68bfada8d0$var$RightOutlined);
var $c8c7be68bfada8d0$export$2e2bcd8739ae039 = $c8c7be68bfada8d0$var$RefIcon;


function $4dfb8f1fff0cbd5e$export$2e2bcd8739ae039() {
    return $4dfb8f1fff0cbd5e$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4dfb8f1fff0cbd5e$export$2e2bcd8739ae039.apply(null, arguments);
}






var $N3oW3 = parcelRequire("N3oW3");



var $N3oW3 = parcelRequire("N3oW3");





var $N3oW3 = parcelRequire("N3oW3");


var $N3oW3 = parcelRequire("N3oW3");
const $0d61fdfe31e32027$var$PanelContent = /*#__PURE__*/ (0, $N3oW3.default).forwardRef((props, ref)=>{
    const { prefixCls: prefixCls, forceRender: forceRender, className: className, style: style, children: children, isActive: isActive, role: role, classNames: customizeClassNames, styles: styles } = props;
    const [rendered, setRendered] = (0, $N3oW3.default).useState(isActive || forceRender);
    (0, $N3oW3.default).useEffect(()=>{
        if (forceRender || isActive) setRendered(true);
    }, [
        forceRender,
        isActive
    ]);
    if (!rendered) return null;
    return /*#__PURE__*/ (0, $N3oW3.default).createElement("div", {
        ref: ref,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-panel`, {
            [`${prefixCls}-panel-active`]: isActive,
            [`${prefixCls}-panel-inactive`]: !isActive
        }, className),
        style: style,
        role: role
    }, /*#__PURE__*/ (0, $N3oW3.default).createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-body`, customizeClassNames?.body),
        style: styles?.body
    }, children));
});
var $0d61fdfe31e32027$export$2e2bcd8739ae039 = $0d61fdfe31e32027$var$PanelContent;


const $547ddcd8b467de4e$var$CollapsePanel = /*#__PURE__*/ (0, $N3oW3.default).forwardRef((props, ref)=>{
    const { showArrow: showArrow = true, headerClass: headerClass, isActive: isActive, onItemClick: onItemClick, forceRender: forceRender, className: className, classNames: customizeClassNames = {}, styles: styles = {}, prefixCls: prefixCls, collapsible: collapsible, accordion: accordion, panelKey: panelKey, extra: extra, header: header, expandIcon: expandIcon, openMotion: openMotion, destroyOnHidden: destroyOnHidden, children: children, ...resetProps } = props;
    const disabled = collapsible === 'disabled';
    const ifExtraExist = extra !== null && extra !== undefined && typeof extra !== 'boolean';
    const collapsibleProps = {
        onClick: ()=>{
            onItemClick?.(panelKey);
        },
        onKeyDown: (e)=>{
            if (e.key === 'Enter' || e.keyCode === (0, $4d7d870d585f8465$export$2e2bcd8739ae039).ENTER || e.which === (0, $4d7d870d585f8465$export$2e2bcd8739ae039).ENTER) onItemClick?.(panelKey);
        },
        role: accordion ? 'tab' : 'button',
        ['aria-expanded']: isActive,
        ['aria-disabled']: disabled,
        tabIndex: disabled ? -1 : 0
    };
    // ======================== Icon ========================
    const iconNodeInner = typeof expandIcon === 'function' ? expandIcon(props) : /*#__PURE__*/ (0, $N3oW3.default).createElement("i", {
        className: "arrow"
    });
    const iconNode = iconNodeInner && /*#__PURE__*/ (0, $N3oW3.default).createElement("div", (0, $4dfb8f1fff0cbd5e$export$2e2bcd8739ae039)({
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-expand-icon`, customizeClassNames?.icon),
        style: styles?.icon
    }, [
        'header',
        'icon'
    ].includes(collapsible) ? collapsibleProps : {}), iconNodeInner);
    const collapsePanelClassNames = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-item`, {
        [`${prefixCls}-item-active`]: isActive,
        [`${prefixCls}-item-disabled`]: disabled
    }, className);
    const headerClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(headerClass, `${prefixCls}-header`, {
        [`${prefixCls}-collapsible-${collapsible}`]: !!collapsible
    }, customizeClassNames?.header);
    // ======================== HeaderProps ========================
    const headerProps = {
        className: headerClassName,
        style: styles?.header,
        ...[
            'header',
            'icon'
        ].includes(collapsible) ? {} : collapsibleProps
    };
    // ======================== Render ========================
    return /*#__PURE__*/ (0, $N3oW3.default).createElement("div", (0, $4dfb8f1fff0cbd5e$export$2e2bcd8739ae039)({}, resetProps, {
        ref: ref,
        className: collapsePanelClassNames
    }), /*#__PURE__*/ (0, $N3oW3.default).createElement("div", headerProps, showArrow && iconNode, /*#__PURE__*/ (0, $N3oW3.default).createElement("span", (0, $4dfb8f1fff0cbd5e$export$2e2bcd8739ae039)({
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-title`, customizeClassNames?.title),
        style: styles?.title
    }, collapsible === 'header' ? collapsibleProps : {}), header), ifExtraExist && /*#__PURE__*/ (0, $N3oW3.default).createElement("div", {
        className: `${prefixCls}-extra`
    }, extra)), /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $db80a026d0a86ece$export$2e2bcd8739ae039), (0, $4dfb8f1fff0cbd5e$export$2e2bcd8739ae039)({
        visible: isActive,
        leavedClassName: `${prefixCls}-panel-hidden`
    }, openMotion, {
        forceRender: forceRender,
        removeOnLeave: destroyOnHidden
    }), ({ className: motionClassName, style: motionStyle }, motionRef)=>{
        return /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $0d61fdfe31e32027$export$2e2bcd8739ae039), {
            ref: motionRef,
            prefixCls: prefixCls,
            className: motionClassName,
            classNames: customizeClassNames,
            style: motionStyle,
            styles: styles,
            isActive: isActive,
            forceRender: forceRender,
            role: accordion ? 'tabpanel' : undefined
        }, children);
    }));
});
var $547ddcd8b467de4e$export$2e2bcd8739ae039 = $547ddcd8b467de4e$var$CollapsePanel;


const $8f53bcf607ec0206$var$convertItemsToNodes = (items, props)=>{
    const { prefixCls: prefixCls, accordion: accordion, collapsible: collapsible, destroyOnHidden: destroyOnHidden, onItemClick: onItemClick, activeKey: activeKey, openMotion: openMotion, expandIcon: expandIcon, classNames: collapseClassNames, styles: styles } = props;
    return items.map((item, index)=>{
        const { children: children, label: label, key: rawKey, collapsible: rawCollapsible, onItemClick: rawOnItemClick, destroyOnHidden: rawDestroyOnHidden, ...restProps } = item;
        // You may be puzzled why you want to convert them all into strings, me too.
        // Maybe: https://github.com/react-component/collapse/blob/aac303a8b6ff30e35060b4f8fecde6f4556fcbe2/src/Collapse.tsx#L15
        const key = String(rawKey ?? index);
        const mergeCollapsible = rawCollapsible ?? collapsible;
        const mergedDestroyOnHidden = rawDestroyOnHidden ?? destroyOnHidden;
        const handleItemClick = (value)=>{
            if (mergeCollapsible === 'disabled') return;
            onItemClick(value);
            rawOnItemClick?.(value);
        };
        let isActive = false;
        if (accordion) isActive = activeKey[0] === key;
        else isActive = activeKey.indexOf(key) > -1;
        return /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $547ddcd8b467de4e$export$2e2bcd8739ae039), (0, $4dfb8f1fff0cbd5e$export$2e2bcd8739ae039)({}, restProps, {
            classNames: collapseClassNames,
            styles: styles,
            prefixCls: prefixCls,
            key: key,
            panelKey: key,
            isActive: isActive,
            accordion: accordion,
            openMotion: openMotion,
            expandIcon: expandIcon,
            header: label,
            collapsible: mergeCollapsible,
            onItemClick: handleItemClick,
            destroyOnHidden: mergedDestroyOnHidden
        }), children);
    });
};
/**
 * @deprecated The next major version will be removed
 */ const $8f53bcf607ec0206$var$getNewChild = (child, index, props)=>{
    if (!child) return null;
    const { prefixCls: prefixCls, accordion: accordion, collapsible: collapsible, destroyOnHidden: destroyOnHidden, onItemClick: onItemClick, activeKey: activeKey, openMotion: openMotion, expandIcon: expandIcon, classNames: collapseClassNames, styles: styles } = props;
    const key = child.key || String(index);
    const { header: header, headerClass: headerClass, destroyOnHidden: childDestroyOnHidden, collapsible: childCollapsible, onItemClick: childOnItemClick } = child.props;
    let isActive = false;
    if (accordion) isActive = activeKey[0] === key;
    else isActive = activeKey.indexOf(key) > -1;
    const mergeCollapsible = childCollapsible ?? collapsible;
    const handleItemClick = (value)=>{
        if (mergeCollapsible === 'disabled') return;
        onItemClick(value);
        childOnItemClick?.(value);
    };
    const childProps = {
        key: key,
        panelKey: key,
        header: header,
        headerClass: headerClass,
        classNames: collapseClassNames,
        styles: styles,
        isActive: isActive,
        prefixCls: prefixCls,
        destroyOnHidden: childDestroyOnHidden ?? destroyOnHidden,
        openMotion: openMotion,
        accordion: accordion,
        children: child.props.children,
        onItemClick: handleItemClick,
        expandIcon: expandIcon,
        collapsible: mergeCollapsible
    };
    // https://github.com/ant-design/ant-design/issues/20479
    if (typeof child.type === 'string') return child;
    Object.keys(childProps).forEach((propName)=>{
        if (typeof childProps[propName] === 'undefined') delete childProps[propName];
    });
    return /*#__PURE__*/ (0, $N3oW3.default).cloneElement(child, childProps);
};
function $8f53bcf607ec0206$var$useItems(items, rawChildren, props) {
    if (Array.isArray(items)) return $8f53bcf607ec0206$var$convertItemsToNodes(items, props);
    return (0, $a60ede783f74e6a9$export$2e2bcd8739ae039)(rawChildren).map((child, index)=>$8f53bcf607ec0206$var$getNewChild(child, index, props));
}
var $8f53bcf607ec0206$export$2e2bcd8739ae039 = $8f53bcf607ec0206$var$useItems;




function $11f0c15adf050f40$var$getActiveKeysArray(activeKey) {
    let currentActiveKey = activeKey;
    if (!Array.isArray(currentActiveKey)) {
        const activeKeyType = typeof currentActiveKey;
        currentActiveKey = activeKeyType === 'number' || activeKeyType === 'string' ? [
            currentActiveKey
        ] : [];
    }
    return currentActiveKey.map((key)=>String(key));
}
const $11f0c15adf050f40$var$Collapse = /*#__PURE__*/ (0, $N3oW3.default).forwardRef((props, ref)=>{
    const { prefixCls: prefixCls = 'rc-collapse', destroyOnHidden: destroyOnHidden = false, style: style, accordion: accordion, className: className, children: children, collapsible: collapsible, openMotion: openMotion, expandIcon: expandIcon, activeKey: rawActiveKey, defaultActiveKey: defaultActiveKey, onChange: onChange, items: items, classNames: customizeClassNames, styles: styles } = props;
    const collapseClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, className);
    const [internalActiveKey, setActiveKey] = (0, $05ea6e97cee440ee$export$2e2bcd8739ae039)(defaultActiveKey, rawActiveKey);
    const activeKey = $11f0c15adf050f40$var$getActiveKeysArray(internalActiveKey);
    const triggerActiveKey = (0, $ea93068db096b7d6$export$2e2bcd8739ae039)((next)=>{
        const nextKeys = $11f0c15adf050f40$var$getActiveKeysArray(next);
        setActiveKey(nextKeys);
        onChange?.(nextKeys);
    });
    const onItemClick = (key)=>{
        if (accordion) triggerActiveKey(activeKey[0] === key ? [] : [
            key
        ]);
        else triggerActiveKey(activeKey.includes(key) ? activeKey.filter((item)=>item !== key) : [
            ...activeKey,
            key
        ]);
    };
    // ======================== Children ========================
    (0, $6591254ed6bd1058$export$2e2bcd8739ae039)(!children, '[rc-collapse] `children` will be removed in next major version. Please use `items` instead.');
    const mergedChildren = (0, $8f53bcf607ec0206$export$2e2bcd8739ae039)(items, children, {
        prefixCls: prefixCls,
        accordion: accordion,
        openMotion: openMotion,
        expandIcon: expandIcon,
        collapsible: collapsible,
        destroyOnHidden: destroyOnHidden,
        onItemClick: onItemClick,
        activeKey: activeKey,
        classNames: customizeClassNames,
        styles: styles
    });
    // ======================== Render ========================
    return /*#__PURE__*/ (0, $N3oW3.default).createElement("div", (0, $4dfb8f1fff0cbd5e$export$2e2bcd8739ae039)({
        ref: ref,
        className: collapseClassName,
        style: style,
        role: accordion ? 'tablist' : undefined
    }, (0, $b0f3dfd0eb3cad70$export$2e2bcd8739ae039)(props, {
        aria: true,
        data: true
    })), mergedChildren);
});
var $11f0c15adf050f40$export$2e2bcd8739ae039 = Object.assign($11f0c15adf050f40$var$Collapse, {
    /**
   * @deprecated use `items` instead, will be removed in `v4.0.0`
   */ Panel: (0, $547ddcd8b467de4e$export$2e2bcd8739ae039)
});


var $17f5870227be36d1$export$2e2bcd8739ae039 = (0, $11f0c15adf050f40$export$2e2bcd8739ae039);
const { Panel: $17f5870227be36d1$export$2ddb90ad54e5f587 } = (0, $11f0c15adf050f40$export$2e2bcd8739ae039);










parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");




"use client";
const $e1ed8ec307f0f6a0$var$CollapsePanel = /*#__PURE__*/ $N3oW3.forwardRef((props, ref)=>{
    const { getPrefixCls: getPrefixCls } = $32rMB.useContext((0, $dd01e2f5a4b8605d$export$a92f85ab3e9ad68b));
    const { prefixCls: customizePrefixCls, className: className, showArrow: showArrow = true } = props;
    const prefixCls = getPrefixCls('collapse', customizePrefixCls);
    const collapsePanelClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)({
        [`${prefixCls}-no-arrow`]: !showArrow
    }, className);
    return /*#__PURE__*/ $hO8yS.createElement((0, $17f5870227be36d1$export$2e2bcd8739ae039).Panel, {
        ref: ref,
        ...props,
        prefixCls: prefixCls,
        className: collapsePanelClassName
    });
});
var $e1ed8ec307f0f6a0$export$2e2bcd8739ae039 = $e1ed8ec307f0f6a0$var$CollapsePanel;




const $f58f14441a7cd550$var$genCollapseMotion = (token)=>({
        [token.componentCls]: {
            // For common/openAnimation
            [`${token.antCls}-motion-collapse-legacy`]: {
                overflow: 'hidden',
                '&-active': {
                    transition: `height ${token.motionDurationMid} ${token.motionEaseInOut},
        opacity ${token.motionDurationMid} ${token.motionEaseInOut} !important`
                }
            },
            [`${token.antCls}-motion-collapse`]: {
                overflow: 'hidden',
                transition: `height ${token.motionDurationMid} ${token.motionEaseInOut},
        opacity ${token.motionDurationMid} ${token.motionEaseInOut} !important`
            }
        }
    });
var $f58f14441a7cd550$export$2e2bcd8739ae039 = $f58f14441a7cd550$var$genCollapseMotion;



const $7162f345c37b2a7d$export$5ca74f7be820a85 = (token)=>{
    const { componentCls: componentCls, contentBg: contentBg, padding: padding, headerBg: headerBg, headerPadding: headerPadding, collapseHeaderPaddingSM: collapseHeaderPaddingSM, collapseHeaderPaddingLG: collapseHeaderPaddingLG, collapsePanelBorderRadius: collapsePanelBorderRadius, lineWidth: lineWidth, lineType: lineType, colorBorder: colorBorder, colorText: colorText, colorTextHeading: colorTextHeading, colorTextDisabled: colorTextDisabled, fontSizeLG: fontSizeLG, lineHeight: lineHeight, lineHeightLG: lineHeightLG, marginSM: marginSM, paddingSM: paddingSM, paddingLG: paddingLG, paddingXS: paddingXS, motionDurationSlow: motionDurationSlow, fontSizeIcon: fontSizeIcon, contentPadding: contentPadding, fontHeight: fontHeight, fontHeightLG: fontHeightLG } = token;
    const borderBase = `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(lineWidth)} ${lineType} ${colorBorder}`;
    return {
        [componentCls]: {
            ...(0, $2f353af2b0f7600b$export$23997c3e44cc1c59)(token),
            backgroundColor: headerBg,
            border: borderBase,
            borderRadius: collapsePanelBorderRadius,
            '&-rtl': {
                direction: 'rtl'
            },
            [`& > ${componentCls}-item`]: {
                borderBottom: borderBase,
                '&:first-child': {
                    [`
            &,
            & > ${componentCls}-header`]: {
                        borderRadius: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(collapsePanelBorderRadius)} ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(collapsePanelBorderRadius)} 0 0`
                    }
                },
                '&:last-child': {
                    [`
            &,
            & > ${componentCls}-header`]: {
                        borderRadius: `0 0 ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(collapsePanelBorderRadius)} ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(collapsePanelBorderRadius)}`
                    }
                },
                [`> ${componentCls}-header`]: {
                    position: 'relative',
                    // Compatible with old version of antd, should remove in next version
                    display: 'flex',
                    flexWrap: 'nowrap',
                    alignItems: 'flex-start',
                    padding: headerPadding,
                    color: colorTextHeading,
                    lineHeight: lineHeight,
                    cursor: 'pointer',
                    transition: `all ${motionDurationSlow}, visibility 0s`,
                    ...(0, $2f353af2b0f7600b$export$a44db842bcb28231)(token),
                    [`> ${componentCls}-title`]: {
                        flex: 'auto'
                    },
                    // >>>>> Arrow
                    [`${componentCls}-expand-icon`]: {
                        height: fontHeight,
                        display: 'flex',
                        alignItems: 'center',
                        marginInlineEnd: marginSM
                    },
                    [`${componentCls}-arrow`]: {
                        ...(0, $2f353af2b0f7600b$export$171ccda7bc085e59)(),
                        fontSize: fontSizeIcon,
                        // when `transform: rotate()` is applied to icon's root element
                        transition: `transform ${motionDurationSlow}`,
                        // when `transform: rotate()` is applied to icon's child element
                        svg: {
                            transition: `transform ${motionDurationSlow}`
                        }
                    },
                    // >>>>> Text
                    [`${componentCls}-title`]: {
                        marginInlineEnd: 'auto'
                    }
                },
                [`${componentCls}-collapsible-header`]: {
                    cursor: 'default',
                    [`${componentCls}-title`]: {
                        flex: 'none',
                        cursor: 'pointer'
                    },
                    [`${componentCls}-expand-icon`]: {
                        cursor: 'pointer'
                    }
                },
                [`${componentCls}-collapsible-icon`]: {
                    cursor: 'unset',
                    [`${componentCls}-expand-icon`]: {
                        cursor: 'pointer'
                    }
                }
            },
            [`${componentCls}-panel`]: {
                color: colorText,
                backgroundColor: contentBg,
                borderTop: borderBase,
                [`& > ${componentCls}-body`]: {
                    padding: contentPadding
                },
                '&-hidden': {
                    display: 'none'
                }
            },
            '&-small': {
                [`> ${componentCls}-item`]: {
                    [`> ${componentCls}-header`]: {
                        padding: collapseHeaderPaddingSM,
                        paddingInlineStart: paddingXS,
                        [`> ${componentCls}-expand-icon`]: {
                            // Arrow offset
                            marginInlineStart: token.calc(paddingSM).sub(paddingXS).equal()
                        }
                    },
                    [`> ${componentCls}-panel > ${componentCls}-body`]: {
                        padding: paddingSM
                    }
                }
            },
            '&-large': {
                [`> ${componentCls}-item`]: {
                    fontSize: fontSizeLG,
                    lineHeight: lineHeightLG,
                    [`> ${componentCls}-header`]: {
                        padding: collapseHeaderPaddingLG,
                        paddingInlineStart: padding,
                        [`> ${componentCls}-expand-icon`]: {
                            height: fontHeightLG,
                            // Arrow offset
                            marginInlineStart: token.calc(paddingLG).sub(padding).equal()
                        }
                    },
                    [`> ${componentCls}-panel > ${componentCls}-body`]: {
                        padding: paddingLG
                    }
                }
            },
            [`${componentCls}-item:last-child`]: {
                borderBottom: 0,
                [`> ${componentCls}-panel`]: {
                    borderRadius: `0 0 ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(collapsePanelBorderRadius)} ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(collapsePanelBorderRadius)}`
                }
            },
            [`& ${componentCls}-item-disabled > ${componentCls}-header`]: {
                [`
          &,
          & > .arrow
        `]: {
                    color: colorTextDisabled,
                    cursor: 'not-allowed'
                }
            },
            // ========================== Icon Placement ==========================
            [`&${componentCls}-icon-placement-end`]: {
                [`& > ${componentCls}-item`]: {
                    [`> ${componentCls}-header`]: {
                        [`${componentCls}-expand-icon`]: {
                            order: 1,
                            marginInlineEnd: 0,
                            marginInlineStart: marginSM
                        }
                    }
                }
            }
        }
    };
};
const $7162f345c37b2a7d$var$genArrowStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const fixedSelector = `> ${componentCls}-item > ${componentCls}-header ${componentCls}-arrow`;
    return {
        [`${componentCls}-rtl`]: {
            [fixedSelector]: {
                transform: `rotate(180deg)`
            }
        }
    };
};
const $7162f345c37b2a7d$var$genBorderlessStyle = (token)=>{
    const { componentCls: componentCls, headerBg: headerBg, borderlessContentPadding: borderlessContentPadding, borderlessContentBg: borderlessContentBg, colorBorder: colorBorder } = token;
    return {
        [`${componentCls}-borderless`]: {
            backgroundColor: headerBg,
            border: 0,
            [`> ${componentCls}-item`]: {
                borderBottom: `1px solid ${colorBorder}`
            },
            [`
        > ${componentCls}-item:last-child,
        > ${componentCls}-item:last-child ${componentCls}-header
      `]: {
                borderRadius: 0
            },
            [`> ${componentCls}-item:last-child`]: {
                borderBottom: 0
            },
            [`> ${componentCls}-item > ${componentCls}-panel`]: {
                backgroundColor: borderlessContentBg,
                borderTop: 0
            },
            [`> ${componentCls}-item > ${componentCls}-panel > ${componentCls}-body`]: {
                padding: borderlessContentPadding
            }
        }
    };
};
const $7162f345c37b2a7d$var$genGhostStyle = (token)=>{
    const { componentCls: componentCls, paddingSM: paddingSM } = token;
    return {
        [`${componentCls}-ghost`]: {
            backgroundColor: 'transparent',
            border: 0,
            [`> ${componentCls}-item`]: {
                borderBottom: 0,
                [`> ${componentCls}-panel`]: {
                    backgroundColor: 'transparent',
                    border: 0,
                    [`> ${componentCls}-body`]: {
                        paddingBlock: paddingSM
                    }
                }
            }
        }
    };
};
const $7162f345c37b2a7d$export$9ca1be8807fe0675 = (token)=>({
        headerPadding: `${token.paddingSM}px ${token.padding}px`,
        headerBg: token.colorFillAlter,
        contentPadding: `${token.padding}px 16px`,
        // Fixed Value
        contentBg: token.colorBgContainer,
        borderlessContentPadding: `${token.paddingXXS}px 16px ${token.padding}px`,
        borderlessContentBg: 'transparent'
    });
var $7162f345c37b2a7d$export$2e2bcd8739ae039 = (0, $d4a2dc313c4d90a4$export$51ec95de45185b42)('Collapse', (token)=>{
    const collapseToken = (0, $90c11ca6cb263fd9$export$4950aa0f605343fb)(token, {
        collapseHeaderPaddingSM: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.paddingXS)} ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.paddingSM)}`,
        collapseHeaderPaddingLG: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.padding)} ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.paddingLG)}`,
        collapsePanelBorderRadius: token.borderRadiusLG
    });
    return [
        $7162f345c37b2a7d$export$5ca74f7be820a85(collapseToken),
        $7162f345c37b2a7d$var$genBorderlessStyle(collapseToken),
        $7162f345c37b2a7d$var$genGhostStyle(collapseToken),
        $7162f345c37b2a7d$var$genArrowStyle(collapseToken),
        (0, $f58f14441a7cd550$export$2e2bcd8739ae039)(collapseToken)
    ];
}, $7162f345c37b2a7d$export$9ca1be8807fe0675);


"use client";
const $38f27b058134c0d0$var$Collapse = /*#__PURE__*/ $N3oW3.forwardRef((props, ref)=>{
    const { getPrefixCls: getPrefixCls, direction: direction, expandIcon: contextExpandIcon, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $dd01e2f5a4b8605d$export$46f4bd6436a25a31)('collapse');
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, style: style, bordered: bordered = true, ghost: ghost, size: customizeSize, expandIconPlacement: expandIconPlacement, expandIconPosition: expandIconPosition, children: children, destroyInactivePanel: destroyInactivePanel, destroyOnHidden: destroyOnHidden, expandIcon: expandIcon, classNames: classNames, styles: styles } = props;
    const mergedSize = (0, $324b30eda6ea1cd7$export$2e2bcd8739ae039)((ctx)=>customizeSize ?? ctx ?? 'middle');
    const prefixCls = getPrefixCls('collapse', customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    const [hashId, cssVarCls] = (0, $7162f345c37b2a7d$export$2e2bcd8739ae039)(prefixCls);
    const mergedPlacement = expandIconPlacement ?? expandIconPosition ?? 'start';
    // =========== Merged Props for Semantic ===========
    const mergedProps = {
        ...props,
        size: mergedSize,
        bordered: bordered,
        expandIconPlacement: mergedPlacement
    };
    const [mergedClassNames, mergedStyles] = (0, $4dcf69d8c3d6df5c$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    const mergedExpandIcon = expandIcon ?? contextExpandIcon;
    var deprecatedName, newName;
    const renderExpandIcon = $32rMB.useCallback((panelProps = {})=>{
        const icon = typeof mergedExpandIcon === 'function' ? mergedExpandIcon(panelProps) : /*#__PURE__*/ $hO8yS.createElement((0, $c8c7be68bfada8d0$export$2e2bcd8739ae039), {
            rotate: panelProps.isActive ? direction === 'rtl' ? -90 : 90 : undefined,
            "aria-label": panelProps.isActive ? 'expanded' : 'collapsed'
        });
        return (0, $62609775897a768c$export$e530037191fcd5d7)(icon, ()=>({
                className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(icon?.props?.className, `${prefixCls}-arrow`)
            }));
    }, [
        mergedExpandIcon,
        prefixCls,
        direction
    ]);
    const collapseClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-icon-placement-${mergedPlacement}`, {
        [`${prefixCls}-borderless`]: !bordered,
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-ghost`]: !!ghost,
        [`${prefixCls}-${mergedSize}`]: mergedSize !== 'middle'
    }, contextClassName, className, rootClassName, hashId, cssVarCls, mergedClassNames.root);
    const openMotion = $32rMB.useMemo(()=>({
            ...(0, $689b5af26dd3c1cd$export$2e2bcd8739ae039)(rootPrefixCls),
            motionAppear: false,
            leavedClassName: `${prefixCls}-panel-hidden`
        }), [
        rootPrefixCls,
        prefixCls
    ]);
    const items = $32rMB.useMemo(()=>{
        if (children) return (0, $a60ede783f74e6a9$export$2e2bcd8739ae039)(children).map((child)=>child);
        return null;
    }, [
        children
    ]);
    return(/*#__PURE__*/ // @ts-ignore
    $hO8yS.createElement((0, $17f5870227be36d1$export$2e2bcd8739ae039), {
        ref: ref,
        openMotion: openMotion,
        ...(0, $f4cf9c2e27c0ac8d$export$2e2bcd8739ae039)(props, [
            'rootClassName'
        ]),
        expandIcon: renderExpandIcon,
        prefixCls: prefixCls,
        className: collapseClassName,
        style: {
            ...mergedStyles.root,
            ...contextStyle,
            ...style
        },
        classNames: mergedClassNames,
        styles: mergedStyles,
        destroyOnHidden: destroyOnHidden ?? destroyInactivePanel
    }, items));
});
var $38f27b058134c0d0$export$2e2bcd8739ae039 = Object.assign($38f27b058134c0d0$var$Collapse, {
    Panel: (0, $e1ed8ec307f0f6a0$export$2e2bcd8739ae039)
});


"use client";
var $a816a1591f827bec$export$2e2bcd8739ae039 = (0, $38f27b058134c0d0$export$2e2bcd8739ae039);





"use client";
const $b2da78f3dea95f26$var$genPresetColor = (list)=>list.map((value)=>{
        value.colors = value.colors.map((0, $44c1040567028aeb$export$c844f5d21427d1ab));
        return value;
    });
const $b2da78f3dea95f26$export$6341b37cb79161da = (value, bgColorToken)=>{
    const { r: r, g: g, b: b, a: a } = value.toRgb();
    const hsv = new (0, $ca36849cc3e4c7a0$export$892596cec99bc70e)(value.toRgbString()).onBackground(bgColorToken).toHsv();
    if (a <= 0.5) // Adapted to dark mode
    return hsv.v > 0.5;
    return r * 0.299 + g * 0.587 + b * 0.114 > 192;
};
const $b2da78f3dea95f26$var$genCollapsePanelKey = (preset, index)=>{
    const mergedKey = preset.key ?? index;
    return `panel-${mergedKey}`;
};
const $b2da78f3dea95f26$var$ColorPresets = ({ prefixCls: prefixCls, presets: presets, value: color, onChange: onChange })=>{
    const [locale] = (0, $c176ccd8a9cbd556$export$2e2bcd8739ae039)('ColorPicker');
    const [, token] = (0, $9481722d146bd166$export$2e2bcd8739ae039)();
    const presetsValue = (0, $32rMB.useMemo)(()=>$b2da78f3dea95f26$var$genPresetColor(presets), [
        presets
    ]);
    const colorPresetsPrefixCls = `${prefixCls}-presets`;
    const activeKeys = (0, $32rMB.useMemo)(()=>presetsValue.reduce((acc, preset, index)=>{
            const { defaultOpen: defaultOpen = true } = preset;
            if (defaultOpen) acc.push($b2da78f3dea95f26$var$genCollapsePanelKey(preset, index));
            return acc;
        }, []), [
        presetsValue
    ]);
    const handleClick = (colorValue)=>{
        onChange?.(colorValue);
    };
    const items = presetsValue.map((preset, index)=>({
            key: $b2da78f3dea95f26$var$genCollapsePanelKey(preset, index),
            label: /*#__PURE__*/ (0, $N3oW3.default).createElement("div", {
                className: `${colorPresetsPrefixCls}-label`
            }, preset?.label),
            children: /*#__PURE__*/ (0, $N3oW3.default).createElement("div", {
                className: `${colorPresetsPrefixCls}-items`
            }, Array.isArray(preset?.colors) && preset.colors?.length > 0 ? preset.colors.map((presetColor, index)=>{
                const colorInst = (0, $44c1040567028aeb$export$c844f5d21427d1ab)(presetColor);
                return /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $d281f14c041ccf6a$export$2e2bcd8739ae039), {
                    // eslint-disable-next-line react/no-array-index-key
                    key: `preset-${index}-${presetColor.toHexString()}`,
                    color: colorInst.toCssString(),
                    prefixCls: prefixCls,
                    className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${colorPresetsPrefixCls}-color`, {
                        [`${colorPresetsPrefixCls}-color-checked`]: presetColor.toCssString() === color?.toCssString(),
                        [`${colorPresetsPrefixCls}-color-bright`]: $b2da78f3dea95f26$export$6341b37cb79161da(presetColor, token.colorBgElevated)
                    }),
                    onClick: ()=>handleClick(presetColor)
                });
            }) : /*#__PURE__*/ (0, $N3oW3.default).createElement("span", {
                className: `${colorPresetsPrefixCls}-empty`
            }, locale.presetEmpty))
        }));
    return /*#__PURE__*/ (0, $N3oW3.default).createElement("div", {
        className: colorPresetsPrefixCls
    }, /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $a816a1591f827bec$export$2e2bcd8739ae039), {
        defaultActiveKey: activeKeys,
        ghost: true,
        items: items
    }));
};
var $b2da78f3dea95f26$export$2e2bcd8739ae039 = $b2da78f3dea95f26$var$ColorPresets;





const $af8e802d7e5def7f$export$362fb92a8f81bbf9 = (token)=>{
    const { paddingInline: paddingInline, onlyIconSize: onlyIconSize, borderColorDisabled: borderColorDisabled } = token;
    const buttonToken = (0, $90c11ca6cb263fd9$export$4950aa0f605343fb)(token, {
        buttonPaddingHorizontal: paddingInline,
        buttonPaddingVertical: 0,
        buttonIconOnlyFontSize: onlyIconSize,
        colorBorderDisabled: borderColorDisabled
    });
    return buttonToken;
};
const $af8e802d7e5def7f$export$9ca1be8807fe0675 = (token)=>{
    const contentFontSize = token.contentFontSize ?? token.fontSize;
    const contentFontSizeSM = token.contentFontSizeSM ?? token.fontSize;
    const contentFontSizeLG = token.contentFontSizeLG ?? token.fontSizeLG;
    const contentLineHeight = token.contentLineHeight ?? (0, $b61daf35cae43c1e$export$56204a27a2958a55)(contentFontSize);
    const contentLineHeightSM = token.contentLineHeightSM ?? (0, $b61daf35cae43c1e$export$56204a27a2958a55)(contentFontSizeSM);
    const contentLineHeightLG = token.contentLineHeightLG ?? (0, $b61daf35cae43c1e$export$56204a27a2958a55)(contentFontSizeLG);
    const solidTextColor = (0, $b2da78f3dea95f26$export$6341b37cb79161da)(new (0, $218ce3eb00027935$export$e8cc8a2e87e145b4)(token.colorBgSolid), '#fff') ? '#000' : '#fff';
    const shadowColorTokens = (0, $81d4e816322e7f22$export$6d4fe3a00a1811ad).reduce((prev, colorKey)=>({
            ...prev,
            [`${colorKey}ShadowColor`]: `0 ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.controlOutlineWidth)} 0 ${(0, $aa087b253bae3724$export$2e2bcd8739ae039)(token[`${colorKey}1`], token.colorBgContainer)}`
        }), {});
    const defaultBgDisabled = token.colorBgContainerDisabled;
    const dashedBgDisabled = token.colorBgContainerDisabled;
    return {
        ...shadowColorTokens,
        fontWeight: 400,
        iconGap: token.marginXS,
        defaultShadow: `0 ${token.controlOutlineWidth}px 0 ${token.controlTmpOutline}`,
        primaryShadow: `0 ${token.controlOutlineWidth}px 0 ${token.controlOutline}`,
        dangerShadow: `0 ${token.controlOutlineWidth}px 0 ${token.colorErrorOutline}`,
        primaryColor: token.colorTextLightSolid,
        dangerColor: token.colorTextLightSolid,
        borderColorDisabled: token.colorBorderDisabled,
        defaultGhostColor: token.colorBgContainer,
        ghostBg: 'transparent',
        defaultGhostBorderColor: token.colorBgContainer,
        paddingInline: token.paddingContentHorizontal - token.lineWidth,
        paddingInlineLG: token.paddingContentHorizontal - token.lineWidth,
        paddingInlineSM: 8 - token.lineWidth,
        onlyIconSize: 'inherit',
        onlyIconSizeSM: 'inherit',
        onlyIconSizeLG: 'inherit',
        groupBorderColor: token.colorPrimaryHover,
        linkHoverBg: 'transparent',
        textTextColor: token.colorText,
        textTextHoverColor: token.colorText,
        textTextActiveColor: token.colorText,
        textHoverBg: token.colorFillTertiary,
        defaultColor: token.colorText,
        defaultBg: token.colorBgContainer,
        defaultBorderColor: token.colorBorder,
        defaultBorderColorDisabled: token.colorBorder,
        defaultHoverBg: token.colorBgContainer,
        defaultHoverColor: token.colorPrimaryHover,
        defaultHoverBorderColor: token.colorPrimaryHover,
        defaultActiveBg: token.colorBgContainer,
        defaultActiveColor: token.colorPrimaryActive,
        defaultActiveBorderColor: token.colorPrimaryActive,
        solidTextColor: solidTextColor,
        contentFontSize: contentFontSize,
        contentFontSizeSM: contentFontSizeSM,
        contentFontSizeLG: contentFontSizeLG,
        contentLineHeight: contentLineHeight,
        contentLineHeightSM: contentLineHeightSM,
        contentLineHeightLG: contentLineHeightLG,
        paddingBlock: Math.max((token.controlHeight - contentFontSize * contentLineHeight) / 2 - token.lineWidth, 0),
        paddingBlockSM: Math.max((token.controlHeightSM - contentFontSizeSM * contentLineHeightSM) / 2 - token.lineWidth, 0),
        paddingBlockLG: Math.max((token.controlHeightLG - contentFontSizeLG * contentLineHeightLG) / 2 - token.lineWidth, 0),
        defaultBgDisabled: defaultBgDisabled,
        dashedBgDisabled: dashedBgDisabled
    };
};




const $b8bee296c4e49a9a$var$genVariantStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    // Default: '--ant-btn-'
    const getCssVar = (0, $d4a2dc313c4d90a4$export$d82b8f66c5649e14)(antCls, 'btn');
    return {
        [componentCls]: [
            // ==============================================================
            // ==                         Variable                         ==
            // ==============================================================
            {
                // Border
                [getCssVar('border-width')]: '1px',
                [getCssVar('border-color')]: '#000',
                [getCssVar('border-color-hover')]: `var(${getCssVar('border-color')})`,
                [getCssVar('border-color-active')]: `var(${getCssVar('border-color')})`,
                [getCssVar('border-color-disabled')]: `var(${getCssVar('border-color')})`,
                [getCssVar('border-style')]: 'solid',
                // Text
                [getCssVar('text-color')]: '#000',
                [getCssVar('text-color-hover')]: `var(${getCssVar('text-color')})`,
                [getCssVar('text-color-active')]: `var(${getCssVar('text-color')})`,
                [getCssVar('text-color-disabled')]: `var(${getCssVar('text-color')})`,
                // Background
                [getCssVar('bg-color')]: '#ddd',
                [getCssVar('bg-color-hover')]: `var(${getCssVar('bg-color')})`,
                [getCssVar('bg-color-active')]: `var(${getCssVar('bg-color')})`,
                [getCssVar('bg-color-disabled')]: token.colorBgContainerDisabled,
                [getCssVar('bg-color-container')]: token.colorBgContainer,
                // Shadow
                [getCssVar('shadow')]: 'none'
            },
            // ==============================================================
            // ==                         Template                         ==
            // ==============================================================
            {
                // Basic
                border: `var(${getCssVar('border-width')}) var(${getCssVar('border-style')}) var(${getCssVar('border-color')})`,
                color: `var(${getCssVar('text-color')})`,
                backgroundColor: `var(${getCssVar('bg-color')})`,
                // Status
                [`&:not(:disabled):not(${componentCls}-disabled)`]: {
                    // Hover
                    '&:hover': {
                        border: `var(${getCssVar('border-width')}) var(${getCssVar('border-style')}) var(${getCssVar('border-color-hover')})`,
                        color: `var(${getCssVar('text-color-hover')})`,
                        backgroundColor: `var(${getCssVar('bg-color-hover')})`
                    },
                    // Active
                    '&:active': {
                        border: `var(${getCssVar('border-width')}) var(${getCssVar('border-style')}) var(${getCssVar('border-color-active')})`,
                        color: `var(${getCssVar('text-color-active')})`,
                        backgroundColor: `var(${getCssVar('bg-color-active')})`
                    }
                }
            },
            // ==============================================================
            // ==                         Variants                         ==
            // ==============================================================
            {
                // >>>>> Solid
                [`&${componentCls}-variant-solid`]: {
                    // Solid Variables
                    [getCssVar('solid-bg-color')]: `var(${getCssVar('color-base')})`,
                    [getCssVar('solid-bg-color-hover')]: `var(${getCssVar('color-hover')})`,
                    [getCssVar('solid-bg-color-active')]: `var(${getCssVar('color-active')})`,
                    // Variables
                    [getCssVar('border-color')]: 'transparent',
                    [getCssVar('text-color')]: token.colorTextLightSolid,
                    [getCssVar('bg-color')]: `var(${getCssVar('solid-bg-color')})`,
                    [getCssVar('bg-color-hover')]: `var(${getCssVar('solid-bg-color-hover')})`,
                    [getCssVar('bg-color-active')]: `var(${getCssVar('solid-bg-color-active')})`,
                    // Box Shadow
                    boxShadow: `var(${getCssVar('shadow')})`
                },
                // >>>>> Outlined & Dashed
                [`&${componentCls}-variant-outlined, &${componentCls}-variant-dashed`]: {
                    [getCssVar('border-color')]: `var(${getCssVar('color-base')})`,
                    [getCssVar('border-color-hover')]: `var(${getCssVar('color-hover')})`,
                    [getCssVar('border-color-active')]: `var(${getCssVar('color-active')})`,
                    [getCssVar('bg-color')]: `var(${getCssVar('bg-color-container')})`,
                    [getCssVar('text-color')]: `var(${getCssVar('color-base')})`,
                    [getCssVar('text-color-hover')]: `var(${getCssVar('color-hover')})`,
                    [getCssVar('text-color-active')]: `var(${getCssVar('color-active')})`,
                    // Box Shadow
                    boxShadow: `var(${getCssVar('shadow')})`
                },
                // >>>>> Dashed
                [`&${componentCls}-variant-dashed`]: {
                    [getCssVar('border-style')]: 'dashed',
                    [getCssVar('bg-color-disabled')]: token.dashedBgDisabled
                },
                // >>>>> Filled
                [`&${componentCls}-variant-filled`]: {
                    [getCssVar('border-color')]: 'transparent',
                    [getCssVar('text-color')]: `var(${getCssVar('color-base')})`,
                    [getCssVar('bg-color')]: `var(${getCssVar('color-light')})`,
                    [getCssVar('bg-color-hover')]: `var(${getCssVar('color-light-hover')})`,
                    [getCssVar('bg-color-active')]: `var(${getCssVar('color-light-active')})`
                },
                // >>>>> Text & Link
                [`&${componentCls}-variant-text, &${componentCls}-variant-link`]: {
                    [getCssVar('border-color')]: 'transparent',
                    [getCssVar('text-color')]: `var(${getCssVar('color-base')})`,
                    [getCssVar('text-color-hover')]: `var(${getCssVar('color-hover')})`,
                    [getCssVar('text-color-active')]: `var(${getCssVar('color-active')})`,
                    [getCssVar('bg-color')]: 'transparent',
                    [getCssVar('bg-color-hover')]: 'transparent',
                    [getCssVar('bg-color-active')]: 'transparent',
                    [`&:disabled, &${token.componentCls}-disabled`]: {
                        background: 'transparent',
                        borderColor: 'transparent'
                    }
                },
                // >>>>> Text
                [`&${componentCls}-variant-text`]: {
                    [getCssVar('bg-color-hover')]: `var(${getCssVar('color-light')})`,
                    [getCssVar('bg-color-active')]: `var(${getCssVar('color-light-active')})`
                }
            },
            // ==============================================================
            // ==                          Colors                          ==
            // ==============================================================
            {
                // ======================== By Default ========================
                // >>>>> Link
                [`&${componentCls}-variant-link`]: {
                    [getCssVar('color-base')]: token.colorLink,
                    [getCssVar('color-hover')]: token.colorLinkHover,
                    [getCssVar('color-active')]: token.colorLinkActive
                },
                // ======================== Compatible ========================
                // >>>>> Primary
                [`&${componentCls}-color-primary`]: {
                    [getCssVar('color-base')]: token.colorPrimary,
                    [getCssVar('color-hover')]: token.colorPrimaryHover,
                    [getCssVar('color-active')]: token.colorPrimaryActive,
                    [getCssVar('color-light')]: token.colorPrimaryBg,
                    [getCssVar('color-light-hover')]: token.colorPrimaryBgHover,
                    [getCssVar('color-light-active')]: token.colorPrimaryBorder,
                    [getCssVar('shadow')]: token.primaryShadow
                },
                // >>>>> Danger
                [`&${componentCls}-color-dangerous`]: {
                    [getCssVar('color-base')]: token.colorError,
                    [getCssVar('color-hover')]: token.colorErrorHover,
                    [getCssVar('color-active')]: token.colorErrorActive,
                    [getCssVar('color-light')]: token.colorErrorBg,
                    [getCssVar('color-light-hover')]: token.colorErrorBgFilledHover,
                    [getCssVar('color-light-active')]: token.colorErrorBgActive,
                    [getCssVar('shadow')]: token.dangerShadow
                },
                // >>>>> Default
                [`&${componentCls}-color-default`]: {
                    [getCssVar('solid-bg-color')]: token.colorBgSolid,
                    [getCssVar('solid-bg-color-hover')]: token.colorBgSolidHover,
                    [getCssVar('solid-bg-color-active')]: token.colorBgSolidActive,
                    [getCssVar('color-base')]: token.defaultBorderColor,
                    [getCssVar('color-hover')]: token.defaultHoverBorderColor,
                    [getCssVar('color-active')]: token.defaultActiveBorderColor,
                    [getCssVar('color-light')]: token.colorFillTertiary,
                    [getCssVar('color-light-hover')]: token.colorFillSecondary,
                    [getCssVar('color-light-active')]: token.colorFill,
                    [getCssVar('text-color')]: token.colorText,
                    [getCssVar('text-color-hover')]: token.defaultHoverBorderColor,
                    [getCssVar('text-color-active')]: token.defaultActiveBorderColor,
                    [getCssVar('shadow')]: token.defaultShadow,
                    [`&${componentCls}-variant-solid`]: {
                        [getCssVar('text-color')]: token.solidTextColor,
                        [getCssVar('text-color-hover')]: `var(${getCssVar('text-color')})`,
                        [getCssVar('text-color-active')]: `var(${getCssVar('text-color')})`
                    },
                    [`&${componentCls}-variant-filled, &${componentCls}-variant-text`]: {
                        [getCssVar('text-color-hover')]: `var(${getCssVar('text-color')})`,
                        [getCssVar('text-color-active')]: `var(${getCssVar('text-color')})`
                    },
                    [`&${componentCls}-background-ghost`]: {
                        [`&${componentCls}-variant-outlined, &${componentCls}-variant-dashed`]: {
                            [getCssVar('text-color')]: token.defaultGhostColor,
                            [getCssVar('border-color')]: token.defaultGhostBorderColor
                        }
                    }
                }
            },
            // >>>>> Preset Colors
            (0, $81d4e816322e7f22$export$6d4fe3a00a1811ad).map((colorKey)=>{
                const darkColor = token[`${colorKey}6`];
                const lightColor = token[`${colorKey}1`];
                const hoverColor = token[`${colorKey}5`];
                const lightHoverColor = token[`${colorKey}2`];
                const lightActiveColor = token[`${colorKey}3`];
                const activeColor = token[`${colorKey}7`];
                const shadowColor = token[`${colorKey}ShadowColor`];
                return {
                    [`&${componentCls}-color-${colorKey}`]: {
                        [getCssVar('color-base')]: darkColor,
                        [getCssVar('color-hover')]: hoverColor,
                        [getCssVar('color-active')]: activeColor,
                        [getCssVar('color-light')]: lightColor,
                        [getCssVar('color-light-hover')]: lightHoverColor,
                        [getCssVar('color-light-active')]: lightActiveColor,
                        [getCssVar('shadow')]: shadowColor
                    }
                };
            }),
            // ==============================================================
            // ==                         Disabled                         ==
            // ==============================================================
            {
                // Disabled
                [`&:disabled, &${token.componentCls}-disabled`]: {
                    cursor: 'not-allowed',
                    borderColor: token.colorBorderDisabled,
                    background: `var(${getCssVar('bg-color-disabled')})`,
                    color: token.colorTextDisabled,
                    boxShadow: 'none'
                }
            },
            // ==============================================================
            // ==                          Ghost                           ==
            // ==============================================================
            {
                // Ghost
                [`&${componentCls}-background-ghost`]: {
                    [getCssVar('bg-color')]: 'transparent',
                    [getCssVar('shadow')]: 'none'
                }
            }
        ]
    };
};
var $b8bee296c4e49a9a$export$2e2bcd8739ae039 = $b8bee296c4e49a9a$var$genVariantStyle;


// ============================== Shared ==============================
const $e7f196f9d120e8a1$var$genSharedButtonStyle = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, fontWeight: fontWeight, opacityLoading: opacityLoading, motionDurationSlow: motionDurationSlow, motionEaseInOut: motionEaseInOut, iconGap: iconGap, calc: calc } = token;
    return {
        [componentCls]: {
            outline: 'none',
            position: 'relative',
            display: 'inline-flex',
            gap: iconGap,
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: fontWeight,
            whiteSpace: 'nowrap',
            textAlign: 'center',
            backgroundImage: 'none',
            cursor: 'pointer',
            transition: `all ${token.motionDurationMid} ${token.motionEaseInOut}`,
            userSelect: 'none',
            touchAction: 'manipulation',
            '&:disabled > *': {
                pointerEvents: 'none'
            },
            // https://github.com/ant-design/ant-design/issues/51380
            [`${componentCls}-icon > svg`]: (0, $2f353af2b0f7600b$export$171ccda7bc085e59)(),
            '> a': {
                color: 'currentColor'
            },
            '&:not(:disabled)': (0, $2f353af2b0f7600b$export$a44db842bcb28231)(token),
            [`&${componentCls}-two-chinese-chars::first-letter`]: {
                letterSpacing: '0.34em'
            },
            [`&${componentCls}-two-chinese-chars > *:not(${iconCls})`]: {
                marginInlineEnd: '-0.34em',
                letterSpacing: '0.34em'
            },
            [`&${componentCls}-icon-only`]: {
                paddingInline: 0,
                // make `btn-icon-only` not too narrow
                [`&${componentCls}-compact-item`]: {
                    flex: 'none'
                }
            },
            // Loading
            [`&${componentCls}-loading`]: {
                opacity: opacityLoading,
                cursor: 'default'
            },
            [`${componentCls}-loading-icon`]: {
                transition: [
                    'width',
                    'opacity',
                    'margin'
                ].map((transition)=>`${transition} ${motionDurationSlow} ${motionEaseInOut}`).join(',')
            },
            // iconPlacement
            [`&:not(${componentCls}-icon-end)`]: {
                [`${componentCls}-loading-icon-motion`]: {
                    '&-appear-start, &-enter-start': {
                        marginInlineEnd: calc(iconGap).mul(-1).equal()
                    },
                    '&-appear-active, &-enter-active': {
                        marginInlineEnd: 0
                    },
                    '&-leave-start': {
                        marginInlineEnd: 0
                    },
                    '&-leave-active': {
                        marginInlineEnd: calc(iconGap).mul(-1).equal()
                    }
                }
            },
            '&-icon-end': {
                flexDirection: 'row-reverse',
                [`${componentCls}-loading-icon-motion`]: {
                    '&-appear-start, &-enter-start': {
                        marginInlineStart: calc(iconGap).mul(-1).equal()
                    },
                    '&-appear-active, &-enter-active': {
                        marginInlineStart: 0
                    },
                    '&-leave-start': {
                        marginInlineStart: 0
                    },
                    '&-leave-active': {
                        marginInlineStart: calc(iconGap).mul(-1).equal()
                    }
                }
            }
        }
    };
};
// ============================== Shape ===============================
const $e7f196f9d120e8a1$var$genCircleButtonStyle = (token)=>({
        minWidth: token.controlHeight,
        paddingInline: 0,
        borderRadius: '50%'
    });
// =============================== Size ===============================
const $e7f196f9d120e8a1$var$genButtonStyle = (token, prefixCls = '')=>{
    const { componentCls: componentCls, controlHeight: controlHeight, fontSize: fontSize, borderRadius: borderRadius, buttonPaddingHorizontal: buttonPaddingHorizontal, iconCls: iconCls, buttonPaddingVertical: buttonPaddingVertical, buttonIconOnlyFontSize: buttonIconOnlyFontSize } = token;
    return [
        {
            [prefixCls]: {
                fontSize: fontSize,
                height: controlHeight,
                padding: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(buttonPaddingVertical)} ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(buttonPaddingHorizontal)}`,
                borderRadius: borderRadius,
                [`&${componentCls}-icon-only`]: {
                    width: controlHeight,
                    [iconCls]: {
                        fontSize: buttonIconOnlyFontSize
                    }
                }
            }
        },
        // Shape - patch prefixCls again to override solid border radius style
        {
            [`${componentCls}${componentCls}-circle${prefixCls}`]: $e7f196f9d120e8a1$var$genCircleButtonStyle(token)
        },
        {
            [`${componentCls}${componentCls}-round${prefixCls}`]: {
                borderRadius: token.controlHeight,
                [`&:not(${componentCls}-icon-only)`]: {
                    paddingInline: token.buttonPaddingHorizontal
                }
            }
        }
    ];
};
const $e7f196f9d120e8a1$var$genSizeBaseButtonStyle = (token)=>{
    const baseToken = (0, $90c11ca6cb263fd9$export$4950aa0f605343fb)(token, {
        fontSize: token.contentFontSize
    });
    return $e7f196f9d120e8a1$var$genButtonStyle(baseToken, token.componentCls);
};
const $e7f196f9d120e8a1$var$genSizeSmallButtonStyle = (token)=>{
    const smallToken = (0, $90c11ca6cb263fd9$export$4950aa0f605343fb)(token, {
        controlHeight: token.controlHeightSM,
        fontSize: token.contentFontSizeSM,
        padding: token.paddingXS,
        buttonPaddingHorizontal: token.paddingInlineSM,
        buttonPaddingVertical: 0,
        borderRadius: token.borderRadiusSM,
        buttonIconOnlyFontSize: token.onlyIconSizeSM
    });
    return $e7f196f9d120e8a1$var$genButtonStyle(smallToken, `${token.componentCls}-sm`);
};
const $e7f196f9d120e8a1$var$genSizeLargeButtonStyle = (token)=>{
    const largeToken = (0, $90c11ca6cb263fd9$export$4950aa0f605343fb)(token, {
        controlHeight: token.controlHeightLG,
        fontSize: token.contentFontSizeLG,
        buttonPaddingHorizontal: token.paddingInlineLG,
        buttonPaddingVertical: 0,
        borderRadius: token.borderRadiusLG,
        buttonIconOnlyFontSize: token.onlyIconSizeLG
    });
    return $e7f196f9d120e8a1$var$genButtonStyle(largeToken, `${token.componentCls}-lg`);
};
const $e7f196f9d120e8a1$var$genBlockButtonStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: {
            [`&${componentCls}-block`]: {
                width: '100%'
            }
        }
    };
};
var // ============================== Export ==============================
$e7f196f9d120e8a1$export$2e2bcd8739ae039 = (0, $d4a2dc313c4d90a4$export$51ec95de45185b42)('Button', (token)=>{
    const buttonToken = (0, $af8e802d7e5def7f$export$362fb92a8f81bbf9)(token);
    return [
        // Shared
        $e7f196f9d120e8a1$var$genSharedButtonStyle(buttonToken),
        // Size
        $e7f196f9d120e8a1$var$genSizeBaseButtonStyle(buttonToken),
        $e7f196f9d120e8a1$var$genSizeSmallButtonStyle(buttonToken),
        $e7f196f9d120e8a1$var$genSizeLargeButtonStyle(buttonToken),
        // Block
        $e7f196f9d120e8a1$var$genBlockButtonStyle(buttonToken),
        // Variant
        (0, $b8bee296c4e49a9a$export$2e2bcd8739ae039)(buttonToken),
        // Button Group
        (0, $d63ea136fc17b109$export$2e2bcd8739ae039)(buttonToken)
    ];
}, (0, $af8e802d7e5def7f$export$9ca1be8807fe0675), {
    unitless: {
        fontWeight: true,
        contentLineHeight: true,
        contentLineHeightSM: true,
        contentLineHeightLG: true
    }
});


// handle border collapse
function $ebe50cd0ffe9b635$var$compactItemBorder(token, parentCls, options, prefixCls) {
    const { focusElCls: focusElCls, focus: focus, borderElCls: borderElCls } = options;
    const childCombinator = borderElCls ? '> *' : '';
    const hoverEffects = [
        'hover',
        focus ? 'focus' : null,
        'active'
    ].filter(Boolean).map((n)=>`&:${n} ${childCombinator}`).join(',');
    return {
        [`&-item:not(${parentCls}-last-item)`]: {
            marginInlineEnd: token.calc(token.lineWidth).mul(-1).equal()
        },
        [`&-item:not(${prefixCls}-status-success)`]: {
            zIndex: 2
        },
        '&-item': {
            [hoverEffects]: {
                zIndex: 3
            },
            ...focusElCls ? {
                [`&${focusElCls}`]: {
                    zIndex: 3
                }
            } : {},
            [`&[disabled] ${childCombinator}`]: {
                zIndex: 0
            }
        }
    };
}
// handle border-radius
function $ebe50cd0ffe9b635$var$compactItemBorderRadius(prefixCls, parentCls, options) {
    const { borderElCls: borderElCls } = options;
    const childCombinator = borderElCls ? `> ${borderElCls}` : '';
    return {
        [`&-item:not(${parentCls}-first-item):not(${parentCls}-last-item) ${childCombinator}`]: {
            borderRadius: 0
        },
        [`&-item:not(${parentCls}-last-item)${parentCls}-first-item`]: {
            [`& ${childCombinator}, &${prefixCls}-sm ${childCombinator}, &${prefixCls}-lg ${childCombinator}`]: {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0
            }
        },
        [`&-item:not(${parentCls}-first-item)${parentCls}-last-item`]: {
            [`& ${childCombinator}, &${prefixCls}-sm ${childCombinator}, &${prefixCls}-lg ${childCombinator}`]: {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
            }
        }
    };
}
function $ebe50cd0ffe9b635$export$b1208b23589b4b73(token, options = {
    focus: true
}) {
    const { componentCls: componentCls } = token;
    const { componentCls: customizePrefixCls } = options;
    const mergedComponentCls = customizePrefixCls || componentCls;
    const compactCls = `${mergedComponentCls}-compact`;
    return {
        [compactCls]: {
            ...$ebe50cd0ffe9b635$var$compactItemBorder(token, compactCls, options, mergedComponentCls),
            ...$ebe50cd0ffe9b635$var$compactItemBorderRadius(mergedComponentCls, compactCls, options)
        }
    };
}


function $8faf635c7b840744$var$compactItemVerticalBorder(token, parentCls, prefixCls) {
    return {
        // border collapse
        [`&-item:not(${parentCls}-last-item)`]: {
            marginBottom: token.calc(token.lineWidth).mul(-1).equal()
        },
        [`&-item:not(${prefixCls}-status-success)`]: {
            zIndex: 2
        },
        '&-item': {
            '&:hover,&:focus,&:active': {
                zIndex: 3
            },
            '&[disabled]': {
                zIndex: 0
            }
        }
    };
}
function $8faf635c7b840744$var$compactItemBorderVerticalRadius(prefixCls, parentCls) {
    return {
        [`&-item:not(${parentCls}-first-item):not(${parentCls}-last-item)`]: {
            borderRadius: 0
        },
        [`&-item${parentCls}-first-item:not(${parentCls}-last-item)`]: {
            [`&, &${prefixCls}-sm, &${prefixCls}-lg`]: {
                borderEndEndRadius: 0,
                borderEndStartRadius: 0
            }
        },
        [`&-item${parentCls}-last-item:not(${parentCls}-first-item)`]: {
            [`&, &${prefixCls}-sm, &${prefixCls}-lg`]: {
                borderStartStartRadius: 0,
                borderStartEndRadius: 0
            }
        }
    };
}
function $8faf635c7b840744$export$4dc87cb8ebf78ac6(token) {
    const compactCls = `${token.componentCls}-compact-vertical`;
    return {
        [compactCls]: {
            ...$8faf635c7b840744$var$compactItemVerticalBorder(token, compactCls, token.componentCls),
            ...$8faf635c7b840744$var$compactItemBorderVerticalRadius(token.componentCls, compactCls)
        }
    };
}




const $0345c5e64e2857f0$var$genButtonCompactStyle = (token)=>{
    const { componentCls: componentCls, colorPrimaryHover: colorPrimaryHover, lineWidth: lineWidth, calc: calc } = token;
    const insetOffset = calc(lineWidth).mul(-1).equal();
    const getCompactBorderStyle = (vertical)=>{
        const itemCls = `${componentCls}-compact${vertical ? '-vertical' : ''}-item`;
        const selector = `${itemCls}${componentCls}-primary:not([disabled])`;
        return {
            // TODO: Border color transition should be not cover when has color.
            [itemCls]: {
                transition: `none`
            },
            [`${selector} + ${selector}::before`]: {
                position: 'absolute',
                top: vertical ? insetOffset : 0,
                insetInlineStart: vertical ? 0 : insetOffset,
                backgroundColor: colorPrimaryHover,
                content: '""',
                width: vertical ? '100%' : lineWidth,
                height: vertical ? lineWidth : '100%'
            }
        };
    };
    // Special styles for Primary Button
    return {
        ...getCompactBorderStyle(),
        ...getCompactBorderStyle(true)
    };
};
var // ============================== Export ==============================
$0345c5e64e2857f0$export$2e2bcd8739ae039 = (0, $d4a2dc313c4d90a4$export$1537386bc155ea56)([
    'Button',
    'compact'
], (token)=>{
    const buttonToken = (0, $af8e802d7e5def7f$export$362fb92a8f81bbf9)(token);
    return [
        // Space Compact
        (0, $ebe50cd0ffe9b635$export$b1208b23589b4b73)(buttonToken),
        (0, $8faf635c7b840744$export$4dc87cb8ebf78ac6)(buttonToken),
        $0345c5e64e2857f0$var$genButtonCompactStyle(buttonToken)
    ];
}, (0, $af8e802d7e5def7f$export$9ca1be8807fe0675));


"use client";
function $33140907d397899a$var$getLoadingConfig(loading) {
    if (typeof loading === 'object' && loading) {
        let delay = loading?.delay;
        delay = !Number.isNaN(delay) && typeof delay === 'number' ? delay : 0;
        return {
            loading: delay <= 0,
            delay: delay
        };
    }
    return {
        loading: !!loading,
        delay: 0
    };
}
const $33140907d397899a$var$ButtonTypeMap = {
    default: [
        'default',
        'outlined'
    ],
    primary: [
        'primary',
        'solid'
    ],
    dashed: [
        'default',
        'dashed'
    ],
    // `link` is not a real color but we should compatible with it
    link: [
        'link',
        'link'
    ],
    text: [
        'default',
        'text'
    ]
};
const $33140907d397899a$var$InternalCompoundedButton = /*#__PURE__*/ (0, $N3oW3.default).forwardRef((props, ref)=>{
    const { _skipSemantic: _skipSemantic, loading: loading = false, prefixCls: customizePrefixCls, color: color, variant: variant, type: type, danger: danger = false, shape: customizeShape, size: customizeSize, disabled: customDisabled, className: className, rootClassName: rootClassName, children: children, icon: icon, iconPosition: iconPosition, iconPlacement: iconPlacement, ghost: ghost = false, block: block = false, htmlType: // React does not recognize the `htmlType` prop on a DOM element. Here we pick it out of `rest`.
    htmlType = 'button', classNames: classNames, styles: styles, style: style, autoInsertSpace: autoInsertSpace, autoFocus: autoFocus, ...rest } = props;
    const childNodes = (0, $a60ede783f74e6a9$export$2e2bcd8739ae039)(children);
    // https://github.com/ant-design/ant-design/issues/47605
    // Compatible with original `type` behavior
    const mergedType = type || 'default';
    const { button: button } = (0, $N3oW3.default).useContext((0, $dd01e2f5a4b8605d$export$a92f85ab3e9ad68b));
    const shape = customizeShape || button?.shape || 'default';
    const [parsedColor, parsedVariant] = (0, $32rMB.useMemo)(()=>{
        // >>>>> Local
        // Color & Variant
        if (color && variant) return [
            color,
            variant
        ];
        // Sugar syntax
        if (type || danger) {
            const colorVariantPair = $33140907d397899a$var$ButtonTypeMap[mergedType] || [];
            if (danger) return [
                'danger',
                colorVariantPair[1]
            ];
            return colorVariantPair;
        }
        // >>> Context fallback
        if (button?.color && button?.variant) return [
            button.color,
            button.variant
        ];
        return [
            'default',
            'outlined'
        ];
    }, [
        color,
        variant,
        type,
        danger,
        button?.color,
        button?.variant,
        mergedType
    ]);
    const [mergedColor, mergedVariant] = (0, $32rMB.useMemo)(()=>{
        if (ghost && parsedVariant === 'solid') return [
            parsedColor,
            'outlined'
        ];
        return [
            parsedColor,
            parsedVariant
        ];
    }, [
        parsedColor,
        parsedVariant,
        ghost
    ]);
    const isDanger = mergedColor === 'danger';
    const mergedColorText = isDanger ? 'dangerous' : mergedColor;
    const { getPrefixCls: getPrefixCls, direction: direction, autoInsertSpace: contextAutoInsertSpace, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $dd01e2f5a4b8605d$export$46f4bd6436a25a31)('button');
    const mergedInsertSpace = autoInsertSpace ?? contextAutoInsertSpace ?? true;
    const prefixCls = getPrefixCls('btn', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $e7f196f9d120e8a1$export$2e2bcd8739ae039)(prefixCls);
    const disabled = (0, $32rMB.useContext)((0, $ff4b4ddbf52ed41f$export$2e2bcd8739ae039));
    const mergedDisabled = customDisabled ?? disabled;
    const groupSize = (0, $32rMB.useContext)((0, $ac1bd5b23bcbd4c2$export$ed0cc8bd1f617d6d));
    const loadingOrDelay = (0, $32rMB.useMemo)(()=>$33140907d397899a$var$getLoadingConfig(loading), [
        loading
    ]);
    const [innerLoading, setLoading] = (0, $32rMB.useState)(loadingOrDelay.loading);
    const [hasTwoCNChar, setHasTwoCNChar] = (0, $32rMB.useState)(false);
    const buttonRef = (0, $32rMB.useRef)(null);
    const mergedRef = (0, $2706ed817e87019d$export$1d1c999670a1285d)(ref, buttonRef);
    const needInserted = childNodes.length === 1 && !icon && !(0, $c59d4dc2abd8d863$export$b120bc11c0d9c214)(mergedVariant);
    // ========================= Mount ==========================
    // Record for mount status.
    // This will help to no to show the animation of loading on the first mount.
    const isMountRef = (0, $32rMB.useRef)(true);
    (0, $N3oW3.default).useEffect(()=>{
        isMountRef.current = false;
        return ()=>{
            isMountRef.current = true;
        };
    }, []);
    // ========================= Effect =========================
    // Loading. Should use `useLayoutEffect` to avoid low perf multiple click issue.
    // https://github.com/ant-design/ant-design/issues/51325
    (0, $60cea2402df671e7$export$2e2bcd8739ae039)(()=>{
        let delayTimer = null;
        if (loadingOrDelay.delay > 0) delayTimer = setTimeout(()=>{
            delayTimer = null;
            setLoading(true);
        }, loadingOrDelay.delay);
        else setLoading(loadingOrDelay.loading);
        function cleanupTimer() {
            if (delayTimer) {
                clearTimeout(delayTimer);
                delayTimer = null;
            }
        }
        return cleanupTimer;
    }, [
        loadingOrDelay.delay,
        loadingOrDelay.loading
    ]);
    // Two chinese characters check
    (0, $32rMB.useEffect)(()=>{
        // FIXME: for HOC usage like <FormatMessage />
        if (!buttonRef.current || !mergedInsertSpace) return;
        const buttonText = buttonRef.current.textContent || '';
        if (needInserted && (0, $c59d4dc2abd8d863$export$c5dca2bf412dea0d)(buttonText)) {
            if (!hasTwoCNChar) setHasTwoCNChar(true);
        } else if (hasTwoCNChar) setHasTwoCNChar(false);
    });
    // Auto focus
    (0, $32rMB.useEffect)(()=>{
        if (autoFocus && buttonRef.current) buttonRef.current.focus();
    }, []);
    // ========================= Events =========================
    const handleClick = (0, $N3oW3.default).useCallback((e)=>{
        // FIXME: https://github.com/ant-design/ant-design/issues/30207
        if (innerLoading || mergedDisabled) {
            e.preventDefault();
            return;
        }
        props.onClick?.('href' in props ? e : e);
    }, [
        props.onClick,
        innerLoading,
        mergedDisabled
    ]);
    // ========================== Size ==========================
    const { compactSize: compactSize, compactItemClassnames: compactItemClassnames } = (0, $085e8dc0a3d19960$export$cd8cf9d7bab8dd4)(prefixCls, direction);
    const sizeClassNameMap = {
        large: 'lg',
        small: 'sm',
        middle: undefined
    };
    const sizeFullName = (0, $324b30eda6ea1cd7$export$2e2bcd8739ae039)((ctxSize)=>customizeSize ?? compactSize ?? groupSize ?? ctxSize);
    const sizeCls = sizeFullName ? sizeClassNameMap[sizeFullName] ?? '' : '';
    const iconType = innerLoading ? 'loading' : icon;
    const mergedIconPlacement = iconPlacement ?? iconPosition ?? 'start';
    const linkButtonRestProps = (0, $f4cf9c2e27c0ac8d$export$2e2bcd8739ae039)(rest, [
        'navigate'
    ]);
    // =========== Merged Props for Semantic ===========
    const mergedProps = {
        ...props,
        type: mergedType,
        color: mergedColor,
        variant: mergedVariant,
        danger: isDanger,
        shape: shape,
        size: sizeFullName,
        disabled: mergedDisabled,
        loading: innerLoading,
        iconPlacement: mergedIconPlacement
    };
    // ========================= Style ==========================
    const [mergedClassNames, mergedStyles] = (0, $4dcf69d8c3d6df5c$export$648566b068f28737)([
        _skipSemantic ? undefined : contextClassNames,
        classNames
    ], [
        _skipSemantic ? undefined : contextStyles,
        styles
    ], {
        props: mergedProps
    });
    // ========================= Render =========================
    const classes = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, hashId, cssVarCls, {
        [`${prefixCls}-${shape}`]: shape !== 'default' && shape !== 'square' && shape,
        // Compatible with versions earlier than 5.21.0
        [`${prefixCls}-${mergedType}`]: mergedType,
        [`${prefixCls}-dangerous`]: danger,
        [`${prefixCls}-color-${mergedColorText}`]: mergedColorText,
        [`${prefixCls}-variant-${mergedVariant}`]: mergedVariant,
        [`${prefixCls}-${sizeCls}`]: sizeCls,
        [`${prefixCls}-icon-only`]: !children && children !== 0 && !!iconType,
        [`${prefixCls}-background-ghost`]: ghost && !(0, $c59d4dc2abd8d863$export$b120bc11c0d9c214)(mergedVariant),
        [`${prefixCls}-loading`]: innerLoading,
        [`${prefixCls}-two-chinese-chars`]: hasTwoCNChar && mergedInsertSpace && !innerLoading,
        [`${prefixCls}-block`]: block,
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-icon-end`]: mergedIconPlacement === 'end'
    }, compactItemClassnames, className, rootClassName, contextClassName, mergedClassNames.root);
    const fullStyle = {
        ...mergedStyles.root,
        ...contextStyle,
        ...style
    };
    const iconSharedProps = {
        className: mergedClassNames.icon,
        style: mergedStyles.icon
    };
    /**
   * Extract icon node
   * If there is a custom icon and not in loading state: show custom icon
   */ const iconWrapperElement = (child)=>/*#__PURE__*/ (0, $N3oW3.default).createElement((0, $1801985a04a36901$export$2e2bcd8739ae039), {
            prefixCls: prefixCls,
            ...iconSharedProps
        }, child);
    const defaultLoadingIconElement = /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $5158f4bd8b12bdc4$export$2e2bcd8739ae039), {
        existIcon: !!icon,
        prefixCls: prefixCls,
        loading: innerLoading,
        mount: isMountRef.current,
        ...iconSharedProps
    });
    /**
   * Using if-else statements can improve code readability without affecting future expansion.
   */ let iconNode;
    if (icon && !innerLoading) iconNode = iconWrapperElement(icon);
    else if (loading && typeof loading === 'object' && loading.icon) iconNode = iconWrapperElement(loading.icon);
    else iconNode = defaultLoadingIconElement;
    const contentNode = (0, $95ac4c3d4339216e$export$2e2bcd8739ae039)(children) ? (0, $c59d4dc2abd8d863$export$b6ee00a7e7908bc)(children, needInserted && mergedInsertSpace, mergedStyles.content, mergedClassNames.content) : null;
    if (linkButtonRestProps.href !== undefined) return /*#__PURE__*/ (0, $N3oW3.default).createElement("a", {
        ...linkButtonRestProps,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(classes, {
            [`${prefixCls}-disabled`]: mergedDisabled
        }),
        href: mergedDisabled ? undefined : linkButtonRestProps.href,
        style: fullStyle,
        onClick: handleClick,
        ref: mergedRef,
        tabIndex: mergedDisabled ? -1 : 0,
        "aria-disabled": mergedDisabled
    }, iconNode, contentNode);
    let buttonNode = /*#__PURE__*/ (0, $N3oW3.default).createElement("button", {
        ...rest,
        type: htmlType,
        className: classes,
        style: fullStyle,
        onClick: handleClick,
        disabled: mergedDisabled,
        ref: mergedRef
    }, iconNode, contentNode, compactItemClassnames && /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $0345c5e64e2857f0$export$2e2bcd8739ae039), {
        prefixCls: prefixCls
    }));
    if (!(0, $c59d4dc2abd8d863$export$b120bc11c0d9c214)(mergedVariant)) buttonNode = /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $b6fefae43eb584fa$export$2e2bcd8739ae039), {
        component: "Button",
        disabled: innerLoading
    }, buttonNode);
    return buttonNode;
});
const $33140907d397899a$var$Button = $33140907d397899a$var$InternalCompoundedButton;
$33140907d397899a$var$Button.Group = (0, $ac1bd5b23bcbd4c2$export$2e2bcd8739ae039);
$33140907d397899a$var$Button.__ANT_BUTTON = true;
var $33140907d397899a$export$2e2bcd8739ae039 = $33140907d397899a$var$Button;



"use client";
var $9632ad3149894c43$export$2e2bcd8739ae039 = (0, $33140907d397899a$export$2e2bcd8739ae039);


var $N3oW3 = parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");
parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
// This icon file is generated automatically.
var $0d93a8b98f62c9b7$var$LeftOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 000 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z"
                }
            }
        ]
    },
    "name": "left",
    "theme": "outlined"
};
var $0d93a8b98f62c9b7$export$2e2bcd8739ae039 = $0d93a8b98f62c9b7$var$LeftOutlined;



function $e4b471ef5251dafb$var$_extends() {
    $e4b471ef5251dafb$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e4b471ef5251dafb$var$_extends.apply(this, arguments);
}
const $e4b471ef5251dafb$var$LeftOutlined = (props, ref)=>/*#__PURE__*/ $hO8yS.createElement((0, $5fd6f3f3c400c267$export$2e2bcd8739ae039), $e4b471ef5251dafb$var$_extends({}, props, {
        ref: ref,
        icon: (0, $0d93a8b98f62c9b7$export$2e2bcd8739ae039)
    }));
/**![left](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTcyNCAyMTguM1YxNDFjMC02LjctNy43LTEwLjQtMTIuOS02LjNMMjYwLjMgNDg2LjhhMzEuODYgMzEuODYgMCAwMDAgNTAuM2w0NTAuOCAzNTIuMWM1LjMgNC4xIDEyLjkuNCAxMi45LTYuM3YtNzcuM2MwLTQuOS0yLjMtOS42LTYuMS0xMi42bC0zNjAtMjgxIDM2MC0yODEuMWMzLjgtMyA2LjEtNy43IDYuMS0xMi42eiIgLz48L3N2Zz4=) */ const $e4b471ef5251dafb$var$RefIcon = /*#__PURE__*/ $N3oW3.forwardRef($e4b471ef5251dafb$var$LeftOutlined);
var $e4b471ef5251dafb$export$2e2bcd8739ae039 = $e4b471ef5251dafb$var$RefIcon;







var $N3oW3 = parcelRequire("N3oW3");


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
const { ESC: $4054aedde8c351e3$var$ESC, TAB: $4054aedde8c351e3$var$TAB } = (0, $4d7d870d585f8465$export$2e2bcd8739ae039);
function $4054aedde8c351e3$export$2e2bcd8739ae039({ visible: visible, triggerRef: triggerRef, onVisibleChange: onVisibleChange, autoFocus: autoFocus, overlayRef: overlayRef }) {
    const focusMenuRef = $32rMB.useRef(false);
    const handleCloseMenuAndReturnFocus = ()=>{
        if (visible) {
            triggerRef.current?.focus?.();
            onVisibleChange?.(false);
        }
    };
    const focusMenu = ()=>{
        if (overlayRef.current?.focus) {
            overlayRef.current.focus();
            focusMenuRef.current = true;
            return true;
        }
        return false;
    };
    const handleKeyDown = (event)=>{
        switch(event.keyCode){
            case $4054aedde8c351e3$var$ESC:
                handleCloseMenuAndReturnFocus();
                break;
            case $4054aedde8c351e3$var$TAB:
                {
                    let focusResult = false;
                    if (!focusMenuRef.current) focusResult = focusMenu();
                    if (focusResult) event.preventDefault();
                    else handleCloseMenuAndReturnFocus();
                    break;
                }
        }
    };
    $32rMB.useEffect(()=>{
        if (visible) {
            window.addEventListener('keydown', handleKeyDown);
            if (autoFocus) // FIXME: hack with raf
            (0, $c9c36e20d667d30c$export$2e2bcd8739ae039)(focusMenu, 3);
            return ()=>{
                window.removeEventListener('keydown', handleKeyDown);
                focusMenuRef.current = false;
            };
        }
        return ()=>{
            focusMenuRef.current = false;
        };
    }, [
        visible
    ]); // eslint-disable-line react-hooks/exhaustive-deps
}




var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
const $d90e2fffca8a9be6$var$Overlay = /*#__PURE__*/ (0, $N3oW3.forwardRef)((props, ref)=>{
    const { overlay: overlay, arrow: arrow, prefixCls: prefixCls } = props;
    const overlayNode = (0, $32rMB.useMemo)(()=>{
        let overlayElement;
        if (typeof overlay === 'function') overlayElement = overlay();
        else overlayElement = overlay;
        return overlayElement;
    }, [
        overlay
    ]);
    const composedRef = (0, $2706ed817e87019d$export$ab452c34e8e05029)(ref, (0, $2706ed817e87019d$export$7465e5c0bf44f19a)(overlayNode));
    return /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $N3oW3.default).Fragment, null, arrow && /*#__PURE__*/ (0, $N3oW3.default).createElement("div", {
        className: `${prefixCls}-arrow`
    }), /*#__PURE__*/ (0, $N3oW3.default).cloneElement(overlayNode, {
        ref: (0, $2706ed817e87019d$export$c1cec34af06bcf7)(overlayNode) ? composedRef : undefined
    }));
});
var $d90e2fffca8a9be6$export$2e2bcd8739ae039 = $d90e2fffca8a9be6$var$Overlay;


const $bd8d35b7af230425$var$autoAdjustOverflow = {
    adjustX: 1,
    adjustY: 1
};
const $bd8d35b7af230425$var$targetOffset = [
    0,
    0
];
const $bd8d35b7af230425$var$placements = {
    topLeft: {
        points: [
            'bl',
            'tl'
        ],
        overflow: $bd8d35b7af230425$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $bd8d35b7af230425$var$targetOffset
    },
    top: {
        points: [
            'bc',
            'tc'
        ],
        overflow: $bd8d35b7af230425$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $bd8d35b7af230425$var$targetOffset
    },
    topRight: {
        points: [
            'br',
            'tr'
        ],
        overflow: $bd8d35b7af230425$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $bd8d35b7af230425$var$targetOffset
    },
    bottomLeft: {
        points: [
            'tl',
            'bl'
        ],
        overflow: $bd8d35b7af230425$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $bd8d35b7af230425$var$targetOffset
    },
    bottom: {
        points: [
            'tc',
            'bc'
        ],
        overflow: $bd8d35b7af230425$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $bd8d35b7af230425$var$targetOffset
    },
    bottomRight: {
        points: [
            'tr',
            'br'
        ],
        overflow: $bd8d35b7af230425$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $bd8d35b7af230425$var$targetOffset
    }
};
var $bd8d35b7af230425$export$2e2bcd8739ae039 = $bd8d35b7af230425$var$placements;


function $ff8cad9b94be20b0$var$_extends() {
    $ff8cad9b94be20b0$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ff8cad9b94be20b0$var$_extends.apply(this, arguments);
}
const $ff8cad9b94be20b0$var$Dropdown = /*#__PURE__*/ (0, $N3oW3.default).forwardRef((props, ref)=>{
    const { arrow: arrow = false, prefixCls: prefixCls = 'rc-dropdown', transitionName: transitionName, animation: animation, align: align, placement: placement = 'bottomLeft', placements: placements = (0, $bd8d35b7af230425$export$2e2bcd8739ae039), getPopupContainer: getPopupContainer, showAction: showAction, hideAction: hideAction, overlayClassName: overlayClassName, overlayStyle: overlayStyle, visible: visible, trigger: trigger = [
        'hover'
    ], autoFocus: autoFocus, overlay: overlay, children: children, onVisibleChange: onVisibleChange, ...otherProps } = props;
    const [triggerVisible, setTriggerVisible] = (0, $N3oW3.default).useState();
    const mergedVisible = 'visible' in props ? visible : triggerVisible;
    const mergedMotionName = animation ? `${prefixCls}-${animation}` : transitionName;
    const triggerRef = (0, $N3oW3.default).useRef(null);
    const overlayRef = (0, $N3oW3.default).useRef(null);
    const childRef = (0, $N3oW3.default).useRef(null);
    (0, $N3oW3.default).useImperativeHandle(ref, ()=>triggerRef.current);
    const handleVisibleChange = (newVisible)=>{
        setTriggerVisible(newVisible);
        onVisibleChange?.(newVisible);
    };
    (0, $4054aedde8c351e3$export$2e2bcd8739ae039)({
        visible: mergedVisible,
        triggerRef: childRef,
        onVisibleChange: handleVisibleChange,
        autoFocus: autoFocus,
        overlayRef: overlayRef
    });
    const onClick = (e)=>{
        const { onOverlayClick: onOverlayClick } = props;
        setTriggerVisible(false);
        if (onOverlayClick) onOverlayClick(e);
    };
    const getMenuElement = ()=>/*#__PURE__*/ (0, $N3oW3.default).createElement((0, $d90e2fffca8a9be6$export$2e2bcd8739ae039), {
            ref: overlayRef,
            overlay: overlay,
            prefixCls: prefixCls,
            arrow: arrow
        });
    const getMenuElementOrLambda = ()=>{
        if (typeof overlay === 'function') return getMenuElement;
        return getMenuElement();
    };
    const getMinOverlayWidthMatchTrigger = ()=>{
        const { minOverlayWidthMatchTrigger: minOverlayWidthMatchTrigger, alignPoint: alignPoint } = props;
        if ('minOverlayWidthMatchTrigger' in props) return minOverlayWidthMatchTrigger;
        return !alignPoint;
    };
    const getOpenClassName = ()=>{
        const { openClassName: openClassName } = props;
        if (openClassName !== undefined) return openClassName;
        return `${prefixCls}-open`;
    };
    const childrenNode = /*#__PURE__*/ (0, $N3oW3.default).cloneElement(children, {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(children.props?.className, mergedVisible && getOpenClassName()),
        ref: (0, $2706ed817e87019d$export$c1cec34af06bcf7)(children) ? (0, $2706ed817e87019d$export$ab452c34e8e05029)(childRef, (0, $2706ed817e87019d$export$7465e5c0bf44f19a)(children)) : undefined
    });
    let triggerHideAction = hideAction;
    if (!triggerHideAction && trigger.indexOf('contextMenu') !== -1) triggerHideAction = [
        'click'
    ];
    return /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $0cc98d0cfc01331c$export$2e2bcd8739ae039), $ff8cad9b94be20b0$var$_extends({
        builtinPlacements: placements
    }, otherProps, {
        prefixCls: prefixCls,
        ref: triggerRef,
        popupClassName: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(overlayClassName, {
            [`${prefixCls}-show-arrow`]: arrow
        }),
        popupStyle: overlayStyle,
        action: trigger,
        showAction: showAction,
        hideAction: triggerHideAction,
        popupPlacement: placement,
        popupAlign: align,
        popupMotion: {
            motionName: mergedMotionName
        },
        popupVisible: mergedVisible,
        stretch: getMinOverlayWidthMatchTrigger() ? 'minWidth' : '',
        popup: getMenuElementOrLambda(),
        onOpenChange: handleVisibleChange,
        onPopupClick: onClick,
        getPopupContainer: getPopupContainer
    }), childrenNode);
});
var $ff8cad9b94be20b0$export$2e2bcd8739ae039 = $ff8cad9b94be20b0$var$Dropdown;


var $d0c9855484e57e9e$export$2e2bcd8739ae039 = (0, $ff8cad9b94be20b0$export$2e2bcd8739ae039);





const $d4f9e905b2d01ac8$var$isPrimitive = (value)=>typeof value !== 'object' && typeof value !== 'function' || value === null;
var $d4f9e905b2d01ac8$export$2e2bcd8739ae039 = $d4f9e905b2d01ac8$var$isPrimitive;



parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");


"use client";
function $63c4642dc3601d57$export$29e2a8c3cdb34b03(Component) {
    return (props)=>/*#__PURE__*/ $hO8yS.createElement((0, $6ff80b51bd11b92e$export$2e2bcd8739ae039), {
            theme: {
                token: {
                    motion: false,
                    zIndexPopupBase: 0
                }
            }
        }, /*#__PURE__*/ $hO8yS.createElement(Component, {
            ...props
        }));
}
/* istanbul ignore next */ const $63c4642dc3601d57$var$genPurePanel = (Component, alignPropName, postProps, defaultPrefixCls, getDropdownCls)=>{
    const PurePanel = (props)=>{
        const { prefixCls: customizePrefixCls, style: style } = props;
        const holderRef = $32rMB.useRef(null);
        const [popupHeight, setPopupHeight] = $32rMB.useState(0);
        const [popupWidth, setPopupWidth] = $32rMB.useState(0);
        const [open, setOpen] = (0, $05ea6e97cee440ee$export$2e2bcd8739ae039)(false, props.open);
        const { getPrefixCls: getPrefixCls } = $32rMB.useContext((0, $dd01e2f5a4b8605d$export$a92f85ab3e9ad68b));
        const prefixCls = getPrefixCls(defaultPrefixCls || 'select', customizePrefixCls);
        $32rMB.useEffect(()=>{
            // We do not care about ssr
            setOpen(true);
            if (typeof ResizeObserver !== 'undefined') {
                const resizeObserver = new ResizeObserver((entries)=>{
                    const element = entries[0].target;
                    setPopupHeight(element.offsetHeight + 8);
                    setPopupWidth(element.offsetWidth);
                });
                const interval = setInterval(()=>{
                    const dropdownCls = getDropdownCls ? `.${getDropdownCls(prefixCls)}` : `.${prefixCls}-dropdown`;
                    const popup = holderRef.current?.querySelector(dropdownCls);
                    if (popup) {
                        clearInterval(interval);
                        resizeObserver.observe(popup);
                    }
                }, 10);
                return ()=>{
                    clearInterval(interval);
                    resizeObserver.disconnect();
                };
            }
        }, [
            prefixCls
        ]);
        let mergedProps = {
            ...props,
            style: {
                ...style,
                margin: 0
            },
            open: open,
            getPopupContainer: ()=>holderRef.current
        };
        if (postProps) mergedProps = postProps(mergedProps);
        if (alignPropName) Object.assign(mergedProps, {
            [alignPropName]: {
                overflow: {
                    adjustX: false,
                    adjustY: false
                }
            }
        });
        const mergedStyle = {
            paddingBottom: popupHeight,
            position: 'relative',
            minWidth: popupWidth
        };
        return /*#__PURE__*/ $hO8yS.createElement("div", {
            ref: holderRef,
            style: mergedStyle
        }, /*#__PURE__*/ $hO8yS.createElement(Component, {
            ...mergedProps
        }));
    };
    return $63c4642dc3601d57$export$29e2a8c3cdb34b03(PurePanel);
};
var $63c4642dc3601d57$export$2e2bcd8739ae039 = $63c4642dc3601d57$var$genPurePanel;







parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");




function $a396812ba85d91d0$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $e942b529d3ff1978$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $a396812ba85d91d0$export$2e2bcd8739ae039)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
var $852a55cf17d8b19d$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if ($852a55cf17d8b19d$exports) {
        classNames.default = classNames;
        $852a55cf17d8b19d$exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();



parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");

var $131625b110d08713$var$REACT_ELEMENT_TYPE_18 = Symbol.for('react.element');
var $131625b110d08713$var$REACT_ELEMENT_TYPE_19 = Symbol.for('react.transitional.element');
var $131625b110d08713$var$REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
function $131625b110d08713$export$2e2bcd8739ae039(object) {
    return(// Base object type
    object && (0, $c5ac91862c8363d3$export$2e2bcd8739ae039)(object) === 'object' && // React Element type
    (object.$$typeof === $131625b110d08713$var$REACT_ELEMENT_TYPE_18 || object.$$typeof === $131625b110d08713$var$REACT_ELEMENT_TYPE_19) && // React Fragment type
    object.type === $131625b110d08713$var$REACT_FRAGMENT_TYPE);
}



var $N3oW3 = parcelRequire("N3oW3");
function $033d3b00e1440394$export$2e2bcd8739ae039(children) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var ret = [];
    (0, $N3oW3.default).Children.forEach(children, function(child) {
        if ((child === undefined || child === null) && !option.keepEmpty) return;
        if (Array.isArray(child)) ret = ret.concat($033d3b00e1440394$export$2e2bcd8739ae039(child));
        else if ((0, $131625b110d08713$export$2e2bcd8739ae039)(child) && child.props) ret = ret.concat($033d3b00e1440394$export$2e2bcd8739ae039(child.props.children, option));
        else ret.push(child);
    });
    return ret;
}


/* eslint-disable no-console */ var $a38e311b37447021$var$warned = {};
var $a38e311b37447021$var$preWarningFns = [];
var $a38e311b37447021$export$61616f168f0e5a05 = function preMessage(fn) {
    $a38e311b37447021$var$preWarningFns.push(fn);
};
function $a38e311b37447021$export$491112666e282270(valid, message) {
    var finalMessage;
}
function $a38e311b37447021$export$a92e4c44d367d0af(valid, message) {
    var finalMessage;
}
function $a38e311b37447021$export$60eef1277fe463e4() {
    $a38e311b37447021$var$warned = {};
}
function $a38e311b37447021$export$848feb93d8f32b9b(method, valid, message) {
    if (!valid && !$a38e311b37447021$var$warned[message]) {
        method(false, message);
        $a38e311b37447021$var$warned[message] = true;
    }
}
function $a38e311b37447021$export$82934adf09101657(valid, message) {
    $a38e311b37447021$export$848feb93d8f32b9b($a38e311b37447021$export$491112666e282270, valid, message);
}
function $a38e311b37447021$export$89ff31684837bbbf(valid, message) {
    $a38e311b37447021$export$848feb93d8f32b9b($a38e311b37447021$export$a92e4c44d367d0af, valid, message);
}
$a38e311b37447021$export$82934adf09101657.preMessage = $a38e311b37447021$export$61616f168f0e5a05;
$a38e311b37447021$export$82934adf09101657.resetWarned = $a38e311b37447021$export$60eef1277fe463e4;
$a38e311b37447021$export$82934adf09101657.noteOnce = $a38e311b37447021$export$89ff31684837bbbf;
var $a38e311b37447021$export$2e2bcd8739ae039 = $a38e311b37447021$export$82934adf09101657;






var $N3oW3 = parcelRequire("N3oW3");

var $N3oW3 = parcelRequire("N3oW3");
function $0227b30c33fc1ed1$export$41e30d8dd0ba7a50(node) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Element
    // Since XULElement is also subclass of Element, we only need HTMLElement and SVGElement
    return node instanceof HTMLElement || node instanceof SVGElement;
}
function $0227b30c33fc1ed1$export$9aa546fdc20ae5b3(node) {
    if (node && (0, $c5ac91862c8363d3$export$2e2bcd8739ae039)(node) === 'object' && $0227b30c33fc1ed1$export$41e30d8dd0ba7a50(node.nativeElement)) return node.nativeElement;
    if ($0227b30c33fc1ed1$export$41e30d8dd0ba7a50(node)) return node;
    return null;
}
function $0227b30c33fc1ed1$export$2e2bcd8739ae039(node) {
    var domNode = $0227b30c33fc1ed1$export$9aa546fdc20ae5b3(node);
    if (domNode) return domNode;
    if (node instanceof (0, $N3oW3.default).Component) {
        var _ReactDOM$findDOMNode;
        return (_ReactDOM$findDOMNode = (0, $N3oW3.default).findDOMNode) === null || _ReactDOM$findDOMNode === void 0 ? void 0 : _ReactDOM$findDOMNode.call((0, $N3oW3.default), node);
    }
    return null;
}




var $N3oW3 = parcelRequire("N3oW3");

parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
function $9f6f67944c6bf803$export$2e2bcd8739ae039(getValue, condition, shouldUpdate) {
    var cacheRef = $32rMB.useRef({});
    if (!('value' in cacheRef.current) || shouldUpdate(cacheRef.current.condition, condition)) {
        cacheRef.current.value = getValue();
        cacheRef.current.condition = condition;
    }
    return cacheRef.current.value;
}



var $0139c34d2bcdde95$var$ReactMajorVersion = Number((0, $N3oW3.version).split('.')[0]);
var $0139c34d2bcdde95$export$f17fd18fa51dcb5b = function fillRef(ref, node) {
    if (typeof ref === 'function') ref(node);
    else if ((0, $c5ac91862c8363d3$export$2e2bcd8739ae039)(ref) === 'object' && ref && 'current' in ref) ref.current = node;
};
var $0139c34d2bcdde95$export$ab452c34e8e05029 = function composeRef() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++)refs[_key] = arguments[_key];
    var refList = refs.filter(Boolean);
    if (refList.length <= 1) return refList[0];
    return function(node) {
        refs.forEach(function(ref) {
            $0139c34d2bcdde95$export$f17fd18fa51dcb5b(ref, node);
        });
    };
};
var $0139c34d2bcdde95$export$1d1c999670a1285d = function useComposeRef() {
    for(var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)refs[_key2] = arguments[_key2];
    return (0, $9f6f67944c6bf803$export$2e2bcd8739ae039)(function() {
        return $0139c34d2bcdde95$export$ab452c34e8e05029.apply(void 0, refs);
    }, refs, function(prev, next) {
        return prev.length !== next.length || prev.every(function(ref, i) {
            return ref !== next[i];
        });
    });
};
var $0139c34d2bcdde95$export$c1cec34af06bcf7 = function supportRef(nodeOrComponent) {
    var _type$prototype, _nodeOrComponent$prot;
    if (!nodeOrComponent) return false;
    // React 19 no need `forwardRef` anymore. So just pass if is a React element.
    if ($0139c34d2bcdde95$var$isReactElement(nodeOrComponent) && $0139c34d2bcdde95$var$ReactMajorVersion >= 19) return true;
    var type = (0, $a3de43725b7a590e$exports.isMemo)(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type;
    // Function component node
    if (typeof type === 'function' && !((_type$prototype = type.prototype) !== null && _type$prototype !== void 0 && _type$prototype.render) && type.$$typeof !== (0, $a3de43725b7a590e$exports.ForwardRef)) return false;
    // Class component
    if (typeof nodeOrComponent === 'function' && !((_nodeOrComponent$prot = nodeOrComponent.prototype) !== null && _nodeOrComponent$prot !== void 0 && _nodeOrComponent$prot.render) && nodeOrComponent.$$typeof !== (0, $a3de43725b7a590e$exports.ForwardRef)) return false;
    return true;
};
function $0139c34d2bcdde95$var$isReactElement(node) {
    return /*#__PURE__*/ (0, $N3oW3.isValidElement)(node) && !(0, $131625b110d08713$export$2e2bcd8739ae039)(node);
}
var $0139c34d2bcdde95$export$b51ae67c7882a242 = function supportNodeRef(node) {
    return $0139c34d2bcdde95$var$isReactElement(node) && $0139c34d2bcdde95$export$c1cec34af06bcf7(node);
};
var $0139c34d2bcdde95$export$7465e5c0bf44f19a = function getNodeRef(node) {
    if (node && $0139c34d2bcdde95$var$isReactElement(node)) {
        var ele = node;
        // Source from:
        // https://github.com/mui/material-ui/blob/master/packages/mui-utils/src/getReactNodeRef/getReactNodeRef.ts
        return ele.props.propertyIsEnumerable('ref') ? ele.props.ref : ele.ref;
    }
    return null;
};



var $N3oW3 = parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");
parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");
var $5caa21e5ebacd8b7$export$db36075d98ba73d3 = /*#__PURE__*/ $hO8yS.createContext(null);
function $5caa21e5ebacd8b7$export$fb8073518f34e6ec(_ref) {
    var children = _ref.children, onBatchResize = _ref.onBatchResize;
    var resizeIdRef = $32rMB.useRef(0);
    var resizeInfosRef = $32rMB.useRef([]);
    var onCollectionResize = $32rMB.useContext($5caa21e5ebacd8b7$export$db36075d98ba73d3);
    var onResize = $32rMB.useCallback(function(size, element, data) {
        resizeIdRef.current += 1;
        var currentId = resizeIdRef.current;
        resizeInfosRef.current.push({
            size: size,
            element: element,
            data: data
        });
        Promise.resolve().then(function() {
            if (currentId === resizeIdRef.current) {
                onBatchResize === null || onBatchResize === void 0 || onBatchResize(resizeInfosRef.current);
                resizeInfosRef.current = [];
            }
        });
        // Continue bubbling if parent exist
        onCollectionResize === null || onCollectionResize === void 0 || onCollectionResize(size, element, data);
    }, [
        onBatchResize,
        onCollectionResize
    ]);
    return /*#__PURE__*/ $hO8yS.createElement($5caa21e5ebacd8b7$export$db36075d98ba73d3.Provider, {
        value: onResize
    }, children);
}


/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */ /* eslint-disable require-jsdoc, valid-jsdoc */ var $cb70c6bc39638066$var$MapShim = function() {
    if (typeof Map !== 'undefined') return Map;
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */ function getIndex(arr, key) {
        var result = -1;
        arr.some(function(entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ function() {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */ get: function() {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */ class_1.prototype.get = function(key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */ class_1.prototype.set = function(key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) this.__entries__[index][1] = value;
            else this.__entries__.push([
                key,
                value
            ]);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.delete = function(key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) entries.splice(index, 1);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.has = function(key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */ class_1.prototype.clear = function() {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */ class_1.prototype.forEach = function(callback, ctx) {
            if (ctx === void 0) ctx = null;
            for(var _i = 0, _a = this.__entries__; _i < _a.length; _i++){
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }();
}();
/**
 * Detects whether window and document objects are available in current environment.
 */ var $cb70c6bc39638066$var$isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
// Returns global object of a current environment.
var $cb70c6bc39638066$var$global$1 = function() {
    if (typeof $parcel$global !== 'undefined' && $parcel$global.Math === Math) return $parcel$global;
    if (typeof self !== 'undefined' && self.Math === Math) return self;
    if (typeof window !== 'undefined' && window.Math === Math) return window;
    // eslint-disable-next-line no-new-func
    return Function('return this')();
}();
/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */ var $cb70c6bc39638066$var$requestAnimationFrame$1 = function() {
    if (typeof requestAnimationFrame === 'function') // It's required to use a bounded function because IE sometimes throws
    // an "Invalid calling object" error if rAF is invoked without the global
    // object on the left hand side.
    return requestAnimationFrame.bind($cb70c6bc39638066$var$global$1);
    return function(callback) {
        return setTimeout(function() {
            return callback(Date.now());
        }, 1000 / 60);
    };
}();
// Defines minimum timeout before adding a trailing call.
var $cb70c6bc39638066$var$trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */ function $cb70c6bc39638066$var$throttle(callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */ function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) proxy();
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */ function timeoutCallback() {
        $cb70c6bc39638066$var$requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */ function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < $cb70c6bc39638066$var$trailingTimeout) return;
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}
// Minimum delay before invoking the update of observers.
var $cb70c6bc39638066$var$REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var $cb70c6bc39638066$var$transitionKeys = [
    'top',
    'right',
    'bottom',
    'left',
    'width',
    'height',
    'size',
    'weight'
];
// Check if MutationObserver is available.
var $cb70c6bc39638066$var$mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */ var $cb70c6bc39638066$var$ResizeObserverController = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */ function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */ this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */ this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */ this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */ this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = $cb70c6bc39638066$var$throttle(this.refresh.bind(this), $cb70c6bc39638066$var$REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */ ResizeObserverController.prototype.addObserver = function(observer) {
        if (!~this.observers_.indexOf(observer)) this.observers_.push(observer);
        // Add listeners if they haven't been added yet.
        if (!this.connected_) this.connect_();
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */ ResizeObserverController.prototype.removeObserver = function(observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) observers.splice(index, 1);
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) this.disconnect_();
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */ ResizeObserverController.prototype.refresh = function() {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) this.refresh();
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */ ResizeObserverController.prototype.updateObservers_ = function() {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function(observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function(observer) {
            return observer.broadcastActive();
        });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.connect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!$cb70c6bc39638066$var$isBrowser || this.connected_) return;
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if ($cb70c6bc39638066$var$mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        } else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.disconnect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!$cb70c6bc39638066$var$isBrowser || !this.connected_) return;
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) this.mutationsObserver_.disconnect();
        if (this.mutationEventsAdded_) document.removeEventListener('DOMSubtreeModified', this.refresh);
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */ ResizeObserverController.prototype.onTransitionEnd_ = function(_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = $cb70c6bc39638066$var$transitionKeys.some(function(key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) this.refresh();
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */ ResizeObserverController.getInstance = function() {
        if (!this.instance_) this.instance_ = new ResizeObserverController();
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */ ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}();
/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */ var $cb70c6bc39638066$var$defineConfigurable = function(target, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
};
/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */ var $cb70c6bc39638066$var$getWindowOf = function(target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || $cb70c6bc39638066$var$global$1;
};
// Placeholder of an empty content rectangle.
var $cb70c6bc39638066$var$emptyRect = $cb70c6bc39638066$var$createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */ function $cb70c6bc39638066$var$toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */ function $cb70c6bc39638066$var$getBordersSize(styles) {
    var positions = [];
    for(var _i = 1; _i < arguments.length; _i++)positions[_i - 1] = arguments[_i];
    return positions.reduce(function(size, position) {
        var value = styles['border-' + position + '-width'];
        return size + $cb70c6bc39638066$var$toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */ function $cb70c6bc39638066$var$getPaddings(styles) {
    var positions = [
        'top',
        'right',
        'bottom',
        'left'
    ];
    var paddings = {};
    for(var _i = 0, positions_1 = positions; _i < positions_1.length; _i++){
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = $cb70c6bc39638066$var$toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */ function $cb70c6bc39638066$var$getSVGContentRect(target) {
    var bbox = target.getBBox();
    return $cb70c6bc39638066$var$createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */ function $cb70c6bc39638066$var$getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) return $cb70c6bc39638066$var$emptyRect;
    var styles = $cb70c6bc39638066$var$getWindowOf(target).getComputedStyle(target);
    var paddings = $cb70c6bc39638066$var$getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = $cb70c6bc39638066$var$toFloat(styles.width), height = $cb70c6bc39638066$var$toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) width -= $cb70c6bc39638066$var$getBordersSize(styles, 'left', 'right') + horizPad;
        if (Math.round(height + vertPad) !== clientHeight) height -= $cb70c6bc39638066$var$getBordersSize(styles, 'top', 'bottom') + vertPad;
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!$cb70c6bc39638066$var$isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) width -= vertScrollbar;
        if (Math.abs(horizScrollbar) !== 1) height -= horizScrollbar;
    }
    return $cb70c6bc39638066$var$createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ var $cb70c6bc39638066$var$isSVGGraphicsElement = function() {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') return function(target) {
        return target instanceof $cb70c6bc39638066$var$getWindowOf(target).SVGGraphicsElement;
    };
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function(target) {
        return target instanceof $cb70c6bc39638066$var$getWindowOf(target).SVGElement && typeof target.getBBox === 'function';
    };
}();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ function $cb70c6bc39638066$var$isDocumentElement(target) {
    return target === $cb70c6bc39638066$var$getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */ function $cb70c6bc39638066$var$getContentRect(target) {
    if (!$cb70c6bc39638066$var$isBrowser) return $cb70c6bc39638066$var$emptyRect;
    if ($cb70c6bc39638066$var$isSVGGraphicsElement(target)) return $cb70c6bc39638066$var$getSVGContentRect(target);
    return $cb70c6bc39638066$var$getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */ function $cb70c6bc39638066$var$createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    $cb70c6bc39638066$var$defineConfigurable(rect, {
        x: x,
        y: y,
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */ function $cb70c6bc39638066$var$createRectInit(x, y, width, height) {
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */ var $cb70c6bc39638066$var$ResizeObservation = /** @class */ function() {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */ function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */ this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */ this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */ this.contentRect_ = $cb70c6bc39638066$var$createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */ ResizeObservation.prototype.isActive = function() {
        var rect = $cb70c6bc39638066$var$getContentRect(this.target);
        this.contentRect_ = rect;
        return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */ ResizeObservation.prototype.broadcastRect = function() {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}();
var $cb70c6bc39638066$var$ResizeObserverEntry = /** @class */ function() {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */ function ResizeObserverEntry(target, rectInit) {
        var contentRect = $cb70c6bc39638066$var$createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        $cb70c6bc39638066$var$defineConfigurable(this, {
            target: target,
            contentRect: contentRect
        });
    }
    return ResizeObserverEntry;
}();
var $cb70c6bc39638066$var$ResizeObserverSPI = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */ function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */ this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */ this.observations_ = new $cb70c6bc39638066$var$MapShim();
        if (typeof callback !== 'function') throw new TypeError('The callback provided as parameter 1 is not a function.');
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */ ResizeObserverSPI.prototype.observe = function(target) {
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) return;
        if (!(target instanceof $cb70c6bc39638066$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) return;
        observations.set(target, new $cb70c6bc39638066$var$ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */ ResizeObserverSPI.prototype.unobserve = function(target) {
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) return;
        if (!(target instanceof $cb70c6bc39638066$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) return;
        observations.delete(target);
        if (!observations.size) this.controller_.removeObserver(this);
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.disconnect = function() {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.gatherActive = function() {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function(observation) {
            if (observation.isActive()) _this.activeObservations_.push(observation);
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.broadcastActive = function() {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) return;
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function(observation) {
            return new $cb70c6bc39638066$var$ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.clearActive = function() {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */ ResizeObserverSPI.prototype.hasActive = function() {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}();
// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var $cb70c6bc39638066$var$observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new $cb70c6bc39638066$var$MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */ var $cb70c6bc39638066$var$ResizeObserver = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */ function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) throw new TypeError('Cannot call a class as a function.');
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        var controller = $cb70c6bc39638066$var$ResizeObserverController.getInstance();
        var observer = new $cb70c6bc39638066$var$ResizeObserverSPI(callback, controller, this);
        $cb70c6bc39638066$var$observers.set(this, observer);
    }
    return ResizeObserver;
}();
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function(method) {
    $cb70c6bc39638066$var$ResizeObserver.prototype[method] = function() {
        var _a;
        return (_a = $cb70c6bc39638066$var$observers.get(this))[method].apply(_a, arguments);
    };
});
var $cb70c6bc39638066$var$index = function() {
    // Export existing implementation if available.
    if (typeof $cb70c6bc39638066$var$global$1.ResizeObserver !== 'undefined') return $cb70c6bc39638066$var$global$1.ResizeObserver;
    return $cb70c6bc39638066$var$ResizeObserver;
}();
var $cb70c6bc39638066$export$2e2bcd8739ae039 = $cb70c6bc39638066$var$index;


// =============================== Const ===============================
var $7a69dcaffe4eba46$var$elementListeners = new Map();
function $7a69dcaffe4eba46$var$onResize(entities) {
    entities.forEach(function(entity) {
        var _elementListeners$get;
        var target = entity.target;
        (_elementListeners$get = $7a69dcaffe4eba46$var$elementListeners.get(target)) === null || _elementListeners$get === void 0 || _elementListeners$get.forEach(function(listener) {
            return listener(target);
        });
    });
}
// Note: ResizeObserver polyfill not support option to measure border-box resize
var $7a69dcaffe4eba46$var$resizeObserver = new (0, $cb70c6bc39638066$export$2e2bcd8739ae039)($7a69dcaffe4eba46$var$onResize);
var $7a69dcaffe4eba46$export$3fbe5a08fd9e4702 = null; // eslint-disable-line
var $7a69dcaffe4eba46$export$524f0fd3b47831a = null; // eslint-disable-line
function $7a69dcaffe4eba46$export$d1203567a167490e(element, callback) {
    if (!$7a69dcaffe4eba46$var$elementListeners.has(element)) {
        $7a69dcaffe4eba46$var$elementListeners.set(element, new Set());
        $7a69dcaffe4eba46$var$resizeObserver.observe(element);
    }
    $7a69dcaffe4eba46$var$elementListeners.get(element).add(callback);
}
function $7a69dcaffe4eba46$export$23a2283368c55ea2(element, callback) {
    if ($7a69dcaffe4eba46$var$elementListeners.has(element)) {
        $7a69dcaffe4eba46$var$elementListeners.get(element).delete(callback);
        if (!$7a69dcaffe4eba46$var$elementListeners.get(element).size) {
            $7a69dcaffe4eba46$var$resizeObserver.unobserve(element);
            $7a69dcaffe4eba46$var$elementListeners.delete(element);
        }
    }
}






parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
/**
 * Fallback to findDOMNode if origin ref do not provide any dom element
 */ var $fadcd127ebfc3b09$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    (0, $83a5b97ffa16e22b$export$2e2bcd8739ae039)(DomWrapper, _React$Component);
    var _super = (0, $c64121b56aafd1fd$export$2e2bcd8739ae039)(DomWrapper);
    function DomWrapper() {
        (0, $c27a1e671724260e$export$2e2bcd8739ae039)(this, DomWrapper);
        return _super.apply(this, arguments);
    }
    (0, $3d68cfa6e8f65ecd$export$2e2bcd8739ae039)(DomWrapper, [
        {
            key: "render",
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return DomWrapper;
}($hO8yS.Component);


function $729e216a452b3776$var$SingleObserver(props, ref) {
    var children = props.children, disabled = props.disabled;
    var elementRef = $32rMB.useRef(null);
    var wrapperRef = $32rMB.useRef(null);
    var onCollectionResize = $32rMB.useContext((0, $5caa21e5ebacd8b7$export$db36075d98ba73d3));
    // =========================== Children ===========================
    var isRenderProps = typeof children === 'function';
    var mergedChildren = isRenderProps ? children(elementRef) : children;
    // ============================= Size =============================
    var sizeRef = $32rMB.useRef({
        width: -1,
        height: -1,
        offsetWidth: -1,
        offsetHeight: -1
    });
    // ============================= Ref ==============================
    var canRef = !isRenderProps && /*#__PURE__*/ $N3oW3.isValidElement(mergedChildren) && (0, $0139c34d2bcdde95$export$c1cec34af06bcf7)(mergedChildren);
    var originRef = canRef ? (0, $0139c34d2bcdde95$export$7465e5c0bf44f19a)(mergedChildren) : null;
    var mergedRef = (0, $0139c34d2bcdde95$export$1d1c999670a1285d)(originRef, elementRef);
    var getDom = function getDom() {
        var _elementRef$current;
        return (0, $0227b30c33fc1ed1$export$2e2bcd8739ae039)(elementRef.current) || // Support `nativeElement` format
        (elementRef.current && (0, $c5ac91862c8363d3$export$2e2bcd8739ae039)(elementRef.current) === 'object' ? (0, $0227b30c33fc1ed1$export$2e2bcd8739ae039)((_elementRef$current = elementRef.current) === null || _elementRef$current === void 0 ? void 0 : _elementRef$current.nativeElement) : null) || (0, $0227b30c33fc1ed1$export$2e2bcd8739ae039)(wrapperRef.current);
    };
    $32rMB.useImperativeHandle(ref, function() {
        return getDom();
    });
    // =========================== Observe ============================
    var propsRef = $32rMB.useRef(props);
    propsRef.current = props;
    // Handler
    var onInternalResize = $32rMB.useCallback(function(target) {
        var _propsRef$current = propsRef.current, onResize = _propsRef$current.onResize, data = _propsRef$current.data;
        var _target$getBoundingCl = target.getBoundingClientRect(), width = _target$getBoundingCl.width, height = _target$getBoundingCl.height;
        var offsetWidth = target.offsetWidth, offsetHeight = target.offsetHeight;
        /**
     * Resize observer trigger when content size changed.
     * In most case we just care about element size,
     * let's use `boundary` instead of `contentRect` here to avoid shaking.
     */ var fixedWidth = Math.floor(width);
        var fixedHeight = Math.floor(height);
        if (sizeRef.current.width !== fixedWidth || sizeRef.current.height !== fixedHeight || sizeRef.current.offsetWidth !== offsetWidth || sizeRef.current.offsetHeight !== offsetHeight) {
            var size = {
                width: fixedWidth,
                height: fixedHeight,
                offsetWidth: offsetWidth,
                offsetHeight: offsetHeight
            };
            sizeRef.current = size;
            // IE is strange, right?
            var mergedOffsetWidth = offsetWidth === Math.round(width) ? width : offsetWidth;
            var mergedOffsetHeight = offsetHeight === Math.round(height) ? height : offsetHeight;
            var sizeInfo = (0, $cde876c32cf7555b$export$2e2bcd8739ae039)((0, $cde876c32cf7555b$export$2e2bcd8739ae039)({}, size), {}, {
                offsetWidth: mergedOffsetWidth,
                offsetHeight: mergedOffsetHeight
            });
            // Let collection know what happened
            onCollectionResize === null || onCollectionResize === void 0 || onCollectionResize(sizeInfo, target, data);
            if (onResize) // defer the callback but not defer to next frame
            Promise.resolve().then(function() {
                onResize(sizeInfo, target);
            });
        }
    }, []);
    // Dynamic observe
    $32rMB.useEffect(function() {
        var currentElement = getDom();
        if (currentElement && !disabled) (0, $7a69dcaffe4eba46$export$d1203567a167490e)(currentElement, onInternalResize);
        return function() {
            return (0, $7a69dcaffe4eba46$export$23a2283368c55ea2)(currentElement, onInternalResize);
        };
    }, [
        elementRef.current,
        disabled
    ]);
    // ============================ Render ============================
    return /*#__PURE__*/ $hO8yS.createElement((0, $fadcd127ebfc3b09$export$2e2bcd8739ae039), {
        ref: wrapperRef
    }, canRef ? /*#__PURE__*/ $N3oW3.cloneElement(mergedChildren, {
        ref: mergedRef
    }) : mergedChildren);
}
var $729e216a452b3776$var$RefSingleObserver = /*#__PURE__*/ $N3oW3.forwardRef($729e216a452b3776$var$SingleObserver);
var $729e216a452b3776$export$2e2bcd8739ae039 = $729e216a452b3776$var$RefSingleObserver;




var $46befc6c0d7dbbd8$var$INTERNAL_PREFIX_KEY = 'rc-observer-key';
function $46befc6c0d7dbbd8$var$ResizeObserver(props, ref) {
    var children = props.children;
    var childNodes = typeof children === 'function' ? [
        children
    ] : (0, $033d3b00e1440394$export$2e2bcd8739ae039)(children);
    return childNodes.map(function(child, index) {
        var key = (child === null || child === void 0 ? void 0 : child.key) || "".concat($46befc6c0d7dbbd8$var$INTERNAL_PREFIX_KEY, "-").concat(index);
        return /*#__PURE__*/ $hO8yS.createElement((0, $729e216a452b3776$export$2e2bcd8739ae039), (0, $4dfb8f1fff0cbd5e$export$2e2bcd8739ae039)({}, props, {
            key: key,
            ref: index === 0 ? ref : undefined
        }), child);
    });
}
var $46befc6c0d7dbbd8$var$RefResizeObserver = /*#__PURE__*/ $N3oW3.forwardRef($46befc6c0d7dbbd8$var$ResizeObserver);
$46befc6c0d7dbbd8$var$RefResizeObserver.Collection = (0, $5caa21e5ebacd8b7$export$fb8073518f34e6ec);
var $46befc6c0d7dbbd8$export$2e2bcd8739ae039 = $46befc6c0d7dbbd8$var$RefResizeObserver;


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
function $6dbb6821b6efdbae$export$2e2bcd8739ae039() {
    return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}


/**
 * Wrap `React.useLayoutEffect` which will not throw warning message in test env
 */ var $af1ff2ee9ec51f79$var$useInternalLayoutEffect = (0, $6dbb6821b6efdbae$export$2e2bcd8739ae039)() ? $32rMB.useLayoutEffect : $32rMB.useEffect;
var $af1ff2ee9ec51f79$var$useLayoutEffect = function useLayoutEffect(callback, deps) {
    var firstMountRef = $32rMB.useRef(true);
    $af1ff2ee9ec51f79$var$useInternalLayoutEffect(function() {
        return callback(firstMountRef.current);
    }, deps);
    // We tell react that first mount has passed
    $af1ff2ee9ec51f79$var$useInternalLayoutEffect(function() {
        firstMountRef.current = false;
        return function() {
            firstMountRef.current = true;
        };
    }, []);
};
var $af1ff2ee9ec51f79$export$9283e56bae2f7b0f = function useLayoutUpdateEffect(callback, deps) {
    $af1ff2ee9ec51f79$var$useLayoutEffect(function(firstMount) {
        if (!firstMount) return callback();
    }, deps);
};
var $af1ff2ee9ec51f79$export$2e2bcd8739ae039 = $af1ff2ee9ec51f79$var$useLayoutEffect;





parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");


var $e97189498885750a$var$_excluded = [
    "prefixCls",
    "invalidate",
    "item",
    "renderItem",
    "responsive",
    "responsiveDisabled",
    "registerSize",
    "itemKey",
    "className",
    "style",
    "children",
    "display",
    "order",
    "component"
];
// Use shared variable to save bundle size
var $e97189498885750a$var$UNDEFINED = undefined;
function $e97189498885750a$var$InternalItem(props, ref) {
    var prefixCls = props.prefixCls, invalidate = props.invalidate, item = props.item, renderItem = props.renderItem, responsive = props.responsive, responsiveDisabled = props.responsiveDisabled, registerSize = props.registerSize, itemKey = props.itemKey, className = props.className, style = props.style, children = props.children, display = props.display, order = props.order, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, restProps = (0, $e942b529d3ff1978$export$2e2bcd8739ae039)(props, $e97189498885750a$var$_excluded);
    var mergedHidden = responsive && !display;
    // ================================ Effect ================================
    function internalRegisterSize(width) {
        registerSize(itemKey, width);
    }
    $32rMB.useEffect(function() {
        return function() {
            internalRegisterSize(null);
        };
    }, []);
    // ================================ Render ================================
    var childNode = renderItem && item !== $e97189498885750a$var$UNDEFINED ? renderItem(item, {
        index: order
    }) : children;
    var overflowStyle;
    if (!invalidate) overflowStyle = {
        opacity: mergedHidden ? 0 : 1,
        height: mergedHidden ? 0 : $e97189498885750a$var$UNDEFINED,
        overflowY: mergedHidden ? 'hidden' : $e97189498885750a$var$UNDEFINED,
        order: responsive ? order : $e97189498885750a$var$UNDEFINED,
        pointerEvents: mergedHidden ? 'none' : $e97189498885750a$var$UNDEFINED,
        position: mergedHidden ? 'absolute' : $e97189498885750a$var$UNDEFINED
    };
    var overflowProps = {};
    if (mergedHidden) overflowProps['aria-hidden'] = true;
    var itemNode = /*#__PURE__*/ $hO8yS.createElement(Component, (0, $4dfb8f1fff0cbd5e$export$2e2bcd8739ae039)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(!invalidate && prefixCls, className),
        style: (0, $cde876c32cf7555b$export$2e2bcd8739ae039)((0, $cde876c32cf7555b$export$2e2bcd8739ae039)({}, overflowStyle), style)
    }, overflowProps, restProps, {
        ref: ref
    }), childNode);
    if (responsive) itemNode = /*#__PURE__*/ $hO8yS.createElement((0, $46befc6c0d7dbbd8$export$2e2bcd8739ae039), {
        onResize: function onResize(_ref) {
            var offsetWidth = _ref.offsetWidth;
            internalRegisterSize(offsetWidth);
        },
        disabled: responsiveDisabled
    }, itemNode);
    return itemNode;
}
var $e97189498885750a$var$Item = /*#__PURE__*/ $N3oW3.forwardRef($e97189498885750a$var$InternalItem);
$e97189498885750a$var$Item.displayName = 'Item';
var $e97189498885750a$export$2e2bcd8739ae039 = $e97189498885750a$var$Item;



parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
function $5c85f0dd15155745$export$2e2bcd8739ae039(callback) {
    var fnRef = $32rMB.useRef();
    fnRef.current = callback;
    var memoFn = $32rMB.useCallback(function() {
        var _fnRef$current;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return (_fnRef$current = fnRef.current) === null || _fnRef$current === void 0 ? void 0 : _fnRef$current.call.apply(_fnRef$current, [
            fnRef
        ].concat(args));
    }, []);
    return memoFn;
}


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");

var $N3oW3 = parcelRequire("N3oW3");
var $99b8d3464c57be61$var$raf = function raf(callback) {
    return +setTimeout(callback, 16);
};
var $99b8d3464c57be61$var$caf = function caf(num) {
    return clearTimeout(num);
};
if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
    $99b8d3464c57be61$var$raf = function raf(callback) {
        return window.requestAnimationFrame(callback);
    };
    $99b8d3464c57be61$var$caf = function caf(handle) {
        return window.cancelAnimationFrame(handle);
    };
}
var $99b8d3464c57be61$var$rafUUID = 0;
var $99b8d3464c57be61$var$rafIds = new Map();
function $99b8d3464c57be61$var$cleanup(id) {
    $99b8d3464c57be61$var$rafIds.delete(id);
}
var $99b8d3464c57be61$var$wrapperRaf = function wrapperRaf(callback) {
    var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    $99b8d3464c57be61$var$rafUUID += 1;
    var id = $99b8d3464c57be61$var$rafUUID;
    function callRef(leftTimes) {
        if (leftTimes === 0) {
            // Clean up
            $99b8d3464c57be61$var$cleanup(id);
            // Trigger
            callback();
        } else {
            // Next raf
            var realId = $99b8d3464c57be61$var$raf(function() {
                callRef(leftTimes - 1);
            });
            // Bind real raf id
            $99b8d3464c57be61$var$rafIds.set(id, realId);
        }
    }
    callRef(times);
    return id;
};
$99b8d3464c57be61$var$wrapperRaf.cancel = function(id) {
    var realId = $99b8d3464c57be61$var$rafIds.get(id);
    $99b8d3464c57be61$var$cleanup(id);
    return $99b8d3464c57be61$var$caf(realId);
};
var $99b8d3464c57be61$export$2e2bcd8739ae039 = $99b8d3464c57be61$var$wrapperRaf;


function $29dc1d96c4338a9c$export$2e2bcd8739ae039(callback) {
    if (typeof MessageChannel === 'undefined') (0, $99b8d3464c57be61$export$2e2bcd8739ae039)(callback);
    else {
        var channel = new MessageChannel();
        channel.port1.onmessage = function() {
            return callback();
        };
        channel.port2.postMessage(undefined);
    }
}


function $507fb206bc6c439d$export$eedf51fe9d751c7a() {
    // Updater Trigger
    var updateFuncRef = $32rMB.useRef(null);
    // Notify update
    var notifyEffectUpdate = function notifyEffectUpdate(callback) {
        if (!updateFuncRef.current) {
            updateFuncRef.current = [];
            (0, $29dc1d96c4338a9c$export$2e2bcd8739ae039)(function() {
                (0, $N3oW3.unstable_batchedUpdates)(function() {
                    updateFuncRef.current.forEach(function(fn) {
                        fn();
                    });
                    updateFuncRef.current = null;
                });
            });
        }
        updateFuncRef.current.push(callback);
    };
    return notifyEffectUpdate;
}
function $507fb206bc6c439d$export$2e2bcd8739ae039(notifyEffectUpdate, defaultValue) {
    // Value
    var _React$useState = $32rMB.useState(defaultValue), _React$useState2 = (0, $e2a93fed214437b8$export$2e2bcd8739ae039)(_React$useState, 2), stateValue = _React$useState2[0], setStateValue = _React$useState2[1];
    // Set State
    var setEffectVal = (0, $5c85f0dd15155745$export$2e2bcd8739ae039)(function(nextValue) {
        notifyEffectUpdate(function() {
            setStateValue(nextValue);
        });
    });
    return [
        stateValue,
        setEffectVal
    ];
}




parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");



var $N3oW3 = parcelRequire("N3oW3");
var $8ca454ed7d3d67af$export$79f16dd643143c25 = /*#__PURE__*/ (0, $N3oW3.default).createContext(null);


var $4e7e4b4d508db28e$var$_excluded = [
    "component"
], $4e7e4b4d508db28e$var$_excluded2 = [
    "className"
], $4e7e4b4d508db28e$var$_excluded3 = [
    "className"
];
var $4e7e4b4d508db28e$var$InternalRawItem = function InternalRawItem(props, ref) {
    var context = $32rMB.useContext((0, $8ca454ed7d3d67af$export$79f16dd643143c25));
    // Render directly when context not provided
    if (!context) {
        var _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, _restProps = (0, $e942b529d3ff1978$export$2e2bcd8739ae039)(props, $4e7e4b4d508db28e$var$_excluded);
        return /*#__PURE__*/ $hO8yS.createElement(Component, (0, $4dfb8f1fff0cbd5e$export$2e2bcd8739ae039)({}, _restProps, {
            ref: ref
        }));
    }
    var contextClassName = context.className, restContext = (0, $e942b529d3ff1978$export$2e2bcd8739ae039)(context, $4e7e4b4d508db28e$var$_excluded2);
    var className = props.className, restProps = (0, $e942b529d3ff1978$export$2e2bcd8739ae039)(props, $4e7e4b4d508db28e$var$_excluded3);
    // Do not pass context to sub item to avoid multiple measure
    return /*#__PURE__*/ $hO8yS.createElement((0, $8ca454ed7d3d67af$export$79f16dd643143c25).Provider, {
        value: null
    }, /*#__PURE__*/ $hO8yS.createElement((0, $e97189498885750a$export$2e2bcd8739ae039), (0, $4dfb8f1fff0cbd5e$export$2e2bcd8739ae039)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(contextClassName, className)
    }, restContext, restProps)));
};
var $4e7e4b4d508db28e$var$RawItem = /*#__PURE__*/ $N3oW3.forwardRef($4e7e4b4d508db28e$var$InternalRawItem);
$4e7e4b4d508db28e$var$RawItem.displayName = 'RawItem';
var $4e7e4b4d508db28e$export$2e2bcd8739ae039 = $4e7e4b4d508db28e$var$RawItem;



var $4d5048b97bd9fcb0$var$_excluded = [
    "prefixCls",
    "data",
    "renderItem",
    "renderRawItem",
    "itemKey",
    "itemWidth",
    "ssr",
    "style",
    "className",
    "maxCount",
    "renderRest",
    "renderRawRest",
    "prefix",
    "suffix",
    "component",
    "itemComponent",
    "onVisibleChange"
];
var $4d5048b97bd9fcb0$var$RESPONSIVE = 'responsive';
var $4d5048b97bd9fcb0$var$INVALIDATE = 'invalidate';
function $4d5048b97bd9fcb0$var$defaultRenderRest(omittedItems) {
    return "+ ".concat(omittedItems.length, " ...");
}
function $4d5048b97bd9fcb0$var$Overflow(props, ref) {
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-overflow' : _props$prefixCls, _props$data = props.data, data = _props$data === void 0 ? [] : _props$data, renderItem = props.renderItem, renderRawItem = props.renderRawItem, itemKey = props.itemKey, _props$itemWidth = props.itemWidth, itemWidth = _props$itemWidth === void 0 ? 10 : _props$itemWidth, ssr = props.ssr, style = props.style, className = props.className, maxCount = props.maxCount, renderRest = props.renderRest, renderRawRest = props.renderRawRest, prefix = props.prefix, suffix = props.suffix, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, itemComponent = props.itemComponent, onVisibleChange = props.onVisibleChange, restProps = (0, $e942b529d3ff1978$export$2e2bcd8739ae039)(props, $4d5048b97bd9fcb0$var$_excluded);
    var fullySSR = ssr === 'full';
    var notifyEffectUpdate = (0, $507fb206bc6c439d$export$eedf51fe9d751c7a)();
    var _useEffectState = (0, $507fb206bc6c439d$export$2e2bcd8739ae039)(notifyEffectUpdate, null), _useEffectState2 = (0, $e2a93fed214437b8$export$2e2bcd8739ae039)(_useEffectState, 2), containerWidth = _useEffectState2[0], setContainerWidth = _useEffectState2[1];
    var mergedContainerWidth = containerWidth || 0;
    var _useEffectState3 = (0, $507fb206bc6c439d$export$2e2bcd8739ae039)(notifyEffectUpdate, new Map()), _useEffectState4 = (0, $e2a93fed214437b8$export$2e2bcd8739ae039)(_useEffectState3, 2), itemWidths = _useEffectState4[0], setItemWidths = _useEffectState4[1];
    var _useEffectState5 = (0, $507fb206bc6c439d$export$2e2bcd8739ae039)(notifyEffectUpdate, 0), _useEffectState6 = (0, $e2a93fed214437b8$export$2e2bcd8739ae039)(_useEffectState5, 2), prevRestWidth = _useEffectState6[0], setPrevRestWidth = _useEffectState6[1];
    var _useEffectState7 = (0, $507fb206bc6c439d$export$2e2bcd8739ae039)(notifyEffectUpdate, 0), _useEffectState8 = (0, $e2a93fed214437b8$export$2e2bcd8739ae039)(_useEffectState7, 2), restWidth = _useEffectState8[0], setRestWidth = _useEffectState8[1];
    var _useEffectState9 = (0, $507fb206bc6c439d$export$2e2bcd8739ae039)(notifyEffectUpdate, 0), _useEffectState10 = (0, $e2a93fed214437b8$export$2e2bcd8739ae039)(_useEffectState9, 2), prefixWidth = _useEffectState10[0], setPrefixWidth = _useEffectState10[1];
    var _useEffectState11 = (0, $507fb206bc6c439d$export$2e2bcd8739ae039)(notifyEffectUpdate, 0), _useEffectState12 = (0, $e2a93fed214437b8$export$2e2bcd8739ae039)(_useEffectState11, 2), suffixWidth = _useEffectState12[0], setSuffixWidth = _useEffectState12[1];
    var _useState = (0, $32rMB.useState)(null), _useState2 = (0, $e2a93fed214437b8$export$2e2bcd8739ae039)(_useState, 2), suffixFixedStart = _useState2[0], setSuffixFixedStart = _useState2[1];
    var _useState3 = (0, $32rMB.useState)(null), _useState4 = (0, $e2a93fed214437b8$export$2e2bcd8739ae039)(_useState3, 2), displayCount = _useState4[0], setDisplayCount = _useState4[1];
    var mergedDisplayCount = $32rMB.useMemo(function() {
        if (displayCount === null && fullySSR) return Number.MAX_SAFE_INTEGER;
        return displayCount || 0;
    }, [
        displayCount,
        containerWidth
    ]);
    var _useState5 = (0, $32rMB.useState)(false), _useState6 = (0, $e2a93fed214437b8$export$2e2bcd8739ae039)(_useState5, 2), restReady = _useState6[0], setRestReady = _useState6[1];
    var itemPrefixCls = "".concat(prefixCls, "-item");
    // Always use the max width to avoid blink
    var mergedRestWidth = Math.max(prevRestWidth, restWidth);
    // ================================= Data =================================
    var isResponsive = maxCount === $4d5048b97bd9fcb0$var$RESPONSIVE;
    var shouldResponsive = data.length && isResponsive;
    var invalidate = maxCount === $4d5048b97bd9fcb0$var$INVALIDATE;
    /**
   * When is `responsive`, we will always render rest node to get the real width of it for calculation
   */ var showRest = shouldResponsive || typeof maxCount === 'number' && data.length > maxCount;
    var mergedData = (0, $32rMB.useMemo)(function() {
        var items = data;
        if (shouldResponsive) {
            if (containerWidth === null && fullySSR) items = data;
            else items = data.slice(0, Math.min(data.length, mergedContainerWidth / itemWidth));
        } else if (typeof maxCount === 'number') items = data.slice(0, maxCount);
        return items;
    }, [
        data,
        itemWidth,
        containerWidth,
        maxCount,
        shouldResponsive
    ]);
    var omittedItems = (0, $32rMB.useMemo)(function() {
        if (shouldResponsive) return data.slice(mergedDisplayCount + 1);
        return data.slice(mergedData.length);
    }, [
        data,
        mergedData,
        shouldResponsive,
        mergedDisplayCount
    ]);
    // ================================= Item =================================
    var getKey = (0, $32rMB.useCallback)(function(item, index) {
        var _ref;
        if (typeof itemKey === 'function') return itemKey(item);
        return (_ref = itemKey && (item === null || item === void 0 ? void 0 : item[itemKey])) !== null && _ref !== void 0 ? _ref : index;
    }, [
        itemKey
    ]);
    var mergedRenderItem = (0, $32rMB.useCallback)(renderItem || function(item) {
        return item;
    }, [
        renderItem
    ]);
    function updateDisplayCount(count, suffixFixedStartVal, notReady) {
        // React 18 will sync render even when the value is same in some case.
        // We take `mergedData` as deps which may cause dead loop if it's dynamic generate.
        // ref: https://github.com/ant-design/ant-design/issues/36559
        if (displayCount === count && (suffixFixedStartVal === undefined || suffixFixedStartVal === suffixFixedStart)) return;
        setDisplayCount(count);
        if (!notReady) {
            setRestReady(count < data.length - 1);
            onVisibleChange === null || onVisibleChange === void 0 || onVisibleChange(count);
        }
        if (suffixFixedStartVal !== undefined) setSuffixFixedStart(suffixFixedStartVal);
    }
    // ================================= Size =================================
    function onOverflowResize(_, element) {
        setContainerWidth(element.clientWidth);
    }
    function registerSize(key, width) {
        setItemWidths(function(origin) {
            var clone = new Map(origin);
            if (width === null) clone.delete(key);
            else clone.set(key, width);
            return clone;
        });
    }
    function registerOverflowSize(_, width) {
        setRestWidth(width);
        setPrevRestWidth(restWidth);
    }
    function registerPrefixSize(_, width) {
        setPrefixWidth(width);
    }
    function registerSuffixSize(_, width) {
        setSuffixWidth(width);
    }
    // ================================ Effect ================================
    function getItemWidth(index) {
        return itemWidths.get(getKey(mergedData[index], index));
    }
    (0, $af1ff2ee9ec51f79$export$2e2bcd8739ae039)(function() {
        if (mergedContainerWidth && typeof mergedRestWidth === 'number' && mergedData) {
            var totalWidth = prefixWidth + suffixWidth;
            var len = mergedData.length;
            var lastIndex = len - 1;
            // When data count change to 0, reset this since not loop will reach
            if (!len) {
                updateDisplayCount(0, null);
                return;
            }
            for(var i = 0; i < len; i += 1){
                var currentItemWidth = getItemWidth(i);
                // Fully will always render
                if (fullySSR) currentItemWidth = currentItemWidth || 0;
                // Break since data not ready
                if (currentItemWidth === undefined) {
                    updateDisplayCount(i - 1, undefined, true);
                    break;
                }
                // Find best match
                totalWidth += currentItemWidth;
                if (// Only one means `totalWidth` is the final width
                lastIndex === 0 && totalWidth <= mergedContainerWidth || // Last two width will be the final width
                i === lastIndex - 1 && totalWidth + getItemWidth(lastIndex) <= mergedContainerWidth) {
                    // Additional check if match the end
                    updateDisplayCount(lastIndex, null);
                    break;
                } else if (totalWidth + mergedRestWidth > mergedContainerWidth) {
                    // Can not hold all the content to show rest
                    updateDisplayCount(i - 1, totalWidth - currentItemWidth - suffixWidth + restWidth);
                    break;
                }
            }
            if (suffix && getItemWidth(0) + suffixWidth > mergedContainerWidth) setSuffixFixedStart(null);
        }
    }, [
        mergedContainerWidth,
        itemWidths,
        restWidth,
        prefixWidth,
        suffixWidth,
        getKey,
        mergedData
    ]);
    // ================================ Render ================================
    var displayRest = restReady && !!omittedItems.length;
    var suffixStyle = {};
    if (suffixFixedStart !== null && shouldResponsive) suffixStyle = {
        position: 'absolute',
        left: suffixFixedStart,
        top: 0
    };
    var itemSharedProps = {
        prefixCls: itemPrefixCls,
        responsive: shouldResponsive,
        component: itemComponent,
        invalidate: invalidate
    };
    // >>>>> Choice render fun by `renderRawItem`
    var internalRenderItemNode = renderRawItem ? function(item, index) {
        var key = getKey(item, index);
        return /*#__PURE__*/ $hO8yS.createElement((0, $8ca454ed7d3d67af$export$79f16dd643143c25).Provider, {
            key: key,
            value: (0, $cde876c32cf7555b$export$2e2bcd8739ae039)((0, $cde876c32cf7555b$export$2e2bcd8739ae039)({}, itemSharedProps), {}, {
                order: index,
                item: item,
                itemKey: key,
                registerSize: registerSize,
                display: index <= mergedDisplayCount
            })
        }, renderRawItem(item, index));
    } : function(item, index) {
        var key = getKey(item, index);
        return /*#__PURE__*/ $hO8yS.createElement((0, $e97189498885750a$export$2e2bcd8739ae039), (0, $4dfb8f1fff0cbd5e$export$2e2bcd8739ae039)({}, itemSharedProps, {
            order: index,
            key: key,
            item: item,
            renderItem: mergedRenderItem,
            itemKey: key,
            registerSize: registerSize,
            display: index <= mergedDisplayCount
        }));
    };
    // >>>>> Rest node
    var restContextProps = {
        order: displayRest ? mergedDisplayCount : Number.MAX_SAFE_INTEGER,
        className: "".concat(itemPrefixCls, "-rest"),
        registerSize: registerOverflowSize,
        display: displayRest
    };
    var mergedRenderRest = renderRest || $4d5048b97bd9fcb0$var$defaultRenderRest;
    var restNode = renderRawRest ? /*#__PURE__*/ $hO8yS.createElement((0, $8ca454ed7d3d67af$export$79f16dd643143c25).Provider, {
        value: (0, $cde876c32cf7555b$export$2e2bcd8739ae039)((0, $cde876c32cf7555b$export$2e2bcd8739ae039)({}, itemSharedProps), restContextProps)
    }, renderRawRest(omittedItems)) : /*#__PURE__*/ $hO8yS.createElement((0, $e97189498885750a$export$2e2bcd8739ae039), (0, $4dfb8f1fff0cbd5e$export$2e2bcd8739ae039)({}, itemSharedProps, restContextProps), typeof mergedRenderRest === 'function' ? mergedRenderRest(omittedItems) : mergedRenderRest);
    var overflowNode = /*#__PURE__*/ $hO8yS.createElement(Component, (0, $4dfb8f1fff0cbd5e$export$2e2bcd8739ae039)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(!invalidate && prefixCls, className),
        style: style,
        ref: ref
    }, restProps), prefix && /*#__PURE__*/ $hO8yS.createElement((0, $e97189498885750a$export$2e2bcd8739ae039), (0, $4dfb8f1fff0cbd5e$export$2e2bcd8739ae039)({}, itemSharedProps, {
        responsive: isResponsive,
        responsiveDisabled: !shouldResponsive,
        order: -1,
        className: "".concat(itemPrefixCls, "-prefix"),
        registerSize: registerPrefixSize,
        display: true
    }), prefix), mergedData.map(internalRenderItemNode), showRest ? restNode : null, suffix && /*#__PURE__*/ $hO8yS.createElement((0, $e97189498885750a$export$2e2bcd8739ae039), (0, $4dfb8f1fff0cbd5e$export$2e2bcd8739ae039)({}, itemSharedProps, {
        responsive: isResponsive,
        responsiveDisabled: !shouldResponsive,
        order: mergedDisplayCount,
        className: "".concat(itemPrefixCls, "-suffix"),
        registerSize: registerSuffixSize,
        display: true,
        style: suffixStyle
    }), suffix));
    return isResponsive ? /*#__PURE__*/ $hO8yS.createElement((0, $46befc6c0d7dbbd8$export$2e2bcd8739ae039), {
        onResize: onOverflowResize,
        disabled: !shouldResponsive
    }, overflowNode) : overflowNode;
}
var $4d5048b97bd9fcb0$var$ForwardOverflow = /*#__PURE__*/ $N3oW3.forwardRef($4d5048b97bd9fcb0$var$Overflow);
$4d5048b97bd9fcb0$var$ForwardOverflow.displayName = 'Overflow';
$4d5048b97bd9fcb0$var$ForwardOverflow.Item = (0, $4e7e4b4d508db28e$export$2e2bcd8739ae039);
$4d5048b97bd9fcb0$var$ForwardOverflow.RESPONSIVE = $4d5048b97bd9fcb0$var$RESPONSIVE;
$4d5048b97bd9fcb0$var$ForwardOverflow.INVALIDATE = $4d5048b97bd9fcb0$var$INVALIDATE;
var // Convert to generic type
$4d5048b97bd9fcb0$export$2e2bcd8739ae039 = $4d5048b97bd9fcb0$var$ForwardOverflow;


var $12a6b9a6c34b9880$export$2e2bcd8739ae039 = (0, $4d5048b97bd9fcb0$export$2e2bcd8739ae039);






parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");

var $N3oW3 = parcelRequire("N3oW3");
parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");
const $64474b8ac302169b$export$26537912ea160acd = /*#__PURE__*/ $hO8yS.createContext(null);
function $64474b8ac302169b$export$80c871fe8d6b896(uuid, eventKey) {
    return `${uuid}-${eventKey}`;
}
function $64474b8ac302169b$export$a276eb4e9be640f8(eventKey) {
    const id = $32rMB.useContext($64474b8ac302169b$export$26537912ea160acd);
    return $64474b8ac302169b$export$80c871fe8d6b896(id, eventKey);
}


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");


const $89decf4267c52ca4$export$c7e742effb1c51e2 = /*#__PURE__*/ $hO8yS.createContext(null);
function $89decf4267c52ca4$var$mergeProps(origin, target) {
    const clone = {
        ...origin
    };
    Object.keys(target).forEach((key)=>{
        const value = target[key];
        if (value !== undefined) clone[key] = value;
    });
    return clone;
}
function $89decf4267c52ca4$export$2e2bcd8739ae039({ children: children, locked: locked, ...restProps }) {
    const context = $32rMB.useContext($89decf4267c52ca4$export$c7e742effb1c51e2);
    const inheritableContext = (0, $7b0442ce5e42625c$export$2e2bcd8739ae039)(()=>$89decf4267c52ca4$var$mergeProps(context, restProps), [
        context,
        restProps
    ], (prev, next)=>!locked && (prev[0] !== next[0] || !(0, $5582f7991b7cfce3$export$2e2bcd8739ae039)(prev[1], next[1], true)));
    return /*#__PURE__*/ $hO8yS.createElement($89decf4267c52ca4$export$c7e742effb1c51e2.Provider, {
        value: inheritableContext
    }, children);
}


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");
const $4d1b4cb331d72abd$var$EmptyList = [];
const $4d1b4cb331d72abd$export$d9ffb5bfd108b003 = /*#__PURE__*/ $hO8yS.createContext(null);
function $4d1b4cb331d72abd$export$e295b0c537d32d7d() {
    return $32rMB.useContext($4d1b4cb331d72abd$export$d9ffb5bfd108b003);
}
const $4d1b4cb331d72abd$export$54d9e16aa4c8a7fa = /*#__PURE__*/ $hO8yS.createContext($4d1b4cb331d72abd$var$EmptyList);
function $4d1b4cb331d72abd$export$d3d2d0a05677870a(eventKey) {
    const parentKeyPath = $32rMB.useContext($4d1b4cb331d72abd$export$54d9e16aa4c8a7fa);
    return $32rMB.useMemo(()=>eventKey !== undefined ? [
            ...parentKeyPath,
            eventKey
        ] : parentKeyPath, [
        parentKeyPath,
        eventKey
    ]);
}
const $4d1b4cb331d72abd$export$f0b9e0db98edfa53 = /*#__PURE__*/ $hO8yS.createContext(null);


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
const $cd4f5cf1f700ce8f$var$PrivateContext = /*#__PURE__*/ $hO8yS.createContext({});
var $cd4f5cf1f700ce8f$export$2e2bcd8739ae039 = $cd4f5cf1f700ce8f$var$PrivateContext;



function $f773cdc81cd324e4$var$focusable(node, includePositive = false) {
    if ((0, $218f20156c5f8705$export$2e2bcd8739ae039)(node)) {
        const nodeName = node.nodeName.toLowerCase();
        const isFocusableElement = // Focusable element
        [
            'input',
            'select',
            'textarea',
            'button'
        ].includes(nodeName) || // Editable element
        node.isContentEditable || // Anchor with href element
        nodeName === 'a' && !!node.getAttribute('href');
        // Get tabIndex
        const tabIndexAttr = node.getAttribute('tabindex');
        const tabIndexNum = Number(tabIndexAttr);
        // Parse as number if validate
        let tabIndex = null;
        if (tabIndexAttr && !Number.isNaN(tabIndexNum)) tabIndex = tabIndexNum;
        else if (isFocusableElement && tabIndex === null) tabIndex = 0;
        // Block focusable if disabled
        if (isFocusableElement && node.disabled) tabIndex = null;
        return tabIndex !== null && (tabIndex >= 0 || includePositive && tabIndex < 0);
    }
    return false;
}
function $f773cdc81cd324e4$export$bbc7b5f11aba534b(node, includePositive = false) {
    const res = [
        ...node.querySelectorAll('*')
    ].filter((child)=>{
        return $f773cdc81cd324e4$var$focusable(child, includePositive);
    });
    if ($f773cdc81cd324e4$var$focusable(node, includePositive)) res.unshift(node);
    return res;
}
let $f773cdc81cd324e4$var$lastFocusElement = null;
function $f773cdc81cd324e4$export$79fea02f7a83293d() {
    $f773cdc81cd324e4$var$lastFocusElement = document.activeElement;
}
function $f773cdc81cd324e4$export$8785654047fe7352() {
    $f773cdc81cd324e4$var$lastFocusElement = null;
}
function $f773cdc81cd324e4$export$fac0a9974415d98f() {
    if ($f773cdc81cd324e4$var$lastFocusElement) try {
        // 元素可能已经被移动了
        $f773cdc81cd324e4$var$lastFocusElement.focus();
    /* eslint-disable no-empty */ } catch (e) {
    // empty
    }
}
function $f773cdc81cd324e4$export$5717027f63f8addb(node, e) {
    if (e.keyCode === 9) {
        const tabNodeList = $f773cdc81cd324e4$export$bbc7b5f11aba534b(node);
        const lastTabNode = tabNodeList[e.shiftKey ? 0 : tabNodeList.length - 1];
        const leavingTab = lastTabNode === document.activeElement || node === document.activeElement;
        if (leavingTab) {
            const target = tabNodeList[e.shiftKey ? tabNodeList.length - 1 : 0];
            target.focus();
            e.preventDefault();
        }
    }
}
function $f773cdc81cd324e4$export$2b92016deb0b7aad(element, option) {
    if (!element) return;
    element.focus(option);
    // Selection content
    const { cursor: cursor } = option || {};
    if (cursor && (element instanceof HTMLInputElement || element instanceof HTMLTextAreaElement)) {
        const len = element.value.length;
        switch(cursor){
            case 'start':
                element.setSelectionRange(0, 0);
                break;
            case 'end':
                element.setSelectionRange(len, len);
                break;
            default:
                element.setSelectionRange(0, len);
        }
    }
}




parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");

// destruct to reduce minify size
const { LEFT: $26171a6153c4c15d$var$LEFT, RIGHT: $26171a6153c4c15d$var$RIGHT, UP: $26171a6153c4c15d$var$UP, DOWN: $26171a6153c4c15d$var$DOWN, ENTER: $26171a6153c4c15d$var$ENTER, ESC: $26171a6153c4c15d$var$ESC, HOME: $26171a6153c4c15d$var$HOME, END: $26171a6153c4c15d$var$END } = (0, $4d7d870d585f8465$export$2e2bcd8739ae039);
const $26171a6153c4c15d$var$ArrowKeys = [
    $26171a6153c4c15d$var$UP,
    $26171a6153c4c15d$var$DOWN,
    $26171a6153c4c15d$var$LEFT,
    $26171a6153c4c15d$var$RIGHT
];
function $26171a6153c4c15d$var$getOffset(mode, isRootLevel, isRtl, which) {
    const prev = 'prev';
    const next = 'next';
    const children = 'children';
    const parent = 'parent';
    // Inline enter is special that we use unique operation
    if (mode === 'inline' && which === $26171a6153c4c15d$var$ENTER) return {
        inlineTrigger: true
    };
    const inline = {
        [$26171a6153c4c15d$var$UP]: prev,
        [$26171a6153c4c15d$var$DOWN]: next
    };
    const horizontal = {
        [$26171a6153c4c15d$var$LEFT]: isRtl ? next : prev,
        [$26171a6153c4c15d$var$RIGHT]: isRtl ? prev : next,
        [$26171a6153c4c15d$var$DOWN]: children,
        [$26171a6153c4c15d$var$ENTER]: children
    };
    const vertical = {
        [$26171a6153c4c15d$var$UP]: prev,
        [$26171a6153c4c15d$var$DOWN]: next,
        [$26171a6153c4c15d$var$ENTER]: children,
        [$26171a6153c4c15d$var$ESC]: parent,
        [$26171a6153c4c15d$var$LEFT]: isRtl ? children : parent,
        [$26171a6153c4c15d$var$RIGHT]: isRtl ? parent : children
    };
    const offsets = {
        inline: inline,
        horizontal: horizontal,
        vertical: vertical,
        inlineSub: inline,
        horizontalSub: vertical,
        verticalSub: vertical
    };
    const type = offsets[`${mode}${isRootLevel ? '' : 'Sub'}`]?.[which];
    switch(type){
        case prev:
            return {
                offset: -1,
                sibling: true
            };
        case next:
            return {
                offset: 1,
                sibling: true
            };
        case parent:
            return {
                offset: -1,
                sibling: false
            };
        case children:
            return {
                offset: 1,
                sibling: false
            };
        default:
            return null;
    }
}
function $26171a6153c4c15d$var$findContainerUL(element) {
    let current = element;
    while(current){
        if (current.getAttribute('data-menu-list')) return current;
        current = current.parentElement;
    }
    // Normally should not reach this line
    /* istanbul ignore next */ return null;
}
/**
 * Find focused element within element set provided
 */ function $26171a6153c4c15d$var$getFocusElement(activeElement, elements) {
    let current = activeElement || document.activeElement;
    while(current){
        if (elements.has(current)) return current;
        current = current.parentElement;
    }
    return null;
}
function $26171a6153c4c15d$export$433aaa1f216cf32d(container, elements) {
    const list = (0, $f773cdc81cd324e4$export$bbc7b5f11aba534b)(container, true);
    return list.filter((ele)=>elements.has(ele));
}
function $26171a6153c4c15d$var$getNextFocusElement(parentQueryContainer, elements, focusMenuElement, offset = 1) {
    // Key on the menu item will not get validate parent container
    if (!parentQueryContainer) return null;
    // List current level menu item elements
    const sameLevelFocusableMenuElementList = $26171a6153c4c15d$export$433aaa1f216cf32d(parentQueryContainer, elements);
    // Find next focus index
    const count = sameLevelFocusableMenuElementList.length;
    let focusIndex = sameLevelFocusableMenuElementList.findIndex((ele)=>focusMenuElement === ele);
    if (offset < 0) {
        if (focusIndex === -1) focusIndex = count - 1;
        else focusIndex -= 1;
    } else if (offset > 0) focusIndex += 1;
    focusIndex = (focusIndex + count) % count;
    // Focus menu item
    return sameLevelFocusableMenuElementList[focusIndex];
}
const $26171a6153c4c15d$export$20827b68c762d23 = (keys, id)=>{
    const elements = new Set();
    const key2element = new Map();
    const element2key = new Map();
    keys.forEach((key)=>{
        const element = document.querySelector(`[data-menu-id='${(0, $64474b8ac302169b$export$80c871fe8d6b896)(id, key)}']`);
        if (element) {
            elements.add(element);
            element2key.set(element, key);
            key2element.set(key, element);
        }
    });
    return {
        elements: elements,
        key2element: key2element,
        element2key: element2key
    };
};
function $26171a6153c4c15d$export$aa6de64279d64603(mode, activeKey, isRtl, id, containerRef, getKeys, getKeyPath, triggerActiveKey, triggerAccessibilityOpen, originOnKeyDown) {
    const rafRef = $32rMB.useRef();
    const activeRef = $32rMB.useRef();
    activeRef.current = activeKey;
    const cleanRaf = ()=>{
        (0, $c9c36e20d667d30c$export$2e2bcd8739ae039).cancel(rafRef.current);
    };
    $32rMB.useEffect(()=>()=>{
            cleanRaf();
        }, []);
    return (e)=>{
        const { which: which } = e;
        if ([
            ...$26171a6153c4c15d$var$ArrowKeys,
            $26171a6153c4c15d$var$ENTER,
            $26171a6153c4c15d$var$ESC,
            $26171a6153c4c15d$var$HOME,
            $26171a6153c4c15d$var$END
        ].includes(which)) {
            const keys = getKeys();
            let refreshedElements = $26171a6153c4c15d$export$20827b68c762d23(keys, id);
            const { elements: elements, key2element: key2element, element2key: element2key } = refreshedElements;
            // First we should find current focused MenuItem/SubMenu element
            const activeElement = key2element.get(activeKey);
            const focusMenuElement = $26171a6153c4c15d$var$getFocusElement(activeElement, elements);
            const focusMenuKey = element2key.get(focusMenuElement);
            const offsetObj = $26171a6153c4c15d$var$getOffset(mode, getKeyPath(focusMenuKey, true).length === 1, isRtl, which);
            // Some mode do not have fully arrow operation like inline
            if (!offsetObj && which !== $26171a6153c4c15d$var$HOME && which !== $26171a6153c4c15d$var$END) return;
            // Arrow prevent default to avoid page scroll
            if ($26171a6153c4c15d$var$ArrowKeys.includes(which) || [
                $26171a6153c4c15d$var$HOME,
                $26171a6153c4c15d$var$END
            ].includes(which)) e.preventDefault();
            const tryFocus = (menuElement)=>{
                if (menuElement) {
                    let focusTargetElement = menuElement;
                    // Focus to link instead of menu item if possible
                    const link = menuElement.querySelector('a');
                    if (link?.getAttribute('href')) focusTargetElement = link;
                    const targetKey = element2key.get(menuElement);
                    triggerActiveKey(targetKey);
                    /**
           * Do not `useEffect` here since `tryFocus` may trigger async
           * which makes React sync update the `activeKey`
           * that force render before `useRef` set the next activeKey
           */ cleanRaf();
                    rafRef.current = (0, $c9c36e20d667d30c$export$2e2bcd8739ae039)(()=>{
                        if (activeRef.current === targetKey) focusTargetElement.focus();
                    });
                }
            };
            if ([
                $26171a6153c4c15d$var$HOME,
                $26171a6153c4c15d$var$END
            ].includes(which) || offsetObj.sibling || !focusMenuElement) {
                // ========================== Sibling ==========================
                // Find walkable focus menu element container
                let parentQueryContainer;
                if (!focusMenuElement || mode === 'inline') parentQueryContainer = containerRef.current;
                else parentQueryContainer = $26171a6153c4c15d$var$findContainerUL(focusMenuElement);
                // Get next focus element
                let targetElement;
                const focusableElements = $26171a6153c4c15d$export$433aaa1f216cf32d(parentQueryContainer, elements);
                if (which === $26171a6153c4c15d$var$HOME) targetElement = focusableElements[0];
                else if (which === $26171a6153c4c15d$var$END) targetElement = focusableElements[focusableElements.length - 1];
                else targetElement = $26171a6153c4c15d$var$getNextFocusElement(parentQueryContainer, elements, focusMenuElement, offsetObj.offset);
                // Focus menu item
                tryFocus(targetElement);
            // ======================= InlineTrigger =======================
            } else if (offsetObj.inlineTrigger) // Inline trigger no need switch to sub menu item
            triggerAccessibilityOpen(focusMenuKey);
            else if (offsetObj.offset > 0) {
                triggerAccessibilityOpen(focusMenuKey, true);
                cleanRaf();
                rafRef.current = (0, $c9c36e20d667d30c$export$2e2bcd8739ae039)(()=>{
                    // Async should resync elements
                    refreshedElements = $26171a6153c4c15d$export$20827b68c762d23(keys, id);
                    const controlId = focusMenuElement.getAttribute('aria-controls');
                    const subQueryContainer = document.getElementById(controlId);
                    // Get sub focusable menu item
                    const targetElement = $26171a6153c4c15d$var$getNextFocusElement(subQueryContainer, refreshedElements.elements);
                    // Focus menu item
                    tryFocus(targetElement);
                }, 5);
            } else if (offsetObj.offset < 0) {
                const keyPath = getKeyPath(focusMenuKey, true);
                const parentKey = keyPath[keyPath.length - 2];
                const parentMenuElement = key2element.get(parentKey);
                // Focus menu item
                triggerAccessibilityOpen(parentKey, false);
                tryFocus(parentMenuElement);
            }
        }
        // Pass origin key down event
        originOnKeyDown?.(e);
    };
}


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");

function $fe1852c79dcf9789$export$7693db51ef834b40(callback) {
    /* istanbul ignore next */ Promise.resolve().then(callback);
}


const $595e43546c04bae6$var$PATH_SPLIT = '__RC_UTIL_PATH_SPLIT__';
const $595e43546c04bae6$var$getPathStr = (keyPath)=>keyPath.join($595e43546c04bae6$var$PATH_SPLIT);
const $595e43546c04bae6$var$getPathKeys = (keyPathStr)=>keyPathStr.split($595e43546c04bae6$var$PATH_SPLIT);
const $595e43546c04bae6$export$20a0132c46ce5b04 = 'rc-menu-more';
function $595e43546c04bae6$export$2e2bcd8739ae039() {
    const [, internalForceUpdate] = $32rMB.useState({});
    const key2pathRef = (0, $32rMB.useRef)(new Map());
    const path2keyRef = (0, $32rMB.useRef)(new Map());
    const [overflowKeys, setOverflowKeys] = $32rMB.useState([]);
    const updateRef = (0, $32rMB.useRef)(0);
    const destroyRef = (0, $32rMB.useRef)(false);
    const forceUpdate = ()=>{
        if (!destroyRef.current) internalForceUpdate({});
    };
    const registerPath = (0, $32rMB.useCallback)((key, keyPath)=>{
        // Fill map
        const connectedPath = $595e43546c04bae6$var$getPathStr(keyPath);
        path2keyRef.current.set(connectedPath, key);
        key2pathRef.current.set(key, connectedPath);
        updateRef.current += 1;
        const id = updateRef.current;
        (0, $fe1852c79dcf9789$export$7693db51ef834b40)(()=>{
            if (id === updateRef.current) forceUpdate();
        });
    }, []);
    const unregisterPath = (0, $32rMB.useCallback)((key, keyPath)=>{
        const connectedPath = $595e43546c04bae6$var$getPathStr(keyPath);
        path2keyRef.current.delete(connectedPath);
        key2pathRef.current.delete(key);
    }, []);
    const refreshOverflowKeys = (0, $32rMB.useCallback)((keys)=>{
        setOverflowKeys(keys);
    }, []);
    const getKeyPath = (0, $32rMB.useCallback)((eventKey, includeOverflow)=>{
        const fullPath = key2pathRef.current.get(eventKey) || '';
        const keys = $595e43546c04bae6$var$getPathKeys(fullPath);
        if (includeOverflow && overflowKeys.includes(keys[0])) keys.unshift($595e43546c04bae6$export$20a0132c46ce5b04);
        return keys;
    }, [
        overflowKeys
    ]);
    const isSubPathKey = (0, $32rMB.useCallback)((pathKeys, eventKey)=>pathKeys.filter((item)=>item !== undefined).some((pathKey)=>{
            const pathKeyList = getKeyPath(pathKey, true);
            return pathKeyList.includes(eventKey);
        }), [
        getKeyPath
    ]);
    const getKeys = ()=>{
        const keys = [
            ...key2pathRef.current.keys()
        ];
        if (overflowKeys.length) keys.push($595e43546c04bae6$export$20a0132c46ce5b04);
        return keys;
    };
    /**
   * Find current key related child path keys
   */ const getSubPathKeys = (0, $32rMB.useCallback)((key)=>{
        const connectedPath = `${key2pathRef.current.get(key)}${$595e43546c04bae6$var$PATH_SPLIT}`;
        const pathKeys = new Set();
        [
            ...path2keyRef.current.keys()
        ].forEach((pathKey)=>{
            if (pathKey.startsWith(connectedPath)) pathKeys.add(path2keyRef.current.get(pathKey));
        });
        return pathKeys;
    }, []);
    $32rMB.useEffect(()=>()=>{
            destroyRef.current = true;
        }, []);
    return {
        registerPath: // Register
        registerPath,
        unregisterPath: unregisterPath,
        refreshOverflowKeys: refreshOverflowKeys,
        isSubPathKey: // Util
        isSubPathKey,
        getKeyPath: getKeyPath,
        getKeys: getKeys,
        getSubPathKeys: getSubPathKeys
    };
}


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
function $ada02c1c0f42cf72$export$2e2bcd8739ae039(func) {
    const funRef = $32rMB.useRef(func);
    funRef.current = func;
    const callback = $32rMB.useCallback((...args)=>funRef.current?.(...args), []);
    return func ? callback : undefined;
}








parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");




parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");

function $115f2373850ba42d$export$2e2bcd8739ae039(eventKey, disabled, onMouseEnter, onMouseLeave) {
    const { activeKey: // Active
    activeKey, onActive: onActive, onInactive: onInactive } = $32rMB.useContext((0, $89decf4267c52ca4$export$c7e742effb1c51e2));
    const ret = {
        active: activeKey === eventKey
    };
    // Skip when disabled
    if (!disabled) {
        ret.onMouseEnter = (domEvent)=>{
            onMouseEnter?.({
                key: eventKey,
                domEvent: domEvent
            });
            onActive(eventKey);
        };
        ret.onMouseLeave = (domEvent)=>{
            onMouseLeave?.({
                key: eventKey,
                domEvent: domEvent
            });
            onInactive(eventKey);
        };
    }
    return ret;
}


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");

function $0a9c9cf62002ab5f$export$2e2bcd8739ae039(level) {
    const { mode: mode, rtl: rtl, inlineIndent: inlineIndent } = $32rMB.useContext((0, $89decf4267c52ca4$export$c7e742effb1c51e2));
    if (mode !== 'inline') return null;
    const len = level;
    return rtl ? {
        paddingRight: len * inlineIndent
    } : {
        paddingLeft: len * inlineIndent
    };
}


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
function $7e71bab9c8cd5296$export$2e2bcd8739ae039({ icon: icon, props: props, children: children }) {
    let iconNode;
    if (icon === null || icon === false) return null;
    if (typeof icon === 'function') iconNode = /*#__PURE__*/ $hO8yS.createElement(icon, {
        ...props
    });
    else if (typeof icon !== "boolean") // Compatible for origin definition
    iconNode = icon;
    return iconNode || children || null;
}



function $6d4de5d3936ee291$export$e189bcd94b66c1db({ item: item, ...restInfo }) {
    Object.defineProperty(restInfo, 'item', {
        get: ()=>{
            (0, $6591254ed6bd1058$export$2e2bcd8739ae039)(false, '`info.item` is deprecated since we will move to function component that not provides React Node instance in future.');
            return item;
        }
    });
    return restInfo;
}


function $c44576def6898817$var$_extends() {
    $c44576def6898817$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c44576def6898817$var$_extends.apply(this, arguments);
}
// Since Menu event provide the `info.item` which point to the MenuItem node instance.
// We have to use class component here.
// This should be removed from doc & api in future.
class $c44576def6898817$var$LegacyMenuItem extends $hO8yS.Component {
    render() {
        const { title: title, attribute: attribute, elementRef: elementRef, ...restProps } = this.props;
        // Here the props are eventually passed to the DOM element.
        // React does not recognize non-standard attributes.
        // Therefore, remove the props that is not used here.
        // ref: https://github.com/ant-design/ant-design/issues/41395
        const passedProps = (0, $f4cf9c2e27c0ac8d$export$2e2bcd8739ae039)(restProps, [
            'eventKey',
            'popupClassName',
            'popupOffset',
            'onTitleClick'
        ]);
        (0, $6591254ed6bd1058$export$2e2bcd8739ae039)(!attribute, '`attribute` of Menu.Item is deprecated. Please pass attribute directly.');
        return /*#__PURE__*/ $hO8yS.createElement((0, $12a6b9a6c34b9880$export$2e2bcd8739ae039).Item, $c44576def6898817$var$_extends({}, attribute, {
            title: typeof title === 'string' ? title : undefined
        }, passedProps, {
            ref: elementRef
        }));
    }
}
/**
 * Real Menu Item component
 */ const $c44576def6898817$var$InternalMenuItem = /*#__PURE__*/ $N3oW3.forwardRef((props, ref)=>{
    const { style: style, className: className, eventKey: eventKey, warnKey: warnKey, disabled: disabled, itemIcon: itemIcon, children: children, role: // Aria
    role, onMouseEnter: // Active
    onMouseEnter, onMouseLeave: onMouseLeave, onClick: onClick, onKeyDown: onKeyDown, onFocus: onFocus, ...restProps } = props;
    const domDataId = (0, $64474b8ac302169b$export$a276eb4e9be640f8)(eventKey);
    const { prefixCls: prefixCls, onItemClick: onItemClick, disabled: contextDisabled, overflowDisabled: overflowDisabled, // Icon
    itemIcon: contextItemIcon, selectedKeys: // Select
    selectedKeys, onActive: // Active
    onActive } = $32rMB.useContext((0, $89decf4267c52ca4$export$c7e742effb1c51e2));
    const { _internalRenderMenuItem: _internalRenderMenuItem } = $32rMB.useContext((0, $cd4f5cf1f700ce8f$export$2e2bcd8739ae039));
    const itemCls = `${prefixCls}-item`;
    const legacyMenuItemRef = $32rMB.useRef();
    const elementRef = $32rMB.useRef();
    const mergedDisabled = contextDisabled || disabled;
    const mergedEleRef = (0, $2706ed817e87019d$export$1d1c999670a1285d)(ref, elementRef);
    const connectedKeys = (0, $4d1b4cb331d72abd$export$d3d2d0a05677870a)(eventKey);
    // ============================= Info =============================
    const getEventInfo = (e)=>{
        return {
            key: eventKey,
            // Note: For legacy code is reversed which not like other antd component
            keyPath: [
                ...connectedKeys
            ].reverse(),
            item: legacyMenuItemRef.current,
            domEvent: e
        };
    };
    // ============================= Icon =============================
    const mergedItemIcon = itemIcon || contextItemIcon;
    // ============================ Active ============================
    const { active: active, ...activeProps } = (0, $115f2373850ba42d$export$2e2bcd8739ae039)(eventKey, mergedDisabled, onMouseEnter, onMouseLeave);
    // ============================ Select ============================
    const selected = selectedKeys.includes(eventKey);
    // ======================== DirectionStyle ========================
    const directionStyle = (0, $0a9c9cf62002ab5f$export$2e2bcd8739ae039)(connectedKeys.length);
    // ============================ Events ============================
    const onInternalClick = (e)=>{
        if (mergedDisabled) return;
        const info = getEventInfo(e);
        onClick?.((0, $6d4de5d3936ee291$export$e189bcd94b66c1db)(info));
        onItemClick(info);
    };
    const onInternalKeyDown = (e)=>{
        onKeyDown?.(e);
        if (e.which === (0, $4d7d870d585f8465$export$2e2bcd8739ae039).ENTER) {
            const info = getEventInfo(e);
            // Legacy. Key will also trigger click event
            onClick?.((0, $6d4de5d3936ee291$export$e189bcd94b66c1db)(info));
            onItemClick(info);
        }
    };
    /**
   * Used for accessibility. Helper will focus element without key board.
   * We should manually trigger an active
   */ const onInternalFocus = (e)=>{
        onActive(eventKey);
        onFocus?.(e);
    };
    // ============================ Render ============================
    const optionRoleProps = {};
    if (props.role === 'option') optionRoleProps['aria-selected'] = selected;
    let renderNode = /*#__PURE__*/ $hO8yS.createElement($c44576def6898817$var$LegacyMenuItem, $c44576def6898817$var$_extends({
        ref: legacyMenuItemRef,
        elementRef: mergedEleRef,
        role: role === null ? 'none' : role || 'menuitem',
        tabIndex: disabled ? null : -1,
        "data-menu-id": overflowDisabled && domDataId ? null : domDataId
    }, (0, $f4cf9c2e27c0ac8d$export$2e2bcd8739ae039)(restProps, [
        'extra'
    ]), activeProps, optionRoleProps, {
        component: "li",
        "aria-disabled": disabled,
        style: {
            ...directionStyle,
            ...style
        },
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(itemCls, {
            [`${itemCls}-active`]: active,
            [`${itemCls}-selected`]: selected,
            [`${itemCls}-disabled`]: mergedDisabled
        }, className),
        onClick: onInternalClick,
        onKeyDown: onInternalKeyDown,
        onFocus: onInternalFocus
    }), children, /*#__PURE__*/ $hO8yS.createElement((0, $7e71bab9c8cd5296$export$2e2bcd8739ae039), {
        props: {
            ...props,
            isSelected: selected
        },
        icon: mergedItemIcon
    }));
    if (_internalRenderMenuItem) renderNode = _internalRenderMenuItem(renderNode, props, {
        selected: selected
    });
    return renderNode;
});
function $c44576def6898817$var$MenuItem(props, ref) {
    const { eventKey: eventKey } = props;
    // ==================== Record KeyPath ====================
    const measure = (0, $4d1b4cb331d72abd$export$e295b0c537d32d7d)();
    const connectedKeyPath = (0, $4d1b4cb331d72abd$export$d3d2d0a05677870a)(eventKey);
    // eslint-disable-next-line consistent-return
    $32rMB.useEffect(()=>{
        if (measure) {
            measure.registerPath(eventKey, connectedKeyPath);
            return ()=>{
                measure.unregisterPath(eventKey, connectedKeyPath);
            };
        }
    }, [
        connectedKeyPath
    ]);
    if (measure) return null;
    // ======================== Render ========================
    return /*#__PURE__*/ $hO8yS.createElement($c44576def6898817$var$InternalMenuItem, $c44576def6898817$var$_extends({}, props, {
        ref: ref
    }));
}
var $c44576def6898817$export$2e2bcd8739ae039 = /*#__PURE__*/ $N3oW3.forwardRef($c44576def6898817$var$MenuItem);


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");



parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");


function $d60741da740535fa$var$_extends() {
    $d60741da740535fa$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d60741da740535fa$var$_extends.apply(this, arguments);
}
const $d60741da740535fa$var$InternalSubMenuList = ({ className: className, children: children, ...restProps }, ref)=>{
    const { prefixCls: prefixCls, mode: mode, rtl: rtl } = $32rMB.useContext((0, $89decf4267c52ca4$export$c7e742effb1c51e2));
    return /*#__PURE__*/ $hO8yS.createElement("ul", $d60741da740535fa$var$_extends({
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, rtl && `${prefixCls}-rtl`, `${prefixCls}-sub`, `${prefixCls}-${mode === 'inline' ? 'inline' : 'vertical'}`, className),
        role: "menu"
    }, restProps, {
        "data-menu-list": true,
        ref: ref
    }), children);
};
const $d60741da740535fa$var$SubMenuList = /*#__PURE__*/ $N3oW3.forwardRef($d60741da740535fa$var$InternalSubMenuList);
var $d60741da740535fa$export$2e2bcd8739ae039 = $d60741da740535fa$var$SubMenuList;




var $N3oW3 = parcelRequire("N3oW3");
function $b0be1c411315864a$export$cd230e97e668be9(children, keyPath) {
    return (0, $a60ede783f74e6a9$export$2e2bcd8739ae039)(children).map((child, index)=>{
        if (/*#__PURE__*/ $N3oW3.isValidElement(child)) {
            const { key: key } = child;
            let eventKey = child.props?.eventKey ?? key;
            const emptyKey = eventKey === null || eventKey === undefined;
            if (emptyKey) eventKey = `tmp_key-${[
                ...keyPath,
                index
            ].join('-')}`;
            const cloneProps = {
                key: eventKey,
                eventKey: eventKey
            };
            return /*#__PURE__*/ $N3oW3.cloneElement(child, cloneProps);
        }
        return child;
    });
}




parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");




const $6f626e82e62eecbf$var$autoAdjustOverflow = {
    adjustX: 1,
    adjustY: 1
};
const $6f626e82e62eecbf$export$803cd8101b6c182b = {
    topLeft: {
        points: [
            'bl',
            'tl'
        ],
        overflow: $6f626e82e62eecbf$var$autoAdjustOverflow
    },
    topRight: {
        points: [
            'br',
            'tr'
        ],
        overflow: $6f626e82e62eecbf$var$autoAdjustOverflow
    },
    bottomLeft: {
        points: [
            'tl',
            'bl'
        ],
        overflow: $6f626e82e62eecbf$var$autoAdjustOverflow
    },
    bottomRight: {
        points: [
            'tr',
            'br'
        ],
        overflow: $6f626e82e62eecbf$var$autoAdjustOverflow
    },
    leftTop: {
        points: [
            'tr',
            'tl'
        ],
        overflow: $6f626e82e62eecbf$var$autoAdjustOverflow
    },
    leftBottom: {
        points: [
            'br',
            'bl'
        ],
        overflow: $6f626e82e62eecbf$var$autoAdjustOverflow
    },
    rightTop: {
        points: [
            'tl',
            'tr'
        ],
        overflow: $6f626e82e62eecbf$var$autoAdjustOverflow
    },
    rightBottom: {
        points: [
            'bl',
            'br'
        ],
        overflow: $6f626e82e62eecbf$var$autoAdjustOverflow
    }
};
const $6f626e82e62eecbf$export$e2b3f69b0a16e1f = {
    topLeft: {
        points: [
            'bl',
            'tl'
        ],
        overflow: $6f626e82e62eecbf$var$autoAdjustOverflow
    },
    topRight: {
        points: [
            'br',
            'tr'
        ],
        overflow: $6f626e82e62eecbf$var$autoAdjustOverflow
    },
    bottomLeft: {
        points: [
            'tl',
            'bl'
        ],
        overflow: $6f626e82e62eecbf$var$autoAdjustOverflow
    },
    bottomRight: {
        points: [
            'tr',
            'br'
        ],
        overflow: $6f626e82e62eecbf$var$autoAdjustOverflow
    },
    rightTop: {
        points: [
            'tr',
            'tl'
        ],
        overflow: $6f626e82e62eecbf$var$autoAdjustOverflow
    },
    rightBottom: {
        points: [
            'br',
            'bl'
        ],
        overflow: $6f626e82e62eecbf$var$autoAdjustOverflow
    },
    leftTop: {
        points: [
            'tl',
            'tr'
        ],
        overflow: $6f626e82e62eecbf$var$autoAdjustOverflow
    },
    leftBottom: {
        points: [
            'bl',
            'br'
        ],
        overflow: $6f626e82e62eecbf$var$autoAdjustOverflow
    }
};
var $6f626e82e62eecbf$export$2e2bcd8739ae039 = $6f626e82e62eecbf$export$803cd8101b6c182b;


function $917790013d4e0201$export$7b8936ddc277a29a(mode, motion, defaultMotions) {
    if (motion) return motion;
    if (defaultMotions) return defaultMotions[mode] || defaultMotions.other;
    return undefined;
}


const $547a7fa3ba03e4fc$var$popupPlacementMap = {
    horizontal: 'bottomLeft',
    vertical: 'rightTop',
    'vertical-left': 'rightTop',
    'vertical-right': 'leftTop'
};
function $547a7fa3ba03e4fc$export$2e2bcd8739ae039({ prefixCls: prefixCls, visible: visible, children: children, popup: popup, popupStyle: popupStyle, popupClassName: popupClassName, popupOffset: popupOffset, disabled: disabled, mode: mode, onVisibleChange: onVisibleChange }) {
    const { getPopupContainer: getPopupContainer, rtl: rtl, subMenuOpenDelay: subMenuOpenDelay, subMenuCloseDelay: subMenuCloseDelay, builtinPlacements: builtinPlacements, triggerSubMenuAction: triggerSubMenuAction, forceSubMenuRender: forceSubMenuRender, rootClassName: rootClassName, motion: // Motion
    motion, defaultMotions: defaultMotions } = $32rMB.useContext((0, $89decf4267c52ca4$export$c7e742effb1c51e2));
    const [innerVisible, setInnerVisible] = $32rMB.useState(false);
    const placement = rtl ? {
        ...(0, $6f626e82e62eecbf$export$e2b3f69b0a16e1f),
        ...builtinPlacements
    } : {
        ...(0, $6f626e82e62eecbf$export$803cd8101b6c182b),
        ...builtinPlacements
    };
    const popupPlacement = $547a7fa3ba03e4fc$var$popupPlacementMap[mode];
    const targetMotion = (0, $917790013d4e0201$export$7b8936ddc277a29a)(mode, motion, defaultMotions);
    const targetMotionRef = $32rMB.useRef(targetMotion);
    if (mode !== 'inline') /**
     * PopupTrigger is only used for vertical and horizontal types.
     * When collapsed is unfolded, the inline animation will destroy the vertical animation.
     */ targetMotionRef.current = targetMotion;
    const mergedMotion = {
        ...targetMotionRef.current,
        leavedClassName: `${prefixCls}-hidden`,
        removeOnLeave: false,
        motionAppear: true
    };
    // Delay to change visible
    const visibleRef = $32rMB.useRef();
    $32rMB.useEffect(()=>{
        visibleRef.current = (0, $c9c36e20d667d30c$export$2e2bcd8739ae039)(()=>{
            setInnerVisible(visible);
        });
        return ()=>{
            (0, $c9c36e20d667d30c$export$2e2bcd8739ae039).cancel(visibleRef.current);
        };
    }, [
        visible
    ]);
    return /*#__PURE__*/ $hO8yS.createElement((0, $0cc98d0cfc01331c$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        popupClassName: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-popup`, {
            [`${prefixCls}-rtl`]: rtl
        }, popupClassName, rootClassName),
        stretch: mode === 'horizontal' ? 'minWidth' : null,
        getPopupContainer: getPopupContainer,
        builtinPlacements: placement,
        popupPlacement: popupPlacement,
        popupVisible: innerVisible,
        popup: popup,
        popupStyle: popupStyle,
        popupAlign: popupOffset && {
            offset: popupOffset
        },
        action: disabled ? [] : [
            triggerSubMenuAction
        ],
        mouseEnterDelay: subMenuOpenDelay,
        mouseLeaveDelay: subMenuCloseDelay,
        onPopupVisibleChange: onVisibleChange,
        forceRender: forceSubMenuRender,
        popupMotion: mergedMotion,
        fresh: true
    }, children);
}






parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");




function $d949d8e0bc846110$var$_extends() {
    $d949d8e0bc846110$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d949d8e0bc846110$var$_extends.apply(this, arguments);
}
function $d949d8e0bc846110$export$2e2bcd8739ae039({ id: id, open: open, keyPath: keyPath, children: children }) {
    const fixedMode = 'inline';
    const { prefixCls: prefixCls, forceSubMenuRender: forceSubMenuRender, motion: motion, defaultMotions: defaultMotions, mode: mode } = $32rMB.useContext((0, $89decf4267c52ca4$export$c7e742effb1c51e2));
    // Always use latest mode check
    const sameModeRef = $32rMB.useRef(false);
    sameModeRef.current = mode === fixedMode;
    // We record `destroy` mark here since when mode change from `inline` to others.
    // The inline list should remove when motion end.
    const [destroy, setDestroy] = $32rMB.useState(!sameModeRef.current);
    const mergedOpen = sameModeRef.current ? open : false;
    // ================================= Effect =================================
    // Reset destroy state when mode change back
    $32rMB.useEffect(()=>{
        if (sameModeRef.current) setDestroy(false);
    }, [
        mode
    ]);
    // ================================= Render =================================
    const mergedMotion = {
        ...(0, $917790013d4e0201$export$7b8936ddc277a29a)(fixedMode, motion, defaultMotions)
    };
    // No need appear since nest inlineCollapse changed
    if (keyPath.length > 1) mergedMotion.motionAppear = false;
    // Hide inline list when mode changed and motion end
    const originOnVisibleChanged = mergedMotion.onVisibleChanged;
    mergedMotion.onVisibleChanged = (newVisible)=>{
        if (!sameModeRef.current && !newVisible) setDestroy(true);
        return originOnVisibleChanged?.(newVisible);
    };
    if (destroy) return null;
    return /*#__PURE__*/ $hO8yS.createElement((0, $89decf4267c52ca4$export$2e2bcd8739ae039), {
        mode: fixedMode,
        locked: !sameModeRef.current
    }, /*#__PURE__*/ $hO8yS.createElement((0, $db80a026d0a86ece$export$2e2bcd8739ae039), $d949d8e0bc846110$var$_extends({
        visible: mergedOpen
    }, mergedMotion, {
        forceRender: forceSubMenuRender,
        removeOnLeave: false,
        leavedClassName: `${prefixCls}-hidden`
    }), ({ className: motionClassName, style: motionStyle })=>{
        return /*#__PURE__*/ $hO8yS.createElement((0, $d60741da740535fa$export$2e2bcd8739ae039), {
            id: id,
            className: motionClassName,
            style: motionStyle
        }, children);
    }));
}





function $0211eb57621e76e2$var$_extends() {
    $0211eb57621e76e2$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0211eb57621e76e2$var$_extends.apply(this, arguments);
}
const $0211eb57621e76e2$var$InternalSubMenu = /*#__PURE__*/ $N3oW3.forwardRef((props, ref)=>{
    const { style: style, className: className, styles: styles, classNames: menuClassNames, title: title, eventKey: eventKey, warnKey: warnKey, disabled: disabled, internalPopupClose: internalPopupClose, children: children, itemIcon: // Icons
    itemIcon, expandIcon: expandIcon, popupClassName: // Popup
    popupClassName, popupOffset: popupOffset, popupStyle: popupStyle, onClick: // Events
    onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTitleClick: onTitleClick, onTitleMouseEnter: onTitleMouseEnter, onTitleMouseLeave: onTitleMouseLeave, popupRender: propsPopupRender, ...restProps } = props;
    const domDataId = (0, $64474b8ac302169b$export$a276eb4e9be640f8)(eventKey);
    const { prefixCls: prefixCls, mode: mode, openKeys: openKeys, // Disabled
    disabled: contextDisabled, overflowDisabled: overflowDisabled, activeKey: // ActiveKey
    activeKey, selectedKeys: // SelectKey
    selectedKeys, // Icon
    itemIcon: contextItemIcon, expandIcon: contextExpandIcon, onItemClick: // Events
    onItemClick, onOpenChange: onOpenChange, onActive: onActive, popupRender: contextPopupRender } = $32rMB.useContext((0, $89decf4267c52ca4$export$c7e742effb1c51e2));
    const { _internalRenderSubMenuItem: _internalRenderSubMenuItem } = $32rMB.useContext((0, $cd4f5cf1f700ce8f$export$2e2bcd8739ae039));
    const { isSubPathKey: isSubPathKey } = $32rMB.useContext((0, $4d1b4cb331d72abd$export$f0b9e0db98edfa53));
    const connectedPath = (0, $4d1b4cb331d72abd$export$d3d2d0a05677870a)();
    const subMenuPrefixCls = `${prefixCls}-submenu`;
    const mergedDisabled = contextDisabled || disabled;
    const elementRef = $32rMB.useRef();
    const popupRef = $32rMB.useRef();
    // ================================ Icon ================================
    const mergedItemIcon = itemIcon ?? contextItemIcon;
    const mergedExpandIcon = expandIcon ?? contextExpandIcon;
    // ================================ Open ================================
    const originOpen = openKeys.includes(eventKey);
    const open = !overflowDisabled && originOpen;
    // =============================== Select ===============================
    const childrenSelected = isSubPathKey(selectedKeys, eventKey);
    // =============================== Active ===============================
    const { active: active, ...activeProps } = (0, $115f2373850ba42d$export$2e2bcd8739ae039)(eventKey, mergedDisabled, onTitleMouseEnter, onTitleMouseLeave);
    // Fallback of active check to avoid hover on menu title or disabled item
    const [childrenActive, setChildrenActive] = $32rMB.useState(false);
    const triggerChildrenActive = (newActive)=>{
        if (!mergedDisabled) setChildrenActive(newActive);
    };
    const onInternalMouseEnter = (domEvent)=>{
        triggerChildrenActive(true);
        onMouseEnter?.({
            key: eventKey,
            domEvent: domEvent
        });
    };
    const onInternalMouseLeave = (domEvent)=>{
        triggerChildrenActive(false);
        onMouseLeave?.({
            key: eventKey,
            domEvent: domEvent
        });
    };
    const mergedActive = $32rMB.useMemo(()=>{
        if (active) return active;
        if (mode !== 'inline') return childrenActive || isSubPathKey([
            activeKey
        ], eventKey);
        return false;
    }, [
        mode,
        active,
        activeKey,
        childrenActive,
        eventKey,
        isSubPathKey
    ]);
    // ========================== DirectionStyle ==========================
    const directionStyle = (0, $0a9c9cf62002ab5f$export$2e2bcd8739ae039)(connectedPath.length);
    // =============================== Events ===============================
    // >>>> Title click
    const onInternalTitleClick = (e)=>{
        // Skip if disabled
        if (mergedDisabled) return;
        onTitleClick?.({
            key: eventKey,
            domEvent: e
        });
        // Trigger open by click when mode is `inline`
        if (mode === 'inline') onOpenChange(eventKey, !originOpen);
    };
    // >>>> Context for children click
    const onMergedItemClick = (0, $ada02c1c0f42cf72$export$2e2bcd8739ae039)((info)=>{
        onClick?.((0, $6d4de5d3936ee291$export$e189bcd94b66c1db)(info));
        onItemClick(info);
    });
    // >>>>> Visible change
    const onPopupVisibleChange = (newVisible)=>{
        if (mode !== 'inline') onOpenChange(eventKey, newVisible);
    };
    /**
   * Used for accessibility. Helper will focus element without key board.
   * We should manually trigger an active
   */ const onInternalFocus = ()=>{
        onActive(eventKey);
    };
    // =============================== Render ===============================
    const popupId = domDataId && `${domDataId}-popup`;
    const expandIconNode = $32rMB.useMemo(()=>/*#__PURE__*/ $hO8yS.createElement((0, $7e71bab9c8cd5296$export$2e2bcd8739ae039), {
            icon: mode !== 'horizontal' ? mergedExpandIcon : undefined,
            props: {
                ...props,
                isOpen: open,
                // [Legacy] Not sure why need this mark
                isSubMenu: true
            }
        }, /*#__PURE__*/ $hO8yS.createElement("i", {
            className: `${subMenuPrefixCls}-arrow`
        })), [
        mode,
        mergedExpandIcon,
        props,
        open,
        subMenuPrefixCls
    ]);
    // >>>>> Title
    let titleNode = /*#__PURE__*/ $hO8yS.createElement("div", $0211eb57621e76e2$var$_extends({
        role: "menuitem",
        style: directionStyle,
        className: `${subMenuPrefixCls}-title`,
        tabIndex: mergedDisabled ? null : -1,
        ref: elementRef,
        title: typeof title === 'string' ? title : null,
        "data-menu-id": overflowDisabled && domDataId ? null : domDataId,
        "aria-expanded": open,
        "aria-haspopup": true,
        "aria-controls": popupId,
        "aria-disabled": mergedDisabled,
        onClick: onInternalTitleClick,
        onFocus: onInternalFocus
    }, activeProps), title, expandIconNode);
    // Cache mode if it change to `inline` which do not have popup motion
    const triggerModeRef = $32rMB.useRef(mode);
    if (mode !== 'inline' && connectedPath.length > 1) triggerModeRef.current = 'vertical';
    else triggerModeRef.current = mode;
    const popupContentTriggerMode = triggerModeRef.current;
    const renderPopupContent = $32rMB.useMemo(()=>{
        const originNode = /*#__PURE__*/ $hO8yS.createElement((0, $89decf4267c52ca4$export$2e2bcd8739ae039), {
            classNames: menuClassNames,
            styles: styles,
            mode: popupContentTriggerMode === 'horizontal' ? 'vertical' : popupContentTriggerMode
        }, /*#__PURE__*/ $hO8yS.createElement((0, $d60741da740535fa$export$2e2bcd8739ae039), {
            id: popupId,
            ref: popupRef
        }, children));
        const mergedPopupRender = propsPopupRender || contextPopupRender;
        if (mergedPopupRender) {
            const node = mergedPopupRender(originNode, {
                item: props,
                keys: connectedPath
            });
            return node;
        }
        return originNode;
    }, [
        propsPopupRender,
        contextPopupRender,
        connectedPath,
        popupId,
        children,
        props,
        popupContentTriggerMode
    ]);
    if (!overflowDisabled) {
        const triggerMode = triggerModeRef.current;
        // Still wrap with Trigger here since we need avoid react re-mount dom node
        // Which makes motion failed
        titleNode = /*#__PURE__*/ $hO8yS.createElement((0, $547a7fa3ba03e4fc$export$2e2bcd8739ae039), {
            mode: triggerMode,
            prefixCls: subMenuPrefixCls,
            visible: !internalPopupClose && open && mode !== 'inline',
            popupClassName: popupClassName,
            popupOffset: popupOffset,
            popupStyle: popupStyle,
            popup: renderPopupContent,
            disabled: mergedDisabled,
            onVisibleChange: onPopupVisibleChange
        }, titleNode);
    }
    // >>>>> List node
    let listNode = /*#__PURE__*/ $hO8yS.createElement((0, $12a6b9a6c34b9880$export$2e2bcd8739ae039).Item, $0211eb57621e76e2$var$_extends({
        ref: ref,
        role: "none"
    }, restProps, {
        component: "li",
        style: style,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(subMenuPrefixCls, `${subMenuPrefixCls}-${mode}`, className, {
            [`${subMenuPrefixCls}-open`]: open,
            [`${subMenuPrefixCls}-active`]: mergedActive,
            [`${subMenuPrefixCls}-selected`]: childrenSelected,
            [`${subMenuPrefixCls}-disabled`]: mergedDisabled
        }),
        onMouseEnter: onInternalMouseEnter,
        onMouseLeave: onInternalMouseLeave
    }), titleNode, !overflowDisabled && /*#__PURE__*/ $hO8yS.createElement((0, $d949d8e0bc846110$export$2e2bcd8739ae039), {
        id: popupId,
        open: open,
        keyPath: connectedPath
    }, children));
    if (_internalRenderSubMenuItem) listNode = _internalRenderSubMenuItem(listNode, props, {
        selected: childrenSelected,
        active: mergedActive,
        open: open,
        disabled: mergedDisabled
    });
    // >>>>> Render
    return /*#__PURE__*/ $hO8yS.createElement((0, $89decf4267c52ca4$export$2e2bcd8739ae039), {
        classNames: menuClassNames,
        styles: styles,
        onItemClick: onMergedItemClick,
        mode: mode === 'horizontal' ? 'vertical' : mode,
        itemIcon: mergedItemIcon,
        expandIcon: mergedExpandIcon
    }, listNode);
});
const $0211eb57621e76e2$var$SubMenu = /*#__PURE__*/ $N3oW3.forwardRef((props, ref)=>{
    const { eventKey: eventKey, children: children } = props;
    const connectedKeyPath = (0, $4d1b4cb331d72abd$export$d3d2d0a05677870a)(eventKey);
    const childList = (0, $b0be1c411315864a$export$cd230e97e668be9)(children, connectedKeyPath);
    // ==================== Record KeyPath ====================
    const measure = (0, $4d1b4cb331d72abd$export$e295b0c537d32d7d)();
    // eslint-disable-next-line consistent-return
    $32rMB.useEffect(()=>{
        if (measure) {
            measure.registerPath(eventKey, connectedKeyPath);
            return ()=>{
                measure.unregisterPath(eventKey, connectedKeyPath);
            };
        }
    }, [
        connectedKeyPath
    ]);
    let renderNode;
    // ======================== Render ========================
    if (measure) renderNode = childList;
    else renderNode = /*#__PURE__*/ $hO8yS.createElement($0211eb57621e76e2$var$InternalSubMenu, $0211eb57621e76e2$var$_extends({
        ref: ref
    }, props), childList);
    return /*#__PURE__*/ $hO8yS.createElement((0, $4d1b4cb331d72abd$export$54d9e16aa4c8a7fa).Provider, {
        value: connectedKeyPath
    }, renderNode);
});
var $0211eb57621e76e2$export$2e2bcd8739ae039 = $0211eb57621e76e2$var$SubMenu;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");



function $4a86d0c1965ddd84$export$2e2bcd8739ae039({ className: className, style: style }) {
    const { prefixCls: prefixCls } = $32rMB.useContext((0, $89decf4267c52ca4$export$c7e742effb1c51e2));
    const measure = (0, $4d1b4cb331d72abd$export$e295b0c537d32d7d)();
    if (measure) return null;
    return /*#__PURE__*/ $hO8yS.createElement("li", {
        role: "separator",
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-item-divider`, className),
        style: style
    });
}





parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");



function $520d4c893c082639$var$_extends() {
    $520d4c893c082639$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $520d4c893c082639$var$_extends.apply(this, arguments);
}
const $520d4c893c082639$var$InternalMenuItemGroup = /*#__PURE__*/ $N3oW3.forwardRef((props, ref)=>{
    const { className: className, title: title, eventKey: eventKey, children: children, ...restProps } = props;
    const { prefixCls: prefixCls, classNames: menuClassNames, styles: styles } = $32rMB.useContext((0, $89decf4267c52ca4$export$c7e742effb1c51e2));
    const groupPrefixCls = `${prefixCls}-item-group`;
    return /*#__PURE__*/ $hO8yS.createElement("li", $520d4c893c082639$var$_extends({
        ref: ref,
        role: "presentation"
    }, restProps, {
        onClick: (e)=>e.stopPropagation(),
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(groupPrefixCls, className)
    }), /*#__PURE__*/ $hO8yS.createElement("div", {
        role: "presentation",
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${groupPrefixCls}-title`, menuClassNames?.listTitle),
        style: styles?.listTitle,
        title: typeof title === 'string' ? title : undefined
    }, title), /*#__PURE__*/ $hO8yS.createElement("ul", {
        role: "group",
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${groupPrefixCls}-list`, menuClassNames?.list),
        style: styles?.list
    }, children));
});
const $520d4c893c082639$var$MenuItemGroup = /*#__PURE__*/ $N3oW3.forwardRef((props, ref)=>{
    const { eventKey: eventKey, children: children } = props;
    const connectedKeyPath = (0, $4d1b4cb331d72abd$export$d3d2d0a05677870a)(eventKey);
    const childList = (0, $b0be1c411315864a$export$cd230e97e668be9)(children, connectedKeyPath);
    const measure = (0, $4d1b4cb331d72abd$export$e295b0c537d32d7d)();
    if (measure) return childList;
    return /*#__PURE__*/ $hO8yS.createElement($520d4c893c082639$var$InternalMenuItemGroup, $520d4c893c082639$var$_extends({
        ref: ref
    }, (0, $f4cf9c2e27c0ac8d$export$2e2bcd8739ae039)(props, [
        'warnKey'
    ])), childList);
});
var $520d4c893c082639$export$2e2bcd8739ae039 = $520d4c893c082639$var$MenuItemGroup;




function $99bc74c20f3dfe08$var$_extends() {
    $99bc74c20f3dfe08$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $99bc74c20f3dfe08$var$_extends.apply(this, arguments);
}
function $99bc74c20f3dfe08$var$convertItemsToNodes(list, components, prefixCls) {
    const { item: MergedMenuItem, group: MergedMenuItemGroup, submenu: MergedSubMenu, divider: MergedDivider } = components;
    return (list || []).map((opt, index)=>{
        if (opt && typeof opt === 'object') {
            const { label: label, children: children, key: key, type: type, extra: extra, ...restProps } = opt;
            const mergedKey = key ?? `tmp-${index}`;
            // MenuItemGroup & SubMenuItem
            if (children || type === 'group') {
                if (type === 'group') // Group
                return /*#__PURE__*/ $hO8yS.createElement(MergedMenuItemGroup, $99bc74c20f3dfe08$var$_extends({
                    key: mergedKey
                }, restProps, {
                    title: label
                }), $99bc74c20f3dfe08$var$convertItemsToNodes(children, components, prefixCls));
                // Sub Menu
                return /*#__PURE__*/ $hO8yS.createElement(MergedSubMenu, $99bc74c20f3dfe08$var$_extends({
                    key: mergedKey
                }, restProps, {
                    title: label
                }), $99bc74c20f3dfe08$var$convertItemsToNodes(children, components, prefixCls));
            }
            // MenuItem & Divider
            if (type === 'divider') return /*#__PURE__*/ $hO8yS.createElement(MergedDivider, $99bc74c20f3dfe08$var$_extends({
                key: mergedKey
            }, restProps));
            return /*#__PURE__*/ $hO8yS.createElement(MergedMenuItem, $99bc74c20f3dfe08$var$_extends({
                key: mergedKey
            }, restProps, {
                extra: extra
            }), label, (!!extra || extra === 0) && /*#__PURE__*/ $hO8yS.createElement("span", {
                className: `${prefixCls}-item-extra`
            }, extra));
        }
        return null;
    }).filter((opt)=>opt);
}
function $99bc74c20f3dfe08$export$50458dc1a9a0f894(children, items, keyPath, components, prefixCls) {
    let childNodes = children;
    const mergedComponents = {
        divider: (0, $4a86d0c1965ddd84$export$2e2bcd8739ae039),
        item: (0, $c44576def6898817$export$2e2bcd8739ae039),
        group: (0, $520d4c893c082639$export$2e2bcd8739ae039),
        submenu: (0, $0211eb57621e76e2$export$2e2bcd8739ae039),
        ...components
    };
    if (items) childNodes = $99bc74c20f3dfe08$var$convertItemsToNodes(items, mergedComponents, prefixCls);
    return (0, $b0be1c411315864a$export$cd230e97e668be9)(childNodes, keyPath);
}



function $7783f523f3b287e3$var$_extends() {
    $7783f523f3b287e3$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7783f523f3b287e3$var$_extends.apply(this, arguments);
}
/**
 * Menu modify after refactor:
 * ## Add
 * - disabled
 *
 * ## Remove
 * - openTransitionName
 * - openAnimation
 * - onDestroy
 * - siderCollapsed: Seems antd do not use this prop (Need test in antd)
 * - collapsedWidth: Seems this logic should be handle by antd Layout.Sider
 */ // optimize for render
const $7783f523f3b287e3$var$EMPTY_LIST = [];
const $7783f523f3b287e3$var$Menu = /*#__PURE__*/ $N3oW3.forwardRef((props, ref)=>{
    const { prefixCls: prefixCls = 'rc-menu', rootClassName: rootClassName, style: style, className: className, styles: styles, classNames: menuClassNames, tabIndex: tabIndex = 0, items: items, children: children, direction: direction, id: id, mode: // Mode
    mode = 'vertical', inlineCollapsed: inlineCollapsed, disabled: // Disabled
    disabled, disabledOverflow: disabledOverflow, subMenuOpenDelay: // Open
    subMenuOpenDelay = 0.1, subMenuCloseDelay: subMenuCloseDelay = 0.1, forceSubMenuRender: forceSubMenuRender, defaultOpenKeys: defaultOpenKeys, openKeys: openKeys, activeKey: // Active
    activeKey, defaultActiveFirst: defaultActiveFirst, selectable: // Selection
    selectable = true, multiple: multiple = false, defaultSelectedKeys: defaultSelectedKeys, selectedKeys: selectedKeys, onSelect: onSelect, onDeselect: onDeselect, inlineIndent: // Level
    inlineIndent = 24, motion: // Motion
    motion, defaultMotions: defaultMotions, triggerSubMenuAction: // Popup
    triggerSubMenuAction = 'hover', builtinPlacements: builtinPlacements, itemIcon: // Icon
    itemIcon, expandIcon: expandIcon, overflowedIndicator: overflowedIndicator = '...', overflowedIndicatorPopupClassName: overflowedIndicatorPopupClassName, getPopupContainer: // Function
    getPopupContainer, onClick: // Events
    onClick, onOpenChange: onOpenChange, onKeyDown: onKeyDown, openAnimation: // Deprecated
    openAnimation, openTransitionName: openTransitionName, _internalRenderMenuItem: // Internal
    _internalRenderMenuItem, _internalRenderSubMenuItem: _internalRenderSubMenuItem, _internalComponents: _internalComponents, popupRender: popupRender, ...restProps } = props;
    const [childList, measureChildList] = $32rMB.useMemo(()=>[
            (0, $99bc74c20f3dfe08$export$50458dc1a9a0f894)(children, items, $7783f523f3b287e3$var$EMPTY_LIST, _internalComponents, prefixCls),
            (0, $99bc74c20f3dfe08$export$50458dc1a9a0f894)(children, items, $7783f523f3b287e3$var$EMPTY_LIST, {}, prefixCls)
        ], [
        children,
        items,
        _internalComponents
    ]);
    const [mounted, setMounted] = $32rMB.useState(false);
    const containerRef = $32rMB.useRef();
    const uuid = (0, $32268c06752c3bab$export$2e2bcd8739ae039)(id ? `rc-menu-uuid-${id}` : 'rc-menu-uuid');
    const isRtl = direction === 'rtl';
    // ========================= Open =========================
    const [innerOpenKeys, setMergedOpenKeys] = (0, $05ea6e97cee440ee$export$2e2bcd8739ae039)(defaultOpenKeys, openKeys);
    const mergedOpenKeys = innerOpenKeys || $7783f523f3b287e3$var$EMPTY_LIST;
    // React 18 will merge mouse event which means we open key will not sync
    // ref: https://github.com/ant-design/ant-design/issues/38818
    const triggerOpenKeys = (keys, forceFlush = false)=>{
        function doUpdate() {
            setMergedOpenKeys(keys);
            onOpenChange?.(keys);
        }
        if (forceFlush) (0, $N3oW3.flushSync)(doUpdate);
        else doUpdate();
    };
    // >>>>> Cache & Reset open keys when inlineCollapsed changed
    const [inlineCacheOpenKeys, setInlineCacheOpenKeys] = $32rMB.useState(mergedOpenKeys);
    const mountRef = $32rMB.useRef(false);
    // ========================= Mode =========================
    const [mergedMode, mergedInlineCollapsed] = $32rMB.useMemo(()=>{
        if ((mode === 'inline' || mode === 'vertical') && inlineCollapsed) return [
            'vertical',
            inlineCollapsed
        ];
        return [
            mode,
            false
        ];
    }, [
        mode,
        inlineCollapsed
    ]);
    const isInlineMode = mergedMode === 'inline';
    const [internalMode, setInternalMode] = $32rMB.useState(mergedMode);
    const [internalInlineCollapsed, setInternalInlineCollapsed] = $32rMB.useState(mergedInlineCollapsed);
    $32rMB.useEffect(()=>{
        setInternalMode(mergedMode);
        setInternalInlineCollapsed(mergedInlineCollapsed);
        if (!mountRef.current) return;
        // Synchronously update MergedOpenKeys
        if (isInlineMode) setMergedOpenKeys(inlineCacheOpenKeys);
        else // Trigger open event in case its in control
        triggerOpenKeys($7783f523f3b287e3$var$EMPTY_LIST);
    }, [
        mergedMode,
        mergedInlineCollapsed
    ]);
    // ====================== Responsive ======================
    const [lastVisibleIndex, setLastVisibleIndex] = $32rMB.useState(0);
    const allVisible = lastVisibleIndex >= childList.length - 1 || internalMode !== 'horizontal' || disabledOverflow;
    // Cache
    $32rMB.useEffect(()=>{
        if (isInlineMode) setInlineCacheOpenKeys(mergedOpenKeys);
    }, [
        mergedOpenKeys
    ]);
    $32rMB.useEffect(()=>{
        mountRef.current = true;
        return ()=>{
            mountRef.current = false;
        };
    }, []);
    // ========================= Path =========================
    const { registerPath: registerPath, unregisterPath: unregisterPath, refreshOverflowKeys: refreshOverflowKeys, isSubPathKey: isSubPathKey, getKeyPath: getKeyPath, getKeys: getKeys, getSubPathKeys: getSubPathKeys } = (0, $595e43546c04bae6$export$2e2bcd8739ae039)();
    const registerPathContext = $32rMB.useMemo(()=>({
            registerPath: registerPath,
            unregisterPath: unregisterPath
        }), [
        registerPath,
        unregisterPath
    ]);
    const pathUserContext = $32rMB.useMemo(()=>({
            isSubPathKey: isSubPathKey
        }), [
        isSubPathKey
    ]);
    $32rMB.useEffect(()=>{
        refreshOverflowKeys(allVisible ? $7783f523f3b287e3$var$EMPTY_LIST : childList.slice(lastVisibleIndex + 1).map((child)=>child.key));
    }, [
        lastVisibleIndex,
        allVisible
    ]);
    // ======================== Active ========================
    const [mergedActiveKey, setMergedActiveKey] = (0, $05ea6e97cee440ee$export$2e2bcd8739ae039)(activeKey || defaultActiveFirst && childList[0]?.key, activeKey);
    const onActive = (0, $ada02c1c0f42cf72$export$2e2bcd8739ae039)((key)=>{
        setMergedActiveKey(key);
    });
    const onInactive = (0, $ada02c1c0f42cf72$export$2e2bcd8739ae039)(()=>{
        setMergedActiveKey(undefined);
    });
    (0, $32rMB.useImperativeHandle)(ref, ()=>{
        return {
            list: containerRef.current,
            focus: (options)=>{
                const keys = getKeys();
                const { elements: elements, key2element: key2element, element2key: element2key } = (0, $26171a6153c4c15d$export$20827b68c762d23)(keys, uuid);
                const focusableElements = (0, $26171a6153c4c15d$export$433aaa1f216cf32d)(containerRef.current, elements);
                let shouldFocusKey;
                if (mergedActiveKey && keys.includes(mergedActiveKey)) shouldFocusKey = mergedActiveKey;
                else shouldFocusKey = focusableElements[0] ? element2key.get(focusableElements[0]) : childList.find((node)=>!node.props.disabled)?.key;
                const elementToFocus = key2element.get(shouldFocusKey);
                if (shouldFocusKey && elementToFocus) elementToFocus?.focus?.(options);
            },
            findItem: ({ key: itemKey })=>{
                const keys = getKeys();
                const { key2element: key2element } = (0, $26171a6153c4c15d$export$20827b68c762d23)(keys, uuid);
                return key2element.get(itemKey) || null;
            }
        };
    });
    // ======================== Select ========================
    // >>>>> Select keys
    const [internalSelectKeys, setMergedSelectKeys] = (0, $05ea6e97cee440ee$export$2e2bcd8739ae039)(defaultSelectedKeys || [], selectedKeys);
    const mergedSelectKeys = $32rMB.useMemo(()=>{
        if (Array.isArray(internalSelectKeys)) return internalSelectKeys;
        if (internalSelectKeys === null || internalSelectKeys === undefined) return $7783f523f3b287e3$var$EMPTY_LIST;
        return [
            internalSelectKeys
        ];
    }, [
        internalSelectKeys
    ]);
    // >>>>> Trigger select
    const triggerSelection = (info)=>{
        if (selectable) {
            // Insert or Remove
            const { key: targetKey } = info;
            const exist = mergedSelectKeys.includes(targetKey);
            let newSelectKeys;
            if (multiple) {
                if (exist) newSelectKeys = mergedSelectKeys.filter((key)=>key !== targetKey);
                else newSelectKeys = [
                    ...mergedSelectKeys,
                    targetKey
                ];
            } else newSelectKeys = [
                targetKey
            ];
            setMergedSelectKeys(newSelectKeys);
            // Trigger event
            const selectInfo = {
                ...info,
                selectedKeys: newSelectKeys
            };
            if (exist) onDeselect?.(selectInfo);
            else onSelect?.(selectInfo);
        }
        // Whatever selectable, always close it
        if (!multiple && mergedOpenKeys.length && internalMode !== 'inline') triggerOpenKeys($7783f523f3b287e3$var$EMPTY_LIST);
    };
    // ========================= Open =========================
    /**
   * Click for item. SubMenu do not have selection status
   */ const onInternalClick = (0, $ada02c1c0f42cf72$export$2e2bcd8739ae039)((info)=>{
        onClick?.((0, $6d4de5d3936ee291$export$e189bcd94b66c1db)(info));
        triggerSelection(info);
    });
    const onInternalOpenChange = (0, $ada02c1c0f42cf72$export$2e2bcd8739ae039)((key, open)=>{
        let newOpenKeys = mergedOpenKeys.filter((k)=>k !== key);
        if (open) newOpenKeys.push(key);
        else if (internalMode !== 'inline') {
            // We need find all related popup to close
            const subPathKeys = getSubPathKeys(key);
            newOpenKeys = newOpenKeys.filter((k)=>!subPathKeys.has(k));
        }
        if (!(0, $5582f7991b7cfce3$export$2e2bcd8739ae039)(mergedOpenKeys, newOpenKeys, true)) triggerOpenKeys(newOpenKeys, true);
    });
    // ==================== Accessibility =====================
    const triggerAccessibilityOpen = (key, open)=>{
        const nextOpen = open ?? !mergedOpenKeys.includes(key);
        onInternalOpenChange(key, nextOpen);
    };
    const onInternalKeyDown = (0, $26171a6153c4c15d$export$aa6de64279d64603)(internalMode, mergedActiveKey, isRtl, uuid, containerRef, getKeys, getKeyPath, setMergedActiveKey, triggerAccessibilityOpen, onKeyDown);
    // ======================== Effect ========================
    $32rMB.useEffect(()=>{
        setMounted(true);
    }, []);
    // ======================= Context ========================
    const privateContext = $32rMB.useMemo(()=>({
            _internalRenderMenuItem: _internalRenderMenuItem,
            _internalRenderSubMenuItem: _internalRenderSubMenuItem
        }), [
        _internalRenderMenuItem,
        _internalRenderSubMenuItem
    ]);
    // ======================== Render ========================
    // >>>>> Children
    const wrappedChildList = internalMode !== 'horizontal' || disabledOverflow ? childList : // Need wrap for overflow dropdown that do not response for open
    childList.map((child, index)=>/*#__PURE__*/ // Always wrap provider to avoid sub node re-mount
        $hO8yS.createElement((0, $89decf4267c52ca4$export$2e2bcd8739ae039), {
            key: child.key,
            overflowDisabled: index > lastVisibleIndex,
            classNames: menuClassNames,
            styles: styles
        }, child));
    // >>>>> Container
    const container = /*#__PURE__*/ $hO8yS.createElement((0, $12a6b9a6c34b9880$export$2e2bcd8739ae039), $7783f523f3b287e3$var$_extends({
        id: id,
        ref: containerRef,
        prefixCls: `${prefixCls}-overflow`,
        component: "ul",
        itemComponent: (0, $c44576def6898817$export$2e2bcd8739ae039),
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-root`, `${prefixCls}-${internalMode}`, className, {
            [`${prefixCls}-inline-collapsed`]: internalInlineCollapsed,
            [`${prefixCls}-rtl`]: isRtl
        }, rootClassName),
        dir: direction,
        style: style,
        role: "menu",
        tabIndex: tabIndex,
        data: wrappedChildList,
        renderRawItem: (node)=>node,
        renderRawRest: (omitItems)=>{
            // We use origin list since wrapped list use context to prevent open
            const len = omitItems.length;
            const originOmitItems = len ? childList.slice(-len) : null;
            return /*#__PURE__*/ $hO8yS.createElement((0, $0211eb57621e76e2$export$2e2bcd8739ae039), {
                eventKey: (0, $595e43546c04bae6$export$20a0132c46ce5b04),
                title: overflowedIndicator,
                disabled: allVisible,
                internalPopupClose: len === 0,
                popupClassName: overflowedIndicatorPopupClassName
            }, originOmitItems);
        },
        maxCount: internalMode !== 'horizontal' || disabledOverflow ? (0, $12a6b9a6c34b9880$export$2e2bcd8739ae039).INVALIDATE : (0, $12a6b9a6c34b9880$export$2e2bcd8739ae039).RESPONSIVE,
        ssr: "full",
        "data-menu-list": true,
        onVisibleChange: (newLastIndex)=>{
            setLastVisibleIndex(newLastIndex);
        },
        onKeyDown: onInternalKeyDown
    }, restProps));
    // >>>>> Render
    return /*#__PURE__*/ $hO8yS.createElement((0, $cd4f5cf1f700ce8f$export$2e2bcd8739ae039).Provider, {
        value: privateContext
    }, /*#__PURE__*/ $hO8yS.createElement((0, $64474b8ac302169b$export$26537912ea160acd).Provider, {
        value: uuid
    }, /*#__PURE__*/ $hO8yS.createElement((0, $89decf4267c52ca4$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        rootClassName: rootClassName,
        classNames: menuClassNames,
        styles: styles,
        mode: internalMode,
        openKeys: mergedOpenKeys,
        rtl: isRtl,
        disabled: disabled,
        motion: mounted ? motion : null,
        defaultMotions: mounted ? defaultMotions : null,
        activeKey: mergedActiveKey,
        onActive: onActive,
        onInactive: onInactive,
        selectedKeys: mergedSelectKeys,
        inlineIndent: inlineIndent,
        subMenuOpenDelay: subMenuOpenDelay,
        subMenuCloseDelay: subMenuCloseDelay,
        forceSubMenuRender: forceSubMenuRender,
        builtinPlacements: builtinPlacements,
        triggerSubMenuAction: triggerSubMenuAction,
        getPopupContainer: getPopupContainer,
        itemIcon: itemIcon,
        expandIcon: expandIcon,
        onItemClick: onInternalClick,
        onOpenChange: onInternalOpenChange,
        popupRender: popupRender
    }, /*#__PURE__*/ $hO8yS.createElement((0, $4d1b4cb331d72abd$export$f0b9e0db98edfa53).Provider, {
        value: pathUserContext
    }, container), /*#__PURE__*/ $hO8yS.createElement("div", {
        style: {
            display: 'none'
        },
        "aria-hidden": true
    }, /*#__PURE__*/ $hO8yS.createElement((0, $4d1b4cb331d72abd$export$d9ffb5bfd108b003).Provider, {
        value: registerPathContext
    }, measureChildList)))));
});
var $7783f523f3b287e3$export$2e2bcd8739ae039 = $7783f523f3b287e3$var$Menu;







const $2b25266c93a9e48f$var$ExportMenu = (0, $7783f523f3b287e3$export$2e2bcd8739ae039);
$2b25266c93a9e48f$var$ExportMenu.Item = (0, $c44576def6898817$export$2e2bcd8739ae039);
$2b25266c93a9e48f$var$ExportMenu.SubMenu = (0, $0211eb57621e76e2$export$2e2bcd8739ae039);
$2b25266c93a9e48f$var$ExportMenu.ItemGroup = (0, $520d4c893c082639$export$2e2bcd8739ae039);
$2b25266c93a9e48f$var$ExportMenu.Divider = (0, $4a86d0c1965ddd84$export$2e2bcd8739ae039);
var $2b25266c93a9e48f$export$2e2bcd8739ae039 = $2b25266c93a9e48f$var$ExportMenu;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
// This icon file is generated automatically.
var $19ed9e0cee9261e9$var$BarsOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0z"
                }
            }
        ]
    },
    "name": "bars",
    "theme": "outlined"
};
var $19ed9e0cee9261e9$export$2e2bcd8739ae039 = $19ed9e0cee9261e9$var$BarsOutlined;



function $514e92571f9d096e$var$_extends() {
    $514e92571f9d096e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $514e92571f9d096e$var$_extends.apply(this, arguments);
}
const $514e92571f9d096e$var$BarsOutlined = (props, ref)=>/*#__PURE__*/ $hO8yS.createElement((0, $5fd6f3f3c400c267$export$2e2bcd8739ae039), $514e92571f9d096e$var$_extends({}, props, {
        ref: ref,
        icon: (0, $19ed9e0cee9261e9$export$2e2bcd8739ae039)
    }));
/**![bars](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkxMiAxOTJIMzI4Yy00LjQgMC04IDMuNi04IDh2NTZjMCA0LjQgMy42IDggOCA4aDU4NGM0LjQgMCA4LTMuNiA4LTh2LTU2YzAtNC40LTMuNi04LTgtOHptMCAyODRIMzI4Yy00LjQgMC04IDMuNi04IDh2NTZjMCA0LjQgMy42IDggOCA4aDU4NGM0LjQgMCA4LTMuNiA4LTh2LTU2YzAtNC40LTMuNi04LTgtOHptMCAyODRIMzI4Yy00LjQgMC04IDMuNi04IDh2NTZjMCA0LjQgMy42IDggOCA4aDU4NGM0LjQgMCA4LTMuNiA4LTh2LTU2YzAtNC40LTMuNi04LTgtOHpNMTA0IDIyOGE1NiA1NiAwIDEwMTEyIDAgNTYgNTYgMCAxMC0xMTIgMHptMCAyODRhNTYgNTYgMCAxMDExMiAwIDU2IDU2IDAgMTAtMTEyIDB6bTAgMjg0YTU2IDU2IDAgMTAxMTIgMCA1NiA1NiAwIDEwLTExMiAweiIgLz48L3N2Zz4=) */ const $514e92571f9d096e$var$RefIcon = /*#__PURE__*/ $N3oW3.forwardRef($514e92571f9d096e$var$BarsOutlined);
var $514e92571f9d096e$export$2e2bcd8739ae039 = $514e92571f9d096e$var$RefIcon;







parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
const $6fe8986eac98f947$export$964282a2c3979546 = /*#__PURE__*/ $hO8yS.createContext({
    siderHook: {
        addSider: ()=>null,
        removeSider: ()=>null
    }
});





const $f4e499aab9d498c8$var$genLayoutStyle = (token)=>{
    const { antCls: antCls, componentCls: // .ant
    componentCls, colorText: // .ant-layout
    colorText, footerBg: footerBg, headerHeight: headerHeight, headerPadding: headerPadding, headerColor: headerColor, footerPadding: footerPadding, fontSize: fontSize, bodyBg: bodyBg, headerBg: headerBg } = token;
    return {
        [componentCls]: {
            display: 'flex',
            flex: 'auto',
            flexDirection: 'column',
            /* fix firefox can't set height smaller than content on flex item */ minHeight: 0,
            background: bodyBg,
            '&, *': {
                boxSizing: 'border-box'
            },
            [`&${componentCls}-has-sider`]: {
                flexDirection: 'row',
                [`> ${componentCls}, > ${componentCls}-content`]: {
                    // https://segmentfault.com/a/1190000019498300
                    width: 0
                }
            },
            [`${componentCls}-header, &${componentCls}-footer`]: {
                flex: '0 0 auto'
            },
            // RTL
            '&-rtl': {
                direction: 'rtl'
            }
        },
        // ==================== Header ====================
        [`${componentCls}-header`]: {
            height: headerHeight,
            padding: headerPadding,
            color: headerColor,
            lineHeight: (0, $763a5b4b58d0a3ff$export$523c0b569236b342)(headerHeight),
            background: headerBg,
            // Other components/menu/style/index.less line:686
            // Integration with header element so menu items have the same height
            [`${antCls}-menu`]: {
                lineHeight: 'inherit'
            }
        },
        // ==================== Footer ====================
        [`${componentCls}-footer`]: {
            padding: footerPadding,
            color: colorText,
            fontSize: fontSize,
            background: footerBg
        },
        // =================== Content ====================
        [`${componentCls}-content`]: {
            flex: 'auto',
            color: colorText,
            // fix firefox can't set height smaller than content on flex item
            minHeight: 0
        }
    };
};
const $f4e499aab9d498c8$export$9ca1be8807fe0675 = (token)=>{
    const { colorBgLayout: colorBgLayout, controlHeight: controlHeight, controlHeightLG: controlHeightLG, colorText: colorText, controlHeightSM: controlHeightSM, marginXXS: marginXXS, colorTextLightSolid: colorTextLightSolid, colorBgContainer: colorBgContainer } = token;
    const paddingInline = controlHeightLG * 1.25;
    return {
        // Deprecated
        colorBgHeader: '#001529',
        colorBgBody: colorBgLayout,
        colorBgTrigger: '#002140',
        bodyBg: colorBgLayout,
        headerBg: '#001529',
        headerHeight: controlHeight * 2,
        headerPadding: `0 ${paddingInline}px`,
        headerColor: colorText,
        footerPadding: `${controlHeightSM}px ${paddingInline}px`,
        footerBg: colorBgLayout,
        siderBg: '#001529',
        triggerHeight: controlHeightLG + marginXXS * 2,
        triggerBg: '#002140',
        triggerColor: colorTextLightSolid,
        zeroTriggerWidth: controlHeightLG,
        zeroTriggerHeight: controlHeightLG,
        lightSiderBg: colorBgContainer,
        lightTriggerBg: colorBgContainer,
        lightTriggerColor: colorText
    };
};
const $f4e499aab9d498c8$export$da0be9ab56e785fc = [
    [
        'colorBgBody',
        'bodyBg'
    ],
    [
        'colorBgHeader',
        'headerBg'
    ],
    [
        'colorBgTrigger',
        'triggerBg'
    ]
];
var $f4e499aab9d498c8$export$2e2bcd8739ae039 = (0, $d4a2dc313c4d90a4$export$51ec95de45185b42)('Layout', $f4e499aab9d498c8$var$genLayoutStyle, $f4e499aab9d498c8$export$9ca1be8807fe0675, {
    deprecatedTokens: $f4e499aab9d498c8$export$da0be9ab56e785fc
});



const $db0e8d9a412c11d7$var$genSiderStyle = (token)=>{
    const { componentCls: componentCls, siderBg: siderBg, motionDurationMid: motionDurationMid, motionDurationSlow: motionDurationSlow, antCls: antCls, triggerHeight: triggerHeight, triggerColor: triggerColor, triggerBg: triggerBg, headerHeight: headerHeight, zeroTriggerWidth: zeroTriggerWidth, zeroTriggerHeight: zeroTriggerHeight, borderRadiusLG: borderRadiusLG, lightSiderBg: lightSiderBg, lightTriggerColor: lightTriggerColor, lightTriggerBg: lightTriggerBg, bodyBg: bodyBg } = token;
    return {
        [componentCls]: {
            position: 'relative',
            // fix firefox can't set width smaller than content on flex item
            minWidth: 0,
            background: siderBg,
            transition: `all ${motionDurationMid}, background 0s`,
            '&-has-trigger': {
                paddingBottom: triggerHeight
            },
            '&-right': {
                order: 1
            },
            [`${componentCls}-children`]: {
                height: '100%',
                // Hack for fixing margin collapse bug
                // https://github.com/ant-design/ant-design/issues/7967
                // solution from https://stackoverflow.com/a/33132624/3040605
                marginTop: -0.1,
                paddingTop: 0.1,
                [`${antCls}-menu${antCls}-menu-inline-collapsed`]: {
                    width: 'auto'
                }
            },
            [`&-zero-width ${componentCls}-children`]: {
                overflow: 'hidden'
            },
            [`${componentCls}-trigger`]: {
                position: 'fixed',
                bottom: 0,
                zIndex: 1,
                height: triggerHeight,
                color: triggerColor,
                lineHeight: (0, $763a5b4b58d0a3ff$export$523c0b569236b342)(triggerHeight),
                textAlign: 'center',
                background: triggerBg,
                cursor: 'pointer',
                transition: `all ${motionDurationMid}`
            },
            [`${componentCls}-zero-width-trigger`]: {
                position: 'absolute',
                top: headerHeight,
                insetInlineEnd: token.calc(zeroTriggerWidth).mul(-1).equal(),
                zIndex: 1,
                width: zeroTriggerWidth,
                height: zeroTriggerHeight,
                color: triggerColor,
                fontSize: token.fontSizeXL,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: siderBg,
                borderRadius: `0 ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(borderRadiusLG)} ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(borderRadiusLG)} 0`,
                cursor: 'pointer',
                transition: `background ${motionDurationSlow} ease`,
                '&::after': {
                    position: 'absolute',
                    inset: 0,
                    background: 'transparent',
                    transition: `all ${motionDurationSlow}`,
                    content: '""'
                },
                '&:hover::after': {
                    background: `rgba(255, 255, 255, 0.2)`
                },
                '&-right': {
                    insetInlineStart: token.calc(zeroTriggerWidth).mul(-1).equal(),
                    borderRadius: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(borderRadiusLG)} 0 0 ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(borderRadiusLG)}`
                }
            },
            // Light
            '&-light': {
                background: lightSiderBg,
                [`${componentCls}-trigger`]: {
                    color: lightTriggerColor,
                    background: lightTriggerBg
                },
                [`${componentCls}-zero-width-trigger`]: {
                    color: lightTriggerColor,
                    background: lightTriggerBg,
                    border: `1px solid ${bodyBg}`,
                    // Safe to modify to any other color
                    borderInlineStart: 0
                }
            }
        }
    };
};
var $db0e8d9a412c11d7$export$2e2bcd8739ae039 = (0, $d4a2dc313c4d90a4$export$51ec95de45185b42)([
    'Layout',
    'Sider'
], $db0e8d9a412c11d7$var$genSiderStyle, (0, $f4e499aab9d498c8$export$9ca1be8807fe0675), {
    deprecatedTokens: (0, $f4e499aab9d498c8$export$da0be9ab56e785fc)
});


"use client";
const $6adf4c035f43d1a3$var$dimensionMaxMap = {
    xs: '479.98px',
    sm: '575.98px',
    md: '767.98px',
    lg: '991.98px',
    xl: '1199.98px',
    xxl: '1599.98px'
};
const $6adf4c035f43d1a3$var$isNumeric = (val)=>!Number.isNaN(Number.parseFloat(val)) && Number.isFinite(Number(val));
const $6adf4c035f43d1a3$export$63554aebd2a6d54c = /*#__PURE__*/ $hO8yS.createContext({});
const $6adf4c035f43d1a3$var$generateId = (()=>{
    let i = 0;
    return (prefix = '')=>{
        i += 1;
        return `${prefix}${i}`;
    };
})();
const $6adf4c035f43d1a3$var$Sider = /*#__PURE__*/ $N3oW3.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, className: className, trigger: trigger, children: children, defaultCollapsed: defaultCollapsed = false, theme: theme = 'dark', style: style = {}, collapsible: collapsible = false, reverseArrow: reverseArrow = false, width: width = 200, collapsedWidth: collapsedWidth = 80, zeroWidthTriggerStyle: zeroWidthTriggerStyle, breakpoint: breakpoint, onCollapse: onCollapse, onBreakpoint: onBreakpoint, ...otherProps } = props;
    const { siderHook: siderHook } = (0, $32rMB.useContext)((0, $6fe8986eac98f947$export$964282a2c3979546));
    const [collapsed, setCollapsed] = (0, $32rMB.useState)('collapsed' in props ? props.collapsed : defaultCollapsed);
    const [below, setBelow] = (0, $32rMB.useState)(false);
    (0, $32rMB.useEffect)(()=>{
        if ('collapsed' in props) setCollapsed(props.collapsed);
    }, [
        props.collapsed
    ]);
    const handleSetCollapsed = (value, type)=>{
        if (!('collapsed' in props)) setCollapsed(value);
        onCollapse?.(value, type);
    };
    // =========================== Prefix ===========================
    const { getPrefixCls: getPrefixCls, direction: direction } = (0, $32rMB.useContext)((0, $dd01e2f5a4b8605d$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('layout-sider', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $db0e8d9a412c11d7$export$2e2bcd8739ae039)(prefixCls);
    // ========================= Responsive =========================
    const responsiveHandlerRef = (0, $32rMB.useRef)(null);
    responsiveHandlerRef.current = (mql)=>{
        setBelow(mql.matches);
        onBreakpoint?.(mql.matches);
        if (collapsed !== mql.matches) handleSetCollapsed(mql.matches, 'responsive');
    };
    (0, $32rMB.useEffect)(()=>{
        function responsiveHandler(mql) {
            return responsiveHandlerRef.current?.(mql);
        }
        let mql;
        if (typeof window?.matchMedia !== 'undefined' && breakpoint && breakpoint in $6adf4c035f43d1a3$var$dimensionMaxMap) {
            mql = window.matchMedia(`screen and (max-width: ${$6adf4c035f43d1a3$var$dimensionMaxMap[breakpoint]})`);
            if (typeof mql?.addEventListener === 'function') mql.addEventListener('change', responsiveHandler);
            responsiveHandler(mql);
        }
        return ()=>{
            if (typeof mql?.removeEventListener === 'function') mql.removeEventListener('change', responsiveHandler);
        };
    }, [
        breakpoint
    ]); // in order to accept dynamic 'breakpoint' property, we need to add 'breakpoint' into dependency array.
    (0, $32rMB.useEffect)(()=>{
        const uniqueId = $6adf4c035f43d1a3$var$generateId('ant-sider-');
        siderHook.addSider(uniqueId);
        return ()=>siderHook.removeSider(uniqueId);
    }, []);
    const toggle = ()=>{
        handleSetCollapsed(!collapsed, 'clickTrigger');
    };
    const divProps = (0, $f4cf9c2e27c0ac8d$export$2e2bcd8739ae039)(otherProps, [
        'collapsed'
    ]);
    const rawWidth = collapsed ? collapsedWidth : width;
    // use "px" as fallback unit for width
    const siderWidth = $6adf4c035f43d1a3$var$isNumeric(rawWidth) ? `${rawWidth}px` : String(rawWidth);
    // special trigger when collapsedWidth == 0
    const zeroWidthTrigger = Number.parseFloat(String(collapsedWidth || 0)) === 0 ? /*#__PURE__*/ $hO8yS.createElement("span", {
        onClick: toggle,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-zero-width-trigger`, `${prefixCls}-zero-width-trigger-${reverseArrow ? 'right' : 'left'}`),
        style: zeroWidthTriggerStyle
    }, trigger || /*#__PURE__*/ $hO8yS.createElement((0, $514e92571f9d096e$export$2e2bcd8739ae039), null)) : null;
    const reverseIcon = direction === 'rtl' === !reverseArrow;
    const iconObj = {
        expanded: reverseIcon ? /*#__PURE__*/ $hO8yS.createElement((0, $c8c7be68bfada8d0$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $hO8yS.createElement((0, $e4b471ef5251dafb$export$2e2bcd8739ae039), null),
        collapsed: reverseIcon ? /*#__PURE__*/ $hO8yS.createElement((0, $e4b471ef5251dafb$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $hO8yS.createElement((0, $c8c7be68bfada8d0$export$2e2bcd8739ae039), null)
    };
    const status = collapsed ? 'collapsed' : 'expanded';
    const defaultTrigger = iconObj[status];
    const triggerDom = trigger !== null ? zeroWidthTrigger || /*#__PURE__*/ $hO8yS.createElement("div", {
        className: `${prefixCls}-trigger`,
        onClick: toggle,
        style: {
            width: siderWidth
        }
    }, trigger || defaultTrigger) : null;
    const divStyle = {
        ...style,
        flex: `0 0 ${siderWidth}`,
        maxWidth: siderWidth,
        // Fix width transition bug in IE11
        minWidth: siderWidth,
        // https://github.com/ant-design/ant-design/issues/6349
        width: siderWidth
    };
    const siderCls = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-${theme}`, {
        [`${prefixCls}-collapsed`]: !!collapsed,
        [`${prefixCls}-has-trigger`]: collapsible && trigger !== null && !zeroWidthTrigger,
        [`${prefixCls}-below`]: !!below,
        [`${prefixCls}-zero-width`]: Number.parseFloat(siderWidth) === 0
    }, className, hashId, cssVarCls);
    const contextValue = $32rMB.useMemo(()=>({
            siderCollapsed: collapsed
        }), [
        collapsed
    ]);
    return /*#__PURE__*/ $hO8yS.createElement($6adf4c035f43d1a3$export$63554aebd2a6d54c.Provider, {
        value: contextValue
    }, /*#__PURE__*/ $hO8yS.createElement("aside", {
        className: siderCls,
        ...divProps,
        style: divStyle,
        ref: ref
    }, /*#__PURE__*/ $hO8yS.createElement("div", {
        className: `${prefixCls}-children`
    }, children), collapsible || below && zeroWidthTrigger ? triggerDom : null));
});
var $6adf4c035f43d1a3$export$2e2bcd8739ae039 = $6adf4c035f43d1a3$var$Sider;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
// This icon file is generated automatically.
var $03b41ad418549ee7$var$EllipsisOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M176 511a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0z"
                }
            }
        ]
    },
    "name": "ellipsis",
    "theme": "outlined"
};
var $03b41ad418549ee7$export$2e2bcd8739ae039 = $03b41ad418549ee7$var$EllipsisOutlined;



function $391e9221407e00e5$var$_extends() {
    $391e9221407e00e5$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $391e9221407e00e5$var$_extends.apply(this, arguments);
}
const $391e9221407e00e5$var$EllipsisOutlined = (props, ref)=>/*#__PURE__*/ $hO8yS.createElement((0, $5fd6f3f3c400c267$export$2e2bcd8739ae039), $391e9221407e00e5$var$_extends({}, props, {
        ref: ref,
        icon: (0, $03b41ad418549ee7$export$2e2bcd8739ae039)
    }));
/**![ellipsis](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTE3NiA1MTFhNTYgNTYgMCAxMDExMiAwIDU2IDU2IDAgMTAtMTEyIDB6bTI4MCAwYTU2IDU2IDAgMTAxMTIgMCA1NiA1NiAwIDEwLTExMiAwem0yODAgMGE1NiA1NiAwIDEwMTEyIDAgNTYgNTYgMCAxMC0xMTIgMHoiIC8+PC9zdmc+) */ const $391e9221407e00e5$var$RefIcon = /*#__PURE__*/ $N3oW3.forwardRef($391e9221407e00e5$var$EllipsisOutlined);
var $391e9221407e00e5$export$2e2bcd8739ae039 = $391e9221407e00e5$var$RefIcon;












parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
"use client";
const $2982543b03b9c07b$var$MenuContext = /*#__PURE__*/ (0, $hO8yS.createContext)({
    prefixCls: '',
    firstLevel: true,
    inlineCollapsed: false,
    styles: null,
    classNames: null
});
var $2982543b03b9c07b$export$2e2bcd8739ae039 = $2982543b03b9c07b$var$MenuContext;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");



"use client";
const $44349498ba1afec0$var$MenuDivider = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, dashed: dashed, ...restProps } = props;
    const { getPrefixCls: getPrefixCls } = $32rMB.useContext((0, $dd01e2f5a4b8605d$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('menu', customizePrefixCls);
    const classString = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)({
        [`${prefixCls}-item-divider-dashed`]: !!dashed
    }, className);
    return /*#__PURE__*/ $hO8yS.createElement((0, $4a86d0c1965ddd84$export$2e2bcd8739ae039), {
        className: classString,
        ...restProps
    });
};
var $44349498ba1afec0$export$2e2bcd8739ae039 = $44349498ba1afec0$var$MenuDivider;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");







"use client";
const $97f615c53f177678$var$MenuItem = (props)=>{
    const { className: className, children: children, icon: icon, title: title, danger: danger, extra: extra } = props;
    const { prefixCls: prefixCls, firstLevel: firstLevel, direction: direction, disableMenuItemTitleTooltip: disableMenuItemTitleTooltip, inlineCollapsed: isInlineCollapsed, styles: styles, classNames: classNames } = $32rMB.useContext((0, $2982543b03b9c07b$export$2e2bcd8739ae039));
    const renderItemChildren = (inlineCollapsed)=>{
        const label = children?.[0];
        const wrapNode = /*#__PURE__*/ $hO8yS.createElement("span", {
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-title-content`, firstLevel ? classNames.itemContent : classNames.subMenu.itemContent, {
                [`${prefixCls}-title-content-with-extra`]: !!extra || extra === 0
            }),
            style: firstLevel ? styles.itemContent : styles.subMenu.itemContent
        }, children);
        // inline-collapsed.md demo 依赖 span 来隐藏文字,有 icon 属性，则内部包裹一个 span
        // ref: https://github.com/ant-design/ant-design/pull/23456
        if (!icon || /*#__PURE__*/ $N3oW3.isValidElement(children) && children.type === 'span') {
            if (children && inlineCollapsed && firstLevel && typeof label === 'string') return /*#__PURE__*/ $hO8yS.createElement("div", {
                className: `${prefixCls}-inline-collapsed-noicon`
            }, label.charAt(0));
        }
        return wrapNode;
    };
    const { siderCollapsed: siderCollapsed } = $32rMB.useContext((0, $6adf4c035f43d1a3$export$63554aebd2a6d54c));
    let tooltipTitle = title;
    if (typeof title === 'undefined') tooltipTitle = firstLevel ? children : '';
    else if (title === false) tooltipTitle = '';
    const tooltipProps = {
        title: tooltipTitle
    };
    if (!siderCollapsed && !isInlineCollapsed) {
        tooltipProps.title = null;
        // Reset `open` to fix control mode tooltip display not correct
        // ref: https://github.com/ant-design/ant-design/issues/16742
        tooltipProps.open = false;
    }
    const childrenLength = (0, $a60ede783f74e6a9$export$2e2bcd8739ae039)(children).length;
    let returnNode = /*#__PURE__*/ $hO8yS.createElement((0, $c44576def6898817$export$2e2bcd8739ae039), {
        ...(0, $f4cf9c2e27c0ac8d$export$2e2bcd8739ae039)(props, [
            'title',
            'icon',
            'danger'
        ]),
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(firstLevel ? classNames.item : classNames.subMenu.item, {
            [`${prefixCls}-item-danger`]: danger,
            [`${prefixCls}-item-only-child`]: (icon ? childrenLength + 1 : childrenLength) === 1
        }, className),
        style: firstLevel ? styles.item : styles.subMenu.item,
        title: typeof title === 'string' ? title : undefined
    }, (0, $62609775897a768c$export$e530037191fcd5d7)(icon, (oriProps)=>({
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(oriProps.className, `${prefixCls}-item-icon`, firstLevel ? classNames.itemIcon : classNames.subMenu.itemIcon),
            style: {
                ...oriProps.style,
                ...firstLevel ? styles.itemIcon : styles.subMenu.itemIcon
            }
        })), renderItemChildren(isInlineCollapsed));
    if (!disableMenuItemTitleTooltip) returnNode = /*#__PURE__*/ $hO8yS.createElement((0, $bdb14b445459ab9d$export$2e2bcd8739ae039), {
        ...tooltipProps,
        placement: direction === 'rtl' ? 'left' : 'right',
        classNames: {
            root: `${prefixCls}-inline-collapsed-tooltip`
        }
    }, returnNode);
    return returnNode;
};
var $97f615c53f177678$export$2e2bcd8739ae039 = $97f615c53f177678$var$MenuItem;



var $N3oW3 = parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");


"use client";
const $4ecfd4dbf7968668$var$OverrideContext = /*#__PURE__*/ $hO8yS.createContext(null);
const $4ecfd4dbf7968668$export$9bd434816b0530d0 = /*#__PURE__*/ $N3oW3.forwardRef((props, ref)=>{
    const { children: children, ...restProps } = props;
    const override = $32rMB.useContext($4ecfd4dbf7968668$var$OverrideContext);
    const context = $32rMB.useMemo(()=>({
            ...override,
            ...restProps
        }), [
        override,
        restProps.prefixCls,
        // restProps.expandIcon, Not mark as deps since this is a ReactNode
        restProps.mode,
        restProps.selectable,
        restProps.rootClassName
    ]);
    const canRef = (0, $2706ed817e87019d$export$b51ae67c7882a242)(children);
    const mergedRef = (0, $2706ed817e87019d$export$1d1c999670a1285d)(ref, canRef ? (0, $2706ed817e87019d$export$7465e5c0bf44f19a)(children) : null);
    return /*#__PURE__*/ $hO8yS.createElement($4ecfd4dbf7968668$var$OverrideContext.Provider, {
        value: context
    }, /*#__PURE__*/ $hO8yS.createElement((0, $8a9bb3ef8b2b36aa$export$2e2bcd8739ae039), {
        space: true
    }, canRef ? /*#__PURE__*/ $N3oW3.cloneElement(children, {
        ref: mergedRef
    }) : children));
});
var /** @internal Only used for Dropdown component. Do not use this in your production. */ $4ecfd4dbf7968668$export$2e2bcd8739ae039 = $4ecfd4dbf7968668$var$OverrideContext;







const $21a6ccba58224685$export$e801b802b037de6a = new (0, $f806545df26bb0b4$export$2e2bcd8739ae039)('antSlideUpIn', {
    '0%': {
        transform: 'scaleY(0.8)',
        transformOrigin: '0% 0%',
        opacity: 0
    },
    '100%': {
        transform: 'scaleY(1)',
        transformOrigin: '0% 0%',
        opacity: 1
    }
});
const $21a6ccba58224685$export$f40f41df328ebc38 = new (0, $f806545df26bb0b4$export$2e2bcd8739ae039)('antSlideUpOut', {
    '0%': {
        transform: 'scaleY(1)',
        transformOrigin: '0% 0%',
        opacity: 1
    },
    '100%': {
        transform: 'scaleY(0.8)',
        transformOrigin: '0% 0%',
        opacity: 0
    }
});
const $21a6ccba58224685$export$dd9f089fa5e819fe = new (0, $f806545df26bb0b4$export$2e2bcd8739ae039)('antSlideDownIn', {
    '0%': {
        transform: 'scaleY(0.8)',
        transformOrigin: '100% 100%',
        opacity: 0
    },
    '100%': {
        transform: 'scaleY(1)',
        transformOrigin: '100% 100%',
        opacity: 1
    }
});
const $21a6ccba58224685$export$f7243fdb9c27c3b7 = new (0, $f806545df26bb0b4$export$2e2bcd8739ae039)('antSlideDownOut', {
    '0%': {
        transform: 'scaleY(1)',
        transformOrigin: '100% 100%',
        opacity: 1
    },
    '100%': {
        transform: 'scaleY(0.8)',
        transformOrigin: '100% 100%',
        opacity: 0
    }
});
const $21a6ccba58224685$export$2ad3a07c3513a54 = new (0, $f806545df26bb0b4$export$2e2bcd8739ae039)('antSlideLeftIn', {
    '0%': {
        transform: 'scaleX(0.8)',
        transformOrigin: '0% 0%',
        opacity: 0
    },
    '100%': {
        transform: 'scaleX(1)',
        transformOrigin: '0% 0%',
        opacity: 1
    }
});
const $21a6ccba58224685$export$486fbda27512d5a9 = new (0, $f806545df26bb0b4$export$2e2bcd8739ae039)('antSlideLeftOut', {
    '0%': {
        transform: 'scaleX(1)',
        transformOrigin: '0% 0%',
        opacity: 1
    },
    '100%': {
        transform: 'scaleX(0.8)',
        transformOrigin: '0% 0%',
        opacity: 0
    }
});
const $21a6ccba58224685$export$dd03ad46dbbcd7e0 = new (0, $f806545df26bb0b4$export$2e2bcd8739ae039)('antSlideRightIn', {
    '0%': {
        transform: 'scaleX(0.8)',
        transformOrigin: '100% 0%',
        opacity: 0
    },
    '100%': {
        transform: 'scaleX(1)',
        transformOrigin: '100% 0%',
        opacity: 1
    }
});
const $21a6ccba58224685$export$db8e3c9b93664f34 = new (0, $f806545df26bb0b4$export$2e2bcd8739ae039)('antSlideRightOut', {
    '0%': {
        transform: 'scaleX(1)',
        transformOrigin: '100% 0%',
        opacity: 1
    },
    '100%': {
        transform: 'scaleX(0.8)',
        transformOrigin: '100% 0%',
        opacity: 0
    }
});
const $21a6ccba58224685$var$slideMotion = {
    'slide-up': {
        inKeyframes: $21a6ccba58224685$export$e801b802b037de6a,
        outKeyframes: $21a6ccba58224685$export$f40f41df328ebc38
    },
    'slide-down': {
        inKeyframes: $21a6ccba58224685$export$dd9f089fa5e819fe,
        outKeyframes: $21a6ccba58224685$export$f7243fdb9c27c3b7
    },
    'slide-left': {
        inKeyframes: $21a6ccba58224685$export$2ad3a07c3513a54,
        outKeyframes: $21a6ccba58224685$export$486fbda27512d5a9
    },
    'slide-right': {
        inKeyframes: $21a6ccba58224685$export$dd03ad46dbbcd7e0,
        outKeyframes: $21a6ccba58224685$export$db8e3c9b93664f34
    }
};
const $21a6ccba58224685$export$9018e60daecf7a6c = (token, motionName)=>{
    const { antCls: antCls } = token;
    const motionCls = `${antCls}-${motionName}`;
    const { inKeyframes: inKeyframes, outKeyframes: outKeyframes } = $21a6ccba58224685$var$slideMotion[motionName];
    return [
        (0, $811fac7c59e65981$export$83e1da9e09ec9112)(motionCls, inKeyframes, outKeyframes, token.motionDurationMid),
        {
            [`
      ${motionCls}-enter,
      ${motionCls}-appear
    `]: {
                transform: 'scale(0)',
                transformOrigin: '0% 0%',
                opacity: 0,
                animationTimingFunction: token.motionEaseOutQuint,
                '&-prepare': {
                    transform: 'scale(1)'
                }
            },
            [`${motionCls}-leave`]: {
                animationTimingFunction: token.motionEaseInQuint
            }
        }
    ];
};




const $b8c258658c545fd9$var$getHorizontalStyle = (token)=>{
    const { componentCls: componentCls, motionDurationSlow: motionDurationSlow, horizontalLineHeight: horizontalLineHeight, colorSplit: colorSplit, lineWidth: lineWidth, lineType: lineType, itemPaddingInline: itemPaddingInline } = token;
    return {
        [`${componentCls}-horizontal`]: {
            lineHeight: horizontalLineHeight,
            border: 0,
            borderBottom: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(lineWidth)} ${lineType} ${colorSplit}`,
            boxShadow: 'none',
            '&::after': {
                display: 'block',
                clear: 'both',
                height: 0,
                content: '"\\20"'
            },
            // ======================= Item =======================
            [`${componentCls}-item, ${componentCls}-submenu`]: {
                position: 'relative',
                display: 'inline-block',
                verticalAlign: 'bottom',
                paddingInline: itemPaddingInline
            },
            [`> ${componentCls}-item:hover,
        > ${componentCls}-item-active,
        > ${componentCls}-submenu ${componentCls}-submenu-title:hover`]: {
                backgroundColor: 'transparent'
            },
            [`${componentCls}-item, ${componentCls}-submenu-title`]: {
                transition: [
                    `border-color ${motionDurationSlow}`,
                    `background ${motionDurationSlow}`
                ].join(',')
            },
            // ===================== Sub Menu =====================
            [`${componentCls}-submenu-arrow`]: {
                display: 'none'
            }
        }
    };
};
var $b8c258658c545fd9$export$2e2bcd8739ae039 = $b8c258658c545fd9$var$getHorizontalStyle;



const $73d96478051ecc0b$var$getRTLStyle = ({ componentCls: componentCls, menuArrowOffset: menuArrowOffset, calc: calc })=>({
        [`${componentCls}-rtl`]: {
            direction: 'rtl'
        },
        [`${componentCls}-submenu-rtl`]: {
            transformOrigin: '100% 0'
        },
        // Vertical Arrow
        [`${componentCls}-rtl${componentCls}-vertical,
    ${componentCls}-submenu-rtl ${componentCls}-vertical`]: {
            [`${componentCls}-submenu-arrow`]: {
                '&::before': {
                    transform: `rotate(-45deg) translateY(${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(calc(menuArrowOffset).mul(-1).equal())})`
                },
                '&::after': {
                    transform: `rotate(45deg) translateY(${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(menuArrowOffset)})`
                }
            }
        }
    });
var $73d96478051ecc0b$export$2e2bcd8739ae039 = $73d96478051ecc0b$var$getRTLStyle;




const $28b90343102b9e0d$var$accessibilityFocus = (token)=>(0, $2f353af2b0f7600b$export$6539948f0a737e39)(token);
const $28b90343102b9e0d$var$getThemeStyle = (token, themeSuffix)=>{
    const { componentCls: componentCls, itemColor: itemColor, itemSelectedColor: itemSelectedColor, subMenuItemSelectedColor: subMenuItemSelectedColor, groupTitleColor: groupTitleColor, itemBg: itemBg, subMenuItemBg: subMenuItemBg, itemSelectedBg: itemSelectedBg, activeBarHeight: activeBarHeight, activeBarWidth: activeBarWidth, activeBarBorderWidth: activeBarBorderWidth, motionDurationSlow: motionDurationSlow, motionEaseInOut: motionEaseInOut, motionEaseOut: motionEaseOut, itemPaddingInline: itemPaddingInline, motionDurationMid: motionDurationMid, itemHoverColor: itemHoverColor, lineType: lineType, colorSplit: colorSplit, itemDisabledColor: // Disabled
    itemDisabledColor, dangerItemColor: // Danger
    dangerItemColor, dangerItemHoverColor: dangerItemHoverColor, dangerItemSelectedColor: dangerItemSelectedColor, dangerItemActiveBg: dangerItemActiveBg, dangerItemSelectedBg: dangerItemSelectedBg, popupBg: // Bg
    popupBg, itemHoverBg: itemHoverBg, itemActiveBg: itemActiveBg, menuSubMenuBg: menuSubMenuBg, horizontalItemSelectedColor: // Horizontal
    horizontalItemSelectedColor, horizontalItemSelectedBg: horizontalItemSelectedBg, horizontalItemBorderRadius: horizontalItemBorderRadius, horizontalItemHoverBg: horizontalItemHoverBg } = token;
    return {
        [`${componentCls}-${themeSuffix}, ${componentCls}-${themeSuffix} > ${componentCls}`]: {
            color: itemColor,
            background: itemBg,
            [`&${componentCls}-root:focus-visible`]: {
                ...$28b90343102b9e0d$var$accessibilityFocus(token)
            },
            // ======================== Item ========================
            [`${componentCls}-item`]: {
                '&-group-title, &-extra': {
                    color: groupTitleColor
                }
            },
            [`${componentCls}-submenu-selected > ${componentCls}-submenu-title`]: {
                color: subMenuItemSelectedColor
            },
            [`${componentCls}-item, ${componentCls}-submenu-title`]: {
                color: itemColor,
                [`&:not(${componentCls}-item-disabled):focus-visible`]: {
                    ...$28b90343102b9e0d$var$accessibilityFocus(token)
                }
            },
            // Disabled
            [`${componentCls}-item-disabled, ${componentCls}-submenu-disabled`]: {
                color: `${itemDisabledColor} !important`
            },
            // Hover
            [`${componentCls}-item:not(${componentCls}-item-selected):not(${componentCls}-submenu-selected)`]: {
                [`&:hover, > ${componentCls}-submenu-title:hover`]: {
                    color: itemHoverColor
                }
            },
            [`&:not(${componentCls}-horizontal)`]: {
                [`${componentCls}-item:not(${componentCls}-item-selected)`]: {
                    '&:hover': {
                        backgroundColor: itemHoverBg
                    },
                    '&:active': {
                        backgroundColor: itemActiveBg
                    }
                },
                [`${componentCls}-submenu-title`]: {
                    '&:hover': {
                        backgroundColor: itemHoverBg
                    },
                    '&:active': {
                        backgroundColor: itemActiveBg
                    }
                }
            },
            // Danger - only Item has
            [`${componentCls}-item-danger`]: {
                color: dangerItemColor,
                [`&${componentCls}-item:hover`]: {
                    [`&:not(${componentCls}-item-selected):not(${componentCls}-submenu-selected)`]: {
                        color: dangerItemHoverColor
                    }
                },
                [`&${componentCls}-item:active`]: {
                    background: dangerItemActiveBg
                }
            },
            [`${componentCls}-item a`]: {
                '&, &:hover': {
                    color: 'inherit'
                }
            },
            [`${componentCls}-item-selected`]: {
                color: itemSelectedColor,
                // Danger
                [`&${componentCls}-item-danger`]: {
                    color: dangerItemSelectedColor
                },
                'a, a:hover': {
                    color: 'inherit'
                }
            },
            [`& ${componentCls}-item-selected`]: {
                backgroundColor: itemSelectedBg,
                // Danger
                [`&${componentCls}-item-danger`]: {
                    backgroundColor: dangerItemSelectedBg
                }
            },
            [`&${componentCls}-submenu > ${componentCls}`]: {
                backgroundColor: menuSubMenuBg
            },
            // ===== 设置浮层的颜色 =======
            // ！dark 模式会被popupBg 会被rest 为 darkPopupBg
            [`&${componentCls}-popup > ${componentCls}`]: {
                backgroundColor: popupBg
            },
            [`&${componentCls}-submenu-popup > ${componentCls}`]: {
                backgroundColor: popupBg
            },
            // ===== 设置浮层的颜色 end =======
            // ====================== Horizontal ======================
            [`&${componentCls}-horizontal`]: {
                ...themeSuffix === 'dark' ? {
                    borderBottom: 0
                } : {},
                [`> ${componentCls}-item, > ${componentCls}-submenu`]: {
                    top: activeBarBorderWidth,
                    marginTop: token.calc(activeBarBorderWidth).mul(-1).equal(),
                    marginBottom: 0,
                    borderRadius: horizontalItemBorderRadius,
                    '&::after': {
                        position: 'absolute',
                        insetInline: itemPaddingInline,
                        bottom: 0,
                        borderBottom: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(activeBarHeight)} solid transparent`,
                        transition: `border-color ${motionDurationSlow} ${motionEaseInOut}`,
                        content: '""'
                    },
                    '&:hover, &-active, &-open': {
                        background: horizontalItemHoverBg,
                        '&::after': {
                            borderBottomWidth: activeBarHeight,
                            borderBottomColor: horizontalItemSelectedColor
                        }
                    },
                    '&-selected': {
                        color: horizontalItemSelectedColor,
                        backgroundColor: horizontalItemSelectedBg,
                        '&:hover': {
                            backgroundColor: horizontalItemSelectedBg
                        },
                        '&::after': {
                            borderBottomWidth: activeBarHeight,
                            borderBottomColor: horizontalItemSelectedColor
                        }
                    }
                }
            },
            // ================== Inline & Vertical ===================
            //
            [`&${componentCls}-root`]: {
                [`&${componentCls}-inline, &${componentCls}-vertical`]: {
                    borderInlineEnd: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(activeBarBorderWidth)} ${lineType} ${colorSplit}`
                }
            },
            // ======================== Inline ========================
            [`&${componentCls}-inline`]: {
                // Sub
                [`${componentCls}-sub${componentCls}-inline`]: {
                    background: subMenuItemBg
                },
                [`${componentCls}-item`]: {
                    position: 'relative',
                    '&::after': {
                        position: 'absolute',
                        insetBlock: 0,
                        insetInlineEnd: 0,
                        borderInlineEnd: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(activeBarWidth)} solid ${itemSelectedColor}`,
                        transform: 'scaleY(0.0001)',
                        opacity: 0,
                        transition: [
                            `transform ${motionDurationMid} ${motionEaseOut}`,
                            `opacity ${motionDurationMid} ${motionEaseOut}`
                        ].join(','),
                        content: '""'
                    },
                    // Danger
                    [`&${componentCls}-item-danger`]: {
                        '&::after': {
                            borderInlineEndColor: dangerItemSelectedColor
                        }
                    }
                },
                [`${componentCls}-selected, ${componentCls}-item-selected`]: {
                    '&::after': {
                        transform: 'scaleY(1)',
                        opacity: 1,
                        transition: [
                            `transform ${motionDurationMid} ${motionEaseInOut}`,
                            `opacity ${motionDurationMid} ${motionEaseInOut}`
                        ].join(',')
                    }
                }
            }
        }
    };
};
var $28b90343102b9e0d$export$2e2bcd8739ae039 = $28b90343102b9e0d$var$getThemeStyle;




const $5161ebff0b656542$var$getVerticalInlineStyle = (token)=>{
    const { componentCls: componentCls, itemHeight: itemHeight, itemMarginInline: itemMarginInline, padding: padding, menuArrowSize: menuArrowSize, marginXS: marginXS, itemMarginBlock: itemMarginBlock, itemWidth: itemWidth, itemPaddingInline: itemPaddingInline } = token;
    const paddingWithArrow = token.calc(menuArrowSize).add(padding).add(marginXS).equal();
    return {
        [`${componentCls}-item`]: {
            position: 'relative',
            overflow: 'hidden'
        },
        [`${componentCls}-item, ${componentCls}-submenu-title`]: {
            height: itemHeight,
            lineHeight: (0, $763a5b4b58d0a3ff$export$523c0b569236b342)(itemHeight),
            paddingInline: itemPaddingInline,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            marginInline: itemMarginInline,
            marginBlock: itemMarginBlock,
            width: itemWidth
        },
        [`> ${componentCls}-item,
            > ${componentCls}-submenu > ${componentCls}-submenu-title`]: {
            height: itemHeight,
            lineHeight: (0, $763a5b4b58d0a3ff$export$523c0b569236b342)(itemHeight)
        },
        [`${componentCls}-item-group-list ${componentCls}-submenu-title,
            ${componentCls}-submenu-title`]: {
            paddingInlineEnd: paddingWithArrow
        }
    };
};
const $5161ebff0b656542$var$getVerticalStyle = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, itemHeight: itemHeight, colorTextLightSolid: colorTextLightSolid, dropdownWidth: dropdownWidth, controlHeightLG: controlHeightLG, motionEaseOut: motionEaseOut, paddingXL: paddingXL, itemMarginInline: itemMarginInline, fontSizeLG: fontSizeLG, motionDurationFast: motionDurationFast, motionDurationSlow: motionDurationSlow, paddingXS: paddingXS, boxShadowSecondary: boxShadowSecondary, collapsedWidth: collapsedWidth, collapsedIconSize: collapsedIconSize } = token;
    const inlineItemStyle = {
        height: itemHeight,
        lineHeight: (0, $763a5b4b58d0a3ff$export$523c0b569236b342)(itemHeight),
        listStylePosition: 'inside',
        listStyleType: 'disc'
    };
    return [
        {
            [componentCls]: {
                '&-inline, &-vertical': {
                    [`&${componentCls}-root`]: {
                        boxShadow: 'none'
                    },
                    ...$5161ebff0b656542$var$getVerticalInlineStyle(token)
                }
            },
            [`${componentCls}-submenu-popup`]: {
                [`${componentCls}-vertical`]: {
                    ...$5161ebff0b656542$var$getVerticalInlineStyle(token),
                    boxShadow: boxShadowSecondary
                }
            }
        },
        // Vertical only
        {
            [`${componentCls}-submenu-popup ${componentCls}-vertical${componentCls}-sub`]: {
                minWidth: dropdownWidth,
                maxHeight: `calc(100vh - ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.calc(controlHeightLG).mul(2.5).equal())})`,
                padding: '0',
                overflow: 'hidden',
                borderInlineEnd: 0,
                // https://github.com/ant-design/ant-design/issues/22244
                // https://github.com/ant-design/ant-design/issues/26812
                "&:not([class*='-active'])": {
                    overflowX: 'hidden',
                    overflowY: 'auto'
                }
            }
        },
        // Inline Only
        {
            [`${componentCls}-inline`]: {
                width: '100%',
                // Motion enhance for first level
                [`&${componentCls}-root`]: {
                    [`${componentCls}-item, ${componentCls}-submenu-title`]: {
                        display: 'flex',
                        alignItems: 'center',
                        transition: [
                            `border-color ${motionDurationSlow}`,
                            `background ${motionDurationSlow}`,
                            `padding ${motionDurationFast} ${motionEaseOut}`
                        ].join(','),
                        [`> ${componentCls}-title-content`]: {
                            flex: 'auto',
                            minWidth: 0,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        },
                        '> *': {
                            flex: 'none'
                        }
                    }
                },
                // >>>>> Sub
                [`${componentCls}-sub${componentCls}-inline`]: {
                    padding: 0,
                    border: 0,
                    borderRadius: 0,
                    boxShadow: 'none',
                    [`& > ${componentCls}-submenu > ${componentCls}-submenu-title`]: inlineItemStyle,
                    [`& ${componentCls}-item-group-title`]: {
                        paddingInlineStart: paddingXL
                    }
                },
                // >>>>> Item
                [`${componentCls}-item`]: inlineItemStyle
            }
        },
        // Inline Collapse Only
        {
            [`${componentCls}-inline-collapsed`]: {
                width: collapsedWidth,
                [`&${componentCls}-root`]: {
                    [`${componentCls}-item, ${componentCls}-submenu ${componentCls}-submenu-title`]: {
                        [`> ${componentCls}-inline-collapsed-noicon`]: {
                            fontSize: fontSizeLG,
                            textAlign: 'center'
                        }
                    }
                },
                [`> ${componentCls}-item,
          > ${componentCls}-item-group > ${componentCls}-item-group-list > ${componentCls}-item,
          > ${componentCls}-item-group > ${componentCls}-item-group-list > ${componentCls}-submenu > ${componentCls}-submenu-title,
          > ${componentCls}-submenu > ${componentCls}-submenu-title`]: {
                    insetInlineStart: 0,
                    paddingInline: `calc(50% - ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.calc(collapsedIconSize).div(2).equal())} - ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(itemMarginInline)})`,
                    textOverflow: 'clip',
                    [`
            ${componentCls}-submenu-arrow,
            ${componentCls}-submenu-expand-icon
          `]: {
                        opacity: 0
                    },
                    [`${componentCls}-item-icon, ${iconCls}`]: {
                        margin: 0,
                        fontSize: collapsedIconSize,
                        lineHeight: (0, $763a5b4b58d0a3ff$export$523c0b569236b342)(itemHeight),
                        '+ span': {
                            display: 'inline-block',
                            opacity: 0
                        }
                    }
                },
                [`${componentCls}-item-icon, ${iconCls}`]: {
                    display: 'inline-block'
                },
                '&-tooltip': {
                    pointerEvents: 'none',
                    [`${componentCls}-item-icon, ${iconCls}`]: {
                        display: 'none'
                    },
                    'a, a:hover': {
                        color: colorTextLightSolid
                    }
                },
                [`${componentCls}-item-group-title`]: {
                    ...(0, $2f353af2b0f7600b$export$b2b65df0d0824629),
                    paddingInline: paddingXS
                }
            }
        }
    ];
};
var $5161ebff0b656542$export$2e2bcd8739ae039 = $5161ebff0b656542$var$getVerticalStyle;


const $eb5228b20f8c2097$var$genMenuItemStyle = (token)=>{
    const { componentCls: componentCls, motionDurationSlow: motionDurationSlow, motionDurationMid: motionDurationMid, motionEaseInOut: motionEaseInOut, motionEaseOut: motionEaseOut, iconCls: iconCls, iconSize: iconSize, iconMarginInlineEnd: iconMarginInlineEnd } = token;
    return {
        // >>>>> Item
        [`${componentCls}-item, ${componentCls}-submenu-title`]: {
            position: 'relative',
            display: 'block',
            margin: 0,
            whiteSpace: 'nowrap',
            cursor: 'pointer',
            transition: [
                `border-color ${motionDurationSlow}`,
                `background ${motionDurationSlow}`,
                `padding calc(${motionDurationSlow} + 0.1s) ${motionEaseInOut}`
            ].join(','),
            [`${componentCls}-item-icon, ${iconCls}`]: {
                minWidth: iconSize,
                fontSize: iconSize,
                transition: [
                    `font-size ${motionDurationMid} ${motionEaseOut}`,
                    `margin ${motionDurationSlow} ${motionEaseInOut}`,
                    `color ${motionDurationSlow}`
                ].join(','),
                '+ span': {
                    marginInlineStart: iconMarginInlineEnd,
                    opacity: 1,
                    transition: [
                        `opacity ${motionDurationSlow} ${motionEaseInOut}`,
                        `margin ${motionDurationSlow}`,
                        `color ${motionDurationSlow}`
                    ].join(',')
                }
            },
            [`${componentCls}-item-icon`]: {
                ...(0, $2f353af2b0f7600b$export$171ccda7bc085e59)()
            },
            [`&${componentCls}-item-only-child`]: {
                [`> ${iconCls}, > ${componentCls}-item-icon`]: {
                    marginInlineEnd: 0
                }
            }
        },
        // Disabled state sets text to gray and nukes hover/tab effects
        [`${componentCls}-item-disabled, ${componentCls}-submenu-disabled`]: {
            background: 'none !important',
            cursor: 'not-allowed',
            '&::after': {
                borderColor: 'transparent !important'
            },
            a: {
                color: 'inherit !important',
                cursor: 'not-allowed',
                pointerEvents: 'none'
            },
            [`> ${componentCls}-submenu-title`]: {
                color: 'inherit !important',
                cursor: 'not-allowed'
            }
        }
    };
};
const $eb5228b20f8c2097$var$genSubMenuArrowStyle = (token)=>{
    const { componentCls: componentCls, motionDurationSlow: motionDurationSlow, motionEaseInOut: motionEaseInOut, borderRadius: borderRadius, menuArrowSize: menuArrowSize, menuArrowOffset: menuArrowOffset } = token;
    return {
        [`${componentCls}-submenu`]: {
            '&-expand-icon, &-arrow': {
                position: 'absolute',
                top: '50%',
                insetInlineEnd: token.margin,
                width: menuArrowSize,
                color: 'currentcolor',
                transform: 'translateY(-50%)',
                transition: `transform ${motionDurationSlow} ${motionEaseInOut}, opacity ${motionDurationSlow}`
            },
            '&-arrow': {
                // →
                '&::before, &::after': {
                    position: 'absolute',
                    width: token.calc(menuArrowSize).mul(0.6).equal(),
                    height: token.calc(menuArrowSize).mul(0.15).equal(),
                    backgroundColor: 'currentcolor',
                    borderRadius: borderRadius,
                    transition: [
                        `background ${motionDurationSlow} ${motionEaseInOut}`,
                        `transform ${motionDurationSlow} ${motionEaseInOut}`,
                        `top ${motionDurationSlow} ${motionEaseInOut}`,
                        `color ${motionDurationSlow} ${motionEaseInOut}`
                    ].join(','),
                    content: '""'
                },
                '&::before': {
                    transform: `rotate(45deg) translateY(${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.calc(menuArrowOffset).mul(-1).equal())})`
                },
                '&::after': {
                    transform: `rotate(-45deg) translateY(${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(menuArrowOffset)})`
                }
            }
        }
    };
};
// =============================== Base ===============================
const $eb5228b20f8c2097$var$getBaseStyle = (token)=>{
    const { antCls: antCls, componentCls: componentCls, fontSize: fontSize, motionDurationSlow: motionDurationSlow, motionDurationMid: motionDurationMid, motionEaseInOut: motionEaseInOut, paddingXS: paddingXS, padding: padding, colorSplit: colorSplit, lineWidth: lineWidth, zIndexPopup: zIndexPopup, borderRadiusLG: borderRadiusLG, subMenuItemBorderRadius: subMenuItemBorderRadius, menuArrowSize: menuArrowSize, menuArrowOffset: menuArrowOffset, lineType: lineType, groupTitleLineHeight: groupTitleLineHeight, groupTitleFontSize: groupTitleFontSize } = token;
    return [
        // Misc
        {
            '': {
                [componentCls]: {
                    ...(0, $2f353af2b0f7600b$export$8c467e8859fdef13)(),
                    // Hidden
                    '&-hidden': {
                        display: 'none'
                    }
                }
            },
            [`${componentCls}-submenu-hidden`]: {
                display: 'none'
            }
        },
        {
            [componentCls]: {
                ...(0, $2f353af2b0f7600b$export$23997c3e44cc1c59)(token),
                ...(0, $2f353af2b0f7600b$export$8c467e8859fdef13)(),
                marginBottom: 0,
                paddingInlineStart: 0,
                fontSize: // Override default ul/ol
                fontSize,
                lineHeight: 0,
                // Fix display inline-block gap
                listStyle: 'none',
                outline: 'none',
                // Magic cubic here but smooth transition
                transition: `width ${motionDurationSlow} cubic-bezier(0.2, 0, 0, 1) 0s`,
                'ul, ol': {
                    margin: 0,
                    padding: 0,
                    listStyle: 'none'
                },
                // Overflow ellipsis
                '&-overflow': {
                    display: 'flex',
                    [`${componentCls}-item`]: {
                        flex: 'none'
                    }
                },
                [`${componentCls}-item, ${componentCls}-submenu, ${componentCls}-submenu-title`]: {
                    borderRadius: token.itemBorderRadius
                },
                [`${componentCls}-item-group-title`]: {
                    padding: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(paddingXS)} ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(padding)}`,
                    fontSize: groupTitleFontSize,
                    lineHeight: groupTitleLineHeight,
                    transition: `all ${motionDurationSlow}`
                },
                [`&-horizontal ${componentCls}-submenu`]: {
                    transition: [
                        `border-color ${motionDurationSlow} ${motionEaseInOut}`,
                        `background ${motionDurationSlow} ${motionEaseInOut}`
                    ].join(',')
                },
                [`${componentCls}-submenu, ${componentCls}-submenu-inline`]: {
                    transition: [
                        `border-color ${motionDurationSlow} ${motionEaseInOut}`,
                        `background ${motionDurationSlow} ${motionEaseInOut}`,
                        `padding ${motionDurationMid} ${motionEaseInOut}`
                    ].join(',')
                },
                [`${componentCls}-submenu ${componentCls}-sub`]: {
                    cursor: 'initial',
                    transition: [
                        `background ${motionDurationSlow} ${motionEaseInOut}`,
                        `padding ${motionDurationSlow} ${motionEaseInOut}`
                    ].join(',')
                },
                [`${componentCls}-title-content`]: {
                    transition: `color ${motionDurationSlow}`,
                    '&-with-extra': {
                        display: 'inline-flex',
                        alignItems: 'center',
                        width: '100%'
                    },
                    // https://github.com/ant-design/ant-design/issues/41143
                    [`> ${antCls}-typography-ellipsis-single-line`]: {
                        display: 'inline',
                        verticalAlign: 'unset'
                    },
                    [`${componentCls}-item-extra`]: {
                        marginInlineStart: 'auto',
                        paddingInlineStart: token.padding
                    }
                },
                [`${componentCls}-item a`]: {
                    '&::before': {
                        position: 'absolute',
                        inset: 0,
                        backgroundColor: 'transparent',
                        content: '""'
                    }
                },
                // Removed a Badge related style seems it's safe
                // https://github.com/ant-design/ant-design/issues/19809
                // >>>>> Divider
                [`${componentCls}-item-divider`]: {
                    overflow: 'hidden',
                    lineHeight: 0,
                    borderColor: colorSplit,
                    borderStyle: lineType,
                    borderWidth: 0,
                    borderTopWidth: lineWidth,
                    marginBlock: lineWidth,
                    padding: 0,
                    '&-dashed': {
                        borderStyle: 'dashed'
                    }
                },
                // Item
                ...$eb5228b20f8c2097$var$genMenuItemStyle(token),
                [`${componentCls}-item-group`]: {
                    [`${componentCls}-item-group-list`]: {
                        margin: 0,
                        padding: 0,
                        [`${componentCls}-item, ${componentCls}-submenu-title`]: {
                            paddingInline: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.calc(fontSize).mul(2).equal())} ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(padding)}`
                        }
                    }
                },
                // ======================= Sub Menu =======================
                '&-submenu': {
                    '&-popup': {
                        position: 'absolute',
                        zIndex: zIndexPopup,
                        borderRadius: borderRadiusLG,
                        boxShadow: 'none',
                        transformOrigin: '0 0',
                        [`&${componentCls}-submenu`]: {
                            background: 'transparent'
                        },
                        // https://github.com/ant-design/ant-design/issues/13955
                        '&::before': {
                            position: 'absolute',
                            inset: 0,
                            zIndex: -1,
                            width: '100%',
                            height: '100%',
                            opacity: 0,
                            content: '""'
                        },
                        [`> ${componentCls}`]: {
                            borderRadius: borderRadiusLG,
                            ...$eb5228b20f8c2097$var$genMenuItemStyle(token),
                            ...$eb5228b20f8c2097$var$genSubMenuArrowStyle(token),
                            [`${componentCls}-item, ${componentCls}-submenu > ${componentCls}-submenu-title`]: {
                                borderRadius: subMenuItemBorderRadius
                            },
                            [`${componentCls}-submenu-title::after`]: {
                                transition: `transform ${motionDurationSlow} ${motionEaseInOut}`
                            }
                        }
                    },
                    [`
          &-placement-leftTop,
          &-placement-bottomRight,
          `]: {
                        transformOrigin: '100% 0'
                    },
                    [`
          &-placement-leftBottom,
          &-placement-topRight,
          `]: {
                        transformOrigin: '100% 100%'
                    },
                    [`
          &-placement-rightBottom,
          &-placement-topLeft,
          `]: {
                        transformOrigin: '0 100%'
                    },
                    [`
          &-placement-bottomLeft,
          &-placement-rightTop,
          `]: {
                        transformOrigin: '0 0'
                    },
                    [`
          &-placement-leftTop,
          &-placement-leftBottom
          `]: {
                        paddingInlineEnd: token.paddingXS
                    },
                    [`
          &-placement-rightTop,
          &-placement-rightBottom
          `]: {
                        paddingInlineStart: token.paddingXS
                    },
                    [`
          &-placement-topRight,
          &-placement-topLeft
          `]: {
                        paddingBottom: token.paddingXS
                    },
                    [`
          &-placement-bottomRight,
          &-placement-bottomLeft
          `]: {
                        paddingTop: token.paddingXS
                    }
                },
                ...$eb5228b20f8c2097$var$genSubMenuArrowStyle(token),
                [`&-inline-collapsed ${componentCls}-submenu-arrow,
        &-inline ${componentCls}-submenu-arrow`]: {
                    // ↓
                    '&::before': {
                        transform: `rotate(-45deg) translateX(${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(menuArrowOffset)})`
                    },
                    '&::after': {
                        transform: `rotate(45deg) translateX(${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.calc(menuArrowOffset).mul(-1).equal())})`
                    }
                },
                [`${componentCls}-submenu-open${componentCls}-submenu-inline > ${componentCls}-submenu-title > ${componentCls}-submenu-arrow`]: {
                    // ↑
                    transform: `translateY(${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.calc(menuArrowSize).mul(0.2).mul(-1).equal())})`,
                    '&::after': {
                        transform: `rotate(-45deg) translateX(${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.calc(menuArrowOffset).mul(-1).equal())})`
                    },
                    '&::before': {
                        transform: `rotate(45deg) translateX(${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(menuArrowOffset)})`
                    }
                }
            }
        },
        // Integration with header element so menu items have the same height
        {
            [`${antCls}-layout-header`]: {
                [componentCls]: {
                    lineHeight: 'inherit'
                }
            }
        }
    ];
};
const $eb5228b20f8c2097$export$9ca1be8807fe0675 = (token)=>{
    const { colorPrimary: colorPrimary, colorError: colorError, colorTextDisabled: colorTextDisabled, colorErrorBg: colorErrorBg, colorText: colorText, colorTextDescription: colorTextDescription, colorBgContainer: colorBgContainer, colorFillAlter: colorFillAlter, colorFillContent: colorFillContent, lineWidth: lineWidth, lineWidthBold: lineWidthBold, controlItemBgActive: controlItemBgActive, colorBgTextHover: colorBgTextHover, controlHeightLG: controlHeightLG, lineHeight: lineHeight, colorBgElevated: colorBgElevated, marginXXS: marginXXS, padding: padding, fontSize: fontSize, controlHeightSM: controlHeightSM, fontSizeLG: fontSizeLG, colorTextLightSolid: colorTextLightSolid, colorErrorHover: colorErrorHover } = token;
    const activeBarWidth = token.activeBarWidth ?? 0;
    const activeBarBorderWidth = token.activeBarBorderWidth ?? lineWidth;
    const itemMarginInline = token.itemMarginInline ?? token.marginXXS;
    const colorTextDark = new (0, $cbc85b6187a98a9b$export$2c4f38d6c0ecc25a)(colorTextLightSolid).setA(0.65).toRgbString();
    return {
        dropdownWidth: 160,
        zIndexPopup: token.zIndexPopupBase + 50,
        radiusItem: token.borderRadiusLG,
        itemBorderRadius: token.borderRadiusLG,
        radiusSubMenuItem: token.borderRadiusSM,
        subMenuItemBorderRadius: token.borderRadiusSM,
        colorItemText: colorText,
        itemColor: colorText,
        colorItemTextHover: colorText,
        itemHoverColor: colorText,
        colorItemTextHoverHorizontal: colorPrimary,
        horizontalItemHoverColor: colorPrimary,
        colorGroupTitle: colorTextDescription,
        groupTitleColor: colorTextDescription,
        colorItemTextSelected: colorPrimary,
        itemSelectedColor: colorPrimary,
        subMenuItemSelectedColor: colorPrimary,
        colorItemTextSelectedHorizontal: colorPrimary,
        horizontalItemSelectedColor: colorPrimary,
        colorItemBg: colorBgContainer,
        itemBg: colorBgContainer,
        colorItemBgHover: colorBgTextHover,
        itemHoverBg: colorBgTextHover,
        colorItemBgActive: colorFillContent,
        itemActiveBg: controlItemBgActive,
        colorSubItemBg: colorFillAlter,
        subMenuItemBg: colorFillAlter,
        colorItemBgSelected: controlItemBgActive,
        itemSelectedBg: controlItemBgActive,
        colorItemBgSelectedHorizontal: 'transparent',
        horizontalItemSelectedBg: 'transparent',
        colorActiveBarWidth: 0,
        activeBarWidth: activeBarWidth,
        colorActiveBarHeight: lineWidthBold,
        activeBarHeight: lineWidthBold,
        colorActiveBarBorderSize: lineWidth,
        activeBarBorderWidth: activeBarBorderWidth,
        // Disabled
        colorItemTextDisabled: colorTextDisabled,
        itemDisabledColor: colorTextDisabled,
        // Danger
        colorDangerItemText: colorError,
        dangerItemColor: colorError,
        colorDangerItemTextHover: colorError,
        dangerItemHoverColor: colorError,
        colorDangerItemTextSelected: colorError,
        dangerItemSelectedColor: colorError,
        colorDangerItemBgActive: colorErrorBg,
        dangerItemActiveBg: colorErrorBg,
        colorDangerItemBgSelected: colorErrorBg,
        dangerItemSelectedBg: colorErrorBg,
        itemMarginInline: itemMarginInline,
        horizontalItemBorderRadius: 0,
        horizontalItemHoverBg: 'transparent',
        itemHeight: controlHeightLG,
        groupTitleLineHeight: lineHeight,
        collapsedWidth: controlHeightLG * 2,
        popupBg: colorBgElevated,
        itemMarginBlock: marginXXS,
        itemPaddingInline: padding,
        horizontalLineHeight: `${controlHeightLG * 1.15}px`,
        iconSize: fontSize,
        iconMarginInlineEnd: controlHeightSM - fontSize,
        collapsedIconSize: fontSizeLG,
        groupTitleFontSize: fontSize,
        // Disabled
        darkItemDisabledColor: new (0, $cbc85b6187a98a9b$export$2c4f38d6c0ecc25a)(colorTextLightSolid).setA(0.25).toRgbString(),
        // Dark
        darkItemColor: colorTextDark,
        darkDangerItemColor: colorError,
        darkItemBg: '#001529',
        darkPopupBg: '#001529',
        darkSubMenuItemBg: '#000c17',
        darkItemSelectedColor: colorTextLightSolid,
        darkItemSelectedBg: colorPrimary,
        darkDangerItemSelectedBg: colorError,
        darkItemHoverBg: 'transparent',
        darkGroupTitleColor: colorTextDark,
        darkItemHoverColor: colorTextLightSolid,
        darkDangerItemHoverColor: colorErrorHover,
        darkDangerItemSelectedColor: colorTextLightSolid,
        darkDangerItemActiveBg: colorError,
        // internal
        itemWidth: activeBarWidth ? `calc(100% + ${activeBarBorderWidth}px)` : `calc(100% - ${itemMarginInline * 2}px)`
    };
};
var // ============================== Export ==============================
$eb5228b20f8c2097$export$2e2bcd8739ae039 = (prefixCls, rootCls = prefixCls, injectStyle = true)=>{
    const useStyle = (0, $d4a2dc313c4d90a4$export$51ec95de45185b42)('Menu', (token)=>{
        const { colorBgElevated: colorBgElevated, controlHeightLG: controlHeightLG, fontSize: fontSize, darkItemColor: darkItemColor, darkDangerItemColor: darkDangerItemColor, darkItemBg: darkItemBg, darkSubMenuItemBg: darkSubMenuItemBg, darkItemSelectedColor: darkItemSelectedColor, darkItemSelectedBg: darkItemSelectedBg, darkDangerItemSelectedBg: darkDangerItemSelectedBg, darkItemHoverBg: darkItemHoverBg, darkGroupTitleColor: darkGroupTitleColor, darkItemHoverColor: darkItemHoverColor, darkItemDisabledColor: darkItemDisabledColor, darkDangerItemHoverColor: darkDangerItemHoverColor, darkDangerItemSelectedColor: darkDangerItemSelectedColor, darkDangerItemActiveBg: darkDangerItemActiveBg, popupBg: popupBg, darkPopupBg: darkPopupBg } = token;
        const menuArrowSize = token.calc(fontSize).div(7).mul(5).equal();
        // Menu Token
        const menuToken = (0, $90c11ca6cb263fd9$export$4950aa0f605343fb)(token, {
            menuArrowSize: menuArrowSize,
            menuHorizontalHeight: token.calc(controlHeightLG).mul(1.15).equal(),
            menuArrowOffset: token.calc(menuArrowSize).mul(0.25).equal(),
            menuSubMenuBg: colorBgElevated,
            calc: token.calc,
            popupBg: popupBg
        });
        const menuDarkToken = (0, $90c11ca6cb263fd9$export$4950aa0f605343fb)(menuToken, {
            itemColor: darkItemColor,
            itemHoverColor: darkItemHoverColor,
            groupTitleColor: darkGroupTitleColor,
            itemSelectedColor: darkItemSelectedColor,
            subMenuItemSelectedColor: darkItemSelectedColor,
            itemBg: darkItemBg,
            popupBg: darkPopupBg,
            subMenuItemBg: darkSubMenuItemBg,
            itemActiveBg: 'transparent',
            itemSelectedBg: darkItemSelectedBg,
            activeBarHeight: 0,
            activeBarBorderWidth: 0,
            itemHoverBg: darkItemHoverBg,
            // Disabled
            itemDisabledColor: darkItemDisabledColor,
            // Danger
            dangerItemColor: darkDangerItemColor,
            dangerItemHoverColor: darkDangerItemHoverColor,
            dangerItemSelectedColor: darkDangerItemSelectedColor,
            dangerItemActiveBg: darkDangerItemActiveBg,
            dangerItemSelectedBg: darkDangerItemSelectedBg,
            menuSubMenuBg: darkSubMenuItemBg,
            // Horizontal
            horizontalItemSelectedColor: darkItemSelectedColor,
            horizontalItemSelectedBg: darkItemSelectedBg
        });
        return [
            // Basic
            $eb5228b20f8c2097$var$getBaseStyle(menuToken),
            // Horizontal
            (0, $b8c258658c545fd9$export$2e2bcd8739ae039)(menuToken),
            // Hard code for some light style
            // Vertical
            (0, $5161ebff0b656542$export$2e2bcd8739ae039)(menuToken),
            // Hard code for some light style
            // Theme
            (0, $28b90343102b9e0d$export$2e2bcd8739ae039)(menuToken, 'light'),
            (0, $28b90343102b9e0d$export$2e2bcd8739ae039)(menuDarkToken, 'dark'),
            // RTL
            (0, $73d96478051ecc0b$export$2e2bcd8739ae039)(menuToken),
            // Motion
            (0, $f58f14441a7cd550$export$2e2bcd8739ae039)(menuToken),
            (0, $21a6ccba58224685$export$9018e60daecf7a6c)(menuToken, 'slide-up'),
            (0, $21a6ccba58224685$export$9018e60daecf7a6c)(menuToken, 'slide-down'),
            (0, $9783f6e7d4c63d86$export$f5d123412490d9dc)(menuToken, 'zoom-big')
        ];
    }, $eb5228b20f8c2097$export$9ca1be8807fe0675, {
        deprecatedTokens: [
            [
                'colorGroupTitle',
                'groupTitleColor'
            ],
            [
                'radiusItem',
                'itemBorderRadius'
            ],
            [
                'radiusSubMenuItem',
                'subMenuItemBorderRadius'
            ],
            [
                'colorItemText',
                'itemColor'
            ],
            [
                'colorItemTextHover',
                'itemHoverColor'
            ],
            [
                'colorItemTextHoverHorizontal',
                'horizontalItemHoverColor'
            ],
            [
                'colorItemTextSelected',
                'itemSelectedColor'
            ],
            [
                'colorItemTextSelectedHorizontal',
                'horizontalItemSelectedColor'
            ],
            [
                'colorItemTextDisabled',
                'itemDisabledColor'
            ],
            [
                'colorDangerItemText',
                'dangerItemColor'
            ],
            [
                'colorDangerItemTextHover',
                'dangerItemHoverColor'
            ],
            [
                'colorDangerItemTextSelected',
                'dangerItemSelectedColor'
            ],
            [
                'colorDangerItemBgActive',
                'dangerItemActiveBg'
            ],
            [
                'colorDangerItemBgSelected',
                'dangerItemSelectedBg'
            ],
            [
                'colorItemBg',
                'itemBg'
            ],
            [
                'colorItemBgHover',
                'itemHoverBg'
            ],
            [
                'colorSubItemBg',
                'subMenuItemBg'
            ],
            [
                'colorItemBgActive',
                'itemActiveBg'
            ],
            [
                'colorItemBgSelectedHorizontal',
                'horizontalItemSelectedBg'
            ],
            [
                'colorActiveBarWidth',
                'activeBarWidth'
            ],
            [
                'colorActiveBarHeight',
                'activeBarHeight'
            ],
            [
                'colorActiveBarBorderSize',
                'activeBarBorderWidth'
            ],
            [
                'colorItemBgSelected',
                'itemSelectedBg'
            ]
        ],
        injectStyle: // Dropdown will handle menu style self. We do not need to handle this.
        injectStyle,
        unitless: {
            groupTitleLineHeight: true
        }
    });
    return useStyle(prefixCls, rootCls);
};


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");






"use client";
const $81c154fcd87ec40e$var$SubMenu = (props)=>{
    const { popupClassName: popupClassName, icon: icon, title: title, theme: customTheme } = props;
    const context = $32rMB.useContext((0, $2982543b03b9c07b$export$2e2bcd8739ae039));
    const { prefixCls: prefixCls, inlineCollapsed: inlineCollapsed, theme: contextTheme, classNames: classNames, styles: styles } = context;
    const parentPath = (0, $4d1b4cb331d72abd$export$d3d2d0a05677870a)();
    let titleNode;
    if (!icon) titleNode = inlineCollapsed && !parentPath.length && title && typeof title === 'string' ? /*#__PURE__*/ $hO8yS.createElement("div", {
        className: `${prefixCls}-inline-collapsed-noicon`
    }, title.charAt(0)) : /*#__PURE__*/ $hO8yS.createElement("span", {
        className: `${prefixCls}-title-content`
    }, title);
    else {
        // inline-collapsed.md demo 依赖 span 来隐藏文字,有 icon 属性，则内部包裹一个 span
        // ref: https://github.com/ant-design/ant-design/pull/23456
        const titleIsSpan = /*#__PURE__*/ $N3oW3.isValidElement(title) && title.type === 'span';
        titleNode = /*#__PURE__*/ $hO8yS.createElement($hO8yS.Fragment, null, (0, $62609775897a768c$export$e530037191fcd5d7)(icon, (oriProps)=>({
                className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(oriProps.className, `${prefixCls}-item-icon`, classNames.itemIcon),
                style: {
                    ...oriProps.style,
                    ...styles.itemIcon
                }
            })), titleIsSpan ? title : /*#__PURE__*/ $hO8yS.createElement("span", {
            className: `${prefixCls}-title-content`
        }, title));
    }
    const contextValue = $32rMB.useMemo(()=>({
            ...context,
            firstLevel: false
        }), [
        context
    ]);
    // ============================ zIndex ============================
    const [zIndex] = (0, $15dbea5a917a06ef$export$3e7906d4075187a4)('Menu');
    return /*#__PURE__*/ $hO8yS.createElement((0, $2982543b03b9c07b$export$2e2bcd8739ae039).Provider, {
        value: contextValue
    }, /*#__PURE__*/ $hO8yS.createElement((0, $0211eb57621e76e2$export$2e2bcd8739ae039), {
        ...(0, $f4cf9c2e27c0ac8d$export$2e2bcd8739ae039)(props, [
            'icon'
        ]),
        title: titleNode,
        classNames: {
            list: classNames.subMenu.list,
            listTitle: classNames.subMenu.itemTitle
        },
        styles: {
            list: styles.subMenu.list,
            listTitle: styles.subMenu.itemTitle
        },
        popupClassName: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, popupClassName, classNames.popup.root, `${prefixCls}-${customTheme || contextTheme}`),
        popupStyle: {
            zIndex: zIndex,
            // fix: https://github.com/ant-design/ant-design/issues/47826#issuecomment-2360737237
            ...props.popupStyle,
            ...styles.popup.root
        }
    }));
};
var $81c154fcd87ec40e$export$2e2bcd8739ae039 = $81c154fcd87ec40e$var$SubMenu;


"use client";
function $689e9132fe40881b$var$isEmptyIcon(icon) {
    return icon === null || icon === false;
}
const $689e9132fe40881b$var$MENU_COMPONENTS = {
    item: (0, $97f615c53f177678$export$2e2bcd8739ae039),
    submenu: (0, $81c154fcd87ec40e$export$2e2bcd8739ae039),
    divider: (0, $44349498ba1afec0$export$2e2bcd8739ae039)
};
const $689e9132fe40881b$var$InternalMenu = /*#__PURE__*/ (0, $N3oW3.forwardRef)((props, ref)=>{
    const override = $32rMB.useContext((0, $4ecfd4dbf7968668$export$2e2bcd8739ae039));
    const overrideObj = override || {};
    const { prefixCls: customizePrefixCls, className: className, style: style, theme: theme = 'light', expandIcon: expandIcon, _internalDisableMenuItemTitleTooltip: _internalDisableMenuItemTitleTooltip, inlineCollapsed: inlineCollapsed, siderCollapsed: siderCollapsed, rootClassName: rootClassName, mode: mode, selectable: selectable, onClick: onClick, overflowedIndicatorPopupClassName: overflowedIndicatorPopupClassName, classNames: classNames, styles: styles, ...restProps } = props;
    const { menu: menu } = $32rMB.useContext((0, $dd01e2f5a4b8605d$export$a92f85ab3e9ad68b));
    const { getPrefixCls: getPrefixCls, getPopupContainer: getPopupContainer, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $dd01e2f5a4b8605d$export$46f4bd6436a25a31)('menu');
    const rootPrefixCls = getPrefixCls();
    const passedProps = (0, $f4cf9c2e27c0ac8d$export$2e2bcd8739ae039)(restProps, [
        'collapsedWidth'
    ]);
    overrideObj.validator?.({
        mode: mode
    });
    // ========================== Click ==========================
    // Tell dropdown that item clicked
    const onItemClick = (0, $ea93068db096b7d6$export$2e2bcd8739ae039)((...args)=>{
        onClick?.(...args);
        overrideObj.onClick?.();
    });
    // ========================== Mode ===========================
    const mergedMode = overrideObj.mode || mode;
    // ======================= Selectable ========================
    const mergedSelectable = selectable ?? overrideObj.selectable;
    // ======================== Collapsed ========================
    // Inline Collapsed
    const mergedInlineCollapsed = inlineCollapsed ?? siderCollapsed;
    // ================ Merged Props for Semantic ================
    const mergedProps = {
        ...props,
        mode: mergedMode,
        inlineCollapsed: mergedInlineCollapsed,
        selectable: mergedSelectable,
        theme: theme
    };
    const [mergedClassNames, mergedStyles] = (0, $4dcf69d8c3d6df5c$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    }, {
        popup: {
            _default: 'root'
        },
        subMenu: {
            _default: 'item'
        }
    });
    const defaultMotions = {
        horizontal: {
            motionName: `${rootPrefixCls}-slide-up`
        },
        inline: (0, $689b5af26dd3c1cd$export$2e2bcd8739ae039)(rootPrefixCls),
        other: {
            motionName: `${rootPrefixCls}-zoom-big`
        }
    };
    const prefixCls = getPrefixCls('menu', customizePrefixCls || overrideObj.prefixCls);
    const rootCls = (0, $54b1aecddbbbed4f$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $eb5228b20f8c2097$export$2e2bcd8739ae039)(prefixCls, rootCls, !override);
    const menuClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-${theme}`, contextClassName, className);
    // ====================== ExpandIcon ========================
    const mergedExpandIcon = $32rMB.useMemo(()=>{
        if (typeof expandIcon === 'function' || $689e9132fe40881b$var$isEmptyIcon(expandIcon)) return expandIcon || null;
        if (typeof overrideObj.expandIcon === 'function' || $689e9132fe40881b$var$isEmptyIcon(overrideObj.expandIcon)) return overrideObj.expandIcon || null;
        if (typeof menu?.expandIcon === 'function' || $689e9132fe40881b$var$isEmptyIcon(menu?.expandIcon)) return menu?.expandIcon || null;
        const mergedIcon = expandIcon ?? overrideObj?.expandIcon ?? menu?.expandIcon;
        return (0, $62609775897a768c$export$e530037191fcd5d7)(mergedIcon, {
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-submenu-expand-icon`, /*#__PURE__*/ $N3oW3.isValidElement(mergedIcon) ? mergedIcon.props?.className : undefined)
        });
    }, [
        expandIcon,
        overrideObj?.expandIcon,
        menu?.expandIcon,
        prefixCls
    ]);
    // ======================== Context ==========================
    const contextValue = $32rMB.useMemo(()=>({
            prefixCls: prefixCls,
            inlineCollapsed: mergedInlineCollapsed || false,
            direction: direction,
            firstLevel: true,
            theme: theme,
            mode: mergedMode,
            disableMenuItemTitleTooltip: _internalDisableMenuItemTitleTooltip,
            classNames: mergedClassNames,
            styles: mergedStyles
        }), [
        prefixCls,
        mergedInlineCollapsed,
        direction,
        _internalDisableMenuItemTitleTooltip,
        theme,
        mergedMode,
        mergedClassNames,
        mergedStyles
    ]);
    // ========================= Render ==========================
    return /*#__PURE__*/ $hO8yS.createElement((0, $4ecfd4dbf7968668$export$2e2bcd8739ae039).Provider, {
        value: null
    }, /*#__PURE__*/ $hO8yS.createElement((0, $2982543b03b9c07b$export$2e2bcd8739ae039).Provider, {
        value: contextValue
    }, /*#__PURE__*/ $hO8yS.createElement((0, $2b25266c93a9e48f$export$2e2bcd8739ae039), {
        getPopupContainer: getPopupContainer,
        overflowedIndicator: /*#__PURE__*/ $hO8yS.createElement((0, $391e9221407e00e5$export$2e2bcd8739ae039), null),
        overflowedIndicatorPopupClassName: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-${theme}`, overflowedIndicatorPopupClassName),
        classNames: {
            list: mergedClassNames.list,
            listTitle: mergedClassNames.itemTitle
        },
        styles: {
            list: mergedStyles.list,
            listTitle: mergedStyles.itemTitle
        },
        mode: mergedMode,
        selectable: mergedSelectable,
        onClick: onItemClick,
        ...passedProps,
        inlineCollapsed: mergedInlineCollapsed,
        style: {
            ...mergedStyles.root,
            ...contextStyle,
            ...style
        },
        className: menuClassName,
        prefixCls: prefixCls,
        direction: direction,
        defaultMotions: defaultMotions,
        expandIcon: mergedExpandIcon,
        ref: ref,
        rootClassName: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(rootClassName, hashId, overrideObj.rootClassName, cssVarCls, rootCls, mergedClassNames.root),
        _internalComponents: $689e9132fe40881b$var$MENU_COMPONENTS
    })));
});
var $689e9132fe40881b$export$2e2bcd8739ae039 = $689e9132fe40881b$var$InternalMenu;





"use client";
const $23cb8fbdad4e5f07$var$Menu = /*#__PURE__*/ (0, $N3oW3.forwardRef)((props, ref)=>{
    const menuRef = (0, $32rMB.useRef)(null);
    const context = $32rMB.useContext((0, $6adf4c035f43d1a3$export$63554aebd2a6d54c));
    (0, $32rMB.useImperativeHandle)(ref, ()=>({
            menu: menuRef.current,
            focus: (options)=>{
                menuRef.current?.focus(options);
            }
        }));
    return /*#__PURE__*/ $hO8yS.createElement((0, $689e9132fe40881b$export$2e2bcd8739ae039), {
        ref: menuRef,
        ...props,
        ...context
    });
});
$23cb8fbdad4e5f07$var$Menu.Item = (0, $97f615c53f177678$export$2e2bcd8739ae039);
$23cb8fbdad4e5f07$var$Menu.SubMenu = (0, $81c154fcd87ec40e$export$2e2bcd8739ae039);
$23cb8fbdad4e5f07$var$Menu.Divider = (0, $44349498ba1afec0$export$2e2bcd8739ae039);
$23cb8fbdad4e5f07$var$Menu.ItemGroup = (0, $520d4c893c082639$export$2e2bcd8739ae039);
var $23cb8fbdad4e5f07$export$2e2bcd8739ae039 = $23cb8fbdad4e5f07$var$Menu;








const $309d9b1280ac3808$export$c81b62e088da1305 = new (0, $f806545df26bb0b4$export$2e2bcd8739ae039)('antMoveDownIn', {
    '0%': {
        transform: 'translate3d(0, 100%, 0)',
        transformOrigin: '0 0',
        opacity: 0
    },
    '100%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    }
});
const $309d9b1280ac3808$export$6c1eca72ac4f6672 = new (0, $f806545df26bb0b4$export$2e2bcd8739ae039)('antMoveDownOut', {
    '0%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    },
    '100%': {
        transform: 'translate3d(0, 100%, 0)',
        transformOrigin: '0 0',
        opacity: 0
    }
});
const $309d9b1280ac3808$export$8dd54688d033571 = new (0, $f806545df26bb0b4$export$2e2bcd8739ae039)('antMoveLeftIn', {
    '0%': {
        transform: 'translate3d(-100%, 0, 0)',
        transformOrigin: '0 0',
        opacity: 0
    },
    '100%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    }
});
const $309d9b1280ac3808$export$be161c4e647bea9b = new (0, $f806545df26bb0b4$export$2e2bcd8739ae039)('antMoveLeftOut', {
    '0%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    },
    '100%': {
        transform: 'translate3d(-100%, 0, 0)',
        transformOrigin: '0 0',
        opacity: 0
    }
});
const $309d9b1280ac3808$export$a984c43131c7d145 = new (0, $f806545df26bb0b4$export$2e2bcd8739ae039)('antMoveRightIn', {
    '0%': {
        transform: 'translate3d(100%, 0, 0)',
        transformOrigin: '0 0',
        opacity: 0
    },
    '100%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    }
});
const $309d9b1280ac3808$export$e141ac6798b476df = new (0, $f806545df26bb0b4$export$2e2bcd8739ae039)('antMoveRightOut', {
    '0%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    },
    '100%': {
        transform: 'translate3d(100%, 0, 0)',
        transformOrigin: '0 0',
        opacity: 0
    }
});
const $309d9b1280ac3808$export$ab676201eaaca05 = new (0, $f806545df26bb0b4$export$2e2bcd8739ae039)('antMoveUpIn', {
    '0%': {
        transform: 'translate3d(0, -100%, 0)',
        transformOrigin: '0 0',
        opacity: 0
    },
    '100%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    }
});
const $309d9b1280ac3808$export$ec1b91b8ec2f6331 = new (0, $f806545df26bb0b4$export$2e2bcd8739ae039)('antMoveUpOut', {
    '0%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    },
    '100%': {
        transform: 'translate3d(0, -100%, 0)',
        transformOrigin: '0 0',
        opacity: 0
    }
});
const $309d9b1280ac3808$var$moveMotion = {
    'move-up': {
        inKeyframes: $309d9b1280ac3808$export$ab676201eaaca05,
        outKeyframes: $309d9b1280ac3808$export$ec1b91b8ec2f6331
    },
    'move-down': {
        inKeyframes: $309d9b1280ac3808$export$c81b62e088da1305,
        outKeyframes: $309d9b1280ac3808$export$6c1eca72ac4f6672
    },
    'move-left': {
        inKeyframes: $309d9b1280ac3808$export$8dd54688d033571,
        outKeyframes: $309d9b1280ac3808$export$be161c4e647bea9b
    },
    'move-right': {
        inKeyframes: $309d9b1280ac3808$export$a984c43131c7d145,
        outKeyframes: $309d9b1280ac3808$export$e141ac6798b476df
    }
};
const $309d9b1280ac3808$export$913b1b7e3288c319 = (token, motionName)=>{
    const { antCls: antCls } = token;
    const motionCls = `${antCls}-${motionName}`;
    const { inKeyframes: inKeyframes, outKeyframes: outKeyframes } = $309d9b1280ac3808$var$moveMotion[motionName];
    return [
        (0, $811fac7c59e65981$export$83e1da9e09ec9112)(motionCls, inKeyframes, outKeyframes, token.motionDurationMid),
        {
            [`
        ${motionCls}-enter,
        ${motionCls}-appear
      `]: {
                opacity: 0,
                animationTimingFunction: token.motionEaseOutCirc
            },
            [`${motionCls}-leave`]: {
                animationTimingFunction: token.motionEaseInOutCirc
            }
        }
    ];
};





const $f658380362c6dd99$var$genStatusStyle = (token)=>{
    const { componentCls: componentCls, menuCls: menuCls, colorError: colorError, colorTextLightSolid: colorTextLightSolid } = token;
    const itemCls = `${menuCls}-item`;
    return {
        [`${componentCls}, ${componentCls}-menu-submenu`]: {
            [`${menuCls} ${itemCls}`]: {
                [`&${itemCls}-danger:not(${itemCls}-disabled)`]: {
                    color: colorError,
                    '&:hover': {
                        color: colorTextLightSolid,
                        backgroundColor: colorError
                    }
                }
            }
        }
    };
};
var $f658380362c6dd99$export$2e2bcd8739ae039 = $f658380362c6dd99$var$genStatusStyle;


// =============================== Base ===============================
const $6f2c73c82b97f963$var$genBaseStyle = (token)=>{
    const { componentCls: componentCls, menuCls: menuCls, zIndexPopup: zIndexPopup, dropdownArrowDistance: dropdownArrowDistance, sizePopupArrow: sizePopupArrow, antCls: antCls, iconCls: iconCls, motionDurationMid: motionDurationMid, paddingBlock: paddingBlock, fontSize: fontSize, dropdownEdgeChildPadding: dropdownEdgeChildPadding, colorTextDisabled: colorTextDisabled, fontSizeIcon: fontSizeIcon, controlPaddingHorizontal: controlPaddingHorizontal, colorBgElevated: colorBgElevated } = token;
    return [
        {
            [componentCls]: {
                position: 'absolute',
                top: -9999,
                left: {
                    _skip_check_: true,
                    value: -9999
                },
                zIndex: zIndexPopup,
                display: 'block',
                // A placeholder out of dropdown visible range to avoid close when user moving
                '&::before': {
                    position: 'absolute',
                    insetBlock: token.calc(sizePopupArrow).div(2).sub(dropdownArrowDistance).equal(),
                    // insetInlineStart: -7, // FIXME: Seems not work for hidden element
                    zIndex: -9999,
                    opacity: 0.0001,
                    content: '""'
                },
                // Makes vertical dropdowns have a scrollbar once they become taller than the viewport.
                '&-menu-vertical': {
                    maxHeight: '100vh',
                    overflowY: 'auto'
                },
                [`&-trigger${antCls}-btn`]: {
                    [`& > ${iconCls}-down, & > ${antCls}-btn-icon > ${iconCls}-down`]: {
                        fontSize: fontSizeIcon
                    }
                },
                [`${componentCls}-wrap`]: {
                    position: 'relative',
                    [`${antCls}-btn > ${iconCls}-down`]: {
                        fontSize: fontSizeIcon
                    },
                    [`${iconCls}-down::before`]: {
                        transition: `transform ${motionDurationMid}`
                    }
                },
                [`${componentCls}-wrap-open`]: {
                    [`${iconCls}-down::before`]: {
                        transform: `rotate(180deg)`
                    }
                },
                [`
        &-hidden,
        &-menu-hidden,
        &-menu-submenu-hidden
      `]: {
                    display: 'none'
                },
                // =============================================================
                // ==                         Motion                          ==
                // =============================================================
                // When position is not enough for dropdown, the placement will revert.
                // We will handle this with revert motion name.
                [`&${antCls}-slide-down-enter${antCls}-slide-down-enter-active${componentCls}-placement-bottomLeft,
          &${antCls}-slide-down-appear${antCls}-slide-down-appear-active${componentCls}-placement-bottomLeft,
          &${antCls}-slide-down-enter${antCls}-slide-down-enter-active${componentCls}-placement-bottom,
          &${antCls}-slide-down-appear${antCls}-slide-down-appear-active${componentCls}-placement-bottom,
          &${antCls}-slide-down-enter${antCls}-slide-down-enter-active${componentCls}-placement-bottomRight,
          &${antCls}-slide-down-appear${antCls}-slide-down-appear-active${componentCls}-placement-bottomRight`]: {
                    animationName: (0, $21a6ccba58224685$export$e801b802b037de6a)
                },
                [`&${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-placement-topLeft,
          &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-placement-topLeft,
          &${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-placement-top,
          &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-placement-top,
          &${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-placement-topRight,
          &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-placement-topRight`]: {
                    animationName: (0, $21a6ccba58224685$export$dd9f089fa5e819fe)
                },
                [`&${antCls}-slide-down-leave${antCls}-slide-down-leave-active${componentCls}-placement-bottomLeft,
          &${antCls}-slide-down-leave${antCls}-slide-down-leave-active${componentCls}-placement-bottom,
          &${antCls}-slide-down-leave${antCls}-slide-down-leave-active${componentCls}-placement-bottomRight`]: {
                    animationName: (0, $21a6ccba58224685$export$f40f41df328ebc38)
                },
                [`&${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-placement-topLeft,
          &${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-placement-top,
          &${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-placement-topRight`]: {
                    animationName: (0, $21a6ccba58224685$export$f7243fdb9c27c3b7)
                }
            }
        },
        // =============================================================
        // ==                        Arrow style                      ==
        // =============================================================
        (0, $8d59d91a3e235d80$export$2e2bcd8739ae039)(token, colorBgElevated, {
            arrowPlacement: {
                top: true,
                bottom: true
            }
        }),
        {
            // =============================================================
            // ==                          Menu                           ==
            // =============================================================
            [`${componentCls} ${menuCls}`]: {
                position: 'relative',
                margin: 0
            },
            [`${menuCls}-submenu-popup`]: {
                position: 'absolute',
                zIndex: zIndexPopup,
                background: 'transparent',
                boxShadow: 'none',
                transformOrigin: '0 0',
                'ul, li': {
                    listStyle: 'none',
                    margin: 0
                }
            },
            [`${componentCls}, ${componentCls}-menu-submenu`]: {
                ...(0, $2f353af2b0f7600b$export$23997c3e44cc1c59)(token),
                [menuCls]: {
                    padding: dropdownEdgeChildPadding,
                    listStyleType: 'none',
                    backgroundColor: colorBgElevated,
                    backgroundClip: 'padding-box',
                    borderRadius: token.borderRadiusLG,
                    outline: 'none',
                    boxShadow: token.boxShadowSecondary,
                    ...(0, $2f353af2b0f7600b$export$a44db842bcb28231)(token),
                    '&:empty': {
                        padding: 0,
                        boxShadow: 'none'
                    },
                    [`${menuCls}-item-group-title`]: {
                        padding: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(paddingBlock)} ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(controlPaddingHorizontal)}`,
                        color: token.colorTextDescription,
                        transition: `all ${motionDurationMid}`
                    },
                    // ======================= Item Content =======================
                    [`${menuCls}-item`]: {
                        position: 'relative',
                        display: 'flex',
                        alignItems: 'center'
                    },
                    [`${menuCls}-item-icon`]: {
                        minWidth: fontSize,
                        marginInlineEnd: token.marginXS,
                        fontSize: token.fontSizeSM
                    },
                    [`${menuCls}-title-content`]: {
                        flex: 'auto',
                        '&-with-extra': {
                            display: 'inline-flex',
                            alignItems: 'center',
                            width: '100%'
                        },
                        '> a': {
                            color: 'inherit',
                            transition: `all ${motionDurationMid}`,
                            '&:hover': {
                                color: 'inherit'
                            },
                            '&::after': {
                                position: 'absolute',
                                inset: 0,
                                content: '""'
                            }
                        },
                        [`${menuCls}-item-extra`]: {
                            paddingInlineStart: token.padding,
                            marginInlineStart: 'auto',
                            fontSize: token.fontSizeSM,
                            color: token.colorTextDescription
                        }
                    },
                    // =========================== Item ===========================
                    [`${menuCls}-item, ${menuCls}-submenu-title`]: {
                        display: 'flex',
                        margin: 0,
                        padding: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(paddingBlock)} ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(controlPaddingHorizontal)}`,
                        color: token.colorText,
                        fontWeight: 'normal',
                        fontSize: fontSize,
                        lineHeight: token.lineHeight,
                        cursor: 'pointer',
                        transition: `all ${motionDurationMid}`,
                        borderRadius: token.borderRadiusSM,
                        '&:hover, &-active': {
                            backgroundColor: token.controlItemBgHover
                        },
                        ...(0, $2f353af2b0f7600b$export$a44db842bcb28231)(token),
                        '&-selected': {
                            color: token.colorPrimary,
                            backgroundColor: token.controlItemBgActive,
                            '&:hover, &-active': {
                                backgroundColor: token.controlItemBgActiveHover
                            }
                        },
                        '&-disabled': {
                            color: colorTextDisabled,
                            cursor: 'not-allowed',
                            '&:hover': {
                                color: colorTextDisabled,
                                backgroundColor: colorBgElevated,
                                cursor: 'not-allowed'
                            },
                            a: {
                                pointerEvents: 'none'
                            }
                        },
                        '&-divider': {
                            height: 1,
                            // By design
                            margin: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.marginXXS)} 0`,
                            overflow: 'hidden',
                            lineHeight: 0,
                            backgroundColor: token.colorSplit
                        },
                        [`${componentCls}-menu-submenu-expand-icon`]: {
                            position: 'absolute',
                            insetInlineEnd: token.paddingXS,
                            [`${componentCls}-menu-submenu-arrow-icon`]: {
                                marginInlineEnd: '0 !important',
                                color: token.colorIcon,
                                fontSize: fontSizeIcon,
                                fontStyle: 'normal'
                            }
                        }
                    },
                    [`${menuCls}-item-group-list`]: {
                        margin: `0 ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.marginXS)}`,
                        padding: 0,
                        listStyle: 'none'
                    },
                    [`${menuCls}-submenu-title`]: {
                        paddingInlineEnd: token.calc(controlPaddingHorizontal).add(token.fontSizeSM).equal()
                    },
                    [`${menuCls}-submenu-vertical`]: {
                        position: 'relative'
                    },
                    [`${menuCls}-submenu${menuCls}-submenu-disabled ${componentCls}-menu-submenu-title`]: {
                        [`&, ${componentCls}-menu-submenu-arrow-icon`]: {
                            color: colorTextDisabled,
                            backgroundColor: colorBgElevated,
                            cursor: 'not-allowed'
                        }
                    },
                    // https://github.com/ant-design/ant-design/issues/19264
                    [`${menuCls}-submenu-selected ${componentCls}-menu-submenu-title`]: {
                        color: token.colorPrimary
                    }
                }
            }
        },
        // Follow code may reuse in other components
        [
            (0, $21a6ccba58224685$export$9018e60daecf7a6c)(token, 'slide-up'),
            (0, $21a6ccba58224685$export$9018e60daecf7a6c)(token, 'slide-down'),
            (0, $309d9b1280ac3808$export$913b1b7e3288c319)(token, 'move-up'),
            (0, $309d9b1280ac3808$export$913b1b7e3288c319)(token, 'move-down'),
            (0, $9783f6e7d4c63d86$export$f5d123412490d9dc)(token, 'zoom-big')
        ]
    ];
};
const $6f2c73c82b97f963$export$9ca1be8807fe0675 = (token)=>({
        zIndexPopup: token.zIndexPopupBase + 50,
        paddingBlock: (token.controlHeight - token.fontSize * token.lineHeight) / 2,
        ...(0, $8d59d91a3e235d80$export$bddc192327bb9823)({
            contentRadius: token.borderRadiusLG,
            limitVerticalRadius: true
        }),
        ...(0, $129ab988bfbe5ce1$export$87e38ee403661ccc)(token)
    });
var $6f2c73c82b97f963$export$2e2bcd8739ae039 = (0, $d4a2dc313c4d90a4$export$51ec95de45185b42)('Dropdown', (token)=>{
    const { marginXXS: marginXXS, sizePopupArrow: sizePopupArrow, paddingXXS: paddingXXS, componentCls: componentCls } = token;
    const dropdownToken = (0, $90c11ca6cb263fd9$export$4950aa0f605343fb)(token, {
        menuCls: `${componentCls}-menu`,
        dropdownArrowDistance: token.calc(sizePopupArrow).div(2).add(marginXXS).equal(),
        dropdownEdgeChildPadding: paddingXXS
    });
    return [
        $6f2c73c82b97f963$var$genBaseStyle(dropdownToken),
        (0, $f658380362c6dd99$export$2e2bcd8739ae039)(dropdownToken)
    ];
}, $6f2c73c82b97f963$export$9ca1be8807fe0675, {
    resetStyle: false
});


"use client";
const $b3687c0712e4a76e$var$_Placements = [
    'topLeft',
    'topCenter',
    'topRight',
    'bottomLeft',
    'bottomCenter',
    'bottomRight',
    'top',
    'bottom'
];
const $b3687c0712e4a76e$var$Dropdown = (props)=>{
    const { menu: menu, arrow: arrow, prefixCls: customizePrefixCls, children: children, trigger: trigger, disabled: disabled, dropdownRender: dropdownRender, popupRender: popupRender, getPopupContainer: getPopupContainer, overlayClassName: overlayClassName, rootClassName: rootClassName, overlayStyle: overlayStyle, open: open, onOpenChange: onOpenChange, mouseEnterDelay: mouseEnterDelay = 0.15, mouseLeaveDelay: mouseLeaveDelay = 0.1, autoAdjustOverflow: autoAdjustOverflow = true, placement: placement = '', transitionName: transitionName, classNames: classNames, styles: styles, destroyPopupOnHide: destroyPopupOnHide, destroyOnHidden: destroyOnHidden } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, getPopupContainer: getContextPopupContainer, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $dd01e2f5a4b8605d$export$46f4bd6436a25a31)('dropdown');
    const mergedProps = {
        ...props,
        mouseEnterDelay: mouseEnterDelay,
        mouseLeaveDelay: mouseLeaveDelay,
        autoAdjustOverflow: autoAdjustOverflow
    };
    const [mergedClassNames, mergedStyles] = (0, $4dcf69d8c3d6df5c$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    const mergedRootStyles = {
        ...contextStyle,
        ...overlayStyle,
        ...mergedStyles.root
    };
    const mergedPopupRender = popupRender || dropdownRender;
    // =================== Warning =====================
    const warning = (0, $d41680c8243eac18$export$cf977aa92c751e61)('Dropdown');
    var deprecatedName, newName;
    const memoTransitionName = $32rMB.useMemo(()=>{
        const rootPrefixCls = getPrefixCls();
        if (transitionName !== undefined) return transitionName;
        if (placement.includes('top')) return `${rootPrefixCls}-slide-down`;
        return `${rootPrefixCls}-slide-up`;
    }, [
        getPrefixCls,
        placement,
        transitionName
    ]);
    const memoPlacement = $32rMB.useMemo(()=>{
        if (!placement) return direction === 'rtl' ? 'bottomRight' : 'bottomLeft';
        if (placement.includes('Center')) return placement.slice(0, placement.indexOf('Center'));
        return placement;
    }, [
        placement,
        direction
    ]);
    const prefixCls = getPrefixCls('dropdown', customizePrefixCls);
    const rootCls = (0, $54b1aecddbbbed4f$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $6f2c73c82b97f963$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const [, token] = (0, $9481722d146bd166$export$2e2bcd8739ae039)();
    const child = $N3oW3.Children.only((0, $d4f9e905b2d01ac8$export$2e2bcd8739ae039)(children) ? /*#__PURE__*/ $hO8yS.createElement("span", null, children) : children);
    const popupTrigger = (0, $62609775897a768c$export$e530037191fcd5d7)(child, {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-trigger`, {
            [`${prefixCls}-rtl`]: direction === 'rtl'
        }, child.props.className),
        disabled: child.props.disabled ?? disabled
    });
    const triggerActions = disabled ? [] : trigger;
    const alignPoint = !!triggerActions?.includes('contextMenu');
    // =========================== Open ============================
    const [mergedOpen, setOpen] = (0, $05ea6e97cee440ee$export$2e2bcd8739ae039)(false, open);
    const onInnerOpenChange = (0, $ea93068db096b7d6$export$2e2bcd8739ae039)((nextOpen)=>{
        onOpenChange?.(nextOpen, {
            source: 'trigger'
        });
        setOpen(nextOpen);
    });
    // =========================== Overlay ============================
    const overlayClassNameCustomized = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(overlayClassName, rootClassName, hashId, cssVarCls, rootCls, contextClassName, mergedClassNames.root, {
        [`${prefixCls}-rtl`]: direction === 'rtl'
    });
    const builtinPlacements = (0, $e523ba814abcafb5$export$2e2bcd8739ae039)({
        arrowPointAtCenter: typeof arrow === 'object' && arrow.pointAtCenter,
        autoAdjustOverflow: autoAdjustOverflow,
        offset: token.marginXXS,
        arrowWidth: arrow ? token.sizePopupArrow : 0,
        borderRadius: token.borderRadius
    });
    const onMenuClick = (0, $ea93068db096b7d6$export$2e2bcd8739ae039)(()=>{
        if (menu?.selectable && menu?.multiple) return;
        onOpenChange?.(false, {
            source: 'menu'
        });
        setOpen(false);
    });
    const renderOverlay = ()=>{
        // @rc-component/dropdown already can process the function of overlay, but we have check logic here.
        // So we need render the element to check and pass back to @rc-component/dropdown.
        const menuClassNames = (0, $f4cf9c2e27c0ac8d$export$2e2bcd8739ae039)(mergedClassNames, [
            'root'
        ]);
        const menuStyles = (0, $f4cf9c2e27c0ac8d$export$2e2bcd8739ae039)(mergedStyles, [
            'root'
        ]);
        let overlayNode;
        if (menu?.items) overlayNode = /*#__PURE__*/ $hO8yS.createElement((0, $23cb8fbdad4e5f07$export$2e2bcd8739ae039), {
            ...menu,
            classNames: {
                ...menuClassNames,
                subMenu: {
                    ...menuClassNames
                }
            },
            styles: {
                ...menuStyles,
                subMenu: {
                    ...menuStyles
                }
            }
        });
        if (mergedPopupRender) overlayNode = mergedPopupRender(overlayNode);
        overlayNode = $N3oW3.Children.only(typeof overlayNode === 'string' ? /*#__PURE__*/ $hO8yS.createElement("span", null, overlayNode) : overlayNode);
        return /*#__PURE__*/ $hO8yS.createElement((0, $4ecfd4dbf7968668$export$9bd434816b0530d0), {
            prefixCls: `${prefixCls}-menu`,
            rootClassName: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(cssVarCls, rootCls),
            expandIcon: /*#__PURE__*/ $hO8yS.createElement("span", {
                className: `${prefixCls}-menu-submenu-arrow`
            }, direction === 'rtl' ? /*#__PURE__*/ $hO8yS.createElement((0, $e4b471ef5251dafb$export$2e2bcd8739ae039), {
                className: `${prefixCls}-menu-submenu-arrow-icon`
            }) : /*#__PURE__*/ $hO8yS.createElement((0, $c8c7be68bfada8d0$export$2e2bcd8739ae039), {
                className: `${prefixCls}-menu-submenu-arrow-icon`
            })),
            mode: "vertical",
            selectable: false,
            onClick: onMenuClick,
            validator: ({ mode: mode })=>{}
        }, overlayNode);
    };
    // =========================== zIndex ============================
    const [zIndex, contextZIndex] = (0, $15dbea5a917a06ef$export$3e7906d4075187a4)('Dropdown', mergedRootStyles.zIndex);
    // ============================ Render ============================
    let renderNode = /*#__PURE__*/ $hO8yS.createElement((0, $d0c9855484e57e9e$export$2e2bcd8739ae039), {
        alignPoint: alignPoint,
        ...(0, $f4cf9c2e27c0ac8d$export$2e2bcd8739ae039)(props, [
            'rootClassName',
            'onOpenChange'
        ]),
        mouseEnterDelay: mouseEnterDelay,
        mouseLeaveDelay: mouseLeaveDelay,
        visible: mergedOpen,
        builtinPlacements: builtinPlacements,
        arrow: !!arrow,
        overlayClassName: overlayClassNameCustomized,
        prefixCls: prefixCls,
        getPopupContainer: getPopupContainer || getContextPopupContainer,
        transitionName: memoTransitionName,
        trigger: triggerActions,
        overlay: renderOverlay,
        placement: memoPlacement,
        onVisibleChange: onInnerOpenChange,
        overlayStyle: {
            ...mergedRootStyles,
            zIndex: zIndex
        },
        autoDestroy: destroyOnHidden ?? destroyPopupOnHide
    }, popupTrigger);
    if (zIndex) renderNode = /*#__PURE__*/ $hO8yS.createElement((0, $eb222ded4c5a3427$export$2e2bcd8739ae039).Provider, {
        value: contextZIndex
    }, renderNode);
    return renderNode;
};
// We don't care debug panel
const $b3687c0712e4a76e$var$PurePanel = (0, $63c4642dc3601d57$export$2e2bcd8739ae039)($b3687c0712e4a76e$var$Dropdown, 'align', undefined, 'dropdown', (prefixCls)=>prefixCls);
/* istanbul ignore next */ const $b3687c0712e4a76e$var$WrapPurePanel = (props)=>/*#__PURE__*/ $hO8yS.createElement($b3687c0712e4a76e$var$PurePanel, {
        ...props
    }, /*#__PURE__*/ $hO8yS.createElement("span", null));
$b3687c0712e4a76e$var$Dropdown._InternalPanelDoNotUseOrYouWillBeFired = $b3687c0712e4a76e$var$WrapPurePanel;
var $b3687c0712e4a76e$export$2e2bcd8739ae039 = $b3687c0712e4a76e$var$Dropdown;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");





parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");


function $a7ee95763d0ac8db$export$f5153c3888a6824e(size) {
    return [
        'small',
        'middle',
        'large'
    ].includes(size);
}
function $a7ee95763d0ac8db$export$1b502d0a9135d42b(size) {
    if (!size) // The case of size = 0 is deliberately excluded here, because the default value of the gap attribute in CSS is 0, so if the user passes 0 in, we can directly ignore it.
    return false;
    return typeof size === 'number' && !Number.isNaN(size);
}








var $N3oW3 = parcelRequire("N3oW3");


const $597dc4581bd08a1e$var$_InputStatuses = [
    'warning',
    'error',
    '',
    'success',
    'validating'
];
const $597dc4581bd08a1e$export$b08e7b47149942a2 = (prefixCls, status, hasFeedback)=>{
    return (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)({
        [`${prefixCls}-status-success`]: status === 'success',
        [`${prefixCls}-status-warning`]: status === 'warning',
        [`${prefixCls}-status-error`]: status === 'error',
        [`${prefixCls}-status-validating`]: status === 'validating',
        [`${prefixCls}-has-feedback`]: hasFeedback
    });
};
const $597dc4581bd08a1e$export$314e193082d7ba49 = (contextStatus, customStatus)=>customStatus || contextStatus;






const $d331d0c8ca382edb$var$genSpaceAddonStyle = (token)=>{
    const { componentCls: componentCls, borderRadius: borderRadius, paddingSM: paddingSM, colorBorder: colorBorder, paddingXS: paddingXS, fontSizeLG: fontSizeLG, fontSizeSM: fontSizeSM, borderRadiusLG: borderRadiusLG, borderRadiusSM: borderRadiusSM, colorBgContainerDisabled: colorBgContainerDisabled, lineWidth: lineWidth } = token;
    return {
        [componentCls]: [
            // ==========================================================
            // ==                         Base                         ==
            // ==========================================================
            {
                display: 'inline-flex',
                alignItems: 'center',
                gap: 0,
                paddingInline: paddingSM,
                margin: 0,
                borderWidth: lineWidth,
                borderStyle: 'solid',
                borderRadius: borderRadius,
                '&:hover': {
                    zIndex: 0
                },
                [`&${componentCls}-disabled`]: {
                    color: token.colorTextDisabled
                },
                '&-large': {
                    fontSize: fontSizeLG,
                    borderRadius: borderRadiusLG
                },
                '&-small': {
                    paddingInline: paddingXS,
                    borderRadius: borderRadiusSM,
                    fontSize: fontSizeSM
                },
                '&-compact-last-item': {
                    borderEndStartRadius: 0,
                    borderStartStartRadius: 0
                },
                '&-compact-first-item': {
                    borderEndEndRadius: 0,
                    borderStartEndRadius: 0
                },
                '&-compact-item:not(:first-child):not(:last-child)': {
                    borderRadius: 0
                },
                '&-compact-item:not(:last-child)': {
                    borderInlineEndWidth: 0
                },
                '&-compact-item:not(:first-child)': {
                    borderInlineStartWidth: 0
                }
            },
            // ==========================================================
            // ==                       Variants                       ==
            // ==========================================================
            {
                '--space-addon-border-color': colorBorder,
                '--space-addon-background': colorBgContainerDisabled,
                // Filled
                '--space-addon-border-color-outlined': colorBorder,
                '--space-addon-background-filled': colorBgContainerDisabled,
                borderColor: 'var(--space-addon-border-color)',
                background: 'var(--space-addon-background)',
                // ======================= Outlined =======================
                '&-variant-outlined': {
                    '--space-addon-border-color': 'var(--space-addon-border-color-outlined)'
                },
                // ======================== Filled ========================
                '&-variant-filled': {
                    '--space-addon-border-color': 'transparent',
                    '--space-addon-background': 'var(--space-addon-background-filled)',
                    // Disabled
                    [`&${componentCls}-disabled`]: {
                        '--space-addon-border-color': colorBorder,
                        '--space-addon-background': colorBgContainerDisabled
                    }
                },
                // ====================== Borderless ======================
                '&-variant-borderless': {
                    border: 'none',
                    background: 'transparent'
                },
                // ====================== Underlined ======================
                '&-variant-underlined': {
                    border: 'none',
                    background: 'transparent'
                }
            },
            // ==========================================================
            // ==                        Status                        ==
            // ==========================================================
            {
                '&-status-error': {
                    '--space-addon-border-color-outlined': token.colorError,
                    '--space-addon-background-filled': token.colorErrorBg,
                    color: token.colorError
                },
                '&-status-warning': {
                    '--space-addon-border-color-outlined': token.colorWarning,
                    '--space-addon-background-filled': token.colorWarningBg,
                    color: token.colorWarning
                }
            }
        ]
    };
};
var // ============================== Export ==============================
$d331d0c8ca382edb$export$2e2bcd8739ae039 = (0, $d4a2dc313c4d90a4$export$51ec95de45185b42)([
    'Space',
    'Addon'
], (token)=>[
        $d331d0c8ca382edb$var$genSpaceAddonStyle(token),
        (0, $ebe50cd0ffe9b635$export$b1208b23589b4b73)(token, {
            focus: false
        })
    ]);


"use client";
const $5568adc20ab84851$var$SpaceAddon = /*#__PURE__*/ (0, $N3oW3.default).forwardRef((props, ref)=>{
    const { className: className, children: children, style: style, prefixCls: customizePrefixCls, variant: variant = 'outlined', disabled: disabled, status: status, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, direction: directionConfig } = (0, $N3oW3.default).useContext((0, $dd01e2f5a4b8605d$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('space-addon', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $d331d0c8ca382edb$export$2e2bcd8739ae039)(prefixCls);
    const { compactItemClassnames: compactItemClassnames, compactSize: compactSize } = (0, $085e8dc0a3d19960$export$cd8cf9d7bab8dd4)(prefixCls, directionConfig);
    const statusCls = (0, $597dc4581bd08a1e$export$b08e7b47149942a2)(prefixCls, status);
    const classes = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, hashId, compactItemClassnames, cssVarCls, `${prefixCls}-variant-${variant}`, statusCls, {
        [`${prefixCls}-${compactSize}`]: compactSize,
        [`${prefixCls}-disabled`]: disabled
    }, className);
    return /*#__PURE__*/ (0, $N3oW3.default).createElement("div", {
        ref: ref,
        className: classes,
        style: style,
        ...restProps
    }, children);
});
var $5568adc20ab84851$export$2e2bcd8739ae039 = $5568adc20ab84851$var$SpaceAddon;



var $N3oW3 = parcelRequire("N3oW3");
const $7e190a884007ddce$export$853f607fd5cc208b = /*#__PURE__*/ (0, $N3oW3.default).createContext({
    latestIndex: 0
});
const $7e190a884007ddce$export$2bbf36e6e96e17f9 = $7e190a884007ddce$export$853f607fd5cc208b.Provider;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");



"use client";
const $2efc48bb86dc0403$var$Item = (props)=>{
    const { className: className, prefix: prefix, index: index, children: children, separator: separator, style: style, classNames: classNames, styles: styles } = props;
    const { latestIndex: latestIndex } = $32rMB.useContext((0, $7e190a884007ddce$export$853f607fd5cc208b));
    if (!(0, $95ac4c3d4339216e$export$2e2bcd8739ae039)(children)) return null;
    return /*#__PURE__*/ $hO8yS.createElement($hO8yS.Fragment, null, /*#__PURE__*/ $hO8yS.createElement("div", {
        className: className,
        style: style
    }, children), index < latestIndex && separator && /*#__PURE__*/ $hO8yS.createElement("span", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefix}-item-separator`, classNames.separator),
        style: styles.separator
    }, separator));
};
var $2efc48bb86dc0403$export$2e2bcd8739ae039 = $2efc48bb86dc0403$var$Item;



const $524518f3587c2eb5$var$genSpaceStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    return {
        [componentCls]: {
            display: 'inline-flex',
            '&-rtl': {
                direction: 'rtl'
            },
            '&-vertical': {
                flexDirection: 'column'
            },
            '&-align': {
                flexDirection: 'column',
                '&-center': {
                    alignItems: 'center'
                },
                '&-start': {
                    alignItems: 'flex-start'
                },
                '&-end': {
                    alignItems: 'flex-end'
                },
                '&-baseline': {
                    alignItems: 'baseline'
                }
            },
            [`${componentCls}-item:empty`]: {
                display: 'none'
            },
            // https://github.com/ant-design/ant-design/issues/47875
            [`${componentCls}-item > ${antCls}-badge-not-a-wrapper:only-child`]: {
                display: 'block'
            }
        }
    };
};
const $524518f3587c2eb5$var$genSpaceGapStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: {
            '&-gap-row-small': {
                rowGap: token.spaceGapSmallSize
            },
            '&-gap-row-middle': {
                rowGap: token.spaceGapMiddleSize
            },
            '&-gap-row-large': {
                rowGap: token.spaceGapLargeSize
            },
            '&-gap-col-small': {
                columnGap: token.spaceGapSmallSize
            },
            '&-gap-col-middle': {
                columnGap: token.spaceGapMiddleSize
            },
            '&-gap-col-large': {
                columnGap: token.spaceGapLargeSize
            }
        }
    };
};
const $524518f3587c2eb5$export$9ca1be8807fe0675 = ()=>({});
var $524518f3587c2eb5$export$2e2bcd8739ae039 = (0, $d4a2dc313c4d90a4$export$51ec95de45185b42)('Space', (token)=>{
    const spaceToken = (0, $90c11ca6cb263fd9$export$4950aa0f605343fb)(token, {
        spaceGapSmallSize: token.paddingXS,
        spaceGapMiddleSize: token.padding,
        spaceGapLargeSize: token.paddingLG
    });
    return [
        $524518f3587c2eb5$var$genSpaceStyle(spaceToken),
        $524518f3587c2eb5$var$genSpaceGapStyle(spaceToken)
    ];
}, ()=>({}), {
    // Space component don't apply extra font style
    // https://github.com/ant-design/ant-design/issues/40315
    resetStyle: false
});


"use client";
const $afba98610eca1bae$var$InternalSpace = /*#__PURE__*/ $N3oW3.forwardRef((props, ref)=>{
    const { getPrefixCls: getPrefixCls, direction: directionConfig, size: contextSize, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $dd01e2f5a4b8605d$export$46f4bd6436a25a31)('space');
    const { size: size = contextSize ?? 'small', align: align, className: className, rootClassName: rootClassName, children: children, direction: direction, orientation: orientation, prefixCls: customizePrefixCls, split: split, separator: separator, style: style, vertical: vertical, wrap: wrap = false, classNames: classNames, styles: styles, ...restProps } = props;
    const [horizontalSize, verticalSize] = Array.isArray(size) ? size : [
        size,
        size
    ];
    const isPresetVerticalSize = (0, $a7ee95763d0ac8db$export$f5153c3888a6824e)(verticalSize);
    const isPresetHorizontalSize = (0, $a7ee95763d0ac8db$export$f5153c3888a6824e)(horizontalSize);
    const isValidVerticalSize = (0, $a7ee95763d0ac8db$export$1b502d0a9135d42b)(verticalSize);
    const isValidHorizontalSize = (0, $a7ee95763d0ac8db$export$1b502d0a9135d42b)(horizontalSize);
    const childNodes = (0, $a60ede783f74e6a9$export$2e2bcd8739ae039)(children, {
        keepEmpty: true
    });
    const [mergedOrientation, mergedVertical] = (0, $2c11327ae0ff8899$export$550084c67147f6c4)(orientation, vertical, direction);
    const mergedAlign = align === undefined && !mergedVertical ? 'center' : align;
    const mergedSeparator = separator ?? split;
    const prefixCls = getPrefixCls('space', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $524518f3587c2eb5$export$2e2bcd8739ae039)(prefixCls);
    // =========== Merged Props for Semantic ==========
    const mergedProps = {
        ...props,
        size: size,
        orientation: mergedOrientation,
        align: mergedAlign
    };
    const [mergedClassNames, mergedStyles] = (0, $4dcf69d8c3d6df5c$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    const rootClassNames = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, contextClassName, hashId, `${prefixCls}-${mergedOrientation}`, {
        [`${prefixCls}-rtl`]: directionConfig === 'rtl',
        [`${prefixCls}-align-${mergedAlign}`]: mergedAlign,
        [`${prefixCls}-gap-row-${verticalSize}`]: isPresetVerticalSize,
        [`${prefixCls}-gap-col-${horizontalSize}`]: isPresetHorizontalSize
    }, className, rootClassName, cssVarCls, mergedClassNames.root);
    const itemClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-item`, mergedClassNames.item);
    // Calculate latest one
    const renderedItems = childNodes.map((child, i)=>{
        const key = child?.key || `${itemClassName}-${i}`;
        return /*#__PURE__*/ $hO8yS.createElement((0, $2efc48bb86dc0403$export$2e2bcd8739ae039), {
            prefix: prefixCls,
            classNames: mergedClassNames,
            styles: mergedStyles,
            className: itemClassName,
            key: key,
            index: i,
            separator: mergedSeparator,
            style: mergedStyles.item
        }, child);
    });
    var deprecatedName, newName;
    const memoizedSpaceContext = $32rMB.useMemo(()=>{
        const calcLatestIndex = childNodes.reduce((latest, child, i)=>(0, $95ac4c3d4339216e$export$2e2bcd8739ae039)(child) ? i : latest, 0);
        return {
            latestIndex: calcLatestIndex
        };
    }, [
        childNodes
    ]);
    // =========================== Render ===========================
    if (childNodes.length === 0) return null;
    const gapStyle = {};
    if (wrap) gapStyle.flexWrap = 'wrap';
    if (!isPresetHorizontalSize && isValidHorizontalSize) gapStyle.columnGap = horizontalSize;
    if (!isPresetVerticalSize && isValidVerticalSize) gapStyle.rowGap = verticalSize;
    return /*#__PURE__*/ $hO8yS.createElement("div", {
        ref: ref,
        className: rootClassNames,
        style: {
            ...gapStyle,
            ...mergedStyles.root,
            ...contextStyle,
            ...style
        },
        ...restProps
    }, /*#__PURE__*/ $hO8yS.createElement((0, $7e190a884007ddce$export$2bbf36e6e96e17f9), {
        value: memoizedSpaceContext
    }, renderedItems));
});
const $afba98610eca1bae$var$Space = $afba98610eca1bae$var$InternalSpace;
$afba98610eca1bae$var$Space.Compact = (0, $085e8dc0a3d19960$export$2e2bcd8739ae039);
$afba98610eca1bae$var$Space.Addon = (0, $5568adc20ab84851$export$2e2bcd8739ae039);
var $afba98610eca1bae$export$2e2bcd8739ae039 = $afba98610eca1bae$var$Space;




"use client";
/** @deprecated Please use Space.Compact + Dropdown + Button instead */ const $7b0103ec917e3d29$var$DropdownButton = (props)=>{
    const { getPopupContainer: getContextPopupContainer, getPrefixCls: getPrefixCls, direction: direction } = $32rMB.useContext((0, $dd01e2f5a4b8605d$export$a92f85ab3e9ad68b));
    const { prefixCls: customizePrefixCls, type: type = 'default', danger: danger, disabled: disabled, loading: loading, onClick: onClick, htmlType: htmlType, children: children, className: className, menu: menu, arrow: arrow, autoFocus: autoFocus, trigger: trigger, align: align, open: open, onOpenChange: onOpenChange, placement: placement, getPopupContainer: getPopupContainer, href: href, icon: icon = /*#__PURE__*/ $hO8yS.createElement((0, $391e9221407e00e5$export$2e2bcd8739ae039), null), title: title, buttonsRender: buttonsRender = (buttons)=>buttons, mouseEnterDelay: mouseEnterDelay, mouseLeaveDelay: mouseLeaveDelay, overlayClassName: overlayClassName, overlayStyle: overlayStyle, destroyOnHidden: destroyOnHidden, destroyPopupOnHide: destroyPopupOnHide, dropdownRender: dropdownRender, popupRender: popupRender, ...restProps } = props;
    const prefixCls = getPrefixCls('dropdown', customizePrefixCls);
    const buttonPrefixCls = `${prefixCls}-button`;
    const mergedPopupRender = popupRender || dropdownRender;
    const dropdownProps = {
        menu: menu,
        arrow: arrow,
        autoFocus: autoFocus,
        align: align,
        disabled: disabled,
        trigger: disabled ? [] : trigger,
        onOpenChange: onOpenChange,
        getPopupContainer: getPopupContainer || getContextPopupContainer,
        mouseEnterDelay: mouseEnterDelay,
        mouseLeaveDelay: mouseLeaveDelay,
        classNames: {
            root: overlayClassName
        },
        styles: {
            root: overlayStyle
        },
        destroyOnHidden: destroyOnHidden,
        popupRender: mergedPopupRender
    };
    const { compactSize: compactSize, compactItemClassnames: compactItemClassnames } = (0, $085e8dc0a3d19960$export$cd8cf9d7bab8dd4)(prefixCls, direction);
    const classes = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(buttonPrefixCls, compactItemClassnames, className);
    if ('destroyPopupOnHide' in props) dropdownProps.destroyPopupOnHide = destroyPopupOnHide;
    if ('open' in props) dropdownProps.open = open;
    if ('placement' in props) dropdownProps.placement = placement;
    else dropdownProps.placement = direction === 'rtl' ? 'bottomLeft' : 'bottomRight';
    const leftButton = /*#__PURE__*/ $hO8yS.createElement((0, $9632ad3149894c43$export$2e2bcd8739ae039), {
        type: type,
        danger: danger,
        disabled: disabled,
        loading: loading,
        onClick: onClick,
        htmlType: htmlType,
        href: href,
        title: title
    }, children);
    const rightButton = /*#__PURE__*/ $hO8yS.createElement((0, $9632ad3149894c43$export$2e2bcd8739ae039), {
        type: type,
        danger: danger,
        icon: icon
    });
    const [leftButtonToRender, rightButtonToRender] = buttonsRender([
        leftButton,
        rightButton
    ]);
    return /*#__PURE__*/ $hO8yS.createElement((0, $afba98610eca1bae$export$2e2bcd8739ae039).Compact, {
        className: classes,
        size: compactSize,
        block: true,
        ...restProps
    }, leftButtonToRender, /*#__PURE__*/ $hO8yS.createElement((0, $b3687c0712e4a76e$export$2e2bcd8739ae039), {
        ...dropdownProps
    }, rightButtonToRender));
};
$7b0103ec917e3d29$var$DropdownButton.__ANT_BUTTON = true;
var $7b0103ec917e3d29$export$2e2bcd8739ae039 = $7b0103ec917e3d29$var$DropdownButton;


"use client";
const $38b79a6ce8fc3a86$var$Dropdown = (0, $b3687c0712e4a76e$export$2e2bcd8739ae039);
/** @deprecated Please use Space.Compact + Dropdown + Button instead */ $38b79a6ce8fc3a86$var$Dropdown.Button = (0, $7b0103ec917e3d29$export$2e2bcd8739ae039);
var $38b79a6ce8fc3a86$export$2e2bcd8739ae039 = $38b79a6ce8fc3a86$var$Dropdown;



parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");






parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
function $dae63c7eec57a29b$export$2e2bcd8739ae039(value) {
    const [cacheValue, setCacheValue] = $32rMB.useState(value);
    $32rMB.useEffect(()=>{
        const timeout = setTimeout(()=>{
            setCacheValue(value);
        }, value.length ? 0 : 10);
        return ()=>{
            clearTimeout(timeout);
        };
    }, [
        value
    ]);
    return cacheValue;
}






const $e7381ea37c3caca5$var$genFormValidateMotionStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const helpCls = `${componentCls}-show-help`;
    const helpItemCls = `${componentCls}-show-help-item`;
    return {
        [helpCls]: {
            // Explain holder
            transition: `opacity ${token.motionDurationFast} ${token.motionEaseInOut}`,
            '&-appear, &-enter': {
                opacity: 0,
                '&-active': {
                    opacity: 1
                }
            },
            '&-leave': {
                opacity: 1,
                '&-active': {
                    opacity: 0
                }
            },
            // Explain
            [helpItemCls]: {
                overflow: 'hidden',
                transition: `height ${token.motionDurationFast} ${token.motionEaseInOut},
                     opacity ${token.motionDurationFast} ${token.motionEaseInOut},
                     transform ${token.motionDurationFast} ${token.motionEaseInOut} !important`,
                [`&${helpItemCls}-appear, &${helpItemCls}-enter`]: {
                    transform: `translateY(-5px)`,
                    opacity: 0,
                    '&-active': {
                        transform: 'translateY(0)',
                        opacity: 1
                    }
                },
                [`&${helpItemCls}-leave-active`]: {
                    transform: `translateY(-5px)`
                }
            }
        }
    };
};
var $e7381ea37c3caca5$export$2e2bcd8739ae039 = $e7381ea37c3caca5$var$genFormValidateMotionStyle;


const $e81ef03cbd337bd2$var$resetForm = (token)=>({
        legend: {
            display: 'block',
            width: '100%',
            marginBottom: token.marginLG,
            padding: 0,
            color: token.colorTextDescription,
            fontSize: token.fontSizeLG,
            lineHeight: 'inherit',
            border: 0,
            borderBottom: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
        },
        'input[type="search"]': {
            boxSizing: 'border-box'
        },
        // Position radios and checkboxes better
        'input[type="radio"], input[type="checkbox"]': {
            lineHeight: 'normal'
        },
        'input[type="file"]': {
            display: 'block'
        },
        // Make range inputs behave like textual form controls
        'input[type="range"]': {
            display: 'block',
            width: '100%'
        },
        // Make multiple select elements height not fixed
        'select[multiple], select[size]': {
            height: 'auto'
        },
        // Focus for file, radio, and checkbox
        [`input[type='file']:focus,
  input[type='radio']:focus,
  input[type='checkbox']:focus`]: {
            outline: 0,
            boxShadow: `0 0 0 ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.controlOutlineWidth)} ${token.controlOutline}`
        },
        // Adjust output element
        output: {
            display: 'block',
            paddingTop: 15,
            color: token.colorText,
            fontSize: token.fontSize,
            lineHeight: token.lineHeight
        }
    });
const $e81ef03cbd337bd2$var$genFormSize = (token, height)=>{
    const { formItemCls: formItemCls } = token;
    return {
        [formItemCls]: {
            [`${formItemCls}-label > label`]: {
                height: height
            },
            [`${formItemCls}-control-input`]: {
                minHeight: height
            }
        }
    };
};
const $e81ef03cbd337bd2$var$genFormStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [token.componentCls]: {
            ...(0, $2f353af2b0f7600b$export$23997c3e44cc1c59)(token),
            ...$e81ef03cbd337bd2$var$resetForm(token),
            [`${componentCls}-text`]: {
                display: 'inline-block',
                paddingInlineEnd: token.paddingSM
            },
            // ================================================================
            // =                             Size                             =
            // ================================================================
            '&-small': {
                ...$e81ef03cbd337bd2$var$genFormSize(token, token.controlHeightSM)
            },
            '&-large': {
                ...$e81ef03cbd337bd2$var$genFormSize(token, token.controlHeightLG)
            }
        }
    };
};
const $e81ef03cbd337bd2$var$genFormItemStyle = (token)=>{
    const { formItemCls: formItemCls, iconCls: iconCls, rootPrefixCls: rootPrefixCls, antCls: antCls, labelRequiredMarkColor: labelRequiredMarkColor, labelColor: labelColor, labelFontSize: labelFontSize, labelHeight: labelHeight, labelColonMarginInlineStart: labelColonMarginInlineStart, labelColonMarginInlineEnd: labelColonMarginInlineEnd, itemMarginBottom: itemMarginBottom } = token;
    return {
        [formItemCls]: {
            ...(0, $2f353af2b0f7600b$export$23997c3e44cc1c59)(token),
            marginBottom: itemMarginBottom,
            verticalAlign: 'top',
            '&-with-help': {
                transition: 'none'
            },
            [`&-hidden,
        &-hidden${antCls}-row`]: {
                // https://github.com/ant-design/ant-design/issues/26141
                display: 'none'
            },
            '&-has-warning': {
                [`${formItemCls}-split`]: {
                    color: token.colorError
                }
            },
            '&-has-error': {
                [`${formItemCls}-split`]: {
                    color: token.colorWarning
                }
            },
            // ==============================================================
            // =                            Label                           =
            // ==============================================================
            [`${formItemCls}-label`]: {
                flexGrow: 0,
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textAlign: 'end',
                verticalAlign: 'middle',
                '&-left': {
                    textAlign: 'start'
                },
                '&-wrap': {
                    overflow: 'unset',
                    lineHeight: token.lineHeight,
                    whiteSpace: 'unset',
                    '> label': {
                        verticalAlign: 'middle',
                        textWrap: 'balance'
                    }
                },
                '> label': {
                    position: 'relative',
                    display: 'inline-flex',
                    alignItems: 'center',
                    maxWidth: '100%',
                    height: labelHeight,
                    color: labelColor,
                    fontSize: labelFontSize,
                    [`> ${iconCls}`]: {
                        fontSize: token.fontSize,
                        verticalAlign: 'top'
                    },
                    [`&${formItemCls}-required`]: {
                        '&::before': {
                            display: 'inline-block',
                            marginInlineEnd: token.marginXXS,
                            color: labelRequiredMarkColor,
                            fontSize: token.fontSize,
                            fontFamily: 'SimSun, sans-serif',
                            lineHeight: 1,
                            content: '"*"'
                        },
                        [`&${formItemCls}-required-mark-hidden, &${formItemCls}-required-mark-optional`]: {
                            '&::before': {
                                display: 'none'
                            }
                        }
                    },
                    // Optional mark
                    [`${formItemCls}-optional`]: {
                        display: 'inline-block',
                        marginInlineStart: token.marginXXS,
                        color: token.colorTextDescription,
                        [`&${formItemCls}-required-mark-hidden`]: {
                            display: 'none'
                        }
                    },
                    // Optional mark
                    [`${formItemCls}-tooltip`]: {
                        color: token.colorTextDescription,
                        cursor: 'help',
                        writingMode: 'horizontal-tb',
                        marginInlineStart: token.marginXXS
                    },
                    '&::after': {
                        content: '":"',
                        position: 'relative',
                        marginBlock: 0,
                        marginInlineStart: labelColonMarginInlineStart,
                        marginInlineEnd: labelColonMarginInlineEnd
                    },
                    [`&${formItemCls}-no-colon::after`]: {
                        content: '"\\a0"'
                    }
                }
            },
            // ==============================================================
            // =                            Input                           =
            // ==============================================================
            [`${formItemCls}-control`]: {
                ['--ant-display']: 'flex',
                flexDirection: 'column',
                flexGrow: 1,
                [`&:first-child:not([class^="'${rootPrefixCls}-col-'"]):not([class*="' ${rootPrefixCls}-col-'"])`]: {
                    width: '100%'
                },
                '&-input': {
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    minHeight: token.controlHeight,
                    '&-content': {
                        flex: 'auto',
                        maxWidth: '100%',
                        // Fix https://github.com/ant-design/ant-design/issues/54042
                        // Remove impact of whitespaces
                        [`&:has(> ${antCls}-switch:only-child, > ${antCls}-rate:only-child)`]: {
                            display: 'flex',
                            alignItems: 'center'
                        }
                    }
                }
            },
            // ==============================================================
            // =                           Explain                          =
            // ==============================================================
            [formItemCls]: {
                '&-additional': {
                    display: 'flex',
                    flexDirection: 'column'
                },
                '&-explain, &-extra': {
                    clear: 'both',
                    color: token.colorTextDescription,
                    fontSize: token.fontSize,
                    lineHeight: token.lineHeight
                },
                '&-explain-connected': {
                    width: '100%'
                },
                '&-extra': {
                    minHeight: token.controlHeightSM,
                    transition: `color ${token.motionDurationMid} ${token.motionEaseOut}` // sync input color transition
                },
                '&-explain': {
                    '&-error': {
                        color: token.colorError
                    },
                    '&-warning': {
                        color: token.colorWarning
                    }
                }
            },
            [`&-with-help ${formItemCls}-explain`]: {
                height: 'auto',
                opacity: 1
            },
            // ==============================================================
            // =                        Feedback Icon                       =
            // ==============================================================
            [`${formItemCls}-feedback-icon`]: {
                fontSize: token.fontSize,
                textAlign: 'center',
                visibility: 'visible',
                animationName: (0, $9783f6e7d4c63d86$export$3b71758b3ed5255f),
                animationDuration: token.motionDurationMid,
                animationTimingFunction: token.motionEaseOutBack,
                pointerEvents: 'none',
                '&-success': {
                    color: token.colorSuccess
                },
                '&-error': {
                    color: token.colorError
                },
                '&-warning': {
                    color: token.colorWarning
                },
                '&-validating': {
                    color: token.colorPrimary
                }
            }
        }
    };
};
const $e81ef03cbd337bd2$var$makeVerticalLayoutLabel = (token)=>({
        padding: token.verticalLabelPadding,
        margin: token.verticalLabelMargin,
        whiteSpace: 'initial',
        textAlign: 'start',
        '> label': {
            margin: 0,
            '&::after': {
                // https://github.com/ant-design/ant-design/issues/43538
                visibility: 'hidden'
            }
        }
    });
const $e81ef03cbd337bd2$var$genHorizontalStyle = (token)=>{
    const { antCls: antCls, formItemCls: formItemCls } = token;
    return {
        [`${formItemCls}-horizontal`]: {
            [`${formItemCls}-label`]: {
                flexGrow: 0
            },
            [`${formItemCls}-control`]: {
                flex: '1 1 0',
                // https://github.com/ant-design/ant-design/issues/32777
                // https://github.com/ant-design/ant-design/issues/33773
                minWidth: 0
            },
            // Do not change this to `ant-col-24`! `-24` match all the responsive rules
            // https://github.com/ant-design/ant-design/issues/32980
            // https://github.com/ant-design/ant-design/issues/34903
            // https://github.com/ant-design/ant-design/issues/44538
            [`${formItemCls}-label[class$='-24'], ${formItemCls}-label[class*='-24 ']`]: {
                [`& + ${formItemCls}-control`]: {
                    minWidth: 'unset'
                }
            },
            [`${antCls}-col-24${formItemCls}-label,
        ${antCls}-col-xl-24${formItemCls}-label`]: $e81ef03cbd337bd2$var$makeVerticalLayoutLabel(token)
        }
    };
};
const $e81ef03cbd337bd2$var$genInlineStyle = (token)=>{
    const { componentCls: componentCls, formItemCls: formItemCls, inlineItemMarginBottom: inlineItemMarginBottom } = token;
    return {
        [`${componentCls}-inline`]: {
            display: 'flex',
            flexWrap: 'wrap',
            [`${formItemCls}-inline`]: {
                flex: 'none',
                marginInlineEnd: token.margin,
                marginBottom: inlineItemMarginBottom,
                '&-row': {
                    flexWrap: 'nowrap'
                },
                [`> ${formItemCls}-label,
        > ${formItemCls}-control`]: {
                    display: 'inline-block',
                    verticalAlign: 'top'
                },
                [`> ${formItemCls}-label`]: {
                    flex: 'none'
                },
                [`${componentCls}-text`]: {
                    display: 'inline-block'
                },
                [`${formItemCls}-has-feedback`]: {
                    display: 'inline-block'
                }
            }
        }
    };
};
const $e81ef03cbd337bd2$var$makeVerticalLayout = (token)=>{
    const { componentCls: componentCls, formItemCls: formItemCls, rootPrefixCls: rootPrefixCls } = token;
    return {
        [`${formItemCls} ${formItemCls}-label`]: $e81ef03cbd337bd2$var$makeVerticalLayoutLabel(token),
        // ref: https://github.com/ant-design/ant-design/issues/45122
        [`${componentCls}:not(${componentCls}-inline)`]: {
            [formItemCls]: {
                flexWrap: 'wrap',
                [`${formItemCls}-label, ${formItemCls}-control`]: {
                    // When developer pass `xs: { span }`,
                    // It should follow the `xs` screen config
                    // ref: https://github.com/ant-design/ant-design/issues/44386
                    [`&:not([class*=" ${rootPrefixCls}-col-xs"])`]: {
                        flex: '0 0 100%',
                        maxWidth: '100%'
                    }
                }
            }
        }
    };
};
const $e81ef03cbd337bd2$var$genVerticalStyle = (token)=>{
    const { componentCls: componentCls, formItemCls: formItemCls, antCls: antCls } = token;
    return {
        [`${formItemCls}-vertical`]: {
            [`${formItemCls}-row`]: {
                flexDirection: 'column'
            },
            [`${formItemCls}-label > label`]: {
                height: 'auto'
            },
            [`${formItemCls}-control`]: {
                width: '100%'
            },
            [`${formItemCls}-label,
        ${antCls}-col-24${formItemCls}-label,
        ${antCls}-col-xl-24${formItemCls}-label`]: $e81ef03cbd337bd2$var$makeVerticalLayoutLabel(token)
        },
        [`@media (max-width: ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.screenXSMax)})`]: [
            $e81ef03cbd337bd2$var$makeVerticalLayout(token),
            {
                [componentCls]: {
                    [`${formItemCls}:not(${formItemCls}-horizontal)`]: {
                        [`${antCls}-col-xs-24${formItemCls}-label`]: $e81ef03cbd337bd2$var$makeVerticalLayoutLabel(token)
                    }
                }
            }
        ],
        [`@media (max-width: ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.screenSMMax)})`]: {
            [componentCls]: {
                [`${formItemCls}:not(${formItemCls}-horizontal)`]: {
                    [`${antCls}-col-sm-24${formItemCls}-label`]: $e81ef03cbd337bd2$var$makeVerticalLayoutLabel(token)
                }
            }
        },
        [`@media (max-width: ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.screenMDMax)})`]: {
            [componentCls]: {
                [`${formItemCls}:not(${formItemCls}-horizontal)`]: {
                    [`${antCls}-col-md-24${formItemCls}-label`]: $e81ef03cbd337bd2$var$makeVerticalLayoutLabel(token)
                }
            }
        },
        [`@media (max-width: ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.screenLGMax)})`]: {
            [componentCls]: {
                [`${formItemCls}:not(${formItemCls}-horizontal)`]: {
                    [`${antCls}-col-lg-24${formItemCls}-label`]: $e81ef03cbd337bd2$var$makeVerticalLayoutLabel(token)
                }
            }
        }
    };
};
const $e81ef03cbd337bd2$export$9ca1be8807fe0675 = (token)=>({
        labelRequiredMarkColor: token.colorError,
        labelColor: token.colorTextHeading,
        labelFontSize: token.fontSize,
        labelHeight: token.controlHeight,
        labelColonMarginInlineStart: token.marginXXS / 2,
        labelColonMarginInlineEnd: token.marginXS,
        itemMarginBottom: token.marginLG,
        verticalLabelPadding: `0 0 ${token.paddingXS}px`,
        verticalLabelMargin: 0,
        inlineItemMarginBottom: 0
    });
const $e81ef03cbd337bd2$export$362fb92a8f81bbf9 = (token, rootPrefixCls)=>{
    const formToken = (0, $90c11ca6cb263fd9$export$4950aa0f605343fb)(token, {
        formItemCls: `${token.componentCls}-item`,
        rootPrefixCls: rootPrefixCls
    });
    return formToken;
};
var $e81ef03cbd337bd2$export$2e2bcd8739ae039 = (0, $d4a2dc313c4d90a4$export$51ec95de45185b42)('Form', (token, { rootPrefixCls: rootPrefixCls })=>{
    const formToken = $e81ef03cbd337bd2$export$362fb92a8f81bbf9(token, rootPrefixCls);
    return [
        $e81ef03cbd337bd2$var$genFormStyle(formToken),
        $e81ef03cbd337bd2$var$genFormItemStyle(formToken),
        (0, $e7381ea37c3caca5$export$2e2bcd8739ae039)(formToken),
        $e81ef03cbd337bd2$var$genHorizontalStyle(formToken),
        $e81ef03cbd337bd2$var$genInlineStyle(formToken),
        $e81ef03cbd337bd2$var$genVerticalStyle(formToken),
        (0, $f58f14441a7cd550$export$2e2bcd8739ae039)(formToken),
        (0, $9783f6e7d4c63d86$export$3b71758b3ed5255f)
    ];
}, $e81ef03cbd337bd2$export$9ca1be8807fe0675, {
    // Let From style before the Grid
    // ref https://github.com/ant-design/ant-design/issues/44386
    order: -1000
});


"use client";
const $2ca4ef559a646f6d$var$EMPTY_LIST = [];
function $2ca4ef559a646f6d$var$toErrorEntity(error, prefix, errorStatus, index = 0) {
    return {
        key: typeof error === 'string' ? error : `${prefix}-${index}`,
        error: error,
        errorStatus: errorStatus
    };
}
const $2ca4ef559a646f6d$var$ErrorList = ({ help: help, helpStatus: helpStatus, errors: errors = $2ca4ef559a646f6d$var$EMPTY_LIST, warnings: warnings = $2ca4ef559a646f6d$var$EMPTY_LIST, className: rootClassName, fieldId: fieldId, onVisibleChanged: onVisibleChanged })=>{
    const { prefixCls: prefixCls } = $32rMB.useContext((0, $a1a112e4dddc1035$export$fb6582d3042cc879));
    const baseClassName = `${prefixCls}-item-explain`;
    const rootCls = (0, $54b1aecddbbbed4f$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $e81ef03cbd337bd2$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const collapseMotion = $32rMB.useMemo(()=>(0, $689b5af26dd3c1cd$export$2e2bcd8739ae039)(prefixCls), [
        prefixCls
    ]);
    // We have to debounce here again since somewhere use ErrorList directly still need no shaking
    // ref: https://github.com/ant-design/ant-design/issues/36336
    const debounceErrors = (0, $dae63c7eec57a29b$export$2e2bcd8739ae039)(errors);
    const debounceWarnings = (0, $dae63c7eec57a29b$export$2e2bcd8739ae039)(warnings);
    const fullKeyList = $32rMB.useMemo(()=>{
        if ((0, $95ac4c3d4339216e$export$2e2bcd8739ae039)(help)) return [
            $2ca4ef559a646f6d$var$toErrorEntity(help, 'help', helpStatus)
        ];
        return [].concat((0, $3746fb019e1f2ee5$export$2e2bcd8739ae039)(debounceErrors.map((error, index)=>$2ca4ef559a646f6d$var$toErrorEntity(error, 'error', 'error', index))), (0, $3746fb019e1f2ee5$export$2e2bcd8739ae039)(debounceWarnings.map((warning, index)=>$2ca4ef559a646f6d$var$toErrorEntity(warning, 'warning', 'warning', index))));
    }, [
        help,
        helpStatus,
        debounceErrors,
        debounceWarnings
    ]);
    const filledKeyFullKeyList = $32rMB.useMemo(()=>{
        const keysCount = {};
        fullKeyList.forEach(({ key: key })=>{
            keysCount[key] = (keysCount[key] || 0) + 1;
        });
        return fullKeyList.map((entity, index)=>({
                ...entity,
                key: keysCount[entity.key] > 1 ? `${entity.key}-fallback-${index}` : entity.key
            }));
    }, [
        fullKeyList
    ]);
    const helpProps = {};
    if (fieldId) helpProps.id = `${fieldId}_help`;
    return /*#__PURE__*/ $hO8yS.createElement((0, $db80a026d0a86ece$export$2e2bcd8739ae039), {
        motionDeadline: collapseMotion.motionDeadline,
        motionName: `${prefixCls}-show-help`,
        visible: !!filledKeyFullKeyList.length,
        onVisibleChanged: onVisibleChanged
    }, (holderProps)=>{
        const { className: holderClassName, style: holderStyle } = holderProps;
        return /*#__PURE__*/ $hO8yS.createElement("div", {
            ...helpProps,
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(baseClassName, holderClassName, cssVarCls, rootCls, rootClassName, hashId),
            style: holderStyle
        }, /*#__PURE__*/ $hO8yS.createElement((0, $24d87673fe580a7b$export$2e2bcd8739ae039), {
            keys: filledKeyFullKeyList,
            ...(0, $689b5af26dd3c1cd$export$2e2bcd8739ae039)(prefixCls),
            motionName: `${prefixCls}-show-help-item`,
            component: false
        }, (itemProps)=>{
            const { key: key, error: error, errorStatus: errorStatus, className: itemClassName, style: itemStyle } = itemProps;
            return /*#__PURE__*/ $hO8yS.createElement("div", {
                key: key,
                className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(itemClassName, {
                    [`${baseClassName}-${errorStatus}`]: errorStatus
                }),
                style: itemStyle
            }, error);
        }));
    });
};
var $2ca4ef559a646f6d$export$2e2bcd8739ae039 = $2ca4ef559a646f6d$var$ErrorList;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");









parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");


const $84afe414f2660b16$var$t = (t)=>"object" == typeof t && null != t && 1 === t.nodeType, $84afe414f2660b16$var$e = (t, e)=>(!e || "hidden" !== t) && "visible" !== t && "clip" !== t, $84afe414f2660b16$var$n = (t, n)=>{
    if (t.clientHeight < t.scrollHeight || t.clientWidth < t.scrollWidth) {
        const o = getComputedStyle(t, null);
        return $84afe414f2660b16$var$e(o.overflowY, n) || $84afe414f2660b16$var$e(o.overflowX, n) || ((t)=>{
            const e = ((t)=>{
                if (!t.ownerDocument || !t.ownerDocument.defaultView) return null;
                try {
                    return t.ownerDocument.defaultView.frameElement;
                } catch (t) {
                    return null;
                }
            })(t);
            return !!e && (e.clientHeight < t.scrollHeight || e.clientWidth < t.scrollWidth);
        })(t);
    }
    return !1;
}, $84afe414f2660b16$var$o = (t, e, n, o, l, r, i, s)=>r < t && i > e || r > t && i < e ? 0 : r <= t && s <= n || i >= e && s >= n ? r - t - o : i > e && s < n || r < t && s > n ? i - e + l : 0, $84afe414f2660b16$var$l = (t)=>{
    const e = t.parentElement;
    return null == e ? t.getRootNode().host || null : e;
}, $84afe414f2660b16$export$3b12cb22b12b954b = (e, r)=>{
    var i, s, d, h;
    if ("undefined" == typeof document) return [];
    const { scrollMode: c, block: f, inline: u, boundary: a, skipOverflowHiddenElements: g } = r, p = "function" == typeof a ? a : (t)=>t !== a;
    if (!$84afe414f2660b16$var$t(e)) throw new TypeError("Invalid target");
    const m = document.scrollingElement || document.documentElement, w = [];
    let W = e;
    for(; $84afe414f2660b16$var$t(W) && p(W);){
        if (W = $84afe414f2660b16$var$l(W), W === m) {
            w.push(W);
            break;
        }
        null != W && W === document.body && $84afe414f2660b16$var$n(W) && !$84afe414f2660b16$var$n(document.documentElement) || null != W && $84afe414f2660b16$var$n(W, g) && w.push(W);
    }
    const b = null != (s = null == (i = window.visualViewport) ? void 0 : i.width) ? s : innerWidth, H = null != (h = null == (d = window.visualViewport) ? void 0 : d.height) ? h : innerHeight, { scrollX: y, scrollY: M } = window, { height: v, width: E, top: x, right: C, bottom: I, left: R } = e.getBoundingClientRect(), { top: T, right: B, bottom: F, left: V } = ((t)=>{
        const e = window.getComputedStyle(t);
        return {
            top: parseFloat(e.scrollMarginTop) || 0,
            right: parseFloat(e.scrollMarginRight) || 0,
            bottom: parseFloat(e.scrollMarginBottom) || 0,
            left: parseFloat(e.scrollMarginLeft) || 0
        };
    })(e);
    let k = "start" === f || "nearest" === f ? x - T : "end" === f ? I + F : x + v / 2 - T + F, D = "center" === u ? R + E / 2 - V + B : "end" === u ? C + B : R - V;
    const L = [];
    for(let t = 0; t < w.length; t++){
        const e = w[t], { height: l, width: r, top: i, right: s, bottom: d, left: h } = e.getBoundingClientRect();
        if ("if-needed" === c && x >= 0 && R >= 0 && I <= H && C <= b && (e === m && !$84afe414f2660b16$var$n(e) || x >= i && I <= d && R >= h && C <= s)) return L;
        const a = getComputedStyle(e), g = parseInt(a.borderLeftWidth, 10), p = parseInt(a.borderTopWidth, 10), W = parseInt(a.borderRightWidth, 10), T = parseInt(a.borderBottomWidth, 10);
        let B = 0, F = 0;
        const V = "offsetWidth" in e ? e.offsetWidth - e.clientWidth - g - W : 0, S = "offsetHeight" in e ? e.offsetHeight - e.clientHeight - p - T : 0, X = "offsetWidth" in e ? 0 === e.offsetWidth ? 0 : r / e.offsetWidth : 0, Y = "offsetHeight" in e ? 0 === e.offsetHeight ? 0 : l / e.offsetHeight : 0;
        if (m === e) B = "start" === f ? k : "end" === f ? k - H : "nearest" === f ? $84afe414f2660b16$var$o(M, M + H, H, p, T, M + k, M + k + v, v) : k - H / 2, F = "start" === u ? D : "center" === u ? D - b / 2 : "end" === u ? D - b : $84afe414f2660b16$var$o(y, y + b, b, g, W, y + D, y + D + E, E), B = Math.max(0, B + M), F = Math.max(0, F + y);
        else {
            B = "start" === f ? k - i - p : "end" === f ? k - d + T + S : "nearest" === f ? $84afe414f2660b16$var$o(i, d, l, p, T + S, k, k + v, v) : k - (i + l / 2) + S / 2, F = "start" === u ? D - h - g : "center" === u ? D - (h + r / 2) + V / 2 : "end" === u ? D - s + W + V : $84afe414f2660b16$var$o(h, s, r, g, W + V, D, D + E, E);
            const { scrollLeft: t, scrollTop: n } = e;
            B = 0 === Y ? 0 : Math.max(0, Math.min(n + B / Y, e.scrollHeight - l / Y + S)), F = 0 === X ? 0 : Math.max(0, Math.min(t + F / X, e.scrollWidth - r / X + V)), k += n - B, D += t - F;
        }
        L.push({
            el: e,
            top: B,
            left: F
        });
    }
    return L;
};


const $d9106a5b9745d941$var$o = (t)=>!1 === t ? {
        block: "end",
        inline: "nearest"
    } : ((t)=>t === Object(t) && 0 !== Object.keys(t).length)(t) ? t : {
        block: "start",
        inline: "nearest"
    };
function $d9106a5b9745d941$export$2e2bcd8739ae039(e, r) {
    if (!e.isConnected || !((t)=>{
        let o = t;
        for(; o && o.parentNode;){
            if (o.parentNode === document) return !0;
            o = o.parentNode instanceof ShadowRoot ? o.parentNode.host : o.parentNode;
        }
        return !1;
    })(e)) return;
    const n = ((t)=>{
        const o = window.getComputedStyle(t);
        return {
            top: parseFloat(o.scrollMarginTop) || 0,
            right: parseFloat(o.scrollMarginRight) || 0,
            bottom: parseFloat(o.scrollMarginBottom) || 0,
            left: parseFloat(o.scrollMarginLeft) || 0
        };
    })(e);
    if (((t)=>"object" == typeof t && "function" == typeof t.behavior)(r)) return r.behavior((0, $84afe414f2660b16$export$3b12cb22b12b954b)(e, r));
    const l = "boolean" == typeof r || null == r ? void 0 : r.behavior;
    for (const { el: a, top: i, left: s } of (0, $84afe414f2660b16$export$3b12cb22b12b954b)(e, $d9106a5b9745d941$var$o(r))){
        const t = i - n.top + n.bottom, o = s - n.left + n.right;
        a.scroll({
            top: t,
            left: o,
            behavior: l
        });
    }
}


// form item name black list.  in form ,you can use form.id get the form item element.
// use object hasOwnProperty will get better performance if black list is longer.
const $64986a7e8b86a8b3$var$formItemNameBlackList = [
    'parentNode'
];
// default form item id prefix.
const $64986a7e8b86a8b3$var$defaultItemNamePrefixCls = 'form_item';
function $64986a7e8b86a8b3$export$45b10814cc054894(candidate) {
    if (candidate === undefined || candidate === false) return [];
    return Array.isArray(candidate) ? candidate : [
        candidate
    ];
}
function $64986a7e8b86a8b3$export$f4457e83c74ac000(namePath, formName) {
    if (!namePath.length) return undefined;
    const mergedId = namePath.join('_');
    if (formName) return `${formName}_${mergedId}`;
    const isIllegalName = $64986a7e8b86a8b3$var$formItemNameBlackList.includes(mergedId);
    return isIllegalName ? `${$64986a7e8b86a8b3$var$defaultItemNamePrefixCls}_${mergedId}` : mergedId;
}
function $64986a7e8b86a8b3$export$b70265791d2079d4(errors, warnings, meta, defaultValidateStatus, hasFeedback, validateStatus) {
    let status = defaultValidateStatus;
    if (validateStatus !== undefined) status = validateStatus;
    else if (meta.validating) status = 'validating';
    else if (errors.length) status = 'error';
    else if (warnings.length) status = 'warning';
    else if (meta.touched || hasFeedback && meta.validated) // success feedback should display when pass hasFeedback prop and current value is valid value
    status = 'success';
    return status;
}


function $33a442f1517960cf$export$368b682c15953eea(name) {
    const namePath = (0, $64986a7e8b86a8b3$export$45b10814cc054894)(name);
    return namePath.join('_');
}
function $33a442f1517960cf$var$getFieldDOMNode(name, wrapForm) {
    const field = wrapForm.getFieldInstance(name);
    const fieldDom = (0, $c1d2a04d2d287797$export$9aa546fdc20ae5b3)(field);
    if (fieldDom) return fieldDom;
    const fieldId = (0, $64986a7e8b86a8b3$export$f4457e83c74ac000)((0, $64986a7e8b86a8b3$export$45b10814cc054894)(name), wrapForm.__INTERNAL__.name);
    if (fieldId) return document.getElementById(fieldId);
}
function $33a442f1517960cf$export$2e2bcd8739ae039(form) {
    const [rcForm] = (0, $1547c3a057122952$export$2e2bcd8739ae039)();
    const itemsRef = $32rMB.useRef({});
    const wrapForm = $32rMB.useMemo(()=>form ?? {
            ...rcForm,
            __INTERNAL__: {
                itemRef: (name)=>(node)=>{
                        const namePathStr = $33a442f1517960cf$export$368b682c15953eea(name);
                        if (node) itemsRef.current[namePathStr] = node;
                        else delete itemsRef.current[namePathStr];
                    }
            },
            scrollToField: (name, options = {})=>{
                const { focus: focus, ...restOpt } = options;
                const node = $33a442f1517960cf$var$getFieldDOMNode(name, wrapForm);
                if (node) {
                    (0, $d9106a5b9745d941$export$2e2bcd8739ae039)(node, {
                        scrollMode: 'if-needed',
                        block: 'nearest',
                        ...restOpt
                    });
                    // Focus if scroll success
                    if (focus) wrapForm.focusField(name);
                }
            },
            focusField: (name)=>{
                const itemRef = wrapForm.getFieldInstance(name);
                if (typeof itemRef?.focus === 'function') itemRef.focus();
                else $33a442f1517960cf$var$getFieldDOMNode(name, wrapForm)?.focus?.();
            },
            getFieldInstance: (name)=>{
                const namePathStr = $33a442f1517960cf$export$368b682c15953eea(name);
                return itemsRef.current[namePathStr];
            }
        }, [
        form,
        rcForm
    ]);
    return [
        wrapForm
    ];
}





"use client";
const $92bef01064ba88da$var$InternalForm = (props, ref)=>{
    const contextDisabled = $32rMB.useContext((0, $ff4b4ddbf52ed41f$export$2e2bcd8739ae039));
    const { getPrefixCls: getPrefixCls, direction: direction, requiredMark: contextRequiredMark, colon: contextColon, scrollToFirstError: contextScrollToFirstError, className: contextClassName, style: contextStyle, styles: contextStyles, classNames: contextClassNames } = (0, $dd01e2f5a4b8605d$export$46f4bd6436a25a31)('form');
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, size: size, disabled: disabled = contextDisabled, form: form, colon: colon, labelAlign: labelAlign, labelWrap: labelWrap, labelCol: labelCol, wrapperCol: wrapperCol, layout: layout = 'horizontal', scrollToFirstError: scrollToFirstError, requiredMark: requiredMark, onFinishFailed: onFinishFailed, name: name, style: style, feedbackIcons: feedbackIcons, variant: variant, classNames: classNames, styles: styles, ...restFormProps } = props;
    const mergedSize = (0, $324b30eda6ea1cd7$export$2e2bcd8739ae039)(size);
    const contextValidateMessages = $32rMB.useContext((0, $731a8553e006c6d2$export$2e2bcd8739ae039));
    /* eslint-enable */ const mergedRequiredMark = $32rMB.useMemo(()=>{
        if (requiredMark !== undefined) return requiredMark;
        if (contextRequiredMark !== undefined) return contextRequiredMark;
        return true;
    }, [
        requiredMark,
        contextRequiredMark
    ]);
    const mergedColon = colon ?? contextColon;
    const prefixCls = getPrefixCls('form', customizePrefixCls);
    // Style
    const rootCls = (0, $54b1aecddbbbed4f$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $e81ef03cbd337bd2$export$2e2bcd8739ae039)(prefixCls, rootCls);
    // =========== Merged Props for Semantic ===========
    const mergedProps = {
        ...props,
        size: mergedSize,
        disabled: disabled,
        layout: layout,
        colon: mergedColon,
        requiredMark: mergedRequiredMark
    };
    const [mergedClassNames, mergedStyles] = (0, $4dcf69d8c3d6df5c$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    const formClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-${layout}`, {
        [`${prefixCls}-hide-required-mark`]: mergedRequiredMark === false,
        // todo: remove in next major version
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-${mergedSize}`]: mergedSize
    }, cssVarCls, rootCls, hashId, contextClassName, className, rootClassName, mergedClassNames.root);
    const [wrapForm] = (0, $33a442f1517960cf$export$2e2bcd8739ae039)(form);
    const { __INTERNAL__: __INTERNAL__ } = wrapForm;
    __INTERNAL__.name = name;
    const formContextValue = $32rMB.useMemo(()=>({
            name: name,
            labelAlign: labelAlign,
            labelCol: labelCol,
            labelWrap: labelWrap,
            wrapperCol: wrapperCol,
            layout: layout,
            colon: mergedColon,
            requiredMark: mergedRequiredMark,
            itemRef: __INTERNAL__.itemRef,
            form: wrapForm,
            feedbackIcons: feedbackIcons,
            classNames: mergedClassNames,
            styles: mergedStyles
        }), [
        name,
        labelAlign,
        labelCol,
        wrapperCol,
        layout,
        mergedColon,
        mergedRequiredMark,
        wrapForm,
        feedbackIcons,
        mergedClassNames,
        mergedStyles
    ]);
    const nativeElementRef = $32rMB.useRef(null);
    $32rMB.useImperativeHandle(ref, ()=>({
            ...wrapForm,
            nativeElement: nativeElementRef.current?.nativeElement
        }));
    const scrollToField = (options, fieldName)=>{
        if (options) {
            let defaultScrollToFirstError = {
                block: 'nearest'
            };
            if (typeof options === 'object') defaultScrollToFirstError = {
                ...defaultScrollToFirstError,
                ...options
            };
            wrapForm.scrollToField(fieldName, defaultScrollToFirstError);
        }
    };
    const onInternalFinishFailed = (errorInfo)=>{
        onFinishFailed?.(errorInfo);
        if (errorInfo.errorFields.length) {
            const fieldName = errorInfo.errorFields[0].name;
            if (scrollToFirstError !== undefined) {
                scrollToField(scrollToFirstError, fieldName);
                return;
            }
            if (contextScrollToFirstError !== undefined) scrollToField(contextScrollToFirstError, fieldName);
        }
    };
    return /*#__PURE__*/ $hO8yS.createElement((0, $a1a112e4dddc1035$export$6f0555dad42725fb).Provider, {
        value: variant
    }, /*#__PURE__*/ $hO8yS.createElement((0, $ff4b4ddbf52ed41f$export$6adb5f3b918b11bb), {
        disabled: disabled
    }, /*#__PURE__*/ $hO8yS.createElement((0, $4859819e58dda691$export$2e2bcd8739ae039).Provider, {
        value: mergedSize
    }, /*#__PURE__*/ $hO8yS.createElement((0, $a1a112e4dddc1035$export$8ce1ff4f94d08846), {
        // This is not list in API, we pass with spread
        validateMessages: contextValidateMessages
    }, /*#__PURE__*/ $hO8yS.createElement((0, $a1a112e4dddc1035$export$c24727297075ec6a).Provider, {
        value: formContextValue
    }, /*#__PURE__*/ $hO8yS.createElement((0, $a1a112e4dddc1035$export$80e4c53cb85dcab1), {
        status: true
    }, /*#__PURE__*/ $hO8yS.createElement((0, $ef79b59c4dbafb7e$export$2e2bcd8739ae039), {
        id: name,
        ...restFormProps,
        name: name,
        onFinishFailed: onInternalFinishFailed,
        form: wrapForm,
        ref: nativeElementRef,
        style: {
            ...mergedStyles?.root,
            ...contextStyle,
            ...style
        },
        className: formClassName
    })))))));
};
const $92bef01064ba88da$var$Form = /*#__PURE__*/ $N3oW3.forwardRef($92bef01064ba88da$var$InternalForm);
var $92bef01064ba88da$export$2e2bcd8739ae039 = $92bef01064ba88da$var$Form;



parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");











function $c4aa65520c339d86$export$2e2bcd8739ae039(children) {
    if (typeof children === 'function') return children;
    const childList = (0, $a60ede783f74e6a9$export$2e2bcd8739ae039)(children);
    return childList.length <= 1 ? childList[0] : childList;
}


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");


const $5dea4debaa0dba86$var$useFormItemStatus = ()=>{
    const { status: status, errors: errors = [], warnings: warnings = [] } = $32rMB.useContext((0, $a1a112e4dddc1035$export$bbb5553c6c7a14ed));
    return {
        status: status,
        errors: errors,
        warnings: warnings
    };
};
// Only used for compatible package. Not promise this will work on future version.
$5dea4debaa0dba86$var$useFormItemStatus.Context = (0, $a1a112e4dddc1035$export$bbb5553c6c7a14ed);
var $5dea4debaa0dba86$export$2e2bcd8739ae039 = $5dea4debaa0dba86$var$useFormItemStatus;


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");

function $621364241b0719fc$export$2e2bcd8739ae039(defaultValue) {
    const [value, setValue] = $32rMB.useState(defaultValue);
    const frameRef = $32rMB.useRef(null);
    const batchRef = $32rMB.useRef([]);
    const destroyRef = $32rMB.useRef(false);
    $32rMB.useEffect(()=>{
        destroyRef.current = false;
        return ()=>{
            destroyRef.current = true;
            (0, $c9c36e20d667d30c$export$2e2bcd8739ae039).cancel(frameRef.current);
            frameRef.current = null;
        };
    }, []);
    function setFrameValue(updater) {
        if (destroyRef.current) return;
        if (frameRef.current === null) {
            batchRef.current = [];
            frameRef.current = (0, $c9c36e20d667d30c$export$2e2bcd8739ae039)(()=>{
                frameRef.current = null;
                setValue((prevValue)=>{
                    let current = prevValue;
                    batchRef.current.forEach((func)=>{
                        current = func(current);
                    });
                    return current;
                });
            });
        }
        batchRef.current.push(updater);
    }
    return [
        value,
        setFrameValue
    ];
}


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");


function $027916070d7c16bd$export$2e2bcd8739ae039() {
    const { itemRef: itemRef } = $32rMB.useContext((0, $a1a112e4dddc1035$export$c24727297075ec6a));
    const cacheRef = $32rMB.useRef({});
    function getRef(name, children) {
        // Outer caller already check the `supportRef`
        const childrenRef = children && typeof children === 'object' && (0, $2706ed817e87019d$export$7465e5c0bf44f19a)(children);
        const nameStr = name.join('_');
        if (cacheRef.current.name !== nameStr || cacheRef.current.originRef !== childrenRef) {
            cacheRef.current.name = nameStr;
            cacheRef.current.originRef = childrenRef;
            cacheRef.current.ref = (0, $2706ed817e87019d$export$ab452c34e8e05029)(itemRef(name), childrenRef);
        }
        return cacheRef.current.ref;
    }
    return getRef;
}




parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");





parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");





function $2acb83680621d4b3$export$2e2bcd8739ae039(gutter, screens) {
    const results = [
        undefined,
        undefined
    ];
    const normalizedGutter = Array.isArray(gutter) ? gutter : [
        gutter,
        undefined
    ];
    // By default use as `xs`
    const mergedScreens = screens || {
        xs: true,
        sm: true,
        md: true,
        lg: true,
        xl: true,
        xxl: true
    };
    normalizedGutter.forEach((g, index)=>{
        if (typeof g === 'object' && g !== null) for(let i = 0; i < (0, $efa0a9940d56f47d$export$74c1bf8296b1541f).length; i++){
            const breakpoint = (0, $efa0a9940d56f47d$export$74c1bf8296b1541f)[i];
            if (mergedScreens[breakpoint] && g[breakpoint] !== undefined) {
                results[index] = g[breakpoint];
                break;
            }
        }
        else results[index] = g;
    });
    return results;
}


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
const $cfa5ccaf5c643c95$var$RowContext = /*#__PURE__*/ (0, $hO8yS.createContext)({});
var $cfa5ccaf5c643c95$export$2e2bcd8739ae039 = $cfa5ccaf5c643c95$var$RowContext;




// ============================== Row-Shared ==============================
const $ce8d76ffb364cac8$var$genGridRowStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        // Grid system
        [componentCls]: {
            display: 'flex',
            flexFlow: 'row wrap',
            minWidth: 0,
            '&::before, &::after': {
                display: 'flex'
            },
            '&-no-wrap': {
                flexWrap: 'nowrap'
            },
            // The origin of the X-axis
            '&-start': {
                justifyContent: 'flex-start'
            },
            // The center of the X-axis
            '&-center': {
                justifyContent: 'center'
            },
            // The opposite of the X-axis
            '&-end': {
                justifyContent: 'flex-end'
            },
            '&-space-between': {
                justifyContent: 'space-between'
            },
            '&-space-around': {
                justifyContent: 'space-around'
            },
            '&-space-evenly': {
                justifyContent: 'space-evenly'
            },
            // Align at the top
            '&-top': {
                alignItems: 'flex-start'
            },
            // Align at the center
            '&-middle': {
                alignItems: 'center'
            },
            '&-bottom': {
                alignItems: 'flex-end'
            }
        }
    };
};
// ============================== Col-Shared ==============================
const $ce8d76ffb364cac8$var$genGridColStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        // Grid system
        [componentCls]: {
            position: 'relative',
            maxWidth: '100%',
            // Prevent columns from collapsing when empty
            minHeight: 1
        }
    };
};
const $ce8d76ffb364cac8$var$genLoopGridColumnsStyle = (token, sizeCls)=>{
    const { prefixCls: prefixCls, componentCls: componentCls, gridColumns: gridColumns } = token;
    const gridColumnsStyle = {};
    for(let i = gridColumns; i >= 0; i--)if (i === 0) {
        gridColumnsStyle[`${componentCls}${sizeCls}-${i}`] = {
            display: 'none'
        };
        gridColumnsStyle[`${componentCls}-push-${i}`] = {
            insetInlineStart: 'auto'
        };
        gridColumnsStyle[`${componentCls}-pull-${i}`] = {
            insetInlineEnd: 'auto'
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-push-${i}`] = {
            insetInlineStart: 'auto'
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-pull-${i}`] = {
            insetInlineEnd: 'auto'
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-offset-${i}`] = {
            marginInlineStart: 0
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-order-${i}`] = {
            order: 0
        };
    } else {
        gridColumnsStyle[`${componentCls}${sizeCls}-${i}`] = [
            // https://github.com/ant-design/ant-design/issues/44456
            // Form set `display: flex` on Col which will override `display: block`.
            // Let's get it from css variable to support override.
            {
                ['--ant-display']: 'block',
                // Fallback to display if variable not support
                display: 'block'
            },
            {
                display: 'var(--ant-display)',
                flex: `0 0 ${i / gridColumns * 100}%`,
                maxWidth: `${i / gridColumns * 100}%`
            }
        ];
        gridColumnsStyle[`${componentCls}${sizeCls}-push-${i}`] = {
            insetInlineStart: `${i / gridColumns * 100}%`
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-pull-${i}`] = {
            insetInlineEnd: `${i / gridColumns * 100}%`
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-offset-${i}`] = {
            marginInlineStart: `${i / gridColumns * 100}%`
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-order-${i}`] = {
            order: i
        };
    }
    // Flex CSS Var
    gridColumnsStyle[`${componentCls}${sizeCls}-flex`] = {
        flex: `var(--${prefixCls}${sizeCls}-flex)`
    };
    return gridColumnsStyle;
};
const $ce8d76ffb364cac8$var$genGridStyle = (token, sizeCls)=>$ce8d76ffb364cac8$var$genLoopGridColumnsStyle(token, sizeCls);
const $ce8d76ffb364cac8$var$genGridMediaStyle = (token, screenSize, sizeCls)=>({
        [`@media (min-width: ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(screenSize)})`]: {
            ...$ce8d76ffb364cac8$var$genGridStyle(token, sizeCls)
        }
    });
const $ce8d76ffb364cac8$export$519f4f378a4f8e85 = ()=>({});
const $ce8d76ffb364cac8$export$5504d86ab3175593 = ()=>({});
const $ce8d76ffb364cac8$export$b0d9c6b8be4e14cd = (0, $d4a2dc313c4d90a4$export$51ec95de45185b42)('Grid', $ce8d76ffb364cac8$var$genGridRowStyle, $ce8d76ffb364cac8$export$519f4f378a4f8e85);
const $ce8d76ffb364cac8$export$6353f655434817c5 = (token)=>{
    const mediaSizesMap = {
        xs: token.screenXSMin,
        sm: token.screenSMMin,
        md: token.screenMDMin,
        lg: token.screenLGMin,
        xl: token.screenXLMin,
        xxl: token.screenXXLMin
    };
    return mediaSizesMap;
};
const $ce8d76ffb364cac8$export$4d3e83959861592f = (0, $d4a2dc313c4d90a4$export$51ec95de45185b42)('Grid', (token)=>{
    const gridToken = (0, $90c11ca6cb263fd9$export$4950aa0f605343fb)(token, {
        gridColumns: 24 // Row is divided into 24 parts in Grid
    });
    const gridMediaSizesMap = $ce8d76ffb364cac8$export$6353f655434817c5(gridToken);
    delete gridMediaSizesMap.xs;
    return [
        $ce8d76ffb364cac8$var$genGridColStyle(gridToken),
        $ce8d76ffb364cac8$var$genGridStyle(gridToken, ''),
        $ce8d76ffb364cac8$var$genGridStyle(gridToken, '-xs'),
        Object.keys(gridMediaSizesMap).map((key)=>$ce8d76ffb364cac8$var$genGridMediaStyle(gridToken, gridMediaSizesMap[key], `-${key}`)).reduce((pre, cur)=>({
                ...pre,
                ...cur
            }), {})
    ];
}, $ce8d76ffb364cac8$export$5504d86ab3175593);


"use client";
const $1034cd2d0d871af4$var$_RowAligns = [
    'top',
    'middle',
    'bottom',
    'stretch'
];
const $1034cd2d0d871af4$var$_RowJustify = [
    'start',
    'end',
    'center',
    'space-around',
    'space-between',
    'space-evenly'
];
function $1034cd2d0d871af4$var$useMergedPropByScreen(oriProp, screen) {
    const [prop, setProp] = $32rMB.useState(typeof oriProp === 'string' ? oriProp : '');
    const calcMergedAlignOrJustify = ()=>{
        if (typeof oriProp === 'string') setProp(oriProp);
        if (typeof oriProp !== 'object') return;
        for(let i = 0; i < (0, $efa0a9940d56f47d$export$74c1bf8296b1541f).length; i++){
            const breakpoint = (0, $efa0a9940d56f47d$export$74c1bf8296b1541f)[i];
            // if do not match, do nothing
            if (!screen || !screen[breakpoint]) continue;
            const curVal = oriProp[breakpoint];
            if (curVal !== undefined) {
                setProp(curVal);
                return;
            }
        }
    };
    $32rMB.useEffect(()=>{
        calcMergedAlignOrJustify();
    }, [
        JSON.stringify(oriProp),
        screen
    ]);
    return prop;
}
const $1034cd2d0d871af4$var$Row = /*#__PURE__*/ $N3oW3.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, justify: justify, align: align, className: className, style: style, children: children, gutter: gutter = 0, wrap: wrap, ...others } = props;
    const { getPrefixCls: getPrefixCls, direction: direction } = $32rMB.useContext((0, $dd01e2f5a4b8605d$export$a92f85ab3e9ad68b));
    const screens = (0, $c5abeec2eaafde8a$export$2e2bcd8739ae039)(true, null);
    const mergedAlign = $1034cd2d0d871af4$var$useMergedPropByScreen(align, screens);
    const mergedJustify = $1034cd2d0d871af4$var$useMergedPropByScreen(justify, screens);
    const prefixCls = getPrefixCls('row', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $ce8d76ffb364cac8$export$b0d9c6b8be4e14cd)(prefixCls);
    const gutters = (0, $2acb83680621d4b3$export$2e2bcd8739ae039)(gutter, screens);
    const classes = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, {
        [`${prefixCls}-no-wrap`]: wrap === false,
        [`${prefixCls}-${mergedJustify}`]: mergedJustify,
        [`${prefixCls}-${mergedAlign}`]: mergedAlign,
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, className, hashId, cssVarCls);
    // Add gutter related style
    const rowStyle = {};
    if (gutters?.[0]) {
        const horizontalGutter = typeof gutters[0] === 'number' ? `${gutters[0] / -2}px` : `calc(${gutters[0]} / -2)`;
        rowStyle.marginInline = horizontalGutter;
    }
    // "gutters" is a new array in each rendering phase, it'll make 'React.useMemo' effectless.
    // So we deconstruct "gutters" variable here.
    const [gutterH, gutterV] = gutters;
    rowStyle.rowGap = gutterV;
    const rowContext = $32rMB.useMemo(()=>({
            gutter: [
                gutterH,
                gutterV
            ],
            wrap: wrap
        }), [
        gutterH,
        gutterV,
        wrap
    ]);
    return /*#__PURE__*/ $hO8yS.createElement((0, $cfa5ccaf5c643c95$export$2e2bcd8739ae039).Provider, {
        value: rowContext
    }, /*#__PURE__*/ $hO8yS.createElement("div", {
        ...others,
        className: classes,
        style: {
            ...rowStyle,
            ...style
        },
        ref: ref
    }, children));
});
var $1034cd2d0d871af4$export$2e2bcd8739ae039 = $1034cd2d0d871af4$var$Row;



parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");



parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");




"use client";
function $b0392451a324479a$var$parseFlex(flex) {
    if (flex === 'auto') return '1 1 auto';
    if (typeof flex === 'number') return `${flex} ${flex} auto`;
    if (/^\d+(\.\d+)?(px|em|rem|%)$/.test(flex)) return `0 0 ${flex}`;
    return flex;
}
const $b0392451a324479a$var$sizes = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl',
    'xxl'
];
const $b0392451a324479a$var$Col = /*#__PURE__*/ $N3oW3.forwardRef((props, ref)=>{
    const { getPrefixCls: getPrefixCls, direction: direction } = $32rMB.useContext((0, $dd01e2f5a4b8605d$export$a92f85ab3e9ad68b));
    const { gutter: gutter, wrap: wrap } = $32rMB.useContext((0, $cfa5ccaf5c643c95$export$2e2bcd8739ae039));
    const { prefixCls: customizePrefixCls, span: span, order: order, offset: offset, push: push, pull: pull, className: className, children: children, flex: flex, style: style, ...others } = props;
    const prefixCls = getPrefixCls('col', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $ce8d76ffb364cac8$export$4d3e83959861592f)(prefixCls);
    // ===================== Size ======================
    const sizeStyle = {};
    let sizeClassObj = {};
    $b0392451a324479a$var$sizes.forEach((size)=>{
        let sizeProps = {};
        const propSize = props[size];
        if (typeof propSize === 'number') sizeProps.span = propSize;
        else if (typeof propSize === 'object') sizeProps = propSize || {};
        delete others[size];
        sizeClassObj = {
            ...sizeClassObj,
            [`${prefixCls}-${size}-${sizeProps.span}`]: sizeProps.span !== undefined,
            [`${prefixCls}-${size}-order-${sizeProps.order}`]: sizeProps.order || sizeProps.order === 0,
            [`${prefixCls}-${size}-offset-${sizeProps.offset}`]: sizeProps.offset || sizeProps.offset === 0,
            [`${prefixCls}-${size}-push-${sizeProps.push}`]: sizeProps.push || sizeProps.push === 0,
            [`${prefixCls}-${size}-pull-${sizeProps.pull}`]: sizeProps.pull || sizeProps.pull === 0,
            [`${prefixCls}-rtl`]: direction === 'rtl'
        };
        // Responsive flex layout
        if (sizeProps.flex) {
            sizeClassObj[`${prefixCls}-${size}-flex`] = true;
            sizeStyle[`--${prefixCls}-${size}-flex`] = $b0392451a324479a$var$parseFlex(sizeProps.flex);
        }
    });
    // ==================== Normal =====================
    const classes = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, {
        [`${prefixCls}-${span}`]: span !== undefined,
        [`${prefixCls}-order-${order}`]: order,
        [`${prefixCls}-offset-${offset}`]: offset,
        [`${prefixCls}-push-${push}`]: push,
        [`${prefixCls}-pull-${pull}`]: pull
    }, className, sizeClassObj, hashId, cssVarCls);
    const mergedStyle = {};
    // Horizontal gutter use padding
    if (gutter?.[0]) {
        const horizontalGutter = typeof gutter[0] === 'number' ? `${gutter[0] / 2}px` : `calc(${gutter[0]} / 2)`;
        mergedStyle.paddingInline = horizontalGutter;
    }
    if (flex) {
        mergedStyle.flex = $b0392451a324479a$var$parseFlex(flex);
        // Hack for Firefox to avoid size issue
        // https://github.com/ant-design/ant-design/pull/20023#issuecomment-564389553
        if (wrap === false && !mergedStyle.minWidth) mergedStyle.minWidth = 0;
    }
    // ==================== Render =====================
    return /*#__PURE__*/ $hO8yS.createElement("div", {
        ...others,
        style: {
            ...mergedStyle,
            ...style,
            ...sizeStyle
        },
        className: classes,
        ref: ref
    }, children);
});
var $b0392451a324479a$export$2e2bcd8739ae039 = $b0392451a324479a$var$Col;




/**
 * Fallback of IE.
 * Safe to remove.
 */ // Style as inline component


// ============================= Fallback =============================
const $e3d833d4cabb820f$var$genFallbackStyle = (token)=>{
    const { formItemCls: formItemCls } = token;
    return {
        '@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)': {
            // Fallback for IE, safe to remove we not support it anymore
            [`${formItemCls}-control`]: {
                display: 'flex'
            }
        }
    };
};
var // ============================== Export ==============================
$e3d833d4cabb820f$export$2e2bcd8739ae039 = (0, $d4a2dc313c4d90a4$export$1537386bc155ea56)([
    'Form',
    'item-item'
], (token, { rootPrefixCls: rootPrefixCls })=>{
    const formToken = (0, $e81ef03cbd337bd2$export$362fb92a8f81bbf9)(token, rootPrefixCls);
    return $e3d833d4cabb820f$var$genFallbackStyle(formToken);
});


"use client";
const $b203540341423dd6$var$GRID_MAX = 24;
const $b203540341423dd6$var$FormItemInput = (props)=>{
    const { prefixCls: prefixCls, status: status, labelCol: labelCol, wrapperCol: wrapperCol, children: children, errors: errors, warnings: warnings, _internalItemRender: formItemRender, extra: extra, help: help, fieldId: fieldId, marginBottom: marginBottom, onErrorVisibleChanged: onErrorVisibleChanged, label: label } = props;
    const baseClassName = `${prefixCls}-item`;
    const formContext = $32rMB.useContext((0, $a1a112e4dddc1035$export$c24727297075ec6a));
    const { classNames: contextClassNames, styles: contextStyles } = formContext;
    const mergedWrapperCol = $32rMB.useMemo(()=>{
        let mergedWrapper = {
            ...wrapperCol || formContext.wrapperCol || {}
        };
        if (label === null && !labelCol && !wrapperCol && formContext.labelCol) {
            const list = [
                undefined,
                'xs',
                'sm',
                'md',
                'lg',
                'xl',
                'xxl'
            ];
            list.forEach((size)=>{
                const _size = size ? [
                    size
                ] : [];
                const formLabel = (0, $7967876a5e08d9ff$export$2e2bcd8739ae039)(formContext.labelCol, _size);
                const formLabelObj = typeof formLabel === 'object' ? formLabel : {};
                const wrapper = (0, $7967876a5e08d9ff$export$2e2bcd8739ae039)(mergedWrapper, _size);
                const wrapperObj = typeof wrapper === 'object' ? wrapper : {};
                if ('span' in formLabelObj && !('offset' in wrapperObj) && formLabelObj.span < $b203540341423dd6$var$GRID_MAX) mergedWrapper = (0, $3d19a70b12f43514$export$2e2bcd8739ae039)(mergedWrapper, [].concat(_size, [
                    'offset'
                ]), formLabelObj.span);
            });
        }
        return mergedWrapper;
    }, [
        wrapperCol,
        formContext.wrapperCol,
        formContext.labelCol,
        label,
        labelCol
    ]);
    const className = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${baseClassName}-control`, mergedWrapperCol.className);
    // Pass to sub FormItem should not with col info
    const subFormContext = $32rMB.useMemo(()=>{
        const { labelCol: _labelCol, wrapperCol: _wrapperCol, ...rest } = formContext;
        return rest;
    }, [
        formContext
    ]);
    const extraRef = $32rMB.useRef(null);
    const [extraHeight, setExtraHeight] = $32rMB.useState(0);
    (0, $60cea2402df671e7$export$2e2bcd8739ae039)(()=>{
        if (extra && extraRef.current) setExtraHeight(extraRef.current.clientHeight);
        else setExtraHeight(0);
    }, [
        extra
    ]);
    const inputDom = /*#__PURE__*/ $hO8yS.createElement("div", {
        className: `${baseClassName}-control-input`
    }, /*#__PURE__*/ $hO8yS.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${baseClassName}-control-input-content`, contextClassNames?.content),
        style: contextStyles?.content
    }, children));
    const formItemContext = $32rMB.useMemo(()=>({
            prefixCls: prefixCls,
            status: status
        }), [
        prefixCls,
        status
    ]);
    const errorListDom = marginBottom !== null || errors.length || warnings.length ? /*#__PURE__*/ $hO8yS.createElement((0, $a1a112e4dddc1035$export$fb6582d3042cc879).Provider, {
        value: formItemContext
    }, /*#__PURE__*/ $hO8yS.createElement((0, $2ca4ef559a646f6d$export$2e2bcd8739ae039), {
        fieldId: fieldId,
        errors: errors,
        warnings: warnings,
        help: help,
        helpStatus: status,
        className: `${baseClassName}-explain-connected`,
        onVisibleChanged: onErrorVisibleChanged
    })) : null;
    const extraProps = {};
    if (fieldId) extraProps.id = `${fieldId}_extra`;
    // If extra = 0, && will goes wrong
    // 0&&error -> 0
    const extraDom = extra ? /*#__PURE__*/ $hO8yS.createElement("div", {
        ...extraProps,
        className: `${baseClassName}-extra`,
        ref: extraRef
    }, extra) : null;
    const additionalDom = errorListDom || extraDom ? /*#__PURE__*/ $hO8yS.createElement("div", {
        className: `${baseClassName}-additional`,
        style: marginBottom ? {
            minHeight: marginBottom + extraHeight
        } : {}
    }, errorListDom, extraDom) : null;
    const dom = formItemRender && formItemRender.mark === 'pro_table_render' && formItemRender.render ? formItemRender.render(props, {
        input: inputDom,
        errorList: errorListDom,
        extra: extraDom
    }) : /*#__PURE__*/ $hO8yS.createElement($hO8yS.Fragment, null, inputDom, additionalDom);
    return /*#__PURE__*/ $hO8yS.createElement((0, $a1a112e4dddc1035$export$c24727297075ec6a).Provider, {
        value: subFormContext
    }, /*#__PURE__*/ $hO8yS.createElement((0, $b0392451a324479a$export$2e2bcd8739ae039), {
        ...mergedWrapperCol,
        className: className
    }, dom), /*#__PURE__*/ $hO8yS.createElement((0, $e3d833d4cabb820f$export$2e2bcd8739ae039), {
        prefixCls: prefixCls
    }));
};
var $b203540341423dd6$export$2e2bcd8739ae039 = $b203540341423dd6$var$FormItemInput;



var $N3oW3 = parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");
parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
// This icon file is generated automatically.
var $95864e56c735dd89$var$QuestionCircleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0130.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1080 0 40 40 0 10-80 0z"
                }
            }
        ]
    },
    "name": "question-circle",
    "theme": "outlined"
};
var $95864e56c735dd89$export$2e2bcd8739ae039 = $95864e56c735dd89$var$QuestionCircleOutlined;



function $e8b184d2f095272b$var$_extends() {
    $e8b184d2f095272b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e8b184d2f095272b$var$_extends.apply(this, arguments);
}
const $e8b184d2f095272b$var$QuestionCircleOutlined = (props, ref)=>/*#__PURE__*/ $hO8yS.createElement((0, $5fd6f3f3c400c267$export$2e2bcd8739ae039), $e8b184d2f095272b$var$_extends({}, props, {
        ref: ref,
        icon: (0, $95864e56c735dd89$export$2e2bcd8739ae039)
    }));
/**![question-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0wIDgyMGMtMjA1LjQgMC0zNzItMTY2LjYtMzcyLTM3MnMxNjYuNi0zNzIgMzcyLTM3MiAzNzIgMTY2LjYgMzcyIDM3Mi0xNjYuNiAzNzItMzcyIDM3MnoiIC8+PHBhdGggZD0iTTYyMy42IDMxNi43QzU5My42IDI5MC40IDU1NCAyNzYgNTEyIDI3NnMtODEuNiAxNC41LTExMS42IDQwLjdDMzY5LjIgMzQ0IDM1MiAzODAuNyAzNTIgNDIwdjcuNmMwIDQuNCAzLjYgOCA4IDhoNDhjNC40IDAgOC0zLjYgOC04VjQyMGMwLTQ0LjEgNDMuMS04MCA5Ni04MHM5NiAzNS45IDk2IDgwYzAgMzEuMS0yMiA1OS42LTU2LjEgNzIuNy0yMS4yIDguMS0zOS4yIDIyLjMtNTIuMSA0MC45LTEzLjEgMTktMTkuOSA0MS44LTE5LjkgNjQuOVY2MjBjMCA0LjQgMy42IDggOCA4aDQ4YzQuNCAwIDgtMy42IDgtOHYtMjIuN2E0OC4zIDQ4LjMgMCAwMTMwLjktNDQuOGM1OS0yMi43IDk3LjEtNzQuNyA5Ny4xLTEzMi41LjEtMzkuMy0xNy4xLTc2LTQ4LjMtMTAzLjN6TTQ3MiA3MzJhNDAgNDAgMCAxMDgwIDAgNDAgNDAgMCAxMC04MCAweiIgLz48L3N2Zz4=) */ const $e8b184d2f095272b$var$RefIcon = /*#__PURE__*/ $N3oW3.forwardRef($e8b184d2f095272b$var$QuestionCircleOutlined);
var $e8b184d2f095272b$export$2e2bcd8739ae039 = $e8b184d2f095272b$var$RefIcon;




var $N3oW3 = parcelRequire("N3oW3");

const $5f3c9eed6194c11d$var$convertToTooltipProps = (tooltip)=>{
    if (!(0, $95ac4c3d4339216e$export$2e2bcd8739ae039)(tooltip)) return null;
    if (typeof tooltip === 'object' && !/*#__PURE__*/ (0, $N3oW3.isValidElement)(tooltip)) return tooltip;
    return {
        title: tooltip
    };
};
var $5f3c9eed6194c11d$export$2e2bcd8739ae039 = $5f3c9eed6194c11d$var$convertToTooltipProps;







"use client";
const $d0d1c0cbc8777131$var$FormItemLabel = ({ prefixCls: prefixCls, label: label, htmlFor: htmlFor, labelCol: labelCol, labelAlign: labelAlign, colon: colon, required: required, requiredMark: requiredMark, tooltip: tooltip, vertical: vertical })=>{
    const [formLocale] = (0, $c176ccd8a9cbd556$export$2e2bcd8739ae039)('Form');
    const { labelAlign: contextLabelAlign, labelCol: contextLabelCol, labelWrap: labelWrap, colon: contextColon, classNames: contextClassNames, styles: contextStyles } = $32rMB.useContext((0, $a1a112e4dddc1035$export$c24727297075ec6a));
    if (!label) return null;
    const mergedLabelCol = labelCol || contextLabelCol || {};
    const mergedLabelAlign = labelAlign || contextLabelAlign;
    const labelClsBasic = `${prefixCls}-item-label`;
    const labelColClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(labelClsBasic, mergedLabelAlign === 'left' && `${labelClsBasic}-left`, mergedLabelCol.className, {
        [`${labelClsBasic}-wrap`]: !!labelWrap
    });
    let labelChildren = label;
    // Keep label is original where there should have no colon
    const computedColon = colon === true || contextColon !== false && colon !== false;
    const haveColon = computedColon && !vertical;
    // Remove duplicated user input colon
    if (haveColon && typeof label === 'string' && label.trim()) labelChildren = label.replace(/[:|：]\s*$/, '');
    // Tooltip
    const tooltipProps = (0, $5f3c9eed6194c11d$export$2e2bcd8739ae039)(tooltip);
    if (tooltipProps) {
        const { icon: icon = /*#__PURE__*/ $hO8yS.createElement((0, $e8b184d2f095272b$export$2e2bcd8739ae039), null), ...restTooltipProps } = tooltipProps;
        const tooltipNode = /*#__PURE__*/ $hO8yS.createElement((0, $bdb14b445459ab9d$export$2e2bcd8739ae039), {
            ...restTooltipProps
        }, /*#__PURE__*/ $N3oW3.cloneElement(icon, {
            className: `${prefixCls}-item-tooltip`,
            title: '',
            onClick: (e)=>{
                // Prevent label behavior in tooltip icon
                // https://github.com/ant-design/ant-design/issues/46154
                e.preventDefault();
            },
            tabIndex: null
        }));
        labelChildren = /*#__PURE__*/ $hO8yS.createElement($hO8yS.Fragment, null, labelChildren, tooltipNode);
    }
    // Required Mark
    const isOptionalMark = requiredMark === 'optional';
    const isRenderMark = typeof requiredMark === 'function';
    const hideRequiredMark = requiredMark === false;
    if (isRenderMark) labelChildren = requiredMark(labelChildren, {
        required: !!required
    });
    else if (isOptionalMark && !required) labelChildren = /*#__PURE__*/ $hO8yS.createElement($hO8yS.Fragment, null, labelChildren, /*#__PURE__*/ $hO8yS.createElement("span", {
        className: `${prefixCls}-item-optional`,
        title: ""
    }, formLocale?.optional || (0, $e154e9cb01eacc19$export$2e2bcd8739ae039).Form?.optional));
    // https://github.com/ant-design/ant-design/pull/52950#discussion_r1980880316
    let markType;
    if (hideRequiredMark) markType = 'hidden';
    else if (isOptionalMark || isRenderMark) markType = 'optional';
    const labelClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(contextClassNames?.label, {
        [`${prefixCls}-item-required`]: required,
        [`${prefixCls}-item-required-mark-${markType}`]: markType,
        [`${prefixCls}-item-no-colon`]: !computedColon
    });
    return /*#__PURE__*/ $hO8yS.createElement((0, $b0392451a324479a$export$2e2bcd8739ae039), {
        ...mergedLabelCol,
        className: labelColClassName
    }, /*#__PURE__*/ $hO8yS.createElement("label", {
        htmlFor: htmlFor,
        className: labelClassName,
        style: contextStyles?.label,
        title: typeof label === 'string' ? label : ''
    }, labelChildren));
};
var $d0d1c0cbc8777131$export$2e2bcd8739ae039 = $d0d1c0cbc8777131$var$FormItemLabel;




parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");







"use client";
const $70955fdde9fcfcf8$var$iconMap = {
    success: (0, $1aa4ade09bf83f85$export$2e2bcd8739ae039),
    warning: (0, $eec2491bdf124fc8$export$2e2bcd8739ae039),
    error: (0, $88ed6189ad3742f6$export$2e2bcd8739ae039),
    validating: (0, $b7d605396d432b67$export$2e2bcd8739ae039)
};
function $70955fdde9fcfcf8$var$StatusProvider({ children: children, errors: errors, warnings: warnings, hasFeedback: hasFeedback, validateStatus: validateStatus, prefixCls: prefixCls, meta: meta, noStyle: noStyle, name: name }) {
    const itemPrefixCls = `${prefixCls}-item`;
    const { feedbackIcons: feedbackIcons } = $32rMB.useContext((0, $a1a112e4dddc1035$export$c24727297075ec6a));
    const mergedValidateStatus = (0, $64986a7e8b86a8b3$export$b70265791d2079d4)(errors, warnings, meta, null, !!hasFeedback, validateStatus);
    const { isFormItemInput: parentIsFormItemInput, status: parentStatus, hasFeedback: parentHasFeedback, feedbackIcon: parentFeedbackIcon, name: parentName } = $32rMB.useContext((0, $a1a112e4dddc1035$export$bbb5553c6c7a14ed));
    // ====================== Context =======================
    const formItemStatusContext = $32rMB.useMemo(()=>{
        let feedbackIcon;
        if (hasFeedback) {
            const customIcons = hasFeedback !== true && hasFeedback.icons || feedbackIcons;
            const customIconNode = mergedValidateStatus && customIcons?.({
                status: mergedValidateStatus,
                errors: errors,
                warnings: warnings
            })?.[mergedValidateStatus];
            const IconNode = mergedValidateStatus ? $70955fdde9fcfcf8$var$iconMap[mergedValidateStatus] : null;
            feedbackIcon = customIconNode !== false && IconNode ? /*#__PURE__*/ $hO8yS.createElement("span", {
                className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${itemPrefixCls}-feedback-icon`, `${itemPrefixCls}-feedback-icon-${mergedValidateStatus}`)
            }, customIconNode || /*#__PURE__*/ $hO8yS.createElement(IconNode, null)) : null;
        }
        const context = {
            status: mergedValidateStatus || '',
            errors: errors,
            warnings: warnings,
            hasFeedback: !!hasFeedback,
            feedbackIcon: feedbackIcon,
            isFormItemInput: true,
            name: name
        };
        // No style will follow parent context
        if (noStyle) {
            context.status = (mergedValidateStatus ?? parentStatus) || '';
            context.isFormItemInput = parentIsFormItemInput;
            context.hasFeedback = !!(hasFeedback ?? parentHasFeedback);
            context.feedbackIcon = hasFeedback !== undefined ? context.feedbackIcon : parentFeedbackIcon;
            context.name = name ?? parentName;
        }
        return context;
    }, [
        mergedValidateStatus,
        hasFeedback,
        noStyle,
        parentIsFormItemInput,
        parentStatus
    ]);
    // ======================= Render =======================
    return /*#__PURE__*/ $hO8yS.createElement((0, $a1a112e4dddc1035$export$bbb5553c6c7a14ed).Provider, {
        value: formItemStatusContext
    }, children);
}
var $70955fdde9fcfcf8$export$2e2bcd8739ae039 = $70955fdde9fcfcf8$var$StatusProvider;


"use client";
function $dcb1d2002ceccf0a$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, className: className, rootClassName: rootClassName, style: style, help: help, errors: errors, warnings: warnings, validateStatus: validateStatus, meta: meta, hasFeedback: hasFeedback, hidden: hidden, children: children, fieldId: fieldId, required: required, isRequired: isRequired, onSubItemMetaChange: onSubItemMetaChange, layout: propsLayout, name: name, ...restProps } = props;
    const itemPrefixCls = `${prefixCls}-item`;
    const { requiredMark: requiredMark, layout: formLayout } = $32rMB.useContext((0, $a1a112e4dddc1035$export$c24727297075ec6a));
    const layout = propsLayout || formLayout;
    const vertical = layout === 'vertical';
    // ======================== Margin ========================
    const itemRef = $32rMB.useRef(null);
    const debounceErrors = (0, $dae63c7eec57a29b$export$2e2bcd8739ae039)(errors);
    const debounceWarnings = (0, $dae63c7eec57a29b$export$2e2bcd8739ae039)(warnings);
    const hasHelp = (0, $95ac4c3d4339216e$export$2e2bcd8739ae039)(help);
    const hasError = !!(hasHelp || errors.length || warnings.length);
    const isOnScreen = !!itemRef.current && (0, $218f20156c5f8705$export$2e2bcd8739ae039)(itemRef.current);
    const [marginBottom, setMarginBottom] = $32rMB.useState(null);
    (0, $60cea2402df671e7$export$2e2bcd8739ae039)(()=>{
        if (hasError && itemRef.current) {
            // The element must be part of the DOMTree to use getComputedStyle
            // https://stackoverflow.com/questions/35360711/getcomputedstyle-returns-a-cssstyledeclaration-but-all-properties-are-empty-on-a
            const itemStyle = getComputedStyle(itemRef.current);
            setMarginBottom(Number.parseInt(itemStyle.marginBottom, 10));
        }
    }, [
        hasError,
        isOnScreen
    ]);
    const onErrorVisibleChanged = (nextVisible)=>{
        if (!nextVisible) setMarginBottom(null);
    };
    // ======================== Status ========================
    const getValidateState = (isDebounce = false)=>{
        const _errors = isDebounce ? debounceErrors : meta.errors;
        const _warnings = isDebounce ? debounceWarnings : meta.warnings;
        return (0, $64986a7e8b86a8b3$export$b70265791d2079d4)(_errors, _warnings, meta, '', !!hasFeedback, validateStatus);
    };
    const mergedValidateStatus = getValidateState();
    // ======================== Render ========================
    const itemClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(itemPrefixCls, className, rootClassName, {
        [`${itemPrefixCls}-with-help`]: hasHelp || debounceErrors.length || debounceWarnings.length,
        // Status
        [`${itemPrefixCls}-has-feedback`]: mergedValidateStatus && hasFeedback,
        [`${itemPrefixCls}-has-success`]: mergedValidateStatus === 'success',
        [`${itemPrefixCls}-has-warning`]: mergedValidateStatus === 'warning',
        [`${itemPrefixCls}-has-error`]: mergedValidateStatus === 'error',
        [`${itemPrefixCls}-is-validating`]: mergedValidateStatus === 'validating',
        [`${itemPrefixCls}-hidden`]: hidden,
        // Layout
        [`${itemPrefixCls}-${layout}`]: layout
    });
    return /*#__PURE__*/ $hO8yS.createElement("div", {
        className: itemClassName,
        style: style,
        ref: itemRef
    }, /*#__PURE__*/ $hO8yS.createElement((0, $1034cd2d0d871af4$export$2e2bcd8739ae039), {
        className: `${itemPrefixCls}-row`,
        ...(0, $f4cf9c2e27c0ac8d$export$2e2bcd8739ae039)(restProps, [
            '_internalItemRender',
            'colon',
            'dependencies',
            'extra',
            'fieldKey',
            'getValueFromEvent',
            'getValueProps',
            'htmlFor',
            'id',
            // It is deprecated because `htmlFor` is its replacement.
            'initialValue',
            'isListField',
            'label',
            'labelAlign',
            'labelCol',
            'labelWrap',
            'messageVariables',
            'name',
            'normalize',
            'noStyle',
            'preserve',
            'requiredMark',
            'rules',
            'shouldUpdate',
            'trigger',
            'tooltip',
            'validateFirst',
            'validateTrigger',
            'valuePropName',
            'wrapperCol',
            'validateDebounce'
        ])
    }, /*#__PURE__*/ $hO8yS.createElement((0, $d0d1c0cbc8777131$export$2e2bcd8739ae039), {
        htmlFor: fieldId,
        ...props,
        requiredMark: requiredMark,
        required: required ?? isRequired,
        prefixCls: prefixCls,
        vertical: vertical
    }), /*#__PURE__*/ $hO8yS.createElement((0, $b203540341423dd6$export$2e2bcd8739ae039), {
        ...props,
        ...meta,
        errors: debounceErrors,
        warnings: debounceWarnings,
        prefixCls: prefixCls,
        status: mergedValidateStatus,
        help: help,
        marginBottom: marginBottom,
        onErrorVisibleChanged: onErrorVisibleChanged
    }, /*#__PURE__*/ $hO8yS.createElement((0, $a1a112e4dddc1035$export$d718247e9f9b0b9e).Provider, {
        value: onSubItemMetaChange
    }, /*#__PURE__*/ $hO8yS.createElement((0, $70955fdde9fcfcf8$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        meta: meta,
        errors: meta.errors,
        warnings: meta.warnings,
        hasFeedback: hasFeedback,
        // Already calculated
        validateStatus: mergedValidateStatus,
        name: name
    }, children)))), !!marginBottom && /*#__PURE__*/ $hO8yS.createElement("div", {
        className: `${itemPrefixCls}-margin-offset`,
        style: {
            marginBottom: -marginBottom
        }
    }));
}



"use client";
const $7d2d0991fbc56fb4$var$NAME_SPLIT = '__SPLIT__';
const $7d2d0991fbc56fb4$var$_ValidateStatuses = [
    'success',
    'warning',
    'error',
    'validating',
    ''
];
// https://github.com/ant-design/ant-design/issues/46417
// `getValueProps` may modify the value props name,
// we should check if the control is similar.
function $7d2d0991fbc56fb4$var$isSimilarControl(a, b) {
    const keysA = Object.keys(a);
    const keysB = Object.keys(b);
    return keysA.length === keysB.length && keysA.every((key)=>{
        const propValueA = a[key];
        const propValueB = b[key];
        return propValueA === propValueB || typeof propValueA === 'function' || typeof propValueB === 'function';
    });
}
const $7d2d0991fbc56fb4$var$MemoInput = /*#__PURE__*/ $N3oW3.memo(({ children: children })=>children, (prev, next)=>$7d2d0991fbc56fb4$var$isSimilarControl(prev.control, next.control) && prev.update === next.update && prev.childProps.length === next.childProps.length && prev.childProps.every((value, index)=>value === next.childProps[index]));
function $7d2d0991fbc56fb4$var$genEmptyMeta() {
    return {
        errors: [],
        warnings: [],
        touched: false,
        validating: false,
        name: [],
        validated: false
    };
}
function $7d2d0991fbc56fb4$var$InternalFormItem(props) {
    const { name: name, noStyle: noStyle, className: className, dependencies: dependencies, prefixCls: customizePrefixCls, shouldUpdate: shouldUpdate, rules: rules, children: children, required: required, label: label, messageVariables: messageVariables, trigger: trigger = 'onChange', validateTrigger: validateTrigger, hidden: hidden, help: help, layout: layout } = props;
    const { getPrefixCls: getPrefixCls } = $32rMB.useContext((0, $dd01e2f5a4b8605d$export$a92f85ab3e9ad68b));
    const { name: formName } = $32rMB.useContext((0, $a1a112e4dddc1035$export$c24727297075ec6a));
    const mergedChildren = (0, $c4aa65520c339d86$export$2e2bcd8739ae039)(children);
    const isRenderProps = typeof mergedChildren === 'function';
    const notifyParentMetaChange = $32rMB.useContext((0, $a1a112e4dddc1035$export$d718247e9f9b0b9e));
    const { validateTrigger: contextValidateTrigger } = $32rMB.useContext((0, $e5b7fab730d97669$export$2e2bcd8739ae039));
    const mergedValidateTrigger = (0, $95ac4c3d4339216e$export$2e2bcd8739ae039)(validateTrigger) ? validateTrigger : contextValidateTrigger;
    const hasName = (0, $95ac4c3d4339216e$export$2e2bcd8739ae039)(name);
    const prefixCls = getPrefixCls('form', customizePrefixCls);
    // Style
    const rootCls = (0, $54b1aecddbbbed4f$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $e81ef03cbd337bd2$export$2e2bcd8739ae039)(prefixCls, rootCls);
    // ========================= Warn =========================
    const warning = (0, $d41680c8243eac18$export$cf977aa92c751e61)('Form.Item');
    // ========================= MISC =========================
    // Get `noStyle` required info
    const listContext = $32rMB.useContext((0, $d651cb95b201e088$export$2e2bcd8739ae039));
    const fieldKeyPathRef = $32rMB.useRef(null);
    // ======================== Errors ========================
    // >>>>> Collect sub field errors
    const [subFieldErrors, setSubFieldErrors] = (0, $621364241b0719fc$export$2e2bcd8739ae039)({});
    // >>>>> Current field errors
    const [meta, setMeta] = (0, $8ad52953f3345b2f$export$2e2bcd8739ae039)(()=>$7d2d0991fbc56fb4$var$genEmptyMeta());
    const onMetaChange = (nextMeta)=>{
        // This keyInfo is not correct when field is removed
        // Since origin keyManager no longer keep the origin key anymore
        // Which means we need cache origin one and reuse when removed
        const keyInfo = listContext?.getKey(nextMeta.name);
        // Destroy will reset all the meta
        setMeta(nextMeta.destroy ? $7d2d0991fbc56fb4$var$genEmptyMeta() : nextMeta, true);
        // Bump to parent since noStyle
        if (noStyle && help !== false && notifyParentMetaChange) {
            let namePath = nextMeta.name;
            if (!nextMeta.destroy) {
                if (keyInfo !== undefined) {
                    const [fieldKey, restPath] = keyInfo;
                    namePath = [
                        fieldKey
                    ].concat((0, $3746fb019e1f2ee5$export$2e2bcd8739ae039)(restPath));
                    fieldKeyPathRef.current = namePath;
                }
            } else // Use origin cache data
            namePath = fieldKeyPathRef.current || namePath;
            notifyParentMetaChange(nextMeta, namePath);
        }
    };
    // >>>>> Collect noStyle Field error to the top FormItem
    const onSubItemMetaChange = (subMeta, uniqueKeys)=>{
        // Only `noStyle` sub item will trigger
        setSubFieldErrors((prevSubFieldErrors)=>{
            const clone = {
                ...prevSubFieldErrors
            };
            // name: ['user', 1] + key: [4] = ['user', 4]
            const mergedNamePath = [].concat((0, $3746fb019e1f2ee5$export$2e2bcd8739ae039)(subMeta.name.slice(0, -1)), (0, $3746fb019e1f2ee5$export$2e2bcd8739ae039)(uniqueKeys));
            const mergedNameKey = mergedNamePath.join($7d2d0991fbc56fb4$var$NAME_SPLIT);
            if (subMeta.destroy) // Remove
            delete clone[mergedNameKey];
            else // Update
            clone[mergedNameKey] = subMeta;
            return clone;
        });
    };
    // >>>>> Get merged errors
    const [mergedErrors, mergedWarnings] = $32rMB.useMemo(()=>{
        const errorList = (0, $3746fb019e1f2ee5$export$2e2bcd8739ae039)(meta.errors);
        const warningList = (0, $3746fb019e1f2ee5$export$2e2bcd8739ae039)(meta.warnings);
        Object.values(subFieldErrors).forEach((subFieldError)=>{
            errorList.push.apply(errorList, (0, $3746fb019e1f2ee5$export$2e2bcd8739ae039)(subFieldError.errors || []));
            warningList.push.apply(warningList, (0, $3746fb019e1f2ee5$export$2e2bcd8739ae039)(subFieldError.warnings || []));
        });
        return [
            errorList,
            warningList
        ];
    }, [
        subFieldErrors,
        meta.errors,
        meta.warnings
    ]);
    // ===================== Children Ref =====================
    const getItemRef = (0, $027916070d7c16bd$export$2e2bcd8739ae039)();
    // ======================== Render ========================
    function renderLayout(baseChildren, fieldId, isRequired) {
        if (noStyle && !hidden) return /*#__PURE__*/ $hO8yS.createElement((0, $70955fdde9fcfcf8$export$2e2bcd8739ae039), {
            prefixCls: prefixCls,
            hasFeedback: props.hasFeedback,
            validateStatus: props.validateStatus,
            meta: meta,
            errors: mergedErrors,
            warnings: mergedWarnings,
            noStyle: true,
            name: name
        }, baseChildren);
        return /*#__PURE__*/ $hO8yS.createElement((0, $dcb1d2002ceccf0a$export$2e2bcd8739ae039), {
            key: "row",
            ...props,
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(className, cssVarCls, rootCls, hashId),
            prefixCls: prefixCls,
            fieldId: fieldId,
            isRequired: isRequired,
            errors: mergedErrors,
            warnings: mergedWarnings,
            meta: meta,
            onSubItemMetaChange: onSubItemMetaChange,
            layout: layout,
            name: name
        }, baseChildren);
    }
    if (!hasName && !isRenderProps && !dependencies) return renderLayout(mergedChildren);
    let variables = {};
    if (typeof label === 'string') variables.label = label;
    else if (name) variables.label = String(name);
    if (messageVariables) variables = {
        ...variables,
        ...messageVariables
    };
    // >>>>> With Field
    return /*#__PURE__*/ $hO8yS.createElement((0, $8b77da48dce7c38e$export$2e2bcd8739ae039), {
        ...props,
        messageVariables: variables,
        trigger: trigger,
        validateTrigger: mergedValidateTrigger,
        onMetaChange: onMetaChange
    }, (control, renderMeta, context)=>{
        const mergedName = (0, $64986a7e8b86a8b3$export$45b10814cc054894)(name).length && renderMeta ? renderMeta.name : [];
        const fieldId = (0, $64986a7e8b86a8b3$export$f4457e83c74ac000)(mergedName, formName);
        const isRequired = required !== undefined ? required : !!rules?.some((rule)=>{
            if (rule && typeof rule === 'object' && rule.required && !rule.warningOnly) return true;
            if (typeof rule === 'function') {
                const ruleEntity = rule(context);
                return ruleEntity?.required && !ruleEntity?.warningOnly;
            }
            return false;
        });
        // ======================= Children =======================
        const mergedControl = {
            ...control
        };
        let childNode = null;
        if (Array.isArray(mergedChildren) && hasName) childNode = mergedChildren;
        else if (isRenderProps && (!(shouldUpdate || dependencies) || hasName)) ;
        else if (dependencies && !isRenderProps && !hasName) ;
        else if (/*#__PURE__*/ $N3oW3.isValidElement(mergedChildren)) {
            const childProps = {
                ...mergedChildren.props,
                ...mergedControl
            };
            if (!childProps.id) childProps.id = fieldId;
            if (help || mergedErrors.length > 0 || mergedWarnings.length > 0 || props.extra) {
                const describedbyArr = [];
                if (help || mergedErrors.length > 0) describedbyArr.push(`${fieldId}_help`);
                if (props.extra) describedbyArr.push(`${fieldId}_extra`);
                childProps['aria-describedby'] = describedbyArr.join(' ');
            }
            if (mergedErrors.length > 0) childProps['aria-invalid'] = 'true';
            if (isRequired) childProps['aria-required'] = 'true';
            if ((0, $2706ed817e87019d$export$c1cec34af06bcf7)(mergedChildren)) childProps.ref = getItemRef(mergedName, mergedChildren);
            // We should keep user origin event handler
            const triggers = new Set([].concat((0, $3746fb019e1f2ee5$export$2e2bcd8739ae039)((0, $64986a7e8b86a8b3$export$45b10814cc054894)(trigger)), (0, $3746fb019e1f2ee5$export$2e2bcd8739ae039)((0, $64986a7e8b86a8b3$export$45b10814cc054894)(mergedValidateTrigger))));
            triggers.forEach((eventName)=>{
                childProps[eventName] = (...args)=>{
                    mergedControl[eventName]?.(...args);
                    mergedChildren.props[eventName]?.(...args);
                };
            });
            // List of props that need to be watched for changes -> if changes are detected in MemoInput -> rerender
            const watchingChildProps = [
                childProps['aria-required'],
                childProps['aria-invalid'],
                childProps['aria-describedby']
            ];
            childNode = /*#__PURE__*/ $hO8yS.createElement($7d2d0991fbc56fb4$var$MemoInput, {
                control: mergedControl,
                update: mergedChildren,
                childProps: watchingChildProps
            }, (0, $62609775897a768c$export$e530037191fcd5d7)(mergedChildren, childProps));
        } else if (isRenderProps && (shouldUpdate || dependencies) && !hasName) childNode = mergedChildren(context);
        else childNode = mergedChildren;
        return renderLayout(childNode, fieldId, isRequired);
    });
}
const $7d2d0991fbc56fb4$var$FormItem = $7d2d0991fbc56fb4$var$InternalFormItem;
$7d2d0991fbc56fb4$var$FormItem.useStatus = (0, $5dea4debaa0dba86$export$2e2bcd8739ae039);
var $7d2d0991fbc56fb4$export$2e2bcd8739ae039 = $7d2d0991fbc56fb4$var$FormItem;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");




"use client";
const $fe2a1716a4511ce6$var$FormList = ({ prefixCls: customizePrefixCls, children: children, ...props })=>{
    const { getPrefixCls: getPrefixCls } = $32rMB.useContext((0, $dd01e2f5a4b8605d$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('form', customizePrefixCls);
    const contextValue = $32rMB.useMemo(()=>({
            prefixCls: prefixCls,
            status: 'error'
        }), [
        prefixCls
    ]);
    return /*#__PURE__*/ $hO8yS.createElement((0, $1c2c0bc5ee309617$export$2e2bcd8739ae039), {
        ...props
    }, (fields, operation, meta)=>/*#__PURE__*/ $hO8yS.createElement((0, $a1a112e4dddc1035$export$fb6582d3042cc879).Provider, {
            value: contextValue
        }, children(fields.map((field)=>({
                ...field,
                fieldKey: field.key
            })), operation, {
            errors: meta.errors,
            warnings: meta.warnings
        })));
};
var $fe2a1716a4511ce6$export$2e2bcd8739ae039 = $fe2a1716a4511ce6$var$FormList;


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");

function $350c575804464796$export$2e2bcd8739ae039() {
    const { form: form } = $32rMB.useContext((0, $a1a112e4dddc1035$export$c24727297075ec6a));
    return form;
}


"use client";
const $3ab5acc35160fbcc$var$Form = (0, $92bef01064ba88da$export$2e2bcd8739ae039);
$3ab5acc35160fbcc$var$Form.Item = (0, $7d2d0991fbc56fb4$export$2e2bcd8739ae039);
$3ab5acc35160fbcc$var$Form.List = (0, $fe2a1716a4511ce6$export$2e2bcd8739ae039);
$3ab5acc35160fbcc$var$Form.ErrorList = (0, $2ca4ef559a646f6d$export$2e2bcd8739ae039);
$3ab5acc35160fbcc$var$Form.useForm = (0, $33a442f1517960cf$export$2e2bcd8739ae039);
$3ab5acc35160fbcc$var$Form.useFormInstance = (0, $350c575804464796$export$2e2bcd8739ae039);
$3ab5acc35160fbcc$var$Form.useWatch = (0, $7eda32901ee1cabd$export$2e2bcd8739ae039);
$3ab5acc35160fbcc$var$Form.Provider = (0, $a1a112e4dddc1035$export$8ce1ff4f94d08846);
var $3ab5acc35160fbcc$export$2e2bcd8739ae039 = $3ab5acc35160fbcc$var$Form;

parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");










function $2086d48ba031927a$export$a157d95850191a12(token) {
    return (0, $90c11ca6cb263fd9$export$4950aa0f605343fb)(token, {
        inputAffixPadding: token.paddingXXS
    });
}
const $2086d48ba031927a$export$bd8b682992bc9781 = (token)=>{
    const { controlHeight: controlHeight, fontSize: fontSize, lineHeight: lineHeight, lineWidth: lineWidth, controlHeightSM: controlHeightSM, controlHeightLG: controlHeightLG, fontSizeLG: fontSizeLG, lineHeightLG: lineHeightLG, paddingSM: paddingSM, controlPaddingHorizontalSM: controlPaddingHorizontalSM, controlPaddingHorizontal: controlPaddingHorizontal, colorFillAlter: colorFillAlter, colorPrimaryHover: colorPrimaryHover, colorPrimary: colorPrimary, controlOutlineWidth: controlOutlineWidth, controlOutline: controlOutline, colorErrorOutline: colorErrorOutline, colorWarningOutline: colorWarningOutline, colorBgContainer: colorBgContainer, inputFontSize: inputFontSize, inputFontSizeLG: inputFontSizeLG, inputFontSizeSM: inputFontSizeSM } = token;
    const mergedFontSize = inputFontSize || fontSize;
    const mergedFontSizeSM = inputFontSizeSM || mergedFontSize;
    const mergedFontSizeLG = inputFontSizeLG || fontSizeLG;
    const paddingBlock = Math.round((controlHeight - mergedFontSize * lineHeight) / 2 * 10) / 10 - lineWidth;
    const paddingBlockSM = Math.round((controlHeightSM - mergedFontSizeSM * lineHeight) / 2 * 10) / 10 - lineWidth;
    const paddingBlockLG = Math.ceil((controlHeightLG - mergedFontSizeLG * lineHeightLG) / 2 * 10) / 10 - lineWidth;
    return {
        paddingBlock: Math.max(paddingBlock, 0),
        paddingBlockSM: Math.max(paddingBlockSM, 0),
        paddingBlockLG: Math.max(paddingBlockLG, 0),
        paddingInline: paddingSM - lineWidth,
        paddingInlineSM: controlPaddingHorizontalSM - lineWidth,
        paddingInlineLG: controlPaddingHorizontal - lineWidth,
        addonBg: colorFillAlter,
        activeBorderColor: colorPrimary,
        hoverBorderColor: colorPrimaryHover,
        activeShadow: `0 0 0 ${controlOutlineWidth}px ${controlOutline}`,
        errorActiveShadow: `0 0 0 ${controlOutlineWidth}px ${colorErrorOutline}`,
        warningActiveShadow: `0 0 0 ${controlOutlineWidth}px ${colorWarningOutline}`,
        hoverBg: colorBgContainer,
        activeBg: colorBgContainer,
        inputFontSize: mergedFontSize,
        inputFontSizeLG: mergedFontSizeLG,
        inputFontSizeSM: mergedFontSizeSM
    };
};




const $8640b68e85787e4a$export$bf820fba296f2fd8 = (token)=>({
        borderColor: token.hoverBorderColor,
        backgroundColor: token.hoverBg
    });
const $8640b68e85787e4a$export$12789f962d420a93 = (token)=>({
        color: token.colorTextDisabled,
        backgroundColor: token.colorBgContainerDisabled,
        borderColor: token.colorBorder,
        boxShadow: 'none',
        cursor: 'not-allowed',
        opacity: 1,
        'input[disabled], textarea[disabled]': {
            cursor: 'not-allowed'
        },
        '&:hover:not([disabled])': {
            ...$8640b68e85787e4a$export$bf820fba296f2fd8((0, $90c11ca6cb263fd9$export$4950aa0f605343fb)(token, {
                hoverBorderColor: token.colorBorder,
                hoverBg: token.colorBgContainerDisabled
            }))
        }
    });
const $8640b68e85787e4a$export$8c569e4cc3fd115f = (token, options)=>({
        background: token.colorBgContainer,
        borderWidth: token.lineWidth,
        borderStyle: token.lineType,
        borderColor: options.borderColor,
        '&:hover': {
            borderColor: options.hoverBorderColor,
            backgroundColor: token.hoverBg
        },
        '&:focus, &:focus-within': {
            borderColor: options.activeBorderColor,
            boxShadow: options.activeShadow,
            outline: 0,
            backgroundColor: token.activeBg
        }
    });
const $8640b68e85787e4a$var$genOutlinedStatusStyle = (token, options)=>({
        [`&${token.componentCls}-status-${options.status}:not(${token.componentCls}-disabled)`]: {
            ...$8640b68e85787e4a$export$8c569e4cc3fd115f(token, options),
            [`${token.componentCls}-prefix, ${token.componentCls}-suffix`]: {
                color: options.affixColor
            }
        },
        [`&${token.componentCls}-status-${options.status}${token.componentCls}-disabled`]: {
            borderColor: options.borderColor
        }
    });
const $8640b68e85787e4a$export$53795bafd774ce02 = (token, extraStyles)=>({
        '&-outlined': {
            ...$8640b68e85787e4a$export$8c569e4cc3fd115f(token, {
                borderColor: token.colorBorder,
                hoverBorderColor: token.hoverBorderColor,
                activeBorderColor: token.activeBorderColor,
                activeShadow: token.activeShadow
            }),
            [`&${token.componentCls}-disabled, &[disabled]`]: {
                ...$8640b68e85787e4a$export$12789f962d420a93(token)
            },
            ...$8640b68e85787e4a$var$genOutlinedStatusStyle(token, {
                status: 'error',
                borderColor: token.colorError,
                hoverBorderColor: token.colorErrorBorderHover,
                activeBorderColor: token.colorError,
                activeShadow: token.errorActiveShadow,
                affixColor: token.colorError
            }),
            ...$8640b68e85787e4a$var$genOutlinedStatusStyle(token, {
                status: 'warning',
                borderColor: token.colorWarning,
                hoverBorderColor: token.colorWarningBorderHover,
                activeBorderColor: token.colorWarning,
                activeShadow: token.warningActiveShadow,
                affixColor: token.colorWarning
            }),
            ...extraStyles
        }
    });
const $8640b68e85787e4a$var$genOutlinedGroupStatusStyle = (token, options)=>({
        [`&${token.componentCls}-group-wrapper-status-${options.status}`]: {
            [`${token.componentCls}-group-addon`]: {
                borderColor: options.addonBorderColor,
                color: options.addonColor
            }
        }
    });
const $8640b68e85787e4a$export$8f88f32c046ff727 = (token)=>({
        '&-outlined': {
            [`${token.componentCls}-group`]: {
                '&-addon': {
                    background: token.addonBg,
                    border: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
                },
                '&-addon:first-child': {
                    borderInlineEnd: 0
                },
                '&-addon:last-child': {
                    borderInlineStart: 0
                }
            },
            ...$8640b68e85787e4a$var$genOutlinedGroupStatusStyle(token, {
                status: 'error',
                addonBorderColor: token.colorError,
                addonColor: token.colorErrorText
            }),
            ...$8640b68e85787e4a$var$genOutlinedGroupStatusStyle(token, {
                status: 'warning',
                addonBorderColor: token.colorWarning,
                addonColor: token.colorWarningText
            }),
            [`&${token.componentCls}-group-wrapper-disabled`]: {
                [`${token.componentCls}-group-addon`]: {
                    ...$8640b68e85787e4a$export$12789f962d420a93(token)
                }
            }
        }
    });
const $8640b68e85787e4a$export$b6de5da7f39edfcb = (token, extraStyles)=>{
    const { componentCls: componentCls } = token;
    return {
        '&-borderless': {
            background: 'transparent',
            border: 'none',
            '&:focus, &:focus-within': {
                outline: 'none'
            },
            // >>>>> Disabled
            [`&${componentCls}-disabled, &[disabled]`]: {
                color: token.colorTextDisabled,
                cursor: 'not-allowed'
            },
            // >>>>> Status
            [`&${componentCls}-status-error`]: {
                '&, & input, & textarea': {
                    color: token.colorError
                }
            },
            [`&${componentCls}-status-warning`]: {
                '&, & input, & textarea': {
                    color: token.colorWarning
                }
            },
            ...extraStyles
        }
    };
};
/* ============== Filled ============== */ const $8640b68e85787e4a$var$genBaseFilledStyle = (token, options)=>({
        background: options.bg,
        borderWidth: token.lineWidth,
        borderStyle: token.lineType,
        borderColor: 'transparent',
        'input&, & input, textarea&, & textarea': {
            color: options?.inputColor ?? 'unset'
        },
        '&:hover': {
            background: options.hoverBg
        },
        '&:focus, &:focus-within': {
            outline: 0,
            borderColor: options.activeBorderColor,
            backgroundColor: token.activeBg
        }
    });
const $8640b68e85787e4a$var$genFilledStatusStyle = (token, options)=>({
        [`&${token.componentCls}-status-${options.status}:not(${token.componentCls}-disabled)`]: {
            ...$8640b68e85787e4a$var$genBaseFilledStyle(token, options),
            [`${token.componentCls}-prefix, ${token.componentCls}-suffix`]: {
                color: options.affixColor
            }
        }
    });
const $8640b68e85787e4a$export$b8365cd7e6671d79 = (token, extraStyles)=>({
        '&-filled': {
            ...$8640b68e85787e4a$var$genBaseFilledStyle(token, {
                bg: token.colorFillTertiary,
                hoverBg: token.colorFillSecondary,
                activeBorderColor: token.activeBorderColor,
                inputColor: token.colorText
            }),
            [`&${token.componentCls}-disabled, &[disabled]`]: {
                ...$8640b68e85787e4a$export$12789f962d420a93(token)
            },
            ...$8640b68e85787e4a$var$genFilledStatusStyle(token, {
                status: 'error',
                bg: token.colorErrorBg,
                hoverBg: token.colorErrorBgHover,
                activeBorderColor: token.colorError,
                inputColor: token.colorErrorText,
                affixColor: token.colorError
            }),
            ...$8640b68e85787e4a$var$genFilledStatusStyle(token, {
                status: 'warning',
                bg: token.colorWarningBg,
                hoverBg: token.colorWarningBgHover,
                activeBorderColor: token.colorWarning,
                inputColor: token.colorWarningText,
                affixColor: token.colorWarning
            }),
            ...extraStyles
        }
    });
const $8640b68e85787e4a$var$genFilledGroupStatusStyle = (token, options)=>({
        [`&${token.componentCls}-group-wrapper-status-${options.status}`]: {
            [`${token.componentCls}-group-addon`]: {
                background: options.addonBg,
                color: options.addonColor
            }
        }
    });
const $8640b68e85787e4a$export$542c0fce51b1d515 = (token)=>({
        '&-filled': {
            [`${token.componentCls}-group-addon`]: {
                background: token.colorFillTertiary,
                '&:last-child': {
                    position: 'static'
                }
            },
            ...$8640b68e85787e4a$var$genFilledGroupStatusStyle(token, {
                status: 'error',
                addonBg: token.colorErrorBg,
                addonColor: token.colorErrorText
            }),
            ...$8640b68e85787e4a$var$genFilledGroupStatusStyle(token, {
                status: 'warning',
                addonBg: token.colorWarningBg,
                addonColor: token.colorWarningText
            }),
            [`&${token.componentCls}-group-wrapper-disabled`]: {
                [`${token.componentCls}-group`]: {
                    '&-addon': {
                        background: token.colorFillTertiary,
                        color: token.colorTextDisabled
                    },
                    '&-addon:first-child': {
                        borderInlineStart: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                        borderTop: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                        borderBottom: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
                    },
                    '&-addon:last-child': {
                        borderInlineEnd: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                        borderTop: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                        borderBottom: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
                    }
                }
            }
        }
    });
const $8640b68e85787e4a$export$7617a11352d704b9 = (token, options)=>({
        background: token.colorBgContainer,
        borderWidth: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.lineWidth)} 0`,
        borderStyle: `${token.lineType} none`,
        borderColor: `transparent transparent ${options.borderColor} transparent`,
        borderRadius: 0,
        '&:hover': {
            borderColor: `transparent transparent ${options.hoverBorderColor} transparent`,
            backgroundColor: token.hoverBg
        },
        '&:focus, &:focus-within': {
            borderColor: `transparent transparent ${options.activeBorderColor} transparent`,
            outline: 0,
            backgroundColor: token.activeBg
        }
    });
const $8640b68e85787e4a$var$genUnderlinedStatusStyle = (token, options)=>({
        [`&${token.componentCls}-status-${options.status}:not(${token.componentCls}-disabled)`]: {
            ...$8640b68e85787e4a$export$7617a11352d704b9(token, options),
            [`${token.componentCls}-prefix, ${token.componentCls}-suffix`]: {
                color: options.affixColor
            }
        },
        [`&${token.componentCls}-status-${options.status}${token.componentCls}-disabled`]: {
            borderColor: `transparent transparent ${options.borderColor} transparent`
        }
    });
const $8640b68e85787e4a$export$34771e60e0439351 = (token, extraStyles)=>({
        '&-underlined': {
            ...$8640b68e85787e4a$export$7617a11352d704b9(token, {
                borderColor: token.colorBorder,
                hoverBorderColor: token.hoverBorderColor,
                activeBorderColor: token.activeBorderColor,
                activeShadow: token.activeShadow
            }),
            // >>>>> Disabled
            [`&${token.componentCls}-disabled, &[disabled]`]: {
                color: token.colorTextDisabled,
                boxShadow: 'none',
                cursor: 'not-allowed',
                '&:hover': {
                    borderColor: `transparent transparent ${token.colorBorder} transparent`
                }
            },
            'input[disabled], textarea[disabled]': {
                cursor: 'not-allowed'
            },
            ...$8640b68e85787e4a$var$genUnderlinedStatusStyle(token, {
                status: 'error',
                borderColor: token.colorError,
                hoverBorderColor: token.colorErrorBorderHover,
                activeBorderColor: token.colorError,
                activeShadow: token.errorActiveShadow,
                affixColor: token.colorError
            }),
            ...$8640b68e85787e4a$var$genUnderlinedStatusStyle(token, {
                status: 'warning',
                borderColor: token.colorWarning,
                hoverBorderColor: token.colorWarningBorderHover,
                activeBorderColor: token.colorWarning,
                activeShadow: token.warningActiveShadow,
                affixColor: token.colorWarning
            }),
            ...extraStyles
        }
    });


const $e8a8f826922d3542$export$92095d0f4c77bd56 = (color)=>({
        // Firefox
        '&::-moz-placeholder': {
            opacity: 1
        },
        '&::placeholder': {
            color: color,
            userSelect: 'none' // https://github.com/ant-design/ant-design/pull/32639
        },
        '&:placeholder-shown': {
            textOverflow: 'ellipsis'
        }
    });
const $e8a8f826922d3542$export$3fe86db3643510f9 = (token)=>({
        borderColor: token.activeBorderColor,
        boxShadow: token.activeShadow,
        outline: 0,
        backgroundColor: token.activeBg
    });
const $e8a8f826922d3542$var$genInputLargeStyle = (token)=>{
    const { paddingBlockLG: paddingBlockLG, lineHeightLG: lineHeightLG, borderRadiusLG: borderRadiusLG, paddingInlineLG: paddingInlineLG } = token;
    return {
        padding: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(paddingBlockLG)} ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(paddingInlineLG)}`,
        fontSize: token.inputFontSizeLG,
        lineHeight: lineHeightLG,
        borderRadius: borderRadiusLG
    };
};
const $e8a8f826922d3542$export$bb047f62c5a56f90 = (token)=>({
        padding: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.paddingBlockSM)} ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.paddingInlineSM)}`,
        fontSize: token.inputFontSizeSM,
        borderRadius: token.borderRadiusSM
    });
const $e8a8f826922d3542$export$8c9a381315f3ebcd = (token, option = {})=>({
        position: 'relative',
        display: 'inline-block',
        width: '100%',
        minWidth: 0,
        padding: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.paddingBlock)} ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.paddingInline)}`,
        color: token.colorText,
        fontSize: token.inputFontSize,
        lineHeight: token.lineHeight,
        borderRadius: token.borderRadius,
        transition: `all ${token.motionDurationMid}`,
        ...$e8a8f826922d3542$export$92095d0f4c77bd56(token.colorTextPlaceholder),
        // Size
        '&-lg': {
            ...$e8a8f826922d3542$var$genInputLargeStyle(token),
            ...option.largeStyle
        },
        '&-sm': {
            ...$e8a8f826922d3542$export$bb047f62c5a56f90(token),
            ...option.smallStyle
        },
        // RTL
        '&-rtl, &-textarea-rtl': {
            direction: 'rtl'
        }
    });
const $e8a8f826922d3542$export$ffe8b2a9bd2e5cfe = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    return {
        position: 'relative',
        display: 'table',
        width: '100%',
        borderCollapse: 'separate',
        borderSpacing: 0,
        // Undo padding and float of grid classes
        "&[class*='col-']": {
            paddingInlineEnd: token.paddingXS,
            '&:last-child': {
                paddingInlineEnd: 0
            }
        },
        // Sizing options
        [`&-lg ${componentCls}, &-lg > ${componentCls}-group-addon`]: {
            ...$e8a8f826922d3542$var$genInputLargeStyle(token)
        },
        [`&-sm ${componentCls}, &-sm > ${componentCls}-group-addon`]: {
            ...$e8a8f826922d3542$export$bb047f62c5a56f90(token)
        },
        // Fix https://github.com/ant-design/ant-design/issues/5754
        [`&-lg ${antCls}-select-single`]: {
            height: token.controlHeightLG
        },
        [`&-sm ${antCls}-select-single`]: {
            height: token.controlHeightSM
        },
        [`> ${componentCls}`]: {
            display: 'table-cell',
            '&:not(:first-child):not(:last-child)': {
                borderRadius: 0
            }
        },
        [`${componentCls}-group`]: {
            '&-addon, &-wrap': {
                display: 'table-cell',
                width: 1,
                whiteSpace: 'nowrap',
                verticalAlign: 'middle',
                '&:not(:first-child):not(:last-child)': {
                    borderRadius: 0
                }
            },
            '&-wrap > *': {
                display: 'block !important'
            },
            '&-addon': {
                position: 'relative',
                padding: `0 ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.paddingInline)}`,
                color: token.colorText,
                fontWeight: 'normal',
                fontSize: token.inputFontSize,
                textAlign: 'center',
                borderRadius: token.borderRadius,
                transition: `all ${token.motionDurationSlow}`,
                lineHeight: 1,
                // Reset Select's style in addon
                [`${antCls}-select`]: {
                    margin: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.calc(token.paddingBlock).add(1).mul(-1).equal())} ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.calc(token.paddingInline).mul(-1).equal())}`,
                    [`&${antCls}-select-single:not(${antCls}-select-customize-input):not(${antCls}-pagination-size-changer)`]: {
                        backgroundColor: 'inherit',
                        border: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} transparent`,
                        boxShadow: 'none'
                    }
                },
                // https://github.com/ant-design/ant-design/issues/31333
                [`${antCls}-cascader-picker`]: {
                    margin: `-9px ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.calc(token.paddingInline).mul(-1).equal())}`,
                    backgroundColor: 'transparent',
                    [`${antCls}-cascader-input`]: {
                        textAlign: 'start',
                        border: 0,
                        boxShadow: 'none'
                    }
                }
            }
        },
        [componentCls]: {
            width: '100%',
            marginBottom: 0,
            textAlign: 'inherit',
            '&:focus': {
                zIndex: 1,
                // Fix https://gw.alipayobjects.com/zos/rmsportal/DHNpoqfMXSfrSnlZvhsJ.png
                borderInlineEndWidth: 1
            },
            '&:hover': {
                zIndex: 1,
                borderInlineEndWidth: 1
            }
        },
        // Reset rounded corners
        [`> ${componentCls}:first-child, ${componentCls}-group-addon:first-child`]: {
            borderStartEndRadius: 0,
            borderEndEndRadius: 0,
            // Reset Select's style in addon
            [`${antCls}-select`]: {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0
            }
        },
        [`> ${componentCls}-affix-wrapper`]: {
            [`&:not(:first-child) ${componentCls}`]: {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
            },
            [`&:not(:last-child) ${componentCls}`]: {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0
            }
        },
        [`> ${componentCls}:last-child, ${componentCls}-group-addon:last-child`]: {
            borderStartStartRadius: 0,
            borderEndStartRadius: 0,
            // Reset Select's style in addon
            [`${antCls}-select`]: {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
            }
        },
        [`${componentCls}-affix-wrapper`]: {
            '&:not(:last-child)': {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0
            },
            '&:not(:first-child)': {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
            }
        },
        [`&${componentCls}-group-compact`]: {
            display: 'block',
            ...(0, $2f353af2b0f7600b$export$8c467e8859fdef13)(),
            [`${componentCls}-group-addon, ${componentCls}-group-wrap, > ${componentCls}`]: {
                '&:not(:first-child):not(:last-child)': {
                    borderInlineEndWidth: token.lineWidth,
                    '&:hover, &:focus': {
                        zIndex: 1
                    }
                }
            },
            '& > *': {
                display: 'inline-flex',
                float: 'none',
                verticalAlign: 'top',
                // https://github.com/ant-design/ant-design-pro/issues/139
                borderRadius: 0
            },
            [`
        & > ${componentCls}-affix-wrapper,
        & > ${componentCls}-number-affix-wrapper,
        & > ${antCls}-picker-range
      `]: {
                display: 'inline-flex'
            },
            '& > *:not(:last-child)': {
                marginInlineEnd: token.calc(token.lineWidth).mul(-1).equal(),
                borderInlineEndWidth: token.lineWidth
            },
            // Undo float for .ant-input-group .ant-input
            [componentCls]: {
                float: 'none'
            },
            // reset border for Select, DatePicker, AutoComplete, Cascader, Mention, TimePicker, Input
            [`& > ${antCls}-select,
      & > ${antCls}-select-auto-complete ${componentCls},
      & > ${antCls}-cascader-picker ${componentCls},
      & > ${componentCls}-group-wrapper ${componentCls}`]: {
                borderInlineEndWidth: token.lineWidth,
                borderRadius: 0,
                '&:hover, &:focus': {
                    zIndex: 1
                }
            },
            [`& > ${antCls}-select-focused`]: {
                zIndex: 1
            },
            // update z-index for arrow icon
            [`& > ${antCls}-select > ${antCls}-select-arrow`]: {
                zIndex: 1 // https://github.com/ant-design/ant-design/issues/20371
            },
            [`& > *:first-child,
      & > ${antCls}-select:first-child,
      & > ${antCls}-select-auto-complete:first-child ${componentCls},
      & > ${antCls}-cascader-picker:first-child ${componentCls}`]: {
                borderStartStartRadius: token.borderRadius,
                borderEndStartRadius: token.borderRadius
            },
            [`& > *:last-child,
      & > ${antCls}-select:last-child,
      & > ${antCls}-cascader-picker:last-child ${componentCls},
      & > ${antCls}-cascader-picker-focused:last-child ${componentCls}`]: {
                borderInlineEndWidth: token.lineWidth,
                borderStartEndRadius: token.borderRadius,
                borderEndEndRadius: token.borderRadius
            },
            // https://github.com/ant-design/ant-design/issues/12493
            [`& > ${antCls}-select-auto-complete ${componentCls}`]: {
                verticalAlign: 'top'
            },
            [`${componentCls}-group-wrapper + ${componentCls}-group-wrapper`]: {
                marginInlineStart: token.calc(token.lineWidth).mul(-1).equal(),
                [`${componentCls}-affix-wrapper`]: {
                }
            }
        }
    };
};
const $e8a8f826922d3542$export$9a752c3888370836 = (token)=>{
    const { componentCls: componentCls, controlHeightSM: controlHeightSM, lineWidth: lineWidth, calc: calc } = token;
    const FIXED_CHROME_COLOR_HEIGHT = 16;
    const colorSmallPadding = calc(controlHeightSM).sub(calc(lineWidth).mul(2)).sub(FIXED_CHROME_COLOR_HEIGHT).div(2).equal();
    return {
        [componentCls]: {
            ...(0, $2f353af2b0f7600b$export$23997c3e44cc1c59)(token),
            ...$e8a8f826922d3542$export$8c9a381315f3ebcd(token),
            // Variants
            ...(0, $8640b68e85787e4a$export$53795bafd774ce02)(token),
            ...(0, $8640b68e85787e4a$export$b8365cd7e6671d79)(token),
            ...(0, $8640b68e85787e4a$export$b6de5da7f39edfcb)(token),
            ...(0, $8640b68e85787e4a$export$34771e60e0439351)(token),
            '&[type="color"]': {
                height: token.controlHeight,
                [`&${componentCls}-lg`]: {
                    height: token.controlHeightLG
                },
                [`&${componentCls}-sm`]: {
                    height: controlHeightSM,
                    paddingTop: colorSmallPadding,
                    paddingBottom: colorSmallPadding
                }
            },
            '&[type="search"]::-webkit-search-cancel-button, &[type="search"]::-webkit-search-decoration': {
                appearance: 'none'
            }
        }
    };
};
const $e8a8f826922d3542$var$genAllowClearStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        // ========================= Input =========================
        [`${componentCls}-clear-icon`]: {
            margin: 0,
            padding: 0,
            lineHeight: 0,
            color: token.colorTextQuaternary,
            fontSize: token.fontSizeIcon,
            verticalAlign: -1,
            // https://github.com/ant-design/ant-design/pull/18151
            // https://codesandbox.io/s/wizardly-sun-u10br
            cursor: 'pointer',
            transition: `color ${token.motionDurationSlow}`,
            border: 'none',
            outline: 'none',
            backgroundColor: 'transparent',
            '&:hover': {
                color: token.colorIcon
            },
            '&:active': {
                color: token.colorText
            },
            '&-hidden': {
                visibility: 'hidden'
            },
            '&-has-suffix': {
                margin: `0 ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.inputAffixPadding)}`
            }
        }
    };
};
const $e8a8f826922d3542$export$77a75da75a374eb9 = (token)=>{
    const { componentCls: componentCls, inputAffixPadding: inputAffixPadding, colorTextDescription: colorTextDescription, motionDurationSlow: motionDurationSlow, colorIcon: colorIcon, colorIconHover: colorIconHover, iconCls: iconCls } = token;
    const affixCls = `${componentCls}-affix-wrapper`;
    const affixClsDisabled = `${componentCls}-affix-wrapper-disabled`;
    return {
        [affixCls]: {
            ...$e8a8f826922d3542$export$8c9a381315f3ebcd(token),
            display: 'inline-flex',
            '&-focused, &:focus': {
                zIndex: 1
            },
            [`> input${componentCls}`]: {
                padding: 0
            },
            [`> input${componentCls}, > textarea${componentCls}`]: {
                fontSize: 'inherit',
                border: 'none',
                borderRadius: 0,
                outline: 'none',
                background: 'transparent',
                color: 'inherit',
                '&::-ms-reveal': {
                    display: 'none'
                },
                '&:focus': {
                    boxShadow: 'none !important'
                }
            },
            '&::before': {
                display: 'inline-block',
                width: 0,
                visibility: 'hidden',
                content: '"\\a0"'
            },
            [componentCls]: {
                '&-prefix, &-suffix': {
                    display: 'flex',
                    flex: 'none',
                    alignItems: 'center',
                    '> *:not(:last-child)': {
                        marginInlineEnd: token.paddingXS
                    }
                },
                '&-show-count-suffix': {
                    color: colorTextDescription,
                    direction: 'ltr'
                },
                '&-show-count-has-suffix': {
                    marginInlineEnd: token.paddingXXS
                },
                '&-prefix': {
                    marginInlineEnd: inputAffixPadding
                },
                '&-suffix': {
                    marginInlineStart: inputAffixPadding
                }
            },
            ...$e8a8f826922d3542$var$genAllowClearStyle(token),
            // password
            [`${iconCls}${componentCls}-password-icon`]: {
                color: colorIcon,
                cursor: 'pointer',
                transition: `all ${motionDurationSlow}`,
                '&:hover': {
                    color: colorIconHover
                }
            }
        },
        // 覆盖 affix-wrapper borderRadius！
        [`${componentCls}-underlined`]: {
            borderRadius: 0
        },
        [affixClsDisabled]: {
            // password disabled
            [`${iconCls}${componentCls}-password-icon`]: {
                color: colorIcon,
                cursor: 'not-allowed',
                '&:hover': {
                    color: colorIcon
                }
            }
        }
    };
};
const $e8a8f826922d3542$var$genGroupStyle = (token)=>{
    const { componentCls: componentCls, borderRadiusLG: borderRadiusLG, borderRadiusSM: borderRadiusSM } = token;
    return {
        [`${componentCls}-group`]: {
            // Style for input-group: input with label, with button or dropdown...
            ...(0, $2f353af2b0f7600b$export$23997c3e44cc1c59)(token),
            ...$e8a8f826922d3542$export$ffe8b2a9bd2e5cfe(token),
            '&-rtl': {
                direction: 'rtl'
            },
            '&-wrapper': {
                display: 'inline-block',
                width: '100%',
                textAlign: 'start',
                verticalAlign: 'top',
                // https://github.com/ant-design/ant-design/issues/6403
                '&-rtl': {
                    direction: 'rtl'
                },
                // Size
                '&-lg': {
                    [`${componentCls}-group-addon`]: {
                        borderRadius: borderRadiusLG,
                        fontSize: token.inputFontSizeLG
                    }
                },
                '&-sm': {
                    [`${componentCls}-group-addon`]: {
                        borderRadius: borderRadiusSM
                    }
                },
                // Variants
                ...(0, $8640b68e85787e4a$export$8f88f32c046ff727)(token),
                ...(0, $8640b68e85787e4a$export$542c0fce51b1d515)(token),
                // '&-disabled': {
                //   [`${componentCls}-group-addon`]: {
                //     ...genDisabledStyle(token),
                //   },
                // },
                // Fix the issue of using icons in Space Compact mode
                // https://github.com/ant-design/ant-design/issues/42122
                [`&:not(${componentCls}-compact-first-item):not(${componentCls}-compact-last-item)${componentCls}-compact-item`]: {
                    [`${componentCls}, ${componentCls}-group-addon`]: {
                        borderRadius: 0
                    }
                },
                [`&:not(${componentCls}-compact-last-item)${componentCls}-compact-first-item`]: {
                    [`${componentCls}, ${componentCls}-group-addon`]: {
                        borderStartEndRadius: 0,
                        borderEndEndRadius: 0
                    }
                },
                [`&:not(${componentCls}-compact-first-item)${componentCls}-compact-last-item`]: {
                    [`${componentCls}, ${componentCls}-group-addon`]: {
                        borderStartStartRadius: 0,
                        borderEndStartRadius: 0
                    }
                },
                // Fix the issue of input use show-count param in space compact mode
                // https://github.com/ant-design/ant-design/issues/46872
                [`&:not(${componentCls}-compact-last-item)${componentCls}-compact-item`]: {
                    [`${componentCls}-affix-wrapper`]: {
                        borderStartEndRadius: 0,
                        borderEndEndRadius: 0
                    }
                },
                // Fix the issue of input use `addonAfter` param in space compact mode
                // https://github.com/ant-design/ant-design/issues/52483
                [`&:not(${componentCls}-compact-first-item)${componentCls}-compact-item`]: {
                    [`${componentCls}-affix-wrapper`]: {
                        borderStartStartRadius: 0,
                        borderEndStartRadius: 0
                    }
                }
            }
        }
    };
};
// ============================== Range ===============================
const $e8a8f826922d3542$var$genRangeStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-out-of-range`]: {
            [`&, & input, & textarea, ${componentCls}-show-count-suffix, ${componentCls}-data-count`]: {
                color: token.colorError
            }
        }
    };
};
const $e8a8f826922d3542$export$de732caeaad5f68e = (0, $d4a2dc313c4d90a4$export$51ec95de45185b42)([
    'Input',
    'Shared'
], (token)=>{
    const inputToken = (0, $90c11ca6cb263fd9$export$4950aa0f605343fb)(token, (0, $2086d48ba031927a$export$a157d95850191a12)(token));
    return [
        $e8a8f826922d3542$export$9a752c3888370836(inputToken),
        $e8a8f826922d3542$export$77a75da75a374eb9(inputToken)
    ];
}, (0, $2086d48ba031927a$export$bd8b682992bc9781), {
    resetFont: false
});
var $e8a8f826922d3542$export$2e2bcd8739ae039 = (0, $d4a2dc313c4d90a4$export$51ec95de45185b42)([
    'Input',
    'Component'
], (token)=>{
    const inputToken = (0, $90c11ca6cb263fd9$export$4950aa0f605343fb)(token, (0, $2086d48ba031927a$export$a157d95850191a12)(token));
    return [
        $e8a8f826922d3542$var$genGroupStyle(inputToken),
        $e8a8f826922d3542$var$genRangeStyle(inputToken),
        // =====================================================
        // ==             Space Compact                       ==
        // =====================================================
        (0, $ebe50cd0ffe9b635$export$b1208b23589b4b73)(inputToken)
    ];
}, (0, $2086d48ba031927a$export$bd8b682992bc9781), {
    resetFont: false
});


"use client";
/** @deprecated Please use `Space.Compact` */ const $a2363e2e0a94198a$var$Group = (props)=>{
    const { getPrefixCls: getPrefixCls, direction: direction } = (0, $32rMB.useContext)((0, $dd01e2f5a4b8605d$export$a92f85ab3e9ad68b));
    const { prefixCls: customizePrefixCls, className: className } = props;
    const prefixCls = getPrefixCls('input-group', customizePrefixCls);
    const inputPrefixCls = getPrefixCls('input');
    const [hashId, cssVarCls] = (0, $e8a8f826922d3542$export$2e2bcd8739ae039)(inputPrefixCls);
    const cls = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, cssVarCls, {
        [`${prefixCls}-lg`]: props.size === 'large',
        [`${prefixCls}-sm`]: props.size === 'small',
        [`${prefixCls}-compact`]: props.compact,
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, hashId, className);
    const formItemContext = (0, $32rMB.useContext)((0, $a1a112e4dddc1035$export$bbb5553c6c7a14ed));
    const groupFormItemContext = (0, $32rMB.useMemo)(()=>({
            ...formItemContext,
            isFormItemInput: false
        }), [
        formItemContext
    ]);
    return /*#__PURE__*/ $hO8yS.createElement((0, $a1a112e4dddc1035$export$bbb5553c6c7a14ed).Provider, {
        value: groupFormItemContext
    }, /*#__PURE__*/ $hO8yS.createElement((0, $afba98610eca1bae$export$2e2bcd8739ae039).Compact, {
        className: cls,
        style: props.style,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        onFocus: props.onFocus,
        onBlur: props.onBlur
    }, props.children));
};
var $a2363e2e0a94198a$export$2e2bcd8739ae039 = $a2363e2e0a94198a$var$Group;



var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");


var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
function $661415facc16dddb$export$ae6255aa850a31d1(props) {
    return !!(props.addonBefore || props.addonAfter);
}
function $661415facc16dddb$export$a19010aeeaa0c7a(props) {
    return !!(props.prefix || props.suffix || props.allowClear);
}
// TODO: It's better to use `Proxy` replace the `element.value`. But we still need support IE11.
function $661415facc16dddb$var$cloneEvent(event, target, value) {
    // A bug report filed on WebKit's Bugzilla tracker, dating back to 2009, specifically addresses the issue of cloneNode() not copying files of <input type="file"> elements.
    // As of the last update, this bug was still marked as "NEW," indicating that it might not have been resolved yet​​.
    // https://bugs.webkit.org/show_bug.cgi?id=28123
    const currentTarget = target.cloneNode(true);
    // click clear icon
    const newEvent = Object.create(event, {
        target: {
            value: currentTarget
        },
        currentTarget: {
            value: currentTarget
        }
    });
    // Fill data
    currentTarget.value = value;
    // Fill selection. Some type like `email` not support selection
    // https://github.com/ant-design/ant-design/issues/47833
    if (typeof target.selectionStart === 'number' && typeof target.selectionEnd === 'number') {
        currentTarget.selectionStart = target.selectionStart;
        currentTarget.selectionEnd = target.selectionEnd;
    }
    currentTarget.setSelectionRange = (...args)=>{
        target.setSelectionRange(...args);
    };
    return newEvent;
}
function $661415facc16dddb$export$c28984794956ddc0(target, e, onChange, targetValue) {
    if (!onChange) return;
    let event = e;
    if (e.type === 'click') {
        // Clone a new target for event.
        // Avoid the following usage, the setQuery method gets the original value.
        //
        // const [query, setQuery] = React.useState('');
        // <Input
        //   allowClear
        //   value={query}
        //   onChange={(e)=> {
        //     setQuery((prevStatus) => e.target.value);
        //   }}
        // />
        event = $661415facc16dddb$var$cloneEvent(e, target, '');
        onChange(event);
        return;
    }
    // Trigger by composition event, this means we need force change the input value
    // https://github.com/ant-design/ant-design/issues/45737
    // https://github.com/ant-design/ant-design/issues/46598
    if (target.type !== 'file' && targetValue !== undefined) {
        event = $661415facc16dddb$var$cloneEvent(e, target, targetValue);
        onChange(event);
        return;
    }
    onChange(event);
}


function $b3991e88a6bc5599$var$_extends() {
    $b3991e88a6bc5599$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b3991e88a6bc5599$var$_extends.apply(this, arguments);
}
const $b3991e88a6bc5599$var$BaseInput = /*#__PURE__*/ (0, $N3oW3.default).forwardRef((props, ref)=>{
    const { inputElement: inputEl, children: children, prefixCls: prefixCls, prefix: prefix, suffix: suffix, addonBefore: addonBefore, addonAfter: addonAfter, className: className, style: style, disabled: disabled, readOnly: readOnly, focused: focused, triggerFocus: triggerFocus, allowClear: allowClear, value: value, handleReset: handleReset, hidden: hidden, classes: classes, classNames: classNames, dataAttrs: dataAttrs, styles: styles, components: components, onClear: onClear } = props;
    const inputElement = children ?? inputEl;
    const AffixWrapperComponent = components?.affixWrapper || 'span';
    const GroupWrapperComponent = components?.groupWrapper || 'span';
    const WrapperComponent = components?.wrapper || 'span';
    const GroupAddonComponent = components?.groupAddon || 'span';
    const containerRef = (0, $32rMB.useRef)(null);
    const onInputClick = (e)=>{
        if (containerRef.current?.contains(e.target)) triggerFocus?.();
    };
    const hasAffix = (0, $661415facc16dddb$export$a19010aeeaa0c7a)(props);
    let element = /*#__PURE__*/ (0, $N3oW3.cloneElement)(inputElement, {
        value: value,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(inputElement.props?.className, !hasAffix && classNames?.variant) || null
    });
    // ======================== Ref ======================== //
    const groupRef = (0, $32rMB.useRef)(null);
    (0, $N3oW3.default).useImperativeHandle(ref, ()=>({
            nativeElement: groupRef.current || containerRef.current
        }));
    // ================== Prefix & Suffix ================== //
    if (hasAffix) {
        // ================== Clear Icon ================== //
        let clearIcon = null;
        if (allowClear) {
            const needClear = !disabled && !readOnly && value;
            const clearIconCls = `${prefixCls}-clear-icon`;
            const iconNode = typeof allowClear === 'object' && allowClear?.clearIcon ? allowClear.clearIcon : "\u2716";
            clearIcon = /*#__PURE__*/ (0, $N3oW3.default).createElement("button", {
                type: "button",
                tabIndex: -1,
                onClick: (event)=>{
                    handleReset?.(event);
                    onClear?.();
                },
                onMouseDown: (e)=>e.preventDefault(),
                className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(clearIconCls, {
                    [`${clearIconCls}-hidden`]: !needClear,
                    [`${clearIconCls}-has-suffix`]: !!suffix
                })
            }, iconNode);
        }
        const affixWrapperPrefixCls = `${prefixCls}-affix-wrapper`;
        const affixWrapperCls = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(affixWrapperPrefixCls, {
            [`${prefixCls}-disabled`]: disabled,
            [`${affixWrapperPrefixCls}-disabled`]: disabled,
            // Not used, but keep it
            [`${affixWrapperPrefixCls}-focused`]: focused,
            // Not used, but keep it
            [`${affixWrapperPrefixCls}-readonly`]: readOnly,
            [`${affixWrapperPrefixCls}-input-with-clear-btn`]: suffix && allowClear && value
        }, classes?.affixWrapper, classNames?.affixWrapper, classNames?.variant);
        const suffixNode = (suffix || allowClear) && /*#__PURE__*/ (0, $N3oW3.default).createElement("span", {
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-suffix`, classNames?.suffix),
            style: styles?.suffix
        }, clearIcon, suffix);
        element = /*#__PURE__*/ (0, $N3oW3.default).createElement(AffixWrapperComponent, $b3991e88a6bc5599$var$_extends({
            className: affixWrapperCls,
            style: styles?.affixWrapper,
            onClick: onInputClick
        }, dataAttrs?.affixWrapper, {
            ref: containerRef
        }), prefix && /*#__PURE__*/ (0, $N3oW3.default).createElement("span", {
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-prefix`, classNames?.prefix),
            style: styles?.prefix
        }, prefix), element, suffixNode);
    }
    // ================== Addon ================== //
    if ((0, $661415facc16dddb$export$ae6255aa850a31d1)(props)) {
        const wrapperCls = `${prefixCls}-group`;
        const addonCls = `${wrapperCls}-addon`;
        const groupWrapperCls = `${wrapperCls}-wrapper`;
        const mergedWrapperClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-wrapper`, wrapperCls, classes?.wrapper, classNames?.wrapper);
        const mergedGroupClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(groupWrapperCls, {
            [`${groupWrapperCls}-disabled`]: disabled
        }, classes?.group, classNames?.groupWrapper);
        // Need another wrapper for changing display:table to display:inline-block
        // and put style prop in wrapper
        element = /*#__PURE__*/ (0, $N3oW3.default).createElement(GroupWrapperComponent, {
            className: mergedGroupClassName,
            ref: groupRef
        }, /*#__PURE__*/ (0, $N3oW3.default).createElement(WrapperComponent, {
            className: mergedWrapperClassName
        }, addonBefore && /*#__PURE__*/ (0, $N3oW3.default).createElement(GroupAddonComponent, {
            className: addonCls
        }, addonBefore), element, addonAfter && /*#__PURE__*/ (0, $N3oW3.default).createElement(GroupAddonComponent, {
            className: addonCls
        }, addonAfter)));
    }
    // `className` and `style` are always on the root element
    return /*#__PURE__*/ (0, $N3oW3.default).cloneElement(element, {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(element.props?.className, className) || null,
        style: {
            ...element.props?.style,
            ...style
        },
        hidden: hidden
    });
});
var $b3991e88a6bc5599$export$2e2bcd8739ae039 = $b3991e88a6bc5599$var$BaseInput;






var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");

parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
function $824a71fa2827d689$export$7a29f0d5cac613ba(value, countConfig) {
    if (!countConfig.max) return true;
    const count = countConfig.strategy(value);
    return count <= countConfig.max;
}
function $824a71fa2827d689$export$2e2bcd8739ae039(count, showCount) {
    return $32rMB.useMemo(()=>{
        let mergedConfig = {};
        if (showCount) mergedConfig.show = typeof showCount === 'object' && showCount.formatter ? showCount.formatter : !!showCount;
        mergedConfig = {
            ...mergedConfig,
            ...count
        };
        const { show: show, ...rest } = mergedConfig;
        return {
            ...rest,
            show: !!show,
            showFormatter: typeof show === 'function' ? show : undefined,
            strategy: rest.strategy || ((value)=>value.length)
        };
    }, [
        count,
        showCount
    ]);
}




function $c5b67aaaaa383a2b$var$_extends() {
    $c5b67aaaaa383a2b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c5b67aaaaa383a2b$var$_extends.apply(this, arguments);
}
const $c5b67aaaaa383a2b$var$Input = /*#__PURE__*/ (0, $N3oW3.forwardRef)((props, ref)=>{
    const { autoComplete: autoComplete, onChange: onChange, onFocus: onFocus, onBlur: onBlur, onPressEnter: onPressEnter, onKeyDown: onKeyDown, onKeyUp: onKeyUp, prefixCls: prefixCls = 'rc-input', disabled: disabled, htmlSize: htmlSize, className: className, maxLength: maxLength, suffix: suffix, showCount: showCount, count: count, type: type = 'text', classes: classes, classNames: classNames, styles: styles, onCompositionStart: onCompositionStart, onCompositionEnd: onCompositionEnd, ...rest } = props;
    const [focused, setFocused] = (0, $32rMB.useState)(false);
    const compositionRef = (0, $32rMB.useRef)(false);
    const keyLockRef = (0, $32rMB.useRef)(false);
    const inputRef = (0, $32rMB.useRef)(null);
    const holderRef = (0, $32rMB.useRef)(null);
    const focus = (option)=>{
        if (inputRef.current) (0, $f773cdc81cd324e4$export$2b92016deb0b7aad)(inputRef.current, option);
    };
    // ====================== Value =======================
    const [value, setValue] = (0, $05ea6e97cee440ee$export$2e2bcd8739ae039)(props.defaultValue, props.value);
    const formatValue = value === undefined || value === null ? '' : String(value);
    // =================== Select Range ===================
    const [selection, setSelection] = (0, $32rMB.useState)(null);
    // ====================== Count =======================
    const countConfig = (0, $824a71fa2827d689$export$2e2bcd8739ae039)(count, showCount);
    const mergedMax = countConfig.max || maxLength;
    const valueLength = countConfig.strategy(formatValue);
    const isOutOfRange = !!mergedMax && valueLength > mergedMax;
    // ======================= Ref ========================
    (0, $32rMB.useImperativeHandle)(ref, ()=>({
            focus: focus,
            blur: ()=>{
                inputRef.current?.blur();
            },
            setSelectionRange: (start, end, direction)=>{
                inputRef.current?.setSelectionRange(start, end, direction);
            },
            select: ()=>{
                inputRef.current?.select();
            },
            input: inputRef.current,
            nativeElement: holderRef.current?.nativeElement || inputRef.current
        }));
    (0, $32rMB.useEffect)(()=>{
        if (keyLockRef.current) keyLockRef.current = false;
        setFocused((prev)=>prev && disabled ? false : prev);
    }, [
        disabled
    ]);
    const triggerChange = (e, currentValue, info)=>{
        let cutValue = currentValue;
        if (!compositionRef.current && countConfig.exceedFormatter && countConfig.max && countConfig.strategy(currentValue) > countConfig.max) {
            cutValue = countConfig.exceedFormatter(currentValue, {
                max: countConfig.max
            });
            if (currentValue !== cutValue) setSelection([
                inputRef.current?.selectionStart || 0,
                inputRef.current?.selectionEnd || 0
            ]);
        } else if (info.source === 'compositionEnd') // Avoid triggering twice
        // https://github.com/ant-design/ant-design/issues/46587
        return;
        setValue(cutValue);
        if (inputRef.current) (0, $661415facc16dddb$export$c28984794956ddc0)(inputRef.current, e, onChange, cutValue);
    };
    (0, $32rMB.useEffect)(()=>{
        if (selection) inputRef.current?.setSelectionRange(...selection);
    }, [
        selection
    ]);
    const onInternalChange = (e)=>{
        triggerChange(e, e.target.value, {
            source: 'change'
        });
    };
    const onInternalCompositionEnd = (e)=>{
        compositionRef.current = false;
        triggerChange(e, e.currentTarget.value, {
            source: 'compositionEnd'
        });
        onCompositionEnd?.(e);
    };
    const handleKeyDown = (e)=>{
        if (onPressEnter && e.key === 'Enter' && !keyLockRef.current && !e.nativeEvent.isComposing) {
            keyLockRef.current = true;
            onPressEnter(e);
        }
        onKeyDown?.(e);
    };
    const handleKeyUp = (e)=>{
        if (e.key === 'Enter') keyLockRef.current = false;
        onKeyUp?.(e);
    };
    const handleFocus = (e)=>{
        setFocused(true);
        onFocus?.(e);
    };
    const handleBlur = (e)=>{
        if (keyLockRef.current) keyLockRef.current = false;
        setFocused(false);
        onBlur?.(e);
    };
    const handleReset = (e)=>{
        setValue('');
        focus();
        if (inputRef.current) (0, $661415facc16dddb$export$c28984794956ddc0)(inputRef.current, e, onChange);
    };
    // ====================== Input =======================
    const outOfRangeCls = isOutOfRange && `${prefixCls}-out-of-range`;
    const getInputElement = ()=>{
        // Fix https://fb.me/react-unknown-prop
        const otherProps = (0, $f4cf9c2e27c0ac8d$export$2e2bcd8739ae039)(props, [
            'prefixCls',
            'onPressEnter',
            'addonBefore',
            'addonAfter',
            'prefix',
            'suffix',
            'allowClear',
            // Input elements must be either controlled or uncontrolled,
            // specify either the value prop, or the defaultValue prop, but not both.
            'defaultValue',
            'showCount',
            'count',
            'classes',
            'htmlSize',
            'styles',
            'classNames',
            'onClear'
        ]);
        return /*#__PURE__*/ (0, $N3oW3.default).createElement("input", $c5b67aaaaa383a2b$var$_extends({
            autoComplete: autoComplete
        }, otherProps, {
            onChange: onInternalChange,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onKeyDown: handleKeyDown,
            onKeyUp: handleKeyUp,
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, {
                [`${prefixCls}-disabled`]: disabled
            }, classNames?.input),
            style: styles?.input,
            ref: inputRef,
            size: htmlSize,
            type: type,
            onCompositionStart: (e)=>{
                compositionRef.current = true;
                onCompositionStart?.(e);
            },
            onCompositionEnd: onInternalCompositionEnd
        }));
    };
    const getSuffix = ()=>{
        // Max length value
        const hasMaxLength = Number(mergedMax) > 0;
        if (suffix || countConfig.show) {
            const dataCount = countConfig.showFormatter ? countConfig.showFormatter({
                value: formatValue,
                count: valueLength,
                maxLength: mergedMax
            }) : `${valueLength}${hasMaxLength ? ` / ${mergedMax}` : ''}`;
            return /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $N3oW3.default).Fragment, null, countConfig.show && /*#__PURE__*/ (0, $N3oW3.default).createElement("span", {
                className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-show-count-suffix`, {
                    [`${prefixCls}-show-count-has-suffix`]: !!suffix
                }, classNames?.count),
                style: {
                    ...styles?.count
                }
            }, dataCount), suffix);
        }
        return null;
    };
    // ====================== Render ======================
    return /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $b3991e88a6bc5599$export$2e2bcd8739ae039), $c5b67aaaaa383a2b$var$_extends({}, rest, {
        prefixCls: prefixCls,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(className, outOfRangeCls),
        handleReset: handleReset,
        value: formatValue,
        focused: focused,
        triggerFocus: focus,
        suffix: getSuffix(),
        disabled: disabled,
        classes: classes,
        classNames: classNames,
        styles: styles,
        ref: holderRef
    }), getInputElement());
});
var $c5b67aaaaa383a2b$export$2e2bcd8739ae039 = $c5b67aaaaa383a2b$var$Input;


var $2ebf18016d7776b2$export$2e2bcd8739ae039 = (0, $c5b67aaaaa383a2b$export$2e2bcd8739ae039);







var $N3oW3 = parcelRequire("N3oW3");

"use client";
const $d2ac56745c809c35$var$getAllowClear = (allowClear)=>{
    let mergedAllowClear;
    if (typeof allowClear === 'object' && allowClear?.clearIcon) mergedAllowClear = allowClear;
    else if (allowClear) mergedAllowClear = {
        clearIcon: /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $88ed6189ad3742f6$export$2e2bcd8739ae039), null)
    };
    return mergedAllowClear;
};
var $d2ac56745c809c35$export$2e2bcd8739ae039 = $d2ac56745c809c35$var$getAllowClear;










parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");


/**
 * Compatible for legacy `bordered` prop.
 */ const $b3bf3719877c7ee9$var$useVariant = (component, variant, legacyBordered)=>{
    const { variant: configVariant, [component]: componentConfig } = $32rMB.useContext((0, $dd01e2f5a4b8605d$export$a92f85ab3e9ad68b));
    const ctxVariant = $32rMB.useContext((0, $a1a112e4dddc1035$export$6f0555dad42725fb));
    const configComponentVariant = componentConfig?.variant;
    let mergedVariant;
    if (typeof variant !== 'undefined') mergedVariant = variant;
    else if (legacyBordered === false) mergedVariant = 'borderless';
    else // form variant > component global variant > global variant
    mergedVariant = ctxVariant ?? configComponentVariant ?? configVariant ?? 'outlined';
    const enableVariantCls = (0, $dd01e2f5a4b8605d$export$fa216ce2679a073b).includes(mergedVariant);
    return [
        mergedVariant,
        enableVariantCls
    ];
};
var $b3bf3719877c7ee9$export$2e2bcd8739ae039 = $b3bf3719877c7ee9$var$useVariant;



parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
function $d730924c750a7d7e$export$2e2bcd8739ae039(inputRef, triggerOnMount) {
    const removePasswordTimeoutRef = (0, $32rMB.useRef)([]);
    const removePasswordTimeout = ()=>{
        removePasswordTimeoutRef.current.push(setTimeout(()=>{
            if (inputRef.current?.input && inputRef.current?.input.getAttribute('type') === 'password' && inputRef.current?.input.hasAttribute('value')) inputRef.current?.input.removeAttribute('value');
        }));
    };
    (0, $32rMB.useEffect)(()=>{
        if (triggerOnMount) removePasswordTimeout();
        return ()=>removePasswordTimeoutRef.current.forEach((timer)=>{
                if (timer) clearTimeout(timer);
            });
    }, []);
    return removePasswordTimeout;
}



function $88f3cdc2e461371a$export$a19010aeeaa0c7a(props) {
    return !!(props.prefix || props.suffix || props.allowClear || props.showCount);
}


"use client";
const $124d0cd1063329f0$var$Input = /*#__PURE__*/ (0, $N3oW3.forwardRef)((props, ref)=>{
    const { prefixCls: customizePrefixCls, bordered: bordered = true, status: customStatus, size: customSize, disabled: customDisabled, onBlur: onBlur, onFocus: onFocus, suffix: suffix, allowClear: allowClear, addonAfter: addonAfter, addonBefore: addonBefore, className: className, style: style, styles: styles, rootClassName: rootClassName, onChange: onChange, classNames: classNames, variant: customVariant, ...rest } = props;
    var prop, newProp;
    const { getPrefixCls: getPrefixCls, direction: direction, allowClear: contextAllowClear, autoComplete: contextAutoComplete, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $dd01e2f5a4b8605d$export$46f4bd6436a25a31)('input');
    const prefixCls = getPrefixCls('input', customizePrefixCls);
    const inputRef = (0, $32rMB.useRef)(null);
    // Style
    const rootCls = (0, $54b1aecddbbbed4f$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $e8a8f826922d3542$export$de732caeaad5f68e)(prefixCls, rootClassName);
    (0, $e8a8f826922d3542$export$2e2bcd8739ae039)(prefixCls, rootCls);
    // ===================== Compact Item =====================
    const { compactSize: compactSize, compactItemClassnames: compactItemClassnames } = (0, $085e8dc0a3d19960$export$cd8cf9d7bab8dd4)(prefixCls, direction);
    // ===================== Size =====================
    const mergedSize = (0, $324b30eda6ea1cd7$export$2e2bcd8739ae039)((ctx)=>customSize ?? compactSize ?? ctx);
    // ===================== Disabled =====================
    const disabled = (0, $N3oW3.default).useContext((0, $ff4b4ddbf52ed41f$export$2e2bcd8739ae039));
    const mergedDisabled = customDisabled ?? disabled;
    // =========== Merged Props for Semantic ==========
    const mergedProps = {
        ...props,
        size: mergedSize,
        disabled: mergedDisabled
    };
    const [mergedClassNames, mergedStyles] = (0, $4dcf69d8c3d6df5c$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    // ===================== Status =====================
    const { status: contextStatus, hasFeedback: hasFeedback, feedbackIcon: feedbackIcon } = (0, $32rMB.useContext)((0, $a1a112e4dddc1035$export$bbb5553c6c7a14ed));
    const mergedStatus = (0, $597dc4581bd08a1e$export$314e193082d7ba49)(contextStatus, customStatus);
    // ===================== Focus warning =====================
    const inputHasPrefixSuffix = (0, $88f3cdc2e461371a$export$a19010aeeaa0c7a)(props) || !!hasFeedback;
    const prevHasPrefixSuffix = (0, $32rMB.useRef)(inputHasPrefixSuffix);
    /* eslint-enable */ // ===================== Remove Password value =====================
    const removePasswordTimeout = (0, $d730924c750a7d7e$export$2e2bcd8739ae039)(inputRef, true);
    const handleBlur = (e)=>{
        removePasswordTimeout();
        onBlur?.(e);
    };
    const handleFocus = (e)=>{
        removePasswordTimeout();
        onFocus?.(e);
    };
    const handleChange = (e)=>{
        removePasswordTimeout();
        onChange?.(e);
    };
    const suffixNode = (hasFeedback || suffix) && /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $N3oW3.default).Fragment, null, suffix, hasFeedback && feedbackIcon);
    const mergedAllowClear = (0, $d2ac56745c809c35$export$2e2bcd8739ae039)(allowClear ?? contextAllowClear);
    const [variant, enableVariantCls] = (0, $b3bf3719877c7ee9$export$2e2bcd8739ae039)('input', customVariant, bordered);
    return /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $2ebf18016d7776b2$export$2e2bcd8739ae039), {
        ref: (0, $2706ed817e87019d$export$ab452c34e8e05029)(ref, inputRef),
        prefixCls: prefixCls,
        autoComplete: contextAutoComplete,
        ...rest,
        disabled: mergedDisabled,
        onBlur: handleBlur,
        onFocus: handleFocus,
        style: {
            ...mergedStyles.root,
            ...contextStyle,
            ...style
        },
        styles: mergedStyles,
        suffix: suffixNode,
        allowClear: mergedAllowClear,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(className, rootClassName, cssVarCls, rootCls, compactItemClassnames, contextClassName, mergedClassNames.root),
        onChange: handleChange,
        addonBefore: addonBefore && /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $8a9bb3ef8b2b36aa$export$2e2bcd8739ae039), {
            form: true,
            space: true
        }, addonBefore),
        addonAfter: addonAfter && /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $8a9bb3ef8b2b36aa$export$2e2bcd8739ae039), {
            form: true,
            space: true
        }, addonAfter),
        classNames: {
            ...mergedClassNames,
            input: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)({
                [`${prefixCls}-sm`]: mergedSize === 'small',
                [`${prefixCls}-lg`]: mergedSize === 'large',
                [`${prefixCls}-rtl`]: direction === 'rtl'
            }, mergedClassNames.input, hashId),
            variant: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)({
                [`${prefixCls}-${variant}`]: enableVariantCls
            }, (0, $597dc4581bd08a1e$export$b08e7b47149942a2)(prefixCls, mergedStatus)),
            affixWrapper: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)({
                [`${prefixCls}-affix-wrapper-sm`]: mergedSize === 'small',
                [`${prefixCls}-affix-wrapper-lg`]: mergedSize === 'large',
                [`${prefixCls}-affix-wrapper-rtl`]: direction === 'rtl'
            }, hashId),
            wrapper: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)({
                [`${prefixCls}-group-rtl`]: direction === 'rtl'
            }, hashId),
            groupWrapper: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)({
                [`${prefixCls}-group-wrapper-sm`]: mergedSize === 'small',
                [`${prefixCls}-group-wrapper-lg`]: mergedSize === 'large',
                [`${prefixCls}-group-wrapper-rtl`]: direction === 'rtl',
                [`${prefixCls}-group-wrapper-${variant}`]: enableVariantCls
            }, (0, $597dc4581bd08a1e$export$b08e7b47149942a2)(`${prefixCls}-group-wrapper`, mergedStatus, hasFeedback), hashId)
        }
    });
});
var $124d0cd1063329f0$export$2e2bcd8739ae039 = $124d0cd1063329f0$var$Input;



parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");











// =============================== OTP ================================
const $dc5c6887787d3287$var$genOTPStyle = (token)=>{
    const { componentCls: componentCls, paddingXS: paddingXS } = token;
    return {
        [componentCls]: {
            display: 'inline-flex',
            alignItems: 'center',
            flexWrap: 'nowrap',
            columnGap: paddingXS,
            [`${componentCls}-input-wrapper`]: {
                position: 'relative',
                [`${componentCls}-mask-icon`]: {
                    position: 'absolute',
                    zIndex: '1',
                    top: '50%',
                    right: '50%',
                    transform: 'translate(50%, -50%)',
                    pointerEvents: 'none'
                },
                [`${componentCls}-mask-input`]: {
                    color: 'transparent',
                    caretColor: token.colorText
                },
                [`${componentCls}-mask-input[type=number]::-webkit-inner-spin-button`]: {
                    '-webkit-appearance': 'none',
                    margin: 0
                },
                [`${componentCls}-mask-input[type=number]`]: {
                    '-moz-appearance': 'textfield'
                }
            },
            '&-rtl': {
                direction: 'rtl'
            },
            [`${componentCls}-input`]: {
                textAlign: 'center',
                paddingInline: token.paddingXXS
            },
            // ================= Size =================
            [`&${componentCls}-sm ${componentCls}-input`]: {
                paddingInline: token.calc(token.paddingXXS).div(2).equal()
            },
            [`&${componentCls}-lg ${componentCls}-input`]: {
                paddingInline: token.paddingXS
            }
        }
    };
};
var // ============================== Export ==============================
$dc5c6887787d3287$export$2e2bcd8739ae039 = (0, $d4a2dc313c4d90a4$export$51ec95de45185b42)([
    'Input',
    'OTP'
], (token)=>{
    const inputToken = (0, $90c11ca6cb263fd9$export$4950aa0f605343fb)(token, (0, $2086d48ba031927a$export$a157d95850191a12)(token));
    return $dc5c6887787d3287$var$genOTPStyle(inputToken);
}, (0, $2086d48ba031927a$export$bd8b682992bc9781));


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");




"use client";
const $e67b8384e0813547$var$OTPInput = /*#__PURE__*/ $N3oW3.forwardRef((props, ref)=>{
    const { className: className, value: value, onChange: onChange, onActiveChange: onActiveChange, index: index, mask: mask, onFocus: onFocus, ...restProps } = props;
    const { getPrefixCls: getPrefixCls } = $32rMB.useContext((0, $dd01e2f5a4b8605d$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('otp');
    const maskValue = typeof mask === 'string' ? mask : value;
    // ========================== Ref ===========================
    const inputRef = $32rMB.useRef(null);
    $32rMB.useImperativeHandle(ref, ()=>inputRef.current);
    // ========================= Input ==========================
    const onInternalChange = (e)=>{
        onChange(index, e.target.value);
    };
    // ========================= Focus ==========================
    const syncSelection = ()=>{
        (0, $c9c36e20d667d30c$export$2e2bcd8739ae039)(()=>{
            const inputEle = inputRef.current?.input;
            if (document.activeElement === inputEle && inputEle) inputEle.select();
        });
    };
    const onInternalFocus = (e)=>{
        onFocus?.(e);
        syncSelection();
    };
    // ======================== Keyboard ========================
    const onInternalKeyDown = (event)=>{
        const { key: key, ctrlKey: ctrlKey, metaKey: metaKey } = event;
        if (key === 'ArrowLeft') onActiveChange(index - 1);
        else if (key === 'ArrowRight') onActiveChange(index + 1);
        else if (key === 'z' && (ctrlKey || metaKey)) event.preventDefault();
        else if (key === 'Backspace' && !value) onActiveChange(index - 1);
        syncSelection();
    };
    // ========================= Render =========================
    return /*#__PURE__*/ $hO8yS.createElement("span", {
        className: `${prefixCls}-input-wrapper`,
        role: "presentation"
    }, mask && value !== '' && value !== undefined && /*#__PURE__*/ $hO8yS.createElement("span", {
        className: `${prefixCls}-mask-icon`,
        "aria-hidden": "true"
    }, maskValue), /*#__PURE__*/ $hO8yS.createElement((0, $124d0cd1063329f0$export$2e2bcd8739ae039), {
        "aria-label": `OTP Input ${index + 1}`,
        type: mask === true ? 'password' : 'text',
        ...restProps,
        ref: inputRef,
        value: value,
        onInput: onInternalChange,
        onFocus: onInternalFocus,
        onKeyDown: onInternalKeyDown,
        onMouseDown: syncSelection,
        onMouseUp: syncSelection,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(className, {
            [`${prefixCls}-mask-input`]: mask
        })
    }));
});
var $e67b8384e0813547$export$2e2bcd8739ae039 = $e67b8384e0813547$var$OTPInput;


"use client";
function $9988f4eabaad6740$var$strToArr(str) {
    return (str || '').split('');
}
const $9988f4eabaad6740$var$Separator = (props)=>{
    const { index: index, prefixCls: prefixCls, separator: separator, className: semanticClassName, style: semanticStyle } = props;
    const separatorNode = typeof separator === 'function' ? separator(index) : separator;
    if (!separatorNode) return null;
    return /*#__PURE__*/ $hO8yS.createElement("span", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-separator`, semanticClassName),
        style: semanticStyle
    }, separatorNode);
};
const $9988f4eabaad6740$var$OTP = /*#__PURE__*/ $N3oW3.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, length: length = 6, size: customSize, defaultValue: defaultValue, value: value, onChange: onChange, formatter: formatter, separator: separator, variant: variant, disabled: disabled, status: customStatus, autoFocus: autoFocus, mask: mask, type: type, onInput: onInput, onFocus: onFocus, inputMode: inputMode, classNames: classNames, styles: styles, className: className, style: style, ...restProps } = props;
    const { classNames: contextClassNames, styles: contextStyles, getPrefixCls: getPrefixCls, direction: direction, style: contextStyle, className: contextClassName } = (0, $dd01e2f5a4b8605d$export$46f4bd6436a25a31)('otp');
    const prefixCls = getPrefixCls('otp', customizePrefixCls);
    const mergedProps = {
        ...props,
        length: length
    };
    const [mergedClassNames, mergedStyles] = (0, $4dcf69d8c3d6df5c$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    const domAttrs = (0, $b0f3dfd0eb3cad70$export$2e2bcd8739ae039)(restProps, {
        aria: true,
        data: true,
        attr: true
    });
    // ========================= Root =========================
    // Style
    const [hashId, cssVarCls] = (0, $dc5c6887787d3287$export$2e2bcd8739ae039)(prefixCls);
    // ========================= Size =========================
    const mergedSize = (0, $324b30eda6ea1cd7$export$2e2bcd8739ae039)((ctx)=>customSize ?? ctx);
    // ======================== Status ========================
    const formContext = $32rMB.useContext((0, $a1a112e4dddc1035$export$bbb5553c6c7a14ed));
    const mergedStatus = (0, $597dc4581bd08a1e$export$314e193082d7ba49)(formContext.status, customStatus);
    const proxyFormContext = $32rMB.useMemo(()=>({
            ...formContext,
            status: mergedStatus,
            hasFeedback: false,
            feedbackIcon: null
        }), [
        formContext,
        mergedStatus
    ]);
    // ========================= Refs =========================
    const containerRef = $32rMB.useRef(null);
    const refs = $32rMB.useRef({});
    $32rMB.useImperativeHandle(ref, ()=>({
            focus: ()=>{
                refs.current[0]?.focus();
            },
            blur: ()=>{
                for(let i = 0; i < length; i += 1)refs.current[i]?.blur();
            },
            nativeElement: containerRef.current
        }));
    // ======================= Formatter ======================
    const internalFormatter = (txt)=>formatter ? formatter(txt) : txt;
    // ======================== Values ========================
    const [valueCells, setValueCells] = $32rMB.useState(()=>$9988f4eabaad6740$var$strToArr(internalFormatter(defaultValue || '')));
    $32rMB.useEffect(()=>{
        if (value !== undefined) setValueCells($9988f4eabaad6740$var$strToArr(value));
    }, [
        value
    ]);
    const triggerValueCellsChange = (0, $ea93068db096b7d6$export$2e2bcd8739ae039)((nextValueCells)=>{
        setValueCells(nextValueCells);
        if (onInput) onInput(nextValueCells);
        // Trigger if all cells are filled
        if (onChange && nextValueCells.length === length && nextValueCells.every((c)=>c) && nextValueCells.some((c, index)=>valueCells[index] !== c)) onChange(nextValueCells.join(''));
    });
    const patchValue = (0, $ea93068db096b7d6$export$2e2bcd8739ae039)((index, txt)=>{
        let nextCells = (0, $3746fb019e1f2ee5$export$2e2bcd8739ae039)(valueCells);
        // Fill cells till index
        for(let i = 0; i < index; i += 1)if (!nextCells[i]) nextCells[i] = '';
        if (txt.length <= 1) nextCells[index] = txt;
        else nextCells = nextCells.slice(0, index).concat($9988f4eabaad6740$var$strToArr(txt));
        nextCells = nextCells.slice(0, length);
        // Clean the last empty cell
        for(let i = nextCells.length - 1; i >= 0; i -= 1){
            if (nextCells[i]) break;
            nextCells.pop();
        }
        // Format if needed
        const formattedValue = internalFormatter(nextCells.map((c)=>c || ' ').join(''));
        nextCells = $9988f4eabaad6740$var$strToArr(formattedValue).map((c, i)=>{
            if (c === ' ' && !nextCells[i]) return nextCells[i];
            return c;
        });
        return nextCells;
    });
    // ======================== Change ========================
    const onInputChange = (index, txt)=>{
        const nextCells = patchValue(index, txt);
        const nextIndex = Math.min(index + txt.length, length - 1);
        if (nextIndex !== index && nextCells[index] !== undefined) refs.current[nextIndex]?.focus();
        triggerValueCellsChange(nextCells);
    };
    const onInputActiveChange = (nextIndex)=>{
        refs.current[nextIndex]?.focus();
    };
    // ======================== Focus ========================
    const onInputFocus = (event, index)=>{
        // keep focus on the first empty cell
        for(let i = 0; i < index; i += 1)if (!refs.current[i]?.input?.value) {
            refs.current[i]?.focus();
            break;
        }
        onFocus?.(event);
    };
    // ======================== Render ========================
    const inputSharedProps = {
        variant: variant,
        disabled: disabled,
        status: mergedStatus,
        mask: mask,
        type: type,
        inputMode: inputMode
    };
    return /*#__PURE__*/ $hO8yS.createElement("div", {
        ...domAttrs,
        ref: containerRef,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(className, prefixCls, {
            [`${prefixCls}-sm`]: mergedSize === 'small',
            [`${prefixCls}-lg`]: mergedSize === 'large',
            [`${prefixCls}-rtl`]: direction === 'rtl'
        }, cssVarCls, hashId, contextClassName, mergedClassNames.root),
        style: {
            ...mergedStyles.root,
            ...contextStyle,
            ...style
        },
        role: "group"
    }, /*#__PURE__*/ $hO8yS.createElement((0, $a1a112e4dddc1035$export$bbb5553c6c7a14ed).Provider, {
        value: proxyFormContext
    }, Array.from({
        length: length
    }).map((_, index)=>{
        const key = `otp-${index}`;
        const singleValue = valueCells[index] || '';
        return /*#__PURE__*/ $hO8yS.createElement($hO8yS.Fragment, {
            key: key
        }, /*#__PURE__*/ $hO8yS.createElement((0, $e67b8384e0813547$export$2e2bcd8739ae039), {
            ref: (inputEle)=>{
                refs.current[index] = inputEle;
            },
            index: index,
            size: mergedSize,
            htmlSize: 1,
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(mergedClassNames.input, `${prefixCls}-input`),
            style: mergedStyles.input,
            onChange: onInputChange,
            value: singleValue,
            onActiveChange: onInputActiveChange,
            autoFocus: index === 0 && autoFocus,
            onFocus: (event)=>onInputFocus(event, index),
            ...inputSharedProps
        }), index < length - 1 && /*#__PURE__*/ $hO8yS.createElement($9988f4eabaad6740$var$Separator, {
            separator: separator,
            index: index,
            prefixCls: prefixCls,
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(mergedClassNames.separator),
            style: mergedStyles.separator
        }));
    })));
});
var $9988f4eabaad6740$export$2e2bcd8739ae039 = $9988f4eabaad6740$var$OTP;



var $N3oW3 = parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");
parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
// This icon file is generated automatically.
var $3c674db196247565$var$EyeInvisibleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5zm-63.57-320.64L836 122.88a8 8 0 00-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 000 11.31L155.17 889a8 8 0 0011.31 0l712.15-712.12a8 8 0 000-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 00-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 01146.2-106.69L401.31 546.2A112 112 0 01396 512z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 00227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 01-112 112z"
                }
            }
        ]
    },
    "name": "eye-invisible",
    "theme": "outlined"
};
var $3c674db196247565$export$2e2bcd8739ae039 = $3c674db196247565$var$EyeInvisibleOutlined;



function $3f37e36c7459bdae$var$_extends() {
    $3f37e36c7459bdae$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3f37e36c7459bdae$var$_extends.apply(this, arguments);
}
const $3f37e36c7459bdae$var$EyeInvisibleOutlined = (props, ref)=>/*#__PURE__*/ $hO8yS.createElement((0, $5fd6f3f3c400c267$export$2e2bcd8739ae039), $3f37e36c7459bdae$var$_extends({}, props, {
        ref: ref,
        icon: (0, $3c674db196247565$export$2e2bcd8739ae039)
    }));
/**![eye-invisible](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTk0Mi4yIDQ4Ni4yUTg4OS40NyAzNzUuMTEgODE2LjcgMzA1bC01MC44OCA1MC44OEM4MDcuMzEgMzk1LjUzIDg0My40NSA0NDcuNCA4NzQuNyA1MTIgNzkxLjUgNjg0LjIgNjczLjQgNzY2IDUxMiA3NjZxLTcyLjY3IDAtMTMzLjg3LTIyLjM4TDMyMyA3OTguNzVRNDA4IDgzOCA1MTIgODM4cTI4OC4zIDAgNDMwLjItMzAwLjNhNjAuMjkgNjAuMjkgMCAwMDAtNTEuNXptLTYzLjU3LTMyMC42NEw4MzYgMTIyLjg4YTggOCAwIDAwLTExLjMyIDBMNzE1LjMxIDIzMi4yUTYyNC44NiAxODYgNTEyIDE4NnEtMjg4LjMgMC00MzAuMiAzMDAuM2E2MC4zIDYwLjMgMCAwMDAgNTEuNXE1Ni42OSAxMTkuNCAxMzYuNSAxOTEuNDFMMTEyLjQ4IDgzNWE4IDggMCAwMDAgMTEuMzFMMTU1LjE3IDg4OWE4IDggMCAwMDExLjMxIDBsNzEyLjE1LTcxMi4xMmE4IDggMCAwMDAtMTEuMzJ6TTE0OS4zIDUxMkMyMzIuNiAzMzkuOCAzNTAuNyAyNTggNTEyIDI1OGM1NC41NCAwIDEwNC4xMyA5LjM2IDE0OS4xMiAyOC4zOWwtNzAuMyA3MC4zYTE3NiAxNzYgMCAwMC0yMzguMTMgMjM4LjEzbC04My40MiA4My40MkMyMjMuMSA2MzcuNDkgMTgzLjMgNTgyLjI4IDE0OS4zIDUxMnptMjQ2LjcgMGExMTIuMTEgMTEyLjExIDAgMDExNDYuMi0xMDYuNjlMNDAxLjMxIDU0Ni4yQTExMiAxMTIgMCAwMTM5NiA1MTJ6IiAvPjxwYXRoIGQ9Ik01MDggNjI0Yy0zLjQ2IDAtNi44Ny0uMTYtMTAuMjUtLjQ3bC01Mi44MiA1Mi44MmExNzYuMDkgMTc2LjA5IDAgMDAyMjcuNDItMjI3LjQybC01Mi44MiA1Mi44MmMuMzEgMy4zOC40NyA2Ljc5LjQ3IDEwLjI1YTExMS45NCAxMTEuOTQgMCAwMS0xMTIgMTEyeiIgLz48L3N2Zz4=) */ const $3f37e36c7459bdae$var$RefIcon = /*#__PURE__*/ $N3oW3.forwardRef($3f37e36c7459bdae$var$EyeInvisibleOutlined);
var $3f37e36c7459bdae$export$2e2bcd8739ae039 = $3f37e36c7459bdae$var$RefIcon;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
// This icon file is generated automatically.
var $2074f26e4d4f1320$var$EyeOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z"
                }
            }
        ]
    },
    "name": "eye",
    "theme": "outlined"
};
var $2074f26e4d4f1320$export$2e2bcd8739ae039 = $2074f26e4d4f1320$var$EyeOutlined;



function $e7681133d8525f0b$var$_extends() {
    $e7681133d8525f0b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e7681133d8525f0b$var$_extends.apply(this, arguments);
}
const $e7681133d8525f0b$var$EyeOutlined = (props, ref)=>/*#__PURE__*/ $hO8yS.createElement((0, $5fd6f3f3c400c267$export$2e2bcd8739ae039), $e7681133d8525f0b$var$_extends({}, props, {
        ref: ref,
        icon: (0, $2074f26e4d4f1320$export$2e2bcd8739ae039)
    }));
/**![eye](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTk0Mi4yIDQ4Ni4yQzg0Ny40IDI4Ni41IDcwNC4xIDE4NiA1MTIgMTg2Yy0xOTIuMiAwLTMzNS40IDEwMC41LTQzMC4yIDMwMC4zYTYwLjMgNjAuMyAwIDAwMCA1MS41QzE3Ni42IDczNy41IDMxOS45IDgzOCA1MTIgODM4YzE5Mi4yIDAgMzM1LjQtMTAwLjUgNDMwLjItMzAwLjMgNy43LTE2LjIgNy43LTM1IDAtNTEuNXpNNTEyIDc2NmMtMTYxLjMgMC0yNzkuNC04MS44LTM2Mi43LTI1NEMyMzIuNiAzMzkuOCAzNTAuNyAyNTggNTEyIDI1OGMxNjEuMyAwIDI3OS40IDgxLjggMzYyLjcgMjU0Qzc5MS41IDY4NC4yIDY3My40IDc2NiA1MTIgNzY2em0tNC00MzBjLTk3LjIgMC0xNzYgNzguOC0xNzYgMTc2czc4LjggMTc2IDE3NiAxNzYgMTc2LTc4LjggMTc2LTE3Ni03OC44LTE3Ni0xNzYtMTc2em0wIDI4OGMtNjEuOSAwLTExMi01MC4xLTExMi0xMTJzNTAuMS0xMTIgMTEyLTExMiAxMTIgNTAuMSAxMTIgMTEyLTUwLjEgMTEyLTExMiAxMTJ6IiAvPjwvc3ZnPg==) */ const $e7681133d8525f0b$var$RefIcon = /*#__PURE__*/ $N3oW3.forwardRef($e7681133d8525f0b$var$EyeOutlined);
var $e7681133d8525f0b$export$2e2bcd8739ae039 = $e7681133d8525f0b$var$RefIcon;









"use client";
const $188ea5730b8c6975$var$defaultIconRender = (visible)=>visible ? /*#__PURE__*/ $hO8yS.createElement((0, $e7681133d8525f0b$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $hO8yS.createElement((0, $3f37e36c7459bdae$export$2e2bcd8739ae039), null);
const $188ea5730b8c6975$var$actionMap = {
    click: 'onClick',
    hover: 'onMouseOver'
};
const $188ea5730b8c6975$var$Password = /*#__PURE__*/ $N3oW3.forwardRef((props, ref)=>{
    const { disabled: customDisabled, action: action = 'click', visibilityToggle: visibilityToggle = true, iconRender: iconRender = $188ea5730b8c6975$var$defaultIconRender, suffix: suffix } = props;
    // ===================== Disabled =====================
    const disabled = $32rMB.useContext((0, $ff4b4ddbf52ed41f$export$2e2bcd8739ae039));
    const mergedDisabled = customDisabled ?? disabled;
    const visibilityControlled = typeof visibilityToggle === 'object' && visibilityToggle.visible !== undefined;
    const [visible, setVisible] = (0, $32rMB.useState)(()=>visibilityControlled ? visibilityToggle.visible : false);
    const inputRef = (0, $32rMB.useRef)(null);
    $32rMB.useEffect(()=>{
        if (visibilityControlled) setVisible(visibilityToggle.visible);
    }, [
        visibilityControlled,
        visibilityToggle
    ]);
    // Remove Password value
    const removePasswordTimeout = (0, $d730924c750a7d7e$export$2e2bcd8739ae039)(inputRef);
    const onVisibleChange = ()=>{
        if (mergedDisabled) return;
        if (visible) removePasswordTimeout();
        const nextVisible = !visible;
        setVisible(nextVisible);
        if (typeof visibilityToggle === 'object') visibilityToggle.onVisibleChange?.(nextVisible);
    };
    const getIcon = (prefixCls)=>{
        const iconTrigger = $188ea5730b8c6975$var$actionMap[action] || '';
        const icon = iconRender(visible);
        const iconProps = {
            [iconTrigger]: onVisibleChange,
            className: `${prefixCls}-icon`,
            key: 'passwordIcon',
            onMouseDown: (e)=>{
                // Prevent focused state lost
                // https://github.com/ant-design/ant-design/issues/15173
                e.preventDefault();
            },
            onMouseUp: (e)=>{
                // Prevent caret position change
                // https://github.com/ant-design/ant-design/issues/23524
                e.preventDefault();
            }
        };
        return /*#__PURE__*/ $N3oW3.cloneElement(/*#__PURE__*/ $N3oW3.isValidElement(icon) ? icon : /*#__PURE__*/ $hO8yS.createElement("span", null, icon), iconProps);
    };
    const { className: className, prefixCls: customizePrefixCls, inputPrefixCls: customizeInputPrefixCls, size: size, ...restProps } = props;
    const { getPrefixCls: getPrefixCls } = $32rMB.useContext((0, $dd01e2f5a4b8605d$export$a92f85ab3e9ad68b));
    const inputPrefixCls = getPrefixCls('input', customizeInputPrefixCls);
    const prefixCls = getPrefixCls('input-password', customizePrefixCls);
    const suffixIcon = visibilityToggle && getIcon(prefixCls);
    const inputClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, className, {
        [`${prefixCls}-${size}`]: !!size
    });
    const omittedProps = {
        ...(0, $f4cf9c2e27c0ac8d$export$2e2bcd8739ae039)(restProps, [
            'suffix',
            'iconRender',
            'visibilityToggle'
        ]),
        type: visible ? 'text' : 'password',
        className: inputClassName,
        prefixCls: inputPrefixCls,
        suffix: /*#__PURE__*/ $hO8yS.createElement($hO8yS.Fragment, null, suffixIcon, suffix)
    };
    if (size) omittedProps.size = size;
    return /*#__PURE__*/ $hO8yS.createElement((0, $124d0cd1063329f0$export$2e2bcd8739ae039), {
        ref: (0, $2706ed817e87019d$export$ab452c34e8e05029)(ref, inputRef),
        ...omittedProps
    });
});
var $188ea5730b8c6975$export$2e2bcd8739ae039 = $188ea5730b8c6975$var$Password;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
// This icon file is generated automatically.
var $b7040e248591e738$var$SearchOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z"
                }
            }
        ]
    },
    "name": "search",
    "theme": "outlined"
};
var $b7040e248591e738$export$2e2bcd8739ae039 = $b7040e248591e738$var$SearchOutlined;



function $a3bf8c02a3dd583c$var$_extends() {
    $a3bf8c02a3dd583c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a3bf8c02a3dd583c$var$_extends.apply(this, arguments);
}
const $a3bf8c02a3dd583c$var$SearchOutlined = (props, ref)=>/*#__PURE__*/ $hO8yS.createElement((0, $5fd6f3f3c400c267$export$2e2bcd8739ae039), $a3bf8c02a3dd583c$var$_extends({}, props, {
        ref: ref,
        icon: (0, $b7040e248591e738$export$2e2bcd8739ae039)
    }));
/**![search](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkwOS42IDg1NC41TDY0OS45IDU5NC44QzY5MC4yIDU0Mi43IDcxMiA0NzkgNzEyIDQxMmMwLTgwLjItMzEuMy0xNTUuNC04Ny45LTIxMi4xLTU2LjYtNTYuNy0xMzItODcuOS0yMTIuMS04Ny45cy0xNTUuNSAzMS4zLTIxMi4xIDg3LjlDMTQzLjIgMjU2LjUgMTEyIDMzMS44IDExMiA0MTJjMCA4MC4xIDMxLjMgMTU1LjUgODcuOSAyMTIuMUMyNTYuNSA2ODAuOCAzMzEuOCA3MTIgNDEyIDcxMmM2NyAwIDEzMC42LTIxLjggMTgyLjctNjJsMjU5LjcgMjU5LjZhOC4yIDguMiAwIDAwMTEuNiAwbDQzLjYtNDMuNWE4LjIgOC4yIDAgMDAwLTExLjZ6TTU3MC40IDU3MC40QzUyOCA2MTIuNyA0NzEuOCA2MzYgNDEyIDYzNnMtMTE2LTIzLjMtMTU4LjQtNjUuNkMyMTEuMyA1MjggMTg4IDQ3MS44IDE4OCA0MTJzMjMuMy0xMTYuMSA2NS42LTE1OC40QzI5NiAyMTEuMyAzNTIuMiAxODggNDEyIDE4OHMxMTYuMSAyMy4yIDE1OC40IDY1LjZTNjM2IDM1Mi4yIDYzNiA0MTJzLTIzLjMgMTE2LjEtNjUuNiAxNTguNHoiIC8+PC9zdmc+) */ const $a3bf8c02a3dd583c$var$RefIcon = /*#__PURE__*/ $N3oW3.forwardRef($a3bf8c02a3dd583c$var$SearchOutlined);
var $a3bf8c02a3dd583c$export$2e2bcd8739ae039 = $a3bf8c02a3dd583c$var$RefIcon;














const $6a034d323e4fb695$var$genSearchStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const btnCls = `${componentCls}-btn`;
    return {
        [componentCls]: {
            width: '100%',
            // =========================== Button ===========================
            [btnCls]: {
                '&-filled': {
                    background: token.colorFillTertiary,
                    '&:not(:disabled)': {
                        '&:hover': {
                            background: token.colorFillSecondary
                        },
                        '&:active': {
                            background: token.colorFill
                        }
                    }
                }
            }
        }
    };
};
var $6a034d323e4fb695$export$2e2bcd8739ae039 = (0, $d4a2dc313c4d90a4$export$51ec95de45185b42)([
    'Input',
    'Search'
], (token)=>{
    return [
        $6a034d323e4fb695$var$genSearchStyle(token)
    ];
});


"use client";
const $2ee2b101710a955f$var$Search = /*#__PURE__*/ $N3oW3.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, inputPrefixCls: customizeInputPrefixCls, className: className, size: customizeSize, style: style, enterButton: enterButton = false, addonAfter: addonAfter, loading: loading, disabled: disabled, onSearch: customOnSearch, onChange: customOnChange, onCompositionStart: onCompositionStart, onCompositionEnd: onCompositionEnd, variant: variant, onPressEnter: customOnPressEnter, classNames: classNames, styles: styles, hidden: hidden, ...restProps } = props;
    const { direction: direction, getPrefixCls: getPrefixCls, classNames: contextClassNames, styles: contextStyles } = (0, $dd01e2f5a4b8605d$export$46f4bd6436a25a31)('inputSearch');
    const mergedProps = {
        ...props,
        enterButton: enterButton
    };
    const [mergedClassNames, mergedStyles] = (0, $4dcf69d8c3d6df5c$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    }, {
        button: {
            _default: 'root'
        }
    });
    const composedRef = $32rMB.useRef(false);
    const prefixCls = getPrefixCls('input-search', customizePrefixCls);
    const inputPrefixCls = getPrefixCls('input', customizeInputPrefixCls);
    const [hashId, cssVarCls] = (0, $6a034d323e4fb695$export$2e2bcd8739ae039)(prefixCls);
    const { compactSize: compactSize } = (0, $085e8dc0a3d19960$export$cd8cf9d7bab8dd4)(prefixCls, direction);
    const size = (0, $324b30eda6ea1cd7$export$2e2bcd8739ae039)((ctx)=>customizeSize ?? compactSize ?? ctx);
    const inputRef = $32rMB.useRef(null);
    const onChange = (e)=>{
        if (e?.target && e.type === 'click' && customOnSearch) customOnSearch(e.target.value, e, {
            source: 'clear'
        });
        customOnChange?.(e);
    };
    const onMouseDown = (e)=>{
        if (document.activeElement === inputRef.current?.input) e.preventDefault();
    };
    const onSearch = (e)=>{
        if (customOnSearch) customOnSearch(inputRef.current?.input?.value, e, {
            source: 'input'
        });
    };
    const onPressEnter = (e)=>{
        if (composedRef.current || loading) return;
        customOnPressEnter?.(e);
        onSearch(e);
    };
    const searchIcon = typeof enterButton === 'boolean' ? /*#__PURE__*/ $hO8yS.createElement((0, $a3bf8c02a3dd583c$export$2e2bcd8739ae039), null) : null;
    const btnPrefixCls = `${prefixCls}-btn`;
    const btnClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(btnPrefixCls, {
        [`${btnPrefixCls}-${variant}`]: variant
    });
    let button;
    const enterButtonAsElement = enterButton || {};
    const isAntdButton = enterButtonAsElement.type && enterButtonAsElement.type.__ANT_BUTTON === true;
    if (isAntdButton || enterButtonAsElement.type === 'button') button = (0, $62609775897a768c$export$e530037191fcd5d7)(enterButtonAsElement, {
        onMouseDown: onMouseDown,
        onClick: (e)=>{
            enterButtonAsElement?.props?.onClick?.(e);
            onSearch(e);
        },
        key: 'enterButton',
        ...isAntdButton ? {
            className: btnClassName,
            size: size
        } : {}
    });
    else button = /*#__PURE__*/ $hO8yS.createElement((0, $9632ad3149894c43$export$2e2bcd8739ae039), {
        classNames: mergedClassNames.button,
        styles: mergedStyles.button,
        className: btnClassName,
        color: enterButton ? 'primary' : 'default',
        size: size,
        disabled: disabled,
        key: "enterButton",
        onMouseDown: onMouseDown,
        onClick: onSearch,
        loading: loading,
        icon: searchIcon,
        variant: variant === 'borderless' || variant === 'filled' || variant === 'underlined' ? 'text' : enterButton ? 'solid' : undefined
    }, enterButton);
    if (addonAfter) button = [
        button,
        (0, $62609775897a768c$export$e530037191fcd5d7)(addonAfter, {
            key: 'addonAfter'
        })
    ];
    const mergedClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, cssVarCls, {
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-${size}`]: !!size,
        [`${prefixCls}-with-button`]: !!enterButton
    }, className, hashId, mergedClassNames.root);
    const handleOnCompositionStart = (e)=>{
        composedRef.current = true;
        onCompositionStart?.(e);
    };
    const handleOnCompositionEnd = (e)=>{
        composedRef.current = false;
        onCompositionEnd?.(e);
    };
    // ========================== Render ==========================
    // >>> Root Props
    const rootProps = (0, $b0f3dfd0eb3cad70$export$2e2bcd8739ae039)(restProps, {
        data: true
    });
    const inputProps = (0, $f4cf9c2e27c0ac8d$export$2e2bcd8739ae039)({
        ...restProps,
        classNames: (0, $f4cf9c2e27c0ac8d$export$2e2bcd8739ae039)(mergedClassNames, [
            'button',
            'root'
        ]),
        styles: (0, $f4cf9c2e27c0ac8d$export$2e2bcd8739ae039)(mergedStyles, [
            'button',
            'root'
        ]),
        prefixCls: inputPrefixCls,
        type: 'search',
        size: size,
        variant: variant,
        onPressEnter: onPressEnter,
        onCompositionStart: handleOnCompositionStart,
        onCompositionEnd: handleOnCompositionEnd,
        onChange: onChange,
        disabled: disabled
    }, Object.keys(rootProps));
    return /*#__PURE__*/ $hO8yS.createElement((0, $085e8dc0a3d19960$export$2e2bcd8739ae039), {
        className: mergedClassName,
        style: {
            ...style,
            ...mergedStyles.root
        },
        ...rootProps,
        hidden: hidden
    }, /*#__PURE__*/ $hO8yS.createElement((0, $124d0cd1063329f0$export$2e2bcd8739ae039), {
        ref: (0, $2706ed817e87019d$export$ab452c34e8e05029)(inputRef, ref),
        ...inputProps
    }), button);
});
var $2ee2b101710a955f$export$2e2bcd8739ae039 = $2ee2b101710a955f$var$Search;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");






var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");





parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
// Thanks to https://github.com/andreypopp/react-textarea-autosize/
/**
 * calculateNodeHeight(uiTextNode, useCache = false)
 */ const $b0588ec11d48e3eb$var$HIDDEN_TEXTAREA_STYLE = `
  min-height:0 !important;
  max-height:none !important;
  height:0 !important;
  visibility:hidden !important;
  overflow:hidden !important;
  position:absolute !important;
  z-index:-1000 !important;
  top:0 !important;
  right:0 !important;
  pointer-events: none !important;
`;
const $b0588ec11d48e3eb$var$SIZING_STYLE = [
    'letter-spacing',
    'line-height',
    'padding-top',
    'padding-bottom',
    'font-family',
    'font-weight',
    'font-size',
    'font-variant',
    'text-rendering',
    'text-transform',
    'width',
    'text-indent',
    'padding-left',
    'padding-right',
    'border-width',
    'box-sizing',
    'word-break',
    'white-space'
];
const $b0588ec11d48e3eb$var$computedStyleCache = {};
let $b0588ec11d48e3eb$var$hiddenTextarea;
function $b0588ec11d48e3eb$export$1a56dc6a39385a18(node, useCache = false) {
    const nodeRef = node.getAttribute('id') || node.getAttribute('data-reactid') || node.getAttribute('name');
    if (useCache && $b0588ec11d48e3eb$var$computedStyleCache[nodeRef]) return $b0588ec11d48e3eb$var$computedStyleCache[nodeRef];
    const style = window.getComputedStyle(node);
    const boxSizing = style.getPropertyValue('box-sizing') || style.getPropertyValue('-moz-box-sizing') || style.getPropertyValue('-webkit-box-sizing');
    const paddingSize = parseFloat(style.getPropertyValue('padding-bottom')) + parseFloat(style.getPropertyValue('padding-top'));
    const borderSize = parseFloat(style.getPropertyValue('border-bottom-width')) + parseFloat(style.getPropertyValue('border-top-width'));
    const sizingStyle = $b0588ec11d48e3eb$var$SIZING_STYLE.map((name)=>`${name}:${style.getPropertyValue(name)}`).join(';');
    const nodeInfo = {
        sizingStyle: sizingStyle,
        paddingSize: paddingSize,
        borderSize: borderSize,
        boxSizing: boxSizing
    };
    if (useCache && nodeRef) $b0588ec11d48e3eb$var$computedStyleCache[nodeRef] = nodeInfo;
    return nodeInfo;
}
function $b0588ec11d48e3eb$export$2e2bcd8739ae039(uiTextNode, useCache = false, minRows = null, maxRows = null) {
    if (!$b0588ec11d48e3eb$var$hiddenTextarea) {
        $b0588ec11d48e3eb$var$hiddenTextarea = document.createElement('textarea');
        $b0588ec11d48e3eb$var$hiddenTextarea.setAttribute('tab-index', '-1');
        $b0588ec11d48e3eb$var$hiddenTextarea.setAttribute('aria-hidden', 'true');
        // fix: A form field element should have an id or name attribute
        // A form field element has neither an id nor a name attribute. This might prevent the browser from correctly autofilling the form.
        // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/textarea
        $b0588ec11d48e3eb$var$hiddenTextarea.setAttribute('name', 'hiddenTextarea');
        document.body.appendChild($b0588ec11d48e3eb$var$hiddenTextarea);
    }
    // Fix wrap="off" issue
    // https://github.com/ant-design/ant-design/issues/6577
    if (uiTextNode.getAttribute('wrap')) $b0588ec11d48e3eb$var$hiddenTextarea.setAttribute('wrap', uiTextNode.getAttribute('wrap'));
    else $b0588ec11d48e3eb$var$hiddenTextarea.removeAttribute('wrap');
    // Copy all CSS properties that have an impact on the height of the content in
    // the textbox
    const { paddingSize: paddingSize, borderSize: borderSize, boxSizing: boxSizing, sizingStyle: sizingStyle } = $b0588ec11d48e3eb$export$1a56dc6a39385a18(uiTextNode, useCache);
    // Need to have the overflow attribute to hide the scrollbar otherwise
    // text-lines will not calculated properly as the shadow will technically be
    // narrower for content
    $b0588ec11d48e3eb$var$hiddenTextarea.setAttribute('style', `${sizingStyle};${$b0588ec11d48e3eb$var$HIDDEN_TEXTAREA_STYLE}`);
    $b0588ec11d48e3eb$var$hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || '';
    let minHeight = undefined;
    let maxHeight = undefined;
    let overflowY;
    let height = $b0588ec11d48e3eb$var$hiddenTextarea.scrollHeight;
    if (boxSizing === 'border-box') // border-box: add border, since height = content + padding + border
    height += borderSize;
    else if (boxSizing === 'content-box') // remove padding, since height = content
    height -= paddingSize;
    if (minRows !== null || maxRows !== null) {
        // measure height of a textarea with a single row
        $b0588ec11d48e3eb$var$hiddenTextarea.value = ' ';
        const singleRowHeight = $b0588ec11d48e3eb$var$hiddenTextarea.scrollHeight - paddingSize;
        if (minRows !== null) {
            minHeight = singleRowHeight * minRows;
            if (boxSizing === 'border-box') minHeight = minHeight + paddingSize + borderSize;
            height = Math.max(minHeight, height);
        }
        if (maxRows !== null) {
            maxHeight = singleRowHeight * maxRows;
            if (boxSizing === 'border-box') maxHeight = maxHeight + paddingSize + borderSize;
            overflowY = height > maxHeight ? '' : 'hidden';
            height = Math.min(maxHeight, height);
        }
    }
    const style = {
        height: height,
        overflowY: overflowY,
        resize: 'none'
    };
    if (minHeight) style.minHeight = minHeight;
    if (maxHeight) style.maxHeight = maxHeight;
    return style;
}


function $67996a6e7c2831d3$var$_extends() {
    $67996a6e7c2831d3$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $67996a6e7c2831d3$var$_extends.apply(this, arguments);
}
const $67996a6e7c2831d3$var$RESIZE_START = 0;
const $67996a6e7c2831d3$var$RESIZE_MEASURING = 1;
const $67996a6e7c2831d3$var$RESIZE_STABLE = 2;
const $67996a6e7c2831d3$var$ResizableTextArea = /*#__PURE__*/ $N3oW3.forwardRef((props, ref)=>{
    const { prefixCls: prefixCls, defaultValue: defaultValue, value: value, autoSize: autoSize, onResize: onResize, className: className, style: style, disabled: disabled, onChange: onChange, onInternalAutoSize: // Test only
    onInternalAutoSize, ...restProps } = props;
    // =============================== Value ================================
    const [internalValue, setMergedValue] = (0, $05ea6e97cee440ee$export$2e2bcd8739ae039)(defaultValue, value);
    const mergedValue = internalValue ?? '';
    const onInternalChange = (event)=>{
        setMergedValue(event.target.value);
        onChange?.(event);
    };
    // ================================ Ref =================================
    const textareaRef = $32rMB.useRef();
    $32rMB.useImperativeHandle(ref, ()=>({
            textArea: textareaRef.current
        }));
    // ============================== AutoSize ==============================
    const [minRows, maxRows] = $32rMB.useMemo(()=>{
        if (autoSize && typeof autoSize === 'object') return [
            autoSize.minRows,
            autoSize.maxRows
        ];
        return [];
    }, [
        autoSize
    ]);
    const needAutoSize = !!autoSize;
    // =============================== Resize ===============================
    const [resizeState, setResizeState] = $32rMB.useState($67996a6e7c2831d3$var$RESIZE_STABLE);
    const [autoSizeStyle, setAutoSizeStyle] = $32rMB.useState();
    const startResize = ()=>{
        setResizeState($67996a6e7c2831d3$var$RESIZE_START);
    };
    // Change to trigger resize measure
    (0, $60cea2402df671e7$export$2e2bcd8739ae039)(()=>{
        if (needAutoSize) startResize();
    }, [
        value,
        minRows,
        maxRows,
        needAutoSize
    ]);
    (0, $60cea2402df671e7$export$2e2bcd8739ae039)(()=>{
        if (resizeState === $67996a6e7c2831d3$var$RESIZE_START) setResizeState($67996a6e7c2831d3$var$RESIZE_MEASURING);
        else if (resizeState === $67996a6e7c2831d3$var$RESIZE_MEASURING) {
            const textareaStyles = (0, $b0588ec11d48e3eb$export$2e2bcd8739ae039)(textareaRef.current, false, minRows, maxRows);
            // Safari has bug that text will keep break line on text cut when it's prev is break line.
            // ZombieJ: This not often happen. So we just skip it.
            // const { selectionStart, selectionEnd, scrollTop } = textareaRef.current;
            // const { value: tmpValue } = textareaRef.current;
            // textareaRef.current.value = '';
            // textareaRef.current.value = tmpValue;
            // if (document.activeElement === textareaRef.current) {
            //   textareaRef.current.scrollTop = scrollTop;
            //   textareaRef.current.setSelectionRange(selectionStart, selectionEnd);
            // }
            setResizeState($67996a6e7c2831d3$var$RESIZE_STABLE);
            setAutoSizeStyle(textareaStyles);
        }
    }, [
        resizeState
    ]);
    // We lock resize trigger by raf to avoid Safari warning
    const resizeRafRef = $32rMB.useRef();
    const cleanRaf = ()=>{
        (0, $c9c36e20d667d30c$export$2e2bcd8739ae039).cancel(resizeRafRef.current);
    };
    const onInternalResize = (size)=>{
        if (resizeState === $67996a6e7c2831d3$var$RESIZE_STABLE) {
            onResize?.(size);
            if (autoSize) {
                cleanRaf();
                resizeRafRef.current = (0, $c9c36e20d667d30c$export$2e2bcd8739ae039)(()=>{
                    startResize();
                });
            }
        }
    };
    $32rMB.useEffect(()=>cleanRaf, []);
    // =============================== Render ===============================
    const mergedAutoSizeStyle = needAutoSize ? autoSizeStyle : null;
    const mergedStyle = {
        ...style,
        ...mergedAutoSizeStyle
    };
    if (resizeState === $67996a6e7c2831d3$var$RESIZE_START || resizeState === $67996a6e7c2831d3$var$RESIZE_MEASURING) {
        mergedStyle.overflowY = 'hidden';
        mergedStyle.overflowX = 'hidden';
    }
    return /*#__PURE__*/ $hO8yS.createElement((0, $b8d12c084d14878d$export$2e2bcd8739ae039), {
        onResize: onInternalResize,
        disabled: !(autoSize || onResize)
    }, /*#__PURE__*/ $hO8yS.createElement("textarea", $67996a6e7c2831d3$var$_extends({}, restProps, {
        ref: textareaRef,
        style: mergedStyle,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, className, {
            [`${prefixCls}-disabled`]: disabled
        }),
        disabled: disabled,
        value: mergedValue,
        onChange: onInternalChange
    })));
});
var $67996a6e7c2831d3$export$2e2bcd8739ae039 = $67996a6e7c2831d3$var$ResizableTextArea;


function $a83b5bb4948f44e2$var$_extends() {
    $a83b5bb4948f44e2$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a83b5bb4948f44e2$var$_extends.apply(this, arguments);
}
const $a83b5bb4948f44e2$var$TextArea = /*#__PURE__*/ (0, $N3oW3.default).forwardRef(({ defaultValue: defaultValue, value: customValue, onFocus: onFocus, onBlur: onBlur, onChange: onChange, allowClear: allowClear, maxLength: maxLength, onCompositionStart: onCompositionStart, onCompositionEnd: onCompositionEnd, suffix: suffix, prefixCls: prefixCls = 'rc-textarea', showCount: showCount, count: count, className: className, style: style, disabled: disabled, hidden: hidden, classNames: classNames, styles: styles, onResize: onResize, onClear: onClear, onPressEnter: onPressEnter, readOnly: readOnly, autoSize: autoSize, onKeyDown: onKeyDown, ...rest }, ref)=>{
    const [value, setValue] = (0, $05ea6e97cee440ee$export$2e2bcd8739ae039)(defaultValue, customValue);
    const formatValue = value === undefined || value === null ? '' : String(value);
    const [focused, setFocused] = (0, $N3oW3.default).useState(false);
    const compositionRef = (0, $N3oW3.default).useRef(false);
    const [textareaResized, setTextareaResized] = (0, $N3oW3.default).useState(null);
    // =============================== Ref ================================
    const holderRef = (0, $32rMB.useRef)(null);
    const resizableTextAreaRef = (0, $32rMB.useRef)(null);
    const getTextArea = ()=>resizableTextAreaRef.current?.textArea;
    const focus = ()=>{
        getTextArea().focus();
    };
    (0, $32rMB.useImperativeHandle)(ref, ()=>({
            resizableTextArea: resizableTextAreaRef.current,
            focus: focus,
            blur: ()=>{
                getTextArea().blur();
            },
            nativeElement: holderRef.current?.nativeElement || getTextArea()
        }));
    (0, $32rMB.useEffect)(()=>{
        setFocused((prev)=>!disabled && prev);
    }, [
        disabled
    ]);
    // =========================== Select Range ===========================
    const [selection, setSelection] = (0, $N3oW3.default).useState(null);
    (0, $N3oW3.default).useEffect(()=>{
        if (selection) getTextArea().setSelectionRange(...selection);
    }, [
        selection
    ]);
    // ============================== Count ===============================
    const countConfig = (0, $824a71fa2827d689$export$2e2bcd8739ae039)(count, showCount);
    const mergedMax = countConfig.max ?? maxLength;
    // Max length value
    const hasMaxLength = Number(mergedMax) > 0;
    const valueLength = countConfig.strategy(formatValue);
    const isOutOfRange = !!mergedMax && valueLength > mergedMax;
    // ============================== Change ==============================
    const triggerChange = (e, currentValue)=>{
        let cutValue = currentValue;
        if (!compositionRef.current && countConfig.exceedFormatter && countConfig.max && countConfig.strategy(currentValue) > countConfig.max) {
            cutValue = countConfig.exceedFormatter(currentValue, {
                max: countConfig.max
            });
            if (currentValue !== cutValue) setSelection([
                getTextArea().selectionStart || 0,
                getTextArea().selectionEnd || 0
            ]);
        }
        setValue(cutValue);
        (0, $661415facc16dddb$export$c28984794956ddc0)(e.currentTarget, e, onChange, cutValue);
    };
    // =========================== Value Update ===========================
    const onInternalCompositionStart = (e)=>{
        compositionRef.current = true;
        onCompositionStart?.(e);
    };
    const onInternalCompositionEnd = (e)=>{
        compositionRef.current = false;
        triggerChange(e, e.currentTarget.value);
        onCompositionEnd?.(e);
    };
    const onInternalChange = (e)=>{
        triggerChange(e, e.target.value);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && onPressEnter && !e.nativeEvent.isComposing) onPressEnter(e);
        onKeyDown?.(e);
    };
    const handleFocus = (e)=>{
        setFocused(true);
        onFocus?.(e);
    };
    const handleBlur = (e)=>{
        setFocused(false);
        onBlur?.(e);
    };
    // ============================== Reset ===============================
    const handleReset = (e)=>{
        setValue('');
        focus();
        (0, $661415facc16dddb$export$c28984794956ddc0)(getTextArea(), e, onChange);
    };
    let suffixNode = suffix;
    let dataCount;
    if (countConfig.show) {
        if (countConfig.showFormatter) dataCount = countConfig.showFormatter({
            value: formatValue,
            count: valueLength,
            maxLength: mergedMax
        });
        else dataCount = `${valueLength}${hasMaxLength ? ` / ${mergedMax}` : ''}`;
        suffixNode = /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $N3oW3.default).Fragment, null, suffixNode, /*#__PURE__*/ (0, $N3oW3.default).createElement("span", {
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-data-count`, classNames?.count),
            style: styles?.count
        }, dataCount));
    }
    const handleResize = (size)=>{
        onResize?.(size);
        if (getTextArea()?.style.height) setTextareaResized(true);
    };
    const isPureTextArea = !autoSize && !showCount && !allowClear;
    return /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $b3991e88a6bc5599$export$2e2bcd8739ae039), {
        ref: holderRef,
        value: formatValue,
        allowClear: allowClear,
        handleReset: handleReset,
        suffix: suffixNode,
        prefixCls: prefixCls,
        classNames: {
            ...classNames,
            affixWrapper: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(classNames?.affixWrapper, {
                [`${prefixCls}-show-count`]: showCount,
                [`${prefixCls}-textarea-allow-clear`]: allowClear
            })
        },
        disabled: disabled,
        focused: focused,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(className, isOutOfRange && `${prefixCls}-out-of-range`),
        style: {
            ...style,
            ...textareaResized && !isPureTextArea ? {
                height: 'auto'
            } : {}
        },
        dataAttrs: {
            affixWrapper: {
                'data-count': typeof dataCount === 'string' ? dataCount : undefined
            }
        },
        hidden: hidden,
        readOnly: readOnly,
        onClear: onClear
    }, /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $67996a6e7c2831d3$export$2e2bcd8739ae039), $a83b5bb4948f44e2$var$_extends({}, rest, {
        autoSize: autoSize,
        maxLength: maxLength,
        onKeyDown: handleKeyDown,
        onChange: onInternalChange,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onCompositionStart: onInternalCompositionStart,
        onCompositionEnd: onInternalCompositionEnd,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(classNames?.textarea),
        style: {
            resize: style?.resize,
            ...styles?.textarea
        },
        disabled: disabled,
        prefixCls: prefixCls,
        onResize: handleResize,
        ref: resizableTextAreaRef,
        readOnly: readOnly
    })));
});
var $a83b5bb4948f44e2$export$2e2bcd8739ae039 = $a83b5bb4948f44e2$var$TextArea;



var $b2a88974a97aeafb$export$2e2bcd8739ae039 = (0, $a83b5bb4948f44e2$export$2e2bcd8739ae039);


















const $3e486b10ce6319a6$var$genTextAreaStyle = (token)=>{
    const { componentCls: componentCls, paddingLG: paddingLG } = token;
    const textareaPrefixCls = `${componentCls}-textarea`;
    return {
        // Raw Textarea
        [`textarea${componentCls}`]: {
            maxWidth: '100%',
            // prevent textarea resize from coming out of its container
            height: 'auto',
            minHeight: token.controlHeight,
            lineHeight: token.lineHeight,
            verticalAlign: 'bottom',
            transition: `all ${token.motionDurationSlow}`,
            resize: 'vertical',
            [`&${componentCls}-mouse-active`]: {
                transition: `all ${token.motionDurationSlow}, height 0s, width 0s`
            }
        },
        // Wrapper for resize
        [`${componentCls}-textarea-affix-wrapper-resize-dirty`]: {
            width: 'auto'
        },
        [textareaPrefixCls]: {
            position: 'relative',
            '&-show-count': {
                [`${componentCls}-data-count`]: {
                    position: 'absolute',
                    bottom: token.calc(token.fontSize).mul(token.lineHeight).mul(-1).equal(),
                    insetInlineEnd: 0,
                    color: token.colorTextDescription,
                    whiteSpace: 'nowrap',
                    pointerEvents: 'none'
                }
            },
            [`
        &-allow-clear > ${componentCls},
        &-affix-wrapper${textareaPrefixCls}-has-feedback ${componentCls}
      `]: {
                paddingInlineEnd: paddingLG
            },
            [`&-affix-wrapper${componentCls}-affix-wrapper`]: {
                padding: 0,
                [`> textarea${componentCls}`]: {
                    fontSize: 'inherit',
                    border: 'none',
                    outline: 'none',
                    background: 'transparent',
                    minHeight: token.calc(token.controlHeight).sub(token.calc(token.lineWidth).mul(2)).equal(),
                    '&:focus': {
                        boxShadow: 'none !important'
                    }
                },
                [`${componentCls}-suffix`]: {
                    margin: 0,
                    '> *:not(:last-child)': {
                        marginInline: 0
                    },
                    // Clear Icon
                    [`${componentCls}-clear-icon`]: {
                        position: 'absolute',
                        insetInlineEnd: token.paddingInline,
                        insetBlockStart: token.paddingXS
                    },
                    // Feedback Icon
                    [`${textareaPrefixCls}-suffix`]: {
                        position: 'absolute',
                        top: 0,
                        insetInlineEnd: token.paddingInline,
                        bottom: 0,
                        zIndex: 1,
                        display: 'inline-flex',
                        alignItems: 'center',
                        margin: 'auto',
                        pointerEvents: 'none'
                    }
                }
            },
            [`&-affix-wrapper${componentCls}-affix-wrapper-rtl`]: {
                [`${componentCls}-suffix`]: {
                    [`${componentCls}-data-count`]: {
                        direction: 'ltr',
                        insetInlineStart: 0
                    }
                }
            },
            [`&-affix-wrapper${componentCls}-affix-wrapper-sm`]: {
                [`${componentCls}-suffix`]: {
                    [`${componentCls}-clear-icon`]: {
                        insetInlineEnd: token.paddingInlineSM
                    }
                }
            }
        }
    };
};
var // ============================== Export ==============================
$3e486b10ce6319a6$export$2e2bcd8739ae039 = (0, $d4a2dc313c4d90a4$export$51ec95de45185b42)([
    'Input',
    'TextArea'
], (token)=>{
    const inputToken = (0, $90c11ca6cb263fd9$export$4950aa0f605343fb)(token, (0, $2086d48ba031927a$export$a157d95850191a12)(token));
    return $3e486b10ce6319a6$var$genTextAreaStyle(inputToken);
}, (0, $2086d48ba031927a$export$bd8b682992bc9781), {
    resetFont: false
});


"use client";
const $9577974f4b162653$var$TextArea = /*#__PURE__*/ (0, $N3oW3.forwardRef)((props, ref)=>{
    const { prefixCls: customizePrefixCls, bordered: bordered = true, size: customizeSize, disabled: customDisabled, status: customStatus, allowClear: allowClear, classNames: classNames, rootClassName: rootClassName, className: className, style: style, styles: styles, variant: customVariant, showCount: showCount, onMouseDown: onMouseDown, onResize: onResize, ...rest } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, allowClear: contextAllowClear, autoComplete: contextAutoComplete, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $dd01e2f5a4b8605d$export$46f4bd6436a25a31)('textArea');
    // =================== Disabled ===================
    const disabled = $32rMB.useContext((0, $ff4b4ddbf52ed41f$export$2e2bcd8739ae039));
    const mergedDisabled = customDisabled ?? disabled;
    // ==================== Status ====================
    const { status: contextStatus, hasFeedback: hasFeedback, feedbackIcon: feedbackIcon } = $32rMB.useContext((0, $a1a112e4dddc1035$export$bbb5553c6c7a14ed));
    const mergedStatus = (0, $597dc4581bd08a1e$export$314e193082d7ba49)(contextStatus, customStatus);
    const [mergedClassNames, mergedStyles] = (0, $4dcf69d8c3d6df5c$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: props
    });
    // ===================== Ref ======================
    const innerRef = $32rMB.useRef(null);
    $32rMB.useImperativeHandle(ref, ()=>({
            resizableTextArea: innerRef.current?.resizableTextArea,
            focus: (option)=>{
                (0, $f773cdc81cd324e4$export$2b92016deb0b7aad)(innerRef.current?.resizableTextArea?.textArea, option);
            },
            blur: ()=>innerRef.current?.blur()
        }));
    const prefixCls = getPrefixCls('input', customizePrefixCls);
    // ==================== Style =====================
    const rootCls = (0, $54b1aecddbbbed4f$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $e8a8f826922d3542$export$de732caeaad5f68e)(prefixCls, rootClassName);
    (0, $3e486b10ce6319a6$export$2e2bcd8739ae039)(prefixCls, rootCls);
    // ================= Compact Item =================
    const { compactSize: compactSize, compactItemClassnames: compactItemClassnames } = (0, $085e8dc0a3d19960$export$cd8cf9d7bab8dd4)(prefixCls, direction);
    // ===================== Size =====================
    const mergedSize = (0, $324b30eda6ea1cd7$export$2e2bcd8739ae039)((ctx)=>customizeSize ?? compactSize ?? ctx);
    const [variant, enableVariantCls] = (0, $b3bf3719877c7ee9$export$2e2bcd8739ae039)('textArea', customVariant, bordered);
    const mergedAllowClear = (0, $d2ac56745c809c35$export$2e2bcd8739ae039)(allowClear ?? contextAllowClear);
    // ==================== Resize ====================
    // https://github.com/ant-design/ant-design/issues/51594
    const [isMouseDown, setIsMouseDown] = $32rMB.useState(false);
    // When has wrapper, resize will make as dirty for `resize: both` style
    const [resizeDirty, setResizeDirty] = $32rMB.useState(false);
    const onInternalMouseDown = (e)=>{
        setIsMouseDown(true);
        onMouseDown?.(e);
        const onMouseUp = ()=>{
            setIsMouseDown(false);
            document.removeEventListener('mouseup', onMouseUp);
        };
        document.addEventListener('mouseup', onMouseUp);
    };
    const onInternalResize = (size)=>{
        onResize?.(size);
        // Change to dirty since this maybe from the `resize: both` style
        if (isMouseDown && typeof getComputedStyle === 'function') {
            const ele = innerRef.current?.nativeElement?.querySelector('textarea');
            if (ele && getComputedStyle(ele).resize === 'both') setResizeDirty(true);
        }
    };
    // ==================== Render ====================
    return /*#__PURE__*/ $hO8yS.createElement((0, $b2a88974a97aeafb$export$2e2bcd8739ae039), {
        autoComplete: contextAutoComplete,
        ...rest,
        style: {
            ...mergedStyles.root,
            ...contextStyle,
            ...style
        },
        styles: mergedStyles,
        disabled: mergedDisabled,
        allowClear: mergedAllowClear,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(cssVarCls, rootCls, className, rootClassName, compactItemClassnames, contextClassName, mergedClassNames.root, // Only for wrapper
        {
            [`${prefixCls}-textarea-affix-wrapper-resize-dirty`]: resizeDirty
        }),
        classNames: {
            ...mergedClassNames,
            textarea: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)({
                [`${prefixCls}-sm`]: mergedSize === 'small',
                [`${prefixCls}-lg`]: mergedSize === 'large'
            }, hashId, mergedClassNames.textarea, isMouseDown && `${prefixCls}-mouse-active`),
            variant: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)({
                [`${prefixCls}-${variant}`]: enableVariantCls
            }, (0, $597dc4581bd08a1e$export$b08e7b47149942a2)(prefixCls, mergedStatus)),
            affixWrapper: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-textarea-affix-wrapper`, {
                [`${prefixCls}-affix-wrapper-rtl`]: direction === 'rtl',
                [`${prefixCls}-affix-wrapper-sm`]: mergedSize === 'small',
                [`${prefixCls}-affix-wrapper-lg`]: mergedSize === 'large',
                [`${prefixCls}-textarea-show-count`]: showCount || props.count?.show
            }, hashId)
        },
        prefixCls: prefixCls,
        suffix: hasFeedback && /*#__PURE__*/ $hO8yS.createElement("span", {
            className: `${prefixCls}-textarea-suffix`
        }, feedbackIcon),
        showCount: showCount,
        ref: innerRef,
        onResize: onInternalResize,
        onMouseDown: onInternalMouseDown
    });
});
var $9577974f4b162653$export$2e2bcd8739ae039 = $9577974f4b162653$var$TextArea;


"use client";
const $f5df81ecd1248f24$var$Input = (0, $124d0cd1063329f0$export$2e2bcd8739ae039);
$f5df81ecd1248f24$var$Input.Group = (0, $a2363e2e0a94198a$export$2e2bcd8739ae039);
$f5df81ecd1248f24$var$Input.Search = (0, $2ee2b101710a955f$export$2e2bcd8739ae039);
$f5df81ecd1248f24$var$Input.TextArea = (0, $9577974f4b162653$export$2e2bcd8739ae039);
$f5df81ecd1248f24$var$Input.Password = (0, $188ea5730b8c6975$export$2e2bcd8739ae039);
$f5df81ecd1248f24$var$Input.OTP = (0, $9988f4eabaad6740$export$2e2bcd8739ae039);
var $f5df81ecd1248f24$export$2e2bcd8739ae039 = $f5df81ecd1248f24$var$Input;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");







function $1e23acbcd3569a86$export$2e2bcd8739ae039(siders, children, hasSider) {
    if (typeof hasSider === 'boolean') return hasSider;
    if (siders.length) return true;
    const childNodes = (0, $a60ede783f74e6a9$export$2e2bcd8739ae039)(children);
    return childNodes.some((node)=>node.type === (0, $6adf4c035f43d1a3$export$2e2bcd8739ae039));
}



"use client";
function $35d0696afe5c3f29$var$generator({ suffixCls: suffixCls, tagName: tagName, displayName: displayName }) {
    return (BasicComponent)=>{
        const Adapter = /*#__PURE__*/ $N3oW3.forwardRef((props, ref)=>/*#__PURE__*/ $hO8yS.createElement(BasicComponent, {
                ref: ref,
                suffixCls: suffixCls,
                tagName: tagName,
                ...props
            }));
        return Adapter;
    };
}
const $35d0696afe5c3f29$var$Basic = /*#__PURE__*/ $N3oW3.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, suffixCls: suffixCls, className: className, tagName: TagName, ...others } = props;
    const { getPrefixCls: getPrefixCls } = $32rMB.useContext((0, $dd01e2f5a4b8605d$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('layout', customizePrefixCls);
    const [hashId] = (0, $f4e499aab9d498c8$export$2e2bcd8739ae039)(prefixCls);
    const prefixWithSuffixCls = suffixCls ? `${prefixCls}-${suffixCls}` : prefixCls;
    return /*#__PURE__*/ $hO8yS.createElement(TagName, {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(customizePrefixCls || prefixWithSuffixCls, className, hashId),
        ref: ref,
        ...others
    });
});
const $35d0696afe5c3f29$var$BasicLayout = /*#__PURE__*/ $N3oW3.forwardRef((props, ref)=>{
    const { direction: direction } = $32rMB.useContext((0, $dd01e2f5a4b8605d$export$a92f85ab3e9ad68b));
    const [siders, setSiders] = $32rMB.useState([]);
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, children: children, hasSider: hasSider, tagName: Tag, style: style, ...others } = props;
    const passedProps = (0, $f4cf9c2e27c0ac8d$export$2e2bcd8739ae039)(others, [
        'suffixCls'
    ]);
    const { getPrefixCls: getPrefixCls, className: contextClassName, style: contextStyle } = (0, $dd01e2f5a4b8605d$export$46f4bd6436a25a31)('layout');
    const prefixCls = getPrefixCls('layout', customizePrefixCls);
    const mergedHasSider = (0, $1e23acbcd3569a86$export$2e2bcd8739ae039)(siders, children, hasSider);
    const [hashId, cssVarCls] = (0, $f4e499aab9d498c8$export$2e2bcd8739ae039)(prefixCls);
    const classString = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, {
        [`${prefixCls}-has-sider`]: mergedHasSider,
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, contextClassName, className, rootClassName, hashId, cssVarCls);
    const contextValue = $32rMB.useMemo(()=>({
            siderHook: {
                addSider: (id)=>{
                    setSiders((prev)=>[].concat((0, $3746fb019e1f2ee5$export$2e2bcd8739ae039)(prev), [
                            id
                        ]));
                },
                removeSider: (id)=>{
                    setSiders((prev)=>prev.filter((currentId)=>currentId !== id));
                }
            }
        }), []);
    return /*#__PURE__*/ $hO8yS.createElement((0, $6fe8986eac98f947$export$964282a2c3979546).Provider, {
        value: contextValue
    }, /*#__PURE__*/ $hO8yS.createElement(Tag, {
        ref: ref,
        className: classString,
        style: {
            ...contextStyle,
            ...style
        },
        ...passedProps
    }, children));
});
const $35d0696afe5c3f29$var$Layout = $35d0696afe5c3f29$var$generator({
    tagName: 'div',
    displayName: 'Layout'
})($35d0696afe5c3f29$var$BasicLayout);
const $35d0696afe5c3f29$export$8b251419efc915eb = $35d0696afe5c3f29$var$generator({
    suffixCls: 'header',
    tagName: 'header',
    displayName: 'Header'
})($35d0696afe5c3f29$var$Basic);
const $35d0696afe5c3f29$export$a06f1c675e846f6f = $35d0696afe5c3f29$var$generator({
    suffixCls: 'footer',
    tagName: 'footer',
    displayName: 'Footer'
})($35d0696afe5c3f29$var$Basic);
const $35d0696afe5c3f29$export$7c6e2c02157bb7d2 = $35d0696afe5c3f29$var$generator({
    suffixCls: 'content',
    tagName: 'main',
    displayName: 'Content'
})($35d0696afe5c3f29$var$Basic);
var $35d0696afe5c3f29$export$2e2bcd8739ae039 = $35d0696afe5c3f29$var$Layout;



"use client";
const $7bcbd8b5f8085112$var$Layout = (0, $35d0696afe5c3f29$export$2e2bcd8739ae039);
$7bcbd8b5f8085112$var$Layout.Header = (0, $35d0696afe5c3f29$export$8b251419efc915eb);
$7bcbd8b5f8085112$var$Layout.Footer = (0, $35d0696afe5c3f29$export$a06f1c675e846f6f);
$7bcbd8b5f8085112$var$Layout.Content = (0, $35d0696afe5c3f29$export$7c6e2c02157bb7d2);
$7bcbd8b5f8085112$var$Layout.Sider = (0, $6adf4c035f43d1a3$export$2e2bcd8739ae039);
$7bcbd8b5f8085112$var$Layout._InternalSiderContext = (0, $6adf4c035f43d1a3$export$63554aebd2a6d54c);
var $7bcbd8b5f8085112$export$2e2bcd8739ae039 = $7bcbd8b5f8085112$var$Layout;



var $d5I5D = parcelRequire("d5I5D");
parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");

var $d5I5D = parcelRequire("d5I5D");
parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
if (!(0, $32rMB.useState)) throw new Error("mobx-react-lite requires React with Hooks support");
if (!(0, $d5I5D.makeObservable)) throw new Error("mobx-react-lite@3 requires mobx at least version 6 to be available");



var $N3oW3 = parcelRequire("N3oW3");


var $N3oW3 = parcelRequire("N3oW3");

var $d5I5D = parcelRequire("d5I5D");
function $bdde0f0763082e03$export$fb2daceae6f5097a(callback) {
    callback();
}
function $bdde0f0763082e03$export$294943bbc3c74f4f(reactionScheduler) {
    if (!reactionScheduler) reactionScheduler = $bdde0f0763082e03$export$fb2daceae6f5097a;
    (0, $d5I5D.configure)({
        reactionScheduler: reactionScheduler
    });
}
var $bdde0f0763082e03$export$13ce1459b9a04b51 = function() {
    return true;
};


var $8f7e1cb2af041a03$var$deprecatedMessages = [];
function $8f7e1cb2af041a03$export$be38475be17599d(msg) {
    if (!$8f7e1cb2af041a03$var$deprecatedMessages.includes(msg)) {
        $8f7e1cb2af041a03$var$deprecatedMessages.push(msg);
        console.warn(msg);
    }
}



var $d5I5D = parcelRequire("d5I5D");

var $N3oW3 = parcelRequire("N3oW3");

var $d5I5D = parcelRequire("d5I5D");
function $a189cdf79cb75cba$export$ef795f1f307682c7(v) {
    return (0, $d5I5D.getDependencyTree)(v);
}


var $7e84ee2a8f32107c$var$globalIsUsingStaticRendering = false;
function $7e84ee2a8f32107c$export$5d52eaa7c0f24c9e(enable) {
    $7e84ee2a8f32107c$var$globalIsUsingStaticRendering = enable;
}
function $7e84ee2a8f32107c$export$55979271896d643e() {
    return $7e84ee2a8f32107c$var$globalIsUsingStaticRendering;
}


var $8814ffa852bce8d4$export$e901ba0ffe10ba41 = 10000;
var $8814ffa852bce8d4$export$1ae22ce5a82f26b6 = 10000;
var $8814ffa852bce8d4$export$b7a00d372cedeedd = /** @class */ function() {
    function TimerBasedFinalizationRegistry(finalize) {
        var _this = this;
        Object.defineProperty(this, "finalize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: finalize
        });
        Object.defineProperty(this, "registrations", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        Object.defineProperty(this, "sweepTimeout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // Bound so it can be used directly as setTimeout callback.
        Object.defineProperty(this, "sweep", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function(maxAge) {
                if (maxAge === void 0) maxAge = $8814ffa852bce8d4$export$e901ba0ffe10ba41;
                // cancel timeout so we can force sweep anytime
                clearTimeout(_this.sweepTimeout);
                _this.sweepTimeout = undefined;
                var now = Date.now();
                _this.registrations.forEach(function(registration, token) {
                    if (now - registration.registeredAt >= maxAge) {
                        _this.finalize(registration.value);
                        _this.registrations.delete(token);
                    }
                });
                if (_this.registrations.size > 0) _this.scheduleSweep();
            }
        });
        // Bound so it can be exported directly as clearTimers test utility.
        Object.defineProperty(this, "finalizeAllImmediately", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function() {
                _this.sweep(0);
            }
        });
    }
    // Token is actually required with this impl
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "register", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(target, value, token) {
            this.registrations.set(token, {
                value: value,
                registeredAt: Date.now()
            });
            this.scheduleSweep();
        }
    });
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "unregister", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(token) {
            this.registrations.delete(token);
        }
    });
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "scheduleSweep", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            if (this.sweepTimeout === undefined) this.sweepTimeout = setTimeout(this.sweep, $8814ffa852bce8d4$export$1ae22ce5a82f26b6);
        }
    });
    return TimerBasedFinalizationRegistry;
}();
var $8814ffa852bce8d4$export$da5d55a244964b51 = typeof FinalizationRegistry !== "undefined" ? FinalizationRegistry : $8814ffa852bce8d4$export$b7a00d372cedeedd;


var $ed383d49abbbd51b$export$10e8a12fbfd8583c = new (0, $8814ffa852bce8d4$export$da5d55a244964b51)(function(adm) {
    var _a;
    (_a = adm.reaction) === null || _a === void 0 || _a.dispose();
    adm.reaction = null;
});


var $4b7c48f1eea1d2eb$exports = {};
'use strict';

$4b7c48f1eea1d2eb$exports = (parcelRequire("b8GbT"));


function $ebd22b90b4fab7a0$var$createReaction(adm) {
    adm.reaction = new (0, $d5I5D.Reaction)("observer".concat(adm.name), function() {
        var _a;
        adm.stateVersion = Symbol();
        // onStoreChange won't be available until the component "mounts".
        // If state changes in between initial render and mount,
        // `useSyncExternalStore` should handle that by checking the state version and issuing update.
        (_a = adm.onStoreChange) === null || _a === void 0 || _a.call(adm);
    });
}
function $ebd22b90b4fab7a0$export$b9c7ecd090a87b14(render, baseComponentName) {
    if (baseComponentName === void 0) baseComponentName = "observed";
    if ((0, $7e84ee2a8f32107c$export$55979271896d643e)()) return render();
    var admRef = (0, $N3oW3.default).useRef(null);
    if (!admRef.current) {
        // First render
        var adm_1 = {
            reaction: null,
            onStoreChange: null,
            stateVersion: Symbol(),
            name: baseComponentName,
            subscribe: function(onStoreChange) {
                // Do NOT access admRef here!
                (0, $ed383d49abbbd51b$export$10e8a12fbfd8583c).unregister(adm_1);
                adm_1.onStoreChange = onStoreChange;
                if (!adm_1.reaction) {
                    // We've lost our reaction and therefore all subscriptions, occurs when:
                    // 1. Timer based finalization registry disposed reaction before component mounted.
                    // 2. React "re-mounts" same component without calling render in between (typically <StrictMode>).
                    // We have to recreate reaction and schedule re-render to recreate subscriptions,
                    // even if state did not change.
                    $ebd22b90b4fab7a0$var$createReaction(adm_1);
                    // `onStoreChange` won't force update if subsequent `getSnapshot` returns same value.
                    // So we make sure that is not the case
                    adm_1.stateVersion = Symbol();
                }
                return function() {
                    var _a;
                    // Do NOT access admRef here!
                    adm_1.onStoreChange = null;
                    (_a = adm_1.reaction) === null || _a === void 0 || _a.dispose();
                    adm_1.reaction = null;
                };
            },
            getSnapshot: function() {
                // Do NOT access admRef here!
                return adm_1.stateVersion;
            }
        };
        admRef.current = adm_1;
    }
    var adm = admRef.current;
    if (!adm.reaction) {
        // First render or reaction was disposed by registry before subscribe
        $ebd22b90b4fab7a0$var$createReaction(adm);
        // StrictMode/ConcurrentMode/Suspense may mean that our component is
        // rendered and abandoned multiple times, so we need to track leaked
        // Reactions.
        (0, $ed383d49abbbd51b$export$10e8a12fbfd8583c).register(admRef, adm, adm);
    }
    (0, $N3oW3.default).useDebugValue(adm.reaction, (0, $a189cdf79cb75cba$export$ef795f1f307682c7));
    (0, $4b7c48f1eea1d2eb$exports.useSyncExternalStore)(// Both of these must be stable, otherwise it would keep resubscribing every render.
    adm.subscribe, adm.getSnapshot, adm.getSnapshot);
    // render the original component, but have the
    // reaction track the observables, so that rendering
    // can be invalidated (see above) once a dependency changes
    var renderResult;
    var exception;
    adm.reaction.track(function() {
        try {
            renderResult = render();
        } catch (e) {
            exception = e;
        }
    });
    if (exception) throw exception; // re-throw any exceptions caught during rendering
    return renderResult;
}





var $N3oW3 = parcelRequire("N3oW3");


var $08de526831c7ab40$var$_a, $08de526831c7ab40$var$_b;
var $08de526831c7ab40$var$warnObserverOptionsDeprecated = true;
var $08de526831c7ab40$var$warnLegacyContextTypes = true;
var $08de526831c7ab40$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
var $08de526831c7ab40$var$isFunctionNameConfigurable = ($08de526831c7ab40$var$_b = ($08de526831c7ab40$var$_a = Object.getOwnPropertyDescriptor(function() {}, "name")) === null || $08de526831c7ab40$var$_a === void 0 ? void 0 : $08de526831c7ab40$var$_a.configurable) !== null && $08de526831c7ab40$var$_b !== void 0 ? $08de526831c7ab40$var$_b : false;
// Using react-is had some issues (and operates on elements, not on types), see #608 / #609
var $08de526831c7ab40$var$ReactForwardRefSymbol = $08de526831c7ab40$var$hasSymbol ? Symbol.for("react.forward_ref") : typeof (0, $N3oW3.forwardRef) === "function" && (0, $N3oW3.forwardRef)(function(props) {
    return null;
})["$$typeof"];
var $08de526831c7ab40$var$ReactMemoSymbol = $08de526831c7ab40$var$hasSymbol ? Symbol.for("react.memo") : typeof (0, $N3oW3.memo) === "function" && (0, $N3oW3.memo)(function(props) {
    return null;
})["$$typeof"];
function $08de526831c7ab40$export$b6ae1bc530f4c149(baseComponent, // TODO remove in next major
options) {
    var _a;
    if ($08de526831c7ab40$var$ReactMemoSymbol && baseComponent["$$typeof"] === $08de526831c7ab40$var$ReactMemoSymbol) throw new Error("[mobx-react-lite] You are trying to use `observer` on a function component wrapped in either another `observer` or `React.memo`. The observer already applies 'React.memo' for you.");
    // The working of observer is explained step by step in this talk: https://www.youtube.com/watch?v=cPF4iBedoF0&feature=youtu.be&t=1307
    if ((0, $7e84ee2a8f32107c$export$55979271896d643e)()) return baseComponent;
    var useForwardRef = (_a = options === null || options === void 0 ? void 0 : options.forwardRef) !== null && _a !== void 0 ? _a : false;
    var render = baseComponent;
    var baseComponentName = baseComponent.displayName || baseComponent.name;
    // If already wrapped with forwardRef, unwrap,
    // so we can patch render and apply memo
    if ($08de526831c7ab40$var$ReactForwardRefSymbol && baseComponent["$$typeof"] === $08de526831c7ab40$var$ReactForwardRefSymbol) {
        useForwardRef = true;
        render = baseComponent["render"];
        if (typeof render !== "function") throw new Error("[mobx-react-lite] `render` property of ForwardRef was not a function");
    }
    var observerComponent = function(props, ref) {
        return (0, $ebd22b90b4fab7a0$export$b9c7ecd090a87b14)(function() {
            return render(props, ref);
        }, baseComponentName);
    };
    observerComponent.displayName = baseComponent.displayName;
    if ($08de526831c7ab40$var$isFunctionNameConfigurable) Object.defineProperty(observerComponent, "name", {
        value: baseComponent.name,
        writable: true,
        configurable: true
    });
    // Support legacy context: `contextTypes` must be applied before `memo`
    if (baseComponent.contextTypes) observerComponent.contextTypes = baseComponent.contextTypes;
    if (useForwardRef) // `forwardRef` must be applied prior `memo`
    // `forwardRef(observer(cmp))` throws:
    // "forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...))"
    observerComponent = (0, $N3oW3.forwardRef)(observerComponent);
    // memo; we are not interested in deep updates
    // in props; we assume that if deep objects are changed,
    // this is in observables, which would have been tracked anyway
    observerComponent = (0, $N3oW3.memo)(observerComponent);
    $08de526831c7ab40$var$copyStaticProperties(baseComponent, observerComponent);
    return observerComponent;
}
// based on https://github.com/mridgway/hoist-non-react-statics/blob/master/src/index.js
var $08de526831c7ab40$var$hoistBlackList = {
    $$typeof: true,
    render: true,
    compare: true,
    type: true,
    // Don't redefine `displayName`,
    // it's defined as getter-setter pair on `memo` (see #3192).
    displayName: true
};
function $08de526831c7ab40$var$copyStaticProperties(base, target) {
    Object.keys(base).forEach(function(key) {
        if (!$08de526831c7ab40$var$hoistBlackList[key]) Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(base, key));
    });
}



function $76817a6ed803577c$export$c1cbdee04e18ea8b(_a) {
    var children = _a.children, render = _a.render;
    if (children && render) console.error("MobX Observer: Do not use children and render in the same time in `Observer`");
    var component = children || render;
    if (typeof component !== "function") return null;
    return (0, $ebd22b90b4fab7a0$export$b9c7ecd090a87b14)(component);
}
$76817a6ed803577c$export$c1cbdee04e18ea8b.displayName = "Observer";
function $76817a6ed803577c$var$ObserverPropsCheck(props, key, componentName, location, propFullName) {
    var extraKey = key === "children" ? "render" : "children";
    var hasProp = typeof props[key] === "function";
    var hasExtraProp = typeof props[extraKey] === "function";
    if (hasProp && hasExtraProp) return new Error("MobX Observer: Do not use children and render in the same time in`" + componentName);
    if (hasProp || hasExtraProp) return null;
    return new Error("Invalid prop `" + propFullName + "` of type `" + typeof props[key] + "` supplied to" + " `" + componentName + "`, expected `function`.");
}



var $d5I5D = parcelRequire("d5I5D");
parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
function $061a4804dd09d500$export$aa207039f277c5f(initializer, annotations) {
    return (0, $32rMB.useState)(function() {
        return (0, $d5I5D.observable)(initializer(), annotations, {
            autoBind: true
        });
    })[0];
}



var $d5I5D = parcelRequire("d5I5D");
parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");



var $d5I5D = parcelRequire("d5I5D");
parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
function $8c9dd40d41ed3f40$export$e0ded3646391939c(current) {
    // We're deliberately not using idiomatic destructuring for the hook here.
    // Accessing the state value as an array element prevents TypeScript from generating unnecessary helpers in the resulting code.
    // For further details, please refer to mobxjs/mobx#3842.
    var res = (0, $32rMB.useState)(function() {
        return (0, $d5I5D.observable)(current, {}, {
            deep: false
        });
    })[0];
    (0, $d5I5D.runInAction)(function() {
        Object.assign(res, current);
    });
    return res;
}


function $88dd9272e6b141eb$export$f5b97ae82d1eeaf3(initializer, current) {
    var source = current && (0, $8c9dd40d41ed3f40$export$e0ded3646391939c)(current);
    return (0, $32rMB.useState)(function() {
        return (0, $d5I5D.observable)(initializer(source), undefined, {
            autoBind: true
        });
    })[0];
}



var $192af2783b5b45fa$var$_a;
(0, $bdde0f0763082e03$export$294943bbc3c74f4f)((0, $N3oW3.unstable_batchedUpdates));
var $192af2783b5b45fa$export$469d51fb8d268227 = ($192af2783b5b45fa$var$_a = (0, $ed383d49abbbd51b$export$10e8a12fbfd8583c)["finalizeAllImmediately"]) !== null && $192af2783b5b45fa$var$_a !== void 0 ? $192af2783b5b45fa$var$_a : function() {};
function $192af2783b5b45fa$export$b9c7ecd090a87b14(fn, baseComponentName) {
    if (baseComponentName === void 0) baseComponentName = "observed";
    return (0, $ebd22b90b4fab7a0$export$b9c7ecd090a87b14)(fn, baseComponentName);
}
function $192af2783b5b45fa$export$7613124ee4202834(enable) {
    (0, $7e84ee2a8f32107c$export$5d52eaa7c0f24c9e)(enable);
}


function $4d3432ed03d68615$var$shallowEqual(objA, objB) {
    //From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if ($4d3432ed03d68615$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.hasOwnProperty.call(objB, keysA[i]) || !$4d3432ed03d68615$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
function $4d3432ed03d68615$var$is(x, y) {
    // From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
// based on https://github.com/mridgway/hoist-non-react-statics/blob/master/src/index.js
var $4d3432ed03d68615$var$hoistBlackList = {
    $$typeof: 1,
    render: 1,
    compare: 1,
    type: 1,
    childContextTypes: 1,
    contextType: 1,
    contextTypes: 1,
    defaultProps: 1,
    getDefaultProps: 1,
    getDerivedStateFromError: 1,
    getDerivedStateFromProps: 1,
    mixins: 1,
    displayName: 1,
    propTypes: 1
};
function $4d3432ed03d68615$var$copyStaticProperties(base, target) {
    var protoProps = Object.getOwnPropertyNames(Object.getPrototypeOf(base));
    Object.getOwnPropertyNames(base).forEach(function(key) {
        if (!$4d3432ed03d68615$var$hoistBlackList[key] && protoProps.indexOf(key) === -1) Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(base, key));
    });
}
/**
 * Utilities for patching componentWillUnmount, to make sure @disposeOnUnmount works correctly icm with user defined hooks
 * and the handler provided by mobx-react
 */ var $4d3432ed03d68615$var$mobxMixins = /*#__PURE__*/ Symbol("patchMixins");
var $4d3432ed03d68615$var$mobxPatchedDefinition = /*#__PURE__*/ Symbol("patchedDefinition");
function $4d3432ed03d68615$var$getMixins(target, methodName) {
    var mixins = target[$4d3432ed03d68615$var$mobxMixins] = target[$4d3432ed03d68615$var$mobxMixins] || {};
    var methodMixins = mixins[methodName] = mixins[methodName] || {};
    methodMixins.locks = methodMixins.locks || 0;
    methodMixins.methods = methodMixins.methods || [];
    return methodMixins;
}
function $4d3432ed03d68615$var$wrapper(realMethod, mixins) {
    var _this = this;
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    // locks are used to ensure that mixins are invoked only once per invocation, even on recursive calls
    mixins.locks++;
    try {
        var retVal;
        if (realMethod !== undefined && realMethod !== null) retVal = realMethod.apply(this, args);
        return retVal;
    } finally{
        mixins.locks--;
        if (mixins.locks === 0) mixins.methods.forEach(function(mx) {
            mx.apply(_this, args);
        });
    }
}
function $4d3432ed03d68615$var$wrapFunction(realMethod, mixins) {
    var fn = function fn() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        $4d3432ed03d68615$var$wrapper.call.apply($4d3432ed03d68615$var$wrapper, [
            this,
            realMethod,
            mixins
        ].concat(args));
    };
    return fn;
}
function $4d3432ed03d68615$var$patch(target, methodName, mixinMethod) {
    var mixins = $4d3432ed03d68615$var$getMixins(target, methodName);
    if (mixins.methods.indexOf(mixinMethod) < 0) mixins.methods.push(mixinMethod);
    var oldDefinition = Object.getOwnPropertyDescriptor(target, methodName);
    if (oldDefinition && oldDefinition[$4d3432ed03d68615$var$mobxPatchedDefinition]) // already patched definition, do not repatch
    return;
    var originalMethod = target[methodName];
    var newDefinition = $4d3432ed03d68615$var$createDefinition(target, methodName, oldDefinition ? oldDefinition.enumerable : undefined, mixins, originalMethod);
    Object.defineProperty(target, methodName, newDefinition);
}
function $4d3432ed03d68615$var$createDefinition(target, methodName, enumerable, mixins, originalMethod) {
    var _ref;
    var wrappedFunc = $4d3432ed03d68615$var$wrapFunction(originalMethod, mixins);
    return _ref = {}, _ref[$4d3432ed03d68615$var$mobxPatchedDefinition] = true, _ref.get = function get() {
        return wrappedFunc;
    }, _ref.set = function set(value) {
        if (this === target) wrappedFunc = $4d3432ed03d68615$var$wrapFunction(value, mixins);
        else {
            // when it is an instance of the prototype/a child prototype patch that particular case again separately
            // since we need to store separate values depending on wether it is the actual instance, the prototype, etc
            // e.g. the method for super might not be the same as the method for the prototype which might be not the same
            // as the method for the instance
            var newDefinition = $4d3432ed03d68615$var$createDefinition(this, methodName, enumerable, mixins, value);
            Object.defineProperty(this, methodName, newDefinition);
        }
    }, _ref.configurable = true, _ref.enumerable = enumerable, _ref;
}
var $4d3432ed03d68615$var$administrationSymbol = /*#__PURE__*/ Symbol("ObserverAdministration");
var $4d3432ed03d68615$var$isMobXReactObserverSymbol = /*#__PURE__*/ Symbol("isMobXReactObserver");
var $4d3432ed03d68615$var$observablePropDescriptors;
function $4d3432ed03d68615$var$getAdministration(component) {
    var _component$administra;
    // We create administration lazily, because we can't patch constructor
    // and the exact moment of initialization partially depends on React internals.
    // At the time of writing this, the first thing invoked is one of the observable getter/setter (state/props/context).
    return (_component$administra = component[$4d3432ed03d68615$var$administrationSymbol]) != null ? _component$administra : component[$4d3432ed03d68615$var$administrationSymbol] = {
        reaction: null,
        mounted: false,
        reactionInvalidatedBeforeMount: false,
        forceUpdate: null,
        name: $4d3432ed03d68615$var$getDisplayName(component.constructor),
        state: undefined,
        props: undefined,
        context: undefined
    };
}
function $4d3432ed03d68615$var$makeClassComponentObserver(componentClass) {
    var prototype = componentClass.prototype;
    if (componentClass[$4d3432ed03d68615$var$isMobXReactObserverSymbol]) {
        var displayName = $4d3432ed03d68615$var$getDisplayName(componentClass);
        throw new Error("The provided component class (" + displayName + ") has already been declared as an observer component.");
    } else componentClass[$4d3432ed03d68615$var$isMobXReactObserverSymbol] = true;
    if (prototype.componentWillReact) throw new Error("The componentWillReact life-cycle event is no longer supported");
    if (componentClass["__proto__"] !== (0, $N3oW3.PureComponent)) {
        if (!prototype.shouldComponentUpdate) prototype.shouldComponentUpdate = $4d3432ed03d68615$var$observerSCU;
        else if (prototype.shouldComponentUpdate !== $4d3432ed03d68615$var$observerSCU) // n.b. unequal check, instead of existence check, as @observer might be on superclass as well
        throw new Error("It is not allowed to use shouldComponentUpdate in observer based components.");
    }
    var originalRender = prototype.render;
    if (typeof originalRender !== "function") {
        var _displayName = $4d3432ed03d68615$var$getDisplayName(componentClass);
        throw new Error("[mobx-react] class component (" + _displayName + ") is missing `render` method." + "\n`observer` requires `render` being a function defined on prototype." + "\n`render = () => {}` or `render = function() {}` is not supported.");
    }
    prototype.render = function() {
        Object.defineProperty(this, "render", {
            // There is no safe way to replace render, therefore it's forbidden.
            configurable: false,
            writable: false,
            value: (0, $7e84ee2a8f32107c$export$55979271896d643e)() ? originalRender : $4d3432ed03d68615$var$createReactiveRender.call(this, originalRender)
        });
        return this.render();
    };
    var originalComponentDidMount = prototype.componentDidMount;
    prototype.componentDidMount = function() {
        var _this = this;
        var _displayName2;
        // `componentDidMount` may not be called at all. React can abandon the instance after `render`.
        // That's why we use finalization registry to dispose reaction created during render.
        // Happens with `<Suspend>` see #3492
        //
        // `componentDidMount` can be called immediately after `componentWillUnmount` without calling `render` in between.
        // Happens with `<StrictMode>`see #3395.
        //
        // If `componentDidMount` is called, it's guaranteed to run synchronously with render (similary to `useLayoutEffect`).
        // Therefore we don't have to worry about external (observable) state being updated before mount (no state version checking).
        //
        // Things may change: "In the future, React will provide a feature that lets components preserve state between unmounts"
        var admin = $4d3432ed03d68615$var$getAdministration(this);
        admin.mounted = true;
        // Component instance committed, prevent reaction disposal.
        (0, $ed383d49abbbd51b$export$10e8a12fbfd8583c).unregister(this);
        // We don't set forceUpdate before mount because it requires a reference to `this`,
        // therefore `this` could NOT be garbage collected before mount,
        // preventing reaction disposal by FinalizationRegistry and leading to memory leak.
        // As an alternative we could have `admin.instanceRef = new WeakRef(this)`, but lets avoid it if possible.
        admin.forceUpdate = function() {
            return _this.forceUpdate();
        };
        if (!admin.reaction || admin.reactionInvalidatedBeforeMount) // Missing reaction:
        // 1. Instance was unmounted (reaction disposed) and immediately remounted without running render #3395.
        // 2. Reaction was disposed by finalization registry before mount. Shouldn't ever happen for class components:
        // `componentDidMount` runs synchronously after render, but our registry are deferred (can't run in between).
        // In any case we lost subscriptions to observables, so we have to create new reaction and re-render to resubscribe.
        // The reaction will be created lazily by following render.
        // Reaction invalidated before mount:
        // 1. A descendant's `componenDidMount` invalidated it's parent #3730
        admin.forceUpdate();
        return originalComponentDidMount == null ? void 0 : originalComponentDidMount.apply(this, arguments);
    };
    // TODO@major Overly complicated "patch" is only needed to support the deprecated @disposeOnUnmount
    $4d3432ed03d68615$var$patch(prototype, "componentWillUnmount", function() {
        var _admin$reaction;
        if ((0, $7e84ee2a8f32107c$export$55979271896d643e)()) return;
        var admin = $4d3432ed03d68615$var$getAdministration(this);
        (_admin$reaction = admin.reaction) == null || _admin$reaction.dispose();
        admin.reaction = null;
        admin.forceUpdate = null;
        admin.mounted = false;
        admin.reactionInvalidatedBeforeMount = false;
    });
    return componentClass;
}
// Generates a friendly name for debugging
function $4d3432ed03d68615$var$getDisplayName(componentClass) {
    return componentClass.displayName || componentClass.name || "<component>";
}
function $4d3432ed03d68615$var$createReactiveRender(originalRender) {
    var boundOriginalRender = originalRender.bind(this);
    var admin = $4d3432ed03d68615$var$getAdministration(this);
    function reactiveRender() {
        if (!admin.reaction) {
            // Create reaction lazily to support re-mounting #3395
            admin.reaction = $4d3432ed03d68615$var$createReaction(admin);
            if (!admin.mounted) // React can abandon this instance and never call `componentDidMount`/`componentWillUnmount`,
            // we have to make sure reaction will be disposed.
            (0, $ed383d49abbbd51b$export$10e8a12fbfd8583c).register(this, admin, this);
        }
        var error = undefined;
        var renderResult = undefined;
        admin.reaction.track(function() {
            try {
                // TODO@major
                // Optimization: replace with _allowStateChangesStart/End (not available in mobx@6.0.0)
                renderResult = (0, $d5I5D._allowStateChanges)(false, boundOriginalRender);
            } catch (e) {
                error = e;
            }
        });
        if (error) throw error;
        return renderResult;
    }
    return reactiveRender;
}
function $4d3432ed03d68615$var$createReaction(admin) {
    return new (0, $d5I5D.Reaction)(admin.name + ".render()", function() {
        if (!admin.mounted) {
            // This is neccessary to avoid react warning about calling forceUpdate on component that isn't mounted yet.
            // This happens when component is abandoned after render - our reaction is already created and reacts to changes.
            // `componenDidMount` runs synchronously after `render`, so unlike functional component, there is no delay during which the reaction could be invalidated.
            // However `componentDidMount` runs AFTER it's descendants' `componentDidMount`, which CAN invalidate the reaction, see #3730. Therefore remember and forceUpdate on mount.
            admin.reactionInvalidatedBeforeMount = true;
            return;
        }
        try {
            admin.forceUpdate == null || admin.forceUpdate();
        } catch (error) {
            var _admin$reaction2;
            (_admin$reaction2 = admin.reaction) == null || _admin$reaction2.dispose();
            admin.reaction = null;
        }
    });
}
function $4d3432ed03d68615$var$observerSCU(nextProps, nextState) {
    if ((0, $7e84ee2a8f32107c$export$55979271896d643e)()) console.warn("[mobx-react] It seems that a re-rendering of a React component is triggered while in static (server-side) mode. Please make sure components are rendered only once server-side.");
    // update on any state changes (as is the default)
    if (this.state !== nextState) return true;
    // update if props are shallowly not equal, inspired by PureRenderMixin
    // we could return just 'false' here, and avoid the `skipRender` checks etc
    // however, it is nicer if lifecycle events are triggered like usually,
    // so we return true here if props are shallowly modified.
    return !$4d3432ed03d68615$var$shallowEqual(this.props, nextProps);
}
function $4d3432ed03d68615$var$createObservablePropDescriptor(key) {
    return {
        configurable: true,
        enumerable: true,
        get: function get() {
            var admin = $4d3432ed03d68615$var$getAdministration(this);
            var derivation = (0, $d5I5D._getGlobalState)().trackingDerivation;
            if (derivation && derivation !== admin.reaction) throw new Error("[mobx-react] Cannot read \"" + admin.name + "." + key + "\" in a reactive context, as it isn't observable.\n                    Please use component lifecycle method to copy the value into a local observable first.\n                    See https://github.com/mobxjs/mobx/blob/main/packages/mobx-react/README.md#note-on-using-props-and-state-in-derivations");
            return admin[key];
        },
        set: function set(value) {
            $4d3432ed03d68615$var$getAdministration(this)[key] = value;
        }
    };
}
function $4d3432ed03d68615$export$b6ae1bc530f4c149(component, context) {
    if (context && context.kind !== "class") throw new Error("The @observer decorator can be used on classes only");
    if (component["isMobxInjector"] === true) console.warn("Mobx observer: You are trying to use `observer` on a component that already has `inject`. Please apply `observer` before applying `inject`");
    if (Object.prototype.isPrototypeOf.call((0, $hO8yS.Component), component) || Object.prototype.isPrototypeOf.call((0, $N3oW3.PureComponent), component)) // Class component
    return $4d3432ed03d68615$var$makeClassComponentObserver(component);
    else // Function component
    return (0, $08de526831c7ab40$export$b6ae1bc530f4c149)(component);
}
function $4d3432ed03d68615$var$_extends() {
    return $4d3432ed03d68615$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4d3432ed03d68615$var$_extends.apply(null, arguments);
}
function $4d3432ed03d68615$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
var $4d3432ed03d68615$var$_excluded = [
    "children"
];
var $4d3432ed03d68615$export$f07786cea590ef31 = /*#__PURE__*/ (0, $N3oW3.default).createContext({});
function $4d3432ed03d68615$export$2881499e37b75b9a(props) {
    var children = props.children, stores = $4d3432ed03d68615$var$_objectWithoutPropertiesLoose(props, $4d3432ed03d68615$var$_excluded);
    var parentValue = (0, $N3oW3.default).useContext($4d3432ed03d68615$export$f07786cea590ef31);
    var mutableProviderRef = (0, $N3oW3.default).useRef($4d3432ed03d68615$var$_extends({}, parentValue, stores));
    var value = mutableProviderRef.current;
    var newValue;
    return (0, $N3oW3.default).createElement($4d3432ed03d68615$export$f07786cea590ef31.Provider, {
        value: value
    }, children);
}
$4d3432ed03d68615$export$2881499e37b75b9a.displayName = "MobXProvider";
/**
 * Store Injection
 */ function $4d3432ed03d68615$var$createStoreInjector(grabStoresFn, component, injectNames, makeReactive) {
    // Support forward refs
    var Injector = (0, $N3oW3.default).forwardRef(function(props, ref) {
        var newProps = $4d3432ed03d68615$var$_extends({}, props);
        var context = (0, $N3oW3.default).useContext($4d3432ed03d68615$export$f07786cea590ef31);
        Object.assign(newProps, grabStoresFn(context || {}, newProps) || {});
        if (ref) newProps.ref = ref;
        return (0, $N3oW3.default).createElement(component, newProps);
    });
    if (makeReactive) Injector = $4d3432ed03d68615$export$b6ae1bc530f4c149(Injector);
    Injector["isMobxInjector"] = true; // assigned late to suppress observer warning
    // Static fields from component should be visible on the generated Injector
    $4d3432ed03d68615$var$copyStaticProperties(component, Injector);
    Injector["wrappedComponent"] = component;
    Injector.displayName = $4d3432ed03d68615$var$getInjectName(component, injectNames);
    return Injector;
}
function $4d3432ed03d68615$var$getInjectName(component, injectNames) {
    var displayName;
    var componentName = component.displayName || component.name || component.constructor && component.constructor.name || "Component";
    if (injectNames) displayName = "inject-with-" + injectNames + "(" + componentName + ")";
    else displayName = "inject(" + componentName + ")";
    return displayName;
}
function $4d3432ed03d68615$var$grabStoresByName(storeNames) {
    return function(baseStores, nextProps) {
        storeNames.forEach(function(storeName) {
            if (storeName in nextProps // prefer props over stores
            ) return;
            if (!(storeName in baseStores)) throw new Error("MobX injector: Store '" + storeName + "' is not available! Make sure it is provided by some Provider");
            nextProps[storeName] = baseStores[storeName];
        });
        return nextProps;
    };
}
/**
 * higher order component that injects stores to a child.
 * takes either a varargs list of strings, which are stores read from the context,
 * or a function that manually maps the available stores from the context to props:
 * storesToProps(mobxStores, props, context) => newProps
 */ function $4d3432ed03d68615$export$a976684a0efeb93f() {
    for(var _len = arguments.length, storeNames = new Array(_len), _key = 0; _key < _len; _key++)storeNames[_key] = arguments[_key];
    if (typeof arguments[0] === "function") {
        var grabStoresFn = arguments[0];
        return function(componentClass) {
            return $4d3432ed03d68615$var$createStoreInjector(grabStoresFn, componentClass, grabStoresFn.name, true);
        };
    } else return function(componentClass) {
        return $4d3432ed03d68615$var$createStoreInjector($4d3432ed03d68615$var$grabStoresByName(storeNames), componentClass, storeNames.join("-"), false);
    };
}
var $4d3432ed03d68615$var$reactMajorVersion = /*#__PURE__*/ Number.parseInt(/*#__PURE__*/ (0, $N3oW3.default).version.split(".")[0]);
var $4d3432ed03d68615$var$warnedAboutDisposeOnUnmountDeprecated = false;
var $4d3432ed03d68615$var$protoStoreKey = /*#__PURE__*/ Symbol("disposeOnUnmountProto");
var $4d3432ed03d68615$var$instStoreKey = /*#__PURE__*/ Symbol("disposeOnUnmountInst");
function $4d3432ed03d68615$var$runDisposersOnWillUnmount() {
    var _this = this;
    [].concat(this[$4d3432ed03d68615$var$protoStoreKey] || [], this[$4d3432ed03d68615$var$instStoreKey] || []).forEach(function(propKeyOrFunction) {
        var prop = typeof propKeyOrFunction === "string" ? _this[propKeyOrFunction] : propKeyOrFunction;
        if (prop !== undefined && prop !== null) {
            if (Array.isArray(prop)) prop.map(function(f) {
                return f();
            });
            else prop();
        }
    });
}
/**
 * @deprecated `disposeOnUnmount` is not compatible with React 18 and higher.
 */ function $4d3432ed03d68615$export$4e749cb731da87a9(target, propertyKeyOrFunction) {
    if (Array.isArray(propertyKeyOrFunction)) return propertyKeyOrFunction.map(function(fn) {
        return $4d3432ed03d68615$export$4e749cb731da87a9(target, fn);
    });
    if (!$4d3432ed03d68615$var$warnedAboutDisposeOnUnmountDeprecated) {
        if ($4d3432ed03d68615$var$reactMajorVersion >= 18) console.error("[mobx-react] disposeOnUnmount is not compatible with React 18 and higher. Don't use it.");
        else console.warn("[mobx-react] disposeOnUnmount is deprecated. It won't work correctly with React 18 and higher.");
        $4d3432ed03d68615$var$warnedAboutDisposeOnUnmountDeprecated = true;
    }
    var c = Object.getPrototypeOf(target).constructor;
    var c2 = Object.getPrototypeOf(target.constructor);
    // Special case for react-hot-loader
    var c3 = Object.getPrototypeOf(Object.getPrototypeOf(target));
    if (!(c === (0, $N3oW3.default).Component || c === (0, $N3oW3.default).PureComponent || c2 === (0, $N3oW3.default).Component || c2 === (0, $N3oW3.default).PureComponent || c3 === (0, $N3oW3.default).Component || c3 === (0, $N3oW3.default).PureComponent)) throw new Error("[mobx-react] disposeOnUnmount only supports direct subclasses of React.Component or React.PureComponent.");
    if (typeof propertyKeyOrFunction !== "string" && typeof propertyKeyOrFunction !== "function" && !Array.isArray(propertyKeyOrFunction)) throw new Error("[mobx-react] disposeOnUnmount only works if the parameter is either a property key or a function.");
    // decorator's target is the prototype, so it doesn't have any instance properties like props
    var isDecorator = typeof propertyKeyOrFunction === "string";
    // add property key / function we want run (disposed) to the store
    var componentWasAlreadyModified = !!target[$4d3432ed03d68615$var$protoStoreKey] || !!target[$4d3432ed03d68615$var$instStoreKey];
    var store = isDecorator ? // decorators are added to the prototype store
    target[$4d3432ed03d68615$var$protoStoreKey] || (target[$4d3432ed03d68615$var$protoStoreKey] = []) : // functions are added to the instance store
    target[$4d3432ed03d68615$var$instStoreKey] || (target[$4d3432ed03d68615$var$instStoreKey] = []);
    store.push(propertyKeyOrFunction);
    // tweak the component class componentWillUnmount if not done already
    if (!componentWasAlreadyModified) $4d3432ed03d68615$var$patch(target, "componentWillUnmount", $4d3432ed03d68615$var$runDisposersOnWillUnmount);
    // return the disposer as is if invoked as a non decorator
    if (typeof propertyKeyOrFunction !== "string") return propertyKeyOrFunction;
}
// Copied from React.PropTypes
function $4d3432ed03d68615$var$createChainableTypeChecker(validator) {
    function checkType(isRequired, props, propName, componentName, location, propFullName) {
        for(var _len = arguments.length, rest = new Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++)rest[_key - 6] = arguments[_key];
        return (0, $d5I5D.untracked)(function() {
            componentName = componentName || "<<anonymous>>";
            propFullName = propFullName || propName;
            if (props[propName] == null) {
                if (isRequired) {
                    var actual = props[propName] === null ? "null" : "undefined";
                    return new Error("The " + location + " `" + propFullName + "` is marked as required " + "in `" + componentName + "`, but its value is `" + actual + "`.");
                }
                return null;
            } else // @ts-ignore rest arg is necessary for some React internals - fails tests otherwise
            return validator.apply(void 0, [
                props,
                propName,
                componentName,
                location,
                propFullName
            ].concat(rest));
        });
    }
    var chainedCheckType = checkType.bind(null, false);
    // Add isRequired to satisfy Requirable
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
}
// Copied from React.PropTypes
function $4d3432ed03d68615$var$isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === "symbol") return true;
    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue["@@toStringTag"] === "Symbol") return true;
    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === "function" && propValue instanceof Symbol) return true;
    return false;
}
// Copied from React.PropTypes
function $4d3432ed03d68615$var$getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) return "array";
    if (propValue instanceof RegExp) // Old webkits (at least until Android 4.0) return 'function' rather than
    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
    // passes PropTypes.object.
    return "object";
    if ($4d3432ed03d68615$var$isSymbol(propType, propValue)) return "symbol";
    return propType;
}
// This handles more types than `getPropType`. Only used for error messages.
// Copied from React.PropTypes
function $4d3432ed03d68615$var$getPreciseType(propValue) {
    var propType = $4d3432ed03d68615$var$getPropType(propValue);
    if (propType === "object") {
        if (propValue instanceof Date) return "date";
        else if (propValue instanceof RegExp) return "regexp";
    }
    return propType;
}
function $4d3432ed03d68615$var$createObservableTypeCheckerCreator(allowNativeType, mobxType) {
    return $4d3432ed03d68615$var$createChainableTypeChecker(function(props, propName, componentName, location, propFullName) {
        return (0, $d5I5D.untracked)(function() {
            if (allowNativeType) {
                if ($4d3432ed03d68615$var$getPropType(props[propName]) === mobxType.toLowerCase()) return null;
            }
            var mobxChecker;
            switch(mobxType){
                case "Array":
                    mobxChecker = (0, $d5I5D.isObservableArray);
                    break;
                case "Object":
                    mobxChecker = (0, $d5I5D.isObservableObject);
                    break;
                case "Map":
                    mobxChecker = (0, $d5I5D.isObservableMap);
                    break;
                default:
                    throw new Error("Unexpected mobxType: " + mobxType);
            }
            var propValue = props[propName];
            if (!mobxChecker(propValue)) {
                var preciseType = $4d3432ed03d68615$var$getPreciseType(propValue);
                var nativeTypeExpectationMessage = allowNativeType ? " or javascript `" + mobxType.toLowerCase() + "`" : "";
                return new Error("Invalid prop `" + propFullName + "` of type `" + preciseType + "` supplied to" + " `" + componentName + "`, expected `mobx.Observable" + mobxType + "`" + nativeTypeExpectationMessage + ".");
            }
            return null;
        });
    });
}
function $4d3432ed03d68615$var$createObservableArrayOfTypeChecker(allowNativeType, typeChecker) {
    return $4d3432ed03d68615$var$createChainableTypeChecker(function(props, propName, componentName, location, propFullName) {
        for(var _len2 = arguments.length, rest = new Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++)rest[_key2 - 5] = arguments[_key2];
        return (0, $d5I5D.untracked)(function() {
            if (typeof typeChecker !== "function") return new Error("Property `" + propFullName + "` of component `" + componentName + "` has " + "invalid PropType notation.");
            else {
                var error = $4d3432ed03d68615$var$createObservableTypeCheckerCreator(allowNativeType, "Array")(props, propName, componentName, location, propFullName);
                if (error instanceof Error) return error;
                var propValue = props[propName];
                for(var i = 0; i < propValue.length; i++){
                    error = typeChecker.apply(void 0, [
                        propValue,
                        i,
                        componentName,
                        location,
                        propFullName + "[" + i + "]"
                    ].concat(rest));
                    if (error instanceof Error) return error;
                }
                return null;
            }
        });
    });
}
var $4d3432ed03d68615$var$observableArray = /*#__PURE__*/ $4d3432ed03d68615$var$createObservableTypeCheckerCreator(false, "Array");
var $4d3432ed03d68615$var$observableArrayOf = /*#__PURE__*/ $4d3432ed03d68615$var$createObservableArrayOfTypeChecker.bind(null, false);
var $4d3432ed03d68615$var$observableMap = /*#__PURE__*/ $4d3432ed03d68615$var$createObservableTypeCheckerCreator(false, "Map");
var $4d3432ed03d68615$var$observableObject = /*#__PURE__*/ $4d3432ed03d68615$var$createObservableTypeCheckerCreator(false, "Object");
var $4d3432ed03d68615$var$arrayOrObservableArray = /*#__PURE__*/ $4d3432ed03d68615$var$createObservableTypeCheckerCreator(true, "Array");
var $4d3432ed03d68615$var$arrayOrObservableArrayOf = /*#__PURE__*/ $4d3432ed03d68615$var$createObservableArrayOfTypeChecker.bind(null, true);
var $4d3432ed03d68615$var$objectOrObservableObject = /*#__PURE__*/ $4d3432ed03d68615$var$createObservableTypeCheckerCreator(true, "Object");
var $4d3432ed03d68615$export$e0c95a451cd220b7 = {
    observableArray: $4d3432ed03d68615$var$observableArray,
    observableArrayOf: $4d3432ed03d68615$var$observableArrayOf,
    observableMap: $4d3432ed03d68615$var$observableMap,
    observableObject: $4d3432ed03d68615$var$observableObject,
    arrayOrObservableArray: $4d3432ed03d68615$var$arrayOrObservableArray,
    arrayOrObservableArrayOf: $4d3432ed03d68615$var$arrayOrObservableArrayOf,
    objectOrObservableObject: $4d3432ed03d68615$var$objectOrObservableObject
};
if (!(0, $hO8yS.Component)) throw new Error("mobx-react requires React to be available");
if (!(0, $d5I5D.observable)) throw new Error("mobx-react requires mobx to be available");


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");


var $d5I5D = parcelRequire("d5I5D");

function $60ed8c037a48fa8d$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $60ed8c037a48fa8d$var$$c6af500b4433b08b$exports = {};
$60ed8c037a48fa8d$var$$parcel$export($60ed8c037a48fa8d$var$$c6af500b4433b08b$exports, "SpeechSynthesisState", function() {
    return $60ed8c037a48fa8d$export$bf098d6e10b5582a;
});
$60ed8c037a48fa8d$var$$parcel$export($60ed8c037a48fa8d$var$$c6af500b4433b08b$exports, "SpeechSynthesisModel", function() {
    return $60ed8c037a48fa8d$export$6c5d58455f3ab236;
});
var $60ed8c037a48fa8d$var$$c6af500b4433b08b$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $60ed8c037a48fa8d$var$$c6af500b4433b08b$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $60ed8c037a48fa8d$var$$c6af500b4433b08b$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $60ed8c037a48fa8d$var$$c6af500b4433b08b$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $60ed8c037a48fa8d$var$$c6af500b4433b08b$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $60ed8c037a48fa8d$export$bf098d6e10b5582a;
(function(SpeechSynthesisState) {
    SpeechSynthesisState[SpeechSynthesisState["Clear"] = 0] = "Clear";
    SpeechSynthesisState[SpeechSynthesisState["Speaking"] = 1] = "Speaking";
    SpeechSynthesisState[SpeechSynthesisState["Pause"] = 2] = "Pause";
})($60ed8c037a48fa8d$export$bf098d6e10b5582a || ($60ed8c037a48fa8d$export$bf098d6e10b5582a = {}));
let $60ed8c037a48fa8d$export$6c5d58455f3ab236 = (()=>{
    var _a, _SpeechSynthesisModel_disposer, _SpeechSynthesisModel_state_accessor_storage;
    let _instanceExtraInitializers = [];
    let _state_decorators;
    let _state_initializers = [];
    let _state_extraInitializers = [];
    let _get_language_decorators;
    return _a = class SpeechSynthesisModel {
        get state() {
            return $60ed8c037a48fa8d$var$$c6af500b4433b08b$var$__classPrivateFieldGet(this, _SpeechSynthesisModel_state_accessor_storage, "f");
        }
        set state(value) {
            $60ed8c037a48fa8d$var$$c6af500b4433b08b$var$__classPrivateFieldSet(this, _SpeechSynthesisModel_state_accessor_storage, value, "f");
        }
        get language() {
            var _b, _c;
            return ((_b = this.i18n) === null || _b === void 0 ? void 0 : _b.currentLanguage) || ((_c = globalThis.navigator) === null || _c === void 0 ? void 0 : _c.language);
        }
        constructor(i18n){
            Object.defineProperty(this, "i18n", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($60ed8c037a48fa8d$var$$c6af500b4433b08b$var$__runInitializers(this, _instanceExtraInitializers), i18n)
            });
            _SpeechSynthesisModel_state_accessor_storage.set(this, $60ed8c037a48fa8d$var$$c6af500b4433b08b$var$__runInitializers(this, _state_initializers, $60ed8c037a48fa8d$export$bf098d6e10b5582a.Clear));
            _SpeechSynthesisModel_disposer.set(this, $60ed8c037a48fa8d$var$$c6af500b4433b08b$var$__runInitializers(this, _state_extraInitializers));
            Object.defineProperty(this, "clear", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ()=>{
                    var _b;
                    this.state = $60ed8c037a48fa8d$export$bf098d6e10b5582a.Clear;
                    (_b = $60ed8c037a48fa8d$var$$c6af500b4433b08b$var$__classPrivateFieldGet(this, _SpeechSynthesisModel_disposer, "f")) === null || _b === void 0 || _b.call(this);
                    speechSynthesis.cancel();
                }
            });
            if (i18n) $60ed8c037a48fa8d$var$$c6af500b4433b08b$var$__classPrivateFieldSet(this, _SpeechSynthesisModel_disposer, (0, $d5I5D.reaction)(()=>i18n.currentLanguage, this.clear), "f");
            globalThis.addEventListener('unload', this.clear);
        }
        static getVoices() {
            const voices = speechSynthesis.getVoices();
            return voices[0] ? Promise.resolve(voices) : new Promise((resolve)=>{
                (0, $fbe6f1e2fed97fc7$export$e772c8ff12451969)(1).then(()=>resolve([]));
                speechSynthesis.onvoiceschanged = ()=>resolve(speechSynthesis.getVoices());
            });
        }
        speak(text) {
            return $60ed8c037a48fa8d$var$$c6af500b4433b08b$var$__awaiter(this, void 0, void 0, function*() {
                const { language: language } = this, content = new SpeechSynthesisUtterance(text), voices = yield _a.getVoices();
                content.voice = voices.find(({ localService: localService, lang: lang })=>localService && lang === language) || voices.find(({ default: backup })=>backup);
                const result = new Promise((resolve, reject)=>{
                    content.onend = resolve;
                    content.onerror = reject;
                });
                speechSynthesis.speak(content);
                this.state = $60ed8c037a48fa8d$export$bf098d6e10b5582a.Speaking;
                try {
                    yield result;
                } finally{
                    this.clear();
                }
            });
        }
        toggle() {
            if (this.state === $60ed8c037a48fa8d$export$bf098d6e10b5582a.Speaking) {
                speechSynthesis.pause();
                this.state = $60ed8c037a48fa8d$export$bf098d6e10b5582a.Pause;
            } else {
                speechSynthesis.resume();
                this.state = $60ed8c037a48fa8d$export$bf098d6e10b5582a.Speaking;
            }
        }
        static *walk(range) {
            const { commonAncestorContainer: commonAncestorContainer, endContainer: endContainer } = range;
            const walker = document.createNodeIterator(commonAncestorContainer);
            var current;
            while(current = walker.nextNode()){
                if (range.intersectsNode(current)) yield current;
                if (commonAncestorContainer !== endContainer && current === endContainer) break;
            }
        }
        static getSelectedText(box) {
            var _b;
            const range = (_b = getSelection()) === null || _b === void 0 ? void 0 : _b.getRangeAt(0);
            if (!(range === null || range === void 0 ? void 0 : range.toString()) || !(box === null || box === void 0 ? void 0 : box.contains(range.commonAncestorContainer))) throw new RangeError('No text selected');
            return [
                ...this.walk(range)
            ].filter(({ nodeType: nodeType, parentNode: parentNode })=>{
                if (nodeType !== 3) return;
                const { width: width, height: height } = parentNode.getBoundingClientRect();
                return width && height;
            }).map(({ nodeValue: nodeValue }, index, { length: length })=>nodeValue.slice(index === 0 ? range.startOffset : 0, index === length - 1 ? range.endOffset : Infinity)).filter((text)=>text.trim()).join('').trim();
        }
        static getReadableText(box) {
            try {
                return this.getSelectedText(box);
            } catch (_b) {
                return (0, $fbe6f1e2fed97fc7$export$be4650432daa84fd)(box);
            }
        }
    }, _SpeechSynthesisModel_disposer = new WeakMap(), _SpeechSynthesisModel_state_accessor_storage = new WeakMap(), (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _state_decorators = [
            (0, $d5I5D.observable)
        ];
        _get_language_decorators = [
            (0, $d5I5D.computed)
        ];
        $60ed8c037a48fa8d$var$$c6af500b4433b08b$var$__esDecorate(_a, null, _state_decorators, {
            kind: "accessor",
            name: "state",
            static: false,
            private: false,
            access: {
                has: (obj)=>"state" in obj,
                get: (obj)=>obj.state,
                set: (obj, value)=>{
                    obj.state = value;
                }
            },
            metadata: _metadata
        }, _state_initializers, _state_extraInitializers);
        $60ed8c037a48fa8d$var$$c6af500b4433b08b$var$__esDecorate(_a, null, _get_language_decorators, {
            kind: "getter",
            name: "language",
            static: false,
            private: false,
            access: {
                has: (obj)=>"language" in obj,
                get: (obj)=>obj.language
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
var $60ed8c037a48fa8d$var$$d1a4b21e19b1b67c$exports = {};
$60ed8c037a48fa8d$var$$parcel$export($60ed8c037a48fa8d$var$$d1a4b21e19b1b67c$exports, "TranslationModel", function() {
    return $60ed8c037a48fa8d$export$d91823dfc159395b;
});
$60ed8c037a48fa8d$var$$parcel$export($60ed8c037a48fa8d$var$$d1a4b21e19b1b67c$exports, "loadLanguageMap", function() {
    return $60ed8c037a48fa8d$export$745e12634107cb52;
});
$60ed8c037a48fa8d$var$$parcel$export($60ed8c037a48fa8d$var$$d1a4b21e19b1b67c$exports, "loadLanguageMapFrom", function() {
    return $60ed8c037a48fa8d$export$b9f85f5ba933b8e7;
});
var $60ed8c037a48fa8d$var$$552a56cc5ff3f479$exports = {};
$60ed8c037a48fa8d$var$$parcel$export($60ed8c037a48fa8d$var$$552a56cc5ff3f479$exports, "isNumberLetter", function() {
    return $60ed8c037a48fa8d$export$df0b442c7f8df5c1;
});
$60ed8c037a48fa8d$var$$parcel$export($60ed8c037a48fa8d$var$$552a56cc5ff3f479$exports, "textJoin", function() {
    return $60ed8c037a48fa8d$export$d977f7cd0cb45fe1;
});
$60ed8c037a48fa8d$var$$parcel$export($60ed8c037a48fa8d$var$$552a56cc5ff3f479$exports, "parseLanguageHeader", function() {
    return $60ed8c037a48fa8d$export$2557e81a557a81ea;
});
const $60ed8c037a48fa8d$export$df0b442c7f8df5c1 = (raw = '')=>new RegExp('\\p{N}', 'u').test(raw) || new RegExp('\\p{Ll}', 'u').test(raw.toLowerCase());
const $60ed8c037a48fa8d$export$d977f7cd0cb45fe1 = (...parts)=>parts.map((raw, index)=>{
        var _a;
        const isNL = $60ed8c037a48fa8d$export$df0b442c7f8df5c1(raw.slice(-1));
        if (index + 1 === parts.length) return raw;
        const diff = isNL !== $60ed8c037a48fa8d$export$df0b442c7f8df5c1((_a = parts[index + 1]) === null || _a === void 0 ? void 0 : _a.trim()[0]);
        return raw + (diff || isNL ? ' ' : '');
    }).join('');
const $60ed8c037a48fa8d$export$2557e81a557a81ea = (value)=>value.split(',').map((language)=>{
        const [name, quantity = ''] = language.split(';');
        const [_, value = '1'] = quantity.split('=');
        return [
            name.trim(),
            +value
        ];
    }).sort(([_, a], [__, b])=>b - a).map(([name])=>name);
var $60ed8c037a48fa8d$var$$d1a4b21e19b1b67c$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $60ed8c037a48fa8d$var$$d1a4b21e19b1b67c$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $60ed8c037a48fa8d$var$$d1a4b21e19b1b67c$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $60ed8c037a48fa8d$var$$d1a4b21e19b1b67c$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $60ed8c037a48fa8d$var$$d1a4b21e19b1b67c$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $60ed8c037a48fa8d$export$d91823dfc159395b = (()=>{
    var _a, _TranslationModel_loading_accessor_storage, _TranslationModel_currentLanguage_accessor_storage, _TranslationModel_currentMap_accessor_storage;
    let _instanceExtraInitializers = [];
    let _loading_decorators;
    let _loading_initializers = [];
    let _loading_extraInitializers = [];
    let _currentLanguage_decorators;
    let _currentLanguage_initializers = [];
    let _currentLanguage_extraInitializers = [];
    let _currentMap_decorators;
    let _currentMap_initializers = [];
    let _currentMap_extraInitializers = [];
    let _get_defaultMap_decorators;
    let _loadLanguages_decorators;
    return _a = class TranslationModel {
        get loading() {
            return $60ed8c037a48fa8d$var$$d1a4b21e19b1b67c$var$__classPrivateFieldGet(this, _TranslationModel_loading_accessor_storage, "f");
        }
        set loading(value) {
            $60ed8c037a48fa8d$var$$d1a4b21e19b1b67c$var$__classPrivateFieldSet(this, _TranslationModel_loading_accessor_storage, value, "f");
        }
        get currentLanguage() {
            return $60ed8c037a48fa8d$var$$d1a4b21e19b1b67c$var$__classPrivateFieldGet(this, _TranslationModel_currentLanguage_accessor_storage, "f");
        }
        set currentLanguage(value) {
            $60ed8c037a48fa8d$var$$d1a4b21e19b1b67c$var$__classPrivateFieldSet(this, _TranslationModel_currentLanguage_accessor_storage, value, "f");
        }
        get currentMap() {
            return $60ed8c037a48fa8d$var$$d1a4b21e19b1b67c$var$__classPrivateFieldGet(this, _TranslationModel_currentMap_accessor_storage, "f");
        }
        set currentMap(value) {
            $60ed8c037a48fa8d$var$$d1a4b21e19b1b67c$var$__classPrivateFieldSet(this, _TranslationModel_currentMap_accessor_storage, value, "f");
        }
        get defaultMap() {
            return this.configuration[this.defaultLanguage];
        }
        constructor(configuration){
            Object.defineProperty(this, "configuration", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($60ed8c037a48fa8d$var$$d1a4b21e19b1b67c$var$__runInitializers(this, _instanceExtraInitializers), configuration)
            });
            _TranslationModel_loading_accessor_storage.set(this, $60ed8c037a48fa8d$var$$d1a4b21e19b1b67c$var$__runInitializers(this, _loading_initializers, false));
            Object.defineProperty(this, "defaultLanguage", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: $60ed8c037a48fa8d$var$$d1a4b21e19b1b67c$var$__runInitializers(this, _loading_extraInitializers)
            });
            _TranslationModel_currentLanguage_accessor_storage.set(this, $60ed8c037a48fa8d$var$$d1a4b21e19b1b67c$var$__runInitializers(this, _currentLanguage_initializers, ''));
            _TranslationModel_currentMap_accessor_storage.set(this, ($60ed8c037a48fa8d$var$$d1a4b21e19b1b67c$var$__runInitializers(this, _currentLanguage_extraInitializers), $60ed8c037a48fa8d$var$$d1a4b21e19b1b67c$var$__runInitializers(this, _currentMap_initializers, {})));
            Object.defineProperty(this, "t", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($60ed8c037a48fa8d$var$$d1a4b21e19b1b67c$var$__runInitializers(this, _currentMap_extraInitializers), this.textOf.bind(this))
            });
            for(const name in configuration)if (typeof configuration[name] !== 'function') this.defaultLanguage = name;
            if (!this.defaultLanguage) throw ReferenceError('One static language map is required');
            if (!globalThis.window) return;
            const languages = [
                (0, $fbe6f1e2fed97fc7$export$d0eaf3e94be578f6)().language,
                ...navigator.languages || [
                    this.defaultLanguage
                ],
                document.documentElement.lang
            ].filter(Boolean);
            this.loadLanguages(...languages);
            window.addEventListener('languagechange', ()=>this.loadLanguages(navigator.language));
        }
        onLanguageChange(handler) {
            (0, $d5I5D.reaction)(()=>this.currentLanguage, (currentLanguage, lastLanguage)=>{
                if (lastLanguage) handler.call(this, currentLanguage);
            });
        }
        setLanguage(name) {
            var _b;
            this.currentLanguage = name;
            if ((_b = globalThis.document) === null || _b === void 0 ? void 0 : _b.documentElement) (0, $fbe6f1e2fed97fc7$export$110700823644f4a6)('language', document.documentElement.lang = name, {
                path: '/'
            });
        }
        loadLanguages(...names) {
            return $60ed8c037a48fa8d$var$$d1a4b21e19b1b67c$var$__awaiter(this, void 0, void 0, function*() {
                this.loading = true;
                const { language: language = this.defaultLanguage, languageMap: languageMap = this.configuration[this.defaultLanguage] } = (yield $60ed8c037a48fa8d$export$745e12634107cb52(this.configuration, names)) || {};
                this.loading = false;
                this.setLanguage(language);
                return this.currentMap = languageMap;
            });
        }
        textOf(key, data) {
            const value = this.currentMap[key] || this.defaultMap[key];
            if (typeof value !== 'function') return value;
            if (!data) throw ReferenceError('Input data is required for Translation Resolver');
            return value(data);
        }
    }, _TranslationModel_loading_accessor_storage = new WeakMap(), _TranslationModel_currentLanguage_accessor_storage = new WeakMap(), _TranslationModel_currentMap_accessor_storage = new WeakMap(), (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _loading_decorators = [
            (0, $d5I5D.observable)
        ];
        _currentLanguage_decorators = [
            (0, $d5I5D.observable)
        ];
        _currentMap_decorators = [
            (0, $d5I5D.observable)
        ];
        _get_defaultMap_decorators = [
            (0, $d5I5D.computed)
        ];
        _loadLanguages_decorators = [
            (0, $d5I5D.action)
        ];
        $60ed8c037a48fa8d$var$$d1a4b21e19b1b67c$var$__esDecorate(_a, null, _loading_decorators, {
            kind: "accessor",
            name: "loading",
            static: false,
            private: false,
            access: {
                has: (obj)=>"loading" in obj,
                get: (obj)=>obj.loading,
                set: (obj, value)=>{
                    obj.loading = value;
                }
            },
            metadata: _metadata
        }, _loading_initializers, _loading_extraInitializers);
        $60ed8c037a48fa8d$var$$d1a4b21e19b1b67c$var$__esDecorate(_a, null, _currentLanguage_decorators, {
            kind: "accessor",
            name: "currentLanguage",
            static: false,
            private: false,
            access: {
                has: (obj)=>"currentLanguage" in obj,
                get: (obj)=>obj.currentLanguage,
                set: (obj, value)=>{
                    obj.currentLanguage = value;
                }
            },
            metadata: _metadata
        }, _currentLanguage_initializers, _currentLanguage_extraInitializers);
        $60ed8c037a48fa8d$var$$d1a4b21e19b1b67c$var$__esDecorate(_a, null, _currentMap_decorators, {
            kind: "accessor",
            name: "currentMap",
            static: false,
            private: false,
            access: {
                has: (obj)=>"currentMap" in obj,
                get: (obj)=>obj.currentMap,
                set: (obj, value)=>{
                    obj.currentMap = value;
                }
            },
            metadata: _metadata
        }, _currentMap_initializers, _currentMap_extraInitializers);
        $60ed8c037a48fa8d$var$$d1a4b21e19b1b67c$var$__esDecorate(_a, null, _get_defaultMap_decorators, {
            kind: "getter",
            name: "defaultMap",
            static: false,
            private: false,
            access: {
                has: (obj)=>"defaultMap" in obj,
                get: (obj)=>obj.defaultMap
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $60ed8c037a48fa8d$var$$d1a4b21e19b1b67c$var$__esDecorate(_a, null, _loadLanguages_decorators, {
            kind: "method",
            name: "loadLanguages",
            static: false,
            private: false,
            access: {
                has: (obj)=>"loadLanguages" in obj,
                get: (obj)=>obj.loadLanguages
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
const $60ed8c037a48fa8d$export$745e12634107cb52 = (configuration, names)=>$60ed8c037a48fa8d$var$$d1a4b21e19b1b67c$var$__awaiter(void 0, void 0, void 0, function*() {
        const languages = Object.keys(configuration).sort(({ length: a }, { length: b })=>b - a);
        for (const name of names){
            const language = languages.includes(name) ? name : languages.find((language)=>name.startsWith(language) || language.startsWith(name));
            if (!language) continue;
            try {
                const languageMap = configuration[language];
                if (typeof languageMap !== 'function') return {
                    language: language,
                    languageMap: languageMap
                };
                const { default: data } = yield languageMap();
                configuration[language] = data;
                return {
                    language: language,
                    languageMap: data
                };
            } catch (_a) {}
        }
    });
const $60ed8c037a48fa8d$export$b9f85f5ba933b8e7 = (configuration, { 'accept-language': acceptLanguage, cookie: cookie })=>{
    const { language: language } = (0, $fbe6f1e2fed97fc7$export$d0eaf3e94be578f6)(cookie || ''), languages = $60ed8c037a48fa8d$export$2557e81a557a81ea(acceptLanguage || '');
    return $60ed8c037a48fa8d$export$745e12634107cb52(configuration, [
        language,
        ...languages
    ].filter(Boolean));
};


var $78bd9c04554e723c$export$2e2bcd8739ae039 = {
    welcome: "\u6B22\u8FCE",
    upstream_projects: "\u4E0A\u6E38\u9879\u76EE",
    home_page: "\u4E3B\u9875",
    source_code: "\u6E90\u4EE3\u7801",
    component: "\u7EC4\u4EF6",
    pagination: "\u5206\u9875",
    powered_by: "\u5F3A\u529B\u9A71\u52A8\u81EA",
    documentation: "\u6587\u6863",
    learn: "\u5B66\u4E60",
    examples: "\u793A\u4F8B",
    deploy: "\u90E8\u7F72",
    sign_in: "\u767B\u5165",
    sign_out: "\u767B\u51FA",
    // REST table
    create: "\u65B0\u589E",
    submit: "\u63D0\u4EA4",
    cancel: "\u53D6\u6D88",
    edit: "\u7F16\u8F91",
    delete: "\u5220\u9664",
    total_x_rows: ({ totalCount: totalCount })=>`\u{5171} ${totalCount} \u{884C}`,
    sure_to_delete_x: ({ keys: keys })=>`\u{60A8}\u{786E}\u{5B9A}\u{5220}\u{9664} ${keys.join("\u3001")} \u{5417}\u{FF1F}`,
    repository_name: "\u4ED3\u5E93\u540D",
    programming_language: "\u7F16\u7A0B\u8BED\u8A00",
    topic: "\u8BDD\u9898",
    star_count: "\u661F\u6807\u6570",
    // Scroll List
    scroll_list: "\u6EDA\u52A8\u5217\u8868",
    load_more: "\u52A0\u8F7D\u66F4\u591A\u2026\u2026",
    no_more: "\u6CA1\u6709\u66F4\u591A"
};




const $b7383b0731549701$export$a7357cdd1f0b0168 = new (0, $60ed8c037a48fa8d$export$d91823dfc159395b)({
    'zh-CN': (0, $78bd9c04554e723c$export$2e2bcd8739ae039),
    'zh-TW': ()=>(parcelRequire("6v8yO")),
    'en-US': ()=>(parcelRequire("dXeVr"))
});
const { t: $b7383b0731549701$export$625550452a3fa3ec } = $b7383b0731549701$export$a7357cdd1f0b0168;
const $b7383b0731549701$export$4b3850bcaaad82f1 = {
    'zh-CN': "\u7B80\u4F53\u4E2D\u6587",
    'zh-TW': "\u7E41\u9AD4\u4E2D\u6587",
    'en-US': 'English'
};


var $d6420b577268fef7$exports = {};

$parcel$export($d6420b577268fef7$exports, "promisifyRequest", () => $d6420b577268fef7$export$b327150396135fe7);
$parcel$export($d6420b577268fef7$exports, "createStore", () => $d6420b577268fef7$export$f51a9068ac82ea43);
$parcel$export($d6420b577268fef7$exports, "get", () => $d6420b577268fef7$export$3988ae62b71be9a3);
$parcel$export($d6420b577268fef7$exports, "set", () => $d6420b577268fef7$export$adaa4cf7ef1b65be);
$parcel$export($d6420b577268fef7$exports, "setMany", () => $d6420b577268fef7$export$daa0a5170277c7a8);
$parcel$export($d6420b577268fef7$exports, "getMany", () => $d6420b577268fef7$export$5df405cccea42673);
$parcel$export($d6420b577268fef7$exports, "update", () => $d6420b577268fef7$export$722fbec263ad908a);
$parcel$export($d6420b577268fef7$exports, "del", () => $d6420b577268fef7$export$1d2f21e549771e67);
$parcel$export($d6420b577268fef7$exports, "delMany", () => $d6420b577268fef7$export$c8aa84257229cac8);
$parcel$export($d6420b577268fef7$exports, "clear", () => $d6420b577268fef7$export$42ffd38884aecdac);
$parcel$export($d6420b577268fef7$exports, "keys", () => $d6420b577268fef7$export$ed97f33186d4b816);
$parcel$export($d6420b577268fef7$exports, "values", () => $d6420b577268fef7$export$68c286be0e7e55b7);
$parcel$export($d6420b577268fef7$exports, "entries", () => $d6420b577268fef7$export$3e9f948b41964866);
function $d6420b577268fef7$export$b327150396135fe7(request) {
    return new Promise((resolve, reject)=>{
        // @ts-ignore - file size hacks
        request.oncomplete = request.onsuccess = ()=>resolve(request.result);
        // @ts-ignore - file size hacks
        request.onabort = request.onerror = ()=>reject(request.error);
    });
}
function $d6420b577268fef7$export$f51a9068ac82ea43(dbName, storeName) {
    let dbp;
    const getDB = ()=>{
        if (dbp) return dbp;
        const request = indexedDB.open(dbName);
        request.onupgradeneeded = ()=>request.result.createObjectStore(storeName);
        dbp = $d6420b577268fef7$export$b327150396135fe7(request);
        dbp.then((db)=>{
            // It seems like Safari sometimes likes to just close the connection.
            // It's supposed to fire this event when that happens. Let's hope it does!
            db.onclose = ()=>dbp = undefined;
        }, ()=>{});
        return dbp;
    };
    return (txMode, callback)=>getDB().then((db)=>callback(db.transaction(storeName, txMode).objectStore(storeName)));
}
let $d6420b577268fef7$var$defaultGetStoreFunc;
function $d6420b577268fef7$var$defaultGetStore() {
    if (!$d6420b577268fef7$var$defaultGetStoreFunc) $d6420b577268fef7$var$defaultGetStoreFunc = $d6420b577268fef7$export$f51a9068ac82ea43('keyval-store', 'keyval');
    return $d6420b577268fef7$var$defaultGetStoreFunc;
}
/**
 * Get a value by its key.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $d6420b577268fef7$export$3988ae62b71be9a3(key, customStore = $d6420b577268fef7$var$defaultGetStore()) {
    return customStore('readonly', (store)=>$d6420b577268fef7$export$b327150396135fe7(store.get(key)));
}
/**
 * Set a value with a key.
 *
 * @param key
 * @param value
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $d6420b577268fef7$export$adaa4cf7ef1b65be(key, value, customStore = $d6420b577268fef7$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.put(value, key);
        return $d6420b577268fef7$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Set multiple values at once. This is faster than calling set() multiple times.
 * It's also atomic – if one of the pairs can't be added, none will be added.
 *
 * @param entries Array of entries, where each entry is an array of `[key, value]`.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $d6420b577268fef7$export$daa0a5170277c7a8(entries, customStore = $d6420b577268fef7$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        entries.forEach((entry)=>store.put(entry[1], entry[0]));
        return $d6420b577268fef7$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Get multiple values by their keys
 *
 * @param keys
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $d6420b577268fef7$export$5df405cccea42673(keys, customStore = $d6420b577268fef7$var$defaultGetStore()) {
    return customStore('readonly', (store)=>Promise.all(keys.map((key)=>$d6420b577268fef7$export$b327150396135fe7(store.get(key)))));
}
/**
 * Update a value. This lets you see the old value and update it as an atomic operation.
 *
 * @param key
 * @param updater A callback that takes the old value and returns a new value.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $d6420b577268fef7$export$722fbec263ad908a(key, updater, customStore = $d6420b577268fef7$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>// Need to create the promise manually.
        // If I try to chain promises, the transaction closes in browsers
        // that use a promise polyfill (IE10/11).
        new Promise((resolve, reject)=>{
            store.get(key).onsuccess = function() {
                try {
                    store.put(updater(this.result), key);
                    resolve($d6420b577268fef7$export$b327150396135fe7(store.transaction));
                } catch (err) {
                    reject(err);
                }
            };
        }));
}
/**
 * Delete a particular key from the store.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $d6420b577268fef7$export$1d2f21e549771e67(key, customStore = $d6420b577268fef7$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.delete(key);
        return $d6420b577268fef7$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Delete multiple keys at once.
 *
 * @param keys List of keys to delete.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $d6420b577268fef7$export$c8aa84257229cac8(keys, customStore = $d6420b577268fef7$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        keys.forEach((key)=>store.delete(key));
        return $d6420b577268fef7$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Clear all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $d6420b577268fef7$export$42ffd38884aecdac(customStore = $d6420b577268fef7$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.clear();
        return $d6420b577268fef7$export$b327150396135fe7(store.transaction);
    });
}
function $d6420b577268fef7$var$eachCursor(store, callback) {
    store.openCursor().onsuccess = function() {
        if (!this.result) return;
        callback(this.result);
        this.result.continue();
    };
    return $d6420b577268fef7$export$b327150396135fe7(store.transaction);
}
/**
 * Get all keys in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $d6420b577268fef7$export$ed97f33186d4b816(customStore = $d6420b577268fef7$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        if (store.getAllKeys) return $d6420b577268fef7$export$b327150396135fe7(store.getAllKeys());
        const items = [];
        return $d6420b577268fef7$var$eachCursor(store, (cursor)=>items.push(cursor.key)).then(()=>items);
    });
}
/**
 * Get all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $d6420b577268fef7$export$68c286be0e7e55b7(customStore = $d6420b577268fef7$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        if (store.getAll) return $d6420b577268fef7$export$b327150396135fe7(store.getAll());
        const items = [];
        return $d6420b577268fef7$var$eachCursor(store, (cursor)=>items.push(cursor.value)).then(()=>items);
    });
}
/**
 * Get all entries in the store. Each entry is an array of `[key, value]`.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $d6420b577268fef7$export$3e9f948b41964866(customStore = $d6420b577268fef7$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        // (although, hopefully we'll get a simpler path some day)
        if (store.getAll && store.getAllKeys) return Promise.all([
            $d6420b577268fef7$export$b327150396135fe7(store.getAllKeys()),
            $d6420b577268fef7$export$b327150396135fe7(store.getAll())
        ]).then(([keys, values])=>keys.map((key, i)=>[
                    key,
                    values[i]
                ]));
        const items = [];
        return customStore('readonly', (store)=>$d6420b577268fef7$var$eachCursor(store, (cursor)=>items.push([
                    cursor.key,
                    cursor.value
                ])).then(()=>items));
    });
}



var $d5I5D = parcelRequire("d5I5D");

var $d5I5D = parcelRequire("d5I5D");


function $29590480c608918b$var$$parcel$exportWildcard(dest, source) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function get() {
                return source[key];
            }
        });
    });
    return dest;
}
function $29590480c608918b$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $29590480c608918b$var$$082ef78710a13331$exports = {};
var $29590480c608918b$var$$80184bab4212ab17$exports = {};
var $29590480c608918b$var$$400caf514fe4dd82$exports = {};
$29590480c608918b$var$$parcel$export($29590480c608918b$var$$400caf514fe4dd82$exports, "toggle", function() {
    return $29590480c608918b$export$e03c1c3201ee8bb7;
});
$29590480c608918b$var$$parcel$export($29590480c608918b$var$$400caf514fe4dd82$exports, "toggleNotification", function() {
    return $29590480c608918b$export$6287f85d0f6a9342;
});
$29590480c608918b$var$$parcel$export($29590480c608918b$var$$400caf514fe4dd82$exports, "PersistNode", function() {
    return $29590480c608918b$export$d1e7755b007c0847;
});
$29590480c608918b$var$$parcel$export($29590480c608918b$var$$400caf514fe4dd82$exports, "persist", function() {
    return $29590480c608918b$export$9a6132153fba2e0;
});
$29590480c608918b$var$$parcel$export($29590480c608918b$var$$400caf514fe4dd82$exports, "restore", function() {
    return $29590480c608918b$export$db239ef39aadc7fe;
});
$29590480c608918b$var$$parcel$export($29590480c608918b$var$$400caf514fe4dd82$exports, "destroy", function() {
    return $29590480c608918b$export$b1fb4cac938035f7;
});
$29590480c608918b$var$$parcel$export($29590480c608918b$var$$400caf514fe4dd82$exports, "persistList", function() {
    return $29590480c608918b$export$8001d3a0cfa5d8fd;
});
var $29590480c608918b$var$$400caf514fe4dd82$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $29590480c608918b$var$$400caf514fe4dd82$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $29590480c608918b$var$$400caf514fe4dd82$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $29590480c608918b$var$$400caf514fe4dd82$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $29590480c608918b$var$$400caf514fe4dd82$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $29590480c608918b$var$$400caf514fe4dd82$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $29590480c608918b$export$e03c1c3201ee8bb7(property) {
    return (origin, {})=>function(...data) {
            return $29590480c608918b$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function*() {
                var value = Reflect.get(this, property);
                Reflect.set(this, property, typeof value === 'number' ? ++value : true);
                try {
                    return yield origin.apply(this, data);
                } finally{
                    value = Reflect.get(this, property);
                    Reflect.set(this, property, typeof value === 'number' ? --value : false);
                }
            });
        };
}
function $29590480c608918b$export$6287f85d0f6a9342(message) {
    return (origin, {})=>function(...data) {
            return $29590480c608918b$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function*() {
                const notification = Notification.requestPermission().then((permission)=>{
                    if (permission === 'granted') return new Notification(typeof message === 'function' ? message(this) : message);
                });
                try {
                    return yield origin.apply(this, data);
                } finally{
                    notification.then((notification)=>notification === null || notification === void 0 ? void 0 : notification.close());
                }
            });
        };
}
class $29590480c608918b$export$d1e7755b007c0847 {
    constructor(meta){
        Object.defineProperty(this, "key", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "value", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "set", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "get", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "expireIn", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "disposer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.assign(this, meta);
    }
    static detectIDB() {
        return $29590480c608918b$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function*() {
            if (this.readyIDB) return this.readyIDB;
            const { get: get } = yield $d6420b577268fef7$exports;
            return this.readyIDB = get('ready');
        });
    }
    save(storeKey, value) {
        return $29590480c608918b$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            if (value != null) this.value = (0, $d5I5D.toJS)((_b = yield (_a = this.set) === null || _a === void 0 ? void 0 : _a.call(this, value)) !== null && _b !== void 0 ? _b : value);
            const { set: set } = yield $d6420b577268fef7$exports, data = {
                value: this.value,
                expireAt: this.expireIn + Date.now()
            };
            return set(`${storeKey}-${this.key}`, data);
        });
    }
    load(storeKey) {
        return $29590480c608918b$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c;
            const { get: get, del: del } = yield $d6420b577268fef7$exports;
            storeKey += `-${this.key}`;
            const { value: value, expireAt: expireAt } = (_a = yield get(storeKey)) !== null && _a !== void 0 ? _a : {};
            if (expireAt && expireAt < Date.now()) {
                delete this.value;
                return del(storeKey);
            }
            this.value = value;
            return (_c = value != null ? yield (_b = this.get) === null || _b === void 0 ? void 0 : _b.call(this, value) : value) !== null && _c !== void 0 ? _c : value;
        });
    }
    destroy(storeKey) {
        return $29590480c608918b$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            (_a = this.disposer) === null || _a === void 0 || _a.call(this);
            const { del: del } = yield $d6420b577268fef7$exports;
            return del(`${storeKey}-${this.key}`);
        });
    }
}
const $29590480c608918b$var$$400caf514fe4dd82$var$PersistNodes = new WeakMap();
function $29590480c608918b$export$9a6132153fba2e0(_a = {}) {
    var { expireIn: expireIn = Infinity } = _a, meta = $29590480c608918b$var$$400caf514fe4dd82$var$__rest(_a, [
        "expireIn"
    ]);
    return ({}, { name: name, addInitializer: addInitializer })=>{
        addInitializer(function() {
            const list = $29590480c608918b$var$$400caf514fe4dd82$var$PersistNodes.get(this) || [];
            list.push(new $29590480c608918b$export$d1e7755b007c0847(Object.assign(Object.assign({}, meta), {
                key: name.toString(),
                expireIn: expireIn
            })));
            $29590480c608918b$var$$400caf514fe4dd82$var$PersistNodes.set(this, list);
        });
    };
}
function $29590480c608918b$export$db239ef39aadc7fe(classInstance, storeKey) {
    return $29590480c608918b$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function*() {
        try {
            yield $29590480c608918b$export$d1e7755b007c0847.detectIDB();
        } catch (_a) {
            return console.warn('IndexedDB or its polyfill is not found in this runtime engine, MobX-RESTful persistence is disabled.');
        }
        const list = $29590480c608918b$var$$400caf514fe4dd82$var$PersistNodes.get(classInstance) || [], restoredData = {};
        for (const item of list){
            const { key: key } = item, value = yield item.load(storeKey);
            if (value != null) {
                Reflect.set(classInstance, key, value);
                restoredData[key] = value;
            }
            item.disposer = (0, $d5I5D.reaction)(()=>classInstance[key], (value)=>item.save(storeKey, value));
        }
        if ((0, $fbe6f1e2fed97fc7$export$dd1bc94b04021eeb)(restoredData)) return;
        console.group(`Restored ${storeKey}`);
        console.table(restoredData);
        console.groupEnd();
    });
}
function $29590480c608918b$export$b1fb4cac938035f7(classInstance, storeKey) {
    return $29590480c608918b$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function*() {
        const list = $29590480c608918b$var$$400caf514fe4dd82$var$PersistNodes.get(classInstance) || [];
        for (const node of list)yield node.destroy(storeKey);
    });
}
function $29590480c608918b$export$8001d3a0cfa5d8fd({ storeKey: storeKey, expireIn: expireIn = Infinity } = {}) {
    return (Super, {})=>(()=>{
            var _a, _PersistListModel_pageIndex_accessor_storage, _PersistListModel_pageSize_accessor_storage, _PersistListModel_filter_accessor_storage, _PersistListModel_totalCount_accessor_storage, _PersistListModel_pageList_accessor_storage;
            let _classSuper = Super;
            let _pageIndex_decorators;
            let _pageIndex_initializers = [];
            let _pageIndex_extraInitializers = [];
            let _pageSize_decorators;
            let _pageSize_initializers = [];
            let _pageSize_extraInitializers = [];
            let _filter_decorators;
            let _filter_initializers = [];
            let _filter_extraInitializers = [];
            let _totalCount_decorators;
            let _totalCount_initializers = [];
            let _totalCount_extraInitializers = [];
            let _pageList_decorators;
            let _pageList_initializers = [];
            let _pageList_extraInitializers = [];
            return _a = class PersistListModel extends _classSuper {
                constructor(){
                    super(...arguments);
                    _PersistListModel_pageIndex_accessor_storage.set(this, $29590480c608918b$var$$400caf514fe4dd82$var$__runInitializers(this, _pageIndex_initializers, 0));
                    _PersistListModel_pageSize_accessor_storage.set(this, ($29590480c608918b$var$$400caf514fe4dd82$var$__runInitializers(this, _pageIndex_extraInitializers), $29590480c608918b$var$$400caf514fe4dd82$var$__runInitializers(this, _pageSize_initializers, 10)));
                    _PersistListModel_filter_accessor_storage.set(this, ($29590480c608918b$var$$400caf514fe4dd82$var$__runInitializers(this, _pageSize_extraInitializers), $29590480c608918b$var$$400caf514fe4dd82$var$__runInitializers(this, _filter_initializers, {})));
                    _PersistListModel_totalCount_accessor_storage.set(this, ($29590480c608918b$var$$400caf514fe4dd82$var$__runInitializers(this, _filter_extraInitializers), $29590480c608918b$var$$400caf514fe4dd82$var$__runInitializers(this, _totalCount_initializers, undefined)));
                    _PersistListModel_pageList_accessor_storage.set(this, ($29590480c608918b$var$$400caf514fe4dd82$var$__runInitializers(this, _totalCount_extraInitializers), $29590480c608918b$var$$400caf514fe4dd82$var$__runInitializers(this, _pageList_initializers, [])));
                    Object.defineProperty(this, "restored", {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: ($29590480c608918b$var$$400caf514fe4dd82$var$__runInitializers(this, _pageList_extraInitializers), globalThis.indexedDB && $29590480c608918b$export$db239ef39aadc7fe(this, typeof storeKey === 'function' ? storeKey(this) : storeKey))
                    });
                }
                get pageIndex() {
                    return $29590480c608918b$var$$400caf514fe4dd82$var$__classPrivateFieldGet(this, _PersistListModel_pageIndex_accessor_storage, "f");
                }
                set pageIndex(value) {
                    $29590480c608918b$var$$400caf514fe4dd82$var$__classPrivateFieldSet(this, _PersistListModel_pageIndex_accessor_storage, value, "f");
                }
                get pageSize() {
                    return $29590480c608918b$var$$400caf514fe4dd82$var$__classPrivateFieldGet(this, _PersistListModel_pageSize_accessor_storage, "f");
                }
                set pageSize(value) {
                    $29590480c608918b$var$$400caf514fe4dd82$var$__classPrivateFieldSet(this, _PersistListModel_pageSize_accessor_storage, value, "f");
                }
                get filter() {
                    return $29590480c608918b$var$$400caf514fe4dd82$var$__classPrivateFieldGet(this, _PersistListModel_filter_accessor_storage, "f");
                }
                set filter(value) {
                    $29590480c608918b$var$$400caf514fe4dd82$var$__classPrivateFieldSet(this, _PersistListModel_filter_accessor_storage, value, "f");
                }
                get totalCount() {
                    return $29590480c608918b$var$$400caf514fe4dd82$var$__classPrivateFieldGet(this, _PersistListModel_totalCount_accessor_storage, "f");
                }
                set totalCount(value) {
                    $29590480c608918b$var$$400caf514fe4dd82$var$__classPrivateFieldSet(this, _PersistListModel_totalCount_accessor_storage, value, "f");
                }
                get pageList() {
                    return $29590480c608918b$var$$400caf514fe4dd82$var$__classPrivateFieldGet(this, _PersistListModel_pageList_accessor_storage, "f");
                }
                set pageList(value) {
                    $29590480c608918b$var$$400caf514fe4dd82$var$__classPrivateFieldSet(this, _PersistListModel_pageList_accessor_storage, value, "f");
                }
            }, _PersistListModel_pageIndex_accessor_storage = new WeakMap(), _PersistListModel_pageSize_accessor_storage = new WeakMap(), _PersistListModel_filter_accessor_storage = new WeakMap(), _PersistListModel_totalCount_accessor_storage = new WeakMap(), _PersistListModel_pageList_accessor_storage = new WeakMap(), (()=>{
                var _b;
                const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
                _pageIndex_decorators = [
                    $29590480c608918b$export$9a6132153fba2e0({
                        expireIn: expireIn
                    }),
                    (0, $d5I5D.observable)
                ];
                _pageSize_decorators = [
                    $29590480c608918b$export$9a6132153fba2e0({
                        expireIn: expireIn
                    }),
                    (0, $d5I5D.observable)
                ];
                _filter_decorators = [
                    $29590480c608918b$export$9a6132153fba2e0({
                        expireIn: expireIn
                    }),
                    (0, $d5I5D.observable)
                ];
                _totalCount_decorators = [
                    $29590480c608918b$export$9a6132153fba2e0({
                        expireIn: expireIn
                    }),
                    (0, $d5I5D.observable)
                ];
                _pageList_decorators = [
                    $29590480c608918b$export$9a6132153fba2e0({
                        expireIn: expireIn
                    }),
                    (0, $d5I5D.observable)
                ];
                $29590480c608918b$var$$400caf514fe4dd82$var$__esDecorate(_a, null, _pageIndex_decorators, {
                    kind: "accessor",
                    name: "pageIndex",
                    static: false,
                    private: false,
                    access: {
                        has: (obj)=>"pageIndex" in obj,
                        get: (obj)=>obj.pageIndex,
                        set: (obj, value)=>{
                            obj.pageIndex = value;
                        }
                    },
                    metadata: _metadata
                }, _pageIndex_initializers, _pageIndex_extraInitializers);
                $29590480c608918b$var$$400caf514fe4dd82$var$__esDecorate(_a, null, _pageSize_decorators, {
                    kind: "accessor",
                    name: "pageSize",
                    static: false,
                    private: false,
                    access: {
                        has: (obj)=>"pageSize" in obj,
                        get: (obj)=>obj.pageSize,
                        set: (obj, value)=>{
                            obj.pageSize = value;
                        }
                    },
                    metadata: _metadata
                }, _pageSize_initializers, _pageSize_extraInitializers);
                $29590480c608918b$var$$400caf514fe4dd82$var$__esDecorate(_a, null, _filter_decorators, {
                    kind: "accessor",
                    name: "filter",
                    static: false,
                    private: false,
                    access: {
                        has: (obj)=>"filter" in obj,
                        get: (obj)=>obj.filter,
                        set: (obj, value)=>{
                            obj.filter = value;
                        }
                    },
                    metadata: _metadata
                }, _filter_initializers, _filter_extraInitializers);
                $29590480c608918b$var$$400caf514fe4dd82$var$__esDecorate(_a, null, _totalCount_decorators, {
                    kind: "accessor",
                    name: "totalCount",
                    static: false,
                    private: false,
                    access: {
                        has: (obj)=>"totalCount" in obj,
                        get: (obj)=>obj.totalCount,
                        set: (obj, value)=>{
                            obj.totalCount = value;
                        }
                    },
                    metadata: _metadata
                }, _totalCount_initializers, _totalCount_extraInitializers);
                $29590480c608918b$var$$400caf514fe4dd82$var$__esDecorate(_a, null, _pageList_decorators, {
                    kind: "accessor",
                    name: "pageList",
                    static: false,
                    private: false,
                    access: {
                        has: (obj)=>"pageList" in obj,
                        get: (obj)=>obj.pageList,
                        set: (obj, value)=>{
                            obj.pageList = value;
                        }
                    },
                    metadata: _metadata
                }, _pageList_initializers, _pageList_extraInitializers);
                if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: _metadata
                });
            })(), _a;
        })();
}
$29590480c608918b$var$$parcel$exportWildcard($29590480c608918b$var$$082ef78710a13331$exports, $29590480c608918b$var$$80184bab4212ab17$exports);
$29590480c608918b$var$$parcel$exportWildcard($29590480c608918b$var$$082ef78710a13331$exports, $29590480c608918b$var$$400caf514fe4dd82$exports);
var $29590480c608918b$var$$16892940cfb7bd51$exports = {};
$29590480c608918b$var$$parcel$export($29590480c608918b$var$$16892940cfb7bd51$exports, "BaseModel", function() {
    return $29590480c608918b$export$d12e20a4eec10acf;
});
$29590480c608918b$var$$parcel$export($29590480c608918b$var$$16892940cfb7bd51$exports, "BaseListModel", function() {
    return $29590480c608918b$export$673dbc4a8d0cb20a;
});
var $29590480c608918b$var$$16892940cfb7bd51$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $29590480c608918b$var$$16892940cfb7bd51$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $29590480c608918b$var$$16892940cfb7bd51$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $29590480c608918b$var$$16892940cfb7bd51$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $29590480c608918b$var$$16892940cfb7bd51$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $29590480c608918b$export$d12e20a4eec10acf = (()=>{
    var _a, _BaseModel_downloading_accessor_storage, _BaseModel_uploading_accessor_storage;
    let _instanceExtraInitializers = [];
    let _downloading_decorators;
    let _downloading_initializers = [];
    let _downloading_extraInitializers = [];
    let _uploading_decorators;
    let _uploading_initializers = [];
    let _uploading_extraInitializers = [];
    let _clear_decorators;
    return _a = class BaseModel {
        get downloading() {
            return $29590480c608918b$var$$16892940cfb7bd51$var$__classPrivateFieldGet(this, _BaseModel_downloading_accessor_storage, "f");
        }
        set downloading(value) {
            $29590480c608918b$var$$16892940cfb7bd51$var$__classPrivateFieldSet(this, _BaseModel_downloading_accessor_storage, value, "f");
        }
        get uploading() {
            return $29590480c608918b$var$$16892940cfb7bd51$var$__classPrivateFieldGet(this, _BaseModel_uploading_accessor_storage, "f");
        }
        set uploading(value) {
            $29590480c608918b$var$$16892940cfb7bd51$var$__classPrivateFieldSet(this, _BaseModel_uploading_accessor_storage, value, "f");
        }
        clear() {
            this.downloading = this.uploading = 0;
        }
        constructor(){
            _BaseModel_downloading_accessor_storage.set(this, ($29590480c608918b$var$$16892940cfb7bd51$var$__runInitializers(this, _instanceExtraInitializers), $29590480c608918b$var$$16892940cfb7bd51$var$__runInitializers(this, _downloading_initializers, 0)));
            _BaseModel_uploading_accessor_storage.set(this, ($29590480c608918b$var$$16892940cfb7bd51$var$__runInitializers(this, _downloading_extraInitializers), $29590480c608918b$var$$16892940cfb7bd51$var$__runInitializers(this, _uploading_initializers, 0)));
            $29590480c608918b$var$$16892940cfb7bd51$var$__runInitializers(this, _uploading_extraInitializers);
        }
    }, _BaseModel_downloading_accessor_storage = new WeakMap(), _BaseModel_uploading_accessor_storage = new WeakMap(), (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _downloading_decorators = [
            (0, $d5I5D.observable)
        ];
        _uploading_decorators = [
            (0, $d5I5D.observable)
        ];
        _clear_decorators = [
            (0, $d5I5D.action)
        ];
        $29590480c608918b$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _downloading_decorators, {
            kind: "accessor",
            name: "downloading",
            static: false,
            private: false,
            access: {
                has: (obj)=>"downloading" in obj,
                get: (obj)=>obj.downloading,
                set: (obj, value)=>{
                    obj.downloading = value;
                }
            },
            metadata: _metadata
        }, _downloading_initializers, _downloading_extraInitializers);
        $29590480c608918b$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _uploading_decorators, {
            kind: "accessor",
            name: "uploading",
            static: false,
            private: false,
            access: {
                has: (obj)=>"uploading" in obj,
                get: (obj)=>obj.uploading,
                set: (obj, value)=>{
                    obj.uploading = value;
                }
            },
            metadata: _metadata
        }, _uploading_initializers, _uploading_extraInitializers);
        $29590480c608918b$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _clear_decorators, {
            kind: "method",
            name: "clear",
            static: false,
            private: false,
            access: {
                has: (obj)=>"clear" in obj,
                get: (obj)=>obj.clear
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
/**
 * This basic class is a middle class, which isn't for direct using
 */ let $29590480c608918b$export$673dbc4a8d0cb20a = (()=>{
    var _a, _BaseListModel_currentOne_accessor_storage;
    let _classSuper = $29590480c608918b$export$d12e20a4eec10acf;
    let _instanceExtraInitializers = [];
    let _currentOne_decorators;
    let _currentOne_initializers = [];
    let _currentOne_extraInitializers = [];
    let _clearCurrent_decorators;
    let _updateOne_decorators;
    let _getOne_decorators;
    let _deleteOne_decorators;
    return _a = class BaseListModel extends _classSuper {
        get currentOne() {
            return $29590480c608918b$var$$16892940cfb7bd51$var$__classPrivateFieldGet(this, _BaseListModel_currentOne_accessor_storage, "f");
        }
        set currentOne(value) {
            $29590480c608918b$var$$16892940cfb7bd51$var$__classPrivateFieldSet(this, _BaseListModel_currentOne_accessor_storage, value, "f");
        }
        // @observable
        // validity: InvalidMessage<D> = {};
        static createNested(parentId) {
            const Model = this;
            const store = new Model();
            store.baseURI = store.baseURI.replace(/:\w+/, parentId + '');
            return store;
        }
        clearCurrent() {
            this.currentOne = {};
        // this.validity = {};
        }
        clear() {
            super.clear();
            this.clearCurrent();
        }
        updateOne(data, id) {
            return $29590480c608918b$var$$16892940cfb7bd51$var$__awaiter(this, void 0, void 0, function*() {
                const { body: body } = yield id ? this.client.patch(`${this.baseURI}/${id}`, data) : this.client.post(this.baseURI, data);
                return this.currentOne = body;
            });
        }
        getOne(id) {
            return $29590480c608918b$var$$16892940cfb7bd51$var$__awaiter(this, void 0, void 0, function*() {
                const { body: body } = yield this.client.get(`${this.baseURI}/${id}`);
                return this.currentOne = body;
            });
        }
        deleteOne(id) {
            return $29590480c608918b$var$$16892940cfb7bd51$var$__awaiter(this, void 0, void 0, function*() {
                yield this.client.delete(`${this.baseURI}/${id}`);
                if (this.currentOne[this.indexKey] === id) this.clearCurrent();
            });
        }
        constructor(){
            super(...arguments);
            Object.defineProperty(this, "indexKey", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($29590480c608918b$var$$16892940cfb7bd51$var$__runInitializers(this, _instanceExtraInitializers), 'id')
            });
            _BaseListModel_currentOne_accessor_storage.set(this, $29590480c608918b$var$$16892940cfb7bd51$var$__runInitializers(this, _currentOne_initializers, {}));
            $29590480c608918b$var$$16892940cfb7bd51$var$__runInitializers(this, _currentOne_extraInitializers);
        }
    }, _BaseListModel_currentOne_accessor_storage = new WeakMap(), (()=>{
        var _b;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
        _currentOne_decorators = [
            (0, $d5I5D.observable)
        ];
        _clearCurrent_decorators = [
            (0, $d5I5D.action)
        ];
        _updateOne_decorators = [
            $29590480c608918b$export$e03c1c3201ee8bb7('uploading')
        ];
        _getOne_decorators = [
            $29590480c608918b$export$e03c1c3201ee8bb7('downloading')
        ];
        _deleteOne_decorators = [
            $29590480c608918b$export$e03c1c3201ee8bb7('uploading')
        ];
        $29590480c608918b$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _currentOne_decorators, {
            kind: "accessor",
            name: "currentOne",
            static: false,
            private: false,
            access: {
                has: (obj)=>"currentOne" in obj,
                get: (obj)=>obj.currentOne,
                set: (obj, value)=>{
                    obj.currentOne = value;
                }
            },
            metadata: _metadata
        }, _currentOne_initializers, _currentOne_extraInitializers);
        $29590480c608918b$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _clearCurrent_decorators, {
            kind: "method",
            name: "clearCurrent",
            static: false,
            private: false,
            access: {
                has: (obj)=>"clearCurrent" in obj,
                get: (obj)=>obj.clearCurrent
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $29590480c608918b$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _updateOne_decorators, {
            kind: "method",
            name: "updateOne",
            static: false,
            private: false,
            access: {
                has: (obj)=>"updateOne" in obj,
                get: (obj)=>obj.updateOne
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $29590480c608918b$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _getOne_decorators, {
            kind: "method",
            name: "getOne",
            static: false,
            private: false,
            access: {
                has: (obj)=>"getOne" in obj,
                get: (obj)=>obj.getOne
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $29590480c608918b$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _deleteOne_decorators, {
            kind: "method",
            name: "deleteOne",
            static: false,
            private: false,
            access: {
                has: (obj)=>"deleteOne" in obj,
                get: (obj)=>obj.deleteOne
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
var $29590480c608918b$var$$5766c49bacaeb5b8$exports = {};
$29590480c608918b$var$$parcel$export($29590480c608918b$var$$5766c49bacaeb5b8$exports, "ListModel", function() {
    return $29590480c608918b$export$36e5777a1ba4b7c3;
});
$29590480c608918b$var$$parcel$export($29590480c608918b$var$$5766c49bacaeb5b8$exports, "Buffer", function() {
    return $29590480c608918b$export$a143d493d941bafc;
});
$29590480c608918b$var$$parcel$export($29590480c608918b$var$$5766c49bacaeb5b8$exports, "Stream", function() {
    return $29590480c608918b$export$6a4eb2e7fc9e8903;
});
var $29590480c608918b$var$$5766c49bacaeb5b8$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $29590480c608918b$var$$5766c49bacaeb5b8$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $29590480c608918b$var$$5766c49bacaeb5b8$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $29590480c608918b$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $29590480c608918b$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $29590480c608918b$var$$5766c49bacaeb5b8$var$__await = function(v) {
    return this instanceof $29590480c608918b$var$$5766c49bacaeb5b8$var$__await ? (this.v = v, this) : new $29590480c608918b$var$$5766c49bacaeb5b8$var$__await(v);
};
var $29590480c608918b$var$$5766c49bacaeb5b8$var$__asyncValues = function(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
var $29590480c608918b$var$$5766c49bacaeb5b8$var$__asyncDelegator = function(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $29590480c608918b$var$$5766c49bacaeb5b8$var$__await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
};
var $29590480c608918b$var$$5766c49bacaeb5b8$var$__asyncGenerator = function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $29590480c608918b$var$$5766c49bacaeb5b8$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
let $29590480c608918b$export$36e5777a1ba4b7c3 = (()=>{
    var _a, _ListModel_pageIndex_accessor_storage, _ListModel_pageSize_accessor_storage, _ListModel_filter_accessor_storage, _ListModel_totalCount_accessor_storage, _ListModel_pageList_accessor_storage, _ListModel_statistic_accessor_storage, _b;
    let _classSuper = $29590480c608918b$export$673dbc4a8d0cb20a;
    let _instanceExtraInitializers = [];
    let _pageIndex_decorators;
    let _pageIndex_initializers = [];
    let _pageIndex_extraInitializers = [];
    let _pageSize_decorators;
    let _pageSize_initializers = [];
    let _pageSize_extraInitializers = [];
    let _filter_decorators;
    let _filter_initializers = [];
    let _filter_extraInitializers = [];
    let _totalCount_decorators;
    let _totalCount_initializers = [];
    let _totalCount_extraInitializers = [];
    let _pageList_decorators;
    let _pageList_initializers = [];
    let _pageList_extraInitializers = [];
    let _get_currentPage_decorators;
    let _get_pageCount_decorators;
    let _get_allItems_decorators;
    let _get_noMore_decorators;
    let _statistic_decorators;
    let _statistic_initializers = [];
    let _statistic_extraInitializers = [];
    let _clearList_decorators;
    let _restoreList_decorators;
    let _turnTo_decorators;
    let _getList_decorators;
    let _deleteOne_decorators;
    return _a = class ListModel extends _classSuper {
        constructor(){
            super(...arguments);
            _ListModel_pageIndex_accessor_storage.set(this, ($29590480c608918b$var$$5766c49bacaeb5b8$var$__runInitializers(this, _instanceExtraInitializers), $29590480c608918b$var$$5766c49bacaeb5b8$var$__runInitializers(this, _pageIndex_initializers, 0)));
            _ListModel_pageSize_accessor_storage.set(this, ($29590480c608918b$var$$5766c49bacaeb5b8$var$__runInitializers(this, _pageIndex_extraInitializers), $29590480c608918b$var$$5766c49bacaeb5b8$var$__runInitializers(this, _pageSize_initializers, 10)));
            _ListModel_filter_accessor_storage.set(this, ($29590480c608918b$var$$5766c49bacaeb5b8$var$__runInitializers(this, _pageSize_extraInitializers), $29590480c608918b$var$$5766c49bacaeb5b8$var$__runInitializers(this, _filter_initializers, {})));
            _ListModel_totalCount_accessor_storage.set(this, ($29590480c608918b$var$$5766c49bacaeb5b8$var$__runInitializers(this, _filter_extraInitializers), $29590480c608918b$var$$5766c49bacaeb5b8$var$__runInitializers(this, _totalCount_initializers, void 0)));
            _ListModel_pageList_accessor_storage.set(this, ($29590480c608918b$var$$5766c49bacaeb5b8$var$__runInitializers(this, _totalCount_extraInitializers), $29590480c608918b$var$$5766c49bacaeb5b8$var$__runInitializers(this, _pageList_initializers, [])));
            _ListModel_statistic_accessor_storage.set(this, ($29590480c608918b$var$$5766c49bacaeb5b8$var$__runInitializers(this, _pageList_extraInitializers), $29590480c608918b$var$$5766c49bacaeb5b8$var$__runInitializers(this, _statistic_initializers, {})));
            Object.defineProperty(this, _b, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($29590480c608918b$var$$5766c49bacaeb5b8$var$__runInitializers(this, _statistic_extraInitializers), this.getAllInStream)
            });
        }
        get pageIndex() {
            return $29590480c608918b$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_pageIndex_accessor_storage, "f");
        }
        set pageIndex(value) {
            $29590480c608918b$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_pageIndex_accessor_storage, value, "f");
        }
        get pageSize() {
            return $29590480c608918b$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_pageSize_accessor_storage, "f");
        }
        set pageSize(value) {
            $29590480c608918b$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_pageSize_accessor_storage, value, "f");
        }
        get filter() {
            return $29590480c608918b$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_filter_accessor_storage, "f");
        }
        set filter(value) {
            $29590480c608918b$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_filter_accessor_storage, value, "f");
        }
        get totalCount() {
            return $29590480c608918b$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_totalCount_accessor_storage, "f");
        }
        set totalCount(value) {
            $29590480c608918b$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_totalCount_accessor_storage, value, "f");
        }
        get pageList() {
            return $29590480c608918b$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_pageList_accessor_storage, "f");
        }
        set pageList(value) {
            $29590480c608918b$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_pageList_accessor_storage, value, "f");
        }
        get currentPage() {
            return this.pageList[this.pageIndex - 1] || [];
        }
        get pageCount() {
            return Math.ceil(this.totalCount / this.pageSize) || this.pageList.length;
        }
        get allItems() {
            const pageList = (0, $d5I5D.toJS)(this.pageList), { pageSize: pageSize, totalCount: totalCount } = this;
            const index = [
                ...pageList
            ].reverse().findIndex((item)=>(item === null || item === void 0 ? void 0 : item[0]) != null);
            return Array.from(pageList.slice(0, -index || Infinity), (page)=>(page === null || page === void 0 ? void 0 : page[0]) ? page : new Array(pageSize).fill({})).flat().slice(0, totalCount || 0);
        }
        get noMore() {
            return this.pageIndex * this.pageSize >= this.totalCount;
        }
        get statistic() {
            return $29590480c608918b$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_statistic_accessor_storage, "f");
        }
        set statistic(value) {
            $29590480c608918b$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_statistic_accessor_storage, value, "f");
        }
        clearList() {
            this.pageIndex = 0;
            this.pageSize = 10;
            this.filter = {};
            this.pageList = [];
            this.totalCount = undefined;
        }
        clear() {
            super.clear();
            this.clearList();
        }
        restoreList({ pageIndex: pageIndex = this.pageIndex + 1, pageSize: pageSize = this.pageSize, allItems: allItems = this.allItems, totalCount: totalCount = Infinity } = {}) {
            if (!allItems.length) return;
            this.pageList = (0, $fbe6f1e2fed97fc7$export$697c3df919c0e61a)(allItems, pageSize);
            this.pageIndex = pageIndex;
            this.pageSize = pageSize;
            this.totalCount = totalCount;
        }
        turnTo(pageIndex, pageSize = this.pageSize) {
            this.pageIndex = pageIndex;
            if (this.pageSize !== pageSize) this.pageList = (0, $fbe6f1e2fed97fc7$export$697c3df919c0e61a)(this.allItems, this.pageSize = pageSize);
            return this;
        }
        /**
             * @protected
             */ loadNewPage(pageIndex, pageSize, filter) {
            return $29590480c608918b$var$$5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function*() {
                const { pageData: pageData, totalCount: totalCount } = yield this.loadPage(pageIndex, pageSize, filter);
                this.pageSize = pageSize;
                const list = [
                    ...this.pageList
                ];
                list[pageIndex - 1] = pageData;
                this.pageList = list;
                this.totalCount = totalCount != null ? isNaN(totalCount) || totalCount < 0 ? Infinity : totalCount : Infinity;
                return {
                    pageData: pageData,
                    totalCount: totalCount
                };
            });
        }
        // @action  // disabled for @override bug of MobX 6
        getList() {
            return $29590480c608918b$var$$5766c49bacaeb5b8$var$__awaiter(this, arguments, void 0, function*(filter = this.filter, pageIndex = this.pageIndex + 1, pageSize = this.pageSize) {
                const { pageData: pageData } = yield this.loadNewPage(pageIndex, pageSize, filter);
                this.filter = filter;
                this.turnTo(pageIndex, pageSize);
                return pageData;
            });
        }
        refreshList() {
            const { filter: filter, pageSize: pageSize } = this;
            this.clearList();
            return this.getList(filter, 1, pageSize);
        }
        getAllInStream() {
            return $29590480c608918b$var$$5766c49bacaeb5b8$var$__asyncGenerator(this, arguments, function* getAllInStream_1(filter = this.filter, pageSize = this.pageSize) {
                this.pageIndex = 0;
                while(!this.noMore)yield $29590480c608918b$var$$5766c49bacaeb5b8$var$__await((yield* $29590480c608918b$var$$5766c49bacaeb5b8$var$__asyncDelegator($29590480c608918b$var$$5766c49bacaeb5b8$var$__asyncValues((yield $29590480c608918b$var$$5766c49bacaeb5b8$var$__await(this.getList(filter, undefined, pageSize)))))));
            });
        }
        getAll(filter = this.filter, pageSize = this.pageSize) {
            return Array.fromAsync(this.getAllInStream(filter, pageSize));
        }
        countAll(keys_1) {
            return $29590480c608918b$var$$5766c49bacaeb5b8$var$__awaiter(this, arguments, void 0, function*(keys, filter = this.filter, pageSize = this.pageSize) {
                const allItems = yield this.getAll(filter, pageSize);
                const statistic = Object.fromEntries(keys.map((key)=>[
                        key,
                        (0, $fbe6f1e2fed97fc7$export$1d012a0dff3dab06)(allItems, key)
                    ]));
                return this.statistic = statistic;
            });
        }
        indexOf(id) {
            const { indexKey: indexKey, allItems: allItems } = this;
            return allItems.findIndex(({ [indexKey]: ID })=>ID === id);
        }
        changeOne(data, id, patch = false) {
            const { pageIndex: pageIndex, allItems: allItems, totalCount: totalCount } = this, index = this.indexOf(id);
            if (index > -1) this.restoreList({
                pageIndex: pageIndex,
                allItems: [
                    ...allItems.slice(0, index),
                    patch ? Object.assign(Object.assign({}, allItems[index]), data) : data,
                    ...allItems.slice(index + 1)
                ],
                totalCount: totalCount
            });
        }
        updateOne(data, id) {
            const _super = Object.create(null, {
                updateOne: {
                    get: ()=>super.updateOne
                }
            });
            return $29590480c608918b$var$$5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function*() {
                yield _super.updateOne.call(this, data, id);
                if (id) this.changeOne(this.currentOne, id);
                return this.currentOne;
            });
        }
        removeOne(id) {
            return $29590480c608918b$var$$5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function*() {
                const { filter: filter, pageIndex: pageIndex, allItems: allItems } = this, index = this.indexOf(id);
                const { pageData: pageData } = yield this.loadPage(allItems.length + 1, 1, filter);
                return this.restoreList({
                    pageIndex: pageIndex,
                    allItems: [
                        ...allItems.slice(0, index),
                        ...allItems.slice(index + 1),
                        ...pageData
                    ],
                    totalCount: this.totalCount--
                });
            });
        }
        deleteOne(id) {
            const _super = Object.create(null, {
                deleteOne: {
                    get: ()=>super.deleteOne
                }
            });
            return $29590480c608918b$var$$5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function*() {
                yield _super.deleteOne.call(this, id);
                yield this.removeOne(id);
            });
        }
    }, _ListModel_pageIndex_accessor_storage = new WeakMap(), _ListModel_pageSize_accessor_storage = new WeakMap(), _ListModel_filter_accessor_storage = new WeakMap(), _ListModel_totalCount_accessor_storage = new WeakMap(), _ListModel_pageList_accessor_storage = new WeakMap(), _ListModel_statistic_accessor_storage = new WeakMap(), _b = (_pageIndex_decorators = [
        (0, $d5I5D.observable)
    ], _pageSize_decorators = [
        (0, $d5I5D.observable)
    ], _filter_decorators = [
        (0, $d5I5D.observable)
    ], _totalCount_decorators = [
        (0, $d5I5D.observable)
    ], _pageList_decorators = [
        (0, $d5I5D.observable)
    ], _get_currentPage_decorators = [
        (0, $d5I5D.computed)
    ], _get_pageCount_decorators = [
        (0, $d5I5D.computed)
    ], _get_allItems_decorators = [
        (0, $d5I5D.computed)
    ], _get_noMore_decorators = [
        (0, $d5I5D.computed)
    ], _statistic_decorators = [
        (0, $d5I5D.observable)
    ], _clearList_decorators = [
        (0, $d5I5D.action)
    ], _restoreList_decorators = [
        (0, $d5I5D.action)
    ], _turnTo_decorators = [
        (0, $d5I5D.action)
    ], _getList_decorators = [
        $29590480c608918b$export$e03c1c3201ee8bb7('downloading')
    ], Symbol.asyncIterator), (()=>{
        var _c;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_c = _classSuper[Symbol.metadata]) !== null && _c !== void 0 ? _c : null) : void 0;
        _deleteOne_decorators = [
            $29590480c608918b$export$e03c1c3201ee8bb7('uploading')
        ];
        $29590480c608918b$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _pageIndex_decorators, {
            kind: "accessor",
            name: "pageIndex",
            static: false,
            private: false,
            access: {
                has: (obj)=>"pageIndex" in obj,
                get: (obj)=>obj.pageIndex,
                set: (obj, value)=>{
                    obj.pageIndex = value;
                }
            },
            metadata: _metadata
        }, _pageIndex_initializers, _pageIndex_extraInitializers);
        $29590480c608918b$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _pageSize_decorators, {
            kind: "accessor",
            name: "pageSize",
            static: false,
            private: false,
            access: {
                has: (obj)=>"pageSize" in obj,
                get: (obj)=>obj.pageSize,
                set: (obj, value)=>{
                    obj.pageSize = value;
                }
            },
            metadata: _metadata
        }, _pageSize_initializers, _pageSize_extraInitializers);
        $29590480c608918b$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _filter_decorators, {
            kind: "accessor",
            name: "filter",
            static: false,
            private: false,
            access: {
                has: (obj)=>"filter" in obj,
                get: (obj)=>obj.filter,
                set: (obj, value)=>{
                    obj.filter = value;
                }
            },
            metadata: _metadata
        }, _filter_initializers, _filter_extraInitializers);
        $29590480c608918b$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _totalCount_decorators, {
            kind: "accessor",
            name: "totalCount",
            static: false,
            private: false,
            access: {
                has: (obj)=>"totalCount" in obj,
                get: (obj)=>obj.totalCount,
                set: (obj, value)=>{
                    obj.totalCount = value;
                }
            },
            metadata: _metadata
        }, _totalCount_initializers, _totalCount_extraInitializers);
        $29590480c608918b$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _pageList_decorators, {
            kind: "accessor",
            name: "pageList",
            static: false,
            private: false,
            access: {
                has: (obj)=>"pageList" in obj,
                get: (obj)=>obj.pageList,
                set: (obj, value)=>{
                    obj.pageList = value;
                }
            },
            metadata: _metadata
        }, _pageList_initializers, _pageList_extraInitializers);
        $29590480c608918b$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _get_currentPage_decorators, {
            kind: "getter",
            name: "currentPage",
            static: false,
            private: false,
            access: {
                has: (obj)=>"currentPage" in obj,
                get: (obj)=>obj.currentPage
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $29590480c608918b$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _get_pageCount_decorators, {
            kind: "getter",
            name: "pageCount",
            static: false,
            private: false,
            access: {
                has: (obj)=>"pageCount" in obj,
                get: (obj)=>obj.pageCount
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $29590480c608918b$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _get_allItems_decorators, {
            kind: "getter",
            name: "allItems",
            static: false,
            private: false,
            access: {
                has: (obj)=>"allItems" in obj,
                get: (obj)=>obj.allItems
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $29590480c608918b$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _get_noMore_decorators, {
            kind: "getter",
            name: "noMore",
            static: false,
            private: false,
            access: {
                has: (obj)=>"noMore" in obj,
                get: (obj)=>obj.noMore
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $29590480c608918b$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _statistic_decorators, {
            kind: "accessor",
            name: "statistic",
            static: false,
            private: false,
            access: {
                has: (obj)=>"statistic" in obj,
                get: (obj)=>obj.statistic,
                set: (obj, value)=>{
                    obj.statistic = value;
                }
            },
            metadata: _metadata
        }, _statistic_initializers, _statistic_extraInitializers);
        $29590480c608918b$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _clearList_decorators, {
            kind: "method",
            name: "clearList",
            static: false,
            private: false,
            access: {
                has: (obj)=>"clearList" in obj,
                get: (obj)=>obj.clearList
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $29590480c608918b$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _restoreList_decorators, {
            kind: "method",
            name: "restoreList",
            static: false,
            private: false,
            access: {
                has: (obj)=>"restoreList" in obj,
                get: (obj)=>obj.restoreList
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $29590480c608918b$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _turnTo_decorators, {
            kind: "method",
            name: "turnTo",
            static: false,
            private: false,
            access: {
                has: (obj)=>"turnTo" in obj,
                get: (obj)=>obj.turnTo
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $29590480c608918b$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _getList_decorators, {
            kind: "method",
            name: "getList",
            static: false,
            private: false,
            access: {
                has: (obj)=>"getList" in obj,
                get: (obj)=>obj.getList
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $29590480c608918b$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _deleteOne_decorators, {
            kind: "method",
            name: "deleteOne",
            static: false,
            private: false,
            access: {
                has: (obj)=>"deleteOne" in obj,
                get: (obj)=>obj.deleteOne
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
function $29590480c608918b$export$a143d493d941bafc(Super) {
    let BufferListMixin = (()=>{
        var _a;
        let _classSuper = Super;
        let _instanceExtraInitializers = [];
        let _getList_decorators;
        return _a = class BufferListMixin extends _classSuper {
            constructor(){
                super(...arguments);
                Object.defineProperty(this, "pendingList", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: ($29590480c608918b$var$$5766c49bacaeb5b8$var$__runInitializers(this, _instanceExtraInitializers), [])
                });
            }
            clearList() {
                super.clearList();
                this.pendingList = [];
            }
            clear() {
                super.clear();
                this.clearList();
            }
            getList() {
                const _super = Object.create(null, {
                    getList: {
                        get: ()=>super.getList
                    }
                });
                return $29590480c608918b$var$$5766c49bacaeb5b8$var$__awaiter(this, arguments, void 0, function*(filter = this.filter, pageIndex = this.pageIndex + 1, pageSize = this.pageSize) {
                    const currentIndex = pageIndex - 1;
                    if (this.pendingList[currentIndex]) {
                        const { pageData: pageData } = yield this.pendingList[currentIndex];
                        this.turnTo(pageIndex, pageSize);
                        return pageData;
                    }
                    if (this.pageList[currentIndex]) this.turnTo(pageIndex, pageSize);
                    else var list = yield _super.getList.call(this, filter, pageIndex, pageSize);
                    const nextIndex = pageIndex + 1;
                    this.pendingList[nextIndex] = this.loadNewPage(nextIndex, pageSize, filter).then((data)=>{
                        this.pendingList[nextIndex] = undefined;
                        return data;
                    });
                    return list;
                });
            }
        }, (()=>{
            var _b;
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
            _getList_decorators = [
                (0, $d5I5D.action),
                $29590480c608918b$export$e03c1c3201ee8bb7('downloading')
            ];
            $29590480c608918b$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _getList_decorators, {
                kind: "method",
                name: "getList",
                static: false,
                private: false,
                access: {
                    has: (obj)=>"getList" in obj,
                    get: (obj)=>obj.getList
                },
                metadata: _metadata
            }, null, _instanceExtraInitializers);
            if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: _metadata
            });
        })(), _a;
    })();
    return BufferListMixin;
}
function $29590480c608918b$export$6a4eb2e7fc9e8903(Super) {
    let StreamListMixin = (()=>{
        var _a;
        let _classSuper = Super;
        let _instanceExtraInitializers = [];
        let _restoreList_decorators;
        return _a = class StreamListMixin extends _classSuper {
            constructor(){
                super(...arguments);
                Object.defineProperty(this, "stream", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: $29590480c608918b$var$$5766c49bacaeb5b8$var$__runInitializers(this, _instanceExtraInitializers)
                });
            }
            clearList() {
                super.clearList();
                this.stream = undefined;
            }
            clear() {
                super.clear();
                this.clearList();
            }
            restoreList() {
                const _super = Object.create(null, {
                    restoreList: {
                        get: ()=>super.restoreList
                    }
                });
                return $29590480c608918b$var$$5766c49bacaeb5b8$var$__awaiter(this, arguments, void 0, function*({ filter: filter = this.filter, pageIndex: pageIndex = this.pageIndex + 1, pageSize: pageSize = this.pageSize, allItems: allItems = this.allItems, totalCount: totalCount = Infinity } = {}) {
                    _super.restoreList.call(this, {
                        pageIndex: pageIndex,
                        pageSize: pageSize,
                        allItems: allItems,
                        totalCount: totalCount
                    });
                    if (allItems.length) yield this.loadStream(filter, allItems.length);
                });
            }
            /**
                 * @protected
                 */ loadStream(filter, newCount) {
                return $29590480c608918b$var$$5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function*() {
                    const newList = [];
                    const stream = this.stream || (this.stream = this.openStream(filter));
                    for(let i = 0; i < newCount; i++){
                        const { done: done, value: value } = yield stream.next();
                        if (done) break;
                        newList.push(value);
                    }
                    return newList;
                });
            }
            /**
                 * @protected
                 */ loadPage(pageIndex, pageSize, filter) {
                return $29590480c608918b$var$$5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function*() {
                    const { totalCount: totalCount, allItems: allItems } = this, requiredCount = pageIndex * pageSize;
                    const newCount = (totalCount ? Math.min(totalCount, requiredCount) : requiredCount) - allItems.length;
                    const newList = yield this.loadStream(filter, newCount);
                    this.pageList = (0, $fbe6f1e2fed97fc7$export$697c3df919c0e61a)([
                        ...this.allItems,
                        ...newList
                    ], pageSize);
                    return {
                        pageData: this.pageList[pageIndex - 1] || [],
                        totalCount: this.totalCount
                    };
                });
            }
        }, (()=>{
            var _b;
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
            _restoreList_decorators = [
                $29590480c608918b$export$e03c1c3201ee8bb7('downloading')
            ];
            $29590480c608918b$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _restoreList_decorators, {
                kind: "method",
                name: "restoreList",
                static: false,
                private: false,
                access: {
                    has: (obj)=>"restoreList" in obj,
                    get: (obj)=>obj.restoreList
                },
                metadata: _metadata
            }, null, _instanceExtraInitializers);
            if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: _metadata
            });
        })(), _a;
    })();
    return StreamListMixin;
}


var $08d2c164df79c500$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $08d2c164df79c500$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $08d2c164df79c500$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $08d2c164df79c500$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $08d2c164df79c500$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $08d2c164df79c500$export$621c2e9225361608 = (()=>{
    var _a, _UserModel_session_accessor_storage;
    let _session_decorators;
    let _session_initializers = [];
    let _session_extraInitializers = [];
    return _a = class UserModel {
        constructor(){
            _UserModel_session_accessor_storage.set(this, $08d2c164df79c500$var$__runInitializers(this, _session_initializers, void 0));
            Object.defineProperty(this, "restored", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($08d2c164df79c500$var$__runInitializers(this, _session_extraInitializers), (0, $29590480c608918b$export$db239ef39aadc7fe)(this, 'User'))
            });
        }
        get session() {
            return $08d2c164df79c500$var$__classPrivateFieldGet(this, _UserModel_session_accessor_storage, "f");
        }
        set session(value) {
            $08d2c164df79c500$var$__classPrivateFieldSet(this, _UserModel_session_accessor_storage, value, "f");
        }
        signIn(_b) {
            return $08d2c164df79c500$var$__awaiter(this, arguments, void 0, function*({ account: account, key: key }) {
                if (account !== 'admin' || key !== '19890604') throw new URIError("The key can't be forgotten!");
                return this.session = {
                    account: account,
                    avatar: 'https://github.com/idea2app.png'
                };
            });
        }
        signOut() {
            this.session = undefined;
            return (0, $d6420b577268fef7$export$42ffd38884aecdac)();
        }
    }, _UserModel_session_accessor_storage = new WeakMap(), (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _session_decorators = [
            (0, $29590480c608918b$export$9a6132153fba2e0)(),
            (0, $d5I5D.observable)
        ];
        $08d2c164df79c500$var$__esDecorate(_a, null, _session_decorators, {
            kind: "accessor",
            name: "session",
            static: false,
            private: false,
            access: {
                has: (obj)=>"session" in obj,
                get: (obj)=>obj.session,
                set: (obj, value)=>{
                    obj.session = value;
                }
            },
            metadata: _metadata
        }, _session_initializers, _session_extraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
var $08d2c164df79c500$export$2e2bcd8739ae039 = new $08d2c164df79c500$export$621c2e9225361608();


var $f957ec994051c3ca$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $f957ec994051c3ca$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $f957ec994051c3ca$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
const { t: $f957ec994051c3ca$var$t } = (0, $b7383b0731549701$export$a7357cdd1f0b0168);
let $f957ec994051c3ca$export$7893f173408d95e4 = (()=>{
    let _classDecorators = [
        (0, $4d3432ed03d68615$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = (0, $hO8yS.Component);
    var PageBox = _classThis = class extends _classSuper {
        renderSignIn() {
            return (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("div", {
                className: "vw-100 vh-100 d-flex flex-column justify-content-center align-items-center",
                style: {
                    background: 'url(https://gw.alipayobjects.com/zos/rmsportal/TVYTbAXWheQpRcWDaDMu.svg)'
                },
                children: [
                    (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("h1", {
                        children: [
                            (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("img", {
                                className: "me-1",
                                style: {
                                    width: '3rem'
                                },
                                src: "https://github.com/ant-design.png"
                            }),
                            "React-MobX-Ant-Design-ts"
                        ]
                    }),
                    (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $3ab5acc35160fbcc$export$2e2bcd8739ae039), {
                        onFinish: (data)=>(0, $08d2c164df79c500$export$2e2bcd8739ae039).signIn(data),
                        children: [
                            (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $3ab5acc35160fbcc$export$2e2bcd8739ae039).Item, {
                                name: "account",
                                required: true,
                                children: (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $f5df81ecd1248f24$export$2e2bcd8739ae039), {
                                    addonBefore: (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $4c99305365a0f992$export$2e2bcd8739ae039), {}),
                                    placeholder: "admin"
                                })
                            }),
                            (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $3ab5acc35160fbcc$export$2e2bcd8739ae039).Item, {
                                name: "key",
                                required: true,
                                children: (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $f5df81ecd1248f24$export$2e2bcd8739ae039), {
                                    type: "password",
                                    addonBefore: (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $e7b3910945d3664d$export$2e2bcd8739ae039), {}),
                                    placeholder: "19890604"
                                })
                            }),
                            (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $9632ad3149894c43$export$2e2bcd8739ae039), {
                                htmlType: "submit",
                                type: "primary",
                                block: true,
                                children: $f957ec994051c3ca$var$t('sign_in')
                            })
                        ]
                    })
                ]
            });
        }
        renderLinks() {
            return (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $23cb8fbdad4e5f07$export$2e2bcd8739ae039), {
                className: "flex-fill",
                mode: "horizontal",
                theme: "dark",
                items: [
                    {
                        key: 'pagination',
                        label: (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $dbfbcf83869c9c18$export$a6c7ac8248d6e38a), {
                            to: "/pagination",
                            children: $f957ec994051c3ca$var$t('pagination')
                        })
                    },
                    {
                        key: 'scroll-list',
                        label: (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $dbfbcf83869c9c18$export$a6c7ac8248d6e38a), {
                            to: "/scroll-list",
                            children: $f957ec994051c3ca$var$t('scroll_list')
                        })
                    },
                    {
                        key: 'source-code',
                        label: (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("a", {
                            target: "_blank",
                            href: "https://github.com/idea2app/React-MobX-Ant-Design-ts",
                            children: $f957ec994051c3ca$var$t('source_code')
                        })
                    }
                ]
            });
        }
        renderUserBar() {
            const { session: session } = (0, $08d2c164df79c500$export$2e2bcd8739ae039);
            return (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("div", {
                className: "d-flex align-items-center gap-3",
                children: [
                    (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $38b79a6ce8fc3a86$export$2e2bcd8739ae039), {
                        menu: {
                            items: Object.entries((0, $b7383b0731549701$export$4b3850bcaaad82f1)).map(([key, label])=>({
                                    key: key,
                                    label: label,
                                    onClick: ()=>(0, $b7383b0731549701$export$a7357cdd1f0b0168).loadLanguages(key)
                                }))
                        },
                        children: (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $222d3e72b595d6b5$export$2e2bcd8739ae039), {
                            className: "text-white fs-4"
                        })
                    }),
                    (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $38b79a6ce8fc3a86$export$2e2bcd8739ae039), {
                        menu: {
                            items: [
                                {
                                    key: 'sign_out',
                                    label: $f957ec994051c3ca$var$t('sign_out'),
                                    onClick: ()=>(0, $08d2c164df79c500$export$2e2bcd8739ae039).signOut()
                                }
                            ]
                        },
                        children: (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $0cb483a407d1bed2$export$2e2bcd8739ae039), {
                            src: session.avatar,
                            children: session.account
                        })
                    })
                ]
            });
        }
        render() {
            const { narrow: narrow, children: children } = this.props;
            return !(0, $08d2c164df79c500$export$2e2bcd8739ae039).session ? this.renderSignIn() : (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $7bcbd8b5f8085112$export$2e2bcd8739ae039), {
                children: [
                    (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $7bcbd8b5f8085112$export$2e2bcd8739ae039).Header, {
                        className: "d-flex align-items-center justify-content-between sticky-top",
                        children: [
                            (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("a", {
                                className: "d-block h-100",
                                href: ".",
                                children: (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("img", {
                                    className: "me-3",
                                    style: {
                                        height: '80%'
                                    },
                                    src: "https://github.com/ant-design.png"
                                })
                            }),
                            this.renderLinks(),
                            this.renderUserBar()
                        ]
                    }),
                    (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $7bcbd8b5f8085112$export$2e2bcd8739ae039).Content, {
                        className: "m-auto overflow-auto",
                        style: {
                            width: narrow ? '90vw' : '100vw'
                        },
                        children: children
                    }),
                    (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $7bcbd8b5f8085112$export$2e2bcd8739ae039).Footer, {
                        className: "text-center",
                        children: [
                            "\u00A92021-",
                            new Date().getFullYear(),
                            (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("a", {
                                className: "ms-2",
                                target: "_blank",
                                href: "https://idea2app.github.io/",
                                children: [
                                    $f957ec994051c3ca$var$t('powered_by'),
                                    " idea2app"
                                ]
                            })
                        ]
                    })
                ]
            });
        }
    };
    $f957ec994051c3ca$var$__setFunctionName(_classThis, "PageBox");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        $f957ec994051c3ca$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        PageBox = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $f957ec994051c3ca$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return PageBox = _classThis;
})();



var $hO8yS = parcelRequire("hO8yS");
parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");







parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");



parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");

"use client";
const $bec1946280bacb1f$var$Element = (props)=>{
    const { prefixCls: prefixCls, className: className, style: style, size: size, shape: shape } = props;
    const sizeCls = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)({
        [`${prefixCls}-lg`]: size === 'large',
        [`${prefixCls}-sm`]: size === 'small'
    });
    const shapeCls = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)({
        [`${prefixCls}-circle`]: shape === 'circle',
        [`${prefixCls}-square`]: shape === 'square',
        [`${prefixCls}-round`]: shape === 'round'
    });
    const sizeStyle = $32rMB.useMemo(()=>typeof size === 'number' ? {
            width: size,
            height: size,
            lineHeight: `${size}px`
        } : {}, [
        size
    ]);
    return /*#__PURE__*/ $hO8yS.createElement("span", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, sizeCls, shapeCls, className),
        style: {
            ...sizeStyle,
            ...style
        }
    });
};
var $bec1946280bacb1f$export$2e2bcd8739ae039 = $bec1946280bacb1f$var$Element;




const $c0e50866760a9255$var$skeletonClsLoading = new (0, $f806545df26bb0b4$export$2e2bcd8739ae039)(`ant-skeleton-loading`, {
    '0%': {
        backgroundPosition: '100% 50%'
    },
    '100%': {
        backgroundPosition: '0 50%'
    }
});
const $c0e50866760a9255$var$genSkeletonElementCommonSize = (size)=>({
        height: size,
        lineHeight: (0, $763a5b4b58d0a3ff$export$523c0b569236b342)(size)
    });
const $c0e50866760a9255$var$genSkeletonElementSize = (size)=>({
        width: size,
        ...$c0e50866760a9255$var$genSkeletonElementCommonSize(size)
    });
const $c0e50866760a9255$var$genSkeletonColor = (token)=>({
        background: token.skeletonLoadingBackground,
        backgroundSize: '400% 100%',
        animationName: $c0e50866760a9255$var$skeletonClsLoading,
        animationDuration: token.skeletonLoadingMotionDuration,
        animationTimingFunction: 'ease',
        animationIterationCount: 'infinite'
    });
const $c0e50866760a9255$var$genSkeletonElementInputSize = (size, calc)=>({
        width: calc(size).mul(5).equal(),
        minWidth: calc(size).mul(5).equal(),
        ...$c0e50866760a9255$var$genSkeletonElementCommonSize(size)
    });
const $c0e50866760a9255$var$genSkeletonElementAvatar = (token)=>{
    const { skeletonAvatarCls: skeletonAvatarCls, gradientFromColor: gradientFromColor, controlHeight: controlHeight, controlHeightLG: controlHeightLG, controlHeightSM: controlHeightSM } = token;
    return {
        [skeletonAvatarCls]: {
            display: 'inline-block',
            verticalAlign: 'top',
            background: gradientFromColor,
            ...$c0e50866760a9255$var$genSkeletonElementSize(controlHeight)
        },
        [`${skeletonAvatarCls}${skeletonAvatarCls}-circle`]: {
            borderRadius: '50%'
        },
        [`${skeletonAvatarCls}${skeletonAvatarCls}-lg`]: {
            ...$c0e50866760a9255$var$genSkeletonElementSize(controlHeightLG)
        },
        [`${skeletonAvatarCls}${skeletonAvatarCls}-sm`]: {
            ...$c0e50866760a9255$var$genSkeletonElementSize(controlHeightSM)
        }
    };
};
const $c0e50866760a9255$var$genSkeletonElementInput = (token)=>{
    const { controlHeight: controlHeight, borderRadiusSM: borderRadiusSM, skeletonInputCls: skeletonInputCls, controlHeightLG: controlHeightLG, controlHeightSM: controlHeightSM, gradientFromColor: gradientFromColor, calc: calc } = token;
    return {
        [skeletonInputCls]: {
            display: 'inline-block',
            verticalAlign: 'top',
            background: gradientFromColor,
            borderRadius: borderRadiusSM,
            ...$c0e50866760a9255$var$genSkeletonElementInputSize(controlHeight, calc)
        },
        [`${skeletonInputCls}-lg`]: {
            ...$c0e50866760a9255$var$genSkeletonElementInputSize(controlHeightLG, calc)
        },
        [`${skeletonInputCls}-sm`]: {
            ...$c0e50866760a9255$var$genSkeletonElementInputSize(controlHeightSM, calc)
        }
    };
};
const $c0e50866760a9255$var$genSkeletonElementShape = (token)=>{
    const { gradientFromColor: gradientFromColor, borderRadiusSM: borderRadiusSM, imageSizeBase: imageSizeBase, calc: calc } = token;
    return {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        verticalAlign: 'middle',
        background: gradientFromColor,
        borderRadius: borderRadiusSM,
        ...$c0e50866760a9255$var$genSkeletonElementSize(calc(imageSizeBase).mul(2).equal())
    };
};
const $c0e50866760a9255$var$genSkeletonElementNode = (token)=>{
    return {
        [token.skeletonNodeCls]: {
            ...$c0e50866760a9255$var$genSkeletonElementShape(token)
        }
    };
};
const $c0e50866760a9255$var$genSkeletonElementImage = (token)=>{
    const { skeletonImageCls: skeletonImageCls, imageSizeBase: imageSizeBase, calc: calc } = token;
    return {
        [skeletonImageCls]: {
            ...$c0e50866760a9255$var$genSkeletonElementShape(token),
            [`${skeletonImageCls}-path`]: {
                fill: '#bfbfbf'
            },
            [`${skeletonImageCls}-svg`]: {
                ...$c0e50866760a9255$var$genSkeletonElementSize(imageSizeBase),
                maxWidth: calc(imageSizeBase).mul(4).equal(),
                maxHeight: calc(imageSizeBase).mul(4).equal()
            },
            [`${skeletonImageCls}-svg${skeletonImageCls}-svg-circle`]: {
                borderRadius: '50%'
            }
        },
        [`${skeletonImageCls}${skeletonImageCls}-circle`]: {
            borderRadius: '50%'
        }
    };
};
const $c0e50866760a9255$var$genSkeletonElementButtonShape = (token, size, buttonCls)=>{
    const { skeletonButtonCls: skeletonButtonCls } = token;
    return {
        [`${buttonCls}${skeletonButtonCls}-circle`]: {
            width: size,
            minWidth: size,
            borderRadius: '50%'
        },
        [`${buttonCls}${skeletonButtonCls}-round`]: {
            borderRadius: size
        }
    };
};
const $c0e50866760a9255$var$genSkeletonElementButtonSize = (size, calc)=>({
        width: calc(size).mul(2).equal(),
        minWidth: calc(size).mul(2).equal(),
        ...$c0e50866760a9255$var$genSkeletonElementCommonSize(size)
    });
const $c0e50866760a9255$var$genSkeletonElementButton = (token)=>{
    const { borderRadiusSM: borderRadiusSM, skeletonButtonCls: skeletonButtonCls, controlHeight: controlHeight, controlHeightLG: controlHeightLG, controlHeightSM: controlHeightSM, gradientFromColor: gradientFromColor, calc: calc } = token;
    return {
        [skeletonButtonCls]: {
            display: 'inline-block',
            verticalAlign: 'top',
            background: gradientFromColor,
            borderRadius: borderRadiusSM,
            width: calc(controlHeight).mul(2).equal(),
            minWidth: calc(controlHeight).mul(2).equal(),
            ...$c0e50866760a9255$var$genSkeletonElementButtonSize(controlHeight, calc)
        },
        ...$c0e50866760a9255$var$genSkeletonElementButtonShape(token, controlHeight, skeletonButtonCls),
        [`${skeletonButtonCls}-lg`]: {
            ...$c0e50866760a9255$var$genSkeletonElementButtonSize(controlHeightLG, calc)
        },
        ...$c0e50866760a9255$var$genSkeletonElementButtonShape(token, controlHeightLG, `${skeletonButtonCls}-lg`),
        [`${skeletonButtonCls}-sm`]: {
            ...$c0e50866760a9255$var$genSkeletonElementButtonSize(controlHeightSM, calc)
        },
        ...$c0e50866760a9255$var$genSkeletonElementButtonShape(token, controlHeightSM, `${skeletonButtonCls}-sm`)
    };
};
// =============================== Base ===============================
const $c0e50866760a9255$var$genBaseStyle = (token)=>{
    const { componentCls: componentCls, skeletonAvatarCls: skeletonAvatarCls, skeletonTitleCls: skeletonTitleCls, skeletonParagraphCls: skeletonParagraphCls, skeletonButtonCls: skeletonButtonCls, skeletonInputCls: skeletonInputCls, skeletonNodeCls: skeletonNodeCls, skeletonImageCls: skeletonImageCls, controlHeight: controlHeight, controlHeightLG: controlHeightLG, controlHeightSM: controlHeightSM, gradientFromColor: gradientFromColor, padding: padding, marginSM: marginSM, borderRadius: borderRadius, titleHeight: titleHeight, blockRadius: blockRadius, paragraphLiHeight: paragraphLiHeight, controlHeightXS: controlHeightXS, paragraphMarginTop: paragraphMarginTop } = token;
    return {
        [componentCls]: {
            display: 'table',
            width: '100%',
            [`${componentCls}-header`]: {
                display: 'table-cell',
                paddingInlineEnd: padding,
                verticalAlign: 'top',
                // Avatar
                [skeletonAvatarCls]: {
                    display: 'inline-block',
                    verticalAlign: 'top',
                    background: gradientFromColor,
                    ...$c0e50866760a9255$var$genSkeletonElementSize(controlHeight)
                },
                [`${skeletonAvatarCls}-circle`]: {
                    borderRadius: '50%'
                },
                [`${skeletonAvatarCls}-lg`]: {
                    ...$c0e50866760a9255$var$genSkeletonElementSize(controlHeightLG)
                },
                [`${skeletonAvatarCls}-sm`]: {
                    ...$c0e50866760a9255$var$genSkeletonElementSize(controlHeightSM)
                }
            },
            [`${componentCls}-section`]: {
                display: 'table-cell',
                width: '100%',
                verticalAlign: 'top',
                // Title
                [skeletonTitleCls]: {
                    width: '100%',
                    height: titleHeight,
                    background: gradientFromColor,
                    borderRadius: blockRadius,
                    [`+ ${skeletonParagraphCls}`]: {
                        marginBlockStart: controlHeightSM
                    }
                },
                // paragraph
                [skeletonParagraphCls]: {
                    padding: 0,
                    '> li': {
                        width: '100%',
                        height: paragraphLiHeight,
                        listStyle: 'none',
                        background: gradientFromColor,
                        borderRadius: blockRadius,
                        '+ li': {
                            marginBlockStart: controlHeightXS
                        }
                    }
                },
                [`${skeletonParagraphCls}> li:last-child:not(:first-child):not(:nth-child(2))`]: {
                    width: '61%'
                }
            },
            [`&-round ${componentCls}-section`]: {
                [`${skeletonTitleCls}, ${skeletonParagraphCls} > li`]: {
                    borderRadius: borderRadius
                }
            }
        },
        [`${componentCls}-with-avatar ${componentCls}-section`]: {
            // Title
            [skeletonTitleCls]: {
                marginBlockStart: marginSM,
                [`+ ${skeletonParagraphCls}`]: {
                    marginBlockStart: paragraphMarginTop
                }
            }
        },
        // Skeleton with element
        [`${componentCls}${componentCls}-element`]: {
            display: 'inline-block',
            width: 'auto',
            ...$c0e50866760a9255$var$genSkeletonElementButton(token),
            ...$c0e50866760a9255$var$genSkeletonElementAvatar(token),
            ...$c0e50866760a9255$var$genSkeletonElementInput(token),
            ...$c0e50866760a9255$var$genSkeletonElementNode(token),
            ...$c0e50866760a9255$var$genSkeletonElementImage(token)
        },
        // Skeleton Block Button, Input
        [`${componentCls}${componentCls}-block`]: {
            width: '100%',
            [skeletonButtonCls]: {
                width: '100%'
            },
            [skeletonInputCls]: {
                width: '100%'
            }
        },
        // With active animation
        [`${componentCls}${componentCls}-active`]: {
            [`
        ${skeletonTitleCls},
        ${skeletonParagraphCls} > li,
        ${skeletonAvatarCls},
        ${skeletonButtonCls},
        ${skeletonInputCls},
        ${skeletonNodeCls},
        ${skeletonImageCls}
      `]: {
                ...$c0e50866760a9255$var$genSkeletonColor(token)
            }
        }
    };
};
const $c0e50866760a9255$export$9ca1be8807fe0675 = (token)=>{
    const { colorFillContent: colorFillContent, colorFill: colorFill } = token;
    const gradientFromColor = colorFillContent;
    const gradientToColor = colorFill;
    return {
        color: gradientFromColor,
        colorGradientEnd: gradientToColor,
        gradientFromColor: gradientFromColor,
        gradientToColor: gradientToColor,
        titleHeight: token.controlHeight / 2,
        blockRadius: token.borderRadiusSM,
        paragraphMarginTop: token.marginLG + token.marginXXS,
        paragraphLiHeight: token.controlHeight / 2
    };
};
var $c0e50866760a9255$export$2e2bcd8739ae039 = (0, $d4a2dc313c4d90a4$export$51ec95de45185b42)('Skeleton', (token)=>{
    const { componentCls: componentCls, calc: calc } = token;
    const skeletonToken = (0, $90c11ca6cb263fd9$export$4950aa0f605343fb)(token, {
        skeletonAvatarCls: `${componentCls}-avatar`,
        skeletonTitleCls: `${componentCls}-title`,
        skeletonParagraphCls: `${componentCls}-paragraph`,
        skeletonButtonCls: `${componentCls}-button`,
        skeletonInputCls: `${componentCls}-input`,
        skeletonNodeCls: `${componentCls}-node`,
        skeletonImageCls: `${componentCls}-image`,
        imageSizeBase: calc(token.controlHeight).mul(1.5).equal(),
        borderRadius: 100,
        // Large number to make capsule shape
        skeletonLoadingBackground: `linear-gradient(90deg, ${token.gradientFromColor} 25%, ${token.gradientToColor} 37%, ${token.gradientFromColor} 63%)`,
        skeletonLoadingMotionDuration: '1.4s'
    });
    return $c0e50866760a9255$var$genBaseStyle(skeletonToken);
}, $c0e50866760a9255$export$9ca1be8807fe0675, {
    deprecatedTokens: [
        [
            'color',
            'gradientFromColor'
        ],
        [
            'colorGradientEnd',
            'gradientToColor'
        ]
    ]
});


"use client";
const $0699bfd03859f5f8$var$SkeletonAvatar = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, classNames: classNames, rootClassName: rootClassName, active: active, style: style, styles: styles, shape: shape = 'circle', size: size = 'default', ...rest } = props;
    const { getPrefixCls: getPrefixCls } = $32rMB.useContext((0, $dd01e2f5a4b8605d$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $c0e50866760a9255$export$2e2bcd8739ae039)(prefixCls);
    const cls = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-element`, {
        [`${prefixCls}-active`]: active
    }, classNames?.root, className, rootClassName, hashId, cssVarCls);
    return /*#__PURE__*/ $hO8yS.createElement("div", {
        className: cls,
        style: styles?.root
    }, /*#__PURE__*/ $hO8yS.createElement((0, $bec1946280bacb1f$export$2e2bcd8739ae039), {
        prefixCls: `${prefixCls}-avatar`,
        className: classNames?.content,
        style: {
            ...styles?.content,
            ...style
        },
        shape: shape,
        size: size,
        ...rest
    }));
};
var $0699bfd03859f5f8$export$2e2bcd8739ae039 = $0699bfd03859f5f8$var$SkeletonAvatar;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");




"use client";
const $c62a5baa29d13e62$var$SkeletonButton = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, classNames: classNames, active: active, style: style, styles: styles, block: block = false, size: size = 'default', ...rest } = props;
    const { getPrefixCls: getPrefixCls } = $32rMB.useContext((0, $dd01e2f5a4b8605d$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $c0e50866760a9255$export$2e2bcd8739ae039)(prefixCls);
    const cls = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-element`, {
        [`${prefixCls}-active`]: active,
        [`${prefixCls}-block`]: block
    }, classNames?.root, className, rootClassName, hashId, cssVarCls);
    return /*#__PURE__*/ $hO8yS.createElement("div", {
        className: cls,
        style: styles?.root
    }, /*#__PURE__*/ $hO8yS.createElement((0, $bec1946280bacb1f$export$2e2bcd8739ae039), {
        prefixCls: `${prefixCls}-button`,
        className: classNames?.content,
        style: {
            ...styles?.content,
            ...style
        },
        size: size,
        ...rest
    }));
};
var $c62a5baa29d13e62$export$2e2bcd8739ae039 = $c62a5baa29d13e62$var$SkeletonButton;



parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");

parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");



"use client";
const $260fef963188ebc3$var$SkeletonNode = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, classNames: classNames, rootClassName: rootClassName, internalClassName: internalClassName, style: style, styles: styles, active: active, children: children } = props;
    const { getPrefixCls: getPrefixCls } = $32rMB.useContext((0, $dd01e2f5a4b8605d$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $c0e50866760a9255$export$2e2bcd8739ae039)(prefixCls);
    const cls = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-element`, {
        [`${prefixCls}-active`]: active
    }, hashId, classNames?.root, className, rootClassName, cssVarCls);
    return /*#__PURE__*/ $hO8yS.createElement("div", {
        className: cls,
        style: styles?.root
    }, /*#__PURE__*/ $hO8yS.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(classNames?.content, internalClassName || `${prefixCls}-node`),
        style: {
            ...styles?.content,
            ...style
        }
    }, children));
};
var $260fef963188ebc3$export$2e2bcd8739ae039 = $260fef963188ebc3$var$SkeletonNode;


"use client";
const $de5301def516c9dd$var$path = 'M365.714286 329.142857q0 45.714286-32.036571 77.677714t-77.677714 32.036571-77.677714-32.036571-32.036571-77.677714 32.036571-77.677714 77.677714-32.036571 77.677714 32.036571 32.036571 77.677714zM950.857143 548.571429l0 256-804.571429 0 0-109.714286 182.857143-182.857143 91.428571 91.428571 292.571429-292.571429zM1005.714286 146.285714l-914.285714 0q-7.460571 0-12.873143 5.412571t-5.412571 12.873143l0 694.857143q0 7.460571 5.412571 12.873143t12.873143 5.412571l914.285714 0q7.460571 0 12.873143-5.412571t5.412571-12.873143l0-694.857143q0-7.460571-5.412571-12.873143t-12.873143-5.412571zM1097.142857 164.571429l0 694.857143q0 37.741714-26.843429 64.585143t-64.585143 26.843429l-914.285714 0q-37.741714 0-64.585143-26.843429t-26.843429-64.585143l0-694.857143q0-37.741714 26.843429-64.585143t64.585143-26.843429l914.285714 0q37.741714 0 64.585143 26.843429t26.843429 64.585143z';
const $de5301def516c9dd$var$SkeletonImage = (props)=>{
    const { getPrefixCls: getPrefixCls } = $32rMB.useContext((0, $dd01e2f5a4b8605d$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('skeleton', props.prefixCls);
    return /*#__PURE__*/ $hO8yS.createElement((0, $260fef963188ebc3$export$2e2bcd8739ae039), {
        ...props,
        internalClassName: `${prefixCls}-image`
    }, /*#__PURE__*/ $hO8yS.createElement("svg", {
        viewBox: "0 0 1098 1024",
        xmlns: "http://www.w3.org/2000/svg",
        className: `${prefixCls}-image-svg`
    }, /*#__PURE__*/ $hO8yS.createElement("title", null, "Image placeholder"), /*#__PURE__*/ $hO8yS.createElement("path", {
        d: $de5301def516c9dd$var$path,
        className: `${prefixCls}-image-path`
    })));
};
var $de5301def516c9dd$export$2e2bcd8739ae039 = $de5301def516c9dd$var$SkeletonImage;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");




"use client";
const $ae9d8d6fd8af13a6$var$SkeletonInput = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, classNames: classNames, rootClassName: rootClassName, active: active, block: block, style: style, styles: styles, size: size = 'default', ...rest } = props;
    const { getPrefixCls: getPrefixCls } = $32rMB.useContext((0, $dd01e2f5a4b8605d$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $c0e50866760a9255$export$2e2bcd8739ae039)(prefixCls);
    const cls = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-element`, {
        [`${prefixCls}-active`]: active,
        [`${prefixCls}-block`]: block
    }, classNames?.root, className, rootClassName, hashId, cssVarCls);
    return /*#__PURE__*/ $hO8yS.createElement("div", {
        className: cls,
        style: styles?.root
    }, /*#__PURE__*/ $hO8yS.createElement((0, $bec1946280bacb1f$export$2e2bcd8739ae039), {
        prefixCls: `${prefixCls}-input`,
        className: classNames?.content,
        style: {
            ...styles?.content,
            ...style
        },
        size: size,
        ...rest
    }));
};
var $ae9d8d6fd8af13a6$export$2e2bcd8739ae039 = $ae9d8d6fd8af13a6$var$SkeletonInput;



parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");

"use client";
const $62f921650f9fd24b$var$getWidth = (index, props)=>{
    const { width: width, rows: rows = 2 } = props;
    if (Array.isArray(width)) return width[index];
    // last paragraph
    if (rows - 1 === index) return width;
    return undefined;
};
const $62f921650f9fd24b$var$Paragraph = (props)=>{
    const { prefixCls: prefixCls, className: className, style: style, rows: rows = 0 } = props;
    const rowList = Array.from({
        length: rows
    }).map((_, index)=>/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
        $hO8yS.createElement("li", {
            key: index,
            style: {
                width: $62f921650f9fd24b$var$getWidth(index, props)
            }
        }));
    return /*#__PURE__*/ $hO8yS.createElement("ul", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, className),
        style: style
    }, rowList);
};
var $62f921650f9fd24b$export$2e2bcd8739ae039 = $62f921650f9fd24b$var$Paragraph;



parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");

"use client";
const $4aa6fb4015eef46d$var$Title = ({ prefixCls: prefixCls, className: className, width: width, style: style })=>/*#__PURE__*/ // biome-ignore lint/a11y/useHeadingContent: HOC here
    $hO8yS.createElement("h3", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, className),
        style: {
            width: width,
            ...style
        }
    });
var $4aa6fb4015eef46d$export$2e2bcd8739ae039 = $4aa6fb4015eef46d$var$Title;


"use client";
function $96fa3f2daafd8034$var$getComponentProps(prop) {
    if (prop && typeof prop === 'object') return prop;
    return {};
}
function $96fa3f2daafd8034$var$getAvatarBasicProps(hasTitle, hasParagraph) {
    if (hasTitle && !hasParagraph) // Square avatar
    return {
        size: 'large',
        shape: 'square'
    };
    return {
        size: 'large',
        shape: 'circle'
    };
}
function $96fa3f2daafd8034$var$getTitleBasicProps(hasAvatar, hasParagraph) {
    if (!hasAvatar && hasParagraph) return {
        width: '38%'
    };
    if (hasAvatar && hasParagraph) return {
        width: '50%'
    };
    return {};
}
function $96fa3f2daafd8034$var$getParagraphBasicProps(hasAvatar, hasTitle) {
    const basicProps = {};
    // Width
    if (!hasAvatar || !hasTitle) basicProps.width = '61%';
    // Rows
    if (!hasAvatar && hasTitle) basicProps.rows = 3;
    else basicProps.rows = 2;
    return basicProps;
}
// Tips: ctx.classNames.root < ctx.className < cpns.classNames.root < cpns.className < rootClassName
const $96fa3f2daafd8034$var$Skeleton = (props)=>{
    const { prefixCls: customizePrefixCls, loading: loading, className: className, rootClassName: rootClassName, classNames: classNames, style: style, styles: styles, children: children, avatar: avatar = false, title: title = true, paragraph: paragraph = true, active: active, round: round } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $dd01e2f5a4b8605d$export$46f4bd6436a25a31)('skeleton');
    const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $c0e50866760a9255$export$2e2bcd8739ae039)(prefixCls);
    const mergedProps = {
        ...props,
        avatar: avatar,
        title: title,
        paragraph: paragraph
    };
    const [mergedClassNames, mergedStyles] = (0, $4dcf69d8c3d6df5c$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    if (loading || !('loading' in props)) {
        const hasAvatar = !!avatar;
        const hasTitle = !!title;
        const hasParagraph = !!paragraph;
        // Avatar
        let avatarNode;
        if (hasAvatar) {
            const avatarProps = {
                className: mergedClassNames.avatar,
                prefixCls: `${prefixCls}-avatar`,
                ...$96fa3f2daafd8034$var$getAvatarBasicProps(hasTitle, hasParagraph),
                ...$96fa3f2daafd8034$var$getComponentProps(avatar),
                style: mergedStyles.avatar
            };
            // We direct use SkeletonElement as avatar in skeleton internal.
            avatarNode = /*#__PURE__*/ $hO8yS.createElement("div", {
                className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(mergedClassNames.header, `${prefixCls}-header`),
                style: mergedStyles.header
            }, /*#__PURE__*/ $hO8yS.createElement((0, $bec1946280bacb1f$export$2e2bcd8739ae039), {
                ...avatarProps
            }));
        }
        let contentNode;
        if (hasTitle || hasParagraph) {
            // Title
            let $title;
            if (hasTitle) {
                const titleProps = {
                    className: mergedClassNames.title,
                    prefixCls: `${prefixCls}-title`,
                    ...$96fa3f2daafd8034$var$getTitleBasicProps(hasAvatar, hasParagraph),
                    ...$96fa3f2daafd8034$var$getComponentProps(title),
                    style: mergedStyles.title
                };
                $title = /*#__PURE__*/ $hO8yS.createElement((0, $4aa6fb4015eef46d$export$2e2bcd8739ae039), {
                    ...titleProps
                });
            }
            // Paragraph
            let paragraphNode;
            if (hasParagraph) {
                const paragraphProps = {
                    className: mergedClassNames.paragraph,
                    prefixCls: `${prefixCls}-paragraph`,
                    ...$96fa3f2daafd8034$var$getParagraphBasicProps(hasAvatar, hasTitle),
                    ...$96fa3f2daafd8034$var$getComponentProps(paragraph),
                    style: mergedStyles.paragraph
                };
                paragraphNode = /*#__PURE__*/ $hO8yS.createElement((0, $62f921650f9fd24b$export$2e2bcd8739ae039), {
                    ...paragraphProps
                });
            }
            contentNode = /*#__PURE__*/ $hO8yS.createElement("div", {
                className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(mergedClassNames.section, `${prefixCls}-section`),
                style: mergedStyles.section
            }, $title, paragraphNode);
        }
        const cls = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, {
            [`${prefixCls}-with-avatar`]: hasAvatar,
            [`${prefixCls}-active`]: active,
            [`${prefixCls}-rtl`]: direction === 'rtl',
            [`${prefixCls}-round`]: round
        }, mergedClassNames.root, contextClassName, className, rootClassName, hashId, cssVarCls);
        return /*#__PURE__*/ $hO8yS.createElement("div", {
            className: cls,
            style: {
                ...mergedStyles.root,
                ...contextStyle,
                ...style
            }
        }, avatarNode, contentNode);
    }
    return children ?? null;
};
$96fa3f2daafd8034$var$Skeleton.Button = (0, $c62a5baa29d13e62$export$2e2bcd8739ae039);
$96fa3f2daafd8034$var$Skeleton.Avatar = (0, $0699bfd03859f5f8$export$2e2bcd8739ae039);
$96fa3f2daafd8034$var$Skeleton.Input = (0, $ae9d8d6fd8af13a6$export$2e2bcd8739ae039);
$96fa3f2daafd8034$var$Skeleton.Image = (0, $de5301def516c9dd$export$2e2bcd8739ae039);
$96fa3f2daafd8034$var$Skeleton.Node = (0, $260fef963188ebc3$export$2e2bcd8739ae039);
var $96fa3f2daafd8034$export$2e2bcd8739ae039 = $96fa3f2daafd8034$var$Skeleton;


"use client";
var $3791c33551ab7576$export$2e2bcd8739ae039 = (0, $96fa3f2daafd8034$export$2e2bcd8739ae039);


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
// This icon file is generated automatically.
var $12908751919ddbb6$var$CloseOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "fill-rule": "evenodd",
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z"
                }
            }
        ]
    },
    "name": "close",
    "theme": "outlined"
};
var $12908751919ddbb6$export$2e2bcd8739ae039 = $12908751919ddbb6$var$CloseOutlined;



function $bd33c75627fd73a4$var$_extends() {
    $bd33c75627fd73a4$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bd33c75627fd73a4$var$_extends.apply(this, arguments);
}
const $bd33c75627fd73a4$var$CloseOutlined = (props, ref)=>/*#__PURE__*/ $hO8yS.createElement((0, $5fd6f3f3c400c267$export$2e2bcd8739ae039), $bd33c75627fd73a4$var$_extends({}, props, {
        ref: ref,
        icon: (0, $12908751919ddbb6$export$2e2bcd8739ae039)
    }));
/**![close](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdmlld0JveD0iNjQgNjQgODk2IDg5NiIgZm9jdXNhYmxlPSJmYWxzZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNzk5Ljg2IDE2Ni4zMWMuMDIgMCAuMDQuMDIuMDguMDZsNTcuNjkgNTcuN2MuMDQuMDMuMDUuMDUuMDYuMDhhLjEyLjEyIDAgMDEwIC4wNmMwIC4wMy0uMDIuMDUtLjA2LjA5TDU2OS45MyA1MTJsMjg3LjcgMjg3LjdjLjA0LjA0LjA1LjA2LjA2LjA5YS4xMi4xMiAwIDAxMCAuMDdjMCAuMDItLjAyLjA0LS4wNi4wOGwtNTcuNyA1Ny42OWMtLjAzLjA0LS4wNS4wNS0uMDcuMDZhLjEyLjEyIDAgMDEtLjA3IDBjLS4wMyAwLS4wNS0uMDItLjA5LS4wNkw1MTIgNTY5LjkzbC0yODcuNyAyODcuN2MtLjA0LjA0LS4wNi4wNS0uMDkuMDZhLjEyLjEyIDAgMDEtLjA3IDBjLS4wMiAwLS4wNC0uMDItLjA4LS4wNmwtNTcuNjktNTcuN2MtLjA0LS4wMy0uMDUtLjA1LS4wNi0uMDdhLjEyLjEyIDAgMDEwLS4wN2MwLS4wMy4wMi0uMDUuMDYtLjA5TDQ1NC4wNyA1MTJsLTI4Ny43LTI4Ny43Yy0uMDQtLjA0LS4wNS0uMDYtLjA2LS4wOWEuMTIuMTIgMCAwMTAtLjA3YzAtLjAyLjAyLS4wNC4wNi0uMDhsNTcuNy01Ny42OWMuMDMtLjA0LjA1LS4wNS4wNy0uMDZhLjEyLjEyIDAgMDEuMDcgMGMuMDMgMCAuMDUuMDIuMDkuMDZMNTEyIDQ1NC4wN2wyODcuNy0yODcuN2MuMDQtLjA0LjA2LS4wNS4wOS0uMDZhLjEyLjEyIDAgMDEuMDcgMHoiIC8+PC9zdmc+) */ const $bd33c75627fd73a4$var$RefIcon = /*#__PURE__*/ $N3oW3.forwardRef($bd33c75627fd73a4$var$CloseOutlined);
var $bd33c75627fd73a4$export$2e2bcd8739ae039 = $bd33c75627fd73a4$var$RefIcon;



parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
// This icon file is generated automatically.
var $75c238bb41dead94$var$PlusOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M192 474h672q8 0 8 8v60q0 8-8 8H160q-8 0-8-8v-60q0-8 8-8z"
                }
            }
        ]
    },
    "name": "plus",
    "theme": "outlined"
};
var $75c238bb41dead94$export$2e2bcd8739ae039 = $75c238bb41dead94$var$PlusOutlined;



function $c6f0ed7390719aa1$var$_extends() {
    $c6f0ed7390719aa1$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c6f0ed7390719aa1$var$_extends.apply(this, arguments);
}
const $c6f0ed7390719aa1$var$PlusOutlined = (props, ref)=>/*#__PURE__*/ $hO8yS.createElement((0, $5fd6f3f3c400c267$export$2e2bcd8739ae039), $c6f0ed7390719aa1$var$_extends({}, props, {
        ref: ref,
        icon: (0, $75c238bb41dead94$export$2e2bcd8739ae039)
    }));
/**![plus](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTQ4MiAxNTJoNjBxOCAwIDggOHY3MDRxMCA4LTggOGgtNjBxLTggMC04LThWMTYwcTAtOCA4LTh6IiAvPjxwYXRoIGQ9Ik0xOTIgNDc0aDY3MnE4IDAgOCA4djYwcTAgOC04IDhIMTYwcS04IDAtOC04di02MHEwLTggOC04eiIgLz48L3N2Zz4=) */ const $c6f0ed7390719aa1$var$RefIcon = /*#__PURE__*/ $N3oW3.forwardRef($c6f0ed7390719aa1$var$PlusOutlined);
var $c6f0ed7390719aa1$export$2e2bcd8739ae039 = $c6f0ed7390719aa1$var$RefIcon;




var $8eea937e36a1b736$exports = {};
'use strict';
$8eea937e36a1b736$exports = $8eea937e36a1b736$var$isMobile;
$8eea937e36a1b736$exports.isMobile = $8eea937e36a1b736$var$isMobile;
$8eea937e36a1b736$exports.default = $8eea937e36a1b736$var$isMobile;
const $8eea937e36a1b736$var$mobileRE = /(android|bb\d+|meego).+mobile|armv7l|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|redmi|series[46]0|samsungbrowser.*mobile|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i;
const $8eea937e36a1b736$var$notMobileRE = /CrOS/;
const $8eea937e36a1b736$var$tabletRE = /android|ipad|playbook|silk/i;
function $8eea937e36a1b736$var$isMobile(opts) {
    if (!opts) opts = {};
    let ua = opts.ua;
    if (!ua && typeof navigator !== 'undefined') ua = navigator.userAgent;
    if (ua && ua.headers && typeof ua.headers['user-agent'] === 'string') ua = ua.headers['user-agent'];
    if (typeof ua !== 'string') return false;
    let result = $8eea937e36a1b736$var$mobileRE.test(ua) && !$8eea937e36a1b736$var$notMobileRE.test(ua) || !!opts.tablet && $8eea937e36a1b736$var$tabletRE.test(ua);
    if (!result && opts.tablet && opts.featureDetect && navigator && navigator.maxTouchPoints > 1 && ua.indexOf('Macintosh') !== -1 && ua.indexOf('Safari') !== -1) result = true;
    return result;
}


let $047894b2832d05da$var$cached;
var $047894b2832d05da$export$2e2bcd8739ae039 = ()=>{
    if (typeof $047894b2832d05da$var$cached === 'undefined') $047894b2832d05da$var$cached = (0, (/*@__PURE__*/$parcel$interopDefault($8eea937e36a1b736$exports)))();
    return $047894b2832d05da$var$cached;
};


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $e94560f563920cb2$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $hO8yS.createContext)(null);


// zombieJ: To compatible with `renderTabBar` usage.
parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");




parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");



var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
const $3cf2419be0713a7e$var$useIndicator = (options)=>{
    const { activeTabOffset: activeTabOffset, horizontal: horizontal, rtl: rtl, indicator: indicator = {} } = options;
    const { size: size, align: align = 'center' } = indicator;
    const [inkStyle, setInkStyle] = (0, $32rMB.useState)();
    const inkBarRafRef = (0, $32rMB.useRef)();
    const getLength = (0, $N3oW3.default).useCallback((origin)=>{
        if (typeof size === 'function') return size(origin);
        if (typeof size === 'number') return size;
        return origin;
    }, [
        size
    ]);
    // Delay set ink style to avoid remove tab blink
    function cleanInkBarRaf() {
        (0, $c9c36e20d667d30c$export$2e2bcd8739ae039).cancel(inkBarRafRef.current);
    }
    (0, $32rMB.useEffect)(()=>{
        const newInkStyle = {};
        if (activeTabOffset) {
            if (horizontal) {
                newInkStyle.width = getLength(activeTabOffset.width);
                const key = rtl ? 'right' : 'left';
                if (align === 'start') newInkStyle[key] = activeTabOffset[key];
                if (align === 'center') {
                    newInkStyle[key] = activeTabOffset[key] + activeTabOffset.width / 2;
                    newInkStyle.transform = rtl ? 'translateX(50%)' : 'translateX(-50%)';
                }
                if (align === 'end') {
                    newInkStyle[key] = activeTabOffset[key] + activeTabOffset.width;
                    newInkStyle.transform = 'translateX(-100%)';
                }
            } else {
                newInkStyle.height = getLength(activeTabOffset.height);
                if (align === 'start') newInkStyle.top = activeTabOffset.top;
                if (align === 'center') {
                    newInkStyle.top = activeTabOffset.top + activeTabOffset.height / 2;
                    newInkStyle.transform = 'translateY(-50%)';
                }
                if (align === 'end') {
                    newInkStyle.top = activeTabOffset.top + activeTabOffset.height;
                    newInkStyle.transform = 'translateY(-100%)';
                }
            }
        }
        cleanInkBarRaf();
        inkBarRafRef.current = (0, $c9c36e20d667d30c$export$2e2bcd8739ae039)(()=>{
            // Avoid jitter caused by tiny numerical differences
            // fix https://github.com/ant-design/ant-design/issues/53378
            const isEqual = inkStyle && newInkStyle && Object.keys(newInkStyle).every((key)=>{
                const newValue = newInkStyle[key];
                const oldValue = inkStyle[key];
                return typeof newValue === 'number' && typeof oldValue === 'number' ? Math.round(newValue) === Math.round(oldValue) : newValue === oldValue;
            });
            if (!isEqual) setInkStyle(newInkStyle);
        });
        return cleanInkBarRaf;
    }, [
        JSON.stringify(activeTabOffset),
        horizontal,
        rtl,
        align,
        getLength
    ]);
    return {
        style: inkStyle
    };
};
var $3cf2419be0713a7e$export$2e2bcd8739ae039 = $3cf2419be0713a7e$var$useIndicator;


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
const $83dfbf380f2a807e$var$DEFAULT_SIZE = {
    width: 0,
    height: 0,
    left: 0,
    top: 0
};
function $83dfbf380f2a807e$export$2e2bcd8739ae039(tabs, tabSizes, holderScrollWidth) {
    return (0, $32rMB.useMemo)(()=>{
        const map = new Map();
        const lastOffset = tabSizes.get(tabs[0]?.key) || $83dfbf380f2a807e$var$DEFAULT_SIZE;
        const rightOffset = lastOffset.left + lastOffset.width;
        for(let i = 0; i < tabs.length; i += 1){
            const { key: key } = tabs[i];
            let data = tabSizes.get(key);
            // Reuse last one when not exist yet
            if (!data) data = tabSizes.get(tabs[i - 1]?.key) || $83dfbf380f2a807e$var$DEFAULT_SIZE;
            const entity = map.get(key) || {
                ...data
            };
            // Right
            entity.right = rightOffset - entity.left - entity.width;
            // Update entity
            map.set(key, entity);
        }
        return map;
    }, [
        tabs.map((tab)=>tab.key).join('_'),
        tabSizes,
        holderScrollWidth
    ]);
}


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
function $21b4a8988c054c69$export$2e2bcd8739ae039(defaultState, onChange) {
    const stateRef = $32rMB.useRef(defaultState);
    const [, forceUpdate] = $32rMB.useState({});
    function setState(updater) {
        const newValue = typeof updater === 'function' ? updater(stateRef.current) : updater;
        if (newValue !== stateRef.current) onChange(newValue, stateRef.current);
        stateRef.current = newValue;
        forceUpdate({});
    }
    return [
        stateRef.current,
        setState
    ];
}


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
const $d839940fa10ef763$var$MIN_SWIPE_DISTANCE = 0.1;
const $d839940fa10ef763$var$STOP_SWIPE_DISTANCE = 0.01;
const $d839940fa10ef763$var$REFRESH_INTERVAL = 20;
const $d839940fa10ef763$var$SPEED_OFF_MULTIPLE = 0.995 ** $d839940fa10ef763$var$REFRESH_INTERVAL;
function $d839940fa10ef763$export$2e2bcd8739ae039(ref, onOffset) {
    const [touchPosition, setTouchPosition] = (0, $32rMB.useState)();
    const [lastTimestamp, setLastTimestamp] = (0, $32rMB.useState)(0);
    const [lastTimeDiff, setLastTimeDiff] = (0, $32rMB.useState)(0);
    const [lastOffset, setLastOffset] = (0, $32rMB.useState)();
    const motionRef = (0, $32rMB.useRef)();
    // ========================= Events =========================
    // >>> Touch events
    function onTouchStart(e) {
        const { screenX: screenX, screenY: screenY } = e.touches[0];
        setTouchPosition({
            x: screenX,
            y: screenY
        });
        window.clearInterval(motionRef.current);
    }
    function onTouchMove(e) {
        if (!touchPosition) return;
        // e.preventDefault();
        const { screenX: screenX, screenY: screenY } = e.touches[0];
        setTouchPosition({
            x: screenX,
            y: screenY
        });
        const offsetX = screenX - touchPosition.x;
        const offsetY = screenY - touchPosition.y;
        onOffset(offsetX, offsetY);
        const now = Date.now();
        setLastTimestamp(now);
        setLastTimeDiff(now - lastTimestamp);
        setLastOffset({
            x: offsetX,
            y: offsetY
        });
    }
    function onTouchEnd() {
        if (!touchPosition) return;
        setTouchPosition(null);
        setLastOffset(null);
        // Swipe if needed
        if (lastOffset) {
            const distanceX = lastOffset.x / lastTimeDiff;
            const distanceY = lastOffset.y / lastTimeDiff;
            const absX = Math.abs(distanceX);
            const absY = Math.abs(distanceY);
            // Skip swipe if low distance
            if (Math.max(absX, absY) < $d839940fa10ef763$var$MIN_SWIPE_DISTANCE) return;
            let currentX = distanceX;
            let currentY = distanceY;
            motionRef.current = window.setInterval(()=>{
                if (Math.abs(currentX) < $d839940fa10ef763$var$STOP_SWIPE_DISTANCE && Math.abs(currentY) < $d839940fa10ef763$var$STOP_SWIPE_DISTANCE) {
                    window.clearInterval(motionRef.current);
                    return;
                }
                currentX *= $d839940fa10ef763$var$SPEED_OFF_MULTIPLE;
                currentY *= $d839940fa10ef763$var$SPEED_OFF_MULTIPLE;
                onOffset(currentX * $d839940fa10ef763$var$REFRESH_INTERVAL, currentY * $d839940fa10ef763$var$REFRESH_INTERVAL);
            }, $d839940fa10ef763$var$REFRESH_INTERVAL);
        }
    }
    // >>> Wheel event
    const lastWheelDirectionRef = (0, $32rMB.useRef)();
    function onWheel(e) {
        const { deltaX: deltaX, deltaY: deltaY } = e;
        // Convert both to x & y since wheel only happened on PC
        let mixed = 0;
        const absX = Math.abs(deltaX);
        const absY = Math.abs(deltaY);
        if (absX === absY) mixed = lastWheelDirectionRef.current === 'x' ? deltaX : deltaY;
        else if (absX > absY) {
            mixed = deltaX;
            lastWheelDirectionRef.current = 'x';
        } else {
            mixed = deltaY;
            lastWheelDirectionRef.current = 'y';
        }
        if (onOffset(-mixed, -mixed)) e.preventDefault();
    }
    // ========================= Effect =========================
    const touchEventsRef = (0, $32rMB.useRef)(null);
    touchEventsRef.current = {
        onTouchStart: onTouchStart,
        onTouchMove: onTouchMove,
        onTouchEnd: onTouchEnd,
        onWheel: onWheel
    };
    $32rMB.useEffect(()=>{
        function onProxyTouchStart(e) {
            touchEventsRef.current.onTouchStart(e);
        }
        function onProxyTouchMove(e) {
            touchEventsRef.current.onTouchMove(e);
        }
        function onProxyTouchEnd(e) {
            touchEventsRef.current.onTouchEnd(e);
        }
        function onProxyWheel(e) {
            touchEventsRef.current.onWheel(e);
        }
        document.addEventListener('touchmove', onProxyTouchMove, {
            passive: false
        });
        document.addEventListener('touchend', onProxyTouchEnd, {
            passive: true
        });
        // No need to clean up since element removed
        ref.current.addEventListener('touchstart', onProxyTouchStart, {
            passive: true
        });
        ref.current.addEventListener('wheel', onProxyWheel, {
            passive: false
        });
        return ()=>{
            document.removeEventListener('touchmove', onProxyTouchMove);
            document.removeEventListener('touchend', onProxyTouchEnd);
        };
    }, []);
}



parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
function $683f625b53564e7d$export$2e2bcd8739ae039(callback) {
    const [count, setCount] = (0, $32rMB.useState)(0);
    const effectRef = (0, $32rMB.useRef)(0);
    const callbackRef = (0, $32rMB.useRef)();
    callbackRef.current = callback;
    // Trigger on `useLayoutEffect`
    (0, $60cea2402df671e7$export$9283e56bae2f7b0f)(()=>{
        callbackRef.current?.();
    }, [
        count
    ]);
    // Trigger to update count
    return ()=>{
        if (effectRef.current !== count) return;
        effectRef.current += 1;
        setCount(effectRef.current);
    };
}
function $683f625b53564e7d$export$aefd2a30eb6d999e(defaultState) {
    const batchRef = (0, $32rMB.useRef)([]);
    const [, forceUpdate] = (0, $32rMB.useState)({});
    const state = (0, $32rMB.useRef)(typeof defaultState === 'function' ? defaultState() : defaultState);
    const flushUpdate = $683f625b53564e7d$export$2e2bcd8739ae039(()=>{
        let current = state.current;
        batchRef.current.forEach((callback)=>{
            current = callback(current);
        });
        batchRef.current = [];
        state.current = current;
        forceUpdate({});
    });
    function updater(callback) {
        batchRef.current.push(callback);
        flushUpdate();
    }
    return [
        state.current,
        updater
    ];
}


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
const $fed991e6fded32cd$var$DEFAULT_SIZE = {
    width: 0,
    height: 0,
    left: 0,
    top: 0,
    right: 0
};
function $fed991e6fded32cd$export$2e2bcd8739ae039(tabOffsets, visibleTabContentValue, transform, tabContentSizeValue, addNodeSizeValue, operationNodeSizeValue, { tabs: tabs, tabPosition: tabPosition, rtl: rtl }) {
    let charUnit;
    let position;
    let transformSize;
    if ([
        'top',
        'bottom'
    ].includes(tabPosition)) {
        charUnit = 'width';
        position = rtl ? 'right' : 'left';
        transformSize = Math.abs(transform);
    } else {
        charUnit = 'height';
        position = 'top';
        transformSize = -transform;
    }
    return (0, $32rMB.useMemo)(()=>{
        if (!tabs.length) return [
            0,
            0
        ];
        const len = tabs.length;
        let endIndex = len;
        for(let i = 0; i < len; i += 1){
            const offset = tabOffsets.get(tabs[i].key) || $fed991e6fded32cd$var$DEFAULT_SIZE;
            if (Math.floor(offset[position] + offset[charUnit]) > Math.floor(transformSize + visibleTabContentValue)) {
                endIndex = i - 1;
                break;
            }
        }
        let startIndex = 0;
        for(let i = len - 1; i >= 0; i -= 1){
            const offset = tabOffsets.get(tabs[i].key) || $fed991e6fded32cd$var$DEFAULT_SIZE;
            if (offset[position] < transformSize) {
                startIndex = i + 1;
                break;
            }
        }
        return startIndex > endIndex ? [
            0,
            -1
        ] : [
            startIndex,
            endIndex
        ];
    }, [
        tabOffsets,
        visibleTabContentValue,
        tabContentSizeValue,
        addNodeSizeValue,
        operationNodeSizeValue,
        transformSize,
        tabPosition,
        tabs.map((tab)=>tab.key).join('_'),
        rtl
    ]);
}


/**
 * We trade Map as deps which may change with same value but different ref object.
 * We should make it as hash for deps
 * */ function $14c999a6a89bdd87$export$fac44ee5b035f737(obj) {
    let tgt;
    if (obj instanceof Map) {
        tgt = {};
        obj.forEach((v, k)=>{
            tgt[k] = v;
        });
    } else tgt = obj;
    return JSON.stringify(tgt);
}
const $14c999a6a89bdd87$var$RC_TABS_DOUBLE_QUOTE = 'TABS_DQ';
function $14c999a6a89bdd87$export$c55417729a96230c(key) {
    return String(key).replace(/"/g, $14c999a6a89bdd87$var$RC_TABS_DOUBLE_QUOTE);
}
function $14c999a6a89bdd87$export$eab31ca11b8b073(closable, closeIcon, editable, disabled) {
    if (// Only editable tabs can be removed
    !editable || // Tabs cannot be removed when disabled
    disabled || // closable is false
    closable === false || // If closable is undefined, the remove button should be hidden when closeIcon is null or false
    closable === undefined && (closeIcon === false || closeIcon === null)) return false;
    return true;
}


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
const $d22ae4f500757e01$var$AddButton = /*#__PURE__*/ $N3oW3.forwardRef((props, ref)=>{
    const { prefixCls: prefixCls, editable: editable, locale: locale, style: style } = props;
    if (!editable || editable.showAdd === false) return null;
    return /*#__PURE__*/ $hO8yS.createElement("button", {
        ref: ref,
        type: "button",
        className: `${prefixCls}-nav-add`,
        style: style,
        "aria-label": locale?.addAriaLabel || 'Add tab',
        onClick: (event)=>{
            editable.onEdit('add', {
                event: event
            });
        }
    }, editable.addIcon || '+');
});
var $d22ae4f500757e01$export$2e2bcd8739ae039 = $d22ae4f500757e01$var$AddButton;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
const $17a3eb38720ba8bf$var$ExtraContent = /*#__PURE__*/ $N3oW3.forwardRef((props, ref)=>{
    const { position: position, prefixCls: prefixCls, extra: extra } = props;
    if (!extra) return null;
    let content;
    // Parse extra
    let assertExtra = {};
    if (typeof extra === 'object' && !/*#__PURE__*/ $N3oW3.isValidElement(extra)) assertExtra = extra;
    else assertExtra.right = extra;
    if (position === 'right') content = assertExtra.right;
    if (position === 'left') content = assertExtra.left;
    return content ? /*#__PURE__*/ $hO8yS.createElement("div", {
        className: `${prefixCls}-extra-content`,
        ref: ref
    }, content) : null;
});
var $17a3eb38720ba8bf$export$2e2bcd8739ae039 = $17a3eb38720ba8bf$var$ExtraContent;






parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");


function $e140c16bb56d90c6$var$_extends() {
    $e140c16bb56d90c6$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e140c16bb56d90c6$var$_extends.apply(this, arguments);
}
const $e140c16bb56d90c6$var$OperationNode = /*#__PURE__*/ $N3oW3.forwardRef((props, ref)=>{
    const { prefixCls: prefixCls, id: id, tabs: tabs, locale: locale, mobile: mobile, more: moreProps = {}, style: style, className: className, editable: editable, tabBarGutter: tabBarGutter, rtl: rtl, removeAriaLabel: removeAriaLabel, onTabClick: onTabClick, getPopupContainer: getPopupContainer, popupClassName: popupClassName, popupStyle: popupStyle } = props;
    // ======================== Dropdown ========================
    const [open, setOpen] = (0, $32rMB.useState)(false);
    const [selectedKey, setSelectedKey] = (0, $32rMB.useState)(null);
    const { icon: moreIcon = 'More' } = moreProps;
    const popupId = `${id}-more-popup`;
    const dropdownPrefix = `${prefixCls}-dropdown`;
    const selectedItemId = selectedKey !== null ? `${popupId}-${selectedKey}` : null;
    const dropdownAriaLabel = locale?.dropdownAriaLabel;
    function onRemoveTab(event, key) {
        event.preventDefault();
        event.stopPropagation();
        editable.onEdit('remove', {
            key: key,
            event: event
        });
    }
    const menu = /*#__PURE__*/ $hO8yS.createElement((0, $2b25266c93a9e48f$export$2e2bcd8739ae039), {
        onClick: ({ key: key, domEvent: domEvent })=>{
            onTabClick(key, domEvent);
            setOpen(false);
        },
        prefixCls: `${dropdownPrefix}-menu`,
        id: popupId,
        tabIndex: -1,
        role: "listbox",
        "aria-activedescendant": selectedItemId,
        selectedKeys: [
            selectedKey
        ],
        "aria-label": dropdownAriaLabel !== undefined ? dropdownAriaLabel : 'expanded dropdown'
    }, tabs.map((tab)=>{
        const { closable: closable, disabled: disabled, closeIcon: closeIcon, key: key, label: label } = tab;
        const removable = (0, $14c999a6a89bdd87$export$eab31ca11b8b073)(closable, closeIcon, editable, disabled);
        return /*#__PURE__*/ $hO8yS.createElement((0, $c44576def6898817$export$2e2bcd8739ae039), {
            key: key,
            id: `${popupId}-${key}`,
            role: "option",
            "aria-controls": id && `${id}-panel-${key}`,
            disabled: disabled
        }, /*#__PURE__*/ $hO8yS.createElement("span", null, label), removable && /*#__PURE__*/ $hO8yS.createElement("button", {
            type: "button",
            "aria-label": removeAriaLabel || 'remove',
            tabIndex: 0,
            className: `${dropdownPrefix}-menu-item-remove`,
            onClick: (e)=>{
                e.stopPropagation();
                onRemoveTab(e, key);
            }
        }, closeIcon || editable.removeIcon || "\xd7"));
    }));
    function selectOffset(offset) {
        const enabledTabs = tabs.filter((tab)=>!tab.disabled);
        let selectedIndex = enabledTabs.findIndex((tab)=>tab.key === selectedKey) || 0;
        const len = enabledTabs.length;
        for(let i = 0; i < len; i += 1){
            selectedIndex = (selectedIndex + offset + len) % len;
            const tab = enabledTabs[selectedIndex];
            if (!tab.disabled) {
                setSelectedKey(tab.key);
                return;
            }
        }
    }
    function onKeyDown(e) {
        const { which: which } = e;
        if (!open) {
            if ([
                (0, $4d7d870d585f8465$export$2e2bcd8739ae039).DOWN,
                (0, $4d7d870d585f8465$export$2e2bcd8739ae039).SPACE,
                (0, $4d7d870d585f8465$export$2e2bcd8739ae039).ENTER
            ].includes(which)) {
                setOpen(true);
                e.preventDefault();
            }
            return;
        }
        switch(which){
            case (0, $4d7d870d585f8465$export$2e2bcd8739ae039).UP:
                selectOffset(-1);
                e.preventDefault();
                break;
            case (0, $4d7d870d585f8465$export$2e2bcd8739ae039).DOWN:
                selectOffset(1);
                e.preventDefault();
                break;
            case (0, $4d7d870d585f8465$export$2e2bcd8739ae039).ESC:
                setOpen(false);
                break;
            case (0, $4d7d870d585f8465$export$2e2bcd8739ae039).SPACE:
            case (0, $4d7d870d585f8465$export$2e2bcd8739ae039).ENTER:
                if (selectedKey !== null) onTabClick(selectedKey, e);
                break;
        }
    }
    // ========================= Effect =========================
    (0, $32rMB.useEffect)(()=>{
        // We use query element here to avoid React strict warning
        const ele = document.getElementById(selectedItemId);
        if (ele?.scrollIntoView) ele.scrollIntoView(false);
    }, [
        selectedItemId,
        selectedKey
    ]);
    (0, $32rMB.useEffect)(()=>{
        if (!open) setSelectedKey(null);
    }, [
        open
    ]);
    // ========================= Render =========================
    const moreStyle = {
        marginInlineStart: tabBarGutter
    };
    if (!tabs.length) {
        moreStyle.visibility = 'hidden';
        moreStyle.order = 1;
    }
    const overlayClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(popupClassName, {
        [`${dropdownPrefix}-rtl`]: rtl
    });
    const moreNode = mobile ? null : /*#__PURE__*/ $hO8yS.createElement((0, $d0c9855484e57e9e$export$2e2bcd8739ae039), $e140c16bb56d90c6$var$_extends({
        prefixCls: dropdownPrefix,
        overlay: menu,
        visible: tabs.length ? open : false,
        onVisibleChange: setOpen,
        overlayClassName: overlayClassName,
        overlayStyle: popupStyle,
        mouseEnterDelay: 0.1,
        mouseLeaveDelay: 0.1,
        getPopupContainer: getPopupContainer
    }, moreProps), /*#__PURE__*/ $hO8yS.createElement("button", {
        type: "button",
        className: `${prefixCls}-nav-more`,
        style: moreStyle,
        "aria-haspopup": "listbox",
        "aria-controls": popupId,
        id: `${id}-more`,
        "aria-expanded": open,
        onKeyDown: onKeyDown
    }, moreIcon));
    return /*#__PURE__*/ $hO8yS.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-nav-operations`, className),
        style: style,
        ref: ref
    }, moreNode, /*#__PURE__*/ $hO8yS.createElement((0, $d22ae4f500757e01$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        locale: locale,
        editable: editable
    }));
});
var $e140c16bb56d90c6$export$2e2bcd8739ae039 = /*#__PURE__*/ $N3oW3.memo($e140c16bb56d90c6$var$OperationNode, (_, next)=>// https://github.com/ant-design/ant-design/issues/32544
    // We'd better remove syntactic sugar in `rc-menu` since this has perf issue
    next.tabMoving);



parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");

const $c8f248d710e53707$var$TabNode = (props)=>{
    const { prefixCls: prefixCls, id: id, active: active, focus: focus, tab: { key: key, label: label, disabled: disabled, closeIcon: closeIcon, icon: icon }, closable: closable, renderWrapper: renderWrapper, removeAriaLabel: removeAriaLabel, editable: editable, onClick: onClick, onFocus: onFocus, onBlur: onBlur, onKeyDown: onKeyDown, onMouseDown: onMouseDown, onMouseUp: onMouseUp, style: style, className: className, tabCount: tabCount, currentPosition: currentPosition } = props;
    const tabPrefix = `${prefixCls}-tab`;
    const removable = (0, $14c999a6a89bdd87$export$eab31ca11b8b073)(closable, closeIcon, editable, disabled);
    function onInternalClick(e) {
        if (disabled) return;
        onClick(e);
    }
    function onRemoveTab(event) {
        event.preventDefault();
        event.stopPropagation();
        editable.onEdit('remove', {
            key: key,
            event: event
        });
    }
    const labelNode = $32rMB.useMemo(()=>icon && typeof label === 'string' ? /*#__PURE__*/ $hO8yS.createElement("span", null, label) : label, [
        label,
        icon
    ]);
    const btnRef = $32rMB.useRef(null);
    $32rMB.useEffect(()=>{
        if (focus && btnRef.current) btnRef.current.focus();
    }, [
        focus
    ]);
    const node = /*#__PURE__*/ $hO8yS.createElement("div", {
        key: key,
        "data-node-key": (0, $14c999a6a89bdd87$export$c55417729a96230c)(key),
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(tabPrefix, className, {
            [`${tabPrefix}-with-remove`]: removable,
            [`${tabPrefix}-active`]: active,
            [`${tabPrefix}-disabled`]: disabled,
            [`${tabPrefix}-focus`]: focus
        }),
        style: style,
        onClick: onInternalClick
    }, /*#__PURE__*/ $hO8yS.createElement("div", {
        ref: btnRef,
        role: "tab",
        "aria-selected": active,
        id: id && `${id}-tab-${key}`,
        className: `${tabPrefix}-btn`,
        "aria-controls": id && `${id}-panel-${key}`,
        "aria-disabled": disabled,
        tabIndex: disabled ? null : active ? 0 : -1,
        onClick: (e)=>{
            e.stopPropagation();
            onInternalClick(e);
        },
        onKeyDown: onKeyDown,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onFocus: onFocus,
        onBlur: onBlur
    }, focus && /*#__PURE__*/ $hO8yS.createElement("div", {
        "aria-live": "polite",
        style: {
            width: 0,
            height: 0,
            position: 'absolute',
            overflow: 'hidden',
            opacity: 0
        }
    }, `Tab ${currentPosition} of ${tabCount}`), icon && /*#__PURE__*/ $hO8yS.createElement("span", {
        className: `${tabPrefix}-icon`
    }, icon), label && labelNode), removable && /*#__PURE__*/ $hO8yS.createElement("button", {
        type: "button",
        "aria-label": removeAriaLabel || 'remove',
        tabIndex: active ? 0 : -1,
        className: `${tabPrefix}-remove`,
        onClick: (e)=>{
            e.stopPropagation();
            onRemoveTab(e);
        }
    }, closeIcon || editable.removeIcon || "\xd7"));
    return renderWrapper ? renderWrapper(node) : node;
};
var $c8f248d710e53707$export$2e2bcd8739ae039 = $c8f248d710e53707$var$TabNode;


function $4473e94c03a0b662$var$_extends() {
    $4473e94c03a0b662$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4473e94c03a0b662$var$_extends.apply(this, arguments);
}
const $4473e94c03a0b662$var$getTabSize = (tab, containerRect)=>{
    // tabListRef
    const { offsetWidth: offsetWidth, offsetHeight: offsetHeight, offsetTop: offsetTop, offsetLeft: offsetLeft } = tab;
    const { width: width, height: height, left: left, top: top } = tab.getBoundingClientRect();
    // Use getBoundingClientRect to avoid decimal inaccuracy
    if (Math.abs(width - offsetWidth) < 1) return [
        width,
        height,
        left - containerRect.left,
        top - containerRect.top
    ];
    return [
        offsetWidth,
        offsetHeight,
        offsetLeft,
        offsetTop
    ];
};
const $4473e94c03a0b662$var$getSize = (refObj)=>{
    const { offsetWidth: offsetWidth = 0, offsetHeight: offsetHeight = 0 } = refObj.current || {};
    // Use getBoundingClientRect to avoid decimal inaccuracy
    if (refObj.current) {
        const { width: width, height: height } = refObj.current.getBoundingClientRect();
        if (Math.abs(width - offsetWidth) < 1) return [
            width,
            height
        ];
    }
    return [
        offsetWidth,
        offsetHeight
    ];
};
/**
 * Convert `SizeInfo` to unit value. Such as [123, 456] with `top` position get `123`
 */ const $4473e94c03a0b662$var$getUnitValue = (size, tabPositionTopOrBottom)=>{
    return size[tabPositionTopOrBottom ? 0 : 1];
};
const $4473e94c03a0b662$var$TabNavList = /*#__PURE__*/ $N3oW3.forwardRef((props, ref)=>{
    const { className: className, style: style, id: id, animated: animated, activeKey: activeKey, rtl: rtl, extra: extra, editable: editable, locale: locale, tabPosition: tabPosition, tabBarGutter: tabBarGutter, children: children, onTabClick: onTabClick, onTabScroll: onTabScroll, indicator: indicator, classNames: tabsClassNames, styles: styles } = props;
    const { prefixCls: prefixCls, tabs: tabs } = $32rMB.useContext((0, $e94560f563920cb2$export$2e2bcd8739ae039));
    const containerRef = (0, $32rMB.useRef)(null);
    const extraLeftRef = (0, $32rMB.useRef)(null);
    const extraRightRef = (0, $32rMB.useRef)(null);
    const tabsWrapperRef = (0, $32rMB.useRef)(null);
    const tabListRef = (0, $32rMB.useRef)(null);
    const operationsRef = (0, $32rMB.useRef)(null);
    const innerAddButtonRef = (0, $32rMB.useRef)(null);
    const tabPositionTopOrBottom = tabPosition === 'top' || tabPosition === 'bottom';
    const [transformLeft, setTransformLeft] = (0, $21b4a8988c054c69$export$2e2bcd8739ae039)(0, (next, prev)=>{
        if (tabPositionTopOrBottom && onTabScroll) onTabScroll({
            direction: next > prev ? 'left' : 'right'
        });
    });
    const [transformTop, setTransformTop] = (0, $21b4a8988c054c69$export$2e2bcd8739ae039)(0, (next, prev)=>{
        if (!tabPositionTopOrBottom && onTabScroll) onTabScroll({
            direction: next > prev ? 'top' : 'bottom'
        });
    });
    const [containerExcludeExtraSize, setContainerExcludeExtraSize] = (0, $32rMB.useState)([
        0,
        0
    ]);
    const [tabContentSize, setTabContentSize] = (0, $32rMB.useState)([
        0,
        0
    ]);
    const [addSize, setAddSize] = (0, $32rMB.useState)([
        0,
        0
    ]);
    const [operationSize, setOperationSize] = (0, $32rMB.useState)([
        0,
        0
    ]);
    const [tabSizes, setTabSizes] = (0, $683f625b53564e7d$export$aefd2a30eb6d999e)(new Map());
    const tabOffsets = (0, $83dfbf380f2a807e$export$2e2bcd8739ae039)(tabs, tabSizes, tabContentSize[0]);
    // ========================== Unit =========================
    const containerExcludeExtraSizeValue = $4473e94c03a0b662$var$getUnitValue(containerExcludeExtraSize, tabPositionTopOrBottom);
    const tabContentSizeValue = $4473e94c03a0b662$var$getUnitValue(tabContentSize, tabPositionTopOrBottom);
    const addSizeValue = $4473e94c03a0b662$var$getUnitValue(addSize, tabPositionTopOrBottom);
    const operationSizeValue = $4473e94c03a0b662$var$getUnitValue(operationSize, tabPositionTopOrBottom);
    const needScroll = Math.floor(containerExcludeExtraSizeValue) < Math.floor(tabContentSizeValue + addSizeValue);
    const visibleTabContentValue = needScroll ? containerExcludeExtraSizeValue - operationSizeValue : containerExcludeExtraSizeValue - addSizeValue;
    // ========================== Util =========================
    const operationsHiddenClassName = `${prefixCls}-nav-operations-hidden`;
    let transformMin = 0;
    let transformMax = 0;
    if (!tabPositionTopOrBottom) {
        transformMin = Math.min(0, visibleTabContentValue - tabContentSizeValue);
        transformMax = 0;
    } else if (rtl) {
        transformMin = 0;
        transformMax = Math.max(0, tabContentSizeValue - visibleTabContentValue);
    } else {
        transformMin = Math.min(0, visibleTabContentValue - tabContentSizeValue);
        transformMax = 0;
    }
    function alignInRange(value) {
        if (value < transformMin) return transformMin;
        if (value > transformMax) return transformMax;
        return value;
    }
    // ========================= Mobile ========================
    const touchMovingRef = (0, $32rMB.useRef)(null);
    const [lockAnimation, setLockAnimation] = (0, $32rMB.useState)();
    function doLockAnimation() {
        setLockAnimation(Date.now());
    }
    function clearTouchMoving() {
        if (touchMovingRef.current) clearTimeout(touchMovingRef.current);
    }
    (0, $d839940fa10ef763$export$2e2bcd8739ae039)(tabsWrapperRef, (offsetX, offsetY)=>{
        function doMove(setState, offset) {
            setState((value)=>{
                const newValue = alignInRange(value + offset);
                return newValue;
            });
        }
        // Skip scroll if place is enough
        if (!needScroll) return false;
        if (tabPositionTopOrBottom) doMove(setTransformLeft, offsetX);
        else doMove(setTransformTop, offsetY);
        clearTouchMoving();
        doLockAnimation();
        return true;
    });
    (0, $32rMB.useEffect)(()=>{
        clearTouchMoving();
        if (lockAnimation) touchMovingRef.current = setTimeout(()=>{
            setLockAnimation(0);
        }, 100);
        return clearTouchMoving;
    }, [
        lockAnimation
    ]);
    // ===================== Visible Range =====================
    // Render tab node & collect tab offset
    const [visibleStart, visibleEnd] = (0, $fed991e6fded32cd$export$2e2bcd8739ae039)(tabOffsets, // Container
    visibleTabContentValue, // Transform
    tabPositionTopOrBottom ? transformLeft : transformTop, // Tabs
    tabContentSizeValue, // Add
    addSizeValue, // Operation
    operationSizeValue, {
        ...props,
        tabs: tabs
    });
    // ========================= Scroll ========================
    const scrollToTab = (0, $ea93068db096b7d6$export$2e2bcd8739ae039)((key = activeKey)=>{
        const tabOffset = tabOffsets.get(key) || {
            width: 0,
            height: 0,
            left: 0,
            right: 0,
            top: 0
        };
        if (tabPositionTopOrBottom) {
            // ============ Align with top & bottom ============
            let newTransform = transformLeft;
            // RTL
            if (rtl) {
                if (tabOffset.right < transformLeft) newTransform = tabOffset.right;
                else if (tabOffset.right + tabOffset.width > transformLeft + visibleTabContentValue) newTransform = tabOffset.right + tabOffset.width - visibleTabContentValue;
            } else if (tabOffset.left < -transformLeft) newTransform = -tabOffset.left;
            else if (tabOffset.left + tabOffset.width > -transformLeft + visibleTabContentValue) newTransform = -(tabOffset.left + tabOffset.width - visibleTabContentValue);
            setTransformTop(0);
            setTransformLeft(alignInRange(newTransform));
        } else {
            // ============ Align with left & right ============
            let newTransform = transformTop;
            if (tabOffset.top < -transformTop) newTransform = -tabOffset.top;
            else if (tabOffset.top + tabOffset.height > -transformTop + visibleTabContentValue) newTransform = -(tabOffset.top + tabOffset.height - visibleTabContentValue);
            setTransformLeft(0);
            setTransformTop(alignInRange(newTransform));
        }
    });
    // ========================= Focus =========================
    const [focusKey, setFocusKey] = (0, $32rMB.useState)();
    const [isMouse, setIsMouse] = (0, $32rMB.useState)(false);
    const enabledTabs = tabs.filter((tab)=>!tab.disabled).map((tab)=>tab.key);
    const onOffset = (offset)=>{
        const currentIndex = enabledTabs.indexOf(focusKey || activeKey);
        const len = enabledTabs.length;
        const nextIndex = (currentIndex + offset + len) % len;
        const newKey = enabledTabs[nextIndex];
        setFocusKey(newKey);
    };
    const handleRemoveTab = (removalTabKey, e)=>{
        const removeIndex = enabledTabs.indexOf(removalTabKey);
        const removeTab = tabs.find((tab)=>tab.key === removalTabKey);
        const removable = (0, $14c999a6a89bdd87$export$eab31ca11b8b073)(removeTab?.closable, removeTab?.closeIcon, editable, removeTab?.disabled);
        if (removable) {
            e.preventDefault();
            e.stopPropagation();
            editable.onEdit('remove', {
                key: removalTabKey,
                event: e
            });
            // when remove last tab, focus previous tab
            if (removeIndex === enabledTabs.length - 1) onOffset(-1);
            else onOffset(1);
        }
    };
    const handleMouseDown = (key, e)=>{
        setIsMouse(true);
        // Middle mouse button
        if (e.button === 1) handleRemoveTab(key, e);
    };
    const handleKeyDown = (e)=>{
        const { code: code } = e;
        const isRTL = rtl && tabPositionTopOrBottom;
        const firstEnabledTab = enabledTabs[0];
        const lastEnabledTab = enabledTabs[enabledTabs.length - 1];
        switch(code){
            // LEFT
            case 'ArrowLeft':
                if (tabPositionTopOrBottom) onOffset(isRTL ? 1 : -1);
                break;
            // RIGHT
            case 'ArrowRight':
                if (tabPositionTopOrBottom) onOffset(isRTL ? -1 : 1);
                break;
            // UP
            case 'ArrowUp':
                e.preventDefault();
                if (!tabPositionTopOrBottom) onOffset(-1);
                break;
            // DOWN
            case 'ArrowDown':
                e.preventDefault();
                if (!tabPositionTopOrBottom) onOffset(1);
                break;
            // HOME
            case 'Home':
                e.preventDefault();
                setFocusKey(firstEnabledTab);
                break;
            // END
            case 'End':
                e.preventDefault();
                setFocusKey(lastEnabledTab);
                break;
            // Enter & Space
            case 'Enter':
            case 'Space':
                e.preventDefault();
                onTabClick(focusKey ?? activeKey, e);
                break;
            // Backspace
            case 'Backspace':
            case 'Delete':
                handleRemoveTab(focusKey, e);
                break;
        }
    };
    // ========================== Tab ==========================
    const tabNodeStyle = {};
    if (tabPositionTopOrBottom) tabNodeStyle.marginInlineStart = tabBarGutter;
    else tabNodeStyle.marginTop = tabBarGutter;
    const tabNodes = tabs.map((tab, i)=>{
        const { key: key } = tab;
        return /*#__PURE__*/ $hO8yS.createElement((0, $c8f248d710e53707$export$2e2bcd8739ae039), {
            id: id,
            prefixCls: prefixCls,
            key: key,
            tab: tab,
            className: tabsClassNames?.item,
            style: i === 0 ? styles?.item : {
                ...tabNodeStyle,
                ...styles?.item
            },
            closable: tab.closable,
            editable: editable,
            active: key === activeKey,
            focus: key === focusKey,
            renderWrapper: children,
            removeAriaLabel: locale?.removeAriaLabel,
            tabCount: enabledTabs.length,
            currentPosition: i + 1,
            onClick: (e)=>{
                onTabClick(key, e);
            },
            onKeyDown: handleKeyDown,
            onFocus: ()=>{
                if (!isMouse) setFocusKey(key);
                scrollToTab(key);
                doLockAnimation();
                if (!tabsWrapperRef.current) return;
                // Focus element will make scrollLeft change which we should reset back
                if (!rtl) tabsWrapperRef.current.scrollLeft = 0;
                tabsWrapperRef.current.scrollTop = 0;
            },
            onBlur: ()=>{
                setFocusKey(undefined);
            },
            onMouseDown: (e)=>handleMouseDown(key, e),
            onMouseUp: ()=>{
                setIsMouse(false);
            }
        });
    });
    // Update buttons records
    const updateTabSizes = ()=>setTabSizes(()=>{
            const newSizes = new Map();
            const listRect = tabListRef.current?.getBoundingClientRect();
            tabs.forEach(({ key: key })=>{
                const btnNode = tabListRef.current?.querySelector(`[data-node-key="${(0, $14c999a6a89bdd87$export$c55417729a96230c)(key)}"]`);
                if (btnNode) {
                    const [width, height, left, top] = $4473e94c03a0b662$var$getTabSize(btnNode, listRect);
                    newSizes.set(key, {
                        width: width,
                        height: height,
                        left: left,
                        top: top
                    });
                }
            });
            return newSizes;
        });
    (0, $32rMB.useEffect)(()=>{
        updateTabSizes();
    }, [
        tabs.map((tab)=>tab.key).join('_')
    ]);
    const onListHolderResize = (0, $683f625b53564e7d$export$2e2bcd8739ae039)(()=>{
        // Update wrapper records
        const containerSize = $4473e94c03a0b662$var$getSize(containerRef);
        const extraLeftSize = $4473e94c03a0b662$var$getSize(extraLeftRef);
        const extraRightSize = $4473e94c03a0b662$var$getSize(extraRightRef);
        setContainerExcludeExtraSize([
            containerSize[0] - extraLeftSize[0] - extraRightSize[0],
            containerSize[1] - extraLeftSize[1] - extraRightSize[1]
        ]);
        const newAddSize = $4473e94c03a0b662$var$getSize(innerAddButtonRef);
        setAddSize(newAddSize);
        const newOperationSize = $4473e94c03a0b662$var$getSize(operationsRef);
        setOperationSize(newOperationSize);
        // Which includes add button size
        const tabContentFullSize = $4473e94c03a0b662$var$getSize(tabListRef);
        setTabContentSize([
            tabContentFullSize[0] - newAddSize[0],
            tabContentFullSize[1] - newAddSize[1]
        ]);
        // Update buttons records
        updateTabSizes();
    });
    // ======================== Dropdown =======================
    const startHiddenTabs = tabs.slice(0, visibleStart);
    const endHiddenTabs = tabs.slice(visibleEnd + 1);
    const hiddenTabs = [
        ...startHiddenTabs,
        ...endHiddenTabs
    ];
    // =================== Link & Operations ===================
    const activeTabOffset = tabOffsets.get(activeKey);
    const { style: indicatorStyle } = (0, $3cf2419be0713a7e$export$2e2bcd8739ae039)({
        activeTabOffset: activeTabOffset,
        horizontal: tabPositionTopOrBottom,
        indicator: indicator,
        rtl: rtl
    });
    // ========================= Effect ========================
    (0, $32rMB.useEffect)(()=>{
        scrollToTab();
    }, [
        activeKey,
        transformMin,
        transformMax,
        (0, $14c999a6a89bdd87$export$fac44ee5b035f737)(activeTabOffset),
        (0, $14c999a6a89bdd87$export$fac44ee5b035f737)(tabOffsets),
        tabPositionTopOrBottom
    ]);
    // Should recalculate when rtl changed
    (0, $32rMB.useEffect)(()=>{
        onListHolderResize();
    // eslint-disable-next-line
    }, [
        rtl
    ]);
    // ========================= Render ========================
    const hasDropdown = !!hiddenTabs.length;
    const wrapPrefix = `${prefixCls}-nav-wrap`;
    let pingLeft;
    let pingRight;
    let pingTop;
    let pingBottom;
    if (tabPositionTopOrBottom) {
        if (rtl) {
            pingRight = transformLeft > 0;
            pingLeft = transformLeft !== transformMax;
        } else {
            pingLeft = transformLeft < 0;
            pingRight = transformLeft !== transformMin;
        }
    } else {
        pingTop = transformTop < 0;
        pingBottom = transformTop !== transformMin;
    }
    return /*#__PURE__*/ $hO8yS.createElement((0, $b8d12c084d14878d$export$2e2bcd8739ae039), {
        onResize: onListHolderResize
    }, /*#__PURE__*/ $hO8yS.createElement("div", {
        ref: (0, $2706ed817e87019d$export$1d1c999670a1285d)(ref, containerRef),
        role: "tablist",
        "aria-orientation": tabPositionTopOrBottom ? 'horizontal' : 'vertical',
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-nav`, className, tabsClassNames?.header),
        style: {
            ...styles?.header,
            ...style
        },
        onKeyDown: ()=>{
            // No need animation when use keyboard
            doLockAnimation();
        }
    }, /*#__PURE__*/ $hO8yS.createElement((0, $17a3eb38720ba8bf$export$2e2bcd8739ae039), {
        ref: extraLeftRef,
        position: "left",
        extra: extra,
        prefixCls: prefixCls
    }), /*#__PURE__*/ $hO8yS.createElement((0, $b8d12c084d14878d$export$2e2bcd8739ae039), {
        onResize: onListHolderResize
    }, /*#__PURE__*/ $hO8yS.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(wrapPrefix, {
            [`${wrapPrefix}-ping-left`]: pingLeft,
            [`${wrapPrefix}-ping-right`]: pingRight,
            [`${wrapPrefix}-ping-top`]: pingTop,
            [`${wrapPrefix}-ping-bottom`]: pingBottom
        }),
        ref: tabsWrapperRef
    }, /*#__PURE__*/ $hO8yS.createElement((0, $b8d12c084d14878d$export$2e2bcd8739ae039), {
        onResize: onListHolderResize
    }, /*#__PURE__*/ $hO8yS.createElement("div", {
        ref: tabListRef,
        className: `${prefixCls}-nav-list`,
        style: {
            transform: `translate(${transformLeft}px, ${transformTop}px)`,
            transition: lockAnimation ? 'none' : undefined
        }
    }, tabNodes, /*#__PURE__*/ $hO8yS.createElement((0, $d22ae4f500757e01$export$2e2bcd8739ae039), {
        ref: innerAddButtonRef,
        prefixCls: prefixCls,
        locale: locale,
        editable: editable,
        style: {
            ...tabNodes.length === 0 ? undefined : tabNodeStyle,
            visibility: hasDropdown ? 'hidden' : null
        }
    }), /*#__PURE__*/ $hO8yS.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-ink-bar`, tabsClassNames?.indicator, {
            [`${prefixCls}-ink-bar-animated`]: animated.inkBar
        }),
        style: {
            ...indicatorStyle,
            ...styles?.indicator
        }
    }))))), /*#__PURE__*/ $hO8yS.createElement((0, $e140c16bb56d90c6$export$2e2bcd8739ae039), $4473e94c03a0b662$var$_extends({}, props, {
        removeAriaLabel: locale?.removeAriaLabel,
        ref: operationsRef,
        prefixCls: prefixCls,
        tabs: hiddenTabs,
        className: !hasDropdown && operationsHiddenClassName,
        popupStyle: styles?.popup,
        tabMoving: !!lockAnimation
    })), /*#__PURE__*/ $hO8yS.createElement((0, $17a3eb38720ba8bf$export$2e2bcd8739ae039), {
        ref: extraRightRef,
        position: "right",
        extra: extra,
        prefixCls: prefixCls
    })));
/* eslint-enable */ });
var $4473e94c03a0b662$export$2e2bcd8739ae039 = $4473e94c03a0b662$var$TabNavList;


// We have to create a TabNavList components.
const $4e582fdcd7daccd7$var$TabNavListWrapper = ({ renderTabBar: renderTabBar, ...restProps })=>{
    if (renderTabBar) return renderTabBar(restProps, (0, $4473e94c03a0b662$export$2e2bcd8739ae039));
    return /*#__PURE__*/ $hO8yS.createElement((0, $4473e94c03a0b662$export$2e2bcd8739ae039), restProps);
};
var $4e582fdcd7daccd7$export$2e2bcd8739ae039 = $4e582fdcd7daccd7$var$TabNavListWrapper;




parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");



var $N3oW3 = parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
const $ae88ba658f22e7e6$var$TabPane = /*#__PURE__*/ $N3oW3.forwardRef((props, ref)=>{
    const { prefixCls: prefixCls, className: className, style: style, id: id, active: active, tabKey: tabKey, children: children } = props;
    const hasContent = $N3oW3.Children.count(children) > 0;
    return /*#__PURE__*/ $hO8yS.createElement("div", {
        id: id && `${id}-panel-${tabKey}`,
        role: "tabpanel",
        tabIndex: active && hasContent ? 0 : -1,
        "aria-labelledby": id && `${id}-tab-${tabKey}`,
        "aria-hidden": !active,
        style: style,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, active && `${prefixCls}-active`, className),
        ref: ref
    }, children);
});
var $ae88ba658f22e7e6$export$2e2bcd8739ae039 = $ae88ba658f22e7e6$var$TabPane;


function $6aa56b373ed36834$var$_extends() {
    $6aa56b373ed36834$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6aa56b373ed36834$var$_extends.apply(this, arguments);
}
const $6aa56b373ed36834$var$TabPanelList = (props)=>{
    const { id: id, activeKey: activeKey, animated: animated, tabPosition: tabPosition, destroyOnHidden: destroyOnHidden, contentStyle: contentStyle, contentClassName: contentClassName } = props;
    const { prefixCls: prefixCls, tabs: tabs } = $32rMB.useContext((0, $e94560f563920cb2$export$2e2bcd8739ae039));
    const tabPaneAnimated = animated.tabPane;
    const tabPanePrefixCls = `${prefixCls}-tabpane`;
    return /*#__PURE__*/ $hO8yS.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-content-holder`)
    }, /*#__PURE__*/ $hO8yS.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-content`, `${prefixCls}-content-${tabPosition}`, {
            [`${prefixCls}-content-animated`]: tabPaneAnimated
        })
    }, tabs.map((item)=>{
        const { key: key, forceRender: forceRender, style: paneStyle, className: paneClassName, destroyOnHidden: itemDestroyOnHidden, ...restTabProps } = item;
        const active = key === activeKey;
        return /*#__PURE__*/ $hO8yS.createElement((0, $db80a026d0a86ece$export$2e2bcd8739ae039), $6aa56b373ed36834$var$_extends({
            key: key,
            visible: active,
            forceRender: forceRender,
            removeOnLeave: !!(destroyOnHidden ?? itemDestroyOnHidden),
            leavedClassName: `${tabPanePrefixCls}-hidden`
        }, animated.tabPaneMotion), ({ style: motionStyle, className: motionClassName }, ref)=>/*#__PURE__*/ $hO8yS.createElement((0, $ae88ba658f22e7e6$export$2e2bcd8739ae039), $6aa56b373ed36834$var$_extends({}, restTabProps, {
                prefixCls: tabPanePrefixCls,
                id: id,
                tabKey: key,
                animated: tabPaneAnimated,
                active: active,
                style: {
                    ...contentStyle,
                    ...paneStyle,
                    ...motionStyle
                },
                className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(contentClassName, paneClassName, motionClassName),
                ref: ref
            })));
    })));
};
var $6aa56b373ed36834$export$2e2bcd8739ae039 = $6aa56b373ed36834$var$TabPanelList;



function $a50499143a67c5a7$export$2e2bcd8739ae039(animated = {
    inkBar: true,
    tabPane: false
}) {
    let mergedAnimated;
    if (animated === false) mergedAnimated = {
        inkBar: false,
        tabPane: false
    };
    else if (animated === true) mergedAnimated = {
        inkBar: true,
        tabPane: false
    };
    else mergedAnimated = {
        inkBar: true,
        ...typeof animated === 'object' ? animated : {}
    };
    // Enable tabPane animation if provide motion
    if (mergedAnimated.tabPaneMotion && mergedAnimated.tabPane === undefined) mergedAnimated.tabPane = true;
    if (!mergedAnimated.tabPaneMotion && mergedAnimated.tabPane) mergedAnimated.tabPane = false;
    return mergedAnimated;
}


function $ba5a3e81f857c4f0$var$_extends() {
    $ba5a3e81f857c4f0$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ba5a3e81f857c4f0$var$_extends.apply(this, arguments);
}
/**
 * Should added antd:
 * - type
 *
 * Removed:
 * - onNextClick
 * - onPrevClick
 * - keyboard
 */ // Used for accessibility
let $ba5a3e81f857c4f0$var$uuid = 0;
const $ba5a3e81f857c4f0$var$Tabs = /*#__PURE__*/ $N3oW3.forwardRef((props, ref)=>{
    const { id: id, prefixCls: prefixCls = 'rc-tabs', className: className, items: items, direction: direction, activeKey: activeKey, defaultActiveKey: defaultActiveKey, editable: editable, animated: animated, tabPosition: tabPosition = 'top', tabBarGutter: tabBarGutter, tabBarStyle: tabBarStyle, tabBarExtraContent: tabBarExtraContent, locale: locale, more: more, destroyOnHidden: destroyOnHidden, renderTabBar: renderTabBar, onChange: onChange, onTabClick: onTabClick, onTabScroll: onTabScroll, getPopupContainer: getPopupContainer, popupClassName: popupClassName, indicator: indicator, classNames: tabsClassNames, styles: styles, ...restProps } = props;
    const tabs = $32rMB.useMemo(()=>(items || []).filter((item)=>item && typeof item === 'object' && 'key' in item), [
        items
    ]);
    const rtl = direction === 'rtl';
    const mergedAnimated = (0, $a50499143a67c5a7$export$2e2bcd8739ae039)(animated);
    // ======================== Mobile ========================
    const [mobile, setMobile] = (0, $32rMB.useState)(false);
    (0, $32rMB.useEffect)(()=>{
        // Only update on the client side
        setMobile((0, $047894b2832d05da$export$2e2bcd8739ae039)());
    }, []);
    // ====================== Active Key ======================
    const [mergedActiveKey, setMergedActiveKey] = (0, $05ea6e97cee440ee$export$2e2bcd8739ae039)(defaultActiveKey ?? tabs[0]?.key, activeKey);
    const [activeIndex, setActiveIndex] = (0, $32rMB.useState)(()=>tabs.findIndex((tab)=>tab.key === mergedActiveKey));
    // Reset active key if not exist anymore
    (0, $32rMB.useEffect)(()=>{
        let newActiveIndex = tabs.findIndex((tab)=>tab.key === mergedActiveKey);
        if (newActiveIndex === -1) {
            newActiveIndex = Math.max(0, Math.min(activeIndex, tabs.length - 1));
            setMergedActiveKey(tabs[newActiveIndex]?.key);
        }
        setActiveIndex(newActiveIndex);
    }, [
        tabs.map((tab)=>tab.key).join('_'),
        mergedActiveKey,
        activeIndex
    ]);
    // ===================== Accessibility ====================
    const [mergedId, setMergedId] = (0, $05ea6e97cee440ee$export$2e2bcd8739ae039)(null, id);
    // Async generate id to avoid ssr mapping failed
    (0, $32rMB.useEffect)(()=>{
        if (!id) {
            setMergedId(`rc-tabs-${$ba5a3e81f857c4f0$var$uuid}`);
            $ba5a3e81f857c4f0$var$uuid += 1;
        }
    }, []);
    // ======================== Events ========================
    function onInternalTabClick(key, e) {
        onTabClick?.(key, e);
        const isActiveChanged = key !== mergedActiveKey;
        setMergedActiveKey(key);
        if (isActiveChanged) onChange?.(key);
    }
    // ======================== Render ========================
    const sharedProps = {
        id: mergedId,
        activeKey: mergedActiveKey,
        animated: mergedAnimated,
        tabPosition: tabPosition,
        rtl: rtl,
        mobile: mobile
    };
    const tabNavBarProps = {
        ...sharedProps,
        editable: editable,
        locale: locale,
        more: more,
        tabBarGutter: tabBarGutter,
        onTabClick: onInternalTabClick,
        onTabScroll: onTabScroll,
        extra: tabBarExtraContent,
        style: tabBarStyle,
        getPopupContainer: getPopupContainer,
        popupClassName: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(popupClassName, tabsClassNames?.popup),
        indicator: indicator,
        styles: styles,
        classNames: tabsClassNames
    };
    const memoizedValue = $32rMB.useMemo(()=>{
        return {
            tabs: tabs,
            prefixCls: prefixCls
        };
    }, [
        tabs,
        prefixCls
    ]);
    return /*#__PURE__*/ $hO8yS.createElement((0, $e94560f563920cb2$export$2e2bcd8739ae039).Provider, {
        value: memoizedValue
    }, /*#__PURE__*/ $hO8yS.createElement("div", $ba5a3e81f857c4f0$var$_extends({
        ref: ref,
        id: id,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-${tabPosition}`, {
            [`${prefixCls}-mobile`]: mobile,
            [`${prefixCls}-editable`]: editable,
            [`${prefixCls}-rtl`]: rtl
        }, className)
    }, restProps), /*#__PURE__*/ $hO8yS.createElement((0, $4e582fdcd7daccd7$export$2e2bcd8739ae039), $ba5a3e81f857c4f0$var$_extends({}, tabNavBarProps, {
        renderTabBar: renderTabBar
    })), /*#__PURE__*/ $hO8yS.createElement((0, $6aa56b373ed36834$export$2e2bcd8739ae039), $ba5a3e81f857c4f0$var$_extends({
        destroyOnHidden: destroyOnHidden
    }, sharedProps, {
        contentStyle: styles?.content,
        contentClassName: tabsClassNames?.content,
        animated: mergedAnimated
    }))));
});
var $ba5a3e81f857c4f0$export$2e2bcd8739ae039 = $ba5a3e81f857c4f0$var$Tabs;


var $6fb86baa3180eeb6$export$2e2bcd8739ae039 = (0, $ba5a3e81f857c4f0$export$2e2bcd8739ae039);










const $f004adebb64c1056$var$motion = {
    motionAppear: false,
    motionEnter: true,
    motionLeave: true
};
function $f004adebb64c1056$export$2e2bcd8739ae039(prefixCls, animated = {
    inkBar: true,
    tabPane: false
}) {
    let mergedAnimated;
    if (animated === false) mergedAnimated = {
        inkBar: false,
        tabPane: false
    };
    else if (animated === true) mergedAnimated = {
        inkBar: true,
        tabPane: true
    };
    else mergedAnimated = {
        inkBar: true,
        ...typeof animated === 'object' ? animated : {}
    };
    if (mergedAnimated.tabPane) mergedAnimated.tabPaneMotion = {
        ...$f004adebb64c1056$var$motion,
        motionName: (0, $689b5af26dd3c1cd$export$27c72201b1d09951)(prefixCls, 'switch')
    };
    return mergedAnimated;
}



var $N3oW3 = parcelRequire("N3oW3");


function $02d23f2476810785$var$filter(items) {
    return items.filter((item)=>item);
}
function $02d23f2476810785$var$useLegacyItems(items, children) {
    if (items) return items.map((item)=>({
            ...item,
            destroyOnHidden: item.destroyOnHidden ?? item.destroyInactiveTabPane
        }));
    const childrenItems = (0, $a60ede783f74e6a9$export$2e2bcd8739ae039)(children).map((node)=>{
        if (/*#__PURE__*/ $N3oW3.isValidElement(node)) {
            const { key: key, props: props } = node;
            const { tab: tab, ...restProps } = props || {};
            const item = {
                key: String(key),
                ...restProps,
                label: tab
            };
            return item;
        }
        return null;
    });
    return $02d23f2476810785$var$filter(childrenItems);
}
var $02d23f2476810785$export$2e2bcd8739ae039 = $02d23f2476810785$var$useLegacyItems;






const $19384673e9a05575$var$genMotionStyle = (token)=>{
    const { componentCls: componentCls, motionDurationSlow: motionDurationSlow } = token;
    return [
        {
            [componentCls]: {
                [`${componentCls}-switch`]: {
                    '&-appear, &-enter': {
                        transition: 'none',
                        '&-start': {
                            opacity: 0
                        },
                        '&-active': {
                            opacity: 1,
                            transition: `opacity ${motionDurationSlow}`
                        }
                    },
                    '&-leave': {
                        position: 'absolute',
                        transition: 'none',
                        inset: 0,
                        '&-start': {
                            opacity: 1
                        },
                        '&-active': {
                            opacity: 0,
                            transition: `opacity ${motionDurationSlow}`
                        }
                    }
                }
            }
        },
        // Follow code may reuse in other components
        [
            (0, $21a6ccba58224685$export$9018e60daecf7a6c)(token, 'slide-up'),
            (0, $21a6ccba58224685$export$9018e60daecf7a6c)(token, 'slide-down')
        ]
    ];
};
var $19384673e9a05575$export$2e2bcd8739ae039 = $19384673e9a05575$var$genMotionStyle;


const $b82e9cd206a94fb3$var$genCardStyle = (token)=>{
    const { componentCls: componentCls, tabsCardPadding: tabsCardPadding, cardBg: cardBg, cardGutter: cardGutter, colorBorderSecondary: colorBorderSecondary, itemSelectedColor: itemSelectedColor } = token;
    return {
        [`${componentCls}-card`]: {
            [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                [`${componentCls}-tab`]: {
                    margin: 0,
                    padding: tabsCardPadding,
                    background: cardBg,
                    border: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${colorBorderSecondary}`,
                    transition: `all ${token.motionDurationSlow} ${token.motionEaseInOut}`
                },
                [`${componentCls}-tab-active`]: {
                    color: itemSelectedColor,
                    background: token.colorBgContainer
                },
                [`${componentCls}-tab-focus:has(${componentCls}-tab-btn:focus-visible)`]: (0, $2f353af2b0f7600b$export$6539948f0a737e39)(token, -3),
                [`& ${componentCls}-tab${componentCls}-tab-focus ${componentCls}-tab-btn:focus-visible`]: {
                    outline: 'none'
                },
                [`${componentCls}-ink-bar`]: {
                    visibility: 'hidden'
                }
            },
            // ========================== Top & Bottom ==========================
            [`&${componentCls}-top, &${componentCls}-bottom`]: {
                [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                    [`${componentCls}-tab + ${componentCls}-tab`]: {
                        marginLeft: {
                            _skip_check_: true,
                            value: (0, $763a5b4b58d0a3ff$export$523c0b569236b342)(cardGutter)
                        }
                    }
                }
            },
            [`&${componentCls}-top`]: {
                [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                    [`${componentCls}-tab`]: {
                        borderRadius: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.borderRadiusLG)} ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.borderRadiusLG)} 0 0`
                    },
                    [`${componentCls}-tab-active`]: {
                        borderBottomColor: token.colorBgContainer
                    }
                }
            },
            [`&${componentCls}-bottom`]: {
                [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                    [`${componentCls}-tab`]: {
                        borderRadius: `0 0 ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.borderRadiusLG)} ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.borderRadiusLG)}`
                    },
                    [`${componentCls}-tab-active`]: {
                        borderTopColor: token.colorBgContainer
                    }
                }
            },
            // ========================== Left & Right ==========================
            [`&${componentCls}-left, &${componentCls}-right`]: {
                [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                    [`${componentCls}-tab + ${componentCls}-tab`]: {
                        marginTop: (0, $763a5b4b58d0a3ff$export$523c0b569236b342)(cardGutter)
                    }
                }
            },
            [`&${componentCls}-left`]: {
                [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                    [`${componentCls}-tab`]: {
                        borderRadius: {
                            _skip_check_: true,
                            value: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.borderRadiusLG)} 0 0 ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.borderRadiusLG)}`
                        }
                    },
                    [`${componentCls}-tab-active`]: {
                        borderRightColor: {
                            _skip_check_: true,
                            value: token.colorBgContainer
                        }
                    }
                }
            },
            [`&${componentCls}-right`]: {
                [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                    [`${componentCls}-tab`]: {
                        borderRadius: {
                            _skip_check_: true,
                            value: `0 ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.borderRadiusLG)} ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.borderRadiusLG)} 0`
                        }
                    },
                    [`${componentCls}-tab-active`]: {
                        borderLeftColor: {
                            _skip_check_: true,
                            value: token.colorBgContainer
                        }
                    }
                }
            }
        }
    };
};
const $b82e9cd206a94fb3$var$genDropdownStyle = (token)=>{
    const { componentCls: componentCls, itemHoverColor: itemHoverColor, dropdownEdgeChildVerticalPadding: dropdownEdgeChildVerticalPadding } = token;
    return {
        [`${componentCls}-dropdown`]: {
            ...(0, $2f353af2b0f7600b$export$23997c3e44cc1c59)(token),
            position: 'absolute',
            top: -9999,
            left: {
                _skip_check_: true,
                value: -9999
            },
            zIndex: token.zIndexPopup,
            display: 'block',
            '&-hidden': {
                display: 'none'
            },
            [`${componentCls}-dropdown-menu`]: {
                maxHeight: token.tabsDropdownHeight,
                margin: 0,
                padding: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(dropdownEdgeChildVerticalPadding)} 0`,
                overflowX: 'hidden',
                overflowY: 'auto',
                textAlign: {
                    _skip_check_: true,
                    value: 'left'
                },
                listStyleType: 'none',
                backgroundColor: token.colorBgContainer,
                backgroundClip: 'padding-box',
                borderRadius: token.borderRadiusLG,
                outline: 'none',
                boxShadow: token.boxShadowSecondary,
                '&-item': {
                    ...(0, $2f353af2b0f7600b$export$b2b65df0d0824629),
                    display: 'flex',
                    alignItems: 'center',
                    minWidth: token.tabsDropdownWidth,
                    margin: 0,
                    padding: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.paddingXXS)} ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.paddingSM)}`,
                    color: token.colorText,
                    fontWeight: 'normal',
                    fontSize: token.fontSize,
                    lineHeight: token.lineHeight,
                    cursor: 'pointer',
                    transition: `all ${token.motionDurationSlow}`,
                    '> span': {
                        flex: 1,
                        whiteSpace: 'nowrap'
                    },
                    '&-remove': {
                        flex: 'none',
                        marginLeft: {
                            _skip_check_: true,
                            value: token.marginSM
                        },
                        color: token.colorIcon,
                        fontSize: token.fontSizeSM,
                        background: 'transparent',
                        border: 0,
                        cursor: 'pointer',
                        '&:hover': {
                            color: itemHoverColor
                        }
                    },
                    '&:hover': {
                        background: token.controlItemBgHover
                    },
                    '&-disabled': {
                        '&, &:hover': {
                            color: token.colorTextDisabled,
                            background: 'transparent',
                            cursor: 'not-allowed'
                        }
                    }
                }
            }
        }
    };
};
const $b82e9cd206a94fb3$var$genPositionStyle = (token)=>{
    const { componentCls: componentCls, margin: margin, colorBorderSecondary: colorBorderSecondary, horizontalMargin: horizontalMargin, verticalItemPadding: verticalItemPadding, verticalItemMargin: verticalItemMargin, calc: calc } = token;
    return {
        // ========================== Top & Bottom ==========================
        [`${componentCls}-top, ${componentCls}-bottom`]: {
            flexDirection: 'column',
            [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                margin: horizontalMargin,
                '&::before': {
                    position: 'absolute',
                    right: {
                        _skip_check_: true,
                        value: 0
                    },
                    left: {
                        _skip_check_: true,
                        value: 0
                    },
                    borderBottom: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${colorBorderSecondary}`,
                    content: "''"
                },
                [`${componentCls}-ink-bar`]: {
                    height: token.lineWidthBold,
                    '&-animated': {
                        transition: `width ${token.motionDurationSlow}, left ${token.motionDurationSlow},
            right ${token.motionDurationSlow}`
                    }
                },
                [`${componentCls}-nav-wrap`]: {
                    '&::before, &::after': {
                        top: 0,
                        bottom: 0,
                        width: token.controlHeight
                    },
                    '&::before': {
                        left: {
                            _skip_check_: true,
                            value: 0
                        },
                        boxShadow: token.boxShadowTabsOverflowLeft
                    },
                    '&::after': {
                        right: {
                            _skip_check_: true,
                            value: 0
                        },
                        boxShadow: token.boxShadowTabsOverflowRight
                    },
                    [`&${componentCls}-nav-wrap-ping-left::before`]: {
                        opacity: 1
                    },
                    [`&${componentCls}-nav-wrap-ping-right::after`]: {
                        opacity: 1
                    }
                }
            }
        },
        [`${componentCls}-top`]: {
            [`> ${componentCls}-nav,
        > div > ${componentCls}-nav`]: {
                '&::before': {
                    bottom: 0
                },
                [`${componentCls}-ink-bar`]: {
                    bottom: 0
                }
            }
        },
        [`${componentCls}-bottom`]: {
            [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                order: 1,
                marginTop: margin,
                marginBottom: 0,
                '&::before': {
                    top: 0
                },
                [`${componentCls}-ink-bar`]: {
                    top: 0
                }
            },
            [`> ${componentCls}-content-holder, > div > ${componentCls}-content-holder`]: {
                order: 0
            }
        },
        // ========================== Left & Right ==========================
        [`${componentCls}-left, ${componentCls}-right`]: {
            [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                flexDirection: 'column',
                minWidth: calc(token.controlHeight).mul(1.25).equal(),
                // >>>>>>>>>>> Tab
                [`${componentCls}-tab`]: {
                    padding: verticalItemPadding,
                    textAlign: 'center'
                },
                [`${componentCls}-tab + ${componentCls}-tab`]: {
                    margin: verticalItemMargin
                },
                // >>>>>>>>>>> Nav
                [`${componentCls}-nav-wrap`]: {
                    flexDirection: 'column',
                    '&::before, &::after': {
                        right: {
                            _skip_check_: true,
                            value: 0
                        },
                        left: {
                            _skip_check_: true,
                            value: 0
                        },
                        height: token.controlHeight
                    },
                    '&::before': {
                        top: 0,
                        boxShadow: token.boxShadowTabsOverflowTop
                    },
                    '&::after': {
                        bottom: 0,
                        boxShadow: token.boxShadowTabsOverflowBottom
                    },
                    [`&${componentCls}-nav-wrap-ping-top::before`]: {
                        opacity: 1
                    },
                    [`&${componentCls}-nav-wrap-ping-bottom::after`]: {
                        opacity: 1
                    }
                },
                // >>>>>>>>>>> Ink Bar
                [`${componentCls}-ink-bar`]: {
                    width: token.lineWidthBold,
                    '&-animated': {
                        transition: `height ${token.motionDurationSlow}, top ${token.motionDurationSlow}`
                    }
                },
                [`${componentCls}-nav-list, ${componentCls}-nav-operations`]: {
                    flex: '1 0 auto',
                    // fix safari scroll problem
                    flexDirection: 'column'
                }
            }
        },
        [`${componentCls}-left`]: {
            [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                [`${componentCls}-ink-bar`]: {
                    right: {
                        _skip_check_: true,
                        value: 0
                    }
                }
            },
            [`> ${componentCls}-content-holder, > div > ${componentCls}-content-holder`]: {
                marginLeft: {
                    _skip_check_: true,
                    value: (0, $763a5b4b58d0a3ff$export$523c0b569236b342)(calc(token.lineWidth).mul(-1).equal())
                },
                borderLeft: {
                    _skip_check_: true,
                    value: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
                },
                [`> ${componentCls}-content > ${componentCls}-tabpane`]: {
                    paddingLeft: {
                        _skip_check_: true,
                        value: token.paddingLG
                    }
                }
            }
        },
        [`${componentCls}-right`]: {
            [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                order: 1,
                [`${componentCls}-ink-bar`]: {
                    left: {
                        _skip_check_: true,
                        value: 0
                    }
                }
            },
            [`> ${componentCls}-content-holder, > div > ${componentCls}-content-holder`]: {
                order: 0,
                marginRight: {
                    _skip_check_: true,
                    value: calc(token.lineWidth).mul(-1).equal()
                },
                borderRight: {
                    _skip_check_: true,
                    value: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
                },
                [`> ${componentCls}-content > ${componentCls}-tabpane`]: {
                    paddingRight: {
                        _skip_check_: true,
                        value: token.paddingLG
                    }
                }
            }
        }
    };
};
const $b82e9cd206a94fb3$var$genSizeStyle = (token)=>{
    const { componentCls: componentCls, cardPaddingSM: cardPaddingSM, cardPaddingLG: cardPaddingLG, cardHeightSM: cardHeightSM, cardHeightLG: cardHeightLG, horizontalItemPaddingSM: horizontalItemPaddingSM, horizontalItemPaddingLG: horizontalItemPaddingLG } = token;
    return {
        // >>>>> shared
        [componentCls]: {
            '&-small': {
                [`> ${componentCls}-nav`]: {
                    [`${componentCls}-tab`]: {
                        padding: horizontalItemPaddingSM,
                        fontSize: token.titleFontSizeSM
                    }
                }
            },
            '&-large': {
                [`> ${componentCls}-nav`]: {
                    [`${componentCls}-tab`]: {
                        padding: horizontalItemPaddingLG,
                        fontSize: token.titleFontSizeLG,
                        lineHeight: token.lineHeightLG
                    }
                }
            }
        },
        // >>>>> card
        [`${componentCls}-card`]: {
            // Small
            [`&${componentCls}-small`]: {
                [`> ${componentCls}-nav`]: {
                    [`${componentCls}-tab`]: {
                        padding: cardPaddingSM
                    },
                    [`${componentCls}-nav-add`]: {
                        minWidth: cardHeightSM,
                        minHeight: cardHeightSM
                    }
                },
                [`&${componentCls}-bottom`]: {
                    [`> ${componentCls}-nav ${componentCls}-tab`]: {
                        borderRadius: `0 0 ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.borderRadius)} ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.borderRadius)}`
                    }
                },
                [`&${componentCls}-top`]: {
                    [`> ${componentCls}-nav ${componentCls}-tab`]: {
                        borderRadius: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.borderRadius)} ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.borderRadius)} 0 0`
                    }
                },
                [`&${componentCls}-right`]: {
                    [`> ${componentCls}-nav ${componentCls}-tab`]: {
                        borderRadius: {
                            _skip_check_: true,
                            value: `0 ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.borderRadius)} ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.borderRadius)} 0`
                        }
                    }
                },
                [`&${componentCls}-left`]: {
                    [`> ${componentCls}-nav ${componentCls}-tab`]: {
                        borderRadius: {
                            _skip_check_: true,
                            value: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.borderRadius)} 0 0 ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.borderRadius)}`
                        }
                    }
                }
            },
            // Large
            [`&${componentCls}-large`]: {
                [`> ${componentCls}-nav`]: {
                    [`${componentCls}-tab`]: {
                        padding: cardPaddingLG
                    },
                    [`${componentCls}-nav-add`]: {
                        minWidth: cardHeightLG,
                        minHeight: cardHeightLG
                    }
                }
            }
        }
    };
};
const $b82e9cd206a94fb3$var$genTabStyle = (token)=>{
    const { componentCls: componentCls, itemActiveColor: itemActiveColor, itemHoverColor: itemHoverColor, iconCls: iconCls, tabsHorizontalItemMargin: tabsHorizontalItemMargin, horizontalItemPadding: horizontalItemPadding, itemSelectedColor: itemSelectedColor, itemColor: itemColor } = token;
    const tabCls = `${componentCls}-tab`;
    return {
        [tabCls]: {
            position: 'relative',
            WebkitTouchCallout: 'none',
            WebkitTapHighlightColor: 'transparent',
            display: 'inline-flex',
            alignItems: 'center',
            padding: horizontalItemPadding,
            fontSize: token.titleFontSize,
            background: 'transparent',
            border: 0,
            outline: 'none',
            cursor: 'pointer',
            color: itemColor,
            '&-btn, &-remove': {
                '&:focus:not(:focus-visible), &:active': {
                    color: itemActiveColor
                }
            },
            '&-btn': {
                outline: 'none',
                transition: `all ${token.motionDurationSlow}`,
                [`${tabCls}-icon:not(:last-child)`]: {
                    marginInlineEnd: token.marginSM
                }
            },
            '&-remove': {
                flex: 'none',
                lineHeight: 1,
                marginRight: {
                    _skip_check_: true,
                    value: token.calc(token.marginXXS).mul(-1).equal()
                },
                marginLeft: {
                    _skip_check_: true,
                    value: token.marginXS
                },
                color: token.colorIcon,
                fontSize: token.fontSizeSM,
                background: 'transparent',
                border: 'none',
                outline: 'none',
                cursor: 'pointer',
                transition: `all ${token.motionDurationSlow}`,
                '&:hover': {
                    color: token.colorTextHeading
                },
                ...(0, $2f353af2b0f7600b$export$a44db842bcb28231)(token)
            },
            '&:hover': {
                color: itemHoverColor
            },
            [`&${tabCls}-active ${tabCls}-btn`]: {
                color: itemSelectedColor
            },
            [`&${tabCls}-focus ${tabCls}-btn:focus-visible`]: (0, $2f353af2b0f7600b$export$6539948f0a737e39)(token),
            [`&${tabCls}-disabled`]: {
                color: token.colorTextDisabled,
                cursor: 'not-allowed'
            },
            [`&${tabCls}-disabled ${tabCls}-btn, &${tabCls}-disabled ${componentCls}-remove`]: {
                '&:focus, &:active': {
                    color: token.colorTextDisabled
                }
            },
            [`& ${tabCls}-remove ${iconCls}`]: {
                margin: 0,
                verticalAlign: 'middle'
            },
            [`${iconCls}:not(:last-child)`]: {
                marginRight: {
                    _skip_check_: true,
                    value: token.marginSM
                }
            }
        },
        [`${tabCls} + ${tabCls}`]: {
            margin: {
                _skip_check_: true,
                value: tabsHorizontalItemMargin
            }
        }
    };
};
const $b82e9cd206a94fb3$var$genRtlStyle = (token)=>{
    const { componentCls: componentCls, tabsHorizontalItemMarginRTL: tabsHorizontalItemMarginRTL, iconCls: iconCls, cardGutter: cardGutter, calc: calc } = token;
    const rtlCls = `${componentCls}-rtl`;
    return {
        [rtlCls]: {
            direction: 'rtl',
            [`${componentCls}-nav`]: {
                [`${componentCls}-tab`]: {
                    margin: {
                        _skip_check_: true,
                        value: tabsHorizontalItemMarginRTL
                    },
                    [`${componentCls}-tab:last-of-type`]: {
                        marginLeft: {
                            _skip_check_: true,
                            value: 0
                        }
                    },
                    [iconCls]: {
                        marginRight: {
                            _skip_check_: true,
                            value: 0
                        },
                        marginLeft: {
                            _skip_check_: true,
                            value: (0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.marginSM)
                        }
                    },
                    [`${componentCls}-tab-remove`]: {
                        marginRight: {
                            _skip_check_: true,
                            value: (0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.marginXS)
                        },
                        marginLeft: {
                            _skip_check_: true,
                            value: (0, $763a5b4b58d0a3ff$export$523c0b569236b342)(calc(token.marginXXS).mul(-1).equal())
                        },
                        [iconCls]: {
                            margin: 0
                        }
                    }
                }
            },
            [`&${componentCls}-left`]: {
                [`> ${componentCls}-nav`]: {
                    order: 1
                },
                [`> ${componentCls}-content-holder`]: {
                    order: 0
                }
            },
            [`&${componentCls}-right`]: {
                [`> ${componentCls}-nav`]: {
                    order: 0
                },
                [`> ${componentCls}-content-holder`]: {
                    order: 1
                }
            },
            // ====================== Card ======================
            [`&${componentCls}-card${componentCls}-top, &${componentCls}-card${componentCls}-bottom`]: {
                [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                    [`${componentCls}-tab + ${componentCls}-tab`]: {
                        marginRight: {
                            _skip_check_: true,
                            value: cardGutter
                        },
                        marginLeft: {
                            _skip_check_: true,
                            value: 0
                        }
                    }
                }
            }
        },
        [`${componentCls}-dropdown-rtl`]: {
            direction: 'rtl'
        },
        [`${componentCls}-menu-item`]: {
            [`${componentCls}-dropdown-rtl`]: {
                textAlign: {
                    _skip_check_: true,
                    value: 'right'
                }
            }
        }
    };
};
const $b82e9cd206a94fb3$var$genTabsStyle = (token)=>{
    const { componentCls: componentCls, tabsCardPadding: tabsCardPadding, cardHeight: cardHeight, cardGutter: cardGutter, itemHoverColor: itemHoverColor, itemActiveColor: itemActiveColor, colorBorderSecondary: colorBorderSecondary } = token;
    return {
        [componentCls]: {
            ...(0, $2f353af2b0f7600b$export$23997c3e44cc1c59)(token),
            display: 'flex',
            // ========================== Navigation ==========================
            [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                position: 'relative',
                display: 'flex',
                flex: 'none',
                alignItems: 'center',
                [`${componentCls}-nav-wrap`]: {
                    position: 'relative',
                    display: 'flex',
                    flex: 'auto',
                    alignSelf: 'stretch',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    transform: 'translate(0)',
                    // Fix chrome render bug
                    // >>>>> Ping shadow
                    '&::before, &::after': {
                        position: 'absolute',
                        zIndex: 1,
                        opacity: 0,
                        transition: `opacity ${token.motionDurationSlow}`,
                        content: "''",
                        pointerEvents: 'none'
                    }
                },
                [`${componentCls}-nav-list`]: {
                    position: 'relative',
                    display: 'flex',
                    transition: `opacity ${token.motionDurationSlow}`
                },
                // >>>>>>>> Operations
                [`${componentCls}-nav-operations`]: {
                    display: 'flex',
                    alignSelf: 'stretch'
                },
                [`${componentCls}-nav-operations-hidden`]: {
                    position: 'absolute',
                    visibility: 'hidden',
                    pointerEvents: 'none'
                },
                [`${componentCls}-nav-more`]: {
                    position: 'relative',
                    padding: tabsCardPadding,
                    background: 'transparent',
                    border: 0,
                    color: token.colorText,
                    '&::after': {
                        position: 'absolute',
                        right: {
                            _skip_check_: true,
                            value: 0
                        },
                        bottom: 0,
                        left: {
                            _skip_check_: true,
                            value: 0
                        },
                        height: token.calc(token.controlHeightLG).div(8).equal(),
                        transform: 'translateY(100%)',
                        content: "''"
                    }
                },
                [`${componentCls}-nav-add`]: {
                    minWidth: cardHeight,
                    minHeight: cardHeight,
                    marginLeft: {
                        _skip_check_: true,
                        value: cardGutter
                    },
                    background: 'transparent',
                    border: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${colorBorderSecondary}`,
                    borderRadius: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.borderRadiusLG)} ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.borderRadiusLG)} 0 0`,
                    outline: 'none',
                    cursor: 'pointer',
                    color: token.colorText,
                    transition: `all ${token.motionDurationSlow} ${token.motionEaseInOut}`,
                    '&:hover': {
                        color: itemHoverColor
                    },
                    '&:active, &:focus:not(:focus-visible)': {
                        color: itemActiveColor
                    },
                    ...(0, $2f353af2b0f7600b$export$a44db842bcb28231)(token, -3)
                }
            },
            [`${componentCls}-extra-content`]: {
                flex: 'none'
            },
            // ============================ InkBar ============================
            [`${componentCls}-ink-bar`]: {
                position: 'absolute',
                background: token.inkBarColor,
                pointerEvents: 'none'
            },
            // ============================= Tabs =============================
            ...$b82e9cd206a94fb3$var$genTabStyle(token),
            // =========================== TabPanes ===========================
            [`${componentCls}-content`]: {
                position: 'relative',
                width: '100%'
            },
            [`${componentCls}-content-holder`]: {
                flex: 'auto',
                minWidth: 0,
                minHeight: 0
            },
            [`${componentCls}-tabpane`]: {
                ...(0, $2f353af2b0f7600b$export$a44db842bcb28231)(token),
                '&-hidden': {
                    display: 'none'
                }
            }
        },
        [`${componentCls}-centered`]: {
            [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                [`${componentCls}-nav-wrap`]: {
                    [`&:not([class*='${componentCls}-nav-wrap-ping']) > ${componentCls}-nav-list`]: {
                        margin: 'auto'
                    }
                }
            }
        }
    };
};
const $b82e9cd206a94fb3$export$9ca1be8807fe0675 = (token)=>{
    const { cardHeight: cardHeight, cardHeightSM: cardHeightSM, cardHeightLG: cardHeightLG, controlHeight: controlHeight, controlHeightLG: controlHeightLG } = token;
    const mergedCardHeight = cardHeight || controlHeightLG;
    const mergedCardHeightSM = cardHeightSM || controlHeight;
    // `controlHeight` missing XL variable, so we directly write it here:
    const mergedCardHeightLG = cardHeightLG || controlHeightLG + 8;
    return {
        zIndexPopup: token.zIndexPopupBase + 50,
        cardBg: token.colorFillAlter,
        // We can not pass this as valid value,
        // Since `cardHeight` will lock nav add button height.
        cardHeight: mergedCardHeight,
        cardHeightSM: mergedCardHeightSM,
        cardHeightLG: mergedCardHeightLG,
        // Initialize with empty string, because cardPadding will be calculated with cardHeight by default.
        cardPadding: `${(mergedCardHeight - token.fontHeight) / 2 - token.lineWidth}px ${token.padding}px`,
        cardPaddingSM: `${(mergedCardHeightSM - token.fontHeight) / 2 - token.lineWidth}px ${token.paddingXS}px`,
        cardPaddingLG: `${(mergedCardHeightLG - token.fontHeightLG) / 2 - token.lineWidth}px ${token.padding}px`,
        titleFontSize: token.fontSize,
        titleFontSizeLG: token.fontSizeLG,
        titleFontSizeSM: token.fontSize,
        inkBarColor: token.colorPrimary,
        horizontalMargin: `0 0 ${token.margin}px 0`,
        horizontalItemGutter: 32,
        // Fixed Value
        // Initialize with empty string, because horizontalItemMargin will be calculated with horizontalItemGutter by default.
        horizontalItemMargin: ``,
        horizontalItemMarginRTL: ``,
        horizontalItemPadding: `${token.paddingSM}px 0`,
        horizontalItemPaddingSM: `${token.paddingXS}px 0`,
        horizontalItemPaddingLG: `${token.padding}px 0`,
        verticalItemPadding: `${token.paddingXS}px ${token.paddingLG}px`,
        verticalItemMargin: `${token.margin}px 0 0 0`,
        itemColor: token.colorText,
        itemSelectedColor: token.colorPrimary,
        itemHoverColor: token.colorPrimaryHover,
        itemActiveColor: token.colorPrimaryActive,
        cardGutter: token.marginXXS / 2
    };
};
var // ============================== Export ==============================
$b82e9cd206a94fb3$export$2e2bcd8739ae039 = (0, $d4a2dc313c4d90a4$export$51ec95de45185b42)('Tabs', (token)=>{
    const tabsToken = (0, $90c11ca6cb263fd9$export$4950aa0f605343fb)(token, {
        // `cardPadding` is empty by default, so we could calculate with dynamic `cardHeight`
        tabsCardPadding: token.cardPadding,
        dropdownEdgeChildVerticalPadding: token.paddingXXS,
        tabsDropdownHeight: 200,
        tabsDropdownWidth: 120,
        tabsHorizontalItemMargin: `0 0 0 ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.horizontalItemGutter)}`,
        tabsHorizontalItemMarginRTL: `0 0 0 ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.horizontalItemGutter)}`
    });
    return [
        $b82e9cd206a94fb3$var$genSizeStyle(tabsToken),
        $b82e9cd206a94fb3$var$genRtlStyle(tabsToken),
        $b82e9cd206a94fb3$var$genPositionStyle(tabsToken),
        $b82e9cd206a94fb3$var$genDropdownStyle(tabsToken),
        $b82e9cd206a94fb3$var$genCardStyle(tabsToken),
        $b82e9cd206a94fb3$var$genTabsStyle(tabsToken),
        (0, $19384673e9a05575$export$2e2bcd8739ae039)(tabsToken)
    ];
}, $b82e9cd206a94fb3$export$9ca1be8807fe0675);


const $2223c5d991e8b3bc$var$TabPane = ()=>null;
var $2223c5d991e8b3bc$export$2e2bcd8739ae039 = $2223c5d991e8b3bc$var$TabPane;


"use client";
const $7fd9b07de4b86c85$var$InternalTabs = /*#__PURE__*/ $N3oW3.forwardRef((props, ref)=>{
    const { type: type, className: className, rootClassName: rootClassName, size: customSize, onEdit: onEdit, hideAdd: hideAdd, centered: centered, addIcon: addIcon, removeIcon: removeIcon, moreIcon: moreIcon, more: more, popupClassName: popupClassName, children: children, items: items, animated: animated, style: style, indicatorSize: indicatorSize, indicator: indicator, classNames: classNames, styles: styles, destroyInactiveTabPane: destroyInactiveTabPane, destroyOnHidden: destroyOnHidden, tabPlacement: tabPlacement, tabPosition: tabPosition, ...restProps } = props;
    const { prefixCls: customizePrefixCls } = restProps;
    const { getPrefixCls: getPrefixCls, direction: direction, getPopupContainer: getPopupContainer, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $dd01e2f5a4b8605d$export$46f4bd6436a25a31)('tabs');
    const { tabs: tabs } = $32rMB.useContext((0, $dd01e2f5a4b8605d$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('tabs', customizePrefixCls);
    const rootCls = (0, $54b1aecddbbbed4f$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $b82e9cd206a94fb3$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const tabsRef = $32rMB.useRef(null);
    $32rMB.useImperativeHandle(ref, ()=>({
            nativeElement: tabsRef.current
        }));
    let editable;
    if (type === 'editable-card') editable = {
        onEdit: (editType, { key: key, event: event })=>{
            onEdit?.(editType === 'add' ? event : key, editType);
        },
        removeIcon: removeIcon ?? tabs?.removeIcon ?? /*#__PURE__*/ $hO8yS.createElement((0, $bd33c75627fd73a4$export$2e2bcd8739ae039), null),
        addIcon: (addIcon ?? tabs?.addIcon) || /*#__PURE__*/ $hO8yS.createElement((0, $c6f0ed7390719aa1$export$2e2bcd8739ae039), null),
        showAdd: hideAdd !== true
    };
    const rootPrefixCls = getPrefixCls();
    var deprecatedName, newName, item;
    const size = (0, $324b30eda6ea1cd7$export$2e2bcd8739ae039)(customSize);
    const mergedItems = (0, $02d23f2476810785$export$2e2bcd8739ae039)(items, children);
    const mergedAnimated = (0, $f004adebb64c1056$export$2e2bcd8739ae039)(prefixCls, animated);
    const mergedIndicator = {
        align: indicator?.align ?? tabs?.indicator?.align,
        size: indicator?.size ?? indicatorSize ?? tabs?.indicator?.size ?? tabs?.indicatorSize
    };
    const mergedPlacement = $32rMB.useMemo(()=>{
        const placement = tabPlacement ?? tabPosition ?? undefined;
        const isRTL = direction === 'rtl';
        switch(placement){
            case 'start':
                return isRTL ? 'right' : 'left';
            case 'end':
                return isRTL ? 'left' : 'right';
            default:
                return placement;
        }
    }, [
        tabPlacement,
        tabPosition,
        direction
    ]);
    // =========== Merged Props for Semantic ===========
    const mergedProps = {
        ...props,
        size: size,
        tabPlacement: mergedPlacement,
        items: mergedItems
    };
    // ========================= Style ==========================
    const [mergedClassNames, mergedStyles] = (0, $4dcf69d8c3d6df5c$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    }, {
        popup: {
            _default: 'root'
        }
    });
    return /*#__PURE__*/ $hO8yS.createElement((0, $6fb86baa3180eeb6$export$2e2bcd8739ae039), {
        ref: tabsRef,
        direction: direction,
        getPopupContainer: getPopupContainer,
        ...restProps,
        items: mergedItems,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)({
            [`${prefixCls}-${size}`]: size,
            [`${prefixCls}-card`]: [
                'card',
                'editable-card'
            ].includes(type),
            [`${prefixCls}-editable-card`]: type === 'editable-card',
            [`${prefixCls}-centered`]: centered
        }, contextClassName, className, rootClassName, mergedClassNames.root, hashId, cssVarCls, rootCls),
        classNames: {
            ...mergedClassNames,
            popup: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(popupClassName, hashId, cssVarCls, rootCls, mergedClassNames.popup?.root)
        },
        styles: mergedStyles,
        style: {
            ...mergedStyles.root,
            ...contextStyle,
            ...style
        },
        editable: editable,
        more: {
            icon: tabs?.more?.icon ?? tabs?.moreIcon ?? moreIcon ?? /*#__PURE__*/ $hO8yS.createElement((0, $391e9221407e00e5$export$2e2bcd8739ae039), null),
            transitionName: `${rootPrefixCls}-slide-up`,
            ...more
        },
        prefixCls: prefixCls,
        animated: mergedAnimated,
        indicator: mergedIndicator,
        destroyOnHidden: destroyOnHidden ?? destroyInactiveTabPane,
        tabPosition: mergedPlacement
    });
});
const $7fd9b07de4b86c85$var$Tabs = $7fd9b07de4b86c85$var$InternalTabs;
$7fd9b07de4b86c85$var$Tabs.TabPane = (0, $2223c5d991e8b3bc$export$2e2bcd8739ae039);
var $7fd9b07de4b86c85$export$2e2bcd8739ae039 = $7fd9b07de4b86c85$var$Tabs;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");


"use client";
const $fdbd28c17c6254f3$var$Grid = ({ prefixCls: prefixCls, className: className, hoverable: hoverable = true, ...props })=>{
    const { getPrefixCls: getPrefixCls } = $32rMB.useContext((0, $dd01e2f5a4b8605d$export$a92f85ab3e9ad68b));
    const prefix = getPrefixCls('card', prefixCls);
    const classString = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefix}-grid`, className, {
        [`${prefix}-grid-hoverable`]: hoverable
    });
    return /*#__PURE__*/ $hO8yS.createElement("div", {
        ...props,
        className: classString
    });
};
var $fdbd28c17c6254f3$export$2e2bcd8739ae039 = $fdbd28c17c6254f3$var$Grid;





// ============================== Styles ==============================
// ============================== Head ==============================
const $01042f27299cf3d1$var$genCardHeadStyle = (token)=>{
    const { antCls: antCls, componentCls: componentCls, headerHeight: headerHeight, headerPadding: headerPadding, tabsMarginBottom: tabsMarginBottom } = token;
    return {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        minHeight: headerHeight,
        marginBottom: -1,
        // Fix card grid overflow bug: https://gw.alipayobjects.com/zos/rmsportal/XonYxBikwpgbqIQBeuhk.png
        padding: `0 ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(headerPadding)}`,
        color: token.colorTextHeading,
        fontWeight: token.fontWeightStrong,
        fontSize: token.headerFontSize,
        background: token.headerBg,
        borderBottom: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorderSecondary}`,
        borderRadius: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.borderRadiusLG)} ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.borderRadiusLG)} 0 0`,
        ...(0, $2f353af2b0f7600b$export$8c467e8859fdef13)(),
        '&-wrapper': {
            width: '100%',
            display: 'flex',
            alignItems: 'center'
        },
        '&-title': {
            display: 'inline-block',
            flex: 1,
            ...(0, $2f353af2b0f7600b$export$b2b65df0d0824629),
            [`
          > ${componentCls}-typography,
          > ${componentCls}-typography-edit-content
        `]: {
                insetInlineStart: 0,
                marginTop: 0,
                marginBottom: 0
            }
        },
        [`${antCls}-tabs-top`]: {
            clear: 'both',
            marginBottom: tabsMarginBottom,
            color: token.colorText,
            fontWeight: 'normal',
            fontSize: token.fontSize,
            '&-bar': {
                borderBottom: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorderSecondary}`
            }
        }
    };
};
// ============================== Grid ==============================
const $01042f27299cf3d1$var$genCardGridStyle = (token)=>{
    const { cardPaddingBase: cardPaddingBase, colorBorderSecondary: colorBorderSecondary, cardShadow: cardShadow, lineWidth: lineWidth } = token;
    return {
        width: '33.33%',
        padding: cardPaddingBase,
        border: 0,
        borderRadius: 0,
        boxShadow: `
      ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(lineWidth)} 0 0 0 ${colorBorderSecondary},
      0 ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(lineWidth)} 0 0 ${colorBorderSecondary},
      ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(lineWidth)} ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(lineWidth)} 0 0 ${colorBorderSecondary},
      ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(lineWidth)} 0 0 0 ${colorBorderSecondary} inset,
      0 ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(lineWidth)} 0 0 ${colorBorderSecondary} inset;
    `,
        transition: `all ${token.motionDurationMid}`,
        '&-hoverable:hover': {
            position: 'relative',
            zIndex: 1,
            boxShadow: cardShadow
        }
    };
};
// ============================== Actions ==============================
const $01042f27299cf3d1$var$genCardActionsStyle = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, actionsLiMargin: actionsLiMargin, cardActionsIconSize: cardActionsIconSize, colorBorderSecondary: colorBorderSecondary, actionsBg: actionsBg } = token;
    return {
        margin: 0,
        padding: 0,
        listStyle: 'none',
        background: actionsBg,
        borderTop: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${colorBorderSecondary}`,
        display: 'flex',
        borderRadius: `0 0 ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.borderRadiusLG)} ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.borderRadiusLG)}`,
        ...(0, $2f353af2b0f7600b$export$8c467e8859fdef13)(),
        '& > li': {
            margin: actionsLiMargin,
            color: token.colorTextDescription,
            textAlign: 'center',
            '> span': {
                position: 'relative',
                display: 'block',
                minWidth: token.calc(token.cardActionsIconSize).mul(2).equal(),
                fontSize: token.fontSize,
                lineHeight: token.lineHeight,
                cursor: 'pointer',
                '&:hover': {
                    color: token.colorPrimary,
                    transition: `color ${token.motionDurationMid}`
                },
                [`a:not(${componentCls}-btn), > ${iconCls}`]: {
                    display: 'inline-block',
                    width: '100%',
                    color: token.colorIcon,
                    lineHeight: (0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.fontHeight),
                    transition: `color ${token.motionDurationMid}`,
                    '&:hover': {
                        color: token.colorPrimary
                    }
                },
                [`> ${iconCls}`]: {
                    fontSize: cardActionsIconSize,
                    lineHeight: (0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.calc(cardActionsIconSize).mul(token.lineHeight).equal())
                }
            },
            '&:not(:last-child)': {
                borderInlineEnd: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${colorBorderSecondary}`
            }
        }
    };
};
// ============================== Meta ==============================
const $01042f27299cf3d1$var$genCardMetaStyle = (token)=>({
        margin: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.calc(token.marginXXS).mul(-1).equal())} 0`,
        display: 'flex',
        ...(0, $2f353af2b0f7600b$export$8c467e8859fdef13)(),
        '&-avatar': {
            paddingInlineEnd: token.padding
        },
        '&-section': {
            overflow: 'hidden',
            flex: 1,
            '> div:not(:last-child)': {
                marginBottom: token.marginXS
            }
        },
        '&-title': {
            color: token.colorTextHeading,
            fontWeight: token.fontWeightStrong,
            fontSize: token.fontSizeLG,
            ...(0, $2f353af2b0f7600b$export$b2b65df0d0824629)
        },
        '&-description': {
            color: token.colorTextDescription
        }
    });
// ============================== Inner ==============================
const $01042f27299cf3d1$var$genCardTypeInnerStyle = (token)=>{
    const { componentCls: componentCls, colorFillAlter: colorFillAlter, headerPadding: headerPadding, bodyPadding: bodyPadding } = token;
    return {
        [`${componentCls}-head`]: {
            padding: `0 ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(headerPadding)}`,
            background: colorFillAlter,
            '&-title': {
                fontSize: token.fontSize
            }
        },
        [`${componentCls}-body`]: {
            padding: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.padding)} ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(bodyPadding)}`
        }
    };
};
// ============================== Loading ==============================
const $01042f27299cf3d1$var$genCardLoadingStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        overflow: 'hidden',
        [`${componentCls}-body`]: {
            userSelect: 'none'
        }
    };
};
// ============================== Basic ==============================
const $01042f27299cf3d1$var$genCardStyle = (token)=>{
    const { componentCls: componentCls, cardShadow: cardShadow, cardHeadPadding: cardHeadPadding, colorBorderSecondary: colorBorderSecondary, boxShadowTertiary: boxShadowTertiary, bodyPadding: bodyPadding, extraColor: extraColor } = token;
    return {
        [componentCls]: {
            ...(0, $2f353af2b0f7600b$export$23997c3e44cc1c59)(token),
            position: 'relative',
            background: token.colorBgContainer,
            borderRadius: token.borderRadiusLG,
            [`&:not(${componentCls}-bordered)`]: {
                boxShadow: boxShadowTertiary
            },
            [`${componentCls}-head`]: $01042f27299cf3d1$var$genCardHeadStyle(token),
            [`${componentCls}-extra`]: {
                // https://stackoverflow.com/a/22429853/3040605
                marginInlineStart: 'auto',
                color: extraColor,
                fontWeight: 'normal',
                fontSize: token.fontSize
            },
            [`${componentCls}-body`]: {
                padding: bodyPadding,
                borderRadius: `0 0 ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.borderRadiusLG)} ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.borderRadiusLG)}`
            },
            [`${componentCls}-grid`]: $01042f27299cf3d1$var$genCardGridStyle(token),
            [`${componentCls}-cover`]: {
                '> *': {
                    display: 'block',
                    width: '100%',
                    borderRadius: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.borderRadiusLG)} ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.borderRadiusLG)} 0 0`
                }
            },
            [`${componentCls}-actions`]: $01042f27299cf3d1$var$genCardActionsStyle(token),
            [`${componentCls}-meta`]: $01042f27299cf3d1$var$genCardMetaStyle(token)
        },
        [`${componentCls}-bordered`]: {
            border: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${colorBorderSecondary}`,
            [`${componentCls}-cover`]: {
                marginTop: -1,
                marginInlineStart: -1,
                marginInlineEnd: -1
            }
        },
        [`${componentCls}-hoverable`]: {
            cursor: 'pointer',
            transition: `box-shadow ${token.motionDurationMid}, border-color ${token.motionDurationMid}`,
            '&:hover': {
                borderColor: 'transparent',
                boxShadow: cardShadow
            }
        },
        [`${componentCls}-contain-grid`]: {
            borderRadius: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.borderRadiusLG)} ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.borderRadiusLG)} 0 0 `,
            [`${componentCls}-body`]: {
                display: 'flex',
                flexWrap: 'wrap'
            },
            [`&:not(${componentCls}-loading) ${componentCls}-body`]: {
                marginBlockStart: token.calc(token.lineWidth).mul(-1).equal(),
                marginInlineStart: token.calc(token.lineWidth).mul(-1).equal(),
                padding: 0
            }
        },
        [`${componentCls}-contain-tabs`]: {
            [`> div${componentCls}-head`]: {
                minHeight: 0,
                [`${componentCls}-head-title, ${componentCls}-extra`]: {
                    paddingTop: cardHeadPadding
                }
            }
        },
        [`${componentCls}-type-inner`]: $01042f27299cf3d1$var$genCardTypeInnerStyle(token),
        [`${componentCls}-loading`]: $01042f27299cf3d1$var$genCardLoadingStyle(token),
        [`${componentCls}-rtl`]: {
            direction: 'rtl'
        }
    };
};
// ============================== Size ==============================
const $01042f27299cf3d1$var$genCardSizeStyle = (token)=>{
    const { componentCls: componentCls, bodyPaddingSM: bodyPaddingSM, headerPaddingSM: headerPaddingSM, headerHeightSM: headerHeightSM, headerFontSizeSM: headerFontSizeSM } = token;
    return {
        [`${componentCls}-small`]: {
            [`> ${componentCls}-head`]: {
                minHeight: headerHeightSM,
                padding: `0 ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(headerPaddingSM)}`,
                fontSize: headerFontSizeSM,
                [`> ${componentCls}-head-wrapper`]: {
                    [`> ${componentCls}-extra`]: {
                        fontSize: token.fontSize
                    }
                }
            },
            [`> ${componentCls}-body`]: {
                padding: bodyPaddingSM
            }
        },
        [`${componentCls}-small${componentCls}-contain-tabs`]: {
            [`> ${componentCls}-head`]: {
                [`${componentCls}-head-title, ${componentCls}-extra`]: {
                    paddingTop: 0,
                    display: 'flex',
                    alignItems: 'center'
                }
            }
        }
    };
};
const $01042f27299cf3d1$export$9ca1be8807fe0675 = (token)=>({
        headerBg: 'transparent',
        headerFontSize: token.fontSizeLG,
        headerFontSizeSM: token.fontSize,
        headerHeight: token.fontSizeLG * token.lineHeightLG + token.padding * 2,
        headerHeightSM: token.fontSize * token.lineHeight + token.paddingXS * 2,
        actionsBg: token.colorBgContainer,
        actionsLiMargin: `${token.paddingSM}px 0`,
        tabsMarginBottom: -token.padding - token.lineWidth,
        extraColor: token.colorText,
        bodyPaddingSM: 12,
        // Fixed padding.
        headerPaddingSM: 12,
        bodyPadding: token.bodyPadding ?? token.paddingLG,
        headerPadding: token.headerPadding ?? token.paddingLG
    });
var // ============================== Export ==============================
$01042f27299cf3d1$export$2e2bcd8739ae039 = (0, $d4a2dc313c4d90a4$export$51ec95de45185b42)('Card', (token)=>{
    const cardToken = (0, $90c11ca6cb263fd9$export$4950aa0f605343fb)(token, {
        cardShadow: token.boxShadowCard,
        cardHeadPadding: token.padding,
        cardPaddingBase: token.paddingLG,
        cardActionsIconSize: token.fontSize
    });
    return [
        // Style
        $01042f27299cf3d1$var$genCardStyle(cardToken),
        // Size
        $01042f27299cf3d1$var$genCardSizeStyle(cardToken)
    ];
}, $01042f27299cf3d1$export$9ca1be8807fe0675);


"use client";
const $6f39b49de50de7fc$var$ActionNode = (props)=>{
    const { actionClasses: actionClasses, actions: actions = [], actionStyle: actionStyle } = props;
    return /*#__PURE__*/ $hO8yS.createElement("ul", {
        className: actionClasses,
        style: actionStyle
    }, actions.map((action, index)=>{
        // Move this out since eslint not allow index key
        // And eslint-disable makes conflict with rollup
        // ref https://github.com/ant-design/ant-design/issues/46022
        const key = `action-${index}`;
        return /*#__PURE__*/ $hO8yS.createElement("li", {
            style: {
                width: `${100 / actions.length}%`
            },
            key: key
        }, /*#__PURE__*/ $hO8yS.createElement("span", null, action));
    }));
};
const $6f39b49de50de7fc$var$Card = /*#__PURE__*/ $N3oW3.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, style: style, extra: extra, headStyle: headStyle = {}, bodyStyle: bodyStyle = {}, title: title, loading: loading, bordered: bordered, variant: customVariant, size: customizeSize, type: type, cover: cover, actions: actions, tabList: tabList, children: children, activeTabKey: activeTabKey, defaultActiveTabKey: defaultActiveTabKey, tabBarExtraContent: tabBarExtraContent, hoverable: hoverable, tabProps: tabProps = {}, classNames: classNames, styles: styles, ...rest } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $dd01e2f5a4b8605d$export$46f4bd6436a25a31)('card');
    const [variant] = (0, $b3bf3719877c7ee9$export$2e2bcd8739ae039)('card', customVariant, bordered);
    const mergedSize = (0, $324b30eda6ea1cd7$export$2e2bcd8739ae039)(customizeSize);
    // =========== Merged Props for Semantic ==========
    const mergedProps = {
        ...props,
        size: mergedSize,
        variant: variant,
        loading: loading
    };
    const [mergedClassNames, mergedStyles] = (0, $4dcf69d8c3d6df5c$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    var deprecatedName, newName;
    const onTabChange = (key)=>{
        props.onTabChange?.(key);
    };
    const isContainGrid = $32rMB.useMemo(()=>{
        const childNodes = (0, $a60ede783f74e6a9$export$2e2bcd8739ae039)(children);
        return childNodes.some((child)=>/*#__PURE__*/ $N3oW3.isValidElement(child) && child.type === (0, $fdbd28c17c6254f3$export$2e2bcd8739ae039));
    }, [
        children
    ]);
    const prefixCls = getPrefixCls('card', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $01042f27299cf3d1$export$2e2bcd8739ae039)(prefixCls);
    const loadingBlock = /*#__PURE__*/ $hO8yS.createElement((0, $3791c33551ab7576$export$2e2bcd8739ae039), {
        loading: true,
        active: true,
        paragraph: {
            rows: 4
        },
        title: false
    }, children);
    const hasActiveTabKey = activeTabKey !== undefined;
    const extraProps = {
        ...tabProps,
        [hasActiveTabKey ? 'activeKey' : 'defaultActiveKey']: hasActiveTabKey ? activeTabKey : defaultActiveTabKey,
        tabBarExtraContent: tabBarExtraContent
    };
    let head;
    const tabSize = !mergedSize || mergedSize === 'default' ? 'large' : mergedSize;
    const tabs = tabList ? /*#__PURE__*/ $hO8yS.createElement((0, $7fd9b07de4b86c85$export$2e2bcd8739ae039), {
        size: tabSize,
        ...extraProps,
        className: `${prefixCls}-head-tabs`,
        onChange: onTabChange,
        items: tabList.map(({ tab: tab, ...item })=>({
                label: tab,
                ...item
            }))
    }) : null;
    if (title || extra || tabs) {
        const headClasses = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-head`, mergedClassNames.header);
        const titleClasses = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-head-title`, mergedClassNames.title);
        const extraClasses = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-extra`, mergedClassNames.extra);
        const mergedHeadStyle = {
            ...headStyle,
            ...mergedStyles.header
        };
        head = /*#__PURE__*/ $hO8yS.createElement("div", {
            className: headClasses,
            style: mergedHeadStyle
        }, /*#__PURE__*/ $hO8yS.createElement("div", {
            className: `${prefixCls}-head-wrapper`
        }, title && /*#__PURE__*/ $hO8yS.createElement("div", {
            className: titleClasses,
            style: mergedStyles.title
        }, title), extra && /*#__PURE__*/ $hO8yS.createElement("div", {
            className: extraClasses,
            style: mergedStyles.extra
        }, extra)), tabs);
    }
    const coverClasses = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-cover`, mergedClassNames.cover);
    const coverDom = cover ? /*#__PURE__*/ $hO8yS.createElement("div", {
        className: coverClasses,
        style: mergedStyles.cover
    }, cover) : null;
    const bodyClasses = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-body`, mergedClassNames.body);
    const mergedBodyStyle = {
        ...bodyStyle,
        ...mergedStyles.body
    };
    const body = /*#__PURE__*/ $hO8yS.createElement("div", {
        className: bodyClasses,
        style: mergedBodyStyle
    }, loading ? loadingBlock : children);
    const actionClasses = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-actions`, mergedClassNames.actions);
    const actionDom = actions?.length ? /*#__PURE__*/ $hO8yS.createElement($6f39b49de50de7fc$var$ActionNode, {
        actionClasses: actionClasses,
        actionStyle: mergedStyles.actions,
        actions: actions
    }) : null;
    const divProps = (0, $f4cf9c2e27c0ac8d$export$2e2bcd8739ae039)(rest, [
        'onTabChange'
    ]);
    const classString = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, contextClassName, {
        [`${prefixCls}-loading`]: loading,
        [`${prefixCls}-bordered`]: variant !== 'borderless',
        [`${prefixCls}-hoverable`]: hoverable,
        [`${prefixCls}-contain-grid`]: isContainGrid,
        [`${prefixCls}-contain-tabs`]: tabList?.length,
        [`${prefixCls}-${mergedSize}`]: mergedSize,
        [`${prefixCls}-type-${type}`]: !!type,
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, className, rootClassName, hashId, cssVarCls, mergedClassNames.root);
    const mergedStyle = {
        ...mergedStyles.root,
        ...contextStyle,
        ...style
    };
    return /*#__PURE__*/ $hO8yS.createElement("div", {
        ref: ref,
        ...divProps,
        className: classString,
        style: mergedStyle
    }, head, coverDom, body, actionDom);
});
var $6f39b49de50de7fc$export$2e2bcd8739ae039 = $6f39b49de50de7fc$var$Card;



parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");



"use client";
const $4b7726f0cf2c4df6$var$Meta = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, avatar: avatar, title: title, description: description, style: style, classNames: cardMetaClassNames, styles: styles, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $dd01e2f5a4b8605d$export$46f4bd6436a25a31)('cardMeta');
    const prefixCls = getPrefixCls('card', customizePrefixCls);
    const metaPrefixCls = `${prefixCls}-meta`;
    const [mergedClassNames, mergedStyles] = (0, $4dcf69d8c3d6df5c$export$648566b068f28737)([
        contextClassNames,
        cardMetaClassNames
    ], [
        contextStyles,
        styles
    ], {
        props: props
    });
    const rootClassNames = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(metaPrefixCls, className, contextClassName, mergedClassNames.root);
    const rootStyles = {
        ...contextStyle,
        ...mergedStyles.root,
        ...style
    };
    const avatarClassNames = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${metaPrefixCls}-avatar`, mergedClassNames.avatar);
    const titleClassNames = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${metaPrefixCls}-title`, mergedClassNames.title);
    const descriptionClassNames = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${metaPrefixCls}-description`, mergedClassNames.description);
    const sectionClassNames = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${metaPrefixCls}-section`, mergedClassNames.section);
    const avatarDom = avatar ? /*#__PURE__*/ $hO8yS.createElement("div", {
        className: avatarClassNames,
        style: mergedStyles.avatar
    }, avatar) : null;
    const titleDom = title ? /*#__PURE__*/ $hO8yS.createElement("div", {
        className: titleClassNames,
        style: mergedStyles.title
    }, title) : null;
    const descriptionDom = description ? /*#__PURE__*/ $hO8yS.createElement("div", {
        className: descriptionClassNames,
        style: mergedStyles.description
    }, description) : null;
    const MetaDetail = titleDom || descriptionDom ? /*#__PURE__*/ $hO8yS.createElement("div", {
        className: sectionClassNames,
        style: mergedStyles.section
    }, titleDom, descriptionDom) : null;
    return /*#__PURE__*/ $hO8yS.createElement("div", {
        ...restProps,
        className: rootClassNames,
        style: rootStyles
    }, avatarDom, MetaDetail);
};
var $4b7726f0cf2c4df6$export$2e2bcd8739ae039 = $4b7726f0cf2c4df6$var$Meta;


"use client";
const $cc75ec4a4b973a53$var$Card = (0, $6f39b49de50de7fc$export$2e2bcd8739ae039);
$cc75ec4a4b973a53$var$Card.Grid = (0, $fdbd28c17c6254f3$export$2e2bcd8739ae039);
$cc75ec4a4b973a53$var$Card.Meta = (0, $4b7726f0cf2c4df6$export$2e2bcd8739ae039);
var $cc75ec4a4b973a53$export$2e2bcd8739ae039 = $cc75ec4a4b973a53$var$Card;


"use client";
var $0205b0ed259f812c$export$2e2bcd8739ae039 = (0, $b0392451a324479a$export$2e2bcd8739ae039);


"use client";
var $f16d0e5c621bcbb8$export$2e2bcd8739ae039 = (0, $1034cd2d0d871af4$export$2e2bcd8739ae039);



parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");



const $81aeefb8b9dacfc2$var$$ed859e9f463198da$var$HooksWrapper = ({ ClassComponent: ClassComponent })=>{
    const location = (0, $dbfbcf83869c9c18$export$45d76561a5302f2b)(), params = (0, $dbfbcf83869c9c18$export$99eaa27ddbbb95ef)();
    const { pathname: pathname = '/', search: search = '', hash: hash = '' } = location;
    const path = pathname + search + hash;
    const match = {
        url: globalThis.location.origin + path,
        path: path,
        params: params
    }, query = (0, $fbe6f1e2fed97fc7$export$eb9b2aadbe449a20)(search);
    return (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)(ClassComponent, {
        location: location,
        match: match,
        query: query
    });
};
const $81aeefb8b9dacfc2$export$369b6b2b30582e8e = (Class, context)=>class ComponentWithRouter extends Class {
        static{
            this.WrappedComponent = Class;
        }
        static{
            this.displayName = `withRouter(${Class.displayName || Class.name})`;
        }
        static getDerivedStateFromProps(nextProps, prevState) {
            return {};
        }
        static getDerivedStateFromError(error) {}
        componentDidMount() {}
        getSnapshotBeforeUpdate(prevProps, prevState) {}
        shouldComponentUpdate(nextProps, nextState, nextContext) {
            return true;
        }
        componentDidUpdate(prevProps, prevState, snapshot) {}
        componentDidCatch(error, errorInfo) {}
        componentWillUnmount() {}
        render() {
            return (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($81aeefb8b9dacfc2$var$$ed859e9f463198da$var$HooksWrapper, {
                ClassComponent: Class
            });
        }
        constructor(...args){
            super(...args), this.state = {};
        }
    };



var $d5I5D = parcelRequire("d5I5D");

function $31c1ac8f3ecbd352$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $31c1ac8f3ecbd352$var$$eef213ff4197108b$exports = {};
$31c1ac8f3ecbd352$var$$parcel$export($31c1ac8f3ecbd352$var$$eef213ff4197108b$exports, "Stack", function() {
    return $31c1ac8f3ecbd352$export$694e0d28c7ffc90c;
});
const { push: $31c1ac8f3ecbd352$var$$eef213ff4197108b$var$push } = Array.prototype;
class $31c1ac8f3ecbd352$export$694e0d28c7ffc90c {
    use(...middlewares) {
        $31c1ac8f3ecbd352$var$$eef213ff4197108b$var$push.apply(this, middlewares);
        return this;
    }
    execute(context, depth = 0) {
        const middleware = this[depth];
        if (middleware instanceof Function) return middleware(context, this.execute.bind(this, context, ++depth));
    }
    mount(condition, stack) {
        return this.use((context, next)=>condition(context) ? stack.execute(context) : next());
    }
    constructor(){
        this.length = 0;
    }
}
var $31c1ac8f3ecbd352$var$$0fe1f1400993ba8a$exports = {};
$31c1ac8f3ecbd352$var$$parcel$export($31c1ac8f3ecbd352$var$$0fe1f1400993ba8a$exports, "BodyRequestMethods", function() {
    return $31c1ac8f3ecbd352$export$4125cfe7e08e2040;
});
$31c1ac8f3ecbd352$var$$parcel$export($31c1ac8f3ecbd352$var$$0fe1f1400993ba8a$exports, "HTTPError", function() {
    return $31c1ac8f3ecbd352$export$aa9d629c530f62a7;
});
$31c1ac8f3ecbd352$var$$parcel$export($31c1ac8f3ecbd352$var$$0fe1f1400993ba8a$exports, "headerParser", function() {
    return $31c1ac8f3ecbd352$export$b725a69477e4d33f;
});
$31c1ac8f3ecbd352$var$$parcel$export($31c1ac8f3ecbd352$var$$0fe1f1400993ba8a$exports, "parseHeaders", function() {
    return $31c1ac8f3ecbd352$export$eea2c1c5e1a37e50;
});
$31c1ac8f3ecbd352$var$$parcel$export($31c1ac8f3ecbd352$var$$0fe1f1400993ba8a$exports, "parseBody", function() {
    return $31c1ac8f3ecbd352$export$3b629cd0ff482602;
});
$31c1ac8f3ecbd352$var$$parcel$export($31c1ac8f3ecbd352$var$$0fe1f1400993ba8a$exports, "requestXHR", function() {
    return $31c1ac8f3ecbd352$export$4f2a8c8c11a6373a;
});
$31c1ac8f3ecbd352$var$$parcel$export($31c1ac8f3ecbd352$var$$0fe1f1400993ba8a$exports, "requestFetch", function() {
    return $31c1ac8f3ecbd352$export$bda27a3e49197b9;
});
$31c1ac8f3ecbd352$var$$parcel$export($31c1ac8f3ecbd352$var$$0fe1f1400993ba8a$exports, "parseResponse", function() {
    return $31c1ac8f3ecbd352$export$ba14d9a5a581e827;
});
$31c1ac8f3ecbd352$var$$parcel$export($31c1ac8f3ecbd352$var$$0fe1f1400993ba8a$exports, "parseFetchBody", function() {
    return $31c1ac8f3ecbd352$export$b7b86d31099674dc;
});
$31c1ac8f3ecbd352$var$$parcel$export($31c1ac8f3ecbd352$var$$0fe1f1400993ba8a$exports, "request", function() {
    return $31c1ac8f3ecbd352$export$b5fe3f66a567bec0;
});
var $31c1ac8f3ecbd352$var$$22de11b45b0eeb97$exports = {};
$31c1ac8f3ecbd352$var$$parcel$export($31c1ac8f3ecbd352$var$$22de11b45b0eeb97$exports, "polyfillProgressEvent", function() {
    return $31c1ac8f3ecbd352$export$5e6a03ce7b01784;
});
$31c1ac8f3ecbd352$var$$parcel$export($31c1ac8f3ecbd352$var$$22de11b45b0eeb97$exports, "parseDocument", function() {
    return $31c1ac8f3ecbd352$export$b6a9369736b19f4d;
});
$31c1ac8f3ecbd352$var$$parcel$export($31c1ac8f3ecbd352$var$$22de11b45b0eeb97$exports, "makeFormData", function() {
    return $31c1ac8f3ecbd352$export$2c28ab2e118e73f1;
});
$31c1ac8f3ecbd352$var$$parcel$export($31c1ac8f3ecbd352$var$$22de11b45b0eeb97$exports, "serializeNode", function() {
    return $31c1ac8f3ecbd352$export$a0beee2e55fb5dd1;
});
$31c1ac8f3ecbd352$var$$parcel$export($31c1ac8f3ecbd352$var$$22de11b45b0eeb97$exports, "serialize", function() {
    return $31c1ac8f3ecbd352$export$dfdc1655ccc5b9cb;
});
$31c1ac8f3ecbd352$var$$parcel$export($31c1ac8f3ecbd352$var$$22de11b45b0eeb97$exports, "streamFromProgress", function() {
    return $31c1ac8f3ecbd352$export$f8162fcba31fa547;
});
$31c1ac8f3ecbd352$var$$parcel$export($31c1ac8f3ecbd352$var$$22de11b45b0eeb97$exports, "emitStreamProgress", function() {
    return $31c1ac8f3ecbd352$export$cebfdbc318a33abe;
});
$31c1ac8f3ecbd352$var$$parcel$export($31c1ac8f3ecbd352$var$$22de11b45b0eeb97$exports, "FileMethod", function() {
    return $31c1ac8f3ecbd352$export$226b21d2db5eaf9f;
});
$31c1ac8f3ecbd352$var$$parcel$export($31c1ac8f3ecbd352$var$$22de11b45b0eeb97$exports, "readAs", function() {
    return $31c1ac8f3ecbd352$export$e209cbb66c5b18c;
});
$31c1ac8f3ecbd352$var$$parcel$export($31c1ac8f3ecbd352$var$$22de11b45b0eeb97$exports, "encodeBase64", function() {
    return $31c1ac8f3ecbd352$export$8fb536984ec8b4d7;
});
function $31c1ac8f3ecbd352$export$5e6a03ce7b01784() {
    return globalThis.ProgressEvent ||= class ProgressEvent1 extends Event {
        constructor(type, { lengthComputable: lengthComputable, total: total, loaded: loaded, ...meta } = {}){
            super(type, meta);
            this.lengthComputable = lengthComputable;
            this.total = total;
            this.loaded = loaded;
        }
    };
}
async function $31c1ac8f3ecbd352$export$b6a9369736b19f4d(text, contentType = '') {
    const [type] = contentType?.split(';') || [];
    return new DOMParser().parseFromString(text, type || 'text/html');
}
function $31c1ac8f3ecbd352$export$2c28ab2e118e73f1(data) {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)){
        const list = typeof value !== 'string' && (0, $fbe6f1e2fed97fc7$export$b5a4d6f439a5044d)(value) ? value : [
            value
        ];
        for (const item of Array.from(list))if (item != null) {
            if (typeof item === 'object') formData.append(key, item, item.name);
            else formData.append(key, item);
        }
    }
    return formData;
}
function $31c1ac8f3ecbd352$export$a0beee2e55fb5dd1(root) {
    var contentType;
    if (!(root instanceof HTMLFormElement)) return {
        contentType: root instanceof SVGElement ? 'image/svg' : root instanceof Document || root instanceof HTMLElement ? 'text/html' : 'application/xml',
        data: (0, $fbe6f1e2fed97fc7$export$b0709844452f8b6b)(root)
    };
    if (root.querySelector('input[type="file"][name]')) return {
        contentType: 'multipart/form-data',
        data: new FormData(root)
    };
    const data = (0, $fbe6f1e2fed97fc7$export$86d7c59254d6a2c9)(root);
    switch(contentType = root.enctype){
        case 'text/plain':
            return {
                contentType: contentType,
                data: Object.entries(data).map(([name, value])=>`${name}=${value}`).join('\n')
            };
        case 'application/x-www-form-urlencoded':
            return {
                contentType: contentType,
                data: new URLSearchParams(data)
            };
        default:
            return {
                contentType: 'application/json',
                data: JSON.stringify(data)
            };
    }
}
function $31c1ac8f3ecbd352$export$dfdc1655ccc5b9cb(data, contentType) {
    const [type] = contentType?.split(';') || [];
    switch(type){
        case 'application/x-www-form-urlencoded':
            return {
                contentType: contentType,
                data: new URLSearchParams(data)
            };
        case 'multipart/form-data':
            return {
                data: $31c1ac8f3ecbd352$export$2c28ab2e118e73f1(data)
            };
        case 'application/json':
            return {
                contentType: contentType,
                data: JSON.stringify(data)
            };
        case 'text/html':
        case 'application/xml':
        case 'image/svg':
            return {
                contentType: contentType,
                data: (0, $fbe6f1e2fed97fc7$export$b0709844452f8b6b)(data)
            };
    }
    if (type) return {
        data: data,
        contentType: contentType
    };
    try {
        if (data instanceof URLSearchParams) return {
            contentType: 'application/x-www-form-urlencoded',
            data: data
        };
    } catch  {}
    try {
        if (data instanceof FormData) return {
            data: data
        };
    } catch  {}
    try {
        if (data instanceof Node) return $31c1ac8f3ecbd352$export$a0beee2e55fb5dd1(data);
    } catch  {}
    try {
        if ((0, $fbe6f1e2fed97fc7$export$b119cc7e1840e59c)(data) || data instanceof ArrayBuffer || data instanceof DataView || data instanceof Blob || data instanceof ReadableStream) return {
            contentType: 'application/octet-stream',
            data: data
        };
    } catch  {}
    try {
        return {
            contentType: 'application/json',
            data: JSON.stringify(data)
        };
    } catch  {}
    throw new Error('Unserialized Object needs a specific Content-Type');
}
const $31c1ac8f3ecbd352$export$f8162fcba31fa547 = (target)=>(0, $fbe6f1e2fed97fc7$export$86c18c6347f4a8c4)(({ next: next, complete: complete, error: error })=>{
        const handleProgress = ({ loaded: loaded, total: total })=>{
            next({
                loaded: loaded,
                total: total
            });
            if (loaded >= total) complete();
        };
        target.addEventListener('progress', handleProgress);
        target.addEventListener('error', error);
        return ()=>{
            target.removeEventListener('progress', handleProgress);
            target.removeEventListener('error', error);
        };
    });
async function* $31c1ac8f3ecbd352$export$cebfdbc318a33abe(stream, total, eventTarget) {
    var loaded = 0;
    $31c1ac8f3ecbd352$export$5e6a03ce7b01784();
    for await (const chunk of stream){
        yield chunk;
        loaded += chunk.byteLength;
        const event = new ProgressEvent('progress', {
            lengthComputable: isNaN(total),
            loaded: loaded,
            total: total
        });
        eventTarget.dispatchEvent(event);
    }
}
var $31c1ac8f3ecbd352$export$226b21d2db5eaf9f = /*#__PURE__*/ function(FileMethod) {
    FileMethod["text"] = "readAsText";
    FileMethod["dataURL"] = "readAsDataURL";
    FileMethod["binaryString"] = "readAsBinaryString";
    FileMethod["arrayBuffer"] = "readAsArrayBuffer";
    return FileMethod;
}({});
function $31c1ac8f3ecbd352$export$e209cbb66c5b18c(file, method, encoding) {
    const reader = new FileReader();
    const result = new Promise((resolve, reject)=>{
        reader.onerror = reject;
        reader.onload = ()=>resolve(reader.result);
        reader[$31c1ac8f3ecbd352$export$226b21d2db5eaf9f[method]](file, encoding);
    });
    return {
        progress: $31c1ac8f3ecbd352$export$f8162fcba31fa547(reader),
        result: result
    };
}
const $31c1ac8f3ecbd352$var$$22de11b45b0eeb97$var$DataURI = /^data:(.+?\/(.+?))?(;base64)?,([\s\S]+)/;
async function $31c1ac8f3ecbd352$export$8fb536984ec8b4d7(raw) {
    if (raw instanceof Blob) {
        const text = await $31c1ac8f3ecbd352$export$e209cbb66c5b18c(raw, 'dataURL').result;
        return ($31c1ac8f3ecbd352$var$$22de11b45b0eeb97$var$DataURI.exec(text) || '')[4];
    }
    const text = encodeURIComponent(raw).replace(/%([0-9A-F]{2})/g, (_, p1)=>String.fromCharCode(+('0x' + p1)));
    return btoa(text);
}
var $31c1ac8f3ecbd352$export$4125cfe7e08e2040 = /*#__PURE__*/ function(BodyRequestMethods) {
    BodyRequestMethods["POST"] = "POST";
    BodyRequestMethods["PUT"] = "PUT";
    BodyRequestMethods["PATCH"] = "PATCH";
    BodyRequestMethods["DELETE"] = "DELETE";
    return BodyRequestMethods;
}({});
class $31c1ac8f3ecbd352$export$aa9d629c530f62a7 extends URIError {
    constructor(message, request, response){
        super(message), this.request = request, this.response = response;
    }
}
const $31c1ac8f3ecbd352$export$b725a69477e4d33f = {
    Link: (value)=>Object.fromEntries(Array.from(value.matchAll(/<(\S+?)>; rel="(\w+)"(?:; title="(.*?)")?/g), ([_, URI, rel, title])=>[
                rel,
                {
                    rel: rel,
                    URI: URI,
                    title: title
                }
            ]))
};
const $31c1ac8f3ecbd352$export$eea2c1c5e1a37e50 = (raw)=>Object.fromEntries(Array.from(raw.trim().matchAll(/^([\w-]+):\s*(.*)/gm), ([_, key, value])=>{
        key = key.replace(/(^[a-z]|-[a-z])/g, (char)=>char.toUpperCase());
        return [
            key,
            $31c1ac8f3ecbd352$export$b725a69477e4d33f[key]?.(value) ?? value
        ];
    }));
function $31c1ac8f3ecbd352$export$3b629cd0ff482602(raw, contentType) {
    if (contentType.includes('json')) return (0, $fbe6f1e2fed97fc7$export$27924e57e9afff7f)(raw);
    if (contentType.match(/html|xml/)) try {
        return $31c1ac8f3ecbd352$export$b6a9369736b19f4d(raw, contentType);
    } catch  {}
    if (contentType.includes('text')) return raw;
    return new TextEncoder().encode(raw).buffer;
}
function $31c1ac8f3ecbd352$export$4f2a8c8c11a6373a({ method: method = 'GET', path: path, headers: headers = {}, body: body, signal: signal, ...rest }) {
    const request = new XMLHttpRequest();
    const header = new Headers(headers);
    const bodyPromise = body instanceof globalThis.ReadableStream ? Array.fromAsync(body).then((parts)=>new Blob(parts)) : Promise.resolve(body);
    const abort = ()=>request.abort();
    signal?.addEventListener('abort', abort);
    const response = new Promise((resolve, reject)=>{
        request.onreadystatechange = ()=>{
            const { readyState: readyState, status: status, statusText: statusText, responseType: responseType } = request;
            if (readyState !== 4 || !status && !signal?.aborted) return;
            resolve({
                status: status,
                statusText: statusText,
                headers: $31c1ac8f3ecbd352$export$eea2c1c5e1a37e50(request.getAllResponseHeaders()),
                body: responseType && responseType !== 'text' ? request.response : request.responseText
            });
        };
        request.onerror = request.ontimeout = reject;
        const [MIMEType] = header.get('Accept')?.split(',') || [
            rest.responseType === 'document' ? 'application/xhtml+xml' : rest.responseType === 'json' ? 'application/json' : ''
        ];
        if (MIMEType) request.overrideMimeType(MIMEType);
        request.open(method, path + '');
        for (const [key, value] of header)request.setRequestHeader(key, value);
        Object.assign(request, rest);
        bodyPromise.then((body)=>request.send(body));
    }).then(({ body: body, ...meta })=>{
        signal?.throwIfAborted();
        const contentType = request.getResponseHeader('Content-Type') || '';
        if (typeof body === 'string' && !contentType.includes('text')) body = $31c1ac8f3ecbd352$export$3b629cd0ff482602(body, contentType);
        return {
            ...meta,
            body: body
        };
    });
    response.finally(()=>signal?.removeEventListener('abort', abort));
    return {
        response: response,
        upload: $31c1ac8f3ecbd352$export$f8162fcba31fa547(request.upload),
        download: $31c1ac8f3ecbd352$export$f8162fcba31fa547(request)
    };
}
function $31c1ac8f3ecbd352$export$bda27a3e49197b9({ path: path, method: method, headers: headers, withCredentials: withCredentials, body: body, signal: signal, timeout: timeout, responseType: responseType }) {
    const signals = [
        signal,
        timeout && AbortSignal.timeout(timeout)
    ].filter(Boolean);
    headers = headers instanceof Headers ? Object.fromEntries(headers.entries()) : headers instanceof Array ? Object.fromEntries(headers) : headers;
    headers = responseType === 'text' ? {
        ...headers,
        Accept: 'text/plain'
    } : responseType === 'json' ? {
        ...headers,
        Accept: 'application/json'
    } : responseType === 'document' ? {
        ...headers,
        Accept: 'text/html, application/xhtml+xml, application/xml'
    } : responseType === 'arraybuffer' || responseType === 'blob' ? {
        ...headers,
        Accept: 'application/octet-stream'
    } : headers;
    const isStream = body instanceof globalThis.ReadableStream;
    var upload;
    if (isStream) {
        const uploadProgress = new EventTarget();
        body = globalThis.ReadableStream['from']($31c1ac8f3ecbd352$export$cebfdbc318a33abe(body, +headers['Content-Length'], uploadProgress));
        upload = $31c1ac8f3ecbd352$export$f8162fcba31fa547(uploadProgress);
    }
    const downloadProgress = new EventTarget();
    const response = fetch(path + '', {
        method: method,
        headers: headers,
        credentials: withCredentials ? 'include' : 'omit',
        body: body,
        signal: signals[0] && AbortSignal.any(signals),
        // @ts-expect-error https://developer.chrome.com/docs/capabilities/web-apis/fetch-streaming-requests
        duplex: isStream ? 'half' : undefined
    }).then((response)=>$31c1ac8f3ecbd352$export$ba14d9a5a581e827(response, responseType, downloadProgress));
    return {
        response: response,
        upload: upload,
        download: $31c1ac8f3ecbd352$export$f8162fcba31fa547(downloadProgress)
    };
}
async function $31c1ac8f3ecbd352$export$ba14d9a5a581e827({ status: status, statusText: statusText, headers: headers, body: body }, responseType, downloadProgress) {
    const stream = globalThis.ReadableStream['from']($31c1ac8f3ecbd352$export$cebfdbc318a33abe(body, +headers.get('Content-Length'), downloadProgress));
    const contentType = headers.get('Content-Type') || '';
    const header = $31c1ac8f3ecbd352$export$eea2c1c5e1a37e50([
        ...headers
    ].map(([key, value])=>`${key}: ${value}`).join('\n'));
    const rBody = status === 204 ? undefined : await $31c1ac8f3ecbd352$export$b7b86d31099674dc(stream, contentType, responseType);
    return {
        status: status,
        statusText: statusText,
        headers: header,
        body: rBody
    };
}
async function $31c1ac8f3ecbd352$export$b7b86d31099674dc(stream, contentType, responseType) {
    const blob = new Blob(await Array.fromAsync(stream), {
        type: contentType
    });
    if (responseType === 'blob') return blob;
    if (responseType === 'arraybuffer') return blob.arrayBuffer();
    const text = await blob.text();
    if (responseType === 'text') return text;
    return $31c1ac8f3ecbd352$export$3b629cd0ff482602(text, contentType);
}
const $31c1ac8f3ecbd352$export$b5fe3f66a567bec0 = typeof globalThis.XMLHttpRequest === 'function' ? $31c1ac8f3ecbd352$export$4f2a8c8c11a6373a : $31c1ac8f3ecbd352$export$bda27a3e49197b9;
var $31c1ac8f3ecbd352$var$$cbd22d3323bef9ca$exports = {};
$31c1ac8f3ecbd352$var$$parcel$export($31c1ac8f3ecbd352$var$$cbd22d3323bef9ca$exports, "HTTPClient", function() {
    return $31c1ac8f3ecbd352$export$45cf759b359d3d24;
});
const { splice: $31c1ac8f3ecbd352$var$$cbd22d3323bef9ca$var$splice } = Array.prototype;
class $31c1ac8f3ecbd352$export$45cf759b359d3d24 extends $31c1ac8f3ecbd352$export$694e0d28c7ffc90c {
    constructor({ baseURI: baseURI = globalThis.document?.baseURI, baseRequest: baseRequest = $31c1ac8f3ecbd352$export$b5fe3f66a567bec0, ...options } = {}){
        super(), this.defaultWare = async ({ request: request, response: response }, next)=>{
            const { method: method = 'GET', headers: headers = {}, body: body } = request;
            if (method in $31c1ac8f3ecbd352$export$4125cfe7e08e2040 && body && typeof body === 'object') {
                const { contentType: contentType, data: data } = $31c1ac8f3ecbd352$export$dfdc1655ccc5b9cb(body, headers['Content-Type']);
                if (contentType) headers['Content-Type'] = contentType;
                request.body = data;
            }
            await next();
            if (response.status > 299) throw new $31c1ac8f3ecbd352$export$aa9d629c530f62a7(response.statusText, request, response);
        };
        this.baseURI = baseURI;
        this.baseRequest = baseRequest;
        this.options = options;
        super.use(this.defaultWare);
        super.use(async ({ request: data, response: response })=>{
            data.path = new URL(data.path + '', this.baseURI) + '';
            Object.assign(response, await this.baseRequest({
                ...options,
                ...data
            }).response);
        });
    }
    use(...middlewares) {
        $31c1ac8f3ecbd352$var$$cbd22d3323bef9ca$var$splice.call(this, -2, 0, ...middlewares);
        return this;
    }
    async request(data) {
        const context = {
            request: {
                ...data,
                headers: {
                    ...data.headers
                }
            },
            response: {}
        };
        await this.execute(context);
        return context.response;
    }
    async head(path, headers, options) {
        const { headers: data } = await this.request({
            method: 'HEAD',
            path: path,
            headers: headers,
            ...options
        });
        return data;
    }
    get(path, headers, options) {
        return this.request({
            method: 'GET',
            path: path,
            headers: headers,
            ...options
        });
    }
    post(path, body, headers, options) {
        return this.request({
            method: 'POST',
            path: path,
            headers: headers,
            body: body,
            ...options
        });
    }
    put(path, body, headers, options) {
        return this.request({
            method: 'PUT',
            path: path,
            headers: headers,
            body: body,
            ...options
        });
    }
    patch(path, body, headers, options) {
        return this.request({
            method: 'PATCH',
            path: path,
            headers: headers,
            body: body,
            ...options
        });
    }
    delete(path, body, headers, options) {
        return this.request({
            method: 'DELETE',
            path: path,
            headers: headers,
            body: body,
            ...options
        });
    }
    async *download(path, { headers: headers, chunkSize: chunkSize = 1024 ** 2, range: [start = 0, end = Infinity] = [], ...options } = {}) {
        var total = 0;
        function setEndAsHeader(length) {
            total = length;
            if (end === Infinity) end = total;
        }
        try {
            const { 'Content-Length': length } = await this.head(path, headers, options);
            setEndAsHeader(+length);
        } catch (error) {
            console.error(error);
        }
        for(let i = start, j = i - 1 + chunkSize; i < end; i = j + 1, j += chunkSize){
            const { status: status, headers: { 'Content-Range': range }, body: body } = await this.get(path, {
                ...headers,
                Range: `bytes=${i}-${j}`
            }, options);
            const totalBytes = +range?.split('/').pop();
            if (totalBytes) setEndAsHeader(totalBytes);
            if (status !== 206) {
                yield {
                    total: total,
                    loaded: total,
                    percent: 100,
                    buffer: body
                };
                break;
            }
            const loaded = i + body.byteLength;
            yield {
                total: total,
                loaded: loaded,
                percent: +(loaded / total * 100).toFixed(2),
                buffer: body
            };
        }
    }
}



var $d5I5D = parcelRequire("d5I5D");



var $aMH3h = parcelRequire("aMH3h");
function $ae81c90c82c6c614$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $ae81c90c82c6c614$var$$d2c94808ccfae153$exports = {};
$ae81c90c82c6c614$var$$parcel$export($ae81c90c82c6c614$var$$d2c94808ccfae153$exports, "githubClient", function() {
    return $ae81c90c82c6c614$export$660e113192f74c8f;
});
const $ae81c90c82c6c614$export$660e113192f74c8f = new (0, $31c1ac8f3ecbd352$export$45cf759b359d3d24)({
    baseURI: 'https://api.github.com',
    responseType: 'json'
});
var $ae81c90c82c6c614$var$$e6ce8158e203b92f$exports = {};
$ae81c90c82c6c614$var$$parcel$export($ae81c90c82c6c614$var$$e6ce8158e203b92f$exports, "UserModel", function() {
    return $ae81c90c82c6c614$export$621c2e9225361608;
});
var $ae81c90c82c6c614$var$$59c6fc29dfdfac1b$exports = {};
$ae81c90c82c6c614$var$$parcel$export($ae81c90c82c6c614$var$$59c6fc29dfdfac1b$exports, "OrganizationModel", function() {
    return $ae81c90c82c6c614$export$28c8139b720f2aa8;
});
var $ae81c90c82c6c614$var$$59c6fc29dfdfac1b$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $ae81c90c82c6c614$var$$59c6fc29dfdfac1b$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $ae81c90c82c6c614$var$$59c6fc29dfdfac1b$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $ae81c90c82c6c614$var$$59c6fc29dfdfac1b$var$__await = function(v) {
    return this instanceof $ae81c90c82c6c614$var$$59c6fc29dfdfac1b$var$__await ? (this.v = v, this) : new $ae81c90c82c6c614$var$$59c6fc29dfdfac1b$var$__await(v);
};
var $ae81c90c82c6c614$var$$59c6fc29dfdfac1b$var$__asyncValues = function(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
var $ae81c90c82c6c614$var$$59c6fc29dfdfac1b$var$__asyncDelegator = function(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $ae81c90c82c6c614$var$$59c6fc29dfdfac1b$var$__await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
};
var $ae81c90c82c6c614$var$$59c6fc29dfdfac1b$var$__asyncGenerator = function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $ae81c90c82c6c614$var$$59c6fc29dfdfac1b$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
let $ae81c90c82c6c614$export$28c8139b720f2aa8 = (()=>{
    var _a;
    let _classSuper = (0, $29590480c608918b$export$6a4eb2e7fc9e8903)((0, $29590480c608918b$export$36e5777a1ba4b7c3));
    let _instanceExtraInitializers = [];
    let _getOne_decorators;
    return _a = class OrganizationModel extends _classSuper {
        constructor(user = ''){
            super();
            Object.defineProperty(this, "user", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($ae81c90c82c6c614$var$$59c6fc29dfdfac1b$var$__runInitializers(this, _instanceExtraInitializers), user)
            });
            Object.defineProperty(this, "client", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: $ae81c90c82c6c614$export$660e113192f74c8f
            });
            Object.defineProperty(this, "baseURI", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: 'orgs'
            });
        }
        openStream() {
            return $ae81c90c82c6c614$var$$59c6fc29dfdfac1b$var$__asyncGenerator(this, arguments, function* openStream_1() {
                var _b;
                var per_page = this.pageSize, since, count = 0;
                const baseURI = this.user ? `users/${this.user}/` : '';
                for(let page = 1;; page++){
                    const { body: body } = yield $ae81c90c82c6c614$var$$59c6fc29dfdfac1b$var$__await(this.client.get(`${baseURI}orgs?${(0, $fbe6f1e2fed97fc7$export$13397a83aa5915d6)({
                        per_page: per_page,
                        page: page,
                        since: since
                    })}`));
                    if (!body[0]) break;
                    since = (_b = body.at(-1)) === null || _b === void 0 ? void 0 : _b.id;
                    count += body.length;
                    yield $ae81c90c82c6c614$var$$59c6fc29dfdfac1b$var$__await((yield* $ae81c90c82c6c614$var$$59c6fc29dfdfac1b$var$__asyncDelegator($ae81c90c82c6c614$var$$59c6fc29dfdfac1b$var$__asyncValues(body))));
                    if (body.length < this.pageSize) break;
                }
                this.totalCount = count;
            });
        }
        getOne(name) {
            const _super = Object.create(null, {
                getOne: {
                    get: ()=>super.getOne
                }
            });
            return $ae81c90c82c6c614$var$$59c6fc29dfdfac1b$var$__awaiter(this, void 0, void 0, function*() {
                return this.currentOne.login === name ? this.currentOne : _super.getOne.call(this, name);
            });
        }
    }, (()=>{
        var _b;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
        _getOne_decorators = [
            (0, $29590480c608918b$export$e03c1c3201ee8bb7)('downloading')
        ];
        $ae81c90c82c6c614$var$$59c6fc29dfdfac1b$var$__esDecorate(_a, null, _getOne_decorators, {
            kind: "method",
            name: "getOne",
            static: false,
            private: false,
            access: {
                has: (obj)=>"getOne" in obj,
                get: (obj)=>obj.getOne
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
var $ae81c90c82c6c614$var$$e6ce8158e203b92f$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $ae81c90c82c6c614$var$$e6ce8158e203b92f$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $ae81c90c82c6c614$var$$e6ce8158e203b92f$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $ae81c90c82c6c614$var$$e6ce8158e203b92f$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $ae81c90c82c6c614$var$$e6ce8158e203b92f$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $ae81c90c82c6c614$export$621c2e9225361608 = (()=>{
    var _a, _UserModel_session_accessor_storage;
    let _classSuper = (0, $29590480c608918b$export$d12e20a4eec10acf);
    let _instanceExtraInitializers = [];
    let _session_decorators;
    let _session_initializers = [];
    let _session_extraInitializers = [];
    let _get_organizationStore_decorators;
    let _get_namespaces_decorators;
    let _getSession_decorators;
    return _a = class UserModel extends _classSuper {
        get session() {
            return $ae81c90c82c6c614$var$$e6ce8158e203b92f$var$__classPrivateFieldGet(this, _UserModel_session_accessor_storage, "f");
        }
        set session(value) {
            $ae81c90c82c6c614$var$$e6ce8158e203b92f$var$__classPrivateFieldSet(this, _UserModel_session_accessor_storage, value, "f");
        }
        get organizationStore() {
            var _b;
            return new $ae81c90c82c6c614$export$28c8139b720f2aa8((_b = this.session) === null || _b === void 0 ? void 0 : _b.login);
        }
        get namespaces() {
            return [
                this.session,
                ...this.organizationStore.allItems
            ].filter(Boolean);
        }
        getSession() {
            return $ae81c90c82c6c614$var$$e6ce8158e203b92f$var$__awaiter(this, void 0, void 0, function*() {
                if (this.session) return this.session;
                const { body: body } = yield this.client.get('user');
                this.session = body;
                yield this.organizationStore.getAll();
                return body;
            });
        }
        constructor(){
            super(...arguments);
            Object.defineProperty(this, "client", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($ae81c90c82c6c614$var$$e6ce8158e203b92f$var$__runInitializers(this, _instanceExtraInitializers), $ae81c90c82c6c614$export$660e113192f74c8f)
            });
            _UserModel_session_accessor_storage.set(this, $ae81c90c82c6c614$var$$e6ce8158e203b92f$var$__runInitializers(this, _session_initializers, void 0));
            $ae81c90c82c6c614$var$$e6ce8158e203b92f$var$__runInitializers(this, _session_extraInitializers);
        }
    }, _UserModel_session_accessor_storage = new WeakMap(), (()=>{
        var _b;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
        _session_decorators = [
            (0, $d5I5D.observable)
        ];
        _get_organizationStore_decorators = [
            (0, $d5I5D.computed)
        ];
        _get_namespaces_decorators = [
            (0, $d5I5D.computed)
        ];
        _getSession_decorators = [
            (0, $29590480c608918b$export$e03c1c3201ee8bb7)('downloading')
        ];
        $ae81c90c82c6c614$var$$e6ce8158e203b92f$var$__esDecorate(_a, null, _session_decorators, {
            kind: "accessor",
            name: "session",
            static: false,
            private: false,
            access: {
                has: (obj)=>"session" in obj,
                get: (obj)=>obj.session,
                set: (obj, value)=>{
                    obj.session = value;
                }
            },
            metadata: _metadata
        }, _session_initializers, _session_extraInitializers);
        $ae81c90c82c6c614$var$$e6ce8158e203b92f$var$__esDecorate(_a, null, _get_organizationStore_decorators, {
            kind: "getter",
            name: "organizationStore",
            static: false,
            private: false,
            access: {
                has: (obj)=>"organizationStore" in obj,
                get: (obj)=>obj.organizationStore
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $ae81c90c82c6c614$var$$e6ce8158e203b92f$var$__esDecorate(_a, null, _get_namespaces_decorators, {
            kind: "getter",
            name: "namespaces",
            static: false,
            private: false,
            access: {
                has: (obj)=>"namespaces" in obj,
                get: (obj)=>obj.namespaces
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $ae81c90c82c6c614$var$$e6ce8158e203b92f$var$__esDecorate(_a, null, _getSession_decorators, {
            kind: "method",
            name: "getSession",
            static: false,
            private: false,
            access: {
                has: (obj)=>"getSession" in obj,
                get: (obj)=>obj.getSession
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
var $ae81c90c82c6c614$var$$d3130a010a88f771$exports = {};
$ae81c90c82c6c614$var$$parcel$export($ae81c90c82c6c614$var$$d3130a010a88f771$exports, "RepositoryModel", function() {
    return $ae81c90c82c6c614$export$e2c4c3b5712a2495;
});
var $ae81c90c82c6c614$var$$dfa451c8fd878073$exports = {};
$ae81c90c82c6c614$var$$parcel$export($ae81c90c82c6c614$var$$dfa451c8fd878073$exports, "ContributorModel", function() {
    return $ae81c90c82c6c614$export$ebe1058377a924a;
});
var $ae81c90c82c6c614$var$$dfa451c8fd878073$var$__await = function(v) {
    return this instanceof $ae81c90c82c6c614$var$$dfa451c8fd878073$var$__await ? (this.v = v, this) : new $ae81c90c82c6c614$var$$dfa451c8fd878073$var$__await(v);
};
var $ae81c90c82c6c614$var$$dfa451c8fd878073$var$__asyncValues = function(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
var $ae81c90c82c6c614$var$$dfa451c8fd878073$var$__asyncDelegator = function(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $ae81c90c82c6c614$var$$dfa451c8fd878073$var$__await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
};
var $ae81c90c82c6c614$var$$dfa451c8fd878073$var$__asyncGenerator = function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $ae81c90c82c6c614$var$$dfa451c8fd878073$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
class $ae81c90c82c6c614$export$ebe1058377a924a extends (0, $29590480c608918b$export$6a4eb2e7fc9e8903)((0, $29590480c608918b$export$36e5777a1ba4b7c3)) {
    constructor(owner, repository){
        super();
        Object.defineProperty(this, "owner", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: owner
        });
        Object.defineProperty(this, "repository", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: repository
        });
        Object.defineProperty(this, "client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $ae81c90c82c6c614$export$660e113192f74c8f
        });
        this.baseURI = `repos/${owner}/${repository}/contributors`;
    }
    openStream(filter) {
        return $ae81c90c82c6c614$var$$dfa451c8fd878073$var$__asyncGenerator(this, arguments, function* openStream_1() {
            const { client: client, baseURI: baseURI, pageSize: per_page } = this;
            var count = 0;
            for(let page = 1;; page++){
                const { body: body } = yield $ae81c90c82c6c614$var$$dfa451c8fd878073$var$__await(client.get(`${baseURI}?${(0, $fbe6f1e2fed97fc7$export$13397a83aa5915d6)(Object.assign({
                    per_page: per_page,
                    page: page
                }, filter))}`));
                if (!body[0]) break;
                count += body.length;
                yield $ae81c90c82c6c614$var$$dfa451c8fd878073$var$__await((yield* $ae81c90c82c6c614$var$$dfa451c8fd878073$var$__asyncDelegator($ae81c90c82c6c614$var$$dfa451c8fd878073$var$__asyncValues(body))));
                if (body.length < this.pageSize) break;
            }
            this.totalCount = count;
        });
    }
}
var $ae81c90c82c6c614$var$$e610a99570571b98$exports = {};
$ae81c90c82c6c614$var$$parcel$export($ae81c90c82c6c614$var$$e610a99570571b98$exports, "IssueModel", function() {
    return $ae81c90c82c6c614$export$5f96977bde248fb7;
});
$ae81c90c82c6c614$var$$parcel$export($ae81c90c82c6c614$var$$e610a99570571b98$exports, "IssueCommentModel", function() {
    return $ae81c90c82c6c614$export$3bba9992a4d664e6;
});
var $ae81c90c82c6c614$var$$985c3e5be67a4078$exports = {};
$ae81c90c82c6c614$var$$parcel$export($ae81c90c82c6c614$var$$985c3e5be67a4078$exports, "PullRequestModel", function() {
    return $ae81c90c82c6c614$export$8b5593d82c2e1a5;
});
var $ae81c90c82c6c614$var$$985c3e5be67a4078$var$__await = function(v) {
    return this instanceof $ae81c90c82c6c614$var$$985c3e5be67a4078$var$__await ? (this.v = v, this) : new $ae81c90c82c6c614$var$$985c3e5be67a4078$var$__await(v);
};
var $ae81c90c82c6c614$var$$985c3e5be67a4078$var$__asyncValues = function(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
var $ae81c90c82c6c614$var$$985c3e5be67a4078$var$__asyncDelegator = function(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $ae81c90c82c6c614$var$$985c3e5be67a4078$var$__await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
};
var $ae81c90c82c6c614$var$$985c3e5be67a4078$var$__asyncGenerator = function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $ae81c90c82c6c614$var$$985c3e5be67a4078$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
class $ae81c90c82c6c614$export$8b5593d82c2e1a5 extends (0, $29590480c608918b$export$6a4eb2e7fc9e8903)((0, $29590480c608918b$export$36e5777a1ba4b7c3)) {
    constructor(owner, repository){
        super();
        Object.defineProperty(this, "owner", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: owner
        });
        Object.defineProperty(this, "repository", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: repository
        });
        Object.defineProperty(this, "client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $ae81c90c82c6c614$export$660e113192f74c8f
        });
        this.baseURI = `repos/${owner}/${repository}/pulls`;
    }
    openStream(filter) {
        return $ae81c90c82c6c614$var$$985c3e5be67a4078$var$__asyncGenerator(this, arguments, function* openStream_1() {
            const { client: client, baseURI: baseURI, pageSize: per_page } = this;
            var count = 0;
            for(let page = 1;; page++){
                const { body: body } = yield $ae81c90c82c6c614$var$$985c3e5be67a4078$var$__await(client.get(`${baseURI}?${(0, $fbe6f1e2fed97fc7$export$13397a83aa5915d6)(Object.assign({
                    per_page: per_page,
                    page: page
                }, filter))}`));
                if (!body[0]) break;
                count += body.length;
                yield $ae81c90c82c6c614$var$$985c3e5be67a4078$var$__await((yield* $ae81c90c82c6c614$var$$985c3e5be67a4078$var$__asyncDelegator($ae81c90c82c6c614$var$$985c3e5be67a4078$var$__asyncValues(body))));
                if (body.length < this.pageSize) break;
            }
            this.totalCount = count;
        });
    }
}
var $ae81c90c82c6c614$var$$e610a99570571b98$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $ae81c90c82c6c614$var$$e610a99570571b98$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $ae81c90c82c6c614$var$$e610a99570571b98$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $ae81c90c82c6c614$var$$e610a99570571b98$var$__await = function(v) {
    return this instanceof $ae81c90c82c6c614$var$$e610a99570571b98$var$__await ? (this.v = v, this) : new $ae81c90c82c6c614$var$$e610a99570571b98$var$__await(v);
};
var $ae81c90c82c6c614$var$$e610a99570571b98$var$__asyncValues = function(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
var $ae81c90c82c6c614$var$$e610a99570571b98$var$__asyncDelegator = function(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $ae81c90c82c6c614$var$$e610a99570571b98$var$__await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
};
var $ae81c90c82c6c614$var$$e610a99570571b98$var$__asyncGenerator = function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $ae81c90c82c6c614$var$$e610a99570571b98$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
var $ae81c90c82c6c614$var$$e610a99570571b98$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
let $ae81c90c82c6c614$export$5f96977bde248fb7 = (()=>{
    var _a;
    let _classSuper = (0, $29590480c608918b$export$6a4eb2e7fc9e8903)((0, $29590480c608918b$export$36e5777a1ba4b7c3));
    let _instanceExtraInitializers = [];
    let _assignOneToCopilot_decorators;
    let _getLinkedPRs_decorators;
    return _a = class IssueModel extends _classSuper {
        constructor(owner, repository){
            super();
            Object.defineProperty(this, "owner", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($ae81c90c82c6c614$var$$e610a99570571b98$var$__runInitializers(this, _instanceExtraInitializers), owner)
            });
            Object.defineProperty(this, "repository", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: repository
            });
            Object.defineProperty(this, "client", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: $ae81c90c82c6c614$export$660e113192f74c8f
            });
            this.baseURI = `repos/${owner}/${repository}/issues`;
        }
        openStream(filter) {
            return $ae81c90c82c6c614$var$$e610a99570571b98$var$__asyncGenerator(this, arguments, function* openStream_1() {
                var per_page = this.pageSize, count = 0;
                for(let page = 1;; page++){
                    const { body: body } = yield $ae81c90c82c6c614$var$$e610a99570571b98$var$__await(this.client.get(`${this.baseURI}?${(0, $fbe6f1e2fed97fc7$export$13397a83aa5915d6)(Object.assign({
                        per_page: per_page,
                        page: page
                    }, filter))}`));
                    const list = body.filter(({ pull_request: pull_request })=>!pull_request);
                    if (!body[0]) break;
                    count += list.length;
                    yield $ae81c90c82c6c614$var$$e610a99570571b98$var$__await((yield* $ae81c90c82c6c614$var$$e610a99570571b98$var$__asyncDelegator($ae81c90c82c6c614$var$$e610a99570571b98$var$__asyncValues(list))));
                    if (body.length < this.pageSize) break;
                }
                this.totalCount = count;
            });
        }
        /**
             * Create or update an issue, with support for Copilot assignee
             *
             * @see {@link https://docs.github.com/en/rest/issues/issues#create-an-issue}
             * @see {@link https://docs.github.com/en/rest/issues/issues#update-an-issue}
             */ updateOne(_b, id) {
            const _super = Object.create(null, {
                updateOne: {
                    get: ()=>super.updateOne
                }
            });
            return $ae81c90c82c6c614$var$$e610a99570571b98$var$__awaiter(this, void 0, void 0, function*() {
                var { assignees: assignees = [] } = _b, rest = $ae81c90c82c6c614$var$$e610a99570571b98$var$__rest(_b, [
                    "assignees"
                ]);
                const assigneeList = assignees;
                const humanAssignees = assigneeList.filter((login)=>login !== 'copilot-swe-agent');
                const hasCopilotAssignee = assigneeList.length !== humanAssignees.length;
                const issueData = Object.assign(Object.assign({}, rest), humanAssignees && {
                    assignees: humanAssignees
                });
                const issue = yield _super.updateOne.call(this, issueData, id);
                if (hasCopilotAssignee) yield this.assignOneToCopilot(issue);
                return issue;
            });
        }
        /**
             * Assign Copilot bot to an issue using GitHub GraphQL API
             *
             * @see {@link https://docs.github.com/en/copilot/how-tos/use-copilot-agents/coding-agent/create-a-pr#assigning-an-existing-issue}
             * @see {@link https://github.com/orgs/community/discussions/164267}
             */ assignOneToCopilot(issue) {
            return $ae81c90c82c6c614$var$$e610a99570571b98$var$__awaiter(this, void 0, void 0, function*() {
                const getUserQuery = `
            query ($owner: String!, $name: String!) {
                repository(owner: $owner, name: $name) {
                    suggestedActors(
                        loginNames: "copilot"
                        capabilities: [CAN_BE_ASSIGNED]
                        first: 1
                    ) {
                        nodes {
                            login
                            __typename
                            ... on Bot { id }
                        }
                    }
                }
            }`;
                const { body: userResult } = yield this.client.post('https://api.github.com/graphql', {
                    query: getUserQuery,
                    variables: {
                        owner: this.owner,
                        name: this.repository
                    }
                });
                const userId = userResult.data.repository.suggestedActors.nodes[0].id;
                const assignMutation = `
            mutation ($issueId: ID!, $userId: ID!) {
                replaceActorsForAssignable(input: {assignableId: $issueId, actorIds: [$userId]}) {
                    assignable {
                        ... on Issue {
                            id
                            title
                            assignees(first: 10) {
                                nodes { login }
                            }
                        }
                    }
                }
            }`;
                const { body: assignResult } = yield this.client.post('https://api.github.com/graphql', {
                    query: assignMutation,
                    variables: {
                        issueId: issue.id,
                        userId: userId
                    }
                });
                return assignResult;
            });
        }
        /**
             * Get pull requests that close an issue using GraphQL
             *
             * @see {@link https://docs.github.com/en/graphql/reference/objects#pullrequest}
             */ getLinkedPRs(issueNumber_1) {
            return $ae81c90c82c6c614$var$$e610a99570571b98$var$__awaiter(this, arguments, void 0, function*(issueNumber, maxCount = 10) {
                const prNumbers = yield this.getLinkedPRNumbers(issueNumber, maxCount);
                const prModel = new $ae81c90c82c6c614$export$8b5593d82c2e1a5(this.owner, this.repository);
                return Promise.all(prNumbers.map((number)=>prModel.getOne(number)));
            });
        }
        getLinkedPRNumbers(issueNumber_1) {
            return $ae81c90c82c6c614$var$$e610a99570571b98$var$__awaiter(this, arguments, void 0, function*(issueNumber, maxCount = 10) {
                const query = `
            query ($owner: String!, $name: String!, $number: Int!, $maxCount: Int!) {
                repository(owner: $owner, name: $name) {
                    issue(number: $number) {
                        closedByPullRequestsReferences(first: $maxCount) {
                            nodes {
                                number
                            }
                        }
                    }
                }
            }`;
                const { body: body } = yield this.client.post(`https://api.github.com/graphql`, {
                    query: query,
                    variables: {
                        owner: this.owner,
                        name: this.repository,
                        number: issueNumber,
                        maxCount: maxCount
                    }
                });
                return body.data.repository.issue.closedByPullRequestsReferences.nodes.map(({ number: number })=>number);
            });
        }
    }, (()=>{
        var _b;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
        _assignOneToCopilot_decorators = [
            (0, $29590480c608918b$export$e03c1c3201ee8bb7)('uploading')
        ];
        _getLinkedPRs_decorators = [
            (0, $29590480c608918b$export$e03c1c3201ee8bb7)('downloading')
        ];
        $ae81c90c82c6c614$var$$e610a99570571b98$var$__esDecorate(_a, null, _assignOneToCopilot_decorators, {
            kind: "method",
            name: "assignOneToCopilot",
            static: false,
            private: false,
            access: {
                has: (obj)=>"assignOneToCopilot" in obj,
                get: (obj)=>obj.assignOneToCopilot
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $ae81c90c82c6c614$var$$e610a99570571b98$var$__esDecorate(_a, null, _getLinkedPRs_decorators, {
            kind: "method",
            name: "getLinkedPRs",
            static: false,
            private: false,
            access: {
                has: (obj)=>"getLinkedPRs" in obj,
                get: (obj)=>obj.getLinkedPRs
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
class $ae81c90c82c6c614$export$3bba9992a4d664e6 extends (0, $29590480c608918b$export$6a4eb2e7fc9e8903)((0, $29590480c608918b$export$36e5777a1ba4b7c3)) {
    constructor(owner, repository, issue){
        super();
        Object.defineProperty(this, "owner", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: owner
        });
        Object.defineProperty(this, "repository", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: repository
        });
        Object.defineProperty(this, "issue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: issue
        });
        Object.defineProperty(this, "client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $ae81c90c82c6c614$export$660e113192f74c8f
        });
        this.baseURI = `repos/${owner}/${repository}/issues/${issue}/comments`;
    }
    openStream(filter) {
        return $ae81c90c82c6c614$var$$e610a99570571b98$var$__asyncGenerator(this, arguments, function* openStream_2() {
            const { client: client, baseURI: baseURI, pageSize: per_page } = this;
            var count = 0;
            for(let page = 1;; page++){
                const { body: body } = yield $ae81c90c82c6c614$var$$e610a99570571b98$var$__await(client.get(`${baseURI}?${(0, $fbe6f1e2fed97fc7$export$13397a83aa5915d6)(Object.assign(Object.assign({}, filter), {
                    per_page: per_page,
                    page: page
                }))}`));
                if (!body[0]) break;
                count += body.length;
                yield $ae81c90c82c6c614$var$$e610a99570571b98$var$__await((yield* $ae81c90c82c6c614$var$$e610a99570571b98$var$__asyncDelegator($ae81c90c82c6c614$var$$e610a99570571b98$var$__asyncValues(body))));
                if (body.length < per_page) break;
            }
            this.totalCount = count;
        });
    }
}
var $ae81c90c82c6c614$var$$d3130a010a88f771$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $ae81c90c82c6c614$var$$d3130a010a88f771$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $ae81c90c82c6c614$var$$d3130a010a88f771$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
let $ae81c90c82c6c614$export$e2c4c3b5712a2495 = (()=>{
    var _a;
    let _classSuper = (0, $29590480c608918b$export$36e5777a1ba4b7c3);
    let _instanceExtraInitializers = [];
    let _getOne_decorators;
    return _a = class RepositoryModel extends _classSuper {
        constructor(owner = ''){
            super();
            Object.defineProperty(this, "owner", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($ae81c90c82c6c614$var$$d3130a010a88f771$var$__runInitializers(this, _instanceExtraInitializers), owner)
            });
            Object.defineProperty(this, "client", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: $ae81c90c82c6c614$export$660e113192f74c8f
            });
            Object.defineProperty(this, "baseURI", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ''
            });
            Object.defineProperty(this, "indexKey", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: 'full_name'
            });
            Object.defineProperty(this, "organizationStore", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: new $ae81c90c82c6c614$export$28c8139b720f2aa8()
            });
            Object.defineProperty(this, "relation", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: {
                    contributors: (0, $aMH3h.memoize)((URI)=>$ae81c90c82c6c614$var$$d3130a010a88f771$var$__awaiter(this, void 0, void 0, function*() {
                            const [owner, repository] = URI.split('/');
                            const body = yield new $ae81c90c82c6c614$export$ebe1058377a924a(owner, repository).getAll();
                            return body.sort((a, b)=>b.contributions - a.contributions) || [];
                        })),
                    issues: (0, $aMH3h.memoize)((URI)=>{
                        const [owner, repository] = URI.split('/');
                        return new $ae81c90c82c6c614$export$5f96977bde248fb7(owner, repository).getAll();
                    }),
                    languages: (0, $aMH3h.memoize)((URI)=>$ae81c90c82c6c614$var$$d3130a010a88f771$var$__awaiter(this, void 0, void 0, function*() {
                            const { body: languageCount } = yield this.client.get(`repos/${URI}/languages`);
                            const languageAverage = (0, $fbe6f1e2fed97fc7$export$e1f36757ecda301d)(...Object.values(languageCount));
                            const languageList = Object.entries(languageCount).filter(([_, score])=>score >= languageAverage).sort(([_, a], [__, b])=>b - a);
                            return languageList.map(([name])=>name);
                        }))
                }
            });
            this.baseURI = owner ? `orgs/${owner}/repos` : 'user/repos';
        }
        getOneRelation(URI_1) {
            return $ae81c90c82c6c614$var$$d3130a010a88f771$var$__awaiter(this, arguments, void 0, function*(URI, relation = []) {
                const relationData = yield Promise.all(relation.map((key)=>$ae81c90c82c6c614$var$$d3130a010a88f771$var$__awaiter(this, void 0, void 0, function*() {
                        const value = yield this.relation[key](URI);
                        return [
                            key,
                            value
                        ];
                    })));
                return Object.fromEntries(relationData);
            });
        }
        getOne(URI_1) {
            return $ae81c90c82c6c614$var$$d3130a010a88f771$var$__awaiter(this, arguments, void 0, function*(URI, relation = []) {
                const { body: body } = yield this.client.get(`repos/${URI}`);
                return this.currentOne = Object.assign(Object.assign({}, body), (yield this.getOneRelation(URI, relation)));
            });
        }
        loadPage(page_1, per_page_1, _b) {
            return $ae81c90c82c6c614$var$$d3130a010a88f771$var$__awaiter(this, arguments, void 0, function*(page, per_page, { relation: relation }) {
                const [kind, namespace] = this.baseURI.split('/'), isUser = kind === 'user';
                const { body: list } = yield this.client.get(`${this.baseURI}?${(0, $fbe6f1e2fed97fc7$export$13397a83aa5915d6)({
                    type: isUser ? 'owner' : 'public',
                    sort: 'pushed',
                    page: page,
                    per_page: per_page
                })}`);
                const pageData = yield Promise.all(list.map((item)=>$ae81c90c82c6c614$var$$d3130a010a88f771$var$__awaiter(this, void 0, void 0, function*() {
                        return Object.assign(Object.assign({}, item), (yield this.getOneRelation(item.full_name, relation)));
                    })));
                var { totalCount: totalCount } = this;
                if (!this.totalCount) {
                    if (!isUser) ({ public_repos: totalCount } = yield this.organizationStore.getOne(namespace));
                    else {
                        const { body: body } = yield this.client.get('user');
                        totalCount = body.public_repos + (body.total_private_repos || 0);
                    }
                }
                return {
                    pageData: pageData,
                    totalCount: totalCount
                };
            });
        }
        getAllContributors() {
            return $ae81c90c82c6c614$var$$d3130a010a88f771$var$__awaiter(this, void 0, void 0, function*() {
                const repositories = yield this.getAll({
                    relation: [
                        'contributors'
                    ]
                });
                const contributors = repositories.filter(({ fork: fork, archived: archived })=>!archived && !fork).flatMap(({ contributors: contributors })=>contributors).filter(({ type: type })=>type === 'User');
                const userGroup = (0, $fbe6f1e2fed97fc7$export$3f063810d7bf01bd)(contributors, 'login');
                return Object.entries(userGroup).map(([login, list])=>Object.assign(Object.assign({}, list[0]), {
                        contributions: list.reduce((sum, { contributions: contributions })=>sum + contributions, 0)
                    })).sort((a, b)=>b.contributions - a.contributions);
            });
        }
    }, (()=>{
        var _b;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
        _getOne_decorators = [
            (0, $29590480c608918b$export$e03c1c3201ee8bb7)('downloading')
        ];
        $ae81c90c82c6c614$var$$d3130a010a88f771$var$__esDecorate(_a, null, _getOne_decorators, {
            kind: "method",
            name: "getOne",
            static: false,
            private: false,
            access: {
                has: (obj)=>"getOne" in obj,
                get: (obj)=>obj.getOne
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
var $ae81c90c82c6c614$var$$88356f023569df5f$exports = {};
$ae81c90c82c6c614$var$$parcel$export($ae81c90c82c6c614$var$$88356f023569df5f$exports, "ContentModel", function() {
    return $ae81c90c82c6c614$export$5b988c733cc838bb;
});
var $ae81c90c82c6c614$var$$88356f023569df5f$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $ae81c90c82c6c614$var$$88356f023569df5f$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $ae81c90c82c6c614$var$$88356f023569df5f$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $ae81c90c82c6c614$var$$88356f023569df5f$var$__asyncValues = function(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
var $ae81c90c82c6c614$var$$88356f023569df5f$var$__await = function(v) {
    return this instanceof $ae81c90c82c6c614$var$$88356f023569df5f$var$__await ? (this.v = v, this) : new $ae81c90c82c6c614$var$$88356f023569df5f$var$__await(v);
};
var $ae81c90c82c6c614$var$$88356f023569df5f$var$__asyncGenerator = function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $ae81c90c82c6c614$var$$88356f023569df5f$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
var $ae81c90c82c6c614$var$$88356f023569df5f$var$__asyncDelegator = function(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $ae81c90c82c6c614$var$$88356f023569df5f$var$__await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
};
let $ae81c90c82c6c614$export$5b988c733cc838bb = (()=>{
    var _a;
    let _classSuper = (0, $29590480c608918b$export$6a4eb2e7fc9e8903)((0, $29590480c608918b$export$36e5777a1ba4b7c3));
    let _instanceExtraInitializers = [];
    let _getOne_decorators;
    let _updateOne_decorators;
    return _a = class ContentModel extends _classSuper {
        constructor(owner, repository){
            super();
            Object.defineProperty(this, "owner", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($ae81c90c82c6c614$var$$88356f023569df5f$var$__runInitializers(this, _instanceExtraInitializers), owner)
            });
            Object.defineProperty(this, "repository", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: repository
            });
            Object.defineProperty(this, "client", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: $ae81c90c82c6c614$export$660e113192f74c8f
            });
            this.baseURI = `repos/${owner}/${repository}/contents`;
        }
        /**
             * Get repository content at a specific path
             *
             * @see {@link https://docs.github.com/en/rest/repos/contents#get-repository-content}
             */ getOne(path) {
            return $ae81c90c82c6c614$var$$88356f023569df5f$var$__awaiter(this, void 0, void 0, function*() {
                const { body: body } = yield this.client.get(`${this.baseURI}/${path}`);
                return Array.isArray(body) ? body[0] : body;
            });
        }
        updateOne(_b, path_1) {
            return $ae81c90c82c6c614$var$$88356f023569df5f$var$__awaiter(this, arguments, void 0, function*({ content: content }, path, message = `[update] ${path}`) {
                try {
                    var { sha: sha } = yield this.getOne(path);
                } catch (_c) {}
                const { body: body } = yield this.client.put(`${this.baseURI}/${path}`, {
                    sha: sha,
                    message: message,
                    content: (0, $fbe6f1e2fed97fc7$export$8fb536984ec8b4d7)(content)
                });
                return body.content;
            });
        }
        openStream(_b) {
            return $ae81c90c82c6c614$var$$88356f023569df5f$var$__asyncGenerator(this, arguments, function* openStream_1({ path: path, name: name }) {
                var _c, e_1, _d, _e;
                const setCount = (total)=>this.totalCount = total;
                const namePattern = name && new RegExp(name);
                const stream = path ? this.traverseChildren(path, setCount) : this.traverseTree(undefined, setCount);
                try {
                    for(var _f = true, stream_1 = $ae81c90c82c6c614$var$$88356f023569df5f$var$__asyncValues(stream), stream_1_1; stream_1_1 = yield $ae81c90c82c6c614$var$$88356f023569df5f$var$__await(stream_1.next()), _c = stream_1_1.done, !_c; _f = true){
                        _e = stream_1_1.value;
                        _f = false;
                        const content = _e;
                        if (!namePattern || namePattern.test(content.name)) yield yield $ae81c90c82c6c614$var$$88356f023569df5f$var$__await(content);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (!_f && !_c && (_d = stream_1.return)) yield $ae81c90c82c6c614$var$$88356f023569df5f$var$__await(_d.call(stream_1));
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
            });
        }
        /**
             * Get direct children of a directory
             */ traverseChildren() {
            return $ae81c90c82c6c614$var$$88356f023569df5f$var$__asyncGenerator(this, arguments, function* traverseChildren_1(parentPath = '', onCount = ()=>{}) {
                const { body: body } = yield $ae81c90c82c6c614$var$$88356f023569df5f$var$__await(this.client.get(`${this.baseURI}/${parentPath}`));
                const contents = (0, $fbe6f1e2fed97fc7$export$7b85fd78dd236198)(body);
                onCount(contents.length);
                for (const content of contents){
                    content.parent_path = parentPath;
                    yield yield $ae81c90c82c6c614$var$$88356f023569df5f$var$__await(content);
                }
            });
        }
        /**
             * Recursively traverse the entire file tree
             */ traverseTree(parentContent, onCount) {
            return $ae81c90c82c6c614$var$$88356f023569df5f$var$__asyncGenerator(this, arguments, function* traverseTree_1() {
                var _b, e_2, _c, _d;
                let totalCount = 0;
                const addCount = (total)=>totalCount += total;
                const stream = this.traverseChildren((parentContent === null || parentContent === void 0 ? void 0 : parentContent.path) || '', addCount);
                try {
                    for(var _e = true, stream_2 = $ae81c90c82c6c614$var$$88356f023569df5f$var$__asyncValues(stream), stream_2_1; stream_2_1 = yield $ae81c90c82c6c614$var$$88356f023569df5f$var$__await(stream_2.next()), _b = stream_2_1.done, !_b; _e = true){
                        _d = stream_2_1.value;
                        _e = false;
                        const content = _d;
                        yield yield $ae81c90c82c6c614$var$$88356f023569df5f$var$__await(content);
                        if (content.type === 'dir') yield $ae81c90c82c6c614$var$$88356f023569df5f$var$__await((yield* $ae81c90c82c6c614$var$$88356f023569df5f$var$__asyncDelegator($ae81c90c82c6c614$var$$88356f023569df5f$var$__asyncValues(this.traverseTree(content, addCount)))));
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (!_e && !_b && (_c = stream_2.return)) yield $ae81c90c82c6c614$var$$88356f023569df5f$var$__await(_c.call(stream_2));
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
                onCount === null || onCount === void 0 || onCount(totalCount);
            });
        }
    }, (()=>{
        var _b;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
        _getOne_decorators = [
            (0, $29590480c608918b$export$e03c1c3201ee8bb7)('downloading')
        ];
        _updateOne_decorators = [
            (0, $29590480c608918b$export$e03c1c3201ee8bb7)('uploading')
        ];
        $ae81c90c82c6c614$var$$88356f023569df5f$var$__esDecorate(_a, null, _getOne_decorators, {
            kind: "method",
            name: "getOne",
            static: false,
            private: false,
            access: {
                has: (obj)=>"getOne" in obj,
                get: (obj)=>obj.getOne
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $ae81c90c82c6c614$var$$88356f023569df5f$var$__esDecorate(_a, null, _updateOne_decorators, {
            kind: "method",
            name: "updateOne",
            static: false,
            private: false,
            access: {
                has: (obj)=>"updateOne" in obj,
                get: (obj)=>obj.updateOne
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
var $ae81c90c82c6c614$var$$8f8defdf9fc6f2e7$exports = {};
$ae81c90c82c6c614$var$$parcel$export($ae81c90c82c6c614$var$$8f8defdf9fc6f2e7$exports, "DiscussionModel", function() {
    return $ae81c90c82c6c614$export$ea22e9ea45676ee3;
});
$ae81c90c82c6c614$var$$parcel$export($ae81c90c82c6c614$var$$8f8defdf9fc6f2e7$exports, "DiscussionCommentModel", function() {
    return $ae81c90c82c6c614$export$76e6d9690e198c8f;
});
var $ae81c90c82c6c614$var$$8f8defdf9fc6f2e7$var$__await = function(v) {
    return this instanceof $ae81c90c82c6c614$var$$8f8defdf9fc6f2e7$var$__await ? (this.v = v, this) : new $ae81c90c82c6c614$var$$8f8defdf9fc6f2e7$var$__await(v);
};
var $ae81c90c82c6c614$var$$8f8defdf9fc6f2e7$var$__asyncValues = function(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
var $ae81c90c82c6c614$var$$8f8defdf9fc6f2e7$var$__asyncDelegator = function(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $ae81c90c82c6c614$var$$8f8defdf9fc6f2e7$var$__await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
};
var $ae81c90c82c6c614$var$$8f8defdf9fc6f2e7$var$__asyncGenerator = function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $ae81c90c82c6c614$var$$8f8defdf9fc6f2e7$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
class $ae81c90c82c6c614$export$ea22e9ea45676ee3 extends (0, $29590480c608918b$export$6a4eb2e7fc9e8903)((0, $29590480c608918b$export$36e5777a1ba4b7c3)) {
    constructor(owner, repository){
        super();
        Object.defineProperty(this, "owner", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: owner
        });
        Object.defineProperty(this, "repository", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: repository
        });
        Object.defineProperty(this, "client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $ae81c90c82c6c614$export$660e113192f74c8f
        });
        this.baseURI = `repos/${owner}/${repository}/discussions`;
    }
    openStream(filter) {
        return $ae81c90c82c6c614$var$$8f8defdf9fc6f2e7$var$__asyncGenerator(this, arguments, function* openStream_1() {
            const { client: client, baseURI: baseURI, pageSize: per_page } = this;
            var count = 0;
            for(let page = 1;; page++){
                const { body: body } = yield $ae81c90c82c6c614$var$$8f8defdf9fc6f2e7$var$__await(client.get(`${baseURI}?${(0, $fbe6f1e2fed97fc7$export$13397a83aa5915d6)(Object.assign({
                    per_page: per_page,
                    page: page
                }, filter))}`));
                if (!body[0]) break;
                count += body.length;
                yield $ae81c90c82c6c614$var$$8f8defdf9fc6f2e7$var$__await((yield* $ae81c90c82c6c614$var$$8f8defdf9fc6f2e7$var$__asyncDelegator($ae81c90c82c6c614$var$$8f8defdf9fc6f2e7$var$__asyncValues(body))));
                if (body.length < this.pageSize) break;
            }
            this.totalCount = count;
        });
    }
}
class $ae81c90c82c6c614$export$76e6d9690e198c8f extends (0, $29590480c608918b$export$6a4eb2e7fc9e8903)((0, $29590480c608918b$export$36e5777a1ba4b7c3)) {
    constructor(owner, repository, discussion){
        super();
        Object.defineProperty(this, "owner", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: owner
        });
        Object.defineProperty(this, "repository", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: repository
        });
        Object.defineProperty(this, "discussion", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: discussion
        });
        Object.defineProperty(this, "client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $ae81c90c82c6c614$export$660e113192f74c8f
        });
        this.baseURI = `repos/${owner}/${repository}/discussions/${discussion}/comments`;
    }
    openStream(filter) {
        return $ae81c90c82c6c614$var$$8f8defdf9fc6f2e7$var$__asyncGenerator(this, arguments, function* openStream_2() {
            const { client: client, baseURI: baseURI, pageSize: per_page } = this;
            const { body: body } = yield $ae81c90c82c6c614$var$$8f8defdf9fc6f2e7$var$__await(client.get(baseURI.split('/').slice(0, -1).join('/')));
            this.totalCount = body.comments;
            if (!this.totalCount) return yield $ae81c90c82c6c614$var$$8f8defdf9fc6f2e7$var$__await(void 0);
            for(let page = 1;; page++){
                const { body: body } = yield $ae81c90c82c6c614$var$$8f8defdf9fc6f2e7$var$__await(client.get(`${baseURI}?${(0, $fbe6f1e2fed97fc7$export$13397a83aa5915d6)(Object.assign({
                    per_page: per_page,
                    page: page
                }, filter))}`));
                if (!body[0]) break;
                yield $ae81c90c82c6c614$var$$8f8defdf9fc6f2e7$var$__await((yield* $ae81c90c82c6c614$var$$8f8defdf9fc6f2e7$var$__asyncDelegator($ae81c90c82c6c614$var$$8f8defdf9fc6f2e7$var$__asyncValues(body))));
                if (body.length < this.pageSize) break;
            }
        });
    }
}
var $ae81c90c82c6c614$var$$131e71a4048073f6$exports = {};
$ae81c90c82c6c614$var$$parcel$export($ae81c90c82c6c614$var$$131e71a4048073f6$exports, "CheckRunModel", function() {
    return $ae81c90c82c6c614$export$3e1022bc3f07e26a;
});
var $ae81c90c82c6c614$var$$131e71a4048073f6$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $ae81c90c82c6c614$var$$131e71a4048073f6$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
class $ae81c90c82c6c614$export$3e1022bc3f07e26a extends (0, $29590480c608918b$export$36e5777a1ba4b7c3) {
    constructor(owner, repository, ref){
        super();
        Object.defineProperty(this, "owner", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: owner
        });
        Object.defineProperty(this, "repository", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: repository
        });
        Object.defineProperty(this, "ref", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ref
        });
        Object.defineProperty(this, "client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $ae81c90c82c6c614$export$660e113192f74c8f
        });
        Object.defineProperty(this, "baseURI", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        this.baseURI = `repos/${owner}/${repository}/commits/${ref}/check-runs`;
    }
    loadPage(page, per_page, _a) {
        return $ae81c90c82c6c614$var$$131e71a4048073f6$var$__awaiter(this, void 0, void 0, function*() {
            var { name: check_name, filter: filter = 'latest' } = _a, restFilter = $ae81c90c82c6c614$var$$131e71a4048073f6$var$__rest(_a, [
                "name",
                "filter"
            ]);
            const { body: body } = yield this.client.get(`${this.baseURI}?${(0, $fbe6f1e2fed97fc7$export$13397a83aa5915d6)(Object.assign(Object.assign({
                check_name: check_name,
                filter: filter
            }, restFilter), {
                per_page: per_page,
                page: page
            }))}`);
            return {
                pageData: body.check_runs,
                totalCount: body.total_count
            };
        });
    }
}
var $ae81c90c82c6c614$var$$0ae0bbd5d9d96cbc$exports = {};
$ae81c90c82c6c614$var$$parcel$export($ae81c90c82c6c614$var$$0ae0bbd5d9d96cbc$exports, "WorkflowRunModel", function() {
    return $ae81c90c82c6c614$export$ba933b122214fc50;
});
var $ae81c90c82c6c614$var$$0ae0bbd5d9d96cbc$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $ae81c90c82c6c614$var$$0ae0bbd5d9d96cbc$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
class $ae81c90c82c6c614$export$ba933b122214fc50 extends (0, $29590480c608918b$export$36e5777a1ba4b7c3) {
    constructor(owner, repository){
        super();
        Object.defineProperty(this, "owner", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: owner
        });
        Object.defineProperty(this, "repository", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: repository
        });
        Object.defineProperty(this, "client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $ae81c90c82c6c614$export$660e113192f74c8f
        });
        Object.defineProperty(this, "baseURI", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        this.baseURI = `repos/${owner}/${repository}/actions/runs`;
    }
    loadPage(page, per_page, _a) {
        return $ae81c90c82c6c614$var$$0ae0bbd5d9d96cbc$var$__awaiter(this, void 0, void 0, function*() {
            var { head_branch: branch, actor: actor } = _a, restFilter = $ae81c90c82c6c614$var$$0ae0bbd5d9d96cbc$var$__rest(_a, [
                "head_branch",
                "actor"
            ]);
            const { body: body } = yield this.client.get(`${this.baseURI}?${(0, $fbe6f1e2fed97fc7$export$13397a83aa5915d6)(Object.assign(Object.assign({
                branch: branch,
                actor: actor
            }, restFilter), {
                per_page: per_page,
                page: page
            }))}`);
            return {
                pageData: body.workflow_runs,
                totalCount: body.total_count
            };
        });
    }
}


const $d919b95fbe3dd622$var$GithubToken = undefined;
(0, $ae81c90c82c6c614$export$660e113192f74c8f).use(({ request: request }, next)=>{
    if ($d919b95fbe3dd622$var$GithubToken) request.headers = Object.assign(Object.assign({}, request.headers), {
        Authorization: `Bearer ${$d919b95fbe3dd622$var$GithubToken}`
    });
    return next();
});
const $d919b95fbe3dd622$export$8701c19c4b8c549b = new (0, $ae81c90c82c6c614$export$e2c4c3b5712a2495)('idea2app');


var $7badf3854cce2230$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $7badf3854cce2230$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $7badf3854cce2230$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $7badf3854cce2230$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $7badf3854cce2230$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $7badf3854cce2230$export$e94ab112fc249792 = (()=>{
    var _a, _ProjectModel_list_accessor_storage;
    let _list_decorators;
    let _list_initializers = [];
    let _list_extraInitializers = [];
    return _a = class ProjectModel {
        get list() {
            return $7badf3854cce2230$var$__classPrivateFieldGet(this, _ProjectModel_list_accessor_storage, "f");
        }
        set list(value) {
            $7badf3854cce2230$var$__classPrivateFieldSet(this, _ProjectModel_list_accessor_storage, value, "f");
        }
        clearList() {
            this.list = [];
            (0, $d919b95fbe3dd622$export$8701c19c4b8c549b).clear();
        }
        getList(...names) {
            return $7badf3854cce2230$var$__awaiter(this, void 0, void 0, function*() {
                for (const name of names){
                    const data = yield (0, $d919b95fbe3dd622$export$8701c19c4b8c549b).getOne(name);
                    const logo = yield _a.getLogo(data.owner.login, data.name);
                    this.list.push(Object.assign(Object.assign({}, data), {
                        logo: logo
                    }));
                }
                return this.list;
            });
        }
        static getLogo(owner, repo) {
            return $7badf3854cce2230$var$__awaiter(this, void 0, void 0, function*() {
                repo = repo.toLowerCase();
                try {
                    return yield new Promise((resolve, reject)=>{
                        const image = new Image();
                        image.onload = ()=>resolve(image.src);
                        image.onerror = reject;
                        image.src = `https://raw.githubusercontent.com/github/explore/master/topics/${repo}/${repo}.png`;
                    });
                } catch (_b) {
                    return `https://github.com/${owner}.png`;
                }
            });
        }
        constructor(){
            _ProjectModel_list_accessor_storage.set(this, $7badf3854cce2230$var$__runInitializers(this, _list_initializers, []));
            $7badf3854cce2230$var$__runInitializers(this, _list_extraInitializers);
        }
    }, _ProjectModel_list_accessor_storage = new WeakMap(), (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _list_decorators = [
            (0, $d5I5D.observable)
        ];
        $7badf3854cce2230$var$__esDecorate(_a, null, _list_decorators, {
            kind: "accessor",
            name: "list",
            static: false,
            private: false,
            access: {
                has: (obj)=>"list" in obj,
                get: (obj)=>obj.list,
                set: (obj, value)=>{
                    obj.list = value;
                }
            },
            metadata: _metadata
        }, _list_initializers, _list_extraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
var $7badf3854cce2230$export$2e2bcd8739ae039 = new $7badf3854cce2230$export$e94ab112fc249792();



var $4b6741e6925a057b$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $4b6741e6925a057b$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $4b6741e6925a057b$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
let $4b6741e6925a057b$export$36d69433c4f81145 = (()=>{
    let _classDecorators = [
        (0, $81aeefb8b9dacfc2$export$369b6b2b30582e8e),
        (0, $4d3432ed03d68615$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = (0, $hO8yS.Component);
    var HomePage = _classThis = class extends _classSuper {
        componentDidMount() {
            (0, $7badf3854cce2230$export$2e2bcd8739ae039).getList('facebook/react', 'microsoft/TypeScript', 'mobxjs/mobx', 'ant-design/ant-design', 'EasyWebApp/KoAJAX');
        }
        componentWillUnmount() {
            (0, $7badf3854cce2230$export$2e2bcd8739ae039).clearList();
        }
        render() {
            const { guest: guest } = this.props.query, { list: list } = (0, $7badf3854cce2230$export$2e2bcd8739ae039);
            return (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $hO8yS.Fragment), {
                children: [
                    (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("h1", {
                        children: (0, $b7383b0731549701$export$625550452a3fa3ec)('upstream_projects')
                    }),
                    guest && (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("h2", {
                        children: [
                            (0, $b7383b0731549701$export$625550452a3fa3ec)('welcome'),
                            " ",
                            guest,
                            "!"
                        ]
                    }),
                    (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $f16d0e5c621bcbb8$export$2e2bcd8739ae039), {
                        gutter: [
                            16,
                            16
                        ],
                        children: list.map(({ name: name, logo: logo, description: description })=>(0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $0205b0ed259f812c$export$2e2bcd8739ae039), {
                                xs: 24,
                                sm: 12,
                                lg: 6,
                                children: (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $cc75ec4a4b973a53$export$2e2bcd8739ae039), {
                                    hoverable: true,
                                    className: "h-100",
                                    cover: (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("img", {
                                        src: logo
                                    }),
                                    children: (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $cc75ec4a4b973a53$export$2e2bcd8739ae039).Meta, {
                                        title: name,
                                        description: description
                                    })
                                })
                            }, name))
                    })
                ]
            });
        }
    };
    $4b6741e6925a057b$var$__setFunctionName(_classThis, "HomePage");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        $4b6741e6925a057b$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        HomePage = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $4b6741e6925a057b$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return HomePage = _classThis;
})();





parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");

var $445678750385e1db$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $445678750385e1db$var$LightTheme = [
    'warning',
    'light'
];
const $445678750385e1db$export$37acb3580601e69a = (_a)=>{
    var { theme: theme = 'primary', children: children } = _a, props = $445678750385e1db$var$__rest(_a, [
        "theme",
        "children"
    ]);
    return (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("a", Object.assign({}, props, {
        className: `text-decoration-none d-inline-block rounded-pill px-3 py-1 bg-${theme} text-${$445678750385e1db$var$LightTheme.includes(theme) ? 'dark' : 'white'}`,
        children: children
    }));
};



var $hO8yS = parcelRequire("hO8yS");

var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");



parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");













var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");



"use client";
const $401dbb31fdf8da4f$var$isThenable = (thing)=>{
    return typeof thing?.then === 'function';
};
const $401dbb31fdf8da4f$var$ActionButton = (props)=>{
    const { type: type, children: children, prefixCls: prefixCls, buttonProps: buttonProps, close: close, autoFocus: autoFocus, emitEvent: emitEvent, isSilent: isSilent, quitOnNullishReturnValue: quitOnNullishReturnValue, actionFn: actionFn } = props;
    const clickedRef = $32rMB.useRef(false);
    const buttonRef = $32rMB.useRef(null);
    const [loading, setLoading] = (0, $8ad52953f3345b2f$export$2e2bcd8739ae039)(false);
    const onInternalClose = (...args)=>{
        close?.(...args);
    };
    $32rMB.useEffect(()=>{
        let timeoutId = null;
        if (autoFocus) timeoutId = setTimeout(()=>{
            buttonRef.current?.focus({
                preventScroll: true
            });
        });
        return ()=>{
            if (timeoutId) clearTimeout(timeoutId);
        };
    }, [
        autoFocus
    ]);
    const handlePromiseOnOk = (returnValueOfOnOk)=>{
        if (!$401dbb31fdf8da4f$var$isThenable(returnValueOfOnOk)) return;
        setLoading(true);
        returnValueOfOnOk.then((...args)=>{
            setLoading(false, true);
            onInternalClose.apply(void 0, args);
            clickedRef.current = false;
        }, (e)=>{
            // See: https://github.com/ant-design/ant-design/issues/6183
            setLoading(false, true);
            clickedRef.current = false;
            // Do not throw if is `await` mode
            if (isSilent?.()) return;
            return Promise.reject(e);
        });
    };
    const onClick = (e)=>{
        if (clickedRef.current) return;
        clickedRef.current = true;
        if (!actionFn) {
            onInternalClose();
            return;
        }
        let returnValueOfOnOk;
        if (emitEvent) {
            returnValueOfOnOk = actionFn(e);
            if (quitOnNullishReturnValue && !$401dbb31fdf8da4f$var$isThenable(returnValueOfOnOk)) {
                clickedRef.current = false;
                onInternalClose(e);
                return;
            }
        } else if (actionFn.length) {
            returnValueOfOnOk = actionFn(close);
            // https://github.com/ant-design/ant-design/issues/23358
            clickedRef.current = false;
        } else {
            returnValueOfOnOk = actionFn();
            if (!$401dbb31fdf8da4f$var$isThenable(returnValueOfOnOk)) {
                onInternalClose();
                return;
            }
        }
        handlePromiseOnOk(returnValueOfOnOk);
    };
    return /*#__PURE__*/ $hO8yS.createElement((0, $9632ad3149894c43$export$2e2bcd8739ae039), {
        ...(0, $c59d4dc2abd8d863$export$19bc9a290855952)(type),
        onClick: onClick,
        loading: loading,
        prefixCls: prefixCls,
        ...buttonProps,
        ref: buttonRef
    }, children);
};
var $401dbb31fdf8da4f$export$2e2bcd8739ae039 = $401dbb31fdf8da4f$var$ActionButton;



var $N3oW3 = parcelRequire("N3oW3");
const $42172c00ae1d981c$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $N3oW3.default).createContext({});
const { Provider: $42172c00ae1d981c$export$7c9538f5f3c365e9 } = $42172c00ae1d981c$export$ab57792b9b6974a6;


"use client";
const $764bd5f1e00785e1$var$ConfirmCancelBtn = ()=>{
    const { autoFocusButton: autoFocusButton, cancelButtonProps: cancelButtonProps, cancelTextLocale: cancelTextLocale, isSilent: isSilent, mergedOkCancel: mergedOkCancel, rootPrefixCls: rootPrefixCls, close: close, onCancel: onCancel, onConfirm: onConfirm, onClose: onClose } = (0, $32rMB.useContext)((0, $42172c00ae1d981c$export$ab57792b9b6974a6));
    return mergedOkCancel ? /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $401dbb31fdf8da4f$export$2e2bcd8739ae039), {
        isSilent: isSilent,
        actionFn: onCancel,
        close: (...args)=>{
            close?.(...args);
            onConfirm?.(false);
            onClose?.();
        },
        autoFocus: autoFocusButton === 'cancel',
        buttonProps: cancelButtonProps,
        prefixCls: `${rootPrefixCls}-btn`
    }, cancelTextLocale) : null;
};
var $764bd5f1e00785e1$export$2e2bcd8739ae039 = $764bd5f1e00785e1$var$ConfirmCancelBtn;



var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");


"use client";
const $5eb00002333fb884$var$ConfirmOkBtn = ()=>{
    const { autoFocusButton: autoFocusButton, close: close, isSilent: isSilent, okButtonProps: okButtonProps, rootPrefixCls: rootPrefixCls, okTextLocale: okTextLocale, okType: okType, onConfirm: onConfirm, onOk: onOk, onClose: onClose } = (0, $32rMB.useContext)((0, $42172c00ae1d981c$export$ab57792b9b6974a6));
    return /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $401dbb31fdf8da4f$export$2e2bcd8739ae039), {
        isSilent: isSilent,
        type: okType || 'primary',
        actionFn: onOk,
        close: (...args)=>{
            close?.(...args);
            onConfirm?.(true);
            onClose?.();
        },
        autoFocus: autoFocusButton === 'ok',
        buttonProps: okButtonProps,
        prefixCls: `${rootPrefixCls}-btn`
    }, okTextLocale);
};
var $5eb00002333fb884$export$2e2bcd8739ae039 = $5eb00002333fb884$var$ConfirmOkBtn;



parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");
parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
const $113d2f24e8de4d86$export$ee4e38b469b6f5d1 = /*#__PURE__*/ $hO8yS.createContext({});







parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");
// =============================== Motion ===============================
function $acc519b476344702$export$ec1a7ebf4579c1c3(prefixCls, transitionName, animationName) {
    let motionName = transitionName;
    if (!motionName && animationName) motionName = `${prefixCls}-${animationName}`;
    return motionName;
}
// =============================== Offset ===============================
function $acc519b476344702$var$getScroll(w, top) {
    let ret = w[`page${top ? 'Y' : 'X'}Offset`];
    const method = `scroll${top ? 'Top' : 'Left'}`;
    if (typeof ret !== 'number') {
        const d = w.document;
        ret = d.documentElement[method];
        if (typeof ret !== 'number') ret = d.body[method];
    }
    return ret;
}
function $acc519b476344702$export$cc800923e997bb8(el) {
    const rect = el.getBoundingClientRect();
    const pos = {
        left: rect.left,
        top: rect.top
    };
    const doc = el.ownerDocument;
    const w = doc.defaultView || doc.parentWindow;
    pos.left += $acc519b476344702$var$getScroll(w);
    pos.top += $acc519b476344702$var$getScroll(w, true);
    return pos;
}


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");






var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");


var $N3oW3 = parcelRequire("N3oW3");
var $a3dbe58c069acf12$export$2e2bcd8739ae039 = /*#__PURE__*/ $N3oW3.memo(({ children: children })=>children, (_, { shouldUpdate: shouldUpdate })=>!shouldUpdate);



function $6cd12ab1be94e582$var$_extends() {
    $6cd12ab1be94e582$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6cd12ab1be94e582$var$_extends.apply(this, arguments);
}
const $6cd12ab1be94e582$var$sentinelStyle = {
    width: 0,
    height: 0,
    overflow: 'hidden',
    outline: 'none'
};
const $6cd12ab1be94e582$var$entityStyle = {
    outline: 'none'
};
const $6cd12ab1be94e582$var$Panel = /*#__PURE__*/ (0, $N3oW3.default).forwardRef((props, ref)=>{
    const { prefixCls: prefixCls, className: className, style: style, title: title, ariaId: ariaId, footer: footer, closable: closable, closeIcon: closeIcon, onClose: onClose, children: children, bodyStyle: bodyStyle, bodyProps: bodyProps, modalRender: modalRender, onMouseDown: onMouseDown, onMouseUp: onMouseUp, holderRef: holderRef, visible: visible, forceRender: forceRender, width: width, height: height, classNames: modalClassNames, styles: modalStyles } = props;
    // ================================= Refs =================================
    const { panel: panelRef } = (0, $N3oW3.default).useContext((0, $113d2f24e8de4d86$export$ee4e38b469b6f5d1));
    const mergedRef = (0, $2706ed817e87019d$export$1d1c999670a1285d)(holderRef, panelRef);
    const sentinelStartRef = (0, $32rMB.useRef)(null);
    const sentinelEndRef = (0, $32rMB.useRef)(null);
    (0, $N3oW3.default).useImperativeHandle(ref, ()=>({
            focus: ()=>{
                sentinelStartRef.current?.focus({
                    preventScroll: true
                });
            },
            changeActive: (next)=>{
                const { activeElement: activeElement } = document;
                if (next && activeElement === sentinelEndRef.current) sentinelStartRef.current.focus({
                    preventScroll: true
                });
                else if (!next && activeElement === sentinelStartRef.current) sentinelEndRef.current.focus({
                    preventScroll: true
                });
            }
        }));
    // ================================ Style =================================
    const contentStyle = {};
    if (width !== undefined) contentStyle.width = width;
    if (height !== undefined) contentStyle.height = height;
    // ================================ Render ================================
    const footerNode = footer ? /*#__PURE__*/ (0, $N3oW3.default).createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-footer`, modalClassNames?.footer),
        style: {
            ...modalStyles?.footer
        }
    }, footer) : null;
    const headerNode = title ? /*#__PURE__*/ (0, $N3oW3.default).createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-header`, modalClassNames?.header),
        style: {
            ...modalStyles?.header
        }
    }, /*#__PURE__*/ (0, $N3oW3.default).createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-title`, modalClassNames?.title),
        id: ariaId,
        style: {
            ...modalStyles?.title
        }
    }, title)) : null;
    const closableObj = (0, $32rMB.useMemo)(()=>{
        if (typeof closable === 'object' && closable !== null) return closable;
        if (closable) return {
            closeIcon: closeIcon ?? /*#__PURE__*/ (0, $N3oW3.default).createElement("span", {
                className: `${prefixCls}-close-x`
            })
        };
        return {};
    }, [
        closable,
        closeIcon,
        prefixCls
    ]);
    const ariaProps = (0, $b0f3dfd0eb3cad70$export$2e2bcd8739ae039)(closableObj, true);
    const closeBtnIsDisabled = typeof closable === 'object' && closable.disabled;
    const closerNode = closable ? /*#__PURE__*/ (0, $N3oW3.default).createElement("button", $6cd12ab1be94e582$var$_extends({
        type: "button",
        onClick: onClose,
        "aria-label": "Close"
    }, ariaProps, {
        className: `${prefixCls}-close`,
        disabled: closeBtnIsDisabled
    }), closableObj.closeIcon) : null;
    const content = /*#__PURE__*/ (0, $N3oW3.default).createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-container`, modalClassNames?.container),
        style: modalStyles?.container
    }, closerNode, headerNode, /*#__PURE__*/ (0, $N3oW3.default).createElement("div", $6cd12ab1be94e582$var$_extends({
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-body`, modalClassNames?.body),
        style: {
            ...bodyStyle,
            ...modalStyles?.body
        }
    }, bodyProps), children), footerNode);
    return /*#__PURE__*/ (0, $N3oW3.default).createElement("div", {
        key: "dialog-element",
        role: "dialog",
        "aria-labelledby": title ? ariaId : null,
        "aria-modal": "true",
        ref: mergedRef,
        style: {
            ...style,
            ...contentStyle
        },
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, className),
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp
    }, /*#__PURE__*/ (0, $N3oW3.default).createElement("div", {
        ref: sentinelStartRef,
        tabIndex: 0,
        style: $6cd12ab1be94e582$var$entityStyle
    }, /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $a3dbe58c069acf12$export$2e2bcd8739ae039), {
        shouldUpdate: visible || forceRender
    }, modalRender ? modalRender(content) : content)), /*#__PURE__*/ (0, $N3oW3.default).createElement("div", {
        tabIndex: 0,
        ref: sentinelEndRef,
        style: $6cd12ab1be94e582$var$sentinelStyle
    }));
});
var $6cd12ab1be94e582$export$2e2bcd8739ae039 = $6cd12ab1be94e582$var$Panel;


function $e7c08bf994765d41$var$_extends() {
    $e7c08bf994765d41$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e7c08bf994765d41$var$_extends.apply(this, arguments);
}
const $e7c08bf994765d41$var$Content = /*#__PURE__*/ $N3oW3.forwardRef((props, ref)=>{
    const { prefixCls: prefixCls, title: title, style: style, className: className, visible: visible, forceRender: forceRender, destroyOnHidden: destroyOnHidden, motionName: motionName, ariaId: ariaId, onVisibleChanged: onVisibleChanged, mousePosition: mousePosition } = props;
    const dialogRef = (0, $32rMB.useRef)(null);
    const panelRef = (0, $32rMB.useRef)(null);
    // ============================== Refs ==============================
    $32rMB.useImperativeHandle(ref, ()=>({
            ...panelRef.current,
            inMotion: dialogRef.current.inMotion,
            enableMotion: dialogRef.current.enableMotion
        }));
    // ============================= Style ==============================
    const [transformOrigin, setTransformOrigin] = $32rMB.useState();
    const contentStyle = {};
    if (transformOrigin) contentStyle.transformOrigin = transformOrigin;
    function onPrepare() {
        const elementOffset = (0, $acc519b476344702$export$cc800923e997bb8)(dialogRef.current.nativeElement);
        setTransformOrigin(mousePosition && (mousePosition.x || mousePosition.y) ? `${mousePosition.x - elementOffset.left}px ${mousePosition.y - elementOffset.top}px` : '');
    }
    // ============================= Render =============================
    return /*#__PURE__*/ $hO8yS.createElement((0, $db80a026d0a86ece$export$2e2bcd8739ae039), {
        visible: visible,
        onVisibleChanged: onVisibleChanged,
        onAppearPrepare: onPrepare,
        onEnterPrepare: onPrepare,
        forceRender: forceRender,
        motionName: motionName,
        removeOnLeave: destroyOnHidden,
        ref: dialogRef
    }, ({ className: motionClassName, style: motionStyle }, motionRef)=>/*#__PURE__*/ $hO8yS.createElement((0, $6cd12ab1be94e582$export$2e2bcd8739ae039), $e7c08bf994765d41$var$_extends({}, props, {
            ref: panelRef,
            title: title,
            ariaId: ariaId,
            prefixCls: prefixCls,
            holderRef: motionRef,
            style: {
                ...motionStyle,
                ...style,
                ...contentStyle
            },
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(className, motionClassName)
        })));
});
var $e7c08bf994765d41$export$2e2bcd8739ae039 = $e7c08bf994765d41$var$Content;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");


function $bee3ec0189414e9d$var$_extends() {
    $bee3ec0189414e9d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bee3ec0189414e9d$var$_extends.apply(this, arguments);
}
const $bee3ec0189414e9d$var$Mask = (props)=>{
    const { prefixCls: prefixCls, style: style, visible: visible, maskProps: maskProps, motionName: motionName, className: className } = props;
    return /*#__PURE__*/ $hO8yS.createElement((0, $db80a026d0a86ece$export$2e2bcd8739ae039), {
        key: "mask",
        visible: visible,
        motionName: motionName,
        leavedClassName: `${prefixCls}-mask-hidden`
    }, ({ className: motionClassName, style: motionStyle }, ref)=>/*#__PURE__*/ $hO8yS.createElement("div", $bee3ec0189414e9d$var$_extends({
            ref: ref,
            style: {
                ...motionStyle,
                ...style
            },
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-mask`, motionClassName, className)
        }, maskProps)));
};
var $bee3ec0189414e9d$export$2e2bcd8739ae039 = $bee3ec0189414e9d$var$Mask;



function $3ae513e0872cd557$var$_extends() {
    $3ae513e0872cd557$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3ae513e0872cd557$var$_extends.apply(this, arguments);
}
const $3ae513e0872cd557$var$Dialog = (props)=>{
    const { prefixCls: prefixCls = 'rc-dialog', zIndex: zIndex, visible: visible = false, keyboard: keyboard = true, focusTriggerAfterClose: focusTriggerAfterClose = true, wrapStyle: // scrollLocker,
    // Wrapper
    wrapStyle, wrapClassName: wrapClassName, wrapProps: wrapProps, onClose: onClose, afterOpenChange: afterOpenChange, afterClose: afterClose, transitionName: // Dialog
    transitionName, animation: animation, closable: closable = true, mask: // Mask
    mask = true, maskTransitionName: maskTransitionName, maskAnimation: maskAnimation, maskClosable: maskClosable = true, maskStyle: maskStyle, maskProps: maskProps, rootClassName: rootClassName, rootStyle: rootStyle, classNames: modalClassNames, styles: modalStyles } = props;
    var prop;
    const lastOutSideActiveElementRef = (0, $32rMB.useRef)(null);
    const wrapperRef = (0, $32rMB.useRef)(null);
    const contentRef = (0, $32rMB.useRef)(null);
    const [animatedVisible, setAnimatedVisible] = $32rMB.useState(visible);
    // ========================== Init ==========================
    const ariaId = (0, $32268c06752c3bab$export$2e2bcd8739ae039)();
    function saveLastOutSideActiveElementRef() {
        if (!(0, $aeb2093ab4befe56$export$2e2bcd8739ae039)(wrapperRef.current, document.activeElement)) lastOutSideActiveElementRef.current = document.activeElement;
    }
    function focusDialogContent() {
        if (!(0, $aeb2093ab4befe56$export$2e2bcd8739ae039)(wrapperRef.current, document.activeElement)) contentRef.current?.focus();
    }
    // ========================= Events =========================
    // Close action will trigger by:
    //   1. When hide motion end
    //   2. Controlled `open` to `false` immediately after set to `true` which will not trigger motion
    function doClose() {
        // Clean up scroll bar & focus back
        setAnimatedVisible(false);
        if (mask && lastOutSideActiveElementRef.current && focusTriggerAfterClose) {
            try {
                lastOutSideActiveElementRef.current.focus({
                    preventScroll: true
                });
            } catch (e) {
            // Do nothing
            }
            lastOutSideActiveElementRef.current = null;
        }
        // Trigger afterClose only when change visible from true to false
        if (animatedVisible) afterClose?.();
    }
    function onDialogVisibleChanged(newVisible) {
        // Try to focus
        if (newVisible) focusDialogContent();
        else doClose();
        afterOpenChange?.(newVisible);
    }
    function onInternalClose(e) {
        onClose?.(e);
    }
    // >>> Content
    const contentClickRef = (0, $32rMB.useRef)(false);
    const contentTimeoutRef = (0, $32rMB.useRef)(null);
    // We need record content click incase content popup out of dialog
    const onContentMouseDown = ()=>{
        clearTimeout(contentTimeoutRef.current);
        contentClickRef.current = true;
    };
    const onContentMouseUp = ()=>{
        contentTimeoutRef.current = setTimeout(()=>{
            contentClickRef.current = false;
        });
    };
    // >>> Wrapper
    // Close only when element not on dialog
    let onWrapperClick = null;
    if (maskClosable) onWrapperClick = (e)=>{
        if (contentClickRef.current) contentClickRef.current = false;
        else if (wrapperRef.current === e.target) onInternalClose(e);
    };
    function onWrapperKeyDown(e) {
        if (keyboard && e.keyCode === (0, $4d7d870d585f8465$export$2e2bcd8739ae039).ESC) {
            e.stopPropagation();
            onInternalClose(e);
            return;
        }
        // keep focus inside dialog
        if (visible && e.keyCode === (0, $4d7d870d585f8465$export$2e2bcd8739ae039).TAB) contentRef.current.changeActive(!e.shiftKey);
    }
    // ========================= Effect =========================
    (0, $32rMB.useEffect)(()=>{
        if (visible) {
            setAnimatedVisible(true);
            saveLastOutSideActiveElementRef();
        } else if (animatedVisible && contentRef.current.enableMotion() && !contentRef.current.inMotion()) doClose();
    }, [
        visible
    ]);
    // Remove direct should also check the scroll bar update
    (0, $32rMB.useEffect)(()=>()=>{
            clearTimeout(contentTimeoutRef.current);
        }, []);
    const mergedStyle = {
        zIndex: zIndex,
        ...wrapStyle,
        ...modalStyles?.wrapper,
        display: !animatedVisible ? 'none' : null
    };
    // ========================= Render =========================
    return /*#__PURE__*/ $hO8yS.createElement("div", $3ae513e0872cd557$var$_extends({
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-root`, rootClassName),
        style: rootStyle
    }, (0, $b0f3dfd0eb3cad70$export$2e2bcd8739ae039)(props, {
        data: true
    })), /*#__PURE__*/ $hO8yS.createElement((0, $bee3ec0189414e9d$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        visible: mask && visible,
        motionName: (0, $acc519b476344702$export$ec1a7ebf4579c1c3)(prefixCls, maskTransitionName, maskAnimation),
        style: {
            zIndex: zIndex,
            ...maskStyle,
            ...modalStyles?.mask
        },
        maskProps: maskProps,
        className: modalClassNames?.mask
    }), /*#__PURE__*/ $hO8yS.createElement("div", $3ae513e0872cd557$var$_extends({
        tabIndex: -1,
        onKeyDown: onWrapperKeyDown,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-wrap`, wrapClassName, modalClassNames?.wrapper),
        ref: wrapperRef,
        onClick: onWrapperClick,
        style: mergedStyle
    }, wrapProps), /*#__PURE__*/ $hO8yS.createElement((0, $e7c08bf994765d41$export$2e2bcd8739ae039), $3ae513e0872cd557$var$_extends({}, props, {
        onMouseDown: onContentMouseDown,
        onMouseUp: onContentMouseUp,
        ref: contentRef,
        closable: closable,
        ariaId: ariaId,
        prefixCls: prefixCls,
        visible: visible && animatedVisible,
        onClose: onInternalClose,
        onVisibleChanged: onDialogVisibleChanged,
        motionName: (0, $acc519b476344702$export$ec1a7ebf4579c1c3)(prefixCls, transitionName, animation)
    }))));
};
var $3ae513e0872cd557$export$2e2bcd8739ae039 = $3ae513e0872cd557$var$Dialog;


function $1c34d16048802887$var$_extends() {
    $1c34d16048802887$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1c34d16048802887$var$_extends.apply(this, arguments);
}
// fix issue #10656
/*
 * getContainer remarks
 * Custom container should not be return, because in the Portal component, it will remove the
 * return container element here, if the custom container is the only child of it's component,
 * like issue #10656, It will has a conflict with removeChild method in react-dom.
 * So here should add a child (div element) to custom container.
 * */ const $1c34d16048802887$var$DialogWrap = (props)=>{
    const { visible: visible, getContainer: getContainer, forceRender: forceRender, destroyOnHidden: destroyOnHidden = false, afterClose: afterClose, closable: closable, panelRef: panelRef } = props;
    const [animatedVisible, setAnimatedVisible] = $32rMB.useState(visible);
    const refContext = $32rMB.useMemo(()=>({
            panel: panelRef
        }), [
        panelRef
    ]);
    $32rMB.useEffect(()=>{
        if (visible) setAnimatedVisible(true);
    }, [
        visible
    ]);
    // Destroy on close will remove wrapped div
    if (!forceRender && destroyOnHidden && !animatedVisible) return null;
    return /*#__PURE__*/ $hO8yS.createElement((0, $113d2f24e8de4d86$export$ee4e38b469b6f5d1).Provider, {
        value: refContext
    }, /*#__PURE__*/ $hO8yS.createElement((0, $af60d9f9d47b1e00$export$2e2bcd8739ae039), {
        open: visible || forceRender || animatedVisible,
        autoDestroy: false,
        getContainer: getContainer,
        autoLock: visible || animatedVisible
    }, /*#__PURE__*/ $hO8yS.createElement((0, $3ae513e0872cd557$export$2e2bcd8739ae039), $1c34d16048802887$var$_extends({}, props, {
        destroyOnHidden: destroyOnHidden,
        afterClose: ()=>{
            const closableObj = closable && typeof closable === 'object' ? closable : {};
            const { afterClose: closableAfterClose } = closableObj || {};
            closableAfterClose?.();
            afterClose?.();
            setAnimatedVisible(false);
        }
    }))));
};
var $1c34d16048802887$export$2e2bcd8739ae039 = $1c34d16048802887$var$DialogWrap;



var $91d9356658c122a2$export$2e2bcd8739ae039 = (0, $1c34d16048802887$export$2e2bcd8739ae039);






var $N3oW3 = parcelRequire("N3oW3");




function $c63f725913016a25$var$mergeProps(...items) {
    const ret = {};
    items.forEach((item)=>{
        if (item) Object.keys(item).forEach((key)=>{
            if (item[key] !== undefined) ret[key] = item[key];
        });
    });
    return ret;
}
var $c63f725913016a25$export$2e2bcd8739ae039 = $c63f725913016a25$var$mergeProps;



"use client";
const $e985b4f58965653f$export$51ad9c30389f050b = (context)=>{
    if (!context) return undefined;
    const { closable: closable, closeIcon: closeIcon } = context;
    return {
        closable: closable,
        closeIcon: closeIcon
    };
};
const $e985b4f58965653f$var$EmptyFallbackCloseCollection = {};
const $e985b4f58965653f$var$computeClosableConfig = (closable, closeIcon)=>{
    if (!closable && (closable === false || closeIcon === false || closeIcon === null)) return false;
    if (closable === undefined && closeIcon === undefined) return null;
    let closableConfig = {
        closeIcon: typeof closeIcon !== 'boolean' && closeIcon !== null ? closeIcon : undefined
    };
    if (closable && typeof closable === 'object') closableConfig = {
        ...closableConfig,
        ...closable
    };
    return closableConfig;
};
const $e985b4f58965653f$var$mergeClosableConfigs = (propConfig, contextConfig, fallbackConfig)=>{
    if (propConfig === false) return false;
    if (propConfig) return (0, $c63f725913016a25$export$2e2bcd8739ae039)(fallbackConfig, contextConfig, propConfig);
    if (contextConfig === false) return false;
    if (contextConfig) return (0, $c63f725913016a25$export$2e2bcd8739ae039)(fallbackConfig, contextConfig);
    return fallbackConfig.closable ? fallbackConfig : false;
};
const $e985b4f58965653f$var$computeCloseIcon = (mergedConfig, fallbackCloseCollection, closeLabel)=>{
    const { closeIconRender: closeIconRender } = fallbackCloseCollection;
    const { closeIcon: closeIcon, ...restConfig } = mergedConfig;
    let finalCloseIcon = closeIcon;
    const ariaOrDataProps = (0, $b0f3dfd0eb3cad70$export$2e2bcd8739ae039)(restConfig, true);
    if ((0, $95ac4c3d4339216e$export$2e2bcd8739ae039)(finalCloseIcon)) {
        if (closeIconRender) finalCloseIcon = closeIconRender(finalCloseIcon);
        finalCloseIcon = /*#__PURE__*/ (0, $N3oW3.default).isValidElement(finalCloseIcon) ? /*#__PURE__*/ (0, $N3oW3.default).cloneElement(finalCloseIcon, {
            'aria-label': closeLabel,
            ...finalCloseIcon.props,
            ...ariaOrDataProps
        }) : /*#__PURE__*/ (0, $N3oW3.default).createElement("span", {
            "aria-label": closeLabel,
            ...ariaOrDataProps
        }, finalCloseIcon);
    }
    return [
        finalCloseIcon,
        ariaOrDataProps
    ];
};
const $e985b4f58965653f$export$41ed0597a5c42f8 = (propCloseCollection, contextCloseCollection, fallbackCloseCollection = $e985b4f58965653f$var$EmptyFallbackCloseCollection, closeLabel = 'Close')=>{
    const propConfig = $e985b4f58965653f$var$computeClosableConfig(propCloseCollection?.closable, propCloseCollection?.closeIcon);
    const contextConfig = $e985b4f58965653f$var$computeClosableConfig(contextCloseCollection?.closable, contextCloseCollection?.closeIcon);
    const mergedFallback = {
        closeIcon: /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $bd33c75627fd73a4$export$2e2bcd8739ae039), null),
        ...fallbackCloseCollection
    };
    const mergedConfig = $e985b4f58965653f$var$mergeClosableConfigs(propConfig, contextConfig, mergedFallback);
    const closeBtnIsDisabled = typeof mergedConfig !== 'boolean' ? !!mergedConfig?.disabled : false;
    if (mergedConfig === false) return [
        false,
        null,
        closeBtnIsDisabled,
        {}
    ];
    const [closeIcon, ariaProps] = $e985b4f58965653f$var$computeCloseIcon(mergedConfig, mergedFallback, closeLabel);
    return [
        true,
        closeIcon,
        closeBtnIsDisabled,
        ariaProps
    ];
};
const $e985b4f58965653f$export$aa101db403ccf5f3 = (propCloseCollection, contextCloseCollection, fallbackCloseCollection = $e985b4f58965653f$var$EmptyFallbackCloseCollection)=>{
    const [contextLocale] = (0, $c176ccd8a9cbd556$export$2e2bcd8739ae039)('global', (0, $e154e9cb01eacc19$export$2e2bcd8739ae039).global);
    return (0, $N3oW3.default).useMemo(()=>{
        return $e985b4f58965653f$export$41ed0597a5c42f8(propCloseCollection, contextCloseCollection, {
            closeIcon: /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $bd33c75627fd73a4$export$2e2bcd8739ae039), null),
            ...fallbackCloseCollection
        }, contextLocale.close);
    }, [
        propCloseCollection,
        contextCloseCollection,
        fallbackCloseCollection,
        contextLocale.close
    ]);
};

parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
const $5c6bc54560501fe9$var$normalizeMaskConfig = (mask)=>{
    if (mask && typeof mask === 'object') return mask;
    if (typeof mask === 'boolean') return {
        enabled: mask,
        blur: mask
    };
    return {};
};
const $5c6bc54560501fe9$export$a4ac1bdd74570410 = (mask, contextMask, prefixCls)=>{
    return (0, $32rMB.useMemo)(()=>{
        const maskConfig = $5c6bc54560501fe9$var$normalizeMaskConfig(mask);
        const contextMaskConfig = $5c6bc54560501fe9$var$normalizeMaskConfig(contextMask);
        const mergedConfig = {
            ...contextMaskConfig,
            ...maskConfig
        };
        const className = mergedConfig.blur !== false ? `${prefixCls}-mask-blur` : undefined;
        return [
            mergedConfig.enabled !== false,
            {
                mask: className
            }
        ];
    }, [
        mask,
        contextMask,
        prefixCls
    ]);
};





const $ebb91cfa0799a60d$var$isStyleNameSupport = (styleName)=>{
    if ((0, $bfbc54ac1ac0215e$export$2e2bcd8739ae039)() && window.document.documentElement) {
        const styleNameList = Array.isArray(styleName) ? styleName : [
            styleName
        ];
        const { documentElement: documentElement } = window.document;
        return styleNameList.some((name)=>name in documentElement.style);
    }
    return false;
};
const $ebb91cfa0799a60d$var$isStyleValueSupport = (styleName, value)=>{
    if (!$ebb91cfa0799a60d$var$isStyleNameSupport(styleName)) return false;
    const ele = document.createElement('div');
    const origin = ele.style[styleName];
    ele.style[styleName] = value;
    return ele.style[styleName] !== origin;
};
function $ebb91cfa0799a60d$export$d616d7831008e86c(styleName, styleValue) {
    if (!Array.isArray(styleName) && styleValue !== undefined) return $ebb91cfa0799a60d$var$isStyleValueSupport(styleName, styleValue);
    return $ebb91cfa0799a60d$var$isStyleNameSupport(styleName);
}


const $c23ac8a120a875e9$export$7dbdadf5e9653129 = ()=>(0, $bfbc54ac1ac0215e$export$2e2bcd8739ae039)() && window.document.documentElement;








parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");

function $12fcc0e46b84a670$var$voidFunc() {}
const $12fcc0e46b84a670$var$WatermarkContext = /*#__PURE__*/ $hO8yS.createContext({
    add: $12fcc0e46b84a670$var$voidFunc,
    remove: $12fcc0e46b84a670$var$voidFunc
});
function $12fcc0e46b84a670$export$94ab53417567be34(panelSelector) {
    const watermark = $32rMB.useContext($12fcc0e46b84a670$var$WatermarkContext);
    const panelEleRef = $32rMB.useRef(null);
    const panelRef = (0, $ea93068db096b7d6$export$2e2bcd8739ae039)((ele)=>{
        if (ele) {
            const innerContentEle = panelSelector ? ele.querySelector(panelSelector) : ele;
            if (innerContentEle) {
                watermark.add(innerContentEle);
                panelEleRef.current = innerContentEle;
            }
        } else watermark.remove(panelEleRef.current);
    });
    return panelRef;
}
var $12fcc0e46b84a670$export$2e2bcd8739ae039 = $12fcc0e46b84a670$var$WatermarkContext;



var $N3oW3 = parcelRequire("N3oW3");




var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");


"use client";
const $539897a47719b0ce$var$NormalCancelBtn = ()=>{
    const { cancelButtonProps: cancelButtonProps, cancelTextLocale: cancelTextLocale, onCancel: onCancel } = (0, $32rMB.useContext)((0, $42172c00ae1d981c$export$ab57792b9b6974a6));
    return /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $9632ad3149894c43$export$2e2bcd8739ae039), {
        onClick: onCancel,
        ...cancelButtonProps
    }, cancelTextLocale);
};
var $539897a47719b0ce$export$2e2bcd8739ae039 = $539897a47719b0ce$var$NormalCancelBtn;



var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");



"use client";
const $c8a20e6f6ff9866c$var$NormalOkBtn = ()=>{
    const { confirmLoading: confirmLoading, okButtonProps: okButtonProps, okType: okType, okTextLocale: okTextLocale, onOk: onOk } = (0, $32rMB.useContext)((0, $42172c00ae1d981c$export$ab57792b9b6974a6));
    return /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $9632ad3149894c43$export$2e2bcd8739ae039), {
        ...(0, $c59d4dc2abd8d863$export$19bc9a290855952)(okType),
        loading: confirmLoading,
        onClick: onOk,
        ...okButtonProps
    }, okTextLocale);
};
var $c8a20e6f6ff9866c$export$2e2bcd8739ae039 = $c8a20e6f6ff9866c$var$NormalOkBtn;




"use client";
function $60f45d0a58d14164$export$97c34646962d356e(prefixCls, closeIcon) {
    return /*#__PURE__*/ (0, $N3oW3.default).createElement("span", {
        className: `${prefixCls}-close-x`
    }, closeIcon || /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $bd33c75627fd73a4$export$2e2bcd8739ae039), {
        className: `${prefixCls}-close-icon`
    }));
}
const $60f45d0a58d14164$export$a06f1c675e846f6f = (props)=>{
    const { okText: okText, okType: okType = 'primary', cancelText: cancelText, confirmLoading: confirmLoading, onOk: onOk, onCancel: onCancel, okButtonProps: okButtonProps, cancelButtonProps: cancelButtonProps, footer: footer } = props;
    const [locale] = (0, $c176ccd8a9cbd556$export$2e2bcd8739ae039)('Modal', (0, $8ffa4a229f480682$export$1b6004afda18cd51)());
    // ================== Locale Text ==================
    const okTextLocale = okText || locale?.okText;
    const cancelTextLocale = cancelText || locale?.cancelText;
    const memoizedValue = (0, $N3oW3.default).useMemo(()=>{
        return {
            confirmLoading: confirmLoading,
            okButtonProps: okButtonProps,
            cancelButtonProps: cancelButtonProps,
            okTextLocale: okTextLocale,
            cancelTextLocale: cancelTextLocale,
            okType: okType,
            onOk: onOk,
            onCancel: onCancel
        };
    }, [
        confirmLoading,
        okButtonProps,
        cancelButtonProps,
        okTextLocale,
        cancelTextLocale,
        okType,
        onOk,
        onCancel
    ]);
    let footerNode;
    if (typeof footer === 'function' || typeof footer === 'undefined') {
        footerNode = /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $N3oW3.default).Fragment, null, /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $539897a47719b0ce$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $c8a20e6f6ff9866c$export$2e2bcd8739ae039), null));
        if (typeof footer === 'function') footerNode = footer(footerNode, {
            OkBtn: (0, $c8a20e6f6ff9866c$export$2e2bcd8739ae039),
            CancelBtn: (0, $539897a47719b0ce$export$2e2bcd8739ae039)
        });
        footerNode = /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $42172c00ae1d981c$export$7c9538f5f3c365e9), {
            value: memoizedValue
        }, footerNode);
    } else footerNode = footer;
    return /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $ff4b4ddbf52ed41f$export$6adb5f3b918b11bb), {
        disabled: false
    }, footerNode);
};








function $71c98052e7bebbb8$var$box(position) {
    return {
        position: position,
        inset: 0
    };
}
const $71c98052e7bebbb8$export$8bb6dada04673ddd = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    return [
        {
            [`${componentCls}-root`]: {
                [`${componentCls}${antCls}-zoom-enter, ${componentCls}${antCls}-zoom-appear`]: {
                    // reset scale avoid mousePosition bug
                    transform: 'none',
                    opacity: 0,
                    animationDuration: token.motionDurationSlow,
                    // https://github.com/ant-design/ant-design/issues/11777
                    userSelect: 'none'
                },
                // https://github.com/ant-design/ant-design/issues/37329
                // https://github.com/ant-design/ant-design/issues/40272
                [`${componentCls}${antCls}-zoom-leave ${componentCls}-container`]: {
                    pointerEvents: 'none'
                },
                [`${componentCls}-mask`]: {
                    ...$71c98052e7bebbb8$var$box('fixed'),
                    zIndex: token.zIndexPopupBase,
                    height: '100%',
                    backgroundColor: token.colorBgMask,
                    pointerEvents: 'none',
                    [`&${componentCls}-mask-blur`]: {
                        backdropFilter: 'blur(4px)'
                    },
                    [`${componentCls}-hidden`]: {
                        display: 'none'
                    }
                },
                [`${componentCls}-wrap`]: {
                    ...$71c98052e7bebbb8$var$box('fixed'),
                    zIndex: token.zIndexPopupBase,
                    overflow: 'auto',
                    outline: 0,
                    WebkitOverflowScrolling: 'touch'
                }
            }
        },
        {
            [`${componentCls}-root`]: (0, $75aa16c51f96f6ab$export$2909268c8354a12)(token)
        }
    ];
};
const $71c98052e7bebbb8$var$genModalStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return [
        // ======================== Root =========================
        {
            [`${componentCls}-root`]: {
                [`${componentCls}-wrap-rtl`]: {
                    direction: 'rtl'
                },
                [`${componentCls}-centered`]: {
                    textAlign: 'center',
                    '&::before': {
                        display: 'inline-block',
                        width: 0,
                        height: '100%',
                        verticalAlign: 'middle',
                        content: '""'
                    },
                    [componentCls]: {
                        top: 0,
                        display: 'inline-block',
                        paddingBottom: 0,
                        textAlign: 'start',
                        verticalAlign: 'middle'
                    }
                },
                [`@media (max-width: ${token.screenSMMax}px)`]: {
                    [componentCls]: {
                        maxWidth: 'calc(100vw - 16px)',
                        margin: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.marginXS)} auto`
                    },
                    [`${componentCls}-centered`]: {
                        [componentCls]: {
                            flex: 1
                        }
                    }
                }
            }
        },
        // ======================== Modal ========================
        {
            [componentCls]: {
                ...(0, $2f353af2b0f7600b$export$23997c3e44cc1c59)(token),
                pointerEvents: 'none',
                position: 'relative',
                top: 100,
                width: 'auto',
                maxWidth: `calc(100vw - ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.calc(token.margin).mul(2).equal())})`,
                margin: '0 auto',
                paddingBottom: token.paddingLG,
                [`${componentCls}-title`]: {
                    margin: 0,
                    color: token.titleColor,
                    fontWeight: token.fontWeightStrong,
                    fontSize: token.titleFontSize,
                    lineHeight: token.titleLineHeight,
                    wordWrap: 'break-word'
                },
                [`${componentCls}-container`]: {
                    position: 'relative',
                    backgroundColor: token.contentBg,
                    backgroundClip: 'padding-box',
                    border: 0,
                    borderRadius: token.borderRadiusLG,
                    boxShadow: token.boxShadow,
                    pointerEvents: 'auto',
                    padding: token.contentPadding
                },
                [`${componentCls}-close`]: {
                    position: 'absolute',
                    top: token.calc(token.modalHeaderHeight).sub(token.modalCloseBtnSize).div(2).equal(),
                    insetInlineEnd: token.calc(token.modalHeaderHeight).sub(token.modalCloseBtnSize).div(2).equal(),
                    zIndex: token.calc(token.zIndexPopupBase).add(10).equal(),
                    padding: 0,
                    color: token.modalCloseIconColor,
                    fontWeight: token.fontWeightStrong,
                    lineHeight: 1,
                    textDecoration: 'none',
                    background: 'transparent',
                    borderRadius: token.borderRadiusSM,
                    width: token.modalCloseBtnSize,
                    height: token.modalCloseBtnSize,
                    border: 0,
                    outline: 0,
                    cursor: 'pointer',
                    transition: `color ${token.motionDurationMid}, background-color ${token.motionDurationMid}`,
                    '&-x': {
                        display: 'flex',
                        fontSize: token.fontSizeLG,
                        fontStyle: 'normal',
                        lineHeight: (0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.modalCloseBtnSize),
                        justifyContent: 'center',
                        textTransform: 'none',
                        textRendering: 'auto'
                    },
                    '&:disabled': {
                        pointerEvents: 'none'
                    },
                    '&:hover': {
                        color: token.modalCloseIconHoverColor,
                        backgroundColor: token.colorBgTextHover,
                        textDecoration: 'none'
                    },
                    '&:active': {
                        backgroundColor: token.colorBgTextActive
                    },
                    ...(0, $2f353af2b0f7600b$export$a44db842bcb28231)(token)
                },
                [`${componentCls}-header`]: {
                    color: token.colorText,
                    background: token.headerBg,
                    borderRadius: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.borderRadiusLG)} ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.borderRadiusLG)} 0 0`,
                    marginBottom: token.headerMarginBottom,
                    padding: token.headerPadding,
                    borderBottom: token.headerBorderBottom
                },
                [`${componentCls}-body`]: {
                    fontSize: token.fontSize,
                    lineHeight: token.lineHeight,
                    wordWrap: 'break-word',
                    padding: token.bodyPadding,
                    [`${componentCls}-body-skeleton`]: {
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        margin: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.margin)} auto`
                    }
                },
                [`${componentCls}-footer`]: {
                    textAlign: 'end',
                    background: token.footerBg,
                    marginTop: token.footerMarginTop,
                    padding: token.footerPadding,
                    borderTop: token.footerBorderTop,
                    borderRadius: token.footerBorderRadius,
                    [`> ${token.antCls}-btn + ${token.antCls}-btn`]: {
                        marginInlineStart: token.marginXS
                    }
                },
                [`${componentCls}-open`]: {
                    overflow: 'hidden'
                }
            }
        },
        // ======================== Pure =========================
        {
            [`${componentCls}-pure-panel`]: {
                top: 'auto',
                padding: 0,
                display: 'flex',
                flexDirection: 'column',
                [`${componentCls}-container,
          ${componentCls}-body,
          ${componentCls}-confirm-body-wrapper`]: {
                    display: 'flex',
                    flexDirection: 'column',
                    flex: 'auto'
                },
                [`${componentCls}-confirm-body`]: {
                    marginBottom: 'auto'
                }
            }
        }
    ];
};
const $71c98052e7bebbb8$var$genRTLStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-root`]: {
            [`${componentCls}-wrap-rtl`]: {
                direction: 'rtl',
                [`${componentCls}-confirm-body`]: {
                    direction: 'rtl'
                }
            }
        }
    };
};
const $71c98052e7bebbb8$var$genResponsiveWidthStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const oriGridMediaSizesMap = (0, $ce8d76ffb364cac8$export$6353f655434817c5)(token);
    const gridMediaSizesMap = {
        ...oriGridMediaSizesMap
    };
    delete gridMediaSizesMap.xs;
    const cssVarPrefix = `--${componentCls.replace('.', '')}-`;
    const responsiveStyles = Object.keys(gridMediaSizesMap).map((key)=>({
            [`@media (min-width: ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(gridMediaSizesMap[key])})`]: {
                width: `var(${cssVarPrefix}${key}-width)`
            }
        }));
    return {
        [`${componentCls}-root`]: {
            [componentCls]: [].concat((0, $3746fb019e1f2ee5$export$2e2bcd8739ae039)(Object.keys(oriGridMediaSizesMap).map((currentKey, index)=>{
                const previousKey = Object.keys(oriGridMediaSizesMap)[index - 1];
                return previousKey ? {
                    [`${cssVarPrefix}${currentKey}-width`]: `var(${cssVarPrefix}${previousKey}-width)`
                } : null;
            })), [
                {
                    width: `var(${cssVarPrefix}xs-width)`
                }
            ], (0, $3746fb019e1f2ee5$export$2e2bcd8739ae039)(responsiveStyles))
        }
    };
};
const $71c98052e7bebbb8$export$362fb92a8f81bbf9 = (token)=>{
    const headerPaddingVertical = token.padding;
    const headerFontSize = token.fontSizeHeading5;
    const headerLineHeight = token.lineHeightHeading5;
    const modalToken = (0, $90c11ca6cb263fd9$export$4950aa0f605343fb)(token, {
        modalHeaderHeight: token.calc(token.calc(headerLineHeight).mul(headerFontSize).equal()).add(token.calc(headerPaddingVertical).mul(2).equal()).equal(),
        modalFooterBorderColorSplit: token.colorSplit,
        modalFooterBorderStyle: token.lineType,
        modalFooterBorderWidth: token.lineWidth,
        modalCloseIconColor: token.colorIcon,
        modalCloseIconHoverColor: token.colorIconHover,
        modalCloseBtnSize: token.controlHeight,
        modalConfirmIconSize: token.fontHeight,
        modalTitleHeight: token.calc(token.titleFontSize).mul(token.titleLineHeight).equal()
    });
    return modalToken;
};
const $71c98052e7bebbb8$export$9ca1be8807fe0675 = (token)=>({
        footerBg: 'transparent',
        headerBg: 'transparent',
        titleLineHeight: token.lineHeightHeading5,
        titleFontSize: token.fontSizeHeading5,
        contentBg: token.colorBgElevated,
        titleColor: token.colorTextHeading,
        // internal
        contentPadding: token.wireframe ? 0 : `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.paddingMD)} ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.paddingContentHorizontalLG)}`,
        headerPadding: token.wireframe ? `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.padding)} ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.paddingLG)}` : 0,
        headerBorderBottom: token.wireframe ? `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorSplit}` : 'none',
        headerMarginBottom: token.wireframe ? 0 : token.marginXS,
        bodyPadding: token.wireframe ? token.paddingLG : 0,
        footerPadding: token.wireframe ? `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.paddingXS)} ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.padding)}` : 0,
        footerBorderTop: token.wireframe ? `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorSplit}` : 'none',
        footerBorderRadius: token.wireframe ? `0 0 ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.borderRadiusLG)} ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.borderRadiusLG)}` : 0,
        footerMarginTop: token.wireframe ? 0 : token.marginSM,
        confirmBodyPadding: token.wireframe ? `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.padding * 2)} ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.padding * 2)} ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.paddingLG)}` : 0,
        confirmIconMarginInlineEnd: token.wireframe ? token.margin : token.marginSM,
        confirmBtnsMarginTop: token.wireframe ? token.marginLG : token.marginSM,
        mask: true
    });
var $71c98052e7bebbb8$export$2e2bcd8739ae039 = (0, $d4a2dc313c4d90a4$export$51ec95de45185b42)('Modal', (token)=>{
    const modalToken = $71c98052e7bebbb8$export$362fb92a8f81bbf9(token);
    return [
        $71c98052e7bebbb8$var$genModalStyle(modalToken),
        $71c98052e7bebbb8$var$genRTLStyle(modalToken),
        $71c98052e7bebbb8$export$8bb6dada04673ddd(modalToken),
        (0, $9783f6e7d4c63d86$export$f5d123412490d9dc)(modalToken, 'zoom'),
        $71c98052e7bebbb8$var$genResponsiveWidthStyle(modalToken)
    ];
}, $71c98052e7bebbb8$export$9ca1be8807fe0675, {
    unitless: {
        titleLineHeight: true
    }
});


"use client";
let $ede8098ff3e6fd70$var$mousePosition;
// ref: https://github.com/ant-design/ant-design/issues/15795
const $ede8098ff3e6fd70$var$getClickPosition = (e)=>{
    $ede8098ff3e6fd70$var$mousePosition = {
        x: e.pageX,
        y: e.pageY
    };
    // 100ms 内发生过点击事件，则从点击位置动画展示
    // 否则直接 zoom 展示
    // 这样可以兼容非点击方式展开
    setTimeout(()=>{
        $ede8098ff3e6fd70$var$mousePosition = null;
    }, 100);
};
// 只有点击事件支持从鼠标位置动画展开
if ((0, $c23ac8a120a875e9$export$7dbdadf5e9653129)()) document.documentElement.addEventListener('click', $ede8098ff3e6fd70$var$getClickPosition, true);
const $ede8098ff3e6fd70$var$Modal = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, open: open, wrapClassName: wrapClassName, centered: centered, getContainer: getContainer, focusTriggerAfterClose: focusTriggerAfterClose = true, style: style, width: width = 520, footer: footer, classNames: classNames, styles: styles, children: children, loading: loading, confirmLoading: confirmLoading, zIndex: customizeZIndex, mousePosition: customizeMousePosition, onOk: onOk, onCancel: onCancel, okButtonProps: okButtonProps, cancelButtonProps: cancelButtonProps, destroyOnHidden: destroyOnHidden, destroyOnClose: destroyOnClose, panelRef: panelRef = null, closable: closable, mask: modalMask, modalRender: modalRender, ...restProps } = props;
    const { getPopupContainer: getContextPopupContainer, getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles, centered: contextCentered, cancelButtonProps: contextCancelButtonProps, okButtonProps: contextOkButtonProps, mask: contextMask } = (0, $dd01e2f5a4b8605d$export$46f4bd6436a25a31)('modal');
    const { modal: modalContext } = $32rMB.useContext((0, $dd01e2f5a4b8605d$export$a92f85ab3e9ad68b));
    const [closableAfterclose, onClose] = $32rMB.useMemo(()=>{
        if (typeof closable === 'boolean') return [
            undefined,
            undefined
        ];
        return [
            closable?.afterClose,
            closable?.onClose
        ];
    }, [
        closable
    ]);
    const prefixCls = getPrefixCls('modal', customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    const [mergedMask, maskBlurClassName] = (0, $5c6bc54560501fe9$export$a4ac1bdd74570410)(modalMask, contextMask, prefixCls);
    const handleCancel = (e)=>{
        if (confirmLoading) return;
        onCancel?.(e);
        onClose?.();
    };
    const handleOk = (e)=>{
        onOk?.(e);
        onClose?.();
    };
    var deprecatedName, newName;
    // Style
    const rootCls = (0, $54b1aecddbbbed4f$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $71c98052e7bebbb8$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const wrapClassNameExtended = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(wrapClassName, {
        [`${prefixCls}-centered`]: centered ?? contextCentered,
        [`${prefixCls}-wrap-rtl`]: direction === 'rtl'
    });
    const dialogFooter = footer !== null && !loading ? /*#__PURE__*/ $hO8yS.createElement((0, $60f45d0a58d14164$export$a06f1c675e846f6f), {
        ...props,
        okButtonProps: {
            ...contextOkButtonProps,
            ...okButtonProps
        },
        onOk: handleOk,
        cancelButtonProps: {
            ...contextCancelButtonProps,
            ...cancelButtonProps
        },
        onCancel: handleCancel
    }) : null;
    const [rawClosable, mergedCloseIcon, closeBtnIsDisabled, ariaProps] = (0, $e985b4f58965653f$export$aa101db403ccf5f3)((0, $e985b4f58965653f$export$51ad9c30389f050b)(props), (0, $e985b4f58965653f$export$51ad9c30389f050b)(modalContext), {
        closable: true,
        closeIcon: /*#__PURE__*/ $hO8yS.createElement((0, $bd33c75627fd73a4$export$2e2bcd8739ae039), {
            className: `${prefixCls}-close-icon`
        }),
        closeIconRender: (icon)=>(0, $60f45d0a58d14164$export$97c34646962d356e)(prefixCls, icon)
    });
    const mergedClosable = rawClosable ? {
        disabled: closeBtnIsDisabled,
        closeIcon: mergedCloseIcon,
        afterClose: closableAfterclose,
        ...ariaProps
    } : false;
    // ============================ modalRender ============================
    const mergedModalRender = modalRender ? (node)=>/*#__PURE__*/ $hO8yS.createElement("div", {
            className: `${prefixCls}-render`
        }, modalRender(node)) : undefined;
    // ============================ Refs ============================
    // Select `ant-modal-container` by `panelRef`
    const panelClassName = `.${prefixCls}-${modalRender ? 'render' : 'container'}`;
    const innerPanelRef = (0, $12fcc0e46b84a670$export$94ab53417567be34)(panelClassName);
    const mergedPanelRef = (0, $2706ed817e87019d$export$ab452c34e8e05029)(panelRef, innerPanelRef);
    // ============================ zIndex ============================
    const [zIndex, contextZIndex] = (0, $15dbea5a917a06ef$export$3e7906d4075187a4)('Modal', customizeZIndex);
    const mergedProps = {
        ...props,
        width: width,
        panelRef: panelRef,
        focusTriggerAfterClose: focusTriggerAfterClose,
        mask: mergedMask,
        zIndex: zIndex
    };
    const [mergedClassNames, mergedStyles] = (0, $4dcf69d8c3d6df5c$export$648566b068f28737)([
        contextClassNames,
        classNames,
        maskBlurClassName
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    // =========================== Width ============================
    const [numWidth, responsiveWidth] = $32rMB.useMemo(()=>{
        if (width && typeof width === 'object') return [
            undefined,
            width
        ];
        return [
            width,
            undefined
        ];
    }, [
        width
    ]);
    const responsiveWidthVars = $32rMB.useMemo(()=>{
        const vars = {};
        if (responsiveWidth) Object.keys(responsiveWidth).forEach((breakpoint)=>{
            const breakpointWidth = responsiveWidth[breakpoint];
            if (breakpointWidth !== undefined) vars[`--${prefixCls}-${breakpoint}-width`] = typeof breakpointWidth === 'number' ? `${breakpointWidth}px` : breakpointWidth;
        });
        return vars;
    }, [
        prefixCls,
        responsiveWidth
    ]);
    // =========================== Render ===========================
    return /*#__PURE__*/ $hO8yS.createElement((0, $8a9bb3ef8b2b36aa$export$2e2bcd8739ae039), {
        form: true,
        space: true
    }, /*#__PURE__*/ $hO8yS.createElement((0, $eb222ded4c5a3427$export$2e2bcd8739ae039).Provider, {
        value: contextZIndex
    }, /*#__PURE__*/ $hO8yS.createElement((0, $91d9356658c122a2$export$2e2bcd8739ae039), {
        width: numWidth,
        ...restProps,
        zIndex: zIndex,
        getContainer: getContainer === undefined ? getContextPopupContainer : getContainer,
        prefixCls: prefixCls,
        rootClassName: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(hashId, rootClassName, cssVarCls, rootCls, mergedClassNames.root),
        rootStyle: mergedStyles.root,
        footer: dialogFooter,
        visible: open,
        mousePosition: customizeMousePosition ?? $ede8098ff3e6fd70$var$mousePosition,
        onClose: handleCancel,
        closable: mergedClosable,
        closeIcon: mergedCloseIcon,
        focusTriggerAfterClose: focusTriggerAfterClose,
        transitionName: (0, $689b5af26dd3c1cd$export$27c72201b1d09951)(rootPrefixCls, 'zoom', props.transitionName),
        maskTransitionName: (0, $689b5af26dd3c1cd$export$27c72201b1d09951)(rootPrefixCls, 'fade', props.maskTransitionName),
        mask: mergedMask,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(hashId, className, contextClassName),
        style: {
            ...contextStyle,
            ...style,
            ...responsiveWidthVars
        },
        classNames: {
            ...mergedClassNames,
            wrapper: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(mergedClassNames.wrapper, wrapClassNameExtended)
        },
        styles: mergedStyles,
        panelRef: mergedPanelRef,
        destroyOnHidden: destroyOnHidden ?? destroyOnClose,
        modalRender: mergedModalRender
    }, loading ? /*#__PURE__*/ $hO8yS.createElement((0, $3791c33551ab7576$export$2e2bcd8739ae039), {
        active: true,
        title: false,
        paragraph: {
            rows: 4
        },
        className: `${prefixCls}-body-skeleton`
    }) : children)));
};
var $ede8098ff3e6fd70$export$2e2bcd8739ae039 = $ede8098ff3e6fd70$var$Modal;


// Style as confirm component




// ============================= Confirm ==============================
const $155fabfb2e676616$var$genModalConfirmStyle = (token)=>{
    const { componentCls: componentCls, titleFontSize: titleFontSize, titleLineHeight: titleLineHeight, modalConfirmIconSize: modalConfirmIconSize, fontSize: fontSize, lineHeight: lineHeight, modalTitleHeight: modalTitleHeight, fontHeight: fontHeight, confirmBodyPadding: confirmBodyPadding } = token;
    const confirmComponentCls = `${componentCls}-confirm`;
    return {
        [confirmComponentCls]: {
            '&-rtl': {
                direction: 'rtl'
            },
            [`${token.antCls}-modal-header`]: {
                display: 'none'
            },
            [`${confirmComponentCls}-body-wrapper`]: {
                ...(0, $2f353af2b0f7600b$export$8c467e8859fdef13)()
            },
            [`&${componentCls} ${componentCls}-body`]: {
                padding: confirmBodyPadding
            },
            // ====================== Body ======================
            [`${confirmComponentCls}-body`]: {
                display: 'flex',
                flexWrap: 'nowrap',
                alignItems: 'start',
                [`> ${token.iconCls}`]: {
                    flex: 'none',
                    fontSize: modalConfirmIconSize,
                    marginInlineEnd: token.confirmIconMarginInlineEnd,
                    marginTop: token.calc(token.calc(fontHeight).sub(modalConfirmIconSize).equal()).div(2).equal()
                },
                [`&-has-title > ${token.iconCls}`]: {
                    marginTop: token.calc(token.calc(modalTitleHeight).sub(modalConfirmIconSize).equal()).div(2).equal()
                }
            },
            [`${confirmComponentCls}-paragraph`]: {
                display: 'flex',
                flexDirection: 'column',
                flex: 'auto',
                rowGap: token.marginXS,
                // https://github.com/ant-design/ant-design/issues/51912
                maxWidth: `calc(100% - ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.marginSM)})`
            },
            // https://github.com/ant-design/ant-design/issues/48159
            [`${token.iconCls} + ${confirmComponentCls}-paragraph`]: {
                maxWidth: `calc(100% - ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.calc(token.modalConfirmIconSize).add(token.marginSM).equal())})`
            },
            [`${confirmComponentCls}-title`]: {
                color: token.colorTextHeading,
                fontWeight: token.fontWeightStrong,
                fontSize: titleFontSize,
                lineHeight: titleLineHeight
            },
            [`${confirmComponentCls}-container`]: {
                color: token.colorText,
                fontSize: fontSize,
                lineHeight: lineHeight
            },
            // ===================== Footer =====================
            [`${confirmComponentCls}-btns`]: {
                textAlign: 'end',
                marginTop: token.confirmBtnsMarginTop,
                [`${token.antCls}-btn + ${token.antCls}-btn`]: {
                    marginBottom: 0,
                    marginInlineStart: token.marginXS
                }
            }
        },
        [`${confirmComponentCls}-error ${confirmComponentCls}-body > ${token.iconCls}`]: {
            color: token.colorError
        },
        [`${confirmComponentCls}-warning ${confirmComponentCls}-body > ${token.iconCls},
        ${confirmComponentCls}-confirm ${confirmComponentCls}-body > ${token.iconCls}`]: {
            color: token.colorWarning
        },
        [`${confirmComponentCls}-info ${confirmComponentCls}-body > ${token.iconCls}`]: {
            color: token.colorInfo
        },
        [`${confirmComponentCls}-success ${confirmComponentCls}-body > ${token.iconCls}`]: {
            color: token.colorSuccess
        }
    };
};
var // ============================== Export ==============================
$155fabfb2e676616$export$2e2bcd8739ae039 = (0, $d4a2dc313c4d90a4$export$1537386bc155ea56)([
    'Modal',
    'confirm'
], (token)=>{
    const modalToken = (0, $71c98052e7bebbb8$export$362fb92a8f81bbf9)(token);
    return $155fabfb2e676616$var$genModalConfirmStyle(modalToken);
}, (0, $71c98052e7bebbb8$export$9ca1be8807fe0675), {
    // confirm is weak than modal since no conflict here
    order: -1000
});


"use client";
const $0f375a90aa0006c9$export$78cf841dc2c9f0b5 = (props)=>{
    const { prefixCls: prefixCls, icon: icon, okText: okText, cancelText: cancelText, confirmPrefixCls: confirmPrefixCls, type: type, okCancel: okCancel, footer: footer, // Legacy for static function usage
    locale: staticLocale, ...restProps } = props;
    // Icon
    let mergedIcon = icon;
    // 支持传入{ icon: null }来隐藏`Modal.confirm`默认的Icon
    if (!icon && icon !== null) switch(type){
        case 'info':
            mergedIcon = /*#__PURE__*/ $hO8yS.createElement((0, $59cfafa07a56daba$export$2e2bcd8739ae039), null);
            break;
        case 'success':
            mergedIcon = /*#__PURE__*/ $hO8yS.createElement((0, $1aa4ade09bf83f85$export$2e2bcd8739ae039), null);
            break;
        case 'error':
            mergedIcon = /*#__PURE__*/ $hO8yS.createElement((0, $88ed6189ad3742f6$export$2e2bcd8739ae039), null);
            break;
        default:
            mergedIcon = /*#__PURE__*/ $hO8yS.createElement((0, $eec2491bdf124fc8$export$2e2bcd8739ae039), null);
    }
    // 默认为 true，保持向下兼容
    const mergedOkCancel = okCancel ?? type === 'confirm';
    const autoFocusButton = props.autoFocusButton === null ? false : props.autoFocusButton || 'ok';
    const [locale] = (0, $c176ccd8a9cbd556$export$2e2bcd8739ae039)('Modal');
    const mergedLocale = staticLocale || locale;
    // ================== Locale Text ==================
    const okTextLocale = okText || (mergedOkCancel ? mergedLocale?.okText : mergedLocale?.justOkText);
    const cancelTextLocale = cancelText || mergedLocale?.cancelText;
    // ================= Context Value =================
    const { closable: closable } = restProps;
    const { onClose: onClose } = closable && typeof closable === 'object' ? closable : {};
    const memoizedValue = $32rMB.useMemo(()=>{
        return {
            autoFocusButton: autoFocusButton,
            cancelTextLocale: cancelTextLocale,
            okTextLocale: okTextLocale,
            mergedOkCancel: mergedOkCancel,
            onClose: onClose,
            ...restProps
        };
    }, [
        autoFocusButton,
        cancelTextLocale,
        okTextLocale,
        mergedOkCancel,
        onClose,
        restProps
    ]);
    // ====================== Footer Origin Node ======================
    const footerOriginNode = /*#__PURE__*/ $hO8yS.createElement($hO8yS.Fragment, null, /*#__PURE__*/ $hO8yS.createElement((0, $764bd5f1e00785e1$export$2e2bcd8739ae039), null), /*#__PURE__*/ $hO8yS.createElement((0, $5eb00002333fb884$export$2e2bcd8739ae039), null));
    const hasTitle = props.title !== undefined && props.title !== null;
    const bodyCls = `${confirmPrefixCls}-body`;
    return /*#__PURE__*/ $hO8yS.createElement("div", {
        className: `${confirmPrefixCls}-body-wrapper`
    }, /*#__PURE__*/ $hO8yS.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(bodyCls, {
            [`${bodyCls}-has-title`]: hasTitle
        })
    }, mergedIcon, /*#__PURE__*/ $hO8yS.createElement("div", {
        className: `${confirmPrefixCls}-paragraph`
    }, hasTitle && /*#__PURE__*/ $hO8yS.createElement("span", {
        className: `${confirmPrefixCls}-title`
    }, props.title), /*#__PURE__*/ $hO8yS.createElement("div", {
        className: `${confirmPrefixCls}-content`
    }, props.content))), footer === undefined || typeof footer === 'function' ? /*#__PURE__*/ $hO8yS.createElement((0, $42172c00ae1d981c$export$7c9538f5f3c365e9), {
        value: memoizedValue
    }, /*#__PURE__*/ $hO8yS.createElement("div", {
        className: `${confirmPrefixCls}-btns`
    }, typeof footer === 'function' ? footer(footerOriginNode, {
        OkBtn: $5eb00002333fb884$export$2e2bcd8739ae039,
        CancelBtn: $764bd5f1e00785e1$export$2e2bcd8739ae039
    }) : footerOriginNode)) : footer, /*#__PURE__*/ $hO8yS.createElement((0, $155fabfb2e676616$export$2e2bcd8739ae039), {
        prefixCls: prefixCls
    }));
};
const $0f375a90aa0006c9$var$ConfirmDialog = (props)=>{
    const { close: close, zIndex: zIndex, maskStyle: maskStyle, direction: direction, prefixCls: prefixCls, wrapClassName: wrapClassName, rootPrefixCls: rootPrefixCls, bodyStyle: bodyStyle, closable: closable = false, onConfirm: onConfirm, styles: styles, title: title, okButtonProps: okButtonProps, cancelButtonProps: cancelButtonProps } = props;
    const { cancelButtonProps: contextCancelButtonProps, okButtonProps: contextOkButtonProps } = (0, $dd01e2f5a4b8605d$export$46f4bd6436a25a31)('modal');
    var deprecatedName, newName;
    const confirmPrefixCls = `${prefixCls}-confirm`;
    const width = props.width || 416;
    const style = props.style || {};
    // 默认为 false，保持旧版默认行为
    const maskClosable = props.maskClosable === undefined ? false : props.maskClosable;
    const classString = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(confirmPrefixCls, `${confirmPrefixCls}-${props.type}`, {
        [`${confirmPrefixCls}-rtl`]: direction === 'rtl'
    }, props.className);
    // ========================= zIndex =========================
    const [, token] = (0, $9481722d146bd166$export$2e2bcd8739ae039)();
    const mergedZIndex = $32rMB.useMemo(()=>{
        if (zIndex !== undefined) return zIndex;
        // Static always use max zIndex
        return token.zIndexPopupBase + (0, $15dbea5a917a06ef$export$33ada7d8845f7e5);
    }, [
        zIndex,
        token
    ]);
    // ========================= Render =========================
    return /*#__PURE__*/ $hO8yS.createElement((0, $ede8098ff3e6fd70$export$2e2bcd8739ae039), {
        ...props,
        className: classString,
        wrapClassName: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)({
            [`${confirmPrefixCls}-centered`]: !!props.centered
        }, wrapClassName),
        onCancel: ()=>{
            close?.({
                triggerCancel: true
            });
            onConfirm?.(false);
        },
        title: title,
        footer: null,
        transitionName: (0, $689b5af26dd3c1cd$export$27c72201b1d09951)(rootPrefixCls || '', 'zoom', props.transitionName),
        maskTransitionName: (0, $689b5af26dd3c1cd$export$27c72201b1d09951)(rootPrefixCls || '', 'fade', props.maskTransitionName),
        maskClosable: maskClosable,
        style: style,
        styles: {
            body: bodyStyle,
            mask: maskStyle,
            ...styles
        },
        width: width,
        zIndex: mergedZIndex,
        closable: closable
    }, /*#__PURE__*/ $hO8yS.createElement($0f375a90aa0006c9$export$78cf841dc2c9f0b5, {
        ...props,
        confirmPrefixCls: confirmPrefixCls,
        okButtonProps: {
            ...contextOkButtonProps,
            ...okButtonProps
        },
        cancelButtonProps: {
            ...contextCancelButtonProps,
            ...cancelButtonProps
        }
    }));
};
const $0f375a90aa0006c9$var$ConfirmDialogWrapper = (props)=>{
    const { rootPrefixCls: rootPrefixCls, iconPrefixCls: iconPrefixCls, direction: direction, theme: theme } = props;
    return /*#__PURE__*/ $hO8yS.createElement((0, $6ff80b51bd11b92e$export$2e2bcd8739ae039), {
        prefixCls: rootPrefixCls,
        iconPrefixCls: iconPrefixCls,
        direction: direction,
        theme: theme
    }, /*#__PURE__*/ $hO8yS.createElement($0f375a90aa0006c9$var$ConfirmDialog, {
        ...props
    }));
};
var $0f375a90aa0006c9$export$2e2bcd8739ae039 = $0f375a90aa0006c9$var$ConfirmDialogWrapper;


const $fe77e43da9ed75d7$var$destroyFns = [];
var $fe77e43da9ed75d7$export$2e2bcd8739ae039 = $fe77e43da9ed75d7$var$destroyFns;



"use client";
let $dd09ee934369f50f$var$defaultRootPrefixCls = '';
function $dd09ee934369f50f$var$getRootPrefixCls() {
    return $dd09ee934369f50f$var$defaultRootPrefixCls;
}
const $dd09ee934369f50f$var$ConfirmDialogWrapper = (props)=>{
    const { prefixCls: customizePrefixCls, getContainer: getContainer, direction: direction } = props;
    const runtimeLocale = (0, $8ffa4a229f480682$export$1b6004afda18cd51)();
    const config = (0, $32rMB.useContext)((0, $dd01e2f5a4b8605d$export$a92f85ab3e9ad68b));
    const rootPrefixCls = $dd09ee934369f50f$var$getRootPrefixCls() || config.getPrefixCls();
    // because Modal.config set rootPrefixCls, which is different from other components
    const prefixCls = customizePrefixCls || `${rootPrefixCls}-modal`;
    let mergedGetContainer = getContainer;
    if (mergedGetContainer === false) mergedGetContainer = undefined;
    return /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $0f375a90aa0006c9$export$2e2bcd8739ae039), {
        ...props,
        rootPrefixCls: rootPrefixCls,
        prefixCls: prefixCls,
        iconPrefixCls: config.iconPrefixCls,
        theme: config.theme,
        direction: direction ?? config.direction,
        locale: config.locale?.Modal ?? runtimeLocale,
        getContainer: mergedGetContainer
    });
};
function $dd09ee934369f50f$export$2e2bcd8739ae039(config) {
    const global = (0, $6ff80b51bd11b92e$export$f9cd1e43211d8a4a)();
    const container = document.createDocumentFragment();
    let currentConfig = {
        ...config,
        close: close,
        open: true
    };
    let timeoutId;
    function destroy(...args) {
        const triggerCancel = args.some((param)=>param?.triggerCancel);
        if (triggerCancel) config.onCancel?.(()=>{}, ...args.slice(1));
        for(let i = 0; i < (0, $fe77e43da9ed75d7$export$2e2bcd8739ae039).length; i++){
            const fn = (0, $fe77e43da9ed75d7$export$2e2bcd8739ae039)[i];
            if (fn === close) {
                (0, $fe77e43da9ed75d7$export$2e2bcd8739ae039).splice(i, 1);
                break;
            }
        }
        (0, $77c6df01f18c5b91$export$121e2d597d222bad)(container).then(()=>{
        // Do nothing
        });
    }
    const scheduleRender = (props)=>{
        clearTimeout(timeoutId);
        /**
     * https://github.com/ant-design/ant-design/issues/23623
     *
     * Sync render blocks React event. Let's make this async.
     */ timeoutId = setTimeout(()=>{
            const rootPrefixCls = global.getPrefixCls(undefined, $dd09ee934369f50f$var$getRootPrefixCls());
            const iconPrefixCls = global.getIconPrefixCls();
            const theme = global.getTheme();
            const dom = /*#__PURE__*/ (0, $N3oW3.default).createElement($dd09ee934369f50f$var$ConfirmDialogWrapper, {
                ...props
            });
            (0, $77c6df01f18c5b91$export$b3890eb0ae9dca99)(/*#__PURE__*/ (0, $N3oW3.default).createElement((0, $6ff80b51bd11b92e$export$2e2bcd8739ae039), {
                prefixCls: rootPrefixCls,
                iconPrefixCls: iconPrefixCls,
                theme: theme
            }, typeof global.holderRender === 'function' ? global.holderRender(dom) : dom), container);
        });
    };
    function close(...args) {
        currentConfig = {
            ...currentConfig,
            open: false,
            afterClose: ()=>{
                if (typeof config.afterClose === 'function') config.afterClose();
                // @ts-ignore
                destroy.apply(this, args);
            }
        };
        scheduleRender(currentConfig);
    }
    function update(configUpdate) {
        if (typeof configUpdate === 'function') currentConfig = configUpdate(currentConfig);
        else currentConfig = {
            ...currentConfig,
            ...configUpdate
        };
        scheduleRender(currentConfig);
    }
    scheduleRender(currentConfig);
    (0, $fe77e43da9ed75d7$export$2e2bcd8739ae039).push(close);
    return {
        destroy: close,
        update: update
    };
}
function $dd09ee934369f50f$export$503fa8fed137d104(props) {
    return {
        ...props,
        type: 'warning'
    };
}
function $dd09ee934369f50f$export$2f728eab0dacbb2e(props) {
    return {
        ...props,
        type: 'info'
    };
}
function $dd09ee934369f50f$export$2b5f8d7f29c805d4(props) {
    return {
        ...props,
        type: 'success'
    };
}
function $dd09ee934369f50f$export$60e9e0884ce12b55(props) {
    return {
        ...props,
        type: 'error'
    };
}
function $dd09ee934369f50f$export$665b64399d4af99c(props) {
    return {
        ...props,
        type: 'confirm'
    };
}
function $dd09ee934369f50f$export$ff0b30c638ae2396({ rootPrefixCls: rootPrefixCls }) {
    $dd09ee934369f50f$var$defaultRootPrefixCls = rootPrefixCls;
}




parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");








"use client";
const $6a65c80a9f37cdc0$var$PurePanel = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, closeIcon: closeIcon, closable: closable, type: type, title: title, children: children, footer: footer, ...restProps } = props;
    const { getPrefixCls: getPrefixCls } = $32rMB.useContext((0, $dd01e2f5a4b8605d$export$a92f85ab3e9ad68b));
    const rootPrefixCls = getPrefixCls();
    const prefixCls = customizePrefixCls || getPrefixCls('modal');
    const rootCls = (0, $54b1aecddbbbed4f$export$2e2bcd8739ae039)(rootPrefixCls);
    const [hashId, cssVarCls] = (0, $71c98052e7bebbb8$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const confirmPrefixCls = `${prefixCls}-confirm`;
    // Choose target props by confirm mark
    let additionalProps = {};
    if (type) additionalProps = {
        closable: closable ?? false,
        title: '',
        footer: '',
        children: /*#__PURE__*/ $hO8yS.createElement((0, $0f375a90aa0006c9$export$78cf841dc2c9f0b5), {
            ...props,
            prefixCls: prefixCls,
            confirmPrefixCls: confirmPrefixCls,
            rootPrefixCls: rootPrefixCls,
            content: children
        })
    };
    else additionalProps = {
        closable: closable ?? true,
        title: title,
        footer: footer !== null && /*#__PURE__*/ $hO8yS.createElement((0, $60f45d0a58d14164$export$a06f1c675e846f6f), {
            ...props
        }),
        children: children
    };
    return /*#__PURE__*/ $hO8yS.createElement((0, $6cd12ab1be94e582$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(hashId, `${prefixCls}-pure-panel`, type && confirmPrefixCls, type && `${confirmPrefixCls}-${type}`, className, cssVarCls, rootCls),
        ...restProps,
        closeIcon: (0, $60f45d0a58d14164$export$97c34646962d356e)(prefixCls, closeIcon),
        closable: closable,
        ...additionalProps
    });
};
var $6a65c80a9f37cdc0$export$2e2bcd8739ae039 = (0, $63c4642dc3601d57$export$29e2a8c3cdb34b03)($6a65c80a9f37cdc0$var$PurePanel);



parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");

parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
const $1fa22041ac2ba133$export$26425c9dd59b4436 = ()=>{
    const [elements, setElements] = $32rMB.useState([]);
    const patchElement = $32rMB.useCallback((element)=>{
        // append a new element to elements (and create a new ref)
        setElements((originElements)=>[].concat((0, $3746fb019e1f2ee5$export$2e2bcd8739ae039)(originElements), [
                element
            ]));
        // return a function that removes the new element out of elements (and create a new ref)
        // it works a little like useEffect
        return ()=>{
            setElements((originElements)=>originElements.filter((ele)=>ele !== element));
        };
    }, []);
    return [
        elements,
        patchElement
    ];
};




parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");




"use client";
const $8e528ae3b48027f9$var$HookModal = ({ afterClose: hookAfterClose, config: config, ...restProps }, ref)=>{
    const [open, setOpen] = $32rMB.useState(true);
    const [innerConfig, setInnerConfig] = $32rMB.useState(config);
    const { direction: direction, getPrefixCls: getPrefixCls } = $32rMB.useContext((0, $dd01e2f5a4b8605d$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('modal');
    const rootPrefixCls = getPrefixCls();
    const afterClose = ()=>{
        hookAfterClose();
        innerConfig.afterClose?.();
    };
    const close = (...args)=>{
        setOpen(false);
        const triggerCancel = args.some((param)=>param?.triggerCancel);
        if (triggerCancel) innerConfig.onCancel?.(()=>{}, ...args.slice(1));
    };
    $32rMB.useImperativeHandle(ref, ()=>({
            destroy: close,
            update: (newConfig)=>{
                setInnerConfig((originConfig)=>{
                    const nextConfig = typeof newConfig === 'function' ? newConfig(originConfig) : newConfig;
                    return {
                        ...originConfig,
                        ...nextConfig
                    };
                });
            }
        }));
    const mergedOkCancel = innerConfig.okCancel ?? innerConfig.type === 'confirm';
    const [contextLocale] = (0, $c176ccd8a9cbd556$export$2e2bcd8739ae039)('Modal', (0, $e154e9cb01eacc19$export$2e2bcd8739ae039).Modal);
    return /*#__PURE__*/ $hO8yS.createElement((0, $0f375a90aa0006c9$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        rootPrefixCls: rootPrefixCls,
        ...innerConfig,
        close: close,
        open: open,
        afterClose: afterClose,
        okText: innerConfig.okText || (mergedOkCancel ? contextLocale?.okText : contextLocale?.justOkText),
        direction: innerConfig.direction || direction,
        cancelText: innerConfig.cancelText || contextLocale?.cancelText,
        ...restProps
    });
};
var $8e528ae3b48027f9$export$2e2bcd8739ae039 = /*#__PURE__*/ $N3oW3.forwardRef($8e528ae3b48027f9$var$HookModal);


"use client";
let $e29358c4e50f0e4c$var$uuid = 0;
const $e29358c4e50f0e4c$var$ElementsHolder = /*#__PURE__*/ $N3oW3.memo(/*#__PURE__*/ $N3oW3.forwardRef((_props, ref)=>{
    const [elements, patchElement] = (0, $1fa22041ac2ba133$export$26425c9dd59b4436)();
    $32rMB.useImperativeHandle(ref, ()=>({
            patchElement: patchElement
        }), [
        patchElement
    ]);
    return /*#__PURE__*/ $hO8yS.createElement($hO8yS.Fragment, null, elements);
}));
function $e29358c4e50f0e4c$var$useModal() {
    const holderRef = $32rMB.useRef(null);
    // ========================== Effect ==========================
    const [actionQueue, setActionQueue] = $32rMB.useState([]);
    $32rMB.useEffect(()=>{
        if (actionQueue.length) {
            const cloneQueue = (0, $3746fb019e1f2ee5$export$2e2bcd8739ae039)(actionQueue);
            cloneQueue.forEach((action)=>{
                action();
            });
            setActionQueue([]);
        }
    }, [
        actionQueue
    ]);
    // =========================== Hook ===========================
    const getConfirmFunc = $32rMB.useCallback((withFunc)=>function hookConfirm(config) {
            $e29358c4e50f0e4c$var$uuid += 1;
            const modalRef = /*#__PURE__*/ $hO8yS.createRef();
            // Proxy to promise with `onClose`
            let resolvePromise;
            const promise = new Promise((resolve)=>{
                resolvePromise = resolve;
            });
            let silent = false;
            let closeFunc;
            const modal = /*#__PURE__*/ $hO8yS.createElement((0, $8e528ae3b48027f9$export$2e2bcd8739ae039), {
                key: `modal-${$e29358c4e50f0e4c$var$uuid}`,
                config: withFunc(config),
                ref: modalRef,
                afterClose: ()=>{
                    closeFunc?.();
                },
                isSilent: ()=>silent,
                onConfirm: (confirmed)=>{
                    resolvePromise(confirmed);
                }
            });
            closeFunc = holderRef.current?.patchElement(modal);
            if (closeFunc) (0, $fe77e43da9ed75d7$export$2e2bcd8739ae039).push(closeFunc);
            const instance = {
                destroy: ()=>{
                    function destroyAction() {
                        modalRef.current?.destroy();
                    }
                    if (modalRef.current) destroyAction();
                    else setActionQueue((prev)=>[].concat((0, $3746fb019e1f2ee5$export$2e2bcd8739ae039)(prev), [
                            destroyAction
                        ]));
                },
                update: (newConfig)=>{
                    function updateAction() {
                        modalRef.current?.update(newConfig);
                    }
                    if (modalRef.current) updateAction();
                    else setActionQueue((prev)=>[].concat((0, $3746fb019e1f2ee5$export$2e2bcd8739ae039)(prev), [
                            updateAction
                        ]));
                },
                then: (resolve)=>{
                    silent = true;
                    return promise.then(resolve);
                }
            };
            return instance;
        }, []);
    const fns = $32rMB.useMemo(()=>({
            info: getConfirmFunc((0, $dd09ee934369f50f$export$2f728eab0dacbb2e)),
            success: getConfirmFunc((0, $dd09ee934369f50f$export$2b5f8d7f29c805d4)),
            error: getConfirmFunc((0, $dd09ee934369f50f$export$60e9e0884ce12b55)),
            warning: getConfirmFunc((0, $dd09ee934369f50f$export$503fa8fed137d104)),
            confirm: getConfirmFunc((0, $dd09ee934369f50f$export$665b64399d4af99c))
        }), [
        getConfirmFunc
    ]);
    return [
        fns,
        /*#__PURE__*/ $hO8yS.createElement($e29358c4e50f0e4c$var$ElementsHolder, {
            key: "modal-holder",
            ref: holderRef
        })
    ];
}
var $e29358c4e50f0e4c$export$2e2bcd8739ae039 = $e29358c4e50f0e4c$var$useModal;


"use client";
function $4466fd620640c52a$var$modalWarn(props) {
    return (0, $dd09ee934369f50f$export$2e2bcd8739ae039)((0, $dd09ee934369f50f$export$503fa8fed137d104)(props));
}
const $4466fd620640c52a$var$Modal = (0, $ede8098ff3e6fd70$export$2e2bcd8739ae039);
$4466fd620640c52a$var$Modal.useModal = (0, $e29358c4e50f0e4c$export$2e2bcd8739ae039);
$4466fd620640c52a$var$Modal.info = function infoFn(props) {
    return (0, $dd09ee934369f50f$export$2e2bcd8739ae039)((0, $dd09ee934369f50f$export$2f728eab0dacbb2e)(props));
};
$4466fd620640c52a$var$Modal.success = function successFn(props) {
    return (0, $dd09ee934369f50f$export$2e2bcd8739ae039)((0, $dd09ee934369f50f$export$2b5f8d7f29c805d4)(props));
};
$4466fd620640c52a$var$Modal.error = function errorFn(props) {
    return (0, $dd09ee934369f50f$export$2e2bcd8739ae039)((0, $dd09ee934369f50f$export$60e9e0884ce12b55)(props));
};
$4466fd620640c52a$var$Modal.warning = $4466fd620640c52a$var$modalWarn;
$4466fd620640c52a$var$Modal.warn = $4466fd620640c52a$var$modalWarn;
$4466fd620640c52a$var$Modal.confirm = function confirmFn(props) {
    return (0, $dd09ee934369f50f$export$2e2bcd8739ae039)((0, $dd09ee934369f50f$export$665b64399d4af99c)(props));
};
$4466fd620640c52a$var$Modal.destroyAll = function destroyAllFn() {
    while((0, $fe77e43da9ed75d7$export$2e2bcd8739ae039).length){
        const close = (0, $fe77e43da9ed75d7$export$2e2bcd8739ae039).pop();
        if (close) close();
    }
};
$4466fd620640c52a$var$Modal.config = (0, $dd09ee934369f50f$export$ff0b30c638ae2396);
$4466fd620640c52a$var$Modal._InternalPanelDoNotUseOrYouWillBeFired = (0, $6a65c80a9f37cdc0$export$2e2bcd8739ae039);
var $4466fd620640c52a$export$2e2bcd8739ae039 = $4466fd620640c52a$var$Modal;

parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
const $a942291e76081e0b$export$e1053575ddfcb301 = {};
const $a942291e76081e0b$export$91b75cf262680225 = 'rc-table-internal-hook';





parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");

var $N3oW3 = parcelRequire("N3oW3");
function $05171245d73033f8$export$fd42f52fd3ae1109(defaultValue) {
    const Context = /*#__PURE__*/ $hO8yS.createContext(undefined);
    const Provider = ({ value: value, children: children })=>{
        const valueRef = $32rMB.useRef(value);
        valueRef.current = value;
        const [context] = $32rMB.useState(()=>({
                getValue: ()=>valueRef.current,
                listeners: new Set()
            }));
        (0, $60cea2402df671e7$export$2e2bcd8739ae039)(()=>{
            (0, $N3oW3.unstable_batchedUpdates)(()=>{
                context.listeners.forEach((listener)=>{
                    listener(value);
                });
            });
        }, [
            value
        ]);
        return /*#__PURE__*/ $hO8yS.createElement(Context.Provider, {
            value: context
        }, children);
    };
    return {
        Context: Context,
        Provider: Provider,
        defaultValue: defaultValue
    };
}
function $05171245d73033f8$export$fae74005e78b1a27(holder, selector) {
    const eventSelector = (0, $ea93068db096b7d6$export$2e2bcd8739ae039)(typeof selector === 'function' ? selector : (ctx)=>{
        if (selector === undefined) return ctx;
        if (!Array.isArray(selector)) return ctx[selector];
        const obj = {};
        selector.forEach((key)=>{
            obj[key] = ctx[key];
        });
        return obj;
    });
    const context = $32rMB.useContext(holder?.Context);
    const { listeners: listeners, getValue: getValue } = context || {};
    const valueRef = $32rMB.useRef();
    valueRef.current = eventSelector(context ? getValue() : holder?.defaultValue);
    const [, forceUpdate] = $32rMB.useState({});
    (0, $60cea2402df671e7$export$2e2bcd8739ae039)(()=>{
        if (!context) return;
        function trigger(nextValue) {
            const nextSelectorValue = eventSelector(nextValue);
            if (!(0, $5582f7991b7cfce3$export$2e2bcd8739ae039)(valueRef.current, nextSelectorValue, true)) forceUpdate({});
        }
        listeners.add(trigger);
        return ()=>{
            listeners.delete(trigger);
        };
    }, [
        context
    ]);
    return valueRef.current;
}



parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
function $d2c641bfa553ef33$var$_extends() {
    $d2c641bfa553ef33$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d2c641bfa553ef33$var$_extends.apply(this, arguments);
}
function $d2c641bfa553ef33$export$2e2bcd8739ae039() {
    const ImmutableContext = /*#__PURE__*/ $hO8yS.createContext(null);
    /**
   * Get render update mark by `makeImmutable` root.
   * Do not deps on the return value as render times
   * but only use for `useMemo` or `useCallback` deps.
   */ function useImmutableMark() {
        return $32rMB.useContext(ImmutableContext);
    }
    /**
  * Wrapped Component will be marked as Immutable.
  * When Component parent trigger render,
  * it will notice children component (use with `responseImmutable`) node that parent has updated.
  * @param Component Passed Component
  * @param triggerRender Customize trigger `responseImmutable` children re-render logic. Default will always trigger re-render when this component re-render.
  */ function makeImmutable(Component, shouldTriggerRender) {
        const refAble = (0, $2706ed817e87019d$export$c1cec34af06bcf7)(Component);
        const ImmutableComponent = (props, ref)=>{
            const refProps = refAble ? {
                ref: ref
            } : {};
            const renderTimesRef = $32rMB.useRef(0);
            const prevProps = $32rMB.useRef(props);
            // If parent has the context, we do not wrap it
            const mark = useImmutableMark();
            if (mark !== null) return /*#__PURE__*/ $hO8yS.createElement(Component, $d2c641bfa553ef33$var$_extends({}, props, refProps));
            if (// Always trigger re-render if `shouldTriggerRender` is not provided
            !shouldTriggerRender || shouldTriggerRender(prevProps.current, props)) renderTimesRef.current += 1;
            prevProps.current = props;
            return /*#__PURE__*/ $hO8yS.createElement(ImmutableContext.Provider, {
                value: renderTimesRef.current
            }, /*#__PURE__*/ $hO8yS.createElement(Component, $d2c641bfa553ef33$var$_extends({}, props, refProps)));
        };
        return refAble ? /*#__PURE__*/ $N3oW3.forwardRef(ImmutableComponent) : ImmutableComponent;
    }
    /**
   * Wrapped Component with `React.memo`.
   * But will rerender when parent with `makeImmutable` rerender.
   */ function responseImmutable(Component, propsAreEqual) {
        const refAble = (0, $2706ed817e87019d$export$c1cec34af06bcf7)(Component);
        const ImmutableComponent = (props, ref)=>{
            const refProps = refAble ? {
                ref: ref
            } : {};
            useImmutableMark();
            return /*#__PURE__*/ $hO8yS.createElement(Component, $d2c641bfa553ef33$var$_extends({}, props, refProps));
        };
        return /*#__PURE__*/ $N3oW3.memo(refAble ? /*#__PURE__*/ $N3oW3.forwardRef(ImmutableComponent) : ImmutableComponent, propsAreEqual);
    }
    return {
        makeImmutable: makeImmutable,
        responseImmutable: responseImmutable,
        useImmutableMark: useImmutableMark
    };
}


// For legacy usage, we export it directly
const { makeImmutable: $5743dc03de9652dd$export$ffd6d5bef5eaf0a4, responseImmutable: $5743dc03de9652dd$export$e9e4cb9eb9e2b4c4, useImmutableMark: $5743dc03de9652dd$export$c5d829a463bd3201 } = (0, $d2c641bfa553ef33$export$2e2bcd8739ae039)();


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");

const { makeImmutable: $92843d8d43ffd1ab$export$ffd6d5bef5eaf0a4, responseImmutable: $92843d8d43ffd1ab$export$e9e4cb9eb9e2b4c4, useImmutableMark: $92843d8d43ffd1ab$export$c5d829a463bd3201 } = (0, $d2c641bfa553ef33$export$2e2bcd8739ae039)();
const $92843d8d43ffd1ab$var$TableContext = (0, $05171245d73033f8$export$fd42f52fd3ae1109)();
var $92843d8d43ffd1ab$export$2e2bcd8739ae039 = $92843d8d43ffd1ab$var$TableContext;


/* istanbul ignore file */ parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
function $133b4e8d7f1ac052$var$useRenderTimes(props, debug) {
    // Render times
    const timesRef = $32rMB.useRef(0);
    timesRef.current += 1;
    // Props changed
    const propsRef = $32rMB.useRef(props);
    const keys = [];
    Object.keys(props || {}).map((key)=>{
        if (props?.[key] !== propsRef.current?.[key]) keys.push(key);
    });
    propsRef.current = props;
    // Cache keys since React rerender may cause it lost
    const keysRef = $32rMB.useRef([]);
    if (keys.length) keysRef.current = keys;
    $32rMB.useDebugValue(timesRef.current);
    $32rMB.useDebugValue(keysRef.current.join(', '));
    if (debug) console.log(`${debug}:`, timesRef.current, keysRef.current);
    return timesRef.current;
}
var $133b4e8d7f1ac052$export$2e2bcd8739ae039 = ()=>{};
const $133b4e8d7f1ac052$export$e57c788cafefed4f = /*#__PURE__*/ $N3oW3.memo(()=>{
    const times = $133b4e8d7f1ac052$var$useRenderTimes();
    return /*#__PURE__*/ $hO8yS.createElement("h1", null, "Render Times: ", times);
});


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");







var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
// TODO: Remove when use `responsiveImmutable`
const $f74a8d1b487bad26$var$PerfContext = /*#__PURE__*/ $hO8yS.createContext({
    renderWithProps: false
});
var $f74a8d1b487bad26$export$2e2bcd8739ae039 = $f74a8d1b487bad26$var$PerfContext;


const $03a2aa9c51b963e1$var$INTERNAL_KEY_PREFIX = 'RC_TABLE_KEY';
function $03a2aa9c51b963e1$var$toArray(arr) {
    if (arr === undefined || arr === null) return [];
    return Array.isArray(arr) ? arr : [
        arr
    ];
}
function $03a2aa9c51b963e1$export$fd2ca5407d9be470(columns) {
    const columnKeys = [];
    const keys = {};
    columns.forEach((column)=>{
        const { key: key, dataIndex: dataIndex } = column || {};
        let mergedKey = key || $03a2aa9c51b963e1$var$toArray(dataIndex).join('-') || $03a2aa9c51b963e1$var$INTERNAL_KEY_PREFIX;
        while(keys[mergedKey])mergedKey = `${mergedKey}_next`;
        keys[mergedKey] = true;
        columnKeys.push(mergedKey);
    });
    return columnKeys;
}
function $03a2aa9c51b963e1$export$b76e9316566cc26e(val) {
    return val !== null && val !== undefined;
}
function $03a2aa9c51b963e1$export$b1cd2bdabe361feb(value) {
    return typeof value === 'number' && !Number.isNaN(value);
}



function $31fef2bff6df797e$var$isRenderCell(data) {
    return data && typeof data === 'object' && !Array.isArray(data) && !/*#__PURE__*/ $N3oW3.isValidElement(data);
}
function $31fef2bff6df797e$export$2e2bcd8739ae039(record, dataIndex, renderIndex, children, render, shouldCellUpdate) {
    // TODO: Remove this after next major version
    const perfRecord = $32rMB.useContext((0, $f74a8d1b487bad26$export$2e2bcd8739ae039));
    const mark = (0, $92843d8d43ffd1ab$export$c5d829a463bd3201)();
    // ======================== Render ========================
    const retData = (0, $7b0442ce5e42625c$export$2e2bcd8739ae039)(()=>{
        if ((0, $03a2aa9c51b963e1$export$b76e9316566cc26e)(children)) return [
            children
        ];
        const path = dataIndex === null || dataIndex === undefined || dataIndex === '' ? [] : Array.isArray(dataIndex) ? dataIndex : [
            dataIndex
        ];
        const value = (0, $7967876a5e08d9ff$export$2e2bcd8739ae039)(record, path);
        // Customize render node
        let returnChildNode = value;
        let returnCellProps = undefined;
        if (render) {
            const renderData = render(value, record, renderIndex);
            if ($31fef2bff6df797e$var$isRenderCell(renderData)) {
                returnChildNode = renderData.children;
                returnCellProps = renderData.props;
                perfRecord.renderWithProps = true;
            } else returnChildNode = renderData;
        }
        return [
            returnChildNode,
            returnCellProps
        ];
    }, [
        // Force update deps
        mark,
        // Normal deps
        record,
        children,
        dataIndex,
        render,
        renderIndex
    ], (prev, next)=>{
        if (shouldCellUpdate) {
            const [, prevRecord] = prev;
            const [, nextRecord] = next;
            return shouldCellUpdate(nextRecord, prevRecord);
        }
        // Legacy mode should always update
        if (perfRecord.renderWithProps) return true;
        return !(0, $5582f7991b7cfce3$export$2e2bcd8739ae039)(prev, next, true);
    });
    return retData;
}




/** Check if cell is in hover range */ function $85ef1f2033904987$var$inHoverRange(cellStartRow, cellRowSpan, startRow, endRow) {
    const cellEndRow = cellStartRow + cellRowSpan - 1;
    return cellStartRow <= endRow && cellEndRow >= startRow;
}
function $85ef1f2033904987$export$2e2bcd8739ae039(rowIndex, rowSpan) {
    return (0, $05171245d73033f8$export$fae74005e78b1a27)((0, $92843d8d43ffd1ab$export$2e2bcd8739ae039), (ctx)=>{
        const hovering = $85ef1f2033904987$var$inHoverRange(rowIndex, rowSpan || 1, ctx.hoverStartRow, ctx.hoverEndRow);
        return [
            hovering,
            ctx.onHover
        ];
    });
}



function $be7b183a427ed9d8$var$_extends() {
    $be7b183a427ed9d8$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $be7b183a427ed9d8$var$_extends.apply(this, arguments);
}
const $be7b183a427ed9d8$var$getTitleFromCellRenderChildren = ({ ellipsis: ellipsis, rowType: rowType, children: children })=>{
    let title;
    const ellipsisConfig = ellipsis === true ? {
        showTitle: true
    } : ellipsis;
    if (ellipsisConfig && (ellipsisConfig.showTitle || rowType === 'header')) {
        if (typeof children === 'string' || typeof children === 'number') title = children.toString();
        else if (/*#__PURE__*/ $N3oW3.isValidElement(children) && typeof children.props?.children === 'string') title = children.props?.children;
    }
    return title;
};
const $be7b183a427ed9d8$var$Cell = (props)=>{
    const { component: Component, children: children, ellipsis: ellipsis, scope: scope, prefixCls: // Style
    prefixCls, className: className, style: style, align: align, record: // Value
    record, render: render, dataIndex: dataIndex, renderIndex: renderIndex, shouldCellUpdate: shouldCellUpdate, index: // Row
    index, rowType: rowType, colSpan: // Span
    colSpan, rowSpan: rowSpan, fixStart: // Fixed
    fixStart, fixEnd: fixEnd, fixedStartShadow: fixedStartShadow, fixedEndShadow: fixedEndShadow, offsetFixedStartShadow: offsetFixedStartShadow, offsetFixedEndShadow: offsetFixedEndShadow, zIndex: zIndex, zIndexReverse: zIndexReverse, appendNode: // Private
    appendNode, additionalProps: additionalProps = {}, isSticky: isSticky } = props;
    const cellPrefixCls = `${prefixCls}-cell`;
    const { allColumnsFixedLeft: allColumnsFixedLeft, rowHoverable: rowHoverable } = (0, $05171245d73033f8$export$fae74005e78b1a27)((0, $92843d8d43ffd1ab$export$2e2bcd8739ae039), [
        'allColumnsFixedLeft',
        'rowHoverable'
    ]);
    // ====================== Value =======================
    const [childNode, legacyCellProps] = (0, $31fef2bff6df797e$export$2e2bcd8739ae039)(record, dataIndex, renderIndex, children, render, shouldCellUpdate);
    // ====================== Fixed =======================
    const fixedStyle = {};
    const isFixStart = typeof fixStart === 'number' && !allColumnsFixedLeft;
    const isFixEnd = typeof fixEnd === 'number' && !allColumnsFixedLeft;
    const [showFixStartShadow, showFixEndShadow] = (0, $05171245d73033f8$export$fae74005e78b1a27)((0, $92843d8d43ffd1ab$export$2e2bcd8739ae039), ({ scrollInfo: scrollInfo })=>{
        if (!isFixStart && !isFixEnd) return [
            false,
            false
        ];
        const [absScroll, scrollWidth] = scrollInfo;
        const showStartShadow = (isFixStart && fixedStartShadow && absScroll) - // For precision, we not show shadow by default which has better user experience.
        offsetFixedStartShadow >= 1;
        const showEndShadow = (isFixEnd && fixedEndShadow && scrollWidth - absScroll) - // Same as above
        offsetFixedEndShadow > 1;
        return [
            showStartShadow,
            showEndShadow
        ];
    });
    if (isFixStart) {
        fixedStyle.insetInlineStart = fixStart;
        fixedStyle['--z-offset'] = zIndex;
        fixedStyle['--z-offset-reverse'] = zIndexReverse;
    }
    if (isFixEnd) {
        fixedStyle.insetInlineEnd = fixEnd;
        fixedStyle['--z-offset'] = zIndex;
        fixedStyle['--z-offset-reverse'] = zIndexReverse;
    }
    // ================ RowSpan & ColSpan =================
    const mergedColSpan = legacyCellProps?.colSpan ?? additionalProps.colSpan ?? colSpan ?? 1;
    const mergedRowSpan = legacyCellProps?.rowSpan ?? additionalProps.rowSpan ?? rowSpan ?? 1;
    // ====================== Hover =======================
    const [hovering, onHover] = (0, $85ef1f2033904987$export$2e2bcd8739ae039)(index, mergedRowSpan);
    const onMouseEnter = (0, $ea93068db096b7d6$export$2e2bcd8739ae039)((event)=>{
        if (record) onHover(index, index + mergedRowSpan - 1);
        additionalProps?.onMouseEnter?.(event);
    });
    const onMouseLeave = (0, $ea93068db096b7d6$export$2e2bcd8739ae039)((event)=>{
        if (record) onHover(-1, -1);
        additionalProps?.onMouseLeave?.(event);
    });
    // ====================== Render ======================
    if (mergedColSpan === 0 || mergedRowSpan === 0) return null;
    // >>>>> Title
    const title = additionalProps.title ?? $be7b183a427ed9d8$var$getTitleFromCellRenderChildren({
        rowType: rowType,
        ellipsis: ellipsis,
        children: childNode
    });
    // >>>>> ClassName
    const mergedClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(cellPrefixCls, className, {
        // Fixed
        [`${cellPrefixCls}-fix`]: isFixStart || isFixEnd,
        [`${cellPrefixCls}-fix-start`]: isFixStart,
        [`${cellPrefixCls}-fix-end`]: isFixEnd,
        // Fixed shadow
        [`${cellPrefixCls}-fix-start-shadow`]: fixedStartShadow,
        [`${cellPrefixCls}-fix-start-shadow-show`]: fixedStartShadow && showFixStartShadow,
        [`${cellPrefixCls}-fix-end-shadow`]: fixedEndShadow,
        [`${cellPrefixCls}-fix-end-shadow-show`]: fixedEndShadow && showFixEndShadow,
        [`${cellPrefixCls}-ellipsis`]: ellipsis,
        [`${cellPrefixCls}-with-append`]: appendNode,
        [`${cellPrefixCls}-fix-sticky`]: (isFixStart || isFixEnd) && isSticky,
        [`${cellPrefixCls}-row-hover`]: !legacyCellProps && hovering
    }, additionalProps.className, legacyCellProps?.className);
    // >>>>> Style
    const alignStyle = {};
    if (align) alignStyle.textAlign = align;
    // The order is important since user can overwrite style.
    // For example ant-design/ant-design#51763
    const mergedStyle = {
        ...legacyCellProps?.style,
        ...fixedStyle,
        ...alignStyle,
        ...additionalProps.style,
        ...style
    };
    // >>>>> Children Node
    let mergedChildNode = childNode;
    // Not crash if final `childNode` is not validate ReactNode
    if (typeof mergedChildNode === 'object' && !Array.isArray(mergedChildNode) && !/*#__PURE__*/ $N3oW3.isValidElement(mergedChildNode)) mergedChildNode = null;
    if (ellipsis && (fixedStartShadow || fixedEndShadow)) mergedChildNode = /*#__PURE__*/ $hO8yS.createElement("span", {
        className: `${cellPrefixCls}-content`
    }, mergedChildNode);
    return /*#__PURE__*/ $hO8yS.createElement(Component, $be7b183a427ed9d8$var$_extends({}, legacyCellProps, additionalProps, {
        className: mergedClassName,
        style: mergedStyle,
        title: title,
        scope: scope,
        onMouseEnter: rowHoverable ? onMouseEnter : undefined,
        onMouseLeave: rowHoverable ? onMouseLeave : undefined,
        colSpan: mergedColSpan !== 1 ? mergedColSpan : null,
        rowSpan: mergedRowSpan !== 1 ? mergedRowSpan : null
    }), appendNode, mergedChildNode);
};
var $be7b183a427ed9d8$export$2e2bcd8739ae039 = /*#__PURE__*/ $N3oW3.memo($be7b183a427ed9d8$var$Cell);




function $8ca613c82c5fdda2$var$isFixedStart(column) {
    return column.fixed === 'start';
}
function $8ca613c82c5fdda2$var$isFixedEnd(column) {
    return column.fixed === 'end';
}
function $8ca613c82c5fdda2$export$695db918331141f3(colStart, colEnd, columns, stickyOffsets) {
    const startColumn = columns[colStart] || {};
    const endColumn = columns[colEnd] || {};
    let fixStart = null;
    let fixEnd = null;
    if ($8ca613c82c5fdda2$var$isFixedStart(startColumn) && $8ca613c82c5fdda2$var$isFixedStart(endColumn)) fixStart = stickyOffsets.start[colStart];
    else if ($8ca613c82c5fdda2$var$isFixedEnd(endColumn) && $8ca613c82c5fdda2$var$isFixedEnd(startColumn)) fixEnd = stickyOffsets.end[colEnd];
    // check if need to add shadow
    let fixedStartShadow = false;
    let fixedEndShadow = false;
    // Calc `zIndex`.
    // first fixed start (start -> end) column `zIndex` should be greater than next column.
    // first fixed end (end -> start) column `zIndex` should be greater than next column.
    let zIndex = 0;
    let zIndexReverse = 0;
    if (fixStart !== null) {
        fixedStartShadow = !columns[colEnd + 1] || !$8ca613c82c5fdda2$var$isFixedStart(columns[colEnd + 1]);
        zIndex = columns.length * 2 - colStart; // Fix start always overlay fix end
        zIndexReverse = columns.length + colStart;
    }
    if (fixEnd !== null) {
        fixedEndShadow = !columns[colStart - 1] || !$8ca613c82c5fdda2$var$isFixedEnd(columns[colStart - 1]);
        zIndex = colEnd;
        zIndexReverse = columns.length - colEnd; // Fix end always overlay fix start
    }
    // Check if scrollLeft will show the shadow
    let offsetFixedStartShadow = 0;
    let offsetFixedEndShadow = 0;
    if (fixedStartShadow) {
        for(let i = 0; i < colStart; i += 1)if (!$8ca613c82c5fdda2$var$isFixedStart(columns[i])) offsetFixedStartShadow += stickyOffsets.widths[i] || 0;
    }
    if (fixedEndShadow) {
        for(let i = columns.length - 1; i > colEnd; i -= 1)if (!$8ca613c82c5fdda2$var$isFixedEnd(columns[i])) offsetFixedEndShadow += stickyOffsets.widths[i] || 0;
    }
    return {
        fixStart: fixStart,
        fixEnd: fixEnd,
        fixedStartShadow: fixedStartShadow,
        fixedEndShadow: fixedEndShadow,
        offsetFixedStartShadow: offsetFixedStartShadow,
        offsetFixedEndShadow: offsetFixedEndShadow,
        isSticky: stickyOffsets.isSticky,
        zIndex: zIndex,
        zIndexReverse: zIndexReverse
    };
}


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
const $e1f5e23cb36e89fa$var$SummaryContext = /*#__PURE__*/ $hO8yS.createContext({});
var $e1f5e23cb36e89fa$export$2e2bcd8739ae039 = $e1f5e23cb36e89fa$var$SummaryContext;


function $1b96adc6cd1d0d48$var$_extends() {
    $1b96adc6cd1d0d48$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1b96adc6cd1d0d48$var$_extends.apply(this, arguments);
}
const $1b96adc6cd1d0d48$var$SummaryCell = (props)=>{
    const { className: className, index: index, children: children, colSpan: colSpan = 1, rowSpan: rowSpan, align: align } = props;
    const { prefixCls: prefixCls } = (0, $05171245d73033f8$export$fae74005e78b1a27)((0, $92843d8d43ffd1ab$export$2e2bcd8739ae039), [
        'prefixCls'
    ]);
    const { scrollColumnIndex: scrollColumnIndex, stickyOffsets: stickyOffsets, flattenColumns: flattenColumns } = $32rMB.useContext((0, $e1f5e23cb36e89fa$export$2e2bcd8739ae039));
    const lastIndex = index + colSpan - 1;
    const mergedColSpan = lastIndex + 1 === scrollColumnIndex ? colSpan + 1 : colSpan;
    const fixedInfo = $32rMB.useMemo(()=>(0, $8ca613c82c5fdda2$export$695db918331141f3)(index, index + mergedColSpan - 1, flattenColumns, stickyOffsets), [
        index,
        mergedColSpan,
        flattenColumns,
        stickyOffsets
    ]);
    return /*#__PURE__*/ $hO8yS.createElement((0, $be7b183a427ed9d8$export$2e2bcd8739ae039), $1b96adc6cd1d0d48$var$_extends({
        className: className,
        index: index,
        component: "td",
        prefixCls: prefixCls,
        record: null,
        dataIndex: null,
        align: align,
        colSpan: mergedColSpan,
        rowSpan: rowSpan,
        render: ()=>children
    }, fixedInfo));
};
var $1b96adc6cd1d0d48$export$2e2bcd8739ae039 = $1b96adc6cd1d0d48$var$SummaryCell;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
const $f17b03c39bc79cee$var$FooterRow = (props)=>{
    const { children: children, ...restProps } = props;
    return /*#__PURE__*/ $hO8yS.createElement("tr", restProps, children);
};
var $f17b03c39bc79cee$export$2e2bcd8739ae039 = $f17b03c39bc79cee$var$FooterRow;


/**
 * Syntactic sugar. Do not support HOC.
 */ const $3e9cca9a5a4ae63a$var$Summary = (props)=>{
    const { children: children } = props;
    return children;
};
$3e9cca9a5a4ae63a$var$Summary.Row = (0, $f17b03c39bc79cee$export$2e2bcd8739ae039);
$3e9cca9a5a4ae63a$var$Summary.Cell = (0, $1b96adc6cd1d0d48$export$2e2bcd8739ae039);
var $3e9cca9a5a4ae63a$export$2e2bcd8739ae039 = $3e9cca9a5a4ae63a$var$Summary;



const $8cbe79460b8099b9$var$Footer = (props)=>{
    const { children: children, stickyOffsets: stickyOffsets, flattenColumns: flattenColumns } = props;
    const prefixCls = (0, $05171245d73033f8$export$fae74005e78b1a27)((0, $92843d8d43ffd1ab$export$2e2bcd8739ae039), 'prefixCls');
    const lastColumnIndex = flattenColumns.length - 1;
    const scrollColumn = flattenColumns[lastColumnIndex];
    const summaryContext = $32rMB.useMemo(()=>({
            stickyOffsets: stickyOffsets,
            flattenColumns: flattenColumns,
            scrollColumnIndex: scrollColumn?.scrollbar ? lastColumnIndex : null
        }), [
        scrollColumn,
        flattenColumns,
        lastColumnIndex,
        stickyOffsets
    ]);
    return /*#__PURE__*/ $hO8yS.createElement((0, $e1f5e23cb36e89fa$export$2e2bcd8739ae039).Provider, {
        value: summaryContext
    }, /*#__PURE__*/ $hO8yS.createElement("tfoot", {
        className: `${prefixCls}-summary`
    }, children));
};
var $8cbe79460b8099b9$export$2e2bcd8739ae039 = (0, $92843d8d43ffd1ab$export$e9e4cb9eb9e2b4c4)($8cbe79460b8099b9$var$Footer);
const $8cbe79460b8099b9$export$d605f3af09eef683 = (0, $3e9cca9a5a4ae63a$export$2e2bcd8739ae039);


/* istanbul ignore next */ /**
 * This is a syntactic sugar for `columns` prop.
 * So HOC will not work on this.
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
function $6d1292d6252693f0$var$Column(_) {
    return null;
}
var $6d1292d6252693f0$export$2e2bcd8739ae039 = $6d1292d6252693f0$var$Column;


/* istanbul ignore next */ /**
 * This is a syntactic sugar for `columns` prop.
 * So HOC will not work on this.
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
function $f224012d2504dc24$var$ColumnGroup(_) {
    return null;
}
var $f224012d2504dc24$export$2e2bcd8739ae039 = $f224012d2504dc24$var$ColumnGroup;









parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");

parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");



parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
// recursion (flat tree structure)
function $ad26f2b33f716db0$var$fillRecords(list, record, indent, childrenColumnName, expandedKeys, getRowKey, index) {
    const key = getRowKey(record, index);
    list.push({
        record: record,
        indent: indent,
        index: index,
        rowKey: key
    });
    const expanded = expandedKeys?.has(key);
    if (record && Array.isArray(record[childrenColumnName]) && expanded) // expanded state, flat record
    for(let i = 0; i < record[childrenColumnName].length; i += 1)$ad26f2b33f716db0$var$fillRecords(list, record[childrenColumnName][i], indent + 1, childrenColumnName, expandedKeys, getRowKey, i);
}
function $ad26f2b33f716db0$export$2e2bcd8739ae039(data, childrenColumnName, expandedKeys, getRowKey) {
    const arr = $32rMB.useMemo(()=>{
        if (expandedKeys?.size) {
            const list = [];
            // collect flattened record
            for(let i = 0; i < data?.length; i += 1){
                const record = data[i];
                // using array.push or spread operator may cause "Maximum call stack size exceeded" exception if array size is big enough.
                $ad26f2b33f716db0$var$fillRecords(list, record, 0, childrenColumnName, expandedKeys, getRowKey, i);
            }
            return list;
        }
        return data?.map((item, index)=>{
            return {
                record: item,
                indent: 0,
                index: index,
                rowKey: getRowKey(item, index)
            };
        });
    }, [
        data,
        childrenColumnName,
        expandedKeys,
        getRowKey
    ]);
    return arr;
}





parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");








function $d620e8c4690f2986$export$2e2bcd8739ae039(record, rowKey, recordIndex, indent) {
    const context = (0, $05171245d73033f8$export$fae74005e78b1a27)((0, $92843d8d43ffd1ab$export$2e2bcd8739ae039), [
        'prefixCls',
        'fixedInfoList',
        'flattenColumns',
        'expandableType',
        'expandRowByClick',
        'onTriggerExpand',
        'rowClassName',
        'expandedRowClassName',
        'indentSize',
        'expandIcon',
        'expandedRowRender',
        'expandIconColumnIndex',
        'expandedKeys',
        'childrenColumnName',
        'rowExpandable',
        'onRow'
    ]);
    const { flattenColumns: flattenColumns, expandableType: expandableType, expandedKeys: expandedKeys, childrenColumnName: childrenColumnName, onTriggerExpand: onTriggerExpand, rowExpandable: rowExpandable, onRow: onRow, expandRowByClick: expandRowByClick, rowClassName: rowClassName } = context;
    // ======================= Expandable =======================
    // Only when row is not expandable and `children` exist in record
    const nestExpandable = expandableType === 'nest';
    const rowSupportExpand = expandableType === 'row' && (!rowExpandable || rowExpandable(record));
    const mergedExpandable = rowSupportExpand || nestExpandable;
    const expanded = expandedKeys && expandedKeys.has(rowKey);
    const hasNestChildren = childrenColumnName && record && record[childrenColumnName];
    const onInternalTriggerExpand = (0, $ea93068db096b7d6$export$2e2bcd8739ae039)(onTriggerExpand);
    // ========================= onRow ==========================
    const rowProps = onRow?.(record, recordIndex);
    const onRowClick = rowProps?.onClick;
    const onClick = (event, ...args)=>{
        if (expandRowByClick && mergedExpandable) onTriggerExpand(record, event);
        onRowClick?.(event, ...args);
    };
    // ====================== RowClassName ======================
    let computeRowClassName;
    if (typeof rowClassName === 'string') computeRowClassName = rowClassName;
    else if (typeof rowClassName === 'function') computeRowClassName = rowClassName(record, recordIndex, indent);
    // ========================= Column =========================
    const columnsKey = (0, $03a2aa9c51b963e1$export$fd2ca5407d9be470)(flattenColumns);
    return {
        ...context,
        columnsKey: columnsKey,
        nestExpandable: nestExpandable,
        expanded: expanded,
        hasNestChildren: hasNestChildren,
        record: record,
        onTriggerExpand: onInternalTriggerExpand,
        rowSupportExpand: rowSupportExpand,
        expandable: mergedExpandable,
        rowProps: {
            ...rowProps,
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(computeRowClassName, rowProps?.className),
            onClick: onClick
        }
    };
}



parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");



const $ffe8fc1e8a1fce08$var$ExpandedRow = (props)=>{
    const { prefixCls: prefixCls, children: children, component: Component, cellComponent: cellComponent, className: className, expanded: expanded, colSpan: colSpan, isEmpty: isEmpty, stickyOffset: stickyOffset = 0 } = props;
    const { scrollbarSize: scrollbarSize, fixHeader: fixHeader, fixColumn: fixColumn, componentWidth: componentWidth, horizonScroll: horizonScroll } = (0, $05171245d73033f8$export$fae74005e78b1a27)((0, $92843d8d43ffd1ab$export$2e2bcd8739ae039), [
        'scrollbarSize',
        'fixHeader',
        'fixColumn',
        'componentWidth',
        'horizonScroll'
    ]);
    // Cache render node
    let contentNode = children;
    if (isEmpty ? horizonScroll && componentWidth : fixColumn) contentNode = /*#__PURE__*/ $hO8yS.createElement("div", {
        style: {
            width: componentWidth - stickyOffset - (fixHeader && !isEmpty ? scrollbarSize : 0),
            position: 'sticky',
            left: stickyOffset,
            overflow: 'hidden'
        },
        className: `${prefixCls}-expanded-row-fixed`
    }, contentNode);
    return /*#__PURE__*/ $hO8yS.createElement(Component, {
        className: className,
        style: {
            display: expanded ? null : 'none'
        }
    }, /*#__PURE__*/ $hO8yS.createElement((0, $be7b183a427ed9d8$export$2e2bcd8739ae039), {
        component: cellComponent,
        prefixCls: prefixCls,
        colSpan: colSpan
    }, contentNode));
};
var $ffe8fc1e8a1fce08$export$2e2bcd8739ae039 = $ffe8fc1e8a1fce08$var$ExpandedRow;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");

function $3fbfb9594bd9c3cf$export$ae14373a7f810e33({ prefixCls: prefixCls, record: record, onExpand: onExpand, expanded: expanded, expandable: expandable }) {
    const expandClassName = `${prefixCls}-row-expand-icon`;
    if (!expandable) return /*#__PURE__*/ $hO8yS.createElement("span", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(expandClassName, `${prefixCls}-row-spaced`)
    });
    const onClick = (event)=>{
        onExpand(record, event);
        event.stopPropagation();
    };
    return /*#__PURE__*/ $hO8yS.createElement("span", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(expandClassName, {
            [`${prefixCls}-row-expanded`]: expanded,
            [`${prefixCls}-row-collapsed`]: !expanded
        }),
        onClick: onClick
    });
}
function $3fbfb9594bd9c3cf$export$49bec56f6055f375(data, getRowKey, childrenColumnName) {
    const keys = [];
    function dig(list) {
        (list || []).forEach((item, index)=>{
            keys.push(getRowKey(item, index));
            dig(item[childrenColumnName]);
        });
    }
    dig(data);
    return keys;
}
function $3fbfb9594bd9c3cf$export$c5c465afb98f57b6(cls, record, index, indent) {
    if (typeof cls === 'string') return cls;
    if (typeof cls === 'function') return cls(record, index, indent);
    return '';
}


function $1a3ac4c477d773c5$var$_extends() {
    $1a3ac4c477d773c5$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1a3ac4c477d773c5$var$_extends.apply(this, arguments);
}
function $1a3ac4c477d773c5$export$16400ac709c56616(rowInfo, column, colIndex, indent, index, rowKeys = [], expandedRowOffset = 0) {
    const { record: record, prefixCls: prefixCls, columnsKey: columnsKey, fixedInfoList: fixedInfoList, expandIconColumnIndex: expandIconColumnIndex, nestExpandable: nestExpandable, indentSize: indentSize, expandIcon: expandIcon, expanded: expanded, hasNestChildren: hasNestChildren, onTriggerExpand: onTriggerExpand, expandable: expandable, expandedKeys: expandedKeys } = rowInfo;
    const key = columnsKey[colIndex];
    const fixedInfo = fixedInfoList[colIndex];
    // ============= Used for nest expandable =============
    let appendCellNode;
    if (colIndex === (expandIconColumnIndex || 0) && nestExpandable) appendCellNode = /*#__PURE__*/ $hO8yS.createElement($hO8yS.Fragment, null, /*#__PURE__*/ $hO8yS.createElement("span", {
        style: {
            paddingLeft: `${indentSize * indent}px`
        },
        className: `${prefixCls}-row-indent indent-level-${indent}`
    }), expandIcon({
        prefixCls: prefixCls,
        expanded: expanded,
        expandable: hasNestChildren,
        record: record,
        onExpand: onTriggerExpand
    }));
    const additionalCellProps = column.onCell?.(record, index) || {};
    // Expandable row has offset
    if (expandedRowOffset) {
        const { rowSpan: rowSpan = 1 } = additionalCellProps;
        // For expandable row with rowSpan,
        // We should increase the rowSpan if the row is expanded
        if (expandable && rowSpan && colIndex < expandedRowOffset) {
            let currentRowSpan = rowSpan;
            for(let i = index; i < index + rowSpan; i += 1){
                const rowKey = rowKeys[i];
                if (expandedKeys.has(rowKey)) currentRowSpan += 1;
            }
            additionalCellProps.rowSpan = currentRowSpan;
        }
    }
    return {
        key: key,
        fixedInfo: fixedInfo,
        appendCellNode: appendCellNode,
        additionalCellProps: additionalCellProps
    };
}
// ==================================================================================
// ==                                 getCellProps                                 ==
// ==================================================================================
const $1a3ac4c477d773c5$var$BodyRow = (props)=>{
    const { className: className, style: style, classNames: classNames, styles: styles, record: record, index: index, renderIndex: renderIndex, rowKey: rowKey, rowKeys: rowKeys, indent: indent = 0, rowComponent: RowComponent, cellComponent: cellComponent, scopeCellComponent: scopeCellComponent, expandedRowInfo: expandedRowInfo } = props;
    const rowInfo = (0, $d620e8c4690f2986$export$2e2bcd8739ae039)(record, rowKey, index, indent);
    const { prefixCls: prefixCls, flattenColumns: flattenColumns, expandedRowClassName: expandedRowClassName, expandedRowRender: expandedRowRender, rowProps: rowProps, expanded: // Misc
    expanded, rowSupportExpand: rowSupportExpand } = rowInfo;
    // Force render expand row if expanded before
    const expandedRef = $32rMB.useRef(false);
    expandedRef.current ||= expanded;
    // 若没有 expandedRowRender 参数, 将使用 baseRowNode 渲染 Children
    // 此时如果 level > 1 则说明是 expandedRow, 一样需要附加 computedExpandedRowClassName
    const expandedClsName = (0, $3fbfb9594bd9c3cf$export$c5c465afb98f57b6)(expandedRowClassName, record, index, indent);
    // ======================== Base tr row ========================
    const baseRowNode = /*#__PURE__*/ $hO8yS.createElement(RowComponent, $1a3ac4c477d773c5$var$_extends({}, rowProps, {
        "data-row-key": rowKey,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(className, `${prefixCls}-row`, `${prefixCls}-row-level-${indent}`, rowProps?.className, classNames.row, {
            [expandedClsName]: indent >= 1
        }),
        style: {
            ...style,
            ...rowProps?.style,
            ...styles.row
        }
    }), flattenColumns.map((column, colIndex)=>{
        const { render: render, dataIndex: dataIndex, className: columnClassName } = column;
        const { key: key, fixedInfo: fixedInfo, appendCellNode: appendCellNode, additionalCellProps: additionalCellProps } = $1a3ac4c477d773c5$export$16400ac709c56616(rowInfo, column, colIndex, indent, index, rowKeys, expandedRowInfo?.offset);
        return /*#__PURE__*/ $hO8yS.createElement((0, $be7b183a427ed9d8$export$2e2bcd8739ae039), $1a3ac4c477d773c5$var$_extends({
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(columnClassName, classNames.cell),
            style: styles.cell,
            ellipsis: column.ellipsis,
            align: column.align,
            scope: column.rowScope,
            component: column.rowScope ? scopeCellComponent : cellComponent,
            prefixCls: prefixCls,
            key: key,
            record: record,
            index: index,
            renderIndex: renderIndex,
            dataIndex: dataIndex,
            render: render,
            shouldCellUpdate: column.shouldCellUpdate
        }, fixedInfo, {
            appendNode: appendCellNode,
            additionalProps: additionalCellProps
        }));
    }));
    // ======================== Expand Row =========================
    let expandRowNode;
    if (rowSupportExpand && (expandedRef.current || expanded)) {
        const expandContent = expandedRowRender(record, index, indent + 1, expanded);
        expandRowNode = /*#__PURE__*/ $hO8yS.createElement((0, $ffe8fc1e8a1fce08$export$2e2bcd8739ae039), {
            expanded: expanded,
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-expanded-row`, `${prefixCls}-expanded-row-level-${indent + 1}`, expandedClsName),
            prefixCls: prefixCls,
            component: RowComponent,
            cellComponent: cellComponent,
            colSpan: expandedRowInfo ? expandedRowInfo.colSpan : flattenColumns.length,
            isEmpty: false,
            stickyOffset: expandedRowInfo?.sticky
        }, expandContent);
    }
    return /*#__PURE__*/ $hO8yS.createElement($hO8yS.Fragment, null, baseRowNode, expandRowNode);
};
var $1a3ac4c477d773c5$export$2e2bcd8739ae039 = (0, $92843d8d43ffd1ab$export$e9e4cb9eb9e2b4c4)($1a3ac4c477d773c5$var$BodyRow);




var $N3oW3 = parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");

parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");


const $270b2a42a54934a2$var$MeasureCell = (props)=>{
    const { columnKey: columnKey, onColumnResize: onColumnResize, title: title } = props;
    const cellRef = $32rMB.useRef(null);
    (0, $60cea2402df671e7$export$2e2bcd8739ae039)(()=>{
        if (cellRef.current) onColumnResize(columnKey, cellRef.current.offsetWidth);
    }, []);
    return /*#__PURE__*/ $hO8yS.createElement((0, $b8d12c084d14878d$export$2e2bcd8739ae039), {
        data: columnKey
    }, /*#__PURE__*/ $hO8yS.createElement("td", {
        ref: cellRef,
        style: {
            paddingTop: 0,
            paddingBottom: 0,
            borderTop: 0,
            borderBottom: 0,
            height: 0
        }
    }, /*#__PURE__*/ $hO8yS.createElement("div", {
        style: {
            height: 0,
            overflow: 'hidden',
            fontWeight: 'bold'
        }
    }, title || '\xa0')));
};
var $270b2a42a54934a2$export$2e2bcd8739ae039 = $270b2a42a54934a2$var$MeasureCell;





const $9d457237b15ddf87$var$MeasureRow = ({ prefixCls: prefixCls, columnsKey: columnsKey, onColumnResize: onColumnResize, columns: columns })=>{
    const ref = $32rMB.useRef(null);
    const { measureRowRender: measureRowRender } = (0, $05171245d73033f8$export$fae74005e78b1a27)((0, $92843d8d43ffd1ab$export$2e2bcd8739ae039), [
        'measureRowRender'
    ]);
    const measureRow = /*#__PURE__*/ $hO8yS.createElement("tr", {
        "aria-hidden": "true",
        className: `${prefixCls}-measure-row`,
        style: {
            height: 0
        },
        ref: ref
    }, /*#__PURE__*/ $hO8yS.createElement((0, $b8d12c084d14878d$export$2e2bcd8739ae039).Collection, {
        onBatchResize: (infoList)=>{
            if ((0, $218f20156c5f8705$export$2e2bcd8739ae039)(ref.current)) infoList.forEach(({ data: columnKey, size: size })=>{
                onColumnResize(columnKey, size.offsetWidth);
            });
        }
    }, columnsKey.map((columnKey)=>{
        const column = columns.find((col)=>col.key === columnKey);
        const rawTitle = column?.title;
        const titleForMeasure = /*#__PURE__*/ $N3oW3.isValidElement(rawTitle) ? /*#__PURE__*/ $N3oW3.cloneElement(rawTitle, {
            ref: null
        }) : rawTitle;
        return /*#__PURE__*/ $hO8yS.createElement((0, $270b2a42a54934a2$export$2e2bcd8739ae039), {
            key: columnKey,
            columnKey: columnKey,
            onColumnResize: onColumnResize,
            title: titleForMeasure
        });
    })));
    return typeof measureRowRender === 'function' ? measureRowRender(measureRow) : measureRow;
};
var $9d457237b15ddf87$export$2e2bcd8739ae039 = $9d457237b15ddf87$var$MeasureRow;


const $1b8c9078f50fff0d$var$Body = (props)=>{
    const { data: data, measureColumnWidth: measureColumnWidth } = props;
    const { prefixCls: prefixCls, getComponent: getComponent, onColumnResize: onColumnResize, flattenColumns: flattenColumns, getRowKey: getRowKey, expandedKeys: expandedKeys, childrenColumnName: childrenColumnName, emptyNode: emptyNode, classNames: classNames, styles: styles, expandedRowOffset: expandedRowOffset = 0, colWidths: colWidths } = (0, $05171245d73033f8$export$fae74005e78b1a27)((0, $92843d8d43ffd1ab$export$2e2bcd8739ae039), [
        'prefixCls',
        'getComponent',
        'onColumnResize',
        'flattenColumns',
        'getRowKey',
        'expandedKeys',
        'childrenColumnName',
        'emptyNode',
        'classNames',
        'styles',
        'expandedRowOffset',
        'fixedInfoList',
        'colWidths'
    ]);
    const { body: bodyCls = {} } = classNames || {};
    const { body: bodyStyles = {} } = styles || {};
    const flattenData = (0, $ad26f2b33f716db0$export$2e2bcd8739ae039)(data, childrenColumnName, expandedKeys, getRowKey);
    const rowKeys = $32rMB.useMemo(()=>flattenData.map((item)=>item.rowKey), [
        flattenData
    ]);
    // =================== Performance ====================
    const perfRef = $32rMB.useRef({
        renderWithProps: false
    });
    // ===================== Expanded =====================
    // `expandedRowOffset` data is same for all the rows.
    // Let's calc on Body side to save performance.
    const expandedRowInfo = $32rMB.useMemo(()=>{
        const expandedColSpan = flattenColumns.length - expandedRowOffset;
        let expandedStickyStart = 0;
        for(let i = 0; i < expandedRowOffset; i += 1)expandedStickyStart += colWidths[i] || 0;
        return {
            offset: expandedRowOffset,
            colSpan: expandedColSpan,
            sticky: expandedStickyStart
        };
    }, [
        flattenColumns.length,
        expandedRowOffset,
        colWidths
    ]);
    // ====================== Render ======================
    const WrapperComponent = getComponent([
        'body',
        'wrapper'
    ], 'tbody');
    const trComponent = getComponent([
        'body',
        'row'
    ], 'tr');
    const tdComponent = getComponent([
        'body',
        'cell'
    ], 'td');
    const thComponent = getComponent([
        'body',
        'cell'
    ], 'th');
    let rows;
    if (data.length) rows = flattenData.map((item, idx)=>{
        const { record: record, indent: indent, index: renderIndex, rowKey: rowKey } = item;
        return /*#__PURE__*/ $hO8yS.createElement((0, $1a3ac4c477d773c5$export$2e2bcd8739ae039), {
            classNames: bodyCls,
            styles: bodyStyles,
            key: rowKey,
            rowKey: rowKey,
            rowKeys: rowKeys,
            record: record,
            index: idx,
            renderIndex: renderIndex,
            rowComponent: trComponent,
            cellComponent: tdComponent,
            scopeCellComponent: thComponent,
            indent: indent,
            expandedRowInfo: expandedRowInfo
        });
    });
    else rows = /*#__PURE__*/ $hO8yS.createElement((0, $ffe8fc1e8a1fce08$export$2e2bcd8739ae039), {
        expanded: true,
        className: `${prefixCls}-placeholder`,
        prefixCls: prefixCls,
        component: trComponent,
        cellComponent: tdComponent,
        colSpan: flattenColumns.length,
        isEmpty: true
    }, emptyNode);
    const columnsKey = (0, $03a2aa9c51b963e1$export$fd2ca5407d9be470)(flattenColumns);
    return /*#__PURE__*/ $hO8yS.createElement((0, $f74a8d1b487bad26$export$2e2bcd8739ae039).Provider, {
        value: perfRef.current
    }, /*#__PURE__*/ $hO8yS.createElement(WrapperComponent, {
        style: bodyStyles.wrapper,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-tbody`, bodyCls.wrapper)
    }, measureColumnWidth && /*#__PURE__*/ $hO8yS.createElement((0, $9d457237b15ddf87$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        columnsKey: columnsKey,
        onColumnResize: onColumnResize,
        columns: flattenColumns
    }), rows));
};
var $1b8c9078f50fff0d$export$2e2bcd8739ae039 = (0, $92843d8d43ffd1ab$export$e9e4cb9eb9e2b4c4)($1b8c9078f50fff0d$var$Body);


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");

const $46de3cc262a8e698$export$f8dba99c0d5b6b87 = 'RC_TABLE_INTERNAL_COL_DEFINE';
function $46de3cc262a8e698$export$e215b9806eacdfb5(props) {
    const { expandable: expandable, ...legacyExpandableConfig } = props;
    let config;
    if ('expandable' in props) config = {
        ...legacyExpandableConfig,
        ...expandable
    };
    else config = legacyExpandableConfig;
    if (config.showExpandColumn === false) config.expandIconColumnIndex = -1;
    return config;
}




function $b1a1923020420a3f$var$_extends() {
    $b1a1923020420a3f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b1a1923020420a3f$var$_extends.apply(this, arguments);
}
const $b1a1923020420a3f$var$ColGroup = (props)=>{
    const { colWidths: colWidths, columns: columns, columCount: columCount } = props;
    const { tableLayout: tableLayout } = (0, $05171245d73033f8$export$fae74005e78b1a27)((0, $92843d8d43ffd1ab$export$2e2bcd8739ae039), [
        'tableLayout'
    ]);
    const cols = [];
    const len = columCount || columns.length;
    // Only insert col with width & additional props
    // Skip if rest col do not have any useful info
    let mustInsert = false;
    for(let i = len - 1; i >= 0; i -= 1){
        const width = colWidths[i];
        const column = columns && columns[i];
        let additionalProps;
        let minWidth;
        if (column) {
            additionalProps = column[0, $46de3cc262a8e698$export$f8dba99c0d5b6b87];
            // fixed will cause layout problems
            if (tableLayout === 'auto') minWidth = column.minWidth;
        }
        if (width || minWidth || additionalProps || mustInsert) {
            const { columnType: columnType, ...restAdditionalProps } = additionalProps || {};
            cols.unshift(/*#__PURE__*/ $hO8yS.createElement("col", $b1a1923020420a3f$var$_extends({
                key: i,
                style: {
                    width: width,
                    minWidth: minWidth
                }
            }, restAdditionalProps)));
            mustInsert = true;
        }
    }
    return cols.length > 0 ? /*#__PURE__*/ $hO8yS.createElement("colgroup", null, cols) : null;
};
var $b1a1923020420a3f$export$2e2bcd8739ae039 = $b1a1923020420a3f$var$ColGroup;







parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");



function $8f6eb7aa3bd017bc$var$useColumnWidth(colWidths, columCount) {
    return (0, $32rMB.useMemo)(()=>{
        const cloneColumns = [];
        for(let i = 0; i < columCount; i += 1){
            const val = colWidths[i];
            if (val !== undefined) cloneColumns[i] = val;
            else return null;
        }
        return cloneColumns;
    }, [
        colWidths.join('_'),
        columCount
    ]);
}
const $8f6eb7aa3bd017bc$var$FixedHolder = /*#__PURE__*/ $N3oW3.forwardRef((props, ref)=>{
    const { className: className, style: style, noData: noData, columns: columns, flattenColumns: flattenColumns, colWidths: colWidths, colGroup: colGroup, columCount: columCount, stickyOffsets: stickyOffsets, direction: direction, fixHeader: fixHeader, stickyTopOffset: stickyTopOffset, stickyBottomOffset: stickyBottomOffset, stickyClassName: stickyClassName, scrollX: scrollX, tableLayout: tableLayout = 'fixed', onScroll: onScroll, maxContentScroll: maxContentScroll, children: children, ...restProps } = props;
    const { prefixCls: prefixCls, scrollbarSize: scrollbarSize, isSticky: isSticky, getComponent: getComponent } = (0, $05171245d73033f8$export$fae74005e78b1a27)((0, $92843d8d43ffd1ab$export$2e2bcd8739ae039), [
        'prefixCls',
        'scrollbarSize',
        'isSticky',
        'getComponent'
    ]);
    const TableComponent = getComponent([
        'header',
        'table'
    ], 'table');
    const combinationScrollBarSize = isSticky && !fixHeader ? 0 : scrollbarSize;
    // Pass wheel to scroll event
    const scrollRef = $32rMB.useRef(null);
    const setScrollRef = $32rMB.useCallback((element)=>{
        (0, $2706ed817e87019d$export$f17fd18fa51dcb5b)(ref, element);
        (0, $2706ed817e87019d$export$f17fd18fa51dcb5b)(scrollRef, element);
    }, []);
    $32rMB.useEffect(()=>{
        function onWheel(e) {
            const { currentTarget: currentTarget, deltaX: deltaX } = e;
            if (deltaX) {
                const { scrollLeft: scrollLeft, scrollWidth: scrollWidth, clientWidth: clientWidth } = currentTarget;
                const maxScrollWidth = scrollWidth - clientWidth;
                let nextScroll = scrollLeft + deltaX;
                if (direction === 'rtl') {
                    nextScroll = Math.max(-maxScrollWidth, nextScroll);
                    nextScroll = Math.min(0, nextScroll);
                } else {
                    nextScroll = Math.min(maxScrollWidth, nextScroll);
                    nextScroll = Math.max(0, nextScroll);
                }
                onScroll({
                    currentTarget: currentTarget,
                    scrollLeft: nextScroll
                });
                e.preventDefault();
            }
        }
        const scrollEle = scrollRef.current;
        scrollEle?.addEventListener('wheel', onWheel, {
            passive: false
        });
        return ()=>{
            scrollEle?.removeEventListener('wheel', onWheel);
        };
    }, []);
    // Add scrollbar column
    const lastColumn = flattenColumns[flattenColumns.length - 1];
    const ScrollBarColumn = {
        fixed: lastColumn ? lastColumn.fixed : null,
        scrollbar: true,
        onHeaderCell: ()=>({
                className: `${prefixCls}-cell-scrollbar`
            })
    };
    const columnsWithScrollbar = (0, $32rMB.useMemo)(()=>combinationScrollBarSize ? [
            ...columns,
            ScrollBarColumn
        ] : columns, [
        combinationScrollBarSize,
        columns
    ]);
    const flattenColumnsWithScrollbar = (0, $32rMB.useMemo)(()=>combinationScrollBarSize ? [
            ...flattenColumns,
            ScrollBarColumn
        ] : flattenColumns, [
        combinationScrollBarSize,
        flattenColumns
    ]);
    // Calculate the sticky offsets
    const headerStickyOffsets = (0, $32rMB.useMemo)(()=>{
        const { start: start, end: end } = stickyOffsets;
        return {
            ...stickyOffsets,
            // left:
            //   direction === 'rtl' ? [...left.map(width => width + combinationScrollBarSize), 0] : left,
            // right:
            //   direction === 'rtl' ? right : [...right.map(width => width + combinationScrollBarSize), 0],
            start: start,
            end: [
                ...end.map((width)=>width + combinationScrollBarSize),
                0
            ],
            isSticky: isSticky
        };
    }, [
        combinationScrollBarSize,
        stickyOffsets,
        isSticky
    ]);
    const mergedColumnWidth = $8f6eb7aa3bd017bc$var$useColumnWidth(colWidths, columCount);
    const isColGroupEmpty = (0, $32rMB.useMemo)(()=>{
        // use original ColGroup if no data or no calculated column width, otherwise use calculated column width
        // Return original colGroup if no data, or mergedColumnWidth is empty, or all widths are falsy
        const noWidth = !mergedColumnWidth || !mergedColumnWidth.length || mergedColumnWidth.every((w)=>!w);
        return noData || noWidth;
    }, [
        noData,
        mergedColumnWidth
    ]);
    return /*#__PURE__*/ $hO8yS.createElement("div", {
        style: {
            overflow: 'hidden',
            ...isSticky ? {
                top: stickyTopOffset,
                bottom: stickyBottomOffset
            } : {},
            ...style
        },
        ref: setScrollRef,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(className, {
            [stickyClassName]: !!stickyClassName
        })
    }, /*#__PURE__*/ $hO8yS.createElement(TableComponent, {
        style: {
            tableLayout: tableLayout,
            minWidth: '100%',
            // https://github.com/ant-design/ant-design/issues/54894
            width: scrollX
        }
    }, isColGroupEmpty ? colGroup : /*#__PURE__*/ $hO8yS.createElement((0, $b1a1923020420a3f$export$2e2bcd8739ae039), {
        colWidths: [
            ...mergedColumnWidth,
            combinationScrollBarSize
        ],
        columCount: columCount + 1,
        columns: flattenColumnsWithScrollbar
    }), children({
        ...restProps,
        stickyOffsets: headerStickyOffsets,
        columns: columnsWithScrollbar,
        flattenColumns: flattenColumnsWithScrollbar
    })));
});
var /** Return a table in div as fixed element which contains sticky info */ // export default responseImmutable(FixedHolder);
$8f6eb7aa3bd017bc$export$2e2bcd8739ae039 = /*#__PURE__*/ $N3oW3.memo($8f6eb7aa3bd017bc$var$FixedHolder);




parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");




parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");





function $c8c7e1ee5e483c6b$var$_extends() {
    $c8c7e1ee5e483c6b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c8c7e1ee5e483c6b$var$_extends.apply(this, arguments);
}
const $c8c7e1ee5e483c6b$var$HeaderRow = (props)=>{
    const { cells: cells, stickyOffsets: stickyOffsets, flattenColumns: flattenColumns, rowComponent: RowComponent, cellComponent: CellComponent, onHeaderRow: onHeaderRow, index: index, classNames: classNames, styles: styles } = props;
    const { prefixCls: prefixCls } = (0, $05171245d73033f8$export$fae74005e78b1a27)((0, $92843d8d43ffd1ab$export$2e2bcd8739ae039), [
        'prefixCls'
    ]);
    let rowProps;
    if (onHeaderRow) rowProps = onHeaderRow(cells.map((cell)=>cell.column), index);
    const columnsKey = (0, $03a2aa9c51b963e1$export$fd2ca5407d9be470)(cells.map((cell)=>cell.column));
    return /*#__PURE__*/ $hO8yS.createElement(RowComponent, $c8c7e1ee5e483c6b$var$_extends({}, rowProps, {
        className: classNames.row,
        style: styles.row
    }), cells.map((cell, cellIndex)=>{
        const { column: column, colStart: colStart, colEnd: colEnd, colSpan: colSpan } = cell;
        const fixedInfo = (0, $8ca613c82c5fdda2$export$695db918331141f3)(colStart, colEnd, flattenColumns, stickyOffsets);
        const additionalProps = column?.onHeaderCell?.(column) || {};
        return /*#__PURE__*/ $hO8yS.createElement((0, $be7b183a427ed9d8$export$2e2bcd8739ae039), $c8c7e1ee5e483c6b$var$_extends({}, cell, {
            scope: column.title ? colSpan > 1 ? 'colgroup' : 'col' : null,
            ellipsis: column.ellipsis,
            align: column.align,
            component: CellComponent,
            prefixCls: prefixCls,
            key: columnsKey[cellIndex]
        }, fixedInfo, {
            additionalProps: additionalProps,
            rowType: "header"
        }));
    }));
};
var $c8c7e1ee5e483c6b$export$2e2bcd8739ae039 = $c8c7e1ee5e483c6b$var$HeaderRow;


function $097a12c1c19b9d3a$var$parseHeaderRows(rootColumns, classNames, styles) {
    const rows = [];
    function fillRowCells(columns, colIndex, rowIndex = 0) {
        // Init rows
        rows[rowIndex] = rows[rowIndex] || [];
        let currentColIndex = colIndex;
        const colSpans = columns.filter(Boolean).map((column)=>{
            const cell = {
                key: column.key,
                className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(column.className, classNames.cell) || '',
                style: styles.cell,
                children: column.title,
                column: column,
                colStart: currentColIndex
            };
            let colSpan = 1;
            const subColumns = column.children;
            if (subColumns && subColumns.length > 0) {
                colSpan = fillRowCells(subColumns, currentColIndex, rowIndex + 1).reduce((total, count)=>total + count, 0);
                cell.hasSubColumns = true;
            }
            if ('colSpan' in column) ({ colSpan: colSpan } = column);
            if ('rowSpan' in column) cell.rowSpan = column.rowSpan;
            cell.colSpan = colSpan;
            cell.colEnd = cell.colStart + colSpan - 1;
            rows[rowIndex].push(cell);
            currentColIndex += colSpan;
            return colSpan;
        });
        return colSpans;
    }
    // Generate `rows` cell data
    fillRowCells(rootColumns, 0);
    // Handle `rowSpan`
    const rowCount = rows.length;
    for(let rowIndex = 0; rowIndex < rowCount; rowIndex += 1)rows[rowIndex].forEach((cell)=>{
        if (!('rowSpan' in cell) && !cell.hasSubColumns) // eslint-disable-next-line no-param-reassign
        cell.rowSpan = rowCount - rowIndex;
    });
    return rows;
}
const $097a12c1c19b9d3a$var$Header = (props)=>{
    const { stickyOffsets: stickyOffsets, columns: columns, flattenColumns: flattenColumns, onHeaderRow: onHeaderRow } = props;
    const { prefixCls: prefixCls, getComponent: getComponent, classNames: classNames, styles: styles } = (0, $05171245d73033f8$export$fae74005e78b1a27)((0, $92843d8d43ffd1ab$export$2e2bcd8739ae039), [
        'prefixCls',
        'getComponent',
        'classNames',
        'styles'
    ]);
    const { header: headerCls = {} } = classNames || {};
    const { header: headerStyles = {} } = styles || {};
    const rows = $32rMB.useMemo(()=>$097a12c1c19b9d3a$var$parseHeaderRows(columns, headerCls, headerStyles), [
        columns,
        headerCls,
        headerStyles
    ]);
    const WrapperComponent = getComponent([
        'header',
        'wrapper'
    ], 'thead');
    const trComponent = getComponent([
        'header',
        'row'
    ], 'tr');
    const thComponent = getComponent([
        'header',
        'cell'
    ], 'th');
    return /*#__PURE__*/ $hO8yS.createElement(WrapperComponent, {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-thead`, headerCls.wrapper),
        style: headerStyles.wrapper
    }, rows.map((row, rowIndex)=>{
        const rowNode = /*#__PURE__*/ $hO8yS.createElement((0, $c8c7e1ee5e483c6b$export$2e2bcd8739ae039), {
            classNames: headerCls,
            styles: headerStyles,
            key: rowIndex,
            flattenColumns: flattenColumns,
            cells: row,
            stickyOffsets: stickyOffsets,
            rowComponent: trComponent,
            cellComponent: thComponent,
            onHeaderRow: onHeaderRow,
            index: rowIndex
        });
        return rowNode;
    }));
};
var $097a12c1c19b9d3a$export$2e2bcd8739ae039 = (0, $92843d8d43ffd1ab$export$e9e4cb9eb9e2b4c4)($097a12c1c19b9d3a$var$Header);




parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
function $8fda95e8b9404722$var$parseColWidth(totalWidth, width = '') {
    if (typeof width === 'number') return width;
    if (width.endsWith('%')) return totalWidth * parseFloat(width) / 100;
    return null;
}
function $8fda95e8b9404722$export$2e2bcd8739ae039(flattenColumns, scrollWidth, clientWidth) {
    return $32rMB.useMemo(()=>{
        // Fill width if needed
        if (scrollWidth && scrollWidth > 0) {
            let totalWidth = 0;
            let missWidthCount = 0;
            // collect not given width column
            flattenColumns.forEach((col)=>{
                const colWidth = $8fda95e8b9404722$var$parseColWidth(scrollWidth, col.width);
                if (colWidth) totalWidth += colWidth;
                else missWidthCount += 1;
            });
            // Fill width
            const maxFitWidth = Math.max(scrollWidth, clientWidth);
            let restWidth = Math.max(maxFitWidth - totalWidth, missWidthCount);
            let restCount = missWidthCount;
            const avgWidth = restWidth / missWidthCount;
            let realTotal = 0;
            const filledColumns = flattenColumns.map((col)=>{
                const clone = {
                    ...col
                };
                const colWidth = $8fda95e8b9404722$var$parseColWidth(scrollWidth, clone.width);
                if (colWidth) clone.width = colWidth;
                else {
                    const colAvgWidth = Math.floor(avgWidth);
                    clone.width = restCount === 1 ? restWidth : colAvgWidth;
                    restWidth -= colAvgWidth;
                    restCount -= 1;
                }
                realTotal += clone.width;
                return clone;
            });
            // If realTotal is less than clientWidth,
            // We need extend column width
            if (realTotal < maxFitWidth) {
                const scale = maxFitWidth / realTotal;
                restWidth = maxFitWidth;
                filledColumns.forEach((col, index)=>{
                    const colWidth = Math.floor(col.width * scale);
                    col.width = index === filledColumns.length - 1 ? restWidth : colWidth;
                    restWidth -= colWidth;
                });
            }
            return [
                filledColumns,
                Math.max(realTotal, maxFitWidth)
            ];
        }
        return [
            flattenColumns,
            scrollWidth
        ];
    }, [
        flattenColumns,
        scrollWidth,
        clientWidth
    ]);
}


function $8b582fb443cfdf83$export$d87a97eba44e0f9c(children) {
    return (0, $a60ede783f74e6a9$export$2e2bcd8739ae039)(children).filter((node)=>/*#__PURE__*/ $N3oW3.isValidElement(node)).map((node)=>{
        const { key: key, props: props } = node;
        const { children: nodeChildren, ...restProps } = props;
        const column = {
            key: key,
            ...restProps
        };
        if (nodeChildren) column.children = $8b582fb443cfdf83$export$d87a97eba44e0f9c(nodeChildren);
        return column;
    });
}
function $8b582fb443cfdf83$var$filterHiddenColumns(columns) {
    return columns.filter((column)=>column && typeof column === 'object' && !column.hidden).map((column)=>{
        const subColumns = column.children;
        if (subColumns && subColumns.length > 0) return {
            ...column,
            children: $8b582fb443cfdf83$var$filterHiddenColumns(subColumns)
        };
        return column;
    });
}
function $8b582fb443cfdf83$var$flatColumns(columns, parentKey = 'key') {
    return columns.filter((column)=>column && typeof column === 'object').reduce((list, column, index)=>{
        const { fixed: fixed } = column;
        const parsedFixed = fixed === true || fixed === 'left' ? 'start' : fixed === 'right' ? 'end' : fixed;
        const mergedKey = `${parentKey}-${index}`;
        const subColumns = column.children;
        if (subColumns && subColumns.length > 0) return [
            ...list,
            ...$8b582fb443cfdf83$var$flatColumns(subColumns, mergedKey).map((subColum)=>({
                    ...subColum,
                    fixed: subColum.fixed ?? parsedFixed
                }))
        ];
        return [
            ...list,
            {
                key: mergedKey,
                ...column,
                fixed: parsedFixed
            }
        ];
    }, []);
}
/**
 * Parse `columns` & `children` into `columns`.
 */ function $8b582fb443cfdf83$var$useColumns({ prefixCls: prefixCls, columns: columns, children: children, expandable: expandable, expandedKeys: expandedKeys, columnTitle: columnTitle, getRowKey: getRowKey, onTriggerExpand: onTriggerExpand, expandIcon: expandIcon, rowExpandable: rowExpandable, expandIconColumnIndex: expandIconColumnIndex, expandedRowOffset: expandedRowOffset = 0, direction: direction, expandRowByClick: expandRowByClick, columnWidth: columnWidth, fixed: fixed, scrollWidth: scrollWidth, clientWidth: clientWidth }, transformColumns) {
    const baseColumns = $32rMB.useMemo(()=>{
        const newColumns = columns || $8b582fb443cfdf83$export$d87a97eba44e0f9c(children) || [];
        return $8b582fb443cfdf83$var$filterHiddenColumns(newColumns.slice());
    }, [
        columns,
        children
    ]);
    // ========================== Expand ==========================
    const withExpandColumns = $32rMB.useMemo(()=>{
        if (expandable) {
            let cloneColumns = baseColumns.slice();
            // >>> Insert expand column if not exist
            if (!cloneColumns.includes((0, $a942291e76081e0b$export$e1053575ddfcb301))) {
                const expandColIndex = expandIconColumnIndex || 0;
                const insertIndex = expandColIndex === 0 && (fixed === 'right' || fixed === 'end') ? baseColumns.length : expandColIndex;
                if (insertIndex >= 0) cloneColumns.splice(insertIndex, 0, (0, $a942291e76081e0b$export$e1053575ddfcb301));
            }
            const expandColumnIndex = cloneColumns.indexOf((0, $a942291e76081e0b$export$e1053575ddfcb301));
            cloneColumns = cloneColumns.filter((column, index)=>column !== (0, $a942291e76081e0b$export$e1053575ddfcb301) || index === expandColumnIndex);
            // >>> Check if expand column need to fixed
            const prevColumn = baseColumns[expandColumnIndex];
            let fixedColumn;
            if (fixed) fixedColumn = fixed;
            else fixedColumn = prevColumn ? prevColumn.fixed : null;
            // >>> Create expandable column
            const expandColumn = {
                [(0, $46de3cc262a8e698$export$f8dba99c0d5b6b87)]: {
                    className: `${prefixCls}-expand-icon-col`,
                    columnType: 'EXPAND_COLUMN'
                },
                title: columnTitle,
                fixed: fixedColumn,
                className: `${prefixCls}-row-expand-icon-cell`,
                width: columnWidth,
                render: (_, record, index)=>{
                    const rowKey = getRowKey(record, index);
                    const expanded = expandedKeys.has(rowKey);
                    const recordExpandable = rowExpandable ? rowExpandable(record) : true;
                    const icon = expandIcon({
                        prefixCls: prefixCls,
                        expanded: expanded,
                        expandable: recordExpandable,
                        record: record,
                        onExpand: onTriggerExpand
                    });
                    if (expandRowByClick) return /*#__PURE__*/ $hO8yS.createElement("span", {
                        onClick: (e)=>e.stopPropagation()
                    }, icon);
                    return icon;
                }
            };
            return cloneColumns.map((col, index)=>{
                const column = col === (0, $a942291e76081e0b$export$e1053575ddfcb301) ? expandColumn : col;
                if (index < expandedRowOffset) return {
                    ...column,
                    fixed: column.fixed || 'start'
                };
                return column;
            });
        }
        return baseColumns.filter((col)=>col !== (0, $a942291e76081e0b$export$e1053575ddfcb301));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        expandable,
        baseColumns,
        getRowKey,
        expandedKeys,
        expandIcon,
        direction,
        expandedRowOffset
    ]);
    // ========================= Transform ========================
    const mergedColumns = $32rMB.useMemo(()=>{
        let finalColumns = withExpandColumns;
        if (transformColumns) finalColumns = transformColumns(finalColumns);
        // Always provides at least one column for table display
        if (!finalColumns.length) finalColumns = [
            {
                render: ()=>null
            }
        ];
        return finalColumns;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        transformColumns,
        withExpandColumns,
        direction
    ]);
    // ========================== Flatten =========================
    const flattenColumns = $32rMB.useMemo(()=>$8b582fb443cfdf83$var$flatColumns(mergedColumns), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        mergedColumns,
        direction,
        scrollWidth
    ]);
    // ========================= FillWidth ========================
    const [filledColumns, realScrollWidth] = (0, $8fda95e8b9404722$export$2e2bcd8739ae039)(flattenColumns, scrollWidth, clientWidth);
    return [
        mergedColumns,
        filledColumns,
        realScrollWidth
    ];
}
var $8b582fb443cfdf83$export$2e2bcd8739ae039 = $8b582fb443cfdf83$var$useColumns;



parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");



function $8cc75ab38fb791bd$export$2e2bcd8739ae039(props, mergedData, getRowKey) {
    const expandableConfig = (0, $46de3cc262a8e698$export$e215b9806eacdfb5)(props);
    const { expandIcon: expandIcon, expandedRowKeys: expandedRowKeys, defaultExpandedRowKeys: defaultExpandedRowKeys, defaultExpandAllRows: defaultExpandAllRows, expandedRowRender: expandedRowRender, onExpand: onExpand, onExpandedRowsChange: onExpandedRowsChange, childrenColumnName: childrenColumnName } = expandableConfig;
    const mergedExpandIcon = expandIcon || (0, $3fbfb9594bd9c3cf$export$ae14373a7f810e33);
    const mergedChildrenColumnName = childrenColumnName || 'children';
    const expandableType = $32rMB.useMemo(()=>{
        if (expandedRowRender) return 'row';
        /* eslint-disable no-underscore-dangle */ /**
     * Fix https://github.com/ant-design/ant-design/issues/21154
     * This is a workaround to not to break current behavior.
     * We can remove follow code after final release.
     *
     * To other developer:
     *  Do not use `__PARENT_RENDER_ICON__` in prod since we will remove this when refactor
     */ if (props.expandable && props.internalHooks === (0, $a942291e76081e0b$export$91b75cf262680225) && props.expandable.__PARENT_RENDER_ICON__ || mergedData.some((record)=>record && typeof record === 'object' && record[mergedChildrenColumnName])) return 'nest';
        /* eslint-enable */ return false;
    }, [
        !!expandedRowRender,
        mergedData
    ]);
    const [innerExpandedKeys, setInnerExpandedKeys] = $32rMB.useState(()=>{
        if (defaultExpandedRowKeys) return defaultExpandedRowKeys;
        if (defaultExpandAllRows) return (0, $3fbfb9594bd9c3cf$export$49bec56f6055f375)(mergedData, getRowKey, mergedChildrenColumnName);
        return [];
    });
    const mergedExpandedKeys = $32rMB.useMemo(()=>new Set(expandedRowKeys || innerExpandedKeys || []), [
        expandedRowKeys,
        innerExpandedKeys
    ]);
    const onTriggerExpand = $32rMB.useCallback((record)=>{
        const key = getRowKey(record, mergedData.indexOf(record));
        let newExpandedKeys;
        const hasKey = mergedExpandedKeys.has(key);
        if (hasKey) {
            mergedExpandedKeys.delete(key);
            newExpandedKeys = [
                ...mergedExpandedKeys
            ];
        } else newExpandedKeys = [
            ...mergedExpandedKeys,
            key
        ];
        setInnerExpandedKeys(newExpandedKeys);
        if (onExpand) onExpand(!hasKey, record);
        if (onExpandedRowsChange) onExpandedRowsChange(newExpandedKeys);
    }, [
        getRowKey,
        mergedExpandedKeys,
        mergedData,
        onExpand,
        onExpandedRowsChange
    ]);
    return [
        expandableConfig,
        expandableType,
        mergedExpandedKeys,
        mergedExpandIcon,
        mergedChildrenColumnName,
        onTriggerExpand
    ];
}





parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
function $3d5cc33a31bd9254$export$2e2bcd8739ae039(flattenColumns, stickyOffsets) {
    const fixedInfoList = $32rMB.useMemo(()=>flattenColumns.map((_, colIndex)=>(0, $8ca613c82c5fdda2$export$695db918331141f3)(colIndex, colIndex, flattenColumns, stickyOffsets)), [
        flattenColumns,
        stickyOffsets
    ]);
    return (0, $7b0442ce5e42625c$export$2e2bcd8739ae039)(()=>fixedInfoList, [
        fixedInfoList
    ], (prev, next)=>!(0, $5582f7991b7cfce3$export$2e2bcd8739ae039)(prev, next));
}


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
function $663f6da0899b0414$export$510e4dd13e0b67dd(defaultState) {
    const stateRef = (0, $32rMB.useRef)(defaultState);
    const [, forceUpdate] = (0, $32rMB.useState)({});
    const lastPromiseRef = (0, $32rMB.useRef)(null);
    const updateBatchRef = (0, $32rMB.useRef)([]);
    function setFrameState(updater) {
        updateBatchRef.current.push(updater);
        const promise = Promise.resolve();
        lastPromiseRef.current = promise;
        promise.then(()=>{
            if (lastPromiseRef.current === promise) {
                const prevBatch = updateBatchRef.current;
                const prevState = stateRef.current;
                updateBatchRef.current = [];
                prevBatch.forEach((batchUpdater)=>{
                    stateRef.current = batchUpdater(stateRef.current);
                });
                lastPromiseRef.current = null;
                if (prevState !== stateRef.current) forceUpdate({});
            }
        });
    }
    (0, $32rMB.useEffect)(()=>()=>{
            lastPromiseRef.current = null;
        }, []);
    return [
        stateRef.current,
        setFrameState
    ];
}
function $663f6da0899b0414$export$d63c72d5e6d02249(defaultState) {
    const frameRef = (0, $32rMB.useRef)(defaultState || null);
    const timeoutRef = (0, $32rMB.useRef)(null);
    function cleanUp() {
        clearTimeout(timeoutRef.current);
    }
    function setState(newState) {
        frameRef.current = newState;
        cleanUp();
        timeoutRef.current = setTimeout(()=>{
            frameRef.current = null;
            timeoutRef.current = undefined;
        }, 100);
    }
    function getState() {
        return frameRef.current;
    }
    (0, $32rMB.useEffect)(()=>cleanUp, []);
    return [
        setState,
        getState
    ];
}


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
function $d25d91a3bff27dc8$export$2e2bcd8739ae039() {
    const [startRow, setStartRow] = $32rMB.useState(-1);
    const [endRow, setEndRow] = $32rMB.useState(-1);
    const onHover = $32rMB.useCallback((start, end)=>{
        setStartRow(start);
        setEndRow(end);
    }, []);
    return [
        startRow,
        endRow,
        onHover
    ];
}


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");

// fix ssr render
const $9b99ed46f0621fb3$var$defaultContainer = (0, $bfbc54ac1ac0215e$export$2e2bcd8739ae039)() ? window : null;
function $9b99ed46f0621fb3$export$2e2bcd8739ae039(sticky, prefixCls) {
    const { offsetHeader: offsetHeader = 0, offsetSummary: offsetSummary = 0, offsetScroll: offsetScroll = 0, getContainer: getContainer = ()=>$9b99ed46f0621fb3$var$defaultContainer } = typeof sticky === 'object' ? sticky : {};
    const container = getContainer() || $9b99ed46f0621fb3$var$defaultContainer;
    const isSticky = !!sticky;
    return $32rMB.useMemo(()=>{
        return {
            isSticky: isSticky,
            stickyClassName: isSticky ? `${prefixCls}-sticky-holder` : '',
            offsetHeader: offsetHeader,
            offsetSummary: offsetSummary,
            offsetScroll: offsetScroll,
            container: container
        };
    }, [
        isSticky,
        offsetScroll,
        offsetHeader,
        offsetSummary,
        prefixCls,
        container
    ]);
}


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
/**
 * Get sticky column offset width
 */ function $fd76d67536aa059a$var$useStickyOffsets(colWidths, flattenColumns) {
    const stickyOffsets = (0, $32rMB.useMemo)(()=>{
        const columnCount = flattenColumns.length;
        const getOffsets = (startIndex, endIndex, offset)=>{
            const offsets = [];
            let total = 0;
            for(let i = startIndex; i !== endIndex; i += offset){
                offsets.push(total);
                if (flattenColumns[i].fixed) total += colWidths[i] || 0;
            }
            return offsets;
        };
        const startOffsets = getOffsets(0, columnCount, 1);
        const endOffsets = getOffsets(columnCount - 1, -1, -1).reverse();
        return {
            start: startOffsets,
            end: endOffsets,
            widths: colWidths
        };
    }, [
        colWidths,
        flattenColumns
    ]);
    return stickyOffsets;
}
var $fd76d67536aa059a$export$2e2bcd8739ae039 = $fd76d67536aa059a$var$useStickyOffsets;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
const $baf50f8286f92490$var$Panel = (props)=>{
    const { children: children, className: className, style: style } = props;
    return /*#__PURE__*/ $hO8yS.createElement("div", {
        className: className,
        style: style
    }, children);
};
var $baf50f8286f92490$export$2e2bcd8739ae039 = $baf50f8286f92490$var$Panel;





parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");




function $e2e30c7ba805882c$export$622cea445a1c5b7d(node) {
    const element = (0, $c1d2a04d2d287797$export$9aa546fdc20ae5b3)(node);
    const box = element.getBoundingClientRect();
    const docElem = document.documentElement;
    // < ie8 not support win.pageXOffset, use docElem.scrollLeft instead
    return {
        left: box.left + (window.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || document.body.clientLeft || 0),
        top: box.top + (window.pageYOffset || docElem.scrollTop) - (docElem.clientTop || document.body.clientTop || 0)
    };
}



const $4d903dccd7eb5ca4$var$MOUSEUP_EVENT = 'mouseup';
const $4d903dccd7eb5ca4$var$MOUSEMOVE_EVENT = 'mousemove';
const $4d903dccd7eb5ca4$var$SCROLL_EVENT = 'scroll';
const $4d903dccd7eb5ca4$var$RESIZE_EVENT = 'resize';
const $4d903dccd7eb5ca4$var$StickyScrollBar = (props, ref)=>{
    const { scrollBodyRef: scrollBodyRef, onScroll: onScroll, offsetScroll: offsetScroll, container: container, direction: direction } = props;
    const prefixCls = (0, $05171245d73033f8$export$fae74005e78b1a27)((0, $92843d8d43ffd1ab$export$2e2bcd8739ae039), 'prefixCls');
    const bodyScrollWidth = scrollBodyRef.current?.scrollWidth || 0;
    const bodyWidth = scrollBodyRef.current?.clientWidth || 0;
    const scrollBarWidth = bodyScrollWidth && bodyWidth * (bodyWidth / bodyScrollWidth);
    const scrollBarRef = $32rMB.useRef(null);
    const [scrollState, setScrollState] = (0, $663f6da0899b0414$export$510e4dd13e0b67dd)({
        scrollLeft: 0,
        isHiddenScrollBar: true
    });
    const refState = $32rMB.useRef({
        delta: 0,
        x: 0
    });
    const [isActive, setActive] = $32rMB.useState(false);
    const rafRef = $32rMB.useRef(null);
    $32rMB.useEffect(()=>()=>{
            (0, $c9c36e20d667d30c$export$2e2bcd8739ae039).cancel(rafRef.current);
        }, []);
    const onMouseUp = ()=>{
        setActive(false);
    };
    const onMouseDown = (event)=>{
        event.persist();
        refState.current.delta = event.pageX - scrollState.scrollLeft;
        refState.current.x = 0;
        setActive(true);
        event.preventDefault();
    };
    const onMouseMove = (event)=>{
        // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/buttons
        const { buttons: buttons } = event || window?.event;
        if (!isActive || buttons === 0) {
            // If out body mouse up, we can set isActive false when mouse move
            if (isActive) setActive(false);
            return;
        }
        let left = refState.current.x + event.pageX - refState.current.x - refState.current.delta;
        const isRTL = direction === 'rtl';
        // Limit scroll range
        left = Math.max(isRTL ? scrollBarWidth - bodyWidth : 0, Math.min(isRTL ? 0 : bodyWidth - scrollBarWidth, left));
        // Calculate the scroll position and update
        const shouldScroll = !isRTL || Math.abs(left) + Math.abs(scrollBarWidth) < bodyWidth;
        if (shouldScroll) {
            onScroll({
                scrollLeft: left / bodyWidth * (bodyScrollWidth + 2)
            });
            refState.current.x = event.pageX;
        }
    };
    const checkScrollBarVisible = ()=>{
        (0, $c9c36e20d667d30c$export$2e2bcd8739ae039).cancel(rafRef.current);
        rafRef.current = (0, $c9c36e20d667d30c$export$2e2bcd8739ae039)(()=>{
            if (!scrollBodyRef.current) return;
            const tableOffsetTop = (0, $e2e30c7ba805882c$export$622cea445a1c5b7d)(scrollBodyRef.current).top;
            const tableBottomOffset = tableOffsetTop + scrollBodyRef.current.offsetHeight;
            const currentClientOffset = container === window ? document.documentElement.scrollTop + window.innerHeight : (0, $e2e30c7ba805882c$export$622cea445a1c5b7d)(container).top + container.clientHeight;
            if (tableBottomOffset - (0, $0ea1ccba8e72ea45$export$2e2bcd8739ae039)() <= currentClientOffset || tableOffsetTop >= currentClientOffset - offsetScroll) setScrollState((state)=>({
                    ...state,
                    isHiddenScrollBar: true
                }));
            else setScrollState((state)=>({
                    ...state,
                    isHiddenScrollBar: false
                }));
        });
    };
    const setScrollLeft = (left)=>{
        setScrollState((state)=>{
            return {
                ...state,
                scrollLeft: left / bodyScrollWidth * bodyWidth || 0
            };
        });
    };
    $32rMB.useImperativeHandle(ref, ()=>({
            setScrollLeft: setScrollLeft,
            checkScrollBarVisible: checkScrollBarVisible
        }));
    $32rMB.useEffect(()=>{
        document.body.addEventListener($4d903dccd7eb5ca4$var$MOUSEUP_EVENT, onMouseUp, false);
        document.body.addEventListener($4d903dccd7eb5ca4$var$MOUSEMOVE_EVENT, onMouseMove, false);
        checkScrollBarVisible();
        return ()=>{
            document.body.removeEventListener($4d903dccd7eb5ca4$var$MOUSEUP_EVENT, onMouseUp);
            document.body.removeEventListener($4d903dccd7eb5ca4$var$MOUSEMOVE_EVENT, onMouseMove);
        };
    }, [
        scrollBarWidth,
        isActive
    ]);
    // Loop for scroll event check
    $32rMB.useEffect(()=>{
        if (scrollBodyRef.current) {
            const scrollParents = [];
            let parent = (0, $c1d2a04d2d287797$export$9aa546fdc20ae5b3)(scrollBodyRef.current);
            while(parent){
                scrollParents.push(parent);
                parent = parent.parentElement;
            }
            scrollParents.forEach((p)=>{
                p.addEventListener($4d903dccd7eb5ca4$var$SCROLL_EVENT, checkScrollBarVisible, false);
            });
            window.addEventListener($4d903dccd7eb5ca4$var$RESIZE_EVENT, checkScrollBarVisible, false);
            window.addEventListener($4d903dccd7eb5ca4$var$SCROLL_EVENT, checkScrollBarVisible, false);
            container.addEventListener($4d903dccd7eb5ca4$var$SCROLL_EVENT, checkScrollBarVisible, false);
            return ()=>{
                scrollParents.forEach((p)=>{
                    p.removeEventListener($4d903dccd7eb5ca4$var$SCROLL_EVENT, checkScrollBarVisible);
                });
                window.removeEventListener($4d903dccd7eb5ca4$var$RESIZE_EVENT, checkScrollBarVisible);
                window.removeEventListener($4d903dccd7eb5ca4$var$SCROLL_EVENT, checkScrollBarVisible);
                container.removeEventListener($4d903dccd7eb5ca4$var$SCROLL_EVENT, checkScrollBarVisible);
            };
        }
    }, [
        container
    ]);
    $32rMB.useEffect(()=>{
        if (!scrollState.isHiddenScrollBar) setScrollState((state)=>{
            const bodyNode = scrollBodyRef.current;
            if (!bodyNode) return state;
            return {
                ...state,
                scrollLeft: bodyNode.scrollLeft / bodyNode.scrollWidth * bodyNode.clientWidth
            };
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        scrollState.isHiddenScrollBar
    ]);
    if (bodyScrollWidth <= bodyWidth || !scrollBarWidth || scrollState.isHiddenScrollBar) return null;
    return /*#__PURE__*/ $hO8yS.createElement("div", {
        style: {
            height: (0, $0ea1ccba8e72ea45$export$2e2bcd8739ae039)(),
            width: bodyWidth,
            bottom: offsetScroll
        },
        className: `${prefixCls}-sticky-scroll`
    }, /*#__PURE__*/ $hO8yS.createElement("div", {
        onMouseDown: onMouseDown,
        ref: scrollBarRef,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-sticky-scroll-bar`, {
            [`${prefixCls}-sticky-scroll-bar-active`]: isActive
        }),
        style: {
            width: `${scrollBarWidth}px`,
            transform: `translate3d(${scrollState.scrollLeft}px, 0, 0)`
        }
    }));
};
var $4d903dccd7eb5ca4$export$2e2bcd8739ae039 = /*#__PURE__*/ $N3oW3.forwardRef($4d903dccd7eb5ca4$var$StickyScrollBar);








function $a9ad8dfff2cff25d$var$_extends() {
    $a9ad8dfff2cff25d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a9ad8dfff2cff25d$var$_extends.apply(this, arguments);
}
const $a9ad8dfff2cff25d$export$c42ed95a478b1ec5 = 'rc-table';
// Used for conditions cache
const $a9ad8dfff2cff25d$var$EMPTY_DATA = [];
// Used for customize scroll
const $a9ad8dfff2cff25d$var$EMPTY_SCROLL_TARGET = {};
function $a9ad8dfff2cff25d$var$defaultEmpty() {
    return 'No Data';
}
const $a9ad8dfff2cff25d$var$Table = (tableProps, ref)=>{
    const props = {
        rowKey: 'key',
        prefixCls: $a9ad8dfff2cff25d$export$c42ed95a478b1ec5,
        emptyText: $a9ad8dfff2cff25d$var$defaultEmpty,
        ...tableProps
    };
    const { prefixCls: prefixCls, className: className, rowClassName: rowClassName, style: style, classNames: classNames, styles: styles, data: data, rowKey: rowKey, scroll: scroll, tableLayout: tableLayout, direction: direction, title: // Additional Part
    title, footer: footer, summary: summary, caption: caption, id: // Customize
    id, showHeader: showHeader, components: components, emptyText: emptyText, onRow: onRow, onHeaderRow: onHeaderRow, measureRowRender: // Measure Row
    measureRowRender, onScroll: // Events
    onScroll, internalHooks: // Internal
    internalHooks, transformColumns: transformColumns, internalRefs: internalRefs, tailor: tailor, getContainerWidth: getContainerWidth, sticky: sticky, rowHoverable: rowHoverable = true } = props;
    const mergedData = data || $a9ad8dfff2cff25d$var$EMPTY_DATA;
    const hasData = !!mergedData.length;
    const useInternalHooks = internalHooks === (0, $a942291e76081e0b$export$91b75cf262680225);
    var name;
    // ==================== Customize =====================
    const getComponent = $32rMB.useCallback((path, defaultComponent)=>(0, $7967876a5e08d9ff$export$2e2bcd8739ae039)(components, path) || defaultComponent, [
        components
    ]);
    const getRowKey = $32rMB.useMemo(()=>{
        if (typeof rowKey === 'function') return rowKey;
        return (record)=>{
            const key = record && record[rowKey];
            return key;
        };
    }, [
        rowKey
    ]);
    const customizeScrollBody = getComponent([
        'body'
    ]);
    // ====================== Hover =======================
    const [startRow, endRow, onHover] = (0, $d25d91a3bff27dc8$export$2e2bcd8739ae039)();
    // ====================== Expand ======================
    const [expandableConfig, expandableType, mergedExpandedKeys, mergedExpandIcon, mergedChildrenColumnName, onTriggerExpand] = (0, $8cc75ab38fb791bd$export$2e2bcd8739ae039)(props, mergedData, getRowKey);
    // ====================== Column ======================
    const scrollX = scroll?.x;
    const [componentWidth, setComponentWidth] = $32rMB.useState(0);
    const [columns, flattenColumns, flattenScrollX] = (0, $8b582fb443cfdf83$export$2e2bcd8739ae039)({
        ...props,
        ...expandableConfig,
        expandable: !!expandableConfig.expandedRowRender,
        columnTitle: expandableConfig.columnTitle,
        expandedKeys: mergedExpandedKeys,
        getRowKey: getRowKey,
        onTriggerExpand: // https://github.com/ant-design/ant-design/issues/23894
        onTriggerExpand,
        expandIcon: mergedExpandIcon,
        expandIconColumnIndex: expandableConfig.expandIconColumnIndex,
        direction: direction,
        scrollWidth: useInternalHooks && tailor && typeof scrollX === 'number' ? scrollX : null,
        clientWidth: componentWidth
    }, useInternalHooks ? transformColumns : null);
    const mergedScrollX = flattenScrollX ?? scrollX;
    const columnContext = $32rMB.useMemo(()=>({
            columns: columns,
            flattenColumns: flattenColumns
        }), [
        columns,
        flattenColumns
    ]);
    // ======================= Refs =======================
    const fullTableRef = $32rMB.useRef(null);
    const scrollHeaderRef = $32rMB.useRef(null);
    const scrollBodyRef = $32rMB.useRef(null);
    const scrollBodyContainerRef = $32rMB.useRef(null);
    $32rMB.useImperativeHandle(ref, ()=>{
        return {
            nativeElement: fullTableRef.current,
            scrollTo: (config)=>{
                if (scrollBodyRef.current instanceof HTMLElement) {
                    // Native scroll
                    const { index: index, top: top, key: key, offset: offset } = config;
                    if ((0, $03a2aa9c51b963e1$export$b1cd2bdabe361feb)(top)) // In top mode, offset is ignored
                    scrollBodyRef.current?.scrollTo({
                        top: top
                    });
                    else {
                        const mergedKey = key ?? getRowKey(mergedData[index]);
                        const targetElement = scrollBodyRef.current.querySelector(`[data-row-key="${mergedKey}"]`);
                        if (targetElement) {
                            if (!offset) // No offset, use scrollIntoView for default behavior
                            targetElement.scrollIntoView();
                            else {
                                // With offset, use element's offsetTop + offset
                                const elementTop = targetElement.offsetTop;
                                scrollBodyRef.current.scrollTo({
                                    top: elementTop + offset
                                });
                            }
                        }
                    }
                } else if (scrollBodyRef.current?.scrollTo) // Pass to proxy
                scrollBodyRef.current.scrollTo(config);
            }
        };
    });
    // ====================== Scroll ======================
    const scrollSummaryRef = $32rMB.useRef(null);
    const [shadowStart, setShadowStart] = $32rMB.useState(false);
    const [shadowEnd, setShadowEnd] = $32rMB.useState(false);
    const [colsWidths, updateColsWidths] = $32rMB.useState(new Map());
    // Convert map to number width
    const colsKeys = (0, $03a2aa9c51b963e1$export$fd2ca5407d9be470)(flattenColumns);
    const pureColWidths = colsKeys.map((columnKey)=>colsWidths.get(columnKey));
    const colWidths = $32rMB.useMemo(()=>pureColWidths, [
        pureColWidths.join('_')
    ]);
    const stickyOffsets = (0, $fd76d67536aa059a$export$2e2bcd8739ae039)(colWidths, flattenColumns);
    const fixHeader = scroll && (0, $03a2aa9c51b963e1$export$b76e9316566cc26e)(scroll.y);
    const horizonScroll = scroll && (0, $03a2aa9c51b963e1$export$b76e9316566cc26e)(mergedScrollX) || Boolean(expandableConfig.fixed);
    const fixColumn = horizonScroll && flattenColumns.some(({ fixed: fixed })=>fixed);
    // Sticky
    const stickyRef = $32rMB.useRef(null);
    const { isSticky: isSticky, offsetHeader: offsetHeader, offsetSummary: offsetSummary, offsetScroll: offsetScroll, stickyClassName: stickyClassName, container: container } = (0, $9b99ed46f0621fb3$export$2e2bcd8739ae039)(sticky, prefixCls);
    // Footer (Fix footer must fixed header)
    const summaryNode = $32rMB.useMemo(()=>summary?.(mergedData), [
        summary,
        mergedData
    ]);
    const fixFooter = (fixHeader || isSticky) && /*#__PURE__*/ $N3oW3.isValidElement(summaryNode) && summaryNode.type === (0, $3e9cca9a5a4ae63a$export$2e2bcd8739ae039) && summaryNode.props.fixed;
    // Scroll
    let scrollXStyle;
    let scrollYStyle;
    let scrollTableStyle;
    if (fixHeader) scrollYStyle = {
        overflowY: hasData ? 'scroll' : 'auto',
        maxHeight: scroll.y
    };
    if (horizonScroll) {
        scrollXStyle = {
            overflowX: 'auto'
        };
        // When no vertical scrollbar, should hide it
        // https://github.com/ant-design/ant-design/pull/20705
        // https://github.com/ant-design/ant-design/issues/21879
        if (!fixHeader) scrollYStyle = {
            overflowY: 'hidden'
        };
        scrollTableStyle = {
            width: mergedScrollX === true ? 'auto' : mergedScrollX,
            minWidth: '100%'
        };
    }
    const onColumnResize = $32rMB.useCallback((columnKey, width)=>{
        updateColsWidths((widths)=>{
            if (widths.get(columnKey) !== width) {
                const newWidths = new Map(widths);
                newWidths.set(columnKey, width);
                return newWidths;
            }
            return widths;
        });
    }, []);
    const [setScrollTarget, getScrollTarget] = (0, $663f6da0899b0414$export$d63c72d5e6d02249)(null);
    function forceScroll(scrollLeft, target) {
        if (!target) return;
        if (typeof target === 'function') target(scrollLeft);
        else if (target.scrollLeft !== scrollLeft) {
            target.scrollLeft = scrollLeft;
            // Delay to force scroll position if not sync
            // ref: https://github.com/ant-design/ant-design/issues/37179
            if (target.scrollLeft !== scrollLeft) setTimeout(()=>{
                target.scrollLeft = scrollLeft;
            }, 0);
        }
    }
    const [scrollInfo, setScrollInfo] = $32rMB.useState([
        0,
        0
    ]);
    const onInternalScroll = (0, $ea93068db096b7d6$export$2e2bcd8739ae039)(({ currentTarget: currentTarget, scrollLeft: scrollLeft })=>{
        const mergedScrollLeft = typeof scrollLeft === 'number' ? scrollLeft : currentTarget.scrollLeft;
        const compareTarget = currentTarget || $a9ad8dfff2cff25d$var$EMPTY_SCROLL_TARGET;
        if (!getScrollTarget() || getScrollTarget() === compareTarget) {
            setScrollTarget(compareTarget);
            forceScroll(mergedScrollLeft, scrollHeaderRef.current);
            forceScroll(mergedScrollLeft, scrollBodyRef.current);
            forceScroll(mergedScrollLeft, scrollSummaryRef.current);
            forceScroll(mergedScrollLeft, stickyRef.current?.setScrollLeft);
        }
        const measureTarget = currentTarget || scrollHeaderRef.current;
        if (measureTarget) {
            const scrollWidth = // Should use mergedScrollX in virtual table(useInternalHooks && tailor === true)
            useInternalHooks && tailor && typeof mergedScrollX === 'number' ? mergedScrollX : measureTarget.scrollWidth;
            const clientWidth = measureTarget.clientWidth;
            const absScrollStart = Math.abs(mergedScrollLeft);
            setScrollInfo((ori)=>{
                const nextScrollInfo = [
                    absScrollStart,
                    scrollWidth - clientWidth
                ];
                return (0, $5582f7991b7cfce3$export$2e2bcd8739ae039)(ori, nextScrollInfo) ? ori : nextScrollInfo;
            });
            // There is no space to scroll
            if (scrollWidth === clientWidth) {
                setShadowStart(false);
                setShadowEnd(false);
                return;
            }
            setShadowStart(absScrollStart > 0);
            setShadowEnd(absScrollStart < scrollWidth - clientWidth - 1);
        }
    });
    const onBodyScroll = (0, $ea93068db096b7d6$export$2e2bcd8739ae039)((e)=>{
        onInternalScroll(e);
        onScroll?.(e);
    });
    const triggerOnScroll = ()=>{
        if (horizonScroll && scrollBodyRef.current) onInternalScroll({
            currentTarget: (0, $c1d2a04d2d287797$export$9aa546fdc20ae5b3)(scrollBodyRef.current),
            scrollLeft: scrollBodyRef.current?.scrollLeft
        });
        else {
            setShadowStart(false);
            setShadowEnd(false);
        }
    };
    const onFullTableResize = (offsetWidth)=>{
        stickyRef.current?.checkScrollBarVisible();
        let mergedWidth = offsetWidth ?? fullTableRef.current?.offsetWidth ?? 0;
        if (useInternalHooks && getContainerWidth && fullTableRef.current) mergedWidth = getContainerWidth(fullTableRef.current, mergedWidth) || mergedWidth;
        if (mergedWidth !== componentWidth) {
            triggerOnScroll();
            setComponentWidth(mergedWidth);
        }
    };
    // fix https://github.com/ant-design/ant-design/issues/49279
    (0, $60cea2402df671e7$export$2e2bcd8739ae039)(()=>{
        if (horizonScroll) onFullTableResize();
    }, [
        horizonScroll
    ]);
    // Sync scroll bar when init or `horizonScroll`, `data` and `columns.length` changed
    const mounted = $32rMB.useRef(false);
    $32rMB.useEffect(()=>{
        // onFullTableResize will be trigger once when ResizeObserver is mounted
        // This will reduce one duplicated triggerOnScroll time
        if (mounted.current) triggerOnScroll();
    }, [
        horizonScroll,
        data,
        columns.length
    ]);
    $32rMB.useEffect(()=>{
        mounted.current = true;
    }, []);
    // ===================== Effects ======================
    const [scrollbarSize, setScrollbarSize] = $32rMB.useState(0);
    (0, $60cea2402df671e7$export$2e2bcd8739ae039)(()=>{
        if (!tailor || !useInternalHooks) {
            if (scrollBodyRef.current instanceof Element) setScrollbarSize((0, $0ea1ccba8e72ea45$export$4f3ef2310365b56a)(scrollBodyRef.current).width);
            else setScrollbarSize((0, $0ea1ccba8e72ea45$export$4f3ef2310365b56a)(scrollBodyContainerRef.current).width);
        }
    }, []);
    // ================== INTERNAL HOOKS ==================
    $32rMB.useEffect(()=>{
        if (useInternalHooks && internalRefs) internalRefs.body.current = scrollBodyRef.current;
    });
    // ========================================================================
    // ==                               Render                               ==
    // ========================================================================
    // =================== Render: Func ===================
    const renderFixedHeaderTable = $32rMB.useCallback((fixedHolderPassProps)=>/*#__PURE__*/ $hO8yS.createElement($hO8yS.Fragment, null, /*#__PURE__*/ $hO8yS.createElement((0, $097a12c1c19b9d3a$export$2e2bcd8739ae039), fixedHolderPassProps), fixFooter === 'top' && /*#__PURE__*/ $hO8yS.createElement((0, $8cbe79460b8099b9$export$2e2bcd8739ae039), fixedHolderPassProps, summaryNode)), [
        fixFooter,
        summaryNode
    ]);
    const renderFixedFooterTable = $32rMB.useCallback((fixedHolderPassProps)=>/*#__PURE__*/ $hO8yS.createElement((0, $8cbe79460b8099b9$export$2e2bcd8739ae039), fixedHolderPassProps, summaryNode), [
        summaryNode
    ]);
    // =================== Render: Node ===================
    const TableComponent = getComponent([
        'table'
    ], 'table');
    // Table layout
    const mergedTableLayout = $32rMB.useMemo(()=>{
        if (tableLayout) return tableLayout;
        // https://github.com/ant-design/ant-design/issues/25227
        // When scroll.x is max-content, no need to fix table layout
        // it's width should stretch out to fit content
        if (fixColumn) return mergedScrollX === 'max-content' ? 'auto' : 'fixed';
        if (fixHeader || isSticky || flattenColumns.some(({ ellipsis: ellipsis })=>ellipsis)) return 'fixed';
        return 'auto';
    }, [
        fixHeader,
        fixColumn,
        flattenColumns,
        tableLayout,
        isSticky
    ]);
    let groupTableNode;
    // Header props
    const headerProps = {
        colWidths: colWidths,
        columCount: flattenColumns.length,
        stickyOffsets: stickyOffsets,
        onHeaderRow: onHeaderRow,
        fixHeader: fixHeader,
        scroll: scroll
    };
    // Empty
    const emptyNode = $32rMB.useMemo(()=>{
        if (hasData) return null;
        if (typeof emptyText === 'function') return emptyText();
        return emptyText;
    }, [
        hasData,
        emptyText
    ]);
    // Body
    const bodyTable = /*#__PURE__*/ $hO8yS.createElement((0, $1b8c9078f50fff0d$export$2e2bcd8739ae039), {
        data: mergedData,
        measureColumnWidth: fixHeader || horizonScroll || isSticky
    });
    const bodyColGroup = /*#__PURE__*/ $hO8yS.createElement((0, $b1a1923020420a3f$export$2e2bcd8739ae039), {
        colWidths: flattenColumns.map(({ width: width })=>width),
        columns: flattenColumns
    });
    const captionElement = caption !== null && caption !== undefined ? /*#__PURE__*/ $hO8yS.createElement("caption", {
        className: `${prefixCls}-caption`
    }, caption) : undefined;
    const dataProps = (0, $b0f3dfd0eb3cad70$export$2e2bcd8739ae039)(props, {
        data: true
    });
    const ariaProps = (0, $b0f3dfd0eb3cad70$export$2e2bcd8739ae039)(props, {
        aria: true
    });
    if (fixHeader || isSticky) {
        // >>>>>> Fixed Header
        let bodyContent;
        if (typeof customizeScrollBody === 'function') {
            bodyContent = customizeScrollBody(mergedData, {
                scrollbarSize: scrollbarSize,
                ref: scrollBodyRef,
                onScroll: onInternalScroll
            });
            headerProps.colWidths = flattenColumns.map(({ width: width }, index)=>{
                const colWidth = index === flattenColumns.length - 1 ? width - scrollbarSize : width;
                if (typeof colWidth === 'number' && !Number.isNaN(colWidth)) return colWidth;
                return 0;
            });
        } else bodyContent = /*#__PURE__*/ $hO8yS.createElement("div", {
            style: {
                ...scrollXStyle,
                ...scrollYStyle
            },
            onScroll: onBodyScroll,
            ref: scrollBodyRef,
            className: `${prefixCls}-body`
        }, /*#__PURE__*/ $hO8yS.createElement(TableComponent, $a9ad8dfff2cff25d$var$_extends({
            style: {
                ...scrollTableStyle,
                tableLayout: mergedTableLayout
            }
        }, ariaProps), captionElement, bodyColGroup, bodyTable, !fixFooter && summaryNode && /*#__PURE__*/ $hO8yS.createElement((0, $8cbe79460b8099b9$export$2e2bcd8739ae039), {
            stickyOffsets: stickyOffsets,
            flattenColumns: flattenColumns
        }, summaryNode)));
        // Fixed holder share the props
        const fixedHolderProps = {
            noData: !mergedData.length,
            maxContentScroll: horizonScroll && mergedScrollX === 'max-content',
            ...headerProps,
            ...columnContext,
            direction: direction,
            stickyClassName: stickyClassName,
            scrollX: mergedScrollX,
            tableLayout: mergedTableLayout,
            onScroll: onInternalScroll
        };
        groupTableNode = /*#__PURE__*/ $hO8yS.createElement($hO8yS.Fragment, null, showHeader !== false && /*#__PURE__*/ $hO8yS.createElement((0, $8f6eb7aa3bd017bc$export$2e2bcd8739ae039), $a9ad8dfff2cff25d$var$_extends({}, fixedHolderProps, {
            stickyTopOffset: offsetHeader,
            className: `${prefixCls}-header`,
            ref: scrollHeaderRef,
            colGroup: bodyColGroup
        }), renderFixedHeaderTable), bodyContent, fixFooter && fixFooter !== 'top' && /*#__PURE__*/ $hO8yS.createElement((0, $8f6eb7aa3bd017bc$export$2e2bcd8739ae039), $a9ad8dfff2cff25d$var$_extends({}, fixedHolderProps, {
            stickyBottomOffset: offsetSummary,
            className: `${prefixCls}-summary`,
            ref: scrollSummaryRef,
            colGroup: bodyColGroup
        }), renderFixedFooterTable), isSticky && scrollBodyRef.current && scrollBodyRef.current instanceof Element && /*#__PURE__*/ $hO8yS.createElement((0, $4d903dccd7eb5ca4$export$2e2bcd8739ae039), {
            ref: stickyRef,
            offsetScroll: offsetScroll,
            scrollBodyRef: scrollBodyRef,
            onScroll: onInternalScroll,
            container: container,
            direction: direction
        }));
    } else // >>>>>> Unique table
    groupTableNode = /*#__PURE__*/ $hO8yS.createElement("div", {
        style: {
            ...scrollXStyle,
            ...scrollYStyle,
            ...styles?.content
        },
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-content`, classNames?.content),
        onScroll: onInternalScroll,
        ref: scrollBodyRef
    }, /*#__PURE__*/ $hO8yS.createElement(TableComponent, $a9ad8dfff2cff25d$var$_extends({
        style: {
            ...scrollTableStyle,
            tableLayout: mergedTableLayout
        }
    }, ariaProps), captionElement, bodyColGroup, showHeader !== false && /*#__PURE__*/ $hO8yS.createElement((0, $097a12c1c19b9d3a$export$2e2bcd8739ae039), $a9ad8dfff2cff25d$var$_extends({}, headerProps, columnContext)), bodyTable, summaryNode && /*#__PURE__*/ $hO8yS.createElement((0, $8cbe79460b8099b9$export$2e2bcd8739ae039), {
        stickyOffsets: stickyOffsets,
        flattenColumns: flattenColumns
    }, summaryNode)));
    const tableStyle = {
        ...style
    };
    // Add css var for sticky header `zIndex` calc
    if (isSticky) tableStyle['--columns-count'] = flattenColumns.length;
    let fullTable = /*#__PURE__*/ $hO8yS.createElement("div", $a9ad8dfff2cff25d$var$_extends({
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, className, {
            [`${prefixCls}-rtl`]: direction === 'rtl',
            [`${prefixCls}-fix-start-shadow`]: horizonScroll,
            [`${prefixCls}-fix-end-shadow`]: horizonScroll,
            [`${prefixCls}-fix-start-shadow-show`]: horizonScroll && shadowStart,
            [`${prefixCls}-fix-end-shadow-show`]: horizonScroll && shadowEnd,
            [`${prefixCls}-layout-fixed`]: tableLayout === 'fixed',
            [`${prefixCls}-fixed-header`]: fixHeader,
            /** No used but for compatible */ [`${prefixCls}-fixed-column`]: fixColumn,
            [`${prefixCls}-scroll-horizontal`]: horizonScroll,
            [`${prefixCls}-has-fix-start`]: flattenColumns[0]?.fixed,
            [`${prefixCls}-has-fix-end`]: flattenColumns[flattenColumns.length - 1]?.fixed === 'end'
        }),
        style: tableStyle,
        id: id,
        ref: fullTableRef
    }, dataProps), title && /*#__PURE__*/ $hO8yS.createElement((0, $baf50f8286f92490$export$2e2bcd8739ae039), {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-title`, classNames?.title),
        style: styles?.title
    }, title(mergedData)), /*#__PURE__*/ $hO8yS.createElement("div", {
        ref: scrollBodyContainerRef,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-container`, classNames?.section),
        style: styles?.section
    }, groupTableNode), footer && /*#__PURE__*/ $hO8yS.createElement((0, $baf50f8286f92490$export$2e2bcd8739ae039), {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-footer`, classNames?.footer),
        style: styles?.footer
    }, footer(mergedData)));
    if (horizonScroll) fullTable = /*#__PURE__*/ $hO8yS.createElement((0, $b8d12c084d14878d$export$2e2bcd8739ae039), {
        onResize: ({ offsetWidth: offsetWidth })=>onFullTableResize(offsetWidth)
    }, fullTable);
    const fixedInfoList = (0, $3d5cc33a31bd9254$export$2e2bcd8739ae039)(flattenColumns, stickyOffsets);
    const TableContextValue = $32rMB.useMemo(()=>({
            // Scroll
            scrollX: mergedScrollX,
            scrollInfo: scrollInfo,
            classNames: classNames,
            styles: styles,
            prefixCls: // Table
            prefixCls,
            getComponent: getComponent,
            scrollbarSize: scrollbarSize,
            direction: direction,
            fixedInfoList: fixedInfoList,
            isSticky: isSticky,
            componentWidth: componentWidth,
            fixHeader: fixHeader,
            fixColumn: fixColumn,
            horizonScroll: horizonScroll,
            // Body
            tableLayout: mergedTableLayout,
            rowClassName: rowClassName,
            expandedRowClassName: expandableConfig.expandedRowClassName,
            expandIcon: mergedExpandIcon,
            expandableType: expandableType,
            expandRowByClick: expandableConfig.expandRowByClick,
            expandedRowRender: expandableConfig.expandedRowRender,
            expandedRowOffset: expandableConfig.expandedRowOffset,
            onTriggerExpand: onTriggerExpand,
            expandIconColumnIndex: expandableConfig.expandIconColumnIndex,
            indentSize: expandableConfig.indentSize,
            allColumnsFixedLeft: flattenColumns.every((col)=>col.fixed === 'start'),
            emptyNode: emptyNode,
            columns: // Column
            columns,
            flattenColumns: flattenColumns,
            onColumnResize: onColumnResize,
            colWidths: colWidths,
            // Row
            hoverStartRow: startRow,
            hoverEndRow: endRow,
            onHover: onHover,
            rowExpandable: expandableConfig.rowExpandable,
            onRow: onRow,
            getRowKey: getRowKey,
            expandedKeys: mergedExpandedKeys,
            childrenColumnName: mergedChildrenColumnName,
            rowHoverable: rowHoverable,
            measureRowRender: // Measure Row
            measureRowRender
        }), [
        // Scroll
        mergedScrollX,
        scrollInfo,
        classNames,
        styles,
        // Table
        prefixCls,
        getComponent,
        scrollbarSize,
        direction,
        fixedInfoList,
        isSticky,
        componentWidth,
        fixHeader,
        fixColumn,
        horizonScroll,
        // Body
        mergedTableLayout,
        rowClassName,
        expandableConfig.expandedRowClassName,
        mergedExpandIcon,
        expandableType,
        expandableConfig.expandRowByClick,
        expandableConfig.expandedRowRender,
        expandableConfig.expandedRowOffset,
        onTriggerExpand,
        expandableConfig.expandIconColumnIndex,
        expandableConfig.indentSize,
        emptyNode,
        // Column
        columns,
        flattenColumns,
        onColumnResize,
        colWidths,
        // Row
        startRow,
        endRow,
        onHover,
        expandableConfig.rowExpandable,
        onRow,
        getRowKey,
        mergedExpandedKeys,
        mergedChildrenColumnName,
        rowHoverable,
        measureRowRender
    ]);
    return /*#__PURE__*/ $hO8yS.createElement((0, $92843d8d43ffd1ab$export$2e2bcd8739ae039).Provider, {
        value: TableContextValue
    }, fullTable);
};
const $a9ad8dfff2cff25d$var$RefTable = /*#__PURE__*/ $N3oW3.forwardRef($a9ad8dfff2cff25d$var$Table);
const $a9ad8dfff2cff25d$export$13da147d1fdf3e3c = (shouldTriggerRender)=>{
    return (0, $92843d8d43ffd1ab$export$ffd6d5bef5eaf0a4)($a9ad8dfff2cff25d$var$RefTable, shouldTriggerRender);
};
const $a9ad8dfff2cff25d$var$ImmutableTable = $a9ad8dfff2cff25d$export$13da147d1fdf3e3c();
$a9ad8dfff2cff25d$var$ImmutableTable.EXPAND_COLUMN = (0, $a942291e76081e0b$export$e1053575ddfcb301);
$a9ad8dfff2cff25d$var$ImmutableTable.INTERNAL_HOOKS = (0, $a942291e76081e0b$export$91b75cf262680225);
$a9ad8dfff2cff25d$var$ImmutableTable.Column = (0, $6d1292d6252693f0$export$2e2bcd8739ae039);
$a9ad8dfff2cff25d$var$ImmutableTable.ColumnGroup = (0, $f224012d2504dc24$export$2e2bcd8739ae039);
$a9ad8dfff2cff25d$var$ImmutableTable.Summary = (0, $8cbe79460b8099b9$export$d605f3af09eef683);
var $a9ad8dfff2cff25d$export$2e2bcd8739ae039 = $a9ad8dfff2cff25d$var$ImmutableTable;





parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");

















parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
function $0edc12b6ff59ecb4$export$2e2bcd8739ae039(defaultValue) {
    var destroyRef = $32rMB.useRef(false);
    var _React$useState = $32rMB.useState(defaultValue), _React$useState2 = (0, $e2a93fed214437b8$export$2e2bcd8739ae039)(_React$useState, 2), value = _React$useState2[0], setValue = _React$useState2[1];
    $32rMB.useEffect(function() {
        destroyRef.current = false;
        return function() {
            destroyRef.current = true;
        };
    }, []);
    function safeSetState(updater, ignoreDestroy) {
        if (ignoreDestroy && destroyRef.current) return;
        setValue(updater);
    }
    return [
        value,
        safeSetState
    ];
}


/** We only think `undefined` is empty */ function $31212879b7ae8efe$var$hasValue(value) {
    return value !== undefined;
}
function $31212879b7ae8efe$export$2e2bcd8739ae039(defaultStateValue, option) {
    var _ref = option || {}, defaultValue = _ref.defaultValue, value = _ref.value, onChange = _ref.onChange, postState = _ref.postState;
    // ======================= Init =======================
    var _useState = (0, $0edc12b6ff59ecb4$export$2e2bcd8739ae039)(function() {
        if ($31212879b7ae8efe$var$hasValue(value)) return value;
        else if ($31212879b7ae8efe$var$hasValue(defaultValue)) return typeof defaultValue === 'function' ? defaultValue() : defaultValue;
        else return typeof defaultStateValue === 'function' ? defaultStateValue() : defaultStateValue;
    }), _useState2 = (0, $e2a93fed214437b8$export$2e2bcd8739ae039)(_useState, 2), innerValue = _useState2[0], setInnerValue = _useState2[1];
    var mergedValue = value !== undefined ? value : innerValue;
    var postMergedValue = postState ? postState(mergedValue) : mergedValue;
    // ====================== Change ======================
    var onChangeFn = (0, $5c85f0dd15155745$export$2e2bcd8739ae039)(onChange);
    var _useState3 = (0, $0edc12b6ff59ecb4$export$2e2bcd8739ae039)([
        mergedValue
    ]), _useState4 = (0, $e2a93fed214437b8$export$2e2bcd8739ae039)(_useState3, 2), prevValue = _useState4[0], setPrevValue = _useState4[1];
    (0, $af1ff2ee9ec51f79$export$9283e56bae2f7b0f)(function() {
        var prev = prevValue[0];
        if (innerValue !== prev) onChangeFn(innerValue, prev);
    }, [
        prevValue
    ]);
    // Sync value back to `undefined` when it from control to un-control
    (0, $af1ff2ee9ec51f79$export$9283e56bae2f7b0f)(function() {
        if (!$31212879b7ae8efe$var$hasValue(value)) setInnerValue(value);
    }, [
        value
    ]);
    // ====================== Update ======================
    var triggerChange = (0, $5c85f0dd15155745$export$2e2bcd8739ae039)(function(updater, ignoreDestroy) {
        setInnerValue(updater, ignoreDestroy);
        setPrevValue([
            mergedValue
        ], ignoreDestroy);
    });
    return [
        postMergedValue,
        triggerChange
    ];
}



function $2934e3f99dc8bea9$export$2e2bcd8739ae039(entity, path) {
    var current = entity;
    for(var i = 0; i < path.length; i += 1){
        if (current === null || current === undefined) return undefined;
        current = current[path[i]];
    }
    return current;
}









function $2cf2a3e6c09ee4c3$export$2e2bcd8739ae039(r) {
    return (0, $8a8c02d238873a10$export$2e2bcd8739ae039)(r) || (0, $165ffe990f52ff5d$export$2e2bcd8739ae039)(r) || (0, $14c3211dd7044622$export$2e2bcd8739ae039)(r) || (0, $a30004e9c9c9c877$export$2e2bcd8739ae039)();
}



function $32021a08fb2bc373$var$internalSet(entity, paths, value, removeIfUndefined) {
    if (!paths.length) return value;
    var _paths = (0, $2cf2a3e6c09ee4c3$export$2e2bcd8739ae039)(paths), path = _paths[0], restPath = _paths.slice(1);
    var clone;
    if (!entity && typeof path === 'number') clone = [];
    else if (Array.isArray(entity)) clone = (0, $3746fb019e1f2ee5$export$2e2bcd8739ae039)(entity);
    else clone = (0, $cde876c32cf7555b$export$2e2bcd8739ae039)({}, entity);
    // Delete prop if `removeIfUndefined` and value is undefined
    if (removeIfUndefined && value === undefined && restPath.length === 1) delete clone[path][restPath[0]];
    else clone[path] = $32021a08fb2bc373$var$internalSet(clone[path], restPath, value, removeIfUndefined);
    return clone;
}
function $32021a08fb2bc373$export$2e2bcd8739ae039(entity, paths, value) {
    var removeIfUndefined = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    // Do nothing if `removeIfUndefined` and parent object not exist
    if (paths.length && removeIfUndefined && value === undefined && !(0, $2934e3f99dc8bea9$export$2e2bcd8739ae039)(entity, paths.slice(0, -1))) return entity;
    return $32021a08fb2bc373$var$internalSet(entity, paths, value, removeIfUndefined);
}
function $32021a08fb2bc373$var$isObject(obj) {
    return (0, $c5ac91862c8363d3$export$2e2bcd8739ae039)(obj) === 'object' && obj !== null && Object.getPrototypeOf(obj) === Object.prototype;
}
function $32021a08fb2bc373$var$createEmpty(source) {
    return Array.isArray(source) ? [] : {};
}
var $32021a08fb2bc373$var$keys = typeof Reflect === 'undefined' ? Object.keys : Reflect.ownKeys;
function $32021a08fb2bc373$export$4950aa0f605343fb() {
    for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
    var clone = $32021a08fb2bc373$var$createEmpty(sources[0]);
    sources.forEach(function(src) {
        function internalMerge(path, parentLoopSet) {
            var loopSet = new Set(parentLoopSet);
            var value = (0, $2934e3f99dc8bea9$export$2e2bcd8739ae039)(src, path);
            var isArr = Array.isArray(value);
            if (isArr || $32021a08fb2bc373$var$isObject(value)) // Only add not loop obj
            {
                if (!loopSet.has(value)) {
                    loopSet.add(value);
                    var originValue = (0, $2934e3f99dc8bea9$export$2e2bcd8739ae039)(clone, path);
                    if (isArr) // Array will always be override
                    clone = $32021a08fb2bc373$export$2e2bcd8739ae039(clone, path, []);
                    else if (!originValue || (0, $c5ac91862c8363d3$export$2e2bcd8739ae039)(originValue) !== 'object') // Init container if not exist
                    clone = $32021a08fb2bc373$export$2e2bcd8739ae039(clone, path, $32021a08fb2bc373$var$createEmpty(value));
                    $32021a08fb2bc373$var$keys(value).forEach(function(key) {
                        internalMerge([].concat((0, $3746fb019e1f2ee5$export$2e2bcd8739ae039)(path), [
                            key
                        ]), loopSet);
                    });
                }
            } else clone = $32021a08fb2bc373$export$2e2bcd8739ae039(clone, path, value);
        }
        internalMerge([]);
    });
    return clone;
}






parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");

var $N3oW3 = parcelRequire("N3oW3");



parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");


/**
 * Fill component to provided the scroll content real height.
 */ var $6038b9db303d24ed$var$Filler = /*#__PURE__*/ $N3oW3.forwardRef(function(_ref, ref) {
    var height = _ref.height, offsetY = _ref.offsetY, offsetX = _ref.offsetX, children = _ref.children, prefixCls = _ref.prefixCls, onInnerResize = _ref.onInnerResize, innerProps = _ref.innerProps, rtl = _ref.rtl, extra = _ref.extra;
    var outerStyle = {};
    var innerStyle = {
        display: 'flex',
        flexDirection: 'column'
    };
    if (offsetY !== undefined) {
        // Not set `width` since this will break `sticky: right`
        outerStyle = {
            height: height,
            position: 'relative',
            overflow: 'hidden'
        };
        innerStyle = (0, $cde876c32cf7555b$export$2e2bcd8739ae039)((0, $cde876c32cf7555b$export$2e2bcd8739ae039)({}, innerStyle), {}, (0, $def8730fb4b8d50a$export$2e2bcd8739ae039)((0, $def8730fb4b8d50a$export$2e2bcd8739ae039)((0, $def8730fb4b8d50a$export$2e2bcd8739ae039)((0, $def8730fb4b8d50a$export$2e2bcd8739ae039)((0, $def8730fb4b8d50a$export$2e2bcd8739ae039)({
            transform: "translateY(".concat(offsetY, "px)")
        }, rtl ? 'marginRight' : 'marginLeft', -offsetX), "position", 'absolute'), "left", 0), "right", 0), "top", 0));
    }
    return /*#__PURE__*/ $hO8yS.createElement("div", {
        style: outerStyle
    }, /*#__PURE__*/ $hO8yS.createElement((0, $46befc6c0d7dbbd8$export$2e2bcd8739ae039), {
        onResize: function onResize(_ref2) {
            var offsetHeight = _ref2.offsetHeight;
            if (offsetHeight && onInnerResize) onInnerResize();
        }
    }, /*#__PURE__*/ $hO8yS.createElement("div", (0, $4dfb8f1fff0cbd5e$export$2e2bcd8739ae039)({
        style: innerStyle,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))((0, $def8730fb4b8d50a$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-holder-inner"), prefixCls)),
        ref: ref
    }, innerProps), children, extra)));
});
$6038b9db303d24ed$var$Filler.displayName = 'Filler';
var $6038b9db303d24ed$export$2e2bcd8739ae039 = $6038b9db303d24ed$var$Filler;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");

var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
function $c97fb16b2f1c93c3$export$6d08773d2e66f8f2(_ref) {
    var children = _ref.children, setRef = _ref.setRef;
    var refFunc = $32rMB.useCallback(function(node) {
        setRef(node);
    }, []);
    return /*#__PURE__*/ $N3oW3.cloneElement(children, {
        ref: refFunc
    });
}


function $c71a6ed0608001ae$export$2e2bcd8739ae039(list, startIndex, endIndex, scrollWidth, offsetX, setNodeRef, renderFunc, _ref) {
    var getKey = _ref.getKey;
    return list.slice(startIndex, endIndex + 1).map(function(item, index) {
        var eleIndex = startIndex + index;
        var node = renderFunc(item, eleIndex, {
            style: {
                width: scrollWidth
            },
            offsetX: offsetX
        });
        var key = getKey(item);
        return /*#__PURE__*/ $hO8yS.createElement((0, $c97fb16b2f1c93c3$export$6d08773d2e66f8f2), {
            key: key,
            setRef: function setRef(ele) {
                return setNodeRef(item, ele);
            }
        }, node);
    });
}



parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
/**
 * Get index with specific start index one by one. e.g.
 * min: 3, max: 9, start: 6
 *
 * Return index is:
 * [0]: 6
 * [1]: 7
 * [2]: 5
 * [3]: 8
 * [4]: 4
 * [5]: 9
 * [6]: 3
 */ function $5e4259fd83d5b1d8$export$38f9023d45dd4a23(min, max, start, index) {
    var beforeCount = start - min;
    var afterCount = max - start;
    var balanceCount = Math.min(beforeCount, afterCount) * 2;
    // Balance
    if (index <= balanceCount) {
        var stepIndex = Math.floor(index / 2);
        if (index % 2) return start + stepIndex + 1;
        return start - stepIndex;
    }
    // One is out of range
    if (beforeCount > afterCount) return start - (index - afterCount);
    return start + (index - beforeCount);
}
function $5e4259fd83d5b1d8$export$418b8d8b03eefdf5(originList, targetList, getKey) {
    var originLen = originList.length;
    var targetLen = targetList.length;
    var shortList;
    var longList;
    if (originLen === 0 && targetLen === 0) return null;
    if (originLen < targetLen) {
        shortList = originList;
        longList = targetList;
    } else {
        shortList = targetList;
        longList = originList;
    }
    var notExistKey = {
        __EMPTY_ITEM__: true
    };
    function getItemKey(item) {
        if (item !== undefined) return getKey(item);
        return notExistKey;
    }
    // Loop to find diff one
    var diffIndex = null;
    var multiple = Math.abs(originLen - targetLen) !== 1;
    for(var i = 0; i < longList.length; i += 1){
        var shortKey = getItemKey(shortList[i]);
        var longKey = getItemKey(longList[i]);
        if (shortKey !== longKey) {
            diffIndex = i;
            multiple = multiple || shortKey !== getItemKey(longList[i + 1]);
            break;
        }
    }
    return diffIndex === null ? null : {
        index: diffIndex,
        multiple: multiple
    };
}


function $a2fd629ebf0af602$export$2e2bcd8739ae039(data, getKey, onDiff) {
    var _React$useState = $32rMB.useState(data), _React$useState2 = (0, $e2a93fed214437b8$export$2e2bcd8739ae039)(_React$useState, 2), prevData = _React$useState2[0], setPrevData = _React$useState2[1];
    var _React$useState3 = $32rMB.useState(null), _React$useState4 = (0, $e2a93fed214437b8$export$2e2bcd8739ae039)(_React$useState3, 2), diffItem = _React$useState4[0], setDiffItem = _React$useState4[1];
    $32rMB.useEffect(function() {
        var diff = (0, $5e4259fd83d5b1d8$export$418b8d8b03eefdf5)(prevData || [], data || [], getKey);
        if ((diff === null || diff === void 0 ? void 0 : diff.index) !== undefined) {
            onDiff === null || onDiff === void 0 || onDiff(diff.index);
            setDiffItem(data[diff.index]);
        }
        setPrevData(data);
    }, [
        data
    ]);
    return [
        diffItem
    ];
}



parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");

var $4222cc967daf20f9$var$isFF = (typeof navigator === "undefined" ? "undefined" : (0, $c5ac91862c8363d3$export$2e2bcd8739ae039)(navigator)) === 'object' && /Firefox/i.test(navigator.userAgent);
var $4222cc967daf20f9$export$2e2bcd8739ae039 = $4222cc967daf20f9$var$isFF;


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
var $2ccf1d98b9d22e58$export$2e2bcd8739ae039 = function(isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight) {
    // Do lock for a wheel when scrolling
    var lockRef = (0, $32rMB.useRef)(false);
    var lockTimeoutRef = (0, $32rMB.useRef)(null);
    function lockScroll() {
        clearTimeout(lockTimeoutRef.current);
        lockRef.current = true;
        lockTimeoutRef.current = setTimeout(function() {
            lockRef.current = false;
        }, 50);
    }
    // Pass to ref since global add is in closure
    var scrollPingRef = (0, $32rMB.useRef)({
        top: isScrollAtTop,
        bottom: isScrollAtBottom,
        left: isScrollAtLeft,
        right: isScrollAtRight
    });
    scrollPingRef.current.top = isScrollAtTop;
    scrollPingRef.current.bottom = isScrollAtBottom;
    scrollPingRef.current.left = isScrollAtLeft;
    scrollPingRef.current.right = isScrollAtRight;
    return function(isHorizontal, delta) {
        var smoothOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var originScroll = isHorizontal ? // Pass origin wheel when on the left
        delta < 0 && scrollPingRef.current.left || // Pass origin wheel when on the right
        delta > 0 && scrollPingRef.current.right // Pass origin wheel when on the top
         : delta < 0 && scrollPingRef.current.top || // Pass origin wheel when on the bottom
        delta > 0 && scrollPingRef.current.bottom;
        if (smoothOffset && originScroll) {
            // No need lock anymore when it's smooth offset from touchMove interval
            clearTimeout(lockTimeoutRef.current);
            lockRef.current = false;
        } else if (!originScroll || lockRef.current) lockScroll();
        return !lockRef.current && originScroll;
    };
};


function $ca6a9eaf1db2ddba$export$2e2bcd8739ae039(inVirtual, isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight, horizontalScroll, /***
 * Return `true` when you need to prevent default event
 */ onWheelDelta) {
    var offsetRef = (0, $32rMB.useRef)(0);
    var nextFrameRef = (0, $32rMB.useRef)(null);
    // Firefox patch
    var wheelValueRef = (0, $32rMB.useRef)(null);
    var isMouseScrollRef = (0, $32rMB.useRef)(false);
    // Scroll status sync
    var originScroll = (0, $2ccf1d98b9d22e58$export$2e2bcd8739ae039)(isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight);
    function onWheelY(e, deltaY) {
        (0, $99b8d3464c57be61$export$2e2bcd8739ae039).cancel(nextFrameRef.current);
        // Do nothing when scroll at the edge, Skip check when is in scroll
        if (originScroll(false, deltaY)) return;
        // Skip if nest List has handled this event
        var event = e;
        if (!event._virtualHandled) event._virtualHandled = true;
        else return;
        offsetRef.current += deltaY;
        wheelValueRef.current = deltaY;
        // Proxy of scroll events
        if (!(0, $4222cc967daf20f9$export$2e2bcd8739ae039)) event.preventDefault();
        nextFrameRef.current = (0, $99b8d3464c57be61$export$2e2bcd8739ae039)(function() {
            // Patch a multiple for Firefox to fix wheel number too small
            // ref: https://github.com/ant-design/ant-design/issues/26372#issuecomment-679460266
            var patchMultiple = isMouseScrollRef.current ? 10 : 1;
            onWheelDelta(offsetRef.current * patchMultiple, false);
            offsetRef.current = 0;
        });
    }
    function onWheelX(event, deltaX) {
        onWheelDelta(deltaX, true);
        if (!(0, $4222cc967daf20f9$export$2e2bcd8739ae039)) event.preventDefault();
    }
    // Check for which direction does wheel do. `sx` means `shift + wheel`
    var wheelDirectionRef = (0, $32rMB.useRef)(null);
    var wheelDirectionCleanRef = (0, $32rMB.useRef)(null);
    function onWheel(event) {
        if (!inVirtual) return;
        // Wait for 2 frame to clean direction
        (0, $99b8d3464c57be61$export$2e2bcd8739ae039).cancel(wheelDirectionCleanRef.current);
        wheelDirectionCleanRef.current = (0, $99b8d3464c57be61$export$2e2bcd8739ae039)(function() {
            wheelDirectionRef.current = null;
        }, 2);
        var deltaX = event.deltaX, deltaY = event.deltaY, shiftKey = event.shiftKey;
        var mergedDeltaX = deltaX;
        var mergedDeltaY = deltaY;
        if (wheelDirectionRef.current === 'sx' || !wheelDirectionRef.current && (shiftKey || false) && deltaY && !deltaX) {
            mergedDeltaX = deltaY;
            mergedDeltaY = 0;
            wheelDirectionRef.current = 'sx';
        }
        var absX = Math.abs(mergedDeltaX);
        var absY = Math.abs(mergedDeltaY);
        if (wheelDirectionRef.current === null) wheelDirectionRef.current = horizontalScroll && absX > absY ? 'x' : 'y';
        if (wheelDirectionRef.current === 'y') onWheelY(event, mergedDeltaY);
        else onWheelX(event, mergedDeltaX);
    }
    // A patch for firefox
    function onFireFoxScroll(event) {
        if (!inVirtual) return;
        isMouseScrollRef.current = event.detail === wheelValueRef.current;
    }
    return [
        onWheel,
        onFireFoxScroll
    ];
}



parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
function $096c1c5beb2f1177$export$a1d82723752af087(mergedData, getKey, heights, itemHeight) {
    var _React$useMemo = $32rMB.useMemo(function() {
        return [
            new Map(),
            []
        ];
    }, [
        mergedData,
        heights.id,
        itemHeight
    ]), _React$useMemo2 = (0, $e2a93fed214437b8$export$2e2bcd8739ae039)(_React$useMemo, 2), key2Index = _React$useMemo2[0], bottomList = _React$useMemo2[1];
    var getSize = function getSize(startKey) {
        var endKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : startKey;
        // Get from cache first
        var startIndex = key2Index.get(startKey);
        var endIndex = key2Index.get(endKey);
        // Loop to fill the cache
        if (startIndex === undefined || endIndex === undefined) {
            var dataLen = mergedData.length;
            for(var i = bottomList.length; i < dataLen; i += 1){
                var _heights$get;
                var item = mergedData[i];
                var key = getKey(item);
                key2Index.set(key, i);
                var cacheHeight = (_heights$get = heights.get(key)) !== null && _heights$get !== void 0 ? _heights$get : itemHeight;
                bottomList[i] = (bottomList[i - 1] || 0) + cacheHeight;
                if (key === startKey) startIndex = i;
                if (key === endKey) endIndex = i;
                if (startIndex !== undefined && endIndex !== undefined) break;
            }
        }
        return {
            top: bottomList[startIndex - 1] || 0,
            bottom: bottomList[endIndex]
        };
    };
    return getSize;
}



parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");



// Firefox has low performance of map.
var $a6f7eb25e65df5c2$var$CacheMap = /*#__PURE__*/ function() {
    function CacheMap() {
        (0, $c27a1e671724260e$export$2e2bcd8739ae039)(this, CacheMap);
        (0, $def8730fb4b8d50a$export$2e2bcd8739ae039)(this, "maps", void 0);
        // Used for cache key
        // `useMemo` no need to update if `id` not change
        (0, $def8730fb4b8d50a$export$2e2bcd8739ae039)(this, "id", 0);
        (0, $def8730fb4b8d50a$export$2e2bcd8739ae039)(this, "diffRecords", new Map());
        this.maps = Object.create(null);
    }
    (0, $3d68cfa6e8f65ecd$export$2e2bcd8739ae039)(CacheMap, [
        {
            key: "set",
            value: function set(key, value) {
                // Record prev value
                this.diffRecords.set(key, this.maps[key]);
                this.maps[key] = value;
                this.id += 1;
            }
        },
        {
            key: "get",
            value: function get(key) {
                return this.maps[key];
            }
        },
        {
            key: "resetRecord",
            value: function resetRecord() {
                this.diffRecords.clear();
            }
        },
        {
            key: "getRecord",
            value: function getRecord() {
                return this.diffRecords;
            }
        }
    ]);
    return CacheMap;
}();
var $a6f7eb25e65df5c2$export$2e2bcd8739ae039 = $a6f7eb25e65df5c2$var$CacheMap;


function $13b63baa5b5ba657$var$parseNumber(value) {
    var num = parseFloat(value);
    return isNaN(num) ? 0 : num;
}
function $13b63baa5b5ba657$export$2e2bcd8739ae039(getKey, onItemAdd, onItemRemove) {
    var _React$useState = $32rMB.useState(0), _React$useState2 = (0, $e2a93fed214437b8$export$2e2bcd8739ae039)(_React$useState, 2), updatedMark = _React$useState2[0], setUpdatedMark = _React$useState2[1];
    var instanceRef = (0, $32rMB.useRef)(new Map());
    var heightsRef = (0, $32rMB.useRef)(new (0, $a6f7eb25e65df5c2$export$2e2bcd8739ae039)());
    var promiseIdRef = (0, $32rMB.useRef)(0);
    function cancelRaf() {
        promiseIdRef.current += 1;
    }
    function collectHeight() {
        var sync = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        cancelRaf();
        var doCollect = function doCollect() {
            var changed = false;
            instanceRef.current.forEach(function(element, key) {
                if (element && element.offsetParent) {
                    var offsetHeight = element.offsetHeight;
                    var _getComputedStyle = getComputedStyle(element), marginTop = _getComputedStyle.marginTop, marginBottom = _getComputedStyle.marginBottom;
                    var marginTopNum = $13b63baa5b5ba657$var$parseNumber(marginTop);
                    var marginBottomNum = $13b63baa5b5ba657$var$parseNumber(marginBottom);
                    var totalHeight = offsetHeight + marginTopNum + marginBottomNum;
                    if (heightsRef.current.get(key) !== totalHeight) {
                        heightsRef.current.set(key, totalHeight);
                        changed = true;
                    }
                }
            });
            // Always trigger update mark to tell parent that should re-calculate heights when resized
            if (changed) setUpdatedMark(function(c) {
                return c + 1;
            });
        };
        if (sync) doCollect();
        else {
            promiseIdRef.current += 1;
            var id = promiseIdRef.current;
            Promise.resolve().then(function() {
                if (id === promiseIdRef.current) doCollect();
            });
        }
    }
    function setInstanceRef(item, instance) {
        var key = getKey(item);
        var origin = instanceRef.current.get(key);
        if (instance) {
            instanceRef.current.set(key, instance);
            collectHeight();
        } else instanceRef.current.delete(key);
        // Instance changed
        if (!origin !== !instance) {
            if (instance) onItemAdd === null || onItemAdd === void 0 || onItemAdd(item);
            else onItemRemove === null || onItemRemove === void 0 || onItemRemove(item);
        }
    }
    (0, $32rMB.useEffect)(function() {
        return cancelRaf;
    }, []);
    return [
        setInstanceRef,
        collectHeight,
        heightsRef.current,
        updatedMark
    ];
}



parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
var $3a044bb2e6ca346b$var$SMOOTH_PTG = 14 / 15;
function $3a044bb2e6ca346b$export$2e2bcd8739ae039(inVirtual, listRef, callback) {
    var touchedRef = (0, $32rMB.useRef)(false);
    var touchXRef = (0, $32rMB.useRef)(0);
    var touchYRef = (0, $32rMB.useRef)(0);
    var elementRef = (0, $32rMB.useRef)(null);
    // Smooth scroll
    var intervalRef = (0, $32rMB.useRef)(null);
    /* eslint-disable prefer-const */ var cleanUpEvents;
    var onTouchMove = function onTouchMove(e) {
        if (touchedRef.current) {
            var currentX = Math.ceil(e.touches[0].pageX);
            var currentY = Math.ceil(e.touches[0].pageY);
            var offsetX = touchXRef.current - currentX;
            var offsetY = touchYRef.current - currentY;
            var _isHorizontal = Math.abs(offsetX) > Math.abs(offsetY);
            if (_isHorizontal) touchXRef.current = currentX;
            else touchYRef.current = currentY;
            var scrollHandled = callback(_isHorizontal, _isHorizontal ? offsetX : offsetY, false, e);
            if (scrollHandled) e.preventDefault();
            // Smooth interval
            clearInterval(intervalRef.current);
            if (scrollHandled) intervalRef.current = setInterval(function() {
                if (_isHorizontal) offsetX *= $3a044bb2e6ca346b$var$SMOOTH_PTG;
                else offsetY *= $3a044bb2e6ca346b$var$SMOOTH_PTG;
                var offset = Math.floor(_isHorizontal ? offsetX : offsetY);
                if (!callback(_isHorizontal, offset, true) || Math.abs(offset) <= 0.1) clearInterval(intervalRef.current);
            }, 16);
        }
    };
    var onTouchEnd = function onTouchEnd() {
        touchedRef.current = false;
        cleanUpEvents();
    };
    var onTouchStart = function onTouchStart(e) {
        cleanUpEvents();
        if (e.touches.length === 1 && !touchedRef.current) {
            touchedRef.current = true;
            touchXRef.current = Math.ceil(e.touches[0].pageX);
            touchYRef.current = Math.ceil(e.touches[0].pageY);
            elementRef.current = e.target;
            elementRef.current.addEventListener('touchmove', onTouchMove, {
                passive: false
            });
            elementRef.current.addEventListener('touchend', onTouchEnd, {
                passive: true
            });
        }
    };
    cleanUpEvents = function cleanUpEvents() {
        if (elementRef.current) {
            elementRef.current.removeEventListener('touchmove', onTouchMove);
            elementRef.current.removeEventListener('touchend', onTouchEnd);
        }
    };
    (0, $af1ff2ee9ec51f79$export$2e2bcd8739ae039)(function() {
        if (inVirtual) listRef.current.addEventListener('touchstart', onTouchStart, {
            passive: true
        });
        return function() {
            var _listRef$current;
            (_listRef$current = listRef.current) === null || _listRef$current === void 0 || _listRef$current.removeEventListener('touchstart', onTouchStart);
            cleanUpEvents();
            clearInterval(intervalRef.current);
        };
    }, [
        inVirtual
    ]);
}




parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
function $b387ede11c8c7060$var$smoothScrollOffset(offset) {
    return Math.floor(Math.pow(offset, 0.5));
}
function $b387ede11c8c7060$export$dbd0143e191dc2e5(e, horizontal) {
    var obj = 'touches' in e ? e.touches[0] : e;
    return obj[horizontal ? 'pageX' : 'pageY'] - window[horizontal ? 'scrollX' : 'scrollY'];
}
function $b387ede11c8c7060$export$2e2bcd8739ae039(inVirtual, componentRef, onScrollOffset) {
    $32rMB.useEffect(function() {
        var ele = componentRef.current;
        if (inVirtual && ele) {
            var mouseDownLock = false;
            var rafId;
            var _offset;
            var stopScroll = function stopScroll() {
                (0, $99b8d3464c57be61$export$2e2bcd8739ae039).cancel(rafId);
            };
            var continueScroll = function continueScroll() {
                stopScroll();
                rafId = (0, $99b8d3464c57be61$export$2e2bcd8739ae039)(function() {
                    onScrollOffset(_offset);
                    continueScroll();
                });
            };
            var clearDragState = function clearDragState() {
                mouseDownLock = false;
                stopScroll();
            };
            var onMouseDown = function onMouseDown(e) {
                // Skip if element set draggable
                if (e.target.draggable || e.button !== 0) return;
                // Skip if nest List has handled this event
                var event = e;
                if (!event._virtualHandled) {
                    event._virtualHandled = true;
                    mouseDownLock = true;
                }
            };
            var onMouseMove = function onMouseMove(e) {
                if (mouseDownLock) {
                    var mouseY = $b387ede11c8c7060$export$dbd0143e191dc2e5(e, false);
                    var _ele$getBoundingClien = ele.getBoundingClientRect(), top = _ele$getBoundingClien.top, bottom = _ele$getBoundingClien.bottom;
                    if (mouseY <= top) {
                        var diff = top - mouseY;
                        _offset = -$b387ede11c8c7060$var$smoothScrollOffset(diff);
                        continueScroll();
                    } else if (mouseY >= bottom) {
                        var _diff = mouseY - bottom;
                        _offset = $b387ede11c8c7060$var$smoothScrollOffset(_diff);
                        continueScroll();
                    } else stopScroll();
                }
            };
            ele.addEventListener('mousedown', onMouseDown);
            ele.ownerDocument.addEventListener('mouseup', clearDragState);
            ele.ownerDocument.addEventListener('mousemove', onMouseMove);
            ele.ownerDocument.addEventListener('dragend', clearDragState);
            return function() {
                ele.removeEventListener('mousedown', onMouseDown);
                ele.ownerDocument.removeEventListener('mouseup', clearDragState);
                ele.ownerDocument.removeEventListener('mousemove', onMouseMove);
                ele.ownerDocument.removeEventListener('dragend', clearDragState);
                stopScroll();
            };
        }
    }, [
        inVirtual
    ]);
}





parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");



var $ac2c934acce7f8cf$var$MAX_TIMES = 10;
function $ac2c934acce7f8cf$export$2e2bcd8739ae039(containerRef, data, heights, itemHeight, getKey, collectHeight, syncScrollTop, triggerFlash) {
    var scrollRef = $32rMB.useRef();
    var _React$useState = $32rMB.useState(null), _React$useState2 = (0, $e2a93fed214437b8$export$2e2bcd8739ae039)(_React$useState, 2), syncState = _React$useState2[0], setSyncState = _React$useState2[1];
    // ========================== Sync Scroll ==========================
    (0, $af1ff2ee9ec51f79$export$2e2bcd8739ae039)(function() {
        if (syncState && syncState.times < $ac2c934acce7f8cf$var$MAX_TIMES) {
            // Never reach
            if (!containerRef.current) {
                setSyncState(function(ori) {
                    return (0, $cde876c32cf7555b$export$2e2bcd8739ae039)({}, ori);
                });
                return;
            }
            collectHeight();
            var targetAlign = syncState.targetAlign, originAlign = syncState.originAlign, index = syncState.index, offset = syncState.offset;
            var height = containerRef.current.clientHeight;
            var needCollectHeight = false;
            var newTargetAlign = targetAlign;
            var targetTop = null;
            // Go to next frame if height not exist
            if (height) {
                var mergedAlign = targetAlign || originAlign;
                // Get top & bottom
                var stackTop = 0;
                var itemTop = 0;
                var itemBottom = 0;
                var maxLen = Math.min(data.length - 1, index);
                for(var i = 0; i <= maxLen; i += 1){
                    var key = getKey(data[i]);
                    itemTop = stackTop;
                    var cacheHeight = heights.get(key);
                    itemBottom = itemTop + (cacheHeight === undefined ? itemHeight : cacheHeight);
                    stackTop = itemBottom;
                }
                // Check if need sync height (visible range has item not record height)
                var leftHeight = mergedAlign === 'top' ? offset : height - offset;
                for(var _i = maxLen; _i >= 0; _i -= 1){
                    var _key = getKey(data[_i]);
                    var _cacheHeight = heights.get(_key);
                    if (_cacheHeight === undefined) {
                        needCollectHeight = true;
                        break;
                    }
                    leftHeight -= _cacheHeight;
                    if (leftHeight <= 0) break;
                }
                // Scroll to
                switch(mergedAlign){
                    case 'top':
                        targetTop = itemTop - offset;
                        break;
                    case 'bottom':
                        targetTop = itemBottom - height + offset;
                        break;
                    default:
                        var scrollTop = containerRef.current.scrollTop;
                        var scrollBottom = scrollTop + height;
                        if (itemTop < scrollTop) newTargetAlign = 'top';
                        else if (itemBottom > scrollBottom) newTargetAlign = 'bottom';
                }
                if (targetTop !== null) syncScrollTop(targetTop);
                // One more time for sync
                if (targetTop !== syncState.lastTop) needCollectHeight = true;
            }
            // Trigger next effect
            if (needCollectHeight) setSyncState((0, $cde876c32cf7555b$export$2e2bcd8739ae039)((0, $cde876c32cf7555b$export$2e2bcd8739ae039)({}, syncState), {}, {
                times: syncState.times + 1,
                targetAlign: newTargetAlign,
                lastTop: targetTop
            }));
        }
    }, [
        syncState,
        containerRef.current
    ]);
    // =========================== Scroll To ===========================
    return function(arg) {
        // When not argument provided, we think dev may want to show the scrollbar
        if (arg === null || arg === undefined) {
            triggerFlash();
            return;
        }
        // Normal scroll logic
        (0, $99b8d3464c57be61$export$2e2bcd8739ae039).cancel(scrollRef.current);
        if (typeof arg === 'number') syncScrollTop(arg);
        else if (arg && (0, $c5ac91862c8363d3$export$2e2bcd8739ae039)(arg) === 'object') {
            var index;
            var align = arg.align;
            if ('index' in arg) index = arg.index;
            else index = data.findIndex(function(item) {
                return getKey(item) === arg.key;
            });
            var _arg$offset = arg.offset, offset = _arg$offset === void 0 ? 0 : _arg$offset;
            setSyncState({
                times: 0,
                index: index,
                offset: offset,
                originAlign: align
            });
        }
    };
}







parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");

var $e62b92d94a24723a$var$ScrollBar = /*#__PURE__*/ $N3oW3.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, rtl = props.rtl, scrollOffset = props.scrollOffset, scrollRange = props.scrollRange, onStartMove = props.onStartMove, onStopMove = props.onStopMove, onScroll = props.onScroll, horizontal = props.horizontal, spinSize = props.spinSize, containerSize = props.containerSize, style = props.style, propsThumbStyle = props.thumbStyle, showScrollBar = props.showScrollBar;
    var _React$useState = $32rMB.useState(false), _React$useState2 = (0, $e2a93fed214437b8$export$2e2bcd8739ae039)(_React$useState, 2), dragging = _React$useState2[0], setDragging = _React$useState2[1];
    var _React$useState3 = $32rMB.useState(null), _React$useState4 = (0, $e2a93fed214437b8$export$2e2bcd8739ae039)(_React$useState3, 2), pageXY = _React$useState4[0], setPageXY = _React$useState4[1];
    var _React$useState5 = $32rMB.useState(null), _React$useState6 = (0, $e2a93fed214437b8$export$2e2bcd8739ae039)(_React$useState5, 2), startTop = _React$useState6[0], setStartTop = _React$useState6[1];
    var isLTR = !rtl;
    // ========================= Refs =========================
    var scrollbarRef = $32rMB.useRef();
    var thumbRef = $32rMB.useRef();
    // ======================= Visible ========================
    var _React$useState7 = $32rMB.useState(showScrollBar), _React$useState8 = (0, $e2a93fed214437b8$export$2e2bcd8739ae039)(_React$useState7, 2), visible = _React$useState8[0], setVisible = _React$useState8[1];
    var visibleTimeoutRef = $32rMB.useRef();
    var delayHidden = function delayHidden() {
        if (showScrollBar === true || showScrollBar === false) return;
        clearTimeout(visibleTimeoutRef.current);
        setVisible(true);
        visibleTimeoutRef.current = setTimeout(function() {
            setVisible(false);
        }, 3000);
    };
    // ======================== Range =========================
    var enableScrollRange = scrollRange - containerSize || 0;
    var enableOffsetRange = containerSize - spinSize || 0;
    // ========================= Top ==========================
    var top = $32rMB.useMemo(function() {
        if (scrollOffset === 0 || enableScrollRange === 0) return 0;
        var ptg = scrollOffset / enableScrollRange;
        return ptg * enableOffsetRange;
    }, [
        scrollOffset,
        enableScrollRange,
        enableOffsetRange
    ]);
    // ====================== Container =======================
    var onContainerMouseDown = function onContainerMouseDown(e) {
        e.stopPropagation();
        e.preventDefault();
    };
    // ======================== Thumb =========================
    var stateRef = $32rMB.useRef({
        top: top,
        dragging: dragging,
        pageY: pageXY,
        startTop: startTop
    });
    stateRef.current = {
        top: top,
        dragging: dragging,
        pageY: pageXY,
        startTop: startTop
    };
    var onThumbMouseDown = function onThumbMouseDown(e) {
        setDragging(true);
        setPageXY((0, $b387ede11c8c7060$export$dbd0143e191dc2e5)(e, horizontal));
        setStartTop(stateRef.current.top);
        onStartMove();
        e.stopPropagation();
        e.preventDefault();
    };
    // ======================== Effect ========================
    // React make event as passive, but we need to preventDefault
    // Add event on dom directly instead.
    // ref: https://github.com/facebook/react/issues/9809
    $32rMB.useEffect(function() {
        var onScrollbarTouchStart = function onScrollbarTouchStart(e) {
            e.preventDefault();
        };
        var scrollbarEle = scrollbarRef.current;
        var thumbEle = thumbRef.current;
        scrollbarEle.addEventListener('touchstart', onScrollbarTouchStart, {
            passive: false
        });
        thumbEle.addEventListener('touchstart', onThumbMouseDown, {
            passive: false
        });
        return function() {
            scrollbarEle.removeEventListener('touchstart', onScrollbarTouchStart);
            thumbEle.removeEventListener('touchstart', onThumbMouseDown);
        };
    }, []);
    // Pass to effect
    var enableScrollRangeRef = $32rMB.useRef();
    enableScrollRangeRef.current = enableScrollRange;
    var enableOffsetRangeRef = $32rMB.useRef();
    enableOffsetRangeRef.current = enableOffsetRange;
    $32rMB.useEffect(function() {
        if (dragging) {
            var moveRafId;
            var onMouseMove = function onMouseMove(e) {
                var _stateRef$current = stateRef.current, stateDragging = _stateRef$current.dragging, statePageY = _stateRef$current.pageY, stateStartTop = _stateRef$current.startTop;
                (0, $99b8d3464c57be61$export$2e2bcd8739ae039).cancel(moveRafId);
                var rect = scrollbarRef.current.getBoundingClientRect();
                var scale = containerSize / (horizontal ? rect.width : rect.height);
                if (stateDragging) {
                    var offset = ((0, $b387ede11c8c7060$export$dbd0143e191dc2e5)(e, horizontal) - statePageY) * scale;
                    var newTop = stateStartTop;
                    if (!isLTR && horizontal) newTop -= offset;
                    else newTop += offset;
                    var tmpEnableScrollRange = enableScrollRangeRef.current;
                    var tmpEnableOffsetRange = enableOffsetRangeRef.current;
                    var ptg = tmpEnableOffsetRange ? newTop / tmpEnableOffsetRange : 0;
                    var newScrollTop = Math.ceil(ptg * tmpEnableScrollRange);
                    newScrollTop = Math.max(newScrollTop, 0);
                    newScrollTop = Math.min(newScrollTop, tmpEnableScrollRange);
                    moveRafId = (0, $99b8d3464c57be61$export$2e2bcd8739ae039)(function() {
                        onScroll(newScrollTop, horizontal);
                    });
                }
            };
            var onMouseUp = function onMouseUp() {
                setDragging(false);
                onStopMove();
            };
            window.addEventListener('mousemove', onMouseMove, {
                passive: true
            });
            window.addEventListener('touchmove', onMouseMove, {
                passive: true
            });
            window.addEventListener('mouseup', onMouseUp, {
                passive: true
            });
            window.addEventListener('touchend', onMouseUp, {
                passive: true
            });
            return function() {
                window.removeEventListener('mousemove', onMouseMove);
                window.removeEventListener('touchmove', onMouseMove);
                window.removeEventListener('mouseup', onMouseUp);
                window.removeEventListener('touchend', onMouseUp);
                (0, $99b8d3464c57be61$export$2e2bcd8739ae039).cancel(moveRafId);
            };
        }
    }, [
        dragging
    ]);
    $32rMB.useEffect(function() {
        delayHidden();
        return function() {
            clearTimeout(visibleTimeoutRef.current);
        };
    }, [
        scrollOffset
    ]);
    // ====================== Imperative ======================
    $32rMB.useImperativeHandle(ref, function() {
        return {
            delayHidden: delayHidden
        };
    });
    // ======================== Render ========================
    var scrollbarPrefixCls = "".concat(prefixCls, "-scrollbar");
    var containerStyle = {
        position: 'absolute',
        visibility: visible ? null : 'hidden'
    };
    var thumbStyle = {
        position: 'absolute',
        borderRadius: 99,
        background: 'var(--rc-virtual-list-scrollbar-bg, rgba(0, 0, 0, 0.5))',
        cursor: 'pointer',
        userSelect: 'none'
    };
    if (horizontal) {
        Object.assign(containerStyle, {
            height: 8,
            left: 0,
            right: 0,
            bottom: 0
        });
        Object.assign(thumbStyle, (0, $def8730fb4b8d50a$export$2e2bcd8739ae039)({
            height: '100%',
            width: spinSize
        }, isLTR ? 'left' : 'right', top));
    } else {
        Object.assign(containerStyle, (0, $def8730fb4b8d50a$export$2e2bcd8739ae039)({
            width: 8,
            top: 0,
            bottom: 0
        }, isLTR ? 'right' : 'left', 0));
        Object.assign(thumbStyle, {
            width: '100%',
            height: spinSize,
            top: top
        });
    }
    return /*#__PURE__*/ $hO8yS.createElement("div", {
        ref: scrollbarRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(scrollbarPrefixCls, (0, $def8730fb4b8d50a$export$2e2bcd8739ae039)((0, $def8730fb4b8d50a$export$2e2bcd8739ae039)((0, $def8730fb4b8d50a$export$2e2bcd8739ae039)({}, "".concat(scrollbarPrefixCls, "-horizontal"), horizontal), "".concat(scrollbarPrefixCls, "-vertical"), !horizontal), "".concat(scrollbarPrefixCls, "-visible"), visible)),
        style: (0, $cde876c32cf7555b$export$2e2bcd8739ae039)((0, $cde876c32cf7555b$export$2e2bcd8739ae039)({}, containerStyle), style),
        onMouseDown: onContainerMouseDown,
        onMouseMove: delayHidden
    }, /*#__PURE__*/ $hO8yS.createElement("div", {
        ref: thumbRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))("".concat(scrollbarPrefixCls, "-thumb"), (0, $def8730fb4b8d50a$export$2e2bcd8739ae039)({}, "".concat(scrollbarPrefixCls, "-thumb-moving"), dragging)),
        style: (0, $cde876c32cf7555b$export$2e2bcd8739ae039)((0, $cde876c32cf7555b$export$2e2bcd8739ae039)({}, thumbStyle), propsThumbStyle),
        onMouseDown: onThumbMouseDown
    }));
});
var $e62b92d94a24723a$export$2e2bcd8739ae039 = $e62b92d94a24723a$var$ScrollBar;


var $c3cb0e76e37c6c57$var$MIN_SIZE = 20;
function $c3cb0e76e37c6c57$export$f2ca68955ab35ace() {
    var containerSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var scrollRange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var baseSize = containerSize / scrollRange * containerSize;
    if (isNaN(baseSize)) baseSize = 0;
    baseSize = Math.max(baseSize, $c3cb0e76e37c6c57$var$MIN_SIZE);
    return Math.floor(baseSize);
}


var $1ea290b538e11455$var$_excluded = [
    "prefixCls",
    "className",
    "height",
    "itemHeight",
    "fullHeight",
    "style",
    "data",
    "children",
    "itemKey",
    "virtual",
    "direction",
    "scrollWidth",
    "component",
    "onScroll",
    "onVirtualScroll",
    "onVisibleChange",
    "innerProps",
    "extraRender",
    "styles",
    "showScrollBar"
];
var $1ea290b538e11455$var$EMPTY_DATA = [];
var $1ea290b538e11455$var$ScrollStyle = {
    overflowY: 'auto',
    overflowAnchor: 'none'
};
function $1ea290b538e11455$export$cc3be4e46e8486ed(props, ref) {
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-virtual-list' : _props$prefixCls, className = props.className, height = props.height, itemHeight = props.itemHeight, _props$fullHeight = props.fullHeight, fullHeight = _props$fullHeight === void 0 ? true : _props$fullHeight, style = props.style, data = props.data, children = props.children, itemKey = props.itemKey, virtual = props.virtual, direction = props.direction, scrollWidth = props.scrollWidth, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, onScroll = props.onScroll, onVirtualScroll = props.onVirtualScroll, onVisibleChange = props.onVisibleChange, innerProps = props.innerProps, extraRender = props.extraRender, styles = props.styles, _props$showScrollBar = props.showScrollBar, showScrollBar = _props$showScrollBar === void 0 ? 'optional' : _props$showScrollBar, restProps = (0, $e942b529d3ff1978$export$2e2bcd8739ae039)(props, $1ea290b538e11455$var$_excluded);
    // =============================== Item Key ===============================
    var getKey = $32rMB.useCallback(function(item) {
        if (typeof itemKey === 'function') return itemKey(item);
        return item === null || item === void 0 ? void 0 : item[itemKey];
    }, [
        itemKey
    ]);
    // ================================ Height ================================
    var _useHeights = (0, $13b63baa5b5ba657$export$2e2bcd8739ae039)(getKey, null, null), _useHeights2 = (0, $e2a93fed214437b8$export$2e2bcd8739ae039)(_useHeights, 4), setInstanceRef = _useHeights2[0], collectHeight = _useHeights2[1], heights = _useHeights2[2], heightUpdatedMark = _useHeights2[3];
    // ================================= MISC =================================
    var useVirtual = !!(virtual !== false && height && itemHeight);
    var containerHeight = $32rMB.useMemo(function() {
        return Object.values(heights.maps).reduce(function(total, curr) {
            return total + curr;
        }, 0);
    }, [
        heights.id,
        heights.maps
    ]);
    var inVirtual = useVirtual && data && (Math.max(itemHeight * data.length, containerHeight) > height || !!scrollWidth);
    var isRTL = direction === 'rtl';
    var mergedClassName = (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(prefixCls, (0, $def8730fb4b8d50a$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-rtl"), isRTL), className);
    var mergedData = data || $1ea290b538e11455$var$EMPTY_DATA;
    var componentRef = (0, $32rMB.useRef)();
    var fillerInnerRef = (0, $32rMB.useRef)();
    var containerRef = (0, $32rMB.useRef)();
    // =============================== Item Key ===============================
    var _useState = (0, $32rMB.useState)(0), _useState2 = (0, $e2a93fed214437b8$export$2e2bcd8739ae039)(_useState, 2), offsetTop = _useState2[0], setOffsetTop = _useState2[1];
    var _useState3 = (0, $32rMB.useState)(0), _useState4 = (0, $e2a93fed214437b8$export$2e2bcd8739ae039)(_useState3, 2), offsetLeft = _useState4[0], setOffsetLeft = _useState4[1];
    var _useState5 = (0, $32rMB.useState)(false), _useState6 = (0, $e2a93fed214437b8$export$2e2bcd8739ae039)(_useState5, 2), scrollMoving = _useState6[0], setScrollMoving = _useState6[1];
    var onScrollbarStartMove = function onScrollbarStartMove() {
        setScrollMoving(true);
    };
    var onScrollbarStopMove = function onScrollbarStopMove() {
        setScrollMoving(false);
    };
    var sharedConfig = {
        getKey: getKey
    };
    // ================================ Scroll ================================
    function syncScrollTop(newTop) {
        setOffsetTop(function(origin) {
            var value;
            if (typeof newTop === 'function') value = newTop(origin);
            else value = newTop;
            var alignedTop = keepInRange(value);
            componentRef.current.scrollTop = alignedTop;
            return alignedTop;
        });
    }
    // ================================ Legacy ================================
    // Put ref here since the range is generate by follow
    var rangeRef = (0, $32rMB.useRef)({
        start: 0,
        end: mergedData.length
    });
    var diffItemRef = (0, $32rMB.useRef)();
    var _useDiffItem = (0, $a2fd629ebf0af602$export$2e2bcd8739ae039)(mergedData, getKey), _useDiffItem2 = (0, $e2a93fed214437b8$export$2e2bcd8739ae039)(_useDiffItem, 1), diffItem = _useDiffItem2[0];
    diffItemRef.current = diffItem;
    // ========================== Visible Calculation =========================
    var _React$useMemo = $32rMB.useMemo(function() {
        if (!useVirtual) return {
            scrollHeight: undefined,
            start: 0,
            end: mergedData.length - 1,
            offset: undefined
        };
        // Always use virtual scroll bar in avoid shaking
        if (!inVirtual) {
            var _fillerInnerRef$curre;
            return {
                scrollHeight: ((_fillerInnerRef$curre = fillerInnerRef.current) === null || _fillerInnerRef$curre === void 0 ? void 0 : _fillerInnerRef$curre.offsetHeight) || 0,
                start: 0,
                end: mergedData.length - 1,
                offset: undefined
            };
        }
        var itemTop = 0;
        var startIndex;
        var startOffset;
        var endIndex;
        var dataLen = mergedData.length;
        for(var i = 0; i < dataLen; i += 1){
            var _item = mergedData[i];
            var key = getKey(_item);
            var cacheHeight = heights.get(key);
            var currentItemBottom = itemTop + (cacheHeight === undefined ? itemHeight : cacheHeight);
            // Check item top in the range
            if (currentItemBottom >= offsetTop && startIndex === undefined) {
                startIndex = i;
                startOffset = itemTop;
            }
            // Check item bottom in the range. We will render additional one item for motion usage
            if (currentItemBottom > offsetTop + height && endIndex === undefined) endIndex = i;
            itemTop = currentItemBottom;
        }
        // When scrollTop at the end but data cut to small count will reach this
        if (startIndex === undefined) {
            startIndex = 0;
            startOffset = 0;
            endIndex = Math.ceil(height / itemHeight);
        }
        if (endIndex === undefined) endIndex = mergedData.length - 1;
        // Give cache to improve scroll experience
        endIndex = Math.min(endIndex + 1, mergedData.length - 1);
        return {
            scrollHeight: itemTop,
            start: startIndex,
            end: endIndex,
            offset: startOffset
        };
    }, [
        inVirtual,
        useVirtual,
        offsetTop,
        mergedData,
        heightUpdatedMark,
        height
    ]), scrollHeight = _React$useMemo.scrollHeight, start = _React$useMemo.start, end = _React$useMemo.end, fillerOffset = _React$useMemo.offset;
    rangeRef.current.start = start;
    rangeRef.current.end = end;
    // When scroll up, first visible item get real height may not same as `itemHeight`,
    // Which will make scroll jump.
    // Let's sync scroll top to avoid jump
    $32rMB.useLayoutEffect(function() {
        var changedRecord = heights.getRecord();
        if (changedRecord.size === 1) {
            var recordKey = Array.from(changedRecord.keys())[0];
            var prevCacheHeight = changedRecord.get(recordKey);
            // Quick switch data may cause `start` not in `mergedData` anymore
            var startItem = mergedData[start];
            if (startItem && prevCacheHeight === undefined) {
                var startIndexKey = getKey(startItem);
                if (startIndexKey === recordKey) {
                    var realStartHeight = heights.get(recordKey);
                    var diffHeight = realStartHeight - itemHeight;
                    syncScrollTop(function(ori) {
                        return ori + diffHeight;
                    });
                }
            }
        }
        heights.resetRecord();
    }, [
        scrollHeight
    ]);
    // ================================= Size =================================
    var _React$useState = $32rMB.useState({
        width: 0,
        height: height
    }), _React$useState2 = (0, $e2a93fed214437b8$export$2e2bcd8739ae039)(_React$useState, 2), size = _React$useState2[0], setSize = _React$useState2[1];
    var onHolderResize = function onHolderResize(sizeInfo) {
        setSize({
            width: sizeInfo.offsetWidth,
            height: sizeInfo.offsetHeight
        });
    };
    // Hack on scrollbar to enable flash call
    var verticalScrollBarRef = (0, $32rMB.useRef)();
    var horizontalScrollBarRef = (0, $32rMB.useRef)();
    var horizontalScrollBarSpinSize = $32rMB.useMemo(function() {
        return (0, $c3cb0e76e37c6c57$export$f2ca68955ab35ace)(size.width, scrollWidth);
    }, [
        size.width,
        scrollWidth
    ]);
    var verticalScrollBarSpinSize = $32rMB.useMemo(function() {
        return (0, $c3cb0e76e37c6c57$export$f2ca68955ab35ace)(size.height, scrollHeight);
    }, [
        size.height,
        scrollHeight
    ]);
    // =============================== In Range ===============================
    var maxScrollHeight = scrollHeight - height;
    var maxScrollHeightRef = (0, $32rMB.useRef)(maxScrollHeight);
    maxScrollHeightRef.current = maxScrollHeight;
    function keepInRange(newScrollTop) {
        var newTop = newScrollTop;
        if (!Number.isNaN(maxScrollHeightRef.current)) newTop = Math.min(newTop, maxScrollHeightRef.current);
        newTop = Math.max(newTop, 0);
        return newTop;
    }
    var isScrollAtTop = offsetTop <= 0;
    var isScrollAtBottom = offsetTop >= maxScrollHeight;
    var isScrollAtLeft = offsetLeft <= 0;
    var isScrollAtRight = offsetLeft >= scrollWidth;
    var originScroll = (0, $2ccf1d98b9d22e58$export$2e2bcd8739ae039)(isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight);
    // ================================ Scroll ================================
    var getVirtualScrollInfo = function getVirtualScrollInfo() {
        return {
            x: isRTL ? -offsetLeft : offsetLeft,
            y: offsetTop
        };
    };
    var lastVirtualScrollInfoRef = (0, $32rMB.useRef)(getVirtualScrollInfo());
    var triggerScroll = (0, $5c85f0dd15155745$export$2e2bcd8739ae039)(function(params) {
        if (onVirtualScroll) {
            var nextInfo = (0, $cde876c32cf7555b$export$2e2bcd8739ae039)((0, $cde876c32cf7555b$export$2e2bcd8739ae039)({}, getVirtualScrollInfo()), params);
            // Trigger when offset changed
            if (lastVirtualScrollInfoRef.current.x !== nextInfo.x || lastVirtualScrollInfoRef.current.y !== nextInfo.y) {
                onVirtualScroll(nextInfo);
                lastVirtualScrollInfoRef.current = nextInfo;
            }
        }
    });
    function onScrollBar(newScrollOffset, horizontal) {
        var newOffset = newScrollOffset;
        if (horizontal) {
            (0, $N3oW3.flushSync)(function() {
                setOffsetLeft(newOffset);
            });
            triggerScroll();
        } else syncScrollTop(newOffset);
    }
    // When data size reduce. It may trigger native scroll event back to fit scroll position
    function onFallbackScroll(e) {
        var newScrollTop = e.currentTarget.scrollTop;
        if (newScrollTop !== offsetTop) syncScrollTop(newScrollTop);
        // Trigger origin onScroll
        onScroll === null || onScroll === void 0 || onScroll(e);
        triggerScroll();
    }
    var keepInHorizontalRange = function keepInHorizontalRange(nextOffsetLeft) {
        var tmpOffsetLeft = nextOffsetLeft;
        var max = !!scrollWidth ? scrollWidth - size.width : 0;
        tmpOffsetLeft = Math.max(tmpOffsetLeft, 0);
        tmpOffsetLeft = Math.min(tmpOffsetLeft, max);
        return tmpOffsetLeft;
    };
    var onWheelDelta = (0, $5c85f0dd15155745$export$2e2bcd8739ae039)(function(offsetXY, fromHorizontal) {
        if (fromHorizontal) {
            (0, $N3oW3.flushSync)(function() {
                setOffsetLeft(function(left) {
                    var nextOffsetLeft = left + (isRTL ? -offsetXY : offsetXY);
                    return keepInHorizontalRange(nextOffsetLeft);
                });
            });
            triggerScroll();
        } else syncScrollTop(function(top) {
            var newTop = top + offsetXY;
            return newTop;
        });
    });
    // Since this added in global,should use ref to keep update
    var _useFrameWheel = (0, $ca6a9eaf1db2ddba$export$2e2bcd8739ae039)(useVirtual, isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight, !!scrollWidth, onWheelDelta), _useFrameWheel2 = (0, $e2a93fed214437b8$export$2e2bcd8739ae039)(_useFrameWheel, 2), onRawWheel = _useFrameWheel2[0], onFireFoxScroll = _useFrameWheel2[1];
    // Mobile touch move
    (0, $3a044bb2e6ca346b$export$2e2bcd8739ae039)(useVirtual, componentRef, function(isHorizontal, delta, smoothOffset, e) {
        var event = e;
        if (originScroll(isHorizontal, delta, smoothOffset)) return false;
        // Fix nest List trigger TouchMove event
        if (!event || !event._virtualHandled) {
            if (event) event._virtualHandled = true;
            onRawWheel({
                preventDefault: function preventDefault() {},
                deltaX: isHorizontal ? delta : 0,
                deltaY: isHorizontal ? 0 : delta
            });
            return true;
        }
        return false;
    });
    // MouseDown drag for scroll
    (0, $b387ede11c8c7060$export$2e2bcd8739ae039)(inVirtual, componentRef, function(offset) {
        syncScrollTop(function(top) {
            return top + offset;
        });
    });
    (0, $af1ff2ee9ec51f79$export$2e2bcd8739ae039)(function() {
        // Firefox only
        function onMozMousePixelScroll(e) {
            // scrolling at top/bottom limit
            var scrollingUpAtTop = isScrollAtTop && e.detail < 0;
            var scrollingDownAtBottom = isScrollAtBottom && e.detail > 0;
            if (useVirtual && !scrollingUpAtTop && !scrollingDownAtBottom) e.preventDefault();
        }
        var componentEle = componentRef.current;
        componentEle.addEventListener('wheel', onRawWheel, {
            passive: false
        });
        componentEle.addEventListener('DOMMouseScroll', onFireFoxScroll, {
            passive: true
        });
        componentEle.addEventListener('MozMousePixelScroll', onMozMousePixelScroll, {
            passive: false
        });
        return function() {
            componentEle.removeEventListener('wheel', onRawWheel);
            componentEle.removeEventListener('DOMMouseScroll', onFireFoxScroll);
            componentEle.removeEventListener('MozMousePixelScroll', onMozMousePixelScroll);
        };
    }, [
        useVirtual,
        isScrollAtTop,
        isScrollAtBottom
    ]);
    // Sync scroll left
    (0, $af1ff2ee9ec51f79$export$2e2bcd8739ae039)(function() {
        if (scrollWidth) {
            var newOffsetLeft = keepInHorizontalRange(offsetLeft);
            setOffsetLeft(newOffsetLeft);
            triggerScroll({
                x: newOffsetLeft
            });
        }
    }, [
        size.width,
        scrollWidth
    ]);
    // ================================= Ref ==================================
    var delayHideScrollBar = function delayHideScrollBar() {
        var _verticalScrollBarRef, _horizontalScrollBarR;
        (_verticalScrollBarRef = verticalScrollBarRef.current) === null || _verticalScrollBarRef === void 0 || _verticalScrollBarRef.delayHidden();
        (_horizontalScrollBarR = horizontalScrollBarRef.current) === null || _horizontalScrollBarR === void 0 || _horizontalScrollBarR.delayHidden();
    };
    var _scrollTo = (0, $ac2c934acce7f8cf$export$2e2bcd8739ae039)(componentRef, mergedData, heights, itemHeight, getKey, function() {
        return collectHeight(true);
    }, syncScrollTop, delayHideScrollBar);
    $32rMB.useImperativeHandle(ref, function() {
        return {
            nativeElement: containerRef.current,
            getScrollInfo: getVirtualScrollInfo,
            scrollTo: function scrollTo(config) {
                function isPosScroll(arg) {
                    return arg && (0, $c5ac91862c8363d3$export$2e2bcd8739ae039)(arg) === 'object' && ('left' in arg || 'top' in arg);
                }
                if (isPosScroll(config)) {
                    // Scroll X
                    if (config.left !== undefined) setOffsetLeft(keepInHorizontalRange(config.left));
                    // Scroll Y
                    _scrollTo(config.top);
                } else _scrollTo(config);
            }
        };
    });
    // ================================ Effect ================================
    /** We need told outside that some list not rendered */ (0, $af1ff2ee9ec51f79$export$2e2bcd8739ae039)(function() {
        if (onVisibleChange) {
            var renderList = mergedData.slice(start, end + 1);
            onVisibleChange(renderList, mergedData);
        }
    }, [
        start,
        end,
        mergedData
    ]);
    // ================================ Extra =================================
    var getSize = (0, $096c1c5beb2f1177$export$a1d82723752af087)(mergedData, getKey, heights, itemHeight);
    var extraContent = extraRender === null || extraRender === void 0 ? void 0 : extraRender({
        start: start,
        end: end,
        virtual: inVirtual,
        offsetX: offsetLeft,
        offsetY: fillerOffset,
        rtl: isRTL,
        getSize: getSize
    });
    // ================================ Render ================================
    var listChildren = (0, $c71a6ed0608001ae$export$2e2bcd8739ae039)(mergedData, start, end, scrollWidth, offsetLeft, setInstanceRef, children, sharedConfig);
    var componentStyle = null;
    if (height) {
        componentStyle = (0, $cde876c32cf7555b$export$2e2bcd8739ae039)((0, $def8730fb4b8d50a$export$2e2bcd8739ae039)({}, fullHeight ? 'height' : 'maxHeight', height), $1ea290b538e11455$var$ScrollStyle);
        if (useVirtual) {
            componentStyle.overflowY = 'hidden';
            if (scrollWidth) componentStyle.overflowX = 'hidden';
            if (scrollMoving) componentStyle.pointerEvents = 'none';
        }
    }
    var containerProps = {};
    if (isRTL) containerProps.dir = 'rtl';
    return /*#__PURE__*/ $hO8yS.createElement("div", (0, $4dfb8f1fff0cbd5e$export$2e2bcd8739ae039)({
        ref: containerRef,
        style: (0, $cde876c32cf7555b$export$2e2bcd8739ae039)((0, $cde876c32cf7555b$export$2e2bcd8739ae039)({}, style), {}, {
            position: 'relative'
        }),
        className: mergedClassName
    }, containerProps, restProps), /*#__PURE__*/ $hO8yS.createElement((0, $46befc6c0d7dbbd8$export$2e2bcd8739ae039), {
        onResize: onHolderResize
    }, /*#__PURE__*/ $hO8yS.createElement(Component, {
        className: "".concat(prefixCls, "-holder"),
        style: componentStyle,
        ref: componentRef,
        onScroll: onFallbackScroll,
        onMouseEnter: delayHideScrollBar
    }, /*#__PURE__*/ $hO8yS.createElement((0, $6038b9db303d24ed$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        height: scrollHeight,
        offsetX: offsetLeft,
        offsetY: fillerOffset,
        scrollWidth: scrollWidth,
        onInnerResize: collectHeight,
        ref: fillerInnerRef,
        innerProps: innerProps,
        rtl: isRTL,
        extra: extraContent
    }, listChildren))), inVirtual && scrollHeight > height && /*#__PURE__*/ $hO8yS.createElement((0, $e62b92d94a24723a$export$2e2bcd8739ae039), {
        ref: verticalScrollBarRef,
        prefixCls: prefixCls,
        scrollOffset: offsetTop,
        scrollRange: scrollHeight,
        rtl: isRTL,
        onScroll: onScrollBar,
        onStartMove: onScrollbarStartMove,
        onStopMove: onScrollbarStopMove,
        spinSize: verticalScrollBarSpinSize,
        containerSize: size.height,
        style: styles === null || styles === void 0 ? void 0 : styles.verticalScrollBar,
        thumbStyle: styles === null || styles === void 0 ? void 0 : styles.verticalScrollBarThumb,
        showScrollBar: showScrollBar
    }), inVirtual && scrollWidth > size.width && /*#__PURE__*/ $hO8yS.createElement((0, $e62b92d94a24723a$export$2e2bcd8739ae039), {
        ref: horizontalScrollBarRef,
        prefixCls: prefixCls,
        scrollOffset: offsetLeft,
        scrollRange: scrollWidth,
        rtl: isRTL,
        onScroll: onScrollBar,
        onStartMove: onScrollbarStartMove,
        onStopMove: onScrollbarStopMove,
        spinSize: horizontalScrollBarSpinSize,
        containerSize: size.width,
        horizontal: true,
        style: styles === null || styles === void 0 ? void 0 : styles.horizontalScrollBar,
        thumbStyle: styles === null || styles === void 0 ? void 0 : styles.horizontalScrollBarThumb,
        showScrollBar: showScrollBar
    }));
}
var $1ea290b538e11455$var$List = /*#__PURE__*/ $N3oW3.forwardRef($1ea290b538e11455$export$cc3be4e46e8486ed);
$1ea290b538e11455$var$List.displayName = 'List';
var $1ea290b538e11455$export$2e2bcd8739ae039 = $1ea290b538e11455$var$List;


var $7c54ff74bcae5103$export$2e2bcd8739ae039 = (0, $1ea290b538e11455$export$2e2bcd8739ae039);


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");




parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");





parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");



const $a691fe8d101f2080$export$fbb76fda59aa02a2 = (0, $05171245d73033f8$export$fd42f52fd3ae1109)(null);
const $a691fe8d101f2080$export$11cae3e04ab99fae = (0, $05171245d73033f8$export$fd42f52fd3ae1109)(null);


function $87531db318ec61dc$var$_extends() {
    $87531db318ec61dc$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $87531db318ec61dc$var$_extends.apply(this, arguments);
}
function $87531db318ec61dc$export$dfa11a34ceba822(colIndex, colSpan, columnsOffset) {
    const mergedColSpan = colSpan || 1;
    return columnsOffset[colIndex + mergedColSpan] - (columnsOffset[colIndex] || 0);
}
const $87531db318ec61dc$var$VirtualCell = (props)=>{
    const { rowInfo: rowInfo, column: column, colIndex: colIndex, indent: indent, index: index, component: component, renderIndex: renderIndex, record: record, style: style, className: className, inverse: inverse, getHeight: getHeight } = props;
    const { render: render, dataIndex: dataIndex, className: columnClassName, width: colWidth } = column;
    const { columnsOffset: columnsOffset } = (0, $05171245d73033f8$export$fae74005e78b1a27)((0, $a691fe8d101f2080$export$11cae3e04ab99fae), [
        'columnsOffset'
    ]);
    // TODO: support `expandableRowOffset`
    const { key: key, fixedInfo: fixedInfo, appendCellNode: appendCellNode, additionalCellProps: additionalCellProps } = (0, $1a3ac4c477d773c5$export$16400ac709c56616)(rowInfo, column, colIndex, indent, index);
    const { style: cellStyle, colSpan: colSpan = 1, rowSpan: rowSpan = 1 } = additionalCellProps;
    // ========================= ColWidth =========================
    // column width
    const startColIndex = colIndex - 1;
    const concatColWidth = $87531db318ec61dc$export$dfa11a34ceba822(startColIndex, colSpan, columnsOffset);
    // margin offset
    const marginOffset = colSpan > 1 ? colWidth - concatColWidth : 0;
    // ========================== Style ===========================
    const mergedStyle = {
        ...cellStyle,
        ...style,
        flex: `0 0 ${concatColWidth}px`,
        width: `${concatColWidth}px`,
        marginRight: marginOffset,
        pointerEvents: 'auto'
    };
    // When `colSpan` or `rowSpan` is `0`, should skip render.
    const needHide = $32rMB.useMemo(()=>{
        if (inverse) return rowSpan <= 1;
        else return colSpan === 0 || rowSpan === 0 || rowSpan > 1;
    }, [
        rowSpan,
        colSpan,
        inverse
    ]);
    // 0 rowSpan or colSpan should not render
    if (needHide) mergedStyle.visibility = 'hidden';
    else if (inverse) mergedStyle.height = getHeight?.(rowSpan);
    const mergedRender = needHide ? ()=>null : render;
    // ========================== Render ==========================
    const cellSpan = {};
    // Virtual should reset `colSpan` & `rowSpan`
    if (rowSpan === 0 || colSpan === 0) {
        cellSpan.rowSpan = 1;
        cellSpan.colSpan = 1;
    }
    return /*#__PURE__*/ $hO8yS.createElement((0, $be7b183a427ed9d8$export$2e2bcd8739ae039), $87531db318ec61dc$var$_extends({
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(columnClassName, className),
        ellipsis: column.ellipsis,
        align: column.align,
        scope: column.rowScope,
        component: component,
        prefixCls: rowInfo.prefixCls,
        key: key,
        record: record,
        index: index,
        renderIndex: renderIndex,
        dataIndex: dataIndex,
        render: mergedRender,
        shouldCellUpdate: column.shouldCellUpdate
    }, fixedInfo, {
        appendNode: appendCellNode,
        additionalProps: {
            ...additionalCellProps,
            style: mergedStyle,
            ...cellSpan
        }
    }));
};
var $87531db318ec61dc$export$2e2bcd8739ae039 = $87531db318ec61dc$var$VirtualCell;




function $bec8620fe3db71a7$var$_extends() {
    $bec8620fe3db71a7$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bec8620fe3db71a7$var$_extends.apply(this, arguments);
}
const $bec8620fe3db71a7$var$BodyLine = /*#__PURE__*/ $N3oW3.forwardRef((props, ref)=>{
    const { data: data, index: index, className: className, rowKey: rowKey, style: style, extra: extra, getHeight: getHeight, ...restProps } = props;
    const { record: record, indent: indent, index: renderIndex } = data;
    const { scrollX: scrollX, flattenColumns: flattenColumns, prefixCls: prefixCls, fixColumn: fixColumn, componentWidth: componentWidth } = (0, $05171245d73033f8$export$fae74005e78b1a27)((0, $92843d8d43ffd1ab$export$2e2bcd8739ae039), [
        'prefixCls',
        'flattenColumns',
        'fixColumn',
        'componentWidth',
        'scrollX'
    ]);
    const { getComponent: getComponent } = (0, $05171245d73033f8$export$fae74005e78b1a27)((0, $a691fe8d101f2080$export$fbb76fda59aa02a2), [
        'getComponent'
    ]);
    const rowInfo = (0, $d620e8c4690f2986$export$2e2bcd8739ae039)(record, rowKey, index, indent);
    const RowComponent = getComponent([
        'body',
        'row'
    ], 'div');
    const cellComponent = getComponent([
        'body',
        'cell'
    ], 'div');
    // ========================== Expand ==========================
    const { rowSupportExpand: rowSupportExpand, expanded: expanded, rowProps: rowProps, expandedRowRender: expandedRowRender, expandedRowClassName: expandedRowClassName } = rowInfo;
    let expandRowNode;
    if (rowSupportExpand && expanded) {
        const expandContent = expandedRowRender(record, index, indent + 1, expanded);
        const expandedClsName = (0, $3fbfb9594bd9c3cf$export$c5c465afb98f57b6)(expandedRowClassName, record, index, indent);
        let additionalProps = {};
        if (fixColumn) additionalProps = {
            style: {
                ['--virtual-width']: `${componentWidth}px`
            }
        };
        const rowCellCls = `${prefixCls}-expanded-row-cell`;
        expandRowNode = /*#__PURE__*/ $hO8yS.createElement(RowComponent, {
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-expanded-row`, `${prefixCls}-expanded-row-level-${indent + 1}`, expandedClsName)
        }, /*#__PURE__*/ $hO8yS.createElement((0, $be7b183a427ed9d8$export$2e2bcd8739ae039), {
            component: cellComponent,
            prefixCls: prefixCls,
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(rowCellCls, {
                [`${rowCellCls}-fixed`]: fixColumn
            }),
            additionalProps: additionalProps
        }, expandContent));
    }
    // ========================== Render ==========================
    const rowStyle = {
        ...style,
        width: scrollX
    };
    if (extra) {
        rowStyle.position = 'absolute';
        rowStyle.pointerEvents = 'none';
    }
    const rowNode = /*#__PURE__*/ $hO8yS.createElement(RowComponent, $bec8620fe3db71a7$var$_extends({}, rowProps, restProps, {
        "data-row-key": rowKey,
        ref: rowSupportExpand ? null : ref,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(className, `${prefixCls}-row`, rowProps?.className, {
            [`${prefixCls}-row-extra`]: extra
        }),
        style: {
            ...rowStyle,
            ...rowProps?.style
        }
    }), flattenColumns.map((column, colIndex)=>{
        return /*#__PURE__*/ $hO8yS.createElement((0, $87531db318ec61dc$export$2e2bcd8739ae039), {
            key: colIndex,
            component: cellComponent,
            rowInfo: rowInfo,
            column: column,
            colIndex: colIndex,
            indent: indent,
            index: index,
            renderIndex: renderIndex,
            record: record,
            inverse: extra,
            getHeight: getHeight
        });
    }));
    if (rowSupportExpand) return /*#__PURE__*/ $hO8yS.createElement("div", {
        ref: ref
    }, rowNode, expandRowNode);
    return rowNode;
});
const $bec8620fe3db71a7$var$ResponseBodyLine = (0, $92843d8d43ffd1ab$export$e9e4cb9eb9e2b4c4)($bec8620fe3db71a7$var$BodyLine);
var $bec8620fe3db71a7$export$2e2bcd8739ae039 = $bec8620fe3db71a7$var$ResponseBodyLine;



const $01ef78e6e6cbb41f$var$Grid = /*#__PURE__*/ $N3oW3.forwardRef((props, ref)=>{
    const { data: data, onScroll: onScroll } = props;
    const { flattenColumns: flattenColumns, onColumnResize: onColumnResize, getRowKey: getRowKey, expandedKeys: expandedKeys, prefixCls: prefixCls, childrenColumnName: childrenColumnName, scrollX: scrollX, direction: direction } = (0, $05171245d73033f8$export$fae74005e78b1a27)((0, $92843d8d43ffd1ab$export$2e2bcd8739ae039), [
        'flattenColumns',
        'onColumnResize',
        'getRowKey',
        'prefixCls',
        'expandedKeys',
        'childrenColumnName',
        'scrollX',
        'direction'
    ]);
    const { sticky: sticky, scrollY: scrollY, listItemHeight: listItemHeight, getComponent: getComponent, onScroll: onTablePropScroll } = (0, $05171245d73033f8$export$fae74005e78b1a27)((0, $a691fe8d101f2080$export$fbb76fda59aa02a2));
    // =========================== Ref ============================
    const listRef = $32rMB.useRef(null);
    // =========================== Data ===========================
    const flattenData = (0, $ad26f2b33f716db0$export$2e2bcd8739ae039)(data, childrenColumnName, expandedKeys, getRowKey);
    // ========================== Column ==========================
    const columnsWidth = $32rMB.useMemo(()=>{
        let total = 0;
        return flattenColumns.map(({ width: width, minWidth: minWidth, key: key })=>{
            const finalWidth = Math.max(width || 0, minWidth || 0);
            total += finalWidth;
            return [
                key,
                finalWidth,
                total
            ];
        });
    }, [
        flattenColumns
    ]);
    const columnsOffset = $32rMB.useMemo(()=>columnsWidth.map((colWidth)=>colWidth[2]), [
        columnsWidth
    ]);
    $32rMB.useEffect(()=>{
        columnsWidth.forEach(([key, width])=>{
            onColumnResize(key, width);
        });
    }, [
        columnsWidth
    ]);
    // =========================== Ref ============================
    $32rMB.useImperativeHandle(ref, ()=>{
        const obj = {
            scrollTo: (config)=>{
                const { offset: offset, ...restConfig } = config;
                // If offset is provided, force align to 'top' for consistent behavior
                if (offset) listRef.current?.scrollTo({
                    ...restConfig,
                    offset: offset,
                    align: 'top'
                });
                else listRef.current?.scrollTo(config);
            },
            nativeElement: listRef.current?.nativeElement
        };
        Object.defineProperty(obj, 'scrollLeft', {
            get: ()=>listRef.current?.getScrollInfo().x || 0,
            set: (value)=>{
                listRef.current?.scrollTo({
                    left: value
                });
            }
        });
        // https://github.com/ant-design/ant-design/issues/54734
        Object.defineProperty(obj, 'scrollTop', {
            get: ()=>listRef.current?.getScrollInfo().y || 0,
            set: (value)=>{
                listRef.current?.scrollTo({
                    top: value
                });
            }
        });
        return obj;
    });
    // ======================= Col/Row Span =======================
    const getRowSpan = (column, index)=>{
        const record = flattenData[index]?.record;
        const { onCell: onCell } = column;
        if (onCell) {
            const cellProps = onCell(record, index);
            return cellProps?.rowSpan ?? 1;
        }
        return 1;
    };
    const extraRender = (info)=>{
        const { start: start, end: end, getSize: getSize, offsetY: offsetY } = info;
        // Do nothing if no data
        if (end < 0) return null;
        // Find first rowSpan column
        let firstRowSpanColumns = flattenColumns.filter(// rowSpan is 0
        (column)=>getRowSpan(column, start) === 0);
        let startIndex = start;
        for(let i = start; i >= 0; i -= 1){
            firstRowSpanColumns = firstRowSpanColumns.filter((column)=>getRowSpan(column, i) === 0);
            if (!firstRowSpanColumns.length) {
                startIndex = i;
                break;
            }
        }
        // Find last rowSpan column
        let lastRowSpanColumns = flattenColumns.filter(// rowSpan is not 1
        (column)=>getRowSpan(column, end) !== 1);
        let endIndex = end;
        for(let i = end; i < flattenData.length; i += 1){
            lastRowSpanColumns = lastRowSpanColumns.filter((column)=>getRowSpan(column, i) !== 1);
            if (!lastRowSpanColumns.length) {
                endIndex = Math.max(i - 1, end);
                break;
            }
        }
        // Collect the line who has rowSpan
        const spanLines = [];
        for(let i = startIndex; i <= endIndex; i += 1){
            const item = flattenData[i];
            // This code will never reach, just incase
            if (!item) continue;
            if (flattenColumns.some((column)=>getRowSpan(column, i) > 1)) spanLines.push(i);
        }
        // Patch extra line on the page
        const nodes = spanLines.map((index)=>{
            const item = flattenData[index];
            const rowKey = getRowKey(item.record, index);
            const getHeight = (rowSpan)=>{
                const endItemIndex = index + rowSpan - 1;
                const endItemKey = getRowKey(flattenData[endItemIndex].record, endItemIndex);
                const sizeInfo = getSize(rowKey, endItemKey);
                return sizeInfo.bottom - sizeInfo.top;
            };
            const sizeInfo = getSize(rowKey);
            return /*#__PURE__*/ $hO8yS.createElement((0, $bec8620fe3db71a7$export$2e2bcd8739ae039), {
                key: index,
                data: item,
                rowKey: rowKey,
                index: index,
                style: {
                    top: -offsetY + sizeInfo.top
                },
                extra: true,
                getHeight: getHeight
            });
        });
        return nodes;
    };
    // ========================= Context ==========================
    const gridContext = $32rMB.useMemo(()=>({
            columnsOffset: columnsOffset
        }), [
        columnsOffset
    ]);
    // ========================== Render ==========================
    const tblPrefixCls = `${prefixCls}-tbody`;
    // default 'div' in rc-virtual-list
    const wrapperComponent = getComponent([
        'body',
        'wrapper'
    ]);
    // ========================== Sticky Scroll Bar ==========================
    const horizontalScrollBarStyle = {};
    if (sticky) {
        horizontalScrollBarStyle.position = 'sticky';
        horizontalScrollBarStyle.bottom = 0;
        if (typeof sticky === 'object' && sticky.offsetScroll) horizontalScrollBarStyle.bottom = sticky.offsetScroll;
    }
    return /*#__PURE__*/ $hO8yS.createElement((0, $a691fe8d101f2080$export$11cae3e04ab99fae).Provider, {
        value: gridContext
    }, /*#__PURE__*/ $hO8yS.createElement((0, $7c54ff74bcae5103$export$2e2bcd8739ae039), {
        fullHeight: false,
        ref: listRef,
        prefixCls: `${tblPrefixCls}-virtual`,
        styles: {
            horizontalScrollBar: horizontalScrollBarStyle
        },
        className: tblPrefixCls,
        height: scrollY,
        itemHeight: listItemHeight || 24,
        data: flattenData,
        itemKey: (item)=>getRowKey(item.record),
        component: wrapperComponent,
        scrollWidth: scrollX,
        direction: direction,
        onVirtualScroll: ({ x: x })=>{
            onScroll({
                currentTarget: listRef.current?.nativeElement,
                scrollLeft: x
            });
        },
        onScroll: onTablePropScroll,
        extraRender: extraRender
    }, (item, index, itemProps)=>{
        const rowKey = getRowKey(item.record, index);
        return /*#__PURE__*/ $hO8yS.createElement((0, $bec8620fe3db71a7$export$2e2bcd8739ae039), {
            data: item,
            rowKey: rowKey,
            index: index,
            style: itemProps.style
        });
    }));
});
const $01ef78e6e6cbb41f$var$ResponseGrid = (0, $92843d8d43ffd1ab$export$e9e4cb9eb9e2b4c4)($01ef78e6e6cbb41f$var$Grid);
var $01ef78e6e6cbb41f$export$2e2bcd8739ae039 = $01ef78e6e6cbb41f$var$ResponseGrid;




function $7e2ea9e225713277$var$_extends() {
    $7e2ea9e225713277$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7e2ea9e225713277$var$_extends.apply(this, arguments);
}
const $7e2ea9e225713277$var$renderBody = (rawData, props)=>{
    const { ref: ref, onScroll: onScroll } = props;
    return /*#__PURE__*/ $hO8yS.createElement((0, $01ef78e6e6cbb41f$export$2e2bcd8739ae039), {
        ref: ref,
        data: rawData,
        onScroll: onScroll
    });
};
const $7e2ea9e225713277$var$VirtualTable = (props, ref)=>{
    const { data: data, columns: columns, scroll: scroll, sticky: sticky, prefixCls: prefixCls = (0, $a9ad8dfff2cff25d$export$c42ed95a478b1ec5), className: className, listItemHeight: listItemHeight, components: components, onScroll: onScroll } = props;
    let { x: scrollX, y: scrollY } = scroll || {};
    // Fill scrollX
    if (typeof scrollX !== 'number') scrollX = 1;
    // Fill scrollY
    if (typeof scrollY !== 'number') scrollY = 500;
    const getComponent = (0, $ea93068db096b7d6$export$2e2bcd8739ae039)((path, defaultComponent)=>(0, $7967876a5e08d9ff$export$2e2bcd8739ae039)(components, path) || defaultComponent);
    // Memo this
    const onInternalScroll = (0, $ea93068db096b7d6$export$2e2bcd8739ae039)(onScroll);
    // ========================= Context ==========================
    const context = $32rMB.useMemo(()=>({
            sticky: sticky,
            scrollY: scrollY,
            listItemHeight: listItemHeight,
            getComponent: getComponent,
            onScroll: onInternalScroll
        }), [
        sticky,
        scrollY,
        listItemHeight,
        getComponent,
        onInternalScroll
    ]);
    // ========================== Render ==========================
    return /*#__PURE__*/ $hO8yS.createElement((0, $a691fe8d101f2080$export$fbb76fda59aa02a2).Provider, {
        value: context
    }, /*#__PURE__*/ $hO8yS.createElement((0, $a9ad8dfff2cff25d$export$2e2bcd8739ae039), $7e2ea9e225713277$var$_extends({}, props, {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(className, `${prefixCls}-virtual`),
        scroll: {
            ...scroll,
            x: scrollX
        },
        components: {
            ...components,
            // fix https://github.com/ant-design/ant-design/issues/48991
            body: data?.length ? $7e2ea9e225713277$var$renderBody : undefined
        },
        columns: columns,
        internalHooks: (0, $a942291e76081e0b$export$91b75cf262680225),
        tailor: true,
        ref: ref
    })));
};
const $7e2ea9e225713277$var$RefVirtualTable = /*#__PURE__*/ $N3oW3.forwardRef($7e2ea9e225713277$var$VirtualTable);
const $7e2ea9e225713277$export$4747b79b36862360 = (shouldTriggerRender)=>{
    return (0, $92843d8d43ffd1ab$export$ffd6d5bef5eaf0a4)($7e2ea9e225713277$var$RefVirtualTable, shouldTriggerRender);
};
var $7e2ea9e225713277$export$2e2bcd8739ae039 = $7e2ea9e225713277$export$4747b79b36862360();


var $0d037f2e10760320$export$2e2bcd8739ae039 = (0, $a9ad8dfff2cff25d$export$2e2bcd8739ae039);


/* istanbul ignore next */ /** This is a syntactic sugar for `columns` prop. So HOC will not work on this. */ const $574ffd90a6412d20$var$Column = (_)=>null;
var $574ffd90a6412d20$export$2e2bcd8739ae039 = $574ffd90a6412d20$var$Column;


/* istanbul ignore next */ /** This is a syntactic sugar for `columns` prop. So HOC will not work on this. */ const $b58f2657f1538597$var$ColumnGroup = (_)=>null;
var $b58f2657f1538597$export$2e2bcd8739ae039 = $b58f2657f1538597$var$ColumnGroup;



parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");
parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
// This icon file is generated automatically.
var $b09d5d6a354f9ab8$var$DownOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z"
                }
            }
        ]
    },
    "name": "down",
    "theme": "outlined"
};
var $b09d5d6a354f9ab8$export$2e2bcd8739ae039 = $b09d5d6a354f9ab8$var$DownOutlined;



function $6c28e8c1b305d317$var$_extends() {
    $6c28e8c1b305d317$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6c28e8c1b305d317$var$_extends.apply(this, arguments);
}
const $6c28e8c1b305d317$var$DownOutlined = (props, ref)=>/*#__PURE__*/ $hO8yS.createElement((0, $5fd6f3f3c400c267$export$2e2bcd8739ae039), $6c28e8c1b305d317$var$_extends({}, props, {
        ref: ref,
        icon: (0, $b09d5d6a354f9ab8$export$2e2bcd8739ae039)
    }));
/**![down](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg4NCAyNTZoLTc1Yy01LjEgMC05LjkgMi41LTEyLjkgNi42TDUxMiA2NTQuMiAyMjcuOSAyNjIuNmMtMy00LjEtNy44LTYuNi0xMi45LTYuNmgtNzVjLTYuNSAwLTEwLjMgNy40LTYuNSAxMi43bDM1Mi42IDQ4Ni4xYzEyLjggMTcuNiAzOSAxNy42IDUxLjcgMGwzNTIuNi00ODYuMWMzLjktNS4zLjEtMTIuNy02LjQtMTIuN3oiIC8+PC9zdmc+) */ const $6c28e8c1b305d317$var$RefIcon = /*#__PURE__*/ $N3oW3.forwardRef($6c28e8c1b305d317$var$DownOutlined);
var $6c28e8c1b305d317$export$2e2bcd8739ae039 = $6c28e8c1b305d317$var$RefIcon;





var $N3oW3 = parcelRequire("N3oW3");

var $N3oW3 = parcelRequire("N3oW3");


/**
 * Webpack has bug for import loop, which is not the same behavior as ES module.
 * When util.js imports the TreeNode for tree generate will cause treeContextTypes be empty.
 */ parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
const $338114f31d3e4af5$export$dfae7d399eea2568 = /*#__PURE__*/ $hO8yS.createContext(null);
const $338114f31d3e4af5$export$e508d6f1a100e5dd = /*#__PURE__*/ $hO8yS.createContext({});



parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
const $091c81bddc291167$var$Indent = ({ prefixCls: prefixCls, level: level, isStart: isStart, isEnd: isEnd })=>{
    const baseClassName = `${prefixCls}-indent-unit`;
    const list = [];
    for(let i = 0; i < level; i += 1)list.push(/*#__PURE__*/ $hO8yS.createElement("span", {
        key: i,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(baseClassName, {
            [`${baseClassName}-start`]: isStart[i],
            [`${baseClassName}-end`]: isEnd[i]
        })
    }));
    return /*#__PURE__*/ $hO8yS.createElement("span", {
        "aria-hidden": "true",
        className: `${prefixCls}-indent`
    }, list);
};
var $091c81bddc291167$export$2e2bcd8739ae039 = /*#__PURE__*/ $N3oW3.memo($091c81bddc291167$var$Indent);


function $6d1342a6ea0fb914$export$2e2bcd8739ae039(keyEntities, key) {
    return keyEntities[key];
}






function $8c21c3908ec083b2$export$1690e12b840569b9(level, index) {
    return `${level}-${index}`;
}
function $8c21c3908ec083b2$export$1c189858aa1437d7(node) {
    return node && node.type && node.type.isTreeNode;
}
function $8c21c3908ec083b2$export$a47fb462a08de82f(key, pos) {
    if (key !== null && key !== undefined) return key;
    return pos;
}
function $8c21c3908ec083b2$export$6c519d302dced239(fieldNames) {
    const { title: title, _title: _title, key: key, children: children } = fieldNames || {};
    const mergedTitle = title || 'title';
    return {
        title: mergedTitle,
        _title: _title || [
            mergedTitle
        ],
        key: key || 'key',
        children: children || 'children'
    };
}
function $8c21c3908ec083b2$export$702780ec64d148df(treeData, fieldNames) {
    const keys = new Map();
    function dig(list, path = '') {
        (list || []).forEach((treeNode)=>{
            const key = treeNode[fieldNames.key];
            const children = treeNode[fieldNames.children];
            (0, $6591254ed6bd1058$export$2e2bcd8739ae039)(key !== null && key !== undefined, `Tree node must have a certain key: [${path}${key}]`);
            const recordKey = String(key);
            (0, $6591254ed6bd1058$export$2e2bcd8739ae039)(!keys.has(recordKey) || key === null || key === undefined, `Same 'key' exist in the Tree: ${recordKey}`);
            keys.set(recordKey, true);
            dig(children, `${path}${recordKey} > `);
        });
    }
    dig(treeData);
}
function $8c21c3908ec083b2$export$6d8b10995563b669(rootNodes) {
    function dig(node) {
        const treeNodes = (0, $a60ede783f74e6a9$export$2e2bcd8739ae039)(node);
        return treeNodes.map((treeNode)=>{
            // Filter invalidate node
            if (!$8c21c3908ec083b2$export$1c189858aa1437d7(treeNode)) {
                (0, $6591254ed6bd1058$export$2e2bcd8739ae039)(!treeNode, 'Tree/TreeNode can only accept TreeNode as children.');
                return null;
            }
            const { key: key } = treeNode;
            const { children: children, ...rest } = treeNode.props;
            const dataNode = {
                key: key,
                ...rest
            };
            const parsedChildren = dig(children);
            if (parsedChildren.length) dataNode.children = parsedChildren;
            return dataNode;
        }).filter((dataNode)=>dataNode);
    }
    return dig(rootNodes);
}
function $8c21c3908ec083b2$export$215c1b4f1ba88b23(treeNodeList, expandedKeys, fieldNames) {
    const { _title: fieldTitles, key: fieldKey, children: fieldChildren } = $8c21c3908ec083b2$export$6c519d302dced239(fieldNames);
    const expandedKeySet = new Set(expandedKeys === true ? [] : expandedKeys);
    const flattenList = [];
    function dig(list, parent = null) {
        return list.map((treeNode, index)=>{
            const pos = $8c21c3908ec083b2$export$1690e12b840569b9(parent ? parent.pos : '0', index);
            const mergedKey = $8c21c3908ec083b2$export$a47fb462a08de82f(treeNode[fieldKey], pos);
            // Pick matched title in field title list
            let mergedTitle;
            for(let i = 0; i < fieldTitles.length; i += 1){
                const fieldTitle = fieldTitles[i];
                if (treeNode[fieldTitle] !== undefined) {
                    mergedTitle = treeNode[fieldTitle];
                    break;
                }
            }
            // Add FlattenDataNode into list
            // We use `Object.assign` here to save perf since babel's `objectSpread` has perf issue
            const flattenNode = Object.assign((0, $f4cf9c2e27c0ac8d$export$2e2bcd8739ae039)(treeNode, [
                ...fieldTitles,
                fieldKey,
                fieldChildren
            ]), {
                title: mergedTitle,
                key: mergedKey,
                parent: parent,
                pos: pos,
                children: null,
                data: treeNode,
                isStart: [
                    ...parent ? parent.isStart : [],
                    index === 0
                ],
                isEnd: [
                    ...parent ? parent.isEnd : [],
                    index === list.length - 1
                ]
            });
            flattenList.push(flattenNode);
            // Loop treeNode children
            if (expandedKeys === true || expandedKeySet.has(mergedKey)) flattenNode.children = dig(treeNode[fieldChildren] || [], flattenNode);
            else flattenNode.children = [];
            return flattenNode;
        });
    }
    dig(treeNodeList);
    return flattenList;
}
function $8c21c3908ec083b2$export$4b2e27469b557f9d(dataNodes, callback, // To avoid too many params, let use config instead of origin param
config) {
    let mergedConfig = {};
    if (typeof config === 'object') mergedConfig = config;
    else mergedConfig = {
        externalGetKey: config
    };
    mergedConfig = mergedConfig || {};
    // Init config
    const { childrenPropName: childrenPropName, externalGetKey: externalGetKey, fieldNames: fieldNames } = mergedConfig;
    const { key: fieldKey, children: fieldChildren } = $8c21c3908ec083b2$export$6c519d302dced239(fieldNames);
    const mergeChildrenPropName = childrenPropName || fieldChildren;
    // Get keys
    let syntheticGetKey;
    if (externalGetKey) {
        if (typeof externalGetKey === 'string') syntheticGetKey = (node)=>node[externalGetKey];
        else if (typeof externalGetKey === 'function') syntheticGetKey = (node)=>externalGetKey(node);
    } else syntheticGetKey = (node, pos)=>$8c21c3908ec083b2$export$a47fb462a08de82f(node[fieldKey], pos);
    // Process
    function processNode(node, index, parent, pathNodes) {
        const children = node ? node[mergeChildrenPropName] : dataNodes;
        const pos = node ? $8c21c3908ec083b2$export$1690e12b840569b9(parent.pos, index) : '0';
        const connectNodes = node ? [
            ...pathNodes,
            node
        ] : [];
        // Process node if is not root
        if (node) {
            const key = syntheticGetKey(node, pos);
            const data = {
                node: node,
                index: index,
                pos: pos,
                key: key,
                parentPos: parent.node ? parent.pos : null,
                level: parent.level + 1,
                nodes: connectNodes
            };
            callback(data);
        }
        // Process children node
        if (children) children.forEach((subNode, subIndex)=>{
            processNode(subNode, subIndex, {
                node: node,
                pos: pos,
                level: parent ? parent.level + 1 : -1
            }, connectNodes);
        });
    }
    processNode(null);
}
function $8c21c3908ec083b2$export$e5d831ce033a4615(dataNodes, { initWrapper: initWrapper, processEntity: processEntity, onProcessFinished: onProcessFinished, externalGetKey: externalGetKey, childrenPropName: childrenPropName, fieldNames: fieldNames } = {}, /** @deprecated Use `config.externalGetKey` instead */ legacyExternalGetKey) {
    // Init config
    const mergedExternalGetKey = externalGetKey || legacyExternalGetKey;
    const posEntities = {};
    const keyEntities = {};
    let wrapper = {
        posEntities: posEntities,
        keyEntities: keyEntities
    };
    if (initWrapper) wrapper = initWrapper(wrapper) || wrapper;
    $8c21c3908ec083b2$export$4b2e27469b557f9d(dataNodes, (item)=>{
        const { node: node, index: index, pos: pos, key: key, parentPos: parentPos, level: level, nodes: nodes } = item;
        const entity = {
            node: node,
            nodes: nodes,
            index: index,
            key: key,
            pos: pos,
            level: level
        };
        const mergedKey = $8c21c3908ec083b2$export$a47fb462a08de82f(key, pos);
        posEntities[pos] = entity;
        keyEntities[mergedKey] = entity;
        // Fill children
        entity.parent = posEntities[parentPos];
        if (entity.parent) {
            entity.parent.children = entity.parent.children || [];
            entity.parent.children.push(entity);
        }
        if (processEntity) processEntity(entity, wrapper);
    }, {
        externalGetKey: mergedExternalGetKey,
        childrenPropName: childrenPropName,
        fieldNames: fieldNames
    });
    if (onProcessFinished) onProcessFinished(wrapper);
    return wrapper;
}
function $8c21c3908ec083b2$export$d961fd523a514db5(key, { expandedKeys: expandedKeys, selectedKeys: selectedKeys, loadedKeys: loadedKeys, loadingKeys: loadingKeys, checkedKeys: checkedKeys, halfCheckedKeys: halfCheckedKeys, dragOverNodeKey: dragOverNodeKey, dropPosition: dropPosition, keyEntities: keyEntities }) {
    const entity = (0, $6d1342a6ea0fb914$export$2e2bcd8739ae039)(keyEntities, key);
    const treeNodeProps = {
        eventKey: key,
        expanded: expandedKeys.indexOf(key) !== -1,
        selected: selectedKeys.indexOf(key) !== -1,
        loaded: loadedKeys.indexOf(key) !== -1,
        loading: loadingKeys.indexOf(key) !== -1,
        checked: checkedKeys.indexOf(key) !== -1,
        halfChecked: halfCheckedKeys.indexOf(key) !== -1,
        pos: String(entity ? entity.pos : ''),
        // [Legacy] Drag props
        // Since the interaction of drag is changed, the semantic of the props are
        // not accuracy, I think it should be finally removed
        dragOver: dragOverNodeKey === key && dropPosition === 0,
        dragOverGapTop: dragOverNodeKey === key && dropPosition === -1,
        dragOverGapBottom: dragOverNodeKey === key && dropPosition === 1
    };
    return treeNodeProps;
}
function $8c21c3908ec083b2$export$7bd1b0fd4a8b540b(props) {
    const { data: data, expanded: expanded, selected: selected, checked: checked, loaded: loaded, loading: loading, halfChecked: halfChecked, dragOver: dragOver, dragOverGapTop: dragOverGapTop, dragOverGapBottom: dragOverGapBottom, pos: pos, active: active, eventKey: eventKey } = props;
    const eventData = {
        ...data,
        expanded: expanded,
        selected: selected,
        checked: checked,
        loaded: loaded,
        loading: loading,
        halfChecked: halfChecked,
        dragOver: dragOver,
        dragOverGapTop: dragOverGapTop,
        dragOverGapBottom: dragOverGapBottom,
        pos: pos,
        active: active,
        key: eventKey
    };
    if (!('props' in eventData)) Object.defineProperty(eventData, 'props', {
        get () {
            (0, $6591254ed6bd1058$export$2e2bcd8739ae039)(false, 'Second param return from event is node data instead of TreeNode instance. Please read value directly instead of reading from `props`.');
            return props;
        }
    });
    return eventData;
}


function $98e6aa449e26d899$var$_extends() {
    $98e6aa449e26d899$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $98e6aa449e26d899$var$_extends.apply(this, arguments);
}
const $98e6aa449e26d899$var$ICON_OPEN = 'open';
const $98e6aa449e26d899$var$ICON_CLOSE = 'close';
const $98e6aa449e26d899$var$defaultTitle = '---';
const $98e6aa449e26d899$var$TreeNode = (props)=>{
    const { eventKey: eventKey, className: className, style: style, dragOver: dragOver, dragOverGapTop: dragOverGapTop, dragOverGapBottom: dragOverGapBottom, isLeaf: isLeaf, isStart: isStart, isEnd: isEnd, expanded: expanded, selected: selected, checked: checked, halfChecked: halfChecked, loading: loading, domRef: domRef, active: active, data: data, onMouseMove: onMouseMove, selectable: selectable, ...otherProps } = props;
    const context = (0, $N3oW3.default).useContext((0, $338114f31d3e4af5$export$dfae7d399eea2568));
    const { classNames: treeClassNames, styles: styles } = context || {};
    const unstableContext = (0, $N3oW3.default).useContext((0, $338114f31d3e4af5$export$e508d6f1a100e5dd));
    const selectHandleRef = (0, $N3oW3.default).useRef(null);
    const [dragNodeHighlight, setDragNodeHighlight] = (0, $N3oW3.default).useState(false);
    // ======= State: Disabled State =======
    const isDisabled = !!(context.disabled || props.disabled || unstableContext.nodeDisabled?.(data));
    const isCheckable = (0, $N3oW3.default).useMemo(()=>{
        // Return false if tree or treeNode is not checkable
        if (!context.checkable || props.checkable === false) return false;
        return context.checkable;
    }, [
        context.checkable,
        props.checkable
    ]);
    // ======= Event Handlers: Selection and Check =======
    const onSelect = (e)=>{
        if (isDisabled) return;
        context.onNodeSelect(e, (0, $8c21c3908ec083b2$export$7bd1b0fd4a8b540b)(props));
    };
    const onCheck = (e)=>{
        if (isDisabled) return;
        if (!isCheckable || props.disableCheckbox) return;
        context.onNodeCheck(e, (0, $8c21c3908ec083b2$export$7bd1b0fd4a8b540b)(props), !checked);
    };
    // ======= State: Selectable Check =======
    const isSelectable = (0, $N3oW3.default).useMemo(()=>{
        // Ignore when selectable is undefined or null
        if (typeof selectable === 'boolean') return selectable;
        return context.selectable;
    }, [
        selectable,
        context.selectable
    ]);
    const onSelectorClick = (e)=>{
        // Click trigger before select/check operation
        context.onNodeClick(e, (0, $8c21c3908ec083b2$export$7bd1b0fd4a8b540b)(props));
        if (isSelectable) onSelect(e);
        else onCheck(e);
    };
    const onSelectorDoubleClick = (e)=>{
        context.onNodeDoubleClick(e, (0, $8c21c3908ec083b2$export$7bd1b0fd4a8b540b)(props));
    };
    const onMouseEnter = (e)=>{
        context.onNodeMouseEnter(e, (0, $8c21c3908ec083b2$export$7bd1b0fd4a8b540b)(props));
    };
    const onMouseLeave = (e)=>{
        context.onNodeMouseLeave(e, (0, $8c21c3908ec083b2$export$7bd1b0fd4a8b540b)(props));
    };
    const onContextMenu = (e)=>{
        context.onNodeContextMenu(e, (0, $8c21c3908ec083b2$export$7bd1b0fd4a8b540b)(props));
    };
    // ======= Drag: Drag Enabled =======
    const isDraggable = (0, $N3oW3.default).useMemo(()=>{
        return !!(context.draggable && (!context.draggable.nodeDraggable || context.draggable.nodeDraggable(data)));
    }, [
        context.draggable,
        data
    ]);
    // ======= Drag: Drag Event Handlers =======
    const onDragStart = (e)=>{
        e.stopPropagation();
        setDragNodeHighlight(true);
        context.onNodeDragStart(e, props);
        try {
            // ie throw error
            // firefox-need-it
            e.dataTransfer.setData('text/plain', '');
        } catch  {
        // empty
        }
    };
    const onDragEnter = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        context.onNodeDragEnter(e, props);
    };
    const onDragOver = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        context.onNodeDragOver(e, props);
    };
    const onDragLeave = (e)=>{
        e.stopPropagation();
        context.onNodeDragLeave(e, props);
    };
    const onDragEnd = (e)=>{
        e.stopPropagation();
        setDragNodeHighlight(false);
        context.onNodeDragEnd(e, props);
    };
    const onDrop = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        setDragNodeHighlight(false);
        context.onNodeDrop(e, props);
    };
    // ======= Expand: Node Expansion =======
    const onExpand = (e)=>{
        if (loading) return;
        context.onNodeExpand(e, (0, $8c21c3908ec083b2$export$7bd1b0fd4a8b540b)(props));
    };
    // ======= State: Has Children =======
    const hasChildren = (0, $N3oW3.default).useMemo(()=>{
        const { children: children } = (0, $6d1342a6ea0fb914$export$2e2bcd8739ae039)(context.keyEntities, eventKey) || {};
        return Boolean((children || []).length);
    }, [
        context.keyEntities,
        eventKey
    ]);
    // ======= State: Leaf Check =======
    const memoizedIsLeaf = (0, $N3oW3.default).useMemo(()=>{
        if (isLeaf === false) return false;
        return isLeaf || !context.loadData && !hasChildren || context.loadData && props.loaded && !hasChildren;
    }, [
        isLeaf,
        context.loadData,
        hasChildren,
        props.loaded
    ]);
    // ============== Effect ==============
    (0, $N3oW3.default).useEffect(()=>{
        // Load data to avoid default expanded tree without data
        if (loading) return;
        // read from state to avoid loadData at same time
        if (typeof context.loadData === 'function' && expanded && !memoizedIsLeaf && !props.loaded) // We needn't reload data when has children in sync logic
        // It's only needed in node expanded
        context.onNodeLoad((0, $8c21c3908ec083b2$export$7bd1b0fd4a8b540b)(props));
    }, [
        loading,
        context.loadData,
        context.onNodeLoad,
        expanded,
        memoizedIsLeaf,
        props
    ]);
    // ==================== Render: Drag Handler ====================
    const dragHandlerNode = (0, $N3oW3.default).useMemo(()=>{
        if (!context.draggable?.icon) return null;
        return /*#__PURE__*/ (0, $N3oW3.default).createElement("span", {
            className: `${context.prefixCls}-draggable-icon`
        }, context.draggable.icon);
    }, [
        context.draggable
    ]);
    // ====================== Render: Switcher ======================
    const renderSwitcherIconDom = (isInternalLeaf)=>{
        const switcherIcon = props.switcherIcon || context.switcherIcon;
        // if switcherIconDom is null, no render switcher span
        if (typeof switcherIcon === 'function') return switcherIcon({
            ...props,
            isLeaf: isInternalLeaf
        });
        return switcherIcon;
    };
    // Switcher
    const renderSwitcher = ()=>{
        if (memoizedIsLeaf) {
            // if switcherIconDom is null, no render switcher span
            const switcherIconDom = renderSwitcherIconDom(true);
            return switcherIconDom !== false ? /*#__PURE__*/ (0, $N3oW3.default).createElement("span", {
                className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${context.prefixCls}-switcher`, `${context.prefixCls}-switcher-noop`)
            }, switcherIconDom) : null;
        }
        const switcherIconDom = renderSwitcherIconDom(false);
        return switcherIconDom !== false ? /*#__PURE__*/ (0, $N3oW3.default).createElement("span", {
            onClick: onExpand,
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${context.prefixCls}-switcher`, `${context.prefixCls}-switcher_${expanded ? $98e6aa449e26d899$var$ICON_OPEN : $98e6aa449e26d899$var$ICON_CLOSE}`)
        }, switcherIconDom) : null;
    };
    // ====================== Checkbox ======================
    const checkboxNode = (0, $N3oW3.default).useMemo(()=>{
        if (!isCheckable) return null;
        // [Legacy] Custom element should be separate with `checkable` in future
        const $custom = typeof isCheckable !== 'boolean' ? isCheckable : null;
        return /*#__PURE__*/ (0, $N3oW3.default).createElement("span", {
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${context.prefixCls}-checkbox`, {
                [`${context.prefixCls}-checkbox-checked`]: checked,
                [`${context.prefixCls}-checkbox-indeterminate`]: !checked && halfChecked,
                [`${context.prefixCls}-checkbox-disabled`]: isDisabled || props.disableCheckbox
            }),
            onClick: onCheck,
            role: "checkbox",
            "aria-checked": halfChecked ? 'mixed' : checked,
            "aria-disabled": isDisabled || props.disableCheckbox,
            "aria-label": `Select ${typeof props.title === 'string' ? props.title : 'tree node'}`
        }, $custom);
    }, [
        isCheckable,
        checked,
        halfChecked,
        isDisabled,
        props.disableCheckbox,
        props.title
    ]);
    // ============== State: Node State (Open/Close) ==============
    const nodeState = (0, $N3oW3.default).useMemo(()=>{
        if (memoizedIsLeaf) return null;
        return expanded ? $98e6aa449e26d899$var$ICON_OPEN : $98e6aa449e26d899$var$ICON_CLOSE;
    }, [
        memoizedIsLeaf,
        expanded
    ]);
    // ==================== Render: Title + Icon ====================
    const iconNode = (0, $N3oW3.default).useMemo(()=>{
        return /*#__PURE__*/ (0, $N3oW3.default).createElement("span", {
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(treeClassNames?.itemIcon, `${context.prefixCls}-iconEle`, `${context.prefixCls}-icon__${nodeState || 'docu'}`, {
                [`${context.prefixCls}-icon_loading`]: loading
            }),
            style: styles?.itemIcon
        });
    }, [
        context.prefixCls,
        nodeState,
        loading
    ]);
    // =================== Drop Indicator ===================
    const dropIndicatorNode = (0, $N3oW3.default).useMemo(()=>{
        const rootDraggable = Boolean(context.draggable);
        // allowDrop is calculated in Tree.tsx, there is no need for calc it here
        const showIndicator = !props.disabled && rootDraggable && context.dragOverNodeKey === eventKey;
        if (!showIndicator) return null;
        return context.dropIndicatorRender({
            dropPosition: context.dropPosition,
            dropLevelOffset: context.dropLevelOffset,
            indent: context.indent,
            prefixCls: context.prefixCls,
            direction: context.direction
        });
    }, [
        context.dropPosition,
        context.dropLevelOffset,
        context.indent,
        context.prefixCls,
        context.direction,
        context.draggable,
        context.dragOverNodeKey,
        context.dropIndicatorRender
    ]);
    // Icon + Title
    const selectorNode = (0, $N3oW3.default).useMemo(()=>{
        const { title: title = $98e6aa449e26d899$var$defaultTitle } = props;
        const wrapClass = `${context.prefixCls}-node-content-wrapper`;
        // Icon - Still show loading icon when loading without showIcon
        let $icon;
        if (context.showIcon) {
            const currentIcon = props.icon || context.icon;
            $icon = currentIcon ? /*#__PURE__*/ (0, $N3oW3.default).createElement("span", {
                className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(treeClassNames?.itemIcon, `${context.prefixCls}-iconEle`, `${context.prefixCls}-icon__customize`),
                style: styles?.itemIcon
            }, typeof currentIcon === 'function' ? currentIcon(props) : currentIcon) : iconNode;
        } else if (context.loadData && loading) $icon = iconNode;
        // Title
        let titleNode;
        if (typeof title === 'function') titleNode = title(data);
        else if (context.titleRender) titleNode = context.titleRender(data);
        else titleNode = title;
        return /*#__PURE__*/ (0, $N3oW3.default).createElement("span", {
            ref: selectHandleRef,
            title: typeof title === 'string' ? title : '',
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(wrapClass, `${wrapClass}-${nodeState || 'normal'}`, {
                [`${context.prefixCls}-node-selected`]: !isDisabled && (selected || dragNodeHighlight)
            }),
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onContextMenu: onContextMenu,
            onClick: onSelectorClick,
            onDoubleClick: onSelectorDoubleClick
        }, $icon, /*#__PURE__*/ (0, $N3oW3.default).createElement("span", {
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${context.prefixCls}-title`, treeClassNames?.itemTitle),
            style: styles?.itemTitle
        }, titleNode), dropIndicatorNode);
    }, [
        context.prefixCls,
        context.showIcon,
        props,
        context.icon,
        iconNode,
        context.titleRender,
        data,
        nodeState,
        onMouseEnter,
        onMouseLeave,
        onContextMenu,
        onSelectorClick,
        onSelectorDoubleClick
    ]);
    const dataOrAriaAttributeProps = (0, $b0f3dfd0eb3cad70$export$2e2bcd8739ae039)(otherProps, {
        aria: true,
        data: true
    });
    const { level: level } = (0, $6d1342a6ea0fb914$export$2e2bcd8739ae039)(context.keyEntities, eventKey) || {};
    const isEndNode = isEnd[isEnd.length - 1];
    const draggableWithoutDisabled = !isDisabled && isDraggable;
    const dragging = context.draggingNodeKey === eventKey;
    const ariaSelected = selectable !== undefined ? {
        'aria-selected': !!selectable
    } : undefined;
    return /*#__PURE__*/ (0, $N3oW3.default).createElement("div", $98e6aa449e26d899$var$_extends({
        ref: domRef,
        role: "treeitem",
        "aria-expanded": isLeaf ? undefined : expanded,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(className, `${context.prefixCls}-treenode`, treeClassNames?.item, {
            [`${context.prefixCls}-treenode-disabled`]: isDisabled,
            [`${context.prefixCls}-treenode-switcher-${expanded ? 'open' : 'close'}`]: !isLeaf,
            [`${context.prefixCls}-treenode-checkbox-checked`]: checked,
            [`${context.prefixCls}-treenode-checkbox-indeterminate`]: halfChecked,
            [`${context.prefixCls}-treenode-selected`]: selected,
            [`${context.prefixCls}-treenode-loading`]: loading,
            [`${context.prefixCls}-treenode-active`]: active,
            [`${context.prefixCls}-treenode-leaf-last`]: isEndNode,
            [`${context.prefixCls}-treenode-draggable`]: isDraggable,
            dragging: dragging,
            'drop-target': context.dropTargetKey === eventKey,
            'drop-container': context.dropContainerKey === eventKey,
            'drag-over': !isDisabled && dragOver,
            'drag-over-gap-top': !isDisabled && dragOverGapTop,
            'drag-over-gap-bottom': !isDisabled && dragOverGapBottom,
            'filter-node': context.filterTreeNode?.((0, $8c21c3908ec083b2$export$7bd1b0fd4a8b540b)(props)),
            [`${context.prefixCls}-treenode-leaf`]: memoizedIsLeaf
        }),
        style: {
            ...style,
            ...styles?.item
        },
        draggable: draggableWithoutDisabled,
        onDragStart: draggableWithoutDisabled ? onDragStart : undefined,
        onDragEnter: isDraggable ? onDragEnter : undefined,
        onDragOver: isDraggable ? onDragOver : undefined,
        onDragLeave: isDraggable ? onDragLeave : undefined,
        onDrop: isDraggable ? onDrop : undefined,
        onDragEnd: isDraggable ? onDragEnd : undefined,
        onMouseMove: onMouseMove
    }, ariaSelected, dataOrAriaAttributeProps), /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $091c81bddc291167$export$2e2bcd8739ae039), {
        prefixCls: context.prefixCls,
        level: level,
        isStart: isStart,
        isEnd: isEnd
    }), dragHandlerNode, renderSwitcher(), checkboxNode, selectorNode);
};
$98e6aa449e26d899$var$TreeNode.isTreeNode = 1;
var $98e6aa449e26d899$export$2e2bcd8739ae039 = $98e6aa449e26d899$var$TreeNode;




function $e60066375029f166$var$_extends() {
    $e60066375029f166$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e60066375029f166$var$_extends.apply(this, arguments);
}
function $e60066375029f166$export$5bfb9ff497fe2298(list, value) {
    if (!list) return [];
    const clone = list.slice();
    const index = clone.indexOf(value);
    if (index >= 0) clone.splice(index, 1);
    return clone;
}
function $e60066375029f166$export$10663f6bbd2fd717(list, value) {
    const clone = (list || []).slice();
    if (clone.indexOf(value) === -1) clone.push(value);
    return clone;
}
function $e60066375029f166$export$ddaee97dc8907312(pos) {
    return pos.split('-');
}
function $e60066375029f166$export$b0610c44bcbb051c(dragNodeKey, keyEntities) {
    // not contains self
    // self for left or right drag
    const dragChildrenKeys = [];
    const entity = (0, $6d1342a6ea0fb914$export$2e2bcd8739ae039)(keyEntities, dragNodeKey);
    function dig(list = []) {
        list.forEach(({ key: key, children: children })=>{
            dragChildrenKeys.push(key);
            dig(children);
        });
    }
    dig(entity.children);
    return dragChildrenKeys;
}
function $e60066375029f166$export$a9933931a4af6704(treeNodeEntity) {
    if (treeNodeEntity.parent) {
        const posArr = $e60066375029f166$export$ddaee97dc8907312(treeNodeEntity.pos);
        return Number(posArr[posArr.length - 1]) === treeNodeEntity.parent.children.length - 1;
    }
    return false;
}
function $e60066375029f166$export$b823688e4155eb8d(treeNodeEntity) {
    const posArr = $e60066375029f166$export$ddaee97dc8907312(treeNodeEntity.pos);
    return Number(posArr[posArr.length - 1]) === 0;
}
function $e60066375029f166$export$78a5519d0fb779c3(event, dragNodeProps, targetNodeProps, indent, startMousePosition, allowDrop, flattenedNodes, keyEntities, expandKeys, direction) {
    const { clientX: clientX, clientY: clientY } = event;
    const { top: top, height: height } = event.target.getBoundingClientRect();
    // optional chain for testing
    const horizontalMouseOffset = (direction === 'rtl' ? -1 : 1) * ((startMousePosition?.x || 0) - clientX);
    const rawDropLevelOffset = (horizontalMouseOffset - 12) / indent;
    // Filter the expanded keys to exclude the node that not has children currently (like async nodes).
    const filteredExpandKeys = expandKeys.filter((key)=>keyEntities[key]?.children?.length);
    // find abstract drop node by horizontal offset
    let abstractDropNodeEntity = (0, $6d1342a6ea0fb914$export$2e2bcd8739ae039)(keyEntities, targetNodeProps.eventKey);
    if (clientY < top + height / 2) {
        // first half, set abstract drop node to previous node
        const nodeIndex = flattenedNodes.findIndex((flattenedNode)=>flattenedNode.key === abstractDropNodeEntity.key);
        const prevNodeIndex = nodeIndex <= 0 ? 0 : nodeIndex - 1;
        const prevNodeKey = flattenedNodes[prevNodeIndex].key;
        abstractDropNodeEntity = (0, $6d1342a6ea0fb914$export$2e2bcd8739ae039)(keyEntities, prevNodeKey);
    }
    const initialAbstractDropNodeKey = abstractDropNodeEntity.key;
    const abstractDragOverEntity = abstractDropNodeEntity;
    const dragOverNodeKey = abstractDropNodeEntity.key;
    let dropPosition = 0;
    let dropLevelOffset = 0;
    // Only allow cross level drop when dragging on a non-expanded node
    if (!filteredExpandKeys.includes(initialAbstractDropNodeKey)) for(let i = 0; i < rawDropLevelOffset; i += 1){
        if ($e60066375029f166$export$a9933931a4af6704(abstractDropNodeEntity)) {
            abstractDropNodeEntity = abstractDropNodeEntity.parent;
            dropLevelOffset += 1;
        } else break;
    }
    const abstractDragDataNode = dragNodeProps.data;
    const abstractDropDataNode = abstractDropNodeEntity.node;
    let dropAllowed = true;
    if ($e60066375029f166$export$b823688e4155eb8d(abstractDropNodeEntity) && abstractDropNodeEntity.level === 0 && clientY < top + height / 2 && allowDrop({
        dragNode: abstractDragDataNode,
        dropNode: abstractDropDataNode,
        dropPosition: -1
    }) && abstractDropNodeEntity.key === targetNodeProps.eventKey) // first half of first node in first level
    dropPosition = -1;
    else if ((abstractDragOverEntity.children || []).length && filteredExpandKeys.includes(dragOverNodeKey)) {
        // drop on expanded node
        // only allow drop inside
        if (allowDrop({
            dragNode: abstractDragDataNode,
            dropNode: abstractDropDataNode,
            dropPosition: 0
        })) dropPosition = 0;
        else dropAllowed = false;
    } else if (dropLevelOffset === 0) {
        if (rawDropLevelOffset > -1.5) {
            // | Node     | <- abstractDropNode
            // | -^-===== | <- mousePosition
            // 1. try drop after
            // 2. do not allow drop
            if (allowDrop({
                dragNode: abstractDragDataNode,
                dropNode: abstractDropDataNode,
                dropPosition: 1
            })) dropPosition = 1;
            else dropAllowed = false;
        } else {
            // | Node     | <- abstractDropNode
            // | ---==^== | <- mousePosition
            // whether it has children or doesn't has children
            // always
            // 1. try drop inside
            // 2. try drop after
            // 3. do not allow drop
            if (allowDrop({
                dragNode: abstractDragDataNode,
                dropNode: abstractDropDataNode,
                dropPosition: 0
            })) dropPosition = 0;
            else if (allowDrop({
                dragNode: abstractDragDataNode,
                dropNode: abstractDropDataNode,
                dropPosition: 1
            })) dropPosition = 1;
            else dropAllowed = false;
        }
    } else // | Node1 | <- abstractDropNode
    //      |  Node2  |
    // --^--|----=====| <- mousePosition
    // 1. try insert after Node1
    // 2. do not allow drop
    if (allowDrop({
        dragNode: abstractDragDataNode,
        dropNode: abstractDropDataNode,
        dropPosition: 1
    })) dropPosition = 1;
    else dropAllowed = false;
    return {
        dropPosition: dropPosition,
        dropLevelOffset: dropLevelOffset,
        dropTargetKey: abstractDropNodeEntity.key,
        dropTargetPos: abstractDropNodeEntity.pos,
        dragOverNodeKey: dragOverNodeKey,
        dropContainerKey: dropPosition === 0 ? null : abstractDropNodeEntity.parent?.key || null,
        dropAllowed: dropAllowed
    };
}
function $e60066375029f166$export$fffc10811828fd68(selectedKeys, props) {
    if (!selectedKeys) return undefined;
    const { multiple: multiple } = props;
    if (multiple) return selectedKeys.slice();
    if (selectedKeys.length) return [
        selectedKeys[0]
    ];
    return selectedKeys;
}
const $e60066375029f166$var$internalProcessProps = (props)=>props;
function $e60066375029f166$export$b28621e8354d6749(treeData, processor) {
    if (!treeData) return [];
    const { processProps: processProps = $e60066375029f166$var$internalProcessProps } = processor || {};
    const list = Array.isArray(treeData) ? treeData : [
        treeData
    ];
    return list.map(({ children: children, ...props })=>{
        const childrenNodes = $e60066375029f166$export$b28621e8354d6749(children, processor);
        return /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $98e6aa449e26d899$export$2e2bcd8739ae039), $e60066375029f166$var$_extends({
            key: props.key
        }, processProps(props)), childrenNodes);
    });
}
function $e60066375029f166$export$29d4989c23990d41(keys) {
    if (!keys) return null;
    // Convert keys to object format
    let keyProps;
    if (Array.isArray(keys)) // [Legacy] Follow the api doc
    keyProps = {
        checkedKeys: keys,
        halfCheckedKeys: undefined
    };
    else if (typeof keys === 'object') keyProps = {
        checkedKeys: keys.checked || undefined,
        halfCheckedKeys: keys.halfChecked || undefined
    };
    else {
        (0, $6591254ed6bd1058$export$2e2bcd8739ae039)(false, '`checkedKeys` is not an array or an object');
        return null;
    }
    return keyProps;
}
function $e60066375029f166$export$fac4a40c345ccd80(keyList, keyEntities) {
    const expandedKeys = new Set();
    function conductUp(key) {
        if (expandedKeys.has(key)) return;
        const entity = (0, $6d1342a6ea0fb914$export$2e2bcd8739ae039)(keyEntities, key);
        if (!entity) return;
        expandedKeys.add(key);
        const { parent: parent, node: node } = entity;
        if (node.disabled) return;
        if (parent) conductUp(parent.key);
    }
    (keyList || []).forEach((key)=>{
        conductUp(key);
    });
    return [
        ...expandedKeys
    ];
}




function $0920639cbc3d717f$var$removeFromCheckedKeys(halfCheckedKeys, checkedKeys) {
    const filteredKeys = new Set();
    halfCheckedKeys.forEach((key)=>{
        if (!checkedKeys.has(key)) filteredKeys.add(key);
    });
    return filteredKeys;
}
function $0920639cbc3d717f$export$ab01c86170b1dea0(node) {
    const { disabled: disabled, disableCheckbox: disableCheckbox, checkable: checkable } = node || {};
    return !!(disabled || disableCheckbox) || checkable === false;
}
// Fill miss keys
function $0920639cbc3d717f$var$fillConductCheck(keys, levelEntities, maxLevel, syntheticGetCheckDisabled) {
    const checkedKeys = new Set(keys);
    const halfCheckedKeys = new Set();
    // Add checked keys top to bottom
    for(let level = 0; level <= maxLevel; level += 1){
        const entities = levelEntities.get(level) || new Set();
        entities.forEach((entity)=>{
            const { key: key, node: node, children: children = [] } = entity;
            if (checkedKeys.has(key) && !syntheticGetCheckDisabled(node)) children.filter((childEntity)=>!syntheticGetCheckDisabled(childEntity.node)).forEach((childEntity)=>{
                checkedKeys.add(childEntity.key);
            });
        });
    }
    // Add checked keys from bottom to top
    const visitedKeys = new Set();
    for(let level = maxLevel; level >= 0; level -= 1){
        const entities = levelEntities.get(level) || new Set();
        entities.forEach((entity)=>{
            const { parent: parent, node: node } = entity;
            // Skip if no need to check
            if (syntheticGetCheckDisabled(node) || !entity.parent || visitedKeys.has(entity.parent.key)) return;
            // Skip if parent is disabled
            if (syntheticGetCheckDisabled(entity.parent.node)) {
                visitedKeys.add(parent.key);
                return;
            }
            let allChecked = true;
            let partialChecked = false;
            (parent.children || []).filter((childEntity)=>!syntheticGetCheckDisabled(childEntity.node)).forEach(({ key: key })=>{
                const checked = checkedKeys.has(key);
                if (allChecked && !checked) allChecked = false;
                if (!partialChecked && (checked || halfCheckedKeys.has(key))) partialChecked = true;
            });
            if (allChecked) checkedKeys.add(parent.key);
            if (partialChecked) halfCheckedKeys.add(parent.key);
            visitedKeys.add(parent.key);
        });
    }
    return {
        checkedKeys: Array.from(checkedKeys),
        halfCheckedKeys: Array.from($0920639cbc3d717f$var$removeFromCheckedKeys(halfCheckedKeys, checkedKeys))
    };
}
// Remove useless key
function $0920639cbc3d717f$var$cleanConductCheck(keys, halfKeys, levelEntities, maxLevel, syntheticGetCheckDisabled) {
    const checkedKeys = new Set(keys);
    let halfCheckedKeys = new Set(halfKeys);
    // Remove checked keys from top to bottom
    for(let level = 0; level <= maxLevel; level += 1){
        const entities = levelEntities.get(level) || new Set();
        entities.forEach((entity)=>{
            const { key: key, node: node, children: children = [] } = entity;
            if (!checkedKeys.has(key) && !halfCheckedKeys.has(key) && !syntheticGetCheckDisabled(node)) children.filter((childEntity)=>!syntheticGetCheckDisabled(childEntity.node)).forEach((childEntity)=>{
                checkedKeys.delete(childEntity.key);
            });
        });
    }
    // Remove checked keys form bottom to top
    halfCheckedKeys = new Set();
    const visitedKeys = new Set();
    for(let level = maxLevel; level >= 0; level -= 1){
        const entities = levelEntities.get(level) || new Set();
        entities.forEach((entity)=>{
            const { parent: parent, node: node } = entity;
            // Skip if no need to check
            if (syntheticGetCheckDisabled(node) || !entity.parent || visitedKeys.has(entity.parent.key)) return;
            // Skip if parent is disabled
            if (syntheticGetCheckDisabled(entity.parent.node)) {
                visitedKeys.add(parent.key);
                return;
            }
            let allChecked = true;
            let partialChecked = false;
            (parent.children || []).filter((childEntity)=>!syntheticGetCheckDisabled(childEntity.node)).forEach(({ key: key })=>{
                const checked = checkedKeys.has(key);
                if (allChecked && !checked) allChecked = false;
                if (!partialChecked && (checked || halfCheckedKeys.has(key))) partialChecked = true;
            });
            if (!allChecked) checkedKeys.delete(parent.key);
            if (partialChecked) halfCheckedKeys.add(parent.key);
            visitedKeys.add(parent.key);
        });
    }
    return {
        checkedKeys: Array.from(checkedKeys),
        halfCheckedKeys: Array.from($0920639cbc3d717f$var$removeFromCheckedKeys(halfCheckedKeys, checkedKeys))
    };
}
function $0920639cbc3d717f$export$43adf2c483e3e633(keyList, checked, keyEntities, getCheckDisabled) {
    const warningMissKeys = [];
    let syntheticGetCheckDisabled;
    if (getCheckDisabled) syntheticGetCheckDisabled = getCheckDisabled;
    else syntheticGetCheckDisabled = $0920639cbc3d717f$export$ab01c86170b1dea0;
    // We only handle exist keys
    const keys = new Set(keyList.filter((key)=>{
        const hasEntity = !!(0, $6d1342a6ea0fb914$export$2e2bcd8739ae039)(keyEntities, key);
        if (!hasEntity) warningMissKeys.push(key);
        return hasEntity;
    }));
    const levelEntities = new Map();
    let maxLevel = 0;
    // Convert entities by level for calculation
    Object.keys(keyEntities).forEach((key)=>{
        const entity = keyEntities[key];
        const { level: level } = entity;
        let levelSet = levelEntities.get(level);
        if (!levelSet) {
            levelSet = new Set();
            levelEntities.set(level, levelSet);
        }
        levelSet.add(entity);
        maxLevel = Math.max(maxLevel, level);
    });
    (0, $6591254ed6bd1058$export$2e2bcd8739ae039)(!warningMissKeys.length, `Tree missing follow keys: ${warningMissKeys.slice(0, 100).map((key)=>`'${key}'`).join(', ')}`);
    let result;
    if (checked === true) result = $0920639cbc3d717f$var$fillConductCheck(keys, levelEntities, maxLevel, syntheticGetCheckDisabled);
    else result = $0920639cbc3d717f$var$cleanConductCheck(keys, checked.halfCheckedKeys, levelEntities, maxLevel, syntheticGetCheckDisabled);
    return result;
}





parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
const $8008927312c4cb7d$export$3f339a531a4f3fb4 = (getKey)=>{
    const [prevSelectedIndex, setPrevSelectedIndex] = (0, $32rMB.useState)(null);
    const multipleSelect = (0, $32rMB.useCallback)((currentSelectedIndex, data, selectedKeys)=>{
        const configPrevSelectedIndex = prevSelectedIndex ?? currentSelectedIndex;
        // add/delete the selected range
        const startIndex = Math.min(configPrevSelectedIndex || 0, currentSelectedIndex);
        const endIndex = Math.max(configPrevSelectedIndex || 0, currentSelectedIndex);
        const rangeKeys = data.slice(startIndex, endIndex + 1).map(getKey);
        const shouldSelected = rangeKeys.some((rangeKey)=>!selectedKeys.has(rangeKey));
        const changedKeys = [];
        rangeKeys.forEach((item)=>{
            if (shouldSelected) {
                if (!selectedKeys.has(item)) changedKeys.push(item);
                selectedKeys.add(item);
            } else {
                selectedKeys.delete(item);
                changedKeys.push(item);
            }
        });
        setPrevSelectedIndex(shouldSelected ? endIndex : null);
        return changedKeys;
    }, [
        prevSelectedIndex
    ]);
    return [
        multipleSelect,
        setPrevSelectedIndex
    ];
};



parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
function $59ba8b296720a8bb$var$_extends() {
    $59ba8b296720a8bb$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $59ba8b296720a8bb$var$_extends.apply(this, arguments);
}
const $59ba8b296720a8bb$export$48513f6b9f8ce62d = /*#__PURE__*/ (0, $N3oW3.forwardRef)((props, ref)=>{
    const { prefixCls: prefixCls = 'rc-checkbox', className: className, style: style, checked: checked, disabled: disabled, defaultChecked: defaultChecked = false, type: type = 'checkbox', title: title, onChange: onChange, ...inputProps } = props;
    const inputRef = (0, $32rMB.useRef)(null);
    const holderRef = (0, $32rMB.useRef)(null);
    const [rawValue, setRawValue] = (0, $05ea6e97cee440ee$export$2e2bcd8739ae039)(defaultChecked, checked);
    (0, $32rMB.useImperativeHandle)(ref, ()=>({
            focus: (options)=>{
                inputRef.current?.focus(options);
            },
            blur: ()=>{
                inputRef.current?.blur();
            },
            input: inputRef.current,
            nativeElement: holderRef.current
        }));
    const classString = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, className, {
        [`${prefixCls}-checked`]: rawValue,
        [`${prefixCls}-disabled`]: disabled
    });
    const handleChange = (e)=>{
        if (disabled) return;
        if (!('checked' in props)) setRawValue(e.target.checked);
        onChange?.({
            target: {
                ...props,
                type: type,
                checked: e.target.checked
            },
            stopPropagation () {
                e.stopPropagation();
            },
            preventDefault () {
                e.preventDefault();
            },
            nativeEvent: e.nativeEvent
        });
    };
    return /*#__PURE__*/ $hO8yS.createElement("span", {
        className: classString,
        title: title,
        style: style,
        ref: holderRef
    }, /*#__PURE__*/ $hO8yS.createElement("input", $59ba8b296720a8bb$var$_extends({}, inputProps, {
        className: `${prefixCls}-input`,
        ref: inputRef,
        onChange: handleChange,
        disabled: disabled,
        checked: !!rawValue,
        type: type
    })), /*#__PURE__*/ $hO8yS.createElement("span", {
        className: `${prefixCls}-inner`
    }));
});
var $59ba8b296720a8bb$export$2e2bcd8739ae039 = $59ba8b296720a8bb$export$48513f6b9f8ce62d;














var $N3oW3 = parcelRequire("N3oW3");
const $963df0c482c60292$var$GroupContext = /*#__PURE__*/ (0, $N3oW3.default).createContext(null);
var $963df0c482c60292$export$2e2bcd8739ae039 = $963df0c482c60292$var$GroupContext;





const $2f2edafb2c86c023$export$92a97fe1d1148438 = (token)=>{
    const { checkboxCls: checkboxCls } = token;
    const wrapperCls = `${checkboxCls}-wrapper`;
    return [
        // ===================== Basic =====================
        {
            // Group
            [`${checkboxCls}-group`]: {
                ...(0, $2f353af2b0f7600b$export$23997c3e44cc1c59)(token),
                display: 'inline-flex',
                flexWrap: 'wrap',
                columnGap: token.marginXS,
                // Group > Grid
                [`> ${token.antCls}-row`]: {
                    flex: 1
                }
            },
            // Wrapper
            [wrapperCls]: {
                ...(0, $2f353af2b0f7600b$export$23997c3e44cc1c59)(token),
                display: 'inline-flex',
                alignItems: 'baseline',
                cursor: 'pointer',
                // Fix checkbox & radio in flex align #30260
                '&:after': {
                    display: 'inline-block',
                    width: 0,
                    overflow: 'hidden',
                    content: "'\\a0'"
                },
                // Checkbox near checkbox
                [`& + ${wrapperCls}`]: {
                    marginInlineStart: 0
                },
                [`&${wrapperCls}-in-form-item`]: {
                    'input[type="checkbox"]': {
                        width: 14,
                        // FIXME: magic
                        height: 14 // FIXME: magic
                    }
                }
            },
            // Wrapper > Checkbox
            [checkboxCls]: {
                ...(0, $2f353af2b0f7600b$export$23997c3e44cc1c59)(token),
                position: 'relative',
                whiteSpace: 'nowrap',
                lineHeight: 1,
                cursor: 'pointer',
                borderRadius: token.borderRadiusSM,
                // To make alignment right when `controlHeight` is changed
                // Ref: https://github.com/ant-design/ant-design/issues/41564
                alignSelf: 'center',
                // Wrapper > Checkbox > input
                [`${checkboxCls}-input`]: {
                    position: 'absolute',
                    // Since baseline align will get additional space offset,
                    // we need to move input to top to make it align with text.
                    // Ref: https://github.com/ant-design/ant-design/issues/38926#issuecomment-1486137799
                    inset: 0,
                    zIndex: 1,
                    cursor: 'pointer',
                    opacity: 0,
                    margin: 0,
                    [`&:focus-visible + ${checkboxCls}-inner`]: (0, $2f353af2b0f7600b$export$6539948f0a737e39)(token)
                },
                // Wrapper > Checkbox > inner
                [`${checkboxCls}-inner`]: {
                    boxSizing: 'border-box',
                    display: 'block',
                    width: token.checkboxSize,
                    height: token.checkboxSize,
                    direction: 'ltr',
                    backgroundColor: token.colorBgContainer,
                    border: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                    borderRadius: token.borderRadiusSM,
                    borderCollapse: 'separate',
                    transition: `all ${token.motionDurationSlow}`,
                    '&:after': {
                        boxSizing: 'border-box',
                        position: 'absolute',
                        top: '50%',
                        insetInlineStart: '25%',
                        display: 'table',
                        width: token.calc(token.checkboxSize).div(14).mul(5).equal(),
                        height: token.calc(token.checkboxSize).div(14).mul(8).equal(),
                        border: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.lineWidthBold)} solid ${token.colorWhite}`,
                        borderTop: 0,
                        borderInlineStart: 0,
                        transform: 'rotate(45deg) scale(0) translate(-50%,-50%)',
                        opacity: 0,
                        content: '""',
                        transition: `all ${token.motionDurationFast} ${token.motionEaseInBack}, opacity ${token.motionDurationFast}`
                    }
                },
                // Wrapper > Checkbox + Text
                '& + span': {
                    paddingInlineStart: token.paddingXS,
                    paddingInlineEnd: token.paddingXS
                }
            }
        },
        // ===================== Hover =====================
        {
            // Wrapper & Wrapper > Checkbox
            [`
        ${wrapperCls}:not(${wrapperCls}-disabled),
        ${checkboxCls}:not(${checkboxCls}-disabled)
      `]: {
                [`&:hover ${checkboxCls}-inner`]: {
                    borderColor: token.colorPrimary
                }
            },
            [`${wrapperCls}:not(${wrapperCls}-disabled)`]: {
                [`&:hover ${checkboxCls}-checked:not(${checkboxCls}-disabled) ${checkboxCls}-inner`]: {
                    backgroundColor: token.colorPrimaryHover,
                    borderColor: 'transparent'
                },
                [`&:hover ${checkboxCls}-checked:not(${checkboxCls}-disabled):after`]: {
                    borderColor: token.colorPrimaryHover
                }
            }
        },
        // ==================== Checked ====================
        {
            // Wrapper > Checkbox
            [`${checkboxCls}-checked`]: {
                [`${checkboxCls}-inner`]: {
                    backgroundColor: token.colorPrimary,
                    borderColor: token.colorPrimary,
                    '&:after': {
                        opacity: 1,
                        transform: 'rotate(45deg) scale(1) translate(-50%,-50%)',
                        transition: `all ${token.motionDurationMid} ${token.motionEaseOutBack} ${token.motionDurationFast}`
                    }
                }
            },
            [`
        ${wrapperCls}-checked:not(${wrapperCls}-disabled),
        ${checkboxCls}-checked:not(${checkboxCls}-disabled)
      `]: {
                [`&:hover ${checkboxCls}-inner`]: {
                    backgroundColor: token.colorPrimaryHover,
                    borderColor: 'transparent'
                }
            }
        },
        // ================= Indeterminate =================
        {
            [checkboxCls]: {
                '&-indeterminate': {
                    '&': {
                        // Wrapper > Checkbox > inner
                        [`${checkboxCls}-inner`]: {
                            backgroundColor: `${token.colorBgContainer}`,
                            borderColor: `${token.colorBorder}`,
                            '&:after': {
                                top: '50%',
                                insetInlineStart: '50%',
                                width: token.calc(token.fontSizeLG).div(2).equal(),
                                height: token.calc(token.fontSizeLG).div(2).equal(),
                                backgroundColor: token.colorPrimary,
                                border: 0,
                                transform: 'translate(-50%, -50%) scale(1)',
                                opacity: 1,
                                content: '""'
                            }
                        },
                        // https://github.com/ant-design/ant-design/issues/50074
                        [`&:hover ${checkboxCls}-inner`]: {
                            backgroundColor: `${token.colorBgContainer}`,
                            borderColor: `${token.colorPrimary}`
                        }
                    }
                }
            }
        },
        // ==================== Disable ====================
        {
            // Wrapper
            [`${wrapperCls}-disabled`]: {
                cursor: 'not-allowed'
            },
            // Wrapper > Checkbox
            [`${checkboxCls}-disabled`]: {
                // Wrapper > Checkbox > input
                [`&, ${checkboxCls}-input`]: {
                    cursor: 'not-allowed',
                    // Disabled for native input to enable Tooltip event handler
                    // ref: https://github.com/ant-design/ant-design/issues/39822#issuecomment-1365075901
                    pointerEvents: 'none'
                },
                // Wrapper > Checkbox > inner
                [`${checkboxCls}-inner`]: {
                    background: token.colorBgContainerDisabled,
                    borderColor: token.colorBorder,
                    '&:after': {
                        borderColor: token.colorTextDisabled
                    }
                },
                '&:after': {
                    display: 'none'
                },
                '& + span': {
                    color: token.colorTextDisabled
                },
                [`&${checkboxCls}-indeterminate ${checkboxCls}-inner::after`]: {
                    background: token.colorTextDisabled
                }
            }
        }
    ];
};
function $2f2edafb2c86c023$export$3d2f074408bd1b82(prefixCls, token) {
    const checkboxToken = (0, $90c11ca6cb263fd9$export$4950aa0f605343fb)(token, {
        checkboxCls: `.${prefixCls}`,
        checkboxSize: token.controlInteractiveSize
    });
    return $2f2edafb2c86c023$export$92a97fe1d1148438(checkboxToken);
}
var $2f2edafb2c86c023$export$2e2bcd8739ae039 = (0, $d4a2dc313c4d90a4$export$51ec95de45185b42)('Checkbox', (token, { prefixCls: prefixCls })=>[
        $2f2edafb2c86c023$export$3d2f074408bd1b82(prefixCls, token)
    ]);



var $N3oW3 = parcelRequire("N3oW3");

function $0e024dd19a1d677c$export$2e2bcd8739ae039(onOriginInputClick) {
    const labelClickLockRef = (0, $N3oW3.default).useRef(null);
    const clearLock = ()=>{
        (0, $c9c36e20d667d30c$export$2e2bcd8739ae039).cancel(labelClickLockRef.current);
        labelClickLockRef.current = null;
    };
    const onLabelClick = ()=>{
        clearLock();
        labelClickLockRef.current = (0, $c9c36e20d667d30c$export$2e2bcd8739ae039)(()=>{
            labelClickLockRef.current = null;
        });
    };
    const onInputClick = (e)=>{
        if (labelClickLockRef.current) {
            e.stopPropagation();
            clearLock();
        }
        onOriginInputClick?.(e);
    };
    return [
        onLabelClick,
        onInputClick
    ];
}


"use client";
const $18405b9166de5b0f$var$InternalCheckbox = (props, ref)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, children: children, indeterminate: indeterminate = false, style: style, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, skipGroup: skipGroup = false, disabled: disabled, classNames: classNames, styles: styles, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $dd01e2f5a4b8605d$export$46f4bd6436a25a31)('checkbox');
    const checkboxGroup = $32rMB.useContext((0, $963df0c482c60292$export$2e2bcd8739ae039));
    const { isFormItemInput: isFormItemInput } = $32rMB.useContext((0, $a1a112e4dddc1035$export$bbb5553c6c7a14ed));
    const contextDisabled = $32rMB.useContext((0, $ff4b4ddbf52ed41f$export$2e2bcd8739ae039));
    const mergedDisabled = (checkboxGroup?.disabled || disabled) ?? contextDisabled;
    // =========== Merged Props for Semantic ==========
    const mergedProps = {
        ...props,
        indeterminate: indeterminate,
        disabled: mergedDisabled
    };
    const [mergedClassNames, mergedStyles] = (0, $4dcf69d8c3d6df5c$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    const prevValue = $32rMB.useRef(restProps.value);
    const checkboxRef = $32rMB.useRef(null);
    const mergedRef = (0, $2706ed817e87019d$export$ab452c34e8e05029)(ref, checkboxRef);
    $32rMB.useEffect(()=>{
        checkboxGroup?.registerValue(restProps.value);
    }, []);
    $32rMB.useEffect(()=>{
        if (skipGroup) return;
        if (restProps.value !== prevValue.current) {
            checkboxGroup?.cancelValue(prevValue.current);
            checkboxGroup?.registerValue(restProps.value);
            prevValue.current = restProps.value;
        }
        return ()=>checkboxGroup?.cancelValue(restProps.value);
    }, [
        restProps.value
    ]);
    $32rMB.useEffect(()=>{
        if (checkboxRef.current?.input) checkboxRef.current.input.indeterminate = indeterminate;
    }, [
        indeterminate
    ]);
    const prefixCls = getPrefixCls('checkbox', customizePrefixCls);
    const rootCls = (0, $54b1aecddbbbed4f$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $2f2edafb2c86c023$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const checkboxProps = {
        ...restProps
    };
    if (checkboxGroup && !skipGroup) {
        checkboxProps.onChange = (...args)=>{
            if (restProps.onChange) restProps.onChange.apply(restProps, args);
            if (checkboxGroup.toggleOption) checkboxGroup.toggleOption({
                label: children,
                value: restProps.value
            });
        };
        checkboxProps.name = checkboxGroup.name;
        checkboxProps.checked = checkboxGroup.value.includes(restProps.value);
    }
    const classString = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-wrapper`, {
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-wrapper-checked`]: checkboxProps.checked,
        [`${prefixCls}-wrapper-disabled`]: mergedDisabled,
        [`${prefixCls}-wrapper-in-form-item`]: isFormItemInput
    }, contextClassName, className, mergedClassNames.root, rootClassName, cssVarCls, rootCls, hashId);
    const checkboxClass = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(mergedClassNames.icon, {
        [`${prefixCls}-indeterminate`]: indeterminate
    }, (0, $989003bd02f62eb9$export$23466a5792b7a5d3), hashId);
    // ============================ Event Lock ============================
    const [onLabelClick, onInputClick] = (0, $0e024dd19a1d677c$export$2e2bcd8739ae039)(checkboxProps.onClick);
    // ============================== Render ==============================
    return /*#__PURE__*/ $hO8yS.createElement((0, $b6fefae43eb584fa$export$2e2bcd8739ae039), {
        component: "Checkbox",
        disabled: mergedDisabled
    }, /*#__PURE__*/ $hO8yS.createElement("label", {
        className: classString,
        style: {
            ...mergedStyles.root,
            ...contextStyle,
            ...style
        },
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onClick: onLabelClick
    }, /*#__PURE__*/ $hO8yS.createElement((0, $59ba8b296720a8bb$export$2e2bcd8739ae039), {
        ...checkboxProps,
        onClick: onInputClick,
        prefixCls: prefixCls,
        className: checkboxClass,
        style: mergedStyles.icon,
        disabled: mergedDisabled,
        ref: mergedRef
    }), (0, $95ac4c3d4339216e$export$2e2bcd8739ae039)(children) && /*#__PURE__*/ $hO8yS.createElement("span", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-label`, mergedClassNames.label),
        style: mergedStyles.label
    }, children)));
};
const $18405b9166de5b0f$var$Checkbox = /*#__PURE__*/ $N3oW3.forwardRef($18405b9166de5b0f$var$InternalCheckbox);
var $18405b9166de5b0f$export$2e2bcd8739ae039 = $18405b9166de5b0f$var$Checkbox;



parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");







"use client";
const $362f6829fc13950b$var$CheckboxGroup = /*#__PURE__*/ $N3oW3.forwardRef((props, ref)=>{
    const { defaultValue: defaultValue, children: children, options: options = [], prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, style: style, onChange: onChange, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, direction: direction } = $32rMB.useContext((0, $dd01e2f5a4b8605d$export$a92f85ab3e9ad68b));
    const [value, setValue] = $32rMB.useState(restProps.value || defaultValue || []);
    const [registeredValues, setRegisteredValues] = $32rMB.useState([]);
    $32rMB.useEffect(()=>{
        if ('value' in restProps) setValue(restProps.value || []);
    }, [
        restProps.value
    ]);
    const memoizedOptions = $32rMB.useMemo(()=>options.map((option)=>{
            if (typeof option === 'string' || typeof option === 'number') return {
                label: option,
                value: option
            };
            return option;
        }), [
        options
    ]);
    const cancelValue = (val)=>{
        setRegisteredValues((prevValues)=>prevValues.filter((v)=>v !== val));
    };
    const registerValue = (val)=>{
        setRegisteredValues((prevValues)=>[].concat((0, $3746fb019e1f2ee5$export$2e2bcd8739ae039)(prevValues), [
                val
            ]));
    };
    const toggleOption = (option)=>{
        const optionIndex = value.indexOf(option.value);
        const newValue = (0, $3746fb019e1f2ee5$export$2e2bcd8739ae039)(value);
        if (optionIndex === -1) newValue.push(option.value);
        else newValue.splice(optionIndex, 1);
        if (!('value' in restProps)) setValue(newValue);
        onChange?.(newValue.filter((val)=>registeredValues.includes(val)).sort((a, b)=>{
            const indexA = memoizedOptions.findIndex((opt)=>opt.value === a);
            const indexB = memoizedOptions.findIndex((opt)=>opt.value === b);
            return indexA - indexB;
        }));
    };
    const prefixCls = getPrefixCls('checkbox', customizePrefixCls);
    const groupPrefixCls = `${prefixCls}-group`;
    const rootCls = (0, $54b1aecddbbbed4f$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $2f2edafb2c86c023$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const domProps = (0, $f4cf9c2e27c0ac8d$export$2e2bcd8739ae039)(restProps, [
        'value',
        'disabled'
    ]);
    const childrenNode = options.length ? memoizedOptions.map((option)=>/*#__PURE__*/ $hO8yS.createElement((0, $18405b9166de5b0f$export$2e2bcd8739ae039), {
            prefixCls: prefixCls,
            key: option.value.toString(),
            disabled: 'disabled' in option ? option.disabled : restProps.disabled,
            value: option.value,
            checked: value.includes(option.value),
            onChange: option.onChange,
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${groupPrefixCls}-item`, option.className),
            style: option.style,
            title: option.title,
            id: option.id,
            required: option.required
        }, option.label)) : children;
    const memoizedContext = $32rMB.useMemo(()=>({
            toggleOption: toggleOption,
            value: value,
            disabled: restProps.disabled,
            name: restProps.name,
            registerValue: // https://github.com/ant-design/ant-design/issues/16376
            registerValue,
            cancelValue: cancelValue
        }), [
        toggleOption,
        value,
        restProps.disabled,
        restProps.name,
        registerValue,
        cancelValue
    ]);
    const classString = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(groupPrefixCls, {
        [`${groupPrefixCls}-rtl`]: direction === 'rtl'
    }, className, rootClassName, cssVarCls, rootCls, hashId);
    return /*#__PURE__*/ $hO8yS.createElement("div", {
        className: classString,
        style: style,
        ...domProps,
        ref: ref
    }, /*#__PURE__*/ $hO8yS.createElement((0, $963df0c482c60292$export$2e2bcd8739ae039).Provider, {
        value: memoizedContext
    }, childrenNode));
});
var $362f6829fc13950b$export$2e2bcd8739ae039 = $362f6829fc13950b$var$CheckboxGroup;


"use client";
const $feaaea83208f19fc$var$Checkbox = (0, $18405b9166de5b0f$export$2e2bcd8739ae039);
$feaaea83208f19fc$var$Checkbox.Group = (0, $362f6829fc13950b$export$2e2bcd8739ae039);
$feaaea83208f19fc$var$Checkbox.__ANT_CHECKBOX = true;
var $feaaea83208f19fc$export$2e2bcd8739ae039 = $feaaea83208f19fc$var$Checkbox;



parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");










parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
const $6790f07b0813167c$var$RadioGroupContext = /*#__PURE__*/ $hO8yS.createContext(null);
const $6790f07b0813167c$export$67d4730aee04efd2 = $6790f07b0813167c$var$RadioGroupContext.Provider;
var $6790f07b0813167c$export$2e2bcd8739ae039 = $6790f07b0813167c$var$RadioGroupContext;
const $6790f07b0813167c$export$4fbd9581b41e971f = /*#__PURE__*/ $hO8yS.createContext(null);
const $6790f07b0813167c$export$1b5d1f64a577990e = $6790f07b0813167c$export$4fbd9581b41e971f.Provider;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
















// ============================== Styles ==============================
// styles from RadioGroup only
const $010e73393656f3e7$var$getGroupRadioStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    const groupPrefixCls = `${componentCls}-group`;
    return {
        [groupPrefixCls]: {
            ...(0, $2f353af2b0f7600b$export$23997c3e44cc1c59)(token),
            display: 'inline-block',
            fontSize: 0,
            // RTL
            [`&${groupPrefixCls}-rtl`]: {
                direction: 'rtl'
            },
            [`&${groupPrefixCls}-block`]: {
                display: 'flex'
            },
            [`${antCls}-badge ${antCls}-badge-count`]: {
                zIndex: 1
            },
            [`> ${antCls}-badge:not(:first-child) > ${antCls}-button-wrapper`]: {
                borderInlineStart: 'none'
            },
            '&-vertical': {
                display: 'flex',
                flexDirection: 'column',
                rowGap: token.marginXS
            }
        }
    };
};
// Styles from radio-wrapper
const $010e73393656f3e7$var$getRadioBasicStyle = (token)=>{
    const { componentCls: componentCls, wrapperMarginInlineEnd: wrapperMarginInlineEnd, colorPrimary: colorPrimary, radioSize: radioSize, motionDurationSlow: motionDurationSlow, motionDurationMid: motionDurationMid, motionEaseInOutCirc: motionEaseInOutCirc, colorBgContainer: colorBgContainer, colorBorder: colorBorder, lineWidth: lineWidth, colorBgContainerDisabled: colorBgContainerDisabled, colorTextDisabled: colorTextDisabled, paddingXS: paddingXS, dotColorDisabled: dotColorDisabled, lineType: lineType, radioColor: radioColor, radioBgColor: radioBgColor, calc: calc } = token;
    const radioInnerPrefixCls = `${componentCls}-inner`;
    const dotPadding = 4;
    const radioDotDisabledSize = calc(radioSize).sub(calc(dotPadding).mul(2));
    const radioSizeCalc = calc(1).mul(radioSize).equal({
        unit: true
    });
    return {
        [`${componentCls}-wrapper`]: {
            ...(0, $2f353af2b0f7600b$export$23997c3e44cc1c59)(token),
            display: 'inline-flex',
            alignItems: 'baseline',
            marginInlineStart: 0,
            marginInlineEnd: wrapperMarginInlineEnd,
            cursor: 'pointer',
            '&:last-child': {
                marginInlineEnd: 0
            },
            // RTL
            [`&${componentCls}-wrapper-rtl`]: {
                direction: 'rtl'
            },
            '&-disabled': {
                cursor: 'not-allowed',
                color: token.colorTextDisabled
            },
            '&::after': {
                display: 'inline-block',
                width: 0,
                overflow: 'hidden',
                content: '"\\a0"'
            },
            '&-block': {
                flex: 1,
                justifyContent: 'center'
            },
            // hashId 在 wrapper 上，只能铺平
            [`${componentCls}-checked::after`]: {
                position: 'absolute',
                insetBlockStart: 0,
                insetInlineStart: 0,
                width: '100%',
                height: '100%',
                border: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(lineWidth)} ${lineType} ${colorPrimary}`,
                borderRadius: '50%',
                visibility: 'hidden',
                opacity: 0,
                content: '""'
            },
            [componentCls]: {
                ...(0, $2f353af2b0f7600b$export$23997c3e44cc1c59)(token),
                position: 'relative',
                display: 'inline-block',
                outline: 'none',
                cursor: 'pointer',
                alignSelf: 'center',
                borderRadius: '50%'
            },
            [`${componentCls}-wrapper:hover &,
        &:hover ${radioInnerPrefixCls}`]: {
                borderColor: colorPrimary
            },
            [`${componentCls}-input:focus-visible + ${radioInnerPrefixCls}`]: (0, $2f353af2b0f7600b$export$6539948f0a737e39)(token),
            [`${componentCls}:hover::after, ${componentCls}-wrapper:hover &::after`]: {
                visibility: 'visible'
            },
            [`${componentCls}-inner`]: {
                '&::after': {
                    boxSizing: 'border-box',
                    position: 'absolute',
                    insetBlockStart: '50%',
                    insetInlineStart: '50%',
                    display: 'block',
                    width: radioSizeCalc,
                    height: radioSizeCalc,
                    marginBlockStart: calc(1).mul(radioSize).div(-2).equal({
                        unit: true
                    }),
                    marginInlineStart: calc(1).mul(radioSize).div(-2).equal({
                        unit: true
                    }),
                    backgroundColor: radioColor,
                    borderBlockStart: 0,
                    borderInlineStart: 0,
                    borderRadius: radioSizeCalc,
                    transform: 'scale(0)',
                    opacity: 0,
                    transition: `all ${motionDurationSlow} ${motionEaseInOutCirc}`,
                    content: '""'
                },
                boxSizing: 'border-box',
                position: 'relative',
                insetBlockStart: 0,
                insetInlineStart: 0,
                display: 'block',
                width: radioSizeCalc,
                height: radioSizeCalc,
                backgroundColor: colorBgContainer,
                borderColor: colorBorder,
                borderStyle: 'solid',
                borderWidth: lineWidth,
                borderRadius: '50%',
                transition: `all ${motionDurationMid}`
            },
            [`${componentCls}-input`]: {
                position: 'absolute',
                inset: 0,
                zIndex: 1,
                cursor: 'pointer',
                opacity: 0
            },
            // 选中状态
            [`${componentCls}-checked`]: {
                [radioInnerPrefixCls]: {
                    borderColor: colorPrimary,
                    backgroundColor: radioBgColor,
                    '&::after': {
                        transform: `scale(${token.calc(token.dotSize).div(radioSize).equal()})`,
                        opacity: 1,
                        transition: `all ${motionDurationSlow} ${motionEaseInOutCirc}`
                    }
                }
            },
            [`${componentCls}-disabled`]: {
                cursor: 'not-allowed',
                [radioInnerPrefixCls]: {
                    backgroundColor: colorBgContainerDisabled,
                    borderColor: colorBorder,
                    cursor: 'not-allowed',
                    '&::after': {
                        backgroundColor: dotColorDisabled
                    }
                },
                [`${componentCls}-input`]: {
                    cursor: 'not-allowed'
                },
                [`${componentCls}-disabled + span`]: {
                    color: colorTextDisabled,
                    cursor: 'not-allowed'
                },
                [`&${componentCls}-checked`]: {
                    [radioInnerPrefixCls]: {
                        '&::after': {
                            transform: `scale(${calc(radioDotDisabledSize).div(radioSize).equal()})`
                        }
                    }
                }
            },
            [`span${componentCls} + *`]: {
                paddingInlineStart: paddingXS,
                paddingInlineEnd: paddingXS
            }
        }
    };
};
// Styles from radio-button
const $010e73393656f3e7$var$getRadioButtonStyle = (token)=>{
    const { buttonColor: buttonColor, controlHeight: controlHeight, componentCls: componentCls, lineWidth: lineWidth, lineType: lineType, colorBorder: colorBorder, motionDurationMid: motionDurationMid, buttonPaddingInline: buttonPaddingInline, fontSize: fontSize, buttonBg: buttonBg, fontSizeLG: fontSizeLG, controlHeightLG: controlHeightLG, controlHeightSM: controlHeightSM, paddingXS: paddingXS, borderRadius: borderRadius, borderRadiusSM: borderRadiusSM, borderRadiusLG: borderRadiusLG, buttonCheckedBg: buttonCheckedBg, buttonSolidCheckedColor: buttonSolidCheckedColor, colorTextDisabled: colorTextDisabled, colorBgContainerDisabled: colorBgContainerDisabled, buttonCheckedBgDisabled: buttonCheckedBgDisabled, buttonCheckedColorDisabled: buttonCheckedColorDisabled, colorPrimary: colorPrimary, colorPrimaryHover: colorPrimaryHover, colorPrimaryActive: colorPrimaryActive, buttonSolidCheckedBg: buttonSolidCheckedBg, buttonSolidCheckedHoverBg: buttonSolidCheckedHoverBg, buttonSolidCheckedActiveBg: buttonSolidCheckedActiveBg, calc: calc } = token;
    return {
        [`${componentCls}-button-wrapper`]: {
            position: 'relative',
            display: 'inline-block',
            height: controlHeight,
            margin: 0,
            paddingInline: buttonPaddingInline,
            paddingBlock: 0,
            color: buttonColor,
            fontSize: fontSize,
            lineHeight: (0, $763a5b4b58d0a3ff$export$523c0b569236b342)(calc(controlHeight).sub(calc(lineWidth).mul(2)).equal()),
            background: buttonBg,
            border: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(lineWidth)} ${lineType} ${colorBorder}`,
            // strange align fix for chrome but works
            // https://gw.alipayobjects.com/zos/rmsportal/VFTfKXJuogBAXcvfAUWJ.gif
            borderBlockStartWidth: calc(lineWidth).add(0.02).equal(),
            borderInlineEndWidth: lineWidth,
            cursor: 'pointer',
            transition: [
                `color ${motionDurationMid}`,
                `background ${motionDurationMid}`,
                `box-shadow ${motionDurationMid}`
            ].join(','),
            a: {
                color: buttonColor
            },
            [`> ${componentCls}-button`]: {
                position: 'absolute',
                insetBlockStart: 0,
                insetInlineStart: 0,
                zIndex: -1,
                width: '100%',
                height: '100%'
            },
            '&:not(:last-child)': {
                marginInlineEnd: calc(lineWidth).mul(-1).equal()
            },
            '&:first-child': {
                borderInlineStart: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(lineWidth)} ${lineType} ${colorBorder}`,
                borderStartStartRadius: borderRadius,
                borderEndStartRadius: borderRadius
            },
            '&:last-child': {
                borderStartEndRadius: borderRadius,
                borderEndEndRadius: borderRadius
            },
            '&:first-child:last-child': {
                borderRadius: borderRadius
            },
            [`${componentCls}-group-large &`]: {
                height: controlHeightLG,
                fontSize: fontSizeLG,
                lineHeight: (0, $763a5b4b58d0a3ff$export$523c0b569236b342)(calc(controlHeightLG).sub(calc(lineWidth).mul(2)).equal()),
                '&:first-child': {
                    borderStartStartRadius: borderRadiusLG,
                    borderEndStartRadius: borderRadiusLG
                },
                '&:last-child': {
                    borderStartEndRadius: borderRadiusLG,
                    borderEndEndRadius: borderRadiusLG
                }
            },
            [`${componentCls}-group-small &`]: {
                height: controlHeightSM,
                paddingInline: calc(paddingXS).sub(lineWidth).equal(),
                paddingBlock: 0,
                lineHeight: (0, $763a5b4b58d0a3ff$export$523c0b569236b342)(calc(controlHeightSM).sub(calc(lineWidth).mul(2)).equal()),
                '&:first-child': {
                    borderStartStartRadius: borderRadiusSM,
                    borderEndStartRadius: borderRadiusSM
                },
                '&:last-child': {
                    borderStartEndRadius: borderRadiusSM,
                    borderEndEndRadius: borderRadiusSM
                }
            },
            '&:hover': {
                position: 'relative',
                color: colorPrimary
            },
            '&:has(:focus-visible)': (0, $2f353af2b0f7600b$export$6539948f0a737e39)(token),
            [`${componentCls}-inner, input[type='checkbox'], input[type='radio']`]: {
                width: 0,
                height: 0,
                opacity: 0,
                pointerEvents: 'none'
            },
            [`&-checked:not(${componentCls}-button-wrapper-disabled)`]: {
                zIndex: 1,
                color: colorPrimary,
                background: buttonCheckedBg,
                borderColor: colorPrimary,
                '&::before': {
                    backgroundColor: colorPrimary
                },
                '&:first-child': {
                    borderColor: colorPrimary
                },
                '&:hover': {
                    color: colorPrimaryHover,
                    borderColor: colorPrimaryHover,
                    '&::before': {
                        backgroundColor: colorPrimaryHover
                    }
                },
                '&:active': {
                    color: colorPrimaryActive,
                    borderColor: colorPrimaryActive,
                    '&::before': {
                        backgroundColor: colorPrimaryActive
                    }
                }
            },
            [`${componentCls}-group-solid &-checked:not(${componentCls}-button-wrapper-disabled)`]: {
                color: buttonSolidCheckedColor,
                background: buttonSolidCheckedBg,
                borderColor: buttonSolidCheckedBg,
                '&:hover': {
                    color: buttonSolidCheckedColor,
                    background: buttonSolidCheckedHoverBg,
                    borderColor: buttonSolidCheckedHoverBg
                },
                '&:active': {
                    color: buttonSolidCheckedColor,
                    background: buttonSolidCheckedActiveBg,
                    borderColor: buttonSolidCheckedActiveBg
                }
            },
            '&-disabled': {
                color: colorTextDisabled,
                backgroundColor: colorBgContainerDisabled,
                borderColor: colorBorder,
                cursor: 'not-allowed',
                '&:first-child, &:hover': {
                    color: colorTextDisabled,
                    backgroundColor: colorBgContainerDisabled,
                    borderColor: colorBorder
                }
            },
            [`&-disabled${componentCls}-button-wrapper-checked`]: {
                color: buttonCheckedColorDisabled,
                backgroundColor: buttonCheckedBgDisabled,
                borderColor: colorBorder,
                boxShadow: 'none'
            },
            '&-block': {
                flex: 1,
                textAlign: 'center'
            }
        }
    };
};
const $010e73393656f3e7$export$9ca1be8807fe0675 = (token)=>{
    const { wireframe: wireframe, padding: padding, marginXS: marginXS, lineWidth: lineWidth, fontSizeLG: fontSizeLG, colorText: colorText, colorBgContainer: colorBgContainer, colorTextDisabled: colorTextDisabled, controlItemBgActiveDisabled: controlItemBgActiveDisabled, colorTextLightSolid: colorTextLightSolid, colorPrimary: colorPrimary, colorPrimaryHover: colorPrimaryHover, colorPrimaryActive: colorPrimaryActive, colorWhite: colorWhite } = token;
    const dotPadding = 4; // Fixed value
    const radioSize = fontSizeLG;
    const radioDotSize = wireframe ? radioSize - dotPadding * 2 : radioSize - (dotPadding + lineWidth) * 2;
    return {
        radioSize: // Radio
        radioSize,
        dotSize: radioDotSize,
        dotColorDisabled: colorTextDisabled,
        // Radio buttons
        buttonSolidCheckedColor: colorTextLightSolid,
        buttonSolidCheckedBg: colorPrimary,
        buttonSolidCheckedHoverBg: colorPrimaryHover,
        buttonSolidCheckedActiveBg: colorPrimaryActive,
        buttonBg: colorBgContainer,
        buttonCheckedBg: colorBgContainer,
        buttonColor: colorText,
        buttonCheckedBgDisabled: controlItemBgActiveDisabled,
        buttonCheckedColorDisabled: colorTextDisabled,
        buttonPaddingInline: padding - lineWidth,
        wrapperMarginInlineEnd: marginXS,
        // internal
        radioColor: wireframe ? colorPrimary : colorWhite,
        radioBgColor: wireframe ? colorBgContainer : colorPrimary
    };
};
var $010e73393656f3e7$export$2e2bcd8739ae039 = (0, $d4a2dc313c4d90a4$export$51ec95de45185b42)('Radio', (token)=>{
    const { controlOutline: controlOutline, controlOutlineWidth: controlOutlineWidth } = token;
    const radioFocusShadow = `0 0 0 ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(controlOutlineWidth)} ${controlOutline}`;
    const radioButtonFocusShadow = radioFocusShadow;
    const radioToken = (0, $90c11ca6cb263fd9$export$4950aa0f605343fb)(token, {
        radioFocusShadow: radioFocusShadow,
        radioButtonFocusShadow: radioButtonFocusShadow
    });
    return [
        $010e73393656f3e7$var$getGroupRadioStyle(radioToken),
        $010e73393656f3e7$var$getRadioBasicStyle(radioToken),
        $010e73393656f3e7$var$getRadioButtonStyle(radioToken)
    ];
}, $010e73393656f3e7$export$9ca1be8807fe0675, {
    unitless: {
        radioSize: true,
        dotSize: true
    }
});


"use client";
const $0a373f44949e7593$var$InternalRadio = (props, ref)=>{
    const groupContext = $32rMB.useContext((0, $6790f07b0813167c$export$2e2bcd8739ae039));
    const radioOptionTypeContext = $32rMB.useContext((0, $6790f07b0813167c$export$4fbd9581b41e971f));
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $dd01e2f5a4b8605d$export$46f4bd6436a25a31)('radio');
    const innerRef = $32rMB.useRef(null);
    const mergedRef = (0, $2706ed817e87019d$export$ab452c34e8e05029)(ref, innerRef);
    const { isFormItemInput: isFormItemInput } = $32rMB.useContext((0, $a1a112e4dddc1035$export$bbb5553c6c7a14ed));
    const onChange = (e)=>{
        props.onChange?.(e);
        groupContext?.onChange?.(e);
    };
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, children: children, style: style, title: title, classNames: classNames, styles: styles, ...restProps } = props;
    const radioPrefixCls = getPrefixCls('radio', customizePrefixCls);
    const isButtonType = (groupContext?.optionType || radioOptionTypeContext) === 'button';
    const prefixCls = isButtonType ? `${radioPrefixCls}-button` : radioPrefixCls;
    // Style
    const rootCls = (0, $54b1aecddbbbed4f$export$2e2bcd8739ae039)(radioPrefixCls);
    const [hashId, cssVarCls] = (0, $010e73393656f3e7$export$2e2bcd8739ae039)(radioPrefixCls, rootCls);
    const radioProps = {
        ...restProps
    };
    // ===================== Disabled =====================
    const disabled = $32rMB.useContext((0, $ff4b4ddbf52ed41f$export$2e2bcd8739ae039));
    if (groupContext) {
        radioProps.name = groupContext.name;
        radioProps.onChange = onChange;
        radioProps.checked = props.value === groupContext.value;
        radioProps.disabled = radioProps.disabled ?? groupContext.disabled;
    }
    radioProps.disabled = radioProps.disabled ?? disabled;
    // =========== Merged Props for Semantic ===========
    const mergedProps = {
        ...props,
        ...radioProps
    };
    const [mergedClassNames, mergedStyles] = (0, $4dcf69d8c3d6df5c$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    const wrapperClassString = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-wrapper`, {
        [`${prefixCls}-wrapper-checked`]: radioProps.checked,
        [`${prefixCls}-wrapper-disabled`]: radioProps.disabled,
        [`${prefixCls}-wrapper-rtl`]: direction === 'rtl',
        [`${prefixCls}-wrapper-in-form-item`]: isFormItemInput,
        [`${prefixCls}-wrapper-block`]: !!groupContext?.block
    }, contextClassName, className, rootClassName, mergedClassNames.root, hashId, cssVarCls, rootCls);
    // ============================ Event Lock ============================
    const [onLabelClick, onInputClick] = (0, $0e024dd19a1d677c$export$2e2bcd8739ae039)(radioProps.onClick);
    // ============================== Render ==============================
    return /*#__PURE__*/ $hO8yS.createElement((0, $b6fefae43eb584fa$export$2e2bcd8739ae039), {
        component: "Radio",
        disabled: radioProps.disabled
    }, /*#__PURE__*/ $hO8yS.createElement("label", {
        className: wrapperClassString,
        style: {
            ...mergedStyles.root,
            ...contextStyle,
            ...style
        },
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        title: title,
        onClick: onLabelClick
    }, /*#__PURE__*/ $hO8yS.createElement((0, $59ba8b296720a8bb$export$2e2bcd8739ae039), {
        ...radioProps,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(mergedClassNames.icon, {
            [(0, $989003bd02f62eb9$export$23466a5792b7a5d3)]: !isButtonType
        }),
        style: mergedStyles.icon,
        type: "radio",
        prefixCls: prefixCls,
        ref: mergedRef,
        onClick: onInputClick
    }), children !== undefined ? /*#__PURE__*/ $hO8yS.createElement("span", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-label`, mergedClassNames.label),
        style: mergedStyles.label
    }, children) : null));
};
const $0a373f44949e7593$var$Radio = /*#__PURE__*/ $N3oW3.forwardRef($0a373f44949e7593$var$InternalRadio);
var $0a373f44949e7593$export$2e2bcd8739ae039 = $0a373f44949e7593$var$Radio;



"use client";
const $af4c86917c615d9b$var$RadioGroup = /*#__PURE__*/ $N3oW3.forwardRef((props, ref)=>{
    const { getPrefixCls: getPrefixCls, direction: direction } = $32rMB.useContext((0, $dd01e2f5a4b8605d$export$a92f85ab3e9ad68b));
    const { name: formItemName } = $32rMB.useContext((0, $a1a112e4dddc1035$export$bbb5553c6c7a14ed));
    const defaultName = (0, $32268c06752c3bab$export$2e2bcd8739ae039)((0, $33a442f1517960cf$export$368b682c15953eea)(formItemName));
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, options: options, buttonStyle: buttonStyle = 'outline', disabled: disabled, children: children, size: customizeSize, style: style, id: id, optionType: optionType, name: name = defaultName, defaultValue: defaultValue, value: customizedValue, block: block = false, onChange: onChange, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onFocus: onFocus, onBlur: onBlur, orientation: orientation, vertical: vertical } = props;
    const [value, setValue] = (0, $05ea6e97cee440ee$export$2e2bcd8739ae039)(defaultValue, customizedValue);
    const onRadioChange = $32rMB.useCallback((event)=>{
        const lastValue = value;
        const val = event.target.value;
        if (!('value' in props)) setValue(val);
        if (val !== lastValue) onChange?.(event);
    }, [
        value,
        setValue,
        onChange
    ]);
    const prefixCls = getPrefixCls('radio', customizePrefixCls);
    const groupPrefixCls = `${prefixCls}-group`;
    // Style
    const rootCls = (0, $54b1aecddbbbed4f$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $010e73393656f3e7$export$2e2bcd8739ae039)(prefixCls, rootCls);
    let childrenToRender = children;
    // 如果存在 options, 优先使用
    if (options && options.length > 0) childrenToRender = options.map((option)=>{
        if (typeof option === 'string' || typeof option === 'number') // 此处类型自动推导为 string
        return /*#__PURE__*/ $hO8yS.createElement((0, $0a373f44949e7593$export$2e2bcd8739ae039), {
            key: option.toString(),
            prefixCls: prefixCls,
            disabled: disabled,
            value: option,
            checked: value === option
        }, option);
        // 此处类型自动推导为 { label: string value: string }
        return /*#__PURE__*/ $hO8yS.createElement((0, $0a373f44949e7593$export$2e2bcd8739ae039), {
            key: `radio-group-value-options-${option.value}`,
            prefixCls: prefixCls,
            disabled: option.disabled || disabled,
            value: option.value,
            checked: value === option.value,
            title: option.title,
            style: option.style,
            className: option.className,
            id: option.id,
            required: option.required
        }, option.label);
    });
    const mergedSize = (0, $324b30eda6ea1cd7$export$2e2bcd8739ae039)(customizeSize);
    const [, mergedVertical] = (0, $2c11327ae0ff8899$export$550084c67147f6c4)(orientation, vertical);
    const classString = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(groupPrefixCls, `${groupPrefixCls}-${buttonStyle}`, {
        [`${groupPrefixCls}-${mergedSize}`]: mergedSize,
        [`${groupPrefixCls}-rtl`]: direction === 'rtl',
        [`${groupPrefixCls}-block`]: block
    }, className, rootClassName, hashId, cssVarCls, rootCls);
    const memoizedValue = $32rMB.useMemo(()=>({
            onChange: onRadioChange,
            value: value,
            disabled: disabled,
            name: name,
            optionType: optionType,
            block: block
        }), [
        onRadioChange,
        value,
        disabled,
        name,
        optionType,
        block
    ]);
    return /*#__PURE__*/ $hO8yS.createElement("div", {
        ...(0, $b0f3dfd0eb3cad70$export$2e2bcd8739ae039)(props, {
            aria: true,
            data: true
        }),
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(classString, {
            [`${prefixCls}-group-vertical`]: mergedVertical
        }),
        style: style,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onFocus: onFocus,
        onBlur: onBlur,
        id: id,
        ref: ref
    }, /*#__PURE__*/ $hO8yS.createElement((0, $6790f07b0813167c$export$67d4730aee04efd2), {
        value: memoizedValue
    }, childrenToRender));
});
var $af4c86917c615d9b$export$2e2bcd8739ae039 = /*#__PURE__*/ $N3oW3.memo($af4c86917c615d9b$var$RadioGroup);



parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");



"use client";
const $d28f109902c33749$var$RadioButton = (props, ref)=>{
    const { getPrefixCls: getPrefixCls } = $32rMB.useContext((0, $dd01e2f5a4b8605d$export$a92f85ab3e9ad68b));
    const { prefixCls: customizePrefixCls, ...radioProps } = props;
    const prefixCls = getPrefixCls('radio', customizePrefixCls);
    return /*#__PURE__*/ $hO8yS.createElement((0, $6790f07b0813167c$export$1b5d1f64a577990e), {
        value: "button"
    }, /*#__PURE__*/ $hO8yS.createElement((0, $0a373f44949e7593$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        ...radioProps,
        type: "radio",
        ref: ref
    }));
};
var $d28f109902c33749$export$2e2bcd8739ae039 = /*#__PURE__*/ $N3oW3.forwardRef($d28f109902c33749$var$RadioButton);


"use client";
const $a3affe103134fa01$var$Radio = (0, $0a373f44949e7593$export$2e2bcd8739ae039);
$a3affe103134fa01$var$Radio.Button = (0, $d28f109902c33749$export$2e2bcd8739ae039);
$a3affe103134fa01$var$Radio.Group = (0, $af4c86917c615d9b$export$2e2bcd8739ae039);
$a3affe103134fa01$var$Radio.__ANT_RADIO = true;
var $a3affe103134fa01$export$2e2bcd8739ae039 = $a3affe103134fa01$var$Radio;


"use client";
const $771b71189b7d291d$export$ed10248435b8f218 = {};
const $771b71189b7d291d$export$14159cd9e2a500c8 = 'SELECT_ALL';
const $771b71189b7d291d$export$625c4f68eaaf8cfd = 'SELECT_INVERT';
const $771b71189b7d291d$export$c1a725540f5a63bd = 'SELECT_NONE';
const $771b71189b7d291d$var$EMPTY_LIST = [];
const $771b71189b7d291d$var$flattenData = (childrenColumnName, data, list = [])=>{
    (data || []).forEach((record)=>{
        list.push(record);
        if (record && typeof record === 'object' && childrenColumnName in record) $771b71189b7d291d$var$flattenData(childrenColumnName, record[childrenColumnName], list);
    });
    return list;
};
const $771b71189b7d291d$var$useSelection = (config, rowSelection)=>{
    const { preserveSelectedRowKeys: preserveSelectedRowKeys, selectedRowKeys: selectedRowKeys, defaultSelectedRowKeys: defaultSelectedRowKeys, getCheckboxProps: getCheckboxProps, getTitleCheckboxProps: getTitleCheckboxProps, onChange: onSelectionChange, onSelect: onSelect, onSelectAll: onSelectAll, onSelectInvert: onSelectInvert, onSelectNone: onSelectNone, onSelectMultiple: onSelectMultiple, columnWidth: selectionColWidth, type: selectionType, selections: selections, fixed: fixed, renderCell: customizeRenderCell, hideSelectAll: hideSelectAll, checkStrictly: checkStrictly = true } = rowSelection || {};
    const { prefixCls: prefixCls, data: data, pageData: pageData, getRecordByKey: getRecordByKey, getRowKey: getRowKey, expandType: expandType, childrenColumnName: childrenColumnName, locale: tableLocale, getPopupContainer: getPopupContainer } = config;
    const warning = (0, $d41680c8243eac18$export$cf977aa92c751e61)('Table');
    // ========================= MultipleSelect =========================
    const [multipleSelect, updatePrevSelectedIndex] = (0, $8008927312c4cb7d$export$3f339a531a4f3fb4)((item)=>item);
    // ========================= Keys =========================
    const [mergedSelectedKeys, setMergedSelectedKeys] = (0, $05ea6e97cee440ee$export$2e2bcd8739ae039)(defaultSelectedRowKeys || $771b71189b7d291d$var$EMPTY_LIST, selectedRowKeys);
    // ======================== Caches ========================
    const preserveRecordsRef = $32rMB.useRef(new Map());
    const updatePreserveRecordsCache = (0, $32rMB.useCallback)((keys)=>{
        if (preserveSelectedRowKeys) {
            const newCache = new Map();
            // Keep key if mark as preserveSelectedRowKeys
            keys.forEach((key)=>{
                let record = getRecordByKey(key);
                if (!record && preserveRecordsRef.current.has(key)) record = preserveRecordsRef.current.get(key);
                newCache.set(key, record);
            });
            // Refresh to new cache
            preserveRecordsRef.current = newCache;
        }
    }, [
        getRecordByKey,
        preserveSelectedRowKeys
    ]);
    // Update cache with selectedKeys
    $32rMB.useEffect(()=>{
        updatePreserveRecordsCache(mergedSelectedKeys);
    }, [
        mergedSelectedKeys
    ]);
    // Get flatten data
    const flattedData = (0, $32rMB.useMemo)(()=>$771b71189b7d291d$var$flattenData(childrenColumnName, pageData), [
        childrenColumnName,
        pageData
    ]);
    const { keyEntities: keyEntities } = (0, $32rMB.useMemo)(()=>{
        if (checkStrictly) return {
            keyEntities: null
        };
        let convertData = data;
        if (preserveSelectedRowKeys) {
            // use flattedData keys
            const keysSet = new Set(flattedData.map(getRowKey));
            // remove preserveRecords that duplicate data
            const preserveRecords = Array.from(preserveRecordsRef.current).reduce((total, [key, value])=>keysSet.has(key) ? total : total.concat(value), []);
            convertData = [].concat((0, $3746fb019e1f2ee5$export$2e2bcd8739ae039)(convertData), (0, $3746fb019e1f2ee5$export$2e2bcd8739ae039)(preserveRecords));
        }
        return (0, $8c21c3908ec083b2$export$e5d831ce033a4615)(convertData, {
            externalGetKey: getRowKey,
            childrenPropName: childrenColumnName
        });
    }, [
        data,
        getRowKey,
        checkStrictly,
        childrenColumnName,
        preserveSelectedRowKeys,
        flattedData
    ]);
    // Get all checkbox props
    const checkboxPropsMap = (0, $32rMB.useMemo)(()=>{
        const map = new Map();
        flattedData.forEach((record, index)=>{
            const key = getRowKey(record, index);
            const checkboxProps = (getCheckboxProps ? getCheckboxProps(record) : null) || {};
            map.set(key, checkboxProps);
        });
        return map;
    }, [
        flattedData,
        getRowKey,
        getCheckboxProps
    ]);
    const isCheckboxDisabled = (0, $32rMB.useCallback)((r)=>{
        const rowKey = getRowKey(r);
        let checkboxProps;
        if (checkboxPropsMap.has(rowKey)) checkboxProps = checkboxPropsMap.get(getRowKey(r));
        else checkboxProps = getCheckboxProps ? getCheckboxProps(r) : undefined;
        return !!checkboxProps?.disabled;
    }, [
        checkboxPropsMap,
        getRowKey
    ]);
    const [derivedSelectedKeys, derivedHalfSelectedKeys] = (0, $32rMB.useMemo)(()=>{
        if (checkStrictly) return [
            mergedSelectedKeys || [],
            []
        ];
        const { checkedKeys: checkedKeys, halfCheckedKeys: halfCheckedKeys } = (0, $0920639cbc3d717f$export$43adf2c483e3e633)(mergedSelectedKeys, true, keyEntities, isCheckboxDisabled);
        return [
            checkedKeys || [],
            halfCheckedKeys
        ];
    }, [
        mergedSelectedKeys,
        checkStrictly,
        keyEntities,
        isCheckboxDisabled
    ]);
    const derivedSelectedKeySet = (0, $32rMB.useMemo)(()=>{
        const keys = selectionType === 'radio' ? derivedSelectedKeys.slice(0, 1) : derivedSelectedKeys;
        return new Set(keys);
    }, [
        derivedSelectedKeys,
        selectionType
    ]);
    const derivedHalfSelectedKeySet = (0, $32rMB.useMemo)(()=>selectionType === 'radio' ? new Set() : new Set(derivedHalfSelectedKeys), [
        derivedHalfSelectedKeys,
        selectionType
    ]);
    // Reset if rowSelection reset
    $32rMB.useEffect(()=>{
        if (!rowSelection) setMergedSelectedKeys($771b71189b7d291d$var$EMPTY_LIST);
    }, [
        !!rowSelection
    ]);
    const setSelectedKeys = (0, $32rMB.useCallback)((keys, method)=>{
        let availableKeys;
        let records;
        updatePreserveRecordsCache(keys);
        if (preserveSelectedRowKeys) {
            availableKeys = keys;
            records = keys.map((key)=>preserveRecordsRef.current.get(key));
        } else {
            // Filter key which not exist in the `dataSource`
            availableKeys = [];
            records = [];
            keys.forEach((key)=>{
                const record = getRecordByKey(key);
                if (record !== undefined) {
                    availableKeys.push(key);
                    records.push(record);
                }
            });
        }
        setMergedSelectedKeys(availableKeys);
        onSelectionChange?.(availableKeys, records, {
            type: method
        });
    }, [
        setMergedSelectedKeys,
        getRecordByKey,
        onSelectionChange,
        preserveSelectedRowKeys
    ]);
    // ====================== Selections ======================
    // Trigger single `onSelect` event
    const triggerSingleSelection = (0, $32rMB.useCallback)((key, selected, keys, event)=>{
        if (onSelect) {
            const rows = keys.map((k)=>getRecordByKey(k));
            onSelect(getRecordByKey(key), selected, rows, event);
        }
        setSelectedKeys(keys, 'single');
    }, [
        onSelect,
        getRecordByKey,
        setSelectedKeys
    ]);
    const mergedSelections = (0, $32rMB.useMemo)(()=>{
        if (!selections || hideSelectAll) return null;
        const selectionList = selections === true ? [
            $771b71189b7d291d$export$14159cd9e2a500c8,
            $771b71189b7d291d$export$625c4f68eaaf8cfd,
            $771b71189b7d291d$export$c1a725540f5a63bd
        ] : selections;
        return selectionList.map((selection)=>{
            if (selection === $771b71189b7d291d$export$14159cd9e2a500c8) return {
                key: 'all',
                text: tableLocale.selectionAll,
                onSelect () {
                    setSelectedKeys(data.map((record, index)=>getRowKey(record, index)).filter((key)=>{
                        const checkProps = checkboxPropsMap.get(key);
                        return !checkProps?.disabled || derivedSelectedKeySet.has(key);
                    }), 'all');
                }
            };
            if (selection === $771b71189b7d291d$export$625c4f68eaaf8cfd) return {
                key: 'invert',
                text: tableLocale.selectInvert,
                onSelect () {
                    const keySet = new Set(derivedSelectedKeySet);
                    pageData.forEach((record, index)=>{
                        const key = getRowKey(record, index);
                        const checkProps = checkboxPropsMap.get(key);
                        if (!checkProps?.disabled) {
                            if (keySet.has(key)) keySet.delete(key);
                            else keySet.add(key);
                        }
                    });
                    const keys = Array.from(keySet);
                    if (onSelectInvert) {
                        warning.deprecated(false, 'onSelectInvert', 'onChange');
                        onSelectInvert(keys);
                    }
                    setSelectedKeys(keys, 'invert');
                }
            };
            if (selection === $771b71189b7d291d$export$c1a725540f5a63bd) return {
                key: 'none',
                text: tableLocale.selectNone,
                onSelect () {
                    onSelectNone?.();
                    setSelectedKeys(Array.from(derivedSelectedKeySet).filter((key)=>{
                        const checkProps = checkboxPropsMap.get(key);
                        return checkProps?.disabled;
                    }), 'none');
                }
            };
            return selection;
        }).map((selection)=>({
                ...selection,
                onSelect: (...rest)=>{
                    selection.onSelect?.(...rest);
                    updatePrevSelectedIndex(null);
                }
            }));
    }, [
        selections,
        hideSelectAll,
        tableLocale.selectionAll,
        tableLocale.selectInvert,
        tableLocale.selectNone,
        checkboxPropsMap,
        derivedSelectedKeySet,
        data,
        pageData,
        getRowKey,
        onSelectInvert,
        setSelectedKeys
    ]);
    // ======================= Columns ========================
    const transformColumns = (0, $32rMB.useCallback)((columns)=>{
        // >>>>>>>>>>> Skip if not exists `rowSelection`
        if (!rowSelection) return columns.filter((col)=>col !== $771b71189b7d291d$export$ed10248435b8f218);
        // >>>>>>>>>>> Support selection
        let cloneColumns = (0, $3746fb019e1f2ee5$export$2e2bcd8739ae039)(columns);
        const keySet = new Set(derivedSelectedKeySet);
        // Record key only need check with enabled
        const recordKeys = flattedData.map(getRowKey).filter((key)=>!checkboxPropsMap.get(key).disabled);
        const checkedCurrentAll = recordKeys.every((key)=>keySet.has(key));
        const checkedCurrentSome = recordKeys.some((key)=>keySet.has(key));
        const onSelectAllChange = ()=>{
            const changeKeys = [];
            if (checkedCurrentAll) recordKeys.forEach((key)=>{
                keySet.delete(key);
                changeKeys.push(key);
            });
            else recordKeys.forEach((key)=>{
                if (!keySet.has(key)) {
                    keySet.add(key);
                    changeKeys.push(key);
                }
            });
            const keys = Array.from(keySet);
            onSelectAll?.(!checkedCurrentAll, keys.map((k)=>getRecordByKey(k)), changeKeys.map((k)=>getRecordByKey(k)));
            setSelectedKeys(keys, 'all');
            updatePrevSelectedIndex(null);
        };
        // ===================== Render =====================
        // Title Cell
        let title;
        let columnTitleCheckbox;
        if (selectionType !== 'radio') {
            let customizeSelections;
            if (mergedSelections) {
                const menu = {
                    getPopupContainer: getPopupContainer,
                    items: mergedSelections.map((selection, index)=>{
                        const { key: key, text: text, onSelect: onSelectionClick } = selection;
                        return {
                            key: key ?? index,
                            onClick: ()=>{
                                onSelectionClick?.(recordKeys);
                            },
                            label: text
                        };
                    })
                };
                customizeSelections = /*#__PURE__*/ $hO8yS.createElement("div", {
                    className: `${prefixCls}-selection-extra`
                }, /*#__PURE__*/ $hO8yS.createElement((0, $38b79a6ce8fc3a86$export$2e2bcd8739ae039), {
                    menu: menu,
                    getPopupContainer: getPopupContainer
                }, /*#__PURE__*/ $hO8yS.createElement("span", null, /*#__PURE__*/ $hO8yS.createElement((0, $6c28e8c1b305d317$export$2e2bcd8739ae039), null))));
            }
            const allDisabledData = flattedData.map((record, index)=>{
                const key = getRowKey(record, index);
                const checkboxProps = checkboxPropsMap.get(key) || {};
                return {
                    checked: keySet.has(key),
                    ...checkboxProps
                };
            }).filter(({ disabled: disabled })=>disabled);
            const allDisabled = !!allDisabledData.length && allDisabledData.length === flattedData.length;
            const allDisabledAndChecked = allDisabled && allDisabledData.every(({ checked: checked })=>checked);
            const allDisabledSomeChecked = allDisabled && allDisabledData.some(({ checked: checked })=>checked);
            const customCheckboxProps = getTitleCheckboxProps?.() || {};
            const { onChange: onChange, disabled: disabled } = customCheckboxProps;
            columnTitleCheckbox = /*#__PURE__*/ $hO8yS.createElement((0, $feaaea83208f19fc$export$2e2bcd8739ae039), {
                "aria-label": customizeSelections ? 'Custom selection' : 'Select all',
                ...customCheckboxProps,
                checked: !allDisabled ? !!flattedData.length && checkedCurrentAll : allDisabledAndChecked,
                indeterminate: !allDisabled ? !checkedCurrentAll && checkedCurrentSome : !allDisabledAndChecked && allDisabledSomeChecked,
                onChange: (e)=>{
                    onSelectAllChange();
                    onChange?.(e);
                },
                disabled: disabled ?? (flattedData.length === 0 || allDisabled),
                skipGroup: true
            });
            title = !hideSelectAll && /*#__PURE__*/ $hO8yS.createElement("div", {
                className: `${prefixCls}-selection`
            }, columnTitleCheckbox, customizeSelections);
        }
        // Body Cell
        let renderCell;
        if (selectionType === 'radio') renderCell = (_, record, index)=>{
            const key = getRowKey(record, index);
            const checked = keySet.has(key);
            const checkboxProps = checkboxPropsMap.get(key);
            return {
                node: /*#__PURE__*/ $hO8yS.createElement((0, $a3affe103134fa01$export$2e2bcd8739ae039), {
                    ...checkboxProps,
                    checked: checked,
                    onClick: (e)=>{
                        e.stopPropagation();
                        checkboxProps?.onClick?.(e);
                    },
                    onChange: (event)=>{
                        if (!keySet.has(key)) triggerSingleSelection(key, true, [
                            key
                        ], event.nativeEvent);
                        checkboxProps?.onChange?.(event);
                    }
                }),
                checked: checked
            };
        };
        else renderCell = (_, record, index)=>{
            const key = getRowKey(record, index);
            const checked = keySet.has(key);
            const indeterminate = derivedHalfSelectedKeySet.has(key);
            const checkboxProps = checkboxPropsMap.get(key);
            let mergedIndeterminate;
            if (expandType === 'nest') mergedIndeterminate = indeterminate;
            else mergedIndeterminate = checkboxProps?.indeterminate ?? indeterminate;
            // Record checked
            return {
                node: /*#__PURE__*/ $hO8yS.createElement((0, $feaaea83208f19fc$export$2e2bcd8739ae039), {
                    ...checkboxProps,
                    indeterminate: mergedIndeterminate,
                    checked: checked,
                    skipGroup: true,
                    onClick: (e)=>{
                        e.stopPropagation();
                        checkboxProps?.onClick?.(e);
                    },
                    onChange: (event)=>{
                        const { nativeEvent: nativeEvent } = event;
                        const { shiftKey: shiftKey } = nativeEvent;
                        const currentSelectedIndex = recordKeys.indexOf(key);
                        const isMultiple = derivedSelectedKeys.some((item)=>recordKeys.includes(item));
                        if (shiftKey && checkStrictly && isMultiple) {
                            const changedKeys = multipleSelect(currentSelectedIndex, recordKeys, keySet);
                            const keys = Array.from(keySet);
                            onSelectMultiple?.(!checked, keys.map((recordKey)=>getRecordByKey(recordKey)), changedKeys.map((recordKey)=>getRecordByKey(recordKey)));
                            setSelectedKeys(keys, 'multiple');
                        } else {
                            // Single record selected
                            const originCheckedKeys = derivedSelectedKeys;
                            if (checkStrictly) {
                                const checkedKeys = checked ? (0, $e60066375029f166$export$5bfb9ff497fe2298)(originCheckedKeys, key) : (0, $e60066375029f166$export$10663f6bbd2fd717)(originCheckedKeys, key);
                                triggerSingleSelection(key, !checked, checkedKeys, nativeEvent);
                            } else {
                                // Always fill first
                                const result = (0, $0920639cbc3d717f$export$43adf2c483e3e633)([].concat((0, $3746fb019e1f2ee5$export$2e2bcd8739ae039)(originCheckedKeys), [
                                    key
                                ]), true, keyEntities, isCheckboxDisabled);
                                const { checkedKeys: checkedKeys, halfCheckedKeys: halfCheckedKeys } = result;
                                let nextCheckedKeys = checkedKeys;
                                // If remove, we do it again to correction
                                if (checked) {
                                    const tempKeySet = new Set(checkedKeys);
                                    tempKeySet.delete(key);
                                    nextCheckedKeys = (0, $0920639cbc3d717f$export$43adf2c483e3e633)(Array.from(tempKeySet), {
                                        checked: false,
                                        halfCheckedKeys: halfCheckedKeys
                                    }, keyEntities, isCheckboxDisabled).checkedKeys;
                                }
                                triggerSingleSelection(key, !checked, nextCheckedKeys, nativeEvent);
                            }
                        }
                        if (checked) updatePrevSelectedIndex(null);
                        else updatePrevSelectedIndex(currentSelectedIndex);
                        checkboxProps?.onChange?.(event);
                    }
                }),
                checked: checked
            };
        };
        const renderSelectionCell = (_, record, index)=>{
            const { node: node, checked: checked } = renderCell(_, record, index);
            if (customizeRenderCell) return customizeRenderCell(checked, record, index, node);
            return node;
        };
        // Insert selection column if not exist
        if (!cloneColumns.includes($771b71189b7d291d$export$ed10248435b8f218)) {
            // Always after expand icon
            if (cloneColumns.findIndex((col)=>col[0, $46de3cc262a8e698$export$f8dba99c0d5b6b87]?.columnType === 'EXPAND_COLUMN') === 0) {
                const [expandColumn, ...restColumns] = cloneColumns;
                cloneColumns = [
                    expandColumn,
                    $771b71189b7d291d$export$ed10248435b8f218
                ].concat((0, $3746fb019e1f2ee5$export$2e2bcd8739ae039)(restColumns));
            } else // Normal insert at first column
            cloneColumns = [
                $771b71189b7d291d$export$ed10248435b8f218
            ].concat((0, $3746fb019e1f2ee5$export$2e2bcd8739ae039)(cloneColumns));
        }
        // Deduplicate selection column
        const selectionColumnIndex = cloneColumns.indexOf($771b71189b7d291d$export$ed10248435b8f218);
        cloneColumns = cloneColumns.filter((column, index)=>column !== $771b71189b7d291d$export$ed10248435b8f218 || index === selectionColumnIndex);
        // Fixed column logic
        const prevCol = cloneColumns[selectionColumnIndex - 1];
        const nextCol = cloneColumns[selectionColumnIndex + 1];
        let mergedFixed = fixed;
        if (mergedFixed === undefined) {
            if (nextCol?.fixed !== undefined) mergedFixed = nextCol.fixed;
            else if (prevCol?.fixed !== undefined) mergedFixed = prevCol.fixed;
        }
        if (mergedFixed && prevCol && prevCol[0, $46de3cc262a8e698$export$f8dba99c0d5b6b87]?.columnType === 'EXPAND_COLUMN' && prevCol.fixed === undefined) prevCol.fixed = mergedFixed;
        const columnCls = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-selection-col`, {
            [`${prefixCls}-selection-col-with-dropdown`]: selections && selectionType === 'checkbox'
        });
        const renderColumnTitle = ()=>{
            if (!rowSelection?.columnTitle) return title;
            if (typeof rowSelection.columnTitle === 'function') return rowSelection.columnTitle(columnTitleCheckbox);
            return rowSelection.columnTitle;
        };
        // Replace with real selection column
        const selectionColumn = {
            fixed: mergedFixed,
            width: selectionColWidth,
            className: `${prefixCls}-selection-column`,
            title: renderColumnTitle(),
            render: renderSelectionCell,
            onCell: rowSelection.onCell,
            align: rowSelection.align,
            [(0, $46de3cc262a8e698$export$f8dba99c0d5b6b87)]: {
                className: columnCls
            }
        };
        return cloneColumns.map((col)=>col === $771b71189b7d291d$export$ed10248435b8f218 ? selectionColumn : col);
    }, [
        getRowKey,
        flattedData,
        rowSelection,
        derivedSelectedKeys,
        derivedSelectedKeySet,
        derivedHalfSelectedKeySet,
        selectionColWidth,
        mergedSelections,
        expandType,
        checkboxPropsMap,
        onSelectMultiple,
        triggerSingleSelection,
        isCheckboxDisabled
    ]);
    return [
        transformColumns,
        derivedSelectedKeySet
    ];
};
var $771b71189b7d291d$export$2e2bcd8739ae039 = $771b71189b7d291d$var$useSelection;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");




// Proxy the dom ref with `{ nativeElement, otherFn }` type
// ref: https://github.com/ant-design/ant-design/discussions/45242
parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
const $83b69e786fd10eae$var$fillProxy = (element, handler)=>{
    element._antProxy = element._antProxy || {};
    Object.keys(handler).forEach((key)=>{
        if (!(key in element._antProxy)) {
            const ori = element[key];
            element._antProxy[key] = ori;
            element[key] = handler[key];
        }
    });
    return element;
};
const $83b69e786fd10eae$export$8edbe0145ad77a36 = (ref, init)=>{
    return (0, $32rMB.useImperativeHandle)(ref, ()=>{
        const refObj = init();
        const { nativeElement: nativeElement } = refObj;
        if (typeof Proxy !== 'undefined') return new Proxy(nativeElement, {
            get (obj, prop) {
                if (refObj[prop]) return refObj[prop];
                return Reflect.get(obj, prop);
            }
        });
        // Fallback of IE
        return $83b69e786fd10eae$var$fillProxy(nativeElement, refObj);
    });
};



function $3c08f6e7605d2ec2$export$24656b269d8df7d6(t, b, c, d) {
    const cc = c - b;
    t /= d / 2;
    if (t < 1) return cc / 2 * t * t * t + b;
    // biome-ignore lint: it is a common easing function
    return cc / 2 * ((t -= 2) * t * t + 2) + b;
}



function $aac50741333b3f4d$export$5a096129d439f843(obj) {
    return (0, $95ac4c3d4339216e$export$2e2bcd8739ae039)(obj) && obj === obj.window;
}
const $aac50741333b3f4d$var$getScroll = (target)=>{
    if (typeof window === 'undefined') /* istanbul ignore next */ return 0;
    let result = 0;
    if ($aac50741333b3f4d$export$5a096129d439f843(target)) result = target.pageYOffset;
    else if (target instanceof Document) result = target.documentElement.scrollTop;
    else if (target instanceof HTMLElement) result = target.scrollTop;
    else if (target) // According to the type inference, the `target` is `never` type.
    // Since we configured the loose mode type checking, and supports mocking the target with such shape below::
    //    `{ documentElement: { scrollLeft: 200, scrollTop: 400 } }`,
    //    the program may falls into this branch.
    // Check the corresponding tests for details. Don't sure what is the real scenario this happens.
    /* biome-ignore lint/complexity/useLiteralKeys: target is a never type */ /* eslint-disable-next-line dot-notation */ result = target['scrollTop'];
    if (target && !$aac50741333b3f4d$export$5a096129d439f843(target) && typeof result !== 'number') result = (target.ownerDocument ?? target).documentElement?.scrollTop;
    return result;
};
var $aac50741333b3f4d$export$2e2bcd8739ae039 = $aac50741333b3f4d$var$getScroll;


function $5664accf2c388193$export$2e2bcd8739ae039(y, options = {}) {
    const { getContainer: getContainer = ()=>window, callback: callback, duration: duration = 450 } = options;
    const container = getContainer();
    const scrollTop = (0, $aac50741333b3f4d$export$2e2bcd8739ae039)(container);
    const startTime = Date.now();
    let rafId;
    const frameFunc = ()=>{
        const timestamp = Date.now();
        const time = timestamp - startTime;
        const nextScrollTop = (0, $3c08f6e7605d2ec2$export$24656b269d8df7d6)(time > duration ? duration : time, scrollTop, y, duration);
        if ((0, $aac50741333b3f4d$export$5a096129d439f843)(container)) container.scrollTo(window.pageXOffset, nextScrollTop);
        else if (container instanceof Document || container.constructor.name === 'HTMLDocument') container.documentElement.scrollTop = nextScrollTop;
        else container.scrollTop = nextScrollTop;
        if (time < duration) rafId = (0, $c9c36e20d667d30c$export$2e2bcd8739ae039)(frameFunc);
        else if (typeof callback === 'function') callback();
    };
    rafId = (0, $c9c36e20d667d30c$export$2e2bcd8739ae039)(frameFunc);
    return ()=>{
        (0, $c9c36e20d667d30c$export$2e2bcd8739ae039).cancel(rafId);
    };
}






var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");

parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");





parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");



"use client";
const $e92f70fe42215fdb$var$Empty = ()=>{
    const [, token] = (0, $9481722d146bd166$export$2e2bcd8739ae039)();
    const [locale] = (0, $c176ccd8a9cbd556$export$2e2bcd8739ae039)('Empty');
    const bgColor = new (0, $cbc85b6187a98a9b$export$2c4f38d6c0ecc25a)(token.colorBgBase);
    // Dark Theme need more dark of this
    const themeStyle = bgColor.toHsl().l < 0.5 ? {
        opacity: 0.65
    } : {};
    return /*#__PURE__*/ $hO8yS.createElement("svg", {
        style: themeStyle,
        width: "184",
        height: "152",
        viewBox: "0 0 184 152",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $hO8yS.createElement("title", null, locale?.description || 'Empty'), /*#__PURE__*/ $hO8yS.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ $hO8yS.createElement("g", {
        transform: "translate(24 31.67)"
    }, /*#__PURE__*/ $hO8yS.createElement("ellipse", {
        fillOpacity: ".8",
        fill: "#F5F5F7",
        cx: "67.797",
        cy: "106.89",
        rx: "67.797",
        ry: "12.668"
    }), /*#__PURE__*/ $hO8yS.createElement("path", {
        d: "M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z",
        fill: "#AEB8C2"
    }), /*#__PURE__*/ $hO8yS.createElement("path", {
        d: "M101.537 86.214L80.63 61.102c-1.001-1.207-2.507-1.867-4.048-1.867H31.724c-1.54 0-3.047.66-4.048 1.867L6.769 86.214v13.792h94.768V86.214z",
        fill: "url(#linearGradient-1)",
        transform: "translate(13.56)"
    }), /*#__PURE__*/ $hO8yS.createElement("path", {
        d: "M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z",
        fill: "#F5F5F7"
    }), /*#__PURE__*/ $hO8yS.createElement("path", {
        d: "M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z",
        fill: "#DCE0E6"
    })), /*#__PURE__*/ $hO8yS.createElement("path", {
        d: "M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z",
        fill: "#DCE0E6"
    }), /*#__PURE__*/ $hO8yS.createElement("g", {
        transform: "translate(149.65 15.383)",
        fill: "#FFF"
    }, /*#__PURE__*/ $hO8yS.createElement("ellipse", {
        cx: "20.654",
        cy: "3.167",
        rx: "2.849",
        ry: "2.815"
    }), /*#__PURE__*/ $hO8yS.createElement("path", {
        d: "M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z"
    }))));
};
var $e92f70fe42215fdb$export$2e2bcd8739ae039 = $e92f70fe42215fdb$var$Empty;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");



"use client";
const $27edd28977a1f1ff$var$Simple = ()=>{
    const [, token] = (0, $9481722d146bd166$export$2e2bcd8739ae039)();
    const [locale] = (0, $c176ccd8a9cbd556$export$2e2bcd8739ae039)('Empty');
    const { colorFill: colorFill, colorFillTertiary: colorFillTertiary, colorFillQuaternary: colorFillQuaternary, colorBgContainer: colorBgContainer } = token;
    const { borderColor: borderColor, shadowColor: shadowColor, contentColor: contentColor } = (0, $32rMB.useMemo)(()=>({
            borderColor: new (0, $cbc85b6187a98a9b$export$2c4f38d6c0ecc25a)(colorFill).onBackground(colorBgContainer).toHexString(),
            shadowColor: new (0, $cbc85b6187a98a9b$export$2c4f38d6c0ecc25a)(colorFillTertiary).onBackground(colorBgContainer).toHexString(),
            contentColor: new (0, $cbc85b6187a98a9b$export$2c4f38d6c0ecc25a)(colorFillQuaternary).onBackground(colorBgContainer).toHexString()
        }), [
        colorFill,
        colorFillTertiary,
        colorFillQuaternary,
        colorBgContainer
    ]);
    return /*#__PURE__*/ $hO8yS.createElement("svg", {
        width: "64",
        height: "41",
        viewBox: "0 0 64 41",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $hO8yS.createElement("title", null, locale?.description || 'Empty'), /*#__PURE__*/ $hO8yS.createElement("g", {
        transform: "translate(0 1)",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ $hO8yS.createElement("ellipse", {
        fill: shadowColor,
        cx: "32",
        cy: "33",
        rx: "32",
        ry: "7"
    }), /*#__PURE__*/ $hO8yS.createElement("g", {
        fillRule: "nonzero",
        stroke: borderColor
    }, /*#__PURE__*/ $hO8yS.createElement("path", {
        d: "M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"
    }), /*#__PURE__*/ $hO8yS.createElement("path", {
        d: "M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z",
        fill: contentColor
    }))));
};
var $27edd28977a1f1ff$export$2e2bcd8739ae039 = $27edd28977a1f1ff$var$Simple;



// ============================== Shared ==============================
const $1bd68ac0a10560c8$var$genSharedEmptyStyle = (token)=>{
    const { componentCls: componentCls, margin: margin, marginXS: marginXS, marginXL: marginXL, fontSize: fontSize, lineHeight: lineHeight } = token;
    return {
        [componentCls]: {
            marginInline: marginXS,
            fontSize: fontSize,
            lineHeight: lineHeight,
            textAlign: 'center',
            // 原来 &-image 没有父子结构，现在为了外层承担我们的 hashId，改成父子结构
            [`${componentCls}-image`]: {
                height: token.emptyImgHeight,
                marginBottom: marginXS,
                opacity: token.opacityImage,
                img: {
                    height: '100%'
                },
                svg: {
                    maxWidth: '100%',
                    height: '100%',
                    margin: 'auto'
                }
            },
            [`${componentCls}-description`]: {
                color: token.colorTextDescription
            },
            // 原来 &-footer 没有父子结构，现在为了外层承担我们的 hashId，改成父子结构
            [`${componentCls}-footer`]: {
                marginTop: margin
            },
            '&-normal': {
                marginBlock: marginXL,
                color: token.colorTextDescription,
                [`${componentCls}-description`]: {
                    color: token.colorTextDescription
                },
                [`${componentCls}-image`]: {
                    height: token.emptyImgHeightMD
                }
            },
            '&-small': {
                marginBlock: marginXS,
                color: token.colorTextDescription,
                [`${componentCls}-image`]: {
                    height: token.emptyImgHeightSM
                }
            }
        }
    };
};
var // ============================== Export ==============================
$1bd68ac0a10560c8$export$2e2bcd8739ae039 = (0, $d4a2dc313c4d90a4$export$51ec95de45185b42)('Empty', (token)=>{
    const { componentCls: componentCls, controlHeightLG: controlHeightLG, calc: calc } = token;
    const emptyToken = (0, $90c11ca6cb263fd9$export$4950aa0f605343fb)(token, {
        emptyImgCls: `${componentCls}-img`,
        emptyImgHeight: calc(controlHeightLG).mul(2.5).equal(),
        emptyImgHeightMD: controlHeightLG,
        emptyImgHeightSM: calc(controlHeightLG).mul(0.875).equal()
    });
    return $1bd68ac0a10560c8$var$genSharedEmptyStyle(emptyToken);
});


"use client";
const $c9639cafaf2858d6$var$defaultEmptyImg = /*#__PURE__*/ $hO8yS.createElement((0, $e92f70fe42215fdb$export$2e2bcd8739ae039), null);
const $c9639cafaf2858d6$var$simpleEmptyImg = /*#__PURE__*/ $hO8yS.createElement((0, $27edd28977a1f1ff$export$2e2bcd8739ae039), null);
const $c9639cafaf2858d6$var$Empty = (props)=>{
    const { className: className, rootClassName: rootClassName, prefixCls: customizePrefixCls, image: image, description: description, children: children, imageStyle: imageStyle, style: style, classNames: classNames, styles: styles, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles, image: contextImage } = (0, $dd01e2f5a4b8605d$export$46f4bd6436a25a31)('empty');
    const prefixCls = getPrefixCls('empty', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $1bd68ac0a10560c8$export$2e2bcd8739ae039)(prefixCls);
    const [mergedClassNames, mergedStyles] = (0, $4dcf69d8c3d6df5c$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: props
    });
    const [locale] = (0, $c176ccd8a9cbd556$export$2e2bcd8739ae039)('Empty');
    const des = typeof description !== 'undefined' ? description : locale?.description;
    const alt = typeof des === 'string' ? des : 'empty';
    const mergedImage = image ?? contextImage ?? $c9639cafaf2858d6$var$defaultEmptyImg;
    let imageNode = null;
    if (typeof mergedImage === 'string') imageNode = /*#__PURE__*/ $hO8yS.createElement("img", {
        draggable: false,
        alt: alt,
        src: mergedImage
    });
    else imageNode = mergedImage;
    var deprecatedName, newName;
    return /*#__PURE__*/ $hO8yS.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(hashId, cssVarCls, prefixCls, contextClassName, {
            [`${prefixCls}-normal`]: mergedImage === $c9639cafaf2858d6$var$simpleEmptyImg,
            [`${prefixCls}-rtl`]: direction === 'rtl'
        }, className, rootClassName, mergedClassNames.root),
        style: {
            ...mergedStyles.root,
            ...contextStyle,
            ...style
        },
        ...restProps
    }, /*#__PURE__*/ $hO8yS.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-image`, mergedClassNames.image),
        style: {
            ...imageStyle,
            ...mergedStyles.image
        }
    }, imageNode), des && /*#__PURE__*/ $hO8yS.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-description`, mergedClassNames.description),
        style: mergedStyles.description
    }, des), children && /*#__PURE__*/ $hO8yS.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-footer`, mergedClassNames.footer),
        style: mergedStyles.footer
    }, children));
};
$c9639cafaf2858d6$var$Empty.PRESENTED_IMAGE_DEFAULT = $c9639cafaf2858d6$var$defaultEmptyImg;
$c9639cafaf2858d6$var$Empty.PRESENTED_IMAGE_SIMPLE = $c9639cafaf2858d6$var$simpleEmptyImg;
var $c9639cafaf2858d6$export$2e2bcd8739ae039 = $c9639cafaf2858d6$var$Empty;


"use client";
const $6650c2c5bdbe4a9f$var$DefaultRenderEmpty = (props)=>{
    const { componentName: componentName } = props;
    const { getPrefixCls: getPrefixCls } = (0, $32rMB.useContext)((0, $dd01e2f5a4b8605d$export$a92f85ab3e9ad68b));
    const prefix = getPrefixCls('empty');
    switch(componentName){
        case 'Table':
        case 'List':
            return /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $c9639cafaf2858d6$export$2e2bcd8739ae039), {
                image: (0, $c9639cafaf2858d6$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE
            });
        case 'Select':
        case 'TreeSelect':
        case 'Cascader':
        case 'Transfer':
        case 'Mentions':
            return /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $c9639cafaf2858d6$export$2e2bcd8739ae039), {
                image: (0, $c9639cafaf2858d6$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE,
                className: `${prefix}-small`
            });
        /**
     * This type of component should satisfy the nullish coalescing operator(??) on the left-hand side.
     * to let the component itself implement the logic.
     * For example `Table.filter`.
     */ case 'Table.filter':
            // why `null`? legacy react16 node type `undefined` is not allowed.
            return null;
        default:
            // Should never hit if we take all the component into consider.
            return /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $c9639cafaf2858d6$export$2e2bcd8739ae039), null);
    }
};
var $6650c2c5bdbe4a9f$export$2e2bcd8739ae039 = $6650c2c5bdbe4a9f$var$DefaultRenderEmpty;







parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");
parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
// This icon file is generated automatically.
var $fb1976fd13ff9f2c$var$DoubleLeftOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M272.9 512l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L186.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H532c6.7 0 10.4-7.7 6.3-12.9L272.9 512zm304 0l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L490.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H836c6.7 0 10.4-7.7 6.3-12.9L576.9 512z"
                }
            }
        ]
    },
    "name": "double-left",
    "theme": "outlined"
};
var $fb1976fd13ff9f2c$export$2e2bcd8739ae039 = $fb1976fd13ff9f2c$var$DoubleLeftOutlined;



function $fd26d0ae16b13197$var$_extends() {
    $fd26d0ae16b13197$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $fd26d0ae16b13197$var$_extends.apply(this, arguments);
}
const $fd26d0ae16b13197$var$DoubleLeftOutlined = (props, ref)=>/*#__PURE__*/ $hO8yS.createElement((0, $5fd6f3f3c400c267$export$2e2bcd8739ae039), $fd26d0ae16b13197$var$_extends({}, props, {
        ref: ref,
        icon: (0, $fb1976fd13ff9f2c$export$2e2bcd8739ae039)
    }));
/**![double-left](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTI3Mi45IDUxMmwyNjUuNC0zMzkuMWM0LjEtNS4yLjQtMTIuOS02LjMtMTIuOWgtNzcuM2MtNC45IDAtOS42IDIuMy0xMi42IDYuMUwxODYuOCA0OTIuM2EzMS45OSAzMS45OSAwIDAwMCAzOS41bDI1NS4zIDMyNi4xYzMgMy45IDcuNyA2LjEgMTIuNiA2LjFINTMyYzYuNyAwIDEwLjQtNy43IDYuMy0xMi45TDI3Mi45IDUxMnptMzA0IDBsMjY1LjQtMzM5LjFjNC4xLTUuMi40LTEyLjktNi4zLTEyLjloLTc3LjNjLTQuOSAwLTkuNiAyLjMtMTIuNiA2LjFMNDkwLjggNDkyLjNhMzEuOTkgMzEuOTkgMCAwMDAgMzkuNWwyNTUuMyAzMjYuMWMzIDMuOSA3LjcgNi4xIDEyLjYgNi4xSDgzNmM2LjcgMCAxMC40LTcuNyA2LjMtMTIuOUw1NzYuOSA1MTJ6IiAvPjwvc3ZnPg==) */ const $fd26d0ae16b13197$var$RefIcon = /*#__PURE__*/ $N3oW3.forwardRef($fd26d0ae16b13197$var$DoubleLeftOutlined);
var $fd26d0ae16b13197$export$2e2bcd8739ae039 = $fd26d0ae16b13197$var$RefIcon;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
// This icon file is generated automatically.
var $3aca83970402d7f5$var$DoubleRightOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M533.2 492.3L277.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H188c-6.7 0-10.4 7.7-6.3 12.9L447.1 512 181.7 851.1A7.98 7.98 0 00188 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5zm304 0L581.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H492c-6.7 0-10.4 7.7-6.3 12.9L751.1 512 485.7 851.1A7.98 7.98 0 00492 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5z"
                }
            }
        ]
    },
    "name": "double-right",
    "theme": "outlined"
};
var $3aca83970402d7f5$export$2e2bcd8739ae039 = $3aca83970402d7f5$var$DoubleRightOutlined;



function $54354c2895be849d$var$_extends() {
    $54354c2895be849d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $54354c2895be849d$var$_extends.apply(this, arguments);
}
const $54354c2895be849d$var$DoubleRightOutlined = (props, ref)=>/*#__PURE__*/ $hO8yS.createElement((0, $5fd6f3f3c400c267$export$2e2bcd8739ae039), $54354c2895be849d$var$_extends({}, props, {
        ref: ref,
        icon: (0, $3aca83970402d7f5$export$2e2bcd8739ae039)
    }));
/**![double-right](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUzMy4yIDQ5Mi4zTDI3Ny45IDE2Ni4xYy0zLTMuOS03LjctNi4xLTEyLjYtNi4xSDE4OGMtNi43IDAtMTAuNCA3LjctNi4zIDEyLjlMNDQ3LjEgNTEyIDE4MS43IDg1MS4xQTcuOTggNy45OCAwIDAwMTg4IDg2NGg3Ny4zYzQuOSAwIDkuNi0yLjMgMTIuNi02LjFsMjU1LjMtMzI2LjFjOS4xLTExLjcgOS4xLTI3LjkgMC0zOS41em0zMDQgMEw1ODEuOSAxNjYuMWMtMy0zLjktNy43LTYuMS0xMi42LTYuMUg0OTJjLTYuNyAwLTEwLjQgNy43LTYuMyAxMi45TDc1MS4xIDUxMiA0ODUuNyA4NTEuMUE3Ljk4IDcuOTggMCAwMDQ5MiA4NjRoNzcuM2M0LjkgMCA5LjYtMi4zIDEyLjYtNi4xbDI1NS4zLTMyNi4xYzkuMS0xMS43IDkuMS0yNy45IDAtMzkuNXoiIC8+PC9zdmc+) */ const $54354c2895be849d$var$RefIcon = /*#__PURE__*/ $N3oW3.forwardRef($54354c2895be849d$var$DoubleRightOutlined);
var $54354c2895be849d$export$2e2bcd8739ae039 = $54354c2895be849d$var$RefIcon;










var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
const $abc4340f04fa9b0a$var$locale = {
    // Options
    items_per_page: "\u6761/\u9875",
    jump_to: "\u8DF3\u81F3",
    jump_to_confirm: "\u786E\u5B9A",
    page: "\u9875",
    // Pagination
    prev_page: "\u4E0A\u4E00\u9875",
    next_page: "\u4E0B\u4E00\u9875",
    prev_5: "\u5411\u524D 5 \u9875",
    next_5: "\u5411\u540E 5 \u9875",
    prev_3: "\u5411\u524D 3 \u9875",
    next_3: "\u5411\u540E 3 \u9875",
    page_size: "\u9875\u7801"
};
var $abc4340f04fa9b0a$export$2e2bcd8739ae039 = $abc4340f04fa9b0a$var$locale;




var $N3oW3 = parcelRequire("N3oW3");
const $8f91bd50271d1c96$var$defaultPageSizeOptions = [
    10,
    20,
    50,
    100
];
const $8f91bd50271d1c96$var$Options = (props)=>{
    const { pageSizeOptions: pageSizeOptions = $8f91bd50271d1c96$var$defaultPageSizeOptions, locale: locale, changeSize: changeSize, pageSize: pageSize, goButton: goButton, quickGo: quickGo, rootPrefixCls: rootPrefixCls, disabled: disabled, buildOptionText: buildOptionText, showSizeChanger: showSizeChanger, sizeChangerRender: sizeChangerRender } = props;
    const [goInputText, setGoInputText] = (0, $N3oW3.default).useState('');
    const getValidValue = (0, $N3oW3.default).useMemo(()=>{
        return !goInputText || Number.isNaN(goInputText) ? undefined : Number(goInputText);
    }, [
        goInputText
    ]);
    const mergeBuildOptionText = typeof buildOptionText === 'function' ? buildOptionText : (value)=>`${value} ${locale.items_per_page}`;
    const handleChange = (e)=>{
        const value = e.target.value;
        if (/^\d*$/.test(value)) setGoInputText(value);
    };
    const handleBlur = (e)=>{
        if (goButton || goInputText === '') return;
        setGoInputText('');
        if (e.relatedTarget && (e.relatedTarget.className.includes(`${rootPrefixCls}-item-link`) || e.relatedTarget.className.includes(`${rootPrefixCls}-item`))) return;
        quickGo?.(getValidValue);
    };
    const go = (e)=>{
        if (goInputText === '') return;
        if (e.keyCode === (0, $4d7d870d585f8465$export$2e2bcd8739ae039).ENTER || e.type === 'click') {
            setGoInputText('');
            quickGo?.(getValidValue);
        }
    };
    const getPageSizeOptions = ()=>{
        if (pageSizeOptions.some((option)=>option.toString() === pageSize.toString())) return pageSizeOptions;
        return pageSizeOptions.concat([
            pageSize
        ]).sort((a, b)=>{
            const numberA = Number.isNaN(Number(a)) ? 0 : Number(a);
            const numberB = Number.isNaN(Number(b)) ? 0 : Number(b);
            return numberA - numberB;
        });
    };
    // ============== cls ==============
    const prefixCls = `${rootPrefixCls}-options`;
    // ============== render ==============
    if (!showSizeChanger && !quickGo) return null;
    let changeSelect = null;
    let goInput = null;
    let gotoButton = null;
    // >>>>> Size Changer
    if (showSizeChanger && sizeChangerRender) changeSelect = sizeChangerRender({
        disabled: disabled,
        size: pageSize,
        onSizeChange: (nextValue)=>{
            changeSize?.(Number(nextValue));
        },
        'aria-label': locale.page_size,
        className: `${prefixCls}-size-changer`,
        options: getPageSizeOptions().map((opt)=>({
                label: mergeBuildOptionText(opt),
                value: opt
            }))
    });
    // >>>>> Quick Go
    if (quickGo) {
        if (goButton) gotoButton = typeof goButton === 'boolean' ? /*#__PURE__*/ (0, $N3oW3.default).createElement("button", {
            type: "button",
            onClick: go,
            onKeyUp: go,
            disabled: disabled,
            className: `${prefixCls}-quick-jumper-button`
        }, locale.jump_to_confirm) : /*#__PURE__*/ (0, $N3oW3.default).createElement("span", {
            onClick: go,
            onKeyUp: go
        }, goButton);
        goInput = /*#__PURE__*/ (0, $N3oW3.default).createElement("div", {
            className: `${prefixCls}-quick-jumper`
        }, locale.jump_to, /*#__PURE__*/ (0, $N3oW3.default).createElement("input", {
            disabled: disabled,
            type: "text",
            value: goInputText,
            onChange: handleChange,
            onKeyUp: go,
            onBlur: handleBlur,
            "aria-label": locale.page
        }), locale.page, gotoButton);
    }
    return /*#__PURE__*/ (0, $N3oW3.default).createElement("li", {
        className: prefixCls
    }, changeSelect, goInput);
};
var $8f91bd50271d1c96$export$2e2bcd8739ae039 = $8f91bd50271d1c96$var$Options;


/* eslint react/prop-types: 0 */ 

var $N3oW3 = parcelRequire("N3oW3");
const $9b1866b682e149db$var$Pager = (props)=>{
    const { rootPrefixCls: rootPrefixCls, page: page, active: active, className: className, style: style, showTitle: showTitle, onClick: onClick, onKeyPress: onKeyPress, itemRender: itemRender } = props;
    const prefixCls = `${rootPrefixCls}-item`;
    const cls = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-${page}`, {
        [`${prefixCls}-active`]: active,
        [`${prefixCls}-disabled`]: !page
    }, className);
    const handleClick = ()=>{
        onClick(page);
    };
    const handleKeyPress = (e)=>{
        onKeyPress(e, onClick, page);
    };
    const pager = itemRender(page, 'page', /*#__PURE__*/ (0, $N3oW3.default).createElement("a", {
        rel: "nofollow"
    }, page));
    return pager ? /*#__PURE__*/ (0, $N3oW3.default).createElement("li", {
        title: showTitle ? String(page) : null,
        className: cls,
        style: style,
        onClick: handleClick,
        onKeyDown: handleKeyPress,
        tabIndex: 0
    }, pager) : null;
};
var $9b1866b682e149db$export$2e2bcd8739ae039 = $9b1866b682e149db$var$Pager;


function $109bb3292f61f545$var$_extends() {
    $109bb3292f61f545$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $109bb3292f61f545$var$_extends.apply(this, arguments);
}
const $109bb3292f61f545$var$defaultItemRender = (_, __, element)=>element;
function $109bb3292f61f545$var$noop() {}
function $109bb3292f61f545$var$isInteger(v) {
    const value = Number(v);
    return typeof value === 'number' && !Number.isNaN(value) && isFinite(value) && Math.floor(value) === value;
}
function $109bb3292f61f545$var$calculatePage(p, pageSize, total) {
    const _pageSize = typeof p === 'undefined' ? pageSize : p;
    return Math.floor((total - 1) / _pageSize) + 1;
}
const $109bb3292f61f545$var$Pagination = (props)=>{
    const { prefixCls: // cls
    prefixCls = 'rc-pagination', selectPrefixCls: selectPrefixCls = 'rc-select', className: className, classNames: paginationClassNames, styles: styles, // control
    current: currentProp, defaultCurrent: defaultCurrent = 1, total: total = 0, pageSize: pageSizeProp, defaultPageSize: defaultPageSize = 10, onChange: onChange = $109bb3292f61f545$var$noop, hideOnSinglePage: // config
    hideOnSinglePage, align: align, showPrevNextJumpers: showPrevNextJumpers = true, showQuickJumper: showQuickJumper, showLessItems: showLessItems, showTitle: showTitle = true, onShowSizeChange: onShowSizeChange = $109bb3292f61f545$var$noop, locale: locale = (0, $abc4340f04fa9b0a$export$2e2bcd8739ae039), style: style, totalBoundaryShowSizeChanger: totalBoundaryShowSizeChanger = 50, disabled: disabled, simple: simple, showTotal: showTotal, showSizeChanger: showSizeChanger = total > totalBoundaryShowSizeChanger, sizeChangerRender: sizeChangerRender, pageSizeOptions: pageSizeOptions, itemRender: // render
    itemRender = $109bb3292f61f545$var$defaultItemRender, jumpPrevIcon: jumpPrevIcon, jumpNextIcon: jumpNextIcon, prevIcon: prevIcon, nextIcon: nextIcon } = props;
    const paginationRef = (0, $N3oW3.default).useRef(null);
    const [pageSize, setPageSize] = (0, $05ea6e97cee440ee$export$2e2bcd8739ae039)(defaultPageSize, pageSizeProp);
    const [internalCurrent, setCurrent] = (0, $05ea6e97cee440ee$export$2e2bcd8739ae039)(defaultCurrent, currentProp);
    const current = Math.max(1, Math.min(internalCurrent, $109bb3292f61f545$var$calculatePage(undefined, pageSize, total)));
    const [internalInputVal, setInternalInputVal] = (0, $N3oW3.default).useState(current);
    (0, $32rMB.useEffect)(()=>{
        setInternalInputVal(current);
    }, [
        current
    ]);
    const hasOnChange = onChange !== $109bb3292f61f545$var$noop;
    const hasCurrent = 'current' in props;
    const jumpPrevPage = Math.max(1, current - (showLessItems ? 3 : 5));
    const jumpNextPage = Math.min($109bb3292f61f545$var$calculatePage(undefined, pageSize, total), current + (showLessItems ? 3 : 5));
    function getItemIcon(icon, label) {
        let iconNode = icon || /*#__PURE__*/ (0, $N3oW3.default).createElement("button", {
            type: "button",
            "aria-label": label,
            className: `${prefixCls}-item-link`
        });
        if (typeof icon === 'function') iconNode = /*#__PURE__*/ (0, $N3oW3.default).createElement(icon, props);
        return iconNode;
    }
    function getValidValue(e) {
        const inputValue = e.target.value;
        const allPages = $109bb3292f61f545$var$calculatePage(undefined, pageSize, total);
        let value;
        if (inputValue === '') value = inputValue;
        else if (Number.isNaN(Number(inputValue))) value = internalInputVal;
        else if (inputValue >= allPages) value = allPages;
        else value = Number(inputValue);
        return value;
    }
    function isValid(page) {
        return $109bb3292f61f545$var$isInteger(page) && page !== current && $109bb3292f61f545$var$isInteger(total) && total > 0;
    }
    const shouldDisplayQuickJumper = total > pageSize ? showQuickJumper : false;
    /**
   * prevent "up arrow" key reseting cursor position within textbox
   * @see https://stackoverflow.com/a/1081114
   */ function handleKeyDown(event) {
        if (event.keyCode === (0, $4d7d870d585f8465$export$2e2bcd8739ae039).UP || event.keyCode === (0, $4d7d870d585f8465$export$2e2bcd8739ae039).DOWN) event.preventDefault();
    }
    function handleKeyUp(event) {
        const value = getValidValue(event);
        if (value !== internalInputVal) setInternalInputVal(value);
        switch(event.keyCode){
            case (0, $4d7d870d585f8465$export$2e2bcd8739ae039).ENTER:
                handleChange(value);
                break;
            case (0, $4d7d870d585f8465$export$2e2bcd8739ae039).UP:
                handleChange(value - 1);
                break;
            case (0, $4d7d870d585f8465$export$2e2bcd8739ae039).DOWN:
                handleChange(value + 1);
                break;
            default:
                break;
        }
    }
    function handleBlur(event) {
        handleChange(getValidValue(event));
    }
    function changePageSize(size) {
        const newCurrent = $109bb3292f61f545$var$calculatePage(size, pageSize, total);
        const nextCurrent = current > newCurrent && newCurrent !== 0 ? newCurrent : current;
        setPageSize(size);
        setInternalInputVal(nextCurrent);
        onShowSizeChange?.(current, size);
        setCurrent(nextCurrent);
        onChange?.(nextCurrent, size);
    }
    function handleChange(page) {
        if (isValid(page) && !disabled) {
            const currentPage = $109bb3292f61f545$var$calculatePage(undefined, pageSize, total);
            let newPage = page;
            if (page > currentPage) newPage = currentPage;
            else if (page < 1) newPage = 1;
            if (newPage !== internalInputVal) setInternalInputVal(newPage);
            setCurrent(newPage);
            onChange?.(newPage, pageSize);
            return newPage;
        }
        return current;
    }
    const hasPrev = current > 1;
    const hasNext = current < $109bb3292f61f545$var$calculatePage(undefined, pageSize, total);
    function prevHandle() {
        if (hasPrev) handleChange(current - 1);
    }
    function nextHandle() {
        if (hasNext) handleChange(current + 1);
    }
    function jumpPrevHandle() {
        handleChange(jumpPrevPage);
    }
    function jumpNextHandle() {
        handleChange(jumpNextPage);
    }
    function runIfEnter(event, callback, ...restParams) {
        if (event.key === 'Enter' || event.charCode === (0, $4d7d870d585f8465$export$2e2bcd8739ae039).ENTER || event.keyCode === (0, $4d7d870d585f8465$export$2e2bcd8739ae039).ENTER) callback(...restParams);
    }
    function runIfEnterPrev(event) {
        runIfEnter(event, prevHandle);
    }
    function runIfEnterNext(event) {
        runIfEnter(event, nextHandle);
    }
    function runIfEnterJumpPrev(event) {
        runIfEnter(event, jumpPrevHandle);
    }
    function runIfEnterJumpNext(event) {
        runIfEnter(event, jumpNextHandle);
    }
    function renderPrev(prevPage) {
        const prevButton = itemRender(prevPage, 'prev', getItemIcon(prevIcon, 'prev page'));
        return /*#__PURE__*/ (0, $N3oW3.default).isValidElement(prevButton) ? /*#__PURE__*/ (0, $N3oW3.default).cloneElement(prevButton, {
            disabled: !hasPrev
        }) : prevButton;
    }
    function renderNext(nextPage) {
        const nextButton = itemRender(nextPage, 'next', getItemIcon(nextIcon, 'next page'));
        return /*#__PURE__*/ (0, $N3oW3.default).isValidElement(nextButton) ? /*#__PURE__*/ (0, $N3oW3.default).cloneElement(nextButton, {
            disabled: !hasNext
        }) : nextButton;
    }
    function handleGoTO(event) {
        if (event.type === 'click' || event.keyCode === (0, $4d7d870d585f8465$export$2e2bcd8739ae039).ENTER) handleChange(internalInputVal);
    }
    let jumpPrev = null;
    const dataOrAriaAttributeProps = (0, $b0f3dfd0eb3cad70$export$2e2bcd8739ae039)(props, {
        aria: true,
        data: true
    });
    const totalText = showTotal && /*#__PURE__*/ (0, $N3oW3.default).createElement("li", {
        className: `${prefixCls}-total-text`
    }, showTotal(total, [
        total === 0 ? 0 : (current - 1) * pageSize + 1,
        current * pageSize > total ? total : current * pageSize
    ]));
    let jumpNext = null;
    const allPages = $109bb3292f61f545$var$calculatePage(undefined, pageSize, total);
    // ================== Render ==================
    // When hideOnSinglePage is true and there is only 1 page, hide the pager
    if (hideOnSinglePage && total <= pageSize) return null;
    const pagerList = [];
    const pagerProps = {
        rootPrefixCls: prefixCls,
        onClick: handleChange,
        onKeyPress: runIfEnter,
        showTitle: showTitle,
        itemRender: itemRender,
        page: -1,
        className: paginationClassNames?.item,
        style: styles?.item
    };
    const prevPage = current - 1 > 0 ? current - 1 : 0;
    const nextPage = current + 1 < allPages ? current + 1 : allPages;
    const goButton = showQuickJumper && showQuickJumper.goButton;
    // ================== Simple ==================
    // FIXME: ts type
    const isReadOnly = typeof simple === 'object' ? simple.readOnly : !simple;
    let gotoButton = goButton;
    let simplePager = null;
    if (simple) {
        // ====== Simple quick jump ======
        if (goButton) {
            if (typeof goButton === 'boolean') gotoButton = /*#__PURE__*/ (0, $N3oW3.default).createElement("button", {
                type: "button",
                onClick: handleGoTO,
                onKeyUp: handleGoTO
            }, locale.jump_to_confirm);
            else gotoButton = /*#__PURE__*/ (0, $N3oW3.default).createElement("span", {
                onClick: handleGoTO,
                onKeyUp: handleGoTO
            }, goButton);
            gotoButton = /*#__PURE__*/ (0, $N3oW3.default).createElement("li", {
                title: showTitle ? `${locale.jump_to}${current}/${allPages}` : null,
                className: `${prefixCls}-simple-pager`
            }, gotoButton);
        }
        simplePager = /*#__PURE__*/ (0, $N3oW3.default).createElement("li", {
            title: showTitle ? `${current}/${allPages}` : null,
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-simple-pager`, paginationClassNames?.item),
            style: styles?.item
        }, isReadOnly ? internalInputVal : /*#__PURE__*/ (0, $N3oW3.default).createElement("input", {
            type: "text",
            "aria-label": locale.jump_to,
            value: internalInputVal,
            disabled: disabled,
            onKeyDown: handleKeyDown,
            onKeyUp: handleKeyUp,
            onChange: handleKeyUp,
            onBlur: handleBlur,
            size: 3
        }), /*#__PURE__*/ (0, $N3oW3.default).createElement("span", {
            className: `${prefixCls}-slash`
        }, "/"), allPages);
    }
    // ====================== Normal ======================
    const pageBufferSize = showLessItems ? 1 : 2;
    if (allPages <= 3 + pageBufferSize * 2) {
        if (!allPages) pagerList.push(/*#__PURE__*/ (0, $N3oW3.default).createElement((0, $9b1866b682e149db$export$2e2bcd8739ae039), $109bb3292f61f545$var$_extends({}, pagerProps, {
            key: "noPager",
            page: 1,
            className: `${prefixCls}-item-disabled`
        })));
        for(let i = 1; i <= allPages; i += 1)pagerList.push(/*#__PURE__*/ (0, $N3oW3.default).createElement((0, $9b1866b682e149db$export$2e2bcd8739ae039), $109bb3292f61f545$var$_extends({}, pagerProps, {
            key: i,
            page: i,
            active: current === i
        })));
    } else {
        const prevItemTitle = showLessItems ? locale.prev_3 : locale.prev_5;
        const nextItemTitle = showLessItems ? locale.next_3 : locale.next_5;
        const jumpPrevContent = itemRender(jumpPrevPage, 'jump-prev', getItemIcon(jumpPrevIcon, 'prev page'));
        const jumpNextContent = itemRender(jumpNextPage, 'jump-next', getItemIcon(jumpNextIcon, 'next page'));
        if (showPrevNextJumpers) {
            jumpPrev = jumpPrevContent ? /*#__PURE__*/ (0, $N3oW3.default).createElement("li", {
                title: showTitle ? prevItemTitle : null,
                key: "prev",
                onClick: jumpPrevHandle,
                tabIndex: 0,
                onKeyDown: runIfEnterJumpPrev,
                className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-jump-prev`, {
                    [`${prefixCls}-jump-prev-custom-icon`]: !!jumpPrevIcon
                })
            }, jumpPrevContent) : null;
            jumpNext = jumpNextContent ? /*#__PURE__*/ (0, $N3oW3.default).createElement("li", {
                title: showTitle ? nextItemTitle : null,
                key: "next",
                onClick: jumpNextHandle,
                tabIndex: 0,
                onKeyDown: runIfEnterJumpNext,
                className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-jump-next`, {
                    [`${prefixCls}-jump-next-custom-icon`]: !!jumpNextIcon
                })
            }, jumpNextContent) : null;
        }
        let left = Math.max(1, current - pageBufferSize);
        let right = Math.min(current + pageBufferSize, allPages);
        if (current - 1 <= pageBufferSize) right = 1 + pageBufferSize * 2;
        if (allPages - current <= pageBufferSize) left = allPages - pageBufferSize * 2;
        for(let i = left; i <= right; i += 1)pagerList.push(/*#__PURE__*/ (0, $N3oW3.default).createElement((0, $9b1866b682e149db$export$2e2bcd8739ae039), $109bb3292f61f545$var$_extends({}, pagerProps, {
            key: i,
            page: i,
            active: current === i
        })));
        if (current - 1 >= pageBufferSize * 2 && current !== 3) {
            pagerList[0] = /*#__PURE__*/ (0, $N3oW3.default).cloneElement(pagerList[0], {
                className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-item-after-jump-prev`, pagerList[0].props.className)
            });
            pagerList.unshift(jumpPrev);
        }
        if (allPages - current >= pageBufferSize * 2 && current !== allPages - 2) {
            const lastOne = pagerList[pagerList.length - 1];
            pagerList[pagerList.length - 1] = /*#__PURE__*/ (0, $N3oW3.default).cloneElement(lastOne, {
                className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-item-before-jump-next`, lastOne.props.className)
            });
            pagerList.push(jumpNext);
        }
        if (left !== 1) pagerList.unshift(/*#__PURE__*/ (0, $N3oW3.default).createElement((0, $9b1866b682e149db$export$2e2bcd8739ae039), $109bb3292f61f545$var$_extends({}, pagerProps, {
            key: 1,
            page: 1
        })));
        if (right !== allPages) pagerList.push(/*#__PURE__*/ (0, $N3oW3.default).createElement((0, $9b1866b682e149db$export$2e2bcd8739ae039), $109bb3292f61f545$var$_extends({}, pagerProps, {
            key: allPages,
            page: allPages
        })));
    }
    let prev = renderPrev(prevPage);
    if (prev) {
        const prevDisabled = !hasPrev || !allPages;
        prev = /*#__PURE__*/ (0, $N3oW3.default).createElement("li", {
            title: showTitle ? locale.prev_page : null,
            onClick: prevHandle,
            tabIndex: prevDisabled ? null : 0,
            onKeyDown: runIfEnterPrev,
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-prev`, paginationClassNames?.item, {
                [`${prefixCls}-disabled`]: prevDisabled
            }),
            style: styles?.item,
            "aria-disabled": prevDisabled
        }, prev);
    }
    let next = renderNext(nextPage);
    if (next) {
        let nextDisabled, nextTabIndex;
        if (simple) {
            nextDisabled = !hasNext;
            nextTabIndex = hasPrev ? 0 : null;
        } else {
            nextDisabled = !hasNext || !allPages;
            nextTabIndex = nextDisabled ? null : 0;
        }
        next = /*#__PURE__*/ (0, $N3oW3.default).createElement("li", {
            title: showTitle ? locale.next_page : null,
            onClick: nextHandle,
            tabIndex: nextTabIndex,
            onKeyDown: runIfEnterNext,
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-next`, paginationClassNames?.item, {
                [`${prefixCls}-disabled`]: nextDisabled
            }),
            style: styles?.item,
            "aria-disabled": nextDisabled
        }, next);
    }
    const cls = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, className, {
        [`${prefixCls}-start`]: align === 'start',
        [`${prefixCls}-center`]: align === 'center',
        [`${prefixCls}-end`]: align === 'end',
        [`${prefixCls}-simple`]: simple,
        [`${prefixCls}-disabled`]: disabled
    });
    return /*#__PURE__*/ (0, $N3oW3.default).createElement("ul", $109bb3292f61f545$var$_extends({
        className: cls,
        style: style,
        ref: paginationRef
    }, dataOrAriaAttributeProps), totalText, prev, simple ? simplePager : pagerList, next, /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $8f91bd50271d1c96$export$2e2bcd8739ae039), {
        locale: locale,
        rootPrefixCls: prefixCls,
        disabled: disabled,
        selectPrefixCls: selectPrefixCls,
        changeSize: changePageSize,
        pageSize: pageSize,
        pageSizeOptions: pageSizeOptions,
        quickGo: shouldDisplayQuickJumper ? handleChange : null,
        goButton: gotoButton,
        showSizeChanger: showSizeChanger,
        sizeChangerRender: sizeChangerRender
    }));
};
var $109bb3292f61f545$export$2e2bcd8739ae039 = $109bb3292f61f545$var$Pagination;












parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
const $0feed1a0f16046f5$export$9ea6397a890aa3e5 = (prefixCls, displayValues, allowClear, clearIcon, disabled = false, mergedSearchValue, mode)=>{
    // Convert boolean to object first
    const allowClearConfig = (0, $32rMB.useMemo)(()=>{
        if (typeof allowClear === 'boolean') return {
            allowClear: allowClear
        };
        if (allowClear && typeof allowClear === 'object') return allowClear;
        return {
            allowClear: false
        };
    }, [
        allowClear
    ]);
    return (0, $32rMB.useMemo)(()=>{
        const mergedAllowClear = !disabled && allowClearConfig.allowClear !== false && (displayValues.length || mergedSearchValue) && !(mode === 'combobox' && mergedSearchValue === '');
        return {
            allowClear: mergedAllowClear,
            clearIcon: mergedAllowClear ? allowClearConfig.clearIcon || clearIcon || "\xd7" : null
        };
    }, [
        allowClearConfig,
        clearIcon,
        disabled,
        displayValues.length,
        mergedSearchValue,
        mode
    ]);
};


/**
 * BaseSelect provide some parsed data into context.
 * You can use this hooks to get them.
 */ parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");
const $833a74f06bbf1e22$export$8234047c0aea33cf = /*#__PURE__*/ $hO8yS.createContext(null);
function $833a74f06bbf1e22$export$2e2bcd8739ae039() {
    return $32rMB.useContext($833a74f06bbf1e22$export$8234047c0aea33cf);
}


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
function $6c16b54fbc459d24$export$2e2bcd8739ae039(duration = 250) {
    const lockRef = $32rMB.useRef(null);
    const timeoutRef = $32rMB.useRef(null);
    // Clean up
    $32rMB.useEffect(()=>()=>{
            window.clearTimeout(timeoutRef.current);
        }, []);
    function doLock(locked) {
        if (locked || lockRef.current === null) lockRef.current = locked;
        window.clearTimeout(timeoutRef.current);
        timeoutRef.current = window.setTimeout(()=>{
            lockRef.current = null;
        }, duration);
    }
    return [
        ()=>lockRef.current,
        doLock
    ];
}


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");

function $56be69502cd3a4f3$export$2e2bcd8739ae039(elements, open, triggerOpen, customizedTrigger) {
    const onGlobalMouseDown = (0, $ea93068db096b7d6$export$2e2bcd8739ae039)((event)=>{
        // If trigger is customized, Trigger will take control of popupVisible
        if (customizedTrigger) return;
        let target = event.target;
        if (target.shadowRoot && event.composed) target = event.composedPath()[0] || target;
        if (open && // Marked by SelectInput mouseDown event
        !event._ignore_global_close && elements().filter((element)=>element).every((element)=>!element.contains(target) && element !== target)) // Should trigger close
        triggerOpen(false);
    });
    $32rMB.useEffect(()=>{
        window.addEventListener('mousedown', onGlobalMouseDown);
        return ()=>window.removeEventListener('mousedown', onGlobalMouseDown);
    }, [
        onGlobalMouseDown
    ]);
}




parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
function $b95e137023175793$var$_extends() {
    $b95e137023175793$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b95e137023175793$var$_extends.apply(this, arguments);
}
const $b95e137023175793$var$getBuiltInPlacements = (popupMatchSelectWidth)=>{
    // Enable horizontal overflow auto-adjustment when a custom dropdown width is provided
    const adjustX = popupMatchSelectWidth === true ? 0 : 1;
    return {
        bottomLeft: {
            points: [
                'tl',
                'bl'
            ],
            offset: [
                0,
                4
            ],
            overflow: {
                adjustX: adjustX,
                adjustY: 1
            },
            htmlRegion: 'scroll'
        },
        bottomRight: {
            points: [
                'tr',
                'br'
            ],
            offset: [
                0,
                4
            ],
            overflow: {
                adjustX: adjustX,
                adjustY: 1
            },
            htmlRegion: 'scroll'
        },
        topLeft: {
            points: [
                'bl',
                'tl'
            ],
            offset: [
                0,
                -4
            ],
            overflow: {
                adjustX: adjustX,
                adjustY: 1
            },
            htmlRegion: 'scroll'
        },
        topRight: {
            points: [
                'br',
                'tr'
            ],
            offset: [
                0,
                -4
            ],
            overflow: {
                adjustX: adjustX,
                adjustY: 1
            },
            htmlRegion: 'scroll'
        }
    };
};
const $b95e137023175793$var$SelectTrigger = (props, ref)=>{
    const { prefixCls: prefixCls, disabled: disabled, visible: visible, children: children, popupElement: popupElement, animation: animation, transitionName: transitionName, popupStyle: popupStyle, popupClassName: popupClassName, direction: direction = 'ltr', placement: placement, builtinPlacements: builtinPlacements, popupMatchSelectWidth: popupMatchSelectWidth, popupRender: popupRender, popupAlign: popupAlign, getPopupContainer: getPopupContainer, empty: empty, onPopupVisibleChange: onPopupVisibleChange, onPopupMouseEnter: onPopupMouseEnter, onPopupMouseDown: onPopupMouseDown, ...restProps } = props;
    // We still use `dropdown` className to keep compatibility
    // This is used for:
    // 1. Styles
    // 2. Animation
    // 3. Theme customization
    // Please do not modify this since it's a breaking change
    const popupPrefixCls = `${prefixCls}-dropdown`;
    let popupNode = popupElement;
    if (popupRender) popupNode = popupRender(popupElement);
    const mergedBuiltinPlacements = $32rMB.useMemo(()=>builtinPlacements || $b95e137023175793$var$getBuiltInPlacements(popupMatchSelectWidth), [
        builtinPlacements,
        popupMatchSelectWidth
    ]);
    // ===================== Motion ======================
    const mergedTransitionName = animation ? `${popupPrefixCls}-${animation}` : transitionName;
    // =================== Popup Width ===================
    const isNumberPopupWidth = typeof popupMatchSelectWidth === 'number';
    const stretch = $32rMB.useMemo(()=>{
        if (isNumberPopupWidth) return null;
        return popupMatchSelectWidth === false ? 'minWidth' : 'width';
    }, [
        popupMatchSelectWidth,
        isNumberPopupWidth
    ]);
    let mergedPopupStyle = popupStyle;
    if (isNumberPopupWidth) mergedPopupStyle = {
        ...popupStyle,
        width: popupMatchSelectWidth
    };
    // ======================= Ref =======================
    const triggerPopupRef = $32rMB.useRef(null);
    $32rMB.useImperativeHandle(ref, ()=>({
            getPopupElement: ()=>triggerPopupRef.current?.popupElement
        }));
    return /*#__PURE__*/ $hO8yS.createElement((0, $0cc98d0cfc01331c$export$2e2bcd8739ae039), $b95e137023175793$var$_extends({}, restProps, {
        showAction: onPopupVisibleChange ? [
            'click'
        ] : [],
        hideAction: onPopupVisibleChange ? [
            'click'
        ] : [],
        popupPlacement: placement || (direction === 'rtl' ? 'bottomRight' : 'bottomLeft'),
        builtinPlacements: mergedBuiltinPlacements,
        prefixCls: popupPrefixCls,
        popupMotion: {
            motionName: mergedTransitionName
        },
        popup: /*#__PURE__*/ $hO8yS.createElement("div", {
            onMouseEnter: onPopupMouseEnter,
            onMouseDown: onPopupMouseDown
        }, popupNode),
        ref: triggerPopupRef,
        stretch: stretch,
        popupAlign: popupAlign,
        popupVisible: visible,
        getPopupContainer: getPopupContainer,
        popupClassName: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(popupClassName, {
            [`${popupPrefixCls}-empty`]: empty
        }),
        popupStyle: mergedPopupStyle,
        onPopupVisibleChange: onPopupVisibleChange
    }), children);
};
const $b95e137023175793$var$RefSelectTrigger = /*#__PURE__*/ $N3oW3.forwardRef($b95e137023175793$var$SelectTrigger);
var $b95e137023175793$export$2e2bcd8739ae039 = $b95e137023175793$var$RefSelectTrigger;



function $e7ac7cc1b1101312$var$getKey(data, index) {
    const { key: key } = data;
    let value;
    if ('value' in data) ({ value: value } = data);
    if (key !== null && key !== undefined) return key;
    if (value !== undefined) return value;
    return `rc-index-key-${index}`;
}
function $e7ac7cc1b1101312$export$be48fd776273e509(value) {
    return typeof value !== 'undefined' && !Number.isNaN(value);
}
function $e7ac7cc1b1101312$export$6c519d302dced239(fieldNames, childrenAsData) {
    const { label: label, value: value, options: options, groupLabel: groupLabel } = fieldNames || {};
    const mergedLabel = label || (childrenAsData ? 'children' : 'label');
    return {
        label: mergedLabel,
        value: value || 'value',
        options: options || 'options',
        groupLabel: groupLabel || mergedLabel
    };
}
function $e7ac7cc1b1101312$export$7baa7c13b358b002(options, { fieldNames: fieldNames, childrenAsData: childrenAsData } = {}) {
    const flattenList = [];
    const { label: fieldLabel, value: fieldValue, options: fieldOptions, groupLabel: groupLabel } = $e7ac7cc1b1101312$export$6c519d302dced239(fieldNames, false);
    function dig(list, isGroupOption) {
        if (!Array.isArray(list)) return;
        list.forEach((data)=>{
            if (isGroupOption || !(fieldOptions in data)) {
                const value = data[fieldValue];
                // Option
                flattenList.push({
                    key: $e7ac7cc1b1101312$var$getKey(data, flattenList.length),
                    groupOption: isGroupOption,
                    data: data,
                    label: data[fieldLabel],
                    value: value
                });
            } else {
                let grpLabel = data[groupLabel];
                if (grpLabel === undefined && childrenAsData) grpLabel = data.label;
                // Option Group
                flattenList.push({
                    key: $e7ac7cc1b1101312$var$getKey(data, flattenList.length),
                    group: true,
                    data: data,
                    label: grpLabel
                });
                dig(data[fieldOptions], true);
            }
        });
    }
    dig(options, false);
    return flattenList;
}
function $e7ac7cc1b1101312$export$d0b21b213c8c013c(option) {
    const newOption = {
        ...option
    };
    if (!('props' in newOption)) Object.defineProperty(newOption, 'props', {
        get () {
            (0, $6591254ed6bd1058$export$2e2bcd8739ae039)(false, 'Return type is option instead of Option instance. Please read value directly instead of reading from `props`.');
            return newOption;
        }
    });
    return newOption;
}
const $e7ac7cc1b1101312$export$a09ca2a89e052b14 = (text, tokens, end)=>{
    if (!tokens || !tokens.length) return null;
    let match = false;
    const separate = (str, [token, ...restTokens])=>{
        if (!token) return [
            str
        ];
        const list = str.split(token);
        match = match || list.length > 1;
        return list.reduce((prevList, unitStr)=>[
                ...prevList,
                ...separate(unitStr, restTokens)
            ], []).filter(Boolean);
    };
    const list = separate(text, tokens);
    if (match) return typeof end !== 'undefined' ? list.slice(0, end) : list;
    else return null;
};


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
function $db70f266b3bfef3f$export$2e2bcd8739ae039(props) {
    const { visible: visible, values: values } = props;
    if (!visible) return null;
    // Only cut part of values since it's a screen reader
    const MAX_COUNT = 50;
    return /*#__PURE__*/ $hO8yS.createElement("span", {
        "aria-live": "polite",
        style: {
            width: 0,
            height: 0,
            position: 'absolute',
            overflow: 'hidden',
            opacity: 0
        }
    }, `${values.slice(0, MAX_COUNT).map(({ label: label, value: value })=>[
            'number',
            'string'
        ].includes(typeof label) ? label : value).join(', ')}`, values.length > MAX_COUNT ? ', ...' : null);
}



parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
const $cb846f6ea1a96450$var$internalMacroTask = (fn)=>{
    const channel = new MessageChannel();
    channel.port1.onmessage = fn;
    channel.port2.postMessage(null);
};
const $cb846f6ea1a96450$export$f1309b2412c6fa89 = (fn, times = 1)=>{
    if (times <= 0) {
        fn();
        return;
    }
    $cb846f6ea1a96450$var$internalMacroTask(()=>{
        $cb846f6ea1a96450$export$f1309b2412c6fa89(fn, times - 1);
    });
};
function $cb846f6ea1a96450$export$2e2bcd8739ae039(propOpen, onOpen, postOpen) {
    // SSR not support Portal which means we need delay `open` for the first time render
    const [rendered, setRendered] = (0, $32rMB.useState)(false);
    (0, $32rMB.useEffect)(()=>{
        setRendered(true);
    }, []);
    const [stateOpen, internalSetOpen] = (0, $05ea6e97cee440ee$export$2e2bcd8739ae039)(false, propOpen);
    // During SSR, always return false for open state
    const ssrSafeOpen = rendered ? stateOpen : false;
    const mergedOpen = postOpen(ssrSafeOpen);
    const taskIdRef = (0, $32rMB.useRef)(0);
    const taskLockRef = (0, $32rMB.useRef)(false);
    const triggerEvent = (0, $ea93068db096b7d6$export$2e2bcd8739ae039)((nextOpen)=>{
        if (onOpen && mergedOpen !== nextOpen) onOpen(nextOpen);
        internalSetOpen(nextOpen);
    });
    const toggleOpen = (0, $ea93068db096b7d6$export$2e2bcd8739ae039)((nextOpen, config = {})=>{
        const { ignoreNext: ignoreNext = false } = config;
        taskIdRef.current += 1;
        const id = taskIdRef.current;
        const nextOpenVal = typeof nextOpen === 'boolean' ? nextOpen : !mergedOpen;
        // Since `mergedOpen` is post-processed, we need to check if the value really changed
        if (nextOpenVal) {
            if (!taskLockRef.current) {
                triggerEvent(nextOpenVal);
                // Lock if needed
                if (ignoreNext) {
                    taskLockRef.current = ignoreNext;
                    $cb846f6ea1a96450$export$f1309b2412c6fa89(()=>{
                        taskLockRef.current = false;
                    }, 2);
                }
            }
            return;
        }
        $cb846f6ea1a96450$export$f1309b2412c6fa89(()=>{
            if (id === taskIdRef.current && !taskLockRef.current) triggerEvent(nextOpenVal);
        });
    });
    return [
        mergedOpen,
        toggleOpen
    ];
}




var $N3oW3 = parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");
parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
function $24394b463923ccf0$export$2e2bcd8739ae039(props) {
    const { children: children, ...restProps } = props;
    if (!children) return null;
    return /*#__PURE__*/ $hO8yS.createElement("div", restProps, children);
}


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");

parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");


var $N3oW3 = parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");

parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");
const $d130c22252f43fc2$var$SelectInputContext = /*#__PURE__*/ $hO8yS.createContext(null);
function $d130c22252f43fc2$export$7785dec5a5aec756() {
    return $32rMB.useContext($d130c22252f43fc2$var$SelectInputContext);
}
var $d130c22252f43fc2$export$2e2bcd8739ae039 = $d130c22252f43fc2$var$SelectInputContext;





const $639756f72da3c861$var$Input = /*#__PURE__*/ $N3oW3.forwardRef((props, ref)=>{
    const { onChange: onChange, onKeyDown: onKeyDown, onBlur: onBlur, style: style, syncWidth: syncWidth, value: value, className: className, autoComplete: autoComplete, ...restProps } = props;
    const { prefixCls: prefixCls, mode: mode, onSearch: onSearch, onSearchSubmit: onSearchSubmit, onInputBlur: onInputBlur, autoFocus: autoFocus, tokenWithEnter: tokenWithEnter, placeholder: placeholder, components: { input: InputComponent = 'input' } } = (0, $d130c22252f43fc2$export$7785dec5a5aec756)();
    const { id: id, classNames: classNames, styles: styles, open: open, activeDescendantId: activeDescendantId, role: role, disabled: disabled } = (0, $833a74f06bbf1e22$export$2e2bcd8739ae039)() || {};
    const inputCls = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-input`, classNames?.input, className);
    // Used to handle input method composition status
    const compositionStatusRef = $32rMB.useRef(false);
    // Used to handle paste content, similar to original Selector implementation
    const pastedTextRef = $32rMB.useRef(null);
    // ============================== Refs ==============================
    const inputRef = $32rMB.useRef(null);
    $32rMB.useImperativeHandle(ref, ()=>inputRef.current);
    // ============================== Data ==============================
    // Handle input changes
    const handleChange = (event)=>{
        let { value: nextVal } = event.target;
        // Handle pasted text with tokenWithEnter, similar to original Selector implementation
        if (tokenWithEnter && pastedTextRef.current && /[\r\n]/.test(pastedTextRef.current)) {
            // CRLF will be treated as a single space for input element
            const replacedText = pastedTextRef.current.replace(/[\r\n]+$/, '').replace(/\r\n/g, ' ').replace(/[\r\n]/g, ' ');
            nextVal = nextVal.replace(replacedText, pastedTextRef.current);
        }
        // Reset pasted text reference
        pastedTextRef.current = null;
        // Call onSearch callback
        if (onSearch) onSearch(nextVal, true, compositionStatusRef.current);
        // Call original onChange callback
        onChange?.(event);
    };
    // ============================ Keyboard ============================
    // Handle keyboard events
    const handleKeyDown = (event)=>{
        const { key: key } = event;
        const { value: nextVal } = event.currentTarget;
        // Handle Enter key submission - referencing Selector implementation
        if (key === 'Enter' && mode === 'tags' && !compositionStatusRef.current && onSearchSubmit) onSearchSubmit(nextVal);
        // Call original onKeyDown callback
        onKeyDown?.(event);
    };
    // Handle blur events
    const handleBlur = (event)=>{
        // Call onInputBlur callback
        onInputBlur?.();
        // Call original onBlur callback
        onBlur?.(event);
    };
    // Handle input method composition start
    const handleCompositionStart = ()=>{
        compositionStatusRef.current = true;
    };
    // Handle input method composition end
    const handleCompositionEnd = (event)=>{
        compositionStatusRef.current = false;
        // Trigger search when input method composition ends, similar to original Selector
        if (mode !== 'combobox') {
            const { value: nextVal } = event.currentTarget;
            onSearch?.(nextVal, true, false);
        }
    };
    // Handle paste events to track pasted content
    const handlePaste = (event)=>{
        const { clipboardData: clipboardData } = event;
        const pastedValue = clipboardData?.getData('text');
        pastedTextRef.current = pastedValue || '';
    };
    // ============================= Width ==============================
    const [widthCssVar, setWidthCssVar] = $32rMB.useState(undefined);
    // When syncWidth is enabled, adjust input width based on content
    (0, $60cea2402df671e7$export$2e2bcd8739ae039)(()=>{
        const input = inputRef.current;
        if (syncWidth && input) {
            input.style.width = '0px';
            const scrollWidth = input.scrollWidth;
            setWidthCssVar(scrollWidth);
            // Reset input style
            input.style.width = '';
        }
    }, [
        syncWidth,
        value
    ]);
    // ============================= Render =============================
    // Extract shared input props
    const sharedInputProps = {
        id: id,
        type: mode === 'combobox' ? 'text' : 'search',
        ...restProps,
        ref: inputRef,
        style: {
            ...styles?.input,
            ...style,
            '--select-input-width': widthCssVar
        },
        autoFocus: autoFocus,
        autoComplete: autoComplete || 'off',
        className: inputCls,
        disabled: disabled,
        value: value || '',
        onChange: handleChange,
        onKeyDown: handleKeyDown,
        onBlur: handleBlur,
        onPaste: handlePaste,
        onCompositionStart: handleCompositionStart,
        onCompositionEnd: handleCompositionEnd,
        // Accessibility attributes
        role: role || 'combobox',
        'aria-expanded': open || false,
        'aria-haspopup': 'listbox',
        'aria-owns': `${id}_list`,
        'aria-autocomplete': 'list',
        'aria-controls': `${id}_list`,
        'aria-activedescendant': open ? activeDescendantId : undefined
    };
    // Handle different InputComponent types
    if (/*#__PURE__*/ $N3oW3.isValidElement(InputComponent)) {
        // If InputComponent is a ReactElement, use cloneElement with merged props
        const existingProps = InputComponent.props || {};
        // Start with shared props as base
        const mergedProps = {
            placeholder: props.placeholder || placeholder,
            ...sharedInputProps,
            ...existingProps
        };
        // Batch update function calls
        Object.keys(existingProps).forEach((key)=>{
            const existingValue = existingProps[key];
            if (typeof existingValue === 'function') // Merge event handlers
            mergedProps[key] = (...args)=>{
                existingValue(...args);
                sharedInputProps[key]?.(...args);
            };
        });
        // Update ref
        mergedProps.ref = (0, $2706ed817e87019d$export$ab452c34e8e05029)(InputComponent.ref, sharedInputProps.ref);
        return /*#__PURE__*/ $N3oW3.cloneElement(InputComponent, mergedProps);
    }
    // If InputComponent is a component type, render normally
    const Component = InputComponent;
    return /*#__PURE__*/ $hO8yS.createElement(Component, sharedInputProps);
});
var $639756f72da3c861$export$2e2bcd8739ae039 = $639756f72da3c861$var$Input;




parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");



function $7d0fe694a0047c52$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, placeholder: placeholder, displayValues: displayValues } = (0, $d130c22252f43fc2$export$7785dec5a5aec756)();
    const { classNames: classNames, styles: styles } = (0, $833a74f06bbf1e22$export$2e2bcd8739ae039)();
    const { show: show = true } = props;
    if (displayValues.length) return null;
    return /*#__PURE__*/ $hO8yS.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-placeholder`, classNames?.placeholder),
        style: {
            visibility: show ? 'visible' : 'hidden',
            ...styles?.placeholder
        }
    }, placeholder);
}


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
// Use any here since we do not get the type during compilation
/**
 * SelectContext is only used for Select. BaseSelect should not consume this context.
 */ const $1777a02474acbc2d$var$SelectContext = /*#__PURE__*/ $hO8yS.createContext(null);
var $1777a02474acbc2d$export$2e2bcd8739ae039 = $1777a02474acbc2d$var$SelectContext;


function $7a9d777f7ba88a29$export$45b10814cc054894(value) {
    if (Array.isArray(value)) return value;
    return value !== undefined ? [
        value
    ] : [];
}
const $7a9d777f7ba88a29$export$7383f122bf48ec30 = typeof window !== 'undefined' && window.document && window.document.documentElement;
const $7a9d777f7ba88a29$export$df7146797a248522 = $7a9d777f7ba88a29$export$7383f122bf48ec30;
function $7a9d777f7ba88a29$export$96bdbc84526f3739(value) {
    return value !== undefined && value !== null;
}
function $7a9d777f7ba88a29$export$9d186c3672bb89c6(value) {
    return !value && value !== 0;
}
function $7a9d777f7ba88a29$var$isTitleType(title) {
    return [
        'string',
        'number'
    ].includes(typeof title);
}
function $7a9d777f7ba88a29$export$70d1bf7729efff40(item) {
    let title = undefined;
    if (item) {
        if ($7a9d777f7ba88a29$var$isTitleType(item.title)) title = item.title.toString();
        else if ($7a9d777f7ba88a29$var$isTitleType(item.label)) title = item.label.toString();
    }
    return title;
}


function $852a55cba3e563e8$var$_extends() {
    $852a55cba3e563e8$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $852a55cba3e563e8$var$_extends.apply(this, arguments);
}
const $852a55cba3e563e8$var$SingleContent = /*#__PURE__*/ $N3oW3.forwardRef(({ inputProps: inputProps }, ref)=>{
    const { prefixCls: prefixCls, searchValue: searchValue, activeValue: activeValue, displayValues: displayValues, maxLength: maxLength, mode: mode } = (0, $d130c22252f43fc2$export$7785dec5a5aec756)();
    const { triggerOpen: triggerOpen, title: rootTitle, showSearch: showSearch, classNames: classNames, styles: styles } = (0, $833a74f06bbf1e22$export$2e2bcd8739ae039)();
    const selectContext = $32rMB.useContext((0, $1777a02474acbc2d$export$2e2bcd8739ae039));
    const [inputChanged, setInputChanged] = $32rMB.useState(false);
    const combobox = mode === 'combobox';
    const displayValue = displayValues[0];
    // Implement the same logic as the old SingleSelector
    const mergedSearchValue = $32rMB.useMemo(()=>{
        if (combobox && activeValue && !inputChanged && triggerOpen) return activeValue;
        return showSearch ? searchValue : '';
    }, [
        combobox,
        activeValue,
        inputChanged,
        triggerOpen,
        searchValue,
        showSearch
    ]);
    // Extract option props, excluding label and value, and handle className/style merging
    const optionProps = $32rMB.useMemo(()=>{
        let restProps = {
            className: `${prefixCls}-content-value`,
            style: {
                visibility: mergedSearchValue ? 'hidden' : 'visible'
            }
        };
        if (displayValue && selectContext?.flattenOptions) {
            const option = selectContext.flattenOptions.find((opt)=>opt.value === displayValue.value);
            if (option?.data) {
                const { label: label, value: value, className: className, style: style, key: key, ...rest } = option.data;
                restProps = {
                    ...restProps,
                    ...rest,
                    title: (0, $7a9d777f7ba88a29$export$70d1bf7729efff40)(option.data),
                    className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(restProps.className, className),
                    style: {
                        ...restProps.style,
                        ...style
                    }
                };
            }
        }
        if (displayValue && !restProps.title) restProps.title = (0, $7a9d777f7ba88a29$export$70d1bf7729efff40)(displayValue);
        if (rootTitle !== undefined) restProps.title = rootTitle;
        return restProps;
    }, [
        displayValue,
        selectContext?.flattenOptions,
        prefixCls,
        mergedSearchValue,
        rootTitle
    ]);
    $32rMB.useEffect(()=>{
        if (combobox) setInputChanged(false);
    }, [
        combobox,
        activeValue
    ]);
    return /*#__PURE__*/ $hO8yS.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-content`, classNames?.content),
        style: styles?.content
    }, displayValue ? /*#__PURE__*/ $hO8yS.createElement("div", optionProps, displayValue.label) : /*#__PURE__*/ $hO8yS.createElement((0, $7d0fe694a0047c52$export$2e2bcd8739ae039), {
        show: !mergedSearchValue
    }), /*#__PURE__*/ $hO8yS.createElement((0, $639756f72da3c861$export$2e2bcd8739ae039), $852a55cba3e563e8$var$_extends({
        ref: ref
    }, inputProps, {
        value: mergedSearchValue,
        maxLength: mode === 'combobox' ? maxLength : undefined,
        onChange: (e)=>{
            setInputChanged(true);
            inputProps.onChange?.(e);
        }
    })));
});
var $852a55cba3e563e8$export$2e2bcd8739ae039 = $852a55cba3e563e8$var$SingleContent;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");




parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");

/**
 * Small wrapper for Select icons (clear/arrow/etc.).
 * Prevents default mousedown to avoid blurring or caret moves, and
 * renders a custom icon or a fallback icon span.
 *
 * DOM structure:
 * <span className={className} ...>
 *   { icon || <span className={`${className}-icon`}>{children}</span> }
 * </span>
 */ const $9b34ad436bf0bd9a$var$TransBtn = (props)=>{
    const { className: className, style: style, customizeIcon: customizeIcon, customizeIconProps: customizeIconProps, children: children, onMouseDown: onMouseDown, onClick: onClick } = props;
    const icon = typeof customizeIcon === 'function' ? customizeIcon(customizeIconProps) : customizeIcon;
    return /*#__PURE__*/ $hO8yS.createElement("span", {
        className: className,
        onMouseDown: (event)=>{
            event.preventDefault();
            onMouseDown?.(event);
        },
        style: {
            userSelect: 'none',
            WebkitUserSelect: 'none',
            ...style
        },
        unselectable: "on",
        onClick: onClick,
        "aria-hidden": true
    }, icon !== undefined ? icon : /*#__PURE__*/ $hO8yS.createElement("span", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(className.split(/\s+/).map((cls)=>`${cls}-icon`))
    }, children));
};
var $9b34ad436bf0bd9a$export$2e2bcd8739ae039 = $9b34ad436bf0bd9a$var$TransBtn;





function $dcf4e7da04cdf348$var$_extends() {
    $dcf4e7da04cdf348$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $dcf4e7da04cdf348$var$_extends.apply(this, arguments);
}
function $dcf4e7da04cdf348$var$itemKey(value) {
    return value.key ?? value.value;
}
const $dcf4e7da04cdf348$var$onPreventMouseDown = (event)=>{
    event.preventDefault();
    event.stopPropagation();
};
var $dcf4e7da04cdf348$export$2e2bcd8739ae039 = /*#__PURE__*/ $N3oW3.forwardRef(function MultipleContent({ inputProps: inputProps }, ref) {
    const { prefixCls: prefixCls, displayValues: displayValues, searchValue: searchValue, mode: mode, onSelectorRemove: onSelectorRemove, removeIcon: removeIconFromContext } = (0, $d130c22252f43fc2$export$7785dec5a5aec756)();
    const { disabled: disabled, showSearch: showSearch, triggerOpen: triggerOpen, toggleOpen: toggleOpen, autoClearSearchValue: autoClearSearchValue, tagRender: tagRenderFromContext, maxTagPlaceholder: maxTagPlaceholderFromContext, maxTagTextLength: maxTagTextLength, maxTagCount: maxTagCount, classNames: classNames, styles: styles } = (0, $833a74f06bbf1e22$export$2e2bcd8739ae039)();
    const selectionItemPrefixCls = `${prefixCls}-selection-item`;
    // ===================== Search ======================
    // Apply autoClearSearchValue logic: when dropdown is closed and autoClearSearchValue is not false (default true), clear search value
    let computedSearchValue = searchValue;
    if (!triggerOpen && mode === 'multiple' && autoClearSearchValue !== false) computedSearchValue = '';
    const inputValue = showSearch ? computedSearchValue || '' : '';
    const inputEditable = showSearch && !disabled;
    // Props from context with safe defaults
    const removeIcon = removeIconFromContext ?? "\xd7";
    const maxTagPlaceholder = maxTagPlaceholderFromContext ?? ((omittedValues)=>`+ ${omittedValues.length} ...`);
    const tagRender = tagRenderFromContext;
    const onToggleOpen = (newOpen)=>{
        toggleOpen(newOpen);
    };
    const onRemove = (value)=>{
        onSelectorRemove?.(value);
    };
    // ======================== Item ========================
    // >>> Render Selector Node. Includes Item & Rest
    const defaultRenderSelector = (item, content, itemDisabled, closable, onClose)=>/*#__PURE__*/ $hO8yS.createElement("span", {
            title: (0, $7a9d777f7ba88a29$export$70d1bf7729efff40)(item),
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(selectionItemPrefixCls, {
                [`${selectionItemPrefixCls}-disabled`]: itemDisabled
            }, classNames?.item),
            style: styles?.item
        }, /*#__PURE__*/ $hO8yS.createElement("span", {
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${selectionItemPrefixCls}-content`, classNames?.itemContent),
            style: styles?.itemContent
        }, content), closable && /*#__PURE__*/ $hO8yS.createElement((0, $9b34ad436bf0bd9a$export$2e2bcd8739ae039), {
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${selectionItemPrefixCls}-remove`, classNames?.itemRemove),
            style: styles?.itemRemove,
            onMouseDown: $dcf4e7da04cdf348$var$onPreventMouseDown,
            onClick: onClose,
            customizeIcon: removeIcon
        }, "\xD7"));
    const customizeRenderSelector = (value, content, itemDisabled, closable, onClose, isMaxTag, info)=>{
        const onMouseDown = (e)=>{
            $dcf4e7da04cdf348$var$onPreventMouseDown(e);
            onToggleOpen(!triggerOpen);
        };
        return /*#__PURE__*/ $hO8yS.createElement("span", {
            onMouseDown: onMouseDown
        }, tagRender({
            label: content,
            value: value,
            index: info?.index,
            disabled: itemDisabled,
            closable: closable,
            onClose: onClose,
            isMaxTag: !!isMaxTag
        }));
    };
    // ====================== Overflow ======================
    const renderItem = (valueItem, info)=>{
        const { disabled: itemDisabled, label: label, value: value } = valueItem;
        const closable = !disabled && !itemDisabled;
        let displayLabel = label;
        if (typeof maxTagTextLength === 'number') {
            if (typeof label === 'string' || typeof label === 'number') {
                const strLabel = String(displayLabel);
                if (strLabel.length > maxTagTextLength) displayLabel = `${strLabel.slice(0, maxTagTextLength)}...`;
            }
        }
        const onClose = (event)=>{
            if (event) event.stopPropagation();
            onRemove(valueItem);
        };
        return typeof tagRender === 'function' ? customizeRenderSelector(value, displayLabel, itemDisabled, closable, onClose, undefined, info) : defaultRenderSelector(valueItem, displayLabel, itemDisabled, closable, onClose);
    };
    const renderRest = (omittedValues)=>{
        // https://github.com/ant-design/ant-design/issues/48930
        if (!displayValues.length) return null;
        const content = typeof maxTagPlaceholder === 'function' ? maxTagPlaceholder(omittedValues) : maxTagPlaceholder;
        return typeof tagRender === 'function' ? customizeRenderSelector(undefined, content, false, false, undefined, true) : defaultRenderSelector({
            title: content
        }, content, false);
    };
    // ======================= Render =======================
    return /*#__PURE__*/ $hO8yS.createElement((0, $12a6b9a6c34b9880$export$2e2bcd8739ae039), {
        prefixCls: `${prefixCls}-content`,
        className: classNames?.content,
        style: styles?.content,
        prefix: !displayValues.length && (!searchValue || !triggerOpen) ? /*#__PURE__*/ $hO8yS.createElement((0, $7d0fe694a0047c52$export$2e2bcd8739ae039), null) : null,
        data: displayValues,
        renderItem: renderItem,
        renderRest: renderRest,
        suffix: /*#__PURE__*/ $hO8yS.createElement((0, $639756f72da3c861$export$2e2bcd8739ae039), $dcf4e7da04cdf348$var$_extends({
            ref: ref,
            disabled: disabled,
            readOnly: !inputEditable
        }, inputProps, {
            value: inputValue || '',
            syncWidth: true
        })),
        itemKey: $dcf4e7da04cdf348$var$itemKey,
        maxCount: maxTagCount
    });
});




const $ba48c6104bcd9e7d$var$SelectContent = /*#__PURE__*/ $N3oW3.forwardRef(function SelectContent(_, ref) {
    const { multiple: multiple, onInputKeyDown: onInputKeyDown, tabIndex: tabIndex } = (0, $d130c22252f43fc2$export$7785dec5a5aec756)();
    const baseProps = (0, $833a74f06bbf1e22$export$2e2bcd8739ae039)();
    const { showSearch: showSearch } = baseProps;
    const ariaProps = (0, $b0f3dfd0eb3cad70$export$2e2bcd8739ae039)(baseProps, {
        aria: true
    });
    const sharedInputProps = {
        ...ariaProps,
        onKeyDown: onInputKeyDown,
        readOnly: !showSearch,
        tabIndex: tabIndex
    };
    if (multiple) return /*#__PURE__*/ $hO8yS.createElement((0, $dcf4e7da04cdf348$export$2e2bcd8739ae039), {
        ref: ref,
        inputProps: sharedInputProps
    });
    return /*#__PURE__*/ $hO8yS.createElement((0, $852a55cba3e563e8$export$2e2bcd8739ae039), {
        ref: ref,
        inputProps: sharedInputProps
    });
});
var $ba48c6104bcd9e7d$export$2e2bcd8739ae039 = $ba48c6104bcd9e7d$var$SelectContent;







function $0acadda773bfa847$export$48ac81d4a07c29c(currentKeyCode) {
    return(// Undefined for Edge bug:
    // https://github.com/ant-design/ant-design/issues/51292
    currentKeyCode && // Other keys
    ![
        // System function button
        (0, $4d7d870d585f8465$export$2e2bcd8739ae039).ESC,
        (0, $4d7d870d585f8465$export$2e2bcd8739ae039).SHIFT,
        (0, $4d7d870d585f8465$export$2e2bcd8739ae039).BACKSPACE,
        (0, $4d7d870d585f8465$export$2e2bcd8739ae039).TAB,
        (0, $4d7d870d585f8465$export$2e2bcd8739ae039).WIN_KEY,
        (0, $4d7d870d585f8465$export$2e2bcd8739ae039).ALT,
        (0, $4d7d870d585f8465$export$2e2bcd8739ae039).META,
        (0, $4d7d870d585f8465$export$2e2bcd8739ae039).WIN_KEY_RIGHT,
        (0, $4d7d870d585f8465$export$2e2bcd8739ae039).CTRL,
        (0, $4d7d870d585f8465$export$2e2bcd8739ae039).SEMICOLON,
        (0, $4d7d870d585f8465$export$2e2bcd8739ae039).EQUALS,
        (0, $4d7d870d585f8465$export$2e2bcd8739ae039).CAPS_LOCK,
        (0, $4d7d870d585f8465$export$2e2bcd8739ae039).CONTEXT_MENU,
        // Arrow keys - should not trigger open when navigating in input
        (0, $4d7d870d585f8465$export$2e2bcd8739ae039).UP,
        // KeyCode.DOWN,
        (0, $4d7d870d585f8465$export$2e2bcd8739ae039).LEFT,
        (0, $4d7d870d585f8465$export$2e2bcd8739ae039).RIGHT,
        // F1-F12
        (0, $4d7d870d585f8465$export$2e2bcd8739ae039).F1,
        (0, $4d7d870d585f8465$export$2e2bcd8739ae039).F2,
        (0, $4d7d870d585f8465$export$2e2bcd8739ae039).F3,
        (0, $4d7d870d585f8465$export$2e2bcd8739ae039).F4,
        (0, $4d7d870d585f8465$export$2e2bcd8739ae039).F5,
        (0, $4d7d870d585f8465$export$2e2bcd8739ae039).F6,
        (0, $4d7d870d585f8465$export$2e2bcd8739ae039).F7,
        (0, $4d7d870d585f8465$export$2e2bcd8739ae039).F8,
        (0, $4d7d870d585f8465$export$2e2bcd8739ae039).F9,
        (0, $4d7d870d585f8465$export$2e2bcd8739ae039).F10,
        (0, $4d7d870d585f8465$export$2e2bcd8739ae039).F11,
        (0, $4d7d870d585f8465$export$2e2bcd8739ae039).F12
    ].includes(currentKeyCode));
}






function $b73f9cba4cf15e2b$var$_extends() {
    $b73f9cba4cf15e2b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b73f9cba4cf15e2b$var$_extends.apply(this, arguments);
}
const $b73f9cba4cf15e2b$var$DEFAULT_OMIT_PROPS = [
    'value',
    'onChange',
    'removeIcon',
    'placeholder',
    'maxTagCount',
    'maxTagTextLength',
    'maxTagPlaceholder',
    'choiceTransitionName',
    'onInputKeyDown',
    'onPopupScroll',
    'tabIndex',
    'activeValue',
    'onSelectorRemove',
    'focused'
];
var $b73f9cba4cf15e2b$export$2e2bcd8739ae039 = /*#__PURE__*/ $N3oW3.forwardRef(function SelectInput(props, ref) {
    const { prefixCls: // Style
    prefixCls, className: className, style: style, prefix: // UI
    prefix, suffix: suffix, clearIcon: clearIcon, children: children, multiple: // Data
    multiple, displayValues: displayValues, placeholder: placeholder, mode: mode, searchValue: // Search
    searchValue, onSearch: onSearch, onSearchSubmit: onSearchSubmit, onInputBlur: onInputBlur, maxLength: // Input
    maxLength, autoFocus: autoFocus, onMouseDown: // Events
    onMouseDown, onBlur: onBlur, onClearMouseDown: onClearMouseDown, onInputKeyDown: onInputKeyDown, onSelectorRemove: onSelectorRemove, tokenWithEnter: // Token handling
    tokenWithEnter, components: // Components
    components, ...restProps } = props;
    const { triggerOpen: triggerOpen, toggleOpen: toggleOpen, showSearch: showSearch, disabled: disabled, loading: loading, classNames: classNames, styles: styles } = (0, $833a74f06bbf1e22$export$2e2bcd8739ae039)();
    const rootRef = $32rMB.useRef(null);
    const inputRef = $32rMB.useRef(null);
    // Handle keyboard events similar to original Selector
    const onInternalInputKeyDown = (0, $ea93068db096b7d6$export$2e2bcd8739ae039)((event)=>{
        const { which: which } = event;
        // Compatible with multiple lines in TextArea
        const isTextAreaElement = inputRef.current instanceof HTMLTextAreaElement;
        // Prevent default behavior for up/down arrows when dropdown is open
        if (!isTextAreaElement && triggerOpen && (which === (0, $4d7d870d585f8465$export$2e2bcd8739ae039).UP || which === (0, $4d7d870d585f8465$export$2e2bcd8739ae039).DOWN)) event.preventDefault();
        // Call the original onInputKeyDown callback
        if (onInputKeyDown) onInputKeyDown(event);
        // Move within the text box for TextArea
        if (isTextAreaElement && !triggerOpen && ~[
            (0, $4d7d870d585f8465$export$2e2bcd8739ae039).UP,
            (0, $4d7d870d585f8465$export$2e2bcd8739ae039).DOWN,
            (0, $4d7d870d585f8465$export$2e2bcd8739ae039).LEFT,
            (0, $4d7d870d585f8465$export$2e2bcd8739ae039).RIGHT
        ].indexOf(which)) return;
        // Open dropdown when a valid open key is pressed
        if ((0, $0acadda773bfa847$export$48ac81d4a07c29c)(which)) toggleOpen(true);
    });
    // ====================== Refs ======================
    $32rMB.useImperativeHandle(ref, ()=>{
        return {
            focus: (options)=>{
                // Focus the inner input if available, otherwise fall back to root div.
                (inputRef.current || rootRef.current).focus?.(options);
            },
            blur: ()=>{
                (inputRef.current || rootRef.current).blur?.();
            },
            nativeElement: rootRef.current
        };
    });
    // ====================== Open ======================
    const onInternalMouseDown = (0, $ea93068db096b7d6$export$2e2bcd8739ae039)((event)=>{
        if (!disabled) {
            // https://github.com/ant-design/ant-design/issues/56002
            // Tell `useSelectTriggerControl` to ignore this event
            // When icon is dynamic render, the parentNode will miss
            // so we need to mark the event directly
            event.nativeEvent._ignore_global_close = true;
            const inputDOM = (0, $c1d2a04d2d287797$export$9aa546fdc20ae5b3)(inputRef.current);
            if (inputDOM && event.target !== inputDOM && !inputDOM.contains(event.target)) event.preventDefault();
            // Check if we should prevent closing when clicking on selector
            // Don't close if: open && not multiple && (combobox mode || showSearch)
            const shouldPreventClose = triggerOpen && !multiple && (mode === 'combobox' || showSearch);
            if (!event.nativeEvent._select_lazy) {
                inputRef.current?.focus();
                // Only toggle open if we should not prevent close
                if (!shouldPreventClose) toggleOpen();
            } else if (triggerOpen) // Lazy should also close when click clear icon
            toggleOpen(false);
        }
        onMouseDown?.(event);
    });
    const onInternalBlur = (event)=>{
        (0, $cb846f6ea1a96450$export$f1309b2412c6fa89)(()=>{
            const inputNode = (0, $c1d2a04d2d287797$export$9aa546fdc20ae5b3)(inputRef.current);
            if (!inputNode || inputNode !== document.activeElement && !inputNode.contains(document.activeElement)) toggleOpen(false);
        });
        onBlur?.(event);
    };
    // =================== Components ===================
    const { root: RootComponent } = components;
    // ===================== Render =====================
    const domProps = (0, $f4cf9c2e27c0ac8d$export$2e2bcd8739ae039)(restProps, $b73f9cba4cf15e2b$var$DEFAULT_OMIT_PROPS);
    // Create context value with wrapped callbacks
    const contextValue = {
        ...props,
        onInputKeyDown: onInternalInputKeyDown
    };
    if (RootComponent) {
        if (/*#__PURE__*/ $N3oW3.isValidElement(RootComponent)) return /*#__PURE__*/ $N3oW3.cloneElement(RootComponent, {
            ...domProps,
            ref: (0, $2706ed817e87019d$export$ab452c34e8e05029)(RootComponent.ref, rootRef)
        });
        return /*#__PURE__*/ $hO8yS.createElement(RootComponent, $b73f9cba4cf15e2b$var$_extends({}, domProps, {
            ref: rootRef
        }));
    }
    return /*#__PURE__*/ $hO8yS.createElement((0, $d130c22252f43fc2$export$2e2bcd8739ae039).Provider, {
        value: contextValue
    }, /*#__PURE__*/ $hO8yS.createElement("div", $b73f9cba4cf15e2b$var$_extends({}, domProps, {
        // Style
        ref: rootRef,
        className: className,
        style: style,
        onMouseDown: onInternalMouseDown,
        onBlur: onInternalBlur
    }), /*#__PURE__*/ $hO8yS.createElement((0, $24394b463923ccf0$export$2e2bcd8739ae039), {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-prefix`, classNames?.prefix),
        style: styles?.prefix
    }, prefix), /*#__PURE__*/ $hO8yS.createElement((0, $ba48c6104bcd9e7d$export$2e2bcd8739ae039), {
        ref: inputRef
    }), /*#__PURE__*/ $hO8yS.createElement((0, $24394b463923ccf0$export$2e2bcd8739ae039), {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-suffix`, {
            [`${prefixCls}-suffix-loading`]: loading
        }, classNames?.suffix),
        style: styles?.suffix
    }, suffix), clearIcon && /*#__PURE__*/ $hO8yS.createElement((0, $24394b463923ccf0$export$2e2bcd8739ae039), {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-clear`, classNames?.clear),
        style: styles?.clear,
        onMouseDown: (e)=>{
            // Mark to tell not trigger open or focus
            e.nativeEvent._select_lazy = true;
            onClearMouseDown?.(e);
        }
    }, clearIcon), children));
});


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
function $9dc0f634dd139251$export$2e2bcd8739ae039(components, getInputElement, getRawInputElement) {
    return $32rMB.useMemo(()=>{
        let { root: root, input: input } = components || {};
        // root: getRawInputElement
        if (getRawInputElement) root = getRawInputElement();
        // input: getInputElement
        if (getInputElement) input = getInputElement();
        return {
            root: root,
            input: input
        };
    }, [
        components,
        getInputElement,
        getRawInputElement
    ]);
}


function $0bb7794112869c71$var$_extends() {
    $0bb7794112869c71$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0bb7794112869c71$var$_extends.apply(this, arguments);
}
const $0bb7794112869c71$export$7f654ad2a77ad2ac = (mode)=>mode === 'tags' || mode === 'multiple';
const $0bb7794112869c71$var$BaseSelect = /*#__PURE__*/ $N3oW3.forwardRef((props, ref)=>{
    const { id: id, prefixCls: prefixCls, className: className, styles: styles, classNames: classNames, showSearch: showSearch, tagRender: tagRender, showScrollBar: showScrollBar = 'optional', direction: direction, omitDomProps: omitDomProps, displayValues: // Value
    displayValues, onDisplayValuesChange: onDisplayValuesChange, emptyOptions: emptyOptions, notFoundContent: notFoundContent = 'Not Found', onClear: onClear, maxCount: maxCount, placeholder: placeholder, mode: // Mode
    mode, disabled: // Status
    disabled, loading: loading, getInputElement: // Customize Input
    getInputElement, getRawInputElement: getRawInputElement, open: // Open
    open, defaultOpen: defaultOpen, onPopupVisibleChange: onPopupVisibleChange, activeValue: // Active
    activeValue, onActiveValueChange: onActiveValueChange, activeDescendantId: activeDescendantId, searchValue: // Search
    searchValue, autoClearSearchValue: autoClearSearchValue, onSearch: onSearch, onSearchSplit: onSearchSplit, tokenSeparators: tokenSeparators, allowClear: // Icons
    allowClear, prefix: prefix, suffix: suffix, suffixIcon: suffixIcon, clearIcon: clearIcon, OptionList: // Dropdown
    OptionList, animation: animation, transitionName: transitionName, popupStyle: popupStyle, popupClassName: popupClassName, popupMatchSelectWidth: popupMatchSelectWidth, popupRender: popupRender, popupAlign: popupAlign, placement: placement, builtinPlacements: builtinPlacements, getPopupContainer: getPopupContainer, showAction: // Focus
    showAction = [], onFocus: onFocus, onBlur: onBlur, onKeyUp: // Rest Events
    onKeyUp, onKeyDown: onKeyDown, onMouseDown: onMouseDown, components: // Components
    components, // Rest Props
    ...restProps } = props;
    // ============================== MISC ==============================
    const multiple = $0bb7794112869c71$export$7f654ad2a77ad2ac(mode);
    // ============================== Refs ==============================
    const containerRef = $32rMB.useRef(null);
    const triggerRef = $32rMB.useRef(null);
    const listRef = $32rMB.useRef(null);
    /** Used for component focused management */ const [focused, setFocused] = $32rMB.useState(false);
    // =========================== Imperative ===========================
    $32rMB.useImperativeHandle(ref, ()=>({
            focus: containerRef.current?.focus,
            blur: containerRef.current?.blur,
            scrollTo: (arg)=>listRef.current?.scrollTo(arg),
            nativeElement: (0, $c1d2a04d2d287797$export$9aa546fdc20ae5b3)(containerRef.current)
        }));
    // =========================== Components ===========================
    const mergedComponents = (0, $9dc0f634dd139251$export$2e2bcd8739ae039)(components, getInputElement, getRawInputElement);
    // ========================== Search Value ==========================
    const mergedSearchValue = $32rMB.useMemo(()=>{
        if (mode !== 'combobox') return searchValue;
        const val = displayValues[0]?.value;
        return typeof val === 'string' || typeof val === 'number' ? String(val) : '';
    }, [
        searchValue,
        mode,
        displayValues
    ]);
    // ========================== Custom Input ==========================
    // Only works in `combobox`
    const customizeInputElement = mode === 'combobox' && typeof getInputElement === 'function' && getInputElement() || null;
    // ============================== Open ==============================
    // Not trigger `open` when `notFoundContent` is empty
    const emptyListContent = !notFoundContent && emptyOptions;
    const [mergedOpen, triggerOpen] = (0, $cb846f6ea1a96450$export$2e2bcd8739ae039)(open, onPopupVisibleChange, (nextOpen)=>disabled || emptyListContent ? false : nextOpen);
    // ============================= Search =============================
    const tokenWithEnter = $32rMB.useMemo(()=>(tokenSeparators || []).some((tokenSeparator)=>[
                '\n',
                '\r\n'
            ].includes(tokenSeparator)), [
        tokenSeparators
    ]);
    const onInternalSearch = (searchText, fromTyping, isCompositing)=>{
        if (multiple && (0, $e7ac7cc1b1101312$export$be48fd776273e509)(maxCount) && displayValues.length >= maxCount) return;
        let ret = true;
        let newSearchText = searchText;
        onActiveValueChange?.(null);
        const separatedList = (0, $e7ac7cc1b1101312$export$a09ca2a89e052b14)(searchText, tokenSeparators, (0, $e7ac7cc1b1101312$export$be48fd776273e509)(maxCount) ? maxCount - displayValues.length : undefined);
        // Check if match the `tokenSeparators`
        const patchLabels = isCompositing ? null : separatedList;
        // Ignore combobox since it's not split-able
        if (mode !== 'combobox' && patchLabels) {
            newSearchText = '';
            onSearchSplit?.(patchLabels);
            // Should close when paste finish
            triggerOpen(false);
            // Tell Selector that break next actions
            ret = false;
        }
        if (onSearch && mergedSearchValue !== newSearchText) onSearch(newSearchText, {
            source: fromTyping ? 'typing' : 'effect'
        });
        // Open if from typing
        if (searchText && fromTyping && ret) triggerOpen(true);
        return ret;
    };
    // Only triggered when menu is closed & mode is tags
    // If menu is open, OptionList will take charge
    // If mode isn't tags, press enter is not meaningful when you can't see any option
    const onInternalSearchSubmit = (searchText)=>{
        // prevent empty tags from appearing when you click the Enter button
        if (!searchText || !searchText.trim()) return;
        onSearch(searchText, {
            source: 'submit'
        });
    };
    // Close will clean up single mode search text
    $32rMB.useEffect(()=>{
        if (!mergedOpen && !multiple && mode !== 'combobox') onInternalSearch('', false, false);
    }, [
        mergedOpen
    ]);
    // ============================ Disabled ============================
    // Close dropdown & remove focus state when disabled change
    $32rMB.useEffect(()=>{
        // After onBlur is triggered, the focused does not need to be reset
        if (disabled) {
            triggerOpen(false);
            setFocused(false);
        }
    }, [
        disabled,
        mergedOpen
    ]);
    // ============================ Keyboard ============================
    /**
   * We record input value here to check if can press to clean up by backspace
   * - null: Key is not down, this is reset by key up
   * - true: Search text is empty when first time backspace down
   * - false: Search text is not empty when first time backspace down
   */ const [getClearLock, setClearLock] = (0, $6c16b54fbc459d24$export$2e2bcd8739ae039)();
    const keyLockRef = $32rMB.useRef(false);
    // KeyDown
    const onInternalKeyDown = (event)=>{
        const clearLock = getClearLock();
        const { key: key } = event;
        const isEnterKey = key === 'Enter';
        if (isEnterKey) {
            // Do not submit form when type in the input
            if (mode !== 'combobox') event.preventDefault();
            // We only manage open state here, close logic should handle by list component
            if (!mergedOpen) triggerOpen(true);
        }
        setClearLock(!!mergedSearchValue);
        // Remove value by `backspace`
        if (key === 'Backspace' && !clearLock && multiple && !mergedSearchValue && displayValues.length) {
            const cloneDisplayValues = [
                ...displayValues
            ];
            let removedDisplayValue = null;
            for(let i = cloneDisplayValues.length - 1; i >= 0; i -= 1){
                const current = cloneDisplayValues[i];
                if (!current.disabled) {
                    cloneDisplayValues.splice(i, 1);
                    removedDisplayValue = current;
                    break;
                }
            }
            if (removedDisplayValue) onDisplayValuesChange(cloneDisplayValues, {
                type: 'remove',
                values: [
                    removedDisplayValue
                ]
            });
        }
        if (mergedOpen && (!isEnterKey || !keyLockRef.current)) {
            // Lock the Enter key after it is pressed to avoid repeated triggering of the onChange event.
            if (isEnterKey) keyLockRef.current = true;
            listRef.current?.onKeyDown(event);
        }
        onKeyDown?.(event);
    };
    // KeyUp
    const onInternalKeyUp = (event, ...rest)=>{
        if (mergedOpen) listRef.current?.onKeyUp(event, ...rest);
        if (event.key === 'Enter') keyLockRef.current = false;
        onKeyUp?.(event, ...rest);
    };
    // ============================ Selector ============================
    const onSelectorRemove = (0, $ea93068db096b7d6$export$2e2bcd8739ae039)((val)=>{
        const newValues = displayValues.filter((i)=>i !== val);
        onDisplayValuesChange(newValues, {
            type: 'remove',
            values: [
                val
            ]
        });
    });
    const onInputBlur = ()=>{
        // Unlock the Enter key after the input blur; otherwise, the Enter key needs to be pressed twice to trigger the correct effect.
        keyLockRef.current = false;
    };
    // ========================== Focus / Blur ==========================
    /** Record real focus status */ // const focusRef = React.useRef<boolean>(false);
    const onInternalFocus = (event)=>{
        setFocused(true);
        if (!disabled) {
            // `showAction` should handle `focus` if set
            if (showAction.includes('focus')) triggerOpen(true);
            onFocus?.(event);
        }
    };
    const onInternalBlur = (event)=>{
        setFocused(false);
        if (mergedSearchValue) {
            // `tags` mode should move `searchValue` into values
            if (mode === 'tags') onSearch(mergedSearchValue, {
                source: 'submit'
            });
            else if (mode === 'multiple') // `multiple` mode only clean the search value but not trigger event
            onSearch('', {
                source: 'blur'
            });
        }
        if (!disabled) onBlur?.(event);
    };
    const onInternalMouseDown = (event, ...restArgs)=>{
        const { target: target } = event;
        const popupElement = triggerRef.current?.getPopupElement();
        // We should give focus back to selector if clicked item is not focusable
        if (popupElement?.contains(target) && triggerOpen) // Tell `open` not to close since it's safe in the popup
        triggerOpen(true, {
            ignoreNext: true
        });
        onMouseDown?.(event, ...restArgs);
    };
    // ============================ Dropdown ============================
    const [, forceUpdate] = $32rMB.useState({});
    // We need force update here since popup dom is render async
    function onPopupMouseEnter() {
        forceUpdate({});
    }
    // Used for raw custom input trigger
    let onTriggerVisibleChange;
    if (!!mergedComponents.root) onTriggerVisibleChange = (newOpen)=>{
        triggerOpen(newOpen);
    };
    // Close when click on non-select element
    (0, $56be69502cd3a4f3$export$2e2bcd8739ae039)(()=>[
            (0, $c1d2a04d2d287797$export$9aa546fdc20ae5b3)(containerRef.current),
            triggerRef.current?.getPopupElement()
        ], mergedOpen, triggerOpen, !!mergedComponents.root);
    // ============================ Context =============================
    const baseSelectContext = $32rMB.useMemo(()=>({
            ...props,
            notFoundContent: notFoundContent,
            open: mergedOpen,
            triggerOpen: mergedOpen,
            id: id,
            showSearch: showSearch,
            multiple: multiple,
            toggleOpen: triggerOpen,
            showScrollBar: showScrollBar,
            styles: styles,
            classNames: classNames
        }), [
        props,
        notFoundContent,
        triggerOpen,
        id,
        showSearch,
        multiple,
        mergedOpen,
        showScrollBar,
        styles,
        classNames
    ]);
    // ==================================================================
    // ==                            Render                            ==
    // ==================================================================
    // ============================= Suffix =============================
    const mergedSuffixIcon = $32rMB.useMemo(()=>{
        const nextSuffix = suffix ?? suffixIcon;
        if (typeof nextSuffix === 'function') return nextSuffix({
            searchValue: mergedSearchValue,
            open: mergedOpen,
            focused: focused,
            showSearch: showSearch,
            loading: loading
        });
        return nextSuffix;
    }, [
        suffix,
        suffixIcon,
        mergedSearchValue,
        mergedOpen,
        focused,
        showSearch,
        loading
    ]);
    // ============================= Clear ==============================
    const onClearMouseDown = ()=>{
        onClear?.();
        containerRef.current?.focus();
        onDisplayValuesChange([], {
            type: 'clear',
            values: displayValues
        });
        onInternalSearch('', false, false);
    };
    const { allowClear: mergedAllowClear, clearIcon: clearNode } = (0, $0feed1a0f16046f5$export$9ea6397a890aa3e5)(prefixCls, displayValues, allowClear, clearIcon, disabled, mergedSearchValue, mode);
    // =========================== OptionList ===========================
    const optionList = /*#__PURE__*/ $hO8yS.createElement(OptionList, {
        ref: listRef
    });
    // ============================= Select =============================
    const mergedClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, className, {
        [`${prefixCls}-focused`]: focused,
        [`${prefixCls}-multiple`]: multiple,
        [`${prefixCls}-single`]: !multiple,
        [`${prefixCls}-allow-clear`]: mergedAllowClear,
        [`${prefixCls}-show-arrow`]: mergedSuffixIcon !== undefined && mergedSuffixIcon !== null,
        [`${prefixCls}-disabled`]: disabled,
        [`${prefixCls}-loading`]: loading,
        [`${prefixCls}-open`]: mergedOpen,
        [`${prefixCls}-customize-input`]: customizeInputElement,
        [`${prefixCls}-show-search`]: showSearch
    });
    // >>> Render
    let renderNode = /*#__PURE__*/ $hO8yS.createElement((0, $b73f9cba4cf15e2b$export$2e2bcd8739ae039), $0bb7794112869c71$var$_extends({}, restProps, {
        // Ref
        ref: containerRef,
        prefixCls: prefixCls,
        className: mergedClassName,
        focused: focused,
        prefix: prefix,
        suffix: mergedSuffixIcon,
        clearIcon: clearNode,
        multiple: multiple,
        mode: mode,
        displayValues: displayValues,
        placeholder: placeholder,
        searchValue: mergedSearchValue,
        activeValue: activeValue,
        onSearch: onInternalSearch,
        onSearchSubmit: onInternalSearchSubmit,
        onInputBlur: onInputBlur,
        onFocus: onInternalFocus,
        onBlur: onInternalBlur,
        onClearMouseDown: onClearMouseDown,
        onKeyDown: onInternalKeyDown,
        onKeyUp: onInternalKeyUp,
        onSelectorRemove: onSelectorRemove,
        tokenWithEnter: tokenWithEnter,
        onMouseDown: onInternalMouseDown,
        components: mergedComponents
    }));
    renderNode = /*#__PURE__*/ $hO8yS.createElement((0, $b95e137023175793$export$2e2bcd8739ae039), {
        ref: triggerRef,
        disabled: disabled,
        prefixCls: prefixCls,
        visible: mergedOpen,
        popupElement: optionList,
        animation: animation,
        transitionName: transitionName,
        popupStyle: popupStyle,
        popupClassName: popupClassName,
        direction: direction,
        popupMatchSelectWidth: popupMatchSelectWidth,
        popupRender: popupRender,
        popupAlign: popupAlign,
        placement: placement,
        builtinPlacements: builtinPlacements,
        getPopupContainer: getPopupContainer,
        empty: emptyOptions,
        onPopupVisibleChange: onTriggerVisibleChange,
        onPopupMouseEnter: onPopupMouseEnter,
        onPopupMouseDown: onInternalMouseDown
    }, renderNode);
    return /*#__PURE__*/ $hO8yS.createElement((0, $833a74f06bbf1e22$export$8234047c0aea33cf).Provider, {
        value: baseSelectContext
    }, /*#__PURE__*/ $hO8yS.createElement((0, $db70f266b3bfef3f$export$2e2bcd8739ae039), {
        visible: focused && !mergedOpen,
        values: displayValues
    }), renderNode);
});
var $0bb7794112869c71$export$2e2bcd8739ae039 = $0bb7794112869c71$var$BaseSelect;


/* istanbul ignore file */ /** This is a placeholder, not real render in dom */ const $9905763ec414f7ba$var$OptGroup = ()=>null;
$9905763ec414f7ba$var$OptGroup.isSelectOptGroup = true;
var $9905763ec414f7ba$export$2e2bcd8739ae039 = $9905763ec414f7ba$var$OptGroup;


/* istanbul ignore file */ /** This is a placeholder, not real render in dom */ const $020133878e2a85ed$var$Option = ()=>null;
$020133878e2a85ed$var$Option.isSelectOption = true;
var $020133878e2a85ed$export$2e2bcd8739ae039 = $020133878e2a85ed$var$Option;








parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");



/* istanbul ignore file */ function $4a058e3f468e7fbc$export$3bbcfec016973a77() {
    return /(mac\sos|macintosh)/i.test(navigator.appVersion);
}



function $e8f25867907b30dd$var$_extends() {
    $e8f25867907b30dd$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e8f25867907b30dd$var$_extends.apply(this, arguments);
}
// export interface OptionListProps<OptionsType extends object[]> {
function $e8f25867907b30dd$var$isTitleType(content) {
    return typeof content === 'string' || typeof content === 'number';
}
/**
 * Using virtual list of option display.
 * Will fallback to dom if use customize render.
 */ const $e8f25867907b30dd$var$OptionList = (_, ref)=>{
    const { prefixCls: prefixCls, id: id, open: open, multiple: multiple, mode: mode, searchValue: searchValue, toggleOpen: toggleOpen, notFoundContent: notFoundContent, onPopupScroll: onPopupScroll, showScrollBar: showScrollBar } = (0, $833a74f06bbf1e22$export$2e2bcd8739ae039)();
    const { maxCount: maxCount, flattenOptions: flattenOptions, onActiveValue: onActiveValue, defaultActiveFirstOption: defaultActiveFirstOption, onSelect: onSelect, menuItemSelectedIcon: menuItemSelectedIcon, rawValues: rawValues, fieldNames: fieldNames, virtual: virtual, direction: direction, listHeight: listHeight, listItemHeight: listItemHeight, optionRender: optionRender, classNames: contextClassNames, styles: contextStyles } = $32rMB.useContext((0, $1777a02474acbc2d$export$2e2bcd8739ae039));
    const itemPrefixCls = `${prefixCls}-item`;
    const memoFlattenOptions = (0, $7b0442ce5e42625c$export$2e2bcd8739ae039)(()=>flattenOptions, [
        open,
        flattenOptions
    ], (prev, next)=>next[0] && prev[1] !== next[1]);
    // =========================== List ===========================
    const listRef = $32rMB.useRef(null);
    const overMaxCount = $32rMB.useMemo(()=>multiple && (0, $e7ac7cc1b1101312$export$be48fd776273e509)(maxCount) && rawValues?.size >= maxCount, [
        multiple,
        maxCount,
        rawValues?.size
    ]);
    const onListMouseDown = (event)=>{
        event.preventDefault();
    };
    const scrollIntoView = (args)=>{
        listRef.current?.scrollTo(typeof args === 'number' ? {
            index: args
        } : args);
    };
    // https://github.com/ant-design/ant-design/issues/34975
    const isSelected = $32rMB.useCallback((value)=>{
        if (mode === 'combobox') return false;
        return rawValues.has(value);
    }, [
        mode,
        [
            ...rawValues
        ].toString(),
        rawValues.size
    ]);
    // ========================== Active ==========================
    const getEnabledActiveIndex = (index, offset = 1)=>{
        const len = memoFlattenOptions.length;
        for(let i = 0; i < len; i += 1){
            const current = (index + i * offset + len) % len;
            const { group: group, data: data } = memoFlattenOptions[current] || {};
            if (!group && !data?.disabled && (isSelected(data.value) || !overMaxCount)) return current;
        }
        return -1;
    };
    const [activeIndex, setActiveIndex] = $32rMB.useState(()=>getEnabledActiveIndex(0));
    const setActive = (index, fromKeyboard = false)=>{
        setActiveIndex(index);
        const info = {
            source: fromKeyboard ? 'keyboard' : 'mouse'
        };
        // Trigger active event
        const flattenItem = memoFlattenOptions[index];
        if (!flattenItem) {
            onActiveValue(null, -1, info);
            return;
        }
        onActiveValue(flattenItem.value, index, info);
    };
    // Auto active first item when list length or searchValue changed
    (0, $32rMB.useEffect)(()=>{
        setActive(defaultActiveFirstOption !== false ? getEnabledActiveIndex(0) : -1);
    }, [
        memoFlattenOptions.length,
        searchValue
    ]);
    // https://github.com/ant-design/ant-design/issues/48036
    const isAriaSelected = $32rMB.useCallback((value)=>{
        if (mode === 'combobox') return String(value).toLowerCase() === searchValue.toLowerCase();
        return rawValues.has(value);
    }, [
        mode,
        searchValue,
        [
            ...rawValues
        ].toString(),
        rawValues.size
    ]);
    // Auto scroll to item position in single mode
    (0, $32rMB.useEffect)(()=>{
        /**
     * React will skip `onChange` when component update.
     * `setActive` function will call root accessibility state update which makes re-render.
     * So we need to delay to let Input component trigger onChange first.
     */ let timeoutId;
        if (!multiple && open && rawValues.size === 1) {
            const value = Array.from(rawValues)[0];
            // Scroll to the option closest to the searchValue if searching.
            const index = memoFlattenOptions.findIndex(({ data: data })=>searchValue ? String(data.value).startsWith(searchValue) : data.value === value);
            if (index !== -1) {
                setActive(index);
                timeoutId = setTimeout(()=>{
                    scrollIntoView(index);
                });
            }
        }
        // Force trigger scrollbar visible when open
        if (open) listRef.current?.scrollTo(undefined);
        return ()=>clearTimeout(timeoutId);
    }, [
        open,
        searchValue
    ]);
    // ========================== Values ==========================
    const onSelectValue = (value)=>{
        if (value !== undefined) onSelect(value, {
            selected: !rawValues.has(value)
        });
        // Single mode should always close by select
        if (!multiple) toggleOpen(false);
    };
    // ========================= Keyboard =========================
    $32rMB.useImperativeHandle(ref, ()=>({
            onKeyDown: (event)=>{
                const { which: which, ctrlKey: ctrlKey } = event;
                switch(which){
                    // >>> Arrow keys & ctrl + n/p on Mac
                    case (0, $4d7d870d585f8465$export$2e2bcd8739ae039).N:
                    case (0, $4d7d870d585f8465$export$2e2bcd8739ae039).P:
                    case (0, $4d7d870d585f8465$export$2e2bcd8739ae039).UP:
                    case (0, $4d7d870d585f8465$export$2e2bcd8739ae039).DOWN:
                        {
                            let offset = 0;
                            if (which === (0, $4d7d870d585f8465$export$2e2bcd8739ae039).UP) offset = -1;
                            else if (which === (0, $4d7d870d585f8465$export$2e2bcd8739ae039).DOWN) offset = 1;
                            else if ((0, $4a058e3f468e7fbc$export$3bbcfec016973a77)() && ctrlKey) {
                                if (which === (0, $4d7d870d585f8465$export$2e2bcd8739ae039).N) offset = 1;
                                else if (which === (0, $4d7d870d585f8465$export$2e2bcd8739ae039).P) offset = -1;
                            }
                            if (offset !== 0) {
                                const nextActiveIndex = getEnabledActiveIndex(activeIndex + offset, offset);
                                scrollIntoView(nextActiveIndex);
                                setActive(nextActiveIndex, true);
                            }
                            break;
                        }
                    // >>> Select (Tab / Enter)
                    case (0, $4d7d870d585f8465$export$2e2bcd8739ae039).TAB:
                    case (0, $4d7d870d585f8465$export$2e2bcd8739ae039).ENTER:
                        {
                            // value
                            const item = memoFlattenOptions[activeIndex];
                            if (!item || item.data.disabled) return onSelectValue(undefined);
                            if (!overMaxCount || rawValues.has(item.value)) onSelectValue(item.value);
                            else onSelectValue(undefined);
                            if (open) event.preventDefault();
                            break;
                        }
                    // >>> Close
                    case (0, $4d7d870d585f8465$export$2e2bcd8739ae039).ESC:
                        toggleOpen(false);
                        if (open) event.stopPropagation();
                }
            },
            onKeyUp: ()=>{},
            scrollTo: (index)=>{
                scrollIntoView(index);
            }
        }));
    // ========================== Render ==========================
    if (memoFlattenOptions.length === 0) return /*#__PURE__*/ $hO8yS.createElement("div", {
        role: "listbox",
        id: `${id}_list`,
        className: `${itemPrefixCls}-empty`,
        onMouseDown: onListMouseDown
    }, notFoundContent);
    const omitFieldNameList = Object.keys(fieldNames).map((key)=>fieldNames[key]);
    const getLabel = (item)=>item.label;
    function getItemAriaProps(item, index) {
        const { group: group } = item;
        return {
            role: group ? 'presentation' : 'option',
            id: `${id}_list_${index}`
        };
    }
    const renderItem = (index)=>{
        const item = memoFlattenOptions[index];
        if (!item) return null;
        const itemData = item.data || {};
        const { value: value } = itemData;
        const { group: group } = item;
        const attrs = (0, $b0f3dfd0eb3cad70$export$2e2bcd8739ae039)(itemData, true);
        const mergedLabel = getLabel(item);
        return item ? /*#__PURE__*/ $hO8yS.createElement("div", $e8f25867907b30dd$var$_extends({
            "aria-label": typeof mergedLabel === 'string' && !group ? mergedLabel : null
        }, attrs, {
            key: index
        }, getItemAriaProps(item, index), {
            "aria-selected": isAriaSelected(value)
        }), value) : null;
    };
    const a11yProps = {
        role: 'listbox',
        id: `${id}_list`
    };
    return /*#__PURE__*/ $hO8yS.createElement($hO8yS.Fragment, null, virtual && /*#__PURE__*/ $hO8yS.createElement("div", $e8f25867907b30dd$var$_extends({}, a11yProps, {
        style: {
            height: 0,
            width: 0,
            overflow: 'hidden'
        }
    }), renderItem(activeIndex - 1), renderItem(activeIndex), renderItem(activeIndex + 1)), /*#__PURE__*/ $hO8yS.createElement((0, $7c54ff74bcae5103$export$2e2bcd8739ae039), {
        itemKey: "key",
        ref: listRef,
        data: memoFlattenOptions,
        height: listHeight,
        itemHeight: listItemHeight,
        fullHeight: false,
        onMouseDown: onListMouseDown,
        onScroll: onPopupScroll,
        virtual: virtual,
        direction: direction,
        innerProps: virtual ? null : a11yProps,
        showScrollBar: showScrollBar,
        className: contextClassNames?.popup?.list,
        style: contextStyles?.popup?.list
    }, (item, itemIndex)=>{
        const { group: group, groupOption: groupOption, data: data, label: label, value: value } = item;
        const { key: key } = data;
        // Group
        if (group) {
            const groupTitle = data.title ?? ($e8f25867907b30dd$var$isTitleType(label) ? label.toString() : undefined);
            return /*#__PURE__*/ $hO8yS.createElement("div", {
                className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(itemPrefixCls, `${itemPrefixCls}-group`, data.className),
                title: groupTitle
            }, label !== undefined ? label : key);
        }
        const { disabled: disabled, title: title, children: children, style: style, className: className, ...otherProps } = data;
        const passedProps = (0, $f4cf9c2e27c0ac8d$export$2e2bcd8739ae039)(otherProps, omitFieldNameList);
        // Option
        const selected = isSelected(value);
        const mergedDisabled = disabled || !selected && overMaxCount;
        const optionPrefixCls = `${itemPrefixCls}-option`;
        const optionClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(itemPrefixCls, optionPrefixCls, className, contextClassNames?.popup?.listItem, {
            [`${optionPrefixCls}-grouped`]: groupOption,
            [`${optionPrefixCls}-active`]: activeIndex === itemIndex && !mergedDisabled,
            [`${optionPrefixCls}-disabled`]: mergedDisabled,
            [`${optionPrefixCls}-selected`]: selected
        });
        const mergedLabel = getLabel(item);
        const iconVisible = !menuItemSelectedIcon || typeof menuItemSelectedIcon === 'function' || selected;
        // https://github.com/ant-design/ant-design/issues/34145
        const content = typeof mergedLabel === 'number' ? mergedLabel : mergedLabel || value;
        // https://github.com/ant-design/ant-design/issues/26717
        let optionTitle = $e8f25867907b30dd$var$isTitleType(content) ? content.toString() : undefined;
        if (title !== undefined) optionTitle = title;
        return /*#__PURE__*/ $hO8yS.createElement("div", $e8f25867907b30dd$var$_extends({}, (0, $b0f3dfd0eb3cad70$export$2e2bcd8739ae039)(passedProps), !virtual ? getItemAriaProps(item, itemIndex) : {}, {
            "aria-selected": virtual ? undefined : isAriaSelected(value),
            className: optionClassName,
            title: optionTitle,
            onMouseMove: ()=>{
                if (activeIndex === itemIndex || mergedDisabled) return;
                setActive(itemIndex);
            },
            onClick: ()=>{
                if (!mergedDisabled) onSelectValue(value);
            },
            style: {
                ...contextStyles?.popup?.listItem,
                ...style
            }
        }), /*#__PURE__*/ $hO8yS.createElement("div", {
            className: `${optionPrefixCls}-content`
        }, typeof optionRender === 'function' ? optionRender(item, {
            index: itemIndex
        }) : content), /*#__PURE__*/ $N3oW3.isValidElement(menuItemSelectedIcon) || selected, iconVisible && /*#__PURE__*/ $hO8yS.createElement((0, $9b34ad436bf0bd9a$export$2e2bcd8739ae039), {
            className: `${itemPrefixCls}-option-state`,
            customizeIcon: menuItemSelectedIcon,
            customizeIconProps: {
                value: value,
                disabled: mergedDisabled,
                isSelected: selected
            }
        }, selected ? "\u2713" : null));
    }));
};
const $e8f25867907b30dd$var$RefOptionList = /*#__PURE__*/ $N3oW3.forwardRef($e8f25867907b30dd$var$OptionList);
var $e8f25867907b30dd$export$2e2bcd8739ae039 = $e8f25867907b30dd$var$RefOptionList;



parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
var /**
 * Cache `value` related LabeledValue & options.
 */ $b37bae9f4c79e505$export$2e2bcd8739ae039 = (labeledValues, valueOptions)=>{
    const cacheRef = $32rMB.useRef({
        values: new Map(),
        options: new Map()
    });
    const filledLabeledValues = $32rMB.useMemo(()=>{
        const { values: prevValueCache, options: prevOptionCache } = cacheRef.current;
        // Fill label by cache
        const patchedValues = labeledValues.map((item)=>{
            if (item.label === undefined) return {
                ...item,
                label: prevValueCache.get(item.value)?.label
            };
            return item;
        });
        // Refresh cache
        const valueCache = new Map();
        const optionCache = new Map();
        patchedValues.forEach((item)=>{
            valueCache.set(item.value, item);
            optionCache.set(item.value, valueOptions.get(item.value) || prevOptionCache.get(item.value));
        });
        cacheRef.current.values = valueCache;
        cacheRef.current.options = optionCache;
        return patchedValues;
    }, [
        labeledValues,
        valueOptions
    ]);
    const getOption = $32rMB.useCallback((val)=>valueOptions.get(val) || cacheRef.current.options.get(val), [
        valueOptions
    ]);
    return [
        filledLabeledValues,
        getOption
    ];
};


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");


function $aff98c6a8bde0369$var$includes(test, search) {
    return (0, $7a9d777f7ba88a29$export$45b10814cc054894)(test).join('').toUpperCase().includes(search);
}
var $aff98c6a8bde0369$export$2e2bcd8739ae039 = (options, fieldNames, searchValue, filterOption, optionFilterProp)=>$32rMB.useMemo(()=>{
        if (!searchValue || filterOption === false) return options;
        const { options: fieldOptions, label: fieldLabel, value: fieldValue } = fieldNames;
        const filteredOptions = [];
        const customizeFilter = typeof filterOption === 'function';
        const upperSearch = searchValue.toUpperCase();
        const filterFunc = customizeFilter ? filterOption : (_, option)=>{
            // Use provided `optionFilterProp`
            if (optionFilterProp) return $aff98c6a8bde0369$var$includes(option[optionFilterProp], upperSearch);
            // Auto select `label` or `value` by option type
            if (option[fieldOptions]) // hack `fieldLabel` since `OptionGroup` children is not `label`
            return $aff98c6a8bde0369$var$includes(option[fieldLabel !== 'children' ? fieldLabel : 'label'], upperSearch);
            return $aff98c6a8bde0369$var$includes(option[fieldValue], upperSearch);
        };
        const wrapOption = customizeFilter ? (opt)=>(0, $e7ac7cc1b1101312$export$d0b21b213c8c013c)(opt) : (opt)=>opt;
        options.forEach((item)=>{
            // Group should check child options
            if (item[fieldOptions]) {
                // Check group first
                const matchGroup = filterFunc(searchValue, wrapOption(item));
                if (matchGroup) filteredOptions.push(item);
                else {
                    // Check option
                    const subOptions = item[fieldOptions].filter((subItem)=>filterFunc(searchValue, wrapOption(subItem)));
                    if (subOptions.length) filteredOptions.push({
                        ...item,
                        [fieldOptions]: subOptions
                    });
                }
                return;
            }
            if (filterFunc(searchValue, wrapOption(item))) filteredOptions.push(item);
        });
        return filteredOptions;
    }, [
        options,
        filterOption,
        optionFilterProp,
        searchValue,
        fieldNames
    ]);



parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");

var $N3oW3 = parcelRequire("N3oW3");

function $372f0f4504a2870d$var$convertNodeToOption(node) {
    const { key: key, props: { children: children, value: value, ...restProps } } = node;
    return {
        key: key,
        value: value !== undefined ? value : key,
        children: children,
        ...restProps
    };
}
function $372f0f4504a2870d$export$3beca35db74c3985(nodes, optionOnly = false) {
    return (0, $a60ede783f74e6a9$export$2e2bcd8739ae039)(nodes).map((node, index)=>{
        if (!/*#__PURE__*/ $N3oW3.isValidElement(node) || !node.type) return null;
        const { type: { isSelectOptGroup: isSelectOptGroup }, key: key, props: { children: children, ...restProps } } = node;
        if (optionOnly || !isSelectOptGroup) return $372f0f4504a2870d$var$convertNodeToOption(node);
        return {
            key: `__RC_SELECT_GRP__${key === null ? index : key}__`,
            label: key,
            ...restProps,
            options: $372f0f4504a2870d$export$3beca35db74c3985(children)
        };
    }).filter((data)=>data);
}


/**
 * Parse `children` to `options` if `options` is not provided.
 * Then flatten the `options`.
 */ const $889ff092bfad038b$var$useOptions = (options, children, fieldNames, optionFilterProp, optionLabelProp)=>{
    return $32rMB.useMemo(()=>{
        let mergedOptions = options;
        const childrenAsData = !options;
        if (childrenAsData) mergedOptions = (0, $372f0f4504a2870d$export$3beca35db74c3985)(children);
        const valueOptions = new Map();
        const labelOptions = new Map();
        const setLabelOptions = (labelOptionsMap, option, key)=>{
            if (key && typeof key === 'string') labelOptionsMap.set(option[key], option);
        };
        const dig = (optionList, isChildren = false)=>{
            // for loop to speed up collection speed
            for(let i = 0; i < optionList.length; i += 1){
                const option = optionList[i];
                if (!option[fieldNames.options] || isChildren) {
                    valueOptions.set(option[fieldNames.value], option);
                    setLabelOptions(labelOptions, option, fieldNames.label);
                    // https://github.com/ant-design/ant-design/issues/35304
                    setLabelOptions(labelOptions, option, optionFilterProp);
                    setLabelOptions(labelOptions, option, optionLabelProp);
                } else dig(option[fieldNames.options], true);
            }
        };
        dig(mergedOptions);
        return {
            options: mergedOptions,
            valueOptions: valueOptions,
            labelOptions: labelOptions
        };
    }, [
        options,
        children,
        fieldNames,
        optionFilterProp,
        optionLabelProp
    ]);
};
var $889ff092bfad038b$export$2e2bcd8739ae039 = $889ff092bfad038b$var$useOptions;


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
function $3954d16bb9c70609$export$2e2bcd8739ae039(callback) {
    const funcRef = $32rMB.useRef();
    funcRef.current = callback;
    const cacheFn = $32rMB.useCallback((...args)=>{
        return funcRef.current(...args);
    }, []);
    return cacheFn;
}







var $N3oW3 = parcelRequire("N3oW3");



function $6def215fd51b3c7c$var$warningProps(props) {
    const { mode: mode, options: options, children: children, backfill: backfill, allowClear: allowClear, placeholder: placeholder, getInputElement: getInputElement, showSearch: showSearch, onSearch: onSearch, defaultOpen: defaultOpen, autoFocus: autoFocus, labelInValue: labelInValue, value: value, optionLabelProp: optionLabelProp } = props;
    const multiple = (0, $0bb7794112869c71$export$7f654ad2a77ad2ac)(mode);
    const mergedShowSearch = showSearch !== undefined ? showSearch : multiple || mode === 'combobox';
    const mergedOptions = options || (0, $372f0f4504a2870d$export$3beca35db74c3985)(children);
    // `tags` should not set option as disabled
    (0, $6591254ed6bd1058$export$2e2bcd8739ae039)(mode !== 'tags' || mergedOptions.every((opt)=>!opt.disabled), 'Please avoid setting option to disabled in tags mode since user can always type text as tag.');
    // `combobox` & `tags` should option be `string` type
    if (mode === 'tags' || mode === 'combobox') {
        const hasNumberValue = mergedOptions.some((item)=>{
            if (item.options) return item.options.some((opt)=>typeof ('value' in opt ? opt.value : opt.key) === 'number');
            return typeof ('value' in item ? item.value : item.key) === 'number';
        });
        (0, $6591254ed6bd1058$export$2e2bcd8739ae039)(!hasNumberValue, '`value` of Option should not use number type when `mode` is `tags` or `combobox`.');
    }
    // `combobox` should not use `optionLabelProp`
    (0, $6591254ed6bd1058$export$2e2bcd8739ae039)(mode !== 'combobox' || !optionLabelProp, '`combobox` mode not support `optionLabelProp`. Please set `value` on Option directly.');
    // Only `combobox` support `backfill`
    (0, $6591254ed6bd1058$export$2e2bcd8739ae039)(mode === 'combobox' || !backfill, '`backfill` only works with `combobox` mode.');
    // Only `combobox` support `getInputElement`
    (0, $6591254ed6bd1058$export$2e2bcd8739ae039)(mode === 'combobox' || !getInputElement, '`getInputElement` only work with `combobox` mode.');
    // Customize `getInputElement` should not use `allowClear` & `placeholder`
    (0, $6591254ed6bd1058$export$89ff31684837bbbf)(mode !== 'combobox' || !getInputElement || !allowClear || !placeholder, 'Customize `getInputElement` should customize clear and placeholder logic instead of configuring `allowClear` and `placeholder`.');
    // `onSearch` should use in `combobox` or `showSearch`
    if (onSearch && !mergedShowSearch && mode !== 'combobox' && mode !== 'tags') (0, $6591254ed6bd1058$export$2e2bcd8739ae039)(false, '`onSearch` should work with `showSearch` instead of use alone.');
    (0, $6591254ed6bd1058$export$89ff31684837bbbf)(!defaultOpen || autoFocus, '`defaultOpen` makes Select open without focus which means it will not close by click outside. You can set `autoFocus` if needed.');
    if (value !== undefined && value !== null) {
        const values = (0, $7a9d777f7ba88a29$export$45b10814cc054894)(value);
        (0, $6591254ed6bd1058$export$2e2bcd8739ae039)(!labelInValue || values.every((val)=>typeof val === 'object' && ('key' in val || 'value' in val)), '`value` should in shape of `{ value: string | number, label?: ReactNode }` when you set `labelInValue` to `true`');
        (0, $6591254ed6bd1058$export$2e2bcd8739ae039)(!multiple || Array.isArray(value), '`value` should be array when `mode` is `multiple` or `tags`');
    }
    // Syntactic sugar should use correct children type
    if (children) {
        let invalidateChildType = null;
        (0, $a60ede783f74e6a9$export$2e2bcd8739ae039)(children).some((node)=>{
            if (!/*#__PURE__*/ $N3oW3.isValidElement(node) || !node.type) return false;
            const { type: type } = node;
            if (type.isSelectOption) return false;
            if (type.isSelectOptGroup) {
                const allChildrenValid = (0, $a60ede783f74e6a9$export$2e2bcd8739ae039)(node.props.children).every((subNode)=>{
                    if (!/*#__PURE__*/ $N3oW3.isValidElement(subNode) || !node.type || subNode.type.isSelectOption) return true;
                    invalidateChildType = subNode.type;
                    return false;
                });
                if (allChildrenValid) return false;
                return true;
            }
            invalidateChildType = type;
            return true;
        });
        if (invalidateChildType) (0, $6591254ed6bd1058$export$2e2bcd8739ae039)(false, `\`children\` should be \`Select.Option\` or \`Select.OptGroup\` instead of \`${invalidateChildType.displayName || invalidateChildType.name || invalidateChildType}\`.`);
    }
}
function $6def215fd51b3c7c$export$c33a1be4de1ec2c(options, fieldNames) {
    if (options) {
        const recursiveOptions = (optionsList, inGroup = false)=>{
            for(let i = 0; i < optionsList.length; i++){
                const option = optionsList[i];
                if (option[fieldNames?.value] === null) {
                    (0, $6591254ed6bd1058$export$2e2bcd8739ae039)(false, '`value` in Select options should not be `null`.');
                    return true;
                }
                if (!inGroup && Array.isArray(option[fieldNames?.options]) && recursiveOptions(option[fieldNames?.options], true)) break;
            }
        };
        recursiveOptions(options);
    }
}
var $6def215fd51b3c7c$export$2e2bcd8739ae039 = $6def215fd51b3c7c$var$warningProps;


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
function $696f6f6ed54616f6$export$2e2bcd8739ae039(showSearch, props, mode) {
    const { filterOption: filterOption, searchValue: searchValue, optionFilterProp: optionFilterProp, filterSort: filterSort, onSearch: onSearch, autoClearSearchValue: autoClearSearchValue } = props;
    return $32rMB.useMemo(()=>{
        const isObject = typeof showSearch === 'object';
        const searchConfig = {
            filterOption: filterOption,
            searchValue: searchValue,
            optionFilterProp: optionFilterProp,
            filterSort: filterSort,
            onSearch: onSearch,
            autoClearSearchValue: autoClearSearchValue,
            ...isObject ? showSearch : {}
        };
        return [
            isObject || mode === 'combobox' || mode === 'tags' || mode === 'multiple' && showSearch === undefined ? true : showSearch,
            searchConfig
        ];
    }, [
        mode,
        showSearch,
        filterOption,
        searchValue,
        optionFilterProp,
        filterSort,
        onSearch,
        autoClearSearchValue
    ]);
}


function $18a7f4c6bd95c19c$var$_extends() {
    $18a7f4c6bd95c19c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $18a7f4c6bd95c19c$var$_extends.apply(this, arguments);
}
const $18a7f4c6bd95c19c$var$OMIT_DOM_PROPS = [
    'inputValue'
];
function $18a7f4c6bd95c19c$var$isRawValue(value) {
    return !value || typeof value !== 'object';
}
const $18a7f4c6bd95c19c$var$Select = /*#__PURE__*/ $N3oW3.forwardRef((props, ref)=>{
    const { id: id, mode: mode, prefixCls: prefixCls = 'rc-select', backfill: backfill, fieldNames: fieldNames, showSearch: // Search
    showSearch, searchValue: legacySearchValue, onSearch: legacyOnSearch, autoClearSearchValue: legacyAutoClearSearchValue, filterOption: legacyFilterOption, optionFilterProp: legacyOptionFilterProp, filterSort: legacyFilterSort, onSelect: // Select
    onSelect, onDeselect: onDeselect, onActive: onActive, popupMatchSelectWidth: popupMatchSelectWidth = true, optionLabelProp: optionLabelProp, options: options, optionRender: optionRender, children: children, defaultActiveFirstOption: defaultActiveFirstOption, menuItemSelectedIcon: menuItemSelectedIcon, virtual: virtual, direction: direction, listHeight: listHeight = 200, listItemHeight: listItemHeight = 20, labelRender: labelRender, value: // Value
    value, defaultValue: defaultValue, labelInValue: labelInValue, onChange: onChange, maxCount: maxCount, classNames: classNames, styles: styles, ...restProps } = props;
    const searchProps = {
        searchValue: legacySearchValue,
        onSearch: legacyOnSearch,
        autoClearSearchValue: legacyAutoClearSearchValue,
        filterOption: legacyFilterOption,
        optionFilterProp: legacyOptionFilterProp,
        filterSort: legacyFilterSort
    };
    const [mergedShowSearch, searchConfig] = (0, $696f6f6ed54616f6$export$2e2bcd8739ae039)(showSearch, searchProps, mode);
    const { filterOption: filterOption, searchValue: searchValue, optionFilterProp: optionFilterProp, filterSort: filterSort, onSearch: onSearch, autoClearSearchValue: autoClearSearchValue = true } = searchConfig;
    const mergedId = (0, $32268c06752c3bab$export$2e2bcd8739ae039)(id);
    const multiple = (0, $0bb7794112869c71$export$7f654ad2a77ad2ac)(mode);
    const childrenAsData = !!(!options && children);
    const mergedFilterOption = $32rMB.useMemo(()=>{
        if (filterOption === undefined && mode === 'combobox') return false;
        return filterOption;
    }, [
        filterOption,
        mode
    ]);
    // ========================= FieldNames =========================
    const mergedFieldNames = $32rMB.useMemo(()=>(0, $e7ac7cc1b1101312$export$6c519d302dced239)(fieldNames, childrenAsData), /* eslint-disable react-hooks/exhaustive-deps */ [
        // We stringify fieldNames to avoid unnecessary re-renders.
        JSON.stringify(fieldNames),
        childrenAsData
    ]);
    // =========================== Search ===========================
    const [internalSearchValue, setSearchValue] = (0, $05ea6e97cee440ee$export$2e2bcd8739ae039)('', searchValue);
    const mergedSearchValue = internalSearchValue || '';
    // =========================== Option ===========================
    const parsedOptions = (0, $889ff092bfad038b$export$2e2bcd8739ae039)(options, children, mergedFieldNames, optionFilterProp, optionLabelProp);
    const { valueOptions: valueOptions, labelOptions: labelOptions, options: mergedOptions } = parsedOptions;
    // ========================= Wrap Value =========================
    const convert2LabelValues = $32rMB.useCallback((draftValues)=>{
        // Convert to array
        const valueList = (0, $7a9d777f7ba88a29$export$45b10814cc054894)(draftValues);
        // Convert to labelInValue type
        return valueList.map((val)=>{
            let rawValue;
            let rawLabel;
            let rawDisabled;
            let rawTitle;
            // Fill label & value
            if ($18a7f4c6bd95c19c$var$isRawValue(val)) rawValue = val;
            else {
                rawLabel = val.label;
                rawValue = val.value;
            }
            const option = valueOptions.get(rawValue);
            if (option) {
                // Fill missing props
                if (rawLabel === undefined) rawLabel = option?.[optionLabelProp || mergedFieldNames.label];
                rawDisabled = option?.disabled;
                rawTitle = option?.title;
            }
            return {
                label: rawLabel,
                value: rawValue,
                key: rawValue,
                disabled: rawDisabled,
                title: rawTitle
            };
        });
    }, [
        mergedFieldNames,
        optionLabelProp,
        valueOptions
    ]);
    // =========================== Values ===========================
    const [internalValue, setInternalValue] = (0, $05ea6e97cee440ee$export$2e2bcd8739ae039)(defaultValue, value);
    // Merged value with LabelValueType
    const rawLabeledValues = $32rMB.useMemo(()=>{
        const newInternalValue = multiple && internalValue === null ? [] : internalValue;
        const values = convert2LabelValues(newInternalValue);
        // combobox no need save value when it's no value (exclude value equal 0)
        if (mode === 'combobox' && (0, $7a9d777f7ba88a29$export$9d186c3672bb89c6)(values[0]?.value)) return [];
        return values;
    }, [
        internalValue,
        convert2LabelValues,
        mode,
        multiple
    ]);
    // Fill label with cache to avoid option remove
    const [mergedValues, getMixedOption] = (0, $b37bae9f4c79e505$export$2e2bcd8739ae039)(rawLabeledValues, valueOptions);
    const displayValues = $32rMB.useMemo(()=>{
        // `null` need show as placeholder instead
        // https://github.com/ant-design/ant-design/issues/25057
        if (!mode && mergedValues.length === 1) {
            const firstValue = mergedValues[0];
            if (firstValue.value === null && (firstValue.label === null || firstValue.label === undefined)) return [];
        }
        return mergedValues.map((item)=>({
                ...item,
                label: (typeof labelRender === 'function' ? labelRender(item) : item.label) ?? item.value
            }));
    }, [
        mode,
        mergedValues,
        labelRender
    ]);
    /** Convert `displayValues` to raw value type set */ const rawValues = $32rMB.useMemo(()=>new Set(mergedValues.map((val)=>val.value)), [
        mergedValues
    ]);
    $32rMB.useEffect(()=>{
        if (mode === 'combobox') {
            const strValue = mergedValues[0]?.value;
            setSearchValue((0, $7a9d777f7ba88a29$export$96bdbc84526f3739)(strValue) ? String(strValue) : '');
        }
    }, [
        mergedValues
    ]);
    // ======================= Display Option =======================
    // Create a placeholder item if not exist in `options`
    const createTagOption = (0, $3954d16bb9c70609$export$2e2bcd8739ae039)((val, label)=>{
        const mergedLabel = label ?? val;
        return {
            [mergedFieldNames.value]: val,
            [mergedFieldNames.label]: mergedLabel
        };
    });
    // Fill tag as option if mode is `tags`
    const filledTagOptions = $32rMB.useMemo(()=>{
        if (mode !== 'tags') return mergedOptions;
        // >>> Tag mode
        const cloneOptions = [
            ...mergedOptions
        ];
        // Check if value exist in options (include new patch item)
        const existOptions = (val)=>valueOptions.has(val);
        // Fill current value as option
        [
            ...mergedValues
        ].sort((a, b)=>a.value < b.value ? -1 : 1).forEach((item)=>{
            const val = item.value;
            if (!existOptions(val)) cloneOptions.push(createTagOption(val, item.label));
        });
        return cloneOptions;
    }, [
        createTagOption,
        mergedOptions,
        valueOptions,
        mergedValues,
        mode
    ]);
    const filteredOptions = (0, $aff98c6a8bde0369$export$2e2bcd8739ae039)(filledTagOptions, mergedFieldNames, mergedSearchValue, mergedFilterOption, optionFilterProp);
    // Fill options with search value if needed
    const filledSearchOptions = $32rMB.useMemo(()=>{
        if (mode !== 'tags' || !mergedSearchValue || filteredOptions.some((item)=>item[optionFilterProp || 'value'] === mergedSearchValue)) return filteredOptions;
        // ignore when search value equal select input value
        if (filteredOptions.some((item)=>item[mergedFieldNames.value] === mergedSearchValue)) return filteredOptions;
        // Fill search value as option
        return [
            createTagOption(mergedSearchValue),
            ...filteredOptions
        ];
    }, [
        createTagOption,
        optionFilterProp,
        mode,
        filteredOptions,
        mergedSearchValue,
        mergedFieldNames
    ]);
    const sorter = (inputOptions)=>{
        const sortedOptions = [
            ...inputOptions
        ].sort((a, b)=>filterSort(a, b, {
                searchValue: mergedSearchValue
            }));
        return sortedOptions.map((item)=>{
            if (Array.isArray(item.options)) return {
                ...item,
                options: item.options.length > 0 ? sorter(item.options) : item.options
            };
            return item;
        });
    };
    const orderedFilteredOptions = $32rMB.useMemo(()=>{
        if (!filterSort) return filledSearchOptions;
        return sorter(filledSearchOptions);
    }, [
        filledSearchOptions,
        filterSort,
        mergedSearchValue
    ]);
    const displayOptions = $32rMB.useMemo(()=>(0, $e7ac7cc1b1101312$export$7baa7c13b358b002)(orderedFilteredOptions, {
            fieldNames: mergedFieldNames,
            childrenAsData: childrenAsData
        }), [
        orderedFilteredOptions,
        mergedFieldNames,
        childrenAsData
    ]);
    // =========================== Change ===========================
    const triggerChange = (values)=>{
        const labeledValues = convert2LabelValues(values);
        setInternalValue(labeledValues);
        if (onChange && // Trigger event only when value changed
        (labeledValues.length !== mergedValues.length || labeledValues.some((newVal, index)=>mergedValues[index]?.value !== newVal?.value))) {
            const returnValues = labelInValue ? labeledValues.map(({ label: l, value: v })=>({
                    label: l,
                    value: v
                })) : labeledValues.map((v)=>v.value);
            const returnOptions = labeledValues.map((v)=>(0, $e7ac7cc1b1101312$export$d0b21b213c8c013c)(getMixedOption(v.value)));
            onChange(// Value
            multiple ? returnValues : returnValues[0], // Option
            multiple ? returnOptions : returnOptions[0]);
        }
    };
    // ======================= Accessibility ========================
    const [activeValue, setActiveValue] = $32rMB.useState(null);
    const [accessibilityIndex, setAccessibilityIndex] = $32rMB.useState(0);
    const mergedDefaultActiveFirstOption = defaultActiveFirstOption !== undefined ? defaultActiveFirstOption : mode !== 'combobox';
    const activeEventRef = $32rMB.useRef();
    const onActiveValue = $32rMB.useCallback((active, index, { source: source = 'keyboard' } = {})=>{
        setAccessibilityIndex(index);
        if (backfill && mode === 'combobox' && active !== null && source === 'keyboard') setActiveValue(String(active));
        // Active will call multiple times.
        // We only need trigger the last one.
        const promise = Promise.resolve().then(()=>{
            if (activeEventRef.current === promise) onActive?.(active);
        });
        activeEventRef.current = promise;
    }, [
        backfill,
        mode,
        onActive
    ]);
    // ========================= OptionList =========================
    const triggerSelect = (val, selected, type)=>{
        const getSelectEnt = ()=>{
            const option = getMixedOption(val);
            return [
                labelInValue ? {
                    label: option?.[mergedFieldNames.label],
                    value: val
                } : val,
                (0, $e7ac7cc1b1101312$export$d0b21b213c8c013c)(option)
            ];
        };
        if (selected && onSelect) {
            const [wrappedValue, option] = getSelectEnt();
            onSelect(wrappedValue, option);
        } else if (!selected && onDeselect && type !== 'clear') {
            const [wrappedValue, option] = getSelectEnt();
            onDeselect(wrappedValue, option);
        }
    };
    // Used for OptionList selection
    const onInternalSelect = (0, $3954d16bb9c70609$export$2e2bcd8739ae039)((val, info)=>{
        let cloneValues;
        // Single mode always trigger select only with option list
        const mergedSelect = multiple ? info.selected : true;
        if (mergedSelect) cloneValues = multiple ? [
            ...mergedValues,
            val
        ] : [
            val
        ];
        else cloneValues = mergedValues.filter((v)=>v.value !== val);
        triggerChange(cloneValues);
        triggerSelect(val, mergedSelect);
        // Clean search value if single or configured
        if (mode === 'combobox') setActiveValue('');
        else if (!(0, $0bb7794112869c71$export$7f654ad2a77ad2ac) || autoClearSearchValue) {
            setSearchValue('');
            setActiveValue('');
        }
    });
    // ======================= Display Change =======================
    // BaseSelect display values change
    const onDisplayValuesChange = (nextValues, info)=>{
        triggerChange(nextValues);
        const { type: type, values: values } = info;
        if (type === 'remove' || type === 'clear') values.forEach((item)=>{
            triggerSelect(item.value, false, type);
        });
    };
    // =========================== Search ===========================
    const onInternalSearch = (searchText, info)=>{
        setSearchValue(searchText);
        setActiveValue(null);
        // [Submit] Tag mode should flush input
        if (info.source === 'submit') {
            const formatted = (searchText || '').trim();
            // prevent empty tags from appearing when you click the Enter button
            if (formatted) {
                const newRawValues = Array.from(new Set([
                    ...rawValues,
                    formatted
                ]));
                triggerChange(newRawValues);
                triggerSelect(formatted, true);
                setSearchValue('');
            }
            return;
        }
        if (info.source !== 'blur') {
            if (mode === 'combobox') triggerChange(searchText);
            onSearch?.(searchText);
        }
    };
    const onInternalSearchSplit = (words)=>{
        let patchValues = words;
        if (mode !== 'tags') patchValues = words.map((word)=>{
            const opt = labelOptions.get(word);
            return opt?.value;
        }).filter((val)=>val !== undefined);
        const newRawValues = Array.from(new Set([
            ...rawValues,
            ...patchValues
        ]));
        triggerChange(newRawValues);
        newRawValues.forEach((newRawValue)=>{
            triggerSelect(newRawValue, true);
        });
    };
    // ========================== Context ===========================
    const selectContext = $32rMB.useMemo(()=>{
        const realVirtual = virtual !== false && popupMatchSelectWidth !== false;
        return {
            ...parsedOptions,
            flattenOptions: displayOptions,
            onActiveValue: onActiveValue,
            defaultActiveFirstOption: mergedDefaultActiveFirstOption,
            onSelect: onInternalSelect,
            menuItemSelectedIcon: menuItemSelectedIcon,
            rawValues: rawValues,
            fieldNames: mergedFieldNames,
            virtual: realVirtual,
            direction: direction,
            listHeight: listHeight,
            listItemHeight: listItemHeight,
            childrenAsData: childrenAsData,
            maxCount: maxCount,
            optionRender: optionRender,
            classNames: classNames,
            styles: styles
        };
    }, [
        maxCount,
        parsedOptions,
        displayOptions,
        onActiveValue,
        mergedDefaultActiveFirstOption,
        onInternalSelect,
        menuItemSelectedIcon,
        rawValues,
        mergedFieldNames,
        virtual,
        popupMatchSelectWidth,
        direction,
        listHeight,
        listItemHeight,
        childrenAsData,
        optionRender,
        classNames,
        styles
    ]);
    // ==============================================================
    // ==                          Render                          ==
    // ==============================================================
    return /*#__PURE__*/ $hO8yS.createElement((0, $1777a02474acbc2d$export$2e2bcd8739ae039).Provider, {
        value: selectContext
    }, /*#__PURE__*/ $hO8yS.createElement((0, $0bb7794112869c71$export$2e2bcd8739ae039), $18a7f4c6bd95c19c$var$_extends({}, restProps, {
        // >>> MISC
        id: mergedId,
        prefixCls: prefixCls,
        ref: ref,
        omitDomProps: $18a7f4c6bd95c19c$var$OMIT_DOM_PROPS,
        mode: mode,
        classNames: classNames,
        styles: styles,
        displayValues: displayValues,
        onDisplayValuesChange: onDisplayValuesChange,
        maxCount: maxCount,
        direction: direction,
        showSearch: mergedShowSearch,
        searchValue: mergedSearchValue,
        onSearch: onInternalSearch,
        autoClearSearchValue: autoClearSearchValue,
        onSearchSplit: onInternalSearchSplit,
        popupMatchSelectWidth: popupMatchSelectWidth,
        OptionList: (0, $e8f25867907b30dd$export$2e2bcd8739ae039),
        emptyOptions: !displayOptions.length,
        activeValue: activeValue,
        activeDescendantId: `${mergedId}_list_${accessibilityIndex}`
    })));
});
const $18a7f4c6bd95c19c$var$TypedSelect = $18a7f4c6bd95c19c$var$Select;
$18a7f4c6bd95c19c$var$TypedSelect.Option = (0, $020133878e2a85ed$export$2e2bcd8739ae039);
$18a7f4c6bd95c19c$var$TypedSelect.OptGroup = (0, $9905763ec414f7ba$export$2e2bcd8739ae039);
var $18a7f4c6bd95c19c$export$2e2bcd8739ae039 = $18a7f4c6bd95c19c$var$TypedSelect;






var $91e9538f306b5a78$export$2e2bcd8739ae039 = (0, $18a7f4c6bd95c19c$export$2e2bcd8739ae039);



















const $8e90042aa87cff17$var$getBuiltInPlacements = (popupOverflow)=>{
    const htmlRegion = popupOverflow === 'scroll' ? 'scroll' : 'visible';
    const sharedConfig = {
        overflow: {
            adjustX: true,
            adjustY: true,
            shiftY: true
        },
        htmlRegion: htmlRegion,
        dynamicInset: true
    };
    return {
        bottomLeft: {
            ...sharedConfig,
            points: [
                'tl',
                'bl'
            ],
            offset: [
                0,
                4
            ]
        },
        bottomRight: {
            ...sharedConfig,
            points: [
                'tr',
                'br'
            ],
            offset: [
                0,
                4
            ]
        },
        topLeft: {
            ...sharedConfig,
            points: [
                'bl',
                'tl'
            ],
            offset: [
                0,
                -4
            ]
        },
        topRight: {
            ...sharedConfig,
            points: [
                'br',
                'tr'
            ],
            offset: [
                0,
                -4
            ]
        }
    };
};
function $8e90042aa87cff17$var$mergedBuiltinPlacements(buildInPlacements, popupOverflow) {
    return buildInPlacements || $8e90042aa87cff17$var$getBuiltInPlacements(popupOverflow);
}
var $8e90042aa87cff17$export$2e2bcd8739ae039 = $8e90042aa87cff17$var$mergedBuiltinPlacements;







const $5f755ef86f8eeafd$var$genItemStyle = (token)=>{
    const { optionHeight: optionHeight, optionFontSize: optionFontSize, optionLineHeight: optionLineHeight, optionPadding: optionPadding } = token;
    return {
        position: 'relative',
        display: 'block',
        minHeight: optionHeight,
        padding: optionPadding,
        color: token.colorText,
        fontWeight: 'normal',
        fontSize: optionFontSize,
        lineHeight: optionLineHeight,
        boxSizing: 'border-box'
    };
};
const $5f755ef86f8eeafd$var$genSingleStyle = (token)=>{
    const { antCls: antCls, componentCls: componentCls } = token;
    const selectItemCls = `${componentCls}-item`;
    const slideUpEnterActive = `&${antCls}-slide-up-enter${antCls}-slide-up-enter-active`;
    const slideUpAppearActive = `&${antCls}-slide-up-appear${antCls}-slide-up-appear-active`;
    const slideUpLeaveActive = `&${antCls}-slide-up-leave${antCls}-slide-up-leave-active`;
    const dropdownPlacementCls = `${componentCls}-dropdown-placement-`;
    const selectedItemCls = `${selectItemCls}-option-selected`;
    return [
        {
            [`${componentCls}-dropdown`]: {
                // ========================== Popup ==========================
                ...(0, $2f353af2b0f7600b$export$23997c3e44cc1c59)(token),
                position: 'absolute',
                top: -9999,
                zIndex: token.zIndexPopup,
                boxSizing: 'border-box',
                padding: token.paddingXXS,
                overflow: 'hidden',
                fontSize: token.fontSize,
                // Fix select render lag of long text in chrome
                // https://github.com/ant-design/ant-design/issues/11456
                // https://github.com/ant-design/ant-design/issues/11843
                fontVariant: 'initial',
                backgroundColor: token.colorBgElevated,
                borderRadius: token.borderRadiusLG,
                outline: 'none',
                boxShadow: token.boxShadowSecondary,
                [`
          ${slideUpEnterActive}${dropdownPlacementCls}bottomLeft,
          ${slideUpAppearActive}${dropdownPlacementCls}bottomLeft
        `]: {
                    animationName: (0, $21a6ccba58224685$export$e801b802b037de6a)
                },
                [`
          ${slideUpEnterActive}${dropdownPlacementCls}topLeft,
          ${slideUpAppearActive}${dropdownPlacementCls}topLeft,
          ${slideUpEnterActive}${dropdownPlacementCls}topRight,
          ${slideUpAppearActive}${dropdownPlacementCls}topRight
        `]: {
                    animationName: (0, $21a6ccba58224685$export$dd9f089fa5e819fe)
                },
                [`${slideUpLeaveActive}${dropdownPlacementCls}bottomLeft`]: {
                    animationName: (0, $21a6ccba58224685$export$f40f41df328ebc38)
                },
                [`
          ${slideUpLeaveActive}${dropdownPlacementCls}topLeft,
          ${slideUpLeaveActive}${dropdownPlacementCls}topRight
        `]: {
                    animationName: (0, $21a6ccba58224685$export$f7243fdb9c27c3b7)
                },
                '&-hidden': {
                    display: 'none'
                },
                [selectItemCls]: {
                    ...$5f755ef86f8eeafd$var$genItemStyle(token),
                    cursor: 'pointer',
                    transition: `background ${token.motionDurationSlow} ease`,
                    borderRadius: token.borderRadiusSM,
                    // =========== Group ============
                    '&-group': {
                        color: token.colorTextDescription,
                        fontSize: token.fontSizeSM,
                        cursor: 'default'
                    },
                    // =========== Option ===========
                    '&-option': {
                        display: 'flex',
                        '&-content': {
                            flex: 'auto',
                            ...(0, $2f353af2b0f7600b$export$b2b65df0d0824629)
                        },
                        '&-state': {
                            flex: 'none',
                            display: 'flex',
                            alignItems: 'center'
                        },
                        [`&-active:not(${selectItemCls}-option-disabled)`]: {
                            backgroundColor: token.optionActiveBg
                        },
                        [`&-selected:not(${selectItemCls}-option-disabled)`]: {
                            color: token.optionSelectedColor,
                            fontWeight: token.optionSelectedFontWeight,
                            backgroundColor: token.optionSelectedBg,
                            [`${selectItemCls}-option-state`]: {
                                color: token.colorPrimary
                            }
                        },
                        '&-disabled': {
                            [`&${selectItemCls}-option-selected`]: {
                                backgroundColor: token.colorBgContainerDisabled
                            },
                            color: token.colorTextDisabled,
                            cursor: 'not-allowed'
                        },
                        '&-grouped': {
                            paddingInlineStart: token.calc(token.controlPaddingHorizontal).mul(2).equal()
                        }
                    },
                    '&-empty': {
                        ...$5f755ef86f8eeafd$var$genItemStyle(token),
                        color: token.colorTextDisabled
                    }
                },
                // https://github.com/ant-design/ant-design/pull/46646
                [`${selectedItemCls}:has(+ ${selectedItemCls})`]: {
                    borderEndStartRadius: 0,
                    borderEndEndRadius: 0,
                    [`& + ${selectedItemCls}`]: {
                        borderStartStartRadius: 0,
                        borderStartEndRadius: 0
                    }
                },
                // =========================== RTL ===========================
                '&-rtl': {
                    direction: 'rtl'
                }
            }
        },
        // Follow code may reuse in other components
        (0, $21a6ccba58224685$export$9018e60daecf7a6c)(token, 'slide-up'),
        (0, $21a6ccba58224685$export$9018e60daecf7a6c)(token, 'slide-down'),
        (0, $309d9b1280ac3808$export$913b1b7e3288c319)(token, 'move-up'),
        (0, $309d9b1280ac3808$export$913b1b7e3288c319)(token, 'move-down')
    ];
};
var $5f755ef86f8eeafd$export$2e2bcd8739ae039 = $5f755ef86f8eeafd$var$genSingleStyle;




const $42a1db86cd704d2d$var$genSelectInputCustomizeStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`&${componentCls}-customize`]: {
            border: 0,
            padding: 0,
            fontSize: 'inherit',
            lineHeight: 'inherit',
            [`${componentCls}-placeholder`]: {
                display: 'none'
            },
            [`${componentCls}-content`]: {
                margin: 0,
                padding: 0,
                '&-value': {
                    display: 'none'
                }
            }
        }
    };
};
var $42a1db86cd704d2d$export$2e2bcd8739ae039 = $42a1db86cd704d2d$var$genSelectInputCustomizeStyle;



const $598d8d9b43196ddd$var$FIXED_INPUT_MIN_WIDTH = 4;
const $598d8d9b43196ddd$var$genSelectInputMultipleStyle = (token)=>{
    const { componentCls: componentCls, calc: calc, iconCls: iconCls, paddingXS: paddingXS, paddingXXS: paddingXXS, INTERNAL_FIXED_ITEM_MARGIN: INTERNAL_FIXED_ITEM_MARGIN, lineWidth: lineWidth, colorIcon: colorIcon, colorIconHover: colorIconHover, inputPaddingHorizontalBase: inputPaddingHorizontalBase } = token;
    return {
        '&-multiple': {
            '--select-multi-item-background': token.multipleItemBg,
            '--select-multi-item-border-color': 'transparent',
            '--select-multi-item-border-radius': token.borderRadiusSM,
            '--select-multi-item-height': token.multipleItemHeight,
            '--select-multi-padding-base': `calc((var(--select-height) - var(--select-multi-item-height)) / 2)`,
            '--select-multi-padding-vertical': `calc(var(--select-multi-padding-base) - ${INTERNAL_FIXED_ITEM_MARGIN} - ${lineWidth})`,
            '--select-multi-item-padding-horizontal': `calc(${inputPaddingHorizontalBase} - var(--select-multi-padding-vertical) - ${lineWidth} * 2)`,
            // ========================================================
            // ==                        Base                        ==
            // ========================================================
            // ========================= Root =========================
            paddingBlock: `var(--select-multi-padding-vertical)`,
            paddingInlineStart: `calc(var(--select-multi-padding-base) - ${lineWidth})`,
            // ======================== Prefix ========================
            [`${componentCls}-prefix`]: {
                marginInlineStart: 'var(--select-multi-item-padding-horizontal)'
            },
            [`${componentCls}-prefix + ${componentCls}-content`]: {
                [`${componentCls}-placeholder`]: {
                    insetInlineStart: 0
                },
                [`${componentCls}-content-item${componentCls}-content-item-suffix`]: {
                    marginInlineStart: 0
                }
            },
            // ===================== Placeholder ======================
            [`${componentCls}-placeholder`]: {
                position: 'absolute',
                lineHeight: 'var(--select-line-height)',
                insetInlineStart: 'var(--select-multi-item-padding-horizontal)',
                width: 'calc(100% - var(--select-multi-item-padding-horizontal))',
                top: '50%',
                transform: 'translateY(-50%)'
            },
            // ======================= Content ========================
            [`${componentCls}-content`]: {
                flexWrap: 'wrap',
                alignItems: 'center',
                lineHeight: 1,
                '&-item-prefix': {
                    height: 'var(--select-font-size)'
                },
                '&-item': {
                    lineHeight: 1,
                    maxWidth: `calc(100% - ${$598d8d9b43196ddd$var$FIXED_INPUT_MIN_WIDTH}px)`
                },
                [`${componentCls}-content-item-prefix + ${componentCls}-content-item-suffix,
          ${componentCls}-content-item-suffix:first-child`]: {
                    marginInlineStart: 'var(--select-multi-item-padding-horizontal)'
                },
                [`${componentCls}-selection-item`]: {
                    lineHeight: `calc(var(--select-multi-item-height) - ${lineWidth} * 2)`,
                    border: `${lineWidth} solid var(--select-multi-item-border-color)`,
                    display: 'flex',
                    marginBlock: INTERNAL_FIXED_ITEM_MARGIN,
                    marginInlineEnd: calc(INTERNAL_FIXED_ITEM_MARGIN).mul(2).equal(),
                    background: `var(--select-multi-item-background)`,
                    borderRadius: `var(--select-multi-item-border-radius)`,
                    paddingInlineStart: paddingXS,
                    paddingInlineEnd: paddingXXS,
                    transition: [
                        'height',
                        'line-height',
                        'padding'
                    ].map((key)=>`${key} ${token.motionDurationSlow}`).join(','),
                    // >>> Content
                    '&-content': {
                        ...(0, $2f353af2b0f7600b$export$b2b65df0d0824629),
                        marginInlineEnd: paddingXXS
                    },
                    // >>> Remove
                    '&-remove': {
                        ...(0, $2f353af2b0f7600b$export$171ccda7bc085e59)(),
                        display: 'inline-flex',
                        alignItems: 'center',
                        color: colorIcon,
                        fontWeight: 'bold',
                        fontSize: 10,
                        lineHeight: 'inherit',
                        cursor: 'pointer',
                        [`> ${iconCls}`]: {
                            verticalAlign: '-0.2em'
                        },
                        '&:hover': {
                            color: colorIconHover
                        }
                    }
                },
                [`${componentCls}-input`]: {
                    lineHeight: calc(INTERNAL_FIXED_ITEM_MARGIN).mul(2).add('var(--select-multi-item-height)').equal(),
                    width: 'calc(var(--select-input-width, 0) * 1px)',
                    minWidth: $598d8d9b43196ddd$var$FIXED_INPUT_MIN_WIDTH,
                    maxWidth: '100%',
                    transition: `line-height ${token.motionDurationSlow}`
                }
            },
            // ========================================================
            // ==                        Size                        ==
            // ========================================================
            [`&${componentCls}-sm`]: {
                '--select-multi-item-height': token.multipleItemHeightSM,
                '--select-multi-item-border-radius': token.borderRadiusXS
            },
            [`&${componentCls}-lg`]: {
                '--select-multi-item-height': token.multipleItemHeightLG,
                '--select-multi-item-border-radius': token.borderRadius
            },
            // ========================================================
            // ==                      Variants                      ==
            // ========================================================
            [`&${componentCls}-filled`]: {
                '--select-multi-item-border-color': token.colorSplit,
                '--select-multi-item-background': token.colorBgContainer,
                [`&${componentCls}-disabled`]: {
                    '--select-multi-item-border-color': 'transparent'
                }
            }
        }
    };
};
var $598d8d9b43196ddd$export$2e2bcd8739ae039 = $598d8d9b43196ddd$var$genSelectInputMultipleStyle;


/** Set CSS variables and hover/focus styles for a Select input based on provided colors. */ const $ee0af94af62d4f0f$var$genSelectInputVariableStyle = (token, colors)=>{
    const { componentCls: componentCls } = token;
    const { border: border, borderHover: borderHover, borderActive: borderActive, borderOutline: borderOutline } = colors;
    const baseBG = colors.background || token.colorBgContainer;
    return {
        '--select-border-color': border,
        '--select-background': baseBG,
        '--select-color': colors.color || token.colorText,
        [`&:not(${componentCls}-disabled)`]: {
            '&:hover': {
                '--select-border-color': borderHover,
                '--select-background': colors.backgroundHover || baseBG
            },
            [`&${componentCls}-focused`]: {
                '--select-border-color': borderActive,
                '--select-background': colors.backgroundActive || baseBG,
                boxShadow: `0 0 0 ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.controlOutlineWidth)} ${borderOutline}`
            }
        },
        [`&${componentCls}-disabled`]: {
            '--select-border-color': colors.borderDisabled || colors.border,
            '--select-background': colors.backgroundDisabled || colors.background
        }
    };
};
/** Generate variant-scoped variable styles and status overrides for a Select input. */ const $ee0af94af62d4f0f$var$genSelectInputVariantStyle = (token, variant, colors, errorColors = {}, warningColors = {}, patchStyle)=>{
    const { componentCls: componentCls } = token;
    return {
        [`&${componentCls}-${variant}`]: [
            $ee0af94af62d4f0f$var$genSelectInputVariableStyle(token, colors),
            {
                [`&${componentCls}-status-error`]: $ee0af94af62d4f0f$var$genSelectInputVariableStyle(token, {
                    ...colors,
                    color: errorColors.color || token.colorError,
                    ...errorColors
                }),
                [`&${componentCls}-status-warning`]: $ee0af94af62d4f0f$var$genSelectInputVariableStyle(token, {
                    ...colors,
                    color: warningColors.color || token.colorWarning,
                    ...warningColors
                })
            },
            patchStyle
        ]
    };
};
const $ee0af94af62d4f0f$var$genSelectInputStyle = (token)=>{
    const { componentCls: componentCls, calc: calc, fontHeight: fontHeight, controlHeight: controlHeight, iconCls: iconCls } = token;
    return {
        [componentCls]: [
            {
                // Border
                '--select-border-radius': token.borderRadius,
                '--select-border-color': '#000',
                '--select-border-size': token.lineWidth,
                // Background
                '--select-background': token.colorBgContainer,
                // Font
                '--select-font-size': token.fontSize,
                '--select-line-height': token.lineHeight,
                '--select-font-height': fontHeight,
                '--select-color': token.colorText,
                // Size
                '--select-height': controlHeight,
                '--select-padding-horizontal': calc(token.paddingSM).sub(token.lineWidth).equal(),
                '--select-padding-vertical': 'calc((var(--select-height) - var(--select-font-height)) / 2 - var(--select-border-size))',
                // ==========================================================
                // ==                         Base                         ==
                // ==========================================================
                ...(0, $2f353af2b0f7600b$export$23997c3e44cc1c59)(token, true),
                display: 'inline-flex',
                // gap: calc(token.paddingXXS).mul(1.5).equal(),
                flexWrap: 'nowrap',
                position: 'relative',
                transition: `all ${token.motionDurationSlow}`,
                alignItems: 'flex-start',
                outline: 0,
                cursor: 'pointer',
                // Border
                borderRadius: 'var(--select-border-radius)',
                borderWidth: 'var(--select-border-size)',
                borderStyle: token.lineType,
                borderColor: 'var(--select-border-color)',
                // Background
                background: 'var(--select-background)',
                // Font
                fontSize: 'var(--select-font-size)',
                lineHeight: 'var(--select-line-height)',
                color: 'var(--select-color)',
                // Padding
                paddingInline: 'var(--select-padding-horizontal)',
                paddingBlock: 'var(--select-padding-vertical)',
                // ========================= Prefix =========================
                [`${componentCls}-prefix`]: {
                    flex: 'none',
                    lineHeight: 1
                },
                // ====================== Placeholder =======================
                [`${componentCls}-placeholder`]: {
                    ...(0, $2f353af2b0f7600b$export$b2b65df0d0824629),
                    color: token.colorTextPlaceholder,
                    pointerEvents: 'none',
                    zIndex: 1
                },
                // ======================== Content =========================
                [`${componentCls}-content`]: {
                    flex: 'auto',
                    minWidth: 0,
                    position: 'relative',
                    display: 'flex',
                    marginInlineEnd: calc(token.paddingXXS).mul(1.5).equal(),
                    '&:before': {
                        content: '"\\a0"',
                        width: 0,
                        overflow: 'hidden'
                    },
                    // >>> Value
                    '&-value': {
                        ...(0, $2f353af2b0f7600b$export$b2b65df0d0824629),
                        transition: `all ${token.motionDurationMid} ${token.motionEaseInOut}`,
                        zIndex: 1
                    },
                    // >>> Input: should only take effect for not customize mode
                    // input element with readOnly use cursor pointer
                    'input[readonly]': {
                        cursor: 'inherit'
                    }
                },
                [`&-open ${componentCls}-content-value`]: {
                    color: token.colorTextPlaceholder
                },
                // ========================= Suffix =========================
                [`${componentCls}-suffix`]: {
                    flex: 'none',
                    color: token.colorTextQuaternary,
                    fontSize: token.fontSizeIcon,
                    lineHeight: 1,
                    '> :not(:last-child)': {
                        marginInlineEnd: token.marginXS
                    }
                },
                [`${componentCls}-prefix, ${componentCls}-suffix`]: {
                    alignSelf: 'center',
                    [iconCls]: {
                        verticalAlign: 'top'
                    }
                },
                // ==========================================================
                // ==                       Disabled                       ==
                // ==========================================================
                '&-disabled': {
                    background: token.colorBgContainerDisabled,
                    color: token.colorTextDisabled,
                    cursor: 'not-allowed'
                },
                // ==========================================================
                // ==                         Size                         ==
                // ==========================================================
                '&-sm': {
                    '--select-height': token.controlHeightSM,
                    '--select-padding-horizontal': calc(token.paddingXS).sub(token.lineWidth).equal(),
                    '--select-border-radius': token.borderRadiusSM
                },
                '&-lg': {
                    '--select-height': token.controlHeightLG,
                    '--select-font-size': token.fontSizeLG,
                    '--select-line-height': token.lineHeightLG,
                    '--select-font-height': token.fontHeightLG,
                    '--select-border-radius': token.borderRadiusLG
                }
            },
            // ============================================================
            // ==                         Input                          ==
            // ============================================================
            {
                [`&:not(${componentCls}-customize)`]: {
                    [`${componentCls}-input`]: {
                        outline: 'none',
                        background: 'transparent',
                        appearance: 'none',
                        border: 0,
                        margin: 0,
                        padding: 0,
                        color: 'inherit',
                        '&::-webkit-search-cancel-button': {
                            display: 'none',
                            appearance: 'none'
                        }
                    }
                }
            },
            // ============================================================
            // ==                         Single                         ==
            // ============================================================
            {
                [`&-single:not(${componentCls}-customize)`]: {
                    [`${componentCls}-input`]: {
                        position: 'absolute',
                        insetInline: 0,
                        insetBlock: 'calc(var(--select-padding-vertical) * -1)',
                        lineHeight: 'calc(var(--select-font-height) + var(--select-padding-vertical) * 2)'
                    },
                    // Content center align
                    [`${componentCls}-content`]: {
                        alignSelf: 'center'
                    }
                }
            },
            // ============================================================
            // ==                        Multiple                        ==
            // ============================================================
            (0, $598d8d9b43196ddd$export$2e2bcd8739ae039)(token),
            // ========================= Variant ==========================
            // >>> Outlined
            $ee0af94af62d4f0f$var$genSelectInputVariantStyle(token, 'outlined', {
                border: token.colorBorder,
                borderHover: token.hoverBorderColor,
                borderActive: token.activeBorderColor,
                borderOutline: token.activeOutlineColor,
                borderDisabled: token.colorBorderDisabled
            }, // Error
            {
                border: token.colorError,
                borderHover: token.colorErrorHover,
                borderActive: token.colorError,
                borderOutline: token.colorErrorOutline
            }, // Warning
            {
                border: token.colorWarning,
                borderHover: token.colorWarningHover,
                borderActive: token.colorWarning,
                borderOutline: token.colorWarningOutline
            }),
            // >>> Filled
            $ee0af94af62d4f0f$var$genSelectInputVariantStyle(token, 'filled', {
                border: 'transparent',
                borderHover: 'transparent',
                borderActive: token.activeBorderColor,
                borderOutline: 'transparent',
                borderDisabled: token.colorBorderDisabled,
                background: token.colorFillTertiary,
                backgroundHover: token.colorFillSecondary,
                backgroundActive: token.colorBgContainer
            }, // Error
            {
                background: token.colorErrorBg,
                backgroundHover: token.colorErrorBgHover,
                borderActive: token.colorError
            }, // Warning
            {
                background: token.colorWarningBg,
                backgroundHover: token.colorWarningBgHover,
                borderActive: token.colorWarning
            }),
            // >>> Borderless
            $ee0af94af62d4f0f$var$genSelectInputVariantStyle(token, 'borderless', {
                border: 'transparent',
                borderHover: 'transparent',
                borderActive: 'transparent',
                borderOutline: 'transparent',
                background: 'transparent'
            }),
            // Underlined
            $ee0af94af62d4f0f$var$genSelectInputVariantStyle(token, 'underlined', {
                border: token.colorBorder,
                borderHover: token.hoverBorderColor,
                borderActive: token.activeBorderColor,
                borderOutline: 'transparent'
            }, // Error
            {
                border: token.colorError,
                borderHover: token.colorErrorHover,
                borderActive: token.colorError
            }, // Warning
            {
                border: token.colorWarning,
                borderHover: token.colorWarningHover,
                borderActive: token.colorWarning
            }, {
                borderRadius: 0,
                borderTopColor: 'transparent',
                borderRightColor: 'transparent',
                borderLeftColor: 'transparent'
            }),
            // ============================================================
            // ==                         Custom                         ==
            // ============================================================
            (0, $42a1db86cd704d2d$export$2e2bcd8739ae039)(token)
        ]
    };
};
var $ee0af94af62d4f0f$export$2e2bcd8739ae039 = $ee0af94af62d4f0f$var$genSelectInputStyle;


const $6d49362e07fb4313$export$9ca1be8807fe0675 = (token)=>{
    const { fontSize: fontSize, lineHeight: lineHeight, lineWidth: lineWidth, controlHeight: controlHeight, controlHeightSM: controlHeightSM, controlHeightLG: controlHeightLG, paddingXXS: paddingXXS, controlPaddingHorizontal: controlPaddingHorizontal, zIndexPopupBase: zIndexPopupBase, colorText: colorText, fontWeightStrong: fontWeightStrong, controlItemBgActive: controlItemBgActive, controlItemBgHover: controlItemBgHover, colorBgContainer: colorBgContainer, colorFillSecondary: colorFillSecondary, colorBgContainerDisabled: colorBgContainerDisabled, colorTextDisabled: colorTextDisabled, colorPrimaryHover: colorPrimaryHover, colorPrimary: colorPrimary, controlOutline: controlOutline } = token;
    // Item height default use `controlHeight - 2 * paddingXXS`,
    // but some case `paddingXXS=0`.
    // Let's fallback it.
    const dblPaddingXXS = paddingXXS * 2;
    const dblLineWidth = lineWidth * 2;
    const multipleItemHeight = Math.min(controlHeight - dblPaddingXXS, controlHeight - dblLineWidth);
    const multipleItemHeightSM = Math.min(controlHeightSM - dblPaddingXXS, controlHeightSM - dblLineWidth);
    const multipleItemHeightLG = Math.min(controlHeightLG - dblPaddingXXS, controlHeightLG - dblLineWidth);
    // FIXED_ITEM_MARGIN is a hardcode calculation since calc not support rounding
    const INTERNAL_FIXED_ITEM_MARGIN = Math.floor(paddingXXS / 2);
    return {
        INTERNAL_FIXED_ITEM_MARGIN: INTERNAL_FIXED_ITEM_MARGIN,
        zIndexPopup: zIndexPopupBase + 50,
        optionSelectedColor: colorText,
        optionSelectedFontWeight: fontWeightStrong,
        optionSelectedBg: controlItemBgActive,
        optionActiveBg: controlItemBgHover,
        optionPadding: `${(controlHeight - fontSize * lineHeight) / 2}px ${controlPaddingHorizontal}px`,
        optionFontSize: fontSize,
        optionLineHeight: lineHeight,
        optionHeight: controlHeight,
        selectorBg: colorBgContainer,
        clearBg: colorBgContainer,
        singleItemHeightLG: controlHeightLG,
        multipleItemBg: colorFillSecondary,
        multipleItemBorderColor: 'transparent',
        multipleItemHeight: multipleItemHeight,
        multipleItemHeightSM: multipleItemHeightSM,
        multipleItemHeightLG: multipleItemHeightLG,
        multipleSelectorBgDisabled: colorBgContainerDisabled,
        multipleItemColorDisabled: colorTextDisabled,
        multipleItemBorderColorDisabled: 'transparent',
        showArrowPaddingInlineEnd: Math.ceil(token.fontSize * 1.25),
        hoverBorderColor: colorPrimaryHover,
        activeBorderColor: colorPrimary,
        activeOutlineColor: controlOutline,
        selectAffixPadding: paddingXXS
    };
};


// =============================== Base ===============================
const $9e4c87039e9217df$var$genBaseStyle = (token)=>{
    const { antCls: antCls, componentCls: componentCls, inputPaddingHorizontalBase: inputPaddingHorizontalBase } = token;
    const hoverShowClearStyle = {
        [`${componentCls}-clear`]: {
            opacity: 1,
            background: token.colorBgBase,
            borderRadius: '50%'
        }
    };
    return {
        [componentCls]: {
            ...(0, $2f353af2b0f7600b$export$23997c3e44cc1c59)(token),
            // ======================== Selection ========================
            [`${componentCls}-selection-item`]: {
                flex: 1,
                fontWeight: 'normal',
                position: 'relative',
                userSelect: 'none',
                ...(0, $2f353af2b0f7600b$export$b2b65df0d0824629),
                // https://github.com/ant-design/ant-design/issues/40421
                [`> ${antCls}-typography`]: {
                    display: 'inline'
                }
            },
            // ========================= Prefix ==========================
            [`${componentCls}-prefix`]: {
                flex: 'none',
                marginInlineEnd: token.selectAffixPadding
            },
            // ========================== Clear ==========================
            [`${componentCls}-clear`]: {
                position: 'absolute',
                top: '50%',
                insetInlineStart: 'auto',
                insetInlineEnd: inputPaddingHorizontalBase,
                zIndex: 1,
                display: 'inline-block',
                width: token.fontSizeIcon,
                height: token.fontSizeIcon,
                marginTop: token.calc(token.fontSizeIcon).mul(-1).div(2).equal(),
                color: token.colorTextQuaternary,
                fontSize: token.fontSizeIcon,
                fontStyle: 'normal',
                lineHeight: 1,
                textAlign: 'center',
                textTransform: 'none',
                cursor: 'pointer',
                opacity: 0,
                transition: `color ${token.motionDurationMid} ease, opacity ${token.motionDurationSlow} ease`,
                textRendering: 'auto',
                // https://github.com/ant-design/ant-design/issues/54205
                // Force GPU compositing on Safari to prevent flickering on opacity/transform transitions
                transform: 'translateZ(0)',
                '&:before': {
                    display: 'block'
                },
                '&:hover': {
                    color: token.colorIcon
                }
            },
            '@media(hover:none)': hoverShowClearStyle,
            '&:hover': hoverShowClearStyle
        },
        // ========================= Feedback ==========================
        [`${componentCls}-status`]: {
            '&-error, &-warning, &-success, &-validating': {
                [`&${componentCls}-has-feedback`]: {
                    [`${componentCls}-clear`]: {
                        insetInlineEnd: token.calc(inputPaddingHorizontalBase).add(token.fontSize).add(token.paddingXS).equal()
                    }
                }
            }
        }
    };
};
// ============================== Styles ==============================
const $9e4c87039e9217df$var$genSelectStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return [
        {
            [componentCls]: {
                // ==================== In Form ====================
                [`&${componentCls}-in-form-item`]: {
                    width: '100%'
                }
            }
        },
        // =====================================================
        // ==                       LTR                       ==
        // =====================================================
        // Base
        $9e4c87039e9217df$var$genBaseStyle(token),
        // Dropdown
        (0, $5f755ef86f8eeafd$export$2e2bcd8739ae039)(token),
        // =====================================================
        // ==                       RTL                       ==
        // =====================================================
        {
            [`${componentCls}-rtl`]: {
                direction: 'rtl'
            }
        },
        // =====================================================
        // ==             Space Compact                       ==
        // =====================================================
        (0, $ebe50cd0ffe9b635$export$b1208b23589b4b73)(token, {
            focusElCls: `${componentCls}-focused`
        })
    ];
};
var // ============================== Export ==============================
$9e4c87039e9217df$export$2e2bcd8739ae039 = (0, $d4a2dc313c4d90a4$export$51ec95de45185b42)('Select', (token, { rootPrefixCls: rootPrefixCls })=>{
    const selectToken = (0, $90c11ca6cb263fd9$export$4950aa0f605343fb)(token, {
        rootPrefixCls: rootPrefixCls,
        inputPaddingHorizontalBase: token.calc(token.paddingSM).sub(token.lineWidth).equal(),
        multipleSelectItemHeight: token.multipleItemHeight,
        selectHeight: token.controlHeight
    });
    return [
        $9e4c87039e9217df$var$genSelectStyle(selectToken),
        (0, $ee0af94af62d4f0f$export$2e2bcd8739ae039)(selectToken)
    ];
}, (0, $6d49362e07fb4313$export$9ca1be8807fe0675), {
    unitless: {
        optionLineHeight: true,
        optionSelectedFontWeight: true
    }
});


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
// This icon file is generated automatically.
var $f4a27040bf0d9459$var$CheckOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z"
                }
            }
        ]
    },
    "name": "check",
    "theme": "outlined"
};
var $f4a27040bf0d9459$export$2e2bcd8739ae039 = $f4a27040bf0d9459$var$CheckOutlined;



function $1787a6a0f26606cf$var$_extends() {
    $1787a6a0f26606cf$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1787a6a0f26606cf$var$_extends.apply(this, arguments);
}
const $1787a6a0f26606cf$var$CheckOutlined = (props, ref)=>/*#__PURE__*/ $hO8yS.createElement((0, $5fd6f3f3c400c267$export$2e2bcd8739ae039), $1787a6a0f26606cf$var$_extends({}, props, {
        ref: ref,
        icon: (0, $f4a27040bf0d9459$export$2e2bcd8739ae039)
    }));
/**![check](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkxMiAxOTBoLTY5LjljLTkuOCAwLTE5LjEgNC41LTI1LjEgMTIuMkw0MDQuNyA3MjQuNSAyMDcgNDc0YTMyIDMyIDAgMDAtMjUuMS0xMi4ySDExMmMtNi43IDAtMTAuNCA3LjctNi4zIDEyLjlsMjczLjkgMzQ3YzEyLjggMTYuMiAzNy40IDE2LjIgNTAuMyAwbDQ4OC40LTYxOC45YzQuMS01LjEuNC0xMi44LTYuMy0xMi44eiIgLz48L3N2Zz4=) */ const $1787a6a0f26606cf$var$RefIcon = /*#__PURE__*/ $N3oW3.forwardRef($1787a6a0f26606cf$var$CheckOutlined);
var $1787a6a0f26606cf$export$2e2bcd8739ae039 = $1787a6a0f26606cf$var$RefIcon;








"use client";
function $8141c17117d71d33$export$2e2bcd8739ae039({ suffixIcon: suffixIcon, clearIcon: clearIcon, menuItemSelectedIcon: menuItemSelectedIcon, removeIcon: removeIcon, loading: loading, multiple: multiple, hasFeedback: hasFeedback, showSuffixIcon: showSuffixIcon, feedbackIcon: feedbackIcon, showArrow: showArrow, componentName: componentName }) {
    // Clear Icon
    const mergedClearIcon = clearIcon ?? /*#__PURE__*/ $hO8yS.createElement((0, $88ed6189ad3742f6$export$2e2bcd8739ae039), null);
    // Validation Feedback Icon
    const getSuffixIconNode = (arrowIcon)=>{
        if (suffixIcon === null && !hasFeedback && !showArrow) return null;
        return /*#__PURE__*/ $hO8yS.createElement($hO8yS.Fragment, null, showSuffixIcon !== false && arrowIcon, hasFeedback && feedbackIcon);
    };
    // Arrow item icon
    let mergedSuffixIcon = null;
    if (suffixIcon !== undefined) mergedSuffixIcon = getSuffixIconNode(suffixIcon);
    else if (loading) mergedSuffixIcon = getSuffixIconNode(/*#__PURE__*/ $hO8yS.createElement((0, $b7d605396d432b67$export$2e2bcd8739ae039), {
        spin: true
    }));
    else mergedSuffixIcon = ({ open: open, showSearch: showSearch })=>{
        if (open && showSearch) return getSuffixIconNode(/*#__PURE__*/ $hO8yS.createElement((0, $a3bf8c02a3dd583c$export$2e2bcd8739ae039), null));
        return getSuffixIconNode(/*#__PURE__*/ $hO8yS.createElement((0, $6c28e8c1b305d317$export$2e2bcd8739ae039), null));
    };
    // Checked item icon
    let mergedItemIcon = null;
    if (menuItemSelectedIcon !== undefined) mergedItemIcon = menuItemSelectedIcon;
    else if (multiple) mergedItemIcon = /*#__PURE__*/ $hO8yS.createElement((0, $1787a6a0f26606cf$export$2e2bcd8739ae039), null);
    else mergedItemIcon = null;
    let mergedRemoveIcon = null;
    if (removeIcon !== undefined) mergedRemoveIcon = removeIcon;
    else mergedRemoveIcon = /*#__PURE__*/ $hO8yS.createElement((0, $bd33c75627fd73a4$export$2e2bcd8739ae039), null);
    return {
        // TODO: remove as when all the deps bumped
        clearIcon: mergedClearIcon,
        suffixIcon: mergedSuffixIcon,
        itemIcon: mergedItemIcon,
        removeIcon: mergedRemoveIcon
    };
}



var $N3oW3 = parcelRequire("N3oW3");

"use client";
function $1bfadd9e93211d73$var$usePopupRender(renderFn) {
    return (0, $N3oW3.default).useMemo(()=>{
        if (!renderFn) return undefined;
        return (...args)=>/*#__PURE__*/ (0, $N3oW3.default).createElement((0, $8a9bb3ef8b2b36aa$export$2e2bcd8739ae039), {
                space: true
            }, renderFn.apply(void 0, args));
    }, [
        renderFn
    ]);
}
var $1bfadd9e93211d73$export$2e2bcd8739ae039 = $1bfadd9e93211d73$var$usePopupRender;


/**
 * Since Select, TreeSelect, Cascader is same Select like component.
 * We just use same hook to handle this logic.
 *
 * If `suffixIcon` is not equal to `null`, always show it.
 */ function $43f09b02deb8f1e2$export$2e2bcd8739ae039(suffixIcon, showArrow) {
    return showArrow !== undefined ? showArrow : suffixIcon !== null;
}


"use client";
const $9dbdc31b38c7097b$var$SECRET_COMBOBOX_MODE_DO_NOT_USE = 'SECRET_COMBOBOX_MODE_DO_NOT_USE';
const $9dbdc31b38c7097b$var$InternalSelect = (props, ref)=>{
    const { prefixCls: customizePrefixCls, bordered: bordered, className: className, rootClassName: rootClassName, getPopupContainer: getPopupContainer, popupClassName: popupClassName, dropdownClassName: dropdownClassName, listHeight: listHeight = 256, placement: placement, listItemHeight: customListItemHeight, size: customizeSize, disabled: customDisabled, notFoundContent: notFoundContent, status: customStatus, builtinPlacements: builtinPlacements, dropdownMatchSelectWidth: dropdownMatchSelectWidth, popupMatchSelectWidth: popupMatchSelectWidth, direction: propDirection, style: style, allowClear: allowClear, variant: customizeVariant, popupStyle: popupStyle, dropdownStyle: dropdownStyle, transitionName: transitionName, tagRender: tagRender, maxCount: maxCount, prefix: prefix, dropdownRender: dropdownRender, popupRender: /**
     * @since 5.25.0
     */ popupRender, onDropdownVisibleChange: onDropdownVisibleChange, onOpenChange: onOpenChange, styles: styles, classNames: classNames, ...rest } = props;
    const { getPopupContainer: getContextPopupContainer, getPrefixCls: getPrefixCls, renderEmpty: renderEmpty, direction: contextDirection, virtual: virtual, popupMatchSelectWidth: contextPopupMatchSelectWidth, popupOverflow: popupOverflow } = $32rMB.useContext((0, $dd01e2f5a4b8605d$export$a92f85ab3e9ad68b));
    const { showSearch: showSearch, style: contextStyle, styles: contextStyles, className: contextClassName, classNames: contextClassNames } = (0, $dd01e2f5a4b8605d$export$46f4bd6436a25a31)('select');
    const [, token] = (0, $9481722d146bd166$export$2e2bcd8739ae039)();
    const listItemHeight = customListItemHeight ?? token?.controlHeight;
    const prefixCls = getPrefixCls('select', customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    const direction = propDirection ?? contextDirection;
    const { compactSize: compactSize, compactItemClassnames: compactItemClassnames } = (0, $085e8dc0a3d19960$export$cd8cf9d7bab8dd4)(prefixCls, direction);
    const [variant, enableVariantCls] = (0, $b3bf3719877c7ee9$export$2e2bcd8739ae039)('select', customizeVariant, bordered);
    const rootCls = (0, $54b1aecddbbbed4f$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $9e4c87039e9217df$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const mode = $32rMB.useMemo(()=>{
        const { mode: m } = props;
        if (m === 'combobox') return undefined;
        if (m === $9dbdc31b38c7097b$var$SECRET_COMBOBOX_MODE_DO_NOT_USE) return 'combobox';
        return m;
    }, [
        props.mode
    ]);
    const isMultiple = mode === 'multiple' || mode === 'tags';
    const showSuffixIcon = (0, $43f09b02deb8f1e2$export$2e2bcd8739ae039)(props.suffixIcon, props.showArrow);
    const mergedPopupMatchSelectWidth = popupMatchSelectWidth ?? dropdownMatchSelectWidth ?? contextPopupMatchSelectWidth;
    const mergedPopupRender = (0, $1bfadd9e93211d73$export$2e2bcd8739ae039)(popupRender || dropdownRender);
    const mergedOnOpenChange = onOpenChange || onDropdownVisibleChange;
    // ===================== Form Status =====================
    const { status: contextStatus, hasFeedback: hasFeedback, isFormItemInput: isFormItemInput, feedbackIcon: feedbackIcon } = $32rMB.useContext((0, $a1a112e4dddc1035$export$bbb5553c6c7a14ed));
    const mergedStatus = (0, $597dc4581bd08a1e$export$314e193082d7ba49)(contextStatus, customStatus);
    // ===================== Empty =====================
    let mergedNotFound;
    if (notFoundContent !== undefined) mergedNotFound = notFoundContent;
    else if (mode === 'combobox') mergedNotFound = null;
    else mergedNotFound = renderEmpty?.('Select') || /*#__PURE__*/ $hO8yS.createElement((0, $6650c2c5bdbe4a9f$export$2e2bcd8739ae039), {
        componentName: "Select"
    });
    // ===================== Icons =====================
    const { suffixIcon: suffixIcon, itemIcon: itemIcon, removeIcon: removeIcon, clearIcon: clearIcon } = (0, $8141c17117d71d33$export$2e2bcd8739ae039)({
        ...rest,
        multiple: isMultiple,
        hasFeedback: hasFeedback,
        feedbackIcon: feedbackIcon,
        showSuffixIcon: showSuffixIcon,
        prefixCls: prefixCls,
        componentName: 'Select'
    });
    const mergedAllowClear = allowClear === true ? {
        clearIcon: clearIcon
    } : allowClear;
    const selectProps = (0, $f4cf9c2e27c0ac8d$export$2e2bcd8739ae039)(rest, [
        'suffixIcon',
        'itemIcon'
    ]);
    const mergedSize = (0, $324b30eda6ea1cd7$export$2e2bcd8739ae039)((ctx)=>customizeSize ?? compactSize ?? ctx);
    // ===================== Disabled =====================
    const disabled = $32rMB.useContext((0, $ff4b4ddbf52ed41f$export$2e2bcd8739ae039));
    const mergedDisabled = customDisabled ?? disabled;
    // ========== Merged Props for Semantic ==================
    const mergedProps = {
        ...props,
        variant: variant,
        status: mergedStatus,
        disabled: mergedDisabled,
        size: mergedSize
    };
    const [mergedClassNames, mergedStyles] = (0, $4dcf69d8c3d6df5c$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    }, {
        popup: {
            _default: 'root'
        }
    });
    const mergedPopupClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(mergedClassNames.popup?.root, popupClassName, dropdownClassName, {
        [`${prefixCls}-dropdown-${direction}`]: direction === 'rtl'
    }, rootClassName, cssVarCls, rootCls, hashId);
    const mergedPopupStyle = {
        ...mergedStyles.popup?.root,
        ...popupStyle ?? dropdownStyle
    };
    const mergedClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)({
        [`${prefixCls}-lg`]: mergedSize === 'large',
        [`${prefixCls}-sm`]: mergedSize === 'small',
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-${variant}`]: enableVariantCls,
        [`${prefixCls}-in-form-item`]: isFormItemInput
    }, (0, $597dc4581bd08a1e$export$b08e7b47149942a2)(prefixCls, mergedStatus, hasFeedback), compactItemClassnames, contextClassName, className, mergedClassNames.root, rootClassName, cssVarCls, rootCls, hashId);
    // ===================== Placement =====================
    const memoPlacement = $32rMB.useMemo(()=>{
        if (placement !== undefined) return placement;
        return direction === 'rtl' ? 'bottomRight' : 'bottomLeft';
    }, [
        placement,
        direction
    ]);
    var oldProp, newProp;
    // ====================== zIndex =========================
    const [zIndex] = (0, $15dbea5a917a06ef$export$3e7906d4075187a4)('SelectLike', mergedStyles.popup?.root?.zIndex ?? mergedPopupStyle?.zIndex);
    // ====================== Render =======================
    return /*#__PURE__*/ $hO8yS.createElement((0, $91e9538f306b5a78$export$2e2bcd8739ae039), {
        ref: ref,
        virtual: virtual,
        classNames: mergedClassNames,
        styles: mergedStyles,
        showSearch: showSearch,
        ...selectProps,
        style: {
            ...mergedStyles.root,
            ...contextStyle,
            ...style
        },
        popupMatchSelectWidth: mergedPopupMatchSelectWidth,
        transitionName: (0, $689b5af26dd3c1cd$export$27c72201b1d09951)(rootPrefixCls, 'slide-up', transitionName),
        builtinPlacements: (0, $8e90042aa87cff17$export$2e2bcd8739ae039)(builtinPlacements, popupOverflow),
        listHeight: listHeight,
        listItemHeight: listItemHeight,
        mode: mode,
        prefixCls: prefixCls,
        placement: memoPlacement,
        direction: direction,
        prefix: prefix,
        suffixIcon: suffixIcon,
        menuItemSelectedIcon: itemIcon,
        removeIcon: removeIcon,
        allowClear: mergedAllowClear,
        notFoundContent: mergedNotFound,
        className: mergedClassName,
        getPopupContainer: getPopupContainer || getContextPopupContainer,
        popupClassName: mergedPopupClassName,
        disabled: mergedDisabled,
        popupStyle: {
            ...mergedStyles.popup?.root,
            ...mergedPopupStyle,
            zIndex: zIndex
        },
        maxCount: isMultiple ? maxCount : undefined,
        tagRender: isMultiple ? tagRender : undefined,
        popupRender: mergedPopupRender,
        onPopupVisibleChange: mergedOnOpenChange
    });
};
const $9dbdc31b38c7097b$var$Select = /*#__PURE__*/ $N3oW3.forwardRef($9dbdc31b38c7097b$var$InternalSelect);
// We don't care debug panel
/* istanbul ignore next */ const $9dbdc31b38c7097b$var$PurePanel = (0, $63c4642dc3601d57$export$2e2bcd8739ae039)($9dbdc31b38c7097b$var$Select, 'popupAlign');
$9dbdc31b38c7097b$var$Select.SECRET_COMBOBOX_MODE_DO_NOT_USE = $9dbdc31b38c7097b$var$SECRET_COMBOBOX_MODE_DO_NOT_USE;
$9dbdc31b38c7097b$var$Select.Option = (0, $020133878e2a85ed$export$2e2bcd8739ae039);
$9dbdc31b38c7097b$var$Select.OptGroup = (0, $9905763ec414f7ba$export$2e2bcd8739ae039);
$9dbdc31b38c7097b$var$Select._InternalPanelDoNotUseOrYouWillBeFired = $9dbdc31b38c7097b$var$PurePanel;
var $9dbdc31b38c7097b$export$2e2bcd8739ae039 = $9dbdc31b38c7097b$var$Select;








const $1b3ec09ed3105952$var$genPaginationDisabledStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-disabled`]: {
            '&, &:hover': {
                cursor: 'not-allowed',
                [`${componentCls}-item-link`]: {
                    color: token.colorTextDisabled,
                    cursor: 'not-allowed'
                }
            },
            '&:focus-visible': {
                cursor: 'not-allowed',
                [`${componentCls}-item-link`]: {
                    color: token.colorTextDisabled,
                    cursor: 'not-allowed'
                }
            }
        },
        [`&${componentCls}-disabled`]: {
            cursor: 'not-allowed',
            [`${componentCls}-item`]: {
                cursor: 'not-allowed',
                backgroundColor: 'transparent',
                '&:hover, &:active': {
                    backgroundColor: 'transparent'
                },
                a: {
                    color: token.colorTextDisabled,
                    backgroundColor: 'transparent',
                    border: 'none',
                    cursor: 'not-allowed'
                },
                '&-active': {
                    borderColor: token.colorBorder,
                    backgroundColor: token.itemActiveBgDisabled,
                    '&:hover, &:active': {
                        backgroundColor: token.itemActiveBgDisabled
                    },
                    a: {
                        color: token.itemActiveColorDisabled
                    }
                }
            },
            [`${componentCls}-item-link`]: {
                color: token.colorTextDisabled,
                cursor: 'not-allowed',
                '&:hover, &:active': {
                    backgroundColor: 'transparent'
                },
                [`${componentCls}-simple&`]: {
                    backgroundColor: 'transparent',
                    '&:hover, &:active': {
                        backgroundColor: 'transparent'
                    }
                }
            },
            [`${componentCls}-simple-pager`]: {
                color: token.colorTextDisabled
            },
            [`${componentCls}-jump-prev, ${componentCls}-jump-next`]: {
                [`${componentCls}-item-link-icon`]: {
                    opacity: 0
                },
                [`${componentCls}-item-ellipsis`]: {
                    opacity: 1
                }
            }
        }
    };
};
const $1b3ec09ed3105952$var$genPaginationMiniStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`&${componentCls}-mini ${componentCls}-total-text, &${componentCls}-mini ${componentCls}-simple-pager`]: {
            height: token.itemSizeSM,
            lineHeight: (0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.itemSizeSM)
        },
        [`&${componentCls}-mini ${componentCls}-item`]: {
            minWidth: token.itemSizeSM,
            height: token.itemSizeSM,
            margin: 0,
            lineHeight: (0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.calc(token.itemSizeSM).sub(2).equal())
        },
        [`&${componentCls}-mini ${componentCls}-prev, &${componentCls}-mini ${componentCls}-next`]: {
            minWidth: token.itemSizeSM,
            height: token.itemSizeSM,
            margin: 0,
            lineHeight: (0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.itemSizeSM)
        },
        [`&${componentCls}-mini:not(${componentCls}-disabled)`]: {
            [`${componentCls}-prev, ${componentCls}-next`]: {
                [`&:hover ${componentCls}-item-link`]: {
                    backgroundColor: token.colorBgTextHover
                },
                [`&:active ${componentCls}-item-link`]: {
                    backgroundColor: token.colorBgTextActive
                },
                [`&${componentCls}-disabled:hover ${componentCls}-item-link`]: {
                    backgroundColor: 'transparent'
                }
            }
        },
        [`
    &${componentCls}-mini ${componentCls}-prev ${componentCls}-item-link,
    &${componentCls}-mini ${componentCls}-next ${componentCls}-item-link
    `]: {
            backgroundColor: 'transparent',
            borderColor: 'transparent',
            '&::after': {
                height: token.itemSizeSM,
                lineHeight: (0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.itemSizeSM)
            }
        },
        [`&${componentCls}-mini ${componentCls}-jump-prev, &${componentCls}-mini ${componentCls}-jump-next`]: {
            height: token.itemSizeSM,
            marginInlineEnd: 0,
            lineHeight: (0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.itemSizeSM)
        },
        [`&${componentCls}-mini ${componentCls}-options`]: {
            marginInlineStart: token.paginationMiniOptionsMarginInlineStart,
            '&-size-changer': {
                top: token.miniOptionsSizeChangerTop
            },
            '&-quick-jumper': {
                height: token.itemSizeSM,
                lineHeight: (0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.itemSizeSM),
                input: {
                    ...(0, $e8a8f826922d3542$export$bb047f62c5a56f90)(token),
                    width: token.paginationMiniQuickJumperInputWidth,
                    height: token.controlHeightSM
                }
            }
        }
    };
};
const $1b3ec09ed3105952$var$genPaginationSimpleStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`&${componentCls}-simple`]: {
            [`${componentCls}-prev, ${componentCls}-next`]: {
                height: token.itemSize,
                lineHeight: (0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.itemSize),
                verticalAlign: 'top',
                [`${componentCls}-item-link`]: {
                    height: token.itemSize,
                    backgroundColor: 'transparent',
                    border: 0,
                    '&:hover': {
                        backgroundColor: token.colorBgTextHover
                    },
                    '&:active': {
                        backgroundColor: token.colorBgTextActive
                    },
                    '&::after': {
                        height: token.itemSize,
                        lineHeight: (0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.itemSize)
                    }
                }
            },
            [`${componentCls}-simple-pager`]: {
                display: 'inline-flex',
                alignItems: 'center',
                height: token.itemSize,
                marginInlineEnd: token.marginXS,
                input: {
                    boxSizing: 'border-box',
                    height: '100%',
                    width: token.quickJumperInputWidth,
                    padding: `0 ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.paginationItemPaddingInline)}`,
                    textAlign: 'center',
                    backgroundColor: token.itemInputBg,
                    border: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                    borderRadius: token.borderRadius,
                    outline: 'none',
                    transition: `border-color ${token.motionDurationMid}`,
                    color: 'inherit',
                    '&:hover': {
                        borderColor: token.colorPrimary
                    },
                    '&:focus': {
                        borderColor: token.colorPrimaryHover,
                        boxShadow: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.inputOutlineOffset)} 0 ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.controlOutlineWidth)} ${token.controlOutline}`
                    },
                    '&[disabled]': {
                        color: token.colorTextDisabled,
                        backgroundColor: token.colorBgContainerDisabled,
                        borderColor: token.colorBorder,
                        cursor: 'not-allowed'
                    }
                }
            },
            [`&${componentCls}-disabled`]: {
                [`${componentCls}-prev, ${componentCls}-next`]: {
                    [`${componentCls}-item-link`]: {
                        '&:hover, &:active': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            },
            [`&${componentCls}-mini`]: {
                [`${componentCls}-prev, ${componentCls}-next`]: {
                    height: token.itemSizeSM,
                    lineHeight: (0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.itemSizeSM),
                    [`${componentCls}-item-link`]: {
                        height: token.itemSizeSM,
                        '&::after': {
                            height: token.itemSizeSM,
                            lineHeight: (0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.itemSizeSM)
                        }
                    }
                },
                [`${componentCls}-simple-pager`]: {
                    height: token.itemSizeSM,
                    input: {
                        width: token.paginationMiniQuickJumperInputWidth
                    }
                }
            }
        }
    };
};
const $1b3ec09ed3105952$var$genPaginationJumpStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-jump-prev, ${componentCls}-jump-next`]: {
            outline: 0,
            [`${componentCls}-item-container`]: {
                position: 'relative',
                [`${componentCls}-item-link-icon`]: {
                    color: token.colorPrimary,
                    fontSize: token.fontSizeSM,
                    opacity: 0,
                    transition: `all ${token.motionDurationMid}`,
                    '&-svg': {
                        top: 0,
                        insetInlineEnd: 0,
                        bottom: 0,
                        insetInlineStart: 0,
                        margin: 'auto'
                    }
                },
                [`${componentCls}-item-ellipsis`]: {
                    position: 'absolute',
                    top: 0,
                    insetInlineEnd: 0,
                    bottom: 0,
                    insetInlineStart: 0,
                    display: 'block',
                    margin: 'auto',
                    color: token.colorTextDisabled,
                    letterSpacing: token.paginationEllipsisLetterSpacing,
                    textAlign: 'center',
                    textIndent: token.paginationEllipsisTextIndent,
                    opacity: 1,
                    transition: `all ${token.motionDurationMid}`
                }
            },
            '&:hover': {
                [`${componentCls}-item-link-icon`]: {
                    opacity: 1
                },
                [`${componentCls}-item-ellipsis`]: {
                    opacity: 0
                }
            }
        },
        [`
    ${componentCls}-prev,
    ${componentCls}-jump-prev,
    ${componentCls}-jump-next
    `]: {
            marginInlineEnd: token.marginXS
        },
        [`
    ${componentCls}-prev,
    ${componentCls}-next,
    ${componentCls}-jump-prev,
    ${componentCls}-jump-next
    `]: {
            display: 'inline-block',
            minWidth: token.itemSize,
            height: token.itemSize,
            color: token.colorText,
            fontFamily: token.fontFamily,
            lineHeight: (0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.itemSize),
            textAlign: 'center',
            verticalAlign: 'middle',
            listStyle: 'none',
            borderRadius: token.borderRadius,
            cursor: 'pointer',
            transition: `all ${token.motionDurationMid}`
        },
        [`${componentCls}-prev, ${componentCls}-next`]: {
            outline: 0,
            button: {
                color: token.colorText,
                cursor: 'pointer',
                userSelect: 'none'
            },
            [`${componentCls}-item-link`]: {
                display: 'block',
                width: '100%',
                height: '100%',
                padding: 0,
                fontSize: token.fontSizeSM,
                textAlign: 'center',
                backgroundColor: 'transparent',
                border: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} transparent`,
                borderRadius: token.borderRadius,
                outline: 'none',
                transition: `all ${token.motionDurationMid}`
            },
            [`&:hover ${componentCls}-item-link`]: {
                backgroundColor: token.colorBgTextHover
            },
            [`&:active ${componentCls}-item-link`]: {
                backgroundColor: token.colorBgTextActive
            },
            [`&${componentCls}-disabled:hover`]: {
                [`${componentCls}-item-link`]: {
                    backgroundColor: 'transparent'
                }
            }
        },
        [`${componentCls}-slash`]: {
            marginInlineEnd: token.paginationSlashMarginInlineEnd,
            marginInlineStart: token.paginationSlashMarginInlineStart
        },
        [`${componentCls}-options`]: {
            display: 'inline-block',
            marginInlineStart: token.margin,
            verticalAlign: 'middle',
            '&-size-changer': {
                width: 'auto'
            },
            '&-quick-jumper': {
                display: 'inline-block',
                height: token.controlHeight,
                marginInlineStart: token.marginXS,
                lineHeight: (0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.controlHeight),
                verticalAlign: 'top',
                input: {
                    ...(0, $e8a8f826922d3542$export$8c9a381315f3ebcd)(token),
                    ...(0, $8640b68e85787e4a$export$8c569e4cc3fd115f)(token, {
                        borderColor: token.colorBorder,
                        hoverBorderColor: token.colorPrimaryHover,
                        activeBorderColor: token.colorPrimary,
                        activeShadow: token.activeShadow
                    }),
                    '&[disabled]': {
                        ...(0, $8640b68e85787e4a$export$12789f962d420a93)(token)
                    },
                    width: token.quickJumperInputWidth,
                    height: token.controlHeight,
                    boxSizing: 'border-box',
                    margin: 0,
                    marginInlineStart: token.marginXS,
                    marginInlineEnd: token.marginXS
                }
            }
        }
    };
};
const $1b3ec09ed3105952$var$genPaginationItemStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-item`]: {
            display: 'inline-block',
            minWidth: token.itemSize,
            height: token.itemSize,
            marginInlineEnd: token.marginXS,
            fontFamily: token.fontFamily,
            lineHeight: (0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.calc(token.itemSize).sub(2).equal()),
            textAlign: 'center',
            verticalAlign: 'middle',
            listStyle: 'none',
            backgroundColor: token.itemBg,
            border: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} transparent`,
            borderRadius: token.borderRadius,
            outline: 0,
            cursor: 'pointer',
            userSelect: 'none',
            a: {
                display: 'block',
                padding: `0 ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.paginationItemPaddingInline)}`,
                color: token.colorText,
                '&:hover': {
                    textDecoration: 'none'
                }
            },
            [`&:not(${componentCls}-item-active)`]: {
                '&:hover': {
                    transition: `all ${token.motionDurationMid}`,
                    backgroundColor: token.colorBgTextHover
                },
                '&:active': {
                    backgroundColor: token.colorBgTextActive
                }
            },
            '&-active': {
                fontWeight: token.fontWeightStrong,
                backgroundColor: token.itemActiveBg,
                borderColor: token.colorPrimary,
                a: {
                    color: token.itemActiveColor
                },
                '&:hover': {
                    borderColor: token.colorPrimaryHover
                },
                '&:hover a': {
                    color: token.itemActiveColorHover
                }
            }
        }
    };
};
const $1b3ec09ed3105952$var$genPaginationStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: {
            ...(0, $2f353af2b0f7600b$export$23997c3e44cc1c59)(token),
            display: 'flex',
            '&-start': {
                justifyContent: 'start'
            },
            '&-center': {
                justifyContent: 'center'
            },
            '&-end': {
                justifyContent: 'end'
            },
            'ul, ol': {
                margin: 0,
                padding: 0,
                listStyle: 'none'
            },
            '&::after': {
                display: 'block',
                clear: 'both',
                height: 0,
                overflow: 'hidden',
                visibility: 'hidden',
                content: '""'
            },
            [`${componentCls}-total-text`]: {
                display: 'inline-block',
                height: token.itemSize,
                marginInlineEnd: token.marginXS,
                lineHeight: (0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.calc(token.itemSize).sub(2).equal()),
                verticalAlign: 'middle'
            },
            // item style
            ...$1b3ec09ed3105952$var$genPaginationItemStyle(token),
            // jump btn style
            ...$1b3ec09ed3105952$var$genPaginationJumpStyle(token),
            // simple style
            ...$1b3ec09ed3105952$var$genPaginationSimpleStyle(token),
            // mini style
            ...$1b3ec09ed3105952$var$genPaginationMiniStyle(token),
            // disabled style
            ...$1b3ec09ed3105952$var$genPaginationDisabledStyle(token),
            // media query style
            [`@media only screen and (max-width: ${token.screenLG}px)`]: {
                [`${componentCls}-item`]: {
                    '&-after-jump-prev, &-before-jump-next': {
                        display: 'none'
                    }
                }
            },
            [`@media only screen and (max-width: ${token.screenSM}px)`]: {
                [`${componentCls}-options`]: {
                    display: 'none'
                }
            }
        },
        // rtl style
        [`&${token.componentCls}-rtl`]: {
            direction: 'rtl'
        }
    };
};
const $1b3ec09ed3105952$var$genPaginationFocusStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}:not(${componentCls}-disabled)`]: {
            [`${componentCls}-item`]: {
                ...(0, $2f353af2b0f7600b$export$a44db842bcb28231)(token)
            },
            [`${componentCls}-jump-prev, ${componentCls}-jump-next`]: {
                '&:focus-visible': {
                    [`${componentCls}-item-link-icon`]: {
                        opacity: 1
                    },
                    [`${componentCls}-item-ellipsis`]: {
                        opacity: 0
                    },
                    ...(0, $2f353af2b0f7600b$export$6539948f0a737e39)(token)
                }
            },
            [`${componentCls}-prev, ${componentCls}-next`]: {
                [`&:focus-visible ${componentCls}-item-link`]: (0, $2f353af2b0f7600b$export$6539948f0a737e39)(token)
            }
        }
    };
};
const $1b3ec09ed3105952$export$9ca1be8807fe0675 = (token)=>({
        itemBg: token.colorBgContainer,
        itemSize: token.controlHeight,
        itemSizeSM: token.controlHeightSM,
        itemActiveBg: token.colorBgContainer,
        itemActiveColor: token.colorPrimary,
        itemActiveColorHover: token.colorPrimaryHover,
        itemLinkBg: token.colorBgContainer,
        itemActiveColorDisabled: token.colorTextDisabled,
        itemActiveBgDisabled: token.controlItemBgActiveDisabled,
        itemInputBg: token.colorBgContainer,
        miniOptionsSizeChangerTop: 0,
        ...(0, $2086d48ba031927a$export$bd8b682992bc9781)(token)
    });
const $1b3ec09ed3105952$export$362fb92a8f81bbf9 = (token)=>(0, $90c11ca6cb263fd9$export$4950aa0f605343fb)(token, {
        inputOutlineOffset: 0,
        quickJumperInputWidth: token.calc(token.controlHeightLG).mul(1.25).equal(),
        paginationMiniOptionsMarginInlineStart: token.calc(token.marginXXS).div(2).equal(),
        paginationMiniQuickJumperInputWidth: token.calc(token.controlHeightLG).mul(1.1).equal(),
        paginationItemPaddingInline: token.calc(token.marginXXS).mul(1.5).equal(),
        paginationEllipsisLetterSpacing: token.calc(token.marginXXS).div(2).equal(),
        paginationSlashMarginInlineStart: token.marginSM,
        paginationSlashMarginInlineEnd: token.marginSM,
        paginationEllipsisTextIndent: '0.13em' // magic for ui experience
    }, (0, $2086d48ba031927a$export$a157d95850191a12)(token));
var // ============================== Export ==============================
$1b3ec09ed3105952$export$2e2bcd8739ae039 = (0, $d4a2dc313c4d90a4$export$51ec95de45185b42)('Pagination', (token)=>{
    const paginationToken = $1b3ec09ed3105952$export$362fb92a8f81bbf9(token);
    return [
        $1b3ec09ed3105952$var$genPaginationStyle(paginationToken),
        $1b3ec09ed3105952$var$genPaginationFocusStyle(paginationToken)
    ];
}, $1b3ec09ed3105952$export$9ca1be8807fe0675);





const $4f1d1760e0ec492d$var$genBorderedStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}${componentCls}-bordered${componentCls}-disabled:not(${componentCls}-mini)`]: {
            '&, &:hover': {
                [`${componentCls}-item-link`]: {
                    borderColor: token.colorBorder
                }
            },
            '&:focus-visible': {
                [`${componentCls}-item-link`]: {
                    borderColor: token.colorBorder
                }
            },
            [`${componentCls}-item, ${componentCls}-item-link`]: {
                backgroundColor: token.colorBgContainerDisabled,
                borderColor: token.colorBorder,
                [`&:hover:not(${componentCls}-item-active)`]: {
                    backgroundColor: token.colorBgContainerDisabled,
                    borderColor: token.colorBorder,
                    a: {
                        color: token.colorTextDisabled
                    }
                },
                [`&${componentCls}-item-active`]: {
                    backgroundColor: token.itemActiveBgDisabled
                }
            },
            [`${componentCls}-prev, ${componentCls}-next`]: {
                '&:hover button': {
                    backgroundColor: token.colorBgContainerDisabled,
                    borderColor: token.colorBorder,
                    color: token.colorTextDisabled
                },
                [`${componentCls}-item-link`]: {
                    backgroundColor: token.colorBgContainerDisabled,
                    borderColor: token.colorBorder
                }
            }
        },
        [`${componentCls}${componentCls}-bordered:not(${componentCls}-mini)`]: {
            [`${componentCls}-prev, ${componentCls}-next`]: {
                '&:hover button': {
                    borderColor: token.colorPrimaryHover,
                    backgroundColor: token.itemBg
                },
                [`${componentCls}-item-link`]: {
                    backgroundColor: token.itemLinkBg,
                    borderColor: token.colorBorder
                },
                [`&:hover ${componentCls}-item-link`]: {
                    borderColor: token.colorPrimary,
                    backgroundColor: token.itemBg,
                    color: token.colorPrimary
                },
                [`&${componentCls}-disabled`]: {
                    [`${componentCls}-item-link`]: {
                        borderColor: token.colorBorder,
                        color: token.colorTextDisabled
                    }
                }
            },
            [`${componentCls}-item`]: {
                backgroundColor: token.itemBg,
                border: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                [`&:hover:not(${componentCls}-item-active)`]: {
                    borderColor: token.colorPrimary,
                    backgroundColor: token.itemBg,
                    a: {
                        color: token.colorPrimary
                    }
                },
                '&-active': {
                    borderColor: token.colorPrimary
                }
            }
        }
    };
};
var $4f1d1760e0ec492d$export$2e2bcd8739ae039 = (0, $d4a2dc313c4d90a4$export$1537386bc155ea56)([
    'Pagination',
    'bordered'
], (token)=>{
    const paginationToken = (0, $1b3ec09ed3105952$export$362fb92a8f81bbf9)(token);
    return $4f1d1760e0ec492d$var$genBorderedStyle(paginationToken);
}, (0, $1b3ec09ed3105952$export$9ca1be8807fe0675));


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
function $5263e563e6efda0c$export$2e2bcd8739ae039(showSizeChanger) {
    return (0, $32rMB.useMemo)(()=>{
        if (typeof showSizeChanger === 'boolean') return [
            showSizeChanger,
            {}
        ];
        if (showSizeChanger && typeof showSizeChanger === 'object') return [
            true,
            showSizeChanger
        ];
        return [
            undefined,
            undefined
        ];
    }, [
        showSizeChanger
    ]);
}


"use client";
const $a677cf7bd8ccf20e$var$Pagination = (props)=>{
    const { align: align, prefixCls: customizePrefixCls, selectPrefixCls: customizeSelectPrefixCls, className: className, rootClassName: rootClassName, style: style, size: customizeSize, locale: customLocale, responsive: responsive, showSizeChanger: showSizeChanger, selectComponentClass: selectComponentClass, pageSizeOptions: pageSizeOptions, styles: styles, classNames: classNames, ...restProps } = props;
    const { xs: xs } = (0, $c5abeec2eaafde8a$export$2e2bcd8739ae039)(responsive);
    const [, token] = (0, $9481722d146bd166$export$2e2bcd8739ae039)();
    const { getPrefixCls: getPrefixCls, direction: direction, showSizeChanger: contextShowSizeChangerConfig, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $dd01e2f5a4b8605d$export$46f4bd6436a25a31)('pagination');
    const prefixCls = getPrefixCls('pagination', customizePrefixCls);
    // Style
    const [hashId, cssVarCls] = (0, $1b3ec09ed3105952$export$2e2bcd8739ae039)(prefixCls);
    // ============================== Size ==============================
    const mergedSize = (0, $324b30eda6ea1cd7$export$2e2bcd8739ae039)(customizeSize);
    const isSmall = mergedSize === 'small' || !!(xs && !mergedSize && responsive);
    // =========== Merged Props for Semantic ==========
    const mergedProps = {
        ...props,
        size: mergedSize
    };
    // ========================= Style ==========================
    const [mergedClassNames, mergedStyles] = (0, $4dcf69d8c3d6df5c$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    // ============================= Locale =============================
    const [contextLocale] = (0, $c176ccd8a9cbd556$export$2e2bcd8739ae039)('Pagination', (0, $2f29be0dcf198ec8$export$2e2bcd8739ae039));
    const locale = {
        ...contextLocale,
        ...customLocale
    };
    // ========================== Size Changer ==========================
    // Merge the props showSizeChanger
    const [propShowSizeChanger, propSizeChangerSelectProps] = (0, $5263e563e6efda0c$export$2e2bcd8739ae039)(showSizeChanger);
    const [contextShowSizeChanger, contextSizeChangerSelectProps] = (0, $5263e563e6efda0c$export$2e2bcd8739ae039)(contextShowSizeChangerConfig);
    const mergedShowSizeChanger = propShowSizeChanger ?? contextShowSizeChanger;
    const mergedShowSizeChangerSelectProps = propSizeChangerSelectProps ?? contextSizeChangerSelectProps;
    const SizeChanger = selectComponentClass || (0, $9dbdc31b38c7097b$export$2e2bcd8739ae039);
    // Generate options
    const mergedPageSizeOptions = $32rMB.useMemo(()=>{
        return pageSizeOptions ? pageSizeOptions.map((option)=>Number(option)) : undefined;
    }, [
        pageSizeOptions
    ]);
    // Render size changer
    const sizeChangerRender = (info)=>{
        const { disabled: disabled, size: pageSize, onSizeChange: onSizeChange, 'aria-label': ariaLabel, className: sizeChangerClassName, options: options } = info;
        const { className: propSizeChangerClassName, onChange: propSizeChangerOnChange } = mergedShowSizeChangerSelectProps || {};
        // Origin Select is using Select.Option,
        // So it make the option value must be string
        // Just for compatible
        const selectedValue = options.find((option)=>String(option.value) === String(pageSize))?.value;
        return /*#__PURE__*/ $hO8yS.createElement(SizeChanger, {
            disabled: disabled,
            showSearch: true,
            popupMatchSelectWidth: false,
            getPopupContainer: (triggerNode)=>triggerNode.parentNode,
            "aria-label": ariaLabel,
            options: options,
            ...mergedShowSizeChangerSelectProps,
            value: selectedValue,
            onChange: (nextSize, option)=>{
                onSizeChange?.(nextSize);
                propSizeChangerOnChange?.(nextSize, option);
            },
            size: isSmall ? 'small' : 'middle',
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(sizeChangerClassName, propSizeChangerClassName)
        });
    };
    // ============================= Render =============================
    const iconsProps = $32rMB.useMemo(()=>{
        const ellipsis = /*#__PURE__*/ $hO8yS.createElement("span", {
            className: `${prefixCls}-item-ellipsis`
        }, "\u2022\u2022\u2022");
        const prevIcon = /*#__PURE__*/ $hO8yS.createElement("button", {
            className: `${prefixCls}-item-link`,
            type: "button",
            tabIndex: -1
        }, direction === 'rtl' ? /*#__PURE__*/ $hO8yS.createElement((0, $c8c7be68bfada8d0$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $hO8yS.createElement((0, $e4b471ef5251dafb$export$2e2bcd8739ae039), null));
        const nextIcon = /*#__PURE__*/ $hO8yS.createElement("button", {
            className: `${prefixCls}-item-link`,
            type: "button",
            tabIndex: -1
        }, direction === 'rtl' ? /*#__PURE__*/ $hO8yS.createElement((0, $e4b471ef5251dafb$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $hO8yS.createElement((0, $c8c7be68bfada8d0$export$2e2bcd8739ae039), null));
        const jumpPrevIcon = /*#__PURE__*/ // biome-ignore lint/a11y/useValidAnchor: it is hard to refactor
        $hO8yS.createElement("a", {
            className: `${prefixCls}-item-link`
        }, /*#__PURE__*/ $hO8yS.createElement("div", {
            className: `${prefixCls}-item-container`
        }, direction === 'rtl' ? /*#__PURE__*/ $hO8yS.createElement((0, $54354c2895be849d$export$2e2bcd8739ae039), {
            className: `${prefixCls}-item-link-icon`
        }) : /*#__PURE__*/ $hO8yS.createElement((0, $fd26d0ae16b13197$export$2e2bcd8739ae039), {
            className: `${prefixCls}-item-link-icon`
        }), ellipsis));
        const jumpNextIcon = /*#__PURE__*/ // biome-ignore lint/a11y/useValidAnchor: it is hard to refactor
        $hO8yS.createElement("a", {
            className: `${prefixCls}-item-link`
        }, /*#__PURE__*/ $hO8yS.createElement("div", {
            className: `${prefixCls}-item-container`
        }, direction === 'rtl' ? /*#__PURE__*/ $hO8yS.createElement((0, $fd26d0ae16b13197$export$2e2bcd8739ae039), {
            className: `${prefixCls}-item-link-icon`
        }) : /*#__PURE__*/ $hO8yS.createElement((0, $54354c2895be849d$export$2e2bcd8739ae039), {
            className: `${prefixCls}-item-link-icon`
        }), ellipsis));
        return {
            prevIcon: prevIcon,
            nextIcon: nextIcon,
            jumpPrevIcon: jumpPrevIcon,
            jumpNextIcon: jumpNextIcon
        };
    }, [
        direction,
        prefixCls
    ]);
    const selectPrefixCls = getPrefixCls('select', customizeSelectPrefixCls);
    const extendedClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)({
        [`${prefixCls}-${align}`]: !!align,
        [`${prefixCls}-mini`]: isSmall,
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-bordered`]: token.wireframe
    }, contextClassName, className, rootClassName, mergedClassNames.root, hashId, cssVarCls);
    const mergedStyle = {
        ...mergedStyles.root,
        ...contextStyle,
        ...style
    };
    return /*#__PURE__*/ $hO8yS.createElement($hO8yS.Fragment, null, token.wireframe && /*#__PURE__*/ $hO8yS.createElement((0, $4f1d1760e0ec492d$export$2e2bcd8739ae039), {
        prefixCls: prefixCls
    }), /*#__PURE__*/ $hO8yS.createElement((0, $109bb3292f61f545$export$2e2bcd8739ae039), {
        ...iconsProps,
        ...restProps,
        styles: mergedStyles,
        classNames: mergedClassNames,
        style: mergedStyle,
        prefixCls: prefixCls,
        selectPrefixCls: selectPrefixCls,
        className: extendedClassName,
        locale: locale,
        pageSizeOptions: mergedPageSizeOptions,
        showSizeChanger: mergedShowSizeChanger,
        sizeChangerRender: sizeChangerRender
    }));
};
var $a677cf7bd8ccf20e$export$2e2bcd8739ae039 = $a677cf7bd8ccf20e$var$Pagination;


"use client";
var $6375cf69372b034f$export$2e2bcd8739ae039 = (0, $a677cf7bd8ccf20e$export$2e2bcd8739ae039);


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");

/* eslint-disable no-undefined,no-param-reassign,no-shadow */ /**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param {number} delay -                  A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher)
 *                                            are most useful.
 * @param {Function} callback -               A function to be executed after delay milliseconds. The `this` context and all arguments are passed through,
 *                                            as-is, to `callback` when the throttled-function is executed.
 * @param {object} [options] -              An object to configure options.
 * @param {boolean} [options.noTrailing] -   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds
 *                                            while the throttled-function is being called. If noTrailing is false or unspecified, callback will be executed
 *                                            one final time after the last throttled-function call. (After the throttled-function has not been called for
 *                                            `delay` milliseconds, the internal counter is reset).
 * @param {boolean} [options.noLeading] -   Optional, defaults to false. If noLeading is false, the first throttled-function call will execute callback
 *                                            immediately. If noLeading is true, the first the callback execution will be skipped. It should be noted that
 *                                            callback will never executed if both noLeading = true and noTrailing = true.
 * @param {boolean} [options.debounceMode] - If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is
 *                                            false (at end), schedule `callback` to execute after `delay` ms.
 *
 * @returns {Function} A new, throttled, function.
 */ function $da0e211d02f808af$export$de363e709c412c8a(delay, callback, options) {
    var _ref = options || {}, _ref$noTrailing = _ref.noTrailing, noTrailing = _ref$noTrailing === void 0 ? false : _ref$noTrailing, _ref$noLeading = _ref.noLeading, noLeading = _ref$noLeading === void 0 ? false : _ref$noLeading, _ref$debounceMode = _ref.debounceMode, debounceMode = _ref$debounceMode === void 0 ? undefined : _ref$debounceMode;
    /*
   * After wrapper has stopped being called, this timeout ensures that
   * `callback` is executed at the proper times in `throttle` and `end`
   * debounce modes.
   */ var timeoutID;
    var cancelled = false;
    // Keep track of the last time `callback` was executed.
    var lastExec = 0;
    // Function to clear existing timeout
    function clearExistingTimeout() {
        if (timeoutID) clearTimeout(timeoutID);
    }
    // Function to cancel next exec
    function cancel(options) {
        var _ref2 = options || {}, _ref2$upcomingOnly = _ref2.upcomingOnly, upcomingOnly = _ref2$upcomingOnly === void 0 ? false : _ref2$upcomingOnly;
        clearExistingTimeout();
        cancelled = !upcomingOnly;
    }
    /*
   * The `wrapper` function encapsulates all of the throttling / debouncing
   * functionality and when executed will limit the rate at which `callback`
   * is executed.
   */ function wrapper() {
        for(var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++)arguments_[_key] = arguments[_key];
        var self = this;
        var elapsed = Date.now() - lastExec;
        if (cancelled) return;
        // Execute `callback` and update the `lastExec` timestamp.
        function exec() {
            lastExec = Date.now();
            callback.apply(self, arguments_);
        }
        /*
     * If `debounceMode` is true (at begin) this is used to clear the flag
     * to allow future `callback` executions.
     */ function clear() {
            timeoutID = undefined;
        }
        if (!noLeading && debounceMode && !timeoutID) /*
       * Since `wrapper` is being called for the first time and
       * `debounceMode` is true (at begin), execute `callback`
       * and noLeading != true.
       */ exec();
        clearExistingTimeout();
        if (debounceMode === undefined && elapsed > delay) {
            if (noLeading) {
                /*
         * In throttle mode with noLeading, if `delay` time has
         * been exceeded, update `lastExec` and schedule `callback`
         * to execute after `delay` ms.
         */ lastExec = Date.now();
                if (!noTrailing) timeoutID = setTimeout(debounceMode ? clear : exec, delay);
            } else /*
         * In throttle mode without noLeading, if `delay` time has been exceeded, execute
         * `callback`.
         */ exec();
        } else if (noTrailing !== true) /*
       * In trailing throttle mode, since `delay` time has not been
       * exceeded, schedule `callback` to execute `delay` ms after most
       * recent execution.
       *
       * If `debounceMode` is true (at begin), schedule `clear` to execute
       * after `delay` ms.
       *
       * If `debounceMode` is false (at end), schedule `callback` to
       * execute after `delay` ms.
       */ timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
    }
    wrapper.cancel = cancel;
    // Return the wrapper function.
    return wrapper;
}
/* eslint-disable no-undefined */ /**
 * Debounce execution of a function. Debouncing, unlike throttling,
 * guarantees that a function is only executed a single time, either at the
 * very beginning of a series of calls, or at the very end.
 *
 * @param {number} delay -               A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param {Function} callback -          A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                        to `callback` when the debounced-function is executed.
 * @param {object} [options] -           An object to configure options.
 * @param {boolean} [options.atBegin] -  Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
 *                                        after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
 *                                        (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
 *
 * @returns {Function} A new, debounced function.
 */ function $da0e211d02f808af$export$61fc7d43ac8f84b0(delay, callback, options) {
    var _ref = options || {}, _ref$atBegin = _ref.atBegin, atBegin = _ref$atBegin === void 0 ? false : _ref$atBegin;
    return $da0e211d02f808af$export$de363e709c412c8a(delay, callback, {
        debounceMode: atBegin !== false
    });
}





parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");

parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");


"use client";
const $d73b0f6f7f6c0ada$var$viewSize = 100;
const $d73b0f6f7f6c0ada$var$borderWidth = $d73b0f6f7f6c0ada$var$viewSize / 5;
const $d73b0f6f7f6c0ada$var$radius = $d73b0f6f7f6c0ada$var$viewSize / 2 - $d73b0f6f7f6c0ada$var$borderWidth / 2;
const $d73b0f6f7f6c0ada$var$circumference = $d73b0f6f7f6c0ada$var$radius * 2 * Math.PI;
const $d73b0f6f7f6c0ada$var$position = 50;
const $d73b0f6f7f6c0ada$var$CustomCircle = (props)=>{
    const { dotClassName: dotClassName, style: style, hasCircleCls: hasCircleCls } = props;
    return /*#__PURE__*/ $hO8yS.createElement("circle", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${dotClassName}-circle`, {
            [`${dotClassName}-circle-bg`]: hasCircleCls
        }),
        r: $d73b0f6f7f6c0ada$var$radius,
        cx: $d73b0f6f7f6c0ada$var$position,
        cy: $d73b0f6f7f6c0ada$var$position,
        strokeWidth: $d73b0f6f7f6c0ada$var$borderWidth,
        style: style
    });
};
const $d73b0f6f7f6c0ada$var$Progress = ({ percent: percent, prefixCls: prefixCls })=>{
    const dotClassName = `${prefixCls}-dot`;
    const holderClassName = `${dotClassName}-holder`;
    const hideClassName = `${holderClassName}-hidden`;
    const [render, setRender] = $32rMB.useState(false);
    // ==================== Visible =====================
    (0, $60cea2402df671e7$export$2e2bcd8739ae039)(()=>{
        if (percent !== 0) setRender(true);
    }, [
        percent !== 0
    ]);
    // ==================== Progress ====================
    const safePtg = Math.max(Math.min(percent, 100), 0);
    // ===================== Render =====================
    if (!render) return null;
    const circleStyle = {
        strokeDashoffset: `${$d73b0f6f7f6c0ada$var$circumference / 4}`,
        strokeDasharray: `${$d73b0f6f7f6c0ada$var$circumference * safePtg / 100} ${$d73b0f6f7f6c0ada$var$circumference * (100 - safePtg) / 100}`
    };
    return /*#__PURE__*/ $hO8yS.createElement("span", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(holderClassName, `${dotClassName}-progress`, safePtg <= 0 && hideClassName)
    }, /*#__PURE__*/ $hO8yS.createElement("svg", {
        viewBox: `0 0 ${$d73b0f6f7f6c0ada$var$viewSize} ${$d73b0f6f7f6c0ada$var$viewSize}`,
        role: "progressbar",
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-valuenow": safePtg
    }, /*#__PURE__*/ $hO8yS.createElement($d73b0f6f7f6c0ada$var$CustomCircle, {
        dotClassName: dotClassName,
        hasCircleCls: true
    }), /*#__PURE__*/ $hO8yS.createElement($d73b0f6f7f6c0ada$var$CustomCircle, {
        dotClassName: dotClassName,
        style: circleStyle
    })));
};
var $d73b0f6f7f6c0ada$export$2e2bcd8739ae039 = $d73b0f6f7f6c0ada$var$Progress;


"use client";
function $5b965db1093ae783$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, percent: percent = 0, className: className, style: style } = props;
    const dotClassName = `${prefixCls}-dot`;
    const holderClassName = `${dotClassName}-holder`;
    const hideClassName = `${holderClassName}-hidden`;
    // ===================== Render =====================
    return /*#__PURE__*/ $hO8yS.createElement($hO8yS.Fragment, null, /*#__PURE__*/ $hO8yS.createElement("span", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(holderClassName, className, percent > 0 && hideClassName),
        style: style
    }, /*#__PURE__*/ $hO8yS.createElement("span", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(dotClassName, `${prefixCls}-dot-spin`)
    }, [
        1,
        2,
        3,
        4
    ].map((i)=>/*#__PURE__*/ $hO8yS.createElement("i", {
            className: `${prefixCls}-dot-item`,
            key: i
        })))), /*#__PURE__*/ $hO8yS.createElement((0, $d73b0f6f7f6c0ada$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        percent: percent
    }));
}


"use client";
function $0dfd4a067431eaf9$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, indicator: indicator, percent: percent, className: className, style: style } = props;
    const dotClassName = `${prefixCls}-dot`;
    if (indicator && /*#__PURE__*/ $N3oW3.isValidElement(indicator)) return (0, $62609775897a768c$export$e530037191fcd5d7)(indicator, (currentProps)=>({
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(currentProps.className, dotClassName, className),
            style: {
                ...currentProps.style,
                ...style
            },
            percent: percent
        }));
    return /*#__PURE__*/ $hO8yS.createElement((0, $5b965db1093ae783$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        percent: percent,
        className: className,
        style: style
    });
}





const $ebaea6f7c0dd24e6$var$antSpinMove = new (0, $f806545df26bb0b4$export$2e2bcd8739ae039)('antSpinMove', {
    to: {
        opacity: 1
    }
});
const $ebaea6f7c0dd24e6$var$antRotate = new (0, $f806545df26bb0b4$export$2e2bcd8739ae039)('antRotate', {
    to: {
        transform: 'rotate(405deg)'
    }
});
const $ebaea6f7c0dd24e6$var$genSpinStyle = (token)=>{
    const { componentCls: componentCls, calc: calc } = token;
    return {
        [componentCls]: {
            ...(0, $2f353af2b0f7600b$export$23997c3e44cc1c59)(token),
            position: 'absolute',
            display: 'none',
            color: token.colorPrimary,
            fontSize: 0,
            textAlign: 'center',
            verticalAlign: 'middle',
            opacity: 0,
            transition: `transform ${token.motionDurationSlow} ${token.motionEaseInOutCirc}`,
            '&-spinning': {
                position: 'relative',
                display: 'inline-block',
                opacity: 1
            },
            [`${componentCls}-text`]: {
                fontSize: token.fontSize,
                paddingTop: calc(calc(token.dotSize).sub(token.fontSize)).div(2).add(2).equal()
            },
            '&-fullscreen': {
                position: 'fixed',
                width: '100vw',
                height: '100vh',
                backgroundColor: token.colorBgMask,
                zIndex: token.zIndexPopupBase,
                inset: 0,
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
                justifyContent: 'center',
                opacity: 0,
                visibility: 'hidden',
                transition: `all ${token.motionDurationMid}`,
                '&-show': {
                    opacity: 1,
                    visibility: 'visible'
                },
                [componentCls]: {
                    [`${componentCls}-dot-holder`]: {
                        color: token.colorWhite
                    },
                    [`${componentCls}-text`]: {
                        color: token.colorTextLightSolid
                    }
                }
            },
            '&-nested-loading': {
                position: 'relative',
                [`> div > ${componentCls}`]: {
                    position: 'absolute',
                    top: 0,
                    insetInlineStart: 0,
                    zIndex: 4,
                    display: 'block',
                    width: '100%',
                    height: '100%',
                    maxHeight: token.contentHeight,
                    [`${componentCls}-dot`]: {
                        position: 'absolute',
                        top: '50%',
                        insetInlineStart: '50%',
                        margin: calc(token.dotSize).mul(-1).div(2).equal()
                    },
                    [`${componentCls}-text`]: {
                        position: 'absolute',
                        top: '50%',
                        width: '100%',
                        textShadow: `0 1px 2px ${token.colorBgContainer}` // FIXME: shadow
                    },
                    [`&${componentCls}-show-text ${componentCls}-dot`]: {
                        marginTop: calc(token.dotSize).div(2).mul(-1).sub(10).equal()
                    },
                    '&-sm': {
                        [`${componentCls}-dot`]: {
                            margin: calc(token.dotSizeSM).mul(-1).div(2).equal()
                        },
                        [`${componentCls}-text`]: {
                            paddingTop: calc(calc(token.dotSizeSM).sub(token.fontSize)).div(2).add(2).equal()
                        },
                        [`&${componentCls}-show-text ${componentCls}-dot`]: {
                            marginTop: calc(token.dotSizeSM).div(2).mul(-1).sub(10).equal()
                        }
                    },
                    '&-lg': {
                        [`${componentCls}-dot`]: {
                            margin: calc(token.dotSizeLG).mul(-1).div(2).equal()
                        },
                        [`${componentCls}-text`]: {
                            paddingTop: calc(calc(token.dotSizeLG).sub(token.fontSize)).div(2).add(2).equal()
                        },
                        [`&${componentCls}-show-text ${componentCls}-dot`]: {
                            marginTop: calc(token.dotSizeLG).div(2).mul(-1).sub(10).equal()
                        }
                    }
                },
                [`${componentCls}-container`]: {
                    position: 'relative',
                    transition: `opacity ${token.motionDurationSlow}`,
                    '&::after': {
                        position: 'absolute',
                        top: 0,
                        insetInlineEnd: 0,
                        bottom: 0,
                        insetInlineStart: 0,
                        zIndex: 10,
                        width: '100%',
                        height: '100%',
                        background: token.colorBgContainer,
                        opacity: 0,
                        transition: `all ${token.motionDurationSlow}`,
                        content: '""',
                        pointerEvents: 'none'
                    }
                },
                [`${componentCls}-blur`]: {
                    clear: 'both',
                    opacity: 0.5,
                    userSelect: 'none',
                    pointerEvents: 'none',
                    '&::after': {
                        opacity: 0.4,
                        pointerEvents: 'auto'
                    }
                }
            },
            // tip
            // ------------------------------
            '&-tip': {
                color: token.spinDotDefault
            },
            // holder
            // ------------------------------
            [`${componentCls}-dot-holder`]: {
                width: '1em',
                height: '1em',
                fontSize: token.dotSize,
                display: 'inline-block',
                transition: `transform ${token.motionDurationSlow} ease, opacity ${token.motionDurationSlow} ease`,
                transformOrigin: '50% 50%',
                lineHeight: 1,
                color: token.colorPrimary,
                '&-hidden': {
                    transform: 'scale(0.3)',
                    opacity: 0
                }
            },
            // progress
            // ------------------------------
            [`${componentCls}-dot-progress`]: {
                position: 'absolute',
                inset: 0
            },
            // dots
            // ------------------------------
            [`${componentCls}-dot`]: {
                position: 'relative',
                display: 'inline-block',
                fontSize: token.dotSize,
                width: '1em',
                height: '1em',
                '&-item': {
                    position: 'absolute',
                    display: 'block',
                    width: calc(token.dotSize).sub(calc(token.marginXXS).div(2)).div(2).equal(),
                    height: calc(token.dotSize).sub(calc(token.marginXXS).div(2)).div(2).equal(),
                    background: 'currentColor',
                    borderRadius: '100%',
                    transform: 'scale(0.75)',
                    transformOrigin: '50% 50%',
                    opacity: 0.3,
                    animationName: $ebaea6f7c0dd24e6$var$antSpinMove,
                    animationDuration: '1s',
                    animationIterationCount: 'infinite',
                    animationTimingFunction: 'linear',
                    animationDirection: 'alternate',
                    '&:nth-child(1)': {
                        top: 0,
                        insetInlineStart: 0,
                        animationDelay: '0s'
                    },
                    '&:nth-child(2)': {
                        top: 0,
                        insetInlineEnd: 0,
                        animationDelay: '0.4s'
                    },
                    '&:nth-child(3)': {
                        insetInlineEnd: 0,
                        bottom: 0,
                        animationDelay: '0.8s'
                    },
                    '&:nth-child(4)': {
                        bottom: 0,
                        insetInlineStart: 0,
                        animationDelay: '1.2s'
                    }
                },
                '&-spin': {
                    transform: 'rotate(45deg)',
                    animationName: $ebaea6f7c0dd24e6$var$antRotate,
                    animationDuration: '1.2s',
                    animationIterationCount: 'infinite',
                    animationTimingFunction: 'linear'
                },
                '&-circle': {
                    strokeLinecap: 'round',
                    transition: [
                        'stroke-dashoffset',
                        'stroke-dasharray',
                        'stroke',
                        'stroke-width',
                        'opacity'
                    ].map((item)=>`${item} ${token.motionDurationSlow} ease`).join(','),
                    fillOpacity: 0,
                    stroke: 'currentcolor'
                },
                '&-circle-bg': {
                    stroke: token.colorFillSecondary
                }
            },
            // small
            [`&-sm ${componentCls}-dot`]: {
                '&, &-holder': {
                    fontSize: token.dotSizeSM
                }
            },
            [`&-sm ${componentCls}-dot-holder`]: {
                i: {
                    width: calc(calc(token.dotSizeSM).sub(calc(token.marginXXS).div(2))).div(2).equal(),
                    height: calc(calc(token.dotSizeSM).sub(calc(token.marginXXS).div(2))).div(2).equal()
                }
            },
            // large
            [`&-lg ${componentCls}-dot`]: {
                '&, &-holder': {
                    fontSize: token.dotSizeLG
                }
            },
            [`&-lg ${componentCls}-dot-holder`]: {
                i: {
                    width: calc(calc(token.dotSizeLG).sub(token.marginXXS)).div(2).equal(),
                    height: calc(calc(token.dotSizeLG).sub(token.marginXXS)).div(2).equal()
                }
            },
            [`&${componentCls}-show-text ${componentCls}-text`]: {
                display: 'block'
            }
        }
    };
};
const $ebaea6f7c0dd24e6$export$9ca1be8807fe0675 = (token)=>{
    const { controlHeightLG: controlHeightLG, controlHeight: controlHeight } = token;
    return {
        contentHeight: 400,
        dotSize: controlHeightLG / 2,
        dotSizeSM: controlHeightLG * 0.35,
        dotSizeLG: controlHeight
    };
};
var // ============================== Export ==============================
$ebaea6f7c0dd24e6$export$2e2bcd8739ae039 = (0, $d4a2dc313c4d90a4$export$51ec95de45185b42)('Spin', (token)=>{
    const spinToken = (0, $90c11ca6cb263fd9$export$4950aa0f605343fb)(token, {
        spinDotDefault: token.colorTextDescription
    });
    return $ebaea6f7c0dd24e6$var$genSpinStyle(spinToken);
}, $ebaea6f7c0dd24e6$export$9ca1be8807fe0675);


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
const $214a7952d911c317$var$AUTO_INTERVAL = 200;
const $214a7952d911c317$var$STEP_BUCKETS = [
    [
        30,
        0.05
    ],
    [
        70,
        0.03
    ],
    [
        96,
        0.01
    ]
];
function $214a7952d911c317$export$2e2bcd8739ae039(spinning, percent) {
    const [mockPercent, setMockPercent] = $32rMB.useState(0);
    const mockIntervalRef = $32rMB.useRef(null);
    const isAuto = percent === 'auto';
    $32rMB.useEffect(()=>{
        if (isAuto && spinning) {
            setMockPercent(0);
            mockIntervalRef.current = setInterval(()=>{
                setMockPercent((prev)=>{
                    const restPTG = 100 - prev;
                    for(let i = 0; i < $214a7952d911c317$var$STEP_BUCKETS.length; i += 1){
                        const [limit, stepPtg] = $214a7952d911c317$var$STEP_BUCKETS[i];
                        if (prev <= limit) return prev + restPTG * stepPtg;
                    }
                    return prev;
                });
            }, $214a7952d911c317$var$AUTO_INTERVAL);
        }
        return ()=>{
            if (mockIntervalRef.current) {
                clearInterval(mockIntervalRef.current);
                mockIntervalRef.current = null;
            }
        };
    }, [
        isAuto,
        spinning
    ]);
    return isAuto ? mockPercent : percent;
}


"use client";
const $e72f20bad19c9555$var$_SpinSizes = [
    'small',
    'default',
    'large'
];
// Render indicator
let $e72f20bad19c9555$var$defaultIndicator;
function $e72f20bad19c9555$var$shouldDelay(spinning, delay) {
    return !!spinning && !!delay && !Number.isNaN(Number(delay));
}
const $e72f20bad19c9555$var$Spin = (props)=>{
    const { prefixCls: customizePrefixCls, spinning: customSpinning = true, delay: delay = 0, className: className, rootClassName: rootClassName, size: size = 'default', tip: tip, wrapperClassName: wrapperClassName, style: style, children: children, fullscreen: fullscreen = false, indicator: indicator, percent: percent, classNames: classNames, styles: styles, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, indicator: contextIndicator, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $dd01e2f5a4b8605d$export$46f4bd6436a25a31)('spin');
    const prefixCls = getPrefixCls('spin', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $ebaea6f7c0dd24e6$export$2e2bcd8739ae039)(prefixCls);
    const [spinning, setSpinning] = $32rMB.useState(()=>customSpinning && !$e72f20bad19c9555$var$shouldDelay(customSpinning, delay));
    const mergedPercent = (0, $214a7952d911c317$export$2e2bcd8739ae039)(spinning, percent);
    $32rMB.useEffect(()=>{
        if (customSpinning) {
            const showSpinning = (0, $da0e211d02f808af$export$61fc7d43ac8f84b0)(delay, ()=>{
                setSpinning(true);
            });
            showSpinning();
            return ()=>{
                showSpinning?.cancel?.();
            };
        }
        setSpinning(false);
    }, [
        delay,
        customSpinning
    ]);
    const isNestedPattern = $32rMB.useMemo(()=>typeof children !== 'undefined' && !fullscreen, [
        children,
        fullscreen
    ]);
    // =========== Merged Props for Semantic ===========
    const mergedProps = {
        ...props,
        size: size,
        spinning: spinning,
        tip: tip,
        fullscreen: fullscreen,
        children: children,
        percent: mergedPercent
    };
    // ========================= Style ==========================
    const [mergedClassNames, mergedStyles] = (0, $4dcf69d8c3d6df5c$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    const spinClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, contextClassName, {
        [`${prefixCls}-sm`]: size === 'small',
        [`${prefixCls}-lg`]: size === 'large',
        [`${prefixCls}-spinning`]: spinning,
        [`${prefixCls}-show-text`]: !!tip,
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, className, !fullscreen && rootClassName, !fullscreen && mergedClassNames.root, hashId, cssVarCls);
    const containerClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-container`, {
        [`${prefixCls}-blur`]: spinning
    });
    const mergedIndicator = indicator ?? contextIndicator ?? $e72f20bad19c9555$var$defaultIndicator;
    const mergedStyle = {
        ...contextStyle,
        ...style
    };
    const spinElement = /*#__PURE__*/ $hO8yS.createElement("div", {
        ...restProps,
        style: fullscreen ? mergedStyle : {
            ...mergedStyles.root,
            ...mergedStyle
        },
        className: spinClassName,
        "aria-live": "polite",
        "aria-busy": spinning
    }, /*#__PURE__*/ $hO8yS.createElement((0, $0dfd4a067431eaf9$export$2e2bcd8739ae039), {
        className: mergedClassNames.indicator,
        style: mergedStyles.indicator,
        prefixCls: prefixCls,
        indicator: mergedIndicator,
        percent: mergedPercent
    }), tip && (isNestedPattern || fullscreen) ? /*#__PURE__*/ $hO8yS.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-text`, mergedClassNames.tip),
        style: mergedStyles.tip
    }, tip) : null);
    if (isNestedPattern) return /*#__PURE__*/ $hO8yS.createElement("div", {
        ...restProps,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-nested-loading`, wrapperClassName, mergedClassNames.wrapper, hashId, cssVarCls),
        style: mergedStyles.wrapper
    }, spinning && /*#__PURE__*/ $hO8yS.createElement("div", {
        key: "loading"
    }, spinElement), /*#__PURE__*/ $hO8yS.createElement("div", {
        className: containerClassName,
        key: "container"
    }, children));
    if (fullscreen) return /*#__PURE__*/ $hO8yS.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-fullscreen`, {
            [`${prefixCls}-fullscreen-show`]: spinning
        }, rootClassName, hashId, cssVarCls, mergedClassNames.mask),
        style: mergedStyles.mask
    }, spinElement);
    return spinElement;
};
$e72f20bad19c9555$var$Spin.setDefaultIndicator = (indicator)=>{
    $e72f20bad19c9555$var$defaultIndicator = indicator;
};
var $e72f20bad19c9555$export$2e2bcd8739ae039 = $e72f20bad19c9555$var$Spin;



parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");

"use client";
function $c5c4c34b0bb1616c$var$renderExpandIcon(locale) {
    return (props)=>{
        const { prefixCls: prefixCls, onExpand: onExpand, record: record, expanded: expanded, expandable: expandable } = props;
        const iconPrefix = `${prefixCls}-row-expand-icon`;
        return /*#__PURE__*/ $hO8yS.createElement("button", {
            type: "button",
            onClick: (e)=>{
                onExpand(record, e);
                e.stopPropagation();
            },
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(iconPrefix, {
                [`${iconPrefix}-spaced`]: !expandable,
                [`${iconPrefix}-expanded`]: expandable && expanded,
                [`${iconPrefix}-collapsed`]: expandable && !expanded
            }),
            "aria-label": expanded ? locale.collapse : locale.expand,
            "aria-expanded": expanded
        });
    };
}
var $c5c4c34b0bb1616c$export$2e2bcd8739ae039 = $c5c4c34b0bb1616c$var$renderExpandIcon;


function $bd71685f1bb86138$export$2e2bcd8739ae039(prefixCls) {
    const getContainerWidth = (ele, width)=>{
        const container = ele.querySelector(`.${prefixCls}-container`);
        let returnWidth = width;
        if (container) {
            const style = getComputedStyle(container);
            const borderLeft = Number.parseInt(style.borderLeftWidth, 10);
            const borderRight = Number.parseInt(style.borderRightWidth, 10);
            returnWidth = width - borderLeft - borderRight;
        }
        return returnWidth;
    };
    return getContainerWidth;
}



parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");

const $4e57f4bd37ec1f3f$export$480219a02f196e72 = (column, defaultKey)=>{
    if ('key' in column && column.key !== undefined && column.key !== null) return column.key;
    if (column.dataIndex) return Array.isArray(column.dataIndex) ? column.dataIndex.join('.') : column.dataIndex;
    return defaultKey;
};
function $4e57f4bd37ec1f3f$export$7e4db04adce9b4db(index, pos) {
    return pos ? `${pos}-${index}` : `${index}`;
}
const $4e57f4bd37ec1f3f$export$cfda450db2088de7 = (title, props)=>{
    if (typeof title === 'function') return title(props);
    return title;
};
const $4e57f4bd37ec1f3f$export$1c24e0676a106839 = (title, props)=>{
    const res = $4e57f4bd37ec1f3f$export$cfda450db2088de7(title, props);
    if (Object.prototype.toString.call(res) === '[object Object]') return '';
    return res;
};



parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");
parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
// This icon file is generated automatically.
var $ec218751af62bba2$var$FilterFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M349 838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V642H349v196zm531.1-684H143.9c-24.5 0-39.8 26.7-27.5 48l221.3 376h348.8l221.3-376c12.1-21.3-3.2-48-27.7-48z"
                }
            }
        ]
    },
    "name": "filter",
    "theme": "filled"
};
var $ec218751af62bba2$export$2e2bcd8739ae039 = $ec218751af62bba2$var$FilterFilled;



function $fc6affef73086579$var$_extends() {
    $fc6affef73086579$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $fc6affef73086579$var$_extends.apply(this, arguments);
}
const $fc6affef73086579$var$FilterFilled = (props, ref)=>/*#__PURE__*/ $hO8yS.createElement((0, $5fd6f3f3c400c267$export$2e2bcd8739ae039), $fc6affef73086579$var$_extends({}, props, {
        ref: ref,
        icon: (0, $ec218751af62bba2$export$2e2bcd8739ae039)
    }));
/**![filter](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTM0OSA4MzhjMCAxNy43IDE0LjIgMzIgMzEuOCAzMmgyNjIuNGMxNy42IDAgMzEuOC0xNC4zIDMxLjgtMzJWNjQySDM0OXYxOTZ6bTUzMS4xLTY4NEgxNDMuOWMtMjQuNSAwLTM5LjggMjYuNy0yNy41IDQ4bDIyMS4zIDM3NmgzNDguOGwyMjEuMy0zNzZjMTIuMS0yMS4zLTMuMi00OC0yNy43LTQ4eiIgLz48L3N2Zz4=) */ const $fc6affef73086579$var$RefIcon = /*#__PURE__*/ $N3oW3.forwardRef($fc6affef73086579$var$FilterFilled);
var $fc6affef73086579$export$2e2bcd8739ae039 = $fc6affef73086579$var$RefIcon;





parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");

const $48bc6347a52d7873$export$bd58d1a153fd4998 = (initialValue)=>{
    const ref = $32rMB.useRef(initialValue);
    const [, forceUpdate] = (0, $fd17bb5dce895170$export$91db9bc4f8ac944a)();
    return [
        ()=>ref.current,
        (newValue)=>{
            ref.current = newValue;
            forceUpdate();
        }
    ];
};















parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");


var $N3oW3 = parcelRequire("N3oW3");
const $550c11b69a6ae5c7$var$DropIndicator = (props)=>{
    const { dropPosition: dropPosition, dropLevelOffset: dropLevelOffset, indent: indent } = props;
    const style = {
        pointerEvents: 'none',
        position: 'absolute',
        right: 0,
        backgroundColor: 'red',
        height: 2
    };
    switch(dropPosition){
        case -1:
            style.top = 0;
            style.left = -dropLevelOffset * indent;
            break;
        case 1:
            style.bottom = 0;
            style.left = -dropLevelOffset * indent;
            break;
        case 0:
            style.bottom = 0;
            style.left = indent;
            break;
    }
    return /*#__PURE__*/ (0, $N3oW3.default).createElement("div", {
        style: style
    });
};
var $550c11b69a6ae5c7$export$2e2bcd8739ae039 = $550c11b69a6ae5c7$var$DropIndicator;




parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");



parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");

/**
 * Trigger only when component unmount
 */ function $2e4e1797a098d09e$var$useUnmount(triggerStart, triggerEnd) {
    const [firstMount, setFirstMount] = $32rMB.useState(false);
    (0, $60cea2402df671e7$export$2e2bcd8739ae039)(()=>{
        if (firstMount) {
            triggerStart();
            return ()=>{
                triggerEnd();
            };
        }
    }, [
        firstMount
    ]);
    (0, $60cea2402df671e7$export$2e2bcd8739ae039)(()=>{
        setFirstMount(true);
        return ()=>{
            setFirstMount(false);
        };
    }, []);
}
var $2e4e1797a098d09e$export$2e2bcd8739ae039 = $2e4e1797a098d09e$var$useUnmount;



function $f8d7c09e780ec12b$var$_extends() {
    $f8d7c09e780ec12b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f8d7c09e780ec12b$var$_extends.apply(this, arguments);
}
const $f8d7c09e780ec12b$var$MotionTreeNode = /*#__PURE__*/ $N3oW3.forwardRef((oriProps, ref)=>{
    const { className: className, style: style, motion: motion, motionNodes: motionNodes, motionType: motionType, onMotionStart: onOriginMotionStart, onMotionEnd: onOriginMotionEnd, active: active, treeNodeRequiredProps: treeNodeRequiredProps, ...props } = oriProps;
    const [visible, setVisible] = $32rMB.useState(true);
    const { prefixCls: prefixCls } = $32rMB.useContext((0, $338114f31d3e4af5$export$dfae7d399eea2568));
    // Calculate target visible here.
    // And apply in effect to make `leave` motion work.
    const targetVisible = motionNodes && motionType !== 'hide';
    (0, $60cea2402df671e7$export$2e2bcd8739ae039)(()=>{
        if (motionNodes) {
            if (targetVisible !== visible) setVisible(targetVisible);
        }
    }, [
        motionNodes
    ]);
    const triggerMotionStart = ()=>{
        if (motionNodes) onOriginMotionStart();
    };
    // Should only trigger once
    const triggerMotionEndRef = $32rMB.useRef(false);
    const triggerMotionEnd = ()=>{
        if (motionNodes && !triggerMotionEndRef.current) {
            triggerMotionEndRef.current = true;
            onOriginMotionEnd();
        }
    };
    // Effect if unmount
    (0, $2e4e1797a098d09e$export$2e2bcd8739ae039)(triggerMotionStart, triggerMotionEnd);
    // Motion end event
    const onVisibleChanged = (nextVisible)=>{
        if (targetVisible === nextVisible) triggerMotionEnd();
    };
    if (motionNodes) return /*#__PURE__*/ $hO8yS.createElement((0, $db80a026d0a86ece$export$2e2bcd8739ae039), $f8d7c09e780ec12b$var$_extends({
        ref: ref,
        visible: visible
    }, motion, {
        motionAppear: motionType === 'show',
        onVisibleChanged: onVisibleChanged
    }), ({ className: motionClassName, style: motionStyle }, motionRef)=>/*#__PURE__*/ $hO8yS.createElement("div", {
            ref: motionRef,
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-treenode-motion`, motionClassName),
            style: motionStyle
        }, motionNodes.map((treeNode)=>{
            const { data: { ...restProps }, title: title, key: key, isStart: isStart, isEnd: isEnd } = treeNode;
            delete restProps.children;
            const treeNodeProps = (0, $8c21c3908ec083b2$export$d961fd523a514db5)(key, treeNodeRequiredProps);
            return /*#__PURE__*/ $hO8yS.createElement((0, $98e6aa449e26d899$export$2e2bcd8739ae039), $f8d7c09e780ec12b$var$_extends({}, restProps, treeNodeProps, {
                title: title,
                active: active,
                data: treeNode.data,
                key: key,
                isStart: isStart,
                isEnd: isEnd
            }));
        })));
    return /*#__PURE__*/ $hO8yS.createElement((0, $98e6aa449e26d899$export$2e2bcd8739ae039), $f8d7c09e780ec12b$var$_extends({
        domRef: ref,
        className: className,
        style: style
    }, props, {
        active: active
    }));
});
var $f8d7c09e780ec12b$export$2e2bcd8739ae039 = $f8d7c09e780ec12b$var$MotionTreeNode;


function $814910d9750c88bb$export$d561f9b5d6be9236(prev = [], next = []) {
    const prevLen = prev.length;
    const nextLen = next.length;
    if (Math.abs(prevLen - nextLen) !== 1) return {
        add: false,
        key: null
    };
    function find(shorter, longer) {
        const cache = new Map();
        shorter.forEach((key)=>{
            cache.set(key, true);
        });
        const keys = longer.filter((key)=>!cache.has(key));
        return keys.length === 1 ? keys[0] : null;
    }
    if (prevLen < nextLen) return {
        add: true,
        key: find(prev, next)
    };
    return {
        add: false,
        key: find(next, prev)
    };
}
function $814910d9750c88bb$export$d9cfb1169163442d(shorter, longer, key) {
    const shorterStartIndex = shorter.findIndex((data)=>data.key === key);
    const shorterEndNode = shorter[shorterStartIndex + 1];
    const longerStartIndex = longer.findIndex((data)=>data.key === key);
    if (shorterEndNode) {
        const longerEndIndex = longer.findIndex((data)=>data.key === shorterEndNode.key);
        return longer.slice(longerStartIndex + 1, longerEndIndex);
    }
    return longer.slice(longerStartIndex + 1);
}



function $9e8364246bc59c04$var$_extends() {
    $9e8364246bc59c04$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9e8364246bc59c04$var$_extends.apply(this, arguments);
}
const $9e8364246bc59c04$var$HIDDEN_STYLE = {
    width: 0,
    height: 0,
    display: 'flex',
    overflow: 'hidden',
    opacity: 0,
    border: 0,
    padding: 0,
    margin: 0
};
const $9e8364246bc59c04$var$noop = ()=>{};
const $9e8364246bc59c04$export$17c02cdd52a7d889 = `RC_TREE_MOTION_${Math.random()}`;
const $9e8364246bc59c04$var$MotionNode = {
    key: $9e8364246bc59c04$export$17c02cdd52a7d889
};
const $9e8364246bc59c04$export$2d18abad5109a402 = {
    key: $9e8364246bc59c04$export$17c02cdd52a7d889,
    level: 0,
    index: 0,
    pos: '0',
    node: $9e8364246bc59c04$var$MotionNode,
    nodes: [
        $9e8364246bc59c04$var$MotionNode
    ]
};
const $9e8364246bc59c04$var$MotionFlattenData = {
    parent: null,
    children: [],
    pos: $9e8364246bc59c04$export$2d18abad5109a402.pos,
    data: $9e8364246bc59c04$var$MotionNode,
    title: null,
    key: $9e8364246bc59c04$export$17c02cdd52a7d889,
    /** Hold empty list here since we do not use it */ isStart: [],
    isEnd: []
};
function $9e8364246bc59c04$export$435bacc8d7a01e14(list, virtual, height, itemHeight) {
    if (virtual === false || !height) return list;
    return list.slice(0, Math.ceil(height / itemHeight) + 1);
}
function $9e8364246bc59c04$var$itemKey(item) {
    const { key: key, pos: pos } = item;
    return (0, $8c21c3908ec083b2$export$a47fb462a08de82f)(key, pos);
}
function $9e8364246bc59c04$var$getAccessibilityPath(item) {
    let path = String(item.data.key);
    let current = item;
    while(current.parent){
        current = current.parent;
        path = `${current.data.key} > ${path}`;
    }
    return path;
}
const $9e8364246bc59c04$var$NodeList = /*#__PURE__*/ $N3oW3.forwardRef((props, ref)=>{
    const { prefixCls: prefixCls, data: data, selectable: selectable, checkable: checkable, expandedKeys: expandedKeys, selectedKeys: selectedKeys, checkedKeys: checkedKeys, loadedKeys: loadedKeys, loadingKeys: loadingKeys, halfCheckedKeys: halfCheckedKeys, keyEntities: keyEntities, disabled: disabled, dragging: dragging, dragOverNodeKey: dragOverNodeKey, dropPosition: dropPosition, motion: motion, height: height, itemHeight: itemHeight, virtual: virtual, scrollWidth: scrollWidth, focusable: focusable, activeItem: activeItem, focused: focused, tabIndex: tabIndex, onKeyDown: onKeyDown, onFocus: onFocus, onBlur: onBlur, onActiveChange: onActiveChange, onListChangeStart: onListChangeStart, onListChangeEnd: onListChangeEnd, ...domProps } = props;
    // =============================== Ref ================================
    const listRef = $32rMB.useRef(null);
    const indentMeasurerRef = $32rMB.useRef(null);
    $32rMB.useImperativeHandle(ref, ()=>({
            scrollTo: (scroll)=>{
                listRef.current.scrollTo(scroll);
            },
            getIndentWidth: ()=>indentMeasurerRef.current.offsetWidth
        }));
    // ============================== Motion ==============================
    const [prevExpandedKeys, setPrevExpandedKeys] = $32rMB.useState(expandedKeys);
    const [prevData, setPrevData] = $32rMB.useState(data);
    const [transitionData, setTransitionData] = $32rMB.useState(data);
    const [transitionRange, setTransitionRange] = $32rMB.useState([]);
    const [motionType, setMotionType] = $32rMB.useState(null);
    // When motion end but data change, this will makes data back to previous one
    const dataRef = $32rMB.useRef(data);
    dataRef.current = data;
    function onMotionEnd() {
        const latestData = dataRef.current;
        setPrevData(latestData);
        setTransitionData(latestData);
        setTransitionRange([]);
        setMotionType(null);
        onListChangeEnd();
    }
    // Do animation if expanded keys changed
    // layoutEffect here to avoid blink of node removing
    (0, $60cea2402df671e7$export$2e2bcd8739ae039)(()=>{
        setPrevExpandedKeys(expandedKeys);
        const diffExpanded = (0, $814910d9750c88bb$export$d561f9b5d6be9236)(prevExpandedKeys, expandedKeys);
        if (diffExpanded.key !== null) {
            if (diffExpanded.add) {
                const keyIndex = prevData.findIndex(({ key: key })=>key === diffExpanded.key);
                const rangeNodes = $9e8364246bc59c04$export$435bacc8d7a01e14((0, $814910d9750c88bb$export$d9cfb1169163442d)(prevData, data, diffExpanded.key), virtual, height, itemHeight);
                const newTransitionData = prevData.slice();
                newTransitionData.splice(keyIndex + 1, 0, $9e8364246bc59c04$var$MotionFlattenData);
                setTransitionData(newTransitionData);
                setTransitionRange(rangeNodes);
                setMotionType('show');
            } else {
                const keyIndex = data.findIndex(({ key: key })=>key === diffExpanded.key);
                const rangeNodes = $9e8364246bc59c04$export$435bacc8d7a01e14((0, $814910d9750c88bb$export$d9cfb1169163442d)(data, prevData, diffExpanded.key), virtual, height, itemHeight);
                const newTransitionData = data.slice();
                newTransitionData.splice(keyIndex + 1, 0, $9e8364246bc59c04$var$MotionFlattenData);
                setTransitionData(newTransitionData);
                setTransitionRange(rangeNodes);
                setMotionType('hide');
            }
        } else if (prevData !== data) {
            // If whole data changed, we just refresh the list
            setPrevData(data);
            setTransitionData(data);
        }
    }, [
        expandedKeys,
        data
    ]);
    // We should clean up motion if is changed by dragging
    $32rMB.useEffect(()=>{
        if (!dragging) onMotionEnd();
    }, [
        dragging
    ]);
    const mergedData = motion ? transitionData : data;
    const treeNodeRequiredProps = {
        expandedKeys: expandedKeys,
        selectedKeys: selectedKeys,
        loadedKeys: loadedKeys,
        loadingKeys: loadingKeys,
        checkedKeys: checkedKeys,
        halfCheckedKeys: halfCheckedKeys,
        dragOverNodeKey: dragOverNodeKey,
        dropPosition: dropPosition,
        keyEntities: keyEntities
    };
    return /*#__PURE__*/ $hO8yS.createElement($hO8yS.Fragment, null, focused && activeItem && /*#__PURE__*/ $hO8yS.createElement("span", {
        style: $9e8364246bc59c04$var$HIDDEN_STYLE,
        "aria-live": "assertive"
    }, $9e8364246bc59c04$var$getAccessibilityPath(activeItem)), /*#__PURE__*/ $hO8yS.createElement("div", null, /*#__PURE__*/ $hO8yS.createElement("input", {
        style: $9e8364246bc59c04$var$HIDDEN_STYLE,
        disabled: focusable === false || disabled,
        tabIndex: focusable !== false ? tabIndex : null,
        onKeyDown: onKeyDown,
        onFocus: onFocus,
        onBlur: onBlur,
        value: "",
        onChange: $9e8364246bc59c04$var$noop,
        "aria-label": "for screen reader"
    })), /*#__PURE__*/ $hO8yS.createElement("div", {
        className: `${prefixCls}-treenode`,
        "aria-hidden": true,
        style: {
            position: 'absolute',
            pointerEvents: 'none',
            visibility: 'hidden',
            height: 0,
            overflow: 'hidden',
            border: 0,
            padding: 0
        }
    }, /*#__PURE__*/ $hO8yS.createElement("div", {
        className: `${prefixCls}-indent`
    }, /*#__PURE__*/ $hO8yS.createElement("div", {
        ref: indentMeasurerRef,
        className: `${prefixCls}-indent-unit`
    }))), /*#__PURE__*/ $hO8yS.createElement((0, $7c54ff74bcae5103$export$2e2bcd8739ae039), $9e8364246bc59c04$var$_extends({}, domProps, {
        data: mergedData,
        itemKey: $9e8364246bc59c04$var$itemKey,
        height: height,
        fullHeight: false,
        virtual: virtual,
        itemHeight: itemHeight,
        scrollWidth: scrollWidth,
        prefixCls: `${prefixCls}-list`,
        ref: listRef,
        role: "tree",
        onVisibleChange: (originList)=>{
            // The best match is using `fullList` - `originList` = `restList`
            // and check the `restList` to see if has the MOTION_KEY node
            // but this will cause performance issue for long list compare
            // we just check `originList` and repeat trigger `onMotionEnd`
            if (originList.every((item)=>$9e8364246bc59c04$var$itemKey(item) !== $9e8364246bc59c04$export$17c02cdd52a7d889)) onMotionEnd();
        }
    }), (treeNode)=>{
        const { pos: pos, data: { ...restProps }, title: title, key: key, isStart: isStart, isEnd: isEnd } = treeNode;
        const mergedKey = (0, $8c21c3908ec083b2$export$a47fb462a08de82f)(key, pos);
        delete restProps.key;
        delete restProps.children;
        const treeNodeProps = (0, $8c21c3908ec083b2$export$d961fd523a514db5)(mergedKey, treeNodeRequiredProps);
        return /*#__PURE__*/ $hO8yS.createElement((0, $f8d7c09e780ec12b$export$2e2bcd8739ae039), $9e8364246bc59c04$var$_extends({}, restProps, treeNodeProps, {
            title: title,
            active: !!activeItem && key === activeItem.key,
            pos: pos,
            data: treeNode.data,
            isStart: isStart,
            isEnd: isEnd,
            motion: motion,
            motionNodes: key === $9e8364246bc59c04$export$17c02cdd52a7d889 ? transitionRange : null,
            motionType: motionType,
            onMotionStart: onListChangeStart,
            onMotionEnd: onMotionEnd,
            treeNodeRequiredProps: treeNodeRequiredProps,
            onMouseMove: ()=>{
                onActiveChange(null);
            }
        }));
    }));
});
var $9e8364246bc59c04$export$2e2bcd8739ae039 = $9e8364246bc59c04$var$NodeList;







function $1ca05cfee6f9f841$var$_extends() {
    $1ca05cfee6f9f841$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1ca05cfee6f9f841$var$_extends.apply(this, arguments);
}
const $1ca05cfee6f9f841$var$MAX_RETRY_TIMES = 10;
class $1ca05cfee6f9f841$var$Tree extends $hO8yS.Component {
    static defaultProps = {
        prefixCls: 'rc-tree',
        showLine: false,
        showIcon: true,
        selectable: true,
        multiple: false,
        checkable: false,
        disabled: false,
        checkStrictly: false,
        draggable: false,
        defaultExpandParent: true,
        autoExpandParent: false,
        defaultExpandAll: false,
        defaultExpandedKeys: [],
        defaultCheckedKeys: [],
        defaultSelectedKeys: [],
        dropIndicatorRender: (0, $550c11b69a6ae5c7$export$2e2bcd8739ae039),
        allowDrop: ()=>true,
        expandAction: false
    };
    static TreeNode = (0, $98e6aa449e26d899$export$2e2bcd8739ae039);
    destroyed = false;
    delayedDragEnterLogic;
    loadingRetryTimes = {};
    state = {
        keyEntities: {},
        indent: null,
        selectedKeys: [],
        checkedKeys: [],
        halfCheckedKeys: [],
        loadedKeys: [],
        loadingKeys: [],
        expandedKeys: [],
        draggingNodeKey: null,
        dragChildrenKeys: [],
        // dropTargetKey is the key of abstract-drop-node
        // the abstract-drop-node is the real drop node when drag and drop
        // not the DOM drag over node
        dropTargetKey: null,
        dropPosition: null,
        // the drop position of abstract-drop-node, inside 0, top -1, bottom 1
        dropContainerKey: null,
        // the container key of abstract-drop-node if dropPosition is -1 or 1
        dropLevelOffset: null,
        // the drop level offset of abstract-drag-over-node
        dropTargetPos: null,
        // the pos of abstract-drop-node
        dropAllowed: true,
        // if drop to abstract-drop-node is allowed
        // the abstract-drag-over-node
        // if mouse is on the bottom of top dom node or no the top of the bottom dom node
        // abstract-drag-over-node is the top node
        dragOverNodeKey: null,
        treeData: [],
        flattenNodes: [],
        focused: false,
        activeKey: null,
        listChanging: false,
        prevProps: null,
        fieldNames: (0, $8c21c3908ec083b2$export$6c519d302dced239)()
    };
    dragStartMousePosition = null;
    dragNodeProps = null;
    currentMouseOverDroppableNodeKey = null;
    listRef = /*#__PURE__*/ $hO8yS.createRef();
    componentDidMount() {
        this.destroyed = false;
        this.onUpdated();
    }
    componentDidUpdate() {
        this.onUpdated();
    }
    onUpdated() {
        const { activeKey: activeKey, itemScrollOffset: itemScrollOffset = 0 } = this.props;
        if (activeKey !== undefined && activeKey !== this.state.activeKey) {
            this.setState({
                activeKey: activeKey
            });
            if (activeKey !== null) this.scrollTo({
                key: activeKey,
                offset: itemScrollOffset
            });
        }
    }
    componentWillUnmount() {
        window.removeEventListener('dragend', this.onWindowDragEnd);
        this.destroyed = true;
    }
    static getDerivedStateFromProps(props, prevState) {
        const { prevProps: prevProps } = prevState;
        const newState = {
            prevProps: props
        };
        function needSync(name) {
            return !prevProps && props.hasOwnProperty(name) || prevProps && prevProps[name] !== props[name];
        }
        // ================== Tree Node ==================
        let treeData;
        // fieldNames
        let { fieldNames: fieldNames } = prevState;
        if (needSync('fieldNames')) {
            fieldNames = (0, $8c21c3908ec083b2$export$6c519d302dced239)(props.fieldNames);
            newState.fieldNames = fieldNames;
        }
        // Check if `treeData` or `children` changed and save into the state.
        if (needSync('treeData')) ({ treeData: treeData } = props);
        else if (needSync('children')) {
            (0, $6591254ed6bd1058$export$2e2bcd8739ae039)(false, '`children` of Tree is deprecated. Please use `treeData` instead.');
            treeData = (0, $8c21c3908ec083b2$export$6d8b10995563b669)(props.children);
        }
        // Save flatten nodes info and convert `treeData` into keyEntities
        if (treeData) {
            newState.treeData = treeData;
            const entitiesMap = (0, $8c21c3908ec083b2$export$e5d831ce033a4615)(treeData, {
                fieldNames: fieldNames
            });
            newState.keyEntities = {
                [(0, $9e8364246bc59c04$export$17c02cdd52a7d889)]: (0, $9e8364246bc59c04$export$2d18abad5109a402),
                ...entitiesMap.keyEntities
            };
        }
        const keyEntities = newState.keyEntities || prevState.keyEntities;
        // ================ expandedKeys =================
        if (needSync('expandedKeys') || prevProps && needSync('autoExpandParent')) newState.expandedKeys = props.autoExpandParent || !prevProps && props.defaultExpandParent ? (0, $e60066375029f166$export$fac4a40c345ccd80)(props.expandedKeys, keyEntities) : props.expandedKeys;
        else if (!prevProps && props.defaultExpandAll) {
            const cloneKeyEntities = {
                ...keyEntities
            };
            delete cloneKeyEntities[0, $9e8364246bc59c04$export$17c02cdd52a7d889];
            // Only take the key who has the children to enhance the performance
            const nextExpandedKeys = [];
            Object.keys(cloneKeyEntities).forEach((key)=>{
                const entity = cloneKeyEntities[key];
                if (entity.children && entity.children.length) nextExpandedKeys.push(entity.key);
            });
            newState.expandedKeys = nextExpandedKeys;
        } else if (!prevProps && props.defaultExpandedKeys) newState.expandedKeys = props.autoExpandParent || props.defaultExpandParent ? (0, $e60066375029f166$export$fac4a40c345ccd80)(props.defaultExpandedKeys, keyEntities) : props.defaultExpandedKeys;
        if (!newState.expandedKeys) delete newState.expandedKeys;
        // ================ flattenNodes =================
        if (treeData || newState.expandedKeys) {
            const flattenNodes = (0, $8c21c3908ec083b2$export$215c1b4f1ba88b23)(treeData || prevState.treeData, newState.expandedKeys || prevState.expandedKeys, fieldNames);
            newState.flattenNodes = flattenNodes;
        }
        // ================ selectedKeys =================
        if (props.selectable) {
            if (needSync('selectedKeys')) newState.selectedKeys = (0, $e60066375029f166$export$fffc10811828fd68)(props.selectedKeys, props);
            else if (!prevProps && props.defaultSelectedKeys) newState.selectedKeys = (0, $e60066375029f166$export$fffc10811828fd68)(props.defaultSelectedKeys, props);
        }
        // ================= checkedKeys =================
        if (props.checkable) {
            let checkedKeyEntity;
            if (needSync('checkedKeys')) checkedKeyEntity = (0, $e60066375029f166$export$29d4989c23990d41)(props.checkedKeys) || {};
            else if (!prevProps && props.defaultCheckedKeys) checkedKeyEntity = (0, $e60066375029f166$export$29d4989c23990d41)(props.defaultCheckedKeys) || {};
            else if (treeData) // If `treeData` changed, we also need check it
            checkedKeyEntity = (0, $e60066375029f166$export$29d4989c23990d41)(props.checkedKeys) || {
                checkedKeys: prevState.checkedKeys,
                halfCheckedKeys: prevState.halfCheckedKeys
            };
            if (checkedKeyEntity) {
                let { checkedKeys: checkedKeys = [], halfCheckedKeys: halfCheckedKeys = [] } = checkedKeyEntity;
                if (!props.checkStrictly) {
                    const conductKeys = (0, $0920639cbc3d717f$export$43adf2c483e3e633)(checkedKeys, true, keyEntities);
                    ({ checkedKeys: checkedKeys, halfCheckedKeys: halfCheckedKeys } = conductKeys);
                }
                newState.checkedKeys = checkedKeys;
                newState.halfCheckedKeys = halfCheckedKeys;
            }
        }
        // ================= loadedKeys ==================
        if (needSync('loadedKeys')) newState.loadedKeys = props.loadedKeys;
        return newState;
    }
    onNodeDragStart = (event, nodeProps)=>{
        const { expandedKeys: expandedKeys, keyEntities: keyEntities } = this.state;
        const { onDragStart: onDragStart } = this.props;
        const { eventKey: eventKey } = nodeProps;
        this.dragNodeProps = nodeProps;
        this.dragStartMousePosition = {
            x: event.clientX,
            y: event.clientY
        };
        const newExpandedKeys = (0, $e60066375029f166$export$5bfb9ff497fe2298)(expandedKeys, eventKey);
        this.setState({
            draggingNodeKey: eventKey,
            dragChildrenKeys: (0, $e60066375029f166$export$b0610c44bcbb051c)(eventKey, keyEntities),
            indent: this.listRef.current.getIndentWidth()
        });
        this.setExpandedKeys(newExpandedKeys);
        window.addEventListener('dragend', this.onWindowDragEnd);
        onDragStart?.({
            event: event,
            node: (0, $8c21c3908ec083b2$export$7bd1b0fd4a8b540b)(nodeProps)
        });
    };
    /**
   * [Legacy] Select handler is smaller than node,
   * so that this will trigger when drag enter node or select handler.
   * This is a little tricky if customize css without padding.
   * Better for use mouse move event to refresh drag state.
   * But let's just keep it to avoid event trigger logic change.
   */ onNodeDragEnter = (event, nodeProps)=>{
        const { expandedKeys: expandedKeys, keyEntities: keyEntities, dragChildrenKeys: dragChildrenKeys, flattenNodes: flattenNodes, indent: indent } = this.state;
        const { onDragEnter: onDragEnter, onExpand: onExpand, allowDrop: allowDrop, direction: direction } = this.props;
        const { pos: pos, eventKey: eventKey } = nodeProps;
        // record the key of node which is latest entered, used in dragleave event.
        if (this.currentMouseOverDroppableNodeKey !== eventKey) this.currentMouseOverDroppableNodeKey = eventKey;
        if (!this.dragNodeProps) {
            this.resetDragState();
            return;
        }
        const { dropPosition: dropPosition, dropLevelOffset: dropLevelOffset, dropTargetKey: dropTargetKey, dropContainerKey: dropContainerKey, dropTargetPos: dropTargetPos, dropAllowed: dropAllowed, dragOverNodeKey: dragOverNodeKey } = (0, $e60066375029f166$export$78a5519d0fb779c3)(event, this.dragNodeProps, nodeProps, indent, this.dragStartMousePosition, allowDrop, flattenNodes, keyEntities, expandedKeys, direction);
        if (// don't allow drop inside its children
        dragChildrenKeys.includes(dropTargetKey) || // don't allow drop when drop is not allowed caculated by calcDropPosition
        !dropAllowed) {
            this.resetDragState();
            return;
        }
        // Side effect for delay drag
        if (!this.delayedDragEnterLogic) this.delayedDragEnterLogic = {};
        Object.keys(this.delayedDragEnterLogic).forEach((key)=>{
            clearTimeout(this.delayedDragEnterLogic[key]);
        });
        if (this.dragNodeProps.eventKey !== nodeProps.eventKey) {
            // hoist expand logic here
            // since if logic is on the bottom
            // it will be blocked by abstract dragover node check
            //   => if you dragenter from top, you mouse will still be consider as in the top node
            event.persist();
            this.delayedDragEnterLogic[pos] = window.setTimeout(()=>{
                if (this.state.draggingNodeKey === null) return;
                let newExpandedKeys = [
                    ...expandedKeys
                ];
                const entity = (0, $6d1342a6ea0fb914$export$2e2bcd8739ae039)(keyEntities, nodeProps.eventKey);
                if (entity && (entity.children || []).length) newExpandedKeys = (0, $e60066375029f166$export$10663f6bbd2fd717)(expandedKeys, nodeProps.eventKey);
                if (!this.props.hasOwnProperty('expandedKeys')) this.setExpandedKeys(newExpandedKeys);
                onExpand?.(newExpandedKeys, {
                    node: (0, $8c21c3908ec083b2$export$7bd1b0fd4a8b540b)(nodeProps),
                    expanded: true,
                    nativeEvent: event.nativeEvent
                });
            }, 800);
        }
        // Skip if drag node is self
        if (this.dragNodeProps.eventKey === dropTargetKey && dropLevelOffset === 0) {
            this.resetDragState();
            return;
        }
        // Update drag over node and drag state
        this.setState({
            dragOverNodeKey: dragOverNodeKey,
            dropPosition: dropPosition,
            dropLevelOffset: dropLevelOffset,
            dropTargetKey: dropTargetKey,
            dropContainerKey: dropContainerKey,
            dropTargetPos: dropTargetPos,
            dropAllowed: dropAllowed
        });
        onDragEnter?.({
            event: event,
            node: (0, $8c21c3908ec083b2$export$7bd1b0fd4a8b540b)(nodeProps),
            expandedKeys: expandedKeys
        });
    };
    onNodeDragOver = (event, nodeProps)=>{
        const { dragChildrenKeys: dragChildrenKeys, flattenNodes: flattenNodes, keyEntities: keyEntities, expandedKeys: expandedKeys, indent: indent } = this.state;
        const { onDragOver: onDragOver, allowDrop: allowDrop, direction: direction } = this.props;
        if (!this.dragNodeProps) return;
        const { dropPosition: dropPosition, dropLevelOffset: dropLevelOffset, dropTargetKey: dropTargetKey, dropContainerKey: dropContainerKey, dropTargetPos: dropTargetPos, dropAllowed: dropAllowed, dragOverNodeKey: dragOverNodeKey } = (0, $e60066375029f166$export$78a5519d0fb779c3)(event, this.dragNodeProps, nodeProps, indent, this.dragStartMousePosition, allowDrop, flattenNodes, keyEntities, expandedKeys, direction);
        if (dragChildrenKeys.includes(dropTargetKey) || !dropAllowed) // don't allow drop inside its children
        // don't allow drop when drop is not allowed calculated by calcDropPosition
        return;
        // Update drag position
        if (this.dragNodeProps.eventKey === dropTargetKey && dropLevelOffset === 0) {
            if (!(this.state.dropPosition === null && this.state.dropLevelOffset === null && this.state.dropTargetKey === null && this.state.dropContainerKey === null && this.state.dropTargetPos === null && this.state.dropAllowed === false && this.state.dragOverNodeKey === null)) this.resetDragState();
        } else if (!(dropPosition === this.state.dropPosition && dropLevelOffset === this.state.dropLevelOffset && dropTargetKey === this.state.dropTargetKey && dropContainerKey === this.state.dropContainerKey && dropTargetPos === this.state.dropTargetPos && dropAllowed === this.state.dropAllowed && dragOverNodeKey === this.state.dragOverNodeKey)) this.setState({
            dropPosition: dropPosition,
            dropLevelOffset: dropLevelOffset,
            dropTargetKey: dropTargetKey,
            dropContainerKey: dropContainerKey,
            dropTargetPos: dropTargetPos,
            dropAllowed: dropAllowed,
            dragOverNodeKey: dragOverNodeKey
        });
        onDragOver?.({
            event: event,
            node: (0, $8c21c3908ec083b2$export$7bd1b0fd4a8b540b)(nodeProps)
        });
    };
    onNodeDragLeave = (event, nodeProps)=>{
        // if it is outside the droppable area
        // currentMouseOverDroppableNodeKey will be updated in dragenter event when into another droppable receiver.
        if (this.currentMouseOverDroppableNodeKey === nodeProps.eventKey && !event.currentTarget.contains(event.relatedTarget)) {
            this.resetDragState();
            this.currentMouseOverDroppableNodeKey = null;
        }
        const { onDragLeave: onDragLeave } = this.props;
        onDragLeave?.({
            event: event,
            node: (0, $8c21c3908ec083b2$export$7bd1b0fd4a8b540b)(nodeProps)
        });
    };
    // since stopPropagation() is called in treeNode
    // if onWindowDrag is called, whice means state is keeped, drag state should be cleared
    onWindowDragEnd = (event)=>{
        this.onNodeDragEnd(event, null, true);
        window.removeEventListener('dragend', this.onWindowDragEnd);
    };
    // if onNodeDragEnd is called, onWindowDragEnd won't be called since stopPropagation() is called
    onNodeDragEnd = (event, nodeProps)=>{
        const { onDragEnd: onDragEnd } = this.props;
        this.setState({
            dragOverNodeKey: null
        });
        this.cleanDragState();
        onDragEnd?.({
            event: event,
            node: (0, $8c21c3908ec083b2$export$7bd1b0fd4a8b540b)(nodeProps)
        });
        this.dragNodeProps = null;
        window.removeEventListener('dragend', this.onWindowDragEnd);
    };
    onNodeDrop = (event, _, outsideTree = false)=>{
        const { dragChildrenKeys: dragChildrenKeys, dropPosition: dropPosition, dropTargetKey: dropTargetKey, dropTargetPos: dropTargetPos, dropAllowed: dropAllowed } = this.state;
        if (!dropAllowed) return;
        const { onDrop: onDrop } = this.props;
        this.setState({
            dragOverNodeKey: null
        });
        this.cleanDragState();
        if (dropTargetKey === null) return;
        const abstractDropNodeProps = {
            ...(0, $8c21c3908ec083b2$export$d961fd523a514db5)(dropTargetKey, this.getTreeNodeRequiredProps()),
            active: this.getActiveItem()?.key === dropTargetKey,
            data: (0, $6d1342a6ea0fb914$export$2e2bcd8739ae039)(this.state.keyEntities, dropTargetKey).node
        };
        const dropToChild = dragChildrenKeys.includes(dropTargetKey);
        (0, $6591254ed6bd1058$export$2e2bcd8739ae039)(!dropToChild, "Can not drop to dragNode's children node. This is a bug of rc-tree. Please report an issue.");
        const posArr = (0, $e60066375029f166$export$ddaee97dc8907312)(dropTargetPos);
        const dropResult = {
            event: event,
            node: (0, $8c21c3908ec083b2$export$7bd1b0fd4a8b540b)(abstractDropNodeProps),
            dragNode: this.dragNodeProps ? (0, $8c21c3908ec083b2$export$7bd1b0fd4a8b540b)(this.dragNodeProps) : null,
            dragNodesKeys: [
                this.dragNodeProps.eventKey
            ].concat(dragChildrenKeys),
            dropToGap: dropPosition !== 0,
            dropPosition: dropPosition + Number(posArr[posArr.length - 1])
        };
        if (!outsideTree) onDrop?.(dropResult);
        this.dragNodeProps = null;
    };
    resetDragState() {
        this.setState({
            dragOverNodeKey: null,
            dropPosition: null,
            dropLevelOffset: null,
            dropTargetKey: null,
            dropContainerKey: null,
            dropTargetPos: null,
            dropAllowed: false
        });
    }
    cleanDragState = ()=>{
        const { draggingNodeKey: draggingNodeKey } = this.state;
        if (draggingNodeKey !== null) this.setState({
            draggingNodeKey: null,
            dropPosition: null,
            dropContainerKey: null,
            dropTargetKey: null,
            dropLevelOffset: null,
            dropAllowed: true,
            dragOverNodeKey: null
        });
        this.dragStartMousePosition = null;
        this.currentMouseOverDroppableNodeKey = null;
    };
    triggerExpandActionExpand = (e, treeNode)=>{
        const { expandedKeys: expandedKeys, flattenNodes: flattenNodes } = this.state;
        const { expanded: expanded, key: key, isLeaf: isLeaf } = treeNode;
        if (isLeaf || e.shiftKey || e.metaKey || e.ctrlKey) return;
        const node = flattenNodes.filter((nodeItem)=>nodeItem.key === key)[0];
        const eventNode = (0, $8c21c3908ec083b2$export$7bd1b0fd4a8b540b)({
            ...(0, $8c21c3908ec083b2$export$d961fd523a514db5)(key, this.getTreeNodeRequiredProps()),
            data: node.data
        });
        this.setExpandedKeys(expanded ? (0, $e60066375029f166$export$5bfb9ff497fe2298)(expandedKeys, key) : (0, $e60066375029f166$export$10663f6bbd2fd717)(expandedKeys, key));
        this.onNodeExpand(e, eventNode);
    };
    onNodeClick = (e, treeNode)=>{
        const { onClick: onClick, expandAction: expandAction } = this.props;
        if (expandAction === 'click') this.triggerExpandActionExpand(e, treeNode);
        onClick?.(e, treeNode);
    };
    onNodeDoubleClick = (e, treeNode)=>{
        const { onDoubleClick: onDoubleClick, expandAction: expandAction } = this.props;
        if (expandAction === 'doubleClick') this.triggerExpandActionExpand(e, treeNode);
        onDoubleClick?.(e, treeNode);
    };
    onNodeSelect = (e, treeNode)=>{
        let { selectedKeys: selectedKeys } = this.state;
        const { keyEntities: keyEntities, fieldNames: fieldNames } = this.state;
        const { onSelect: onSelect, multiple: multiple } = this.props;
        const { selected: selected } = treeNode;
        const key = treeNode[fieldNames.key];
        const targetSelected = !selected;
        // Update selected keys
        if (!targetSelected) selectedKeys = (0, $e60066375029f166$export$5bfb9ff497fe2298)(selectedKeys, key);
        else if (!multiple) selectedKeys = [
            key
        ];
        else selectedKeys = (0, $e60066375029f166$export$10663f6bbd2fd717)(selectedKeys, key);
        // [Legacy] Not found related usage in doc or upper libs
        const selectedNodes = selectedKeys.map((selectedKey)=>{
            const entity = (0, $6d1342a6ea0fb914$export$2e2bcd8739ae039)(keyEntities, selectedKey);
            return entity ? entity.node : null;
        }).filter(Boolean);
        this.setUncontrolledState({
            selectedKeys: selectedKeys
        });
        onSelect?.(selectedKeys, {
            event: 'select',
            selected: targetSelected,
            node: treeNode,
            selectedNodes: selectedNodes,
            nativeEvent: e.nativeEvent
        });
    };
    onNodeCheck = (e, treeNode, checked)=>{
        const { keyEntities: keyEntities, checkedKeys: oriCheckedKeys, halfCheckedKeys: oriHalfCheckedKeys } = this.state;
        const { checkStrictly: checkStrictly, onCheck: onCheck } = this.props;
        const { key: key } = treeNode;
        // Prepare trigger arguments
        let checkedObj;
        const eventObj = {
            event: 'check',
            node: treeNode,
            checked: checked,
            nativeEvent: e.nativeEvent
        };
        if (checkStrictly) {
            const checkedKeys = checked ? (0, $e60066375029f166$export$10663f6bbd2fd717)(oriCheckedKeys, key) : (0, $e60066375029f166$export$5bfb9ff497fe2298)(oriCheckedKeys, key);
            const halfCheckedKeys = (0, $e60066375029f166$export$5bfb9ff497fe2298)(oriHalfCheckedKeys, key);
            checkedObj = {
                checked: checkedKeys,
                halfChecked: halfCheckedKeys
            };
            eventObj.checkedNodes = checkedKeys.map((checkedKey)=>(0, $6d1342a6ea0fb914$export$2e2bcd8739ae039)(keyEntities, checkedKey)).filter(Boolean).map((entity)=>entity.node);
            this.setUncontrolledState({
                checkedKeys: checkedKeys
            });
        } else {
            // Always fill first
            let { checkedKeys: checkedKeys, halfCheckedKeys: halfCheckedKeys } = (0, $0920639cbc3d717f$export$43adf2c483e3e633)([
                ...oriCheckedKeys,
                key
            ], true, keyEntities);
            // If remove, we do it again to correction
            if (!checked) {
                const keySet = new Set(checkedKeys);
                keySet.delete(key);
                ({ checkedKeys: checkedKeys, halfCheckedKeys: halfCheckedKeys } = (0, $0920639cbc3d717f$export$43adf2c483e3e633)(Array.from(keySet), {
                    checked: false,
                    halfCheckedKeys: halfCheckedKeys
                }, keyEntities));
            }
            checkedObj = checkedKeys;
            // [Legacy] This is used for `rc-tree-select`
            eventObj.checkedNodes = [];
            eventObj.checkedNodesPositions = [];
            eventObj.halfCheckedKeys = halfCheckedKeys;
            checkedKeys.forEach((checkedKey)=>{
                const entity = (0, $6d1342a6ea0fb914$export$2e2bcd8739ae039)(keyEntities, checkedKey);
                if (!entity) return;
                const { node: node, pos: pos } = entity;
                eventObj.checkedNodes.push(node);
                eventObj.checkedNodesPositions.push({
                    node: node,
                    pos: pos
                });
            });
            this.setUncontrolledState({
                checkedKeys: checkedKeys
            }, false, {
                halfCheckedKeys: halfCheckedKeys
            });
        }
        onCheck?.(checkedObj, eventObj);
    };
    onNodeLoad = (treeNode)=>{
        const { key: key } = treeNode;
        const { keyEntities: keyEntities } = this.state;
        // Skip if has children already
        const entity = (0, $6d1342a6ea0fb914$export$2e2bcd8739ae039)(keyEntities, key);
        if (entity?.children?.length) return;
        const loadPromise = new Promise((resolve, reject)=>{
            // We need to get the latest state of loading/loaded keys
            this.setState(({ loadedKeys: loadedKeys = [], loadingKeys: loadingKeys = [] })=>{
                const { loadData: loadData, onLoad: onLoad } = this.props;
                if (!loadData || loadedKeys.includes(key) || loadingKeys.includes(key)) return null;
                // Process load data
                const promise = loadData(treeNode);
                promise.then(()=>{
                    const { loadedKeys: currentLoadedKeys } = this.state;
                    const newLoadedKeys = (0, $e60066375029f166$export$10663f6bbd2fd717)(currentLoadedKeys, key);
                    // onLoad should trigger before internal setState to avoid `loadData` trigger twice.
                    // https://github.com/ant-design/ant-design/issues/12464
                    onLoad?.(newLoadedKeys, {
                        event: 'load',
                        node: treeNode
                    });
                    this.setUncontrolledState({
                        loadedKeys: newLoadedKeys
                    });
                    this.setState((prevState)=>({
                            loadingKeys: (0, $e60066375029f166$export$5bfb9ff497fe2298)(prevState.loadingKeys, key)
                        }));
                    resolve();
                }).catch((e)=>{
                    this.setState((prevState)=>({
                            loadingKeys: (0, $e60066375029f166$export$5bfb9ff497fe2298)(prevState.loadingKeys, key)
                        }));
                    // If exceed max retry times, we give up retry
                    this.loadingRetryTimes[key] = (this.loadingRetryTimes[key] || 0) + 1;
                    if (this.loadingRetryTimes[key] >= $1ca05cfee6f9f841$var$MAX_RETRY_TIMES) {
                        const { loadedKeys: currentLoadedKeys } = this.state;
                        (0, $6591254ed6bd1058$export$2e2bcd8739ae039)(false, 'Retry for `loadData` many times but still failed. No more retry.');
                        this.setUncontrolledState({
                            loadedKeys: (0, $e60066375029f166$export$10663f6bbd2fd717)(currentLoadedKeys, key)
                        });
                        resolve();
                    }
                    reject(e);
                });
                return {
                    loadingKeys: (0, $e60066375029f166$export$10663f6bbd2fd717)(loadingKeys, key)
                };
            });
        });
        // Not care warning if we ignore this
        loadPromise.catch(()=>{});
        return loadPromise;
    };
    onNodeMouseEnter = (event, node)=>{
        const { onMouseEnter: onMouseEnter } = this.props;
        onMouseEnter?.({
            event: event,
            node: node
        });
    };
    onNodeMouseLeave = (event, node)=>{
        const { onMouseLeave: onMouseLeave } = this.props;
        onMouseLeave?.({
            event: event,
            node: node
        });
    };
    onNodeContextMenu = (event, node)=>{
        const { onRightClick: onRightClick } = this.props;
        if (onRightClick) {
            event.preventDefault();
            onRightClick({
                event: event,
                node: node
            });
        }
    };
    onFocus = (...args)=>{
        const { onFocus: onFocus } = this.props;
        this.setState({
            focused: true
        });
        onFocus?.(...args);
    };
    onBlur = (...args)=>{
        const { onBlur: onBlur } = this.props;
        this.setState({
            focused: false
        });
        this.onActiveChange(null);
        onBlur?.(...args);
    };
    getTreeNodeRequiredProps = ()=>{
        const { expandedKeys: expandedKeys, selectedKeys: selectedKeys, loadedKeys: loadedKeys, loadingKeys: loadingKeys, checkedKeys: checkedKeys, halfCheckedKeys: halfCheckedKeys, dragOverNodeKey: dragOverNodeKey, dropPosition: dropPosition, keyEntities: keyEntities } = this.state;
        return {
            expandedKeys: expandedKeys || [],
            selectedKeys: selectedKeys || [],
            loadedKeys: loadedKeys || [],
            loadingKeys: loadingKeys || [],
            checkedKeys: checkedKeys || [],
            halfCheckedKeys: halfCheckedKeys || [],
            dragOverNodeKey: dragOverNodeKey,
            dropPosition: dropPosition,
            keyEntities: keyEntities
        };
    };
    // =========================== Expanded ===========================
    /** Set uncontrolled `expandedKeys`. This will also auto update `flattenNodes`. */ setExpandedKeys = (expandedKeys)=>{
        const { treeData: treeData, fieldNames: fieldNames } = this.state;
        const flattenNodes = (0, $8c21c3908ec083b2$export$215c1b4f1ba88b23)(treeData, expandedKeys, fieldNames);
        this.setUncontrolledState({
            expandedKeys: expandedKeys,
            flattenNodes: flattenNodes
        }, true);
    };
    onNodeExpand = (e, treeNode)=>{
        let { expandedKeys: expandedKeys } = this.state;
        const { listChanging: listChanging, fieldNames: fieldNames } = this.state;
        const { onExpand: onExpand, loadData: loadData } = this.props;
        const { expanded: expanded } = treeNode;
        const key = treeNode[fieldNames.key];
        // Do nothing when motion is in progress
        if (listChanging) return;
        // Update selected keys
        const certain = expandedKeys.includes(key);
        const targetExpanded = !expanded;
        (0, $6591254ed6bd1058$export$2e2bcd8739ae039)(expanded && certain || !expanded && !certain, 'Expand state not sync with index check');
        expandedKeys = targetExpanded ? (0, $e60066375029f166$export$10663f6bbd2fd717)(expandedKeys, key) : (0, $e60066375029f166$export$5bfb9ff497fe2298)(expandedKeys, key);
        this.setExpandedKeys(expandedKeys);
        onExpand?.(expandedKeys, {
            node: treeNode,
            expanded: targetExpanded,
            nativeEvent: e.nativeEvent
        });
        // Async Load data
        if (targetExpanded && loadData) {
            const loadPromise = this.onNodeLoad(treeNode);
            if (loadPromise) loadPromise.then(()=>{
                // [Legacy] Refresh logic
                const newFlattenTreeData = (0, $8c21c3908ec083b2$export$215c1b4f1ba88b23)(this.state.treeData, expandedKeys, fieldNames);
                this.setUncontrolledState({
                    flattenNodes: newFlattenTreeData
                });
            }).catch(()=>{
                const { expandedKeys: currentExpandedKeys } = this.state;
                const expandedKeysToRestore = (0, $e60066375029f166$export$5bfb9ff497fe2298)(currentExpandedKeys, key);
                this.setExpandedKeys(expandedKeysToRestore);
            });
        }
    };
    onListChangeStart = ()=>{
        this.setUncontrolledState({
            listChanging: true
        });
    };
    onListChangeEnd = ()=>{
        setTimeout(()=>{
            this.setUncontrolledState({
                listChanging: false
            });
        });
    };
    // =========================== Keyboard ===========================
    onActiveChange = (newActiveKey)=>{
        const { activeKey: activeKey } = this.state;
        const { onActiveChange: onActiveChange, itemScrollOffset: itemScrollOffset = 0 } = this.props;
        if (activeKey === newActiveKey) return;
        this.setState({
            activeKey: newActiveKey
        });
        if (newActiveKey !== null) this.scrollTo({
            key: newActiveKey,
            offset: itemScrollOffset
        });
        onActiveChange?.(newActiveKey);
    };
    getActiveItem = ()=>{
        const { activeKey: activeKey, flattenNodes: flattenNodes } = this.state;
        if (activeKey === null) return null;
        return flattenNodes.find(({ key: key })=>key === activeKey) || null;
    };
    offsetActiveKey = (offset)=>{
        const { flattenNodes: flattenNodes, activeKey: activeKey } = this.state;
        let index = flattenNodes.findIndex(({ key: key })=>key === activeKey);
        // Align with index
        if (index === -1 && offset < 0) index = flattenNodes.length;
        index = (index + offset + flattenNodes.length) % flattenNodes.length;
        const item = flattenNodes[index];
        if (item) {
            const { key: key } = item;
            this.onActiveChange(key);
        } else this.onActiveChange(null);
    };
    onKeyDown = (event)=>{
        const { activeKey: activeKey, expandedKeys: expandedKeys, checkedKeys: checkedKeys, fieldNames: fieldNames } = this.state;
        const { onKeyDown: onKeyDown, checkable: checkable, selectable: selectable } = this.props;
        // >>>>>>>>>> Direction
        switch(event.which){
            case (0, $4d7d870d585f8465$export$2e2bcd8739ae039).UP:
                this.offsetActiveKey(-1);
                event.preventDefault();
                break;
            case (0, $4d7d870d585f8465$export$2e2bcd8739ae039).DOWN:
                this.offsetActiveKey(1);
                event.preventDefault();
                break;
        }
        // >>>>>>>>>> Expand & Selection
        const activeItem = this.getActiveItem();
        if (activeItem && activeItem.data) {
            const treeNodeRequiredProps = this.getTreeNodeRequiredProps();
            const expandable = activeItem.data.isLeaf === false || !!(activeItem.data[fieldNames.children] || []).length;
            const eventNode = (0, $8c21c3908ec083b2$export$7bd1b0fd4a8b540b)({
                ...(0, $8c21c3908ec083b2$export$d961fd523a514db5)(activeKey, treeNodeRequiredProps),
                data: activeItem.data,
                active: true
            });
            switch(event.which){
                // >>> Expand
                case (0, $4d7d870d585f8465$export$2e2bcd8739ae039).LEFT:
                    // Collapse if possible
                    if (expandable && expandedKeys.includes(activeKey)) this.onNodeExpand({}, eventNode);
                    else if (activeItem.parent) this.onActiveChange(activeItem.parent.key);
                    event.preventDefault();
                    break;
                case (0, $4d7d870d585f8465$export$2e2bcd8739ae039).RIGHT:
                    // Expand if possible
                    if (expandable && !expandedKeys.includes(activeKey)) this.onNodeExpand({}, eventNode);
                    else if (activeItem.children && activeItem.children.length) this.onActiveChange(activeItem.children[0].key);
                    event.preventDefault();
                    break;
                // Selection
                case (0, $4d7d870d585f8465$export$2e2bcd8739ae039).ENTER:
                case (0, $4d7d870d585f8465$export$2e2bcd8739ae039).SPACE:
                    if (checkable && !eventNode.disabled && eventNode.checkable !== false && !eventNode.disableCheckbox) this.onNodeCheck({}, eventNode, !checkedKeys.includes(activeKey));
                    else if (!checkable && selectable && !eventNode.disabled && eventNode.selectable !== false) this.onNodeSelect({}, eventNode);
                    break;
            }
        }
        onKeyDown?.(event);
    };
    /**
   * Only update the value which is not in props
   */ setUncontrolledState = (state, atomic = false, forceState = null)=>{
        if (!this.destroyed) {
            let needSync = false;
            let allPassed = true;
            const newState = {};
            Object.keys(state).forEach((name)=>{
                if (this.props.hasOwnProperty(name)) {
                    allPassed = false;
                    return;
                }
                needSync = true;
                newState[name] = state[name];
            });
            if (needSync && (!atomic || allPassed)) this.setState({
                ...newState,
                ...forceState
            });
        }
    };
    scrollTo = (scroll)=>{
        this.listRef.current.scrollTo(scroll);
    };
    render() {
        const { focused: focused, flattenNodes: flattenNodes, keyEntities: keyEntities, draggingNodeKey: draggingNodeKey, activeKey: activeKey, dropLevelOffset: dropLevelOffset, dropContainerKey: dropContainerKey, dropTargetKey: dropTargetKey, dropPosition: dropPosition, dragOverNodeKey: dragOverNodeKey, indent: indent } = this.state;
        const { prefixCls: prefixCls, className: className, style: style, styles: styles, classNames: treeClassNames, showLine: showLine, focusable: focusable, tabIndex: tabIndex = 0, selectable: selectable, showIcon: showIcon, icon: icon, switcherIcon: switcherIcon, draggable: draggable, checkable: checkable, checkStrictly: checkStrictly, disabled: disabled, motion: motion, loadData: loadData, filterTreeNode: filterTreeNode, height: height, itemHeight: itemHeight, scrollWidth: scrollWidth, virtual: virtual, titleRender: titleRender, dropIndicatorRender: dropIndicatorRender, onContextMenu: onContextMenu, onScroll: onScroll, direction: direction, rootClassName: rootClassName, rootStyle: rootStyle } = this.props;
        const domProps = (0, $b0f3dfd0eb3cad70$export$2e2bcd8739ae039)(this.props, {
            aria: true,
            data: true
        });
        // It's better move to hooks but we just simply keep here
        let draggableConfig;
        if (draggable) {
            if (typeof draggable === 'object') draggableConfig = draggable;
            else if (typeof draggable === 'function') draggableConfig = {
                nodeDraggable: draggable
            };
            else draggableConfig = {};
        }
        const contextValue = {
            styles: styles,
            classNames: treeClassNames,
            prefixCls: prefixCls,
            selectable: selectable,
            showIcon: showIcon,
            icon: icon,
            switcherIcon: switcherIcon,
            draggable: draggableConfig,
            draggingNodeKey: draggingNodeKey,
            checkable: checkable,
            checkStrictly: checkStrictly,
            disabled: disabled,
            keyEntities: keyEntities,
            dropLevelOffset: dropLevelOffset,
            dropContainerKey: dropContainerKey,
            dropTargetKey: dropTargetKey,
            dropPosition: dropPosition,
            dragOverNodeKey: dragOverNodeKey,
            indent: indent,
            direction: direction,
            dropIndicatorRender: dropIndicatorRender,
            loadData: loadData,
            filterTreeNode: filterTreeNode,
            titleRender: titleRender,
            onNodeClick: this.onNodeClick,
            onNodeDoubleClick: this.onNodeDoubleClick,
            onNodeExpand: this.onNodeExpand,
            onNodeSelect: this.onNodeSelect,
            onNodeCheck: this.onNodeCheck,
            onNodeLoad: this.onNodeLoad,
            onNodeMouseEnter: this.onNodeMouseEnter,
            onNodeMouseLeave: this.onNodeMouseLeave,
            onNodeContextMenu: this.onNodeContextMenu,
            onNodeDragStart: this.onNodeDragStart,
            onNodeDragEnter: this.onNodeDragEnter,
            onNodeDragOver: this.onNodeDragOver,
            onNodeDragLeave: this.onNodeDragLeave,
            onNodeDragEnd: this.onNodeDragEnd,
            onNodeDrop: this.onNodeDrop
        };
        return /*#__PURE__*/ $hO8yS.createElement((0, $338114f31d3e4af5$export$dfae7d399eea2568).Provider, {
            value: contextValue
        }, /*#__PURE__*/ $hO8yS.createElement("div", {
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, className, rootClassName, {
                [`${prefixCls}-show-line`]: showLine,
                [`${prefixCls}-focused`]: focused,
                [`${prefixCls}-active-focused`]: activeKey !== null
            }),
            style: rootStyle
        }, /*#__PURE__*/ $hO8yS.createElement((0, $9e8364246bc59c04$export$2e2bcd8739ae039), $1ca05cfee6f9f841$var$_extends({
            ref: this.listRef,
            prefixCls: prefixCls,
            style: style,
            data: flattenNodes,
            disabled: disabled,
            selectable: selectable,
            checkable: !!checkable,
            motion: motion,
            dragging: draggingNodeKey !== null,
            height: height,
            itemHeight: itemHeight,
            virtual: virtual,
            focusable: focusable,
            focused: focused,
            tabIndex: tabIndex,
            activeItem: this.getActiveItem(),
            onFocus: this.onFocus,
            onBlur: this.onBlur,
            onKeyDown: this.onKeyDown,
            onActiveChange: this.onActiveChange,
            onListChangeStart: this.onListChangeStart,
            onListChangeEnd: this.onListChangeEnd,
            onContextMenu: onContextMenu,
            onScroll: onScroll,
            scrollWidth: scrollWidth
        }, this.getTreeNodeRequiredProps(), domProps))));
    }
}
var $1ca05cfee6f9f841$export$2e2bcd8739ae039 = $1ca05cfee6f9f841$var$Tree;




var $1b8a52b61c304d61$export$2e2bcd8739ae039 = (0, $1ca05cfee6f9f841$export$2e2bcd8739ae039);



parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
// This icon file is generated automatically.
var $79c2e9c0e148b099$var$FileOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494z"
                }
            }
        ]
    },
    "name": "file",
    "theme": "outlined"
};
var $79c2e9c0e148b099$export$2e2bcd8739ae039 = $79c2e9c0e148b099$var$FileOutlined;



function $7b3429f0254f561b$var$_extends() {
    $7b3429f0254f561b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7b3429f0254f561b$var$_extends.apply(this, arguments);
}
const $7b3429f0254f561b$var$FileOutlined = (props, ref)=>/*#__PURE__*/ $hO8yS.createElement((0, $5fd6f3f3c400c267$export$2e2bcd8739ae039), $7b3429f0254f561b$var$_extends({}, props, {
        ref: ref,
        icon: (0, $79c2e9c0e148b099$export$2e2bcd8739ae039)
    }));
/**![file](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg1NC42IDI4OC42TDYzOS40IDczLjRjLTYtNi0xNC4xLTkuNC0yMi42LTkuNEgxOTJjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjgzMmMwIDE3LjcgMTQuMyAzMiAzMiAzMmg2NDBjMTcuNyAwIDMyLTE0LjMgMzItMzJWMzExLjNjMC04LjUtMy40LTE2LjctOS40LTIyLjd6TTc5MC4yIDMyNkg2MDJWMTM3LjhMNzkwLjIgMzI2em0xLjggNTYySDIzMlYxMzZoMzAydjIxNmE0MiA0MiAwIDAwNDIgNDJoMjE2djQ5NHoiIC8+PC9zdmc+) */ const $7b3429f0254f561b$var$RefIcon = /*#__PURE__*/ $N3oW3.forwardRef($7b3429f0254f561b$var$FileOutlined);
var $7b3429f0254f561b$export$2e2bcd8739ae039 = $7b3429f0254f561b$var$RefIcon;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
// This icon file is generated automatically.
var $4288f2e570830a6b$var$FolderOpenOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 00-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zM136 256h188.5l119.6 114.4H748V444H238c-13 0-24.8 7.9-29.7 20L136 643.2V256zm635.3 512H159l103.3-256h612.4L771.3 768z"
                }
            }
        ]
    },
    "name": "folder-open",
    "theme": "outlined"
};
var $4288f2e570830a6b$export$2e2bcd8739ae039 = $4288f2e570830a6b$var$FolderOpenOutlined;



function $a8003da8ac256e75$var$_extends() {
    $a8003da8ac256e75$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a8003da8ac256e75$var$_extends.apply(this, arguments);
}
const $a8003da8ac256e75$var$FolderOpenOutlined = (props, ref)=>/*#__PURE__*/ $hO8yS.createElement((0, $5fd6f3f3c400c267$export$2e2bcd8739ae039), $a8003da8ac256e75$var$_extends({}, props, {
        ref: ref,
        icon: (0, $4288f2e570830a6b$export$2e2bcd8739ae039)
    }));
/**![folder-open](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkyOCA0NDRIODIwVjMzMC40YzAtMTcuNy0xNC4zLTMyLTMyLTMySDQ3M0wzNTUuNyAxODYuMmE4LjE1IDguMTUgMCAwMC01LjUtMi4ySDk2Yy0xNy43IDAtMzIgMTQuMy0zMiAzMnY1OTJjMCAxNy43IDE0LjMgMzIgMzIgMzJoNjk4YzEzIDAgMjQuOC03LjkgMjkuNy0yMGwxMzQtMzMyYzEuNS0zLjggMi4zLTcuOSAyLjMtMTIgMC0xNy43LTE0LjMtMzItMzItMzJ6TTEzNiAyNTZoMTg4LjVsMTE5LjYgMTE0LjRINzQ4VjQ0NEgyMzhjLTEzIDAtMjQuOCA3LjktMjkuNyAyMEwxMzYgNjQzLjJWMjU2em02MzUuMyA1MTJIMTU5bDEwMy4zLTI1Nmg2MTIuNEw3NzEuMyA3Njh6IiAvPjwvc3ZnPg==) */ const $a8003da8ac256e75$var$RefIcon = /*#__PURE__*/ $N3oW3.forwardRef($a8003da8ac256e75$var$FolderOpenOutlined);
var $a8003da8ac256e75$export$2e2bcd8739ae039 = $a8003da8ac256e75$var$RefIcon;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
// This icon file is generated automatically.
var $fad820d8e434d5d4$var$FolderOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M880 298.4H521L403.7 186.2a8.15 8.15 0 00-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z"
                }
            }
        ]
    },
    "name": "folder",
    "theme": "outlined"
};
var $fad820d8e434d5d4$export$2e2bcd8739ae039 = $fad820d8e434d5d4$var$FolderOutlined;



function $d33e1b3ce5b3ab4e$var$_extends() {
    $d33e1b3ce5b3ab4e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d33e1b3ce5b3ab4e$var$_extends.apply(this, arguments);
}
const $d33e1b3ce5b3ab4e$var$FolderOutlined = (props, ref)=>/*#__PURE__*/ $hO8yS.createElement((0, $5fd6f3f3c400c267$export$2e2bcd8739ae039), $d33e1b3ce5b3ab4e$var$_extends({}, props, {
        ref: ref,
        icon: (0, $fad820d8e434d5d4$export$2e2bcd8739ae039)
    }));
/**![folder](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg4MCAyOTguNEg1MjFMNDAzLjcgMTg2LjJhOC4xNSA4LjE1IDAgMDAtNS41LTIuMkgxNDRjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjU5MmMwIDE3LjcgMTQuMyAzMiAzMiAzMmg3MzZjMTcuNyAwIDMyLTE0LjMgMzItMzJWMzMwLjRjMC0xNy43LTE0LjMtMzItMzItMzJ6TTg0MCA3NjhIMTg0VjI1NmgxODguNWwxMTkuNiAxMTQuNEg4NDBWNzY4eiIgLz48L3N2Zz4=) */ const $d33e1b3ce5b3ab4e$var$RefIcon = /*#__PURE__*/ $N3oW3.forwardRef($d33e1b3ce5b3ab4e$var$FolderOutlined);
var $d33e1b3ce5b3ab4e$export$2e2bcd8739ae039 = $d33e1b3ce5b3ab4e$var$RefIcon;







var $N3oW3 = parcelRequire("N3oW3");
parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
// This icon file is generated automatically.
var $3fb0ebeededcdeb7$var$HolderOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M300 276.5a56 56 0 1056-97 56 56 0 00-56 97zm0 284a56 56 0 1056-97 56 56 0 00-56 97zM640 228a56 56 0 10112 0 56 56 0 00-112 0zm0 284a56 56 0 10112 0 56 56 0 00-112 0zM300 844.5a56 56 0 1056-97 56 56 0 00-56 97zM640 796a56 56 0 10112 0 56 56 0 00-112 0z"
                }
            }
        ]
    },
    "name": "holder",
    "theme": "outlined"
};
var $3fb0ebeededcdeb7$export$2e2bcd8739ae039 = $3fb0ebeededcdeb7$var$HolderOutlined;



function $ad59ac7027a53716$var$_extends() {
    $ad59ac7027a53716$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ad59ac7027a53716$var$_extends.apply(this, arguments);
}
const $ad59ac7027a53716$var$HolderOutlined = (props, ref)=>/*#__PURE__*/ $hO8yS.createElement((0, $5fd6f3f3c400c267$export$2e2bcd8739ae039), $ad59ac7027a53716$var$_extends({}, props, {
        ref: ref,
        icon: (0, $3fb0ebeededcdeb7$export$2e2bcd8739ae039)
    }));
/**![holder](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTMwMCAyNzYuNWE1NiA1NiAwIDEwNTYtOTcgNTYgNTYgMCAwMC01NiA5N3ptMCAyODRhNTYgNTYgMCAxMDU2LTk3IDU2IDU2IDAgMDAtNTYgOTd6TTY0MCAyMjhhNTYgNTYgMCAxMDExMiAwIDU2IDU2IDAgMDAtMTEyIDB6bTAgMjg0YTU2IDU2IDAgMTAxMTIgMCA1NiA1NiAwIDAwLTExMiAwek0zMDAgODQ0LjVhNTYgNTYgMCAxMDU2LTk3IDU2IDU2IDAgMDAtNTYgOTd6TTY0MCA3OTZhNTYgNTYgMCAxMDExMiAwIDU2IDU2IDAgMDAtMTEyIDB6IiAvPjwvc3ZnPg==) */ const $ad59ac7027a53716$var$RefIcon = /*#__PURE__*/ $N3oW3.forwardRef($ad59ac7027a53716$var$HolderOutlined);
var $ad59ac7027a53716$export$2e2bcd8739ae039 = $ad59ac7027a53716$var$RefIcon;















// ============================ Directory =============================
const $b1d1fd0e2a902c6a$export$2f47474ee6fcebcf = ({ treeCls: treeCls, treeNodeCls: treeNodeCls, directoryNodeSelectedBg: directoryNodeSelectedBg, directoryNodeSelectedColor: directoryNodeSelectedColor, motionDurationMid: motionDurationMid, borderRadius: borderRadius, controlItemBgHover: controlItemBgHover })=>({
        [`${treeCls}${treeCls}-directory ${treeNodeCls}`]: {
            // >>> Title
            [`${treeCls}-node-content-wrapper`]: {
                position: 'static',
                [`&:has(${treeCls}-drop-indicator)`]: {
                    position: 'relative'
                },
                [`> *:not(${treeCls}-drop-indicator)`]: {
                    position: 'relative'
                },
                '&:hover': {
                    background: 'transparent'
                },
                // Expand interactive area to whole line
                '&:before': {
                    position: 'absolute',
                    inset: 0,
                    transition: `background-color ${motionDurationMid}`,
                    content: '""',
                    borderRadius: borderRadius
                },
                '&:hover:before': {
                    background: controlItemBgHover
                }
            },
            [`${treeCls}-switcher, ${treeCls}-checkbox, ${treeCls}-draggable-icon`]: {
                zIndex: 1
            },
            // ============= Selected =============
            '&-selected': {
                background: directoryNodeSelectedBg,
                borderRadius: borderRadius,
                [`${treeCls}-switcher, ${treeCls}-draggable-icon`]: {
                    color: directoryNodeSelectedColor
                },
                // >>> Title
                [`${treeCls}-node-content-wrapper`]: {
                    color: directoryNodeSelectedColor,
                    background: 'transparent',
                    '&, &:hover': {
                        color: directoryNodeSelectedColor
                    },
                    '&:before, &:hover:before': {
                        background: directoryNodeSelectedBg
                    }
                }
            }
        }
    });


// ============================ Keyframes =============================
const $ee5b1948734dd854$var$treeNodeFX = new (0, $f806545df26bb0b4$export$2e2bcd8739ae039)('ant-tree-node-fx-do-not-use', {
    '0%': {
        opacity: 0
    },
    '100%': {
        opacity: 1
    }
});
// ============================== Switch ==============================
const $ee5b1948734dd854$var$getSwitchStyle = (prefixCls, token)=>({
        [`.${prefixCls}-switcher-icon`]: {
            display: 'inline-block',
            fontSize: 10,
            verticalAlign: 'baseline',
            svg: {
                transition: `transform ${token.motionDurationSlow}`
            }
        }
    });
// =============================== Drop ===============================
const $ee5b1948734dd854$var$getDropIndicatorStyle = (prefixCls, token)=>({
        [`.${prefixCls}-drop-indicator`]: {
            position: 'absolute',
            // it should displayed over the following node
            zIndex: 1,
            height: 2,
            backgroundColor: token.colorPrimary,
            borderRadius: 1,
            pointerEvents: 'none',
            '&:after': {
                position: 'absolute',
                top: -3,
                insetInlineStart: -6,
                width: 8,
                height: 8,
                backgroundColor: 'transparent',
                border: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.lineWidthBold)} solid ${token.colorPrimary}`,
                borderRadius: '50%',
                content: '""'
            }
        }
    });
const $ee5b1948734dd854$export$5ca74f7be820a85 = (prefixCls, token)=>{
    const { treeCls: treeCls, treeNodeCls: treeNodeCls, treeNodePadding: treeNodePadding, titleHeight: titleHeight, indentSize: indentSize, nodeSelectedBg: nodeSelectedBg, nodeHoverBg: nodeHoverBg, colorTextQuaternary: colorTextQuaternary, controlItemBgActiveDisabled: controlItemBgActiveDisabled } = token;
    return {
        [treeCls]: {
            ...(0, $2f353af2b0f7600b$export$23997c3e44cc1c59)(token),
            // fix https://github.com/ant-design/ant-design/issues/50316
            ['--rc-virtual-list-scrollbar-bg']: token.colorSplit,
            background: token.colorBgContainer,
            borderRadius: token.borderRadius,
            transition: `background-color ${token.motionDurationSlow}`,
            '&-rtl': {
                direction: 'rtl'
            },
            [`&${treeCls}-rtl ${treeCls}-switcher_close ${treeCls}-switcher-icon svg`]: {
                transform: 'rotate(90deg)'
            },
            [`&-focused:not(:hover):not(${treeCls}-active-focused)`]: (0, $2f353af2b0f7600b$export$6539948f0a737e39)(token),
            // =================== Virtual List ===================
            [`${treeCls}-list-holder-inner`]: {
                alignItems: 'flex-start'
            },
            [`&${treeCls}-block-node`]: {
                [`${treeCls}-list-holder-inner`]: {
                    alignItems: 'stretch',
                    // >>> Title
                    [`${treeCls}-node-content-wrapper`]: {
                        flex: 'auto'
                    },
                    // >>> Drag
                    [`${treeNodeCls}.dragging:after`]: {
                        position: 'absolute',
                        inset: 0,
                        border: `1px solid ${token.colorPrimary}`,
                        opacity: 0,
                        animationName: $ee5b1948734dd854$var$treeNodeFX,
                        animationDuration: token.motionDurationSlow,
                        animationPlayState: 'running',
                        animationFillMode: 'forwards',
                        content: '""',
                        pointerEvents: 'none',
                        borderRadius: token.borderRadius
                    }
                }
            },
            // ===================== TreeNode =====================
            [treeNodeCls]: {
                display: 'flex',
                alignItems: 'flex-start',
                marginBottom: treeNodePadding,
                lineHeight: (0, $763a5b4b58d0a3ff$export$523c0b569236b342)(titleHeight),
                position: 'relative',
                // 非常重要，避免 drop-indicator 在拖拽过程中闪烁
                '&:before': {
                    content: '""',
                    position: 'absolute',
                    zIndex: 1,
                    insetInlineStart: 0,
                    width: '100%',
                    top: '100%',
                    height: treeNodePadding
                },
                // Disabled
                [`&-disabled ${treeCls}-node-content-wrapper`]: {
                    color: token.colorTextDisabled,
                    cursor: 'not-allowed',
                    '&:hover': {
                        background: 'transparent'
                    }
                },
                [`${treeCls}-checkbox-disabled + ${treeCls}-node-selected,&${treeNodeCls}-disabled${treeNodeCls}-selected ${treeCls}-node-content-wrapper`]: {
                    backgroundColor: controlItemBgActiveDisabled
                },
                // we can not set pointer-events to none for checkbox in tree
                // ref: https://github.com/ant-design/ant-design/issues/39822#issuecomment-2605234058
                [`${treeCls}-checkbox-disabled`]: {
                    pointerEvents: 'unset'
                },
                // not disable
                [`&:not(${treeNodeCls}-disabled)`]: {
                    // >>> Title
                    [`${treeCls}-node-content-wrapper`]: {
                        '&:hover': {
                            color: token.nodeHoverColor
                        }
                    }
                },
                [`&-active ${treeCls}-node-content-wrapper`]: {
                    background: token.controlItemBgHover
                },
                [`&:not(${treeNodeCls}-disabled).filter-node ${treeCls}-title`]: {
                    color: token.colorPrimary,
                    fontWeight: token.fontWeightStrong
                },
                '&-draggable': {
                    cursor: 'grab',
                    [`${treeCls}-draggable-icon`]: {
                        // https://github.com/ant-design/ant-design/issues/41915
                        flexShrink: 0,
                        width: titleHeight,
                        textAlign: 'center',
                        visibility: 'visible',
                        color: colorTextQuaternary
                    },
                    [`&${treeNodeCls}-disabled ${treeCls}-draggable-icon`]: {
                        visibility: 'hidden'
                    }
                }
            },
            // >>> Indent
            [`${treeCls}-indent`]: {
                alignSelf: 'stretch',
                whiteSpace: 'nowrap',
                userSelect: 'none',
                '&-unit': {
                    display: 'inline-block',
                    width: indentSize
                }
            },
            // >>> Drag Handler
            [`${treeCls}-draggable-icon`]: {
                visibility: 'hidden'
            },
            // Switcher / Checkbox
            [`${treeCls}-switcher, ${treeCls}-checkbox`]: {
                marginInlineEnd: token.calc(token.calc(titleHeight).sub(token.controlInteractiveSize)).div(2).equal()
            },
            // >>> Switcher
            [`${treeCls}-switcher`]: {
                ...$ee5b1948734dd854$var$getSwitchStyle(prefixCls, token),
                position: 'relative',
                flex: 'none',
                alignSelf: 'stretch',
                width: titleHeight,
                textAlign: 'center',
                cursor: 'pointer',
                userSelect: 'none',
                transition: `all ${token.motionDurationSlow}`,
                '&-noop': {
                    cursor: 'unset'
                },
                '&:before': {
                    pointerEvents: 'none',
                    content: '""',
                    width: titleHeight,
                    height: titleHeight,
                    position: 'absolute',
                    left: {
                        _skip_check_: true,
                        value: 0
                    },
                    top: 0,
                    borderRadius: token.borderRadius,
                    transition: `all ${token.motionDurationSlow}`
                },
                [`&:not(${treeCls}-switcher-noop):hover:before`]: {
                    backgroundColor: token.colorBgTextHover
                },
                [`&_close ${treeCls}-switcher-icon svg`]: {
                    transform: 'rotate(-90deg)'
                },
                '&-loading-icon': {
                    color: token.colorPrimary
                },
                '&-leaf-line': {
                    position: 'relative',
                    zIndex: 1,
                    display: 'inline-block',
                    width: '100%',
                    height: '100%',
                    // https://github.com/ant-design/ant-design/issues/31884
                    '&:before': {
                        position: 'absolute',
                        top: 0,
                        insetInlineEnd: token.calc(titleHeight).div(2).equal(),
                        bottom: token.calc(treeNodePadding).mul(-1).equal(),
                        marginInlineStart: -1,
                        borderInlineEnd: `1px solid ${token.colorBorder}`,
                        content: '""'
                    },
                    '&:after': {
                        position: 'absolute',
                        width: token.calc(token.calc(titleHeight).div(2).equal()).mul(0.8).equal(),
                        height: token.calc(titleHeight).div(2).equal(),
                        borderBottom: `1px solid ${token.colorBorder}`,
                        content: '""'
                    }
                }
            },
            // >>> Title
            // add `${treeCls}-checkbox + span` to cover checkbox `${checkboxCls} + span`
            [`${treeCls}-node-content-wrapper`]: {
                position: 'relative',
                minHeight: titleHeight,
                paddingBlock: 0,
                paddingInline: token.paddingXS,
                background: 'transparent',
                borderRadius: token.borderRadius,
                cursor: 'pointer',
                transition: `all ${token.motionDurationMid}, border 0s, line-height 0s, box-shadow 0s`,
                ...$ee5b1948734dd854$var$getDropIndicatorStyle(prefixCls, token),
                '&:hover': {
                    backgroundColor: nodeHoverBg
                },
                [`&${treeCls}-node-selected`]: {
                    color: token.nodeSelectedColor,
                    backgroundColor: nodeSelectedBg
                },
                // Icon
                [`${treeCls}-iconEle`]: {
                    display: 'inline-block',
                    width: titleHeight,
                    height: titleHeight,
                    textAlign: 'center',
                    verticalAlign: 'top',
                    '&:empty': {
                        display: 'none'
                    }
                }
            },
            // https://github.com/ant-design/ant-design/issues/28217
            [`${treeCls}-unselectable ${treeCls}-node-content-wrapper:hover`]: {
                backgroundColor: 'transparent'
            },
            [`${treeNodeCls}.drop-container > [draggable]`]: {
                boxShadow: `0 0 0 2px ${token.colorPrimary}`
            },
            // ==================== Show Line =====================
            '&-show-line': {
                // ================ Indent lines ================
                [`${treeCls}-indent-unit`]: {
                    position: 'relative',
                    height: '100%',
                    '&:before': {
                        position: 'absolute',
                        top: 0,
                        insetInlineEnd: token.calc(titleHeight).div(2).equal(),
                        bottom: token.calc(treeNodePadding).mul(-1).equal(),
                        borderInlineEnd: `1px solid ${token.colorBorder}`,
                        content: '""'
                    },
                    '&-end:before': {
                        display: 'none'
                    }
                },
                // ============== Cover Background ==============
                [`${treeCls}-switcher`]: {
                    background: 'transparent',
                    '&-line-icon': {
                        // https://github.com/ant-design/ant-design/issues/32813
                        verticalAlign: '-0.15em'
                    }
                }
            },
            [`${treeNodeCls}-leaf-last ${treeCls}-switcher-leaf-line:before`]: {
                top: 'auto !important',
                bottom: 'auto !important',
                height: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(token.calc(titleHeight).div(2).equal())} !important`
            }
        }
    };
};
const $ee5b1948734dd854$export$6543b952798356f2 = (prefixCls, token, /**
 * @descCN 是否启用目录树样式
 * @descEN Whether to enable directory style
 * @default true
 */ enableDirectory = true)=>{
    const treeCls = `.${prefixCls}`;
    const treeNodeCls = `${treeCls}-treenode`;
    const treeNodePadding = token.calc(token.paddingXS).div(2).equal();
    const treeToken = (0, $90c11ca6cb263fd9$export$4950aa0f605343fb)(token, {
        treeCls: treeCls,
        treeNodeCls: treeNodeCls,
        treeNodePadding: treeNodePadding
    });
    return [
        // Basic
        $ee5b1948734dd854$export$5ca74f7be820a85(prefixCls, treeToken),
        // Directory
        enableDirectory && (0, $b1d1fd0e2a902c6a$export$2f47474ee6fcebcf)(treeToken)
    ].filter(Boolean);
};
const $ee5b1948734dd854$export$bd8b682992bc9781 = (token)=>{
    const { controlHeightSM: controlHeightSM, controlItemBgHover: controlItemBgHover, controlItemBgActive: controlItemBgActive } = token;
    const titleHeight = controlHeightSM;
    return {
        titleHeight: titleHeight,
        indentSize: titleHeight,
        nodeHoverBg: controlItemBgHover,
        nodeHoverColor: token.colorText,
        nodeSelectedBg: controlItemBgActive,
        nodeSelectedColor: token.colorText
    };
};
const $ee5b1948734dd854$export$9ca1be8807fe0675 = (token)=>{
    const { colorTextLightSolid: colorTextLightSolid, colorPrimary: colorPrimary } = token;
    return {
        ...$ee5b1948734dd854$export$bd8b682992bc9781(token),
        directoryNodeSelectedColor: colorTextLightSolid,
        directoryNodeSelectedBg: colorPrimary
    };
};
var $ee5b1948734dd854$export$2e2bcd8739ae039 = (0, $d4a2dc313c4d90a4$export$51ec95de45185b42)('Tree', (token, { prefixCls: prefixCls })=>[
        {
            [token.componentCls]: (0, $2f2edafb2c86c023$export$3d2f074408bd1b82)(`${prefixCls}-checkbox`, token)
        },
        $ee5b1948734dd854$export$6543b952798356f2(prefixCls, token),
        (0, $f58f14441a7cd550$export$2e2bcd8739ae039)(token)
    ], $ee5b1948734dd854$export$9ca1be8807fe0675);



var $N3oW3 = parcelRequire("N3oW3");
"use client";
const $a2b4e3fffde5a5da$export$cc800923e997bb8 = 4;
function $a2b4e3fffde5a5da$var$dropIndicatorRender(props) {
    const { dropPosition: dropPosition, dropLevelOffset: dropLevelOffset, prefixCls: prefixCls, indent: indent, direction: direction = 'ltr' } = props;
    const startPosition = direction === 'ltr' ? 'left' : 'right';
    const endPosition = direction === 'ltr' ? 'right' : 'left';
    const style = {
        [startPosition]: -dropLevelOffset * indent + $a2b4e3fffde5a5da$export$cc800923e997bb8,
        [endPosition]: 0
    };
    switch(dropPosition){
        case -1:
            style.top = -3;
            break;
        case 1:
            style.bottom = -3;
            break;
        default:
            // dropPosition === 0
            style.bottom = -3;
            style[startPosition] = indent + $a2b4e3fffde5a5da$export$cc800923e997bb8;
            break;
    }
    return /*#__PURE__*/ (0, $N3oW3.default).createElement("div", {
        style: style,
        className: `${prefixCls}-drop-indicator`
    });
}
var $a2b4e3fffde5a5da$export$2e2bcd8739ae039 = $a2b4e3fffde5a5da$var$dropIndicatorRender;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
// This icon file is generated automatically.
var $ae3581f1648e6d79$var$CaretDownFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z"
                }
            }
        ]
    },
    "name": "caret-down",
    "theme": "filled"
};
var $ae3581f1648e6d79$export$2e2bcd8739ae039 = $ae3581f1648e6d79$var$CaretDownFilled;



function $edfcec35246b4faa$var$_extends() {
    $edfcec35246b4faa$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $edfcec35246b4faa$var$_extends.apply(this, arguments);
}
const $edfcec35246b4faa$var$CaretDownFilled = (props, ref)=>/*#__PURE__*/ $hO8yS.createElement((0, $5fd6f3f3c400c267$export$2e2bcd8739ae039), $edfcec35246b4faa$var$_extends({}, props, {
        ref: ref,
        icon: (0, $ae3581f1648e6d79$export$2e2bcd8739ae039)
    }));
/**![caret-down](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg0MC40IDMwMEgxODMuNmMtMTkuNyAwLTMwLjcgMjAuOC0xOC41IDM1bDMyOC40IDM4MC44YzkuNCAxMC45IDI3LjUgMTAuOSAzNyAwTDg1OC45IDMzNWMxMi4yLTE0LjIgMS4yLTM1LTE4LjUtMzV6IiAvPjwvc3ZnPg==) */ const $edfcec35246b4faa$var$RefIcon = /*#__PURE__*/ $N3oW3.forwardRef($edfcec35246b4faa$var$CaretDownFilled);
var $edfcec35246b4faa$export$2e2bcd8739ae039 = $edfcec35246b4faa$var$RefIcon;




parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
// This icon file is generated automatically.
var $0a9d238f10ec6518$var$MinusSquareOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M328 544h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            }
        ]
    },
    "name": "minus-square",
    "theme": "outlined"
};
var $0a9d238f10ec6518$export$2e2bcd8739ae039 = $0a9d238f10ec6518$var$MinusSquareOutlined;



function $fd561b2c2d8dc6ee$var$_extends() {
    $fd561b2c2d8dc6ee$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $fd561b2c2d8dc6ee$var$_extends.apply(this, arguments);
}
const $fd561b2c2d8dc6ee$var$MinusSquareOutlined = (props, ref)=>/*#__PURE__*/ $hO8yS.createElement((0, $5fd6f3f3c400c267$export$2e2bcd8739ae039), $fd561b2c2d8dc6ee$var$_extends({}, props, {
        ref: ref,
        icon: (0, $0a9d238f10ec6518$export$2e2bcd8739ae039)
    }));
/**![minus-square](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTMyOCA1NDRoMzY4YzQuNCAwIDgtMy42IDgtOHYtNDhjMC00LjQtMy42LTgtOC04SDMyOGMtNC40IDAtOCAzLjYtOCA4djQ4YzAgNC40IDMuNiA4IDggOHoiIC8+PHBhdGggZD0iTTg4MCAxMTJIMTQ0Yy0xNy43IDAtMzIgMTQuMy0zMiAzMnY3MzZjMCAxNy43IDE0LjMgMzIgMzIgMzJoNzM2YzE3LjcgMCAzMi0xNC4zIDMyLTMyVjE0NGMwLTE3LjctMTQuMy0zMi0zMi0zMnptLTQwIDcyOEgxODRWMTg0aDY1NnY2NTZ6IiAvPjwvc3ZnPg==) */ const $fd561b2c2d8dc6ee$var$RefIcon = /*#__PURE__*/ $N3oW3.forwardRef($fd561b2c2d8dc6ee$var$MinusSquareOutlined);
var $fd561b2c2d8dc6ee$export$2e2bcd8739ae039 = $fd561b2c2d8dc6ee$var$RefIcon;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
// This icon file is generated automatically.
var $878b4bc0dafed2fb$var$PlusSquareOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M328 544h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            }
        ]
    },
    "name": "plus-square",
    "theme": "outlined"
};
var $878b4bc0dafed2fb$export$2e2bcd8739ae039 = $878b4bc0dafed2fb$var$PlusSquareOutlined;



function $9d7b8e2e11966a0e$var$_extends() {
    $9d7b8e2e11966a0e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9d7b8e2e11966a0e$var$_extends.apply(this, arguments);
}
const $9d7b8e2e11966a0e$var$PlusSquareOutlined = (props, ref)=>/*#__PURE__*/ $hO8yS.createElement((0, $5fd6f3f3c400c267$export$2e2bcd8739ae039), $9d7b8e2e11966a0e$var$_extends({}, props, {
        ref: ref,
        icon: (0, $878b4bc0dafed2fb$export$2e2bcd8739ae039)
    }));
/**![plus-square](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTMyOCA1NDRoMTUydjE1MmMwIDQuNCAzLjYgOCA4IDhoNDhjNC40IDAgOC0zLjYgOC04VjU0NGgxNTJjNC40IDAgOC0zLjYgOC04di00OGMwLTQuNC0zLjYtOC04LThINTQ0VjMyOGMwLTQuNC0zLjYtOC04LThoLTQ4Yy00LjQgMC04IDMuNi04IDh2MTUySDMyOGMtNC40IDAtOCAzLjYtOCA4djQ4YzAgNC40IDMuNiA4IDggOHoiIC8+PHBhdGggZD0iTTg4MCAxMTJIMTQ0Yy0xNy43IDAtMzIgMTQuMy0zMiAzMnY3MzZjMCAxNy43IDE0LjMgMzIgMzIgMzJoNzM2YzE3LjcgMCAzMi0xNC4zIDMyLTMyVjE0NGMwLTE3LjctMTQuMy0zMi0zMi0zMnptLTQwIDcyOEgxODRWMTg0aDY1NnY2NTZ6IiAvPjwvc3ZnPg==) */ const $9d7b8e2e11966a0e$var$RefIcon = /*#__PURE__*/ $N3oW3.forwardRef($9d7b8e2e11966a0e$var$PlusSquareOutlined);
var $9d7b8e2e11966a0e$export$2e2bcd8739ae039 = $9d7b8e2e11966a0e$var$RefIcon;




"use client";
const $b037235ea7a01989$var$SwitcherIconCom = (props)=>{
    const { prefixCls: prefixCls, switcherIcon: switcherIcon, treeNodeProps: treeNodeProps, showLine: showLine, switcherLoadingIcon: switcherLoadingIcon } = props;
    const { isLeaf: isLeaf, expanded: expanded, loading: loading } = treeNodeProps;
    if (loading) {
        if (/*#__PURE__*/ $N3oW3.isValidElement(switcherLoadingIcon)) return switcherLoadingIcon;
        return /*#__PURE__*/ $hO8yS.createElement((0, $b7d605396d432b67$export$2e2bcd8739ae039), {
            className: `${prefixCls}-switcher-loading-icon`
        });
    }
    let showLeafIcon;
    if (showLine && typeof showLine === 'object') showLeafIcon = showLine.showLeafIcon;
    if (isLeaf) {
        if (!showLine) return null;
        if (typeof showLeafIcon !== 'boolean' && !!showLeafIcon) {
            const leafIcon = typeof showLeafIcon === 'function' ? showLeafIcon(treeNodeProps) : showLeafIcon;
            const leafCls = `${prefixCls}-switcher-line-custom-icon`;
            if (/*#__PURE__*/ $N3oW3.isValidElement(leafIcon)) return (0, $62609775897a768c$export$e530037191fcd5d7)(leafIcon, {
                className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(leafIcon.props?.className, leafCls)
            });
            return leafIcon;
        }
        return showLeafIcon ? /*#__PURE__*/ $hO8yS.createElement((0, $7b3429f0254f561b$export$2e2bcd8739ae039), {
            className: `${prefixCls}-switcher-line-icon`
        }) : /*#__PURE__*/ $hO8yS.createElement("span", {
            className: `${prefixCls}-switcher-leaf-line`
        });
    }
    const switcherCls = `${prefixCls}-switcher-icon`;
    const switcher = typeof switcherIcon === 'function' ? switcherIcon(treeNodeProps) : switcherIcon;
    if (/*#__PURE__*/ $N3oW3.isValidElement(switcher)) return (0, $62609775897a768c$export$e530037191fcd5d7)(switcher, {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(switcher.props?.className, switcherCls)
    });
    if (switcher !== undefined) return switcher;
    if (showLine) return expanded ? /*#__PURE__*/ $hO8yS.createElement((0, $fd561b2c2d8dc6ee$export$2e2bcd8739ae039), {
        className: `${prefixCls}-switcher-line-icon`
    }) : /*#__PURE__*/ $hO8yS.createElement((0, $9d7b8e2e11966a0e$export$2e2bcd8739ae039), {
        className: `${prefixCls}-switcher-line-icon`
    });
    return /*#__PURE__*/ $hO8yS.createElement((0, $edfcec35246b4faa$export$2e2bcd8739ae039), {
        className: switcherCls
    });
};
var $b037235ea7a01989$export$2e2bcd8739ae039 = $b037235ea7a01989$var$SwitcherIconCom;


"use client";
const $ee8c32d6a2afff00$var$Tree = /*#__PURE__*/ (0, $N3oW3.default).forwardRef((props, ref)=>{
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $dd01e2f5a4b8605d$export$46f4bd6436a25a31)('tree');
    const { virtual: virtual } = (0, $N3oW3.default).useContext((0, $dd01e2f5a4b8605d$export$a92f85ab3e9ad68b));
    const { prefixCls: customizePrefixCls, className: className, showIcon: showIcon = false, showLine: showLine, switcherIcon: switcherIcon, switcherLoadingIcon: switcherLoadingIcon, blockNode: blockNode = false, children: children, checkable: checkable = false, selectable: selectable = true, draggable: draggable, disabled: disabled, motion: customMotion, style: style, rootClassName: rootClassName, classNames: classNames, styles: styles } = props;
    const contextDisabled = (0, $N3oW3.default).useContext((0, $ff4b4ddbf52ed41f$export$2e2bcd8739ae039));
    const mergedDisabled = disabled ?? contextDisabled;
    const prefixCls = getPrefixCls('tree', customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    const motion = customMotion ?? {
        ...(0, $689b5af26dd3c1cd$export$2e2bcd8739ae039)(rootPrefixCls),
        motionAppear: false
    };
    // =========== Merged Props for Semantic ==========
    const mergedProps = {
        ...props,
        showIcon: showIcon,
        blockNode: blockNode,
        checkable: checkable,
        selectable: selectable,
        disabled: mergedDisabled,
        motion: motion
    };
    const [mergedClassNames, mergedStyles] = (0, $4dcf69d8c3d6df5c$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    const newProps = {
        ...props,
        checkable: checkable,
        selectable: selectable,
        showIcon: showIcon,
        motion: motion,
        blockNode: blockNode,
        disabled: mergedDisabled,
        showLine: Boolean(showLine),
        dropIndicatorRender: $a2b4e3fffde5a5da$export$2e2bcd8739ae039
    };
    const [hashId, cssVarCls] = (0, $ee5b1948734dd854$export$2e2bcd8739ae039)(prefixCls);
    const [, token] = (0, $9481722d146bd166$export$2e2bcd8739ae039)();
    const itemHeight = token.paddingXS / 2 + (token.Tree?.titleHeight || token.controlHeightSM);
    const draggableConfig = (0, $N3oW3.default).useMemo(()=>{
        if (!draggable) return false;
        let mergedDraggable = {};
        switch(typeof draggable){
            case 'function':
                mergedDraggable.nodeDraggable = draggable;
                break;
            case 'object':
                mergedDraggable = {
                    ...draggable
                };
                break;
            default:
                break;
        }
        if (mergedDraggable.icon !== false) mergedDraggable.icon = mergedDraggable.icon || /*#__PURE__*/ (0, $N3oW3.default).createElement((0, $ad59ac7027a53716$export$2e2bcd8739ae039), null);
        return mergedDraggable;
    }, [
        draggable
    ]);
    const renderSwitcherIcon = (nodeProps)=>/*#__PURE__*/ (0, $N3oW3.default).createElement((0, $b037235ea7a01989$export$2e2bcd8739ae039), {
            prefixCls: prefixCls,
            switcherIcon: switcherIcon,
            switcherLoadingIcon: switcherLoadingIcon,
            treeNodeProps: nodeProps,
            showLine: showLine
        });
    return(/*#__PURE__*/ // @ts-ignore
    (0, $N3oW3.default).createElement((0, $1b8a52b61c304d61$export$2e2bcd8739ae039), {
        itemHeight: itemHeight,
        ref: ref,
        virtual: virtual,
        ...newProps,
        // newProps may contain style so declare style below it
        prefixCls: prefixCls,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)({
            [`${prefixCls}-icon-hide`]: !showIcon,
            [`${prefixCls}-block-node`]: blockNode,
            [`${prefixCls}-unselectable`]: !selectable,
            [`${prefixCls}-rtl`]: direction === 'rtl',
            [`${prefixCls}-disabled`]: mergedDisabled
        }, contextClassName, className, hashId, cssVarCls),
        style: {
            ...contextStyle,
            ...style
        },
        rootClassName: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(mergedClassNames?.root, rootClassName),
        rootStyle: mergedStyles?.root,
        classNames: mergedClassNames,
        styles: mergedStyles,
        direction: direction,
        checkable: checkable ? /*#__PURE__*/ (0, $N3oW3.default).createElement("span", {
            className: `${prefixCls}-checkbox-inner`
        }) : checkable,
        selectable: selectable,
        switcherIcon: renderSwitcherIcon,
        draggable: draggableConfig
    }, children));
});
var $ee8c32d6a2afff00$export$2e2bcd8739ae039 = $ee8c32d6a2afff00$var$Tree;




const $4b4d71c6924ae4a5$var$RECORD_NONE = 0;
const $4b4d71c6924ae4a5$var$RECORD_START = 1;
const $4b4d71c6924ae4a5$var$RECORD_END = 2;
function $4b4d71c6924ae4a5$var$traverseNodesKey(treeData, callback, fieldNames) {
    const { key: fieldKey, children: fieldChildren } = fieldNames;
    function processNode(dataNode) {
        const key = dataNode[fieldKey];
        const children = dataNode[fieldChildren];
        if (callback(key, dataNode) !== false) $4b4d71c6924ae4a5$var$traverseNodesKey(children || [], callback, fieldNames);
    }
    treeData.forEach(processNode);
}
function $4b4d71c6924ae4a5$export$aad0b800290b42ab({ treeData: treeData, expandedKeys: expandedKeys, startKey: startKey, endKey: endKey, fieldNames: fieldNames }) {
    const keys = [];
    let record = $4b4d71c6924ae4a5$var$RECORD_NONE;
    if (startKey && startKey === endKey) return [
        startKey
    ];
    if (!startKey || !endKey) return [];
    function matchKey(key) {
        return key === startKey || key === endKey;
    }
    $4b4d71c6924ae4a5$var$traverseNodesKey(treeData, (key)=>{
        if (record === $4b4d71c6924ae4a5$var$RECORD_END) return false;
        if (matchKey(key)) {
            // Match test
            keys.push(key);
            if (record === $4b4d71c6924ae4a5$var$RECORD_NONE) record = $4b4d71c6924ae4a5$var$RECORD_START;
            else if (record === $4b4d71c6924ae4a5$var$RECORD_START) {
                record = $4b4d71c6924ae4a5$var$RECORD_END;
                return false;
            }
        } else if (record === $4b4d71c6924ae4a5$var$RECORD_START) // Append selection
        keys.push(key);
        return expandedKeys.includes(key);
    }, (0, $8c21c3908ec083b2$export$6c519d302dced239)(fieldNames));
    return keys;
}
function $4b4d71c6924ae4a5$export$7d40a46ab3886826(treeData, keys, fieldNames) {
    const restKeys = (0, $3746fb019e1f2ee5$export$2e2bcd8739ae039)(keys);
    const nodes = [];
    $4b4d71c6924ae4a5$var$traverseNodesKey(treeData, (key, node)=>{
        const index = restKeys.indexOf(key);
        if (index !== -1) {
            nodes.push(node);
            restKeys.splice(index, 1);
        }
        return !!restKeys.length;
    }, (0, $8c21c3908ec083b2$export$6c519d302dced239)(fieldNames));
    return nodes;
}


"use client";
function $7983b534ae8f3eff$var$getIcon(props) {
    const { isLeaf: isLeaf, expanded: expanded } = props;
    if (isLeaf) return /*#__PURE__*/ $hO8yS.createElement((0, $7b3429f0254f561b$export$2e2bcd8739ae039), null);
    return expanded ? /*#__PURE__*/ $hO8yS.createElement((0, $a8003da8ac256e75$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $hO8yS.createElement((0, $d33e1b3ce5b3ab4e$export$2e2bcd8739ae039), null);
}
function $7983b534ae8f3eff$var$getTreeData({ treeData: treeData, children: children }) {
    return treeData || (0, $8c21c3908ec083b2$export$6d8b10995563b669)(children);
}
const $7983b534ae8f3eff$var$DirectoryTree = ({ defaultExpandAll: defaultExpandAll, defaultExpandParent: defaultExpandParent, defaultExpandedKeys: defaultExpandedKeys, ...props }, ref)=>{
    // Shift click usage
    const lastSelectedKey = $32rMB.useRef(null);
    const cachedSelectedKeys = $32rMB.useRef(null);
    const getInitExpandedKeys = ()=>{
        const { keyEntities: keyEntities } = (0, $8c21c3908ec083b2$export$e5d831ce033a4615)($7983b534ae8f3eff$var$getTreeData(props), {
            fieldNames: props.fieldNames
        });
        let initExpandedKeys;
        // Expanded keys
        if (defaultExpandAll) initExpandedKeys = Object.keys(keyEntities);
        else if (defaultExpandParent) initExpandedKeys = (0, $e60066375029f166$export$fac4a40c345ccd80)(props.expandedKeys || defaultExpandedKeys || [], keyEntities);
        else initExpandedKeys = props.expandedKeys || defaultExpandedKeys || [];
        return initExpandedKeys;
    };
    const [selectedKeys, setSelectedKeys] = $32rMB.useState(props.selectedKeys || props.defaultSelectedKeys || []);
    const [expandedKeys, setExpandedKeys] = $32rMB.useState(()=>getInitExpandedKeys());
    $32rMB.useEffect(()=>{
        if ('selectedKeys' in props) setSelectedKeys(props.selectedKeys);
    }, [
        props.selectedKeys
    ]);
    $32rMB.useEffect(()=>{
        if ('expandedKeys' in props) setExpandedKeys(props.expandedKeys);
    }, [
        props.expandedKeys
    ]);
    const onExpand = (keys, info)=>{
        if (!('expandedKeys' in props)) setExpandedKeys(keys);
        // Call origin function
        return props.onExpand?.(keys, info);
    };
    const onSelect = (keys, event)=>{
        const { multiple: multiple, fieldNames: fieldNames } = props;
        const { node: node, nativeEvent: nativeEvent } = event;
        const { key: key = '' } = node;
        const treeData = $7983b534ae8f3eff$var$getTreeData(props);
        // const newState: DirectoryTreeState = {};
        // We need wrap this event since some value is not same
        const newEvent = {
            ...event,
            selected: true // Directory selected always true
        };
        // Windows / Mac single pick
        const ctrlPick = nativeEvent?.ctrlKey || nativeEvent?.metaKey;
        const shiftPick = nativeEvent?.shiftKey;
        // Generate new selected keys
        let newSelectedKeys;
        if (multiple && ctrlPick) {
            // Control click
            newSelectedKeys = keys;
            lastSelectedKey.current = key;
            cachedSelectedKeys.current = newSelectedKeys;
            newEvent.selectedNodes = (0, $4b4d71c6924ae4a5$export$7d40a46ab3886826)(treeData, newSelectedKeys, fieldNames);
        } else if (multiple && shiftPick) {
            // Shift click
            newSelectedKeys = Array.from(new Set([].concat((0, $3746fb019e1f2ee5$export$2e2bcd8739ae039)(cachedSelectedKeys.current || []), (0, $3746fb019e1f2ee5$export$2e2bcd8739ae039)((0, $4b4d71c6924ae4a5$export$aad0b800290b42ab)({
                treeData: treeData,
                expandedKeys: expandedKeys,
                startKey: key,
                endKey: lastSelectedKey.current,
                fieldNames: fieldNames
            })))));
            newEvent.selectedNodes = (0, $4b4d71c6924ae4a5$export$7d40a46ab3886826)(treeData, newSelectedKeys, fieldNames);
        } else {
            // Single click
            newSelectedKeys = [
                key
            ];
            lastSelectedKey.current = key;
            cachedSelectedKeys.current = newSelectedKeys;
            newEvent.selectedNodes = (0, $4b4d71c6924ae4a5$export$7d40a46ab3886826)(treeData, newSelectedKeys, fieldNames);
        }
        props.onSelect?.(newSelectedKeys, newEvent);
        if (!('selectedKeys' in props)) setSelectedKeys(newSelectedKeys);
    };
    const { getPrefixCls: getPrefixCls, direction: direction } = $32rMB.useContext((0, $dd01e2f5a4b8605d$export$a92f85ab3e9ad68b));
    const { prefixCls: customizePrefixCls, className: className, showIcon: showIcon = true, expandAction: expandAction = 'click', ...otherProps } = props;
    const prefixCls = getPrefixCls('tree', customizePrefixCls);
    const connectClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-directory`, {
        [`${prefixCls}-directory-rtl`]: direction === 'rtl'
    }, className);
    return /*#__PURE__*/ $hO8yS.createElement((0, $ee8c32d6a2afff00$export$2e2bcd8739ae039), {
        icon: $7983b534ae8f3eff$var$getIcon,
        ref: ref,
        blockNode: true,
        ...otherProps,
        showIcon: showIcon,
        expandAction: expandAction,
        prefixCls: prefixCls,
        className: connectClassName,
        expandedKeys: expandedKeys,
        selectedKeys: selectedKeys,
        onSelect: onSelect,
        onExpand: onExpand
    });
};
const $7983b534ae8f3eff$var$ForwardDirectoryTree = /*#__PURE__*/ $N3oW3.forwardRef($7983b534ae8f3eff$var$DirectoryTree);
var $7983b534ae8f3eff$export$2e2bcd8739ae039 = $7983b534ae8f3eff$var$ForwardDirectoryTree;



"use client";
const $cabd1d48354efbf4$var$Tree = (0, $ee8c32d6a2afff00$export$2e2bcd8739ae039);
$cabd1d48354efbf4$var$Tree.DirectoryTree = (0, $7983b534ae8f3eff$export$2e2bcd8739ae039);
$cabd1d48354efbf4$var$Tree.TreeNode = (0, $98e6aa449e26d899$export$2e2bcd8739ae039);
var $cabd1d48354efbf4$export$2e2bcd8739ae039 = $cabd1d48354efbf4$var$Tree;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");


"use client";
const $9116ca97a8ba6838$var$FilterSearch = (props)=>{
    const { value: value, filterSearch: filterSearch, tablePrefixCls: tablePrefixCls, locale: locale, onChange: onChange } = props;
    if (!filterSearch) return null;
    return /*#__PURE__*/ $hO8yS.createElement("div", {
        className: `${tablePrefixCls}-filter-dropdown-search`
    }, /*#__PURE__*/ $hO8yS.createElement((0, $124d0cd1063329f0$export$2e2bcd8739ae039), {
        prefix: /*#__PURE__*/ $hO8yS.createElement((0, $a3bf8c02a3dd583c$export$2e2bcd8739ae039), null),
        placeholder: locale.filterSearchPlaceholder,
        onChange: onChange,
        value: value,
        // for skip min-width of input
        htmlSize: 1,
        className: `${tablePrefixCls}-filter-dropdown-search-input`
    }));
};
var $9116ca97a8ba6838$export$2e2bcd8739ae039 = $9116ca97a8ba6838$var$FilterSearch;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");

"use client";
const $11334a72d78d9394$var$onKeyDown = (event)=>{
    const { keyCode: keyCode } = event;
    if (keyCode === (0, $4d7d870d585f8465$export$2e2bcd8739ae039).ENTER) event.stopPropagation();
};
const $11334a72d78d9394$var$FilterDropdownMenuWrapper = /*#__PURE__*/ $N3oW3.forwardRef((props, ref)=>/*#__PURE__*/ $hO8yS.createElement("div", {
        className: props.className,
        onClick: (e)=>e.stopPropagation(),
        onKeyDown: $11334a72d78d9394$var$onKeyDown,
        ref: ref
    }, props.children));
var $11334a72d78d9394$export$2e2bcd8739ae039 = $11334a72d78d9394$var$FilterDropdownMenuWrapper;


"use client";
function $73a24dd43a5d70ce$export$50792ddeed01ab0a(filters) {
    let keys = [];
    (filters || []).forEach(({ value: value, children: children })=>{
        keys.push(value);
        if (children) keys = [].concat((0, $3746fb019e1f2ee5$export$2e2bcd8739ae039)(keys), (0, $3746fb019e1f2ee5$export$2e2bcd8739ae039)($73a24dd43a5d70ce$export$50792ddeed01ab0a(children)));
    });
    return keys;
}
function $73a24dd43a5d70ce$var$hasSubMenu(filters) {
    return filters.some(({ children: children })=>children);
}
function $73a24dd43a5d70ce$var$searchValueMatched(searchValue, text) {
    if (typeof text === 'string' || typeof text === 'number') return text?.toString().toLowerCase().includes(searchValue.trim().toLowerCase());
    return false;
}
function $73a24dd43a5d70ce$var$renderFilterItems({ filters: filters, prefixCls: prefixCls, filteredKeys: filteredKeys, filterMultiple: filterMultiple, searchValue: searchValue, filterSearch: filterSearch }) {
    return filters.map((filter, index)=>{
        const key = String(filter.value);
        if (filter.children) return {
            key: key || index,
            label: filter.text,
            popupClassName: `${prefixCls}-dropdown-submenu`,
            children: $73a24dd43a5d70ce$var$renderFilterItems({
                filters: filter.children,
                prefixCls: prefixCls,
                filteredKeys: filteredKeys,
                filterMultiple: filterMultiple,
                searchValue: searchValue,
                filterSearch: filterSearch
            })
        };
        const Component = filterMultiple ? (0, $feaaea83208f19fc$export$2e2bcd8739ae039) : (0, $a3affe103134fa01$export$2e2bcd8739ae039);
        const item = {
            key: filter.value !== undefined ? key : index,
            label: /*#__PURE__*/ $hO8yS.createElement($hO8yS.Fragment, null, /*#__PURE__*/ $hO8yS.createElement(Component, {
                checked: filteredKeys.includes(key)
            }), /*#__PURE__*/ $hO8yS.createElement("span", null, filter.text))
        };
        if (searchValue.trim()) {
            if (typeof filterSearch === 'function') return filterSearch(searchValue, filter) ? item : null;
            return $73a24dd43a5d70ce$var$searchValueMatched(searchValue, filter.text) ? item : null;
        }
        return item;
    });
}
function $73a24dd43a5d70ce$var$wrapStringListType(keys) {
    return keys || [];
}
const $73a24dd43a5d70ce$var$FilterDropdown = (props)=>{
    const { tablePrefixCls: tablePrefixCls, prefixCls: prefixCls, column: column, dropdownPrefixCls: dropdownPrefixCls, columnKey: columnKey, filterOnClose: filterOnClose, filterMultiple: filterMultiple, filterMode: filterMode = 'menu', filterSearch: filterSearch = false, filterState: filterState, triggerFilter: triggerFilter, locale: locale, children: children, getPopupContainer: getPopupContainer, rootClassName: rootClassName } = props;
    const { filterResetToDefaultFilteredValue: filterResetToDefaultFilteredValue, defaultFilteredValue: defaultFilteredValue, filterDropdownProps: filterDropdownProps = {}, filterDropdownOpen: // Deprecated
    filterDropdownOpen, onFilterDropdownOpenChange: onFilterDropdownOpenChange } = column;
    const [visible, setVisible] = $32rMB.useState(false);
    const filtered = !!(filterState && (filterState.filteredKeys?.length || filterState.forceFiltered));
    const triggerVisible = (newVisible)=>{
        setVisible(newVisible);
        filterDropdownProps.onOpenChange?.(newVisible);
        // deprecated
        onFilterDropdownOpenChange?.(newVisible);
    };
    var deprecatedName, newName;
    const mergedVisible = filterDropdownProps.open ?? filterDropdownOpen ?? // deprecated
    visible; // inner state
    // ===================== Select Keys =====================
    const propFilteredKeys = filterState?.filteredKeys;
    const [getFilteredKeysSync, setFilteredKeysSync] = (0, $48bc6347a52d7873$export$bd58d1a153fd4998)($73a24dd43a5d70ce$var$wrapStringListType(propFilteredKeys));
    const onSelectKeys = ({ selectedKeys: selectedKeys })=>{
        setFilteredKeysSync(selectedKeys);
    };
    const onCheck = (keys, { node: node, checked: checked })=>{
        if (!filterMultiple) onSelectKeys({
            selectedKeys: checked && node.key ? [
                node.key
            ] : []
        });
        else onSelectKeys({
            selectedKeys: keys
        });
    };
    $32rMB.useEffect(()=>{
        if (!visible) return;
        onSelectKeys({
            selectedKeys: $73a24dd43a5d70ce$var$wrapStringListType(propFilteredKeys)
        });
    }, [
        propFilteredKeys
    ]);
    // ====================== Open Keys ======================
    const [openKeys, setOpenKeys] = $32rMB.useState([]);
    const onOpenChange = (keys)=>{
        setOpenKeys(keys);
    };
    // search in tree mode column filter
    const [searchValue, setSearchValue] = $32rMB.useState('');
    const onSearch = (e)=>{
        const { value: value } = e.target;
        setSearchValue(value);
    };
    // clear search value after close filter dropdown
    $32rMB.useEffect(()=>{
        if (!visible) setSearchValue('');
    }, [
        visible
    ]);
    // ======================= Submit ========================
    const internalTriggerFilter = (keys)=>{
        const mergedKeys = keys?.length ? keys : null;
        if (mergedKeys === null && (!filterState || !filterState.filteredKeys)) return null;
        if ((0, $5582f7991b7cfce3$export$2e2bcd8739ae039)(mergedKeys, filterState?.filteredKeys, true)) return null;
        triggerFilter({
            column: column,
            key: columnKey,
            filteredKeys: mergedKeys
        });
    };
    const onConfirm = ()=>{
        triggerVisible(false);
        internalTriggerFilter(getFilteredKeysSync());
    };
    const onReset = ({ confirm: confirm, closeDropdown: closeDropdown } = {
        confirm: false,
        closeDropdown: false
    })=>{
        if (confirm) internalTriggerFilter([]);
        if (closeDropdown) triggerVisible(false);
        setSearchValue('');
        if (filterResetToDefaultFilteredValue) setFilteredKeysSync((defaultFilteredValue || []).map((key)=>String(key)));
        else setFilteredKeysSync([]);
    };
    const doFilter = ({ closeDropdown: closeDropdown } = {
        closeDropdown: true
    })=>{
        if (closeDropdown) triggerVisible(false);
        internalTriggerFilter(getFilteredKeysSync());
    };
    const onVisibleChange = (newVisible, info)=>{
        if (info.source === 'trigger') {
            if (newVisible && propFilteredKeys !== undefined) // Sync filteredKeys on appear in controlled mode (propFilteredKeys !== undefined)
            setFilteredKeysSync($73a24dd43a5d70ce$var$wrapStringListType(propFilteredKeys));
            triggerVisible(newVisible);
            if (!newVisible && !column.filterDropdown && filterOnClose) onConfirm();
        }
    };
    // ======================== Style ========================
    const dropdownMenuClass = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)({
        [`${dropdownPrefixCls}-menu-without-submenu`]: !$73a24dd43a5d70ce$var$hasSubMenu(column.filters || [])
    });
    const onCheckAll = (e)=>{
        if (e.target.checked) {
            const allFilterKeys = $73a24dd43a5d70ce$export$50792ddeed01ab0a(column?.filters).map((key)=>String(key));
            setFilteredKeysSync(allFilterKeys);
        } else setFilteredKeysSync([]);
    };
    const getTreeData = ({ filters: filters })=>(filters || []).map((filter, index)=>{
            const key = String(filter.value);
            const item = {
                title: filter.text,
                key: filter.value !== undefined ? key : String(index)
            };
            if (filter.children) item.children = getTreeData({
                filters: filter.children
            });
            return item;
        });
    const getFilterData = (node)=>({
            ...node,
            text: node.title,
            value: node.key,
            children: node.children?.map((item)=>getFilterData(item)) || []
        });
    let dropdownContent;
    const { direction: direction, renderEmpty: renderEmpty } = $32rMB.useContext((0, $dd01e2f5a4b8605d$export$a92f85ab3e9ad68b));
    if (typeof column.filterDropdown === 'function') dropdownContent = column.filterDropdown({
        prefixCls: `${dropdownPrefixCls}-custom`,
        setSelectedKeys: (selectedKeys)=>onSelectKeys({
                selectedKeys: selectedKeys
            }),
        selectedKeys: getFilteredKeysSync(),
        confirm: doFilter,
        clearFilters: onReset,
        filters: column.filters,
        visible: mergedVisible,
        close: ()=>{
            triggerVisible(false);
        }
    });
    else if (column.filterDropdown) dropdownContent = column.filterDropdown;
    else {
        const selectedKeys = getFilteredKeysSync() || [];
        const getFilterComponent = ()=>{
            const empty = renderEmpty?.('Table.filter') ?? /*#__PURE__*/ $hO8yS.createElement((0, $c9639cafaf2858d6$export$2e2bcd8739ae039), {
                image: (0, $c9639cafaf2858d6$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE,
                description: locale.filterEmptyText,
                styles: {
                    image: {
                        height: 24
                    }
                },
                style: {
                    margin: 0,
                    padding: '16px 0'
                }
            });
            if ((column.filters || []).length === 0) return empty;
            if (filterMode === 'tree') return /*#__PURE__*/ $hO8yS.createElement($hO8yS.Fragment, null, /*#__PURE__*/ $hO8yS.createElement((0, $9116ca97a8ba6838$export$2e2bcd8739ae039), {
                filterSearch: filterSearch,
                value: searchValue,
                onChange: onSearch,
                tablePrefixCls: tablePrefixCls,
                locale: locale
            }), /*#__PURE__*/ $hO8yS.createElement("div", {
                className: `${tablePrefixCls}-filter-dropdown-tree`
            }, filterMultiple ? /*#__PURE__*/ $hO8yS.createElement((0, $feaaea83208f19fc$export$2e2bcd8739ae039), {
                checked: selectedKeys.length === $73a24dd43a5d70ce$export$50792ddeed01ab0a(column.filters).length,
                indeterminate: selectedKeys.length > 0 && selectedKeys.length < $73a24dd43a5d70ce$export$50792ddeed01ab0a(column.filters).length,
                className: `${tablePrefixCls}-filter-dropdown-checkall`,
                onChange: onCheckAll
            }, locale?.filterCheckall ?? locale?.filterCheckAll) : null, /*#__PURE__*/ $hO8yS.createElement((0, $cabd1d48354efbf4$export$2e2bcd8739ae039), {
                checkable: true,
                selectable: false,
                blockNode: true,
                multiple: filterMultiple,
                checkStrictly: !filterMultiple,
                className: `${dropdownPrefixCls}-menu`,
                onCheck: onCheck,
                checkedKeys: selectedKeys,
                selectedKeys: selectedKeys,
                showIcon: false,
                treeData: getTreeData({
                    filters: column.filters
                }),
                autoExpandParent: true,
                defaultExpandAll: true,
                filterTreeNode: searchValue.trim() ? (node)=>{
                    if (typeof filterSearch === 'function') return filterSearch(searchValue, getFilterData(node));
                    return $73a24dd43a5d70ce$var$searchValueMatched(searchValue, node.title);
                } : undefined
            })));
            const items = $73a24dd43a5d70ce$var$renderFilterItems({
                filters: column.filters || [],
                filterSearch: filterSearch,
                prefixCls: prefixCls,
                filteredKeys: getFilteredKeysSync(),
                filterMultiple: filterMultiple,
                searchValue: searchValue
            });
            const isEmpty = items.every((item)=>item === null);
            return /*#__PURE__*/ $hO8yS.createElement($hO8yS.Fragment, null, /*#__PURE__*/ $hO8yS.createElement((0, $9116ca97a8ba6838$export$2e2bcd8739ae039), {
                filterSearch: filterSearch,
                value: searchValue,
                onChange: onSearch,
                tablePrefixCls: tablePrefixCls,
                locale: locale
            }), isEmpty ? empty : /*#__PURE__*/ $hO8yS.createElement((0, $23cb8fbdad4e5f07$export$2e2bcd8739ae039), {
                selectable: true,
                multiple: filterMultiple,
                prefixCls: `${dropdownPrefixCls}-menu`,
                className: dropdownMenuClass,
                onSelect: onSelectKeys,
                onDeselect: onSelectKeys,
                selectedKeys: selectedKeys,
                getPopupContainer: getPopupContainer,
                openKeys: openKeys,
                onOpenChange: onOpenChange,
                items: items
            }));
        };
        const getResetDisabled = ()=>{
            if (filterResetToDefaultFilteredValue) return (0, $5582f7991b7cfce3$export$2e2bcd8739ae039)((defaultFilteredValue || []).map((key)=>String(key)), selectedKeys, true);
            return selectedKeys.length === 0;
        };
        dropdownContent = /*#__PURE__*/ $hO8yS.createElement($hO8yS.Fragment, null, getFilterComponent(), /*#__PURE__*/ $hO8yS.createElement("div", {
            className: `${prefixCls}-dropdown-btns`
        }, /*#__PURE__*/ $hO8yS.createElement((0, $9632ad3149894c43$export$2e2bcd8739ae039), {
            type: "link",
            size: "small",
            disabled: getResetDisabled(),
            onClick: ()=>onReset()
        }, locale.filterReset), /*#__PURE__*/ $hO8yS.createElement((0, $9632ad3149894c43$export$2e2bcd8739ae039), {
            type: "primary",
            size: "small",
            onClick: onConfirm
        }, locale.filterConfirm)));
    }
    // We should not block customize Menu with additional props
    if (column.filterDropdown) dropdownContent = /*#__PURE__*/ $hO8yS.createElement((0, $4ecfd4dbf7968668$export$9bd434816b0530d0), {
        selectable: undefined
    }, dropdownContent);
    dropdownContent = /*#__PURE__*/ $hO8yS.createElement((0, $11334a72d78d9394$export$2e2bcd8739ae039), {
        className: `${prefixCls}-dropdown`
    }, dropdownContent);
    const getDropdownTrigger = ()=>{
        let filterIcon;
        if (typeof column.filterIcon === 'function') filterIcon = column.filterIcon(filtered);
        else if (column.filterIcon) filterIcon = column.filterIcon;
        else filterIcon = /*#__PURE__*/ $hO8yS.createElement((0, $fc6affef73086579$export$2e2bcd8739ae039), null);
        return /*#__PURE__*/ $hO8yS.createElement("span", {
            role: "button",
            tabIndex: -1,
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-trigger`, {
                active: filtered
            }),
            onClick: (e)=>{
                e.stopPropagation();
            }
        }, filterIcon);
    };
    const mergedDropdownProps = (0, $c63f725913016a25$export$2e2bcd8739ae039)({
        trigger: [
            'click'
        ],
        placement: direction === 'rtl' ? 'bottomLeft' : 'bottomRight',
        children: getDropdownTrigger(),
        getPopupContainer: getPopupContainer
    }, {
        ...filterDropdownProps,
        rootClassName: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(rootClassName, filterDropdownProps.rootClassName),
        open: mergedVisible,
        onOpenChange: onVisibleChange,
        popupRender: ()=>{
            if (typeof filterDropdownProps?.dropdownRender === 'function') return filterDropdownProps.dropdownRender(dropdownContent);
            return dropdownContent;
        }
    });
    return /*#__PURE__*/ $hO8yS.createElement("div", {
        className: `${prefixCls}-column`
    }, /*#__PURE__*/ $hO8yS.createElement("span", {
        className: `${tablePrefixCls}-column-title`
    }, children), /*#__PURE__*/ $hO8yS.createElement((0, $38b79a6ce8fc3a86$export$2e2bcd8739ae039), {
        ...mergedDropdownProps
    }));
};
var $73a24dd43a5d70ce$export$2e2bcd8739ae039 = $73a24dd43a5d70ce$var$FilterDropdown;


"use client";
const $277d684919ff2714$var$collectFilterStates = (columns, init, pos)=>{
    let filterStates = [];
    (columns || []).forEach((column, index)=>{
        const columnPos = (0, $4e57f4bd37ec1f3f$export$7e4db04adce9b4db)(index, pos);
        const filterDropdownIsDefined = column.filterDropdown !== undefined;
        if (column.filters || filterDropdownIsDefined || 'onFilter' in column) {
            if ('filteredValue' in column) {
                // Controlled
                let filteredValues = column.filteredValue;
                if (!filterDropdownIsDefined) filteredValues = filteredValues?.map(String) ?? filteredValues;
                filterStates.push({
                    column: column,
                    key: (0, $4e57f4bd37ec1f3f$export$480219a02f196e72)(column, columnPos),
                    filteredKeys: filteredValues,
                    forceFiltered: column.filtered
                });
            } else // Uncontrolled
            filterStates.push({
                column: column,
                key: (0, $4e57f4bd37ec1f3f$export$480219a02f196e72)(column, columnPos),
                filteredKeys: init && column.defaultFilteredValue ? column.defaultFilteredValue : undefined,
                forceFiltered: column.filtered
            });
        }
        if ('children' in column) filterStates = [].concat((0, $3746fb019e1f2ee5$export$2e2bcd8739ae039)(filterStates), (0, $3746fb019e1f2ee5$export$2e2bcd8739ae039)($277d684919ff2714$var$collectFilterStates(column.children, init, columnPos)));
    });
    return filterStates;
};
function $277d684919ff2714$var$injectFilter(prefixCls, dropdownPrefixCls, columns, filterStates, locale, triggerFilter, getPopupContainer, pos, rootClassName) {
    return columns.map((column, index)=>{
        const columnPos = (0, $4e57f4bd37ec1f3f$export$7e4db04adce9b4db)(index, pos);
        const { filterOnClose: filterOnClose = true, filterMultiple: filterMultiple = true, filterMode: filterMode, filterSearch: filterSearch } = column;
        let newColumn = column;
        if (newColumn.filters || newColumn.filterDropdown) {
            const columnKey = (0, $4e57f4bd37ec1f3f$export$480219a02f196e72)(newColumn, columnPos);
            const filterState = filterStates.find(({ key: key })=>columnKey === key);
            newColumn = {
                ...newColumn,
                title: (renderProps)=>/*#__PURE__*/ $hO8yS.createElement((0, $73a24dd43a5d70ce$export$2e2bcd8739ae039), {
                        tablePrefixCls: prefixCls,
                        prefixCls: `${prefixCls}-filter`,
                        dropdownPrefixCls: dropdownPrefixCls,
                        column: newColumn,
                        columnKey: columnKey,
                        filterState: filterState,
                        filterOnClose: filterOnClose,
                        filterMultiple: filterMultiple,
                        filterMode: filterMode,
                        filterSearch: filterSearch,
                        triggerFilter: triggerFilter,
                        locale: locale,
                        getPopupContainer: getPopupContainer,
                        rootClassName: rootClassName
                    }, (0, $4e57f4bd37ec1f3f$export$cfda450db2088de7)(column.title, renderProps))
            };
        }
        if ('children' in newColumn) newColumn = {
            ...newColumn,
            children: $277d684919ff2714$var$injectFilter(prefixCls, dropdownPrefixCls, newColumn.children, filterStates, locale, triggerFilter, getPopupContainer, columnPos, rootClassName)
        };
        return newColumn;
    });
}
const $277d684919ff2714$var$generateFilterInfo = (filterStates)=>{
    const currentFilters = {};
    filterStates.forEach(({ key: key, filteredKeys: filteredKeys, column: column })=>{
        const keyAsString = key;
        const { filters: filters, filterDropdown: filterDropdown } = column;
        if (filterDropdown) currentFilters[keyAsString] = filteredKeys || null;
        else if (Array.isArray(filteredKeys)) {
            const keys = (0, $73a24dd43a5d70ce$export$50792ddeed01ab0a)(filters);
            currentFilters[keyAsString] = keys.filter((originKey)=>filteredKeys.includes(String(originKey)));
        } else currentFilters[keyAsString] = null;
    });
    return currentFilters;
};
const $277d684919ff2714$export$37643bb40f4c1c56 = (data, filterStates, childrenColumnName)=>{
    const filterDatas = filterStates.reduce((currentData, filterState)=>{
        const { column: { onFilter: onFilter, filters: filters }, filteredKeys: filteredKeys } = filterState;
        if (onFilter && filteredKeys && filteredKeys.length) return currentData// shallow copy
        .map((record)=>({
                ...record
            })).filter((record)=>filteredKeys.some((key)=>{
                const keys = (0, $73a24dd43a5d70ce$export$50792ddeed01ab0a)(filters);
                const keyIndex = keys.findIndex((k)=>String(k) === String(key));
                const realKey = keyIndex !== -1 ? keys[keyIndex] : key;
                // filter children
                if (record[childrenColumnName]) record[childrenColumnName] = $277d684919ff2714$export$37643bb40f4c1c56(record[childrenColumnName], filterStates, childrenColumnName);
                return onFilter(realKey, record);
            }));
        return currentData;
    }, data);
    return filterDatas;
};
const $277d684919ff2714$var$getMergedColumns = (rawMergedColumns)=>rawMergedColumns.flatMap((column)=>{
        if ('children' in column) return [
            column
        ].concat((0, $3746fb019e1f2ee5$export$2e2bcd8739ae039)($277d684919ff2714$var$getMergedColumns(column.children || [])));
        return [
            column
        ];
    });
const $277d684919ff2714$var$useFilter = (props)=>{
    const { prefixCls: prefixCls, dropdownPrefixCls: dropdownPrefixCls, mergedColumns: rawMergedColumns, onFilterChange: onFilterChange, getPopupContainer: getPopupContainer, locale: tableLocale, rootClassName: rootClassName } = props;
    const warning = (0, $d41680c8243eac18$export$cf977aa92c751e61)('Table');
    const mergedColumns = $32rMB.useMemo(()=>$277d684919ff2714$var$getMergedColumns(rawMergedColumns || []), [
        rawMergedColumns
    ]);
    const [filterStates, setFilterStates] = $32rMB.useState(()=>$277d684919ff2714$var$collectFilterStates(mergedColumns, true));
    const mergedFilterStates = $32rMB.useMemo(()=>{
        const collectedStates = $277d684919ff2714$var$collectFilterStates(mergedColumns, false);
        if (collectedStates.length === 0) return collectedStates;
        let filteredKeysIsAllNotControlled = true;
        let filteredKeysIsAllControlled = true;
        collectedStates.forEach(({ filteredKeys: filteredKeys })=>{
            if (filteredKeys !== undefined) filteredKeysIsAllNotControlled = false;
            else filteredKeysIsAllControlled = false;
        });
        // Return if not controlled
        if (filteredKeysIsAllNotControlled) {
            // Filter column may have been removed
            const keyList = (mergedColumns || []).map((column, index)=>(0, $4e57f4bd37ec1f3f$export$480219a02f196e72)(column, (0, $4e57f4bd37ec1f3f$export$7e4db04adce9b4db)(index)));
            return filterStates.filter(({ key: key })=>keyList.includes(key)).map((item)=>{
                const col = mergedColumns[keyList.indexOf(item.key)];
                return {
                    ...item,
                    column: {
                        ...item.column,
                        ...col
                    },
                    forceFiltered: col.filtered
                };
            });
        }
        return collectedStates;
    }, [
        mergedColumns,
        filterStates
    ]);
    const filters = $32rMB.useMemo(()=>$277d684919ff2714$var$generateFilterInfo(mergedFilterStates), [
        mergedFilterStates
    ]);
    const triggerFilter = (filterState)=>{
        const newFilterStates = mergedFilterStates.filter(({ key: key })=>key !== filterState.key);
        newFilterStates.push(filterState);
        setFilterStates(newFilterStates);
        onFilterChange($277d684919ff2714$var$generateFilterInfo(newFilterStates), newFilterStates);
    };
    const transformColumns = (innerColumns)=>$277d684919ff2714$var$injectFilter(prefixCls, dropdownPrefixCls, innerColumns, mergedFilterStates, tableLocale, triggerFilter, getPopupContainer, undefined, rootClassName);
    return [
        transformColumns,
        mergedFilterStates,
        filters
    ];
};
var $277d684919ff2714$export$2e2bcd8739ae039 = $277d684919ff2714$var$useFilter;


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
const $4021ef1459e32498$var$useLazyKVMap = (data, childrenColumnName, getRowKey)=>{
    const mapCacheRef = $32rMB.useRef({});
    function getRecordByKey(key) {
        if (!mapCacheRef.current || mapCacheRef.current.data !== data || mapCacheRef.current.childrenColumnName !== childrenColumnName || mapCacheRef.current.getRowKey !== getRowKey) {
            const kvMap = new Map();
            function dig(records) {
                records.forEach((record, index)=>{
                    const rowKey = getRowKey(record, index);
                    kvMap.set(rowKey, record);
                    if (record && typeof record === 'object' && childrenColumnName in record) dig(record[childrenColumnName] || []);
                });
            }
            dig(data);
            mapCacheRef.current = {
                data: data,
                childrenColumnName: childrenColumnName,
                kvMap: kvMap,
                getRowKey: getRowKey
            };
        }
        return mapCacheRef.current.kvMap?.get(key);
    }
    return [
        getRecordByKey
    ];
};
var $4021ef1459e32498$export$2e2bcd8739ae039 = $4021ef1459e32498$var$useLazyKVMap;


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");

const $8a644da720268443$export$5716e8bcb003888d = 10;
function $8a644da720268443$export$27eceeed7bf0f4c2(mergedPagination, pagination) {
    const param = {
        current: mergedPagination.current,
        pageSize: mergedPagination.pageSize
    };
    const paginationObj = pagination && typeof pagination === 'object' ? pagination : {};
    Object.keys(paginationObj).forEach((pageProp)=>{
        const value = mergedPagination[pageProp];
        if (typeof value !== 'function') param[pageProp] = value;
    });
    return param;
}
function $8a644da720268443$var$usePagination(total, onChange, pagination) {
    const { total: paginationTotal = 0, ...paginationObj } = pagination && typeof pagination === 'object' ? pagination : {};
    const [innerPagination, setInnerPagination] = (0, $32rMB.useState)(()=>({
            current: 'defaultCurrent' in paginationObj ? paginationObj.defaultCurrent : 1,
            pageSize: 'defaultPageSize' in paginationObj ? paginationObj.defaultPageSize : $8a644da720268443$export$5716e8bcb003888d
        }));
    // ============ Basic Pagination Config ============
    const mergedPagination = (0, $c63f725913016a25$export$2e2bcd8739ae039)(innerPagination, paginationObj, {
        total: paginationTotal > 0 ? paginationTotal : total
    });
    // Reset `current` if data length or pageSize changed
    const maxPage = Math.ceil((paginationTotal || total) / mergedPagination.pageSize);
    if (mergedPagination.current > maxPage) // Prevent a maximum page count of 0
    mergedPagination.current = maxPage || 1;
    const refreshPagination = (current, pageSize)=>{
        setInnerPagination({
            current: current ?? 1,
            pageSize: pageSize || mergedPagination.pageSize
        });
    };
    const onInternalChange = (current, pageSize)=>{
        if (pagination) pagination.onChange?.(current, pageSize);
        refreshPagination(current, pageSize);
        onChange(current, pageSize || mergedPagination?.pageSize);
    };
    if (pagination === false) return [
        {},
        ()=>{}
    ];
    return [
        {
            ...mergedPagination,
            onChange: onInternalChange
        },
        refreshPagination
    ];
}
var $8a644da720268443$export$2e2bcd8739ae039 = $8a644da720268443$var$usePagination;




parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");
parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
// This icon file is generated automatically.
var $770988ebca2f9c89$var$CaretDownOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z"
                }
            }
        ]
    },
    "name": "caret-down",
    "theme": "outlined"
};
var $770988ebca2f9c89$export$2e2bcd8739ae039 = $770988ebca2f9c89$var$CaretDownOutlined;



function $4b7cbd6e479e83a9$var$_extends() {
    $4b7cbd6e479e83a9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4b7cbd6e479e83a9$var$_extends.apply(this, arguments);
}
const $4b7cbd6e479e83a9$var$CaretDownOutlined = (props, ref)=>/*#__PURE__*/ $hO8yS.createElement((0, $5fd6f3f3c400c267$export$2e2bcd8739ae039), $4b7cbd6e479e83a9$var$_extends({}, props, {
        ref: ref,
        icon: (0, $770988ebca2f9c89$export$2e2bcd8739ae039)
    }));
/**![caret-down](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg0MC40IDMwMEgxODMuNmMtMTkuNyAwLTMwLjcgMjAuOC0xOC41IDM1bDMyOC40IDM4MC44YzkuNCAxMC45IDI3LjUgMTAuOSAzNyAwTDg1OC45IDMzNWMxMi4yLTE0LjIgMS4yLTM1LTE4LjUtMzV6IiAvPjwvc3ZnPg==) */ const $4b7cbd6e479e83a9$var$RefIcon = /*#__PURE__*/ $N3oW3.forwardRef($4b7cbd6e479e83a9$var$CaretDownOutlined);
var $4b7cbd6e479e83a9$export$2e2bcd8739ae039 = $4b7cbd6e479e83a9$var$RefIcon;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
// This icon file is generated automatically.
var $910f7306f5bf0855$var$CaretUpOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z"
                }
            }
        ]
    },
    "name": "caret-up",
    "theme": "outlined"
};
var $910f7306f5bf0855$export$2e2bcd8739ae039 = $910f7306f5bf0855$var$CaretUpOutlined;



function $0490f62138d60577$var$_extends() {
    $0490f62138d60577$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0490f62138d60577$var$_extends.apply(this, arguments);
}
const $0490f62138d60577$var$CaretUpOutlined = (props, ref)=>/*#__PURE__*/ $hO8yS.createElement((0, $5fd6f3f3c400c267$export$2e2bcd8739ae039), $0490f62138d60577$var$_extends({}, props, {
        ref: ref,
        icon: (0, $910f7306f5bf0855$export$2e2bcd8739ae039)
    }));
/**![caret-up](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg1OC45IDY4OUw1MzAuNSAzMDguMmMtOS40LTEwLjktMjcuNS0xMC45LTM3IDBMMTY1LjEgNjg5Yy0xMi4yIDE0LjItMS4yIDM1IDE4LjUgMzVoNjU2LjhjMTkuNyAwIDMwLjctMjAuOCAxOC41LTM1eiIgLz48L3N2Zz4=) */ const $0490f62138d60577$var$RefIcon = /*#__PURE__*/ $N3oW3.forwardRef($0490f62138d60577$var$CaretUpOutlined);
var $0490f62138d60577$export$2e2bcd8739ae039 = $0490f62138d60577$var$RefIcon;






"use client";
const $54e1725fbe4607ee$var$ASCEND = 'ascend';
const $54e1725fbe4607ee$var$DESCEND = 'descend';
const $54e1725fbe4607ee$var$getMultiplePriority = (column)=>{
    if (typeof column.sorter === 'object' && typeof column.sorter.multiple === 'number') return column.sorter.multiple;
    return false;
};
const $54e1725fbe4607ee$var$getSortFunction = (sorter)=>{
    if (typeof sorter === 'function') return sorter;
    if (sorter && typeof sorter === 'object' && sorter.compare) return sorter.compare;
    return false;
};
const $54e1725fbe4607ee$var$nextSortDirection = (sortDirections, current)=>{
    if (!current) return sortDirections[0];
    return sortDirections[sortDirections.indexOf(current) + 1];
};
const $54e1725fbe4607ee$var$collectSortStates = (columns, init, pos)=>{
    let sortStates = [];
    const pushState = (column, columnPos)=>{
        sortStates.push({
            column: column,
            key: (0, $4e57f4bd37ec1f3f$export$480219a02f196e72)(column, columnPos),
            multiplePriority: $54e1725fbe4607ee$var$getMultiplePriority(column),
            sortOrder: column.sortOrder
        });
    };
    (columns || []).forEach((column, index)=>{
        const columnPos = (0, $4e57f4bd37ec1f3f$export$7e4db04adce9b4db)(index, pos);
        if (column.children) {
            if ('sortOrder' in column) // Controlled
            pushState(column, columnPos);
            sortStates = [].concat((0, $3746fb019e1f2ee5$export$2e2bcd8739ae039)(sortStates), (0, $3746fb019e1f2ee5$export$2e2bcd8739ae039)($54e1725fbe4607ee$var$collectSortStates(column.children, init, columnPos)));
        } else if (column.sorter) {
            if ('sortOrder' in column) // Controlled
            pushState(column, columnPos);
            else if (init && column.defaultSortOrder) // Default sorter
            sortStates.push({
                column: column,
                key: (0, $4e57f4bd37ec1f3f$export$480219a02f196e72)(column, columnPos),
                multiplePriority: $54e1725fbe4607ee$var$getMultiplePriority(column),
                sortOrder: column.defaultSortOrder
            });
        }
    });
    return sortStates;
};
const $54e1725fbe4607ee$var$injectSorter = (prefixCls, columns, sorterStates, triggerSorter, defaultSortDirections, tableLocale, tableShowSorterTooltip, pos, a11yLocale)=>{
    const finalColumns = (columns || []).map((column, index)=>{
        const columnPos = (0, $4e57f4bd37ec1f3f$export$7e4db04adce9b4db)(index, pos);
        let newColumn = column;
        if (newColumn.sorter) {
            const sortDirections = newColumn.sortDirections || defaultSortDirections;
            const showSorterTooltip = newColumn.showSorterTooltip === undefined ? tableShowSorterTooltip : newColumn.showSorterTooltip;
            const columnKey = (0, $4e57f4bd37ec1f3f$export$480219a02f196e72)(newColumn, columnPos);
            const sorterState = sorterStates.find(({ key: key })=>key === columnKey);
            const sortOrder = sorterState ? sorterState.sortOrder : null;
            const nextSortOrder = $54e1725fbe4607ee$var$nextSortDirection(sortDirections, sortOrder);
            let sorter;
            if (column.sortIcon) sorter = column.sortIcon({
                sortOrder: sortOrder
            });
            else {
                const upNode = sortDirections.includes($54e1725fbe4607ee$var$ASCEND) && /*#__PURE__*/ $hO8yS.createElement((0, $0490f62138d60577$export$2e2bcd8739ae039), {
                    className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-column-sorter-up`, {
                        active: sortOrder === $54e1725fbe4607ee$var$ASCEND
                    })
                });
                const downNode = sortDirections.includes($54e1725fbe4607ee$var$DESCEND) && /*#__PURE__*/ $hO8yS.createElement((0, $4b7cbd6e479e83a9$export$2e2bcd8739ae039), {
                    className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-column-sorter-down`, {
                        active: sortOrder === $54e1725fbe4607ee$var$DESCEND
                    })
                });
                sorter = /*#__PURE__*/ $hO8yS.createElement("span", {
                    className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-column-sorter`, {
                        [`${prefixCls}-column-sorter-full`]: !!(upNode && downNode)
                    })
                }, /*#__PURE__*/ $hO8yS.createElement("span", {
                    className: `${prefixCls}-column-sorter-inner`,
                    "aria-hidden": "true"
                }, upNode, downNode));
            }
            const { cancelSort: cancelSort, triggerAsc: triggerAsc, triggerDesc: triggerDesc } = tableLocale || {};
            let sortTip = cancelSort;
            if (nextSortOrder === $54e1725fbe4607ee$var$DESCEND) sortTip = triggerDesc;
            else if (nextSortOrder === $54e1725fbe4607ee$var$ASCEND) sortTip = triggerAsc;
            const tooltipProps = typeof showSorterTooltip === 'object' ? {
                title: sortTip,
                ...showSorterTooltip
            } : {
                title: sortTip
            };
            newColumn = {
                ...newColumn,
                className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(newColumn.className, {
                    [`${prefixCls}-column-sort`]: sortOrder
                }),
                title: (renderProps)=>{
                    const columnSortersClass = `${prefixCls}-column-sorters`;
                    const renderColumnTitleWrapper = /*#__PURE__*/ $hO8yS.createElement("span", {
                        className: `${prefixCls}-column-title`
                    }, (0, $4e57f4bd37ec1f3f$export$cfda450db2088de7)(column.title, renderProps));
                    const renderSortTitle = /*#__PURE__*/ $hO8yS.createElement("div", {
                        className: columnSortersClass
                    }, renderColumnTitleWrapper, sorter);
                    if (showSorterTooltip) {
                        if (typeof showSorterTooltip !== 'boolean' && showSorterTooltip?.target === 'sorter-icon') return /*#__PURE__*/ $hO8yS.createElement("div", {
                            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(columnSortersClass, `${columnSortersClass}-tooltip-target-sorter`)
                        }, renderColumnTitleWrapper, /*#__PURE__*/ $hO8yS.createElement((0, $bdb14b445459ab9d$export$2e2bcd8739ae039), {
                            ...tooltipProps
                        }, sorter));
                        return /*#__PURE__*/ $hO8yS.createElement((0, $bdb14b445459ab9d$export$2e2bcd8739ae039), {
                            ...tooltipProps
                        }, renderSortTitle);
                    }
                    return renderSortTitle;
                },
                onHeaderCell: (col)=>{
                    const cell = column.onHeaderCell?.(col) || {};
                    const originOnClick = cell.onClick;
                    const originOKeyDown = cell.onKeyDown;
                    cell.onClick = (event)=>{
                        triggerSorter({
                            column: column,
                            key: columnKey,
                            sortOrder: nextSortOrder,
                            multiplePriority: $54e1725fbe4607ee$var$getMultiplePriority(column)
                        });
                        originOnClick?.(event);
                    };
                    cell.onKeyDown = (event)=>{
                        if (event.keyCode === (0, $4d7d870d585f8465$export$2e2bcd8739ae039).ENTER) {
                            triggerSorter({
                                column: column,
                                key: columnKey,
                                sortOrder: nextSortOrder,
                                multiplePriority: $54e1725fbe4607ee$var$getMultiplePriority(column)
                            });
                            originOKeyDown?.(event);
                        }
                    };
                    const renderTitle = (0, $4e57f4bd37ec1f3f$export$1c24e0676a106839)(column.title, {});
                    const displayTitle = renderTitle?.toString();
                    // Inform the screen-reader so it can tell the visually impaired user which column is sorted
                    if (sortOrder) cell['aria-sort'] = sortOrder === 'ascend' ? 'ascending' : 'descending';
                    // Inform the screen-reader so it can tell the visually impaired user that this column can be sorted
                    cell['aria-description'] = a11yLocale?.sortable;
                    cell['aria-label'] = displayTitle || '';
                    cell.className = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(cell.className, `${prefixCls}-column-has-sorters`);
                    cell.tabIndex = 0;
                    if (column.ellipsis) cell.title = (renderTitle ?? '').toString();
                    return cell;
                }
            };
        }
        if ('children' in newColumn) newColumn = {
            ...newColumn,
            children: $54e1725fbe4607ee$var$injectSorter(prefixCls, newColumn.children, sorterStates, triggerSorter, defaultSortDirections, tableLocale, tableShowSorterTooltip, columnPos, a11yLocale)
        };
        return newColumn;
    });
    return finalColumns;
};
const $54e1725fbe4607ee$var$stateToInfo = (sorterState)=>{
    const { column: column, sortOrder: sortOrder } = sorterState;
    return {
        column: column,
        order: sortOrder,
        field: column.dataIndex,
        columnKey: column.key
    };
};
const $54e1725fbe4607ee$var$generateSorterInfo = (sorterStates)=>{
    const activeSorters = sorterStates.filter(({ sortOrder: sortOrder })=>sortOrder).map($54e1725fbe4607ee$var$stateToInfo);
    // =========== Legacy compatible support ===========
    // https://github.com/ant-design/ant-design/pull/19226
    if (activeSorters.length === 0 && sorterStates.length) {
        const lastIndex = sorterStates.length - 1;
        return {
            ...$54e1725fbe4607ee$var$stateToInfo(sorterStates[lastIndex]),
            column: undefined,
            order: undefined,
            field: undefined,
            columnKey: undefined
        };
    }
    if (activeSorters.length <= 1) return activeSorters[0] || {};
    return activeSorters;
};
const $54e1725fbe4607ee$export$594b2c8da4a70ee = (data, sortStates, childrenColumnName)=>{
    const innerSorterStates = sortStates.slice().sort((a, b)=>b.multiplePriority - a.multiplePriority);
    const cloneData = data.slice();
    const runningSorters = innerSorterStates.filter(({ column: { sorter: sorter }, sortOrder: sortOrder })=>$54e1725fbe4607ee$var$getSortFunction(sorter) && sortOrder);
    // Skip if no sorter needed
    if (!runningSorters.length) return cloneData;
    return cloneData.sort((record1, record2)=>{
        for(let i = 0; i < runningSorters.length; i += 1){
            const sorterState = runningSorters[i];
            const { column: { sorter: sorter }, sortOrder: sortOrder } = sorterState;
            const compareFn = $54e1725fbe4607ee$var$getSortFunction(sorter);
            if (compareFn && sortOrder) {
                const compareResult = compareFn(record1, record2, sortOrder);
                if (compareResult !== 0) return sortOrder === $54e1725fbe4607ee$var$ASCEND ? compareResult : -compareResult;
            }
        }
        return 0;
    }).map((record)=>{
        const subRecords = record[childrenColumnName];
        if (subRecords) return {
            ...record,
            [childrenColumnName]: $54e1725fbe4607ee$export$594b2c8da4a70ee(subRecords, sortStates, childrenColumnName)
        };
        return record;
    });
};
const $54e1725fbe4607ee$var$useFilterSorter = (props)=>{
    const { prefixCls: prefixCls, mergedColumns: mergedColumns, sortDirections: sortDirections, tableLocale: tableLocale, showSorterTooltip: showSorterTooltip, onSorterChange: onSorterChange, globalLocale: globalLocale } = props;
    const [sortStates, setSortStates] = $32rMB.useState(()=>$54e1725fbe4607ee$var$collectSortStates(mergedColumns, true));
    const getColumnKeys = (columns, pos)=>{
        const newKeys = [];
        columns.forEach((item, index)=>{
            const columnPos = (0, $4e57f4bd37ec1f3f$export$7e4db04adce9b4db)(index, pos);
            newKeys.push((0, $4e57f4bd37ec1f3f$export$480219a02f196e72)(item, columnPos));
            if (Array.isArray(item.children)) {
                const childKeys = getColumnKeys(item.children, columnPos);
                newKeys.push.apply(newKeys, (0, $3746fb019e1f2ee5$export$2e2bcd8739ae039)(childKeys));
            }
        });
        return newKeys;
    };
    const mergedSorterStates = $32rMB.useMemo(()=>{
        let validate = true;
        const collectedStates = $54e1725fbe4607ee$var$collectSortStates(mergedColumns, false);
        // Return if not controlled
        if (!collectedStates.length) {
            const mergedColumnsKeys = getColumnKeys(mergedColumns);
            return sortStates.filter(({ key: key })=>mergedColumnsKeys.includes(key));
        }
        const validateStates = [];
        function patchStates(state) {
            if (validate) validateStates.push(state);
            else validateStates.push({
                ...state,
                sortOrder: null
            });
        }
        let multipleMode = null;
        collectedStates.forEach((state)=>{
            if (multipleMode === null) {
                patchStates(state);
                if (state.sortOrder) {
                    if (state.multiplePriority === false) validate = false;
                    else multipleMode = true;
                }
            } else if (multipleMode && state.multiplePriority !== false) patchStates(state);
            else {
                validate = false;
                patchStates(state);
            }
        });
        return validateStates;
    }, [
        mergedColumns,
        sortStates
    ]);
    // Get render columns title required props
    const columnTitleSorterProps = $32rMB.useMemo(()=>{
        const sortColumns = mergedSorterStates.map(({ column: column, sortOrder: sortOrder })=>({
                column: column,
                order: sortOrder
            }));
        return {
            sortColumns: sortColumns,
            // Legacy
            sortColumn: sortColumns[0]?.column,
            sortOrder: sortColumns[0]?.order
        };
    }, [
        mergedSorterStates
    ]);
    const triggerSorter = (sortState)=>{
        let newSorterStates;
        if (sortState.multiplePriority === false || !mergedSorterStates.length || mergedSorterStates[0].multiplePriority === false) newSorterStates = [
            sortState
        ];
        else newSorterStates = [].concat((0, $3746fb019e1f2ee5$export$2e2bcd8739ae039)(mergedSorterStates.filter(({ key: key })=>key !== sortState.key)), [
            sortState
        ]);
        setSortStates(newSorterStates);
        onSorterChange($54e1725fbe4607ee$var$generateSorterInfo(newSorterStates), newSorterStates);
    };
    const transformColumns = (innerColumns)=>$54e1725fbe4607ee$var$injectSorter(prefixCls, innerColumns, mergedSorterStates, triggerSorter, sortDirections, tableLocale, showSorterTooltip, undefined, globalLocale);
    const getSorters = ()=>$54e1725fbe4607ee$var$generateSorterInfo(mergedSorterStates);
    return [
        transformColumns,
        mergedSorterStates,
        columnTitleSorterProps,
        getSorters
    ];
};
var $54e1725fbe4607ee$export$2e2bcd8739ae039 = $54e1725fbe4607ee$var$useFilterSorter;


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");

const $da535fbd1a514794$var$fillTitle = (columns, columnTitleProps)=>{
    const finalColumns = columns.map((column)=>{
        const cloneColumn = {
            ...column
        };
        cloneColumn.title = (0, $4e57f4bd37ec1f3f$export$cfda450db2088de7)(column.title, columnTitleProps);
        if ('children' in cloneColumn) cloneColumn.children = $da535fbd1a514794$var$fillTitle(cloneColumn.children, columnTitleProps);
        return cloneColumn;
    });
    return finalColumns;
};
const $da535fbd1a514794$var$useTitleColumns = (columnTitleProps)=>{
    const filledColumns = $32rMB.useCallback((columns)=>$da535fbd1a514794$var$fillTitle(columns, columnTitleProps), [
        columnTitleProps
    ]);
    return [
        filledColumns
    ];
};
var $da535fbd1a514794$export$2e2bcd8739ae039 = $da535fbd1a514794$var$useTitleColumns;



"use client";
/**
 * Same as `rc-component/table` but we modify trigger children update logic instead.
 */ const $58112a7c4e4e00db$var$RcTable = (0, $a9ad8dfff2cff25d$export$13da147d1fdf3e3c)((prev, next)=>{
    const { _renderTimes: prevRenderTimes } = prev;
    const { _renderTimes: nextRenderTimes } = next;
    return prevRenderTimes !== nextRenderTimes;
});
var $58112a7c4e4e00db$export$2e2bcd8739ae039 = $58112a7c4e4e00db$var$RcTable;



"use client";
/**
 * Same as `rc-component/table` but we modify trigger children update logic instead.
 */ const $62e5d5292cece3ed$var$RcVirtualTable = (0, $7e2ea9e225713277$export$4747b79b36862360)((prev, next)=>{
    const { _renderTimes: prevRenderTimes } = prev;
    const { _renderTimes: nextRenderTimes } = next;
    return prevRenderTimes !== nextRenderTimes;
});
var $62e5d5292cece3ed$export$2e2bcd8739ae039 = $62e5d5292cece3ed$var$RcVirtualTable;







const $a098f63b90ab548f$var$genBorderedStyle = (token)=>{
    const { componentCls: componentCls, lineWidth: lineWidth, lineType: lineType, tableBorderColor: tableBorderColor, tableHeaderBg: tableHeaderBg, tablePaddingVertical: tablePaddingVertical, tablePaddingHorizontal: tablePaddingHorizontal, calc: calc } = token;
    const tableBorder = `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(lineWidth)} ${lineType} ${tableBorderColor}`;
    const getSizeBorderStyle = (size, paddingVertical, paddingHorizontal)=>({
            [`&${componentCls}-${size}`]: {
                [`> ${componentCls}-container`]: {
                    [`> ${componentCls}-content, > ${componentCls}-body`]: {
                        [`
            > table > tbody > tr > th,
            > table > tbody > tr > td
          `]: {
                            [`> ${componentCls}-expanded-row-fixed`]: {
                                margin: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(calc(paddingVertical).mul(-1).equal())}
              ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(calc(calc(paddingHorizontal).add(lineWidth)).mul(-1).equal())}`
                            }
                        }
                    }
                }
            }
        });
    return {
        [`${componentCls}-wrapper`]: {
            [`${componentCls}${componentCls}-bordered`]: {
                // ============================ Title =============================
                [`> ${componentCls}-title`]: {
                    border: tableBorder,
                    borderBottom: 0
                },
                // ============================ Content ============================
                [`> ${componentCls}-container`]: {
                    borderInlineStart: tableBorder,
                    borderTop: tableBorder,
                    [`
            > ${componentCls}-content,
            > ${componentCls}-header,
            > ${componentCls}-body,
            > ${componentCls}-summary
          `]: {
                        '> table': {
                            // ============================= Cell =============================
                            [`
                > thead > tr > th,
                > thead > tr > td,
                > tbody > tr > th,
                > tbody > tr > td,
                > tfoot > tr > th,
                > tfoot > tr > td
              `]: {
                                borderInlineEnd: tableBorder
                            },
                            // ============================ Header ============================
                            '> thead': {
                                '> tr:not(:last-child) > th': {
                                    borderBottom: tableBorder
                                },
                                '> tr > th::before': {
                                    backgroundColor: 'transparent !important'
                                }
                            },
                            // Fixed right should provides additional border
                            [`
                > thead > tr,
                > tbody > tr,
                > tfoot > tr
              `]: {
                                [`> ${componentCls}-cell-fix-right-first::after`]: {
                                    borderInlineEnd: tableBorder
                                }
                            },
                            // ========================== Expandable ==========================
                            [`
                > tbody > tr > th,
                > tbody > tr > td
              `]: {
                                [`> ${componentCls}-expanded-row-fixed`]: {
                                    margin: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(calc(tablePaddingVertical).mul(-1).equal())} ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(calc(calc(tablePaddingHorizontal).add(lineWidth)).mul(-1).equal())}`,
                                    '&::after': {
                                        position: 'absolute',
                                        top: 0,
                                        insetInlineEnd: lineWidth,
                                        bottom: 0,
                                        borderInlineEnd: tableBorder,
                                        content: '""'
                                    }
                                }
                            }
                        }
                    }
                },
                // ============================ Scroll ============================
                [`&${componentCls}-scroll-horizontal`]: {
                    [`> ${componentCls}-container > ${componentCls}-body`]: {
                        '> table > tbody': {
                            [`
                > tr${componentCls}-expanded-row,
                > tr${componentCls}-placeholder
              `]: {
                                '> th, > td': {
                                    borderInlineEnd: 0
                                }
                            }
                        }
                    }
                },
                // ============================ Size ============================
                ...getSizeBorderStyle('middle', token.tablePaddingVerticalMiddle, token.tablePaddingHorizontalMiddle),
                ...getSizeBorderStyle('small', token.tablePaddingVerticalSmall, token.tablePaddingHorizontalSmall),
                // ============================ Footer ============================
                [`> ${componentCls}-footer`]: {
                    border: tableBorder,
                    borderTop: 0
                }
            },
            // ============================ Nested ============================
            [`${componentCls}-cell`]: {
                [`${componentCls}-container:first-child`]: {
                    // :first-child to avoid the case when bordered and title is set
                    borderTop: 0
                },
                // https://github.com/ant-design/ant-design/issues/35577
                '&-scrollbar:not([rowspan])': {
                    boxShadow: `0 ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(lineWidth)} 0 ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(lineWidth)} ${tableHeaderBg}`
                }
            },
            [`${componentCls}-bordered ${componentCls}-cell-scrollbar`]: {
                borderInlineEnd: tableBorder
            }
        }
    };
};
var $a098f63b90ab548f$export$2e2bcd8739ae039 = $a098f63b90ab548f$var$genBorderedStyle;



const $a50cf50759bb1166$var$genEllipsisStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-wrapper`]: {
            [`${componentCls}-cell-ellipsis`]: {
                ...(0, $2f353af2b0f7600b$export$b2b65df0d0824629),
                wordBreak: 'keep-all',
                // Fixed first or last should special process
                [`
          &${componentCls}-cell-fix-start-shadow,
          &${componentCls}-cell-fix-end-shadow
        `]: {
                    overflow: 'visible',
                    [`${componentCls}-cell-content`]: {
                        ...(0, $2f353af2b0f7600b$export$b2b65df0d0824629),
                        display: 'block'
                    }
                },
                [`${componentCls}-column-title`]: {
                    ...(0, $2f353af2b0f7600b$export$b2b65df0d0824629),
                    wordBreak: 'keep-all'
                }
            }
        }
    };
};
var $a50cf50759bb1166$export$2e2bcd8739ae039 = $a50cf50759bb1166$var$genEllipsisStyle;


// ========================= Placeholder ==========================
const $f1041df7cabca587$var$genEmptyStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-wrapper`]: {
            [`${componentCls}-tbody > tr${componentCls}-placeholder`]: {
                textAlign: 'center',
                color: token.colorTextDisabled,
                [`
          &:hover > th,
          &:hover > td,
        `]: {
                    background: token.colorBgContainer
                }
            }
        }
    };
};
var $f1041df7cabca587$export$2e2bcd8739ae039 = $f1041df7cabca587$var$genEmptyStyle;




const $f2dccf46e40183fe$var$genExpandStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls, motionDurationSlow: motionDurationSlow, lineWidth: lineWidth, paddingXS: paddingXS, lineType: lineType, tableBorderColor: tableBorderColor, tableExpandIconBg: tableExpandIconBg, tableExpandColumnWidth: tableExpandColumnWidth, borderRadius: borderRadius, tablePaddingVertical: tablePaddingVertical, tablePaddingHorizontal: tablePaddingHorizontal, tableExpandedRowBg: tableExpandedRowBg, paddingXXS: paddingXXS, expandIconMarginTop: expandIconMarginTop, expandIconSize: expandIconSize, expandIconHalfInner: expandIconHalfInner, expandIconScale: expandIconScale, calc: calc } = token;
    const tableBorder = `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(lineWidth)} ${lineType} ${tableBorderColor}`;
    const expandIconLineOffset = calc(paddingXXS).sub(lineWidth).equal();
    return {
        [`${componentCls}-wrapper`]: {
            [`${componentCls}-expand-icon-col`]: {
                width: tableExpandColumnWidth
            },
            [`${componentCls}-row-expand-icon-cell`]: {
                textAlign: 'center',
                [`${componentCls}-row-expand-icon`]: {
                    display: 'inline-flex',
                    float: 'none',
                    verticalAlign: 'sub'
                }
            },
            [`${componentCls}-row-indent`]: {
                height: 1,
                float: 'left'
            },
            [`${componentCls}-row-expand-icon`]: {
                ...(0, $2f353af2b0f7600b$export$9a16e7694a707ab4)(token),
                position: 'relative',
                float: 'left',
                width: expandIconSize,
                height: expandIconSize,
                color: 'inherit',
                lineHeight: (0, $763a5b4b58d0a3ff$export$523c0b569236b342)(expandIconSize),
                background: tableExpandIconBg,
                border: tableBorder,
                borderRadius: borderRadius,
                transform: `scale(${expandIconScale})`,
                '&:focus, &:hover, &:active': {
                    borderColor: 'currentcolor'
                },
                '&::before, &::after': {
                    position: 'absolute',
                    background: 'currentcolor',
                    transition: `transform ${motionDurationSlow} ease-out`,
                    content: '""'
                },
                '&::before': {
                    top: expandIconHalfInner,
                    insetInlineEnd: expandIconLineOffset,
                    insetInlineStart: expandIconLineOffset,
                    height: lineWidth
                },
                '&::after': {
                    top: expandIconLineOffset,
                    bottom: expandIconLineOffset,
                    insetInlineStart: expandIconHalfInner,
                    width: lineWidth,
                    transform: 'rotate(90deg)'
                },
                // Motion effect
                '&-collapsed::before': {
                    transform: 'rotate(-180deg)'
                },
                '&-collapsed::after': {
                    transform: 'rotate(0deg)'
                },
                '&-spaced': {
                    '&::before, &::after': {
                        display: 'none',
                        content: 'none'
                    },
                    background: 'transparent',
                    border: 0,
                    visibility: 'hidden'
                }
            },
            [`${componentCls}-row-indent + ${componentCls}-row-expand-icon`]: {
                marginTop: expandIconMarginTop,
                marginInlineEnd: paddingXS
            },
            [`tr${componentCls}-expanded-row`]: {
                '&, &:hover': {
                    '> th, > td': {
                        background: tableExpandedRowBg
                    }
                },
                // https://github.com/ant-design/ant-design/issues/25573
                [`${antCls}-descriptions-view`]: {
                    display: 'flex',
                    table: {
                        flex: 'auto',
                        width: '100%'
                    }
                }
            },
            // With fixed
            [`${componentCls}-expanded-row-fixed`]: {
                position: 'relative',
                margin: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(calc(tablePaddingVertical).mul(-1).equal())} ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(calc(tablePaddingHorizontal).mul(-1).equal())}`,
                padding: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(tablePaddingVertical)} ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(tablePaddingHorizontal)}`
            }
        }
    };
};
var $f2dccf46e40183fe$export$2e2bcd8739ae039 = $f2dccf46e40183fe$var$genExpandStyle;




const $e63a3b6d6e25e763$var$genFilterStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls, iconCls: iconCls, tableFilterDropdownWidth: tableFilterDropdownWidth, tableFilterDropdownSearchWidth: tableFilterDropdownSearchWidth, paddingXXS: paddingXXS, paddingXS: paddingXS, colorText: colorText, lineWidth: lineWidth, lineType: lineType, tableBorderColor: tableBorderColor, headerIconColor: headerIconColor, fontSizeSM: fontSizeSM, tablePaddingHorizontal: tablePaddingHorizontal, borderRadius: borderRadius, motionDurationSlow: motionDurationSlow, colorIcon: colorIcon, colorPrimary: colorPrimary, tableHeaderFilterActiveBg: tableHeaderFilterActiveBg, colorTextDisabled: colorTextDisabled, tableFilterDropdownBg: tableFilterDropdownBg, tableFilterDropdownHeight: tableFilterDropdownHeight, controlItemBgHover: controlItemBgHover, controlItemBgActive: controlItemBgActive, boxShadowSecondary: boxShadowSecondary, filterDropdownMenuBg: filterDropdownMenuBg, calc: calc } = token;
    const dropdownPrefixCls = `${antCls}-dropdown`;
    const tableFilterDropdownPrefixCls = `${componentCls}-filter-dropdown`;
    const treePrefixCls = `${antCls}-tree`;
    const tableBorder = `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(lineWidth)} ${lineType} ${tableBorderColor}`;
    return [
        {
            [`${componentCls}-wrapper`]: {
                [`${componentCls}-filter-column`]: {
                    display: 'flex',
                    justifyContent: 'space-between'
                },
                [`${componentCls}-filter-trigger`]: {
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    marginBlock: calc(paddingXXS).mul(-1).equal(),
                    marginInline: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(paddingXXS)} ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(calc(tablePaddingHorizontal).div(2).mul(-1).equal())}`,
                    padding: `0 ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(paddingXXS)}`,
                    color: headerIconColor,
                    fontSize: fontSizeSM,
                    borderRadius: borderRadius,
                    cursor: 'pointer',
                    transition: `all ${motionDurationSlow}`,
                    '&:hover': {
                        color: colorIcon,
                        background: tableHeaderFilterActiveBg
                    },
                    '&.active': {
                        color: colorPrimary
                    }
                }
            }
        },
        {
            // Dropdown
            [`${antCls}-dropdown`]: {
                [tableFilterDropdownPrefixCls]: {
                    ...(0, $2f353af2b0f7600b$export$23997c3e44cc1c59)(token),
                    minWidth: tableFilterDropdownWidth,
                    backgroundColor: tableFilterDropdownBg,
                    borderRadius: borderRadius,
                    boxShadow: boxShadowSecondary,
                    overflow: 'hidden',
                    // Reset menu
                    [`${dropdownPrefixCls}-menu`]: {
                        // https://github.com/ant-design/ant-design/issues/4916
                        // https://github.com/ant-design/ant-design/issues/19542
                        maxHeight: tableFilterDropdownHeight,
                        overflowX: 'hidden',
                        border: 0,
                        boxShadow: 'none',
                        borderRadius: 'unset',
                        backgroundColor: filterDropdownMenuBg,
                        '&:empty::after': {
                            display: 'block',
                            padding: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(paddingXS)} 0`,
                            color: colorTextDisabled,
                            fontSize: fontSizeSM,
                            textAlign: 'center',
                            content: '"Not Found"'
                        }
                    },
                    [`${tableFilterDropdownPrefixCls}-tree`]: {
                        paddingBlock: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(paddingXS)} 0`,
                        paddingInline: paddingXS,
                        [treePrefixCls]: {
                            padding: 0
                        },
                        [`${treePrefixCls}-treenode ${treePrefixCls}-node-content-wrapper:hover`]: {
                            backgroundColor: controlItemBgHover
                        },
                        [`${treePrefixCls}-treenode-checkbox-checked ${treePrefixCls}-node-content-wrapper`]: {
                            '&, &:hover': {
                                backgroundColor: controlItemBgActive
                            }
                        }
                    },
                    [`${tableFilterDropdownPrefixCls}-search`]: {
                        padding: paddingXS,
                        borderBottom: tableBorder,
                        '&-input': {
                            input: {
                                minWidth: tableFilterDropdownSearchWidth
                            },
                            [iconCls]: {
                                color: colorTextDisabled
                            }
                        }
                    },
                    [`${tableFilterDropdownPrefixCls}-checkall`]: {
                        width: '100%',
                        marginBottom: paddingXXS,
                        marginInlineStart: paddingXXS
                    },
                    // Operation
                    [`${tableFilterDropdownPrefixCls}-btns`]: {
                        display: 'flex',
                        justifyContent: 'space-between',
                        padding: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(calc(paddingXS).sub(lineWidth).equal())} ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(paddingXS)}`,
                        overflow: 'hidden',
                        borderTop: tableBorder
                    }
                }
            }
        },
        // Dropdown Menu & SubMenu
        {
            // submenu of table filter dropdown
            [`${antCls}-dropdown ${tableFilterDropdownPrefixCls}, ${tableFilterDropdownPrefixCls}-submenu`]: {
                // Checkbox
                [`${antCls}-checkbox-wrapper + span`]: {
                    paddingInlineStart: paddingXS,
                    color: colorText
                },
                '> ul': {
                    maxHeight: 'calc(100vh - 130px)',
                    overflowX: 'hidden',
                    overflowY: 'auto'
                }
            }
        }
    ];
};
var $e63a3b6d6e25e763$export$2e2bcd8739ae039 = $e63a3b6d6e25e763$var$genFilterStyle;


function $79c33d63173da9aa$export$a16fd84c5da6565a({ colorSplit: shadowColor }) {
    const leftShadowStyle = {
        boxShadow: `inset 10px 0 8px -8px ${shadowColor}`
    };
    const rightShadowStyle = {
        boxShadow: `inset -10px 0 8px -8px ${shadowColor}`
    };
    return [
        leftShadowStyle,
        rightShadowStyle
    ];
}
const $79c33d63173da9aa$var$genFixedStyle = (token)=>{
    const { componentCls: componentCls, lineWidth: lineWidth, motionDurationSlow: motionDurationSlow, zIndexTableFixed: zIndexTableFixed, tableBg: tableBg, calc: calc } = token;
    const cellCls = `${componentCls}-cell`;
    const fixCellCls = `${cellCls}-fix`;
    const sharedShadowStyle = {
        position: 'absolute',
        top: 0,
        bottom: calc(lineWidth).mul(-1).equal(),
        width: 30,
        transition: `box-shadow ${motionDurationSlow}`,
        content: '""',
        pointerEvents: 'none'
    };
    const [leftShadowStyle, rightShadowStyle] = $79c33d63173da9aa$export$a16fd84c5da6565a(token);
    // Follow style is magic of shadow which should not follow token:
    return {
        [`${componentCls}-wrapper`]: {
            // ====================== Cell ======================
            [`${cellCls}${fixCellCls}`]: {
                position: 'sticky'
            },
            [fixCellCls]: {
                zIndex: `calc(var(--z-offset-reverse) + ${zIndexTableFixed})`,
                background: tableBg,
                '&:after': sharedShadowStyle,
                // Position
                '&-start:after': {
                    insetInlineStart: '100%'
                },
                '&-end:after': {
                    insetInlineEnd: '100%'
                },
                // visible
                '&-start-shadow-show:after': leftShadowStyle,
                '&-end-shadow-show:after': rightShadowStyle
            },
            // =================== Container ====================
            [`${componentCls}-container`]: {
                position: 'relative',
                '&:before, &:after': {
                    ...sharedShadowStyle,
                    zIndex: `calc(var(--columns-count) * 2 + ${zIndexTableFixed} + 1)`
                },
                '&:before': {
                    insetInlineStart: 0
                },
                '&:after': {
                    insetInlineEnd: 0
                }
            },
            [`${componentCls}-has-fix-start ${componentCls}-container:before`]: {
                display: 'none'
            },
            [`${componentCls}-has-fix-end ${componentCls}-container:after`]: {
                display: 'none'
            },
            [`${componentCls}-fix-start-shadow-show ${componentCls}-container:before`]: leftShadowStyle,
            [`${componentCls}-fix-end-shadow-show ${componentCls}-container:after`]: rightShadowStyle
        }
    };
};
var $79c33d63173da9aa$export$2e2bcd8739ae039 = $79c33d63173da9aa$var$genFixedStyle;



const $489527eec6ab58d0$var$genPaginationStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls, margin: margin } = token;
    return {
        [`${componentCls}-wrapper`]: {
            // ========================== Pagination ==========================
            [`${componentCls}-pagination${antCls}-pagination`]: {
                margin: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(margin)} 0`
            },
            [`${componentCls}-pagination`]: {
                display: 'flex',
                flexWrap: 'wrap',
                rowGap: token.paddingXS,
                '> *': {
                    flex: 'none'
                },
                '&-start': {
                    justifyContent: 'flex-start'
                },
                '&-center': {
                    justifyContent: 'center'
                },
                '&-end': {
                    justifyContent: 'flex-end'
                }
            }
        }
    };
};
var $489527eec6ab58d0$export$2e2bcd8739ae039 = $489527eec6ab58d0$var$genPaginationStyle;



const $57ba617433a81a8f$var$genRadiusStyle = (token)=>{
    const { componentCls: componentCls, tableRadius: tableRadius } = token;
    return {
        [`${componentCls}-wrapper`]: {
            [componentCls]: {
                // https://github.com/ant-design/ant-design/issues/39115#issuecomment-1362314574
                [`${componentCls}-title, ${componentCls}-header`]: {
                    borderRadius: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(tableRadius)} ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(tableRadius)} 0 0`
                },
                [`${componentCls}-title + ${componentCls}-container`]: {
                    borderStartStartRadius: 0,
                    borderStartEndRadius: 0,
                    // https://github.com/ant-design/ant-design/issues/41975
                    [`${componentCls}-header, table`]: {
                        borderRadius: 0
                    },
                    'table > thead > tr:first-child': {
                        'th:first-child, th:last-child, td:first-child, td:last-child': {
                            borderRadius: 0
                        }
                    }
                },
                '&-container': {
                    borderStartStartRadius: tableRadius,
                    borderStartEndRadius: tableRadius,
                    'table > thead > tr:first-child': {
                        '> *:first-child': {
                            borderStartStartRadius: tableRadius
                        },
                        '> *:last-child': {
                            borderStartEndRadius: tableRadius
                        }
                    }
                },
                '&-footer': {
                    borderRadius: `0 0 ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(tableRadius)} ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(tableRadius)}`
                }
            }
        }
    };
};
var $57ba617433a81a8f$export$2e2bcd8739ae039 = $57ba617433a81a8f$var$genRadiusStyle;



const $c134db5bf24aa3e8$var$genStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const [leftShadowStyle, rightShadowStyle] = (0, $79c33d63173da9aa$export$a16fd84c5da6565a)(token);
    return {
        [`${componentCls}-wrapper-rtl`]: {
            direction: 'rtl',
            table: {
                direction: 'rtl'
            },
            [`${componentCls}-row-expand-icon`]: {
                float: 'right',
                '&::after': {
                    transform: 'rotate(-90deg)'
                },
                '&-collapsed::before': {
                    transform: 'rotate(180deg)'
                },
                '&-collapsed::after': {
                    transform: 'rotate(0deg)'
                }
            },
            // ====================== Cell ======================
            [`${componentCls}-cell-fix`]: {
                '&-start-shadow-show:after': rightShadowStyle,
                '&-end-shadow-show:after': leftShadowStyle
            },
            // =================== Container ====================
            [`${componentCls}-container`]: {
                [`${componentCls}-row-indent`]: {
                    float: 'right'
                }
            },
            [`${componentCls}-fix-start-shadow-show ${componentCls}-container:before`]: rightShadowStyle,
            [`${componentCls}-fix-end-shadow-show ${componentCls}-container:after`]: leftShadowStyle
        }
    };
};
var $c134db5bf24aa3e8$export$2e2bcd8739ae039 = $c134db5bf24aa3e8$var$genStyle;



const $327d803edcec2f41$var$genSelectionStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls, iconCls: iconCls, fontSizeIcon: fontSizeIcon, padding: padding, paddingXS: paddingXS, headerIconColor: headerIconColor, headerIconHoverColor: headerIconHoverColor, tableSelectionColumnWidth: tableSelectionColumnWidth, tableSelectedRowBg: tableSelectedRowBg, tableSelectedRowHoverBg: tableSelectedRowHoverBg, tableRowHoverBg: tableRowHoverBg, tablePaddingHorizontal: tablePaddingHorizontal, calc: calc } = token;
    return {
        [`${componentCls}-wrapper`]: {
            // ========================== Selections ==========================
            [`${componentCls}-selection-col`]: {
                width: tableSelectionColumnWidth,
                [`&${componentCls}-selection-col-with-dropdown`]: {
                    width: calc(tableSelectionColumnWidth).add(fontSizeIcon).add(calc(padding).div(4)).equal()
                }
            },
            [`${componentCls}-bordered ${componentCls}-selection-col`]: {
                width: calc(tableSelectionColumnWidth).add(calc(paddingXS).mul(2)).equal(),
                [`&${componentCls}-selection-col-with-dropdown`]: {
                    width: calc(tableSelectionColumnWidth).add(fontSizeIcon).add(calc(padding).div(4)).add(calc(paddingXS).mul(2)).equal()
                }
            },
            [`
        table tr th${componentCls}-selection-column,
        table tr td${componentCls}-selection-column,
        ${componentCls}-selection-column
      `]: {
                paddingInlineEnd: token.paddingXS,
                paddingInlineStart: token.paddingXS,
                textAlign: 'center',
                [`${antCls}-radio-wrapper`]: {
                    marginInlineEnd: 0
                }
            },
            [`table tr th${componentCls}-selection-column${componentCls}-cell-fix-left`]: {
                zIndex: calc(token.zIndexTableFixed).add(1).equal({
                    unit: false
                })
            },
            [`table tr th${componentCls}-selection-column::after`]: {
                backgroundColor: 'transparent !important'
            },
            [`${componentCls}-selection`]: {
                position: 'relative',
                display: 'inline-flex',
                flexDirection: 'column'
            },
            [`${componentCls}-selection-extra`]: {
                position: 'absolute',
                top: 0,
                zIndex: 1,
                cursor: 'pointer',
                transition: `all ${token.motionDurationSlow}`,
                marginInlineStart: '100%',
                paddingInlineStart: (0, $763a5b4b58d0a3ff$export$523c0b569236b342)(calc(tablePaddingHorizontal).div(4).equal()),
                [iconCls]: {
                    color: headerIconColor,
                    fontSize: fontSizeIcon,
                    verticalAlign: 'baseline',
                    '&:hover': {
                        color: headerIconHoverColor
                    }
                }
            },
            // ============================= Rows =============================
            [`${componentCls}-tbody`]: {
                [`${componentCls}-row`]: {
                    [`&${componentCls}-row-selected`]: {
                        [`> ${componentCls}-cell`]: {
                            background: tableSelectedRowBg,
                            '&-row-hover': {
                                background: tableSelectedRowHoverBg
                            }
                        }
                    },
                    [`> ${componentCls}-cell-row-hover`]: {
                        background: tableRowHoverBg
                    }
                }
            }
        }
    };
};
var $327d803edcec2f41$export$2e2bcd8739ae039 = $327d803edcec2f41$var$genSelectionStyle;



const $14399733878180cf$var$genSizeStyle = (token)=>{
    const { componentCls: componentCls, tableExpandColumnWidth: tableExpandColumnWidth, calc: calc } = token;
    const getSizeStyle = (size, paddingVertical, paddingHorizontal, fontSize)=>({
            [`${componentCls}${componentCls}-${size}`]: {
                fontSize: fontSize,
                [`
        ${componentCls}-title,
        ${componentCls}-footer,
        ${componentCls}-cell,
        ${componentCls}-thead > tr > th,
        ${componentCls}-tbody > tr > th,
        ${componentCls}-tbody > tr > td,
        tfoot > tr > th,
        tfoot > tr > td
      `]: {
                    padding: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(paddingVertical)} ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(paddingHorizontal)}`
                },
                [`${componentCls}-filter-trigger`]: {
                    marginInlineEnd: (0, $763a5b4b58d0a3ff$export$523c0b569236b342)(calc(paddingHorizontal).div(2).mul(-1).equal())
                },
                [`${componentCls}-expanded-row-fixed`]: {
                    margin: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(calc(paddingVertical).mul(-1).equal())} ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(calc(paddingHorizontal).mul(-1).equal())}`
                },
                [`${componentCls}-tbody`]: {
                    // ========================= Nest Table ===========================
                    [`${componentCls}-wrapper:only-child ${componentCls}`]: {
                        marginBlock: (0, $763a5b4b58d0a3ff$export$523c0b569236b342)(calc(paddingVertical).mul(-1).equal()),
                        marginInline: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(calc(tableExpandColumnWidth).sub(paddingHorizontal).equal())} ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(calc(paddingHorizontal).mul(-1).equal())}`
                    }
                },
                // https://github.com/ant-design/ant-design/issues/35167
                [`${componentCls}-selection-extra`]: {
                    paddingInlineStart: (0, $763a5b4b58d0a3ff$export$523c0b569236b342)(calc(paddingHorizontal).div(4).equal())
                }
            }
        });
    return {
        [`${componentCls}-wrapper`]: {
            ...getSizeStyle('middle', token.tablePaddingVerticalMiddle, token.tablePaddingHorizontalMiddle, token.tableFontSizeMiddle),
            ...getSizeStyle('small', token.tablePaddingVerticalSmall, token.tablePaddingHorizontalSmall, token.tableFontSizeSmall)
        }
    };
};
var $14399733878180cf$export$2e2bcd8739ae039 = $14399733878180cf$var$genSizeStyle;


const $ac137d4b95a5cf86$var$genSorterStyle = (token)=>{
    const { componentCls: componentCls, marginXXS: marginXXS, fontSizeIcon: fontSizeIcon, headerIconColor: headerIconColor, headerIconHoverColor: headerIconHoverColor } = token;
    return {
        [`${componentCls}-wrapper`]: {
            [`${componentCls}-thead th${componentCls}-column-has-sorters`]: {
                outline: 'none',
                cursor: 'pointer',
                // why left 0s? Avoid column header move with transition when left is changed
                // https://github.com/ant-design/ant-design/issues/50588
                transition: `all ${token.motionDurationSlow}, left 0s`,
                '&:hover': {
                    background: token.tableHeaderSortHoverBg,
                    '&::before': {
                        backgroundColor: 'transparent !important'
                    }
                },
                '&:focus-visible': {
                    color: token.colorPrimary
                },
                // https://github.com/ant-design/ant-design/issues/30969
                [`
          &${componentCls}-cell-fix-left:hover,
          &${componentCls}-cell-fix-right:hover
        `]: {
                    background: token.tableFixedHeaderSortActiveBg
                }
            },
            [`${componentCls}-thead th${componentCls}-column-sort`]: {
                background: token.tableHeaderSortBg,
                '&::before': {
                    backgroundColor: 'transparent !important'
                }
            },
            [`td${componentCls}-column-sort`]: {
                background: token.tableBodySortBg
            },
            [`${componentCls}-column-title`]: {
                position: 'relative',
                zIndex: 1,
                flex: 1,
                minWidth: 0
            },
            [`${componentCls}-column-sorters`]: {
                display: 'flex',
                flex: 'auto',
                alignItems: 'center',
                justifyContent: 'space-between',
                '&::after': {
                    position: 'absolute',
                    inset: 0,
                    width: '100%',
                    height: '100%',
                    content: '""'
                }
            },
            [`${componentCls}-column-sorters-tooltip-target-sorter`]: {
                '&::after': {
                    content: 'none'
                }
            },
            [`${componentCls}-column-sorter`]: {
                marginInlineStart: marginXXS,
                color: headerIconColor,
                fontSize: 0,
                transition: `color ${token.motionDurationSlow}`,
                '&-inner': {
                    display: 'inline-flex',
                    flexDirection: 'column',
                    alignItems: 'center'
                },
                '&-up, &-down': {
                    fontSize: fontSizeIcon,
                    '&.active': {
                        color: token.colorPrimary
                    }
                },
                [`${componentCls}-column-sorter-up + ${componentCls}-column-sorter-down`]: {
                    marginTop: '-0.3em'
                }
            },
            [`${componentCls}-column-sorters:hover ${componentCls}-column-sorter`]: {
                color: headerIconHoverColor
            }
        }
    };
};
var $ac137d4b95a5cf86$export$2e2bcd8739ae039 = $ac137d4b95a5cf86$var$genSorterStyle;



const $a3ba101aba55e3fe$var$genStickyStyle = (token)=>{
    const { componentCls: componentCls, opacityLoading: opacityLoading, tableScrollThumbBg: tableScrollThumbBg, tableScrollThumbBgHover: tableScrollThumbBgHover, tableScrollThumbSize: tableScrollThumbSize, tableScrollBg: tableScrollBg, stickyScrollBarBorderRadius: stickyScrollBarBorderRadius, lineWidth: lineWidth, lineType: lineType, tableBorderColor: tableBorderColor, zIndexTableFixed: zIndexTableFixed } = token;
    const tableBorder = `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(lineWidth)} ${lineType} ${tableBorderColor}`;
    return {
        [`${componentCls}-wrapper`]: {
            [`${componentCls}-sticky`]: {
                '&-holder': {
                    position: 'sticky',
                    zIndex: `calc(var(--columns-count) * 2 + ${zIndexTableFixed} + 1)`,
                    background: token.colorBgContainer
                },
                '&-scroll': {
                    position: 'sticky',
                    bottom: 0,
                    height: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(tableScrollThumbSize)} !important`,
                    zIndex: `calc(var(--columns-count) * 2 + ${zIndexTableFixed} + 1)`,
                    display: 'flex',
                    alignItems: 'center',
                    background: tableScrollBg,
                    borderTop: tableBorder,
                    opacity: opacityLoading,
                    '&:hover': {
                        transformOrigin: 'center bottom'
                    },
                    // fake scrollbar style of sticky
                    '&-bar': {
                        height: tableScrollThumbSize,
                        backgroundColor: tableScrollThumbBg,
                        borderRadius: stickyScrollBarBorderRadius,
                        transition: `all ${token.motionDurationSlow}, transform 0s`,
                        position: 'absolute',
                        bottom: 0,
                        '&:hover, &-active': {
                            backgroundColor: tableScrollThumbBgHover
                        }
                    }
                }
            }
        }
    };
};
var $a3ba101aba55e3fe$export$2e2bcd8739ae039 = $a3ba101aba55e3fe$var$genStickyStyle;



const $483f053d426ad109$var$genSummaryStyle = (token)=>{
    const { componentCls: componentCls, lineWidth: lineWidth, tableBorderColor: tableBorderColor, calc: calc } = token;
    const tableBorder = `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(lineWidth)} ${token.lineType} ${tableBorderColor}`;
    return {
        [`${componentCls}-wrapper`]: {
            [`${componentCls}-summary`]: {
                position: 'relative',
                zIndex: token.zIndexTableFixed,
                background: token.tableBg,
                '> tr': {
                    '> th, > td': {
                        borderBottom: tableBorder
                    }
                }
            },
            [`div${componentCls}-summary`]: {
                boxShadow: `0 ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(calc(lineWidth).mul(-1).equal())} 0 ${tableBorderColor}`
            }
        }
    };
};
var $483f053d426ad109$export$2e2bcd8739ae039 = $483f053d426ad109$var$genSummaryStyle;



const $52f7f243bef004ef$var$genVirtualStyle = (token)=>{
    const { componentCls: componentCls, motionDurationMid: motionDurationMid, lineWidth: lineWidth, lineType: lineType, tableBorderColor: tableBorderColor, calc: calc } = token;
    const tableBorder = `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(lineWidth)} ${lineType} ${tableBorderColor}`;
    const rowCellCls = `${componentCls}-expanded-row-cell`;
    return {
        [`${componentCls}-wrapper`]: {
            // ========================== Row ==========================
            [`${componentCls}-tbody-virtual`]: {
                [`${componentCls}-tbody-virtual-holder-inner`]: {
                    [`
            & > ${componentCls}-row, 
            & > div:not(${componentCls}-row) > ${componentCls}-row
          `]: {
                        display: 'flex',
                        boxSizing: 'border-box',
                        width: '100%'
                    }
                },
                [`${componentCls}-cell`]: {
                    borderBottom: tableBorder,
                    transition: `background ${motionDurationMid}`
                },
                [`${componentCls}-expanded-row`]: {
                    [`${rowCellCls}${rowCellCls}-fixed`]: {
                        position: 'sticky',
                        insetInlineStart: 0,
                        overflow: 'hidden',
                        width: `calc(var(--virtual-width) - ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(lineWidth)})`,
                        borderInlineEnd: 'none'
                    }
                }
            },
            // ======================== Border =========================
            [`${componentCls}-bordered`]: {
                [`${componentCls}-tbody-virtual`]: {
                    '&:after': {
                        content: '""',
                        insetInline: 0,
                        bottom: 0,
                        borderBottom: tableBorder,
                        position: 'absolute'
                    },
                    [`${componentCls}-cell`]: {
                        borderInlineEnd: tableBorder,
                        [`&${componentCls}-cell-fix-right-first:before`]: {
                            content: '""',
                            position: 'absolute',
                            insetBlock: 0,
                            insetInlineStart: calc(lineWidth).mul(-1).equal(),
                            borderInlineStart: tableBorder
                        }
                    }
                },
                // Empty placeholder
                [`&${componentCls}-virtual`]: {
                    [`${componentCls}-placeholder ${componentCls}-cell`]: {
                        borderInlineEnd: tableBorder,
                        borderBottom: tableBorder
                    }
                }
            }
        }
    };
};
var $52f7f243bef004ef$export$2e2bcd8739ae039 = $52f7f243bef004ef$var$genVirtualStyle;


const $038d8430fed7e536$var$genTableStyle = (token)=>{
    const { componentCls: componentCls, fontWeightStrong: fontWeightStrong, tablePaddingVertical: tablePaddingVertical, tablePaddingHorizontal: tablePaddingHorizontal, tableExpandColumnWidth: tableExpandColumnWidth, lineWidth: lineWidth, lineType: lineType, tableBorderColor: tableBorderColor, tableFontSize: tableFontSize, tableBg: tableBg, tableRadius: tableRadius, tableHeaderTextColor: tableHeaderTextColor, motionDurationMid: motionDurationMid, tableHeaderBg: tableHeaderBg, tableHeaderCellSplitColor: tableHeaderCellSplitColor, tableFooterTextColor: tableFooterTextColor, tableFooterBg: tableFooterBg, calc: calc } = token;
    const tableBorder = `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(lineWidth)} ${lineType} ${tableBorderColor}`;
    return {
        [`${componentCls}-wrapper`]: {
            clear: 'both',
            maxWidth: '100%',
            // fix https://github.com/ant-design/ant-design/issues/46177
            ['--rc-virtual-list-scrollbar-bg']: token.tableScrollBg,
            ...(0, $2f353af2b0f7600b$export$8c467e8859fdef13)(),
            [componentCls]: {
                ...(0, $2f353af2b0f7600b$export$23997c3e44cc1c59)(token),
                fontSize: tableFontSize,
                background: tableBg,
                borderRadius: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(tableRadius)} ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(tableRadius)} 0 0`,
                // https://github.com/ant-design/ant-design/issues/47486
                scrollbarColor: `${token.tableScrollThumbBg} ${token.tableScrollBg}`
            },
            // https://github.com/ant-design/ant-design/issues/17611
            table: {
                width: '100%',
                textAlign: 'start',
                borderRadius: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(tableRadius)} ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(tableRadius)} 0 0`,
                borderCollapse: 'separate',
                borderSpacing: 0
            },
            // ============================= Cell ==============================
            [`
          ${componentCls}-cell,
          ${componentCls}-thead > tr > th,
          ${componentCls}-tbody > tr > th,
          ${componentCls}-tbody > tr > td,
          tfoot > tr > th,
          tfoot > tr > td
        `]: {
                position: 'relative',
                padding: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(tablePaddingVertical)} ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(tablePaddingHorizontal)}`,
                overflowWrap: 'break-word'
            },
            // ============================ Title =============================
            [`${componentCls}-title`]: {
                padding: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(tablePaddingVertical)} ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(tablePaddingHorizontal)}`
            },
            // ============================ Header ============================
            [`${componentCls}-thead`]: {
                [`
          > tr > th,
          > tr > td
        `]: {
                    position: 'relative',
                    color: tableHeaderTextColor,
                    fontWeight: fontWeightStrong,
                    textAlign: 'start',
                    background: tableHeaderBg,
                    borderBottom: tableBorder,
                    transition: `background ${motionDurationMid} ease`,
                    "&[colspan]:not([colspan='1'])": {
                        textAlign: 'center'
                    },
                    [`&:not(:last-child):not(${componentCls}-selection-column):not(${componentCls}-row-expand-icon-cell):not([colspan])::before`]: {
                        position: 'absolute',
                        top: '50%',
                        insetInlineEnd: 0,
                        width: 1,
                        height: '1.6em',
                        backgroundColor: tableHeaderCellSplitColor,
                        transform: 'translateY(-50%)',
                        transition: `background-color ${motionDurationMid}`,
                        content: '""'
                    }
                },
                '> tr:not(:last-child) > th[colspan]': {
                    borderBottom: 0
                }
            },
            // ============================ Body ============================
            [`${componentCls}-tbody`]: {
                '> tr': {
                    '> th, > td': {
                        transition: `background ${motionDurationMid}, border-color ${motionDurationMid}`,
                        borderBottom: tableBorder,
                        // ========================= Nest Table ===========================
                        [`
              > ${componentCls}-wrapper:only-child,
              > ${componentCls}-expanded-row-fixed > ${componentCls}-wrapper:only-child
            `]: {
                            [componentCls]: {
                                marginBlock: (0, $763a5b4b58d0a3ff$export$523c0b569236b342)(calc(tablePaddingVertical).mul(-1).equal()),
                                marginInline: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(calc(tableExpandColumnWidth).sub(tablePaddingHorizontal).equal())}
                ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(calc(tablePaddingHorizontal).mul(-1).equal())}`,
                                [`${componentCls}-tbody > tr:last-child > td`]: {
                                    borderBottomWidth: 0,
                                    '&:first-child, &:last-child': {
                                        borderRadius: 0
                                    }
                                }
                            }
                        }
                    },
                    '> th': {
                        position: 'relative',
                        color: tableHeaderTextColor,
                        fontWeight: fontWeightStrong,
                        textAlign: 'start',
                        background: tableHeaderBg,
                        borderBottom: tableBorder,
                        transition: `background ${motionDurationMid} ease`
                    },
                    // measure cell styles
                    [`& > ${componentCls}-measure-cell`]: {
                        paddingBlock: `0 !important`,
                        borderBlock: `0 !important`,
                        [`${componentCls}-measure-cell-content`]: {
                            height: 0,
                            overflow: 'hidden',
                            pointerEvents: 'none'
                        }
                    }
                }
            },
            // ============================ Footer ============================
            [`${componentCls}-footer`]: {
                padding: `${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(tablePaddingVertical)} ${(0, $763a5b4b58d0a3ff$export$523c0b569236b342)(tablePaddingHorizontal)}`,
                color: tableFooterTextColor,
                background: tableFooterBg
            }
        }
    };
};
const $038d8430fed7e536$export$9ca1be8807fe0675 = (token)=>{
    const { colorFillAlter: colorFillAlter, colorBgContainer: colorBgContainer, colorTextHeading: colorTextHeading, colorFillSecondary: colorFillSecondary, colorFillContent: colorFillContent, controlItemBgActive: controlItemBgActive, controlItemBgActiveHover: controlItemBgActiveHover, padding: padding, paddingSM: paddingSM, paddingXS: paddingXS, colorBorderSecondary: colorBorderSecondary, borderRadiusLG: borderRadiusLG, controlHeight: controlHeight, colorTextPlaceholder: colorTextPlaceholder, fontSize: fontSize, fontSizeSM: fontSizeSM, lineHeight: lineHeight, lineWidth: lineWidth, colorIcon: colorIcon, colorIconHover: colorIconHover, opacityLoading: opacityLoading, controlInteractiveSize: controlInteractiveSize } = token;
    const colorFillSecondarySolid = new (0, $cbc85b6187a98a9b$export$2c4f38d6c0ecc25a)(colorFillSecondary).onBackground(colorBgContainer).toHexString();
    const colorFillContentSolid = new (0, $cbc85b6187a98a9b$export$2c4f38d6c0ecc25a)(colorFillContent).onBackground(colorBgContainer).toHexString();
    const colorFillAlterSolid = new (0, $cbc85b6187a98a9b$export$2c4f38d6c0ecc25a)(colorFillAlter).onBackground(colorBgContainer).toHexString();
    const baseColorAction = new (0, $cbc85b6187a98a9b$export$2c4f38d6c0ecc25a)(colorIcon);
    const baseColorActionHover = new (0, $cbc85b6187a98a9b$export$2c4f38d6c0ecc25a)(colorIconHover);
    const expandIconHalfInner = controlInteractiveSize / 2 - lineWidth;
    const expandIconSize = expandIconHalfInner * 2 + lineWidth * 3;
    return {
        headerBg: colorFillAlterSolid,
        headerColor: colorTextHeading,
        headerSortActiveBg: colorFillSecondarySolid,
        headerSortHoverBg: colorFillContentSolid,
        bodySortBg: colorFillAlterSolid,
        rowHoverBg: colorFillAlterSolid,
        rowSelectedBg: controlItemBgActive,
        rowSelectedHoverBg: controlItemBgActiveHover,
        rowExpandedBg: colorFillAlter,
        cellPaddingBlock: padding,
        cellPaddingInline: padding,
        cellPaddingBlockMD: paddingSM,
        cellPaddingInlineMD: paddingXS,
        cellPaddingBlockSM: paddingXS,
        cellPaddingInlineSM: paddingXS,
        borderColor: colorBorderSecondary,
        headerBorderRadius: borderRadiusLG,
        footerBg: colorFillAlterSolid,
        footerColor: colorTextHeading,
        cellFontSize: fontSize,
        cellFontSizeMD: fontSize,
        cellFontSizeSM: fontSize,
        headerSplitColor: colorBorderSecondary,
        fixedHeaderSortActiveBg: colorFillSecondarySolid,
        headerFilterHoverBg: colorFillContent,
        filterDropdownMenuBg: colorBgContainer,
        filterDropdownBg: colorBgContainer,
        expandIconBg: colorBgContainer,
        selectionColumnWidth: controlHeight,
        stickyScrollBarBg: colorTextPlaceholder,
        stickyScrollBarBorderRadius: 100,
        expandIconMarginTop: (fontSize * lineHeight - lineWidth * 3) / 2 - Math.ceil((fontSizeSM * 1.4 - lineWidth * 3) / 2),
        headerIconColor: baseColorAction.clone().setA(baseColorAction.a * opacityLoading).toRgbString(),
        headerIconHoverColor: baseColorActionHover.clone().setA(baseColorActionHover.a * opacityLoading).toRgbString(),
        expandIconHalfInner: expandIconHalfInner,
        expandIconSize: expandIconSize,
        expandIconScale: controlInteractiveSize / expandIconSize
    };
};
const $038d8430fed7e536$var$zIndexTableFixed = 2;
var // ============================== Export ==============================
$038d8430fed7e536$export$2e2bcd8739ae039 = (0, $d4a2dc313c4d90a4$export$51ec95de45185b42)('Table', (token)=>{
    const { colorTextHeading: colorTextHeading, colorSplit: colorSplit, colorBgContainer: colorBgContainer, controlInteractiveSize: checkboxSize, headerBg: headerBg, headerColor: headerColor, headerSortActiveBg: headerSortActiveBg, headerSortHoverBg: headerSortHoverBg, bodySortBg: bodySortBg, rowHoverBg: rowHoverBg, rowSelectedBg: rowSelectedBg, rowSelectedHoverBg: rowSelectedHoverBg, rowExpandedBg: rowExpandedBg, cellPaddingBlock: cellPaddingBlock, cellPaddingInline: cellPaddingInline, cellPaddingBlockMD: cellPaddingBlockMD, cellPaddingInlineMD: cellPaddingInlineMD, cellPaddingBlockSM: cellPaddingBlockSM, cellPaddingInlineSM: cellPaddingInlineSM, borderColor: borderColor, footerBg: footerBg, footerColor: footerColor, headerBorderRadius: headerBorderRadius, cellFontSize: cellFontSize, cellFontSizeMD: cellFontSizeMD, cellFontSizeSM: cellFontSizeSM, headerSplitColor: headerSplitColor, fixedHeaderSortActiveBg: fixedHeaderSortActiveBg, headerFilterHoverBg: headerFilterHoverBg, filterDropdownBg: filterDropdownBg, expandIconBg: expandIconBg, selectionColumnWidth: selectionColumnWidth, stickyScrollBarBg: stickyScrollBarBg, calc: calc } = token;
    const tableToken = (0, $90c11ca6cb263fd9$export$4950aa0f605343fb)(token, {
        tableFontSize: cellFontSize,
        tableBg: colorBgContainer,
        tableRadius: headerBorderRadius,
        tablePaddingVertical: cellPaddingBlock,
        tablePaddingHorizontal: cellPaddingInline,
        tablePaddingVerticalMiddle: cellPaddingBlockMD,
        tablePaddingHorizontalMiddle: cellPaddingInlineMD,
        tablePaddingVerticalSmall: cellPaddingBlockSM,
        tablePaddingHorizontalSmall: cellPaddingInlineSM,
        tableBorderColor: borderColor,
        tableHeaderTextColor: headerColor,
        tableHeaderBg: headerBg,
        tableFooterTextColor: footerColor,
        tableFooterBg: footerBg,
        tableHeaderCellSplitColor: headerSplitColor,
        tableHeaderSortBg: headerSortActiveBg,
        tableHeaderSortHoverBg: headerSortHoverBg,
        tableBodySortBg: bodySortBg,
        tableFixedHeaderSortActiveBg: fixedHeaderSortActiveBg,
        tableHeaderFilterActiveBg: headerFilterHoverBg,
        tableFilterDropdownBg: filterDropdownBg,
        tableRowHoverBg: rowHoverBg,
        tableSelectedRowBg: rowSelectedBg,
        tableSelectedRowHoverBg: rowSelectedHoverBg,
        zIndexTableFixed: $038d8430fed7e536$var$zIndexTableFixed,
        tableFontSizeMiddle: cellFontSizeMD,
        tableFontSizeSmall: cellFontSizeSM,
        tableSelectionColumnWidth: selectionColumnWidth,
        tableExpandIconBg: expandIconBg,
        tableExpandColumnWidth: calc(checkboxSize).add(calc(token.padding).mul(2)).equal(),
        tableExpandedRowBg: rowExpandedBg,
        // Dropdown
        tableFilterDropdownWidth: 120,
        tableFilterDropdownHeight: 264,
        tableFilterDropdownSearchWidth: 140,
        // Virtual Scroll Bar
        tableScrollThumbSize: 8,
        // Mac scroll bar size
        tableScrollThumbBg: stickyScrollBarBg,
        tableScrollThumbBgHover: colorTextHeading,
        tableScrollBg: colorSplit
    });
    return [
        $038d8430fed7e536$var$genTableStyle(tableToken),
        (0, $489527eec6ab58d0$export$2e2bcd8739ae039)(tableToken),
        (0, $483f053d426ad109$export$2e2bcd8739ae039)(tableToken),
        (0, $ac137d4b95a5cf86$export$2e2bcd8739ae039)(tableToken),
        (0, $e63a3b6d6e25e763$export$2e2bcd8739ae039)(tableToken),
        (0, $a098f63b90ab548f$export$2e2bcd8739ae039)(tableToken),
        (0, $57ba617433a81a8f$export$2e2bcd8739ae039)(tableToken),
        (0, $f2dccf46e40183fe$export$2e2bcd8739ae039)(tableToken),
        (0, $483f053d426ad109$export$2e2bcd8739ae039)(tableToken),
        (0, $f1041df7cabca587$export$2e2bcd8739ae039)(tableToken),
        (0, $327d803edcec2f41$export$2e2bcd8739ae039)(tableToken),
        (0, $79c33d63173da9aa$export$2e2bcd8739ae039)(tableToken),
        (0, $a3ba101aba55e3fe$export$2e2bcd8739ae039)(tableToken),
        (0, $a50cf50759bb1166$export$2e2bcd8739ae039)(tableToken),
        (0, $14399733878180cf$export$2e2bcd8739ae039)(tableToken),
        (0, $c134db5bf24aa3e8$export$2e2bcd8739ae039)(tableToken),
        (0, $52f7f243bef004ef$export$2e2bcd8739ae039)(tableToken)
    ];
}, $038d8430fed7e536$export$9ca1be8807fe0675, {
    unitless: {
        expandIconScale: true
    }
});


"use client";
const $76b9af3c2d5c3cff$var$EMPTY_LIST = [];
const $76b9af3c2d5c3cff$var$InternalTable = (props, ref)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, style: style, classNames: classNames, styles: styles, size: customizeSize, bordered: bordered, dropdownPrefixCls: customizeDropdownPrefixCls, dataSource: dataSource, pagination: pagination, rowSelection: rowSelection, rowKey: customizeRowKey, rowClassName: rowClassName, columns: columns, children: children, childrenColumnName: legacyChildrenColumnName, onChange: onChange, getPopupContainer: getPopupContainer, loading: loading, expandIcon: expandIcon, expandable: expandable, expandedRowRender: expandedRowRender, expandIconColumnIndex: expandIconColumnIndex, indentSize: indentSize, scroll: scroll, sortDirections: sortDirections, locale: locale, showSorterTooltip: showSorterTooltip = {
        target: 'full-header'
    }, virtual: virtual } = props;
    const warning = (0, $d41680c8243eac18$export$cf977aa92c751e61)('Table');
    const baseColumns = $32rMB.useMemo(()=>columns || (0, $8b582fb443cfdf83$export$d87a97eba44e0f9c)(children), [
        columns,
        children
    ]);
    const needResponsive = $32rMB.useMemo(()=>baseColumns.some((col)=>col.responsive), [
        baseColumns
    ]);
    const screens = (0, $c5abeec2eaafde8a$export$2e2bcd8739ae039)(needResponsive);
    const mergedColumns = $32rMB.useMemo(()=>{
        const matched = new Set(Object.keys(screens).filter((m)=>screens[m]));
        return baseColumns.filter((c)=>!c.responsive || c.responsive.some((r)=>matched.has(r)));
    }, [
        baseColumns,
        screens
    ]);
    const tableProps = (0, $f4cf9c2e27c0ac8d$export$2e2bcd8739ae039)(props, [
        'className',
        'style',
        'columns'
    ]);
    const { locale: contextLocale = (0, $e154e9cb01eacc19$export$2e2bcd8739ae039), table: table } = $32rMB.useContext((0, $dd01e2f5a4b8605d$export$a92f85ab3e9ad68b));
    const { getPrefixCls: getPrefixCls, direction: direction, renderEmpty: renderEmpty, getPopupContainer: getContextPopupContainer, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $dd01e2f5a4b8605d$export$46f4bd6436a25a31)('table');
    const mergedSize = (0, $324b30eda6ea1cd7$export$2e2bcd8739ae039)(customizeSize);
    // =========== Merged Props for Semantic ==========
    const mergedProps = {
        ...props,
        size: mergedSize,
        bordered: bordered
    };
    const [mergedClassNames, mergedStyles] = (0, $4dcf69d8c3d6df5c$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    }, {
        pagination: {
            _default: 'root'
        },
        header: {
            _default: 'wrapper'
        },
        body: {
            _default: 'wrapper'
        }
    });
    const tableLocale = {
        ...contextLocale.Table,
        ...locale
    };
    const [globalLocale] = (0, $c176ccd8a9cbd556$export$2e2bcd8739ae039)('global', (0, $e154e9cb01eacc19$export$2e2bcd8739ae039).global);
    const rawData = dataSource || $76b9af3c2d5c3cff$var$EMPTY_LIST;
    const prefixCls = getPrefixCls('table', customizePrefixCls);
    const dropdownPrefixCls = getPrefixCls('dropdown', customizeDropdownPrefixCls);
    const [, token] = (0, $9481722d146bd166$export$2e2bcd8739ae039)();
    const rootCls = (0, $54b1aecddbbbed4f$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $038d8430fed7e536$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const mergedExpandable = {
        childrenColumnName: legacyChildrenColumnName,
        expandIconColumnIndex: expandIconColumnIndex,
        ...expandable,
        expandIcon: expandable?.expandIcon ?? table?.expandable?.expandIcon
    };
    const { childrenColumnName: childrenColumnName = 'children' } = mergedExpandable;
    const expandType = $32rMB.useMemo(()=>{
        if (rawData.some((item)=>item?.[childrenColumnName])) return 'nest';
        if (expandedRowRender || expandable?.expandedRowRender) return 'row';
        return null;
    }, [
        childrenColumnName,
        rawData
    ]);
    const internalRefs = {
        body: $32rMB.useRef(null)
    };
    // ============================ Width =============================
    const getContainerWidth = (0, $bd71685f1bb86138$export$2e2bcd8739ae039)(prefixCls);
    // ============================= Refs =============================
    const rootRef = $32rMB.useRef(null);
    const tblRef = $32rMB.useRef(null);
    (0, $83b69e786fd10eae$export$8edbe0145ad77a36)(ref, ()=>({
            ...tblRef.current,
            nativeElement: rootRef.current
        }));
    // ============================ RowKey ============================
    const rowKey = customizeRowKey || table?.rowKey || 'key';
    const getRowKey = $32rMB.useMemo(()=>{
        if (typeof rowKey === 'function') return rowKey;
        return (record)=>record?.[rowKey];
    }, [
        rowKey
    ]);
    const [getRecordByKey] = (0, $4021ef1459e32498$export$2e2bcd8739ae039)(rawData, childrenColumnName, getRowKey);
    // ============================ Events =============================
    const changeEventInfo = {};
    const triggerOnChange = (info, action, reset = false)=>{
        const changeInfo = {
            ...changeEventInfo,
            ...info
        };
        if (reset) {
            changeEventInfo.resetPagination?.();
            // Reset event param
            if (changeInfo.pagination?.current) changeInfo.pagination.current = 1;
            // Trigger pagination events
            if (pagination) pagination.onChange?.(1, changeInfo.pagination?.pageSize);
        }
        if (scroll && scroll.scrollToFirstRowOnChange !== false && internalRefs.body.current) (0, $5664accf2c388193$export$2e2bcd8739ae039)(0, {
            getContainer: ()=>internalRefs.body.current
        });
        onChange?.(changeInfo.pagination, changeInfo.filters, changeInfo.sorter, {
            currentDataSource: (0, $277d684919ff2714$export$37643bb40f4c1c56)((0, $54e1725fbe4607ee$export$594b2c8da4a70ee)(rawData, changeInfo.sorterStates, childrenColumnName), changeInfo.filterStates, childrenColumnName),
            action: action
        });
    };
    /**
   * Controlled state in `columns` is not a good idea that makes too many code (1000+ line?) to read
   * state out and then put it back to title render. Move these code into `hooks` but still too
   * complex. We should provides Table props like `sorter` & `filter` to handle control in next big
   * version.
   */ // ============================ Sorter =============================
    const onSorterChange = (sorter, sorterStates)=>{
        triggerOnChange({
            sorter: sorter,
            sorterStates: sorterStates
        }, 'sort', false);
    };
    const [transformSorterColumns, sortStates, sorterTitleProps, getSorters] = (0, $54e1725fbe4607ee$export$2e2bcd8739ae039)({
        prefixCls: prefixCls,
        mergedColumns: mergedColumns,
        onSorterChange: onSorterChange,
        sortDirections: sortDirections || [
            'ascend',
            'descend'
        ],
        tableLocale: tableLocale,
        showSorterTooltip: showSorterTooltip,
        globalLocale: globalLocale
    });
    const sortedData = $32rMB.useMemo(()=>(0, $54e1725fbe4607ee$export$594b2c8da4a70ee)(rawData, sortStates, childrenColumnName), [
        childrenColumnName,
        rawData,
        sortStates
    ]);
    changeEventInfo.sorter = getSorters();
    changeEventInfo.sorterStates = sortStates;
    // ============================ Filter ============================
    const onFilterChange = (filters, filterStates)=>{
        triggerOnChange({
            filters: filters,
            filterStates: filterStates
        }, 'filter', true);
    };
    const [transformFilterColumns, filterStates, filters] = (0, $277d684919ff2714$export$2e2bcd8739ae039)({
        prefixCls: prefixCls,
        locale: tableLocale,
        dropdownPrefixCls: dropdownPrefixCls,
        mergedColumns: mergedColumns,
        onFilterChange: onFilterChange,
        getPopupContainer: getPopupContainer || getContextPopupContainer,
        rootClassName: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(rootClassName, rootCls)
    });
    const mergedData = (0, $277d684919ff2714$export$37643bb40f4c1c56)(sortedData, filterStates, childrenColumnName);
    changeEventInfo.filters = filters;
    changeEventInfo.filterStates = filterStates;
    // ============================ Column ============================
    const columnTitleProps = $32rMB.useMemo(()=>{
        const mergedFilters = {};
        Object.keys(filters).forEach((filterKey)=>{
            if (filters[filterKey] !== null) mergedFilters[filterKey] = filters[filterKey];
        });
        return {
            ...sorterTitleProps,
            filters: mergedFilters
        };
    }, [
        sorterTitleProps,
        filters
    ]);
    const [transformTitleColumns] = (0, $da535fbd1a514794$export$2e2bcd8739ae039)(columnTitleProps);
    // ========================== Pagination ==========================
    const onPaginationChange = (current, pageSize)=>{
        triggerOnChange({
            pagination: {
                ...changeEventInfo.pagination,
                current: current,
                pageSize: pageSize
            }
        }, 'paginate');
    };
    const [mergedPagination, resetPagination] = (0, $8a644da720268443$export$2e2bcd8739ae039)(mergedData.length, onPaginationChange, pagination);
    changeEventInfo.pagination = pagination === false ? {} : (0, $8a644da720268443$export$27eceeed7bf0f4c2)(mergedPagination, pagination);
    changeEventInfo.resetPagination = resetPagination;
    // ============================= Data =============================
    const pageData = $32rMB.useMemo(()=>{
        if (pagination === false || !mergedPagination.pageSize) return mergedData;
        const { current: current = 1, total: total, pageSize: pageSize = (0, $8a644da720268443$export$5716e8bcb003888d) } = mergedPagination;
        // Dynamic table data
        if (mergedData.length < total) {
            if (mergedData.length > pageSize) return mergedData.slice((current - 1) * pageSize, current * pageSize);
            return mergedData;
        }
        return mergedData.slice((current - 1) * pageSize, current * pageSize);
    }, [
        !!pagination,
        mergedData,
        mergedPagination?.current,
        mergedPagination?.pageSize,
        mergedPagination?.total
    ]);
    // ========================== Selections ==========================
    const [transformSelectionColumns, selectedKeySet] = (0, $771b71189b7d291d$export$2e2bcd8739ae039)({
        prefixCls: prefixCls,
        data: mergedData,
        pageData: pageData,
        getRowKey: getRowKey,
        getRecordByKey: getRecordByKey,
        expandType: expandType,
        childrenColumnName: childrenColumnName,
        locale: tableLocale,
        getPopupContainer: getPopupContainer || getContextPopupContainer
    }, rowSelection);
    const internalRowClassName = (record, index, indent)=>{
        const resolvedRowClassName = typeof rowClassName === 'function' ? rowClassName(record, index, indent) : rowClassName;
        return (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)({
            [`${prefixCls}-row-selected`]: selectedKeySet.has(getRowKey(record, index))
        }, resolvedRowClassName);
    };
    // ========================== Expandable ==========================
    // Pass origin render status into `@rc-component/table`, this can be removed when refactor with `@rc-component/table`
    mergedExpandable.__PARENT_RENDER_ICON__ = mergedExpandable.expandIcon;
    // Customize expandable icon
    mergedExpandable.expandIcon = mergedExpandable.expandIcon || expandIcon || (0, $c5c4c34b0bb1616c$export$2e2bcd8739ae039)(tableLocale);
    // Adjust expand icon index, no overwrite expandIconColumnIndex if set.
    if (expandType === 'nest' && mergedExpandable.expandIconColumnIndex === undefined) mergedExpandable.expandIconColumnIndex = rowSelection ? 1 : 0;
    else if (mergedExpandable.expandIconColumnIndex > 0 && rowSelection) mergedExpandable.expandIconColumnIndex -= 1;
    // Indent size
    if (typeof mergedExpandable.indentSize !== 'number') mergedExpandable.indentSize = typeof indentSize === 'number' ? indentSize : 15;
    // ============================ Render ============================
    const transformColumns = $32rMB.useCallback((innerColumns)=>transformTitleColumns(transformSelectionColumns(transformFilterColumns(transformSorterColumns(innerColumns)))), [
        transformSorterColumns,
        transformFilterColumns,
        transformSelectionColumns
    ]);
    let topPaginationNode;
    let bottomPaginationNode;
    if (pagination !== false && mergedPagination?.total) {
        let paginationSize;
        if (mergedPagination.size) paginationSize = mergedPagination.size;
        else paginationSize = mergedSize === 'small' || mergedSize === 'middle' ? 'small' : undefined;
        const renderPagination = (placement = 'end')=>/*#__PURE__*/ $hO8yS.createElement((0, $6375cf69372b034f$export$2e2bcd8739ae039), {
                ...mergedPagination,
                classNames: mergedClassNames.pagination,
                styles: mergedStyles.pagination,
                className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-pagination ${prefixCls}-pagination-${placement}`, mergedPagination.className),
                size: paginationSize
            });
        const { placement: placement, position: position } = mergedPagination;
        const mergedPlacement = placement ?? position;
        const normalizePlacement = (pos)=>{
            const lowerPos = pos.toLowerCase();
            if (lowerPos.includes('center')) return 'center';
            return lowerPos.includes('left') || lowerPos.includes('start') ? 'start' : 'end';
        };
        if (Array.isArray(mergedPlacement)) {
            const [topPos, bottomPos] = [
                'top',
                'bottom'
            ].map((dir)=>mergedPlacement.find((p)=>p.includes(dir)));
            const isDisable = mergedPlacement.every((p)=>`${p}` === 'none');
            if (!topPos && !bottomPos && !isDisable) bottomPaginationNode = renderPagination();
            if (topPos) topPaginationNode = renderPagination(normalizePlacement(topPos));
            if (bottomPos) bottomPaginationNode = renderPagination(normalizePlacement(bottomPos));
        } else bottomPaginationNode = renderPagination();
    }
    // >>>>>>>>> Spinning
    const spinProps = $32rMB.useMemo(()=>{
        if (typeof loading === 'boolean') return {
            spinning: loading
        };
        else if (typeof loading === 'object' && loading !== null) return {
            spinning: true,
            ...loading
        };
        else return undefined;
    }, [
        loading
    ]);
    const wrappercls = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(cssVarCls, rootCls, `${prefixCls}-wrapper`, contextClassName, {
        [`${prefixCls}-wrapper-rtl`]: direction === 'rtl'
    }, className, rootClassName, mergedClassNames.root, hashId);
    const mergedStyle = {
        ...mergedStyles.root,
        ...contextStyle,
        ...style
    };
    // ========== empty ==========
    const mergedEmptyNode = $32rMB.useMemo(()=>{
        // When dataSource is null/undefined (detected by reference equality with EMPTY_LIST),
        // and the table is in a loading state, we only show the loading spinner without the empty placeholder.
        // For empty arrays (datasource={[]}), both loading and empty states would normally be shown.
        // discussion https://github.com/ant-design/ant-design/issues/54601#issuecomment-3158091383
        if (spinProps?.spinning && rawData === $76b9af3c2d5c3cff$var$EMPTY_LIST) return null;
        if (typeof locale?.emptyText !== 'undefined') return locale.emptyText;
        return renderEmpty?.('Table') || /*#__PURE__*/ $hO8yS.createElement((0, $6650c2c5bdbe4a9f$export$2e2bcd8739ae039), {
            componentName: "Table"
        });
    }, [
        spinProps?.spinning,
        rawData,
        locale?.emptyText,
        renderEmpty
    ]);
    // ========================== Render ==========================
    const TableComponent = virtual ? (0, $62e5d5292cece3ed$export$2e2bcd8739ae039) : (0, $58112a7c4e4e00db$export$2e2bcd8739ae039);
    // >>> Virtual Table props. We set height here since it will affect height collection
    const virtualProps = {};
    const listItemHeight = $32rMB.useMemo(()=>{
        const { fontSize: fontSize, lineHeight: lineHeight, lineWidth: lineWidth, padding: padding, paddingXS: paddingXS, paddingSM: paddingSM } = token;
        const fontHeight = Math.floor(fontSize * lineHeight);
        switch(mergedSize){
            case 'middle':
                return paddingSM * 2 + fontHeight + lineWidth;
            case 'small':
                return paddingXS * 2 + fontHeight + lineWidth;
            default:
                return padding * 2 + fontHeight + lineWidth;
        }
    }, [
        token,
        mergedSize
    ]);
    if (virtual) virtualProps.listItemHeight = listItemHeight;
    return /*#__PURE__*/ $hO8yS.createElement("div", {
        ref: rootRef,
        className: wrappercls,
        style: mergedStyle
    }, /*#__PURE__*/ $hO8yS.createElement((0, $e72f20bad19c9555$export$2e2bcd8739ae039), {
        spinning: false,
        ...spinProps
    }, topPaginationNode, /*#__PURE__*/ $hO8yS.createElement(TableComponent, {
        ...virtualProps,
        ...tableProps,
        classNames: mergedClassNames,
        styles: mergedStyles,
        ref: tblRef,
        columns: mergedColumns,
        direction: direction,
        expandable: mergedExpandable,
        prefixCls: prefixCls,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)({
            [`${prefixCls}-middle`]: mergedSize === 'middle',
            [`${prefixCls}-small`]: mergedSize === 'small',
            [`${prefixCls}-bordered`]: bordered,
            [`${prefixCls}-empty`]: rawData.length === 0
        }, cssVarCls, rootCls, hashId),
        data: pageData,
        rowKey: getRowKey,
        rowClassName: internalRowClassName,
        emptyText: mergedEmptyNode,
        // Internal
        internalHooks: (0, $a942291e76081e0b$export$91b75cf262680225),
        internalRefs: internalRefs,
        transformColumns: transformColumns,
        getContainerWidth: getContainerWidth,
        measureRowRender: (measureRow)=>/*#__PURE__*/ $hO8yS.createElement((0, $6ff80b51bd11b92e$export$2e2bcd8739ae039), {
                getPopupContainer: (node)=>node
            }, measureRow)
    }), bottomPaginationNode));
};
var $76b9af3c2d5c3cff$export$2e2bcd8739ae039 = /*#__PURE__*/ $N3oW3.forwardRef($76b9af3c2d5c3cff$var$InternalTable);


"use client";
const $9f709ae404b84a17$var$Table = (props, ref)=>{
    const renderTimesRef = $32rMB.useRef(0);
    renderTimesRef.current += 1;
    return /*#__PURE__*/ $hO8yS.createElement((0, $76b9af3c2d5c3cff$export$2e2bcd8739ae039), {
        ...props,
        ref: ref,
        _renderTimes: renderTimesRef.current
    });
};
const $9f709ae404b84a17$var$ForwardTable = /*#__PURE__*/ $N3oW3.forwardRef($9f709ae404b84a17$var$Table);
$9f709ae404b84a17$var$ForwardTable.SELECTION_COLUMN = (0, $771b71189b7d291d$export$ed10248435b8f218);
$9f709ae404b84a17$var$ForwardTable.EXPAND_COLUMN = (0, $a942291e76081e0b$export$e1053575ddfcb301);
$9f709ae404b84a17$var$ForwardTable.SELECTION_ALL = (0, $771b71189b7d291d$export$14159cd9e2a500c8);
$9f709ae404b84a17$var$ForwardTable.SELECTION_INVERT = (0, $771b71189b7d291d$export$625c4f68eaaf8cfd);
$9f709ae404b84a17$var$ForwardTable.SELECTION_NONE = (0, $771b71189b7d291d$export$c1a725540f5a63bd);
$9f709ae404b84a17$var$ForwardTable.Column = (0, $574ffd90a6412d20$export$2e2bcd8739ae039);
$9f709ae404b84a17$var$ForwardTable.ColumnGroup = (0, $b58f2657f1538597$export$2e2bcd8739ae039);
$9f709ae404b84a17$var$ForwardTable.Summary = (0, $8cbe79460b8099b9$export$d605f3af09eef683);
var $9f709ae404b84a17$export$2e2bcd8739ae039 = $9f709ae404b84a17$var$ForwardTable;


"use client";
var $19f315999f2129ce$export$2e2bcd8739ae039 = (0, $9f709ae404b84a17$export$2e2bcd8739ae039);



var $d5I5D = parcelRequire("d5I5D");

var $1cea8647883c4012$exports = {};
var $95518c9e748840bb$export$71511d61b312f219;
"use strict";
var $9ac8e64cff09d58e$export$71511d61b312f219;
"use strict";
function $9ac8e64cff09d58e$var$_get_prototype_of(o) {
    $9ac8e64cff09d58e$export$71511d61b312f219 = $9ac8e64cff09d58e$var$_get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $9ac8e64cff09d58e$var$_get_prototype_of(o);
}
$9ac8e64cff09d58e$export$71511d61b312f219 = $9ac8e64cff09d58e$var$_get_prototype_of;


var $1f26b1989c741e87$export$71511d61b312f219;
"use strict";
function $1f26b1989c741e87$var$_is_native_reflect_construct() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($1f26b1989c741e87$export$71511d61b312f219 = $1f26b1989c741e87$var$_is_native_reflect_construct = function() {
        return !!result;
    })();
}
$1f26b1989c741e87$export$71511d61b312f219 = $1f26b1989c741e87$var$_is_native_reflect_construct;


var $0782f2494bcab272$export$71511d61b312f219;
"use strict";
var $548135c5314beecb$export$71511d61b312f219;
"use strict";
function $548135c5314beecb$var$_assert_this_initialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
$548135c5314beecb$export$71511d61b312f219 = $548135c5314beecb$var$_assert_this_initialized;


var $35f6c23f56aaf458$export$71511d61b312f219;
"use strict";
function $35f6c23f56aaf458$var$_type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
$35f6c23f56aaf458$export$71511d61b312f219 = $35f6c23f56aaf458$var$_type_of;


function $0782f2494bcab272$var$_possible_constructor_return(self, call) {
    if (call && ($35f6c23f56aaf458$export$71511d61b312f219(call) === "object" || typeof call === "function")) return call;
    return $548135c5314beecb$export$71511d61b312f219(self);
}
$0782f2494bcab272$export$71511d61b312f219 = $0782f2494bcab272$var$_possible_constructor_return;


function $95518c9e748840bb$var$_call_super(_this, derived, args) {
    // Super
    derived = $9ac8e64cff09d58e$export$71511d61b312f219(derived);
    return $0782f2494bcab272$export$71511d61b312f219(_this, $1f26b1989c741e87$export$71511d61b312f219() ? Reflect.construct(derived, args || [], $9ac8e64cff09d58e$export$71511d61b312f219(_this).constructor) : derived.apply(_this, args));
}
$95518c9e748840bb$export$71511d61b312f219 = $95518c9e748840bb$var$_call_super;


var $2b3af368dbb30b38$export$71511d61b312f219;
"use strict";
function $2b3af368dbb30b38$var$_class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
$2b3af368dbb30b38$export$71511d61b312f219 = $2b3af368dbb30b38$var$_class_call_check;


var $53cdca766716469e$export$71511d61b312f219;
"use strict";
function $53cdca766716469e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $53cdca766716469e$var$_create_class(Constructor, protoProps, staticProps) {
    if (protoProps) $53cdca766716469e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $53cdca766716469e$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
$53cdca766716469e$export$71511d61b312f219 = $53cdca766716469e$var$_create_class;


var $0b0867a6ee357054$export$71511d61b312f219;
"use strict";
var $e5c30bc2aeee69ad$export$71511d61b312f219;
"use strict";

function $e5c30bc2aeee69ad$var$_super_prop_base(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = $9ac8e64cff09d58e$export$71511d61b312f219(object);
        if (object === null) break;
    }
    return object;
}
$e5c30bc2aeee69ad$export$71511d61b312f219 = $e5c30bc2aeee69ad$var$_super_prop_base;


function $0b0867a6ee357054$var$_get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $0b0867a6ee357054$export$71511d61b312f219 = $0b0867a6ee357054$var$_get = Reflect.get;
    else $0b0867a6ee357054$export$71511d61b312f219 = $0b0867a6ee357054$var$_get = function get(target, property, receiver) {
        var base = $e5c30bc2aeee69ad$export$71511d61b312f219(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $0b0867a6ee357054$var$_get(target, property, receiver || target);
}
$0b0867a6ee357054$export$71511d61b312f219 = $0b0867a6ee357054$var$_get;



var $92f5157d74f7ea45$export$71511d61b312f219;
"use strict";
var $0ef57a67a4dbd747$export$71511d61b312f219;
"use strict";
function $0ef57a67a4dbd747$var$_set_prototype_of(o, p) {
    $0ef57a67a4dbd747$export$71511d61b312f219 = $0ef57a67a4dbd747$var$_set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0ef57a67a4dbd747$var$_set_prototype_of(o, p);
}
$0ef57a67a4dbd747$export$71511d61b312f219 = $0ef57a67a4dbd747$var$_set_prototype_of;


function $92f5157d74f7ea45$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $0ef57a67a4dbd747$export$71511d61b312f219(subClass, superClass);
}
$92f5157d74f7ea45$export$71511d61b312f219 = $92f5157d74f7ea45$var$_inherits;




var $dYe7D = parcelRequire("dYe7D");

var $d5I5D = parcelRequire("d5I5D");
parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");

function $1cea8647883c4012$var$$parcel$exportWildcard(e, t) {
    return Object.keys(t).forEach(function(r) {
        "default" === r || "__esModule" === r || Object.prototype.hasOwnProperty.call(e, r) || Object.defineProperty(e, r, {
            enumerable: !0,
            get: function() {
                return t[r];
            }
        });
    }), e;
}
function $1cea8647883c4012$var$$parcel$interopDefault(e) {
    return e && e.__esModule ? e.default : e;
}
function $1cea8647883c4012$var$$parcel$export(e, t, r, a) {
    Object.defineProperty(e, t, {
        get: r,
        set: a,
        enumerable: !0,
        configurable: !0
    });
}
var $1cea8647883c4012$var$$0172b398bee57f0a$exports = {};
$1cea8647883c4012$var$$parcel$export($1cea8647883c4012$var$$0172b398bee57f0a$exports, "isEqualProps", function() {
    return $1cea8647883c4012$var$$0172b398bee57f0a$export$7112c88e033533b8;
}), $1cea8647883c4012$var$$parcel$export($1cea8647883c4012$var$$0172b398bee57f0a$exports, "reaction", function() {
    return $1cea8647883c4012$var$$0172b398bee57f0a$export$7203b476385689ae;
}), $1cea8647883c4012$var$$parcel$export($1cea8647883c4012$var$$0172b398bee57f0a$exports, "ObservedComponent", function() {
    return $1cea8647883c4012$var$$0172b398bee57f0a$export$bf180ef329d1efd8;
});
var $1cea8647883c4012$var$$0172b398bee57f0a$var$__esDecorate = function(e, t, r, a, s, n) {
    function i(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var c, o = a.kind, l = "getter" === o ? "get" : "setter" === o ? "set" : "value", $ = !t && e ? a.static ? e : e.prototype : null, u = t || ($ ? Object.getOwnPropertyDescriptor($, a.name) : {}), f = !1, d = r.length - 1; d >= 0; d--){
        var b = {};
        for(var p in a)b[p] = "access" === p ? {} : a[p];
        for(var p in a.access)b.access[p] = a.access[p];
        b.addInitializer = function(e) {
            if (f) throw TypeError("Cannot add initializers after decoration has completed");
            n.push(i(e || null));
        };
        var v = (0, r[d])("accessor" === o ? {
            get: u.get,
            set: u.set
        } : u[l], b);
        if ("accessor" === o) {
            if (void 0 === v) continue;
            if (null === v || (void 0 === v ? "undefined" : (0, $35f6c23f56aaf458$export$71511d61b312f219)(v)) !== "object") throw TypeError("Object expected");
            (c = i(v.get)) && (u.get = c), (c = i(v.set)) && (u.set = c), (c = i(v.init)) && s.unshift(c);
        } else (c = i(v)) && ("field" === o ? s.unshift(c) : u[l] = c);
    }
    $ && Object.defineProperty($, a.name, u), f = !0;
}, $1cea8647883c4012$var$$0172b398bee57f0a$var$__runInitializers = function(e, t, r) {
    for(var a = arguments.length > 2, s = 0; s < t.length; s++)r = a ? t[s].call(e, r) : t[s].call(e);
    return a ? r : void 0;
}, $1cea8647883c4012$var$$0172b398bee57f0a$var$__classPrivateFieldGet = function(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $1cea8647883c4012$var$$0172b398bee57f0a$var$__classPrivateFieldSet = function(e, t, r, a, s) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !s) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !s : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? s.call(e, r) : s ? s.value = r : t.set(e, r), r;
}, $1cea8647883c4012$var$$0172b398bee57f0a$export$7112c88e033533b8 = function(e, t) {
    return $1cea8647883c4012$var$$parcel$interopDefault($dYe7D)(e, t, function(e, t, r) {
        return [
            "_owner",
            "$$typeof"
        ].includes(r) || void 0;
    });
}, $1cea8647883c4012$var$$0172b398bee57f0a$var$reactionMap = new WeakMap, $1cea8647883c4012$var$$0172b398bee57f0a$export$7203b476385689ae = function(e) {
    return function(t, r) {
        return (0, r.addInitializer)(function() {
            var r = $1cea8647883c4012$var$$0172b398bee57f0a$var$reactionMap.get(this) || [];
            r.push({
                expression: e,
                effect: t
            }), $1cea8647883c4012$var$$0172b398bee57f0a$var$reactionMap.set(this, r);
        });
    };
}, $1cea8647883c4012$var$$0172b398bee57f0a$export$bf180ef329d1efd8 = function() {
    var e, t, r, a, s, n, i, c, o, l, $, u, f = $hO8yS.Component, d = [], b = [], p = [], v = [], _ = [], h = [];
    return r = function(e) {
        "use strict";
        function t() {
            var e;
            return (0, $2b3af368dbb30b38$export$71511d61b312f219)(this, t), e = (0, $95518c9e748840bb$export$71511d61b312f219)(this, t, arguments), s.set(e, $1cea8647883c4012$var$$0172b398bee57f0a$var$__runInitializers(e, d, e.props)), n.set(e, ($1cea8647883c4012$var$$0172b398bee57f0a$var$__runInitializers(e, b), $1cea8647883c4012$var$$0172b398bee57f0a$var$__runInitializers(e, p, e.state))), i.set(e, ($1cea8647883c4012$var$$0172b398bee57f0a$var$__runInitializers(e, v), $1cea8647883c4012$var$$0172b398bee57f0a$var$__runInitializers(e, _, e.context))), a.set(e, $1cea8647883c4012$var$$0172b398bee57f0a$var$__runInitializers(e, h)), e;
        }
        return (0, $92f5157d74f7ea45$export$71511d61b312f219)(t, e), (0, $53cdca766716469e$export$71511d61b312f219)(t, [
            {
                key: "observedProps",
                get: function() {
                    return $1cea8647883c4012$var$$0172b398bee57f0a$var$__classPrivateFieldGet(this, s, "f");
                },
                set: function(e) {
                    $1cea8647883c4012$var$$0172b398bee57f0a$var$__classPrivateFieldSet(this, s, e, "f");
                }
            },
            {
                key: "observedState",
                get: function() {
                    return $1cea8647883c4012$var$$0172b398bee57f0a$var$__classPrivateFieldGet(this, n, "f");
                },
                set: function(e) {
                    $1cea8647883c4012$var$$0172b398bee57f0a$var$__classPrivateFieldSet(this, n, e, "f");
                }
            },
            {
                key: "observedContext",
                get: function() {
                    return $1cea8647883c4012$var$$0172b398bee57f0a$var$__classPrivateFieldGet(this, i, "f");
                },
                set: function(e) {
                    $1cea8647883c4012$var$$0172b398bee57f0a$var$__classPrivateFieldSet(this, i, e, "f");
                }
            },
            {
                key: "componentDidMount",
                value: function() {
                    var e, t = this;
                    $1cea8647883c4012$var$$0172b398bee57f0a$var$__classPrivateFieldSet(this, a, null == (e = $1cea8647883c4012$var$$0172b398bee57f0a$var$reactionMap.get(this)) ? void 0 : e.map(function(e) {
                        var r = e.expression, a = e.effect;
                        return (0, $d5I5D.reaction)(function(e) {
                            return r(t, e);
                        }, a.bind(t));
                    }), "f");
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    var e;
                    null == (e = $1cea8647883c4012$var$$0172b398bee57f0a$var$__classPrivateFieldGet(this, a, "f")) || e.forEach(function(e) {
                        return e();
                    });
                }
            },
            {
                key: "componentDidUpdate",
                value: function(e, r, a) {
                    var s;
                    $1cea8647883c4012$var$$0172b398bee57f0a$export$7112c88e033533b8(e, this.props) || (this.observedProps = Object.assign({}, this.props)), $1cea8647883c4012$var$$0172b398bee57f0a$export$7112c88e033533b8(r, this.state) || (this.observedState = Object.assign({}, this.state)), null == (s = (0, $0b0867a6ee357054$export$71511d61b312f219)((0, $9ac8e64cff09d58e$export$71511d61b312f219)(t.prototype), "componentDidUpdate", this)) || s.call(this, e, r, a);
                }
            }
        ]), t;
    }(f), a = new WeakMap, s = new WeakMap, n = new WeakMap, i = new WeakMap, t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = f[Symbol.metadata]) ? e : null) : void 0, l = [
        (e = $d5I5D.observable).shallow.bind(e)
    ], $ = [
        (c = $d5I5D.observable).shallow.bind(c)
    ], u = [
        (o = $d5I5D.observable).shallow.bind(o)
    ], $1cea8647883c4012$var$$0172b398bee57f0a$var$__esDecorate(r, null, l, {
        kind: "accessor",
        name: "observedProps",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "observedProps" in e;
            },
            get: function(e) {
                return e.observedProps;
            },
            set: function(e, t) {
                e.observedProps = t;
            }
        },
        metadata: t
    }, d, b), $1cea8647883c4012$var$$0172b398bee57f0a$var$__esDecorate(r, null, $, {
        kind: "accessor",
        name: "observedState",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "observedState" in e;
            },
            get: function(e) {
                return e.observedState;
            },
            set: function(e, t) {
                e.observedState = t;
            }
        },
        metadata: t
    }, p, v), $1cea8647883c4012$var$$0172b398bee57f0a$var$__esDecorate(r, null, u, {
        kind: "accessor",
        name: "observedContext",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "observedContext" in e;
            },
            get: function(e) {
                return e.observedContext;
            },
            set: function(e, t) {
                e.observedContext = t;
            }
        },
        metadata: t
    }, _, h), t && Object.defineProperty(r, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), r;
}(), $1cea8647883c4012$var$$621b7277d4dc39e9$exports = {};
$1cea8647883c4012$var$$parcel$export($1cea8647883c4012$var$$621b7277d4dc39e9$exports, "FormComponent", function() {
    return $1cea8647883c4012$var$$621b7277d4dc39e9$export$cec7cafc710f5d68;
});
var $1cea8647883c4012$var$$621b7277d4dc39e9$var$__runInitializers = function(e, t, r) {
    for(var a = arguments.length > 2, s = 0; s < t.length; s++)r = a ? t[s].call(e, r) : t[s].call(e);
    return a ? r : void 0;
}, $1cea8647883c4012$var$$621b7277d4dc39e9$var$__esDecorate = function(e, t, r, a, s, n) {
    function i(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var c, o = a.kind, l = "getter" === o ? "get" : "setter" === o ? "set" : "value", $ = !t && e ? a.static ? e : e.prototype : null, u = t || ($ ? Object.getOwnPropertyDescriptor($, a.name) : {}), f = !1, d = r.length - 1; d >= 0; d--){
        var b = {};
        for(var p in a)b[p] = "access" === p ? {} : a[p];
        for(var p in a.access)b.access[p] = a.access[p];
        b.addInitializer = function(e) {
            if (f) throw TypeError("Cannot add initializers after decoration has completed");
            n.push(i(e || null));
        };
        var v = (0, r[d])("accessor" === o ? {
            get: u.get,
            set: u.set
        } : u[l], b);
        if ("accessor" === o) {
            if (void 0 === v) continue;
            if (null === v || (void 0 === v ? "undefined" : (0, $35f6c23f56aaf458$export$71511d61b312f219)(v)) !== "object") throw TypeError("Object expected");
            (c = i(v.get)) && (u.get = c), (c = i(v.set)) && (u.set = c), (c = i(v.init)) && s.unshift(c);
        } else (c = i(v)) && ("field" === o ? s.unshift(c) : u[l] = c);
    }
    $ && Object.defineProperty($, a.name, u), f = !0;
}, $1cea8647883c4012$var$$621b7277d4dc39e9$var$__classPrivateFieldGet = function(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $1cea8647883c4012$var$$621b7277d4dc39e9$var$__classPrivateFieldSet = function(e, t, r, a, s) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !s) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !s : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? s.call(e, r) : s ? s.value = r : t.set(e, r), r;
}, $1cea8647883c4012$var$$621b7277d4dc39e9$export$cec7cafc710f5d68 = function() {
    var e, t, r, a, s, n, i, c, o, l = [], $ = [], u = [];
    return e = function(e) {
        "use strict";
        function n() {
            var e;
            return (0, $2b3af368dbb30b38$export$71511d61b312f219)(this, n), e = (0, $95518c9e748840bb$export$71511d61b312f219)(this, n, arguments), Object.defineProperty(e, "ref", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($1cea8647883c4012$var$$621b7277d4dc39e9$var$__runInitializers(e, l), (0, $hO8yS.createRef)())
            }), s.set(e, $1cea8647883c4012$var$$621b7277d4dc39e9$var$__runInitializers(e, $, e.props.defaultValue)), t.set(e, $1cea8647883c4012$var$$621b7277d4dc39e9$var$__runInitializers(e, u)), r.set(e, void 0), a.set(e, function(t) {
                !(0, $fbe6f1e2fed97fc7$export$dd1bc94b04021eeb)(t) && (0, $fbe6f1e2fed97fc7$export$dd1bc94b04021eeb)(e.innerValue) && (e.innerValue = t);
            }), Object.defineProperty(e, "emitValue", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function(t) {
                    var r, a;
                    return null == (a = (r = e.observedProps).onChange) ? void 0 : a.call(r, t && (void 0 === t ? "undefined" : (0, $35f6c23f56aaf458$export$71511d61b312f219)(t)) === "object" ? (0, $d5I5D.toJS)(t) : t);
                }
            }), Object.defineProperty(e, "reset", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function() {
                    return e.innerValue = e.props.defaultValue;
                }
            }), e;
        }
        return (0, $92f5157d74f7ea45$export$71511d61b312f219)(n, e), (0, $53cdca766716469e$export$71511d61b312f219)(n, [
            {
                key: "innerValue",
                get: function() {
                    return $1cea8647883c4012$var$$621b7277d4dc39e9$var$__classPrivateFieldGet(this, s, "f");
                },
                set: function(e) {
                    $1cea8647883c4012$var$$621b7277d4dc39e9$var$__classPrivateFieldSet(this, s, e, "f");
                }
            },
            {
                key: "value",
                get: function() {
                    var e;
                    return null != (e = this.observedProps.value) ? e : this.innerValue;
                }
            },
            {
                key: "componentDidMount",
                value: function() {
                    var e, s, n = this;
                    $1cea8647883c4012$var$$621b7277d4dc39e9$var$__classPrivateFieldSet(this, t, (0, $d5I5D.reaction)(function() {
                        return n.observedProps.defaultValue;
                    }, $1cea8647883c4012$var$$621b7277d4dc39e9$var$__classPrivateFieldGet(this, a, "f")), "f"), $1cea8647883c4012$var$$621b7277d4dc39e9$var$__classPrivateFieldSet(this, r, (0, $d5I5D.reaction)(function() {
                        return n.innerValue;
                    }, this.emitValue), "f"), null == (s = null == (e = this.ref.current) ? void 0 : e.form) || s.addEventListener("reset", this.reset);
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    var e, a, s, n;
                    null == (e = $1cea8647883c4012$var$$621b7277d4dc39e9$var$__classPrivateFieldGet(this, t, "f")) || e.call(this), $1cea8647883c4012$var$$621b7277d4dc39e9$var$__classPrivateFieldSet(this, t, void 0, "f"), null == (a = $1cea8647883c4012$var$$621b7277d4dc39e9$var$__classPrivateFieldGet(this, r, "f")) || a.call(this), $1cea8647883c4012$var$$621b7277d4dc39e9$var$__classPrivateFieldSet(this, r, void 0, "f"), null == (n = null == (s = this.ref.current) ? void 0 : s.form) || n.removeEventListener("reset", this.reset);
                }
            }
        ]), n;
    }($1cea8647883c4012$var$$0172b398bee57f0a$export$bf180ef329d1efd8), t = new WeakMap, r = new WeakMap, a = new WeakMap, s = new WeakMap, o = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (c = $1cea8647883c4012$var$$0172b398bee57f0a$export$bf180ef329d1efd8[Symbol.metadata]) ? c : null) : void 0, n = [
        $d5I5D.observable
    ], i = [
        $d5I5D.computed
    ], $1cea8647883c4012$var$$621b7277d4dc39e9$var$__esDecorate(e, null, n, {
        kind: "accessor",
        name: "innerValue",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "innerValue" in e;
            },
            get: function(e) {
                return e.innerValue;
            },
            set: function(e, t) {
                e.innerValue = t;
            }
        },
        metadata: o
    }, $, u), $1cea8647883c4012$var$$621b7277d4dc39e9$var$__esDecorate(e, null, i, {
        kind: "getter",
        name: "value",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "value" in e;
            },
            get: function(e) {
                return e.value;
            }
        },
        metadata: o
    }, null, l), o && Object.defineProperty(e, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: o
    }), e;
}();
$1cea8647883c4012$var$$parcel$exportWildcard($1cea8647883c4012$exports, $1cea8647883c4012$var$$0172b398bee57f0a$exports), $1cea8647883c4012$var$$parcel$exportWildcard($1cea8647883c4012$exports, $1cea8647883c4012$var$$621b7277d4dc39e9$exports);





parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");



var $4643543b32ea28a9$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $4643543b32ea28a9$export$7f7cbe89f1eacd2 = (_a)=>{
    var { className: className = '', style: style, ratio: ratio = '1x1' } = _a, props = $4643543b32ea28a9$var$__rest(_a, [
        "className",
        "style",
        "ratio"
    ]);
    return (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("div", {
        className: `ratio ratio-${ratio} d-flex justify-content-center align-items-center ${className}`,
        style: style,
        children: (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $e72f20bad19c9555$export$2e2bcd8739ae039), Object.assign({}, props, {
            className: "position-static"
        }))
    });
};


var $bec6726d537cf691$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $bec6726d537cf691$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $bec6726d537cf691$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $bec6726d537cf691$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
/**
 * A re-implement of {@link https://github.com/idea2app/MobX-RESTful-table/blob/master/source/RestForm.tsx}
 */ let $bec6726d537cf691$export$341e3470805a945e = (()=>{
    let _classDecorators = [
        (0, $4d3432ed03d68615$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = (0, $hO8yS.Component);
    var RestForm = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            Object.defineProperty(this, "handleSubmit", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (event)=>{
                    event.preventDefault();
                    const data = (0, $fbe6f1e2fed97fc7$export$86d7c59254d6a2c9)(event.currentTarget);
                    console.log(data);
                }
            });
        }
        componentDidMount() {
            const { store: store, id: id } = this.props;
            if (id) store.getOne(id);
        }
        componentWillUnmount() {
            this.props.store.clearCurrent();
        }
        render() {
            const _a = this.props, { id: id, fields: fields, store: store, translator: translator } = _a, props = $bec6726d537cf691$var$__rest(_a, [
                "id",
                "fields",
                "store",
                "translator"
            ]);
            const { t: t } = translator, { downloading: downloading, currentOne: currentOne } = store;
            return (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $3ab5acc35160fbcc$export$2e2bcd8739ae039), Object.assign({}, props, {
                onSubmitCapture: this.handleSubmit,
                children: [
                    downloading > 0 ? (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $4643543b32ea28a9$export$7f7cbe89f1eacd2), {}) : fields.map((_a, index)=>{
                        var { key: key, title: title } = _a, props = $bec6726d537cf691$var$__rest(_a, [
                            "key",
                            "title"
                        ]);
                        return (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $3ab5acc35160fbcc$export$2e2bcd8739ae039).Item, {
                            label: title,
                            labelCol: {
                                span: 6
                            },
                            children: (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $f5df81ecd1248f24$export$2e2bcd8739ae039), Object.assign({}, props, {
                                name: key,
                                defaultValue: currentOne[key]
                            }))
                        }, key || index);
                    }),
                    (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("footer", {
                        className: "d-flex justify-content-end gap-3",
                        children: [
                            (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $9632ad3149894c43$export$2e2bcd8739ae039), {
                                htmlType: "reset",
                                children: t('cancel')
                            }),
                            (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $9632ad3149894c43$export$2e2bcd8739ae039), {
                                htmlType: "submit",
                                type: "primary",
                                children: t('submit')
                            })
                        ]
                    })
                ]
            }));
        }
    };
    $bec6726d537cf691$var$__setFunctionName(_classThis, "RestForm");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        $bec6726d537cf691$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        RestForm = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $bec6726d537cf691$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return RestForm = _classThis;
})();


var $f51b3960210a9c94$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $f51b3960210a9c94$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $f51b3960210a9c94$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $f51b3960210a9c94$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $f51b3960210a9c94$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $f51b3960210a9c94$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $f51b3960210a9c94$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
/**
 * A re-implement of {@link https://github.com/idea2app/MobX-RESTful-table/blob/master/source/RestTable.tsx}
 */ let $f51b3960210a9c94$export$fd90441354a7d816 = (()=>{
    var _RestTable_editingId_accessor_storage, _RestTable_checkedKeys_accessor_storage;
    let _classDecorators = [
        (0, $4d3432ed03d68615$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = (0, $1cea8647883c4012$exports.ObservedComponent);
    let _instanceExtraInitializers = [];
    let _editingId_decorators;
    let _editingId_initializers = [];
    let _editingId_extraInitializers = [];
    let _checkedKeys_decorators;
    let _checkedKeys_initializers = [];
    let _checkedKeys_extraInitializers = [];
    let _get_fields_decorators;
    let _get_columns_decorators;
    var RestTable = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            _RestTable_editingId_accessor_storage.set(this, ($f51b3960210a9c94$var$__runInitializers(this, _instanceExtraInitializers), $f51b3960210a9c94$var$__runInitializers(this, _editingId_initializers, void 0)));
            _RestTable_checkedKeys_accessor_storage.set(this, ($f51b3960210a9c94$var$__runInitializers(this, _editingId_extraInitializers), $f51b3960210a9c94$var$__runInitializers(this, _checkedKeys_initializers, [])));
            Object.defineProperty(this, "closeEditor", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($f51b3960210a9c94$var$__runInitializers(this, _checkedKeys_extraInitializers), ()=>this.editingId = undefined)
            });
            Object.defineProperty(this, "handleCheck", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (_, list)=>{
                    const { store: store, onCheck: onCheck } = this.props;
                    this.checkedKeys = list.map(({ [store.indexKey]: ID })=>ID);
                    onCheck === null || onCheck === void 0 || onCheck(this.checkedKeys);
                }
            });
        }
        get editingId() {
            return $f51b3960210a9c94$var$__classPrivateFieldGet(this, _RestTable_editingId_accessor_storage, "f");
        }
        set editingId(value) {
            $f51b3960210a9c94$var$__classPrivateFieldSet(this, _RestTable_editingId_accessor_storage, value, "f");
        }
        get checkedKeys() {
            return $f51b3960210a9c94$var$__classPrivateFieldGet(this, _RestTable_checkedKeys_accessor_storage, "f");
        }
        set checkedKeys(value) {
            $f51b3960210a9c94$var$__classPrivateFieldSet(this, _RestTable_checkedKeys_accessor_storage, value, "f");
        }
        componentDidMount() {
            this.props.store.getList({}, 1);
        }
        componentWillUnmount() {
            this.props.store.clear();
        }
        get fields() {
            return this.observedProps.columns.map((_a)=>{
                var { key: key, dataIndex: dataIndex = key, type: type, title: title = key, render: render } = _a, column = $f51b3960210a9c94$var$__rest(_a, [
                    "key",
                    "dataIndex",
                    "type",
                    "title",
                    "render"
                ]);
                return Object.assign(Object.assign({}, column), {
                    key: key,
                    dataIndex: dataIndex,
                    title: title,
                    type: type,
                    render: render || ((value)=>type === 'url' ? (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("a", {
                            target: "_blank",
                            href: value,
                            children: value
                        }) : value)
                });
            });
        }
        get columns() {
            const { store: store, translator: translator, editable: editable, deletable: deletable } = this.observedProps;
            const { t: t } = translator;
            return [
                ...this.fields,
                (editable || deletable) && {
                    key: 'edit',
                    render: (_, { [store.indexKey]: ID })=>(0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $afba98610eca1bae$export$2e2bcd8739ae039), {
                            children: [
                                editable && (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $9632ad3149894c43$export$2e2bcd8739ae039), {
                                    className: "bg-warning",
                                    onClick: ()=>this.editingId = ID,
                                    children: t('edit')
                                }),
                                deletable && (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $9632ad3149894c43$export$2e2bcd8739ae039), {
                                    className: "bg-danger text-white",
                                    onClick: ()=>this.delete([
                                            ID
                                        ]),
                                    children: t('delete')
                                })
                            ]
                        })
                }
            ];
        }
        delete(keys) {
            return $f51b3960210a9c94$var$__awaiter(this, void 0, void 0, function*() {
                const { translator: translator, store: store } = this.props;
                if (!confirm(translator.t('sure_to_delete_x', {
                    keys: keys
                }))) return;
                for (const ID of keys)yield store.deleteOne(ID);
                (0, $d1cd4dd6f62e88cc$export$2e2bcd8739ae039).success("\u221A");
            });
        }
        renderDialog() {
            const { id: id, store: store, translator: translator } = this.props, { fields: fields, editingId: editingId } = this;
            const { t: t } = translator;
            const currentTitle = `${id ? t('edit') : t('create')} ${store.currentOne[store.indexKey] || ''}`;
            return (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $4466fd620640c52a$export$2e2bcd8739ae039), {
                destroyOnClose: true,
                title: currentTitle,
                open: editingId != null,
                footer: null,
                onCancel: this.closeEditor,
                children: (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $bec6726d537cf691$export$341e3470805a945e), {
                    id: editingId,
                    fields: fields,
                    store: store,
                    translator: translator,
                    onReset: this.closeEditor
                })
            });
        }
        render() {
            const _a = this.props, { columns: columns, store: store, editable: editable, deletable: deletable, onCheck: onCheck } = _a, props = $f51b3960210a9c94$var$__rest(_a, [
                "columns",
                "store",
                "editable",
                "deletable",
                "onCheck"
            ]);
            const checkable = deletable || typeof onCheck === 'function', { t: t } = props.translator, { downloading: downloading, pageSize: pageSize, pageIndex: pageIndex, totalCount: totalCount = 0, currentPage: currentPage } = store;
            return (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $hO8yS.Fragment), {
                children: [
                    (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("header", {
                        className: "d-flex align-items-center gap-3 py-3",
                        children: [
                            (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("span", {
                                className: "me-auto",
                                children: t('total_x_rows', {
                                    totalCount: totalCount
                                })
                            }),
                            (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $9632ad3149894c43$export$2e2bcd8739ae039), {
                                type: "primary",
                                onClick: ()=>this.editingId = 0,
                                children: t('create')
                            }),
                            deletable && (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $9632ad3149894c43$export$2e2bcd8739ae039), {
                                className: "bg-danger text-white",
                                disabled: !this.checkedKeys.length,
                                onClick: ()=>this.delete(this.checkedKeys),
                                children: t('delete')
                            })
                        ]
                    }),
                    (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $19f315999f2129ce$export$2e2bcd8739ae039), Object.assign({}, props, {
                        columns: this.columns,
                        rowKey: store.indexKey.toString(),
                        loading: downloading > 0,
                        pagination: {
                            pageSize: pageSize,
                            current: pageIndex,
                            total: totalCount,
                            onChange: (page, pageSize)=>store.getList({}, page, pageSize)
                        },
                        dataSource: currentPage,
                        rowSelection: checkable ? {
                            type: 'checkbox',
                            onChange: this.handleCheck
                        } : undefined
                    })),
                    this.renderDialog()
                ]
            });
        }
    };
    _RestTable_editingId_accessor_storage = new WeakMap();
    _RestTable_checkedKeys_accessor_storage = new WeakMap();
    $f51b3960210a9c94$var$__setFunctionName(_classThis, "RestTable");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _editingId_decorators = [
            (0, $d5I5D.observable)
        ];
        _checkedKeys_decorators = [
            (0, $d5I5D.observable)
        ];
        _get_fields_decorators = [
            (0, $d5I5D.computed)
        ];
        _get_columns_decorators = [
            (0, $d5I5D.computed)
        ];
        $f51b3960210a9c94$var$__esDecorate(_classThis, null, _editingId_decorators, {
            kind: "accessor",
            name: "editingId",
            static: false,
            private: false,
            access: {
                has: (obj)=>"editingId" in obj,
                get: (obj)=>obj.editingId,
                set: (obj, value)=>{
                    obj.editingId = value;
                }
            },
            metadata: _metadata
        }, _editingId_initializers, _editingId_extraInitializers);
        $f51b3960210a9c94$var$__esDecorate(_classThis, null, _checkedKeys_decorators, {
            kind: "accessor",
            name: "checkedKeys",
            static: false,
            private: false,
            access: {
                has: (obj)=>"checkedKeys" in obj,
                get: (obj)=>obj.checkedKeys,
                set: (obj, value)=>{
                    obj.checkedKeys = value;
                }
            },
            metadata: _metadata
        }, _checkedKeys_initializers, _checkedKeys_extraInitializers);
        $f51b3960210a9c94$var$__esDecorate(_classThis, null, _get_fields_decorators, {
            kind: "getter",
            name: "fields",
            static: false,
            private: false,
            access: {
                has: (obj)=>"fields" in obj,
                get: (obj)=>obj.fields
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $f51b3960210a9c94$var$__esDecorate(_classThis, null, _get_columns_decorators, {
            kind: "getter",
            name: "columns",
            static: false,
            private: false,
            access: {
                has: (obj)=>"columns" in obj,
                get: (obj)=>obj.columns
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $f51b3960210a9c94$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        RestTable = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $f51b3960210a9c94$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return RestTable = _classThis;
})();




var $d67107f60bf33937$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $d67107f60bf33937$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $d67107f60bf33937$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
let $d67107f60bf33937$export$fb01502f5340e3de = (()=>{
    let _classDecorators = [
        (0, $4d3432ed03d68615$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = (0, $hO8yS.Component);
    var PaginationPage = _classThis = class extends _classSuper {
        get columns() {
            return [
                {
                    key: 'full_name',
                    title: (0, $b7383b0731549701$export$625550452a3fa3ec)('repository_name'),
                    render: (_, { html_url: html_url, full_name: full_name })=>(0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("a", {
                            target: "_blank",
                            href: html_url,
                            rel: "noreferrer",
                            children: full_name
                        })
                },
                {
                    key: 'homepage',
                    title: (0, $b7383b0731549701$export$625550452a3fa3ec)('home_page'),
                    type: 'url'
                },
                {
                    key: 'language',
                    title: (0, $b7383b0731549701$export$625550452a3fa3ec)('programming_language')
                },
                {
                    key: 'topics',
                    title: (0, $b7383b0731549701$export$625550452a3fa3ec)('topic'),
                    render: (_, { topics: topics })=>(0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $afba98610eca1bae$export$2e2bcd8739ae039), {
                            wrap: true,
                            children: topics.map((topic)=>(0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $445678750385e1db$export$37acb3580601e69a), {
                                    target: "_blank",
                                    href: `https://github.com/topics/${topic}`,
                                    children: topic
                                }, topic))
                        })
                },
                {
                    key: 'stargazers_count',
                    title: (0, $b7383b0731549701$export$625550452a3fa3ec)('star_count'),
                    type: 'number'
                }
            ];
        }
        render() {
            return (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $f51b3960210a9c94$export$fd90441354a7d816), {
                editable: true,
                deletable: true,
                translator: (0, $b7383b0731549701$export$a7357cdd1f0b0168),
                store: (0, $d919b95fbe3dd622$export$8701c19c4b8c549b),
                columns: this.columns,
                onCheck: console.log
            });
        }
    };
    $d67107f60bf33937$var$__setFunctionName(_classThis, "PaginationPage");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        $d67107f60bf33937$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        PaginationPage = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $d67107f60bf33937$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return PaginationPage = _classThis;
})();




var $ac22e9ddbc30c291$exports = {};
var $ac22e9ddbc30c291$var$$aac96070b6d8b41d$export$5eeb11949c905cc1;
var $ca91dac30bd8a8fe$export$71511d61b312f219;
"use strict";
var $b120af89f9316587$export$71511d61b312f219;
"use strict";
var $f1f2a513a1d434f1$export$71511d61b312f219;
"use strict";
function $f1f2a513a1d434f1$var$_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
$f1f2a513a1d434f1$export$71511d61b312f219 = $f1f2a513a1d434f1$var$_array_like_to_array;


function $b120af89f9316587$var$_array_without_holes(arr) {
    if (Array.isArray(arr)) return $f1f2a513a1d434f1$export$71511d61b312f219(arr);
}
$b120af89f9316587$export$71511d61b312f219 = $b120af89f9316587$var$_array_without_holes;


var $12645b8195910e7b$export$71511d61b312f219;
"use strict";
function $12645b8195910e7b$var$_iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
$12645b8195910e7b$export$71511d61b312f219 = $12645b8195910e7b$var$_iterable_to_array;


var $a0db71370622b2eb$export$71511d61b312f219;
"use strict";
function $a0db71370622b2eb$var$_non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$a0db71370622b2eb$export$71511d61b312f219 = $a0db71370622b2eb$var$_non_iterable_spread;


var $ee22f18d51655989$export$71511d61b312f219;
"use strict";

function $ee22f18d51655989$var$_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f1f2a513a1d434f1$export$71511d61b312f219(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f1f2a513a1d434f1$export$71511d61b312f219(o, minLen);
}
$ee22f18d51655989$export$71511d61b312f219 = $ee22f18d51655989$var$_unsupported_iterable_to_array;


function $ca91dac30bd8a8fe$var$_to_consumable_array(arr) {
    return $b120af89f9316587$export$71511d61b312f219(arr) || $12645b8195910e7b$export$71511d61b312f219(arr) || $ee22f18d51655989$export$71511d61b312f219(arr) || $a0db71370622b2eb$export$71511d61b312f219();
}
$ca91dac30bd8a8fe$export$71511d61b312f219 = $ca91dac30bd8a8fe$var$_to_consumable_array;



var $hO8yS = parcelRequire("hO8yS");


var $N3oW3 = parcelRequire("N3oW3");
parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");

"use client";
const $966d0ab785dd4154$export$666ad80b5007f835 = [
    'xxl',
    'xl',
    'lg',
    'md',
    'sm',
    'xs'
];
const $966d0ab785dd4154$export$ff817e17bad2e091 = 'xs';
const $966d0ab785dd4154$var$ThemeContext = /*#__PURE__*/ $hO8yS.createContext({
    prefixes: {},
    breakpoints: $966d0ab785dd4154$export$666ad80b5007f835,
    minBreakpoint: $966d0ab785dd4154$export$ff817e17bad2e091
});
const { Consumer: $966d0ab785dd4154$export$b631efc24e9d5e2f, Provider: $966d0ab785dd4154$var$Provider } = $966d0ab785dd4154$var$ThemeContext;
function $966d0ab785dd4154$var$ThemeProvider({ prefixes: prefixes = {}, breakpoints: breakpoints = $966d0ab785dd4154$export$666ad80b5007f835, minBreakpoint: minBreakpoint = $966d0ab785dd4154$export$ff817e17bad2e091, dir: dir, children: children }) {
    const contextValue = (0, $32rMB.useMemo)(()=>({
            prefixes: {
                ...prefixes
            },
            breakpoints: breakpoints,
            minBreakpoint: minBreakpoint,
            dir: dir
        }), [
        prefixes,
        breakpoints,
        minBreakpoint,
        dir
    ]);
    return /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($966d0ab785dd4154$var$Provider, {
        value: contextValue,
        children: children
    });
}
function $966d0ab785dd4154$export$7f387860ebffb32c(prefix, defaultPrefix) {
    const { prefixes: prefixes } = (0, $32rMB.useContext)($966d0ab785dd4154$var$ThemeContext);
    return prefix || prefixes[defaultPrefix] || defaultPrefix;
}
function $966d0ab785dd4154$export$8970c8db816a5863() {
    const { breakpoints: breakpoints } = (0, $32rMB.useContext)($966d0ab785dd4154$var$ThemeContext);
    return breakpoints;
}
function $966d0ab785dd4154$export$d926d6ef38f3fd32() {
    const { minBreakpoint: minBreakpoint } = (0, $32rMB.useContext)($966d0ab785dd4154$var$ThemeContext);
    return minBreakpoint;
}
function $966d0ab785dd4154$export$35e511eefa30ac5a() {
    const { dir: dir } = (0, $32rMB.useContext)($966d0ab785dd4154$var$ThemeContext);
    return dir === 'rtl';
}
function $966d0ab785dd4154$export$ce75053c20498f85(Component, opts) {
    if (typeof opts === 'string') opts = {
        prefix: opts
    };
    const isClassy = Component.prototype && Component.prototype.isReactComponent;
    // If it's a functional component make sure we don't break it with a ref
    const { prefix: prefix, forwardRefAs: forwardRefAs = isClassy ? 'ref' : 'innerRef' } = opts;
    const Wrapped = /*#__PURE__*/ $N3oW3.forwardRef(({ ...props }, ref)=>{
        props[forwardRefAs] = ref;
        const bsPrefix = $966d0ab785dd4154$export$7f387860ebffb32c(props.bsPrefix, prefix);
        return /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)(Component, {
            ...props,
            bsPrefix: bsPrefix
        });
    });
    Wrapped.displayName = `Bootstrap(${Component.displayName || Component.name})`;
    return Wrapped;
}
var $966d0ab785dd4154$export$2e2bcd8739ae039 = $966d0ab785dd4154$var$ThemeProvider;



"use client";
const $611ebbb42c2db614$var$Badge = /*#__PURE__*/ $N3oW3.forwardRef(({ bsPrefix: bsPrefix, bg: bg = 'primary', pill: pill = false, text: text, className: className, as: Component = 'span', ...props }, ref)=>{
    const prefix = (0, $966d0ab785dd4154$export$7f387860ebffb32c)(bsPrefix, 'badge');
    return /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, prefix, pill && `rounded-pill`, text && `text-${text}`, bg && `bg-${bg}`)
    });
});
$611ebbb42c2db614$var$Badge.displayName = 'Badge';
var $611ebbb42c2db614$export$2e2bcd8739ae039 = $611ebbb42c2db614$var$Badge;



var $N3oW3 = parcelRequire("N3oW3");

var $N3oW3 = parcelRequire("N3oW3");

const $da03b6413f74f004$var$_excluded = [
    "as",
    "disabled"
];
function $da03b6413f74f004$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $da03b6413f74f004$export$72369ab2cc99204b(href) {
    return !href || href.trim() === '#';
}
function $da03b6413f74f004$export$a0ee72f2c720a5c3({ tagName: tagName, disabled: disabled, href: href, target: target, rel: rel, role: role, onClick: onClick, tabIndex: tabIndex = 0, type: type }) {
    if (!tagName) {
        if (href != null || target != null || rel != null) tagName = 'a';
        else tagName = 'button';
    }
    const meta = {
        tagName: tagName
    };
    if (tagName === 'button') return [
        {
            type: type || 'button',
            disabled: disabled
        },
        meta
    ];
    const handleClick = (event)=>{
        if (disabled || tagName === 'a' && $da03b6413f74f004$export$72369ab2cc99204b(href)) event.preventDefault();
        if (disabled) {
            event.stopPropagation();
            return;
        }
        onClick == null || onClick(event);
    };
    const handleKeyDown = (event)=>{
        if (event.key === ' ') {
            event.preventDefault();
            handleClick(event);
        }
    };
    if (tagName === 'a') {
        // Ensure there's a href so Enter can trigger anchor button.
        href || (href = '#');
        if (disabled) href = undefined;
    }
    return [
        {
            role: role != null ? role : 'button',
            // explicitly undefined so that it overrides the props disabled in a spread
            // e.g. <Tag {...props} {...hookProps} />
            disabled: undefined,
            tabIndex: disabled ? undefined : tabIndex,
            href: href,
            target: tagName === 'a' ? target : undefined,
            'aria-disabled': !disabled ? undefined : disabled,
            rel: tagName === 'a' ? rel : undefined,
            onClick: handleClick,
            onKeyDown: handleKeyDown
        },
        meta
    ];
}
const $da03b6413f74f004$var$Button = /*#__PURE__*/ $N3oW3.forwardRef((_ref, ref)=>{
    let { as: asProp, disabled: disabled } = _ref, props = $da03b6413f74f004$var$_objectWithoutPropertiesLoose(_ref, $da03b6413f74f004$var$_excluded);
    const [buttonProps, { tagName: Component }] = $da03b6413f74f004$export$a0ee72f2c720a5c3(Object.assign({
        tagName: asProp,
        disabled: disabled
    }, props));
    return /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)(Component, Object.assign({}, props, buttonProps, {
        ref: ref
    }));
});
$da03b6413f74f004$var$Button.displayName = 'Button';
var $da03b6413f74f004$export$2e2bcd8739ae039 = $da03b6413f74f004$var$Button;




"use client";
const $b4033c9bbfbcc946$var$Button = /*#__PURE__*/ $N3oW3.forwardRef(({ as: as, bsPrefix: bsPrefix, variant: variant = 'primary', size: size, active: active = false, disabled: disabled = false, className: className, ...props }, ref)=>{
    const prefix = (0, $966d0ab785dd4154$export$7f387860ebffb32c)(bsPrefix, 'btn');
    const [buttonProps, { tagName: tagName }] = (0, $da03b6413f74f004$export$a0ee72f2c720a5c3)({
        tagName: as,
        disabled: disabled,
        ...props
    });
    const Component = tagName;
    return /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)(Component, {
        ...buttonProps,
        ...props,
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, prefix, active && 'active', variant && `${prefix}-${variant}`, size && `${prefix}-${size}`, props.href && disabled && 'disabled')
    });
});
$b4033c9bbfbcc946$var$Button.displayName = 'Button';
var $b4033c9bbfbcc946$export$2e2bcd8739ae039 = $b4033c9bbfbcc946$var$Button;



var $N3oW3 = parcelRequire("N3oW3");


"use client";
const $fd8349ff8538bb6f$var$ButtonGroup = /*#__PURE__*/ $N3oW3.forwardRef(({ bsPrefix: bsPrefix, size: size, vertical: vertical = false, className: className, role: role = 'group', // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...rest }, ref)=>{
    const prefix = (0, $966d0ab785dd4154$export$7f387860ebffb32c)(bsPrefix, 'btn-group');
    let baseClass = prefix;
    if (vertical) baseClass = `${prefix}-vertical`;
    return /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)(Component, {
        ...rest,
        ref: ref,
        role: role,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, baseClass, size && `${prefix}-${size}`)
    });
});
$fd8349ff8538bb6f$var$ButtonGroup.displayName = 'ButtonGroup';
var $fd8349ff8538bb6f$export$2e2bcd8739ae039 = $fd8349ff8538bb6f$var$ButtonGroup;

var $38b29c2dc0019b47$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $38b29c2dc0019b47$var$ReactIs, $38b29c2dc0019b47$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$38b29c2dc0019b47$exports = (parcelRequire("dflA0"))();



var $N3oW3 = parcelRequire("N3oW3");


const $25f7395c3ada3645$var$propTypes = {
    /** An accessible label indicating the relevant information about the Close Button. */ 'aria-label': (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string,
    /** A callback fired after the Close Button is clicked. */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).func,
    /**
   * Render different color variant for the button.
   *
   * Omitting this will render the default dark color.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).oneOf([
        'white'
    ])
};
const $25f7395c3ada3645$var$CloseButton = /*#__PURE__*/ $N3oW3.forwardRef(({ className: className, variant: variant, 'aria-label': ariaLabel = 'Close', ...props }, ref)=>/*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("button", {
        ref: ref,
        type: "button",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('btn-close', variant && `btn-close-${variant}`, className),
        "aria-label": ariaLabel,
        ...props
    }));
$25f7395c3ada3645$var$CloseButton.displayName = 'CloseButton';
$25f7395c3ada3645$var$CloseButton.propTypes = $25f7395c3ada3645$var$propTypes;
var $25f7395c3ada3645$export$2e2bcd8739ae039 = $25f7395c3ada3645$var$CloseButton;




var $N3oW3 = parcelRequire("N3oW3");


var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");


var $N3oW3 = parcelRequire("N3oW3");


const $052608978816a117$var$propTypes = {
    /**
   * Specify whether the feedback is for valid or invalid fields
   *
   * @type {('valid'|'invalid')}
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string,
    /** Display feedback as a tooltip. */ tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).elementType
};
const $052608978816a117$var$Feedback = /*#__PURE__*/ $N3oW3.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ as: Component = 'div', className: className, type: type = 'valid', tooltip: tooltip = false, ...props }, ref)=>/*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, `${type}-${tooltip ? 'tooltip' : 'feedback'}`)
    }));
$052608978816a117$var$Feedback.displayName = 'Feedback';
$052608978816a117$var$Feedback.propTypes = $052608978816a117$var$propTypes;
var $052608978816a117$export$2e2bcd8739ae039 = $052608978816a117$var$Feedback;




var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
"use client";
// TODO
const $2e97ecad219dbf95$var$FormContext = /*#__PURE__*/ $hO8yS.createContext({});
var $2e97ecad219dbf95$export$2e2bcd8739ae039 = $2e97ecad219dbf95$var$FormContext;




"use client";
const $9b3d00805d05349a$var$FormCheckInput = /*#__PURE__*/ $N3oW3.forwardRef(({ id: id, bsPrefix: bsPrefix, className: className, type: type = 'checkbox', isValid: isValid = false, isInvalid: isInvalid = false, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'input', ...props }, ref)=>{
    const { controlId: controlId } = (0, $32rMB.useContext)((0, $2e97ecad219dbf95$export$2e2bcd8739ae039));
    bsPrefix = (0, $966d0ab785dd4154$export$7f387860ebffb32c)(bsPrefix, 'form-check-input');
    return /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)(Component, {
        ...props,
        ref: ref,
        type: type,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix, isValid && 'is-valid', isInvalid && 'is-invalid')
    });
});
$9b3d00805d05349a$var$FormCheckInput.displayName = 'FormCheckInput';
var $9b3d00805d05349a$export$2e2bcd8739ae039 = $9b3d00805d05349a$var$FormCheckInput;




var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");



"use client";
const $ca0262d8c95ba804$var$FormCheckLabel = /*#__PURE__*/ $N3oW3.forwardRef(({ bsPrefix: bsPrefix, className: className, htmlFor: htmlFor, ...props }, ref)=>{
    const { controlId: controlId } = (0, $32rMB.useContext)((0, $2e97ecad219dbf95$export$2e2bcd8739ae039));
    bsPrefix = (0, $966d0ab785dd4154$export$7f387860ebffb32c)(bsPrefix, 'form-check-label');
    return /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("label", {
        ...props,
        ref: ref,
        htmlFor: htmlFor || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix)
    });
});
$ca0262d8c95ba804$var$FormCheckLabel.displayName = 'FormCheckLabel';
var $ca0262d8c95ba804$export$2e2bcd8739ae039 = $ca0262d8c95ba804$var$FormCheckLabel;





var $N3oW3 = parcelRequire("N3oW3");
/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid elements".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 */ function $636cc69cfad83823$export$871de8747c9eaa88(children, func) {
    let index = 0;
    return $N3oW3.Children.map(children, (child)=>/*#__PURE__*/ $N3oW3.isValidElement(child) ? func(child, index++) : child);
}
/**
 * Iterates through children that are "valid elements".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 */ function $636cc69cfad83823$export$4b80e395e36b5a56(children, func) {
    let index = 0;
    $N3oW3.Children.forEach(children, (child)=>{
        if (/*#__PURE__*/ $N3oW3.isValidElement(child)) func(child, index++);
    });
}
/**
 * Finds whether a component's `children` prop includes a React element of the
 * specified type.
 */ function $636cc69cfad83823$export$500fd6099226ffae(children, type) {
    return $N3oW3.Children.toArray(children).some((child)=>/*#__PURE__*/ $N3oW3.isValidElement(child) && child.type === type);
}



var $hO8yS = parcelRequire("hO8yS");
"use client";
const $0ba3144cb2116a78$var$FormCheck = /*#__PURE__*/ $N3oW3.forwardRef(({ id: id, bsPrefix: bsPrefix, bsSwitchPrefix: bsSwitchPrefix, inline: inline = false, reverse: reverse = false, disabled: disabled = false, isValid: isValid = false, isInvalid: isInvalid = false, feedbackTooltip: feedbackTooltip = false, feedback: feedback, feedbackType: feedbackType, className: className, style: style, title: title = '', type: type = 'checkbox', label: label, children: children, as: // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as = 'input', ...props }, ref)=>{
    bsPrefix = (0, $966d0ab785dd4154$export$7f387860ebffb32c)(bsPrefix, 'form-check');
    bsSwitchPrefix = (0, $966d0ab785dd4154$export$7f387860ebffb32c)(bsSwitchPrefix, 'form-switch');
    const { controlId: controlId } = (0, $32rMB.useContext)((0, $2e97ecad219dbf95$export$2e2bcd8739ae039));
    const innerFormContext = (0, $32rMB.useMemo)(()=>({
            controlId: id || controlId
        }), [
        controlId,
        id
    ]);
    const hasLabel = !children && label != null && label !== false || (0, $636cc69cfad83823$export$500fd6099226ffae)(children, (0, $ca0262d8c95ba804$export$2e2bcd8739ae039));
    const input = /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $9b3d00805d05349a$export$2e2bcd8739ae039), {
        ...props,
        type: type === 'switch' ? 'checkbox' : type,
        ref: ref,
        isValid: isValid,
        isInvalid: isInvalid,
        disabled: disabled,
        as: as
    });
    return /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $2e97ecad219dbf95$export$2e2bcd8739ae039).Provider, {
        value: innerFormContext,
        children: /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("div", {
            style: style,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, hasLabel && bsPrefix, inline && `${bsPrefix}-inline`, reverse && `${bsPrefix}-reverse`, type === 'switch' && bsSwitchPrefix),
            children: children || /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $hO8yS.Fragment), {
                children: [
                    input,
                    hasLabel && /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $ca0262d8c95ba804$export$2e2bcd8739ae039), {
                        title: title,
                        children: label
                    }),
                    feedback && /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $052608978816a117$export$2e2bcd8739ae039), {
                        type: feedbackType,
                        tooltip: feedbackTooltip,
                        children: feedback
                    })
                ]
            })
        })
    });
});
$0ba3144cb2116a78$var$FormCheck.displayName = 'FormCheck';
var $0ba3144cb2116a78$export$2e2bcd8739ae039 = Object.assign($0ba3144cb2116a78$var$FormCheck, {
    Input: (0, $9b3d00805d05349a$export$2e2bcd8739ae039),
    Label: (0, $ca0262d8c95ba804$export$2e2bcd8739ae039)
});




var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
var $9abc3dc86fc6eb1f$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $9abc3dc86fc6eb1f$var$__DEV__ = false;
var $9abc3dc86fc6eb1f$var$warning = function() {};
if ($9abc3dc86fc6eb1f$var$__DEV__) {
    var $9abc3dc86fc6eb1f$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $9abc3dc86fc6eb1f$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $9abc3dc86fc6eb1f$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$9abc3dc86fc6eb1f$exports = $9abc3dc86fc6eb1f$var$warning;






"use client";
const $efea879f0c0382a0$var$FormControl = /*#__PURE__*/ $N3oW3.forwardRef(({ bsPrefix: bsPrefix, type: type, size: size, htmlSize: htmlSize, id: id, className: className, isValid: isValid = false, isInvalid: isInvalid = false, plaintext: plaintext, readOnly: readOnly, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'input', ...props }, ref)=>{
    const { controlId: controlId } = (0, $32rMB.useContext)((0, $2e97ecad219dbf95$export$2e2bcd8739ae039));
    bsPrefix = (0, $966d0ab785dd4154$export$7f387860ebffb32c)(bsPrefix, 'form-control');
    return /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)(Component, {
        ...props,
        type: type,
        size: htmlSize,
        ref: ref,
        readOnly: readOnly,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, plaintext ? `${bsPrefix}-plaintext` : bsPrefix, size && `${bsPrefix}-${size}`, type === 'color' && `${bsPrefix}-color`, isValid && 'is-valid', isInvalid && 'is-invalid')
    });
});
$efea879f0c0382a0$var$FormControl.displayName = 'FormControl';
var $efea879f0c0382a0$export$2e2bcd8739ae039 = Object.assign($efea879f0c0382a0$var$FormControl, {
    Feedback: $052608978816a117$export$2e2bcd8739ae039
});



var $N3oW3 = parcelRequire("N3oW3");



"use client";
const $885e046394f9ec66$var$FormFloating = /*#__PURE__*/ $N3oW3.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $966d0ab785dd4154$export$7f387860ebffb32c)(bsPrefix, 'form-floating');
    return /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$885e046394f9ec66$var$FormFloating.displayName = 'FormFloating';
var $885e046394f9ec66$export$2e2bcd8739ae039 = $885e046394f9ec66$var$FormFloating;



var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");


const $9d0985da9951fbd1$var$FormGroup = /*#__PURE__*/ $N3oW3.forwardRef(({ controlId: controlId, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const context = (0, $32rMB.useMemo)(()=>({
            controlId: controlId
        }), [
        controlId
    ]);
    return /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $2e97ecad219dbf95$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)(Component, {
            ...props,
            ref: ref
        })
    });
});
$9d0985da9951fbd1$var$FormGroup.displayName = 'FormGroup';
var $9d0985da9951fbd1$export$2e2bcd8739ae039 = $9d0985da9951fbd1$var$FormGroup;




var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");



var $N3oW3 = parcelRequire("N3oW3");


"use client";
function $c03a9168ebb39c59$export$2ed43d61a0a9f5a3({ as: as, bsPrefix: bsPrefix, className: className, ...props }) {
    bsPrefix = (0, $966d0ab785dd4154$export$7f387860ebffb32c)(bsPrefix, 'col');
    const breakpoints = (0, $966d0ab785dd4154$export$8970c8db816a5863)();
    const minBreakpoint = (0, $966d0ab785dd4154$export$d926d6ef38f3fd32)();
    const spans = [];
    const classes = [];
    breakpoints.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        delete props[brkPoint];
        let span;
        let offset;
        let order;
        if (typeof propValue === 'object' && propValue != null) ({ span: span, offset: offset, order: order } = propValue);
        else span = propValue;
        const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
        if (span) spans.push(span === true ? `${bsPrefix}${infix}` : `${bsPrefix}${infix}-${span}`);
        if (order != null) classes.push(`order${infix}-${order}`);
        if (offset != null) classes.push(`offset${infix}-${offset}`);
    });
    return [
        {
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, ...spans, ...classes)
        },
        {
            as: as,
            bsPrefix: bsPrefix,
            spans: spans
        }
    ];
}
const $c03a9168ebb39c59$var$Col = /*#__PURE__*/ $N3oW3.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(props, ref)=>{
    const [{ className: className, ...colProps }, { as: Component = 'div', bsPrefix: bsPrefix, spans: spans }] = $c03a9168ebb39c59$export$2ed43d61a0a9f5a3(props);
    return /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)(Component, {
        ...colProps,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, !spans.length && bsPrefix)
    });
});
$c03a9168ebb39c59$var$Col.displayName = 'Col';
var $c03a9168ebb39c59$export$2e2bcd8739ae039 = $c03a9168ebb39c59$var$Col;





"use client";
const $ece621a68bacbd4d$var$FormLabel = /*#__PURE__*/ $N3oW3.forwardRef(({ // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'label', bsPrefix: bsPrefix, column: column = false, visuallyHidden: visuallyHidden = false, className: className, htmlFor: htmlFor, ...props }, ref)=>{
    const { controlId: controlId } = (0, $32rMB.useContext)((0, $2e97ecad219dbf95$export$2e2bcd8739ae039));
    bsPrefix = (0, $966d0ab785dd4154$export$7f387860ebffb32c)(bsPrefix, 'form-label');
    let columnClass = 'col-form-label';
    if (typeof column === 'string') columnClass = `${columnClass} ${columnClass}-${column}`;
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix, visuallyHidden && 'visually-hidden', column && columnClass);
    htmlFor = htmlFor || controlId;
    if (column) return /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $c03a9168ebb39c59$export$2e2bcd8739ae039), {
        ref: ref,
        as: "label",
        className: classes,
        htmlFor: htmlFor,
        ...props
    });
    return /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)(Component, {
        ref: ref,
        className: classes,
        htmlFor: htmlFor,
        ...props
    });
});
$ece621a68bacbd4d$var$FormLabel.displayName = 'FormLabel';
var $ece621a68bacbd4d$export$2e2bcd8739ae039 = $ece621a68bacbd4d$var$FormLabel;




var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");



"use client";
const $5f827168e1bf9901$var$FormRange = /*#__PURE__*/ $N3oW3.forwardRef(({ bsPrefix: bsPrefix, className: className, id: id, ...props }, ref)=>{
    const { controlId: controlId } = (0, $32rMB.useContext)((0, $2e97ecad219dbf95$export$2e2bcd8739ae039));
    bsPrefix = (0, $966d0ab785dd4154$export$7f387860ebffb32c)(bsPrefix, 'form-range');
    return /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("input", {
        ...props,
        type: "range",
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        id: id || controlId
    });
});
$5f827168e1bf9901$var$FormRange.displayName = 'FormRange';
var $5f827168e1bf9901$export$2e2bcd8739ae039 = $5f827168e1bf9901$var$FormRange;




var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");



"use client";
const $237daa89cf6e737c$var$FormSelect = /*#__PURE__*/ $N3oW3.forwardRef(({ bsPrefix: bsPrefix, size: size, htmlSize: htmlSize, className: className, isValid: isValid = false, isInvalid: isInvalid = false, id: id, ...props }, ref)=>{
    const { controlId: controlId } = (0, $32rMB.useContext)((0, $2e97ecad219dbf95$export$2e2bcd8739ae039));
    bsPrefix = (0, $966d0ab785dd4154$export$7f387860ebffb32c)(bsPrefix, 'form-select');
    return /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("select", {
        ...props,
        size: htmlSize,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix, size && `${bsPrefix}-${size}`, isValid && `is-valid`, isInvalid && `is-invalid`),
        id: id || controlId
    });
});
$237daa89cf6e737c$var$FormSelect.displayName = 'FormSelect';
var $237daa89cf6e737c$export$2e2bcd8739ae039 = $237daa89cf6e737c$var$FormSelect;




var $N3oW3 = parcelRequire("N3oW3");


"use client";
const $0cb84e62a1c8bdec$var$FormText = /*#__PURE__*/ $N3oW3.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ bsPrefix: bsPrefix, className: className, as: Component = 'small', muted: muted, ...props }, ref)=>{
    bsPrefix = (0, $966d0ab785dd4154$export$7f387860ebffb32c)(bsPrefix, 'form-text');
    return /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix, muted && 'text-muted')
    });
});
$0cb84e62a1c8bdec$var$FormText.displayName = 'FormText';
var $0cb84e62a1c8bdec$export$2e2bcd8739ae039 = $0cb84e62a1c8bdec$var$FormText;



var $N3oW3 = parcelRequire("N3oW3");


const $a9cbf38e4b1cf112$var$Switch = /*#__PURE__*/ $N3oW3.forwardRef((props, ref)=>/*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $0ba3144cb2116a78$export$2e2bcd8739ae039), {
        ...props,
        ref: ref,
        type: "switch"
    }));
$a9cbf38e4b1cf112$var$Switch.displayName = 'Switch';
var $a9cbf38e4b1cf112$export$2e2bcd8739ae039 = Object.assign($a9cbf38e4b1cf112$var$Switch, {
    Input: (0, $0ba3144cb2116a78$export$2e2bcd8739ae039).Input,
    Label: (0, $0ba3144cb2116a78$export$2e2bcd8739ae039).Label
});




var $N3oW3 = parcelRequire("N3oW3");



"use client";
const $9b4e6e87e291e84b$var$FloatingLabel = /*#__PURE__*/ $N3oW3.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, controlId: controlId, label: label, ...props }, ref)=>{
    bsPrefix = (0, $966d0ab785dd4154$export$7f387860ebffb32c)(bsPrefix, 'form-floating');
    return /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $9d0985da9951fbd1$export$2e2bcd8739ae039), {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        controlId: controlId,
        ...props,
        children: [
            children,
            /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("label", {
                htmlFor: controlId,
                children: label
            })
        ]
    });
});
$9b4e6e87e291e84b$var$FloatingLabel.displayName = 'FloatingLabel';
var $9b4e6e87e291e84b$export$2e2bcd8739ae039 = $9b4e6e87e291e84b$var$FloatingLabel;



const $a213c3bf0143d254$var$propTypes = {
    /**
   * The Form `ref` will be forwarded to the underlying element,
   * which means, unless it's rendered `as` a composite component,
   * it will be a DOM node, when resolved.
   *
   * @type {ReactRef}
   * @alias ref
   */ _ref: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).any,
    /**
   * Mark a form as having been validated. Setting it to `true` will
   * toggle any validation styles on the forms elements.
   */ validated: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).elementType
};
const $a213c3bf0143d254$var$Form = /*#__PURE__*/ $N3oW3.forwardRef(({ className: className, validated: validated, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'form', ...props }, ref)=>/*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, validated && 'was-validated')
    }));
$a213c3bf0143d254$var$Form.displayName = 'Form';
$a213c3bf0143d254$var$Form.propTypes = $a213c3bf0143d254$var$propTypes;
var $a213c3bf0143d254$export$2e2bcd8739ae039 = Object.assign($a213c3bf0143d254$var$Form, {
    Group: (0, $9d0985da9951fbd1$export$2e2bcd8739ae039),
    Control: (0, $efea879f0c0382a0$export$2e2bcd8739ae039),
    Floating: (0, $885e046394f9ec66$export$2e2bcd8739ae039),
    Check: (0, $0ba3144cb2116a78$export$2e2bcd8739ae039),
    Switch: $a9cbf38e4b1cf112$export$2e2bcd8739ae039,
    Label: (0, $ece621a68bacbd4d$export$2e2bcd8739ae039),
    Text: (0, $0cb84e62a1c8bdec$export$2e2bcd8739ae039),
    Range: (0, $5f827168e1bf9901$export$2e2bcd8739ae039),
    Select: (0, $237daa89cf6e737c$export$2e2bcd8739ae039),
    FloatingLabel: $9b4e6e87e291e84b$export$2e2bcd8739ae039
});



var $N3oW3 = parcelRequire("N3oW3");



"use client";
const $da05e9bb3075bec1$export$513805011eaa4892 = {
    /**
   * @default 'img'
   */ bsPrefix: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string,
    /**
   * Sets image as fluid image.
   */ fluid: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).bool,
    /**
   * Sets image shape as rounded.
   */ rounded: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).bool,
    /**
   * Sets image shape as circle.
   */ roundedCircle: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).bool,
    /**
   * Sets image shape as thumbnail.
   */ thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).bool
};
const $da05e9bb3075bec1$var$Image = /*#__PURE__*/ $N3oW3.forwardRef(({ bsPrefix: bsPrefix, className: className, fluid: fluid = false, rounded: rounded = false, roundedCircle: roundedCircle = false, thumbnail: thumbnail = false, ...props }, ref)=>{
    bsPrefix = (0, $966d0ab785dd4154$export$7f387860ebffb32c)(bsPrefix, 'img');
    return /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("img", {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, fluid && `${bsPrefix}-fluid`, rounded && `rounded`, roundedCircle && `rounded-circle`, thumbnail && `${bsPrefix}-thumbnail`)
    });
});
$da05e9bb3075bec1$var$Image.displayName = 'Image';
var $da05e9bb3075bec1$export$2e2bcd8739ae039 = $da05e9bb3075bec1$var$Image;



var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
"use client";
const $ddcc53812175b77c$var$context = /*#__PURE__*/ $hO8yS.createContext(null);
$ddcc53812175b77c$var$context.displayName = 'InputGroupContext';
var $ddcc53812175b77c$export$2e2bcd8739ae039 = $ddcc53812175b77c$var$context;



var $N3oW3 = parcelRequire("N3oW3");



"use client";
const $1acb58e08fcc85c9$var$InputGroupText = /*#__PURE__*/ $N3oW3.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'span', ...props }, ref)=>{
    bsPrefix = (0, $966d0ab785dd4154$export$7f387860ebffb32c)(bsPrefix, 'input-group-text');
    return /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$1acb58e08fcc85c9$var$InputGroupText.displayName = 'InputGroupText';
var $1acb58e08fcc85c9$export$2e2bcd8739ae039 = $1acb58e08fcc85c9$var$InputGroupText;



"use client";
const $43bff9b07dfb92e6$var$InputGroupCheckbox = (props)=>/*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $1acb58e08fcc85c9$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $9b3d00805d05349a$export$2e2bcd8739ae039), {
            type: "checkbox",
            ...props
        })
    });
const $43bff9b07dfb92e6$var$InputGroupRadio = (props)=>/*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $1acb58e08fcc85c9$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $9b3d00805d05349a$export$2e2bcd8739ae039), {
            type: "radio",
            ...props
        })
    });
const $43bff9b07dfb92e6$var$InputGroup = /*#__PURE__*/ $N3oW3.forwardRef(({ bsPrefix: bsPrefix, size: size, hasValidation: hasValidation, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $966d0ab785dd4154$export$7f387860ebffb32c)(bsPrefix, 'input-group');
    // Intentionally an empty object. Used in detecting if a dropdown
    // exists under an input group.
    const contextValue = (0, $32rMB.useMemo)(()=>({}), []);
    return /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $ddcc53812175b77c$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)(Component, {
            ref: ref,
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix, size && `${bsPrefix}-${size}`, hasValidation && 'has-validation')
        })
    });
});
$43bff9b07dfb92e6$var$InputGroup.displayName = 'InputGroup';
var $43bff9b07dfb92e6$export$2e2bcd8739ae039 = Object.assign($43bff9b07dfb92e6$var$InputGroup, {
    Text: (0, $1acb58e08fcc85c9$export$2e2bcd8739ae039),
    Radio: $43bff9b07dfb92e6$var$InputGroupRadio,
    Checkbox: $43bff9b07dfb92e6$var$InputGroupCheckbox
});



var $N3oW3 = parcelRequire("N3oW3");



parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
var $0e34bdc1602f642d$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $0e34bdc1602f642d$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
$0e34bdc1602f642d$exports = $0e34bdc1602f642d$var$invariant;


var $55a020f4bf5fa6d9$var$noop = function noop() {};
function $55a020f4bf5fa6d9$var$readOnlyPropType(handler, name) {
    return function(props, propName) {
        if (props[propName] !== undefined) {
            if (!props[handler]) return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + $55a020f4bf5fa6d9$export$26cbf8c37e721e67(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
        }
    };
}
function $55a020f4bf5fa6d9$export$8abd944bed26e726(controlledValues, displayName) {
    var propTypes = {};
    Object.keys(controlledValues).forEach(function(prop) {
        // add default propTypes for folks that use runtime checks
        propTypes[$55a020f4bf5fa6d9$export$26cbf8c37e721e67(prop)] = $55a020f4bf5fa6d9$var$noop;
        var handler;
    });
    return propTypes;
}
function $55a020f4bf5fa6d9$export$12ae2baa35bd9b8b(props, prop) {
    return props[prop] !== undefined;
}
function $55a020f4bf5fa6d9$export$26cbf8c37e721e67(key) {
    return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
function $55a020f4bf5fa6d9$export$95e5b18573b29087(component) {
    return !!component && (typeof component !== 'function' || component.prototype && component.prototype.isReactComponent);
}


function $0a5cdb039ef2f0e5$var$_toPropertyKey(arg) {
    var key = $0a5cdb039ef2f0e5$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $0a5cdb039ef2f0e5$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $0a5cdb039ef2f0e5$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    var wasPropRef = (0, $32rMB.useRef)(propValue !== undefined);
    var _useState = (0, $32rMB.useState)(defaultValue), stateValue = _useState[0], setState = _useState[1];
    var isProp = propValue !== undefined;
    var wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $32rMB.useCallback)(function(value) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            if (handler) handler.apply(void 0, [
                value
            ].concat(args));
            setState(value);
        }, [
            handler
        ])
    ];
}
function $0a5cdb039ef2f0e5$export$2e2bcd8739ae039(props, config) {
    return Object.keys(config).reduce(function(result, fieldName) {
        var _extends2;
        var _ref = result, defaultValue = _ref[$55a020f4bf5fa6d9$export$26cbf8c37e721e67(fieldName)], propsValue = _ref[fieldName], rest = (0, $a396812ba85d91d0$export$2e2bcd8739ae039)(_ref, [
            $55a020f4bf5fa6d9$export$26cbf8c37e721e67(fieldName),
            fieldName
        ].map($0a5cdb039ef2f0e5$var$_toPropertyKey));
        var handlerName = config[fieldName];
        var _useUncontrolledProp = $0a5cdb039ef2f0e5$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]), value = _useUncontrolledProp[0], handler = _useUncontrolledProp[1];
        return (0, $4dfb8f1fff0cbd5e$export$2e2bcd8739ae039)({}, rest, (_extends2 = {}, _extends2[fieldName] = value, _extends2[handlerName] = handler, _extends2));
    }, props);
}





function $5122792117adb82d$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $e3c997c5b70ce726$export$2e2bcd8739ae039)(t, o);
}



var $N3oW3 = parcelRequire("N3oW3");
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $51cb67738c4a415e$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $51cb67738c4a415e$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $51cb67738c4a415e$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$51cb67738c4a415e$var$componentWillMount.__suppressDeprecationWarning = true;
$51cb67738c4a415e$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$51cb67738c4a415e$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $51cb67738c4a415e$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = $51cb67738c4a415e$var$componentWillMount;
        prototype.componentWillReceiveProps = $51cb67738c4a415e$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = $51cb67738c4a415e$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}




var $c71989f9de8f46b4$var$_jsxFileName = "/Users/jquense/src/uncontrollable/src/uncontrollable.js";
function $c71989f9de8f46b4$export$2e2bcd8739ae039(Component, controlledValues, methods) {
    if (methods === void 0) methods = [];
    var displayName = Component.displayName || Component.name || 'Component';
    var canAcceptRef = $55a020f4bf5fa6d9$export$95e5b18573b29087(Component);
    var controlledProps = Object.keys(controlledValues);
    var PROPS_TO_OMIT = controlledProps.map($55a020f4bf5fa6d9$export$26cbf8c37e721e67);
    !(canAcceptRef || !methods.length) && (0, (/*@__PURE__*/$parcel$interopDefault($0e34bdc1602f642d$exports)))(false);
    var UncontrolledComponent = /*#__PURE__*/ function(_React$Component) {
        (0, $5122792117adb82d$export$2e2bcd8739ae039)(UncontrolledComponent, _React$Component);
        function UncontrolledComponent() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.handlers = Object.create(null);
            controlledProps.forEach(function(propName) {
                var handlerName = controlledValues[propName];
                var handleChange = function handleChange(value) {
                    if (_this.props[handlerName]) {
                        var _this$props;
                        _this._notifying = true;
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        (_this$props = _this.props)[handlerName].apply(_this$props, [
                            value
                        ].concat(args));
                        _this._notifying = false;
                    }
                    if (!_this.unmounted) _this.setState(function(_ref) {
                        var _extends2;
                        var values = _ref.values;
                        return {
                            values: (0, $4dfb8f1fff0cbd5e$export$2e2bcd8739ae039)(Object.create(null), values, (_extends2 = {}, _extends2[propName] = value, _extends2))
                        };
                    });
                };
                _this.handlers[handlerName] = handleChange;
            });
            if (methods.length) _this.attachRef = function(ref) {
                _this.inner = ref;
            };
            var values = Object.create(null);
            controlledProps.forEach(function(key) {
                values[key] = _this.props[$55a020f4bf5fa6d9$export$26cbf8c37e721e67(key)];
            });
            _this.state = {
                values: values,
                prevProps: {}
            };
            return _this;
        }
        var _proto = UncontrolledComponent.prototype;
        _proto.shouldComponentUpdate = function shouldComponentUpdate() {
            //let setState trigger the update
            return !this._notifying;
        };
        UncontrolledComponent.getDerivedStateFromProps = function getDerivedStateFromProps(props, _ref2) {
            var values = _ref2.values, prevProps = _ref2.prevProps;
            var nextState = {
                values: (0, $4dfb8f1fff0cbd5e$export$2e2bcd8739ae039)(Object.create(null), values),
                prevProps: {}
            };
            controlledProps.forEach(function(key) {
                /**
         * If a prop switches from controlled to Uncontrolled
         * reset its value to the defaultValue
         */ nextState.prevProps[key] = props[key];
                if (!$55a020f4bf5fa6d9$export$12ae2baa35bd9b8b(props, key) && $55a020f4bf5fa6d9$export$12ae2baa35bd9b8b(prevProps, key)) nextState.values[key] = props[$55a020f4bf5fa6d9$export$26cbf8c37e721e67(key)];
            });
            return nextState;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.unmounted = true;
        };
        _proto.render = function render() {
            var _this2 = this;
            var _this$props2 = this.props, innerRef = _this$props2.innerRef, props = (0, $a396812ba85d91d0$export$2e2bcd8739ae039)(_this$props2, [
                "innerRef"
            ]);
            PROPS_TO_OMIT.forEach(function(prop) {
                delete props[prop];
            });
            var newProps = {};
            controlledProps.forEach(function(propName) {
                var propValue = _this2.props[propName];
                newProps[propName] = propValue !== undefined ? propValue : _this2.state.values[propName];
            });
            return (0, $N3oW3.default).createElement(Component, (0, $4dfb8f1fff0cbd5e$export$2e2bcd8739ae039)({}, props, newProps, this.handlers, {
                ref: innerRef || this.attachRef
            }));
        };
        return UncontrolledComponent;
    }((0, $N3oW3.default).Component);
    (0, $51cb67738c4a415e$export$cea1c58a6db52bca)(UncontrolledComponent);
    UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
    UncontrolledComponent.propTypes = (0, $4dfb8f1fff0cbd5e$export$2e2bcd8739ae039)({
        innerRef: function innerRef() {}
    }, $55a020f4bf5fa6d9$export$8abd944bed26e726(controlledValues, displayName));
    methods.forEach(function(method) {
        UncontrolledComponent.prototype[method] = function $proxiedMethod() {
            var _this$inner;
            return (_this$inner = this.inner)[method].apply(_this$inner, arguments);
        };
    });
    var WrappedComponent = UncontrolledComponent;
    if ((0, $N3oW3.default).forwardRef) {
        WrappedComponent = (0, $N3oW3.default).forwardRef(function(props, ref) {
            return (0, $N3oW3.default).createElement(UncontrolledComponent, (0, $4dfb8f1fff0cbd5e$export$2e2bcd8739ae039)({}, props, {
                innerRef: ref,
                __source: {
                    fileName: $c71989f9de8f46b4$var$_jsxFileName,
                    lineNumber: 128
                },
                __self: this
            }));
        });
        WrappedComponent.propTypes = UncontrolledComponent.propTypes;
    }
    WrappedComponent.ControlledComponent = Component;
    /**
   * useful when wrapping a Component and you want to control
   * everything
   */ WrappedComponent.deferControlTo = function(newComponent, additions, nextMethods) {
        if (additions === void 0) additions = {};
        return $c71989f9de8f46b4$export$2e2bcd8739ae039(newComponent, (0, $4dfb8f1fff0cbd5e$export$2e2bcd8739ae039)({}, controlledValues, additions), nextMethods);
    };
    return WrappedComponent;
}




var $e756898da11911b9$var$toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
function $e756898da11911b9$export$2e2bcd8739ae039(element, selector) {
    return $e756898da11911b9$var$toArray(element.querySelectorAll(selector));
}



var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
function $0241506d38016947$export$2e2bcd8739ae039() {
    // The toggling state value is designed to defeat React optimizations for skipping
    // updates when they are strictly equal to the last state value
    const [, dispatch] = (0, $32rMB.useReducer)((revision)=>revision + 1, 0);
    return dispatch;
}


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
const $d800aaeb14770c37$var$toFnRef = (ref)=>!ref || typeof ref === 'function' ? ref : (value)=>{
        ref.current = value;
    };
function $d800aaeb14770c37$export$c9058316764c140e(refA, refB) {
    const a = $d800aaeb14770c37$var$toFnRef(refA);
    const b = $d800aaeb14770c37$var$toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $d800aaeb14770c37$var$useMergedRefs(refA, refB) {
    return (0, $32rMB.useMemo)(()=>$d800aaeb14770c37$export$c9058316764c140e(refA, refB), [
        refA,
        refB
    ]);
}
var $d800aaeb14770c37$export$2e2bcd8739ae039 = $d800aaeb14770c37$var$useMergedRefs;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
const $27d8cfedcb46ce62$var$NavContext = /*#__PURE__*/ $hO8yS.createContext(null);
$27d8cfedcb46ce62$var$NavContext.displayName = 'NavContext';
var $27d8cfedcb46ce62$export$2e2bcd8739ae039 = $27d8cfedcb46ce62$var$NavContext;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
const $6d2b91050fb01d0c$var$SelectableContext = /*#__PURE__*/ $hO8yS.createContext(null);
const $6d2b91050fb01d0c$export$eef49b42fde998a3 = (eventKey, href = null)=>{
    if (eventKey != null) return String(eventKey);
    return href || null;
};
var $6d2b91050fb01d0c$export$2e2bcd8739ae039 = $6d2b91050fb01d0c$var$SelectableContext;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
const $1a51b6abd67ab133$var$TabContext = /*#__PURE__*/ $hO8yS.createContext(null);
var $1a51b6abd67ab133$export$2e2bcd8739ae039 = $1a51b6abd67ab133$var$TabContext;


const $0eb79cb8e07f5ad3$export$fd7bcb7e9bef4e8a = `data-rr-ui-`;
const $0eb79cb8e07f5ad3$export$635202801f9383a0 = `rrUi`;
function $0eb79cb8e07f5ad3$export$5cc3b7b83e34ade7(property) {
    return `${$0eb79cb8e07f5ad3$export$fd7bcb7e9bef4e8a}${property}`;
}
function $0eb79cb8e07f5ad3$export$7776c0a7cd2eb3e0(property) {
    return `${$0eb79cb8e07f5ad3$export$635202801f9383a0}${property}`;
}



var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $af09b53ff15e420e$var$useCommittedRef(value) {
    const ref = (0, $32rMB.useRef)(value);
    (0, $32rMB.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $af09b53ff15e420e$export$2e2bcd8739ae039 = $af09b53ff15e420e$var$useCommittedRef;


function $68696f9faa27e86f$export$2e2bcd8739ae039(fn) {
    const ref = (0, $af09b53ff15e420e$export$2e2bcd8739ae039)(fn);
    return (0, $32rMB.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}








const $e5349015a17cca55$var$_excluded = [
    "as",
    "active",
    "eventKey"
];
function $e5349015a17cca55$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $e5349015a17cca55$export$d7a68693710982a({ key: key, onClick: onClick, active: active, id: id, role: role, disabled: disabled }) {
    const parentOnSelect = (0, $32rMB.useContext)((0, $6d2b91050fb01d0c$export$2e2bcd8739ae039));
    const navContext = (0, $32rMB.useContext)((0, $27d8cfedcb46ce62$export$2e2bcd8739ae039));
    const tabContext = (0, $32rMB.useContext)((0, $1a51b6abd67ab133$export$2e2bcd8739ae039));
    let isActive = active;
    const props = {
        role: role
    };
    if (navContext) {
        if (!role && navContext.role === 'tablist') props.role = 'tab';
        const contextControllerId = navContext.getControllerId(key != null ? key : null);
        const contextControlledId = navContext.getControlledId(key != null ? key : null);
        // @ts-ignore
        props[(0, $0eb79cb8e07f5ad3$export$5cc3b7b83e34ade7)('event-key')] = key;
        props.id = contextControllerId || id;
        isActive = active == null && key != null ? navContext.activeKey === key : active;
        /**
     * Simplified scenario for `mountOnEnter`.
     *
     * While it would make sense to keep 'aria-controls' for tabs that have been mounted at least
     * once, it would also complicate the code quite a bit, for very little gain.
     * The following implementation is probably good enough.
     *
     * @see https://github.com/react-restart/ui/pull/40#issuecomment-1009971561
     */ if (isActive || !(tabContext != null && tabContext.unmountOnExit) && !(tabContext != null && tabContext.mountOnEnter)) props['aria-controls'] = contextControlledId;
    }
    if (props.role === 'tab') {
        props['aria-selected'] = isActive;
        if (!isActive) props.tabIndex = -1;
        if (disabled) {
            props.tabIndex = -1;
            props['aria-disabled'] = true;
        }
    }
    props.onClick = (0, $68696f9faa27e86f$export$2e2bcd8739ae039)((e)=>{
        if (disabled) return;
        onClick == null || onClick(e);
        if (key == null) return;
        if (parentOnSelect && !e.isPropagationStopped()) parentOnSelect(key, e);
    });
    return [
        props,
        {
            isActive: isActive
        }
    ];
}
const $e5349015a17cca55$var$NavItem = /*#__PURE__*/ $N3oW3.forwardRef((_ref, ref)=>{
    let { as: Component = (0, $da03b6413f74f004$export$2e2bcd8739ae039), active: active, eventKey: eventKey } = _ref, options = $e5349015a17cca55$var$_objectWithoutPropertiesLoose(_ref, $e5349015a17cca55$var$_excluded);
    const [props, meta] = $e5349015a17cca55$export$d7a68693710982a(Object.assign({
        key: (0, $6d2b91050fb01d0c$export$eef49b42fde998a3)(eventKey, options.href),
        active: active
    }, options));
    // @ts-ignore
    props[(0, $0eb79cb8e07f5ad3$export$5cc3b7b83e34ade7)('active')] = meta.isActive;
    return /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)(Component, Object.assign({}, options, props, {
        ref: ref
    }));
});
$e5349015a17cca55$var$NavItem.displayName = 'NavItem';
var $e5349015a17cca55$export$2e2bcd8739ae039 = $e5349015a17cca55$var$NavItem;



const $ec0613a1593c8550$var$_excluded = [
    "as",
    "onSelect",
    "activeKey",
    "role",
    "onKeyDown"
];
function $ec0613a1593c8550$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $ec0613a1593c8550$var$noop = ()=>{};
const $ec0613a1593c8550$var$EVENT_KEY_ATTR = (0, $0eb79cb8e07f5ad3$export$5cc3b7b83e34ade7)('event-key');
const $ec0613a1593c8550$var$Nav = /*#__PURE__*/ $N3oW3.forwardRef((_ref, ref)=>{
    let { // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', onSelect: onSelect, activeKey: activeKey, role: role, onKeyDown: onKeyDown } = _ref, props = $ec0613a1593c8550$var$_objectWithoutPropertiesLoose(_ref, $ec0613a1593c8550$var$_excluded);
    // A ref and forceUpdate for refocus, b/c we only want to trigger when needed
    // and don't want to reset the set in the effect
    const forceUpdate = (0, $0241506d38016947$export$2e2bcd8739ae039)();
    const needsRefocusRef = (0, $32rMB.useRef)(false);
    const parentOnSelect = (0, $32rMB.useContext)((0, $6d2b91050fb01d0c$export$2e2bcd8739ae039));
    const tabContext = (0, $32rMB.useContext)((0, $1a51b6abd67ab133$export$2e2bcd8739ae039));
    let getControlledId, getControllerId;
    if (tabContext) {
        role = role || 'tablist';
        activeKey = tabContext.activeKey;
        // TODO: do we need to duplicate these?
        getControlledId = tabContext.getControlledId;
        getControllerId = tabContext.getControllerId;
    }
    const listNode = (0, $32rMB.useRef)(null);
    const getNextActiveTab = (offset)=>{
        const currentListNode = listNode.current;
        if (!currentListNode) return null;
        const items = (0, $e756898da11911b9$export$2e2bcd8739ae039)(currentListNode, `[${$ec0613a1593c8550$var$EVENT_KEY_ATTR}]:not([aria-disabled=true])`);
        const activeChild = currentListNode.querySelector('[aria-selected=true]');
        if (!activeChild || activeChild !== document.activeElement) return null;
        const index = items.indexOf(activeChild);
        if (index === -1) return null;
        let nextIndex = index + offset;
        if (nextIndex >= items.length) nextIndex = 0;
        if (nextIndex < 0) nextIndex = items.length - 1;
        return items[nextIndex];
    };
    const handleSelect = (key, event)=>{
        if (key == null) return;
        onSelect == null || onSelect(key, event);
        parentOnSelect == null || parentOnSelect(key, event);
    };
    const handleKeyDown = (event)=>{
        onKeyDown == null || onKeyDown(event);
        if (!tabContext) return;
        let nextActiveChild;
        switch(event.key){
            case 'ArrowLeft':
            case 'ArrowUp':
                nextActiveChild = getNextActiveTab(-1);
                break;
            case 'ArrowRight':
            case 'ArrowDown':
                nextActiveChild = getNextActiveTab(1);
                break;
            default:
                return;
        }
        if (!nextActiveChild) return;
        event.preventDefault();
        handleSelect(nextActiveChild.dataset[(0, $0eb79cb8e07f5ad3$export$7776c0a7cd2eb3e0)('EventKey')] || null, event);
        needsRefocusRef.current = true;
        forceUpdate();
    };
    (0, $32rMB.useEffect)(()=>{
        if (listNode.current && needsRefocusRef.current) {
            const activeChild = listNode.current.querySelector(`[${$ec0613a1593c8550$var$EVENT_KEY_ATTR}][aria-selected=true]`);
            activeChild == null || activeChild.focus();
        }
        needsRefocusRef.current = false;
    });
    const mergedRef = (0, $d800aaeb14770c37$export$2e2bcd8739ae039)(ref, listNode);
    return /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $6d2b91050fb01d0c$export$2e2bcd8739ae039).Provider, {
        value: handleSelect,
        children: /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $27d8cfedcb46ce62$export$2e2bcd8739ae039).Provider, {
            value: {
                role: role,
                // used by NavLink to determine it's role
                activeKey: (0, $6d2b91050fb01d0c$export$eef49b42fde998a3)(activeKey),
                getControlledId: getControlledId || $ec0613a1593c8550$var$noop,
                getControllerId: getControllerId || $ec0613a1593c8550$var$noop
            },
            children: /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)(Component, Object.assign({}, props, {
                onKeyDown: handleKeyDown,
                ref: mergedRef,
                role: role
            }))
        })
    });
});
$ec0613a1593c8550$var$Nav.displayName = 'Nav';
var $ec0613a1593c8550$export$2e2bcd8739ae039 = Object.assign($ec0613a1593c8550$var$Nav, {
    Item: (0, $e5349015a17cca55$export$2e2bcd8739ae039)
});





var $N3oW3 = parcelRequire("N3oW3");

parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $b3828e69dc470ca4$var$useCommittedRef(value) {
    const ref = (0, $32rMB.useRef)(value);
    (0, $32rMB.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $b3828e69dc470ca4$export$2e2bcd8739ae039 = $b3828e69dc470ca4$var$useCommittedRef;


function $2df5b52280a74552$export$2e2bcd8739ae039(fn) {
    const ref = (0, $b3828e69dc470ca4$export$2e2bcd8739ae039)(fn);
    return (0, $32rMB.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}






"use client";
const $fe6f0408a5725466$var$ListGroupItem = /*#__PURE__*/ $N3oW3.forwardRef(({ bsPrefix: bsPrefix, active: active, disabled: disabled, eventKey: eventKey, className: className, variant: variant, action: action, as: as, ...props }, ref)=>{
    bsPrefix = (0, $966d0ab785dd4154$export$7f387860ebffb32c)(bsPrefix, 'list-group-item');
    const [navItemProps, meta] = (0, $e5349015a17cca55$export$d7a68693710982a)({
        key: (0, $6d2b91050fb01d0c$export$eef49b42fde998a3)(eventKey, props.href),
        active: active,
        ...props
    });
    const handleClick = (0, $2df5b52280a74552$export$2e2bcd8739ae039)((event)=>{
        if (disabled) {
            event.preventDefault();
            event.stopPropagation();
            return;
        }
        navItemProps.onClick(event);
    });
    if (disabled && props.tabIndex === undefined) {
        props.tabIndex = -1;
        props['aria-disabled'] = true;
    }
    const Component = as || (action ? props.href ? 'a' : 'button' : 'div');
    return /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)(Component, {
        ref: ref,
        ...props,
        ...navItemProps,
        onClick: handleClick,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix, meta.isActive && 'active', disabled && 'disabled', variant && `${bsPrefix}-${variant}`, action && `${bsPrefix}-action`)
    });
});
$fe6f0408a5725466$var$ListGroupItem.displayName = 'ListGroupItem';
var $fe6f0408a5725466$export$2e2bcd8739ae039 = $fe6f0408a5725466$var$ListGroupItem;



"use client";
const $d5d534a7c63bc198$var$ListGroup = /*#__PURE__*/ $N3oW3.forwardRef((props, ref)=>{
    const { className: className, bsPrefix: initialBsPrefix, variant: variant, horizontal: horizontal, numbered: numbered, as: // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as = 'div', ...controlledProps } = (0, $0a5cdb039ef2f0e5$export$2e2bcd8739ae039)(props, {
        activeKey: 'onSelect'
    });
    const bsPrefix = (0, $966d0ab785dd4154$export$7f387860ebffb32c)(initialBsPrefix, 'list-group');
    let horizontalVariant;
    if (horizontal) horizontalVariant = horizontal === true ? 'horizontal' : `horizontal-${horizontal}`;
    return /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $ec0613a1593c8550$export$2e2bcd8739ae039), {
        ref: ref,
        ...controlledProps,
        as: as,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix, variant && `${bsPrefix}-${variant}`, horizontalVariant && `${bsPrefix}-${horizontalVariant}`, numbered && `${bsPrefix}-numbered`)
    });
});
$d5d534a7c63bc198$var$ListGroup.displayName = 'ListGroup';
var $d5d534a7c63bc198$export$2e2bcd8739ae039 = Object.assign($d5d534a7c63bc198$var$ListGroup, {
    Item: (0, $fe6f0408a5725466$export$2e2bcd8739ae039)
});


/* eslint-disable no-return-assign */ var $c36f36ded4bef1c0$export$2e2bcd8739ae039 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


var $7e72389cdcb8fa2e$export$63fefd044b2bc624 = false;
var $7e72389cdcb8fa2e$export$a614c6b395900f69 = false;
try {
    var $7e72389cdcb8fa2e$var$options = {
        get passive () {
            return $7e72389cdcb8fa2e$export$63fefd044b2bc624 = true;
        },
        get once () {
            // eslint-disable-next-line no-multi-assign
            return $7e72389cdcb8fa2e$export$a614c6b395900f69 = $7e72389cdcb8fa2e$export$63fefd044b2bc624 = true;
        }
    };
    if (0, $c36f36ded4bef1c0$export$2e2bcd8739ae039) {
        window.addEventListener('test', $7e72389cdcb8fa2e$var$options, $7e72389cdcb8fa2e$var$options);
        window.removeEventListener('test', $7e72389cdcb8fa2e$var$options, true);
    }
} catch (e) {
/* */ }
/**
 * An `addEventListener` ponyfill, supports the `once` option
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $7e72389cdcb8fa2e$var$addEventListener(node, eventName, handler, options) {
    if (options && typeof options !== 'boolean' && !$7e72389cdcb8fa2e$export$a614c6b395900f69) {
        var once = options.once, capture = options.capture;
        var wrappedHandler = handler;
        if (!$7e72389cdcb8fa2e$export$a614c6b395900f69 && once) {
            wrappedHandler = handler.__once || function onceHandler(event) {
                this.removeEventListener(eventName, onceHandler, capture);
                handler.call(this, event);
            };
            handler.__once = wrappedHandler;
        }
        node.addEventListener(eventName, wrappedHandler, $7e72389cdcb8fa2e$export$63fefd044b2bc624 ? options : capture);
    }
    node.addEventListener(eventName, handler, options);
}
var $7e72389cdcb8fa2e$export$2e2bcd8739ae039 = $7e72389cdcb8fa2e$var$addEventListener;



/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */ function $e2f451e3d449ae45$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


/**
 * A `removeEventListener` ponyfill
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $1570e8bef8c3dfba$var$removeEventListener(node, eventName, handler, options) {
    var capture = options && typeof options !== 'boolean' ? options.capture : options;
    node.removeEventListener(eventName, handler, capture);
    if (handler.__once) node.removeEventListener(eventName, handler.__once, capture);
}
var $1570e8bef8c3dfba$export$2e2bcd8739ae039 = $1570e8bef8c3dfba$var$removeEventListener;



var $9c19bd5bfd1a1a58$var$size;
function $9c19bd5bfd1a1a58$export$2e2bcd8739ae039(recalc) {
    if (!$9c19bd5bfd1a1a58$var$size && $9c19bd5bfd1a1a58$var$size !== 0 || recalc) {
        if (0, $c36f36ded4bef1c0$export$2e2bcd8739ae039) {
            var scrollDiv = document.createElement('div');
            scrollDiv.style.position = 'absolute';
            scrollDiv.style.top = '-9999px';
            scrollDiv.style.width = '50px';
            scrollDiv.style.height = '50px';
            scrollDiv.style.overflow = 'scroll';
            document.body.appendChild(scrollDiv);
            $9c19bd5bfd1a1a58$var$size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        }
    }
    return $9c19bd5bfd1a1a58$var$size;
}


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
function $8a04b79342a4a80a$export$2e2bcd8739ae039() {
    return (0, $32rMB.useState)(null);
}



parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
const $b91c05b18c44a18c$var$toFnRef = (ref)=>!ref || typeof ref === 'function' ? ref : (value)=>{
        ref.current = value;
    };
function $b91c05b18c44a18c$export$c9058316764c140e(refA, refB) {
    const a = $b91c05b18c44a18c$var$toFnRef(refA);
    const b = $b91c05b18c44a18c$var$toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $b91c05b18c44a18c$var$useMergedRefs(refA, refB) {
    return (0, $32rMB.useMemo)(()=>$b91c05b18c44a18c$export$c9058316764c140e(refA, refB), [
        refA,
        refB
    ]);
}
var $b91c05b18c44a18c$export$2e2bcd8739ae039 = $b91c05b18c44a18c$var$useMergedRefs;


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
function $1a068f802aa93c7d$export$2e2bcd8739ae039(value) {
    const valueRef = (0, $32rMB.useRef)(value);
    valueRef.current = value;
    return valueRef;
}


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
function $1437ece6b2d622f6$export$2e2bcd8739ae039(fn) {
    const onUnmount = (0, $1a068f802aa93c7d$export$2e2bcd8739ae039)(fn);
    (0, $32rMB.useEffect)(()=>()=>onUnmount.current(), []);
}



function $687967af0f2f65dd$export$2e2bcd8739ae039(node) {
    var doc = (0, $e2f451e3d449ae45$export$2e2bcd8739ae039)(node);
    return doc && doc.defaultView || window;
}


function $bab365215d6465d0$export$2e2bcd8739ae039(node, psuedoElement) {
    return (0, $687967af0f2f65dd$export$2e2bcd8739ae039)(node).getComputedStyle(node, psuedoElement);
}


/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */ var $bb45a00770e1e637$var$rUpper = /([A-Z])/g;
function $bb45a00770e1e637$export$2e2bcd8739ae039(string) {
    return string.replace($bb45a00770e1e637$var$rUpper, '-$1').toLowerCase();
}


var $b9e9e022259fd181$var$msPattern = /^ms-/;
function $b9e9e022259fd181$export$2e2bcd8739ae039(string) {
    return (0, $bb45a00770e1e637$export$2e2bcd8739ae039)(string).replace($b9e9e022259fd181$var$msPattern, '-ms-');
}


var $cfefa1cd0af90d26$var$supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function $cfefa1cd0af90d26$export$2e2bcd8739ae039(value) {
    return !!(value && $cfefa1cd0af90d26$var$supportedTransforms.test(value));
}


function $8e0039237f2a8b13$var$style(node, property) {
    var css = '';
    var transforms = '';
    if (typeof property === 'string') return node.style.getPropertyValue((0, $b9e9e022259fd181$export$2e2bcd8739ae039)(property)) || (0, $bab365215d6465d0$export$2e2bcd8739ae039)(node).getPropertyValue((0, $b9e9e022259fd181$export$2e2bcd8739ae039)(property));
    Object.keys(property).forEach(function(key) {
        var value = property[key];
        if (!value && value !== 0) node.style.removeProperty((0, $b9e9e022259fd181$export$2e2bcd8739ae039)(key));
        else if ((0, $cfefa1cd0af90d26$export$2e2bcd8739ae039)(key)) transforms += key + "(" + value + ") ";
        else css += (0, $b9e9e022259fd181$export$2e2bcd8739ae039)(key) + ": " + value + ";";
    });
    if (transforms) css += "transform: " + transforms + ";";
    node.style.cssText += ";" + css;
}
var $8e0039237f2a8b13$export$2e2bcd8739ae039 = $8e0039237f2a8b13$var$style;




function $e30c1a8b3e180f01$var$listen(node, eventName, handler, options) {
    (0, $7e72389cdcb8fa2e$export$2e2bcd8739ae039)(node, eventName, handler, options);
    return function() {
        (0, $1570e8bef8c3dfba$export$2e2bcd8739ae039)(node, eventName, handler, options);
    };
}
var $e30c1a8b3e180f01$export$2e2bcd8739ae039 = $e30c1a8b3e180f01$var$listen;


/**
 * Triggers an event on a given element.
 * 
 * @param node the element
 * @param eventName the event name to trigger
 * @param bubbles whether the event should bubble up
 * @param cancelable whether the event should be cancelable
 */ function $86531d9dcbce6c08$export$2e2bcd8739ae039(node, eventName, bubbles, cancelable) {
    if (bubbles === void 0) bubbles = false;
    if (cancelable === void 0) cancelable = true;
    if (node) {
        var event = document.createEvent('HTMLEvents');
        event.initEvent(eventName, bubbles, cancelable);
        node.dispatchEvent(event);
    }
}


function $d247f6e7f04e903f$var$parseDuration(node) {
    var str = (0, $8e0039237f2a8b13$export$2e2bcd8739ae039)(node, 'transitionDuration') || '';
    var mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $d247f6e7f04e903f$var$emulateTransitionEnd(element, duration, padding) {
    if (padding === void 0) padding = 5;
    var called = false;
    var handle = setTimeout(function() {
        if (!called) (0, $86531d9dcbce6c08$export$2e2bcd8739ae039)(element, 'transitionend', true);
    }, duration + padding);
    var remove = (0, $e30c1a8b3e180f01$export$2e2bcd8739ae039)(element, 'transitionend', function() {
        called = true;
    }, {
        once: true
    });
    return function() {
        clearTimeout(handle);
        remove();
    };
}
function $d247f6e7f04e903f$export$2e2bcd8739ae039(element, handler, duration, padding) {
    if (duration == null) duration = $d247f6e7f04e903f$var$parseDuration(element) || 0;
    var removeEmulate = $d247f6e7f04e903f$var$emulateTransitionEnd(element, duration, padding);
    var remove = (0, $e30c1a8b3e180f01$export$2e2bcd8739ae039)(element, 'transitionend', handler);
    return function() {
        removeEmulate();
        remove();
    };
}



var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");

function $7928c6e4d5223063$export$2e2bcd8739ae039(doc) {
    if (doc === void 0) doc = (0, $e2f451e3d449ae45$export$2e2bcd8739ae039)();
    // Support: IE 9 only
    // IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
    try {
        var active = doc.activeElement; // IE11 returns a seemingly empty object in some cases when accessing
        // document.activeElement from an <iframe>
        if (!active || !active.nodeName) return null;
        return active;
    } catch (e) {
        /* ie throws if no active element */ return doc.body;
    }
}


/* eslint-disable no-bitwise, no-cond-assign */ /**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */ function $97c75dca58f4c376$export$2e2bcd8739ae039(context, node) {
    // HTML DOM and SVG DOM may have different support levels,
    // so we need to check on context instead of a document root element.
    if (context.contains) return context.contains(node);
    if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}





var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");

var $N3oW3 = parcelRequire("N3oW3");
parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
function $2b5645f46c1d9ddf$export$2e2bcd8739ae039() {
    const mounted = (0, $32rMB.useRef)(true);
    const isMounted = (0, $32rMB.useRef)(()=>mounted.current);
    (0, $32rMB.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
function $74fb7c3fdb458908$export$2e2bcd8739ae039(value) {
    const valueRef = (0, $32rMB.useRef)(value);
    valueRef.current = value;
    return valueRef;
}


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
function $0bb9172946169e36$export$2e2bcd8739ae039(fn) {
    const onUnmount = (0, $74fb7c3fdb458908$export$2e2bcd8739ae039)(fn);
    (0, $32rMB.useEffect)(()=>()=>onUnmount.current(), []);
}


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
function $063c4c2d2d30bbad$export$2e2bcd8739ae039(value) {
    const ref = (0, $32rMB.useRef)(null);
    (0, $32rMB.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
}





/**
 * Get the width of the vertical window scrollbar if it's visible
 */ function $377f60235b0f4616$export$2e2bcd8739ae039(ownerDocument = document) {
    const window = ownerDocument.defaultView;
    return Math.abs(window.innerWidth - ownerDocument.documentElement.clientWidth);
}


const $d74cfc51808fc4b5$export$1a88c12b8b979fa0 = (0, $0eb79cb8e07f5ad3$export$5cc3b7b83e34ade7)('modal-open');
/**
 * Manages a stack of Modals as well as ensuring
 * body scrolling is is disabled and padding accounted for
 */ class $d74cfc51808fc4b5$var$ModalManager {
    constructor({ ownerDocument: ownerDocument, handleContainerOverflow: handleContainerOverflow = true, isRTL: isRTL = false } = {}){
        this.handleContainerOverflow = handleContainerOverflow;
        this.isRTL = isRTL;
        this.modals = [];
        this.ownerDocument = ownerDocument;
    }
    getScrollbarWidth() {
        return (0, $377f60235b0f4616$export$2e2bcd8739ae039)(this.ownerDocument);
    }
    getElement() {
        return (this.ownerDocument || document).body;
    }
    setModalAttributes(_modal) {
    // For overriding
    }
    removeModalAttributes(_modal) {
    // For overriding
    }
    setContainerStyle(containerState) {
        const style = {
            overflow: 'hidden'
        };
        // we are only interested in the actual `style` here
        // because we will override it
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const container = this.getElement();
        containerState.style = {
            overflow: container.style.overflow,
            [paddingProp]: container.style[paddingProp]
        };
        if (containerState.scrollBarWidth) // use computed style, here to get the real padding
        // to add our scrollbar width
        style[paddingProp] = `${parseInt((0, $8e0039237f2a8b13$export$2e2bcd8739ae039)(container, paddingProp) || '0', 10) + containerState.scrollBarWidth}px`;
        container.setAttribute($d74cfc51808fc4b5$export$1a88c12b8b979fa0, '');
        (0, $8e0039237f2a8b13$export$2e2bcd8739ae039)(container, style);
    }
    reset() {
        [
            ...this.modals
        ].forEach((m)=>this.remove(m));
    }
    removeContainerStyle(containerState) {
        const container = this.getElement();
        container.removeAttribute($d74cfc51808fc4b5$export$1a88c12b8b979fa0);
        Object.assign(container.style, containerState.style);
    }
    add(modal) {
        let modalIdx = this.modals.indexOf(modal);
        if (modalIdx !== -1) return modalIdx;
        modalIdx = this.modals.length;
        this.modals.push(modal);
        this.setModalAttributes(modal);
        if (modalIdx !== 0) return modalIdx;
        this.state = {
            scrollBarWidth: this.getScrollbarWidth(),
            style: {}
        };
        if (this.handleContainerOverflow) this.setContainerStyle(this.state);
        return modalIdx;
    }
    remove(modal) {
        const modalIdx = this.modals.indexOf(modal);
        if (modalIdx === -1) return;
        this.modals.splice(modalIdx, 1);
        // if that was the last modal in a container,
        // clean up the container
        if (!this.modals.length && this.handleContainerOverflow) this.removeContainerStyle(this.state);
        this.removeModalAttributes(modal);
    }
    isTopModal(modal) {
        return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
    }
}
var $d74cfc51808fc4b5$export$2e2bcd8739ae039 = $d74cfc51808fc4b5$var$ModalManager;




parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $32rMB = parcelRequire("32rMB");

const $b21c870bad316c41$var$Context = /*#__PURE__*/ (0, $hO8yS.createContext)((0, $c36f36ded4bef1c0$export$2e2bcd8739ae039) ? window : undefined);
const $b21c870bad316c41$export$f7d306aeb1cf5fbc = $b21c870bad316c41$var$Context.Provider;
function $b21c870bad316c41$export$2e2bcd8739ae039() {
    return (0, $32rMB.useContext)($b21c870bad316c41$var$Context);
}


const $7e516195c77a0c62$export$c91fd81e6d65f84a = (ref, document)=>{
    if (!(0, $c36f36ded4bef1c0$export$2e2bcd8739ae039)) return null;
    if (ref == null) return (document || (0, $e2f451e3d449ae45$export$2e2bcd8739ae039)()).body;
    if (typeof ref === 'function') ref = ref();
    if (ref && 'current' in ref) ref = ref.current;
    if (ref && ('nodeType' in ref || ref.getBoundingClientRect)) return ref;
    return null;
};
function $7e516195c77a0c62$export$2e2bcd8739ae039(ref, onResolved) {
    const window = (0, $b21c870bad316c41$export$2e2bcd8739ae039)();
    const [resolvedRef, setRef] = (0, $32rMB.useState)(()=>$7e516195c77a0c62$export$c91fd81e6d65f84a(ref, window == null ? void 0 : window.document));
    if (!resolvedRef) {
        const earlyRef = $7e516195c77a0c62$export$c91fd81e6d65f84a(ref);
        if (earlyRef) setRef(earlyRef);
    }
    (0, $32rMB.useEffect)(()=>{
        if (onResolved && resolvedRef) onResolved(resolvedRef);
    }, [
        onResolved,
        resolvedRef
    ]);
    (0, $32rMB.useEffect)(()=>{
        const nextRef = $7e516195c77a0c62$export$c91fd81e6d65f84a(ref);
        if (nextRef !== resolvedRef) setRef(nextRef);
    }, [
        ref,
        resolvedRef
    ]);
    return resolvedRef;
}





parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
const $901ab6643cb69fc5$var$isReactNative = typeof $parcel$global !== 'undefined' && // @ts-ignore
$parcel$global.navigator && // @ts-ignore
$parcel$global.navigator.product === 'ReactNative';
const $901ab6643cb69fc5$var$isDOM = typeof document !== 'undefined';
var /**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ $901ab6643cb69fc5$export$2e2bcd8739ae039 = $901ab6643cb69fc5$var$isDOM || $901ab6643cb69fc5$var$isReactNative ? (0, $32rMB.useLayoutEffect) : (0, $32rMB.useEffect);



var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");



var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");

var $N3oW3 = parcelRequire("N3oW3");
function $a5ebb00982d95d8c$export$806fcc22e55e107d(e) {
    return e.code === 'Escape' || e.keyCode === 27;
}
function $a5ebb00982d95d8c$export$13e065f3a74cfe36() {
    const parts = $N3oW3.version.split('.');
    return {
        major: +parts[0],
        minor: +parts[1],
        patch: +parts[2]
    };
}
function $a5ebb00982d95d8c$export$87943f2672146d57(element) {
    if (!element || typeof element === 'function') return null;
    const { major: major } = $a5ebb00982d95d8c$export$13e065f3a74cfe36();
    const childRef = major >= 19 ? element.props.ref : element.ref;
    return childRef;
}


function $bc48773adb9f4195$var$NoopTransition({ children: children, in: inProp, onExited: onExited, mountOnEnter: mountOnEnter, unmountOnExit: unmountOnExit }) {
    const ref = (0, $32rMB.useRef)(null);
    const hasEnteredRef = (0, $32rMB.useRef)(inProp);
    const handleExited = (0, $68696f9faa27e86f$export$2e2bcd8739ae039)(onExited);
    (0, $32rMB.useEffect)(()=>{
        if (inProp) hasEnteredRef.current = true;
        else handleExited(ref.current);
    }, [
        inProp,
        handleExited
    ]);
    const combinedRef = (0, $d800aaeb14770c37$export$2e2bcd8739ae039)(ref, (0, $a5ebb00982d95d8c$export$87943f2672146d57)(children));
    const child = /*#__PURE__*/ (0, $N3oW3.cloneElement)(children, {
        ref: combinedRef
    });
    if (inProp) return child;
    if (unmountOnExit) return null;
    if (!hasEnteredRef.current && mountOnEnter) return null;
    return child;
}
var $bc48773adb9f4195$export$2e2bcd8739ae039 = $bc48773adb9f4195$var$NoopTransition;



var $N3oW3 = parcelRequire("N3oW3");

var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");


const $77ac3929f29a6745$var$_excluded = [
    "onEnter",
    "onEntering",
    "onEntered",
    "onExit",
    "onExiting",
    "onExited",
    "addEndListener",
    "children"
];
function $77ac3929f29a6745$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $77ac3929f29a6745$export$2e2bcd8739ae039(_ref) {
    let { onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, addEndListener: addEndListener, children: children } = _ref, props = $77ac3929f29a6745$var$_objectWithoutPropertiesLoose(_ref, $77ac3929f29a6745$var$_excluded);
    const nodeRef = (0, $32rMB.useRef)(null);
    const mergedRef = (0, $d800aaeb14770c37$export$2e2bcd8739ae039)(nodeRef, (0, $a5ebb00982d95d8c$export$87943f2672146d57)(children));
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    /* eslint-disable react-hooks/exhaustive-deps */ const handleEnter = (0, $32rMB.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, $32rMB.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, $32rMB.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, $32rMB.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, $32rMB.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, $32rMB.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, $32rMB.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return Object.assign({}, props, {
        nodeRef: nodeRef
    }, onEnter && {
        onEnter: handleEnter
    }, onEntering && {
        onEntering: handleEntering
    }, onEntered && {
        onEntered: handleEntered
    }, onExit && {
        onExit: handleExit
    }, onExiting && {
        onExiting: handleExiting
    }, onExited && {
        onExited: handleExited
    }, addEndListener && {
        addEndListener: handleAddEndListener
    }, {
        children: typeof children === 'function' ? (status, innerProps)=>// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, Object.assign({}, innerProps, {
                ref: mergedRef
            })) : /*#__PURE__*/ (0, $N3oW3.cloneElement)(children, {
            ref: mergedRef
        })
    });
}



const $c39e6557dc7d435d$var$_excluded = [
    "component"
];
function $c39e6557dc7d435d$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// Normalizes Transition callbacks when nodeRef is used.
const $c39e6557dc7d435d$var$RTGTransition = /*#__PURE__*/ $N3oW3.forwardRef((_ref, ref)=>{
    let { component: Component } = _ref, props = $c39e6557dc7d435d$var$_objectWithoutPropertiesLoose(_ref, $c39e6557dc7d435d$var$_excluded);
    const transitionProps = (0, $77ac3929f29a6745$export$2e2bcd8739ae039)(props);
    return /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)(Component, Object.assign({
        ref: ref
    }, transitionProps));
});
var $c39e6557dc7d435d$export$2e2bcd8739ae039 = $c39e6557dc7d435d$var$RTGTransition;




function $ddc0af6642e1c288$export$7b286972b8d8ccbf({ in: inProp, onTransition: onTransition }) {
    const ref = (0, $32rMB.useRef)(null);
    const isInitialRef = (0, $32rMB.useRef)(true);
    const handleTransition = (0, $68696f9faa27e86f$export$2e2bcd8739ae039)(onTransition);
    (0, $901ab6643cb69fc5$export$2e2bcd8739ae039)(()=>{
        if (!ref.current) return undefined;
        let stale = false;
        handleTransition({
            in: inProp,
            element: ref.current,
            initial: isInitialRef.current,
            isStale: ()=>stale
        });
        return ()=>{
            stale = true;
        };
    }, [
        inProp,
        handleTransition
    ]);
    (0, $901ab6643cb69fc5$export$2e2bcd8739ae039)(()=>{
        isInitialRef.current = false;
        // this is for strict mode
        return ()=>{
            isInitialRef.current = true;
        };
    }, []);
    return ref;
}
function $ddc0af6642e1c288$export$2e2bcd8739ae039({ children: children, in: inProp, onExited: onExited, onEntered: onEntered, transition: transition }) {
    const [exited, setExited] = (0, $32rMB.useState)(!inProp);
    // TODO: I think this needs to be in an effect
    if (inProp && exited) setExited(false);
    const ref = $ddc0af6642e1c288$export$7b286972b8d8ccbf({
        in: !!inProp,
        onTransition: (options)=>{
            const onFinish = ()=>{
                if (options.isStale()) return;
                if (options.in) onEntered == null || onEntered(options.element, options.initial);
                else {
                    setExited(true);
                    onExited == null || onExited(options.element);
                }
            };
            Promise.resolve(transition(options)).then(onFinish, (error)=>{
                if (!options.in) setExited(true);
                throw error;
            });
        }
    });
    const combinedRef = (0, $d800aaeb14770c37$export$2e2bcd8739ae039)(ref, (0, $a5ebb00982d95d8c$export$87943f2672146d57)(children));
    return exited && !inProp ? null : /*#__PURE__*/ (0, $N3oW3.cloneElement)(children, {
        ref: combinedRef
    });
}
function $ddc0af6642e1c288$export$f41d64aae6d6dba5(component, runTransition, props) {
    if (component) return /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $c39e6557dc7d435d$export$2e2bcd8739ae039), Object.assign({}, props, {
        component: component
    }));
    if (runTransition) return /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($ddc0af6642e1c288$export$2e2bcd8739ae039, Object.assign({}, props, {
        transition: runTransition
    }));
    return /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $bc48773adb9f4195$export$2e2bcd8739ae039), Object.assign({}, props));
}




var $hO8yS = parcelRequire("hO8yS");
const $b441b1c2dfdbc52c$var$_excluded = [
    "show",
    "role",
    "className",
    "style",
    "children",
    "backdrop",
    "keyboard",
    "onBackdropClick",
    "onEscapeKeyDown",
    "transition",
    "runTransition",
    "backdropTransition",
    "runBackdropTransition",
    "autoFocus",
    "enforceFocus",
    "restoreFocus",
    "restoreFocusOptions",
    "renderDialog",
    "renderBackdrop",
    "manager",
    "container",
    "onShow",
    "onHide",
    "onExit",
    "onExited",
    "onExiting",
    "onEnter",
    "onEntering",
    "onEntered"
];
function $b441b1c2dfdbc52c$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
let $b441b1c2dfdbc52c$var$manager;
/*
  Modal props are split into a version with and without index signature so that you can fully use them in another projects
  This is due to Typescript not playing well with index signatures e.g. when using Omit
*/ function $b441b1c2dfdbc52c$var$getManager(window) {
    if (!$b441b1c2dfdbc52c$var$manager) $b441b1c2dfdbc52c$var$manager = new (0, $d74cfc51808fc4b5$export$2e2bcd8739ae039)({
        ownerDocument: window == null ? void 0 : window.document
    });
    return $b441b1c2dfdbc52c$var$manager;
}
function $b441b1c2dfdbc52c$var$useModalManager(provided) {
    const window = (0, $b21c870bad316c41$export$2e2bcd8739ae039)();
    const modalManager = provided || $b441b1c2dfdbc52c$var$getManager(window);
    const modal = (0, $32rMB.useRef)({
        dialog: null,
        backdrop: null
    });
    return Object.assign(modal.current, {
        add: ()=>modalManager.add(modal.current),
        remove: ()=>modalManager.remove(modal.current),
        isTopModal: ()=>modalManager.isTopModal(modal.current),
        setDialogRef: (0, $32rMB.useCallback)((ref)=>{
            modal.current.dialog = ref;
        }, []),
        setBackdropRef: (0, $32rMB.useCallback)((ref)=>{
            modal.current.backdrop = ref;
        }, [])
    });
}
const $b441b1c2dfdbc52c$var$Modal = /*#__PURE__*/ (0, $N3oW3.forwardRef)((_ref, ref)=>{
    let { show: show = false, role: role = 'dialog', className: className, style: style, children: children, backdrop: backdrop = true, keyboard: keyboard = true, onBackdropClick: onBackdropClick, onEscapeKeyDown: onEscapeKeyDown, transition: transition, runTransition: runTransition, backdropTransition: backdropTransition, runBackdropTransition: runBackdropTransition, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, renderDialog: renderDialog, renderBackdrop: renderBackdrop = (props)=>/*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("div", Object.assign({}, props)), manager: providedManager, container: containerRef, onShow: onShow, onHide: onHide = ()=>{}, onExit: onExit, onExited: onExited, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered } = _ref, rest = $b441b1c2dfdbc52c$var$_objectWithoutPropertiesLoose(_ref, $b441b1c2dfdbc52c$var$_excluded);
    const ownerWindow = (0, $b21c870bad316c41$export$2e2bcd8739ae039)();
    const container = (0, $7e516195c77a0c62$export$2e2bcd8739ae039)(containerRef);
    const modal = $b441b1c2dfdbc52c$var$useModalManager(providedManager);
    const isMounted = (0, $2b5645f46c1d9ddf$export$2e2bcd8739ae039)();
    const prevShow = (0, $063c4c2d2d30bbad$export$2e2bcd8739ae039)(show);
    const [exited, setExited] = (0, $32rMB.useState)(!show);
    const lastFocusRef = (0, $32rMB.useRef)(null);
    (0, $32rMB.useImperativeHandle)(ref, ()=>modal, [
        modal
    ]);
    if ((0, $c36f36ded4bef1c0$export$2e2bcd8739ae039) && !prevShow && show) lastFocusRef.current = (0, $7928c6e4d5223063$export$2e2bcd8739ae039)(ownerWindow == null ? void 0 : ownerWindow.document);
    // TODO: I think this needs to be in an effect
    if (show && exited) setExited(false);
    const handleShow = (0, $68696f9faa27e86f$export$2e2bcd8739ae039)(()=>{
        modal.add();
        removeKeydownListenerRef.current = (0, $e30c1a8b3e180f01$export$2e2bcd8739ae039)(document, 'keydown', handleDocumentKeyDown);
        removeFocusListenerRef.current = (0, $e30c1a8b3e180f01$export$2e2bcd8739ae039)(document, 'focus', // the timeout is necessary b/c this will run before the new modal is mounted
        // and so steals focus from it
        ()=>setTimeout(handleEnforceFocus), true);
        if (onShow) onShow();
        // autofocus after onShow to not trigger a focus event for previous
        // modals before this one is shown.
        if (autoFocus) {
            var _modal$dialog$ownerDo, _modal$dialog;
            const currentActiveElement = (0, $7928c6e4d5223063$export$2e2bcd8739ae039)((_modal$dialog$ownerDo = (_modal$dialog = modal.dialog) == null ? void 0 : _modal$dialog.ownerDocument) != null ? _modal$dialog$ownerDo : ownerWindow == null ? void 0 : ownerWindow.document);
            if (modal.dialog && currentActiveElement && !(0, $97c75dca58f4c376$export$2e2bcd8739ae039)(modal.dialog, currentActiveElement)) {
                lastFocusRef.current = currentActiveElement;
                modal.dialog.focus();
            }
        }
    });
    const handleHide = (0, $68696f9faa27e86f$export$2e2bcd8739ae039)(()=>{
        modal.remove();
        removeKeydownListenerRef.current == null || removeKeydownListenerRef.current();
        removeFocusListenerRef.current == null || removeFocusListenerRef.current();
        if (restoreFocus) {
            var _lastFocusRef$current;
            // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
            (_lastFocusRef$current = lastFocusRef.current) == null || _lastFocusRef$current.focus == null || _lastFocusRef$current.focus(restoreFocusOptions);
            lastFocusRef.current = null;
        }
    });
    // TODO: try and combine these effects: https://github.com/react-bootstrap/react-overlays/pull/794#discussion_r409954120
    // Show logic when:
    //  - show is `true` _and_ `container` has resolved
    (0, $32rMB.useEffect)(()=>{
        if (!show || !container) return;
        handleShow();
    }, [
        show,
        container,
        /* should never change: */ handleShow
    ]);
    // Hide cleanup logic when:
    //  - `exited` switches to true
    //  - component unmounts;
    (0, $32rMB.useEffect)(()=>{
        if (!exited) return;
        handleHide();
    }, [
        exited,
        handleHide
    ]);
    (0, $0bb9172946169e36$export$2e2bcd8739ae039)(()=>{
        handleHide();
    });
    // --------------------------------
    const handleEnforceFocus = (0, $68696f9faa27e86f$export$2e2bcd8739ae039)(()=>{
        if (!enforceFocus || !isMounted() || !modal.isTopModal()) return;
        const currentActiveElement = (0, $7928c6e4d5223063$export$2e2bcd8739ae039)(ownerWindow == null ? void 0 : ownerWindow.document);
        if (modal.dialog && currentActiveElement && !(0, $97c75dca58f4c376$export$2e2bcd8739ae039)(modal.dialog, currentActiveElement)) modal.dialog.focus();
    });
    const handleBackdropClick = (0, $68696f9faa27e86f$export$2e2bcd8739ae039)((e)=>{
        if (e.target !== e.currentTarget) return;
        onBackdropClick == null || onBackdropClick(e);
        if (backdrop === true) onHide();
    });
    const handleDocumentKeyDown = (0, $68696f9faa27e86f$export$2e2bcd8739ae039)((e)=>{
        if (keyboard && (0, $a5ebb00982d95d8c$export$806fcc22e55e107d)(e) && modal.isTopModal()) {
            onEscapeKeyDown == null || onEscapeKeyDown(e);
            if (!e.defaultPrevented) onHide();
        }
    });
    const removeFocusListenerRef = (0, $32rMB.useRef)();
    const removeKeydownListenerRef = (0, $32rMB.useRef)();
    const handleHidden = (...args)=>{
        setExited(true);
        onExited == null || onExited(...args);
    };
    if (!container) return null;
    const dialogProps = Object.assign({
        role: role,
        ref: modal.setDialogRef,
        // apparently only works on the dialog role element
        'aria-modal': role === 'dialog' ? true : undefined
    }, rest, {
        style: style,
        className: className,
        tabIndex: -1
    });
    let dialog = renderDialog ? renderDialog(dialogProps) : /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("div", Object.assign({}, dialogProps, {
        children: /*#__PURE__*/ $N3oW3.cloneElement(children, {
            role: 'document'
        })
    }));
    dialog = (0, $ddc0af6642e1c288$export$f41d64aae6d6dba5)(transition, runTransition, {
        unmountOnExit: true,
        mountOnEnter: true,
        appear: true,
        in: !!show,
        onExit: onExit,
        onExiting: onExiting,
        onExited: handleHidden,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        children: dialog
    });
    let backdropElement = null;
    if (backdrop) {
        backdropElement = renderBackdrop({
            ref: modal.setBackdropRef,
            onClick: handleBackdropClick
        });
        backdropElement = (0, $ddc0af6642e1c288$export$f41d64aae6d6dba5)(backdropTransition, runBackdropTransition, {
            in: !!show,
            appear: true,
            mountOnEnter: true,
            unmountOnExit: true,
            children: backdropElement
        });
    }
    return /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $hO8yS.Fragment), {
        children: /*#__PURE__*/ (0, $N3oW3.default).createPortal(/*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $hO8yS.Fragment), {
            children: [
                backdropElement,
                dialog
            ]
        }), container)
    });
});
$b441b1c2dfdbc52c$var$Modal.displayName = 'Modal';
var $b441b1c2dfdbc52c$export$2e2bcd8739ae039 = Object.assign($b441b1c2dfdbc52c$var$Modal, {
    Manager: (0, $d74cfc51808fc4b5$export$2e2bcd8739ae039)
});


/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $bb7f18969320ba30$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}


function $da42d038f708cdd8$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $bb7f18969320ba30$export$2e2bcd8739ae039)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}




function $9bb1922ade4b5d1d$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function $9bb1922ade4b5d1d$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $9bb1922ade4b5d1d$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $9bb1922ade4b5d1d$var$replaceClassName(element.className && element.className.baseVal || '', className));
}



const $42994831cbd4e2e4$var$Selector = {
    FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
    STICKY_CONTENT: '.sticky-top',
    NAVBAR_TOGGLER: '.navbar-toggler'
};
class $42994831cbd4e2e4$var$BootstrapModalManager extends (0, $d74cfc51808fc4b5$export$2e2bcd8739ae039) {
    adjustAndStore(prop, element, adjust) {
        const actual = element.style[prop];
        // @ts-expect-error TODO: DOMStringMap and CSSStyleDeclaration aren't strictly compatible
        element.dataset[prop] = actual;
        (0, $8e0039237f2a8b13$export$2e2bcd8739ae039)(element, {
            [prop]: `${parseFloat((0, $8e0039237f2a8b13$export$2e2bcd8739ae039)(element, prop)) + adjust}px`
        });
    }
    restore(prop, element) {
        const value = element.dataset[prop];
        if (value !== undefined) {
            delete element.dataset[prop];
            (0, $8e0039237f2a8b13$export$2e2bcd8739ae039)(element, {
                [prop]: value
            });
        }
    }
    setContainerStyle(containerState) {
        super.setContainerStyle(containerState);
        const container = this.getElement();
        (0, $da42d038f708cdd8$export$2e2bcd8739ae039)(container, 'modal-open');
        if (!containerState.scrollBarWidth) return;
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
        (0, $e756898da11911b9$export$2e2bcd8739ae039)(container, $42994831cbd4e2e4$var$Selector.FIXED_CONTENT).forEach((el)=>this.adjustAndStore(paddingProp, el, containerState.scrollBarWidth));
        (0, $e756898da11911b9$export$2e2bcd8739ae039)(container, $42994831cbd4e2e4$var$Selector.STICKY_CONTENT).forEach((el)=>this.adjustAndStore(marginProp, el, -containerState.scrollBarWidth));
        (0, $e756898da11911b9$export$2e2bcd8739ae039)(container, $42994831cbd4e2e4$var$Selector.NAVBAR_TOGGLER).forEach((el)=>this.adjustAndStore(marginProp, el, containerState.scrollBarWidth));
    }
    removeContainerStyle(containerState) {
        super.removeContainerStyle(containerState);
        const container = this.getElement();
        (0, $9bb1922ade4b5d1d$export$2e2bcd8739ae039)(container, 'modal-open');
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
        (0, $e756898da11911b9$export$2e2bcd8739ae039)(container, $42994831cbd4e2e4$var$Selector.FIXED_CONTENT).forEach((el)=>this.restore(paddingProp, el));
        (0, $e756898da11911b9$export$2e2bcd8739ae039)(container, $42994831cbd4e2e4$var$Selector.STICKY_CONTENT).forEach((el)=>this.restore(marginProp, el));
        (0, $e756898da11911b9$export$2e2bcd8739ae039)(container, $42994831cbd4e2e4$var$Selector.NAVBAR_TOGGLER).forEach((el)=>this.restore(marginProp, el));
    }
}
let $42994831cbd4e2e4$var$sharedManager;
function $42994831cbd4e2e4$export$a03641438014b436(options) {
    if (!$42994831cbd4e2e4$var$sharedManager) $42994831cbd4e2e4$var$sharedManager = new $42994831cbd4e2e4$var$BootstrapModalManager(options);
    return $42994831cbd4e2e4$var$sharedManager;
}
var $42994831cbd4e2e4$export$2e2bcd8739ae039 = $42994831cbd4e2e4$var$BootstrapModalManager;




var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");




var $N3oW3 = parcelRequire("N3oW3");

var $N3oW3 = parcelRequire("N3oW3");
var $f6cbeee4dd506344$export$2e2bcd8739ae039 = {
    disabled: false
};




var $N3oW3 = parcelRequire("N3oW3");
var $92d6dc7f2da8e9e6$export$2e2bcd8739ae039 = (0, $N3oW3.default).createContext(null);


var $c7b2ab26231cb28f$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $78dd13198da4f165$export$bb38bb9a1161268 = 'unmounted';
var $78dd13198da4f165$export$84cbff306f539230 = 'exited';
var $78dd13198da4f165$export$df38205c966be359 = 'entering';
var $78dd13198da4f165$export$78e9e6e3e014d60a = 'entered';
var $78dd13198da4f165$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $78dd13198da4f165$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $5122792117adb82d$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $78dd13198da4f165$export$84cbff306f539230;
                _this.appearStatus = $78dd13198da4f165$export$df38205c966be359;
            } else initialStatus = $78dd13198da4f165$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $78dd13198da4f165$export$bb38bb9a1161268;
        else initialStatus = $78dd13198da4f165$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $78dd13198da4f165$export$bb38bb9a1161268) return {
            status: $78dd13198da4f165$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $78dd13198da4f165$export$df38205c966be359 && status !== $78dd13198da4f165$export$78e9e6e3e014d60a) nextStatus = $78dd13198da4f165$export$df38205c966be359;
            } else if (status === $78dd13198da4f165$export$df38205c966be359 || status === $78dd13198da4f165$export$78e9e6e3e014d60a) nextStatus = $78dd13198da4f165$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $78dd13198da4f165$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, $N3oW3.default).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $c7b2ab26231cb28f$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $78dd13198da4f165$export$84cbff306f539230) this.setState({
            status: $78dd13198da4f165$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, $N3oW3.default).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $f6cbeee4dd506344$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $78dd13198da4f165$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $78dd13198da4f165$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $78dd13198da4f165$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, $N3oW3.default).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $f6cbeee4dd506344$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $78dd13198da4f165$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $78dd13198da4f165$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $78dd13198da4f165$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, $N3oW3.default).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $78dd13198da4f165$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $a396812ba85d91d0$export$2e2bcd8739ae039)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, $N3oW3.default).createElement((0, $92d6dc7f2da8e9e6$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, $N3oW3.default).cloneElement((0, $N3oW3.default).Children.only(children), childProps)));
    };
    return Transition;
}((0, $N3oW3.default).Component);
$78dd13198da4f165$var$Transition.contextType = (0, $92d6dc7f2da8e9e6$export$2e2bcd8739ae039);
$78dd13198da4f165$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $78dd13198da4f165$var$noop() {}
$78dd13198da4f165$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $78dd13198da4f165$var$noop,
    onEntering: $78dd13198da4f165$var$noop,
    onEntered: $78dd13198da4f165$var$noop,
    onExit: $78dd13198da4f165$var$noop,
    onExiting: $78dd13198da4f165$var$noop,
    onExited: $78dd13198da4f165$var$noop
};
$78dd13198da4f165$var$Transition.UNMOUNTED = $78dd13198da4f165$export$bb38bb9a1161268;
$78dd13198da4f165$var$Transition.EXITED = $78dd13198da4f165$export$84cbff306f539230;
$78dd13198da4f165$var$Transition.ENTERING = $78dd13198da4f165$export$df38205c966be359;
$78dd13198da4f165$var$Transition.ENTERED = $78dd13198da4f165$export$78e9e6e3e014d60a;
$78dd13198da4f165$var$Transition.EXITING = $78dd13198da4f165$export$4aacc83d4d59139f;
var $78dd13198da4f165$export$2e2bcd8739ae039 = $78dd13198da4f165$var$Transition;





function $a8b66f384fc1b4cd$var$parseDuration(node, property) {
    const str = (0, $8e0039237f2a8b13$export$2e2bcd8739ae039)(node, property) || '';
    const mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $a8b66f384fc1b4cd$export$2e2bcd8739ae039(element, handler) {
    const duration = $a8b66f384fc1b4cd$var$parseDuration(element, 'transitionDuration');
    const delay = $a8b66f384fc1b4cd$var$parseDuration(element, 'transitionDelay');
    const remove = (0, $d247f6e7f04e903f$export$2e2bcd8739ae039)(element, (e)=>{
        if (e.target === element) {
            remove();
            handler(e);
        }
    }, duration + delay);
}


// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
function $214cbfb1d5ffaa80$export$2e2bcd8739ae039(node) {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    node.offsetHeight;
}



var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");



var $N3oW3 = parcelRequire("N3oW3");
function $d126c6fb847a6110$export$2e2bcd8739ae039(componentOrElement) {
    if (componentOrElement && 'setState' in componentOrElement) // TODO: Remove in next major.
    // eslint-disable-next-line react/no-find-dom-node
    return (0, $N3oW3.default).findDOMNode(componentOrElement);
    return componentOrElement != null ? componentOrElement : null;
}



"use client";
// Normalizes Transition callbacks when nodeRef is used.
const $cffcad425741e9a4$var$TransitionWrapper = /*#__PURE__*/ (0, $N3oW3.default).forwardRef(({ onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, addEndListener: addEndListener, children: children, childRef: childRef, ...props }, ref)=>{
    const nodeRef = (0, $32rMB.useRef)(null);
    const mergedRef = (0, $b91c05b18c44a18c$export$2e2bcd8739ae039)(nodeRef, childRef);
    const attachRef = (r)=>{
        mergedRef((0, $d126c6fb847a6110$export$2e2bcd8739ae039)(r));
    };
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    const handleEnter = (0, $32rMB.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, $32rMB.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, $32rMB.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, $32rMB.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, $32rMB.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, $32rMB.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, $32rMB.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    return /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $78dd13198da4f165$export$2e2bcd8739ae039), {
        ref: ref,
        ...props,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        children: typeof children === 'function' ? (status, innerProps)=>// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, {
                ...innerProps,
                ref: attachRef
            }) : /*#__PURE__*/ (0, $N3oW3.default).cloneElement(children, {
            ref: attachRef
        })
    });
});
$cffcad425741e9a4$var$TransitionWrapper.displayName = 'TransitionWrapper';
var $cffcad425741e9a4$export$2e2bcd8739ae039 = $cffcad425741e9a4$var$TransitionWrapper;



const $0d9aee9639f47a0c$var$fadeStyles = {
    [(0, $78dd13198da4f165$export$df38205c966be359)]: 'show',
    [(0, $78dd13198da4f165$export$78e9e6e3e014d60a)]: 'show'
};
const $0d9aee9639f47a0c$var$Fade = /*#__PURE__*/ $N3oW3.forwardRef(({ className: className, children: children, transitionClasses: transitionClasses = {}, onEnter: onEnter, ...rest }, ref)=>{
    const props = {
        in: false,
        timeout: 300,
        mountOnEnter: false,
        unmountOnExit: false,
        appear: false,
        ...rest
    };
    const handleEnter = (0, $32rMB.useCallback)((node, isAppearing)=>{
        (0, $214cbfb1d5ffaa80$export$2e2bcd8739ae039)(node);
        onEnter == null || onEnter(node, isAppearing);
    }, [
        onEnter
    ]);
    return /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $cffcad425741e9a4$export$2e2bcd8739ae039), {
        ref: ref,
        addEndListener: (0, $a8b66f384fc1b4cd$export$2e2bcd8739ae039),
        ...props,
        onEnter: handleEnter,
        childRef: (0, $a5ebb00982d95d8c$export$87943f2672146d57)(children),
        children: (status, innerProps)=>/*#__PURE__*/ $N3oW3.cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('fade', className, children.props.className, $0d9aee9639f47a0c$var$fadeStyles[status], transitionClasses[status])
            })
    });
});
$0d9aee9639f47a0c$var$Fade.displayName = 'Fade';
var $0d9aee9639f47a0c$export$2e2bcd8739ae039 = $0d9aee9639f47a0c$var$Fade;



var $N3oW3 = parcelRequire("N3oW3");



"use client";
const $25cce779e7f3ae7d$var$ModalBody = /*#__PURE__*/ $N3oW3.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $966d0ab785dd4154$export$7f387860ebffb32c)(bsPrefix, 'modal-body');
    return /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$25cce779e7f3ae7d$var$ModalBody.displayName = 'ModalBody';
var $25cce779e7f3ae7d$export$2e2bcd8739ae039 = $25cce779e7f3ae7d$var$ModalBody;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
"use client";
const $1907d7ab2a83d96c$var$ModalContext = /*#__PURE__*/ $hO8yS.createContext({
    onHide () {}
});
var $1907d7ab2a83d96c$export$2e2bcd8739ae039 = $1907d7ab2a83d96c$var$ModalContext;




var $N3oW3 = parcelRequire("N3oW3");


"use client";
const $493d3c91083ec45a$var$ModalDialog = /*#__PURE__*/ $N3oW3.forwardRef(({ bsPrefix: bsPrefix, className: className, contentClassName: contentClassName, centered: centered, size: size, fullscreen: fullscreen, children: children, scrollable: scrollable, ...props }, ref)=>{
    bsPrefix = (0, $966d0ab785dd4154$export$7f387860ebffb32c)(bsPrefix, 'modal');
    const dialogClass = `${bsPrefix}-dialog`;
    const fullScreenClass = typeof fullscreen === 'string' ? `${bsPrefix}-fullscreen-${fullscreen}` : `${bsPrefix}-fullscreen`;
    return /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("div", {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(dialogClass, className, size && `${bsPrefix}-${size}`, centered && `${dialogClass}-centered`, scrollable && `${dialogClass}-scrollable`, fullscreen && fullScreenClass),
        children: /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(`${bsPrefix}-content`, contentClassName),
            children: children
        })
    });
});
$493d3c91083ec45a$var$ModalDialog.displayName = 'ModalDialog';
var $493d3c91083ec45a$export$2e2bcd8739ae039 = $493d3c91083ec45a$var$ModalDialog;



var $N3oW3 = parcelRequire("N3oW3");



"use client";
const $546a0a12aef521b2$var$ModalFooter = /*#__PURE__*/ $N3oW3.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $966d0ab785dd4154$export$7f387860ebffb32c)(bsPrefix, 'modal-footer');
    return /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$546a0a12aef521b2$var$ModalFooter.displayName = 'ModalFooter';
var $546a0a12aef521b2$export$2e2bcd8739ae039 = $546a0a12aef521b2$var$ModalFooter;




var $N3oW3 = parcelRequire("N3oW3");


var $N3oW3 = parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");




"use client";
const $9829631bd03ad17b$var$AbstractModalHeader = /*#__PURE__*/ $N3oW3.forwardRef(({ closeLabel: closeLabel = 'Close', closeVariant: closeVariant, closeButton: closeButton = false, onHide: onHide, children: children, ...props }, ref)=>{
    const context = (0, $32rMB.useContext)((0, $1907d7ab2a83d96c$export$2e2bcd8739ae039));
    const handleClick = (0, $2df5b52280a74552$export$2e2bcd8739ae039)(()=>{
        context == null || context.onHide();
        onHide == null || onHide();
    });
    return /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("div", {
        ref: ref,
        ...props,
        children: [
            children,
            closeButton && /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $25f7395c3ada3645$export$2e2bcd8739ae039), {
                "aria-label": closeLabel,
                variant: closeVariant,
                onClick: handleClick
            })
        ]
    });
});
$9829631bd03ad17b$var$AbstractModalHeader.displayName = 'AbstractModalHeader';
var $9829631bd03ad17b$export$2e2bcd8739ae039 = $9829631bd03ad17b$var$AbstractModalHeader;



"use client";
const $526bfaa2fedc36ca$var$ModalHeader = /*#__PURE__*/ $N3oW3.forwardRef(({ bsPrefix: bsPrefix, className: className, closeLabel: closeLabel = 'Close', closeButton: closeButton = false, ...props }, ref)=>{
    bsPrefix = (0, $966d0ab785dd4154$export$7f387860ebffb32c)(bsPrefix, 'modal-header');
    return /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $9829631bd03ad17b$export$2e2bcd8739ae039), {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        closeLabel: closeLabel,
        closeButton: closeButton
    });
});
$526bfaa2fedc36ca$var$ModalHeader.displayName = 'ModalHeader';
var $526bfaa2fedc36ca$export$2e2bcd8739ae039 = $526bfaa2fedc36ca$var$ModalHeader;



var $N3oW3 = parcelRequire("N3oW3");


var $N3oW3 = parcelRequire("N3oW3");


var $e8e2e8ffe672697a$export$2e2bcd8739ae039 = (className)=>/*#__PURE__*/ // eslint-disable-next-line react/display-name
    $N3oW3.forwardRef((p, ref)=>/*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("div", {
            ...p,
            ref: ref,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(p.className, className)
        }));




"use client";
const $8542659f580cc26d$var$DivStyledAsH4 = (0, $e8e2e8ffe672697a$export$2e2bcd8739ae039)('h4');
const $8542659f580cc26d$var$ModalTitle = /*#__PURE__*/ $N3oW3.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $8542659f580cc26d$var$DivStyledAsH4, ...props }, ref)=>{
    bsPrefix = (0, $966d0ab785dd4154$export$7f387860ebffb32c)(bsPrefix, 'modal-title');
    return /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$8542659f580cc26d$var$ModalTitle.displayName = 'ModalTitle';
var $8542659f580cc26d$export$2e2bcd8739ae039 = $8542659f580cc26d$var$ModalTitle;




"use client";
function $8cc4069d2715af29$var$DialogTransition(props) {
    return /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $0d9aee9639f47a0c$export$2e2bcd8739ae039), {
        ...props,
        timeout: null
    });
}
function $8cc4069d2715af29$var$BackdropTransition(props) {
    return /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $0d9aee9639f47a0c$export$2e2bcd8739ae039), {
        ...props,
        timeout: null
    });
}
const $8cc4069d2715af29$var$Modal = /*#__PURE__*/ $N3oW3.forwardRef(({ bsPrefix: bsPrefix, className: className, style: style, dialogClassName: dialogClassName, contentClassName: contentClassName, children: children, dialogAs: Dialog = (0, $493d3c91083ec45a$export$2e2bcd8739ae039), 'data-bs-theme': dataBsTheme, 'aria-labelledby': ariaLabelledby, 'aria-describedby': ariaDescribedby, 'aria-label': ariaLabel, show: /* BaseModal props */ show = false, animation: animation = true, backdrop: backdrop = true, keyboard: keyboard = true, onEscapeKeyDown: onEscapeKeyDown, onShow: onShow, onHide: onHide, container: container, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onExited: onExited, backdropClassName: backdropClassName, manager: propsManager, ...props }, ref)=>{
    const [modalStyle, setStyle] = (0, $32rMB.useState)({});
    const [animateStaticModal, setAnimateStaticModal] = (0, $32rMB.useState)(false);
    const waitingForMouseUpRef = (0, $32rMB.useRef)(false);
    const ignoreBackdropClickRef = (0, $32rMB.useRef)(false);
    const removeStaticModalAnimationRef = (0, $32rMB.useRef)(null);
    const [modal, setModalRef] = (0, $8a04b79342a4a80a$export$2e2bcd8739ae039)();
    const mergedRef = (0, $b91c05b18c44a18c$export$2e2bcd8739ae039)(ref, setModalRef);
    const handleHide = (0, $2df5b52280a74552$export$2e2bcd8739ae039)(onHide);
    const isRTL = (0, $966d0ab785dd4154$export$35e511eefa30ac5a)();
    bsPrefix = (0, $966d0ab785dd4154$export$7f387860ebffb32c)(bsPrefix, 'modal');
    const modalContext = (0, $32rMB.useMemo)(()=>({
            onHide: handleHide
        }), [
        handleHide
    ]);
    function getModalManager() {
        if (propsManager) return propsManager;
        return (0, $42994831cbd4e2e4$export$a03641438014b436)({
            isRTL: isRTL
        });
    }
    function updateDialogStyle(node) {
        if (!(0, $c36f36ded4bef1c0$export$2e2bcd8739ae039)) return;
        const containerIsOverflowing = getModalManager().getScrollbarWidth() > 0;
        const modalIsOverflowing = node.scrollHeight > (0, $e2f451e3d449ae45$export$2e2bcd8739ae039)(node).documentElement.clientHeight;
        setStyle({
            paddingRight: containerIsOverflowing && !modalIsOverflowing ? (0, $9c19bd5bfd1a1a58$export$2e2bcd8739ae039)() : undefined,
            paddingLeft: !containerIsOverflowing && modalIsOverflowing ? (0, $9c19bd5bfd1a1a58$export$2e2bcd8739ae039)() : undefined
        });
    }
    const handleWindowResize = (0, $2df5b52280a74552$export$2e2bcd8739ae039)(()=>{
        if (modal) updateDialogStyle(modal.dialog);
    });
    (0, $1437ece6b2d622f6$export$2e2bcd8739ae039)(()=>{
        (0, $1570e8bef8c3dfba$export$2e2bcd8739ae039)(window, 'resize', handleWindowResize);
        removeStaticModalAnimationRef.current == null || removeStaticModalAnimationRef.current();
    });
    // We prevent the modal from closing during a drag by detecting where the
    // click originates from. If it starts in the modal and then ends outside
    // don't close.
    const handleDialogMouseDown = ()=>{
        waitingForMouseUpRef.current = true;
    };
    const handleMouseUp = (e)=>{
        if (waitingForMouseUpRef.current && modal && e.target === modal.dialog) ignoreBackdropClickRef.current = true;
        waitingForMouseUpRef.current = false;
    };
    const handleStaticModalAnimation = ()=>{
        setAnimateStaticModal(true);
        removeStaticModalAnimationRef.current = (0, $d247f6e7f04e903f$export$2e2bcd8739ae039)(modal.dialog, ()=>{
            setAnimateStaticModal(false);
        });
    };
    const handleStaticBackdropClick = (e)=>{
        if (e.target !== e.currentTarget) return;
        handleStaticModalAnimation();
    };
    const handleClick = (e)=>{
        if (backdrop === 'static') {
            handleStaticBackdropClick(e);
            return;
        }
        if (ignoreBackdropClickRef.current || e.target !== e.currentTarget) {
            ignoreBackdropClickRef.current = false;
            return;
        }
        onHide == null || onHide();
    };
    const handleEscapeKeyDown = (e)=>{
        if (keyboard) onEscapeKeyDown == null || onEscapeKeyDown(e);
        else {
            // Call preventDefault to stop modal from closing in @restart/ui.
            e.preventDefault();
            if (backdrop === 'static') // Play static modal animation.
            handleStaticModalAnimation();
        }
    };
    const handleEnter = (node, isAppearing)=>{
        if (node) updateDialogStyle(node);
        onEnter == null || onEnter(node, isAppearing);
    };
    const handleExit = (node)=>{
        removeStaticModalAnimationRef.current == null || removeStaticModalAnimationRef.current();
        onExit == null || onExit(node);
    };
    const handleEntering = (node, isAppearing)=>{
        onEntering == null || onEntering(node, isAppearing);
        // FIXME: This should work even when animation is disabled.
        (0, $7e72389cdcb8fa2e$export$2e2bcd8739ae039)(window, 'resize', handleWindowResize);
    };
    const handleExited = (node)=>{
        if (node) node.style.display = ''; // RHL removes it sometimes
        onExited == null || onExited(node);
        // FIXME: This should work even when animation is disabled.
        (0, $1570e8bef8c3dfba$export$2e2bcd8739ae039)(window, 'resize', handleWindowResize);
    };
    const renderBackdrop = (0, $32rMB.useCallback)((backdropProps)=>/*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("div", {
            ...backdropProps,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(`${bsPrefix}-backdrop`, backdropClassName, !animation && 'show')
        }), [
        animation,
        backdropClassName,
        bsPrefix
    ]);
    const baseModalStyle = {
        ...style,
        ...modalStyle
    };
    // If `display` is not set to block, autoFocus inside the modal fails
    // https://github.com/react-bootstrap/react-bootstrap/issues/5102
    baseModalStyle.display = 'block';
    const renderDialog = (dialogProps)=>/*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("div", {
            role: "dialog",
            ...dialogProps,
            style: baseModalStyle,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix, animateStaticModal && `${bsPrefix}-static`, !animation && 'show'),
            onClick: backdrop ? handleClick : undefined,
            onMouseUp: handleMouseUp,
            "data-bs-theme": dataBsTheme,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledby,
            "aria-describedby": ariaDescribedby,
            children: /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)(Dialog, {
                ...props,
                onMouseDown: handleDialogMouseDown,
                className: dialogClassName,
                contentClassName: contentClassName,
                children: children
            })
        });
    return /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $1907d7ab2a83d96c$export$2e2bcd8739ae039).Provider, {
        value: modalContext,
        children: /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $b441b1c2dfdbc52c$export$2e2bcd8739ae039), {
            show: show,
            ref: mergedRef,
            backdrop: backdrop,
            container: container,
            keyboard: true // Always set true - see handleEscapeKeyDown
            ,
            autoFocus: autoFocus,
            enforceFocus: enforceFocus,
            restoreFocus: restoreFocus,
            restoreFocusOptions: restoreFocusOptions,
            onEscapeKeyDown: handleEscapeKeyDown,
            onShow: onShow,
            onHide: onHide,
            onEnter: handleEnter,
            onEntering: handleEntering,
            onEntered: onEntered,
            onExit: handleExit,
            onExiting: onExiting,
            onExited: handleExited,
            manager: getModalManager(),
            transition: animation ? $8cc4069d2715af29$var$DialogTransition : undefined,
            backdropTransition: animation ? $8cc4069d2715af29$var$BackdropTransition : undefined,
            renderBackdrop: renderBackdrop,
            renderDialog: renderDialog
        })
    });
});
$8cc4069d2715af29$var$Modal.displayName = 'Modal';
var $8cc4069d2715af29$export$2e2bcd8739ae039 = Object.assign($8cc4069d2715af29$var$Modal, {
    Body: (0, $25cce779e7f3ae7d$export$2e2bcd8739ae039),
    Header: (0, $526bfaa2fedc36ca$export$2e2bcd8739ae039),
    Title: (0, $8542659f580cc26d$export$2e2bcd8739ae039),
    Footer: (0, $546a0a12aef521b2$export$2e2bcd8739ae039),
    Dialog: (0, $493d3c91083ec45a$export$2e2bcd8739ae039),
    TRANSITION_DURATION: 300,
    BACKDROP_TRANSITION_DURATION: 150
});



var $N3oW3 = parcelRequire("N3oW3");



var $N3oW3 = parcelRequire("N3oW3");

var $N3oW3 = parcelRequire("N3oW3");
parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
function $dd051a031965c7a7$export$2e2bcd8739ae039() {
    return (0, $32rMB.useState)(null);
}




parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");

function $b50b27c84464ec25$export$2e2bcd8739ae039(eventTarget, event, listener, capture = false) {
    const handler = (0, $68696f9faa27e86f$export$2e2bcd8739ae039)(listener);
    (0, $32rMB.useEffect)(()=>{
        const target = typeof eventTarget === 'function' ? eventTarget() : eventTarget;
        target.addEventListener(event, handler, capture);
        return ()=>target.removeEventListener(event, handler, capture);
    }, [
        eventTarget
    ]);
}



parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
function $6d832248ebd92ab3$export$2e2bcd8739ae039(event, handler, capture = false) {
    const documentTarget = (0, $32rMB.useCallback)(()=>document, []);
    return (0, $b50b27c84464ec25$export$2e2bcd8739ae039)(documentTarget, event, handler, capture);
}


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");

/**
 * Creates a `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  function Timer() {
 *    const [timer, setTimer] = useState(0)
 *    useInterval(() => setTimer(i => i + 1), 1000)
 *
 *    return <span>{timer} seconds past</span>
 *  }
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 */ /**
 * Creates a pausable `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [paused, setPaused] = useState(false)
 *  const [timer, setTimer] = useState(0)
 *
 *  useInterval(() => setTimer(i => i + 1), 1000, paused)
 *
 *  return (
 *    <span>
 *      {timer} seconds past
 *
 *      <button onClick={() => setPaused(p => !p)}>{paused ? 'Play' : 'Pause' }</button>
 *    </span>
 * )
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 */ /**
 * Creates a pausable `setInterval` that _fires_ immediately and is
 * properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [timer, setTimer] = useState(-1)
 *  useInterval(() => setTimer(i => i + 1), 1000, false, true)
 *
 *  // will update to 0 on the first effect
 *  return <span>{timer} seconds past</span>
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 * @param runImmediately Whether to run the function immediately on mount or unpause
 * rather than waiting for the first interval to elapse
 *

 */ function $08b1b490277d1ee0$var$useInterval(fn, ms, paused = false, runImmediately = false) {
    let handle;
    const fnRef = (0, $af09b53ff15e420e$export$2e2bcd8739ae039)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    const pausedRef = (0, $af09b53ff15e420e$export$2e2bcd8739ae039)(paused);
    const tick = ()=>{
        if (pausedRef.current) return;
        fnRef.current();
        schedule(); // eslint-disable-line no-use-before-define
    };
    const schedule = ()=>{
        clearTimeout(handle);
        handle = setTimeout(tick, ms);
    };
    (0, $32rMB.useEffect)(()=>{
        if (runImmediately) tick();
        else schedule();
        return ()=>clearTimeout(handle);
    }, [
        paused,
        runImmediately
    ]);
}
var $08b1b490277d1ee0$export$2e2bcd8739ae039 = $08b1b490277d1ee0$var$useInterval;


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");

function $1c376c75712f6e29$var$useRafInterval(fn, ms, paused = false) {
    let handle;
    let start = new Date().getTime();
    const fnRef = (0, $af09b53ff15e420e$export$2e2bcd8739ae039)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    const pausedRef = (0, $af09b53ff15e420e$export$2e2bcd8739ae039)(paused);
    function loop() {
        const current = new Date().getTime();
        const delta = current - start;
        if (pausedRef.current) return;
        if (delta >= ms && fnRef.current) {
            fnRef.current();
            start = new Date().getTime();
        }
        cancelAnimationFrame(handle);
        handle = requestAnimationFrame(loop);
    }
    (0, $32rMB.useEffect)(()=>{
        handle = requestAnimationFrame(loop);
        return ()=>cancelAnimationFrame(handle);
    }, []);
}
var $1c376c75712f6e29$export$2e2bcd8739ae039 = $1c376c75712f6e29$var$useRafInterval;


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
function $817b09f10f7d8182$export$2e2bcd8739ae039(initialState) {
    const [state, setState] = (0, $32rMB.useState)(initialState);
    const updater = (0, $32rMB.useCallback)((update)=>{
        if (update === null) return;
        if (typeof update === 'function') setState((state)=>{
            const nextState = update(state);
            return nextState == null ? state : Object.assign({}, state, nextState);
        });
        else setState((state)=>Object.assign({}, state, update));
    }, [
        setState
    ]);
    return [
        state,
        updater
    ];
}



function $d93f0463ed481b26$export$2e2bcd8739ae039(props, gDSFP, initialState) {
    const [state, setState] = (0, $817b09f10f7d8182$export$2e2bcd8739ae039)(initialState);
    const nextState = gDSFP(props, state);
    if (nextState !== null) setState(nextState);
    return [
        state,
        setState
    ];
}




parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");
function $40a60acc26343d7f$export$2e2bcd8739ae039(imageOrUrl, crossOrigin) {
    const [state, setState] = (0, $32rMB.useState)({
        image: null,
        error: null
    });
    (0, $32rMB.useEffect)(()=>{
        if (!imageOrUrl) return undefined;
        let image;
        if (typeof imageOrUrl === 'string') {
            image = new Image();
            if (crossOrigin) image.crossOrigin = crossOrigin;
            image.src = imageOrUrl;
        } else {
            image = imageOrUrl;
            if (image.complete && image.naturalHeight > 0) {
                setState({
                    image: image,
                    error: null
                });
                return;
            }
        }
        function onLoad() {
            setState({
                image: image,
                error: null
            });
        }
        function onError(error) {
            setState({
                image: image,
                error: error
            });
        }
        image.addEventListener('load', onLoad);
        image.addEventListener('error', onError);
        return ()=>{
            image.removeEventListener('load', onLoad);
            image.removeEventListener('error', onError);
        };
    }, [
        imageOrUrl,
        crossOrigin
    ]);
    return state;
}


parcelRequire("N3oW3");
var $32rMB = parcelRequire("32rMB");

const $a5b9167c659492aa$var$targetMap = new WeakMap();
let $a5b9167c659492aa$var$resizeObserver;
function $a5b9167c659492aa$var$getResizeObserver() {
    // eslint-disable-next-line no-return-assign
    return $a5b9167c659492aa$var$resizeObserver = $a5b9167c659492aa$var$resizeObserver || new window.ResizeObserver((entries)=>{
        entries.forEach((entry)=>{
            const handler = $a5b9167c659492aa$var$targetMap.get(entry.target);
            if (handler) handler(entry.contentRect);
        });
    });
}
function $a5b9167c659492aa$export$2e2bcd8739ae039(element) {
    const [rect, setRect] = (0, $32rMB.useState)(null);
    (0, $901ab6643cb69fc5$export$2e2bcd8739ae039)(()=>{
        if (!element) return;
        $a5b9167c659492aa$var$getResizeObserver().observe(element);
        setRect(element.getBoundingClientRect());
        $a5b9167c659492aa$var$targetMap.set(element, (rect)=>{
            setRect(rect);
        });
        return ()=>{
            $a5b9167c659492aa$var$targetMap.delete(element);
        };
    }, [
        element
    ]);
    return rect;
}






const $478a5e562b19945c$var$_excluded = [
    "onKeyDown"
];
function $478a5e562b19945c$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $478a5e562b19945c$export$72369ab2cc99204b(href) {
    return !href || href.trim() === '#';
}
/**
 * An generic `<a>` component that covers a few A11y cases, ensuring that
 * cases where the `href` is missing or trivial like "#" are treated like buttons.
 */ const $478a5e562b19945c$var$Anchor = /*#__PURE__*/ $N3oW3.forwardRef((_ref, ref)=>{
    let { onKeyDown: onKeyDown } = _ref, props = $478a5e562b19945c$var$_objectWithoutPropertiesLoose(_ref, $478a5e562b19945c$var$_excluded);
    const [buttonProps] = (0, $da03b6413f74f004$export$a0ee72f2c720a5c3)(Object.assign({
        tagName: 'a'
    }, props));
    const handleKeyDown = (0, $68696f9faa27e86f$export$2e2bcd8739ae039)((e)=>{
        buttonProps.onKeyDown(e);
        onKeyDown == null || onKeyDown(e);
    });
    if ($478a5e562b19945c$export$72369ab2cc99204b(props.href) || props.role === 'button') return /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("a", Object.assign({
        ref: ref
    }, props, buttonProps, {
        onKeyDown: handleKeyDown
    }));
    return /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("a", Object.assign({
        ref: ref
    }, props, {
        onKeyDown: onKeyDown
    }));
});
$478a5e562b19945c$var$Anchor.displayName = 'Anchor';
var $478a5e562b19945c$export$2e2bcd8739ae039 = $478a5e562b19945c$var$Anchor;



const $c9fdd9d501e77b9d$var$PageItem = /*#__PURE__*/ $N3oW3.forwardRef(({ active: active = false, disabled: disabled = false, className: className, style: style, activeLabel: activeLabel = '(current)', children: children, linkStyle: linkStyle, linkClassName: linkClassName, as: as = (0, $478a5e562b19945c$export$2e2bcd8739ae039), ...props }, ref)=>{
    const Component = active || disabled ? 'span' : as;
    return /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("li", {
        ref: ref,
        style: style,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, 'page-item', {
            active: active,
            disabled: disabled
        }),
        children: /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)(Component, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('page-link', linkClassName),
            style: linkStyle,
            ...props,
            children: [
                children,
                active && activeLabel && /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("span", {
                    className: "visually-hidden",
                    children: activeLabel
                })
            ]
        })
    });
});
$c9fdd9d501e77b9d$var$PageItem.displayName = 'PageItem';
var $c9fdd9d501e77b9d$export$2e2bcd8739ae039 = $c9fdd9d501e77b9d$var$PageItem;
function $c9fdd9d501e77b9d$var$createButton(name, defaultValue, label = name) {
    const Button = /*#__PURE__*/ $N3oW3.forwardRef(({ children: children, ...props }, ref)=>/*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($c9fdd9d501e77b9d$var$PageItem, {
            ...props,
            ref: ref,
            children: [
                /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("span", {
                    "aria-hidden": "true",
                    children: children || defaultValue
                }),
                /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("span", {
                    className: "visually-hidden",
                    children: label
                })
            ]
        }));
    Button.displayName = name;
    return Button;
}
const $c9fdd9d501e77b9d$export$b25abba66f7be210 = $c9fdd9d501e77b9d$var$createButton('First', "\xab");
const $c9fdd9d501e77b9d$export$1b265216817111b9 = $c9fdd9d501e77b9d$var$createButton('Prev', "\u2039", 'Previous');
const $c9fdd9d501e77b9d$export$1297970233533a7d = $c9fdd9d501e77b9d$var$createButton('Ellipsis', "\u2026", 'More');
const $c9fdd9d501e77b9d$export$b820fc49f2736e85 = $c9fdd9d501e77b9d$var$createButton('Next', "\u203A");
const $c9fdd9d501e77b9d$export$bed9238d8933c9a8 = $c9fdd9d501e77b9d$var$createButton('Last', "\xbb");



"use client";
const $99a4e9403f4f1ccb$var$Pagination = /*#__PURE__*/ $N3oW3.forwardRef(({ bsPrefix: bsPrefix, className: className, size: size, ...props }, ref)=>{
    const decoratedBsPrefix = (0, $966d0ab785dd4154$export$7f387860ebffb32c)(bsPrefix, 'pagination');
    return /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("ul", {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, decoratedBsPrefix, size && `${decoratedBsPrefix}-${size}`)
    });
});
$99a4e9403f4f1ccb$var$Pagination.displayName = 'Pagination';
var $99a4e9403f4f1ccb$export$2e2bcd8739ae039 = Object.assign($99a4e9403f4f1ccb$var$Pagination, {
    First: $c9fdd9d501e77b9d$export$b25abba66f7be210,
    Prev: $c9fdd9d501e77b9d$export$1b265216817111b9,
    Ellipsis: $c9fdd9d501e77b9d$export$1297970233533a7d,
    Item: (0, $c9fdd9d501e77b9d$export$2e2bcd8739ae039),
    Next: $c9fdd9d501e77b9d$export$b820fc49f2736e85,
    Last: $c9fdd9d501e77b9d$export$bed9238d8933c9a8
});



var $N3oW3 = parcelRequire("N3oW3");


"use client";
const $999d941606fa59dc$var$Spinner = /*#__PURE__*/ $N3oW3.forwardRef(({ bsPrefix: bsPrefix, variant: variant, animation: animation = 'border', size: size, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', className: className, ...props }, ref)=>{
    bsPrefix = (0, $966d0ab785dd4154$export$7f387860ebffb32c)(bsPrefix, 'spinner');
    const bsSpinnerPrefix = `${bsPrefix}-${animation}`;
    return /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsSpinnerPrefix, size && `${bsSpinnerPrefix}-${size}`, variant && `text-${variant}`)
    });
});
$999d941606fa59dc$var$Spinner.displayName = 'Spinner';
var $999d941606fa59dc$export$2e2bcd8739ae039 = $999d941606fa59dc$var$Spinner;



var $N3oW3 = parcelRequire("N3oW3");


"use client";
const $972aa4b18ce22626$var$Table = /*#__PURE__*/ $N3oW3.forwardRef(({ bsPrefix: bsPrefix, className: className, striped: striped, bordered: bordered, borderless: borderless, hover: hover, size: size, variant: variant, responsive: responsive, ...props }, ref)=>{
    const decoratedBsPrefix = (0, $966d0ab785dd4154$export$7f387860ebffb32c)(bsPrefix, 'table');
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, decoratedBsPrefix, variant && `${decoratedBsPrefix}-${variant}`, size && `${decoratedBsPrefix}-${size}`, striped && `${decoratedBsPrefix}-${typeof striped === 'string' ? `striped-${striped}` : 'striped'}`, bordered && `${decoratedBsPrefix}-bordered`, borderless && `${decoratedBsPrefix}-borderless`, hover && `${decoratedBsPrefix}-hover`);
    const table = /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("table", {
        ...props,
        className: classes,
        ref: ref
    });
    if (responsive) {
        let responsiveClass = `${decoratedBsPrefix}-responsive`;
        if (typeof responsive === 'string') responsiveClass = `${responsiveClass}-${responsive}`;
        return /*#__PURE__*/ (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("div", {
            className: responsiveClass,
            children: table
        });
    }
    return table;
});
$972aa4b18ce22626$var$Table.displayName = 'Table';
var $972aa4b18ce22626$export$2e2bcd8739ae039 = $972aa4b18ce22626$var$Table;








var $8fdeac7b23d8f90e$export$71511d61b312f219;
"use strict";

$8fdeac7b23d8f90e$export$71511d61b312f219 = (parcelRequire("gkQP3")).__generator;




var $d5I5D = parcelRequire("d5I5D");


var $8a4b9e1682f367e1$export$71511d61b312f219;
"use strict";
var $d99f4a016ac4e7a1$export$71511d61b312f219;
"use strict";
function $d99f4a016ac4e7a1$var$_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
$d99f4a016ac4e7a1$export$71511d61b312f219 = $d99f4a016ac4e7a1$var$_array_with_holes;



var $fcf9c8c2e7d5c043$export$71511d61b312f219;
"use strict";
function $fcf9c8c2e7d5c043$var$_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$fcf9c8c2e7d5c043$export$71511d61b312f219 = $fcf9c8c2e7d5c043$var$_non_iterable_rest;



function $8a4b9e1682f367e1$var$_to_array(arr) {
    return $d99f4a016ac4e7a1$export$71511d61b312f219(arr) || $12645b8195910e7b$export$71511d61b312f219(arr) || $ee22f18d51655989$export$71511d61b312f219(arr) || $fcf9c8c2e7d5c043$export$71511d61b312f219();
}
$8a4b9e1682f367e1$export$71511d61b312f219 = $8a4b9e1682f367e1$var$_to_array;





var $176d75244f0e6d93$export$71511d61b312f219;
"use strict";
function $176d75244f0e6d93$var$_object_destructuring_empty(o) {
    if (o === null || o === void 0) throw new TypeError("Cannot destructure " + o);
    return o;
}
$176d75244f0e6d93$export$71511d61b312f219 = $176d75244f0e6d93$var$_object_destructuring_empty;


var $c73d96e37869302b$export$71511d61b312f219;
"use strict";
function $c73d96e37869302b$var$_define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
$c73d96e37869302b$export$71511d61b312f219 = $c73d96e37869302b$var$_define_property;


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $35c5af1670f53210$exports = {};

var $hO8yS = parcelRequire("hO8yS");




const $e8ea7ccd2bdcbf17$export$5f747a46dc0eb6ee = (()=>{
    if ("undefined" == typeof self) return !1;
    if ("top" in self && self !== top) try {
        top.window.document._ = 0;
    } catch (e) {
        return !1;
    }
    return "showOpenFilePicker" in self;
})(), $e8ea7ccd2bdcbf17$var$t = $e8ea7ccd2bdcbf17$export$5f747a46dc0eb6ee ? Promise.resolve().then(function() {
    return $e8ea7ccd2bdcbf17$var$c;
}) : Promise.resolve().then(function() {
    return $e8ea7ccd2bdcbf17$var$h;
});
async function $e8ea7ccd2bdcbf17$export$c1bd535e520dbbc3(...e) {
    return (await $e8ea7ccd2bdcbf17$var$t).default(...e);
}
const $e8ea7ccd2bdcbf17$var$r = $e8ea7ccd2bdcbf17$export$5f747a46dc0eb6ee ? Promise.resolve().then(function() {
    return $e8ea7ccd2bdcbf17$var$y;
}) : Promise.resolve().then(function() {
    return $e8ea7ccd2bdcbf17$var$b;
});
async function $e8ea7ccd2bdcbf17$export$270aed3754275094(...e) {
    return (await $e8ea7ccd2bdcbf17$var$r).default(...e);
}
const $e8ea7ccd2bdcbf17$var$a = $e8ea7ccd2bdcbf17$export$5f747a46dc0eb6ee ? Promise.resolve().then(function() {
    return $e8ea7ccd2bdcbf17$var$m;
}) : Promise.resolve().then(function() {
    return $e8ea7ccd2bdcbf17$var$_;
});
async function $e8ea7ccd2bdcbf17$export$cf414c79194c40b9(...e) {
    return (await $e8ea7ccd2bdcbf17$var$a).default(...e);
}
const $e8ea7ccd2bdcbf17$var$s = async (e)=>{
    const t = await e.getFile();
    return t.handle = e, t;
};
var $e8ea7ccd2bdcbf17$export$73dd4a3df259d52 = async (e = [
    {}
])=>{
    Array.isArray(e) || (e = [
        e
    ]);
    const t = [];
    e.forEach((e, n)=>{
        t[n] = {
            description: e.description || "Files",
            accept: {}
        }, e.mimeTypes ? e.mimeTypes.map((r)=>{
            t[n].accept[r] = e.extensions || [];
        }) : t[n].accept["*/*"] = e.extensions || [];
    });
    const n = await window.showOpenFilePicker({
        id: e[0].id,
        startIn: e[0].startIn,
        types: t,
        multiple: e[0].multiple || !1,
        excludeAcceptAllOption: e[0].excludeAcceptAllOption || !1
    }), r = await Promise.all(n.map($e8ea7ccd2bdcbf17$var$s));
    return e[0].multiple ? r : r[0];
}, $e8ea7ccd2bdcbf17$var$c = {
    __proto__: null,
    default: $e8ea7ccd2bdcbf17$export$73dd4a3df259d52
};
function $e8ea7ccd2bdcbf17$var$u(e) {
    function t(e) {
        if (Object(e) !== e) return Promise.reject(new TypeError(e + " is not an object."));
        var t = e.done;
        return Promise.resolve(e.value).then(function(e) {
            return {
                value: e,
                done: t
            };
        });
    }
    return $e8ea7ccd2bdcbf17$var$u = function(e) {
        this.s = e, this.n = e.next;
    }, $e8ea7ccd2bdcbf17$var$u.prototype = {
        s: null,
        n: null,
        next: function() {
            return t(this.n.apply(this.s, arguments));
        },
        return: function(e) {
            var n = this.s.return;
            return void 0 === n ? Promise.resolve({
                value: e,
                done: !0
            }) : t(n.apply(this.s, arguments));
        },
        throw: function(e) {
            var n = this.s.return;
            return void 0 === n ? Promise.reject(e) : t(n.apply(this.s, arguments));
        }
    }, new $e8ea7ccd2bdcbf17$var$u(e);
}
const $e8ea7ccd2bdcbf17$var$p = async (e, t, n = e.name, r)=>{
    const i = [], a = [];
    var o, s = !1, l = !1;
    try {
        for(var c, d = function(e) {
            var t, n, r, i = 2;
            for("undefined" != typeof Symbol && (n = Symbol.asyncIterator, r = Symbol.iterator); i--;){
                if (n && null != (t = e[n])) return t.call(e);
                if (r && null != (t = e[r])) return new $e8ea7ccd2bdcbf17$var$u(t.call(e));
                n = "@@asyncIterator", r = "@@iterator";
            }
            throw new TypeError("Object is not async iterable");
        }(e.values()); s = !(c = await d.next()).done; s = !1){
            const o = c.value, s = `${n}/${o.name}`;
            "file" === o.kind ? a.push(o.getFile().then((t)=>(t.directoryHandle = e, t.handle = o, Object.defineProperty(t, "webkitRelativePath", {
                    configurable: !0,
                    enumerable: !0,
                    get: ()=>s
                })))) : "directory" !== o.kind || !t || r && r(o) || i.push($e8ea7ccd2bdcbf17$var$p(o, t, s, r));
        }
    } catch (e) {
        l = !0, o = e;
    } finally{
        try {
            s && null != d.return && await d.return();
        } finally{
            if (l) throw o;
        }
    }
    return [
        ...(await Promise.all(i)).flat(),
        ...await Promise.all(a)
    ];
};
var $e8ea7ccd2bdcbf17$export$aeb41617a6d6e89 = async (e = {})=>{
    e.recursive = e.recursive || !1, e.mode = e.mode || "read";
    const t = await window.showDirectoryPicker({
        id: e.id,
        startIn: e.startIn,
        mode: e.mode
    });
    return (await (await t.values()).next()).done ? [
        t
    ] : $e8ea7ccd2bdcbf17$var$p(t, e.recursive, void 0, e.skipDirectory);
}, $e8ea7ccd2bdcbf17$var$y = {
    __proto__: null,
    default: $e8ea7ccd2bdcbf17$export$aeb41617a6d6e89
}, $e8ea7ccd2bdcbf17$export$ff17ca902e7337af = async (e, t = [
    {}
], n = null, r = !1, i = null)=>{
    Array.isArray(t) || (t = [
        t
    ]), t[0].fileName = t[0].fileName || "Untitled";
    const a = [];
    let o = null;
    if (e instanceof Blob && e.type ? o = e.type : e.headers && e.headers.get("content-type") && (o = e.headers.get("content-type")), t.forEach((e, t)=>{
        a[t] = {
            description: e.description || "Files",
            accept: {}
        }, e.mimeTypes ? (0 === t && o && e.mimeTypes.push(o), e.mimeTypes.map((n)=>{
            a[t].accept[n] = e.extensions || [];
        })) : o ? a[t].accept[o] = e.extensions || [] : a[t].accept["*/*"] = e.extensions || [];
    }), n) try {
        await n.getFile();
    } catch (e) {
        if (n = null, r) throw e;
    }
    const s = n || await window.showSaveFilePicker({
        suggestedName: t[0].fileName,
        id: t[0].id,
        startIn: t[0].startIn,
        types: a,
        excludeAcceptAllOption: t[0].excludeAcceptAllOption || !1
    });
    !n && i && i(s);
    const l = await s.createWritable();
    if ("stream" in e) {
        const t = e.stream();
        return await t.pipeTo(l), s;
    }
    return "body" in e ? (await e.body.pipeTo(l), s) : (await l.write(await e), await l.close(), s);
}, $e8ea7ccd2bdcbf17$var$m = {
    __proto__: null,
    default: $e8ea7ccd2bdcbf17$export$ff17ca902e7337af
}, $e8ea7ccd2bdcbf17$export$f1c676766788056a = async (e = [
    {}
])=>(Array.isArray(e) || (e = [
        e
    ]), new Promise((t, n)=>{
        const r = document.createElement("input");
        r.type = "file";
        const i = [
            ...e.map((e)=>e.mimeTypes || []),
            ...e.map((e)=>e.extensions || [])
        ].join();
        r.multiple = e[0].multiple || !1, r.accept = i || "", r.style.display = "none", document.body.append(r), r.addEventListener("cancel", ()=>{
            r.remove(), n(new DOMException("The user aborted a request.", "AbortError"));
        }), r.addEventListener("change", ()=>{
            r.remove(), t(r.multiple ? Array.from(r.files) : r.files[0]);
        }), "showPicker" in HTMLInputElement.prototype ? r.showPicker() : r.click();
    })), $e8ea7ccd2bdcbf17$var$h = {
    __proto__: null,
    default: $e8ea7ccd2bdcbf17$export$f1c676766788056a
}, $e8ea7ccd2bdcbf17$export$14ab45eaad58ab5 = async (e = [
    {}
])=>(Array.isArray(e) || (e = [
        e
    ]), e[0].recursive = e[0].recursive || !1, new Promise((t, n)=>{
        const r = document.createElement("input");
        r.type = "file", r.webkitdirectory = !0, r.style.display = "none", document.body.append(r), r.addEventListener("cancel", ()=>{
            r.remove(), n(new DOMException("The user aborted a request.", "AbortError"));
        }), r.addEventListener("change", ()=>{
            r.remove();
            let n = Array.from(r.files);
            e[0].recursive ? e[0].recursive && e[0].skipDirectory && (n = n.filter((t)=>t.webkitRelativePath.split("/").every((t)=>!e[0].skipDirectory({
                        name: t,
                        kind: "directory"
                    })))) : n = n.filter((e)=>2 === e.webkitRelativePath.split("/").length), t(n);
        }), "showPicker" in HTMLInputElement.prototype ? r.showPicker() : r.click();
    })), $e8ea7ccd2bdcbf17$var$b = {
    __proto__: null,
    default: $e8ea7ccd2bdcbf17$export$14ab45eaad58ab5
}, $e8ea7ccd2bdcbf17$export$19f956f8dbe9df86 = async (e, t = {})=>{
    Array.isArray(t) && (t = t[0]);
    const n = document.createElement("a");
    let r = e;
    "body" in e && (r = await async function(e, t) {
        const n = e.getReader(), r = new ReadableStream({
            start: (e)=>(async function t() {
                    return n.read().then(({ done: n, value: r })=>{
                        if (!n) return e.enqueue(r), t();
                        e.close();
                    });
                })()
        }), i = new Response(r), a = await i.blob();
        return n.releaseLock(), new Blob([
            a
        ], {
            type: t
        });
    }(e.body, e.headers.get("content-type"))), n.download = t.fileName || "Untitled", n.href = URL.createObjectURL(await r);
    const i = ()=>{
        "function" == typeof a && a();
    }, a = t.legacySetup && t.legacySetup(i, ()=>a(), n);
    return n.addEventListener("click", ()=>{
        setTimeout(()=>URL.revokeObjectURL(n.href), 3e4), i();
    }), n.click(), null;
}, $e8ea7ccd2bdcbf17$var$_ = {
    __proto__: null,
    default: $e8ea7ccd2bdcbf17$export$19f956f8dbe9df86
};


function $092db34b836d8ae4$var$extend(destination) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (source.hasOwnProperty(key)) destination[key] = source[key];
    }
    return destination;
}
function $092db34b836d8ae4$var$repeat(character, count) {
    return Array(count + 1).join(character);
}
function $092db34b836d8ae4$var$trimLeadingNewlines(string) {
    return string.replace(/^\n*/, '');
}
function $092db34b836d8ae4$var$trimTrailingNewlines(string) {
    // avoid match-at-end regexp bottleneck, see #370
    var indexEnd = string.length;
    while(indexEnd > 0 && string[indexEnd - 1] === '\n')indexEnd--;
    return string.substring(0, indexEnd);
}
function $092db34b836d8ae4$var$trimNewlines(string) {
    return $092db34b836d8ae4$var$trimTrailingNewlines($092db34b836d8ae4$var$trimLeadingNewlines(string));
}
var $092db34b836d8ae4$var$blockElements = [
    'ADDRESS',
    'ARTICLE',
    'ASIDE',
    'AUDIO',
    'BLOCKQUOTE',
    'BODY',
    'CANVAS',
    'CENTER',
    'DD',
    'DIR',
    'DIV',
    'DL',
    'DT',
    'FIELDSET',
    'FIGCAPTION',
    'FIGURE',
    'FOOTER',
    'FORM',
    'FRAMESET',
    'H1',
    'H2',
    'H3',
    'H4',
    'H5',
    'H6',
    'HEADER',
    'HGROUP',
    'HR',
    'HTML',
    'ISINDEX',
    'LI',
    'MAIN',
    'MENU',
    'NAV',
    'NOFRAMES',
    'NOSCRIPT',
    'OL',
    'OUTPUT',
    'P',
    'PRE',
    'SECTION',
    'TABLE',
    'TBODY',
    'TD',
    'TFOOT',
    'TH',
    'THEAD',
    'TR',
    'UL'
];
function $092db34b836d8ae4$var$isBlock(node) {
    return $092db34b836d8ae4$var$is(node, $092db34b836d8ae4$var$blockElements);
}
var $092db34b836d8ae4$var$voidElements = [
    'AREA',
    'BASE',
    'BR',
    'COL',
    'COMMAND',
    'EMBED',
    'HR',
    'IMG',
    'INPUT',
    'KEYGEN',
    'LINK',
    'META',
    'PARAM',
    'SOURCE',
    'TRACK',
    'WBR'
];
function $092db34b836d8ae4$var$isVoid(node) {
    return $092db34b836d8ae4$var$is(node, $092db34b836d8ae4$var$voidElements);
}
function $092db34b836d8ae4$var$hasVoid(node) {
    return $092db34b836d8ae4$var$has(node, $092db34b836d8ae4$var$voidElements);
}
var $092db34b836d8ae4$var$meaningfulWhenBlankElements = [
    'A',
    'TABLE',
    'THEAD',
    'TBODY',
    'TFOOT',
    'TH',
    'TD',
    'IFRAME',
    'SCRIPT',
    'AUDIO',
    'VIDEO'
];
function $092db34b836d8ae4$var$isMeaningfulWhenBlank(node) {
    return $092db34b836d8ae4$var$is(node, $092db34b836d8ae4$var$meaningfulWhenBlankElements);
}
function $092db34b836d8ae4$var$hasMeaningfulWhenBlank(node) {
    return $092db34b836d8ae4$var$has(node, $092db34b836d8ae4$var$meaningfulWhenBlankElements);
}
function $092db34b836d8ae4$var$is(node, tagNames) {
    return tagNames.indexOf(node.nodeName) >= 0;
}
function $092db34b836d8ae4$var$has(node, tagNames) {
    return node.getElementsByTagName && tagNames.some(function(tagName) {
        return node.getElementsByTagName(tagName).length;
    });
}
var $092db34b836d8ae4$var$rules = {};
$092db34b836d8ae4$var$rules.paragraph = {
    filter: 'p',
    replacement: function(content) {
        return '\n\n' + content + '\n\n';
    }
};
$092db34b836d8ae4$var$rules.lineBreak = {
    filter: 'br',
    replacement: function(content, node, options) {
        return options.br + '\n';
    }
};
$092db34b836d8ae4$var$rules.heading = {
    filter: [
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6'
    ],
    replacement: function(content, node, options) {
        var hLevel = Number(node.nodeName.charAt(1));
        if (options.headingStyle === 'setext' && hLevel < 3) {
            var underline = $092db34b836d8ae4$var$repeat(hLevel === 1 ? '=' : '-', content.length);
            return '\n\n' + content + '\n' + underline + '\n\n';
        } else return '\n\n' + $092db34b836d8ae4$var$repeat('#', hLevel) + ' ' + content + '\n\n';
    }
};
$092db34b836d8ae4$var$rules.blockquote = {
    filter: 'blockquote',
    replacement: function(content) {
        content = $092db34b836d8ae4$var$trimNewlines(content).replace(/^/gm, '> ');
        return '\n\n' + content + '\n\n';
    }
};
$092db34b836d8ae4$var$rules.list = {
    filter: [
        'ul',
        'ol'
    ],
    replacement: function(content, node) {
        var parent = node.parentNode;
        if (parent.nodeName === 'LI' && parent.lastElementChild === node) return '\n' + content;
        else return '\n\n' + content + '\n\n';
    }
};
$092db34b836d8ae4$var$rules.listItem = {
    filter: 'li',
    replacement: function(content, node, options) {
        var prefix = options.bulletListMarker + '   ';
        var parent = node.parentNode;
        if (parent.nodeName === 'OL') {
            var start = parent.getAttribute('start');
            var index = Array.prototype.indexOf.call(parent.children, node);
            prefix = (start ? Number(start) + index : index + 1) + '.  ';
        }
        var isParagraph = /\n$/.test(content);
        content = $092db34b836d8ae4$var$trimNewlines(content) + (isParagraph ? '\n' : '');
        content = content.replace(/\n/gm, '\n' + ' '.repeat(prefix.length)); // indent
        return prefix + content + (node.nextSibling ? '\n' : '');
    }
};
$092db34b836d8ae4$var$rules.indentedCodeBlock = {
    filter: function(node, options) {
        return options.codeBlockStyle === 'indented' && node.nodeName === 'PRE' && node.firstChild && node.firstChild.nodeName === 'CODE';
    },
    replacement: function(content, node, options) {
        return '\n\n    ' + node.firstChild.textContent.replace(/\n/g, '\n    ') + '\n\n';
    }
};
$092db34b836d8ae4$var$rules.fencedCodeBlock = {
    filter: function(node, options) {
        return options.codeBlockStyle === 'fenced' && node.nodeName === 'PRE' && node.firstChild && node.firstChild.nodeName === 'CODE';
    },
    replacement: function(content, node, options) {
        var className = node.firstChild.getAttribute('class') || '';
        var language = (className.match(/language-(\S+)/) || [
            null,
            ''
        ])[1];
        var code = node.firstChild.textContent;
        var fenceChar = options.fence.charAt(0);
        var fenceSize = 3;
        var fenceInCodeRegex = new RegExp('^' + fenceChar + '{3,}', 'gm');
        var match;
        while(match = fenceInCodeRegex.exec(code))if (match[0].length >= fenceSize) fenceSize = match[0].length + 1;
        var fence = $092db34b836d8ae4$var$repeat(fenceChar, fenceSize);
        return '\n\n' + fence + language + '\n' + code.replace(/\n$/, '') + '\n' + fence + '\n\n';
    }
};
$092db34b836d8ae4$var$rules.horizontalRule = {
    filter: 'hr',
    replacement: function(content, node, options) {
        return '\n\n' + options.hr + '\n\n';
    }
};
$092db34b836d8ae4$var$rules.inlineLink = {
    filter: function(node, options) {
        return options.linkStyle === 'inlined' && node.nodeName === 'A' && node.getAttribute('href');
    },
    replacement: function(content, node) {
        var href = node.getAttribute('href');
        if (href) href = href.replace(/([()])/g, '\\$1');
        var title = $092db34b836d8ae4$var$cleanAttribute(node.getAttribute('title'));
        if (title) title = ' "' + title.replace(/"/g, '\\"') + '"';
        return '[' + content + '](' + href + title + ')';
    }
};
$092db34b836d8ae4$var$rules.referenceLink = {
    filter: function(node, options) {
        return options.linkStyle === 'referenced' && node.nodeName === 'A' && node.getAttribute('href');
    },
    replacement: function(content, node, options) {
        var href = node.getAttribute('href');
        var title = $092db34b836d8ae4$var$cleanAttribute(node.getAttribute('title'));
        if (title) title = ' "' + title + '"';
        var replacement;
        var reference;
        switch(options.linkReferenceStyle){
            case 'collapsed':
                replacement = '[' + content + '][]';
                reference = '[' + content + ']: ' + href + title;
                break;
            case 'shortcut':
                replacement = '[' + content + ']';
                reference = '[' + content + ']: ' + href + title;
                break;
            default:
                var id = this.references.length + 1;
                replacement = '[' + content + '][' + id + ']';
                reference = '[' + id + ']: ' + href + title;
        }
        this.references.push(reference);
        return replacement;
    },
    references: [],
    append: function(options) {
        var references = '';
        if (this.references.length) {
            references = '\n\n' + this.references.join('\n') + '\n\n';
            this.references = []; // Reset references
        }
        return references;
    }
};
$092db34b836d8ae4$var$rules.emphasis = {
    filter: [
        'em',
        'i'
    ],
    replacement: function(content, node, options) {
        if (!content.trim()) return '';
        return options.emDelimiter + content + options.emDelimiter;
    }
};
$092db34b836d8ae4$var$rules.strong = {
    filter: [
        'strong',
        'b'
    ],
    replacement: function(content, node, options) {
        if (!content.trim()) return '';
        return options.strongDelimiter + content + options.strongDelimiter;
    }
};
$092db34b836d8ae4$var$rules.code = {
    filter: function(node) {
        var hasSiblings = node.previousSibling || node.nextSibling;
        var isCodeBlock = node.parentNode.nodeName === 'PRE' && !hasSiblings;
        return node.nodeName === 'CODE' && !isCodeBlock;
    },
    replacement: function(content) {
        if (!content) return '';
        content = content.replace(/\r?\n|\r/g, ' ');
        var extraSpace = /^`|^ .*?[^ ].* $|`$/.test(content) ? ' ' : '';
        var delimiter = '`';
        var matches = content.match(/`+/gm) || [];
        while(matches.indexOf(delimiter) !== -1)delimiter = delimiter + '`';
        return delimiter + extraSpace + content + extraSpace + delimiter;
    }
};
$092db34b836d8ae4$var$rules.image = {
    filter: 'img',
    replacement: function(content, node) {
        var alt = $092db34b836d8ae4$var$cleanAttribute(node.getAttribute('alt'));
        var src = node.getAttribute('src') || '';
        var title = $092db34b836d8ae4$var$cleanAttribute(node.getAttribute('title'));
        var titlePart = title ? ' "' + title + '"' : '';
        return src ? '![' + alt + ']' + '(' + src + titlePart + ')' : '';
    }
};
function $092db34b836d8ae4$var$cleanAttribute(attribute) {
    return attribute ? attribute.replace(/(\n+\s*)+/g, '\n') : '';
}
/**
 * Manages a collection of rules used to convert HTML to Markdown
 */ function $092db34b836d8ae4$var$Rules(options) {
    this.options = options;
    this._keep = [];
    this._remove = [];
    this.blankRule = {
        replacement: options.blankReplacement
    };
    this.keepReplacement = options.keepReplacement;
    this.defaultRule = {
        replacement: options.defaultReplacement
    };
    this.array = [];
    for(var key in options.rules)this.array.push(options.rules[key]);
}
$092db34b836d8ae4$var$Rules.prototype = {
    add: function(key, rule) {
        this.array.unshift(rule);
    },
    keep: function(filter) {
        this._keep.unshift({
            filter: filter,
            replacement: this.keepReplacement
        });
    },
    remove: function(filter) {
        this._remove.unshift({
            filter: filter,
            replacement: function() {
                return '';
            }
        });
    },
    forNode: function(node) {
        if (node.isBlank) return this.blankRule;
        var rule;
        if (rule = $092db34b836d8ae4$var$findRule(this.array, node, this.options)) return rule;
        if (rule = $092db34b836d8ae4$var$findRule(this._keep, node, this.options)) return rule;
        if (rule = $092db34b836d8ae4$var$findRule(this._remove, node, this.options)) return rule;
        return this.defaultRule;
    },
    forEach: function(fn) {
        for(var i = 0; i < this.array.length; i++)fn(this.array[i], i);
    }
};
function $092db34b836d8ae4$var$findRule(rules, node, options) {
    for(var i = 0; i < rules.length; i++){
        var rule = rules[i];
        if ($092db34b836d8ae4$var$filterValue(rule, node, options)) return rule;
    }
    return void 0;
}
function $092db34b836d8ae4$var$filterValue(rule, node, options) {
    var filter = rule.filter;
    if (typeof filter === 'string') {
        if (filter === node.nodeName.toLowerCase()) return true;
    } else if (Array.isArray(filter)) {
        if (filter.indexOf(node.nodeName.toLowerCase()) > -1) return true;
    } else if (typeof filter === 'function') {
        if (filter.call(rule, node, options)) return true;
    } else throw new TypeError('`filter` needs to be a string, array, or function');
}
/**
 * The collapseWhitespace function is adapted from collapse-whitespace
 * by Luc Thevenard.
 *
 * The MIT License (MIT)
 *
 * Copyright (c) 2014 Luc Thevenard <lucthevenard@gmail.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ /**
 * collapseWhitespace(options) removes extraneous whitespace from an the given element.
 *
 * @param {Object} options
 */ function $092db34b836d8ae4$var$collapseWhitespace(options) {
    var element = options.element;
    var isBlock = options.isBlock;
    var isVoid = options.isVoid;
    var isPre = options.isPre || function(node) {
        return node.nodeName === 'PRE';
    };
    if (!element.firstChild || isPre(element)) return;
    var prevText = null;
    var keepLeadingWs = false;
    var prev = null;
    var node = $092db34b836d8ae4$var$next(prev, element, isPre);
    while(node !== element){
        if (node.nodeType === 3 || node.nodeType === 4) {
            var text = node.data.replace(/[ \r\n\t]+/g, ' ');
            if ((!prevText || / $/.test(prevText.data)) && !keepLeadingWs && text[0] === ' ') text = text.substr(1);
            // `text` might be empty at this point.
            if (!text) {
                node = $092db34b836d8ae4$var$remove(node);
                continue;
            }
            node.data = text;
            prevText = node;
        } else if (node.nodeType === 1) {
            if (isBlock(node) || node.nodeName === 'BR') {
                if (prevText) prevText.data = prevText.data.replace(/ $/, '');
                prevText = null;
                keepLeadingWs = false;
            } else if (isVoid(node) || isPre(node)) {
                // Avoid trimming space around non-block, non-BR void elements and inline PRE.
                prevText = null;
                keepLeadingWs = true;
            } else if (prevText) // Drop protection if set previously.
            keepLeadingWs = false;
        } else {
            node = $092db34b836d8ae4$var$remove(node);
            continue;
        }
        var nextNode = $092db34b836d8ae4$var$next(prev, node, isPre);
        prev = node;
        node = nextNode;
    }
    if (prevText) {
        prevText.data = prevText.data.replace(/ $/, '');
        if (!prevText.data) $092db34b836d8ae4$var$remove(prevText);
    }
}
/**
 * remove(node) removes the given node from the DOM and returns the
 * next node in the sequence.
 *
 * @param {Node} node
 * @return {Node} node
 */ function $092db34b836d8ae4$var$remove(node) {
    var next = node.nextSibling || node.parentNode;
    node.parentNode.removeChild(node);
    return next;
}
/**
 * next(prev, current, isPre) returns the next node in the sequence, given the
 * current and previous nodes.
 *
 * @param {Node} prev
 * @param {Node} current
 * @param {Function} isPre
 * @return {Node}
 */ function $092db34b836d8ae4$var$next(prev, current, isPre) {
    if (prev && prev.parentNode === current || isPre(current)) return current.nextSibling || current.parentNode;
    return current.firstChild || current.nextSibling || current.parentNode;
}
/*
 * Set up window for Node.js
 */ var $092db34b836d8ae4$var$root = typeof window !== 'undefined' ? window : {};
/*
 * Parsing HTML strings
 */ function $092db34b836d8ae4$var$canParseHTMLNatively() {
    var Parser = $092db34b836d8ae4$var$root.DOMParser;
    var canParse = false;
    // Adapted from https://gist.github.com/1129031
    // Firefox/Opera/IE throw errors on unsupported types
    try {
        // WebKit returns null on unsupported types
        if (new Parser().parseFromString('', 'text/html')) canParse = true;
    } catch (e) {}
    return canParse;
}
function $092db34b836d8ae4$var$createHTMLParser() {
    var Parser = function() {};
    if ($092db34b836d8ae4$var$shouldUseActiveX()) Parser.prototype.parseFromString = function(string) {
        var doc = new window.ActiveXObject('htmlfile');
        doc.designMode = 'on'; // disable on-page scripts
        doc.open();
        doc.write(string);
        doc.close();
        return doc;
    };
    else Parser.prototype.parseFromString = function(string) {
        var doc = document.implementation.createHTMLDocument('');
        doc.open();
        doc.write(string);
        doc.close();
        return doc;
    };
    return Parser;
}
function $092db34b836d8ae4$var$shouldUseActiveX() {
    var useActiveX = false;
    try {
        document.implementation.createHTMLDocument('').open();
    } catch (e) {
        if ($092db34b836d8ae4$var$root.ActiveXObject) useActiveX = true;
    }
    return useActiveX;
}
var $092db34b836d8ae4$var$HTMLParser = $092db34b836d8ae4$var$canParseHTMLNatively() ? $092db34b836d8ae4$var$root.DOMParser : $092db34b836d8ae4$var$createHTMLParser();
function $092db34b836d8ae4$var$RootNode(input, options) {
    var root;
    if (typeof input === 'string') {
        var doc = $092db34b836d8ae4$var$htmlParser().parseFromString(// DOM parsers arrange elements in the <head> and <body>.
        // Wrapping in a custom element ensures elements are reliably arranged in
        // a single element.
        '<x-turndown id="turndown-root">' + input + '</x-turndown>', 'text/html');
        root = doc.getElementById('turndown-root');
    } else root = input.cloneNode(true);
    $092db34b836d8ae4$var$collapseWhitespace({
        element: root,
        isBlock: $092db34b836d8ae4$var$isBlock,
        isVoid: $092db34b836d8ae4$var$isVoid,
        isPre: options.preformattedCode ? $092db34b836d8ae4$var$isPreOrCode : null
    });
    return root;
}
var $092db34b836d8ae4$var$_htmlParser;
function $092db34b836d8ae4$var$htmlParser() {
    $092db34b836d8ae4$var$_htmlParser = $092db34b836d8ae4$var$_htmlParser || new $092db34b836d8ae4$var$HTMLParser();
    return $092db34b836d8ae4$var$_htmlParser;
}
function $092db34b836d8ae4$var$isPreOrCode(node) {
    return node.nodeName === 'PRE' || node.nodeName === 'CODE';
}
function $092db34b836d8ae4$var$Node(node, options) {
    node.isBlock = $092db34b836d8ae4$var$isBlock(node);
    node.isCode = node.nodeName === 'CODE' || node.parentNode.isCode;
    node.isBlank = $092db34b836d8ae4$var$isBlank(node);
    node.flankingWhitespace = $092db34b836d8ae4$var$flankingWhitespace(node, options);
    return node;
}
function $092db34b836d8ae4$var$isBlank(node) {
    return !$092db34b836d8ae4$var$isVoid(node) && !$092db34b836d8ae4$var$isMeaningfulWhenBlank(node) && /^\s*$/i.test(node.textContent) && !$092db34b836d8ae4$var$hasVoid(node) && !$092db34b836d8ae4$var$hasMeaningfulWhenBlank(node);
}
function $092db34b836d8ae4$var$flankingWhitespace(node, options) {
    if (node.isBlock || options.preformattedCode && node.isCode) return {
        leading: '',
        trailing: ''
    };
    var edges = $092db34b836d8ae4$var$edgeWhitespace(node.textContent);
    // abandon leading ASCII WS if left-flanked by ASCII WS
    if (edges.leadingAscii && $092db34b836d8ae4$var$isFlankedByWhitespace('left', node, options)) edges.leading = edges.leadingNonAscii;
    // abandon trailing ASCII WS if right-flanked by ASCII WS
    if (edges.trailingAscii && $092db34b836d8ae4$var$isFlankedByWhitespace('right', node, options)) edges.trailing = edges.trailingNonAscii;
    return {
        leading: edges.leading,
        trailing: edges.trailing
    };
}
function $092db34b836d8ae4$var$edgeWhitespace(string) {
    var m = string.match(/^(([ \t\r\n]*)(\s*))(?:(?=\S)[\s\S]*\S)?((\s*?)([ \t\r\n]*))$/);
    return {
        leading: m[1],
        leadingAscii: m[2],
        leadingNonAscii: m[3],
        trailing: m[4],
        trailingNonAscii: m[5],
        trailingAscii: m[6]
    };
}
function $092db34b836d8ae4$var$isFlankedByWhitespace(side, node, options) {
    var sibling;
    var regExp;
    var isFlanked;
    if (side === 'left') {
        sibling = node.previousSibling;
        regExp = / $/;
    } else {
        sibling = node.nextSibling;
        regExp = /^ /;
    }
    if (sibling) {
        if (sibling.nodeType === 3) isFlanked = regExp.test(sibling.nodeValue);
        else if (options.preformattedCode && sibling.nodeName === 'CODE') isFlanked = false;
        else if (sibling.nodeType === 1 && !$092db34b836d8ae4$var$isBlock(sibling)) isFlanked = regExp.test(sibling.textContent);
    }
    return isFlanked;
}
var $092db34b836d8ae4$var$reduce = Array.prototype.reduce;
var $092db34b836d8ae4$var$escapes = [
    [
        /\\/g,
        '\\\\'
    ],
    [
        /\*/g,
        '\\*'
    ],
    [
        /^-/g,
        '\\-'
    ],
    [
        /^\+ /g,
        '\\+ '
    ],
    [
        /^(=+)/g,
        '\\$1'
    ],
    [
        /^(#{1,6}) /g,
        '\\$1 '
    ],
    [
        /`/g,
        '\\`'
    ],
    [
        /^~~~/g,
        '\\~~~'
    ],
    [
        /\[/g,
        '\\['
    ],
    [
        /\]/g,
        '\\]'
    ],
    [
        /^>/g,
        '\\>'
    ],
    [
        /_/g,
        '\\_'
    ],
    [
        /^(\d+)\. /g,
        '$1\\. '
    ]
];
function $092db34b836d8ae4$var$TurndownService(options) {
    if (!(this instanceof $092db34b836d8ae4$var$TurndownService)) return new $092db34b836d8ae4$var$TurndownService(options);
    var defaults = {
        rules: $092db34b836d8ae4$var$rules,
        headingStyle: 'setext',
        hr: '* * *',
        bulletListMarker: '*',
        codeBlockStyle: 'indented',
        fence: '```',
        emDelimiter: '_',
        strongDelimiter: '**',
        linkStyle: 'inlined',
        linkReferenceStyle: 'full',
        br: '  ',
        preformattedCode: false,
        blankReplacement: function(content, node) {
            return node.isBlock ? '\n\n' : '';
        },
        keepReplacement: function(content, node) {
            return node.isBlock ? '\n\n' + node.outerHTML + '\n\n' : node.outerHTML;
        },
        defaultReplacement: function(content, node) {
            return node.isBlock ? '\n\n' + content + '\n\n' : content;
        }
    };
    this.options = $092db34b836d8ae4$var$extend({}, defaults, options);
    this.rules = new $092db34b836d8ae4$var$Rules(this.options);
}
$092db34b836d8ae4$var$TurndownService.prototype = {
    /**
   * The entry point for converting a string or DOM node to Markdown
   * @public
   * @param {String|HTMLElement} input The string or DOM node to convert
   * @returns A Markdown representation of the input
   * @type String
   */ turndown: function(input) {
        if (!$092db34b836d8ae4$var$canConvert(input)) throw new TypeError(input + ' is not a string, or an element/document/fragment node.');
        if (input === '') return '';
        var output = $092db34b836d8ae4$var$process.call(this, new $092db34b836d8ae4$var$RootNode(input, this.options));
        return $092db34b836d8ae4$var$postProcess.call(this, output);
    },
    /**
   * Add one or more plugins
   * @public
   * @param {Function|Array} plugin The plugin or array of plugins to add
   * @returns The Turndown instance for chaining
   * @type Object
   */ use: function(plugin) {
        if (Array.isArray(plugin)) for(var i = 0; i < plugin.length; i++)this.use(plugin[i]);
        else if (typeof plugin === 'function') plugin(this);
        else throw new TypeError('plugin must be a Function or an Array of Functions');
        return this;
    },
    /**
   * Adds a rule
   * @public
   * @param {String} key The unique key of the rule
   * @param {Object} rule The rule
   * @returns The Turndown instance for chaining
   * @type Object
   */ addRule: function(key, rule) {
        this.rules.add(key, rule);
        return this;
    },
    /**
   * Keep a node (as HTML) that matches the filter
   * @public
   * @param {String|Array|Function} filter The unique key of the rule
   * @returns The Turndown instance for chaining
   * @type Object
   */ keep: function(filter) {
        this.rules.keep(filter);
        return this;
    },
    /**
   * Remove a node that matches the filter
   * @public
   * @param {String|Array|Function} filter The unique key of the rule
   * @returns The Turndown instance for chaining
   * @type Object
   */ remove: function(filter) {
        this.rules.remove(filter);
        return this;
    },
    /**
   * Escapes Markdown syntax
   * @public
   * @param {String} string The string to escape
   * @returns A string with Markdown syntax escaped
   * @type String
   */ escape: function(string) {
        return $092db34b836d8ae4$var$escapes.reduce(function(accumulator, escape) {
            return accumulator.replace(escape[0], escape[1]);
        }, string);
    }
};
/**
 * Reduces a DOM node down to its Markdown string equivalent
 * @private
 * @param {HTMLElement} parentNode The node to convert
 * @returns A Markdown representation of the node
 * @type String
 */ function $092db34b836d8ae4$var$process(parentNode) {
    var self = this;
    return $092db34b836d8ae4$var$reduce.call(parentNode.childNodes, function(output, node) {
        node = new $092db34b836d8ae4$var$Node(node, self.options);
        var replacement = '';
        if (node.nodeType === 3) replacement = node.isCode ? node.nodeValue : self.escape(node.nodeValue);
        else if (node.nodeType === 1) replacement = $092db34b836d8ae4$var$replacementForNode.call(self, node);
        return $092db34b836d8ae4$var$join(output, replacement);
    }, '');
}
/**
 * Appends strings as each rule requires and trims the output
 * @private
 * @param {String} output The conversion output
 * @returns A trimmed version of the ouput
 * @type String
 */ function $092db34b836d8ae4$var$postProcess(output) {
    var self = this;
    this.rules.forEach(function(rule) {
        if (typeof rule.append === 'function') output = $092db34b836d8ae4$var$join(output, rule.append(self.options));
    });
    return output.replace(/^[\t\r\n]+/, '').replace(/[\t\r\n\s]+$/, '');
}
/**
 * Converts an element node to its Markdown equivalent
 * @private
 * @param {HTMLElement} node The node to convert
 * @returns A Markdown representation of the node
 * @type String
 */ function $092db34b836d8ae4$var$replacementForNode(node) {
    var rule = this.rules.forNode(node);
    var content = $092db34b836d8ae4$var$process.call(this, node);
    var whitespace = node.flankingWhitespace;
    if (whitespace.leading || whitespace.trailing) content = content.trim();
    return whitespace.leading + rule.replacement(content, node, this.options) + whitespace.trailing;
}
/**
 * Joins replacement to the current output with appropriate number of new lines
 * @private
 * @param {String} output The current conversion output
 * @param {String} replacement The string to append to the output
 * @returns Joined output
 * @type String
 */ function $092db34b836d8ae4$var$join(output, replacement) {
    var s1 = $092db34b836d8ae4$var$trimTrailingNewlines(output);
    var s2 = $092db34b836d8ae4$var$trimLeadingNewlines(replacement);
    var nls = Math.max(output.length - s1.length, replacement.length - s2.length);
    var separator = '\n\n'.substring(0, nls);
    return s1 + separator + s2;
}
/**
 * Determines whether an input can be converted
 * @private
 * @param {String|HTMLElement} input Describe this parameter
 * @returns Describe what it returns
 * @type String|Object|Array|Boolean|Number
 */ function $092db34b836d8ae4$var$canConvert(input) {
    return input != null && (typeof input === 'string' || input.nodeType && (input.nodeType === 1 || input.nodeType === 9 || input.nodeType === 11));
}
var $092db34b836d8ae4$export$2e2bcd8739ae039 = $092db34b836d8ae4$var$TurndownService;


var $8b5b54c590bb494d$var$highlightRegExp = /highlight-(?:text|source)-([a-z0-9]+)/;
function $8b5b54c590bb494d$export$c359330ed80b1889(turndownService) {
    turndownService.addRule('highlightedCodeBlock', {
        filter: function(node) {
            var firstChild = node.firstChild;
            return node.nodeName === 'DIV' && $8b5b54c590bb494d$var$highlightRegExp.test(node.className) && firstChild && firstChild.nodeName === 'PRE';
        },
        replacement: function(content, node, options) {
            var className = node.className || '';
            var language = (className.match($8b5b54c590bb494d$var$highlightRegExp) || [
                null,
                ''
            ])[1];
            return '\n\n' + options.fence + language + '\n' + node.firstChild.textContent + '\n' + options.fence + '\n\n';
        }
    });
}
function $8b5b54c590bb494d$export$19426ff118fe8be(turndownService) {
    turndownService.addRule('strikethrough', {
        filter: [
            'del',
            's',
            'strike'
        ],
        replacement: function(content) {
            return '~' + content + '~';
        }
    });
}
var $8b5b54c590bb494d$var$indexOf = Array.prototype.indexOf;
var $8b5b54c590bb494d$var$every = Array.prototype.every;
var $8b5b54c590bb494d$var$rules = {};
$8b5b54c590bb494d$var$rules.tableCell = {
    filter: [
        'th',
        'td'
    ],
    replacement: function(content, node) {
        return $8b5b54c590bb494d$var$cell(content, node);
    }
};
$8b5b54c590bb494d$var$rules.tableRow = {
    filter: 'tr',
    replacement: function(content, node) {
        var borderCells = '';
        var alignMap = {
            left: ':--',
            right: '--:',
            center: ':-:'
        };
        if ($8b5b54c590bb494d$var$isHeadingRow(node)) for(var i = 0; i < node.childNodes.length; i++){
            var border = '---';
            var align = (node.childNodes[i].getAttribute('align') || '').toLowerCase();
            if (align) border = alignMap[align] || border;
            borderCells += $8b5b54c590bb494d$var$cell(border, node.childNodes[i]);
        }
        return '\n' + content + (borderCells ? '\n' + borderCells : '');
    }
};
$8b5b54c590bb494d$var$rules.table = {
    // Only convert tables with a heading row.
    // Tables with no heading row are kept using `keep` (see below).
    filter: function(node) {
        return node.nodeName === 'TABLE' && $8b5b54c590bb494d$var$isHeadingRow(node.rows[0]);
    },
    replacement: function(content) {
        // Ensure there are no blank lines
        content = content.replace('\n\n', '\n');
        return '\n\n' + content + '\n\n';
    }
};
$8b5b54c590bb494d$var$rules.tableSection = {
    filter: [
        'thead',
        'tbody',
        'tfoot'
    ],
    replacement: function(content) {
        return content;
    }
};
// A tr is a heading row if:
// - the parent is a THEAD
// - or if its the first child of the TABLE or the first TBODY (possibly
//   following a blank THEAD)
// - and every cell is a TH
function $8b5b54c590bb494d$var$isHeadingRow(tr) {
    var parentNode = tr.parentNode;
    return parentNode.nodeName === 'THEAD' || parentNode.firstChild === tr && (parentNode.nodeName === 'TABLE' || $8b5b54c590bb494d$var$isFirstTbody(parentNode)) && $8b5b54c590bb494d$var$every.call(tr.childNodes, function(n) {
        return n.nodeName === 'TH';
    });
}
function $8b5b54c590bb494d$var$isFirstTbody(element) {
    var previousSibling = element.previousSibling;
    return element.nodeName === 'TBODY' && (!previousSibling || previousSibling.nodeName === 'THEAD' && /^\s*$/i.test(previousSibling.textContent));
}
function $8b5b54c590bb494d$var$cell(content, node) {
    var index = $8b5b54c590bb494d$var$indexOf.call(node.parentNode.childNodes, node);
    var prefix = ' ';
    if (index === 0) prefix = '| ';
    return prefix + content + ' |';
}
function $8b5b54c590bb494d$export$cc4ff83fc7bd256e(turndownService) {
    turndownService.keep(function(node) {
        return node.nodeName === 'TABLE' && !$8b5b54c590bb494d$var$isHeadingRow(node.rows[0]);
    });
    for(var key in $8b5b54c590bb494d$var$rules)turndownService.addRule(key, $8b5b54c590bb494d$var$rules[key]);
}
function $8b5b54c590bb494d$export$1f0c2747e2ba0b8d(turndownService) {
    turndownService.addRule('taskListItems', {
        filter: function(node) {
            return node.type === 'checkbox' && node.parentNode.nodeName === 'LI';
        },
        replacement: function(content, node) {
            return (node.checked ? '[x]' : '[ ]') + ' ';
        }
    });
}
function $8b5b54c590bb494d$export$59ffe8c4d7a4aab2(turndownService) {
    turndownService.use([
        $8b5b54c590bb494d$export$c359330ed80b1889,
        $8b5b54c590bb494d$export$19426ff118fe8be,
        $8b5b54c590bb494d$export$cc4ff83fc7bd256e,
        $8b5b54c590bb494d$export$1f0c2747e2ba0b8d
    ]);
}



/**
 * marked v15.0.12 - a markdown parser
 * Copyright (c) 2011-2025, Christopher Jeffrey. (MIT Licensed)
 * https://github.com/markedjs/marked
 */ /**
 * DO NOT EDIT THIS FILE
 * The code in this file is generated from files in ./src/
 */ // src/defaults.ts
function $a5cf0eae8608a64d$export$212bb2fc580a90a8() {
    return {
        async: false,
        breaks: false,
        extensions: null,
        gfm: true,
        hooks: null,
        pedantic: false,
        renderer: null,
        silent: false,
        tokenizer: null,
        walkTokens: null
    };
}
var $a5cf0eae8608a64d$export$ebe90cb607ad99e = $a5cf0eae8608a64d$export$212bb2fc580a90a8();
function $a5cf0eae8608a64d$var$changeDefaults(newDefaults) {
    $a5cf0eae8608a64d$export$ebe90cb607ad99e = newDefaults;
}
// src/rules.ts
var $a5cf0eae8608a64d$var$noopTest = {
    exec: ()=>null
};
function $a5cf0eae8608a64d$var$edit(regex, opt = "") {
    let source = typeof regex === "string" ? regex : regex.source;
    const obj = {
        replace: (name, val)=>{
            let valSource = typeof val === "string" ? val : val.source;
            valSource = valSource.replace($a5cf0eae8608a64d$var$other.caret, "$1");
            source = source.replace(name, valSource);
            return obj;
        },
        getRegex: ()=>{
            return new RegExp(source, opt);
        }
    };
    return obj;
}
var $a5cf0eae8608a64d$var$other = {
    codeRemoveIndent: /^(?: {1,4}| {0,3}\t)/gm,
    outputLinkReplace: /\\([\[\]])/g,
    indentCodeCompensation: /^(\s+)(?:```)/,
    beginningSpace: /^\s+/,
    endingHash: /#$/,
    startingSpaceChar: /^ /,
    endingSpaceChar: / $/,
    nonSpaceChar: /[^ ]/,
    newLineCharGlobal: /\n/g,
    tabCharGlobal: /\t/g,
    multipleSpaceGlobal: /\s+/g,
    blankLine: /^[ \t]*$/,
    doubleBlankLine: /\n[ \t]*\n[ \t]*$/,
    blockquoteStart: /^ {0,3}>/,
    blockquoteSetextReplace: /\n {0,3}((?:=+|-+) *)(?=\n|$)/g,
    blockquoteSetextReplace2: /^ {0,3}>[ \t]?/gm,
    listReplaceTabs: /^\t+/,
    listReplaceNesting: /^ {1,4}(?=( {4})*[^ ])/g,
    listIsTask: /^\[[ xX]\] /,
    listReplaceTask: /^\[[ xX]\] +/,
    anyLine: /\n.*\n/,
    hrefBrackets: /^<(.*)>$/,
    tableDelimiter: /[:|]/,
    tableAlignChars: /^\||\| *$/g,
    tableRowBlankLine: /\n[ \t]*$/,
    tableAlignRight: /^ *-+: *$/,
    tableAlignCenter: /^ *:-+: *$/,
    tableAlignLeft: /^ *:-+ *$/,
    startATag: /^<a /i,
    endATag: /^<\/a>/i,
    startPreScriptTag: /^<(pre|code|kbd|script)(\s|>)/i,
    endPreScriptTag: /^<\/(pre|code|kbd|script)(\s|>)/i,
    startAngleBracket: /^</,
    endAngleBracket: />$/,
    pedanticHrefTitle: /^([^'"]*[^\s])\s+(['"])(.*)\2/,
    unicodeAlphaNumeric: /[\p{L}\p{N}]/u,
    escapeTest: /[&<>"']/,
    escapeReplace: /[&<>"']/g,
    escapeTestNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/,
    escapeReplaceNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/g,
    unescapeTest: /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig,
    caret: /(^|[^\[])\^/g,
    percentDecode: /%25/g,
    findPipe: /\|/g,
    splitPipe: / \|/,
    slashPipe: /\\\|/g,
    carriageReturn: /\r\n|\r/g,
    spaceLine: /^ +$/gm,
    notSpaceStart: /^\S*/,
    endingNewline: /\n$/,
    listItemRegex: (bull)=>new RegExp(`^( {0,3}${bull})((?:[	 ][^\\n]*)?(?:\\n|$))`),
    nextBulletRegex: (indent)=>new RegExp(`^ {0,${Math.min(3, indent - 1)}}(?:[*+-]|\\d{1,9}[.)])((?:[ 	][^\\n]*)?(?:\\n|$))`),
    hrRegex: (indent)=>new RegExp(`^ {0,${Math.min(3, indent - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`),
    fencesBeginRegex: (indent)=>new RegExp(`^ {0,${Math.min(3, indent - 1)}}(?:\`\`\`|~~~)`),
    headingBeginRegex: (indent)=>new RegExp(`^ {0,${Math.min(3, indent - 1)}}#`),
    htmlBeginRegex: (indent)=>new RegExp(`^ {0,${Math.min(3, indent - 1)}}<(?:[a-z].*>|!--)`, "i")
};
var $a5cf0eae8608a64d$var$newline = /^(?:[ \t]*(?:\n|$))+/;
var $a5cf0eae8608a64d$var$blockCode = /^((?: {4}| {0,3}\t)[^\n]+(?:\n(?:[ \t]*(?:\n|$))*)?)+/;
var $a5cf0eae8608a64d$var$fences = /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/;
var $a5cf0eae8608a64d$var$hr = /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/;
var $a5cf0eae8608a64d$var$heading = /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/;
var $a5cf0eae8608a64d$var$bullet = /(?:[*+-]|\d{1,9}[.)])/;
var $a5cf0eae8608a64d$var$lheadingCore = /^(?!bull |blockCode|fences|blockquote|heading|html|table)((?:.|\n(?!\s*?\n|bull |blockCode|fences|blockquote|heading|html|table))+?)\n {0,3}(=+|-+) *(?:\n+|$)/;
var $a5cf0eae8608a64d$var$lheading = $a5cf0eae8608a64d$var$edit($a5cf0eae8608a64d$var$lheadingCore).replace(/bull/g, $a5cf0eae8608a64d$var$bullet).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/\|table/g, "").getRegex();
var $a5cf0eae8608a64d$var$lheadingGfm = $a5cf0eae8608a64d$var$edit($a5cf0eae8608a64d$var$lheadingCore).replace(/bull/g, $a5cf0eae8608a64d$var$bullet).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/table/g, / {0,3}\|?(?:[:\- ]*\|)+[\:\- ]*\n/).getRegex();
var $a5cf0eae8608a64d$var$_paragraph = /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/;
var $a5cf0eae8608a64d$var$blockText = /^[^\n]+/;
var $a5cf0eae8608a64d$var$_blockLabel = /(?!\s*\])(?:\\.|[^\[\]\\])+/;
var $a5cf0eae8608a64d$var$def = $a5cf0eae8608a64d$var$edit(/^ {0,3}\[(label)\]: *(?:\n[ \t]*)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n[ \t]*)?| *\n[ \t]*)(title))? *(?:\n+|$)/).replace("label", $a5cf0eae8608a64d$var$_blockLabel).replace("title", /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/).getRegex();
var $a5cf0eae8608a64d$var$list = $a5cf0eae8608a64d$var$edit(/^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/).replace(/bull/g, $a5cf0eae8608a64d$var$bullet).getRegex();
var $a5cf0eae8608a64d$var$_tag = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|search|section|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul";
var $a5cf0eae8608a64d$var$_comment = /<!--(?:-?>|[\s\S]*?(?:-->|$))/;
var $a5cf0eae8608a64d$var$html = $a5cf0eae8608a64d$var$edit("^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$))", "i").replace("comment", $a5cf0eae8608a64d$var$_comment).replace("tag", $a5cf0eae8608a64d$var$_tag).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex();
var $a5cf0eae8608a64d$var$paragraph = $a5cf0eae8608a64d$var$edit($a5cf0eae8608a64d$var$_paragraph).replace("hr", $a5cf0eae8608a64d$var$hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", $a5cf0eae8608a64d$var$_tag).getRegex();
var $a5cf0eae8608a64d$var$blockquote = $a5cf0eae8608a64d$var$edit(/^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/).replace("paragraph", $a5cf0eae8608a64d$var$paragraph).getRegex();
var $a5cf0eae8608a64d$var$blockNormal = {
    blockquote: $a5cf0eae8608a64d$var$blockquote,
    code: $a5cf0eae8608a64d$var$blockCode,
    def: $a5cf0eae8608a64d$var$def,
    fences: $a5cf0eae8608a64d$var$fences,
    heading: $a5cf0eae8608a64d$var$heading,
    hr: $a5cf0eae8608a64d$var$hr,
    html: $a5cf0eae8608a64d$var$html,
    lheading: $a5cf0eae8608a64d$var$lheading,
    list: $a5cf0eae8608a64d$var$list,
    newline: $a5cf0eae8608a64d$var$newline,
    paragraph: $a5cf0eae8608a64d$var$paragraph,
    table: $a5cf0eae8608a64d$var$noopTest,
    text: $a5cf0eae8608a64d$var$blockText
};
var $a5cf0eae8608a64d$var$gfmTable = $a5cf0eae8608a64d$var$edit("^ *([^\\n ].*)\\n {0,3}((?:\\| *)?:?-+:? *(?:\\| *:?-+:? *)*(?:\\| *)?)(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)").replace("hr", $a5cf0eae8608a64d$var$hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("blockquote", " {0,3}>").replace("code", "(?: {4}| {0,3}	)[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", $a5cf0eae8608a64d$var$_tag).getRegex();
var $a5cf0eae8608a64d$var$blockGfm = {
    ...$a5cf0eae8608a64d$var$blockNormal,
    lheading: $a5cf0eae8608a64d$var$lheadingGfm,
    table: $a5cf0eae8608a64d$var$gfmTable,
    paragraph: $a5cf0eae8608a64d$var$edit($a5cf0eae8608a64d$var$_paragraph).replace("hr", $a5cf0eae8608a64d$var$hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("table", $a5cf0eae8608a64d$var$gfmTable).replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", $a5cf0eae8608a64d$var$_tag).getRegex()
};
var $a5cf0eae8608a64d$var$blockPedantic = {
    ...$a5cf0eae8608a64d$var$blockNormal,
    html: $a5cf0eae8608a64d$var$edit(`^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:"[^"]*"|'[^']*'|\\s[^'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))`).replace("comment", $a5cf0eae8608a64d$var$_comment).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
    def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
    heading: /^(#{1,6})(.*)(?:\n+|$)/,
    fences: $a5cf0eae8608a64d$var$noopTest,
    // fences not supported
    lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
    paragraph: $a5cf0eae8608a64d$var$edit($a5cf0eae8608a64d$var$_paragraph).replace("hr", $a5cf0eae8608a64d$var$hr).replace("heading", " *#{1,6} *[^\n]").replace("lheading", $a5cf0eae8608a64d$var$lheading).replace("|table", "").replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").replace("|tag", "").getRegex()
};
var $a5cf0eae8608a64d$var$escape = /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/;
var $a5cf0eae8608a64d$var$inlineCode = /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/;
var $a5cf0eae8608a64d$var$br = /^( {2,}|\\)\n(?!\s*$)/;
var $a5cf0eae8608a64d$var$inlineText = /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/;
var $a5cf0eae8608a64d$var$_punctuation = /[\p{P}\p{S}]/u;
var $a5cf0eae8608a64d$var$_punctuationOrSpace = /[\s\p{P}\p{S}]/u;
var $a5cf0eae8608a64d$var$_notPunctuationOrSpace = /[^\s\p{P}\p{S}]/u;
var $a5cf0eae8608a64d$var$punctuation = $a5cf0eae8608a64d$var$edit(/^((?![*_])punctSpace)/, "u").replace(/punctSpace/g, $a5cf0eae8608a64d$var$_punctuationOrSpace).getRegex();
var $a5cf0eae8608a64d$var$_punctuationGfmStrongEm = /(?!~)[\p{P}\p{S}]/u;
var $a5cf0eae8608a64d$var$_punctuationOrSpaceGfmStrongEm = /(?!~)[\s\p{P}\p{S}]/u;
var $a5cf0eae8608a64d$var$_notPunctuationOrSpaceGfmStrongEm = /(?:[^\s\p{P}\p{S}]|~)/u;
var $a5cf0eae8608a64d$var$blockSkip = /\[[^[\]]*?\]\((?:\\.|[^\\\(\)]|\((?:\\.|[^\\\(\)])*\))*\)|`[^`]*?`|<[^<>]*?>/g;
var $a5cf0eae8608a64d$var$emStrongLDelimCore = /^(?:\*+(?:((?!\*)punct)|[^\s*]))|^_+(?:((?!_)punct)|([^\s_]))/;
var $a5cf0eae8608a64d$var$emStrongLDelim = $a5cf0eae8608a64d$var$edit($a5cf0eae8608a64d$var$emStrongLDelimCore, "u").replace(/punct/g, $a5cf0eae8608a64d$var$_punctuation).getRegex();
var $a5cf0eae8608a64d$var$emStrongLDelimGfm = $a5cf0eae8608a64d$var$edit($a5cf0eae8608a64d$var$emStrongLDelimCore, "u").replace(/punct/g, $a5cf0eae8608a64d$var$_punctuationGfmStrongEm).getRegex();
var $a5cf0eae8608a64d$var$emStrongRDelimAstCore = "^[^_*]*?__[^_*]*?\\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\\*)punct(\\*+)(?=[\\s]|$)|notPunctSpace(\\*+)(?!\\*)(?=punctSpace|$)|(?!\\*)punctSpace(\\*+)(?=notPunctSpace)|[\\s](\\*+)(?!\\*)(?=punct)|(?!\\*)punct(\\*+)(?!\\*)(?=punct)|notPunctSpace(\\*+)(?=notPunctSpace)";
var $a5cf0eae8608a64d$var$emStrongRDelimAst = $a5cf0eae8608a64d$var$edit($a5cf0eae8608a64d$var$emStrongRDelimAstCore, "gu").replace(/notPunctSpace/g, $a5cf0eae8608a64d$var$_notPunctuationOrSpace).replace(/punctSpace/g, $a5cf0eae8608a64d$var$_punctuationOrSpace).replace(/punct/g, $a5cf0eae8608a64d$var$_punctuation).getRegex();
var $a5cf0eae8608a64d$var$emStrongRDelimAstGfm = $a5cf0eae8608a64d$var$edit($a5cf0eae8608a64d$var$emStrongRDelimAstCore, "gu").replace(/notPunctSpace/g, $a5cf0eae8608a64d$var$_notPunctuationOrSpaceGfmStrongEm).replace(/punctSpace/g, $a5cf0eae8608a64d$var$_punctuationOrSpaceGfmStrongEm).replace(/punct/g, $a5cf0eae8608a64d$var$_punctuationGfmStrongEm).getRegex();
var $a5cf0eae8608a64d$var$emStrongRDelimUnd = $a5cf0eae8608a64d$var$edit("^[^_*]*?\\*\\*[^_*]*?_[^_*]*?(?=\\*\\*)|[^_]+(?=[^_])|(?!_)punct(_+)(?=[\\s]|$)|notPunctSpace(_+)(?!_)(?=punctSpace|$)|(?!_)punctSpace(_+)(?=notPunctSpace)|[\\s](_+)(?!_)(?=punct)|(?!_)punct(_+)(?!_)(?=punct)", "gu").replace(/notPunctSpace/g, $a5cf0eae8608a64d$var$_notPunctuationOrSpace).replace(/punctSpace/g, $a5cf0eae8608a64d$var$_punctuationOrSpace).replace(/punct/g, $a5cf0eae8608a64d$var$_punctuation).getRegex();
var $a5cf0eae8608a64d$var$anyPunctuation = $a5cf0eae8608a64d$var$edit(/\\(punct)/, "gu").replace(/punct/g, $a5cf0eae8608a64d$var$_punctuation).getRegex();
var $a5cf0eae8608a64d$var$autolink = $a5cf0eae8608a64d$var$edit(/^<(scheme:[^\s\x00-\x1f<>]*|email)>/).replace("scheme", /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/).replace("email", /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/).getRegex();
var $a5cf0eae8608a64d$var$_inlineComment = $a5cf0eae8608a64d$var$edit($a5cf0eae8608a64d$var$_comment).replace("(?:-->|$)", "-->").getRegex();
var $a5cf0eae8608a64d$var$tag = $a5cf0eae8608a64d$var$edit("^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>").replace("comment", $a5cf0eae8608a64d$var$_inlineComment).replace("attribute", /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/).getRegex();
var $a5cf0eae8608a64d$var$_inlineLabel = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
var $a5cf0eae8608a64d$var$link = $a5cf0eae8608a64d$var$edit(/^!?\[(label)\]\(\s*(href)(?:(?:[ \t]*(?:\n[ \t]*)?)(title))?\s*\)/).replace("label", $a5cf0eae8608a64d$var$_inlineLabel).replace("href", /<(?:\\.|[^\n<>\\])+>|[^ \t\n\x00-\x1f]*/).replace("title", /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/).getRegex();
var $a5cf0eae8608a64d$var$reflink = $a5cf0eae8608a64d$var$edit(/^!?\[(label)\]\[(ref)\]/).replace("label", $a5cf0eae8608a64d$var$_inlineLabel).replace("ref", $a5cf0eae8608a64d$var$_blockLabel).getRegex();
var $a5cf0eae8608a64d$var$nolink = $a5cf0eae8608a64d$var$edit(/^!?\[(ref)\](?:\[\])?/).replace("ref", $a5cf0eae8608a64d$var$_blockLabel).getRegex();
var $a5cf0eae8608a64d$var$reflinkSearch = $a5cf0eae8608a64d$var$edit("reflink|nolink(?!\\()", "g").replace("reflink", $a5cf0eae8608a64d$var$reflink).replace("nolink", $a5cf0eae8608a64d$var$nolink).getRegex();
var $a5cf0eae8608a64d$var$inlineNormal = {
    _backpedal: $a5cf0eae8608a64d$var$noopTest,
    anyPunctuation: // only used for GFM url
    $a5cf0eae8608a64d$var$anyPunctuation,
    autolink: $a5cf0eae8608a64d$var$autolink,
    blockSkip: $a5cf0eae8608a64d$var$blockSkip,
    br: $a5cf0eae8608a64d$var$br,
    code: $a5cf0eae8608a64d$var$inlineCode,
    del: $a5cf0eae8608a64d$var$noopTest,
    emStrongLDelim: $a5cf0eae8608a64d$var$emStrongLDelim,
    emStrongRDelimAst: $a5cf0eae8608a64d$var$emStrongRDelimAst,
    emStrongRDelimUnd: $a5cf0eae8608a64d$var$emStrongRDelimUnd,
    escape: $a5cf0eae8608a64d$var$escape,
    link: $a5cf0eae8608a64d$var$link,
    nolink: $a5cf0eae8608a64d$var$nolink,
    punctuation: $a5cf0eae8608a64d$var$punctuation,
    reflink: $a5cf0eae8608a64d$var$reflink,
    reflinkSearch: $a5cf0eae8608a64d$var$reflinkSearch,
    tag: $a5cf0eae8608a64d$var$tag,
    text: $a5cf0eae8608a64d$var$inlineText,
    url: $a5cf0eae8608a64d$var$noopTest
};
var $a5cf0eae8608a64d$var$inlinePedantic = {
    ...$a5cf0eae8608a64d$var$inlineNormal,
    link: $a5cf0eae8608a64d$var$edit(/^!?\[(label)\]\((.*?)\)/).replace("label", $a5cf0eae8608a64d$var$_inlineLabel).getRegex(),
    reflink: $a5cf0eae8608a64d$var$edit(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", $a5cf0eae8608a64d$var$_inlineLabel).getRegex()
};
var $a5cf0eae8608a64d$var$inlineGfm = {
    ...$a5cf0eae8608a64d$var$inlineNormal,
    emStrongRDelimAst: $a5cf0eae8608a64d$var$emStrongRDelimAstGfm,
    emStrongLDelim: $a5cf0eae8608a64d$var$emStrongLDelimGfm,
    url: $a5cf0eae8608a64d$var$edit(/^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/, "i").replace("email", /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/).getRegex(),
    _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
    del: /^(~~?)(?=[^\s~])((?:\\.|[^\\])*?(?:\\.|[^\s~\\]))\1(?=[^~]|$)/,
    text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
};
var $a5cf0eae8608a64d$var$inlineBreaks = {
    ...$a5cf0eae8608a64d$var$inlineGfm,
    br: $a5cf0eae8608a64d$var$edit($a5cf0eae8608a64d$var$br).replace("{2,}", "*").getRegex(),
    text: $a5cf0eae8608a64d$var$edit($a5cf0eae8608a64d$var$inlineGfm.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
};
var $a5cf0eae8608a64d$var$block = {
    normal: $a5cf0eae8608a64d$var$blockNormal,
    gfm: $a5cf0eae8608a64d$var$blockGfm,
    pedantic: $a5cf0eae8608a64d$var$blockPedantic
};
var $a5cf0eae8608a64d$var$inline = {
    normal: $a5cf0eae8608a64d$var$inlineNormal,
    gfm: $a5cf0eae8608a64d$var$inlineGfm,
    breaks: $a5cf0eae8608a64d$var$inlineBreaks,
    pedantic: $a5cf0eae8608a64d$var$inlinePedantic
};
// src/helpers.ts
var $a5cf0eae8608a64d$var$escapeReplacements = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
};
var $a5cf0eae8608a64d$var$getEscapeReplacement = (ch)=>$a5cf0eae8608a64d$var$escapeReplacements[ch];
function $a5cf0eae8608a64d$var$escape2(html2, encode) {
    if (encode) {
        if ($a5cf0eae8608a64d$var$other.escapeTest.test(html2)) return html2.replace($a5cf0eae8608a64d$var$other.escapeReplace, $a5cf0eae8608a64d$var$getEscapeReplacement);
    } else {
        if ($a5cf0eae8608a64d$var$other.escapeTestNoEncode.test(html2)) return html2.replace($a5cf0eae8608a64d$var$other.escapeReplaceNoEncode, $a5cf0eae8608a64d$var$getEscapeReplacement);
    }
    return html2;
}
function $a5cf0eae8608a64d$var$cleanUrl(href) {
    try {
        href = encodeURI(href).replace($a5cf0eae8608a64d$var$other.percentDecode, "%");
    } catch  {
        return null;
    }
    return href;
}
function $a5cf0eae8608a64d$var$splitCells(tableRow, count) {
    const row = tableRow.replace($a5cf0eae8608a64d$var$other.findPipe, (match, offset, str)=>{
        let escaped = false;
        let curr = offset;
        while(--curr >= 0 && str[curr] === "\\")escaped = !escaped;
        if (escaped) return "|";
        else return " |";
    }), cells = row.split($a5cf0eae8608a64d$var$other.splitPipe);
    let i = 0;
    if (!cells[0].trim()) cells.shift();
    if (cells.length > 0 && !cells.at(-1)?.trim()) cells.pop();
    if (count) {
        if (cells.length > count) cells.splice(count);
        else while(cells.length < count)cells.push("");
    }
    for(; i < cells.length; i++)cells[i] = cells[i].trim().replace($a5cf0eae8608a64d$var$other.slashPipe, "|");
    return cells;
}
function $a5cf0eae8608a64d$var$rtrim(str, c, invert) {
    const l = str.length;
    if (l === 0) return "";
    let suffLen = 0;
    while(suffLen < l){
        const currChar = str.charAt(l - suffLen - 1);
        if (currChar === c && !invert) suffLen++;
        else if (currChar !== c && invert) suffLen++;
        else break;
    }
    return str.slice(0, l - suffLen);
}
function $a5cf0eae8608a64d$var$findClosingBracket(str, b) {
    if (str.indexOf(b[1]) === -1) return -1;
    let level = 0;
    for(let i = 0; i < str.length; i++){
        if (str[i] === "\\") i++;
        else if (str[i] === b[0]) level++;
        else if (str[i] === b[1]) {
            level--;
            if (level < 0) return i;
        }
    }
    if (level > 0) return -2;
    return -1;
}
// src/Tokenizer.ts
function $a5cf0eae8608a64d$var$outputLink(cap, link2, raw, lexer2, rules) {
    const href = link2.href;
    const title = link2.title || null;
    const text = cap[1].replace(rules.other.outputLinkReplace, "$1");
    lexer2.state.inLink = true;
    const token = {
        type: cap[0].charAt(0) === "!" ? "image" : "link",
        raw: raw,
        href: href,
        title: title,
        text: text,
        tokens: lexer2.inlineTokens(text)
    };
    lexer2.state.inLink = false;
    return token;
}
function $a5cf0eae8608a64d$var$indentCodeCompensation(raw, text, rules) {
    const matchIndentToCode = raw.match(rules.other.indentCodeCompensation);
    if (matchIndentToCode === null) return text;
    const indentToCode = matchIndentToCode[1];
    return text.split("\n").map((node)=>{
        const matchIndentInNode = node.match(rules.other.beginningSpace);
        if (matchIndentInNode === null) return node;
        const [indentInNode] = matchIndentInNode;
        if (indentInNode.length >= indentToCode.length) return node.slice(indentToCode.length);
        return node;
    }).join("\n");
}
var $a5cf0eae8608a64d$export$55e8b082af4aa63e = class {
    options;
    rules;
    // set by the lexer
    lexer;
    // set by the lexer
    constructor(options2){
        this.options = options2 || $a5cf0eae8608a64d$export$ebe90cb607ad99e;
    }
    space(src) {
        const cap = this.rules.block.newline.exec(src);
        if (cap && cap[0].length > 0) return {
            type: "space",
            raw: cap[0]
        };
    }
    code(src) {
        const cap = this.rules.block.code.exec(src);
        if (cap) {
            const text = cap[0].replace(this.rules.other.codeRemoveIndent, "");
            return {
                type: "code",
                raw: cap[0],
                codeBlockStyle: "indented",
                text: !this.options.pedantic ? $a5cf0eae8608a64d$var$rtrim(text, "\n") : text
            };
        }
    }
    fences(src) {
        const cap = this.rules.block.fences.exec(src);
        if (cap) {
            const raw = cap[0];
            const text = $a5cf0eae8608a64d$var$indentCodeCompensation(raw, cap[3] || "", this.rules);
            return {
                type: "code",
                raw: raw,
                lang: cap[2] ? cap[2].trim().replace(this.rules.inline.anyPunctuation, "$1") : cap[2],
                text: text
            };
        }
    }
    heading(src) {
        const cap = this.rules.block.heading.exec(src);
        if (cap) {
            let text = cap[2].trim();
            if (this.rules.other.endingHash.test(text)) {
                const trimmed = $a5cf0eae8608a64d$var$rtrim(text, "#");
                if (this.options.pedantic) text = trimmed.trim();
                else if (!trimmed || this.rules.other.endingSpaceChar.test(trimmed)) text = trimmed.trim();
            }
            return {
                type: "heading",
                raw: cap[0],
                depth: cap[1].length,
                text: text,
                tokens: this.lexer.inline(text)
            };
        }
    }
    hr(src) {
        const cap = this.rules.block.hr.exec(src);
        if (cap) return {
            type: "hr",
            raw: $a5cf0eae8608a64d$var$rtrim(cap[0], "\n")
        };
    }
    blockquote(src) {
        const cap = this.rules.block.blockquote.exec(src);
        if (cap) {
            let lines = $a5cf0eae8608a64d$var$rtrim(cap[0], "\n").split("\n");
            let raw = "";
            let text = "";
            const tokens = [];
            while(lines.length > 0){
                let inBlockquote = false;
                const currentLines = [];
                let i;
                for(i = 0; i < lines.length; i++){
                    if (this.rules.other.blockquoteStart.test(lines[i])) {
                        currentLines.push(lines[i]);
                        inBlockquote = true;
                    } else if (!inBlockquote) currentLines.push(lines[i]);
                    else break;
                }
                lines = lines.slice(i);
                const currentRaw = currentLines.join("\n");
                const currentText = currentRaw.replace(this.rules.other.blockquoteSetextReplace, "\n    $1").replace(this.rules.other.blockquoteSetextReplace2, "");
                raw = raw ? `${raw}
${currentRaw}` : currentRaw;
                text = text ? `${text}
${currentText}` : currentText;
                const top = this.lexer.state.top;
                this.lexer.state.top = true;
                this.lexer.blockTokens(currentText, tokens, true);
                this.lexer.state.top = top;
                if (lines.length === 0) break;
                const lastToken = tokens.at(-1);
                if (lastToken?.type === "code") break;
                else if (lastToken?.type === "blockquote") {
                    const oldToken = lastToken;
                    const newText = oldToken.raw + "\n" + lines.join("\n");
                    const newToken = this.blockquote(newText);
                    tokens[tokens.length - 1] = newToken;
                    raw = raw.substring(0, raw.length - oldToken.raw.length) + newToken.raw;
                    text = text.substring(0, text.length - oldToken.text.length) + newToken.text;
                    break;
                } else if (lastToken?.type === "list") {
                    const oldToken = lastToken;
                    const newText = oldToken.raw + "\n" + lines.join("\n");
                    const newToken = this.list(newText);
                    tokens[tokens.length - 1] = newToken;
                    raw = raw.substring(0, raw.length - lastToken.raw.length) + newToken.raw;
                    text = text.substring(0, text.length - oldToken.raw.length) + newToken.raw;
                    lines = newText.substring(tokens.at(-1).raw.length).split("\n");
                    continue;
                }
            }
            return {
                type: "blockquote",
                raw: raw,
                tokens: tokens,
                text: text
            };
        }
    }
    list(src) {
        let cap = this.rules.block.list.exec(src);
        if (cap) {
            let bull = cap[1].trim();
            const isordered = bull.length > 1;
            const list2 = {
                type: "list",
                raw: "",
                ordered: isordered,
                start: isordered ? +bull.slice(0, -1) : "",
                loose: false,
                items: []
            };
            bull = isordered ? `\\d{1,9}\\${bull.slice(-1)}` : `\\${bull}`;
            if (this.options.pedantic) bull = isordered ? bull : "[*+-]";
            const itemRegex = this.rules.other.listItemRegex(bull);
            let endsWithBlankLine = false;
            while(src){
                let endEarly = false;
                let raw = "";
                let itemContents = "";
                if (!(cap = itemRegex.exec(src))) break;
                if (this.rules.block.hr.test(src)) break;
                raw = cap[0];
                src = src.substring(raw.length);
                let line = cap[2].split("\n", 1)[0].replace(this.rules.other.listReplaceTabs, (t)=>" ".repeat(3 * t.length));
                let nextLine = src.split("\n", 1)[0];
                let blankLine = !line.trim();
                let indent = 0;
                if (this.options.pedantic) {
                    indent = 2;
                    itemContents = line.trimStart();
                } else if (blankLine) indent = cap[1].length + 1;
                else {
                    indent = cap[2].search(this.rules.other.nonSpaceChar);
                    indent = indent > 4 ? 1 : indent;
                    itemContents = line.slice(indent);
                    indent += cap[1].length;
                }
                if (blankLine && this.rules.other.blankLine.test(nextLine)) {
                    raw += nextLine + "\n";
                    src = src.substring(nextLine.length + 1);
                    endEarly = true;
                }
                if (!endEarly) {
                    const nextBulletRegex = this.rules.other.nextBulletRegex(indent);
                    const hrRegex = this.rules.other.hrRegex(indent);
                    const fencesBeginRegex = this.rules.other.fencesBeginRegex(indent);
                    const headingBeginRegex = this.rules.other.headingBeginRegex(indent);
                    const htmlBeginRegex = this.rules.other.htmlBeginRegex(indent);
                    while(src){
                        const rawLine = src.split("\n", 1)[0];
                        let nextLineWithoutTabs;
                        nextLine = rawLine;
                        if (this.options.pedantic) {
                            nextLine = nextLine.replace(this.rules.other.listReplaceNesting, "  ");
                            nextLineWithoutTabs = nextLine;
                        } else nextLineWithoutTabs = nextLine.replace(this.rules.other.tabCharGlobal, "    ");
                        if (fencesBeginRegex.test(nextLine)) break;
                        if (headingBeginRegex.test(nextLine)) break;
                        if (htmlBeginRegex.test(nextLine)) break;
                        if (nextBulletRegex.test(nextLine)) break;
                        if (hrRegex.test(nextLine)) break;
                        if (nextLineWithoutTabs.search(this.rules.other.nonSpaceChar) >= indent || !nextLine.trim()) itemContents += "\n" + nextLineWithoutTabs.slice(indent);
                        else {
                            if (blankLine) break;
                            if (line.replace(this.rules.other.tabCharGlobal, "    ").search(this.rules.other.nonSpaceChar) >= 4) break;
                            if (fencesBeginRegex.test(line)) break;
                            if (headingBeginRegex.test(line)) break;
                            if (hrRegex.test(line)) break;
                            itemContents += "\n" + nextLine;
                        }
                        if (!blankLine && !nextLine.trim()) blankLine = true;
                        raw += rawLine + "\n";
                        src = src.substring(rawLine.length + 1);
                        line = nextLineWithoutTabs.slice(indent);
                    }
                }
                if (!list2.loose) {
                    if (endsWithBlankLine) list2.loose = true;
                    else if (this.rules.other.doubleBlankLine.test(raw)) endsWithBlankLine = true;
                }
                let istask = null;
                let ischecked;
                if (this.options.gfm) {
                    istask = this.rules.other.listIsTask.exec(itemContents);
                    if (istask) {
                        ischecked = istask[0] !== "[ ] ";
                        itemContents = itemContents.replace(this.rules.other.listReplaceTask, "");
                    }
                }
                list2.items.push({
                    type: "list_item",
                    raw: raw,
                    task: !!istask,
                    checked: ischecked,
                    loose: false,
                    text: itemContents,
                    tokens: []
                });
                list2.raw += raw;
            }
            const lastItem = list2.items.at(-1);
            if (lastItem) {
                lastItem.raw = lastItem.raw.trimEnd();
                lastItem.text = lastItem.text.trimEnd();
            } else return;
            list2.raw = list2.raw.trimEnd();
            for(let i = 0; i < list2.items.length; i++){
                this.lexer.state.top = false;
                list2.items[i].tokens = this.lexer.blockTokens(list2.items[i].text, []);
                if (!list2.loose) {
                    const spacers = list2.items[i].tokens.filter((t)=>t.type === "space");
                    const hasMultipleLineBreaks = spacers.length > 0 && spacers.some((t)=>this.rules.other.anyLine.test(t.raw));
                    list2.loose = hasMultipleLineBreaks;
                }
            }
            if (list2.loose) for(let i = 0; i < list2.items.length; i++)list2.items[i].loose = true;
            return list2;
        }
    }
    html(src) {
        const cap = this.rules.block.html.exec(src);
        if (cap) {
            const token = {
                type: "html",
                block: true,
                raw: cap[0],
                pre: cap[1] === "pre" || cap[1] === "script" || cap[1] === "style",
                text: cap[0]
            };
            return token;
        }
    }
    def(src) {
        const cap = this.rules.block.def.exec(src);
        if (cap) {
            const tag2 = cap[1].toLowerCase().replace(this.rules.other.multipleSpaceGlobal, " ");
            const href = cap[2] ? cap[2].replace(this.rules.other.hrefBrackets, "$1").replace(this.rules.inline.anyPunctuation, "$1") : "";
            const title = cap[3] ? cap[3].substring(1, cap[3].length - 1).replace(this.rules.inline.anyPunctuation, "$1") : cap[3];
            return {
                type: "def",
                tag: tag2,
                raw: cap[0],
                href: href,
                title: title
            };
        }
    }
    table(src) {
        const cap = this.rules.block.table.exec(src);
        if (!cap) return;
        if (!this.rules.other.tableDelimiter.test(cap[2])) return;
        const headers = $a5cf0eae8608a64d$var$splitCells(cap[1]);
        const aligns = cap[2].replace(this.rules.other.tableAlignChars, "").split("|");
        const rows = cap[3]?.trim() ? cap[3].replace(this.rules.other.tableRowBlankLine, "").split("\n") : [];
        const item = {
            type: "table",
            raw: cap[0],
            header: [],
            align: [],
            rows: []
        };
        if (headers.length !== aligns.length) return;
        for (const align of aligns){
            if (this.rules.other.tableAlignRight.test(align)) item.align.push("right");
            else if (this.rules.other.tableAlignCenter.test(align)) item.align.push("center");
            else if (this.rules.other.tableAlignLeft.test(align)) item.align.push("left");
            else item.align.push(null);
        }
        for(let i = 0; i < headers.length; i++)item.header.push({
            text: headers[i],
            tokens: this.lexer.inline(headers[i]),
            header: true,
            align: item.align[i]
        });
        for (const row of rows)item.rows.push($a5cf0eae8608a64d$var$splitCells(row, item.header.length).map((cell, i)=>{
            return {
                text: cell,
                tokens: this.lexer.inline(cell),
                header: false,
                align: item.align[i]
            };
        }));
        return item;
    }
    lheading(src) {
        const cap = this.rules.block.lheading.exec(src);
        if (cap) return {
            type: "heading",
            raw: cap[0],
            depth: cap[2].charAt(0) === "=" ? 1 : 2,
            text: cap[1],
            tokens: this.lexer.inline(cap[1])
        };
    }
    paragraph(src) {
        const cap = this.rules.block.paragraph.exec(src);
        if (cap) {
            const text = cap[1].charAt(cap[1].length - 1) === "\n" ? cap[1].slice(0, -1) : cap[1];
            return {
                type: "paragraph",
                raw: cap[0],
                text: text,
                tokens: this.lexer.inline(text)
            };
        }
    }
    text(src) {
        const cap = this.rules.block.text.exec(src);
        if (cap) return {
            type: "text",
            raw: cap[0],
            text: cap[0],
            tokens: this.lexer.inline(cap[0])
        };
    }
    escape(src) {
        const cap = this.rules.inline.escape.exec(src);
        if (cap) return {
            type: "escape",
            raw: cap[0],
            text: cap[1]
        };
    }
    tag(src) {
        const cap = this.rules.inline.tag.exec(src);
        if (cap) {
            if (!this.lexer.state.inLink && this.rules.other.startATag.test(cap[0])) this.lexer.state.inLink = true;
            else if (this.lexer.state.inLink && this.rules.other.endATag.test(cap[0])) this.lexer.state.inLink = false;
            if (!this.lexer.state.inRawBlock && this.rules.other.startPreScriptTag.test(cap[0])) this.lexer.state.inRawBlock = true;
            else if (this.lexer.state.inRawBlock && this.rules.other.endPreScriptTag.test(cap[0])) this.lexer.state.inRawBlock = false;
            return {
                type: "html",
                raw: cap[0],
                inLink: this.lexer.state.inLink,
                inRawBlock: this.lexer.state.inRawBlock,
                block: false,
                text: cap[0]
            };
        }
    }
    link(src) {
        const cap = this.rules.inline.link.exec(src);
        if (cap) {
            const trimmedUrl = cap[2].trim();
            if (!this.options.pedantic && this.rules.other.startAngleBracket.test(trimmedUrl)) {
                if (!this.rules.other.endAngleBracket.test(trimmedUrl)) return;
                const rtrimSlash = $a5cf0eae8608a64d$var$rtrim(trimmedUrl.slice(0, -1), "\\");
                if ((trimmedUrl.length - rtrimSlash.length) % 2 === 0) return;
            } else {
                const lastParenIndex = $a5cf0eae8608a64d$var$findClosingBracket(cap[2], "()");
                if (lastParenIndex === -2) return;
                if (lastParenIndex > -1) {
                    const start = cap[0].indexOf("!") === 0 ? 5 : 4;
                    const linkLen = start + cap[1].length + lastParenIndex;
                    cap[2] = cap[2].substring(0, lastParenIndex);
                    cap[0] = cap[0].substring(0, linkLen).trim();
                    cap[3] = "";
                }
            }
            let href = cap[2];
            let title = "";
            if (this.options.pedantic) {
                const link2 = this.rules.other.pedanticHrefTitle.exec(href);
                if (link2) {
                    href = link2[1];
                    title = link2[3];
                }
            } else title = cap[3] ? cap[3].slice(1, -1) : "";
            href = href.trim();
            if (this.rules.other.startAngleBracket.test(href)) {
                if (this.options.pedantic && !this.rules.other.endAngleBracket.test(trimmedUrl)) href = href.slice(1);
                else href = href.slice(1, -1);
            }
            return $a5cf0eae8608a64d$var$outputLink(cap, {
                href: href ? href.replace(this.rules.inline.anyPunctuation, "$1") : href,
                title: title ? title.replace(this.rules.inline.anyPunctuation, "$1") : title
            }, cap[0], this.lexer, this.rules);
        }
    }
    reflink(src, links) {
        let cap;
        if ((cap = this.rules.inline.reflink.exec(src)) || (cap = this.rules.inline.nolink.exec(src))) {
            const linkString = (cap[2] || cap[1]).replace(this.rules.other.multipleSpaceGlobal, " ");
            const link2 = links[linkString.toLowerCase()];
            if (!link2) {
                const text = cap[0].charAt(0);
                return {
                    type: "text",
                    raw: text,
                    text: text
                };
            }
            return $a5cf0eae8608a64d$var$outputLink(cap, link2, cap[0], this.lexer, this.rules);
        }
    }
    emStrong(src, maskedSrc, prevChar = "") {
        let match = this.rules.inline.emStrongLDelim.exec(src);
        if (!match) return;
        if (match[3] && prevChar.match(this.rules.other.unicodeAlphaNumeric)) return;
        const nextChar = match[1] || match[2] || "";
        if (!nextChar || !prevChar || this.rules.inline.punctuation.exec(prevChar)) {
            const lLength = [
                ...match[0]
            ].length - 1;
            let rDelim, rLength, delimTotal = lLength, midDelimTotal = 0;
            const endReg = match[0][0] === "*" ? this.rules.inline.emStrongRDelimAst : this.rules.inline.emStrongRDelimUnd;
            endReg.lastIndex = 0;
            maskedSrc = maskedSrc.slice(-1 * src.length + lLength);
            while((match = endReg.exec(maskedSrc)) != null){
                rDelim = match[1] || match[2] || match[3] || match[4] || match[5] || match[6];
                if (!rDelim) continue;
                rLength = [
                    ...rDelim
                ].length;
                if (match[3] || match[4]) {
                    delimTotal += rLength;
                    continue;
                } else if (match[5] || match[6]) {
                    if (lLength % 3 && !((lLength + rLength) % 3)) {
                        midDelimTotal += rLength;
                        continue;
                    }
                }
                delimTotal -= rLength;
                if (delimTotal > 0) continue;
                rLength = Math.min(rLength, rLength + delimTotal + midDelimTotal);
                const lastCharLength = [
                    ...match[0]
                ][0].length;
                const raw = src.slice(0, lLength + match.index + lastCharLength + rLength);
                if (Math.min(lLength, rLength) % 2) {
                    const text2 = raw.slice(1, -1);
                    return {
                        type: "em",
                        raw: raw,
                        text: text2,
                        tokens: this.lexer.inlineTokens(text2)
                    };
                }
                const text = raw.slice(2, -2);
                return {
                    type: "strong",
                    raw: raw,
                    text: text,
                    tokens: this.lexer.inlineTokens(text)
                };
            }
        }
    }
    codespan(src) {
        const cap = this.rules.inline.code.exec(src);
        if (cap) {
            let text = cap[2].replace(this.rules.other.newLineCharGlobal, " ");
            const hasNonSpaceChars = this.rules.other.nonSpaceChar.test(text);
            const hasSpaceCharsOnBothEnds = this.rules.other.startingSpaceChar.test(text) && this.rules.other.endingSpaceChar.test(text);
            if (hasNonSpaceChars && hasSpaceCharsOnBothEnds) text = text.substring(1, text.length - 1);
            return {
                type: "codespan",
                raw: cap[0],
                text: text
            };
        }
    }
    br(src) {
        const cap = this.rules.inline.br.exec(src);
        if (cap) return {
            type: "br",
            raw: cap[0]
        };
    }
    del(src) {
        const cap = this.rules.inline.del.exec(src);
        if (cap) return {
            type: "del",
            raw: cap[0],
            text: cap[2],
            tokens: this.lexer.inlineTokens(cap[2])
        };
    }
    autolink(src) {
        const cap = this.rules.inline.autolink.exec(src);
        if (cap) {
            let text, href;
            if (cap[2] === "@") {
                text = cap[1];
                href = "mailto:" + text;
            } else {
                text = cap[1];
                href = text;
            }
            return {
                type: "link",
                raw: cap[0],
                text: text,
                href: href,
                tokens: [
                    {
                        type: "text",
                        raw: text,
                        text: text
                    }
                ]
            };
        }
    }
    url(src) {
        let cap;
        if (cap = this.rules.inline.url.exec(src)) {
            let text, href;
            if (cap[2] === "@") {
                text = cap[0];
                href = "mailto:" + text;
            } else {
                let prevCapZero;
                do {
                    prevCapZero = cap[0];
                    cap[0] = this.rules.inline._backpedal.exec(cap[0])?.[0] ?? "";
                }while (prevCapZero !== cap[0]);
                text = cap[0];
                if (cap[1] === "www.") href = "http://" + cap[0];
                else href = cap[0];
            }
            return {
                type: "link",
                raw: cap[0],
                text: text,
                href: href,
                tokens: [
                    {
                        type: "text",
                        raw: text,
                        text: text
                    }
                ]
            };
        }
    }
    inlineText(src) {
        const cap = this.rules.inline.text.exec(src);
        if (cap) {
            const escaped = this.lexer.state.inRawBlock;
            return {
                type: "text",
                raw: cap[0],
                text: cap[0],
                escaped: escaped
            };
        }
    }
};
// src/Lexer.ts
var $a5cf0eae8608a64d$export$6168dc8908a6c652 = class __Lexer {
    tokens;
    options;
    state;
    tokenizer;
    inlineQueue;
    constructor(options2){
        this.tokens = [];
        this.tokens.links = /* @__PURE__ */ Object.create(null);
        this.options = options2 || $a5cf0eae8608a64d$export$ebe90cb607ad99e;
        this.options.tokenizer = this.options.tokenizer || new $a5cf0eae8608a64d$export$55e8b082af4aa63e();
        this.tokenizer = this.options.tokenizer;
        this.tokenizer.options = this.options;
        this.tokenizer.lexer = this;
        this.inlineQueue = [];
        this.state = {
            inLink: false,
            inRawBlock: false,
            top: true
        };
        const rules = {
            other: $a5cf0eae8608a64d$var$other,
            block: $a5cf0eae8608a64d$var$block.normal,
            inline: $a5cf0eae8608a64d$var$inline.normal
        };
        if (this.options.pedantic) {
            rules.block = $a5cf0eae8608a64d$var$block.pedantic;
            rules.inline = $a5cf0eae8608a64d$var$inline.pedantic;
        } else if (this.options.gfm) {
            rules.block = $a5cf0eae8608a64d$var$block.gfm;
            if (this.options.breaks) rules.inline = $a5cf0eae8608a64d$var$inline.breaks;
            else rules.inline = $a5cf0eae8608a64d$var$inline.gfm;
        }
        this.tokenizer.rules = rules;
    }
    /**
   * Expose Rules
   */ static get rules() {
        return {
            block: $a5cf0eae8608a64d$var$block,
            inline: $a5cf0eae8608a64d$var$inline
        };
    }
    /**
   * Static Lex Method
   */ static lex(src, options2) {
        const lexer2 = new __Lexer(options2);
        return lexer2.lex(src);
    }
    /**
   * Static Lex Inline Method
   */ static lexInline(src, options2) {
        const lexer2 = new __Lexer(options2);
        return lexer2.inlineTokens(src);
    }
    /**
   * Preprocessing
   */ lex(src) {
        src = src.replace($a5cf0eae8608a64d$var$other.carriageReturn, "\n");
        this.blockTokens(src, this.tokens);
        for(let i = 0; i < this.inlineQueue.length; i++){
            const next = this.inlineQueue[i];
            this.inlineTokens(next.src, next.tokens);
        }
        this.inlineQueue = [];
        return this.tokens;
    }
    blockTokens(src, tokens = [], lastParagraphClipped = false) {
        if (this.options.pedantic) src = src.replace($a5cf0eae8608a64d$var$other.tabCharGlobal, "    ").replace($a5cf0eae8608a64d$var$other.spaceLine, "");
        while(src){
            let token;
            if (this.options.extensions?.block?.some((extTokenizer)=>{
                if (token = extTokenizer.call({
                    lexer: this
                }, src, tokens)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    return true;
                }
                return false;
            })) continue;
            if (token = this.tokenizer.space(src)) {
                src = src.substring(token.raw.length);
                const lastToken = tokens.at(-1);
                if (token.raw.length === 1 && lastToken !== void 0) lastToken.raw += "\n";
                else tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.code(src)) {
                src = src.substring(token.raw.length);
                const lastToken = tokens.at(-1);
                if (lastToken?.type === "paragraph" || lastToken?.type === "text") {
                    lastToken.raw += "\n" + token.raw;
                    lastToken.text += "\n" + token.text;
                    this.inlineQueue.at(-1).src = lastToken.text;
                } else tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.fences(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.heading(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.hr(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.blockquote(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.list(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.html(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.def(src)) {
                src = src.substring(token.raw.length);
                const lastToken = tokens.at(-1);
                if (lastToken?.type === "paragraph" || lastToken?.type === "text") {
                    lastToken.raw += "\n" + token.raw;
                    lastToken.text += "\n" + token.raw;
                    this.inlineQueue.at(-1).src = lastToken.text;
                } else if (!this.tokens.links[token.tag]) this.tokens.links[token.tag] = {
                    href: token.href,
                    title: token.title
                };
                continue;
            }
            if (token = this.tokenizer.table(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.lheading(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            let cutSrc = src;
            if (this.options.extensions?.startBlock) {
                let startIndex = Infinity;
                const tempSrc = src.slice(1);
                let tempStart;
                this.options.extensions.startBlock.forEach((getStartIndex)=>{
                    tempStart = getStartIndex.call({
                        lexer: this
                    }, tempSrc);
                    if (typeof tempStart === "number" && tempStart >= 0) startIndex = Math.min(startIndex, tempStart);
                });
                if (startIndex < Infinity && startIndex >= 0) cutSrc = src.substring(0, startIndex + 1);
            }
            if (this.state.top && (token = this.tokenizer.paragraph(cutSrc))) {
                const lastToken = tokens.at(-1);
                if (lastParagraphClipped && lastToken?.type === "paragraph") {
                    lastToken.raw += "\n" + token.raw;
                    lastToken.text += "\n" + token.text;
                    this.inlineQueue.pop();
                    this.inlineQueue.at(-1).src = lastToken.text;
                } else tokens.push(token);
                lastParagraphClipped = cutSrc.length !== src.length;
                src = src.substring(token.raw.length);
                continue;
            }
            if (token = this.tokenizer.text(src)) {
                src = src.substring(token.raw.length);
                const lastToken = tokens.at(-1);
                if (lastToken?.type === "text") {
                    lastToken.raw += "\n" + token.raw;
                    lastToken.text += "\n" + token.text;
                    this.inlineQueue.pop();
                    this.inlineQueue.at(-1).src = lastToken.text;
                } else tokens.push(token);
                continue;
            }
            if (src) {
                const errMsg = "Infinite loop on byte: " + src.charCodeAt(0);
                if (this.options.silent) {
                    console.error(errMsg);
                    break;
                } else throw new Error(errMsg);
            }
        }
        this.state.top = true;
        return tokens;
    }
    inline(src, tokens = []) {
        this.inlineQueue.push({
            src: src,
            tokens: tokens
        });
        return tokens;
    }
    /**
   * Lexing/Compiling
   */ inlineTokens(src, tokens = []) {
        let maskedSrc = src;
        let match = null;
        if (this.tokens.links) {
            const links = Object.keys(this.tokens.links);
            if (links.length > 0) {
                while((match = this.tokenizer.rules.inline.reflinkSearch.exec(maskedSrc)) != null)if (links.includes(match[0].slice(match[0].lastIndexOf("[") + 1, -1))) maskedSrc = maskedSrc.slice(0, match.index) + "[" + "a".repeat(match[0].length - 2) + "]" + maskedSrc.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex);
            }
        }
        while((match = this.tokenizer.rules.inline.anyPunctuation.exec(maskedSrc)) != null)maskedSrc = maskedSrc.slice(0, match.index) + "++" + maskedSrc.slice(this.tokenizer.rules.inline.anyPunctuation.lastIndex);
        while((match = this.tokenizer.rules.inline.blockSkip.exec(maskedSrc)) != null)maskedSrc = maskedSrc.slice(0, match.index) + "[" + "a".repeat(match[0].length - 2) + "]" + maskedSrc.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
        let keepPrevChar = false;
        let prevChar = "";
        while(src){
            if (!keepPrevChar) prevChar = "";
            keepPrevChar = false;
            let token;
            if (this.options.extensions?.inline?.some((extTokenizer)=>{
                if (token = extTokenizer.call({
                    lexer: this
                }, src, tokens)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    return true;
                }
                return false;
            })) continue;
            if (token = this.tokenizer.escape(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.tag(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.link(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.reflink(src, this.tokens.links)) {
                src = src.substring(token.raw.length);
                const lastToken = tokens.at(-1);
                if (token.type === "text" && lastToken?.type === "text") {
                    lastToken.raw += token.raw;
                    lastToken.text += token.text;
                } else tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.emStrong(src, maskedSrc, prevChar)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.codespan(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.br(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.del(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.autolink(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (!this.state.inLink && (token = this.tokenizer.url(src))) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            let cutSrc = src;
            if (this.options.extensions?.startInline) {
                let startIndex = Infinity;
                const tempSrc = src.slice(1);
                let tempStart;
                this.options.extensions.startInline.forEach((getStartIndex)=>{
                    tempStart = getStartIndex.call({
                        lexer: this
                    }, tempSrc);
                    if (typeof tempStart === "number" && tempStart >= 0) startIndex = Math.min(startIndex, tempStart);
                });
                if (startIndex < Infinity && startIndex >= 0) cutSrc = src.substring(0, startIndex + 1);
            }
            if (token = this.tokenizer.inlineText(cutSrc)) {
                src = src.substring(token.raw.length);
                if (token.raw.slice(-1) !== "_") prevChar = token.raw.slice(-1);
                keepPrevChar = true;
                const lastToken = tokens.at(-1);
                if (lastToken?.type === "text") {
                    lastToken.raw += token.raw;
                    lastToken.text += token.text;
                } else tokens.push(token);
                continue;
            }
            if (src) {
                const errMsg = "Infinite loop on byte: " + src.charCodeAt(0);
                if (this.options.silent) {
                    console.error(errMsg);
                    break;
                } else throw new Error(errMsg);
            }
        }
        return tokens;
    }
};
// src/Renderer.ts
var $a5cf0eae8608a64d$export$88530751e3977073 = class {
    options;
    parser;
    // set by the parser
    constructor(options2){
        this.options = options2 || $a5cf0eae8608a64d$export$ebe90cb607ad99e;
    }
    space(token) {
        return "";
    }
    code({ text: text, lang: lang, escaped: escaped }) {
        const langString = (lang || "").match($a5cf0eae8608a64d$var$other.notSpaceStart)?.[0];
        const code = text.replace($a5cf0eae8608a64d$var$other.endingNewline, "") + "\n";
        if (!langString) return "<pre><code>" + (escaped ? code : $a5cf0eae8608a64d$var$escape2(code, true)) + "</code></pre>\n";
        return '<pre><code class="language-' + $a5cf0eae8608a64d$var$escape2(langString) + '">' + (escaped ? code : $a5cf0eae8608a64d$var$escape2(code, true)) + "</code></pre>\n";
    }
    blockquote({ tokens: tokens }) {
        const body = this.parser.parse(tokens);
        return `<blockquote>
${body}</blockquote>
`;
    }
    html({ text: text }) {
        return text;
    }
    heading({ tokens: tokens, depth: depth }) {
        return `<h${depth}>${this.parser.parseInline(tokens)}</h${depth}>
`;
    }
    hr(token) {
        return "<hr>\n";
    }
    list(token) {
        const ordered = token.ordered;
        const start = token.start;
        let body = "";
        for(let j = 0; j < token.items.length; j++){
            const item = token.items[j];
            body += this.listitem(item);
        }
        const type = ordered ? "ol" : "ul";
        const startAttr = ordered && start !== 1 ? ' start="' + start + '"' : "";
        return "<" + type + startAttr + ">\n" + body + "</" + type + ">\n";
    }
    listitem(item) {
        let itemBody = "";
        if (item.task) {
            const checkbox = this.checkbox({
                checked: !!item.checked
            });
            if (item.loose) {
                if (item.tokens[0]?.type === "paragraph") {
                    item.tokens[0].text = checkbox + " " + item.tokens[0].text;
                    if (item.tokens[0].tokens && item.tokens[0].tokens.length > 0 && item.tokens[0].tokens[0].type === "text") {
                        item.tokens[0].tokens[0].text = checkbox + " " + $a5cf0eae8608a64d$var$escape2(item.tokens[0].tokens[0].text);
                        item.tokens[0].tokens[0].escaped = true;
                    }
                } else item.tokens.unshift({
                    type: "text",
                    raw: checkbox + " ",
                    text: checkbox + " ",
                    escaped: true
                });
            } else itemBody += checkbox + " ";
        }
        itemBody += this.parser.parse(item.tokens, !!item.loose);
        return `<li>${itemBody}</li>
`;
    }
    checkbox({ checked: checked }) {
        return "<input " + (checked ? 'checked="" ' : "") + 'disabled="" type="checkbox">';
    }
    paragraph({ tokens: tokens }) {
        return `<p>${this.parser.parseInline(tokens)}</p>
`;
    }
    table(token) {
        let header = "";
        let cell = "";
        for(let j = 0; j < token.header.length; j++)cell += this.tablecell(token.header[j]);
        header += this.tablerow({
            text: cell
        });
        let body = "";
        for(let j = 0; j < token.rows.length; j++){
            const row = token.rows[j];
            cell = "";
            for(let k = 0; k < row.length; k++)cell += this.tablecell(row[k]);
            body += this.tablerow({
                text: cell
            });
        }
        if (body) body = `<tbody>${body}</tbody>`;
        return "<table>\n<thead>\n" + header + "</thead>\n" + body + "</table>\n";
    }
    tablerow({ text: text }) {
        return `<tr>
${text}</tr>
`;
    }
    tablecell(token) {
        const content = this.parser.parseInline(token.tokens);
        const type = token.header ? "th" : "td";
        const tag2 = token.align ? `<${type} align="${token.align}">` : `<${type}>`;
        return tag2 + content + `</${type}>
`;
    }
    /**
   * span level renderer
   */ strong({ tokens: tokens }) {
        return `<strong>${this.parser.parseInline(tokens)}</strong>`;
    }
    em({ tokens: tokens }) {
        return `<em>${this.parser.parseInline(tokens)}</em>`;
    }
    codespan({ text: text }) {
        return `<code>${$a5cf0eae8608a64d$var$escape2(text, true)}</code>`;
    }
    br(token) {
        return "<br>";
    }
    del({ tokens: tokens }) {
        return `<del>${this.parser.parseInline(tokens)}</del>`;
    }
    link({ href: href, title: title, tokens: tokens }) {
        const text = this.parser.parseInline(tokens);
        const cleanHref = $a5cf0eae8608a64d$var$cleanUrl(href);
        if (cleanHref === null) return text;
        href = cleanHref;
        let out = '<a href="' + href + '"';
        if (title) out += ' title="' + $a5cf0eae8608a64d$var$escape2(title) + '"';
        out += ">" + text + "</a>";
        return out;
    }
    image({ href: href, title: title, text: text, tokens: tokens }) {
        if (tokens) text = this.parser.parseInline(tokens, this.parser.textRenderer);
        const cleanHref = $a5cf0eae8608a64d$var$cleanUrl(href);
        if (cleanHref === null) return $a5cf0eae8608a64d$var$escape2(text);
        href = cleanHref;
        let out = `<img src="${href}" alt="${text}"`;
        if (title) out += ` title="${$a5cf0eae8608a64d$var$escape2(title)}"`;
        out += ">";
        return out;
    }
    text(token) {
        return "tokens" in token && token.tokens ? this.parser.parseInline(token.tokens) : "escaped" in token && token.escaped ? token.text : $a5cf0eae8608a64d$var$escape2(token.text);
    }
};
// src/TextRenderer.ts
var $a5cf0eae8608a64d$export$75ebcd2c8ed5b901 = class {
    // no need for block level renderers
    strong({ text: text }) {
        return text;
    }
    em({ text: text }) {
        return text;
    }
    codespan({ text: text }) {
        return text;
    }
    del({ text: text }) {
        return text;
    }
    html({ text: text }) {
        return text;
    }
    text({ text: text }) {
        return text;
    }
    link({ text: text }) {
        return "" + text;
    }
    image({ text: text }) {
        return "" + text;
    }
    br() {
        return "";
    }
};
// src/Parser.ts
var $a5cf0eae8608a64d$export$7acfa6ed01010e37 = class __Parser {
    options;
    renderer;
    textRenderer;
    constructor(options2){
        this.options = options2 || $a5cf0eae8608a64d$export$ebe90cb607ad99e;
        this.options.renderer = this.options.renderer || new $a5cf0eae8608a64d$export$88530751e3977073();
        this.renderer = this.options.renderer;
        this.renderer.options = this.options;
        this.renderer.parser = this;
        this.textRenderer = new $a5cf0eae8608a64d$export$75ebcd2c8ed5b901();
    }
    /**
   * Static Parse Method
   */ static parse(tokens, options2) {
        const parser2 = new __Parser(options2);
        return parser2.parse(tokens);
    }
    /**
   * Static Parse Inline Method
   */ static parseInline(tokens, options2) {
        const parser2 = new __Parser(options2);
        return parser2.parseInline(tokens);
    }
    /**
   * Parse Loop
   */ parse(tokens, top = true) {
        let out = "";
        for(let i = 0; i < tokens.length; i++){
            const anyToken = tokens[i];
            if (this.options.extensions?.renderers?.[anyToken.type]) {
                const genericToken = anyToken;
                const ret = this.options.extensions.renderers[genericToken.type].call({
                    parser: this
                }, genericToken);
                if (ret !== false || ![
                    "space",
                    "hr",
                    "heading",
                    "code",
                    "table",
                    "blockquote",
                    "list",
                    "html",
                    "paragraph",
                    "text"
                ].includes(genericToken.type)) {
                    out += ret || "";
                    continue;
                }
            }
            const token = anyToken;
            switch(token.type){
                case "space":
                    out += this.renderer.space(token);
                    continue;
                case "hr":
                    out += this.renderer.hr(token);
                    continue;
                case "heading":
                    out += this.renderer.heading(token);
                    continue;
                case "code":
                    out += this.renderer.code(token);
                    continue;
                case "table":
                    out += this.renderer.table(token);
                    continue;
                case "blockquote":
                    out += this.renderer.blockquote(token);
                    continue;
                case "list":
                    out += this.renderer.list(token);
                    continue;
                case "html":
                    out += this.renderer.html(token);
                    continue;
                case "paragraph":
                    out += this.renderer.paragraph(token);
                    continue;
                case "text":
                    {
                        let textToken = token;
                        let body = this.renderer.text(textToken);
                        while(i + 1 < tokens.length && tokens[i + 1].type === "text"){
                            textToken = tokens[++i];
                            body += "\n" + this.renderer.text(textToken);
                        }
                        if (top) out += this.renderer.paragraph({
                            type: "paragraph",
                            raw: body,
                            text: body,
                            tokens: [
                                {
                                    type: "text",
                                    raw: body,
                                    text: body,
                                    escaped: true
                                }
                            ]
                        });
                        else out += body;
                        continue;
                    }
                default:
                    {
                        const errMsg = 'Token with "' + token.type + '" type was not found.';
                        if (this.options.silent) {
                            console.error(errMsg);
                            return "";
                        } else throw new Error(errMsg);
                    }
            }
        }
        return out;
    }
    /**
   * Parse Inline Tokens
   */ parseInline(tokens, renderer = this.renderer) {
        let out = "";
        for(let i = 0; i < tokens.length; i++){
            const anyToken = tokens[i];
            if (this.options.extensions?.renderers?.[anyToken.type]) {
                const ret = this.options.extensions.renderers[anyToken.type].call({
                    parser: this
                }, anyToken);
                if (ret !== false || ![
                    "escape",
                    "html",
                    "link",
                    "image",
                    "strong",
                    "em",
                    "codespan",
                    "br",
                    "del",
                    "text"
                ].includes(anyToken.type)) {
                    out += ret || "";
                    continue;
                }
            }
            const token = anyToken;
            switch(token.type){
                case "escape":
                    out += renderer.text(token);
                    break;
                case "html":
                    out += renderer.html(token);
                    break;
                case "link":
                    out += renderer.link(token);
                    break;
                case "image":
                    out += renderer.image(token);
                    break;
                case "strong":
                    out += renderer.strong(token);
                    break;
                case "em":
                    out += renderer.em(token);
                    break;
                case "codespan":
                    out += renderer.codespan(token);
                    break;
                case "br":
                    out += renderer.br(token);
                    break;
                case "del":
                    out += renderer.del(token);
                    break;
                case "text":
                    out += renderer.text(token);
                    break;
                default:
                    {
                        const errMsg = 'Token with "' + token.type + '" type was not found.';
                        if (this.options.silent) {
                            console.error(errMsg);
                            return "";
                        } else throw new Error(errMsg);
                    }
            }
        }
        return out;
    }
};
// src/Hooks.ts
var $a5cf0eae8608a64d$export$5fbefe39e79899a6 = class {
    options;
    block;
    constructor(options2){
        this.options = options2 || $a5cf0eae8608a64d$export$ebe90cb607ad99e;
    }
    static passThroughHooks = /* @__PURE__ */ new Set([
        "preprocess",
        "postprocess",
        "processAllTokens"
    ]);
    /**
   * Process markdown before marked
   */ preprocess(markdown) {
        return markdown;
    }
    /**
   * Process HTML after marked is finished
   */ postprocess(html2) {
        return html2;
    }
    /**
   * Process all tokens before walk tokens
   */ processAllTokens(tokens) {
        return tokens;
    }
    /**
   * Provide function to tokenize markdown
   */ provideLexer() {
        return this.block ? $a5cf0eae8608a64d$export$6168dc8908a6c652.lex : $a5cf0eae8608a64d$export$6168dc8908a6c652.lexInline;
    }
    /**
   * Provide function to parse tokens
   */ provideParser() {
        return this.block ? $a5cf0eae8608a64d$export$7acfa6ed01010e37.parse : $a5cf0eae8608a64d$export$7acfa6ed01010e37.parseInline;
    }
};
// src/Instance.ts
var $a5cf0eae8608a64d$export$164128c95a350e30 = class {
    defaults = $a5cf0eae8608a64d$export$212bb2fc580a90a8();
    options = this.setOptions;
    parse = this.parseMarkdown(true);
    parseInline = this.parseMarkdown(false);
    Parser = $a5cf0eae8608a64d$export$7acfa6ed01010e37;
    Renderer = $a5cf0eae8608a64d$export$88530751e3977073;
    TextRenderer = $a5cf0eae8608a64d$export$75ebcd2c8ed5b901;
    Lexer = $a5cf0eae8608a64d$export$6168dc8908a6c652;
    Tokenizer = $a5cf0eae8608a64d$export$55e8b082af4aa63e;
    Hooks = $a5cf0eae8608a64d$export$5fbefe39e79899a6;
    constructor(...args){
        this.use(...args);
    }
    /**
   * Run callback for every token
   */ walkTokens(tokens, callback) {
        let values = [];
        for (const token of tokens){
            values = values.concat(callback.call(this, token));
            switch(token.type){
                case "table":
                    {
                        const tableToken = token;
                        for (const cell of tableToken.header)values = values.concat(this.walkTokens(cell.tokens, callback));
                        for (const row of tableToken.rows)for (const cell of row)values = values.concat(this.walkTokens(cell.tokens, callback));
                        break;
                    }
                case "list":
                    {
                        const listToken = token;
                        values = values.concat(this.walkTokens(listToken.items, callback));
                        break;
                    }
                default:
                    {
                        const genericToken = token;
                        if (this.defaults.extensions?.childTokens?.[genericToken.type]) this.defaults.extensions.childTokens[genericToken.type].forEach((childTokens)=>{
                            const tokens2 = genericToken[childTokens].flat(Infinity);
                            values = values.concat(this.walkTokens(tokens2, callback));
                        });
                        else if (genericToken.tokens) values = values.concat(this.walkTokens(genericToken.tokens, callback));
                    }
            }
        }
        return values;
    }
    use(...args) {
        const extensions = this.defaults.extensions || {
            renderers: {},
            childTokens: {}
        };
        args.forEach((pack)=>{
            const opts = {
                ...pack
            };
            opts.async = this.defaults.async || opts.async || false;
            if (pack.extensions) {
                pack.extensions.forEach((ext)=>{
                    if (!ext.name) throw new Error("extension name required");
                    if ("renderer" in ext) {
                        const prevRenderer = extensions.renderers[ext.name];
                        if (prevRenderer) extensions.renderers[ext.name] = function(...args2) {
                            let ret = ext.renderer.apply(this, args2);
                            if (ret === false) ret = prevRenderer.apply(this, args2);
                            return ret;
                        };
                        else extensions.renderers[ext.name] = ext.renderer;
                    }
                    if ("tokenizer" in ext) {
                        if (!ext.level || ext.level !== "block" && ext.level !== "inline") throw new Error("extension level must be 'block' or 'inline'");
                        const extLevel = extensions[ext.level];
                        if (extLevel) extLevel.unshift(ext.tokenizer);
                        else extensions[ext.level] = [
                            ext.tokenizer
                        ];
                        if (ext.start) {
                            if (ext.level === "block") {
                                if (extensions.startBlock) extensions.startBlock.push(ext.start);
                                else extensions.startBlock = [
                                    ext.start
                                ];
                            } else if (ext.level === "inline") {
                                if (extensions.startInline) extensions.startInline.push(ext.start);
                                else extensions.startInline = [
                                    ext.start
                                ];
                            }
                        }
                    }
                    if ("childTokens" in ext && ext.childTokens) extensions.childTokens[ext.name] = ext.childTokens;
                });
                opts.extensions = extensions;
            }
            if (pack.renderer) {
                const renderer = this.defaults.renderer || new $a5cf0eae8608a64d$export$88530751e3977073(this.defaults);
                for(const prop in pack.renderer){
                    if (!(prop in renderer)) throw new Error(`renderer '${prop}' does not exist`);
                    if ([
                        "options",
                        "parser"
                    ].includes(prop)) continue;
                    const rendererProp = prop;
                    const rendererFunc = pack.renderer[rendererProp];
                    const prevRenderer = renderer[rendererProp];
                    renderer[rendererProp] = (...args2)=>{
                        let ret = rendererFunc.apply(renderer, args2);
                        if (ret === false) ret = prevRenderer.apply(renderer, args2);
                        return ret || "";
                    };
                }
                opts.renderer = renderer;
            }
            if (pack.tokenizer) {
                const tokenizer = this.defaults.tokenizer || new $a5cf0eae8608a64d$export$55e8b082af4aa63e(this.defaults);
                for(const prop in pack.tokenizer){
                    if (!(prop in tokenizer)) throw new Error(`tokenizer '${prop}' does not exist`);
                    if ([
                        "options",
                        "rules",
                        "lexer"
                    ].includes(prop)) continue;
                    const tokenizerProp = prop;
                    const tokenizerFunc = pack.tokenizer[tokenizerProp];
                    const prevTokenizer = tokenizer[tokenizerProp];
                    tokenizer[tokenizerProp] = (...args2)=>{
                        let ret = tokenizerFunc.apply(tokenizer, args2);
                        if (ret === false) ret = prevTokenizer.apply(tokenizer, args2);
                        return ret;
                    };
                }
                opts.tokenizer = tokenizer;
            }
            if (pack.hooks) {
                const hooks = this.defaults.hooks || new $a5cf0eae8608a64d$export$5fbefe39e79899a6();
                for(const prop in pack.hooks){
                    if (!(prop in hooks)) throw new Error(`hook '${prop}' does not exist`);
                    if ([
                        "options",
                        "block"
                    ].includes(prop)) continue;
                    const hooksProp = prop;
                    const hooksFunc = pack.hooks[hooksProp];
                    const prevHook = hooks[hooksProp];
                    if ($a5cf0eae8608a64d$export$5fbefe39e79899a6.passThroughHooks.has(prop)) hooks[hooksProp] = (arg)=>{
                        if (this.defaults.async) return Promise.resolve(hooksFunc.call(hooks, arg)).then((ret2)=>{
                            return prevHook.call(hooks, ret2);
                        });
                        const ret = hooksFunc.call(hooks, arg);
                        return prevHook.call(hooks, ret);
                    };
                    else hooks[hooksProp] = (...args2)=>{
                        let ret = hooksFunc.apply(hooks, args2);
                        if (ret === false) ret = prevHook.apply(hooks, args2);
                        return ret;
                    };
                }
                opts.hooks = hooks;
            }
            if (pack.walkTokens) {
                const walkTokens2 = this.defaults.walkTokens;
                const packWalktokens = pack.walkTokens;
                opts.walkTokens = function(token) {
                    let values = [];
                    values.push(packWalktokens.call(this, token));
                    if (walkTokens2) values = values.concat(walkTokens2.call(this, token));
                    return values;
                };
            }
            this.defaults = {
                ...this.defaults,
                ...opts
            };
        });
        return this;
    }
    setOptions(opt) {
        this.defaults = {
            ...this.defaults,
            ...opt
        };
        return this;
    }
    lexer(src, options2) {
        return $a5cf0eae8608a64d$export$6168dc8908a6c652.lex(src, options2 ?? this.defaults);
    }
    parser(tokens, options2) {
        return $a5cf0eae8608a64d$export$7acfa6ed01010e37.parse(tokens, options2 ?? this.defaults);
    }
    parseMarkdown(blockType) {
        const parse2 = (src, options2)=>{
            const origOpt = {
                ...options2
            };
            const opt = {
                ...this.defaults,
                ...origOpt
            };
            const throwError = this.onError(!!opt.silent, !!opt.async);
            if (this.defaults.async === true && origOpt.async === false) return throwError(new Error("marked(): The async option was set to true by an extension. Remove async: false from the parse options object to return a Promise."));
            if (typeof src === "undefined" || src === null) return throwError(new Error("marked(): input parameter is undefined or null"));
            if (typeof src !== "string") return throwError(new Error("marked(): input parameter is of type " + Object.prototype.toString.call(src) + ", string expected"));
            if (opt.hooks) {
                opt.hooks.options = opt;
                opt.hooks.block = blockType;
            }
            const lexer2 = opt.hooks ? opt.hooks.provideLexer() : blockType ? $a5cf0eae8608a64d$export$6168dc8908a6c652.lex : $a5cf0eae8608a64d$export$6168dc8908a6c652.lexInline;
            const parser2 = opt.hooks ? opt.hooks.provideParser() : blockType ? $a5cf0eae8608a64d$export$7acfa6ed01010e37.parse : $a5cf0eae8608a64d$export$7acfa6ed01010e37.parseInline;
            if (opt.async) return Promise.resolve(opt.hooks ? opt.hooks.preprocess(src) : src).then((src2)=>lexer2(src2, opt)).then((tokens)=>opt.hooks ? opt.hooks.processAllTokens(tokens) : tokens).then((tokens)=>opt.walkTokens ? Promise.all(this.walkTokens(tokens, opt.walkTokens)).then(()=>tokens) : tokens).then((tokens)=>parser2(tokens, opt)).then((html2)=>opt.hooks ? opt.hooks.postprocess(html2) : html2).catch(throwError);
            try {
                if (opt.hooks) src = opt.hooks.preprocess(src);
                let tokens = lexer2(src, opt);
                if (opt.hooks) tokens = opt.hooks.processAllTokens(tokens);
                if (opt.walkTokens) this.walkTokens(tokens, opt.walkTokens);
                let html2 = parser2(tokens, opt);
                if (opt.hooks) html2 = opt.hooks.postprocess(html2);
                return html2;
            } catch (e) {
                return throwError(e);
            }
        };
        return parse2;
    }
    onError(silent, async) {
        return (e)=>{
            e.message += "\nPlease report this to https://github.com/markedjs/marked.";
            if (silent) {
                const msg = "<p>An error occurred:</p><pre>" + $a5cf0eae8608a64d$var$escape2(e.message + "", true) + "</pre>";
                if (async) return Promise.resolve(msg);
                return msg;
            }
            if (async) return Promise.reject(e);
            throw e;
        };
    }
};
// src/marked.ts
var $a5cf0eae8608a64d$var$markedInstance = new $a5cf0eae8608a64d$export$164128c95a350e30();
function $a5cf0eae8608a64d$export$db8f131360c543a5(src, opt) {
    return $a5cf0eae8608a64d$var$markedInstance.parse(src, opt);
}
$a5cf0eae8608a64d$export$db8f131360c543a5.options = $a5cf0eae8608a64d$export$db8f131360c543a5.setOptions = function(options2) {
    $a5cf0eae8608a64d$var$markedInstance.setOptions(options2);
    $a5cf0eae8608a64d$export$db8f131360c543a5.defaults = $a5cf0eae8608a64d$var$markedInstance.defaults;
    $a5cf0eae8608a64d$var$changeDefaults($a5cf0eae8608a64d$export$db8f131360c543a5.defaults);
    return $a5cf0eae8608a64d$export$db8f131360c543a5;
};
$a5cf0eae8608a64d$export$db8f131360c543a5.getDefaults = $a5cf0eae8608a64d$export$212bb2fc580a90a8;
$a5cf0eae8608a64d$export$db8f131360c543a5.defaults = $a5cf0eae8608a64d$export$ebe90cb607ad99e;
$a5cf0eae8608a64d$export$db8f131360c543a5.use = function(...args) {
    $a5cf0eae8608a64d$var$markedInstance.use(...args);
    $a5cf0eae8608a64d$export$db8f131360c543a5.defaults = $a5cf0eae8608a64d$var$markedInstance.defaults;
    $a5cf0eae8608a64d$var$changeDefaults($a5cf0eae8608a64d$export$db8f131360c543a5.defaults);
    return $a5cf0eae8608a64d$export$db8f131360c543a5;
};
$a5cf0eae8608a64d$export$db8f131360c543a5.walkTokens = function(tokens, callback) {
    return $a5cf0eae8608a64d$var$markedInstance.walkTokens(tokens, callback);
};
$a5cf0eae8608a64d$export$db8f131360c543a5.parseInline = $a5cf0eae8608a64d$var$markedInstance.parseInline;
$a5cf0eae8608a64d$export$db8f131360c543a5.Parser = $a5cf0eae8608a64d$export$7acfa6ed01010e37;
$a5cf0eae8608a64d$export$db8f131360c543a5.parser = $a5cf0eae8608a64d$export$7acfa6ed01010e37.parse;
$a5cf0eae8608a64d$export$db8f131360c543a5.Renderer = $a5cf0eae8608a64d$export$88530751e3977073;
$a5cf0eae8608a64d$export$db8f131360c543a5.TextRenderer = $a5cf0eae8608a64d$export$75ebcd2c8ed5b901;
$a5cf0eae8608a64d$export$db8f131360c543a5.Lexer = $a5cf0eae8608a64d$export$6168dc8908a6c652;
$a5cf0eae8608a64d$export$db8f131360c543a5.lexer = $a5cf0eae8608a64d$export$6168dc8908a6c652.lex;
$a5cf0eae8608a64d$export$db8f131360c543a5.Tokenizer = $a5cf0eae8608a64d$export$55e8b082af4aa63e;
$a5cf0eae8608a64d$export$db8f131360c543a5.Hooks = $a5cf0eae8608a64d$export$5fbefe39e79899a6;
$a5cf0eae8608a64d$export$db8f131360c543a5.parse = $a5cf0eae8608a64d$export$db8f131360c543a5;
var $a5cf0eae8608a64d$export$41c562ebe57d11e2 = $a5cf0eae8608a64d$export$db8f131360c543a5.options;
var $a5cf0eae8608a64d$export$add91eafeaeab287 = $a5cf0eae8608a64d$export$db8f131360c543a5.setOptions;
var $a5cf0eae8608a64d$export$1f96ae73734a86cc = $a5cf0eae8608a64d$export$db8f131360c543a5.use;
var $a5cf0eae8608a64d$export$3eedd5437d43cb76 = $a5cf0eae8608a64d$export$db8f131360c543a5.walkTokens;
var $a5cf0eae8608a64d$export$c7679c2b5e355e6f = $a5cf0eae8608a64d$export$db8f131360c543a5.parseInline;
var $a5cf0eae8608a64d$export$98e6a39c04603d36 = $a5cf0eae8608a64d$export$db8f131360c543a5;
var $a5cf0eae8608a64d$export$8f49e4af10703ce3 = $a5cf0eae8608a64d$export$7acfa6ed01010e37.parse;
var $a5cf0eae8608a64d$export$43feed32102720d2 = $a5cf0eae8608a64d$export$6168dc8908a6c652.lex;


function $3606afe94d964185$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $3606afe94d964185$var$$57ba63c17513cbba$exports = {};
$3606afe94d964185$var$$parcel$export($3606afe94d964185$var$$57ba63c17513cbba$exports, "getAnchorElement", function() {
    return $3606afe94d964185$export$ac81f1ba58a5f363;
});
$3606afe94d964185$var$$parcel$export($3606afe94d964185$var$$57ba63c17513cbba$exports, "Tool", function() {
    return $3606afe94d964185$export$724f6b867059ef5f;
});
$3606afe94d964185$var$$parcel$export($3606afe94d964185$var$$57ba63c17513cbba$exports, "FileTool", function() {
    return $3606afe94d964185$export$de3122b2484864a7;
});
function $3606afe94d964185$export$ac81f1ba58a5f363() {
    const { anchorNode: anchorNode } = globalThis.getSelection?.() || {};
    if (anchorNode) return anchorNode.parentElement;
}
class $3606afe94d964185$export$724f6b867059ef5f {
    get usable() {
        const { command: command } = this;
        return !command || !globalThis.document || document.queryCommandSupported(command) || document.queryCommandEnabled(command);
    }
    getActive() {
        const { command: command, tags: tags } = this;
        if (tags) {
            const box = $3606afe94d964185$export$ac81f1ba58a5f363();
            return !!box && box.matches(tags.map((tag)=>`${tag}, ${tag} *`).join(', '));
        }
        if (command) return !!globalThis.document && document.queryCommandState(command);
        return false;
    }
    get active() {
        return this.getActive();
    }
    get title() {
        const { name: name, keys: keys, usable: usable } = this;
        return `${name}${usable ? keys ? `\n(${keys.join(' + ')})` : '' : '\n(not supported)'}`;
    }
    edit(editor, ...data) {
        editor.focus();
        document.execCommand(this.command, null, ...data);
    }
    execute(editor, ...data) {
        var { inputs: inputs } = this, values = [];
        if (inputs) {
            const data = inputs.map((input)=>self.prompt(input));
            if (!data.filter(Boolean)[0]) return;
            values = data;
        }
        this.edit(editor, ...values);
    }
}
class $3606afe94d964185$export$de3122b2484864a7 extends $3606afe94d964185$export$724f6b867059ef5f {
    async save(data) {
        return URL.createObjectURL(data);
    }
    codeOf(path) {
        return path;
    }
    async execute(editor) {
        try {
            var path = await this.save(await (0, $e8ea7ccd2bdcbf17$export$c1bd535e520dbbc3)());
        } catch  {
            var path = self.prompt('No file uploaded, please input an URL');
        }
        if (path) this.edit(editor, this.codeOf(path));
    }
}
var $3606afe94d964185$var$$761e5fca3dae08eb$exports = {};
$3606afe94d964185$var$$parcel$export($3606afe94d964185$var$$761e5fca3dae08eb$exports, "BoldTool", function() {
    return $3606afe94d964185$export$10056a49e3b218eb;
});
$3606afe94d964185$var$$parcel$export($3606afe94d964185$var$$761e5fca3dae08eb$exports, "ItalicTool", function() {
    return $3606afe94d964185$export$edf99d0f51bacb1e;
});
$3606afe94d964185$var$$parcel$export($3606afe94d964185$var$$761e5fca3dae08eb$exports, "UnderlineTool", function() {
    return $3606afe94d964185$export$4b6d9c17188960d2;
});
$3606afe94d964185$var$$parcel$export($3606afe94d964185$var$$761e5fca3dae08eb$exports, "StrikeThroughTool", function() {
    return $3606afe94d964185$export$a35bffaeae8fdda0;
});
$3606afe94d964185$var$$parcel$export($3606afe94d964185$var$$761e5fca3dae08eb$exports, "HeadingTool", function() {
    return $3606afe94d964185$export$85cf7848e2652151;
});
$3606afe94d964185$var$$parcel$export($3606afe94d964185$var$$761e5fca3dae08eb$exports, "H1Tool", function() {
    return $3606afe94d964185$export$30e8c6b428f8749f;
});
$3606afe94d964185$var$$parcel$export($3606afe94d964185$var$$761e5fca3dae08eb$exports, "H2Tool", function() {
    return $3606afe94d964185$export$58443375efa91029;
});
$3606afe94d964185$var$$parcel$export($3606afe94d964185$var$$761e5fca3dae08eb$exports, "H3Tool", function() {
    return $3606afe94d964185$export$75d24d6b8b747307;
});
$3606afe94d964185$var$$parcel$export($3606afe94d964185$var$$761e5fca3dae08eb$exports, "FontSizeDownTool", function() {
    return $3606afe94d964185$export$a20806c6ef6938f8;
});
$3606afe94d964185$var$$parcel$export($3606afe94d964185$var$$761e5fca3dae08eb$exports, "FontSizeUpTool", function() {
    return $3606afe94d964185$export$744da7e24e4a7382;
});
$3606afe94d964185$var$$parcel$export($3606afe94d964185$var$$761e5fca3dae08eb$exports, "SubscriptTool", function() {
    return $3606afe94d964185$export$6137518b4e998008;
});
$3606afe94d964185$var$$parcel$export($3606afe94d964185$var$$761e5fca3dae08eb$exports, "SuperscriptTool", function() {
    return $3606afe94d964185$export$7217f06c61ebd4fc;
});
$3606afe94d964185$var$$parcel$export($3606afe94d964185$var$$761e5fca3dae08eb$exports, "LinkTool", function() {
    return $3606afe94d964185$export$f6c54364b5332e66;
});
class $3606afe94d964185$export$10056a49e3b218eb extends $3606afe94d964185$export$724f6b867059ef5f {
    constructor(...args){
        super(...args), this.name = 'Bold', this.tags = [
            'b',
            'strong'
        ], this.keys = [
            'Ctrl',
            'B'
        ], this.command = 'bold';
    }
}
class $3606afe94d964185$export$edf99d0f51bacb1e extends $3606afe94d964185$export$724f6b867059ef5f {
    constructor(...args){
        super(...args), this.name = 'Italic', this.tags = [
            'i',
            'em'
        ], this.keys = [
            'Ctrl',
            'I'
        ], this.command = 'italic';
    }
}
class $3606afe94d964185$export$4b6d9c17188960d2 extends $3606afe94d964185$export$724f6b867059ef5f {
    constructor(...args){
        super(...args), this.name = 'Underline', this.tags = [
            'u'
        ], this.keys = [
            'Ctrl',
            'U'
        ], this.command = 'underline';
    }
}
class $3606afe94d964185$export$a35bffaeae8fdda0 extends $3606afe94d964185$export$724f6b867059ef5f {
    constructor(...args){
        super(...args), this.name = 'Strike through', this.tags = [
            's',
            'del',
            'strike'
        ], this.command = 'strikeThrough';
    }
}
class $3606afe94d964185$export$85cf7848e2652151 extends $3606afe94d964185$export$724f6b867059ef5f {
    execute(editor) {
        this.edit(editor, this.name);
    }
    constructor(...args){
        super(...args), this.command = globalThis.document?.queryCommandSupported('heading') ? 'heading' : 'formatBlock';
    }
}
class $3606afe94d964185$export$30e8c6b428f8749f extends $3606afe94d964185$export$85cf7848e2652151 {
    constructor(...args){
        super(...args), this.name = 'H1', this.tags = [
            'h1'
        ];
    }
}
class $3606afe94d964185$export$58443375efa91029 extends $3606afe94d964185$export$85cf7848e2652151 {
    constructor(...args){
        super(...args), this.name = 'H2', this.tags = [
            'h2'
        ];
    }
}
class $3606afe94d964185$export$75d24d6b8b747307 extends $3606afe94d964185$export$85cf7848e2652151 {
    constructor(...args){
        super(...args), this.name = 'H3', this.tags = [
            'h3'
        ];
    }
}
class $3606afe94d964185$export$a20806c6ef6938f8 extends $3606afe94d964185$export$724f6b867059ef5f {
    constructor(...args){
        super(...args), this.name = 'Font Size down', this.tags = [
            'small'
        ], this.command = 'decreaseFontSize';
    }
}
class $3606afe94d964185$export$744da7e24e4a7382 extends $3606afe94d964185$export$724f6b867059ef5f {
    constructor(...args){
        super(...args), this.name = 'Font Size up', this.tags = [
            'big'
        ], this.command = 'increaseFontSize';
    }
}
class $3606afe94d964185$export$6137518b4e998008 extends $3606afe94d964185$export$724f6b867059ef5f {
    constructor(...args){
        super(...args), this.name = 'Subscript', this.tags = [
            'sub'
        ], this.command = 'subscript';
    }
}
class $3606afe94d964185$export$7217f06c61ebd4fc extends $3606afe94d964185$export$724f6b867059ef5f {
    constructor(...args){
        super(...args), this.name = 'Superscript', this.tags = [
            'sup'
        ], this.command = 'superscript';
    }
}
class $3606afe94d964185$export$f6c54364b5332e66 extends $3606afe94d964185$export$724f6b867059ef5f {
    constructor(...args){
        super(...args), this.name = 'Link', this.tags = [
            'a'
        ], this.inputs = [
            'Path'
        ], this.command = 'createLink';
    }
}
var $3606afe94d964185$var$$e999eec76d3b8abe$exports = {};
$3606afe94d964185$var$$parcel$export($3606afe94d964185$var$$e999eec76d3b8abe$exports, "ColorTool", function() {
    return $3606afe94d964185$export$ba9bbe5370f1bf2f;
});
$3606afe94d964185$var$$parcel$export($3606afe94d964185$var$$e999eec76d3b8abe$exports, "ForeColorTool", function() {
    return $3606afe94d964185$export$cab0e15cfb8489d7;
});
$3606afe94d964185$var$$parcel$export($3606afe94d964185$var$$e999eec76d3b8abe$exports, "BackColorTool", function() {
    return $3606afe94d964185$export$92bb6183e7459be2;
});
class $3606afe94d964185$export$ba9bbe5370f1bf2f extends $3606afe94d964185$export$724f6b867059ef5f {
    getColor() {
        const box = $3606afe94d964185$export$ac81f1ba58a5f363(), { colorName: colorName } = this;
        if (!box) return colorName === 'color' ? '#000000' : '#ffffff';
        const { [colorName]: color } = getComputedStyle(box);
        const [red, green, blue] = color.match(/\d+/g);
        return '#' + (+red).toString(16).padStart(2, '0') + (+green).toString(16).padStart(2, '0') + (+blue).toString(16).padStart(2, '0');
    }
    get active() {
        return !!this.getColor();
    }
    execute(editor, color) {
        this.edit(editor, color);
    }
}
class $3606afe94d964185$export$cab0e15cfb8489d7 extends $3606afe94d964185$export$ba9bbe5370f1bf2f {
    constructor(...args){
        super(...args), this.name = 'Fore Color', this.command = 'foreColor', this.colorName = 'color';
    }
}
class $3606afe94d964185$export$92bb6183e7459be2 extends $3606afe94d964185$export$ba9bbe5370f1bf2f {
    constructor(...args){
        super(...args), this.name = 'Back Color', this.command = 'backColor', this.colorName = 'backgroundColor';
    }
}
var $3606afe94d964185$var$$258f24df7a3cbf67$exports = {};
$3606afe94d964185$var$$parcel$export($3606afe94d964185$var$$258f24df7a3cbf67$exports, "AlignTool", function() {
    return $3606afe94d964185$export$6c1211091eb3b68f;
});
$3606afe94d964185$var$$parcel$export($3606afe94d964185$var$$258f24df7a3cbf67$exports, "AlignLeftTool", function() {
    return $3606afe94d964185$export$42a444ebfdcfe7b9;
});
$3606afe94d964185$var$$parcel$export($3606afe94d964185$var$$258f24df7a3cbf67$exports, "AlignCenterTool", function() {
    return $3606afe94d964185$export$9a2e6e0294a984eb;
});
$3606afe94d964185$var$$parcel$export($3606afe94d964185$var$$258f24df7a3cbf67$exports, "AlignRightTool", function() {
    return $3606afe94d964185$export$22363f91860fc258;
});
$3606afe94d964185$var$$parcel$export($3606afe94d964185$var$$258f24df7a3cbf67$exports, "AlignFullTool", function() {
    return $3606afe94d964185$export$42827b1362fed748;
});
$3606afe94d964185$var$$parcel$export($3606afe94d964185$var$$258f24df7a3cbf67$exports, "OrderedListTool", function() {
    return $3606afe94d964185$export$faf4e70f09f43a15;
});
$3606afe94d964185$var$$parcel$export($3606afe94d964185$var$$258f24df7a3cbf67$exports, "UnorderedListTool", function() {
    return $3606afe94d964185$export$cf4030b57a3fbe37;
});
$3606afe94d964185$var$$parcel$export($3606afe94d964185$var$$258f24df7a3cbf67$exports, "HorizontalRuleTool", function() {
    return $3606afe94d964185$export$dce8a7d6279fc201;
});
class $3606afe94d964185$export$6c1211091eb3b68f extends $3606afe94d964185$export$724f6b867059ef5f {
    get active() {
        if (super.getActive()) return true;
        const box = $3606afe94d964185$export$ac81f1ba58a5f363();
        return !!box && getComputedStyle(box).textAlign === this.align;
    }
}
class $3606afe94d964185$export$42a444ebfdcfe7b9 extends $3606afe94d964185$export$6c1211091eb3b68f {
    constructor(...args){
        super(...args), this.name = 'Align Left', this.command = 'justifyLeft', this.align = 'left';
    }
}
class $3606afe94d964185$export$9a2e6e0294a984eb extends $3606afe94d964185$export$6c1211091eb3b68f {
    constructor(...args){
        super(...args), this.name = 'Align Center', this.command = 'justifyCenter', this.align = 'center';
    }
}
class $3606afe94d964185$export$22363f91860fc258 extends $3606afe94d964185$export$6c1211091eb3b68f {
    constructor(...args){
        super(...args), this.name = 'Align Right', this.command = 'justifyRight', this.align = 'right';
    }
}
class $3606afe94d964185$export$42827b1362fed748 extends $3606afe94d964185$export$6c1211091eb3b68f {
    constructor(...args){
        super(...args), this.name = 'Align Full', this.command = 'justifyFull', this.align = 'justify';
    }
}
class $3606afe94d964185$export$faf4e70f09f43a15 extends $3606afe94d964185$export$724f6b867059ef5f {
    constructor(...args){
        super(...args), this.name = 'Ordered list', this.tags = [
            'ol'
        ], this.command = 'insertOrderedList';
    }
}
class $3606afe94d964185$export$cf4030b57a3fbe37 extends $3606afe94d964185$export$724f6b867059ef5f {
    constructor(...args){
        super(...args), this.name = 'Unordered list', this.tags = [
            'ul'
        ], this.command = 'insertUnorderedList';
    }
}
class $3606afe94d964185$export$dce8a7d6279fc201 extends $3606afe94d964185$export$724f6b867059ef5f {
    constructor(...args){
        super(...args), this.name = 'Horizontal rule', this.tags = [
            'hr'
        ], this.command = 'insertHorizontalRule';
    }
}
var $3606afe94d964185$var$$0769f8c709024b7a$exports = {};
$3606afe94d964185$var$$parcel$export($3606afe94d964185$var$$0769f8c709024b7a$exports, "IFrameTool", function() {
    return $3606afe94d964185$export$3e557574863db086;
});
$3606afe94d964185$var$$parcel$export($3606afe94d964185$var$$0769f8c709024b7a$exports, "ImageTool", function() {
    return $3606afe94d964185$export$982f47444a2f88da;
});
$3606afe94d964185$var$$parcel$export($3606afe94d964185$var$$0769f8c709024b7a$exports, "AudioTool", function() {
    return $3606afe94d964185$export$6024938f37e646f8;
});
$3606afe94d964185$var$$parcel$export($3606afe94d964185$var$$0769f8c709024b7a$exports, "VideoTool", function() {
    return $3606afe94d964185$export$932111b8028f79ed;
});
class $3606afe94d964185$export$3e557574863db086 extends $3606afe94d964185$export$724f6b867059ef5f {
    execute(editor) {
        const path = self.prompt('Path');
        if (path) this.edit(editor, `<iframe style="width: 100%; height: 50vh; border: none" src="${path}"></iframe>`);
    }
    constructor(...args){
        super(...args), this.name = 'Embed Web page', this.tags = [
            'iframe'
        ], this.command = 'insertHTML';
    }
}
class $3606afe94d964185$export$982f47444a2f88da extends $3606afe94d964185$export$de3122b2484864a7 {
    codeOf(path) {
        return `<img style="max-width: 100%; height: auto" src="${path}"/>`;
    }
    constructor(...args){
        super(...args), this.name = 'Image', this.tags = [
            'img'
        ], this.command = 'insertHTML';
    }
}
class $3606afe94d964185$export$6024938f37e646f8 extends $3606afe94d964185$export$de3122b2484864a7 {
    codeOf(path) {
        return `<audio controls src="${path}"></audio>`;
    }
    constructor(...args){
        super(...args), this.name = 'Audio', this.tags = [
            'audio'
        ], this.command = 'insertHTML';
    }
}
class $3606afe94d964185$export$932111b8028f79ed extends $3606afe94d964185$export$de3122b2484864a7 {
    codeOf(path) {
        return `<video controls src="${path}"></video>`;
    }
    constructor(...args){
        super(...args), this.name = 'Video', this.tags = [
            'video'
        ], this.command = 'insertHTML';
    }
}
var $3606afe94d964185$var$$2c12cf671c105d76$exports = {};
$3606afe94d964185$var$$parcel$export($3606afe94d964185$var$$2c12cf671c105d76$exports, "UndoTool", function() {
    return $3606afe94d964185$export$65235875731ff287;
});
$3606afe94d964185$var$$parcel$export($3606afe94d964185$var$$2c12cf671c105d76$exports, "RedoTool", function() {
    return $3606afe94d964185$export$b60f30d254d1e1a6;
});
$3606afe94d964185$var$$parcel$export($3606afe94d964185$var$$2c12cf671c105d76$exports, "ResetTool", function() {
    return $3606afe94d964185$export$6f46dc3d81fbb4bd;
});
$3606afe94d964185$var$$parcel$export($3606afe94d964185$var$$2c12cf671c105d76$exports, "ClearTool", function() {
    return $3606afe94d964185$export$25eb377ce1feaada;
});
class $3606afe94d964185$export$65235875731ff287 extends $3606afe94d964185$export$724f6b867059ef5f {
    constructor(...args){
        super(...args), this.name = 'Undo', this.command = 'undo';
    }
}
class $3606afe94d964185$export$b60f30d254d1e1a6 extends $3606afe94d964185$export$724f6b867059ef5f {
    constructor(...args){
        super(...args), this.name = 'Redo', this.command = 'redo';
    }
}
class $3606afe94d964185$export$6f46dc3d81fbb4bd extends $3606afe94d964185$export$724f6b867059ef5f {
    constructor(...args){
        super(...args), this.name = 'Reset', this.command = 'removeFormat';
    }
}
class $3606afe94d964185$export$25eb377ce1feaada extends $3606afe94d964185$export$724f6b867059ef5f {
    execute(editor) {
        editor.focus();
        document.execCommand('selectAll');
        document.execCommand('delete');
    }
    constructor(...args){
        super(...args), this.name = 'Clear';
    }
}
var $3606afe94d964185$var$$6e883fb0ea04260a$exports = {};
$3606afe94d964185$var$$parcel$export($3606afe94d964185$var$$6e883fb0ea04260a$exports, "turndown", function() {
    return $3606afe94d964185$export$48d4d6bf65314082;
});
$3606afe94d964185$var$$parcel$export($3606afe94d964185$var$$6e883fb0ea04260a$exports, "CopyMarkdownTool", function() {
    return $3606afe94d964185$export$4b13df0a6effdd72;
});
const $3606afe94d964185$var$$6e883fb0ea04260a$var$Empty_HREF = /^(#|javascript:\s*void\(0\);?\s*)$/;
const $3606afe94d964185$export$48d4d6bf65314082 = new (0, $092db34b836d8ae4$export$2e2bcd8739ae039)({
    hr: '---',
    linkStyle: 'referenced',
    headingStyle: 'atx',
    bulletListMarker: '-',
    codeBlockStyle: 'fenced'
}).use((0, $8b5b54c590bb494d$export$19426ff118fe8be)).use((0, $8b5b54c590bb494d$export$cc4ff83fc7bd256e)).use((0, $8b5b54c590bb494d$export$1f0c2747e2ba0b8d)).use((0, $8b5b54c590bb494d$export$59ffe8c4d7a4aab2)).addRule('non_url', {
    filter: (node)=>[
            'a',
            'area'
        ].includes(node.nodeName.toLowerCase()) && $3606afe94d964185$var$$6e883fb0ea04260a$var$Empty_HREF.test(node.getAttribute('href') || ''),
    replacement: ()=>''
}).addRule('img-srcset', {
    filter: [
        'img'
    ],
    replacement (_, { alt: alt, title: title, src: src, srcset: srcset }) {
        const [firstSet] = srcset.split(',')[0]?.split(/\s+/) || [];
        const content = [
            src || firstSet,
            title && JSON.stringify(title)
        ].filter(Boolean);
        return `![${alt}](${content.join(' ')})`;
    }
}).addRule('source-srcset', {
    filter: [
        'picture'
    ],
    replacement (_, node) {
        const { src: src, alt: alt, title: title } = node.querySelector('img') || {};
        const sourceList = [
            ...node.querySelectorAll('source')
        ].map(({ sizes: sizes, srcset: srcset })=>{
            const size = Math.max(...sizes.split(/,|\)/).map((pixel)=>parseFloat(pixel.trim())).filter(Boolean));
            const [src] = srcset.split(',')[0]?.split(/\s+/) || [];
            return {
                size: size,
                src: src
            };
        });
        const sources = sourceList.sort(({ size: a }, { size: b })=>b - a);
        const content = [
            src || sources[0]?.src,
            title && JSON.stringify(title)
        ].filter(Boolean);
        return `![${alt}](${content.join(' ')})`;
    }
}).remove((node)=>node.matches('style, script, aside, form, [class*="ads" i]')).keep((node)=>node.matches('kbd, iframe'));
class $3606afe94d964185$export$4b13df0a6effdd72 extends $3606afe94d964185$export$724f6b867059ef5f {
    async execute({ innerHTML: innerHTML }) {
        const markdown = $3606afe94d964185$export$48d4d6bf65314082.turndown(innerHTML);
        await navigator.clipboard.writeText(markdown);
        alert('Markdown copied to clipboard');
    }
    constructor(...args){
        super(...args), this.name = 'Copy Markdown';
    }
}
var $3606afe94d964185$var$$b738b8c7b1139833$exports = {};
$3606afe94d964185$var$$parcel$export($3606afe94d964185$var$$b738b8c7b1139833$exports, "editor", function() {
    return $3606afe94d964185$export$b5d042d2b680aed6;
});
const $3606afe94d964185$export$b5d042d2b680aed6 = (Class, {})=>class EditorTrait extends Class {
        async uploadFile(tool, data) {
            if (typeof data === 'string' && !/^(data|blob):/.test(data)) return data;
            try {
                return await tool.save(typeof data === 'string' ? await (0, $fbe6f1e2fed97fc7$export$fd89523fba250fa4)(data) : data);
            } catch (error) {
                console.error(error);
                if (typeof data === 'string') return data;
            }
        }
        async clearHTML(markup) {
            const { imageTool: imageTool, audioTool: audioTool, videoTool: videoTool } = this, fragment = document.createDocumentFragment();
            fragment.append(...(0, $fbe6f1e2fed97fc7$export$d66b332881d9723f)(markup));
            for (const element of (0, $fbe6f1e2fed97fc7$export$5118471ee5d5453b)(fragment, Node.ELEMENT_NODE)){
                const { style: style, dataset: dataset } = element;
                if ([
                    'nowrap',
                    'pre'
                ].includes(style.whiteSpace)) style.whiteSpace = 'normal';
                for(const key in dataset)delete dataset[key];
                if (element instanceof HTMLImageElement && imageTool) element.src = await this.uploadFile(imageTool, element.src);
                else if (element instanceof HTMLAudioElement && audioTool) element.src = await this.uploadFile(audioTool, element.src);
                else if (element instanceof HTMLVideoElement && videoTool) element.src = await this.uploadFile(videoTool, element.src);
            }
            return fragment;
        }
        async transferMedia(item) {
            const { imageTool: imageTool, audioTool: audioTool, videoTool: videoTool } = this;
            if (item.type === 'text/html') {
                const raw = await new Promise((resolve)=>item.getAsString(resolve));
                (0, $fbe6f1e2fed97fc7$export$28d9d24a8cd0ffc2)(await this.clearHTML(raw));
            } else if (item.type.startsWith('image/') && imageTool) {
                const URI = await this.uploadFile(imageTool, item.getAsFile());
                if (URI) (0, $fbe6f1e2fed97fc7$export$28d9d24a8cd0ffc2)((0, $fbe6f1e2fed97fc7$export$d66b332881d9723f)(`<img src="${URI}" />`)[0]);
            } else if (item.type.startsWith('audio/') && audioTool) {
                const URI = await this.uploadFile(audioTool, item.getAsFile());
                if (URI) (0, $fbe6f1e2fed97fc7$export$28d9d24a8cd0ffc2)((0, $fbe6f1e2fed97fc7$export$d66b332881d9723f)(`<audio src="${URI}" />`)[0]);
            } else if (item.type.startsWith('video/') && videoTool) {
                const URI = await this.uploadFile(videoTool, item.getAsFile());
                if (URI) (0, $fbe6f1e2fed97fc7$export$28d9d24a8cd0ffc2)((0, $fbe6f1e2fed97fc7$export$d66b332881d9723f)(`<video src="${URI}" />`)[0]);
            }
        }
        constructor(...args){
            super(...args), this.handlePasteDrop = async (event)=>{
                event.preventDefault();
                const root = event.currentTarget;
                const list = event.type === 'paste' ? [
                    ...event.clipboardData.items
                ] : [
                    ...event.dataTransfer.items
                ];
                root.focus();
                const [plainText, htmlText] = list.filter(({ type: type })=>type.startsWith('text/'));
                if (!htmlText && plainText.type === 'text/plain') {
                    const raw = await new Promise((resolve)=>plainText.getAsString(resolve));
                    (0, $fbe6f1e2fed97fc7$export$28d9d24a8cd0ffc2)(await this.clearHTML((0, $a5cf0eae8608a64d$export$db8f131360c543a5)(raw)));
                } else for (const item of list)await this.transferMedia(item);
                this.updateValue(root.innerHTML);
            };
        }
    };







var $d5I5D = parcelRequire("d5I5D");

var $dc0c0b6e58c23485$exports = {};








var $dYe7D = parcelRequire("dYe7D");

var $d5I5D = parcelRequire("d5I5D");
parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");

function $dc0c0b6e58c23485$var$$parcel$exportWildcard(e, t) {
    return Object.keys(t).forEach(function(r) {
        "default" === r || "__esModule" === r || Object.prototype.hasOwnProperty.call(e, r) || Object.defineProperty(e, r, {
            enumerable: !0,
            get: function() {
                return t[r];
            }
        });
    }), e;
}
function $dc0c0b6e58c23485$var$$parcel$interopDefault(e) {
    return e && e.__esModule ? e.default : e;
}
function $dc0c0b6e58c23485$var$$parcel$export(e, t, r, a) {
    Object.defineProperty(e, t, {
        get: r,
        set: a,
        enumerable: !0,
        configurable: !0
    });
}
var $dc0c0b6e58c23485$var$$0172b398bee57f0a$exports = {};
$dc0c0b6e58c23485$var$$parcel$export($dc0c0b6e58c23485$var$$0172b398bee57f0a$exports, "isEqualProps", function() {
    return $dc0c0b6e58c23485$var$$0172b398bee57f0a$export$7112c88e033533b8;
}), $dc0c0b6e58c23485$var$$parcel$export($dc0c0b6e58c23485$var$$0172b398bee57f0a$exports, "ObservedComponent", function() {
    return $dc0c0b6e58c23485$var$$0172b398bee57f0a$export$bf180ef329d1efd8;
});
var $dc0c0b6e58c23485$var$$0172b398bee57f0a$var$__esDecorate = function(e, t, r, a, s, n) {
    function i(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var c, o = a.kind, l = "getter" === o ? "get" : "setter" === o ? "set" : "value", u = !t && e ? a.static ? e : e.prototype : null, $ = t || (u ? Object.getOwnPropertyDescriptor(u, a.name) : {}), f = !1, d = r.length - 1; d >= 0; d--){
        var b = {};
        for(var p in a)b[p] = "access" === p ? {} : a[p];
        for(var p in a.access)b.access[p] = a.access[p];
        b.addInitializer = function(e) {
            if (f) throw TypeError("Cannot add initializers after decoration has completed");
            n.push(i(e || null));
        };
        var v = (0, r[d])("accessor" === o ? {
            get: $.get,
            set: $.set
        } : $[l], b);
        if ("accessor" === o) {
            if (void 0 === v) continue;
            if (null === v || (void 0 === v ? "undefined" : (0, $35f6c23f56aaf458$export$71511d61b312f219)(v)) !== "object") throw TypeError("Object expected");
            (c = i(v.get)) && ($.get = c), (c = i(v.set)) && ($.set = c), (c = i(v.init)) && s.unshift(c);
        } else (c = i(v)) && ("field" === o ? s.unshift(c) : $[l] = c);
    }
    u && Object.defineProperty(u, a.name, $), f = !0;
}, $dc0c0b6e58c23485$var$$0172b398bee57f0a$var$__runInitializers = function(e, t, r) {
    for(var a = arguments.length > 2, s = 0; s < t.length; s++)r = a ? t[s].call(e, r) : t[s].call(e);
    return a ? r : void 0;
}, $dc0c0b6e58c23485$var$$0172b398bee57f0a$var$__classPrivateFieldGet = function(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $dc0c0b6e58c23485$var$$0172b398bee57f0a$var$__classPrivateFieldSet = function(e, t, r, a, s) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !s) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !s : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? s.call(e, r) : s ? s.value = r : t.set(e, r), r;
}, $dc0c0b6e58c23485$var$$0172b398bee57f0a$export$7112c88e033533b8 = function(e, t) {
    return $dc0c0b6e58c23485$var$$parcel$interopDefault($dYe7D)(e, t, function(e, t, r) {
        return [
            "_owner",
            "$$typeof"
        ].includes(r) || void 0;
    });
}, $dc0c0b6e58c23485$var$$0172b398bee57f0a$export$bf180ef329d1efd8 = function() {
    var e, t, r, a, s, n, i, c, o, l, u, $ = $hO8yS.Component, f = [], d = [], b = [], p = [], v = [], _ = [];
    return r = function(e) {
        "use strict";
        function t() {
            var e;
            return (0, $2b3af368dbb30b38$export$71511d61b312f219)(this, t), e = (0, $95518c9e748840bb$export$71511d61b312f219)(this, t, arguments), a.set(e, $dc0c0b6e58c23485$var$$0172b398bee57f0a$var$__runInitializers(e, f, e.props)), s.set(e, ($dc0c0b6e58c23485$var$$0172b398bee57f0a$var$__runInitializers(e, d), $dc0c0b6e58c23485$var$$0172b398bee57f0a$var$__runInitializers(e, b, e.state))), n.set(e, ($dc0c0b6e58c23485$var$$0172b398bee57f0a$var$__runInitializers(e, p), $dc0c0b6e58c23485$var$$0172b398bee57f0a$var$__runInitializers(e, v, e.context))), $dc0c0b6e58c23485$var$$0172b398bee57f0a$var$__runInitializers(e, _), e;
        }
        return (0, $92f5157d74f7ea45$export$71511d61b312f219)(t, e), (0, $53cdca766716469e$export$71511d61b312f219)(t, [
            {
                key: "observedProps",
                get: function() {
                    return $dc0c0b6e58c23485$var$$0172b398bee57f0a$var$__classPrivateFieldGet(this, a, "f");
                },
                set: function(e) {
                    $dc0c0b6e58c23485$var$$0172b398bee57f0a$var$__classPrivateFieldSet(this, a, e, "f");
                }
            },
            {
                key: "observedState",
                get: function() {
                    return $dc0c0b6e58c23485$var$$0172b398bee57f0a$var$__classPrivateFieldGet(this, s, "f");
                },
                set: function(e) {
                    $dc0c0b6e58c23485$var$$0172b398bee57f0a$var$__classPrivateFieldSet(this, s, e, "f");
                }
            },
            {
                key: "observedContext",
                get: function() {
                    return $dc0c0b6e58c23485$var$$0172b398bee57f0a$var$__classPrivateFieldGet(this, n, "f");
                },
                set: function(e) {
                    $dc0c0b6e58c23485$var$$0172b398bee57f0a$var$__classPrivateFieldSet(this, n, e, "f");
                }
            },
            {
                key: "componentDidUpdate",
                value: function(e, r, a) {
                    var s;
                    $dc0c0b6e58c23485$var$$0172b398bee57f0a$export$7112c88e033533b8(e, this.props) || (this.observedProps = Object.assign({}, this.props)), $dc0c0b6e58c23485$var$$0172b398bee57f0a$export$7112c88e033533b8(r, this.state) || (this.observedState = Object.assign({}, this.state)), null == (s = (0, $0b0867a6ee357054$export$71511d61b312f219)((0, $9ac8e64cff09d58e$export$71511d61b312f219)(t.prototype), "componentDidUpdate", this)) || s.call(this, e, r, a);
                }
            }
        ]), t;
    }($), a = new WeakMap, s = new WeakMap, n = new WeakMap, t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = $[Symbol.metadata]) ? e : null) : void 0, o = [
        (e = $d5I5D.observable).shallow.bind(e)
    ], l = [
        (i = $d5I5D.observable).shallow.bind(i)
    ], u = [
        (c = $d5I5D.observable).shallow.bind(c)
    ], $dc0c0b6e58c23485$var$$0172b398bee57f0a$var$__esDecorate(r, null, o, {
        kind: "accessor",
        name: "observedProps",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "observedProps" in e;
            },
            get: function(e) {
                return e.observedProps;
            },
            set: function(e, t) {
                e.observedProps = t;
            }
        },
        metadata: t
    }, f, d), $dc0c0b6e58c23485$var$$0172b398bee57f0a$var$__esDecorate(r, null, l, {
        kind: "accessor",
        name: "observedState",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "observedState" in e;
            },
            get: function(e) {
                return e.observedState;
            },
            set: function(e, t) {
                e.observedState = t;
            }
        },
        metadata: t
    }, b, p), $dc0c0b6e58c23485$var$$0172b398bee57f0a$var$__esDecorate(r, null, u, {
        kind: "accessor",
        name: "observedContext",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "observedContext" in e;
            },
            get: function(e) {
                return e.observedContext;
            },
            set: function(e, t) {
                e.observedContext = t;
            }
        },
        metadata: t
    }, v, _), t && Object.defineProperty(r, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), r;
}(), $dc0c0b6e58c23485$var$$621b7277d4dc39e9$exports = {};
$dc0c0b6e58c23485$var$$parcel$export($dc0c0b6e58c23485$var$$621b7277d4dc39e9$exports, "FormComponent", function() {
    return $dc0c0b6e58c23485$var$$621b7277d4dc39e9$export$cec7cafc710f5d68;
});
var $dc0c0b6e58c23485$var$$621b7277d4dc39e9$var$__runInitializers = function(e, t, r) {
    for(var a = arguments.length > 2, s = 0; s < t.length; s++)r = a ? t[s].call(e, r) : t[s].call(e);
    return a ? r : void 0;
}, $dc0c0b6e58c23485$var$$621b7277d4dc39e9$var$__esDecorate = function(e, t, r, a, s, n) {
    function i(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var c, o = a.kind, l = "getter" === o ? "get" : "setter" === o ? "set" : "value", u = !t && e ? a.static ? e : e.prototype : null, $ = t || (u ? Object.getOwnPropertyDescriptor(u, a.name) : {}), f = !1, d = r.length - 1; d >= 0; d--){
        var b = {};
        for(var p in a)b[p] = "access" === p ? {} : a[p];
        for(var p in a.access)b.access[p] = a.access[p];
        b.addInitializer = function(e) {
            if (f) throw TypeError("Cannot add initializers after decoration has completed");
            n.push(i(e || null));
        };
        var v = (0, r[d])("accessor" === o ? {
            get: $.get,
            set: $.set
        } : $[l], b);
        if ("accessor" === o) {
            if (void 0 === v) continue;
            if (null === v || (void 0 === v ? "undefined" : (0, $35f6c23f56aaf458$export$71511d61b312f219)(v)) !== "object") throw TypeError("Object expected");
            (c = i(v.get)) && ($.get = c), (c = i(v.set)) && ($.set = c), (c = i(v.init)) && s.unshift(c);
        } else (c = i(v)) && ("field" === o ? s.unshift(c) : $[l] = c);
    }
    u && Object.defineProperty(u, a.name, $), f = !0;
}, $dc0c0b6e58c23485$var$$621b7277d4dc39e9$var$__classPrivateFieldGet = function(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $dc0c0b6e58c23485$var$$621b7277d4dc39e9$var$__classPrivateFieldSet = function(e, t, r, a, s) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !s) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !s : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? s.call(e, r) : s ? s.value = r : t.set(e, r), r;
}, $dc0c0b6e58c23485$var$$621b7277d4dc39e9$export$cec7cafc710f5d68 = function() {
    var e, t, r, a, s, n, i, c, o, l = [], u = [], $ = [];
    return e = function(e) {
        "use strict";
        function n() {
            var e;
            return (0, $2b3af368dbb30b38$export$71511d61b312f219)(this, n), e = (0, $95518c9e748840bb$export$71511d61b312f219)(this, n, arguments), Object.defineProperty(e, "ref", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($dc0c0b6e58c23485$var$$621b7277d4dc39e9$var$__runInitializers(e, l), (0, $hO8yS.createRef)())
            }), s.set(e, $dc0c0b6e58c23485$var$$621b7277d4dc39e9$var$__runInitializers(e, u, e.props.defaultValue)), t.set(e, $dc0c0b6e58c23485$var$$621b7277d4dc39e9$var$__runInitializers(e, $)), r.set(e, void 0), a.set(e, function(t) {
                !(0, $fbe6f1e2fed97fc7$export$dd1bc94b04021eeb)(t) && (0, $fbe6f1e2fed97fc7$export$dd1bc94b04021eeb)(e.innerValue) && (e.innerValue = t);
            }), Object.defineProperty(e, "emitValue", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function(t) {
                    var r, a;
                    return null == (a = (r = e.observedProps).onChange) ? void 0 : a.call(r, t && (void 0 === t ? "undefined" : (0, $35f6c23f56aaf458$export$71511d61b312f219)(t)) === "object" ? (0, $d5I5D.toJS)(t) : t);
                }
            }), Object.defineProperty(e, "reset", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function() {
                    return e.innerValue = e.props.defaultValue;
                }
            }), e;
        }
        return (0, $92f5157d74f7ea45$export$71511d61b312f219)(n, e), (0, $53cdca766716469e$export$71511d61b312f219)(n, [
            {
                key: "innerValue",
                get: function() {
                    return $dc0c0b6e58c23485$var$$621b7277d4dc39e9$var$__classPrivateFieldGet(this, s, "f");
                },
                set: function(e) {
                    $dc0c0b6e58c23485$var$$621b7277d4dc39e9$var$__classPrivateFieldSet(this, s, e, "f");
                }
            },
            {
                key: "value",
                get: function() {
                    var e;
                    return null != (e = this.observedProps.value) ? e : this.innerValue;
                }
            },
            {
                key: "componentDidMount",
                value: function() {
                    var e, s, n = this;
                    $dc0c0b6e58c23485$var$$621b7277d4dc39e9$var$__classPrivateFieldSet(this, t, (0, $d5I5D.reaction)(function() {
                        return n.observedProps.defaultValue;
                    }, $dc0c0b6e58c23485$var$$621b7277d4dc39e9$var$__classPrivateFieldGet(this, a, "f")), "f"), $dc0c0b6e58c23485$var$$621b7277d4dc39e9$var$__classPrivateFieldSet(this, r, (0, $d5I5D.reaction)(function() {
                        return n.innerValue;
                    }, this.emitValue), "f"), null == (s = null == (e = this.ref.current) ? void 0 : e.form) || s.addEventListener("reset", this.reset);
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    var e, a, s, n;
                    null == (e = $dc0c0b6e58c23485$var$$621b7277d4dc39e9$var$__classPrivateFieldGet(this, t, "f")) || e.call(this), $dc0c0b6e58c23485$var$$621b7277d4dc39e9$var$__classPrivateFieldSet(this, t, void 0, "f"), null == (a = $dc0c0b6e58c23485$var$$621b7277d4dc39e9$var$__classPrivateFieldGet(this, r, "f")) || a.call(this), $dc0c0b6e58c23485$var$$621b7277d4dc39e9$var$__classPrivateFieldSet(this, r, void 0, "f"), null == (n = null == (s = this.ref.current) ? void 0 : s.form) || n.removeEventListener("reset", this.reset);
                }
            }
        ]), n;
    }($dc0c0b6e58c23485$var$$0172b398bee57f0a$export$bf180ef329d1efd8), t = new WeakMap, r = new WeakMap, a = new WeakMap, s = new WeakMap, o = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (c = $dc0c0b6e58c23485$var$$0172b398bee57f0a$export$bf180ef329d1efd8[Symbol.metadata]) ? c : null) : void 0, n = [
        $d5I5D.observable
    ], i = [
        $d5I5D.computed
    ], $dc0c0b6e58c23485$var$$621b7277d4dc39e9$var$__esDecorate(e, null, n, {
        kind: "accessor",
        name: "innerValue",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "innerValue" in e;
            },
            get: function(e) {
                return e.innerValue;
            },
            set: function(e, t) {
                e.innerValue = t;
            }
        },
        metadata: o
    }, u, $), $dc0c0b6e58c23485$var$$621b7277d4dc39e9$var$__esDecorate(e, null, i, {
        kind: "getter",
        name: "value",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "value" in e;
            },
            get: function(e) {
                return e.value;
            }
        },
        metadata: o
    }, null, l), o && Object.defineProperty(e, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: o
    }), e;
}();
$dc0c0b6e58c23485$var$$parcel$exportWildcard($dc0c0b6e58c23485$exports, $dc0c0b6e58c23485$var$$0172b398bee57f0a$exports), $dc0c0b6e58c23485$var$$parcel$exportWildcard($dc0c0b6e58c23485$exports, $dc0c0b6e58c23485$var$$621b7277d4dc39e9$exports);


parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
function $35c5af1670f53210$var$$parcel$exportWildcard(e, r) {
    return Object.keys(r).forEach(function(c) {
        "default" === c || "__esModule" === c || Object.prototype.hasOwnProperty.call(e, c) || Object.defineProperty(e, c, {
            enumerable: !0,
            get: function() {
                return r[c];
            }
        });
    }), e;
}
function $35c5af1670f53210$var$$parcel$export(e, r, c, t) {
    Object.defineProperty(e, r, {
        get: c,
        set: t,
        enumerable: !0,
        configurable: !0
    });
}
var $35c5af1670f53210$var$$73a8882fd67c0324$exports = {};
function $35c5af1670f53210$var$$73a8882fd67c0324$export$56ccecc1dac11363(e) {
    var r = this, c = this.title, t = this.active, a = this.icon, $ = this.usable;
    return (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("button", {
        type: "button",
        title: c,
        className: "btn btn-".concat((t ? "" : "outline-") + "secondary", " me-2 mb-2"),
        style: {
            cursor: $ ? "pointer" : "not-allowed"
        },
        disabled: !$,
        onClick: function(c) {
            c.preventDefault(), e.current && r.execute(e.current);
        },
        children: (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("i", {
            className: "bi-".concat(a)
        })
    }, a);
}
$35c5af1670f53210$var$$parcel$export($35c5af1670f53210$var$$73a8882fd67c0324$exports, "renderTool", function() {
    return $35c5af1670f53210$var$$73a8882fd67c0324$export$56ccecc1dac11363;
});
var $35c5af1670f53210$var$$a01145bb2edfc771$exports = {};
$35c5af1670f53210$var$$parcel$export($35c5af1670f53210$var$$a01145bb2edfc771$exports, "TextTools", function() {
    return $35c5af1670f53210$var$$a01145bb2edfc771$export$e252ba763eff5cdc;
}), $35c5af1670f53210$var$$parcel$export($35c5af1670f53210$var$$a01145bb2edfc771$exports, "ColorTools", function() {
    return $35c5af1670f53210$var$$a01145bb2edfc771$export$bdef6e97a10dbad4;
}), $35c5af1670f53210$var$$parcel$export($35c5af1670f53210$var$$a01145bb2edfc771$exports, "LayoutTools", function() {
    return $35c5af1670f53210$var$$a01145bb2edfc771$export$145c1b37c0810d7;
}), $35c5af1670f53210$var$$parcel$export($35c5af1670f53210$var$$a01145bb2edfc771$exports, "MediaTools", function() {
    return $35c5af1670f53210$var$$a01145bb2edfc771$export$999636c6e25075fb;
}), $35c5af1670f53210$var$$parcel$export($35c5af1670f53210$var$$a01145bb2edfc771$exports, "ControlTools", function() {
    return $35c5af1670f53210$var$$a01145bb2edfc771$export$f35db4b82786c3a4;
}), $35c5af1670f53210$var$$parcel$export($35c5af1670f53210$var$$a01145bb2edfc771$exports, "ExtraTools", function() {
    return $35c5af1670f53210$var$$a01145bb2edfc771$export$b8ecf7d74432d529;
}), $35c5af1670f53210$var$$parcel$export($35c5af1670f53210$var$$a01145bb2edfc771$exports, "OriginalTools", function() {
    return $35c5af1670f53210$var$$a01145bb2edfc771$export$9ddb256264948609;
}), $35c5af1670f53210$var$$parcel$export($35c5af1670f53210$var$$a01145bb2edfc771$exports, "DefaultTools", function() {
    return $35c5af1670f53210$var$$a01145bb2edfc771$export$aa718db1466ce312;
});
var $35c5af1670f53210$var$$fe2cab60e3c7ea35$exports = {};
$35c5af1670f53210$var$$parcel$export($35c5af1670f53210$var$$fe2cab60e3c7ea35$exports, "BoldTool", function() {
    return $35c5af1670f53210$var$$fe2cab60e3c7ea35$export$10056a49e3b218eb;
}), $35c5af1670f53210$var$$parcel$export($35c5af1670f53210$var$$fe2cab60e3c7ea35$exports, "ItalicTool", function() {
    return $35c5af1670f53210$var$$fe2cab60e3c7ea35$export$edf99d0f51bacb1e;
}), $35c5af1670f53210$var$$parcel$export($35c5af1670f53210$var$$fe2cab60e3c7ea35$exports, "UnderlineTool", function() {
    return $35c5af1670f53210$var$$fe2cab60e3c7ea35$export$4b6d9c17188960d2;
}), $35c5af1670f53210$var$$parcel$export($35c5af1670f53210$var$$fe2cab60e3c7ea35$exports, "StrikeThroughTool", function() {
    return $35c5af1670f53210$var$$fe2cab60e3c7ea35$export$a35bffaeae8fdda0;
}), $35c5af1670f53210$var$$parcel$export($35c5af1670f53210$var$$fe2cab60e3c7ea35$exports, "H1Tool", function() {
    return $35c5af1670f53210$var$$fe2cab60e3c7ea35$export$30e8c6b428f8749f;
}), $35c5af1670f53210$var$$parcel$export($35c5af1670f53210$var$$fe2cab60e3c7ea35$exports, "H2Tool", function() {
    return $35c5af1670f53210$var$$fe2cab60e3c7ea35$export$58443375efa91029;
}), $35c5af1670f53210$var$$parcel$export($35c5af1670f53210$var$$fe2cab60e3c7ea35$exports, "H3Tool", function() {
    return $35c5af1670f53210$var$$fe2cab60e3c7ea35$export$75d24d6b8b747307;
}), $35c5af1670f53210$var$$parcel$export($35c5af1670f53210$var$$fe2cab60e3c7ea35$exports, "FontSizeDownTool", function() {
    return $35c5af1670f53210$var$$fe2cab60e3c7ea35$export$a20806c6ef6938f8;
}), $35c5af1670f53210$var$$parcel$export($35c5af1670f53210$var$$fe2cab60e3c7ea35$exports, "FontSizeUpTool", function() {
    return $35c5af1670f53210$var$$fe2cab60e3c7ea35$export$744da7e24e4a7382;
}), $35c5af1670f53210$var$$parcel$export($35c5af1670f53210$var$$fe2cab60e3c7ea35$exports, "SubscriptTool", function() {
    return $35c5af1670f53210$var$$fe2cab60e3c7ea35$export$6137518b4e998008;
}), $35c5af1670f53210$var$$parcel$export($35c5af1670f53210$var$$fe2cab60e3c7ea35$exports, "SuperscriptTool", function() {
    return $35c5af1670f53210$var$$fe2cab60e3c7ea35$export$7217f06c61ebd4fc;
}), $35c5af1670f53210$var$$parcel$export($35c5af1670f53210$var$$fe2cab60e3c7ea35$exports, "LinkTool", function() {
    return $35c5af1670f53210$var$$fe2cab60e3c7ea35$export$f6c54364b5332e66;
});
var $35c5af1670f53210$var$$fe2cab60e3c7ea35$export$10056a49e3b218eb = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $2b3af368dbb30b38$export$71511d61b312f219)(this, r), e = (0, $95518c9e748840bb$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "type-bold"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $35c5af1670f53210$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), e;
    }
    return (0, $92f5157d74f7ea45$export$71511d61b312f219)(r, e), r;
}($3606afe94d964185$export$10056a49e3b218eb), $35c5af1670f53210$var$$fe2cab60e3c7ea35$export$edf99d0f51bacb1e = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $2b3af368dbb30b38$export$71511d61b312f219)(this, r), e = (0, $95518c9e748840bb$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "type-italic"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $35c5af1670f53210$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), e;
    }
    return (0, $92f5157d74f7ea45$export$71511d61b312f219)(r, e), r;
}($3606afe94d964185$export$edf99d0f51bacb1e), $35c5af1670f53210$var$$fe2cab60e3c7ea35$export$4b6d9c17188960d2 = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $2b3af368dbb30b38$export$71511d61b312f219)(this, r), e = (0, $95518c9e748840bb$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "type-underline"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $35c5af1670f53210$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), e;
    }
    return (0, $92f5157d74f7ea45$export$71511d61b312f219)(r, e), r;
}($3606afe94d964185$export$4b6d9c17188960d2), $35c5af1670f53210$var$$fe2cab60e3c7ea35$export$a35bffaeae8fdda0 = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $2b3af368dbb30b38$export$71511d61b312f219)(this, r), e = (0, $95518c9e748840bb$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "type-strikethrough"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $35c5af1670f53210$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), e;
    }
    return (0, $92f5157d74f7ea45$export$71511d61b312f219)(r, e), r;
}($3606afe94d964185$export$a35bffaeae8fdda0), $35c5af1670f53210$var$$fe2cab60e3c7ea35$export$30e8c6b428f8749f = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $2b3af368dbb30b38$export$71511d61b312f219)(this, r), e = (0, $95518c9e748840bb$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "type-h1"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $35c5af1670f53210$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), e;
    }
    return (0, $92f5157d74f7ea45$export$71511d61b312f219)(r, e), r;
}($3606afe94d964185$export$30e8c6b428f8749f), $35c5af1670f53210$var$$fe2cab60e3c7ea35$export$58443375efa91029 = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $2b3af368dbb30b38$export$71511d61b312f219)(this, r), e = (0, $95518c9e748840bb$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "type-h2"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $35c5af1670f53210$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), e;
    }
    return (0, $92f5157d74f7ea45$export$71511d61b312f219)(r, e), r;
}($3606afe94d964185$export$58443375efa91029), $35c5af1670f53210$var$$fe2cab60e3c7ea35$export$75d24d6b8b747307 = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $2b3af368dbb30b38$export$71511d61b312f219)(this, r), e = (0, $95518c9e748840bb$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "type-h3"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $35c5af1670f53210$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), e;
    }
    return (0, $92f5157d74f7ea45$export$71511d61b312f219)(r, e), r;
}($3606afe94d964185$export$75d24d6b8b747307), $35c5af1670f53210$var$$fe2cab60e3c7ea35$export$a20806c6ef6938f8 = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $2b3af368dbb30b38$export$71511d61b312f219)(this, r), e = (0, $95518c9e748840bb$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "sort-alpha-down"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $35c5af1670f53210$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), e;
    }
    return (0, $92f5157d74f7ea45$export$71511d61b312f219)(r, e), r;
}($3606afe94d964185$export$a20806c6ef6938f8), $35c5af1670f53210$var$$fe2cab60e3c7ea35$export$744da7e24e4a7382 = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $2b3af368dbb30b38$export$71511d61b312f219)(this, r), e = (0, $95518c9e748840bb$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "sort-alpha-up"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $35c5af1670f53210$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), e;
    }
    return (0, $92f5157d74f7ea45$export$71511d61b312f219)(r, e), r;
}($3606afe94d964185$export$744da7e24e4a7382), $35c5af1670f53210$var$$fe2cab60e3c7ea35$export$6137518b4e998008 = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $2b3af368dbb30b38$export$71511d61b312f219)(this, r), e = (0, $95518c9e748840bb$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "box-arrow-down-right"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $35c5af1670f53210$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), e;
    }
    return (0, $92f5157d74f7ea45$export$71511d61b312f219)(r, e), r;
}($3606afe94d964185$export$6137518b4e998008), $35c5af1670f53210$var$$fe2cab60e3c7ea35$export$7217f06c61ebd4fc = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $2b3af368dbb30b38$export$71511d61b312f219)(this, r), e = (0, $95518c9e748840bb$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "box-arrow-up-right"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $35c5af1670f53210$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), e;
    }
    return (0, $92f5157d74f7ea45$export$71511d61b312f219)(r, e), r;
}($3606afe94d964185$export$7217f06c61ebd4fc), $35c5af1670f53210$var$$fe2cab60e3c7ea35$export$f6c54364b5332e66 = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $2b3af368dbb30b38$export$71511d61b312f219)(this, r), e = (0, $95518c9e748840bb$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "link"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $35c5af1670f53210$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), e;
    }
    return (0, $92f5157d74f7ea45$export$71511d61b312f219)(r, e), r;
}($3606afe94d964185$export$f6c54364b5332e66), $35c5af1670f53210$var$$b1f503bd59fa3427$exports = {};
$35c5af1670f53210$var$$parcel$export($35c5af1670f53210$var$$b1f503bd59fa3427$exports, "ColorSelector", function() {
    return $35c5af1670f53210$var$$b1f503bd59fa3427$export$9012acaf449cdfcb;
}), $35c5af1670f53210$var$$parcel$export($35c5af1670f53210$var$$b1f503bd59fa3427$exports, "renderColorTool", function() {
    return $35c5af1670f53210$var$$b1f503bd59fa3427$export$e913fac2ab7b6f29;
}), $35c5af1670f53210$var$$parcel$export($35c5af1670f53210$var$$b1f503bd59fa3427$exports, "ForeColorTool", function() {
    return $35c5af1670f53210$var$$b1f503bd59fa3427$export$cab0e15cfb8489d7;
}), $35c5af1670f53210$var$$parcel$export($35c5af1670f53210$var$$b1f503bd59fa3427$exports, "BackColorTool", function() {
    return $35c5af1670f53210$var$$b1f503bd59fa3427$export$92bb6183e7459be2;
});
var $35c5af1670f53210$var$$b1f503bd59fa3427$export$9012acaf449cdfcb = function(e) {
    var r = e.className, c = e.title, t = e.type, a = e.value, $ = e.onChange, o = e.icon;
    return (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("span", {
        className: "d-inline-block align-middle position-relative ".concat(void 0 === r ? "" : r),
        title: c,
        children: [
            (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("input", {
                className: "position-absolute w-100 h-100 start-0 top-0 z-n1 rounded-3",
                type: "color",
                value: a,
                onChange: function(e) {
                    var r = e.target.value;
                    return null == $ ? void 0 : $(r);
                }
            }),
            (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("button", {
                className: "btn",
                style: {
                    color: "color" === t ? a : "lightgray",
                    backgroundColor: "color" === t ? "white" : a,
                    borderColor: a
                },
                onClick: function(e) {
                    e.preventDefault(), e.currentTarget.previousElementSibling.click();
                },
                children: (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("i", {
                    className: "bi-".concat(o)
                })
            })
        ]
    });
};
function $35c5af1670f53210$var$$b1f503bd59fa3427$export$e913fac2ab7b6f29(e) {
    var r = this, c = this.icon, t = this.name, a = this.colorName;
    return (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($35c5af1670f53210$var$$b1f503bd59fa3427$export$9012acaf449cdfcb, {
        className: "me-2 mb-2",
        title: t,
        icon: c,
        type: a,
        value: this.getColor(),
        onChange: function(c) {
            return e.current && r.execute(e.current, c);
        }
    }, c);
}
var $35c5af1670f53210$var$$b1f503bd59fa3427$export$cab0e15cfb8489d7 = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $2b3af368dbb30b38$export$71511d61b312f219)(this, r), e = (0, $95518c9e748840bb$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "file-earmark-font"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $35c5af1670f53210$var$$b1f503bd59fa3427$export$e913fac2ab7b6f29
        }), e;
    }
    return (0, $92f5157d74f7ea45$export$71511d61b312f219)(r, e), r;
}($3606afe94d964185$export$cab0e15cfb8489d7), $35c5af1670f53210$var$$b1f503bd59fa3427$export$92bb6183e7459be2 = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $2b3af368dbb30b38$export$71511d61b312f219)(this, r), e = (0, $95518c9e748840bb$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "file-earmark-font-fill"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $35c5af1670f53210$var$$b1f503bd59fa3427$export$e913fac2ab7b6f29
        }), e;
    }
    return (0, $92f5157d74f7ea45$export$71511d61b312f219)(r, e), r;
}($3606afe94d964185$export$92bb6183e7459be2), $35c5af1670f53210$var$$eb30d0fbb9378b9a$exports = {};
$35c5af1670f53210$var$$parcel$export($35c5af1670f53210$var$$eb30d0fbb9378b9a$exports, "AlignLeftTool", function() {
    return $35c5af1670f53210$var$$eb30d0fbb9378b9a$export$42a444ebfdcfe7b9;
}), $35c5af1670f53210$var$$parcel$export($35c5af1670f53210$var$$eb30d0fbb9378b9a$exports, "AlignCenterTool", function() {
    return $35c5af1670f53210$var$$eb30d0fbb9378b9a$export$9a2e6e0294a984eb;
}), $35c5af1670f53210$var$$parcel$export($35c5af1670f53210$var$$eb30d0fbb9378b9a$exports, "AlignRightTool", function() {
    return $35c5af1670f53210$var$$eb30d0fbb9378b9a$export$22363f91860fc258;
}), $35c5af1670f53210$var$$parcel$export($35c5af1670f53210$var$$eb30d0fbb9378b9a$exports, "AlignFullTool", function() {
    return $35c5af1670f53210$var$$eb30d0fbb9378b9a$export$42827b1362fed748;
}), $35c5af1670f53210$var$$parcel$export($35c5af1670f53210$var$$eb30d0fbb9378b9a$exports, "OrderedListTool", function() {
    return $35c5af1670f53210$var$$eb30d0fbb9378b9a$export$faf4e70f09f43a15;
}), $35c5af1670f53210$var$$parcel$export($35c5af1670f53210$var$$eb30d0fbb9378b9a$exports, "UnorderedListTool", function() {
    return $35c5af1670f53210$var$$eb30d0fbb9378b9a$export$cf4030b57a3fbe37;
}), $35c5af1670f53210$var$$parcel$export($35c5af1670f53210$var$$eb30d0fbb9378b9a$exports, "HorizontalRuleTool", function() {
    return $35c5af1670f53210$var$$eb30d0fbb9378b9a$export$dce8a7d6279fc201;
});
var $35c5af1670f53210$var$$eb30d0fbb9378b9a$export$42a444ebfdcfe7b9 = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $2b3af368dbb30b38$export$71511d61b312f219)(this, r), e = (0, $95518c9e748840bb$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "text-left"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $35c5af1670f53210$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), e;
    }
    return (0, $92f5157d74f7ea45$export$71511d61b312f219)(r, e), r;
}($3606afe94d964185$export$42a444ebfdcfe7b9), $35c5af1670f53210$var$$eb30d0fbb9378b9a$export$9a2e6e0294a984eb = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $2b3af368dbb30b38$export$71511d61b312f219)(this, r), e = (0, $95518c9e748840bb$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "text-center"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $35c5af1670f53210$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), e;
    }
    return (0, $92f5157d74f7ea45$export$71511d61b312f219)(r, e), r;
}($3606afe94d964185$export$9a2e6e0294a984eb), $35c5af1670f53210$var$$eb30d0fbb9378b9a$export$22363f91860fc258 = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $2b3af368dbb30b38$export$71511d61b312f219)(this, r), e = (0, $95518c9e748840bb$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "text-right"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $35c5af1670f53210$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), e;
    }
    return (0, $92f5157d74f7ea45$export$71511d61b312f219)(r, e), r;
}($3606afe94d964185$export$22363f91860fc258), $35c5af1670f53210$var$$eb30d0fbb9378b9a$export$42827b1362fed748 = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $2b3af368dbb30b38$export$71511d61b312f219)(this, r), e = (0, $95518c9e748840bb$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "justify"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $35c5af1670f53210$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), e;
    }
    return (0, $92f5157d74f7ea45$export$71511d61b312f219)(r, e), r;
}($3606afe94d964185$export$42827b1362fed748), $35c5af1670f53210$var$$eb30d0fbb9378b9a$export$faf4e70f09f43a15 = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $2b3af368dbb30b38$export$71511d61b312f219)(this, r), e = (0, $95518c9e748840bb$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "list-ol"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $35c5af1670f53210$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), e;
    }
    return (0, $92f5157d74f7ea45$export$71511d61b312f219)(r, e), r;
}($3606afe94d964185$export$faf4e70f09f43a15), $35c5af1670f53210$var$$eb30d0fbb9378b9a$export$cf4030b57a3fbe37 = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $2b3af368dbb30b38$export$71511d61b312f219)(this, r), e = (0, $95518c9e748840bb$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "list-ul"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $35c5af1670f53210$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), e;
    }
    return (0, $92f5157d74f7ea45$export$71511d61b312f219)(r, e), r;
}($3606afe94d964185$export$cf4030b57a3fbe37), $35c5af1670f53210$var$$eb30d0fbb9378b9a$export$dce8a7d6279fc201 = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $2b3af368dbb30b38$export$71511d61b312f219)(this, r), e = (0, $95518c9e748840bb$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "reception-0"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $35c5af1670f53210$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), e;
    }
    return (0, $92f5157d74f7ea45$export$71511d61b312f219)(r, e), r;
}($3606afe94d964185$export$dce8a7d6279fc201), $35c5af1670f53210$var$$345f51138f435756$exports = {};
$35c5af1670f53210$var$$parcel$export($35c5af1670f53210$var$$345f51138f435756$exports, "IFrameTool", function() {
    return $35c5af1670f53210$var$$345f51138f435756$export$3e557574863db086;
}), $35c5af1670f53210$var$$parcel$export($35c5af1670f53210$var$$345f51138f435756$exports, "ImageTool", function() {
    return $35c5af1670f53210$var$$345f51138f435756$export$982f47444a2f88da;
}), $35c5af1670f53210$var$$parcel$export($35c5af1670f53210$var$$345f51138f435756$exports, "AudioTool", function() {
    return $35c5af1670f53210$var$$345f51138f435756$export$6024938f37e646f8;
}), $35c5af1670f53210$var$$parcel$export($35c5af1670f53210$var$$345f51138f435756$exports, "VideoTool", function() {
    return $35c5af1670f53210$var$$345f51138f435756$export$932111b8028f79ed;
});
var $35c5af1670f53210$var$$345f51138f435756$export$3e557574863db086 = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $2b3af368dbb30b38$export$71511d61b312f219)(this, r), e = (0, $95518c9e748840bb$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "window"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $35c5af1670f53210$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), e;
    }
    return (0, $92f5157d74f7ea45$export$71511d61b312f219)(r, e), r;
}($3606afe94d964185$export$3e557574863db086), $35c5af1670f53210$var$$345f51138f435756$export$982f47444a2f88da = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $2b3af368dbb30b38$export$71511d61b312f219)(this, r), e = (0, $95518c9e748840bb$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "image"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $35c5af1670f53210$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), e;
    }
    return (0, $92f5157d74f7ea45$export$71511d61b312f219)(r, e), r;
}($3606afe94d964185$export$982f47444a2f88da), $35c5af1670f53210$var$$345f51138f435756$export$6024938f37e646f8 = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $2b3af368dbb30b38$export$71511d61b312f219)(this, r), e = (0, $95518c9e748840bb$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "voicemail"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $35c5af1670f53210$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), e;
    }
    return (0, $92f5157d74f7ea45$export$71511d61b312f219)(r, e), r;
}($3606afe94d964185$export$6024938f37e646f8), $35c5af1670f53210$var$$345f51138f435756$export$932111b8028f79ed = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $2b3af368dbb30b38$export$71511d61b312f219)(this, r), e = (0, $95518c9e748840bb$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "camera-video"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $35c5af1670f53210$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), e;
    }
    return (0, $92f5157d74f7ea45$export$71511d61b312f219)(r, e), r;
}($3606afe94d964185$export$932111b8028f79ed), $35c5af1670f53210$var$$15eac7d4db191f2f$exports = {};
$35c5af1670f53210$var$$parcel$export($35c5af1670f53210$var$$15eac7d4db191f2f$exports, "UndoTool", function() {
    return $35c5af1670f53210$var$$15eac7d4db191f2f$export$65235875731ff287;
}), $35c5af1670f53210$var$$parcel$export($35c5af1670f53210$var$$15eac7d4db191f2f$exports, "RedoTool", function() {
    return $35c5af1670f53210$var$$15eac7d4db191f2f$export$b60f30d254d1e1a6;
}), $35c5af1670f53210$var$$parcel$export($35c5af1670f53210$var$$15eac7d4db191f2f$exports, "ResetTool", function() {
    return $35c5af1670f53210$var$$15eac7d4db191f2f$export$6f46dc3d81fbb4bd;
}), $35c5af1670f53210$var$$parcel$export($35c5af1670f53210$var$$15eac7d4db191f2f$exports, "ClearTool", function() {
    return $35c5af1670f53210$var$$15eac7d4db191f2f$export$25eb377ce1feaada;
});
var $35c5af1670f53210$var$$15eac7d4db191f2f$export$65235875731ff287 = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $2b3af368dbb30b38$export$71511d61b312f219)(this, r), e = (0, $95518c9e748840bb$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "arrow-counterclockwise"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $35c5af1670f53210$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), e;
    }
    return (0, $92f5157d74f7ea45$export$71511d61b312f219)(r, e), r;
}($3606afe94d964185$export$65235875731ff287), $35c5af1670f53210$var$$15eac7d4db191f2f$export$b60f30d254d1e1a6 = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $2b3af368dbb30b38$export$71511d61b312f219)(this, r), e = (0, $95518c9e748840bb$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "arrow-clockwise"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $35c5af1670f53210$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), e;
    }
    return (0, $92f5157d74f7ea45$export$71511d61b312f219)(r, e), r;
}($3606afe94d964185$export$b60f30d254d1e1a6), $35c5af1670f53210$var$$15eac7d4db191f2f$export$6f46dc3d81fbb4bd = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $2b3af368dbb30b38$export$71511d61b312f219)(this, r), e = (0, $95518c9e748840bb$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "eraser"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $35c5af1670f53210$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), e;
    }
    return (0, $92f5157d74f7ea45$export$71511d61b312f219)(r, e), r;
}($3606afe94d964185$export$6f46dc3d81fbb4bd), $35c5af1670f53210$var$$15eac7d4db191f2f$export$25eb377ce1feaada = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $2b3af368dbb30b38$export$71511d61b312f219)(this, r), e = (0, $95518c9e748840bb$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "file-earmark-x"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $35c5af1670f53210$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), e;
    }
    return (0, $92f5157d74f7ea45$export$71511d61b312f219)(r, e), r;
}($3606afe94d964185$export$25eb377ce1feaada), $35c5af1670f53210$var$$b9bef41109a8f18c$exports = {};
$35c5af1670f53210$var$$parcel$export($35c5af1670f53210$var$$b9bef41109a8f18c$exports, "CopyMarkdownTool", function() {
    return $35c5af1670f53210$var$$b9bef41109a8f18c$export$4b13df0a6effdd72;
});
var $35c5af1670f53210$var$$b9bef41109a8f18c$export$4b13df0a6effdd72 = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $2b3af368dbb30b38$export$71511d61b312f219)(this, r), e = (0, $95518c9e748840bb$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "markdown"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $35c5af1670f53210$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), e;
    }
    return (0, $92f5157d74f7ea45$export$71511d61b312f219)(r, e), r;
}($3606afe94d964185$export$4b13df0a6effdd72), $35c5af1670f53210$var$$a01145bb2edfc771$export$e252ba763eff5cdc = [
    $35c5af1670f53210$var$$fe2cab60e3c7ea35$export$10056a49e3b218eb,
    $35c5af1670f53210$var$$fe2cab60e3c7ea35$export$edf99d0f51bacb1e,
    $35c5af1670f53210$var$$fe2cab60e3c7ea35$export$4b6d9c17188960d2,
    $35c5af1670f53210$var$$fe2cab60e3c7ea35$export$a35bffaeae8fdda0,
    $35c5af1670f53210$var$$fe2cab60e3c7ea35$export$30e8c6b428f8749f,
    $35c5af1670f53210$var$$fe2cab60e3c7ea35$export$58443375efa91029,
    $35c5af1670f53210$var$$fe2cab60e3c7ea35$export$75d24d6b8b747307,
    $35c5af1670f53210$var$$fe2cab60e3c7ea35$export$a20806c6ef6938f8,
    $35c5af1670f53210$var$$fe2cab60e3c7ea35$export$744da7e24e4a7382,
    $35c5af1670f53210$var$$fe2cab60e3c7ea35$export$6137518b4e998008,
    $35c5af1670f53210$var$$fe2cab60e3c7ea35$export$7217f06c61ebd4fc,
    $35c5af1670f53210$var$$fe2cab60e3c7ea35$export$f6c54364b5332e66
], $35c5af1670f53210$var$$a01145bb2edfc771$export$bdef6e97a10dbad4 = [
    $35c5af1670f53210$var$$b1f503bd59fa3427$export$cab0e15cfb8489d7,
    $35c5af1670f53210$var$$b1f503bd59fa3427$export$92bb6183e7459be2
], $35c5af1670f53210$var$$a01145bb2edfc771$export$145c1b37c0810d7 = [
    $35c5af1670f53210$var$$eb30d0fbb9378b9a$export$42a444ebfdcfe7b9,
    $35c5af1670f53210$var$$eb30d0fbb9378b9a$export$9a2e6e0294a984eb,
    $35c5af1670f53210$var$$eb30d0fbb9378b9a$export$22363f91860fc258,
    $35c5af1670f53210$var$$eb30d0fbb9378b9a$export$42827b1362fed748,
    $35c5af1670f53210$var$$eb30d0fbb9378b9a$export$faf4e70f09f43a15,
    $35c5af1670f53210$var$$eb30d0fbb9378b9a$export$cf4030b57a3fbe37,
    $35c5af1670f53210$var$$eb30d0fbb9378b9a$export$dce8a7d6279fc201
], $35c5af1670f53210$var$$a01145bb2edfc771$export$999636c6e25075fb = [
    $35c5af1670f53210$var$$345f51138f435756$export$3e557574863db086,
    $35c5af1670f53210$var$$345f51138f435756$export$982f47444a2f88da,
    $35c5af1670f53210$var$$345f51138f435756$export$6024938f37e646f8,
    $35c5af1670f53210$var$$345f51138f435756$export$932111b8028f79ed
], $35c5af1670f53210$var$$a01145bb2edfc771$export$f35db4b82786c3a4 = [
    $35c5af1670f53210$var$$15eac7d4db191f2f$export$65235875731ff287,
    $35c5af1670f53210$var$$15eac7d4db191f2f$export$b60f30d254d1e1a6,
    $35c5af1670f53210$var$$15eac7d4db191f2f$export$6f46dc3d81fbb4bd,
    $35c5af1670f53210$var$$15eac7d4db191f2f$export$25eb377ce1feaada
], $35c5af1670f53210$var$$a01145bb2edfc771$export$b8ecf7d74432d529 = [
    $35c5af1670f53210$var$$b9bef41109a8f18c$export$4b13df0a6effdd72
], $35c5af1670f53210$var$$a01145bb2edfc771$export$9ddb256264948609 = (0, $ca91dac30bd8a8fe$export$71511d61b312f219)($35c5af1670f53210$var$$a01145bb2edfc771$export$e252ba763eff5cdc).concat((0, $ca91dac30bd8a8fe$export$71511d61b312f219)($35c5af1670f53210$var$$a01145bb2edfc771$export$bdef6e97a10dbad4), (0, $ca91dac30bd8a8fe$export$71511d61b312f219)($35c5af1670f53210$var$$a01145bb2edfc771$export$145c1b37c0810d7), (0, $ca91dac30bd8a8fe$export$71511d61b312f219)($35c5af1670f53210$var$$a01145bb2edfc771$export$999636c6e25075fb), (0, $ca91dac30bd8a8fe$export$71511d61b312f219)($35c5af1670f53210$var$$a01145bb2edfc771$export$f35db4b82786c3a4)), $35c5af1670f53210$var$$a01145bb2edfc771$export$aa718db1466ce312 = [
    $35c5af1670f53210$var$$fe2cab60e3c7ea35$export$10056a49e3b218eb,
    $35c5af1670f53210$var$$fe2cab60e3c7ea35$export$edf99d0f51bacb1e,
    $35c5af1670f53210$var$$fe2cab60e3c7ea35$export$4b6d9c17188960d2,
    $35c5af1670f53210$var$$fe2cab60e3c7ea35$export$a35bffaeae8fdda0,
    $35c5af1670f53210$var$$fe2cab60e3c7ea35$export$30e8c6b428f8749f,
    $35c5af1670f53210$var$$fe2cab60e3c7ea35$export$58443375efa91029,
    $35c5af1670f53210$var$$fe2cab60e3c7ea35$export$75d24d6b8b747307,
    $35c5af1670f53210$var$$fe2cab60e3c7ea35$export$6137518b4e998008,
    $35c5af1670f53210$var$$fe2cab60e3c7ea35$export$7217f06c61ebd4fc,
    $35c5af1670f53210$var$$b1f503bd59fa3427$export$cab0e15cfb8489d7,
    $35c5af1670f53210$var$$b1f503bd59fa3427$export$92bb6183e7459be2,
    $35c5af1670f53210$var$$eb30d0fbb9378b9a$export$42a444ebfdcfe7b9,
    $35c5af1670f53210$var$$eb30d0fbb9378b9a$export$9a2e6e0294a984eb,
    $35c5af1670f53210$var$$eb30d0fbb9378b9a$export$22363f91860fc258,
    $35c5af1670f53210$var$$eb30d0fbb9378b9a$export$42827b1362fed748,
    $35c5af1670f53210$var$$eb30d0fbb9378b9a$export$faf4e70f09f43a15,
    $35c5af1670f53210$var$$eb30d0fbb9378b9a$export$cf4030b57a3fbe37,
    $35c5af1670f53210$var$$eb30d0fbb9378b9a$export$dce8a7d6279fc201,
    $35c5af1670f53210$var$$345f51138f435756$export$982f47444a2f88da,
    $35c5af1670f53210$var$$15eac7d4db191f2f$export$65235875731ff287,
    $35c5af1670f53210$var$$15eac7d4db191f2f$export$b60f30d254d1e1a6,
    $35c5af1670f53210$var$$15eac7d4db191f2f$export$25eb377ce1feaada
];
$35c5af1670f53210$var$$parcel$exportWildcard($35c5af1670f53210$var$$a01145bb2edfc771$exports, $35c5af1670f53210$var$$fe2cab60e3c7ea35$exports), $35c5af1670f53210$var$$parcel$exportWildcard($35c5af1670f53210$var$$a01145bb2edfc771$exports, $35c5af1670f53210$var$$b1f503bd59fa3427$exports), $35c5af1670f53210$var$$parcel$exportWildcard($35c5af1670f53210$var$$a01145bb2edfc771$exports, $35c5af1670f53210$var$$eb30d0fbb9378b9a$exports), $35c5af1670f53210$var$$parcel$exportWildcard($35c5af1670f53210$var$$a01145bb2edfc771$exports, $35c5af1670f53210$var$$345f51138f435756$exports), $35c5af1670f53210$var$$parcel$exportWildcard($35c5af1670f53210$var$$a01145bb2edfc771$exports, $35c5af1670f53210$var$$15eac7d4db191f2f$exports), $35c5af1670f53210$var$$parcel$exportWildcard($35c5af1670f53210$var$$a01145bb2edfc771$exports, $35c5af1670f53210$var$$b9bef41109a8f18c$exports);
var $35c5af1670f53210$var$$68aab1d0e8e5016c$exports = {};
$35c5af1670f53210$var$$parcel$export($35c5af1670f53210$var$$68aab1d0e8e5016c$exports, "Editor", function() {
    return $35c5af1670f53210$var$$68aab1d0e8e5016c$export$7cda8d932e2f33c0;
});
var $35c5af1670f53210$var$$68aab1d0e8e5016c$var$__runInitializers = function(e, r, c) {
    for(var t = arguments.length > 2, a = 0; a < r.length; a++)c = t ? r[a].call(e, c) : r[a].call(e);
    return t ? c : void 0;
}, $35c5af1670f53210$var$$68aab1d0e8e5016c$var$__esDecorate = function(e, r, c, t, a, $) {
    function o(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var s, n = t.kind, l = "getter" === n ? "get" : "setter" === n ? "set" : "value", i = !r && e ? t.static ? e : e.prototype : null, u = r || (i ? Object.getOwnPropertyDescriptor(i, t.name) : {}), b = !1, p = c.length - 1; p >= 0; p--){
        var f = {};
        for(var d in t)f[d] = "access" === d ? {} : t[d];
        for(var d in t.access)f.access[d] = t.access[d];
        f.addInitializer = function(e) {
            if (b) throw TypeError("Cannot add initializers after decoration has completed");
            $.push(o(e || null));
        };
        var _ = (0, c[p])("accessor" === n ? {
            get: u.get,
            set: u.set
        } : u[l], f);
        if ("accessor" === n) {
            if (void 0 === _) continue;
            if (null === _ || (void 0 === _ ? "undefined" : (0, $35f6c23f56aaf458$export$71511d61b312f219)(_)) !== "object") throw TypeError("Object expected");
            (s = o(_.get)) && (u.get = s), (s = o(_.set)) && (u.set = s), (s = o(_.init)) && a.unshift(s);
        } else (s = o(_)) && ("field" === n ? a.unshift(s) : u[l] = s);
    }
    i && Object.defineProperty(i, t.name, u), b = !0;
}, $35c5af1670f53210$var$$68aab1d0e8e5016c$var$__setFunctionName = function(e, r, c) {
    return (void 0 === r ? "undefined" : (0, $35f6c23f56aaf458$export$71511d61b312f219)(r)) === "symbol" && (r = r.description ? "[".concat(r.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: c ? "".concat(c, " ", r) : r
    });
}, $35c5af1670f53210$var$$68aab1d0e8e5016c$var$__classPrivateFieldGet = function(e, r, c, t) {
    if ("a" === c && !t) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof r ? e !== r || !t : !r.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === c ? t : "a" === c ? t.call(e) : t ? t.value : r.get(e);
}, $35c5af1670f53210$var$$68aab1d0e8e5016c$var$__classPrivateFieldSet = function(e, r, c, t, a) {
    if ("m" === t) throw TypeError("Private method is not writable");
    if ("a" === t && !a) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof r ? e !== r || !a : !r.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === t ? a.call(e, c) : a ? a.value = c : r.set(e, c), c;
}, $35c5af1670f53210$var$$68aab1d0e8e5016c$export$7cda8d932e2f33c0 = function() {
    var e, r, c, t, a, $, o, s, n, l, i = [
        $4d3432ed03d68615$export$b6ae1bc530f4c149,
        $3606afe94d964185$export$b5d042d2b680aed6
    ], u = [], b = $dc0c0b6e58c23485$exports.FormComponent, p = [], f = [], d = [];
    return a = function(e) {
        "use strict";
        function r() {
            var e;
            return (0, $2b3af368dbb30b38$export$71511d61b312f219)(this, r), e = (0, $95518c9e748840bb$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "box", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($35c5af1670f53210$var$$68aab1d0e8e5016c$var$__runInitializers(e, p), (0, $hO8yS.createRef)())
            }), c.set(e, $35c5af1670f53210$var$$68aab1d0e8e5016c$var$__runInitializers(e, f, "")), Object.defineProperty(e, "updateTools", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($35c5af1670f53210$var$$68aab1d0e8e5016c$var$__runInitializers(e, d), function() {
                    if (e.box.current === document.activeElement) {
                        var r, c = (getSelection().getRangeAt(0) || {}).endContainer, t = (null == (r = c instanceof Element ? c : c.parentElement) ? void 0 : r.getBoundingClientRect()) || {};
                        e.cursorPoint = [
                            t.x,
                            t.y
                        ] + "";
                    }
                })
            }), Object.defineProperty(e, "updateValue", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function(r) {
                    return e.innerValue = r.trim();
                }
            }), e;
        }
        return (0, $92f5157d74f7ea45$export$71511d61b312f219)(r, e), (0, $53cdca766716469e$export$71511d61b312f219)(r, [
            {
                key: "cursorPoint",
                get: function() {
                    return $35c5af1670f53210$var$$68aab1d0e8e5016c$var$__classPrivateFieldGet(this, c, "f");
                },
                set: function(e) {
                    $35c5af1670f53210$var$$68aab1d0e8e5016c$var$__classPrivateFieldSet(this, c, e, "f");
                }
            },
            {
                key: "toolList",
                get: function() {
                    return (this.observedProps.tools || $35c5af1670f53210$var$$a01145bb2edfc771$export$aa718db1466ce312).map(function(e) {
                        return new e;
                    });
                }
            },
            {
                key: "imageTool",
                get: function() {
                    return this.toolList.find(function(e) {
                        return e instanceof $3606afe94d964185$export$982f47444a2f88da;
                    });
                }
            },
            {
                key: "audioTool",
                get: function() {
                    return this.toolList.find(function(e) {
                        return e instanceof $35c5af1670f53210$var$$345f51138f435756$export$6024938f37e646f8;
                    });
                }
            },
            {
                key: "videoTool",
                get: function() {
                    return this.toolList.find(function(e) {
                        return e instanceof $35c5af1670f53210$var$$345f51138f435756$export$932111b8028f79ed;
                    });
                }
            },
            {
                key: "componentDidMount",
                value: function() {
                    (0, $0b0867a6ee357054$export$71511d61b312f219)((0, $9ac8e64cff09d58e$export$71511d61b312f219)(r.prototype), "componentDidMount", this).call(this);
                    var e = this.props.defaultValue;
                    null != e && (this.box.current.innerHTML = e), document.addEventListener("selectionchange", this.updateTools);
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    (0, $0b0867a6ee357054$export$71511d61b312f219)((0, $9ac8e64cff09d58e$export$71511d61b312f219)(r.prototype), "componentWillUnmount", this).call(this), document.removeEventListener("selectionchange", this.updateTools);
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this;
                    this.cursorPoint;
                    var r = this.toolList, c = this.innerValue, t = this.props.name;
                    return (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($hO8yS.Fragment, {
                        children: [
                            (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("header", {
                                children: r.map(function(r) {
                                    return r.render(e.box);
                                })
                            }),
                            (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("div", {
                                ref: this.box,
                                className: "form-control h-auto",
                                contentEditable: !0,
                                onInput: function(r) {
                                    var c = r.currentTarget.innerHTML;
                                    return e.updateValue(c);
                                },
                                onPaste: this.handlePasteDrop,
                                onDrop: this.handlePasteDrop
                            }),
                            (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("input", {
                                type: "hidden",
                                name: t,
                                value: c
                            })
                        ]
                    });
                }
            }
        ]), r;
    }(b), c = new WeakMap, $35c5af1670f53210$var$$68aab1d0e8e5016c$var$__setFunctionName(a, "Editor"), r = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = b[Symbol.metadata]) ? e : null) : void 0, $ = [
        $d5I5D.observable
    ], o = [
        $d5I5D.computed
    ], s = [
        $d5I5D.computed
    ], n = [
        $d5I5D.computed
    ], l = [
        $d5I5D.computed
    ], $35c5af1670f53210$var$$68aab1d0e8e5016c$var$__esDecorate(a, null, $, {
        kind: "accessor",
        name: "cursorPoint",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "cursorPoint" in e;
            },
            get: function(e) {
                return e.cursorPoint;
            },
            set: function(e, r) {
                e.cursorPoint = r;
            }
        },
        metadata: r
    }, f, d), $35c5af1670f53210$var$$68aab1d0e8e5016c$var$__esDecorate(a, null, o, {
        kind: "getter",
        name: "toolList",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "toolList" in e;
            },
            get: function(e) {
                return e.toolList;
            }
        },
        metadata: r
    }, null, p), $35c5af1670f53210$var$$68aab1d0e8e5016c$var$__esDecorate(a, null, s, {
        kind: "getter",
        name: "imageTool",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "imageTool" in e;
            },
            get: function(e) {
                return e.imageTool;
            }
        },
        metadata: r
    }, null, p), $35c5af1670f53210$var$$68aab1d0e8e5016c$var$__esDecorate(a, null, n, {
        kind: "getter",
        name: "audioTool",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "audioTool" in e;
            },
            get: function(e) {
                return e.audioTool;
            }
        },
        metadata: r
    }, null, p), $35c5af1670f53210$var$$68aab1d0e8e5016c$var$__esDecorate(a, null, l, {
        kind: "getter",
        name: "videoTool",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "videoTool" in e;
            },
            get: function(e) {
                return e.videoTool;
            }
        },
        metadata: r
    }, null, p), $35c5af1670f53210$var$$68aab1d0e8e5016c$var$__esDecorate(null, t = {
        value: a
    }, i, {
        kind: "class",
        name: a.name,
        metadata: r
    }, null, u), a = t.value, r && Object.defineProperty(a, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }), Object.defineProperty(a, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "Editor"
    }), $35c5af1670f53210$var$$68aab1d0e8e5016c$var$__runInitializers(a, u), a;
}();
$35c5af1670f53210$var$$parcel$exportWildcard($35c5af1670f53210$exports, $35c5af1670f53210$var$$73a8882fd67c0324$exports), $35c5af1670f53210$var$$parcel$exportWildcard($35c5af1670f53210$exports, $35c5af1670f53210$var$$a01145bb2edfc771$exports), $35c5af1670f53210$var$$parcel$exportWildcard($35c5af1670f53210$exports, $35c5af1670f53210$var$$68aab1d0e8e5016c$exports);



var $aMH3h = parcelRequire("aMH3h");
var $44015290ab5c0623$export$71511d61b312f219;
"use strict";

var $fbe5a6a7891777c2$export$71511d61b312f219;
"use strict";
function $fbe5a6a7891777c2$var$_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
$fbe5a6a7891777c2$export$71511d61b312f219 = $fbe5a6a7891777c2$var$_iterable_to_array_limit;




function $44015290ab5c0623$var$_sliced_to_array(arr, i) {
    return $d99f4a016ac4e7a1$export$71511d61b312f219(arr) || $fbe5a6a7891777c2$export$71511d61b312f219(arr, i) || $ee22f18d51655989$export$71511d61b312f219(arr, i) || $fcf9c8c2e7d5c043$export$71511d61b312f219();
}
$44015290ab5c0623$export$71511d61b312f219 = $44015290ab5c0623$var$_sliced_to_array;


function $ac22e9ddbc30c291$var$$parcel$exportWildcard(e, t) {
    return Object.keys(t).forEach(function(r) {
        "default" === r || "__esModule" === r || Object.prototype.hasOwnProperty.call(e, r) || Object.defineProperty(e, r, {
            enumerable: !0,
            get: function() {
                return t[r];
            }
        });
    }), e;
}
function $ac22e9ddbc30c291$var$$parcel$export(e, t, r, a) {
    Object.defineProperty(e, t, {
        get: r,
        set: a,
        enumerable: !0,
        configurable: !0
    });
}
function $ac22e9ddbc30c291$var$$parcel$interopDefault(e) {
    return e && e.__esModule ? e.default : e;
}
var $ac22e9ddbc30c291$var$$f600741b98acd6fe$exports = {};
$ac22e9ddbc30c291$var$$parcel$export($ac22e9ddbc30c291$var$$f600741b98acd6fe$exports, "VariantColors", function() {
    return $ac22e9ddbc30c291$var$$f600741b98acd6fe$export$50b010be9260e56b;
}), $ac22e9ddbc30c291$var$$parcel$export($ac22e9ddbc30c291$var$$f600741b98acd6fe$exports, "text2color", function() {
    return $ac22e9ddbc30c291$var$$f600741b98acd6fe$export$b480d00b75c9ac2d;
}), $ac22e9ddbc30c291$var$$parcel$export($ac22e9ddbc30c291$var$$f600741b98acd6fe$exports, "BadgeBar", function() {
    return $ac22e9ddbc30c291$var$$f600741b98acd6fe$export$ef1c4106ceccca63;
});
var $ac22e9ddbc30c291$var$$f600741b98acd6fe$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var n = 0, a = Object.getOwnPropertySymbols(e); n < a.length; n++)0 > t.indexOf(a[n]) && Object.prototype.propertyIsEnumerable.call(e, a[n]) && (r[a[n]] = e[a[n]]);
    return r;
}, $ac22e9ddbc30c291$var$$f600741b98acd6fe$export$50b010be9260e56b = [
    "primary",
    "secondary",
    "success",
    "danger",
    "warning",
    "info"
], $ac22e9ddbc30c291$var$$f600741b98acd6fe$export$b480d00b75c9ac2d = function(e) {
    return $ac22e9ddbc30c291$var$$f600741b98acd6fe$export$50b010be9260e56b[$fbe6f1e2fed97fc7$export$8a63f25cc62965f1.apply(void 0, (0, $ca91dac30bd8a8fe$export$71511d61b312f219)(Array.from(e, function(e) {
        return e.charCodeAt(0);
    }))) % $ac22e9ddbc30c291$var$$f600741b98acd6fe$export$50b010be9260e56b.length];
}, $ac22e9ddbc30c291$var$$f600741b98acd6fe$export$ef1c4106ceccca63 = function(e) {
    var t = e.className, r = e.list, a = e.bgResolver, n = void 0 === a ? $ac22e9ddbc30c291$var$$f600741b98acd6fe$export$b480d00b75c9ac2d : a, c = e.onCheck, s = e.onDelete, i = $ac22e9ddbc30c291$var$$f600741b98acd6fe$var$__rest(e, [
        "className",
        "list",
        "bgResolver",
        "onCheck",
        "onDelete"
    ]);
    return (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("ul", Object.assign({
        className: "list-unstyled m-0 d-flex flex-wrap gap-2 ".concat(void 0 === t ? "" : t)
    }, i, {
        children: r.map(function(e, t) {
            var r = e.text, a = e.link;
            return (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($611ebbb42c2db614$export$2e2bcd8739ae039, {
                bg: n(r),
                text: "white",
                as: "li",
                className: "d-flex align-items-center gap-2",
                children: [
                    a || URL.canParse(r) ? (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("a", {
                        className: "text-decoration-none text-white",
                        href: a || r,
                        children: r
                    }) : c ? (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("span", {
                        onClick: function() {
                            return c({
                                text: r,
                                link: a
                            }, t);
                        },
                        children: r
                    }) : r,
                    s && (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($25f7395c3ada3645$export$2e2bcd8739ae039, {
                        onClick: function() {
                            return s({
                                text: r,
                                link: a
                            }, t);
                        }
                    })
                ]
            }, r);
        })
    }));
};
$ac22e9ddbc30c291$var$$f600741b98acd6fe$export$ef1c4106ceccca63.displayName = "BadgeBar";
var $ac22e9ddbc30c291$var$$faee9857e4bdfa8b$exports = {};
$ac22e9ddbc30c291$var$$parcel$export($ac22e9ddbc30c291$var$$faee9857e4bdfa8b$exports, "ImagePreview", function() {
    return $ac22e9ddbc30c291$var$$faee9857e4bdfa8b$export$4a96334d5925dbf2;
});
var $ac22e9ddbc30c291$var$$faee9857e4bdfa8b$var$__runInitializers = function(e, t, r) {
    for(var a = arguments.length > 2, n = 0; n < t.length; n++)r = a ? t[n].call(e, r) : t[n].call(e);
    return a ? r : void 0;
}, $ac22e9ddbc30c291$var$$faee9857e4bdfa8b$var$__esDecorate = function(e, t, r, a, n, c) {
    function s(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var i, o = a.kind, l = "getter" === o ? "get" : "setter" === o ? "set" : "value", u = !t && e ? a.static ? e : e.prototype : null, p = t || (u ? Object.getOwnPropertyDescriptor(u, a.name) : {}), $ = !1, f = r.length - 1; f >= 0; f--){
        var d = {};
        for(var b in a)d[b] = "access" === b ? {} : a[b];
        for(var b in a.access)d.access[b] = a.access[b];
        d.addInitializer = function(e) {
            if ($) throw TypeError("Cannot add initializers after decoration has completed");
            c.push(s(e || null));
        };
        var m = (0, r[f])("accessor" === o ? {
            get: p.get,
            set: p.set
        } : p[l], d);
        if ("accessor" === o) {
            if (void 0 === m) continue;
            if (null === m || (void 0 === m ? "undefined" : (0, $35f6c23f56aaf458$export$71511d61b312f219)(m)) !== "object") throw TypeError("Object expected");
            (i = s(m.get)) && (p.get = i), (i = s(m.set)) && (p.set = i), (i = s(m.init)) && n.unshift(i);
        } else (i = s(m)) && ("field" === o ? n.unshift(i) : p[l] = i);
    }
    u && Object.defineProperty(u, a.name, p), $ = !0;
}, $ac22e9ddbc30c291$var$$faee9857e4bdfa8b$var$__awaiter = function(e, t, r, a) {
    return new (r || (r = Promise))(function(n, c) {
        function s(e) {
            try {
                o(a.next(e));
            } catch (e) {
                c(e);
            }
        }
        function i(e) {
            try {
                o(a.throw(e));
            } catch (e) {
                c(e);
            }
        }
        function o(e) {
            var t;
            e.done ? n(e.value) : ((t = e.value) instanceof r ? t : new r(function(e) {
                e(t);
            })).then(s, i);
        }
        o((a = a.apply(e, t || [])).next());
    });
}, $ac22e9ddbc30c291$var$$faee9857e4bdfa8b$var$__setFunctionName = function(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $35f6c23f56aaf458$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $ac22e9ddbc30c291$var$$faee9857e4bdfa8b$var$__classPrivateFieldGet = function(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $ac22e9ddbc30c291$var$$faee9857e4bdfa8b$var$__classPrivateFieldSet = function(e, t, r, a, n) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !n) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !n : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? n.call(e, r) : n ? n.value = r : t.set(e, r), r;
}, $ac22e9ddbc30c291$var$$faee9857e4bdfa8b$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var n = 0, a = Object.getOwnPropertySymbols(e); n < a.length; n++)0 > t.indexOf(a[n]) && Object.prototype.propertyIsEnumerable.call(e, a[n]) && (r[a[n]] = e[a[n]]);
    return r;
}, $ac22e9ddbc30c291$var$$faee9857e4bdfa8b$export$4a96334d5925dbf2 = function() {
    var e, t, r, a, n, c, s, i, o, l, u, p = [
        $4d3432ed03d68615$export$b6ae1bc530f4c149
    ], $ = [], f = $1cea8647883c4012$exports.ObservedComponent, d = [], b = [], m = [], v = [], h = [], _ = [], j = [];
    return s = function(e) {
        "use strict";
        function t() {
            var e;
            return (0, $2b3af368dbb30b38$export$71511d61b312f219)(this, t), e = (0, $95518c9e748840bb$export$71511d61b312f219)(this, t, arguments), r.set(e, ($ac22e9ddbc30c291$var$$faee9857e4bdfa8b$var$__runInitializers(e, d), $ac22e9ddbc30c291$var$$faee9857e4bdfa8b$var$__runInitializers(e, b, !1))), a.set(e, ($ac22e9ddbc30c291$var$$faee9857e4bdfa8b$var$__runInitializers(e, m), $ac22e9ddbc30c291$var$$faee9857e4bdfa8b$var$__runInitializers(e, v, ""))), n.set(e, ($ac22e9ddbc30c291$var$$faee9857e4bdfa8b$var$__runInitializers(e, h), $ac22e9ddbc30c291$var$$faee9857e4bdfa8b$var$__runInitializers(e, _, !1))), $ac22e9ddbc30c291$var$$faee9857e4bdfa8b$var$__runInitializers(e, j), e;
        }
        return (0, $92f5157d74f7ea45$export$71511d61b312f219)(t, e), (0, $53cdca766716469e$export$71511d61b312f219)(t, [
            {
                key: "downloading",
                get: function() {
                    return $ac22e9ddbc30c291$var$$faee9857e4bdfa8b$var$__classPrivateFieldGet(this, r, "f");
                },
                set: function(e) {
                    $ac22e9ddbc30c291$var$$faee9857e4bdfa8b$var$__classPrivateFieldSet(this, r, e, "f");
                }
            },
            {
                key: "loadedPath",
                get: function() {
                    return $ac22e9ddbc30c291$var$$faee9857e4bdfa8b$var$__classPrivateFieldGet(this, a, "f");
                },
                set: function(e) {
                    $ac22e9ddbc30c291$var$$faee9857e4bdfa8b$var$__classPrivateFieldSet(this, a, e, "f");
                }
            },
            {
                key: "viewing",
                get: function() {
                    return $ac22e9ddbc30c291$var$$faee9857e4bdfa8b$var$__classPrivateFieldGet(this, n, "f");
                },
                set: function(e) {
                    $ac22e9ddbc30c291$var$$faee9857e4bdfa8b$var$__classPrivateFieldSet(this, n, e, "f");
                }
            },
            {
                key: "componentDidMount",
                value: function() {
                    var e = this.observedProps.src;
                    this.loadedPath = "", e && this.load(e);
                }
            },
            {
                key: "load",
                value: function(e) {
                    return $ac22e9ddbc30c291$var$$faee9857e4bdfa8b$var$__awaiter(this, void 0, void 0, function() {
                        return (0, $8fdeac7b23d8f90e$export$71511d61b312f219)(this, function(t) {
                            switch(t.label){
                                case 0:
                                    return this.downloading = !0, [
                                        4,
                                        new Promise(function(t, r) {
                                            var a = new globalThis.Image;
                                            a.onload = t, a.onerror = r, a.src = e;
                                        })
                                    ];
                                case 1:
                                    return t.sent(), this.loadedPath = e, this.downloading = !1, [
                                        2
                                    ];
                            }
                        });
                    });
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this, t = this.downloading, r = this.loadedPath, a = this.viewing, n = this.props, c = n.className, s = n.loading, i = (n.src, n.fluid), o = n.rounded, l = n.roundedCircle, u = n.thumbnail, p = $ac22e9ddbc30c291$var$$faee9857e4bdfa8b$var$__rest(n, [
                        "className",
                        "loading",
                        "src",
                        "fluid",
                        "rounded",
                        "roundedCircle",
                        "thumbnail"
                    ]);
                    return (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("div", Object.assign({
                        className: $ac22e9ddbc30c291$var$$parcel$interopDefault($852a55cf17d8b19d$exports)("m-0", t && "d-flex justify-content-center align-items-center", c)
                    }, p, {
                        children: [
                            t ? (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($999d941606fa59dc$export$2e2bcd8739ae039, {}) : r && (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($da05e9bb3075bec1$export$2e2bcd8739ae039, {
                                className: "object-fit-contain",
                                loading: s,
                                fluid: i,
                                rounded: o,
                                roundedCircle: l,
                                thumbnail: u,
                                src: r,
                                onClick: function() {
                                    return e.viewing = !0;
                                }
                            }),
                            (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($8cc4069d2715af29$export$2e2bcd8739ae039, {
                                centered: !0,
                                show: a,
                                onHide: function() {
                                    return e.viewing = !1;
                                },
                                children: [
                                    (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($8cc4069d2715af29$export$2e2bcd8739ae039.Body, {
                                        className: "text-center",
                                        children: (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($da05e9bb3075bec1$export$2e2bcd8739ae039, {
                                            fluid: !0,
                                            src: r
                                        })
                                    }),
                                    (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($8cc4069d2715af29$export$2e2bcd8739ae039.Footer, {
                                        className: "justify-content-center",
                                        as: "a",
                                        href: r,
                                        target: "_blank",
                                        download: r.split("/").pop(),
                                        children: r
                                    })
                                ]
                            })
                        ]
                    }));
                }
            }
        ]), t;
    }(f), r = new WeakMap, a = new WeakMap, n = new WeakMap, $ac22e9ddbc30c291$var$$faee9857e4bdfa8b$var$__setFunctionName(s, "ImagePreview"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = f[Symbol.metadata]) ? e : null) : void 0, i = [
        $d5I5D.observable
    ], o = [
        $d5I5D.observable
    ], l = [
        $d5I5D.observable
    ], u = [
        (0, $1cea8647883c4012$exports.reaction)(function(e) {
            return e.observedProps.src;
        })
    ], $ac22e9ddbc30c291$var$$faee9857e4bdfa8b$var$__esDecorate(s, null, i, {
        kind: "accessor",
        name: "downloading",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "downloading" in e;
            },
            get: function(e) {
                return e.downloading;
            },
            set: function(e, t) {
                e.downloading = t;
            }
        },
        metadata: t
    }, b, m), $ac22e9ddbc30c291$var$$faee9857e4bdfa8b$var$__esDecorate(s, null, o, {
        kind: "accessor",
        name: "loadedPath",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "loadedPath" in e;
            },
            get: function(e) {
                return e.loadedPath;
            },
            set: function(e, t) {
                e.loadedPath = t;
            }
        },
        metadata: t
    }, v, h), $ac22e9ddbc30c291$var$$faee9857e4bdfa8b$var$__esDecorate(s, null, l, {
        kind: "accessor",
        name: "viewing",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "viewing" in e;
            },
            get: function(e) {
                return e.viewing;
            },
            set: function(e, t) {
                e.viewing = t;
            }
        },
        metadata: t
    }, _, j), $ac22e9ddbc30c291$var$$faee9857e4bdfa8b$var$__esDecorate(s, null, u, {
        kind: "method",
        name: "componentDidMount",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "componentDidMount" in e;
            },
            get: function(e) {
                return e.componentDidMount;
            }
        },
        metadata: t
    }, null, d), $ac22e9ddbc30c291$var$$faee9857e4bdfa8b$var$__esDecorate(null, c = {
        value: s
    }, p, {
        kind: "class",
        name: s.name,
        metadata: t
    }, null, $), s = c.value, t && Object.defineProperty(s, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(s, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "ImagePreview"
    }), $ac22e9ddbc30c291$var$$faee9857e4bdfa8b$var$__runInitializers(s, $), s;
}(), $ac22e9ddbc30c291$var$$8663609ea235ec39$exports = {};
$ac22e9ddbc30c291$var$$parcel$export($ac22e9ddbc30c291$var$$8663609ea235ec39$exports, "FileTypeMap", function() {
    return $ac22e9ddbc30c291$var$$8663609ea235ec39$export$413fb8502ce63cf9;
}), $ac22e9ddbc30c291$var$$parcel$export($ac22e9ddbc30c291$var$$8663609ea235ec39$exports, "FilePreview", function() {
    return $ac22e9ddbc30c291$var$$8663609ea235ec39$export$a127194569a41afb;
});
var $ac22e9ddbc30c291$var$$8663609ea235ec39$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var n = 0, a = Object.getOwnPropertySymbols(e); n < a.length; n++)0 > t.indexOf(a[n]) && Object.prototype.propertyIsEnumerable.call(e, a[n]) && (r[a[n]] = e[a[n]]);
    return r;
}, $ac22e9ddbc30c291$var$$8663609ea235ec39$export$413fb8502ce63cf9 = {
    stream: "binary",
    compressed: "zip",
    msword: "doc",
    document: "docx",
    powerpoint: "ppt",
    presentation: "pptx",
    excel: "xls",
    sheet: "xlsx"
}, $ac22e9ddbc30c291$var$$8663609ea235ec39$export$a127194569a41afb = function(e) {
    var t = e.className, r = e.style, a = e.hidden, n = e.type, c = e.path, s = $ac22e9ddbc30c291$var$$8663609ea235ec39$var$__rest(e, [
        "className",
        "style",
        "hidden",
        "type",
        "path"
    ]), i = (0, $8a4b9e1682f367e1$export$71511d61b312f219)((null == n ? void 0 : n.split(/\W+/)) || []), o = i[0], l = i.slice(1), u = decodeURI(new URL(c, "http://localhost").pathname.split("/").at(-1)), p = $ac22e9ddbc30c291$var$$8663609ea235ec39$export$413fb8502ce63cf9[l.at(-1)] || ((null == u ? void 0 : u.includes(".")) ? u.split(".").at(-1) : l.at(-1));
    return (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("figure", {
        className: "d-flex flex-column align-items-center justify-content-center m-0 ".concat(void 0 === t ? "" : t),
        style: r,
        hidden: a,
        children: "image" === o ? (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($ac22e9ddbc30c291$var$$faee9857e4bdfa8b$export$4a96334d5925dbf2, Object.assign({
            className: "h-100",
            fluid: !0,
            loading: "lazy",
            src: c
        }, s)) : "audio" === o ? (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("audio", Object.assign({
            controls: !0,
            src: c
        }, s)) : "video" === o ? (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("video", Object.assign({
            muted: !0,
            src: c,
            onMouseEnter: function(e) {
                return e.currentTarget.play();
            },
            onMouseLeave: function(e) {
                return e.currentTarget.pause();
            }
        }, s)) : (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($hO8yS.Fragment, {
            children: [
                (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("a", Object.assign({
                    className: "d-inline-flex justify-content-center align-items-center",
                    href: c,
                    target: "_blank",
                    download: u
                }, s, {
                    children: (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("i", {
                        className: "bi bi-filetype-".concat(p || "file-earmark", " fs-1")
                    })
                })),
                (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("figcaption", {
                    className: "mw-100 text-truncate",
                    children: u
                })
            ]
        })
    });
};
$ac22e9ddbc30c291$var$$8663609ea235ec39$export$a127194569a41afb.displayName = "FilePreview";
var $ac22e9ddbc30c291$var$$f2af1554fbcf9c96$exports = {};
$ac22e9ddbc30c291$var$$parcel$export($ac22e9ddbc30c291$var$$f2af1554fbcf9c96$exports, "FilePicker", function() {
    return $ac22e9ddbc30c291$var$$f2af1554fbcf9c96$export$54dc470bcc5c41d1;
});
var $ac22e9ddbc30c291$var$$f2af1554fbcf9c96$var$__runInitializers = function(e, t, r) {
    for(var a = arguments.length > 2, n = 0; n < t.length; n++)r = a ? t[n].call(e, r) : t[n].call(e);
    return a ? r : void 0;
}, $ac22e9ddbc30c291$var$$f2af1554fbcf9c96$var$__esDecorate = function(e, t, r, a, n, c) {
    function s(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var i, o = a.kind, l = "getter" === o ? "get" : "setter" === o ? "set" : "value", u = !t && e ? a.static ? e : e.prototype : null, p = t || (u ? Object.getOwnPropertyDescriptor(u, a.name) : {}), $ = !1, f = r.length - 1; f >= 0; f--){
        var d = {};
        for(var b in a)d[b] = "access" === b ? {} : a[b];
        for(var b in a.access)d.access[b] = a.access[b];
        d.addInitializer = function(e) {
            if ($) throw TypeError("Cannot add initializers after decoration has completed");
            c.push(s(e || null));
        };
        var m = (0, r[f])("accessor" === o ? {
            get: p.get,
            set: p.set
        } : p[l], d);
        if ("accessor" === o) {
            if (void 0 === m) continue;
            if (null === m || (void 0 === m ? "undefined" : (0, $35f6c23f56aaf458$export$71511d61b312f219)(m)) !== "object") throw TypeError("Object expected");
            (i = s(m.get)) && (p.get = i), (i = s(m.set)) && (p.set = i), (i = s(m.init)) && n.unshift(i);
        } else (i = s(m)) && ("field" === o ? n.unshift(i) : p[l] = i);
    }
    u && Object.defineProperty(u, a.name, p), $ = !0;
}, $ac22e9ddbc30c291$var$$f2af1554fbcf9c96$var$__awaiter = function(e, t, r, a) {
    return new (r || (r = Promise))(function(n, c) {
        function s(e) {
            try {
                o(a.next(e));
            } catch (e) {
                c(e);
            }
        }
        function i(e) {
            try {
                o(a.throw(e));
            } catch (e) {
                c(e);
            }
        }
        function o(e) {
            var t;
            e.done ? n(e.value) : ((t = e.value) instanceof r ? t : new r(function(e) {
                e(t);
            })).then(s, i);
        }
        o((a = a.apply(e, t || [])).next());
    });
}, $ac22e9ddbc30c291$var$$f2af1554fbcf9c96$var$__setFunctionName = function(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $35f6c23f56aaf458$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $ac22e9ddbc30c291$var$$f2af1554fbcf9c96$var$__classPrivateFieldGet = function(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $ac22e9ddbc30c291$var$$f2af1554fbcf9c96$var$__classPrivateFieldSet = function(e, t, r, a, n) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !n) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !n : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? n.call(e, r) : n ? n.value = r : t.set(e, r), r;
}, $ac22e9ddbc30c291$var$$f2af1554fbcf9c96$var$blobCache = new WeakMap, $ac22e9ddbc30c291$var$$f2af1554fbcf9c96$export$54dc470bcc5c41d1 = function() {
    var e, t, r, a, n, c, s, i, o, l, u = [
        $4d3432ed03d68615$export$b6ae1bc530f4c149
    ], p = [], $ = $1cea8647883c4012$exports.FormComponent, f = [], d = [], b = [];
    return c = function(e) {
        "use strict";
        function t() {
            var e;
            return (0, $2b3af368dbb30b38$export$71511d61b312f219)(this, t), e = (0, $95518c9e748840bb$export$71511d61b312f219)(this, t, arguments), a.set(e, ($ac22e9ddbc30c291$var$$f2af1554fbcf9c96$var$__runInitializers(e, f), $ac22e9ddbc30c291$var$$f2af1554fbcf9c96$var$__runInitializers(e, d, void 0))), r.set(e, ($ac22e9ddbc30c291$var$$f2af1554fbcf9c96$var$__runInitializers(e, b), function(t) {
                if (e.file = t, t) e.innerValue = t, $ac22e9ddbc30c291$var$$f2af1554fbcf9c96$var$blobCache.set(t, URL.createObjectURL(t));
                else if (e.value) {
                    var r = e.innerValue;
                    "string" == typeof r && r.startsWith("blob:") ? URL.revokeObjectURL(r) : r instanceof File && $ac22e9ddbc30c291$var$$f2af1554fbcf9c96$var$blobCache.delete(r), e.innerValue = "";
                }
            })), e;
        }
        return (0, $92f5157d74f7ea45$export$71511d61b312f219)(t, e), (0, $53cdca766716469e$export$71511d61b312f219)(t, [
            {
                key: "file",
                get: function() {
                    return $ac22e9ddbc30c291$var$$f2af1554fbcf9c96$var$__classPrivateFieldGet(this, a, "f");
                },
                set: function(e) {
                    $ac22e9ddbc30c291$var$$f2af1554fbcf9c96$var$__classPrivateFieldSet(this, a, e, "f");
                }
            },
            {
                key: "fileType",
                get: function() {
                    var e, t = this.observedProps.accept, r = this.file;
                    return (null == r ? void 0 : r.type) || (null == (e = null == r ? void 0 : r.name.match(/\.\w+$/)) ? void 0 : e[0]) || t;
                }
            },
            {
                key: "filePath",
                get: function() {
                    var e = this.value;
                    return "string" == typeof e ? e : $ac22e9ddbc30c291$var$$f2af1554fbcf9c96$var$blobCache.get(e);
                }
            },
            {
                key: "restoreFile",
                value: function(e) {
                    return $ac22e9ddbc30c291$var$$f2af1554fbcf9c96$var$__awaiter(this, void 0, void 0, function() {
                        var t, r;
                        return (0, $8fdeac7b23d8f90e$export$71511d61b312f219)(this, function(a) {
                            switch(a.label){
                                case 0:
                                    if ("string" != typeof e) return [
                                        3,
                                        4
                                    ];
                                    a.label = 1;
                                case 1:
                                    return a.trys.push([
                                        1,
                                        3,
                                        ,
                                        4
                                    ]), [
                                        4,
                                        (0, $fbe6f1e2fed97fc7$export$fd89523fba250fa4)(e)
                                    ];
                                case 2:
                                    return r = new File([
                                        t = a.sent()
                                    ], e.split("/").at(-1), {
                                        type: t.type
                                    }), $ac22e9ddbc30c291$var$$f2af1554fbcf9c96$var$blobCache.set(r, e), [
                                        2,
                                        this.file = r
                                    ];
                                case 3:
                                    return a.sent(), [
                                        3,
                                        4
                                    ];
                                case 4:
                                    if (e instanceof File) return $ac22e9ddbc30c291$var$$f2af1554fbcf9c96$var$blobCache.has(e) || $ac22e9ddbc30c291$var$$f2af1554fbcf9c96$var$blobCache.set(e, URL.createObjectURL(e)), [
                                        2,
                                        this.file = e
                                    ];
                                    return [
                                        2,
                                        this.file = void 0
                                    ];
                            }
                        });
                    });
                }
            },
            {
                key: "componentDidMount",
                value: function() {
                    (0, $0b0867a6ee357054$export$71511d61b312f219)((0, $9ac8e64cff09d58e$export$71511d61b312f219)(t.prototype), "componentDidMount", this).call(this), this.restoreFile(this.value);
                }
            },
            {
                key: "renderInput",
                value: function() {
                    var e = this, t = this.props, a = t.id, n = t.name, c = t.value, s = t.required, i = t.disabled, o = t.accept, l = t.multiple, u = this.filePath;
                    return (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($hO8yS.Fragment, {
                        children: [
                            (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("input", {
                                ref: this.ref,
                                className: "position-absolute start-0 top-0 w-100 h-100 opacity-0",
                                type: "file",
                                name: c ? void 0 : n,
                                required: !c && s,
                                id: a,
                                disabled: i,
                                accept: o,
                                multiple: l,
                                onChange: function(t) {
                                    var a = t.currentTarget.files;
                                    return $ac22e9ddbc30c291$var$$f2af1554fbcf9c96$var$__classPrivateFieldGet(e, r, "f").call(e, null == a ? void 0 : a[0]);
                                }
                            }),
                            u && (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("input", {
                                type: "hidden",
                                name: n,
                                value: u
                            })
                        ]
                    });
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this, t = this.filePath, a = this.fileType, n = this.props, c = n.className, s = n.style;
                    return (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("div", {
                        className: "d-inline-block border rounded position-relative ".concat(void 0 === c ? "" : c),
                        style: Object.assign({
                            width: "10rem",
                            height: "10rem"
                        }, s),
                        children: [
                            t ? (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($ac22e9ddbc30c291$var$$8663609ea235ec39$export$a127194569a41afb, {
                                className: "w-100 h-100",
                                type: a,
                                path: t
                            }) : (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("div", {
                                className: "w-100 h-100 d-flex justify-content-center align-items-center display-1",
                                children: "+"
                            }),
                            this.renderInput(),
                            t && (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($25f7395c3ada3645$export$2e2bcd8739ae039, {
                                className: "position-absolute top-0 end-0",
                                style: {
                                    width: "0.5rem",
                                    height: "0.5rem"
                                },
                                onClick: function() {
                                    return $ac22e9ddbc30c291$var$$f2af1554fbcf9c96$var$__classPrivateFieldGet(e, r, "f").call(e);
                                }
                            })
                        ]
                    });
                }
            }
        ]), t;
    }($), r = new WeakMap, a = new WeakMap, $ac22e9ddbc30c291$var$$f2af1554fbcf9c96$var$__setFunctionName(c, "FilePicker"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = $[Symbol.metadata]) ? e : null) : void 0, s = [
        $d5I5D.observable
    ], i = [
        $d5I5D.computed
    ], o = [
        $d5I5D.computed
    ], l = [
        (0, $1cea8647883c4012$exports.reaction)(function(e) {
            return e.value;
        })
    ], $ac22e9ddbc30c291$var$$f2af1554fbcf9c96$var$__esDecorate(c, null, s, {
        kind: "accessor",
        name: "file",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "file" in e;
            },
            get: function(e) {
                return e.file;
            },
            set: function(e, t) {
                e.file = t;
            }
        },
        metadata: t
    }, d, b), $ac22e9ddbc30c291$var$$f2af1554fbcf9c96$var$__esDecorate(c, null, i, {
        kind: "getter",
        name: "fileType",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "fileType" in e;
            },
            get: function(e) {
                return e.fileType;
            }
        },
        metadata: t
    }, null, f), $ac22e9ddbc30c291$var$$f2af1554fbcf9c96$var$__esDecorate(c, null, o, {
        kind: "getter",
        name: "filePath",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "filePath" in e;
            },
            get: function(e) {
                return e.filePath;
            }
        },
        metadata: t
    }, null, f), $ac22e9ddbc30c291$var$$f2af1554fbcf9c96$var$__esDecorate(c, null, l, {
        kind: "method",
        name: "restoreFile",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "restoreFile" in e;
            },
            get: function(e) {
                return e.restoreFile;
            }
        },
        metadata: t
    }, null, f), $ac22e9ddbc30c291$var$$f2af1554fbcf9c96$var$__esDecorate(null, n = {
        value: c
    }, u, {
        kind: "class",
        name: c.name,
        metadata: t
    }, null, p), c = n.value, t && Object.defineProperty(c, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(c, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "FilePicker"
    }), $ac22e9ddbc30c291$var$$f2af1554fbcf9c96$var$__runInitializers(c, p), c;
}(), $ac22e9ddbc30c291$var$$a21a50f24f1cbd28$exports = {};
$ac22e9ddbc30c291$var$$parcel$export($ac22e9ddbc30c291$var$$a21a50f24f1cbd28$exports, "FileModel", function() {
    return $ac22e9ddbc30c291$var$$a21a50f24f1cbd28$export$424c8de2e117ab22;
}), $ac22e9ddbc30c291$var$$parcel$export($ac22e9ddbc30c291$var$$a21a50f24f1cbd28$exports, "FileUploader", function() {
    return $ac22e9ddbc30c291$var$$a21a50f24f1cbd28$export$1a5cb5295a7d2749;
});
var $ac22e9ddbc30c291$var$$a21a50f24f1cbd28$var$__esDecorate = function(e, t, r, a, n, c) {
    function s(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var i, o = a.kind, l = "getter" === o ? "get" : "setter" === o ? "set" : "value", u = !t && e ? a.static ? e : e.prototype : null, p = t || (u ? Object.getOwnPropertyDescriptor(u, a.name) : {}), $ = !1, f = r.length - 1; f >= 0; f--){
        var d = {};
        for(var b in a)d[b] = "access" === b ? {} : a[b];
        for(var b in a.access)d.access[b] = a.access[b];
        d.addInitializer = function(e) {
            if ($) throw TypeError("Cannot add initializers after decoration has completed");
            c.push(s(e || null));
        };
        var m = (0, r[f])("accessor" === o ? {
            get: p.get,
            set: p.set
        } : p[l], d);
        if ("accessor" === o) {
            if (void 0 === m) continue;
            if (null === m || (void 0 === m ? "undefined" : (0, $35f6c23f56aaf458$export$71511d61b312f219)(m)) !== "object") throw TypeError("Object expected");
            (i = s(m.get)) && (p.get = i), (i = s(m.set)) && (p.set = i), (i = s(m.init)) && n.unshift(i);
        } else (i = s(m)) && ("field" === o ? n.unshift(i) : p[l] = i);
    }
    u && Object.defineProperty(u, a.name, p), $ = !0;
}, $ac22e9ddbc30c291$var$$a21a50f24f1cbd28$var$__runInitializers = function(e, t, r) {
    for(var a = arguments.length > 2, n = 0; n < t.length; n++)r = a ? t[n].call(e, r) : t[n].call(e);
    return a ? r : void 0;
}, $ac22e9ddbc30c291$var$$a21a50f24f1cbd28$var$__awaiter = function(e, t, r, a) {
    return new (r || (r = Promise))(function(n, c) {
        function s(e) {
            try {
                o(a.next(e));
            } catch (e) {
                c(e);
            }
        }
        function i(e) {
            try {
                o(a.throw(e));
            } catch (e) {
                c(e);
            }
        }
        function o(e) {
            var t;
            e.done ? n(e.value) : ((t = e.value) instanceof r ? t : new r(function(e) {
                e(t);
            })).then(s, i);
        }
        o((a = a.apply(e, t || [])).next());
    });
}, $ac22e9ddbc30c291$var$$a21a50f24f1cbd28$var$__classPrivateFieldGet = function(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $ac22e9ddbc30c291$var$$a21a50f24f1cbd28$var$__classPrivateFieldSet = function(e, t, r, a, n) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !n) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !n : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? n.call(e, r) : n ? n.value = r : t.set(e, r), r;
}, $ac22e9ddbc30c291$var$$a21a50f24f1cbd28$var$__setFunctionName = function(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $35f6c23f56aaf458$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $ac22e9ddbc30c291$var$$a21a50f24f1cbd28$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var n = 0, a = Object.getOwnPropertySymbols(e); n < a.length; n++)0 > t.indexOf(a[n]) && Object.prototype.propertyIsEnumerable.call(e, a[n]) && (r[a[n]] = e[a[n]]);
    return r;
}, $ac22e9ddbc30c291$var$$a21a50f24f1cbd28$export$424c8de2e117ab22 = function() {
    var e, t, r, a, n = $29590480c608918b$export$d12e20a4eec10acf, c = [], s = [];
    return r = function(e) {
        "use strict";
        function t() {
            var e;
            return (0, $2b3af368dbb30b38$export$71511d61b312f219)(this, t), e = (0, $95518c9e748840bb$export$71511d61b312f219)(this, t, arguments), a.set(e, $ac22e9ddbc30c291$var$$a21a50f24f1cbd28$var$__runInitializers(e, c, [])), $ac22e9ddbc30c291$var$$a21a50f24f1cbd28$var$__runInitializers(e, s), e;
        }
        return (0, $92f5157d74f7ea45$export$71511d61b312f219)(t, e), (0, $53cdca766716469e$export$71511d61b312f219)(t, [
            {
                key: "files",
                get: function() {
                    return $ac22e9ddbc30c291$var$$a21a50f24f1cbd28$var$__classPrivateFieldGet(this, a, "f");
                },
                set: function(e) {
                    $ac22e9ddbc30c291$var$$a21a50f24f1cbd28$var$__classPrivateFieldSet(this, a, e, "f");
                }
            },
            {
                key: "clear",
                value: function() {
                    (0, $0b0867a6ee357054$export$71511d61b312f219)((0, $9ac8e64cff09d58e$export$71511d61b312f219)(t.prototype), "clear", this).call(this), this.files = [];
                }
            },
            {
                key: "upload",
                value: function(e) {
                    return $ac22e9ddbc30c291$var$$a21a50f24f1cbd28$var$__awaiter(this, void 0, void 0, function() {
                        var t;
                        return (0, $8fdeac7b23d8f90e$export$71511d61b312f219)(this, function(r) {
                            return e instanceof Blob && (e = URL.createObjectURL(e)), (t = this.files).includes(e) || (this.files = (0, $ca91dac30bd8a8fe$export$71511d61b312f219)(t).concat([
                                e
                            ])), [
                                2,
                                e
                            ];
                        });
                    });
                }
            },
            {
                key: "delete",
                value: function(e) {
                    return $ac22e9ddbc30c291$var$$a21a50f24f1cbd28$var$__awaiter(this, void 0, void 0, function() {
                        var t, r;
                        return (0, $8fdeac7b23d8f90e$export$71511d61b312f219)(this, function(a) {
                            return r = (t = this.files).indexOf(e), this.files = (0, $ca91dac30bd8a8fe$export$71511d61b312f219)(t.slice(0, r)).concat((0, $ca91dac30bd8a8fe$export$71511d61b312f219)(t.slice(r + 1))), [
                                2
                            ];
                        });
                    });
                }
            },
            {
                key: "move",
                value: function(e, t) {
                    var r = this.files, a = r[e], n = r[t], c = Math.min(e, t), s = Math.max(e, t), i = r.slice(0, c), o = r.slice(c + 1, s), l = r.slice(s + 1);
                    this.files = e < t ? (0, $ca91dac30bd8a8fe$export$71511d61b312f219)(i).concat((0, $ca91dac30bd8a8fe$export$71511d61b312f219)(o), [
                        n,
                        a
                    ], (0, $ca91dac30bd8a8fe$export$71511d61b312f219)(l)) : (0, $ca91dac30bd8a8fe$export$71511d61b312f219)(i).concat([
                        a,
                        n
                    ], (0, $ca91dac30bd8a8fe$export$71511d61b312f219)(o), (0, $ca91dac30bd8a8fe$export$71511d61b312f219)(l));
                }
            }
        ]), t;
    }(n), a = new WeakMap, t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = n[Symbol.metadata]) ? e : null) : void 0, $ac22e9ddbc30c291$var$$a21a50f24f1cbd28$var$__esDecorate(r, null, [
        $d5I5D.observable
    ], {
        kind: "accessor",
        name: "files",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "files" in e;
            },
            get: function(e) {
                return e.files;
            },
            set: function(e, t) {
                e.files = t;
            }
        },
        metadata: t
    }, c, s), t && Object.defineProperty(r, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), r;
}(), $ac22e9ddbc30c291$var$$a21a50f24f1cbd28$export$1a5cb5295a7d2749 = function() {
    var e, t, r, a, n, c, s, i = [
        $4d3432ed03d68615$export$b6ae1bc530f4c149
    ], o = [], l = $1cea8647883c4012$exports.FormComponent, u = [], p = [], $ = [];
    return n = function(e) {
        "use strict";
        function t() {
            var e;
            return (0, $2b3af368dbb30b38$export$71511d61b312f219)(this, t), e = (0, $95518c9e748840bb$export$71511d61b312f219)(this, t, arguments), r.set(e, ($ac22e9ddbc30c291$var$$a21a50f24f1cbd28$var$__runInitializers(e, u), $ac22e9ddbc30c291$var$$a21a50f24f1cbd28$var$__runInitializers(e, p, void 0))), Object.defineProperty(e, "handleDrop", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($ac22e9ddbc30c291$var$$a21a50f24f1cbd28$var$__runInitializers(e, $), function(t) {
                    return function(r) {
                        r.preventDefault();
                        var a = e.props, n = e.pickIndex;
                        null != n && (a.store.move(n, t), e.innerValue = a.store.files);
                    };
                })
            }), Object.defineProperty(e, "handleChange", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function() {
                    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
                    return function(r) {
                        return $ac22e9ddbc30c291$var$$a21a50f24f1cbd28$var$__awaiter(e, void 0, void 0, function() {
                            var e;
                            return (0, $8fdeac7b23d8f90e$export$71511d61b312f219)(this, function(a) {
                                switch(a.label){
                                    case 0:
                                        if (e = this.props.store, !t) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            e.delete(t)
                                        ];
                                    case 1:
                                        a.sent(), a.label = 2;
                                    case 2:
                                        if (!r) return [
                                            3,
                                            4
                                        ];
                                        return [
                                            4,
                                            e.upload(r)
                                        ];
                                    case 3:
                                        a.sent(), a.label = 4;
                                    case 4:
                                        return this.innerValue = e.files, [
                                            2
                                        ];
                                }
                            });
                        });
                    };
                }
            }), e;
        }
        return (0, $92f5157d74f7ea45$export$71511d61b312f219)(t, e), (0, $53cdca766716469e$export$71511d61b312f219)(t, [
            {
                key: "pickIndex",
                get: function() {
                    return $ac22e9ddbc30c291$var$$a21a50f24f1cbd28$var$__classPrivateFieldGet(this, r, "f");
                },
                set: function(e) {
                    $ac22e9ddbc30c291$var$$a21a50f24f1cbd28$var$__classPrivateFieldSet(this, r, e, "f");
                }
            },
            {
                key: "componentDidMount",
                value: function() {
                    (0, $0b0867a6ee357054$export$71511d61b312f219)((0, $9ac8e64cff09d58e$export$71511d61b312f219)(t.prototype), "componentDidMount", this).call(this), this.props.store.files = this.value || [];
                }
            },
            {
                key: "restoreFile",
                value: function(e) {
                    this.props.store.files = e;
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this, t = this.props, r = t.className, a = t.style, n = t.multiple, c = (t.store, t.value, t.defaultValue, t.onChange, $ac22e9ddbc30c291$var$$a21a50f24f1cbd28$var$__rest(t, [
                        "className",
                        "style",
                        "multiple",
                        "store",
                        "value",
                        "defaultValue",
                        "onChange"
                    ])), s = this.value;
                    return (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("ol", {
                        className: "list-inline d-flex ".concat(void 0 === r ? "m-0" : r),
                        style: a,
                        onDragOver: function(e) {
                            return e.preventDefault();
                        },
                        children: [
                            null == s ? void 0 : s.map(function(t, r) {
                                return (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("li", {
                                    className: "list-inline-item",
                                    draggable: !0,
                                    onDragStart: function() {
                                        return e.pickIndex = r;
                                    },
                                    onDrop: e.handleDrop(r),
                                    children: (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($ac22e9ddbc30c291$var$$f2af1554fbcf9c96$export$54dc470bcc5c41d1, Object.assign({}, c, {
                                        value: t,
                                        onChange: e.handleChange(t)
                                    }))
                                }, t);
                            }),
                            (n || !(null == s ? void 0 : s[0])) && (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("li", {
                                className: "list-inline-item",
                                children: (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($ac22e9ddbc30c291$var$$f2af1554fbcf9c96$export$54dc470bcc5c41d1, Object.assign({}, c, {
                                    name: void 0,
                                    value: "",
                                    required: !(null == s ? void 0 : s[0]) && c.required,
                                    onChange: this.handleChange()
                                }))
                            })
                        ]
                    });
                }
            }
        ]), t;
    }(l), r = new WeakMap, $ac22e9ddbc30c291$var$$a21a50f24f1cbd28$var$__setFunctionName(n, "FileUploader"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = l[Symbol.metadata]) ? e : null) : void 0, c = [
        $d5I5D.observable
    ], s = [
        (0, $1cea8647883c4012$exports.reaction)(function(e) {
            return e.value;
        })
    ], $ac22e9ddbc30c291$var$$a21a50f24f1cbd28$var$__esDecorate(n, null, c, {
        kind: "accessor",
        name: "pickIndex",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "pickIndex" in e;
            },
            get: function(e) {
                return e.pickIndex;
            },
            set: function(e, t) {
                e.pickIndex = t;
            }
        },
        metadata: t
    }, p, $), $ac22e9ddbc30c291$var$$a21a50f24f1cbd28$var$__esDecorate(n, null, s, {
        kind: "method",
        name: "restoreFile",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "restoreFile" in e;
            },
            get: function(e) {
                return e.restoreFile;
            }
        },
        metadata: t
    }, null, u), $ac22e9ddbc30c291$var$$a21a50f24f1cbd28$var$__esDecorate(null, a = {
        value: n
    }, i, {
        kind: "class",
        name: n.name,
        metadata: t
    }, null, o), n = a.value, t && Object.defineProperty(n, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(n, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "FileUploader"
    }), $ac22e9ddbc30c291$var$$a21a50f24f1cbd28$var$__runInitializers(n, o), n;
}(), $ac22e9ddbc30c291$var$$4e6504f15de995a8$exports = {};
$ac22e9ddbc30c291$var$$parcel$export($ac22e9ddbc30c291$var$$4e6504f15de995a8$exports, "FormField", function() {
    return $ac22e9ddbc30c291$var$$4e6504f15de995a8$export$56e87bf42978147a;
});
var $ac22e9ddbc30c291$var$$4e6504f15de995a8$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var n = 0, a = Object.getOwnPropertySymbols(e); n < a.length; n++)0 > t.indexOf(a[n]) && Object.prototype.propertyIsEnumerable.call(e, a[n]) && (r[a[n]] = e[a[n]]);
    return r;
}, $ac22e9ddbc30c291$var$$4e6504f15de995a8$export$56e87bf42978147a = function(e) {
    var t = e.className, r = e.style, a = e.label, n = e.placeholder, c = e.id, s = e.name, i = e.options, o = e.multiple, l = e.rows, u = e.onBlur, p = $ac22e9ddbc30c291$var$$4e6504f15de995a8$var$__rest(e, [
        "className",
        "style",
        "label",
        "placeholder",
        "id",
        "name",
        "options",
        "multiple",
        "rows",
        "onBlur"
    ]);
    return (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($a213c3bf0143d254$export$2e2bcd8739ae039.FloatingLabel, {
        className: t,
        style: r,
        label: a,
        controlId: s || c,
        onBlur: function(e) {
            e.target.checkValidity() ? (e.target.classList.remove("is-invalid"), e.currentTarget.classList.remove("is-invalid")) : (e.target.classList.add("is-invalid"), e.currentTarget.classList.add("is-invalid")), null == u || u(e);
        },
        children: i ? (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($a213c3bf0143d254$export$2e2bcd8739ae039.Select, Object.assign({
            className: o ? "h-auto" : "",
            name: s,
            multiple: o,
            htmlSize: l
        }, p, {
            children: i.map(function(e) {
                var t = e.value, r = e.text, a = e.label, n = e.disabled;
                return (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("option", {
                    value: t,
                    label: a,
                    disabled: n,
                    children: r || t
                }, t);
            })
        })) : (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($a213c3bf0143d254$export$2e2bcd8739ae039.Control, Object.assign({
            className: l > 1 ? "h-auto" : "",
            name: s,
            multiple: o,
            rows: l
        }, p, {
            placeholder: n || ("string" == typeof a ? a : s || c)
        }))
    });
};
$ac22e9ddbc30c291$var$$4e6504f15de995a8$export$56e87bf42978147a.displayName = "FormField";
var $ac22e9ddbc30c291$var$$92bd5b9c2e8cd28e$exports = {};
$ac22e9ddbc30c291$var$$parcel$export($ac22e9ddbc30c291$var$$92bd5b9c2e8cd28e$exports, "RangeInput", function() {
    return $ac22e9ddbc30c291$var$$92bd5b9c2e8cd28e$export$f5603a09670563b9;
});
var $ac22e9ddbc30c291$var$$92bd5b9c2e8cd28e$var$__esDecorate = function(e, t, r, a, n, c) {
    function s(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var i, o = a.kind, l = "getter" === o ? "get" : "setter" === o ? "set" : "value", u = !t && e ? a.static ? e : e.prototype : null, p = t || (u ? Object.getOwnPropertyDescriptor(u, a.name) : {}), $ = !1, f = r.length - 1; f >= 0; f--){
        var d = {};
        for(var b in a)d[b] = "access" === b ? {} : a[b];
        for(var b in a.access)d.access[b] = a.access[b];
        d.addInitializer = function(e) {
            if ($) throw TypeError("Cannot add initializers after decoration has completed");
            c.push(s(e || null));
        };
        var m = (0, r[f])("accessor" === o ? {
            get: p.get,
            set: p.set
        } : p[l], d);
        if ("accessor" === o) {
            if (void 0 === m) continue;
            if (null === m || (void 0 === m ? "undefined" : (0, $35f6c23f56aaf458$export$71511d61b312f219)(m)) !== "object") throw TypeError("Object expected");
            (i = s(m.get)) && (p.get = i), (i = s(m.set)) && (p.set = i), (i = s(m.init)) && n.unshift(i);
        } else (i = s(m)) && ("field" === o ? n.unshift(i) : p[l] = i);
    }
    u && Object.defineProperty(u, a.name, p), $ = !0;
}, $ac22e9ddbc30c291$var$$92bd5b9c2e8cd28e$var$__runInitializers = function(e, t, r) {
    for(var a = arguments.length > 2, n = 0; n < t.length; n++)r = a ? t[n].call(e, r) : t[n].call(e);
    return a ? r : void 0;
}, $ac22e9ddbc30c291$var$$92bd5b9c2e8cd28e$var$__setFunctionName = function(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $35f6c23f56aaf458$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $ac22e9ddbc30c291$var$$92bd5b9c2e8cd28e$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var n = 0, a = Object.getOwnPropertySymbols(e); n < a.length; n++)0 > t.indexOf(a[n]) && Object.prototype.propertyIsEnumerable.call(e, a[n]) && (r[a[n]] = e[a[n]]);
    return r;
}, $ac22e9ddbc30c291$var$$92bd5b9c2e8cd28e$export$f5603a09670563b9 = function() {
    var e, t, r, a, n = [
        $4d3432ed03d68615$export$b6ae1bc530f4c149
    ], c = [], s = $1cea8647883c4012$exports.FormComponent;
    return $ac22e9ddbc30c291$var$$92bd5b9c2e8cd28e$var$__setFunctionName(a = function(e) {
        "use strict";
        function t() {
            return (0, $2b3af368dbb30b38$export$71511d61b312f219)(this, t), (0, $95518c9e748840bb$export$71511d61b312f219)(this, t, arguments);
        }
        return (0, $92f5157d74f7ea45$export$71511d61b312f219)(t, e), (0, $53cdca766716469e$export$71511d61b312f219)(t, [
            {
                key: "renderItem",
                value: function(e) {
                    var t = this.value, r = this.observedProps, a = r.icon, n = r.step, c = void 0 === n ? 1 : n, s = Math.max(Math.min((void 0 === t ? 0 : t) - c * e, +c), 0);
                    return (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("li", {
                        className: "text-center",
                        children: "function" == typeof a ? a(s) : a
                    }, e);
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this, t = this.observedProps, r = t.className, a = t.icon, n = t.min, c = t.max, s = void 0 === c ? a ? 5 : 100 : c, i = (t.onChange, $ac22e9ddbc30c291$var$$92bd5b9c2e8cd28e$var$__rest(t, [
                        "className",
                        "icon",
                        "min",
                        "max",
                        "onChange"
                    ])), o = this.value, l = void 0 === o ? n || 0 : o;
                    return (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("div", {
                        className: void 0 === r ? "d-inline-block position-relative" : r,
                        title: l + "",
                        children: [
                            (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("input", Object.assign({
                                min: n,
                                max: s,
                                value: l
                            }, i, {
                                className: a ? "opacity-0" : "",
                                style: {
                                    margin: "0 -0.5rem",
                                    cursor: "pointer"
                                },
                                type: "range",
                                onChange: function(t) {
                                    return e.innerValue = t.currentTarget.value;
                                }
                            })),
                            (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("ol", {
                                className: "list-unstyled user-select-none position-absolute start-0 top-0 w-100 h-100 pe-none d-flex justify-content-around",
                                children: Array.from({
                                    length: +s
                                }, function(t, r) {
                                    return e.renderItem(r);
                                })
                            })
                        ]
                    });
                }
            }
        ]), t;
    }(s), "RangeInput"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = s[Symbol.metadata]) ? e : null) : void 0, $ac22e9ddbc30c291$var$$92bd5b9c2e8cd28e$var$__esDecorate(null, r = {
        value: a
    }, n, {
        kind: "class",
        name: a.name,
        metadata: t
    }, null, c), a = r.value, t && Object.defineProperty(a, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(a, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "RangeInput"
    }), $ac22e9ddbc30c291$var$$92bd5b9c2e8cd28e$var$__runInitializers(a, c), a;
}(), $ac22e9ddbc30c291$var$$fa84453248a3f065$exports = {};
$ac22e9ddbc30c291$var$$parcel$export($ac22e9ddbc30c291$var$$fa84453248a3f065$exports, "TextInputTypes", function() {
    return $ac22e9ddbc30c291$var$$fa84453248a3f065$export$82cd8db40d0f609c;
}), $ac22e9ddbc30c291$var$$parcel$export($ac22e9ddbc30c291$var$$fa84453248a3f065$exports, "BadgeInput", function() {
    return $ac22e9ddbc30c291$var$$fa84453248a3f065$export$76834b0602c89bd;
});
var $ac22e9ddbc30c291$var$$fa84453248a3f065$var$__esDecorate = function(e, t, r, a, n, c) {
    function s(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var i, o = a.kind, l = "getter" === o ? "get" : "setter" === o ? "set" : "value", u = !t && e ? a.static ? e : e.prototype : null, p = t || (u ? Object.getOwnPropertyDescriptor(u, a.name) : {}), $ = !1, f = r.length - 1; f >= 0; f--){
        var d = {};
        for(var b in a)d[b] = "access" === b ? {} : a[b];
        for(var b in a.access)d.access[b] = a.access[b];
        d.addInitializer = function(e) {
            if ($) throw TypeError("Cannot add initializers after decoration has completed");
            c.push(s(e || null));
        };
        var m = (0, r[f])("accessor" === o ? {
            get: p.get,
            set: p.set
        } : p[l], d);
        if ("accessor" === o) {
            if (void 0 === m) continue;
            if (null === m || (void 0 === m ? "undefined" : (0, $35f6c23f56aaf458$export$71511d61b312f219)(m)) !== "object") throw TypeError("Object expected");
            (i = s(m.get)) && (p.get = i), (i = s(m.set)) && (p.set = i), (i = s(m.init)) && n.unshift(i);
        } else (i = s(m)) && ("field" === o ? n.unshift(i) : p[l] = i);
    }
    u && Object.defineProperty(u, a.name, p), $ = !0;
}, $ac22e9ddbc30c291$var$$fa84453248a3f065$var$__runInitializers = function(e, t, r) {
    for(var a = arguments.length > 2, n = 0; n < t.length; n++)r = a ? t[n].call(e, r) : t[n].call(e);
    return a ? r : void 0;
}, $ac22e9ddbc30c291$var$$fa84453248a3f065$var$__setFunctionName = function(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $35f6c23f56aaf458$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $ac22e9ddbc30c291$var$$fa84453248a3f065$export$82cd8db40d0f609c = [
    "text",
    "number",
    "tel",
    "email",
    "url"
], $ac22e9ddbc30c291$var$$fa84453248a3f065$export$76834b0602c89bd = function() {
    var e, t, r, a, n = [
        $4d3432ed03d68615$export$b6ae1bc530f4c149
    ], c = [], s = $1cea8647883c4012$exports.FormComponent;
    return $ac22e9ddbc30c291$var$$fa84453248a3f065$var$__setFunctionName(a = function(e) {
        "use strict";
        function t() {
            var e;
            return (0, $2b3af368dbb30b38$export$71511d61b312f219)(this, t), e = (0, $95518c9e748840bb$export$71511d61b312f219)(this, t, arguments), Object.defineProperty(e, "handleInput", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function(t) {
                    var r = t.currentTarget, a = r.value, n = e.innerValue || [];
                    switch(t.key){
                        case "Enter":
                            t.preventDefault(), r.value = "", a && (e.innerValue = (0, $ca91dac30bd8a8fe$export$71511d61b312f219)(n).concat([
                                a
                            ]));
                            break;
                        case "Backspace":
                            a || (e.innerValue = n.slice(0, -1));
                    }
                }
            }), e;
        }
        return (0, $92f5157d74f7ea45$export$71511d61b312f219)(t, e), (0, $53cdca766716469e$export$71511d61b312f219)(t, [
            {
                key: "delete",
                value: function(e) {
                    var t = this.innerValue;
                    this.innerValue = (0, $ca91dac30bd8a8fe$export$71511d61b312f219)(t.slice(0, e)).concat((0, $ca91dac30bd8a8fe$export$71511d61b312f219)(t.slice(e + 1)));
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this, t = this.value, r = this.props, a = r.className, n = r.style, c = r.type, s = r.name, i = r.required, o = r.placeholder;
                    return (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("div", {
                        className: "form-control p-2 d-flex flex-wrap gap-2 ".concat(void 0 === a ? "" : a),
                        style: n,
                        children: [
                            (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($ac22e9ddbc30c291$var$$f600741b98acd6fe$export$ef1c4106ceccca63, {
                                list: (t || []).map(function(e) {
                                    return {
                                        text: e
                                    };
                                }),
                                onDelete: function(t, r) {
                                    return (0, $176d75244f0e6d93$export$71511d61b312f219)(t), e.delete(r);
                                }
                            }),
                            (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("input", {
                                className: "border-0 flex-fill",
                                style: {
                                    outline: "none"
                                },
                                type: c,
                                required: (0, $fbe6f1e2fed97fc7$export$dd1bc94b04021eeb)(t) ? i : void 0,
                                placeholder: o,
                                onKeyDown: this.handleInput
                            }),
                            (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("input", {
                                type: "hidden",
                                name: s,
                                value: JSON.stringify(t)
                            })
                        ]
                    });
                }
            }
        ], [
            {
                key: "match",
                value: function(e) {
                    return $ac22e9ddbc30c291$var$$fa84453248a3f065$export$82cd8db40d0f609c.includes(e);
                }
            }
        ]), t;
    }(s), "BadgeInput"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = s[Symbol.metadata]) ? e : null) : void 0, $ac22e9ddbc30c291$var$$fa84453248a3f065$var$__esDecorate(null, r = {
        value: a
    }, n, {
        kind: "class",
        name: a.name,
        metadata: t
    }, null, c), a = r.value, t && Object.defineProperty(a, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(a, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "BadgeInput"
    }), $ac22e9ddbc30c291$var$$fa84453248a3f065$var$__runInitializers(a, c), a;
}(), $ac22e9ddbc30c291$var$$36ed2012ed0bbec3$exports = {};
$ac22e9ddbc30c291$var$$parcel$export($ac22e9ddbc30c291$var$$36ed2012ed0bbec3$exports, "ArrayField", function() {
    return $ac22e9ddbc30c291$var$$36ed2012ed0bbec3$export$42efeba470be9198;
});
var $ac22e9ddbc30c291$var$$36ed2012ed0bbec3$var$__esDecorate = function(e, t, r, a, n, c) {
    function s(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var i, o = a.kind, l = "getter" === o ? "get" : "setter" === o ? "set" : "value", u = !t && e ? a.static ? e : e.prototype : null, p = t || (u ? Object.getOwnPropertyDescriptor(u, a.name) : {}), $ = !1, f = r.length - 1; f >= 0; f--){
        var d = {};
        for(var b in a)d[b] = "access" === b ? {} : a[b];
        for(var b in a.access)d.access[b] = a.access[b];
        d.addInitializer = function(e) {
            if ($) throw TypeError("Cannot add initializers after decoration has completed");
            c.push(s(e || null));
        };
        var m = (0, r[f])("accessor" === o ? {
            get: p.get,
            set: p.set
        } : p[l], d);
        if ("accessor" === o) {
            if (void 0 === m) continue;
            if (null === m || (void 0 === m ? "undefined" : (0, $35f6c23f56aaf458$export$71511d61b312f219)(m)) !== "object") throw TypeError("Object expected");
            (i = s(m.get)) && (p.get = i), (i = s(m.set)) && (p.set = i), (i = s(m.init)) && n.unshift(i);
        } else (i = s(m)) && ("field" === o ? n.unshift(i) : p[l] = i);
    }
    u && Object.defineProperty(u, a.name, p), $ = !0;
}, $ac22e9ddbc30c291$var$$36ed2012ed0bbec3$var$__runInitializers = function(e, t, r) {
    for(var a = arguments.length > 2, n = 0; n < t.length; n++)r = a ? t[n].call(e, r) : t[n].call(e);
    return a ? r : void 0;
}, $ac22e9ddbc30c291$var$$36ed2012ed0bbec3$var$__setFunctionName = function(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $35f6c23f56aaf458$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $ac22e9ddbc30c291$var$$36ed2012ed0bbec3$export$42efeba470be9198 = function() {
    var e, t, r, a, n = [
        $4d3432ed03d68615$export$b6ae1bc530f4c149
    ], c = [], s = $1cea8647883c4012$exports.FormComponent;
    return $ac22e9ddbc30c291$var$$36ed2012ed0bbec3$var$__setFunctionName(a = function(e) {
        "use strict";
        function t() {
            var e;
            return (0, $2b3af368dbb30b38$export$71511d61b312f219)(this, t), e = (0, $95518c9e748840bb$export$71511d61b312f219)(this, t, arguments), Object.defineProperty(e, "add", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function() {
                    return e.innerValue = (0, $ca91dac30bd8a8fe$export$71511d61b312f219)(e.innerValue || []).concat([
                        {}
                    ]);
                }
            }), Object.defineProperty(e, "remove", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function(t) {
                    var r;
                    return e.innerValue = null == (r = e.innerValue) ? void 0 : r.filter(function(e, r) {
                        return r !== t;
                    });
                }
            }), Object.defineProperty(e, "handleChange", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function(t) {
                    return function(r) {
                        var a, n, c = r.currentTarget, s = (0, $fbe6f1e2fed97fc7$export$86d7c59254d6a2c9)(c), i = e.innerValue, o = (0, $ca91dac30bd8a8fe$export$71511d61b312f219)(i.slice(0, t)).concat([
                            s
                        ], (0, $ca91dac30bd8a8fe$export$71511d61b312f219)(i.slice(t + 1))).map(function(e) {
                            return (0, $d5I5D.toJS)(e);
                        });
                        null == (n = (a = e.props).onChange) || n.call(a, o);
                    };
                }
            }), Object.defineProperty(e, "handleUpdate", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function(t) {
                    return function(r) {
                        var a = r.currentTarget;
                        return e.innerValue[t] = (0, $fbe6f1e2fed97fc7$export$86d7c59254d6a2c9)(a);
                    };
                }
            }), e;
        }
        return (0, $92f5157d74f7ea45$export$71511d61b312f219)(t, e), (0, $53cdca766716469e$export$71511d61b312f219)(t, [
            {
                key: "componentDidMount",
                value: function() {
                    (0, $0b0867a6ee357054$export$71511d61b312f219)((0, $9ac8e64cff09d58e$export$71511d61b312f219)(t.prototype), "componentDidMount", this).call(this), (0, $fbe6f1e2fed97fc7$export$dd1bc94b04021eeb)(this.value) && this.add();
                }
            },
            {
                key: "render",
                value: function() {
                    var e, t = this, r = this.props, a = r.className, n = void 0 === a ? "" : a, c = r.style, s = r.name, i = r.renderItem;
                    return (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($hO8yS.Fragment, {
                        children: null == (e = this.value) ? void 0 : e.map(function(e, r, a) {
                            var o = a.length;
                            return (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("fieldset", {
                                className: "d-flex align-items-center my-2 gap-2 ".concat(n),
                                style: c,
                                name: s,
                                onChange: t.handleChange(r),
                                onBlur: t.handleUpdate(r),
                                children: [
                                    (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("div", {
                                        className: "flex-fill",
                                        children: i(e, r)
                                    }),
                                    (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($fd8349ff8538bb6f$export$2e2bcd8739ae039, {
                                        children: [
                                            (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($b4033c9bbfbcc946$export$2e2bcd8739ae039, {
                                                type: "button",
                                                size: "sm",
                                                variant: "warning",
                                                onClick: t.add,
                                                children: "+"
                                            }),
                                            (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($b4033c9bbfbcc946$export$2e2bcd8739ae039, {
                                                type: "button",
                                                size: "sm",
                                                variant: "danger",
                                                disabled: o < 2,
                                                onClick: function() {
                                                    return t.remove(r);
                                                },
                                                children: "-"
                                            })
                                        ]
                                    })
                                ]
                            }, JSON.stringify(e));
                        })
                    });
                }
            }
        ]), t;
    }(s), "ArrayField"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = s[Symbol.metadata]) ? e : null) : void 0, $ac22e9ddbc30c291$var$$36ed2012ed0bbec3$var$__esDecorate(null, r = {
        value: a
    }, n, {
        kind: "class",
        name: a.name,
        metadata: t
    }, null, c), a = r.value, t && Object.defineProperty(a, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(a, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "ArrayField"
    }), $ac22e9ddbc30c291$var$$36ed2012ed0bbec3$var$__runInitializers(a, c), a;
}(), $ac22e9ddbc30c291$var$$cd7ba08b282791a9$exports = {};
$ac22e9ddbc30c291$var$$parcel$export($ac22e9ddbc30c291$var$$cd7ba08b282791a9$exports, "RestForm", function() {
    return $ac22e9ddbc30c291$var$$cd7ba08b282791a9$export$341e3470805a945e;
});
var $ac22e9ddbc30c291$var$$cd7ba08b282791a9$var$__runInitializers = function(e, t, r) {
    for(var a = arguments.length > 2, n = 0; n < t.length; n++)r = a ? t[n].call(e, r) : t[n].call(e);
    return a ? r : void 0;
}, $ac22e9ddbc30c291$var$$cd7ba08b282791a9$var$__esDecorate = function(e, t, r, a, n, c) {
    function s(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var i, o = a.kind, l = "getter" === o ? "get" : "setter" === o ? "set" : "value", u = !t && e ? a.static ? e : e.prototype : null, p = t || (u ? Object.getOwnPropertyDescriptor(u, a.name) : {}), $ = !1, f = r.length - 1; f >= 0; f--){
        var d = {};
        for(var b in a)d[b] = "access" === b ? {} : a[b];
        for(var b in a.access)d.access[b] = a.access[b];
        d.addInitializer = function(e) {
            if ($) throw TypeError("Cannot add initializers after decoration has completed");
            c.push(s(e || null));
        };
        var m = (0, r[f])("accessor" === o ? {
            get: p.get,
            set: p.set
        } : p[l], d);
        if ("accessor" === o) {
            if (void 0 === m) continue;
            if (null === m || (void 0 === m ? "undefined" : (0, $35f6c23f56aaf458$export$71511d61b312f219)(m)) !== "object") throw TypeError("Object expected");
            (i = s(m.get)) && (p.get = i), (i = s(m.set)) && (p.set = i), (i = s(m.init)) && n.unshift(i);
        } else (i = s(m)) && ("field" === o ? n.unshift(i) : p[l] = i);
    }
    u && Object.defineProperty(u, a.name, p), $ = !0;
}, $ac22e9ddbc30c291$var$$cd7ba08b282791a9$var$__awaiter = function(e, t, r, a) {
    return new (r || (r = Promise))(function(n, c) {
        function s(e) {
            try {
                o(a.next(e));
            } catch (e) {
                c(e);
            }
        }
        function i(e) {
            try {
                o(a.throw(e));
            } catch (e) {
                c(e);
            }
        }
        function o(e) {
            var t;
            e.done ? n(e.value) : ((t = e.value) instanceof r ? t : new r(function(e) {
                e(t);
            })).then(s, i);
        }
        o((a = a.apply(e, t || [])).next());
    });
}, $ac22e9ddbc30c291$var$$cd7ba08b282791a9$var$__setFunctionName = function(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $35f6c23f56aaf458$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $ac22e9ddbc30c291$var$$cd7ba08b282791a9$var$__classPrivateFieldGet = function(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $ac22e9ddbc30c291$var$$cd7ba08b282791a9$var$__classPrivateFieldSet = function(e, t, r, a, n) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !n) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !n : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? n.call(e, r) : n ? n.value = r : t.set(e, r), r;
}, $ac22e9ddbc30c291$var$$cd7ba08b282791a9$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var n = 0, a = Object.getOwnPropertySymbols(e); n < a.length; n++)0 > t.indexOf(a[n]) && Object.prototype.propertyIsEnumerable.call(e, a[n]) && (r[a[n]] = e[a[n]]);
    return r;
}, $ac22e9ddbc30c291$var$$cd7ba08b282791a9$export$341e3470805a945e = function() {
    var e, t, r, a, n, c, s, i, o, l, u = [
        $4d3432ed03d68615$export$b6ae1bc530f4c149
    ], p = [], $ = $1cea8647883c4012$exports.ObservedComponent, f = [], d = [], b = [], m = n = function(e) {
        "use strict";
        function t() {
            var e;
            return (0, $2b3af368dbb30b38$export$71511d61b312f219)(this, t), e = (0, $95518c9e748840bb$export$71511d61b312f219)(this, t, arguments), r.set(e, ($ac22e9ddbc30c291$var$$cd7ba08b282791a9$var$__runInitializers(e, f), $ac22e9ddbc30c291$var$$cd7ba08b282791a9$var$__runInitializers(e, d, !1))), Object.defineProperty(e, "handleSubmit", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($ac22e9ddbc30c291$var$$cd7ba08b282791a9$var$__runInitializers(e, b), function(t) {
                    return $ac22e9ddbc30c291$var$$cd7ba08b282791a9$var$__awaiter(e, void 0, void 0, function() {
                        var e, r, a, n, c, s, i;
                        return (0, $8fdeac7b23d8f90e$export$71511d61b312f219)(this, function(o) {
                            switch(o.label){
                                case 0:
                                    if (t.preventDefault(), t.stopPropagation(), r = (e = t.currentTarget).checkValidity(), this.validated = !0, !r) return [
                                        3,
                                        2
                                    ];
                                    return n = (a = this.props).id, c = a.store, s = a.onSubmit, i = (0, $fbe6f1e2fed97fc7$export$86d7c59254d6a2c9)(e), [
                                        4,
                                        null == c ? void 0 : c.updateOne(i, n)
                                    ];
                                case 1:
                                    i = o.sent(), null == s || s(i), null == c || c.clearCurrent(), o.label = 2;
                                case 2:
                                    return this.validated = !1, [
                                        2
                                    ];
                            }
                        });
                    });
                })
            }), Object.defineProperty(e, "handleReset", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function(t) {
                    var r = t.currentTarget, a = e.props, n = a.onReset, c = a.store;
                    null == n || n((0, $fbe6f1e2fed97fc7$export$86d7c59254d6a2c9)(r)), null == c || c.clearCurrent();
                }
            }), Object.defineProperty(e, "renderFile", (0, $c73d96e37869302b$export$71511d61b312f219)({
                enumerable: !0,
                configurable: !0,
                writable: !0
            }, "value", function(e) {
                var t = e.key, r = e.type, a = e.required, n = e.multiple, c = e.accept, s = e.uploader, i = $ac22e9ddbc30c291$var$$cd7ba08b282791a9$var$__rest(e, [
                    "key",
                    "type",
                    "required",
                    "multiple",
                    "accept",
                    "uploader"
                ]);
                return function(e) {
                    var o = e[t], l = (Array.isArray(o) ? o : [
                        o
                    ]).filter(Boolean);
                    return (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)(m.FieldBox, Object.assign({
                        name: t
                    }, i, {
                        children: s ? (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($ac22e9ddbc30c291$var$$a21a50f24f1cbd28$export$1a5cb5295a7d2749, {
                            store: s,
                            name: null == t ? void 0 : t.toString(),
                            required: a,
                            multiple: n,
                            accept: c,
                            defaultValue: l
                        }) : l.map(function(e) {
                            return (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($ac22e9ddbc30c291$var$$8663609ea235ec39$export$a127194569a41afb, {
                                type: r,
                                path: e
                            });
                        })
                    }));
                };
            })), Object.defineProperty(e, "renderCheckGroup", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function(t) {
                    var r = t.key, a = t.type, n = t.options, c = $ac22e9ddbc30c291$var$$cd7ba08b282791a9$var$__rest(t, [
                        "key",
                        "type",
                        "options"
                    ]);
                    return function(t) {
                        return (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)(m.FieldBox, Object.assign({
                            name: r
                        }, c, {
                            children: (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("div", {
                                children: e.fieldReady && n.map(function(e) {
                                    var n, s = e.value, i = e.text, o = void 0 === i ? s : i;
                                    return (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($a213c3bf0143d254$export$2e2bcd8739ae039.Check, Object.assign({
                                        id: [
                                            r,
                                            s
                                        ] + "",
                                        label: o,
                                        inline: !0
                                    }, c, {
                                        type: a,
                                        name: r.toString(),
                                        value: s,
                                        defaultChecked: null == (n = t[r]) ? void 0 : n.includes(s)
                                    }), s);
                                })
                            })
                        }));
                    };
                }
            }), Object.defineProperty(e, "renderMultipleInput", (0, $c73d96e37869302b$export$71511d61b312f219)({
                enumerable: !0,
                configurable: !0,
                writable: !0
            }, "value", function(t) {
                var r = t.key, a = (t.type, $ac22e9ddbc30c291$var$$cd7ba08b282791a9$var$__rest(t, [
                    "key",
                    "type"
                ]));
                return function(t) {
                    var n = t[r];
                    return (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)(m.FieldBox, Object.assign({
                        name: r
                    }, a, {
                        children: e.fieldReady && (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($ac22e9ddbc30c291$var$$fa84453248a3f065$export$76834b0602c89bd, Object.assign({}, a, {
                            name: null == r ? void 0 : r.toString(),
                            defaultValue: n
                        }))
                    }));
                };
            })), Object.defineProperty(e, "renderHTMLEditor", (0, $c73d96e37869302b$export$71511d61b312f219)({
                enumerable: !0,
                configurable: !0,
                writable: !0
            }, "value", function(t) {
                var r = t.key, a = (t.contentEditable, t.tools), n = $ac22e9ddbc30c291$var$$cd7ba08b282791a9$var$__rest(t, [
                    "key",
                    "contentEditable",
                    "tools"
                ]);
                return function(t) {
                    var c = t[r];
                    return (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)(m.FieldBox, Object.assign({
                        name: r
                    }, n, {
                        children: e.fieldReady && (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($35c5af1670f53210$exports.Editor, {
                            tools: a,
                            name: null == r ? void 0 : r.toString(),
                            defaultValue: c
                        })
                    }));
                };
            })), Object.defineProperty(e, "renderField", (0, $c73d96e37869302b$export$71511d61b312f219)({
                enumerable: !0,
                configurable: !0,
                writable: !0
            }, "value", function(t, r) {
                var a = t.key, n = t.type, c = t.step, s = t.renderLabel, i = (t.renderInput, t.validMessage), o = t.invalidMessage, l = $ac22e9ddbc30c291$var$$cd7ba08b282791a9$var$__rest(t, [
                    "key",
                    "type",
                    "step",
                    "renderLabel",
                    "renderInput",
                    "validMessage",
                    "invalidMessage"
                ]);
                void 0 === r && (r = {});
                var u = "function" == typeof s ? null == s ? void 0 : s(a) : s || a;
                return function(t) {
                    var s = t[a];
                    return (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($43bff9b07dfb92e6$export$2e2bcd8739ae039, {
                        hasValidation: e.customValidation,
                        children: [
                            e.fieldReady && (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($ac22e9ddbc30c291$var$$4e6504f15de995a8$export$56e87bf42978147a, Object.assign({}, r, l, {
                                type: n,
                                step: c,
                                label: u,
                                size: e.observedProps.size,
                                name: a.toString(),
                                defaultValue: m.dateValueOf({
                                    type: n,
                                    step: c
                                }, s)
                            })),
                            i && (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($a213c3bf0143d254$export$2e2bcd8739ae039.Control.Feedback, {
                                tooltip: !0,
                                type: "valid",
                                children: i
                            }),
                            o && (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($a213c3bf0143d254$export$2e2bcd8739ae039.Control.Feedback, {
                                tooltip: !0,
                                type: "invalid",
                                children: o
                            })
                        ]
                    });
                };
            })), e;
        }
        return (0, $92f5157d74f7ea45$export$71511d61b312f219)(t, e), (0, $53cdca766716469e$export$71511d61b312f219)(t, [
            {
                key: "validated",
                get: function() {
                    return $ac22e9ddbc30c291$var$$cd7ba08b282791a9$var$__classPrivateFieldGet(this, r, "f");
                },
                set: function(e) {
                    $ac22e9ddbc30c291$var$$cd7ba08b282791a9$var$__classPrivateFieldSet(this, r, e, "f");
                }
            },
            {
                key: "componentDidMount",
                value: function() {
                    var e = this.props, t = e.id, r = e.store;
                    t && (null == r || r.getOne(t));
                }
            },
            {
                key: "fields",
                get: function() {
                    var e = this;
                    return this.observedProps.fields.map(function(t) {
                        var r = t.renderInput, a = $ac22e9ddbc30c291$var$$cd7ba08b282791a9$var$__rest(t, [
                            "renderInput"
                        ]);
                        return Object.assign(Object.assign({}, a), {
                            renderInput: null != r ? r : "file" === a.type ? e.renderFile(a) : ("radio" === a.type || "checkbox" === a.type) && a.options ? e.renderCheckGroup(a) : a.contentEditable ? e.renderHTMLEditor(a) : !a.options && a.multiple ? e.renderMultipleInput(a) : a.key && e.renderField(a, a.rows && !a.options ? {
                                as: "textarea"
                            } : {})
                        });
                    });
                }
            },
            {
                key: "readOnly",
                get: function() {
                    return this.fields.every(function(e) {
                        var t = e.readOnly, r = e.disabled;
                        return t || r;
                    });
                }
            },
            {
                key: "customValidation",
                get: function() {
                    return this.fields.some(function(e) {
                        var t = e.validMessage, r = e.invalidMessage;
                        return t || r;
                    });
                }
            },
            {
                key: "fieldReady",
                get: function() {
                    var e = this.observedProps, t = e.id, r = e.store;
                    return !t || (null == r ? void 0 : r.downloading) < 1;
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this.fields, t = this.readOnly, r = this.customValidation, a = this.validated, n = this.props, c = (n.id, n.className), s = n.size, i = n.store, o = n.translator, l = $ac22e9ddbc30c291$var$$cd7ba08b282791a9$var$__rest(n, [
                        "id",
                        "className",
                        "size",
                        "store",
                        "translator"
                    ]), u = i || {}, p = u.downloading, $ = u.uploading, f = u.currentOne, d = void 0 === f ? {} : f, b = o.t, m = p > 0 || $ > 0;
                    return (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($a213c3bf0143d254$export$2e2bcd8739ae039, Object.assign({}, l, {
                        className: void 0 === c ? "d-flex flex-column gap-3" : c,
                        validated: a,
                        noValidate: r,
                        onSubmit: this.handleSubmit,
                        onReset: this.handleReset,
                        children: [
                            e.map(function(e) {
                                var t, r = e.renderInput, a = $ac22e9ddbc30c291$var$$cd7ba08b282791a9$var$__rest(e, [
                                    "renderInput"
                                ]);
                                return (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($hO8yS.Fragment, {
                                    children: null == r ? void 0 : r(d, a)
                                }, null == (t = a.key) ? void 0 : t.toString());
                            }),
                            !t && (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("footer", {
                                className: "d-flex gap-3",
                                children: [
                                    (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($b4033c9bbfbcc946$export$2e2bcd8739ae039, {
                                        className: "flex-fill",
                                        size: s,
                                        type: "submit",
                                        disabled: m,
                                        children: b("submit")
                                    }),
                                    (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($b4033c9bbfbcc946$export$2e2bcd8739ae039, {
                                        className: "flex-fill",
                                        size: s,
                                        type: "reset",
                                        variant: "danger",
                                        disabled: m,
                                        children: b("cancel")
                                    })
                                ]
                            })
                        ]
                    }));
                }
            }
        ]), t;
    }($);
    return r = new WeakMap, $ac22e9ddbc30c291$var$$cd7ba08b282791a9$var$__setFunctionName(n, "RestForm"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = $[Symbol.metadata]) ? e : null) : void 0, c = [
        $d5I5D.observable
    ], s = [
        $d5I5D.computed
    ], i = [
        $d5I5D.computed
    ], o = [
        $d5I5D.computed
    ], l = [
        $d5I5D.computed
    ], $ac22e9ddbc30c291$var$$cd7ba08b282791a9$var$__esDecorate(n, null, c, {
        kind: "accessor",
        name: "validated",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "validated" in e;
            },
            get: function(e) {
                return e.validated;
            },
            set: function(e, t) {
                e.validated = t;
            }
        },
        metadata: t
    }, d, b), $ac22e9ddbc30c291$var$$cd7ba08b282791a9$var$__esDecorate(n, null, s, {
        kind: "getter",
        name: "fields",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "fields" in e;
            },
            get: function(e) {
                return e.fields;
            }
        },
        metadata: t
    }, null, f), $ac22e9ddbc30c291$var$$cd7ba08b282791a9$var$__esDecorate(n, null, i, {
        kind: "getter",
        name: "readOnly",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "readOnly" in e;
            },
            get: function(e) {
                return e.readOnly;
            }
        },
        metadata: t
    }, null, f), $ac22e9ddbc30c291$var$$cd7ba08b282791a9$var$__esDecorate(n, null, o, {
        kind: "getter",
        name: "customValidation",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "customValidation" in e;
            },
            get: function(e) {
                return e.customValidation;
            }
        },
        metadata: t
    }, null, f), $ac22e9ddbc30c291$var$$cd7ba08b282791a9$var$__esDecorate(n, null, l, {
        kind: "getter",
        name: "fieldReady",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "fieldReady" in e;
            },
            get: function(e) {
                return e.fieldReady;
            }
        },
        metadata: t
    }, null, f), $ac22e9ddbc30c291$var$$cd7ba08b282791a9$var$__esDecorate(null, a = {
        value: n
    }, u, {
        kind: "class",
        name: n.name,
        metadata: t
    }, null, p), m = n = a.value, t && Object.defineProperty(n, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(n, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "RestForm"
    }), Object.defineProperty(n, "dateValueOf", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: function(e, t) {
            var r = e.type, a = e.step;
            return (0, $fbe6f1e2fed97fc7$export$dd1bc94b04021eeb)(t) ? t : "month" === r ? (0, $fbe6f1e2fed97fc7$export$3ae94a2503e890a1)(t, "YYYY-MM") : "date" === r ? (0, $fbe6f1e2fed97fc7$export$3ae94a2503e890a1)(t, "YYYY-MM-DD") : "datetime-local" === r ? (0, $fbe6f1e2fed97fc7$export$3ae94a2503e890a1)(t, "YYYY-MM-DDTHH:mm".concat(60 > +(void 0 === a ? "60" : a) ? ":ss" : "")) : t;
        }
    }), Object.defineProperty(n, "FieldBox", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: function(e) {
            var t = e.name, r = e.renderLabel, a = e.validMessage, n = e.invalidMessage, c = e.children, s = $ac22e9ddbc30c291$var$$cd7ba08b282791a9$var$__rest(e, [
                "name",
                "renderLabel",
                "validMessage",
                "invalidMessage",
                "children"
            ]);
            return (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($a213c3bf0143d254$export$2e2bcd8739ae039.Group, Object.assign({}, s, {
                children: [
                    (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($a213c3bf0143d254$export$2e2bcd8739ae039.Label, {
                        children: "function" == typeof r ? r(t) : r || t
                    }),
                    c,
                    a && (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($a213c3bf0143d254$export$2e2bcd8739ae039.Control.Feedback, {
                        tooltip: !0,
                        type: "valid",
                        children: a
                    }),
                    n && (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($a213c3bf0143d254$export$2e2bcd8739ae039.Control.Feedback, {
                        tooltip: !0,
                        type: "invalid",
                        children: n
                    })
                ]
            }));
        }
    }), $ac22e9ddbc30c291$var$$cd7ba08b282791a9$var$__runInitializers(n, p), m = n;
}(), $ac22e9ddbc30c291$var$$bcc38e2aa906301f$exports = {};
$ac22e9ddbc30c291$var$$parcel$export($ac22e9ddbc30c291$var$$bcc38e2aa906301f$exports, "Pager", function() {
    return $ac22e9ddbc30c291$var$$bcc38e2aa906301f$export$57625d62e5386b09;
});
var $ac22e9ddbc30c291$var$$bcc38e2aa906301f$export$57625d62e5386b09 = function(e) {
    var t = e.pageSize, r = e.pageIndex, a = e.pageCount, n = e.onChange;
    function c() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, r = {
            pageSize: t,
            pageIndex: e
        };
        return {
            href: "?".concat((0, $fbe6f1e2fed97fc7$export$13397a83aa5915d6)(Object.assign(Object.assign({}, (0, $fbe6f1e2fed97fc7$export$eb9b2aadbe449a20)()), r))),
            onClick: n && function(e) {
                e.preventDefault(), n(r);
            }
        };
    }
    return (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("form", {
        className: "m-0 d-flex align-items-center gap-2",
        onSubmit: n && function(e) {
            return e.preventDefault(), e.stopPropagation();
        },
        children: [
            (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($a213c3bf0143d254$export$2e2bcd8739ae039.Control, {
                type: "number",
                name: "pageSize",
                defaultValue: t,
                min: 1,
                required: !0,
                onChange: function(e) {
                    var t = e.currentTarget;
                    return t.reportValidity() && (null == n ? void 0 : n({
                        pageSize: +t.value,
                        pageIndex: r
                    }));
                }
            }),
            "x",
            (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($a213c3bf0143d254$export$2e2bcd8739ae039.Control, {
                type: "number",
                name: "pageIndex",
                defaultValue: r || 1,
                min: 1,
                max: a,
                required: !0,
                onChange: function(e) {
                    var r = e.currentTarget;
                    return r.reportValidity() && (null == n ? void 0 : n({
                        pageSize: t,
                        pageIndex: +r.value
                    }));
                }
            }),
            (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($99a4e9403f4f1ccb$export$2e2bcd8739ae039, {
                className: "m-0",
                children: [
                    r > 1 && (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($99a4e9403f4f1ccb$export$2e2bcd8739ae039.Item, Object.assign({}, c(1), {
                        children: "1"
                    })),
                    r > 3 && (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($99a4e9403f4f1ccb$export$2e2bcd8739ae039.Ellipsis, {}),
                    r > 2 && (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($99a4e9403f4f1ccb$export$2e2bcd8739ae039.Item, Object.assign({}, c(r - 1), {
                        children: r - 1
                    })),
                    (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($99a4e9403f4f1ccb$export$2e2bcd8739ae039.Item, {
                        active: !0,
                        children: r
                    }),
                    a - r > 1 && (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($99a4e9403f4f1ccb$export$2e2bcd8739ae039.Item, Object.assign({}, c(r + 1), {
                        children: r + 1
                    })),
                    a - r > 2 && (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($99a4e9403f4f1ccb$export$2e2bcd8739ae039.Ellipsis, {}),
                    r < a && (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($99a4e9403f4f1ccb$export$2e2bcd8739ae039.Item, Object.assign({}, c(a), {
                        children: a
                    }))
                ]
            })
        ]
    });
};
$ac22e9ddbc30c291$var$$bcc38e2aa906301f$export$57625d62e5386b09.displayName = "Pager";
var $ac22e9ddbc30c291$var$$3800431d840f9bec$exports = {};
$ac22e9ddbc30c291$var$$parcel$export($ac22e9ddbc30c291$var$$3800431d840f9bec$exports, "RestTable", function() {
    return $ac22e9ddbc30c291$var$$3800431d840f9bec$export$fd90441354a7d816;
});
var $ac22e9ddbc30c291$var$$bfbc9f72f179e373$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var n = 0, a = Object.getOwnPropertySymbols(e); n < a.length; n++)0 > t.indexOf(a[n]) && Object.prototype.propertyIsEnumerable.call(e, a[n]) && (r[a[n]] = e[a[n]]);
    return r;
}, $ac22e9ddbc30c291$var$$bfbc9f72f179e373$export$28baae8ef86bbf36 = (0, $4d3432ed03d68615$export$b6ae1bc530f4c149)(function(e) {
    var t = e.fields, r = e.store, a = e.translator, n = $ac22e9ddbc30c291$var$$bfbc9f72f179e373$var$__rest(e, [
        "fields",
        "store",
        "translator"
    ]), c = r.indexKey, s = r.currentOne, i = !(0, $fbe6f1e2fed97fc7$export$dd1bc94b04021eeb)(s), o = s[c];
    return (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($8cc4069d2715af29$export$2e2bcd8739ae039, {
        show: i,
        onHide: function() {
            return r.clearCurrent();
        },
        children: [
            (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($8cc4069d2715af29$export$2e2bcd8739ae039.Header, {
                closeButton: !0,
                children: o
            }),
            (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($8cc4069d2715af29$export$2e2bcd8739ae039.Body, {
                children: (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($ac22e9ddbc30c291$var$$cd7ba08b282791a9$export$341e3470805a945e, Object.assign({
                    id: o,
                    fields: t,
                    store: r,
                    translator: a
                }, n))
            })
        ]
    });
});
$ac22e9ddbc30c291$var$$aac96070b6d8b41d$export$5eeb11949c905cc1 = "SrGRNq_filterBar";
var $ac22e9ddbc30c291$var$$3800431d840f9bec$var$__runInitializers = function(e, t, r) {
    for(var a = arguments.length > 2, n = 0; n < t.length; n++)r = a ? t[n].call(e, r) : t[n].call(e);
    return a ? r : void 0;
}, $ac22e9ddbc30c291$var$$3800431d840f9bec$var$__esDecorate = function(e, t, r, a, n, c) {
    function s(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var i, o = a.kind, l = "getter" === o ? "get" : "setter" === o ? "set" : "value", u = !t && e ? a.static ? e : e.prototype : null, p = t || (u ? Object.getOwnPropertyDescriptor(u, a.name) : {}), $ = !1, f = r.length - 1; f >= 0; f--){
        var d = {};
        for(var b in a)d[b] = "access" === b ? {} : a[b];
        for(var b in a.access)d.access[b] = a.access[b];
        d.addInitializer = function(e) {
            if ($) throw TypeError("Cannot add initializers after decoration has completed");
            c.push(s(e || null));
        };
        var m = (0, r[f])("accessor" === o ? {
            get: p.get,
            set: p.set
        } : p[l], d);
        if ("accessor" === o) {
            if (void 0 === m) continue;
            if (null === m || (void 0 === m ? "undefined" : (0, $35f6c23f56aaf458$export$71511d61b312f219)(m)) !== "object") throw TypeError("Object expected");
            (i = s(m.get)) && (p.get = i), (i = s(m.set)) && (p.set = i), (i = s(m.init)) && n.unshift(i);
        } else (i = s(m)) && ("field" === o ? n.unshift(i) : p[l] = i);
    }
    u && Object.defineProperty(u, a.name, p), $ = !0;
}, $ac22e9ddbc30c291$var$$3800431d840f9bec$var$__awaiter = function(e, t, r, a) {
    return new (r || (r = Promise))(function(n, c) {
        function s(e) {
            try {
                o(a.next(e));
            } catch (e) {
                c(e);
            }
        }
        function i(e) {
            try {
                o(a.throw(e));
            } catch (e) {
                c(e);
            }
        }
        function o(e) {
            var t;
            e.done ? n(e.value) : ((t = e.value) instanceof r ? t : new r(function(e) {
                e(t);
            })).then(s, i);
        }
        o((a = a.apply(e, t || [])).next());
    });
}, $ac22e9ddbc30c291$var$$3800431d840f9bec$var$__setFunctionName = function(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $35f6c23f56aaf458$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $ac22e9ddbc30c291$var$$3800431d840f9bec$var$__classPrivateFieldGet = function(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $ac22e9ddbc30c291$var$$3800431d840f9bec$var$__classPrivateFieldSet = function(e, t, r, a, n) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !n) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !n : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? n.call(e, r) : n ? n.value = r : t.set(e, r), r;
}, $ac22e9ddbc30c291$var$$3800431d840f9bec$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var n = 0, a = Object.getOwnPropertySymbols(e); n < a.length; n++)0 > t.indexOf(a[n]) && Object.prototype.propertyIsEnumerable.call(e, a[n]) && (r[a[n]] = e[a[n]]);
    return r;
}, $ac22e9ddbc30c291$var$$3800431d840f9bec$export$fd90441354a7d816 = function() {
    var e, t, r, a, n, c, s, i, o, l, u, p, $, f = [
        $4d3432ed03d68615$export$b6ae1bc530f4c149
    ], d = [], b = $1cea8647883c4012$exports.ObservedComponent, m = [], v = [], h = [];
    return n = function(e) {
        "use strict";
        function t() {
            var e;
            return (0, $2b3af368dbb30b38$export$71511d61b312f219)(this, t), e = (0, $95518c9e748840bb$export$71511d61b312f219)(this, t, arguments), r.set(e, ($ac22e9ddbc30c291$var$$3800431d840f9bec$var$__runInitializers(e, m), $ac22e9ddbc30c291$var$$3800431d840f9bec$var$__runInitializers(e, v, []))), Object.defineProperty(e, "toggleCheckAll", (0, $c73d96e37869302b$export$71511d61b312f219)({
                enumerable: !0,
                configurable: !0,
                writable: !0
            }, "value", ($ac22e9ddbc30c291$var$$3800431d840f9bec$var$__runInitializers(e, h), function() {
                var t = e.props, r = t.store, a = t.onCheck, n = r.indexKey, c = r.currentPage;
                e.checkedKeys = e.checkedKeys.length ? [] : c.map(function(e) {
                    return e[n];
                }), null == a || a(e.checkedKeys);
            }))), Object.defineProperty(e, "renderCustomBody", (0, $c73d96e37869302b$export$71511d61b312f219)({
                enumerable: !0,
                configurable: !0,
                writable: !0
            }, "value", function(e) {
                var t = e.key, r = e.type, a = e.multiple, n = e.options, c = e.accept, s = e.rows;
                return "url" === r ? function(e) {
                    var r = e[t];
                    return r && (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("a", {
                        target: "_blank",
                        href: r,
                        children: r
                    });
                } : "email" === r ? function(e) {
                    var r = e[t];
                    return r && (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("a", {
                        href: "mailto:".concat(r),
                        children: r
                    });
                } : "tel" === r ? function(e) {
                    var r = e[t];
                    return r && (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("a", {
                        href: "tel:".concat(r),
                        children: r
                    });
                } : "file" === r ? function(e) {
                    var r = e[t];
                    return (Array.isArray(r) ? r : [
                        r
                    ]).map(function(e) {
                        return e && (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($ac22e9ddbc30c291$var$$8663609ea235ec39$export$a127194569a41afb, {
                            type: c,
                            path: e
                        }, e);
                    });
                } : n || a ? function(e) {
                    var r = e[t];
                    return r && (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($ac22e9ddbc30c291$var$$f600741b98acd6fe$export$ef1c4106ceccca63, {
                        list: r.map(function(e) {
                            return {
                                text: e
                            };
                        })
                    });
                } : !n && s ? function(e) {
                    var r = e[t];
                    return (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("p", {
                        className: "m-0 text-truncate",
                        style: {
                            maxWidth: "20rem"
                        },
                        title: r,
                        children: r
                    });
                } : void 0;
            })), Object.defineProperty(e, "getList", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: (0, $aMH3h.debounce)(function(t) {
                    var r = t.pageIndex, a = t.pageSize, n = e.props, c = n.store, s = n.filter;
                    c.downloading < 1 && c.getList(s, r, a);
                })
            }), e;
        }
        return (0, $92f5157d74f7ea45$export$71511d61b312f219)(t, e), (0, $53cdca766716469e$export$71511d61b312f219)(t, [
            {
                key: "componentDidMount",
                value: function() {
                    var e = this.props, t = e.store, r = e.filter;
                    t.clear(), t.getList(r);
                }
            },
            {
                key: "fieldSize",
                get: function() {
                    var e = this.observedProps.size;
                    return e ? "sm" === e ? "sm" : "lg" : void 0;
                }
            },
            {
                key: "checkedKeys",
                get: function() {
                    return $ac22e9ddbc30c291$var$$3800431d840f9bec$var$__classPrivateFieldGet(this, r, "f");
                },
                set: function(e) {
                    $ac22e9ddbc30c291$var$$3800431d840f9bec$var$__classPrivateFieldSet(this, r, e, "f");
                }
            },
            {
                key: "toggleCheck",
                value: function(e) {
                    var t, r, a = this.checkedKeys, n = a.indexOf(e);
                    this.checkedKeys = n < 0 ? (0, $ca91dac30bd8a8fe$export$71511d61b312f219)(a).concat([
                        e
                    ]) : (0, $ca91dac30bd8a8fe$export$71511d61b312f219)(a.slice(0, n)).concat((0, $ca91dac30bd8a8fe$export$71511d61b312f219)(a.slice(n + 1))), null == (r = (t = this.props).onCheck) || r.call(t, this.checkedKeys);
                }
            },
            (0, $c73d96e37869302b$export$71511d61b312f219)({
                key: "checkColumn"
            }, "get", function() {
                var e, t = this, r = this.checkedKeys, a = this.toggleCheckAll, n = this.observedProps.store, c = n.indexKey, s = n.currentPage;
                return e = {}, (0, $c73d96e37869302b$export$71511d61b312f219)(e, "renderHead", function() {
                    var e;
                    return (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($a213c3bf0143d254$export$2e2bcd8739ae039.Check, (e = {
                        type: "checkbox",
                        name: "all-".concat(c.toString()),
                        value: r + ""
                    }, (0, $c73d96e37869302b$export$71511d61b312f219)(e, "checked", !!s[0] && s.every(function(e) {
                        var t = e[c];
                        return r.includes(t);
                    })), (0, $c73d96e37869302b$export$71511d61b312f219)(e, "ref", function(e) {
                        e && (e.indeterminate = !!r.length && r.length < s.length);
                    }), (0, $c73d96e37869302b$export$71511d61b312f219)(e, "onClick", a), (0, $c73d96e37869302b$export$71511d61b312f219)(e, "onKeyUp", function(e) {
                        return " " === e.key && a();
                    }), e));
                }), (0, $c73d96e37869302b$export$71511d61b312f219)(e, "renderBody", function(e) {
                    var a = e[c];
                    return (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($a213c3bf0143d254$export$2e2bcd8739ae039.Check, {
                        type: "checkbox",
                        name: c.toString(),
                        value: a,
                        checked: r.includes(a),
                        onClick: function() {
                            return t.toggleCheck(a);
                        },
                        onKeyUp: function(e) {
                            return " " === e.key && t.toggleCheck(a);
                        }
                    });
                }), e;
            }),
            {
                key: "operateColumn",
                get: function() {
                    var e = this, t = this.observedProps, r = t.editable, a = t.deletable, n = t.columns, c = t.store, s = t.translator, i = this.fieldSize, o = s.t, l = n.every(function(e) {
                        return e.readOnly;
                    }), u = n.every(function(e) {
                        return e.disabled;
                    });
                    return {
                        renderHead: function() {
                            return (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($hO8yS.Fragment, {});
                        },
                        renderBody: function(t) {
                            return (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($hO8yS.Fragment, {
                                children: [
                                    u ? (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($hO8yS.Fragment, {}) : r && (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($b4033c9bbfbcc946$export$2e2bcd8739ae039, {
                                        className: "text-nowrap m-1",
                                        variant: l ? "primary" : "warning",
                                        size: i,
                                        onClick: function() {
                                            return c.currentOne = t;
                                        },
                                        children: l ? o("view") : o("edit")
                                    }),
                                    a && (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($b4033c9bbfbcc946$export$2e2bcd8739ae039, {
                                        className: "text-nowrap m-1",
                                        variant: "danger",
                                        size: i,
                                        onClick: function() {
                                            return e.deleteList([
                                                t.id
                                            ]);
                                        },
                                        children: o("delete")
                                    })
                                ]
                            });
                        }
                    };
                }
            },
            {
                key: "columns",
                get: function() {
                    var e = this, t = this.observedProps, r = t.editable, a = t.deletable, n = t.columns;
                    return [
                        t.onCheck && this.checkColumn
                    ].concat((0, $ca91dac30bd8a8fe$export$71511d61b312f219)(n.map(function(t) {
                        var r = t.renderBody, a = $ac22e9ddbc30c291$var$$3800431d840f9bec$var$__rest(t, [
                            "renderBody"
                        ]);
                        return Object.assign(Object.assign({}, a), {
                            renderBody: null != r ? r : e.renderCustomBody(a)
                        });
                    })), [
                        (r || a) && this.operateColumn
                    ]).filter(Boolean);
                }
            },
            {
                key: "hasHeader",
                get: function() {
                    return this.columns.some(function(e) {
                        return e.renderHead;
                    });
                }
            },
            {
                key: "hasFooter",
                get: function() {
                    return this.columns.some(function(e) {
                        return e.renderFoot;
                    });
                }
            },
            {
                key: "editing",
                get: function() {
                    return !(0, $fbe6f1e2fed97fc7$export$dd1bc94b04021eeb)(this.observedProps.store.currentOne);
                }
            },
            {
                key: "renderTable",
                value: function() {
                    var e = this.props, t = (e.className, e.columns, e.store), r = (e.translator, e.editable, e.deletable, e.onCheck, e.onSubmit, e.onReset, e.responsive), a = $ac22e9ddbc30c291$var$$3800431d840f9bec$var$__rest(e, [
                        "className",
                        "columns",
                        "store",
                        "translator",
                        "editable",
                        "deletable",
                        "onCheck",
                        "onSubmit",
                        "onReset",
                        "responsive"
                    ]), n = this.hasHeader, c = this.hasFooter, s = this.columns, i = this.editing, o = t.indexKey, l = t.downloading, u = t.currentPage;
                    return (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($972aa4b18ce22626$export$2e2bcd8739ae039, Object.assign({}, a, {
                        responsive: void 0 === r || r,
                        children: [
                            n && (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("thead", {
                                children: (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("tr", {
                                    className: "align-middle text-nowrap",
                                    children: s.map(function(e, t) {
                                        var r = e.key, a = e.renderHead;
                                        return (r || a) && (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("th", {
                                            children: "function" == typeof a ? a(r) : a || r
                                        }, (null == r ? void 0 : r.toString()) || t);
                                    })
                                })
                            }),
                            (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("tbody", {
                                children: !i && l > 0 ? (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("tr", {
                                    children: (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("td", {
                                        className: "text-center p-3",
                                        colSpan: s.length,
                                        children: (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($999d941606fa59dc$export$2e2bcd8739ae039, {})
                                    })
                                }) : u.map(function(e) {
                                    return (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("tr", {
                                        className: "align-middle",
                                        children: s.map(function(t, r) {
                                            var a = t.key, n = t.renderBody;
                                            return (a || n) && (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("td", {
                                                children: (null == n ? void 0 : n(e)) || a && e[a]
                                            }, (null == a ? void 0 : a.toString()) || r);
                                        })
                                    }, e[o]);
                                })
                            }),
                            c && (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("tfoot", {
                                children: (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("tr", {
                                    className: "align-middle",
                                    children: s.map(function(e, t) {
                                        var r = e.key, a = e.renderFoot;
                                        return (r || a) && (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("td", {
                                            children: "function" == typeof a ? a(r) : a || r
                                        }, (null == r ? void 0 : r.toString()) || t);
                                    })
                                })
                            })
                        ]
                    }));
                }
            },
            {
                key: "deleteList",
                value: function(e) {
                    return $ac22e9ddbc30c291$var$$3800431d840f9bec$var$__awaiter(this, void 0, void 0, function() {
                        var t, r, a, n, c, s, i, o, l, u;
                        return (0, $8fdeac7b23d8f90e$export$71511d61b312f219)(this, function(p) {
                            switch(p.label){
                                case 0:
                                    if (r = (t = this.props).translator, a = t.store, n = !0, c = !1, s = void 0, !confirm(r.t("sure_to_delete_x", {
                                        keys: e
                                    }))) return [
                                        3,
                                        8
                                    ];
                                    p.label = 1;
                                case 1:
                                    p.trys.push([
                                        1,
                                        6,
                                        7,
                                        8
                                    ]), i = e[Symbol.iterator](), p.label = 2;
                                case 2:
                                    if (n = (o = i.next()).done) return [
                                        3,
                                        5
                                    ];
                                    return l = o.value, [
                                        4,
                                        a.deleteOne(l)
                                    ];
                                case 3:
                                    p.sent(), p.label = 4;
                                case 4:
                                    return n = !0, [
                                        3,
                                        2
                                    ];
                                case 5:
                                    return [
                                        3,
                                        8
                                    ];
                                case 6:
                                    return u = p.sent(), c = !0, s = u, [
                                        3,
                                        8
                                    ];
                                case 7:
                                    try {
                                        n || null == i.return || i.return();
                                    } finally{
                                        if (c) throw s;
                                    }
                                    return [
                                        7
                                    ];
                                case 8:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this, t = this.props, r = t.className, a = t.editable, n = t.deletable, c = t.filterFields, s = t.store, i = t.translator, o = t.onSubmit, l = (t.onReset, $ac22e9ddbc30c291$var$$3800431d840f9bec$var$__rest(t, [
                        "className",
                        "editable",
                        "deletable",
                        "filterFields",
                        "store",
                        "translator",
                        "onSubmit",
                        "onReset"
                    ])), u = this.fieldSize, p = i.t, $ = s.indexKey, f = s.pageSize, d = s.pageIndex, b = s.pageCount, m = s.totalCount;
                    return (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("div", Object.assign({
                        className: void 0 === r ? "overflow-auto d-flex flex-column gap-3" : r
                    }, l, {
                        children: [
                            (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("header", {
                                className: "sticky-top bg-white py-3",
                                children: [
                                    c && (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($ac22e9ddbc30c291$var$$cd7ba08b282791a9$export$341e3470805a945e, {
                                        className: "d-flex flex-wrap align-items-center gap-3 pb-3 border-bottom ".concat($ac22e9ddbc30c291$var$$aac96070b6d8b41d$export$5eeb11949c905cc1),
                                        size: u,
                                        translator: i,
                                        fields: c,
                                        onSubmit: function(e) {
                                            return s.getList(e, 1);
                                        },
                                        onReset: function() {
                                            return s.getList({}, 1);
                                        }
                                    }),
                                    (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("div", {
                                        className: "d-flex justify-content-between align-items-center",
                                        children: [
                                            n && (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($b4033c9bbfbcc946$export$2e2bcd8739ae039, {
                                                className: "mx-2",
                                                variant: "danger",
                                                size: u,
                                                onClick: function() {
                                                    return e.deleteList(e.checkedKeys);
                                                },
                                                children: p("delete")
                                            }),
                                            a && (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($b4033c9bbfbcc946$export$2e2bcd8739ae039, {
                                                size: u,
                                                onClick: function() {
                                                    return s.currentOne[$] = "";
                                                },
                                                children: p("create")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            this.renderTable(),
                            (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("footer", {
                                className: "d-flex justify-content-between align-items-center",
                                children: [
                                    !!m && (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("span", {
                                        className: "mx-3 fs14",
                                        children: p("total_x_rows", {
                                            totalCount: m
                                        })
                                    }),
                                    (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($ac22e9ddbc30c291$var$$bcc38e2aa906301f$export$57625d62e5386b09, {
                                        pageSize: f,
                                        pageIndex: d,
                                        pageCount: b,
                                        onChange: this.getList
                                    })
                                ]
                            }),
                            a && (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($ac22e9ddbc30c291$var$$bfbc9f72f179e373$export$28baae8ef86bbf36, {
                                size: u,
                                fields: this.columns.map(function(e) {
                                    var t = e.renderHead;
                                    return Object.assign(Object.assign({}, $ac22e9ddbc30c291$var$$3800431d840f9bec$var$__rest(e, [
                                        "renderHead"
                                    ])), {
                                        renderLabel: t
                                    });
                                }),
                                store: s,
                                translator: i,
                                onSubmit: o
                            })
                        ]
                    }));
                }
            }
        ]), t;
    }(b), r = new WeakMap, $ac22e9ddbc30c291$var$$3800431d840f9bec$var$__setFunctionName(n, "RestTable"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = b[Symbol.metadata]) ? e : null) : void 0, c = [
        $d5I5D.computed
    ], s = [
        $d5I5D.observable
    ], i = [
        $d5I5D.computed
    ], o = [
        $d5I5D.computed
    ], l = [
        $d5I5D.computed
    ], u = [
        $d5I5D.computed
    ], p = [
        $d5I5D.computed
    ], $ = [
        $d5I5D.computed
    ], $ac22e9ddbc30c291$var$$3800431d840f9bec$var$__esDecorate(n, null, c, {
        kind: "getter",
        name: "fieldSize",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "fieldSize" in e;
            },
            get: function(e) {
                return e.fieldSize;
            }
        },
        metadata: t
    }, null, m), $ac22e9ddbc30c291$var$$3800431d840f9bec$var$__esDecorate(n, null, s, {
        kind: "accessor",
        name: "checkedKeys",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "checkedKeys" in e;
            },
            get: function(e) {
                return e.checkedKeys;
            },
            set: function(e, t) {
                e.checkedKeys = t;
            }
        },
        metadata: t
    }, v, h), $ac22e9ddbc30c291$var$$3800431d840f9bec$var$__esDecorate(n, null, i, {
        kind: "getter",
        name: "checkColumn",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "checkColumn" in e;
            },
            get: function(e) {
                return e.checkColumn;
            }
        },
        metadata: t
    }, null, m), $ac22e9ddbc30c291$var$$3800431d840f9bec$var$__esDecorate(n, null, o, {
        kind: "getter",
        name: "operateColumn",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "operateColumn" in e;
            },
            get: function(e) {
                return e.operateColumn;
            }
        },
        metadata: t
    }, null, m), $ac22e9ddbc30c291$var$$3800431d840f9bec$var$__esDecorate(n, null, l, {
        kind: "getter",
        name: "columns",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "columns" in e;
            },
            get: function(e) {
                return e.columns;
            }
        },
        metadata: t
    }, null, m), $ac22e9ddbc30c291$var$$3800431d840f9bec$var$__esDecorate(n, null, u, {
        kind: "getter",
        name: "hasHeader",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "hasHeader" in e;
            },
            get: function(e) {
                return e.hasHeader;
            }
        },
        metadata: t
    }, null, m), $ac22e9ddbc30c291$var$$3800431d840f9bec$var$__esDecorate(n, null, p, {
        kind: "getter",
        name: "hasFooter",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "hasFooter" in e;
            },
            get: function(e) {
                return e.hasFooter;
            }
        },
        metadata: t
    }, null, m), $ac22e9ddbc30c291$var$$3800431d840f9bec$var$__esDecorate(n, null, $, {
        kind: "getter",
        name: "editing",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "editing" in e;
            },
            get: function(e) {
                return e.editing;
            }
        },
        metadata: t
    }, null, m), $ac22e9ddbc30c291$var$$3800431d840f9bec$var$__esDecorate(null, a = {
        value: n
    }, f, {
        kind: "class",
        name: n.name,
        metadata: t
    }, null, d), n = a.value, t && Object.defineProperty(n, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(n, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "RestTable"
    }), $ac22e9ddbc30c291$var$$3800431d840f9bec$var$__runInitializers(n, d), n;
}(), $ac22e9ddbc30c291$var$$3330ccfab53de794$exports = {};
$ac22e9ddbc30c291$var$$parcel$export($ac22e9ddbc30c291$var$$3330ccfab53de794$exports, "ScrollBoundary", function() {
    return $ac22e9ddbc30c291$var$$3330ccfab53de794$export$d086fcc3bc3f366f;
});
var $ac22e9ddbc30c291$var$$3330ccfab53de794$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var n = 0, a = Object.getOwnPropertySymbols(e); n < a.length; n++)0 > t.indexOf(a[n]) && Object.prototype.propertyIsEnumerable.call(e, a[n]) && (r[a[n]] = e[a[n]]);
    return r;
}, $ac22e9ddbc30c291$var$$3330ccfab53de794$var$EdgeOrder = [
    "top",
    "right",
    "bottom",
    "left"
], $ac22e9ddbc30c291$var$$3330ccfab53de794$var$touch = function(e, t) {
    return function(r) {
        if (r) {
            var a, n = null == (a = r.parentElement) ? void 0 : a.parentElement, c = n ? getComputedStyle(n) : {}, s = c.overflowX, i = c.overflowY, o = "".concat(s).concat(i).match(/auto|scroll/) ? n : null, l = [
                ,
                ,
                ,
                , 
            ].fill("0px");
            l[$ac22e9ddbc30c291$var$$3330ccfab53de794$var$EdgeOrder.indexOf(e)] = "200px", new IntersectionObserver(function(r) {
                return (0, $44015290ab5c0623$export$71511d61b312f219)(r, 1)[0].isIntersecting && t(e);
            }, {
                root: o,
                rootMargin: l.join(" ")
            }).observe(r);
        }
    };
}, $ac22e9ddbc30c291$var$$3330ccfab53de794$export$d086fcc3bc3f366f = function(e) {
    var t = e.className, r = e.onTouch, a = e.top, n = e.left, c = e.right, s = e.bottom, i = e.children, o = $ac22e9ddbc30c291$var$$3330ccfab53de794$var$__rest(e, [
        "className",
        "onTouch",
        "top",
        "left",
        "right",
        "bottom",
        "children"
    ]);
    return (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("div", Object.assign({
        className: $ac22e9ddbc30c291$var$$parcel$interopDefault($852a55cf17d8b19d$exports)("position-relative", t)
    }, o, {
        children: [
            (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("div", {
                className: "position-absolute top-0 left-0 w-100",
                ref: $ac22e9ddbc30c291$var$$3330ccfab53de794$var$touch("top", r),
                children: a
            }),
            (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("div", {
                className: "position-absolute top-0 left-0 h-100",
                ref: $ac22e9ddbc30c291$var$$3330ccfab53de794$var$touch("left", r),
                children: n
            }),
            i,
            (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("div", {
                className: "position-absolute top-0 right-0 h-100",
                ref: $ac22e9ddbc30c291$var$$3330ccfab53de794$var$touch("right", r),
                children: c
            }),
            (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("div", {
                className: "position-absolute top-100 left-0 w-100",
                ref: $ac22e9ddbc30c291$var$$3330ccfab53de794$var$touch("bottom", r),
                children: s
            })
        ]
    }));
};
$ac22e9ddbc30c291$var$$3330ccfab53de794$export$d086fcc3bc3f366f.displayName = "ScrollBoundary";
var $ac22e9ddbc30c291$var$$6c88af5e81334c9f$exports = {};
$ac22e9ddbc30c291$var$$parcel$export($ac22e9ddbc30c291$var$$6c88af5e81334c9f$exports, "ScrollList", function() {
    return $ac22e9ddbc30c291$var$$6c88af5e81334c9f$export$797e591eba0ca37c;
});
var $ac22e9ddbc30c291$var$$6c88af5e81334c9f$var$__esDecorate = function(e, t, r, a, n, c) {
    function s(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var i, o = a.kind, l = "getter" === o ? "get" : "setter" === o ? "set" : "value", u = !t && e ? a.static ? e : e.prototype : null, p = t || (u ? Object.getOwnPropertyDescriptor(u, a.name) : {}), $ = !1, f = r.length - 1; f >= 0; f--){
        var d = {};
        for(var b in a)d[b] = "access" === b ? {} : a[b];
        for(var b in a.access)d.access[b] = a.access[b];
        d.addInitializer = function(e) {
            if ($) throw TypeError("Cannot add initializers after decoration has completed");
            c.push(s(e || null));
        };
        var m = (0, r[f])("accessor" === o ? {
            get: p.get,
            set: p.set
        } : p[l], d);
        if ("accessor" === o) {
            if (void 0 === m) continue;
            if (null === m || (void 0 === m ? "undefined" : (0, $35f6c23f56aaf458$export$71511d61b312f219)(m)) !== "object") throw TypeError("Object expected");
            (i = s(m.get)) && (p.get = i), (i = s(m.set)) && (p.set = i), (i = s(m.init)) && n.unshift(i);
        } else (i = s(m)) && ("field" === o ? n.unshift(i) : p[l] = i);
    }
    u && Object.defineProperty(u, a.name, p), $ = !0;
}, $ac22e9ddbc30c291$var$$6c88af5e81334c9f$var$__runInitializers = function(e, t, r) {
    for(var a = arguments.length > 2, n = 0; n < t.length; n++)r = a ? t[n].call(e, r) : t[n].call(e);
    return a ? r : void 0;
}, $ac22e9ddbc30c291$var$$6c88af5e81334c9f$var$__awaiter = function(e, t, r, a) {
    return new (r || (r = Promise))(function(n, c) {
        function s(e) {
            try {
                o(a.next(e));
            } catch (e) {
                c(e);
            }
        }
        function i(e) {
            try {
                o(a.throw(e));
            } catch (e) {
                c(e);
            }
        }
        function o(e) {
            var t;
            e.done ? n(e.value) : ((t = e.value) instanceof r ? t : new r(function(e) {
                e(t);
            })).then(s, i);
        }
        o((a = a.apply(e, t || [])).next());
    });
}, $ac22e9ddbc30c291$var$$6c88af5e81334c9f$var$__setFunctionName = function(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $35f6c23f56aaf458$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $ac22e9ddbc30c291$var$$6c88af5e81334c9f$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var n = 0, a = Object.getOwnPropertySymbols(e); n < a.length; n++)0 > t.indexOf(a[n]) && Object.prototype.propertyIsEnumerable.call(e, a[n]) && (r[a[n]] = e[a[n]]);
    return r;
}, $ac22e9ddbc30c291$var$$6c88af5e81334c9f$export$797e591eba0ca37c = function() {
    var e, t, r, a, n = [
        $4d3432ed03d68615$export$b6ae1bc530f4c149
    ], c = [], s = $hO8yS.Component;
    return $ac22e9ddbc30c291$var$$6c88af5e81334c9f$var$__setFunctionName(a = function(e) {
        "use strict";
        function t() {
            var e;
            return (0, $2b3af368dbb30b38$export$71511d61b312f219)(this, t), e = (0, $95518c9e748840bb$export$71511d61b312f219)(this, t, arguments), Object.defineProperty(e, "loadMore", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: (0, $aMH3h.debounce)(function(t) {
                    var r = e.props.store;
                    "bottom" === t && r.downloading < 1 && !r.noMore && r.getList();
                })
            }), e;
        }
        return (0, $92f5157d74f7ea45$export$71511d61b312f219)(t, e), (0, $53cdca766716469e$export$71511d61b312f219)(t, [
            {
                key: "componentDidMount",
                value: function() {
                    return $ac22e9ddbc30c291$var$$6c88af5e81334c9f$var$__awaiter(this, void 0, void 0, function() {
                        var e, t, r, a;
                        return (0, $8fdeac7b23d8f90e$export$71511d61b312f219)(this, function(n) {
                            switch(n.label){
                                case 0:
                                    return $29590480c608918b$export$6a4eb2e7fc9e8903, t = (e = this.props).filter, r = e.defaultData, a = this.props.store, [
                                        4,
                                        (0, $d5I5D.when)(function() {
                                            return a.downloading < 1;
                                        })
                                    ];
                                case 1:
                                    if (n.sent(), a.clearList(), !r) return [
                                        3,
                                        3
                                    ];
                                    return [
                                        4,
                                        a.restoreList({
                                            allItems: r,
                                            filter: t
                                        })
                                    ];
                                case 2:
                                    n.sent(), n.label = 3;
                                case 3:
                                    return [
                                        4,
                                        a.getList(t, a.pageList.length + 1)
                                    ];
                                case 4:
                                    return n.sent(), [
                                        2
                                    ];
                            }
                        });
                    });
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    this.props.store.clearList();
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this.props, t = e.translator, r = e.store, a = e.renderList, n = $ac22e9ddbc30c291$var$$6c88af5e81334c9f$var$__rest(e, [
                        "translator",
                        "store",
                        "renderList"
                    ]), c = t.t, s = r.noMore, i = r.allItems;
                    return (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($ac22e9ddbc30c291$var$$3330ccfab53de794$export$d086fcc3bc3f366f, Object.assign({}, n, {
                        onTouch: this.loadMore,
                        children: (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("div", {
                            children: [
                                a(i),
                                (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("footer", {
                                    className: "mt-2 text-center text-muted small",
                                    children: c(s || !i.length ? "no_more" : "load_more")
                                })
                            ]
                        })
                    }));
                }
            }
        ]), t;
    }(s), "ScrollList"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = s[Symbol.metadata]) ? e : null) : void 0, $ac22e9ddbc30c291$var$$6c88af5e81334c9f$var$__esDecorate(null, r = {
        value: a
    }, n, {
        kind: "class",
        name: a.name,
        metadata: t
    }, null, c), a = r.value, t && Object.defineProperty(a, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(a, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "ScrollList"
    }), $ac22e9ddbc30c291$var$$6c88af5e81334c9f$var$__runInitializers(a, c), a;
}(), $ac22e9ddbc30c291$var$$5dc3ca4c9dfca0f7$exports = {};
$ac22e9ddbc30c291$var$$parcel$export($ac22e9ddbc30c291$var$$5dc3ca4c9dfca0f7$exports, "SearchableInput", function() {
    return $ac22e9ddbc30c291$var$$5dc3ca4c9dfca0f7$export$2724f2f2a56ff7fc;
});
var $ac22e9ddbc30c291$var$$5dc3ca4c9dfca0f7$var$__esDecorate = function(e, t, r, a, n, c) {
    function s(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var i, o = a.kind, l = "getter" === o ? "get" : "setter" === o ? "set" : "value", u = !t && e ? a.static ? e : e.prototype : null, p = t || (u ? Object.getOwnPropertyDescriptor(u, a.name) : {}), $ = !1, f = r.length - 1; f >= 0; f--){
        var d = {};
        for(var b in a)d[b] = "access" === b ? {} : a[b];
        for(var b in a.access)d.access[b] = a.access[b];
        d.addInitializer = function(e) {
            if ($) throw TypeError("Cannot add initializers after decoration has completed");
            c.push(s(e || null));
        };
        var m = (0, r[f])("accessor" === o ? {
            get: p.get,
            set: p.set
        } : p[l], d);
        if ("accessor" === o) {
            if (void 0 === m) continue;
            if (null === m || (void 0 === m ? "undefined" : (0, $35f6c23f56aaf458$export$71511d61b312f219)(m)) !== "object") throw TypeError("Object expected");
            (i = s(m.get)) && (p.get = i), (i = s(m.set)) && (p.set = i), (i = s(m.init)) && n.unshift(i);
        } else (i = s(m)) && ("field" === o ? n.unshift(i) : p[l] = i);
    }
    u && Object.defineProperty(u, a.name, p), $ = !0;
}, $ac22e9ddbc30c291$var$$5dc3ca4c9dfca0f7$var$__runInitializers = function(e, t, r) {
    for(var a = arguments.length > 2, n = 0; n < t.length; n++)r = a ? t[n].call(e, r) : t[n].call(e);
    return a ? r : void 0;
}, $ac22e9ddbc30c291$var$$5dc3ca4c9dfca0f7$var$__awaiter = function(e, t, r, a) {
    return new (r || (r = Promise))(function(n, c) {
        function s(e) {
            try {
                o(a.next(e));
            } catch (e) {
                c(e);
            }
        }
        function i(e) {
            try {
                o(a.throw(e));
            } catch (e) {
                c(e);
            }
        }
        function o(e) {
            var t;
            e.done ? n(e.value) : ((t = e.value) instanceof r ? t : new r(function(e) {
                e(t);
            })).then(s, i);
        }
        o((a = a.apply(e, t || [])).next());
    });
}, $ac22e9ddbc30c291$var$$5dc3ca4c9dfca0f7$var$__setFunctionName = function(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $35f6c23f56aaf458$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $ac22e9ddbc30c291$var$$5dc3ca4c9dfca0f7$var$__classPrivateFieldGet = function(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $ac22e9ddbc30c291$var$$5dc3ca4c9dfca0f7$var$__classPrivateFieldSet = function(e, t, r, a, n) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !n) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !n : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? n.call(e, r) : n ? n.value = r : t.set(e, r), r;
}, $ac22e9ddbc30c291$var$$5dc3ca4c9dfca0f7$export$2724f2f2a56ff7fc = function() {
    var e, t, r, a, n, c, s, i, o = [
        $4d3432ed03d68615$export$b6ae1bc530f4c149
    ], l = [], u = $1cea8647883c4012$exports.FormComponent, p = [], $ = [], f = [], d = [];
    return c = function(e) {
        "use strict";
        function t() {
            var e;
            return (0, $2b3af368dbb30b38$export$71511d61b312f219)(this, t), e = (0, $95518c9e748840bb$export$71511d61b312f219)(this, t, arguments), r.set(e, $ac22e9ddbc30c291$var$$5dc3ca4c9dfca0f7$var$__runInitializers(e, p, e.props.filter)), a.set(e, ($ac22e9ddbc30c291$var$$5dc3ca4c9dfca0f7$var$__runInitializers(e, $), $ac22e9ddbc30c291$var$$5dc3ca4c9dfca0f7$var$__runInitializers(e, f, !1))), Object.defineProperty(e, "search", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($ac22e9ddbc30c291$var$$5dc3ca4c9dfca0f7$var$__runInitializers(e, d), (0, $aMH3h.debounce)(function(t) {
                    return $ac22e9ddbc30c291$var$$5dc3ca4c9dfca0f7$var$__awaiter(e, void 0, void 0, function() {
                        var e, r, a;
                        return (0, $8fdeac7b23d8f90e$export$71511d61b312f219)(this, function(n) {
                            switch(n.label){
                                case 0:
                                    if (r = (e = this.props).store, a = e.labelKey, t = t.trim(), this.filter = Object.assign(Object.assign({}, this.filter), (0, $c73d96e37869302b$export$71511d61b312f219)({}, a, t || void 0)), !(r.downloading < 1)) return [
                                        3,
                                        5
                                    ];
                                    if (!t) return [
                                        3,
                                        4
                                    ];
                                    if (this.listShown) return [
                                        3,
                                        1
                                    ];
                                    return this.listShown = !0, [
                                        3,
                                        3
                                    ];
                                case 1:
                                    return [
                                        4,
                                        r.getList(this.filter, 1)
                                    ];
                                case 2:
                                    n.sent(), n.label = 3;
                                case 3:
                                    return [
                                        3,
                                        5
                                    ];
                                case 4:
                                    this.listShown = !1, r.clearList(), n.label = 5;
                                case 5:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                }, $fbe6f1e2fed97fc7$export$c489aa6f7fd82b1a))
            }), Object.defineProperty(e, "add", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function(t, r) {
                    var a = e.value || [];
                    !a.find(function(e) {
                        return e.value === r;
                    }) && (e.innerValue = (0, $ca91dac30bd8a8fe$export$71511d61b312f219)(a).concat([
                        {
                            label: t,
                            value: r
                        }
                    ]), e.props.multiple || (e.listShown = !1));
                }
            }), Object.defineProperty(e, "delete", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function(t) {
                    return e.innerValue = (0, $ca91dac30bd8a8fe$export$71511d61b312f219)(e.value.slice(0, t)).concat((0, $ca91dac30bd8a8fe$export$71511d61b312f219)(e.value.slice(t + 1)));
                }
            }), Object.defineProperty(e, "handleBlur", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function(t) {
                    var r = t.target, a = t.relatedTarget;
                    r.parentElement !== (null == a ? void 0 : a.parentElement) && (e.listShown = !1);
                }
            }), Object.defineProperty(e, "renderList", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function(t) {
                    return t[0] ? (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($d5d534a7c63bc198$export$2e2bcd8739ae039, {
                        children: t.map(function(t) {
                            var r = e.observedProps, a = r.labelKey, n = r.valueKey, c = t[a], s = t[n];
                            return (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($d5d534a7c63bc198$export$2e2bcd8739ae039.Item, {
                                as: "button",
                                type: "button",
                                action: !0,
                                onClick: function() {
                                    return e.add(c, s);
                                },
                                children: c
                            }, s);
                        })
                    }) : e.observedProps.store.downloading > 0 && (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("div", {
                        className: "text-center my-3",
                        children: (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($999d941606fa59dc$export$2e2bcd8739ae039, {})
                    });
                }
            }), e;
        }
        return (0, $92f5157d74f7ea45$export$71511d61b312f219)(t, e), (0, $53cdca766716469e$export$71511d61b312f219)(t, [
            {
                key: "filter",
                get: function() {
                    return $ac22e9ddbc30c291$var$$5dc3ca4c9dfca0f7$var$__classPrivateFieldGet(this, r, "f");
                },
                set: function(e) {
                    $ac22e9ddbc30c291$var$$5dc3ca4c9dfca0f7$var$__classPrivateFieldSet(this, r, e, "f");
                }
            },
            {
                key: "listShown",
                get: function() {
                    return $ac22e9ddbc30c291$var$$5dc3ca4c9dfca0f7$var$__classPrivateFieldGet(this, a, "f");
                },
                set: function(e) {
                    $ac22e9ddbc30c291$var$$5dc3ca4c9dfca0f7$var$__classPrivateFieldSet(this, a, e, "f");
                }
            },
            (0, $c73d96e37869302b$export$71511d61b312f219)({
                key: "renderOverlay"
            }, "value", function() {
                var e = this.filter, t = this.props, r = t.translator, a = t.fields, n = t.store, c = t.labelKey, s = t.renderList, i = void 0 === s ? this.renderList : s, o = e[c], l = !n.allItems.some(function(e) {
                    return e[c] === o;
                });
                return (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("div", {
                    className: "position-absolute start-0 z-3 overflow-auto py-1 bg-white shadow-sm",
                    style: {
                        top: "100%",
                        maxHeight: "30vh"
                    },
                    onBlurCapture: this.handleBlur,
                    children: [
                        l && (null == a ? void 0 : a[0]) && (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($b4033c9bbfbcc946$export$2e2bcd8739ae039, {
                            className: "w-100 sticky-top",
                            variant: "warning",
                            size: "sm",
                            type: "button",
                            onClick: function() {
                                return n.currentOne = (0, $c73d96e37869302b$export$71511d61b312f219)({}, c, o);
                            },
                            children: [
                                "+ ",
                                o
                            ]
                        }),
                        (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($ac22e9ddbc30c291$var$$6c88af5e81334c9f$export$797e591eba0ca37c, {
                            translator: r,
                            store: n,
                            filter: e,
                            renderList: i
                        })
                    ]
                });
            }),
            (0, $c73d96e37869302b$export$71511d61b312f219)({
                key: "render"
            }, "value", function() {
                var e = this, t = this.value, r = this.listShown, a = this.props, n = a.translator, c = a.fields, s = a.store, i = a.labelKey, o = a.valueKey, l = a.type, u = a.name, p = a.required, $ = a.readOnly, f = a.disabled, d = a.placeholder;
                return (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($43bff9b07dfb92e6$export$2e2bcd8739ae039, (0, $c73d96e37869302b$export$71511d61b312f219)({
                    className: "position-relative"
                }, "children", [
                    (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($43bff9b07dfb92e6$export$2e2bcd8739ae039.Text, {
                        className: "d-flex flex-wrap align-items-center gap-2",
                        children: (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($ac22e9ddbc30c291$var$$f600741b98acd6fe$export$ef1c4106ceccca63, {
                            list: (t || []).map(function(e) {
                                return {
                                    text: e.label
                                };
                            }),
                            onDelete: function(t, r) {
                                return (0, $176d75244f0e6d93$export$71511d61b312f219)(t), e.delete(r);
                            }
                        })
                    }),
                    r && this.renderOverlay(),
                    (null == c ? void 0 : c[0]) && (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($ac22e9ddbc30c291$var$$bfbc9f72f179e373$export$28baae8ef86bbf36, (0, $c73d96e37869302b$export$71511d61b312f219)({
                        translator: n,
                        fields: c,
                        store: s
                    }, "onSubmit", function(t) {
                        var r = t[i], a = t[o];
                        e.add(r, a), e.listShown = !1;
                    })),
                    (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)("input", {
                        type: "hidden",
                        name: u,
                        value: JSON.stringify(null == t ? void 0 : t.map(function(e) {
                            return e.value;
                        }))
                    }),
                    (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)($a213c3bf0143d254$export$2e2bcd8739ae039.Control, {
                        type: void 0 === l ? "search" : l,
                        placeholder: d,
                        required: p,
                        readOnly: $,
                        disabled: f,
                        onChange: function(t) {
                            var r = t.currentTarget.value;
                            return e.search(r);
                        }
                    })
                ]));
            })
        ]), t;
    }(u), r = new WeakMap, a = new WeakMap, $ac22e9ddbc30c291$var$$5dc3ca4c9dfca0f7$var$__setFunctionName(c, "SearchableInput"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = u[Symbol.metadata]) ? e : null) : void 0, s = [
        $d5I5D.observable
    ], i = [
        $d5I5D.observable
    ], $ac22e9ddbc30c291$var$$5dc3ca4c9dfca0f7$var$__esDecorate(c, null, s, {
        kind: "accessor",
        name: "filter",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "filter" in e;
            },
            get: function(e) {
                return e.filter;
            },
            set: function(e, t) {
                e.filter = t;
            }
        },
        metadata: t
    }, p, $), $ac22e9ddbc30c291$var$$5dc3ca4c9dfca0f7$var$__esDecorate(c, null, i, {
        kind: "accessor",
        name: "listShown",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "listShown" in e;
            },
            get: function(e) {
                return e.listShown;
            },
            set: function(e, t) {
                e.listShown = t;
            }
        },
        metadata: t
    }, f, d), $ac22e9ddbc30c291$var$$5dc3ca4c9dfca0f7$var$__esDecorate(null, n = {
        value: c
    }, o, {
        kind: "class",
        name: c.name,
        metadata: t
    }, null, l), c = n.value, t && Object.defineProperty(c, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(c, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "SearchableInput"
    }), $ac22e9ddbc30c291$var$$5dc3ca4c9dfca0f7$var$__runInitializers(c, l), c;
}();
$ac22e9ddbc30c291$var$$parcel$exportWildcard($ac22e9ddbc30c291$exports, $ac22e9ddbc30c291$var$$f600741b98acd6fe$exports), $ac22e9ddbc30c291$var$$parcel$exportWildcard($ac22e9ddbc30c291$exports, $ac22e9ddbc30c291$var$$faee9857e4bdfa8b$exports), $ac22e9ddbc30c291$var$$parcel$exportWildcard($ac22e9ddbc30c291$exports, $ac22e9ddbc30c291$var$$8663609ea235ec39$exports), $ac22e9ddbc30c291$var$$parcel$exportWildcard($ac22e9ddbc30c291$exports, $ac22e9ddbc30c291$var$$f2af1554fbcf9c96$exports), $ac22e9ddbc30c291$var$$parcel$exportWildcard($ac22e9ddbc30c291$exports, $ac22e9ddbc30c291$var$$a21a50f24f1cbd28$exports), $ac22e9ddbc30c291$var$$parcel$exportWildcard($ac22e9ddbc30c291$exports, $ac22e9ddbc30c291$var$$4e6504f15de995a8$exports), $ac22e9ddbc30c291$var$$parcel$exportWildcard($ac22e9ddbc30c291$exports, $ac22e9ddbc30c291$var$$92bd5b9c2e8cd28e$exports), $ac22e9ddbc30c291$var$$parcel$exportWildcard($ac22e9ddbc30c291$exports, $ac22e9ddbc30c291$var$$fa84453248a3f065$exports), $ac22e9ddbc30c291$var$$parcel$exportWildcard($ac22e9ddbc30c291$exports, $ac22e9ddbc30c291$var$$36ed2012ed0bbec3$exports), $ac22e9ddbc30c291$var$$parcel$exportWildcard($ac22e9ddbc30c291$exports, $ac22e9ddbc30c291$var$$cd7ba08b282791a9$exports), $ac22e9ddbc30c291$var$$parcel$exportWildcard($ac22e9ddbc30c291$exports, $ac22e9ddbc30c291$var$$bcc38e2aa906301f$exports), $ac22e9ddbc30c291$var$$parcel$exportWildcard($ac22e9ddbc30c291$exports, $ac22e9ddbc30c291$var$$3800431d840f9bec$exports), $ac22e9ddbc30c291$var$$parcel$exportWildcard($ac22e9ddbc30c291$exports, $ac22e9ddbc30c291$var$$3330ccfab53de794$exports), $ac22e9ddbc30c291$var$$parcel$exportWildcard($ac22e9ddbc30c291$exports, $ac22e9ddbc30c291$var$$6c88af5e81334c9f$exports), $ac22e9ddbc30c291$var$$parcel$exportWildcard($ac22e9ddbc30c291$exports, $ac22e9ddbc30c291$var$$5dc3ca4c9dfca0f7$exports); //# sourceMappingURL=index.js.map










var $d5I5D = parcelRequire("d5I5D");

parcelRequire("N3oW3");
var $hO8yS = parcelRequire("hO8yS");
var $991e2a094a6973c7$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $991e2a094a6973c7$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $991e2a094a6973c7$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $991e2a094a6973c7$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $991e2a094a6973c7$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $991e2a094a6973c7$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $991e2a094a6973c7$export$82ac5bfd81727a32 = (()=>{
    var _GitLogo_path_accessor_storage;
    let _classDecorators = [
        (0, $4d3432ed03d68615$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = (0, $hO8yS.Component);
    let _path_decorators;
    let _path_initializers = [];
    let _path_extraInitializers = [];
    var GitLogo = _classThis = class extends _classSuper {
        get path() {
            return $991e2a094a6973c7$var$__classPrivateFieldGet(this, _GitLogo_path_accessor_storage, "f");
        }
        set path(value) {
            $991e2a094a6973c7$var$__classPrivateFieldSet(this, _GitLogo_path_accessor_storage, value, "f");
        }
        componentDidMount() {
            return $991e2a094a6973c7$var$__awaiter(this, void 0, void 0, function*() {
                const { name: name } = this.props;
                const topic = name.toLowerCase();
                try {
                    const { src: src } = yield this.loadImage(`https://raw.githubusercontent.com/github/explore/master/topics/${topic}/${topic}.png`);
                    this.path = src;
                } catch (_a) {
                    const { src: src } = yield this.loadImage(`https://github.com/${name}.png`);
                    this.path = src;
                }
            });
        }
        loadImage(path) {
            return new Promise((resolve, reject)=>{
                const image = new globalThis.Image();
                image.onload = ()=>resolve(image);
                image.onerror = reject;
                image.src = path;
            });
        }
        render() {
            const { path: path } = this;
            const { name: name } = this.props;
            return path && (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $0cb483a407d1bed2$export$2e2bcd8739ae039), {
                shape: "square",
                size: "large",
                src: path,
                alt: name
            });
        }
        constructor(){
            super(...arguments);
            _GitLogo_path_accessor_storage.set(this, $991e2a094a6973c7$var$__runInitializers(this, _path_initializers, ''));
            $991e2a094a6973c7$var$__runInitializers(this, _path_extraInitializers);
        }
    };
    _GitLogo_path_accessor_storage = new WeakMap();
    $991e2a094a6973c7$var$__setFunctionName(_classThis, "GitLogo");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _path_decorators = [
            (0, $d5I5D.observable)
        ];
        $991e2a094a6973c7$var$__esDecorate(_classThis, null, _path_decorators, {
            kind: "accessor",
            name: "path",
            static: false,
            private: false,
            access: {
                has: (obj)=>"path" in obj,
                get: (obj)=>obj.path,
                set: (obj, value)=>{
                    obj.path = value;
                }
            },
            metadata: _metadata
        }, _path_initializers, _path_extraInitializers);
        $991e2a094a6973c7$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        GitLogo = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $991e2a094a6973c7$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return GitLogo = _classThis;
})();


const $9ff5a3159236dcb5$export$3663268b2052b3d = (0, $4d3432ed03d68615$export$b6ae1bc530f4c149)(({ full_name: full_name, language: language, description: description, topics: topics, homepage: homepage })=>(0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $cc75ec4a4b973a53$export$2e2bcd8739ae039), {
        className: "h-100 mb-3",
        actions: [
            (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $9632ad3149894c43$export$2e2bcd8739ae039), {
                target: "_blank",
                href: homepage,
                children: (0, $b7383b0731549701$export$a7357cdd1f0b0168).t('home_page')
            })
        ],
        children: [
            (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $cc75ec4a4b973a53$export$2e2bcd8739ae039).Meta, {
                avatar: language && (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $991e2a094a6973c7$export$82ac5bfd81727a32), {
                    name: language
                }),
                title: full_name,
                description: description
            }),
            (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $afba98610eca1bae$export$2e2bcd8739ae039), {
                className: "mt-3",
                wrap: true,
                children: topics === null || topics === void 0 ? void 0 : topics.map((topic)=>(0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $445678750385e1db$export$37acb3580601e69a), {
                        children: topic
                    }, topic))
            })
        ]
    }));




const $755b93b97419b261$export$5636eeba3ebdcdc3 = ()=>(0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $ac22e9ddbc30c291$exports.ScrollList), {
        translator: (0, $b7383b0731549701$export$a7357cdd1f0b0168),
        store: (0, $d919b95fbe3dd622$export$8701c19c4b8c549b),
        renderList: (allItems)=>(0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $f16d0e5c621bcbb8$export$2e2bcd8739ae039), {
                gutter: [
                    16,
                    16
                ],
                children: allItems.map((repository)=>(0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $0205b0ed259f812c$export$2e2bcd8739ae039), {
                        xs: 24,
                        md: 12,
                        lg: 6,
                        children: (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $9ff5a3159236dcb5$export$3663268b2052b3d), Object.assign({}, repository))
                    }, repository.full_name))
            })
    });


var $f1ce7503a99226dc$export$2e2bcd8739ae039 = ()=>(0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $dbfbcf83869c9c18$export$7221d69dcfc8e36b), {
        children: (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $dbfbcf83869c9c18$export$3565eb3d00ca5a74), {
            children: [
                (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $dbfbcf83869c9c18$export$e7b0ac011bb776c6), {
                    path: "/",
                    element: (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $f957ec994051c3ca$export$7893f173408d95e4), {
                        narrow: true,
                        children: (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $4b6741e6925a057b$export$36d69433c4f81145), {})
                    })
                }),
                (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $dbfbcf83869c9c18$export$e7b0ac011bb776c6), {
                    path: "/pagination",
                    element: (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $f957ec994051c3ca$export$7893f173408d95e4), {
                        narrow: true,
                        children: (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $d67107f60bf33937$export$fb01502f5340e3de), {})
                    })
                }),
                (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $dbfbcf83869c9c18$export$e7b0ac011bb776c6), {
                    path: "/scroll-list",
                    element: (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $f957ec994051c3ca$export$7893f173408d95e4), {
                        narrow: true,
                        children: (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $755b93b97419b261$export$5636eeba3ebdcdc3), {})
                    })
                })
            ]
        })
    });


(0, $5ec47347fc6130b4$export$dfb5619354ba860)();
(0, $d5I5D.configure)({
    enforceActions: 'never'
});
globalThis.addEventListener('unhandledrejection', ({ reason: reason })=>{
    if (reason instanceof URIError) (0, $d1cd4dd6f62e88cc$export$2e2bcd8739ae039).error(reason.message);
});
const { serviceWorker: $ce967277cb0dfddc$var$serviceWorker } = window.navigator;
$ce967277cb0dfddc$var$serviceWorker === null || $ce967277cb0dfddc$var$serviceWorker === void 0 || $ce967277cb0dfddc$var$serviceWorker.register('sw.js').then((0, $fbe6f1e2fed97fc7$export$d635d04af3887bbe)).then((worker)=>{
    if (window.confirm('New version of this Web App detected, update now?')) worker.postMessage({
        type: 'SKIP_WAITING'
    });
});
$ce967277cb0dfddc$var$serviceWorker === null || $ce967277cb0dfddc$var$serviceWorker === void 0 || $ce967277cb0dfddc$var$serviceWorker.addEventListener('controllerchange', ()=>window.location.reload());
(0, $30c53faf8d313331$export$882461b6382ed46c)(document.querySelector('main')).render((0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $c756b57cbfcd44a7$export$6aedb87c7b665270), {
    hashPriority: "high",
    transformers: [
        (0, $dc1797a4c67f216d$export$2e2bcd8739ae039)
    ],
    children: (0, $2882e8b6468c3ed5$export$34b9dba7ce09269b)((0, $f1ce7503a99226dc$export$2e2bcd8739ae039), {})
}));


//# sourceMappingURL=React-MobX-Ant-Design-ts.d0db9508.js.map
